import * as React from "react";
import React__default, { createContext, useRef, useState, useEffect, useContext, useLayoutEffect, useMemo, useCallback, isValidElement as isValidElement$1, forwardRef, createElement as createElement$3, useImperativeHandle, useReducer } from "react";
import require$$2, { createPortal, flushSync } from "react-dom";
var commonjsGlobal$4 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$6(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace$3(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var f2 = n.default;
  if (typeof f2 == "function") {
    var a = function a2() {
      var isInstance = false;
      try {
        isInstance = this instanceof a2;
      } catch {
      }
      if (isInstance) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a.prototype = f2.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k2) {
    var d = Object.getOwnPropertyDescriptor(n, k2);
    Object.defineProperty(a, k2, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k2];
      }
    });
  });
  return a;
}
var jsxRuntime$3 = { exports: {} };
var reactJsxRuntime_production$3 = {};
var hasRequiredReactJsxRuntime_production$3;
function requireReactJsxRuntime_production$3() {
  if (hasRequiredReactJsxRuntime_production$3) return reactJsxRuntime_production$3;
  hasRequiredReactJsxRuntime_production$3 = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production$3.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production$3.jsx = jsxProd;
  reactJsxRuntime_production$3.jsxs = jsxProd;
  return reactJsxRuntime_production$3;
}
var reactJsxRuntime_development$3 = {};
var hasRequiredReactJsxRuntime_development$3;
function requireReactJsxRuntime_development$3() {
  if (hasRequiredReactJsxRuntime_development$3) return reactJsxRuntime_development$3;
  hasRequiredReactJsxRuntime_development$3 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name2 = getComponentNameFromType(type);
        return name2 ? "<" + name2 + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props2, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props2, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props2, owner, debugStack, debugTask) {
      var refProp = props2.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props: props2,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node) {
      isValidElement2(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement2(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement2(object2) {
      return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React2 = React__default, REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React2 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React2.react_stack_bottom_frame.bind(
      React2,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development$3.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development$3.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development$3.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development$3;
}
var hasRequiredJsxRuntime$3;
function requireJsxRuntime$3() {
  if (hasRequiredJsxRuntime$3) return jsxRuntime$3.exports;
  hasRequiredJsxRuntime$3 = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime$3.exports = requireReactJsxRuntime_production$3();
  } else {
    jsxRuntime$3.exports = requireReactJsxRuntime_development$3();
  }
  return jsxRuntime$3.exports;
}
var jsxRuntimeExports$3 = requireJsxRuntime$3();
var alea$2 = { exports: {} };
var alea = alea$2.exports;
var hasRequiredAlea$2;
function requireAlea$2() {
  if (hasRequiredAlea$2) return alea$2.exports;
  hasRequiredAlea$2 = 1;
  (function(module) {
    (function(global2, module2, define) {
      function Alea(seed) {
        var me2 = this, mash = Mash();
        me2.next = function() {
          var t2 = 2091639 * me2.s0 + me2.c * 23283064365386963e-26;
          me2.s0 = me2.s1;
          me2.s1 = me2.s2;
          return me2.s2 = t2 - (me2.c = t2 | 0);
        };
        me2.c = 1;
        me2.s0 = mash(" ");
        me2.s1 = mash(" ");
        me2.s2 = mash(" ");
        me2.s0 -= mash(seed);
        if (me2.s0 < 0) {
          me2.s0 += 1;
        }
        me2.s1 -= mash(seed);
        if (me2.s1 < 0) {
          me2.s1 += 1;
        }
        me2.s2 -= mash(seed);
        if (me2.s2 < 0) {
          me2.s2 += 1;
        }
        mash = null;
      }
      function copy2(f2, t2) {
        t2.c = f2.c;
        t2.s0 = f2.s0;
        t2.s1 = f2.s1;
        t2.s2 = f2.s2;
        return t2;
      }
      function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
          return xg.next() * 4294967296 | 0;
        };
        prng.double = function() {
          return prng() + (prng() * 2097152 | 0) * 11102230246251565e-32;
        };
        prng.quick = prng;
        if (state) {
          if (typeof state == "object") copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      function Mash() {
        var n = 4022871197;
        var mash = function(data) {
          data = String(data);
          for (var i2 = 0; i2 < data.length; i2++) {
            n += data.charCodeAt(i2);
            var h = 0.02519603282416938 * n;
            n = h >>> 0;
            h -= n;
            h *= n;
            n = h >>> 0;
            h -= n;
            n += h * 4294967296;
          }
          return (n >>> 0) * 23283064365386963e-26;
        };
        return mash;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.alea = impl;
      }
    })(
      alea,
      module
    );
  })(alea$2);
  return alea$2.exports;
}
var xor128$2 = { exports: {} };
var xor128 = xor128$2.exports;
var hasRequiredXor128$2;
function requireXor128$2() {
  if (hasRequiredXor128$2) return xor128$2.exports;
  hasRequiredXor128$2 = 1;
  (function(module) {
    (function(global2, module2, define) {
      function XorGen(seed) {
        var me2 = this, strseed = "";
        me2.x = 0;
        me2.y = 0;
        me2.z = 0;
        me2.w = 0;
        me2.next = function() {
          var t2 = me2.x ^ me2.x << 11;
          me2.x = me2.y;
          me2.y = me2.z;
          me2.z = me2.w;
          return me2.w ^= me2.w >>> 19 ^ t2 ^ t2 >>> 8;
        };
        if (seed === (seed | 0)) {
          me2.x = seed;
        } else {
          strseed += seed;
        }
        for (var k2 = 0; k2 < strseed.length + 64; k2++) {
          me2.x ^= strseed.charCodeAt(k2) | 0;
          me2.next();
        }
      }
      function copy2(f2, t2) {
        t2.x = f2.x;
        t2.y = f2.y;
        t2.z = f2.z;
        t2.w = f2.w;
        return t2;
      }
      function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (typeof state == "object") copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.xor128 = impl;
      }
    })(
      xor128,
      module
    );
  })(xor128$2);
  return xor128$2.exports;
}
var xorwow$2 = { exports: {} };
var xorwow = xorwow$2.exports;
var hasRequiredXorwow$2;
function requireXorwow$2() {
  if (hasRequiredXorwow$2) return xorwow$2.exports;
  hasRequiredXorwow$2 = 1;
  (function(module) {
    (function(global2, module2, define) {
      function XorGen(seed) {
        var me2 = this, strseed = "";
        me2.next = function() {
          var t2 = me2.x ^ me2.x >>> 2;
          me2.x = me2.y;
          me2.y = me2.z;
          me2.z = me2.w;
          me2.w = me2.v;
          return (me2.d = me2.d + 362437 | 0) + (me2.v = me2.v ^ me2.v << 4 ^ (t2 ^ t2 << 1)) | 0;
        };
        me2.x = 0;
        me2.y = 0;
        me2.z = 0;
        me2.w = 0;
        me2.v = 0;
        if (seed === (seed | 0)) {
          me2.x = seed;
        } else {
          strseed += seed;
        }
        for (var k2 = 0; k2 < strseed.length + 64; k2++) {
          me2.x ^= strseed.charCodeAt(k2) | 0;
          if (k2 == strseed.length) {
            me2.d = me2.x << 10 ^ me2.x >>> 4;
          }
          me2.next();
        }
      }
      function copy2(f2, t2) {
        t2.x = f2.x;
        t2.y = f2.y;
        t2.z = f2.z;
        t2.w = f2.w;
        t2.v = f2.v;
        t2.d = f2.d;
        return t2;
      }
      function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (typeof state == "object") copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.xorwow = impl;
      }
    })(
      xorwow,
      module
    );
  })(xorwow$2);
  return xorwow$2.exports;
}
var xorshift7$2 = { exports: {} };
var xorshift7 = xorshift7$2.exports;
var hasRequiredXorshift7$2;
function requireXorshift7$2() {
  if (hasRequiredXorshift7$2) return xorshift7$2.exports;
  hasRequiredXorshift7$2 = 1;
  (function(module) {
    (function(global2, module2, define) {
      function XorGen(seed) {
        var me2 = this;
        me2.next = function() {
          var X2 = me2.x, i2 = me2.i, t2, v2;
          t2 = X2[i2];
          t2 ^= t2 >>> 7;
          v2 = t2 ^ t2 << 24;
          t2 = X2[i2 + 1 & 7];
          v2 ^= t2 ^ t2 >>> 10;
          t2 = X2[i2 + 3 & 7];
          v2 ^= t2 ^ t2 >>> 3;
          t2 = X2[i2 + 4 & 7];
          v2 ^= t2 ^ t2 << 7;
          t2 = X2[i2 + 7 & 7];
          t2 = t2 ^ t2 << 13;
          v2 ^= t2 ^ t2 << 9;
          X2[i2] = v2;
          me2.i = i2 + 1 & 7;
          return v2;
        };
        function init2(me3, seed2) {
          var j2, X2 = [];
          if (seed2 === (seed2 | 0)) {
            X2[0] = seed2;
          } else {
            seed2 = "" + seed2;
            for (j2 = 0; j2 < seed2.length; ++j2) {
              X2[j2 & 7] = X2[j2 & 7] << 15 ^ seed2.charCodeAt(j2) + X2[j2 + 1 & 7] << 13;
            }
          }
          while (X2.length < 8) X2.push(0);
          for (j2 = 0; j2 < 8 && X2[j2] === 0; ++j2) ;
          if (j2 == 8) X2[7] = -1;
          else X2[j2];
          me3.x = X2;
          me3.i = 0;
          for (j2 = 256; j2 > 0; --j2) {
            me3.next();
          }
        }
        init2(me2, seed);
      }
      function copy2(f2, t2) {
        t2.x = f2.x.slice();
        t2.i = f2.i;
        return t2;
      }
      function impl(seed, opts) {
        if (seed == null) seed = +/* @__PURE__ */ new Date();
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (state.x) copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.xorshift7 = impl;
      }
    })(
      xorshift7,
      module
    );
  })(xorshift7$2);
  return xorshift7$2.exports;
}
var xor4096$2 = { exports: {} };
var xor4096 = xor4096$2.exports;
var hasRequiredXor4096$2;
function requireXor4096$2() {
  if (hasRequiredXor4096$2) return xor4096$2.exports;
  hasRequiredXor4096$2 = 1;
  (function(module) {
    (function(global2, module2, define) {
      function XorGen(seed) {
        var me2 = this;
        me2.next = function() {
          var w2 = me2.w, X2 = me2.X, i2 = me2.i, t2, v2;
          me2.w = w2 = w2 + 1640531527 | 0;
          v2 = X2[i2 + 34 & 127];
          t2 = X2[i2 = i2 + 1 & 127];
          v2 ^= v2 << 13;
          t2 ^= t2 << 17;
          v2 ^= v2 >>> 15;
          t2 ^= t2 >>> 12;
          v2 = X2[i2] = v2 ^ t2;
          me2.i = i2;
          return v2 + (w2 ^ w2 >>> 16) | 0;
        };
        function init2(me3, seed2) {
          var t2, v2, i2, j2, w2, X2 = [], limit = 128;
          if (seed2 === (seed2 | 0)) {
            v2 = seed2;
            seed2 = null;
          } else {
            seed2 = seed2 + "\0";
            v2 = 0;
            limit = Math.max(limit, seed2.length);
          }
          for (i2 = 0, j2 = -32; j2 < limit; ++j2) {
            if (seed2) v2 ^= seed2.charCodeAt((j2 + 32) % seed2.length);
            if (j2 === 0) w2 = v2;
            v2 ^= v2 << 10;
            v2 ^= v2 >>> 15;
            v2 ^= v2 << 4;
            v2 ^= v2 >>> 13;
            if (j2 >= 0) {
              w2 = w2 + 1640531527 | 0;
              t2 = X2[j2 & 127] ^= v2 + w2;
              i2 = 0 == t2 ? i2 + 1 : 0;
            }
          }
          if (i2 >= 128) {
            X2[(seed2 && seed2.length || 0) & 127] = -1;
          }
          i2 = 127;
          for (j2 = 4 * 128; j2 > 0; --j2) {
            v2 = X2[i2 + 34 & 127];
            t2 = X2[i2 = i2 + 1 & 127];
            v2 ^= v2 << 13;
            t2 ^= t2 << 17;
            v2 ^= v2 >>> 15;
            t2 ^= t2 >>> 12;
            X2[i2] = v2 ^ t2;
          }
          me3.w = w2;
          me3.X = X2;
          me3.i = i2;
        }
        init2(me2, seed);
      }
      function copy2(f2, t2) {
        t2.i = f2.i;
        t2.w = f2.w;
        t2.X = f2.X.slice();
        return t2;
      }
      function impl(seed, opts) {
        if (seed == null) seed = +/* @__PURE__ */ new Date();
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (state.X) copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.xor4096 = impl;
      }
    })(
      xor4096,
      // window object or global
      module
    );
  })(xor4096$2);
  return xor4096$2.exports;
}
var tychei$2 = { exports: {} };
var tychei = tychei$2.exports;
var hasRequiredTychei$2;
function requireTychei$2() {
  if (hasRequiredTychei$2) return tychei$2.exports;
  hasRequiredTychei$2 = 1;
  (function(module) {
    (function(global2, module2, define) {
      function XorGen(seed) {
        var me2 = this, strseed = "";
        me2.next = function() {
          var b2 = me2.b, c2 = me2.c, d = me2.d, a = me2.a;
          b2 = b2 << 25 ^ b2 >>> 7 ^ c2;
          c2 = c2 - d | 0;
          d = d << 24 ^ d >>> 8 ^ a;
          a = a - b2 | 0;
          me2.b = b2 = b2 << 20 ^ b2 >>> 12 ^ c2;
          me2.c = c2 = c2 - d | 0;
          me2.d = d << 16 ^ c2 >>> 16 ^ a;
          return me2.a = a - b2 | 0;
        };
        me2.a = 0;
        me2.b = 0;
        me2.c = 2654435769 | 0;
        me2.d = 1367130551;
        if (seed === Math.floor(seed)) {
          me2.a = seed / 4294967296 | 0;
          me2.b = seed | 0;
        } else {
          strseed += seed;
        }
        for (var k2 = 0; k2 < strseed.length + 20; k2++) {
          me2.b ^= strseed.charCodeAt(k2) | 0;
          me2.next();
        }
      }
      function copy2(f2, t2) {
        t2.a = f2.a;
        t2.b = f2.b;
        t2.c = f2.c;
        t2.d = f2.d;
        return t2;
      }
      function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (typeof state == "object") copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.tychei = impl;
      }
    })(
      tychei,
      module
    );
  })(tychei$2);
  return tychei$2.exports;
}
var seedrandom$8 = { exports: {} };
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0$3 = /* @__PURE__ */ getAugmentedNamespace$3(__viteBrowserExternal$1);
var seedrandom$7 = seedrandom$8.exports;
var hasRequiredSeedrandom$4;
function requireSeedrandom$4() {
  if (hasRequiredSeedrandom$4) return seedrandom$8.exports;
  hasRequiredSeedrandom$4 = 1;
  (function(module) {
    (function(global2, pool, math2) {
      var width = 256, chunks = 6, digits2 = 52, rngname = "random", startdenom = math2.pow(width, chunks), significance = math2.pow(2, digits2), overflow = significance * 2, mask = width - 1, nodecrypto;
      function seedrandom2(seed, options2, callback) {
        var key = [];
        options2 = options2 == true ? { entropy: true } : options2 || {};
        var shortseed = mixkey(flatten2(
          options2.entropy ? [seed, tostring(pool)] : seed == null ? autoseed() : seed,
          3
        ), key);
        var arc4 = new ARC4(key);
        var prng = function() {
          var n = arc4.g(chunks), d = startdenom, x2 = 0;
          while (n < significance) {
            n = (n + x2) * width;
            d *= width;
            x2 = arc4.g(1);
          }
          while (n >= overflow) {
            n /= 2;
            d /= 2;
            x2 >>>= 1;
          }
          return (n + x2) / d;
        };
        prng.int32 = function() {
          return arc4.g(4) | 0;
        };
        prng.quick = function() {
          return arc4.g(4) / 4294967296;
        };
        prng.double = prng;
        mixkey(tostring(arc4.S), pool);
        return (options2.pass || callback || function(prng2, seed2, is_math_call, state) {
          if (state) {
            if (state.S) {
              copy2(state, arc4);
            }
            prng2.state = function() {
              return copy2(arc4, {});
            };
          }
          if (is_math_call) {
            math2[rngname] = prng2;
            return seed2;
          } else return prng2;
        })(
          prng,
          shortseed,
          "global" in options2 ? options2.global : this == math2,
          options2.state
        );
      }
      function ARC4(key) {
        var t2, keylen = key.length, me2 = this, i2 = 0, j2 = me2.i = me2.j = 0, s = me2.S = [];
        if (!keylen) {
          key = [keylen++];
        }
        while (i2 < width) {
          s[i2] = i2++;
        }
        for (i2 = 0; i2 < width; i2++) {
          s[i2] = s[j2 = mask & j2 + key[i2 % keylen] + (t2 = s[i2])];
          s[j2] = t2;
        }
        (me2.g = function(count) {
          var t3, r = 0, i3 = me2.i, j3 = me2.j, s2 = me2.S;
          while (count--) {
            t3 = s2[i3 = mask & i3 + 1];
            r = r * width + s2[mask & (s2[i3] = s2[j3 = mask & j3 + t3]) + (s2[j3] = t3)];
          }
          me2.i = i3;
          me2.j = j3;
          return r;
        })(width);
      }
      function copy2(f2, t2) {
        t2.i = f2.i;
        t2.j = f2.j;
        t2.S = f2.S.slice();
        return t2;
      }
      function flatten2(obj, depth) {
        var result2 = [], typ = typeof obj, prop;
        if (depth && typ == "object") {
          for (prop in obj) {
            try {
              result2.push(flatten2(obj[prop], depth - 1));
            } catch (e2) {
            }
          }
        }
        return result2.length ? result2 : typ == "string" ? obj : obj + "\0";
      }
      function mixkey(seed, key) {
        var stringseed = seed + "", smear, j2 = 0;
        while (j2 < stringseed.length) {
          key[mask & j2] = mask & (smear ^= key[mask & j2] * 19) + stringseed.charCodeAt(j2++);
        }
        return tostring(key);
      }
      function autoseed() {
        try {
          var out;
          if (nodecrypto && (out = nodecrypto.randomBytes)) {
            out = out(width);
          } else {
            out = new Uint8Array(width);
            (global2.crypto || global2.msCrypto).getRandomValues(out);
          }
          return tostring(out);
        } catch (e2) {
          var browser2 = global2.navigator, plugins2 = browser2 && browser2.plugins;
          return [+/* @__PURE__ */ new Date(), global2, plugins2, global2.screen, tostring(pool)];
        }
      }
      function tostring(a) {
        return String.fromCharCode.apply(0, a);
      }
      mixkey(math2.random(), pool);
      if (module.exports) {
        module.exports = seedrandom2;
        try {
          nodecrypto = require$$0$3;
        } catch (ex) {
        }
      } else {
        math2["seed" + rngname] = seedrandom2;
      }
    })(
      // global: `self` in browsers (including strict mode and web workers),
      // otherwise `this` in Node and other environments
      typeof self !== "undefined" ? self : seedrandom$7,
      [],
      // pool: entropy pool starts empty
      Math
      // math: package containing random, pow, and seedrandom
    );
  })(seedrandom$8);
  return seedrandom$8.exports;
}
var seedrandom$6;
var hasRequiredSeedrandom$3;
function requireSeedrandom$3() {
  if (hasRequiredSeedrandom$3) return seedrandom$6;
  hasRequiredSeedrandom$3 = 1;
  var alea2 = requireAlea$2();
  var xor1282 = requireXor128$2();
  var xorwow2 = requireXorwow$2();
  var xorshift72 = requireXorshift7$2();
  var xor40962 = requireXor4096$2();
  var tychei2 = requireTychei$2();
  var sr2 = requireSeedrandom$4();
  sr2.alea = alea2;
  sr2.xor128 = xor1282;
  sr2.xorwow = xorwow2;
  sr2.xorshift7 = xorshift72;
  sr2.xor4096 = xor40962;
  sr2.tychei = tychei2;
  seedrandom$6 = sr2;
  return seedrandom$6;
}
var seedrandomExports$2 = requireSeedrandom$3();
const seedrandom$5 = /* @__PURE__ */ getDefaultExportFromCjs$6(seedrandomExports$2);
const __variableDynamicImportRuntimeHelper = (glob$1, path$13, segs) => {
  const v2 = glob$1[path$13];
  if (v2) return typeof v2 === "function" ? v2() : Promise.resolve(v2);
  return new Promise((_2, reject2) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(reject2.bind(null, /* @__PURE__ */ new Error("Unknown variable dynamic import: " + path$13 + (path$13.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : ""))));
  });
};
const urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let nanoid$1 = (size2 = 21) => {
  let id2 = "";
  let bytes = crypto.getRandomValues(new Uint8Array(size2 |= 0));
  while (size2--) {
    id2 += urlAlphabet$1[bytes[size2] & 63];
  }
  return id2;
};
const get_tree$1 = function(e2) {
  if (null != e2) return void 0 !== e2.tree ? e2.tree : e2;
};
function* subsets$1(e2, t2) {
  var r = e2.length;
  if (void 0 === t2 && (t2 = r), 0 !== t2) {
    for (let t3 = 0; t3 < r; t3++) yield [e2[t3]];
    if (1 !== t2) for (let n = 0; n < r; n++) {
      let r2 = subsets$1(e2.slice(n + 1), t2 - 1);
      for (let t3 of r2) yield [e2[n]].concat(t3);
    }
  }
}
var is_associative$1$1 = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$5$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if (n = n.map((function(e3, t3) {
    return flatten$5$1(e3);
  })), is_associative$1$1[r]) {
    for (var i2 = [], a = 0; a < n.length; a++) Array.isArray(n[a]) && n[a][0] === r && n[a].length > 2 ? i2 = i2.concat(n[a].slice(1)) : i2.push(n[a]);
    n = i2;
  }
  return [r].concat(n);
}
const unflattenRight$1 = function(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ((n = n.map((function(e3, t3) {
    return unflattenRight$1(e3);
  }))).length > 2 && is_associative$1$1[r]) {
    for (var i2 = [r, n[0], void 0], a = i2, o = 1; o < n.length - 1; o++) a[2] = [r, n[o], void 0], a = a[2];
    return a[2] = n[n.length - 1], i2;
  }
  return [r].concat(n);
}, unflattenLeft$1 = function(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ((n = n.map((function(e3, t3) {
    return unflattenLeft$1(e3);
  }))).length > 2 && is_associative$1$1[r]) {
    for (var i2 = [r, void 0, n[n.length - 1]], a = i2, o = n.length - 2; o > 0; o--) a[1] = [r, void 0, n[o]], a = a[1];
    return a[1] = n[0], i2;
  }
  return [r].concat(n);
}, allChildren$1 = function(e2) {
  if (!Array.isArray(e2)) return [];
  var t2 = e2[0], r = e2.slice(1);
  return is_associative$1$1[t2] ? r.reduce((function(e3, r2) {
    return Array.isArray(r2) && r2[0] === t2 ? e3.concat(allChildren$1(r2)) : e3.concat([r2]);
  }), []) : r;
};
function get_all_units$1() {
  return { "%": { scale: (e2) => ["/", e2, 100], only_scales: true }, $: { prefix: true, scale: (e2) => e2 }, deg: { scale: (e2) => ["/", ["*", e2, "pi"], 180], only_scales: true } };
}
let all_units$1$1 = get_all_units$1();
function get_unit_of_tree$1(e2) {
  if ("unit" === e2[0]) {
    for (let t2 in all_units$1$1) if (all_units$1$1[t2].prefix) {
      if (e2[1] === t2) return t2;
    } else if (e2[2] === t2) return t2;
  }
  return null;
}
function get_unit_value_of_tree$1(e2) {
  if ("unit" === e2[0]) {
    for (let t2 in all_units$1$1) if (all_units$1$1[t2].prefix) {
      if (e2[1] === t2) return [t2, e2[2]];
    } else if (e2[2] === t2) return [t2, e2[1]];
  }
  return null;
}
function remove_duplicate_negatives$1(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  return "-" === t2 && Array.isArray(r[0]) && "-" === r[0][0] ? remove_duplicate_negatives$1(r[0][1]) : (r = r.map(remove_duplicate_negatives$1), [t2].concat(r));
}
function normalize_negatives_in_factors$1(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if (r = r.map(normalize_negatives_in_factors$1), "*" !== t2 && "/" !== t2) return [t2].concat(r);
  for (var n = 1, i2 = [], a = 0; a < r.length; a++) Array.isArray(r[a]) && "-" === r[a][0] ? (n *= -1, i2.push(r[a][1])) : i2.push(r[a]);
  var o = [t2].concat(i2);
  return -1 === n && (o = ["-", o]), o;
}
function normalize_negatives$1(e2) {
  var t2 = get_tree$1(e2);
  return t2 = remove_duplicate_negatives$1(t2), t2 = remove_duplicate_negatives$1(t2 = normalize_negatives_in_factors$1(t2));
}
function sort_key$1(e2, t2 = {}) {
  if ("number" == typeof e2) return t2.ignore_negatives ? [0, "number", Math.abs(e2)] : [0, "number", e2];
  if ("string" == typeof e2) return "-" === e2 || "+" === e2 ? [8, "plus_minus_string", e2] : [1, "symbol", e2];
  if ("boolean" == typeof e2) return [1, "boolean", e2];
  if (!Array.isArray(e2)) return [-1, "unknown", e2];
  var r = e2[0], n = e2.slice(1);
  if ("apply" === r) {
    var i2 = [2, "function", n[0]], a = n[1], o = 1, s = [];
    return Array.isArray(a) ? (o = (a = a.slice(1)).length, s = a.map(((e3) => sort_key$1(e3, t2)))) : s = [sort_key$1(a, t2)], i2.push([o, s]), i2;
  }
  if ("unit" === r) {
    let [r2, n3] = get_unit_value_of_tree$1(e2);
    if (r2) {
      let e3 = sort_key$1(n3, t2);
      return e3[1] += "_" + r2, e3;
    }
  }
  var u = n.length, c2 = n.map(sort_key$1, t2);
  return "*" === r ? [4, "product", u, c2] : "/" === r ? [4, "quotient", u, c2] : "+" === r ? [5, "sum", u, c2] : "-" === r ? t2.ignore_negatives ? c2[0] : [6, "minus", u, c2] : ["tuple", "vector", "altvector"].includes(r) ? [7, u, c2] : "interval" === r ? false === n[1][1] ? false === n[1][2] ? [7, ...c2[0].slice(1)] : [8, u, c2] : false === n[1][2] ? [8, u, c2] : [9, ...c2[0].slice(1)] : "array" === r ? [9, u, c2] : [10, r, u, c2];
}
function arrayCompare$1(e2, t2) {
  if (Array.isArray(e2)) {
    if (Array.isArray(t2)) {
      let r = Math.min(e2.length, t2.length);
      for (let n = 0; n < r; n++) {
        let r2 = arrayCompare$1(e2[n], t2[n]);
        if (0 !== r2) return r2;
      }
      return e2.length < t2.length ? -1 : e2.length > t2.length ? 1 : 0;
    }
    return 1;
  }
  return Array.isArray(t2) || e2 < t2 ? -1 : e2 > t2 ? 1 : 0;
}
function compare_function$1(e2, t2, r = {}) {
  return arrayCompare$1(sort_key$1(e2, r), sort_key$1(t2, r));
}
function coeff_factors_from_term$1(e2, t2) {
  if ("string" == typeof e2) {
    let r = t2.indexOf(e2);
    -1 === r && (t2.push(e2), r = t2.length - 1);
    let n = [];
    return n[r] = 1, { factor_contains: n, coeff: 1 };
  }
  if (Array.isArray(e2)) {
    let r = e2[0], n = e2.slice(1);
    if ("*" === r) {
      let e3 = [], r2 = [];
      for (let i2 of n) if ("string" != typeof i2) if (!Array.isArray(i2) || "^" !== i2[0] && "-" !== i2[0]) e3.push(i2);
      else {
        let n3 = coeff_factors_from_term$1(i2, t2);
        for (let e4 in n3.factor_contains) void 0 === r2[e4] && (r2[e4] = 0), r2[e4] += n3.factor_contains[e4];
        1 !== n3.coeff && e3.push(n3.coeff);
      }
      else {
        let e4 = t2.indexOf(i2);
        -1 === e4 && (t2.push(i2), e4 = t2.length - 1), void 0 === r2[e4] && (r2[e4] = 0), r2[e4]++;
      }
      return e3 = 0 === e3.length ? 1 : 1 === e3.length ? e3[0] : ["*", ...e3], { factor_contains: r2, coeff: e3 };
    }
    if ("^" === r) {
      let e3 = n[0], r2 = n[1], i2 = [];
      if ("string" == typeof e3 && Number.isFinite(r2)) {
        let n3 = t2.indexOf(e3);
        return -1 === n3 && (t2.push(e3), n3 = t2.length - 1), i2[n3] = r2, { factor_contains: i2, coeff: 1 };
      }
    } else {
      if ("-" === r) {
        let e3 = coeff_factors_from_term$1(n[0], t2), r2 = -1;
        return "number" == typeof e3.coeff ? r2 *= e3.coeff : r2 = ["-", e3.coeff], { factor_contains: e3.factor_contains, coeff: r2 };
      }
      if ("/" === r) {
        let e3 = coeff_factors_from_term$1(n[0], t2), r2 = ["/", e3.coeff, n[1]];
        return { factor_contains: e3.factor_contains, coeff: r2 };
      }
    }
  }
  return { factor_contains: [], coeff: e2 };
}
function default_order$1(e2, t2) {
  void 0 === t2 && (t2 = {});
  var r = get_tree$1(e2);
  return r = normalize_negatives$1(r = flatten$5$1(r)), normalize_negatives$1((function e3(r2) {
    if (!Array.isArray(r2)) return r2;
    var n = r2[0], i2 = r2.slice(1);
    if (i2 = i2.map(e3), "+" === n) {
      let e4 = [], r3 = [], n3 = [];
      for (let t3 of i2) {
        let i3 = coeff_factors_from_term$1(t3, e4);
        r3.push(i3.factor_contains), n3.push(i3.coeff);
      }
      let a2 = [];
      for (let [t3, n4] of e4.entries()) {
        let e5 = { varname: n4, exponents_in_term: [] };
        for (let n5 = 0; n5 < r3.length; n5++) e5.exponents_in_term.push(r3[n5][t3] || 0);
        a2.push(e5);
      }
      a2.sort(((e5, t3) => e5.varname < t3.varname ? -1 : 1));
      let o2 = [];
      for (let e5 = 0; e5 < n3.length; e5++) {
        let r4 = a2.reduce(((t3, r5) => [...t3, -r5.exponents_in_term[e5]]), []);
        r4.push(sort_key$1(n3[e5], t2)), o2.push(r4);
      }
      let s = [];
      for (let [e5, t3] of i2.entries()) s.push({ term: t3, sort_key: o2[e5] });
      s.sort(((e5, t3) => arrayCompare$1(e5.sort_key, t3.sort_key))), i2 = s.map(((e5) => e5.term));
    } else if ("*" === n) {
      let e4 = [], r3 = [];
      for (let t3 of i2) ["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(t3[0]) ? r3.push(t3) : e4.push(t3);
      e4.sort(((e5, r4) => compare_function$1(e5, r4, t2))), i2 = [...e4, ...r3];
    } else if ("=" === n || "and" === n || "or" === n || "ne" === n || "union" === n || "intersect" === n) i2.sort(((e4, r3) => compare_function$1(e4, r3, t2)));
    else if (">" === n || "ge" === n) i2 = i2.reverse(), n = ">" === n ? "<" : "le";
    else if ("gts" === n) {
      var a = i2[0], o = i2[1];
      if ("tuple" !== a[0] || "tuple" !== o[0]) throw new Error("Badly formed ast");
      n = "lts", i2 = [a = ["tuple"].concat(a.slice(1).reverse()), o = ["tuple"].concat(o.slice(1).reverse())];
    } else if ("ni" === n || "notni" === n || "superset" === n || "notsuperset" === n || "superseteq" === n || "notsuperseteq" === n) i2 = i2.reverse(), "ni" === n ? n = "in" : "notni" === n ? n = "notin" : "superset" === n ? n = "subset" : "notsuperset" === n ? n = "notsubset" : "superseteq" === n ? n = "subseteq" : "notsuperseteq" === n && (n = "notsubseteq");
    else if ("-" === n && "*" === i2[0][0]) return i2[0][1] = ["-", i2[0][1]], i2[0];
    return [n].concat(i2);
  })(r));
}
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var r = arguments[t2];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e2[n] = r[n]);
    }
    return e2;
  }, _extends$4.apply(null, arguments);
}
var DEFAULT_CONFIG$1 = { relTol: 1e-12, absTol: 1e-15, matrix: "Matrix", number: "number", numberFallback: "number", precision: 64, predictable: false, randomSeed: null, legacySubset: false };
function getSafeProperty$1(e2, t2) {
  if (isSafeProperty$1(e2, t2)) return e2[t2];
  if ("function" == typeof e2[t2] && isSafeMethod$1(e2, t2)) throw new Error('Cannot access method "' + t2 + '" as a property');
  throw new Error('No access to property "' + t2 + '"');
}
function setSafeProperty$1(e2, t2, r) {
  if (isSafeProperty$1(e2, t2)) return e2[t2] = r, r;
  throw new Error('No access to property "' + t2 + '"');
}
function isSafeProperty$1(e2, t2) {
  return !(!isPlainObject$5(e2) && !Array.isArray(e2)) && (!!hasOwnProperty$1$2(safeNativeProperties$1, t2) || !(t2 in Object.prototype) && !(t2 in Function.prototype));
}
function getSafeMethod$1(e2, t2) {
  if (!isSafeMethod$1(e2, t2)) throw new Error('No access to method "' + t2 + '"');
  return e2[t2];
}
function isSafeMethod$1(e2, t2) {
  return null != e2 && "function" == typeof e2[t2] && (!(hasOwnProperty$1$2(e2, t2) && Object.getPrototypeOf && t2 in Object.getPrototypeOf(e2)) && (!!hasOwnProperty$1$2(safeNativeMethods$1, t2) || !(t2 in Object.prototype) && !(t2 in Function.prototype)));
}
function isPlainObject$5(e2) {
  return "object" == typeof e2 && e2 && e2.constructor === Object;
}
var safeNativeProperties$1 = { length: true, name: true }, safeNativeMethods$1 = { toString: true, valueOf: true, toLocaleString: true };
let ObjectWrappingMap$1 = class ObjectWrappingMap2 {
  constructor(e2) {
    this.wrappedObject = e2, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter(((e2) => this.has(e2))).values();
  }
  get(e2) {
    return getSafeProperty$1(this.wrappedObject, e2);
  }
  set(e2, t2) {
    return setSafeProperty$1(this.wrappedObject, e2, t2), this;
  }
  has(e2) {
    return isSafeProperty$1(this.wrappedObject, e2) && e2 in this.wrappedObject;
  }
  entries() {
    return mapIterator$1(this.keys(), ((e2) => [e2, this.get(e2)]));
  }
  forEach(e2) {
    for (var t2 of this.keys()) e2(this.get(t2), t2, this);
  }
  delete(e2) {
    isSafeProperty$1(this.wrappedObject, e2) && delete this.wrappedObject[e2];
  }
  clear() {
    for (var e2 of this.keys()) this.delete(e2);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
};
let PartitionedMap$1 = class PartitionedMap2 {
  constructor(e2, t2, r) {
    this.a = e2, this.b = t2, this.bKeys = r, this[Symbol.iterator] = this.entries;
  }
  get(e2) {
    return this.bKeys.has(e2) ? this.b.get(e2) : this.a.get(e2);
  }
  set(e2, t2) {
    return this.bKeys.has(e2) ? this.b.set(e2, t2) : this.a.set(e2, t2), this;
  }
  has(e2) {
    return this.b.has(e2) || this.a.has(e2);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return mapIterator$1(this.keys(), ((e2) => [e2, this.get(e2)]));
  }
  forEach(e2) {
    for (var t2 of this.keys()) e2(this.get(t2), t2, this);
  }
  delete(e2) {
    return this.bKeys.has(e2) ? this.b.delete(e2) : this.a.delete(e2);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
};
function mapIterator$1(e2, t2) {
  return { next: () => {
    var r = e2.next();
    return r.done ? r : { value: t2(r.value), done: false };
  } };
}
function createEmptyMap$1() {
  return /* @__PURE__ */ new Map();
}
function createMap$1$1(e2) {
  if (!e2) return createEmptyMap$1();
  if (isMap$1$1(e2)) return e2;
  if (isObject$1$1(e2)) return new ObjectWrappingMap$1(e2);
  throw new Error("createMap can create maps from objects or Maps");
}
function toObject$1(e2) {
  if (e2 instanceof ObjectWrappingMap$1) return e2.wrappedObject;
  var t2 = {};
  for (var r of e2.keys()) {
    setSafeProperty$1(t2, r, e2.get(r));
  }
  return t2;
}
function isNumber$1$1(e2) {
  return "number" == typeof e2;
}
function isBigNumber$1(e2) {
  return !(!e2 || "object" != typeof e2 || "function" != typeof e2.constructor) && (true === e2.isBigNumber && "object" == typeof e2.constructor.prototype && true === e2.constructor.prototype.isBigNumber || "function" == typeof e2.constructor.isDecimal && true === e2.constructor.isDecimal(e2));
}
function isBigInt$1(e2) {
  return "bigint" == typeof e2;
}
function isComplex$1(e2) {
  return e2 && "object" == typeof e2 && true === Object.getPrototypeOf(e2).isComplex || false;
}
function isFraction$1(e2) {
  return e2 && "object" == typeof e2 && true === Object.getPrototypeOf(e2).isFraction || false;
}
function isUnit$1(e2) {
  return e2 && true === e2.constructor.prototype.isUnit || false;
}
function isString$1$1(e2) {
  return "string" == typeof e2;
}
var isArray$1$1 = Array.isArray;
function isMatrix$1(e2) {
  return e2 && true === e2.constructor.prototype.isMatrix || false;
}
function isCollection$1(e2) {
  return Array.isArray(e2) || isMatrix$1(e2);
}
function isDenseMatrix$1(e2) {
  return e2 && e2.isDenseMatrix && true === e2.constructor.prototype.isMatrix || false;
}
function isSparseMatrix$1(e2) {
  return e2 && e2.isSparseMatrix && true === e2.constructor.prototype.isMatrix || false;
}
function isRange$1(e2) {
  return e2 && true === e2.constructor.prototype.isRange || false;
}
function isIndex$1(e2) {
  return e2 && true === e2.constructor.prototype.isIndex || false;
}
function isBoolean$1$1(e2) {
  return "boolean" == typeof e2;
}
function isResultSet$1(e2) {
  return e2 && true === e2.constructor.prototype.isResultSet || false;
}
function isHelp$1(e2) {
  return e2 && true === e2.constructor.prototype.isHelp || false;
}
function isFunction$2$1(e2) {
  return "function" == typeof e2;
}
function isDate$1$1(e2) {
  return e2 instanceof Date;
}
function isRegExp$1$1(e2) {
  return e2 instanceof RegExp;
}
function isObject$1$1(e2) {
  return !(!e2 || "object" != typeof e2 || e2.constructor !== Object || isComplex$1(e2) || isFraction$1(e2));
}
function isMap$1$1(e2) {
  return !!e2 && (e2 instanceof Map || e2 instanceof ObjectWrappingMap$1 || "function" == typeof e2.set && "function" == typeof e2.get && "function" == typeof e2.keys && "function" == typeof e2.has);
}
function isPartitionedMap$1(e2) {
  return isMap$1$1(e2) && isMap$1$1(e2.a) && isMap$1$1(e2.b);
}
function isObjectWrappingMap$1(e2) {
  return isMap$1$1(e2) && isObject$1$1(e2.wrappedObject);
}
function isNull$1$1(e2) {
  return null === e2;
}
function isUndefined$1$1(e2) {
  return void 0 === e2;
}
function isAccessorNode$1(e2) {
  return e2 && true === e2.isAccessorNode && true === e2.constructor.prototype.isNode || false;
}
function isArrayNode$1(e2) {
  return e2 && true === e2.isArrayNode && true === e2.constructor.prototype.isNode || false;
}
function isAssignmentNode$1(e2) {
  return e2 && true === e2.isAssignmentNode && true === e2.constructor.prototype.isNode || false;
}
function isBlockNode$1(e2) {
  return e2 && true === e2.isBlockNode && true === e2.constructor.prototype.isNode || false;
}
function isConditionalNode$1(e2) {
  return e2 && true === e2.isConditionalNode && true === e2.constructor.prototype.isNode || false;
}
function isConstantNode$1(e2) {
  return e2 && true === e2.isConstantNode && true === e2.constructor.prototype.isNode || false;
}
function rule2Node$1(e2) {
  return isConstantNode$1(e2) || isOperatorNode$1(e2) && 1 === e2.args.length && isConstantNode$1(e2.args[0]) && "-+~".includes(e2.op);
}
function isFunctionAssignmentNode$1(e2) {
  return e2 && true === e2.isFunctionAssignmentNode && true === e2.constructor.prototype.isNode || false;
}
function isFunctionNode$1(e2) {
  return e2 && true === e2.isFunctionNode && true === e2.constructor.prototype.isNode || false;
}
function isIndexNode$1(e2) {
  return e2 && true === e2.isIndexNode && true === e2.constructor.prototype.isNode || false;
}
function isNode$2(e2) {
  return e2 && true === e2.isNode && true === e2.constructor.prototype.isNode || false;
}
function isObjectNode$1(e2) {
  return e2 && true === e2.isObjectNode && true === e2.constructor.prototype.isNode || false;
}
function isOperatorNode$1(e2) {
  return e2 && true === e2.isOperatorNode && true === e2.constructor.prototype.isNode || false;
}
function isParenthesisNode$1(e2) {
  return e2 && true === e2.isParenthesisNode && true === e2.constructor.prototype.isNode || false;
}
function isRangeNode$1(e2) {
  return e2 && true === e2.isRangeNode && true === e2.constructor.prototype.isNode || false;
}
function isRelationalNode$1(e2) {
  return e2 && true === e2.isRelationalNode && true === e2.constructor.prototype.isNode || false;
}
function isSymbolNode$1(e2) {
  return e2 && true === e2.isSymbolNode && true === e2.constructor.prototype.isNode || false;
}
function isChain$1(e2) {
  return e2 && true === e2.constructor.prototype.isChain || false;
}
function typeOf$1(e2) {
  var t2 = typeof e2;
  return "object" === t2 ? null === e2 ? "null" : isBigNumber$1(e2) ? "BigNumber" : e2.constructor && e2.constructor.name ? e2.constructor.name : "Object" : t2;
}
function clone$3$1(e2) {
  var t2 = typeof e2;
  if ("number" === t2 || "bigint" === t2 || "string" === t2 || "boolean" === t2 || null == e2) return e2;
  if ("function" == typeof e2.clone) return e2.clone();
  if (Array.isArray(e2)) return e2.map((function(e3) {
    return clone$3$1(e3);
  }));
  if (e2 instanceof Date) return new Date(e2.valueOf());
  if (isBigNumber$1(e2)) return e2;
  if (isObject$1$1(e2)) return mapObject$1$1(e2, clone$3$1);
  if ("function" === t2) return e2;
  throw new TypeError("Cannot clone: unknown type of value (value: ".concat(e2, ")"));
}
function mapObject$1$1(e2, t2) {
  var r = {};
  for (var n in e2) hasOwnProperty$1$2(e2, n) && (r[n] = t2(e2[n]));
  return r;
}
function extend$2$1(e2, t2) {
  for (var r in t2) hasOwnProperty$1$2(t2, r) && (e2[r] = t2[r]);
  return e2;
}
function deepExtend$1(e2, t2) {
  if (Array.isArray(t2)) throw new TypeError("Arrays are not supported by deepExtend");
  for (var r in t2) if (hasOwnProperty$1$2(t2, r) && !(r in Object.prototype) && !(r in Function.prototype)) if (t2[r] && t2[r].constructor === Object) void 0 === e2[r] && (e2[r] = {}), e2[r] && e2[r].constructor === Object ? deepExtend$1(e2[r], t2[r]) : e2[r] = t2[r];
  else {
    if (Array.isArray(t2[r])) throw new TypeError("Arrays are not supported by deepExtend");
    e2[r] = t2[r];
  }
  return e2;
}
function deepStrictEqual$1(e2, t2) {
  var r, n, i2;
  if (Array.isArray(e2)) {
    if (!Array.isArray(t2)) return false;
    if (e2.length !== t2.length) return false;
    for (n = 0, i2 = e2.length; n < i2; n++) if (!deepStrictEqual$1(e2[n], t2[n])) return false;
    return true;
  }
  if ("function" == typeof e2) return e2 === t2;
  if (e2 instanceof Object) {
    if (Array.isArray(t2) || !(t2 instanceof Object)) return false;
    for (r in e2) if (!(r in t2) || !deepStrictEqual$1(e2[r], t2[r])) return false;
    for (r in t2) if (!(r in e2)) return false;
    return true;
  }
  return e2 === t2;
}
function deepFlatten$1(e2) {
  var t2 = {};
  return _deepFlatten$1(e2, t2), t2;
}
function _deepFlatten$1(e2, t2) {
  for (var r in e2) if (hasOwnProperty$1$2(e2, r)) {
    var n = e2[r];
    "object" == typeof n && null !== n ? _deepFlatten$1(n, t2) : t2[r] = n;
  }
}
function lazy$1(e2, t2, r) {
  var n, i2 = true;
  Object.defineProperty(e2, t2, { get: function() {
    return i2 && (n = r(), i2 = false), n;
  }, set: function(e3) {
    n = e3, i2 = false;
  }, configurable: true, enumerable: true });
}
function hasOwnProperty$1$2(e2, t2) {
  return e2 && Object.hasOwnProperty.call(e2, t2);
}
function isLegacyFactory$1(e2) {
  return e2 && "function" == typeof e2.factory;
}
function pickShallow$1(e2, t2) {
  for (var r = {}, n = 0; n < t2.length; n++) {
    var i2 = t2[n], a = e2[i2];
    void 0 !== a && (r[i2] = a);
  }
  return r;
}
var MATRIX_OPTIONS$1 = ["Matrix", "Array"], NUMBER_OPTIONS$1 = ["number", "BigNumber", "bigint", "Fraction"];
function configFactory$1(e2, t2) {
  function r(n) {
    if (n) {
      if (void 0 !== n.epsilon) {
        console.warn('Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.');
        var i2 = clone$3$1(n);
        return i2.relTol = n.epsilon, i2.absTol = 1e-3 * n.epsilon, delete i2.epsilon, r(i2);
      }
      true === n.legacySubset && console.warn('Warning: The configuration option "legacySubset" is for compatibility only and might be deprecated in the future.');
      var a = clone$3$1(e2);
      validateOption$1(n, "matrix", MATRIX_OPTIONS$1), validateOption$1(n, "number", NUMBER_OPTIONS$1), deepExtend$1(e2, n);
      var o = clone$3$1(e2), s = clone$3$1(n);
      return t2("config", o, a, s), o;
    }
    return clone$3$1(e2);
  }
  return r.MATRIX_OPTIONS = MATRIX_OPTIONS$1, r.NUMBER_OPTIONS = NUMBER_OPTIONS$1, Object.keys(DEFAULT_CONFIG$1).forEach(((t3) => {
    Object.defineProperty(r, t3, { get: () => e2[t3], enumerable: true, configurable: true });
  })), r;
}
function validateOption$1(e2, t2, r) {
  void 0 === e2[t2] || r.includes(e2[t2]) || console.warn('Warning: Unknown value "' + e2[t2] + '" for configuration option "' + t2 + '". Available options: ' + r.map(((e3) => JSON.stringify(e3))).join(", ") + ".");
}
var commonjsGlobal$3 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function getDefaultExportFromCjs$5(e2) {
  return e2 && e2.__esModule && Object.prototype.hasOwnProperty.call(e2, "default") ? e2.default : e2;
}
function getAugmentedNamespace$2(e2) {
  if (e2.__esModule) return e2;
  var t2 = e2.default;
  if ("function" == typeof t2) {
    var r = function e3() {
      return this instanceof e3 ? Reflect.construct(t2, arguments, this.constructor) : t2.apply(this, arguments);
    };
    r.prototype = t2.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: true }), Object.keys(e2).forEach((function(t3) {
    var n = Object.getOwnPropertyDescriptor(e2, t3);
    Object.defineProperty(r, t3, n.get ? n : { enumerable: true, get: function() {
      return e2[t3];
    } });
  })), r;
}
var typedFunction$2$1 = { exports: {} };
typedFunction$2$1.exports;
var hasRequiredTypedFunction$1;
function requireTypedFunction$1() {
  return hasRequiredTypedFunction$1 || (hasRequiredTypedFunction$1 = 1, e2 = typedFunction$2$1, typedFunction$2$1.exports, e2.exports = (function() {
    function e3() {
      return true;
    }
    function t2() {
      return false;
    }
    function r() {
    }
    const n = "Argument is not a typed-function.";
    function i2() {
      function a2(e4) {
        return "object" == typeof e4 && null !== e4 && e4.constructor === Object;
      }
      const o = [{ name: "number", test: function(e4) {
        return "number" == typeof e4;
      } }, { name: "string", test: function(e4) {
        return "string" == typeof e4;
      } }, { name: "boolean", test: function(e4) {
        return "boolean" == typeof e4;
      } }, { name: "Function", test: function(e4) {
        return "function" == typeof e4;
      } }, { name: "Array", test: Array.isArray }, { name: "Date", test: function(e4) {
        return e4 instanceof Date;
      } }, { name: "RegExp", test: function(e4) {
        return e4 instanceof RegExp;
      } }, { name: "Object", test: a2 }, { name: "null", test: function(e4) {
        return null === e4;
      } }, { name: "undefined", test: function(e4) {
        return void 0 === e4;
      } }], s = { name: "any", test: e3, isAny: true };
      let u, c2, l = 0, f2 = { createCount: 0 };
      function p(e4) {
        const t3 = u.get(e4);
        if (t3) return t3;
        let r2 = 'Unknown type "' + e4 + '"';
        const n3 = e4.toLowerCase();
        let i3;
        for (i3 of c2) if (i3.toLowerCase() === n3) {
          r2 += '. Did you mean "' + i3 + '" ?';
          break;
        }
        throw new TypeError(r2);
      }
      function m(e4) {
        let t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "any";
        const r2 = t3 ? p(t3).index : c2.length, n3 = [];
        for (let t4 = 0; t4 < e4.length; ++t4) {
          if (!e4[t4] || "string" != typeof e4[t4].name || "function" != typeof e4[t4].test) throw new TypeError("Object with properties {name: string, test: function} expected");
          const i4 = e4[t4].name;
          if (u.has(i4)) throw new TypeError('Duplicate type name "' + i4 + '"');
          n3.push(i4), u.set(i4, { name: i4, test: e4[t4].test, isAny: e4[t4].isAny, index: r2 + t4, conversionsTo: [] });
        }
        const i3 = c2.slice(r2);
        c2 = c2.slice(0, r2).concat(n3).concat(i3);
        for (let e5 = r2 + n3.length; e5 < c2.length; ++e5) u.get(c2[e5]).index = e5;
      }
      function d() {
        u = /* @__PURE__ */ new Map(), c2 = [], l = 0, m([s], false);
      }
      function h() {
        let e4;
        for (e4 of c2) u.get(e4).conversionsTo = [];
        l = 0;
      }
      function g(e4) {
        const t3 = c2.filter(((t4) => {
          const r2 = u.get(t4);
          return !r2.isAny && r2.test(e4);
        }));
        return t3.length ? t3 : ["any"];
      }
      function y(e4) {
        return e4 && "function" == typeof e4 && "_typedFunctionData" in e4;
      }
      function v2(e4, t3, r2) {
        if (!y(e4)) throw new TypeError(n);
        const i3 = r2 && r2.exact, a3 = D(Array.isArray(t3) ? t3.join(",") : t3), o2 = _2(a3);
        if (!i3 || o2 in e4.signatures) {
          const t4 = e4._typedFunctionData.signatureMap.get(o2);
          if (t4) return t4;
        }
        const s2 = a3.length;
        let u2, c3;
        if (i3) {
          let t4;
          for (t4 in u2 = [], e4.signatures) u2.push(e4._typedFunctionData.signatureMap.get(t4));
        } else u2 = e4._typedFunctionData.signatures;
        for (let e5 = 0; e5 < s2; ++e5) {
          const t4 = a3[e5], r3 = [];
          let n3;
          for (n3 of u2) {
            const i4 = C2(n3.params, e5);
            if (i4 && (!t4.restParam || i4.restParam)) {
              if (!i4.hasAny) {
                const e6 = N(i4);
                if (t4.types.some(((t5) => !e6.has(t5.name)))) continue;
              }
              r3.push(n3);
            }
          }
          if (u2 = r3, 0 === u2.length) break;
        }
        for (c3 of u2) if (c3.params.length <= s2) return c3;
        throw new TypeError("Signature not found (signature: " + (e4.name || "unnamed") + "(" + _2(a3, ", ") + "))");
      }
      function x2(e4, t3, r2) {
        return v2(e4, t3, r2).implementation;
      }
      function b2(e4, t3) {
        const r2 = p(t3);
        if (r2.test(e4)) return e4;
        const n3 = r2.conversionsTo;
        if (0 === n3.length) throw new Error("There are no conversions to " + t3 + " defined.");
        for (let t4 = 0; t4 < n3.length; t4++) if (p(n3[t4].from).test(e4)) return n3[t4].convert(e4);
        throw new Error("Cannot convert " + e4 + " to " + t3);
      }
      function _2(e4) {
        let t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",";
        return e4.map(((e5) => e5.name)).join(t3);
      }
      function w2(e4) {
        const t3 = 0 === e4.indexOf("..."), r2 = (t3 ? e4.length > 3 ? e4.slice(3) : "any" : e4).split("|").map(((e5) => p(e5.trim())));
        let n3 = false, i3 = t3 ? "..." : "";
        return { types: r2.map((function(e5) {
          return n3 = e5.isAny || n3, i3 += e5.name + "|", { name: e5.name, typeIndex: e5.index, test: e5.test, isAny: e5.isAny, conversion: null, conversionIndex: -1 };
        })), name: i3.slice(0, -1), hasAny: n3, hasConversion: false, restParam: t3 };
      }
      function A2(e4) {
        const t3 = q2(e4.types.map(((e5) => e5.name)));
        let r2 = e4.hasAny, n3 = e4.name;
        const i3 = t3.map((function(e5) {
          const t4 = p(e5.from);
          return r2 = t4.isAny || r2, n3 += "|" + e5.from, { name: e5.from, typeIndex: t4.index, test: t4.test, isAny: t4.isAny, conversion: e5, conversionIndex: e5.index };
        }));
        return { types: e4.types.concat(i3), name: n3, hasAny: r2, hasConversion: i3.length > 0, restParam: e4.restParam };
      }
      function N(e4) {
        return e4.typeSet || (e4.typeSet = /* @__PURE__ */ new Set(), e4.types.forEach(((t3) => e4.typeSet.add(t3.name)))), e4.typeSet;
      }
      function D(e4) {
        const t3 = [];
        if ("string" != typeof e4) throw new TypeError("Signatures must be strings");
        const r2 = e4.trim();
        if ("" === r2) return t3;
        const n3 = r2.split(",");
        for (let e5 = 0; e5 < n3.length; ++e5) {
          const r3 = w2(n3[e5].trim());
          if (r3.restParam && e5 !== n3.length - 1) throw new SyntaxError('Unexpected rest parameter "' + n3[e5] + '": only allowed for the last parameter');
          if (0 === r3.types.length) return null;
          t3.push(r3);
        }
        return t3;
      }
      function E(e4) {
        const t3 = Q2(e4);
        return !!t3 && t3.restParam;
      }
      function $2(t3) {
        if (t3 && 0 !== t3.types.length) {
          if (1 === t3.types.length) return p(t3.types[0].name).test;
          if (2 === t3.types.length) {
            const e4 = p(t3.types[0].name).test, r2 = p(t3.types[1].name).test;
            return function(t4) {
              return e4(t4) || r2(t4);
            };
          }
          {
            const e4 = t3.types.map((function(e5) {
              return p(e5.name).test;
            }));
            return function(t4) {
              for (let r2 = 0; r2 < e4.length; r2++) if (e4[r2](t4)) return true;
              return false;
            };
          }
        }
        return e3;
      }
      function S2(e4) {
        let t3, r2, n3;
        if (E(e4)) {
          t3 = W2(e4).map($2);
          const r3 = t3.length, n4 = $2(Q2(e4)), i3 = function(e5) {
            for (let t4 = r3; t4 < e5.length; t4++) if (!n4(e5[t4])) return false;
            return true;
          };
          return function(e5) {
            for (let r4 = 0; r4 < t3.length; r4++) if (!t3[r4](e5[r4])) return false;
            return i3(e5) && e5.length >= r3 + 1;
          };
        }
        return 0 === e4.length ? function(e5) {
          return 0 === e5.length;
        } : 1 === e4.length ? (r2 = $2(e4[0]), function(e5) {
          return r2(e5[0]) && 1 === e5.length;
        }) : 2 === e4.length ? (r2 = $2(e4[0]), n3 = $2(e4[1]), function(e5) {
          return r2(e5[0]) && n3(e5[1]) && 2 === e5.length;
        }) : (t3 = e4.map($2), function(e5) {
          for (let r3 = 0; r3 < t3.length; r3++) if (!t3[r3](e5[r3])) return false;
          return e5.length === t3.length;
        });
      }
      function C2(e4, t3) {
        return t3 < e4.length ? e4[t3] : E(e4) ? Q2(e4) : null;
      }
      function M2(e4, t3) {
        const r2 = C2(e4, t3);
        return r2 ? N(r2) : /* @__PURE__ */ new Set();
      }
      function T2(e4) {
        return null === e4.conversion || void 0 === e4.conversion;
      }
      function F(e4, t3) {
        const r2 = /* @__PURE__ */ new Set();
        return e4.forEach(((e5) => {
          const n3 = M2(e5.params, t3);
          let i3;
          for (i3 of n3) r2.add(i3);
        })), r2.has("any") ? ["any"] : Array.from(r2);
      }
      function O2(e4, t3, r2) {
        let n3, i3;
        const a3 = e4 || "unnamed";
        let o2, s2 = r2;
        for (o2 = 0; o2 < t3.length; o2++) {
          const e5 = [];
          if (s2.forEach(((r3) => {
            const n4 = $2(C2(r3.params, o2));
            (o2 < r3.params.length || E(r3.params)) && n4(t3[o2]) && e5.push(r3);
          })), 0 === e5.length) {
            if (i3 = F(s2, o2), i3.length > 0) {
              const e6 = g(t3[o2]);
              return n3 = new TypeError("Unexpected type of argument in function " + a3 + " (expected: " + i3.join(" or ") + ", actual: " + e6.join(" | ") + ", index: " + o2 + ")"), n3.data = { category: "wrongType", fn: a3, index: o2, actual: e6, expected: i3 }, n3;
            }
          } else s2 = e5;
        }
        const u2 = s2.map((function(e5) {
          return E(e5.params) ? 1 / 0 : e5.params.length;
        }));
        if (t3.length < Math.min.apply(null, u2)) return i3 = F(s2, o2), n3 = new TypeError("Too few arguments in function " + a3 + " (expected: " + i3.join(" or ") + ", index: " + t3.length + ")"), n3.data = { category: "tooFewArgs", fn: a3, index: t3.length, expected: i3 }, n3;
        const c3 = Math.max.apply(null, u2);
        if (t3.length > c3) return n3 = new TypeError("Too many arguments in function " + a3 + " (expected: " + c3 + ", actual: " + t3.length + ")"), n3.data = { category: "tooManyArgs", fn: a3, index: t3.length, expectedLength: c3 }, n3;
        const l2 = [];
        for (let e5 = 0; e5 < t3.length; ++e5) l2.push(g(t3[e5]).join("|"));
        return n3 = new TypeError('Arguments of type "' + l2.join(", ") + '" do not match any of the defined signatures of function ' + a3 + "."), n3.data = { category: "mismatch", actual: l2 }, n3;
      }
      function k2(e4) {
        let t3 = c2.length + 1;
        for (let r2 = 0; r2 < e4.types.length; r2++) T2(e4.types[r2]) && (t3 = Math.min(t3, e4.types[r2].typeIndex));
        return t3;
      }
      function B2(e4) {
        let t3 = l + 1;
        for (let r2 = 0; r2 < e4.types.length; r2++) T2(e4.types[r2]) || (t3 = Math.min(t3, e4.types[r2].conversionIndex));
        return t3;
      }
      function I2(e4, t3) {
        if (e4.hasAny) {
          if (!t3.hasAny) return 1;
        } else if (t3.hasAny) return -1;
        if (e4.restParam) {
          if (!t3.restParam) return 1;
        } else if (t3.restParam) return -1;
        if (e4.hasConversion) {
          if (!t3.hasConversion) return 1;
        } else if (t3.hasConversion) return -1;
        const r2 = k2(e4) - k2(t3);
        if (r2 < 0) return -1;
        if (r2 > 0) return 1;
        const n3 = B2(e4) - B2(t3);
        return n3 < 0 ? -1 : n3 > 0 ? 1 : 0;
      }
      function R2(e4, t3) {
        const r2 = e4.params, n3 = t3.params, i3 = Q2(r2), a3 = Q2(n3), o2 = E(r2), s2 = E(n3);
        if (o2 && i3.hasAny) {
          if (!s2 || !a3.hasAny) return 1;
        } else if (s2 && a3.hasAny) return -1;
        let u2, c3 = 0, l2 = 0;
        for (u2 of r2) u2.hasAny && ++c3, u2.hasConversion && ++l2;
        let f3 = 0, p2 = 0;
        for (u2 of n3) u2.hasAny && ++f3, u2.hasConversion && ++p2;
        if (c3 !== f3) return c3 - f3;
        if (o2 && i3.hasConversion) {
          if (!s2 || !a3.hasConversion) return 1;
        } else if (s2 && a3.hasConversion) return -1;
        if (l2 !== p2) return l2 - p2;
        if (o2) {
          if (!s2) return 1;
        } else if (s2) return -1;
        const m2 = (r2.length - n3.length) * (o2 ? -1 : 1);
        if (0 !== m2) return m2;
        const d2 = [];
        let h2, g2 = 0;
        for (let e5 = 0; e5 < r2.length; ++e5) {
          const t4 = I2(r2[e5], n3[e5]);
          d2.push(t4), g2 += t4;
        }
        if (0 !== g2) return g2;
        for (h2 of d2) if (0 !== h2) return h2;
        return 0;
      }
      function q2(e4) {
        if (0 === e4.length) return [];
        const t3 = e4.map(p);
        e4.length > 1 && t3.sort(((e5, t4) => e5.index - t4.index));
        let r2 = t3[0].conversionsTo;
        if (1 === e4.length) return r2;
        r2 = r2.concat([]);
        const n3 = new Set(e4);
        for (let e5 = 1; e5 < t3.length; ++e5) {
          let i3;
          for (i3 of t3[e5].conversionsTo) n3.has(i3.from) || (r2.push(i3), n3.add(i3.from));
        }
        return r2;
      }
      function z2(e4, t3) {
        let r2 = t3;
        if (e4.some(((e5) => e5.hasConversion))) {
          const n4 = E(e4), i3 = e4.map(P2);
          r2 = function() {
            const e5 = [], r3 = n4 ? arguments.length - 1 : arguments.length;
            for (let t4 = 0; t4 < r3; t4++) e5[t4] = i3[t4](arguments[t4]);
            return n4 && (e5[r3] = arguments[r3].map(i3[r3])), t3.apply(this, e5);
          };
        }
        let n3 = r2;
        if (E(e4)) {
          const t4 = e4.length - 1;
          n3 = function() {
            return r2.apply(this, Y2(arguments, 0, t4).concat([Y2(arguments, t4)]));
          };
        }
        return n3;
      }
      function P2(e4) {
        let t3, r2, n3, i3;
        const a3 = [], o2 = [];
        switch (e4.types.forEach((function(e5) {
          e5.conversion && (a3.push(p(e5.conversion.from).test), o2.push(e5.conversion.convert));
        })), o2.length) {
          case 0:
            return function(e5) {
              return e5;
            };
          case 1:
            return t3 = a3[0], n3 = o2[0], function(e5) {
              return t3(e5) ? n3(e5) : e5;
            };
          case 2:
            return t3 = a3[0], r2 = a3[1], n3 = o2[0], i3 = o2[1], function(e5) {
              return t3(e5) ? n3(e5) : r2(e5) ? i3(e5) : e5;
            };
          default:
            return function(e5) {
              for (let t4 = 0; t4 < o2.length; t4++) if (a3[t4](e5)) return o2[t4](e5);
              return e5;
            };
        }
      }
      function L2(e4) {
        function t3(e5, r2, n3) {
          if (r2 < e5.length) {
            const i3 = e5[r2];
            let a3 = [];
            if (i3.restParam) {
              const e6 = i3.types.filter(T2);
              e6.length < i3.types.length && a3.push({ types: e6, name: "..." + e6.map(((e7) => e7.name)).join("|"), hasAny: e6.some(((e7) => e7.isAny)), hasConversion: false, restParam: true }), a3.push(i3);
            } else a3 = i3.types.map((function(e6) {
              return { types: [e6], name: e6.name, hasAny: e6.isAny, hasConversion: e6.conversion, restParam: false };
            }));
            return K2(a3, (function(i4) {
              return t3(e5, r2 + 1, n3.concat([i4]));
            }));
          }
          return [n3];
        }
        return t3(e4, 0, []);
      }
      function j2(e4, t3) {
        const r2 = Math.max(e4.length, t3.length);
        for (let n4 = 0; n4 < r2; n4++) {
          const r3 = M2(e4, n4), i4 = M2(t3, n4);
          let a4, o3 = false;
          for (a4 of i4) if (r3.has(a4)) {
            o3 = true;
            break;
          }
          if (!o3) return false;
        }
        const n3 = e4.length, i3 = t3.length, a3 = E(e4), o2 = E(t3);
        return a3 ? o2 ? n3 === i3 : i3 >= n3 : o2 ? n3 >= i3 : n3 === i3;
      }
      function U2(e4) {
        return e4.map(((e5) => ie2(e5) ? re2(e5.referToSelf.callback) : ne(e5) ? te2(e5.referTo.references, e5.referTo.callback) : e5));
      }
      function Z2(e4, t3, r2) {
        const n3 = [];
        let i3;
        for (i3 of e4) {
          let e5 = r2[i3];
          if ("number" != typeof e5) throw new TypeError('No definition for referenced signature "' + i3 + '"');
          if (e5 = t3[e5], "function" != typeof e5) return false;
          n3.push(e5);
        }
        return n3;
      }
      function G2(e4, t3, r2) {
        const n3 = U2(e4), i3 = new Array(n3.length).fill(false);
        let a3 = true;
        for (; a3; ) {
          a3 = false;
          let e5 = true;
          for (let o2 = 0; o2 < n3.length; ++o2) {
            if (i3[o2]) continue;
            const s2 = n3[o2];
            if (ie2(s2)) n3[o2] = s2.referToSelf.callback(r2), n3[o2].referToSelf = s2.referToSelf, i3[o2] = true, e5 = false;
            else if (ne(s2)) {
              const r3 = Z2(s2.referTo.references, n3, t3);
              r3 ? (n3[o2] = s2.referTo.callback.apply(this, r3), n3[o2].referTo = s2.referTo, i3[o2] = true, e5 = false) : a3 = true;
            }
          }
          if (e5 && a3) throw new SyntaxError("Circular reference detected in resolving typed.referTo");
        }
        return n3;
      }
      function V2(e4) {
        const t3 = /\bthis(\(|\.signatures\b)/;
        Object.keys(e4).forEach(((r2) => {
          const n3 = e4[r2];
          if (t3.test(n3.toString())) throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
        }));
      }
      function H2(e4, n3) {
        if (f2.createCount++, 0 === Object.keys(n3).length) throw new SyntaxError("No signatures provided");
        f2.warnAgainstDeprecatedThis && V2(n3);
        const i3 = [], a3 = [], o2 = {}, s2 = [];
        let u2;
        for (u2 in n3) {
          if (!Object.prototype.hasOwnProperty.call(n3, u2)) continue;
          const e5 = D(u2);
          if (!e5) continue;
          i3.forEach((function(t4) {
            if (j2(t4, e5)) throw new TypeError('Conflicting signatures "' + _2(t4) + '" and "' + _2(e5) + '".');
          })), i3.push(e5);
          const t3 = a3.length;
          a3.push(n3[u2]);
          const r2 = e5.map(A2);
          let c4;
          for (c4 of L2(r2)) {
            const e6 = _2(c4);
            s2.push({ params: c4, name: e6, fn: t3 }), c4.every(((e7) => !e7.hasConversion)) && (o2[e6] = t3);
          }
        }
        s2.sort(R2);
        const c3 = G2(a3, o2, ue3);
        let l2;
        for (l2 in o2) Object.prototype.hasOwnProperty.call(o2, l2) && (o2[l2] = c3[o2[l2]]);
        const p2 = [], m2 = /* @__PURE__ */ new Map();
        for (l2 of s2) m2.has(l2.name) || (l2.fn = c3[l2.fn], p2.push(l2), m2.set(l2.name, l2));
        const d2 = p2[0] && p2[0].params.length <= 2 && !E(p2[0].params), h2 = p2[1] && p2[1].params.length <= 2 && !E(p2[1].params), g2 = p2[2] && p2[2].params.length <= 2 && !E(p2[2].params), y2 = p2[3] && p2[3].params.length <= 2 && !E(p2[3].params), v3 = p2[4] && p2[4].params.length <= 2 && !E(p2[4].params), x3 = p2[5] && p2[5].params.length <= 2 && !E(p2[5].params), b3 = d2 && h2 && g2 && y2 && v3 && x3;
        for (let e5 = 0; e5 < p2.length; ++e5) p2[e5].test = S2(p2[e5].params);
        const w3 = d2 ? $2(p2[0].params[0]) : t2, N2 = h2 ? $2(p2[1].params[0]) : t2, C3 = g2 ? $2(p2[2].params[0]) : t2, M3 = y2 ? $2(p2[3].params[0]) : t2, T3 = v3 ? $2(p2[4].params[0]) : t2, F2 = x3 ? $2(p2[5].params[0]) : t2, O3 = d2 ? $2(p2[0].params[1]) : t2, k3 = h2 ? $2(p2[1].params[1]) : t2, B3 = g2 ? $2(p2[2].params[1]) : t2, I3 = y2 ? $2(p2[3].params[1]) : t2, q3 = v3 ? $2(p2[4].params[1]) : t2, P3 = x3 ? $2(p2[5].params[1]) : t2;
        for (let e5 = 0; e5 < p2.length; ++e5) p2[e5].implementation = z2(p2[e5].params, p2[e5].fn);
        const U3 = d2 ? p2[0].implementation : r, Z3 = h2 ? p2[1].implementation : r, H3 = g2 ? p2[2].implementation : r, X3 = y2 ? p2[3].implementation : r, W3 = v3 ? p2[4].implementation : r, Q3 = x3 ? p2[5].implementation : r, Y3 = d2 ? p2[0].params.length : -1, J2 = h2 ? p2[1].params.length : -1, K3 = g2 ? p2[2].params.length : -1, ee3 = y2 ? p2[3].params.length : -1, te3 = v3 ? p2[4].params.length : -1, re3 = x3 ? p2[5].params.length : -1, ne2 = b3 ? 6 : 0, ie3 = p2.length, ae3 = p2.map(((e5) => e5.test)), oe3 = p2.map(((e5) => e5.implementation)), se3 = function() {
          for (let e5 = ne2; e5 < ie3; e5++) if (ae3[e5](arguments)) return oe3[e5].apply(this, arguments);
          return f2.onMismatch(e4, arguments, p2);
        };
        function ue3(e5, t3) {
          return arguments.length === Y3 && w3(e5) && O3(t3) ? U3.apply(this, arguments) : arguments.length === J2 && N2(e5) && k3(t3) ? Z3.apply(this, arguments) : arguments.length === K3 && C3(e5) && B3(t3) ? H3.apply(this, arguments) : arguments.length === ee3 && M3(e5) && I3(t3) ? X3.apply(this, arguments) : arguments.length === te3 && T3(e5) && q3(t3) ? W3.apply(this, arguments) : arguments.length === re3 && F2(e5) && P3(t3) ? Q3.apply(this, arguments) : se3.apply(this, arguments);
        }
        try {
          Object.defineProperty(ue3, "name", { value: e4 });
        } catch (e5) {
        }
        return ue3.signatures = o2, ue3._typedFunctionData = { signatures: p2, signatureMap: m2 }, ue3;
      }
      function X2(e4, t3, r2) {
        throw O2(e4, t3, r2);
      }
      function W2(e4) {
        return Y2(e4, 0, e4.length - 1);
      }
      function Q2(e4) {
        return e4[e4.length - 1];
      }
      function Y2(e4, t3, r2) {
        return Array.prototype.slice.call(e4, t3, r2);
      }
      function J(e4, t3) {
        for (let r2 = 0; r2 < e4.length; r2++) if (t3(e4[r2])) return e4[r2];
      }
      function K2(e4, t3) {
        return Array.prototype.concat.apply([], e4.map(t3));
      }
      function ee2() {
        const e4 = W2(arguments).map(((e5) => _2(D(e5)))), t3 = Q2(arguments);
        if ("function" != typeof t3) throw new TypeError("Callback function expected as last argument");
        return te2(e4, t3);
      }
      function te2(e4, t3) {
        return { referTo: { references: e4, callback: t3 } };
      }
      function re2(e4) {
        if ("function" != typeof e4) throw new TypeError("Callback function expected as first argument");
        return { referToSelf: { callback: e4 } };
      }
      function ne(e4) {
        return e4 && "object" == typeof e4.referTo && Array.isArray(e4.referTo.references) && "function" == typeof e4.referTo.callback;
      }
      function ie2(e4) {
        return e4 && "object" == typeof e4.referToSelf && "function" == typeof e4.referToSelf.callback;
      }
      function ae2(e4, t3) {
        if (!e4) return t3;
        if (t3 && t3 !== e4) {
          const r2 = new Error("Function names do not match (expected: " + e4 + ", actual: " + t3 + ")");
          throw r2.data = { actual: t3, expected: e4 }, r2;
        }
        return e4;
      }
      function oe2(e4) {
        let t3;
        for (const r2 in e4) Object.prototype.hasOwnProperty.call(e4, r2) && (y(e4[r2]) || "string" == typeof e4[r2].signature) && (t3 = ae2(t3, e4[r2].name));
        return t3;
      }
      function se2(e4, t3) {
        let r2;
        for (r2 in t3) if (Object.prototype.hasOwnProperty.call(t3, r2)) {
          if (r2 in e4 && t3[r2] !== e4[r2]) {
            const n3 = new Error('Signature "' + r2 + '" is defined twice');
            throw n3.data = { signature: r2, sourceFunction: t3[r2], destFunction: e4[r2] }, n3;
          }
          e4[r2] = t3[r2];
        }
      }
      d(), m(o);
      const ue2 = f2;
      function ce2(e4) {
        if (!e4 || "string" != typeof e4.from || "string" != typeof e4.to || "function" != typeof e4.convert) throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
        if (e4.to === e4.from) throw new SyntaxError('Illegal to define conversion from "' + e4.from + '" to itself.');
      }
      return f2 = function(e4) {
        const t3 = "string" == typeof e4;
        let r2 = t3 ? e4 : "";
        const n3 = {};
        for (let e5 = t3 ? 1 : 0; e5 < arguments.length; ++e5) {
          const i3 = arguments[e5];
          let o2, s2 = {};
          if ("function" == typeof i3 ? (o2 = i3.name, "string" == typeof i3.signature ? s2[i3.signature] = i3 : y(i3) && (s2 = i3.signatures)) : a2(i3) && (s2 = i3, t3 || (o2 = oe2(i3))), 0 === Object.keys(s2).length) {
            const t4 = new TypeError("Argument to 'typed' at index " + e5 + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
            throw t4.data = { index: e5, argument: i3 }, t4;
          }
          t3 || (r2 = ae2(r2, o2)), se2(n3, s2);
        }
        return H2(r2 || "", n3);
      }, f2.create = i2, f2.createCount = ue2.createCount, f2.onMismatch = X2, f2.throwMismatchError = X2, f2.createError = O2, f2.clear = d, f2.clearConversions = h, f2.addTypes = m, f2._findType = p, f2.referTo = ee2, f2.referToSelf = re2, f2.convert = b2, f2.findSignature = v2, f2.find = x2, f2.isTypedFunction = y, f2.warnAgainstDeprecatedThis = true, f2.addType = function(e4, t3) {
        let r2 = "any";
        false !== t3 && u.has("Object") && (r2 = "Object"), f2.addTypes([e4], r2);
      }, f2.addConversion = function(e4) {
        let t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { override: false };
        ce2(e4);
        const r2 = p(e4.to), n3 = r2.conversionsTo.find(((t4) => t4.from === e4.from));
        if (n3) {
          if (!t3 || !t3.override) throw new Error('There is already a conversion from "' + e4.from + '" to "' + r2.name + '"');
          f2.removeConversion({ from: n3.from, to: e4.to, convert: n3.convert });
        }
        r2.conversionsTo.push({ from: e4.from, convert: e4.convert, index: l++ });
      }, f2.addConversions = function(e4, t3) {
        e4.forEach(((e5) => f2.addConversion(e5, t3)));
      }, f2.removeConversion = function(e4) {
        ce2(e4);
        const t3 = p(e4.to), r2 = J(t3.conversionsTo, ((t4) => t4.from === e4.from));
        if (!r2) throw new Error("Attempt to remove nonexistent conversion from " + e4.from + " to " + e4.to);
        if (r2.convert !== e4.convert) throw new Error("Conversion to remove does not match existing conversion");
        const n3 = t3.conversionsTo.indexOf(r2);
        t3.conversionsTo.splice(n3, 1);
      }, f2.resolve = function(e4, t3) {
        if (!y(e4)) throw new TypeError(n);
        const r2 = e4._typedFunctionData.signatures;
        for (let e5 = 0; e5 < r2.length; ++e5) if (r2[e5].test(t3)) return r2[e5];
        return null;
      }, f2;
    }
    var a = i2();
    return a;
  })()), typedFunction$2$1.exports;
  var e2;
}
var typedFunctionExports$1 = requireTypedFunction$1(), typedFunction$1 = getDefaultExportFromCjs$5(typedFunctionExports$1);
function factory$1(e2, t2, r, n) {
  function i2(n3) {
    var i3 = pickShallow$1(n3, t2.map(stripOptionalNotation$1));
    return assertDependencies$1(e2, t2, n3), r(i3);
  }
  return i2.isFactory = true, i2.fn = e2, i2.dependencies = t2.slice().sort(), n && (i2.meta = n), i2;
}
function isFactory$1(e2) {
  return "function" == typeof e2 && "string" == typeof e2.fn && Array.isArray(e2.dependencies);
}
function assertDependencies$1(e2, t2, r) {
  if (!t2.filter(((e3) => !isOptionalDependency$1(e3))).every(((e3) => void 0 !== r[e3]))) {
    var n = t2.filter(((e3) => void 0 === r[e3]));
    throw new Error('Cannot create function "'.concat(e2, '", ') + "some dependencies are missing: ".concat(n.map(((e3) => '"'.concat(e3, '"'))).join(", "), "."));
  }
}
function isOptionalDependency$1(e2) {
  return e2 && "?" === e2[0];
}
function stripOptionalNotation$1(e2) {
  return e2 && "?" === e2[0] ? e2.slice(1) : e2;
}
function isInteger$1(e2) {
  return "boolean" == typeof e2 || !!Number.isFinite(e2) && e2 === Math.round(e2);
}
function safeNumberType$1(e2, t2) {
  if ("bigint" === t2.number) try {
    BigInt(e2);
  } catch (e3) {
    return t2.numberFallback;
  }
  return t2.number;
}
var sign$2$1 = Math.sign || function(e2) {
  return e2 > 0 ? 1 : e2 < 0 ? -1 : 0;
}, log2$1$1 = Math.log2 || function(e2) {
  return Math.log(e2) / Math.LN2;
}, log10$2$1 = Math.log10 || function(e2) {
  return Math.log(e2) / Math.LN10;
}, log1p$1 = Math.log1p || function(e2) {
  return Math.log(e2 + 1);
}, cbrt$1$1 = Math.cbrt || function(e2) {
  if (0 === e2) return e2;
  var t2, r = e2 < 0;
  return r && (e2 = -e2), t2 = Number.isFinite(e2) ? (e2 / ((t2 = Math.exp(Math.log(e2) / 3)) * t2) + 2 * t2) / 3 : e2, r ? -t2 : t2;
}, expm1$1 = Math.expm1 || function(e2) {
  return e2 >= 2e-4 || e2 <= -2e-4 ? Math.exp(e2) - 1 : e2 + e2 * e2 / 2 + e2 * e2 * e2 / 6;
};
function formatNumberToBase$1(e2, t2, r) {
  var n = { 2: "0b", 8: "0o", 16: "0x" }[t2], i2 = "";
  if (r) {
    if (r < 1) throw new Error("size must be in greater than 0");
    if (!isInteger$1(r)) throw new Error("size must be an integer");
    if (e2 > 2 ** (r - 1) - 1 || e2 < -(2 ** (r - 1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
    if (!isInteger$1(e2)) throw new Error("Value must be an integer");
    e2 < 0 && (e2 += 2 ** r), i2 = "i".concat(r);
  }
  var a = "";
  return e2 < 0 && (e2 = -e2, a = "-"), "".concat(a).concat(n).concat(e2.toString(t2)).concat(i2);
}
function format$2$1(e2, t2) {
  if ("function" == typeof t2) return t2(e2);
  if (e2 === 1 / 0) return "Infinity";
  if (e2 === -1 / 0) return "-Infinity";
  if (isNaN(e2)) return "NaN";
  var { notation: r, precision: n, wordSize: i2 } = normalizeFormatOptions$1(t2);
  switch (r) {
    case "fixed":
      return toFixed$2$1(e2, n);
    case "exponential":
      return toExponential$1$1(e2, n);
    case "engineering":
      return toEngineering$1$1(e2, n);
    case "bin":
      return formatNumberToBase$1(e2, 2, i2);
    case "oct":
      return formatNumberToBase$1(e2, 8, i2);
    case "hex":
      return formatNumberToBase$1(e2, 16, i2);
    case "auto":
      return toPrecision$1(e2, n, t2).replace(/((\.\d*?)(0+))($|e)/, (function() {
        var e3 = arguments[2], t3 = arguments[4];
        return "." !== e3 ? e3 + t3 : t3;
      }));
    default:
      throw new Error('Unknown notation "' + r + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function normalizeFormatOptions$1(e2) {
  var t2, r, n = "auto";
  if (void 0 !== e2) if (isNumber$1$1(e2)) t2 = e2;
  else if (isBigNumber$1(e2)) t2 = e2.toNumber();
  else {
    if (!isObject$1$1(e2)) throw new Error("Unsupported type of options, number, BigNumber, or object expected");
    void 0 !== e2.precision && (t2 = _toNumberOrThrow$1(e2.precision, (() => {
      throw new Error('Option "precision" must be a number or BigNumber');
    }))), void 0 !== e2.wordSize && (r = _toNumberOrThrow$1(e2.wordSize, (() => {
      throw new Error('Option "wordSize" must be a number or BigNumber');
    }))), e2.notation && (n = e2.notation);
  }
  return { notation: n, precision: t2, wordSize: r };
}
function splitNumber$1(e2) {
  var t2 = String(e2).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!t2) throw new SyntaxError("Invalid number " + e2);
  var r = t2[1], n = t2[2], i2 = parseFloat(t2[4] || "0"), a = n.indexOf(".");
  i2 += -1 !== a ? a - 1 : n.length - 1;
  var o = n.replace(".", "").replace(/^0*/, (function(e3) {
    return i2 -= e3.length, "";
  })).replace(/0*$/, "").split("").map((function(e3) {
    return parseInt(e3);
  }));
  return 0 === o.length && (o.push(0), i2++), { sign: r, coefficients: o, exponent: i2 };
}
function toEngineering$1$1(e2, t2) {
  if (isNaN(e2) || !Number.isFinite(e2)) return String(e2);
  var r = roundDigits$1(splitNumber$1(e2), t2), n = r.exponent, i2 = r.coefficients, a = n % 3 == 0 ? n : n < 0 ? n - 3 - n % 3 : n - n % 3;
  if (isNumber$1$1(t2)) for (; t2 > i2.length || n - a + 1 > i2.length; ) i2.push(0);
  else for (var o = Math.abs(n - a) - (i2.length - 1), s = 0; s < o; s++) i2.push(0);
  for (var u = Math.abs(n - a), c2 = 1; u > 0; ) c2++, u--;
  var l = i2.slice(c2).join(""), f2 = isNumber$1$1(t2) && l.length || l.match(/[1-9]/) ? "." + l : "", p = i2.slice(0, c2).join("") + f2 + "e" + (n >= 0 ? "+" : "") + a.toString();
  return r.sign + p;
}
function toFixed$2$1(e2, t2) {
  if (isNaN(e2) || !Number.isFinite(e2)) return String(e2);
  var r = splitNumber$1(e2), n = "number" == typeof t2 ? roundDigits$1(r, r.exponent + 1 + t2) : r, i2 = n.coefficients, a = n.exponent + 1, o = a + (t2 || 0);
  return i2.length < o && (i2 = i2.concat(zeros$1(o - i2.length))), a < 0 && (i2 = zeros$1(1 - a).concat(i2), a = 1), a < i2.length && i2.splice(a, 0, 0 === a ? "0." : "."), n.sign + i2.join("");
}
function toExponential$1$1(e2, t2) {
  if (isNaN(e2) || !Number.isFinite(Number(e2))) return String(e2);
  var r = splitNumber$1(e2), n = t2 ? roundDigits$1(r, t2) : r, i2 = n.coefficients, a = n.exponent;
  i2.length < t2 && (i2 = i2.concat(zeros$1(t2 - i2.length)));
  var o = i2.shift();
  return n.sign + o + (i2.length > 0 ? "." + i2.join("") : "") + "e" + (a >= 0 ? "+" : "") + a;
}
function toPrecision$1(e2, t2, r) {
  if (isNaN(e2) || !Number.isFinite(e2)) return String(e2);
  var n = _toNumberOrDefault$1$1(null == r ? void 0 : r.lowerExp, -3), i2 = _toNumberOrDefault$1$1(null == r ? void 0 : r.upperExp, 5), a = splitNumber$1(e2), o = t2 ? roundDigits$1(a, t2) : a;
  if (o.exponent < n || o.exponent >= i2) return toExponential$1$1(e2, t2);
  var s = o.coefficients, u = o.exponent;
  s.length < t2 && (s = s.concat(zeros$1(t2 - s.length))), s = s.concat(zeros$1(u - s.length + 1 + (s.length < t2 ? t2 - s.length : 0)));
  var c2 = u > 0 ? u : 0;
  return c2 < (s = zeros$1(-u).concat(s)).length - 1 && s.splice(c2 + 1, 0, "."), o.sign + s.join("");
}
function roundDigits$1(e2, t2) {
  for (var r = { sign: e2.sign, coefficients: e2.coefficients, exponent: e2.exponent }, n = r.coefficients; t2 <= 0; ) n.unshift(0), r.exponent++, t2++;
  if (n.length > t2 && n.splice(t2, n.length - t2)[0] >= 5) {
    var i2 = t2 - 1;
    for (n[i2]++; 10 === n[i2]; ) n.pop(), 0 === i2 && (n.unshift(0), r.exponent++, i2++), n[--i2]++;
  }
  return r;
}
function zeros$1(e2) {
  for (var t2 = [], r = 0; r < e2; r++) t2.push(0);
  return t2;
}
function digits$1(e2) {
  return e2.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
function nearlyEqual$1$1(e2, t2) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e-8, n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
  if (r <= 0) throw new Error("Relative tolerance must be greater than 0");
  if (n < 0) throw new Error("Absolute tolerance must be at least 0");
  return !isNaN(e2) && !isNaN(t2) && (Number.isFinite(e2) && Number.isFinite(t2) ? e2 === t2 || Math.abs(e2 - t2) <= Math.max(r * Math.max(Math.abs(e2), Math.abs(t2)), n) : e2 === t2);
}
var acosh$2$1 = Math.acosh || function(e2) {
  return Math.log(Math.sqrt(e2 * e2 - 1) + e2);
}, asinh$2$1 = Math.asinh || function(e2) {
  return Math.log(Math.sqrt(e2 * e2 + 1) + e2);
}, atanh$2$1 = Math.atanh || function(e2) {
  return Math.log((1 + e2) / (1 - e2)) / 2;
}, cosh$3$1 = Math.cosh || function(e2) {
  return (Math.exp(e2) + Math.exp(-e2)) / 2;
}, sinh$3$1 = Math.sinh || function(e2) {
  return (Math.exp(e2) - Math.exp(-e2)) / 2;
}, tanh$2$1 = Math.tanh || function(e2) {
  var t2 = Math.exp(2 * e2);
  return (t2 - 1) / (t2 + 1);
};
function copysign$1(e2, t2) {
  return e2 > 0 ^ (t2 > 0 || !(t2 < 0) && 1 / t2 == 1 / 0) ? -e2 : e2;
}
function _toNumberOrThrow$1(e2, t2) {
  return isNumber$1$1(e2) ? e2 : isBigNumber$1(e2) ? e2.toNumber() : void t2();
}
function _toNumberOrDefault$1$1(e2, t2) {
  return isNumber$1$1(e2) ? e2 : isBigNumber$1(e2) ? e2.toNumber() : t2;
}
var _createTyped2$1 = function() {
  return _createTyped2$1 = typedFunction$1.create, typedFunction$1;
}, dependencies$50$1 = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], createTyped$1 = factory$1("typed", dependencies$50$1, (function(e2) {
  var { BigNumber: t2, Complex: r, DenseMatrix: n, Fraction: i2 } = e2, a = _createTyped2$1();
  return a.clear(), a.addTypes([{ name: "number", test: isNumber$1$1 }, { name: "Complex", test: isComplex$1 }, { name: "BigNumber", test: isBigNumber$1 }, { name: "bigint", test: isBigInt$1 }, { name: "Fraction", test: isFraction$1 }, { name: "Unit", test: isUnit$1 }, { name: "identifier", test: (e3) => isString$1$1 && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(e3) }, { name: "string", test: isString$1$1 }, { name: "Chain", test: isChain$1 }, { name: "Array", test: isArray$1$1 }, { name: "Matrix", test: isMatrix$1 }, { name: "DenseMatrix", test: isDenseMatrix$1 }, { name: "SparseMatrix", test: isSparseMatrix$1 }, { name: "Range", test: isRange$1 }, { name: "Index", test: isIndex$1 }, { name: "boolean", test: isBoolean$1$1 }, { name: "ResultSet", test: isResultSet$1 }, { name: "Help", test: isHelp$1 }, { name: "function", test: isFunction$2$1 }, { name: "Date", test: isDate$1$1 }, { name: "RegExp", test: isRegExp$1$1 }, { name: "null", test: isNull$1$1 }, { name: "undefined", test: isUndefined$1$1 }, { name: "AccessorNode", test: isAccessorNode$1 }, { name: "ArrayNode", test: isArrayNode$1 }, { name: "AssignmentNode", test: isAssignmentNode$1 }, { name: "BlockNode", test: isBlockNode$1 }, { name: "ConditionalNode", test: isConditionalNode$1 }, { name: "ConstantNode", test: isConstantNode$1 }, { name: "FunctionNode", test: isFunctionNode$1 }, { name: "FunctionAssignmentNode", test: isFunctionAssignmentNode$1 }, { name: "IndexNode", test: isIndexNode$1 }, { name: "Node", test: isNode$2 }, { name: "ObjectNode", test: isObjectNode$1 }, { name: "OperatorNode", test: isOperatorNode$1 }, { name: "ParenthesisNode", test: isParenthesisNode$1 }, { name: "RangeNode", test: isRangeNode$1 }, { name: "RelationalNode", test: isRelationalNode$1 }, { name: "SymbolNode", test: isSymbolNode$1 }, { name: "Map", test: isMap$1$1 }, { name: "Object", test: isObject$1$1 }]), a.addConversions([{ from: "number", to: "BigNumber", convert: function(e3) {
    if (t2 || throwNoBignumber$1(e3), digits$1(e3) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + e3 + "). Use function bignumber(x) to convert to BigNumber.");
    return new t2(e3);
  } }, { from: "number", to: "Complex", convert: function(e3) {
    return r || throwNoComplex$1(e3), new r(e3, 0);
  } }, { from: "BigNumber", to: "Complex", convert: function(e3) {
    return r || throwNoComplex$1(e3), new r(e3.toNumber(), 0);
  } }, { from: "bigint", to: "number", convert: function(e3) {
    if (e3 > Number.MAX_SAFE_INTEGER) throw new TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + e3 + ")");
    return Number(e3);
  } }, { from: "bigint", to: "BigNumber", convert: function(e3) {
    return t2 || throwNoBignumber$1(e3), new t2(e3.toString());
  } }, { from: "bigint", to: "Fraction", convert: function(e3) {
    return i2 || throwNoFraction$1(e3), new i2(e3);
  } }, { from: "Fraction", to: "BigNumber", convert: function(e3) {
    throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
  } }, { from: "Fraction", to: "Complex", convert: function(e3) {
    return r || throwNoComplex$1(e3), new r(e3.valueOf(), 0);
  } }, { from: "number", to: "Fraction", convert: function(e3) {
    i2 || throwNoFraction$1(e3);
    var t3 = new i2(e3);
    if (t3.valueOf() !== e3) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + e3 + "). Use function fraction(x) to convert to Fraction.");
    return t3;
  } }, { from: "string", to: "number", convert: function(e3) {
    var t3 = Number(e3);
    if (isNaN(t3)) throw new Error('Cannot convert "' + e3 + '" to a number');
    return t3;
  } }, { from: "string", to: "BigNumber", convert: function(e3) {
    t2 || throwNoBignumber$1(e3);
    try {
      return new t2(e3);
    } catch (t3) {
      throw new Error('Cannot convert "' + e3 + '" to BigNumber');
    }
  } }, { from: "string", to: "bigint", convert: function(e3) {
    try {
      return BigInt(e3);
    } catch (t3) {
      throw new Error('Cannot convert "' + e3 + '" to BigInt');
    }
  } }, { from: "string", to: "Fraction", convert: function(e3) {
    i2 || throwNoFraction$1(e3);
    try {
      return new i2(e3);
    } catch (t3) {
      throw new Error('Cannot convert "' + e3 + '" to Fraction');
    }
  } }, { from: "string", to: "Complex", convert: function(e3) {
    r || throwNoComplex$1(e3);
    try {
      return new r(e3);
    } catch (t3) {
      throw new Error('Cannot convert "' + e3 + '" to Complex');
    }
  } }, { from: "boolean", to: "number", convert: function(e3) {
    return +e3;
  } }, { from: "boolean", to: "BigNumber", convert: function(e3) {
    return t2 || throwNoBignumber$1(e3), new t2(+e3);
  } }, { from: "boolean", to: "bigint", convert: function(e3) {
    return BigInt(+e3);
  } }, { from: "boolean", to: "Fraction", convert: function(e3) {
    return i2 || throwNoFraction$1(e3), new i2(+e3);
  } }, { from: "boolean", to: "string", convert: function(e3) {
    return String(e3);
  } }, { from: "Array", to: "Matrix", convert: function(e3) {
    return n || throwNoMatrix$1(), new n(e3);
  } }, { from: "Matrix", to: "Array", convert: function(e3) {
    return e3.valueOf();
  } }]), a.onMismatch = (e3, t3, r2) => {
    var n3 = a.createError(e3, t3, r2);
    if (["wrongType", "mismatch"].includes(n3.data.category) && 1 === t3.length && isCollection$1(t3[0]) && r2.some(((e4) => !e4.params.includes(",")))) {
      var i3 = new TypeError("Function '".concat(e3, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(e3, ")'."));
      throw i3.data = n3.data, i3;
    }
    throw n3;
  }, a.onMismatch = (e3, t3, r2) => {
    var n3 = a.createError(e3, t3, r2);
    if (["wrongType", "mismatch"].includes(n3.data.category) && 1 === t3.length && isCollection$1(t3[0]) && r2.some(((e4) => !e4.params.includes(",")))) {
      var i3 = new TypeError("Function '".concat(e3, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(e3, ")'."));
      throw i3.data = n3.data, i3;
    }
    throw n3;
  }, a;
}));
function throwNoBignumber$1(e2) {
  throw new Error("Cannot convert value ".concat(e2, " into a BigNumber: no class 'BigNumber' provided"));
}
function throwNoComplex$1(e2) {
  throw new Error("Cannot convert value ".concat(e2, " into a Complex number: no class 'Complex' provided"));
}
function throwNoMatrix$1() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function throwNoFraction$1(e2) {
  throw new Error("Cannot convert value ".concat(e2, " into a Fraction, no class 'Fraction' provided."));
}
var name$4$$1 = "ResultSet", dependencies$4$$1 = [], createResultSet$1 = factory$1(name$4$$1, dependencies$4$$1, (() => {
  function e2(t2) {
    if (!(this instanceof e2)) throw new SyntaxError("Constructor must be called with the new operator");
    this.entries = t2 || [];
  }
  return e2.prototype.type = "ResultSet", e2.prototype.isResultSet = true, e2.prototype.valueOf = function() {
    return this.entries;
  }, e2.prototype.toString = function() {
    return "[" + this.entries.map(String).join(", ") + "]";
  }, e2.prototype.toJSON = function() {
    return { mathjs: "ResultSet", entries: this.entries };
  }, e2.fromJSON = function(t2) {
    return new e2(t2.entries);
  }, e2;
}), { isClass: true }), EXP_LIMIT$1 = 9e15, MAX_DIGITS$1 = 1e9, NUMERALS$1 = "0123456789abcdef", LN10$1 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", PI$1 = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", DEFAULTS$1 = { precision: 20, rounding: 4, modulo: 1, toExpNeg: -7, toExpPos: 21, minE: -EXP_LIMIT$1, maxE: EXP_LIMIT$1, crypto: false }, inexact$1, quadrant$1, external$1 = true, decimalError$1 = "[DecimalError] ", invalidArgument$1 = decimalError$1 + "Invalid argument: ", precisionLimitExceeded$1 = decimalError$1 + "Precision limit exceeded", cryptoUnavailable$1 = decimalError$1 + "crypto unavailable", tag$1 = "[object Decimal]", mathfloor$1 = Math.floor, mathpow$1 = Math.pow, isBinary$1 = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex$1 = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal$1 = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal$1 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE$1 = 1e7, LOG_BASE$1 = 7, MAX_SAFE_INTEGER$1 = 9007199254740991, LN10_PRECISION$1 = LN10$1.length - 1, PI_PRECISION$1 = PI$1.length - 1, P$3$1 = { toStringTag: tag$1 };
function digitsToString$1(e2) {
  var t2, r, n, i2 = e2.length - 1, a = "", o = e2[0];
  if (i2 > 0) {
    for (a += o, t2 = 1; t2 < i2; t2++) n = e2[t2] + "", (r = LOG_BASE$1 - n.length) && (a += getZeroString$1(r)), a += n;
    o = e2[t2], (r = LOG_BASE$1 - (n = o + "").length) && (a += getZeroString$1(r));
  } else if (0 === o) return "0";
  for (; o % 10 == 0; ) o /= 10;
  return a + o;
}
function checkInt32$1(e2, t2, r) {
  if (e2 !== ~~e2 || e2 < t2 || e2 > r) throw Error(invalidArgument$1 + e2);
}
function checkRoundingDigits$1(e2, t2, r, n) {
  var i2, a, o, s;
  for (a = e2[0]; a >= 10; a /= 10) --t2;
  return --t2 < 0 ? (t2 += LOG_BASE$1, i2 = 0) : (i2 = Math.ceil((t2 + 1) / LOG_BASE$1), t2 %= LOG_BASE$1), a = mathpow$1(10, LOG_BASE$1 - t2), s = e2[i2] % a | 0, null == n ? t2 < 3 ? (0 == t2 ? s = s / 100 | 0 : 1 == t2 && (s = s / 10 | 0), o = r < 4 && 99999 == s || r > 3 && 49999 == s || 5e4 == s || 0 == s) : o = (r < 4 && s + 1 == a || r > 3 && s + 1 == a / 2) && (e2[i2 + 1] / a / 100 | 0) == mathpow$1(10, t2 - 2) - 1 || (s == a / 2 || 0 == s) && !(e2[i2 + 1] / a / 100 | 0) : t2 < 4 ? (0 == t2 ? s = s / 1e3 | 0 : 1 == t2 ? s = s / 100 | 0 : 2 == t2 && (s = s / 10 | 0), o = (n || r < 4) && 9999 == s || !n && r > 3 && 4999 == s) : o = ((n || r < 4) && s + 1 == a || !n && r > 3 && s + 1 == a / 2) && (e2[i2 + 1] / a / 1e3 | 0) == mathpow$1(10, t2 - 3) - 1, o;
}
function convertBase$1(e2, t2, r) {
  for (var n, i2, a = [0], o = 0, s = e2.length; o < s; ) {
    for (i2 = a.length; i2--; ) a[i2] *= t2;
    for (a[0] += NUMERALS$1.indexOf(e2.charAt(o++)), n = 0; n < a.length; n++) a[n] > r - 1 && (void 0 === a[n + 1] && (a[n + 1] = 0), a[n + 1] += a[n] / r | 0, a[n] %= r);
  }
  return a.reverse();
}
function cosine$1(e2, t2) {
  var r, n, i2;
  if (t2.isZero()) return t2;
  (n = t2.d.length) < 32 ? i2 = (1 / tinyPow$1(4, r = Math.ceil(n / 3))).toString() : (r = 16, i2 = "2.3283064365386962890625e-10"), e2.precision += r, t2 = taylorSeries$1(e2, 1, t2.times(i2), new e2(1));
  for (var a = r; a--; ) {
    var o = t2.times(t2);
    t2 = o.times(o).minus(o).times(8).plus(1);
  }
  return e2.precision -= r, t2;
}
P$3$1.absoluteValue = P$3$1.abs = function() {
  var e2 = new this.constructor(this);
  return e2.s < 0 && (e2.s = 1), finalise$1(e2);
}, P$3$1.ceil = function() {
  return finalise$1(new this.constructor(this), this.e + 1, 2);
}, P$3$1.clampedTo = P$3$1.clamp = function(e2, t2) {
  var r = this, n = r.constructor;
  if (e2 = new n(e2), t2 = new n(t2), !e2.s || !t2.s) return new n(NaN);
  if (e2.gt(t2)) throw Error(invalidArgument$1 + t2);
  return r.cmp(e2) < 0 ? e2 : r.cmp(t2) > 0 ? t2 : new n(r);
}, P$3$1.comparedTo = P$3$1.cmp = function(e2) {
  var t2, r, n, i2, a = this, o = a.d, s = (e2 = new a.constructor(e2)).d, u = a.s, c2 = e2.s;
  if (!o || !s) return u && c2 ? u !== c2 ? u : o === s ? 0 : !o ^ u < 0 ? 1 : -1 : NaN;
  if (!o[0] || !s[0]) return o[0] ? u : s[0] ? -c2 : 0;
  if (u !== c2) return u;
  if (a.e !== e2.e) return a.e > e2.e ^ u < 0 ? 1 : -1;
  for (t2 = 0, r = (n = o.length) < (i2 = s.length) ? n : i2; t2 < r; ++t2) if (o[t2] !== s[t2]) return o[t2] > s[t2] ^ u < 0 ? 1 : -1;
  return n === i2 ? 0 : n > i2 ^ u < 0 ? 1 : -1;
}, P$3$1.cosine = P$3$1.cos = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.d ? r.d[0] ? (e2 = n.precision, t2 = n.rounding, n.precision = e2 + Math.max(r.e, r.sd()) + LOG_BASE$1, n.rounding = 1, r = cosine$1(n, toLessThanHalfPi$1(n, r)), n.precision = e2, n.rounding = t2, finalise$1(2 == quadrant$1 || 3 == quadrant$1 ? r.neg() : r, e2, t2, true)) : new n(1) : new n(NaN);
}, P$3$1.cubeRoot = P$3$1.cbrt = function() {
  var e2, t2, r, n, i2, a, o, s, u, c2, l = this, f2 = l.constructor;
  if (!l.isFinite() || l.isZero()) return new f2(l);
  for (external$1 = false, (a = l.s * mathpow$1(l.s * l, 1 / 3)) && Math.abs(a) != 1 / 0 ? n = new f2(a.toString()) : (r = digitsToString$1(l.d), (a = ((e2 = l.e) - r.length + 1) % 3) && (r += 1 == a || -2 == a ? "0" : "00"), a = mathpow$1(r, 1 / 3), e2 = mathfloor$1((e2 + 1) / 3) - (e2 % 3 == (e2 < 0 ? -1 : 2)), (n = new f2(r = a == 1 / 0 ? "5e" + e2 : (r = a.toExponential()).slice(0, r.indexOf("e") + 1) + e2)).s = l.s), o = (e2 = f2.precision) + 3; ; ) if (c2 = (u = (s = n).times(s).times(s)).plus(l), n = divide$1$1(c2.plus(l).times(s), c2.plus(u), o + 2, 1), digitsToString$1(s.d).slice(0, o) === (r = digitsToString$1(n.d)).slice(0, o)) {
    if ("9999" != (r = r.slice(o - 3, o + 1)) && (i2 || "4999" != r)) {
      +r && (+r.slice(1) || "5" != r.charAt(0)) || (finalise$1(n, e2 + 1, 1), t2 = !n.times(n).times(n).eq(l));
      break;
    }
    if (!i2 && (finalise$1(s, e2 + 1, 0), s.times(s).times(s).eq(l))) {
      n = s;
      break;
    }
    o += 4, i2 = 1;
  }
  return external$1 = true, finalise$1(n, e2, f2.rounding, t2);
}, P$3$1.decimalPlaces = P$3$1.dp = function() {
  var e2, t2 = this.d, r = NaN;
  if (t2) {
    if (r = ((e2 = t2.length - 1) - mathfloor$1(this.e / LOG_BASE$1)) * LOG_BASE$1, e2 = t2[e2]) for (; e2 % 10 == 0; e2 /= 10) r--;
    r < 0 && (r = 0);
  }
  return r;
}, P$3$1.dividedBy = P$3$1.div = function(e2) {
  return divide$1$1(this, new this.constructor(e2));
}, P$3$1.dividedToIntegerBy = P$3$1.divToInt = function(e2) {
  var t2 = this.constructor;
  return finalise$1(divide$1$1(this, new t2(e2), 0, 1, 1), t2.precision, t2.rounding);
}, P$3$1.equals = P$3$1.eq = function(e2) {
  return 0 === this.cmp(e2);
}, P$3$1.floor = function() {
  return finalise$1(new this.constructor(this), this.e + 1, 3);
}, P$3$1.greaterThan = P$3$1.gt = function(e2) {
  return this.cmp(e2) > 0;
}, P$3$1.greaterThanOrEqualTo = P$3$1.gte = function(e2) {
  var t2 = this.cmp(e2);
  return 1 == t2 || 0 === t2;
}, P$3$1.hyperbolicCosine = P$3$1.cosh = function() {
  var e2, t2, r, n, i2, a = this, o = a.constructor, s = new o(1);
  if (!a.isFinite()) return new o(a.s ? 1 / 0 : NaN);
  if (a.isZero()) return s;
  r = o.precision, n = o.rounding, o.precision = r + Math.max(a.e, a.sd()) + 4, o.rounding = 1, (i2 = a.d.length) < 32 ? t2 = (1 / tinyPow$1(4, e2 = Math.ceil(i2 / 3))).toString() : (e2 = 16, t2 = "2.3283064365386962890625e-10"), a = taylorSeries$1(o, 1, a.times(t2), new o(1), true);
  for (var u, c2 = e2, l = new o(8); c2--; ) u = a.times(a), a = s.minus(u.times(l.minus(u.times(l))));
  return finalise$1(a, o.precision = r, o.rounding = n, true);
}, P$3$1.hyperbolicSine = P$3$1.sinh = function() {
  var e2, t2, r, n, i2 = this, a = i2.constructor;
  if (!i2.isFinite() || i2.isZero()) return new a(i2);
  if (t2 = a.precision, r = a.rounding, a.precision = t2 + Math.max(i2.e, i2.sd()) + 4, a.rounding = 1, (n = i2.d.length) < 3) i2 = taylorSeries$1(a, 2, i2, i2, true);
  else {
    e2 = (e2 = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | e2, i2 = taylorSeries$1(a, 2, i2 = i2.times(1 / tinyPow$1(5, e2)), i2, true);
    for (var o, s = new a(5), u = new a(16), c2 = new a(20); e2--; ) o = i2.times(i2), i2 = i2.times(s.plus(o.times(u.times(o).plus(c2))));
  }
  return a.precision = t2, a.rounding = r, finalise$1(i2, t2, r, true);
}, P$3$1.hyperbolicTangent = P$3$1.tanh = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e2 = n.precision, t2 = n.rounding, n.precision = e2 + 7, n.rounding = 1, divide$1$1(r.sinh(), r.cosh(), n.precision = e2, n.rounding = t2)) : new n(r.s);
}, P$3$1.inverseCosine = P$3$1.acos = function() {
  var e2, t2 = this, r = t2.constructor, n = t2.abs().cmp(1), i2 = r.precision, a = r.rounding;
  return -1 !== n ? 0 === n ? t2.isNeg() ? getPi$1(r, i2, a) : new r(0) : new r(NaN) : t2.isZero() ? getPi$1(r, i2 + 4, a).times(0.5) : (r.precision = i2 + 6, r.rounding = 1, t2 = t2.asin(), e2 = getPi$1(r, i2 + 4, a).times(0.5), r.precision = i2, r.rounding = a, e2.minus(t2));
}, P$3$1.inverseHyperbolicCosine = P$3$1.acosh = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.lte(1) ? new n(r.eq(1) ? 0 : NaN) : r.isFinite() ? (e2 = n.precision, t2 = n.rounding, n.precision = e2 + Math.max(Math.abs(r.e), r.sd()) + 4, n.rounding = 1, external$1 = false, r = r.times(r).minus(1).sqrt().plus(r), external$1 = true, n.precision = e2, n.rounding = t2, r.ln()) : new n(r);
}, P$3$1.inverseHyperbolicSine = P$3$1.asinh = function() {
  var e2, t2, r = this, n = r.constructor;
  return !r.isFinite() || r.isZero() ? new n(r) : (e2 = n.precision, t2 = n.rounding, n.precision = e2 + 2 * Math.max(Math.abs(r.e), r.sd()) + 6, n.rounding = 1, external$1 = false, r = r.times(r).plus(1).sqrt().plus(r), external$1 = true, n.precision = e2, n.rounding = t2, r.ln());
}, P$3$1.inverseHyperbolicTangent = P$3$1.atanh = function() {
  var e2, t2, r, n, i2 = this, a = i2.constructor;
  return i2.isFinite() ? i2.e >= 0 ? new a(i2.abs().eq(1) ? i2.s / 0 : i2.isZero() ? i2 : NaN) : (e2 = a.precision, t2 = a.rounding, n = i2.sd(), Math.max(n, e2) < 2 * -i2.e - 1 ? finalise$1(new a(i2), e2, t2, true) : (a.precision = r = n - i2.e, i2 = divide$1$1(i2.plus(1), new a(1).minus(i2), r + e2, 1), a.precision = e2 + 4, a.rounding = 1, i2 = i2.ln(), a.precision = e2, a.rounding = t2, i2.times(0.5))) : new a(NaN);
}, P$3$1.inverseSine = P$3$1.asin = function() {
  var e2, t2, r, n, i2 = this, a = i2.constructor;
  return i2.isZero() ? new a(i2) : (t2 = i2.abs().cmp(1), r = a.precision, n = a.rounding, -1 !== t2 ? 0 === t2 ? ((e2 = getPi$1(a, r + 4, n).times(0.5)).s = i2.s, e2) : new a(NaN) : (a.precision = r + 6, a.rounding = 1, i2 = i2.div(new a(1).minus(i2.times(i2)).sqrt().plus(1)).atan(), a.precision = r, a.rounding = n, i2.times(2)));
}, P$3$1.inverseTangent = P$3$1.atan = function() {
  var e2, t2, r, n, i2, a, o, s, u, c2 = this, l = c2.constructor, f2 = l.precision, p = l.rounding;
  if (c2.isFinite()) {
    if (c2.isZero()) return new l(c2);
    if (c2.abs().eq(1) && f2 + 4 <= PI_PRECISION$1) return (o = getPi$1(l, f2 + 4, p).times(0.25)).s = c2.s, o;
  } else {
    if (!c2.s) return new l(NaN);
    if (f2 + 4 <= PI_PRECISION$1) return (o = getPi$1(l, f2 + 4, p).times(0.5)).s = c2.s, o;
  }
  for (l.precision = s = f2 + 10, l.rounding = 1, e2 = r = Math.min(28, s / LOG_BASE$1 + 2 | 0); e2; --e2) c2 = c2.div(c2.times(c2).plus(1).sqrt().plus(1));
  for (external$1 = false, t2 = Math.ceil(s / LOG_BASE$1), n = 1, u = c2.times(c2), o = new l(c2), i2 = c2; -1 !== e2; ) if (i2 = i2.times(u), a = o.minus(i2.div(n += 2)), i2 = i2.times(u), void 0 !== (o = a.plus(i2.div(n += 2))).d[t2]) for (e2 = t2; o.d[e2] === a.d[e2] && e2--; ) ;
  return r && (o = o.times(2 << r - 1)), external$1 = true, finalise$1(o, l.precision = f2, l.rounding = p, true);
}, P$3$1.isFinite = function() {
  return !!this.d;
}, P$3$1.isInteger = P$3$1.isInt = function() {
  return !!this.d && mathfloor$1(this.e / LOG_BASE$1) > this.d.length - 2;
}, P$3$1.isNaN = function() {
  return !this.s;
}, P$3$1.isNegative = P$3$1.isNeg = function() {
  return this.s < 0;
}, P$3$1.isPositive = P$3$1.isPos = function() {
  return this.s > 0;
}, P$3$1.isZero = function() {
  return !!this.d && 0 === this.d[0];
}, P$3$1.lessThan = P$3$1.lt = function(e2) {
  return this.cmp(e2) < 0;
}, P$3$1.lessThanOrEqualTo = P$3$1.lte = function(e2) {
  return this.cmp(e2) < 1;
}, P$3$1.logarithm = P$3$1.log = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2 = this, l = c2.constructor, f2 = l.precision, p = l.rounding;
  if (null == e2) e2 = new l(10), t2 = true;
  else {
    if (r = (e2 = new l(e2)).d, e2.s < 0 || !r || !r[0] || e2.eq(1)) return new l(NaN);
    t2 = e2.eq(10);
  }
  if (r = c2.d, c2.s < 0 || !r || !r[0] || c2.eq(1)) return new l(r && !r[0] ? -1 / 0 : 1 != c2.s ? NaN : r ? 0 : 1 / 0);
  if (t2) if (r.length > 1) a = true;
  else {
    for (i2 = r[0]; i2 % 10 == 0; ) i2 /= 10;
    a = 1 !== i2;
  }
  if (external$1 = false, o = naturalLogarithm$1(c2, s = f2 + 5), n = t2 ? getLn10$1(l, s + 10) : naturalLogarithm$1(e2, s), checkRoundingDigits$1((u = divide$1$1(o, n, s, 1)).d, i2 = f2, p)) do {
    if (o = naturalLogarithm$1(c2, s += 10), n = t2 ? getLn10$1(l, s + 10) : naturalLogarithm$1(e2, s), u = divide$1$1(o, n, s, 1), !a) {
      +digitsToString$1(u.d).slice(i2 + 1, i2 + 15) + 1 == 1e14 && (u = finalise$1(u, f2 + 1, 0));
      break;
    }
  } while (checkRoundingDigits$1(u.d, i2 += 10, p));
  return external$1 = true, finalise$1(u, f2, p);
}, P$3$1.minus = P$3$1.sub = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2, l, f2, p, m = this, d = m.constructor;
  if (e2 = new d(e2), !m.d || !e2.d) return m.s && e2.s ? m.d ? e2.s = -e2.s : e2 = new d(e2.d || m.s !== e2.s ? m : NaN) : e2 = new d(NaN), e2;
  if (m.s != e2.s) return e2.s = -e2.s, m.plus(e2);
  if (c2 = m.d, p = e2.d, s = d.precision, u = d.rounding, !c2[0] || !p[0]) {
    if (p[0]) e2.s = -e2.s;
    else {
      if (!c2[0]) return new d(3 === u ? -0 : 0);
      e2 = new d(m);
    }
    return external$1 ? finalise$1(e2, s, u) : e2;
  }
  if (r = mathfloor$1(e2.e / LOG_BASE$1), l = mathfloor$1(m.e / LOG_BASE$1), c2 = c2.slice(), a = l - r) {
    for ((f2 = a < 0) ? (t2 = c2, a = -a, o = p.length) : (t2 = p, r = l, o = c2.length), a > (n = Math.max(Math.ceil(s / LOG_BASE$1), o) + 2) && (a = n, t2.length = 1), t2.reverse(), n = a; n--; ) t2.push(0);
    t2.reverse();
  } else {
    for ((f2 = (n = c2.length) < (o = p.length)) && (o = n), n = 0; n < o; n++) if (c2[n] != p[n]) {
      f2 = c2[n] < p[n];
      break;
    }
    a = 0;
  }
  for (f2 && (t2 = c2, c2 = p, p = t2, e2.s = -e2.s), o = c2.length, n = p.length - o; n > 0; --n) c2[o++] = 0;
  for (n = p.length; n > a; ) {
    if (c2[--n] < p[n]) {
      for (i2 = n; i2 && 0 === c2[--i2]; ) c2[i2] = BASE$1 - 1;
      --c2[i2], c2[n] += BASE$1;
    }
    c2[n] -= p[n];
  }
  for (; 0 === c2[--o]; ) c2.pop();
  for (; 0 === c2[0]; c2.shift()) --r;
  return c2[0] ? (e2.d = c2, e2.e = getBase10Exponent$1(c2, r), external$1 ? finalise$1(e2, s, u) : e2) : new d(3 === u ? -0 : 0);
}, P$3$1.modulo = P$3$1.mod = function(e2) {
  var t2, r = this, n = r.constructor;
  return e2 = new n(e2), !r.d || !e2.s || e2.d && !e2.d[0] ? new n(NaN) : !e2.d || r.d && !r.d[0] ? finalise$1(new n(r), n.precision, n.rounding) : (external$1 = false, 9 == n.modulo ? (t2 = divide$1$1(r, e2.abs(), 0, 3, 1)).s *= e2.s : t2 = divide$1$1(r, e2, 0, n.modulo, 1), t2 = t2.times(e2), external$1 = true, r.minus(t2));
}, P$3$1.naturalExponential = P$3$1.exp = function() {
  return naturalExponential$1(this);
}, P$3$1.naturalLogarithm = P$3$1.ln = function() {
  return naturalLogarithm$1(this);
}, P$3$1.negated = P$3$1.neg = function() {
  var e2 = new this.constructor(this);
  return e2.s = -e2.s, finalise$1(e2);
}, P$3$1.plus = P$3$1.add = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2, l, f2 = this, p = f2.constructor;
  if (e2 = new p(e2), !f2.d || !e2.d) return f2.s && e2.s ? f2.d || (e2 = new p(e2.d || f2.s === e2.s ? f2 : NaN)) : e2 = new p(NaN), e2;
  if (f2.s != e2.s) return e2.s = -e2.s, f2.minus(e2);
  if (c2 = f2.d, l = e2.d, s = p.precision, u = p.rounding, !c2[0] || !l[0]) return l[0] || (e2 = new p(f2)), external$1 ? finalise$1(e2, s, u) : e2;
  if (a = mathfloor$1(f2.e / LOG_BASE$1), n = mathfloor$1(e2.e / LOG_BASE$1), c2 = c2.slice(), i2 = a - n) {
    for (i2 < 0 ? (r = c2, i2 = -i2, o = l.length) : (r = l, n = a, o = c2.length), i2 > (o = (a = Math.ceil(s / LOG_BASE$1)) > o ? a + 1 : o + 1) && (i2 = o, r.length = 1), r.reverse(); i2--; ) r.push(0);
    r.reverse();
  }
  for ((o = c2.length) - (i2 = l.length) < 0 && (i2 = o, r = l, l = c2, c2 = r), t2 = 0; i2; ) t2 = (c2[--i2] = c2[i2] + l[i2] + t2) / BASE$1 | 0, c2[i2] %= BASE$1;
  for (t2 && (c2.unshift(t2), ++n), o = c2.length; 0 == c2[--o]; ) c2.pop();
  return e2.d = c2, e2.e = getBase10Exponent$1(c2, n), external$1 ? finalise$1(e2, s, u) : e2;
}, P$3$1.precision = P$3$1.sd = function(e2) {
  var t2, r = this;
  if (void 0 !== e2 && e2 !== !!e2 && 1 !== e2 && 0 !== e2) throw Error(invalidArgument$1 + e2);
  return r.d ? (t2 = getPrecision$1(r.d), e2 && r.e + 1 > t2 && (t2 = r.e + 1)) : t2 = NaN, t2;
}, P$3$1.round = function() {
  var e2 = this, t2 = e2.constructor;
  return finalise$1(new t2(e2), e2.e + 1, t2.rounding);
}, P$3$1.sine = P$3$1.sin = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e2 = n.precision, t2 = n.rounding, n.precision = e2 + Math.max(r.e, r.sd()) + LOG_BASE$1, n.rounding = 1, r = sine$1(n, toLessThanHalfPi$1(n, r)), n.precision = e2, n.rounding = t2, finalise$1(quadrant$1 > 2 ? r.neg() : r, e2, t2, true)) : new n(NaN);
}, P$3$1.squareRoot = P$3$1.sqrt = function() {
  var e2, t2, r, n, i2, a, o = this, s = o.d, u = o.e, c2 = o.s, l = o.constructor;
  if (1 !== c2 || !s || !s[0]) return new l(!c2 || c2 < 0 && (!s || s[0]) ? NaN : s ? o : 1 / 0);
  for (external$1 = false, 0 == (c2 = Math.sqrt(+o)) || c2 == 1 / 0 ? (((t2 = digitsToString$1(s)).length + u) % 2 == 0 && (t2 += "0"), c2 = Math.sqrt(t2), u = mathfloor$1((u + 1) / 2) - (u < 0 || u % 2), n = new l(t2 = c2 == 1 / 0 ? "5e" + u : (t2 = c2.toExponential()).slice(0, t2.indexOf("e") + 1) + u)) : n = new l(c2.toString()), r = (u = l.precision) + 3; ; ) if (n = (a = n).plus(divide$1$1(o, a, r + 2, 1)).times(0.5), digitsToString$1(a.d).slice(0, r) === (t2 = digitsToString$1(n.d)).slice(0, r)) {
    if ("9999" != (t2 = t2.slice(r - 3, r + 1)) && (i2 || "4999" != t2)) {
      +t2 && (+t2.slice(1) || "5" != t2.charAt(0)) || (finalise$1(n, u + 1, 1), e2 = !n.times(n).eq(o));
      break;
    }
    if (!i2 && (finalise$1(a, u + 1, 0), a.times(a).eq(o))) {
      n = a;
      break;
    }
    r += 4, i2 = 1;
  }
  return external$1 = true, finalise$1(n, u, l.rounding, e2);
}, P$3$1.tangent = P$3$1.tan = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e2 = n.precision, t2 = n.rounding, n.precision = e2 + 10, n.rounding = 1, (r = r.sin()).s = 1, r = divide$1$1(r, new n(1).minus(r.times(r)).sqrt(), e2 + 10, 0), n.precision = e2, n.rounding = t2, finalise$1(2 == quadrant$1 || 4 == quadrant$1 ? r.neg() : r, e2, t2, true)) : new n(NaN);
}, P$3$1.times = P$3$1.mul = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2, l = this, f2 = l.constructor, p = l.d, m = (e2 = new f2(e2)).d;
  if (e2.s *= l.s, !(p && p[0] && m && m[0])) return new f2(!e2.s || p && !p[0] && !m || m && !m[0] && !p ? NaN : p && m ? 0 * e2.s : e2.s / 0);
  for (r = mathfloor$1(l.e / LOG_BASE$1) + mathfloor$1(e2.e / LOG_BASE$1), (u = p.length) < (c2 = m.length) && (a = p, p = m, m = a, o = u, u = c2, c2 = o), a = [], n = o = u + c2; n--; ) a.push(0);
  for (n = c2; --n >= 0; ) {
    for (t2 = 0, i2 = u + n; i2 > n; ) s = a[i2] + m[n] * p[i2 - n - 1] + t2, a[i2--] = s % BASE$1 | 0, t2 = s / BASE$1 | 0;
    a[i2] = (a[i2] + t2) % BASE$1 | 0;
  }
  for (; !a[--o]; ) a.pop();
  return t2 ? ++r : a.shift(), e2.d = a, e2.e = getBase10Exponent$1(a, r), external$1 ? finalise$1(e2, f2.precision, f2.rounding) : e2;
}, P$3$1.toBinary = function(e2, t2) {
  return toStringBinary$1(this, 2, e2, t2);
}, P$3$1.toDecimalPlaces = P$3$1.toDP = function(e2, t2) {
  var r = this, n = r.constructor;
  return r = new n(r), void 0 === e2 ? r : (checkInt32$1(e2, 0, MAX_DIGITS$1), void 0 === t2 ? t2 = n.rounding : checkInt32$1(t2, 0, 8), finalise$1(r, e2 + r.e + 1, t2));
}, P$3$1.toExponential = function(e2, t2) {
  var r, n = this, i2 = n.constructor;
  return void 0 === e2 ? r = finiteToString$1(n, true) : (checkInt32$1(e2, 0, MAX_DIGITS$1), void 0 === t2 ? t2 = i2.rounding : checkInt32$1(t2, 0, 8), r = finiteToString$1(n = finalise$1(new i2(n), e2 + 1, t2), true, e2 + 1)), n.isNeg() && !n.isZero() ? "-" + r : r;
}, P$3$1.toFixed = function(e2, t2) {
  var r, n, i2 = this, a = i2.constructor;
  return void 0 === e2 ? r = finiteToString$1(i2) : (checkInt32$1(e2, 0, MAX_DIGITS$1), void 0 === t2 ? t2 = a.rounding : checkInt32$1(t2, 0, 8), r = finiteToString$1(n = finalise$1(new a(i2), e2 + i2.e + 1, t2), false, e2 + n.e + 1)), i2.isNeg() && !i2.isZero() ? "-" + r : r;
}, P$3$1.toFraction = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2, l, f2, p, m = this, d = m.d, h = m.constructor;
  if (!d) return new h(m);
  if (c2 = r = new h(1), n = u = new h(0), o = (a = (t2 = new h(n)).e = getPrecision$1(d) - m.e - 1) % LOG_BASE$1, t2.d[0] = mathpow$1(10, o < 0 ? LOG_BASE$1 + o : o), null == e2) e2 = a > 0 ? t2 : c2;
  else {
    if (!(s = new h(e2)).isInt() || s.lt(c2)) throw Error(invalidArgument$1 + s);
    e2 = s.gt(t2) ? a > 0 ? t2 : c2 : s;
  }
  for (external$1 = false, s = new h(digitsToString$1(d)), l = h.precision, h.precision = a = d.length * LOG_BASE$1 * 2; f2 = divide$1$1(s, t2, 0, 1, 1), 1 != (i2 = r.plus(f2.times(n))).cmp(e2); ) r = n, n = i2, i2 = c2, c2 = u.plus(f2.times(i2)), u = i2, i2 = t2, t2 = s.minus(f2.times(i2)), s = i2;
  return i2 = divide$1$1(e2.minus(r), n, 0, 1, 1), u = u.plus(i2.times(c2)), r = r.plus(i2.times(n)), u.s = c2.s = m.s, p = divide$1$1(c2, n, a, 1).minus(m).abs().cmp(divide$1$1(u, r, a, 1).minus(m).abs()) < 1 ? [c2, n] : [u, r], h.precision = l, external$1 = true, p;
}, P$3$1.toHexadecimal = P$3$1.toHex = function(e2, t2) {
  return toStringBinary$1(this, 16, e2, t2);
}, P$3$1.toNearest = function(e2, t2) {
  var r = this, n = r.constructor;
  if (r = new n(r), null == e2) {
    if (!r.d) return r;
    e2 = new n(1), t2 = n.rounding;
  } else {
    if (e2 = new n(e2), void 0 === t2 ? t2 = n.rounding : checkInt32$1(t2, 0, 8), !r.d) return e2.s ? r : e2;
    if (!e2.d) return e2.s && (e2.s = r.s), e2;
  }
  return e2.d[0] ? (external$1 = false, r = divide$1$1(r, e2, 0, t2, 1).times(e2), external$1 = true, finalise$1(r)) : (e2.s = r.s, r = e2), r;
}, P$3$1.toNumber = function() {
  return +this;
}, P$3$1.toOctal = function(e2, t2) {
  return toStringBinary$1(this, 8, e2, t2);
}, P$3$1.toPower = P$3$1.pow = function(e2) {
  var t2, r, n, i2, a, o, s = this, u = s.constructor, c2 = +(e2 = new u(e2));
  if (!(s.d && e2.d && s.d[0] && e2.d[0])) return new u(mathpow$1(+s, c2));
  if ((s = new u(s)).eq(1)) return s;
  if (n = u.precision, a = u.rounding, e2.eq(1)) return finalise$1(s, n, a);
  if ((t2 = mathfloor$1(e2.e / LOG_BASE$1)) >= e2.d.length - 1 && (r = c2 < 0 ? -c2 : c2) <= MAX_SAFE_INTEGER$1) return i2 = intPow$1(u, s, r, n), e2.s < 0 ? new u(1).div(i2) : finalise$1(i2, n, a);
  if ((o = s.s) < 0) {
    if (t2 < e2.d.length - 1) return new u(NaN);
    if (1 & e2.d[t2] || (o = 1), 0 == s.e && 1 == s.d[0] && 1 == s.d.length) return s.s = o, s;
  }
  return (t2 = 0 != (r = mathpow$1(+s, c2)) && isFinite(r) ? new u(r + "").e : mathfloor$1(c2 * (Math.log("0." + digitsToString$1(s.d)) / Math.LN10 + s.e + 1))) > u.maxE + 1 || t2 < u.minE - 1 ? new u(t2 > 0 ? o / 0 : 0) : (external$1 = false, u.rounding = s.s = 1, r = Math.min(12, (t2 + "").length), (i2 = naturalExponential$1(e2.times(naturalLogarithm$1(s, n + r)), n)).d && checkRoundingDigits$1((i2 = finalise$1(i2, n + 5, 1)).d, n, a) && (t2 = n + 10, +digitsToString$1((i2 = finalise$1(naturalExponential$1(e2.times(naturalLogarithm$1(s, t2 + r)), t2), t2 + 5, 1)).d).slice(n + 1, n + 15) + 1 == 1e14 && (i2 = finalise$1(i2, n + 1, 0))), i2.s = o, external$1 = true, u.rounding = a, finalise$1(i2, n, a));
}, P$3$1.toPrecision = function(e2, t2) {
  var r, n = this, i2 = n.constructor;
  return void 0 === e2 ? r = finiteToString$1(n, n.e <= i2.toExpNeg || n.e >= i2.toExpPos) : (checkInt32$1(e2, 1, MAX_DIGITS$1), void 0 === t2 ? t2 = i2.rounding : checkInt32$1(t2, 0, 8), r = finiteToString$1(n = finalise$1(new i2(n), e2, t2), e2 <= n.e || n.e <= i2.toExpNeg, e2)), n.isNeg() && !n.isZero() ? "-" + r : r;
}, P$3$1.toSignificantDigits = P$3$1.toSD = function(e2, t2) {
  var r = this.constructor;
  return void 0 === e2 ? (e2 = r.precision, t2 = r.rounding) : (checkInt32$1(e2, 1, MAX_DIGITS$1), void 0 === t2 ? t2 = r.rounding : checkInt32$1(t2, 0, 8)), finalise$1(new r(this), e2, t2);
}, P$3$1.toString = function() {
  var e2 = this, t2 = e2.constructor, r = finiteToString$1(e2, e2.e <= t2.toExpNeg || e2.e >= t2.toExpPos);
  return e2.isNeg() && !e2.isZero() ? "-" + r : r;
}, P$3$1.truncated = P$3$1.trunc = function() {
  return finalise$1(new this.constructor(this), this.e + 1, 1);
}, P$3$1.valueOf = P$3$1.toJSON = function() {
  var e2 = this, t2 = e2.constructor, r = finiteToString$1(e2, e2.e <= t2.toExpNeg || e2.e >= t2.toExpPos);
  return e2.isNeg() ? "-" + r : r;
};
var divide$1$1 = /* @__PURE__ */ (function() {
  function e2(e3, t3, r2) {
    var n, i2 = 0, a = e3.length;
    for (e3 = e3.slice(); a--; ) n = e3[a] * t3 + i2, e3[a] = n % r2 | 0, i2 = n / r2 | 0;
    return i2 && e3.unshift(i2), e3;
  }
  function t2(e3, t3, r2, n) {
    var i2, a;
    if (r2 != n) a = r2 > n ? 1 : -1;
    else for (i2 = a = 0; i2 < r2; i2++) if (e3[i2] != t3[i2]) {
      a = e3[i2] > t3[i2] ? 1 : -1;
      break;
    }
    return a;
  }
  function r(e3, t3, r2, n) {
    for (var i2 = 0; r2--; ) e3[r2] -= i2, i2 = e3[r2] < t3[r2] ? 1 : 0, e3[r2] = i2 * n + e3[r2] - t3[r2];
    for (; !e3[0] && e3.length > 1; ) e3.shift();
  }
  return function(n, i2, a, o, s, u) {
    var c2, l, f2, p, m, d, h, g, y, v2, x2, b2, _2, w2, A2, N, D, E, $2, S2, C2 = n.constructor, M2 = n.s == i2.s ? 1 : -1, T2 = n.d, F = i2.d;
    if (!(T2 && T2[0] && F && F[0])) return new C2(n.s && i2.s && (T2 ? !F || T2[0] != F[0] : F) ? T2 && 0 == T2[0] || !F ? 0 * M2 : M2 / 0 : NaN);
    for (u ? (m = 1, l = n.e - i2.e) : (u = BASE$1, m = LOG_BASE$1, l = mathfloor$1(n.e / m) - mathfloor$1(i2.e / m)), $2 = F.length, D = T2.length, v2 = (y = new C2(M2)).d = [], f2 = 0; F[f2] == (T2[f2] || 0); f2++) ;
    if (F[f2] > (T2[f2] || 0) && l--, null == a ? (w2 = a = C2.precision, o = C2.rounding) : w2 = s ? a + (n.e - i2.e) + 1 : a, w2 < 0) v2.push(1), d = true;
    else {
      if (w2 = w2 / m + 2 | 0, f2 = 0, 1 == $2) {
        for (p = 0, F = F[0], w2++; (f2 < D || p) && w2--; f2++) A2 = p * u + (T2[f2] || 0), v2[f2] = A2 / F | 0, p = A2 % F | 0;
        d = p || f2 < D;
      } else {
        for ((p = u / (F[0] + 1) | 0) > 1 && (F = e2(F, p, u), T2 = e2(T2, p, u), $2 = F.length, D = T2.length), N = $2, b2 = (x2 = T2.slice(0, $2)).length; b2 < $2; ) x2[b2++] = 0;
        (S2 = F.slice()).unshift(0), E = F[0], F[1] >= u / 2 && ++E;
        do {
          p = 0, (c2 = t2(F, x2, $2, b2)) < 0 ? (_2 = x2[0], $2 != b2 && (_2 = _2 * u + (x2[1] || 0)), (p = _2 / E | 0) > 1 ? (p >= u && (p = u - 1), 1 == (c2 = t2(h = e2(F, p, u), x2, g = h.length, b2 = x2.length)) && (p--, r(h, $2 < g ? S2 : F, g, u))) : (0 == p && (c2 = p = 1), h = F.slice()), (g = h.length) < b2 && h.unshift(0), r(x2, h, b2, u), -1 == c2 && (c2 = t2(F, x2, $2, b2 = x2.length)) < 1 && (p++, r(x2, $2 < b2 ? S2 : F, b2, u)), b2 = x2.length) : 0 === c2 && (p++, x2 = [0]), v2[f2++] = p, c2 && x2[0] ? x2[b2++] = T2[N] || 0 : (x2 = [T2[N]], b2 = 1);
        } while ((N++ < D || void 0 !== x2[0]) && w2--);
        d = void 0 !== x2[0];
      }
      v2[0] || v2.shift();
    }
    if (1 == m) y.e = l, inexact$1 = d;
    else {
      for (f2 = 1, p = v2[0]; p >= 10; p /= 10) f2++;
      y.e = f2 + l * m - 1, finalise$1(y, s ? a + y.e + 1 : a, o, d);
    }
    return y;
  };
})();
function finalise$1(e2, t2, r, n) {
  var i2, a, o, s, u, c2, l, f2, p, m = e2.constructor;
  e: if (null != t2) {
    if (!(f2 = e2.d)) return e2;
    for (i2 = 1, s = f2[0]; s >= 10; s /= 10) i2++;
    if ((a = t2 - i2) < 0) a += LOG_BASE$1, o = t2, u = (l = f2[p = 0]) / mathpow$1(10, i2 - o - 1) % 10 | 0;
    else if ((p = Math.ceil((a + 1) / LOG_BASE$1)) >= (s = f2.length)) {
      if (!n) break e;
      for (; s++ <= p; ) f2.push(0);
      l = u = 0, i2 = 1, o = (a %= LOG_BASE$1) - LOG_BASE$1 + 1;
    } else {
      for (l = s = f2[p], i2 = 1; s >= 10; s /= 10) i2++;
      u = (o = (a %= LOG_BASE$1) - LOG_BASE$1 + i2) < 0 ? 0 : l / mathpow$1(10, i2 - o - 1) % 10 | 0;
    }
    if (n = n || t2 < 0 || void 0 !== f2[p + 1] || (o < 0 ? l : l % mathpow$1(10, i2 - o - 1)), c2 = r < 4 ? (u || n) && (0 == r || r == (e2.s < 0 ? 3 : 2)) : u > 5 || 5 == u && (4 == r || n || 6 == r && (a > 0 ? o > 0 ? l / mathpow$1(10, i2 - o) : 0 : f2[p - 1]) % 10 & 1 || r == (e2.s < 0 ? 8 : 7)), t2 < 1 || !f2[0]) return f2.length = 0, c2 ? (t2 -= e2.e + 1, f2[0] = mathpow$1(10, (LOG_BASE$1 - t2 % LOG_BASE$1) % LOG_BASE$1), e2.e = -t2 || 0) : f2[0] = e2.e = 0, e2;
    if (0 == a ? (f2.length = p, s = 1, p--) : (f2.length = p + 1, s = mathpow$1(10, LOG_BASE$1 - a), f2[p] = o > 0 ? (l / mathpow$1(10, i2 - o) % mathpow$1(10, o) | 0) * s : 0), c2) for (; ; ) {
      if (0 == p) {
        for (a = 1, o = f2[0]; o >= 10; o /= 10) a++;
        for (o = f2[0] += s, s = 1; o >= 10; o /= 10) s++;
        a != s && (e2.e++, f2[0] == BASE$1 && (f2[0] = 1));
        break;
      }
      if (f2[p] += s, f2[p] != BASE$1) break;
      f2[p--] = 0, s = 1;
    }
    for (a = f2.length; 0 === f2[--a]; ) f2.pop();
  }
  return external$1 && (e2.e > m.maxE ? (e2.d = null, e2.e = NaN) : e2.e < m.minE && (e2.e = 0, e2.d = [0])), e2;
}
function finiteToString$1(e2, t2, r) {
  if (!e2.isFinite()) return nonFiniteToString$1(e2);
  var n, i2 = e2.e, a = digitsToString$1(e2.d), o = a.length;
  return t2 ? (r && (n = r - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + getZeroString$1(n) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (e2.e < 0 ? "e" : "e+") + e2.e) : i2 < 0 ? (a = "0." + getZeroString$1(-i2 - 1) + a, r && (n = r - o) > 0 && (a += getZeroString$1(n))) : i2 >= o ? (a += getZeroString$1(i2 + 1 - o), r && (n = r - i2 - 1) > 0 && (a = a + "." + getZeroString$1(n))) : ((n = i2 + 1) < o && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - o) > 0 && (i2 + 1 === o && (a += "."), a += getZeroString$1(n))), a;
}
function getBase10Exponent$1(e2, t2) {
  var r = e2[0];
  for (t2 *= LOG_BASE$1; r >= 10; r /= 10) t2++;
  return t2;
}
function getLn10$1(e2, t2, r) {
  if (t2 > LN10_PRECISION$1) throw external$1 = true, r && (e2.precision = r), Error(precisionLimitExceeded$1);
  return finalise$1(new e2(LN10$1), t2, 1, true);
}
function getPi$1(e2, t2, r) {
  if (t2 > PI_PRECISION$1) throw Error(precisionLimitExceeded$1);
  return finalise$1(new e2(PI$1), t2, r, true);
}
function getPrecision$1(e2) {
  var t2 = e2.length - 1, r = t2 * LOG_BASE$1 + 1;
  if (t2 = e2[t2]) {
    for (; t2 % 10 == 0; t2 /= 10) r--;
    for (t2 = e2[0]; t2 >= 10; t2 /= 10) r++;
  }
  return r;
}
function getZeroString$1(e2) {
  for (var t2 = ""; e2--; ) t2 += "0";
  return t2;
}
function intPow$1(e2, t2, r, n) {
  var i2, a = new e2(1), o = Math.ceil(n / LOG_BASE$1 + 4);
  for (external$1 = false; ; ) {
    if (r % 2 && truncate$1((a = a.times(t2)).d, o) && (i2 = true), 0 === (r = mathfloor$1(r / 2))) {
      r = a.d.length - 1, i2 && 0 === a.d[r] && ++a.d[r];
      break;
    }
    truncate$1((t2 = t2.times(t2)).d, o);
  }
  return external$1 = true, a;
}
function isOdd$1(e2) {
  return 1 & e2.d[e2.d.length - 1];
}
function maxOrMin$1(e2, t2, r) {
  for (var n, i2 = new e2(t2[0]), a = 0; ++a < t2.length; ) {
    if (!(n = new e2(t2[a])).s) {
      i2 = n;
      break;
    }
    i2[r](n) && (i2 = n);
  }
  return i2;
}
function naturalExponential$1(e2, t2) {
  var r, n, i2, a, o, s, u, c2 = 0, l = 0, f2 = 0, p = e2.constructor, m = p.rounding, d = p.precision;
  if (!e2.d || !e2.d[0] || e2.e > 17) return new p(e2.d ? e2.d[0] ? e2.s < 0 ? 0 : 1 / 0 : 1 : e2.s ? e2.s < 0 ? 0 : e2 : NaN);
  for (null == t2 ? (external$1 = false, u = d) : u = t2, s = new p(0.03125); e2.e > -2; ) e2 = e2.times(s), f2 += 5;
  for (u += n = Math.log(mathpow$1(2, f2)) / Math.LN10 * 2 + 5 | 0, r = a = o = new p(1), p.precision = u; ; ) {
    if (a = finalise$1(a.times(e2), u, 1), r = r.times(++l), digitsToString$1((s = o.plus(divide$1$1(a, r, u, 1))).d).slice(0, u) === digitsToString$1(o.d).slice(0, u)) {
      for (i2 = f2; i2--; ) o = finalise$1(o.times(o), u, 1);
      if (null != t2) return p.precision = d, o;
      if (!(c2 < 3 && checkRoundingDigits$1(o.d, u - n, m, c2))) return finalise$1(o, p.precision = d, m, external$1 = true);
      p.precision = u += 10, r = a = s = new p(1), l = 0, c2++;
    }
    o = s;
  }
}
function naturalLogarithm$1(e2, t2) {
  var r, n, i2, a, o, s, u, c2, l, f2, p, m = 1, d = e2, h = d.d, g = d.constructor, y = g.rounding, v2 = g.precision;
  if (d.s < 0 || !h || !h[0] || !d.e && 1 == h[0] && 1 == h.length) return new g(h && !h[0] ? -1 / 0 : 1 != d.s ? NaN : h ? 0 : d);
  if (null == t2 ? (external$1 = false, l = v2) : l = t2, g.precision = l += 10, n = (r = digitsToString$1(h)).charAt(0), !(Math.abs(a = d.e) < 15e14)) return c2 = getLn10$1(g, l + 2, v2).times(a + ""), d = naturalLogarithm$1(new g(n + "." + r.slice(1)), l - 10).plus(c2), g.precision = v2, null == t2 ? finalise$1(d, v2, y, external$1 = true) : d;
  for (; n < 7 && 1 != n || 1 == n && r.charAt(1) > 3; ) n = (r = digitsToString$1((d = d.times(e2)).d)).charAt(0), m++;
  for (a = d.e, n > 1 ? (d = new g("0." + r), a++) : d = new g(n + "." + r.slice(1)), f2 = d, u = o = d = divide$1$1(d.minus(1), d.plus(1), l, 1), p = finalise$1(d.times(d), l, 1), i2 = 3; ; ) {
    if (o = finalise$1(o.times(p), l, 1), digitsToString$1((c2 = u.plus(divide$1$1(o, new g(i2), l, 1))).d).slice(0, l) === digitsToString$1(u.d).slice(0, l)) {
      if (u = u.times(2), 0 !== a && (u = u.plus(getLn10$1(g, l + 2, v2).times(a + ""))), u = divide$1$1(u, new g(m), l, 1), null != t2) return g.precision = v2, u;
      if (!checkRoundingDigits$1(u.d, l - 10, y, s)) return finalise$1(u, g.precision = v2, y, external$1 = true);
      g.precision = l += 10, c2 = o = d = divide$1$1(f2.minus(1), f2.plus(1), l, 1), p = finalise$1(d.times(d), l, 1), i2 = s = 1;
    }
    u = c2, i2 += 2;
  }
}
function nonFiniteToString$1(e2) {
  return String(e2.s * e2.s / 0);
}
function parseDecimal$1(e2, t2) {
  var r, n, i2;
  for ((r = t2.indexOf(".")) > -1 && (t2 = t2.replace(".", "")), (n = t2.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t2.slice(n + 1), t2 = t2.substring(0, n)) : r < 0 && (r = t2.length), n = 0; 48 === t2.charCodeAt(n); n++) ;
  for (i2 = t2.length; 48 === t2.charCodeAt(i2 - 1); --i2) ;
  if (t2 = t2.slice(n, i2)) {
    if (i2 -= n, e2.e = r = r - n - 1, e2.d = [], n = (r + 1) % LOG_BASE$1, r < 0 && (n += LOG_BASE$1), n < i2) {
      for (n && e2.d.push(+t2.slice(0, n)), i2 -= LOG_BASE$1; n < i2; ) e2.d.push(+t2.slice(n, n += LOG_BASE$1));
      t2 = t2.slice(n), n = LOG_BASE$1 - t2.length;
    } else n -= i2;
    for (; n--; ) t2 += "0";
    e2.d.push(+t2), external$1 && (e2.e > e2.constructor.maxE ? (e2.d = null, e2.e = NaN) : e2.e < e2.constructor.minE && (e2.e = 0, e2.d = [0]));
  } else e2.e = 0, e2.d = [0];
  return e2;
}
function parseOther$1(e2, t2) {
  var r, n, i2, a, o, s, u, c2, l;
  if (t2.indexOf("_") > -1) {
    if (t2 = t2.replace(/(\d)_(?=\d)/g, "$1"), isDecimal$1.test(t2)) return parseDecimal$1(e2, t2);
  } else if ("Infinity" === t2 || "NaN" === t2) return +t2 || (e2.s = NaN), e2.e = NaN, e2.d = null, e2;
  if (isHex$1.test(t2)) r = 16, t2 = t2.toLowerCase();
  else if (isBinary$1.test(t2)) r = 2;
  else {
    if (!isOctal$1.test(t2)) throw Error(invalidArgument$1 + t2);
    r = 8;
  }
  for ((a = t2.search(/p/i)) > 0 ? (u = +t2.slice(a + 1), t2 = t2.substring(2, a)) : t2 = t2.slice(2), o = (a = t2.indexOf(".")) >= 0, n = e2.constructor, o && (a = (s = (t2 = t2.replace(".", "")).length) - a, i2 = intPow$1(n, new n(r), a, 2 * a)), a = l = (c2 = convertBase$1(t2, r, BASE$1)).length - 1; 0 === c2[a]; --a) c2.pop();
  return a < 0 ? new n(0 * e2.s) : (e2.e = getBase10Exponent$1(c2, l), e2.d = c2, external$1 = false, o && (e2 = divide$1$1(e2, i2, 4 * s)), u && (e2 = e2.times(Math.abs(u) < 54 ? mathpow$1(2, u) : Decimal$1.pow(2, u))), external$1 = true, e2);
}
function sine$1(e2, t2) {
  var r, n = t2.d.length;
  if (n < 3) return t2.isZero() ? t2 : taylorSeries$1(e2, 2, t2, t2);
  r = (r = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | r, t2 = taylorSeries$1(e2, 2, t2 = t2.times(1 / tinyPow$1(5, r)), t2);
  for (var i2, a = new e2(5), o = new e2(16), s = new e2(20); r--; ) i2 = t2.times(t2), t2 = t2.times(a.plus(i2.times(o.times(i2).minus(s))));
  return t2;
}
function taylorSeries$1(e2, t2, r, n, i2) {
  var a, o, s, u, c2 = e2.precision, l = Math.ceil(c2 / LOG_BASE$1);
  for (external$1 = false, u = r.times(r), s = new e2(n); ; ) {
    if (o = divide$1$1(s.times(u), new e2(t2++ * t2++), c2, 1), s = i2 ? n.plus(o) : n.minus(o), n = divide$1$1(o.times(u), new e2(t2++ * t2++), c2, 1), void 0 !== (o = s.plus(n)).d[l]) {
      for (a = l; o.d[a] === s.d[a] && a--; ) ;
      if (-1 == a) break;
    }
    a = s, s = n, n = o, o = a;
  }
  return external$1 = true, o.d.length = l + 1, o;
}
function tinyPow$1(e2, t2) {
  for (var r = e2; --t2; ) r *= e2;
  return r;
}
function toLessThanHalfPi$1(e2, t2) {
  var r, n = t2.s < 0, i2 = getPi$1(e2, e2.precision, 1), a = i2.times(0.5);
  if ((t2 = t2.abs()).lte(a)) return quadrant$1 = n ? 4 : 1, t2;
  if ((r = t2.divToInt(i2)).isZero()) quadrant$1 = n ? 3 : 2;
  else {
    if ((t2 = t2.minus(r.times(i2))).lte(a)) return quadrant$1 = isOdd$1(r) ? n ? 2 : 3 : n ? 4 : 1, t2;
    quadrant$1 = isOdd$1(r) ? n ? 1 : 4 : n ? 3 : 2;
  }
  return t2.minus(i2).abs();
}
function toStringBinary$1(e2, t2, r, n) {
  var i2, a, o, s, u, c2, l, f2, p, m = e2.constructor, d = void 0 !== r;
  if (d ? (checkInt32$1(r, 1, MAX_DIGITS$1), void 0 === n ? n = m.rounding : checkInt32$1(n, 0, 8)) : (r = m.precision, n = m.rounding), e2.isFinite()) {
    for (d ? (i2 = 2, 16 == t2 ? r = 4 * r - 3 : 8 == t2 && (r = 3 * r - 2)) : i2 = t2, (o = (l = finiteToString$1(e2)).indexOf(".")) >= 0 && (l = l.replace(".", ""), (p = new m(1)).e = l.length - o, p.d = convertBase$1(finiteToString$1(p), 10, i2), p.e = p.d.length), a = u = (f2 = convertBase$1(l, 10, i2)).length; 0 == f2[--u]; ) f2.pop();
    if (f2[0]) {
      if (o < 0 ? a-- : ((e2 = new m(e2)).d = f2, e2.e = a, f2 = (e2 = divide$1$1(e2, p, r, n, 0, i2)).d, a = e2.e, c2 = inexact$1), o = f2[r], s = i2 / 2, c2 = c2 || void 0 !== f2[r + 1], c2 = n < 4 ? (void 0 !== o || c2) && (0 === n || n === (e2.s < 0 ? 3 : 2)) : o > s || o === s && (4 === n || c2 || 6 === n && 1 & f2[r - 1] || n === (e2.s < 0 ? 8 : 7)), f2.length = r, c2) for (; ++f2[--r] > i2 - 1; ) f2[r] = 0, r || (++a, f2.unshift(1));
      for (u = f2.length; !f2[u - 1]; --u) ;
      for (o = 0, l = ""; o < u; o++) l += NUMERALS$1.charAt(f2[o]);
      if (d) {
        if (u > 1) if (16 == t2 || 8 == t2) {
          for (o = 16 == t2 ? 4 : 3, --u; u % o; u++) l += "0";
          for (u = (f2 = convertBase$1(l, i2, t2)).length; !f2[u - 1]; --u) ;
          for (o = 1, l = "1."; o < u; o++) l += NUMERALS$1.charAt(f2[o]);
        } else l = l.charAt(0) + "." + l.slice(1);
        l = l + (a < 0 ? "p" : "p+") + a;
      } else if (a < 0) {
        for (; ++a; ) l = "0" + l;
        l = "0." + l;
      } else if (++a > u) for (a -= u; a--; ) l += "0";
      else a < u && (l = l.slice(0, a) + "." + l.slice(a));
    } else l = d ? "0p+0" : "0";
    l = (16 == t2 ? "0x" : 2 == t2 ? "0b" : 8 == t2 ? "0o" : "") + l;
  } else l = nonFiniteToString$1(e2);
  return e2.s < 0 ? "-" + l : l;
}
function truncate$1(e2, t2) {
  if (e2.length > t2) return e2.length = t2, true;
}
function abs$1$1(e2) {
  return new this(e2).abs();
}
function acos$1$1(e2) {
  return new this(e2).acos();
}
function acosh$1$1(e2) {
  return new this(e2).acosh();
}
function add$1$1(e2, t2) {
  return new this(e2).plus(t2);
}
function asin$1$1(e2) {
  return new this(e2).asin();
}
function asinh$1$1(e2) {
  return new this(e2).asinh();
}
function atan$1$1(e2) {
  return new this(e2).atan();
}
function atanh$1$1(e2) {
  return new this(e2).atanh();
}
function atan2$1$1(e2, t2) {
  e2 = new this(e2), t2 = new this(t2);
  var r, n = this.precision, i2 = this.rounding, a = n + 4;
  return e2.s && t2.s ? e2.d || t2.d ? !t2.d || e2.isZero() ? (r = t2.s < 0 ? getPi$1(this, n, i2) : new this(0)).s = e2.s : !e2.d || t2.isZero() ? (r = getPi$1(this, a, 1).times(0.5)).s = e2.s : t2.s < 0 ? (this.precision = a, this.rounding = 1, r = this.atan(divide$1$1(e2, t2, a, 1)), t2 = getPi$1(this, a, 1), this.precision = n, this.rounding = i2, r = e2.s < 0 ? r.minus(t2) : r.plus(t2)) : r = this.atan(divide$1$1(e2, t2, a, 1)) : (r = getPi$1(this, a, 1).times(t2.s > 0 ? 0.25 : 0.75)).s = e2.s : r = new this(NaN), r;
}
function cbrt$2(e2) {
  return new this(e2).cbrt();
}
function ceil$1(e2) {
  return finalise$1(e2 = new this(e2), e2.e + 1, 2);
}
function clamp$2(e2, t2, r) {
  return new this(e2).clamp(t2, r);
}
function config$1$1(e2) {
  if (!e2 || "object" != typeof e2) throw Error(decimalError$1 + "Object expected");
  var t2, r, n, i2 = true === e2.defaults, a = ["precision", 1, MAX_DIGITS$1, "rounding", 0, 8, "toExpNeg", -EXP_LIMIT$1, 0, "toExpPos", 0, EXP_LIMIT$1, "maxE", 0, EXP_LIMIT$1, "minE", -EXP_LIMIT$1, 0, "modulo", 0, 9];
  for (t2 = 0; t2 < a.length; t2 += 3) if (r = a[t2], i2 && (this[r] = DEFAULTS$1[r]), void 0 !== (n = e2[r])) {
    if (!(mathfloor$1(n) === n && n >= a[t2 + 1] && n <= a[t2 + 2])) throw Error(invalidArgument$1 + r + ": " + n);
    this[r] = n;
  }
  if (r = "crypto", i2 && (this[r] = DEFAULTS$1[r]), void 0 !== (n = e2[r])) {
    if (true !== n && false !== n && 0 !== n && 1 !== n) throw Error(invalidArgument$1 + r + ": " + n);
    if (n) {
      if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw Error(cryptoUnavailable$1);
      this[r] = true;
    } else this[r] = false;
  }
  return this;
}
function cos$1$1(e2) {
  return new this(e2).cos();
}
function cosh$2$1(e2) {
  return new this(e2).cosh();
}
function clone$2$1(e2) {
  var t2, r, n;
  function i2(e3) {
    var t3, r2, n3, a = this;
    if (!(a instanceof i2)) return new i2(e3);
    if (a.constructor = i2, isDecimalInstance$1(e3)) return a.s = e3.s, void (external$1 ? !e3.d || e3.e > i2.maxE ? (a.e = NaN, a.d = null) : e3.e < i2.minE ? (a.e = 0, a.d = [0]) : (a.e = e3.e, a.d = e3.d.slice()) : (a.e = e3.e, a.d = e3.d ? e3.d.slice() : e3.d));
    if ("number" === (n3 = typeof e3)) {
      if (0 === e3) return a.s = 1 / e3 < 0 ? -1 : 1, a.e = 0, void (a.d = [0]);
      if (e3 < 0 ? (e3 = -e3, a.s = -1) : a.s = 1, e3 === ~~e3 && e3 < 1e7) {
        for (t3 = 0, r2 = e3; r2 >= 10; r2 /= 10) t3++;
        return void (external$1 ? t3 > i2.maxE ? (a.e = NaN, a.d = null) : t3 < i2.minE ? (a.e = 0, a.d = [0]) : (a.e = t3, a.d = [e3]) : (a.e = t3, a.d = [e3]));
      }
      return 0 * e3 != 0 ? (e3 || (a.s = NaN), a.e = NaN, void (a.d = null)) : parseDecimal$1(a, e3.toString());
    }
    if ("string" !== n3) throw Error(invalidArgument$1 + e3);
    return 45 === (r2 = e3.charCodeAt(0)) ? (e3 = e3.slice(1), a.s = -1) : (43 === r2 && (e3 = e3.slice(1)), a.s = 1), isDecimal$1.test(e3) ? parseDecimal$1(a, e3) : parseOther$1(a, e3);
  }
  if (i2.prototype = P$3$1, i2.ROUND_UP = 0, i2.ROUND_DOWN = 1, i2.ROUND_CEIL = 2, i2.ROUND_FLOOR = 3, i2.ROUND_HALF_UP = 4, i2.ROUND_HALF_DOWN = 5, i2.ROUND_HALF_EVEN = 6, i2.ROUND_HALF_CEIL = 7, i2.ROUND_HALF_FLOOR = 8, i2.EUCLID = 9, i2.config = i2.set = config$1$1, i2.clone = clone$2$1, i2.isDecimal = isDecimalInstance$1, i2.abs = abs$1$1, i2.acos = acos$1$1, i2.acosh = acosh$1$1, i2.add = add$1$1, i2.asin = asin$1$1, i2.asinh = asinh$1$1, i2.atan = atan$1$1, i2.atanh = atanh$1$1, i2.atan2 = atan2$1$1, i2.cbrt = cbrt$2, i2.ceil = ceil$1, i2.clamp = clamp$2, i2.cos = cos$1$1, i2.cosh = cosh$2$1, i2.div = div$1, i2.exp = exp$1$1, i2.floor = floor$2, i2.hypot = hypot$1$1, i2.ln = ln$1, i2.log = log$1$1, i2.log10 = log10$1$1, i2.log2 = log2$2, i2.max = max$1$1, i2.min = min$1$1, i2.mod = mod$1$1, i2.mul = mul$1, i2.pow = pow$1$1, i2.random = random$1$1, i2.round = round$1$1, i2.sign = sign$1$1, i2.sin = sin$1$1, i2.sinh = sinh$2$1, i2.sqrt = sqrt$1$1, i2.sub = sub$1, i2.sum = sum$1, i2.tan = tan$1$1, i2.tanh = tanh$1$1, i2.trunc = trunc$1$1, void 0 === e2 && (e2 = {}), e2 && true !== e2.defaults) for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], t2 = 0; t2 < n.length; ) e2.hasOwnProperty(r = n[t2++]) || (e2[r] = this[r]);
  return i2.config(e2), i2;
}
function div$1(e2, t2) {
  return new this(e2).div(t2);
}
function exp$1$1(e2) {
  return new this(e2).exp();
}
function floor$2(e2) {
  return finalise$1(e2 = new this(e2), e2.e + 1, 3);
}
function hypot$1$1() {
  var e2, t2, r = new this(0);
  for (external$1 = false, e2 = 0; e2 < arguments.length; ) if ((t2 = new this(arguments[e2++])).d) r.d && (r = r.plus(t2.times(t2)));
  else {
    if (t2.s) return external$1 = true, new this(1 / 0);
    r = t2;
  }
  return external$1 = true, r.sqrt();
}
function isDecimalInstance$1(e2) {
  return e2 instanceof Decimal$1 || e2 && e2.toStringTag === tag$1 || false;
}
function ln$1(e2) {
  return new this(e2).ln();
}
function log$1$1(e2, t2) {
  return new this(e2).log(t2);
}
function log2$2(e2) {
  return new this(e2).log(2);
}
function log10$1$1(e2) {
  return new this(e2).log(10);
}
function max$1$1() {
  return maxOrMin$1(this, arguments, "lt");
}
function min$1$1() {
  return maxOrMin$1(this, arguments, "gt");
}
function mod$1$1(e2, t2) {
  return new this(e2).mod(t2);
}
function mul$1(e2, t2) {
  return new this(e2).mul(t2);
}
function pow$1$1(e2, t2) {
  return new this(e2).pow(t2);
}
function random$1$1(e2) {
  var t2, r, n, i2, a = 0, o = new this(1), s = [];
  if (void 0 === e2 ? e2 = this.precision : checkInt32$1(e2, 1, MAX_DIGITS$1), n = Math.ceil(e2 / LOG_BASE$1), this.crypto) if (crypto.getRandomValues) for (t2 = crypto.getRandomValues(new Uint32Array(n)); a < n; ) (i2 = t2[a]) >= 429e7 ? t2[a] = crypto.getRandomValues(new Uint32Array(1))[0] : s[a++] = i2 % 1e7;
  else {
    if (!crypto.randomBytes) throw Error(cryptoUnavailable$1);
    for (t2 = crypto.randomBytes(n *= 4); a < n; ) (i2 = t2[a] + (t2[a + 1] << 8) + (t2[a + 2] << 16) + ((127 & t2[a + 3]) << 24)) >= 214e7 ? crypto.randomBytes(4).copy(t2, a) : (s.push(i2 % 1e7), a += 4);
    a = n / 4;
  }
  else for (; a < n; ) s[a++] = 1e7 * Math.random() | 0;
  for (n = s[--a], e2 %= LOG_BASE$1, n && e2 && (i2 = mathpow$1(10, LOG_BASE$1 - e2), s[a] = (n / i2 | 0) * i2); 0 === s[a]; a--) s.pop();
  if (a < 0) r = 0, s = [0];
  else {
    for (r = -1; 0 === s[0]; r -= LOG_BASE$1) s.shift();
    for (n = 1, i2 = s[0]; i2 >= 10; i2 /= 10) n++;
    n < LOG_BASE$1 && (r -= LOG_BASE$1 - n);
  }
  return o.e = r, o.d = s, o;
}
function round$1$1(e2) {
  return finalise$1(e2 = new this(e2), e2.e + 1, this.rounding);
}
function sign$1$1(e2) {
  return (e2 = new this(e2)).d ? e2.d[0] ? e2.s : 0 * e2.s : e2.s || NaN;
}
function sin$1$1(e2) {
  return new this(e2).sin();
}
function sinh$2$1(e2) {
  return new this(e2).sinh();
}
function sqrt$1$1(e2) {
  return new this(e2).sqrt();
}
function sub$1(e2, t2) {
  return new this(e2).sub(t2);
}
function sum$1() {
  var e2 = 0, t2 = arguments, r = new this(t2[e2]);
  for (external$1 = false; r.s && ++e2 < t2.length; ) r = r.plus(t2[e2]);
  return external$1 = true, finalise$1(r, this.precision, this.rounding);
}
function tan$1$1(e2) {
  return new this(e2).tan();
}
function tanh$1$1(e2) {
  return new this(e2).tanh();
}
function trunc$1$1(e2) {
  return finalise$1(e2 = new this(e2), e2.e + 1, 1);
}
P$3$1[Symbol.for("nodejs.util.inspect.custom")] = P$3$1.toString, P$3$1[Symbol.toStringTag] = "Decimal";
var Decimal$1 = P$3$1.constructor = clone$2$1(DEFAULTS$1);
LN10$1 = new Decimal$1(LN10$1), PI$1 = new Decimal$1(PI$1);
var name$4_$1 = "BigNumber", dependencies$4_$1 = ["?on", "config"], createBigNumberClass$1 = factory$1(name$4_$1, dependencies$4_$1, ((e2) => {
  var { on: t2, config: r } = e2, n = Decimal$1.clone({ precision: r.precision, modulo: Decimal$1.EUCLID });
  return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = true, n.prototype.toJSON = function() {
    return { mathjs: "BigNumber", value: this.toString() };
  }, n.fromJSON = function(e3) {
    return new n(e3.value);
  }, t2 && t2("config", (function(e3, t3) {
    e3.precision !== t3.precision && n.config({ precision: e3.precision });
  })), n;
}), { isClass: true });
const cosh$1$1 = Math.cosh || function(e2) {
  return Math.abs(e2) < 1e-9 ? 1 - e2 : 0.5 * (Math.exp(e2) + Math.exp(-e2));
}, sinh$1$1 = Math.sinh || function(e2) {
  return Math.abs(e2) < 1e-9 ? e2 : 0.5 * (Math.exp(e2) - Math.exp(-e2));
}, cosm1$1 = function(e2) {
  const t2 = Math.PI / 4;
  if (-t2 > e2 || e2 > t2) return Math.cos(e2) - 1;
  const r = e2 * e2;
  return r * (r * (r * (r * (r * (r * (r * (r / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 0.5);
}, hypot$2 = function(e2, t2) {
  return (e2 = Math.abs(e2)) < (t2 = Math.abs(t2)) && ([e2, t2] = [t2, e2]), e2 < 1e8 ? Math.sqrt(e2 * e2 + t2 * t2) : (t2 /= e2, e2 * Math.sqrt(1 + t2 * t2));
}, parser_exit$1 = function() {
  throw SyntaxError("Invalid Param");
};
function logHypot$1(e2, t2) {
  const r = Math.abs(e2), n = Math.abs(t2);
  return 0 === e2 ? Math.log(n) : 0 === t2 ? Math.log(r) : r < 3e3 && n < 3e3 ? 0.5 * Math.log(e2 * e2 + t2 * t2) : (e2 *= 0.5, t2 *= 0.5, 0.5 * Math.log(e2 * e2 + t2 * t2) + Math.LN2);
}
const P$2$1 = { re: 0, im: 0 }, parse$1$1 = function(e2, t2) {
  const r = P$2$1;
  if (null == e2) r.re = r.im = 0;
  else if (void 0 !== t2) r.re = e2, r.im = t2;
  else switch (typeof e2) {
    case "object":
      if ("im" in e2 && "re" in e2) r.re = e2.re, r.im = e2.im;
      else if ("abs" in e2 && "arg" in e2) {
        if (!isFinite(e2.abs) && isFinite(e2.arg)) return Complex$1.INFINITY;
        r.re = e2.abs * Math.cos(e2.arg), r.im = e2.abs * Math.sin(e2.arg);
      } else if ("r" in e2 && "phi" in e2) {
        if (!isFinite(e2.r) && isFinite(e2.phi)) return Complex$1.INFINITY;
        r.re = e2.r * Math.cos(e2.phi), r.im = e2.r * Math.sin(e2.phi);
      } else 2 === e2.length ? (r.re = e2[0], r.im = e2[1]) : parser_exit$1();
      break;
    case "string":
      r.im = r.re = 0;
      const t3 = e2.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
      let n = 1, i2 = 0;
      null === t3 && parser_exit$1();
      for (let e3 = 0; e3 < t3.length; e3++) {
        const a = t3[e3];
        " " === a || "	" === a || "\n" === a || ("+" === a ? n++ : "-" === a ? i2++ : "i" === a || "I" === a ? (n + i2 === 0 && parser_exit$1(), " " === t3[e3 + 1] || isNaN(t3[e3 + 1]) ? r.im += parseFloat((i2 % 2 ? "-" : "") + "1") : (r.im += parseFloat((i2 % 2 ? "-" : "") + t3[e3 + 1]), e3++), n = i2 = 0) : ((n + i2 === 0 || isNaN(a)) && parser_exit$1(), "i" === t3[e3 + 1] || "I" === t3[e3 + 1] ? (r.im += parseFloat((i2 % 2 ? "-" : "") + a), e3++) : r.re += parseFloat((i2 % 2 ? "-" : "") + a), n = i2 = 0));
      }
      n + i2 > 0 && parser_exit$1();
      break;
    case "number":
      r.im = 0, r.re = e2;
      break;
    default:
      parser_exit$1();
  }
  return isNaN(r.re) || isNaN(r.im), r;
};
function Complex$1(e2, t2) {
  if (!(this instanceof Complex$1)) return new Complex$1(e2, t2);
  const r = parse$1$1(e2, t2);
  this.re = r.re, this.im = r.im;
}
Complex$1.prototype = { re: 0, im: 0, sign: function() {
  const e2 = hypot$2(this.re, this.im);
  return new Complex$1(this.re / e2, this.im / e2);
}, add: function(e2, t2) {
  const r = parse$1$1(e2, t2), n = this.isInfinite(), i2 = !(isFinite(r.re) && isFinite(r.im));
  return n || i2 ? n && i2 ? Complex$1.NAN : Complex$1.INFINITY : new Complex$1(this.re + r.re, this.im + r.im);
}, sub: function(e2, t2) {
  const r = parse$1$1(e2, t2), n = this.isInfinite(), i2 = !(isFinite(r.re) && isFinite(r.im));
  return n || i2 ? n && i2 ? Complex$1.NAN : Complex$1.INFINITY : new Complex$1(this.re - r.re, this.im - r.im);
}, mul: function(e2, t2) {
  const r = parse$1$1(e2, t2), n = this.isInfinite(), i2 = !(isFinite(r.re) && isFinite(r.im)), a = 0 === this.re && 0 === this.im, o = 0 === r.re && 0 === r.im;
  return n && o || i2 && a ? Complex$1.NAN : n || i2 ? Complex$1.INFINITY : 0 === r.im && 0 === this.im ? new Complex$1(this.re * r.re, 0) : new Complex$1(this.re * r.re - this.im * r.im, this.re * r.im + this.im * r.re);
}, div: function(e2, t2) {
  const r = parse$1$1(e2, t2), n = this.isInfinite(), i2 = !(isFinite(r.re) && isFinite(r.im)), a = 0 === this.re && 0 === this.im, o = 0 === r.re && 0 === r.im;
  if (a && o || n && i2) return Complex$1.NAN;
  if (o || n) return Complex$1.INFINITY;
  if (a || i2) return Complex$1.ZERO;
  if (0 === r.im) return new Complex$1(this.re / r.re, this.im / r.re);
  if (Math.abs(r.re) < Math.abs(r.im)) {
    const e3 = r.re / r.im, t3 = r.re * e3 + r.im;
    return new Complex$1((this.re * e3 + this.im) / t3, (this.im * e3 - this.re) / t3);
  }
  {
    const e3 = r.im / r.re, t3 = r.im * e3 + r.re;
    return new Complex$1((this.re + this.im * e3) / t3, (this.im - this.re * e3) / t3);
  }
}, pow: function(e2, t2) {
  const r = parse$1$1(e2, t2), n = 0 === this.re && 0 === this.im;
  if (0 === r.re && 0 === r.im) return Complex$1.ONE;
  if (0 === r.im) {
    if (0 === this.im && this.re > 0) return new Complex$1(Math.pow(this.re, r.re), 0);
    if (0 === this.re) switch ((r.re % 4 + 4) % 4) {
      case 0:
        return new Complex$1(Math.pow(this.im, r.re), 0);
      case 1:
        return new Complex$1(0, Math.pow(this.im, r.re));
      case 2:
        return new Complex$1(-Math.pow(this.im, r.re), 0);
      case 3:
        return new Complex$1(0, -Math.pow(this.im, r.re));
    }
  }
  if (n && r.re > 0) return Complex$1.ZERO;
  const i2 = Math.atan2(this.im, this.re), a = logHypot$1(this.re, this.im);
  let o = Math.exp(r.re * a - r.im * i2), s = r.im * a + r.re * i2;
  return new Complex$1(o * Math.cos(s), o * Math.sin(s));
}, sqrt: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === t2) return e2 >= 0 ? new Complex$1(Math.sqrt(e2), 0) : new Complex$1(0, Math.sqrt(-e2));
  const r = hypot$2(e2, t2);
  let n = Math.sqrt(0.5 * (r + Math.abs(e2))), i2 = Math.abs(t2) / (2 * n);
  return e2 >= 0 ? new Complex$1(n, t2 < 0 ? -i2 : i2) : new Complex$1(i2, t2 < 0 ? -n : n);
}, exp: function() {
  const e2 = Math.exp(this.re);
  return 0 === this.im ? new Complex$1(e2, 0) : new Complex$1(e2 * Math.cos(this.im), e2 * Math.sin(this.im));
}, expm1: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex$1(Math.expm1(e2) * Math.cos(t2) + cosm1$1(t2), Math.exp(e2) * Math.sin(t2));
}, log: function() {
  const e2 = this.re, t2 = this.im;
  return 0 === t2 && e2 > 0 ? new Complex$1(Math.log(e2), 0) : new Complex$1(logHypot$1(e2, t2), Math.atan2(t2, e2));
}, abs: function() {
  return hypot$2(this.re, this.im);
}, arg: function() {
  return Math.atan2(this.im, this.re);
}, sin: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex$1(Math.sin(e2) * cosh$1$1(t2), Math.cos(e2) * sinh$1$1(t2));
}, cos: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex$1(Math.cos(e2) * cosh$1$1(t2), -Math.sin(e2) * sinh$1$1(t2));
}, tan: function() {
  const e2 = 2 * this.re, t2 = 2 * this.im, r = Math.cos(e2) + cosh$1$1(t2);
  return new Complex$1(Math.sin(e2) / r, sinh$1$1(t2) / r);
}, cot: function() {
  const e2 = 2 * this.re, t2 = 2 * this.im, r = Math.cos(e2) - cosh$1$1(t2);
  return new Complex$1(-Math.sin(e2) / r, sinh$1$1(t2) / r);
}, sec: function() {
  const e2 = this.re, t2 = this.im, r = 0.5 * cosh$1$1(2 * t2) + 0.5 * Math.cos(2 * e2);
  return new Complex$1(Math.cos(e2) * cosh$1$1(t2) / r, Math.sin(e2) * sinh$1$1(t2) / r);
}, csc: function() {
  const e2 = this.re, t2 = this.im, r = 0.5 * cosh$1$1(2 * t2) - 0.5 * Math.cos(2 * e2);
  return new Complex$1(Math.sin(e2) * cosh$1$1(t2) / r, -Math.cos(e2) * sinh$1$1(t2) / r);
}, asin: function() {
  const e2 = this.re, t2 = this.im, r = new Complex$1(t2 * t2 - e2 * e2 + 1, -2 * e2 * t2).sqrt(), n = new Complex$1(r.re - t2, r.im + e2).log();
  return new Complex$1(n.im, -n.re);
}, acos: function() {
  const e2 = this.re, t2 = this.im, r = new Complex$1(t2 * t2 - e2 * e2 + 1, -2 * e2 * t2).sqrt(), n = new Complex$1(r.re - t2, r.im + e2).log();
  return new Complex$1(Math.PI / 2 - n.im, n.re);
}, atan: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === e2) {
    if (1 === t2) return new Complex$1(0, 1 / 0);
    if (-1 === t2) return new Complex$1(0, -1 / 0);
  }
  const r = e2 * e2 + (1 - t2) * (1 - t2), n = new Complex$1((1 - t2 * t2 - e2 * e2) / r, -2 * e2 / r).log();
  return new Complex$1(-0.5 * n.im, 0.5 * n.re);
}, acot: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === t2) return new Complex$1(Math.atan2(1, e2), 0);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex$1(e2 / r, -t2 / r).atan() : new Complex$1(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).atan();
}, asec: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === e2 && 0 === t2) return new Complex$1(0, 1 / 0);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex$1(e2 / r, -t2 / r).acos() : new Complex$1(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).acos();
}, acsc: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === e2 && 0 === t2) return new Complex$1(Math.PI / 2, 1 / 0);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex$1(e2 / r, -t2 / r).asin() : new Complex$1(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).asin();
}, sinh: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex$1(sinh$1$1(e2) * Math.cos(t2), cosh$1$1(e2) * Math.sin(t2));
}, cosh: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex$1(cosh$1$1(e2) * Math.cos(t2), sinh$1$1(e2) * Math.sin(t2));
}, tanh: function() {
  const e2 = 2 * this.re, t2 = 2 * this.im, r = cosh$1$1(e2) + Math.cos(t2);
  return new Complex$1(sinh$1$1(e2) / r, Math.sin(t2) / r);
}, coth: function() {
  const e2 = 2 * this.re, t2 = 2 * this.im, r = cosh$1$1(e2) - Math.cos(t2);
  return new Complex$1(sinh$1$1(e2) / r, -Math.sin(t2) / r);
}, csch: function() {
  const e2 = this.re, t2 = this.im, r = Math.cos(2 * t2) - cosh$1$1(2 * e2);
  return new Complex$1(-2 * sinh$1$1(e2) * Math.cos(t2) / r, 2 * cosh$1$1(e2) * Math.sin(t2) / r);
}, sech: function() {
  const e2 = this.re, t2 = this.im, r = Math.cos(2 * t2) + cosh$1$1(2 * e2);
  return new Complex$1(2 * cosh$1$1(e2) * Math.cos(t2) / r, -2 * sinh$1$1(e2) * Math.sin(t2) / r);
}, asinh: function() {
  let e2 = this.im;
  this.im = -this.re, this.re = e2;
  const t2 = this.asin();
  return this.re = -this.im, this.im = e2, e2 = t2.re, t2.re = -t2.im, t2.im = e2, t2;
}, acosh: function() {
  const e2 = this.acos();
  if (e2.im <= 0) {
    const t2 = e2.re;
    e2.re = -e2.im, e2.im = t2;
  } else {
    const t2 = e2.im;
    e2.im = -e2.re, e2.re = t2;
  }
  return e2;
}, atanh: function() {
  const e2 = this.re, t2 = this.im, r = e2 > 1 && 0 === t2, n = 1 - e2, i2 = 1 + e2, a = n * n + t2 * t2, o = 0 !== a ? new Complex$1((i2 * n - t2 * t2) / a, (t2 * n + i2 * t2) / a) : new Complex$1(-1 !== e2 ? e2 / 0 : 0, 0 !== t2 ? t2 / 0 : 0), s = o.re;
  return o.re = logHypot$1(o.re, o.im) / 2, o.im = Math.atan2(o.im, s) / 2, r && (o.im = -o.im), o;
}, acoth: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === e2 && 0 === t2) return new Complex$1(0, Math.PI / 2);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex$1(e2 / r, -t2 / r).atanh() : new Complex$1(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).atanh();
}, acsch: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === t2) return new Complex$1(0 !== e2 ? Math.log(e2 + Math.sqrt(e2 * e2 + 1)) : 1 / 0, 0);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex$1(e2 / r, -t2 / r).asinh() : new Complex$1(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).asinh();
}, asech: function() {
  const e2 = this.re, t2 = this.im;
  if (this.isZero()) return Complex$1.INFINITY;
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex$1(e2 / r, -t2 / r).acosh() : new Complex$1(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).acosh();
}, inverse: function() {
  if (this.isZero()) return Complex$1.INFINITY;
  if (this.isInfinite()) return Complex$1.ZERO;
  const e2 = this.re, t2 = this.im, r = e2 * e2 + t2 * t2;
  return new Complex$1(e2 / r, -t2 / r);
}, conjugate: function() {
  return new Complex$1(this.re, -this.im);
}, neg: function() {
  return new Complex$1(-this.re, -this.im);
}, ceil: function(e2) {
  return e2 = Math.pow(10, e2 || 0), new Complex$1(Math.ceil(this.re * e2) / e2, Math.ceil(this.im * e2) / e2);
}, floor: function(e2) {
  return e2 = Math.pow(10, e2 || 0), new Complex$1(Math.floor(this.re * e2) / e2, Math.floor(this.im * e2) / e2);
}, round: function(e2) {
  return e2 = Math.pow(10, e2 || 0), new Complex$1(Math.round(this.re * e2) / e2, Math.round(this.im * e2) / e2);
}, equals: function(e2, t2) {
  const r = parse$1$1(e2, t2);
  return Math.abs(r.re - this.re) <= Complex$1.EPSILON && Math.abs(r.im - this.im) <= Complex$1.EPSILON;
}, clone: function() {
  return new Complex$1(this.re, this.im);
}, toString: function() {
  let e2 = this.re, t2 = this.im, r = "";
  return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(e2) < Complex$1.EPSILON && (e2 = 0), Math.abs(t2) < Complex$1.EPSILON && (t2 = 0), 0 === t2 ? r + e2 : (0 !== e2 ? (r += e2, r += " ", t2 < 0 ? (t2 = -t2, r += "-") : r += "+", r += " ") : t2 < 0 && (t2 = -t2, r += "-"), 1 !== t2 && (r += t2), r + "i"));
}, toVector: function() {
  return [this.re, this.im];
}, valueOf: function() {
  return 0 === this.im ? this.re : null;
}, isNaN: function() {
  return isNaN(this.re) || isNaN(this.im);
}, isZero: function() {
  return 0 === this.im && 0 === this.re;
}, isFinite: function() {
  return isFinite(this.re) && isFinite(this.im);
}, isInfinite: function() {
  return !this.isFinite();
} }, Complex$1.ZERO = new Complex$1(0, 0), Complex$1.ONE = new Complex$1(1, 0), Complex$1.I = new Complex$1(0, 1), Complex$1.PI = new Complex$1(Math.PI, 0), Complex$1.E = new Complex$1(Math.E, 0), Complex$1.INFINITY = new Complex$1(1 / 0, 1 / 0), Complex$1.NAN = new Complex$1(NaN, NaN), Complex$1.EPSILON = 1e-15;
var name$4Z$1 = "Complex", dependencies$4Z$1 = [], createComplexClass$1 = factory$1(name$4Z$1, dependencies$4Z$1, (() => (Object.defineProperty(Complex$1, "name", { value: "Complex" }), Complex$1.prototype.constructor = Complex$1, Complex$1.prototype.type = "Complex", Complex$1.prototype.isComplex = true, Complex$1.prototype.toJSON = function() {
  return { mathjs: "Complex", re: this.re, im: this.im };
}, Complex$1.prototype.toPolar = function() {
  return { r: this.abs(), phi: this.arg() };
}, Complex$1.prototype.format = function(e2) {
  var t2 = this.im, r = this.re, n = format$2$1(this.re, e2), i2 = format$2$1(this.im, e2), a = isNumber$1$1(e2) ? e2 : e2 ? e2.precision : null;
  if (null !== a) {
    var o = Math.pow(10, -a);
    Math.abs(r / t2) < o && (r = 0), Math.abs(t2 / r) < o && (t2 = 0);
  }
  return 0 === t2 ? n : 0 === r ? 1 === t2 ? "i" : -1 === t2 ? "-i" : i2 + "i" : t2 < 0 ? -1 === t2 ? n + " - i" : n + " - " + i2.substring(1) + "i" : 1 === t2 ? n + " + i" : n + " + " + i2 + "i";
}, Complex$1.fromPolar = function(e2) {
  switch (arguments.length) {
    case 1:
      var t2 = arguments[0];
      if ("object" == typeof t2) return Complex$1(t2);
      throw new TypeError("Input has to be an object with r and phi keys.");
    case 2:
      var r = arguments[0], n = arguments[1];
      if (isNumber$1$1(r)) {
        if (isUnit$1(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), isNumber$1$1(n)) return new Complex$1({ r, phi: n });
        throw new TypeError("Phi is not a number nor an angle unit.");
      }
      throw new TypeError("Radius r is not a number.");
    default:
      throw new SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, Complex$1.prototype.valueOf = Complex$1.prototype.toString, Complex$1.fromJSON = function(e2) {
  return new Complex$1(e2);
}, Complex$1.compare = function(e2, t2) {
  return e2.re > t2.re ? 1 : e2.re < t2.re ? -1 : e2.im > t2.im ? 1 : e2.im < t2.im ? -1 : 0;
}, Complex$1)), { isClass: true });
"undefined" == typeof BigInt && (BigInt = function(e2) {
  if (isNaN(e2)) throw new Error("");
  return e2;
});
const C_ZERO$1 = BigInt(0), C_ONE$1 = BigInt(1), C_TWO$1 = BigInt(2), C_FIVE$1 = BigInt(5), C_TEN$1 = BigInt(10), MAX_CYCLE_LEN$1 = 2e3, P$1$1 = { s: C_ONE$1, n: C_ZERO$1, d: C_ONE$1 };
function assign$1(e2, t2) {
  try {
    e2 = BigInt(e2);
  } catch (e3) {
    throw InvalidParameter$1();
  }
  return e2 * t2;
}
function trunc$2(e2) {
  return "bigint" == typeof e2 ? e2 : Math.floor(e2);
}
function newFraction$1(e2, t2) {
  if (t2 === C_ZERO$1) throw DivisionByZero$1();
  const r = Object.create(Fraction$1.prototype);
  r.s = e2 < C_ZERO$1 ? -C_ONE$1 : C_ONE$1;
  const n = gcd$2$1(e2 = e2 < C_ZERO$1 ? -e2 : e2, t2);
  return r.n = e2 / n, r.d = t2 / n, r;
}
function factorize$1(e2) {
  const t2 = {};
  let r = e2, n = C_TWO$1, i2 = C_FIVE$1 - C_ONE$1;
  for (; i2 <= r; ) {
    for (; r % n === C_ZERO$1; ) r /= n, t2[n] = (t2[n] || C_ZERO$1) + C_ONE$1;
    i2 += C_ONE$1 + C_TWO$1 * n++;
  }
  return r !== e2 ? r > 1 && (t2[r] = (t2[r] || C_ZERO$1) + C_ONE$1) : t2[e2] = (t2[e2] || C_ZERO$1) + C_ONE$1, t2;
}
const parse$3 = function(e2, t2) {
  let r = C_ZERO$1, n = C_ONE$1, i2 = C_ONE$1;
  if (null == e2) ;
  else if (void 0 !== t2) {
    if ("bigint" == typeof e2) r = e2;
    else {
      if (isNaN(e2)) throw InvalidParameter$1();
      if (e2 % 1 != 0) throw NonIntegerParameter$1();
      r = BigInt(e2);
    }
    if ("bigint" == typeof t2) n = t2;
    else {
      if (isNaN(t2)) throw InvalidParameter$1();
      if (t2 % 1 != 0) throw NonIntegerParameter$1();
      n = BigInt(t2);
    }
    i2 = r * n;
  } else if ("object" == typeof e2) {
    if ("d" in e2 && "n" in e2) r = BigInt(e2.n), n = BigInt(e2.d), "s" in e2 && (r *= BigInt(e2.s));
    else if (0 in e2) r = BigInt(e2[0]), 1 in e2 && (n = BigInt(e2[1]));
    else {
      if ("bigint" != typeof e2) throw InvalidParameter$1();
      r = e2;
    }
    i2 = r * n;
  } else if ("number" == typeof e2) {
    if (isNaN(e2)) throw InvalidParameter$1();
    if (e2 < 0 && (i2 = -C_ONE$1, e2 = -e2), e2 % 1 == 0) r = BigInt(e2);
    else {
      let t3 = 1, i3 = 0, a = 1, o = 1, s = 1, u = 1e7;
      for (e2 >= 1 && (t3 = 10 ** Math.floor(1 + Math.log10(e2)), e2 /= t3); a <= u && s <= u; ) {
        let t4 = (i3 + o) / (a + s);
        if (e2 === t4) {
          a + s <= u ? (r = i3 + o, n = a + s) : s > a ? (r = o, n = s) : (r = i3, n = a);
          break;
        }
        e2 > t4 ? (i3 += o, a += s) : (o += i3, s += a), a > u ? (r = o, n = s) : (r = i3, n = a);
      }
      r = BigInt(r) * BigInt(t3), n = BigInt(n);
    }
  } else if ("string" == typeof e2) {
    let t3 = 0, a = C_ZERO$1, o = C_ZERO$1, s = C_ZERO$1, u = C_ONE$1, c2 = C_ONE$1, l = e2.replace(/_/g, "").match(/\d+|./g);
    if (null === l) throw InvalidParameter$1();
    if ("-" === l[t3] ? (i2 = -C_ONE$1, t3++) : "+" === l[t3] && t3++, l.length === t3 + 1 ? o = assign$1(l[t3++], i2) : "." === l[t3 + 1] || "." === l[t3] ? ("." !== l[t3] && (a = assign$1(l[t3++], i2)), t3++, (t3 + 1 === l.length || "(" === l[t3 + 1] && ")" === l[t3 + 3] || "'" === l[t3 + 1] && "'" === l[t3 + 3]) && (o = assign$1(l[t3], i2), u = C_TEN$1 ** BigInt(l[t3].length), t3++), ("(" === l[t3] && ")" === l[t3 + 2] || "'" === l[t3] && "'" === l[t3 + 2]) && (s = assign$1(l[t3 + 1], i2), c2 = C_TEN$1 ** BigInt(l[t3 + 1].length) - C_ONE$1, t3 += 3)) : "/" === l[t3 + 1] || ":" === l[t3 + 1] ? (o = assign$1(l[t3], i2), u = assign$1(l[t3 + 2], C_ONE$1), t3 += 3) : "/" === l[t3 + 3] && " " === l[t3 + 1] && (a = assign$1(l[t3], i2), o = assign$1(l[t3 + 2], i2), u = assign$1(l[t3 + 4], C_ONE$1), t3 += 5), !(l.length <= t3)) throw InvalidParameter$1();
    n = u * c2, i2 = r = s + n * a + c2 * o;
  } else {
    if ("bigint" != typeof e2) throw InvalidParameter$1();
    r = e2, i2 = e2, n = C_ONE$1;
  }
  if (n === C_ZERO$1) throw DivisionByZero$1();
  P$1$1.s = i2 < C_ZERO$1 ? -C_ONE$1 : C_ONE$1, P$1$1.n = r < C_ZERO$1 ? -r : r, P$1$1.d = n < C_ZERO$1 ? -n : n;
};
function modpow$1(e2, t2, r) {
  let n = C_ONE$1;
  for (; t2 > C_ZERO$1; e2 = e2 * e2 % r, t2 >>= C_ONE$1) t2 & C_ONE$1 && (n = n * e2 % r);
  return n;
}
function cycleLen$1(e2, t2) {
  for (; t2 % C_TWO$1 === C_ZERO$1; t2 /= C_TWO$1) ;
  for (; t2 % C_FIVE$1 === C_ZERO$1; t2 /= C_FIVE$1) ;
  if (t2 === C_ONE$1) return C_ZERO$1;
  let r = C_TEN$1 % t2, n = 1;
  for (; r !== C_ONE$1; n++) if (r = r * C_TEN$1 % t2, n > MAX_CYCLE_LEN$1) return C_ZERO$1;
  return BigInt(n);
}
function cycleStart$1(e2, t2, r) {
  let n = C_ONE$1, i2 = modpow$1(C_TEN$1, r, t2);
  for (let e3 = 0; e3 < 300; e3++) {
    if (n === i2) return BigInt(e3);
    n = n * C_TEN$1 % t2, i2 = i2 * C_TEN$1 % t2;
  }
  return 0;
}
function gcd$2$1(e2, t2) {
  if (!e2) return t2;
  if (!t2) return e2;
  for (; ; ) {
    if (!(e2 %= t2)) return t2;
    if (!(t2 %= e2)) return e2;
  }
}
function Fraction$1(e2, t2) {
  if (parse$3(e2, t2), !(this instanceof Fraction$1)) return newFraction$1(P$1$1.s * P$1$1.n, P$1$1.d);
  e2 = gcd$2$1(P$1$1.d, P$1$1.n), this.s = P$1$1.s, this.n = P$1$1.n / e2, this.d = P$1$1.d / e2;
}
var DivisionByZero$1 = function() {
  return new Error("Division by Zero");
}, InvalidParameter$1 = function() {
  return new Error("Invalid argument");
}, NonIntegerParameter$1 = function() {
  return new Error("Parameters must be integer");
};
Fraction$1.prototype = { s: C_ONE$1, n: C_ZERO$1, d: C_ONE$1, abs: function() {
  return newFraction$1(this.n, this.d);
}, neg: function() {
  return newFraction$1(-this.s * this.n, this.d);
}, add: function(e2, t2) {
  return parse$3(e2, t2), newFraction$1(this.s * this.n * P$1$1.d + P$1$1.s * this.d * P$1$1.n, this.d * P$1$1.d);
}, sub: function(e2, t2) {
  return parse$3(e2, t2), newFraction$1(this.s * this.n * P$1$1.d - P$1$1.s * this.d * P$1$1.n, this.d * P$1$1.d);
}, mul: function(e2, t2) {
  return parse$3(e2, t2), newFraction$1(this.s * P$1$1.s * this.n * P$1$1.n, this.d * P$1$1.d);
}, div: function(e2, t2) {
  return parse$3(e2, t2), newFraction$1(this.s * P$1$1.s * this.n * P$1$1.d, this.d * P$1$1.n);
}, clone: function() {
  return newFraction$1(this.s * this.n, this.d);
}, mod: function(e2, t2) {
  if (void 0 === e2) return newFraction$1(this.s * this.n % this.d, C_ONE$1);
  if (parse$3(e2, t2), C_ZERO$1 === P$1$1.n * this.d) throw DivisionByZero$1();
  return newFraction$1(this.s * (P$1$1.d * this.n) % (P$1$1.n * this.d), P$1$1.d * this.d);
}, gcd: function(e2, t2) {
  return parse$3(e2, t2), newFraction$1(gcd$2$1(P$1$1.n, this.n) * gcd$2$1(P$1$1.d, this.d), P$1$1.d * this.d);
}, lcm: function(e2, t2) {
  return parse$3(e2, t2), P$1$1.n === C_ZERO$1 && this.n === C_ZERO$1 ? newFraction$1(C_ZERO$1, C_ONE$1) : newFraction$1(P$1$1.n * this.n, gcd$2$1(P$1$1.n, this.n) * gcd$2$1(P$1$1.d, this.d));
}, inverse: function() {
  return newFraction$1(this.s * this.d, this.n);
}, pow: function(e2, t2) {
  if (parse$3(e2, t2), P$1$1.d === C_ONE$1) return P$1$1.s < C_ZERO$1 ? newFraction$1((this.s * this.d) ** P$1$1.n, this.n ** P$1$1.n) : newFraction$1((this.s * this.n) ** P$1$1.n, this.d ** P$1$1.n);
  if (this.s < C_ZERO$1) return null;
  let r = factorize$1(this.n), n = factorize$1(this.d), i2 = C_ONE$1, a = C_ONE$1;
  for (let e3 in r) if ("1" !== e3) {
    if ("0" === e3) {
      i2 = C_ZERO$1;
      break;
    }
    if (r[e3] *= P$1$1.n, r[e3] % P$1$1.d !== C_ZERO$1) return null;
    r[e3] /= P$1$1.d, i2 *= BigInt(e3) ** r[e3];
  }
  for (let e3 in n) if ("1" !== e3) {
    if (n[e3] *= P$1$1.n, n[e3] % P$1$1.d !== C_ZERO$1) return null;
    n[e3] /= P$1$1.d, a *= BigInt(e3) ** n[e3];
  }
  return P$1$1.s < C_ZERO$1 ? newFraction$1(a, i2) : newFraction$1(i2, a);
}, log: function(e2, t2) {
  if (parse$3(e2, t2), this.s <= C_ZERO$1 || P$1$1.s <= C_ZERO$1) return null;
  const r = {}, n = factorize$1(P$1$1.n), i2 = factorize$1(P$1$1.d), a = factorize$1(this.n), o = factorize$1(this.d);
  for (const e3 in i2) n[e3] = (n[e3] || C_ZERO$1) - i2[e3];
  for (const e3 in o) a[e3] = (a[e3] || C_ZERO$1) - o[e3];
  for (const e3 in n) "1" !== e3 && (r[e3] = true);
  for (const e3 in a) "1" !== e3 && (r[e3] = true);
  let s = null, u = null;
  for (const e3 in r) {
    const t3 = n[e3] || C_ZERO$1, r2 = a[e3] || C_ZERO$1;
    if (t3 === C_ZERO$1) {
      if (r2 !== C_ZERO$1) return null;
      continue;
    }
    let i3 = r2, o2 = t3;
    const c2 = gcd$2$1(i3, o2);
    if (i3 /= c2, o2 /= c2, null === s && null === u) s = i3, u = o2;
    else if (i3 * u != s * o2) return null;
  }
  return null !== s && null !== u ? newFraction$1(s, u) : null;
}, equals: function(e2, t2) {
  return parse$3(e2, t2), this.s * this.n * P$1$1.d == P$1$1.s * P$1$1.n * this.d;
}, lt: function(e2, t2) {
  return parse$3(e2, t2), this.s * this.n * P$1$1.d < P$1$1.s * P$1$1.n * this.d;
}, lte: function(e2, t2) {
  return parse$3(e2, t2), this.s * this.n * P$1$1.d <= P$1$1.s * P$1$1.n * this.d;
}, gt: function(e2, t2) {
  return parse$3(e2, t2), this.s * this.n * P$1$1.d > P$1$1.s * P$1$1.n * this.d;
}, gte: function(e2, t2) {
  return parse$3(e2, t2), this.s * this.n * P$1$1.d >= P$1$1.s * P$1$1.n * this.d;
}, compare: function(e2, t2) {
  parse$3(e2, t2);
  let r = this.s * this.n * P$1$1.d - P$1$1.s * P$1$1.n * this.d;
  return (C_ZERO$1 < r) - (r < C_ZERO$1);
}, ceil: function(e2) {
  return e2 = C_TEN$1 ** BigInt(e2 || 0), newFraction$1(trunc$2(this.s * e2 * this.n / this.d) + (e2 * this.n % this.d > C_ZERO$1 && this.s >= C_ZERO$1 ? C_ONE$1 : C_ZERO$1), e2);
}, floor: function(e2) {
  return e2 = C_TEN$1 ** BigInt(e2 || 0), newFraction$1(trunc$2(this.s * e2 * this.n / this.d) - (e2 * this.n % this.d > C_ZERO$1 && this.s < C_ZERO$1 ? C_ONE$1 : C_ZERO$1), e2);
}, round: function(e2) {
  return e2 = C_TEN$1 ** BigInt(e2 || 0), newFraction$1(trunc$2(this.s * e2 * this.n / this.d) + this.s * ((this.s >= C_ZERO$1 ? C_ONE$1 : C_ZERO$1) + C_TWO$1 * (e2 * this.n % this.d) > this.d ? C_ONE$1 : C_ZERO$1), e2);
}, roundTo: function(e2, t2) {
  parse$3(e2, t2);
  const r = this.n * P$1$1.d, n = this.d * P$1$1.n, i2 = r % n;
  let a = trunc$2(r / n);
  return i2 + i2 >= n && a++, newFraction$1(this.s * a * P$1$1.n, P$1$1.d);
}, divisible: function(e2, t2) {
  return parse$3(e2, t2), !(!(P$1$1.n * this.d) || this.n * P$1$1.d % (P$1$1.n * this.d));
}, valueOf: function() {
  return Number(this.s * this.n) / Number(this.d);
}, toString: function(e2) {
  let t2 = this.n, r = this.d;
  e2 = e2 || 15;
  let n = cycleLen$1(t2, r), i2 = cycleStart$1(t2, r, n), a = this.s < C_ZERO$1 ? "-" : "";
  if (a += trunc$2(t2 / r), t2 %= r, t2 *= C_TEN$1, t2 && (a += "."), n) {
    for (let e3 = i2; e3--; ) a += trunc$2(t2 / r), t2 %= r, t2 *= C_TEN$1;
    a += "(";
    for (let e3 = n; e3--; ) a += trunc$2(t2 / r), t2 %= r, t2 *= C_TEN$1;
    a += ")";
  } else for (let n3 = e2; t2 && n3--; ) a += trunc$2(t2 / r), t2 %= r, t2 *= C_TEN$1;
  return a;
}, toFraction: function(e2) {
  let t2 = this.n, r = this.d, n = this.s < C_ZERO$1 ? "-" : "";
  if (r === C_ONE$1) n += t2;
  else {
    let i2 = trunc$2(t2 / r);
    e2 && i2 > C_ZERO$1 && (n += i2, n += " ", t2 %= r), n += t2, n += "/", n += r;
  }
  return n;
}, toLatex: function(e2) {
  let t2 = this.n, r = this.d, n = this.s < C_ZERO$1 ? "-" : "";
  if (r === C_ONE$1) n += t2;
  else {
    let i2 = trunc$2(t2 / r);
    e2 && i2 > C_ZERO$1 && (n += i2, t2 %= r), n += "\\frac{", n += t2, n += "}{", n += r, n += "}";
  }
  return n;
}, toContinued: function() {
  let e2 = this.n, t2 = this.d, r = [];
  do {
    r.push(trunc$2(e2 / t2));
    let n = e2 % t2;
    e2 = t2, t2 = n;
  } while (e2 !== C_ONE$1);
  return r;
}, simplify: function(e2) {
  const t2 = BigInt(1 / (e2 || 1e-3) | 0), r = this.abs(), n = r.toContinued();
  for (let e3 = 1; e3 < n.length; e3++) {
    let i2 = newFraction$1(n[e3 - 1], C_ONE$1);
    for (let t3 = e3 - 2; t3 >= 0; t3--) i2 = i2.inverse().add(n[t3]);
    let a = i2.sub(r);
    if (a.n * t2 < a.d) return i2.mul(this.s);
  }
  return this;
} };
var name$4Y$1 = "Fraction", dependencies$4Y$1 = [], createFractionClass$1 = factory$1(name$4Y$1, dependencies$4Y$1, (() => (Object.defineProperty(Fraction$1, "name", { value: "Fraction" }), Fraction$1.prototype.constructor = Fraction$1, Fraction$1.prototype.type = "Fraction", Fraction$1.prototype.isFraction = true, Fraction$1.prototype.toJSON = function() {
  return { mathjs: "Fraction", n: String(this.s * this.n), d: String(this.d) };
}, Fraction$1.fromJSON = function(e2) {
  return new Fraction$1(e2);
}, Fraction$1)), { isClass: true }), name$4X$1 = "Range", dependencies$4X$1 = [], createRangeClass$1 = factory$1(name$4X$1, dependencies$4X$1, (() => {
  function e2(t2, r, n) {
    if (!(this instanceof e2)) throw new SyntaxError("Constructor must be called with the new operator");
    var i2 = null != t2, a = null != r, o = null != n;
    if (i2) {
      if (isBigNumber$1(t2)) t2 = t2.toNumber();
      else if ("number" != typeof t2 && !isBigInt$1(t2)) throw new TypeError("Parameter start must be a number or bigint");
    }
    if (a) {
      if (isBigNumber$1(r)) r = r.toNumber();
      else if ("number" != typeof r && !isBigInt$1(r)) throw new TypeError("Parameter end must be a number or bigint");
    }
    if (o) {
      if (isBigNumber$1(n)) n = n.toNumber();
      else if ("number" != typeof n && !isBigInt$1(n)) throw new TypeError("Parameter step must be a number or bigint");
    }
    if (this.start = i2 ? parseFloat(t2) : 0, this.end = a ? parseFloat(r) : 0, this.step = o ? parseFloat(n) : 1, o && nearlyEqual$1$1(this.step, 0)) throw new Error("Step must not be zero");
  }
  return e2.prototype.type = "Range", e2.prototype.isRange = true, e2.parse = function(t2) {
    if ("string" != typeof t2) return null;
    var r = t2.split(":").map((function(e3) {
      return parseFloat(e3);
    }));
    if (r.some((function(e3) {
      return isNaN(e3);
    }))) return null;
    switch (r.length) {
      case 2:
        return new e2(r[0], r[1]);
      case 3:
        return new e2(r[0], r[2], r[1]);
      default:
        return null;
    }
  }, e2.prototype.clone = function() {
    return new e2(this.start, this.end, this.step);
  }, e2.prototype.size = function() {
    var e3 = 0, t2 = this.start, r = this.step, n = this.end - t2;
    return sign$2$1(r) === sign$2$1(n) ? e3 = Math.ceil(n / r) : 0 === n && (e3 = 0), isNaN(e3) && (e3 = 0), [e3];
  }, e2.prototype.min = function() {
    var e3 = this.size()[0];
    return e3 > 0 ? this.step > 0 ? this.start : this.start + (e3 - 1) * this.step : void 0;
  }, e2.prototype.max = function() {
    var e3 = this.size()[0];
    return e3 > 0 ? this.step > 0 ? this.start + (e3 - 1) * this.step : this.start : void 0;
  }, e2.prototype.forEach = function(e3) {
    var t2 = this.start, r = this.step, n = this.end, i2 = 0;
    if (r > 0) for (; t2 < n; ) e3(t2, [i2], this), t2 += r, i2++;
    else if (r < 0) for (; t2 > n; ) e3(t2, [i2], this), t2 += r, i2++;
  }, e2.prototype.map = function(e3) {
    var t2 = [];
    return this.forEach((function(r, n, i2) {
      t2[n[0]] = e3(r, n, i2);
    })), t2;
  }, e2.prototype.toArray = function() {
    var e3 = [];
    return this.forEach((function(t2, r) {
      e3[r[0]] = t2;
    })), e3;
  }, e2.prototype.valueOf = function() {
    return this.toArray();
  }, e2.prototype.format = function(e3) {
    var t2 = format$2$1(this.start, e3);
    return 1 !== this.step && (t2 += ":" + format$2$1(this.step, e3)), t2 += ":" + format$2$1(this.end, e3);
  }, e2.prototype.toString = function() {
    return this.format();
  }, e2.prototype.toJSON = function() {
    return { mathjs: "Range", start: this.start, end: this.end, step: this.step };
  }, e2.fromJSON = function(t2) {
    return new e2(t2.start, t2.end, t2.step);
  }, e2;
}), { isClass: true }), name$4W$1 = "Matrix", dependencies$4W$1 = [], createMatrixClass$1 = factory$1(name$4W$1, dependencies$4W$1, (() => {
  function e2() {
    if (!(this instanceof e2)) throw new SyntaxError("Constructor must be called with the new operator");
  }
  return e2.prototype.type = "Matrix", e2.prototype.isMatrix = true, e2.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, e2.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, e2.prototype.create = function(e3, t2) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, e2.prototype.subset = function(e3, t2, r) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, e2.prototype.get = function(e3) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, e2.prototype.set = function(e3, t2, r) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, e2.prototype.resize = function(e3, t2) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, e2.prototype.reshape = function(e3, t2) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, e2.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, e2.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, e2.prototype.map = function(e3, t2) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, e2.prototype.forEach = function(e3) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, e2.prototype[Symbol.iterator] = function() {
    throw new Error("Cannot iterate a Matrix interface");
  }, e2.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, e2.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, e2.prototype.format = function(e3) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, e2.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, e2;
}), { isClass: true });
function formatBigNumberToBase$1(e2, t2, r) {
  var n = new e2.constructor(2), i2 = "";
  if (r) {
    if (r < 1) throw new Error("size must be in greater than 0");
    if (!isInteger$1(r)) throw new Error("size must be an integer");
    if (e2.greaterThan(n.pow(r - 1).sub(1)) || e2.lessThan(n.pow(r - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
    if (!e2.isInteger()) throw new Error("Value must be an integer");
    e2.lessThan(0) && (e2 = e2.add(n.pow(r))), i2 = "i".concat(r);
  }
  switch (t2) {
    case 2:
      return "".concat(e2.toBinary()).concat(i2);
    case 8:
      return "".concat(e2.toOctal()).concat(i2);
    case 16:
      return "".concat(e2.toHexadecimal()).concat(i2);
    default:
      throw new Error("Base ".concat(t2, " not supported "));
  }
}
function format$1$1(e2, t2) {
  if ("function" == typeof t2) return t2(e2);
  if (!e2.isFinite()) return e2.isNaN() ? "NaN" : e2.gt(0) ? "Infinity" : "-Infinity";
  var { notation: r, precision: n, wordSize: i2 } = normalizeFormatOptions$1(t2);
  switch (r) {
    case "fixed":
      return toFixed$1$1(e2, n);
    case "exponential":
      return toExponential$2(e2, n);
    case "engineering":
      return toEngineering$2(e2, n);
    case "bin":
      return formatBigNumberToBase$1(e2, 2, i2);
    case "oct":
      return formatBigNumberToBase$1(e2, 8, i2);
    case "hex":
      return formatBigNumberToBase$1(e2, 16, i2);
    case "auto":
      var a = _toNumberOrDefault$2(null == t2 ? void 0 : t2.lowerExp, -3), o = _toNumberOrDefault$2(null == t2 ? void 0 : t2.upperExp, 5);
      if (e2.isZero()) return "0";
      var s = e2.toSignificantDigits(n), u = s.e;
      return (u >= a && u < o ? s.toFixed() : toExponential$2(e2, n)).replace(/((\.\d*?)(0+))($|e)/, (function() {
        var e3 = arguments[2], t3 = arguments[4];
        return "." !== e3 ? e3 + t3 : t3;
      }));
    default:
      throw new Error('Unknown notation "' + r + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function toEngineering$2(e2, t2) {
  var r = e2.e, n = r % 3 == 0 ? r : r < 0 ? r - 3 - r % 3 : r - r % 3, i2 = e2.mul(Math.pow(10, -n)).toPrecision(t2);
  i2.includes("e") && (i2 = new e2.constructor(i2).toFixed());
  return i2 + "e" + (r >= 0 ? "+" : "") + n.toString();
}
function toExponential$2(e2, t2) {
  return void 0 !== t2 ? e2.toExponential(t2 - 1) : e2.toExponential();
}
function toFixed$1$1(e2, t2) {
  return e2.toFixed(t2);
}
function _toNumberOrDefault$2(e2, t2) {
  return isNumber$1$1(e2) ? e2 : isBigNumber$1(e2) ? e2.toNumber() : t2;
}
function endsWith$1(e2, t2) {
  var r = e2.length - t2.length, n = e2.length;
  return e2.substring(r, n) === t2;
}
function format$3(e2, t2) {
  var r = _format$1(e2, t2);
  return t2 && "object" == typeof t2 && "truncate" in t2 && r.length > t2.truncate ? r.substring(0, t2.truncate - 3) + "..." : r;
}
function _format$1(e2, t2) {
  return "number" == typeof e2 ? format$2$1(e2, t2) : isBigNumber$1(e2) ? format$1$1(e2, t2) : looksLikeFraction$1(e2) ? t2 && "decimal" === t2.fraction ? e2.toString() : "".concat(e2.s * e2.n, "/").concat(e2.d) : Array.isArray(e2) ? formatArray$1(e2, t2) : isString$1$1(e2) ? stringify$1(e2) : "function" == typeof e2 ? e2.syntax ? String(e2.syntax) : "function" : e2 && "object" == typeof e2 ? "function" == typeof e2.format ? e2.format(t2) : e2 && e2.toString(t2) !== {}.toString() ? e2.toString(t2) : "{" + Object.keys(e2).map(((r) => stringify$1(r) + ": " + format$3(e2[r], t2))).join(", ") + "}" : String(e2);
}
function stringify$1(e2) {
  for (var t2 = String(e2), r = "", n = 0; n < t2.length; ) {
    var i2 = t2.charAt(n);
    r += i2 in controlCharacters$1 ? controlCharacters$1[i2] : i2, n++;
  }
  return '"' + r + '"';
}
var controlCharacters$1 = { '"': '\\"', "\\": "\\\\", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t" };
function escape$1$1(e2) {
  var t2 = String(e2);
  return t2 = t2.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function formatArray$1(e2, t2) {
  if (Array.isArray(e2)) {
    for (var r = "[", n = e2.length, i2 = 0; i2 < n; i2++) 0 !== i2 && (r += ", "), r += formatArray$1(e2[i2], t2);
    return r += "]";
  }
  return format$3(e2, t2);
}
function looksLikeFraction$1(e2) {
  return e2 && "object" == typeof e2 && "bigint" == typeof e2.s && "bigint" == typeof e2.n && "bigint" == typeof e2.d || false;
}
function compareText$1(e2, t2) {
  if (!isString$1$1(e2)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + typeOf$1(e2) + ", index: 0)");
  if (!isString$1$1(t2)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + typeOf$1(t2) + ", index: 1)");
  return e2 === t2 ? 0 : e2 > t2 ? 1 : -1;
}
function DimensionError$1(e2, t2, r) {
  if (!(this instanceof DimensionError$1)) throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = e2, this.expected = t2, this.relation = r, this.message = "Dimension mismatch (" + (Array.isArray(e2) ? "[" + e2.join(", ") + "]" : e2) + " " + (this.relation || "!=") + " " + (Array.isArray(t2) ? "[" + t2.join(", ") + "]" : t2) + ")", this.stack = new Error().stack;
}
function IndexError$1(e2, t2, r) {
  if (!(this instanceof IndexError$1)) throw new SyntaxError("Constructor must be called with the new operator");
  this.index = e2, arguments.length < 3 ? (this.min = 0, this.max = t2) : (this.min = t2, this.max = r), void 0 !== this.min && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : void 0 !== this.max && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
function arraySize$1(e2) {
  for (var t2 = []; Array.isArray(e2); ) t2.push(e2.length), e2 = e2[0];
  return t2;
}
function _validate$1(e2, t2, r) {
  var n, i2 = e2.length;
  if (i2 !== t2[r]) throw new DimensionError$1(i2, t2[r]);
  if (r < t2.length - 1) {
    var a = r + 1;
    for (n = 0; n < i2; n++) {
      var o = e2[n];
      if (!Array.isArray(o)) throw new DimensionError$1(t2.length - 1, t2.length, "<");
      _validate$1(e2[n], t2, a);
    }
  } else for (n = 0; n < i2; n++) if (Array.isArray(e2[n])) throw new DimensionError$1(t2.length + 1, t2.length, ">");
}
function validate$1(e2, t2) {
  if (0 === t2.length) {
    if (Array.isArray(e2)) throw new DimensionError$1(e2.length, 0);
  } else _validate$1(e2, t2, 0);
}
function validateIndexSourceSize$1(e2, t2) {
  var r = e2.isMatrix ? e2._size : arraySize$1(e2);
  t2._sourceSize.forEach(((e3, t3) => {
    if (null !== e3 && e3 !== r[t3]) throw new DimensionError$1(e3, r[t3]);
  }));
}
function validateIndex$1(e2, t2) {
  if (void 0 !== e2) {
    if (!isNumber$1$1(e2) || !isInteger$1(e2)) throw new TypeError("Index must be an integer (value: " + e2 + ")");
    if (e2 < 0 || "number" == typeof t2 && e2 >= t2) throw new IndexError$1(e2, t2);
  }
}
function isEmptyIndex$1(e2) {
  for (var t2 = 0; t2 < e2._dimensions.length; ++t2) {
    var r = e2._dimensions[t2];
    if (r._data && isArray$1$1(r._data)) {
      if (0 === r._size[0]) return true;
    } else if (r.isRange) {
      if (r.start === r.end) return true;
    } else if (isString$1$1(r) && 0 === r.length) return true;
  }
  return false;
}
function resize$1(e2, t2, r) {
  if (!Array.isArray(t2)) throw new TypeError("Array expected");
  if (0 === t2.length) throw new Error("Resizing to scalar is not supported");
  return t2.forEach((function(e3) {
    if (!isNumber$1$1(e3) || !isInteger$1(e3) || e3 < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + format$3(t2) + ")");
  })), (isNumber$1$1(e2) || isBigNumber$1(e2)) && (e2 = [e2]), _resize$1(e2, t2, 0, void 0 !== r ? r : 0), e2;
}
function _resize$1(e2, t2, r, n) {
  var i2, a, o = e2.length, s = t2[r], u = Math.min(o, s);
  if (e2.length = s, r < t2.length - 1) {
    var c2 = r + 1;
    for (i2 = 0; i2 < u; i2++) a = e2[i2], Array.isArray(a) || (a = [a], e2[i2] = a), _resize$1(a, t2, c2, n);
    for (i2 = u; i2 < s; i2++) a = [], e2[i2] = a, _resize$1(a, t2, c2, n);
  } else {
    for (i2 = 0; i2 < u; i2++) for (; Array.isArray(e2[i2]); ) e2[i2] = e2[i2][0];
    for (i2 = u; i2 < s; i2++) e2[i2] = n;
  }
}
function reshape$1(e2, t2) {
  var r = flatten$4$1(e2, true), n = r.length;
  if (!Array.isArray(e2) || !Array.isArray(t2)) throw new TypeError("Array expected");
  if (0 === t2.length) throw new DimensionError$1(0, n, "!=");
  var i2 = product$1$1(t2 = processSizesWildcard$1(t2, n));
  if (n !== i2) throw new DimensionError$1(i2, n, "!=");
  try {
    return _reshape$1(r, t2);
  } catch (e3) {
    if (e3 instanceof DimensionError$1) throw new DimensionError$1(i2, n, "!=");
    throw e3;
  }
}
function processSizesWildcard$1(e2, t2) {
  var r = product$1$1(e2), n = e2.slice(), i2 = e2.indexOf(-1);
  if (e2.indexOf(-1, i2 + 1) >= 0) throw new Error("More than one wildcard in sizes");
  if (i2 >= 0) {
    if (!(t2 % r == 0)) throw new Error("Could not replace wildcard, since " + t2 + " is no multiple of " + -r);
    n[i2] = -t2 / r;
  }
  return n;
}
function product$1$1(e2) {
  return e2.reduce(((e3, t2) => e3 * t2), 1);
}
function _reshape$1(e2, t2) {
  for (var r, n = e2, i2 = t2.length - 1; i2 > 0; i2--) {
    var a = t2[i2];
    r = [];
    for (var o = n.length / a, s = 0; s < o; s++) r.push(n.slice(s * a, (s + 1) * a));
    n = r;
  }
  return n;
}
function squeeze$1(e2, t2) {
  for (var r = arraySize$1(e2); Array.isArray(e2) && 1 === e2.length; ) e2 = e2[0], r.shift();
  for (var n = r.length; 1 === r[n - 1]; ) n--;
  return n < r.length && (e2 = _squeeze$1(e2, n, 0), r.length = n), e2;
}
function _squeeze$1(e2, t2, r) {
  var n, i2;
  if (r < t2) {
    var a = r + 1;
    for (n = 0, i2 = e2.length; n < i2; n++) e2[n] = _squeeze$1(e2[n], t2, a);
  } else for (; Array.isArray(e2); ) e2 = e2[0];
  return e2;
}
function unsqueeze$1(e2, t2, r, n) {
  var i2 = n || arraySize$1(e2);
  if (r) for (var a = 0; a < r; a++) e2 = [e2], i2.unshift(1);
  for (e2 = _unsqueeze$1(e2, t2, 0); i2.length < t2; ) i2.push(1);
  return e2;
}
function _unsqueeze$1(e2, t2, r) {
  var n, i2;
  if (Array.isArray(e2)) {
    var a = r + 1;
    for (n = 0, i2 = e2.length; n < i2; n++) e2[n] = _unsqueeze$1(e2[n], t2, a);
  } else for (var o = r; o < t2; o++) e2 = [e2];
  return e2;
}
function flatten$4$1(e2) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  if (!Array.isArray(e2)) return e2;
  if ("boolean" != typeof t2) throw new TypeError("Boolean expected for second argument of flatten");
  var r = [];
  return t2 ? (function e3(t3) {
    if (Array.isArray(t3[0])) for (var n = 0; n < t3.length; n++) e3(t3[n]);
    else for (var i2 = 0; i2 < t3.length; i2++) r.push(t3[i2]);
  })(e2) : (function e3(t3) {
    for (var n = 0; n < t3.length; n++) {
      var i2 = t3[n];
      Array.isArray(i2) ? e3(i2) : r.push(i2);
    }
  })(e2), r;
}
function map$1$1(e2, t2) {
  return Array.prototype.map.call(e2, t2);
}
function forEach$1(e2, t2) {
  Array.prototype.forEach.call(e2, t2);
}
function filter$1$1(e2, t2) {
  if (1 !== arraySize$1(e2).length) throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(e2, t2);
}
function filterRegExp$1(e2, t2) {
  if (1 !== arraySize$1(e2).length) throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(e2, ((e3) => t2.test(e3)));
}
function join$5(e2, t2) {
  return Array.prototype.join.call(e2, t2);
}
function identify$1(e2) {
  if (!Array.isArray(e2)) throw new TypeError("Array input expected");
  if (0 === e2.length) return e2;
  var t2 = [], r = 0;
  t2[0] = { value: e2[0], identifier: 0 };
  for (var n = 1; n < e2.length; n++) e2[n] === e2[n - 1] ? r++ : r = 0, t2.push({ value: e2[n], identifier: r });
  return t2;
}
function generalize$1(e2) {
  if (!Array.isArray(e2)) throw new TypeError("Array input expected");
  if (0 === e2.length) return e2;
  for (var t2 = [], r = 0; r < e2.length; r++) t2.push(e2[r].value);
  return t2;
}
function getArrayDataType$1(e2, t2) {
  for (var r, n = 0, i2 = 0; i2 < e2.length; i2++) {
    var a = e2[i2], o = Array.isArray(a);
    if (0 === i2 && o && (n = a.length), o && a.length !== n) return;
    var s = o ? getArrayDataType$1(a, t2) : t2(a);
    if (void 0 === r) r = s;
    else if (r !== s) return "mixed";
  }
  return r;
}
function concatRecursive$1(e2, t2, r, n) {
  if (n < r) {
    if (e2.length !== t2.length) throw new DimensionError$1(e2.length, t2.length);
    for (var i2 = [], a = 0; a < e2.length; a++) i2[a] = concatRecursive$1(e2[a], t2[a], r, n + 1);
    return i2;
  }
  return e2.concat(t2);
}
function concat$1() {
  var e2 = Array.prototype.slice.call(arguments, 0, -1), t2 = Array.prototype.slice.call(arguments, -1);
  if (1 === e2.length) return e2[0];
  if (e2.length > 1) return e2.slice(1).reduce((function(e3, r) {
    return concatRecursive$1(e3, r, t2, 0);
  }), e2[0]);
  throw new Error("Wrong number of arguments in function concat");
}
function broadcastSizes$1() {
  for (var e2 = arguments.length, t2 = new Array(e2), r = 0; r < e2; r++) t2[r] = arguments[r];
  for (var n = t2.map(((e3) => e3.length)), i2 = Math.max(...n), a = new Array(i2).fill(null), o = 0; o < t2.length; o++) for (var s = t2[o], u = n[o], c2 = 0; c2 < u; c2++) {
    var l = i2 - u + c2;
    s[c2] > a[l] && (a[l] = s[c2]);
  }
  for (var f2 = 0; f2 < t2.length; f2++) checkBroadcastingRules$1(t2[f2], a);
  return a;
}
function checkBroadcastingRules$1(e2, t2) {
  for (var r = t2.length, n = e2.length, i2 = 0; i2 < n; i2++) {
    var a = r - n + i2;
    if (e2[i2] < t2[a] && e2[i2] > 1 || e2[i2] > t2[a]) throw new Error("shape mismatch: mismatch is found in arg with shape (".concat(e2, ") not possible to broadcast dimension ").concat(n, " with size ").concat(e2[i2], " to size ").concat(t2[a]));
  }
}
function broadcastTo$1(e2, t2) {
  var r = arraySize$1(e2);
  if (deepStrictEqual$1(r, t2)) return e2;
  checkBroadcastingRules$1(r, t2);
  var n = broadcastSizes$1(r, t2), i2 = n.length, a = [...Array(i2 - r.length).fill(1), ...r], o = clone$1$1(e2);
  r.length < i2 && (r = arraySize$1(o = reshape$1(o, a)));
  for (var s = 0; s < i2; s++) r[s] < n[s] && (r = arraySize$1(o = stretch$1(o, n[s], s)));
  return o;
}
function stretch$1(e2, t2, r) {
  return concat$1(...Array(t2).fill(e2), r);
}
function get$1$1(e2, t2) {
  if (!Array.isArray(e2)) throw new Error("Array expected");
  var r = arraySize$1(e2);
  if (t2.length !== r.length) throw new DimensionError$1(t2.length, r.length);
  for (var n = 0; n < t2.length; n++) validateIndex$1(t2[n], r[n]);
  return t2.reduce(((e3, t3) => e3[t3]), e2);
}
function deepMap$1$1(e2, t2) {
  var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
  if (0 === e2.length) return [];
  if (r) return (function e3(r2) {
    if (Array.isArray(r2)) {
      for (var n3 = r2.length, i2 = Array(n3), a = 0; a < n3; a++) i2[a] = e3(r2[a]);
      return i2;
    }
    return t2(r2);
  })(e2);
  var n = [];
  return (function r2(i2, a) {
    if (Array.isArray(i2)) {
      for (var o = i2.length, s = Array(o), u = 0; u < o; u++) n[a] = u, s[u] = r2(i2[u], a + 1);
      return s;
    }
    return t2(i2, n.slice(0, a), e2);
  })(e2, 0);
}
function deepForEach$1$1(e2, t2) {
  var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
  if (0 !== e2.length) if (r) (function e3(r2) {
    if (Array.isArray(r2)) for (var n3 = r2.length, i2 = 0; i2 < n3; i2++) e3(r2[i2]);
    else t2(r2);
  })(e2);
  else {
    var n = [];
    !(function r2(i2, a) {
      if (Array.isArray(i2)) for (var o = i2.length, s = 0; s < o; s++) n[a] = s, r2(i2[s], a + 1);
      else t2(i2, n.slice(0, a), e2);
    })(e2, 0);
  }
}
function clone$1$1(e2) {
  return _extends$4([], e2);
}
function optimizeCallback$1(e2, t2, r, n) {
  if (typedFunction$1.isTypedFunction(e2)) {
    var i2, a;
    if (n) i2 = 1;
    else {
      var o = t2.isMatrix ? t2.size() : arraySize$1(t2);
      if (!o.length || 0 === o[o.length - 1]) return { isUnary: n, fn: e2 };
      var s = o.map((() => 0)), u = t2.isMatrix ? t2.get(s) : get$1$1(t2, s);
      i2 = _findNumberOfArgumentsTyped$1(e2, u, s, t2);
    }
    if (t2.isMatrix && "mixed" !== t2.dataType && void 0 !== t2.dataType) {
      var c2 = _findSingleSignatureWithArity$1(e2, i2);
      a = void 0 !== c2 ? c2 : e2;
    } else a = e2;
    return i2 >= 1 && i2 <= 3 ? { isUnary: 1 === i2, fn: function() {
      for (var t3 = arguments.length, n3 = new Array(t3), o2 = 0; o2 < t3; o2++) n3[o2] = arguments[o2];
      return _tryFunctionWithArgs$1(a, n3.slice(0, i2), r, e2.name);
    } } : { isUnary: false, fn: function() {
      for (var t3 = arguments.length, n3 = new Array(t3), i3 = 0; i3 < t3; i3++) n3[i3] = arguments[i3];
      return _tryFunctionWithArgs$1(a, n3, r, e2.name);
    } };
  }
  return void 0 === n ? { isUnary: _findIfCallbackIsUnary$1(e2), fn: e2 } : { isUnary: n, fn: e2 };
}
function _findSingleSignatureWithArity$1(e2, t2) {
  var r = [];
  if (Object.entries(e2.signatures).forEach(((e3) => {
    var [n, i2] = e3;
    n.split(",").length === t2 && r.push(i2);
  })), 1 === r.length) return r[0];
}
function _findIfCallbackIsUnary$1(e2) {
  if (1 !== e2.length) return false;
  var t2 = e2.toString();
  if (/arguments/.test(t2)) return false;
  var r = t2.match(/\(.*?\)/);
  return !/\.\.\./.test(r);
}
function _findNumberOfArgumentsTyped$1(e2, t2, r, n) {
  for (var i2 = [t2, r, n], a = 3; a > 0; a--) {
    var o = i2.slice(0, a);
    if (null !== typedFunction$1.resolve(e2, o)) return a;
  }
}
function _tryFunctionWithArgs$1(e2, t2, r, n) {
  try {
    return e2(...t2);
  } catch (e3) {
    _createCallbackError$1(e3, t2, r, n);
  }
}
function _createCallbackError$1(e2, t2, r, n) {
  var i2;
  if (e2 instanceof TypeError && "wrongType" === (null === (i2 = e2.data) || void 0 === i2 ? void 0 : i2.category)) {
    var a = [];
    throw a.push("value: ".concat(typeOf$1(t2[0]))), t2.length >= 2 && a.push("index: ".concat(typeOf$1(t2[1]))), t2.length >= 3 && a.push("array: ".concat(typeOf$1(t2[2]))), new TypeError("Function ".concat(r, " cannot apply callback arguments ") + "".concat(n, "(").concat(a.join(", "), ") at index ").concat(JSON.stringify(t2[1])));
  }
  throw new TypeError("Function ".concat(r, " cannot apply callback arguments ") + "to function ".concat(n, ": ").concat(e2.message));
}
DimensionError$1.prototype = new RangeError(), DimensionError$1.prototype.constructor = RangeError, DimensionError$1.prototype.name = "DimensionError", DimensionError$1.prototype.isDimensionError = true, IndexError$1.prototype = new RangeError(), IndexError$1.prototype.constructor = RangeError, IndexError$1.prototype.name = "IndexError", IndexError$1.prototype.isIndexError = true;
var name$4V$1 = "DenseMatrix", dependencies$4V$1 = ["Matrix", "config"], createDenseMatrixClass$1 = factory$1(name$4V$1, dependencies$4V$1, ((e2) => {
  var { Matrix: t2, config: r } = e2;
  function n(e3, t3) {
    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
    if (t3 && !isString$1$1(t3)) throw new Error("Invalid datatype: " + t3);
    if (isMatrix$1(e3)) "DenseMatrix" === e3.type ? (this._data = clone$3$1(e3._data), this._size = clone$3$1(e3._size), this._datatype = t3 || e3._datatype) : (this._data = e3.toArray(), this._size = e3.size(), this._datatype = t3 || e3._datatype);
    else if (e3 && isArray$1$1(e3.data) && isArray$1$1(e3.size)) this._data = e3.data, this._size = e3.size, validate$1(this._data, this._size), this._datatype = t3 || e3.datatype;
    else if (isArray$1$1(e3)) this._data = o(e3), this._size = arraySize$1(this._data), validate$1(this._data, this._size), this._datatype = t3;
    else {
      if (e3) throw new TypeError("Unsupported type of data (" + typeOf$1(e3) + ")");
      this._data = [], this._size = [0], this._datatype = t3;
    }
  }
  function i2(e3, t3, r2) {
    if (0 === t3.length) {
      for (var n3 = e3._data; isArray$1$1(n3); ) n3 = n3[0];
      return n3;
    }
    return e3._size = t3.slice(0), e3._data = resize$1(e3._data, e3._size, r2), e3;
  }
  function a(e3, t3, r2) {
    for (var n3 = e3._size.slice(0), a2 = false; n3.length < t3.length; ) n3.push(0), a2 = true;
    for (var o2 = 0, s = t3.length; o2 < s; o2++) t3[o2] > n3[o2] && (n3[o2] = t3[o2], a2 = true);
    a2 && i2(e3, n3, r2);
  }
  function o(e3) {
    return isMatrix$1(e3) ? o(e3.valueOf()) : isArray$1$1(e3) ? e3.map(o) : e3;
  }
  return n.prototype = new t2(), n.prototype.createDenseMatrix = function(e3, t3) {
    return new n(e3, t3);
  }, Object.defineProperty(n, "name", { value: "DenseMatrix" }), n.prototype.constructor = n, n.prototype.type = "DenseMatrix", n.prototype.isDenseMatrix = true, n.prototype.getDataType = function() {
    return getArrayDataType$1(this._data, typeOf$1);
  }, n.prototype.storage = function() {
    return "dense";
  }, n.prototype.datatype = function() {
    return this._datatype;
  }, n.prototype.create = function(e3, t3) {
    return new n(e3, t3);
  }, n.prototype.subset = function(e3, t3, i3) {
    switch (arguments.length) {
      case 1:
        return (function(e4, t4) {
          if (!isIndex$1(t4)) throw new TypeError("Invalid index");
          var i4 = r.legacySubset ? t4.size().every(((e5) => 1 === e5)) : t4.isScalar();
          if (i4) return e4.get(t4.min());
          var a2 = t4.size();
          if (a2.length !== e4._size.length) throw new DimensionError$1(a2.length, e4._size.length);
          for (var o2 = t4.min(), s = t4.max(), u = 0, c2 = e4._size.length; u < c2; u++) validateIndex$1(o2[u], e4._size[u]), validateIndex$1(s[u], e4._size[u]);
          var l = new n(), f2 = (function(e5, t5) {
            var r2 = t5.size().length - 1, n3 = Array(r2);
            return { data: i5(e5), size: n3.filter(((e6) => null !== e6)) };
            function i5(e6) {
              var a3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, o3 = t5.dimension(a3);
              function s2(e7, t6) {
                return isNumber$1$1(e7) ? t6(e7) : e7.map(t6).valueOf();
              }
              return isNumber$1$1(o3) ? n3[a3] = null : n3[a3] = o3.size()[0], s2(o3, a3 < r2 ? (t6) => (validateIndex$1(t6, e6.length), i5(e6[t6], a3 + 1)) : (t6) => (validateIndex$1(t6, e6.length), e6[t6]));
            }
          })(e4._data, t4);
          return l._size = f2.size, l._datatype = e4._datatype, l._data = f2.data, r.legacySubset ? l.reshape(t4.size()) : l;
        })(this, e3);
      case 2:
      case 3:
        return (function(e4, t4, r2, n3) {
          if (!t4 || true !== t4.isIndex) throw new TypeError("Invalid index");
          var i4, o2 = t4.size(), s = t4.isScalar();
          isMatrix$1(r2) ? (i4 = r2.size(), r2 = r2.valueOf()) : i4 = arraySize$1(r2);
          if (s) {
            if (0 !== i4.length) throw new TypeError("Scalar expected");
            e4.set(t4.min(), r2, n3);
          } else {
            if (!deepStrictEqual$1(i4, o2)) {
              if (0 === i4.length) r2 = broadcastTo$1([r2], o2);
              else try {
                r2 = broadcastTo$1(r2, o2);
              } catch (e5) {
              }
              i4 = arraySize$1(r2);
            }
            if (o2.length < e4._size.length) throw new DimensionError$1(o2.length, e4._size.length, "<");
            if (i4.length < o2.length) {
              for (var u = 0, c2 = 0; 1 === o2[u] && 1 === i4[u]; ) u++;
              for (; 1 === o2[u]; ) c2++, u++;
              r2 = unsqueeze$1(r2, o2.length, c2, i4);
            }
            if (!deepStrictEqual$1(o2, i4)) throw new DimensionError$1(o2, i4, ">");
            var l = t4.max().map((function(e5) {
              return e5 + 1;
            }));
            a(e4, l, n3), (function(e5, t5, r3) {
              var n4 = t5.size().length - 1;
              function i5(e6, r4) {
                var a2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, o3 = t5.dimension(a2), s2 = (t6, n5) => {
                  validateIndex$1(t6, e6.length), i5(e6[t6], r4[n5[0]], a2 + 1);
                }, u2 = (t6, n5) => {
                  validateIndex$1(t6, e6.length), e6[t6] = r4[n5[0]];
                };
                a2 < n4 ? isNumber$1$1(o3) ? s2(o3, [0]) : o3.forEach(s2) : isNumber$1$1(o3) ? u2(o3, [0]) : o3.forEach(u2);
              }
              i5(e5, r3);
            })(e4._data, t4, r2);
          }
          return e4;
        })(this, e3, t3, i3);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.get = function(e3) {
    return get$1$1(this._data, e3);
  }, n.prototype.set = function(e3, t3, r2) {
    if (!isArray$1$1(e3)) throw new TypeError("Array expected");
    if (e3.length < this._size.length) throw new DimensionError$1(e3.length, this._size.length, "<");
    var n3, i3, o2, s = e3.map((function(e4) {
      return e4 + 1;
    }));
    a(this, s, r2);
    var u = this._data;
    for (n3 = 0, i3 = e3.length - 1; n3 < i3; n3++) validateIndex$1(o2 = e3[n3], u.length), u = u[o2];
    return validateIndex$1(o2 = e3[e3.length - 1], u.length), u[o2] = t3, this;
  }, n.prototype.resize = function(e3, t3, r2) {
    if (!isCollection$1(e3)) throw new TypeError("Array or Matrix expected");
    var n3 = e3.valueOf().map(((e4) => Array.isArray(e4) && 1 === e4.length ? e4[0] : e4));
    return i2(r2 ? this.clone() : this, n3, t3);
  }, n.prototype.reshape = function(e3, t3) {
    var r2 = t3 ? this.clone() : this;
    r2._data = reshape$1(r2._data, e3);
    var n3 = r2._size.reduce(((e4, t4) => e4 * t4));
    return r2._size = processSizesWildcard$1(e3, n3), r2;
  }, n.prototype.clone = function() {
    return new n({ data: clone$3$1(this._data), size: clone$3$1(this._size), datatype: this._datatype });
  }, n.prototype.size = function() {
    return this._size.slice(0);
  }, n.prototype.map = function(e3) {
    var t3 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r2 = this, n3 = r2._size.length - 1;
    if (n3 < 0) return r2.clone();
    var i3 = optimizeCallback$1(e3, r2, "map", t3), a2 = i3.fn, o2 = r2.create(void 0, r2._datatype);
    if (o2._size = r2._size, t3 || i3.isUnary) return o2._data = (function e4(t4) {
      var r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i4 = Array(t4.length);
      if (r3 < n3) for (var o3 = 0; o3 < t4.length; o3++) i4[o3] = e4(t4[o3], r3 + 1);
      else for (var s2 = 0; s2 < t4.length; s2++) i4[s2] = a2(t4[s2]);
      return i4;
    })(r2._data), o2;
    if (0 === n3) {
      for (var s = r2.valueOf(), u = Array(s.length), c2 = 0; c2 < s.length; c2++) u[c2] = a2(s[c2], [c2], r2);
      return o2._data = u, o2;
    }
    var l = [];
    return o2._data = (function e4(t4) {
      var i4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, o3 = Array(t4.length);
      if (i4 < n3) for (var s2 = 0; s2 < t4.length; s2++) l[i4] = s2, o3[s2] = e4(t4[s2], i4 + 1);
      else for (var u2 = 0; u2 < t4.length; u2++) l[i4] = u2, o3[u2] = a2(t4[u2], l.slice(), r2);
      return o3;
    })(r2._data), o2;
  }, n.prototype.forEach = function(e3) {
    var t3 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r2 = this, n3 = r2._size.length - 1;
    if (!(n3 < 0)) {
      var i3 = optimizeCallback$1(e3, r2, "map", t3), a2 = i3.fn;
      if (t3 || i3.isUnary) (function e4(t4) {
        var r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (r3 < n3) for (var i4 = 0; i4 < t4.length; i4++) e4(t4[i4], r3 + 1);
        else for (var o3 = 0; o3 < t4.length; o3++) a2(t4[o3]);
      })(r2._data);
      else if (0 !== n3) {
        var o2 = [];
        !(function e4(t4) {
          var i4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          if (i4 < n3) for (var s2 = 0; s2 < t4.length; s2++) o2[i4] = s2, e4(t4[s2], i4 + 1);
          else for (var u = 0; u < t4.length; u++) o2[i4] = u, a2(t4[u], o2.slice(), r2);
        })(r2._data);
      } else for (var s = 0; s < r2._data.length; s++) a2(r2._data[s], [s], r2);
    }
  }, n.prototype[Symbol.iterator] = function* () {
    var e3 = this._size.length - 1;
    if (!(e3 < 0)) if (0 !== e3) for (var t3 = Array(e3 + 1).fill(0), r2 = this._size.reduce(((e4, t4) => e4 * t4), 1), n3 = 0; n3 < r2; n3++) {
      for (var i3 = this._data, a2 = 0; a2 < e3; a2++) i3 = i3[t3[a2]];
      yield { value: i3[t3[e3]], index: t3.slice() };
      for (var o2 = e3; o2 >= 0 && (t3[o2]++, !(t3[o2] < this._size[o2])); o2--) t3[o2] = 0;
    }
    else for (var s = 0; s < this._data.length; s++) yield { value: this._data[s], index: [s] };
  }, n.prototype.rows = function() {
    var e3 = [];
    if (2 !== this.size().length) throw new TypeError("Rows can only be returned for a 2D matrix.");
    var t3 = this._data;
    for (var r2 of t3) e3.push(new n([r2], this._datatype));
    return e3;
  }, n.prototype.columns = function() {
    var e3 = this, t3 = [], r2 = this.size();
    if (2 !== r2.length) throw new TypeError("Rows can only be returned for a 2D matrix.");
    for (var i3 = this._data, a2 = function(r3) {
      var a3 = i3.map(((e4) => [e4[r3]]));
      t3.push(new n(a3, e3._datatype));
    }, o2 = 0; o2 < r2[1]; o2++) a2(o2);
    return t3;
  }, n.prototype.toArray = function() {
    return clone$3$1(this._data);
  }, n.prototype.valueOf = function() {
    return this._data;
  }, n.prototype.format = function(e3) {
    return format$3(this._data, e3);
  }, n.prototype.toString = function() {
    return format$3(this._data);
  }, n.prototype.toJSON = function() {
    return { mathjs: "DenseMatrix", data: this._data, size: this._size, datatype: this._datatype };
  }, n.prototype.diagonal = function(e3) {
    if (e3) {
      if (isBigNumber$1(e3) && (e3 = e3.toNumber()), !isNumber$1$1(e3) || !isInteger$1(e3)) throw new TypeError("The parameter k must be an integer number");
    } else e3 = 0;
    for (var t3 = e3 > 0 ? e3 : 0, r2 = e3 < 0 ? -e3 : 0, i3 = this._size[0], a2 = this._size[1], o2 = Math.min(i3 - r2, a2 - t3), s = [], u = 0; u < o2; u++) s[u] = this._data[u + r2][u + t3];
    return new n({ data: s, size: [o2], datatype: this._datatype });
  }, n.diagonal = function(e3, t3, r2, i3) {
    if (!isArray$1$1(e3)) throw new TypeError("Array expected, size parameter");
    if (2 !== e3.length) throw new Error("Only two dimensions matrix are supported");
    if (e3 = e3.map((function(e4) {
      if (isBigNumber$1(e4) && (e4 = e4.toNumber()), !isNumber$1$1(e4) || !isInteger$1(e4) || e4 < 1) throw new Error("Size values must be positive integers");
      return e4;
    })), r2) {
      if (isBigNumber$1(r2) && (r2 = r2.toNumber()), !isNumber$1$1(r2) || !isInteger$1(r2)) throw new TypeError("The parameter k must be an integer number");
    } else r2 = 0;
    var a2, o2 = r2 > 0 ? r2 : 0, s = r2 < 0 ? -r2 : 0, u = e3[0], c2 = e3[1], l = Math.min(u - s, c2 - o2);
    if (isArray$1$1(t3)) {
      if (t3.length !== l) throw new Error("Invalid value array length");
      a2 = function(e4) {
        return t3[e4];
      };
    } else if (isMatrix$1(t3)) {
      var f2 = t3.size();
      if (1 !== f2.length || f2[0] !== l) throw new Error("Invalid matrix length");
      a2 = function(e4) {
        return t3.get([e4]);
      };
    } else a2 = function() {
      return t3;
    };
    i3 || (i3 = isBigNumber$1(a2(0)) ? a2(0).mul(0) : 0);
    var p = [];
    if (e3.length > 0) {
      p = resize$1(p, e3, i3);
      for (var m = 0; m < l; m++) p[m + s][m + o2] = a2(m);
    }
    return new n({ data: p, size: [u, c2] });
  }, n.fromJSON = function(e3) {
    return new n(e3);
  }, n.prototype.swapRows = function(e3, t3) {
    if (!(isNumber$1$1(e3) && isInteger$1(e3) && isNumber$1$1(t3) && isInteger$1(t3))) throw new Error("Row index must be positive integers");
    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
    return validateIndex$1(e3, this._size[0]), validateIndex$1(t3, this._size[0]), n._swapRows(e3, t3, this._data), this;
  }, n._swapRows = function(e3, t3, r2) {
    var n3 = r2[e3];
    r2[e3] = r2[t3], r2[t3] = n3;
  }, n;
}), { isClass: true }), name$4U$1 = "clone", dependencies$4U$1 = ["typed"], createClone$1 = factory$1(name$4U$1, dependencies$4U$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4U$1, { any: clone$3$1 });
}));
function _switch$1$1(e2) {
  var t2, r, n = e2.length, i2 = e2[0].length, a = [];
  for (r = 0; r < i2; r++) {
    var o = [];
    for (t2 = 0; t2 < n; t2++) o.push(e2[t2][r]);
    a.push(o);
  }
  return a;
}
function containsCollections$1(e2) {
  for (var t2 = 0; t2 < e2.length; t2++) if (isCollection$1(e2[t2])) return true;
  return false;
}
function deepForEach$2(e2, t2) {
  isMatrix$1(e2) ? e2.forEach(((e3) => t2(e3)), false, true) : deepForEach$1$1(e2, t2, true);
}
function deepMap$2(e2, t2, r) {
  if (!r) return isMatrix$1(e2) ? e2.map(((e3) => t2(e3)), false, true) : deepMap$1$1(e2, t2, true);
  var n = (e3) => 0 === e3 ? e3 : t2(e3);
  return isMatrix$1(e2) ? e2.map(((e3) => n(e3)), false, true) : deepMap$1$1(e2, n, true);
}
function reduce$2$1(e2, t2, r) {
  var n = Array.isArray(e2) ? arraySize$1(e2) : e2.size();
  if (t2 < 0 || t2 >= n.length) throw new IndexError$1(t2, n.length);
  return isMatrix$1(e2) ? e2.create(_reduce$1(e2.valueOf(), t2, r), e2.datatype()) : _reduce$1(e2, t2, r);
}
function _reduce$1(e2, t2, r) {
  var n, i2, a, o;
  if (t2 <= 0) {
    if (Array.isArray(e2[0])) {
      for (o = _switch$1$1(e2), i2 = [], n = 0; n < o.length; n++) i2[n] = _reduce$1(o[n], t2 - 1, r);
      return i2;
    }
    for (a = e2[0], n = 1; n < e2.length; n++) a = r(a, e2[n]);
    return a;
  }
  for (i2 = [], n = 0; n < e2.length; n++) i2[n] = _reduce$1(e2[n], t2 - 1, r);
  return i2;
}
function scatter$1(e2, t2, r, n, i2, a, o, s, u, c2, l) {
  var f2, p, m, d, h = e2._values, g = e2._index, y = e2._ptr;
  if (n) for (p = y[t2], m = y[t2 + 1], f2 = p; f2 < m; f2++) r[d = g[f2]] !== a ? (r[d] = a, o.push(d), n[d] = h[f2]) : (n[d] = s(n[d], h[f2]), i2[d] = a);
  else for (p = y[t2], m = y[t2 + 1], f2 = p; f2 < m; f2++) r[d = g[f2]] !== a ? (r[d] = a, o.push(d)) : i2[d] = a;
}
var name$4T$1 = "isInteger", dependencies$4T$1 = ["typed", "equal"], createIsInteger$1 = factory$1(name$4T$1, dependencies$4T$1, ((e2) => {
  var { typed: t2, equal: r } = e2;
  return t2(name$4T$1, { number: (e3) => !!Number.isFinite(e3) && r(e3, Math.round(e3)), BigNumber: (e3) => !!e3.isFinite() && r(e3.round(), e3), bigint: (e3) => true, Fraction: (e3) => 1n === e3.d, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), n1$4$1 = "number", n2$2$1 = "number, number";
function absNumber$1(e2) {
  return Math.abs(e2);
}
function addNumber$1(e2, t2) {
  return e2 + t2;
}
function subtractNumber$1(e2, t2) {
  return e2 - t2;
}
function multiplyNumber$1(e2, t2) {
  return e2 * t2;
}
function unaryMinusNumber$1(e2) {
  return -e2;
}
function unaryPlusNumber$1(e2) {
  return e2;
}
function cbrtNumber$1(e2) {
  return cbrt$1$1(e2);
}
function cubeNumber$1(e2) {
  return e2 * e2 * e2;
}
function expNumber$1(e2) {
  return Math.exp(e2);
}
function expm1Number$1(e2) {
  return expm1$1(e2);
}
function lcmNumber$1(e2, t2) {
  if (!isInteger$1(e2) || !isInteger$1(t2)) throw new Error("Parameters in function lcm must be integer numbers");
  if (0 === e2 || 0 === t2) return 0;
  for (var r, n = e2 * t2; 0 !== t2; ) t2 = e2 % (r = t2), e2 = r;
  return Math.abs(n / e2);
}
function logNumber$1(e2, t2) {
  return t2 ? Math.log(e2) / Math.log(t2) : Math.log(e2);
}
function log10Number$1(e2) {
  return log10$2$1(e2);
}
function log2Number$1(e2) {
  return log2$1$1(e2);
}
function nthRootNumber$1(e2) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2, r = t2 < 0;
  if (r && (t2 = -t2), 0 === t2) throw new Error("Root must be non-zero");
  if (e2 < 0 && Math.abs(t2) % 2 != 1) throw new Error("Root must be odd when a is negative.");
  if (0 === e2) return r ? 1 / 0 : 0;
  if (!isFinite(e2)) return r ? 0 : e2;
  var n = Math.pow(Math.abs(e2), 1 / t2);
  return n = e2 < 0 ? -n : n, r ? 1 / n : n;
}
function signNumber$1(e2) {
  return sign$2$1(e2);
}
function squareNumber$1(e2) {
  return e2 * e2;
}
function xgcdNumber$1(e2, t2) {
  var r, n, i2, a = 0, o = 1, s = 1, u = 0;
  if (!isInteger$1(e2) || !isInteger$1(t2)) throw new Error("Parameters in function xgcd must be integer numbers");
  for (; t2; ) i2 = e2 - (n = Math.floor(e2 / t2)) * t2, r = a, a = o - n * a, o = r, r = s, s = u - n * s, u = r, e2 = t2, t2 = i2;
  return e2 < 0 ? [-e2, -o, -u] : [e2, e2 ? o : 0, u];
}
function powNumber$1(e2, t2) {
  return e2 * e2 < 1 && t2 === 1 / 0 || e2 * e2 > 1 && t2 === -1 / 0 ? 0 : Math.pow(e2, t2);
}
function roundNumber$1(e2) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
  if (!isInteger$1(t2) || t2 < 0 || t2 > 15) throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
  return parseFloat(toFixed$2$1(e2, t2));
}
absNumber$1.signature = n1$4$1, addNumber$1.signature = n2$2$1, subtractNumber$1.signature = n2$2$1, multiplyNumber$1.signature = n2$2$1, unaryMinusNumber$1.signature = n1$4$1, unaryPlusNumber$1.signature = n1$4$1, cbrtNumber$1.signature = n1$4$1, cubeNumber$1.signature = n1$4$1, expNumber$1.signature = n1$4$1, expm1Number$1.signature = n1$4$1, lcmNumber$1.signature = n2$2$1, log10Number$1.signature = n1$4$1, log2Number$1.signature = n1$4$1, signNumber$1.signature = n1$4$1, squareNumber$1.signature = n1$4$1, xgcdNumber$1.signature = n2$2$1, powNumber$1.signature = n2$2$1;
var n1$3$1 = "number", n2$1$1 = "number, number";
function bitAndNumber$1(e2, t2) {
  if (!isInteger$1(e2) || !isInteger$1(t2)) throw new Error("Integers expected in function bitAnd");
  return e2 & t2;
}
function bitNotNumber$1(e2) {
  if (!isInteger$1(e2)) throw new Error("Integer expected in function bitNot");
  return ~e2;
}
function bitOrNumber$1(e2, t2) {
  if (!isInteger$1(e2) || !isInteger$1(t2)) throw new Error("Integers expected in function bitOr");
  return e2 | t2;
}
function bitXorNumber$1(e2, t2) {
  if (!isInteger$1(e2) || !isInteger$1(t2)) throw new Error("Integers expected in function bitXor");
  return e2 ^ t2;
}
function leftShiftNumber$1(e2, t2) {
  if (!isInteger$1(e2) || !isInteger$1(t2)) throw new Error("Integers expected in function leftShift");
  return e2 << t2;
}
function rightArithShiftNumber$1(e2, t2) {
  if (!isInteger$1(e2) || !isInteger$1(t2)) throw new Error("Integers expected in function rightArithShift");
  return e2 >> t2;
}
function rightLogShiftNumber$1(e2, t2) {
  if (!isInteger$1(e2) || !isInteger$1(t2)) throw new Error("Integers expected in function rightLogShift");
  return e2 >>> t2;
}
function product$2(e2, t2) {
  if (t2 < e2) return 1;
  if (t2 === e2) return t2;
  var r = t2 + e2 >> 1;
  return product$2(e2, r) * product$2(r + 1, t2);
}
function combinationsNumber$1(e2, t2) {
  if (!isInteger$1(e2) || e2 < 0) throw new TypeError("Positive integer value expected in function combinations");
  if (!isInteger$1(t2) || t2 < 0) throw new TypeError("Positive integer value expected in function combinations");
  if (t2 > e2) throw new TypeError("k must be less than or equal to n");
  for (var r = e2 - t2, n = 1, i2 = 2, a = t2 < r ? t2 : r, o = t2 < r ? r + 1 : t2 + 1; o <= e2; ++o) for (n *= o; i2 <= a && n % i2 == 0; ) n /= i2, ++i2;
  return i2 <= a && (n /= product$2(i2, a)), n;
}
bitAndNumber$1.signature = n2$1$1, bitNotNumber$1.signature = n1$3$1, bitOrNumber$1.signature = n2$1$1, bitXorNumber$1.signature = n2$1$1, leftShiftNumber$1.signature = n2$1$1, rightArithShiftNumber$1.signature = n2$1$1, rightLogShiftNumber$1.signature = n2$1$1, combinationsNumber$1.signature = "number, number";
var pi$1 = Math.PI, tau$1 = 2 * Math.PI, e$1 = Math.E, phi$1 = 1.618033988749895, n1$2$1 = "number", n2$3 = "number, number";
function notNumber$1(e2) {
  return !e2;
}
function orNumber$1(e2, t2) {
  return !(!e2 && !t2);
}
function xorNumber$1(e2, t2) {
  return !!e2 != !!t2;
}
function andNumber$1(e2, t2) {
  return !(!e2 || !t2);
}
function gammaNumber$1(e2) {
  var t2;
  if (isInteger$1(e2)) return e2 <= 0 ? Number.isFinite(e2) ? 1 / 0 : NaN : e2 > 171 ? 1 / 0 : product$2(1, e2 - 1);
  if (e2 < 0.5) return Math.PI / (Math.sin(Math.PI * e2) * gammaNumber$1(1 - e2));
  if (e2 >= 171.35) return 1 / 0;
  if (e2 > 85) {
    var r = e2 * e2, n = r * e2, i2 = n * e2, a = i2 * e2;
    return Math.sqrt(2 * Math.PI / e2) * Math.pow(e2 / Math.E, e2) * (1 + 1 / (12 * e2) + 1 / (288 * r) - 139 / (51840 * n) - 571 / (2488320 * i2) + 163879 / (209018880 * a) + 5246819 / (75246796800 * a * e2));
  }
  --e2, t2 = gammaP$1[0];
  for (var o = 1; o < gammaP$1.length; ++o) t2 += gammaP$1[o] / (e2 + o);
  var s = e2 + gammaG$1 + 0.5;
  return Math.sqrt(2 * Math.PI) * Math.pow(s, e2 + 0.5) * Math.exp(-s) * t2;
}
notNumber$1.signature = n1$2$1, orNumber$1.signature = n2$3, xorNumber$1.signature = n2$3, andNumber$1.signature = n2$3, gammaNumber$1.signature = "number";
var gammaG$1 = 4.7421875, gammaP$1 = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], lnSqrt2PI$1 = 0.9189385332046728, lgammaG$1 = 5, lgammaN$1 = 7, lgammaSeries$1 = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function lgammaNumber$1(e2) {
  if (e2 < 0) return NaN;
  if (0 === e2) return 1 / 0;
  if (!Number.isFinite(e2)) return e2;
  if (e2 < 0.5) return Math.log(Math.PI / Math.sin(Math.PI * e2)) - lgammaNumber$1(1 - e2);
  for (var t2 = (e2 -= 1) + lgammaG$1 + 0.5, r = lgammaSeries$1[0], n = lgammaN$1 - 1; n >= 1; n--) r += lgammaSeries$1[n] / (e2 + n);
  return lnSqrt2PI$1 + (e2 + 0.5) * Math.log(t2) - t2 + Math.log(r);
}
lgammaNumber$1.signature = "number";
var n1$1$1 = "number";
function acoshNumber$1(e2) {
  return acosh$2$1(e2);
}
function acotNumber$1(e2) {
  return Math.atan(1 / e2);
}
function acothNumber$1(e2) {
  return Number.isFinite(e2) ? (Math.log((e2 + 1) / e2) + Math.log(e2 / (e2 - 1))) / 2 : 0;
}
function acscNumber$1(e2) {
  return Math.asin(1 / e2);
}
function acschNumber$1(e2) {
  var t2 = 1 / e2;
  return Math.log(t2 + Math.sqrt(t2 * t2 + 1));
}
function asecNumber$1(e2) {
  return Math.acos(1 / e2);
}
function asechNumber$1(e2) {
  var t2 = 1 / e2, r = Math.sqrt(t2 * t2 - 1);
  return Math.log(r + t2);
}
function asinhNumber$1(e2) {
  return asinh$2$1(e2);
}
function atanhNumber$1(e2) {
  return atanh$2$1(e2);
}
function cotNumber$1(e2) {
  return 1 / Math.tan(e2);
}
function cothNumber$1(e2) {
  var t2 = Math.exp(2 * e2);
  return (t2 + 1) / (t2 - 1);
}
function cscNumber$1(e2) {
  return 1 / Math.sin(e2);
}
function cschNumber$1(e2) {
  return 0 === e2 ? Number.POSITIVE_INFINITY : Math.abs(2 / (Math.exp(e2) - Math.exp(-e2))) * sign$2$1(e2);
}
function secNumber$1(e2) {
  return 1 / Math.cos(e2);
}
function sechNumber$1(e2) {
  return 2 / (Math.exp(e2) + Math.exp(-e2));
}
function sinhNumber$1(e2) {
  return sinh$3$1(e2);
}
acoshNumber$1.signature = n1$1$1, acotNumber$1.signature = n1$1$1, acothNumber$1.signature = n1$1$1, acscNumber$1.signature = n1$1$1, acschNumber$1.signature = n1$1$1, asecNumber$1.signature = n1$1$1, asechNumber$1.signature = n1$1$1, asinhNumber$1.signature = n1$1$1, atanhNumber$1.signature = n1$1$1, cotNumber$1.signature = n1$1$1, cothNumber$1.signature = n1$1$1, cscNumber$1.signature = n1$1$1, cschNumber$1.signature = n1$1$1, secNumber$1.signature = n1$1$1, sechNumber$1.signature = n1$1$1, sinhNumber$1.signature = n1$1$1;
var n1$5 = "number";
function isNegativeNumber$1(e2) {
  return e2 < 0;
}
function isPositiveNumber$1(e2) {
  return e2 > 0;
}
function isNaNNumber$1(e2) {
  return Number.isNaN(e2);
}
function nearlyEqual$2(e2, t2) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e-9, n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
  if (r <= 0) throw new Error("Relative tolerance must be greater than 0");
  if (n < 0) throw new Error("Absolute tolerance must be at least 0");
  return !e2.isNaN() && !t2.isNaN() && (e2.isFinite() && t2.isFinite() ? !!e2.eq(t2) || e2.minus(t2).abs().lte(e2.constructor.max(e2.constructor.max(e2.abs(), t2.abs()).mul(r), n)) : e2.eq(t2));
}
isNegativeNumber$1.signature = n1$5, isPositiveNumber$1.signature = n1$5, isNaNNumber$1.signature = n1$5;
var name$4S$1 = "isNegative", dependencies$4S$1 = ["typed", "config"], createIsNegative$1 = factory$1(name$4S$1, dependencies$4S$1, ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$4S$1, { number: (e3) => !nearlyEqual$1$1(e3, 0, r.relTol, r.absTol) && isNegativeNumber$1(e3), BigNumber: (e3) => !nearlyEqual$2(e3, new e3.constructor(0), r.relTol, r.absTol) && (e3.isNeg() && !e3.isZero() && !e3.isNaN()), bigint: (e3) => e3 < 0n, Fraction: (e3) => e3.s < 0n, Unit: t2.referToSelf(((e3) => (r2) => t2.find(e3, r2.valueType())(r2.value))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4R$1 = "isNumeric", dependencies$4R$1 = ["typed"], createIsNumeric$1 = factory$1(name$4R$1, dependencies$4R$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4R$1, { "number | BigNumber | bigint | Fraction | boolean": () => true, "Complex | Unit | string | null | undefined | Node": () => false, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4Q$1 = "hasNumericValue", dependencies$4Q$1 = ["typed", "isNumeric"], createHasNumericValue$1 = factory$1(name$4Q$1, dependencies$4Q$1, ((e2) => {
  var { typed: t2, isNumeric: r } = e2;
  return t2(name$4Q$1, { boolean: () => true, string: function(e3) {
    return e3.trim().length > 0 && !isNaN(Number(e3));
  }, any: function(e3) {
    return r(e3);
  } });
})), name$4P$1 = "isPositive", dependencies$4P$1 = ["typed", "config"], createIsPositive$1 = factory$1(name$4P$1, dependencies$4P$1, ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$4P$1, { number: (e3) => !nearlyEqual$1$1(e3, 0, r.relTol, r.absTol) && isPositiveNumber$1(e3), BigNumber: (e3) => !nearlyEqual$2(e3, new e3.constructor(0), r.relTol, r.absTol) && (!e3.isNeg() && !e3.isZero() && !e3.isNaN()), bigint: (e3) => e3 > 0n, Fraction: (e3) => e3.s > 0n && e3.n > 0n, Unit: t2.referToSelf(((e3) => (r2) => t2.find(e3, r2.valueType())(r2.value))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4O$1 = "isZero", dependencies$4O$1 = ["typed", "equalScalar"], createIsZero$1 = factory$1(name$4O$1, dependencies$4O$1, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return t2(name$4O$1, { "number | BigNumber | Complex | Fraction": (e3) => r(e3, 0), bigint: (e3) => 0n === e3, Unit: t2.referToSelf(((e3) => (r2) => t2.find(e3, r2.valueType())(r2.value))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4N$1 = "isNaN", dependencies$4N$1 = ["typed"], createIsNaN$1 = factory$1(name$4N$1, dependencies$4N$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4N$1, { number: isNaNNumber$1, BigNumber: function(e3) {
    return e3.isNaN();
  }, bigint: function(e3) {
    return false;
  }, Fraction: function(e3) {
    return false;
  }, Complex: function(e3) {
    return e3.isNaN();
  }, Unit: function(e3) {
    return Number.isNaN(e3.value);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4M$1 = "isBounded", dependencies$4M$1 = ["typed"], createIsBounded$1 = factory$1(name$4M$1, dependencies$4M$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4M$1, { number: (e3) => Number.isFinite(e3), "BigNumber | Complex": (e3) => e3.isFinite(), "bigint | Fraction": () => true, "null | undefined": () => false, Unit: t2.referToSelf(((e3) => (t3) => e3(t3.value))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => (Array.isArray(t3) || (t3 = t3.valueOf()), t3.every(((t4) => e3(t4)))))) });
})), name$4L$1 = "isFinite", dependencies$4L$1 = ["typed", "isBounded", "map"], createIsFinite$1 = factory$1(name$4L$1, dependencies$4L$1, ((e2) => {
  var { typed: t2, isBounded: r, map: n } = e2;
  return t2(name$4L$1, { "Array | Matrix": (e3) => n(e3, r), any: (e3) => r(e3) });
})), name$4K$1 = "typeOf", dependencies$4K$1 = ["typed"], createTypeOf$1 = factory$1(name$4K$1, dependencies$4K$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4K$1, { any: typeOf$1 });
}));
function complexEquals$1(e2, t2, r, n) {
  return nearlyEqual$1$1(e2.re, t2.re, r, n) && nearlyEqual$1$1(e2.im, t2.im, r, n);
}
var createCompareUnits$1 = factory$1("compareUnits", ["typed"], ((e2) => {
  var { typed: t2 } = e2;
  return { "Unit, Unit": t2.referToSelf(((e3) => (r, n) => {
    if (!r.equalBase(n)) throw new Error("Cannot compare units with different base");
    return t2.find(e3, [r.valueType(), n.valueType()])(r.value, n.value);
  })) };
})), name$4J$1 = "equalScalar", dependencies$4J$1 = ["typed", "config"], createEqualScalar$1 = factory$1(name$4J$1, dependencies$4J$1, ((e2) => {
  var { typed: t2, config: r } = e2, n = createCompareUnits$1({ typed: t2 });
  return t2(name$4J$1, { "boolean, boolean": function(e3, t3) {
    return e3 === t3;
  }, "number, number": function(e3, t3) {
    return nearlyEqual$1$1(e3, t3, r.relTol, r.absTol);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return e3.eq(t3) || nearlyEqual$2(e3, t3, r.relTol, r.absTol);
  }, "bigint, bigint": function(e3, t3) {
    return e3 === t3;
  }, "Fraction, Fraction": function(e3, t3) {
    return e3.equals(t3);
  }, "Complex, Complex": function(e3, t3) {
    return complexEquals$1(e3, t3, r.relTol, r.absTol);
  } }, n);
}));
factory$1(name$4J$1, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$4J$1, { "number, number": function(e3, t3) {
    return nearlyEqual$1$1(e3, t3, r.relTol, r.absTol);
  } });
}));
var name$4I$1 = "SparseMatrix", dependencies$4I$1 = ["typed", "equalScalar", "Matrix"], createSparseMatrixClass$1 = factory$1(name$4I$1, dependencies$4I$1, ((e2) => {
  var { typed: t2, equalScalar: r, Matrix: n } = e2;
  function i2(e3, t3) {
    if (!(this instanceof i2)) throw new SyntaxError("Constructor must be called with the new operator");
    if (t3 && !isString$1$1(t3)) throw new Error("Invalid datatype: " + t3);
    if (isMatrix$1(e3)) !(function(e4, t4, r2) {
      "SparseMatrix" === t4.type ? (e4._values = t4._values ? clone$3$1(t4._values) : void 0, e4._index = clone$3$1(t4._index), e4._ptr = clone$3$1(t4._ptr), e4._size = clone$3$1(t4._size), e4._datatype = r2 || t4._datatype) : a(e4, t4.valueOf(), r2 || t4._datatype);
    })(this, e3, t3);
    else if (e3 && isArray$1$1(e3.index) && isArray$1$1(e3.ptr) && isArray$1$1(e3.size)) this._values = e3.values, this._index = e3.index, this._ptr = e3.ptr, this._size = e3.size, this._datatype = t3 || e3.datatype;
    else if (isArray$1$1(e3)) a(this, e3, t3);
    else {
      if (e3) throw new TypeError("Unsupported type of data (" + typeOf$1(e3) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = t3;
    }
  }
  function a(e3, n3, i3) {
    e3._values = [], e3._index = [], e3._ptr = [], e3._datatype = i3;
    var a2 = n3.length, o2 = 0, s2 = r, u2 = 0;
    if (isString$1$1(i3) && (s2 = t2.find(r, [i3, i3]) || r, u2 = t2.convert(0, i3)), a2 > 0) {
      var c3 = 0;
      do {
        e3._ptr.push(e3._index.length);
        for (var l = 0; l < a2; l++) {
          var f2 = n3[l];
          if (isArray$1$1(f2)) {
            if (0 === c3 && o2 < f2.length && (o2 = f2.length), c3 < f2.length) {
              var p = f2[c3];
              s2(p, u2) || (e3._values.push(p), e3._index.push(l));
            }
          } else 0 === c3 && o2 < 1 && (o2 = 1), s2(f2, u2) || (e3._values.push(f2), e3._index.push(l));
        }
        c3++;
      } while (c3 < o2);
    }
    for (; e3._ptr.length <= o2; ) e3._ptr.push(e3._index.length);
    e3._size = [a2, o2];
  }
  function o(e3, t3, r2, n3) {
    if (r2 - t3 == 0) return r2;
    for (var i3 = t3; i3 < r2; i3++) if (n3[i3] === e3) return i3;
    return t3;
  }
  function s(e3, t3, r2, n3, i3, a2, o2) {
    i3.splice(e3, 0, n3), a2.splice(e3, 0, t3);
    for (var s2 = r2 + 1; s2 < o2.length; s2++) o2[s2]++;
  }
  function u(e3, n3, i3, a2) {
    var o2 = a2 || 0, s2 = r, u2 = 0;
    isString$1$1(e3._datatype) && (s2 = t2.find(r, [e3._datatype, e3._datatype]) || r, u2 = t2.convert(0, e3._datatype), o2 = t2.convert(o2, e3._datatype));
    var c3, l, f2, p = !s2(o2, u2), m = e3._size[0], d = e3._size[1];
    if (i3 > d) {
      for (l = d; l < i3; l++) if (e3._ptr[l] = e3._values.length, p) for (c3 = 0; c3 < m; c3++) e3._values.push(o2), e3._index.push(c3);
      e3._ptr[i3] = e3._values.length;
    } else i3 < d && (e3._ptr.splice(i3 + 1, d - i3), e3._values.splice(e3._ptr[i3], e3._values.length), e3._index.splice(e3._ptr[i3], e3._index.length));
    if (d = i3, n3 > m) {
      if (p) {
        var h = 0;
        for (l = 0; l < d; l++) {
          e3._ptr[l] = e3._ptr[l] + h, f2 = e3._ptr[l + 1] + h;
          var g = 0;
          for (c3 = m; c3 < n3; c3++, g++) e3._values.splice(f2 + g, 0, o2), e3._index.splice(f2 + g, 0, c3), h++;
        }
        e3._ptr[d] = e3._values.length;
      }
    } else if (n3 < m) {
      var y = 0;
      for (l = 0; l < d; l++) {
        e3._ptr[l] = e3._ptr[l] - y;
        var v2 = e3._ptr[l], x2 = e3._ptr[l + 1] - y;
        for (f2 = v2; f2 < x2; f2++) (c3 = e3._index[f2]) > n3 - 1 && (e3._values.splice(f2, 1), e3._index.splice(f2, 1), y++);
      }
      e3._ptr[l] = e3._values.length;
    }
    return e3._size[0] = n3, e3._size[1] = i3, e3;
  }
  function c2(e3, t3, r2, n3, i3) {
    var a2, o2, s2 = n3[0], u2 = n3[1], c3 = [];
    for (a2 = 0; a2 < s2; a2++) for (c3[a2] = [], o2 = 0; o2 < u2; o2++) c3[a2][o2] = 0;
    for (o2 = 0; o2 < u2; o2++) for (var l = r2[o2], f2 = r2[o2 + 1], p = l; p < f2; p++) c3[a2 = t3[p]][o2] = e3 ? i3 ? clone$3$1(e3[p]) : e3[p] : 1;
    return c3;
  }
  return i2.prototype = new n(), i2.prototype.createSparseMatrix = function(e3, t3) {
    return new i2(e3, t3);
  }, Object.defineProperty(i2, "name", { value: "SparseMatrix" }), i2.prototype.constructor = i2, i2.prototype.type = "SparseMatrix", i2.prototype.isSparseMatrix = true, i2.prototype.getDataType = function() {
    return getArrayDataType$1(this._values, typeOf$1);
  }, i2.prototype.storage = function() {
    return "sparse";
  }, i2.prototype.datatype = function() {
    return this._datatype;
  }, i2.prototype.create = function(e3, t3) {
    return new i2(e3, t3);
  }, i2.prototype.density = function() {
    var e3 = this._size[0], t3 = this._size[1];
    return 0 !== e3 && 0 !== t3 ? this._index.length / (e3 * t3) : 0;
  }, i2.prototype.subset = function(e3, t3, r2) {
    if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return (function(e4, t4) {
          if (!isIndex$1(t4)) throw new TypeError("Invalid index");
          if (t4.isScalar()) return e4.get(t4.min());
          var r3, n3, a2, o2, s2 = t4.size();
          if (s2.length !== e4._size.length) throw new DimensionError$1(s2.length, e4._size.length);
          var u2 = t4.min(), c3 = t4.max();
          for (r3 = 0, n3 = e4._size.length; r3 < n3; r3++) validateIndex$1(u2[r3], e4._size[r3]), validateIndex$1(c3[r3], e4._size[r3]);
          var l = e4._values, f2 = e4._index, p = e4._ptr, m = t4.dimension(0), d = t4.dimension(1), h = [], g = [];
          function y(e5, t5) {
            g[e5] = t5[0], h[e5] = true;
          }
          Number.isInteger(m) ? y(m, [0]) : m.forEach(y);
          var v2 = l ? [] : void 0, x2 = [], b2 = [];
          function _2(e5) {
            for (b2.push(x2.length), a2 = p[e5], o2 = p[e5 + 1]; a2 < o2; a2++) r3 = f2[a2], true === h[r3] && (x2.push(g[r3]), v2 && v2.push(l[a2]));
          }
          Number.isInteger(d) ? _2(d) : d.forEach(_2);
          return b2.push(x2.length), new i2({ values: v2, index: x2, ptr: b2, size: s2, datatype: e4._datatype });
        })(this, e3);
      case 2:
      case 3:
        return (function(e4, t4, r3, n3) {
          if (!t4 || true !== t4.isIndex) throw new TypeError("Invalid index");
          var i3, a2 = t4.size(), o2 = t4.isScalar();
          isMatrix$1(r3) ? (i3 = r3.size(), r3 = r3.toArray()) : i3 = arraySize$1(r3);
          if (o2) {
            if (0 !== i3.length) throw new TypeError("Scalar expected");
            e4.set(t4.min(), r3, n3);
          } else {
            if (1 !== a2.length && 2 !== a2.length) throw new DimensionError$1(a2.length, e4._size.length, "<");
            if (i3.length < a2.length) {
              for (var s2 = 0, u2 = 0; 1 === a2[s2] && 1 === i3[s2]; ) s2++;
              for (; 1 === a2[s2]; ) u2++, s2++;
              r3 = unsqueeze$1(r3, a2.length, u2, i3);
            }
            if (!deepStrictEqual$1(a2, i3)) throw new DimensionError$1(a2, i3, ">");
            if (1 === a2.length) {
              f2(t4.dimension(0), ((t5, i4) => {
                validateIndex$1(t5), e4.set([t5, 0], r3[i4[0]], n3);
              }));
            } else {
              var c3 = t4.dimension(0), l = t4.dimension(1);
              f2(c3, ((t5, i4) => {
                validateIndex$1(t5), f2(l, ((a3, o3) => {
                  validateIndex$1(a3), e4.set([t5, a3], r3[i4[0]][o3[0]], n3);
                }));
              }));
            }
          }
          return e4;
          function f2(e5, t5) {
            isNumber$1$1(e5) ? t5(e5, [0]) : e5.forEach(t5);
          }
        })(this, e3, t3, r2);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, i2.prototype.get = function(e3) {
    if (!isArray$1$1(e3)) throw new TypeError("Array expected");
    if (e3.length !== this._size.length) throw new DimensionError$1(e3.length, this._size.length);
    if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
    var t3 = e3[0], r2 = e3[1];
    validateIndex$1(t3, this._size[0]), validateIndex$1(r2, this._size[1]);
    var n3 = o(t3, this._ptr[r2], this._ptr[r2 + 1], this._index);
    return n3 < this._ptr[r2 + 1] && this._index[n3] === t3 ? this._values[n3] : 0;
  }, i2.prototype.set = function(e3, n3, i3) {
    if (!isArray$1$1(e3)) throw new TypeError("Array expected");
    if (e3.length !== this._size.length) throw new DimensionError$1(e3.length, this._size.length);
    if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
    var a2 = e3[0], c3 = e3[1], l = this._size[0], f2 = this._size[1], p = r, m = 0;
    isString$1$1(this._datatype) && (p = t2.find(r, [this._datatype, this._datatype]) || r, m = t2.convert(0, this._datatype)), (a2 > l - 1 || c3 > f2 - 1) && (u(this, Math.max(a2 + 1, l), Math.max(c3 + 1, f2), i3), l = this._size[0], f2 = this._size[1]), validateIndex$1(a2, l), validateIndex$1(c3, f2);
    var d = o(a2, this._ptr[c3], this._ptr[c3 + 1], this._index);
    return d < this._ptr[c3 + 1] && this._index[d] === a2 ? p(n3, m) ? (function(e4, t3, r2, n4, i4) {
      r2.splice(e4, 1), n4.splice(e4, 1);
      for (var a3 = t3 + 1; a3 < i4.length; a3++) i4[a3]--;
    })(d, c3, this._values, this._index, this._ptr) : this._values[d] = n3 : p(n3, m) || s(d, a2, c3, n3, this._values, this._index, this._ptr), this;
  }, i2.prototype.resize = function(e3, t3, r2) {
    if (!isCollection$1(e3)) throw new TypeError("Array or Matrix expected");
    var n3 = e3.valueOf().map(((e4) => Array.isArray(e4) && 1 === e4.length ? e4[0] : e4));
    if (2 !== n3.length) throw new Error("Only two dimensions matrix are supported");
    return n3.forEach((function(e4) {
      if (!isNumber$1$1(e4) || !isInteger$1(e4) || e4 < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + format$3(n3) + ")");
    })), u(r2 ? this.clone() : this, n3[0], n3[1], t3);
  }, i2.prototype.reshape = function(e3, t3) {
    if (!isArray$1$1(e3)) throw new TypeError("Array expected");
    if (2 !== e3.length) throw new Error("Sparse matrices can only be reshaped in two dimensions");
    e3.forEach((function(t4) {
      if (!isNumber$1$1(t4) || !isInteger$1(t4) || t4 <= -2 || 0 === t4) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + format$3(e3) + ")");
    }));
    var r2 = this._size[0] * this._size[1];
    if (r2 !== (e3 = processSizesWildcard$1(e3, r2))[0] * e3[1]) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var n3 = t3 ? this.clone() : this;
    if (this._size[0] === e3[0] && this._size[1] === e3[1]) return n3;
    for (var i3 = [], a2 = 0; a2 < n3._ptr.length; a2++) for (var u2 = 0; u2 < n3._ptr[a2 + 1] - n3._ptr[a2]; u2++) i3.push(a2);
    for (var c3 = n3._values.slice(), l = n3._index.slice(), f2 = 0; f2 < n3._index.length; f2++) {
      var p = l[f2], m = i3[f2], d = p * n3._size[1] + m;
      i3[f2] = d % e3[1], l[f2] = Math.floor(d / e3[1]);
    }
    n3._values.length = 0, n3._index.length = 0, n3._ptr.length = e3[1] + 1, n3._size = e3.slice();
    for (var h = 0; h < n3._ptr.length; h++) n3._ptr[h] = 0;
    for (var g = 0; g < c3.length; g++) {
      var y = l[g], v2 = i3[g], x2 = c3[g];
      s(o(y, n3._ptr[v2], n3._ptr[v2 + 1], n3._index), y, v2, x2, n3._values, n3._index, n3._ptr);
    }
    return n3;
  }, i2.prototype.clone = function() {
    return new i2({ values: this._values ? clone$3$1(this._values) : void 0, index: clone$3$1(this._index), ptr: clone$3$1(this._ptr), size: clone$3$1(this._size), datatype: this._datatype });
  }, i2.prototype.size = function() {
    return this._size.slice(0);
  }, i2.prototype.map = function(e3, n3) {
    if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
    var a2 = this, o2 = this._size[0], s2 = this._size[1], u2 = optimizeCallback$1(e3, a2, "map");
    return (function(e4, n4, a3, o3, s3, u3, c3) {
      var l = [], f2 = [], p = [], m = r, d = 0;
      isString$1$1(e4._datatype) && (m = t2.find(r, [e4._datatype, e4._datatype]) || r, d = t2.convert(0, e4._datatype));
      for (var h = function(e5, t3, r2) {
        var n5 = u3(e5, t3, r2);
        m(n5, d) || (l.push(n5), f2.push(t3));
      }, g = o3; g <= s3; g++) {
        p.push(l.length);
        var y = e4._ptr[g], v2 = e4._ptr[g + 1];
        if (c3) for (var x2 = y; x2 < v2; x2++) {
          var b2 = e4._index[x2];
          b2 >= n4 && b2 <= a3 && h(e4._values[x2], b2 - n4, g - o3);
        }
        else {
          for (var _2 = {}, w2 = y; w2 < v2; w2++) {
            _2[e4._index[w2]] = e4._values[w2];
          }
          for (var A2 = n4; A2 <= a3; A2++) {
            h(A2 in _2 ? _2[A2] : 0, A2 - n4, g - o3);
          }
        }
      }
      return p.push(l.length), new i2({ values: l, index: f2, ptr: p, size: [a3 - n4 + 1, s3 - o3 + 1] });
    })(this, 0, o2 - 1, 0, s2 - 1, (function(e4, t3, r2) {
      return u2.fn(e4, [t3, r2], a2);
    }), n3);
  }, i2.prototype.forEach = function(e3, t3) {
    if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var r2 = this, n3 = this._size[0], i3 = this._size[1], a2 = optimizeCallback$1(e3, r2, "forEach"), o2 = 0; o2 < i3; o2++) {
      var s2 = this._ptr[o2], u2 = this._ptr[o2 + 1];
      if (t3) for (var c3 = s2; c3 < u2; c3++) {
        var l = this._index[c3];
        a2.fn(this._values[c3], [l, o2], r2);
      }
      else {
        for (var f2 = {}, p = s2; p < u2; p++) {
          f2[this._index[p]] = this._values[p];
        }
        for (var m = 0; m < n3; m++) {
          var d = m in f2 ? f2[m] : 0;
          a2.fn(d, [m, o2], r2);
        }
      }
    }
  }, i2.prototype[Symbol.iterator] = function* () {
    if (!this._values) throw new Error("Cannot iterate a Pattern only matrix");
    for (var e3 = this._size[1], t3 = 0; t3 < e3; t3++) for (var r2 = this._ptr[t3], n3 = this._ptr[t3 + 1], i3 = r2; i3 < n3; i3++) {
      var a2 = this._index[i3];
      yield { value: this._values[i3], index: [a2, t3] };
    }
  }, i2.prototype.toArray = function() {
    return c2(this._values, this._index, this._ptr, this._size, true);
  }, i2.prototype.valueOf = function() {
    return c2(this._values, this._index, this._ptr, this._size, false);
  }, i2.prototype.format = function(e3) {
    for (var t3 = this._size[0], r2 = this._size[1], n3 = this.density(), i3 = "Sparse Matrix [" + format$3(t3, e3) + " x " + format$3(r2, e3) + "] density: " + format$3(n3, e3) + "\n", a2 = 0; a2 < r2; a2++) for (var o2 = this._ptr[a2], s2 = this._ptr[a2 + 1], u2 = o2; u2 < s2; u2++) {
      i3 += "\n    (" + format$3(this._index[u2], e3) + ", " + format$3(a2, e3) + ") ==> " + (this._values ? format$3(this._values[u2], e3) : "X");
    }
    return i3;
  }, i2.prototype.toString = function() {
    return format$3(this.toArray());
  }, i2.prototype.toJSON = function() {
    return { mathjs: "SparseMatrix", values: this._values, index: this._index, ptr: this._ptr, size: this._size, datatype: this._datatype };
  }, i2.prototype.diagonal = function(e3) {
    if (e3) {
      if (isBigNumber$1(e3) && (e3 = e3.toNumber()), !isNumber$1$1(e3) || !isInteger$1(e3)) throw new TypeError("The parameter k must be an integer number");
    } else e3 = 0;
    var t3 = e3 > 0 ? e3 : 0, r2 = e3 < 0 ? -e3 : 0, n3 = this._size[0], a2 = this._size[1], o2 = Math.min(n3 - r2, a2 - t3), s2 = [], u2 = [], c3 = [];
    c3[0] = 0;
    for (var l = t3; l < a2 && s2.length < o2; l++) for (var f2 = this._ptr[l], p = this._ptr[l + 1], m = f2; m < p; m++) {
      var d = this._index[m];
      if (d === l - t3 + r2) {
        s2.push(this._values[m]), u2[s2.length - 1] = d - r2;
        break;
      }
    }
    return c3.push(s2.length), new i2({ values: s2, index: u2, ptr: c3, size: [o2, 1] });
  }, i2.fromJSON = function(e3) {
    return new i2(e3);
  }, i2.diagonal = function(e3, n3, a2, o2, s2) {
    if (!isArray$1$1(e3)) throw new TypeError("Array expected, size parameter");
    if (2 !== e3.length) throw new Error("Only two dimensions matrix are supported");
    if (e3 = e3.map((function(e4) {
      if (isBigNumber$1(e4) && (e4 = e4.toNumber()), !isNumber$1$1(e4) || !isInteger$1(e4) || e4 < 1) throw new Error("Size values must be positive integers");
      return e4;
    })), a2) {
      if (isBigNumber$1(a2) && (a2 = a2.toNumber()), !isNumber$1$1(a2) || !isInteger$1(a2)) throw new TypeError("The parameter k must be an integer number");
    } else a2 = 0;
    var u2 = r, c3 = 0;
    isString$1$1(s2) && (u2 = t2.find(r, [s2, s2]) || r, c3 = t2.convert(0, s2));
    var l, f2 = a2 > 0 ? a2 : 0, p = a2 < 0 ? -a2 : 0, m = e3[0], d = e3[1], h = Math.min(m - p, d - f2);
    if (isArray$1$1(n3)) {
      if (n3.length !== h) throw new Error("Invalid value array length");
      l = function(e4) {
        return n3[e4];
      };
    } else if (isMatrix$1(n3)) {
      var g = n3.size();
      if (1 !== g.length || g[0] !== h) throw new Error("Invalid matrix length");
      l = function(e4) {
        return n3.get([e4]);
      };
    } else l = function() {
      return n3;
    };
    for (var y = [], v2 = [], x2 = [], b2 = 0; b2 < d; b2++) {
      x2.push(y.length);
      var _2 = b2 - f2;
      if (_2 >= 0 && _2 < h) {
        var w2 = l(_2);
        u2(w2, c3) || (v2.push(_2 + p), y.push(w2));
      }
    }
    return x2.push(y.length), new i2({ values: y, index: v2, ptr: x2, size: [m, d] });
  }, i2.prototype.swapRows = function(e3, t3) {
    if (!(isNumber$1$1(e3) && isInteger$1(e3) && isNumber$1$1(t3) && isInteger$1(t3))) throw new Error("Row index must be positive integers");
    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
    return validateIndex$1(e3, this._size[0]), validateIndex$1(t3, this._size[0]), i2._swapRows(e3, t3, this._size[1], this._values, this._index, this._ptr), this;
  }, i2._forEachRow = function(e3, t3, r2, n3, i3) {
    for (var a2 = n3[e3], o2 = n3[e3 + 1], s2 = a2; s2 < o2; s2++) i3(r2[s2], t3[s2]);
  }, i2._swapRows = function(e3, t3, r2, n3, i3, a2) {
    for (var s2 = 0; s2 < r2; s2++) {
      var u2 = a2[s2], c3 = a2[s2 + 1], l = o(e3, u2, c3, i3), f2 = o(t3, u2, c3, i3);
      if (l < c3 && f2 < c3 && i3[l] === e3 && i3[f2] === t3) {
        if (n3) {
          var p = n3[l];
          n3[l] = n3[f2], n3[f2] = p;
        }
      } else if (l < c3 && i3[l] === e3 && (f2 >= c3 || i3[f2] !== t3)) {
        var m = n3 ? n3[l] : void 0;
        i3.splice(f2, 0, t3), n3 && n3.splice(f2, 0, m), i3.splice(f2 <= l ? l + 1 : l, 1), n3 && n3.splice(f2 <= l ? l + 1 : l, 1);
      } else if (f2 < c3 && i3[f2] === t3 && (l >= c3 || i3[l] !== e3)) {
        var d = n3 ? n3[f2] : void 0;
        i3.splice(l, 0, e3), n3 && n3.splice(l, 0, d), i3.splice(l <= f2 ? f2 + 1 : f2, 1), n3 && n3.splice(l <= f2 ? f2 + 1 : f2, 1);
      }
    }
  }, i2;
}), { isClass: true }), name$4H$1 = "number", dependencies$4H$1 = ["typed"];
function getNonDecimalNumberParts$1(e2) {
  var t2 = e2.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  return t2 ? { input: e2, radix: { "0b": 2, "0o": 8, "0x": 16 }[t2[1]], integerPart: t2[2], fractionalPart: t2[3] } : null;
}
function makeNumberFromNonDecimalParts$1(e2) {
  for (var t2 = parseInt(e2.integerPart, e2.radix), r = 0, n = 0; n < e2.fractionalPart.length; n++) {
    r += parseInt(e2.fractionalPart[n], e2.radix) / Math.pow(e2.radix, n + 1);
  }
  var i2 = t2 + r;
  if (isNaN(i2)) throw new SyntaxError('String "' + e2.input + '" is not a valid number');
  return i2;
}
var createNumber$1 = factory$1(name$4H$1, dependencies$4H$1, ((e2) => {
  var { typed: t2 } = e2, r = t2("number", { "": function() {
    return 0;
  }, number: function(e3) {
    return e3;
  }, string: function(e3) {
    if ("NaN" === e3) return NaN;
    var t3 = getNonDecimalNumberParts$1(e3);
    if (t3) return makeNumberFromNonDecimalParts$1(t3);
    var r2 = 0, n = e3.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    n && (r2 = Number(n[2]), e3 = n[1]);
    var i2 = Number(e3);
    if (isNaN(i2)) throw new SyntaxError('String "' + e3 + '" is not a valid number');
    if (n) {
      if (i2 > 2 ** r2 - 1) throw new SyntaxError('String "'.concat(e3, '" is out of range'));
      i2 >= 2 ** (r2 - 1) && (i2 -= 2 ** r2);
    }
    return i2;
  }, BigNumber: function(e3) {
    return e3.toNumber();
  }, bigint: function(e3) {
    return Number(e3);
  }, Fraction: function(e3) {
    return e3.valueOf();
  }, Unit: t2.referToSelf(((e3) => (t3) => {
    var r2 = t3.clone();
    return r2.value = e3(t3.value), r2;
  })), null: function(e3) {
    return 0;
  }, "Unit, string | Unit": function(e3, t3) {
    return e3.toNumber(t3);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
  return r.fromJSON = function(e3) {
    return parseFloat(e3.value);
  }, r;
})), name$4G$1 = "bigint", dependencies$4G$1 = ["typed"], createBigint$1 = factory$1(name$4G$1, dependencies$4G$1, ((e2) => {
  var { typed: t2 } = e2, r = t2("bigint", { "": function() {
    return 0n;
  }, bigint: function(e3) {
    return e3;
  }, number: function(e3) {
    return BigInt(e3.toFixed());
  }, BigNumber: function(e3) {
    return BigInt(e3.round().toString());
  }, Fraction: function(e3) {
    return BigInt(e3.valueOf().toFixed());
  }, "string | boolean": function(e3) {
    return BigInt(e3);
  }, null: function(e3) {
    return 0n;
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
  return r.fromJSON = function(e3) {
    return BigInt(e3.value);
  }, r;
})), name$4F$1 = "string", dependencies$4F$1 = ["typed"], createString$1 = factory$1(name$4F$1, dependencies$4F$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4F$1, { "": function() {
    return "";
  }, number: format$2$1, null: function(e3) {
    return "null";
  }, boolean: function(e3) {
    return e3 + "";
  }, string: function(e3) {
    return e3;
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))), any: function(e3) {
    return String(e3);
  } });
})), name$4E$1 = "boolean", dependencies$4E$1 = ["typed"], createBoolean$1 = factory$1(name$4E$1, dependencies$4E$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4E$1, { "": function() {
    return false;
  }, boolean: function(e3) {
    return e3;
  }, number: function(e3) {
    return !!e3;
  }, null: function(e3) {
    return false;
  }, BigNumber: function(e3) {
    return !e3.isZero();
  }, string: function(e3) {
    var t3 = e3.toLowerCase();
    if ("true" === t3) return true;
    if ("false" === t3) return false;
    var r = Number(e3);
    if ("" !== e3 && !isNaN(r)) return !!r;
    throw new Error('Cannot convert "' + e3 + '" to a boolean');
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4D$1 = "bignumber", dependencies$4D$1 = ["typed", "BigNumber"], createBignumber$1 = factory$1(name$4D$1, dependencies$4D$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2("bignumber", { "": function() {
    return new r(0);
  }, number: function(e3) {
    return new r(e3 + "");
  }, string: function(e3) {
    var t3 = e3.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    if (t3) {
      var n = t3[2], i2 = r(t3[1]), a = new r(2).pow(Number(n));
      if (i2.gt(a.sub(1))) throw new SyntaxError('String "'.concat(e3, '" is out of range'));
      var o = new r(2).pow(Number(n) - 1);
      return i2.gte(o) ? i2.sub(a) : i2;
    }
    return new r(e3);
  }, BigNumber: function(e3) {
    return e3;
  }, bigint: function(e3) {
    return new r(e3.toString());
  }, Unit: t2.referToSelf(((e3) => (t3) => {
    var r2 = t3.clone();
    return r2.value = e3(t3.value), r2;
  })), Fraction: function(e3) {
    return new r(String(e3.n)).div(String(e3.d)).times(String(e3.s));
  }, null: function(e3) {
    return new r(0);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4C$1 = "complex", dependencies$4C$1 = ["typed", "Complex"], createComplex$1 = factory$1(name$4C$1, dependencies$4C$1, ((e2) => {
  var { typed: t2, Complex: r } = e2;
  return t2("complex", { "": function() {
    return r.ZERO;
  }, number: function(e3) {
    return new r(e3, 0);
  }, "number, number": function(e3, t3) {
    return new r(e3, t3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return new r(e3.toNumber(), t3.toNumber());
  }, Fraction: function(e3) {
    return new r(e3.valueOf(), 0);
  }, Complex: function(e3) {
    return e3.clone();
  }, string: function(e3) {
    return r(e3);
  }, null: function(e3) {
    return r(0);
  }, Object: function(e3) {
    if ("re" in e3 && "im" in e3) return new r(e3.re, e3.im);
    if ("r" in e3 && "phi" in e3 || "abs" in e3 && "arg" in e3) return new r(e3);
    throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4B$1 = "fraction", dependencies$4B$1 = ["typed", "Fraction"], createFraction$1 = factory$1(name$4B$1, dependencies$4B$1, ((e2) => {
  var { typed: t2, Fraction: r } = e2;
  return t2("fraction", { number: function(e3) {
    if (!Number.isFinite(e3) || isNaN(e3)) throw new Error(e3 + " cannot be represented as a fraction");
    return new r(e3);
  }, string: function(e3) {
    return new r(e3);
  }, "number, number": function(e3, t3) {
    return new r(e3, t3);
  }, "bigint, bigint": function(e3, t3) {
    return new r(e3, t3);
  }, null: function(e3) {
    return new r(0);
  }, BigNumber: function(e3) {
    return new r(e3.toString());
  }, bigint: function(e3) {
    return new r(e3.toString());
  }, Fraction: function(e3) {
    return e3;
  }, Unit: t2.referToSelf(((e3) => (t3) => {
    var r2 = t3.clone();
    return r2.value = e3(t3.value), r2;
  })), Object: function(e3) {
    return new r(e3);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$4A$1 = "matrix", dependencies$4A$1 = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], createMatrix$1 = factory$1(name$4A$1, dependencies$4A$1, ((e2) => {
  var { typed: t2, Matrix: r, DenseMatrix: n, SparseMatrix: i2 } = e2;
  return t2(name$4A$1, { "": function() {
    return a([]);
  }, string: function(e3) {
    return a([], e3);
  }, "string, string": function(e3, t3) {
    return a([], e3, t3);
  }, Array: function(e3) {
    return a(e3);
  }, Matrix: function(e3) {
    return a(e3, e3.storage());
  }, "Array | Matrix, string": a, "Array | Matrix, string, string": a });
  function a(e3, t3, r2) {
    if ("dense" === t3 || "default" === t3 || void 0 === t3) return new n(e3, r2);
    if ("sparse" === t3) return new i2(e3, r2);
    throw new TypeError("Unknown matrix type " + JSON.stringify(t3) + ".");
  }
})), name$4z$1 = "matrixFromFunction", dependencies$4z$1 = ["typed", "matrix", "isZero"], createMatrixFromFunction$1 = factory$1(name$4z$1, dependencies$4z$1, ((e2) => {
  var { typed: t2, matrix: r, isZero: n } = e2;
  return t2(name$4z$1, { "Array | Matrix, function, string, string": function(e3, t3, r2, n3) {
    return i2(e3, t3, r2, n3);
  }, "Array | Matrix, function, string": function(e3, t3, r2) {
    return i2(e3, t3, r2);
  }, "Matrix, function": function(e3, t3) {
    return i2(e3, t3, "dense");
  }, "Array, function": function(e3, t3) {
    return i2(e3, t3, "dense").toArray();
  }, "Array | Matrix, string, function": function(e3, t3, r2) {
    return i2(e3, r2, t3);
  }, "Array | Matrix, string, string, function": function(e3, t3, r2, n3) {
    return i2(e3, n3, t3, r2);
  } });
  function i2(e3, t3, i3, a) {
    var o;
    return (o = void 0 !== a ? r(i3, a) : r(i3)).resize(e3), o.forEach((function(e4, r2) {
      var i4 = t3(r2);
      n(i4) || o.set(r2, i4);
    })), o;
  }
})), name$4y$1 = "matrixFromRows", dependencies$4y$1 = ["typed", "matrix", "flatten", "size"], createMatrixFromRows$1 = factory$1(name$4y$1, dependencies$4y$1, ((e2) => {
  var { typed: t2, matrix: r, flatten: n, size: i2 } = e2;
  return t2(name$4y$1, { "...Array": function(e3) {
    return a(e3);
  }, "...Matrix": function(e3) {
    return r(a(e3.map(((e4) => e4.toArray()))));
  } });
  function a(e3) {
    if (0 === e3.length) throw new TypeError("At least one row is needed to construct a matrix.");
    var t3 = o(e3[0]), r2 = [];
    for (var i3 of e3) {
      var a2 = o(i3);
      if (a2 !== t3) throw new TypeError("The vectors had different length: " + (0 | t3) + " ≠ " + (0 | a2));
      r2.push(n(i3));
    }
    return r2;
  }
  function o(e3) {
    var t3 = i2(e3);
    if (1 === t3.length) return t3[0];
    if (2 === t3.length) {
      if (1 === t3[0]) return t3[1];
      if (1 === t3[1]) return t3[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    }
    throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
})), name$4x$1 = "matrixFromColumns", dependencies$4x$1 = ["typed", "matrix", "flatten", "size"], createMatrixFromColumns$1 = factory$1(name$4x$1, dependencies$4x$1, ((e2) => {
  var { typed: t2, matrix: r, flatten: n, size: i2 } = e2;
  return t2(name$4x$1, { "...Array": function(e3) {
    return a(e3);
  }, "...Matrix": function(e3) {
    return r(a(e3.map(((e4) => e4.toArray()))));
  } });
  function a(e3) {
    if (0 === e3.length) throw new TypeError("At least one column is needed to construct a matrix.");
    for (var t3 = o(e3[0]), r2 = [], i3 = 0; i3 < t3; i3++) r2[i3] = [];
    for (var a2 of e3) {
      var s = o(a2);
      if (s !== t3) throw new TypeError("The vectors had different length: " + (0 | t3) + " ≠ " + (0 | s));
      for (var u = n(a2), c2 = 0; c2 < t3; c2++) r2[c2].push(u[c2]);
    }
    return r2;
  }
  function o(e3) {
    var t3 = i2(e3);
    if (1 === t3.length) return t3[0];
    if (2 === t3.length) {
      if (1 === t3[0]) return t3[1];
      if (1 === t3[1]) return t3[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    }
    throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
})), name$4w$1 = "splitUnit", dependencies$4w$1 = ["typed"], createSplitUnit$1 = factory$1(name$4w$1, dependencies$4w$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4w$1, { "Unit, Array": function(e3, t3) {
    return e3.splitUnit(t3);
  } });
})), name$4v$1 = "unaryMinus", dependencies$4v$1 = ["typed"], createUnaryMinus$1 = factory$1(name$4v$1, dependencies$4v$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4v$1, { number: unaryMinusNumber$1, "Complex | BigNumber | Fraction": (e3) => e3.neg(), bigint: (e3) => -e3, Unit: t2.referToSelf(((e3) => (r) => {
    var n = r.clone();
    return n.value = t2.find(e3, n.valueType())(r.value), n;
  })), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3, true))) });
})), name$4u$1 = "unaryPlus", dependencies$4u$1 = ["typed", "config", "numeric"], createUnaryPlus$1 = factory$1(name$4u$1, dependencies$4u$1, ((e2) => {
  var { typed: t2, config: r, numeric: n } = e2;
  return t2(name$4u$1, { number: unaryPlusNumber$1, Complex: function(e3) {
    return e3;
  }, BigNumber: function(e3) {
    return e3;
  }, bigint: function(e3) {
    return e3;
  }, Fraction: function(e3) {
    return e3;
  }, Unit: function(e3) {
    return e3.clone();
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3, true))), boolean: function(e3) {
    return n(e3 ? 1 : 0, r.number);
  }, string: function(e3) {
    return n(e3, safeNumberType$1(e3, r));
  } });
})), name$4t$1 = "abs", dependencies$4t$1 = ["typed"], createAbs$1 = factory$1(name$4t$1, dependencies$4t$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4t$1, { number: absNumber$1, "Complex | BigNumber | Fraction | Unit": (e3) => e3.abs(), bigint: (e3) => e3 < 0n ? -e3 : e3, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3, true))) });
})), name$4s$1 = "mapSlices", dependencies$4s$1 = ["typed", "isInteger"], createMapSlices$1 = factory$1(name$4s$1, dependencies$4s$1, ((e2) => {
  var { typed: t2, isInteger: r } = e2;
  return t2(name$4s$1, { "Array | Matrix, number | BigNumber, function": function(e3, t3, n) {
    if (!r(t3)) throw new TypeError("Integer number expected for dimension");
    var i2 = Array.isArray(e3) ? arraySize$1(e3) : e3.size();
    if (t3 < 0 || t3 >= i2.length) throw new IndexError$1(t3, i2.length);
    return isMatrix$1(e3) ? e3.create(_mapSlices$1(e3.valueOf(), t3, n), e3.datatype()) : _mapSlices$1(e3, t3, n);
  } });
}), { formerly: "apply" });
function _mapSlices$1(e2, t2, r) {
  var n, i2, a;
  if (t2 <= 0) {
    if (Array.isArray(e2[0])) {
      for (a = _switch$2(e2), i2 = [], n = 0; n < a.length; n++) i2[n] = _mapSlices$1(a[n], t2 - 1, r);
      return i2;
    }
    return r(e2);
  }
  for (i2 = [], n = 0; n < e2.length; n++) i2[n] = _mapSlices$1(e2[n], t2 - 1, r);
  return i2;
}
function _switch$2(e2) {
  var t2, r, n = e2.length, i2 = e2[0].length, a = [];
  for (r = 0; r < i2; r++) {
    var o = [];
    for (t2 = 0; t2 < n; t2++) o.push(e2[t2][r]);
    a.push(o);
  }
  return a;
}
var name$4r$1 = "addScalar", dependencies$4r$1 = ["typed"], createAddScalar$1 = factory$1(name$4r$1, dependencies$4r$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4r$1, { "number, number": addNumber$1, "Complex, Complex": function(e3, t3) {
    return e3.add(t3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return e3.plus(t3);
  }, "bigint, bigint": function(e3, t3) {
    return e3 + t3;
  }, "Fraction, Fraction": function(e3, t3) {
    return e3.add(t3);
  }, "Unit, Unit": t2.referToSelf(((e3) => (r, n) => {
    if (null === r.value || void 0 === r.value) throw new Error("Parameter x contains a unit with undefined value");
    if (null === n.value || void 0 === n.value) throw new Error("Parameter y contains a unit with undefined value");
    if (!r.equalBase(n)) throw new Error("Units do not match");
    var i2 = r.clone();
    return i2.value = t2.find(e3, [i2.valueType(), n.valueType()])(i2.value, n.value), i2.fixPrefix = false, i2;
  })) });
})), name$4q$1 = "subtractScalar", dependencies$4q$1 = ["typed"], createSubtractScalar$1 = factory$1(name$4q$1, dependencies$4q$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4q$1, { "number, number": subtractNumber$1, "Complex, Complex": function(e3, t3) {
    return e3.sub(t3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return e3.minus(t3);
  }, "bigint, bigint": function(e3, t3) {
    return e3 - t3;
  }, "Fraction, Fraction": function(e3, t3) {
    return e3.sub(t3);
  }, "Unit, Unit": t2.referToSelf(((e3) => (r, n) => {
    if (null === r.value || void 0 === r.value) throw new Error("Parameter x contains a unit with undefined value");
    if (null === n.value || void 0 === n.value) throw new Error("Parameter y contains a unit with undefined value");
    if (!r.equalBase(n)) throw new Error("Units do not match");
    var i2 = r.clone();
    return i2.value = t2.find(e3, [i2.valueType(), n.valueType()])(i2.value, n.value), i2.fixPrefix = false, i2;
  })) });
})), name$4p$1 = "cbrt", dependencies$4p$1 = ["config", "typed", "isNegative", "unaryMinus", "matrix", "Complex", "BigNumber", "Fraction"], createCbrt$1 = factory$1(name$4p$1, dependencies$4p$1, ((e2) => {
  var { config: t2, typed: r, isNegative: n, unaryMinus: i2, matrix: a, Complex: o, BigNumber: s, Fraction: u } = e2;
  return r(name$4p$1, { number: cbrtNumber$1, Complex: c2, "Complex, boolean": c2, BigNumber: function(e3) {
    return e3.cbrt();
  }, Unit: function(e3) {
    if (e3.value && isComplex$1(e3.value)) {
      var t3 = e3.clone();
      return t3.value = 1, (t3 = t3.pow(1 / 3)).value = c2(e3.value), t3;
    }
    var r2, a2 = n(e3.value);
    a2 && (e3.value = i2(e3.value)), r2 = isBigNumber$1(e3.value) ? new s(1).div(3) : isFraction$1(e3.value) ? new u(1, 3) : 1 / 3;
    var o2 = e3.pow(r2);
    return a2 && (o2.value = i2(o2.value)), o2;
  } });
  function c2(e3, r2) {
    var n3 = e3.arg() / 3, i3 = e3.abs(), s2 = new o(cbrtNumber$1(i3), 0).mul(new o(0, n3).exp());
    if (r2) {
      var u2 = [s2, new o(cbrtNumber$1(i3), 0).mul(new o(0, n3 + 2 * Math.PI / 3).exp()), new o(cbrtNumber$1(i3), 0).mul(new o(0, n3 - 2 * Math.PI / 3).exp())];
      return "Array" === t2.matrix ? u2 : a(u2);
    }
    return s2;
  }
})), name$4o$1 = "matAlgo11xS0s", dependencies$4o$1 = ["typed", "equalScalar"], createMatAlgo11xS0s$1 = factory$1(name$4o$1, dependencies$4o$1, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2, a) {
    var o = e3._values, s = e3._index, u = e3._ptr, c2 = e3._size, l = e3._datatype;
    if (!o) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f2, p = c2[0], m = c2[1], d = r, h = 0, g = i2;
    "string" == typeof l && (f2 = l, d = t2.find(r, [f2, f2]), h = t2.convert(0, f2), n = t2.convert(n, f2), g = t2.find(i2, [f2, f2]));
    for (var y = [], v2 = [], x2 = [], b2 = 0; b2 < m; b2++) {
      x2[b2] = v2.length;
      for (var _2 = u[b2], w2 = u[b2 + 1], A2 = _2; A2 < w2; A2++) {
        var N = s[A2], D = a ? g(n, o[A2]) : g(o[A2], n);
        d(D, h) || (v2.push(N), y.push(D));
      }
    }
    return x2[m] = v2.length, e3.createSparseMatrix({ values: y, index: v2, ptr: x2, size: [p, m], datatype: f2 });
  };
})), name$4n$1 = "matAlgo12xSfs", dependencies$4n$1 = ["typed", "DenseMatrix"], createMatAlgo12xSfs$1 = factory$1(name$4n$1, dependencies$4n$1, ((e2) => {
  var { typed: t2, DenseMatrix: r } = e2;
  return function(e3, n, i2, a) {
    var o = e3._values, s = e3._index, u = e3._ptr, c2 = e3._size, l = e3._datatype;
    if (!o) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f2, p = c2[0], m = c2[1], d = i2;
    "string" == typeof l && (f2 = l, n = t2.convert(n, f2), d = t2.find(i2, [f2, f2]));
    for (var h = [], g = [], y = [], v2 = 0; v2 < m; v2++) {
      for (var x2 = v2 + 1, b2 = u[v2], _2 = u[v2 + 1], w2 = b2; w2 < _2; w2++) {
        var A2 = s[w2];
        g[A2] = o[w2], y[A2] = x2;
      }
      for (var N = 0; N < p; N++) 0 === v2 && (h[N] = []), y[N] === x2 ? h[N][v2] = a ? d(n, g[N]) : d(g[N], n) : h[N][v2] = a ? d(n, 0) : d(0, n);
    }
    return new r({ data: h, size: [p, m], datatype: f2 });
  };
})), name$4m$1 = "matAlgo14xDs", dependencies$4m$1 = ["typed"], createMatAlgo14xDs$1 = factory$1(name$4m$1, dependencies$4m$1, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, n, i2, a) {
    var o, s = e3._data, u = e3._size, c2 = e3._datatype, l = i2;
    "string" == typeof c2 && (o = c2, n = t2.convert(n, o), l = t2.find(i2, [o, o]));
    var f2 = u.length > 0 ? r(l, 0, u, u[0], s, n, a) : [];
    return e3.createDenseMatrix({ data: f2, size: clone$3$1(u), datatype: o });
  };
  function r(e3, t3, n, i2, a, o, s) {
    var u = [];
    if (t3 === n.length - 1) for (var c2 = 0; c2 < i2; c2++) u[c2] = s ? e3(o, a[c2]) : e3(a[c2], o);
    else for (var l = 0; l < i2; l++) u[l] = r(e3, t3 + 1, n, n[t3 + 1], a[l], o, s);
    return u;
  }
})), name$4l$1 = "ceil", dependencies$4l$1 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], bigTen$1$1 = new Decimal$1(10), createCeilNumber$1 = factory$1(name$4l$1, ["typed", "config", "round"], ((e2) => {
  var { typed: t2, config: r, round: n } = e2;
  function i2(e3) {
    var t3 = Math.ceil(e3), i3 = n(e3);
    return t3 === i3 ? t3 : nearlyEqual$1$1(e3, i3, r.relTol, r.absTol) && !nearlyEqual$1$1(e3, t3, r.relTol, r.absTol) ? i3 : t3;
  }
  return t2(name$4l$1, { number: i2, "number, number": function(e3, t3) {
    if (!isInteger$1(t3)) throw new RangeError("number of decimals in function ceil must be an integer");
    if (t3 < 0 || t3 > 15) throw new RangeError("number of decimals in ceil number must be in range 0-15");
    var r2 = 10 ** t3;
    return i2(e3 * r2) / r2;
  } });
})), createCeil$1 = factory$1(name$4l$1, dependencies$4l$1, ((e2) => {
  var { typed: t2, config: r, round: n, matrix: i2, equalScalar: a, zeros: o, DenseMatrix: s } = e2, u = createMatAlgo11xS0s$1({ typed: t2, equalScalar: a }), c2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: s }), l = createMatAlgo14xDs$1({ typed: t2 }), f2 = createCeilNumber$1({ typed: t2, config: r, round: n });
  function p(e3) {
    var t3 = (e4, t4) => nearlyEqual$2(e4, t4, r.relTol, r.absTol), i3 = e3.ceil(), a2 = n(e3);
    return i3.eq(a2) ? i3 : t3(e3, a2) && !t3(e3, i3) ? a2 : i3;
  }
  return t2("ceil", { number: f2.signatures.number, "number,number": f2.signatures["number,number"], Complex: function(e3) {
    return e3.ceil();
  }, "Complex, number": function(e3, t3) {
    return e3.ceil(t3);
  }, "Complex, BigNumber": function(e3, t3) {
    return e3.ceil(t3.toNumber());
  }, BigNumber: p, "BigNumber, BigNumber": function(e3, t3) {
    var r2 = bigTen$1$1.pow(t3);
    return p(e3.mul(r2)).div(r2);
  }, bigint: (e3) => e3, "bigint, number": (e3, t3) => e3, "bigint, BigNumber": (e3, t3) => e3, Fraction: function(e3) {
    return e3.ceil();
  }, "Fraction, number": function(e3, t3) {
    return e3.ceil(t3);
  }, "Fraction, BigNumber": function(e3, t3) {
    return e3.ceil(t3.toNumber());
  }, "Unit, number, Unit": t2.referToSelf(((e3) => function(t3, r2, n3) {
    var i3 = t3.toNumeric(n3);
    return n3.multiply(e3(i3, r2));
  })), "Unit, BigNumber, Unit": t2.referToSelf(((e3) => (t3, r2, n3) => e3(t3, r2.toNumber(), n3))), "Array | Matrix, number | BigNumber, Unit": t2.referToSelf(((e3) => (t3, r2, n3) => deepMap$2(t3, ((t4) => e3(t4, r2, n3)), true))), "Array | Matrix | Unit, Unit": t2.referToSelf(((e3) => (t3, r2) => e3(t3, 0, r2))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3, true))), "Array, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => deepMap$2(t3, ((t4) => e3(t4, r2)), true))), "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => u(t3, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => l(t3, r2, e3, false))), "number | Complex | Fraction | BigNumber, Array": t2.referToSelf(((e3) => (t3, r2) => l(i2(r2), t3, e3, true).valueOf())), "number | Complex | Fraction | BigNumber, Matrix": t2.referToSelf(((e3) => (t3, r2) => a(t3, 0) ? o(r2.size(), r2.storage()) : "dense" === r2.storage() ? l(r2, t3, e3, true) : c2(r2, t3, e3, true))) });
})), name$4k$1 = "cube", dependencies$4k$1 = ["typed"], createCube$1 = factory$1(name$4k$1, dependencies$4k$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4k$1, { number: cubeNumber$1, Complex: function(e3) {
    return e3.mul(e3).mul(e3);
  }, BigNumber: function(e3) {
    return e3.times(e3).times(e3);
  }, bigint: function(e3) {
    return e3 * e3 * e3;
  }, Fraction: function(e3) {
    return e3.pow(3);
  }, Unit: function(e3) {
    return e3.pow(3);
  } });
})), name$4j$1 = "exp", dependencies$4j$1 = ["typed"], createExp$1 = factory$1(name$4j$1, dependencies$4j$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4j$1, { number: expNumber$1, Complex: function(e3) {
    return e3.exp();
  }, BigNumber: function(e3) {
    return e3.exp();
  } });
})), name$4i$1 = "expm1", dependencies$4i$1 = ["typed", "Complex"], createExpm1$1 = factory$1(name$4i$1, dependencies$4i$1, ((e2) => {
  var { typed: t2, Complex: r } = e2;
  return t2(name$4i$1, { number: expm1Number$1, Complex: function(e3) {
    var t3 = Math.exp(e3.re);
    return new r(t3 * Math.cos(e3.im) - 1, t3 * Math.sin(e3.im));
  }, BigNumber: function(e3) {
    return e3.exp().minus(1);
  } });
})), name$4h$1 = "fix", dependencies$4h$1 = ["typed", "Complex", "matrix", "ceil", "floor", "equalScalar", "zeros", "DenseMatrix"], createFixNumber$1 = factory$1(name$4h$1, ["typed", "ceil", "floor"], ((e2) => {
  var { typed: t2, ceil: r, floor: n } = e2;
  return t2(name$4h$1, { number: function(e3) {
    return e3 > 0 ? n(e3) : r(e3);
  }, "number, number": function(e3, t3) {
    return e3 > 0 ? n(e3, t3) : r(e3, t3);
  } });
})), createFix$1 = factory$1(name$4h$1, dependencies$4h$1, ((e2) => {
  var { typed: t2, Complex: r, matrix: n, ceil: i2, floor: a, equalScalar: o, zeros: s, DenseMatrix: u } = e2, c2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: u }), l = createMatAlgo14xDs$1({ typed: t2 }), f2 = createFixNumber$1({ typed: t2, ceil: i2, floor: a });
  return t2("fix", { number: f2.signatures.number, "number, number | BigNumber": f2.signatures["number,number"], Complex: function(e3) {
    return new r(e3.re > 0 ? Math.floor(e3.re) : Math.ceil(e3.re), e3.im > 0 ? Math.floor(e3.im) : Math.ceil(e3.im));
  }, "Complex, number": function(e3, t3) {
    return new r(e3.re > 0 ? a(e3.re, t3) : i2(e3.re, t3), e3.im > 0 ? a(e3.im, t3) : i2(e3.im, t3));
  }, "Complex, BigNumber": function(e3, t3) {
    var n3 = t3.toNumber();
    return new r(e3.re > 0 ? a(e3.re, n3) : i2(e3.re, n3), e3.im > 0 ? a(e3.im, n3) : i2(e3.im, n3));
  }, BigNumber: function(e3) {
    return e3.isNegative() ? i2(e3) : a(e3);
  }, "BigNumber, number | BigNumber": function(e3, t3) {
    return e3.isNegative() ? i2(e3, t3) : a(e3, t3);
  }, bigint: (e3) => e3, "bigint, number": (e3, t3) => e3, "bigint, BigNumber": (e3, t3) => e3, Fraction: function(e3) {
    return e3.s < 0n ? e3.ceil() : e3.floor();
  }, "Fraction, number | BigNumber": function(e3, t3) {
    return e3.s < 0n ? i2(e3, t3) : a(e3, t3);
  }, "Unit, number, Unit": t2.referToSelf(((e3) => function(t3, r2, n3) {
    var i3 = t3.toNumeric(n3);
    return n3.multiply(e3(i3, r2));
  })), "Unit, BigNumber, Unit": t2.referToSelf(((e3) => (t3, r2, n3) => e3(t3, r2.toNumber(), n3))), "Array | Matrix, number | BigNumber, Unit": t2.referToSelf(((e3) => (t3, r2, n3) => deepMap$2(t3, ((t4) => e3(t4, r2, n3)), true))), "Array | Matrix | Unit, Unit": t2.referToSelf(((e3) => (t3, r2) => e3(t3, 0, r2))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3, true))), "Array | Matrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => deepMap$2(t3, ((t4) => e3(t4, r2)), true))), "number | Complex | Fraction | BigNumber, Array": t2.referToSelf(((e3) => (t3, r2) => l(n(r2), t3, e3, true).valueOf())), "number | Complex | Fraction | BigNumber, Matrix": t2.referToSelf(((e3) => (t3, r2) => o(t3, 0) ? s(r2.size(), r2.storage()) : "dense" === r2.storage() ? l(r2, t3, e3, true) : c2(r2, t3, e3, true))) });
})), name$4g$1 = "floor", dependencies$4g$1 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], bigTen$2 = new Decimal$1(10), createFloorNumber$1 = factory$1(name$4g$1, ["typed", "config", "round"], ((e2) => {
  var { typed: t2, config: r, round: n } = e2;
  function i2(e3) {
    var t3 = Math.floor(e3), i3 = n(e3);
    return t3 === i3 ? t3 : nearlyEqual$1$1(e3, i3, r.relTol, r.absTol) && !nearlyEqual$1$1(e3, t3, r.relTol, r.absTol) ? i3 : t3;
  }
  return t2(name$4g$1, { number: i2, "number, number": function(e3, t3) {
    if (!isInteger$1(t3)) throw new RangeError("number of decimals in function floor must be an integer");
    if (t3 < 0 || t3 > 15) throw new RangeError("number of decimals in floor number must be in range 0 - 15");
    var r2 = 10 ** t3;
    return i2(e3 * r2) / r2;
  } });
})), createFloor$1 = factory$1(name$4g$1, dependencies$4g$1, ((e2) => {
  var { typed: t2, config: r, round: n, matrix: i2, equalScalar: a, zeros: o, DenseMatrix: s } = e2, u = createMatAlgo11xS0s$1({ typed: t2, equalScalar: a }), c2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: s }), l = createMatAlgo14xDs$1({ typed: t2 }), f2 = createFloorNumber$1({ typed: t2, config: r, round: n });
  function p(e3) {
    var t3 = (e4, t4) => nearlyEqual$2(e4, t4, r.relTol, r.absTol), i3 = e3.floor(), a2 = n(e3);
    return i3.eq(a2) ? i3 : t3(e3, a2) && !t3(e3, i3) ? a2 : i3;
  }
  return t2("floor", { number: f2.signatures.number, "number,number": f2.signatures["number,number"], Complex: function(e3) {
    return e3.floor();
  }, "Complex, number": function(e3, t3) {
    return e3.floor(t3);
  }, "Complex, BigNumber": function(e3, t3) {
    return e3.floor(t3.toNumber());
  }, BigNumber: p, "BigNumber, BigNumber": function(e3, t3) {
    var r2 = bigTen$2.pow(t3);
    return p(e3.mul(r2)).div(r2);
  }, bigint: (e3) => e3, "bigint, number": (e3, t3) => e3, "bigint, BigNumber": (e3, t3) => e3, Fraction: function(e3) {
    return e3.floor();
  }, "Fraction, number": function(e3, t3) {
    return e3.floor(t3);
  }, "Fraction, BigNumber": function(e3, t3) {
    return e3.floor(t3.toNumber());
  }, "Unit, number, Unit": t2.referToSelf(((e3) => function(t3, r2, n3) {
    var i3 = t3.toNumeric(n3);
    return n3.multiply(e3(i3, r2));
  })), "Unit, BigNumber, Unit": t2.referToSelf(((e3) => (t3, r2, n3) => e3(t3, r2.toNumber(), n3))), "Array | Matrix, number | BigNumber, Unit": t2.referToSelf(((e3) => (t3, r2, n3) => deepMap$2(t3, ((t4) => e3(t4, r2, n3)), true))), "Array | Matrix | Unit, Unit": t2.referToSelf(((e3) => (t3, r2) => e3(t3, 0, r2))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3, true))), "Array, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => deepMap$2(t3, ((t4) => e3(t4, r2)), true))), "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => u(t3, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => l(t3, r2, e3, false))), "number | Complex | Fraction | BigNumber, Array": t2.referToSelf(((e3) => (t3, r2) => l(i2(r2), t3, e3, true).valueOf())), "number | Complex | Fraction | BigNumber, Matrix": t2.referToSelf(((e3) => (t3, r2) => a(t3, 0) ? o(r2.size(), r2.storage()) : "dense" === r2.storage() ? l(r2, t3, e3, true) : c2(r2, t3, e3, true))) });
})), name$4f$1 = "matAlgo02xDS0", dependencies$4f$1 = ["typed", "equalScalar"], createMatAlgo02xDS0$1 = factory$1(name$4f$1, dependencies$4f$1, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2, a) {
    var o = e3._data, s = e3._size, u = e3._datatype || e3.getDataType(), c2 = n._values, l = n._index, f2 = n._ptr, p = n._size, m = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (s.length !== p.length) throw new DimensionError$1(s.length, p.length);
    if (s[0] !== p[0] || s[1] !== p[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + p + ")");
    if (!c2) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var d, h = s[0], g = s[1], y = r, v2 = 0, x2 = i2;
    "string" == typeof u && u === m && "mixed" !== u && (d = u, y = t2.find(r, [d, d]), v2 = t2.convert(0, d), x2 = t2.find(i2, [d, d]));
    for (var b2 = [], _2 = [], w2 = [], A2 = 0; A2 < g; A2++) {
      w2[A2] = _2.length;
      for (var N = f2[A2], D = f2[A2 + 1], E = N; E < D; E++) {
        var $2 = l[E], S2 = a ? x2(c2[E], o[$2][A2]) : x2(o[$2][A2], c2[E]);
        y(S2, v2) || (_2.push($2), b2.push(S2));
      }
    }
    return w2[g] = _2.length, n.createSparseMatrix({ values: b2, index: _2, ptr: w2, size: [h, g], datatype: u === e3._datatype && m === n._datatype ? d : void 0 });
  };
})), name$4e$1 = "matAlgo03xDSf", dependencies$4e$1 = ["typed"], createMatAlgo03xDSf$1 = factory$1(name$4e$1, dependencies$4e$1, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, r, n, i2) {
    var a = e3._data, o = e3._size, s = e3._datatype || e3.getDataType(), u = r._values, c2 = r._index, l = r._ptr, f2 = r._size, p = r._datatype || void 0 === r._data ? r._datatype : r.getDataType();
    if (o.length !== f2.length) throw new DimensionError$1(o.length, f2.length);
    if (o[0] !== f2[0] || o[1] !== f2[1]) throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + f2 + ")");
    if (!u) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var m, d = o[0], h = o[1], g = 0, y = n;
    "string" == typeof s && s === p && "mixed" !== s && (m = s, g = t2.convert(0, m), y = t2.find(n, [m, m]));
    for (var v2 = [], x2 = 0; x2 < d; x2++) v2[x2] = [];
    for (var b2 = [], _2 = [], w2 = 0; w2 < h; w2++) {
      for (var A2 = w2 + 1, N = l[w2], D = l[w2 + 1], E = N; E < D; E++) {
        var $2 = c2[E];
        b2[$2] = i2 ? y(u[E], a[$2][w2]) : y(a[$2][w2], u[E]), _2[$2] = A2;
      }
      for (var S2 = 0; S2 < d; S2++) _2[S2] === A2 ? v2[S2][w2] = b2[S2] : v2[S2][w2] = i2 ? y(g, a[S2][w2]) : y(a[S2][w2], g);
    }
    return e3.createDenseMatrix({ data: v2, size: [d, h], datatype: s === e3._datatype && p === r._datatype ? m : void 0 });
  };
})), name$4d$1 = "matAlgo05xSfSf", dependencies$4d$1 = ["typed", "equalScalar"], createMatAlgo05xSfSf$1 = factory$1(name$4d$1, dependencies$4d$1, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._index, s = e3._ptr, u = e3._size, c2 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l = n._values, f2 = n._index, p = n._ptr, m = n._size, d = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (u.length !== m.length) throw new DimensionError$1(u.length, m.length);
    if (u[0] !== m[0] || u[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + m + ")");
    var h, g = u[0], y = u[1], v2 = r, x2 = 0, b2 = i2;
    "string" == typeof c2 && c2 === d && "mixed" !== c2 && (h = c2, v2 = t2.find(r, [h, h]), x2 = t2.convert(0, h), b2 = t2.find(i2, [h, h]));
    var _2, w2, A2, N, D = a && l ? [] : void 0, E = [], $2 = [], S2 = D ? [] : void 0, C2 = D ? [] : void 0, M2 = [], T2 = [];
    for (w2 = 0; w2 < y; w2++) {
      $2[w2] = E.length;
      var F = w2 + 1;
      for (A2 = s[w2], N = s[w2 + 1]; A2 < N; A2++) _2 = o[A2], E.push(_2), M2[_2] = F, S2 && (S2[_2] = a[A2]);
      for (A2 = p[w2], N = p[w2 + 1]; A2 < N; A2++) M2[_2 = f2[A2]] !== F && E.push(_2), T2[_2] = F, C2 && (C2[_2] = l[A2]);
      if (D) for (A2 = $2[w2]; A2 < E.length; ) {
        var O2 = M2[_2 = E[A2]], k2 = T2[_2];
        if (O2 === F || k2 === F) {
          var B2 = b2(O2 === F ? S2[_2] : x2, k2 === F ? C2[_2] : x2);
          v2(B2, x2) ? E.splice(A2, 1) : (D.push(B2), A2++);
        }
      }
    }
    return $2[y] = E.length, e3.createSparseMatrix({ values: D, index: E, ptr: $2, size: [g, y], datatype: c2 === e3._datatype && d === n._datatype ? h : void 0 });
  };
})), name$4c$1 = "matAlgo13xDD", dependencies$4c$1 = ["typed"], createMatAlgo13xDD$1 = factory$1(name$4c$1, dependencies$4c$1, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, n, i2) {
    var a, o = e3._data, s = e3._size, u = e3._datatype, c2 = n._data, l = n._size, f2 = n._datatype, p = [];
    if (s.length !== l.length) throw new DimensionError$1(s.length, l.length);
    for (var m = 0; m < s.length; m++) {
      if (s[m] !== l[m]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + l + ")");
      p[m] = s[m];
    }
    var d = i2;
    "string" == typeof u && u === f2 && (a = u, d = t2.find(i2, [a, a]));
    var h = p.length > 0 ? r(d, 0, p, p[0], o, c2) : [];
    return e3.createDenseMatrix({ data: h, size: p, datatype: a });
  };
  function r(e3, t3, n, i2, a, o) {
    var s = [];
    if (t3 === n.length - 1) for (var u = 0; u < i2; u++) s[u] = e3(a[u], o[u]);
    else for (var c2 = 0; c2 < i2; c2++) s[c2] = r(e3, t3 + 1, n, n[t3 + 1], a[c2], o[c2]);
    return s;
  }
}));
function broadcast$1(e2, t2) {
  if (deepStrictEqual$1(e2.size(), t2.size())) return [e2, t2];
  var r = broadcastSizes$1(e2.size(), t2.size());
  return [e2, t2].map(((e3) => _broadcastTo$1(e3, r)));
}
function _broadcastTo$1(e2, t2) {
  return deepStrictEqual$1(e2.size(), t2) ? e2 : e2.create(broadcastTo$1(e2.valueOf(), t2), e2.datatype());
}
var name$4b$1 = "matrixAlgorithmSuite", dependencies$4b$1 = ["typed", "matrix"], createMatrixAlgorithmSuite$1 = factory$1(name$4b$1, dependencies$4b$1, ((e2) => {
  var { typed: t2, matrix: r } = e2, n = createMatAlgo13xDD$1({ typed: t2 }), i2 = createMatAlgo14xDs$1({ typed: t2 });
  return function(e3) {
    var a, o = e3.elop, s = e3.SD || e3.DS;
    o ? (a = { "DenseMatrix, DenseMatrix": (e4, t3) => n(...broadcast$1(e4, t3), o), "Array, Array": (e4, t3) => n(...broadcast$1(r(e4), r(t3)), o).valueOf(), "Array, DenseMatrix": (e4, t3) => n(...broadcast$1(r(e4), t3), o), "DenseMatrix, Array": (e4, t3) => n(...broadcast$1(e4, r(t3)), o) }, e3.SS && (a["SparseMatrix, SparseMatrix"] = (t3, r2) => e3.SS(...broadcast$1(t3, r2), o, false)), e3.DS && (a["DenseMatrix, SparseMatrix"] = (t3, r2) => e3.DS(...broadcast$1(t3, r2), o, false), a["Array, SparseMatrix"] = (t3, n3) => e3.DS(...broadcast$1(r(t3), n3), o, false)), s && (a["SparseMatrix, DenseMatrix"] = (e4, t3) => s(...broadcast$1(t3, e4), o, true), a["SparseMatrix, Array"] = (e4, t3) => s(...broadcast$1(r(t3), e4), o, true))) : (a = { "DenseMatrix, DenseMatrix": t2.referToSelf(((e4) => (t3, r2) => n(...broadcast$1(t3, r2), e4))), "Array, Array": t2.referToSelf(((e4) => (t3, i3) => n(...broadcast$1(r(t3), r(i3)), e4).valueOf())), "Array, DenseMatrix": t2.referToSelf(((e4) => (t3, i3) => n(...broadcast$1(r(t3), i3), e4))), "DenseMatrix, Array": t2.referToSelf(((e4) => (t3, i3) => n(...broadcast$1(t3, r(i3)), e4))) }, e3.SS && (a["SparseMatrix, SparseMatrix"] = t2.referToSelf(((t3) => (r2, n3) => e3.SS(...broadcast$1(r2, n3), t3, false)))), e3.DS && (a["DenseMatrix, SparseMatrix"] = t2.referToSelf(((t3) => (r2, n3) => e3.DS(...broadcast$1(r2, n3), t3, false))), a["Array, SparseMatrix"] = t2.referToSelf(((t3) => (n3, i3) => e3.DS(...broadcast$1(r(n3), i3), t3, false)))), s && (a["SparseMatrix, DenseMatrix"] = t2.referToSelf(((e4) => (t3, r2) => s(...broadcast$1(r2, t3), e4, true))), a["SparseMatrix, Array"] = t2.referToSelf(((e4) => (t3, n3) => s(...broadcast$1(r(n3), t3), e4, true)))));
    var u = e3.scalar || "any";
    (e3.Ds || e3.Ss) && (o ? (a["DenseMatrix," + u] = (e4, t3) => i2(e4, t3, o, false), a[u + ", DenseMatrix"] = (e4, t3) => i2(t3, e4, o, true), a["Array," + u] = (e4, t3) => i2(r(e4), t3, o, false).valueOf(), a[u + ", Array"] = (e4, t3) => i2(r(t3), e4, o, true).valueOf()) : (a["DenseMatrix," + u] = t2.referToSelf(((e4) => (t3, r2) => i2(t3, r2, e4, false))), a[u + ", DenseMatrix"] = t2.referToSelf(((e4) => (t3, r2) => i2(r2, t3, e4, true))), a["Array," + u] = t2.referToSelf(((e4) => (t3, n3) => i2(r(t3), n3, e4, false).valueOf())), a[u + ", Array"] = t2.referToSelf(((e4) => (t3, n3) => i2(r(n3), t3, e4, true).valueOf()))));
    var c2 = void 0 !== e3.sS ? e3.sS : e3.Ss;
    return o ? (e3.Ss && (a["SparseMatrix," + u] = (t3, r2) => e3.Ss(t3, r2, o, false)), c2 && (a[u + ", SparseMatrix"] = (e4, t3) => c2(t3, e4, o, true))) : (e3.Ss && (a["SparseMatrix," + u] = t2.referToSelf(((t3) => (r2, n3) => e3.Ss(r2, n3, t3, false)))), c2 && (a[u + ", SparseMatrix"] = t2.referToSelf(((e4) => (t3, r2) => c2(r2, t3, e4, true))))), o && o.signatures && extend$2$1(a, o.signatures), a;
  };
})), name$4a$1 = "mod", dependencies$4a$1 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createMod$1 = factory$1(name$4a$1, dependencies$4a$1, ((e2) => {
  var { typed: t2, config: r, round: n, matrix: i2, equalScalar: a, zeros: o, DenseMatrix: s, concat: u } = e2, c2 = createFloor$1({ typed: t2, config: r, round: n, matrix: i2, equalScalar: a, zeros: o, DenseMatrix: s }), l = createMatAlgo02xDS0$1({ typed: t2, equalScalar: a }), f2 = createMatAlgo03xDSf$1({ typed: t2 }), p = createMatAlgo05xSfSf$1({ typed: t2, equalScalar: a }), m = createMatAlgo11xS0s$1({ typed: t2, equalScalar: a }), d = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: s }), h = createMatrixAlgorithmSuite$1({ typed: t2, matrix: i2, concat: u });
  return t2(name$4a$1, { "number, number": function(e3, t3) {
    return 0 === t3 ? e3 : e3 - t3 * c2(e3 / t3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return t3.isZero() ? e3 : e3.sub(t3.mul(c2(e3.div(t3))));
  }, "bigint, bigint": function(e3, t3) {
    if (0n === t3) return e3;
    if (e3 < 0) {
      var r2 = e3 % t3;
      return 0n === r2 ? r2 : r2 + t3;
    }
    return e3 % t3;
  }, "Fraction, Fraction": function(e3, t3) {
    return t3.equals(0) ? e3 : e3.sub(t3.mul(c2(e3.div(t3))));
  } }, h({ SS: p, DS: f2, SD: l, Ss: m, sS: d }));
})), name$49$1 = "matAlgo01xDSid", dependencies$49$1 = ["typed"], createMatAlgo01xDSid$1 = factory$1(name$49$1, dependencies$49$1, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, r, n, i2) {
    var a = e3._data, o = e3._size, s = e3._datatype || e3.getDataType(), u = r._values, c2 = r._index, l = r._ptr, f2 = r._size, p = r._datatype || void 0 === r._data ? r._datatype : r.getDataType();
    if (o.length !== f2.length) throw new DimensionError$1(o.length, f2.length);
    if (o[0] !== f2[0] || o[1] !== f2[1]) throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + f2 + ")");
    if (!u) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var m, d, h = o[0], g = o[1], y = "string" == typeof s && "mixed" !== s && s === p ? s : void 0, v2 = y ? t2.find(n, [y, y]) : n, x2 = [];
    for (m = 0; m < h; m++) x2[m] = [];
    var b2 = [], _2 = [];
    for (d = 0; d < g; d++) {
      for (var w2 = d + 1, A2 = l[d], N = l[d + 1], D = A2; D < N; D++) b2[m = c2[D]] = i2 ? v2(u[D], a[m][d]) : v2(a[m][d], u[D]), _2[m] = w2;
      for (m = 0; m < h; m++) _2[m] === w2 ? x2[m][d] = b2[m] : x2[m][d] = a[m][d];
    }
    return e3.createDenseMatrix({ data: x2, size: [h, g], datatype: s === e3._datatype && p === r._datatype ? y : void 0 });
  };
})), name$48$1 = "matAlgo04xSidSid", dependencies$48$1 = ["typed", "equalScalar"], createMatAlgo04xSidSid$1 = factory$1(name$48$1, dependencies$48$1, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._index, s = e3._ptr, u = e3._size, c2 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l = n._values, f2 = n._index, p = n._ptr, m = n._size, d = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (u.length !== m.length) throw new DimensionError$1(u.length, m.length);
    if (u[0] !== m[0] || u[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + m + ")");
    var h, g = u[0], y = u[1], v2 = r, x2 = 0, b2 = i2;
    "string" == typeof c2 && c2 === d && "mixed" !== c2 && (h = c2, v2 = t2.find(r, [h, h]), x2 = t2.convert(0, h), b2 = t2.find(i2, [h, h]));
    var _2, w2, A2, N, D, E = a && l ? [] : void 0, $2 = [], S2 = [], C2 = a && l ? [] : void 0, M2 = a && l ? [] : void 0, T2 = [], F = [];
    for (w2 = 0; w2 < y; w2++) {
      S2[w2] = $2.length;
      var O2 = w2 + 1;
      for (N = s[w2], D = s[w2 + 1], A2 = N; A2 < D; A2++) _2 = o[A2], $2.push(_2), T2[_2] = O2, C2 && (C2[_2] = a[A2]);
      for (N = p[w2], D = p[w2 + 1], A2 = N; A2 < D; A2++) if (T2[_2 = f2[A2]] === O2) {
        if (C2) {
          var k2 = b2(C2[_2], l[A2]);
          v2(k2, x2) ? T2[_2] = null : C2[_2] = k2;
        }
      } else $2.push(_2), F[_2] = O2, M2 && (M2[_2] = l[A2]);
      if (C2 && M2) for (A2 = S2[w2]; A2 < $2.length; ) T2[_2 = $2[A2]] === O2 ? (E[A2] = C2[_2], A2++) : F[_2] === O2 ? (E[A2] = M2[_2], A2++) : $2.splice(A2, 1);
    }
    return S2[y] = $2.length, e3.createSparseMatrix({ values: E, index: $2, ptr: S2, size: [g, y], datatype: c2 === e3._datatype && d === n._datatype ? h : void 0 });
  };
})), name$47$1 = "matAlgo10xSids", dependencies$47$1 = ["typed", "DenseMatrix"], createMatAlgo10xSids$1 = factory$1(name$47$1, dependencies$47$1, ((e2) => {
  var { typed: t2, DenseMatrix: r } = e2;
  return function(e3, n, i2, a) {
    var o = e3._values, s = e3._index, u = e3._ptr, c2 = e3._size, l = e3._datatype;
    if (!o) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f2, p = c2[0], m = c2[1], d = i2;
    "string" == typeof l && (f2 = l, n = t2.convert(n, f2), d = t2.find(i2, [f2, f2]));
    for (var h = [], g = [], y = [], v2 = 0; v2 < m; v2++) {
      for (var x2 = v2 + 1, b2 = u[v2], _2 = u[v2 + 1], w2 = b2; w2 < _2; w2++) {
        var A2 = s[w2];
        g[A2] = o[w2], y[A2] = x2;
      }
      for (var N = 0; N < p; N++) 0 === v2 && (h[N] = []), y[N] === x2 ? h[N][v2] = a ? d(n, g[N]) : d(g[N], n) : h[N][v2] = n;
    }
    return new r({ data: h, size: [p, m], datatype: f2 });
  };
}));
function ArgumentsError$1(e2, t2, r, n) {
  if (!(this instanceof ArgumentsError$1)) throw new SyntaxError("Constructor must be called with the new operator");
  this.fn = e2, this.count = t2, this.min = r, this.max = n, this.message = "Wrong number of arguments in function " + e2 + " (" + t2 + " provided, " + r + (null != n ? "-" + n : "") + " expected)", this.stack = new Error().stack;
}
ArgumentsError$1.prototype = new Error(), ArgumentsError$1.prototype.constructor = Error, ArgumentsError$1.prototype.name = "ArgumentsError", ArgumentsError$1.prototype.isArgumentsError = true;
var name$46$1 = "gcd", dependencies$46$1 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix", "concat"], gcdTypes$1 = "number | BigNumber | Fraction | Matrix | Array", gcdManyTypesSignature$1 = "".concat(gcdTypes$1, ", ").concat(gcdTypes$1, ", ...").concat(gcdTypes$1);
function is1d$1(e2) {
  return !e2.some(((e3) => Array.isArray(e3)));
}
var createGcd$1 = factory$1(name$46$1, dependencies$46$1, ((e2) => {
  var { typed: t2, matrix: r, config: n, round: i2, equalScalar: a, zeros: o, BigNumber: s, DenseMatrix: u, concat: c2 } = e2, l = createMod$1({ typed: t2, config: n, round: i2, matrix: r, equalScalar: a, zeros: o, DenseMatrix: u, concat: c2 }), f2 = createMatAlgo01xDSid$1({ typed: t2 }), p = createMatAlgo04xSidSid$1({ typed: t2, equalScalar: a }), m = createMatAlgo10xSids$1({ typed: t2, DenseMatrix: u }), d = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: c2 });
  return t2(name$46$1, { "number, number": function(e3, t3) {
    if (!isInteger$1(e3) || !isInteger$1(t3)) throw new Error("Parameters in function gcd must be integer numbers");
    var r2;
    for (; 0 !== t3; ) r2 = l(e3, t3), e3 = t3, t3 = r2;
    return e3 < 0 ? -e3 : e3;
  }, "BigNumber, BigNumber": function(e3, t3) {
    if (!e3.isInt() || !t3.isInt()) throw new Error("Parameters in function gcd must be integer numbers");
    var r2 = new s(0);
    for (; !t3.isZero(); ) {
      var n3 = l(e3, t3);
      e3 = t3, t3 = n3;
    }
    return e3.lt(r2) ? e3.neg() : e3;
  }, "Fraction, Fraction": (e3, t3) => e3.gcd(t3) }, d({ SS: p, DS: f2, Ss: m }), { [gcdManyTypesSignature$1]: t2.referToSelf(((e3) => (t3, r2, n3) => {
    for (var i3 = e3(t3, r2), a2 = 0; a2 < n3.length; a2++) i3 = e3(i3, n3[a2]);
    return i3;
  })), Array: t2.referToSelf(((e3) => (t3) => {
    if (1 === t3.length && Array.isArray(t3[0]) && is1d$1(t3[0])) return e3(...t3[0]);
    if (is1d$1(t3)) return e3(...t3);
    throw new ArgumentsError$1("gcd() supports only 1d matrices!");
  })), Matrix: t2.referToSelf(((e3) => (t3) => e3(t3.toArray()))) });
})), name$45$1 = "matAlgo06xS0S0", dependencies$45$1 = ["typed", "equalScalar"], createMatAlgo06xS0S0$1 = factory$1(name$45$1, dependencies$45$1, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._size, s = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), u = n._values, c2 = n._size, l = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (o.length !== c2.length) throw new DimensionError$1(o.length, c2.length);
    if (o[0] !== c2[0] || o[1] !== c2[1]) throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + c2 + ")");
    var f2, p = o[0], m = o[1], d = r, h = 0, g = i2;
    "string" == typeof s && s === l && "mixed" !== s && (f2 = s, d = t2.find(r, [f2, f2]), h = t2.convert(0, f2), g = t2.find(i2, [f2, f2]));
    for (var y = a && u ? [] : void 0, v2 = [], x2 = [], b2 = y ? [] : void 0, _2 = [], w2 = [], A2 = 0; A2 < m; A2++) {
      x2[A2] = v2.length;
      var N = A2 + 1;
      if (scatter$1(e3, A2, _2, b2, w2, N, v2, g), scatter$1(n, A2, _2, b2, w2, N, v2, g), b2) for (var D = x2[A2]; D < v2.length; ) {
        var E = v2[D];
        if (w2[E] === N) {
          var $2 = b2[E];
          d($2, h) ? v2.splice(D, 1) : (y.push($2), D++);
        } else v2.splice(D, 1);
      }
      else for (var S2 = x2[A2]; S2 < v2.length; ) {
        w2[v2[S2]] !== N ? v2.splice(S2, 1) : S2++;
      }
    }
    return x2[m] = v2.length, e3.createSparseMatrix({ values: y, index: v2, ptr: x2, size: [p, m], datatype: s === e3._datatype && l === n._datatype ? f2 : void 0 });
  };
})), name$44$1 = "lcm", dependencies$44$1 = ["typed", "matrix", "equalScalar", "concat"], createLcm$1 = factory$1(name$44$1, dependencies$44$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, concat: i2 } = e2, a = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), o = createMatAlgo06xS0S0$1({ typed: t2, equalScalar: n }), s = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), u = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: i2 }), c2 = "number | BigNumber | Fraction | Matrix | Array", l = {};
  return l["".concat(c2, ", ").concat(c2, ", ...").concat(c2)] = t2.referToSelf(((e3) => (t3, r2, n3) => {
    for (var i3 = e3(t3, r2), a2 = 0; a2 < n3.length; a2++) i3 = e3(i3, n3[a2]);
    return i3;
  })), t2(name$44$1, { "number, number": lcmNumber$1, "BigNumber, BigNumber": function(e3, t3) {
    if (!e3.isInt() || !t3.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
    if (e3.isZero()) return e3;
    if (t3.isZero()) return t3;
    var r2 = e3.times(t3);
    for (; !t3.isZero(); ) {
      var n3 = t3;
      t3 = e3.mod(n3), e3 = n3;
    }
    return r2.div(e3).abs();
  }, "Fraction, Fraction": (e3, t3) => e3.lcm(t3) }, u({ SS: o, DS: a, Ss: s }), l);
}));
function promoteLogarithm$1(e2, t2, r, n) {
  return function(i2) {
    if (i2 > 0 || r.predictable) {
      if (i2 <= 0) return NaN;
      var a = i2.toString(16), o = a.substring(0, 15);
      return e2 * (a.length - o.length) + t2(Number("0x" + o));
    }
    return n(i2.toNumber());
  };
}
var name$43$1 = "log10", dependencies$43$1 = ["typed", "config", "Complex"], log16$1 = log10Number$1(16), createLog10$1 = factory$1(name$43$1, dependencies$43$1, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  function i2(e3) {
    return e3.log().div(Math.LN10);
  }
  function a(e3) {
    return i2(new n(e3, 0));
  }
  return t2(name$43$1, { number: function(e3) {
    return e3 >= 0 || r.predictable ? log10Number$1(e3) : a(e3);
  }, bigint: promoteLogarithm$1(log16$1, log10Number$1, r, a), Complex: i2, BigNumber: function(e3) {
    return !e3.isNegative() || r.predictable ? e3.log() : a(e3.toNumber());
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$42$1 = "log2", dependencies$42$1 = ["typed", "config", "Complex"], createLog2$1 = factory$1(name$42$1, dependencies$42$1, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  function i2(e3) {
    return a(new n(e3, 0));
  }
  return t2(name$42$1, { number: function(e3) {
    return e3 >= 0 || r.predictable ? log2Number$1(e3) : i2(e3);
  }, bigint: promoteLogarithm$1(4, log2Number$1, r, i2), Complex: a, BigNumber: function(e3) {
    return !e3.isNegative() || r.predictable ? e3.log(2) : i2(e3.toNumber());
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
  function a(e3) {
    var t3 = Math.sqrt(e3.re * e3.re + e3.im * e3.im);
    return new n(Math.log2 ? Math.log2(t3) : Math.log(t3) / Math.LN2, Math.atan2(e3.im, e3.re) / Math.LN2);
  }
})), name$41$1 = "multiplyScalar", dependencies$41$1 = ["typed"], createMultiplyScalar$1 = factory$1(name$41$1, dependencies$41$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2("multiplyScalar", { "number, number": multiplyNumber$1, "Complex, Complex": function(e3, t3) {
    return e3.mul(t3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return e3.times(t3);
  }, "bigint, bigint": function(e3, t3) {
    return e3 * t3;
  }, "Fraction, Fraction": function(e3, t3) {
    return e3.mul(t3);
  }, "number | Fraction | BigNumber | Complex, Unit": (e3, t3) => t3.multiply(e3), "Unit, number | Fraction | BigNumber | Complex | Unit": (e3, t3) => e3.multiply(t3) });
})), name$40$1 = "multiply", dependencies$40$1 = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], createMultiply$1 = factory$1(name$40$1, dependencies$40$1, ((e2) => {
  var { typed: t2, matrix: r, addScalar: n, multiplyScalar: i2, equalScalar: a, dot: o } = e2, s = createMatAlgo11xS0s$1({ typed: t2, equalScalar: a }), u = createMatAlgo14xDs$1({ typed: t2 });
  function c2(e3, t3) {
    switch (e3.length) {
      case 1:
        switch (t3.length) {
          case 1:
            if (e3[0] !== t3[0]) throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (e3[0] !== t3[0]) throw new RangeError("Dimension mismatch in multiplication. Vector length (" + e3[0] + ") must match Matrix rows (" + t3[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + t3.length + " dimensions)");
        }
        break;
      case 2:
        switch (t3.length) {
          case 1:
            if (e3[1] !== t3[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + e3[1] + ") must match Vector length (" + t3[0] + ")");
            break;
          case 2:
            if (e3[1] !== t3[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + e3[1] + ") must match Matrix B rows (" + t3[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + t3.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + e3.length + " dimensions)");
    }
  }
  function l(e3, r2) {
    if ("dense" !== r2.storage()) throw new Error("Support for SparseMatrix not implemented");
    return (function(e4, r3) {
      var a2, o2 = e4._data, s2 = e4._size, u2 = e4._datatype || e4.getDataType(), c3 = r3._data, l2 = r3._size, f3 = r3._datatype || r3.getDataType(), p2 = s2[0], m = l2[1], d = n, h = i2;
      u2 && f3 && u2 === f3 && "string" == typeof u2 && "mixed" !== u2 && (a2 = u2, d = t2.find(n, [a2, a2]), h = t2.find(i2, [a2, a2]));
      for (var g = [], y = 0; y < m; y++) {
        for (var v2 = h(o2[0], c3[0][y]), x2 = 1; x2 < p2; x2++) v2 = d(v2, h(o2[x2], c3[x2][y]));
        g[y] = v2;
      }
      return e4.createDenseMatrix({ data: g, size: [m], datatype: u2 === e4._datatype && f3 === r3._datatype ? a2 : void 0 });
    })(e3, r2);
  }
  var f2 = t2("_multiplyMatrixVector", { "DenseMatrix, any": function(e3, r2) {
    var a2, o2 = e3._data, s2 = e3._size, u2 = e3._datatype || e3.getDataType(), c3 = r2._data, l2 = r2._datatype || r2.getDataType(), f3 = s2[0], p2 = s2[1], m = n, d = i2;
    u2 && l2 && u2 === l2 && "string" == typeof u2 && "mixed" !== u2 && (a2 = u2, m = t2.find(n, [a2, a2]), d = t2.find(i2, [a2, a2]));
    for (var h = [], g = 0; g < f3; g++) {
      for (var y = o2[g], v2 = d(y[0], c3[0]), x2 = 1; x2 < p2; x2++) v2 = m(v2, d(y[x2], c3[x2]));
      h[g] = v2;
    }
    return e3.createDenseMatrix({ data: h, size: [f3], datatype: u2 === e3._datatype && l2 === r2._datatype ? a2 : void 0 });
  }, "SparseMatrix, any": function(e3, r2) {
    var o2 = e3._values, s2 = e3._index, u2 = e3._ptr, c3 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType();
    if (!o2) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var l2, f3 = r2._data, p2 = r2._datatype || r2.getDataType(), m = e3._size[0], d = r2._size[0], h = [], g = [], y = [], v2 = n, x2 = i2, b2 = a, _2 = 0;
    c3 && p2 && c3 === p2 && "string" == typeof c3 && "mixed" !== c3 && (l2 = c3, v2 = t2.find(n, [l2, l2]), x2 = t2.find(i2, [l2, l2]), b2 = t2.find(a, [l2, l2]), _2 = t2.convert(0, l2));
    var w2 = [], A2 = [];
    y[0] = 0;
    for (var N = 0; N < d; N++) {
      var D = f3[N];
      if (!b2(D, _2)) for (var E = u2[N], $2 = u2[N + 1], S2 = E; S2 < $2; S2++) {
        var C2 = s2[S2];
        A2[C2] ? w2[C2] = v2(w2[C2], x2(D, o2[S2])) : (A2[C2] = true, g.push(C2), w2[C2] = x2(D, o2[S2]));
      }
    }
    for (var M2 = g.length, T2 = 0; T2 < M2; T2++) {
      var F = g[T2];
      h[T2] = w2[F];
    }
    return y[1] = g.length, e3.createSparseMatrix({ values: h, index: g, ptr: y, size: [m, 1], datatype: c3 === e3._datatype && p2 === r2._datatype ? l2 : void 0 });
  } }), p = t2("_multiplyMatrixMatrix", { "DenseMatrix, DenseMatrix": function(e3, r2) {
    var a2, o2 = e3._data, s2 = e3._size, u2 = e3._datatype || e3.getDataType(), c3 = r2._data, l2 = r2._size, f3 = r2._datatype || r2.getDataType(), p2 = s2[0], m = s2[1], d = l2[1], h = n, g = i2;
    u2 && f3 && u2 === f3 && "string" == typeof u2 && "mixed" !== u2 && "mixed" !== u2 && (a2 = u2, h = t2.find(n, [a2, a2]), g = t2.find(i2, [a2, a2]));
    for (var y = [], v2 = 0; v2 < p2; v2++) {
      var x2 = o2[v2];
      y[v2] = [];
      for (var b2 = 0; b2 < d; b2++) {
        for (var _2 = g(x2[0], c3[0][b2]), w2 = 1; w2 < m; w2++) _2 = h(_2, g(x2[w2], c3[w2][b2]));
        y[v2][b2] = _2;
      }
    }
    return e3.createDenseMatrix({ data: y, size: [p2, d], datatype: u2 === e3._datatype && f3 === r2._datatype ? a2 : void 0 });
  }, "DenseMatrix, SparseMatrix": function(e3, r2) {
    var o2 = e3._data, s2 = e3._size, u2 = e3._datatype || e3.getDataType(), c3 = r2._values, l2 = r2._index, f3 = r2._ptr, p2 = r2._size, m = r2._datatype || void 0 === r2._data ? r2._datatype : r2.getDataType();
    if (!c3) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var d, h = s2[0], g = p2[1], y = n, v2 = i2, x2 = a, b2 = 0;
    u2 && m && u2 === m && "string" == typeof u2 && "mixed" !== u2 && (d = u2, y = t2.find(n, [d, d]), v2 = t2.find(i2, [d, d]), x2 = t2.find(a, [d, d]), b2 = t2.convert(0, d));
    for (var _2 = [], w2 = [], A2 = [], N = r2.createSparseMatrix({ values: _2, index: w2, ptr: A2, size: [h, g], datatype: u2 === e3._datatype && m === r2._datatype ? d : void 0 }), D = 0; D < g; D++) {
      A2[D] = w2.length;
      var E = f3[D], $2 = f3[D + 1];
      if ($2 > E) for (var S2 = 0, C2 = 0; C2 < h; C2++) {
        for (var M2 = C2 + 1, T2 = void 0, F = E; F < $2; F++) {
          var O2 = l2[F];
          S2 !== M2 ? (T2 = v2(o2[C2][O2], c3[F]), S2 = M2) : T2 = y(T2, v2(o2[C2][O2], c3[F]));
        }
        S2 !== M2 || x2(T2, b2) || (w2.push(C2), _2.push(T2));
      }
    }
    return A2[g] = w2.length, N;
  }, "SparseMatrix, DenseMatrix": function(e3, r2) {
    var o2 = e3._values, s2 = e3._index, u2 = e3._ptr, c3 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType();
    if (!o2) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var l2, f3 = r2._data, p2 = r2._datatype || r2.getDataType(), m = e3._size[0], d = r2._size[0], h = r2._size[1], g = n, y = i2, v2 = a, x2 = 0;
    c3 && p2 && c3 === p2 && "string" == typeof c3 && "mixed" !== c3 && (l2 = c3, g = t2.find(n, [l2, l2]), y = t2.find(i2, [l2, l2]), v2 = t2.find(a, [l2, l2]), x2 = t2.convert(0, l2));
    for (var b2 = [], _2 = [], w2 = [], A2 = e3.createSparseMatrix({ values: b2, index: _2, ptr: w2, size: [m, h], datatype: c3 === e3._datatype && p2 === r2._datatype ? l2 : void 0 }), N = [], D = [], E = 0; E < h; E++) {
      w2[E] = _2.length;
      for (var $2 = E + 1, S2 = 0; S2 < d; S2++) {
        var C2 = f3[S2][E];
        if (!v2(C2, x2)) for (var M2 = u2[S2], T2 = u2[S2 + 1], F = M2; F < T2; F++) {
          var O2 = s2[F];
          D[O2] !== $2 ? (D[O2] = $2, _2.push(O2), N[O2] = y(C2, o2[F])) : N[O2] = g(N[O2], y(C2, o2[F]));
        }
      }
      for (var k2 = w2[E], B2 = _2.length, I2 = k2; I2 < B2; I2++) {
        var R2 = _2[I2];
        b2[I2] = N[R2];
      }
    }
    return w2[h] = _2.length, A2;
  }, "SparseMatrix, SparseMatrix": function(e3, r2) {
    var a2, o2 = e3._values, s2 = e3._index, u2 = e3._ptr, c3 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l2 = r2._values, f3 = r2._index, p2 = r2._ptr, m = r2._datatype || void 0 === r2._data ? r2._datatype : r2.getDataType(), d = e3._size[0], h = r2._size[1], g = o2 && l2, y = n, v2 = i2;
    c3 && m && c3 === m && "string" == typeof c3 && "mixed" !== c3 && (a2 = c3, y = t2.find(n, [a2, a2]), v2 = t2.find(i2, [a2, a2]));
    for (var x2, b2, _2, w2, A2, N, D, E, $2 = g ? [] : void 0, S2 = [], C2 = [], M2 = e3.createSparseMatrix({ values: $2, index: S2, ptr: C2, size: [d, h], datatype: c3 === e3._datatype && m === r2._datatype ? a2 : void 0 }), T2 = g ? [] : void 0, F = [], O2 = 0; O2 < h; O2++) {
      C2[O2] = S2.length;
      var k2 = O2 + 1;
      for (A2 = p2[O2], N = p2[O2 + 1], w2 = A2; w2 < N; w2++) if (E = f3[w2], g) for (b2 = u2[E], _2 = u2[E + 1], x2 = b2; x2 < _2; x2++) F[D = s2[x2]] !== k2 ? (F[D] = k2, S2.push(D), T2[D] = v2(l2[w2], o2[x2])) : T2[D] = y(T2[D], v2(l2[w2], o2[x2]));
      else for (b2 = u2[E], _2 = u2[E + 1], x2 = b2; x2 < _2; x2++) F[D = s2[x2]] !== k2 && (F[D] = k2, S2.push(D));
      if (g) for (var B2 = C2[O2], I2 = S2.length, R2 = B2; R2 < I2; R2++) {
        var q2 = S2[R2];
        $2[R2] = T2[q2];
      }
    }
    return C2[h] = S2.length, M2;
  } });
  return t2(name$40$1, i2, { "Array, Array": t2.referTo("Matrix, Matrix", ((e3) => (t3, n3) => {
    c2(arraySize$1(t3), arraySize$1(n3));
    var i3 = e3(r(t3), r(n3));
    return isMatrix$1(i3) ? i3.valueOf() : i3;
  })), "Matrix, Matrix": function(e3, t3) {
    var r2 = e3.size(), n3 = t3.size();
    return c2(r2, n3), 1 === r2.length ? 1 === n3.length ? (function(e4, t4, r3) {
      if (0 === r3) throw new Error("Cannot multiply two empty vectors");
      return o(e4, t4);
    })(e3, t3, r2[0]) : l(e3, t3) : 1 === n3.length ? f2(e3, t3) : p(e3, t3);
  }, "Matrix, Array": t2.referTo("Matrix,Matrix", ((e3) => (t3, n3) => e3(t3, r(n3)))), "Array, Matrix": t2.referToSelf(((e3) => (t3, n3) => e3(r(t3, n3.storage()), n3))), "SparseMatrix, any": function(e3, t3) {
    return s(e3, t3, i2, false);
  }, "DenseMatrix, any": function(e3, t3) {
    return u(e3, t3, i2, false);
  }, "any, SparseMatrix": function(e3, t3) {
    return s(t3, e3, i2, true);
  }, "any, DenseMatrix": function(e3, t3) {
    return u(t3, e3, i2, true);
  }, "Array, any": function(e3, t3) {
    return u(r(e3), t3, i2, false).valueOf();
  }, "any, Array": function(e3, t3) {
    return u(r(t3), e3, i2, true).valueOf();
  }, "any, any": i2, "any, any, ...any": t2.referToSelf(((e3) => (t3, r2, n3) => {
    for (var i3 = e3(t3, r2), a2 = 0; a2 < n3.length; a2++) i3 = e3(i3, n3[a2]);
    return i3;
  })) });
})), name$3$$1 = "nthRoot", dependencies$3$$1 = ["typed", "matrix", "equalScalar", "BigNumber", "concat"], createNthRoot$1 = factory$1(name$3$$1, dependencies$3$$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, BigNumber: i2, concat: a } = e2, o = createMatAlgo01xDSid$1({ typed: t2 }), s = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), u = createMatAlgo06xS0S0$1({ typed: t2, equalScalar: n }), c2 = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), l = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: a });
  function f2() {
    throw new Error("Complex number not supported in function nthRoot. Use nthRoots instead.");
  }
  return t2(name$3$$1, { number: nthRootNumber$1, "number, number": nthRootNumber$1, BigNumber: (e3) => p(e3, new i2(2)), "BigNumber, BigNumber": p, Complex: f2, "Complex, number": f2, Array: t2.referTo("DenseMatrix,number", ((e3) => (t3) => e3(r(t3), 2).valueOf())), DenseMatrix: t2.referTo("DenseMatrix,number", ((e3) => (t3) => e3(t3, 2))), SparseMatrix: t2.referTo("SparseMatrix,number", ((e3) => (t3) => e3(t3, 2))), "SparseMatrix, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => {
    if (1 === r2.density()) return u(t3, r2, e3);
    throw new Error("Root must be non-zero");
  })), "DenseMatrix, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => {
    if (1 === r2.density()) return o(t3, r2, e3, false);
    throw new Error("Root must be non-zero");
  })), "Array, SparseMatrix": t2.referTo("DenseMatrix,SparseMatrix", ((e3) => (t3, n3) => e3(r(t3), n3))), "number | BigNumber, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => {
    if (1 === r2.density()) return c2(r2, t3, e3, true);
    throw new Error("Root must be non-zero");
  })) }, l({ scalar: "number | BigNumber", SD: s, Ss: c2, sS: false }));
  function p(e3, t3) {
    var r2 = i2.precision, n3 = i2.clone({ precision: r2 + 2 }), a2 = new i2(0), o2 = new n3(1), s2 = t3.isNegative();
    if (s2 && (t3 = t3.neg()), t3.isZero()) throw new Error("Root must be non-zero");
    if (e3.isNegative() && !t3.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
    if (e3.isZero()) return s2 ? new n3(1 / 0) : 0;
    if (!e3.isFinite()) return s2 ? a2 : e3;
    var u2 = e3.abs().pow(o2.div(t3));
    return u2 = e3.isNeg() ? u2.neg() : u2, new i2((s2 ? o2.div(u2) : u2).toPrecision(r2));
  }
})), name$3_$1 = "sign", dependencies$3_$1 = ["typed", "BigNumber", "Fraction", "complex"], createSign$1 = factory$1(name$3_$1, dependencies$3_$1, ((e2) => {
  var { typed: t2, BigNumber: r, complex: n, Fraction: i2 } = e2;
  return t2(name$3_$1, { number: signNumber$1, Complex: function(e3) {
    return 0 === e3.im ? n(signNumber$1(e3.re)) : e3.sign();
  }, BigNumber: function(e3) {
    return new r(e3.cmp(0));
  }, bigint: function(e3) {
    return e3 > 0n ? 1n : e3 < 0n ? -1n : 0n;
  }, Fraction: function(e3) {
    return 0n === e3.n ? new i2(0) : new i2(e3.s);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3, true))), Unit: t2.referToSelf(((e3) => (r2) => {
    if (!r2._isDerived() && 0 !== r2.units[0].unit.offset) throw new TypeError("sign is ambiguous for units with offset");
    return t2.find(e3, r2.valueType())(r2.value);
  })) });
})), name$3Z$1 = "sqrt", dependencies$3Z$1 = ["config", "typed", "Complex"], createSqrt$1 = factory$1(name$3Z$1, dependencies$3Z$1, ((e2) => {
  var { config: t2, typed: r, Complex: n } = e2;
  return r("sqrt", { number: i2, Complex: function(e3) {
    return e3.sqrt();
  }, BigNumber: function(e3) {
    return !e3.isNegative() || t2.predictable ? e3.sqrt() : i2(e3.toNumber());
  }, Unit: function(e3) {
    return e3.pow(0.5);
  } });
  function i2(e3) {
    return isNaN(e3) ? NaN : e3 >= 0 || t2.predictable ? Math.sqrt(e3) : new n(e3, 0).sqrt();
  }
})), name$3Y$1 = "square", dependencies$3Y$1 = ["typed"], createSquare$1 = factory$1(name$3Y$1, dependencies$3Y$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3Y$1, { number: squareNumber$1, Complex: function(e3) {
    return e3.mul(e3);
  }, BigNumber: function(e3) {
    return e3.times(e3);
  }, bigint: function(e3) {
    return e3 * e3;
  }, Fraction: function(e3) {
    return e3.mul(e3);
  }, Unit: function(e3) {
    return e3.pow(2);
  } });
})), name$3X$1 = "subtract", dependencies$3X$1 = ["typed", "matrix", "equalScalar", "subtractScalar", "unaryMinus", "DenseMatrix", "concat"], createSubtract$1 = factory$1(name$3X$1, dependencies$3X$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, subtractScalar: i2, unaryMinus: a, DenseMatrix: o, concat: s } = e2, u = createMatAlgo01xDSid$1({ typed: t2 }), c2 = createMatAlgo03xDSf$1({ typed: t2 }), l = createMatAlgo05xSfSf$1({ typed: t2, equalScalar: n }), f2 = createMatAlgo10xSids$1({ typed: t2, DenseMatrix: o }), p = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: o }), m = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: s });
  return t2(name$3X$1, { "any, any": i2 }, m({ elop: i2, SS: l, DS: u, SD: c2, Ss: p, sS: f2 }));
})), name$3W$1 = "xgcd", dependencies$3W$1 = ["typed", "config", "matrix", "BigNumber"], createXgcd$1 = factory$1(name$3W$1, dependencies$3W$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, BigNumber: i2 } = e2;
  return t2(name$3W$1, { "number, number": function(e3, t3) {
    var i3 = xgcdNumber$1(e3, t3);
    return "Array" === r.matrix ? i3 : n(i3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    var a, o, s, u, c2 = new i2(0), l = new i2(1), f2 = c2, p = l, m = l, d = c2;
    if (!e3.isInt() || !t3.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");
    for (; !t3.isZero(); ) o = e3.div(t3).floor(), s = e3.mod(t3), a = f2, f2 = p.minus(o.times(f2)), p = a, a = m, m = d.minus(o.times(m)), d = a, e3 = t3, t3 = s;
    u = e3.lt(c2) ? [e3.neg(), p.neg(), d.neg()] : [e3, e3.isZero() ? 0 : p, d];
    return "Array" === r.matrix ? u : n(u);
  } });
})), name$3V$1 = "invmod", dependencies$3V$1 = ["typed", "config", "BigNumber", "xgcd", "equal", "smaller", "mod", "add", "isInteger"], createInvmod$1 = factory$1(name$3V$1, dependencies$3V$1, ((e2) => {
  var { typed: t2, config: r, BigNumber: n, xgcd: i2, equal: a, smaller: o, mod: s, add: u, isInteger: c2 } = e2;
  return t2(name$3V$1, { "number, number": l, "BigNumber, BigNumber": l });
  function l(e3, t3) {
    if (!c2(e3) || !c2(t3)) throw new Error("Parameters in function invmod must be integer numbers");
    if (e3 = s(e3, t3), a(t3, 0)) throw new Error("Divisor must be non zero");
    var r2 = i2(e3, t3);
    r2 = r2.valueOf();
    var [l2, f2] = r2;
    return a(l2, n(1)) ? (f2 = s(f2, t3), o(f2, n(0)) && (f2 = u(f2, t3)), f2) : NaN;
  }
})), name$3U$1 = "matAlgo09xS0Sf", dependencies$3U$1 = ["typed", "equalScalar"], createMatAlgo09xS0Sf$1 = factory$1(name$3U$1, dependencies$3U$1, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._index, s = e3._ptr, u = e3._size, c2 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l = n._values, f2 = n._index, p = n._ptr, m = n._size, d = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (u.length !== m.length) throw new DimensionError$1(u.length, m.length);
    if (u[0] !== m[0] || u[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + m + ")");
    var h, g = u[0], y = u[1], v2 = r, x2 = 0, b2 = i2;
    "string" == typeof c2 && c2 === d && "mixed" !== c2 && (h = c2, v2 = t2.find(r, [h, h]), x2 = t2.convert(0, h), b2 = t2.find(i2, [h, h]));
    var _2, w2, A2, N, D, E = a && l ? [] : void 0, $2 = [], S2 = [], C2 = E ? [] : void 0, M2 = [];
    for (w2 = 0; w2 < y; w2++) {
      S2[w2] = $2.length;
      var T2 = w2 + 1;
      if (C2) for (N = p[w2], D = p[w2 + 1], A2 = N; A2 < D; A2++) M2[_2 = f2[A2]] = T2, C2[_2] = l[A2];
      for (N = s[w2], D = s[w2 + 1], A2 = N; A2 < D; A2++) if (_2 = o[A2], C2) {
        var F = M2[_2] === T2 ? C2[_2] : x2, O2 = b2(a[A2], F);
        v2(O2, x2) || ($2.push(_2), E.push(O2));
      } else $2.push(_2);
    }
    return S2[y] = $2.length, e3.createSparseMatrix({ values: E, index: $2, ptr: S2, size: [g, y], datatype: c2 === e3._datatype && d === n._datatype ? h : void 0 });
  };
})), name$3T$1 = "dotMultiply", dependencies$3T$1 = ["typed", "matrix", "equalScalar", "multiplyScalar", "concat"], createDotMultiply$1 = factory$1(name$3T$1, dependencies$3T$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, multiplyScalar: i2, concat: a } = e2, o = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), s = createMatAlgo09xS0Sf$1({ typed: t2, equalScalar: n }), u = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), c2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: a });
  return t2(name$3T$1, c2({ elop: i2, SS: s, DS: o, Ss: u }));
}));
function bitAndBigNumber$1(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function bitAnd");
  var r = e2.constructor;
  if (e2.isNaN() || t2.isNaN()) return new r(NaN);
  if (e2.isZero() || t2.eq(-1) || e2.eq(t2)) return e2;
  if (t2.isZero() || e2.eq(-1)) return t2;
  if (!e2.isFinite() || !t2.isFinite()) {
    if (!e2.isFinite() && !t2.isFinite()) return e2.isNegative() === t2.isNegative() ? e2 : new r(0);
    if (!e2.isFinite()) return t2.isNegative() ? e2 : e2.isNegative() ? new r(0) : t2;
    if (!t2.isFinite()) return e2.isNegative() ? t2 : t2.isNegative() ? new r(0) : e2;
  }
  return bitwise$1(e2, t2, (function(e3, t3) {
    return e3 & t3;
  }));
}
function bitNotBigNumber$1(e2) {
  if (e2.isFinite() && !e2.isInteger()) throw new Error("Integer expected in function bitNot");
  var t2 = e2.constructor, r = t2.precision;
  t2.config({ precision: 1e9 });
  var n = e2.plus(new t2(1));
  return n.s = -n.s || null, t2.config({ precision: r }), n;
}
function bitOrBigNumber$1(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function bitOr");
  var r = e2.constructor;
  if (e2.isNaN() || t2.isNaN()) return new r(NaN);
  var n = new r(-1);
  return e2.isZero() || t2.eq(n) || e2.eq(t2) ? t2 : t2.isZero() || e2.eq(n) ? e2 : e2.isFinite() && t2.isFinite() ? bitwise$1(e2, t2, (function(e3, t3) {
    return e3 | t3;
  })) : !e2.isFinite() && !e2.isNegative() && t2.isNegative() || e2.isNegative() && !t2.isNegative() && !t2.isFinite() ? n : e2.isNegative() && t2.isNegative() ? e2.isFinite() ? e2 : t2 : e2.isFinite() ? t2 : e2;
}
function bitwise$1(e2, t2, r) {
  var n, i2, a, o, s, u = e2.constructor, c2 = +(e2.s < 0), l = +(t2.s < 0);
  if (c2) {
    n = decCoefficientToBinaryString$1(bitNotBigNumber$1(e2));
    for (var f2 = 0; f2 < n.length; ++f2) n[f2] ^= 1;
  } else n = decCoefficientToBinaryString$1(e2);
  if (l) {
    i2 = decCoefficientToBinaryString$1(bitNotBigNumber$1(t2));
    for (var p = 0; p < i2.length; ++p) i2[p] ^= 1;
  } else i2 = decCoefficientToBinaryString$1(t2);
  n.length <= i2.length ? (a = n, o = i2, s = c2) : (a = i2, o = n, s = l);
  var m = a.length, d = o.length, h = 1 ^ r(c2, l), g = new u(1 ^ h), y = new u(1), v2 = new u(2), x2 = u.precision;
  for (u.config({ precision: 1e9 }); m > 0; ) r(a[--m], o[--d]) === h && (g = g.plus(y)), y = y.times(v2);
  for (; d > 0; ) r(s, o[--d]) === h && (g = g.plus(y)), y = y.times(v2);
  return u.config({ precision: x2 }), 0 === h && (g.s = -g.s), g;
}
function decCoefficientToBinaryString$1(e2) {
  for (var t2 = e2.d, r = t2[0] + "", n = 1; n < t2.length; ++n) {
    for (var i2 = t2[n] + "", a = 7 - i2.length; a--; ) i2 = "0" + i2;
    r += i2;
  }
  for (var o = r.length; "0" === r.charAt(o); ) o--;
  var s = e2.e, u = r.slice(0, o + 1 || 1), c2 = u.length;
  if (s > 0) if (++s > c2) for (s -= c2; s--; ) u += "0";
  else s < c2 && (u = u.slice(0, s) + "." + u.slice(s));
  for (var l = [0], f2 = 0; f2 < u.length; ) {
    for (var p = l.length; p--; ) l[p] *= 10;
    l[0] += parseInt(u.charAt(f2++));
    for (var m = 0; m < l.length; ++m) l[m] > 1 && (null !== l[m + 1] && void 0 !== l[m + 1] || (l[m + 1] = 0), l[m + 1] += l[m] >> 1, l[m] &= 1);
  }
  return l.reverse();
}
function bitXor$1(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function bitXor");
  var r = e2.constructor;
  if (e2.isNaN() || t2.isNaN()) return new r(NaN);
  if (e2.isZero()) return t2;
  if (t2.isZero()) return e2;
  if (e2.eq(t2)) return new r(0);
  var n = new r(-1);
  return e2.eq(n) ? bitNotBigNumber$1(t2) : t2.eq(n) ? bitNotBigNumber$1(e2) : e2.isFinite() && t2.isFinite() ? bitwise$1(e2, t2, (function(e3, t3) {
    return e3 ^ t3;
  })) : e2.isFinite() || t2.isFinite() ? new r(e2.isNegative() === t2.isNegative() ? 1 / 0 : -1 / 0) : n;
}
function leftShiftBigNumber$1(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function leftShift");
  var r = e2.constructor;
  return e2.isNaN() || t2.isNaN() || t2.isNegative() && !t2.isZero() ? new r(NaN) : e2.isZero() || t2.isZero() ? e2 : e2.isFinite() || t2.isFinite() ? t2.lt(55) ? e2.times(Math.pow(2, t2.toNumber()) + "") : e2.times(new r(2).pow(t2)) : new r(NaN);
}
function rightArithShiftBigNumber$1(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function rightArithShift");
  var r = e2.constructor;
  return e2.isNaN() || t2.isNaN() || t2.isNegative() && !t2.isZero() ? new r(NaN) : e2.isZero() || t2.isZero() ? e2 : t2.isFinite() ? t2.lt(55) ? e2.div(Math.pow(2, t2.toNumber()) + "").floor() : e2.div(new r(2).pow(t2)).floor() : e2.isNegative() ? new r(-1) : e2.isFinite() ? new r(0) : new r(NaN);
}
var name$3S$1 = "bitAnd", dependencies$3S$1 = ["typed", "matrix", "equalScalar", "concat"], createBitAnd$1 = factory$1(name$3S$1, dependencies$3S$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, concat: i2 } = e2, a = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), o = createMatAlgo06xS0S0$1({ typed: t2, equalScalar: n }), s = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), u = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: i2 });
  return t2(name$3S$1, { "number, number": bitAndNumber$1, "BigNumber, BigNumber": bitAndBigNumber$1, "bigint, bigint": (e3, t3) => e3 & t3 }, u({ SS: o, DS: a, Ss: s }));
})), name$3R$1 = "bitNot", dependencies$3R$1 = ["typed"], createBitNot$1 = factory$1(name$3R$1, dependencies$3R$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3R$1, { number: bitNotNumber$1, BigNumber: bitNotBigNumber$1, bigint: (e3) => ~e3, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$3Q$1 = "bitOr", dependencies$3Q$1 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createBitOr$1 = factory$1(name$3Q$1, dependencies$3Q$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a } = e2, o = createMatAlgo01xDSid$1({ typed: t2 }), s = createMatAlgo04xSidSid$1({ typed: t2, equalScalar: n }), u = createMatAlgo10xSids$1({ typed: t2, DenseMatrix: i2 }), c2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: a });
  return t2(name$3Q$1, { "number, number": bitOrNumber$1, "BigNumber, BigNumber": bitOrBigNumber$1, "bigint, bigint": (e3, t3) => e3 | t3 }, c2({ SS: s, DS: o, Ss: u }));
})), name$3P$1 = "matAlgo07xSSf", dependencies$3P$1 = ["typed", "SparseMatrix"], createMatAlgo07xSSf$1 = factory$1(name$3P$1, dependencies$3P$1, ((e2) => {
  var { typed: t2, SparseMatrix: r } = e2;
  return function(e3, i2, a) {
    var o = e3._size, s = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), u = i2._size, c2 = i2._datatype || void 0 === i2._data ? i2._datatype : i2.getDataType();
    if (o.length !== u.length) throw new DimensionError$1(o.length, u.length);
    if (o[0] !== u[0] || o[1] !== u[1]) throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + u + ")");
    var l, f2 = o[0], p = o[1], m = 0, d = a;
    "string" == typeof s && s === c2 && "mixed" !== s && (l = s, m = t2.convert(0, l), d = t2.find(a, [l, l]));
    for (var h = [], g = [], y = new Array(p + 1).fill(0), v2 = [], x2 = [], b2 = [], _2 = [], w2 = 0; w2 < p; w2++) {
      var A2 = w2 + 1, N = 0;
      n(e3, w2, b2, v2, A2), n(i2, w2, _2, x2, A2);
      for (var D = 0; D < f2; D++) {
        var E = d(b2[D] === A2 ? v2[D] : m, _2[D] === A2 ? x2[D] : m);
        0 !== E && false !== E && (g.push(D), h.push(E), N++);
      }
      y[w2 + 1] = y[w2] + N;
    }
    return new r({ values: h, index: g, ptr: y, size: [f2, p], datatype: s === e3._datatype && c2 === i2._datatype ? l : void 0 });
  };
  function n(e3, t3, r2, n3, i2) {
    for (var a = e3._values, o = e3._index, s = e3._ptr, u = s[t3], c2 = s[t3 + 1]; u < c2; u++) {
      var l = o[u];
      r2[l] = i2, n3[l] = a[u];
    }
  }
})), name$3O$1 = "bitXor", dependencies$3O$1 = ["typed", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createBitXor$1 = factory$1(name$3O$1, dependencies$3O$1, ((e2) => {
  var { typed: t2, matrix: r, DenseMatrix: n, concat: i2, SparseMatrix: a } = e2, o = createMatAlgo03xDSf$1({ typed: t2 }), s = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: a }), u = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: n }), c2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: i2 });
  return t2(name$3O$1, { "number, number": bitXorNumber$1, "BigNumber, BigNumber": bitXor$1, "bigint, bigint": (e3, t3) => e3 ^ t3 }, c2({ SS: s, DS: o, Ss: u }));
})), name$3N$1 = "arg", dependencies$3N$1 = ["typed"], createArg$1 = factory$1(name$3N$1, dependencies$3N$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3N$1, { number: function(e3) {
    return Math.atan2(0, e3);
  }, BigNumber: function(e3) {
    return e3.constructor.atan2(0, e3);
  }, Complex: function(e3) {
    return e3.arg();
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$3M$1 = "conj", dependencies$3M$1 = ["typed"], createConj$1 = factory$1(name$3M$1, dependencies$3M$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3M$1, { "number | BigNumber | Fraction": (e3) => e3, Complex: (e3) => e3.conjugate(), Unit: t2.referToSelf(((e3) => (t3) => new t3.constructor(e3(t3.toNumeric()), t3.formatUnits()))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$3L$1 = "im", dependencies$3L$1 = ["typed"], createIm$1 = factory$1(name$3L$1, dependencies$3L$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3L$1, { number: () => 0, "BigNumber | Fraction": (e3) => e3.mul(0), Complex: (e3) => e3.im, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$3K$1 = "re", dependencies$3K$1 = ["typed"], createRe$1 = factory$1(name$3K$1, dependencies$3K$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3K$1, { "number | BigNumber | Fraction": (e3) => e3, Complex: (e3) => e3.re, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$3J$1 = "not", dependencies$3J$1 = ["typed"], createNot$1 = factory$1(name$3J$1, dependencies$3J$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3J$1, { "null | undefined": () => true, number: notNumber$1, Complex: function(e3) {
    return 0 === e3.re && 0 === e3.im;
  }, BigNumber: function(e3) {
    return e3.isZero() || e3.isNaN();
  }, bigint: (e3) => !e3, Unit: t2.referToSelf(((e3) => (r) => t2.find(e3, r.valueType())(r.value))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$3I$1 = "nullish", dependencies$3I$1 = ["typed", "matrix", "size", "flatten", "deepEqual"], createNullish$1 = factory$1(name$3I$1, dependencies$3I$1, ((e2) => {
  var { typed: t2, matrix: r, size: n, flatten: i2, deepEqual: a } = e2, o = createMatAlgo03xDSf$1({ typed: t2 }), s = createMatAlgo14xDs$1({ typed: t2 }), u = createMatAlgo13xDD$1({ typed: t2 });
  return t2(name$3I$1, { "number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any": (e3, t3) => e3, "null, any": (e3, t3) => t3, "undefined, any": (e3, t3) => t3, "SparseMatrix, Array | Matrix": (e3, t3) => {
    var r2 = n(e3), i3 = n(t3);
    if (a(r2, i3)) return e3;
    throw new DimensionError$1(r2, i3);
  }, "DenseMatrix, DenseMatrix": t2.referToSelf(((e3) => (t3, r2) => u(t3, r2, e3))), "DenseMatrix, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => o(t3, r2, e3, false))), "DenseMatrix, Array": t2.referToSelf(((e3) => (t3, n3) => u(t3, r(n3), e3))), "DenseMatrix, any": t2.referToSelf(((e3) => (t3, r2) => s(t3, r2, e3, false))), "Array, Array": t2.referToSelf(((e3) => (t3, n3) => u(r(t3), r(n3), e3).valueOf())), "Array, DenseMatrix": t2.referToSelf(((e3) => (t3, n3) => u(r(t3), n3, e3))), "Array, SparseMatrix": t2.referToSelf(((e3) => (t3, n3) => o(r(t3), n3, e3, false))), "Array, any": t2.referToSelf(((e3) => (t3, n3) => s(r(t3), n3, e3, false).valueOf())) });
})), name$3H$1 = "or", dependencies$3H$1 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createOr$1 = factory$1(name$3H$1, dependencies$3H$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a } = e2, o = createMatAlgo03xDSf$1({ typed: t2 }), s = createMatAlgo05xSfSf$1({ typed: t2, equalScalar: n }), u = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: i2 }), c2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: a });
  return t2(name$3H$1, { "number, number": orNumber$1, "Complex, Complex": function(e3, t3) {
    return 0 !== e3.re || 0 !== e3.im || 0 !== t3.re || 0 !== t3.im;
  }, "BigNumber, BigNumber": function(e3, t3) {
    return !e3.isZero() && !e3.isNaN() || !t3.isZero() && !t3.isNaN();
  }, "bigint, bigint": orNumber$1, "Unit, Unit": t2.referToSelf(((e3) => (t3, r2) => e3(t3.value || 0, r2.value || 0))) }, c2({ SS: s, DS: o, Ss: u }));
})), name$3G$1 = "xor", dependencies$3G$1 = ["typed", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createXor$1 = factory$1(name$3G$1, dependencies$3G$1, ((e2) => {
  var { typed: t2, matrix: r, DenseMatrix: n, concat: i2, SparseMatrix: a } = e2, o = createMatAlgo03xDSf$1({ typed: t2 }), s = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: a }), u = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: n }), c2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: i2 });
  return t2(name$3G$1, { "number, number": xorNumber$1, "Complex, Complex": function(e3, t3) {
    return (0 !== e3.re || 0 !== e3.im) != (0 !== t3.re || 0 !== t3.im);
  }, "bigint, bigint": xorNumber$1, "BigNumber, BigNumber": function(e3, t3) {
    return (!e3.isZero() && !e3.isNaN()) != (!t3.isZero() && !t3.isNaN());
  }, "Unit, Unit": t2.referToSelf(((e3) => (t3, r2) => e3(t3.value || 0, r2.value || 0))) }, c2({ SS: s, DS: o, Ss: u }));
})), name$3F$1 = "concat", dependencies$3F$1 = ["typed", "matrix", "isInteger"], createConcat$1 = factory$1(name$3F$1, dependencies$3F$1, ((e2) => {
  var { typed: t2, matrix: r, isInteger: n } = e2;
  return t2(name$3F$1, { "...Array | Matrix | number | BigNumber": function(e3) {
    var t3, i2, a = e3.length, o = -1, s = false, u = [];
    for (t3 = 0; t3 < a; t3++) {
      var c2 = e3[t3];
      if (isMatrix$1(c2) && (s = true), isNumber$1$1(c2) || isBigNumber$1(c2)) {
        if (t3 !== a - 1) throw new Error("Dimension must be specified as last argument");
        if (i2 = o, o = c2.valueOf(), !n(o)) throw new TypeError("Integer number expected for dimension");
        if (o < 0 || t3 > 0 && o > i2) throw new IndexError$1(o, i2 + 1);
      } else {
        var l = clone$3$1(c2).valueOf(), f2 = arraySize$1(l);
        if (u[t3] = l, i2 = o, o = f2.length - 1, t3 > 0 && o !== i2) throw new DimensionError$1(i2 + 1, o + 1);
      }
    }
    if (0 === u.length) throw new SyntaxError("At least one matrix expected");
    for (var p = u.shift(); u.length; ) p = concat$1(p, u.shift(), o);
    return s ? r(p) : p;
  }, "...string": function(e3) {
    return e3.join("");
  } });
})), name$3E$1 = "column", dependencies$3E$1 = ["typed", "Index", "matrix", "range"], createColumn$1 = factory$1(name$3E$1, dependencies$3E$1, ((e2) => {
  var { typed: t2, Index: r, matrix: n, range: i2 } = e2;
  return t2(name$3E$1, { "Matrix, number": a, "Array, number": function(e3, t3) {
    return a(n(clone$3$1(e3)), t3).valueOf();
  } });
  function a(e3, t3) {
    if (2 !== e3.size().length) throw new Error("Only two dimensional matrix is supported");
    validateIndex$1(t3, e3.size()[1]);
    var a2 = i2(0, e3.size()[0]), o = new r(a2, [t3]), s = e3.subset(o);
    return isMatrix$1(s) ? s : n([[s]]);
  }
})), name$3D$1 = "count", dependencies$3D$1 = ["typed", "size", "prod"], createCount$1 = factory$1(name$3D$1, dependencies$3D$1, ((e2) => {
  var { typed: t2, size: r, prod: n } = e2;
  return t2(name$3D$1, { string: function(e3) {
    return e3.length;
  }, "Matrix | Array": function(e3) {
    return n(r(e3));
  } });
})), name$3C$1 = "cross", dependencies$3C$1 = ["typed", "matrix", "subtract", "multiply"], createCross$1 = factory$1(name$3C$1, dependencies$3C$1, ((e2) => {
  var { typed: t2, matrix: r, subtract: n, multiply: i2 } = e2;
  return t2(name$3C$1, { "Matrix, Matrix": function(e3, t3) {
    return r(a(e3.toArray(), t3.toArray()));
  }, "Matrix, Array": function(e3, t3) {
    return r(a(e3.toArray(), t3));
  }, "Array, Matrix": function(e3, t3) {
    return r(a(e3, t3.toArray()));
  }, "Array, Array": a });
  function a(e3, t3) {
    var r2 = Math.max(arraySize$1(e3).length, arraySize$1(t3).length);
    e3 = squeeze$1(e3), t3 = squeeze$1(t3);
    var a2 = arraySize$1(e3), o = arraySize$1(t3);
    if (1 !== a2.length || 1 !== o.length || 3 !== a2[0] || 3 !== o[0]) throw new RangeError("Vectors with length 3 expected (Size A = [" + a2.join(", ") + "], B = [" + o.join(", ") + "])");
    var s = [n(i2(e3[1], t3[2]), i2(e3[2], t3[1])), n(i2(e3[2], t3[0]), i2(e3[0], t3[2])), n(i2(e3[0], t3[1]), i2(e3[1], t3[0]))];
    return r2 > 1 ? [s] : s;
  }
})), name$3B$1 = "diag", dependencies$3B$1 = ["typed", "matrix", "DenseMatrix", "SparseMatrix"], createDiag$1 = factory$1(name$3B$1, dependencies$3B$1, ((e2) => {
  var { typed: t2, matrix: r, DenseMatrix: n, SparseMatrix: i2 } = e2;
  return t2(name$3B$1, { Array: function(e3) {
    return a(e3, 0, arraySize$1(e3), null);
  }, "Array, number": function(e3, t3) {
    return a(e3, t3, arraySize$1(e3), null);
  }, "Array, BigNumber": function(e3, t3) {
    return a(e3, t3.toNumber(), arraySize$1(e3), null);
  }, "Array, string": function(e3, t3) {
    return a(e3, 0, arraySize$1(e3), t3);
  }, "Array, number, string": function(e3, t3, r2) {
    return a(e3, t3, arraySize$1(e3), r2);
  }, "Array, BigNumber, string": function(e3, t3, r2) {
    return a(e3, t3.toNumber(), arraySize$1(e3), r2);
  }, Matrix: function(e3) {
    return a(e3, 0, e3.size(), e3.storage());
  }, "Matrix, number": function(e3, t3) {
    return a(e3, t3, e3.size(), e3.storage());
  }, "Matrix, BigNumber": function(e3, t3) {
    return a(e3, t3.toNumber(), e3.size(), e3.storage());
  }, "Matrix, string": function(e3, t3) {
    return a(e3, 0, e3.size(), t3);
  }, "Matrix, number, string": function(e3, t3, r2) {
    return a(e3, t3, e3.size(), r2);
  }, "Matrix, BigNumber, string": function(e3, t3, r2) {
    return a(e3, t3.toNumber(), e3.size(), r2);
  } });
  function a(e3, t3, a2, o) {
    if (!isInteger$1(t3)) throw new TypeError("Second parameter in function diag must be an integer");
    var s = t3 > 0 ? t3 : 0, u = t3 < 0 ? -t3 : 0;
    switch (a2.length) {
      case 1:
        return (function(e4, t4, r2, a3, o2, s2) {
          var u2 = [a3 + o2, a3 + s2];
          if (r2 && "sparse" !== r2 && "dense" !== r2) throw new TypeError("Unknown matrix type ".concat(r2, '"'));
          var c2 = "sparse" === r2 ? i2.diagonal(u2, e4, t4) : n.diagonal(u2, e4, t4);
          return null !== r2 ? c2 : c2.valueOf();
        })(e3, t3, o, a2[0], u, s);
      case 2:
        return (function(e4, t4, n3, i3, a3, o2) {
          if (isMatrix$1(e4)) {
            var s2 = e4.diagonal(t4);
            return null !== n3 ? n3 !== s2.storage() ? r(s2, n3) : s2 : s2.valueOf();
          }
          for (var u2 = Math.min(i3[0] - a3, i3[1] - o2), c2 = [], l = 0; l < u2; l++) c2[l] = e4[l + a3][l + o2];
          return null !== n3 ? r(c2) : c2;
        })(e3, t3, o, a2, u, s);
    }
    throw new RangeError("Matrix for function diag must be 2 dimensional");
  }
})), name$3A$1 = "filter", dependencies$3A$1 = ["typed"], createFilter$1 = factory$1(name$3A$1, dependencies$3A$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2("filter", { "Array, function": _filterCallback$1, "Matrix, function": function(e3, t3) {
    return e3.create(_filterCallback$1(e3.valueOf(), t3), e3.datatype());
  }, "Array, RegExp": filterRegExp$1, "Matrix, RegExp": function(e3, t3) {
    return e3.create(filterRegExp$1(e3.valueOf(), t3), e3.datatype());
  } });
}));
function _filterCallback$1(e2, t2) {
  var r = optimizeCallback$1(t2, e2, "filter");
  return r.isUnary ? filter$1$1(e2, r.fn) : filter$1$1(e2, (function(e3, t3, n) {
    return r.fn(e3, [t3], n);
  }));
}
var name$3z$1 = "flatten", dependencies$3z$1 = ["typed"], createFlatten$1 = factory$1(name$3z$1, dependencies$3z$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3z$1, { Array: function(e3) {
    return flatten$4$1(e3);
  }, DenseMatrix: function(e3) {
    return e3.create(flatten$4$1(e3.valueOf(), true), e3.datatype());
  }, SparseMatrix: function(e3) {
    throw new TypeError("SparseMatrix is not supported by function flatten because it does not support 1D vectors. Convert to a DenseMatrix or Array first. Example: flatten(x.toArray())");
  } });
})), name$3y$1 = "forEach", dependencies$3y$1 = ["typed"], createForEach$1 = factory$1(name$3y$1, dependencies$3y$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3y$1, { "Array, function": _forEach$1, "Matrix, function": function(e3, t3) {
    e3.forEach(t3);
  } });
}));
function _forEach$1(e2, t2) {
  var r = optimizeCallback$1(t2, e2, name$3y$1);
  deepForEach$1$1(e2, r.fn, r.isUnary);
}
var name$3x$1 = "getMatrixDataType", dependencies$3x$1 = ["typed"], createGetMatrixDataType$1 = factory$1(name$3x$1, dependencies$3x$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3x$1, { Array: function(e3) {
    return getArrayDataType$1(e3, typeOf$1);
  }, Matrix: function(e3) {
    return e3.getDataType();
  } });
})), name$3w$1 = "identity", dependencies$3w$1 = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], createIdentity$1 = factory$1(name$3w$1, dependencies$3w$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, BigNumber: i2, DenseMatrix: a, SparseMatrix: o } = e2;
  return t2(name$3w$1, { "": function() {
    return "Matrix" === r.matrix ? n([]) : [];
  }, string: function(e3) {
    return n(e3);
  }, "number | BigNumber": function(e3) {
    return u(e3, e3, "Matrix" === r.matrix ? "dense" : void 0);
  }, "number | BigNumber, string": function(e3, t3) {
    return u(e3, e3, t3);
  }, "number | BigNumber, number | BigNumber": function(e3, t3) {
    return u(e3, t3, "Matrix" === r.matrix ? "dense" : void 0);
  }, "number | BigNumber, number | BigNumber, string": function(e3, t3, r2) {
    return u(e3, t3, r2);
  }, Array: function(e3) {
    return s(e3);
  }, "Array, string": function(e3, t3) {
    return s(e3, t3);
  }, Matrix: function(e3) {
    return s(e3.valueOf(), e3.storage());
  }, "Matrix, string": function(e3, t3) {
    return s(e3.valueOf(), t3);
  } });
  function s(e3, t3) {
    switch (e3.length) {
      case 0:
        return t3 ? n(t3) : [];
      case 1:
        return u(e3[0], e3[0], t3);
      case 2:
        return u(e3[0], e3[1], t3);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function u(e3, t3, r2) {
    var n3 = isBigNumber$1(e3) || isBigNumber$1(t3) ? i2 : null;
    if (isBigNumber$1(e3) && (e3 = e3.toNumber()), isBigNumber$1(t3) && (t3 = t3.toNumber()), !isInteger$1(e3) || e3 < 1) throw new Error("Parameters in function identity must be positive integers");
    if (!isInteger$1(t3) || t3 < 1) throw new Error("Parameters in function identity must be positive integers");
    var s2 = n3 ? new i2(1) : 1, u2 = n3 ? new n3(0) : 0, c2 = [e3, t3];
    if (r2) {
      if ("sparse" === r2) return o.diagonal(c2, s2, 0, u2);
      if ("dense" === r2) return a.diagonal(c2, s2, 0, u2);
      throw new TypeError('Unknown matrix type "'.concat(r2, '"'));
    }
    for (var l = resize$1([], c2, u2), f2 = e3 < t3 ? e3 : t3, p = 0; p < f2; p++) l[p][p] = s2;
    return l;
  }
})), name$3v$1 = "kron", dependencies$3v$1 = ["typed", "matrix", "multiplyScalar"], createKron$1 = factory$1(name$3v$1, dependencies$3v$1, ((e2) => {
  var { typed: t2, matrix: r, multiplyScalar: n } = e2;
  return t2(name$3v$1, { "Matrix, Matrix": function(e3, t3) {
    return r(i2(e3.toArray(), t3.toArray()));
  }, "Matrix, Array": function(e3, t3) {
    return r(i2(e3.toArray(), t3));
  }, "Array, Matrix": function(e3, t3) {
    return r(i2(e3, t3.toArray()));
  }, "Array, Array": i2 });
  function i2(e3, t3) {
    var r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1;
    if (r2 < 0) {
      var a = arraySize$1(e3).length, o = arraySize$1(t3).length;
      for (r2 = Math.max(a, o); a++ < r2; ) e3 = [e3];
      for (; o++ < r2; ) t3 = [t3];
    }
    return 1 === r2 ? (function(e4, t4) {
      return e4.flatMap(((e5) => t4.map(((t5) => n(e5, t5)))));
    })(e3, t3) : e3.flatMap(((e4) => t3.map(((t4) => i2(e4, t4, r2 - 1)))));
  }
})), name$3u$1 = "map", dependencies$3u$1 = ["typed"], createMap$2 = factory$1(name$3u$1, dependencies$3u$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3u$1, { "Array, function": n, "Matrix, function": function(e3, t3) {
    return e3.map(t3);
  }, "Array|Matrix, Array|Matrix, ...Array|Matrix|function": (e3, i2, a) => (function(e4, i3) {
    if ("function" != typeof i3) throw new Error("Last argument must be a callback function");
    var a2 = e4[0].isMatrix, o = e4.map(((e5) => e5.isMatrix ? e5.size() : arraySize$1(e5))), s = broadcastSizes$1(...o), u = e4.length, c2 = a2 ? (e5, t3) => e5.get(t3) : get$1$1, l = e4.map(((e5, t3) => {
      var r2 = o[t3].map((() => 0));
      return e5.isMatrix ? e5.get(r2) : get$1$1(e5, r2);
    })), f2 = t2.isTypedFunction(i3) ? (function(e5, r2, n3, i4) {
      if (null !== t2.resolve(e5, [...r2, n3, ...i4])) return 2;
      if (null !== t2.resolve(e5, [...r2, n3])) return 1;
      if (null !== t2.resolve(e5, r2)) return 0;
      return 0;
    })(i3, l, s.map((() => 0)), e4) : (function(e5, t3) {
      var r2 = e5.toString();
      if (/arguments/.test(r2)) return 2;
      var n3 = r2.match(/\(.*?\)/);
      if (/\.\.\./.test(n3)) return 2;
      if (e5.length > t3 + 1) return 2;
      if (e5.length === t3 + 1) return 1;
      return 0;
    })(i3, u);
    if (f2 < 2) {
      var p = r(f2, i3, null);
      return (function(e5, t3) {
        var r2 = e5[0], n3 = e5.map(((e6) => e6.isMatrix ? e6.valueOf() : e6)), i4 = e5.map(((e6) => e6.isMatrix ? e6.size() : arraySize$1(e6))), a3 = broadcastSizes$1(...i4), o2 = i4.map(((e6) => a3.length - e6.length)), s2 = a3.length - 1, u2 = t3.length > 1, c3 = u2 ? [] : null, l2 = p2(n3, 0);
        if (r2.isMatrix) {
          var f3 = r2.create();
          return f3._data = l2, f3._size = a3, f3;
        }
        return l2;
        function p2(e6) {
          var r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n4 = a3[r3], i5 = Array(n4);
          if (r3 < s2) for (var u3 = function(t4) {
            c3 && (c3[r3] = t4), i5[t4] = p2(e6.map(((e7, n5) => o2[n5] > r3 ? e7 : 1 === e7.length ? e7[0] : e7[t4])), r3 + 1);
          }, l3 = 0; l3 < n4; l3++) u3(l3);
          else for (var f4 = function(n5) {
            c3 && (c3[r3] = n5), i5[n5] = t3(e6.map(((e7) => 1 === e7.length ? e7[0] : e7[n5])), c3 ? c3.slice() : void 0);
          }, m2 = 0; m2 < n4; m2++) f4(m2);
          return i5;
        }
      })(e4, p);
    }
    var m = a2 ? e4.map(((t3) => t3.isMatrix ? t3.create(broadcastTo$1(t3.toArray(), s), t3.datatype()) : e4[0].create(broadcastTo$1(t3.valueOf(), s)))) : e4.map(((e5) => e5.isMatrix ? broadcastTo$1(e5.toArray(), s) : broadcastTo$1(e5, s))), d = r(f2, i3, m), h = (e5, t3) => d([e5, ...m.slice(1).map(((e6) => c2(e6, t3)))], t3);
    return a2 ? m[0].map(h) : n(m[0], h);
  })([e3, i2, ...a.slice(0, a.length - 1)], a[a.length - 1]) });
  function r(e3, t3, r2) {
    switch (e3) {
      case 0:
        return (e4) => t3(...e4);
      case 1:
        return (e4, r3) => t3(...e4, r3);
      case 2:
        return (e4, n3) => t3(...e4, n3, ...r2);
    }
  }
  function n(e3, t3) {
    var r2 = optimizeCallback$1(t3, e3, name$3u$1);
    return deepMap$1$1(e3, r2.fn, r2.isUnary);
  }
})), name$3t$1 = "diff", dependencies$3t$1 = ["typed", "matrix", "subtract", "number"], createDiff$1 = factory$1(name$3t$1, dependencies$3t$1, ((e2) => {
  var { typed: t2, matrix: r, subtract: n, number: i2 } = e2;
  return t2(name$3t$1, { "Array | Matrix": function(e3) {
    return isMatrix$1(e3) ? r(o(e3.toArray())) : o(e3);
  }, "Array | Matrix, number": function(e3, t3) {
    if (!isInteger$1(t3)) throw new RangeError("Dimension must be a whole number");
    return isMatrix$1(e3) ? r(a(e3.toArray(), t3)) : a(e3, t3);
  }, "Array, BigNumber": t2.referTo("Array,number", ((e3) => (t3, r2) => e3(t3, i2(r2)))), "Matrix, BigNumber": t2.referTo("Matrix,number", ((e3) => (t3, r2) => e3(t3, i2(r2)))) });
  function a(e3, t3) {
    if (isMatrix$1(e3) && (e3 = e3.toArray()), !Array.isArray(e3)) throw RangeError("Array/Matrix does not have that many dimensions");
    if (t3 > 0) {
      var r2 = [];
      return e3.forEach(((e4) => {
        r2.push(a(e4, t3 - 1));
      })), r2;
    }
    if (0 === t3) return o(e3);
    throw RangeError("Cannot have negative dimension");
  }
  function o(e3) {
    for (var t3 = [], r2 = e3.length, n3 = 1; n3 < r2; n3++) t3.push(s(e3[n3 - 1], e3[n3]));
    return t3;
  }
  function s(e3, t3) {
    isMatrix$1(e3) && (e3 = e3.toArray()), isMatrix$1(t3) && (t3 = t3.toArray());
    var r2 = Array.isArray(e3), i3 = Array.isArray(t3);
    if (r2 && i3) return (function(e4, t4) {
      if (e4.length !== t4.length) throw RangeError("Not all sub-arrays have the same length");
      for (var r3 = [], n3 = e4.length, i4 = 0; i4 < n3; i4++) r3.push(s(e4[i4], t4[i4]));
      return r3;
    })(e3, t3);
    if (!r2 && !i3) return n(t3, e3);
    throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
  }
})), name$3s$1 = "ones", dependencies$3s$1 = ["typed", "config", "matrix", "BigNumber"], createOnes$1 = factory$1(name$3s$1, dependencies$3s$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, BigNumber: i2 } = e2;
  return t2("ones", { "": function() {
    return "Array" === r.matrix ? a([]) : a([], "default");
  }, "...number | BigNumber | string": function(e3) {
    if ("string" == typeof e3[e3.length - 1]) {
      var t3 = e3.pop();
      return a(e3, t3);
    }
    return "Array" === r.matrix ? a(e3) : a(e3, "default");
  }, Array: a, Matrix: function(e3) {
    var t3 = e3.storage();
    return a(e3.valueOf(), t3);
  }, "Array | Matrix, string": function(e3, t3) {
    return a(e3.valueOf(), t3);
  } });
  function a(e3, t3) {
    var r2 = (function(e4) {
      var t4 = false;
      return e4.forEach((function(e5, r3, n3) {
        isBigNumber$1(e5) && (t4 = true, n3[r3] = e5.toNumber());
      })), t4;
    })(e3), a2 = r2 ? new i2(1) : 1;
    if ((function(e4) {
      e4.forEach((function(e5) {
        if ("number" != typeof e5 || !isInteger$1(e5) || e5 < 0) throw new Error("Parameters in function ones must be positive integers");
      }));
    })(e3), t3) {
      var o = n(t3);
      return e3.length > 0 ? o.resize(e3, a2) : o;
    }
    var s = [];
    return e3.length > 0 ? resize$1(s, e3, a2) : s;
  }
}));
function noBignumber$1() {
  throw new Error('No "bignumber" implementation available');
}
function noFraction$1() {
  throw new Error('No "fraction" implementation available');
}
function noMatrix$1() {
  throw new Error('No "matrix" implementation available');
}
var name$3r$1 = "range", dependencies$3r$1 = ["typed", "config", "?matrix", "?bignumber", "equal", "smaller", "smallerEq", "larger", "largerEq", "add", "isZero", "isPositive"], createRange$1 = factory$1(name$3r$1, dependencies$3r$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, bignumber: i2, smaller: a, smallerEq: o, larger: s, largerEq: u, add: c2, isZero: l, isPositive: f2 } = e2;
  return t2(name$3r$1, { string: m, "string, boolean": m, number: function(e3) {
    throw new TypeError("Too few arguments to function range(): ".concat(e3));
  }, boolean: function(e3) {
    throw new TypeError("Unexpected type of argument 1 to function range(): ".concat(e3, ", number|bigint|BigNumber|Fraction"));
  }, "number, number": function(e3, t3) {
    return p(d(e3, t3, 1, false));
  }, "number, number, number": function(e3, t3, r2) {
    return p(d(e3, t3, r2, false));
  }, "number, number, boolean": function(e3, t3, r2) {
    return p(d(e3, t3, 1, r2));
  }, "number, number, number, boolean": function(e3, t3, r2, n3) {
    return p(d(e3, t3, r2, n3));
  }, "bigint, bigint|number": function(e3, t3) {
    return p(d(e3, t3, 1n, false));
  }, "number, bigint": function(e3, t3) {
    return p(d(BigInt(e3), t3, 1n, false));
  }, "bigint, bigint|number, bigint|number": function(e3, t3, r2) {
    return p(d(e3, t3, BigInt(r2), false));
  }, "number, bigint, bigint|number": function(e3, t3, r2) {
    return p(d(BigInt(e3), t3, BigInt(r2), false));
  }, "bigint, bigint|number, boolean": function(e3, t3, r2) {
    return p(d(e3, t3, 1n, r2));
  }, "number, bigint, boolean": function(e3, t3, r2) {
    return p(d(BigInt(e3), t3, 1n, r2));
  }, "bigint, bigint|number, bigint|number, boolean": function(e3, t3, r2, n3) {
    return p(d(e3, t3, BigInt(r2), n3));
  }, "number, bigint, bigint|number, boolean": function(e3, t3, r2, n3) {
    return p(d(BigInt(e3), t3, BigInt(r2), n3));
  }, "BigNumber, BigNumber": function(e3, t3) {
    return p(d(e3, t3, new e3.constructor(1), false));
  }, "BigNumber, BigNumber, BigNumber": function(e3, t3, r2) {
    return p(d(e3, t3, r2, false));
  }, "BigNumber, BigNumber, boolean": function(e3, t3, r2) {
    return p(d(e3, t3, new e3.constructor(1), r2));
  }, "BigNumber, BigNumber, BigNumber, boolean": function(e3, t3, r2, n3) {
    return p(d(e3, t3, r2, n3));
  }, "Fraction, Fraction": function(e3, t3) {
    return p(d(e3, t3, 1, false));
  }, "Fraction, Fraction, Fraction": function(e3, t3, r2) {
    return p(d(e3, t3, r2, false));
  }, "Fraction, Fraction, boolean": function(e3, t3, r2) {
    return p(d(e3, t3, 1, r2));
  }, "Fraction, Fraction, Fraction, boolean": function(e3, t3, r2, n3) {
    return p(d(e3, t3, r2, n3));
  }, "Unit, Unit, Unit": function(e3, t3, r2) {
    return p(d(e3, t3, r2, false));
  }, "Unit, Unit, Unit, boolean": function(e3, t3, r2, n3) {
    return p(d(e3, t3, r2, n3));
  } });
  function p(e3) {
    return "Matrix" === r.matrix ? n ? n(e3) : noMatrix$1() : e3;
  }
  function m(e3, t3) {
    var n3 = (function(e4) {
      var t4 = e4.split(":"), r2 = t4.map((function(e5) {
        return Number(e5);
      }));
      if (r2.some((function(e5) {
        return isNaN(e5);
      }))) return null;
      switch (r2.length) {
        case 2:
          return { start: r2[0], end: r2[1], step: 1 };
        case 3:
          return { start: r2[0], end: r2[2], step: r2[1] };
        default:
          return null;
      }
    })(e3);
    if (!n3) throw new SyntaxError('String "' + e3 + '" is no valid range');
    return "BigNumber" === r.number ? (void 0 === i2 && noBignumber$1(), p(d(i2(n3.start), i2(n3.end), i2(n3.step)))) : p(d(n3.start, n3.end, n3.step, t3));
  }
  function d(e3, t3, r2, n3) {
    var i3 = [];
    if (l(r2)) throw new Error("Step must be non-zero");
    for (var p2 = f2(r2) ? n3 ? o : a : n3 ? u : s, m2 = e3; p2(m2, t3); ) i3.push(m2), m2 = c2(m2, r2);
    return i3;
  }
})), name$3q$1 = "reshape", dependencies$3q$1 = ["typed", "isInteger", "matrix"], createReshape$1 = factory$1(name$3q$1, dependencies$3q$1, ((e2) => {
  var { typed: t2, isInteger: r } = e2;
  return t2(name$3q$1, { "Matrix, Array": function(e3, t3) {
    return e3.reshape(t3, true);
  }, "Array, Array": function(e3, t3) {
    return t3.forEach((function(e4) {
      if (!r(e4)) throw new TypeError("Invalid size for dimension: " + e4);
    })), reshape$1(e3, t3);
  } });
})), name$3p$1 = "resize", dependencies$3p$1 = ["config", "matrix"], createResize$1 = factory$1(name$3p$1, dependencies$3p$1, ((e2) => {
  var { config: t2, matrix: r } = e2;
  return function(e3, n, i2) {
    if (2 !== arguments.length && 3 !== arguments.length) throw new ArgumentsError$1("resize", arguments.length, 2, 3);
    if (isMatrix$1(n) && (n = n.valueOf()), isBigNumber$1(n[0]) && (n = n.map((function(e4) {
      return isBigNumber$1(e4) ? e4.toNumber() : e4;
    }))), isMatrix$1(e3)) return e3.resize(n, i2, true);
    if ("string" == typeof e3) return (function(e4, t3, r2) {
      if (void 0 !== r2) {
        if ("string" != typeof r2 || 1 !== r2.length) throw new TypeError("Single character expected as defaultValue");
      } else r2 = " ";
      if (1 !== t3.length) throw new DimensionError$1(t3.length, 1);
      var n3 = t3[0];
      if ("number" != typeof n3 || !isInteger$1(n3)) throw new TypeError("Invalid size, must contain positive integers (size: " + format$3(t3) + ")");
      if (e4.length > n3) return e4.substring(0, n3);
      if (e4.length < n3) {
        for (var i3 = e4, a2 = 0, o2 = n3 - e4.length; a2 < o2; a2++) i3 += r2;
        return i3;
      }
      return e4;
    })(e3, n, i2);
    var a = !Array.isArray(e3) && "Array" !== t2.matrix;
    if (0 === n.length) {
      for (; Array.isArray(e3); ) e3 = e3[0];
      return clone$3$1(e3);
    }
    Array.isArray(e3) || (e3 = [e3]);
    var o = resize$1(e3 = clone$3$1(e3), n, i2);
    return a ? r(o) : o;
  };
})), name$3o$1 = "rotate", dependencies$3o$1 = ["typed", "multiply", "rotationMatrix"], createRotate$1 = factory$1(name$3o$1, dependencies$3o$1, ((e2) => {
  var { typed: t2, multiply: r, rotationMatrix: n } = e2;
  return t2(name$3o$1, { "Array , number | BigNumber | Complex | Unit": function(e3, t3) {
    return i2(e3, 2), r(n(t3), e3).toArray();
  }, "Matrix , number | BigNumber | Complex | Unit": function(e3, t3) {
    return i2(e3, 2), r(n(t3), e3);
  }, "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(e3, t3, a) {
    return i2(e3, 3), r(n(t3, a), e3);
  }, "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(e3, t3, a) {
    return i2(e3, 3), r(n(t3, a), e3);
  } });
  function i2(e3, t3) {
    var r2 = Array.isArray(e3) ? arraySize$1(e3) : e3.size();
    if (r2.length > 2) throw new RangeError("Vector must be of dimensions 1x".concat(t3));
    if (2 === r2.length && 1 !== r2[1]) throw new RangeError("Vector must be of dimensions 1x".concat(t3));
    if (r2[0] !== t3) throw new RangeError("Vector must be of dimensions 1x".concat(t3));
  }
})), name$3n$1 = "rotationMatrix", dependencies$3n$1 = ["typed", "config", "multiplyScalar", "addScalar", "unaryMinus", "norm", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix", "cos", "sin"], createRotationMatrix$1 = factory$1(name$3n$1, dependencies$3n$1, ((e2) => {
  var { typed: t2, config: r, multiplyScalar: n, addScalar: i2, unaryMinus: a, norm: o, BigNumber: s, matrix: u, DenseMatrix: c2, SparseMatrix: l, cos: f2, sin: p } = e2;
  return t2(name$3n$1, { "": function() {
    return "Matrix" === r.matrix ? u([]) : [];
  }, string: function(e3) {
    return u(e3);
  }, "number | BigNumber | Complex | Unit": function(e3) {
    return m(e3, "Matrix" === r.matrix ? "dense" : void 0);
  }, "number | BigNumber | Complex | Unit, string": function(e3, t3) {
    return m(e3, t3);
  }, "number | BigNumber | Complex | Unit, Array": function(e3, t3) {
    var r2 = u(t3);
    return d(r2), y(e3, r2, void 0);
  }, "number | BigNumber | Complex | Unit, Matrix": function(e3, t3) {
    d(t3);
    var n3 = t3.storage() || ("Matrix" === r.matrix ? "dense" : void 0);
    return y(e3, t3, n3);
  }, "number | BigNumber | Complex | Unit, Array, string": function(e3, t3, r2) {
    var n3 = u(t3);
    return d(n3), y(e3, n3, r2);
  }, "number | BigNumber | Complex | Unit, Matrix, string": function(e3, t3, r2) {
    return d(t3), y(e3, t3, r2);
  } });
  function m(e3, t3) {
    var r2 = isBigNumber$1(e3) ? new s(-1) : -1, i3 = f2(e3), a2 = p(e3);
    return g([[i3, n(r2, a2)], [a2, i3]], t3);
  }
  function d(e3) {
    var t3 = e3.size();
    if (t3.length < 1 || 3 !== t3[0]) throw new RangeError("Vector must be of dimensions 1x3");
  }
  function h(e3) {
    return e3.reduce(((e4, t3) => n(e4, t3)));
  }
  function g(e3, t3) {
    if (t3) {
      if ("sparse" === t3) return new l(e3);
      if ("dense" === t3) return new c2(e3);
      throw new TypeError('Unknown matrix type "'.concat(t3, '"'));
    }
    return e3;
  }
  function y(e3, t3, r2) {
    var n3 = o(t3);
    if (0 === n3) throw new RangeError("Rotation around zero vector");
    var u2 = isBigNumber$1(e3) ? s : null, c3 = u2 ? new u2(1) : 1, l2 = u2 ? new u2(-1) : -1, m2 = u2 ? new u2(t3.get([0]) / n3) : t3.get([0]) / n3, d2 = u2 ? new u2(t3.get([1]) / n3) : t3.get([1]) / n3, y2 = u2 ? new u2(t3.get([2]) / n3) : t3.get([2]) / n3, v2 = f2(e3), x2 = i2(c3, a(v2)), b2 = p(e3);
    return g([[i2(v2, h([m2, m2, x2])), i2(h([m2, d2, x2]), h([l2, y2, b2])), i2(h([m2, y2, x2]), h([d2, b2]))], [i2(h([m2, d2, x2]), h([y2, b2])), i2(v2, h([d2, d2, x2])), i2(h([d2, y2, x2]), h([l2, m2, b2]))], [i2(h([m2, y2, x2]), h([l2, d2, b2])), i2(h([d2, y2, x2]), h([m2, b2])), i2(v2, h([y2, y2, x2]))]], r2);
  }
})), name$3m$1 = "row", dependencies$3m$1 = ["typed", "Index", "matrix", "range"], createRow$1 = factory$1(name$3m$1, dependencies$3m$1, ((e2) => {
  var { typed: t2, Index: r, matrix: n, range: i2 } = e2;
  return t2(name$3m$1, { "Matrix, number": a, "Array, number": function(e3, t3) {
    return a(n(clone$3$1(e3)), t3).valueOf();
  } });
  function a(e3, t3) {
    if (2 !== e3.size().length) throw new Error("Only two dimensional matrix is supported");
    validateIndex$1(t3, e3.size()[0]);
    var a2 = i2(0, e3.size()[1]), o = new r([t3], a2), s = e3.subset(o);
    return isMatrix$1(s) ? s : n([[s]]);
  }
})), name$3l$1 = "size", dependencies$3l$1 = ["typed"], createSize$1 = factory$1(name$3l$1, dependencies$3l$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3l$1, { Matrix: (e3) => e3.size(), Array: arraySize$1, string: (e3) => [e3.length], "number | Complex | BigNumber | Unit | boolean | null": (e3) => [] });
})), name$3k$1 = "squeeze", dependencies$3k$1 = ["typed"], createSqueeze$1 = factory$1(name$3k$1, dependencies$3k$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3k$1, { Array: function(e3) {
    return squeeze$1(clone$3$1(e3));
  }, Matrix: function(e3) {
    var t3 = squeeze$1(e3.toArray());
    return Array.isArray(t3) ? e3.create(t3, e3.datatype()) : t3;
  }, any: function(e3) {
    return clone$3$1(e3);
  } });
})), name$3j$1 = "subset", dependencies$3j$1 = ["typed", "matrix", "zeros", "add"], createSubset$1 = factory$1(name$3j$1, dependencies$3j$1, ((e2) => {
  var { typed: t2, matrix: r, zeros: n, add: i2 } = e2;
  return t2(name$3j$1, { "Matrix, Index": function(e3, t3) {
    return isEmptyIndex$1(t3) ? r() : (validateIndexSourceSize$1(e3, t3), e3.subset(t3));
  }, "Array, Index": t2.referTo("Matrix, Index", (function(e3) {
    return function(t3, n3) {
      var i3 = e3(r(t3), n3);
      return n3.isScalar() ? i3 : i3.valueOf();
    };
  })), "Object, Index": _getObjectProperty$1, "string, Index": _getSubstring$1, "Matrix, Index, any, any": function(e3, t3, r2, a) {
    return isEmptyIndex$1(t3) ? e3 : (validateIndexSourceSize$1(e3, t3), e3.clone().subset(t3, (function(e4, t4) {
      if ("string" == typeof e4) throw new Error("can't boradcast a string");
      if (t4.isScalar()) return e4;
      var r3 = t4.size();
      if (!r3.every(((e5) => e5 > 0))) return e4;
      try {
        return i2(e4, n(r3));
      } catch (t5) {
        return e4;
      }
    })(r2, t3), a));
  }, "Array, Index, any, any": t2.referTo("Matrix, Index, any, any", (function(e3) {
    return function(t3, n3, i3, a) {
      var o = e3(r(t3), n3, i3, a);
      return o.isMatrix ? o.valueOf() : o;
    };
  })), "Array, Index, any": t2.referTo("Matrix, Index, any, any", (function(e3) {
    return function(t3, n3, i3) {
      return e3(r(t3), n3, i3, void 0).valueOf();
    };
  })), "Matrix, Index, any": t2.referTo("Matrix, Index, any, any", (function(e3) {
    return function(t3, r2, n3) {
      return e3(t3, r2, n3, void 0);
    };
  })), "string, Index, string": _setSubstring$1, "string, Index, string, string": _setSubstring$1, "Object, Index, any": _setObjectProperty$1 });
}));
function _getSubstring$1(e2, t2) {
  if (!isIndex$1(t2)) throw new TypeError("Index expected");
  if (isEmptyIndex$1(t2)) return "";
  if (validateIndexSourceSize$1(Array.from(e2), t2), 1 !== t2.size().length) throw new DimensionError$1(t2.size().length, 1);
  var r = e2.length;
  validateIndex$1(t2.min()[0], r), validateIndex$1(t2.max()[0], r);
  var n = t2.dimension(0), i2 = "";
  function a(t3) {
    i2 += e2.charAt(t3);
  }
  return Number.isInteger(n) ? a(n) : n.forEach(a), i2;
}
function _setSubstring$1(e2, t2, r, n) {
  if (!t2 || true !== t2.isIndex) throw new TypeError("Index expected");
  if (isEmptyIndex$1(t2)) return e2;
  if (validateIndexSourceSize$1(Array.from(e2), t2), 1 !== t2.size().length) throw new DimensionError$1(t2.size().length, 1);
  if (void 0 !== n) {
    if ("string" != typeof n || 1 !== n.length) throw new TypeError("Single character expected as defaultValue");
  } else n = " ";
  var i2 = t2.dimension(0);
  if ((Number.isInteger(i2) ? 1 : i2.size()[0]) !== r.length) throw new DimensionError$1(i2.size()[0], r.length);
  var a = e2.length;
  validateIndex$1(t2.min()[0]), validateIndex$1(t2.max()[0]);
  for (var o = [], s = 0; s < a; s++) o[s] = e2.charAt(s);
  function u(e3, t3) {
    o[e3] = r.charAt(t3[0]);
  }
  if (Number.isInteger(i2) ? u(i2, [0]) : i2.forEach(u), o.length > a) for (var c2 = a - 1, l = o.length; c2 < l; c2++) o[c2] || (o[c2] = n);
  return o.join("");
}
function _getObjectProperty$1(e2, t2) {
  if (!isEmptyIndex$1(t2)) {
    if (1 !== t2.size().length) throw new DimensionError$1(t2.size(), 1);
    var r = t2.dimension(0);
    if ("string" != typeof r) throw new TypeError("String expected as index to retrieve an object property");
    return getSafeProperty$1(e2, r);
  }
}
function _setObjectProperty$1(e2, t2, r) {
  if (isEmptyIndex$1(t2)) return e2;
  if (1 !== t2.size().length) throw new DimensionError$1(t2.size(), 1);
  var n = t2.dimension(0);
  if ("string" != typeof n) throw new TypeError("String expected as index to retrieve an object property");
  var i2 = clone$3$1(e2);
  return setSafeProperty$1(i2, n, r), i2;
}
var name$3i$1 = "transpose", dependencies$3i$1 = ["typed", "matrix"], createTranspose$1 = factory$1(name$3i$1, dependencies$3i$1, ((e2) => {
  var { typed: t2, matrix: r } = e2;
  return t2(name$3i$1, { Array: (e3) => n(r(e3)).valueOf(), Matrix: n, any: clone$3$1 });
  function n(e3) {
    var t3, r2 = e3.size();
    switch (r2.length) {
      case 1:
        t3 = e3.clone();
        break;
      case 2:
        var n3 = r2[0], i2 = r2[1];
        if (0 === i2) throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + format$3(r2) + ")");
        switch (e3.storage()) {
          case "dense":
            t3 = (function(e4, t4, r3) {
              for (var n4, i3 = e4._data, a = [], o = 0; o < r3; o++) {
                n4 = a[o] = [];
                for (var s = 0; s < t4; s++) n4[s] = clone$3$1(i3[s][o]);
              }
              return e4.createDenseMatrix({ data: a, size: [r3, t4], datatype: e4._datatype });
            })(e3, n3, i2);
            break;
          case "sparse":
            t3 = (function(e4, t4, r3) {
              for (var n4, i3, a, o = e4._values, s = e4._index, u = e4._ptr, c2 = o ? [] : void 0, l = [], f2 = [], p = [], m = 0; m < t4; m++) p[m] = 0;
              for (n4 = 0, i3 = s.length; n4 < i3; n4++) p[s[n4]]++;
              for (var d = 0, h = 0; h < t4; h++) f2.push(d), d += p[h], p[h] = f2[h];
              for (f2.push(d), a = 0; a < r3; a++) for (var g = u[a], y = u[a + 1], v2 = g; v2 < y; v2++) {
                var x2 = p[s[v2]]++;
                l[x2] = a, o && (c2[x2] = clone$3$1(o[v2]));
              }
              return e4.createSparseMatrix({ values: c2, index: l, ptr: f2, size: [r3, t4], datatype: e4._datatype });
            })(e3, n3, i2);
        }
        break;
      default:
        throw new RangeError("Matrix must be a vector or two dimensional (size: " + format$3(r2) + ")");
    }
    return t3;
  }
})), name$3h$1 = "ctranspose", dependencies$3h$1 = ["typed", "transpose", "conj"], createCtranspose$1 = factory$1(name$3h$1, dependencies$3h$1, ((e2) => {
  var { typed: t2, transpose: r, conj: n } = e2;
  return t2(name$3h$1, { any: function(e3) {
    return n(r(e3));
  } });
})), name$3g$1 = "zeros", dependencies$3g$1 = ["typed", "config", "matrix", "BigNumber"], createZeros$1 = factory$1(name$3g$1, dependencies$3g$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, BigNumber: i2 } = e2;
  return t2(name$3g$1, { "": function() {
    return "Array" === r.matrix ? a([]) : a([], "default");
  }, "...number | BigNumber | string": function(e3) {
    if ("string" == typeof e3[e3.length - 1]) {
      var t3 = e3.pop();
      return a(e3, t3);
    }
    return "Array" === r.matrix ? a(e3) : a(e3, "default");
  }, Array: a, Matrix: function(e3) {
    var t3 = e3.storage();
    return a(e3.valueOf(), t3);
  }, "Array | Matrix, string": function(e3, t3) {
    return a(e3.valueOf(), t3);
  } });
  function a(e3, t3) {
    var r2 = (function(e4) {
      var t4 = false;
      return e4.forEach((function(e5, r3, n3) {
        isBigNumber$1(e5) && (t4 = true, n3[r3] = e5.toNumber());
      })), t4;
    })(e3), a2 = r2 ? new i2(0) : 0;
    if ((function(e4) {
      e4.forEach((function(e5) {
        if ("number" != typeof e5 || !isInteger$1(e5) || e5 < 0) throw new Error("Parameters in function zeros must be positive integers");
      }));
    })(e3), t3) {
      var o = n(t3);
      return e3.length > 0 ? o.resize(e3, a2) : o;
    }
    var s = [];
    return e3.length > 0 ? resize$1(s, e3, a2) : s;
  }
})), name$3f$1 = "fft", dependencies$3f$1 = ["typed", "matrix", "addScalar", "multiplyScalar", "divideScalar", "exp", "tau", "i", "dotDivide", "conj", "pow", "ceil", "log2"], createFft$1 = factory$1(name$3f$1, dependencies$3f$1, ((e2) => {
  var { typed: t2, matrix: r, addScalar: n, multiplyScalar: i2, divideScalar: a, exp: o, tau: s, i: u, dotDivide: c2, conj: l, pow: f2, ceil: p, log2: m } = e2;
  return t2(name$3f$1, { Array: d, Matrix: function(e3) {
    return e3.create(d(e3.valueOf()), e3.datatype());
  } });
  function d(e3) {
    var t3 = arraySize$1(e3);
    return 1 === t3.length ? g(e3, t3[0]) : h(e3.map(((e4) => d(e4, t3.slice(1)))), 0);
  }
  function h(e3, t3) {
    var r2 = arraySize$1(e3);
    if (0 !== t3) return new Array(r2[0]).fill(0).map(((r3, n4) => h(e3[n4], t3 - 1)));
    if (1 === r2.length) return g(e3);
    function n3(e4) {
      var t4 = arraySize$1(e4);
      return new Array(t4[1]).fill(0).map(((r3, n4) => new Array(t4[0]).fill(0).map(((t5, r4) => e4[r4][n4]))));
    }
    return n3(h(n3(e3), 1));
  }
  function g(e3) {
    var t3 = e3.length;
    if (1 === t3) return [e3[0]];
    if (t3 % 2 == 0) {
      for (var r2 = [...g(e3.filter(((e4, t4) => t4 % 2 == 0))), ...g(e3.filter(((e4, t4) => t4 % 2 == 1)))], h2 = 0; h2 < t3 / 2; h2++) {
        var y = r2[h2], v2 = i2(r2[h2 + t3 / 2], o(i2(i2(s, u), a(-h2, t3))));
        r2[h2] = n(y, v2), r2[h2 + t3 / 2] = n(y, i2(-1, v2));
      }
      return r2;
    }
    return (function(e4) {
      for (var t4 = e4.length, r3 = o(a(i2(-1, i2(u, s)), t4)), n3 = [], h3 = 1 - t4; h3 < t4; h3++) n3.push(f2(r3, a(f2(h3, 2), 2)));
      for (var y2 = f2(2, p(m(t4 + t4 - 1))), v3 = [...new Array(t4).fill(0).map(((r4, a2) => i2(e4[a2], n3[t4 - 1 + a2]))), ...new Array(y2 - t4).fill(0)], x2 = [...new Array(t4 + t4 - 1).fill(0).map(((e5, t5) => a(1, n3[t5]))), ...new Array(y2 - (t4 + t4 - 1)).fill(0)], b2 = g(v3), _2 = g(x2), w2 = new Array(y2).fill(0).map(((e5, t5) => i2(b2[t5], _2[t5]))), A2 = c2(l(d(l(w2))), y2), N = [], D = t4 - 1; D < t4 + t4 - 1; D++) N.push(i2(A2[D], n3[D]));
      return N;
    })(e3);
  }
})), name$3e$1 = "ifft", dependencies$3e$1 = ["typed", "fft", "dotDivide", "conj"], createIfft$1 = factory$1(name$3e$1, dependencies$3e$1, ((e2) => {
  var { typed: t2, fft: r, dotDivide: n, conj: i2 } = e2;
  return t2(name$3e$1, { "Array | Matrix": function(e3) {
    var t3 = isMatrix$1(e3) ? e3.size() : arraySize$1(e3);
    return n(i2(r(i2(e3))), t3.reduce(((e4, t4) => e4 * t4), 1));
  } });
}));
function _typeof$1(e2) {
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e3) {
    return typeof e3;
  } : function(e3) {
    return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
  }, _typeof$1(e2);
}
function toPrimitive$1(e2, t2) {
  if ("object" != _typeof$1(e2) || !e2) return e2;
  var r = e2[Symbol.toPrimitive];
  if (void 0 !== r) {
    var n = r.call(e2, t2);
    if ("object" != _typeof$1(n)) return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === t2 ? String : Number)(e2);
}
function toPropertyKey$1(e2) {
  var t2 = toPrimitive$1(e2, "string");
  return "symbol" == _typeof$1(t2) ? t2 : t2 + "";
}
function _defineProperty$3(e2, t2, r) {
  return (t2 = toPropertyKey$1(t2)) in e2 ? Object.defineProperty(e2, t2, { value: r, enumerable: true, configurable: true, writable: true }) : e2[t2] = r, e2;
}
function ownKeys$3$1(e2, t2) {
  var r = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e2);
    t2 && (n = n.filter((function(t3) {
      return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread$3$1(e2) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? ownKeys$3$1(Object(r), true).forEach((function(t3) {
      _defineProperty$3(e2, t3, r[t3]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r)) : ownKeys$3$1(Object(r)).forEach((function(t3) {
      Object.defineProperty(e2, t3, Object.getOwnPropertyDescriptor(r, t3));
    }));
  }
  return e2;
}
var name$3d$1 = "solveODE", dependencies$3d$1 = ["typed", "add", "subtract", "multiply", "divide", "max", "map", "abs", "isPositive", "isNegative", "larger", "smaller", "matrix", "bignumber", "unaryMinus"], createSolveODE$1 = factory$1(name$3d$1, dependencies$3d$1, ((e2) => {
  var { typed: t2, add: r, subtract: n, multiply: i2, divide: a, max: o, map: s, abs: u, isPositive: c2, isNegative: l, larger: f2, smaller: p, matrix: m, bignumber: d, unaryMinus: h } = e2;
  function g(e3) {
    return function(t3, m2, g2, y2) {
      if (!(2 === m2.length && (m2.every(b2) || m2.every(isUnit$1)))) throw new Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
      var v3 = m2[0], x3 = m2[1], _3 = f2(x3, v3), w2 = y2.firstStep;
      if (void 0 !== w2 && !c2(w2)) throw new Error('"firstStep" must be positive');
      var A2 = y2.maxStep;
      if (void 0 !== A2 && !c2(A2)) throw new Error('"maxStep" must be positive');
      var N = y2.minStep;
      if (N && l(N)) throw new Error('"minStep" must be positive or zero');
      var D = [v3, x3, w2, N, A2].filter(((e4) => void 0 !== e4));
      if (!D.every(b2) && !D.every(isUnit$1)) throw new Error('Inconsistent type of "t" dependant variables');
      for (var E = y2.tol ? y2.tol : 1e-4, $2 = y2.minDelta ? y2.minDelta : 0.2, S2 = y2.maxDelta ? y2.maxDelta : 5, C2 = y2.maxIter ? y2.maxIter : 1e4, M2 = [v3, x3, ...g2, A2, N].some(isBigNumber$1), [T2, F, O2, k2] = M2 ? [d(e3.a), d(e3.c), d(e3.b), d(e3.bp)] : [e3.a, e3.c, e3.b, e3.bp], B2 = w2 ? _3 ? w2 : h(w2) : a(n(x3, v3), 1), I2 = [v3], R2 = [g2], q2 = n(O2, k2), z2 = 0, P2 = 0, L2 = /* @__PURE__ */ (function(e4) {
        return e4 ? p : f2;
      })(_3), j2 = /* @__PURE__ */ (function(e4) {
        var t4 = e4 ? f2 : p;
        return function(e5, i3, a2) {
          var o2 = r(e5, a2);
          return t4(o2, i3) ? n(i3, e5) : a2;
        };
      })(_3); L2(I2[z2], x3); ) {
        var U2 = [];
        B2 = j2(I2[z2], x3, B2), U2.push(t3(I2[z2], R2[z2]));
        for (var Z2 = 1; Z2 < F.length; ++Z2) U2.push(t3(r(I2[z2], i2(F[Z2], B2)), r(R2[z2], i2(B2, T2[Z2], U2))));
        var G2 = o(u(s(i2(q2, U2), ((e4) => isUnit$1(e4) ? e4.value : e4))));
        G2 < E && E / G2 > 1 / 4 && (I2.push(r(I2[z2], B2)), R2.push(r(R2[z2], i2(B2, O2, U2))), z2++);
        var V2 = 0.84 * (E / G2) ** 0.2;
        if (p(V2, $2) ? V2 = $2 : f2(V2, S2) && (V2 = S2), V2 = M2 ? d(V2) : V2, B2 = i2(B2, V2), A2 && f2(u(B2), A2) ? B2 = _3 ? A2 : h(A2) : N && p(u(B2), N) && (B2 = _3 ? N : h(N)), ++P2 > C2) throw new Error("Maximum number of iterations reached, try changing options");
      }
      return { t: I2, y: R2 };
    };
  }
  function y(e3, t3, r2, n3) {
    return g({ a: [[], [0.5], [0, 3 / 4], [2 / 9, 1 / 3, 4 / 9]], c: [null, 0.5, 3 / 4, 1], b: [2 / 9, 1 / 3, 4 / 9, 0], bp: [7 / 24, 1 / 4, 1 / 3, 1 / 8] })(e3, t3, r2, n3);
  }
  function v2(e3, t3, r2, n3) {
    return g({ a: [[], [0.2], [3 / 40, 9 / 40], [44 / 45, -56 / 15, 32 / 9], [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84]], c: [null, 0.2, 0.3, 0.8, 8 / 9, 1, 1], b: [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], bp: [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40] })(e3, t3, r2, n3);
  }
  function x2(e3, t3, r2, n3) {
    var i3 = n3.method ? n3.method : "RK45", a2 = { RK23: y, RK45: v2 };
    if (i3.toUpperCase() in a2) {
      var o2 = _objectSpread$3$1({}, n3);
      return delete o2.method, a2[i3.toUpperCase()](e3, t3, r2, o2);
    }
    var s2 = Object.keys(a2).map(((e4) => '"'.concat(e4, '"'))), u2 = "".concat(s2.slice(0, -1).join(", "), " and ").concat(s2.slice(-1));
    throw new Error('Unavailable method "'.concat(i3, '". Available methods are ').concat(u2));
  }
  function b2(e3) {
    return isBigNumber$1(e3) || isNumber$1$1(e3);
  }
  function _2(e3, t3, r2, n3) {
    var i3 = x2(e3, t3.toArray(), r2.toArray(), n3);
    return { t: m(i3.t), y: m(i3.y) };
  }
  return t2("solveODE", { "function, Array, Array, Object": x2, "function, Matrix, Matrix, Object": _2, "function, Array, Array": (e3, t3, r2) => x2(e3, t3, r2, {}), "function, Matrix, Matrix": (e3, t3, r2) => _2(e3, t3, r2, {}), "function, Array, number | BigNumber | Unit": (e3, t3, r2) => {
    var n3 = x2(e3, t3, [r2], {});
    return { t: n3.t, y: n3.y.map(((e4) => e4[0])) };
  }, "function, Matrix, number | BigNumber | Unit": (e3, t3, r2) => {
    var n3 = x2(e3, t3.toArray(), [r2], {});
    return { t: m(n3.t), y: m(n3.y.map(((e4) => e4[0]))) };
  }, "function, Array, number | BigNumber | Unit, Object": (e3, t3, r2, n3) => {
    var i3 = x2(e3, t3, [r2], n3);
    return { t: i3.t, y: i3.y.map(((e4) => e4[0])) };
  }, "function, Matrix, number | BigNumber | Unit, Object": (e3, t3, r2, n3) => {
    var i3 = x2(e3, t3.toArray(), [r2], n3);
    return { t: m(i3.t), y: m(i3.y.map(((e4) => e4[0]))) };
  } });
})), name$3c$1 = "erf", dependencies$3c$1 = ["typed"], createErf$1 = factory$1(name$3c$1, dependencies$3c$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2("name", { number: function(e3) {
    var t3 = Math.abs(e3);
    return t3 >= MAX_NUM$1 ? sign$2$1(e3) : t3 <= THRESH$1 ? sign$2$1(e3) * (function(e4) {
      var t4, r = e4 * e4, n = P$5[0][4] * r, i2 = r;
      for (t4 = 0; t4 < 3; t4 += 1) n = (n + P$5[0][t4]) * r, i2 = (i2 + Q$1[0][t4]) * r;
      return e4 * (n + P$5[0][3]) / (i2 + Q$1[0][3]);
    })(t3) : t3 <= 4 ? sign$2$1(e3) * (1 - (function(e4) {
      var t4, r = P$5[1][8] * e4, n = e4;
      for (t4 = 0; t4 < 7; t4 += 1) r = (r + P$5[1][t4]) * e4, n = (n + Q$1[1][t4]) * e4;
      var i2 = (r + P$5[1][7]) / (n + Q$1[1][7]), a = parseInt(16 * e4) / 16, o = (e4 - a) * (e4 + a);
      return Math.exp(-a * a) * Math.exp(-o) * i2;
    })(t3)) : sign$2$1(e3) * (1 - (function(e4) {
      var t4, r = 1 / (e4 * e4), n = P$5[2][5] * r, i2 = r;
      for (t4 = 0; t4 < 4; t4 += 1) n = (n + P$5[2][t4]) * r, i2 = (i2 + Q$1[2][t4]) * r;
      var a = r * (n + P$5[2][4]) / (i2 + Q$1[2][4]);
      a = (SQRPI$1 - a) / e4, r = parseInt(16 * e4) / 16;
      var o = (e4 - r) * (e4 + r);
      return Math.exp(-r * r) * Math.exp(-o) * a;
    })(t3));
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), THRESH$1 = 0.46875, SQRPI$1 = 0.5641895835477563, P$5 = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Q$1 = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], MAX_NUM$1 = Math.pow(2, 53), name$3b$1 = "zeta", dependencies$3b$1 = ["typed", "config", "multiply", "pow", "divide", "factorial", "equal", "smallerEq", "isBounded", "isNegative", "gamma", "sin", "subtract", "add", "?Complex", "?BigNumber", "pi"], createZeta$1 = factory$1(name$3b$1, dependencies$3b$1, ((e2) => {
  var { typed: t2, config: r, multiply: n, pow: i2, divide: a, factorial: o, equal: s, smallerEq: u, isBounded: c2, isNegative: l, gamma: f2, sin: p, subtract: m, add: d, Complex: h, BigNumber: g, pi: y } = e2;
  return t2(name$3b$1, { number: (e3) => v2(e3, ((e4) => e4), (() => 20)), BigNumber: (e3) => v2(e3, ((e4) => new g(e4)), (() => Math.abs(Math.log10(r.relTol)))), Complex: function(e3) {
    if (0 === e3.re && 0 === e3.im) return new h(-0.5);
    if (1 === e3.re) return new h(NaN, NaN);
    if (e3.re === 1 / 0 && 0 === e3.im) return new h(1);
    if (e3.im === 1 / 0 || e3.re === -1 / 0) return new h(NaN, NaN);
    return x2(e3, ((e4) => e4), ((e4) => Math.round(19.5 + 0.9 * Math.abs(e4.im))), ((e4) => e4.re));
  } });
  function v2(e3, t3, r2) {
    return s(e3, 0) ? t3(-0.5) : s(e3, 1) ? t3(NaN) : c2(e3) ? x2(e3, t3, r2, ((e4) => e4)) : l(e3) ? t3(NaN) : t3(1);
  }
  function x2(e3, t3, r2, o2) {
    var s2 = r2(e3);
    if (o2(e3) > -(s2 - 1) / 2) return (function(e4, t4, r3) {
      for (var o3 = a(1, n(b2(r3(0), t4), m(1, i2(2, m(1, e4))))), s3 = r3(0), c4 = r3(1); u(c4, t4); c4 = d(c4, 1)) s3 = d(s3, a(n((-1) ** (c4 - 1), b2(c4, t4)), i2(c4, e4)));
      return n(o3, s3);
    })(e3, t3(s2), t3);
    var c3 = n(i2(2, e3), i2(t3(y), m(e3, 1)));
    return c3 = n(c3, p(n(a(t3(y), 2), e3))), c3 = n(c3, f2(m(1, e3))), n(c3, x2(m(1, e3), t3, r2, o2));
  }
  function b2(e3, t3) {
    for (var r2 = e3, s2 = e3; u(s2, t3); s2 = d(s2, 1)) {
      var c3 = a(n(o(d(t3, m(s2, 1))), i2(4, s2)), n(o(m(t3, s2)), o(n(2, s2))));
      r2 = d(r2, c3);
    }
    return n(t3, r2);
  }
})), name$3a$1 = "mode", dependencies$3a$1 = ["typed", "isNaN", "isNumeric"], createMode$1 = factory$1(name$3a$1, dependencies$3a$1, ((e2) => {
  var { typed: t2, isNaN: r, isNumeric: n } = e2;
  return t2(name$3a$1, { "Array | Matrix": i2, "...": function(e3) {
    return i2(e3);
  } });
  function i2(e3) {
    if (0 === (e3 = flatten$4$1(e3.valueOf())).length) throw new Error("Cannot calculate mode of an empty array");
    for (var t3 = {}, i3 = [], a = 0, o = 0; o < e3.length; o++) {
      var s = e3[o];
      if (n(s) && r(s)) throw new Error("Cannot calculate mode of an array containing NaN values");
      s in t3 || (t3[s] = 0), t3[s]++, t3[s] === a ? i3.push(s) : t3[s] > a && (a = t3[s], i3 = [s]);
    }
    return i3;
  }
}));
function improveErrorMessage$1(e2, t2, r) {
  var n;
  return String(e2).includes("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + typeOf$1(r) + ", value: " + JSON.stringify(r) + ")" : " (type: " + e2.data.actual + ")", new TypeError("Cannot calculate " + t2 + ", unexpected type of argument" + n)) : String(e2).includes("complex numbers") ? (n = arguments.length > 2 ? " (type: " + typeOf$1(r) + ", value: " + JSON.stringify(r) + ")" : "", new TypeError("Cannot calculate " + t2 + ", no ordering relation is defined for complex numbers" + n)) : e2;
}
var name$39$1 = "prod", dependencies$39$1 = ["typed", "config", "multiplyScalar", "numeric"], createProd$1 = factory$1(name$39$1, dependencies$39$1, ((e2) => {
  var { typed: t2, config: r, multiplyScalar: n, numeric: i2 } = e2;
  return t2(name$39$1, { "Array | Matrix": a, "Array | Matrix, number | BigNumber": function(e3, t3) {
    throw new Error("prod(A, dim) is not yet supported");
  }, "...": function(e3) {
    return a(e3);
  } });
  function a(e3) {
    var t3;
    if (deepForEach$2(e3, (function(e4) {
      try {
        t3 = void 0 === t3 ? e4 : n(t3, e4);
      } catch (t4) {
        throw improveErrorMessage$1(t4, "prod", e4);
      }
    })), "string" == typeof t3 && (t3 = i2(t3, safeNumberType$1(t3, r))), void 0 === t3) throw new Error("Cannot calculate prod of an empty array");
    return t3;
  }
})), name$38$1 = "format", dependencies$38$1 = ["typed"], createFormat$1 = factory$1(name$38$1, dependencies$38$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$38$1, { any: format$3, "any, Object | function | number | BigNumber": format$3 });
})), name$37$1 = "bin", dependencies$37$1 = ["typed", "format"], createBin$1 = factory$1(name$37$1, dependencies$37$1, ((e2) => {
  var { typed: t2, format: r } = e2;
  return t2(name$37$1, { "number | BigNumber": function(e3) {
    return r(e3, { notation: "bin" });
  }, "number | BigNumber, number | BigNumber": function(e3, t3) {
    return r(e3, { notation: "bin", wordSize: t3 });
  } });
})), name$36$1 = "oct", dependencies$36$1 = ["typed", "format"], createOct$1 = factory$1(name$36$1, dependencies$36$1, ((e2) => {
  var { typed: t2, format: r } = e2;
  return t2(name$36$1, { "number | BigNumber": function(e3) {
    return r(e3, { notation: "oct" });
  }, "number | BigNumber, number | BigNumber": function(e3, t3) {
    return r(e3, { notation: "oct", wordSize: t3 });
  } });
})), name$35$1 = "hex", dependencies$35$1 = ["typed", "format"], createHex$1 = factory$1(name$35$1, dependencies$35$1, ((e2) => {
  var { typed: t2, format: r } = e2;
  return t2(name$35$1, { "number | BigNumber": function(e3) {
    return r(e3, { notation: "hex" });
  }, "number | BigNumber, number | BigNumber": function(e3, t3) {
    return r(e3, { notation: "hex", wordSize: t3 });
  } });
})), printTemplate$1 = /\$([\w.]+)/g, name$34$1 = "print", dependencies$34$1 = ["typed"], createPrint$1 = factory$1(name$34$1, dependencies$34$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$34$1, { "string, Object | Array": _print$1, "string, Object | Array, number | Object": _print$1 });
}));
function _print$1(e2, t2, r) {
  return e2.replace(printTemplate$1, (function(e3, n) {
    var i2 = n.split("."), a = t2[i2.shift()];
    for (void 0 !== a && a.isMatrix && (a = a.toArray()); i2.length && void 0 !== a; ) {
      var o = i2.shift();
      a = o ? a[o] : a + ".";
    }
    return void 0 !== a ? isString$1$1(a) ? a : format$3(a, r) : e3;
  }));
}
var name$33$1 = "to", dependencies$33$1 = ["typed", "matrix", "concat"], createTo$1 = factory$1(name$33$1, dependencies$33$1, ((e2) => {
  var { typed: t2, matrix: r, concat: n } = e2, i2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: n });
  return t2(name$33$1, { "Unit, Unit | string": (e3, t3) => e3.to(t3) }, i2({ Ds: true }));
})), name$32$1 = "toBest", dependencies$32$1 = ["typed"], createToBest$1 = factory$1(name$32$1, dependencies$32$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$32$1, { Unit: (e3) => e3.toBest(), "Unit, string": (e3, t3) => e3.toBest(t3.split(",")), "Unit, string, Object": (e3, t3, r) => e3.toBest(t3.split(","), r), "Unit, Array": (e3, t3) => e3.toBest(t3), "Unit, Array, Object": (e3, t3, r) => e3.toBest(t3, r) });
})), name$31$1 = "isPrime", dependencies$31$1 = ["typed"], createIsPrime$1 = factory$1(name$31$1, dependencies$31$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$31$1, { number: function(e3) {
    if (e3 <= 3) return e3 > 1;
    if (e3 % 2 == 0 || e3 % 3 == 0) return false;
    for (var t3 = 5; t3 * t3 <= e3; t3 += 6) if (e3 % t3 == 0 || e3 % (t3 + 2) == 0) return false;
    return true;
  }, bigint: function(e3) {
    if (e3 <= 3n) return e3 > 1n;
    if (e3 % 2n === 0n || e3 % 3n === 0n) return false;
    for (var t3 = 5n; t3 * t3 <= e3; t3 += 6n) if (e3 % t3 === 0n || e3 % (t3 + 2n) === 0n) return false;
    return true;
  }, BigNumber: function(e3) {
    if (e3.lte(3)) return e3.gt(1);
    if (e3.mod(2).eq(0) || e3.mod(3).eq(0)) return false;
    if (e3.lt(Math.pow(2, 32))) {
      for (var t3 = e3.toNumber(), r = 5; r * r <= t3; r += 6) if (t3 % r == 0 || t3 % (r + 2) == 0) return false;
      return true;
    }
    function n(e4, t4, r2) {
      for (var n3 = 1; !t4.eq(0); ) t4.mod(2).eq(0) ? (t4 = t4.div(2), e4 = e4.mul(e4).mod(r2)) : (t4 = t4.sub(1), n3 = e4.mul(n3).mod(r2));
      return n3;
    }
    for (var i2 = e3.constructor.clone({ precision: 2 * e3.toFixed(0).length }), a = 0, o = (e3 = new i2(e3)).sub(1); o.mod(2).eq(0); ) o = o.div(2), a += 1;
    var s = null;
    if (e3.lt("3317044064679887385961981")) s = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter(((t4) => t4 < e3));
    else {
      var u = Math.min(e3.toNumber() - 2, Math.floor(2 * Math.pow(e3.toFixed(0).length * Math.log(10), 2)));
      s = [];
      for (var c2 = 2; c2 <= u; c2 += 1) s.push(u);
    }
    for (var l = 0; l < s.length; l += 1) {
      var f2 = s[l], p = n(e3.sub(e3).add(f2), o, e3);
      if (!p.eq(1)) {
        for (var m = 0, d = p; !d.eq(e3.sub(1)); m += 1, d = d.mul(d).mod(e3)) if (m === a - 1) return false;
      }
    }
    return true;
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$30$1 = "numeric", dependencies$30$1 = ["number", "?bignumber", "?fraction"], createNumeric$1 = factory$1(name$30$1, dependencies$30$1, ((e2) => {
  var { number: t2, bignumber: r, fraction: n } = e2, i2 = { string: true, number: true, BigNumber: true, Fraction: true }, a = { number: (e3) => t2(e3), BigNumber: r ? (e3) => r(e3) : noBignumber$1, bigint: (e3) => BigInt(e3), Fraction: n ? (e3) => n(e3) : noFraction$1 };
  return function(e3) {
    var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "number";
    if (void 0 !== (arguments.length > 2 ? arguments[2] : void 0)) throw new SyntaxError("numeric() takes one or two arguments");
    var r2 = typeOf$1(e3);
    if (!(r2 in i2)) throw new TypeError("Cannot convert " + e3 + ' of type "' + r2 + '"; valid input types are ' + Object.keys(i2).join(", "));
    if (!(t3 in a)) throw new TypeError("Cannot convert " + e3 + ' to type "' + t3 + '"; valid output types are ' + Object.keys(a).join(", "));
    return t3 === r2 ? e3 : a[t3](e3);
  };
})), name$2$$1 = "divideScalar", dependencies$2$$1 = ["typed", "numeric"], createDivideScalar$1 = factory$1(name$2$$1, dependencies$2$$1, ((e2) => {
  var { typed: t2, numeric: r } = e2;
  return t2(name$2$$1, { "number, number": function(e3, t3) {
    return e3 / t3;
  }, "Complex, Complex": function(e3, t3) {
    return e3.div(t3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return e3.div(t3);
  }, "bigint, bigint": function(e3, t3) {
    return e3 / t3;
  }, "Fraction, Fraction": function(e3, t3) {
    return e3.div(t3);
  }, "Unit, number | Complex | Fraction | BigNumber | Unit": (e3, t3) => e3.divide(t3), "number | Fraction | Complex | BigNumber, Unit": (e3, t3) => t3.divideInto(e3) });
})), name$2_$1 = "pow", dependencies$2_$1 = ["typed", "config", "identity", "multiply", "matrix", "inv", "fraction", "number", "Complex"], createPow$1 = factory$1(name$2_$1, dependencies$2_$1, ((e2) => {
  var { typed: t2, config: r, identity: n, multiply: i2, matrix: a, inv: o, number: s, fraction: u, Complex: c2 } = e2;
  return t2(name$2_$1, { "number, number": l, "Complex, Complex": function(e3, t3) {
    return e3.pow(t3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return t3.isInteger() || e3 >= 0 || r.predictable ? e3.pow(t3) : new c2(e3.toNumber(), 0).pow(t3.toNumber(), 0);
  }, "bigint, bigint": (e3, t3) => e3 ** t3, "Fraction, Fraction": function(e3, t3) {
    var n3 = e3.pow(t3);
    if (null != n3) return n3;
    if (r.predictable) throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
    return l(e3.valueOf(), t3.valueOf());
  }, "Array, number": f2, "Array, BigNumber": function(e3, t3) {
    return f2(e3, t3.toNumber());
  }, "Matrix, number": p, "Matrix, BigNumber": function(e3, t3) {
    return p(e3, t3.toNumber());
  }, "Unit, number | BigNumber": function(e3, t3) {
    return e3.pow(t3);
  } });
  function l(e3, t3) {
    if (r.predictable && !isInteger$1(t3) && e3 < 0) try {
      var n3 = u(t3), i3 = s(n3);
      if ((t3 === i3 || Math.abs((t3 - i3) / t3) < 1e-14) && n3.d % 2n === 1n) return (n3.n % 2n === 0n ? 1 : -1) * Math.pow(-e3, t3);
    } catch (e4) {
    }
    return r.predictable && (e3 < -1 && t3 === 1 / 0 || e3 > -1 && e3 < 0 && t3 === -1 / 0) ? NaN : isInteger$1(t3) || e3 >= 0 || r.predictable ? powNumber$1(e3, t3) : e3 * e3 < 1 && t3 === 1 / 0 || e3 * e3 > 1 && t3 === -1 / 0 ? 0 : new c2(e3, 0).pow(t3, 0);
  }
  function f2(e3, t3) {
    if (!isInteger$1(t3)) throw new TypeError("For A^b, b must be an integer (value is " + t3 + ")");
    var r2 = arraySize$1(e3);
    if (2 !== r2.length) throw new Error("For A^b, A must be 2 dimensional (A has " + r2.length + " dimensions)");
    if (r2[0] !== r2[1]) throw new Error("For A^b, A must be square (size is " + r2[0] + "x" + r2[1] + ")");
    if (t3 < 0) try {
      return f2(o(e3), -t3);
    } catch (e4) {
      if ("Cannot calculate inverse, determinant is zero" === e4.message) throw new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + t3 + ")");
      throw e4;
    }
    for (var a2 = n(r2[0]).valueOf(), s2 = e3; t3 >= 1; ) 1 & ~t3 || (a2 = i2(s2, a2)), t3 >>= 1, s2 = i2(s2, s2);
    return a2;
  }
  function p(e3, t3) {
    return a(f2(e3.valueOf(), t3));
  }
})), NO_INT$1 = "Number of decimals in function round must be an integer", name$2Z$1 = "round", dependencies$2Z$1 = ["typed", "config", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix"], createRound$1 = factory$1(name$2Z$1, dependencies$2Z$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, equalScalar: i2, zeros: a, BigNumber: o, DenseMatrix: s } = e2, u = createMatAlgo11xS0s$1({ typed: t2, equalScalar: i2 }), c2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: s }), l = createMatAlgo14xDs$1({ typed: t2 });
  function f2(e3) {
    return Math.abs(splitNumber$1(e3).exponent);
  }
  return t2(name$2Z$1, { number: function(e3) {
    var t3 = roundNumber$1(e3, f2(r.relTol));
    return roundNumber$1(nearlyEqual$1$1(e3, t3, r.relTol, r.absTol) ? t3 : e3);
  }, "number, number": function(e3, t3) {
    var n3 = f2(r.relTol);
    if (t3 >= n3) return roundNumber$1(e3, t3);
    var i3 = roundNumber$1(e3, n3);
    return roundNumber$1(nearlyEqual$1$1(e3, i3, r.relTol, r.absTol) ? i3 : e3, t3);
  }, "number, BigNumber": function(e3, t3) {
    if (!t3.isInteger()) throw new TypeError(NO_INT$1);
    return new o(e3).toDecimalPlaces(t3.toNumber());
  }, Complex: function(e3) {
    return e3.round();
  }, "Complex, number": function(e3, t3) {
    if (t3 % 1) throw new TypeError(NO_INT$1);
    return e3.round(t3);
  }, "Complex, BigNumber": function(e3, t3) {
    if (!t3.isInteger()) throw new TypeError(NO_INT$1);
    var r2 = t3.toNumber();
    return e3.round(r2);
  }, BigNumber: function(e3) {
    var t3 = new o(e3).toDecimalPlaces(f2(r.relTol));
    return (nearlyEqual$2(e3, t3, r.relTol, r.absTol) ? t3 : e3).toDecimalPlaces(0);
  }, "BigNumber, BigNumber": function(e3, t3) {
    if (!t3.isInteger()) throw new TypeError(NO_INT$1);
    var n3 = f2(r.relTol);
    if (t3 >= n3) return e3.toDecimalPlaces(t3.toNumber());
    var i3 = e3.toDecimalPlaces(n3);
    return (nearlyEqual$2(e3, i3, r.relTol, r.absTol) ? i3 : e3).toDecimalPlaces(t3.toNumber());
  }, bigint: (e3) => e3, "bigint, number": (e3, t3) => e3, "bigint, BigNumber": (e3, t3) => e3, Fraction: function(e3) {
    return e3.round();
  }, "Fraction, number": function(e3, t3) {
    if (t3 % 1) throw new TypeError(NO_INT$1);
    return e3.round(t3);
  }, "Fraction, BigNumber": function(e3, t3) {
    if (!t3.isInteger()) throw new TypeError(NO_INT$1);
    return e3.round(t3.toNumber());
  }, "Unit, number, Unit": t2.referToSelf(((e3) => function(t3, r2, n3) {
    var i3 = t3.toNumeric(n3);
    return n3.multiply(e3(i3, r2));
  })), "Unit, BigNumber, Unit": t2.referToSelf(((e3) => (t3, r2, n3) => e3(t3, r2.toNumber(), n3))), "Array | Matrix, number | BigNumber, Unit": t2.referToSelf(((e3) => (t3, r2, n3) => deepMap$2(t3, ((t4) => e3(t4, r2, n3)), true))), "Array | Matrix | Unit, Unit": t2.referToSelf(((e3) => (t3, r2) => e3(t3, 0, r2))), "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3, true))), "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => u(t3, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => l(t3, r2, e3, false))), "Array, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => l(n(t3), r2, e3, false).valueOf())), "number | Complex | BigNumber | Fraction, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => i2(t3, 0) ? a(r2.size(), r2.storage()) : c2(r2, t3, e3, true))), "number | Complex | BigNumber | Fraction, DenseMatrix": t2.referToSelf(((e3) => (t3, r2) => i2(t3, 0) ? a(r2.size(), r2.storage()) : l(r2, t3, e3, true))), "number | Complex | BigNumber | Fraction, Array": t2.referToSelf(((e3) => (t3, r2) => l(n(r2), t3, e3, true).valueOf())) });
})), name$2Y$1 = "log", dependencies$2Y$1 = ["config", "typed", "typeOf", "divideScalar", "Complex"], nlg16$1 = Math.log(16), createLog$1 = factory$1(name$2Y$1, dependencies$2Y$1, ((e2) => {
  var { typed: t2, typeOf: r, config: n, divideScalar: i2, Complex: a } = e2;
  function o(e3) {
    return e3.log();
  }
  function s(e3) {
    return o(new a(e3, 0));
  }
  return t2(name$2Y$1, { number: function(e3) {
    return e3 >= 0 || n.predictable ? logNumber$1(e3) : s(e3);
  }, bigint: promoteLogarithm$1(nlg16$1, logNumber$1, n, s), Complex: o, BigNumber: function(e3) {
    return !e3.isNegative() || n.predictable ? e3.ln() : s(e3.toNumber());
  }, "any, any": t2.referToSelf(((e3) => (t3, n3) => {
    if ("Fraction" === r(t3) && "Fraction" === r(n3)) {
      var a2 = t3.log(n3);
      if (null !== a2) return a2;
    }
    return i2(e3(t3), e3(n3));
  })) });
})), name$2X$1 = "log1p", dependencies$2X$1 = ["typed", "config", "divideScalar", "log", "Complex"], createLog1p$1 = factory$1(name$2X$1, dependencies$2X$1, ((e2) => {
  var { typed: t2, config: r, divideScalar: n, log: i2, Complex: a } = e2;
  return t2(name$2X$1, { number: function(e3) {
    return e3 >= -1 || r.predictable ? log1p$1(e3) : o(new a(e3, 0));
  }, Complex: o, BigNumber: function(e3) {
    var t3 = e3.plus(1);
    return !t3.isNegative() || r.predictable ? t3.ln() : o(new a(e3.toNumber(), 0));
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))), "any, any": t2.referToSelf(((e3) => (t3, r2) => n(e3(t3), i2(r2)))) });
  function o(e3) {
    var t3 = e3.re + 1;
    return new a(Math.log(Math.sqrt(t3 * t3 + e3.im * e3.im)), Math.atan2(e3.im, t3));
  }
})), name$2W$1 = "nthRoots", dependencies$2W$1 = ["config", "typed", "divideScalar", "Complex"], createNthRoots$1 = factory$1(name$2W$1, dependencies$2W$1, ((e2) => {
  var { typed: t2, config: r, divideScalar: n, Complex: i2 } = e2, a = [function(e3) {
    return new i2(e3, 0);
  }, function(e3) {
    return new i2(0, e3);
  }, function(e3) {
    return new i2(-e3, 0);
  }, function(e3) {
    return new i2(0, -e3);
  }];
  function o(e3, t3) {
    if (t3 < 0) throw new Error("Root must be greater than zero");
    if (0 === t3) throw new Error("Root must be non-zero");
    if (t3 % 1 != 0) throw new Error("Root must be an integer");
    if (0 === e3 || 0 === e3.abs()) return [new i2(0, 0)];
    var r2, n3 = "number" == typeof e3;
    (n3 || 0 === e3.re || 0 === e3.im) && (r2 = n3 ? 2 * +(e3 < 0) : 0 === e3.im ? 2 * +(e3.re < 0) : 2 * +(e3.im < 0) + 1);
    for (var o2 = e3.arg(), s = e3.abs(), u = [], c2 = Math.pow(s, 1 / t3), l = 0; l < t3; l++) {
      var f2 = (r2 + 4 * l) / t3;
      f2 !== Math.round(f2) ? u.push(new i2({ r: c2, phi: (o2 + 2 * Math.PI * l) / t3 })) : u.push(a[f2 % 4](c2));
    }
    return u;
  }
  return t2(name$2W$1, { Complex: function(e3) {
    return o(e3, 2);
  }, "Complex, number": o });
})), name$2V$1 = "dotPow", dependencies$2V$1 = ["typed", "equalScalar", "matrix", "pow", "DenseMatrix", "concat", "SparseMatrix"], createDotPow$1 = factory$1(name$2V$1, dependencies$2V$1, ((e2) => {
  var { typed: t2, equalScalar: r, matrix: n, pow: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo03xDSf$1({ typed: t2 }), c2 = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: s }), l = createMatAlgo11xS0s$1({ typed: t2, equalScalar: r }), f2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: a }), p = createMatrixAlgorithmSuite$1({ typed: t2, matrix: n, concat: o }), m = {};
  for (var d in i2.signatures) Object.prototype.hasOwnProperty.call(i2.signatures, d) && (d.includes("Matrix") || d.includes("Array") || (m[d] = i2.signatures[d]));
  var h = t2(m);
  return t2(name$2V$1, p({ elop: h, SS: c2, DS: u, Ss: l, sS: f2 }));
})), name$2U$1 = "dotDivide", dependencies$2U$1 = ["typed", "matrix", "equalScalar", "divideScalar", "DenseMatrix", "concat", "SparseMatrix"], createDotDivide$1 = factory$1(name$2U$1, dependencies$2U$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, divideScalar: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), c2 = createMatAlgo03xDSf$1({ typed: t2 }), l = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: s }), f2 = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), p = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: a }), m = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: o });
  return t2(name$2U$1, m({ elop: i2, SS: l, DS: c2, SD: u, Ss: f2, sS: p }));
}));
function createSolveValidation$1(e2) {
  var { DenseMatrix: t2 } = e2;
  return function(e3, r, n) {
    var i2 = e3.size();
    if (2 !== i2.length) throw new RangeError("Matrix must be two dimensional (size: " + format$3(i2) + ")");
    var a = i2[0];
    if (a !== i2[1]) throw new RangeError("Matrix must be square (size: " + format$3(i2) + ")");
    var o = [];
    if (isMatrix$1(r)) {
      var s = r.size(), u = r._data;
      if (1 === s.length) {
        if (s[0] !== a) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var c2 = 0; c2 < a; c2++) o[c2] = [u[c2]];
        return new t2({ data: o, size: [a, 1], datatype: r._datatype });
      }
      if (2 === s.length) {
        if (s[0] !== a || 1 !== s[1]) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        if (isDenseMatrix$1(r)) {
          if (n) {
            o = [];
            for (var l = 0; l < a; l++) o[l] = [u[l][0]];
            return new t2({ data: o, size: [a, 1], datatype: r._datatype });
          }
          return r;
        }
        if (isSparseMatrix$1(r)) {
          for (var f2 = 0; f2 < a; f2++) o[f2] = [0];
          for (var p = r._values, m = r._index, d = r._ptr, h = d[1], g = d[0]; g < h; g++) {
            o[m[g]][0] = p[g];
          }
          return new t2({ data: o, size: [a, 1], datatype: r._datatype });
        }
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
    if (isArray$1$1(r)) {
      var y = arraySize$1(r);
      if (1 === y.length) {
        if (y[0] !== a) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var v2 = 0; v2 < a; v2++) o[v2] = [r[v2]];
        return new t2({ data: o, size: [a, 1] });
      }
      if (2 === y.length) {
        if (y[0] !== a || 1 !== y[1]) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var x2 = 0; x2 < a; x2++) o[x2] = [r[x2][0]];
        return new t2({ data: o, size: [a, 1] });
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
  };
}
var name$2T$1 = "lsolve", dependencies$2T$1 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createLsolve$1 = factory$1(name$2T$1, dependencies$2T$1, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, multiplyScalar: i2, subtractScalar: a, equalScalar: o, DenseMatrix: s } = e2, u = createSolveValidation$1({ DenseMatrix: s });
  return t2(name$2T$1, { "SparseMatrix, Array | Matrix": function(e3, t3) {
    return (function(e4, t4) {
      for (var r2 = (t4 = u(e4, t4, true))._data, c3 = e4._size[0], l = e4._size[1], f2 = e4._values, p = e4._index, m = e4._ptr, d = [], h = 0; h < l; h++) {
        var g = r2[h][0] || 0;
        if (o(g, 0)) d[h] = [0];
        else {
          for (var y = 0, v2 = [], x2 = [], b2 = m[h], _2 = m[h + 1], w2 = b2; w2 < _2; w2++) {
            var A2 = p[w2];
            A2 === h ? y = f2[w2] : A2 > h && (v2.push(f2[w2]), x2.push(A2));
          }
          if (o(y, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
          for (var N = n(g, y), D = 0, E = x2.length; D < E; D++) {
            var $2 = x2[D];
            r2[$2] = [a(r2[$2][0] || 0, i2(N, v2[D]))];
          }
          d[h] = [N];
        }
      }
      return new s({ data: d, size: [c3, 1] });
    })(e3, t3);
  }, "DenseMatrix, Array | Matrix": function(e3, t3) {
    return c2(e3, t3);
  }, "Array, Array | Matrix": function(e3, t3) {
    return c2(r(e3), t3).valueOf();
  } });
  function c2(e3, t3) {
    for (var r2 = (t3 = u(e3, t3, true))._data, c3 = e3._size[0], l = e3._size[1], f2 = [], p = e3._data, m = 0; m < l; m++) {
      var d = r2[m][0] || 0, h = void 0;
      if (o(d, 0)) h = 0;
      else {
        var g = p[m][m];
        if (o(g, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
        h = n(d, g);
        for (var y = m + 1; y < c3; y++) r2[y] = [a(r2[y][0] || 0, i2(h, p[y][m]))];
      }
      f2[m] = [h];
    }
    return new s({ data: f2, size: [c3, 1] });
  }
})), name$2S$1 = "usolve", dependencies$2S$1 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createUsolve$1 = factory$1(name$2S$1, dependencies$2S$1, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, multiplyScalar: i2, subtractScalar: a, equalScalar: o, DenseMatrix: s } = e2, u = createSolveValidation$1({ DenseMatrix: s });
  return t2(name$2S$1, { "SparseMatrix, Array | Matrix": function(e3, t3) {
    return (function(e4, t4) {
      for (var r2 = (t4 = u(e4, t4, true))._data, c3 = e4._size[0], l = e4._size[1], f2 = e4._values, p = e4._index, m = e4._ptr, d = [], h = l - 1; h >= 0; h--) {
        var g = r2[h][0] || 0;
        if (o(g, 0)) d[h] = [0];
        else {
          for (var y = 0, v2 = [], x2 = [], b2 = m[h], _2 = m[h + 1] - 1; _2 >= b2; _2--) {
            var w2 = p[_2];
            w2 === h ? y = f2[_2] : w2 < h && (v2.push(f2[_2]), x2.push(w2));
          }
          if (o(y, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
          for (var A2 = n(g, y), N = 0, D = x2.length; N < D; N++) {
            var E = x2[N];
            r2[E] = [a(r2[E][0], i2(A2, v2[N]))];
          }
          d[h] = [A2];
        }
      }
      return new s({ data: d, size: [c3, 1] });
    })(e3, t3);
  }, "DenseMatrix, Array | Matrix": function(e3, t3) {
    return c2(e3, t3);
  }, "Array, Array | Matrix": function(e3, t3) {
    return c2(r(e3), t3).valueOf();
  } });
  function c2(e3, t3) {
    for (var r2 = (t3 = u(e3, t3, true))._data, c3 = e3._size[0], l = e3._size[1], f2 = [], p = e3._data, m = l - 1; m >= 0; m--) {
      var d = r2[m][0] || 0, h = void 0;
      if (o(d, 0)) h = 0;
      else {
        var g = p[m][m];
        if (o(g, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
        h = n(d, g);
        for (var y = m - 1; y >= 0; y--) r2[y] = [a(r2[y][0] || 0, i2(h, p[y][m]))];
      }
      f2[m] = [h];
    }
    return new s({ data: f2, size: [c3, 1] });
  }
})), name$2R$1 = "lsolveAll", dependencies$2R$1 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createLsolveAll$1 = factory$1(name$2R$1, dependencies$2R$1, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, multiplyScalar: i2, subtractScalar: a, equalScalar: o, DenseMatrix: s } = e2, u = createSolveValidation$1({ DenseMatrix: s });
  return t2(name$2R$1, { "SparseMatrix, Array | Matrix": function(e3, t3) {
    return (function(e4, t4) {
      for (var r2 = [u(e4, t4, true)._data.map(((e5) => e5[0]))], c3 = e4._size[0], l = e4._size[1], f2 = e4._values, p = e4._index, m = e4._ptr, d = 0; d < l; d++) for (var h = r2.length, g = 0; g < h; g++) {
        for (var y = r2[g], v2 = [], x2 = [], b2 = m[d], _2 = m[d + 1], w2 = 0, A2 = b2; A2 < _2; A2++) {
          var N = p[A2];
          N === d ? w2 = f2[A2] : N > d && (v2.push(f2[A2]), x2.push(N));
        }
        if (o(w2, 0)) if (o(y[d], 0)) {
          if (0 === g) {
            var D = [...y];
            D[d] = 1;
            for (var E = 0, $2 = x2.length; E < $2; E++) {
              var S2 = x2[E];
              D[S2] = a(D[S2], v2[E]);
            }
            r2.push(D);
          }
        } else {
          if (0 === g) return [];
          r2.splice(g, 1), g -= 1, h -= 1;
        }
        else {
          y[d] = n(y[d], w2);
          for (var C2 = 0, M2 = x2.length; C2 < M2; C2++) {
            var T2 = x2[C2];
            y[T2] = a(y[T2], i2(y[d], v2[C2]));
          }
        }
      }
      return r2.map(((e5) => new s({ data: e5.map(((e6) => [e6])), size: [c3, 1] })));
    })(e3, t3);
  }, "DenseMatrix, Array | Matrix": function(e3, t3) {
    return c2(e3, t3);
  }, "Array, Array | Matrix": function(e3, t3) {
    return c2(r(e3), t3).map(((e4) => e4.valueOf()));
  } });
  function c2(e3, t3) {
    for (var r2 = [u(e3, t3, true)._data.map(((e4) => e4[0]))], c3 = e3._data, l = e3._size[0], f2 = e3._size[1], p = 0; p < f2; p++) for (var m = r2.length, d = 0; d < m; d++) {
      var h = r2[d];
      if (o(c3[p][p], 0)) if (o(h[p], 0)) {
        if (0 === d) {
          var g = [...h];
          g[p] = 1;
          for (var y = p + 1; y < f2; y++) g[y] = a(g[y], c3[y][p]);
          r2.push(g);
        }
      } else {
        if (0 === d) return [];
        r2.splice(d, 1), d -= 1, m -= 1;
      }
      else {
        h[p] = n(h[p], c3[p][p]);
        for (var v2 = p + 1; v2 < f2; v2++) h[v2] = a(h[v2], i2(h[p], c3[v2][p]));
      }
    }
    return r2.map(((e4) => new s({ data: e4.map(((e5) => [e5])), size: [l, 1] })));
  }
})), name$2Q$1 = "usolveAll", dependencies$2Q$1 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createUsolveAll$1 = factory$1(name$2Q$1, dependencies$2Q$1, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, multiplyScalar: i2, subtractScalar: a, equalScalar: o, DenseMatrix: s } = e2, u = createSolveValidation$1({ DenseMatrix: s });
  return t2(name$2Q$1, { "SparseMatrix, Array | Matrix": function(e3, t3) {
    return (function(e4, t4) {
      for (var r2 = [u(e4, t4, true)._data.map(((e5) => e5[0]))], c3 = e4._size[0], l = e4._size[1], f2 = e4._values, p = e4._index, m = e4._ptr, d = l - 1; d >= 0; d--) for (var h = r2.length, g = 0; g < h; g++) {
        for (var y = r2[g], v2 = [], x2 = [], b2 = m[d], _2 = 0, w2 = m[d + 1] - 1; w2 >= b2; w2--) {
          var A2 = p[w2];
          A2 === d ? _2 = f2[w2] : A2 < d && (v2.push(f2[w2]), x2.push(A2));
        }
        if (o(_2, 0)) if (o(y[d], 0)) {
          if (0 === g) {
            var N = [...y];
            N[d] = 1;
            for (var D = 0, E = x2.length; D < E; D++) {
              var $2 = x2[D];
              N[$2] = a(N[$2], v2[D]);
            }
            r2.push(N);
          }
        } else {
          if (0 === g) return [];
          r2.splice(g, 1), g -= 1, h -= 1;
        }
        else {
          y[d] = n(y[d], _2);
          for (var S2 = 0, C2 = x2.length; S2 < C2; S2++) {
            var M2 = x2[S2];
            y[M2] = a(y[M2], i2(y[d], v2[S2]));
          }
        }
      }
      return r2.map(((e5) => new s({ data: e5.map(((e6) => [e6])), size: [c3, 1] })));
    })(e3, t3);
  }, "DenseMatrix, Array | Matrix": function(e3, t3) {
    return c2(e3, t3);
  }, "Array, Array | Matrix": function(e3, t3) {
    return c2(r(e3), t3).map(((e4) => e4.valueOf()));
  } });
  function c2(e3, t3) {
    for (var r2 = [u(e3, t3, true)._data.map(((e4) => e4[0]))], c3 = e3._data, l = e3._size[0], f2 = e3._size[1] - 1; f2 >= 0; f2--) for (var p = r2.length, m = 0; m < p; m++) {
      var d = r2[m];
      if (o(c3[f2][f2], 0)) if (o(d[f2], 0)) {
        if (0 === m) {
          var h = [...d];
          h[f2] = 1;
          for (var g = f2 - 1; g >= 0; g--) h[g] = a(h[g], c3[g][f2]);
          r2.push(h);
        }
      } else {
        if (0 === m) return [];
        r2.splice(m, 1), m -= 1, p -= 1;
      }
      else {
        d[f2] = n(d[f2], c3[f2][f2]);
        for (var y = f2 - 1; y >= 0; y--) d[y] = a(d[y], i2(d[f2], c3[y][f2]));
      }
    }
    return r2.map(((e4) => new s({ data: e4.map(((e5) => [e5])), size: [l, 1] })));
  }
})), name$2P$1 = "matAlgo08xS0Sid", dependencies$2P$1 = ["typed", "equalScalar"], createMatAlgo08xS0Sid$1 = factory$1(name$2P$1, dependencies$2P$1, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._index, s = e3._ptr, u = e3._size, c2 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l = n._values, f2 = n._index, p = n._ptr, m = n._size, d = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (u.length !== m.length) throw new DimensionError$1(u.length, m.length);
    if (u[0] !== m[0] || u[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + m + ")");
    if (!a || !l) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
    var h, g = u[0], y = u[1], v2 = r, x2 = 0, b2 = i2;
    "string" == typeof c2 && c2 === d && "mixed" !== c2 && (h = c2, v2 = t2.find(r, [h, h]), x2 = t2.convert(0, h), b2 = t2.find(i2, [h, h]));
    for (var _2, w2, A2, N, D = [], E = [], $2 = [], S2 = [], C2 = [], M2 = 0; M2 < y; M2++) {
      $2[M2] = E.length;
      var T2 = M2 + 1;
      for (w2 = s[M2], A2 = s[M2 + 1], _2 = w2; _2 < A2; _2++) C2[N = o[_2]] = T2, S2[N] = a[_2], E.push(N);
      for (w2 = p[M2], A2 = p[M2 + 1], _2 = w2; _2 < A2; _2++) C2[N = f2[_2]] === T2 && (S2[N] = b2(S2[N], l[_2]));
      for (_2 = $2[M2]; _2 < E.length; ) {
        var F = S2[N = E[_2]];
        v2(F, x2) ? E.splice(_2, 1) : (D.push(F), _2++);
      }
    }
    return $2[y] = E.length, e3.createSparseMatrix({ values: D, index: E, ptr: $2, size: [g, y], datatype: c2 === e3._datatype && d === n._datatype ? h : void 0 });
  };
})), createUseMatrixForArrayScalar$1 = factory$1("useMatrixForArrayScalar", ["typed", "matrix"], ((e2) => {
  var { typed: t2, matrix: r } = e2;
  return { "Array, number": t2.referTo("DenseMatrix, number", ((e3) => (t3, n) => e3(r(t3), n).valueOf())), "Array, BigNumber": t2.referTo("DenseMatrix, BigNumber", ((e3) => (t3, n) => e3(r(t3), n).valueOf())), "number, Array": t2.referTo("number, DenseMatrix", ((e3) => (t3, n) => e3(t3, r(n)).valueOf())), "BigNumber, Array": t2.referTo("BigNumber, DenseMatrix", ((e3) => (t3, n) => e3(t3, r(n)).valueOf())) };
})), name$2O$1 = "leftShift", dependencies$2O$1 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createLeftShift$1 = factory$1(name$2O$1, dependencies$2O$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, DenseMatrix: a, concat: o } = e2, s = createMatAlgo01xDSid$1({ typed: t2 }), u = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), c2 = createMatAlgo08xS0Sid$1({ typed: t2, equalScalar: n }), l = createMatAlgo10xSids$1({ typed: t2, DenseMatrix: a }), f2 = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), p = createMatAlgo14xDs$1({ typed: t2 }), m = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: o }), d = createUseMatrixForArrayScalar$1({ typed: t2, matrix: r });
  return t2(name$2O$1, { "number, number": leftShiftNumber$1, "BigNumber, BigNumber": leftShiftBigNumber$1, "bigint, bigint": (e3, t3) => e3 << t3, "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => n(r2, 0) ? t3.clone() : f2(t3, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => n(r2, 0) ? t3.clone() : p(t3, r2, e3, false))), "number | BigNumber, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => n(t3, 0) ? i2(r2.size(), r2.storage()) : l(r2, t3, e3, true))), "number | BigNumber, DenseMatrix": t2.referToSelf(((e3) => (t3, r2) => n(t3, 0) ? i2(r2.size(), r2.storage()) : p(r2, t3, e3, true))) }, d, m({ SS: c2, DS: s, SD: u }));
})), name$2N$1 = "rightArithShift", dependencies$2N$1 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createRightArithShift$1 = factory$1(name$2N$1, dependencies$2N$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, DenseMatrix: a, concat: o } = e2, s = createMatAlgo01xDSid$1({ typed: t2 }), u = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), c2 = createMatAlgo08xS0Sid$1({ typed: t2, equalScalar: n }), l = createMatAlgo10xSids$1({ typed: t2, DenseMatrix: a }), f2 = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), p = createMatAlgo14xDs$1({ typed: t2 }), m = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: o }), d = createUseMatrixForArrayScalar$1({ typed: t2, matrix: r });
  return t2(name$2N$1, { "number, number": rightArithShiftNumber$1, "BigNumber, BigNumber": rightArithShiftBigNumber$1, "bigint, bigint": (e3, t3) => e3 >> t3, "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => n(r2, 0) ? t3.clone() : f2(t3, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => n(r2, 0) ? t3.clone() : p(t3, r2, e3, false))), "number | BigNumber, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => n(t3, 0) ? i2(r2.size(), r2.storage()) : l(r2, t3, e3, true))), "number | BigNumber, DenseMatrix": t2.referToSelf(((e3) => (t3, r2) => n(t3, 0) ? i2(r2.size(), r2.storage()) : p(r2, t3, e3, true))) }, d, m({ SS: c2, DS: s, SD: u }));
})), name$2M$1 = "rightLogShift", dependencies$2M$1 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createRightLogShift$1 = factory$1(name$2M$1, dependencies$2M$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, DenseMatrix: a, concat: o } = e2, s = createMatAlgo01xDSid$1({ typed: t2 }), u = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), c2 = createMatAlgo08xS0Sid$1({ typed: t2, equalScalar: n }), l = createMatAlgo10xSids$1({ typed: t2, DenseMatrix: a }), f2 = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), p = createMatAlgo14xDs$1({ typed: t2 }), m = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: o }), d = createUseMatrixForArrayScalar$1({ typed: t2, matrix: r });
  return t2(name$2M$1, { "number, number": rightLogShiftNumber$1, "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => n(r2, 0) ? t3.clone() : f2(t3, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t3, r2) => n(r2, 0) ? t3.clone() : p(t3, r2, e3, false))), "number | BigNumber, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => n(t3, 0) ? i2(r2.size(), r2.storage()) : l(r2, t3, e3, true))), "number | BigNumber, DenseMatrix": t2.referToSelf(((e3) => (t3, r2) => n(t3, 0) ? i2(r2.size(), r2.storage()) : p(r2, t3, e3, true))) }, d, m({ SS: c2, DS: s, SD: u }));
})), name$2L$1 = "and", dependencies$2L$1 = ["typed", "matrix", "equalScalar", "zeros", "not", "concat"], createAnd$1 = factory$1(name$2L$1, dependencies$2L$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o } = e2, s = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), u = createMatAlgo06xS0S0$1({ typed: t2, equalScalar: n }), c2 = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), l = createMatAlgo14xDs$1({ typed: t2 }), f2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: o });
  return t2(name$2L$1, { "number, number": andNumber$1, "Complex, Complex": function(e3, t3) {
    return !(0 === e3.re && 0 === e3.im || 0 === t3.re && 0 === t3.im);
  }, "BigNumber, BigNumber": function(e3, t3) {
    return !(e3.isZero() || t3.isZero() || e3.isNaN() || t3.isNaN());
  }, "bigint, bigint": andNumber$1, "Unit, Unit": t2.referToSelf(((e3) => (t3, r2) => e3(t3.value || 0, r2.value || 0))), "SparseMatrix, any": t2.referToSelf(((e3) => (t3, r2) => a(r2) ? i2(t3.size(), t3.storage()) : c2(t3, r2, e3, false))), "DenseMatrix, any": t2.referToSelf(((e3) => (t3, r2) => a(r2) ? i2(t3.size(), t3.storage()) : l(t3, r2, e3, false))), "any, SparseMatrix": t2.referToSelf(((e3) => (t3, r2) => a(t3) ? i2(t3.size(), t3.storage()) : c2(r2, t3, e3, true))), "any, DenseMatrix": t2.referToSelf(((e3) => (t3, r2) => a(t3) ? i2(t3.size(), t3.storage()) : l(r2, t3, e3, true))), "Array, any": t2.referToSelf(((e3) => (t3, n3) => e3(r(t3), n3).valueOf())), "any, Array": t2.referToSelf(((e3) => (t3, n3) => e3(t3, r(n3)).valueOf())) }, f2({ SS: u, DS: s }));
})), name$2K$1 = "compare", dependencies$2K$1 = ["typed", "config", "matrix", "equalScalar", "BigNumber", "Fraction", "DenseMatrix", "concat"], createCompare$1 = factory$1(name$2K$1, dependencies$2K$1, ((e2) => {
  var { typed: t2, config: r, equalScalar: n, matrix: i2, BigNumber: a, Fraction: o, DenseMatrix: s, concat: u } = e2, c2 = createMatAlgo03xDSf$1({ typed: t2 }), l = createMatAlgo05xSfSf$1({ typed: t2, equalScalar: n }), f2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: s }), p = createMatrixAlgorithmSuite$1({ typed: t2, matrix: i2, concat: u }), m = createCompareUnits$1({ typed: t2 });
  return t2(name$2K$1, createCompareNumber$1({ typed: t2, config: r }), { "boolean, boolean": function(e3, t3) {
    return e3 === t3 ? 0 : e3 > t3 ? 1 : -1;
  }, "BigNumber, BigNumber": function(e3, t3) {
    return nearlyEqual$2(e3, t3, r.relTol, r.absTol) ? new a(0) : new a(e3.cmp(t3));
  }, "bigint, bigint": function(e3, t3) {
    return e3 === t3 ? 0n : e3 > t3 ? 1n : -1n;
  }, "Fraction, Fraction": function(e3, t3) {
    return new o(e3.compare(t3));
  }, "Complex, Complex": function() {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, m, p({ SS: l, DS: c2, Ss: f2 }));
})), createCompareNumber$1 = factory$1(name$2K$1, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2K$1, { "number, number": function(e3, t3) {
    return nearlyEqual$1$1(e3, t3, r.relTol, r.absTol) ? 0 : e3 > t3 ? 1 : -1;
  } });
})), naturalSort$1$1, hasRequiredNaturalSort$1;
function requireNaturalSort$1() {
  return hasRequiredNaturalSort$1 || (hasRequiredNaturalSort$1 = 1, naturalSort$1$1 = function e2(t2, r) {
    var n, i2, a = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, o = /(^[ ]*|[ ]*$)/g, s = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, u = /^0x[0-9a-f]+$/i, c2 = /^0/, l = function(t3) {
      return e2.insensitive && ("" + t3).toLowerCase() || "" + t3;
    }, f2 = l(t2).replace(o, "") || "", p = l(r).replace(o, "") || "", m = f2.replace(a, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), d = p.replace(a, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), h = parseInt(f2.match(u), 16) || 1 !== m.length && f2.match(s) && Date.parse(f2), g = parseInt(p.match(u), 16) || h && p.match(s) && Date.parse(p) || null;
    if (g) {
      if (h < g) return -1;
      if (h > g) return 1;
    }
    for (var y = 0, v2 = Math.max(m.length, d.length); y < v2; y++) {
      if (n = !(m[y] || "").match(c2) && parseFloat(m[y]) || m[y] || 0, i2 = !(d[y] || "").match(c2) && parseFloat(d[y]) || d[y] || 0, isNaN(n) !== isNaN(i2)) return isNaN(n) ? 1 : -1;
      if (typeof n != typeof i2 && (n += "", i2 += ""), n < i2) return -1;
      if (n > i2) return 1;
    }
    return 0;
  }), naturalSort$1$1;
}
var naturalSortExports$1 = requireNaturalSort$1(), naturalSort$2 = getDefaultExportFromCjs$5(naturalSortExports$1), name$2J$1 = "compareNatural", dependencies$2J$1 = ["typed", "compare"], createCompareNatural$1 = factory$1(name$2J$1, dependencies$2J$1, ((e2) => {
  var { typed: t2, compare: r } = e2, n = r.signatures["boolean,boolean"];
  return t2(name$2J$1, { "any, any": function e3(t3, o) {
    var s, u = typeOf$1(t3), c2 = typeOf$1(o);
    if (!("number" !== u && "BigNumber" !== u && "Fraction" !== u || "number" !== c2 && "BigNumber" !== c2 && "Fraction" !== c2)) return "0" !== (s = r(t3, o)).toString() ? s > 0 ? 1 : -1 : naturalSort$2(u, c2);
    var l = ["Array", "DenseMatrix", "SparseMatrix"];
    if (l.includes(u) || l.includes(c2)) return 0 !== (s = i2(e3, t3, o)) ? s : naturalSort$2(u, c2);
    if (u !== c2) return naturalSort$2(u, c2);
    if ("Complex" === u) return compareComplexNumbers$1(t3, o);
    if ("Unit" === u) return t3.equalBase(o) ? e3(t3.value, o.value) : a(e3, t3.formatUnits(), o.formatUnits());
    if ("boolean" === u) return n(t3, o);
    if ("string" === u) return naturalSort$2(t3, o);
    if ("Object" === u) return (function(e4, t4, r2) {
      var n3 = Object.keys(t4), i3 = Object.keys(r2);
      n3.sort(naturalSort$2), i3.sort(naturalSort$2);
      var o2 = a(e4, n3, i3);
      if (0 !== o2) return o2;
      for (var s2 = 0; s2 < n3.length; s2++) {
        var u2 = e4(t4[n3[s2]], r2[i3[s2]]);
        if (0 !== u2) return u2;
      }
      return 0;
    })(e3, t3, o);
    if ("null" === u) return 0;
    if ("undefined" === u) return 0;
    throw new TypeError('Unsupported type of value "' + u + '"');
  } });
  function i2(e3, t3, r2) {
    return isSparseMatrix$1(t3) && isSparseMatrix$1(r2) ? a(e3, t3.toJSON().values, r2.toJSON().values) : isSparseMatrix$1(t3) ? i2(e3, t3.toArray(), r2) : isSparseMatrix$1(r2) ? i2(e3, t3, r2.toArray()) : isDenseMatrix$1(t3) ? i2(e3, t3.toJSON().data, r2) : isDenseMatrix$1(r2) ? i2(e3, t3, r2.toJSON().data) : Array.isArray(t3) ? Array.isArray(r2) ? a(e3, t3, r2) : i2(e3, t3, [r2]) : i2(e3, [t3], r2);
  }
  function a(e3, t3, r2) {
    for (var n3 = 0, i3 = Math.min(t3.length, r2.length); n3 < i3; n3++) {
      var a2 = e3(t3[n3], r2[n3]);
      if (0 !== a2) return a2;
    }
    return t3.length > r2.length ? 1 : t3.length < r2.length ? -1 : 0;
  }
}));
function compareComplexNumbers$1(e2, t2) {
  return e2.re > t2.re ? 1 : e2.re < t2.re ? -1 : e2.im > t2.im ? 1 : e2.im < t2.im ? -1 : 0;
}
var name$2I$1 = "compareText", dependencies$2I$1 = ["typed", "matrix", "concat"];
compareText$1.signature = "any, any";
var createCompareText$1 = factory$1(name$2I$1, dependencies$2I$1, ((e2) => {
  var { typed: t2, matrix: r, concat: n } = e2, i2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: n });
  return t2(name$2I$1, compareText$1, i2({ elop: compareText$1, Ds: true }));
})), name$2H$1 = "equal", dependencies$2H$1 = ["typed", "matrix", "equalScalar", "DenseMatrix", "SparseMatrix"], createEqual$1 = factory$1(name$2H$1, dependencies$2H$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a, SparseMatrix: o } = e2, s = createMatAlgo03xDSf$1({ typed: t2 }), u = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: o }), c2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: i2 }), l = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r });
  return t2(name$2H$1, createEqualNumber$1({ typed: t2, equalScalar: n }), l({ elop: n, SS: u, DS: s, Ss: c2 }));
})), createEqualNumber$1 = factory$1(name$2H$1, ["typed", "equalScalar"], ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return t2(name$2H$1, { "any, any": function(e3, t3) {
    return null === e3 ? null === t3 : null === t3 ? null === e3 : void 0 === e3 ? void 0 === t3 : void 0 === t3 ? void 0 === e3 : r(e3, t3);
  } });
})), name$2G$1 = "equalText", dependencies$2G$1 = ["typed", "compareText", "isZero"], createEqualText$1 = factory$1(name$2G$1, dependencies$2G$1, ((e2) => {
  var { typed: t2, compareText: r, isZero: n } = e2;
  return t2(name$2G$1, { "any, any": function(e3, t3) {
    return n(r(e3, t3));
  } });
})), name$2F$1 = "smaller", dependencies$2F$1 = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createSmaller$1 = factory$1(name$2F$1, dependencies$2F$1, ((e2) => {
  var { typed: t2, config: r, bignumber: n, matrix: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo03xDSf$1({ typed: t2 }), c2 = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: s }), l = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: a }), f2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: i2, concat: o }), p = createCompareUnits$1({ typed: t2 });
  function m(e3, t3) {
    return e3.lt(t3) && !nearlyEqual$2(e3, t3, r.relTol, r.absTol);
  }
  return t2(name$2F$1, createSmallerNumber$1({ typed: t2, config: r }), { "boolean, boolean": (e3, t3) => e3 < t3, "BigNumber, BigNumber": m, "bigint, bigint": (e3, t3) => e3 < t3, "Fraction, Fraction": (e3, t3) => -1 === e3.compare(t3), "Fraction, BigNumber": function(e3, t3) {
    return m(n(e3), t3);
  }, "BigNumber, Fraction": function(e3, t3) {
    return m(e3, n(t3));
  }, "Complex, Complex": function(e3, t3) {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, p, f2({ SS: c2, DS: u, Ss: l }));
})), createSmallerNumber$1 = factory$1(name$2F$1, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2F$1, { "number, number": function(e3, t3) {
    return e3 < t3 && !nearlyEqual$1$1(e3, t3, r.relTol, r.absTol);
  } });
})), name$2E$1 = "smallerEq", dependencies$2E$1 = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createSmallerEq$1 = factory$1(name$2E$1, dependencies$2E$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, DenseMatrix: i2, concat: a, SparseMatrix: o } = e2, s = createMatAlgo03xDSf$1({ typed: t2 }), u = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: o }), c2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: i2 }), l = createMatrixAlgorithmSuite$1({ typed: t2, matrix: n, concat: a }), f2 = createCompareUnits$1({ typed: t2 });
  return t2(name$2E$1, createSmallerEqNumber$1({ typed: t2, config: r }), { "boolean, boolean": (e3, t3) => e3 <= t3, "BigNumber, BigNumber": function(e3, t3) {
    return e3.lte(t3) || nearlyEqual$2(e3, t3, r.relTol, r.absTol);
  }, "bigint, bigint": (e3, t3) => e3 <= t3, "Fraction, Fraction": (e3, t3) => 1 !== e3.compare(t3), "Complex, Complex": function() {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, f2, l({ SS: u, DS: s, Ss: c2 }));
})), createSmallerEqNumber$1 = factory$1(name$2E$1, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2E$1, { "number, number": function(e3, t3) {
    return e3 <= t3 || nearlyEqual$1$1(e3, t3, r.relTol, r.absTol);
  } });
})), name$2D$1 = "larger", dependencies$2D$1 = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createLarger$1 = factory$1(name$2D$1, dependencies$2D$1, ((e2) => {
  var { typed: t2, config: r, bignumber: n, matrix: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo03xDSf$1({ typed: t2 }), c2 = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: s }), l = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: a }), f2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: i2, concat: o }), p = createCompareUnits$1({ typed: t2 });
  function m(e3, t3) {
    return e3.gt(t3) && !nearlyEqual$2(e3, t3, r.relTol, r.absTol);
  }
  return t2(name$2D$1, createLargerNumber$1({ typed: t2, config: r }), { "boolean, boolean": (e3, t3) => e3 > t3, "BigNumber, BigNumber": m, "bigint, bigint": (e3, t3) => e3 > t3, "Fraction, Fraction": (e3, t3) => 1 === e3.compare(t3), "Fraction, BigNumber": function(e3, t3) {
    return m(n(e3), t3);
  }, "BigNumber, Fraction": function(e3, t3) {
    return m(e3, n(t3));
  }, "Complex, Complex": function() {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, p, f2({ SS: c2, DS: u, Ss: l }));
})), createLargerNumber$1 = factory$1(name$2D$1, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2D$1, { "number, number": function(e3, t3) {
    return e3 > t3 && !nearlyEqual$1$1(e3, t3, r.relTol, r.absTol);
  } });
})), name$2C$1 = "largerEq", dependencies$2C$1 = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createLargerEq$1 = factory$1(name$2C$1, dependencies$2C$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, DenseMatrix: i2, concat: a, SparseMatrix: o } = e2, s = createMatAlgo03xDSf$1({ typed: t2 }), u = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: o }), c2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: i2 }), l = createMatrixAlgorithmSuite$1({ typed: t2, matrix: n, concat: a }), f2 = createCompareUnits$1({ typed: t2 });
  return t2(name$2C$1, createLargerEqNumber$1({ typed: t2, config: r }), { "boolean, boolean": (e3, t3) => e3 >= t3, "BigNumber, BigNumber": function(e3, t3) {
    return e3.gte(t3) || nearlyEqual$2(e3, t3, r.relTol, r.absTol);
  }, "bigint, bigint": function(e3, t3) {
    return e3 >= t3;
  }, "Fraction, Fraction": (e3, t3) => -1 !== e3.compare(t3), "Complex, Complex": function() {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, f2, l({ SS: u, DS: s, Ss: c2 }));
})), createLargerEqNumber$1 = factory$1(name$2C$1, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2C$1, { "number, number": function(e3, t3) {
    return e3 >= t3 || nearlyEqual$1$1(e3, t3, r.relTol, r.absTol);
  } });
})), name$2B$1 = "deepEqual", dependencies$2B$1 = ["typed", "equal"], createDeepEqual$1 = factory$1(name$2B$1, dependencies$2B$1, ((e2) => {
  var { typed: t2, equal: r } = e2;
  return t2(name$2B$1, { "any, any": function(e3, t3) {
    return n(e3.valueOf(), t3.valueOf());
  } });
  function n(e3, t3) {
    if (Array.isArray(e3)) {
      if (Array.isArray(t3)) {
        var i2 = e3.length;
        if (i2 !== t3.length) return false;
        for (var a = 0; a < i2; a++) if (!n(e3[a], t3[a])) return false;
        return true;
      }
      return false;
    }
    return !Array.isArray(t3) && r(e3, t3);
  }
})), name$2A$1 = "unequal", dependencies$2A$1 = ["typed", "config", "equalScalar", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createUnequal$1 = factory$1(name$2A$1, dependencies$2A$1, ((e2) => {
  var { typed: t2, config: r, equalScalar: n, matrix: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo03xDSf$1({ typed: t2 }), c2 = createMatAlgo07xSSf$1({ typed: t2, SparseMatrix: s }), l = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: a }), f2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: i2, concat: o });
  return t2(name$2A$1, createUnequalNumber$1({ typed: t2, equalScalar: n }), f2({ elop: function(e3, t3) {
    return !n(e3, t3);
  }, SS: c2, DS: u, Ss: l }));
})), createUnequalNumber$1 = factory$1(name$2A$1, ["typed", "equalScalar"], ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return t2(name$2A$1, { "any, any": function(e3, t3) {
    return null === e3 ? null !== t3 : null === t3 ? null !== e3 : void 0 === e3 ? void 0 !== t3 : void 0 === t3 ? void 0 !== e3 : !r(e3, t3);
  } });
})), name$2z$1 = "partitionSelect", dependencies$2z$1 = ["typed", "isNumeric", "isNaN", "compare"], createPartitionSelect$1 = factory$1(name$2z$1, dependencies$2z$1, ((e2) => {
  var { typed: t2, isNumeric: r, isNaN: n, compare: i2 } = e2, a = i2, o = (e3, t3) => -i2(e3, t3);
  return t2(name$2z$1, { "Array | Matrix, number": function(e3, t3) {
    return s(e3, t3, a);
  }, "Array | Matrix, number, string": function(e3, t3, r2) {
    if ("asc" === r2) return s(e3, t3, a);
    if ("desc" === r2) return s(e3, t3, o);
    throw new Error('Compare string must be "asc" or "desc"');
  }, "Array | Matrix, number, function": s });
  function s(e3, t3, r2) {
    if (!isInteger$1(t3) || t3 < 0) throw new Error("k must be a non-negative integer");
    if (isMatrix$1(e3)) {
      if (e3.size().length > 1) throw new Error("Only one dimensional matrices supported");
      return u(e3.valueOf(), t3, r2);
    }
    if (Array.isArray(e3)) return u(e3, t3, r2);
  }
  function u(e3, t3, i3) {
    if (t3 >= e3.length) throw new Error("k out of bounds");
    for (var a2 = 0; a2 < e3.length; a2++) if (r(e3[a2]) && n(e3[a2])) return e3[a2];
    for (var o2 = 0, s2 = e3.length - 1; o2 < s2; ) {
      for (var u2 = o2, c2 = s2, l = e3[Math.floor(Math.random() * (s2 - o2 + 1)) + o2]; u2 < c2; ) if (i3(e3[u2], l) >= 0) {
        var f2 = e3[c2];
        e3[c2] = e3[u2], e3[u2] = f2, --c2;
      } else ++u2;
      i3(e3[u2], l) > 0 && --u2, t3 <= u2 ? s2 = u2 : o2 = u2 + 1;
    }
    return e3[t3];
  }
})), name$2y$1 = "sort", dependencies$2y$1 = ["typed", "matrix", "compare", "compareNatural"], createSort$1 = factory$1(name$2y$1, dependencies$2y$1, ((e2) => {
  var { typed: t2, matrix: r, compare: n, compareNatural: i2 } = e2, a = n, o = (e3, t3) => -n(e3, t3);
  return t2(name$2y$1, { Array: function(e3) {
    return u(e3), e3.sort(a);
  }, Matrix: function(e3) {
    return c2(e3), r(e3.toArray().sort(a), e3.storage());
  }, "Array, function": function(e3, t3) {
    return u(e3), e3.sort(t3);
  }, "Matrix, function": function(e3, t3) {
    return c2(e3), r(e3.toArray().sort(t3), e3.storage());
  }, "Array, string": function(e3, t3) {
    return u(e3), e3.sort(s(t3));
  }, "Matrix, string": function(e3, t3) {
    return c2(e3), r(e3.toArray().sort(s(t3)), e3.storage());
  } });
  function s(e3) {
    if ("asc" === e3) return a;
    if ("desc" === e3) return o;
    if ("natural" === e3) return i2;
    throw new Error('String "asc", "desc", or "natural" expected');
  }
  function u(e3) {
    if (1 !== arraySize$1(e3).length) throw new Error("One dimensional array expected");
  }
  function c2(e3) {
    if (1 !== e3.size().length) throw new Error("One dimensional matrix expected");
  }
})), name$2x$1 = "max", dependencies$2x$1 = ["typed", "config", "numeric", "larger", "isNaN"], createMax$1 = factory$1(name$2x$1, dependencies$2x$1, ((e2) => {
  var { typed: t2, config: r, numeric: n, larger: i2, isNaN: a } = e2;
  return t2(name$2x$1, { "Array | Matrix": s, "Array | Matrix, number | BigNumber": function(e3, t3) {
    return reduce$2$1(e3, t3.valueOf(), o);
  }, "...": function(e3) {
    if (containsCollections$1(e3)) throw new TypeError("Scalar values expected in function max");
    return s(e3);
  } });
  function o(e3, t3) {
    try {
      return i2(e3, t3) ? e3 : t3;
    } catch (e4) {
      throw improveErrorMessage$1(e4, "max", t3);
    }
  }
  function s(e3) {
    var t3;
    if (deepForEach$2(e3, (function(e4) {
      try {
        (a(e4) || void 0 === t3 || i2(e4, t3)) && (t3 = e4);
      } catch (t4) {
        throw improveErrorMessage$1(t4, "max", e4);
      }
    })), void 0 === t3) throw new Error("Cannot calculate max of an empty array");
    return "string" == typeof t3 && (t3 = n(t3, safeNumberType$1(t3, r))), t3;
  }
})), name$2w$1 = "min", dependencies$2w$1 = ["typed", "config", "numeric", "smaller", "isNaN"], createMin$1 = factory$1(name$2w$1, dependencies$2w$1, ((e2) => {
  var { typed: t2, config: r, numeric: n, smaller: i2, isNaN: a } = e2;
  return t2(name$2w$1, { "Array | Matrix": s, "Array | Matrix, number | BigNumber": function(e3, t3) {
    return reduce$2$1(e3, t3.valueOf(), o);
  }, "...": function(e3) {
    if (containsCollections$1(e3)) throw new TypeError("Scalar values expected in function min");
    return s(e3);
  } });
  function o(e3, t3) {
    try {
      return i2(e3, t3) ? e3 : t3;
    } catch (e4) {
      throw improveErrorMessage$1(e4, "min", t3);
    }
  }
  function s(e3) {
    var t3;
    if (deepForEach$2(e3, (function(e4) {
      try {
        (a(e4) || void 0 === t3 || i2(e4, t3)) && (t3 = e4);
      } catch (t4) {
        throw improveErrorMessage$1(t4, "min", e4);
      }
    })), void 0 === t3) throw new Error("Cannot calculate min of an empty array");
    return "string" == typeof t3 && (t3 = n(t3, safeNumberType$1(t3, r))), t3;
  }
})), name$2v$1 = "ImmutableDenseMatrix", dependencies$2v$1 = ["smaller", "DenseMatrix"], createImmutableDenseMatrixClass$1 = factory$1(name$2v$1, dependencies$2v$1, ((e2) => {
  var { smaller: t2, DenseMatrix: r } = e2;
  function n(e3, t3) {
    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
    if (t3 && !isString$1$1(t3)) throw new Error("Invalid datatype: " + t3);
    if (isMatrix$1(e3) || isArray$1$1(e3)) {
      var i2 = new r(e3, t3);
      this._data = i2._data, this._size = i2._size, this._datatype = i2._datatype, this._min = null, this._max = null;
    } else if (e3 && isArray$1$1(e3.data) && isArray$1$1(e3.size)) this._data = e3.data, this._size = e3.size, this._datatype = e3.datatype, this._min = void 0 !== e3.min ? e3.min : null, this._max = void 0 !== e3.max ? e3.max : null;
    else {
      if (e3) throw new TypeError("Unsupported type of data (" + typeOf$1(e3) + ")");
      this._data = [], this._size = [0], this._datatype = t3, this._min = null, this._max = null;
    }
  }
  return n.prototype = new r(), n.prototype.type = "ImmutableDenseMatrix", n.prototype.isImmutableDenseMatrix = true, n.prototype.subset = function(e3) {
    switch (arguments.length) {
      case 1:
        var t3 = r.prototype.subset.call(this, e3);
        return isMatrix$1(t3) ? new n({ data: t3._data, size: t3._size, datatype: t3._datatype }) : t3;
      case 2:
      case 3:
        throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.set = function() {
    throw new Error("Cannot invoke set on an Immutable Matrix instance");
  }, n.prototype.resize = function() {
    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
  }, n.prototype.reshape = function() {
    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, n.prototype.clone = function() {
    return new n({ data: clone$3$1(this._data), size: clone$3$1(this._size), datatype: this._datatype });
  }, n.prototype.toJSON = function() {
    return { mathjs: "ImmutableDenseMatrix", data: this._data, size: this._size, datatype: this._datatype };
  }, n.fromJSON = function(e3) {
    return new n(e3);
  }, n.prototype.swapRows = function() {
    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, n.prototype.min = function() {
    if (null === this._min) {
      var e3 = null;
      this.forEach((function(r2) {
        (null === e3 || t2(r2, e3)) && (e3 = r2);
      })), this._min = null !== e3 ? e3 : void 0;
    }
    return this._min;
  }, n.prototype.max = function() {
    if (null === this._max) {
      var e3 = null;
      this.forEach((function(r2) {
        (null === e3 || t2(e3, r2)) && (e3 = r2);
      })), this._max = null !== e3 ? e3 : void 0;
    }
    return this._max;
  }, n;
}), { isClass: true }), name$2u$1 = "Index", dependencies$2u$1 = ["ImmutableDenseMatrix", "getMatrixDataType"], createIndexClass$1 = factory$1(name$2u$1, dependencies$2u$1, ((e2) => {
  var { ImmutableDenseMatrix: t2, getMatrixDataType: r } = e2;
  function n() {
    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._sourceSize = [], this._isScalar = true;
    for (var e3 = 0, t3 = arguments.length; e3 < t3; e3++) {
      var a = e3 < 0 || arguments.length <= e3 ? void 0 : arguments[e3], o = isArray$1$1(a), s = isMatrix$1(a), u = typeof a, c2 = null;
      if (isRange$1(a)) this._dimensions.push(a), this._isScalar = false;
      else if (o || s) {
        var l = void 0;
        this._isScalar = false, "boolean" === r(a) ? (o && (l = i2(_booleansArrayToNumbersForIndex$1(a).valueOf())), s && (l = i2(_booleansArrayToNumbersForIndex$1(a._data).valueOf())), c2 = a.valueOf().length) : l = i2(a.valueOf()), this._dimensions.push(l);
      } else if ("number" === u) this._dimensions.push(a);
      else if ("bigint" === u) this._dimensions.push(Number(a));
      else {
        if ("string" !== u) throw new TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
        this._dimensions.push(a);
      }
      this._sourceSize.push(c2);
    }
  }
  function i2(e3) {
    for (var r2 = 0, n3 = e3.length; r2 < n3; r2++) if (!isNumber$1$1(e3[r2]) || !isInteger$1(e3[r2])) throw new TypeError("Index parameters must be positive integer numbers");
    var i3 = new t2();
    return i3._data = e3, i3._size = [e3.length], i3;
  }
  return n.prototype.type = "Index", n.prototype.isIndex = true, n.prototype.clone = function() {
    var e3 = new n();
    return e3._dimensions = clone$3$1(this._dimensions), e3._isScalar = this._isScalar, e3._sourceSize = this._sourceSize, e3;
  }, n.create = function(e3) {
    var t3 = new n();
    return n.apply(t3, e3), t3;
  }, n.prototype.size = function() {
    for (var e3 = [], t3 = 0, r2 = this._dimensions.length; t3 < r2; t3++) {
      var n3 = this._dimensions[t3];
      e3[t3] = isString$1$1(n3) || isNumber$1$1(n3) ? 1 : n3.size()[0];
    }
    return e3;
  }, n.prototype.max = function() {
    for (var e3 = [], t3 = 0, r2 = this._dimensions.length; t3 < r2; t3++) {
      var n3 = this._dimensions[t3];
      e3[t3] = isString$1$1(n3) || isNumber$1$1(n3) ? n3 : n3.max();
    }
    return e3;
  }, n.prototype.min = function() {
    for (var e3 = [], t3 = 0, r2 = this._dimensions.length; t3 < r2; t3++) {
      var n3 = this._dimensions[t3];
      e3[t3] = isString$1$1(n3) || isNumber$1$1(n3) ? n3 : n3.min();
    }
    return e3;
  }, n.prototype.forEach = function(e3) {
    for (var t3 = 0, r2 = this._dimensions.length; t3 < r2; t3++) e3(this._dimensions[t3], t3, this);
  }, n.prototype.dimension = function(e3) {
    var t3;
    return isNumber$1$1(e3) && null !== (t3 = this._dimensions[e3]) && void 0 !== t3 ? t3 : null;
  }, n.prototype.isObjectProperty = function() {
    return 1 === this._dimensions.length && isString$1$1(this._dimensions[0]);
  }, n.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, n.prototype.isScalar = function() {
    return this._isScalar;
  }, n.prototype.toArray = function() {
    for (var e3 = [], t3 = 0, r2 = this._dimensions.length; t3 < r2; t3++) {
      var n3 = this._dimensions[t3];
      e3.push(isString$1$1(n3) || isNumber$1$1(n3) ? n3 : n3.toArray());
    }
    return e3;
  }, n.prototype.valueOf = n.prototype.toArray, n.prototype.toString = function() {
    for (var e3 = [], t3 = 0, r2 = this._dimensions.length; t3 < r2; t3++) {
      var n3 = this._dimensions[t3];
      isString$1$1(n3) ? e3.push(JSON.stringify(n3)) : e3.push(n3.toString());
    }
    return "[" + e3.join(", ") + "]";
  }, n.prototype.toJSON = function() {
    return { mathjs: "Index", dimensions: this._dimensions };
  }, n.fromJSON = function(e3) {
    return n.create(e3.dimensions);
  }, n;
}), { isClass: true });
function _booleansArrayToNumbersForIndex$1(e2) {
  var t2 = [];
  return e2.forEach(((e3, r) => {
    e3 && t2.push(r);
  })), t2;
}
var name$2t$1 = "FibonacciHeap", dependencies$2t$1 = ["smaller", "larger"], createFibonacciHeapClass$1 = factory$1(name$2t$1, dependencies$2t$1, ((e2) => {
  var { smaller: t2, larger: r } = e2, n = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function i2() {
    if (!(this instanceof i2)) throw new SyntaxError("Constructor must be called with the new operator");
    this._minimum = null, this._size = 0;
  }
  function a(e3, t3, r2) {
    t3.left.right = t3.right, t3.right.left = t3.left, r2.degree--, r2.child === t3 && (r2.child = t3.right), 0 === r2.degree && (r2.child = null), t3.left = e3, t3.right = e3.right, e3.right = t3, t3.right.left = t3, t3.parent = null, t3.mark = false;
  }
  function o(e3, t3) {
    var r2 = t3.parent;
    r2 && (t3.mark ? (a(e3, t3, r2), o(r2)) : t3.mark = true);
  }
  i2.prototype.type = "FibonacciHeap", i2.prototype.isFibonacciHeap = true, i2.prototype.insert = function(e3, r2) {
    var n3 = { key: e3, value: r2, degree: 0 };
    if (this._minimum) {
      var i3 = this._minimum;
      n3.left = i3, n3.right = i3.right, i3.right = n3, n3.right.left = n3, t2(e3, i3.key) && (this._minimum = n3);
    } else n3.left = n3, n3.right = n3, this._minimum = n3;
    return this._size++, n3;
  }, i2.prototype.size = function() {
    return this._size;
  }, i2.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, i2.prototype.isEmpty = function() {
    return 0 === this._size;
  }, i2.prototype.extractMinimum = function() {
    var e3 = this._minimum;
    if (null === e3) return e3;
    for (var i3 = this._minimum, a2 = e3.degree, o2 = e3.child; a2 > 0; ) {
      var u = o2.right;
      o2.left.right = o2.right, o2.right.left = o2.left, o2.left = i3, o2.right = i3.right, i3.right = o2, o2.right.left = o2, o2.parent = null, o2 = u, a2--;
    }
    return e3.left.right = e3.right, e3.right.left = e3.left, i3 = e3 === e3.right ? null : (function(e4, i4) {
      var a3, o3 = Math.floor(Math.log(i4) * n) + 1, u2 = new Array(o3), c2 = 0, l = e4;
      if (l) for (c2++, l = l.right; l !== e4; ) c2++, l = l.right;
      for (; c2 > 0; ) {
        for (var f2 = l.degree, p = l.right; a3 = u2[f2]; ) {
          if (r(l.key, a3.key)) {
            var m = a3;
            a3 = l, l = m;
          }
          s(a3, l), u2[f2] = null, f2++;
        }
        u2[f2] = l, l = p, c2--;
      }
      e4 = null;
      for (var d = 0; d < o3; d++) (a3 = u2[d]) && (e4 ? (a3.left.right = a3.right, a3.right.left = a3.left, a3.left = e4, a3.right = e4.right, e4.right = a3, a3.right.left = a3, t2(a3.key, e4.key) && (e4 = a3)) : e4 = a3);
      return e4;
    })(i3 = e3.right, this._size), this._size--, this._minimum = i3, e3;
  }, i2.prototype.remove = function(e3) {
    this._minimum = (function(e4, r2, n3) {
      r2.key = n3;
      var i3 = r2.parent;
      i3 && t2(r2.key, i3.key) && (a(e4, r2, i3), o(e4, i3));
      t2(r2.key, e4.key) && (e4 = r2);
      return e4;
    })(this._minimum, e3, -1), this.extractMinimum();
  };
  var s = function(e3, t3) {
    e3.left.right = e3.right, e3.right.left = e3.left, e3.parent = t3, t3.child ? (e3.left = t3.child, e3.right = t3.child.right, t3.child.right = e3, e3.right.left = e3) : (t3.child = e3, e3.right = e3, e3.left = e3), t3.degree++, e3.mark = false;
  };
  return i2;
}), { isClass: true }), name$2s$1 = "Spa", dependencies$2s$1 = ["addScalar", "equalScalar", "FibonacciHeap"], createSpaClass$1 = factory$1(name$2s$1, dependencies$2s$1, ((e2) => {
  var { addScalar: t2, equalScalar: r, FibonacciHeap: n } = e2;
  function i2() {
    if (!(this instanceof i2)) throw new SyntaxError("Constructor must be called with the new operator");
    this._values = [], this._heap = new n();
  }
  return i2.prototype.type = "Spa", i2.prototype.isSpa = true, i2.prototype.set = function(e3, t3) {
    if (this._values[e3]) this._values[e3].value = t3;
    else {
      var r2 = this._heap.insert(e3, t3);
      this._values[e3] = r2;
    }
  }, i2.prototype.get = function(e3) {
    var t3 = this._values[e3];
    return t3 ? t3.value : 0;
  }, i2.prototype.accumulate = function(e3, r2) {
    var n3 = this._values[e3];
    n3 ? n3.value = t2(n3.value, r2) : (n3 = this._heap.insert(e3, r2), this._values[e3] = n3);
  }, i2.prototype.forEach = function(e3, t3, n3) {
    var i3 = this._heap, a = this._values, o = [], s = i3.extractMinimum();
    for (s && o.push(s); s && s.key <= t3; ) s.key >= e3 && (r(s.value, 0) || n3(s.key, s.value, this)), (s = i3.extractMinimum()) && o.push(s);
    for (var u = 0; u < o.length; u++) {
      var c2 = o[u];
      a[(s = i3.insert(c2.key, c2.value)).key] = s;
    }
  }, i2.prototype.swap = function(e3, t3) {
    var r2 = this._values[e3], n3 = this._values[t3];
    if (!r2 && n3) r2 = this._heap.insert(e3, n3.value), this._heap.remove(n3), this._values[e3] = r2, this._values[t3] = void 0;
    else if (r2 && !n3) n3 = this._heap.insert(t3, r2.value), this._heap.remove(r2), this._values[t3] = n3, this._values[e3] = void 0;
    else if (r2 && n3) {
      var i3 = r2.value;
      r2.value = n3.value, n3.value = i3;
    }
  }, i2;
}), { isClass: true });
function lruQueue$1(e2) {
  var t2 = 0, r = 1, n = /* @__PURE__ */ Object.create(null), i2 = /* @__PURE__ */ Object.create(null), a = 0, o = function(e3) {
    var o2 = i2[e3];
    if (o2 && (delete n[o2], delete i2[e3], --t2, r === o2)) {
      if (!t2) return a = 0, void (r = 1);
      for (; !Object.prototype.hasOwnProperty.call(n, ++r); ) ;
    }
  };
  return e2 = Math.abs(e2), { hit: function(s) {
    var u = i2[s], c2 = ++a;
    if (n[c2] = s, i2[s] = c2, !u) {
      if (++t2 <= e2) return;
      return s = n[r], o(s), s;
    }
    if (delete n[u], r === u) for (; !Object.prototype.hasOwnProperty.call(n, ++r); ) ;
  }, delete: o, clear: function() {
    t2 = a = 0, r = 1, n = /* @__PURE__ */ Object.create(null), i2 = /* @__PURE__ */ Object.create(null);
  } };
}
function memoize$1$1(e2) {
  var { hasher: t2, limit: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return r = null == r ? Number.POSITIVE_INFINITY : r, t2 = null == t2 ? JSON.stringify : t2, function n() {
    "object" != typeof n.cache && (n.cache = { values: /* @__PURE__ */ new Map(), lru: lruQueue$1(r || Number.POSITIVE_INFINITY) });
    for (var i2 = [], a = 0; a < arguments.length; a++) i2[a] = arguments[a];
    var o = t2(i2);
    if (n.cache.values.has(o)) return n.cache.lru.hit(o), n.cache.values.get(o);
    var s = e2.apply(e2, i2);
    return n.cache.values.set(o, s), n.cache.values.delete(n.cache.lru.hit(o)), s;
  };
}
var createBigNumberE$1 = memoize$1$1((function(e2) {
  return new e2(1).exp();
}), { hasher: hasher$1 }), createBigNumberPhi$1 = memoize$1$1((function(e2) {
  return new e2(1).plus(new e2(5).sqrt()).div(2);
}), { hasher: hasher$1 }), createBigNumberPi$1 = memoize$1$1((function(e2) {
  return e2.acos(-1);
}), { hasher: hasher$1 }), createBigNumberTau$1 = memoize$1$1((function(e2) {
  return createBigNumberPi$1(e2).times(2);
}), { hasher: hasher$1 });
function hasher$1(e2) {
  return e2[0].precision;
}
function ownKeys$2$1(e2, t2) {
  var r = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e2);
    t2 && (n = n.filter((function(t3) {
      return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread$2$1(e2) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? ownKeys$2$1(Object(r), true).forEach((function(t3) {
      _defineProperty$3(e2, t3, r[t3]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r)) : ownKeys$2$1(Object(r)).forEach((function(t3) {
      Object.defineProperty(e2, t3, Object.getOwnPropertyDescriptor(r, t3));
    }));
  }
  return e2;
}
var name$2r$1 = "Unit", dependencies$2r$1 = ["?on", "config", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "abs", "fix", "round", "equal", "isNumeric", "format", "number", "Complex", "BigNumber", "Fraction"], createUnitClass$1 = factory$1(name$2r$1, dependencies$2r$1, ((e2) => {
  var t2, r, n, { on: i2, config: a, addScalar: o, subtractScalar: s, multiplyScalar: u, divideScalar: c2, pow: l, abs: f2, fix: p, round: m, equal: d, isNumeric: h, format: g, number: y, Complex: v2, BigNumber: x2, Fraction: b2 } = e2, _2 = y, w2 = false, A2 = true;
  function N(e3, t3) {
    if (!(this instanceof N)) throw new Error("Constructor must be called with the new operator");
    if (null != e3 && !h(e3) && !isComplex$1(e3)) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
    if (this.fixPrefix = w2, this.skipAutomaticSimplification = A2, void 0 === t3) this.units = [], this.dimensions = R2.map(((e4) => 0));
    else if ("string" == typeof t3) {
      var r2 = N.parse(t3);
      this.units = r2.units, this.dimensions = r2.dimensions;
    } else {
      if (!isUnit$1(t3) || null !== t3.value) throw new TypeError("Second parameter in Unit constructor must be a string or valueless Unit");
      this.fixPrefix = t3.fixPrefix, this.skipAutomaticSimplification = t3.skipAutomaticSimplification, this.dimensions = t3.dimensions.slice(0), this.units = t3.units.map(((e4) => _extends$4({}, e4)));
    }
    this.value = this._normalize(e3);
  }
  function D() {
    for (; " " === n || "	" === n; ) $2();
  }
  function E(e3) {
    return e3 >= "0" && e3 <= "9";
  }
  function $2() {
    r++, n = t2.charAt(r);
  }
  function S2(e3) {
    r = e3, n = t2.charAt(r);
  }
  function C2() {
    var e3 = "", t3 = r;
    if ("+" === n ? $2() : "-" === n && (e3 += n, $2()), !(function(e4) {
      return e4 >= "0" && e4 <= "9" || "." === e4;
    })(n)) return S2(t3), null;
    if ("." === n) {
      if (e3 += n, $2(), !E(n)) return S2(t3), null;
    } else {
      for (; E(n); ) e3 += n, $2();
      "." === n && (e3 += n, $2());
    }
    for (; E(n); ) e3 += n, $2();
    if ("E" === n || "e" === n) {
      var i3 = "", a2 = r;
      if (i3 += n, $2(), "+" !== n && "-" !== n || (i3 += n, $2()), !E(n)) return S2(a2), e3;
      for (e3 += i3; E(n); ) e3 += n, $2();
    }
    return e3;
  }
  function M2() {
    for (var e3 = ""; E(n) || N.isValidAlpha(n); ) e3 += n, $2();
    var t3 = e3.charAt(0);
    return N.isValidAlpha(t3) ? e3 : null;
  }
  function T2(e3) {
    return n === e3 ? ($2(), e3) : null;
  }
  Object.defineProperty(N, "name", { value: "Unit" }), N.prototype.constructor = N, N.prototype.type = "Unit", N.prototype.isUnit = true, N.parse = function(e3, i3) {
    if (i3 = i3 || {}, r = -1, n = "", "string" != typeof (t2 = e3)) throw new TypeError("Invalid argument in Unit.parse, string expected");
    var o2 = new N();
    o2.units = [];
    var s2 = 1, u2 = false;
    $2(), D();
    var c3 = C2(), l2 = null;
    if (c3) {
      if ("BigNumber" === a.number) l2 = new x2(c3);
      else if ("Fraction" === a.number) try {
        l2 = new b2(c3);
      } catch (e4) {
        l2 = parseFloat(c3);
      }
      else l2 = parseFloat(c3);
      D(), T2("*") ? (s2 = 1, u2 = true) : T2("/") && (s2 = -1, u2 = true);
    }
    for (var f3 = [], p2 = 1; ; ) {
      for (D(); "(" === n; ) f3.push(s2), p2 *= s2, s2 = 1, $2(), D();
      var m2 = void 0;
      if (!n) break;
      var d2 = n;
      if (null === (m2 = M2())) throw new SyntaxError('Unexpected "' + d2 + '" in "' + t2 + '" at index ' + r.toString());
      var h2 = F(m2);
      if (null === h2) throw new SyntaxError('Unit "' + m2 + '" not found.');
      var g2 = s2 * p2;
      if (D(), T2("^")) {
        D();
        var y2 = C2();
        if (null === y2) throw new SyntaxError('In "' + e3 + '", "^" must be followed by a floating-point number');
        g2 *= y2;
      }
      o2.units.push({ unit: h2.unit, prefix: h2.prefix, power: g2 });
      for (var v3 = 0; v3 < R2.length; v3++) o2.dimensions[v3] += (h2.unit.dimensions[v3] || 0) * g2;
      for (D(); ")" === n; ) {
        if (0 === f3.length) throw new SyntaxError('Unmatched ")" in "' + t2 + '" at index ' + r.toString());
        p2 /= f3.pop(), $2(), D();
      }
      if (u2 = false, T2("*") ? (s2 = 1, u2 = true) : T2("/") ? (s2 = -1, u2 = true) : s2 = 1, h2.unit.base) {
        var _3 = h2.unit.base.key;
        Z2.auto[_3] = { unit: h2.unit, prefix: h2.prefix };
      }
    }
    if (D(), n) throw new SyntaxError('Could not parse: "' + e3 + '"');
    if (u2) throw new SyntaxError('Trailing characters: "' + e3 + '"');
    if (0 !== f3.length) throw new SyntaxError('Unmatched "(" in "' + t2 + '"');
    if (0 === o2.units.length && !i3.allowNoUnits) throw new SyntaxError('"' + e3 + '" contains no units');
    return o2.value = void 0 !== l2 ? o2._normalize(l2) : null, o2;
  }, N.prototype.clone = function() {
    var e3 = new N();
    e3.fixPrefix = this.fixPrefix, e3.skipAutomaticSimplification = this.skipAutomaticSimplification, e3.value = clone$3$1(this.value), e3.dimensions = this.dimensions.slice(0), e3.units = [];
    for (var t3 = 0; t3 < this.units.length; t3++) for (var r2 in e3.units[t3] = {}, this.units[t3]) hasOwnProperty$1$2(this.units[t3], r2) && (e3.units[t3][r2] = this.units[t3][r2]);
    return e3;
  }, N.prototype.valueType = function() {
    return typeOf$1(this.value);
  }, N.prototype._isDerived = function() {
    return 0 !== this.units.length && (this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15);
  }, N.prototype._normalize = function(e3) {
    if (null == e3 || 0 === this.units.length) return e3;
    for (var t3 = e3, r2 = N._getNumberConverter(typeOf$1(e3)), n3 = 0; n3 < this.units.length; n3++) {
      var i3 = r2(this.units[n3].unit.value), a2 = r2(this.units[n3].prefix.value), o2 = r2(this.units[n3].power);
      t3 = u(t3, l(u(i3, a2), o2));
    }
    return t3;
  }, N.prototype._denormalize = function(e3, t3) {
    if (null == e3 || 0 === this.units.length) return e3;
    for (var r2 = e3, n3 = N._getNumberConverter(typeOf$1(e3)), i3 = 0; i3 < this.units.length; i3++) {
      var a2 = n3(this.units[i3].unit.value), o2 = n3(this.units[i3].prefix.value), s2 = n3(this.units[i3].power);
      r2 = c2(r2, l(u(a2, o2), s2));
    }
    return r2;
  };
  var F = memoize$1$1(((e3) => {
    if (hasOwnProperty$1$2(L2, e3)) {
      var t3 = L2[e3];
      return { unit: t3, prefix: t3.prefixes[""] };
    }
    for (var r2 in L2) if (hasOwnProperty$1$2(L2, r2) && endsWith$1(e3, r2)) {
      var n3 = L2[r2], i3 = e3.length - r2.length, a2 = e3.substring(0, i3), o2 = hasOwnProperty$1$2(n3.prefixes, a2) ? n3.prefixes[a2] : void 0;
      if (void 0 !== o2) return { unit: n3, prefix: o2 };
    }
    return null;
  }), { hasher: (e3) => e3[0], limit: 100 });
  function O2(e3) {
    return e3.equalBase(q2.NONE) && null !== e3.value && !a.predictable ? e3.value : e3;
  }
  function k2(e3) {
    return N._getNumberConverter(typeOf$1(e3))(1);
  }
  function B2(e3) {
    var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = e3.skipAutomaticSimplification || null === e3.value ? e3.clone() : e3.simplify();
    !(function(e4) {
      var t4 = false;
      void 0 !== e4.value && null !== e4.value && isComplex$1(e4.value) && (t4 = Math.abs(e4.value.re) < 1e-14);
      for (var r3 in e4.units) hasOwnProperty$1$2(e4.units, r3) && e4.units[r3].unit && ("VA" === e4.units[r3].unit.name && t4 ? e4.units[r3].unit = L2.VAR : "VAR" !== e4.units[r3].unit.name || t4 || (e4.units[r3].unit = L2.VA));
    })(r2), (function(e4, t4) {
      1 !== e4.units.length || e4.fixPrefix || Math.abs(e4.units[0].power - Math.round(e4.units[0].power)) < 1e-14 && (e4.units[0].prefix = e4._bestPrefix(t4));
    })(r2, t3.offset);
    var n3 = r2._denormalize(r2.value), i3 = null !== r2.value ? g(n3, t3 || {}) : "", a2 = r2.formatUnits();
    return { simp: r2, valueStr: i3, unitStr: a2 };
  }
  N.isValuelessUnit = function(e3) {
    return null !== F(e3);
  }, N.prototype.hasBase = function(e3) {
    if ("string" == typeof e3 && (e3 = q2[e3]), !e3) return false;
    for (var t3 = 0; t3 < R2.length; t3++) if (Math.abs((this.dimensions[t3] || 0) - (e3.dimensions[t3] || 0)) > 1e-12) return false;
    return true;
  }, N.prototype.equalBase = function(e3) {
    for (var t3 = 0; t3 < R2.length; t3++) if (Math.abs((this.dimensions[t3] || 0) - (e3.dimensions[t3] || 0)) > 1e-12) return false;
    return true;
  }, N.prototype.equals = function(e3) {
    return this.equalBase(e3) && d(this.value, e3.value);
  }, N.prototype.multiply = function(e3) {
    for (var t3 = this.clone(), r2 = isUnit$1(e3) ? e3 : new N(e3), n3 = 0; n3 < R2.length; n3++) t3.dimensions[n3] = (this.dimensions[n3] || 0) + (r2.dimensions[n3] || 0);
    for (var i3 = 0; i3 < r2.units.length; i3++) {
      var a2 = _objectSpread$2$1({}, r2.units[i3]);
      t3.units.push(a2);
    }
    if (null !== this.value || null !== r2.value) {
      var o2 = null === this.value ? this._normalize(k2(r2.value)) : this.value, s2 = null === r2.value ? r2._normalize(k2(this.value)) : r2.value;
      t3.value = u(o2, s2);
    } else t3.value = null;
    return isUnit$1(e3) && (t3.skipAutomaticSimplification = false), O2(t3);
  }, N.prototype.divideInto = function(e3) {
    return new N(e3).divide(this);
  }, N.prototype.divide = function(e3) {
    for (var t3 = this.clone(), r2 = isUnit$1(e3) ? e3 : new N(e3), n3 = 0; n3 < R2.length; n3++) t3.dimensions[n3] = (this.dimensions[n3] || 0) - (r2.dimensions[n3] || 0);
    for (var i3 = 0; i3 < r2.units.length; i3++) {
      var a2 = _objectSpread$2$1(_objectSpread$2$1({}, r2.units[i3]), {}, { power: -r2.units[i3].power });
      t3.units.push(a2);
    }
    if (null !== this.value || null !== r2.value) {
      var o2 = null === this.value ? this._normalize(k2(r2.value)) : this.value, s2 = null === r2.value ? r2._normalize(k2(this.value)) : r2.value;
      t3.value = c2(o2, s2);
    } else t3.value = null;
    return isUnit$1(e3) && (t3.skipAutomaticSimplification = false), O2(t3);
  }, N.prototype.pow = function(e3) {
    for (var t3 = this.clone(), r2 = 0; r2 < R2.length; r2++) t3.dimensions[r2] = (this.dimensions[r2] || 0) * e3;
    for (var n3 = 0; n3 < t3.units.length; n3++) t3.units[n3].power *= e3;
    return null !== t3.value ? t3.value = l(t3.value, e3) : t3.value = null, t3.skipAutomaticSimplification = false, O2(t3);
  }, N.prototype.abs = function() {
    var e3 = this.clone();
    if (null !== e3.value) if (e3._isDerived() || 0 === e3.units.length || 0 === e3.units[0].unit.offset) e3.value = f2(e3.value);
    else {
      var t3 = e3._numberConverter(), r2 = t3(e3.units[0].unit.value), n3 = t3(e3.units[0].unit.offset), i3 = u(r2, n3);
      e3.value = s(f2(o(e3.value, i3)), i3);
    }
    for (var a2 in e3.units) "VA" !== e3.units[a2].unit.name && "VAR" !== e3.units[a2].unit.name || (e3.units[a2].unit = L2.W);
    return e3;
  }, N.prototype.to = function(e3) {
    var t3, r2 = null === this.value ? this._normalize(1) : this.value;
    if ("string" == typeof e3) t3 = N.parse(e3);
    else {
      if (!isUnit$1(e3)) throw new Error("String or Unit expected as parameter");
      t3 = e3.clone();
    }
    if (!this.equalBase(t3)) throw new Error("Units do not match ('".concat(t3.toString(), "' != '").concat(this.toString(), "')"));
    if (null !== t3.value) throw new Error("Cannot convert to a unit with a value");
    if (null === this.value || this._isDerived() || 0 === this.units.length || 0 === t3.units.length || this.units[0].unit.offset === t3.units[0].unit.offset) t3.value = clone$3$1(r2);
    else {
      var n3 = N._getNumberConverter(typeOf$1(r2)), i3 = this.units[0].unit.value, a2 = this.units[0].unit.offset, c3 = u(i3, a2), l2 = t3.units[0].unit.value, f3 = t3.units[0].unit.offset, p2 = u(l2, f3);
      t3.value = o(r2, n3(s(c3, p2)));
    }
    return t3.fixPrefix = true, t3.skipAutomaticSimplification = true, t3;
  }, N.prototype.toNumber = function(e3) {
    return _2(this.toNumeric(e3));
  }, N.prototype.toNumeric = function(e3) {
    var t3;
    return (t3 = e3 ? this.to(e3) : this.clone())._isDerived() || 0 === t3.units.length ? t3._denormalize(t3.value) : t3._denormalize(t3.value, t3.units[0].prefix.value);
  }, N.prototype.toString = function() {
    return this.format();
  }, N.prototype.toJSON = function() {
    return { mathjs: "Unit", value: this._denormalize(this.value), unit: this.units.length > 0 ? this.formatUnits() : null, fixPrefix: this.fixPrefix, skipSimp: this.skipAutomaticSimplification };
  }, N.fromJSON = function(e3) {
    var t3, r2, n3, i3 = new N(e3.value, null !== (t3 = e3.unit) && void 0 !== t3 ? t3 : void 0);
    return i3.fixPrefix = null !== (r2 = e3.fixPrefix) && void 0 !== r2 ? r2 : w2, i3.skipAutomaticSimplification = null !== (n3 = e3.skipSimp) && void 0 !== n3 ? n3 : A2, i3;
  }, N.prototype.valueOf = N.prototype.toString, N.prototype.simplify = function() {
    var e3, t3, r2 = this.clone(), n3 = [];
    for (var i3 in G2) if (hasOwnProperty$1$2(G2, i3) && r2.hasBase(q2[i3])) {
      e3 = i3;
      break;
    }
    if ("NONE" === e3) r2.units = [];
    else if (e3 && hasOwnProperty$1$2(G2, e3) && (t3 = G2[e3]), t3) r2.units = [{ unit: t3.unit, prefix: t3.prefix, power: 1 }];
    else {
      for (var a2 = false, o2 = 0; o2 < R2.length; o2++) {
        var s2 = R2[o2];
        Math.abs(r2.dimensions[o2] || 0) > 1e-12 && (hasOwnProperty$1$2(G2, s2) ? n3.push({ unit: G2[s2].unit, prefix: G2[s2].prefix, power: r2.dimensions[o2] || 0 }) : a2 = true);
      }
      n3.length < r2.units.length && !a2 && (r2.units = n3);
    }
    return r2;
  }, N.prototype.toSI = function() {
    for (var e3 = this.clone(), t3 = [], r2 = 0; r2 < R2.length; r2++) {
      var n3 = R2[r2];
      if (Math.abs(e3.dimensions[r2] || 0) > 1e-12) {
        if (!hasOwnProperty$1$2(Z2.si, n3)) throw new Error("Cannot express custom unit " + n3 + " in SI units");
        t3.push({ unit: Z2.si[n3].unit, prefix: Z2.si[n3].prefix, power: e3.dimensions[r2] || 0 });
      }
    }
    return e3.units = t3, e3.fixPrefix = true, e3.skipAutomaticSimplification = true, null !== this.value ? (e3.value = null, this.to(e3)) : e3;
  }, N.prototype.formatUnits = function() {
    for (var e3 = "", t3 = "", r2 = 0, n3 = 0, i3 = 0; i3 < this.units.length; i3++) this.units[i3].power > 0 ? (r2++, e3 += " " + this.units[i3].prefix.name + this.units[i3].unit.name, Math.abs(this.units[i3].power - 1) > 1e-15 && (e3 += "^" + this.units[i3].power)) : this.units[i3].power < 0 && n3++;
    if (n3 > 0) for (var a2 = 0; a2 < this.units.length; a2++) this.units[a2].power < 0 && (r2 > 0 ? (t3 += " " + this.units[a2].prefix.name + this.units[a2].unit.name, Math.abs(this.units[a2].power + 1) > 1e-15 && (t3 += "^" + -this.units[a2].power)) : (t3 += " " + this.units[a2].prefix.name + this.units[a2].unit.name, t3 += "^" + this.units[a2].power));
    e3 = e3.substr(1), t3 = t3.substr(1), r2 > 1 && n3 > 0 && (e3 = "(" + e3 + ")"), n3 > 1 && r2 > 0 && (t3 = "(" + t3 + ")");
    var o2 = e3;
    return r2 > 0 && n3 > 0 && (o2 += " / "), o2 += t3;
  }, N.prototype.toBest = function() {
    var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (e3 && !Array.isArray(e3)) throw new Error("Invalid unit type. Expected string or Unit.");
    var r2 = this.units[0].unit.prefixes;
    if (e3 && e3.length > 0) {
      var n3 = e3.map(((e4) => {
        var t4 = null;
        if ("string" == typeof e4) {
          if (!(t4 = N.parse(e4))) throw new Error("Invalid unit type. Expected compatible string or Unit.");
        } else if (!isUnit$1(e4)) throw new Error("Invalid unit type. Expected compatible string or Unit.");
        null === t4 && (t4 = e4.clone());
        try {
          return this.to(t4.formatUnits()), t4;
        } catch (e5) {
          throw new Error("Invalid unit type. Expected compatible string or Unit.");
        }
      })), i3 = n3.map(((e4) => e4.units[0].prefix));
      this.units[0].unit.prefixes = i3.reduce(((e4, t4) => (e4[t4.name] = t4, e4)), {}), this.units[0].prefix = i3[0];
    }
    var a2 = B2(this, t3).simp;
    return this.units[0].unit.prefixes = r2, a2.fixPrefix = true, a2;
  }, N.prototype.format = function(e3) {
    var { simp: t3, valueStr: r2, unitStr: n3 } = B2(this, e3), i3 = r2;
    return t3.value && isComplex$1(t3.value) && (i3 = "(" + i3 + ")"), n3.length > 0 && i3.length > 0 && (i3 += " "), i3 += n3;
  }, N.prototype._bestPrefix = function() {
    var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1.2;
    if (1 !== this.units.length) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    var t3 = null !== this.value ? f2(this.value) : 0, r2 = f2(this.units[0].unit.value), n3 = this.units[0].prefix;
    if (0 === t3) return n3;
    var i3 = this.units[0].power, a2 = Math.log(t3 / Math.pow(n3.value * r2, i3)) / Math.LN10 - e3;
    if (a2 > -2.200001 && a2 < 1.800001) return n3;
    a2 = Math.abs(a2);
    var o2 = this.units[0].unit.prefixes;
    for (var s2 in o2) if (hasOwnProperty$1$2(o2, s2)) {
      var u2 = o2[s2];
      if (u2.scientific) {
        var c3 = Math.abs(Math.log(t3 / Math.pow(u2.value * r2, i3)) / Math.LN10 - e3);
        (c3 < a2 || c3 === a2 && u2.name.length < n3.name.length) && (n3 = u2, a2 = c3);
      }
    }
    return n3;
  }, N.prototype.splitUnit = function(e3) {
    for (var t3 = this.clone(), r2 = [], n3 = 0; n3 < e3.length && (t3 = t3.to(e3[n3]), n3 !== e3.length - 1); n3++) {
      var i3 = t3.toNumeric(), a2 = m(i3), u2 = new N(d(a2, i3) ? a2 : p(t3.toNumeric()), e3[n3].toString());
      r2.push(u2), t3 = s(t3, u2);
    }
    for (var c3 = 0, l2 = 0; l2 < r2.length; l2++) c3 = o(c3, r2[l2].value);
    return d(c3, this.value) && (t3.value = 0), r2.push(t3), r2;
  };
  var I2 = { NONE: { "": { name: "", value: 1, scientific: true } }, SHORT: { "": { name: "", value: 1, scientific: true }, da: { name: "da", value: 10, scientific: false }, h: { name: "h", value: 100, scientific: false }, k: { name: "k", value: 1e3, scientific: true }, M: { name: "M", value: 1e6, scientific: true }, G: { name: "G", value: 1e9, scientific: true }, T: { name: "T", value: 1e12, scientific: true }, P: { name: "P", value: 1e15, scientific: true }, E: { name: "E", value: 1e18, scientific: true }, Z: { name: "Z", value: 1e21, scientific: true }, Y: { name: "Y", value: 1e24, scientific: true }, R: { name: "R", value: 1e27, scientific: true }, Q: { name: "Q", value: 1e30, scientific: true }, d: { name: "d", value: 0.1, scientific: false }, c: { name: "c", value: 0.01, scientific: false }, m: { name: "m", value: 1e-3, scientific: true }, u: { name: "u", value: 1e-6, scientific: true }, n: { name: "n", value: 1e-9, scientific: true }, p: { name: "p", value: 1e-12, scientific: true }, f: { name: "f", value: 1e-15, scientific: true }, a: { name: "a", value: 1e-18, scientific: true }, z: { name: "z", value: 1e-21, scientific: true }, y: { name: "y", value: 1e-24, scientific: true }, r: { name: "r", value: 1e-27, scientific: true }, q: { name: "q", value: 1e-30, scientific: true } }, LONG: { "": { name: "", value: 1, scientific: true }, deca: { name: "deca", value: 10, scientific: false }, hecto: { name: "hecto", value: 100, scientific: false }, kilo: { name: "kilo", value: 1e3, scientific: true }, mega: { name: "mega", value: 1e6, scientific: true }, giga: { name: "giga", value: 1e9, scientific: true }, tera: { name: "tera", value: 1e12, scientific: true }, peta: { name: "peta", value: 1e15, scientific: true }, exa: { name: "exa", value: 1e18, scientific: true }, zetta: { name: "zetta", value: 1e21, scientific: true }, yotta: { name: "yotta", value: 1e24, scientific: true }, ronna: { name: "ronna", value: 1e27, scientific: true }, quetta: { name: "quetta", value: 1e30, scientific: true }, deci: { name: "deci", value: 0.1, scientific: false }, centi: { name: "centi", value: 0.01, scientific: false }, milli: { name: "milli", value: 1e-3, scientific: true }, micro: { name: "micro", value: 1e-6, scientific: true }, nano: { name: "nano", value: 1e-9, scientific: true }, pico: { name: "pico", value: 1e-12, scientific: true }, femto: { name: "femto", value: 1e-15, scientific: true }, atto: { name: "atto", value: 1e-18, scientific: true }, zepto: { name: "zepto", value: 1e-21, scientific: true }, yocto: { name: "yocto", value: 1e-24, scientific: true }, ronto: { name: "ronto", value: 1e-27, scientific: true }, quecto: { name: "quecto", value: 1e-30, scientific: true } }, SQUARED: { "": { name: "", value: 1, scientific: true }, da: { name: "da", value: 100, scientific: false }, h: { name: "h", value: 1e4, scientific: false }, k: { name: "k", value: 1e6, scientific: true }, M: { name: "M", value: 1e12, scientific: true }, G: { name: "G", value: 1e18, scientific: true }, T: { name: "T", value: 1e24, scientific: true }, P: { name: "P", value: 1e30, scientific: true }, E: { name: "E", value: 1e36, scientific: true }, Z: { name: "Z", value: 1e42, scientific: true }, Y: { name: "Y", value: 1e48, scientific: true }, R: { name: "R", value: 1e54, scientific: true }, Q: { name: "Q", value: 1e60, scientific: true }, d: { name: "d", value: 0.01, scientific: false }, c: { name: "c", value: 1e-4, scientific: false }, m: { name: "m", value: 1e-6, scientific: true }, u: { name: "u", value: 1e-12, scientific: true }, n: { name: "n", value: 1e-18, scientific: true }, p: { name: "p", value: 1e-24, scientific: true }, f: { name: "f", value: 1e-30, scientific: true }, a: { name: "a", value: 1e-36, scientific: true }, z: { name: "z", value: 1e-42, scientific: true }, y: { name: "y", value: 1e-48, scientific: true }, r: { name: "r", value: 1e-54, scientific: true }, q: { name: "q", value: 1e-60, scientific: true } }, CUBIC: { "": { name: "", value: 1, scientific: true }, da: { name: "da", value: 1e3, scientific: false }, h: { name: "h", value: 1e6, scientific: false }, k: { name: "k", value: 1e9, scientific: true }, M: { name: "M", value: 1e18, scientific: true }, G: { name: "G", value: 1e27, scientific: true }, T: { name: "T", value: 1e36, scientific: true }, P: { name: "P", value: 1e45, scientific: true }, E: { name: "E", value: 1e54, scientific: true }, Z: { name: "Z", value: 1e63, scientific: true }, Y: { name: "Y", value: 1e72, scientific: true }, R: { name: "R", value: 1e81, scientific: true }, Q: { name: "Q", value: 1e90, scientific: true }, d: { name: "d", value: 1e-3, scientific: false }, c: { name: "c", value: 1e-6, scientific: false }, m: { name: "m", value: 1e-9, scientific: true }, u: { name: "u", value: 1e-18, scientific: true }, n: { name: "n", value: 1e-27, scientific: true }, p: { name: "p", value: 1e-36, scientific: true }, f: { name: "f", value: 1e-45, scientific: true }, a: { name: "a", value: 1e-54, scientific: true }, z: { name: "z", value: 1e-63, scientific: true }, y: { name: "y", value: 1e-72, scientific: true }, r: { name: "r", value: 1e-81, scientific: true }, q: { name: "q", value: 1e-90, scientific: true } }, BINARY_SHORT_SI: { "": { name: "", value: 1, scientific: true }, k: { name: "k", value: 1e3, scientific: true }, M: { name: "M", value: 1e6, scientific: true }, G: { name: "G", value: 1e9, scientific: true }, T: { name: "T", value: 1e12, scientific: true }, P: { name: "P", value: 1e15, scientific: true }, E: { name: "E", value: 1e18, scientific: true }, Z: { name: "Z", value: 1e21, scientific: true }, Y: { name: "Y", value: 1e24, scientific: true } }, BINARY_SHORT_IEC: { "": { name: "", value: 1, scientific: true }, Ki: { name: "Ki", value: 1024, scientific: true }, Mi: { name: "Mi", value: Math.pow(1024, 2), scientific: true }, Gi: { name: "Gi", value: Math.pow(1024, 3), scientific: true }, Ti: { name: "Ti", value: Math.pow(1024, 4), scientific: true }, Pi: { name: "Pi", value: Math.pow(1024, 5), scientific: true }, Ei: { name: "Ei", value: Math.pow(1024, 6), scientific: true }, Zi: { name: "Zi", value: Math.pow(1024, 7), scientific: true }, Yi: { name: "Yi", value: Math.pow(1024, 8), scientific: true } }, BINARY_LONG_SI: { "": { name: "", value: 1, scientific: true }, kilo: { name: "kilo", value: 1e3, scientific: true }, mega: { name: "mega", value: 1e6, scientific: true }, giga: { name: "giga", value: 1e9, scientific: true }, tera: { name: "tera", value: 1e12, scientific: true }, peta: { name: "peta", value: 1e15, scientific: true }, exa: { name: "exa", value: 1e18, scientific: true }, zetta: { name: "zetta", value: 1e21, scientific: true }, yotta: { name: "yotta", value: 1e24, scientific: true } }, BINARY_LONG_IEC: { "": { name: "", value: 1, scientific: true }, kibi: { name: "kibi", value: 1024, scientific: true }, mebi: { name: "mebi", value: Math.pow(1024, 2), scientific: true }, gibi: { name: "gibi", value: Math.pow(1024, 3), scientific: true }, tebi: { name: "tebi", value: Math.pow(1024, 4), scientific: true }, pebi: { name: "pebi", value: Math.pow(1024, 5), scientific: true }, exi: { name: "exi", value: Math.pow(1024, 6), scientific: true }, zebi: { name: "zebi", value: Math.pow(1024, 7), scientific: true }, yobi: { name: "yobi", value: Math.pow(1024, 8), scientific: true } }, BTU: { "": { name: "", value: 1, scientific: true }, MM: { name: "MM", value: 1e6, scientific: true } } };
  I2.SHORTLONG = _extends$4({}, I2.SHORT, I2.LONG), I2.BINARY_SHORT = _extends$4({}, I2.BINARY_SHORT_SI, I2.BINARY_SHORT_IEC), I2.BINARY_LONG = _extends$4({}, I2.BINARY_LONG_SI, I2.BINARY_LONG_IEC);
  var R2 = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"], q2 = { NONE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0] }, MASS: { dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0] }, LENGTH: { dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0] }, TIME: { dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0] }, CURRENT: { dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0] }, TEMPERATURE: { dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0] }, LUMINOUS_INTENSITY: { dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0] }, AMOUNT_OF_SUBSTANCE: { dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0] }, FORCE: { dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0] }, SURFACE: { dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0] }, VOLUME: { dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0] }, ENERGY: { dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0] }, POWER: { dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0] }, PRESSURE: { dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0] }, ELECTRIC_CHARGE: { dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0] }, ELECTRIC_CAPACITANCE: { dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0] }, ELECTRIC_POTENTIAL: { dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0] }, ELECTRIC_RESISTANCE: { dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0] }, ELECTRIC_INDUCTANCE: { dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0] }, ELECTRIC_CONDUCTANCE: { dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX: { dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX_DENSITY: { dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0] }, FREQUENCY: { dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0] }, ANGLE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0] }, BIT: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1] } };
  for (var z2 in q2) hasOwnProperty$1$2(q2, z2) && (q2[z2].key = z2);
  var P2 = { name: "", base: {}, value: 1, offset: 0, dimensions: R2.map(((e3) => 0)) }, L2 = { meter: { name: "meter", base: q2.LENGTH, prefixes: I2.LONG, value: 1, offset: 0 }, inch: { name: "inch", base: q2.LENGTH, prefixes: I2.NONE, value: 0.0254, offset: 0 }, foot: { name: "foot", base: q2.LENGTH, prefixes: I2.NONE, value: 0.3048, offset: 0 }, yard: { name: "yard", base: q2.LENGTH, prefixes: I2.NONE, value: 0.9144, offset: 0 }, mile: { name: "mile", base: q2.LENGTH, prefixes: I2.NONE, value: 1609.344, offset: 0 }, link: { name: "link", base: q2.LENGTH, prefixes: I2.NONE, value: 0.201168, offset: 0 }, rod: { name: "rod", base: q2.LENGTH, prefixes: I2.NONE, value: 5.0292, offset: 0 }, chain: { name: "chain", base: q2.LENGTH, prefixes: I2.NONE, value: 20.1168, offset: 0 }, angstrom: { name: "angstrom", base: q2.LENGTH, prefixes: I2.NONE, value: 1e-10, offset: 0 }, m: { name: "m", base: q2.LENGTH, prefixes: I2.SHORT, value: 1, offset: 0 }, in: { name: "in", base: q2.LENGTH, prefixes: I2.NONE, value: 0.0254, offset: 0 }, ft: { name: "ft", base: q2.LENGTH, prefixes: I2.NONE, value: 0.3048, offset: 0 }, yd: { name: "yd", base: q2.LENGTH, prefixes: I2.NONE, value: 0.9144, offset: 0 }, mi: { name: "mi", base: q2.LENGTH, prefixes: I2.NONE, value: 1609.344, offset: 0 }, li: { name: "li", base: q2.LENGTH, prefixes: I2.NONE, value: 0.201168, offset: 0 }, rd: { name: "rd", base: q2.LENGTH, prefixes: I2.NONE, value: 5.02921, offset: 0 }, ch: { name: "ch", base: q2.LENGTH, prefixes: I2.NONE, value: 20.1168, offset: 0 }, mil: { name: "mil", base: q2.LENGTH, prefixes: I2.NONE, value: 254e-7, offset: 0 }, m2: { name: "m2", base: q2.SURFACE, prefixes: I2.SQUARED, value: 1, offset: 0 }, sqin: { name: "sqin", base: q2.SURFACE, prefixes: I2.NONE, value: 64516e-8, offset: 0 }, sqft: { name: "sqft", base: q2.SURFACE, prefixes: I2.NONE, value: 0.09290304, offset: 0 }, sqyd: { name: "sqyd", base: q2.SURFACE, prefixes: I2.NONE, value: 0.83612736, offset: 0 }, sqmi: { name: "sqmi", base: q2.SURFACE, prefixes: I2.NONE, value: 2589988110336e-6, offset: 0 }, sqrd: { name: "sqrd", base: q2.SURFACE, prefixes: I2.NONE, value: 25.29295, offset: 0 }, sqch: { name: "sqch", base: q2.SURFACE, prefixes: I2.NONE, value: 404.6873, offset: 0 }, sqmil: { name: "sqmil", base: q2.SURFACE, prefixes: I2.NONE, value: 64516e-14, offset: 0 }, acre: { name: "acre", base: q2.SURFACE, prefixes: I2.NONE, value: 4046.86, offset: 0 }, hectare: { name: "hectare", base: q2.SURFACE, prefixes: I2.NONE, value: 1e4, offset: 0 }, m3: { name: "m3", base: q2.VOLUME, prefixes: I2.CUBIC, value: 1, offset: 0 }, L: { name: "L", base: q2.VOLUME, prefixes: I2.SHORT, value: 1e-3, offset: 0 }, l: { name: "l", base: q2.VOLUME, prefixes: I2.SHORT, value: 1e-3, offset: 0 }, litre: { name: "litre", base: q2.VOLUME, prefixes: I2.LONG, value: 1e-3, offset: 0 }, cuin: { name: "cuin", base: q2.VOLUME, prefixes: I2.NONE, value: 16387064e-12, offset: 0 }, cuft: { name: "cuft", base: q2.VOLUME, prefixes: I2.NONE, value: 0.028316846592, offset: 0 }, cuyd: { name: "cuyd", base: q2.VOLUME, prefixes: I2.NONE, value: 0.764554857984, offset: 0 }, teaspoon: { name: "teaspoon", base: q2.VOLUME, prefixes: I2.NONE, value: 5e-6, offset: 0 }, tablespoon: { name: "tablespoon", base: q2.VOLUME, prefixes: I2.NONE, value: 15e-6, offset: 0 }, drop: { name: "drop", base: q2.VOLUME, prefixes: I2.NONE, value: 5e-8, offset: 0 }, gtt: { name: "gtt", base: q2.VOLUME, prefixes: I2.NONE, value: 5e-8, offset: 0 }, minim: { name: "minim", base: q2.VOLUME, prefixes: I2.NONE, value: 61611519921875e-21, offset: 0 }, fluiddram: { name: "fluiddram", base: q2.VOLUME, prefixes: I2.NONE, value: 36966911953125e-19, offset: 0 }, fluidounce: { name: "fluidounce", base: q2.VOLUME, prefixes: I2.NONE, value: 295735295625e-16, offset: 0 }, gill: { name: "gill", base: q2.VOLUME, prefixes: I2.NONE, value: 11829411825e-14, offset: 0 }, cc: { name: "cc", base: q2.VOLUME, prefixes: I2.NONE, value: 1e-6, offset: 0 }, cup: { name: "cup", base: q2.VOLUME, prefixes: I2.NONE, value: 2365882365e-13, offset: 0 }, pint: { name: "pint", base: q2.VOLUME, prefixes: I2.NONE, value: 473176473e-12, offset: 0 }, quart: { name: "quart", base: q2.VOLUME, prefixes: I2.NONE, value: 946352946e-12, offset: 0 }, gallon: { name: "gallon", base: q2.VOLUME, prefixes: I2.NONE, value: 0.003785411784, offset: 0 }, beerbarrel: { name: "beerbarrel", base: q2.VOLUME, prefixes: I2.NONE, value: 0.117347765304, offset: 0 }, oilbarrel: { name: "oilbarrel", base: q2.VOLUME, prefixes: I2.NONE, value: 0.158987294928, offset: 0 }, hogshead: { name: "hogshead", base: q2.VOLUME, prefixes: I2.NONE, value: 0.238480942392, offset: 0 }, g: { name: "g", base: q2.MASS, prefixes: I2.SHORT, value: 1e-3, offset: 0 }, gram: { name: "gram", base: q2.MASS, prefixes: I2.LONG, value: 1e-3, offset: 0 }, ton: { name: "ton", base: q2.MASS, prefixes: I2.SHORT, value: 907.18474, offset: 0 }, t: { name: "t", base: q2.MASS, prefixes: I2.SHORT, value: 1e3, offset: 0 }, tonne: { name: "tonne", base: q2.MASS, prefixes: I2.LONG, value: 1e3, offset: 0 }, grain: { name: "grain", base: q2.MASS, prefixes: I2.NONE, value: 6479891e-11, offset: 0 }, dram: { name: "dram", base: q2.MASS, prefixes: I2.NONE, value: 0.0017718451953125, offset: 0 }, ounce: { name: "ounce", base: q2.MASS, prefixes: I2.NONE, value: 0.028349523125, offset: 0 }, poundmass: { name: "poundmass", base: q2.MASS, prefixes: I2.NONE, value: 0.45359237, offset: 0 }, hundredweight: { name: "hundredweight", base: q2.MASS, prefixes: I2.NONE, value: 45.359237, offset: 0 }, stick: { name: "stick", base: q2.MASS, prefixes: I2.NONE, value: 0.115, offset: 0 }, stone: { name: "stone", base: q2.MASS, prefixes: I2.NONE, value: 6.35029318, offset: 0 }, gr: { name: "gr", base: q2.MASS, prefixes: I2.NONE, value: 6479891e-11, offset: 0 }, dr: { name: "dr", base: q2.MASS, prefixes: I2.NONE, value: 0.0017718451953125, offset: 0 }, oz: { name: "oz", base: q2.MASS, prefixes: I2.NONE, value: 0.028349523125, offset: 0 }, lbm: { name: "lbm", base: q2.MASS, prefixes: I2.NONE, value: 0.45359237, offset: 0 }, cwt: { name: "cwt", base: q2.MASS, prefixes: I2.NONE, value: 45.359237, offset: 0 }, s: { name: "s", base: q2.TIME, prefixes: I2.SHORT, value: 1, offset: 0 }, min: { name: "min", base: q2.TIME, prefixes: I2.NONE, value: 60, offset: 0 }, h: { name: "h", base: q2.TIME, prefixes: I2.NONE, value: 3600, offset: 0 }, second: { name: "second", base: q2.TIME, prefixes: I2.LONG, value: 1, offset: 0 }, sec: { name: "sec", base: q2.TIME, prefixes: I2.LONG, value: 1, offset: 0 }, minute: { name: "minute", base: q2.TIME, prefixes: I2.NONE, value: 60, offset: 0 }, hour: { name: "hour", base: q2.TIME, prefixes: I2.NONE, value: 3600, offset: 0 }, day: { name: "day", base: q2.TIME, prefixes: I2.NONE, value: 86400, offset: 0 }, week: { name: "week", base: q2.TIME, prefixes: I2.NONE, value: 604800, offset: 0 }, month: { name: "month", base: q2.TIME, prefixes: I2.NONE, value: 2629800, offset: 0 }, year: { name: "year", base: q2.TIME, prefixes: I2.NONE, value: 31557600, offset: 0 }, decade: { name: "decade", base: q2.TIME, prefixes: I2.NONE, value: 315576e3, offset: 0 }, century: { name: "century", base: q2.TIME, prefixes: I2.NONE, value: 315576e4, offset: 0 }, millennium: { name: "millennium", base: q2.TIME, prefixes: I2.NONE, value: 315576e5, offset: 0 }, hertz: { name: "Hertz", base: q2.FREQUENCY, prefixes: I2.LONG, value: 1, offset: 0, reciprocal: true }, Hz: { name: "Hz", base: q2.FREQUENCY, prefixes: I2.SHORT, value: 1, offset: 0, reciprocal: true }, rad: { name: "rad", base: q2.ANGLE, prefixes: I2.SHORT, value: 1, offset: 0 }, radian: { name: "radian", base: q2.ANGLE, prefixes: I2.LONG, value: 1, offset: 0 }, deg: { name: "deg", base: q2.ANGLE, prefixes: I2.SHORT, value: null, offset: 0 }, degree: { name: "degree", base: q2.ANGLE, prefixes: I2.LONG, value: null, offset: 0 }, grad: { name: "grad", base: q2.ANGLE, prefixes: I2.SHORT, value: null, offset: 0 }, gradian: { name: "gradian", base: q2.ANGLE, prefixes: I2.LONG, value: null, offset: 0 }, cycle: { name: "cycle", base: q2.ANGLE, prefixes: I2.NONE, value: null, offset: 0 }, arcsec: { name: "arcsec", base: q2.ANGLE, prefixes: I2.NONE, value: null, offset: 0 }, arcmin: { name: "arcmin", base: q2.ANGLE, prefixes: I2.NONE, value: null, offset: 0 }, A: { name: "A", base: q2.CURRENT, prefixes: I2.SHORT, value: 1, offset: 0 }, ampere: { name: "ampere", base: q2.CURRENT, prefixes: I2.LONG, value: 1, offset: 0 }, K: { name: "K", base: q2.TEMPERATURE, prefixes: I2.SHORT, value: 1, offset: 0 }, degC: { name: "degC", base: q2.TEMPERATURE, prefixes: I2.SHORT, value: 1, offset: 273.15 }, degF: { name: "degF", base: q2.TEMPERATURE, prefixes: I2.SHORT, value: new b2(5, 9), offset: 459.67 }, degR: { name: "degR", base: q2.TEMPERATURE, prefixes: I2.SHORT, value: new b2(5, 9), offset: 0 }, kelvin: { name: "kelvin", base: q2.TEMPERATURE, prefixes: I2.LONG, value: 1, offset: 0 }, celsius: { name: "celsius", base: q2.TEMPERATURE, prefixes: I2.LONG, value: 1, offset: 273.15 }, fahrenheit: { name: "fahrenheit", base: q2.TEMPERATURE, prefixes: I2.LONG, value: new b2(5, 9), offset: 459.67 }, rankine: { name: "rankine", base: q2.TEMPERATURE, prefixes: I2.LONG, value: new b2(5, 9), offset: 0 }, mol: { name: "mol", base: q2.AMOUNT_OF_SUBSTANCE, prefixes: I2.SHORT, value: 1, offset: 0 }, mole: { name: "mole", base: q2.AMOUNT_OF_SUBSTANCE, prefixes: I2.LONG, value: 1, offset: 0 }, cd: { name: "cd", base: q2.LUMINOUS_INTENSITY, prefixes: I2.SHORT, value: 1, offset: 0 }, candela: { name: "candela", base: q2.LUMINOUS_INTENSITY, prefixes: I2.LONG, value: 1, offset: 0 }, N: { name: "N", base: q2.FORCE, prefixes: I2.SHORT, value: 1, offset: 0 }, newton: { name: "newton", base: q2.FORCE, prefixes: I2.LONG, value: 1, offset: 0 }, dyn: { name: "dyn", base: q2.FORCE, prefixes: I2.SHORT, value: 1e-5, offset: 0 }, dyne: { name: "dyne", base: q2.FORCE, prefixes: I2.LONG, value: 1e-5, offset: 0 }, lbf: { name: "lbf", base: q2.FORCE, prefixes: I2.NONE, value: 4.4482216152605, offset: 0 }, poundforce: { name: "poundforce", base: q2.FORCE, prefixes: I2.NONE, value: 4.4482216152605, offset: 0 }, kip: { name: "kip", base: q2.FORCE, prefixes: I2.LONG, value: 4448.2216, offset: 0 }, kilogramforce: { name: "kilogramforce", base: q2.FORCE, prefixes: I2.NONE, value: 9.80665, offset: 0 }, J: { name: "J", base: q2.ENERGY, prefixes: I2.SHORT, value: 1, offset: 0 }, joule: { name: "joule", base: q2.ENERGY, prefixes: I2.LONG, value: 1, offset: 0 }, erg: { name: "erg", base: q2.ENERGY, prefixes: I2.SHORTLONG, value: 1e-7, offset: 0 }, Wh: { name: "Wh", base: q2.ENERGY, prefixes: I2.SHORT, value: 3600, offset: 0 }, BTU: { name: "BTU", base: q2.ENERGY, prefixes: I2.BTU, value: 1055.05585262, offset: 0 }, eV: { name: "eV", base: q2.ENERGY, prefixes: I2.SHORT, value: 1602176565e-28, offset: 0 }, electronvolt: { name: "electronvolt", base: q2.ENERGY, prefixes: I2.LONG, value: 1602176565e-28, offset: 0 }, W: { name: "W", base: q2.POWER, prefixes: I2.SHORT, value: 1, offset: 0 }, watt: { name: "watt", base: q2.POWER, prefixes: I2.LONG, value: 1, offset: 0 }, hp: { name: "hp", base: q2.POWER, prefixes: I2.NONE, value: 745.6998715386, offset: 0 }, VAR: { name: "VAR", base: q2.POWER, prefixes: I2.SHORT, value: v2.I, offset: 0 }, VA: { name: "VA", base: q2.POWER, prefixes: I2.SHORT, value: 1, offset: 0 }, Pa: { name: "Pa", base: q2.PRESSURE, prefixes: I2.SHORT, value: 1, offset: 0 }, psi: { name: "psi", base: q2.PRESSURE, prefixes: I2.NONE, value: 6894.75729276459, offset: 0 }, atm: { name: "atm", base: q2.PRESSURE, prefixes: I2.NONE, value: 101325, offset: 0 }, bar: { name: "bar", base: q2.PRESSURE, prefixes: I2.SHORTLONG, value: 1e5, offset: 0 }, torr: { name: "torr", base: q2.PRESSURE, prefixes: I2.NONE, value: 133.322, offset: 0 }, mmHg: { name: "mmHg", base: q2.PRESSURE, prefixes: I2.NONE, value: 133.322, offset: 0 }, mmH2O: { name: "mmH2O", base: q2.PRESSURE, prefixes: I2.NONE, value: 9.80665, offset: 0 }, cmH2O: { name: "cmH2O", base: q2.PRESSURE, prefixes: I2.NONE, value: 98.0665, offset: 0 }, coulomb: { name: "coulomb", base: q2.ELECTRIC_CHARGE, prefixes: I2.LONG, value: 1, offset: 0 }, C: { name: "C", base: q2.ELECTRIC_CHARGE, prefixes: I2.SHORT, value: 1, offset: 0 }, farad: { name: "farad", base: q2.ELECTRIC_CAPACITANCE, prefixes: I2.LONG, value: 1, offset: 0 }, F: { name: "F", base: q2.ELECTRIC_CAPACITANCE, prefixes: I2.SHORT, value: 1, offset: 0 }, volt: { name: "volt", base: q2.ELECTRIC_POTENTIAL, prefixes: I2.LONG, value: 1, offset: 0 }, V: { name: "V", base: q2.ELECTRIC_POTENTIAL, prefixes: I2.SHORT, value: 1, offset: 0 }, ohm: { name: "ohm", base: q2.ELECTRIC_RESISTANCE, prefixes: I2.SHORTLONG, value: 1, offset: 0 }, henry: { name: "henry", base: q2.ELECTRIC_INDUCTANCE, prefixes: I2.LONG, value: 1, offset: 0 }, H: { name: "H", base: q2.ELECTRIC_INDUCTANCE, prefixes: I2.SHORT, value: 1, offset: 0 }, siemens: { name: "siemens", base: q2.ELECTRIC_CONDUCTANCE, prefixes: I2.LONG, value: 1, offset: 0 }, S: { name: "S", base: q2.ELECTRIC_CONDUCTANCE, prefixes: I2.SHORT, value: 1, offset: 0 }, weber: { name: "weber", base: q2.MAGNETIC_FLUX, prefixes: I2.LONG, value: 1, offset: 0 }, Wb: { name: "Wb", base: q2.MAGNETIC_FLUX, prefixes: I2.SHORT, value: 1, offset: 0 }, tesla: { name: "tesla", base: q2.MAGNETIC_FLUX_DENSITY, prefixes: I2.LONG, value: 1, offset: 0 }, T: { name: "T", base: q2.MAGNETIC_FLUX_DENSITY, prefixes: I2.SHORT, value: 1, offset: 0 }, b: { name: "b", base: q2.BIT, prefixes: I2.BINARY_SHORT, value: 1, offset: 0 }, bits: { name: "bits", base: q2.BIT, prefixes: I2.BINARY_LONG, value: 1, offset: 0 }, B: { name: "B", base: q2.BIT, prefixes: I2.BINARY_SHORT, value: 8, offset: 0 }, bytes: { name: "bytes", base: q2.BIT, prefixes: I2.BINARY_LONG, value: 8, offset: 0 } }, j2 = { meters: "meter", inches: "inch", feet: "foot", yards: "yard", miles: "mile", links: "link", rods: "rod", chains: "chain", angstroms: "angstrom", lt: "l", litres: "litre", liter: "litre", liters: "litre", teaspoons: "teaspoon", tablespoons: "tablespoon", minims: "minim", fldr: "fluiddram", fluiddrams: "fluiddram", floz: "fluidounce", fluidounces: "fluidounce", gi: "gill", gills: "gill", cp: "cup", cups: "cup", pt: "pint", pints: "pint", qt: "quart", quarts: "quart", gal: "gallon", gallons: "gallon", bbl: "beerbarrel", beerbarrels: "beerbarrel", obl: "oilbarrel", oilbarrels: "oilbarrel", hogsheads: "hogshead", gtts: "gtt", grams: "gram", tons: "ton", tonnes: "tonne", grains: "grain", drams: "dram", ounces: "ounce", poundmasses: "poundmass", hundredweights: "hundredweight", sticks: "stick", lb: "lbm", lbs: "lbm", kips: "kip", kgf: "kilogramforce", acres: "acre", hectares: "hectare", sqfeet: "sqft", sqyard: "sqyd", sqmile: "sqmi", sqmiles: "sqmi", mmhg: "mmHg", mmh2o: "mmH2O", cmh2o: "cmH2O", seconds: "second", secs: "second", minutes: "minute", mins: "minute", hours: "hour", hr: "hour", hrs: "hour", days: "day", weeks: "week", months: "month", years: "year", decades: "decade", centuries: "century", millennia: "millennium", hertz: "hertz", radians: "radian", degrees: "degree", gradians: "gradian", cycles: "cycle", arcsecond: "arcsec", arcseconds: "arcsec", arcminute: "arcmin", arcminutes: "arcmin", BTUs: "BTU", watts: "watt", joules: "joule", amperes: "ampere", amps: "ampere", amp: "ampere", coulombs: "coulomb", volts: "volt", ohms: "ohm", farads: "farad", webers: "weber", teslas: "tesla", electronvolts: "electronvolt", moles: "mole", bit: "bits", byte: "bytes" };
  function U2(e3) {
    if ("BigNumber" === e3.number) {
      var t3 = createBigNumberPi$1(x2);
      L2.rad.value = new x2(1), L2.deg.value = t3.div(180), L2.grad.value = t3.div(200), L2.cycle.value = t3.times(2), L2.arcsec.value = t3.div(648e3), L2.arcmin.value = t3.div(10800);
    } else L2.rad.value = 1, L2.deg.value = Math.PI / 180, L2.grad.value = Math.PI / 200, L2.cycle.value = 2 * Math.PI, L2.arcsec.value = Math.PI / 648e3, L2.arcmin.value = Math.PI / 10800;
    L2.radian.value = L2.rad.value, L2.degree.value = L2.deg.value, L2.gradian.value = L2.grad.value;
  }
  U2(a), i2 && i2("config", (function(e3, t3) {
    e3.number !== t3.number && U2(e3);
  }));
  var Z2 = { si: { NONE: { unit: P2, prefix: I2.NONE[""] }, LENGTH: { unit: L2.m, prefix: I2.SHORT[""] }, MASS: { unit: L2.g, prefix: I2.SHORT.k }, TIME: { unit: L2.s, prefix: I2.SHORT[""] }, CURRENT: { unit: L2.A, prefix: I2.SHORT[""] }, TEMPERATURE: { unit: L2.K, prefix: I2.SHORT[""] }, LUMINOUS_INTENSITY: { unit: L2.cd, prefix: I2.SHORT[""] }, AMOUNT_OF_SUBSTANCE: { unit: L2.mol, prefix: I2.SHORT[""] }, ANGLE: { unit: L2.rad, prefix: I2.SHORT[""] }, BIT: { unit: L2.bits, prefix: I2.SHORT[""] }, FORCE: { unit: L2.N, prefix: I2.SHORT[""] }, ENERGY: { unit: L2.J, prefix: I2.SHORT[""] }, POWER: { unit: L2.W, prefix: I2.SHORT[""] }, PRESSURE: { unit: L2.Pa, prefix: I2.SHORT[""] }, ELECTRIC_CHARGE: { unit: L2.C, prefix: I2.SHORT[""] }, ELECTRIC_CAPACITANCE: { unit: L2.F, prefix: I2.SHORT[""] }, ELECTRIC_POTENTIAL: { unit: L2.V, prefix: I2.SHORT[""] }, ELECTRIC_RESISTANCE: { unit: L2.ohm, prefix: I2.SHORT[""] }, ELECTRIC_INDUCTANCE: { unit: L2.H, prefix: I2.SHORT[""] }, ELECTRIC_CONDUCTANCE: { unit: L2.S, prefix: I2.SHORT[""] }, MAGNETIC_FLUX: { unit: L2.Wb, prefix: I2.SHORT[""] }, MAGNETIC_FLUX_DENSITY: { unit: L2.T, prefix: I2.SHORT[""] }, FREQUENCY: { unit: L2.Hz, prefix: I2.SHORT[""] } } };
  Z2.cgs = JSON.parse(JSON.stringify(Z2.si)), Z2.cgs.LENGTH = { unit: L2.m, prefix: I2.SHORT.c }, Z2.cgs.MASS = { unit: L2.g, prefix: I2.SHORT[""] }, Z2.cgs.FORCE = { unit: L2.dyn, prefix: I2.SHORT[""] }, Z2.cgs.ENERGY = { unit: L2.erg, prefix: I2.NONE[""] }, Z2.us = JSON.parse(JSON.stringify(Z2.si)), Z2.us.LENGTH = { unit: L2.ft, prefix: I2.NONE[""] }, Z2.us.MASS = { unit: L2.lbm, prefix: I2.NONE[""] }, Z2.us.TEMPERATURE = { unit: L2.degF, prefix: I2.NONE[""] }, Z2.us.FORCE = { unit: L2.lbf, prefix: I2.NONE[""] }, Z2.us.ENERGY = { unit: L2.BTU, prefix: I2.BTU[""] }, Z2.us.POWER = { unit: L2.hp, prefix: I2.NONE[""] }, Z2.us.PRESSURE = { unit: L2.psi, prefix: I2.NONE[""] }, Z2.auto = JSON.parse(JSON.stringify(Z2.si));
  var G2 = Z2.auto;
  for (var V2 in N.setUnitSystem = function(e3) {
    if (!hasOwnProperty$1$2(Z2, e3)) throw new Error("Unit system " + e3 + " does not exist. Choices are: " + Object.keys(Z2).join(", "));
    G2 = Z2[e3];
  }, N.getUnitSystem = function() {
    for (var e3 in Z2) if (hasOwnProperty$1$2(Z2, e3) && Z2[e3] === G2) return e3;
  }, N.typeConverters = { BigNumber: function(e3) {
    return null != e3 && e3.isFraction ? new x2(String(e3.n)).div(String(e3.d)).times(String(e3.s)) : new x2(e3 + "");
  }, Fraction: function(e3) {
    return new b2(e3);
  }, Complex: function(e3) {
    return e3;
  }, number: function(e3) {
    return null != e3 && e3.isFraction ? y(e3) : e3;
  } }, N.prototype._numberConverter = function() {
    var e3 = N.typeConverters[this.valueType()];
    if (e3) return e3;
    throw new TypeError('Unsupported Unit value type "' + this.valueType() + '"');
  }, N._getNumberConverter = function(e3) {
    if (!N.typeConverters[e3]) throw new TypeError('Unsupported type "' + e3 + '"');
    return N.typeConverters[e3];
  }, L2) if (hasOwnProperty$1$2(L2, V2)) {
    var H2 = L2[V2];
    H2.dimensions = H2.base.dimensions;
  }
  for (var X2 in j2) if (hasOwnProperty$1$2(j2, X2)) {
    var W2 = L2[j2[X2]], Q2 = {};
    for (var Y2 in W2) hasOwnProperty$1$2(W2, Y2) && (Q2[Y2] = W2[Y2]);
    Q2.name = X2, L2[X2] = Q2;
  }
  return N.isValidAlpha = function(e3) {
    return /^[a-zA-Z]$/.test(e3);
  }, N.createUnit = function(e3, t3) {
    if ("object" != typeof e3) throw new TypeError("createUnit expects first parameter to be of type 'Object'");
    if (t3 && t3.override) {
      for (var r2 in e3) if (hasOwnProperty$1$2(e3, r2) && N.deleteUnit(r2), e3[r2].aliases) for (var n3 = 0; n3 < e3[r2].aliases.length; n3++) N.deleteUnit(e3[r2].aliases[n3]);
    }
    var i3;
    for (var a2 in e3) hasOwnProperty$1$2(e3, a2) && (i3 = N.createUnitSingle(a2, e3[a2]));
    return i3;
  }, N.createUnitSingle = function(e3, t3) {
    if (null == t3 && (t3 = {}), "string" != typeof e3) throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
    if (hasOwnProperty$1$2(L2, e3)) throw new Error('Cannot create unit "' + e3 + '": a unit with that name already exists');
    !(function(e4) {
      for (var t4 = 0; t4 < e4.length; t4++) {
        if (n = e4.charAt(t4), 0 === t4 && !N.isValidAlpha(n)) throw new Error('Invalid unit name (must begin with alpha character): "' + e4 + '"');
        if (t4 > 0 && !N.isValidAlpha(n) && !E(n)) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + e4 + '"');
      }
    })(e3);
    var r2, i3, a2, o2 = null, s2 = [], u2 = 0;
    if (t3 && "Unit" === t3.type) o2 = t3.clone();
    else if ("string" == typeof t3) "" !== t3 && (r2 = t3);
    else {
      if ("object" != typeof t3) throw new TypeError('Cannot create unit "' + e3 + '" from "' + t3.toString() + '": expecting "string" or "Unit" or "Object"');
      r2 = t3.definition, i3 = t3.prefixes, u2 = t3.offset, a2 = t3.baseName, t3.aliases && (s2 = t3.aliases.valueOf());
    }
    if (s2) {
      for (var c3 = 0; c3 < s2.length; c3++) if (hasOwnProperty$1$2(L2, s2[c3])) throw new Error('Cannot create alias "' + s2[c3] + '": a unit with that name already exists');
    }
    if (r2 && "string" == typeof r2 && !o2) try {
      o2 = N.parse(r2, { allowNoUnits: true });
    } catch (t4) {
      throw t4.message = 'Could not create unit "' + e3 + '" from "' + r2 + '": ' + t4.message, t4;
    }
    else r2 && "Unit" === r2.type && (o2 = r2.clone());
    s2 = s2 || [], u2 = u2 || 0, i3 = i3 && i3.toUpperCase && I2[i3.toUpperCase()] || I2.NONE;
    var l2 = {};
    if (o2) {
      l2 = { name: e3, value: o2.value, dimensions: o2.dimensions.slice(0), prefixes: i3, offset: u2 };
      var f3 = false;
      for (var p2 in q2) if (hasOwnProperty$1$2(q2, p2)) {
        for (var m2 = true, d2 = 0; d2 < R2.length; d2++) if (Math.abs((l2.dimensions[d2] || 0) - (q2[p2].dimensions[d2] || 0)) > 1e-12) {
          m2 = false;
          break;
        }
        if (m2) {
          f3 = true, l2.base = q2[p2];
          break;
        }
      }
      if (!f3) {
        a2 = a2 || e3 + "_STUFF";
        var h2 = { dimensions: o2.dimensions.slice(0) };
        h2.key = a2, q2[a2] = h2, G2[a2] = { unit: l2, prefix: I2.NONE[""] }, l2.base = q2[a2];
      }
    } else {
      if (a2 = a2 || e3 + "_STUFF", R2.indexOf(a2) >= 0) throw new Error('Cannot create new base unit "' + e3 + '": a base unit with that name already exists (and cannot be overridden)');
      for (var g2 in R2.push(a2), q2) hasOwnProperty$1$2(q2, g2) && (q2[g2].dimensions[R2.length - 1] = 0);
      for (var y2 = { dimensions: [] }, v3 = 0; v3 < R2.length; v3++) y2.dimensions[v3] = 0;
      y2.dimensions[R2.length - 1] = 1, y2.key = a2, q2[a2] = y2, l2 = { name: e3, value: 1, dimensions: q2[a2].dimensions.slice(0), prefixes: i3, offset: u2, base: q2[a2] }, G2[a2] = { unit: l2, prefix: I2.NONE[""] };
    }
    N.UNITS[e3] = l2;
    for (var x3 = 0; x3 < s2.length; x3++) {
      var b3 = s2[x3], _3 = {};
      for (var w3 in l2) hasOwnProperty$1$2(l2, w3) && (_3[w3] = l2[w3]);
      _3.name = b3, N.UNITS[b3] = _3;
    }
    return delete F.cache, new N(null, e3);
  }, N.deleteUnit = function(e3) {
    delete N.UNITS[e3], delete F.cache;
  }, N.PREFIXES = I2, N.BASE_DIMENSIONS = R2, N.BASE_UNITS = q2, N.UNIT_SYSTEMS = Z2, N.UNITS = L2, N;
}), { isClass: true }), name$2q$1 = "unit", dependencies$2q$1 = ["typed", "Unit"], createUnitFunction$1 = factory$1(name$2q$1, dependencies$2q$1, ((e2) => {
  var { typed: t2, Unit: r } = e2;
  return t2(name$2q$1, { Unit: function(e3) {
    return e3.clone();
  }, string: function(e3) {
    return r.isValuelessUnit(e3) ? new r(null, e3) : r.parse(e3, { allowNoUnits: true });
  }, "number | BigNumber | Fraction | Complex, string | Unit": function(e3, t3) {
    return new r(e3, t3);
  }, "number | BigNumber | Fraction": function(e3) {
    return new r(e3);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$2p$1 = "sparse", dependencies$2p$1 = ["typed", "SparseMatrix"], createSparse$1 = factory$1(name$2p$1, dependencies$2p$1, ((e2) => {
  var { typed: t2, SparseMatrix: r } = e2;
  return t2(name$2p$1, { "": function() {
    return new r([]);
  }, string: function(e3) {
    return new r([], e3);
  }, "Array | Matrix": function(e3) {
    return new r(e3);
  }, "Array | Matrix, string": function(e3, t3) {
    return new r(e3, t3);
  } });
})), name$2o$1 = "createUnit", dependencies$2o$1 = ["typed", "Unit"], createCreateUnit$1 = factory$1(name$2o$1, dependencies$2o$1, ((e2) => {
  var { typed: t2, Unit: r } = e2;
  return t2(name$2o$1, { "Object, Object": function(e3, t3) {
    return r.createUnit(e3, t3);
  }, Object: function(e3) {
    return r.createUnit(e3, {});
  }, "string, Unit | string | Object, Object": function(e3, t3, n) {
    var i2 = {};
    return i2[e3] = t3, r.createUnit(i2, n);
  }, "string, Unit | string | Object": function(e3, t3) {
    var n = {};
    return n[e3] = t3, r.createUnit(n, {});
  }, string: function(e3) {
    var t3 = {};
    return t3[e3] = {}, r.createUnit(t3, {});
  } });
})), name$2n$1 = "acos", dependencies$2n$1 = ["typed", "config", "Complex"], createAcos$1 = factory$1(name$2n$1, dependencies$2n$1, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  return t2(name$2n$1, { number: function(e3) {
    return e3 >= -1 && e3 <= 1 || r.predictable ? Math.acos(e3) : new n(e3, 0).acos();
  }, Complex: function(e3) {
    return e3.acos();
  }, BigNumber: function(e3) {
    return e3.acos();
  } });
})), name$2m$1 = "acosh", dependencies$2m$1 = ["typed", "config", "Complex"], createAcosh$1 = factory$1(name$2m$1, dependencies$2m$1, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  return t2(name$2m$1, { number: function(e3) {
    return e3 >= 1 || r.predictable ? acoshNumber$1(e3) : e3 <= -1 ? new n(Math.log(Math.sqrt(e3 * e3 - 1) - e3), Math.PI) : new n(e3, 0).acosh();
  }, Complex: function(e3) {
    return e3.acosh();
  }, BigNumber: function(e3) {
    return e3.acosh();
  } });
})), name$2l$1 = "acot", dependencies$2l$1 = ["typed", "BigNumber"], createAcot$1 = factory$1(name$2l$1, dependencies$2l$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$2l$1, { number: acotNumber$1, Complex: function(e3) {
    return e3.acot();
  }, BigNumber: function(e3) {
    return new r(1).div(e3).atan();
  } });
})), name$2k$1 = "acoth", dependencies$2k$1 = ["typed", "config", "Complex", "BigNumber"], createAcoth$1 = factory$1(name$2k$1, dependencies$2k$1, ((e2) => {
  var { typed: t2, config: r, Complex: n, BigNumber: i2 } = e2;
  return t2(name$2k$1, { number: function(e3) {
    return e3 >= 1 || e3 <= -1 || r.predictable ? acothNumber$1(e3) : new n(e3, 0).acoth();
  }, Complex: function(e3) {
    return e3.acoth();
  }, BigNumber: function(e3) {
    return new i2(1).div(e3).atanh();
  } });
})), name$2j$1 = "acsc", dependencies$2j$1 = ["typed", "config", "Complex", "BigNumber"], createAcsc$1 = factory$1(name$2j$1, dependencies$2j$1, ((e2) => {
  var { typed: t2, config: r, Complex: n, BigNumber: i2 } = e2;
  return t2(name$2j$1, { number: function(e3) {
    return e3 <= -1 || e3 >= 1 || r.predictable ? acscNumber$1(e3) : new n(e3, 0).acsc();
  }, Complex: function(e3) {
    return e3.acsc();
  }, BigNumber: function(e3) {
    return new i2(1).div(e3).asin();
  } });
})), name$2i$1 = "acsch", dependencies$2i$1 = ["typed", "BigNumber"], createAcsch$1 = factory$1(name$2i$1, dependencies$2i$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$2i$1, { number: acschNumber$1, Complex: function(e3) {
    return e3.acsch();
  }, BigNumber: function(e3) {
    return new r(1).div(e3).asinh();
  } });
})), name$2h$1 = "asec", dependencies$2h$1 = ["typed", "config", "Complex", "BigNumber"], createAsec$1 = factory$1(name$2h$1, dependencies$2h$1, ((e2) => {
  var { typed: t2, config: r, Complex: n, BigNumber: i2 } = e2;
  return t2(name$2h$1, { number: function(e3) {
    return e3 <= -1 || e3 >= 1 || r.predictable ? asecNumber$1(e3) : new n(e3, 0).asec();
  }, Complex: function(e3) {
    return e3.asec();
  }, BigNumber: function(e3) {
    return new i2(1).div(e3).acos();
  } });
})), name$2g$1 = "asech", dependencies$2g$1 = ["typed", "config", "Complex", "BigNumber"], createAsech$1 = factory$1(name$2g$1, dependencies$2g$1, ((e2) => {
  var { typed: t2, config: r, Complex: n, BigNumber: i2 } = e2;
  return t2(name$2g$1, { number: function(e3) {
    if (e3 <= 1 && e3 >= -1 || r.predictable) {
      var t3 = 1 / e3;
      if (t3 > 0 || r.predictable) return asechNumber$1(e3);
      var i3 = Math.sqrt(t3 * t3 - 1);
      return new n(Math.log(i3 - t3), Math.PI);
    }
    return new n(e3, 0).asech();
  }, Complex: function(e3) {
    return e3.asech();
  }, BigNumber: function(e3) {
    return new i2(1).div(e3).acosh();
  } });
})), name$2f$1 = "asin", dependencies$2f$1 = ["typed", "config", "Complex"], createAsin$1 = factory$1(name$2f$1, dependencies$2f$1, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  return t2(name$2f$1, { number: function(e3) {
    return e3 >= -1 && e3 <= 1 || r.predictable ? Math.asin(e3) : new n(e3, 0).asin();
  }, Complex: function(e3) {
    return e3.asin();
  }, BigNumber: function(e3) {
    return e3.asin();
  } });
})), name$2e$1 = "asinh", dependencies$2e$1 = ["typed"], createAsinh$1 = factory$1(name$2e$1, dependencies$2e$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2("asinh", { number: asinhNumber$1, Complex: function(e3) {
    return e3.asinh();
  }, BigNumber: function(e3) {
    return e3.asinh();
  } });
})), name$2d$1 = "atan", dependencies$2d$1 = ["typed"], createAtan$1 = factory$1(name$2d$1, dependencies$2d$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2("atan", { number: function(e3) {
    return Math.atan(e3);
  }, Complex: function(e3) {
    return e3.atan();
  }, BigNumber: function(e3) {
    return e3.atan();
  } });
})), name$2c$1 = "atan2", dependencies$2c$1 = ["typed", "matrix", "equalScalar", "BigNumber", "DenseMatrix", "concat"], createAtan2$1 = factory$1(name$2c$1, dependencies$2c$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, BigNumber: i2, DenseMatrix: a, concat: o } = e2, s = createMatAlgo02xDS0$1({ typed: t2, equalScalar: n }), u = createMatAlgo03xDSf$1({ typed: t2 }), c2 = createMatAlgo09xS0Sf$1({ typed: t2, equalScalar: n }), l = createMatAlgo11xS0s$1({ typed: t2, equalScalar: n }), f2 = createMatAlgo12xSfs$1({ typed: t2, DenseMatrix: a }), p = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: o });
  return t2(name$2c$1, { "number, number": Math.atan2, "BigNumber, BigNumber": (e3, t3) => i2.atan2(e3, t3) }, p({ scalar: "number | BigNumber", SS: c2, DS: u, SD: s, Ss: l, sS: f2 }));
})), name$2b$1 = "atanh", dependencies$2b$1 = ["typed", "config", "Complex"], createAtanh$1 = factory$1(name$2b$1, dependencies$2b$1, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  return t2(name$2b$1, { number: function(e3) {
    return e3 <= 1 && e3 >= -1 || r.predictable ? atanhNumber$1(e3) : new n(e3, 0).atanh();
  }, Complex: function(e3) {
    return e3.atanh();
  }, BigNumber: function(e3) {
    return e3.atanh();
  } });
})), createTrigUnit$1 = factory$1("trigUnit", ["typed"], ((e2) => {
  var { typed: t2 } = e2;
  return { Unit: t2.referToSelf(((e3) => (r) => {
    if (!r.hasBase(r.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
    return t2.find(e3, r.valueType())(r.value);
  })) };
})), name$2a$1 = "cos", dependencies$2a$1 = ["typed"], createCos$1 = factory$1(name$2a$1, dependencies$2a$1, ((e2) => {
  var { typed: t2 } = e2, r = createTrigUnit$1({ typed: t2 });
  return t2(name$2a$1, { number: Math.cos, "Complex | BigNumber": (e3) => e3.cos() }, r);
})), name$29$1 = "cosh", dependencies$29$1 = ["typed"], createCosh$1 = factory$1(name$29$1, dependencies$29$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$29$1, { number: cosh$3$1, "Complex | BigNumber": (e3) => e3.cosh() });
})), name$28$1 = "cot", dependencies$28$1 = ["typed", "BigNumber"], createCot$1 = factory$1(name$28$1, dependencies$28$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2, n = createTrigUnit$1({ typed: t2 });
  return t2(name$28$1, { number: cotNumber$1, Complex: (e3) => e3.cot(), BigNumber: (e3) => new r(1).div(e3.tan()) }, n);
})), name$27$1 = "coth", dependencies$27$1 = ["typed", "BigNumber"], createCoth$1 = factory$1(name$27$1, dependencies$27$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$27$1, { number: cothNumber$1, Complex: (e3) => e3.coth(), BigNumber: (e3) => new r(1).div(e3.tanh()) });
})), name$26$1 = "csc", dependencies$26$1 = ["typed", "BigNumber"], createCsc$1 = factory$1(name$26$1, dependencies$26$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2, n = createTrigUnit$1({ typed: t2 });
  return t2(name$26$1, { number: cscNumber$1, Complex: (e3) => e3.csc(), BigNumber: (e3) => new r(1).div(e3.sin()) }, n);
})), name$25$1 = "csch", dependencies$25$1 = ["typed", "BigNumber"], createCsch$1 = factory$1(name$25$1, dependencies$25$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$25$1, { number: cschNumber$1, Complex: (e3) => e3.csch(), BigNumber: (e3) => new r(1).div(e3.sinh()) });
})), name$24$1 = "sec", dependencies$24$1 = ["typed", "BigNumber"], createSec$1 = factory$1(name$24$1, dependencies$24$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2, n = createTrigUnit$1({ typed: t2 });
  return t2(name$24$1, { number: secNumber$1, Complex: (e3) => e3.sec(), BigNumber: (e3) => new r(1).div(e3.cos()) }, n);
})), name$23$1 = "sech", dependencies$23$1 = ["typed", "BigNumber"], createSech$1 = factory$1(name$23$1, dependencies$23$1, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$23$1, { number: sechNumber$1, Complex: (e3) => e3.sech(), BigNumber: (e3) => new r(1).div(e3.cosh()) });
})), name$22$1 = "sin", dependencies$22$1 = ["typed"], createSin$1 = factory$1(name$22$1, dependencies$22$1, ((e2) => {
  var { typed: t2 } = e2, r = createTrigUnit$1({ typed: t2 });
  return t2(name$22$1, { number: Math.sin, "Complex | BigNumber": (e3) => e3.sin() }, r);
})), name$21$1 = "sinh", dependencies$21$1 = ["typed"], createSinh$1 = factory$1(name$21$1, dependencies$21$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$21$1, { number: sinhNumber$1, "Complex | BigNumber": (e3) => e3.sinh() });
})), name$20$1 = "tan", dependencies$20$1 = ["typed"], createTan$1 = factory$1(name$20$1, dependencies$20$1, ((e2) => {
  var { typed: t2 } = e2, r = createTrigUnit$1({ typed: t2 });
  return t2(name$20$1, { number: Math.tan, "Complex | BigNumber": (e3) => e3.tan() }, r);
})), name$1$$1 = "tanh", dependencies$1$$1 = ["typed"], createTanh$1 = factory$1(name$1$$1, dependencies$1$$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2("tanh", { number: tanh$2$1, "Complex | BigNumber": (e3) => e3.tanh() });
})), name$1_$1 = "setCartesian", dependencies$1_$1 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetCartesian$1 = factory$1(name$1_$1, dependencies$1_$1, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a, DenseMatrix: o } = e2;
  return t2(name$1_$1, { "Array | Matrix, Array | Matrix": function(e3, t3) {
    var s = [];
    if (0 !== n(r(e3), new a(0)) && 0 !== n(r(t3), new a(0))) {
      var u = flatten$4$1(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2), c2 = flatten$4$1(Array.isArray(t3) ? t3 : t3.toArray()).sort(i2);
      s = [];
      for (var l = 0; l < u.length; l++) for (var f2 = 0; f2 < c2.length; f2++) s.push([u[l], c2[f2]]);
    }
    return Array.isArray(e3) && Array.isArray(t3) ? s : new o(s);
  } });
})), name$1Z$1 = "setDifference", dependencies$1Z$1 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetDifference$1 = factory$1(name$1Z$1, dependencies$1Z$1, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a, DenseMatrix: o } = e2;
  return t2(name$1Z$1, { "Array | Matrix, Array | Matrix": function(e3, t3) {
    var s;
    if (0 === n(r(e3), new a(0))) s = [];
    else {
      if (0 === n(r(t3), new a(0))) return flatten$4$1(e3.toArray());
      var u, c2 = identify$1(flatten$4$1(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2)), l = identify$1(flatten$4$1(Array.isArray(t3) ? t3 : t3.toArray()).sort(i2));
      s = [];
      for (var f2 = 0; f2 < c2.length; f2++) {
        u = false;
        for (var p = 0; p < l.length; p++) if (0 === i2(c2[f2].value, l[p].value) && c2[f2].identifier === l[p].identifier) {
          u = true;
          break;
        }
        u || s.push(c2[f2]);
      }
    }
    return Array.isArray(e3) && Array.isArray(t3) ? generalize$1(s) : new o(generalize$1(s));
  } });
})), name$1Y$1 = "setDistinct", dependencies$1Y$1 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetDistinct$1 = factory$1(name$1Y$1, dependencies$1Y$1, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a, DenseMatrix: o } = e2;
  return t2(name$1Y$1, { "Array | Matrix": function(e3) {
    var t3;
    if (0 === n(r(e3), new a(0))) t3 = [];
    else {
      var s = flatten$4$1(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2);
      (t3 = []).push(s[0]);
      for (var u = 1; u < s.length; u++) 0 !== i2(s[u], s[u - 1]) && t3.push(s[u]);
    }
    return Array.isArray(e3) ? t3 : new o(t3);
  } });
})), name$1X$1 = "setIntersect", dependencies$1X$1 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetIntersect$1 = factory$1(name$1X$1, dependencies$1X$1, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a, DenseMatrix: o } = e2;
  return t2(name$1X$1, { "Array | Matrix, Array | Matrix": function(e3, t3) {
    var s;
    if (0 === n(r(e3), new a(0)) || 0 === n(r(t3), new a(0))) s = [];
    else {
      var u = identify$1(flatten$4$1(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2)), c2 = identify$1(flatten$4$1(Array.isArray(t3) ? t3 : t3.toArray()).sort(i2));
      s = [];
      for (var l = 0; l < u.length; l++) for (var f2 = 0; f2 < c2.length; f2++) if (0 === i2(u[l].value, c2[f2].value) && u[l].identifier === c2[f2].identifier) {
        s.push(u[l]);
        break;
      }
    }
    return Array.isArray(e3) && Array.isArray(t3) ? generalize$1(s) : new o(generalize$1(s));
  } });
})), name$1W$1 = "setIsSubset", dependencies$1W$1 = ["typed", "size", "subset", "compareNatural", "Index"], createSetIsSubset$1 = factory$1(name$1W$1, dependencies$1W$1, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a } = e2;
  return t2(name$1W$1, { "Array | Matrix, Array | Matrix": function(e3, t3) {
    if (0 === n(r(e3), new a(0))) return true;
    if (0 === n(r(t3), new a(0))) return false;
    for (var o, s = identify$1(flatten$4$1(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2)), u = identify$1(flatten$4$1(Array.isArray(t3) ? t3 : t3.toArray()).sort(i2)), c2 = 0; c2 < s.length; c2++) {
      o = false;
      for (var l = 0; l < u.length; l++) if (0 === i2(s[c2].value, u[l].value) && s[c2].identifier === u[l].identifier) {
        o = true;
        break;
      }
      if (false === o) return false;
    }
    return true;
  } });
})), name$1V$1 = "setMultiplicity", dependencies$1V$1 = ["typed", "size", "subset", "compareNatural", "Index"], createSetMultiplicity$1 = factory$1(name$1V$1, dependencies$1V$1, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a } = e2;
  return t2(name$1V$1, { "number | BigNumber | Fraction | Complex, Array | Matrix": function(e3, t3) {
    if (0 === n(r(t3), new a(0))) return 0;
    for (var o = flatten$4$1(Array.isArray(t3) ? t3 : t3.toArray()), s = 0, u = 0; u < o.length; u++) 0 === i2(o[u], e3) && s++;
    return s;
  } });
})), name$1U$1 = "setPowerset", dependencies$1U$1 = ["typed", "size", "subset", "compareNatural", "Index"], createSetPowerset$1 = factory$1(name$1U$1, dependencies$1U$1, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a } = e2;
  return t2(name$1U$1, { "Array | Matrix": function(e3) {
    if (0 === n(r(e3), new a(0))) return [];
    for (var t3 = flatten$4$1(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2), s = [], u = 0; u.toString(2).length <= t3.length; ) s.push(o(t3, u.toString(2).split("").reverse())), u++;
    return (function(e4) {
      for (var t4 = [], r2 = e4.length - 1; r2 > 0; r2--) for (var n3 = 0; n3 < r2; n3++) e4[n3].length > e4[n3 + 1].length && (t4 = e4[n3], e4[n3] = e4[n3 + 1], e4[n3 + 1] = t4);
      return e4;
    })(s);
  } });
  function o(e3, t3) {
    for (var r2 = [], n3 = 0; n3 < t3.length; n3++) "1" === t3[n3] && r2.push(e3[n3]);
    return r2;
  }
})), name$1T$1 = "setSize", dependencies$1T$1 = ["typed", "compareNatural"], createSetSize$1 = factory$1(name$1T$1, dependencies$1T$1, ((e2) => {
  var { typed: t2, compareNatural: r } = e2;
  return t2(name$1T$1, { "Array | Matrix": function(e3) {
    return Array.isArray(e3) ? flatten$4$1(e3).length : flatten$4$1(e3.toArray()).length;
  }, "Array | Matrix, boolean": function(e3, t3) {
    if (false === t3 || 0 === e3.length) return Array.isArray(e3) ? flatten$4$1(e3).length : flatten$4$1(e3.toArray()).length;
    for (var n = flatten$4$1(Array.isArray(e3) ? e3 : e3.toArray()).sort(r), i2 = 1, a = 1; a < n.length; a++) 0 !== r(n[a], n[a - 1]) && i2++;
    return i2;
  } });
})), name$1S$1 = "setSymDifference", dependencies$1S$1 = ["typed", "size", "concat", "subset", "setDifference", "Index"], createSetSymDifference$1 = factory$1(name$1S$1, dependencies$1S$1, ((e2) => {
  var { typed: t2, size: r, concat: n, subset: i2, setDifference: a, Index: o } = e2;
  return t2(name$1S$1, { "Array | Matrix, Array | Matrix": function(e3, t3) {
    if (0 === i2(r(e3), new o(0))) return flatten$4$1(t3);
    if (0 === i2(r(t3), new o(0))) return flatten$4$1(e3);
    var s = flatten$4$1(e3), u = flatten$4$1(t3);
    return n(a(s, u), a(u, s));
  } });
})), name$1R$1 = "setUnion", dependencies$1R$1 = ["typed", "size", "concat", "subset", "setIntersect", "setSymDifference", "Index"], createSetUnion$1 = factory$1(name$1R$1, dependencies$1R$1, ((e2) => {
  var { typed: t2, size: r, concat: n, subset: i2, setIntersect: a, setSymDifference: o, Index: s } = e2;
  return t2(name$1R$1, { "Array | Matrix, Array | Matrix": function(e3, t3) {
    if (0 === i2(r(e3), new s(0))) return flatten$4$1(t3);
    if (0 === i2(r(t3), new s(0))) return flatten$4$1(e3);
    var u = flatten$4$1(e3), c2 = flatten$4$1(t3);
    return n(o(u, c2), a(u, c2));
  } });
})), name$1Q$1 = "add", dependencies$1Q$1 = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix", "concat"], createAdd$1 = factory$1(name$1Q$1, dependencies$1Q$1, ((e2) => {
  var { typed: t2, matrix: r, addScalar: n, equalScalar: i2, DenseMatrix: a, SparseMatrix: o, concat: s } = e2, u = createMatAlgo01xDSid$1({ typed: t2 }), c2 = createMatAlgo04xSidSid$1({ typed: t2, equalScalar: i2 }), l = createMatAlgo10xSids$1({ typed: t2, DenseMatrix: a }), f2 = createMatrixAlgorithmSuite$1({ typed: t2, matrix: r, concat: s });
  return t2(name$1Q$1, { "any, any": n, "any, any, ...any": t2.referToSelf(((e3) => (t3, r2, n3) => {
    for (var i3 = e3(t3, r2), a2 = 0; a2 < n3.length; a2++) i3 = e3(i3, n3[a2]);
    return i3;
  })) }, f2({ elop: n, DS: u, SS: c2, Ss: l }));
})), name$1P$1 = "hypot", dependencies$1P$1 = ["typed", "abs", "addScalar", "divideScalar", "multiplyScalar", "sqrt", "smaller", "isPositive"], createHypot$1 = factory$1(name$1P$1, dependencies$1P$1, ((e2) => {
  var { typed: t2, abs: r, addScalar: n, divideScalar: i2, multiplyScalar: a, sqrt: o, smaller: s, isPositive: u } = e2;
  return t2(name$1P$1, { "... number | BigNumber": c2, Array: c2, Matrix: (e3) => c2(flatten$4$1(e3.toArray(), true)) });
  function c2(e3) {
    for (var t3 = 0, c3 = 0, l = 0; l < e3.length; l++) {
      if (isComplex$1(e3[l])) throw new TypeError("Unexpected type of argument to hypot");
      var f2 = r(e3[l]);
      s(c3, f2) ? (t3 = a(t3, a(i2(c3, f2), i2(c3, f2))), t3 = n(t3, 1), c3 = f2) : t3 = n(t3, u(f2) ? a(i2(f2, c3), i2(f2, c3)) : f2);
    }
    return a(c3, o(t3));
  }
})), name$1O$1 = "norm", dependencies$1O$1 = ["typed", "abs", "add", "pow", "conj", "sqrt", "multiply", "equalScalar", "larger", "smaller", "matrix", "ctranspose", "eigs"], createNorm$1 = factory$1(name$1O$1, dependencies$1O$1, ((e2) => {
  var { typed: t2, abs: r, add: n, pow: i2, conj: a, sqrt: o, multiply: s, equalScalar: u, larger: c2, smaller: l, matrix: f2, ctranspose: p, eigs: m } = e2;
  return t2(name$1O$1, { number: Math.abs, Complex: function(e3) {
    return e3.abs();
  }, BigNumber: function(e3) {
    return e3.abs();
  }, boolean: function(e3) {
    return Math.abs(e3);
  }, Array: function(e3) {
    return g(f2(e3), 2);
  }, Matrix: function(e3) {
    return g(e3, 2);
  }, "Array, number | BigNumber | string": function(e3, t3) {
    return g(f2(e3), t3);
  }, "Matrix, number | BigNumber | string": function(e3, t3) {
    return g(e3, t3);
  } });
  function d(e3, t3) {
    if (t3 === Number.POSITIVE_INFINITY || "inf" === t3) return (function(e4) {
      var t4 = 0;
      return e4.forEach((function(e5) {
        var n3 = r(e5);
        c2(n3, t4) && (t4 = n3);
      }), true), t4;
    })(e3);
    if (t3 === Number.NEGATIVE_INFINITY || "-inf" === t3) return (function(e4) {
      var t4;
      return e4.forEach((function(e5) {
        var n3 = r(e5);
        t4 && !l(n3, t4) || (t4 = n3);
      }), true), t4 || 0;
    })(e3);
    if ("fro" === t3) return g(e3, 2);
    if ("number" == typeof t3 && !isNaN(t3)) {
      if (!u(t3, 0)) {
        var a2 = 0;
        return e3.forEach((function(e4) {
          a2 = n(i2(r(e4), t3), a2);
        }), true), i2(a2, 1 / t3);
      }
      return Number.POSITIVE_INFINITY;
    }
    throw new Error("Unsupported parameter value");
  }
  function h(e3, t3) {
    if (1 === t3) return (function(e4) {
      var t4 = [], i3 = 0;
      return e4.forEach((function(e5, a2) {
        var o2 = a2[1], s2 = n(t4[o2] || 0, r(e5));
        c2(s2, i3) && (i3 = s2), t4[o2] = s2;
      }), true), i3;
    })(e3);
    if (t3 === Number.POSITIVE_INFINITY || "inf" === t3) return (function(e4) {
      var t4 = [], i3 = 0;
      return e4.forEach((function(e5, a2) {
        var o2 = a2[0], s2 = n(t4[o2] || 0, r(e5));
        c2(s2, i3) && (i3 = s2), t4[o2] = s2;
      }), true), i3;
    })(e3);
    if ("fro" === t3) return (function(e4) {
      var t4 = 0;
      return e4.forEach((function(e5, r2) {
        t4 = n(t4, s(e5, a(e5)));
      })), r(o(t4));
    })(e3);
    if (2 === t3) return (function(e4) {
      var t4 = e4.size();
      if (t4[0] !== t4[1]) throw new RangeError("Invalid matrix dimensions");
      var n3 = p(e4), i3 = s(n3, e4), a2 = m(i3).values.toArray(), u2 = a2[a2.length - 1];
      return r(o(u2));
    })(e3);
    throw new Error("Unsupported parameter value " + t3);
  }
  function g(e3, t3) {
    var r2 = e3.size();
    if (1 === r2.length) return d(e3, t3);
    if (2 === r2.length) {
      if (r2[0] && r2[1]) return h(e3, t3);
      throw new RangeError("Invalid matrix dimensions");
    }
  }
})), name$1N$1 = "dot", dependencies$1N$1 = ["typed", "addScalar", "multiplyScalar", "conj", "size"], createDot$1 = factory$1(name$1N$1, dependencies$1N$1, ((e2) => {
  var { typed: t2, addScalar: r, multiplyScalar: n, conj: i2, size: a } = e2;
  return t2(name$1N$1, { "Array | DenseMatrix, Array | DenseMatrix": function(e3, s) {
    var u = o(e3, s), c2 = isMatrix$1(e3) ? e3._data : e3, l = isMatrix$1(e3) ? e3._datatype || e3.getDataType() : void 0, f2 = isMatrix$1(s) ? s._data : s, p = isMatrix$1(s) ? s._datatype || s.getDataType() : void 0, m = 2 === a(e3).length, d = 2 === a(s).length, h = r, g = n;
    if (l && p && l === p && "string" == typeof l && "mixed" !== l) {
      var y = l;
      h = t2.find(r, [y, y]), g = t2.find(n, [y, y]);
    }
    if (!m && !d) {
      for (var v2 = g(i2(c2[0]), f2[0]), x2 = 1; x2 < u; x2++) v2 = h(v2, g(i2(c2[x2]), f2[x2]));
      return v2;
    }
    if (!m && d) {
      for (var b2 = g(i2(c2[0]), f2[0][0]), _2 = 1; _2 < u; _2++) b2 = h(b2, g(i2(c2[_2]), f2[_2][0]));
      return b2;
    }
    if (m && !d) {
      for (var w2 = g(i2(c2[0][0]), f2[0]), A2 = 1; A2 < u; A2++) w2 = h(w2, g(i2(c2[A2][0]), f2[A2]));
      return w2;
    }
    if (m && d) {
      for (var N = g(i2(c2[0][0]), f2[0][0]), D = 1; D < u; D++) N = h(N, g(i2(c2[D][0]), f2[D][0]));
      return N;
    }
  }, "SparseMatrix, SparseMatrix": function(e3, t3) {
    o(e3, t3);
    var i3 = e3._index, a2 = e3._values, s = t3._index, u = t3._values, c2 = 0, l = r, f2 = n, p = 0, m = 0;
    for (; p < i3.length && m < s.length; ) {
      var d = i3[p], h = s[m];
      d < h ? p++ : d > h ? m++ : d === h && (c2 = l(c2, f2(a2[p], u[m])), p++, m++);
    }
    return c2;
  } });
  function o(e3, t3) {
    var r2, n3, i3 = a(e3), o2 = a(t3);
    if (1 === i3.length) r2 = i3[0];
    else {
      if (2 !== i3.length || 1 !== i3[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + i3.join(", ") + ")");
      r2 = i3[0];
    }
    if (1 === o2.length) n3 = o2[0];
    else {
      if (2 !== o2.length || 1 !== o2[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + o2.join(", ") + ")");
      n3 = o2[0];
    }
    if (r2 !== n3) throw new RangeError("Vectors must have equal length (" + r2 + " != " + n3 + ")");
    if (0 === r2) throw new RangeError("Cannot calculate the dot product of empty vectors");
    return r2;
  }
})), name$1M$1 = "trace", dependencies$1M$1 = ["typed", "matrix", "add"], createTrace$1 = factory$1(name$1M$1, dependencies$1M$1, ((e2) => {
  var { typed: t2, matrix: r, add: n } = e2;
  return t2("trace", { Array: function(e3) {
    return i2(r(e3));
  }, SparseMatrix: function(e3) {
    var t3 = e3._values, r2 = e3._index, i3 = e3._ptr, a = e3._size, o = a[0], s = a[1];
    if (o === s) {
      var u = 0;
      if (t3.length > 0) for (var c2 = 0; c2 < s; c2++) for (var l = i3[c2], f2 = i3[c2 + 1], p = l; p < f2; p++) {
        var m = r2[p];
        if (m === c2) {
          u = n(u, t3[p]);
          break;
        }
        if (m > c2) break;
      }
      return u;
    }
    throw new RangeError("Matrix must be square (size: " + format$3(a) + ")");
  }, DenseMatrix: i2, any: clone$3$1 });
  function i2(e3) {
    var t3 = e3._size, r2 = e3._data;
    switch (t3.length) {
      case 1:
        if (1 === t3[0]) return clone$3$1(r2[0]);
        throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
      case 2:
        var i3 = t3[0];
        if (i3 === t3[1]) {
          for (var a = 0, o = 0; o < i3; o++) a = n(a, r2[o][o]);
          return a;
        }
        throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + format$3(t3) + ")");
    }
  }
})), name$1L$1 = "index", dependencies$1L$1 = ["typed", "Index"], createIndex$1 = factory$1(name$1L$1, dependencies$1L$1, ((e2) => {
  var { typed: t2, Index: r } = e2;
  return t2(name$1L$1, { "...number | string | BigNumber | Range | Array | Matrix": function(e3) {
    var t3 = e3.map((function(e4) {
      return isBigNumber$1(e4) ? e4.toNumber() : isArray$1$1(e4) || isMatrix$1(e4) ? e4.map((function(e5) {
        return isBigNumber$1(e5) ? e5.toNumber() : e5;
      })) : e4;
    })), n = new r();
    return r.apply(n, t3), n;
  } });
})), keywords$1 = /* @__PURE__ */ new Set(["end"]), name$1K$1 = "Node", dependencies$1K$1 = ["mathWithTransform"], createNode$1 = factory$1(name$1K$1, dependencies$1K$1, ((e2) => {
  var { mathWithTransform: t2 } = e2;
  return class {
    get type() {
      return "Node";
    }
    get isNode() {
      return true;
    }
    evaluate(e3) {
      return this.compile().evaluate(e3);
    }
    compile() {
      var e3 = this._compile(t2, {}), r = {};
      return { evaluate: function(t3) {
        var n = createMap$1$1(t3);
        return (function(e4) {
          for (var t4 of [...keywords$1]) if (e4.has(t4)) throw new Error('Scope contains an illegal symbol, "' + t4 + '" is a reserved keyword');
        })(n), e3(n, r, null);
      } };
    }
    _compile(e3, t3) {
      throw new Error("Method _compile must be implemented by type " + this.type);
    }
    forEach(e3) {
      throw new Error("Cannot run forEach on a Node interface");
    }
    map(e3) {
      throw new Error("Cannot run map on a Node interface");
    }
    _ifNode(e3) {
      if (!isNode$2(e3)) throw new TypeError("Callback function must return a Node");
      return e3;
    }
    traverse(e3) {
      e3(this, null, null), (function e4(t3, r) {
        t3.forEach((function(t4, n, i2) {
          r(t4, n, i2), e4(t4, r);
        }));
      })(this, e3);
    }
    transform(e3) {
      return (function t3(r, n, i2) {
        var a = e3(r, n, i2);
        return a !== r ? a : r.map(t3);
      })(this, null, null);
    }
    filter(e3) {
      var t3 = [];
      return this.traverse((function(r, n, i2) {
        e3(r, n, i2) && t3.push(r);
      })), t3;
    }
    clone() {
      throw new Error("Cannot clone a Node interface");
    }
    cloneDeep() {
      return this.map((function(e3) {
        return e3.cloneDeep();
      }));
    }
    equals(e3) {
      return !!e3 && (this.type === e3.type && deepStrictEqual$1(this, e3));
    }
    toString(e3) {
      var t3 = this._getCustomString(e3);
      return void 0 !== t3 ? t3 : this._toString(e3);
    }
    _toString() {
      throw new Error("_toString not implemented for " + this.type);
    }
    toJSON() {
      throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
    }
    toHTML(e3) {
      var t3 = this._getCustomString(e3);
      return void 0 !== t3 ? t3 : this._toHTML(e3);
    }
    _toHTML() {
      throw new Error("_toHTML not implemented for " + this.type);
    }
    toTex(e3) {
      var t3 = this._getCustomString(e3);
      return void 0 !== t3 ? t3 : this._toTex(e3);
    }
    _toTex(e3) {
      throw new Error("_toTex not implemented for " + this.type);
    }
    _getCustomString(e3) {
      if (e3 && "object" == typeof e3) switch (typeof e3.handler) {
        case "object":
        case "undefined":
          return;
        case "function":
          return e3.handler(this, e3);
        default:
          throw new TypeError("Object or function expected as callback");
      }
    }
    getIdentifier() {
      return this.type;
    }
    getContent() {
      return this;
    }
  };
}), { isClass: true, isNode: true });
function errorTransform$1(e2) {
  return e2 && e2.isIndexError ? new IndexError$1(e2.index + 1, e2.min + 1, void 0 !== e2.max ? e2.max + 1 : void 0) : e2;
}
function accessFactory$1(e2) {
  var { subset: t2 } = e2;
  return function(e3, r) {
    try {
      if (Array.isArray(e3)) return t2(e3, r);
      if (e3 && "function" == typeof e3.subset) return e3.subset(r);
      if ("string" == typeof e3) return t2(e3, r);
      if ("object" == typeof e3) {
        if (!r.isObjectProperty()) throw new TypeError("Cannot apply a numeric index as object property");
        return getSafeProperty$1(e3, r.getObjectProperty());
      }
      throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  };
}
var name$1J$1 = "AccessorNode", dependencies$1J$1 = ["subset", "Node"], createAccessorNode$1 = factory$1(name$1J$1, dependencies$1J$1, ((e2) => {
  var { subset: t2, Node: r } = e2, n = accessFactory$1({ subset: t2 });
  function i2(e3) {
    return !(isAccessorNode$1(e3) || isArrayNode$1(e3) || isConstantNode$1(e3) || isFunctionNode$1(e3) || isObjectNode$1(e3) || isParenthesisNode$1(e3) || isSymbolNode$1(e3));
  }
  class a extends r {
    constructor(e3, t3) {
      var r2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      if (super(), !isNode$2(e3)) throw new TypeError('Node expected for parameter "object"');
      if (!isIndexNode$1(t3)) throw new TypeError('IndexNode expected for parameter "index"');
      this.object = e3, this.index = t3, this.optionalChaining = r2;
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return name$1J$1;
    }
    get isAccessorNode() {
      return true;
    }
    _compile(e3, t3) {
      var r2 = this.object._compile(e3, t3), i3 = this.index._compile(e3, t3), a2 = this.optionalChaining, o = isAccessorNode$1(this.object) && this.object.optionalChaining;
      if (this.index.isObjectProperty()) {
        var s = this.index.getObjectProperty();
        return function(e4, t4, n3) {
          var i4 = n3 || {}, u = r2(e4, t4, i4);
          if (a2 && null == u) i4.optionalShortCircuit = true;
          else if (!o || null == i4 || !i4.optionalShortCircuit) return getSafeProperty$1(u, s);
        };
      }
      return function(e4, t4, s2) {
        var u = s2 || {}, c2 = r2(e4, t4, u);
        if (a2 && null == c2) u.optionalShortCircuit = true;
        else if (!o || null == u || !u.optionalShortCircuit) {
          var l = i3(e4, t4, c2);
          return n(c2, l);
        }
      };
    }
    forEach(e3) {
      e3(this.object, "object", this), e3(this.index, "index", this);
    }
    map(e3) {
      return new a(this._ifNode(e3(this.object, "object", this)), this._ifNode(e3(this.index, "index", this)), this.optionalChaining);
    }
    clone() {
      return new a(this.object, this.index, this.optionalChaining);
    }
    _toString(e3) {
      var t3 = this.object.toString(e3);
      return i2(this.object) && (t3 = "(" + t3 + ")"), t3 + (this.optionalChaining ? this.index.dotNotation ? "?" : "?." : "") + this.index.toString(e3);
    }
    _toHTML(e3) {
      var t3 = this.object.toHTML(e3);
      return i2(this.object) && (t3 = '<span class="math-parenthesis math-round-parenthesis">(</span>' + t3 + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t3 + this.index.toHTML(e3);
    }
    _toTex(e3) {
      var t3 = this.object.toTex(e3);
      return i2(this.object) && (t3 = "\\left(' + object + '\\right)"), t3 + this.index.toTex(e3);
    }
    toJSON() {
      return { mathjs: name$1J$1, object: this.object, index: this.index, optionalChaining: this.optionalChaining };
    }
    static fromJSON(e3) {
      return new a(e3.object, e3.index, e3.optionalChaining);
    }
  }
  return _defineProperty$3(a, "name", name$1J$1), a;
}), { isClass: true, isNode: true }), name$1I$1 = "ArrayNode", dependencies$1I$1 = ["Node"], createArrayNode$1 = factory$1(name$1I$1, dependencies$1I$1, ((e2) => {
  var { Node: t2 } = e2;
  class r extends t2 {
    constructor(e3) {
      if (super(), this.items = e3 || [], !Array.isArray(this.items) || !this.items.every(isNode$2)) throw new TypeError("Array containing Nodes expected");
    }
    get type() {
      return name$1I$1;
    }
    get isArrayNode() {
      return true;
    }
    _compile(e3, t3) {
      var r2 = map$1$1(this.items, (function(r3) {
        return r3._compile(e3, t3);
      }));
      if ("Array" !== e3.config.matrix) {
        var n = e3.matrix;
        return function(e4, t4, i2) {
          return n(map$1$1(r2, (function(r3) {
            return r3(e4, t4, i2);
          })));
        };
      }
      return function(e4, t4, n3) {
        return map$1$1(r2, (function(r3) {
          return r3(e4, t4, n3);
        }));
      };
    }
    forEach(e3) {
      for (var t3 = 0; t3 < this.items.length; t3++) {
        e3(this.items[t3], "items[" + t3 + "]", this);
      }
    }
    map(e3) {
      for (var t3 = [], n = 0; n < this.items.length; n++) t3[n] = this._ifNode(e3(this.items[n], "items[" + n + "]", this));
      return new r(t3);
    }
    clone() {
      return new r(this.items.slice(0));
    }
    _toString(e3) {
      return "[" + this.items.map((function(t3) {
        return t3.toString(e3);
      })).join(", ") + "]";
    }
    toJSON() {
      return { mathjs: name$1I$1, items: this.items };
    }
    static fromJSON(e3) {
      return new r(e3.items);
    }
    _toHTML(e3) {
      return '<span class="math-parenthesis math-square-parenthesis">[</span>' + this.items.map((function(t3) {
        return t3.toHTML(e3);
      })).join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    _toTex(e3) {
      return (function t3(r2, n) {
        var i2 = r2.some(isArrayNode$1) && !r2.every(isArrayNode$1), a = n || i2, o = a ? "&" : "\\\\", s = r2.map((function(r3) {
          return r3.items ? t3(r3.items, !n) : r3.toTex(e3);
        })).join(o);
        return i2 || !a || a && !n ? "\\begin{bmatrix}" + s + "\\end{bmatrix}" : s;
      })(this.items, false);
    }
  }
  return _defineProperty$3(r, "name", name$1I$1), r;
}), { isClass: true, isNode: true });
function assignFactory$1(e2) {
  var { subset: t2, matrix: r } = e2;
  return function(e3, n, i2) {
    try {
      if (Array.isArray(e3)) return r(e3).subset(n, i2).valueOf().forEach(((t3, r2) => {
        e3[r2] = t3;
      })), e3;
      if (e3 && "function" == typeof e3.subset) return e3.subset(n, i2);
      if ("string" == typeof e3) return t2(e3, n, i2);
      if ("object" == typeof e3) {
        if (!n.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
        return setSafeProperty$1(e3, n.getObjectProperty(), i2), e3;
      }
      throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  };
}
var properties$1 = [{ AssignmentNode: {}, FunctionAssignmentNode: {} }, { ConditionalNode: { latexLeftParens: false, latexRightParens: false, latexParens: false } }, { "OperatorNode:or": { op: "or", associativity: "left", associativeWith: [] } }, { "OperatorNode:xor": { op: "xor", associativity: "left", associativeWith: [] } }, { "OperatorNode:and": { op: "and", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitOr": { op: "|", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitXor": { op: "^|", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitAnd": { op: "&", associativity: "left", associativeWith: [] } }, { "OperatorNode:equal": { op: "==", associativity: "left", associativeWith: [] }, "OperatorNode:unequal": { op: "!=", associativity: "left", associativeWith: [] }, "OperatorNode:smaller": { op: "<", associativity: "left", associativeWith: [] }, "OperatorNode:larger": { op: ">", associativity: "left", associativeWith: [] }, "OperatorNode:smallerEq": { op: "<=", associativity: "left", associativeWith: [] }, "OperatorNode:largerEq": { op: ">=", associativity: "left", associativeWith: [] }, RelationalNode: { associativity: "left", associativeWith: [] } }, { "OperatorNode:leftShift": { op: "<<", associativity: "left", associativeWith: [] }, "OperatorNode:rightArithShift": { op: ">>", associativity: "left", associativeWith: [] }, "OperatorNode:rightLogShift": { op: ">>>", associativity: "left", associativeWith: [] } }, { "OperatorNode:to": { op: "to", associativity: "left", associativeWith: [] } }, { RangeNode: {} }, { "OperatorNode:add": { op: "+", associativity: "left", associativeWith: ["OperatorNode:add", "OperatorNode:subtract"] }, "OperatorNode:subtract": { op: "-", associativity: "left", associativeWith: [] } }, { "OperatorNode:multiply": { op: "*", associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"] }, "OperatorNode:divide": { op: "/", associativity: "left", associativeWith: [], latexLeftParens: false, latexRightParens: false, latexParens: false }, "OperatorNode:dotMultiply": { op: ".*", associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "OperatorNode:dotMultiply", "OperatorNode:doDivide"] }, "OperatorNode:dotDivide": { op: "./", associativity: "left", associativeWith: [] }, "OperatorNode:mod": { op: "mod", associativity: "left", associativeWith: [] } }, { "OperatorNode:multiply": { associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"] } }, { "OperatorNode:unaryPlus": { op: "+", associativity: "right" }, "OperatorNode:unaryMinus": { op: "-", associativity: "right" }, "OperatorNode:bitNot": { op: "~", associativity: "right" }, "OperatorNode:not": { op: "not", associativity: "right" } }, { "OperatorNode:pow": { op: "^", associativity: "right", associativeWith: [], latexRightParens: false }, "OperatorNode:dotPow": { op: ".^", associativity: "right", associativeWith: [] } }, { "OperatorNode:nullish": { op: "??", associativity: "left", associativeWith: [] } }, { "OperatorNode:factorial": { op: "!", associativity: "left" } }, { "OperatorNode:ctranspose": { op: "'", associativity: "left" } }];
function unwrapParen$1(e2, t2) {
  if (!t2 || "auto" !== t2) return e2;
  for (var r = e2; isParenthesisNode$1(r); ) r = r.content;
  return r;
}
function getPrecedence$1(e2, t2, r, n) {
  var i2 = e2;
  "keep" !== t2 && (i2 = e2.getContent());
  for (var a = i2.getIdentifier(), o = null, s = 0; s < properties$1.length; s++) if (a in properties$1[s]) {
    o = s;
    break;
  }
  if ("OperatorNode:multiply" === a && i2.implicit && "show" !== r) {
    var u = unwrapParen$1(i2.args[0], t2);
    isConstantNode$1(u) && n && "OperatorNode:divide" === n.getIdentifier() && rule2Node$1(unwrapParen$1(n.args[0], t2)) || "OperatorNode:divide" === u.getIdentifier() && rule2Node$1(unwrapParen$1(u.args[0], t2)) && isConstantNode$1(unwrapParen$1(u.args[1])) || (o += 1);
  }
  return o;
}
function getAssociativity$1(e2, t2) {
  var r = e2;
  "keep" !== t2 && (r = e2.getContent());
  var n = r.getIdentifier(), i2 = getPrecedence$1(r, t2);
  if (null === i2) return null;
  var a = properties$1[i2][n];
  if (hasOwnProperty$1$2(a, "associativity")) {
    if ("left" === a.associativity) return "left";
    if ("right" === a.associativity) return "right";
    throw Error("'" + n + "' has the invalid associativity '" + a.associativity + "'.");
  }
  return null;
}
function isAssociativeWith$1(e2, t2, r) {
  var n = "keep" !== r ? e2.getContent() : e2, i2 = "keep" !== r ? e2.getContent() : t2, a = n.getIdentifier(), o = i2.getIdentifier(), s = getPrecedence$1(n, r);
  if (null === s) return null;
  var u = properties$1[s][a];
  if (hasOwnProperty$1$2(u, "associativeWith") && u.associativeWith instanceof Array) {
    for (var c2 = 0; c2 < u.associativeWith.length; c2++) if (u.associativeWith[c2] === o) return true;
    return false;
  }
  return null;
}
function getOperator$1(e2) {
  var t2 = "OperatorNode:" + e2;
  for (var r of properties$1) if (t2 in r) return r[t2].op;
  return null;
}
var name$1H$1 = "AssignmentNode", dependencies$1H$1 = ["subset", "?matrix", "Node"], createAssignmentNode$1 = factory$1(name$1H$1, dependencies$1H$1, ((e2) => {
  var { subset: t2, matrix: r, Node: n } = e2, i2 = accessFactory$1({ subset: t2 }), a = assignFactory$1({ subset: t2, matrix: r });
  function o(e3, t3, r2) {
    t3 || (t3 = "keep");
    var n3 = getPrecedence$1(e3, t3, r2), i3 = getPrecedence$1(e3.value, t3, r2);
    return "all" === t3 || null !== i3 && i3 <= n3;
  }
  class s extends n {
    constructor(e3, t3, r2) {
      if (super(), this.object = e3, this.index = r2 ? t3 : null, this.value = r2 || t3, !isSymbolNode$1(e3) && !isAccessorNode$1(e3)) throw new TypeError('SymbolNode or AccessorNode expected as "object"');
      if (isSymbolNode$1(e3) && "end" === e3.name) throw new Error('Cannot assign to symbol "end"');
      if (this.index && !isIndexNode$1(this.index)) throw new TypeError('IndexNode expected as "index"');
      if (!isNode$2(this.value)) throw new TypeError('Node expected as "value"');
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return name$1H$1;
    }
    get isAssignmentNode() {
      return true;
    }
    _compile(e3, t3) {
      var r2 = this.object._compile(e3, t3), n3 = this.index ? this.index._compile(e3, t3) : null, o2 = this.value._compile(e3, t3), s2 = this.object.name;
      if (this.index) {
        if (this.index.isObjectProperty()) {
          var u = this.index.getObjectProperty();
          return function(e4, t4, n4) {
            var i3 = r2(e4, t4, n4), a2 = o2(e4, t4, n4);
            return setSafeProperty$1(i3, u, a2), a2;
          };
        }
        if (isSymbolNode$1(this.object)) return function(e4, t4, i3) {
          var u2 = r2(e4, t4, i3), c3 = o2(e4, t4, i3), l2 = n3(e4, t4, u2);
          return e4.set(s2, a(u2, l2, c3)), c3;
        };
        var c2 = this.object.object._compile(e3, t3);
        if (this.object.index.isObjectProperty()) {
          var l = this.object.index.getObjectProperty();
          return function(e4, t4, r3) {
            var i3 = c2(e4, t4, r3), s3 = getSafeProperty$1(i3, l), u2 = n3(e4, t4, s3), f3 = o2(e4, t4, r3);
            return setSafeProperty$1(i3, l, a(s3, u2, f3)), f3;
          };
        }
        var f2 = this.object.index._compile(e3, t3);
        return function(e4, t4, r3) {
          var s3 = c2(e4, t4, r3), u2 = f2(e4, t4, s3), l2 = i2(s3, u2), p = n3(e4, t4, l2), m = o2(e4, t4, r3);
          return a(s3, u2, a(l2, p, m)), m;
        };
      }
      if (!isSymbolNode$1(this.object)) throw new TypeError("SymbolNode expected as object");
      return function(e4, t4, r3) {
        var n4 = o2(e4, t4, r3);
        return e4.set(s2, n4), n4;
      };
    }
    forEach(e3) {
      e3(this.object, "object", this), this.index && e3(this.index, "index", this), e3(this.value, "value", this);
    }
    map(e3) {
      var t3 = this._ifNode(e3(this.object, "object", this)), r2 = this.index ? this._ifNode(e3(this.index, "index", this)) : null, n3 = this._ifNode(e3(this.value, "value", this));
      return new s(t3, r2, n3);
    }
    clone() {
      return new s(this.object, this.index, this.value);
    }
    _toString(e3) {
      var t3 = this.object.toString(e3), r2 = this.index ? this.index.toString(e3) : "", n3 = this.value.toString(e3);
      return o(this, e3 && e3.parenthesis, e3 && e3.implicit) && (n3 = "(" + n3 + ")"), t3 + r2 + " = " + n3;
    }
    toJSON() {
      return { mathjs: name$1H$1, object: this.object, index: this.index, value: this.value };
    }
    static fromJSON(e3) {
      return new s(e3.object, e3.index, e3.value);
    }
    _toHTML(e3) {
      var t3 = this.object.toHTML(e3), r2 = this.index ? this.index.toHTML(e3) : "", n3 = this.value.toHTML(e3);
      return o(this, e3 && e3.parenthesis, e3 && e3.implicit) && (n3 = '<span class="math-paranthesis math-round-parenthesis">(</span>' + n3 + '<span class="math-paranthesis math-round-parenthesis">)</span>'), t3 + r2 + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + n3;
    }
    _toTex(e3) {
      var t3 = this.object.toTex(e3), r2 = this.index ? this.index.toTex(e3) : "", n3 = this.value.toTex(e3);
      return o(this, e3 && e3.parenthesis, e3 && e3.implicit) && (n3 = "\\left(".concat(n3, "\\right)")), t3 + r2 + "=" + n3;
    }
  }
  return _defineProperty$3(s, "name", name$1H$1), s;
}), { isClass: true, isNode: true }), name$1G$1 = "BlockNode", dependencies$1G$1 = ["ResultSet", "Node"], createBlockNode$1 = factory$1(name$1G$1, dependencies$1G$1, ((e2) => {
  var { ResultSet: t2, Node: r } = e2;
  class n extends r {
    constructor(e3) {
      if (super(), !Array.isArray(e3)) throw new Error("Array expected");
      this.blocks = e3.map((function(e4) {
        var t3 = e4 && e4.node, r2 = !e4 || void 0 === e4.visible || e4.visible;
        if (!isNode$2(t3)) throw new TypeError('Property "node" must be a Node');
        if ("boolean" != typeof r2) throw new TypeError('Property "visible" must be a boolean');
        return { node: t3, visible: r2 };
      }));
    }
    get type() {
      return name$1G$1;
    }
    get isBlockNode() {
      return true;
    }
    _compile(e3, r2) {
      var n3 = map$1$1(this.blocks, (function(t3) {
        return { evaluate: t3.node._compile(e3, r2), visible: t3.visible };
      }));
      return function(e4, r3, i2) {
        var a = [];
        return forEach$1(n3, (function(t3) {
          var n4 = t3.evaluate(e4, r3, i2);
          t3.visible && a.push(n4);
        })), new t2(a);
      };
    }
    forEach(e3) {
      for (var t3 = 0; t3 < this.blocks.length; t3++) e3(this.blocks[t3].node, "blocks[" + t3 + "].node", this);
    }
    map(e3) {
      for (var t3 = [], r2 = 0; r2 < this.blocks.length; r2++) {
        var i2 = this.blocks[r2], a = this._ifNode(e3(i2.node, "blocks[" + r2 + "].node", this));
        t3[r2] = { node: a, visible: i2.visible };
      }
      return new n(t3);
    }
    clone() {
      var e3 = this.blocks.map((function(e4) {
        return { node: e4.node, visible: e4.visible };
      }));
      return new n(e3);
    }
    _toString(e3) {
      return this.blocks.map((function(t3) {
        return t3.node.toString(e3) + (t3.visible ? "" : ";");
      })).join("\n");
    }
    toJSON() {
      return { mathjs: name$1G$1, blocks: this.blocks };
    }
    static fromJSON(e3) {
      return new n(e3.blocks);
    }
    _toHTML(e3) {
      return this.blocks.map((function(t3) {
        return t3.node.toHTML(e3) + (t3.visible ? "" : '<span class="math-separator">;</span>');
      })).join('<span class="math-separator"><br /></span>');
    }
    _toTex(e3) {
      return this.blocks.map((function(t3) {
        return t3.node.toTex(e3) + (t3.visible ? "" : ";");
      })).join("\\;\\;\n");
    }
  }
  return _defineProperty$3(n, "name", name$1G$1), n;
}), { isClass: true, isNode: true }), name$1F$1 = "ConditionalNode", dependencies$1F$1 = ["Node"], createConditionalNode$1 = factory$1(name$1F$1, dependencies$1F$1, ((e2) => {
  var { Node: t2 } = e2;
  class r extends t2 {
    constructor(e3, t3, r2) {
      if (super(), !isNode$2(e3)) throw new TypeError("Parameter condition must be a Node");
      if (!isNode$2(t3)) throw new TypeError("Parameter trueExpr must be a Node");
      if (!isNode$2(r2)) throw new TypeError("Parameter falseExpr must be a Node");
      this.condition = e3, this.trueExpr = t3, this.falseExpr = r2;
    }
    get type() {
      return name$1F$1;
    }
    get isConditionalNode() {
      return true;
    }
    _compile(e3, t3) {
      var r2 = this.condition._compile(e3, t3), n = this.trueExpr._compile(e3, t3), i2 = this.falseExpr._compile(e3, t3);
      return function(e4, t4, a) {
        return (function(e5) {
          if ("number" == typeof e5 || "boolean" == typeof e5 || "string" == typeof e5) return !!e5;
          if (e5) {
            if (isBigNumber$1(e5)) return !e5.isZero();
            if (isComplex$1(e5)) return !(!e5.re && !e5.im);
            if (isUnit$1(e5)) return !!e5.value;
          }
          if (null == e5) return false;
          throw new TypeError('Unsupported type of condition "' + typeOf$1(e5) + '"');
        })(r2(e4, t4, a)) ? n(e4, t4, a) : i2(e4, t4, a);
      };
    }
    forEach(e3) {
      e3(this.condition, "condition", this), e3(this.trueExpr, "trueExpr", this), e3(this.falseExpr, "falseExpr", this);
    }
    map(e3) {
      return new r(this._ifNode(e3(this.condition, "condition", this)), this._ifNode(e3(this.trueExpr, "trueExpr", this)), this._ifNode(e3(this.falseExpr, "falseExpr", this)));
    }
    clone() {
      return new r(this.condition, this.trueExpr, this.falseExpr);
    }
    _toString(e3) {
      var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = getPrecedence$1(this, t3, e3 && e3.implicit), n = this.condition.toString(e3), i2 = getPrecedence$1(this.condition, t3, e3 && e3.implicit);
      ("all" === t3 || "OperatorNode" === this.condition.type || null !== i2 && i2 <= r2) && (n = "(" + n + ")");
      var a = this.trueExpr.toString(e3), o = getPrecedence$1(this.trueExpr, t3, e3 && e3.implicit);
      ("all" === t3 || "OperatorNode" === this.trueExpr.type || null !== o && o <= r2) && (a = "(" + a + ")");
      var s = this.falseExpr.toString(e3), u = getPrecedence$1(this.falseExpr, t3, e3 && e3.implicit);
      return ("all" === t3 || "OperatorNode" === this.falseExpr.type || null !== u && u <= r2) && (s = "(" + s + ")"), n + " ? " + a + " : " + s;
    }
    toJSON() {
      return { mathjs: name$1F$1, condition: this.condition, trueExpr: this.trueExpr, falseExpr: this.falseExpr };
    }
    static fromJSON(e3) {
      return new r(e3.condition, e3.trueExpr, e3.falseExpr);
    }
    _toHTML(e3) {
      var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = getPrecedence$1(this, t3, e3 && e3.implicit), n = this.condition.toHTML(e3), i2 = getPrecedence$1(this.condition, t3, e3 && e3.implicit);
      ("all" === t3 || "OperatorNode" === this.condition.type || null !== i2 && i2 <= r2) && (n = '<span class="math-parenthesis math-round-parenthesis">(</span>' + n + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var a = this.trueExpr.toHTML(e3), o = getPrecedence$1(this.trueExpr, t3, e3 && e3.implicit);
      ("all" === t3 || "OperatorNode" === this.trueExpr.type || null !== o && o <= r2) && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var s = this.falseExpr.toHTML(e3), u = getPrecedence$1(this.falseExpr, t3, e3 && e3.implicit);
      return ("all" === t3 || "OperatorNode" === this.falseExpr.type || null !== u && u <= r2) && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), n + '<span class="math-operator math-conditional-operator">?</span>' + a + '<span class="math-operator math-conditional-operator">:</span>' + s;
    }
    _toTex(e3) {
      return "\\begin{cases} {" + this.trueExpr.toTex(e3) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(e3) + "}\\\\{" + this.falseExpr.toTex(e3) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    }
  }
  return _defineProperty$3(r, "name", name$1F$1), r;
}), { isClass: true, isNode: true }), dist$2, hasRequiredDist$1;
function requireDist$1() {
  if (hasRequiredDist$1) return dist$2;
  hasRequiredDist$1 = 1;
  var e2 = Object.assign || function(e3) {
    for (var t3 = 1; t3 < arguments.length; t3++) {
      var r2 = arguments[t3];
      for (var n3 in r2) Object.prototype.hasOwnProperty.call(r2, n3) && (e3[n3] = r2[n3]);
    }
    return e3;
  }, t2 = { "{": "\\{", "}": "\\}", "\\": "\\textbackslash{}", "#": "\\#", $: "\\$", "%": "\\%", "&": "\\&", "^": "\\textasciicircum{}", _: "\\_", "~": "\\textasciitilde{}" }, r = { "–": "\\--", "—": "\\---", " ": "~", "	": "\\qquad{}", "\r\n": "\\newline{}", "\n": "\\newline{}" }, n = function(t3, r2) {
    return e2({}, t3, r2);
  };
  return dist$2 = function(i2) {
    for (var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = a.preserveFormatting, s = void 0 !== o && o, u = a.escapeMapFn, c2 = void 0 === u ? n : u, l = String(i2), f2 = "", p = c2(e2({}, t2), s ? e2({}, r) : {}), m = Object.keys(p), d = function() {
      var e3 = false;
      m.forEach((function(t3, r2) {
        e3 || l.length >= t3.length && l.slice(0, t3.length) === t3 && (f2 += p[m[r2]], l = l.slice(t3.length, l.length), e3 = true);
      })), e3 || (f2 += l.slice(0, 1), l = l.slice(1, l.length));
    }; l; ) d();
    return f2;
  }, dist$2;
}
var distExports$1 = requireDist$1(), escapeLatexLib$1 = getDefaultExportFromCjs$5(distExports$1), latexSymbols$1 = { Alpha: "A", alpha: "\\alpha", Beta: "B", beta: "\\beta", Gamma: "\\Gamma", gamma: "\\gamma", Delta: "\\Delta", delta: "\\delta", Epsilon: "E", epsilon: "\\epsilon", varepsilon: "\\varepsilon", Zeta: "Z", zeta: "\\zeta", Eta: "H", eta: "\\eta", Theta: "\\Theta", theta: "\\theta", vartheta: "\\vartheta", Iota: "I", iota: "\\iota", Kappa: "K", kappa: "\\kappa", varkappa: "\\varkappa", Lambda: "\\Lambda", lambda: "\\lambda", Mu: "M", mu: "\\mu", Nu: "N", nu: "\\nu", Xi: "\\Xi", xi: "\\xi", Omicron: "O", omicron: "o", Pi: "\\Pi", pi: "\\pi", varpi: "\\varpi", Rho: "P", rho: "\\rho", varrho: "\\varrho", Sigma: "\\Sigma", sigma: "\\sigma", varsigma: "\\varsigma", Tau: "T", tau: "\\tau", Upsilon: "\\Upsilon", upsilon: "\\upsilon", Phi: "\\Phi", phi: "\\phi", varphi: "\\varphi", Chi: "X", chi: "\\chi", Psi: "\\Psi", psi: "\\psi", Omega: "\\Omega", omega: "\\omega", true: "\\mathrm{True}", false: "\\mathrm{False}", i: "i", inf: "\\infty", Inf: "\\infty", infinity: "\\infty", Infinity: "\\infty", oo: "\\infty", lim: "\\lim", undefined: "\\mathbf{?}" }, latexOperators$1 = { transpose: "^\\top", ctranspose: "^H", factorial: "!", pow: "^", dotPow: ".^\\wedge", unaryPlus: "+", unaryMinus: "-", bitNot: "\\~", not: "\\neg", multiply: "\\cdot", divide: "\\frac", dotMultiply: ".\\cdot", dotDivide: ".:", mod: "\\mod", add: "+", subtract: "-", to: "\\rightarrow", leftShift: "<<", rightArithShift: ">>", rightLogShift: ">>>", equal: "=", unequal: "\\neq", smaller: "<", larger: ">", smallerEq: "\\leq", largerEq: "\\geq", bitAnd: "\\&", bitXor: "\\underline{|}", bitOr: "|", and: "\\wedge", xor: "\\veebar", or: "\\vee" }, latexFunctions$1 = { abs: { 1: "\\left|${args[0]}\\right|" }, add: { 2: "\\left(${args[0]}".concat(latexOperators$1.add, "${args[1]}\\right)") }, cbrt: { 1: "\\sqrt[3]{${args[0]}}" }, ceil: { 1: "\\left\\lceil${args[0]}\\right\\rceil" }, cube: { 1: "\\left(${args[0]}\\right)^3" }, divide: { 2: "\\frac{${args[0]}}{${args[1]}}" }, dotDivide: { 2: "\\left(${args[0]}".concat(latexOperators$1.dotDivide, "${args[1]}\\right)") }, dotMultiply: { 2: "\\left(${args[0]}".concat(latexOperators$1.dotMultiply, "${args[1]}\\right)") }, dotPow: { 2: "\\left(${args[0]}".concat(latexOperators$1.dotPow, "${args[1]}\\right)") }, exp: { 1: "\\exp\\left(${args[0]}\\right)" }, expm1: "\\left(e".concat(latexOperators$1.pow, "{${args[0]}}-1\\right)"), fix: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, floor: { 1: "\\left\\lfloor${args[0]}\\right\\rfloor" }, fraction: { 2: "\\frac{${args[0]}}{${args[1]}}" }, gcd: "\\gcd\\left(${args}\\right)", hypot: "\\hypot\\left(${args}\\right)", log: { 1: "\\ln\\left(${args[0]}\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}\\right)" }, log10: { 1: "\\log_{10}\\left(${args[0]}\\right)" }, log1p: { 1: "\\ln\\left(${args[0]}+1\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)" }, log2: "\\log_{2}\\left(${args[0]}\\right)", mod: { 2: "\\left(${args[0]}".concat(latexOperators$1.mod, "${args[1]}\\right)") }, multiply: { 2: "\\left(${args[0]}".concat(latexOperators$1.multiply, "${args[1]}\\right)") }, norm: { 1: "\\left\\|${args[0]}\\right\\|", 2: void 0 }, nthRoot: { 2: "\\sqrt[${args[1]}]{${args[0]}}" }, nthRoots: { 2: "\\{y : y^${args[1]} = {${args[0]}}\\}" }, pow: { 2: "\\left(${args[0]}\\right)".concat(latexOperators$1.pow, "{${args[1]}}") }, round: { 1: "\\left\\lfloor${args[0]}\\right\\rceil", 2: void 0 }, sign: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, sqrt: { 1: "\\sqrt{${args[0]}}" }, square: { 1: "\\left(${args[0]}\\right)^2" }, subtract: { 2: "\\left(${args[0]}".concat(latexOperators$1.subtract, "${args[1]}\\right)") }, unaryMinus: { 1: "".concat(latexOperators$1.unaryMinus, "\\left(${args[0]}\\right)") }, unaryPlus: { 1: "".concat(latexOperators$1.unaryPlus, "\\left(${args[0]}\\right)") }, bitAnd: { 2: "\\left(${args[0]}".concat(latexOperators$1.bitAnd, "${args[1]}\\right)") }, bitNot: { 1: latexOperators$1.bitNot + "\\left(${args[0]}\\right)" }, bitOr: { 2: "\\left(${args[0]}".concat(latexOperators$1.bitOr, "${args[1]}\\right)") }, bitXor: { 2: "\\left(${args[0]}".concat(latexOperators$1.bitXor, "${args[1]}\\right)") }, leftShift: { 2: "\\left(${args[0]}".concat(latexOperators$1.leftShift, "${args[1]}\\right)") }, rightArithShift: { 2: "\\left(${args[0]}".concat(latexOperators$1.rightArithShift, "${args[1]}\\right)") }, rightLogShift: { 2: "\\left(${args[0]}".concat(latexOperators$1.rightLogShift, "${args[1]}\\right)") }, bellNumbers: { 1: "\\mathrm{B}_{${args[0]}}" }, catalan: { 1: "\\mathrm{C}_{${args[0]}}" }, stirlingS2: { 2: "\\mathrm{S}\\left(${args}\\right)" }, arg: { 1: "\\arg\\left(${args[0]}\\right)" }, conj: { 1: "\\left(${args[0]}\\right)^*" }, im: { 1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace" }, re: { 1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace" }, and: { 2: "\\left(${args[0]}".concat(latexOperators$1.and, "${args[1]}\\right)") }, not: { 1: latexOperators$1.not + "\\left(${args[0]}\\right)" }, or: { 2: "\\left(${args[0]}".concat(latexOperators$1.or, "${args[1]}\\right)") }, xor: { 2: "\\left(${args[0]}".concat(latexOperators$1.xor, "${args[1]}\\right)") }, cross: { 2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)" }, ctranspose: { 1: "\\left(${args[0]}\\right)".concat(latexOperators$1.ctranspose) }, det: { 1: "\\det\\left(${args[0]}\\right)" }, dot: { 2: "\\left(${args[0]}\\cdot${args[1]}\\right)" }, expm: { 1: "\\exp\\left(${args[0]}\\right)" }, inv: { 1: "\\left(${args[0]}\\right)^{-1}" }, pinv: { 1: "\\left(${args[0]}\\right)^{+}" }, sqrtm: { 1: "{${args[0]}}".concat(latexOperators$1.pow, "{\\frac{1}{2}}") }, trace: { 1: "\\mathrm{tr}\\left(${args[0]}\\right)" }, transpose: { 1: "\\left(${args[0]}\\right)".concat(latexOperators$1.transpose) }, combinations: { 2: "\\binom{${args[0]}}{${args[1]}}" }, combinationsWithRep: { 2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)" }, factorial: { 1: "\\left(${args[0]}\\right)".concat(latexOperators$1.factorial) }, gamma: { 1: "\\Gamma\\left(${args[0]}\\right)" }, lgamma: { 1: "\\ln\\Gamma\\left(${args[0]}\\right)" }, equal: { 2: "\\left(${args[0]}".concat(latexOperators$1.equal, "${args[1]}\\right)") }, larger: { 2: "\\left(${args[0]}".concat(latexOperators$1.larger, "${args[1]}\\right)") }, largerEq: { 2: "\\left(${args[0]}".concat(latexOperators$1.largerEq, "${args[1]}\\right)") }, smaller: { 2: "\\left(${args[0]}".concat(latexOperators$1.smaller, "${args[1]}\\right)") }, smallerEq: { 2: "\\left(${args[0]}".concat(latexOperators$1.smallerEq, "${args[1]}\\right)") }, unequal: { 2: "\\left(${args[0]}".concat(latexOperators$1.unequal, "${args[1]}\\right)") }, erf: { 1: "erf\\left(${args[0]}\\right)" }, max: "\\max\\left(${args}\\right)", min: "\\min\\left(${args}\\right)", variance: "\\mathrm{Var}\\left(${args}\\right)", acos: { 1: "\\cos^{-1}\\left(${args[0]}\\right)" }, acosh: { 1: "\\cosh^{-1}\\left(${args[0]}\\right)" }, acot: { 1: "\\cot^{-1}\\left(${args[0]}\\right)" }, acoth: { 1: "\\coth^{-1}\\left(${args[0]}\\right)" }, acsc: { 1: "\\csc^{-1}\\left(${args[0]}\\right)" }, acsch: { 1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)" }, asec: { 1: "\\sec^{-1}\\left(${args[0]}\\right)" }, asech: { 1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)" }, asin: { 1: "\\sin^{-1}\\left(${args[0]}\\right)" }, asinh: { 1: "\\sinh^{-1}\\left(${args[0]}\\right)" }, atan: { 1: "\\tan^{-1}\\left(${args[0]}\\right)" }, atan2: { 2: "\\mathrm{atan2}\\left(${args}\\right)" }, atanh: { 1: "\\tanh^{-1}\\left(${args[0]}\\right)" }, cos: { 1: "\\cos\\left(${args[0]}\\right)" }, cosh: { 1: "\\cosh\\left(${args[0]}\\right)" }, cot: { 1: "\\cot\\left(${args[0]}\\right)" }, coth: { 1: "\\coth\\left(${args[0]}\\right)" }, csc: { 1: "\\csc\\left(${args[0]}\\right)" }, csch: { 1: "\\mathrm{csch}\\left(${args[0]}\\right)" }, sec: { 1: "\\sec\\left(${args[0]}\\right)" }, sech: { 1: "\\mathrm{sech}\\left(${args[0]}\\right)" }, sin: { 1: "\\sin\\left(${args[0]}\\right)" }, sinh: { 1: "\\sinh\\left(${args[0]}\\right)" }, tan: { 1: "\\tan\\left(${args[0]}\\right)" }, tanh: { 1: "\\tanh\\left(${args[0]}\\right)" }, to: { 2: "\\left(${args[0]}".concat(latexOperators$1.to, "${args[1]}\\right)") }, numeric: function(e2, t2) {
  return e2.args[0].toTex();
}, number: { 0: "0", 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" }, string: { 0: '\\mathtt{""}', 1: "\\mathrm{string}\\left(${args[0]}\\right)" }, bignumber: { 0: "0", 1: "\\left(${args[0]}\\right)" }, bigint: { 0: "0", 1: "\\left(${args[0]}\\right)" }, complex: { 0: "0", 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)+".concat(latexSymbols$1.i, "\\cdot\\left(${args[1]}\\right)\\right)") }, matrix: { 0: "\\begin{bmatrix}\\end{bmatrix}", 1: "\\left(${args[0]}\\right)", 2: "\\left(${args[0]}\\right)" }, sparse: { 0: "\\begin{bsparse}\\end{bsparse}", 1: "\\left(${args[0]}\\right)" }, unit: { 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" } }, defaultTemplate$1 = "\\mathrm{${name}}\\left(${args}\\right)", latexUnits$1 = { deg: "^\\circ" };
function escapeLatex$1(e2) {
  return escapeLatexLib$1(e2, { preserveFormatting: true });
}
function toSymbol$1(e2, t2) {
  return (t2 = void 0 !== t2 && t2) ? hasOwnProperty$1$2(latexUnits$1, e2) ? latexUnits$1[e2] : "\\mathrm{" + escapeLatex$1(e2) + "}" : hasOwnProperty$1$2(latexSymbols$1, e2) ? latexSymbols$1[e2] : escapeLatex$1(e2);
}
var name$1E$1 = "ConstantNode", dependencies$1E$1 = ["Node", "isBounded"], createConstantNode$1 = factory$1(name$1E$1, dependencies$1E$1, ((e2) => {
  var { Node: t2, isBounded: r } = e2;
  class n extends t2 {
    constructor(e3) {
      super(), this.value = e3;
    }
    get type() {
      return name$1E$1;
    }
    get isConstantNode() {
      return true;
    }
    _compile(e3, t3) {
      var r2 = this.value;
      return function() {
        return r2;
      };
    }
    forEach(e3) {
    }
    map(e3) {
      return this.clone();
    }
    clone() {
      return new n(this.value);
    }
    _toString(e3) {
      return format$3(this.value, e3);
    }
    _toHTML(e3) {
      var t3 = this._toString(e3);
      switch (typeOf$1(this.value)) {
        case "number":
        case "bigint":
        case "BigNumber":
        case "Fraction":
          return '<span class="math-number">' + t3 + "</span>";
        case "string":
          return '<span class="math-string">' + t3 + "</span>";
        case "boolean":
          return '<span class="math-boolean">' + t3 + "</span>";
        case "null":
          return '<span class="math-null-symbol">' + t3 + "</span>";
        case "undefined":
          return '<span class="math-undefined">' + t3 + "</span>";
        default:
          return '<span class="math-symbol">' + t3 + "</span>";
      }
    }
    toJSON() {
      return { mathjs: name$1E$1, value: this.value };
    }
    static fromJSON(e3) {
      return new n(e3.value);
    }
    _toTex(e3) {
      var t3 = this._toString(e3);
      switch (typeOf$1(this.value)) {
        case "string":
          return "\\mathtt{" + escapeLatex$1(t3) + "}";
        case "number":
        case "BigNumber":
          if (!r(this.value)) return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
          var n3 = t3.toLowerCase().indexOf("e");
          return -1 !== n3 ? t3.substring(0, n3) + "\\cdot10^{" + t3.substring(n3 + 1) + "}" : t3;
        case "bigint":
          return t3.toString();
        case "Fraction":
          return this.value.toLatex();
        default:
          return t3;
      }
    }
  }
  return _defineProperty$3(n, "name", name$1E$1), n;
}), { isClass: true, isNode: true }), name$1D$1 = "FunctionAssignmentNode", dependencies$1D$1 = ["typed", "Node"], createFunctionAssignmentNode$1 = factory$1(name$1D$1, dependencies$1D$1, ((e2) => {
  var { typed: t2, Node: r } = e2;
  function n(e3, t3, r2) {
    var n3 = getPrecedence$1(e3, t3, r2), i3 = getPrecedence$1(e3.expr, t3, r2);
    return "all" === t3 || null !== i3 && i3 <= n3;
  }
  class i2 extends r {
    constructor(e3, t3, r2) {
      if (super(), "string" != typeof e3) throw new TypeError('String expected for parameter "name"');
      if (!Array.isArray(t3)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
      if (!isNode$2(r2)) throw new TypeError('Node expected for parameter "expr"');
      if (keywords$1.has(e3)) throw new Error('Illegal function name, "' + e3 + '" is a reserved keyword');
      var n3 = /* @__PURE__ */ new Set();
      for (var i3 of t3) {
        var a = "string" == typeof i3 ? i3 : i3.name;
        if (n3.has(a)) throw new Error('Duplicate parameter name "'.concat(a, '"'));
        n3.add(a);
      }
      this.name = e3, this.params = t3.map((function(e4) {
        return e4 && e4.name || e4;
      })), this.types = t3.map((function(e4) {
        return e4 && e4.type || "any";
      })), this.expr = r2;
    }
    get type() {
      return name$1D$1;
    }
    get isFunctionAssignmentNode() {
      return true;
    }
    _compile(e3, r2) {
      var n3 = Object.create(r2);
      forEach$1(this.params, (function(e4) {
        n3[e4] = true;
      }));
      var i3 = this.expr, a = i3._compile(e3, n3), o = this.name, s = this.params, u = join$5(this.types, ","), c2 = o + "(" + join$5(this.params, ", ") + ")";
      return function(e4, r3, n4) {
        var l = {};
        l[u] = function() {
          for (var t3 = Object.create(r3), i4 = 0; i4 < s.length; i4++) t3[s[i4]] = arguments[i4];
          return a(e4, t3, n4);
        };
        var f2 = t2(o, l);
        return f2.syntax = c2, f2.expr = i3.toString(), e4.set(o, f2), f2;
      };
    }
    forEach(e3) {
      e3(this.expr, "expr", this);
    }
    map(e3) {
      var t3 = this._ifNode(e3(this.expr, "expr", this));
      return new i2(this.name, this.params.slice(0), t3);
    }
    clone() {
      return new i2(this.name, this.params.slice(0), this.expr);
    }
    _toString(e3) {
      var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = this.expr.toString(e3);
      return n(this, t3, e3 && e3.implicit) && (r2 = "(" + r2 + ")"), this.name + "(" + this.params.join(", ") + ") = " + r2;
    }
    toJSON() {
      var e3 = this.types;
      return { mathjs: name$1D$1, name: this.name, params: this.params.map((function(t3, r2) {
        return { name: t3, type: e3[r2] };
      })), expr: this.expr };
    }
    static fromJSON(e3) {
      return new i2(e3.name, e3.params, e3.expr);
    }
    _toHTML(e3) {
      for (var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = [], i3 = 0; i3 < this.params.length; i3++) r2.push('<span class="math-symbol math-parameter">' + escape$1$1(this.params[i3]) + "</span>");
      var a = this.expr.toHTML(e3);
      return n(this, t3, e3 && e3.implicit) && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>'), '<span class="math-function">' + escape$1$1(this.name) + '</span><span class="math-parenthesis math-round-parenthesis">(</span>' + r2.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + a;
    }
    _toTex(e3) {
      var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = this.expr.toTex(e3);
      return n(this, t3, e3 && e3.implicit) && (r2 = "\\left(".concat(r2, "\\right)")), "\\mathrm{" + this.name + "}\\left(" + this.params.map(toSymbol$1).join(",") + "\\right)=" + r2;
    }
  }
  return _defineProperty$3(i2, "name", name$1D$1), i2;
}), { isClass: true, isNode: true }), name$1C$1 = "IndexNode", dependencies$1C$1 = ["Node", "size"], createIndexNode$1 = factory$1(name$1C$1, dependencies$1C$1, ((e2) => {
  var { Node: t2, size: r } = e2;
  class n extends t2 {
    constructor(e3, t3) {
      if (super(), this.dimensions = e3, this.dotNotation = t3 || false, !Array.isArray(e3) || !e3.every(isNode$2)) throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
      if (this.dotNotation && !this.isObjectProperty()) throw new Error("dotNotation only applicable for object properties");
    }
    get type() {
      return name$1C$1;
    }
    get isIndexNode() {
      return true;
    }
    _compile(e3, t3) {
      var n3 = map$1$1(this.dimensions, (function(n4, i3) {
        if (n4.filter(((e4) => e4.isSymbolNode && "end" === e4.name)).length > 0) {
          var a = Object.create(t3);
          a.end = true;
          var o = n4._compile(e3, a);
          return function(e4, t4, n5) {
            if (!isMatrix$1(n5) && !isArray$1$1(n5) && !isString$1$1(n5)) throw new TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + typeOf$1(n5));
            var a2 = r(n5), s = Object.create(t4);
            return s.end = a2[i3], o(e4, s, n5);
          };
        }
        return n4._compile(e3, t3);
      })), i2 = getSafeProperty$1(e3, "index");
      return function(e4, t4, r2) {
        var a = map$1$1(n3, (function(n4) {
          return n4(e4, t4, r2);
        }));
        return i2(...a);
      };
    }
    forEach(e3) {
      for (var t3 = 0; t3 < this.dimensions.length; t3++) e3(this.dimensions[t3], "dimensions[" + t3 + "]", this);
    }
    map(e3) {
      for (var t3 = [], r2 = 0; r2 < this.dimensions.length; r2++) t3[r2] = this._ifNode(e3(this.dimensions[r2], "dimensions[" + r2 + "]", this));
      return new n(t3, this.dotNotation);
    }
    clone() {
      return new n(this.dimensions.slice(0), this.dotNotation);
    }
    isObjectProperty() {
      return 1 === this.dimensions.length && isConstantNode$1(this.dimensions[0]) && "string" == typeof this.dimensions[0].value;
    }
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    _toString(e3) {
      return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    }
    toJSON() {
      return { mathjs: name$1C$1, dimensions: this.dimensions, dotNotation: this.dotNotation };
    }
    static fromJSON(e3) {
      return new n(e3.dimensions, e3.dotNotation);
    }
    _toHTML(e3) {
      for (var t3 = [], r2 = 0; r2 < this.dimensions.length; r2++) t3[r2] = this.dimensions[r2].toHTML();
      return this.dotNotation ? '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + escape$1$1(this.getObjectProperty()) + "</span>" : '<span class="math-parenthesis math-square-parenthesis">[</span>' + t3.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    _toTex(e3) {
      var t3 = this.dimensions.map((function(t4) {
        return t4.toTex(e3);
      }));
      return this.dotNotation ? "." + this.getObjectProperty() : "_{" + t3.join(",") + "}";
    }
  }
  return _defineProperty$3(n, "name", name$1C$1), n;
}), { isClass: true, isNode: true }), name$1B$1 = "ObjectNode", dependencies$1B$1 = ["Node"], createObjectNode$1 = factory$1(name$1B$1, dependencies$1B$1, ((e2) => {
  var { Node: t2 } = e2;
  class r extends t2 {
    constructor(e3) {
      if (super(), this.properties = e3 || {}, e3 && ("object" != typeof e3 || !Object.keys(e3).every((function(t3) {
        return isNode$2(e3[t3]);
      })))) throw new TypeError("Object containing Nodes expected");
    }
    get type() {
      return name$1B$1;
    }
    get isObjectNode() {
      return true;
    }
    _compile(e3, t3) {
      var r2 = {};
      for (var n in this.properties) if (hasOwnProperty$1$2(this.properties, n)) {
        var i2 = stringify$1(n), a = JSON.parse(i2), o = getSafeProperty$1(this.properties, n);
        r2[a] = o._compile(e3, t3);
      }
      return function(e4, t4, n3) {
        var i3 = {};
        for (var a2 in r2) hasOwnProperty$1$2(r2, a2) && (i3[a2] = r2[a2](e4, t4, n3));
        return i3;
      };
    }
    forEach(e3) {
      for (var t3 in this.properties) hasOwnProperty$1$2(this.properties, t3) && e3(this.properties[t3], "properties[" + stringify$1(t3) + "]", this);
    }
    map(e3) {
      var t3 = {};
      for (var n in this.properties) hasOwnProperty$1$2(this.properties, n) && (t3[n] = this._ifNode(e3(this.properties[n], "properties[" + stringify$1(n) + "]", this)));
      return new r(t3);
    }
    clone() {
      var e3 = {};
      for (var t3 in this.properties) hasOwnProperty$1$2(this.properties, t3) && (e3[t3] = this.properties[t3]);
      return new r(e3);
    }
    _toString(e3) {
      var t3 = [];
      for (var r2 in this.properties) hasOwnProperty$1$2(this.properties, r2) && t3.push(stringify$1(r2) + ": " + this.properties[r2].toString(e3));
      return "{" + t3.join(", ") + "}";
    }
    toJSON() {
      return { mathjs: name$1B$1, properties: this.properties };
    }
    static fromJSON(e3) {
      return new r(e3.properties);
    }
    _toHTML(e3) {
      var t3 = [];
      for (var r2 in this.properties) hasOwnProperty$1$2(this.properties, r2) && t3.push('<span class="math-symbol math-property">' + escape$1$1(r2) + '</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[r2].toHTML(e3));
      return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + t3.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    }
    _toTex(e3) {
      var t3 = [];
      for (var r2 in this.properties) hasOwnProperty$1$2(this.properties, r2) && t3.push("\\mathbf{" + r2 + ":} & " + this.properties[r2].toTex(e3) + "\\\\");
      return "\\left\\{\\begin{array}{ll}" + t3.join("\n") + "\\end{array}\\right\\}";
    }
  }
  return _defineProperty$3(r, "name", name$1B$1), r;
}), { isClass: true, isNode: true });
function createSubScope$1(e2, t2) {
  return new PartitionedMap$1(e2, new ObjectWrappingMap$1(t2), new Set(Object.keys(t2)));
}
var name$1A$1 = "OperatorNode", dependencies$1A$1 = ["Node"], createOperatorNode$1 = factory$1(name$1A$1, dependencies$1A$1, ((e2) => {
  var { Node: t2 } = e2;
  function r(e3, t3) {
    var n3 = e3;
    if ("auto" === t3) for (; isParenthesisNode$1(n3); ) n3 = n3.content;
    return !!isConstantNode$1(n3) || !!isOperatorNode$1(n3) && r(n3.args[0], t3);
  }
  function n(e3, t3, n3, i3, a) {
    var o, s = getPrecedence$1(e3, t3, n3), u = getAssociativity$1(e3, t3);
    if ("all" === t3 || i3.length > 2 && "OperatorNode:add" !== e3.getIdentifier() && "OperatorNode:multiply" !== e3.getIdentifier()) return i3.map((function(e4) {
      switch (e4.getContent().type) {
        case "ArrayNode":
        case "ConstantNode":
        case "SymbolNode":
        case "ParenthesisNode":
          return false;
        default:
          return true;
      }
    }));
    switch (i3.length) {
      case 0:
        o = [];
        break;
      case 1:
        var c2 = getPrecedence$1(i3[0], t3, n3, e3);
        if (a && null !== c2) {
          var l, f2;
          if ("keep" === t3 ? (l = i3[0].getIdentifier(), f2 = e3.getIdentifier()) : (l = i3[0].getContent().getIdentifier(), f2 = e3.getContent().getIdentifier()), false === properties$1[s][f2].latexLeftParens) {
            o = [false];
            break;
          }
          if (false === properties$1[c2][l].latexParens) {
            o = [false];
            break;
          }
        }
        if (null === c2) {
          o = [false];
          break;
        }
        if (c2 <= s) {
          o = [true];
          break;
        }
        o = [false];
        break;
      case 2:
        var p, m, d = getPrecedence$1(i3[0], t3, n3, e3), h = isAssociativeWith$1(e3, i3[0], t3);
        p = null !== d && (d === s && "right" === u && !h || d < s);
        var g, y, v2, x2 = getPrecedence$1(i3[1], t3, n3, e3), b2 = isAssociativeWith$1(e3, i3[1], t3);
        if (m = null !== x2 && (x2 === s && "left" === u && !b2 || x2 < s), a) "keep" === t3 ? (g = e3.getIdentifier(), y = e3.args[0].getIdentifier(), v2 = e3.args[1].getIdentifier()) : (g = e3.getContent().getIdentifier(), y = e3.args[0].getContent().getIdentifier(), v2 = e3.args[1].getContent().getIdentifier()), null !== d && (false === properties$1[s][g].latexLeftParens && (p = false), false === properties$1[d][y].latexParens && (p = false)), null !== x2 && (false === properties$1[s][g].latexRightParens && (m = false), false === properties$1[x2][v2].latexParens && (m = false));
        o = [p, m];
        break;
      default:
        "OperatorNode:add" !== e3.getIdentifier() && "OperatorNode:multiply" !== e3.getIdentifier() || (o = i3.map((function(r2) {
          var i4 = getPrecedence$1(r2, t3, n3, e3), a2 = isAssociativeWith$1(e3, r2, t3), o2 = getAssociativity$1(r2, t3);
          return null !== i4 && (s === i4 && u === o2 && !a2 || i4 < s);
        })));
    }
    if (i3.length >= 2 && "OperatorNode:multiply" === e3.getIdentifier() && e3.implicit && "all" !== t3 && "hide" === n3) for (var _2 = 1; _2 < o.length; ++_2) !r(i3[_2], t3) || o[_2 - 1] || "keep" === t3 && isParenthesisNode$1(i3[_2 - 1]) || (o[_2] = true);
    return o;
  }
  class i2 extends t2 {
    constructor(e3, t3, r2, n3, i3) {
      if (super(), "string" != typeof e3) throw new TypeError('string expected for parameter "op"');
      if ("string" != typeof t3) throw new TypeError('string expected for parameter "fn"');
      if (!Array.isArray(r2) || !r2.every(isNode$2)) throw new TypeError('Array containing Nodes expected for parameter "args"');
      this.implicit = true === n3, this.isPercentage = true === i3, this.op = e3, this.fn = t3, this.args = r2 || [];
    }
    get type() {
      return name$1A$1;
    }
    get isOperatorNode() {
      return true;
    }
    _compile(e3, t3) {
      if ("string" != typeof this.fn || !isSafeMethod$1(e3, this.fn)) throw e3[this.fn] ? new Error('No access to function "' + this.fn + '"') : new Error("Function " + this.fn + ' missing in provided namespace "math"');
      var r2 = getSafeProperty$1(e3, this.fn), n3 = map$1$1(this.args, (function(r3) {
        return r3._compile(e3, t3);
      }));
      if ("function" == typeof r2 && true === r2.rawArgs) {
        var i3 = this.args;
        return function(t4, n4, a2) {
          return r2(i3, e3, createSubScope$1(t4, n4));
        };
      }
      if (1 === n3.length) {
        var a = n3[0];
        return function(e4, t4, n4) {
          return r2(a(e4, t4, n4));
        };
      }
      if (2 === n3.length) {
        var o = n3[0], s = n3[1];
        return function(e4, t4, n4) {
          return r2(o(e4, t4, n4), s(e4, t4, n4));
        };
      }
      return function(e4, t4, i4) {
        return r2.apply(null, map$1$1(n3, (function(r3) {
          return r3(e4, t4, i4);
        })));
      };
    }
    forEach(e3) {
      for (var t3 = 0; t3 < this.args.length; t3++) e3(this.args[t3], "args[" + t3 + "]", this);
    }
    map(e3) {
      for (var t3 = [], r2 = 0; r2 < this.args.length; r2++) t3[r2] = this._ifNode(e3(this.args[r2], "args[" + r2 + "]", this));
      return new i2(this.op, this.fn, t3, this.implicit, this.isPercentage);
    }
    clone() {
      return new i2(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    isUnary() {
      return 1 === this.args.length;
    }
    isBinary() {
      return 2 === this.args.length;
    }
    _toString(e3) {
      var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = e3 && e3.implicit ? e3.implicit : "hide", i3 = this.args, a = n(this, t3, r2, i3, false);
      if (1 === i3.length) {
        var o = getAssociativity$1(this, t3), s = i3[0].toString(e3);
        a[0] && (s = "(" + s + ")");
        var u = /[a-zA-Z]+/.test(this.op);
        return "right" === o ? this.op + (u ? " " : "") + s : "left" === o ? s + (u ? " " : "") + this.op : s + this.op;
      }
      if (2 === i3.length) {
        var c2 = i3[0].toString(e3), l = i3[1].toString(e3);
        return a[0] && (c2 = "(" + c2 + ")"), a[1] && (l = "(" + l + ")"), this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r2 ? c2 + " " + l : c2 + " " + this.op + " " + l;
      }
      if (i3.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier())) {
        var f2 = i3.map((function(t4, r3) {
          return t4 = t4.toString(e3), a[r3] && (t4 = "(" + t4 + ")"), t4;
        }));
        return this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r2 ? f2.join(" ") : f2.join(" " + this.op + " ");
      }
      return this.fn + "(" + this.args.join(", ") + ")";
    }
    toJSON() {
      return { mathjs: name$1A$1, op: this.op, fn: this.fn, args: this.args, implicit: this.implicit, isPercentage: this.isPercentage };
    }
    static fromJSON(e3) {
      return new i2(e3.op, e3.fn, e3.args, e3.implicit, e3.isPercentage);
    }
    _toHTML(e3) {
      var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = e3 && e3.implicit ? e3.implicit : "hide", i3 = this.args, a = n(this, t3, r2, i3, false);
      if (1 === i3.length) {
        var o = getAssociativity$1(this, t3), s = i3[0].toHTML(e3);
        return a[0] && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), "right" === o ? '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + escape$1$1(this.op) + "</span>" + s : s + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + escape$1$1(this.op) + "</span>";
      }
      if (2 === i3.length) {
        var u = i3[0].toHTML(e3), c2 = i3[1].toHTML(e3);
        return a[0] && (u = '<span class="math-parenthesis math-round-parenthesis">(</span>' + u + '<span class="math-parenthesis math-round-parenthesis">)</span>'), a[1] && (c2 = '<span class="math-parenthesis math-round-parenthesis">(</span>' + c2 + '<span class="math-parenthesis math-round-parenthesis">)</span>'), this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r2 ? u + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + c2 : u + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape$1$1(this.op) + "</span>" + c2;
      }
      var l = i3.map((function(t4, r3) {
        return t4 = t4.toHTML(e3), a[r3] && (t4 = '<span class="math-parenthesis math-round-parenthesis">(</span>' + t4 + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t4;
      }));
      return i3.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier()) ? this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r2 ? l.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>') : l.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape$1$1(this.op) + "</span>") : '<span class="math-function">' + escape$1$1(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + l.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
    _toTex(e3) {
      var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = e3 && e3.implicit ? e3.implicit : "hide", i3 = this.args, a = n(this, t3, r2, i3, true), o = latexOperators$1[this.fn];
      if (o = void 0 === o ? this.op : o, 1 === i3.length) {
        var s = getAssociativity$1(this, t3), u = i3[0].toTex(e3);
        return a[0] && (u = "\\left(".concat(u, "\\right)")), "right" === s ? o + u : u + o;
      }
      if (2 === i3.length) {
        var c2 = i3[0], l = c2.toTex(e3);
        a[0] && (l = "\\left(".concat(l, "\\right)"));
        var f2, p = i3[1].toTex(e3);
        switch (a[1] && (p = "\\left(".concat(p, "\\right)")), f2 = "keep" === t3 ? c2.getIdentifier() : c2.getContent().getIdentifier(), this.getIdentifier()) {
          case "OperatorNode:divide":
            return o + "{" + l + "}{" + p + "}";
          case "OperatorNode:pow":
            switch (l = "{" + l + "}", p = "{" + p + "}", f2) {
              case "ConditionalNode":
              case "OperatorNode:divide":
                l = "\\left(".concat(l, "\\right)");
            }
            break;
          case "OperatorNode:multiply":
            if (this.implicit && "hide" === r2) return l + "~" + p;
        }
        return l + o + p;
      }
      if (i3.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier())) {
        var m = i3.map((function(t4, r3) {
          return t4 = t4.toTex(e3), a[r3] && (t4 = "\\left(".concat(t4, "\\right)")), t4;
        }));
        return "OperatorNode:multiply" === this.getIdentifier() && this.implicit && "hide" === r2 ? m.join("~") : m.join(o);
      }
      return "\\mathrm{" + this.fn + "}\\left(" + i3.map((function(t4) {
        return t4.toTex(e3);
      })).join(",") + "\\right)";
    }
    getIdentifier() {
      return this.type + ":" + this.fn;
    }
  }
  return _defineProperty$3(i2, "name", name$1A$1), i2;
}), { isClass: true, isNode: true }), name$1z$1 = "ParenthesisNode", dependencies$1z$1 = ["Node"], createParenthesisNode$1 = factory$1(name$1z$1, dependencies$1z$1, ((e2) => {
  var { Node: t2 } = e2;
  class r extends t2 {
    constructor(e3) {
      if (super(), !isNode$2(e3)) throw new TypeError('Node expected for parameter "content"');
      this.content = e3;
    }
    get type() {
      return name$1z$1;
    }
    get isParenthesisNode() {
      return true;
    }
    _compile(e3, t3) {
      return this.content._compile(e3, t3);
    }
    getContent() {
      return this.content.getContent();
    }
    forEach(e3) {
      e3(this.content, "content", this);
    }
    map(e3) {
      var t3 = e3(this.content, "content", this);
      return new r(t3);
    }
    clone() {
      return new r(this.content);
    }
    _toString(e3) {
      return !e3 || e3 && !e3.parenthesis || e3 && "keep" === e3.parenthesis ? "(" + this.content.toString(e3) + ")" : this.content.toString(e3);
    }
    toJSON() {
      return { mathjs: name$1z$1, content: this.content };
    }
    static fromJSON(e3) {
      return new r(e3.content);
    }
    _toHTML(e3) {
      return !e3 || e3 && !e3.parenthesis || e3 && "keep" === e3.parenthesis ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(e3) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : this.content.toHTML(e3);
    }
    _toTex(e3) {
      return !e3 || e3 && !e3.parenthesis || e3 && "keep" === e3.parenthesis ? "\\left(".concat(this.content.toTex(e3), "\\right)") : this.content.toTex(e3);
    }
  }
  return _defineProperty$3(r, "name", name$1z$1), r;
}), { isClass: true, isNode: true }), name$1y$1 = "RangeNode", dependencies$1y$1 = ["Node"], createRangeNode$1 = factory$1(name$1y$1, dependencies$1y$1, ((e2) => {
  var { Node: t2 } = e2;
  function r(e3, t3, r2) {
    var n3 = getPrecedence$1(e3, t3, r2), i2 = {}, a = getPrecedence$1(e3.start, t3, r2);
    if (i2.start = null !== a && a <= n3 || "all" === t3, e3.step) {
      var o = getPrecedence$1(e3.step, t3, r2);
      i2.step = null !== o && o <= n3 || "all" === t3;
    }
    var s = getPrecedence$1(e3.end, t3, r2);
    return i2.end = null !== s && s <= n3 || "all" === t3, i2;
  }
  class n extends t2 {
    constructor(e3, t3, r2) {
      if (super(), !isNode$2(e3)) throw new TypeError("Node expected");
      if (!isNode$2(t3)) throw new TypeError("Node expected");
      if (r2 && !isNode$2(r2)) throw new TypeError("Node expected");
      if (arguments.length > 3) throw new Error("Too many arguments");
      this.start = e3, this.end = t3, this.step = r2 || null;
    }
    get type() {
      return name$1y$1;
    }
    get isRangeNode() {
      return true;
    }
    needsEnd() {
      return this.filter((function(e3) {
        return isSymbolNode$1(e3) && "end" === e3.name;
      })).length > 0;
    }
    _compile(e3, t3) {
      var r2 = e3.range, n3 = this.start._compile(e3, t3), i2 = this.end._compile(e3, t3);
      if (this.step) {
        var a = this.step._compile(e3, t3);
        return function(e4, t4, o) {
          return r2(n3(e4, t4, o), i2(e4, t4, o), a(e4, t4, o));
        };
      }
      return function(e4, t4, a2) {
        return r2(n3(e4, t4, a2), i2(e4, t4, a2));
      };
    }
    forEach(e3) {
      e3(this.start, "start", this), e3(this.end, "end", this), this.step && e3(this.step, "step", this);
    }
    map(e3) {
      return new n(this._ifNode(e3(this.start, "start", this)), this._ifNode(e3(this.end, "end", this)), this.step && this._ifNode(e3(this.step, "step", this)));
    }
    clone() {
      return new n(this.start, this.end, this.step && this.step);
    }
    _toString(e3) {
      var t3, n3 = r(this, e3 && e3.parenthesis ? e3.parenthesis : "keep", e3 && e3.implicit), i2 = this.start.toString(e3);
      if (n3.start && (i2 = "(" + i2 + ")"), t3 = i2, this.step) {
        var a = this.step.toString(e3);
        n3.step && (a = "(" + a + ")"), t3 += ":" + a;
      }
      var o = this.end.toString(e3);
      return n3.end && (o = "(" + o + ")"), t3 += ":" + o;
    }
    toJSON() {
      return { mathjs: name$1y$1, start: this.start, end: this.end, step: this.step };
    }
    static fromJSON(e3) {
      return new n(e3.start, e3.end, e3.step);
    }
    _toHTML(e3) {
      var t3, n3 = r(this, e3 && e3.parenthesis ? e3.parenthesis : "keep", e3 && e3.implicit), i2 = this.start.toHTML(e3);
      if (n3.start && (i2 = '<span class="math-parenthesis math-round-parenthesis">(</span>' + i2 + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t3 = i2, this.step) {
        var a = this.step.toHTML(e3);
        n3.step && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t3 += '<span class="math-operator math-range-operator">:</span>' + a;
      }
      var o = this.end.toHTML(e3);
      return n3.end && (o = '<span class="math-parenthesis math-round-parenthesis">(</span>' + o + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t3 += '<span class="math-operator math-range-operator">:</span>' + o;
    }
    _toTex(e3) {
      var t3 = r(this, e3 && e3.parenthesis ? e3.parenthesis : "keep", e3 && e3.implicit), n3 = this.start.toTex(e3);
      if (t3.start && (n3 = "\\left(".concat(n3, "\\right)")), this.step) {
        var i2 = this.step.toTex(e3);
        t3.step && (i2 = "\\left(".concat(i2, "\\right)")), n3 += ":" + i2;
      }
      var a = this.end.toTex(e3);
      return t3.end && (a = "\\left(".concat(a, "\\right)")), n3 += ":" + a;
    }
  }
  return _defineProperty$3(n, "name", name$1y$1), n;
}), { isClass: true, isNode: true }), name$1x$1 = "RelationalNode", dependencies$1x$1 = ["Node"], createRelationalNode$1 = factory$1(name$1x$1, dependencies$1x$1, ((e2) => {
  var { Node: t2 } = e2, r = { equal: "==", unequal: "!=", smaller: "<", larger: ">", smallerEq: "<=", largerEq: ">=" };
  class n extends t2 {
    constructor(e3, t3) {
      if (super(), !Array.isArray(e3)) throw new TypeError("Parameter conditionals must be an array");
      if (!Array.isArray(t3)) throw new TypeError("Parameter params must be an array");
      if (e3.length !== t3.length - 1) throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
      this.conditionals = e3, this.params = t3;
    }
    get type() {
      return name$1x$1;
    }
    get isRelationalNode() {
      return true;
    }
    _compile(e3, t3) {
      var r2 = this, n3 = this.params.map(((r3) => r3._compile(e3, t3)));
      return function(t4, i2, a) {
        for (var o, s = n3[0](t4, i2, a), u = 0; u < r2.conditionals.length; u++) {
          if (o = s, s = n3[u + 1](t4, i2, a), !getSafeProperty$1(e3, r2.conditionals[u])(o, s)) return false;
        }
        return true;
      };
    }
    forEach(e3) {
      this.params.forEach(((t3, r2) => e3(t3, "params[" + r2 + "]", this)), this);
    }
    map(e3) {
      return new n(this.conditionals.slice(), this.params.map(((t3, r2) => this._ifNode(e3(t3, "params[" + r2 + "]", this))), this));
    }
    clone() {
      return new n(this.conditionals, this.params);
    }
    _toString(e3) {
      for (var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", n3 = getPrecedence$1(this, t3, e3 && e3.implicit), i2 = this.params.map((function(r2, i3) {
        var a2 = getPrecedence$1(r2, t3, e3 && e3.implicit);
        return "all" === t3 || null !== a2 && a2 <= n3 ? "(" + r2.toString(e3) + ")" : r2.toString(e3);
      })), a = i2[0], o = 0; o < this.conditionals.length; o++) a += " " + r[this.conditionals[o]], a += " " + i2[o + 1];
      return a;
    }
    toJSON() {
      return { mathjs: name$1x$1, conditionals: this.conditionals, params: this.params };
    }
    static fromJSON(e3) {
      return new n(e3.conditionals, e3.params);
    }
    _toHTML(e3) {
      for (var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", n3 = getPrecedence$1(this, t3, e3 && e3.implicit), i2 = this.params.map((function(r2, i3) {
        var a2 = getPrecedence$1(r2, t3, e3 && e3.implicit);
        return "all" === t3 || null !== a2 && a2 <= n3 ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + r2.toHTML(e3) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : r2.toHTML(e3);
      })), a = i2[0], o = 0; o < this.conditionals.length; o++) a += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape$1$1(r[this.conditionals[o]]) + "</span>" + i2[o + 1];
      return a;
    }
    _toTex(e3) {
      for (var t3 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = getPrecedence$1(this, t3, e3 && e3.implicit), n3 = this.params.map((function(n4, i3) {
        var a2 = getPrecedence$1(n4, t3, e3 && e3.implicit);
        return "all" === t3 || null !== a2 && a2 <= r2 ? "\\left(" + n4.toTex(e3) + "\right)" : n4.toTex(e3);
      })), i2 = n3[0], a = 0; a < this.conditionals.length; a++) i2 += latexOperators$1[this.conditionals[a]] + n3[a + 1];
      return i2;
    }
  }
  return _defineProperty$3(n, "name", name$1x$1), n;
}), { isClass: true, isNode: true }), name$1w$1 = "SymbolNode", dependencies$1w$1 = ["math", "?Unit", "Node"], createSymbolNode$1 = factory$1(name$1w$1, dependencies$1w$1, ((e2) => {
  var { math: t2, Unit: r, Node: n } = e2;
  function i2(e3) {
    return !!r && r.isValuelessUnit(e3);
  }
  class a extends n {
    constructor(e3) {
      if (super(), "string" != typeof e3) throw new TypeError('String expected for parameter "name"');
      this.name = e3;
    }
    get type() {
      return "SymbolNode";
    }
    get isSymbolNode() {
      return true;
    }
    _compile(e3, t3) {
      var n3 = this.name;
      if (true === t3[n3]) return function(e4, t4, r2) {
        return getSafeProperty$1(t4, n3);
      };
      if (n3 in e3) return function(t4, r2, i3) {
        return t4.has(n3) ? t4.get(n3) : getSafeProperty$1(e3, n3);
      };
      var o = i2(n3);
      return function(e4, t4, i3) {
        return e4.has(n3) ? e4.get(n3) : o ? new r(null, n3) : a.onUndefinedSymbol(n3);
      };
    }
    forEach(e3) {
    }
    map(e3) {
      return this.clone();
    }
    static onUndefinedSymbol(e3) {
      throw new Error("Undefined symbol " + e3);
    }
    clone() {
      return new a(this.name);
    }
    _toString(e3) {
      return this.name;
    }
    _toHTML(e3) {
      var t3 = escape$1$1(this.name);
      return "true" === t3 || "false" === t3 ? '<span class="math-symbol math-boolean">' + t3 + "</span>" : "i" === t3 ? '<span class="math-symbol math-imaginary-symbol">' + t3 + "</span>" : "Infinity" === t3 ? '<span class="math-symbol math-infinity-symbol">' + t3 + "</span>" : "NaN" === t3 ? '<span class="math-symbol math-nan-symbol">' + t3 + "</span>" : "null" === t3 ? '<span class="math-symbol math-null-symbol">' + t3 + "</span>" : "undefined" === t3 ? '<span class="math-symbol math-undefined-symbol">' + t3 + "</span>" : '<span class="math-symbol">' + t3 + "</span>";
    }
    toJSON() {
      return { mathjs: "SymbolNode", name: this.name };
    }
    static fromJSON(e3) {
      return new a(e3.name);
    }
    _toTex(e3) {
      var r2 = false;
      void 0 === t2[this.name] && i2(this.name) && (r2 = true);
      var n3 = toSymbol$1(this.name, r2);
      return "\\" === n3[0] ? n3 : " " + n3;
    }
  }
  return a;
}), { isClass: true, isNode: true }), name$1v$1 = "FunctionNode", dependencies$1v$1 = ["math", "Node", "SymbolNode"], createFunctionNode$1 = factory$1(name$1v$1, dependencies$1v$1, ((e2) => {
  var t2, { math: r, Node: n, SymbolNode: i2 } = e2, a = (e3) => format$3(e3, { truncate: 78 });
  function o(e3, t3, r2) {
    for (var n3, i3 = "", a2 = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, o2 = 0; null !== (n3 = a2.exec(e3)); ) if (i3 += e3.substring(o2, n3.index), o2 = n3.index, "$$" === n3[0]) i3 += "$", o2++;
    else {
      o2 += n3[0].length;
      var s2 = t3[n3[1]];
      if (!s2) throw new ReferenceError("Template: Property " + n3[1] + " does not exist.");
      if (void 0 === n3[2]) switch (typeof s2) {
        case "string":
          i3 += s2;
          break;
        case "object":
          if (isNode$2(s2)) i3 += s2.toTex(r2);
          else {
            if (!Array.isArray(s2)) throw new TypeError("Template: " + n3[1] + " has to be a Node, String or array of Nodes");
            i3 += s2.map((function(e4, t4) {
              if (isNode$2(e4)) return e4.toTex(r2);
              throw new TypeError("Template: " + n3[1] + "[" + t4 + "] is not a Node.");
            })).join(",");
          }
          break;
        default:
          throw new TypeError("Template: " + n3[1] + " has to be a Node, String or array of Nodes");
      }
      else {
        if (!isNode$2(s2[n3[2]] && s2[n3[2]])) throw new TypeError("Template: " + n3[1] + "[" + n3[2] + "] is not a Node.");
        i3 += s2[n3[2]].toTex(r2);
      }
    }
    return i3 += e3.slice(o2);
  }
  class s extends n {
    constructor(e3, t3, r2) {
      if (super(), "string" == typeof e3 && (e3 = new i2(e3)), !isNode$2(e3)) throw new TypeError('Node expected as parameter "fn"');
      if (!Array.isArray(t3) || !t3.every(isNode$2)) throw new TypeError('Array containing Nodes expected for parameter "args"');
      var n3 = typeof r2;
      if ("undefined" !== n3 && "boolean" !== n3) throw new TypeError("optional flag, if specified, must be boolean");
      this.fn = e3, this.args = t3 || [], this.optional = !!r2;
    }
    get name() {
      return this.fn.name || "";
    }
    get type() {
      return name$1v$1;
    }
    get isFunctionNode() {
      return true;
    }
    _compile(e3, t3) {
      var r2 = this.args.map(((r3) => r3._compile(e3, t3))), n3 = this.optional || isAccessorNode$1(this.fn) && this.fn.optionalChaining;
      if (!isSymbolNode$1(this.fn)) {
        if (isAccessorNode$1(this.fn) && isIndexNode$1(this.fn.index) && this.fn.index.isObjectProperty()) {
          var i3 = this.fn.object._compile(e3, t3), o2 = this.fn.index.getObjectProperty(), u = this.args;
          return function(t4, a2, s2) {
            var c3 = i3(t4, a2, s2);
            if (!n3 || null != c3 && void 0 !== c3[o2]) {
              var l2 = getSafeMethod$1(c3, o2);
              if (null != l2 && l2.rawArgs) return l2(u, e3, createSubScope$1(t4, a2));
              var f3 = r2.map(((e4) => e4(t4, a2, s2)));
              return l2.apply(c3, f3);
            }
          };
        }
        var c2 = this.fn.toString(), l = this.fn._compile(e3, t3), f2 = this.args;
        return function(t4, i4, o3) {
          var s2 = l(t4, i4, o3);
          if (!n3 || void 0 !== s2) {
            if ("function" != typeof s2) throw new TypeError("Expression '".concat(c2, "' did not evaluate to a function; value is:") + "\n  ".concat(a(s2)));
            if (s2.rawArgs) return s2(f2, e3, createSubScope$1(t4, i4));
            var u2 = r2.map(((e4) => e4(t4, i4, o3)));
            return s2.apply(s2, u2);
          }
        };
      }
      var p = this.fn.name;
      if (t3[p]) {
        var m = this.args;
        return function(t4, i4, o3) {
          var s2 = getSafeProperty$1(i4, p);
          if (!n3 || void 0 !== s2) {
            if ("function" != typeof s2) throw new TypeError("Argument '".concat(p, "' was not a function; received: ").concat(a(s2)));
            if (s2.rawArgs) return s2(m, e3, createSubScope$1(t4, i4));
            var u2 = r2.map(((e4) => e4(t4, i4, o3)));
            return s2.apply(s2, u2);
          }
        };
      }
      var d = p in e3 ? getSafeProperty$1(e3, p) : void 0, h = "function" == typeof d && true === d.rawArgs, g = (t4) => {
        var r3;
        if (t4.has(p)) r3 = t4.get(p);
        else if (p in e3) r3 = getSafeProperty$1(e3, p);
        else {
          if (!n3) return s.onUndefinedFunction(p);
          r3 = void 0;
        }
        if ("function" == typeof r3 || n3 && void 0 === r3) return r3;
        throw new TypeError("'".concat(p, "' is not a function; its value is:\n  ").concat(a(r3)));
      };
      if (h) {
        var y = this.args;
        return function(t4, n4, i4) {
          var a2 = g(t4);
          return true === a2.rawArgs ? a2(y, e3, createSubScope$1(t4, n4)) : a2(...r2.map(((e4) => e4(t4, n4, i4))));
        };
      }
      switch (r2.length) {
        case 0:
          return function(e4, t4, r3) {
            var i4 = g(e4);
            if (!n3 || void 0 !== i4) return i4();
          };
        case 1:
          return function(e4, t4, i4) {
            var a2 = g(e4);
            if (!n3 || void 0 !== a2) return a2((0, r2[0])(e4, t4, i4));
          };
        case 2:
          return function(e4, t4, i4) {
            var a2 = g(e4);
            if (!n3 || void 0 !== a2) {
              var o3 = r2[0], s2 = r2[1];
              return a2(o3(e4, t4, i4), s2(e4, t4, i4));
            }
          };
        default:
          return function(e4, t4, i4) {
            var a2 = g(e4);
            if (!n3 || void 0 !== a2) return a2(...r2.map(((r3) => r3(e4, t4, i4))));
          };
      }
    }
    forEach(e3) {
      e3(this.fn, "fn", this);
      for (var t3 = 0; t3 < this.args.length; t3++) e3(this.args[t3], "args[" + t3 + "]", this);
    }
    map(e3) {
      for (var t3 = this._ifNode(e3(this.fn, "fn", this)), r2 = [], n3 = 0; n3 < this.args.length; n3++) r2[n3] = this._ifNode(e3(this.args[n3], "args[" + n3 + "]", this));
      return new s(t3, r2);
    }
    clone() {
      return new s(this.fn, this.args.slice(0));
    }
    toString(e3) {
      var t3, r2 = this.fn.toString(e3);
      return e3 && "object" == typeof e3.handler && hasOwnProperty$1$2(e3.handler, r2) && (t3 = e3.handler[r2](this, e3)), void 0 !== t3 ? t3 : super.toString(e3);
    }
    _toString(e3) {
      var t3 = this.args.map((function(t4) {
        return t4.toString(e3);
      }));
      return (isFunctionAssignmentNode$1(this.fn) ? "(" + this.fn.toString(e3) + ")" : this.fn.toString(e3)) + "(" + t3.join(", ") + ")";
    }
    toJSON() {
      return { mathjs: name$1v$1, fn: this.fn, args: this.args };
    }
    _toHTML(e3) {
      var t3 = this.args.map((function(t4) {
        return t4.toHTML(e3);
      }));
      return '<span class="math-function">' + escape$1$1(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + t3.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
    toTex(e3) {
      var t3;
      return e3 && "object" == typeof e3.handler && hasOwnProperty$1$2(e3.handler, this.name) && (t3 = e3.handler[this.name](this, e3)), void 0 !== t3 ? t3 : super.toTex(e3);
    }
    _toTex(e3) {
      var t3, n3, i3 = this.args.map((function(t4) {
        return t4.toTex(e3);
      }));
      switch (latexFunctions$1[this.name] && (t3 = latexFunctions$1[this.name]), !r[this.name] || "function" != typeof r[this.name].toTex && "object" != typeof r[this.name].toTex && "string" != typeof r[this.name].toTex || (t3 = r[this.name].toTex), typeof t3) {
        case "function":
          n3 = t3(this, e3);
          break;
        case "string":
          n3 = o(t3, this, e3);
          break;
        case "object":
          switch (typeof t3[i3.length]) {
            case "function":
              n3 = t3[i3.length](this, e3);
              break;
            case "string":
              n3 = o(t3[i3.length], this, e3);
          }
      }
      return void 0 !== n3 ? n3 : o(defaultTemplate$1, this, e3);
    }
    getIdentifier() {
      return this.type + ":" + this.name;
    }
  }
  return t2 = s, _defineProperty$3(s, "name", name$1v$1), _defineProperty$3(s, "onUndefinedFunction", (function(e3) {
    throw new Error("Undefined function " + e3);
  })), _defineProperty$3(s, "fromJSON", (function(e3) {
    return new t2(e3.fn, e3.args);
  })), s;
}), { isClass: true, isNode: true }), name$1u$1 = "parse", dependencies$1u$1 = ["typed", "numeric", "config", "AccessorNode", "ArrayNode", "AssignmentNode", "BlockNode", "ConditionalNode", "ConstantNode", "FunctionAssignmentNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "RangeNode", "RelationalNode", "SymbolNode"], createParse$1 = factory$1(name$1u$1, dependencies$1u$1, ((e2) => {
  var { typed: t2, numeric: r, config: n, AccessorNode: i2, ArrayNode: a, AssignmentNode: o, BlockNode: s, ConditionalNode: u, ConstantNode: c2, FunctionAssignmentNode: l, FunctionNode: f2, IndexNode: p, ObjectNode: m, OperatorNode: d, ParenthesisNode: h, RangeNode: g, RelationalNode: y, SymbolNode: v2 } = e2, x2 = t2(name$1u$1, { string: function(e3) {
    return I2(e3, {});
  }, "Array | Matrix": function(e3) {
    return b2(e3, {});
  }, "string, Object": function(e3, t3) {
    return I2(e3, void 0 !== t3.nodes ? t3.nodes : {});
  }, "Array | Matrix, Object": b2 });
  function b2(e3) {
    var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = void 0 !== t3.nodes ? t3.nodes : {};
    return deepMap$2(e3, (function(e4) {
      if ("string" != typeof e4) throw new TypeError("String expected");
      return I2(e4, r2);
    }));
  }
  var _2 = { NULL: 0, DELIMITER: 1, NUMBER: 2, SYMBOL: 3, UNKNOWN: 4 }, w2 = { ",": true, "(": true, ")": true, "[": true, "]": true, "{": true, "}": true, '"': true, "'": true, ";": true, "+": true, "-": true, "*": true, ".*": true, "/": true, "./": true, "%": true, "^": true, ".^": true, "~": true, "!": true, "&": true, "|": true, "^|": true, "=": true, ":": true, "?": true, "?.": true, "??": true, "==": true, "!=": true, "<": true, ">": true, "<=": true, ">=": true, "<<": true, ">>": true, ">>>": true }, A2 = { mod: true, to: true, in: true, and: true, xor: true, or: true, not: true }, N = { true: true, false: false, null: null, undefined: void 0 }, D = ["NaN", "Infinity"], E = { '"': '"', "'": "'", "\\": "\\", "/": "/", b: "\b", f: "\f", n: "\n", r: "\r", t: "	" };
  function $2(e3, t3) {
    return e3.expression.substr(e3.index, t3);
  }
  function S2(e3) {
    return $2(e3, 1);
  }
  function C2(e3) {
    e3.index++;
  }
  function M2(e3) {
    return e3.expression.charAt(e3.index - 1);
  }
  function T2(e3) {
    return e3.expression.charAt(e3.index + 1);
  }
  function F(e3) {
    for (e3.tokenType = _2.NULL, e3.token = "", e3.comment = ""; ; ) {
      if ("#" === S2(e3)) for (; "\n" !== S2(e3) && "" !== S2(e3); ) e3.comment += S2(e3), C2(e3);
      if (!x2.isWhitespace(S2(e3), e3.nestingLevel)) break;
      C2(e3);
    }
    if ("" !== S2(e3)) {
      if ("\n" === S2(e3) && !e3.nestingLevel) return e3.tokenType = _2.DELIMITER, e3.token = S2(e3), void C2(e3);
      var t3 = S2(e3), r2 = $2(e3, 2), n3 = $2(e3, 3);
      if (3 === n3.length && w2[n3]) return e3.tokenType = _2.DELIMITER, e3.token = n3, C2(e3), C2(e3), void C2(e3);
      if (2 === r2.length && w2[r2] && ("?." !== r2 || !x2.isDigit(e3.expression.charAt(e3.index + 2)))) return e3.tokenType = _2.DELIMITER, e3.token = r2, C2(e3), void C2(e3);
      if (w2[t3]) return e3.tokenType = _2.DELIMITER, e3.token = t3, void C2(e3);
      if (x2.isDigitDot(t3)) {
        e3.tokenType = _2.NUMBER;
        var i3 = $2(e3, 2);
        if ("0b" === i3 || "0o" === i3 || "0x" === i3) {
          for (e3.token += S2(e3), C2(e3), e3.token += S2(e3), C2(e3); x2.isAlpha(S2(e3), M2(e3), T2(e3)) || x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
          if ("." === S2(e3)) for (e3.token += ".", C2(e3); x2.isAlpha(S2(e3), M2(e3), T2(e3)) || x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
          else if ("i" === S2(e3)) for (e3.token += "i", C2(e3); x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
          return;
        }
        if ("." === S2(e3)) {
          if (e3.token += S2(e3), C2(e3), !x2.isDigit(S2(e3))) return void (e3.tokenType = _2.DELIMITER);
        } else {
          for (; x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
          x2.isDecimalMark(S2(e3), T2(e3)) && (e3.token += S2(e3), C2(e3));
        }
        for (; x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
        if ("E" === S2(e3) || "e" === S2(e3)) {
          if (x2.isDigit(T2(e3)) || "-" === T2(e3) || "+" === T2(e3)) {
            if (e3.token += S2(e3), C2(e3), "+" !== S2(e3) && "-" !== S2(e3) || (e3.token += S2(e3), C2(e3)), !x2.isDigit(S2(e3))) throw ie2(e3, 'Digit expected, got "' + S2(e3) + '"');
            for (; x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
            if (x2.isDecimalMark(S2(e3), T2(e3))) throw ie2(e3, 'Digit expected, got "' + S2(e3) + '"');
          } else if (x2.isDecimalMark(T2(e3), e3.expression.charAt(e3.index + 2))) throw C2(e3), ie2(e3, 'Digit expected, got "' + S2(e3) + '"');
        }
      } else {
        if (!x2.isAlpha(S2(e3), M2(e3), T2(e3))) {
          for (e3.tokenType = _2.UNKNOWN; "" !== S2(e3); ) e3.token += S2(e3), C2(e3);
          throw ie2(e3, 'Syntax error in part "' + e3.token + '"');
        }
        for (; x2.isAlpha(S2(e3), M2(e3), T2(e3)) || x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
        hasOwnProperty$1$2(A2, e3.token) ? e3.tokenType = _2.DELIMITER : e3.tokenType = _2.SYMBOL;
      }
    } else e3.tokenType = _2.DELIMITER;
  }
  function O2(e3) {
    do {
      F(e3);
    } while ("\n" === e3.token);
  }
  function k2(e3) {
    e3.nestingLevel++;
  }
  function B2(e3) {
    e3.nestingLevel--;
  }
  function I2(e3, t3) {
    var r2 = { extraNodes: {}, expression: "", comment: "", index: 0, token: "", tokenType: _2.NULL, nestingLevel: 0, conditionalLevel: null };
    _extends$4(r2, { expression: e3, extraNodes: t3 }), F(r2);
    var n3 = (function(e4) {
      var t4, r3, n4 = [];
      "" !== e4.token && "\n" !== e4.token && ";" !== e4.token && (t4 = R2(e4), e4.comment && (t4.comment = e4.comment));
      for (; "\n" === e4.token || ";" === e4.token; ) 0 === n4.length && t4 && (r3 = ";" !== e4.token, n4.push({ node: t4, visible: r3 })), F(e4), "\n" !== e4.token && ";" !== e4.token && "" !== e4.token && (t4 = R2(e4), e4.comment && (t4.comment = e4.comment), r3 = ";" !== e4.token, n4.push({ node: t4, visible: r3 }));
      return n4.length > 0 ? new s(n4) : (t4 || (t4 = new c2(void 0), e4.comment && (t4.comment = e4.comment)), t4);
    })(r2);
    if ("" !== r2.token) throw r2.tokenType === _2.DELIMITER ? ae2(r2, "Unexpected operator " + r2.token) : ie2(r2, 'Unexpected part "' + r2.token + '"');
    return n3;
  }
  function R2(e3) {
    var t3, r2, n3, i3, a2 = (function(e4) {
      var t4 = (function(e5) {
        var t5 = q2(e5);
        for (; "or" === e5.token; ) O2(e5), t5 = new d("or", "or", [t5, q2(e5)]);
        return t5;
      })(e4);
      for (; "?" === e4.token; ) {
        var r3 = e4.conditionalLevel;
        e4.conditionalLevel = e4.nestingLevel, O2(e4);
        var n4 = t4, i4 = R2(e4);
        if (":" !== e4.token) throw ie2(e4, "False part of conditional expression expected");
        e4.conditionalLevel = null, O2(e4);
        var a3 = R2(e4);
        t4 = new u(n4, i4, a3), e4.conditionalLevel = r3;
      }
      return t4;
    })(e3);
    if ("=" === e3.token) {
      if (isSymbolNode$1(a2)) return t3 = a2.name, O2(e3), n3 = R2(e3), new o(new v2(t3), n3);
      if (isAccessorNode$1(a2)) {
        if (a2.optionalChaining) throw ie2(e3, "Cannot assign to optional chain");
        return O2(e3), n3 = R2(e3), new o(a2.object, a2.index, n3);
      }
      if (isFunctionNode$1(a2) && isSymbolNode$1(a2.fn) && (i3 = true, r2 = [], t3 = a2.name, a2.args.forEach((function(e4, t4) {
        isSymbolNode$1(e4) ? r2[t4] = e4.name : i3 = false;
      })), i3)) return O2(e3), n3 = R2(e3), new l(t3, r2, n3);
      throw ie2(e3, "Invalid left hand side of assignment operator =");
    }
    return a2;
  }
  function q2(e3) {
    for (var t3 = z2(e3); "xor" === e3.token; ) O2(e3), t3 = new d("xor", "xor", [t3, z2(e3)]);
    return t3;
  }
  function z2(e3) {
    for (var t3 = P2(e3); "and" === e3.token; ) O2(e3), t3 = new d("and", "and", [t3, P2(e3)]);
    return t3;
  }
  function P2(e3) {
    for (var t3 = L2(e3); "|" === e3.token; ) O2(e3), t3 = new d("|", "bitOr", [t3, L2(e3)]);
    return t3;
  }
  function L2(e3) {
    for (var t3 = j2(e3); "^|" === e3.token; ) O2(e3), t3 = new d("^|", "bitXor", [t3, j2(e3)]);
    return t3;
  }
  function j2(e3) {
    for (var t3 = U2(e3); "&" === e3.token; ) O2(e3), t3 = new d("&", "bitAnd", [t3, U2(e3)]);
    return t3;
  }
  function U2(e3) {
    for (var t3 = [Z2(e3)], r2 = [], n3 = { "==": "equal", "!=": "unequal", "<": "smaller", ">": "larger", "<=": "smallerEq", ">=": "largerEq" }; hasOwnProperty$1$2(n3, e3.token); ) {
      var i3 = { name: e3.token, fn: n3[e3.token] };
      r2.push(i3), O2(e3), t3.push(Z2(e3));
    }
    return 1 === t3.length ? t3[0] : 2 === t3.length ? new d(r2[0].name, r2[0].fn, t3) : new y(r2.map(((e4) => e4.fn)), t3);
  }
  function Z2(e3) {
    var t3, r2, n3, i3;
    t3 = G2(e3);
    for (var a2 = { "<<": "leftShift", ">>": "rightArithShift", ">>>": "rightLogShift" }; hasOwnProperty$1$2(a2, e3.token); ) n3 = a2[r2 = e3.token], O2(e3), i3 = [t3, G2(e3)], t3 = new d(r2, n3, i3);
    return t3;
  }
  function G2(e3) {
    var t3, r2, n3, i3;
    t3 = V2(e3);
    for (var a2 = { to: "to", in: "to" }; hasOwnProperty$1$2(a2, e3.token); ) n3 = a2[r2 = e3.token], O2(e3), "in" === r2 && "])},;".includes(e3.token) ? t3 = new d("*", "multiply", [t3, new v2("in")], true) : (i3 = [t3, V2(e3)], t3 = new d(r2, n3, i3));
    return t3;
  }
  function V2(e3) {
    var t3, r2 = [];
    if (t3 = ":" === e3.token ? new c2(1) : H2(e3), ":" === e3.token && e3.conditionalLevel !== e3.nestingLevel) {
      for (r2.push(t3); ":" === e3.token && r2.length < 3; ) O2(e3), ")" === e3.token || "]" === e3.token || "," === e3.token || "" === e3.token ? r2.push(new v2("end")) : r2.push(H2(e3));
      t3 = 3 === r2.length ? new g(r2[0], r2[2], r2[1]) : new g(r2[0], r2[1]);
    }
    return t3;
  }
  function H2(e3) {
    var t3, r2, n3, i3;
    t3 = X2(e3);
    for (var a2 = { "+": "add", "-": "subtract" }; hasOwnProperty$1$2(a2, e3.token); ) {
      n3 = a2[r2 = e3.token], O2(e3);
      var o2 = X2(e3);
      i3 = o2.isPercentage ? [t3, new d("*", "multiply", [t3, o2])] : [t3, o2], t3 = new d(r2, n3, i3);
    }
    return t3;
  }
  function X2(e3) {
    var t3, r2, n3, i3;
    r2 = t3 = W2(e3);
    for (var a2 = { "*": "multiply", ".*": "dotMultiply", "/": "divide", "./": "dotDivide", "%": "mod", mod: "mod" }; hasOwnProperty$1$2(a2, e3.token); ) i3 = a2[n3 = e3.token], O2(e3), r2 = W2(e3), t3 = new d(n3, i3, [t3, r2]);
    return t3;
  }
  function W2(e3) {
    var t3, r2;
    for (r2 = t3 = Q2(e3); e3.tokenType === _2.SYMBOL || "in" === e3.token && isConstantNode$1(t3) || "in" === e3.token && isOperatorNode$1(t3) && "unaryMinus" === t3.fn && isConstantNode$1(t3.args[0]) || !(e3.tokenType !== _2.NUMBER || isConstantNode$1(r2) || isOperatorNode$1(r2) && "!" !== r2.op) || "(" === e3.token; ) r2 = Q2(e3), t3 = new d("*", "multiply", [t3, r2], true);
    return t3;
  }
  function Q2(e3) {
    for (var t3 = Y2(e3), r2 = t3, n3 = []; "/" === e3.token && rule2Node$1(r2); ) {
      if (n3.push(_extends$4({}, e3)), O2(e3), e3.tokenType !== _2.NUMBER) {
        _extends$4(e3, n3.pop());
        break;
      }
      if (n3.push(_extends$4({}, e3)), O2(e3), e3.tokenType !== _2.SYMBOL && "(" !== e3.token && "in" !== e3.token) {
        n3.pop(), _extends$4(e3, n3.pop());
        break;
      }
      _extends$4(e3, n3.pop()), n3.pop(), r2 = Y2(e3), t3 = new d("/", "divide", [t3, r2]);
    }
    return t3;
  }
  function Y2(e3) {
    var t3 = J(e3);
    if ("%" === e3.token) {
      var r2 = _extends$4({}, e3);
      O2(e3);
      try {
        J(e3), _extends$4(e3, r2);
      } catch (e4) {
        t3 = new d("/", "divide", [t3, new c2(100)], false, true);
      }
    }
    return t3;
  }
  function J(e3) {
    var t3, r2, n3, i3 = { "-": "unaryMinus", "+": "unaryPlus", "~": "bitNot", not: "not" };
    return hasOwnProperty$1$2(i3, e3.token) ? (n3 = i3[e3.token], t3 = e3.token, O2(e3), r2 = [J(e3)], new d(t3, n3, r2)) : (function(e4) {
      var t4, r3, n4, i4;
      t4 = (function(e5) {
        var t5 = K2(e5);
        for (; "??" === e5.token; ) O2(e5), t5 = new d("??", "nullish", [t5, K2(e5)]);
        return t5;
      })(e4), ("^" === e4.token || ".^" === e4.token) && (n4 = "^" === (r3 = e4.token) ? "pow" : "dotPow", O2(e4), i4 = [t4, J(e4)], t4 = new d(r3, n4, i4));
      return t4;
    })(e3);
  }
  function K2(e3) {
    var t3, i3, o2;
    t3 = (function(e4) {
      var t4 = [];
      if (e4.tokenType === _2.SYMBOL && hasOwnProperty$1$2(e4.extraNodes, e4.token)) {
        var i4 = e4.extraNodes[e4.token];
        if (F(e4), "(" === e4.token) {
          if (t4 = [], k2(e4), F(e4), ")" !== e4.token) for (t4.push(R2(e4)); "," === e4.token; ) F(e4), t4.push(R2(e4));
          if (")" !== e4.token) throw ie2(e4, "Parenthesis ) expected");
          B2(e4), F(e4);
        }
        return new i4(t4);
      }
      return (function(e5) {
        var t5;
        if (e5.tokenType === _2.SYMBOL || e5.tokenType === _2.DELIMITER && e5.token in A2) return t5 = e5.token, F(e5), ee2(e5, hasOwnProperty$1$2(N, t5) ? new c2(N[t5]) : D.includes(t5) ? new c2(r(t5, "number")) : new v2(t5));
        return (function(e6) {
          var t6;
          if ('"' === e6.token || "'" === e6.token) return t6 = te2(e6, e6.token), ee2(e6, new c2(t6));
          return (function(e7) {
            var t7, i5, o3, s3;
            if ("[" === e7.token) {
              if (k2(e7), F(e7), "]" !== e7.token) {
                var u2 = re2(e7);
                if (";" === e7.token) {
                  for (o3 = 1, i5 = [u2]; ";" === e7.token; ) F(e7), "]" !== e7.token && (i5[o3] = re2(e7), o3++);
                  if ("]" !== e7.token) throw ie2(e7, "End of matrix ] expected");
                  B2(e7), F(e7), s3 = i5[0].items.length;
                  for (var l2 = 1; l2 < o3; l2++) if (i5[l2].items.length !== s3) throw ae2(e7, "Column dimensions mismatch (" + i5[l2].items.length + " !== " + s3 + ")");
                  t7 = new a(i5);
                } else {
                  if ("]" !== e7.token) throw ie2(e7, "End of matrix ] expected");
                  B2(e7), F(e7), t7 = u2;
                }
              } else B2(e7), F(e7), t7 = new a([]);
              return ee2(e7, t7);
            }
            return (function(e8) {
              if ("{" === e8.token) {
                var t8;
                k2(e8);
                var i6 = {};
                do {
                  if (F(e8), "}" !== e8.token) {
                    if ('"' === e8.token || "'" === e8.token) t8 = te2(e8, e8.token);
                    else {
                      if (!(e8.tokenType === _2.SYMBOL || e8.tokenType === _2.DELIMITER && e8.token in A2)) throw ie2(e8, "Symbol or string expected as object key");
                      t8 = e8.token, F(e8);
                    }
                    if (":" !== e8.token) throw ie2(e8, "Colon : expected after object key");
                    F(e8), i6[t8] = R2(e8);
                  }
                } while ("," === e8.token);
                if ("}" !== e8.token) throw ie2(e8, "Comma , or bracket } expected after object value");
                B2(e8), F(e8);
                var a2 = new m(i6);
                return a2 = ee2(e8, a2);
              }
              return (function(e9) {
                var t9;
                if (e9.tokenType === _2.NUMBER) {
                  t9 = e9.token, F(e9);
                  var i7 = safeNumberType$1(t9, n), a3 = r(t9, i7);
                  return new c2(a3);
                }
                return (function(e10) {
                  var t10;
                  if ("(" === e10.token) {
                    if (k2(e10), F(e10), t10 = R2(e10), ")" !== e10.token) throw ie2(e10, "Parenthesis ) expected");
                    return B2(e10), F(e10), t10 = ee2(e10, t10 = new h(t10));
                  }
                  return (function(e11) {
                    throw "" === e11.token ? ie2(e11, "Unexpected end of expression") : ie2(e11, "Value expected");
                  })(e10);
                })(e9);
              })(e8);
            })(e7);
          })(e6);
        })(e5);
      })(e4);
    })(e3);
    for (var s2 = { "!": "factorial", "'": "ctranspose" }; hasOwnProperty$1$2(s2, e3.token); ) o2 = s2[i3 = e3.token], F(e3), t3 = ee2(e3, t3 = new d(i3, o2, [t3]));
    return t3;
  }
  function ee2(e3, t3, r2) {
    for (var n3; ; ) {
      var a2 = false;
      "?." === e3.token && (a2 = true, F(e3));
      var o2 = ("(" === e3.token || "[" === e3.token || "." === e3.token) && true;
      if (!a2 && !o2) break;
      if (n3 = [], "(" === e3.token) {
        if (!(a2 || isSymbolNode$1(t3) || isAccessorNode$1(t3))) return t3;
        if (k2(e3), F(e3), ")" !== e3.token) for (n3.push(R2(e3)); "," === e3.token; ) F(e3), n3.push(R2(e3));
        if (")" !== e3.token) throw ie2(e3, "Parenthesis ) expected");
        B2(e3), F(e3), t3 = new f2(t3, n3, a2);
      } else if ("[" === e3.token) {
        if (k2(e3), F(e3), "]" !== e3.token) for (n3.push(R2(e3)); "," === e3.token; ) F(e3), n3.push(R2(e3));
        if ("]" !== e3.token) throw ie2(e3, "Parenthesis ] expected");
        B2(e3), F(e3), t3 = new i2(t3, new p(n3), a2);
      } else {
        if (a2 || F(e3), !(e3.tokenType === _2.SYMBOL || e3.tokenType === _2.DELIMITER && e3.token in A2)) {
          var s2 = "Property name expected after ";
          throw ie2(e3, s2 += a2 ? "optional chain" : "dot");
        }
        n3.push(new c2(e3.token)), F(e3);
        t3 = new i2(t3, new p(n3, true), a2);
      }
    }
    return t3;
  }
  function te2(e3, t3) {
    for (var r2 = ""; "" !== S2(e3) && S2(e3) !== t3; ) if ("\\" === S2(e3)) {
      C2(e3);
      var n3 = S2(e3), i3 = E[n3];
      if (void 0 !== i3) r2 += i3, e3.index += 1;
      else {
        if ("u" !== n3) throw ie2(e3, "Bad escape character \\".concat(n3));
        var a2 = e3.expression.slice(e3.index + 1, e3.index + 5);
        if (!/^[0-9A-Fa-f]{4}$/.test(a2)) throw ie2(e3, "Invalid unicode character \\u".concat(a2));
        r2 += String.fromCharCode(parseInt(a2, 16)), e3.index += 5;
      }
    } else r2 += S2(e3), C2(e3);
    if (F(e3), e3.token !== t3) throw ie2(e3, "End of string ".concat(t3, " expected"));
    return F(e3), r2;
  }
  function re2(e3) {
    for (var t3 = [R2(e3)], r2 = 1; "," === e3.token; ) F(e3), "]" !== e3.token && ";" !== e3.token && (t3[r2] = R2(e3), r2++);
    return new a(t3);
  }
  function ne(e3) {
    return e3.index - e3.token.length + 1;
  }
  function ie2(e3, t3) {
    var r2 = ne(e3), n3 = new SyntaxError(t3 + " (char " + r2 + ")");
    return n3.char = r2, n3;
  }
  function ae2(e3, t3) {
    var r2 = ne(e3), n3 = new SyntaxError(t3 + " (char " + r2 + ")");
    return n3.char = r2, n3;
  }
  return x2.isAlpha = function(e3, t3, r2) {
    return x2.isValidLatinOrGreek(e3) || x2.isValidMathSymbol(e3, r2) || x2.isValidMathSymbol(t3, e3);
  }, x2.isValidLatinOrGreek = function(e3) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(e3);
  }, x2.isValidMathSymbol = function(e3, t3) {
    return /^[\uD835]$/.test(e3) && /^[\uDC00-\uDFFF]$/.test(t3) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(t3);
  }, x2.isWhitespace = function(e3, t3) {
    return " " === e3 || "	" === e3 || " " === e3 || "\n" === e3 && t3 > 0;
  }, x2.isDecimalMark = function(e3, t3) {
    return "." === e3 && "/" !== t3 && "*" !== t3 && "^" !== t3;
  }, x2.isDigitDot = function(e3) {
    return e3 >= "0" && e3 <= "9" || "." === e3;
  }, x2.isDigit = function(e3) {
    return e3 >= "0" && e3 <= "9";
  }, t2.addConversion({ from: "string", to: "Node", convert: x2 }), x2;
})), name$1t$1 = "compile", dependencies$1t$1 = ["typed", "parse"], createCompile$1 = factory$1(name$1t$1, dependencies$1t$1, ((e2) => {
  var { typed: t2, parse: r } = e2;
  return t2(name$1t$1, { string: function(e3) {
    return r(e3).compile();
  }, "Array | Matrix": function(e3) {
    return deepMap$2(e3, (function(e4) {
      return r(e4).compile();
    }));
  } });
})), name$1s$1 = "evaluate", dependencies$1s$1 = ["typed", "parse"], createEvaluate$1 = factory$1(name$1s$1, dependencies$1s$1, ((e2) => {
  var { typed: t2, parse: r } = e2;
  return t2(name$1s$1, { string: function(e3) {
    var t3 = createEmptyMap$1();
    return r(e3).compile().evaluate(t3);
  }, "string, Map | Object": function(e3, t3) {
    return r(e3).compile().evaluate(t3);
  }, "Array | Matrix": function(e3) {
    var t3 = createEmptyMap$1();
    return deepMap$2(e3, (function(e4) {
      return r(e4).compile().evaluate(t3);
    }));
  }, "Array | Matrix, Map | Object": function(e3, t3) {
    return deepMap$2(e3, (function(e4) {
      return r(e4).compile().evaluate(t3);
    }));
  } });
})), name$1r$1 = "Parser", dependencies$1r$1 = ["evaluate", "parse"], createParserClass$1 = factory$1(name$1r$1, dependencies$1r$1, ((e2) => {
  var { evaluate: t2, parse: r } = e2;
  function n() {
    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
    Object.defineProperty(this, "scope", { value: createEmptyMap$1(), writable: false });
  }
  return n.prototype.type = "Parser", n.prototype.isParser = true, n.prototype.evaluate = function(e3) {
    return t2(e3, this.scope);
  }, n.prototype.get = function(e3) {
    if (this.scope.has(e3)) return this.scope.get(e3);
  }, n.prototype.getAll = function() {
    return toObject$1(this.scope);
  }, n.prototype.getAllAsMap = function() {
    return this.scope;
  }, n.prototype.set = function(e3, t3) {
    if (!(function(e4) {
      if (0 === e4.length) return false;
      for (var t4 = 0; t4 < e4.length; t4++) {
        var n3 = e4.charAt(t4 - 1), i2 = e4.charAt(t4), a = e4.charAt(t4 + 1);
        if (!(r.isAlpha(i2, n3, a) || t4 > 0 && r.isDigit(i2))) return false;
      }
      return true;
    })(e3)) throw new Error("Invalid variable name: '".concat(e3, "'. Variable names must follow the specified rules."));
    return this.scope.set(e3, t3), t3;
  }, n.prototype.remove = function(e3) {
    this.scope.delete(e3);
  }, n.prototype.clear = function() {
    this.scope.clear();
  }, n.prototype.toJSON = function() {
    var e3 = { mathjs: "Parser", variables: {}, functions: {} };
    for (var [t3, r2] of this.scope) if (isFunction$2$1(r2)) {
      if (!isExpressionFunction$1(r2)) throw new Error("Cannot serialize external function ".concat(t3));
      e3.functions[t3] = "".concat(r2.syntax, " = ").concat(r2.expr);
    } else e3.variables[t3] = r2;
    return e3;
  }, n.fromJSON = function(e3) {
    var t3 = new n();
    return Object.entries(e3.variables).forEach(((e4) => {
      var [r2, n3] = e4;
      return t3.set(r2, n3);
    })), Object.entries(e3.functions).forEach(((e4) => {
      var [r2, n3] = e4;
      return t3.evaluate(n3);
    })), t3;
  }, n;
}), { isClass: true });
function isExpressionFunction$1(e2) {
  return "function" == typeof e2 && "string" == typeof e2.syntax && "string" == typeof e2.expr;
}
var name$1q$1 = "parser", dependencies$1q$1 = ["typed", "Parser"], createParser$1 = factory$1(name$1q$1, dependencies$1q$1, ((e2) => {
  var { typed: t2, Parser: r } = e2;
  return t2(name$1q$1, { "": function() {
    return new r();
  } });
})), name$1p$1 = "lup", dependencies$1p$1 = ["typed", "matrix", "abs", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "larger", "equalScalar", "unaryMinus", "DenseMatrix", "SparseMatrix", "Spa"], createLup$1 = factory$1(name$1p$1, dependencies$1p$1, ((e2) => {
  var { typed: t2, matrix: r, abs: n, addScalar: i2, divideScalar: a, multiplyScalar: o, subtractScalar: s, larger: u, equalScalar: c2, unaryMinus: l, DenseMatrix: f2, SparseMatrix: p, Spa: m } = e2;
  return t2(name$1p$1, { DenseMatrix: function(e3) {
    return d(e3);
  }, SparseMatrix: function(e3) {
    return h(e3);
  }, Array: function(e3) {
    var t3 = d(r(e3));
    return { L: t3.L.valueOf(), U: t3.U.valueOf(), p: t3.p };
  } });
  function d(e3) {
    var t3, r2, l2, p2 = e3._size[0], m2 = e3._size[1], d2 = Math.min(p2, m2), h2 = clone$3$1(e3._data), g = [], y = [p2, d2], v2 = [], x2 = [d2, m2], b2 = [];
    for (t3 = 0; t3 < p2; t3++) b2[t3] = t3;
    for (r2 = 0; r2 < m2; r2++) {
      if (r2 > 0) for (t3 = 0; t3 < p2; t3++) {
        var _2 = Math.min(t3, r2), w2 = 0;
        for (l2 = 0; l2 < _2; l2++) w2 = i2(w2, o(h2[t3][l2], h2[l2][r2]));
        h2[t3][r2] = s(h2[t3][r2], w2);
      }
      var A2 = r2, N = 0, D = 0;
      for (t3 = r2; t3 < p2; t3++) {
        var E = h2[t3][r2], $2 = n(E);
        u($2, N) && (A2 = t3, N = $2, D = E);
      }
      if (r2 !== A2 && (b2[r2] = [b2[A2], b2[A2] = b2[r2]][0], f2._swapRows(r2, A2, h2)), r2 < p2) for (t3 = r2 + 1; t3 < p2; t3++) {
        var S2 = h2[t3][r2];
        c2(S2, 0) || (h2[t3][r2] = a(h2[t3][r2], D));
      }
    }
    for (r2 = 0; r2 < m2; r2++) for (t3 = 0; t3 < p2; t3++) 0 === r2 && (t3 < m2 && (v2[t3] = []), g[t3] = []), t3 < r2 ? (t3 < m2 && (v2[t3][r2] = h2[t3][r2]), r2 < p2 && (g[t3][r2] = 0)) : t3 !== r2 ? (t3 < m2 && (v2[t3][r2] = 0), r2 < p2 && (g[t3][r2] = h2[t3][r2])) : (t3 < m2 && (v2[t3][r2] = h2[t3][r2]), r2 < p2 && (g[t3][r2] = 1));
    var C2 = new f2({ data: g, size: y }), M2 = new f2({ data: v2, size: x2 }), T2 = [];
    for (t3 = 0, d2 = b2.length; t3 < d2; t3++) T2[b2[t3]] = t3;
    return { L: C2, U: M2, p: T2, toString: function() {
      return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
    } };
  }
  function h(e3) {
    var t3, r2, i3, s2 = e3._size[0], f3 = e3._size[1], d2 = Math.min(s2, f3), h2 = e3._values, g = e3._index, y = e3._ptr, v2 = [], x2 = [], b2 = [], _2 = [s2, d2], w2 = [], A2 = [], N = [], D = [d2, f3], E = [], $2 = [];
    for (t3 = 0; t3 < s2; t3++) E[t3] = t3, $2[t3] = t3;
    var S2 = function() {
      var e4 = new m();
      r2 < s2 && (b2.push(v2.length), v2.push(1), x2.push(r2)), N.push(w2.length);
      var f4 = y[r2], d3 = y[r2 + 1];
      for (i3 = f4; i3 < d3; i3++) t3 = g[i3], e4.set(E[t3], h2[i3]);
      r2 > 0 && e4.forEach(0, r2 - 1, (function(t4, r3) {
        p._forEachRow(t4, v2, x2, b2, (function(n3, i4) {
          n3 > t4 && e4.accumulate(n3, l(o(i4, r3)));
        }));
      }));
      var S3, C2, M2, T2, F = r2, O2 = e4.get(r2), k2 = n(O2);
      e4.forEach(r2 + 1, s2 - 1, (function(e5, t4) {
        var r3 = n(t4);
        u(r3, k2) && (F = e5, k2 = r3, O2 = t4);
      })), r2 !== F && (p._swapRows(r2, F, _2[1], v2, x2, b2), p._swapRows(r2, F, D[1], w2, A2, N), e4.swap(r2, F), C2 = F, M2 = $2[S3 = r2], T2 = $2[C2], E[M2] = C2, E[T2] = S3, $2[S3] = T2, $2[C2] = M2), e4.forEach(0, s2 - 1, (function(e5, t4) {
        e5 <= r2 ? (w2.push(t4), A2.push(e5)) : (t4 = a(t4, O2), c2(t4, 0) || (v2.push(t4), x2.push(e5)));
      }));
    };
    for (r2 = 0; r2 < f3; r2++) S2();
    return N.push(w2.length), b2.push(v2.length), { L: new p({ values: v2, index: x2, ptr: b2, size: _2 }), U: new p({ values: w2, index: A2, ptr: N, size: D }), p: E, toString: function() {
      return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
    } };
  }
})), name$1o$1 = "qr", dependencies$1o$1 = ["typed", "matrix", "zeros", "identity", "isZero", "equal", "sign", "sqrt", "conj", "unaryMinus", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "complex"], createQr$1 = factory$1(name$1o$1, dependencies$1o$1, ((e2) => {
  var { typed: t2, matrix: r, zeros: n, identity: i2, isZero: a, equal: o, sign: s, sqrt: u, conj: c2, unaryMinus: l, addScalar: f2, divideScalar: p, multiplyScalar: m, subtractScalar: d, complex: h } = e2;
  return _extends$4(t2(name$1o$1, { DenseMatrix: function(e3) {
    return y(e3);
  }, SparseMatrix: function(e3) {
    return (function() {
      throw new Error("qr not implemented for sparse matrices yet");
    })();
  }, Array: function(e3) {
    var t3 = y(r(e3));
    return { Q: t3.Q.valueOf(), R: t3.R.valueOf() };
  } }), { _denseQRimpl: g });
  function g(e3) {
    var t3, r2, h2, g2 = e3._size[0], y2 = e3._size[1], v2 = i2([g2], "dense"), x2 = v2._data, b2 = e3.clone(), _2 = b2._data, w2 = n([g2], "");
    for (h2 = 0; h2 < Math.min(y2, g2); ++h2) {
      var A2 = _2[h2][h2], N = l(o(A2, 0) ? 1 : s(A2)), D = c2(N), E = 0;
      for (t3 = h2; t3 < g2; t3++) E = f2(E, m(_2[t3][h2], c2(_2[t3][h2])));
      var $2 = m(N, u(E));
      if (!a($2)) {
        var S2 = d(A2, $2);
        for (w2[h2] = 1, t3 = h2 + 1; t3 < g2; t3++) w2[t3] = p(_2[t3][h2], S2);
        var C2 = l(c2(p(S2, $2))), M2 = void 0;
        for (r2 = h2; r2 < y2; r2++) {
          for (M2 = 0, t3 = h2; t3 < g2; t3++) M2 = f2(M2, m(c2(w2[t3]), _2[t3][r2]));
          for (M2 = m(M2, C2), t3 = h2; t3 < g2; t3++) _2[t3][r2] = m(d(_2[t3][r2], m(w2[t3], M2)), D);
        }
        for (t3 = 0; t3 < g2; t3++) {
          for (M2 = 0, r2 = h2; r2 < g2; r2++) M2 = f2(M2, m(x2[t3][r2], w2[r2]));
          for (M2 = m(M2, C2), r2 = h2; r2 < g2; ++r2) x2[t3][r2] = p(d(x2[t3][r2], m(M2, c2(w2[r2]))), D);
        }
      }
    }
    return { Q: v2, R: b2, toString: function() {
      return "Q: " + this.Q.toString() + "\nR: " + this.R.toString();
    } };
  }
  function y(e3) {
    var t3 = g(e3), r2 = t3.R._data;
    if (e3._data.length > 0) for (var n3 = "Complex" === r2[0][0].type ? h(0) : 0, i3 = 0; i3 < r2.length; ++i3) for (var a2 = 0; a2 < i3 && a2 < (r2[0] || []).length; ++a2) r2[i3][a2] = n3;
    return t3;
  }
}));
function csPermute$1(e2, t2, r, n) {
  for (var i2 = e2._values, a = e2._index, o = e2._ptr, s = e2._size, u = e2._datatype, c2 = s[0], l = s[1], f2 = null, p = [], m = [], d = 0, h = 0; h < l; h++) {
    m[h] = d;
    for (var g = r ? r[h] : h, y = o[g], v2 = o[g + 1], x2 = y; x2 < v2; x2++) {
      var b2 = a[x2];
      p[d] = b2, f2 && (f2[d] = i2[x2]), d++;
    }
  }
  return m[l] = d, e2.createSparseMatrix({ values: f2, index: p, ptr: m, size: [c2, l], datatype: u });
}
function csTdfs$1(e2, t2, r, n, i2, a, o) {
  var s = 0;
  for (r[o] = e2; s >= 0; ) {
    var u = r[o + s], c2 = r[n + u];
    -1 === c2 ? (s--, a[t2++] = u) : (r[n + u] = r[i2 + c2], r[o + ++s] = c2);
  }
  return t2;
}
function csPost$1(e2, t2) {
  if (!e2) return null;
  var r, n = 0, i2 = [], a = [], o = t2, s = 2 * t2;
  for (r = 0; r < t2; r++) a[0 + r] = -1;
  for (r = t2 - 1; r >= 0; r--) -1 !== e2[r] && (a[o + r] = a[0 + e2[r]], a[0 + e2[r]] = r);
  for (r = 0; r < t2; r++) -1 === e2[r] && (n = csTdfs$1(r, n, a, 0, o, i2, s));
  return i2;
}
function csEtree$1(e2, t2) {
  if (!e2) return null;
  var r, n, i2 = e2._index, a = e2._ptr, o = e2._size, s = o[0], u = o[1], c2 = [], l = [], f2 = u;
  for (r = 0; r < s; r++) l[f2 + r] = -1;
  for (var p = 0; p < u; p++) {
    c2[p] = -1, l[0 + p] = -1;
    for (var m = a[p], d = a[p + 1], h = m; h < d; h++) {
      var g = i2[h];
      for (r = l[f2 + g]; -1 !== r && r < p; r = n) n = l[0 + r], l[0 + r] = p, -1 === n && (c2[r] = p);
      l[f2 + g] = p;
    }
  }
  return c2;
}
function csFkeep$1(e2, t2, r) {
  for (var n = e2._values, i2 = e2._index, a = e2._ptr, o = e2._size[1], s = 0, u = 0; u < o; u++) {
    var c2 = a[u];
    for (a[u] = s; c2 < a[u + 1]; c2++) t2(i2[c2], u, n ? n[c2] : 1, r) && (i2[s] = i2[c2], n && (n[s] = n[c2]), s++);
  }
  return a[o] = s, i2.splice(s, i2.length - s), n && n.splice(s, n.length - s), s;
}
function csFlip$1(e2) {
  return -e2 - 2;
}
var name$1n$1 = "csAmd", dependencies$1n$1 = ["add", "multiply", "transpose"], createCsAmd$1 = factory$1(name$1n$1, dependencies$1n$1, ((e2) => {
  var { add: t2, multiply: r, transpose: n } = e2;
  return function(e3, o) {
    if (!o || e3 <= 0 || e3 > 3) return null;
    var s = o._size, u = s[0], c2 = s[1], l = 0, f2 = Math.max(16, 10 * Math.sqrt(c2)), p = (function(e4, i3, a2, o2, s2) {
      var u2 = n(i3);
      if (1 === e4 && o2 === a2) return t2(i3, u2);
      if (2 === e4) {
        for (var c3 = u2._index, l2 = u2._ptr, f3 = 0, p2 = 0; p2 < a2; p2++) {
          var m2 = l2[p2];
          if (l2[p2] = f3, !(l2[p2 + 1] - m2 > s2)) for (var d2 = l2[p2 + 1]; m2 < d2; m2++) c3[f3++] = c3[m2];
        }
        return l2[a2] = f3, i3 = n(u2), r(u2, i3);
      }
      return r(u2, i3);
    })(e3, o, u, c2, f2 = Math.min(c2 - 2, f2));
    csFkeep$1(p, a, null);
    for (var m, d, h, g, y, v2, x2, b2, _2, w2, A2, N, D, E, $2, S2, C2 = p._index, M2 = p._ptr, T2 = M2[c2], F = [], O2 = [], k2 = c2 + 1, B2 = 2 * (c2 + 1), I2 = 3 * (c2 + 1), R2 = 4 * (c2 + 1), q2 = 5 * (c2 + 1), z2 = 6 * (c2 + 1), P2 = 7 * (c2 + 1), L2 = F, j2 = (function(e4, t3, r2, n3, a2, o2, s2, u2, c3, l2, f3, p2) {
      for (var m2 = 0; m2 < e4; m2++) r2[n3 + m2] = t3[m2 + 1] - t3[m2];
      r2[n3 + e4] = 0;
      for (var d2 = 0; d2 <= e4; d2++) r2[a2 + d2] = -1, o2[d2] = -1, r2[s2 + d2] = -1, r2[u2 + d2] = -1, r2[c3 + d2] = 1, r2[l2 + d2] = 1, r2[f3 + d2] = 0, r2[p2 + d2] = r2[n3 + d2];
      var h2 = i2(0, 0, r2, l2, e4);
      return r2[f3 + e4] = -2, t3[e4] = -1, r2[l2 + e4] = 0, h2;
    })(c2, M2, O2, 0, I2, L2, B2, P2, k2, z2, R2, q2), U2 = (function(e4, t3, r2, n3, i3, a2, o2, s2, u2, c3, l2) {
      for (var f3 = 0, p2 = 0; p2 < e4; p2++) {
        var m2 = r2[n3 + p2];
        if (0 === m2) r2[i3 + p2] = -2, f3++, t3[p2] = -1, r2[a2 + p2] = 0;
        else if (m2 > o2) r2[s2 + p2] = 0, r2[i3 + p2] = -1, f3++, t3[p2] = csFlip$1(e4), r2[s2 + e4]++;
        else {
          var d2 = r2[u2 + m2];
          -1 !== d2 && (c3[d2] = p2), r2[l2 + p2] = r2[u2 + m2], r2[u2 + m2] = p2;
        }
      }
      return f3;
    })(c2, M2, O2, q2, R2, z2, f2, k2, I2, L2, B2), Z2 = 0; U2 < c2; ) {
      for (h = -1; Z2 < c2 && -1 === (h = O2[I2 + Z2]); Z2++) ;
      -1 !== O2[B2 + h] && (L2[O2[B2 + h]] = -1), O2[I2 + Z2] = O2[B2 + h];
      var G2 = O2[R2 + h], V2 = O2[k2 + h];
      U2 += V2;
      var H2 = 0;
      O2[k2 + h] = -V2;
      var X2 = M2[h], W2 = 0 === G2 ? X2 : T2, Q2 = W2;
      for (g = 1; g <= G2 + 1; g++) {
        for (g > G2 ? (v2 = h, x2 = X2, b2 = O2[0 + h] - G2) : (x2 = M2[v2 = C2[X2++]], b2 = O2[0 + v2]), y = 1; y <= b2; y++) (_2 = O2[k2 + (m = C2[x2++])]) <= 0 || (H2 += _2, O2[k2 + m] = -_2, C2[Q2++] = m, -1 !== O2[B2 + m] && (L2[O2[B2 + m]] = L2[m]), -1 !== L2[m] ? O2[B2 + L2[m]] = O2[B2 + m] : O2[I2 + O2[q2 + m]] = O2[B2 + m]);
        v2 !== h && (M2[v2] = csFlip$1(h), O2[z2 + v2] = 0);
      }
      for (0 !== G2 && (T2 = Q2), O2[q2 + h] = H2, M2[h] = W2, O2[0 + h] = Q2 - W2, O2[R2 + h] = -2, j2 = i2(j2, l, O2, z2, c2), w2 = W2; w2 < Q2; w2++) if (!((A2 = O2[R2 + (m = C2[w2])]) <= 0)) {
        var Y2 = j2 - (_2 = -O2[k2 + m]);
        for (X2 = M2[m], N = M2[m] + A2 - 1; X2 <= N; X2++) O2[z2 + (v2 = C2[X2])] >= j2 ? O2[z2 + v2] -= _2 : 0 !== O2[z2 + v2] && (O2[z2 + v2] = O2[q2 + v2] + Y2);
      }
      for (w2 = W2; w2 < Q2; w2++) {
        for (D = (N = M2[m = C2[w2]]) + O2[R2 + m] - 1, E = N, $2 = 0, S2 = 0, X2 = N; X2 <= D; X2++) if (0 !== O2[z2 + (v2 = C2[X2])]) {
          var J = O2[z2 + v2] - j2;
          J > 0 ? (S2 += J, C2[E++] = v2, $2 += v2) : (M2[v2] = csFlip$1(h), O2[z2 + v2] = 0);
        }
        O2[R2 + m] = E - N + 1;
        var K2 = E, ee2 = N + O2[0 + m];
        for (X2 = D + 1; X2 < ee2; X2++) {
          var te2 = O2[k2 + (d = C2[X2])];
          te2 <= 0 || (S2 += te2, C2[E++] = d, $2 += d);
        }
        0 === S2 ? (M2[m] = csFlip$1(h), H2 -= _2 = -O2[k2 + m], V2 += _2, U2 += _2, O2[k2 + m] = 0, O2[R2 + m] = -1) : (O2[q2 + m] = Math.min(O2[q2 + m], S2), C2[E] = C2[K2], C2[K2] = C2[N], C2[N] = h, O2[0 + m] = E - N + 1, $2 = ($2 < 0 ? -$2 : $2) % c2, O2[B2 + m] = O2[P2 + $2], O2[P2 + $2] = m, L2[m] = $2);
      }
      for (O2[q2 + h] = H2, j2 = i2(j2 + (l = Math.max(l, H2)), l, O2, z2, c2), w2 = W2; w2 < Q2; w2++) if (!(O2[k2 + (m = C2[w2])] >= 0)) for (m = O2[P2 + ($2 = L2[m])], O2[P2 + $2] = -1; -1 !== m && -1 !== O2[B2 + m]; m = O2[B2 + m], j2++) {
        for (b2 = O2[0 + m], A2 = O2[R2 + m], X2 = M2[m] + 1; X2 <= M2[m] + b2 - 1; X2++) O2[z2 + C2[X2]] = j2;
        var re2 = m;
        for (d = O2[B2 + m]; -1 !== d; ) {
          var ne = O2[0 + d] === b2 && O2[R2 + d] === A2;
          for (X2 = M2[d] + 1; ne && X2 <= M2[d] + b2 - 1; X2++) O2[z2 + C2[X2]] !== j2 && (ne = 0);
          ne ? (M2[d] = csFlip$1(m), O2[k2 + m] += O2[k2 + d], O2[k2 + d] = 0, O2[R2 + d] = -1, d = O2[B2 + d], O2[B2 + re2] = d) : (re2 = d, d = O2[B2 + d]);
        }
      }
      for (X2 = W2, w2 = W2; w2 < Q2; w2++) (_2 = -O2[k2 + (m = C2[w2])]) <= 0 || (O2[k2 + m] = _2, S2 = O2[q2 + m] + H2 - _2, -1 !== O2[I2 + (S2 = Math.min(S2, c2 - U2 - _2))] && (L2[O2[I2 + S2]] = m), O2[B2 + m] = O2[I2 + S2], L2[m] = -1, O2[I2 + S2] = m, Z2 = Math.min(Z2, S2), O2[q2 + m] = S2, C2[X2++] = m);
      O2[k2 + h] = V2, 0 == (O2[0 + h] = X2 - W2) && (M2[h] = -1, O2[z2 + h] = 0), 0 !== G2 && (T2 = X2);
    }
    for (m = 0; m < c2; m++) M2[m] = csFlip$1(M2[m]);
    for (d = 0; d <= c2; d++) O2[I2 + d] = -1;
    for (d = c2; d >= 0; d--) O2[k2 + d] > 0 || (O2[B2 + d] = O2[I2 + M2[d]], O2[I2 + M2[d]] = d);
    for (v2 = c2; v2 >= 0; v2--) O2[k2 + v2] <= 0 || -1 !== M2[v2] && (O2[B2 + v2] = O2[I2 + M2[v2]], O2[I2 + M2[v2]] = v2);
    for (h = 0, m = 0; m <= c2; m++) -1 === M2[m] && (h = csTdfs$1(m, h, O2, I2, B2, F, z2));
    return F.splice(F.length - 1, 1), F;
  };
  function i2(e3, t3, r2, n3, i3) {
    if (e3 < 2 || e3 + t3 < 0) {
      for (var a2 = 0; a2 < i3; a2++) 0 !== r2[n3 + a2] && (r2[n3 + a2] = 1);
      e3 = 2;
    }
    return e3;
  }
  function a(e3, t3) {
    return e3 !== t3;
  }
}));
function csLeaf$1(e2, t2, r, n, i2, a, o) {
  var s, u, c2, l = 0;
  if (e2 <= t2 || r[n + t2] <= r[i2 + e2]) return -1;
  r[i2 + e2] = r[n + t2];
  var f2 = r[a + e2];
  if (r[a + e2] = t2, -1 === f2) l = 1, c2 = e2;
  else {
    for (l = 2, c2 = f2; c2 !== r[o + c2]; c2 = r[o + c2]) ;
    for (s = f2; s !== c2; s = u) u = r[o + s], r[o + s] = c2;
  }
  return { jleaf: l, q: c2 };
}
var name$1m$1 = "csCounts", dependencies$1m$1 = ["transpose"], createCsCounts$1 = factory$1(name$1m$1, dependencies$1m$1, ((e2) => {
  var { transpose: t2 } = e2;
  return function(e3, r, n, i2) {
    if (!e3 || !r || !n) return null;
    var a, o, s, u, c2, l, f2, p = e3._size, m = p[0], d = p[1], h = 4 * d + (i2 ? d + m + 1 : 0), g = [], y = d, v2 = 2 * d, x2 = 3 * d, b2 = 4 * d, _2 = 5 * d + 1;
    for (s = 0; s < h; s++) g[s] = -1;
    var w2 = [], A2 = t2(e3), N = A2._index, D = A2._ptr;
    for (s = 0; s < d; s++) for (w2[o = n[s]] = -1 === g[x2 + o] ? 1 : 0; -1 !== o && -1 === g[x2 + o]; o = r[o]) g[x2 + o] = s;
    if (i2) {
      for (s = 0; s < d; s++) g[n[s]] = s;
      for (a = 0; a < m; a++) {
        for (s = d, l = D[a], f2 = D[a + 1], c2 = l; c2 < f2; c2++) s = Math.min(s, g[N[c2]]);
        g[_2 + a] = g[b2 + s], g[b2 + s] = a;
      }
    }
    for (a = 0; a < d; a++) g[0 + a] = a;
    for (s = 0; s < d; s++) {
      for (-1 !== r[o = n[s]] && w2[r[o]]--, u = i2 ? g[b2 + s] : o; -1 !== u; u = i2 ? g[_2 + u] : -1) for (c2 = D[u]; c2 < D[u + 1]; c2++) {
        var E = csLeaf$1(a = N[c2], o, g, x2, y, v2, 0);
        E.jleaf >= 1 && w2[o]++, 2 === E.jleaf && w2[E.q]--;
      }
      -1 !== r[o] && (g[0 + o] = r[o]);
    }
    for (o = 0; o < d; o++) -1 !== r[o] && (w2[r[o]] += w2[o]);
    return w2;
  };
})), name$1l$1 = "csSqr", dependencies$1l$1 = ["add", "multiply", "transpose"], createCsSqr$1 = factory$1(name$1l$1, dependencies$1l$1, ((e2) => {
  var { add: t2, multiply: r, transpose: n } = e2, i2 = createCsAmd$1({ add: t2, multiply: r, transpose: n }), a = createCsCounts$1({ transpose: n });
  return function(e3, t3, r2) {
    var n3, o = t3._ptr, s = t3._size[1], u = {};
    if (u.q = i2(e3, t3), e3 && !u.q) return null;
    if (r2) {
      var c2 = e3 ? csPermute$1(t3, null, u.q) : t3;
      u.parent = csEtree$1(c2);
      var l = csPost$1(u.parent, s);
      if (u.cp = a(c2, u.parent, l, 1), c2 && u.parent && u.cp && (function(e4, t4) {
        var r3 = e4._ptr, n4 = e4._index, i3 = e4._size, a2 = i3[0], o2 = i3[1];
        t4.pinv = [], t4.leftmost = [];
        var s2, u2, c3, l2, f2, p = t4.parent, m = t4.pinv, d = t4.leftmost, h = [], g = 0, y = a2, v2 = a2 + o2, x2 = a2 + 2 * o2;
        for (u2 = 0; u2 < o2; u2++) h[y + u2] = -1, h[v2 + u2] = -1, h[x2 + u2] = 0;
        for (s2 = 0; s2 < a2; s2++) d[s2] = -1;
        for (u2 = o2 - 1; u2 >= 0; u2--) for (l2 = r3[u2], f2 = r3[u2 + 1], c3 = l2; c3 < f2; c3++) d[n4[c3]] = u2;
        for (s2 = a2 - 1; s2 >= 0; s2--) m[s2] = -1, -1 !== (u2 = d[s2]) && (0 == h[x2 + u2]++ && (h[v2 + u2] = s2), h[g + s2] = h[y + u2], h[y + u2] = s2);
        for (t4.lnz = 0, t4.m2 = a2, u2 = 0; u2 < o2; u2++) if (s2 = h[y + u2], t4.lnz++, s2 < 0 && (s2 = t4.m2++), m[s2] = u2, !(--x2[u2] <= 0)) {
          t4.lnz += h[x2 + u2];
          var b2 = p[u2];
          -1 !== b2 && (0 === h[x2 + b2] && (h[v2 + b2] = h[v2 + u2]), h[g + h[v2 + u2]] = h[y + b2], h[y + b2] = h[g + s2], h[x2 + b2] += h[x2 + u2]);
        }
        for (s2 = 0; s2 < a2; s2++) m[s2] < 0 && (m[s2] = u2++);
        return true;
      })(c2, u)) for (u.unz = 0, n3 = 0; n3 < s; n3++) u.unz += u.cp[n3];
    } else u.unz = 4 * o[s] + s, u.lnz = u.unz;
    return u;
  };
}));
function csMarked$1(e2, t2) {
  return e2[t2] < 0;
}
function csMark$1(e2, t2) {
  e2[t2] = csFlip$1(e2[t2]);
}
function csUnflip$1(e2) {
  return e2 < 0 ? csFlip$1(e2) : e2;
}
function csDfs$1(e2, t2, r, n, i2) {
  var a, o, s, u = t2._index, c2 = t2._ptr, l = t2._size[1], f2 = 0;
  for (n[0] = e2; f2 >= 0; ) {
    e2 = n[f2];
    var p = i2 ? i2[e2] : e2;
    csMarked$1(c2, e2) || (csMark$1(c2, e2), n[l + f2] = p < 0 ? 0 : csUnflip$1(c2[p]));
    var m = 1;
    for (o = n[l + f2], s = p < 0 ? 0 : csUnflip$1(c2[p + 1]); o < s; o++) if (!csMarked$1(c2, a = u[o])) {
      n[l + f2] = o, n[++f2] = a, m = 0;
      break;
    }
    m && (f2--, n[--r] = e2);
  }
  return r;
}
function csReach$1(e2, t2, r, n, i2) {
  var a, o, s, u = e2._ptr, c2 = e2._size, l = t2._index, f2 = t2._ptr, p = c2[1], m = p;
  for (o = f2[r], s = f2[r + 1], a = o; a < s; a++) {
    var d = l[a];
    csMarked$1(u, d) || (m = csDfs$1(d, e2, m, n, i2));
  }
  for (a = m; a < p; a++) csMark$1(u, n[a]);
  return m;
}
var name$1k$1 = "csSpsolve", dependencies$1k$1 = ["divideScalar", "multiply", "subtract"], createCsSpsolve$1 = factory$1(name$1k$1, dependencies$1k$1, ((e2) => {
  var { divideScalar: t2, multiply: r, subtract: n } = e2;
  return function(e3, i2, a, o, s, u, c2) {
    var l, f2, p, m, d = e3._values, h = e3._index, g = e3._ptr, y = e3._size[1], v2 = i2._values, x2 = i2._index, b2 = i2._ptr, _2 = csReach$1(e3, i2, a, o, u);
    for (l = _2; l < y; l++) s[o[l]] = 0;
    for (f2 = b2[a], p = b2[a + 1], l = f2; l < p; l++) s[x2[l]] = v2[l];
    for (var w2 = _2; w2 < y; w2++) {
      var A2 = o[w2], N = u ? u[A2] : A2;
      if (!(N < 0)) for (f2 = g[N], p = g[N + 1], s[A2] = t2(s[A2], d[c2 ? f2 : p - 1]), l = c2 ? f2 + 1 : f2, m = c2 ? p : p - 1; l < m; l++) {
        var D = h[l];
        s[D] = n(s[D], r(d[l], s[A2]));
      }
    }
    return _2;
  };
})), name$1j$1 = "csLu", dependencies$1j$1 = ["abs", "divideScalar", "multiply", "subtract", "larger", "largerEq", "SparseMatrix"], createCsLu$1 = factory$1(name$1j$1, dependencies$1j$1, ((e2) => {
  var { abs: t2, divideScalar: r, multiply: n, subtract: i2, larger: a, largerEq: o, SparseMatrix: s } = e2, u = createCsSpsolve$1({ divideScalar: r, multiply: n, subtract: i2 });
  return function(e3, i3, c2) {
    if (!e3) return null;
    var l, f2 = e3._size[1], p = 100, m = 100;
    i3 && (l = i3.q, p = i3.lnz || p, m = i3.unz || m);
    var d, h, g = [], y = [], v2 = [], x2 = new s({ values: g, index: y, ptr: v2, size: [f2, f2] }), b2 = [], _2 = [], w2 = [], A2 = new s({ values: b2, index: _2, ptr: w2, size: [f2, f2] }), N = [], D = [], E = [];
    for (d = 0; d < f2; d++) D[d] = 0, N[d] = -1, v2[d + 1] = 0;
    p = 0, m = 0;
    for (var $2 = 0; $2 < f2; $2++) {
      v2[$2] = p, w2[$2] = m;
      var S2 = l ? l[$2] : $2, C2 = u(x2, e3, S2, E, D, N, 1), M2 = -1, T2 = -1;
      for (h = C2; h < f2; h++) if (N[d = E[h]] < 0) {
        var F = t2(D[d]);
        a(F, T2) && (T2 = F, M2 = d);
      } else _2[m] = N[d], b2[m++] = D[d];
      if (-1 === M2 || T2 <= 0) return null;
      N[S2] < 0 && o(t2(D[S2]), n(T2, c2)) && (M2 = S2);
      var O2 = D[M2];
      for (_2[m] = $2, b2[m++] = O2, N[M2] = $2, y[p] = M2, g[p++] = 1, h = C2; h < f2; h++) N[d = E[h]] < 0 && (y[p] = d, g[p++] = r(D[d], O2)), D[d] = 0;
    }
    for (v2[f2] = p, w2[f2] = m, h = 0; h < p; h++) y[h] = N[y[h]];
    return g.splice(p, g.length - p), y.splice(p, y.length - p), b2.splice(m, b2.length - m), _2.splice(m, _2.length - m), { L: x2, U: A2, pinv: N };
  };
})), name$1i$1 = "slu", dependencies$1i$1 = ["typed", "abs", "add", "multiply", "transpose", "divideScalar", "subtract", "larger", "largerEq", "SparseMatrix"], createSlu$1 = factory$1(name$1i$1, dependencies$1i$1, ((e2) => {
  var { typed: t2, abs: r, add: n, multiply: i2, transpose: a, divideScalar: o, subtract: s, larger: u, largerEq: c2, SparseMatrix: l } = e2, f2 = createCsSqr$1({ add: n, multiply: i2, transpose: a }), p = createCsLu$1({ abs: r, divideScalar: o, multiply: i2, subtract: s, larger: u, largerEq: c2, SparseMatrix: l });
  return t2(name$1i$1, { "SparseMatrix, number, number": function(e3, t3, r2) {
    if (!isInteger$1(t3) || t3 < 0 || t3 > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
    if (r2 < 0 || r2 > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
    var n3 = f2(t3, e3, false), i3 = p(e3, n3, r2);
    return { L: i3.L, U: i3.U, p: i3.pinv, q: n3.q, toString: function() {
      return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
    } };
  } });
}));
function csIpvec$1(e2, t2) {
  var r, n = t2.length, i2 = [];
  if (e2) for (r = 0; r < n; r++) i2[e2[r]] = t2[r];
  else for (r = 0; r < n; r++) i2[r] = t2[r];
  return i2;
}
var name$1h$1 = "lusolve", dependencies$1h$1 = ["typed", "matrix", "lup", "slu", "usolve", "lsolve", "DenseMatrix"], createLusolve$1 = factory$1(name$1h$1, dependencies$1h$1, ((e2) => {
  var { typed: t2, matrix: r, lup: n, slu: i2, usolve: a, lsolve: o, DenseMatrix: s } = e2, u = createSolveValidation$1({ DenseMatrix: s });
  return t2(name$1h$1, { "Array, Array | Matrix": function(e3, t3) {
    e3 = r(e3);
    var i3 = n(e3);
    return l(i3.L, i3.U, i3.p, null, t3).valueOf();
  }, "DenseMatrix, Array | Matrix": function(e3, t3) {
    var r2 = n(e3);
    return l(r2.L, r2.U, r2.p, null, t3);
  }, "SparseMatrix, Array | Matrix": function(e3, t3) {
    var r2 = n(e3);
    return l(r2.L, r2.U, r2.p, null, t3);
  }, "SparseMatrix, Array | Matrix, number, number": function(e3, t3, r2, n3) {
    var a2 = i2(e3, r2, n3);
    return l(a2.L, a2.U, a2.p, a2.q, t3);
  }, "Object, Array | Matrix": function(e3, t3) {
    return l(e3.L, e3.U, e3.p, e3.q, t3);
  } });
  function c2(e3) {
    if (isMatrix$1(e3)) return e3;
    if (isArray$1$1(e3)) return r(e3);
    throw new TypeError("Invalid Matrix LU decomposition");
  }
  function l(e3, t3, r2, n3, i3) {
    e3 = c2(e3), t3 = c2(t3), r2 && ((i3 = u(e3, i3, true))._data = csIpvec$1(r2, i3._data));
    var s2 = o(e3, i3), l2 = a(t3, s2);
    return n3 && (l2._data = csIpvec$1(n3, l2._data)), l2;
  }
})), name$1g$1 = "polynomialRoot", dependencies$1g$1 = ["typed", "isZero", "equalScalar", "add", "subtract", "multiply", "divide", "sqrt", "unaryMinus", "cbrt", "typeOf", "im", "re"], createPolynomialRoot$1 = factory$1(name$1g$1, dependencies$1g$1, ((e2) => {
  var { typed: t2, isZero: r, equalScalar: n, add: i2, subtract: a, multiply: o, divide: s, sqrt: u, unaryMinus: c2, cbrt: l, typeOf: f2, im: p, re: m } = e2;
  return t2(name$1g$1, { "number|Complex, ...number|Complex": (e3, t3) => {
    for (var d = [e3, ...t3]; d.length > 0 && r(d[d.length - 1]); ) d.pop();
    if (d.length < 2) throw new RangeError("Polynomial [".concat(e3, ", ").concat(t3, "] must have a non-zero non-constant coefficient"));
    switch (d.length) {
      case 2:
        return [c2(s(d[0], d[1]))];
      case 3:
        var [h, g, y] = d, v2 = o(2, y), x2 = o(g, g), b2 = o(4, y, h);
        if (n(x2, b2)) return [s(c2(g), v2)];
        var _2 = u(a(x2, b2));
        return [s(a(_2, g), v2), s(a(c2(_2), g), v2)];
      case 4:
        var [w2, A2, N, D] = d, E = c2(o(3, D)), $2 = o(N, N), S2 = o(3, D, A2), C2 = i2(o(2, N, N, N), o(27, D, D, w2)), M2 = o(9, D, N, A2);
        if (n($2, S2) && n(C2, M2)) return [s(N, E)];
        var T2, F = a($2, S2), O2 = a(C2, M2), k2 = i2(o(18, D, N, A2, w2), o(N, N, A2, A2)), B2 = i2(o(4, N, N, N, w2), o(4, D, A2, A2, A2), o(27, D, D, w2, w2));
        if (n(k2, B2)) return [s(a(o(4, D, N, A2), i2(o(9, D, D, w2), o(N, N, N))), o(D, F)), s(a(o(9, D, w2), o(N, A2)), o(2, F))];
        T2 = n($2, S2) ? O2 : s(i2(O2, u(a(o(O2, O2), o(4, F, F, F)))), 2);
        return l(T2, true).toArray().map(((e4) => s(i2(N, e4, s(F, e4)), E))).map(((e4) => "Complex" === f2(e4) && n(m(e4), m(e4) + p(e4)) ? m(e4) : e4));
      default:
        throw new RangeError("only implemented for cubic or lower-order polynomials, not ".concat(d));
    }
  } });
})), name$1f$1 = "Help", dependencies$1f$1 = ["evaluate"], createHelpClass$1 = factory$1(name$1f$1, dependencies$1f$1, ((e2) => {
  var { evaluate: t2 } = e2;
  function r(e3) {
    if (!(this instanceof r)) throw new SyntaxError("Constructor must be called with the new operator");
    if (!e3) throw new Error('Argument "doc" missing');
    this.doc = e3;
  }
  return r.prototype.type = "Help", r.prototype.isHelp = true, r.prototype.toString = function() {
    var e3 = this.doc || {}, r2 = "\n";
    if (e3.name && (r2 += "Name: " + e3.name + "\n\n"), e3.category && (r2 += "Category: " + e3.category + "\n\n"), e3.description && (r2 += "Description:\n    " + e3.description + "\n\n"), e3.syntax && (r2 += "Syntax:\n    " + e3.syntax.join("\n    ") + "\n\n"), e3.examples) {
      r2 += "Examples:\n";
      for (var n = false, i2 = t2("config()"), a = { config: (e4) => (n = true, t2("config(newConfig)", { newConfig: e4 })) }, o = 0; o < e3.examples.length; o++) {
        var s = e3.examples[o];
        r2 += "    " + s + "\n";
        var u = void 0;
        try {
          u = t2(s, a);
        } catch (e4) {
          u = e4;
        }
        void 0 === u || isHelp$1(u) || (r2 += "        " + format$3(u, { precision: 14 }) + "\n");
      }
      r2 += "\n", n && t2("config(originalConfig)", { originalConfig: i2 });
    }
    return e3.mayThrow && e3.mayThrow.length && (r2 += "Throws: " + e3.mayThrow.join(", ") + "\n\n"), e3.seealso && e3.seealso.length && (r2 += "See also: " + e3.seealso.join(", ") + "\n"), r2;
  }, r.prototype.toJSON = function() {
    var e3 = clone$3$1(this.doc);
    return e3.mathjs = "Help", e3;
  }, r.fromJSON = function(e3) {
    var t3 = {};
    return Object.keys(e3).filter(((e4) => "mathjs" !== e4)).forEach(((r2) => {
      t3[r2] = e3[r2];
    })), new r(t3);
  }, r.prototype.valueOf = r.prototype.toString, r;
}), { isClass: true }), name$1e$1 = "Chain", dependencies$1e$1 = ["?on", "math", "typed"], createChainClass$1 = factory$1(name$1e$1, dependencies$1e$1, ((e2) => {
  var { on: t2, math: r, typed: n } = e2;
  function i2(e3) {
    if (!(this instanceof i2)) throw new SyntaxError("Constructor must be called with the new operator");
    isChain$1(e3) ? this.value = e3.value : this.value = e3;
  }
  function a(e3, t3) {
    lazy$1(i2.prototype, e3, (function() {
      var e4 = t3();
      if ("function" == typeof e4) return o(e4);
    }));
  }
  function o(e3) {
    return function() {
      if (0 === arguments.length) return new i2(e3(this.value));
      for (var t3 = [this.value], r2 = 0; r2 < arguments.length; r2++) t3[r2 + 1] = arguments[r2];
      if (n.isTypedFunction(e3)) {
        var a2 = n.resolve(e3, t3);
        if (1 === a2.params.length) throw new Error("chain function " + e3.name + " cannot match rest parameter between chain value and additional arguments.");
        return new i2(a2.implementation.apply(e3, t3));
      }
      return new i2(e3.apply(e3, t3));
    };
  }
  i2.prototype.type = "Chain", i2.prototype.isChain = true, i2.prototype.done = function() {
    return this.value;
  }, i2.prototype.valueOf = function() {
    return this.value;
  }, i2.prototype.toString = function() {
    return format$3(this.value);
  }, i2.prototype.toJSON = function() {
    return { mathjs: "Chain", value: this.value };
  }, i2.fromJSON = function(e3) {
    return new i2(e3.value);
  }, i2.createProxy = function(e3, t3) {
    if ("string" == typeof e3) !(function(e4, t4) {
      "function" == typeof t4 && (i2.prototype[e4] = o(t4));
    })(e3, t3);
    else {
      var r2 = function(t4) {
        hasOwnProperty$1$2(e3, t4) && void 0 === s[t4] && a(t4, (() => e3[t4]));
      };
      for (var n3 in e3) r2(n3);
    }
  };
  var s = { expression: true, docs: true, type: true, classes: true, json: true, error: true, isChain: true };
  return i2.createProxy(r), t2 && t2("import", (function(e3, t3, r2) {
    r2 || a(e3, t3);
  })), i2;
}), { isClass: true }), eDocs$1 = { name: "e", category: "Constants", syntax: ["e"], description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828", examples: ["e", "e ^ 2", "exp(2)", "log(e)"], seealso: ["exp"] }, falseDocs$1 = { name: "false", category: "Constants", syntax: ["false"], description: "Boolean value false", examples: ["false"], seealso: ["true"] }, iDocs$1 = { name: "i", category: "Constants", syntax: ["i"], description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.", examples: ["i", "i * i", "sqrt(-1)"], seealso: [] }, InfinityDocs$1 = { name: "Infinity", category: "Constants", syntax: ["Infinity"], description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.", examples: ["Infinity", "1 / 0"], seealso: [] }, LN10Docs$1 = { name: "LN10", category: "Constants", syntax: ["LN10"], description: "Returns the natural logarithm of 10, approximately equal to 2.302", examples: ["LN10", "log(10)"], seealso: [] }, LN2Docs$1 = { name: "LN2", category: "Constants", syntax: ["LN2"], description: "Returns the natural logarithm of 2, approximately equal to 0.693", examples: ["LN2", "log(2)"], seealso: [] }, LOG10EDocs$1 = { name: "LOG10E", category: "Constants", syntax: ["LOG10E"], description: "Returns the base-10 logarithm of E, approximately equal to 0.434", examples: ["LOG10E", "log(e, 10)"], seealso: [] }, LOG2EDocs$1 = { name: "LOG2E", category: "Constants", syntax: ["LOG2E"], description: "Returns the base-2 logarithm of E, approximately equal to 1.442", examples: ["LOG2E", "log(e, 2)"], seealso: [] }, NaNDocs$1 = { name: "NaN", category: "Constants", syntax: ["NaN"], description: "Not a number", examples: ["NaN", "0 / 0"], seealso: [] }, nullDocs$1 = { name: "null", category: "Constants", syntax: ["null"], description: "Value null", examples: ["null"], seealso: ["true", "false"] }, phiDocs$1 = { name: "phi", category: "Constants", syntax: ["phi"], description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...", examples: ["phi"], seealso: [] }, piDocs$1 = { name: "pi", category: "Constants", syntax: ["pi"], description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159", examples: ["pi", "sin(pi/2)"], seealso: ["tau"] }, SQRT12Docs$1 = { name: "SQRT1_2", category: "Constants", syntax: ["SQRT1_2"], description: "Returns the square root of 1/2, approximately equal to 0.707", examples: ["SQRT1_2", "sqrt(1/2)"], seealso: [] }, SQRT2Docs$1 = { name: "SQRT2", category: "Constants", syntax: ["SQRT2"], description: "Returns the square root of 2, approximately equal to 1.414", examples: ["SQRT2", "sqrt(2)"], seealso: [] }, tauDocs$1 = { name: "tau", category: "Constants", syntax: ["tau"], description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.", examples: ["tau", "2 * pi"], seealso: ["pi"] }, trueDocs$1 = { name: "true", category: "Constants", syntax: ["true"], description: "Boolean value true", examples: ["true"], seealso: ["false"] }, versionDocs$1 = { name: "version", category: "Constants", syntax: ["version"], description: "A string with the version number of math.js", examples: ["version"], seealso: [] }, bignumberDocs$1 = { name: "bignumber", category: "Construction", syntax: ["bignumber(x)"], description: "Create a big number from a number or string.", examples: ["0.1 + 0.2", "bignumber(0.1) + bignumber(0.2)", 'bignumber("7.2")', 'bignumber("7.2e500")', "bignumber([0.1, 0.2, 0.3])"], seealso: ["boolean", "bigint", "complex", "fraction", "index", "matrix", "string", "unit"] }, bigintDocs$1 = { name: "bigint", category: "Construction", syntax: ["bigint(x)"], description: "Create a bigint, an integer with an arbitrary number of digits, from a number or string.", examples: ["123123123123123123 # a large number will lose digits", 'bigint("123123123123123123")', 'bignumber(["1", "3", "5"])'], seealso: ["boolean", "bignumber", "number", "complex", "fraction", "index", "matrix", "string", "unit"] }, booleanDocs$1 = { name: "boolean", category: "Construction", syntax: ["x", "boolean(x)"], description: "Convert a string or number into a boolean.", examples: ["boolean(0)", "boolean(1)", "boolean(3)", 'boolean("true")', 'boolean("false")', "boolean([1, 0, 1, 1])"], seealso: ["bignumber", "complex", "index", "matrix", "number", "string", "unit"] }, complexDocs$1 = { name: "complex", category: "Construction", syntax: ["complex()", "complex(re, im)", "complex(string)"], description: "Create a complex number.", examples: ["complex()", "complex(2, 3)", 'complex("7 - 2i")'], seealso: ["bignumber", "boolean", "index", "matrix", "number", "string", "unit"] }, createUnitDocs$1 = { name: "createUnit", category: "Construction", syntax: ["createUnit(definitions)", "createUnit(name, definition)"], description: "Create a user-defined unit and register it with the Unit type.", examples: ['createUnit("foo")', 'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})', 'createUnit("mph", "1 mile/hour")'], seealso: ["unit", "splitUnit"] }, fractionDocs$1 = { name: "fraction", category: "Construction", syntax: ["fraction(num)", "fraction(matrix)", "fraction(num,den)", "fraction({n: num, d: den})"], description: "Create a fraction from a number or from integer numerator and denominator.", examples: ["fraction(0.125)", "fraction(1, 3) + fraction(2, 5)", "fraction({n: 333, d: 53})", "fraction([sqrt(9), sqrt(10), sqrt(11)])"], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "string", "unit"] }, indexDocs$1 = { name: "index", category: "Construction", syntax: ["[start]", "[start:end]", "[start:step:end]", "[start1, start 2, ...]", "[start1:end1, start2:end2, ...]", "[start1:step1:end1, start2:step2:end2, ...]"], description: "Create an index to get or replace a subset of a matrix", examples: ["A = [1, 2, 3; 4, 5, 6]", "A[1, :]", "A[1, 2] = 50", "A[1:2, 1:2] = 1", "B = [1, 2, 3]", "B[B>1 and B<3]"], seealso: ["bignumber", "boolean", "complex", "matrix", "number", "range", "string", "unit"] }, matrixDocs$1 = { name: "matrix", category: "Construction", syntax: ["[]", "[a1, b1, ...; a2, b2, ...]", "matrix()", 'matrix("dense")', "matrix([...])"], description: "Create a matrix.", examples: ["[]", "[1, 2, 3]", "[1, 2, 3; 4, 5, 6]", "matrix()", "matrix([3, 4])", 'matrix([3, 4; 5, 6], "sparse")', 'matrix([3, 4; 5, 6], "sparse", "number")'], seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "sparse"] }, numberDocs$1 = { name: "number", category: "Construction", syntax: ["x", "number(x)", "number(unit, valuelessUnit)"], description: "Create a number or convert a string or boolean into a number.", examples: ["2", "2e3", "4.05", "number(2)", 'number("7.2")', "number(true)", "number([true, false, true, true])", 'number(unit("52cm"), "m")'], seealso: ["bignumber", "bigint", "boolean", "complex", "fraction", "index", "matrix", "string", "unit"] }, sparseDocs$1 = { name: "sparse", category: "Construction", syntax: ["sparse()", "sparse([a1, b1, ...; a1, b2, ...])", 'sparse([a1, b1, ...; a1, b2, ...], "number")'], description: "Create a sparse matrix.", examples: ["sparse()", "sparse([3, 4; 5, 6])", 'sparse([3, 0; 5, 0], "number")'], seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "matrix"] }, splitUnitDocs$1 = { name: "splitUnit", category: "Construction", syntax: ["splitUnit(unit: Unit, parts: Unit[])"], description: "Split a unit in an array of units whose sum is equal to the original unit.", examples: ['splitUnit(1 m, ["feet", "inch"])'], seealso: ["unit", "createUnit"] }, stringDocs$1 = { name: "string", category: "Construction", syntax: ['"text"', "string(x)"], description: "Create a string or convert a value to a string", examples: ['"Hello World!"', "string(4.2)", "string(3 + 2i)"], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "unit"] }, unitDocs$1 = { name: "unit", category: "Construction", syntax: ["value unit", "unit(value, unit)", "unit(string)"], description: "Create a unit.", examples: ["5.5 mm", "3 inch", 'unit(7.1, "kilogram")', 'unit("23 deg")'], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "string"] }, configDocs$1 = { name: "config", category: "Core", syntax: ["config()", "config(options)"], description: "Get configuration or change configuration.", examples: ["config()", "1/3 + 1/4", 'config({number: "Fraction"})', "1/3 + 1/4"], seealso: [] }, importDocs$1 = { name: "import", category: "Core", syntax: ["import(functions)", "import(functions, options)"], description: "Import functions or constants from an object.", examples: ["import({myFn: f(x)=x^2, myConstant: 32 })", "myFn(2)", "myConstant"], seealso: [] }, typedDocs$1 = { name: "typed", category: "Core", syntax: ["typed(signatures)", "typed(name, signatures)"], description: "Create a typed function.", examples: ['double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })', "double(2)", 'double("hello")'], seealso: [] }, derivativeDocs$1 = { name: "derivative", category: "Algebra", syntax: ["derivative(expr, variable)", "derivative(expr, variable, {simplify: boolean})"], description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.", examples: ['derivative("2x^3", "x")', 'derivative("2x^3", "x", {simplify: false})', 'derivative("2x^2 + 3x + 4", "x")', 'derivative("sin(2x)", "x")', 'f = parse("x^2 + x")', 'x = parse("x")', "df = derivative(f, x)", "df.evaluate({x: 3})"], seealso: ["simplify", "parse", "evaluate"] }, leafCountDocs$1 = { name: "leafCount", category: "Algebra", syntax: ["leafCount(expr)"], description: "Computes the number of leaves in the parse tree of the given expression", examples: ['leafCount("e^(i*pi)-1")', 'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'], seealso: ["simplify"] }, lsolveDocs$1 = { name: "lsolve", category: "Algebra", syntax: ["x=lsolve(L, b)"], description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"], seealso: ["lsolveAll", "lup", "lusolve", "usolve", "matrix", "sparse"] }, lsolveAllDocs$1 = { name: "lsolveAll", category: "Algebra", syntax: ["x=lsolveAll(L, b)"], description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"], seealso: ["lsolve", "lup", "lusolve", "usolve", "matrix", "sparse"] }, lupDocs$1 = { name: "lup", category: "Algebra", syntax: ["lup(m)"], description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U", examples: ["lup([[2, 1], [1, 4]])", "lup(matrix([[2, 1], [1, 4]]))", "lup(sparse([[2, 1], [1, 4]]))"], seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "slu", "qr"] }, lusolveDocs$1 = { name: "lusolve", category: "Algebra", syntax: ["x=lusolve(A, b)", "x=lusolve(lu, b)"], description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lusolve(a, b)"], seealso: ["lup", "slu", "lsolve", "usolve", "matrix", "sparse"] }, polynomialRootDocs$1 = { name: "polynomialRoot", category: "Algebra", syntax: ["x=polynomialRoot(-6, 3)", "x=polynomialRoot(4, -4, 1)", "x=polynomialRoot(-8, 12, -6, 1)"], description: "Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.", examples: ["a = polynomialRoot(-6, 11, -6, 1)"], seealso: ["cbrt", "sqrt"] }, qrDocs$1 = { name: "qr", category: "Algebra", syntax: ["qr(A)"], description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.", examples: ["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"], seealso: ["lup", "slu", "matrix"] }, rationalizeDocs$1 = { name: "rationalize", category: "Algebra", syntax: ["rationalize(expr)", "rationalize(expr, scope)", "rationalize(expr, scope, detailed)"], description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.", examples: ['rationalize("2x/y - y/(x+1)")', 'rationalize("2x/y - y/(x+1)", true)'], seealso: ["simplify"] }, resolveDocs$1 = { name: "resolve", category: "Algebra", syntax: ["resolve(node, scope)"], description: "Recursively substitute variables in an expression tree.", examples: ['resolve(parse("1 + x"), { x: 7 })', 'resolve(parse("size(text)"), { text: "Hello World" })', 'resolve(parse("x + y"), { x: parse("3z") })', 'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'], seealso: ["simplify", "evaluate"], mayThrow: ["ReferenceError"] }, simplifyDocs$1 = { name: "simplify", category: "Algebra", syntax: ["simplify(expr)", "simplify(expr, rules)"], description: "Simplify an expression tree.", examples: ['simplify("3 + 2 / 4")', 'simplify("2x + x")', 'f = parse("x * (x + 2 + x)")', "simplified = simplify(f)", "simplified.evaluate({x: 2})"], seealso: ["simplifyCore", "derivative", "evaluate", "parse", "rationalize", "resolve"] }, simplifyConstantDocs$1 = { name: "simplifyConstant", category: "Algebra", syntax: ["simplifyConstant(expr)", "simplifyConstant(expr, options)"], description: "Replace constant subexpressions of node with their values.", examples: ['simplifyConstant("(3-3)*x")', 'simplifyConstant(parse("z-cos(tau/8)"))'], seealso: ["simplify", "simplifyCore", "evaluate"] }, simplifyCoreDocs$1 = { name: "simplifyCore", category: "Algebra", syntax: ["simplifyCore(node)"], description: "Perform simple one-pass simplifications on an expression tree.", examples: ['simplifyCore(parse("0*x"))', 'simplifyCore(parse("(x+0)*2"))'], seealso: ["simplify", "simplifyConstant", "evaluate"] }, sluDocs$1 = { name: "slu", category: "Algebra", syntax: ["slu(A, order, threshold)"], description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U", examples: ["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"], seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "lup", "qr"] }, symbolicEqualDocs$1 = { name: "symbolicEqual", category: "Algebra", syntax: ["symbolicEqual(expr1, expr2)", "symbolicEqual(expr1, expr2, options)"], description: "Returns true if the difference of the expressions simplifies to 0", examples: ['symbolicEqual("x*y","y*x")', 'symbolicEqual("abs(x^2)", "x^2")', 'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'], seealso: ["simplify", "evaluate"] }, usolveDocs$1 = { name: "usolve", category: "Algebra", syntax: ["x=usolve(U, b)"], description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.", examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"], seealso: ["usolveAll", "lup", "lusolve", "lsolve", "matrix", "sparse"] }, usolveAllDocs$1 = { name: "usolveAll", category: "Algebra", syntax: ["x=usolve(U, b)"], description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.", examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"], seealso: ["usolve", "lup", "lusolve", "lsolve", "matrix", "sparse"] }, absDocs$1 = { name: "abs", category: "Arithmetic", syntax: ["abs(x)"], description: "Compute the absolute value.", examples: ["abs(3.5)", "abs(-4.2)"], seealso: ["sign"] }, addDocs$1 = { name: "add", category: "Operators", syntax: ["x + y", "add(x, y)"], description: "Add two values.", examples: ["a = 2.1 + 3.6", "a - 3.6", "3 + 2i", "3 cm + 2 inch", '"2.3" + "4"'], seealso: ["subtract"] }, cbrtDocs$1 = { name: "cbrt", category: "Arithmetic", syntax: ["cbrt(x)", "cbrt(x, allRoots)"], description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned", examples: ["cbrt(64)", "cube(4)", "cbrt(-8)", "cbrt(2 + 3i)", "cbrt(8i)", "cbrt(8i, true)", "cbrt(27 m^3)"], seealso: ["square", "sqrt", "cube", "multiply"] }, ceilDocs$1 = { name: "ceil", category: "Arithmetic", syntax: ["ceil(x)", "ceil(x, n)", "ceil(unit, valuelessUnit)", "ceil(unit, n, valuelessUnit)"], description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.", examples: ["ceil(3.2)", "ceil(3.8)", "ceil(-4.2)", "ceil(3.241cm, cm)", "ceil(3.241cm, 2, cm)"], seealso: ["floor", "fix", "round"] }, cubeDocs$1 = { name: "cube", category: "Arithmetic", syntax: ["cube(x)"], description: "Compute the cube of a value. The cube of x is x * x * x.", examples: ["cube(2)", "2^3", "2 * 2 * 2"], seealso: ["multiply", "square", "pow"] }, divideDocs$1 = { name: "divide", category: "Operators", syntax: ["x / y", "divide(x, y)"], description: "Divide two values.", examples: ["a = 2 / 3", "a * 3", "4.5 / 2", "3 + 4 / 2", "(3 + 4) / 2", "18 km / 4.5"], seealso: ["multiply"] }, dotDivideDocs$1 = { name: "dotDivide", category: "Operators", syntax: ["x ./ y", "dotDivide(x, y)"], description: "Divide two values element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a ./ b"], seealso: ["multiply", "dotMultiply", "divide"] }, dotMultiplyDocs$1 = { name: "dotMultiply", category: "Operators", syntax: ["x .* y", "dotMultiply(x, y)"], description: "Multiply two values element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a .* b"], seealso: ["multiply", "divide", "dotDivide"] }, dotPowDocs$1 = { name: "dotPow", category: "Operators", syntax: ["x .^ y", "dotPow(x, y)"], description: "Calculates the power of x to y element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "a .^ 2"], seealso: ["pow"] }, expDocs$1 = { name: "exp", category: "Arithmetic", syntax: ["exp(x)"], description: "Calculate the exponent of a value.", examples: ["exp(1.3)", "e ^ 1.3", "log(exp(1.3))", "x = 2.4", "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"], seealso: ["expm", "expm1", "pow", "log"] }, expmDocs$1 = { name: "expm", category: "Arithmetic", syntax: ["exp(x)"], description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.", examples: ["expm([[0,2],[0,0]])"], seealso: ["exp"] }, expm1Docs$1 = { name: "expm1", category: "Arithmetic", syntax: ["expm1(x)"], description: "Calculate the value of subtracting 1 from the exponential value.", examples: ["expm1(2)", "pow(e, 2) - 1", "log(expm1(2) + 1)"], seealso: ["exp", "pow", "log"] }, fixDocs$1 = { name: "fix", category: "Arithmetic", syntax: ["fix(x)", "fix(x, n)", "fix(unit, valuelessUnit)", "fix(unit, n, valuelessUnit)"], description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.", examples: ["fix(3.2)", "fix(3.8)", "fix(-4.2)", "fix(-4.8)", "fix(3.241cm, cm)", "fix(3.241cm, 2, cm)"], seealso: ["ceil", "floor", "round"] }, floorDocs$1 = { name: "floor", category: "Arithmetic", syntax: ["floor(x)", "floor(x, n)", "floor(unit, valuelessUnit)", "floor(unit, n, valuelessUnit)"], description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.", examples: ["floor(3.2)", "floor(3.8)", "floor(-4.2)", "floor(3.241cm, cm)", "floor(3.241cm, 2, cm)"], seealso: ["ceil", "fix", "round"] }, gcdDocs$1 = { name: "gcd", category: "Arithmetic", syntax: ["gcd(a, b)", "gcd(a, b, c, ...)"], description: "Compute the greatest common divisor.", examples: ["gcd(8, 12)", "gcd(-4, 6)", "gcd(25, 15, -10)"], seealso: ["lcm", "xgcd"] }, hypotDocs$1 = { name: "hypot", category: "Arithmetic", syntax: ["hypot(a, b, c, ...)", "hypot([a, b, c, ...])"], description: "Calculate the hypotenuse of a list with values.", examples: ["hypot(3, 4)", "sqrt(3^2 + 4^2)", "hypot(-2)", "hypot([3, 4, 5])"], seealso: ["abs", "norm"] }, invmodDocs$1 = { name: "invmod", category: "Arithmetic", syntax: ["invmod(a, b)"], description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)", examples: ["invmod(8, 12)", "invmod(7, 13)", "invmod(15151, 15122)"], seealso: ["gcd", "xgcd"] }, lcmDocs$1 = { name: "lcm", category: "Arithmetic", syntax: ["lcm(x, y)"], description: "Compute the least common multiple.", examples: ["lcm(4, 6)", "lcm(6, 21)", "lcm(6, 21, 5)"], seealso: ["gcd"] }, logDocs$1 = { name: "log", category: "Arithmetic", syntax: ["log(x)", "log(x, base)"], description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).", examples: ["log(3.5)", "a = log(2.4)", "exp(a)", "10 ^ 4", "log(10000, 10)", "log(10000) / log(10)", "b = log(1024, 2)", "2 ^ b"], seealso: ["exp", "log1p", "log2", "log10"] }, log10Docs$1 = { name: "log10", category: "Arithmetic", syntax: ["log10(x)"], description: "Compute the 10-base logarithm of a value.", examples: ["log10(0.00001)", "log10(10000)", "10 ^ 4", "log(10000) / log(10)", "log(10000, 10)"], seealso: ["exp", "log"] }, log1pDocs$1 = { name: "log1p", category: "Arithmetic", syntax: ["log1p(x)", "log1p(x, base)"], description: "Calculate the logarithm of a `value+1`", examples: ["log1p(2.5)", "exp(log1p(1.4))", "pow(10, 4)", "log1p(9999, 10)", "log1p(9999) / log(10)"], seealso: ["exp", "log", "log2", "log10"] }, log2Docs$1 = { name: "log2", category: "Arithmetic", syntax: ["log2(x)"], description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.", examples: ["log2(0.03125)", "log2(16)", "log2(16) / log2(2)", "pow(2, 4)"], seealso: ["exp", "log1p", "log", "log10"] }, modDocs$1 = { name: "mod", category: "Operators", syntax: ["x % y", "x mod y", "mod(x, y)"], description: "Calculates the modulus, the remainder of an integer division.", examples: ["7 % 3", "11 % 2", "10 mod 4", "isOdd(x) = x % 2", "isOdd(2)", "isOdd(3)"], seealso: ["divide"] }, multiplyDocs$1 = { name: "multiply", category: "Operators", syntax: ["x * y", "multiply(x, y)"], description: "multiply two values.", examples: ["a = 2.1 * 3.4", "a / 3.4", "2 * 3 + 4", "2 * (3 + 4)", "3 * 2.1 km"], seealso: ["divide"] }, normDocs$1 = { name: "norm", category: "Arithmetic", syntax: ["norm(x)", "norm(x, p)"], description: "Calculate the norm of a number, vector or matrix.", examples: ["abs(-3.5)", "norm(-3.5)", "norm(3 - 4i)", "norm([1, 2, -3], Infinity)", "norm([1, 2, -3], -Infinity)", "norm([3, 4], 2)", "norm([[1, 2], [3, 4]], 1)", 'norm([[1, 2], [3, 4]], "inf")', 'norm([[1, 2], [3, 4]], "fro")'] }, nthRootDocs$1 = { name: "nthRoot", category: "Arithmetic", syntax: ["nthRoot(a)", "nthRoot(a, root)"], description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".', examples: ["4 ^ 3", "nthRoot(64, 3)", "nthRoot(9, 2)", "sqrt(9)"], seealso: ["nthRoots", "pow", "sqrt"] }, nthRootsDocs$1 = { name: "nthRoots", category: "Arithmetic", syntax: ["nthRoots(A)", "nthRoots(A, root)"], description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.', examples: ["nthRoots(1)", "nthRoots(1, 3)"], seealso: ["sqrt", "pow", "nthRoot"] }, powDocs$1 = { name: "pow", category: "Operators", syntax: ["x ^ y", "pow(x, y)"], description: "Calculates the power of x to y, x^y.", examples: ["2^3", "2*2*2", "1 + e ^ (pi * i)", "pow([[1, 2], [4, 3]], 2)", "pow([[1, 2], [4, 3]], -1)"], seealso: ["multiply", "nthRoot", "nthRoots", "sqrt"] }, roundDocs$1 = { name: "round", category: "Arithmetic", syntax: ["round(x)", "round(x, n)", "round(unit, valuelessUnit)", "round(unit, n, valuelessUnit)"], description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.", examples: ["round(3.2)", "round(3.8)", "round(-4.2)", "round(-4.8)", "round(pi, 3)", "round(123.45678, 2)", "round(3.241cm, 2, cm)", "round([3.2, 3.8, -4.7])"], seealso: ["ceil", "floor", "fix"] }, signDocs$1 = { name: "sign", category: "Arithmetic", syntax: ["sign(x)"], description: "Compute the sign of a value. The sign of a value x is 1 when x>0, -1 when x<0, and 0 when x=0.", examples: ["sign(3.5)", "sign(-4.2)", "sign(0)"], seealso: ["abs"] }, sqrtDocs$1 = { name: "sqrt", category: "Arithmetic", syntax: ["sqrt(x)"], description: "Compute the square root value. If x = y * y, then y is the square root of x.", examples: ["sqrt(25)", "5 * 5", "sqrt(-1)"], seealso: ["square", "sqrtm", "multiply", "nthRoot", "nthRoots", "pow"] }, sqrtmDocs$1 = { name: "sqrtm", category: "Arithmetic", syntax: ["sqrtm(x)"], description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.", examples: ["sqrtm([[33, 24], [48, 57]])"], seealso: ["sqrt", "abs", "square", "multiply"] }, sylvesterDocs$1 = { name: "sylvester", category: "Algebra", syntax: ["sylvester(A,B,C)"], description: "Solves the real-valued Sylvester equation AX+XB=C for X", examples: ["sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])", "A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]", "sylvester(A, B, C)"], seealso: ["schur", "lyap"] }, schurDocs$1 = { name: "schur", category: "Algebra", syntax: ["schur(A)"], description: "Performs a real Schur decomposition of the real matrix A = UTU'", examples: ["schur([[1, 0], [-4, 3]])", "A = [[1, 0], [-4, 3]]", "schur(A)"], seealso: ["lyap", "sylvester"] }, lyapDocs$1 = { name: "lyap", category: "Algebra", syntax: ["lyap(A,Q)"], description: "Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P", examples: ["lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])", "A = [[-2, 0], [1, -4]]", "Q = [[3, 1], [1, 3]]", "lyap(A,Q)"], seealso: ["schur", "sylvester"] }, squareDocs$1 = { name: "square", category: "Arithmetic", syntax: ["square(x)"], description: "Compute the square of a value. The square of x is x * x.", examples: ["square(3)", "sqrt(9)", "3^2", "3 * 3"], seealso: ["multiply", "pow", "sqrt", "cube"] }, subtractDocs$1 = { name: "subtract", category: "Operators", syntax: ["x - y", "subtract(x, y)"], description: "subtract two values.", examples: ["a = 5.3 - 2", "a + 2", "2/3 - 1/6", "2 * 3 - 3", "2.1 km - 500m"], seealso: ["add"] }, unaryMinusDocs$1 = { name: "unaryMinus", category: "Operators", syntax: ["-x", "unaryMinus(x)"], description: "Inverse the sign of a value. Converts booleans and strings to numbers.", examples: ["-4.5", "-(-5.6)", '-"22"'], seealso: ["add", "subtract", "unaryPlus"] }, unaryPlusDocs$1 = { name: "unaryPlus", category: "Operators", syntax: ["+x", "unaryPlus(x)"], description: "Converts booleans and strings to numbers.", examples: ["+true", '+"2"'], seealso: ["add", "subtract", "unaryMinus"] }, xgcdDocs$1 = { name: "xgcd", category: "Arithmetic", syntax: ["xgcd(a, b)"], description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.", examples: ["xgcd(8, 12)", "gcd(8, 12)", "xgcd(36163, 21199)"], seealso: ["gcd", "lcm"] }, bitAndDocs$1 = { name: "bitAnd", category: "Bitwise", syntax: ["x & y", "bitAnd(x, y)"], description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0", examples: ["5 & 3", "bitAnd(53, 131)", "[1, 12, 31] & 42"], seealso: ["bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitNotDocs$1 = { name: "bitNot", category: "Bitwise", syntax: ["~x", "bitNot(x)"], description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.", examples: ["~1", "~2", "bitNot([2, -3, 4])"], seealso: ["bitAnd", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitOrDocs$1 = { name: "bitOr", category: "Bitwise", syntax: ["x | y", "bitOr(x, y)"], description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.", examples: ["5 | 3", "bitOr([1, 2, 3], 4)"], seealso: ["bitAnd", "bitNot", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitXorDocs$1 = { name: "bitXor", category: "Bitwise", syntax: ["bitXor(x, y)"], description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.", examples: ["bitOr(1, 2)", "bitXor([2, 3, 4], 4)"], seealso: ["bitAnd", "bitNot", "bitOr", "leftShift", "rightArithShift", "rightLogShift"] }, leftShiftDocs$1 = { name: "leftShift", category: "Bitwise", syntax: ["x << y", "leftShift(x, y)"], description: "Bitwise left logical shift of a value x by y number of bits.", examples: ["4 << 1", "8 >> 1"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "rightArithShift", "rightLogShift"] }, rightArithShiftDocs$1 = { name: "rightArithShift", category: "Bitwise", syntax: ["x >> y", "rightArithShift(x, y)"], description: "Bitwise right arithmetic shift of a value x by y number of bits.", examples: ["8 >> 1", "4 << 1", "-12 >> 2"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightLogShift"] }, rightLogShiftDocs$1 = { name: "rightLogShift", category: "Bitwise", syntax: ["x >>> y", "rightLogShift(x, y)"], description: "Bitwise right logical shift of a value x by y number of bits.", examples: ["8 >>> 1", "4 << 1", "-12 >>> 2"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift"] }, bellNumbersDocs$1 = { name: "bellNumbers", category: "Combinatorics", syntax: ["bellNumbers(n)"], description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.", examples: ["bellNumbers(3)", "bellNumbers(8)"], seealso: ["stirlingS2"] }, catalanDocs$1 = { name: "catalan", category: "Combinatorics", syntax: ["catalan(n)"], description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.", examples: ["catalan(3)", "catalan(8)"], seealso: ["bellNumbers"] }, compositionDocs$1 = { name: "composition", category: "Combinatorics", syntax: ["composition(n, k)"], description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.", examples: ["composition(5, 3)"], seealso: ["combinations"] }, stirlingS2Docs$1 = { name: "stirlingS2", category: "Combinatorics", syntax: ["stirlingS2(n, k)"], description: "The Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.", examples: ["stirlingS2(5, 3)"], seealso: ["bellNumbers", "bernoulli"] }, argDocs$1 = { name: "arg", category: "Complex", syntax: ["arg(x)"], description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).", examples: ["arg(2 + 2i)", "atan2(3, 2)", "arg(2 + 3i)"], seealso: ["re", "im", "conj", "abs"] }, conjDocs$1 = { name: "conj", category: "Complex", syntax: ["conj(x)"], description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.", examples: ["conj(2 + 3i)", "conj(2 - 3i)", "conj(-5.2i)"], seealso: ["re", "im", "abs", "arg"] }, imDocs$1 = { name: "im", category: "Complex", syntax: ["im(x)"], description: "Get the imaginary part of a complex number.", examples: ["im(2 + 3i)", "re(2 + 3i)", "im(-5.2i)", "im(2.4)"], seealso: ["re", "conj", "abs", "arg"] }, reDocs$1 = { name: "re", category: "Complex", syntax: ["re(x)"], description: "Get the real part of a complex number.", examples: ["re(2 + 3i)", "im(2 + 3i)", "re(-5.2i)", "re(2.4)"], seealso: ["im", "conj", "abs", "arg"] }, evaluateDocs$1 = { name: "evaluate", category: "Expression", syntax: ["evaluate(expression)", "evaluate(expression, scope)", "evaluate([expr1, expr2, expr3, ...])", "evaluate([expr1, expr2, expr3, ...], scope)"], description: "Evaluate an expression or an array with expressions.", examples: ['evaluate("2 + 3")', 'evaluate("sqrt(16)")', 'evaluate("2 inch to cm")', 'evaluate("sin(x * pi)", { "x": 1/2 })', 'evaluate(["width=2", "height=4","width*height"])'], seealso: ["parser", "parse", "compile"] }, parserDocs$1 = { name: "parser", category: "Expression", syntax: ["parser()"], description: "Create a parser object that keeps a context of variables and their values, allowing the evaluation of expressions in that context.", examples: ["myParser = parser()", 'myParser.evaluate("sqrt(3^2 + 4^2)")', 'myParser.set("x", 3)', 'myParser.evaluate("y = x + 3")', 'myParser.evaluate(["y = x + 3", "y = y + 1"])', 'myParser.get("y")'], seealso: ["evaluate", "parse", "compile"] }, parseDocs$1 = { name: "parse", category: "Expression", syntax: ["parse(expr)", "parse(expr, options)", "parse([expr1, expr2, expr3, ...])", "parse([expr1, expr2, expr3, ...], options)"], description: "Parse an expression. Returns a node tree, which can be evaluated by invoking node.evaluate() or transformed into a functional object via node.compile().", examples: ['node1 = parse("sqrt(3^2 + 4^2)")', "node1.evaluate()", "code1 = node1.compile()", "code1.evaluate()", "scope = {a: 3, b: 4}", 'node2 = parse("a * b")', "node2.evaluate(scope)", "code2 = node2.compile()", "code2.evaluate(scope)"], seealso: ["parser", "evaluate", "compile"] }, compileDocs$1 = { name: "compile", category: "Expression", syntax: ["compile(expr) ", "compile([expr1, expr2, expr3, ...])"], description: "Parse and compile an expression. Returns a an object with a function evaluate([scope]) to evaluate the compiled expression.", examples: ['code1 = compile("sqrt(3^2 + 4^2)")', "code1.evaluate() ", 'code2 = compile("a * b")', "code2.evaluate({a: 3, b: 4})"], seealso: ["parser", "parse", "evaluate"] }, helpDocs$1 = { name: "help", category: "Expression", syntax: ["help(object)", "help(string)"], description: "Display documentation on a function or data type.", examples: ["help(sqrt)", 'help("complex")'], seealso: [] }, distanceDocs$1 = { name: "distance", category: "Geometry", syntax: ["distance([x1, y1], [x2, y2])", "distance([[x1, y1], [x2, y2]])"], description: "Calculates the Euclidean distance between two points.", examples: ["distance([0,0], [4,4])", "distance([[0,0], [4,4]])"], seealso: [] }, intersectDocs$1 = { name: "intersect", category: "Geometry", syntax: ["intersect(expr1, expr2, expr3, expr4)", "intersect(expr1, expr2, expr3)"], description: "Computes the intersection point of lines and/or planes.", examples: ["intersect([0, 0], [10, 10], [10, 0], [0, 10])", "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"], seealso: [] }, andDocs$1 = { name: "and", category: "Logical", syntax: ["x and y", "and(x, y)"], description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.", examples: ["true and false", "true and true", "2 and 4"], seealso: ["not", "or", "xor"] }, notDocs$1 = { name: "not", category: "Logical", syntax: ["not x", "not(x)"], description: "Logical not. Flips the boolean value of given argument.", examples: ["not true", "not false", "not 2", "not 0"], seealso: ["and", "or", "xor"] }, nullishDocs$1 = { name: "nullish", category: "Logical", syntax: ["x ?? y", "nullish(x, y)"], description: "Nullish coalescing operator. Returns the right-hand operand when the left-hand operand is null or undefined, and otherwise returns the left-hand operand.", examples: ["null ?? 42", "undefined ?? 42", "0 ?? 42", "false ?? 42", "null ?? undefined ?? 42"], seealso: ["and", "or", "not"] }, orDocs$1 = { name: "or", category: "Logical", syntax: ["x or y", "or(x, y)"], description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.", examples: ["true or false", "false or false", "0 or 4"], seealso: ["not", "and", "xor"] }, xorDocs$1 = { name: "xor", category: "Logical", syntax: ["x xor y", "xor(x, y)"], description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.", examples: ["true xor false", "false xor false", "true xor true", "0 xor 4"], seealso: ["not", "and", "or"] }, mapSlicesDocs$1 = { name: "mapSlices", category: "Matrix", syntax: ["mapSlices(A, dim, callback)"], description: "Generate a matrix one dimension less than A by applying callback to each slice of A along dimension dim.", examples: ["A = [[1, 2], [3, 4]]", "mapSlices(A, 1, sum)", "mapSlices(A, 2, prod)"], seealso: ["map", "forEach"] }, columnDocs$1 = { name: "column", category: "Matrix", syntax: ["column(x, index)"], description: "Return a column from a matrix or array.", examples: ["A = [[1, 2], [3, 4]]", "column(A, 1)", "column(A, 2)"], seealso: ["row", "matrixFromColumns"] }, concatDocs$1 = { name: "concat", category: "Matrix", syntax: ["concat(A, B, C, ...)", "concat(A, B, C, ..., dim)"], description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.", examples: ["A = [1, 2; 5, 6]", "B = [3, 4; 7, 8]", "concat(A, B)", "concat(A, B, 1)", "concat(A, B, 2)"], seealso: ["det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, countDocs$1 = { name: "count", category: "Matrix", syntax: ["count(x)"], description: "Count the number of elements of a matrix, array or string.", examples: ["a = [1, 2; 3, 4; 5, 6]", "count(a)", "size(a)", 'count("hello world")'], seealso: ["size"] }, crossDocs$1 = { name: "cross", category: "Matrix", syntax: ["cross(A, B)"], description: "Calculate the cross product for two vectors in three dimensional space.", examples: ["cross([1, 1, 0],  [0, 1, 1])", "cross([3, -3, 1], [4, 9, 2])", "cross([2, 3, 4],  [5, 6, 7])"], seealso: ["multiply", "dot"] }, ctransposeDocs$1 = { name: "ctranspose", category: "Matrix", syntax: ["x'", "ctranspose(x)"], description: "Complex Conjugate and Transpose a matrix", examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "ctranspose(a)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"] }, detDocs$1 = { name: "det", category: "Matrix", syntax: ["det(x)"], description: "Calculate the determinant of a matrix", examples: ["det([1, 2; 3, 4])", "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"], seealso: ["concat", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, diagDocs$1 = { name: "diag", category: "Matrix", syntax: ["diag(x)", "diag(x, k)"], description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.", examples: ["diag(1:3)", "diag(1:3, 1)", "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]", "diag(a)"], seealso: ["concat", "det", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, diffDocs$1 = { name: "diff", category: "Matrix", syntax: ["diff(arr)", "diff(arr, dim)"], description: ["Create a new matrix or array with the difference of the passed matrix or array.", "Dim parameter is optional and used to indicate the dimension of the array/matrix to apply the difference", "If no dimension parameter is passed it is assumed as dimension 0", "Dimension is zero-based in javascript and one-based in the parser", "Arrays must be 'rectangular' meaning arrays like [1, 2]", "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"], examples: ["A = [1, 2, 4, 7, 0]", "diff(A)", "diff(A, 1)", "B = [[1, 2], [3, 4]]", "diff(B)", "diff(B, 1)", "diff(B, 2)", "diff(B, bignumber(2))", "diff([[1, 2], matrix([3, 4])], 2)"], seealso: ["subtract", "partitionSelect"] }, dotDocs$1 = { name: "dot", category: "Matrix", syntax: ["dot(A, B)", "A * B"], description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn", examples: ["dot([2, 4, 1], [2, 2, 3])", "[2, 4, 1] * [2, 2, 3]"], seealso: ["multiply", "cross"] }, eigsDocs$1 = { name: "eigs", category: "Matrix", syntax: ["eigs(x)"], description: "Calculate the eigenvalues and optionally eigenvectors of a square matrix", examples: ["eigs([[5, 2.3], [2.3, 1]])", "eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })"], seealso: ["inv"] }, filterDocs$1 = { name: "filter", category: "Matrix", syntax: ["filter(x, test)"], description: "Filter items in a matrix.", examples: ["isPositive(x) = x > 0", "filter([6, -2, -1, 4, 3], isPositive)", "filter([6, -2, 0, 1, 0], x != 0)"], seealso: ["sort", "map", "forEach"] }, flattenDocs$1 = { name: "flatten", category: "Matrix", syntax: ["flatten(x)"], description: "Flatten a multi dimensional matrix into a single dimensional matrix.", examples: ["a = [1, 2, 3; 4, 5, 6]", "size(a)", "b = flatten(a)", "size(b)"], seealso: ["concat", "resize", "size", "squeeze"] }, forEachDocs$1 = { name: "forEach", category: "Matrix", syntax: ["forEach(x, callback)"], description: "Iterates over all elements of a matrix/array, and executes the given callback function.", examples: ["numberOfPets = {}", "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;", 'forEach(["Dog","Cat","Cat"], addPet)', "numberOfPets"], seealso: ["map", "sort", "filter"] }, getMatrixDataTypeDocs$1 = { name: "getMatrixDataType", category: "Matrix", syntax: ["getMatrixDataType(x)"], description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".', examples: ["getMatrixDataType([1, 2, 3])", "getMatrixDataType([[5 cm], [2 inch]])", 'getMatrixDataType([1, "text"])', "getMatrixDataType([1, bignumber(4)])"], seealso: ["matrix", "sparse", "typeOf"] }, identityDocs$1 = { name: "identity", category: "Matrix", syntax: ["identity(n)", "identity(m, n)", "identity([m, n])"], description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.", examples: ["identity(3)", "identity(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "identity(size(a))"], seealso: ["concat", "det", "diag", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, invDocs$1 = { name: "inv", category: "Matrix", syntax: ["inv(x)"], description: "Calculate the inverse of a matrix", examples: ["inv([1, 2; 3, 4])", "inv(4)", "1 / 4"], seealso: ["concat", "det", "diag", "identity", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, pinvDocs$1 = { name: "pinv", category: "Matrix", syntax: ["pinv(x)"], description: "Calculate the Moore–Penrose inverse of a matrix", examples: ["pinv([1, 2; 3, 4])", "pinv([[1, 0], [0, 1], [0, 1]])", "pinv(4)"], seealso: ["inv"] }, kronDocs$1 = { name: "kron", category: "Matrix", syntax: ["kron(x, y)"], description: "Calculates the Kronecker product of 2 matrices or vectors.", examples: ["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])", "kron([1,1], [2,3,4])"], seealso: ["multiply", "dot", "cross"] }, mapDocs$1 = { name: "map", category: "Matrix", syntax: ["map(x, callback)", "map(x, y, ..., callback)"], description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array or the matrices/arrays.", examples: ["map([1, 2, 3], square)", "map([1, 2], [3, 4], f(a,b) = a + b)"], seealso: ["filter", "forEach"] }, matrixFromColumnsDocs$1 = { name: "matrixFromColumns", category: "Matrix", syntax: ["matrixFromColumns(...arr)", "matrixFromColumns(row1, row2)", "matrixFromColumns(row1, row2, row3)"], description: "Create a dense matrix from vectors as individual columns.", examples: ["matrixFromColumns([1, 2, 3], [[4],[5],[6]])"], seealso: ["matrix", "matrixFromRows", "matrixFromFunction", "zeros"] }, matrixFromFunctionDocs$1 = { name: "matrixFromFunction", category: "Matrix", syntax: ["matrixFromFunction(size, fn)", "matrixFromFunction(size, fn, format)", "matrixFromFunction(size, fn, format, datatype)", "matrixFromFunction(size, format, fn)", "matrixFromFunction(size, format, datatype, fn)"], description: "Create a matrix by evaluating a generating function at each index.", examples: ["f(I) = I[1] - I[2]", "matrixFromFunction([3,3], f)", "g(I) = I[1] - I[2] == 1 ? 4 : 0", 'matrixFromFunction([100, 100], "sparse", g)', "matrixFromFunction([5], random)"], seealso: ["matrix", "matrixFromRows", "matrixFromColumns", "zeros"] }, matrixFromRowsDocs$1 = { name: "matrixFromRows", category: "Matrix", syntax: ["matrixFromRows(...arr)", "matrixFromRows(row1, row2)", "matrixFromRows(row1, row2, row3)"], description: "Create a dense matrix from vectors as individual rows.", examples: ["matrixFromRows([1, 2, 3], [[4],[5],[6]])"], seealso: ["matrix", "matrixFromColumns", "matrixFromFunction", "zeros"] }, onesDocs$1 = { name: "ones", category: "Matrix", syntax: ["ones(m)", "ones(m, n)", "ones(m, n, p, ...)", "ones([m])", "ones([m, n])", "ones([m, n, p, ...])"], description: "Create a matrix containing ones.", examples: ["ones(3)", "ones(3, 5)", "ones([2,3]) * 4.5", "a = [1, 2, 3; 4, 5, 6]", "ones(size(a))"], seealso: ["concat", "det", "diag", "identity", "inv", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, partitionSelectDocs$1 = { name: "partitionSelect", category: "Matrix", syntax: ["partitionSelect(x, k)", "partitionSelect(x, k, compare)"], description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.", examples: ["partitionSelect([5, 10, 1], 2)", 'partitionSelect(["C", "B", "A", "D"], 1, compareText)', "arr = [5, 2, 1]", "partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]", "arr", "partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]", "arr"], seealso: ["sort"] }, rangeDocs$1 = { name: "range", category: "Type", syntax: ["start:end", "start:step:end", "range(start, end)", "range(start, end, step)", "range(string)"], description: "Create a range. Lower bound of the range is included, upper bound is excluded.", examples: ["1:5", "3:-1:-3", "range(3, 7)", "range(0, 12, 2)", 'range("4:10")', "range(1m, 1m, 3m)", "a = [1, 2, 3, 4; 5, 6, 7, 8]", "a[1:2, 1:2]"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, reshapeDocs$1 = { name: "reshape", category: "Matrix", syntax: ["reshape(x, sizes)"], description: "Reshape a multi dimensional array to fit the specified dimensions.", examples: ["reshape([1, 2, 3, 4, 5, 6], [2, 3])", "reshape([[1, 2], [3, 4]], [1, 4])", "reshape([[1, 2], [3, 4]], [4])", "reshape([1, 2, 3, 4], [-1, 2])"], seealso: ["size", "squeeze", "resize"] }, resizeDocs$1 = { name: "resize", category: "Matrix", syntax: ["resize(x, size)", "resize(x, size, defaultValue)"], description: "Resize a matrix.", examples: ["resize([1,2,3,4,5], [3])", "resize([1,2,3], [5])", "resize([1,2,3], [5], -1)", "resize(2, [2, 3])", 'resize("hello", [8], "!")'], seealso: ["size", "subset", "squeeze", "reshape"] }, rotateDocs$1 = { name: "rotate", category: "Matrix", syntax: ["rotate(w, theta)", "rotate(w, theta, v)"], description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.", examples: ["rotate([1, 0], pi / 2)", 'rotate(matrix([1, 0]), unit("35deg"))', 'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])', 'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'], seealso: ["matrix", "rotationMatrix"] }, rotationMatrixDocs$1 = { name: "rotationMatrix", category: "Matrix", syntax: ["rotationMatrix(theta)", "rotationMatrix(theta, v)", "rotationMatrix(theta, v, format)"], description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.", examples: ["rotationMatrix(pi / 2)", 'rotationMatrix(unit("45deg"), [0, 0, 1])', 'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'], seealso: ["cos", "sin"] }, rowDocs$1 = { name: "row", category: "Matrix", syntax: ["row(x, index)"], description: "Return a row from a matrix or array.", examples: ["A = [[1, 2], [3, 4]]", "row(A, 1)", "row(A, 2)"], seealso: ["column", "matrixFromRows"] }, sizeDocs$1 = { name: "size", category: "Matrix", syntax: ["size(x)"], description: "Calculate the size of a matrix.", examples: ["size(2.3)", 'size("hello world")', "a = [1, 2; 3, 4; 5, 6]", "size(a)", "size(1:6)"], seealso: ["concat", "count", "det", "diag", "identity", "inv", "ones", "range", "squeeze", "subset", "trace", "transpose", "zeros"] }, sortDocs$1 = { name: "sort", category: "Matrix", syntax: ["sort(x)", "sort(x, compare)"], description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.', examples: ["sort([5, 10, 1])", 'sort(["C", "B", "A", "D"], "natural")', "sortByLength(a, b) = size(a)[1] - size(b)[1]", 'sort(["Langdon", "Tom", "Sara"], sortByLength)', 'sort(["10", "1", "2"], "natural")'], seealso: ["map", "filter", "forEach"] }, squeezeDocs$1 = { name: "squeeze", category: "Matrix", syntax: ["squeeze(x)"], description: "Remove inner and outer singleton dimensions from a matrix.", examples: ["a = zeros(3,2,1)", "size(squeeze(a))", "b = zeros(1,1,3)", "size(squeeze(b))"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "subset", "trace", "transpose", "zeros"] }, subsetDocs$1 = { name: "subset", category: "Matrix", syntax: ["value(index)", "value(index) = replacement", "subset(value, [index])", "subset(value, [index], replacement)"], description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.", examples: ["d = [1, 2; 3, 4]", "e = []", "e[1, 1:2] = [5, 6]", "e[2, :] = [7, 8]", "f = d * e", "f[2, 1]", "f[:, 1]", "f[[1,2], [1,3]] = [9, 10; 11, 12]", "f"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "trace", "transpose", "zeros"] }, traceDocs$1 = { name: "trace", category: "Matrix", syntax: ["trace(A)"], description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.", examples: ["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]", "trace(A)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "transpose", "zeros"] }, transposeDocs$1 = { name: "transpose", category: "Matrix", syntax: ["x'", "transpose(x)"], description: "Transpose a matrix", examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "transpose(a)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"] }, zerosDocs$1 = { name: "zeros", category: "Matrix", syntax: ["zeros(m)", "zeros(m, n)", "zeros(m, n, p, ...)", "zeros([m])", "zeros([m, n])", "zeros([m, n, p, ...])"], description: "Create a matrix containing zeros.", examples: ["zeros(3)", "zeros(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "zeros(size(a))"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose"] }, fftDocs$1 = { name: "fft", category: "Matrix", syntax: ["fft(x)"], description: "Calculate N-dimensional Fourier transform", examples: ["fft([[1, 0], [1, 0]])"], seealso: ["ifft"] }, ifftDocs$1 = { name: "ifft", category: "Matrix", syntax: ["ifft(x)"], description: "Calculate N-dimensional inverse Fourier transform", examples: ["ifft([[2, 2], [0, 0]])"], seealso: ["fft"] }, bernoulliDocs$1 = { name: "bernoulli", category: "Probability", syntax: ["bernoulli(n)"], description: "The nth Bernoulli number", examples: ["bernoulli(4)", "bernoulli(fraction(12))"], seealso: ["combinations", "gamma", "stirlingS2"] }, combinationsDocs$1 = { name: "combinations", category: "Probability", syntax: ["combinations(n, k)"], description: "Compute the number of combinations of n items taken k at a time", examples: ["combinations(7, 5)"], seealso: ["combinationsWithRep", "permutations", "factorial"] }, combinationsWithRepDocs$1 = { name: "combinationsWithRep", category: "Probability", syntax: ["combinationsWithRep(n, k)"], description: "Compute the number of combinations of n items taken k at a time with replacements.", examples: ["combinationsWithRep(7, 5)"], seealso: ["combinations", "permutations", "factorial"] }, factorialDocs$1 = { name: "factorial", category: "Probability", syntax: ["n!", "factorial(n)"], description: "Compute the factorial of a value", examples: ["5!", "5 * 4 * 3 * 2 * 1", "3!"], seealso: ["combinations", "combinationsWithRep", "permutations", "gamma"] }, gammaDocs$1 = { name: "gamma", category: "Probability", syntax: ["gamma(n)"], description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.", examples: ["gamma(4)", "3!", "gamma(1/2)", "sqrt(pi)"], seealso: ["factorial"] }, lgammaDocs$1 = { name: "lgamma", category: "Probability", syntax: ["lgamma(n)"], description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.", examples: ["lgamma(4)", "lgamma(1/2)", "lgamma(i)", "lgamma(complex(1.1, 2))"], seealso: ["gamma"] }, kldivergenceDocs$1 = { name: "kldivergence", category: "Probability", syntax: ["kldivergence(x, y)"], description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.", examples: ["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"], seealso: [] }, multinomialDocs$1 = { name: "multinomial", category: "Probability", syntax: ["multinomial(A)"], description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.", examples: ["multinomial([1, 2, 1])"], seealso: ["combinations", "factorial"] }, permutationsDocs$1 = { name: "permutations", category: "Probability", syntax: ["permutations(n)", "permutations(n, k)"], description: "Compute the number of permutations of n items taken k at a time", examples: ["permutations(5)", "permutations(5, 3)"], seealso: ["combinations", "combinationsWithRep", "factorial"] }, pickRandomDocs$1 = { name: "pickRandom", category: "Probability", syntax: ["pickRandom(array)", "pickRandom(array, number)", "pickRandom(array, weights)", "pickRandom(array, number, weights)", "pickRandom(array, weights, number)"], description: "Pick a random entry from a given array.", examples: ["pickRandom(0:10)", "pickRandom([1, 3, 1, 6])", "pickRandom([1, 3, 1, 6], 2)", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"], seealso: ["random", "randomInt"] }, randomDocs$1 = { name: "random", category: "Probability", syntax: ["random()", "random(max)", "random(min, max)", "random(size)", "random(size, max)", "random(size, min, max)"], description: "Return a random number.", examples: ["random()", "random(10, 20)", "random([2, 3])"], seealso: ["pickRandom", "randomInt"] }, randomIntDocs$1 = { name: "randomInt", category: "Probability", syntax: ["randomInt(max)", "randomInt(min, max)", "randomInt(size)", "randomInt(size, max)", "randomInt(size, min, max)"], description: "Return a random integer number", examples: ["randomInt(10, 20)", "randomInt([2, 3], 10)"], seealso: ["pickRandom", "random"] }, compareDocs$1 = { name: "compare", category: "Relational", syntax: ["compare(x, y)"], description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ["compare(2, 3)", "compare(3, 2)", "compare(2, 2)", "compare(5cm, 40mm)", "compare(2, [1, 2, 3])"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compareNatural", "compareText"] }, compareNaturalDocs$1 = { name: "compareNatural", category: "Relational", syntax: ["compareNatural(x, y)"], description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ["compareNatural(2, 3)", "compareNatural(3, 2)", "compareNatural(2, 2)", "compareNatural(5cm, 40mm)", 'compareNatural("2", "10")', "compareNatural(2 + 3i, 2 + 4i)", "compareNatural([1, 2, 4], [1, 2, 3])", "compareNatural([1, 5], [1, 2, 3])", "compareNatural([1, 2], [1, 2])", "compareNatural({a: 2}, {a: 4})"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare", "compareText"] }, compareTextDocs$1 = { name: "compareText", category: "Relational", syntax: ["compareText(x, y)"], description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ['compareText("B", "A")', 'compareText("A", "B")', 'compareText("A", "A")', 'compareText("2", "10")', 'compare("2", "10")', "compare(2, 10)", 'compareNatural("2", "10")', 'compareText("B", ["A", "B", "C"])'], seealso: ["compare", "compareNatural"] }, deepEqualDocs$1 = { name: "deepEqual", category: "Relational", syntax: ["deepEqual(x, y)"], description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.", examples: ["deepEqual([1,3,4], [1,3,4])", "deepEqual([1,3,4], [1,3])"], seealso: ["equal", "unequal", "smaller", "larger", "smallerEq", "largerEq", "compare"] }, equalDocs$1 = { name: "equal", category: "Relational", syntax: ["x == y", "equal(x, y)"], description: "Check equality of two values. Returns true if the values are equal, and false if not.", examples: ["2+2 == 3", "2+2 == 4", "a = 3.2", "b = 6-2.8", "a == b", "50cm == 0.5m"], seealso: ["unequal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual", "equalText"] }, equalTextDocs$1 = { name: "equalText", category: "Relational", syntax: ["equalText(x, y)"], description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.", examples: ['equalText("Hello", "Hello")', 'equalText("a", "A")', 'equal("2e3", "2000")', 'equalText("2e3", "2000")', 'equalText("B", ["A", "B", "C"])'], seealso: ["compare", "compareNatural", "compareText", "equal"] }, largerDocs$1 = { name: "larger", category: "Relational", syntax: ["x > y", "larger(x, y)"], description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not. Comparing a value with NaN returns false.", examples: ["2 > 3", "5 > 2*2", "a = 3.3", "b = 6-2.8", "(a > b)", "(b < a)", "5 cm > 2 inch"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare"] }, largerEqDocs$1 = { name: "largerEq", category: "Relational", syntax: ["x >= y", "largerEq(x, y)"], description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.", examples: ["2 >= 1+1", "2 > 1+1", "a = 3.2", "b = 6-2.8", "(a >= b)"], seealso: ["equal", "unequal", "smallerEq", "smaller", "compare"] }, smallerDocs$1 = { name: "smaller", category: "Relational", syntax: ["x < y", "smaller(x, y)"], description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not. Comparing a value with NaN returns false.", examples: ["2 < 3", "5 < 2*2", "a = 3.3", "b = 6-2.8", "(a < b)", "5 cm < 2 inch"], seealso: ["equal", "unequal", "larger", "smallerEq", "largerEq", "compare"] }, smallerEqDocs$1 = { name: "smallerEq", category: "Relational", syntax: ["x <= y", "smallerEq(x, y)"], description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.", examples: ["2 <= 1+1", "2 < 1+1", "a = 3.2", "b = 6-2.8", "(a <= b)"], seealso: ["equal", "unequal", "larger", "smaller", "largerEq", "compare"] }, unequalDocs$1 = { name: "unequal", category: "Relational", syntax: ["x != y", "unequal(x, y)"], description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.", examples: ["2+2 != 3", "2+2 != 4", "a = 3.2", "b = 6-2.8", "a != b", "50cm != 0.5m", "5 cm != 2 inch"], seealso: ["equal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"] }, setCartesianDocs$1 = { name: "setCartesian", category: "Set", syntax: ["setCartesian(set1, set2)"], description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.", examples: ["setCartesian([1, 2], [3, 4])"], seealso: ["setUnion", "setIntersect", "setDifference", "setPowerset"] }, setDifferenceDocs$1 = { name: "setDifference", category: "Set", syntax: ["setDifference(set1, set2)"], description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setIntersect", "setSymDifference"] }, setDistinctDocs$1 = { name: "setDistinct", category: "Set", syntax: ["setDistinct(set)"], description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setDistinct([1, 1, 1, 2, 2, 3])"], seealso: ["setMultiplicity"] }, setIntersectDocs$1 = { name: "setIntersect", category: "Set", syntax: ["setIntersect(set1, set2)"], description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])", "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setDifference"] }, setIsSubsetDocs$1 = { name: "setIsSubset", category: "Set", syntax: ["setIsSubset(set1, set2)"], description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setIsSubset([1, 2], [3, 4, 5, 6])", "setIsSubset([3, 4], [3, 4, 5, 6])"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setMultiplicityDocs$1 = { name: "setMultiplicity", category: "Set", syntax: ["setMultiplicity(element, set)"], description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setMultiplicity(1, [1, 2, 2, 4])", "setMultiplicity(2, [1, 2, 2, 4])"], seealso: ["setDistinct", "setSize"] }, setPowersetDocs$1 = { name: "setPowerset", category: "Set", syntax: ["setPowerset(set)"], description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setPowerset([1, 2, 3])"], seealso: ["setCartesian"] }, setSizeDocs$1 = { name: "setSize", category: "Set", syntax: ["setSize(set)", "setSize(set, unique)"], description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.', examples: ["setSize([1, 2, 2, 4])", "setSize([1, 2, 2, 4], true)"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setSymDifferenceDocs$1 = { name: "setSymDifference", category: "Set", syntax: ["setSymDifference(set1, set2)"], description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setUnionDocs$1 = { name: "setUnion", category: "Set", syntax: ["setUnion(set1, set2)"], description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setUnion([1, 2, 3, 4], [3, 4, 5, 6])", "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setIntersect", "setDifference"] }, zpk2tfDocs$1 = { name: "zpk2tf", category: "Signal", syntax: ["zpk2tf(z, p, k)"], description: "Compute the transfer function of a zero-pole-gain model.", examples: ["zpk2tf([1, 2], [-1, -2], 1)", "zpk2tf([1, 2], [-1, -2])", "zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"], seealso: [] }, freqzDocs$1 = { name: "freqz", category: "Signal", syntax: ["freqz(b, a)", "freqz(b, a, w)"], description: "Calculates the frequency response of a filter given its numerator and denominator coefficients.", examples: ["freqz([1, 2], [1, 2, 3])", "freqz([1, 2], [1, 2, 3], [0, 1])", "freqz([1, 2], [1, 2, 3], 512)"], seealso: [] }, erfDocs$1 = { name: "erf", category: "Special", syntax: ["erf(x)"], description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x", examples: ["erf(0.2)", "erf(-0.5)", "erf(4)"], seealso: [] }, zetaDocs$1 = { name: "zeta", category: "Special", syntax: ["zeta(s)"], description: "Compute the Riemann Zeta Function using an infinite series and Riemann's Functional Equation for the entire complex plane", examples: ["zeta(0.2)", "zeta(-0.5)", "zeta(4)"], seealso: [] }, madDocs$1 = { name: "mad", category: "Statistics", syntax: ["mad(a, b, c, ...)", "mad(A)"], description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.", examples: ["mad(10, 20, 30)", "mad([1, 2, 3])"], seealso: ["mean", "median", "std", "abs"] }, maxDocs$1 = { name: "max", category: "Statistics", syntax: ["max(a, b, c, ...)", "max(A)", "max(A, dimension)"], description: "Compute the maximum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.", examples: ["max(2, 3, 4, 1)", "max([2, 3, 4, 1])", "max([2, 5; 4, 3])", "max([2, 5; 4, 3], 1)", "max([2, 5; 4, 3], 2)", "max(2.7, 7.1, -4.5, 2.0, 4.1)", "min(2.7, 7.1, -4.5, 2.0, 4.1)"], seealso: ["mean", "median", "min", "prod", "std", "sum", "variance"] }, meanDocs$1 = { name: "mean", category: "Statistics", syntax: ["mean(a, b, c, ...)", "mean(A)", "mean(A, dimension)"], description: "Compute the arithmetic mean of a list of values.", examples: ["mean(2, 3, 4, 1)", "mean([2, 3, 4, 1])", "mean([2, 5; 4, 3])", "mean([2, 5; 4, 3], 1)", "mean([2, 5; 4, 3], 2)", "mean([1.0, 2.7, 3.2, 4.0])"], seealso: ["max", "median", "min", "prod", "std", "sum", "variance"] }, medianDocs$1 = { name: "median", category: "Statistics", syntax: ["median(a, b, c, ...)", "median(A)"], description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.", examples: ["median(5, 2, 7)", "median([3, -1, 5, 7])"], seealso: ["max", "mean", "min", "prod", "std", "sum", "variance", "quantileSeq"] }, minDocs$1 = { name: "min", category: "Statistics", syntax: ["min(a, b, c, ...)", "min(A)", "min(A, dimension)"], description: "Compute the minimum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.", examples: ["min(2, 3, 4, 1)", "min([2, 3, 4, 1])", "min([2, 5; 4, 3])", "min([2, 5; 4, 3], 1)", "min([2, 5; 4, 3], 2)", "min(2.7, 7.1, -4.5, 2.0, 4.1)", "max(2.7, 7.1, -4.5, 2.0, 4.1)"], seealso: ["max", "mean", "median", "prod", "std", "sum", "variance"] }, modeDocs$1 = { name: "mode", category: "Statistics", syntax: ["mode(a, b, c, ...)", "mode(A)", "mode(A, a, b, B, c, ...)"], description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.", examples: ["mode(2, 1, 4, 3, 1)", "mode([1, 2.7, 3.2, 4, 2.7])", "mode(1, 4, 6, 1, 6)"], seealso: ["max", "mean", "min", "median", "prod", "std", "sum", "variance"] }, prodDocs$1 = { name: "prod", category: "Statistics", syntax: ["prod(a, b, c, ...)", "prod(A)"], description: "Compute the product of all values.", examples: ["prod(2, 3, 4)", "prod([2, 3, 4])", "prod([2, 5; 4, 3])"], seealso: ["max", "mean", "min", "median", "min", "std", "sum", "variance"] }, quantileSeqDocs$1 = { name: "quantileSeq", category: "Statistics", syntax: ["quantileSeq(A, prob[, sorted])", "quantileSeq(A, [prob1, prob2, ...][, sorted])", "quantileSeq(A, N[, sorted])"], description: "Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probability are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.", examples: ["quantileSeq([3, -1, 5, 7], 0.5)", "quantileSeq([3, -1, 5, 7], [1/3, 2/3])", "quantileSeq([3, -1, 5, 7], 2)", "quantileSeq([-1, 3, 5, 7], 0.5, true)"], seealso: ["mean", "median", "min", "max", "prod", "std", "sum", "variance"] }, stdDocs$1 = { name: "std", category: "Statistics", syntax: ["std(a, b, c, ...)", "std(A)", "std(A, dimension)", "std(A, normalization)", "std(A, dimension, normalization)"], description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".', examples: ["std(2, 4, 6)", "std([2, 4, 6, 8])", 'std([2, 4, 6, 8], "uncorrected")', 'std([2, 4, 6, 8], "biased")', "std([1, 2, 3; 4, 5, 6])"], seealso: ["max", "mean", "min", "median", "prod", "sum", "variance"] }, cumSumDocs$1 = { name: "cumsum", category: "Statistics", syntax: ["cumsum(a, b, c, ...)", "cumsum(A)"], description: "Compute the cumulative sum of all values.", examples: ["cumsum(2, 3, 4, 1)", "cumsum([2, 3, 4, 1])", "cumsum([1, 2; 3, 4])", "cumsum([1, 2; 3, 4], 1)", "cumsum([1, 2; 3, 4], 2)"], seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"] }, sumDocs$1 = { name: "sum", category: "Statistics", syntax: ["sum(a, b, c, ...)", "sum(A)", "sum(A, dimension)"], description: "Compute the sum of all values.", examples: ["sum(2, 3, 4, 1)", "sum([2, 3, 4, 1])", "sum([2, 5; 4, 3])"], seealso: ["max", "mean", "median", "min", "prod", "std", "variance"] }, varianceDocs$1 = { name: "variance", category: "Statistics", syntax: ["variance(a, b, c, ...)", "variance(A)", "variance(A, dimension)", "variance(A, normalization)", "variance(A, dimension, normalization)"], description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".', examples: ["variance(2, 4, 6)", "variance([2, 4, 6, 8])", 'variance([2, 4, 6, 8], "uncorrected")', 'variance([2, 4, 6, 8], "biased")', "variance([1, 2, 3; 4, 5, 6])"], seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"] }, corrDocs$1 = { name: "corr", category: "Statistics", syntax: ["corr(A,B)"], description: "Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.", examples: ["corr([2, 4, 6, 8],[1, 2, 3, 6])", "corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"], seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"] }, acosDocs$1 = { name: "acos", category: "Trigonometry", syntax: ["acos(x)"], description: "Compute the inverse cosine of a value in radians.", examples: ["acos(0.5)", "acos(cos(2.3))"], seealso: ["cos", "atan", "asin"] }, acoshDocs$1 = { name: "acosh", category: "Trigonometry", syntax: ["acosh(x)"], description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.", examples: ["acosh(1.5)"], seealso: ["cosh", "asinh", "atanh"] }, acotDocs$1 = { name: "acot", category: "Trigonometry", syntax: ["acot(x)"], description: "Calculate the inverse cotangent of a value.", examples: ["acot(0.5)", "acot(cot(0.5))", "acot(2)"], seealso: ["cot", "atan"] }, acothDocs$1 = { name: "acoth", category: "Trigonometry", syntax: ["acoth(x)"], description: "Calculate the inverse hyperbolic tangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.", examples: ["acoth(2)", "acoth(0.5)"], seealso: ["acsch", "asech"] }, acscDocs$1 = { name: "acsc", category: "Trigonometry", syntax: ["acsc(x)"], description: "Calculate the inverse cotangent of a value.", examples: ["acsc(2)", "acsc(csc(0.5))", "acsc(0.5)"], seealso: ["csc", "asin", "asec"] }, acschDocs$1 = { name: "acsch", category: "Trigonometry", syntax: ["acsch(x)"], description: "Calculate the inverse hyperbolic cosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.", examples: ["acsch(0.5)"], seealso: ["asech", "acoth"] }, asecDocs$1 = { name: "asec", category: "Trigonometry", syntax: ["asec(x)"], description: "Calculate the inverse secant of a value.", examples: ["asec(0.5)", "asec(sec(0.5))", "asec(2)"], seealso: ["acos", "acot", "acsc"] }, asechDocs$1 = { name: "asech", category: "Trigonometry", syntax: ["asech(x)"], description: "Calculate the inverse secant of a value.", examples: ["asech(0.5)"], seealso: ["acsch", "acoth"] }, asinDocs$1 = { name: "asin", category: "Trigonometry", syntax: ["asin(x)"], description: "Compute the inverse sine of a value in radians.", examples: ["asin(0.5)", "asin(sin(0.5))"], seealso: ["sin", "acos", "atan"] }, asinhDocs$1 = { name: "asinh", category: "Trigonometry", syntax: ["asinh(x)"], description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.", examples: ["asinh(0.5)"], seealso: ["acosh", "atanh"] }, atanDocs$1 = { name: "atan", category: "Trigonometry", syntax: ["atan(x)"], description: "Compute the inverse tangent of a value in radians.", examples: ["atan(0.5)", "atan(tan(0.5))"], seealso: ["tan", "acos", "asin"] }, atan2Docs$1 = { name: "atan2", category: "Trigonometry", syntax: ["atan2(y, x)"], description: "Computes the principal value of the arc tangent of y/x in radians.", examples: ["atan2(2, 2) / pi", "angle = 60 deg in rad", "x = cos(angle)", "y = sin(angle)", "atan2(y, x)"], seealso: ["sin", "cos", "tan"] }, atanhDocs$1 = { name: "atanh", category: "Trigonometry", syntax: ["atanh(x)"], description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.", examples: ["atanh(0.5)"], seealso: ["acosh", "asinh"] }, cosDocs$1 = { name: "cos", category: "Trigonometry", syntax: ["cos(x)"], description: "Compute the cosine of x in radians.", examples: ["cos(2)", "cos(pi / 4) ^ 2", "cos(180 deg)", "cos(60 deg)", "sin(0.2)^2 + cos(0.2)^2"], seealso: ["acos", "sin", "tan"] }, coshDocs$1 = { name: "cosh", category: "Trigonometry", syntax: ["cosh(x)"], description: "Compute the hyperbolic cosine of x in radians.", examples: ["cosh(0.5)"], seealso: ["sinh", "tanh", "coth"] }, cotDocs$1 = { name: "cot", category: "Trigonometry", syntax: ["cot(x)"], description: "Compute the cotangent of x in radians. Defined as 1/tan(x)", examples: ["cot(2)", "1 / tan(2)"], seealso: ["sec", "csc", "tan"] }, cothDocs$1 = { name: "coth", category: "Trigonometry", syntax: ["coth(x)"], description: "Compute the hyperbolic cotangent of x in radians.", examples: ["coth(2)", "1 / tanh(2)"], seealso: ["sech", "csch", "tanh"] }, cscDocs$1 = { name: "csc", category: "Trigonometry", syntax: ["csc(x)"], description: "Compute the cosecant of x in radians. Defined as 1/sin(x)", examples: ["csc(2)", "1 / sin(2)"], seealso: ["sec", "cot", "sin"] }, cschDocs$1 = { name: "csch", category: "Trigonometry", syntax: ["csch(x)"], description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)", examples: ["csch(2)", "1 / sinh(2)"], seealso: ["sech", "coth", "sinh"] }, secDocs$1 = { name: "sec", category: "Trigonometry", syntax: ["sec(x)"], description: "Compute the secant of x in radians. Defined as 1/cos(x)", examples: ["sec(2)", "1 / cos(2)"], seealso: ["cot", "csc", "cos"] }, sechDocs$1 = { name: "sech", category: "Trigonometry", syntax: ["sech(x)"], description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)", examples: ["sech(2)", "1 / cosh(2)"], seealso: ["coth", "csch", "cosh"] }, sinDocs$1 = { name: "sin", category: "Trigonometry", syntax: ["sin(x)"], description: "Compute the sine of x in radians.", examples: ["sin(2)", "sin(pi / 4) ^ 2", "sin(90 deg)", "sin(30 deg)", "sin(0.2)^2 + cos(0.2)^2"], seealso: ["asin", "cos", "tan"] }, sinhDocs$1 = { name: "sinh", category: "Trigonometry", syntax: ["sinh(x)"], description: "Compute the hyperbolic sine of x in radians.", examples: ["sinh(0.5)"], seealso: ["cosh", "tanh"] }, tanDocs$1 = { name: "tan", category: "Trigonometry", syntax: ["tan(x)"], description: "Compute the tangent of x in radians.", examples: ["tan(0.5)", "sin(0.5) / cos(0.5)", "tan(pi / 4)", "tan(45 deg)"], seealso: ["atan", "sin", "cos"] }, tanhDocs$1 = { name: "tanh", category: "Trigonometry", syntax: ["tanh(x)"], description: "Compute the hyperbolic tangent of x in radians.", examples: ["tanh(0.5)", "sinh(0.5) / cosh(0.5)"], seealso: ["sinh", "cosh"] }, toDocs$1 = { name: "to", category: "Units", syntax: ["x to unit", "to(x, unit)"], description: "Change the unit of a value.", examples: ["5 inch to cm", "3.2kg to g", "16 bytes in bits"], seealso: [] }, toBestDocs$1 = { name: "toBest", category: "Units", syntax: ["toBest(x)", "toBest(x, unitList)", "toBest(x, unitList, options)"], description: "Converts to the most appropriate display unit.", examples: ['toBest(unit(5000, "m"))', 'toBest(unit(3500000, "W"))', 'toBest(unit(0.000000123, "A"))', 'toBest(unit(10, "m"), "cm")', 'toBest(unit(10, "m"), "mm,km", {offset: 1.5})'], seealso: [] }, binDocs$1 = { name: "bin", category: "Utils", syntax: ["bin(value)"], description: "Format a number as binary", examples: ["bin(2)"], seealso: ["oct", "hex"] }, cloneDocs$1 = { name: "clone", category: "Utils", syntax: ["clone(x)"], description: "Clone a variable. Creates a copy of primitive variables, and a deep copy of matrices", examples: ["clone(3.5)", "clone(2 - 4i)", "clone(45 deg)", "clone([1, 2; 3, 4])", 'clone("hello world")'], seealso: [] }, formatDocs$1 = { name: "format", category: "Utils", syntax: ["format(value)", "format(value, precision)"], description: "Format a value of any type as string.", examples: ["format(2.3)", "format(3 - 4i)", "format([])", "format(pi, 3)"], seealso: ["print"] }, hasNumericValueDocs$1 = { name: "hasNumericValue", category: "Utils", syntax: ["hasNumericValue(x)"], description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.", examples: ["hasNumericValue(2)", 'hasNumericValue("2")', 'isNumeric("2")', "hasNumericValue(0)", "hasNumericValue(bignumber(500))", "hasNumericValue(fraction(0.125))", "hasNumericValue(2 + 3i)", 'hasNumericValue([2.3, "foo", false])'], seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "isNumeric"] }, hexDocs$1 = { name: "hex", category: "Utils", syntax: ["hex(value)"], description: "Format a number as hexadecimal", examples: ["hex(240)"], seealso: ["bin", "oct"] }, isIntegerDocs$1 = { name: "isInteger", category: "Utils", syntax: ["isInteger(x)"], description: "Test whether a value is an integer number.", examples: ["isInteger(2)", "isInteger(3.5)", "isInteger([3, 0.5, -2])"], seealso: ["isNegative", "isNumeric", "isPositive", "isZero"] }, isNaNDocs$1 = { name: "isNaN", category: "Utils", syntax: ["isNaN(x)"], description: "Test whether a value is NaN (not a number)", examples: ["isNaN(2)", "isNaN(0 / 0)", "isNaN(NaN)", "isNaN(Infinity)"], seealso: ["isNegative", "isNumeric", "isPositive", "isZero", "isFinite", "isBounded"] }, isBoundedDocs$1 = { name: "isBounded", category: "Utils", syntax: ["isBounded(x)"], description: "Test whether a value or its entries are bounded.", examples: ["isBounded(Infinity)", "isBounded(bigint(3))", "isBounded([3, -Infinity, -3])"], seealso: ["isFinite", "isNumeric", "isNaN", "isNegative", "isPositive"] }, isFiniteDocs$1 = { name: "isFinite", category: "Utils", syntax: ["isFinite(x)"], description: "Test whether a value is finite, elementwise on collections.", examples: ["isFinite(Infinity)", "isFinite(bigint(3))", "isFinite([3, -Infinity, -3])"], seealso: ["isBounded", "isNumeric", "isNaN", "isNegative", "isPositive"] }, isNegativeDocs$1 = { name: "isNegative", category: "Utils", syntax: ["isNegative(x)"], description: "Test whether a value is negative: smaller than zero.", examples: ["isNegative(2)", "isNegative(0)", "isNegative(-4)", "isNegative([3, 0.5, -2])"], seealso: ["isInteger", "isNumeric", "isPositive", "isZero"] }, isNumericDocs$1 = { name: "isNumeric", category: "Utils", syntax: ["isNumeric(x)"], description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.", examples: ["isNumeric(2)", 'isNumeric("2")', 'hasNumericValue("2")', "isNumeric(0)", "isNumeric(bignumber(500))", "isNumeric(fraction(0.125))", "isNumeric(2 + 3i)", 'isNumeric([2.3, "foo", false])'], seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "hasNumericValue", "isFinite", "isBounded"] }, isPositiveDocs$1 = { name: "isPositive", category: "Utils", syntax: ["isPositive(x)"], description: "Test whether a value is positive: larger than zero.", examples: ["isPositive(2)", "isPositive(0)", "isPositive(-4)", "isPositive([3, 0.5, -2])"], seealso: ["isInteger", "isNumeric", "isNegative", "isZero"] }, isPrimeDocs$1 = { name: "isPrime", category: "Utils", syntax: ["isPrime(x)"], description: "Test whether a value is prime: has no divisors other than itself and one.", examples: ["isPrime(3)", "isPrime(-2)", "isPrime([2, 17, 100])"], seealso: ["isInteger", "isNumeric", "isNegative", "isZero"] }, isZeroDocs$1 = { name: "isZero", category: "Utils", syntax: ["isZero(x)"], description: "Test whether a value is zero.", examples: ["isZero(2)", "isZero(0)", "isZero(-4)", "isZero([3, 0, -2, 0])"], seealso: ["isInteger", "isNumeric", "isNegative", "isPositive"] }, numericDocs$1 = { name: "numeric", category: "Utils", syntax: ["numeric(x)"], description: "Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.", examples: ['numeric("4")', 'numeric("4", "number")', 'numeric("4", "bigint")', 'numeric("4", "BigNumber")', 'numeric("4", "Fraction")', 'numeric(4, "Fraction")', 'numeric(fraction(2, 5), "number")'], seealso: ["number", "bigint", "fraction", "bignumber", "string", "format"] }, octDocs$1 = { name: "oct", category: "Utils", syntax: ["oct(value)"], description: "Format a number as octal", examples: ["oct(56)"], seealso: ["bin", "hex"] }, printDocs$1 = { name: "print", category: "Utils", syntax: ["print(template, values)", "print(template, values, precision)"], description: "Interpolate values into a string template.", examples: ['print("Lucy is $age years old", {age: 5})', 'print("The value of pi is $pi", {pi: pi}, 3)', 'print("Hello, $user.name!", {user: {name: "John"}})', 'print("Values: $1, $2, $3", [6, 9, 4])'], seealso: ["format"] }, typeOfDocs$1 = { name: "typeOf", category: "Utils", syntax: ["typeOf(x)"], description: "Get the type of a variable.", examples: ["typeOf(3.5)", "typeOf(2 - 4i)", "typeOf(45 deg)", 'typeOf("hello world")'], seealso: ["getMatrixDataType"] }, solveODEDocs$1 = { name: "solveODE", category: "Numeric", syntax: ["solveODE(func, tspan, y0)", "solveODE(func, tspan, y0, options)"], description: "Numerical Integration of Ordinary Differential Equations.", examples: ["f(t,y) = y", "tspan = [0, 4]", "solveODE(f, tspan, 1)", "solveODE(f, tspan, [1, 2])", 'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })'], seealso: ["derivative", "simplifyCore"] }, embeddedDocs$1 = { bignumber: bignumberDocs$1, bigint: bigintDocs$1, boolean: booleanDocs$1, complex: complexDocs$1, createUnit: createUnitDocs$1, fraction: fractionDocs$1, index: indexDocs$1, matrix: matrixDocs$1, number: numberDocs$1, sparse: sparseDocs$1, splitUnit: splitUnitDocs$1, string: stringDocs$1, unit: unitDocs$1, e: eDocs$1, E: eDocs$1, false: falseDocs$1, i: iDocs$1, Infinity: InfinityDocs$1, LN2: LN2Docs$1, LN10: LN10Docs$1, LOG2E: LOG2EDocs$1, LOG10E: LOG10EDocs$1, NaN: NaNDocs$1, null: nullDocs$1, pi: piDocs$1, PI: piDocs$1, phi: phiDocs$1, SQRT1_2: SQRT12Docs$1, SQRT2: SQRT2Docs$1, tau: tauDocs$1, true: trueDocs$1, version: versionDocs$1, speedOfLight: { description: "Speed of light in vacuum", examples: ["speedOfLight"] }, gravitationConstant: { description: "Newtonian constant of gravitation", examples: ["gravitationConstant"] }, planckConstant: { description: "Planck constant", examples: ["planckConstant"] }, reducedPlanckConstant: { description: "Reduced Planck constant", examples: ["reducedPlanckConstant"] }, magneticConstant: { description: "Magnetic constant (vacuum permeability)", examples: ["magneticConstant"] }, electricConstant: { description: "Electric constant (vacuum permeability)", examples: ["electricConstant"] }, vacuumImpedance: { description: "Characteristic impedance of vacuum", examples: ["vacuumImpedance"] }, coulomb: { description: "Coulomb's constant. Deprecated in favor of coulombConstant", examples: ["coulombConstant"] }, coulombConstant: { description: "Coulomb's constant", examples: ["coulombConstant"] }, elementaryCharge: { description: "Elementary charge", examples: ["elementaryCharge"] }, bohrMagneton: { description: "Bohr magneton", examples: ["bohrMagneton"] }, conductanceQuantum: { description: "Conductance quantum", examples: ["conductanceQuantum"] }, inverseConductanceQuantum: { description: "Inverse conductance quantum", examples: ["inverseConductanceQuantum"] }, magneticFluxQuantum: { description: "Magnetic flux quantum", examples: ["magneticFluxQuantum"] }, nuclearMagneton: { description: "Nuclear magneton", examples: ["nuclearMagneton"] }, klitzing: { description: "Von Klitzing constant", examples: ["klitzing"] }, bohrRadius: { description: "Bohr radius", examples: ["bohrRadius"] }, classicalElectronRadius: { description: "Classical electron radius", examples: ["classicalElectronRadius"] }, electronMass: { description: "Electron mass", examples: ["electronMass"] }, fermiCoupling: { description: "Fermi coupling constant", examples: ["fermiCoupling"] }, fineStructure: { description: "Fine-structure constant", examples: ["fineStructure"] }, hartreeEnergy: { description: "Hartree energy", examples: ["hartreeEnergy"] }, protonMass: { description: "Proton mass", examples: ["protonMass"] }, deuteronMass: { description: "Deuteron Mass", examples: ["deuteronMass"] }, neutronMass: { description: "Neutron mass", examples: ["neutronMass"] }, quantumOfCirculation: { description: "Quantum of circulation", examples: ["quantumOfCirculation"] }, rydberg: { description: "Rydberg constant", examples: ["rydberg"] }, thomsonCrossSection: { description: "Thomson cross section", examples: ["thomsonCrossSection"] }, weakMixingAngle: { description: "Weak mixing angle", examples: ["weakMixingAngle"] }, efimovFactor: { description: "Efimov factor", examples: ["efimovFactor"] }, atomicMass: { description: "Atomic mass constant", examples: ["atomicMass"] }, avogadro: { description: "Avogadro's number", examples: ["avogadro"] }, boltzmann: { description: "Boltzmann constant", examples: ["boltzmann"] }, faraday: { description: "Faraday constant", examples: ["faraday"] }, firstRadiation: { description: "First radiation constant", examples: ["firstRadiation"] }, loschmidt: { description: "Loschmidt constant at T=273.15 K and p=101.325 kPa", examples: ["loschmidt"] }, gasConstant: { description: "Gas constant", examples: ["gasConstant"] }, molarPlanckConstant: { description: "Molar Planck constant", examples: ["molarPlanckConstant"] }, molarVolume: { description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa", examples: ["molarVolume"] }, sackurTetrode: { description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa", examples: ["sackurTetrode"] }, secondRadiation: { description: "Second radiation constant", examples: ["secondRadiation"] }, stefanBoltzmann: { description: "Stefan-Boltzmann constant", examples: ["stefanBoltzmann"] }, wienDisplacement: { description: "Wien displacement law constant", examples: ["wienDisplacement"] }, molarMass: { description: "Molar mass constant", examples: ["molarMass"] }, molarMassC12: { description: "Molar mass constant of carbon-12", examples: ["molarMassC12"] }, gravity: { description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)", examples: ["gravity"] }, planckLength: { description: "Planck length", examples: ["planckLength"] }, planckMass: { description: "Planck mass", examples: ["planckMass"] }, planckTime: { description: "Planck time", examples: ["planckTime"] }, planckCharge: { description: "Planck charge", examples: ["planckCharge"] }, planckTemperature: { description: "Planck temperature", examples: ["planckTemperature"] }, derivative: derivativeDocs$1, lsolve: lsolveDocs$1, lsolveAll: lsolveAllDocs$1, lup: lupDocs$1, lusolve: lusolveDocs$1, leafCount: leafCountDocs$1, polynomialRoot: polynomialRootDocs$1, resolve: resolveDocs$1, simplify: simplifyDocs$1, simplifyConstant: simplifyConstantDocs$1, simplifyCore: simplifyCoreDocs$1, symbolicEqual: symbolicEqualDocs$1, rationalize: rationalizeDocs$1, slu: sluDocs$1, usolve: usolveDocs$1, usolveAll: usolveAllDocs$1, qr: qrDocs$1, abs: absDocs$1, add: addDocs$1, cbrt: cbrtDocs$1, ceil: ceilDocs$1, cube: cubeDocs$1, divide: divideDocs$1, dotDivide: dotDivideDocs$1, dotMultiply: dotMultiplyDocs$1, dotPow: dotPowDocs$1, exp: expDocs$1, expm: expmDocs$1, expm1: expm1Docs$1, fix: fixDocs$1, floor: floorDocs$1, gcd: gcdDocs$1, hypot: hypotDocs$1, lcm: lcmDocs$1, log: logDocs$1, log2: log2Docs$1, log1p: log1pDocs$1, log10: log10Docs$1, mod: modDocs$1, multiply: multiplyDocs$1, norm: normDocs$1, nthRoot: nthRootDocs$1, nthRoots: nthRootsDocs$1, pow: powDocs$1, round: roundDocs$1, sign: signDocs$1, sqrt: sqrtDocs$1, sqrtm: sqrtmDocs$1, square: squareDocs$1, subtract: subtractDocs$1, unaryMinus: unaryMinusDocs$1, unaryPlus: unaryPlusDocs$1, xgcd: xgcdDocs$1, invmod: invmodDocs$1, bitAnd: bitAndDocs$1, bitNot: bitNotDocs$1, bitOr: bitOrDocs$1, bitXor: bitXorDocs$1, leftShift: leftShiftDocs$1, rightArithShift: rightArithShiftDocs$1, rightLogShift: rightLogShiftDocs$1, bellNumbers: bellNumbersDocs$1, catalan: catalanDocs$1, composition: compositionDocs$1, stirlingS2: stirlingS2Docs$1, config: configDocs$1, import: importDocs$1, typed: typedDocs$1, arg: argDocs$1, conj: conjDocs$1, re: reDocs$1, im: imDocs$1, evaluate: evaluateDocs$1, help: helpDocs$1, parse: parseDocs$1, parser: parserDocs$1, compile: compileDocs$1, distance: distanceDocs$1, intersect: intersectDocs$1, and: andDocs$1, not: notDocs$1, nullish: nullishDocs$1, or: orDocs$1, xor: xorDocs$1, mapSlices: mapSlicesDocs$1, concat: concatDocs$1, count: countDocs$1, cross: crossDocs$1, column: columnDocs$1, ctranspose: ctransposeDocs$1, det: detDocs$1, diag: diagDocs$1, diff: diffDocs$1, dot: dotDocs$1, getMatrixDataType: getMatrixDataTypeDocs$1, identity: identityDocs$1, filter: filterDocs$1, flatten: flattenDocs$1, forEach: forEachDocs$1, inv: invDocs$1, pinv: pinvDocs$1, eigs: eigsDocs$1, kron: kronDocs$1, matrixFromFunction: matrixFromFunctionDocs$1, matrixFromRows: matrixFromRowsDocs$1, matrixFromColumns: matrixFromColumnsDocs$1, map: mapDocs$1, ones: onesDocs$1, partitionSelect: partitionSelectDocs$1, range: rangeDocs$1, resize: resizeDocs$1, reshape: reshapeDocs$1, rotate: rotateDocs$1, rotationMatrix: rotationMatrixDocs$1, row: rowDocs$1, size: sizeDocs$1, sort: sortDocs$1, squeeze: squeezeDocs$1, subset: subsetDocs$1, trace: traceDocs$1, transpose: transposeDocs$1, zeros: zerosDocs$1, fft: fftDocs$1, ifft: ifftDocs$1, sylvester: sylvesterDocs$1, schur: schurDocs$1, lyap: lyapDocs$1, solveODE: solveODEDocs$1, bernoulli: bernoulliDocs$1, combinations: combinationsDocs$1, combinationsWithRep: combinationsWithRepDocs$1, factorial: factorialDocs$1, gamma: gammaDocs$1, kldivergence: kldivergenceDocs$1, lgamma: lgammaDocs$1, multinomial: multinomialDocs$1, permutations: permutationsDocs$1, pickRandom: pickRandomDocs$1, random: randomDocs$1, randomInt: randomIntDocs$1, compare: compareDocs$1, compareNatural: compareNaturalDocs$1, compareText: compareTextDocs$1, deepEqual: deepEqualDocs$1, equal: equalDocs$1, equalText: equalTextDocs$1, larger: largerDocs$1, largerEq: largerEqDocs$1, smaller: smallerDocs$1, smallerEq: smallerEqDocs$1, unequal: unequalDocs$1, setCartesian: setCartesianDocs$1, setDifference: setDifferenceDocs$1, setDistinct: setDistinctDocs$1, setIntersect: setIntersectDocs$1, setIsSubset: setIsSubsetDocs$1, setMultiplicity: setMultiplicityDocs$1, setPowerset: setPowersetDocs$1, setSize: setSizeDocs$1, setSymDifference: setSymDifferenceDocs$1, setUnion: setUnionDocs$1, zpk2tf: zpk2tfDocs$1, freqz: freqzDocs$1, erf: erfDocs$1, zeta: zetaDocs$1, cumsum: cumSumDocs$1, mad: madDocs$1, max: maxDocs$1, mean: meanDocs$1, median: medianDocs$1, min: minDocs$1, mode: modeDocs$1, prod: prodDocs$1, quantileSeq: quantileSeqDocs$1, std: stdDocs$1, sum: sumDocs$1, variance: varianceDocs$1, corr: corrDocs$1, acos: acosDocs$1, acosh: acoshDocs$1, acot: acotDocs$1, acoth: acothDocs$1, acsc: acscDocs$1, acsch: acschDocs$1, asec: asecDocs$1, asech: asechDocs$1, asin: asinDocs$1, asinh: asinhDocs$1, atan: atanDocs$1, atanh: atanhDocs$1, atan2: atan2Docs$1, cos: cosDocs$1, cosh: coshDocs$1, cot: cotDocs$1, coth: cothDocs$1, csc: cscDocs$1, csch: cschDocs$1, sec: secDocs$1, sech: sechDocs$1, sin: sinDocs$1, sinh: sinhDocs$1, tan: tanDocs$1, tanh: tanhDocs$1, to: toDocs$1, toBest: toBestDocs$1, clone: cloneDocs$1, format: formatDocs$1, bin: binDocs$1, oct: octDocs$1, hex: hexDocs$1, isNaN: isNaNDocs$1, isBounded: isBoundedDocs$1, isFinite: isFiniteDocs$1, isInteger: isIntegerDocs$1, isNegative: isNegativeDocs$1, isNumeric: isNumericDocs$1, hasNumericValue: hasNumericValueDocs$1, isPositive: isPositiveDocs$1, isPrime: isPrimeDocs$1, isZero: isZeroDocs$1, print: printDocs$1, typeOf: typeOfDocs$1, numeric: numericDocs$1 }, name$1d$1 = "help", dependencies$1d$1 = ["typed", "mathWithTransform", "Help"], createHelp$1 = factory$1(name$1d$1, dependencies$1d$1, ((e2) => {
  var { typed: t2, mathWithTransform: r, Help: n } = e2;
  return t2(name$1d$1, { any: function(e3) {
    var t3, i2 = e3;
    if ("string" != typeof e3) {
      for (t3 in r) if (hasOwnProperty$1$2(r, t3) && e3 === r[t3]) {
        i2 = t3;
        break;
      }
    }
    var a = getSafeProperty$1(embeddedDocs$1, i2);
    if (!a) {
      var o = "function" == typeof i2 ? i2.name : i2;
      throw new Error('No documentation found on "' + o + '"');
    }
    return new n(a);
  } });
})), name$1c$1 = "chain", dependencies$1c$1 = ["typed", "Chain"], createChain$1 = factory$1(name$1c$1, dependencies$1c$1, ((e2) => {
  var { typed: t2, Chain: r } = e2;
  return t2(name$1c$1, { "": function() {
    return new r();
  }, any: function(e3) {
    return new r(e3);
  } });
})), name$1b$1 = "det", dependencies$1b$1 = ["typed", "matrix", "subtractScalar", "multiply", "divideScalar", "isZero", "unaryMinus"], createDet$1 = factory$1(name$1b$1, dependencies$1b$1, ((e2) => {
  var { typed: t2, matrix: r, subtractScalar: n, multiply: i2, divideScalar: a, isZero: o, unaryMinus: s } = e2;
  return t2(name$1b$1, { any: function(e3) {
    return clone$3$1(e3);
  }, "Array | Matrix": function(e3) {
    var t3;
    switch ((t3 = isMatrix$1(e3) ? e3.size() : Array.isArray(e3) ? (e3 = r(e3)).size() : []).length) {
      case 0:
        return clone$3$1(e3);
      case 1:
        if (1 === t3[0]) return clone$3$1(e3.valueOf()[0]);
        if (0 === t3[0]) return 1;
        throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
      case 2:
        var u = t3[0], c2 = t3[1];
        if (u === c2) return (function(e4, t4) {
          if (1 === t4) return clone$3$1(e4[0][0]);
          if (2 === t4) return n(i2(e4[0][0], e4[1][1]), i2(e4[1][0], e4[0][1]));
          for (var r2 = false, u2 = new Array(t4).fill(0).map(((e5, t5) => t5)), c3 = 0; c3 < t4; c3++) {
            var l = u2[c3];
            if (o(e4[l][c3])) {
              var f2 = void 0;
              for (f2 = c3 + 1; f2 < t4; f2++) if (!o(e4[u2[f2]][c3])) {
                l = u2[f2], u2[f2] = u2[c3], u2[c3] = l, r2 = !r2;
                break;
              }
              if (f2 === t4) return e4[l][c3];
            }
            for (var p = e4[l][c3], m = 0 === c3 ? 1 : e4[u2[c3 - 1]][c3 - 1], d = c3 + 1; d < t4; d++) for (var h = u2[d], g = c3 + 1; g < t4; g++) e4[h][g] = a(n(i2(e4[h][g], p), i2(e4[h][c3], e4[l][g])), m);
          }
          var y = e4[u2[t4 - 1]][t4 - 1];
          return r2 ? s(y) : y;
        })(e3.clone().valueOf(), u);
        if (0 === c2) return 1;
        throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + format$3(t3) + ")");
    }
  } });
})), name$1a$1 = "inv", dependencies$1a$1 = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], createInv$1 = factory$1(name$1a$1, dependencies$1a$1, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, addScalar: i2, multiply: a, unaryMinus: o, det: s, identity: u, abs: c2 } = e2;
  return t2(name$1a$1, { "Array | Matrix": function(e3) {
    var t3 = isMatrix$1(e3) ? e3.size() : arraySize$1(e3);
    switch (t3.length) {
      case 1:
        if (1 === t3[0]) return isMatrix$1(e3) ? r([n(1, e3.valueOf()[0])]) : [n(1, e3[0])];
        throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
      case 2:
        var i3 = t3[0], a2 = t3[1];
        if (i3 === a2) return isMatrix$1(e3) ? r(l(e3.valueOf(), i3, a2), e3.storage()) : l(e3, i3, a2);
        throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + format$3(t3) + ")");
    }
  }, any: function(e3) {
    return n(1, e3);
  } });
  function l(e3, t3, r2) {
    var l2, f2, p, m, d;
    if (1 === t3) {
      if (0 === (m = e3[0][0])) throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(1, m)]];
    }
    if (2 === t3) {
      var h = s(e3);
      if (0 === h) throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(e3[1][1], h), n(o(e3[0][1]), h)], [n(o(e3[1][0]), h), n(e3[0][0], h)]];
    }
    var g = e3.concat();
    for (l2 = 0; l2 < t3; l2++) g[l2] = g[l2].concat();
    for (var y = u(t3).valueOf(), v2 = 0; v2 < r2; v2++) {
      var x2 = c2(g[v2][v2]), b2 = v2;
      for (l2 = v2 + 1; l2 < t3; ) c2(g[l2][v2]) > x2 && (x2 = c2(g[l2][v2]), b2 = l2), l2++;
      if (0 === x2) throw Error("Cannot calculate inverse, determinant is zero");
      (l2 = b2) !== v2 && (d = g[v2], g[v2] = g[l2], g[l2] = d, d = y[v2], y[v2] = y[l2], y[l2] = d);
      var _2 = g[v2], w2 = y[v2];
      for (l2 = 0; l2 < t3; l2++) {
        var A2 = g[l2], N = y[l2];
        if (l2 !== v2) {
          if (0 !== A2[v2]) {
            for (p = n(o(A2[v2]), _2[v2]), f2 = v2; f2 < r2; f2++) A2[f2] = i2(A2[f2], a(p, _2[f2]));
            for (f2 = 0; f2 < r2; f2++) N[f2] = i2(N[f2], a(p, w2[f2]));
          }
        } else {
          for (p = _2[v2], f2 = v2; f2 < r2; f2++) A2[f2] = n(A2[f2], p);
          for (f2 = 0; f2 < r2; f2++) N[f2] = n(N[f2], p);
        }
      }
    }
    return y;
  }
})), name$19$1 = "pinv", dependencies$19$1 = ["typed", "matrix", "inv", "deepEqual", "equal", "dotDivide", "dot", "ctranspose", "divideScalar", "multiply", "add", "Complex"], createPinv$1 = factory$1(name$19$1, dependencies$19$1, ((e2) => {
  var { typed: t2, matrix: r, inv: n, deepEqual: i2, equal: a, dotDivide: o, dot: s, ctranspose: u, divideScalar: c2, multiply: l, add: f2, Complex: p } = e2;
  return t2(name$19$1, { "Array | Matrix": function(e3) {
    var t3 = isMatrix$1(e3) ? e3.size() : arraySize$1(e3);
    switch (t3.length) {
      case 1:
        return h(e3) ? u(e3) : 1 === t3[0] ? n(e3) : o(u(e3), s(e3, e3));
      case 2:
        if (h(e3)) return u(e3);
        var i3 = t3[0], a2 = t3[1];
        if (i3 === a2) try {
          return n(e3);
        } catch (e4) {
          if (!(e4 instanceof Error && e4.message.match(/Cannot calculate inverse, determinant is zero/))) throw e4;
        }
        return isMatrix$1(e3) ? r(m(e3.valueOf(), i3, a2), e3.storage()) : m(e3, i3, a2);
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + format$3(t3) + ")");
    }
  }, any: function(e3) {
    return a(e3, 0) ? clone$3$1(e3) : c2(1, e3);
  } });
  function m(e3, t3, r2) {
    var { C: i3, F: a2 } = (function(e4, t4, r3) {
      var n3 = (function(e5, t5, r4) {
        for (var n4 = clone$3$1(e5), i5 = 0, a4 = 0; a4 < t5; a4++) {
          if (r4 <= i5) return n4;
          for (var s2 = a4; d(n4[s2][i5]); ) if (t5 === ++s2 && (s2 = a4, r4 === ++i5)) return n4;
          [n4[s2], n4[a4]] = [n4[a4], n4[s2]];
          for (var u2 = n4[a4][i5], c4 = 0; c4 < r4; c4++) n4[a4][c4] = o(n4[a4][c4], u2);
          for (var p3 = 0; p3 < t5; p3++) if (p3 !== a4) {
            u2 = n4[p3][i5];
            for (var m2 = 0; m2 < r4; m2++) n4[p3][m2] = f2(n4[p3][m2], l(-1, l(u2, n4[a4][m2])));
          }
          i5++;
        }
        return n4;
      })(e4, t4, r3), i4 = e4.map(((e5, r4) => e5.filter(((e6, r5) => r5 < t4 && !d(s(n3[r5], n3[r5])))))), a3 = n3.filter(((e5, t5) => !d(s(n3[t5], n3[t5]))));
      return { C: i4, F: a3 };
    })(e3, t3, r2), c3 = l(n(l(u(i3), i3)), u(i3)), p2 = l(u(a2), n(l(a2, u(a2))));
    return l(p2, c3);
  }
  function d(e3) {
    return a(f2(e3, p(1, 1)), f2(0, p(1, 1)));
  }
  function h(e3) {
    return i2(f2(e3, p(1, 1)), f2(l(e3, 0), p(1, 1)));
  }
}));
function createComplexEigs$1(e2) {
  var { addScalar: t2, subtract: r, flatten: n, multiply: i2, multiplyScalar: a, divideScalar: o, sqrt: s, abs: u, bignumber: c2, diag: l, size: f2, reshape: p, inv: m, qr: d, usolve: h, usolveAll: g, equal: y, complex: v2, larger: x2, smaller: b2, matrixFromColumns: _2, dot: w2 } = e2;
  function A2(e3, n3, i3, o2) {
    var u2 = t2(e3, o2), c3 = r(a(e3, o2), a(n3, i3)), l2 = a(u2, 0.5), f3 = a(s(r(a(u2, u2), a(4, c3))), 0.5);
    return [t2(l2, f3), r(l2, f3)];
  }
  function N(e3, t3, n3, i3, a2, o2, s2, l2) {
    var f3 = "BigNumber" === l2, p2 = "Complex" === l2, m2 = f3 ? c2(0) : p2 ? v2(0) : 0, d2 = f3 ? c2(1) : p2 ? v2(1) : 1;
    if (b2(u(n3), s2)) return [[d2, m2], [m2, d2]];
    if (x2(u(r(a2, o2)), s2)) return [[r(a2, i3), r(o2, i3)], [n3, n3]];
    var h2 = r(e3, a2), g2 = r(i3, a2);
    return b2(u(t3), s2) && b2(u(g2), s2) ? [[h2, d2], [n3, m2]] : [[t3, m2], [g2, d2]];
  }
  function D(e3, t3) {
    for (var r2 = 0; r2 < e3.length; r2++) e3[r2].push(...Array(t3 - e3[r2].length).fill(0));
    for (var n3 = e3.length; n3 < t3; n3++) e3.push(Array(t3).fill(0)), e3[n3][n3] = 1;
    return e3;
  }
  function E(e3, t3, r2) {
    for (var n3 = 0; n3 < e3.length; n3++) if (r2(e3[n3], t3)) return n3;
    return -1;
  }
  function $2(e3, t3, r2, n3, i3) {
    for (var a2, o2 = "BigNumber" === i3 ? c2(1e3) : 1e3, s2 = 0; s2 < 5; ++s2) {
      a2 = S2(t3, r2, i3);
      try {
        a2 = h(e3, a2);
      } catch (e4) {
        continue;
      }
      if (x2(M2(a2), o2)) break;
    }
    if (s2 >= 5) return null;
    for (s2 = 0; ; ) {
      var u2 = h(e3, a2);
      if (b2(M2(C2(a2, [u2])), n3)) break;
      if (++s2 >= 10) return null;
      a2 = T2(u2);
    }
    return a2;
  }
  function S2(e3, t3, r2) {
    var n3 = "BigNumber" === r2, i3 = "Complex" === r2, a2 = Array(e3).fill(0).map(((e4) => 2 * Math.random() - 1));
    return n3 && (a2 = a2.map(((e4) => c2(e4)))), i3 && (a2 = a2.map(((e4) => v2(e4)))), T2(a2 = C2(a2, t3), r2);
  }
  function C2(e3, t3) {
    var n3 = f2(e3);
    for (var a2 of t3) a2 = p(a2, n3), e3 = r(e3, i2(o(w2(a2, e3), w2(a2, a2)), a2));
    return e3;
  }
  function M2(e3) {
    return u(s(w2(e3, e3)));
  }
  function T2(e3, t3) {
    var r2 = "Complex" === t3, n3 = "BigNumber" === t3 ? c2(1) : r2 ? v2(1) : 1;
    return i2(o(n3, M2(e3)), e3);
  }
  return function(e3, s2, f3, p2) {
    var h2 = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], _3 = (function(e4, r2, n3, i3, s3) {
      var f4, p3 = "BigNumber" === i3, m2 = "Complex" === i3, d2 = p3 ? c2(0) : 0, h3 = p3 ? c2(1) : m2 ? v2(1) : 1, g2 = p3 ? c2(1) : 1, _4 = p3 ? c2(10) : 2, w4 = a(_4, _4);
      s3 && (f4 = Array(r2).fill(h3));
      var A3 = false;
      for (; !A3; ) {
        A3 = true;
        for (var N2 = 0; N2 < r2; N2++) {
          for (var D2 = d2, E2 = d2, $3 = 0; $3 < r2; $3++) N2 !== $3 && (D2 = t2(D2, u(e4[$3][N2])), E2 = t2(E2, u(e4[N2][$3])));
          if (!y(D2, 0) && !y(E2, 0)) {
            for (var S4 = g2, C4 = D2, M3 = o(E2, _4), T3 = a(E2, _4); b2(C4, M3); ) C4 = a(C4, w4), S4 = a(S4, _4);
            for (; x2(C4, T3); ) C4 = o(C4, w4), S4 = o(S4, _4);
            if (b2(o(t2(C4, E2), S4), a(t2(D2, E2), 0.95))) {
              A3 = false;
              for (var F = o(1, S4), O2 = 0; O2 < r2; O2++) N2 !== O2 && (e4[N2][O2] = a(e4[N2][O2], F), e4[O2][N2] = a(e4[O2][N2], S4));
              s3 && (f4[N2] = a(f4[N2], F));
            }
          }
        }
      }
      return s3 ? l(f4) : null;
    })(e3, s2, 0, p2, h2);
    !(function(e4, n3, i3, s3, l2, f4) {
      var p3 = "BigNumber" === s3, m2 = "Complex" === s3, d2 = p3 ? c2(0) : m2 ? v2(0) : 0;
      p3 && (i3 = c2(i3));
      for (var h3 = 0; h3 < n3 - 2; h3++) {
        for (var g2 = 0, y2 = d2, x3 = h3 + 1; x3 < n3; x3++) {
          var _4 = e4[x3][h3];
          b2(u(y2), u(_4)) && (y2 = _4, g2 = x3);
        }
        if (!b2(u(y2), i3)) {
          if (g2 !== h3 + 1) {
            var w4 = e4[g2];
            e4[g2] = e4[h3 + 1], e4[h3 + 1] = w4;
            for (var A3 = 0; A3 < n3; A3++) {
              var N2 = e4[A3][g2];
              e4[A3][g2] = e4[A3][h3 + 1], e4[A3][h3 + 1] = N2;
            }
            if (l2) {
              var D2 = f4[g2];
              f4[g2] = f4[h3 + 1], f4[h3 + 1] = D2;
            }
          }
          for (var E2 = h3 + 2; E2 < n3; E2++) {
            var $3 = o(e4[E2][h3], y2);
            if (0 !== $3) {
              for (var S4 = 0; S4 < n3; S4++) e4[E2][S4] = r(e4[E2][S4], a($3, e4[h3 + 1][S4]));
              for (var C4 = 0; C4 < n3; C4++) e4[C4][h3 + 1] = t2(e4[C4][h3 + 1], a($3, e4[C4][E2]));
              if (l2) for (var M3 = 0; M3 < n3; M3++) f4[E2][M3] = r(f4[E2][M3], a($3, f4[h3 + 1][M3]));
            }
          }
        }
      }
    })(e3, s2, f3, p2, h2, _3);
    var { values: w3, C: S3 } = (function(e4, n3, a2, o2, s3) {
      var f4 = "BigNumber" === o2, p3 = "Complex" === o2, m2 = f4 ? c2(1) : p3 ? v2(1) : 1;
      f4 && (a2 = c2(a2));
      var h3 = clone$3$1(e4), g2 = [], y2 = n3, x3 = [], _4 = s3 ? l(Array(n3).fill(m2)) : void 0, w4 = s3 ? l(Array(y2).fill(m2)) : void 0, E2 = 0;
      for (; E2 <= 100; ) {
        E2 += 1;
        for (var $3 = h3[y2 - 1][y2 - 1], S4 = 0; S4 < y2; S4++) h3[S4][S4] = r(h3[S4][S4], $3);
        var { Q: C4, R: M3 } = d(h3);
        h3 = i2(M3, C4);
        for (var T3 = 0; T3 < y2; T3++) h3[T3][T3] = t2(h3[T3][T3], $3);
        if (s3 && (w4 = i2(w4, C4)), 1 === y2 || b2(u(h3[y2 - 1][y2 - 2]), a2)) {
          E2 = 0, g2.push(h3[y2 - 1][y2 - 1]), s3 && (x3.unshift([[1]]), D(w4, n3), _4 = i2(_4, w4), y2 > 1 && (w4 = l(Array(y2 - 1).fill(m2)))), y2 -= 1, h3.pop();
          for (var F = 0; F < y2; F++) h3[F].pop();
        } else if (2 === y2 || b2(u(h3[y2 - 2][y2 - 3]), a2)) {
          E2 = 0;
          var O2 = A2(h3[y2 - 2][y2 - 2], h3[y2 - 2][y2 - 1], h3[y2 - 1][y2 - 2], h3[y2 - 1][y2 - 1]);
          g2.push(...O2), s3 && (x3.unshift(N(h3[y2 - 2][y2 - 2], h3[y2 - 2][y2 - 1], h3[y2 - 1][y2 - 2], h3[y2 - 1][y2 - 1], O2[0], O2[1], a2, o2)), D(w4, n3), _4 = i2(_4, w4), y2 > 2 && (w4 = l(Array(y2 - 2).fill(m2)))), y2 -= 2, h3.pop(), h3.pop();
          for (var k2 = 0; k2 < y2; k2++) h3[k2].pop(), h3[k2].pop();
        }
        if (0 === y2) break;
      }
      if (g2.sort(((e5, t3) => +r(u(e5), u(t3)))), E2 > 100) {
        var B2 = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + g2.join(", "));
        throw B2.values = g2, B2.vectors = [], B2;
      }
      var I2 = s3 ? i2(_4, (function(e5, t3) {
        for (var r2 = [], n4 = 0; n4 < t3; n4++) r2[n4] = Array(t3).fill(0);
        var i3 = 0;
        for (var a3 of e5) {
          for (var o3 = a3.length, s4 = 0; s4 < o3; s4++) for (var u2 = 0; u2 < o3; u2++) r2[i3 + s4][i3 + u2] = a3[s4][u2];
          i3 += o3;
        }
        return r2;
      })(x3, n3)) : void 0;
      return { values: g2, C: I2 };
    })(e3, s2, f3, p2, h2);
    if (h2) {
      var C3 = (function(e4, t3, a2, o2, s3, u2, f4) {
        var p3 = m(a2), d2 = i2(p3, e4, a2), h3 = "BigNumber" === f4, x3 = "Complex" === f4, b3 = h3 ? c2(0) : x3 ? v2(0) : 0, _4 = h3 ? c2(1) : x3 ? v2(1) : 1, w4 = [], A3 = [];
        for (var N2 of s3) {
          var D2 = E(w4, N2, y);
          -1 === D2 ? (w4.push(N2), A3.push(1)) : A3[D2] += 1;
        }
        for (var S4 = [], C4 = w4.length, M3 = Array(t3).fill(b3), T3 = l(Array(t3).fill(_4)), F = function() {
          var e5 = w4[O2], s4 = r(d2, i2(e5, T3)), c3 = g(s4, M3);
          for (c3.shift(); c3.length < A3[O2]; ) {
            var l2 = $2(s4, t3, c3, u2, f4);
            if (null === l2) break;
            c3.push(l2);
          }
          var p4 = i2(m(o2), a2);
          c3 = c3.map(((e6) => i2(p4, e6))), S4.push(...c3.map(((t4) => ({ value: e5, vector: n(t4) }))));
        }, O2 = 0; O2 < C4; O2++) F();
        return S4;
      })(e3, s2, S3, _3, w3, f3, p2);
      return { values: w3, eigenvectors: C3 };
    }
    return { values: w3 };
  };
}
function createRealSymmetric$1(e2) {
  var { config: t2, addScalar: r, subtract: n, abs: i2, atan: a, cos: o, sin: s, multiplyScalar: u, inv: c2, bignumber: l, multiply: f2, add: p } = e2;
  function m(e3, r2, n3) {
    var i3 = r2 - e3;
    return Math.abs(i3) <= t2.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * n3 / (r2 - e3));
  }
  function d(e3, r2, o2) {
    var s2 = n(r2, e3);
    return i2(s2) <= t2.relTol ? l(-1).acos().div(4) : u(0.5, a(f2(2, o2, c2(s2))));
  }
  function h(e3, t3, r2, n3) {
    for (var i3 = e3.length, a2 = Math.cos(t3), o2 = Math.sin(t3), s2 = Array(i3).fill(0), u2 = Array(i3).fill(0), c3 = 0; c3 < i3; c3++) s2[c3] = a2 * e3[c3][r2] - o2 * e3[c3][n3], u2[c3] = o2 * e3[c3][r2] + a2 * e3[c3][n3];
    for (var l2 = 0; l2 < i3; l2++) e3[l2][r2] = s2[l2], e3[l2][n3] = u2[l2];
    return e3;
  }
  function g(e3, t3, i3, a2) {
    for (var c3 = e3.length, f3 = o(t3), p2 = s(t3), m2 = Array(c3).fill(l(0)), d2 = Array(c3).fill(l(0)), h2 = 0; h2 < c3; h2++) m2[h2] = n(u(f3, e3[h2][i3]), u(p2, e3[h2][a2])), d2[h2] = r(u(p2, e3[h2][i3]), u(f3, e3[h2][a2]));
    for (var g2 = 0; g2 < c3; g2++) e3[g2][i3] = m2[g2], e3[g2][a2] = d2[g2];
    return e3;
  }
  function y(e3, t3, i3, a2) {
    for (var c3 = e3.length, m2 = l(o(t3)), d2 = l(s(t3)), h2 = u(m2, m2), g2 = u(d2, d2), y2 = Array(c3).fill(l(0)), v3 = Array(c3).fill(l(0)), x3 = f2(l(2), m2, d2, e3[i3][a2]), b3 = r(n(u(h2, e3[i3][i3]), x3), u(g2, e3[a2][a2])), _3 = p(u(g2, e3[i3][i3]), x3, u(h2, e3[a2][a2])), w2 = 0; w2 < c3; w2++) y2[w2] = n(u(m2, e3[i3][w2]), u(d2, e3[a2][w2])), v3[w2] = r(u(d2, e3[i3][w2]), u(m2, e3[a2][w2]));
    e3[i3][i3] = b3, e3[a2][a2] = _3, e3[i3][a2] = l(0), e3[a2][i3] = l(0);
    for (var A2 = 0; A2 < c3; A2++) A2 !== i3 && A2 !== a2 && (e3[i3][A2] = y2[A2], e3[A2][i3] = y2[A2], e3[a2][A2] = v3[A2], e3[A2][a2] = v3[A2]);
    return e3;
  }
  function v2(e3, t3, r2, n3) {
    for (var i3 = e3.length, a2 = Math.cos(t3), o2 = Math.sin(t3), s2 = a2 * a2, u2 = o2 * o2, c3 = Array(i3).fill(0), l2 = Array(i3).fill(0), f3 = s2 * e3[r2][r2] - 2 * a2 * o2 * e3[r2][n3] + u2 * e3[n3][n3], p2 = u2 * e3[r2][r2] + 2 * a2 * o2 * e3[r2][n3] + s2 * e3[n3][n3], m2 = 0; m2 < i3; m2++) c3[m2] = a2 * e3[r2][m2] - o2 * e3[n3][m2], l2[m2] = o2 * e3[r2][m2] + a2 * e3[n3][m2];
    e3[r2][r2] = f3, e3[n3][n3] = p2, e3[r2][n3] = 0, e3[n3][r2] = 0;
    for (var d2 = 0; d2 < i3; d2++) d2 !== r2 && d2 !== n3 && (e3[r2][d2] = c3[d2], e3[d2][r2] = c3[d2], e3[n3][d2] = l2[d2], e3[d2][n3] = l2[d2]);
    return e3;
  }
  function x2(e3) {
    for (var t3 = e3.length, r2 = 0, n3 = [0, 1], i3 = 0; i3 < t3; i3++) for (var a2 = i3 + 1; a2 < t3; a2++) Math.abs(r2) < Math.abs(e3[i3][a2]) && (r2 = Math.abs(e3[i3][a2]), n3 = [i3, a2]);
    return [n3, r2];
  }
  function b2(e3) {
    for (var t3 = e3.length, r2 = 0, n3 = [0, 1], a2 = 0; a2 < t3; a2++) for (var o2 = a2 + 1; o2 < t3; o2++) i2(r2) < i2(e3[a2][o2]) && (r2 = i2(e3[a2][o2]), n3 = [a2, o2]);
    return [n3, r2];
  }
  function _2(e3, t3, r2) {
    var n3, a2 = e3.length, o2 = Array(a2);
    if (r2) {
      n3 = Array(a2);
      for (var s2 = 0; s2 < a2; s2++) n3[s2] = Array(a2);
    }
    for (var u2 = 0; u2 < a2; u2++) {
      for (var c3 = 0, l2 = e3[0], f3 = 0; f3 < e3.length; f3++) i2(e3[f3]) < i2(l2) && (l2 = e3[c3 = f3]);
      if (o2[u2] = e3.splice(c3, 1)[0], r2) for (var p2 = 0; p2 < a2; p2++) n3[u2][p2] = t3[p2][c3], t3[p2].splice(c3, 1);
    }
    if (!r2) return { values: o2 };
    var m2 = n3.map(((e4, t4) => ({ value: o2[t4], vector: e4 })));
    return { values: o2, eigenvectors: m2 };
  }
  return function(e3, r2) {
    var n3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t2.relTol, a2 = arguments.length > 3 ? arguments[3] : void 0, o2 = arguments.length > 4 ? arguments[4] : void 0;
    if ("number" === a2) return (function(e4, t3, r3) {
      var n4, i3, a3 = e4.length, o3 = Math.abs(t3 / a3);
      if (r3) {
        i3 = new Array(a3);
        for (var s2 = 0; s2 < a3; s2++) i3[s2] = Array(a3).fill(0), i3[s2][s2] = 1;
      }
      var u2 = x2(e4);
      for (; Math.abs(u2[1]) >= Math.abs(o3); ) {
        var c3 = u2[0][0], l2 = u2[0][1];
        e4 = v2(e4, n4 = m(e4[c3][c3], e4[l2][l2], e4[c3][l2]), c3, l2), r3 && (i3 = h(i3, n4, c3, l2)), u2 = x2(e4);
      }
      for (var f3 = Array(a3).fill(0), p2 = 0; p2 < a3; p2++) f3[p2] = e4[p2][p2];
      return _2(clone$3$1(f3), i3, r3);
    })(e3, n3, o2);
    if ("BigNumber" === a2) return (function(e4, t3, r3) {
      var n4, a3, o3 = e4.length, s2 = i2(t3 / o3);
      if (r3) {
        a3 = new Array(o3);
        for (var u2 = 0; u2 < o3; u2++) a3[u2] = Array(o3).fill(0), a3[u2][u2] = 1;
      }
      var c3 = b2(e4);
      for (; i2(c3[1]) >= i2(s2); ) {
        var l2 = c3[0][0], f3 = c3[0][1];
        e4 = y(e4, n4 = d(e4[l2][l2], e4[f3][f3], e4[l2][f3]), l2, f3), r3 && (a3 = g(a3, n4, l2, f3)), c3 = b2(e4);
      }
      for (var p2 = Array(o3).fill(0), m2 = 0; m2 < o3; m2++) p2[m2] = e4[m2][m2];
      return _2(clone$3$1(p2), a3, r3);
    })(e3, n3, o2);
    throw TypeError("Unsupported data type: " + a2);
  };
}
var name$18$1 = "eigs", dependencies$18$1 = ["config", "typed", "matrix", "addScalar", "equal", "subtract", "abs", "atan", "cos", "sin", "multiplyScalar", "divideScalar", "inv", "bignumber", "multiply", "add", "larger", "column", "flatten", "number", "complex", "sqrt", "diag", "size", "reshape", "qr", "usolve", "usolveAll", "im", "re", "smaller", "matrixFromColumns", "dot"], createEigs$1 = factory$1(name$18$1, dependencies$18$1, ((e2) => {
  var { config: t2, typed: r, matrix: n, addScalar: i2, subtract: a, equal: o, abs: s, atan: u, cos: c2, sin: l, multiplyScalar: f2, divideScalar: p, inv: m, bignumber: d, multiply: h, add: g, larger: y, column: v2, flatten: x2, number: b2, complex: _2, sqrt: w2, diag: A2, size: N, reshape: D, qr: E, usolve: $2, usolveAll: S2, im: C2, re: M2, smaller: T2, matrixFromColumns: F, dot: O2 } = e2, k2 = createRealSymmetric$1({ config: t2, addScalar: i2, subtract: a, abs: s, atan: u, cos: c2, sin: l, multiplyScalar: f2, inv: m, bignumber: d, multiply: h, add: g }), B2 = createComplexEigs$1({ addScalar: i2, subtract: a, multiply: h, multiplyScalar: f2, flatten: x2, divideScalar: p, sqrt: w2, abs: s, bignumber: d, diag: A2, size: N, reshape: D, qr: E, inv: m, usolve: $2, usolveAll: S2, equal: o, complex: _2, larger: y, smaller: T2, matrixFromColumns: F, dot: O2 });
  return r("eigs", { Array: function(e3) {
    return I2(n(e3));
  }, "Array, number|BigNumber": function(e3, t3) {
    return I2(n(e3), { precision: t3 });
  }, "Array, Object": (e3, t3) => I2(n(e3), t3), Matrix: function(e3) {
    return I2(e3, { matricize: true });
  }, "Matrix, number|BigNumber": function(e3, t3) {
    return I2(e3, { precision: t3, matricize: true });
  }, "Matrix, Object": function(e3, t3) {
    var r2 = { matricize: true };
    return _extends$4(r2, t3), I2(e3, r2);
  } });
  function I2(e3) {
    var r2, i3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o2 = !("eigenvectors" in i3) || i3.eigenvectors, u2 = (function(e4, t3, r3) {
      var n3 = e4.toArray(), i4 = e4.size();
      if (2 !== i4.length || i4[0] !== i4[1]) throw new RangeError("Matrix must be square (size: ".concat(format$3(i4), ")"));
      var o3 = i4[0];
      if ((function(e5, t4, r4) {
        for (var n4 = 0; n4 < t4; n4++) for (var i5 = 0; i5 < t4; i5++) if (y(d(s(C2(e5[n4][i5]))), r4)) return false;
        return true;
      })(n3, o3, t3) && ((function(e5, t4) {
        for (var r4 = 0; r4 < t4; r4++) for (var n4 = 0; n4 < t4; n4++) e5[r4][n4] = M2(e5[r4][n4]);
      })(n3, o3), (function(e5, t4, r4) {
        for (var n4 = 0; n4 < t4; n4++) for (var i5 = n4; i5 < t4; i5++) if (y(d(s(a(e5[n4][i5], e5[i5][n4]))), r4)) return false;
        return true;
      })(n3, o3, t3))) {
        var u3 = R2(e4, n3, o3);
        return k2(n3, o3, t3, u3, r3);
      }
      var c3 = R2(e4, n3, o3);
      return B2(n3, o3, t3, c3, r3);
    })(e3, null !== (r2 = i3.precision) && void 0 !== r2 ? r2 : t2.relTol, o2);
    return i3.matricize && (u2.values = n(u2.values), o2 && (u2.eigenvectors = u2.eigenvectors.map(((e4) => {
      var { value: t3, vector: r3 } = e4;
      return { value: t3, vector: n(r3) };
    })))), o2 && Object.defineProperty(u2, "vectors", { enumerable: false, get: () => {
      throw new Error("eigs(M).vectors replaced with eigs(M).eigenvectors");
    } }), u2;
  }
  function R2(e3, t3, r2) {
    var n3 = e3.datatype();
    if ("number" === n3 || "BigNumber" === n3 || "Complex" === n3) return n3;
    for (var i3 = false, a2 = false, o2 = false, s2 = 0; s2 < r2; s2++) for (var u2 = 0; u2 < r2; u2++) {
      var c3 = t3[s2][u2];
      if (isNumber$1$1(c3) || isFraction$1(c3)) i3 = true;
      else if (isBigNumber$1(c3)) a2 = true;
      else {
        if (!isComplex$1(c3)) throw TypeError("Unsupported type in Matrix: " + typeOf$1(c3));
        o2 = true;
      }
    }
    if (a2 && o2 && console.warn("Complex BigNumbers not supported, this operation will lose precission."), o2) {
      for (var l2 = 0; l2 < r2; l2++) for (var f3 = 0; f3 < r2; f3++) t3[l2][f3] = _2(t3[l2][f3]);
      return "Complex";
    }
    if (a2) {
      for (var p2 = 0; p2 < r2; p2++) for (var m2 = 0; m2 < r2; m2++) t3[p2][m2] = d(t3[p2][m2]);
      return "BigNumber";
    }
    if (i3) {
      for (var h2 = 0; h2 < r2; h2++) for (var g2 = 0; g2 < r2; g2++) t3[h2][g2] = b2(t3[h2][g2]);
      return "number";
    }
    throw TypeError("Matrix contains unsupported types only.");
  }
})), name$17$1 = "expm", dependencies$17$1 = ["typed", "abs", "add", "identity", "inv", "multiply"], createExpm$1 = factory$1(name$17$1, dependencies$17$1, ((e2) => {
  var { typed: t2, abs: r, add: n, identity: i2, inv: a, multiply: o } = e2;
  return t2(name$17$1, { Matrix: function(e3) {
    var t3 = e3.size();
    if (2 !== t3.length || t3[0] !== t3[1]) throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
    for (var u = t3[0], c2 = (function(e4) {
      for (var t4 = e4.size()[0], n3 = 0, i3 = 0; i3 < t4; i3++) {
        for (var a2 = 0, o2 = 0; o2 < t4; o2++) a2 += r(e4.get([i3, o2]));
        n3 = Math.max(a2, n3);
      }
      return n3;
    })(e3), l = (function(e4, t4) {
      for (var r2 = 30, n3 = 0; n3 < r2; n3++) for (var i3 = 0; i3 <= n3; i3++) {
        var a2 = n3 - i3;
        if (s(e4, i3, a2) < t4) return { q: i3, j: a2 };
      }
      throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
    })(c2, 1e-15), f2 = l.q, p = l.j, m = o(e3, Math.pow(2, -p)), d = i2(u), h = i2(u), g = 1, y = m, v2 = -1, x2 = 1; x2 <= f2; x2++) x2 > 1 && (y = o(y, m), v2 = -v2), d = n(d, o(g = g * (f2 - x2 + 1) / ((2 * f2 - x2 + 1) * x2), y)), h = n(h, o(g * v2, y));
    for (var b2 = o(a(h), d), _2 = 0; _2 < p; _2++) b2 = o(b2, b2);
    return isSparseMatrix$1(e3) ? e3.createSparseMatrix(b2) : b2;
  } });
  function s(e3, t3, r2) {
    for (var n3 = 1, i3 = 2; i3 <= t3; i3++) n3 *= i3;
    for (var a2 = n3, o2 = t3 + 1; o2 <= 2 * t3; o2++) a2 *= o2;
    var s2 = a2 * (2 * t3 + 1);
    return 8 * Math.pow(e3 / Math.pow(2, r2), 2 * t3) * n3 * n3 / (a2 * s2);
  }
})), name$16$1 = "sqrtm", dependencies$16$1 = ["typed", "abs", "add", "multiply", "map", "sqrt", "subtract", "inv", "size", "max", "identity"], createSqrtm$1 = factory$1(name$16$1, dependencies$16$1, ((e2) => {
  var { typed: t2, abs: r, add: n, multiply: i2, map: a, sqrt: o, subtract: s, inv: u, size: c2, max: l, identity: f2 } = e2, p = 1e-6;
  function m(e3) {
    var t3, a2 = 0, o2 = e3, m2 = f2(c2(e3));
    do {
      var d = o2;
      if (o2 = i2(0.5, n(d, u(m2))), m2 = i2(0.5, n(m2, u(d))), (t3 = l(r(s(o2, d)))) > p && ++a2 > 1e3) throw new Error("computing square root of matrix: iterative method could not converge");
    } while (t3 > p);
    return o2;
  }
  return t2(name$16$1, { "Array | Matrix": function(e3) {
    var t3 = isMatrix$1(e3) ? e3.size() : arraySize$1(e3);
    switch (t3.length) {
      case 1:
        if (1 === t3[0]) return a(e3, o);
        throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
      case 2:
        if (t3[0] === t3[1]) return m(e3);
        throw new RangeError("Matrix must be square (size: " + format$3(t3) + ")");
      default:
        throw new RangeError("Matrix must be at most two dimensional (size: " + format$3(t3) + ")");
    }
  } });
})), name$15$1 = "sylvester", dependencies$15$1 = ["typed", "schur", "matrixFromColumns", "matrix", "multiply", "range", "concat", "transpose", "index", "subset", "add", "subtract", "identity", "lusolve", "abs"], createSylvester$1 = factory$1(name$15$1, dependencies$15$1, ((e2) => {
  var { typed: t2, schur: r, matrixFromColumns: n, matrix: i2, multiply: a, range: o, concat: s, transpose: u, index: c2, subset: l, add: f2, subtract: p, identity: m, lusolve: d, abs: h, config: g } = e2;
  return t2(name$15$1, { "Matrix, Matrix, Matrix": y, "Array, Matrix, Matrix": function(e3, t3, r2) {
    return y(i2(e3), t3, r2);
  }, "Array, Array, Matrix": function(e3, t3, r2) {
    return y(i2(e3), i2(t3), r2);
  }, "Array, Matrix, Array": function(e3, t3, r2) {
    return y(i2(e3), t3, i2(r2));
  }, "Matrix, Array, Matrix": function(e3, t3, r2) {
    return y(e3, i2(t3), r2);
  }, "Matrix, Array, Array": function(e3, t3, r2) {
    return y(e3, i2(t3), i2(r2));
  }, "Matrix, Matrix, Array": function(e3, t3, r2) {
    return y(e3, t3, i2(r2));
  }, "Array, Array, Array": function(e3, t3, r2) {
    return y(i2(e3), i2(t3), i2(r2)).toArray();
  } });
  function y(e3, t3, g2) {
    for (var y2 = t3.size()[0], v2 = e3.size()[0], x2 = r(e3), b2 = x2.T, _2 = x2.U, w2 = r(a(-1, t3)), A2 = w2.T, N = w2.U, D = a(a(u(_2), g2), N), E = o(0, v2), $2 = [], S2 = (e4, t4) => s(e4, t4, 1), C2 = (e4, t4) => s(e4, t4, 0), M2 = 0; M2 < y2; M2++) if (M2 < y2 - 1 && h(l(A2, c2(M2 + 1, M2))) > 1e-5) {
      for (var T2 = C2(l(D, c2(E, [M2])), l(D, c2(E, [M2 + 1]))), F = 0; F < M2; F++) T2 = f2(T2, C2(a($2[F], l(A2, c2(F, M2))), a($2[F], l(A2, c2(F, M2 + 1)))));
      var O2 = a(m(v2), a(-1, l(A2, c2(M2, M2)))), k2 = a(m(v2), a(-1, l(A2, c2(M2 + 1, M2)))), B2 = a(m(v2), a(-1, l(A2, c2(M2, M2 + 1)))), I2 = a(m(v2), a(-1, l(A2, c2(M2 + 1, M2 + 1)))), R2 = C2(S2(f2(b2, O2), k2), S2(B2, f2(b2, I2))), q2 = d(R2, T2);
      $2[M2] = q2.subset(c2(o(0, v2), [0])), $2[M2 + 1] = q2.subset(c2(o(v2, 2 * v2), [0])), M2++;
    } else {
      for (var z2 = l(D, c2(E, [M2])), P2 = 0; P2 < M2; P2++) z2 = f2(z2, a($2[P2], l(A2, c2(P2, M2))));
      var L2 = l(A2, c2(M2, M2)), j2 = p(b2, a(L2, m(v2)));
      $2[M2] = d(j2, z2);
    }
    var U2 = i2(n(...$2));
    return a(_2, a(U2, u(N)));
  }
})), name$14$1 = "schur", dependencies$14$1 = ["typed", "matrix", "identity", "multiply", "qr", "norm", "subtract"], createSchur$1 = factory$1(name$14$1, dependencies$14$1, ((e2) => {
  var { typed: t2, matrix: r, identity: n, multiply: i2, qr: a, norm: o, subtract: s } = e2;
  return t2(name$14$1, { Array: function(e3) {
    var t3 = u(r(e3));
    return { U: t3.U.valueOf(), T: t3.T.valueOf() };
  }, Matrix: function(e3) {
    return u(e3);
  } });
  function u(e3) {
    var t3, r2 = e3.size()[0], u2 = e3, c2 = n(r2), l = 0;
    do {
      t3 = u2;
      var f2 = a(u2), p = f2.Q, m = f2.R;
      if (u2 = i2(m, p), c2 = i2(c2, p), l++ > 100) break;
    } while (o(s(u2, t3)) > 1e-4);
    return { U: c2, T: u2 };
  }
})), name$13$1 = "lyap", dependencies$13$1 = ["typed", "matrix", "sylvester", "multiply", "transpose"], createLyap$1 = factory$1(name$13$1, dependencies$13$1, ((e2) => {
  var { typed: t2, matrix: r, sylvester: n, multiply: i2, transpose: a } = e2;
  return t2(name$13$1, { "Matrix, Matrix": function(e3, t3) {
    return n(e3, a(e3), i2(-1, t3));
  }, "Array, Matrix": function(e3, t3) {
    return n(r(e3), a(r(e3)), i2(-1, t3));
  }, "Matrix, Array": function(e3, t3) {
    return n(e3, a(r(e3)), r(i2(-1, t3)));
  }, "Array, Array": function(e3, t3) {
    return n(r(e3), a(r(e3)), r(i2(-1, t3))).toArray();
  } });
})), name$12$1 = "divide", dependencies$12$1 = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], createDivide$1 = factory$1(name$12$1, dependencies$12$1, ((e2) => {
  var { typed: t2, matrix: r, multiply: n, equalScalar: i2, divideScalar: a, inv: o } = e2, s = createMatAlgo11xS0s$1({ typed: t2, equalScalar: i2 }), u = createMatAlgo14xDs$1({ typed: t2 });
  return t2("divide", extend$2$1({ "Array | Matrix, Array | Matrix": function(e3, t3) {
    return n(e3, o(t3));
  }, "DenseMatrix, any": function(e3, t3) {
    return u(e3, t3, a, false);
  }, "SparseMatrix, any": function(e3, t3) {
    return s(e3, t3, a, false);
  }, "Array, any": function(e3, t3) {
    return u(r(e3), t3, a, false).valueOf();
  }, "any, Array | Matrix": function(e3, t3) {
    return n(e3, o(t3));
  } }, a.signatures));
})), name$11$1 = "distance", dependencies$11$1 = ["typed", "addScalar", "subtractScalar", "divideScalar", "multiplyScalar", "deepEqual", "sqrt", "abs"], createDistance$1 = factory$1(name$11$1, dependencies$11$1, ((e2) => {
  var { typed: t2, addScalar: r, subtractScalar: n, multiplyScalar: i2, divideScalar: a, deepEqual: o, sqrt: s, abs: u } = e2;
  return t2(name$11$1, { "Array, Array, Array": function(e3, t3, r2) {
    if (2 === e3.length && 2 === t3.length && 2 === r2.length) {
      if (!l(e3)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!l(t3)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!l(r2)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (o(t3, r2)) throw new TypeError("LinePoint1 should not be same with LinePoint2");
      var a2 = n(r2[1], t3[1]), s2 = n(t3[0], r2[0]), u2 = n(i2(r2[0], t3[1]), i2(t3[0], r2[1]));
      return h(e3[0], e3[1], a2, s2, u2);
    }
    throw new TypeError("Invalid Arguments: Try again");
  }, "Object, Object, Object": function(e3, t3, r2) {
    if (2 === Object.keys(e3).length && 2 === Object.keys(t3).length && 2 === Object.keys(r2).length) {
      if (!l(e3)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
      if (!l(t3)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
      if (!l(r2)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
      if (o(d(t3), d(r2))) throw new TypeError("LinePoint1 should not be same with LinePoint2");
      if ("pointX" in e3 && "pointY" in e3 && "lineOnePtX" in t3 && "lineOnePtY" in t3 && "lineTwoPtX" in r2 && "lineTwoPtY" in r2) {
        var a2 = n(r2.lineTwoPtY, t3.lineOnePtY), s2 = n(t3.lineOnePtX, r2.lineTwoPtX), u2 = n(i2(r2.lineTwoPtX, t3.lineOnePtY), i2(t3.lineOnePtX, r2.lineTwoPtY));
        return h(e3.pointX, e3.pointY, a2, s2, u2);
      }
      throw new TypeError("Key names do not match");
    }
    throw new TypeError("Invalid Arguments: Try again");
  }, "Array, Array": function(e3, t3) {
    if (2 === e3.length && 3 === t3.length) {
      if (!l(e3)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!f2(t3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      return h(e3[0], e3[1], t3[0], t3[1], t3[2]);
    }
    if (3 === e3.length && 6 === t3.length) {
      if (!f2(e3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!m(t3)) throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
      return g(e3[0], e3[1], e3[2], t3[0], t3[1], t3[2], t3[3], t3[4], t3[5]);
    }
    if (e3.length === t3.length && e3.length > 0) {
      if (!p(e3)) throw new TypeError("All values of an array should be numbers or BigNumbers");
      if (!p(t3)) throw new TypeError("All values of an array should be numbers or BigNumbers");
      return y(e3, t3);
    }
    throw new TypeError("Invalid Arguments: Try again");
  }, "Object, Object": function(e3, t3) {
    if (2 === Object.keys(e3).length && 3 === Object.keys(t3).length) {
      if (!l(e3)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
      if (!f2(t3)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
      if ("pointX" in e3 && "pointY" in e3 && "xCoeffLine" in t3 && "yCoeffLine" in t3 && "constant" in t3) return h(e3.pointX, e3.pointY, t3.xCoeffLine, t3.yCoeffLine, t3.constant);
      throw new TypeError("Key names do not match");
    }
    if (3 === Object.keys(e3).length && 6 === Object.keys(t3).length) {
      if (!f2(e3)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
      if (!m(t3)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
      if ("pointX" in e3 && "pointY" in e3 && "x0" in t3 && "y0" in t3 && "z0" in t3 && "a" in t3 && "b" in t3 && "c" in t3) return g(e3.pointX, e3.pointY, e3.pointZ, t3.x0, t3.y0, t3.z0, t3.a, t3.b, t3.c);
      throw new TypeError("Key names do not match");
    }
    if (2 === Object.keys(e3).length && 2 === Object.keys(t3).length) {
      if (!l(e3)) throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
      if (!l(t3)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
      if ("pointOneX" in e3 && "pointOneY" in e3 && "pointTwoX" in t3 && "pointTwoY" in t3) return y([e3.pointOneX, e3.pointOneY], [t3.pointTwoX, t3.pointTwoY]);
      throw new TypeError("Key names do not match");
    }
    if (3 === Object.keys(e3).length && 3 === Object.keys(t3).length) {
      if (!f2(e3)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
      if (!f2(t3)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
      if ("pointOneX" in e3 && "pointOneY" in e3 && "pointOneZ" in e3 && "pointTwoX" in t3 && "pointTwoY" in t3 && "pointTwoZ" in t3) return y([e3.pointOneX, e3.pointOneY, e3.pointOneZ], [t3.pointTwoX, t3.pointTwoY, t3.pointTwoZ]);
      throw new TypeError("Key names do not match");
    }
    throw new TypeError("Invalid Arguments: Try again");
  }, Array: function(e3) {
    if (!(function(e4) {
      if (2 === e4[0].length && c2(e4[0][0]) && c2(e4[0][1])) {
        if (e4.some(((e5) => 2 !== e5.length || !c2(e5[0]) || !c2(e5[1])))) return false;
      } else {
        if (!(3 === e4[0].length && c2(e4[0][0]) && c2(e4[0][1]) && c2(e4[0][2]))) return false;
        if (e4.some(((e5) => 3 !== e5.length || !c2(e5[0]) || !c2(e5[1]) || !c2(e5[2])))) return false;
      }
      return true;
    })(e3)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
    return (function(e4) {
      for (var t3 = [], r2 = [], n3 = [], i3 = 0; i3 < e4.length - 1; i3++) for (var a2 = i3 + 1; a2 < e4.length; a2++) 2 === e4[0].length ? (r2 = [e4[i3][0], e4[i3][1]], n3 = [e4[a2][0], e4[a2][1]]) : 3 === e4[0].length && (r2 = [e4[i3][0], e4[i3][1], e4[i3][2]], n3 = [e4[a2][0], e4[a2][1], e4[a2][2]]), t3.push(y(r2, n3));
      return t3;
    })(e3);
  } });
  function c2(e3) {
    return "number" == typeof e3 || isBigNumber$1(e3);
  }
  function l(e3) {
    return e3.constructor !== Array && (e3 = d(e3)), c2(e3[0]) && c2(e3[1]);
  }
  function f2(e3) {
    return e3.constructor !== Array && (e3 = d(e3)), c2(e3[0]) && c2(e3[1]) && c2(e3[2]);
  }
  function p(e3) {
    return Array.isArray(e3) || (e3 = d(e3)), e3.every(c2);
  }
  function m(e3) {
    return e3.constructor !== Array && (e3 = d(e3)), c2(e3[0]) && c2(e3[1]) && c2(e3[2]) && c2(e3[3]) && c2(e3[4]) && c2(e3[5]);
  }
  function d(e3) {
    for (var t3 = Object.keys(e3), r2 = [], n3 = 0; n3 < t3.length; n3++) r2.push(e3[t3[n3]]);
    return r2;
  }
  function h(e3, t3, n3, o2, c3) {
    var l2 = u(r(r(i2(n3, e3), i2(o2, t3)), c3)), f3 = s(r(i2(n3, n3), i2(o2, o2)));
    return a(l2, f3);
  }
  function g(e3, t3, o2, u2, c3, l2, f3, p2, m2) {
    var d2 = [n(i2(n(c3, t3), m2), i2(n(l2, o2), p2)), n(i2(n(l2, o2), f3), i2(n(u2, e3), m2)), n(i2(n(u2, e3), p2), i2(n(c3, t3), f3))];
    d2 = s(r(r(i2(d2[0], d2[0]), i2(d2[1], d2[1])), i2(d2[2], d2[2])));
    var h2 = s(r(r(i2(f3, f3), i2(p2, p2)), i2(m2, m2)));
    return a(d2, h2);
  }
  function y(e3, t3) {
    for (var a2 = e3.length, o2 = 0, u2 = 0, c3 = 0; c3 < a2; c3++) u2 = n(e3[c3], t3[c3]), o2 = r(i2(u2, u2), o2);
    return s(o2);
  }
})), name$10$1 = "intersect", dependencies$10$1 = ["typed", "config", "abs", "add", "addScalar", "matrix", "multiply", "multiplyScalar", "divideScalar", "subtract", "smaller", "equalScalar", "flatten", "isZero", "isNumeric"], createIntersect$1 = factory$1(name$10$1, dependencies$10$1, ((e2) => {
  var { typed: t2, config: r, abs: n, add: i2, addScalar: a, matrix: o, multiply: s, multiplyScalar: u, divideScalar: c2, subtract: l, smaller: f2, equalScalar: p, flatten: m, isZero: d, isNumeric: h } = e2;
  return t2("intersect", { "Array, Array, Array": g, "Array, Array, Array, Array": y, "Matrix, Matrix, Matrix": function(e3, t3, r2) {
    var n3 = g(e3.valueOf(), t3.valueOf(), r2.valueOf());
    return null === n3 ? null : o(n3);
  }, "Matrix, Matrix, Matrix, Matrix": function(e3, t3, r2, n3) {
    var i3 = y(e3.valueOf(), t3.valueOf(), r2.valueOf(), n3.valueOf());
    return null === i3 ? null : o(i3);
  } });
  function g(e3, t3, r2) {
    if (e3 = v2(e3), t3 = v2(t3), r2 = v2(r2), !b2(e3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
    if (!b2(t3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
    if (!(function(e4) {
      return 4 === e4.length && h(e4[0]) && h(e4[1]) && h(e4[2]) && h(e4[3]);
    })(r2)) throw new TypeError("Array with 4 numbers expected as third argument");
    return (function(e4, t4, r3, n3, i3, o2, s2, f3, p2, m2) {
      var d2 = u(e4, s2), h2 = u(n3, s2), g2 = u(t4, f3), y2 = u(i3, f3), v3 = u(r3, p2), x3 = u(o2, p2), b3 = l(l(l(m2, d2), g2), v3), _3 = l(l(l(a(a(h2, y2), x3), d2), g2), v3), w2 = c2(b3, _3), A2 = a(e4, u(w2, l(n3, e4))), N = a(t4, u(w2, l(i3, t4))), D = a(r3, u(w2, l(o2, r3)));
      return [A2, N, D];
    })(e3[0], e3[1], e3[2], t3[0], t3[1], t3[2], r2[0], r2[1], r2[2], r2[3]);
  }
  function y(e3, t3, o2, m2) {
    if (e3 = v2(e3), t3 = v2(t3), o2 = v2(o2), m2 = v2(m2), 2 === e3.length) {
      if (!x2(e3)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!x2(t3)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!x2(o2)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (!x2(m2)) throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
      return (function(e4, t4, o3, p2) {
        var m3 = e4, h2 = o3, g2 = l(m3, t4), y2 = l(h2, p2), v3 = l(u(g2[0], y2[1]), u(y2[0], g2[1]));
        if (d(v3)) return null;
        if (f2(n(v3), r.relTol)) return null;
        var x3 = u(y2[0], m3[1]), b3 = u(y2[1], m3[0]), _3 = u(y2[0], h2[1]), w2 = u(y2[1], h2[0]), A2 = c2(a(l(l(x3, b3), _3), w2), v3);
        return i2(s(g2, A2), m3);
      })(e3, t3, o2, m2);
    }
    if (3 === e3.length) {
      if (!b2(e3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!b2(t3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      if (!b2(o2)) throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
      if (!b2(m2)) throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
      return (function(e4, t4, r2, n3, i3, o3, s2, f3, m3, h2, g2, y2) {
        var v3 = _2(e4, s2, h2, s2, t4, f3, g2, f3, r2, m3, y2, m3), x3 = _2(h2, s2, n3, e4, g2, f3, i3, t4, y2, m3, o3, r2), b3 = _2(e4, s2, n3, e4, t4, f3, i3, t4, r2, m3, o3, r2), w2 = _2(h2, s2, h2, s2, g2, f3, g2, f3, y2, m3, y2, m3), A2 = _2(n3, e4, n3, e4, i3, t4, i3, t4, o3, r2, o3, r2), N = l(u(v3, x3), u(b3, w2)), D = l(u(A2, w2), u(x3, x3));
        if (d(D)) return null;
        var E = c2(N, D), $2 = c2(a(v3, u(E, x3)), w2), S2 = a(e4, u(E, l(n3, e4))), C2 = a(t4, u(E, l(i3, t4))), M2 = a(r2, u(E, l(o3, r2))), T2 = a(s2, u($2, l(h2, s2))), F = a(f3, u($2, l(g2, f3))), O2 = a(m3, u($2, l(y2, m3)));
        return p(S2, T2) && p(C2, F) && p(M2, O2) ? [S2, C2, M2] : null;
      })(e3[0], e3[1], e3[2], t3[0], t3[1], t3[2], o2[0], o2[1], o2[2], m2[0], m2[1], m2[2]);
    }
    throw new TypeError("Arrays with two or thee dimensional points expected");
  }
  function v2(e3) {
    return 1 === e3.length ? e3[0] : e3.length > 1 && Array.isArray(e3[0]) && e3.every(((e4) => Array.isArray(e4) && 1 === e4.length)) ? m(e3) : e3;
  }
  function x2(e3) {
    return 2 === e3.length && h(e3[0]) && h(e3[1]);
  }
  function b2(e3) {
    return 3 === e3.length && h(e3[0]) && h(e3[1]) && h(e3[2]);
  }
  function _2(e3, t3, r2, n3, i3, o2, s2, c3, f3, p2, m2, d2) {
    var h2 = u(l(e3, t3), l(r2, n3)), g2 = u(l(i3, o2), l(s2, c3)), y2 = u(l(f3, p2), l(m2, d2));
    return a(a(h2, g2), y2);
  }
})), name$$$1 = "sum", dependencies$$$1 = ["typed", "config", "add", "numeric"], createSum$1 = factory$1(name$$$1, dependencies$$$1, ((e2) => {
  var { typed: t2, config: r, add: n, numeric: i2 } = e2;
  return t2(name$$$1, { "Array | Matrix": a, "Array | Matrix, number | BigNumber": function(e3, t3) {
    try {
      return reduce$2$1(e3, t3, n);
    } catch (e4) {
      throw improveErrorMessage$1(e4, "sum");
    }
  }, "...": function(e3) {
    if (containsCollections$1(e3)) throw new TypeError("Scalar values expected in function sum");
    return a(e3);
  } });
  function a(e3) {
    var t3;
    return deepForEach$2(e3, (function(e4) {
      try {
        t3 = void 0 === t3 ? e4 : n(t3, e4);
      } catch (t4) {
        throw improveErrorMessage$1(t4, "sum", e4);
      }
    })), void 0 === t3 && (t3 = i2(0, r.number)), "string" == typeof t3 && (t3 = i2(t3, safeNumberType$1(t3, r))), t3;
  }
})), name$_$1 = "cumsum", dependencies$_$1 = ["typed", "add", "unaryPlus"], createCumSum$1 = factory$1(name$_$1, dependencies$_$1, ((e2) => {
  var { typed: t2, add: r, unaryPlus: n } = e2;
  return t2(name$_$1, { Array: i2, Matrix: function(e3) {
    return e3.create(i2(e3.valueOf(), e3.datatype()));
  }, "Array, number | BigNumber": o, "Matrix, number | BigNumber": function(e3, t3) {
    return e3.create(o(e3.valueOf(), t3), e3.datatype());
  }, "...": function(e3) {
    if (containsCollections$1(e3)) throw new TypeError("All values expected to be scalar in function cumsum");
    return i2(e3);
  } });
  function i2(e3) {
    try {
      return a(e3);
    } catch (e4) {
      throw improveErrorMessage$1(e4, name$_$1);
    }
  }
  function a(e3) {
    if (0 === e3.length) return [];
    for (var t3 = [n(e3[0])], i3 = 1; i3 < e3.length; ++i3) t3.push(r(t3[i3 - 1], e3[i3]));
    return t3;
  }
  function o(e3, t3) {
    var r2 = arraySize$1(e3);
    if (t3 < 0 || t3 >= r2.length) throw new IndexError$1(t3, r2.length);
    try {
      return s(e3, t3);
    } catch (e4) {
      throw improveErrorMessage$1(e4, name$_$1);
    }
  }
  function s(e3, t3) {
    var r2, n3, i3;
    if (t3 <= 0) {
      var o2 = e3[0][0];
      if (Array.isArray(o2)) {
        for (i3 = _switch$1$1(e3), n3 = [], r2 = 0; r2 < i3.length; r2++) n3[r2] = s(i3[r2], t3 - 1);
        return n3;
      }
      return a(e3);
    }
    for (n3 = [], r2 = 0; r2 < e3.length; r2++) n3[r2] = s(e3[r2], t3 - 1);
    return n3;
  }
})), name$Z$1 = "mean", dependencies$Z$1 = ["typed", "add", "divide"], createMean$1 = factory$1(name$Z$1, dependencies$Z$1, ((e2) => {
  var { typed: t2, add: r, divide: n } = e2;
  return t2(name$Z$1, { "Array | Matrix": i2, "Array | Matrix, number | BigNumber": function(e3, t3) {
    try {
      var i3 = reduce$2$1(e3, t3, r), a = Array.isArray(e3) ? arraySize$1(e3) : e3.size();
      return n(i3, a[t3]);
    } catch (e4) {
      throw improveErrorMessage$1(e4, "mean");
    }
  }, "...": function(e3) {
    if (containsCollections$1(e3)) throw new TypeError("Scalar values expected in function mean");
    return i2(e3);
  } });
  function i2(e3) {
    var t3, i3 = 0;
    if (deepForEach$2(e3, (function(e4) {
      try {
        t3 = void 0 === t3 ? e4 : r(t3, e4), i3++;
      } catch (t4) {
        throw improveErrorMessage$1(t4, "mean", e4);
      }
    })), 0 === i3) throw new Error("Cannot calculate the mean of an empty array");
    return n(t3, i3);
  }
})), name$Y$1 = "median", dependencies$Y$1 = ["typed", "add", "divide", "compare", "partitionSelect"], createMedian$1 = factory$1(name$Y$1, dependencies$Y$1, ((e2) => {
  var { typed: t2, add: r, divide: n, compare: i2, partitionSelect: a } = e2;
  function o(e3) {
    try {
      var t3 = (e3 = flatten$4$1(e3.valueOf())).length;
      if (0 === t3) throw new Error("Cannot calculate median of an empty array");
      if (t3 % 2 == 0) {
        for (var r2 = t3 / 2 - 1, n3 = a(e3, r2 + 1), o2 = e3[r2], c2 = 0; c2 < r2; ++c2) i2(e3[c2], o2) > 0 && (o2 = e3[c2]);
        return u(o2, n3);
      }
      var l = a(e3, (t3 - 1) / 2);
      return s(l);
    } catch (e4) {
      throw improveErrorMessage$1(e4, "median");
    }
  }
  var s = t2({ "number | BigNumber | Complex | Unit": function(e3) {
    return e3;
  } }), u = t2({ "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(e3, t3) {
    return n(r(e3, t3), 2);
  } });
  return t2(name$Y$1, { "Array | Matrix": o, "Array | Matrix, number | BigNumber": function(e3, t3) {
    throw new Error("median(A, dim) is not yet supported");
  }, "...": function(e3) {
    if (containsCollections$1(e3)) throw new TypeError("Scalar values expected in function median");
    return o(e3);
  } });
})), name$X$1 = "mad", dependencies$X$1 = ["typed", "abs", "map", "median", "subtract"], createMad$1 = factory$1(name$X$1, dependencies$X$1, ((e2) => {
  var { typed: t2, abs: r, map: n, median: i2, subtract: a } = e2;
  return t2(name$X$1, { "Array | Matrix": o, "...": function(e3) {
    return o(e3);
  } });
  function o(e3) {
    if (0 === (e3 = flatten$4$1(e3.valueOf())).length) throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
    try {
      var t3 = i2(e3);
      return i2(n(e3, (function(e4) {
        return r(a(e4, t3));
      })));
    } catch (e4) {
      throw e4 instanceof TypeError && e4.message.includes("median") ? new TypeError(e4.message.replace("median", "mad")) : improveErrorMessage$1(e4, "mad");
    }
  }
})), DEFAULT_NORMALIZATION$1 = "unbiased", name$W$1 = "variance", dependencies$W$1 = ["typed", "add", "subtract", "multiply", "divide", "mapSlices", "isNaN"], createVariance$1 = factory$1(name$W$1, dependencies$W$1, ((e2) => {
  var { typed: t2, add: r, subtract: n, multiply: i2, divide: a, mapSlices: o, isNaN: s } = e2;
  return t2(name$W$1, { "Array | Matrix": function(e3) {
    return u(e3, DEFAULT_NORMALIZATION$1);
  }, "Array | Matrix, string": u, "Array | Matrix, number | BigNumber": function(e3, t3) {
    return c2(e3, t3, DEFAULT_NORMALIZATION$1);
  }, "Array | Matrix, number | BigNumber, string": c2, "...": function(e3) {
    return u(e3, DEFAULT_NORMALIZATION$1);
  } });
  function u(e3, t3) {
    var o2, u2 = 0;
    if (0 === e3.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
    if (deepForEach$2(e3, (function(e4) {
      try {
        o2 = void 0 === o2 ? e4 : r(o2, e4), u2++;
      } catch (t4) {
        throw improveErrorMessage$1(t4, "variance", e4);
      }
    })), 0 === u2) throw new Error("Cannot calculate variance of an empty array");
    var c3 = a(o2, u2);
    if (o2 = void 0, deepForEach$2(e3, (function(e4) {
      var t4 = n(e4, c3);
      o2 = void 0 === o2 ? i2(t4, t4) : r(o2, i2(t4, t4));
    })), s(o2)) return o2;
    switch (t3) {
      case "uncorrected":
        return a(o2, u2);
      case "biased":
        return a(o2, u2 + 1);
      case "unbiased":
        var l = isBigNumber$1(o2) ? o2.mul(0) : 0;
        return 1 === u2 ? l : a(o2, u2 - 1);
      default:
        throw new Error('Unknown normalization "' + t3 + '". Choose "unbiased" (default), "uncorrected", or "biased".');
    }
  }
  function c2(e3, t3, r2) {
    try {
      if (0 === e3.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
      return o(e3, t3, ((e4) => u(e4, r2)));
    } catch (e4) {
      throw improveErrorMessage$1(e4, "variance");
    }
  }
})), name$V$1 = "quantileSeq", dependencies$V$1 = ["typed", "?bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger", "mapSlices"], createQuantileSeq$1 = factory$1(name$V$1, dependencies$V$1, ((e2) => {
  var { typed: t2, bignumber: r, add: n, subtract: i2, divide: a, multiply: o, partitionSelect: s, compare: u, isInteger: c2, smaller: l, smallerEq: f2, larger: p, mapSlices: m } = e2;
  return t2(name$V$1, { "Array | Matrix, number | BigNumber": (e3, t3) => h(e3, t3, false), "Array | Matrix, number | BigNumber, number": (e3, t3, r2) => d(e3, t3, false, r2, h), "Array | Matrix, number | BigNumber, boolean": h, "Array | Matrix, number | BigNumber, boolean, number": (e3, t3, r2, n3) => d(e3, t3, r2, n3, h), "Array | Matrix, Array | Matrix": (e3, t3) => g(e3, t3, false), "Array | Matrix, Array | Matrix, number": (e3, t3, r2) => d(e3, t3, false, r2, g), "Array | Matrix, Array | Matrix, boolean": g, "Array | Matrix, Array | Matrix, boolean, number": (e3, t3, r2, n3) => d(e3, t3, r2, n3, g) });
  function d(e3, t3, r2, n3, i3) {
    return m(e3, n3, ((e4) => i3(e4, t3, r2)));
  }
  function h(e3, t3, i3) {
    var o2, s2 = e3.valueOf();
    if (l(t3, 0)) throw new Error("N/prob must be non-negative");
    if (f2(t3, 1)) return isNumber$1$1(t3) ? y(s2, t3, i3) : r(y(s2, t3, i3));
    if (p(t3, 1)) {
      if (!c2(t3)) throw new Error("N must be a positive integer");
      if (p(t3, 4294967295)) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
      var u2 = n(t3, 1);
      o2 = [];
      for (var m2 = 0; l(m2, t3); m2++) {
        var d2 = a(m2 + 1, u2);
        o2.push(y(s2, d2, i3));
      }
      return isNumber$1$1(t3) ? o2 : r(o2);
    }
  }
  function g(e3, t3, r2) {
    for (var n3 = e3.valueOf(), i3 = t3.valueOf(), a2 = [], o2 = 0; o2 < i3.length; ++o2) a2.push(y(n3, i3[o2], r2));
    return a2;
  }
  function y(e3, t3, r2) {
    var a2 = flatten$4$1(e3), l2 = a2.length;
    if (0 === l2) throw new Error("Cannot calculate quantile of an empty sequence");
    var f3, p2, m2 = isNumber$1$1(t3) ? t3 * (l2 - 1) : t3.times(l2 - 1), d2 = isNumber$1$1(t3) ? Math.floor(m2) : m2.floor().toNumber(), h2 = isNumber$1$1(t3) ? m2 % 1 : m2.minus(d2);
    if (c2(m2)) return r2 ? a2[m2] : s(a2, isNumber$1$1(t3) ? m2 : m2.valueOf());
    if (r2) f3 = a2[d2], p2 = a2[d2 + 1];
    else {
      p2 = s(a2, d2 + 1), f3 = a2[d2];
      for (var g2 = 0; g2 < d2; ++g2) u(a2[g2], f3) > 0 && (f3 = a2[g2]);
    }
    return n(o(f3, i2(1, h2)), o(p2, h2));
  }
})), name$U$1 = "std", dependencies$U$1 = ["typed", "map", "sqrt", "variance"], createStd$1 = factory$1(name$U$1, dependencies$U$1, ((e2) => {
  var { typed: t2, map: r, sqrt: n, variance: i2 } = e2;
  return t2(name$U$1, { "Array | Matrix": a, "Array | Matrix, string": a, "Array | Matrix, number | BigNumber": a, "Array | Matrix, number | BigNumber, string": a, "...": function(e3) {
    return a(e3);
  } });
  function a(e3, t3) {
    if (0 === e3.length) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
    try {
      var a2 = i2.apply(null, arguments);
      return isCollection$1(a2) ? r(a2, n) : n(a2);
    } catch (e4) {
      throw e4 instanceof TypeError && e4.message.includes(" variance") ? new TypeError(e4.message.replace(" variance", " std")) : e4;
    }
  }
})), name$T$1 = "corr", dependencies$T$1 = ["typed", "matrix", "mean", "sqrt", "sum", "add", "subtract", "multiply", "pow", "divide"], createCorr$1 = factory$1(name$T$1, dependencies$T$1, ((e2) => {
  var { typed: t2, matrix: r, sqrt: n, sum: i2, add: a, subtract: o, multiply: s, pow: u, divide: c2 } = e2;
  return t2(name$T$1, { "Array, Array": function(e3, t3) {
    return l(e3, t3);
  }, "Matrix, Matrix": function(e3, t3) {
    var n3 = l(e3.toArray(), t3.toArray());
    return Array.isArray(n3) ? r(n3) : n3;
  } });
  function l(e3, t3) {
    var r2 = [];
    if (Array.isArray(e3[0]) && Array.isArray(t3[0])) {
      if (e3.length !== t3.length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same length.");
      for (var n3 = 0; n3 < e3.length; n3++) {
        if (e3[n3].length !== t3[n3].length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
        r2.push(f2(e3[n3], t3[n3]));
      }
      return r2;
    }
    if (e3.length !== t3.length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
    return f2(e3, t3);
  }
  function f2(e3, t3) {
    var r2 = e3.length, l2 = i2(e3), f3 = i2(t3), p = e3.reduce(((e4, r3, n3) => a(e4, s(r3, t3[n3]))), 0), m = i2(e3.map(((e4) => u(e4, 2)))), d = i2(t3.map(((e4) => u(e4, 2)))), h = o(s(r2, p), s(l2, f3)), g = n(s(o(s(r2, m), u(l2, 2)), o(s(r2, d), u(f3, 2))));
    return c2(h, g);
  }
})), name$S$1 = "bernoulli", dependencies$S$1 = ["typed", "config", "isInteger", "number", "?BigNumber", "?Fraction"], createBernoulli$1 = factory$1(name$S$1, dependencies$S$1, ((e2) => {
  var { typed: t2, config: r, number: n, BigNumber: i2, Fraction: a } = e2, o = [void 0], s = [void 0], u = [void 0], c2 = 50;
  return t2(name$S$1, { number: (e3) => _bernoulli$1(e3, ((e4) => e4), o, ((e4, t3) => e4 + t3), ((e4, t3) => e4 * t3), ((e4, t3) => e4 / t3)), "bigint | Fraction": (e3) => _bernoulli$1(n(e3), ((e4) => new a(e4)), s, ((e4, t3) => e4.add(t3)), ((e4, t3) => e4.mul(t3)), ((e4, t3) => e4.div(t3))), BigNumber: (e3) => (r.precision !== c2 && (u = [void 0], c2 = r.precision), _bernoulli$1(n(e3), ((e4) => new i2(e4)), u, ((e4, t3) => e4.add(t3)), ((e4, t3) => e4.mul(t3)), ((e4, t3) => e4.div(t3)))) });
}));
function _bernoulli$1(e2, t2, r, n, i2, a) {
  if (e2 < 0 || !isInteger$1(e2)) throw new RangeError("Bernoulli index must be nonnegative integer");
  if (0 === e2) return t2(1);
  if (1 === e2) return a(t2(-1), t2(2));
  if (e2 % 2 == 1) return t2(0);
  var o = t2(1);
  1 === r.length && r.push([a(o, t2(-3)), a(o, t2(-2)), a(o, t2(6))]);
  for (var s = e2 / 2, u = t2(0), c2 = t2(2); r.length <= s; ) {
    for (var l = r.length, f2 = Math.floor((l + 1) / 2), p = u, m = 1; m < f2; ++m) p = n(p, i2(r[m][0], r[l - m][0]));
    p = i2(p, c2), l % 2 == 0 && (p = n(p, i2(r[f2][0], r[f2][0]))), p = a(p, t2(-(2 * l + 1)));
    var d = a(i2(r[l - 1][1], t2(-l * (2 * l - 1))), c2);
    r.push([p, d, i2(d, p)]);
  }
  return r[s][2];
}
var name$R$1 = "combinations", dependencies$R$1 = ["typed"], createCombinations$1 = factory$1(name$R$1, dependencies$R$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$R$1, { "number, number": combinationsNumber$1, "BigNumber, BigNumber": function(e3, t3) {
    var r, n, i2 = e3.constructor, a = e3.minus(t3), o = new i2(1);
    if (!isPositiveInteger$2$1(e3) || !isPositiveInteger$2$1(t3)) throw new TypeError("Positive integer value expected in function combinations");
    if (t3.gt(e3)) throw new TypeError("k must be less than n in function combinations");
    if (r = o, t3.lt(a)) for (n = o; n.lte(a); n = n.plus(o)) r = r.times(t3.plus(n)).dividedBy(n);
    else for (n = o; n.lte(t3); n = n.plus(o)) r = r.times(a.plus(n)).dividedBy(n);
    return r;
  } });
}));
function isPositiveInteger$2$1(e2) {
  return e2.isInteger() && e2.gte(0);
}
var name$Q$1 = "combinationsWithRep", dependencies$Q$1 = ["typed"], createCombinationsWithRep$1 = factory$1(name$Q$1, dependencies$Q$1, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$Q$1, { "number, number": function(e3, t3) {
    if (!isInteger$1(e3) || e3 < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
    if (!isInteger$1(t3) || t3 < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
    if (e3 < 1) throw new TypeError("k must be less than or equal to n + k - 1");
    return t3 < e3 - 1 ? product$2(e3, e3 + t3 - 1) / product$2(1, t3) : product$2(t3 + 1, e3 + t3 - 1) / product$2(1, e3 - 1);
  }, "BigNumber, BigNumber": function(e3, t3) {
    var r, n, i2 = new e3.constructor(1), a = e3.minus(i2);
    if (!isPositiveInteger$1$1(e3) || !isPositiveInteger$1$1(t3)) throw new TypeError("Positive integer value expected in function combinationsWithRep");
    if (e3.lt(i2)) throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
    if (r = i2, t3.lt(a)) for (n = i2; n.lte(a); n = n.plus(i2)) r = r.times(t3.plus(n)).dividedBy(n);
    else for (n = i2; n.lte(t3); n = n.plus(i2)) r = r.times(a.plus(n)).dividedBy(n);
    return r;
  } });
}));
function isPositiveInteger$1$1(e2) {
  return e2.isInteger() && e2.gte(0);
}
var name$P$1 = "gamma", dependencies$P$1 = ["typed", "config", "multiplyScalar", "pow", "BigNumber", "Complex"], createGamma$1 = factory$1(name$P$1, dependencies$P$1, ((e2) => {
  var { typed: t2, config: r, multiplyScalar: n, pow: i2, BigNumber: a, Complex: o } = e2;
  return t2(name$P$1, { number: gammaNumber$1, Complex: function e3(t3) {
    if (0 === t3.im) return gammaNumber$1(t3.re);
    if (t3.re < 0.5) {
      var r2 = new o(1 - t3.re, -t3.im), n3 = new o(Math.PI * t3.re, Math.PI * t3.im);
      return new o(Math.PI).div(n3.sin()).div(e3(r2));
    }
    t3 = new o(t3.re - 1, t3.im);
    for (var i3 = new o(gammaP$1[0], 0), a2 = 1; a2 < gammaP$1.length; ++a2) {
      var s2 = new o(gammaP$1[a2], 0);
      i3 = i3.add(s2.div(t3.add(a2)));
    }
    var u = new o(t3.re + gammaG$1 + 0.5, t3.im), c2 = Math.sqrt(2 * Math.PI), l = u.pow(t3.add(0.5)), f2 = u.neg().exp();
    return i3.mul(c2).mul(l).mul(f2);
  }, BigNumber: function(e3) {
    if (e3.isInteger()) return e3.isNegative() || e3.isZero() ? new a(1 / 0) : s(e3.minus(1));
    if (!e3.isFinite()) return new a(e3.isNegative() ? NaN : 1 / 0);
    throw new Error("Integer BigNumber expected");
  } });
  function s(e3) {
    if (e3 < 8) return new a([1, 1, 2, 6, 24, 120, 720, 5040][e3]);
    var t3 = r.precision + (0 | Math.log(e3.toNumber())), n3 = a.clone({ precision: t3 });
    if (e3 % 2 == 1) return e3.times(s(new a(e3 - 1)));
    for (var i3 = e3, o2 = new n3(e3), u = e3.toNumber(); i3 > 2; ) u += i3 -= 2, o2 = o2.times(u);
    return new a(o2.toPrecision(a.precision));
  }
})), name$O$1 = "lgamma", dependencies$O$1 = ["Complex", "typed"], createLgamma$1 = factory$1(name$O$1, dependencies$O$1, ((e2) => {
  var { Complex: t2, typed: r } = e2, n = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return r(name$O$1, { number: lgammaNumber$1, Complex: function e3(r2) {
    if (r2.isNaN()) return new t2(NaN, NaN);
    if (0 === r2.im) return new t2(lgammaNumber$1(r2.re), 0);
    if (r2.re >= 7 || Math.abs(r2.im) >= 7) return i2(r2);
    if (r2.re <= 0.1) {
      var n3 = copysign$1(6.283185307179586, r2.im) * Math.floor(0.5 * r2.re + 0.25), o = r2.mul(Math.PI).sin().log(), s = e3(new t2(1 - r2.re, -r2.im));
      return new t2(1.1447298858494002, n3).sub(o).sub(s);
    }
    return r2.im >= 0 ? a(r2) : a(r2.conjugate()).conjugate();
  }, BigNumber: function() {
    throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
  } });
  function i2(e3) {
    for (var r2 = e3.sub(0.5).mul(e3.log()).sub(e3).add(lnSqrt2PI$1), i3 = new t2(1, 0).div(e3), a2 = i3.div(e3), o = n[0], s = n[1], u = 2 * a2.re, c2 = a2.re * a2.re + a2.im * a2.im, l = 2; l < 8; l++) {
      var f2 = s;
      s = -c2 * o + n[l], o = u * o + f2;
    }
    var p = i3.mul(a2.mul(o).add(s));
    return r2.add(p);
  }
  function a(e3) {
    var r2 = 0, n3 = 0, a2 = e3;
    for (e3 = e3.add(1); e3.re <= 7; ) {
      var o = (a2 = a2.mul(e3)).im < 0 ? 1 : 0;
      0 !== o && 0 === n3 && r2++, n3 = o, e3 = e3.add(1);
    }
    return i2(e3).sub(a2.log()).sub(new t2(0, 2 * r2 * Math.PI * 1));
  }
})), name$N$1 = "factorial", dependencies$N$1 = ["typed", "gamma"], createFactorial$1 = factory$1(name$N$1, dependencies$N$1, ((e2) => {
  var { typed: t2, gamma: r } = e2;
  return t2(name$N$1, { number: function(e3) {
    if (e3 < 0) throw new Error("Value must be non-negative");
    return r(e3 + 1);
  }, BigNumber: function(e3) {
    if (e3.isNegative()) throw new Error("Value must be non-negative");
    return r(e3.plus(1));
  }, "Array | Matrix": t2.referToSelf(((e3) => (t3) => deepMap$2(t3, e3))) });
})), name$M$1 = "kldivergence", dependencies$M$1 = ["typed", "matrix", "divide", "sum", "multiply", "map", "dotDivide", "log", "isNumeric"], createKldivergence$1 = factory$1(name$M$1, dependencies$M$1, ((e2) => {
  var { typed: t2, matrix: r, divide: n, sum: i2, multiply: a, map: o, dotDivide: s, log: u, isNumeric: c2 } = e2;
  return t2(name$M$1, { "Array, Array": function(e3, t3) {
    return l(r(e3), r(t3));
  }, "Matrix, Array": function(e3, t3) {
    return l(e3, r(t3));
  }, "Array, Matrix": function(e3, t3) {
    return l(r(e3), t3);
  }, "Matrix, Matrix": function(e3, t3) {
    return l(e3, t3);
  } });
  function l(e3, t3) {
    var r2 = t3.size().length, l2 = e3.size().length;
    if (r2 > 1) throw new Error("first object must be one dimensional");
    if (l2 > 1) throw new Error("second object must be one dimensional");
    if (r2 !== l2) throw new Error("Length of two vectors must be equal");
    if (0 === i2(e3)) throw new Error("Sum of elements in first object must be non zero");
    if (0 === i2(t3)) throw new Error("Sum of elements in second object must be non zero");
    var f2 = n(e3, i2(e3)), p = n(t3, i2(t3)), m = i2(a(f2, o(s(f2, p), ((e4) => u(e4)))));
    return c2(m) ? m : Number.NaN;
  }
})), name$L$1 = "multinomial", dependencies$L$1 = ["typed", "add", "divide", "multiply", "factorial", "isInteger", "isPositive"], createMultinomial$1 = factory$1(name$L$1, dependencies$L$1, ((e2) => {
  var { typed: t2, add: r, divide: n, multiply: i2, factorial: a, isInteger: o, isPositive: s } = e2;
  return t2(name$L$1, { "Array | Matrix": function(e3) {
    var t3 = 0, u = 1;
    return deepForEach$2(e3, (function(e4) {
      if (!o(e4) || !s(e4)) throw new TypeError("Positive integer value expected in function multinomial");
      t3 = r(t3, e4), u = i2(u, a(e4));
    })), n(a(t3), u);
  } });
})), name$K$1 = "permutations", dependencies$K$1 = ["typed", "factorial"], createPermutations$1 = factory$1(name$K$1, dependencies$K$1, ((e2) => {
  var { typed: t2, factorial: r } = e2;
  return t2(name$K$1, { "number | BigNumber": r, "number, number": function(e3, t3) {
    if (!isInteger$1(e3) || e3 < 0) throw new TypeError("Positive integer value expected in function permutations");
    if (!isInteger$1(t3) || t3 < 0) throw new TypeError("Positive integer value expected in function permutations");
    if (t3 > e3) throw new TypeError("second argument k must be less than or equal to first argument n");
    return product$2(e3 - t3 + 1, e3);
  }, "BigNumber, BigNumber": function(e3, t3) {
    var r2, n;
    if (!isPositiveInteger$3(e3) || !isPositiveInteger$3(t3)) throw new TypeError("Positive integer value expected in function permutations");
    if (t3.gt(e3)) throw new TypeError("second argument k must be less than or equal to first argument n");
    for (r2 = e3.mul(0).add(1), n = e3.minus(t3).plus(1); n.lte(e3); n = n.plus(1)) r2 = r2.times(n);
    return r2;
  } });
}));
function isPositiveInteger$3(e2) {
  return e2.isInteger() && e2.gte(0);
}
var alea$1$1 = { exports: {} }, hasRequiredAlea$1;
function requireAlea$1() {
  return hasRequiredAlea$1 || (hasRequiredAlea$1 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t3 = this, r2 = /* @__PURE__ */ (function() {
        var e4 = 4022871197, t4 = function(t5) {
          t5 = String(t5);
          for (var r3 = 0; r3 < t5.length; r3++) {
            var n3 = 0.02519603282416938 * (e4 += t5.charCodeAt(r3));
            n3 -= e4 = n3 >>> 0, e4 = (n3 *= e4) >>> 0, e4 += 4294967296 * (n3 -= e4);
          }
          return 23283064365386963e-26 * (e4 >>> 0);
        };
        return t4;
      })();
      t3.next = function() {
        var e4 = 2091639 * t3.s0 + 23283064365386963e-26 * t3.c;
        return t3.s0 = t3.s1, t3.s1 = t3.s2, t3.s2 = e4 - (t3.c = 0 | e4);
      }, t3.c = 1, t3.s0 = r2(" "), t3.s1 = r2(" "), t3.s2 = r2(" "), t3.s0 -= r2(e3), t3.s0 < 0 && (t3.s0 += 1), t3.s1 -= r2(e3), t3.s1 < 0 && (t3.s1 += 1), t3.s2 -= r2(e3), t3.s2 < 0 && (t3.s2 += 1), r2 = null;
    }
    function i2(e3, t3) {
      return t3.c = e3.c, t3.s0 = e3.s0, t3.s1 = e3.s1, t3.s2 = e3.s2, t3;
    }
    function a(e3, t3) {
      var r2 = new n(e3), a2 = t3 && t3.state, o = r2.next;
      return o.int32 = function() {
        return 4294967296 * r2.next() | 0;
      }, o.double = function() {
        return o() + 11102230246251565e-32 * (2097152 * o() | 0);
      }, o.quick = o, a2 && ("object" == typeof a2 && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.alea = a;
  })(0, alea$1$1)), alea$1$1.exports;
}
var xor128$1$1 = { exports: {} }, hasRequiredXor128$1;
function requireXor128$1() {
  return hasRequiredXor128$1 || (hasRequiredXor128$1 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t3 = this, r2 = "";
      t3.x = 0, t3.y = 0, t3.z = 0, t3.w = 0, t3.next = function() {
        var e4 = t3.x ^ t3.x << 11;
        return t3.x = t3.y, t3.y = t3.z, t3.z = t3.w, t3.w ^= t3.w >>> 19 ^ e4 ^ e4 >>> 8;
      }, e3 === (0 | e3) ? t3.x = e3 : r2 += e3;
      for (var n3 = 0; n3 < r2.length + 64; n3++) t3.x ^= 0 | r2.charCodeAt(n3), t3.next();
    }
    function i2(e3, t3) {
      return t3.x = e3.x, t3.y = e3.y, t3.z = e3.z, t3.w = e3.w, t3;
    }
    function a(e3, t3) {
      var r2 = new n(e3), a2 = t3 && t3.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && ("object" == typeof a2 && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.xor128 = a;
  })(0, xor128$1$1)), xor128$1$1.exports;
}
var xorwow$1$1 = { exports: {} }, hasRequiredXorwow$1;
function requireXorwow$1() {
  return hasRequiredXorwow$1 || (hasRequiredXorwow$1 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t3 = this, r2 = "";
      t3.next = function() {
        var e4 = t3.x ^ t3.x >>> 2;
        return t3.x = t3.y, t3.y = t3.z, t3.z = t3.w, t3.w = t3.v, (t3.d = t3.d + 362437 | 0) + (t3.v = t3.v ^ t3.v << 4 ^ e4 ^ e4 << 1) | 0;
      }, t3.x = 0, t3.y = 0, t3.z = 0, t3.w = 0, t3.v = 0, e3 === (0 | e3) ? t3.x = e3 : r2 += e3;
      for (var n3 = 0; n3 < r2.length + 64; n3++) t3.x ^= 0 | r2.charCodeAt(n3), n3 == r2.length && (t3.d = t3.x << 10 ^ t3.x >>> 4), t3.next();
    }
    function i2(e3, t3) {
      return t3.x = e3.x, t3.y = e3.y, t3.z = e3.z, t3.w = e3.w, t3.v = e3.v, t3.d = e3.d, t3;
    }
    function a(e3, t3) {
      var r2 = new n(e3), a2 = t3 && t3.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && ("object" == typeof a2 && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.xorwow = a;
  })(0, xorwow$1$1)), xorwow$1$1.exports;
}
var xorshift7$1$1 = { exports: {} }, hasRequiredXorshift7$1;
function requireXorshift7$1() {
  return hasRequiredXorshift7$1 || (hasRequiredXorshift7$1 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t3 = this;
      t3.next = function() {
        var e4, r2, n3 = t3.x, i3 = t3.i;
        return e4 = n3[i3], r2 = (e4 ^= e4 >>> 7) ^ e4 << 24, r2 ^= (e4 = n3[i3 + 1 & 7]) ^ e4 >>> 10, r2 ^= (e4 = n3[i3 + 3 & 7]) ^ e4 >>> 3, r2 ^= (e4 = n3[i3 + 4 & 7]) ^ e4 << 7, e4 = n3[i3 + 7 & 7], r2 ^= (e4 ^= e4 << 13) ^ e4 << 9, n3[i3] = r2, t3.i = i3 + 1 & 7, r2;
      }, (function(e4, t4) {
        var r2, n3 = [];
        if (t4 === (0 | t4)) n3[0] = t4;
        else for (t4 = "" + t4, r2 = 0; r2 < t4.length; ++r2) n3[7 & r2] = n3[7 & r2] << 15 ^ t4.charCodeAt(r2) + n3[r2 + 1 & 7] << 13;
        for (; n3.length < 8; ) n3.push(0);
        for (r2 = 0; r2 < 8 && 0 === n3[r2]; ++r2) ;
        for (8 == r2 ? n3[7] = -1 : n3[r2], e4.x = n3, e4.i = 0, r2 = 256; r2 > 0; --r2) e4.next();
      })(t3, e3);
    }
    function i2(e3, t3) {
      return t3.x = e3.x.slice(), t3.i = e3.i, t3;
    }
    function a(e3, t3) {
      null == e3 && (e3 = +/* @__PURE__ */ new Date());
      var r2 = new n(e3), a2 = t3 && t3.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && (a2.x && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.xorshift7 = a;
  })(0, xorshift7$1$1)), xorshift7$1$1.exports;
}
var xor4096$1$1 = { exports: {} }, hasRequiredXor4096$1;
function requireXor4096$1() {
  return hasRequiredXor4096$1 || (hasRequiredXor4096$1 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t3 = this;
      t3.next = function() {
        var e4, r2, n3 = t3.w, i3 = t3.X, a2 = t3.i;
        return t3.w = n3 = n3 + 1640531527 | 0, r2 = i3[a2 + 34 & 127], e4 = i3[a2 = a2 + 1 & 127], r2 ^= r2 << 13, e4 ^= e4 << 17, r2 ^= r2 >>> 15, e4 ^= e4 >>> 12, r2 = i3[a2] = r2 ^ e4, t3.i = a2, r2 + (n3 ^ n3 >>> 16) | 0;
      }, (function(e4, t4) {
        var r2, n3, i3, a2, o, s = [], u = 128;
        for (t4 === (0 | t4) ? (n3 = t4, t4 = null) : (t4 += "\0", n3 = 0, u = Math.max(u, t4.length)), i3 = 0, a2 = -32; a2 < u; ++a2) t4 && (n3 ^= t4.charCodeAt((a2 + 32) % t4.length)), 0 === a2 && (o = n3), n3 ^= n3 << 10, n3 ^= n3 >>> 15, n3 ^= n3 << 4, n3 ^= n3 >>> 13, a2 >= 0 && (o = o + 1640531527 | 0, i3 = 0 == (r2 = s[127 & a2] ^= n3 + o) ? i3 + 1 : 0);
        for (i3 >= 128 && (s[127 & (t4 && t4.length || 0)] = -1), i3 = 127, a2 = 512; a2 > 0; --a2) n3 = s[i3 + 34 & 127], r2 = s[i3 = i3 + 1 & 127], n3 ^= n3 << 13, r2 ^= r2 << 17, n3 ^= n3 >>> 15, r2 ^= r2 >>> 12, s[i3] = n3 ^ r2;
        e4.w = o, e4.X = s, e4.i = i3;
      })(t3, e3);
    }
    function i2(e3, t3) {
      return t3.i = e3.i, t3.w = e3.w, t3.X = e3.X.slice(), t3;
    }
    function a(e3, t3) {
      null == e3 && (e3 = +/* @__PURE__ */ new Date());
      var r2 = new n(e3), a2 = t3 && t3.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && (a2.X && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.xor4096 = a;
  })(0, xor4096$1$1)), xor4096$1$1.exports;
}
var tychei$1$1 = { exports: {} }, hasRequiredTychei$1;
function requireTychei$1() {
  return hasRequiredTychei$1 || (hasRequiredTychei$1 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t3 = this, r2 = "";
      t3.next = function() {
        var e4 = t3.b, r3 = t3.c, n4 = t3.d, i3 = t3.a;
        return e4 = e4 << 25 ^ e4 >>> 7 ^ r3, r3 = r3 - n4 | 0, n4 = n4 << 24 ^ n4 >>> 8 ^ i3, i3 = i3 - e4 | 0, t3.b = e4 = e4 << 20 ^ e4 >>> 12 ^ r3, t3.c = r3 = r3 - n4 | 0, t3.d = n4 << 16 ^ r3 >>> 16 ^ i3, t3.a = i3 - e4 | 0;
      }, t3.a = 0, t3.b = 0, t3.c = -1640531527, t3.d = 1367130551, e3 === Math.floor(e3) ? (t3.a = e3 / 4294967296 | 0, t3.b = 0 | e3) : r2 += e3;
      for (var n3 = 0; n3 < r2.length + 20; n3++) t3.b ^= 0 | r2.charCodeAt(n3), t3.next();
    }
    function i2(e3, t3) {
      return t3.a = e3.a, t3.b = e3.b, t3.c = e3.c, t3.d = e3.d, t3;
    }
    function a(e3, t3) {
      var r2 = new n(e3), a2 = t3 && t3.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && ("object" == typeof a2 && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.tychei = a;
  })(0, tychei$1$1)), tychei$1$1.exports;
}
var seedrandom$4$1 = { exports: {} }, _polyfillNode_crypto$2 = {}, _polyfillNode_crypto$1$1 = Object.freeze({ __proto__: null, default: _polyfillNode_crypto$2 }), require$$0$1$1 = getAugmentedNamespace$2(_polyfillNode_crypto$1$1), seedrandom$3$1 = seedrandom$4$1.exports, hasRequiredSeedrandom$1$1, seedrandom$2$1, hasRequiredSeedrandom$2;
function requireSeedrandom$1$1() {
  return hasRequiredSeedrandom$1$1 || (hasRequiredSeedrandom$1$1 = 1, e2 = seedrandom$4$1, (function(t2, r, n) {
    var i2, a = 256, o = "random", s = n.pow(a, 6), u = n.pow(2, 52), c2 = 2 * u, l = 255;
    function f2(e3, l2, f3) {
      var y = [], v2 = h(d((l2 = 1 == l2 ? { entropy: true } : l2 || {}).entropy ? [e3, g(r)] : null == e3 ? (function() {
        try {
          var e4;
          return i2 && (e4 = i2.randomBytes) ? e4 = e4(a) : (e4 = new Uint8Array(a), (t2.crypto || t2.msCrypto).getRandomValues(e4)), g(e4);
        } catch (e5) {
          var n3 = t2.navigator, o2 = n3 && n3.plugins;
          return [+/* @__PURE__ */ new Date(), t2, o2, t2.screen, g(r)];
        }
      })() : e3, 3), y), x2 = new p(y), b2 = function() {
        for (var e4 = x2.g(6), t3 = s, r2 = 0; e4 < u; ) e4 = (e4 + r2) * a, t3 *= a, r2 = x2.g(1);
        for (; e4 >= c2; ) e4 /= 2, t3 /= 2, r2 >>>= 1;
        return (e4 + r2) / t3;
      };
      return b2.int32 = function() {
        return 0 | x2.g(4);
      }, b2.quick = function() {
        return x2.g(4) / 4294967296;
      }, b2.double = b2, h(g(x2.S), r), (l2.pass || f3 || function(e4, t3, r2, i3) {
        return i3 && (i3.S && m(i3, x2), e4.state = function() {
          return m(x2, {});
        }), r2 ? (n[o] = e4, t3) : e4;
      })(b2, v2, "global" in l2 ? l2.global : this == n, l2.state);
    }
    function p(e3) {
      var t3, r2 = e3.length, n3 = this, i3 = 0, o2 = n3.i = n3.j = 0, s2 = n3.S = [];
      for (r2 || (e3 = [r2++]); i3 < a; ) s2[i3] = i3++;
      for (i3 = 0; i3 < a; i3++) s2[i3] = s2[o2 = l & o2 + e3[i3 % r2] + (t3 = s2[i3])], s2[o2] = t3;
      (n3.g = function(e4) {
        for (var t4, r3 = 0, i4 = n3.i, o3 = n3.j, s3 = n3.S; e4--; ) t4 = s3[i4 = l & i4 + 1], r3 = r3 * a + s3[l & (s3[i4] = s3[o3 = l & o3 + t4]) + (s3[o3] = t4)];
        return n3.i = i4, n3.j = o3, r3;
      })(a);
    }
    function m(e3, t3) {
      return t3.i = e3.i, t3.j = e3.j, t3.S = e3.S.slice(), t3;
    }
    function d(e3, t3) {
      var r2, n3 = [], i3 = typeof e3;
      if (t3 && "object" == i3) for (r2 in e3) try {
        n3.push(d(e3[r2], t3 - 1));
      } catch (e4) {
      }
      return n3.length ? n3 : "string" == i3 ? e3 : e3 + "\0";
    }
    function h(e3, t3) {
      for (var r2, n3 = e3 + "", i3 = 0; i3 < n3.length; ) t3[l & i3] = l & (r2 ^= 19 * t3[l & i3]) + n3.charCodeAt(i3++);
      return g(t3);
    }
    function g(e3) {
      return String.fromCharCode.apply(0, e3);
    }
    if (h(n.random(), r), e2.exports) {
      e2.exports = f2;
      try {
        i2 = require$$0$1$1;
      } catch (e3) {
      }
    } else n["seed" + o] = f2;
  })("undefined" != typeof self ? self : seedrandom$3$1, [], Math)), seedrandom$4$1.exports;
  var e2;
}
function requireSeedrandom$2() {
  if (hasRequiredSeedrandom$2) return seedrandom$2$1;
  hasRequiredSeedrandom$2 = 1;
  var e2 = requireAlea$1(), t2 = requireXor128$1(), r = requireXorwow$1(), n = requireXorshift7$1(), i2 = requireXor4096$1(), a = requireTychei$1(), o = requireSeedrandom$1$1();
  return o.alea = e2, o.xor128 = t2, o.xorwow = r, o.xorshift7 = n, o.xor4096 = i2, o.tychei = a, seedrandom$2$1 = o;
}
var seedrandomExports$1 = requireSeedrandom$2(), seedrandom$1$1 = getDefaultExportFromCjs$5(seedrandomExports$1), singletonRandom$1 = seedrandom$1$1(Date.now());
function createRng$1(e2) {
  var t2, r;
  return t2 = null === (r = e2) ? singletonRandom$1 : seedrandom$1$1(String(r)), function() {
    return t2();
  };
}
var name$J$1 = "pickRandom", dependencies$J$1 = ["typed", "config", "?on"], createPickRandom$1 = factory$1(name$J$1, dependencies$J$1, ((e2) => {
  var { typed: t2, config: r, on: n } = e2, i2 = createRng$1(r.randomSeed);
  return n && n("config", (function(e3, t3) {
    e3.randomSeed !== t3.randomSeed && (i2 = createRng$1(e3.randomSeed));
  })), t2(name$J$1, { "Array | Matrix": function(e3) {
    return a(e3, {});
  }, "Array | Matrix, Object": function(e3, t3) {
    return a(e3, t3);
  }, "Array | Matrix, number": function(e3, t3) {
    return a(e3, { number: t3 });
  }, "Array | Matrix, Array | Matrix": function(e3, t3) {
    return a(e3, { weights: t3 });
  }, "Array | Matrix, Array | Matrix, number": function(e3, t3, r2) {
    return a(e3, { number: r2, weights: t3 });
  }, "Array | Matrix, number, Array | Matrix": function(e3, t3, r2) {
    return a(e3, { number: t3, weights: r2 });
  } });
  function a(e3, t3) {
    var { number: r2, weights: n3, elementWise: a2 = true } = t3, o = void 0 === r2;
    o && (r2 = 1);
    var s = isMatrix$1(e3) ? e3.create : isMatrix$1(n3) ? n3.create : null;
    e3 = e3.valueOf(), n3 && (n3 = n3.valueOf()), true === a2 && (e3 = flatten$4$1(e3), n3 = flatten$4$1(n3));
    var u = 0;
    if (void 0 !== n3) {
      if (n3.length !== e3.length) throw new Error("Weights must have the same length as possibles");
      for (var c2 = 0, l = n3.length; c2 < l; c2++) {
        if (!isNumber$1$1(n3[c2]) || n3[c2] < 0) throw new Error("Weights must be an array of positive numbers");
        u += n3[c2];
      }
    }
    for (var f2, p = e3.length, m = []; m.length < r2; ) {
      if (void 0 === n3) f2 = e3[Math.floor(i2() * p)];
      else for (var d = i2() * u, h = 0, g = e3.length; h < g; h++) if ((d -= n3[h]) < 0) {
        f2 = e3[h];
        break;
      }
      m.push(f2);
    }
    return o ? m[0] : s ? s(m) : m;
  }
}));
function randomMatrix$1(e2, t2) {
  var r = [];
  if ((e2 = e2.slice(0)).length > 1) for (var n = 0, i2 = e2.shift(); n < i2; n++) r.push(randomMatrix$1(e2, t2));
  else for (var a = 0, o = e2.shift(); a < o; a++) r.push(t2());
  return r;
}
var name$I$1 = "random", dependencies$I$1 = ["typed", "config", "?on"], createRandom$1 = factory$1(name$I$1, dependencies$I$1, ((e2) => {
  var { typed: t2, config: r, on: n } = e2, i2 = createRng$1(r.randomSeed);
  return n && n("config", (function(e3, t3) {
    e3.randomSeed !== t3.randomSeed && (i2 = createRng$1(e3.randomSeed));
  })), t2(name$I$1, { "": () => o(0, 1), number: (e3) => o(0, e3), "number, number": (e3, t3) => o(e3, t3), "Array | Matrix": (e3) => a(e3, 0, 1), "Array | Matrix, number": (e3, t3) => a(e3, 0, t3), "Array | Matrix, number, number": (e3, t3, r2) => a(e3, t3, r2) });
  function a(e3, t3, r2) {
    var n3 = randomMatrix$1(e3.valueOf(), (() => o(t3, r2)));
    return isMatrix$1(e3) ? e3.create(n3, "number") : n3;
  }
  function o(e3, t3) {
    return e3 + i2() * (t3 - e3);
  }
})), name$H$1 = "randomInt", dependencies$H$1 = ["typed", "config", "log2", "?on"], createRandomInt$1 = factory$1(name$H$1, dependencies$H$1, ((e2) => {
  var { typed: t2, config: r, log2: n, on: i2 } = e2, a = createRng$1(r.randomSeed);
  return i2 && i2("config", (function(e3, t3) {
    e3.randomSeed !== t3.randomSeed && (a = createRng$1(e3.randomSeed));
  })), t2(name$H$1, { "": () => s(0, 2), number: (e3) => s(0, e3), "number, number": (e3, t3) => s(e3, t3), bigint: (e3) => u(0n, e3), "bigint, bigint": u, "Array | Matrix": (e3) => o(e3, 0, 1), "Array | Matrix, number": (e3, t3) => o(e3, 0, t3), "Array | Matrix, number, number": (e3, t3, r2) => o(e3, t3, r2) });
  function o(e3, t3, r2) {
    var n3 = randomMatrix$1(e3.valueOf(), (() => s(t3, r2)));
    return isMatrix$1(e3) ? e3.create(n3, "number") : n3;
  }
  function s(e3, t3) {
    return Math.floor(e3 + a() * (t3 - e3));
  }
  function u(e3, t3) {
    var r2 = t3 - e3;
    if (r2 <= 2n ** 30n) return e3 + BigInt(s(0, Number(r2)));
    for (var i3 = n(r2), o2 = r2; o2 >= r2; ) {
      o2 = 0n;
      for (var u2 = 0; u2 < i3; ++u2) o2 = 2n * o2 + (a() < 0.5 ? 0n : 1n);
    }
    return e3 + o2;
  }
})), name$G$1 = "stirlingS2", dependencies$G$1 = ["typed", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "factorial", "combinations", "isNegative", "isInteger", "number", "?bignumber", "larger"], createStirlingS2$1 = factory$1(name$G$1, dependencies$G$1, ((e2) => {
  var { typed: t2, addScalar: r, subtractScalar: n, multiplyScalar: i2, divideScalar: a, pow: o, factorial: s, combinations: u, isNegative: c2, isInteger: l, number: f2, bignumber: p, larger: m } = e2, d = [], h = [];
  return t2(name$G$1, { "number | BigNumber, number | BigNumber": function(e3, t3) {
    if (!l(e3) || c2(e3) || !l(t3) || c2(t3)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
    if (m(t3, e3)) throw new TypeError("k must be less than or equal to n in function stirlingS2");
    var n3 = !(isNumber$1$1(e3) && isNumber$1$1(t3)), a2 = n3 ? h : d, o2 = n3 ? p : f2, s2 = f2(e3), u2 = f2(t3);
    if (a2[s2] && a2[s2].length > u2) return a2[s2][u2];
    for (var g = 0; g <= s2; ++g) if (a2[g] || (a2[g] = [o2(0 === g ? 1 : 0)]), 0 !== g) for (var y = a2[g], v2 = a2[g - 1], x2 = y.length; x2 <= g && x2 <= u2; ++x2) y[x2] = x2 === g ? 1 : r(i2(o2(x2), v2[x2]), v2[x2 - 1]);
    return a2[s2][u2];
  } });
})), name$F$1 = "bellNumbers", dependencies$F$1 = ["typed", "addScalar", "isNegative", "isInteger", "stirlingS2"], createBellNumbers$1 = factory$1(name$F$1, dependencies$F$1, ((e2) => {
  var { typed: t2, addScalar: r, isNegative: n, isInteger: i2, stirlingS2: a } = e2;
  return t2(name$F$1, { "number | BigNumber": function(e3) {
    if (!i2(e3) || n(e3)) throw new TypeError("Non-negative integer value expected in function bellNumbers");
    for (var t3 = 0, o = 0; o <= e3; o++) t3 = r(t3, a(e3, o));
    return t3;
  } });
})), name$E$1 = "catalan", dependencies$E$1 = ["typed", "addScalar", "divideScalar", "multiplyScalar", "combinations", "isNegative", "isInteger"], createCatalan$1 = factory$1(name$E$1, dependencies$E$1, ((e2) => {
  var { typed: t2, addScalar: r, divideScalar: n, multiplyScalar: i2, combinations: a, isNegative: o, isInteger: s } = e2;
  return t2(name$E$1, { "number | BigNumber": function(e3) {
    if (!s(e3) || o(e3)) throw new TypeError("Non-negative integer value expected in function catalan");
    return n(a(i2(e3, 2), e3), r(e3, 1));
  } });
})), name$D$1 = "composition", dependencies$D$1 = ["typed", "addScalar", "combinations", "isNegative", "isPositive", "isInteger", "larger"], createComposition$1 = factory$1(name$D$1, dependencies$D$1, ((e2) => {
  var { typed: t2, addScalar: r, combinations: n, isPositive: i2, isNegative: a, isInteger: o, larger: s } = e2;
  return t2(name$D$1, { "number | BigNumber, number | BigNumber": function(e3, t3) {
    if (!(o(e3) && i2(e3) && o(t3) && i2(t3))) throw new TypeError("Positive integer value expected in function composition");
    if (s(t3, e3)) throw new TypeError("k must be less than or equal to n in function composition");
    return n(r(e3, -1), r(t3, -1));
  } });
})), name$C$1 = "leafCount", dependencies$C$1 = ["parse", "typed"], createLeafCount$1 = factory$1(name$C$1, dependencies$C$1, ((e2) => {
  var { parse: t2, typed: r } = e2;
  function n(e3) {
    var t3 = 0;
    return e3.forEach(((e4) => {
      t3 += n(e4);
    })), t3 || 1;
  }
  return r(name$C$1, { Node: function(e3) {
    return n(e3);
  } });
}));
function isNumericNode$1(e2) {
  return isConstantNode$1(e2) || isOperatorNode$1(e2) && e2.isUnary() && isConstantNode$1(e2.args[0]);
}
function isConstantExpression$1(e2) {
  return !!isConstantNode$1(e2) || (!(!isFunctionNode$1(e2) && !isOperatorNode$1(e2) || !e2.args.every(isConstantExpression$1)) || !(!isParenthesisNode$1(e2) || !isConstantExpression$1(e2.content)));
}
function ownKeys$1$1(e2, t2) {
  var r = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e2);
    t2 && (n = n.filter((function(t3) {
      return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread$1$1(e2) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? ownKeys$1$1(Object(r), true).forEach((function(t3) {
      _defineProperty$3(e2, t3, r[t3]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r)) : ownKeys$1$1(Object(r)).forEach((function(t3) {
      Object.defineProperty(e2, t3, Object.getOwnPropertyDescriptor(r, t3));
    }));
  }
  return e2;
}
var name$B$1 = "simplifyUtil", dependencies$B$1 = ["FunctionNode", "OperatorNode", "SymbolNode"], createUtil$1 = factory$1(name$B$1, dependencies$B$1, ((e2) => {
  var { FunctionNode: t2, OperatorNode: r, SymbolNode: n } = e2, i2 = true, a = false, o = "defaultF", s = { add: { trivial: i2, total: i2, commutative: i2, associative: i2 }, unaryPlus: { trivial: i2, total: i2, commutative: i2, associative: i2 }, subtract: { trivial: a, total: i2, commutative: a, associative: a }, multiply: { trivial: i2, total: i2, commutative: i2, associative: i2 }, divide: { trivial: a, total: i2, commutative: a, associative: a }, paren: { trivial: i2, total: i2, commutative: i2, associative: a }, defaultF: { trivial: a, total: i2, commutative: a, associative: a } };
  function u(e3, t3) {
    var r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s, n3 = o;
    if ("string" == typeof e3 ? n3 = e3 : isOperatorNode$1(e3) ? n3 = e3.fn.toString() : isFunctionNode$1(e3) ? n3 = e3.name : isParenthesisNode$1(e3) && (n3 = "paren"), hasOwnProperty$1$2(r2, n3)) {
      var i3 = r2[n3];
      if (hasOwnProperty$1$2(i3, t3)) return i3[t3];
      if (hasOwnProperty$1$2(s, n3)) return s[n3][t3];
    }
    if (hasOwnProperty$1$2(r2, o)) {
      var a2 = r2[o];
      return hasOwnProperty$1$2(a2, t3) ? a2[t3] : s[o][t3];
    }
    if (hasOwnProperty$1$2(s, n3)) {
      var u2 = s[n3];
      if (hasOwnProperty$1$2(u2, t3)) return u2[t3];
    }
    return s[o][t3];
  }
  function c2(e3) {
    return u(e3, "associative", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s);
  }
  function l(e3, t3) {
    var r2, n3 = [], i3 = function(e4) {
      for (var t4 = 0; t4 < e4.args.length; t4++) {
        var a2 = e4.args[t4];
        isOperatorNode$1(a2) && r2 === a2.op ? i3(a2) : n3.push(a2);
      }
    };
    return c2(e3, t3) ? (r2 = e3.op, i3(e3), n3) : e3.args;
  }
  function f2(e3) {
    return isOperatorNode$1(e3) ? function(t3) {
      try {
        return new r(e3.op, e3.fn, t3, e3.implicit);
      } catch (e4) {
        return console.error(e4), [];
      }
    } : function(r2) {
      return new t2(new n(e3.name), r2);
    };
  }
  return { createMakeNodeFunction: f2, hasProperty: u, isCommutative: function(e3) {
    return u(e3, "commutative", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s);
  }, isAssociative: c2, mergeContext: function(e3, t3) {
    var r2 = _objectSpread$1$1({}, e3);
    for (var n3 in t3) hasOwnProperty$1$2(e3, n3) ? r2[n3] = _objectSpread$1$1(_objectSpread$1$1({}, t3[n3]), e3[n3]) : r2[n3] = t3[n3];
    return r2;
  }, flatten: function e3(t3, r2) {
    if (!t3.args || 0 === t3.args.length) return t3;
    t3.args = l(t3, r2);
    for (var n3 = 0; n3 < t3.args.length; n3++) e3(t3.args[n3], r2);
  }, allChildren: l, unflattenr: function e3(t3, r2) {
    if (t3.args && 0 !== t3.args.length) {
      for (var n3 = f2(t3), i3 = t3.args.length, a2 = 0; a2 < i3; a2++) e3(t3.args[a2], r2);
      if (i3 > 2 && c2(t3, r2)) {
        for (var o2 = t3.args.pop(); t3.args.length > 0; ) o2 = n3([t3.args.pop(), o2]);
        t3.args = o2.args;
      }
    }
  }, unflattenl: function e3(t3, r2) {
    if (t3.args && 0 !== t3.args.length) {
      for (var n3 = f2(t3), i3 = t3.args.length, a2 = 0; a2 < i3; a2++) e3(t3.args[a2], r2);
      if (i3 > 2 && c2(t3, r2)) {
        for (var o2 = t3.args.shift(); t3.args.length > 0; ) o2 = n3([o2, t3.args.shift()]);
        t3.args = o2.args;
      }
    }
  }, defaultContext: s, realContext: { divide: { total: a }, log: { total: a } }, positiveContext: { subtract: { total: a }, abs: { trivial: i2 }, log: { total: i2 } } };
})), name$A$1 = "simplify", dependencies$A$1 = ["typed", "parse", "equal", "resolve", "simplifyConstant", "simplifyCore", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode", "replacer"], createSimplify$1 = factory$1(name$A$1, dependencies$A$1, ((e2) => {
  var { typed: t2, parse: r, equal: n, resolve: i2, simplifyConstant: a, simplifyCore: o, AccessorNode: s, ArrayNode: u, ConstantNode: c2, FunctionNode: l, IndexNode: f2, ObjectNode: p, OperatorNode: m, ParenthesisNode: d, SymbolNode: h, replacer: g } = e2, { hasProperty: y, isCommutative: v2, isAssociative: x2, mergeContext: b2, flatten: _2, unflattenr: w2, unflattenl: A2, createMakeNodeFunction: N, defaultContext: D, realContext: E, positiveContext: $2 } = createUtil$1({ FunctionNode: l, OperatorNode: m, SymbolNode: h });
  t2.addConversion({ from: "Object", to: "Map", convert: createMap$1$1 });
  var S2 = t2("simplify", { Node: k2, "Node, Map": (e3, t3) => k2(e3, false, t3), "Node, Map, Object": (e3, t3, r2) => k2(e3, false, t3, r2), "Node, Array": k2, "Node, Array, Map": k2, "Node, Array, Map, Object": k2 });
  function C2(e3) {
    return e3.transform((function(e4) {
      return isParenthesisNode$1(e4) ? C2(e4.content) : e4;
    }));
  }
  t2.removeConversion({ from: "Object", to: "Map", convert: createMap$1$1 }), S2.defaultContext = D, S2.realContext = E, S2.positiveContext = $2;
  var M2 = { true: true, false: true, e: true, i: true, Infinity: true, LN2: true, LN10: true, LOG2E: true, LOG10E: true, NaN: true, phi: true, pi: true, SQRT1_2: true, SQRT2: true, tau: true };
  function T2(e3, t3) {
    var n3 = {};
    if (e3.s) {
      var i3 = e3.s.split("->");
      if (2 !== i3.length) throw SyntaxError("Could not parse rule: " + e3.s);
      n3.l = i3[0], n3.r = i3[1];
    } else n3.l = e3.l, n3.r = e3.r;
    for (var a2 of (n3.l = C2(r(n3.l)), n3.r = C2(r(n3.r)), ["imposeContext", "repeat", "assuming"])) a2 in e3 && (n3[a2] = e3[a2]);
    if (e3.evaluate && (n3.evaluate = r(e3.evaluate)), x2(n3.l, t3)) {
      var o2, s2 = !v2(n3.l, t3);
      s2 && (o2 = O2());
      var u2 = N(n3.l), c3 = O2();
      n3.expanded = {}, n3.expanded.l = u2([n3.l, c3]), _2(n3.expanded.l, t3), w2(n3.expanded.l, t3), n3.expanded.r = u2([n3.r, c3]), s2 && (n3.expandedNC1 = {}, n3.expandedNC1.l = u2([o2, n3.l]), n3.expandedNC1.r = u2([o2, n3.r]), n3.expandedNC2 = {}, n3.expandedNC2.l = u2([o2, n3.expanded.l]), n3.expandedNC2.r = u2([o2, n3.expanded.r]));
    }
    return n3;
  }
  S2.rules = [o, { l: "log(e)", r: "1" }, { s: "n-n1 -> n+-n1", assuming: { subtract: { total: true } } }, { s: "n-n -> 0", assuming: { subtract: { total: false } } }, { s: "-(cl*v) -> v * (-cl)", assuming: { multiply: { commutative: true }, subtract: { total: true } } }, { s: "-(cl*v) -> (-cl) * v", assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { s: "-(v*cl) -> v * (-cl)", assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { l: "-(n1/n2)", r: "-n1/n2" }, { l: "-v", r: "v * (-1)" }, { l: "(n1 + n2)*(-1)", r: "n1*(-1) + n2*(-1)", repeat: true }, { l: "n/n1^n2", r: "n*n1^-n2" }, { l: "n/n1", r: "n*n1^-1" }, { s: "(n1*n2)^n3 -> n1^n3 * n2^n3", assuming: { multiply: { commutative: true } } }, { s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)", assuming: { multiply: { commutative: false } } }, { s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)", assuming: { divide: { total: true } } }, { l: " vd   * ( vd   * n1 + n2)", r: "vd^2       * n1 +  vd   * n2" }, { s: " vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2", assuming: { divide: { total: true } } }, { s: "vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2", assuming: { divide: { total: true } } }, { s: "vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2", assuming: { divide: { total: true } } }, { l: "n*n", r: "n^2" }, { s: "n * n^n1 -> n^(n1+1)", assuming: { divide: { total: true } } }, { s: "n^n1 * n^n2 -> n^(n1+n2)", assuming: { divide: { total: true } } }, a, { s: "n+n -> 2*n", assuming: { add: { total: true } } }, { l: "n+-n", r: "0" }, { l: "vd*n + vd", r: "vd*(n+1)" }, { l: "n3*n1 + n3*n2", r: "n3*(n1+n2)" }, { l: "n3^(-n4)*n1 +   n3  * n2", r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)" }, { l: "n3^(-n4)*n1 + n3^n5 * n2", r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)" }, { s: "n*vd + vd -> (n+1)*vd", assuming: { multiply: { commutative: false } } }, { s: "vd + n*vd -> (1+n)*vd", assuming: { multiply: { commutative: false } } }, { s: "n1*n3 + n2*n3 -> (n1+n2)*n3", assuming: { multiply: { commutative: false } } }, { s: "n^n1 * n -> n^(n1+1)", assuming: { divide: { total: true }, multiply: { commutative: false } } }, { s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)", assuming: { multiply: { commutative: false } } }, { s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)", assuming: { multiply: { commutative: false } } }, { l: "n*cd + cd", r: "(n+1)*cd" }, { s: "cd*n + cd -> cd*(n+1)", assuming: { multiply: { commutative: false } } }, { s: "cd + cd*n -> cd*(1+n)", assuming: { multiply: { commutative: false } } }, a, { s: "(-n)*n1 -> -(n*n1)", assuming: { subtract: { total: true } } }, { s: "n1*(-n) -> -(n1*n)", assuming: { subtract: { total: true }, multiply: { commutative: false } } }, { s: "ce+ve -> ve+ce", assuming: { add: { commutative: true } }, imposeContext: { add: { commutative: false } } }, { s: "vd*cd -> cd*vd", assuming: { multiply: { commutative: true } }, imposeContext: { multiply: { commutative: false } } }, { l: "n+-n1", r: "n-n1" }, { l: "n+-(n1)", r: "n-(n1)" }, { s: "n*(n1^-1) -> n/n1", assuming: { multiply: { commutative: true } } }, { s: "n*n1^-n2 -> n/n1^n2", assuming: { multiply: { commutative: true } } }, { s: "n^-1 -> 1/n", assuming: { multiply: { commutative: true } } }, { l: "n^1", r: "n" }, { s: "n*(n1/n2) -> (n*n1)/n2", assuming: { multiply: { associative: true } } }, { s: "n-(n1+n2) -> n-n1-n2", assuming: { addition: { associative: true, commutative: true } } }, { l: "1*n", r: "n", imposeContext: { multiply: { commutative: true } } }, { s: "n1/(n2/n3) -> (n1*n3)/n2", assuming: { multiply: { associative: true } } }, { l: "n1/(-n2)", r: "-n1/n2" }];
  var F = 0;
  function O2() {
    return new h("_p" + F++);
  }
  function k2(e3, t3) {
    var r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : createEmptyMap$1(), n3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, a2 = n3.consoleDebug;
    t3 = (function(e4, t4) {
      for (var r3 = [], n4 = 0; n4 < e4.length; n4++) {
        var i3 = e4[n4], a3 = void 0, o3 = typeof i3;
        switch (o3) {
          case "string":
            i3 = { s: i3 };
          case "object":
            a3 = T2(i3, t4);
            break;
          case "function":
            a3 = i3;
            break;
          default:
            throw TypeError("Unsupported type of rule: " + o3);
        }
        r3.push(a3);
      }
      return r3;
    })(t3 || S2.rules, n3.context);
    for (var o2 = i2(e3, r2), s2 = {}, u2 = (o2 = C2(o2)).toString({ parenthesis: "all" }); !s2[u2]; ) {
      s2[u2] = true, F = 0;
      var c3 = u2;
      a2 && console.log("Working on: ", u2);
      for (var l2 = 0; l2 < t3.length; l2++) {
        var f3 = "";
        if ("function" == typeof t3[l2] ? (o2 = t3[l2](o2, n3), a2 && (f3 = t3[l2].name)) : (_2(o2, n3.context), o2 = I2(o2, t3[l2], n3.context), a2 && (f3 = "".concat(t3[l2].l.toString(), " -> ").concat(t3[l2].r.toString()))), a2) {
          var p2 = o2.toString({ parenthesis: "all" });
          p2 !== c3 && (console.log("Applying", f3, "produced", p2), c3 = p2);
        }
        A2(o2, n3.context);
      }
      u2 = o2.toString({ parenthesis: "all" });
    }
    return o2;
  }
  function B2(e3, t3, r2) {
    var n3 = e3;
    if (e3) for (var i3 = 0; i3 < e3.length; ++i3) {
      var a2 = I2(e3[i3], t3, r2);
      a2 !== e3[i3] && (n3 === e3 && (n3 = e3.slice()), n3[i3] = a2);
    }
    return n3;
  }
  function I2(e3, t3, r2) {
    if (t3.assuming) {
      for (var n3 in t3.assuming) for (var i3 in t3.assuming[n3]) if (y(n3, i3, r2) !== t3.assuming[n3][i3]) return e3;
    }
    var a2 = b2(t3.imposeContext, r2), o2 = e3;
    if (o2 instanceof m || o2 instanceof l) {
      var c3 = B2(o2.args, t3, r2);
      c3 !== o2.args && ((o2 = o2.clone()).args = c3);
    } else if (o2 instanceof d) {
      if (o2.content) {
        var h2 = I2(o2.content, t3, r2);
        h2 !== o2.content && (o2 = new d(h2));
      }
    } else if (o2 instanceof u) {
      var g2 = B2(o2.items, t3, r2);
      g2 !== o2.items && (o2 = new u(g2));
    } else if (o2 instanceof s) {
      var v3 = o2.object;
      o2.object && (v3 = I2(o2.object, t3, r2));
      var x3 = o2.index;
      o2.index && (x3 = I2(o2.index, t3, r2)), v3 === o2.object && x3 === o2.index || (o2 = new s(v3, x3));
    } else if (o2 instanceof f2) {
      var _3 = B2(o2.dimensions, t3, r2);
      _3 !== o2.dimensions && (o2 = new f2(_3));
    } else if (o2 instanceof p) {
      var w3 = false, A3 = {};
      for (var N2 in o2.properties) A3[N2] = I2(o2.properties[N2], t3, r2), A3[N2] !== o2.properties[N2] && (w3 = true);
      w3 && (o2 = new p(A3));
    }
    var D2 = t3.r, E2 = z2(t3.l, o2, a2)[0];
    if (!E2 && t3.expanded && (D2 = t3.expanded.r, E2 = z2(t3.expanded.l, o2, a2)[0]), !E2 && t3.expandedNC1 && (D2 = t3.expandedNC1.r, (E2 = z2(t3.expandedNC1.l, o2, a2)[0]) || (D2 = t3.expandedNC2.r, E2 = z2(t3.expandedNC2.l, o2, a2)[0])), E2) {
      var $3 = o2.implicit;
      o2 = D2.clone(), $3 && "implicit" in D2 && (o2.implicit = true), o2 = o2.transform((function(e4) {
        return e4.isSymbolNode && hasOwnProperty$1$2(E2.placeholders, e4.name) ? E2.placeholders[e4.name].clone() : e4;
      }));
    }
    return t3.repeat && o2 !== e3 && (o2 = I2(o2, t3, r2)), o2;
  }
  function R2(e3, t3) {
    var r2 = { placeholders: {} };
    if (!e3.placeholders && !t3.placeholders) return r2;
    if (!e3.placeholders) return t3;
    if (!t3.placeholders) return e3;
    for (var n3 in e3.placeholders) if (hasOwnProperty$1$2(e3.placeholders, n3) && (r2.placeholders[n3] = e3.placeholders[n3], hasOwnProperty$1$2(t3.placeholders, n3) && !P2(e3.placeholders[n3], t3.placeholders[n3]))) return null;
    for (var i3 in t3.placeholders) hasOwnProperty$1$2(t3.placeholders, i3) && (r2.placeholders[i3] = t3.placeholders[i3]);
    return r2;
  }
  function q2(e3, t3) {
    var r2, n3 = [];
    if (0 === e3.length || 0 === t3.length) return n3;
    for (var i3 = 0; i3 < e3.length; i3++) for (var a2 = 0; a2 < t3.length; a2++) (r2 = R2(e3[i3], t3[a2])) && n3.push(r2);
    return n3;
  }
  function z2(e3, t3, r2, i3) {
    var a2 = [{ placeholders: {} }];
    if (e3 instanceof m && t3 instanceof m || e3 instanceof l && t3 instanceof l) {
      if (e3 instanceof m) {
        if (e3.op !== t3.op || e3.fn !== t3.fn) return [];
      } else if (e3 instanceof l && e3.name !== t3.name) return [];
      if (!(1 === t3.args.length && 1 === e3.args.length || !x2(t3, r2) && t3.args.length === e3.args.length || i3)) {
        if (t3.args.length >= 2 && 2 === e3.args.length) {
          for (var o2 = (function(e4, t4) {
            var r3, n3, i4 = [], a3 = N(e4);
            if (v2(e4, t4)) for (var o3 = 0; o3 < e4.args.length; o3++) (n3 = e4.args.slice(0)).splice(o3, 1), r3 = 1 === n3.length ? n3[0] : a3(n3), i4.push(a3([e4.args[o3], r3]));
            else for (var s3 = 1; s3 < e4.args.length; s3++) {
              var u3 = e4.args[0];
              s3 > 1 && (u3 = a3(e4.args.slice(0, s3))), r3 = 1 === (n3 = e4.args.slice(s3)).length ? n3[0] : a3(n3), i4.push(a3([u3, r3]));
            }
            return i4;
          })(t3, r2), s2 = [], u2 = 0; u2 < o2.length; u2++) {
            var f3 = z2(e3, o2[u2], r2, true);
            s2 = s2.concat(f3);
          }
          return s2;
        }
        if (e3.args.length > 2) throw Error("Unexpected non-binary associative function: " + e3.toString());
        return [];
      }
      for (var p2 = [], d2 = 0; d2 < e3.args.length; d2++) {
        var y2 = z2(e3.args[d2], t3.args[d2], r2);
        if (0 === y2.length) break;
        p2.push(y2);
      }
      if (p2.length !== e3.args.length) {
        if (!v2(t3, r2) || 1 === e3.args.length) return [];
        if (e3.args.length > 2) throw new Error("permuting >2 commutative non-associative rule arguments not yet implemented");
        var b3 = z2(e3.args[0], t3.args[1], r2);
        if (0 === b3.length) return [];
        var _3 = z2(e3.args[1], t3.args[0], r2);
        if (0 === _3.length) return [];
        p2 = [b3, _3];
      }
      a2 = (function(e4) {
        if (0 === e4.length) return e4;
        for (var t4 = e4.reduce(q2), r3 = [], n3 = {}, i4 = 0; i4 < t4.length; i4++) {
          var a3 = JSON.stringify(t4[i4], g);
          n3[a3] || (n3[a3] = true, r3.push(t4[i4]));
        }
        return r3;
      })(p2);
    } else if (e3 instanceof h) {
      if (0 === e3.name.length) throw new Error("Symbol in rule has 0 length...!?");
      if (M2[e3.name]) {
        if (e3.name !== t3.name) return [];
      } else switch (e3.name[1] >= "a" && e3.name[1] <= "z" ? e3.name.substring(0, 2) : e3.name[0]) {
        case "n":
        case "_p":
          a2[0].placeholders[e3.name] = t3;
          break;
        case "c":
        case "cl":
          if (!isConstantNode$1(t3)) return [];
          a2[0].placeholders[e3.name] = t3;
          break;
        case "v":
          if (isConstantNode$1(t3)) return [];
          a2[0].placeholders[e3.name] = t3;
          break;
        case "vl":
          if (!isSymbolNode$1(t3)) return [];
          a2[0].placeholders[e3.name] = t3;
          break;
        case "cd":
          if (!isNumericNode$1(t3)) return [];
          a2[0].placeholders[e3.name] = t3;
          break;
        case "vd":
          if (isNumericNode$1(t3)) return [];
          a2[0].placeholders[e3.name] = t3;
          break;
        case "ce":
          if (!isConstantExpression$1(t3)) return [];
          a2[0].placeholders[e3.name] = t3;
          break;
        case "ve":
          if (isConstantExpression$1(t3)) return [];
          a2[0].placeholders[e3.name] = t3;
          break;
        default:
          throw new Error("Invalid symbol in rule: " + e3.name);
      }
    } else {
      if (!(e3 instanceof c2)) return [];
      if (!n(e3.value, t3.value)) return [];
    }
    return a2;
  }
  function P2(e3, t3) {
    if (e3 instanceof c2 && t3 instanceof c2) {
      if (!n(e3.value, t3.value)) return false;
    } else if (e3 instanceof h && t3 instanceof h) {
      if (e3.name !== t3.name) return false;
    } else {
      if (!(e3 instanceof m && t3 instanceof m || e3 instanceof l && t3 instanceof l)) return false;
      if (e3 instanceof m) {
        if (e3.op !== t3.op || e3.fn !== t3.fn) return false;
      } else if (e3 instanceof l && e3.name !== t3.name) return false;
      if (e3.args.length !== t3.args.length) return false;
      for (var r2 = 0; r2 < e3.args.length; r2++) if (!P2(e3.args[r2], t3.args[r2])) return false;
    }
    return true;
  }
  return S2;
})), name$z$1 = "simplifyConstant", dependencies$z$1 = ["typed", "config", "mathWithTransform", "matrix", "isBounded", "?fraction", "?bignumber", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode"], createSimplifyConstant$1 = factory$1(name$z$1, dependencies$z$1, ((e2) => {
  var { typed: t2, config: r, mathWithTransform: n, matrix: i2, isBounded: a, fraction: o, bignumber: s, AccessorNode: u, ArrayNode: c2, ConstantNode: l, FunctionNode: f2, IndexNode: p, ObjectNode: m, OperatorNode: d, SymbolNode: h } = e2, { isCommutative: g, isAssociative: y, allChildren: v2, createMakeNodeFunction: x2 } = createUtil$1({ FunctionNode: f2, OperatorNode: d, SymbolNode: h }), b2 = t2("simplifyConstant", { Node: (e3) => N(C2(e3, {})), "Node, Object": function(e3, t3) {
    return N(C2(e3, t3));
  } });
  function _2(e3) {
    return isFraction$1(e3) ? e3.valueOf() : e3 instanceof Array ? e3.map(_2) : isMatrix$1(e3) ? i2(_2(e3.valueOf())) : e3;
  }
  function w2(e3, t3, r2) {
    try {
      return n[e3].apply(null, t3);
    } catch (i3) {
      return t3 = t3.map(_2), E(n[e3].apply(null, t3), r2);
    }
  }
  var A2 = t2({ Fraction: function(e3) {
    var t3 = (e4) => "BigNumber" === r.number && s ? s(e4) : Number(e4), n3 = e3.s * e3.n, i3 = n3 < 0n ? new d("-", "unaryMinus", [new l(-t3(n3))]) : new l(t3(n3));
    return 1n === e3.d ? i3 : new d("/", "divide", [i3, new l(t3(e3.d))]);
  }, number: function(e3) {
    return e3 < 0 ? $2(new l(-e3)) : new l(e3);
  }, BigNumber: function(e3) {
    return e3 < 0 ? $2(new l(-e3)) : new l(e3);
  }, bigint: function(e3) {
    return e3 < 0n ? $2(new l(-e3)) : new l(e3);
  }, Complex: function(e3) {
    throw new Error("Cannot convert Complex number to Node");
  }, string: function(e3) {
    return new l(e3);
  }, Matrix: function(e3) {
    return new c2(e3.valueOf().map(((e4) => A2(e4))));
  } });
  function N(e3) {
    return isNode$2(e3) ? e3 : A2(e3);
  }
  function D(e3, t3) {
    if (t3 && false !== t3.exactFractions && a(e3) && o) {
      var r2 = o(e3), n3 = t3 && "number" == typeof t3.fractionsLimit ? t3.fractionsLimit : 1 / 0;
      if (r2.valueOf() === e3 && r2.n < n3 && r2.d < n3) return r2;
    }
    return e3;
  }
  var E = t2({ "string, Object": function(e3, t3) {
    var n3 = safeNumberType$1(e3, r);
    return "BigNumber" === n3 ? (void 0 === s && noBignumber$1(), s(e3)) : "bigint" === n3 ? BigInt(e3) : "Fraction" === n3 ? (void 0 === o && noFraction$1(), o(e3)) : D(parseFloat(e3), t3);
  }, "Fraction, Object": function(e3, t3) {
    return e3;
  }, "BigNumber, Object": function(e3, t3) {
    return e3;
  }, "number, Object": function(e3, t3) {
    return D(e3, t3);
  }, "bigint, Object": function(e3, t3) {
    return e3;
  }, "Complex, Object": function(e3, t3) {
    return 0 !== e3.im ? e3 : D(e3.re, t3);
  }, "Matrix, Object": function(e3, t3) {
    return i2(D(e3.valueOf()));
  }, "Array, Object": function(e3, t3) {
    return e3.map(D);
  } });
  function $2(e3) {
    return new d("-", "unaryMinus", [e3]);
  }
  function S2(e3, t3, r2, n3) {
    var i3 = t3.shift(), a2 = t3.reduce(((t4, i4) => {
      if (!isNode$2(i4)) {
        var a3 = t4.pop();
        if (isNode$2(a3)) return [a3, i4];
        try {
          return t4.push(w2(e3, [a3, i4], n3)), t4;
        } catch (e4) {
          t4.push(a3);
        }
      }
      t4.push(N(t4.pop()));
      var o2 = 1 === t4.length ? t4[0] : r2(t4);
      return [r2([o2, N(i4)])];
    }), [i3]);
    return 1 === a2.length ? a2[0] : r2([a2[0], A2(a2[1])]);
  }
  function C2(e3, t3) {
    switch (e3.type) {
      case "SymbolNode":
        return e3;
      case "ConstantNode":
        switch (typeof e3.value) {
          case "number":
          case "bigint":
            return E(e3.value, t3);
          case "string":
            return e3.value;
          default:
            if (!isNaN(e3.value)) return E(e3.value, t3);
        }
        return e3;
      case "FunctionNode":
        if (n[e3.name] && n[e3.name].rawArgs) return e3;
        if (!["add", "multiply"].includes(e3.name)) {
          var r2 = e3.args.map(((e4) => C2(e4, t3)));
          if (!r2.some(isNode$2)) try {
            return w2(e3.name, r2, t3);
          } catch (e4) {
          }
          if ("size" === e3.name && 1 === r2.length && isArrayNode$1(r2[0])) {
            for (var a2 = [], o2 = r2[0]; isArrayNode$1(o2); ) a2.push(o2.items.length), o2 = o2.items[0];
            return i2(a2);
          }
          return new f2(e3.name, r2.map(N));
        }
      case "OperatorNode":
        var s2, d2, h2 = e3.fn.toString(), _3 = x2(e3);
        if (isOperatorNode$1(e3) && e3.isUnary()) d2 = isNode$2((s2 = [C2(e3.args[0], t3)])[0]) ? _3(s2) : w2(h2, s2, t3);
        else if (y(e3, t3.context)) if (s2 = (s2 = v2(e3, t3.context)).map(((e4) => C2(e4, t3))), g(h2, t3.context)) {
          for (var A3 = [], D2 = [], $3 = 0; $3 < s2.length; $3++) isNode$2(s2[$3]) ? D2.push(s2[$3]) : A3.push(s2[$3]);
          A3.length > 1 ? (d2 = S2(h2, A3, _3, t3), D2.unshift(d2), d2 = S2(h2, D2, _3, t3)) : d2 = S2(h2, s2, _3, t3);
        } else d2 = S2(h2, s2, _3, t3);
        else d2 = S2(h2, s2 = e3.args.map(((e4) => C2(e4, t3))), _3, t3);
        return d2;
      case "ParenthesisNode":
        return C2(e3.content, t3);
      case "AccessorNode":
        return (function(e4, t4, r3) {
          if (!isIndexNode$1(t4)) return new u(N(e4), N(t4));
          if (isArrayNode$1(e4) || isMatrix$1(e4)) {
            for (var n3 = Array.from(t4.dimensions); n3.length > 0; ) if (isConstantNode$1(n3[0]) && "string" != typeof n3[0].value) {
              var a3 = E(n3.shift().value, r3);
              isArrayNode$1(e4) ? e4 = e4.items[a3 - 1] : (e4 = e4.valueOf()[a3 - 1]) instanceof Array && (e4 = i2(e4));
            } else {
              if (!(n3.length > 1 && isConstantNode$1(n3[1]) && "string" != typeof n3[1].value)) break;
              var o3 = E(n3[1].value, r3), s3 = [], f3 = isArrayNode$1(e4) ? e4.items : e4.valueOf();
              for (var m2 of f3) if (isArrayNode$1(m2)) s3.push(m2.items[o3 - 1]);
              else {
                if (!isMatrix$1(e4)) break;
                s3.push(m2[o3 - 1]);
              }
              if (s3.length !== f3.length) break;
              e4 = isArrayNode$1(e4) ? new c2(s3) : i2(s3), n3.splice(1, 1);
            }
            return n3.length === t4.dimensions.length ? new u(N(e4), t4) : n3.length > 0 ? (t4 = new p(n3), new u(N(e4), t4)) : e4;
          }
          if (isObjectNode$1(e4) && 1 === t4.dimensions.length && isConstantNode$1(t4.dimensions[0])) {
            var d3 = t4.dimensions[0].value;
            return d3 in e4.properties ? e4.properties[d3] : new l();
          }
          return new u(N(e4), t4);
        })(C2(e3.object, t3), C2(e3.index, t3), t3);
      case "ArrayNode":
        var M2 = e3.items.map(((e4) => C2(e4, t3)));
        return M2.some(isNode$2) ? new c2(M2.map(N)) : i2(M2);
      case "IndexNode":
        return new p(e3.dimensions.map(((e4) => b2(e4, t3))));
      case "ObjectNode":
        var T2 = {};
        for (var F in e3.properties) T2[F] = b2(e3.properties[F], t3);
        return new m(T2);
      default:
        throw new Error("Unimplemented node type in simplifyConstant: ".concat(e3.type));
    }
  }
  return b2;
})), name$y$1 = "simplifyCore", dependencies$y$1 = ["typed", "parse", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], createSimplifyCore$1 = factory$1(name$y$1, dependencies$y$1, ((e2) => {
  var { typed: t2, parse: r, equal: n, isZero: i2, add: a, subtract: o, multiply: s, divide: u, pow: c2, AccessorNode: l, ArrayNode: f2, ConstantNode: p, FunctionNode: m, IndexNode: d, ObjectNode: h, OperatorNode: g, ParenthesisNode: y, SymbolNode: v2 } = e2, x2 = new p(0), b2 = new p(1), _2 = new p(true), w2 = new p(false);
  function A2(e3) {
    return isOperatorNode$1(e3) && ["and", "not", "or"].includes(e3.op);
  }
  var { hasProperty: N, isCommutative: D } = createUtil$1({ FunctionNode: m, OperatorNode: g, SymbolNode: v2 });
  function E(e3) {
    var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t3 ? t3.context : void 0;
    if (N(e3, "trivial", r2)) {
      if (isFunctionNode$1(e3) && 1 === e3.args.length) return E(e3.args[0], t3);
      var a2 = false, o2 = 0;
      if (e3.forEach(((e4) => {
        1 === ++o2 && (a2 = E(e4, t3));
      })), 1 === o2) return a2;
    }
    var s2 = e3;
    if (isFunctionNode$1(s2)) {
      var u2 = getOperator$1(s2.name);
      if (!u2) return new m(E(s2.fn), s2.args.map(((e4) => E(e4, t3))));
      if (s2.args.length > 2 && N(s2, "associative", r2)) for (; s2.args.length > 2; ) {
        var c3 = s2.args.pop(), p2 = s2.args.pop();
        s2.args.push(new g(u2, s2.name, [c3, p2]));
      }
      s2 = new g(u2, s2.name, s2.args);
    }
    if (isOperatorNode$1(s2) && s2.isUnary()) {
      var y2 = E(s2.args[0], t3);
      if ("~" === s2.op && isOperatorNode$1(y2) && y2.isUnary() && "~" === y2.op) return y2.args[0];
      if ("not" === s2.op && isOperatorNode$1(y2) && y2.isUnary() && "not" === y2.op && A2(y2.args[0])) return y2.args[0];
      var v3 = true;
      if ("-" === s2.op && isOperatorNode$1(y2) && (y2.isBinary() && "subtract" === y2.fn && (s2 = new g("-", "subtract", [y2.args[1], y2.args[0]]), v3 = false), y2.isUnary() && "-" === y2.op)) return y2.args[0];
      if (v3) return new g(s2.op, s2.fn, [y2]);
    }
    if (isOperatorNode$1(s2) && s2.isBinary()) {
      var $2 = E(s2.args[0], t3), S2 = E(s2.args[1], t3);
      if ("+" === s2.op) {
        if (isConstantNode$1($2) && i2($2.value)) return S2;
        if (isConstantNode$1(S2) && i2(S2.value)) return $2;
        isOperatorNode$1(S2) && S2.isUnary() && "-" === S2.op && (S2 = S2.args[0], s2 = new g("-", "subtract", [$2, S2]));
      }
      if ("-" === s2.op) return isOperatorNode$1(S2) && S2.isUnary() && "-" === S2.op ? E(new g("+", "add", [$2, S2.args[0]]), t3) : isConstantNode$1($2) && i2($2.value) ? E(new g("-", "unaryMinus", [S2])) : isConstantNode$1(S2) && i2(S2.value) ? $2 : new g(s2.op, s2.fn, [$2, S2]);
      if ("*" === s2.op) {
        if (isConstantNode$1($2)) {
          if (i2($2.value)) return x2;
          if (n($2.value, 1)) return S2;
        }
        if (isConstantNode$1(S2)) {
          if (i2(S2.value)) return x2;
          if (n(S2.value, 1)) return $2;
          if (D(s2, r2)) return new g(s2.op, s2.fn, [S2, $2], s2.implicit);
        }
        return new g(s2.op, s2.fn, [$2, S2], s2.implicit);
      }
      if ("/" === s2.op) return isConstantNode$1($2) && i2($2.value) ? x2 : isConstantNode$1(S2) && n(S2.value, 1) ? $2 : new g(s2.op, s2.fn, [$2, S2]);
      if ("^" === s2.op && isConstantNode$1(S2)) {
        if (i2(S2.value)) return b2;
        if (n(S2.value, 1)) return $2;
      }
      if ("and" === s2.op) {
        if (isConstantNode$1($2)) {
          if (!$2.value) return w2;
          if (A2(S2)) return S2;
          if (isConstantNode$1(S2)) return S2.value ? _2 : w2;
        }
        if (isConstantNode$1(S2)) {
          if (!S2.value) return w2;
          if (A2($2)) return $2;
        }
      }
      if ("or" === s2.op) {
        if (isConstantNode$1($2)) {
          if ($2.value) return _2;
          if (A2(S2)) return S2;
        }
        if (isConstantNode$1(S2)) {
          if (S2.value) return _2;
          if (A2($2)) return $2;
        }
      }
      return new g(s2.op, s2.fn, [$2, S2]);
    }
    if (isOperatorNode$1(s2)) return new g(s2.op, s2.fn, s2.args.map(((e4) => E(e4, t3))));
    if (isArrayNode$1(s2)) return new f2(s2.items.map(((e4) => E(e4, t3))));
    if (isAccessorNode$1(s2)) return new l(E(s2.object, t3), E(s2.index, t3));
    if (isIndexNode$1(s2)) return new d(s2.dimensions.map(((e4) => E(e4, t3))));
    if (isObjectNode$1(s2)) {
      var C2 = {};
      for (var M2 in s2.properties) C2[M2] = E(s2.properties[M2], t3);
      return new h(C2);
    }
    return s2;
  }
  return t2(name$y$1, { Node: E, "Node,Object": E });
})), name$x$1 = "resolve", dependencies$x$1 = ["typed", "parse", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode"], createResolve$1 = factory$1(name$x$1, dependencies$x$1, ((e2) => {
  var { typed: t2, parse: r, ConstantNode: n, FunctionNode: i2, OperatorNode: a, ParenthesisNode: o } = e2;
  function s(e3, t3) {
    var u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : /* @__PURE__ */ new Set();
    if (!t3) return e3;
    if (isSymbolNode$1(e3)) {
      if (u.has(e3.name)) {
        var c2 = Array.from(u).join(", ");
        throw new ReferenceError("recursive loop of variable definitions among {".concat(c2, "}"));
      }
      var l = t3.get(e3.name);
      if (isNode$2(l)) {
        var f2 = new Set(u);
        return f2.add(e3.name), s(l, t3, f2);
      }
      return "number" == typeof l ? r(String(l)) : void 0 !== l ? new n(l) : e3;
    }
    if (isOperatorNode$1(e3)) {
      var p = e3.args.map((function(e4) {
        return s(e4, t3, u);
      }));
      return new a(e3.op, e3.fn, p, e3.implicit);
    }
    if (isParenthesisNode$1(e3)) return new o(s(e3.content, t3, u));
    if (isFunctionNode$1(e3)) {
      var m = e3.args.map((function(e4) {
        return s(e4, t3, u);
      }));
      return new i2(e3.name, m);
    }
    return e3.map(((e4) => s(e4, t3, u)));
  }
  return t2("resolve", { Node: s, "Node, Map | null | undefined": s, "Node, Object": (e3, t3) => s(e3, createMap$1$1(t3)), "Array | Matrix": t2.referToSelf(((e3) => (t3) => t3.map(((t4) => e3(t4))))), "Array | Matrix, null | undefined": t2.referToSelf(((e3) => (t3) => t3.map(((t4) => e3(t4))))), "Array, Object": t2.referTo("Array,Map", ((e3) => (t3, r2) => e3(t3, createMap$1$1(r2)))), "Matrix, Object": t2.referTo("Matrix,Map", ((e3) => (t3, r2) => e3(t3, createMap$1$1(r2)))), "Array | Matrix, Map": t2.referToSelf(((e3) => (t3, r2) => t3.map(((t4) => e3(t4, r2))))) });
})), name$w$1 = "symbolicEqual", dependencies$w$1 = ["parse", "simplify", "typed", "OperatorNode"], createSymbolicEqual$1 = factory$1(name$w$1, dependencies$w$1, ((e2) => {
  var { parse: t2, simplify: r, typed: n, OperatorNode: i2 } = e2;
  function a(e3, t3) {
    var n3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, a2 = new i2("-", "subtract", [e3, t3]), o = r(a2, {}, n3);
    return isConstantNode$1(o) && !o.value;
  }
  return n(name$w$1, { "Node, Node": a, "Node, Node, Object": a });
})), name$v$1 = "derivative", dependencies$v$1 = ["typed", "config", "parse", "simplify", "equal", "isZero", "numeric", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], createDerivative$1 = factory$1(name$v$1, dependencies$v$1, ((e2) => {
  var { typed: t2, config: r, parse: n, simplify: i2, equal: a, isZero: o, numeric: s, ConstantNode: u, FunctionNode: c2, OperatorNode: l, ParenthesisNode: f2, SymbolNode: p } = e2;
  function m(e3, t3) {
    var r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { simplify: true }, n3 = /* @__PURE__ */ new Map(), a2 = t3.name;
    var o2 = v2(e3, (function e4(t4) {
      var r3 = n3.get(t4);
      if (void 0 !== r3) return r3;
      var i3 = y(e4, t4, a2);
      return n3.set(t4, i3), i3;
    }));
    return r2.simplify ? i2(o2) : o2;
  }
  function d(e3) {
    var t3 = n(e3);
    if (!t3.isSymbolNode) throw new TypeError("Invalid variable. " + "Cannot parse ".concat(JSON.stringify(e3), " into a variable in function derivative"));
    return t3;
  }
  var h = t2(name$v$1, { "Node, SymbolNode": m, "Node, SymbolNode, Object": m, "Node, string": (e3, t3) => m(e3, d(t3)), "Node, string, Object": (e3, t3, r2) => m(e3, d(t3), r2) });
  h._simplify = true, h.toTex = function(e3) {
    return g.apply(null, e3.args);
  };
  var g = t2("_derivTex", { "Node, SymbolNode": function(e3, t3) {
    return isConstantNode$1(e3) && "string" === typeOf$1(e3.value) ? g(n(e3.value).toString(), t3.toString(), 1) : g(e3.toTex(), t3.toString(), 1);
  }, "Node, ConstantNode": function(e3, t3) {
    if ("string" === typeOf$1(t3.value)) return g(e3, n(t3.value));
    throw new Error("The second parameter to 'derivative' is a non-string constant");
  }, "Node, SymbolNode, ConstantNode": function(e3, t3, r2) {
    return g(e3.toString(), t3.name, r2.value);
  }, "string, string, number": function(e3, t3, r2) {
    return (1 === r2 ? "{d\\over d" + t3 + "}" : "{d^{" + r2 + "}\\over d" + t3 + "^{" + r2 + "}}") + "\\left[".concat(e3, "\\right]");
  } }), y = t2("_isConst", { "function, ConstantNode, string": function() {
    return true;
  }, "function, SymbolNode, string": function(e3, t3, r2) {
    return t3.name !== r2;
  }, "function, ParenthesisNode, string": function(e3, t3, r2) {
    return e3(t3.content, r2);
  }, "function, FunctionAssignmentNode, string": function(e3, t3, r2) {
    return !t3.params.includes(r2) || e3(t3.expr, r2);
  }, "function, FunctionNode | OperatorNode, string": function(e3, t3, r2) {
    return t3.args.every(((t4) => e3(t4, r2)));
  } }), v2 = t2("_derivative", { "ConstantNode, function": function() {
    return x2(0);
  }, "SymbolNode, function": function(e3, t3) {
    return t3(e3) ? x2(0) : x2(1);
  }, "ParenthesisNode, function": function(e3, t3) {
    return new f2(v2(e3.content, t3));
  }, "FunctionAssignmentNode, function": function(e3, t3) {
    return t3(e3) ? x2(0) : v2(e3.expr, t3);
  }, "FunctionNode, function": function(e3, t3) {
    if (t3(e3)) return x2(0);
    var r2, n3, i3, a2, o2 = e3.args[0], s2 = false, u2 = false;
    switch (e3.name) {
      case "cbrt":
        s2 = true, n3 = new l("*", "multiply", [x2(3), new l("^", "pow", [o2, new l("/", "divide", [x2(2), x2(3)])])]);
        break;
      case "sqrt":
      case "nthRoot":
        if (1 === e3.args.length) s2 = true, n3 = new l("*", "multiply", [x2(2), new c2("sqrt", [o2])]);
        else if (2 === e3.args.length) return r2 = new l("/", "divide", [x2(1), e3.args[1]]), v2(new l("^", "pow", [o2, r2]), t3);
        break;
      case "log10":
        r2 = x2(10);
      case "log":
        if (r2 || 1 !== e3.args.length) {
          if (1 === e3.args.length && r2 || 2 === e3.args.length && t3(e3.args[1])) n3 = new l("*", "multiply", [o2.clone(), new c2("log", [r2 || e3.args[1]])]), s2 = true;
          else if (2 === e3.args.length) return v2(new l("/", "divide", [new c2("log", [o2]), new c2("log", [e3.args[1]])]), t3);
        } else n3 = o2.clone(), s2 = true;
        break;
      case "pow":
        if (2 === e3.args.length) return v2(new l("^", "pow", [o2, e3.args[1]]), t3);
        break;
      case "exp":
        n3 = new c2("exp", [o2.clone()]);
        break;
      case "sin":
        n3 = new c2("cos", [o2.clone()]);
        break;
      case "cos":
        n3 = new l("-", "unaryMinus", [new c2("sin", [o2.clone()])]);
        break;
      case "tan":
        n3 = new l("^", "pow", [new c2("sec", [o2.clone()]), x2(2)]);
        break;
      case "sec":
        n3 = new l("*", "multiply", [e3, new c2("tan", [o2.clone()])]);
        break;
      case "csc":
        u2 = true, n3 = new l("*", "multiply", [e3, new c2("cot", [o2.clone()])]);
        break;
      case "cot":
        u2 = true, n3 = new l("^", "pow", [new c2("csc", [o2.clone()]), x2(2)]);
        break;
      case "asin":
        s2 = true, n3 = new c2("sqrt", [new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])])]);
        break;
      case "acos":
        s2 = true, u2 = true, n3 = new c2("sqrt", [new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])])]);
        break;
      case "atan":
        s2 = true, n3 = new l("+", "add", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)]);
        break;
      case "asec":
        s2 = true, n3 = new l("*", "multiply", [new c2("abs", [o2.clone()]), new c2("sqrt", [new l("-", "subtract", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])])]);
        break;
      case "acsc":
        s2 = true, u2 = true, n3 = new l("*", "multiply", [new c2("abs", [o2.clone()]), new c2("sqrt", [new l("-", "subtract", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])])]);
        break;
      case "acot":
        s2 = true, u2 = true, n3 = new l("+", "add", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)]);
        break;
      case "sinh":
        n3 = new c2("cosh", [o2.clone()]);
        break;
      case "cosh":
        n3 = new c2("sinh", [o2.clone()]);
        break;
      case "tanh":
        n3 = new l("^", "pow", [new c2("sech", [o2.clone()]), x2(2)]);
        break;
      case "sech":
        u2 = true, n3 = new l("*", "multiply", [e3, new c2("tanh", [o2.clone()])]);
        break;
      case "csch":
        u2 = true, n3 = new l("*", "multiply", [e3, new c2("coth", [o2.clone()])]);
        break;
      case "coth":
        u2 = true, n3 = new l("^", "pow", [new c2("csch", [o2.clone()]), x2(2)]);
        break;
      case "asinh":
        s2 = true, n3 = new c2("sqrt", [new l("+", "add", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])]);
        break;
      case "acosh":
        s2 = true, n3 = new c2("sqrt", [new l("-", "subtract", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])]);
        break;
      case "atanh":
        s2 = true, n3 = new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])]);
        break;
      case "asech":
        s2 = true, u2 = true, n3 = new l("*", "multiply", [o2.clone(), new c2("sqrt", [new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])])])]);
        break;
      case "acsch":
        s2 = true, u2 = true, n3 = new l("*", "multiply", [new c2("abs", [o2.clone()]), new c2("sqrt", [new l("+", "add", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])])]);
        break;
      case "acoth":
        s2 = true, u2 = true, n3 = new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])]);
        break;
      case "abs":
        n3 = new l("/", "divide", [new c2(new p("abs"), [o2.clone()]), o2.clone()]);
        break;
      default:
        throw new Error('Cannot process function "' + e3.name + '" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported');
    }
    s2 ? (i3 = "/", a2 = "divide") : (i3 = "*", a2 = "multiply");
    var f3 = v2(o2, t3);
    return u2 && (f3 = new l("-", "unaryMinus", [f3])), new l(i3, a2, [f3, n3]);
  }, "OperatorNode, function": function(e3, t3) {
    if (t3(e3)) return x2(0);
    if ("+" === e3.op) return new l(e3.op, e3.fn, e3.args.map((function(e4) {
      return v2(e4, t3);
    })));
    if ("-" === e3.op) {
      if (e3.isUnary()) return new l(e3.op, e3.fn, [v2(e3.args[0], t3)]);
      if (e3.isBinary()) return new l(e3.op, e3.fn, [v2(e3.args[0], t3), v2(e3.args[1], t3)]);
    }
    if ("*" === e3.op) {
      var r2 = e3.args.filter((function(e4) {
        return t3(e4);
      }));
      if (r2.length > 0) {
        var n3 = e3.args.filter((function(e4) {
          return !t3(e4);
        })), i3 = 1 === n3.length ? n3[0] : new l("*", "multiply", n3), s2 = r2.concat(v2(i3, t3));
        return new l("*", "multiply", s2);
      }
      return new l("+", "add", e3.args.map((function(r3) {
        return new l("*", "multiply", e3.args.map((function(e4) {
          return e4 === r3 ? v2(e4, t3) : e4.clone();
        })));
      })));
    }
    if ("/" === e3.op && e3.isBinary()) {
      var u2 = e3.args[0], f3 = e3.args[1];
      return t3(f3) ? new l("/", "divide", [v2(u2, t3), f3]) : t3(u2) ? new l("*", "multiply", [new l("-", "unaryMinus", [u2]), new l("/", "divide", [v2(f3, t3), new l("^", "pow", [f3.clone(), x2(2)])])]) : new l("/", "divide", [new l("-", "subtract", [new l("*", "multiply", [v2(u2, t3), f3.clone()]), new l("*", "multiply", [u2.clone(), v2(f3, t3)])]), new l("^", "pow", [f3.clone(), x2(2)])]);
    }
    if ("^" === e3.op && e3.isBinary()) {
      var p2 = e3.args[0], m2 = e3.args[1];
      if (t3(p2)) return isConstantNode$1(p2) && (o(p2.value) || a(p2.value, 1)) ? x2(0) : new l("*", "multiply", [e3, new l("*", "multiply", [new c2("log", [p2.clone()]), v2(m2.clone(), t3)])]);
      if (t3(m2)) {
        if (isConstantNode$1(m2)) {
          if (o(m2.value)) return x2(0);
          if (a(m2.value, 1)) return v2(p2, t3);
        }
        var d2 = new l("^", "pow", [p2.clone(), new l("-", "subtract", [m2, x2(1)])]);
        return new l("*", "multiply", [m2.clone(), new l("*", "multiply", [v2(p2, t3), d2])]);
      }
      return new l("*", "multiply", [new l("^", "pow", [p2.clone(), m2.clone()]), new l("+", "add", [new l("*", "multiply", [v2(p2, t3), new l("/", "divide", [m2.clone(), p2.clone()])]), new l("*", "multiply", [v2(m2, t3), new c2("log", [p2.clone()])])])]);
    }
    throw new Error('Cannot process operator "' + e3.op + '" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported');
  } });
  function x2(e3, t3) {
    return new u(s(e3, safeNumberType$1(String(e3), r)));
  }
  return h;
})), name$u$1 = "rationalize", dependencies$u$1 = ["config", "typed", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "parse", "simplifyConstant", "simplifyCore", "simplify", "?bignumber", "?fraction", "mathWithTransform", "matrix", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode", "ParenthesisNode"], createRationalize$1 = factory$1(name$u$1, dependencies$u$1, ((e2) => {
  var { config: t2, typed: r, equal: n, isZero: i2, add: a, subtract: o, multiply: s, divide: u, pow: c2, parse: l, simplifyConstant: f2, simplifyCore: p, simplify: m, fraction: d, bignumber: h, mathWithTransform: g, matrix: y, AccessorNode: v2, ArrayNode: x2, ConstantNode: b2, FunctionNode: _2, IndexNode: w2, ObjectNode: A2, OperatorNode: N, SymbolNode: D, ParenthesisNode: E } = e2;
  function $2(e3) {
    var t3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n3 = (function() {
      var e4 = [p, { l: "n+n", r: "2*n" }, { l: "n+-n", r: "0" }, f2, { l: "n*(n1^-1)", r: "n/n1" }, { l: "n*n1^-n2", r: "n/n1^n2" }, { l: "n1^-1", r: "1/n1" }, { l: "n*(n1/n2)", r: "(n*n1)/n2" }, { l: "1*n", r: "n" }], t4 = [{ l: "(-n1)/(-n2)", r: "n1/n2" }, { l: "(-n1)*(-n2)", r: "n1*n2" }, { l: "n1--n2", r: "n1+n2" }, { l: "n1-n2", r: "n1+(-n2)" }, { l: "(n1+n2)*n3", r: "(n1*n3 + n2*n3)" }, { l: "n1*(n2+n3)", r: "(n1*n2+n1*n3)" }, { l: "c1*n + c2*n", r: "(c1+c2)*n" }, { l: "c1*n + n", r: "(c1+1)*n" }, { l: "c1*n - c2*n", r: "(c1-c2)*n" }, { l: "c1*n - n", r: "(c1-1)*n" }, { l: "v/c", r: "(1/c)*v" }, { l: "v/-c", r: "-(1/c)*v" }, { l: "-v*-c", r: "c*v" }, { l: "-v*c", r: "-c*v" }, { l: "v*-c", r: "-c*v" }, { l: "v*c", r: "c*v" }, { l: "-(-n1*n2)", r: "(n1*n2)" }, { l: "-(n1*n2)", r: "(-n1*n2)" }, { l: "-(-n1+n2)", r: "(n1-n2)" }, { l: "-(n1+n2)", r: "(-n1-n2)" }, { l: "(n1^n2)^n3", r: "(n1^(n2*n3))" }, { l: "-(-n1/n2)", r: "(n1/n2)" }, { l: "-(n1/n2)", r: "(-n1/n2)" }], r3 = [{ l: "(n1/n2 + n3/n4)", r: "((n1*n4 + n3*n2)/(n2*n4))" }, { l: "(n1/n2 + n3)", r: "((n1 + n3*n2)/n2)" }, { l: "(n1 + n2/n3)", r: "((n1*n3 + n2)/n3)" }], n4 = [{ l: "(n1/(n2/n3))", r: "((n1*n3)/n2)" }, { l: "(n1/n2/n3)", r: "(n1/(n2*n3))" }], i4 = {};
      return i4.firstRules = e4.concat(t4, n4), i4.distrDivRules = r3, i4.sucDivRules = n4, i4.firstRulesAgain = e4.concat(t4), i4.finalRules = [p, { l: "n*-n", r: "-n^2" }, { l: "n*n", r: "n^2" }, f2, { l: "n*-n^n1", r: "-n^(n1+1)" }, { l: "n*n^n1", r: "n^(n1+1)" }, { l: "n^n1*-n^n2", r: "-n^(n1+n2)" }, { l: "n^n1*n^n2", r: "n^(n1+n2)" }, { l: "n^n1*-n", r: "-n^(n1+1)" }, { l: "n^n1*n", r: "n^(n1+1)" }, { l: "n^n1/-n", r: "-n^(n1-1)" }, { l: "n^n1/n", r: "n^(n1-1)" }, { l: "n/-n^n1", r: "-n^(1-n1)" }, { l: "n/n^n1", r: "n^(1-n1)" }, { l: "n^n1/-n^n2", r: "n^(n1-n2)" }, { l: "n^n1/n^n2", r: "n^(n1-n2)" }, { l: "n1+(-n2*n3)", r: "n1-n2*n3" }, { l: "v*(-c)", r: "-c*v" }, { l: "n1+-n2", r: "n1-n2" }, { l: "v*c", r: "c*v" }, { l: "(n1^n2)^n3", r: "(n1^(n2*n3))" }], i4;
    })(), i3 = (function(e4, t4, r3, n4) {
      var i4 = [], a3 = m(e4, n4, t4, { exactFractions: false }), o3 = "+-*" + ((r3 = !!r3) ? "/" : "");
      u3(a3);
      var s3 = {};
      return s3.expression = a3, s3.variables = i4, s3;
      function u3(e5) {
        var t5 = e5.type;
        if ("FunctionNode" === t5) throw new Error("There is an unsolved function call");
        if ("OperatorNode" === t5) if ("^" === e5.op) {
          if ("ConstantNode" !== e5.args[1].type || !isInteger$1(parseFloat(e5.args[1].value))) throw new Error("There is a non-integer exponent");
          u3(e5.args[0]);
        } else {
          if (!o3.includes(e5.op)) throw new Error("Operator " + e5.op + " invalid in polynomial expression");
          for (var r4 = 0; r4 < e5.args.length; r4++) u3(e5.args[r4]);
        }
        else if ("SymbolNode" === t5) {
          var n5 = e5.name;
          -1 === i4.indexOf(n5) && i4.push(n5);
        } else if ("ParenthesisNode" === t5) u3(e5.content);
        else if ("ConstantNode" !== t5) throw new Error("type " + t5 + " is not allowed in polynomial expression");
      }
    })(e3, t3, true, n3.firstRules), a2 = i3.variables.length, o2 = { exactFractions: false }, s2 = { exactFractions: true };
    if (e3 = i3.expression, a2 >= 1) {
      var u2, c3;
      e3 = S2(e3);
      var l2, d2 = true, h2 = false;
      for (e3 = m(e3, n3.firstRules, {}, o2); c3 = d2 ? n3.distrDivRules : n3.sucDivRules, d2 = !d2, (l2 = (e3 = m(e3, c3, {}, s2)).toString()) !== u2; ) h2 = true, u2 = l2;
      h2 && (e3 = m(e3, n3.firstRulesAgain, {}, o2)), e3 = m(e3, n3.finalRules, {}, o2);
    }
    var g2 = [], y2 = {};
    return "OperatorNode" === e3.type && e3.isBinary() && "/" === e3.op ? (1 === a2 && (e3.args[0] = C2(e3.args[0], g2), e3.args[1] = C2(e3.args[1])), r2 && (y2.numerator = e3.args[0], y2.denominator = e3.args[1])) : (1 === a2 && (e3 = C2(e3, g2)), r2 && (y2.numerator = e3, y2.denominator = null)), r2 ? (y2.coefficients = g2, y2.variables = i3.variables, y2.expression = e3, y2) : e3;
  }
  return r(name$u$1, { Node: $2, "Node, boolean": (e3, t3) => $2(e3, {}, t3), "Node, Object": $2, "Node, Object, boolean": $2 });
  function S2(e3, t3, r2) {
    var n3 = e3.type, i3 = arguments.length > 1;
    if ("OperatorNode" === n3 && e3.isBinary()) {
      var a2, o2 = false;
      if ("^" === e3.op && ("ParenthesisNode" !== e3.args[0].type && "OperatorNode" !== e3.args[0].type || "ConstantNode" !== e3.args[1].type || (o2 = (a2 = parseFloat(e3.args[1].value)) >= 2 && isInteger$1(a2))), o2) {
        if (a2 > 2) {
          var s2 = e3.args[0], u2 = new N("^", "pow", [e3.args[0].cloneDeep(), new b2(a2 - 1)]);
          e3 = new N("*", "multiply", [s2, u2]);
        } else e3 = new N("*", "multiply", [e3.args[0], e3.args[0].cloneDeep()]);
        i3 && ("content" === r2 ? t3.content = e3 : t3.args[r2] = e3);
      }
    }
    if ("ParenthesisNode" === n3) S2(e3.content, e3, "content");
    else if ("ConstantNode" !== n3 && "SymbolNode" !== n3) for (var c3 = 0; c3 < e3.args.length; c3++) S2(e3.args[c3], e3, c3);
    if (!i3) return e3;
  }
  function C2(e3, t3) {
    void 0 === t3 && (t3 = []), t3[0] = 0;
    var r2 = { cte: 1, oper: "+", fire: "" }, n3 = 0, i3 = "";
    !(function e4(r3, a3, o3) {
      var s3 = r3.type;
      if ("FunctionNode" === s3) throw new Error("There is an unsolved function call");
      if ("OperatorNode" === s3) {
        if (!"+-*^".includes(r3.op)) throw new Error("Operator " + r3.op + " invalid");
        if (null !== a3) {
          if (("unaryMinus" === r3.fn || "pow" === r3.fn) && "add" !== a3.fn && "subtract" !== a3.fn && "multiply" !== a3.fn) throw new Error("Invalid " + r3.op + " placing");
          if (("subtract" === r3.fn || "add" === r3.fn || "multiply" === r3.fn) && "add" !== a3.fn && "subtract" !== a3.fn) throw new Error("Invalid " + r3.op + " placing");
          if (("subtract" === r3.fn || "add" === r3.fn || "unaryMinus" === r3.fn) && 0 !== o3.noFil) throw new Error("Invalid " + r3.op + " placing");
        }
        "^" !== r3.op && "*" !== r3.op || (o3.fire = r3.op);
        for (var u3 = 0; u3 < r3.args.length; u3++) "unaryMinus" === r3.fn && (o3.oper = "-"), "+" !== r3.op && "subtract" !== r3.fn || (o3.fire = "", o3.cte = 1, o3.oper = 0 === u3 ? "+" : r3.op), o3.noFil = u3, e4(r3.args[u3], r3, o3);
      } else if ("SymbolNode" === s3) {
        if (r3.name !== i3 && "" !== i3) throw new Error("There is more than one variable");
        if (i3 = r3.name, null === a3) return void (t3[1] = 1);
        if ("^" === a3.op && 0 !== o3.noFil) throw new Error("In power the variable should be the first parameter");
        if ("*" === a3.op && 1 !== o3.noFil) throw new Error("In multiply the variable should be the second parameter");
        "" !== o3.fire && "*" !== o3.fire || (n3 < 1 && (t3[1] = 0), t3[1] += o3.cte * ("+" === o3.oper ? 1 : -1), n3 = Math.max(1, n3));
      } else {
        if ("ConstantNode" !== s3) throw new Error("Type " + s3 + " is not allowed");
        var c4 = parseFloat(r3.value);
        if (null === a3) return void (t3[0] = c4);
        if ("^" === a3.op) {
          if (1 !== o3.noFil) throw new Error("Constant cannot be powered");
          if (!isInteger$1(c4) || c4 <= 0) throw new Error("Non-integer exponent is not allowed");
          for (var l3 = n3 + 1; l3 < c4; l3++) t3[l3] = 0;
          return c4 > n3 && (t3[c4] = 0), t3[c4] += o3.cte * ("+" === o3.oper ? 1 : -1), void (n3 = Math.max(c4, n3));
        }
        o3.cte = c4, "" === o3.fire && (t3[0] += o3.cte * ("+" === o3.oper ? 1 : -1));
      }
    })(e3, null, r2);
    for (var a2, o2 = true, s2 = n3 = t3.length - 1; s2 >= 0; s2--) if (0 !== t3[s2]) {
      var u2 = new b2(o2 ? t3[s2] : Math.abs(t3[s2])), c3 = t3[s2] < 0 ? "-" : "+";
      if (s2 > 0) {
        var l2 = new D(i3);
        if (s2 > 1) {
          var f3 = new b2(s2);
          l2 = new N("^", "pow", [l2, f3]);
        }
        u2 = -1 === t3[s2] && o2 ? new N("-", "unaryMinus", [l2]) : 1 === Math.abs(t3[s2]) ? l2 : new N("*", "multiply", [u2, l2]);
      }
      a2 = o2 ? u2 : "+" === c3 ? new N("+", "add", [a2, u2]) : new N("-", "subtract", [a2, u2]), o2 = false;
    }
    return o2 ? new b2(0) : a2;
  }
})), name$t$1 = "zpk2tf", dependencies$t$1 = ["typed", "add", "multiply", "Complex", "number"], createZpk2tf$1 = factory$1(name$t$1, dependencies$t$1, ((e2) => {
  var { typed: t2, add: r, multiply: n, Complex: i2, number: a } = e2;
  return t2(name$t$1, { "Array,Array,number": function(e3, t3, r2) {
    return o(e3, t3, r2);
  }, "Array,Array": function(e3, t3) {
    return o(e3, t3, 1);
  }, "Matrix,Matrix,number": function(e3, t3, r2) {
    return o(e3.valueOf(), t3.valueOf(), r2);
  }, "Matrix,Matrix": function(e3, t3) {
    return o(e3.valueOf(), t3.valueOf(), 1);
  } });
  function o(e3, t3, r2) {
    e3.some(((e4) => "BigNumber" === e4.type)) && (e3 = e3.map(((e4) => a(e4)))), t3.some(((e4) => "BigNumber" === e4.type)) && (t3 = t3.map(((e4) => a(e4))));
    for (var o2 = [i2(1, 0)], u = [i2(1, 0)], c2 = 0; c2 < e3.length; c2++) {
      var l = e3[c2];
      "number" == typeof l && (l = i2(l, 0)), o2 = s(o2, [i2(1, 0), i2(-l.re, -l.im)]);
    }
    for (var f2 = 0; f2 < t3.length; f2++) {
      var p = t3[f2];
      "number" == typeof p && (p = i2(p, 0)), u = s(u, [i2(1, 0), i2(-p.re, -p.im)]);
    }
    for (var m = 0; m < o2.length; m++) o2[m] = n(o2[m], r2);
    return [o2, u];
  }
  function s(e3, t3) {
    for (var a2 = [], o2 = 0; o2 < e3.length + t3.length - 1; o2++) {
      a2[o2] = i2(0, 0);
      for (var s2 = 0; s2 < e3.length; s2++) o2 - s2 >= 0 && o2 - s2 < t3.length && (a2[o2] = r(a2[o2], n(e3[s2], t3[o2 - s2])));
    }
    return a2;
  }
})), name$s$1 = "freqz", dependencies$s$1 = ["typed", "add", "multiply", "Complex", "divide", "matrix"], createFreqz$1 = factory$1(name$s$1, dependencies$s$1, ((e2) => {
  var { typed: t2, add: r, multiply: n, Complex: i2, divide: a, matrix: o } = e2;
  return t2(name$s$1, { "Array, Array": function(e3, t3) {
    return s(e3, t3, u(512));
  }, "Array, Array, Array": function(e3, t3, r2) {
    return s(e3, t3, r2);
  }, "Array, Array, number": function(e3, t3, r2) {
    if (r2 < 0) throw new Error("w must be a positive number");
    return s(e3, t3, u(r2));
  }, "Matrix, Matrix": function(e3, t3) {
    var r2 = u(512), { w: n3, h: i3 } = s(e3.valueOf(), t3.valueOf(), r2);
    return { w: o(n3), h: o(i3) };
  }, "Matrix, Matrix, Matrix": function(e3, t3, r2) {
    var { h: n3 } = s(e3.valueOf(), t3.valueOf(), r2.valueOf());
    return { h: o(n3), w: o(r2) };
  }, "Matrix, Matrix, number": function(e3, t3, r2) {
    if (r2 < 0) throw new Error("w must be a positive number");
    var n3 = u(r2), { h: i3 } = s(e3.valueOf(), t3.valueOf(), n3);
    return { h: o(i3), w: o(n3) };
  } });
  function s(e3, t3, o2) {
    for (var s2 = [], u2 = [], c2 = 0; c2 < o2.length; c2++) {
      for (var l = i2(0, 0), f2 = i2(0, 0), p = 0; p < e3.length; p++) l = r(l, n(e3[p], i2(Math.cos(-p * o2[c2]), Math.sin(-p * o2[c2]))));
      for (var m = 0; m < t3.length; m++) f2 = r(f2, n(t3[m], i2(Math.cos(-m * o2[c2]), Math.sin(-m * o2[c2]))));
      s2.push(l), u2.push(f2);
    }
    for (var d = [], h = 0; h < s2.length; h++) d.push(a(s2[h], u2[h]));
    return { h: d, w: o2 };
  }
  function u(e3) {
    for (var t3 = [], r2 = 0; r2 < e3; r2++) t3.push(r2 / e3 * Math.PI);
    return t3;
  }
})), name$r$1 = "reviver", dependencies$r$1 = ["classes"], createReviver$1 = factory$1(name$r$1, dependencies$r$1, ((e2) => {
  var { classes: t2 } = e2;
  return function(e3, r) {
    var n = t2[r && r.mathjs];
    return n && "function" == typeof n.fromJSON ? n.fromJSON(r) : r;
  };
})), name$q$1 = "replacer", dependencies$q$1 = [], createReplacer$1 = factory$1(name$q$1, dependencies$q$1, (() => function(e2, t2) {
  return "number" != typeof t2 || Number.isFinite(t2) && !isNaN(t2) ? "bigint" == typeof t2 ? { mathjs: "bigint", value: String(t2) } : t2 : { mathjs: "number", value: String(t2) };
})), version$1$1 = "15.1.0", createTrue$1 = factory$1("true", [], (() => true)), createFalse$1 = factory$1("false", [], (() => false)), createNull$1 = factory$1("null", [], (() => null)), createInfinity$1 = recreateFactory$1("Infinity", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(1 / 0) : 1 / 0;
})), createNaN$1 = recreateFactory$1("NaN", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(NaN) : NaN;
})), createPi$1 = recreateFactory$1("pi", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? createBigNumberPi$1(r) : pi$1;
})), createTau$1 = recreateFactory$1("tau", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? createBigNumberTau$1(r) : tau$1;
})), createE$1 = recreateFactory$1("e", ["config", "?BigNumber"], ((t2) => {
  var { config: r, BigNumber: n } = t2;
  return "BigNumber" === r.number ? createBigNumberE$1(n) : e$1;
})), createPhi$1 = recreateFactory$1("phi", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? createBigNumberPhi$1(r) : phi$1;
})), createLN2$1 = recreateFactory$1("LN2", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(2).ln() : Math.LN2;
})), createLN10$1 = recreateFactory$1("LN10", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(10).ln() : Math.LN10;
})), createLOG2E$1 = recreateFactory$1("LOG2E", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(1).div(new r(2).ln()) : Math.LOG2E;
})), createLOG10E$1 = recreateFactory$1("LOG10E", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(1).div(new r(10).ln()) : Math.LOG10E;
})), createSQRT1_2$1 = recreateFactory$1("SQRT1_2", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r("0.5").sqrt() : Math.SQRT1_2;
})), createSQRT2$1 = recreateFactory$1("SQRT2", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(2).sqrt() : Math.SQRT2;
})), createI$1 = recreateFactory$1("i", ["Complex"], ((e2) => {
  var { Complex: t2 } = e2;
  return t2.I;
})), createUppercasePi$1 = factory$1("PI", ["pi"], ((e2) => {
  var { pi: t2 } = e2;
  return t2;
})), createUppercaseE$1 = factory$1("E", ["e"], ((e2) => {
  var { e: t2 } = e2;
  return t2;
})), createVersion$1 = factory$1("version", [], (() => version$1$1));
function recreateFactory$1(e2, t2, r) {
  return factory$1(e2, t2, r, { recreateOnConfigChange: true });
}
var createSpeedOfLight$1 = unitFactory$1("speedOfLight", "299792458", "m s^-1"), createGravitationConstant$1 = unitFactory$1("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2"), createPlanckConstant$1 = unitFactory$1("planckConstant", "6.62607015e-34", "J s"), createReducedPlanckConstant$1 = unitFactory$1("reducedPlanckConstant", "1.0545718176461565e-34", "J s"), createMagneticConstant$1 = unitFactory$1("magneticConstant", "1.25663706212e-6", "N A^-2"), createElectricConstant$1 = unitFactory$1("electricConstant", "8.8541878128e-12", "F m^-1"), createVacuumImpedance$1 = unitFactory$1("vacuumImpedance", "376.730313667", "ohm"), createCoulomb$1 = unitFactory$1("coulomb", "8.987551792261171e9", "N m^2 C^-2"), createCoulombConstant$1 = unitFactory$1("coulombConstant", "8.987551792261171e9", "N m^2 C^-2"), createElementaryCharge$1 = unitFactory$1("elementaryCharge", "1.602176634e-19", "C"), createBohrMagneton$1 = unitFactory$1("bohrMagneton", "9.2740100783e-24", "J T^-1"), createConductanceQuantum$1 = unitFactory$1("conductanceQuantum", "7.748091729863649e-5", "S"), createInverseConductanceQuantum$1 = unitFactory$1("inverseConductanceQuantum", "12906.403729652257", "ohm"), createMagneticFluxQuantum$1 = unitFactory$1("magneticFluxQuantum", "2.0678338484619295e-15", "Wb"), createNuclearMagneton$1 = unitFactory$1("nuclearMagneton", "5.0507837461e-27", "J T^-1"), createKlitzing$1 = unitFactory$1("klitzing", "25812.807459304513", "ohm"), createBohrRadius$1 = unitFactory$1("bohrRadius", "5.29177210903e-11", "m"), createClassicalElectronRadius$1 = unitFactory$1("classicalElectronRadius", "2.8179403262e-15", "m"), createElectronMass$1 = unitFactory$1("electronMass", "9.1093837015e-31", "kg"), createFermiCoupling$1 = unitFactory$1("fermiCoupling", "1.1663787e-5", "GeV^-2"), createFineStructure$1 = numberFactory$1("fineStructure", 0.0072973525693), createHartreeEnergy$1 = unitFactory$1("hartreeEnergy", "4.3597447222071e-18", "J"), createProtonMass$1 = unitFactory$1("protonMass", "1.67262192369e-27", "kg"), createDeuteronMass$1 = unitFactory$1("deuteronMass", "3.3435830926e-27", "kg"), createNeutronMass$1 = unitFactory$1("neutronMass", "1.6749271613e-27", "kg"), createQuantumOfCirculation$1 = unitFactory$1("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1"), createRydberg$1 = unitFactory$1("rydberg", "10973731.568160", "m^-1"), createThomsonCrossSection$1 = unitFactory$1("thomsonCrossSection", "6.6524587321e-29", "m^2"), createWeakMixingAngle$1 = numberFactory$1("weakMixingAngle", 0.2229), createEfimovFactor$1 = numberFactory$1("efimovFactor", 22.7), createAtomicMass$1 = unitFactory$1("atomicMass", "1.66053906660e-27", "kg"), createAvogadro$1 = unitFactory$1("avogadro", "6.02214076e23", "mol^-1"), createBoltzmann$1 = unitFactory$1("boltzmann", "1.380649e-23", "J K^-1"), createFaraday$1 = unitFactory$1("faraday", "96485.33212331001", "C mol^-1"), createFirstRadiation$1 = unitFactory$1("firstRadiation", "3.7417718521927573e-16", "W m^2"), createLoschmidt$1 = unitFactory$1("loschmidt", "2.686780111798444e25", "m^-3"), createGasConstant$1 = unitFactory$1("gasConstant", "8.31446261815324", "J K^-1 mol^-1"), createMolarPlanckConstant$1 = unitFactory$1("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1"), createMolarVolume$1 = unitFactory$1("molarVolume", "0.022413969545014137", "m^3 mol^-1"), createSackurTetrode$1 = numberFactory$1("sackurTetrode", -1.16487052358), createSecondRadiation$1 = unitFactory$1("secondRadiation", "0.014387768775039337", "m K"), createStefanBoltzmann$1 = unitFactory$1("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4"), createWienDisplacement$1 = unitFactory$1("wienDisplacement", "2.897771955e-3", "m K"), createMolarMass$1 = unitFactory$1("molarMass", "0.99999999965e-3", "kg mol^-1"), createMolarMassC12$1 = unitFactory$1("molarMassC12", "11.9999999958e-3", "kg mol^-1"), createGravity$1 = unitFactory$1("gravity", "9.80665", "m s^-2"), createPlanckLength$1 = unitFactory$1("planckLength", "1.616255e-35", "m"), createPlanckMass$1 = unitFactory$1("planckMass", "2.176435e-8", "kg"), createPlanckTime$1 = unitFactory$1("planckTime", "5.391245e-44", "s"), createPlanckCharge$1 = unitFactory$1("planckCharge", "1.87554603778e-18", "C"), createPlanckTemperature$1 = unitFactory$1("planckTemperature", "1.416785e+32", "K");
function unitFactory$1(e2, t2, r) {
  return factory$1(e2, ["config", "Unit", "BigNumber"], ((e3) => {
    var { config: n, Unit: i2, BigNumber: a } = e3, o = new i2("BigNumber" === n.number ? new a(t2) : parseFloat(t2), r);
    return o.fixPrefix = true, o;
  }));
}
function numberFactory$1(e2, t2) {
  return factory$1(e2, ["config", "BigNumber"], ((e3) => {
    var { config: r, BigNumber: n } = e3;
    return "BigNumber" === r.number ? new n(t2) : t2;
  }));
}
function ownKeys$6(e2, t2) {
  var r = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e2);
    t2 && (n = n.filter((function(t3) {
      return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread$6(e2) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? ownKeys$6(Object(r), true).forEach((function(t3) {
      _defineProperty$3(e2, t3, r[t3]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r)) : ownKeys$6(Object(r)).forEach((function(t3) {
      Object.defineProperty(e2, t3, Object.getOwnPropertyDescriptor(r, t3));
    }));
  }
  return e2;
}
var name$p$1 = "mapSlices", dependencies$p$1 = ["typed", "isInteger"], createMapSlicesTransform$1 = factory$1(name$p$1, dependencies$p$1, ((e2) => {
  var { typed: t2, isInteger: r } = e2, n = createMapSlices$1({ typed: t2, isInteger: r });
  return t2("mapSlices", { "...any": function(e3) {
    var t3 = e3[1];
    isNumber$1$1(t3) ? e3[1] = t3 - 1 : isBigNumber$1(t3) && (e3[1] = t3.minus(1));
    try {
      return n.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), _objectSpread$6({ isTransformFunction: true }, createMapSlices$1.meta)), name$o$1 = "column", dependencies$o$1 = ["typed", "Index", "matrix", "range"], createColumnTransform$1 = factory$1(name$o$1, dependencies$o$1, ((e2) => {
  var { typed: t2, Index: r, matrix: n, range: i2 } = e2, a = createColumn$1({ typed: t2, Index: r, matrix: n, range: i2 });
  return t2("column", { "...any": function(e3) {
    var t3 = e3.length - 1, r2 = e3[t3];
    isNumber$1$1(r2) && (e3[t3] = r2 - 1);
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true });
function compileInlineExpression$1(e2, t2, r) {
  var n = e2.filter((function(e3) {
    return isSymbolNode$1(e3) && !(e3.name in t2) && !r.has(e3.name);
  }))[0];
  if (!n) throw new Error('No undefined variable found in inline expression "' + e2 + '"');
  var i2 = n.name, a = /* @__PURE__ */ new Map(), o = new PartitionedMap$1(r, a, /* @__PURE__ */ new Set([i2])), s = e2.compile();
  return function(e3) {
    return a.set(i2, e3), s.evaluate(o);
  };
}
var name$n$1 = "transformCallback", dependencies$n$1 = ["typed"], createTransformCallback$1 = factory$1(name$n$1, dependencies$n$1, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, n) {
    return t2.isTypedFunction(e3) ? r(e3, n) : _transformCallbackFunction$1(e3, e3.length, n);
  };
  function r(e3, n) {
    var i2 = Object.fromEntries(Object.entries(e3.signatures).map(((e4) => {
      var [i3, a] = e4, o = i3.split(",").length;
      return t2.isTypedFunction(a) ? [i3, r(a, n)] : [i3, _transformCallbackFunction$1(a, o, n)];
    })));
    return "string" == typeof e3.name ? t2(e3.name, i2) : t2(i2);
  }
}));
function _transformCallbackFunction$1(e2, t2, r) {
  return t2 === r ? e2 : t2 === r + 1 ? function() {
    for (var t3 = arguments.length, n = new Array(t3), i2 = 0; i2 < t3; i2++) n[i2] = arguments[i2];
    var a = n.slice(0, r), o = _transformDims$1(n[r]);
    return e2(...a, o);
  } : t2 > r + 1 ? function() {
    for (var t3 = arguments.length, n = new Array(t3), i2 = 0; i2 < t3; i2++) n[i2] = arguments[i2];
    var a = n.slice(0, r), o = _transformDims$1(n[r]), s = n.slice(r + 1);
    return e2(...a, o, ...s);
  } : e2;
}
function _transformDims$1(e2) {
  return e2.map(((e3) => e3 + 1));
}
var name$m$1 = "filter", dependencies$m$1 = ["typed"], createFilterTransform$1 = factory$1(name$m$1, dependencies$m$1, ((e2) => {
  var { typed: t2 } = e2;
  function r(e3, r2, i2) {
    var a = createFilter$1({ typed: t2 }), o = createTransformCallback$1({ typed: t2 });
    if (0 === e3.length) return a();
    var s = e3[0];
    if (1 === e3.length) return a(s);
    var u = e3.length - 1, c2 = e3[u];
    return s && (s = n(s, i2)), c2 && (c2 = isSymbolNode$1(c2) || isFunctionAssignmentNode$1(c2) ? n(c2, i2) : compileInlineExpression$1(c2, r2, i2)), a(s, o(c2, u));
  }
  function n(e3, t3) {
    return e3.compile().evaluate(t3);
  }
  return r.rawArgs = true, r;
}), { isTransformFunction: true }), name$l$1 = "forEach", dependencies$l$1 = ["typed"], createForEachTransform$1 = factory$1(name$l$1, dependencies$l$1, ((e2) => {
  var { typed: t2 } = e2, r = createForEach$1({ typed: t2 }), n = createTransformCallback$1({ typed: t2 });
  function i2(e3, t3, i3) {
    if (0 === e3.length) return r();
    var o = e3[0];
    if (1 === e3.length) return r(o);
    var s = e3.length - 1, u = e3[s];
    return o && (o = a(o, i3)), u && (u = isSymbolNode$1(u) || isFunctionAssignmentNode$1(u) ? a(u, i3) : compileInlineExpression$1(u, t3, i3)), r(o, n(u, s));
  }
  function a(e3, t3) {
    return e3.compile().evaluate(t3);
  }
  return i2.rawArgs = true, i2;
}), { isTransformFunction: true }), name$k$1 = "index", dependencies$k$1 = ["Index", "getMatrixDataType"], createIndexTransform$1 = factory$1(name$k$1, dependencies$k$1, ((e2) => {
  var { Index: t2, getMatrixDataType: r } = e2;
  return function() {
    for (var e3 = [], n = 0, i2 = arguments.length; n < i2; n++) {
      var a = arguments[n];
      if (isRange$1(a)) a.start--, a.end -= a.step > 0 ? 0 : 2;
      else if (a && true === a.isSet) a = a.map((function(e4) {
        return e4 - 1;
      }));
      else if (isArray$1$1(a) || isMatrix$1(a)) "boolean" !== r(a) && (a = a.map((function(e4) {
        return e4 - 1;
      })));
      else if (isNumber$1$1(a) || isBigInt$1(a)) a--;
      else if (isBigNumber$1(a)) a = a.toNumber() - 1;
      else if ("string" != typeof a) throw new TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
      e3[n] = a;
    }
    var o = new t2();
    return t2.apply(o, e3), o;
  };
}), { isTransformFunction: true }), name$j$1 = "map", dependencies$j$1 = ["typed"], createMapTransform$1 = factory$1(name$j$1, dependencies$j$1, ((e2) => {
  var { typed: t2 } = e2, r = createMap$2({ typed: t2 }), n = createTransformCallback$1({ typed: t2 });
  function i2(e3, t3, i3) {
    if (0 === e3.length) return r();
    if (1 === e3.length) return r(e3[0]);
    var a = e3.length - 1, o = e3.slice(0, a), s = e3[a];
    return o = o.map(((e4) => u(e4, i3))), s && (s = isSymbolNode$1(s) || isFunctionAssignmentNode$1(s) ? u(s, i3) : compileInlineExpression$1(s, t3, i3)), r(...o, n(s, a));
    function u(e4, t4) {
      return e4.compile().evaluate(t4);
    }
  }
  return i2.rawArgs = true, i2;
}), { isTransformFunction: true });
function dimToZeroBase$1(e2) {
  return isNumber$1$1(e2) ? e2 - 1 : isBigNumber$1(e2) ? e2.minus(1) : e2;
}
function isNumberOrBigNumber$1(e2) {
  return isNumber$1$1(e2) || isBigNumber$1(e2);
}
function lastDimToZeroBase$1(e2) {
  if (2 === e2.length && isCollection$1(e2[0])) {
    var t2 = (e2 = e2.slice())[1];
    isNumberOrBigNumber$1(t2) && (e2[1] = dimToZeroBase$1(t2));
  }
  return e2;
}
var name$i$1 = "max", dependencies$i$1 = ["typed", "config", "numeric", "larger", "isNaN"], createMaxTransform$1 = factory$1(name$i$1, dependencies$i$1, ((e2) => {
  var { typed: t2, config: r, numeric: n, larger: i2, isNaN: a } = e2, o = createMax$1({ typed: t2, config: r, numeric: n, larger: i2, isNaN: a });
  return t2("max", { "...any": function(e3) {
    e3 = lastDimToZeroBase$1(e3);
    try {
      return o.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$h$1 = "mean", dependencies$h$1 = ["typed", "add", "divide"], createMeanTransform$1 = factory$1(name$h$1, dependencies$h$1, ((e2) => {
  var { typed: t2, add: r, divide: n } = e2, i2 = createMean$1({ typed: t2, add: r, divide: n });
  return t2("mean", { "...any": function(e3) {
    e3 = lastDimToZeroBase$1(e3);
    try {
      return i2.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$g$1 = "min", dependencies$g$1 = ["typed", "config", "numeric", "smaller", "isNaN"], createMinTransform$1 = factory$1(name$g$1, dependencies$g$1, ((e2) => {
  var { typed: t2, config: r, numeric: n, smaller: i2, isNaN: a } = e2, o = createMin$1({ typed: t2, config: r, numeric: n, smaller: i2, isNaN: a });
  return t2("min", { "...any": function(e3) {
    e3 = lastDimToZeroBase$1(e3);
    try {
      return o.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$f$1 = "range", dependencies$f$1 = ["typed", "config", "?matrix", "?bignumber", "equal", "smaller", "smallerEq", "larger", "largerEq", "add", "isZero", "isPositive"], createRangeTransform$1 = factory$1(name$f$1, dependencies$f$1, ((e2) => {
  var { typed: t2, config: r, matrix: n, bignumber: i2, equal: a, smaller: o, smallerEq: s, larger: u, largerEq: c2, add: l, isZero: f2, isPositive: p } = e2, m = createRange$1({ typed: t2, config: r, matrix: n, bignumber: i2, equal: a, smaller: o, smallerEq: s, larger: u, largerEq: c2, add: l, isZero: f2, isPositive: p });
  return t2("range", { "...any": function(e3) {
    return "boolean" != typeof e3[e3.length - 1] && e3.push(true), m.apply(null, e3);
  } });
}), { isTransformFunction: true }), name$e$1 = "row", dependencies$e$1 = ["typed", "Index", "matrix", "range"], createRowTransform$1 = factory$1(name$e$1, dependencies$e$1, ((e2) => {
  var { typed: t2, Index: r, matrix: n, range: i2 } = e2, a = createRow$1({ typed: t2, Index: r, matrix: n, range: i2 });
  return t2("row", { "...any": function(e3) {
    var t3 = e3.length - 1, r2 = e3[t3];
    isNumber$1$1(r2) && (e3[t3] = r2 - 1);
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$d$1 = "subset", dependencies$d$1 = ["typed", "matrix", "zeros", "add"], createSubsetTransform$1 = factory$1(name$d$1, dependencies$d$1, ((e2) => {
  var { typed: t2, matrix: r, zeros: n, add: i2 } = e2, a = createSubset$1({ typed: t2, matrix: r, zeros: n, add: i2 });
  return t2("subset", { "...any": function(e3) {
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$c$1 = "concat", dependencies$c$1 = ["typed", "matrix", "isInteger"], createConcatTransform$1 = factory$1(name$c$1, dependencies$c$1, ((e2) => {
  var { typed: t2, matrix: r, isInteger: n } = e2, i2 = createConcat$1({ typed: t2, matrix: r, isInteger: n });
  return t2("concat", { "...any": function(e3) {
    var t3 = e3.length - 1, r2 = e3[t3];
    isNumber$1$1(r2) ? e3[t3] = r2 - 1 : isBigNumber$1(r2) && (e3[t3] = r2.minus(1));
    try {
      return i2.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$b$1 = "diff", dependencies$b$1 = ["typed", "matrix", "subtract", "number", "bignumber"], createDiffTransform$1 = factory$1(name$b$1, dependencies$b$1, ((e2) => {
  var { typed: t2, matrix: r, subtract: n, number: i2, bignumber: a } = e2, o = createDiff$1({ typed: t2, matrix: r, subtract: n, number: i2, bignumber: a });
  return t2(name$b$1, { "...any": function(e3) {
    e3 = lastDimToZeroBase$1(e3);
    try {
      return o.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$a$1 = "std", dependencies$a$1 = ["typed", "map", "sqrt", "variance"], createStdTransform$1 = factory$1(name$a$1, dependencies$a$1, ((e2) => {
  var { typed: t2, map: r, sqrt: n, variance: i2 } = e2, a = createStd$1({ typed: t2, map: r, sqrt: n, variance: i2 });
  return t2("std", { "...any": function(e3) {
    e3 = lastDimToZeroBase$1(e3);
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$9$1 = "sum", dependencies$9$1 = ["typed", "config", "add", "numeric"], createSumTransform$1 = factory$1(name$9$1, dependencies$9$1, ((e2) => {
  var { typed: t2, config: r, add: n, numeric: i2 } = e2, a = createSum$1({ typed: t2, config: r, add: n, numeric: i2 });
  return t2(name$9$1, { "...any": function(e3) {
    e3 = lastDimToZeroBase$1(e3);
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$8$1 = "quantileSeq", dependencies$8$1 = ["typed", "bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger", "mapSlices"], createQuantileSeqTransform$1 = factory$1(name$8$1, dependencies$8$1, ((e2) => {
  var { typed: t2, bignumber: r, add: n, subtract: i2, divide: a, multiply: o, partitionSelect: s, compare: u, isInteger: c2, smaller: l, smallerEq: f2, larger: p, mapSlices: m } = e2, d = createQuantileSeq$1({ typed: t2, bignumber: r, add: n, subtract: i2, divide: a, multiply: o, partitionSelect: s, compare: u, isInteger: c2, smaller: l, smallerEq: f2, larger: p, mapSlices: m });
  return t2("quantileSeq", { "Array | Matrix, number | BigNumber": d, "Array | Matrix, number | BigNumber, number": (e3, t3, r2) => d(e3, t3, h(r2)), "Array | Matrix, number | BigNumber, boolean": d, "Array | Matrix, number | BigNumber, boolean, number": (e3, t3, r2, n3) => d(e3, t3, r2, h(n3)), "Array | Matrix, Array | Matrix": d, "Array | Matrix, Array | Matrix, number": (e3, t3, r2) => d(e3, t3, h(r2)), "Array | Matrix, Array | Matrix, boolean": d, "Array | Matrix, Array | Matrix, boolean, number": (e3, t3, r2, n3) => d(e3, t3, r2, h(n3)) });
  function h(e3) {
    return lastDimToZeroBase$1([[], e3])[1];
  }
}), { isTransformFunction: true }), name$7$1 = "cumsum", dependencies$7$1 = ["typed", "add", "unaryPlus"], createCumSumTransform$1 = factory$1(name$7$1, dependencies$7$1, ((e2) => {
  var { typed: t2, add: r, unaryPlus: n } = e2, i2 = createCumSum$1({ typed: t2, add: r, unaryPlus: n });
  return t2(name$7$1, { "...any": function(e3) {
    if (2 === e3.length && isCollection$1(e3[0])) {
      var t3 = e3[1];
      isNumber$1$1(t3) ? e3[1] = t3 - 1 : isBigNumber$1(t3) && (e3[1] = t3.minus(1));
    }
    try {
      return i2.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$6$1 = "variance", dependencies$6$1 = ["typed", "add", "subtract", "multiply", "divide", "mapSlices", "isNaN"], createVarianceTransform$1 = factory$1(name$6$1, dependencies$6$1, ((e2) => {
  var { typed: t2, add: r, subtract: n, multiply: i2, divide: a, mapSlices: o, isNaN: s } = e2, u = createVariance$1({ typed: t2, add: r, subtract: n, multiply: i2, divide: a, mapSlices: o, isNaN: s });
  return t2(name$6$1, { "...any": function(e3) {
    e3 = lastDimToZeroBase$1(e3);
    try {
      return u.apply(null, e3);
    } catch (e4) {
      throw errorTransform$1(e4);
    }
  } });
}), { isTransformFunction: true }), name$5$1 = "print", dependencies$5$1 = ["typed", "matrix", "zeros", "add"], createPrintTransform$1 = factory$1(name$5$1, dependencies$5$1, ((e2) => {
  var { typed: t2, matrix: r, zeros: n, add: i2 } = e2, a = createPrint$1({ typed: t2, matrix: r, zeros: n, add: i2 });
  return t2(name$5$1, { "string, Object | Array": function(e3, t3) {
    return a(o(e3), t3);
  }, "string, Object | Array, number | Object": function(e3, t3, r2) {
    return a(o(e3), t3, r2);
  } });
  function o(e3) {
    return e3.replace(printTemplate$1, ((e4) => "$" + e4.slice(1).split(".").map((function(e5) {
      return !isNaN(e5) && e5.length > 0 ? parseInt(e5) - 1 : e5;
    })).join(".")));
  }
}), { isTransformFunction: true }), name$4$1 = "and", dependencies$4$1 = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], createAndTransform$1 = factory$1(name$4$1, dependencies$4$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o } = e2, s = createAnd$1({ typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o });
  function u(e3, t3, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection$1(n3) && !s(n3, true)) return false;
    var i3 = e3[1].compile().evaluate(r2);
    return s(n3, i3);
  }
  return u.rawArgs = true, u;
}), { isTransformFunction: true }), name$3$1 = "or", dependencies$3$1 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createOrTransform$1 = factory$1(name$3$1, dependencies$3$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a } = e2, o = createOr$1({ typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a });
  function s(e3, t3, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection$1(n3) && o(n3, false)) return true;
    var i3 = e3[1].compile().evaluate(r2);
    return o(n3, i3);
  }
  return s.rawArgs = true, s;
}), { isTransformFunction: true }), name$2$1 = "nullish", dependencies$2$1 = ["typed", "matrix", "size", "flatten", "deepEqual"], createNullishTransform$1 = factory$1(name$2$1, dependencies$2$1, ((e2) => {
  var { typed: t2, matrix: r, size: n, flatten: i2, deepEqual: a } = e2, o = createNullish$1({ typed: t2, matrix: r, size: n, flatten: i2, deepEqual: a });
  function s(e3, t3, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection$1(n3) && null != n3 && void 0 !== n3) return n3;
    var i3 = e3[1].compile().evaluate(r2);
    return o(n3, i3);
  }
  return s.rawArgs = true, s;
}), { isTransformFunction: true }), name$1$1 = "bitAnd", dependencies$1$1 = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], createBitAndTransform$1 = factory$1(name$1$1, dependencies$1$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o } = e2, s = createBitAnd$1({ typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o });
  function u(e3, t3, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection$1(n3)) {
      if (isNaN(n3)) return NaN;
      if (0 === n3 || false === n3) return 0;
    }
    var i3 = e3[1].compile().evaluate(r2);
    return s(n3, i3);
  }
  return u.rawArgs = true, u;
}), { isTransformFunction: true }), name$52 = "bitOr", dependencies$51 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createBitOrTransform$1 = factory$1(name$52, dependencies$51, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a } = e2, o = createBitOr$1({ typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a });
  function s(e3, t3, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection$1(n3)) {
      if (isNaN(n3)) return NaN;
      if (-1 === n3) return -1;
      if (true === n3) return 1;
    }
    var i3 = e3[1].compile().evaluate(r2);
    return o(n3, i3);
  }
  return s.rawArgs = true, s;
}), { isTransformFunction: true }), allFactories$1 = Object.freeze({ __proto__: null, createTyped: createTyped$1, createResultSet: createResultSet$1, createBigNumberClass: createBigNumberClass$1, createComplexClass: createComplexClass$1, createFractionClass: createFractionClass$1, createRangeClass: createRangeClass$1, createMatrixClass: createMatrixClass$1, createDenseMatrixClass: createDenseMatrixClass$1, createClone: createClone$1, createIsInteger: createIsInteger$1, createIsNegative: createIsNegative$1, createIsNumeric: createIsNumeric$1, createHasNumericValue: createHasNumericValue$1, createIsPositive: createIsPositive$1, createIsZero: createIsZero$1, createIsNaN: createIsNaN$1, createIsBounded: createIsBounded$1, createIsFinite: createIsFinite$1, createTypeOf: createTypeOf$1, createEqualScalar: createEqualScalar$1, createSparseMatrixClass: createSparseMatrixClass$1, createNumber: createNumber$1, createBigint: createBigint$1, createString: createString$1, createBoolean: createBoolean$1, createBignumber: createBignumber$1, createComplex: createComplex$1, createFraction: createFraction$1, createMatrix: createMatrix$1, createMatrixFromFunction: createMatrixFromFunction$1, createMatrixFromRows: createMatrixFromRows$1, createMatrixFromColumns: createMatrixFromColumns$1, createSplitUnit: createSplitUnit$1, createUnaryMinus: createUnaryMinus$1, createUnaryPlus: createUnaryPlus$1, createAbs: createAbs$1, createMapSlices: createMapSlices$1, createAddScalar: createAddScalar$1, createSubtractScalar: createSubtractScalar$1, createCbrt: createCbrt$1, createCeil: createCeil$1, createCube: createCube$1, createExp: createExp$1, createExpm1: createExpm1$1, createFix: createFix$1, createFloor: createFloor$1, createGcd: createGcd$1, createLcm: createLcm$1, createLog10: createLog10$1, createLog2: createLog2$1, createMod: createMod$1, createMultiplyScalar: createMultiplyScalar$1, createMultiply: createMultiply$1, createNthRoot: createNthRoot$1, createSign: createSign$1, createSqrt: createSqrt$1, createSquare: createSquare$1, createSubtract: createSubtract$1, createXgcd: createXgcd$1, createInvmod: createInvmod$1, createDotMultiply: createDotMultiply$1, createBitAnd: createBitAnd$1, createBitNot: createBitNot$1, createBitOr: createBitOr$1, createBitXor: createBitXor$1, createArg: createArg$1, createConj: createConj$1, createIm: createIm$1, createRe: createRe$1, createNot: createNot$1, createNullish: createNullish$1, createOr: createOr$1, createXor: createXor$1, createConcat: createConcat$1, createColumn: createColumn$1, createCount: createCount$1, createCross: createCross$1, createDiag: createDiag$1, createFilter: createFilter$1, createFlatten: createFlatten$1, createForEach: createForEach$1, createGetMatrixDataType: createGetMatrixDataType$1, createIdentity: createIdentity$1, createKron: createKron$1, createMap: createMap$2, createDiff: createDiff$1, createOnes: createOnes$1, createRange: createRange$1, createReshape: createReshape$1, createResize: createResize$1, createRotate: createRotate$1, createRotationMatrix: createRotationMatrix$1, createRow: createRow$1, createSize: createSize$1, createSqueeze: createSqueeze$1, createSubset: createSubset$1, createTranspose: createTranspose$1, createCtranspose: createCtranspose$1, createZeros: createZeros$1, createFft: createFft$1, createIfft: createIfft$1, createSolveODE: createSolveODE$1, createErf: createErf$1, createZeta: createZeta$1, createMode: createMode$1, createProd: createProd$1, createFormat: createFormat$1, createBin: createBin$1, createOct: createOct$1, createHex: createHex$1, createPrint: createPrint$1, createTo: createTo$1, createToBest: createToBest$1, createIsPrime: createIsPrime$1, createNumeric: createNumeric$1, createDivideScalar: createDivideScalar$1, createPow: createPow$1, createRound: createRound$1, createLog: createLog$1, createLog1p: createLog1p$1, createNthRoots: createNthRoots$1, createDotPow: createDotPow$1, createDotDivide: createDotDivide$1, createLsolve: createLsolve$1, createUsolve: createUsolve$1, createLsolveAll: createLsolveAll$1, createUsolveAll: createUsolveAll$1, createLeftShift: createLeftShift$1, createRightArithShift: createRightArithShift$1, createRightLogShift: createRightLogShift$1, createAnd: createAnd$1, createCompare: createCompare$1, createCompareNatural: createCompareNatural$1, createCompareText: createCompareText$1, createEqual: createEqual$1, createEqualText: createEqualText$1, createSmaller: createSmaller$1, createSmallerEq: createSmallerEq$1, createLarger: createLarger$1, createLargerEq: createLargerEq$1, createDeepEqual: createDeepEqual$1, createUnequal: createUnequal$1, createPartitionSelect: createPartitionSelect$1, createSort: createSort$1, createMax: createMax$1, createMin: createMin$1, createImmutableDenseMatrixClass: createImmutableDenseMatrixClass$1, createIndexClass: createIndexClass$1, createFibonacciHeapClass: createFibonacciHeapClass$1, createSpaClass: createSpaClass$1, createUnitClass: createUnitClass$1, createUnitFunction: createUnitFunction$1, createSparse: createSparse$1, createCreateUnit: createCreateUnit$1, createAcos: createAcos$1, createAcosh: createAcosh$1, createAcot: createAcot$1, createAcoth: createAcoth$1, createAcsc: createAcsc$1, createAcsch: createAcsch$1, createAsec: createAsec$1, createAsech: createAsech$1, createAsin: createAsin$1, createAsinh: createAsinh$1, createAtan: createAtan$1, createAtan2: createAtan2$1, createAtanh: createAtanh$1, createCos: createCos$1, createCosh: createCosh$1, createCot: createCot$1, createCoth: createCoth$1, createCsc: createCsc$1, createCsch: createCsch$1, createSec: createSec$1, createSech: createSech$1, createSin: createSin$1, createSinh: createSinh$1, createTan: createTan$1, createTanh: createTanh$1, createSetCartesian: createSetCartesian$1, createSetDifference: createSetDifference$1, createSetDistinct: createSetDistinct$1, createSetIntersect: createSetIntersect$1, createSetIsSubset: createSetIsSubset$1, createSetMultiplicity: createSetMultiplicity$1, createSetPowerset: createSetPowerset$1, createSetSize: createSetSize$1, createSetSymDifference: createSetSymDifference$1, createSetUnion: createSetUnion$1, createAdd: createAdd$1, createHypot: createHypot$1, createNorm: createNorm$1, createDot: createDot$1, createTrace: createTrace$1, createIndex: createIndex$1, createNode: createNode$1, createAccessorNode: createAccessorNode$1, createArrayNode: createArrayNode$1, createAssignmentNode: createAssignmentNode$1, createBlockNode: createBlockNode$1, createConditionalNode: createConditionalNode$1, createConstantNode: createConstantNode$1, createFunctionAssignmentNode: createFunctionAssignmentNode$1, createIndexNode: createIndexNode$1, createObjectNode: createObjectNode$1, createOperatorNode: createOperatorNode$1, createParenthesisNode: createParenthesisNode$1, createRangeNode: createRangeNode$1, createRelationalNode: createRelationalNode$1, createSymbolNode: createSymbolNode$1, createFunctionNode: createFunctionNode$1, createParse: createParse$1, createCompile: createCompile$1, createEvaluate: createEvaluate$1, createParserClass: createParserClass$1, createParser: createParser$1, createLup: createLup$1, createQr: createQr$1, createSlu: createSlu$1, createLusolve: createLusolve$1, createPolynomialRoot: createPolynomialRoot$1, createHelpClass: createHelpClass$1, createChainClass: createChainClass$1, createHelp: createHelp$1, createChain: createChain$1, createDet: createDet$1, createInv: createInv$1, createPinv: createPinv$1, createEigs: createEigs$1, createExpm: createExpm$1, createSqrtm: createSqrtm$1, createSylvester: createSylvester$1, createSchur: createSchur$1, createLyap: createLyap$1, createDivide: createDivide$1, createDistance: createDistance$1, createIntersect: createIntersect$1, createSum: createSum$1, createCumSum: createCumSum$1, createMean: createMean$1, createMedian: createMedian$1, createMad: createMad$1, createVariance: createVariance$1, createQuantileSeq: createQuantileSeq$1, createStd: createStd$1, createCorr: createCorr$1, createBernoulli: createBernoulli$1, createCombinations: createCombinations$1, createCombinationsWithRep: createCombinationsWithRep$1, createGamma: createGamma$1, createLgamma: createLgamma$1, createFactorial: createFactorial$1, createKldivergence: createKldivergence$1, createMultinomial: createMultinomial$1, createPermutations: createPermutations$1, createPickRandom: createPickRandom$1, createRandom: createRandom$1, createRandomInt: createRandomInt$1, createStirlingS2: createStirlingS2$1, createBellNumbers: createBellNumbers$1, createCatalan: createCatalan$1, createComposition: createComposition$1, createLeafCount: createLeafCount$1, createSimplify: createSimplify$1, createSimplifyConstant: createSimplifyConstant$1, createSimplifyCore: createSimplifyCore$1, createResolve: createResolve$1, createSymbolicEqual: createSymbolicEqual$1, createDerivative: createDerivative$1, createRationalize: createRationalize$1, createZpk2tf: createZpk2tf$1, createFreqz: createFreqz$1, createReviver: createReviver$1, createReplacer: createReplacer$1, createE: createE$1, createUppercaseE: createUppercaseE$1, createFalse: createFalse$1, createI: createI$1, createInfinity: createInfinity$1, createLN10: createLN10$1, createLN2: createLN2$1, createLOG10E: createLOG10E$1, createLOG2E: createLOG2E$1, createNaN: createNaN$1, createNull: createNull$1, createPhi: createPhi$1, createPi: createPi$1, createUppercasePi: createUppercasePi$1, createSQRT1_2: createSQRT1_2$1, createSQRT2: createSQRT2$1, createTau: createTau$1, createTrue: createTrue$1, createVersion: createVersion$1, createAtomicMass: createAtomicMass$1, createAvogadro: createAvogadro$1, createBohrMagneton: createBohrMagneton$1, createBohrRadius: createBohrRadius$1, createBoltzmann: createBoltzmann$1, createClassicalElectronRadius: createClassicalElectronRadius$1, createConductanceQuantum: createConductanceQuantum$1, createCoulomb: createCoulomb$1, createCoulombConstant: createCoulombConstant$1, createDeuteronMass: createDeuteronMass$1, createEfimovFactor: createEfimovFactor$1, createElectricConstant: createElectricConstant$1, createElectronMass: createElectronMass$1, createElementaryCharge: createElementaryCharge$1, createFaraday: createFaraday$1, createFermiCoupling: createFermiCoupling$1, createFineStructure: createFineStructure$1, createFirstRadiation: createFirstRadiation$1, createGasConstant: createGasConstant$1, createGravitationConstant: createGravitationConstant$1, createGravity: createGravity$1, createHartreeEnergy: createHartreeEnergy$1, createInverseConductanceQuantum: createInverseConductanceQuantum$1, createKlitzing: createKlitzing$1, createLoschmidt: createLoschmidt$1, createMagneticConstant: createMagneticConstant$1, createMagneticFluxQuantum: createMagneticFluxQuantum$1, createMolarMass: createMolarMass$1, createMolarMassC12: createMolarMassC12$1, createMolarPlanckConstant: createMolarPlanckConstant$1, createMolarVolume: createMolarVolume$1, createNeutronMass: createNeutronMass$1, createNuclearMagneton: createNuclearMagneton$1, createPlanckCharge: createPlanckCharge$1, createPlanckConstant: createPlanckConstant$1, createPlanckLength: createPlanckLength$1, createPlanckMass: createPlanckMass$1, createPlanckTemperature: createPlanckTemperature$1, createPlanckTime: createPlanckTime$1, createProtonMass: createProtonMass$1, createQuantumOfCirculation: createQuantumOfCirculation$1, createReducedPlanckConstant: createReducedPlanckConstant$1, createRydberg: createRydberg$1, createSackurTetrode: createSackurTetrode$1, createSecondRadiation: createSecondRadiation$1, createSpeedOfLight: createSpeedOfLight$1, createStefanBoltzmann: createStefanBoltzmann$1, createThomsonCrossSection: createThomsonCrossSection$1, createVacuumImpedance: createVacuumImpedance$1, createWeakMixingAngle: createWeakMixingAngle$1, createWienDisplacement: createWienDisplacement$1, createMapSlicesTransform: createMapSlicesTransform$1, createColumnTransform: createColumnTransform$1, createFilterTransform: createFilterTransform$1, createForEachTransform: createForEachTransform$1, createIndexTransform: createIndexTransform$1, createMapTransform: createMapTransform$1, createMaxTransform: createMaxTransform$1, createMeanTransform: createMeanTransform$1, createMinTransform: createMinTransform$1, createRangeTransform: createRangeTransform$1, createRowTransform: createRowTransform$1, createSubsetTransform: createSubsetTransform$1, createConcatTransform: createConcatTransform$1, createDiffTransform: createDiffTransform$1, createStdTransform: createStdTransform$1, createSumTransform: createSumTransform$1, createQuantileSeqTransform: createQuantileSeqTransform$1, createCumSumTransform: createCumSumTransform$1, createVarianceTransform: createVarianceTransform$1, createPrintTransform: createPrintTransform$1, createAndTransform: createAndTransform$1, createOrTransform: createOrTransform$1, createNullishTransform: createNullishTransform$1, createBitAndTransform: createBitAndTransform$1, createBitOrTransform: createBitOrTransform$1 }), all$1 = allFactories$1, tinyEmitter$1 = { exports: {} }, hasRequiredTinyEmitter$1;
function requireTinyEmitter$1() {
  if (hasRequiredTinyEmitter$1) return tinyEmitter$1.exports;
  function e2() {
  }
  return hasRequiredTinyEmitter$1 = 1, e2.prototype = { on: function(e3, t2, r) {
    var n = this.e || (this.e = {});
    return (n[e3] || (n[e3] = [])).push({ fn: t2, ctx: r }), this;
  }, once: function(e3, t2, r) {
    var n = this;
    function i2() {
      n.off(e3, i2), t2.apply(r, arguments);
    }
    return i2._ = t2, this.on(e3, i2, r);
  }, emit: function(e3) {
    for (var t2 = [].slice.call(arguments, 1), r = ((this.e || (this.e = {}))[e3] || []).slice(), n = 0, i2 = r.length; n < i2; n++) r[n].fn.apply(r[n].ctx, t2);
    return this;
  }, off: function(e3, t2) {
    var r = this.e || (this.e = {}), n = r[e3], i2 = [];
    if (n && t2) for (var a = 0, o = n.length; a < o; a++) n[a].fn !== t2 && n[a].fn._ !== t2 && i2.push(n[a]);
    return i2.length ? r[e3] = i2 : delete r[e3], this;
  } }, tinyEmitter$1.exports = e2, tinyEmitter$1.exports.TinyEmitter = e2, tinyEmitter$1.exports;
}
var tinyEmitterExports$1 = requireTinyEmitter$1(), Emitter$1 = getDefaultExportFromCjs$5(tinyEmitterExports$1);
function mixin$1$1(e2) {
  var t2 = new Emitter$1();
  return e2.on = t2.on.bind(t2), e2.off = t2.off.bind(t2), e2.once = t2.once.bind(t2), e2.emit = t2.emit.bind(t2), e2;
}
function importFactory$1(e2, t2, r, n) {
  function i2(t3, i3, o2) {
    var s2, u2;
    if (o2.wrap && "function" == typeof i3 && (i3 = (function(e3) {
      var t4 = function() {
        for (var t5 = [], n3 = 0, i4 = arguments.length; n3 < i4; n3++) {
          var a2 = arguments[n3];
          t5[n3] = a2 && a2.valueOf();
        }
        return e3.apply(r, t5);
      };
      e3.transform && (t4.transform = e3.transform);
      return t4;
    })(i3)), "function" == typeof (u2 = i3) && "string" == typeof u2.signature && (i3 = e2(t3, { [i3.signature]: i3 })), e2.isTypedFunction(r[t3]) && e2.isTypedFunction(i3)) return i3 = o2.override ? e2(t3, i3.signatures) : e2(r[t3], i3), r[t3] = i3, delete n[t3], a(t3, i3), void r.emit("import", t3, (function() {
      return i3;
    }));
    var c3 = void 0 !== r[t3], l2 = null === (s2 = r.Unit) || void 0 === s2 ? void 0 : s2.isValuelessUnit(t3);
    if (!c3 && !l2 || o2.override) return r[t3] = i3, delete n[t3], a(t3, i3), void r.emit("import", t3, (function() {
      return i3;
    }));
    if (!o2.silent) throw new Error('Cannot import "' + t3 + '": already exists');
  }
  function a(e3, t3) {
    t3 && "function" == typeof t3.transform ? (r.expression.transform[e3] = t3.transform, c2(e3) && (r.expression.mathWithTransform[e3] = t3.transform)) : (delete r.expression.transform[e3], c2(e3) && (r.expression.mathWithTransform[e3] = t3));
  }
  function o(e3) {
    delete r.expression.transform[e3], c2(e3) ? r.expression.mathWithTransform[e3] = r[e3] : delete r.expression.mathWithTransform[e3];
  }
  function s(t3, i3) {
    var a2, s2, u2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t3.fn;
    if (u2.includes(".")) throw new Error("Factory name should not contain a nested path. Name: " + JSON.stringify(u2));
    var c3 = l(t3) ? r.expression.transform : r, p = u2 in r.expression.transform, m = hasOwnProperty$1$2(c3, u2) ? c3[u2] : void 0, d = function() {
      var n3 = {};
      t3.dependencies.map(stripOptionalNotation$1).forEach(((e3) => {
        if (e3.includes(".")) throw new Error("Factory dependency should not contain a nested path. Name: " + JSON.stringify(e3));
        "math" === e3 ? n3.math = r : "mathWithTransform" === e3 ? n3.mathWithTransform = r.expression.mathWithTransform : "classes" === e3 ? n3.classes = r : n3[e3] = r[e3];
      }));
      var a3 = t3(n3);
      if (a3 && "function" == typeof a3.transform) throw new Error('Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"');
      if (void 0 === m || i3.override) return a3;
      if (e2.isTypedFunction(m) && e2.isTypedFunction(a3)) return e2(m, a3);
      if (i3.silent) return m;
      throw new Error('Cannot import "' + u2 + '": already exists');
    }, h = null !== (a2 = null === (s2 = t3.meta) || void 0 === s2 ? void 0 : s2.formerly) && void 0 !== a2 ? a2 : "", g = l(t3) || (function(e3) {
      return !(e3.fn.includes(".") || hasOwnProperty$1$2(f2, e3.fn) || e3.meta && e3.meta.isClass);
    })(t3), y = r.expression.mathWithTransform;
    t3.meta && false === t3.meta.lazy ? (c3[u2] = d(), h && (c3[h] = c3[u2]), m && p ? (o(u2), h && o(h)) : g && (lazy$1(y, u2, (() => c3[u2])), h && lazy$1(y, h, (() => c3[u2])))) : (lazy$1(c3, u2, d), h && lazy$1(c3, h, d), m && p ? (o(u2), h && o(h)) : g && (lazy$1(y, u2, (() => c3[u2])), h && lazy$1(y, h, (() => c3[u2])))), n[u2] = t3, r.emit("import", u2, d);
  }
  function u(e3) {
    return "function" == typeof e3 || "number" == typeof e3 || "string" == typeof e3 || "boolean" == typeof e3 || null === e3 || isUnit$1(e3) || isComplex$1(e3) || isBigNumber$1(e3) || isFraction$1(e3) || isMatrix$1(e3) || Array.isArray(e3);
  }
  function c2(e3) {
    return !hasOwnProperty$1$2(f2, e3);
  }
  function l(e3) {
    return void 0 !== e3 && void 0 !== e3.meta && true === e3.meta.isTransformFunction || false;
  }
  var f2 = { expression: true, type: true, docs: true, error: true, json: true, chain: true };
  return function(e3, t3) {
    var r2 = arguments.length;
    if (1 !== r2 && 2 !== r2) throw new ArgumentsError$1("import", r2, 1, 2);
    t3 || (t3 = {});
    var n3 = {};
    for (var a2 in (function e4(r3, n4, i3) {
      if (Array.isArray(n4)) n4.forEach(((t4) => e4(r3, t4)));
      else if (isObject$1$1(n4) || (function(e5) {
        return "object" == typeof e5 && "Module" === e5[Symbol.toStringTag];
      })(n4)) for (var a3 in n4) hasOwnProperty$1$2(n4, a3) && e4(r3, n4[a3], a3);
      else if (isFactory$1(n4) || void 0 !== i3) {
        var o3 = isFactory$1(n4) ? l(n4) ? n4.fn + ".transform" : n4.fn : i3;
        if (hasOwnProperty$1$2(r3, o3) && r3[o3] !== n4 && !t3.silent) throw new Error('Cannot import "' + o3 + '" twice');
        r3[o3] = n4;
      } else if (!t3.silent) throw new TypeError("Factory, Object, or Array expected");
    })(n3, e3), n3) if (hasOwnProperty$1$2(n3, a2)) {
      var o2 = n3[a2];
      if (isFactory$1(o2)) s(o2, t3);
      else if (u(o2)) i2(a2, o2, t3);
      else if (!t3.silent) throw new TypeError("Factory, Object, or Array expected");
    }
  };
}
function create$1$1(e2, t2) {
  var r = _extends$4({}, DEFAULT_CONFIG$1, t2);
  if ("function" != typeof Object.create) throw new Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");
  var n = mixin$1$1({ isNumber: isNumber$1$1, isComplex: isComplex$1, isBigNumber: isBigNumber$1, isBigInt: isBigInt$1, isFraction: isFraction$1, isUnit: isUnit$1, isString: isString$1$1, isArray: isArray$1$1, isMatrix: isMatrix$1, isCollection: isCollection$1, isDenseMatrix: isDenseMatrix$1, isSparseMatrix: isSparseMatrix$1, isRange: isRange$1, isIndex: isIndex$1, isBoolean: isBoolean$1$1, isResultSet: isResultSet$1, isHelp: isHelp$1, isFunction: isFunction$2$1, isDate: isDate$1$1, isRegExp: isRegExp$1$1, isObject: isObject$1$1, isMap: isMap$1$1, isPartitionedMap: isPartitionedMap$1, isObjectWrappingMap: isObjectWrappingMap$1, isNull: isNull$1$1, isUndefined: isUndefined$1$1, isAccessorNode: isAccessorNode$1, isArrayNode: isArrayNode$1, isAssignmentNode: isAssignmentNode$1, isBlockNode: isBlockNode$1, isConditionalNode: isConditionalNode$1, isConstantNode: isConstantNode$1, isFunctionAssignmentNode: isFunctionAssignmentNode$1, isFunctionNode: isFunctionNode$1, isIndexNode: isIndexNode$1, isNode: isNode$2, isObjectNode: isObjectNode$1, isOperatorNode: isOperatorNode$1, isParenthesisNode: isParenthesisNode$1, isRangeNode: isRangeNode$1, isRelationalNode: isRelationalNode$1, isSymbolNode: isSymbolNode$1, isChain: isChain$1 });
  n.config = configFactory$1(r, n.emit), n.expression = { transform: {}, mathWithTransform: { config: n.config } };
  var i2 = [], a = [];
  var o = {};
  function s() {
    for (var e3 = arguments.length, t3 = new Array(e3), r2 = 0; r2 < e3; r2++) t3[r2] = arguments[r2];
    return n.typed.apply(n.typed, t3);
  }
  s.isTypedFunction = typedFunction$1.isTypedFunction;
  var u = importFactory$1(s, (function e3(t3) {
    if (isFactory$1(t3)) return t3(n);
    var o2 = t3[Object.keys(t3)[0]];
    if (isFactory$1(o2)) return o2(n);
    if (!isLegacyFactory$1(t3)) throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", t3), new Error("Factory object with properties `type`, `name`, and `factory` expected");
    var s2, u2 = i2.indexOf(t3);
    return -1 === u2 ? (s2 = true === t3.math ? t3.factory(n.type, r, e3, n.typed, n) : t3.factory(n.type, r, e3, n.typed), i2.push(t3), a.push(s2)) : s2 = a[u2], s2;
  }), n, o);
  return n.import = u, n.on("config", (() => {
    Object.values(o).forEach(((e3) => {
      e3 && e3.meta && e3.meta.recreateOnConfigChange && u(e3, { override: true });
    }));
  })), n.create = create$1$1.bind(null, e2), n.factory = factory$1, n.import(Object.values(deepFlatten$1(e2))), n.ArgumentsError = ArgumentsError$1, n.DimensionError = DimensionError$1, n.IndexError = IndexError$1, n;
}
var numeric1_2_6$1 = {}, hasRequiredNumeric1_2_6$1;
function requireNumeric1_2_6$1() {
  return hasRequiredNumeric1_2_6$1 || (hasRequiredNumeric1_2_6$1 = 1, (function(exports$1) {
    var numeric = exports$1;
    void 0 !== commonjsGlobal$3 && (commonjsGlobal$3.numeric = numeric), numeric.version = "1.2.6", numeric.bench = function(e2, t2) {
      var r, n, i2;
      for (void 0 === t2 && (t2 = 15), n = 0.5, r = /* @__PURE__ */ new Date(); ; ) {
        for (i2 = n *= 2; i2 > 3; i2 -= 4) e2(), e2(), e2(), e2();
        for (; i2 > 0; ) e2(), i2--;
        if (/* @__PURE__ */ new Date() - r > t2) break;
      }
      for (i2 = n; i2 > 3; i2 -= 4) e2(), e2(), e2(), e2();
      for (; i2 > 0; ) e2(), i2--;
      return 1e3 * (3 * n - 1) / (/* @__PURE__ */ new Date() - r);
    }, numeric._myIndexOf = function(e2) {
      var t2, r = this.length;
      for (t2 = 0; t2 < r; ++t2) if (this[t2] === e2) return t2;
      return -1;
    }, numeric.myIndexOf = Array.prototype.indexOf ? Array.prototype.indexOf : numeric._myIndexOf, numeric.Function = Function, numeric.precision = 4, numeric.largeArray = 50, numeric.prettyPrint = function(e2) {
      function t2(e3) {
        if (0 === e3) return "0";
        if (isNaN(e3)) return "NaN";
        if (e3 < 0) return "-" + t2(-e3);
        if (isFinite(e3)) {
          var r2 = Math.floor(Math.log(e3) / Math.log(10)), n = e3 / Math.pow(10, r2), i2 = n.toPrecision(numeric.precision);
          return 10 === parseFloat(i2) && (r2++, i2 = (n = 1).toPrecision(numeric.precision)), parseFloat(i2).toString() + "e" + r2.toString();
        }
        return "Infinity";
      }
      var r = [];
      return (function e3(n) {
        var i2;
        if (void 0 === n) return r.push(Array(numeric.precision + 8).join(" ")), false;
        if ("string" == typeof n) return r.push('"' + n + '"'), false;
        if ("boolean" == typeof n) return r.push(n.toString()), false;
        if ("number" == typeof n) {
          var a = t2(n), o = n.toPrecision(numeric.precision), s = parseFloat(n.toString()).toString(), u = [a, o, s, parseFloat(o).toString(), parseFloat(s).toString()];
          for (i2 = 1; i2 < u.length; i2++) u[i2].length < a.length && (a = u[i2]);
          return r.push(Array(numeric.precision + 8 - a.length).join(" ") + a), false;
        }
        if (null === n) return r.push("null"), false;
        if ("function" == typeof n) {
          r.push(n.toString());
          var c2 = false;
          for (i2 in n) n.hasOwnProperty(i2) && (c2 ? r.push(",\n") : r.push("\n{"), c2 = true, r.push(i2), r.push(": \n"), e3(n[i2]));
          return c2 && r.push("}\n"), true;
        }
        if (n instanceof Array) {
          if (n.length > numeric.largeArray) return r.push("...Large Array..."), true;
          c2 = false;
          for (r.push("["), i2 = 0; i2 < n.length; i2++) i2 > 0 && (r.push(","), c2 && r.push("\n ")), c2 = e3(n[i2]);
          return r.push("]"), true;
        }
        for (i2 in r.push("{"), c2 = false, n) n.hasOwnProperty(i2) && (c2 && r.push(",\n"), c2 = true, r.push(i2), r.push(": \n"), e3(n[i2]));
        return r.push("}"), true;
      })(e2), r.join("");
    }, numeric.parseDate = function(e2) {
      return (function e3(t2) {
        if ("string" == typeof t2) return Date.parse(t2.replace(/-/g, "/"));
        if (!(t2 instanceof Array)) throw new Error("parseDate: parameter must be arrays of strings");
        var r, n = [];
        for (r = 0; r < t2.length; r++) n[r] = e3(t2[r]);
        return n;
      })(e2);
    }, numeric.parseFloat = function(e2) {
      return (function e3(t2) {
        if ("string" == typeof t2) return parseFloat(t2);
        if (!(t2 instanceof Array)) throw new Error("parseFloat: parameter must be arrays of strings");
        var r, n = [];
        for (r = 0; r < t2.length; r++) n[r] = e3(t2[r]);
        return n;
      })(e2);
    }, numeric.parseCSV = function(e2) {
      var t2, r, n, i2 = e2.split("\n"), a = [], o = /(([^'",]*)|('[^']*')|("[^"]*")),/g, s = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/, u = 0;
      for (r = 0; r < i2.length; r++) {
        var c2, l = (i2[r] + ",").match(o);
        if (l.length > 0) {
          for (a[u] = [], t2 = 0; t2 < l.length; t2++) c2 = (n = l[t2]).substr(0, n.length - 1), s.test(c2) ? a[u][t2] = parseFloat(c2) : a[u][t2] = c2;
          u++;
        }
      }
      return a;
    }, numeric.toCSV = function(e2) {
      var t2, r, n, i2, a, o = numeric.dim(e2);
      for (n = o[0], o[1], a = [], t2 = 0; t2 < n; t2++) {
        for (i2 = [], r = 0; r < n; r++) i2[r] = e2[t2][r].toString();
        a[t2] = i2.join(", ");
      }
      return a.join("\n") + "\n";
    }, numeric.getURL = function(e2) {
      var t2 = new XMLHttpRequest();
      return t2.open("GET", e2, false), t2.send(), t2;
    }, numeric.imageURL = function(e2) {
      function t2(e3, t3, r2) {
        void 0 === t3 && (t3 = 0), void 0 === r2 && (r2 = e3.length);
        var n3, i3 = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117], a2 = -1;
        for (e3.length, n3 = t3; n3 < r2; n3++) a2 = a2 >>> 8 ^ i3[255 & (a2 ^ e3[n3])];
        return ~a2;
      }
      var r, n, i2, a, o, s, u, c2, l, f2, p = e2[0].length, m = e2[0][0].length, d = [137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, 255 & m, p >> 24 & 255, p >> 16 & 255, p >> 8 & 255, 255 & p, 8, 2, 0, 0, 0, -1, -2, -3, -4, -5, -6, -7, -8, 73, 68, 65, 84, 8, 29];
      for (f2 = t2(d, 12, 29), d[29] = f2 >> 24 & 255, d[30] = f2 >> 16 & 255, d[31] = f2 >> 8 & 255, d[32] = 255 & f2, r = 1, n = 0, u = 0; u < p; u++) {
        for (u < p - 1 ? d.push(0) : d.push(1), o = 3 * m + 1 + (0 === u) & 255, s = 3 * m + 1 + (0 === u) >> 8 & 255, d.push(o), d.push(s), d.push(255 & ~o), d.push(255 & ~s), 0 === u && d.push(0), c2 = 0; c2 < m; c2++) for (i2 = 0; i2 < 3; i2++) n = (n + (r = (r + (o = (o = e2[i2][u][c2]) > 255 ? 255 : o < 0 ? 0 : Math.round(o))) % 65521)) % 65521, d.push(o);
        d.push(0);
      }
      return l = (n << 16) + r, d.push(l >> 24 & 255), d.push(l >> 16 & 255), d.push(l >> 8 & 255), d.push(255 & l), a = d.length - 41, d[33] = a >> 24 & 255, d[34] = a >> 16 & 255, d[35] = a >> 8 & 255, d[36] = 255 & a, f2 = t2(d, 37), d.push(f2 >> 24 & 255), d.push(f2 >> 16 & 255), d.push(f2 >> 8 & 255), d.push(255 & f2), d.push(0), d.push(0), d.push(0), d.push(0), d.push(73), d.push(69), d.push(78), d.push(68), d.push(174), d.push(66), d.push(96), d.push(130), "data:image/png;base64," + (function(e3) {
        var t3, r2, n3, i3, a2, o2, s2, u2 = e3.length, c3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", l2 = "";
        for (t3 = 0; t3 < u2; t3 += 3) a2 = ((3 & (r2 = e3[t3])) << 4) + ((n3 = e3[t3 + 1]) >> 4), o2 = ((15 & n3) << 2) + ((i3 = e3[t3 + 2]) >> 6), s2 = 63 & i3, t3 + 1 >= u2 ? o2 = s2 = 64 : t3 + 2 >= u2 && (s2 = 64), l2 += c3.charAt(r2 >> 2) + c3.charAt(a2) + c3.charAt(o2) + c3.charAt(s2);
        return l2;
      })(d);
    }, numeric._dim = function(e2) {
      for (var t2 = []; "object" == typeof e2; ) t2.push(e2.length), e2 = e2[0];
      return t2;
    }, numeric.dim = function(e2) {
      var t2;
      return "object" == typeof e2 ? "object" == typeof (t2 = e2[0]) ? "object" == typeof t2[0] ? numeric._dim(e2) : [e2.length, t2.length] : [e2.length] : [];
    }, numeric.mapreduce = function(e2, t2) {
      return Function("x", "accum", "_s", "_k", 'if(typeof accum === "undefined") accum = ' + t2 + ';\nif(typeof x === "number") { var xi = x; ' + e2 + '; return accum; }\nif(typeof _s === "undefined") _s = numeric.dim(x);\nif(typeof _k === "undefined") _k = 0;\nvar _n = _s[_k];\nvar i,xi;\nif(_k < _s.length-1) {\n    for(i=_n-1;i>=0;i--) {\n        accum = arguments.callee(x[i],accum,_s,_k+1);\n    }    return accum;\n}\nfor(i=_n-1;i>=1;i-=2) { \n    xi = x[i];\n    ' + e2 + ";\n    xi = x[i-1];\n    " + e2 + ";\n}\nif(i === 0) {\n    xi = x[i];\n    " + e2 + "\n}\nreturn accum;");
    }, numeric.mapreduce2 = function(e2, t2) {
      return Function("x", "var n = x.length;\nvar i,xi;\n" + t2 + ";\nfor(i=n-1;i!==-1;--i) { \n    xi = x[i];\n    " + e2 + ";\n}\nreturn accum;");
    }, numeric.same = function e2(t2, r) {
      var n, i2;
      if (!(t2 instanceof Array && r instanceof Array)) return false;
      if ((i2 = t2.length) !== r.length) return false;
      for (n = 0; n < i2; n++) if (t2[n] !== r[n]) {
        if ("object" != typeof t2[n]) return false;
        if (!e2(t2[n], r[n])) return false;
      }
      return true;
    }, numeric.rep = function(e2, t2, r) {
      void 0 === r && (r = 0);
      var n, i2 = e2[r], a = Array(i2);
      if (r === e2.length - 1) {
        for (n = i2 - 2; n >= 0; n -= 2) a[n + 1] = t2, a[n] = t2;
        return -1 === n && (a[0] = t2), a;
      }
      for (n = i2 - 1; n >= 0; n--) a[n] = numeric.rep(e2, t2, r + 1);
      return a;
    }, numeric.dotMMsmall = function(e2, t2) {
      var r, n, i2, a, o, s, u, c2, l, f2, p;
      for (a = e2.length, o = t2.length, s = t2[0].length, u = Array(a), r = a - 1; r >= 0; r--) {
        for (c2 = Array(s), l = e2[r], i2 = s - 1; i2 >= 0; i2--) {
          for (f2 = l[o - 1] * t2[o - 1][i2], n = o - 2; n >= 1; n -= 2) p = n - 1, f2 += l[n] * t2[n][i2] + l[p] * t2[p][i2];
          0 === n && (f2 += l[0] * t2[0][i2]), c2[i2] = f2;
        }
        u[r] = c2;
      }
      return u;
    }, numeric._getCol = function(e2, t2, r) {
      var n;
      for (n = e2.length - 1; n > 0; --n) r[n] = e2[n][t2], r[--n] = e2[n][t2];
      0 === n && (r[0] = e2[0][t2]);
    }, numeric.dotMMbig = function(e2, t2) {
      var r, n, i2, a = numeric._getCol, o = t2.length, s = Array(o), u = e2.length, c2 = t2[0].length, l = new Array(u), f2 = numeric.dotVV;
      for (--o, n = --u; -1 !== n; --n) l[n] = Array(c2);
      for (n = --c2; -1 !== n; --n) for (a(t2, n, s), i2 = u; -1 !== i2; --i2) r = e2[i2], l[i2][n] = f2(r, s);
      return l;
    }, numeric.dotMV = function(e2, t2) {
      var r, n = e2.length;
      t2.length;
      var i2 = Array(n), a = numeric.dotVV;
      for (r = n - 1; r >= 0; r--) i2[r] = a(e2[r], t2);
      return i2;
    }, numeric.dotVM = function(e2, t2) {
      var r, n, i2, a, o, s, u;
      for (i2 = e2.length, a = t2[0].length, o = Array(a), n = a - 1; n >= 0; n--) {
        for (s = e2[i2 - 1] * t2[i2 - 1][n], r = i2 - 2; r >= 1; r -= 2) u = r - 1, s += e2[r] * t2[r][n] + e2[u] * t2[u][n];
        0 === r && (s += e2[0] * t2[0][n]), o[n] = s;
      }
      return o;
    }, numeric.dotVV = function(e2, t2) {
      var r, n, i2 = e2.length, a = e2[i2 - 1] * t2[i2 - 1];
      for (r = i2 - 2; r >= 1; r -= 2) n = r - 1, a += e2[r] * t2[r] + e2[n] * t2[n];
      return 0 === r && (a += e2[0] * t2[0]), a;
    }, numeric.dot = function(e2, t2) {
      var r = numeric.dim;
      switch (1e3 * r(e2).length + r(t2).length) {
        case 2002:
          return t2.length < 10 ? numeric.dotMMsmall(e2, t2) : numeric.dotMMbig(e2, t2);
        case 2001:
          return numeric.dotMV(e2, t2);
        case 1002:
          return numeric.dotVM(e2, t2);
        case 1001:
          return numeric.dotVV(e2, t2);
        case 1e3:
          return numeric.mulVS(e2, t2);
        case 1:
          return numeric.mulSV(e2, t2);
        case 0:
          return e2 * t2;
        default:
          throw new Error("numeric.dot only works on vectors and matrices");
      }
    }, numeric.diag = function(e2) {
      var t2, r, n, i2, a = e2.length, o = Array(a);
      for (t2 = a - 1; t2 >= 0; t2--) {
        for (i2 = Array(a), r = t2 + 2, n = a - 1; n >= r; n -= 2) i2[n] = 0, i2[n - 1] = 0;
        for (n > t2 && (i2[n] = 0), i2[t2] = e2[t2], n = t2 - 1; n >= 1; n -= 2) i2[n] = 0, i2[n - 1] = 0;
        0 === n && (i2[0] = 0), o[t2] = i2;
      }
      return o;
    }, numeric.getDiag = function(e2) {
      var t2, r = Math.min(e2.length, e2[0].length), n = Array(r);
      for (t2 = r - 1; t2 >= 1; --t2) n[t2] = e2[t2][t2], n[--t2] = e2[t2][t2];
      return 0 === t2 && (n[0] = e2[0][0]), n;
    }, numeric.identity = function(e2) {
      return numeric.diag(numeric.rep([e2], 1));
    }, numeric.pointwise = function(e2, t2, r) {
      void 0 === r && (r = "");
      var n, i2, a = [], o = /\[i\]$/, s = "", u = false;
      for (n = 0; n < e2.length; n++) o.test(e2[n]) ? s = i2 = e2[n].substring(0, e2[n].length - 3) : i2 = e2[n], "ret" === i2 && (u = true), a.push(i2);
      return a[e2.length] = "_s", a[e2.length + 1] = "_k", a[e2.length + 2] = 'if(typeof _s === "undefined") _s = numeric.dim(' + s + ');\nif(typeof _k === "undefined") _k = 0;\nvar _n = _s[_k];\nvar i' + (u ? "" : ", ret = Array(_n)") + ";\nif(_k < _s.length-1) {\n    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee(" + e2.join(",") + ",_s,_k+1);\n    return ret;\n}\n" + r + "\nfor(i=_n-1;i!==-1;--i) {\n    " + t2 + "\n}\nreturn ret;", Function.apply(null, a);
    }, numeric.pointwise2 = function(e2, t2, r) {
      void 0 === r && (r = "");
      var n, i2, a = [], o = /\[i\]$/, s = "", u = false;
      for (n = 0; n < e2.length; n++) o.test(e2[n]) ? s = i2 = e2[n].substring(0, e2[n].length - 3) : i2 = e2[n], "ret" === i2 && (u = true), a.push(i2);
      return a[e2.length] = "var _n = " + s + ".length;\nvar i" + (u ? "" : ", ret = Array(_n)") + ";\n" + r + "\nfor(i=_n-1;i!==-1;--i) {\n" + t2 + "\n}\nreturn ret;", Function.apply(null, a);
    }, numeric._biforeach = function e2(t2, r, n, i2, a) {
      var o;
      if (i2 !== n.length - 1) for (o = n[i2] - 1; o >= 0; o--) e2("object" == typeof t2 ? t2[o] : t2, "object" == typeof r ? r[o] : r, n, i2 + 1, a);
      else a(t2, r);
    }, numeric._biforeach2 = function e2(t2, r, n, i2, a) {
      if (i2 === n.length - 1) return a(t2, r);
      var o, s = n[i2], u = Array(s);
      for (o = s - 1; o >= 0; --o) u[o] = e2("object" == typeof t2 ? t2[o] : t2, "object" == typeof r ? r[o] : r, n, i2 + 1, a);
      return u;
    }, numeric._foreach = function e2(t2, r, n, i2) {
      var a;
      if (n !== r.length - 1) for (a = r[n] - 1; a >= 0; a--) e2(t2[a], r, n + 1, i2);
      else i2(t2);
    }, numeric._foreach2 = function e2(t2, r, n, i2) {
      if (n === r.length - 1) return i2(t2);
      var a, o = r[n], s = Array(o);
      for (a = o - 1; a >= 0; a--) s[a] = e2(t2[a], r, n + 1, i2);
      return s;
    }, numeric.ops2 = { add: "+", sub: "-", mul: "*", div: "/", mod: "%", and: "&&", or: "||", eq: "===", neq: "!==", lt: "<", gt: ">", leq: "<=", geq: ">=", band: "&", bor: "|", bxor: "^", lshift: "<<", rshift: ">>", rrshift: ">>>" }, numeric.opseq = { addeq: "+=", subeq: "-=", muleq: "*=", diveq: "/=", modeq: "%=", lshifteq: "<<=", rshifteq: ">>=", rrshifteq: ">>>=", bandeq: "&=", boreq: "|=", bxoreq: "^=" }, numeric.mathfuns = ["abs", "acos", "asin", "atan", "ceil", "cos", "exp", "floor", "log", "round", "sin", "sqrt", "tan", "isNaN", "isFinite"], numeric.mathfuns2 = ["atan2", "pow", "max", "min"], numeric.ops1 = { neg: "-", not: "!", bnot: "~", clone: "" }, numeric.mapreducers = { any: ["if(xi) return true;", "var accum = false;"], all: ["if(!xi) return false;", "var accum = true;"], sum: ["accum += xi;", "var accum = 0;"], prod: ["accum *= xi;", "var accum = 1;"], norm2Squared: ["accum += xi*xi;", "var accum = 0;"], norminf: ["accum = max(accum,abs(xi));", "var accum = 0, max = Math.max, abs = Math.abs;"], norm1: ["accum += abs(xi)", "var accum = 0, abs = Math.abs;"], sup: ["accum = max(accum,xi);", "var accum = -Infinity, max = Math.max;"], inf: ["accum = min(accum,xi);", "var accum = Infinity, min = Math.min;"] }, (function() {
      var e2, t2;
      for (e2 = 0; e2 < numeric.mathfuns2.length; ++e2) t2 = numeric.mathfuns2[e2], numeric.ops2[t2] = t2;
      for (e2 in numeric.ops2) if (numeric.ops2.hasOwnProperty(e2)) {
        t2 = numeric.ops2[e2];
        var r, n, i2 = "";
        -1 !== numeric.myIndexOf.call(numeric.mathfuns2, e2) ? (i2 = "var " + t2 + " = Math." + t2 + ";\n", r = function(e3, r2, n3) {
          return e3 + " = " + t2 + "(" + r2 + "," + n3 + ")";
        }, n = function(e3, r2) {
          return e3 + " = " + t2 + "(" + e3 + "," + r2 + ")";
        }) : (r = function(e3, r2, n3) {
          return e3 + " = " + r2 + " " + t2 + " " + n3;
        }, n = numeric.opseq.hasOwnProperty(e2 + "eq") ? function(e3, r2) {
          return e3 + " " + t2 + "= " + r2;
        } : function(e3, r2) {
          return e3 + " = " + e3 + " " + t2 + " " + r2;
        }), numeric[e2 + "VV"] = numeric.pointwise2(["x[i]", "y[i]"], r("ret[i]", "x[i]", "y[i]"), i2), numeric[e2 + "SV"] = numeric.pointwise2(["x", "y[i]"], r("ret[i]", "x", "y[i]"), i2), numeric[e2 + "VS"] = numeric.pointwise2(["x[i]", "y"], r("ret[i]", "x[i]", "y"), i2), numeric[e2] = Function("var n = arguments.length, i, x = arguments[0], y;\nvar VV = numeric." + e2 + "VV, VS = numeric." + e2 + "VS, SV = numeric." + e2 + 'SV;\nvar dim = numeric.dim;\nfor(i=1;i!==n;++i) { \n  y = arguments[i];\n  if(typeof x === "object") {\n      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);\n      else x = numeric._biforeach2(x,y,dim(x),0,VS);\n  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);\n  else ' + n("x", "y") + "\n}\nreturn x;\n"), numeric[t2] = numeric[e2], numeric[e2 + "eqV"] = numeric.pointwise2(["ret[i]", "x[i]"], n("ret[i]", "x[i]"), i2), numeric[e2 + "eqS"] = numeric.pointwise2(["ret[i]", "x"], n("ret[i]", "x"), i2), numeric[e2 + "eq"] = Function("var n = arguments.length, i, x = arguments[0], y;\nvar V = numeric." + e2 + "eqV, S = numeric." + e2 + 'eqS\nvar s = numeric.dim(x);\nfor(i=1;i!==n;++i) { \n  y = arguments[i];\n  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);\n  else numeric._biforeach(x,y,s,0,S);\n}\nreturn x;\n');
      }
      for (e2 = 0; e2 < numeric.mathfuns2.length; ++e2) t2 = numeric.mathfuns2[e2], delete numeric.ops2[t2];
      for (e2 = 0; e2 < numeric.mathfuns.length; ++e2) t2 = numeric.mathfuns[e2], numeric.ops1[t2] = t2;
      for (e2 in numeric.ops1) numeric.ops1.hasOwnProperty(e2) && (i2 = "", t2 = numeric.ops1[e2], -1 !== numeric.myIndexOf.call(numeric.mathfuns, e2) && Math.hasOwnProperty(t2) && (i2 = "var " + t2 + " = Math." + t2 + ";\n"), numeric[e2 + "eqV"] = numeric.pointwise2(["ret[i]"], "ret[i] = " + t2 + "(ret[i]);", i2), numeric[e2 + "eq"] = Function("x", 'if(typeof x !== "object") return ' + t2 + "x\nvar i;\nvar V = numeric." + e2 + "eqV;\nvar s = numeric.dim(x);\nnumeric._foreach(x,s,0,V);\nreturn x;\n"), numeric[e2 + "V"] = numeric.pointwise2(["x[i]"], "ret[i] = " + t2 + "(x[i]);", i2), numeric[e2] = Function("x", 'if(typeof x !== "object") return ' + t2 + "(x)\nvar i;\nvar V = numeric." + e2 + "V;\nvar s = numeric.dim(x);\nreturn numeric._foreach2(x,s,0,V);\n"));
      for (e2 = 0; e2 < numeric.mathfuns.length; ++e2) t2 = numeric.mathfuns[e2], delete numeric.ops1[t2];
      for (e2 in numeric.mapreducers) numeric.mapreducers.hasOwnProperty(e2) && (t2 = numeric.mapreducers[e2], numeric[e2 + "V"] = numeric.mapreduce2(t2[0], t2[1]), numeric[e2] = Function("x", "s", "k", t2[1] + 'if(typeof x !== "object") {    xi = x;\n' + t2[0] + ';\n    return accum;\n}if(typeof s === "undefined") s = numeric.dim(x);\nif(typeof k === "undefined") k = 0;\nif(k === s.length-1) return numeric.' + e2 + "V(x);\nvar xi;\nvar n = x.length, i;\nfor(i=n-1;i!==-1;--i) {\n   xi = arguments.callee(x[i]);\n" + t2[0] + ";\n}\nreturn accum;\n"));
    })(), numeric.truncVV = numeric.pointwise(["x[i]", "y[i]"], "ret[i] = round(x[i]/y[i])*y[i];", "var round = Math.round;"), numeric.truncVS = numeric.pointwise(["x[i]", "y"], "ret[i] = round(x[i]/y)*y;", "var round = Math.round;"), numeric.truncSV = numeric.pointwise(["x", "y[i]"], "ret[i] = round(x/y[i])*y[i];", "var round = Math.round;"), numeric.trunc = function(e2, t2) {
      return "object" == typeof e2 ? "object" == typeof t2 ? numeric.truncVV(e2, t2) : numeric.truncVS(e2, t2) : "object" == typeof t2 ? numeric.truncSV(e2, t2) : Math.round(e2 / t2) * t2;
    }, numeric.inv = function(e2) {
      var t2, r, n, i2, a, o, s, u = numeric.dim(e2), c2 = Math.abs, l = u[0], f2 = u[1], p = numeric.clone(e2), m = numeric.identity(l);
      for (o = 0; o < f2; ++o) {
        var d = -1, h = -1;
        for (a = o; a !== l; ++a) (s = c2(p[a][o])) > h && (d = a, h = s);
        for (r = p[d], p[d] = p[o], p[o] = r, i2 = m[d], m[d] = m[o], m[o] = i2, e2 = r[o], s = o; s !== f2; ++s) r[s] /= e2;
        for (s = f2 - 1; -1 !== s; --s) i2[s] /= e2;
        for (a = l - 1; -1 !== a; --a) if (a !== o) {
          for (t2 = p[a], n = m[a], e2 = t2[o], s = o + 1; s !== f2; ++s) t2[s] -= r[s] * e2;
          for (s = f2 - 1; s > 0; --s) n[s] -= i2[s] * e2, n[--s] -= i2[s] * e2;
          0 === s && (n[0] -= i2[0] * e2);
        }
      }
      return m;
    }, numeric.det = function(e2) {
      var t2 = numeric.dim(e2);
      if (2 !== t2.length || t2[0] !== t2[1]) throw new Error("numeric: det() only works on square matrices");
      var r, n, i2, a, o, s, u, c2, l = t2[0], f2 = 1, p = numeric.clone(e2);
      for (n = 0; n < l - 1; n++) {
        for (i2 = n, r = n + 1; r < l; r++) Math.abs(p[r][n]) > Math.abs(p[i2][n]) && (i2 = r);
        for (i2 !== n && (u = p[i2], p[i2] = p[n], p[n] = u, f2 *= -1), a = p[n], r = n + 1; r < l; r++) {
          for (s = (o = p[r])[n] / a[n], i2 = n + 1; i2 < l - 1; i2 += 2) c2 = i2 + 1, o[i2] -= a[i2] * s, o[c2] -= a[c2] * s;
          i2 !== l && (o[i2] -= a[i2] * s);
        }
        if (0 === a[n]) return 0;
        f2 *= a[n];
      }
      return f2 * p[n][n];
    }, numeric.transpose = function(e2) {
      var t2, r, n, i2, a, o = e2.length, s = e2[0].length, u = Array(s);
      for (r = 0; r < s; r++) u[r] = Array(o);
      for (t2 = o - 1; t2 >= 1; t2 -= 2) {
        for (i2 = e2[t2], n = e2[t2 - 1], r = s - 1; r >= 1; --r) (a = u[r])[t2] = i2[r], a[t2 - 1] = n[r], (a = u[--r])[t2] = i2[r], a[t2 - 1] = n[r];
        0 === r && ((a = u[0])[t2] = i2[0], a[t2 - 1] = n[0]);
      }
      if (0 === t2) {
        for (n = e2[0], r = s - 1; r >= 1; --r) u[r][0] = n[r], u[--r][0] = n[r];
        0 === r && (u[0][0] = n[0]);
      }
      return u;
    }, numeric.negtranspose = function(e2) {
      var t2, r, n, i2, a, o = e2.length, s = e2[0].length, u = Array(s);
      for (r = 0; r < s; r++) u[r] = Array(o);
      for (t2 = o - 1; t2 >= 1; t2 -= 2) {
        for (i2 = e2[t2], n = e2[t2 - 1], r = s - 1; r >= 1; --r) (a = u[r])[t2] = -i2[r], a[t2 - 1] = -n[r], (a = u[--r])[t2] = -i2[r], a[t2 - 1] = -n[r];
        0 === r && ((a = u[0])[t2] = -i2[0], a[t2 - 1] = -n[0]);
      }
      if (0 === t2) {
        for (n = e2[0], r = s - 1; r >= 1; --r) u[r][0] = -n[r], u[--r][0] = -n[r];
        0 === r && (u[0][0] = -n[0]);
      }
      return u;
    }, numeric._random = function e2(t2, r) {
      var n, i2, a = t2[r], o = Array(a);
      if (r === t2.length - 1) {
        for (i2 = Math.random, n = a - 1; n >= 1; n -= 2) o[n] = i2(), o[n - 1] = i2();
        return 0 === n && (o[0] = i2()), o;
      }
      for (n = a - 1; n >= 0; n--) o[n] = e2(t2, r + 1);
      return o;
    }, numeric.random = function(e2) {
      return numeric._random(e2, 0);
    }, numeric.norm2 = function(e2) {
      return Math.sqrt(numeric.norm2Squared(e2));
    }, numeric.linspace = function(e2, t2, r) {
      if (void 0 === r && (r = Math.max(Math.round(t2 - e2) + 1, 1)), r < 2) return 1 === r ? [e2] : [];
      var n, i2 = Array(r);
      for (n = --r; n >= 0; n--) i2[n] = (n * t2 + (r - n) * e2) / r;
      return i2;
    }, numeric.getBlock = function(e2, t2, r) {
      var n = numeric.dim(e2);
      return (function e3(i2, a) {
        var o, s = t2[a], u = r[a] - s, c2 = Array(u);
        if (a === n.length - 1) {
          for (o = u; o >= 0; o--) c2[o] = i2[o + s];
          return c2;
        }
        for (o = u; o >= 0; o--) c2[o] = e3(i2[o + s], a + 1);
        return c2;
      })(e2, 0);
    }, numeric.setBlock = function(e2, t2, r, n) {
      var i2 = numeric.dim(e2);
      return (function e3(n3, a, o) {
        var s, u = t2[o], c2 = r[o] - u;
        if (o === i2.length - 1) for (s = c2; s >= 0; s--) n3[s + u] = a[s];
        for (s = c2; s >= 0; s--) e3(n3[s + u], a[s], o + 1);
      })(e2, n, 0), e2;
    }, numeric.getRange = function(e2, t2, r) {
      var n, i2, a, o, s = t2.length, u = r.length, c2 = Array(s);
      for (n = s - 1; -1 !== n; --n) for (c2[n] = Array(u), a = c2[n], o = e2[t2[n]], i2 = u - 1; -1 !== i2; --i2) a[i2] = o[r[i2]];
      return c2;
    }, numeric.blockMatrix = function(e2) {
      var t2 = numeric.dim(e2);
      if (t2.length < 4) return numeric.blockMatrix([e2]);
      var r, n, i2, a, o, s = t2[0], u = t2[1];
      for (r = 0, n = 0, i2 = 0; i2 < s; ++i2) r += e2[i2][0].length;
      for (a = 0; a < u; ++a) n += e2[0][a][0].length;
      var c2 = Array(r);
      for (i2 = 0; i2 < r; ++i2) c2[i2] = Array(n);
      var l, f2, p, m, d, h = 0;
      for (i2 = 0; i2 < s; ++i2) {
        for (l = n, a = u - 1; -1 !== a; --a) for (l -= (o = e2[i2][a])[0].length, p = o.length - 1; -1 !== p; --p) for (d = o[p], f2 = c2[h + p], m = d.length - 1; -1 !== m; --m) f2[l + m] = d[m];
        h += e2[i2][0].length;
      }
      return c2;
    }, numeric.tensor = function(e2, t2) {
      if ("number" == typeof e2 || "number" == typeof t2) return numeric.mul(e2, t2);
      var r = numeric.dim(e2), n = numeric.dim(t2);
      if (1 !== r.length || 1 !== n.length) throw new Error("numeric: tensor product is only defined for vectors");
      var i2, a, o, s, u = r[0], c2 = n[0], l = Array(u);
      for (a = u - 1; a >= 0; a--) {
        for (i2 = Array(c2), s = e2[a], o = c2 - 1; o >= 3; --o) i2[o] = s * t2[o], i2[--o] = s * t2[o], i2[--o] = s * t2[o], i2[--o] = s * t2[o];
        for (; o >= 0; ) i2[o] = s * t2[o], --o;
        l[a] = i2;
      }
      return l;
    }, numeric.T = function(e2, t2) {
      this.x = e2, this.y = t2;
    }, numeric.t = function(e2, t2) {
      return new numeric.T(e2, t2);
    }, numeric.Tbinop = function(e2, t2, r, n, i2) {
      var a;
      if (numeric.indexOf, "string" != typeof i2) for (a in i2 = "", numeric) numeric.hasOwnProperty(a) && (e2.indexOf(a) >= 0 || t2.indexOf(a) >= 0 || r.indexOf(a) >= 0 || n.indexOf(a) >= 0) && a.length > 1 && (i2 += "var " + a + " = numeric." + a + ";\n");
      return Function(["y"], "var x = this;\nif(!(y instanceof numeric.T)) { y = new numeric.T(y); }\n" + i2 + "\nif(x.y) {  if(y.y) {    return new numeric.T(" + n + ");\n  }\n  return new numeric.T(" + r + ");\n}\nif(y.y) {\n  return new numeric.T(" + t2 + ");\n}\nreturn new numeric.T(" + e2 + ");\n");
    }, numeric.T.prototype.add = numeric.Tbinop("add(x.x,y.x)", "add(x.x,y.x),y.y", "add(x.x,y.x),x.y", "add(x.x,y.x),add(x.y,y.y)"), numeric.T.prototype.sub = numeric.Tbinop("sub(x.x,y.x)", "sub(x.x,y.x),neg(y.y)", "sub(x.x,y.x),x.y", "sub(x.x,y.x),sub(x.y,y.y)"), numeric.T.prototype.mul = numeric.Tbinop("mul(x.x,y.x)", "mul(x.x,y.x),mul(x.x,y.y)", "mul(x.x,y.x),mul(x.y,y.x)", "sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))"), numeric.T.prototype.reciprocal = function() {
      var e2 = numeric.mul, t2 = numeric.div;
      if (this.y) {
        var r = numeric.add(e2(this.x, this.x), e2(this.y, this.y));
        return new numeric.T(t2(this.x, r), t2(numeric.neg(this.y), r));
      }
      return new T(t2(1, this.x));
    }, numeric.T.prototype.div = function(e2) {
      if (e2 instanceof numeric.T || (e2 = new numeric.T(e2)), e2.y) return this.mul(e2.reciprocal());
      var t2 = numeric.div;
      return this.y ? new numeric.T(t2(this.x, e2.x), t2(this.y, e2.x)) : new numeric.T(t2(this.x, e2.x));
    }, numeric.T.prototype.dot = numeric.Tbinop("dot(x.x,y.x)", "dot(x.x,y.x),dot(x.x,y.y)", "dot(x.x,y.x),dot(x.y,y.x)", "sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))"), numeric.T.prototype.transpose = function() {
      var e2 = numeric.transpose, t2 = this.x, r = this.y;
      return r ? new numeric.T(e2(t2), e2(r)) : new numeric.T(e2(t2));
    }, numeric.T.prototype.transjugate = function() {
      var e2 = numeric.transpose, t2 = this.x, r = this.y;
      return r ? new numeric.T(e2(t2), numeric.negtranspose(r)) : new numeric.T(e2(t2));
    }, numeric.Tunop = function(e2, t2, r) {
      return "string" != typeof r && (r = ""), Function("var x = this;\n" + r + "\nif(x.y) {  " + t2 + ";\n}\n" + e2 + ";\n");
    }, numeric.T.prototype.exp = numeric.Tunop("return new numeric.T(ex)", "return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))", "var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;"), numeric.T.prototype.conj = numeric.Tunop("return new numeric.T(x.x);", "return new numeric.T(x.x,numeric.neg(x.y));"), numeric.T.prototype.neg = numeric.Tunop("return new numeric.T(neg(x.x));", "return new numeric.T(neg(x.x),neg(x.y));", "var neg = numeric.neg;"), numeric.T.prototype.sin = numeric.Tunop("return new numeric.T(numeric.sin(x.x))", "return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));"), numeric.T.prototype.cos = numeric.Tunop("return new numeric.T(numeric.cos(x.x))", "return x.exp().add(x.neg().exp()).div(2);"), numeric.T.prototype.abs = numeric.Tunop("return new numeric.T(numeric.abs(x.x));", "return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));", "var mul = numeric.mul;"), numeric.T.prototype.log = numeric.Tunop("return new numeric.T(numeric.log(x.x));", "var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();\nreturn new numeric.T(numeric.log(r.x),theta.x);"), numeric.T.prototype.norm2 = numeric.Tunop("return numeric.norm2(x.x);", "var f = numeric.norm2Squared;\nreturn Math.sqrt(f(x.x)+f(x.y));"), numeric.T.prototype.inv = function() {
      var e2 = this;
      if (void 0 === e2.y) return new numeric.T(numeric.inv(e2.x));
      var t2, r, n, i2, a, o, s, u, c2, l, f2, p, m, d, h, g, y, v2, x2 = e2.x.length, b2 = numeric.identity(x2), _2 = numeric.rep([x2, x2], 0), w2 = numeric.clone(e2.x), A2 = numeric.clone(e2.y);
      for (c2 = 0; c2 < x2; c2++) {
        for (p = (d = w2[c2][c2]) * d + (h = A2[c2][c2]) * h, f2 = c2, l = c2 + 1; l < x2; l++) (m = (d = w2[l][c2]) * d + (h = A2[l][c2]) * h) > p && (f2 = l, p = m);
        for (f2 !== c2 && (v2 = w2[c2], w2[c2] = w2[f2], w2[f2] = v2, v2 = A2[c2], A2[c2] = A2[f2], A2[f2] = v2, v2 = b2[c2], b2[c2] = b2[f2], b2[f2] = v2, v2 = _2[c2], _2[c2] = _2[f2], _2[f2] = v2), t2 = w2[c2], r = A2[c2], a = b2[c2], o = _2[c2], d = t2[c2], h = r[c2], l = c2 + 1; l < x2; l++) g = t2[l], y = r[l], t2[l] = (g * d + y * h) / p, r[l] = (y * d - g * h) / p;
        for (l = 0; l < x2; l++) g = a[l], y = o[l], a[l] = (g * d + y * h) / p, o[l] = (y * d - g * h) / p;
        for (l = c2 + 1; l < x2; l++) {
          for (n = w2[l], i2 = A2[l], s = b2[l], u = _2[l], d = n[c2], h = i2[c2], f2 = c2 + 1; f2 < x2; f2++) g = t2[f2], y = r[f2], n[f2] -= g * d - y * h, i2[f2] -= y * d + g * h;
          for (f2 = 0; f2 < x2; f2++) g = a[f2], y = o[f2], s[f2] -= g * d - y * h, u[f2] -= y * d + g * h;
        }
      }
      for (c2 = x2 - 1; c2 > 0; c2--) for (a = b2[c2], o = _2[c2], l = c2 - 1; l >= 0; l--) for (s = b2[l], u = _2[l], d = w2[l][c2], h = A2[l][c2], f2 = x2 - 1; f2 >= 0; f2--) g = a[f2], y = o[f2], s[f2] -= d * g - h * y, u[f2] -= d * y + h * g;
      return new numeric.T(b2, _2);
    }, numeric.T.prototype.get = function(e2) {
      var t2, r = this.x, n = this.y, i2 = 0, a = e2.length;
      if (n) {
        for (; i2 < a; ) r = r[t2 = e2[i2]], n = n[t2], i2++;
        return new numeric.T(r, n);
      }
      for (; i2 < a; ) r = r[t2 = e2[i2]], i2++;
      return new numeric.T(r);
    }, numeric.T.prototype.set = function(e2, t2) {
      var r, n = this.x, i2 = this.y, a = 0, o = e2.length, s = t2.x, u = t2.y;
      if (0 === o) return u ? this.y = u : i2 && (this.y = void 0), this.x = n, this;
      if (u) {
        for (i2 || (i2 = numeric.rep(numeric.dim(n), 0), this.y = i2); a < o - 1; ) n = n[r = e2[a]], i2 = i2[r], a++;
        return n[r = e2[a]] = s, i2[r] = u, this;
      }
      if (i2) {
        for (; a < o - 1; ) n = n[r = e2[a]], i2 = i2[r], a++;
        return n[r = e2[a]] = s, i2[r] = s instanceof Array ? numeric.rep(numeric.dim(s), 0) : 0, this;
      }
      for (; a < o - 1; ) n = n[r = e2[a]], a++;
      return n[r = e2[a]] = s, this;
    }, numeric.T.prototype.getRows = function(e2, t2) {
      var r, n, i2 = t2 - e2 + 1, a = Array(i2), o = this.x, s = this.y;
      for (r = e2; r <= t2; r++) a[r - e2] = o[r];
      if (s) {
        for (n = Array(i2), r = e2; r <= t2; r++) n[r - e2] = s[r];
        return new numeric.T(a, n);
      }
      return new numeric.T(a);
    }, numeric.T.prototype.setRows = function(e2, t2, r) {
      var n, i2 = this.x, a = this.y, o = r.x, s = r.y;
      for (n = e2; n <= t2; n++) i2[n] = o[n - e2];
      if (s) for (a || (a = numeric.rep(numeric.dim(i2), 0), this.y = a), n = e2; n <= t2; n++) a[n] = s[n - e2];
      else if (a) for (n = e2; n <= t2; n++) a[n] = numeric.rep([o[n - e2].length], 0);
      return this;
    }, numeric.T.prototype.getRow = function(e2) {
      var t2 = this.x, r = this.y;
      return r ? new numeric.T(t2[e2], r[e2]) : new numeric.T(t2[e2]);
    }, numeric.T.prototype.setRow = function(e2, t2) {
      var r = this.x, n = this.y, i2 = t2.x, a = t2.y;
      return r[e2] = i2, a ? (n || (n = numeric.rep(numeric.dim(r), 0), this.y = n), n[e2] = a) : n && (n = numeric.rep([i2.length], 0)), this;
    }, numeric.T.prototype.getBlock = function(e2, t2) {
      var r = this.x, n = this.y, i2 = numeric.getBlock;
      return n ? new numeric.T(i2(r, e2, t2), i2(n, e2, t2)) : new numeric.T(i2(r, e2, t2));
    }, numeric.T.prototype.setBlock = function(e2, t2, r) {
      r instanceof numeric.T || (r = new numeric.T(r));
      var n = this.x, i2 = this.y, a = numeric.setBlock, o = r.x, s = r.y;
      if (s) return i2 || (this.y = numeric.rep(numeric.dim(this), 0), i2 = this.y), a(n, e2, t2, o), a(i2, e2, t2, s), this;
      a(n, e2, t2, o), i2 && a(i2, e2, t2, numeric.rep(numeric.dim(o), 0));
    }, numeric.T.rep = function(e2, t2) {
      var r = numeric.T;
      t2 instanceof r || (t2 = new r(t2));
      var n = t2.x, i2 = t2.y, a = numeric.rep;
      return i2 ? new r(a(e2, n), a(e2, i2)) : new r(a(e2, n));
    }, numeric.T.diag = function(e2) {
      e2 instanceof numeric.T || (e2 = new numeric.T(e2));
      var t2 = e2.x, r = e2.y, n = numeric.diag;
      return r ? new numeric.T(n(t2), n(r)) : new numeric.T(n(t2));
    }, numeric.T.eig = function() {
      if (this.y) throw new Error("eig: not implemented for complex matrices.");
      return numeric.eig(this.x);
    }, numeric.T.identity = function(e2) {
      return new numeric.T(numeric.identity(e2));
    }, numeric.T.prototype.getDiag = function() {
      var e2 = numeric, t2 = this.x, r = this.y;
      return r ? new e2.T(e2.getDiag(t2), e2.getDiag(r)) : new e2.T(e2.getDiag(t2));
    }, numeric.house = function(e2) {
      var t2 = numeric.clone(e2), r = (e2[0] >= 0 ? 1 : -1) * numeric.norm2(e2);
      t2[0] += r;
      var n = numeric.norm2(t2);
      if (0 === n) throw new Error("eig: internal error");
      return numeric.div(t2, n);
    }, numeric.toUpperHessenberg = function(e2) {
      var t2 = numeric.dim(e2);
      if (2 !== t2.length || t2[0] !== t2[1]) throw new Error("numeric: toUpperHessenberg() only works on square matrices");
      var r, n, i2, a, o, s, u, c2, l, f2, p = t2[0], m = numeric.clone(e2), d = numeric.identity(p);
      for (n = 0; n < p - 2; n++) {
        for (a = Array(p - n - 1), r = n + 1; r < p; r++) a[r - n - 1] = m[r][n];
        if (numeric.norm2(a) > 0) {
          for (o = numeric.house(a), s = numeric.getBlock(m, [n + 1, n], [p - 1, p - 1]), u = numeric.tensor(o, numeric.dot(o, s)), r = n + 1; r < p; r++) for (c2 = m[r], l = u[r - n - 1], i2 = n; i2 < p; i2++) c2[i2] -= 2 * l[i2 - n];
          for (s = numeric.getBlock(m, [0, n + 1], [p - 1, p - 1]), u = numeric.tensor(numeric.dot(s, o), o), r = 0; r < p; r++) for (c2 = m[r], l = u[r], i2 = n + 1; i2 < p; i2++) c2[i2] -= 2 * l[i2 - n - 1];
          for (s = Array(p - n - 1), r = n + 1; r < p; r++) s[r - n - 1] = d[r];
          for (u = numeric.tensor(o, numeric.dot(o, s)), r = n + 1; r < p; r++) for (f2 = d[r], l = u[r - n - 1], i2 = 0; i2 < p; i2++) f2[i2] -= 2 * l[i2];
        }
      }
      return { H: m, Q: d };
    }, numeric.epsilon = 2220446049250313e-31, numeric.QRFrancis = function(e2, t2) {
      void 0 === t2 && (t2 = 1e4), e2 = numeric.clone(e2), numeric.clone(e2);
      var r, n, i2, a, o, s, u, c2, l, f2, p, m, d, h, g, y, v2, x2, b2 = numeric.dim(e2)[0], _2 = numeric.identity(b2);
      if (b2 < 3) return { Q: _2, B: [[0, b2 - 1]] };
      var w2 = numeric.epsilon;
      for (x2 = 0; x2 < t2; x2++) {
        for (y = 0; y < b2 - 1; y++) if (Math.abs(e2[y + 1][y]) < w2 * (Math.abs(e2[y][y]) + Math.abs(e2[y + 1][y + 1]))) {
          var A2 = numeric.QRFrancis(numeric.getBlock(e2, [0, 0], [y, y]), t2), N = numeric.QRFrancis(numeric.getBlock(e2, [y + 1, y + 1], [b2 - 1, b2 - 1]), t2);
          for (m = Array(y + 1), g = 0; g <= y; g++) m[g] = _2[g];
          for (d = numeric.dot(A2.Q, m), g = 0; g <= y; g++) _2[g] = d[g];
          for (m = Array(b2 - y - 1), g = y + 1; g < b2; g++) m[g - y - 1] = _2[g];
          for (d = numeric.dot(N.Q, m), g = y + 1; g < b2; g++) _2[g] = d[g - y - 1];
          return { Q: _2, B: A2.B.concat(numeric.add(N.B, y + 1)) };
        }
        var D, E, $2;
        if (i2 = e2[b2 - 2][b2 - 2], a = e2[b2 - 2][b2 - 1], o = e2[b2 - 1][b2 - 2], c2 = i2 + (s = e2[b2 - 1][b2 - 1]), u = i2 * s - a * o, l = numeric.getBlock(e2, [0, 0], [2, 2]), c2 * c2 >= 4 * u) D = 0.5 * (c2 + Math.sqrt(c2 * c2 - 4 * u)), E = 0.5 * (c2 - Math.sqrt(c2 * c2 - 4 * u)), l = numeric.add(numeric.sub(numeric.dot(l, l), numeric.mul(l, D + E)), numeric.diag(numeric.rep([3], D * E)));
        else l = numeric.add(numeric.sub(numeric.dot(l, l), numeric.mul(l, c2)), numeric.diag(numeric.rep([3], u)));
        for (r = [l[0][0], l[1][0], l[2][0]], n = numeric.house(r), m = [e2[0], e2[1], e2[2]], d = numeric.tensor(n, numeric.dot(n, m)), g = 0; g < 3; g++) for (p = e2[g], h = d[g], v2 = 0; v2 < b2; v2++) p[v2] -= 2 * h[v2];
        for (m = numeric.getBlock(e2, [0, 0], [b2 - 1, 2]), d = numeric.tensor(numeric.dot(m, n), n), g = 0; g < b2; g++) for (p = e2[g], h = d[g], v2 = 0; v2 < 3; v2++) p[v2] -= 2 * h[v2];
        for (m = [_2[0], _2[1], _2[2]], d = numeric.tensor(n, numeric.dot(n, m)), g = 0; g < 3; g++) for (f2 = _2[g], h = d[g], v2 = 0; v2 < b2; v2++) f2[v2] -= 2 * h[v2];
        for (y = 0; y < b2 - 2; y++) {
          for (v2 = y; v2 <= y + 1; v2++) if (Math.abs(e2[v2 + 1][v2]) < w2 * (Math.abs(e2[v2][v2]) + Math.abs(e2[v2 + 1][v2 + 1]))) {
            A2 = numeric.QRFrancis(numeric.getBlock(e2, [0, 0], [v2, v2]), t2), N = numeric.QRFrancis(numeric.getBlock(e2, [v2 + 1, v2 + 1], [b2 - 1, b2 - 1]), t2);
            for (m = Array(v2 + 1), g = 0; g <= v2; g++) m[g] = _2[g];
            for (d = numeric.dot(A2.Q, m), g = 0; g <= v2; g++) _2[g] = d[g];
            for (m = Array(b2 - v2 - 1), g = v2 + 1; g < b2; g++) m[g - v2 - 1] = _2[g];
            for (d = numeric.dot(N.Q, m), g = v2 + 1; g < b2; g++) _2[g] = d[g - v2 - 1];
            return { Q: _2, B: A2.B.concat(numeric.add(N.B, v2 + 1)) };
          }
          for ($2 = Math.min(b2 - 1, y + 3), r = Array($2 - y), g = y + 1; g <= $2; g++) r[g - y - 1] = e2[g][y];
          for (n = numeric.house(r), m = numeric.getBlock(e2, [y + 1, y], [$2, b2 - 1]), d = numeric.tensor(n, numeric.dot(n, m)), g = y + 1; g <= $2; g++) for (p = e2[g], h = d[g - y - 1], v2 = y; v2 < b2; v2++) p[v2] -= 2 * h[v2 - y];
          for (m = numeric.getBlock(e2, [0, y + 1], [b2 - 1, $2]), d = numeric.tensor(numeric.dot(m, n), n), g = 0; g < b2; g++) for (p = e2[g], h = d[g], v2 = y + 1; v2 <= $2; v2++) p[v2] -= 2 * h[v2 - y - 1];
          for (m = Array($2 - y), g = y + 1; g <= $2; g++) m[g - y - 1] = _2[g];
          for (d = numeric.tensor(n, numeric.dot(n, m)), g = y + 1; g <= $2; g++) for (f2 = _2[g], h = d[g - y - 1], v2 = 0; v2 < b2; v2++) f2[v2] -= 2 * h[v2];
        }
      }
      throw new Error("numeric: eigenvalue iteration does not converge -- increase maxiter?");
    }, numeric.eig = function(e2, t2) {
      var r, n, i2, a, o, s, u, c2, l, f2, p, m, d, h, g, y, v2 = numeric.toUpperHessenberg(e2), x2 = numeric.QRFrancis(v2.H, t2), b2 = numeric.T, _2 = e2.length, w2 = x2.B, A2 = numeric.dot(x2.Q, numeric.dot(v2.H, numeric.transpose(x2.Q))), N = new b2(numeric.dot(x2.Q, v2.Q)), D = w2.length, E = Math.sqrt;
      for (n = 0; n < D; n++) if ((r = w2[n][0]) === w2[n][1]) ;
      else {
        if (a = r + 1, o = A2[r][r], s = A2[r][a], u = A2[a][r], c2 = A2[a][a], 0 === s && 0 === u) continue;
        (f2 = (l = -o - c2) * l - 4 * (o * c2 - s * u)) >= 0 ? ((g = (o - (p = l < 0 ? -0.5 * (l - E(f2)) : -0.5 * (l + E(f2)))) * (o - p) + s * s) > (y = u * u + (c2 - p) * (c2 - p)) ? (d = (o - p) / (g = E(g)), h = s / g) : (d = u / (y = E(y)), h = (c2 - p) / y), i2 = new b2([[h, -d], [d, h]]), N.setRows(r, a, i2.dot(N.getRows(r, a)))) : (p = -0.5 * l, m = 0.5 * E(-f2), (g = (o - p) * (o - p) + s * s) > (y = u * u + (c2 - p) * (c2 - p)) ? (d = (o - p) / (g = E(g + m * m)), h = s / g, p = 0, m /= g) : (d = u / (y = E(y + m * m)), h = (c2 - p) / y, p = m / y, m = 0), i2 = new b2([[h, -d], [d, h]], [[p, m], [m, -p]]), N.setRows(r, a, i2.dot(N.getRows(r, a))));
      }
      var $2 = N.dot(e2).dot(N.transjugate()), S2 = (_2 = e2.length, numeric.T.identity(_2));
      for (a = 0; a < _2; a++) if (a > 0) for (n = a - 1; n >= 0; n--) {
        var C2 = $2.get([n, n]), M2 = $2.get([a, a]);
        numeric.neq(C2.x, M2.x) || numeric.neq(C2.y, M2.y) ? (p = $2.getRow(n).getBlock([n], [a - 1]), m = S2.getRow(a).getBlock([n], [a - 1]), S2.set([a, n], $2.get([n, a]).neg().sub(p.dot(m)).div(C2.sub(M2)))) : S2.setRow(a, S2.getRow(n));
      }
      for (a = 0; a < _2; a++) p = S2.getRow(a), S2.setRow(a, p.div(p.norm2()));
      return S2 = S2.transpose(), S2 = N.transjugate().dot(S2), { lambda: $2.getDiag(), E: S2 };
    }, numeric.ccsSparse = function(e2) {
      var t2, r, n, i2 = e2.length, a = [];
      for (r = i2 - 1; -1 !== r; --r) for (n in t2 = e2[r]) {
        for (n = parseInt(n); n >= a.length; ) a[a.length] = 0;
        0 !== t2[n] && a[n]++;
      }
      var o = a.length, s = Array(o + 1);
      for (s[0] = 0, r = 0; r < o; ++r) s[r + 1] = s[r] + a[r];
      var u = Array(s[o]), c2 = Array(s[o]);
      for (r = i2 - 1; -1 !== r; --r) for (n in t2 = e2[r]) 0 !== t2[n] && (a[n]--, u[s[n] + a[n]] = r, c2[s[n] + a[n]] = t2[n]);
      return [s, u, c2];
    }, numeric.ccsFull = function(e2) {
      var t2, r, n, i2, a = e2[0], o = e2[1], s = e2[2], u = numeric.ccsDim(e2), c2 = u[0], l = u[1], f2 = numeric.rep([c2, l], 0);
      for (t2 = 0; t2 < l; t2++) for (n = a[t2], i2 = a[t2 + 1], r = n; r < i2; ++r) f2[o[r]][t2] = s[r];
      return f2;
    }, numeric.ccsTSolve = function(e2, t2, r, n, i2) {
      var a, o, s, u, c2, l, f2, p = e2[0], m = e2[1], d = e2[2], h = p.length - 1, g = Math.max, y = 0;
      function v2(e3) {
        var t3;
        if (0 === r[e3]) {
          for (r[e3] = 1, t3 = p[e3]; t3 < p[e3 + 1]; ++t3) v2(m[t3]);
          i2[y] = e3, ++y;
        }
      }
      for (void 0 === n && (r = numeric.rep([h], 0)), void 0 === n && (n = numeric.linspace(0, r.length - 1)), void 0 === i2 && (i2 = []), a = n.length - 1; -1 !== a; --a) v2(n[a]);
      for (i2.length = y, a = i2.length - 1; -1 !== a; --a) r[i2[a]] = 0;
      for (a = n.length - 1; -1 !== a; --a) o = n[a], r[o] = t2[o];
      for (a = i2.length - 1; -1 !== a; --a) {
        for (o = i2[a], s = p[o], u = g(p[o + 1], s), c2 = s; c2 !== u; ++c2) if (m[c2] === o) {
          r[o] /= d[c2];
          break;
        }
        for (f2 = r[o], c2 = s; c2 !== u; ++c2) (l = m[c2]) !== o && (r[l] -= f2 * d[c2]);
      }
      return r;
    }, numeric.ccsDFS = function(e2) {
      this.k = Array(e2), this.k1 = Array(e2), this.j = Array(e2);
    }, numeric.ccsDFS.prototype.dfs = function(e2, t2, r, n, i2, a) {
      var o, s, u, c2 = 0, l = i2.length, f2 = this.k, p = this.k1, m = this.j;
      if (0 === n[e2]) for (n[e2] = 1, m[0] = e2, f2[0] = s = t2[e2], p[0] = u = t2[e2 + 1]; ; ) if (s >= u) {
        if (i2[l] = m[c2], 0 === c2) return;
        ++l, s = f2[--c2], u = p[c2];
      } else 0 === n[o = a[r[s]]] ? (n[o] = 1, f2[c2] = s, m[++c2] = o, s = t2[o], p[c2] = u = t2[o + 1]) : ++s;
    }, numeric.ccsLPSolve = function(e2, t2, r, n, i2, a, o) {
      var s = e2[0], u = e2[1], c2 = e2[2];
      s.length;
      var l, f2, p, m, d, h, g, y, v2, x2 = t2[0], b2 = t2[1], _2 = t2[2];
      for (f2 = x2[i2], p = x2[i2 + 1], n.length = 0, l = f2; l < p; ++l) o.dfs(a[b2[l]], s, u, r, n, a);
      for (l = n.length - 1; -1 !== l; --l) r[n[l]] = 0;
      for (l = f2; l !== p; ++l) r[m = a[b2[l]]] = _2[l];
      for (l = n.length - 1; -1 !== l; --l) {
        for (d = s[m = n[l]], h = s[m + 1], g = d; g < h; ++g) if (a[u[g]] === m) {
          r[m] /= c2[g];
          break;
        }
        for (v2 = r[m], g = d; g < h; ++g) (y = a[u[g]]) !== m && (r[y] -= v2 * c2[g]);
      }
      return r;
    }, numeric.ccsLUP1 = function(e2, t2) {
      var r, n, i2, a, o, s, u, c2 = e2[0].length - 1, l = [numeric.rep([c2 + 1], 0), [], []], f2 = [numeric.rep([c2 + 1], 0), [], []], p = l[0], m = l[1], d = l[2], h = f2[0], g = f2[1], y = f2[2], v2 = numeric.rep([c2], 0), x2 = numeric.rep([c2], 0), b2 = numeric.ccsLPSolve, _2 = Math.abs, w2 = numeric.linspace(0, c2 - 1), A2 = numeric.linspace(0, c2 - 1), N = new numeric.ccsDFS(c2);
      for (void 0 === t2 && (t2 = 1), r = 0; r < c2; ++r) {
        for (b2(l, e2, v2, x2, r, A2, N), a = -1, o = -1, n = x2.length - 1; -1 !== n; --n) (i2 = x2[n]) <= r || (s = _2(v2[i2])) > a && (o = i2, a = s);
        for (_2(v2[r]) < t2 * a && (n = w2[r], a = w2[o], w2[r] = a, A2[a] = r, w2[o] = n, A2[n] = o, a = v2[r], v2[r] = v2[o], v2[o] = a), a = p[r], o = h[r], u = v2[r], m[a] = w2[r], d[a] = 1, ++a, n = x2.length - 1; -1 !== n; --n) s = v2[i2 = x2[n]], x2[n] = 0, v2[i2] = 0, i2 <= r ? (g[o] = i2, y[o] = s, ++o) : (m[a] = w2[i2], d[a] = s / u, ++a);
        p[r + 1] = a, h[r + 1] = o;
      }
      for (n = m.length - 1; -1 !== n; --n) m[n] = A2[m[n]];
      return { L: l, U: f2, P: w2, Pinv: A2 };
    }, numeric.ccsDFS0 = function(e2) {
      this.k = Array(e2), this.k1 = Array(e2), this.j = Array(e2);
    }, numeric.ccsDFS0.prototype.dfs = function(e2, t2, r, n, i2, a, o) {
      var s, u, c2, l = 0, f2 = i2.length, p = this.k, m = this.k1, d = this.j;
      if (0 === n[e2]) for (n[e2] = 1, d[0] = e2, p[0] = u = t2[a[e2]], m[0] = c2 = t2[a[e2] + 1]; ; ) {
        if (isNaN(u)) throw new Error("Ow!");
        if (u >= c2) {
          if (i2[f2] = a[d[l]], 0 === l) return;
          ++f2, u = p[--l], c2 = m[l];
        } else 0 === n[s = r[u]] ? (n[s] = 1, p[l] = u, d[++l] = s, u = t2[s = a[s]], m[l] = c2 = t2[s + 1]) : ++u;
      }
    }, numeric.ccsLPSolve0 = function(e2, t2, r, n, i2, a, o, s) {
      var u = e2[0], c2 = e2[1], l = e2[2];
      u.length;
      var f2, p, m, d, h, g, y, v2, x2, b2 = t2[0], _2 = t2[1], w2 = t2[2];
      for (p = b2[i2], m = b2[i2 + 1], n.length = 0, f2 = p; f2 < m; ++f2) s.dfs(_2[f2], u, c2, r, n, a, o);
      for (f2 = n.length - 1; -1 !== f2; --f2) r[o[d = n[f2]]] = 0;
      for (f2 = p; f2 !== m; ++f2) r[d = _2[f2]] = w2[f2];
      for (f2 = n.length - 1; -1 !== f2; --f2) {
        for (v2 = o[d = n[f2]], h = u[d], g = u[d + 1], y = h; y < g; ++y) if (c2[y] === v2) {
          r[v2] /= l[y];
          break;
        }
        for (x2 = r[v2], y = h; y < g; ++y) r[c2[y]] -= x2 * l[y];
        r[v2] = x2;
      }
    }, numeric.ccsLUP0 = function(e2, t2) {
      var r, n, i2, a, o, s, u, c2 = e2[0].length - 1, l = [numeric.rep([c2 + 1], 0), [], []], f2 = [numeric.rep([c2 + 1], 0), [], []], p = l[0], m = l[1], d = l[2], h = f2[0], g = f2[1], y = f2[2], v2 = numeric.rep([c2], 0), x2 = numeric.rep([c2], 0), b2 = numeric.ccsLPSolve0, _2 = Math.abs, w2 = numeric.linspace(0, c2 - 1), A2 = numeric.linspace(0, c2 - 1), N = new numeric.ccsDFS0(c2);
      for (void 0 === t2 && (t2 = 1), r = 0; r < c2; ++r) {
        for (b2(l, e2, v2, x2, r, A2, w2, N), a = -1, o = -1, n = x2.length - 1; -1 !== n; --n) (i2 = x2[n]) <= r || (s = _2(v2[w2[i2]])) > a && (o = i2, a = s);
        for (_2(v2[w2[r]]) < t2 * a && (n = w2[r], a = w2[o], w2[r] = a, A2[a] = r, w2[o] = n, A2[n] = o), a = p[r], o = h[r], u = v2[w2[r]], m[a] = w2[r], d[a] = 1, ++a, n = x2.length - 1; -1 !== n; --n) s = v2[w2[i2 = x2[n]]], x2[n] = 0, v2[w2[i2]] = 0, i2 <= r ? (g[o] = i2, y[o] = s, ++o) : (m[a] = w2[i2], d[a] = s / u, ++a);
        p[r + 1] = a, h[r + 1] = o;
      }
      for (n = m.length - 1; -1 !== n; --n) m[n] = A2[m[n]];
      return { L: l, U: f2, P: w2, Pinv: A2 };
    }, numeric.ccsLUP = numeric.ccsLUP0, numeric.ccsDim = function(e2) {
      return [numeric.sup(e2[1]) + 1, e2[0].length - 1];
    }, numeric.ccsGetBlock = function(e2, t2, r) {
      var n = numeric.ccsDim(e2), i2 = n[0], a = n[1];
      void 0 === t2 ? t2 = numeric.linspace(0, i2 - 1) : "number" == typeof t2 && (t2 = [t2]), void 0 === r ? r = numeric.linspace(0, a - 1) : "number" == typeof r && (r = [r]);
      var o, s, u, c2, l = t2.length, f2 = r.length, p = numeric.rep([a], 0), m = [], d = [], h = [p, m, d], g = e2[0], y = e2[1], v2 = e2[2], x2 = numeric.rep([i2], 0), b2 = 0, _2 = numeric.rep([i2], 0);
      for (s = 0; s < f2; ++s) {
        var w2 = g[c2 = r[s]], A2 = g[c2 + 1];
        for (o = w2; o < A2; ++o) _2[u = y[o]] = 1, x2[u] = v2[o];
        for (o = 0; o < l; ++o) _2[t2[o]] && (m[b2] = o, d[b2] = x2[t2[o]], ++b2);
        for (o = w2; o < A2; ++o) _2[u = y[o]] = 0;
        p[s + 1] = b2;
      }
      return h;
    }, numeric.ccsDot = function(e2, t2) {
      var r = e2[0], n = e2[1], i2 = e2[2], a = t2[0], o = t2[1], s = t2[2], u = numeric.ccsDim(e2), c2 = numeric.ccsDim(t2), l = u[0];
      u[1];
      var f2, p, m, d, h, g, y, v2, x2, b2, _2, w2 = c2[1], A2 = numeric.rep([l], 0), N = numeric.rep([l], 0), D = Array(l), E = numeric.rep([w2], 0), $2 = [], S2 = [], C2 = [E, $2, S2];
      for (m = 0; m !== w2; ++m) {
        for (d = a[m], h = a[m + 1], x2 = 0, p = d; p < h; ++p) for (b2 = o[p], _2 = s[p], g = r[b2], y = r[b2 + 1], f2 = g; f2 < y; ++f2) 0 === N[v2 = n[f2]] && (D[x2] = v2, N[v2] = 1, x2 += 1), A2[v2] = A2[v2] + i2[f2] * _2;
        for (h = (d = E[m]) + x2, E[m + 1] = h, p = x2 - 1; -1 !== p; --p) _2 = d + p, f2 = D[p], $2[_2] = f2, S2[_2] = A2[f2], N[f2] = 0, A2[f2] = 0;
        E[m + 1] = E[m] + x2;
      }
      return C2;
    }, numeric.ccsLUPSolve = function(e2, t2) {
      var r = e2.L, n = e2.U;
      e2.P;
      var i2 = t2[0], a = false;
      "object" != typeof i2 && (i2 = (t2 = [[0, t2.length], numeric.linspace(0, t2.length - 1), t2])[0], a = true);
      var o, s, u, c2, l, f2, p = t2[1], m = t2[2], d = r[0].length - 1, h = i2.length - 1, g = numeric.rep([d], 0), y = Array(d), v2 = numeric.rep([d], 0), x2 = Array(d), b2 = numeric.rep([h + 1], 0), _2 = [], w2 = [], A2 = numeric.ccsTSolve, N = 0;
      for (o = 0; o < h; ++o) {
        for (l = 0, u = i2[o], c2 = i2[o + 1], s = u; s < c2; ++s) f2 = e2.Pinv[p[s]], x2[l] = f2, v2[f2] = m[s], ++l;
        for (x2.length = l, A2(r, v2, g, x2, y), s = x2.length - 1; -1 !== s; --s) v2[x2[s]] = 0;
        if (A2(n, g, v2, y, x2), a) return v2;
        for (s = y.length - 1; -1 !== s; --s) g[y[s]] = 0;
        for (s = x2.length - 1; -1 !== s; --s) f2 = x2[s], _2[N] = f2, w2[N] = v2[f2], v2[f2] = 0, ++N;
        b2[o + 1] = N;
      }
      return [b2, _2, w2];
    }, numeric.ccsbinop = function(e2, t2) {
      return void 0 === t2 && (t2 = ""), Function("X", "Y", "var Xi = X[0], Xj = X[1], Xv = X[2];\nvar Yi = Y[0], Yj = Y[1], Yv = Y[2];\nvar n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;\nvar Zi = numeric.rep([n+1],0), Zj = [], Zv = [];\nvar x = numeric.rep([m],0),y = numeric.rep([m],0);\nvar xk,yk,zk;\nvar i,j,j0,j1,k,p=0;\n" + t2 + "for(i=0;i<n;++i) {\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Xj[j];\n    x[k] = 1;\n    Zj[p] = k;\n    ++p;\n  }\n  j0 = Yi[i]; j1 = Yi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Yj[j];\n    y[k] = Yv[j];\n    if(x[k] === 0) {\n      Zj[p] = k;\n      ++p;\n    }\n  }\n  Zi[i+1] = p;\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];\n  j0 = Zi[i]; j1 = Zi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Zj[j];\n    xk = x[k];\n    yk = y[k];\n" + e2 + "\n    Zv[j] = zk;\n  }\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;\n  j0 = Yi[i]; j1 = Yi[i+1];\n  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;\n}\nreturn [Zi,Zj,Zv];");
    }, (function() {
      var k, A, B, C;
      for (k in numeric.ops2) A = isFinite(eval("1" + numeric.ops2[k] + "0")) ? "[Y[0],Y[1],numeric." + k + "(X,Y[2])]" : "NaN", B = isFinite(eval("0" + numeric.ops2[k] + "1")) ? "[X[0],X[1],numeric." + k + "(X[2],Y)]" : "NaN", C = isFinite(eval("1" + numeric.ops2[k] + "0")) && isFinite(eval("0" + numeric.ops2[k] + "1")) ? "numeric.ccs" + k + "MM(X,Y)" : "NaN", numeric["ccs" + k + "MM"] = numeric.ccsbinop("zk = xk " + numeric.ops2[k] + "yk;"), numeric["ccs" + k] = Function("X", "Y", 'if(typeof X === "number") return ' + A + ';\nif(typeof Y === "number") return ' + B + ";\nreturn " + C + ";\n");
    })(), numeric.ccsScatter = function(e2) {
      var t2, r = e2[0], n = e2[1], i2 = e2[2], a = numeric.sup(n) + 1, o = r.length, s = numeric.rep([a], 0), u = Array(o), c2 = Array(o), l = numeric.rep([a], 0);
      for (t2 = 0; t2 < o; ++t2) l[n[t2]]++;
      for (t2 = 0; t2 < a; ++t2) s[t2 + 1] = s[t2] + l[t2];
      var f2, p, m = s.slice(0);
      for (t2 = 0; t2 < o; ++t2) u[f2 = m[p = n[t2]]] = r[t2], c2[f2] = i2[t2], m[p] = m[p] + 1;
      return [s, u, c2];
    }, numeric.ccsGather = function(e2) {
      var t2, r, n, i2, a, o = e2[0], s = e2[1], u = e2[2], c2 = o.length - 1, l = s.length, f2 = Array(l), p = Array(l), m = Array(l);
      for (a = 0, t2 = 0; t2 < c2; ++t2) for (n = o[t2], i2 = o[t2 + 1], r = n; r !== i2; ++r) p[a] = t2, f2[a] = s[r], m[a] = u[r], ++a;
      return [f2, p, m];
    }, numeric.sdim = function e2(t2, r, n) {
      if (void 0 === r && (r = []), "object" != typeof t2) return r;
      var i2;
      for (i2 in void 0 === n && (n = 0), n in r || (r[n] = 0), t2.length > r[n] && (r[n] = t2.length), t2) t2.hasOwnProperty(i2) && e2(t2[i2], r, n + 1);
      return r;
    }, numeric.sclone = function e2(t2, r, n) {
      void 0 === r && (r = 0), void 0 === n && (n = numeric.sdim(t2).length);
      var i2, a = Array(t2.length);
      if (r === n - 1) {
        for (i2 in t2) t2.hasOwnProperty(i2) && (a[i2] = t2[i2]);
        return a;
      }
      for (i2 in t2) t2.hasOwnProperty(i2) && (a[i2] = e2(t2[i2], r + 1, n));
      return a;
    }, numeric.sdiag = function(e2) {
      var t2, r, n = e2.length, i2 = Array(n);
      for (t2 = n - 1; t2 >= 1; t2 -= 2) r = t2 - 1, i2[t2] = [], i2[t2][t2] = e2[t2], i2[r] = [], i2[r][r] = e2[r];
      return 0 === t2 && (i2[0] = [], i2[0][0] = e2[t2]), i2;
    }, numeric.sidentity = function(e2) {
      return numeric.sdiag(numeric.rep([e2], 1));
    }, numeric.stranspose = function(e2) {
      var t2, r, n, i2 = [];
      for (t2 in e2.length, e2) if (e2.hasOwnProperty(t2)) for (r in n = e2[t2]) n.hasOwnProperty(r) && ("object" != typeof i2[r] && (i2[r] = []), i2[r][t2] = n[r]);
      return i2;
    }, numeric.sLUP = function(e2, t2) {
      throw new Error("The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.");
    }, numeric.sdotMM = function(e2, t2) {
      var r = e2.length;
      t2.length;
      var n, i2, a, o, s, u, c2, l = numeric.stranspose(t2), f2 = l.length, p = Array(r);
      for (a = r - 1; a >= 0; a--) {
        for (c2 = [], n = e2[a], s = f2 - 1; s >= 0; s--) {
          for (o in u = 0, i2 = l[s], n) n.hasOwnProperty(o) && o in i2 && (u += n[o] * i2[o]);
          u && (c2[s] = u);
        }
        p[a] = c2;
      }
      return p;
    }, numeric.sdotMV = function(e2, t2) {
      var r, n, i2, a, o = e2.length, s = Array(o);
      for (n = o - 1; n >= 0; n--) {
        for (i2 in a = 0, r = e2[n]) r.hasOwnProperty(i2) && t2[i2] && (a += r[i2] * t2[i2]);
        a && (s[n] = a);
      }
      return s;
    }, numeric.sdotVM = function(e2, t2) {
      var r, n, i2, a, o = [];
      for (r in e2) if (e2.hasOwnProperty(r)) for (n in i2 = t2[r], a = e2[r], i2) i2.hasOwnProperty(n) && (o[n] || (o[n] = 0), o[n] += a * i2[n]);
      return o;
    }, numeric.sdotVV = function(e2, t2) {
      var r, n = 0;
      for (r in e2) e2[r] && t2[r] && (n += e2[r] * t2[r]);
      return n;
    }, numeric.sdot = function(e2, t2) {
      var r = numeric.sdim(e2).length, n = numeric.sdim(t2).length;
      switch (1e3 * r + n) {
        case 0:
          return e2 * t2;
        case 1001:
          return numeric.sdotVV(e2, t2);
        case 2001:
          return numeric.sdotMV(e2, t2);
        case 1002:
          return numeric.sdotVM(e2, t2);
        case 2002:
          return numeric.sdotMM(e2, t2);
        default:
          throw new Error("numeric.sdot not implemented for tensors of order " + r + " and " + n);
      }
    }, numeric.sscatter = function(e2) {
      var t2, r, n, i2, a = e2[0].length, o = e2.length, s = [];
      for (r = a - 1; r >= 0; --r) if (e2[o - 1][r]) {
        for (i2 = s, n = 0; n < o - 2; n++) i2[t2 = e2[n][r]] || (i2[t2] = []), i2 = i2[t2];
        i2[e2[n][r]] = e2[n + 1][r];
      }
      return s;
    }, numeric.sgather = function e2(t2, r, n) {
      var i2, a, o;
      for (a in void 0 === r && (r = []), void 0 === n && (n = []), i2 = n.length, t2) if (t2.hasOwnProperty(a)) if (n[i2] = parseInt(a), "number" == typeof (o = t2[a])) {
        if (o) {
          if (0 === r.length) for (a = i2 + 1; a >= 0; --a) r[a] = [];
          for (a = i2; a >= 0; --a) r[a].push(n[a]);
          r[i2 + 1].push(o);
        }
      } else e2(o, r, n);
      return n.length > i2 && n.pop(), r;
    }, numeric.cLU = function(e2) {
      var t2, r, n, i2, a, o, s = e2[0], u = e2[1], c2 = e2[2], l = s.length, f2 = 0;
      for (t2 = 0; t2 < l; t2++) s[t2] > f2 && (f2 = s[t2]);
      f2++;
      var p, m = Array(f2), d = Array(f2), h = numeric.rep([f2], 1 / 0), g = numeric.rep([f2], -1 / 0);
      for (n = 0; n < l; n++) t2 = s[n], (r = u[n]) < h[t2] && (h[t2] = r), r > g[t2] && (g[t2] = r);
      for (t2 = 0; t2 < f2 - 1; t2++) g[t2] > g[t2 + 1] && (g[t2 + 1] = g[t2]);
      for (t2 = f2 - 1; t2 >= 1; t2--) h[t2] < h[t2 - 1] && (h[t2 - 1] = h[t2]);
      for (t2 = 0; t2 < f2; t2++) d[t2] = numeric.rep([g[t2] - h[t2] + 1], 0), m[t2] = numeric.rep([t2 - h[t2]], 0), t2 - h[t2] + 1, g[t2] - t2 + 1;
      for (n = 0; n < l; n++) d[t2 = s[n]][u[n] - h[t2]] = c2[n];
      for (t2 = 0; t2 < f2 - 1; t2++) for (i2 = t2 - h[t2], x2 = d[t2], r = t2 + 1; h[r] <= t2 && r < f2; r++) if (a = t2 - h[r], o = g[t2] - t2, p = (b2 = d[r])[a] / x2[i2]) {
        for (n = 1; n <= o; n++) b2[n + a] -= p * x2[n + i2];
        m[r][t2 - h[r]] = p;
      }
      var y, v2, x2 = [], b2 = [], _2 = [], w2 = [], A2 = [], N = [];
      for (l = 0, y = 0, t2 = 0; t2 < f2; t2++) {
        for (i2 = h[t2], a = g[t2], v2 = d[t2], r = t2; r <= a; r++) v2[r - i2] && (x2[l] = t2, b2[l] = r, _2[l] = v2[r - i2], l++);
        for (v2 = m[t2], r = i2; r < t2; r++) v2[r - i2] && (w2[y] = t2, A2[y] = r, N[y] = v2[r - i2], y++);
        w2[y] = t2, A2[y] = t2, N[y] = 1, y++;
      }
      return { U: [x2, b2, _2], L: [w2, A2, N] };
    }, numeric.cLUsolve = function(e2, t2) {
      var r = e2.L, n = e2.U, i2 = numeric.clone(t2), a = r[0], o = r[1], s = r[2], u = n[0], c2 = n[1], l = n[2], f2 = u.length;
      a.length;
      var p, m, d = i2.length;
      for (m = 0, p = 0; p < d; p++) {
        for (; o[m] < p; ) i2[p] -= s[m] * i2[o[m]], m++;
        m++;
      }
      for (m = f2 - 1, p = d - 1; p >= 0; p--) {
        for (; c2[m] > p; ) i2[p] -= l[m] * i2[c2[m]], m--;
        i2[p] /= l[m], m--;
      }
      return i2;
    }, numeric.cgrid = function(e2, t2) {
      "number" == typeof e2 && (e2 = [e2, e2]);
      var r, n, i2, a = numeric.rep(e2, -1);
      if ("function" != typeof t2) if ("L" === t2) t2 = function(t3, r2) {
        return t3 >= e2[0] / 2 || r2 < e2[1] / 2;
      };
      else t2 = function(e3, t3) {
        return true;
      };
      for (i2 = 0, r = 1; r < e2[0] - 1; r++) for (n = 1; n < e2[1] - 1; n++) t2(r, n) && (a[r][n] = i2, i2++);
      return a;
    }, numeric.cdelsq = function(e2) {
      var t2, r, n, i2, a, o = [[-1, 0], [0, -1], [0, 1], [1, 0]], s = numeric.dim(e2), u = s[0], c2 = s[1], l = [], f2 = [], p = [];
      for (t2 = 1; t2 < u - 1; t2++) for (r = 1; r < c2 - 1; r++) if (!(e2[t2][r] < 0)) {
        for (n = 0; n < 4; n++) i2 = t2 + o[n][0], a = r + o[n][1], e2[i2][a] < 0 || (l.push(e2[t2][r]), f2.push(e2[i2][a]), p.push(-1));
        l.push(e2[t2][r]), f2.push(e2[t2][r]), p.push(4);
      }
      return [l, f2, p];
    }, numeric.cdotMV = function(e2, t2) {
      var r, n, i2, a = e2[0], o = e2[1], s = e2[2], u = a.length;
      for (i2 = 0, n = 0; n < u; n++) a[n] > i2 && (i2 = a[n]);
      for (i2++, r = numeric.rep([i2], 0), n = 0; n < u; n++) r[a[n]] += s[n] * t2[o[n]];
      return r;
    }, numeric.Spline = function(e2, t2, r, n, i2) {
      this.x = e2, this.yl = t2, this.yr = r, this.kl = n, this.kr = i2;
    }, numeric.Spline.prototype._at = function(e2, t2) {
      var r, n, i2, a = this.x, o = this.yl, s = this.yr, u = this.kl, c2 = this.kr, l = numeric.add, f2 = numeric.sub, p = numeric.mul;
      r = f2(p(u[t2], a[t2 + 1] - a[t2]), f2(s[t2 + 1], o[t2])), n = l(p(c2[t2 + 1], a[t2] - a[t2 + 1]), f2(s[t2 + 1], o[t2]));
      var m = (i2 = (e2 - a[t2]) / (a[t2 + 1] - a[t2])) * (1 - i2);
      return l(l(l(p(1 - i2, o[t2]), p(i2, s[t2 + 1])), p(r, m * (1 - i2))), p(n, m * i2));
    }, numeric.Spline.prototype.at = function(e2) {
      if ("number" == typeof e2) {
        var t2, r, n, i2 = this.x, a = i2.length, o = Math.floor;
        for (t2 = 0, r = a - 1; r - t2 > 1; ) i2[n = o((t2 + r) / 2)] <= e2 ? t2 = n : r = n;
        return this._at(e2, t2);
      }
      a = e2.length;
      var s, u = Array(a);
      for (s = a - 1; -1 !== s; --s) u[s] = this.at(e2[s]);
      return u;
    }, numeric.Spline.prototype.diff = function() {
      var e2, t2, r, n = this.x, i2 = this.yl, a = this.yr, o = this.kl, s = this.kr, u = i2.length, c2 = o, l = s, f2 = Array(u), p = Array(u), m = numeric.add, d = numeric.mul, h = numeric.div, g = numeric.sub;
      for (e2 = u - 1; -1 !== e2; --e2) t2 = n[e2 + 1] - n[e2], r = g(a[e2 + 1], i2[e2]), f2[e2] = h(m(d(r, 6), d(o[e2], -4 * t2), d(s[e2 + 1], -2 * t2)), t2 * t2), p[e2 + 1] = h(m(d(r, -6), d(o[e2], 2 * t2), d(s[e2 + 1], 4 * t2)), t2 * t2);
      return new numeric.Spline(n, c2, l, f2, p);
    }, numeric.Spline.prototype.roots = function() {
      function e2(e3) {
        return e3 * e3;
      }
      var t2 = [], r = this.x, n = this.yl, i2 = this.yr, a = this.kl, o = this.kr;
      "number" == typeof n[0] && (n = [n], i2 = [i2], a = [a], o = [o]);
      var s, u, c2, l, f2, p, m, d, h, g, y, v2, x2, b2, _2, w2, A2, N, D, E, $2, S2, C2, M2 = n.length, T2 = r.length - 1, F = (t2 = Array(M2), Math.sqrt);
      for (s = 0; s !== M2; ++s) {
        for (l = n[s], f2 = i2[s], p = a[s], m = o[s], d = [], u = 0; u !== T2; u++) {
          for (u > 0 && f2[u] * l[u] < 0 && d.push(r[u]), w2 = r[u + 1] - r[u], r[u], y = l[u], v2 = f2[u + 1], h = p[u] / w2, x2 = (g = m[u + 1] / w2) + 3 * y + 2 * h - 3 * v2, b2 = 3 * (g + h + 2 * (y - v2)), (_2 = e2(h - g + 3 * (y - v2)) + 12 * g * y) <= 0 ? A2 = (N = x2 / b2) > r[u] && N < r[u + 1] ? [r[u], N, r[u + 1]] : [r[u], r[u + 1]] : (N = (x2 - F(_2)) / b2, D = (x2 + F(_2)) / b2, A2 = [r[u]], N > r[u] && N < r[u + 1] && A2.push(N), D > r[u] && D < r[u + 1] && A2.push(D), A2.push(r[u + 1])), $2 = A2[0], N = this._at($2, u), c2 = 0; c2 < A2.length - 1; c2++) if (S2 = A2[c2 + 1], D = this._at(S2, u), 0 !== N) if (0 === D || N * D > 0) $2 = S2, N = D;
          else {
            for (var O2 = 0; !((C2 = (N * S2 - D * $2) / (N - D)) <= $2 || C2 >= S2); ) if ((E = this._at(C2, u)) * D > 0) S2 = C2, D = E, -1 === O2 && (N *= 0.5), O2 = -1;
            else {
              if (!(E * N > 0)) break;
              $2 = C2, N = E, 1 === O2 && (D *= 0.5), O2 = 1;
            }
            d.push(C2), $2 = A2[c2 + 1], N = this._at($2, u);
          }
          else d.push($2), $2 = S2, N = D;
          0 === D && d.push(S2);
        }
        t2[s] = d;
      }
      return "number" == typeof this.yl[0] ? t2[0] : t2;
    }, numeric.spline = function(e2, t2, r, n) {
      var i2, a = e2.length, o = [], s = [], u = [], c2 = numeric.sub, l = numeric.mul, f2 = numeric.add;
      for (i2 = a - 2; i2 >= 0; i2--) s[i2] = e2[i2 + 1] - e2[i2], u[i2] = c2(t2[i2 + 1], t2[i2]);
      "string" != typeof r && "string" != typeof n || (r = n = "periodic");
      var p = [[], [], []];
      switch (typeof r) {
        case "undefined":
          o[0] = l(3 / (s[0] * s[0]), u[0]), p[0].push(0, 0), p[1].push(0, 1), p[2].push(2 / s[0], 1 / s[0]);
          break;
        case "string":
          o[0] = f2(l(3 / (s[a - 2] * s[a - 2]), u[a - 2]), l(3 / (s[0] * s[0]), u[0])), p[0].push(0, 0, 0), p[1].push(a - 2, 0, 1), p[2].push(1 / s[a - 2], 2 / s[a - 2] + 2 / s[0], 1 / s[0]);
          break;
        default:
          o[0] = r, p[0].push(0), p[1].push(0), p[2].push(1);
      }
      for (i2 = 1; i2 < a - 1; i2++) o[i2] = f2(l(3 / (s[i2 - 1] * s[i2 - 1]), u[i2 - 1]), l(3 / (s[i2] * s[i2]), u[i2])), p[0].push(i2, i2, i2), p[1].push(i2 - 1, i2, i2 + 1), p[2].push(1 / s[i2 - 1], 2 / s[i2 - 1] + 2 / s[i2], 1 / s[i2]);
      switch (typeof n) {
        case "undefined":
          o[a - 1] = l(3 / (s[a - 2] * s[a - 2]), u[a - 2]), p[0].push(a - 1, a - 1), p[1].push(a - 2, a - 1), p[2].push(1 / s[a - 2], 2 / s[a - 2]);
          break;
        case "string":
          p[1][p[1].length - 1] = 0;
          break;
        default:
          o[a - 1] = n, p[0].push(a - 1), p[1].push(a - 1), p[2].push(1);
      }
      o = "number" != typeof o[0] ? numeric.transpose(o) : [o];
      var m = Array(o.length);
      if ("string" == typeof r) for (i2 = m.length - 1; -1 !== i2; --i2) m[i2] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(p)), o[i2]), m[i2][a - 1] = m[i2][0];
      else for (i2 = m.length - 1; -1 !== i2; --i2) m[i2] = numeric.cLUsolve(numeric.cLU(p), o[i2]);
      return m = "number" == typeof t2[0] ? m[0] : numeric.transpose(m), new numeric.Spline(e2, t2, t2, m, m);
    }, numeric.fftpow2 = function e2(t2, r) {
      var n = t2.length;
      if (1 !== n) {
        var i2, a, o = Math.cos, s = Math.sin, u = Array(n / 2), c2 = Array(n / 2), l = Array(n / 2), f2 = Array(n / 2);
        for (a = n / 2, i2 = n - 1; -1 !== i2; --i2) l[--a] = t2[i2], f2[a] = r[i2], --i2, u[a] = t2[i2], c2[a] = r[i2];
        e2(u, c2), e2(l, f2), a = n / 2;
        var p, m, d, h = -6.283185307179586 / n;
        for (i2 = n - 1; -1 !== i2; --i2) -1 === --a && (a = n / 2 - 1), m = o(p = h * i2), d = s(p), t2[i2] = u[a] + m * l[a] - d * f2[a], r[i2] = c2[a] + m * f2[a] + d * l[a];
      }
    }, numeric._ifftpow2 = function e2(t2, r) {
      var n = t2.length;
      if (1 !== n) {
        var i2, a, o = Math.cos, s = Math.sin, u = Array(n / 2), c2 = Array(n / 2), l = Array(n / 2), f2 = Array(n / 2);
        for (a = n / 2, i2 = n - 1; -1 !== i2; --i2) l[--a] = t2[i2], f2[a] = r[i2], --i2, u[a] = t2[i2], c2[a] = r[i2];
        e2(u, c2), e2(l, f2), a = n / 2;
        var p, m, d, h = 6.283185307179586 / n;
        for (i2 = n - 1; -1 !== i2; --i2) -1 === --a && (a = n / 2 - 1), m = o(p = h * i2), d = s(p), t2[i2] = u[a] + m * l[a] - d * f2[a], r[i2] = c2[a] + m * f2[a] + d * l[a];
      }
    }, numeric.ifftpow2 = function(e2, t2) {
      numeric._ifftpow2(e2, t2), numeric.diveq(e2, e2.length), numeric.diveq(t2, t2.length);
    }, numeric.convpow2 = function(e2, t2, r, n) {
      var i2, a, o, s, u;
      for (numeric.fftpow2(e2, t2), numeric.fftpow2(r, n), i2 = e2.length - 1; -1 !== i2; --i2) a = e2[i2], s = t2[i2], o = r[i2], u = n[i2], e2[i2] = a * o - s * u, t2[i2] = a * u + s * o;
      numeric.ifftpow2(e2, t2);
    }, numeric.T.prototype.fft = function() {
      var e2, t2, r = this.x, n = this.y, i2 = r.length, a = Math.log, o = a(2), s = Math.ceil(a(2 * i2 - 1) / o), u = Math.pow(2, s), c2 = numeric.rep([u], 0), l = numeric.rep([u], 0), f2 = Math.cos, p = Math.sin, m = -3.141592653589793 / i2, d = numeric.rep([u], 0), h = numeric.rep([u], 0);
      for (e2 = 0; e2 < i2; e2++) d[e2] = r[e2];
      if (void 0 !== n) for (e2 = 0; e2 < i2; e2++) h[e2] = n[e2];
      for (c2[0] = 1, e2 = 1; e2 <= u / 2; e2++) t2 = m * e2 * e2, c2[e2] = f2(t2), l[e2] = p(t2), c2[u - e2] = f2(t2), l[u - e2] = p(t2);
      var g = new numeric.T(d, h), y = new numeric.T(c2, l);
      return g = g.mul(y), numeric.convpow2(g.x, g.y, numeric.clone(y.x), numeric.neg(y.y)), (g = g.mul(y)).x.length = i2, g.y.length = i2, g;
    }, numeric.T.prototype.ifft = function() {
      var e2, t2, r = this.x, n = this.y, i2 = r.length, a = Math.log, o = a(2), s = Math.ceil(a(2 * i2 - 1) / o), u = Math.pow(2, s), c2 = numeric.rep([u], 0), l = numeric.rep([u], 0), f2 = Math.cos, p = Math.sin, m = 3.141592653589793 / i2, d = numeric.rep([u], 0), h = numeric.rep([u], 0);
      for (e2 = 0; e2 < i2; e2++) d[e2] = r[e2];
      if (void 0 !== n) for (e2 = 0; e2 < i2; e2++) h[e2] = n[e2];
      for (c2[0] = 1, e2 = 1; e2 <= u / 2; e2++) t2 = m * e2 * e2, c2[e2] = f2(t2), l[e2] = p(t2), c2[u - e2] = f2(t2), l[u - e2] = p(t2);
      var g = new numeric.T(d, h), y = new numeric.T(c2, l);
      return g = g.mul(y), numeric.convpow2(g.x, g.y, numeric.clone(y.x), numeric.neg(y.y)), (g = g.mul(y)).x.length = i2, g.y.length = i2, g.div(i2);
    }, numeric.gradient = function(e2, t2) {
      var r = t2.length, n = e2(t2);
      if (isNaN(n)) throw new Error("gradient: f(x) is a NaN!");
      var i2, a, o, s = Math.max, u = numeric.clone(t2), c2 = Array(r);
      numeric.div, numeric.sub;
      s = Math.max;
      var l, f2, p, m, d, h, g = Math.abs, y = Math.min, v2 = 0;
      for (i2 = 0; i2 < r; i2++) for (var x2 = s(1e-6 * n, 1e-8); ; ) {
        if (++v2 > 20) throw new Error("Numerical gradient fails");
        if (u[i2] = t2[i2] + x2, a = e2(u), u[i2] = t2[i2] - x2, o = e2(u), u[i2] = t2[i2], isNaN(a) || isNaN(o)) x2 /= 16;
        else {
          if (c2[i2] = (a - o) / (2 * x2), l = t2[i2] - x2, f2 = t2[i2], p = t2[i2] + x2, m = (a - n) / x2, d = (n - o) / x2, h = s(g(c2[i2]), g(n), g(a), g(o), g(l), g(f2), g(p), 1e-8), !(y(s(g(m - c2[i2]), g(d - c2[i2]), g(m - d)) / h, x2 / h) > 1e-3)) break;
          x2 /= 16;
        }
      }
      return c2;
    }, numeric.uncmin = function(e2, t2, r, n, i2, a, o) {
      var s = numeric.gradient;
      void 0 === o && (o = {}), void 0 === r && (r = 1e-8), void 0 === n && (n = function(t3) {
        return s(e2, t3);
      }), void 0 === i2 && (i2 = 1e3);
      var u, c2, l = (t2 = numeric.clone(t2)).length, f2 = e2(t2);
      if (isNaN(f2)) throw new Error("uncmin: f(x0) is a NaN!");
      var p = Math.max, m = numeric.norm2;
      r = p(r, numeric.epsilon);
      var d, h, g, y = o.Hinv || numeric.identity(l), v2 = numeric.dot;
      numeric.inv;
      var x2, b2, _2, w2, A2, N, D, E = numeric.sub, $2 = numeric.add, S2 = numeric.tensor, C2 = numeric.div, M2 = numeric.mul, T2 = numeric.all, F = numeric.isFinite, O2 = numeric.neg, k2 = 0, B2 = "";
      for (h = n(t2); k2 < i2; ) {
        if ("function" == typeof a && a(k2, t2, f2, h, y)) {
          B2 = "Callback returned true";
          break;
        }
        if (!T2(F(h))) {
          B2 = "Gradient has Infinity or NaN";
          break;
        }
        if (!T2(F(d = O2(v2(y, h))))) {
          B2 = "Search direction has Infinity or NaN";
          break;
        }
        if ((D = m(d)) < r) {
          B2 = "Newton step smaller than tol";
          break;
        }
        for (N = 1, c2 = v2(h, d), b2 = t2; k2 < i2 && !(N * D < r) && (b2 = $2(t2, x2 = M2(d, N)), (u = e2(b2)) - f2 >= 0.1 * N * c2 || isNaN(u)); ) N *= 0.5, ++k2;
        if (N * D < r) {
          B2 = "Line search step size smaller than tol";
          break;
        }
        if (k2 === i2) {
          B2 = "maxit reached during line search";
          break;
        }
        A2 = v2(_2 = E(g = n(b2), h), x2), w2 = v2(y, _2), y = E($2(y, M2((A2 + v2(_2, w2)) / (A2 * A2), S2(x2, x2))), C2($2(S2(w2, x2), S2(x2, w2)), A2)), t2 = b2, f2 = u, h = g, ++k2;
      }
      return { solution: t2, f: f2, gradient: h, invHessian: y, iterations: k2, message: B2 };
    }, numeric.Dopri = function(e2, t2, r, n, i2, a, o) {
      this.x = e2, this.y = t2, this.f = r, this.ymid = n, this.iterations = i2, this.events = o, this.message = a;
    }, numeric.Dopri.prototype._at = function(e2, t2) {
      function r(e3) {
        return e3 * e3;
      }
      var n, i2, a, o, s, u, c2 = this, l = c2.x, f2 = c2.y, p = c2.f, m = c2.ymid;
      l.length;
      var d, h, g, y = numeric.add, v2 = numeric.mul, x2 = numeric.sub;
      return n = l[t2], i2 = l[t2 + 1], o = f2[t2], s = f2[t2 + 1], a = n + 0.5 * (i2 - n), u = m[t2], d = x2(p[t2], v2(o, 1 / (n - a) + 2 / (n - i2))), h = x2(p[t2 + 1], v2(s, 1 / (i2 - a) + 2 / (i2 - n))), y(y(y(y(v2(o, (g = [r(e2 - i2) * (e2 - a) / r(n - i2) / (n - a), r(e2 - n) * r(e2 - i2) / r(n - a) / r(i2 - a), r(e2 - n) * (e2 - a) / r(i2 - n) / (i2 - a), (e2 - n) * r(e2 - i2) * (e2 - a) / r(n - i2) / (n - a), (e2 - i2) * r(e2 - n) * (e2 - a) / r(n - i2) / (i2 - a)])[0]), v2(u, g[1])), v2(s, g[2])), v2(d, g[3])), v2(h, g[4]));
    }, numeric.Dopri.prototype.at = function(e2) {
      var t2, r, n, i2 = Math.floor;
      if ("number" != typeof e2) {
        var a = e2.length, o = Array(a);
        for (t2 = a - 1; -1 !== t2; --t2) o[t2] = this.at(e2[t2]);
        return o;
      }
      var s = this.x;
      for (t2 = 0, r = s.length - 1; r - t2 > 1; ) s[n = i2(0.5 * (t2 + r))] <= e2 ? t2 = n : r = n;
      return this._at(e2, t2);
    }, numeric.dopri = function(e2, t2, r, n, i2, a, o) {
      void 0 === i2 && (i2 = 1e-6), void 0 === a && (a = 1e3);
      var s, u, c2, l, f2, p, m, d, h, g, y, v2, x2, b2 = [e2], _2 = [r], w2 = [n(e2, r)], A2 = [], N = [3 / 40, 9 / 40], D = [44 / 45, -56 / 15, 32 / 9], E = [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], $2 = [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], S2 = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84], C2 = [0.10013431883002395, 0, 0.3918321794184259, -0.02982460176594817, 0.05893268337240795, -0.04497888809104361, 56185495e-1 / 235043384], M2 = [0.2, 0.3, 0.8, 8 / 9, 1, 1], T2 = [-71 / 57600, 0, 71 / 16695, -71 / 1920, 17253 / 339200, -22 / 525, 1 / 40], F = 0, O2 = (t2 - e2) / 10, k2 = 0, B2 = numeric.add, I2 = numeric.mul, R2 = Math.min, q2 = Math.abs, z2 = numeric.norminf, P2 = Math.pow, L2 = numeric.any, j2 = numeric.lt, U2 = numeric.and;
      numeric.sub;
      var Z2 = new numeric.Dopri(b2, _2, w2, A2, -1, "");
      for ("function" == typeof o && (y = o(e2, r)); e2 < t2 && k2 < a; ) if (++k2, e2 + O2 > t2 && (O2 = t2 - e2), s = n(e2 + M2[0] * O2, B2(r, I2(0.2 * O2, w2[F]))), u = n(e2 + M2[1] * O2, B2(B2(r, I2(N[0] * O2, w2[F])), I2(N[1] * O2, s))), c2 = n(e2 + M2[2] * O2, B2(B2(B2(r, I2(D[0] * O2, w2[F])), I2(D[1] * O2, s)), I2(D[2] * O2, u))), l = n(e2 + M2[3] * O2, B2(B2(B2(B2(r, I2(E[0] * O2, w2[F])), I2(E[1] * O2, s)), I2(E[2] * O2, u)), I2(E[3] * O2, c2))), f2 = n(e2 + M2[4] * O2, B2(B2(B2(B2(B2(r, I2($2[0] * O2, w2[F])), I2($2[1] * O2, s)), I2($2[2] * O2, u)), I2($2[3] * O2, c2)), I2($2[4] * O2, l))), p = n(e2 + O2, h = B2(B2(B2(B2(B2(r, I2(w2[F], O2 * S2[0])), I2(u, O2 * S2[2])), I2(c2, O2 * S2[3])), I2(l, O2 * S2[4])), I2(f2, O2 * S2[5]))), (g = "number" == typeof (m = B2(B2(B2(B2(B2(I2(w2[F], O2 * T2[0]), I2(u, O2 * T2[2])), I2(c2, O2 * T2[3])), I2(l, O2 * T2[4])), I2(f2, O2 * T2[5])), I2(p, O2 * T2[6]))) ? q2(m) : z2(m)) > i2) {
        if (e2 + (O2 = 0.2 * O2 * P2(i2 / g, 0.25)) === e2) {
          Z2.msg = "Step size became too small";
          break;
        }
      } else {
        if (A2[F] = B2(B2(B2(B2(B2(B2(r, I2(w2[F], O2 * C2[0])), I2(u, O2 * C2[2])), I2(c2, O2 * C2[3])), I2(l, O2 * C2[4])), I2(f2, O2 * C2[5])), I2(p, O2 * C2[6])), b2[++F] = e2 + O2, _2[F] = h, w2[F] = p, "function" == typeof o) {
          var G2, V2, H2 = e2, X2 = e2 + 0.5 * O2;
          if (v2 = o(X2, A2[F - 1]), L2(x2 = U2(j2(y, 0), j2(0, v2))) || (H2 = X2, y = v2, v2 = o(X2 = e2 + O2, h), x2 = U2(j2(y, 0), j2(0, v2))), L2(x2)) {
            for (var W2, Q2, Y2 = 0, J = 1, K2 = 1; ; ) {
              if ("number" == typeof y) V2 = (K2 * v2 * H2 - J * y * X2) / (K2 * v2 - J * y);
              else for (V2 = X2, d = y.length - 1; -1 !== d; --d) y[d] < 0 && v2[d] > 0 && (V2 = R2(V2, (K2 * v2[d] * H2 - J * y[d] * X2) / (K2 * v2[d] - J * y[d])));
              if (V2 <= H2 || V2 >= X2) break;
              Q2 = o(V2, G2 = Z2._at(V2, F - 1)), L2(W2 = U2(j2(y, 0), j2(0, Q2))) ? (X2 = V2, v2 = Q2, x2 = W2, K2 = 1, -1 === Y2 ? J *= 0.5 : J = 1, Y2 = -1) : (H2 = V2, y = Q2, J = 1, 1 === Y2 ? K2 *= 0.5 : K2 = 1, Y2 = 1);
            }
            return h = Z2._at(0.5 * (e2 + V2), F - 1), Z2.f[F] = n(V2, G2), Z2.x[F] = V2, Z2.y[F] = G2, Z2.ymid[F - 1] = h, Z2.events = x2, Z2.iterations = k2, Z2;
          }
        }
        e2 += O2, r = h, y = v2, O2 = R2(0.8 * O2 * P2(i2 / g, 0.25), 4 * O2);
      }
      return Z2.iterations = k2, Z2;
    }, numeric.LU = function(e2, t2) {
      t2 = t2 || false;
      var r, n, i2, a, o, s, u, c2, l, f2 = Math.abs, p = e2.length, m = p - 1, d = new Array(p);
      for (t2 || (e2 = numeric.clone(e2)), i2 = 0; i2 < p; ++i2) {
        for (u = i2, l = f2((s = e2[i2])[i2]), n = i2 + 1; n < p; ++n) l < (a = f2(e2[n][i2])) && (l = a, u = n);
        for (d[i2] = u, u != i2 && (e2[i2] = e2[u], e2[u] = s, s = e2[i2]), o = s[i2], r = i2 + 1; r < p; ++r) e2[r][i2] /= o;
        for (r = i2 + 1; r < p; ++r) {
          for (c2 = e2[r], n = i2 + 1; n < m; ++n) c2[n] -= c2[i2] * s[n], c2[++n] -= c2[i2] * s[n];
          n === m && (c2[n] -= c2[i2] * s[n]);
        }
      }
      return { LU: e2, P: d };
    }, numeric.LUsolve = function(e2, t2) {
      var r, n, i2, a, o, s = e2.LU, u = s.length, c2 = numeric.clone(t2), l = e2.P;
      for (r = u - 1; -1 !== r; --r) c2[r] = t2[r];
      for (r = 0; r < u; ++r) for (i2 = l[r], l[r] !== r && (o = c2[r], c2[r] = c2[i2], c2[i2] = o), a = s[r], n = 0; n < r; ++n) c2[r] -= c2[n] * a[n];
      for (r = u - 1; r >= 0; --r) {
        for (a = s[r], n = r + 1; n < u; ++n) c2[r] -= c2[n] * a[n];
        c2[r] /= a[r];
      }
      return c2;
    }, numeric.solve = function(e2, t2, r) {
      return numeric.LUsolve(numeric.LU(e2, r), t2);
    }, numeric.echelonize = function(e2) {
      var t2, r, n, i2, a, o, s, u, c2 = numeric.dim(e2), l = c2[0], f2 = c2[1], p = numeric.identity(l), m = Array(l), d = Math.abs, h = numeric.diveq;
      for (e2 = numeric.clone(e2), t2 = 0; t2 < l; ++t2) {
        for (n = 0, a = e2[t2], o = p[t2], r = 1; r < f2; ++r) d(a[n]) < d(a[r]) && (n = r);
        for (m[t2] = n, h(o, a[n]), h(a, a[n]), r = 0; r < l; ++r) if (r !== t2) {
          for (u = (s = e2[r])[n], i2 = f2 - 1; -1 !== i2; --i2) s[i2] -= a[i2] * u;
          for (s = p[r], i2 = l - 1; -1 !== i2; --i2) s[i2] -= o[i2] * u;
        }
      }
      return { I: p, A: e2, P: m };
    }, numeric.__solveLP = function(e2, t2, r, n, i2, a, o) {
      var s = numeric.sum;
      numeric.log;
      var u, c2 = numeric.mul, l = numeric.sub, f2 = numeric.dot, p = numeric.div, m = numeric.add, d = e2.length, h = r.length, g = false, y = 1;
      numeric.transpose(t2), numeric.svd;
      var v2 = numeric.transpose;
      numeric.leq;
      var x2 = Math.sqrt, b2 = Math.abs;
      numeric.muleq, numeric.norminf, numeric.any;
      var _2, w2 = Math.min, A2 = numeric.all, N = numeric.gt, D = Array(d), E = Array(h);
      numeric.rep([h], 1);
      var $2, S2, C2 = numeric.solve, M2 = l(r, f2(t2, a)), T2 = f2(e2, e2);
      for ($2 = 0; $2 < i2; ++$2) {
        var F, O2;
        for (F = h - 1; -1 !== F; --F) E[F] = p(t2[F], M2[F]);
        var k2 = v2(E);
        for (F = d - 1; -1 !== F; --F) D[F] = s(k2[F]);
        y = 0.25 * b2(T2 / f2(e2, D));
        var B2 = 100 * x2(T2 / f2(D, D));
        for ((!isFinite(y) || y > B2) && (y = B2), S2 = m(e2, c2(y, D)), _2 = f2(k2, E), F = d - 1; -1 !== F; --F) _2[F][F] += 1;
        O2 = C2(_2, p(S2, y), true);
        var I2 = p(M2, f2(t2, O2)), R2 = 1;
        for (F = h - 1; -1 !== F; --F) I2[F] < 0 && (R2 = w2(R2, -0.999 * I2[F]));
        if (u = l(a, c2(O2, R2)), !A2(N(M2 = l(r, f2(t2, u)), 0))) return { solution: a, message: "", iterations: $2 };
        if (a = u, y < n) return { solution: u, message: "", iterations: $2 };
        if (o) {
          var q2 = f2(e2, S2), z2 = f2(t2, S2);
          for (g = true, F = h - 1; -1 !== F; --F) if (q2 * z2[F] < 0) {
            g = false;
            break;
          }
        } else g = !(a[d - 1] >= 0);
        if (g) return { solution: u, message: "Unbounded", iterations: $2 };
      }
      return { solution: a, message: "maximum iteration count exceeded", iterations: $2 };
    }, numeric._solveLP = function(e2, t2, r, n, i2) {
      var a = e2.length, o = r.length;
      numeric.sum, numeric.log, numeric.mul;
      var s = numeric.sub, u = numeric.dot;
      numeric.div, numeric.add;
      var c2 = numeric.rep([a], 0).concat([1]), l = numeric.rep([o, 1], -1), f2 = numeric.blockMatrix([[t2, l]]), p = r, m = numeric.rep([a], 0).concat(Math.max(0, numeric.sup(numeric.neg(r))) + 1), d = numeric.__solveLP(c2, f2, p, n, i2, m, false), h = numeric.clone(d.solution);
      if (h.length = a, numeric.inf(s(r, u(t2, h))) < 0) return { solution: NaN, message: "Infeasible", iterations: d.iterations };
      var g = numeric.__solveLP(e2, t2, r, n, i2 - d.iterations, h, true);
      return g.iterations += d.iterations, g;
    }, numeric.solveLP = function(e2, t2, r, n, i2, a, o) {
      if (void 0 === o && (o = 1e3), void 0 === a && (a = numeric.epsilon), void 0 === n) return numeric._solveLP(e2, t2, r, a, o);
      var s, u = n.length, c2 = n[0].length, l = t2.length, f2 = numeric.echelonize(n), p = numeric.rep([c2], 0), m = f2.P, d = [];
      for (s = m.length - 1; -1 !== s; --s) p[m[s]] = 1;
      for (s = c2 - 1; -1 !== s; --s) 0 === p[s] && d.push(s);
      var h = numeric.getRange, g = numeric.linspace(0, u - 1), y = numeric.linspace(0, l - 1), v2 = h(n, g, d), x2 = h(t2, y, m), b2 = h(t2, y, d), _2 = numeric.dot, w2 = numeric.sub, A2 = _2(x2, f2.I), N = w2(b2, _2(A2, v2)), D = w2(r, _2(A2, i2)), E = Array(m.length), $2 = Array(d.length);
      for (s = m.length - 1; -1 !== s; --s) E[s] = e2[m[s]];
      for (s = d.length - 1; -1 !== s; --s) $2[s] = e2[d[s]];
      var S2 = w2($2, _2(E, _2(f2.I, v2))), C2 = numeric._solveLP(S2, N, D, a, o), M2 = C2.solution;
      if (M2 != M2) return C2;
      var T2 = _2(f2.I, w2(i2, _2(v2, M2))), F = Array(e2.length);
      for (s = m.length - 1; -1 !== s; --s) F[m[s]] = T2[s];
      for (s = d.length - 1; -1 !== s; --s) F[d[s]] = M2[s];
      return { solution: F, message: C2.message, iterations: C2.iterations };
    }, numeric.MPStoLP = function(e2) {
      e2 instanceof String && e2.split("\n");
      var t2, r, n, i2, a = 0, o = ["Initial state", "NAME", "ROWS", "COLUMNS", "RHS", "BOUNDS", "ENDATA"], s = e2.length, u = 0, c2 = {}, l = [], f2 = 0, p = {}, m = 0, d = [], h = [], g = [];
      function y(r2) {
        throw new Error("MPStoLP: " + r2 + "\nLine " + t2 + ": " + e2[t2] + "\nCurrent state: " + o[a] + "\n");
      }
      for (t2 = 0; t2 < s; ++t2) {
        var v2 = (n = e2[t2]).match(/\S*/g), x2 = [];
        for (r = 0; r < v2.length; ++r) "" !== v2[r] && x2.push(v2[r]);
        if (0 !== x2.length) {
          for (r = 0; r < o.length && n.substr(0, o[r].length) !== o[r]; ++r) ;
          if (r < o.length) {
            if (a = r, 1 === r && (i2 = x2[1]), 6 === r) return { name: i2, c: d, A: numeric.transpose(h), b: g, rows: c2, vars: p };
          } else switch (a) {
            case 0:
            case 1:
              y("Unexpected line");
            case 2:
              switch (x2[0]) {
                case "N":
                  0 === u ? u = x2[1] : y("Two or more N rows");
                  break;
                case "L":
                  c2[x2[1]] = f2, l[f2] = 1, g[f2] = 0, ++f2;
                  break;
                case "G":
                  c2[x2[1]] = f2, l[f2] = -1, g[f2] = 0, ++f2;
                  break;
                case "E":
                  c2[x2[1]] = f2, l[f2] = 0, g[f2] = 0, ++f2;
                  break;
                default:
                  y("Parse error " + numeric.prettyPrint(x2));
              }
              break;
            case 3:
              p.hasOwnProperty(x2[0]) || (p[x2[0]] = m, d[m] = 0, h[m] = numeric.rep([f2], 0), ++m);
              var b2 = p[x2[0]];
              for (r = 1; r < x2.length; r += 2) if (x2[r] !== u) {
                var _2 = c2[x2[r]];
                h[b2][_2] = (l[_2] < 0 ? -1 : 1) * parseFloat(x2[r + 1]);
              } else d[b2] = parseFloat(x2[r + 1]);
              break;
            case 4:
              for (r = 1; r < x2.length; r += 2) g[c2[x2[r]]] = (l[c2[x2[r]]] < 0 ? -1 : 1) * parseFloat(x2[r + 1]);
              break;
            case 5:
              break;
            case 6:
              y("Internal error");
          }
        }
      }
      y("Reached end of file without ENDATA");
    }, numeric.seedrandom = { pow: Math.pow, random: Math.random }, (function(e2, t2, r, n, i2, a, o) {
      function s(e3) {
        var t3, n3, i3 = this, a2 = e3.length, o2 = 0, s2 = i3.i = i3.j = i3.m = 0;
        for (i3.S = [], i3.c = [], a2 || (e3 = [a2++]); o2 < r; ) i3.S[o2] = o2++;
        for (o2 = 0; o2 < r; o2++) s2 = l(s2 + (t3 = i3.S[o2]) + e3[o2 % a2]), n3 = i3.S[s2], i3.S[o2] = n3, i3.S[s2] = t3;
        i3.g = function(e4) {
          var t4 = i3.S, n4 = l(i3.i + 1), a3 = t4[n4], o3 = l(i3.j + a3), s3 = t4[o3];
          t4[n4] = s3, t4[o3] = a3;
          for (var u2 = t4[l(a3 + s3)]; --e4; ) n4 = l(n4 + 1), s3 = t4[o3 = l(o3 + (a3 = t4[n4]))], t4[n4] = s3, t4[o3] = a3, u2 = u2 * r + t4[l(a3 + s3)];
          return i3.i = n4, i3.j = o3, u2;
        }, i3.g(r);
      }
      function u(e3, t3, r2, n3, i3) {
        if (r2 = [], i3 = typeof e3, t3 && "object" == i3) {
          for (n3 in e3) if (n3.indexOf("S") < 5) try {
            r2.push(u(e3[n3], t3 - 1));
          } catch (e4) {
          }
        }
        return r2.length ? r2 : e3 + ("string" != i3 ? "\0" : "");
      }
      function c2(e3, t3, r2, n3) {
        for (e3 += "", r2 = 0, n3 = 0; n3 < e3.length; n3++) t3[l(n3)] = l((r2 ^= 19 * t3[l(n3)]) + e3.charCodeAt(n3));
        for (n3 in e3 = "", t3) e3 += String.fromCharCode(t3[n3]);
        return e3;
      }
      function l(e3) {
        return 255 & e3;
      }
      t2.seedrandom = function(n3, l2) {
        var f2, p = [];
        return n3 = c2(u(l2 ? [n3, e2] : arguments.length ? n3 : [(/* @__PURE__ */ new Date()).getTime(), e2, window], 3), p), c2((f2 = new s(p)).S, e2), t2.random = function() {
          for (var e3 = f2.g(6), t3 = o, n4 = 0; e3 < i2; ) e3 = (e3 + n4) * r, t3 *= r, n4 = f2.g(1);
          for (; e3 >= a; ) e3 /= 2, t3 /= 2, n4 >>>= 1;
          return (e3 + n4) / t3;
        }, n3;
      }, o = t2.pow(r, 6), i2 = t2.pow(2, i2), a = 2 * i2, c2(t2.random(), e2);
    })([], numeric.seedrandom, 256, 0, 52), (function(e2) {
      function t2(e3) {
        if ("object" != typeof e3) return e3;
        var r2, n3 = [], i2 = e3.length;
        for (r2 = 0; r2 < i2; r2++) n3[r2 + 1] = t2(e3[r2]);
        return n3;
      }
      function r(e3) {
        if ("object" != typeof e3) return e3;
        var t3, n3 = [], i2 = e3.length;
        for (t3 = 1; t3 < i2; t3++) n3[t3 - 1] = r(e3[t3]);
        return n3;
      }
      function n(e3, t3, r2, n3, i2, a, o, s, u, c2, l, f2, p, m, d, h) {
        var g, y, v2, x2, b2, _2, w2, A2, N, D, E, $2, S2, C2, M2, T2, F, O2, k2, B2, I2, R2, q2, z2, P2, L2, j2;
        S2 = Math.min(n3, c2), v2 = 2 * n3 + S2 * (S2 + 5) / 2 + 2 * c2 + 1, z2 = 1e-60;
        do {
          P2 = 1 + 0.1 * (z2 += z2), L2 = 1 + 0.2 * z2;
        } while (P2 <= 1 || L2 <= 1);
        for (g = 1; g <= n3; g += 1) d[g] = t3[g];
        for (g = n3 + 1; g <= v2; g += 1) d[g] = 0;
        for (g = 1; g <= c2; g += 1) f2[g] = 0;
        if (b2 = [], 0 === h[1]) {
          if ((function(e4, t4, r3, n4) {
            var i3, a2, o2, s2, u2, c3;
            for (a2 = 1; a2 <= r3; a2 += 1) {
              if (n4[1] = a2, c3 = 0, (o2 = a2 - 1) < 1) {
                if ((c3 = e4[a2][a2] - c3) <= 0) break;
                e4[a2][a2] = Math.sqrt(c3);
              } else {
                for (s2 = 1; s2 <= o2; s2 += 1) {
                  for (u2 = e4[s2][a2], i3 = 1; i3 < s2; i3 += 1) u2 -= e4[i3][a2] * e4[i3][s2];
                  u2 /= e4[s2][s2], e4[s2][a2] = u2, c3 += u2 * u2;
                }
                if ((c3 = e4[a2][a2] - c3) <= 0) break;
                e4[a2][a2] = Math.sqrt(c3);
              }
              n4[1] = 0;
            }
          })(e3, 0, n3, b2), 0 !== b2[1]) return void (h[1] = 2);
          !(function(e4, t4, r3, n4) {
            var i3, a2, o2, s2;
            for (a2 = 1; a2 <= r3; a2 += 1) {
              for (s2 = 0, i3 = 1; i3 < a2; i3 += 1) s2 += e4[i3][a2] * n4[i3];
              n4[a2] = (n4[a2] - s2) / e4[a2][a2];
            }
            for (o2 = 1; o2 <= r3; o2 += 1) for (n4[a2 = r3 + 1 - o2] = n4[a2] / e4[a2][a2], s2 = -n4[a2], i3 = 1; i3 < a2; i3 += 1) n4[i3] = n4[i3] + s2 * e4[i3][a2];
          })(e3, 0, n3, t3), (function(e4, t4, r3) {
            var n4, i3, a2, o2, s2;
            for (a2 = 1; a2 <= r3; a2 += 1) {
              for (e4[a2][a2] = 1 / e4[a2][a2], s2 = -e4[a2][a2], n4 = 1; n4 < a2; n4 += 1) e4[n4][a2] = s2 * e4[n4][a2];
              if (r3 < (o2 = a2 + 1)) break;
              for (i3 = o2; i3 <= r3; i3 += 1) for (s2 = e4[a2][i3], e4[a2][i3] = 0, n4 = 1; n4 <= a2; n4 += 1) e4[n4][i3] = e4[n4][i3] + s2 * e4[n4][a2];
            }
          })(e3, 0, n3);
        } else {
          for (y = 1; y <= n3; y += 1) for (i2[y] = 0, g = 1; g <= y; g += 1) i2[y] = i2[y] + e3[g][y] * t3[g];
          for (y = 1; y <= n3; y += 1) for (t3[y] = 0, g = y; g <= n3; g += 1) t3[y] = t3[y] + e3[y][g] * i2[g];
        }
        for (a[1] = 0, y = 1; y <= n3; y += 1) for (i2[y] = t3[y], a[1] = a[1] + d[y] * i2[y], d[y] = 0, g = y + 1; g <= n3; g += 1) e3[g][y] = 0;
        for (a[1] = -a[1] / 2, h[1] = 0, C2 = (D = (N = (E = (A2 = (w2 = n3) + n3) + S2) + S2 + 1) + S2 * (S2 + 1) / 2) + c2, g = 1; g <= c2; g += 1) {
          for (T2 = 0, y = 1; y <= n3; y += 1) T2 += o[y][g] * o[y][g];
          d[C2 + g] = Math.sqrt(T2);
        }
        function U2() {
          for (m[1] = m[1] + 1, v2 = D, g = 1; g <= c2; g += 1) {
            for (v2 += 1, T2 = -s[g], y = 1; y <= n3; y += 1) T2 += o[y][g] * i2[y];
            if (Math.abs(T2) < z2 && (T2 = 0), g > l) d[v2] = T2;
            else if (d[v2] = -Math.abs(T2), T2 > 0) {
              for (y = 1; y <= n3; y += 1) o[y][g] = -o[y][g];
              s[g] = -s[g];
            }
          }
          for (g = 1; g <= p; g += 1) d[D + f2[g]] = 0;
          for ($2 = 0, M2 = 0, g = 1; g <= c2; g += 1) d[D + g] < M2 * d[C2 + g] && ($2 = g, M2 = d[D + g] / d[C2 + g]);
          return 0 === $2 ? 999 : 0;
        }
        function Z2() {
          for (g = 1; g <= n3; g += 1) {
            for (T2 = 0, y = 1; y <= n3; y += 1) T2 += e3[y][g] * o[y][$2];
            d[g] = T2;
          }
          for (x2 = w2, g = 1; g <= n3; g += 1) d[x2 + g] = 0;
          for (y = p + 1; y <= n3; y += 1) for (g = 1; g <= n3; g += 1) d[x2 + g] = d[x2 + g] + e3[g][y] * d[y];
          for (R2 = true, g = p; g >= 1; g -= 1) {
            for (T2 = d[g], x2 = (v2 = N + g * (g + 3) / 2) - g, y = g + 1; y <= p; y += 1) T2 -= d[v2] * d[A2 + y], v2 += y;
            if (T2 /= d[x2], d[A2 + g] = T2, f2[g] < l) break;
            if (T2 < 0) break;
            R2 = false, _2 = g;
          }
          if (!R2) for (F = d[E + _2] / d[A2 + _2], g = 1; g <= p && !(f2[g] < l) && !(d[A2 + g] < 0); g += 1) (M2 = d[E + g] / d[A2 + g]) < F && (F = M2, _2 = g);
          for (T2 = 0, g = w2 + 1; g <= w2 + n3; g += 1) T2 += d[g] * d[g];
          if (Math.abs(T2) <= z2) {
            if (R2) return h[1] = 1, 999;
            for (g = 1; g <= p; g += 1) d[E + g] = d[E + g] - F * d[A2 + g];
            return d[E + p + 1] = d[E + p + 1] + F, 700;
          }
          for (T2 = 0, g = 1; g <= n3; g += 1) T2 += d[w2 + g] * o[g][$2];
          for (O2 = -d[D + $2] / T2, q2 = true, R2 || F < O2 && (O2 = F, q2 = false), g = 1; g <= n3; g += 1) i2[g] = i2[g] + O2 * d[w2 + g], Math.abs(i2[g]) < z2 && (i2[g] = 0);
          for (a[1] = a[1] + O2 * T2 * (O2 / 2 + d[E + p + 1]), g = 1; g <= p; g += 1) d[E + g] = d[E + g] - O2 * d[A2 + g];
          if (d[E + p + 1] = d[E + p + 1] + O2, !q2) {
            for (T2 = -s[$2], y = 1; y <= n3; y += 1) T2 += i2[y] * o[y][$2];
            if ($2 > l) d[D + $2] = T2;
            else if (d[D + $2] = -Math.abs(T2), T2 > 0) {
              for (y = 1; y <= n3; y += 1) o[y][$2] = -o[y][$2];
              s[$2] = -s[$2];
            }
            return 700;
          }
          for (f2[p += 1] = $2, v2 = N + (p - 1) * p / 2 + 1, g = 1; g <= p - 1; g += 1) d[v2] = d[g], v2 += 1;
          if (p === n3) d[v2] = d[n3];
          else {
            for (g = n3; g >= p + 1 && 0 !== d[g] && (k2 = Math.max(Math.abs(d[g - 1]), Math.abs(d[g])), B2 = Math.min(Math.abs(d[g - 1]), Math.abs(d[g])), M2 = d[g - 1] >= 0 ? Math.abs(k2 * Math.sqrt(1 + B2 * B2 / (k2 * k2))) : -Math.abs(k2 * Math.sqrt(1 + B2 * B2 / (k2 * k2))), k2 = d[g - 1] / M2, B2 = d[g] / M2, 1 !== k2); g -= 1) if (0 === k2) for (d[g - 1] = B2 * M2, y = 1; y <= n3; y += 1) M2 = e3[y][g - 1], e3[y][g - 1] = e3[y][g], e3[y][g] = M2;
            else for (d[g - 1] = M2, I2 = B2 / (1 + k2), y = 1; y <= n3; y += 1) M2 = k2 * e3[y][g - 1] + B2 * e3[y][g], e3[y][g] = I2 * (e3[y][g - 1] + M2) - e3[y][g], e3[y][g - 1] = M2;
            d[v2] = d[p];
          }
          return 0;
        }
        function G2() {
          if (0 === d[x2 = (v2 = N + _2 * (_2 + 1) / 2 + 1) + _2]) return 798;
          if (k2 = Math.max(Math.abs(d[x2 - 1]), Math.abs(d[x2])), B2 = Math.min(Math.abs(d[x2 - 1]), Math.abs(d[x2])), M2 = d[x2 - 1] >= 0 ? Math.abs(k2 * Math.sqrt(1 + B2 * B2 / (k2 * k2))) : -Math.abs(k2 * Math.sqrt(1 + B2 * B2 / (k2 * k2))), k2 = d[x2 - 1] / M2, B2 = d[x2] / M2, 1 === k2) return 798;
          if (0 === k2) {
            for (g = _2 + 1; g <= p; g += 1) M2 = d[x2 - 1], d[x2 - 1] = d[x2], d[x2] = M2, x2 += g;
            for (g = 1; g <= n3; g += 1) M2 = e3[g][_2], e3[g][_2] = e3[g][_2 + 1], e3[g][_2 + 1] = M2;
          } else {
            for (I2 = B2 / (1 + k2), g = _2 + 1; g <= p; g += 1) M2 = k2 * d[x2 - 1] + B2 * d[x2], d[x2] = I2 * (d[x2 - 1] + M2) - d[x2], d[x2 - 1] = M2, x2 += g;
            for (g = 1; g <= n3; g += 1) M2 = k2 * e3[g][_2] + B2 * e3[g][_2 + 1], e3[g][_2 + 1] = I2 * (e3[g][_2] + M2) - e3[g][_2 + 1], e3[g][_2] = M2;
          }
          return 0;
        }
        function V2() {
          for (x2 = v2 - _2, g = 1; g <= _2; g += 1) d[x2] = d[v2], v2 += 1, x2 += 1;
          return d[E + _2] = d[E + _2 + 1], f2[_2] = f2[_2 + 1], (_2 += 1) < p ? 797 : 0;
        }
        function H2() {
          return d[E + p] = d[E + p + 1], d[E + p + 1] = 0, f2[p] = 0, p -= 1, m[2] = m[2] + 1, 0;
        }
        for (p = 0, m[1] = 0, m[2] = 0, j2 = 0; ; ) {
          if (999 === (j2 = U2())) return;
          for (; 0 !== (j2 = Z2()); ) {
            if (999 === j2) return;
            if (700 === j2) if (_2 === p) H2();
            else {
              for (; G2(), 797 === (j2 = V2()); ) ;
              H2();
            }
          }
        }
      }
      e2.solveQP = function(e3, i2, a, o, s, u) {
        e3 = t2(e3), i2 = t2(i2), a = t2(a);
        var c2, l, f2, p, m, d = [], h = [], g = [], y = [], v2 = [];
        if (s = s || 0, u = u ? t2(u) : [void 0, 0], o = o ? t2(o) : [], l = e3.length - 1, f2 = a[1].length - 1, !o) for (c2 = 1; c2 <= f2; c2 += 1) o[c2] = 0;
        for (c2 = 1; c2 <= f2; c2 += 1) h[c2] = 0;
        for (p = Math.min(l, f2), c2 = 1; c2 <= l; c2 += 1) g[c2] = 0;
        for (d[1] = 0, c2 = 1; c2 <= 2 * l + p * (p + 5) / 2 + 2 * f2 + 1; c2 += 1) y[c2] = 0;
        for (c2 = 1; c2 <= 2; c2 += 1) v2[c2] = 0;
        return n(e3, i2, 0, l, g, d, a, o, 0, f2, s, h, 0, v2, y, u), m = "", 1 === u[1] && (m = "constraints are inconsistent, no solution!"), 2 === u[1] && (m = "matrix D in quadratic function is not positive definite!"), { solution: r(g), value: r(d), unconstrained_solution: r(i2), iterations: r(v2), iact: r(h), message: m };
      };
    })(numeric), numeric.svd = function(e2) {
      var t2, r = numeric.epsilon, n = 1e-64 / r, i2 = 0, a = 0, o = 0, s = 0, u = 0, c2 = numeric.clone(e2), l = c2.length, f2 = c2[0].length;
      if (l < f2) throw "Need more rows than columns";
      var p = new Array(f2), m = new Array(f2);
      for (a = 0; a < f2; a++) p[a] = m[a] = 0;
      var d = numeric.rep([f2, f2], 0);
      function h(e3, t3) {
        return (e3 = Math.abs(e3)) > (t3 = Math.abs(t3)) ? e3 * Math.sqrt(1 + t3 * t3 / e3 / e3) : 0 == t3 ? e3 : t3 * Math.sqrt(1 + e3 * e3 / t3 / t3);
      }
      var g = 0, y = 0, v2 = 0, x2 = 0, b2 = 0, _2 = 0, w2 = 0;
      for (a = 0; a < f2; a++) {
        for (p[a] = y, w2 = 0, u = a + 1, o = a; o < l; o++) w2 += c2[o][a] * c2[o][a];
        if (w2 <= n) y = 0;
        else for (g = c2[a][a], y = Math.sqrt(w2), g >= 0 && (y = -y), v2 = g * y - w2, c2[a][a] = g - y, o = u; o < f2; o++) {
          for (w2 = 0, s = a; s < l; s++) w2 += c2[s][a] * c2[s][o];
          for (g = w2 / v2, s = a; s < l; s++) c2[s][o] += g * c2[s][a];
        }
        for (m[a] = y, w2 = 0, o = u; o < f2; o++) w2 += c2[a][o] * c2[a][o];
        if (w2 <= n) y = 0;
        else {
          for (g = c2[a][a + 1], y = Math.sqrt(w2), g >= 0 && (y = -y), v2 = g * y - w2, c2[a][a + 1] = g - y, o = u; o < f2; o++) p[o] = c2[a][o] / v2;
          for (o = u; o < l; o++) {
            for (w2 = 0, s = u; s < f2; s++) w2 += c2[o][s] * c2[a][s];
            for (s = u; s < f2; s++) c2[o][s] += w2 * p[s];
          }
        }
        (b2 = Math.abs(m[a]) + Math.abs(p[a])) > x2 && (x2 = b2);
      }
      for (a = f2 - 1; -1 != a; a += -1) {
        if (0 != y) {
          for (v2 = y * c2[a][a + 1], o = u; o < f2; o++) d[o][a] = c2[a][o] / v2;
          for (o = u; o < f2; o++) {
            for (w2 = 0, s = u; s < f2; s++) w2 += c2[a][s] * d[s][o];
            for (s = u; s < f2; s++) d[s][o] += w2 * d[s][a];
          }
        }
        for (o = u; o < f2; o++) d[a][o] = 0, d[o][a] = 0;
        d[a][a] = 1, y = p[a], u = a;
      }
      for (a = f2 - 1; -1 != a; a += -1) {
        for (u = a + 1, y = m[a], o = u; o < f2; o++) c2[a][o] = 0;
        if (0 != y) {
          for (v2 = c2[a][a] * y, o = u; o < f2; o++) {
            for (w2 = 0, s = u; s < l; s++) w2 += c2[s][a] * c2[s][o];
            for (g = w2 / v2, s = a; s < l; s++) c2[s][o] += g * c2[s][a];
          }
          for (o = a; o < l; o++) c2[o][a] = c2[o][a] / y;
        } else for (o = a; o < l; o++) c2[o][a] = 0;
        c2[a][a] += 1;
      }
      for (r *= x2, s = f2 - 1; -1 != s; s += -1) for (var A2 = 0; A2 < 50; A2++) {
        var N = false;
        for (u = s; -1 != u; u += -1) {
          if (Math.abs(p[u]) <= r) {
            N = true;
            break;
          }
          if (Math.abs(m[u - 1]) <= r) break;
        }
        if (!N) {
          i2 = 0, w2 = 1;
          var D = u - 1;
          for (a = u; a < s + 1 && (g = w2 * p[a], p[a] = i2 * p[a], !(Math.abs(g) <= r)); a++) for (v2 = h(g, y = m[a]), m[a] = v2, i2 = y / v2, w2 = -g / v2, o = 0; o < l; o++) b2 = c2[o][D], _2 = c2[o][a], c2[o][D] = b2 * i2 + _2 * w2, c2[o][a] = -b2 * w2 + _2 * i2;
        }
        if (_2 = m[s], u == s) {
          if (_2 < 0) for (m[s] = -_2, o = 0; o < f2; o++) d[o][s] = -d[o][s];
          break;
        }
        if (A2 >= 49) throw "Error: no convergence.";
        for (x2 = m[u], y = h(g = (((b2 = m[s - 1]) - _2) * (b2 + _2) + ((y = p[s - 1]) - (v2 = p[s])) * (y + v2)) / (2 * v2 * b2), 1), g = g < 0 ? ((x2 - _2) * (x2 + _2) + v2 * (b2 / (g - y) - v2)) / x2 : ((x2 - _2) * (x2 + _2) + v2 * (b2 / (g + y) - v2)) / x2, i2 = 1, w2 = 1, a = u + 1; a < s + 1; a++) {
          for (y = p[a], b2 = m[a], v2 = w2 * y, y *= i2, _2 = h(g, v2), p[a - 1] = _2, g = x2 * (i2 = g / _2) + y * (w2 = v2 / _2), y = -x2 * w2 + y * i2, v2 = b2 * w2, b2 *= i2, o = 0; o < f2; o++) x2 = d[o][a - 1], _2 = d[o][a], d[o][a - 1] = x2 * i2 + _2 * w2, d[o][a] = -x2 * w2 + _2 * i2;
          for (_2 = h(g, v2), m[a - 1] = _2, g = (i2 = g / _2) * y + (w2 = v2 / _2) * b2, x2 = -w2 * y + i2 * b2, o = 0; o < l; o++) b2 = c2[o][a - 1], _2 = c2[o][a], c2[o][a - 1] = b2 * i2 + _2 * w2, c2[o][a] = -b2 * w2 + _2 * i2;
        }
        p[u] = 0, p[s] = g, m[s] = x2;
      }
      for (a = 0; a < m.length; a++) m[a] < r && (m[a] = 0);
      for (a = 0; a < f2; a++) for (o = a - 1; o >= 0; o--) if (m[o] < m[a]) {
        for (i2 = m[o], m[o] = m[a], m[a] = i2, s = 0; s < c2.length; s++) t2 = c2[s][a], c2[s][a] = c2[s][o], c2[s][o] = t2;
        for (s = 0; s < d.length; s++) t2 = d[s][a], d[s][a] = d[s][o], d[s][o] = t2;
        a = o;
      }
      return { U: c2, S: m, V: d };
    };
  })(numeric1_2_6$1)), numeric1_2_6$1;
}
var numeric1_2_6Exports$1 = requireNumeric1_2_6$1(), numeric$1 = getDefaultExportFromCjs$5(numeric1_2_6Exports$1);
function createInstance$1({ define_e: e2 = true, define_pi: t2 = true, define_i: r = true, pow_strict: n = true } = {}) {
  let i2 = { ...all$1 };
  delete i2.createTau, delete i2.createPhi, e2 || delete i2.createE, t2 || delete i2.createPi, r || delete i2.createI;
  let a = create$1$1(i2);
  a.import(numeric$1, { wrap: true, silent: true });
  var o = a.pow;
  return n ? a.import({ pow: function(e3, t3) {
    return 0 !== t3 || "number" != typeof e3 || 0 !== e3 && Number.isFinite(e3) ? o(e3, t3) : NaN;
  } }, { override: true }) : a.import({ pow: o }, { override: true }), a.define_e = e2, a.define_pi = t2, a.define_i = r, a.pow_strict = n, a;
}
var math$1$1 = createInstance$1();
function leaves$1(e2, t2) {
  if (!Array.isArray(e2)) return [e2];
  var r = e2[0], n = e2.slice(1);
  return !t2 || "_" !== r || "string" != typeof n[0] || "string" != typeof n[1] && "number" != typeof n[1] ? ("apply" === r && (n = e2.slice(2)), 0 === n.length ? [] : n.map((function(e3, r2) {
    return leaves$1(e3, t2);
  })).reduce((function(e3, t3) {
    return e3.concat(t3);
  }))) : [n[0] + "_" + n[1]];
}
function variables$2(e2, t2 = false) {
  var r = leaves$1(get_tree$1(e2), t2);
  return r = (r = r.filter((function(e3, t3) {
    return "string" == typeof e3 && (math$1$1.define_e || "e" !== e3) && (math$1$1.define_pi || "pi" !== e3) && (math$1$1.define_i || "i" !== e3);
  }))).filter((function(e3, t3, n) {
    return t3 === r.indexOf(e3);
  }));
}
function operators_list$1(e2) {
  if (!Array.isArray(e2)) return [];
  var t2 = e2[0], r = e2.slice(1);
  return "apply" === t2 && (r = e2.slice(2)), 0 === r.length ? [t2] : [t2].concat(r.map((function(e3, t3) {
    return operators_list$1(e3);
  })).reduce((function(e3, t3) {
    return e3.concat(t3);
  })));
}
function operators$3$1(e2) {
  var t2 = operators_list$1(get_tree$1(e2));
  return t2 = (t2 = t2.filter((function(e3, t3) {
    return "apply" !== e3;
  }))).filter((function(e3, r, n) {
    return r === t2.indexOf(e3);
  }));
}
function functions_list$1(e2) {
  if (!Array.isArray(e2)) return [];
  var t2 = e2[0], r = e2.slice(1), n = [];
  return "apply" === t2 && (n = [r[0]], r = e2.slice(2)), n.concat(r.map((function(e3, t3) {
    return functions_list$1(e3);
  })).reduce((function(e3, t3) {
    return e3.concat(t3);
  }), []));
}
function functions$2$1(e2) {
  var t2 = functions_list$1(get_tree$1(e2));
  return t2 = t2.filter((function(e3, r, n) {
    return r === t2.indexOf(e3);
  }));
}
var variables$1$1 = Object.freeze({ __proto__: null, variables: variables$2, operators: operators$3$1, functions: functions$2$1 }), global$1$1 = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, VERSION$1 = "1.13.6", root$1 = "object" == typeof self && self.self === self && self || "object" == typeof global$1$1 && global$1$1.global === global$1$1 && global$1$1 || Function("return this")() || {}, ArrayProto$1 = Array.prototype, ObjProto$1 = Object.prototype, SymbolProto$1 = "undefined" != typeof Symbol ? Symbol.prototype : null, push$2 = ArrayProto$1.push, slice$1 = ArrayProto$1.slice, toString$1$1 = ObjProto$1.toString, hasOwnProperty$5 = ObjProto$1.hasOwnProperty, supportsArrayBuffer$1 = "undefined" != typeof ArrayBuffer, supportsDataView$1 = "undefined" != typeof DataView, nativeIsArray$1 = Array.isArray, nativeKeys$1 = Object.keys, nativeCreate$1 = Object.create, nativeIsView$1 = supportsArrayBuffer$1 && ArrayBuffer.isView, _isNaN$1 = isNaN, _isFinite$1 = isFinite, hasEnumBug$1 = !{ toString: null }.propertyIsEnumerable("toString"), nonEnumerableProps$1 = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], MAX_ARRAY_INDEX$1 = Math.pow(2, 53) - 1;
function restArguments$1(e2, t2) {
  return t2 = null == t2 ? e2.length - 1 : +t2, function() {
    for (var r = Math.max(arguments.length - t2, 0), n = Array(r), i2 = 0; i2 < r; i2++) n[i2] = arguments[i2 + t2];
    switch (t2) {
      case 0:
        return e2.call(this, n);
      case 1:
        return e2.call(this, arguments[0], n);
      case 2:
        return e2.call(this, arguments[0], arguments[1], n);
    }
    var a = Array(t2 + 1);
    for (i2 = 0; i2 < t2; i2++) a[i2] = arguments[i2];
    return a[t2] = n, e2.apply(this, a);
  };
}
function isObject$3(e2) {
  var t2 = typeof e2;
  return "function" === t2 || "object" === t2 && !!e2;
}
function isNull$2(e2) {
  return null === e2;
}
function isUndefined$2(e2) {
  return void 0 === e2;
}
function isBoolean$4(e2) {
  return true === e2 || false === e2 || "[object Boolean]" === toString$1$1.call(e2);
}
function isElement$3(e2) {
  return !(!e2 || 1 !== e2.nodeType);
}
function tagTester$1(e2) {
  var t2 = "[object " + e2 + "]";
  return function(e3) {
    return toString$1$1.call(e3) === t2;
  };
}
var isString$2 = tagTester$1("String"), isNumber$2 = tagTester$1("Number"), isDate$3 = tagTester$1("Date"), isRegExp$2 = tagTester$1("RegExp"), isError$2 = tagTester$1("Error"), isSymbol$1 = tagTester$1("Symbol"), isArrayBuffer$1 = tagTester$1("ArrayBuffer"), isFunction$4 = tagTester$1("Function"), nodelist$1 = root$1.document && root$1.document.childNodes;
"function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof nodelist$1 && (isFunction$4 = function(e2) {
  return "function" == typeof e2 || false;
});
var isFunction$1$1 = isFunction$4, hasObjectTag$1 = tagTester$1("Object"), hasStringTagBug$1 = supportsDataView$1 && hasObjectTag$1(new DataView(new ArrayBuffer(8))), isIE11$1 = "undefined" != typeof Map && hasObjectTag$1(/* @__PURE__ */ new Map()), isDataView$2 = tagTester$1("DataView");
function ie10IsDataView$1(e2) {
  return null != e2 && isFunction$1$1(e2.getInt8) && isArrayBuffer$1(e2.buffer);
}
var isDataView$1$1 = hasStringTagBug$1 ? ie10IsDataView$1 : isDataView$2, isArray$3 = nativeIsArray$1 || tagTester$1("Array");
function has$1$1(e2, t2) {
  return null != e2 && hasOwnProperty$5.call(e2, t2);
}
var isArguments$2 = tagTester$1("Arguments");
!(function() {
  isArguments$2(arguments) || (isArguments$2 = function(e2) {
    return has$1$1(e2, "callee");
  });
})();
var isArguments$1$1 = isArguments$2;
function isFinite$1$1(e2) {
  return !isSymbol$1(e2) && _isFinite$1(e2) && !isNaN(parseFloat(e2));
}
function isNaN$1$1(e2) {
  return isNumber$2(e2) && _isNaN$1(e2);
}
function constant$1(e2) {
  return function() {
    return e2;
  };
}
function createSizePropertyCheck$1(e2) {
  return function(t2) {
    var r = e2(t2);
    return "number" == typeof r && r >= 0 && r <= MAX_ARRAY_INDEX$1;
  };
}
function shallowProperty$1(e2) {
  return function(t2) {
    return null == t2 ? void 0 : t2[e2];
  };
}
var getByteLength$1 = shallowProperty$1("byteLength"), isBufferLike$1 = createSizePropertyCheck$1(getByteLength$1), typedArrayPattern$1 = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray$2(e2) {
  return nativeIsView$1 ? nativeIsView$1(e2) && !isDataView$1$1(e2) : isBufferLike$1(e2) && typedArrayPattern$1.test(toString$1$1.call(e2));
}
var isTypedArray$1$1 = supportsArrayBuffer$1 ? isTypedArray$2 : constant$1(false), getLength$1 = shallowProperty$1("length");
function emulatedSet$1(e2) {
  for (var t2 = {}, r = e2.length, n = 0; n < r; ++n) t2[e2[n]] = true;
  return { contains: function(e3) {
    return true === t2[e3];
  }, push: function(r2) {
    return t2[r2] = true, e2.push(r2);
  } };
}
function collectNonEnumProps$1(e2, t2) {
  t2 = emulatedSet$1(t2);
  var r = nonEnumerableProps$1.length, n = e2.constructor, i2 = isFunction$1$1(n) && n.prototype || ObjProto$1, a = "constructor";
  for (has$1$1(e2, a) && !t2.contains(a) && t2.push(a); r--; ) (a = nonEnumerableProps$1[r]) in e2 && e2[a] !== i2[a] && !t2.contains(a) && t2.push(a);
}
function keys$2(e2) {
  if (!isObject$3(e2)) return [];
  if (nativeKeys$1) return nativeKeys$1(e2);
  var t2 = [];
  for (var r in e2) has$1$1(e2, r) && t2.push(r);
  return hasEnumBug$1 && collectNonEnumProps$1(e2, t2), t2;
}
function isEmpty$1(e2) {
  if (null == e2) return true;
  var t2 = getLength$1(e2);
  return "number" == typeof t2 && (isArray$3(e2) || isString$2(e2) || isArguments$1$1(e2)) ? 0 === t2 : 0 === getLength$1(keys$2(e2));
}
function isMatch$1(e2, t2) {
  var r = keys$2(t2), n = r.length;
  if (null == e2) return !n;
  for (var i2 = Object(e2), a = 0; a < n; a++) {
    var o = r[a];
    if (t2[o] !== i2[o] || !(o in i2)) return false;
  }
  return true;
}
function _$1$1(e2) {
  return e2 instanceof _$1$1 ? e2 : this instanceof _$1$1 ? void (this._wrapped = e2) : new _$1$1(e2);
}
function toBufferView$1(e2) {
  return new Uint8Array(e2.buffer || e2, e2.byteOffset || 0, getByteLength$1(e2));
}
_$1$1.VERSION = VERSION$1, _$1$1.prototype.value = function() {
  return this._wrapped;
}, _$1$1.prototype.valueOf = _$1$1.prototype.toJSON = _$1$1.prototype.value, _$1$1.prototype.toString = function() {
  return String(this._wrapped);
};
var tagDataView$1 = "[object DataView]";
function eq$1(e2, t2, r, n) {
  if (e2 === t2) return 0 !== e2 || 1 / e2 == 1 / t2;
  if (null == e2 || null == t2) return false;
  if (e2 != e2) return t2 != t2;
  var i2 = typeof e2;
  return ("function" === i2 || "object" === i2 || "object" == typeof t2) && deepEq$1(e2, t2, r, n);
}
function deepEq$1(e2, t2, r, n) {
  e2 instanceof _$1$1 && (e2 = e2._wrapped), t2 instanceof _$1$1 && (t2 = t2._wrapped);
  var i2 = toString$1$1.call(e2);
  if (i2 !== toString$1$1.call(t2)) return false;
  if (hasStringTagBug$1 && "[object Object]" == i2 && isDataView$1$1(e2)) {
    if (!isDataView$1$1(t2)) return false;
    i2 = tagDataView$1;
  }
  switch (i2) {
    case "[object RegExp]":
    case "[object String]":
      return "" + e2 == "" + t2;
    case "[object Number]":
      return +e2 != +e2 ? +t2 != +t2 : 0 == +e2 ? 1 / +e2 == 1 / t2 : +e2 == +t2;
    case "[object Date]":
    case "[object Boolean]":
      return +e2 == +t2;
    case "[object Symbol]":
      return SymbolProto$1.valueOf.call(e2) === SymbolProto$1.valueOf.call(t2);
    case "[object ArrayBuffer]":
    case tagDataView$1:
      return deepEq$1(toBufferView$1(e2), toBufferView$1(t2), r, n);
  }
  var a = "[object Array]" === i2;
  if (!a && isTypedArray$1$1(e2)) {
    if (getByteLength$1(e2) !== getByteLength$1(t2)) return false;
    if (e2.buffer === t2.buffer && e2.byteOffset === t2.byteOffset) return true;
    a = true;
  }
  if (!a) {
    if ("object" != typeof e2 || "object" != typeof t2) return false;
    var o = e2.constructor, s = t2.constructor;
    if (o !== s && !(isFunction$1$1(o) && o instanceof o && isFunction$1$1(s) && s instanceof s) && "constructor" in e2 && "constructor" in t2) return false;
  }
  n = n || [];
  for (var u = (r = r || []).length; u--; ) if (r[u] === e2) return n[u] === t2;
  if (r.push(e2), n.push(t2), a) {
    if ((u = e2.length) !== t2.length) return false;
    for (; u--; ) if (!eq$1(e2[u], t2[u], r, n)) return false;
  } else {
    var c2, l = keys$2(e2);
    if (u = l.length, keys$2(t2).length !== u) return false;
    for (; u--; ) if (!has$1$1(t2, c2 = l[u]) || !eq$1(e2[c2], t2[c2], r, n)) return false;
  }
  return r.pop(), n.pop(), true;
}
function isEqual$1(e2, t2) {
  return eq$1(e2, t2);
}
function allKeys$1(e2) {
  if (!isObject$3(e2)) return [];
  var t2 = [];
  for (var r in e2) t2.push(r);
  return hasEnumBug$1 && collectNonEnumProps$1(e2, t2), t2;
}
function ie11fingerprint$1(e2) {
  var t2 = getLength$1(e2);
  return function(r) {
    if (null == r) return false;
    var n = allKeys$1(r);
    if (getLength$1(n)) return false;
    for (var i2 = 0; i2 < t2; i2++) if (!isFunction$1$1(r[e2[i2]])) return false;
    return e2 !== weakMapMethods$1 || !isFunction$1$1(r[forEachName$1]);
  };
}
var forEachName$1 = "forEach", hasName$1 = "has", commonInit$1 = ["clear", "delete"], mapTail$1 = ["get", hasName$1, "set"], mapMethods$1 = commonInit$1.concat(forEachName$1, mapTail$1), weakMapMethods$1 = commonInit$1.concat(mapTail$1), setMethods$1 = ["add"].concat(commonInit$1, forEachName$1, hasName$1), isMap$3 = isIE11$1 ? ie11fingerprint$1(mapMethods$1) : tagTester$1("Map"), isWeakMap$1 = isIE11$1 ? ie11fingerprint$1(weakMapMethods$1) : tagTester$1("WeakMap"), isSet$2 = isIE11$1 ? ie11fingerprint$1(setMethods$1) : tagTester$1("Set"), isWeakSet$1 = tagTester$1("WeakSet");
function values$1(e2) {
  for (var t2 = keys$2(e2), r = t2.length, n = Array(r), i2 = 0; i2 < r; i2++) n[i2] = e2[t2[i2]];
  return n;
}
function pairs$1(e2) {
  for (var t2 = keys$2(e2), r = t2.length, n = Array(r), i2 = 0; i2 < r; i2++) n[i2] = [t2[i2], e2[t2[i2]]];
  return n;
}
function invert$1(e2) {
  for (var t2 = {}, r = keys$2(e2), n = 0, i2 = r.length; n < i2; n++) t2[e2[r[n]]] = r[n];
  return t2;
}
function functions$1$1(e2) {
  var t2 = [];
  for (var r in e2) isFunction$1$1(e2[r]) && t2.push(r);
  return t2.sort();
}
function createAssigner$1(e2, t2) {
  return function(r) {
    var n = arguments.length;
    if (t2 && (r = Object(r)), n < 2 || null == r) return r;
    for (var i2 = 1; i2 < n; i2++) for (var a = arguments[i2], o = e2(a), s = o.length, u = 0; u < s; u++) {
      var c2 = o[u];
      t2 && void 0 !== r[c2] || (r[c2] = a[c2]);
    }
    return r;
  };
}
var extend$1$3 = createAssigner$1(allKeys$1), extendOwn$1 = createAssigner$1(keys$2), defaults$3 = createAssigner$1(allKeys$1, true);
function ctor$1() {
  return function() {
  };
}
function baseCreate$1(e2) {
  if (!isObject$3(e2)) return {};
  if (nativeCreate$1) return nativeCreate$1(e2);
  var t2 = ctor$1();
  t2.prototype = e2;
  var r = new t2();
  return t2.prototype = null, r;
}
function create$2(e2, t2) {
  var r = baseCreate$1(e2);
  return t2 && extendOwn$1(r, t2), r;
}
function clone$4(e2) {
  return isObject$3(e2) ? isArray$3(e2) ? e2.slice() : extend$1$3({}, e2) : e2;
}
function tap$1(e2, t2) {
  return t2(e2), e2;
}
function toPath$1$1(e2) {
  return isArray$3(e2) ? e2 : [e2];
}
function toPath$2(e2) {
  return _$1$1.toPath(e2);
}
function deepGet$1(e2, t2) {
  for (var r = t2.length, n = 0; n < r; n++) {
    if (null == e2) return;
    e2 = e2[t2[n]];
  }
  return r ? e2 : void 0;
}
function get$4(e2, t2, r) {
  var n = deepGet$1(e2, toPath$2(t2));
  return isUndefined$2(n) ? r : n;
}
function has$3(e2, t2) {
  for (var r = (t2 = toPath$2(t2)).length, n = 0; n < r; n++) {
    var i2 = t2[n];
    if (!has$1$1(e2, i2)) return false;
    e2 = e2[i2];
  }
  return !!r;
}
function identity$3(e2) {
  return e2;
}
function matcher$1(e2) {
  return e2 = extendOwn$1({}, e2), function(t2) {
    return isMatch$1(t2, e2);
  };
}
function property$1(e2) {
  return e2 = toPath$2(e2), function(t2) {
    return deepGet$1(t2, e2);
  };
}
function optimizeCb$1(e2, t2, r) {
  if (void 0 === t2) return e2;
  switch (null == r ? 3 : r) {
    case 1:
      return function(r2) {
        return e2.call(t2, r2);
      };
    case 3:
      return function(r2, n, i2) {
        return e2.call(t2, r2, n, i2);
      };
    case 4:
      return function(r2, n, i2, a) {
        return e2.call(t2, r2, n, i2, a);
      };
  }
  return function() {
    return e2.apply(t2, arguments);
  };
}
function baseIteratee$1(e2, t2, r) {
  return null == e2 ? identity$3 : isFunction$1$1(e2) ? optimizeCb$1(e2, t2, r) : isObject$3(e2) && !isArray$3(e2) ? matcher$1(e2) : property$1(e2);
}
function iteratee$1(e2, t2) {
  return baseIteratee$1(e2, t2, 1 / 0);
}
function cb$1(e2, t2, r) {
  return _$1$1.iteratee !== iteratee$1 ? _$1$1.iteratee(e2, t2) : baseIteratee$1(e2, t2, r);
}
function mapObject$2(e2, t2, r) {
  t2 = cb$1(t2, r);
  for (var n = keys$2(e2), i2 = n.length, a = {}, o = 0; o < i2; o++) {
    var s = n[o];
    a[s] = t2(e2[s], s, e2);
  }
  return a;
}
function noop$1$2() {
}
function propertyOf$1(e2) {
  return null == e2 ? noop$1$2 : function(t2) {
    return get$4(e2, t2);
  };
}
function times$1(e2, t2, r) {
  var n = Array(Math.max(0, e2));
  t2 = optimizeCb$1(t2, r, 1);
  for (var i2 = 0; i2 < e2; i2++) n[i2] = t2(i2);
  return n;
}
function random$2(e2, t2) {
  return null == t2 && (t2 = e2, e2 = 0), e2 + Math.floor(Math.random() * (t2 - e2 + 1));
}
_$1$1.toPath = toPath$1$1, _$1$1.iteratee = iteratee$1;
var now$1 = Date.now || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function createEscaper$1(e2) {
  var t2 = function(t3) {
    return e2[t3];
  }, r = "(?:" + keys$2(e2).join("|") + ")", n = RegExp(r), i2 = RegExp(r, "g");
  return function(e3) {
    return e3 = null == e3 ? "" : "" + e3, n.test(e3) ? e3.replace(i2, t2) : e3;
  };
}
var escapeMap$1 = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;" }, escape$3 = createEscaper$1(escapeMap$1), unescapeMap$1 = invert$1(escapeMap$1), unescape$1 = createEscaper$1(unescapeMap$1), templateSettings$1 = _$1$1.templateSettings = { evaluate: /<%([\s\S]+?)%>/g, interpolate: /<%=([\s\S]+?)%>/g, escape: /<%-([\s\S]+?)%>/g }, noMatch$1 = /(.)^/, escapes$1 = { "'": "'", "\\": "\\", "\r": "r", "\n": "n", "\u2028": "u2028", "\u2029": "u2029" }, escapeRegExp$1 = /\\|'|\r|\n|\u2028|\u2029/g;
function escapeChar$1(e2) {
  return "\\" + escapes$1[e2];
}
var bareIdentifier$1 = /^\s*(\w|\$)+\s*$/;
function template$1(e2, t2, r) {
  !t2 && r && (t2 = r), t2 = defaults$3({}, t2, _$1$1.templateSettings);
  var n = RegExp([(t2.escape || noMatch$1).source, (t2.interpolate || noMatch$1).source, (t2.evaluate || noMatch$1).source].join("|") + "|$", "g"), i2 = 0, a = "__p+='";
  e2.replace(n, (function(t3, r2, n3, o2, s2) {
    return a += e2.slice(i2, s2).replace(escapeRegExp$1, escapeChar$1), i2 = s2 + t3.length, r2 ? a += "'+\n((__t=(" + r2 + "))==null?'':_.escape(__t))+\n'" : n3 ? a += "'+\n((__t=(" + n3 + "))==null?'':__t)+\n'" : o2 && (a += "';\n" + o2 + "\n__p+='"), t3;
  })), a += "';\n";
  var o, s = t2.variable;
  if (s) {
    if (!bareIdentifier$1.test(s)) throw new Error("variable is not a bare identifier: " + s);
  } else a = "with(obj||{}){\n" + a + "}\n", s = "obj";
  a = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + a + "return __p;\n";
  try {
    o = new Function(s, "_", a);
  } catch (e3) {
    throw e3.source = a, e3;
  }
  var u = function(e3) {
    return o.call(this, e3, _$1$1);
  };
  return u.source = "function(" + s + "){\n" + a + "}", u;
}
function result$1(e2, t2, r) {
  var n = (t2 = toPath$2(t2)).length;
  if (!n) return isFunction$1$1(r) ? r.call(e2) : r;
  for (var i2 = 0; i2 < n; i2++) {
    var a = null == e2 ? void 0 : e2[t2[i2]];
    void 0 === a && (a = r, i2 = n), e2 = isFunction$1$1(a) ? a.call(e2) : a;
  }
  return e2;
}
var idCounter$1 = 0;
function uniqueId$1(e2) {
  var t2 = ++idCounter$1 + "";
  return e2 ? e2 + t2 : t2;
}
function chain$3(e2) {
  var t2 = _$1$1(e2);
  return t2._chain = true, t2;
}
function executeBound$1(e2, t2, r, n, i2) {
  if (!(n instanceof t2)) return e2.apply(r, i2);
  var a = baseCreate$1(e2.prototype), o = e2.apply(a, i2);
  return isObject$3(o) ? o : a;
}
var partial$1 = restArguments$1((function(e2, t2) {
  var r = partial$1.placeholder, n = function() {
    for (var i2 = 0, a = t2.length, o = Array(a), s = 0; s < a; s++) o[s] = t2[s] === r ? arguments[i2++] : t2[s];
    for (; i2 < arguments.length; ) o.push(arguments[i2++]);
    return executeBound$1(e2, n, this, this, o);
  };
  return n;
}));
partial$1.placeholder = _$1$1;
var bind$1 = restArguments$1((function(e2, t2, r) {
  if (!isFunction$1$1(e2)) throw new TypeError("Bind must be called on a function");
  var n = restArguments$1((function(i2) {
    return executeBound$1(e2, n, t2, this, r.concat(i2));
  }));
  return n;
})), isArrayLike$1 = createSizePropertyCheck$1(getLength$1);
function flatten$3$1(e2, t2, r, n) {
  if (n = n || [], t2 || 0 === t2) {
    if (t2 <= 0) return n.concat(e2);
  } else t2 = 1 / 0;
  for (var i2 = n.length, a = 0, o = getLength$1(e2); a < o; a++) {
    var s = e2[a];
    if (isArrayLike$1(s) && (isArray$3(s) || isArguments$1$1(s))) if (t2 > 1) flatten$3$1(s, t2 - 1, r, n), i2 = n.length;
    else for (var u = 0, c2 = s.length; u < c2; ) n[i2++] = s[u++];
    else r || (n[i2++] = s);
  }
  return n;
}
var bindAll$1 = restArguments$1((function(e2, t2) {
  var r = (t2 = flatten$3$1(t2, false, false)).length;
  if (r < 1) throw new Error("bindAll must be passed function names");
  for (; r--; ) {
    var n = t2[r];
    e2[n] = bind$1(e2[n], e2);
  }
  return e2;
}));
function memoize$2(e2, t2) {
  var r = function(n) {
    var i2 = r.cache, a = "" + (t2 ? t2.apply(this, arguments) : n);
    return has$1$1(i2, a) || (i2[a] = e2.apply(this, arguments)), i2[a];
  };
  return r.cache = {}, r;
}
var delay$1 = restArguments$1((function(e2, t2, r) {
  return setTimeout((function() {
    return e2.apply(null, r);
  }), t2);
})), defer$1 = partial$1(delay$1, _$1$1, 1);
function throttle$1(e2, t2, r) {
  var n, i2, a, o, s = 0;
  r || (r = {});
  var u = function() {
    s = false === r.leading ? 0 : now$1(), n = null, o = e2.apply(i2, a), n || (i2 = a = null);
  }, c2 = function() {
    var c3 = now$1();
    s || false !== r.leading || (s = c3);
    var l = t2 - (c3 - s);
    return i2 = this, a = arguments, l <= 0 || l > t2 ? (n && (clearTimeout(n), n = null), s = c3, o = e2.apply(i2, a), n || (i2 = a = null)) : n || false === r.trailing || (n = setTimeout(u, l)), o;
  };
  return c2.cancel = function() {
    clearTimeout(n), s = 0, n = i2 = a = null;
  }, c2;
}
function debounce$2(e2, t2, r) {
  var n, i2, a, o, s, u = function() {
    var c3 = now$1() - i2;
    t2 > c3 ? n = setTimeout(u, t2 - c3) : (n = null, r || (o = e2.apply(s, a)), n || (a = s = null));
  }, c2 = restArguments$1((function(c3) {
    return s = this, a = c3, i2 = now$1(), n || (n = setTimeout(u, t2), r && (o = e2.apply(s, a))), o;
  }));
  return c2.cancel = function() {
    clearTimeout(n), n = a = s = null;
  }, c2;
}
function wrap$4(e2, t2) {
  return partial$1(t2, e2);
}
function negate$1(e2) {
  return function() {
    return !e2.apply(this, arguments);
  };
}
function compose$2() {
  var e2 = arguments, t2 = e2.length - 1;
  return function() {
    for (var r = t2, n = e2[t2].apply(this, arguments); r--; ) n = e2[r].call(this, n);
    return n;
  };
}
function after$1(e2, t2) {
  return function() {
    if (--e2 < 1) return t2.apply(this, arguments);
  };
}
function before$1(e2, t2) {
  var r;
  return function() {
    return --e2 > 0 && (r = t2.apply(this, arguments)), e2 <= 1 && (t2 = null), r;
  };
}
var once$1$1 = partial$1(before$1, 2);
function findKey$1(e2, t2, r) {
  t2 = cb$1(t2, r);
  for (var n, i2 = keys$2(e2), a = 0, o = i2.length; a < o; a++) if (t2(e2[n = i2[a]], n, e2)) return n;
}
function createPredicateIndexFinder$1(e2) {
  return function(t2, r, n) {
    r = cb$1(r, n);
    for (var i2 = getLength$1(t2), a = e2 > 0 ? 0 : i2 - 1; a >= 0 && a < i2; a += e2) if (r(t2[a], a, t2)) return a;
    return -1;
  };
}
var findIndex$1 = createPredicateIndexFinder$1(1), findLastIndex$2 = createPredicateIndexFinder$1(-1);
function sortedIndex$1(e2, t2, r, n) {
  for (var i2 = (r = cb$1(r, n, 1))(t2), a = 0, o = getLength$1(e2); a < o; ) {
    var s = Math.floor((a + o) / 2);
    r(e2[s]) < i2 ? a = s + 1 : o = s;
  }
  return a;
}
function createIndexFinder$1(e2, t2, r) {
  return function(n, i2, a) {
    var o = 0, s = getLength$1(n);
    if ("number" == typeof a) e2 > 0 ? o = a >= 0 ? a : Math.max(a + s, o) : s = a >= 0 ? Math.min(a + 1, s) : a + s + 1;
    else if (r && a && s) return n[a = r(n, i2)] === i2 ? a : -1;
    if (i2 != i2) return (a = t2(slice$1.call(n, o, s), isNaN$1$1)) >= 0 ? a + o : -1;
    for (a = e2 > 0 ? o : s - 1; a >= 0 && a < s; a += e2) if (n[a] === i2) return a;
    return -1;
  };
}
var indexOf$1 = createIndexFinder$1(1, findIndex$1, sortedIndex$1), lastIndexOf$1 = createIndexFinder$1(-1, findLastIndex$2);
function find$2(e2, t2, r) {
  var n = (isArrayLike$1(e2) ? findIndex$1 : findKey$1)(e2, t2, r);
  if (void 0 !== n && -1 !== n) return e2[n];
}
function findWhere$1(e2, t2) {
  return find$2(e2, matcher$1(t2));
}
function each$2(e2, t2, r) {
  var n, i2;
  if (t2 = optimizeCb$1(t2, r), isArrayLike$1(e2)) for (n = 0, i2 = e2.length; n < i2; n++) t2(e2[n], n, e2);
  else {
    var a = keys$2(e2);
    for (n = 0, i2 = a.length; n < i2; n++) t2(e2[a[n]], a[n], e2);
  }
  return e2;
}
function map$2(e2, t2, r) {
  t2 = cb$1(t2, r);
  for (var n = !isArrayLike$1(e2) && keys$2(e2), i2 = (n || e2).length, a = Array(i2), o = 0; o < i2; o++) {
    var s = n ? n[o] : o;
    a[o] = t2(e2[s], s, e2);
  }
  return a;
}
function createReduce$1(e2) {
  return function(t2, r, n, i2) {
    var a = arguments.length >= 3;
    return (function(t3, r2, n3, i3) {
      var a2 = !isArrayLike$1(t3) && keys$2(t3), o = (a2 || t3).length, s = e2 > 0 ? 0 : o - 1;
      for (i3 || (n3 = t3[a2 ? a2[s] : s], s += e2); s >= 0 && s < o; s += e2) {
        var u = a2 ? a2[s] : s;
        n3 = r2(n3, t3[u], u, t3);
      }
      return n3;
    })(t2, optimizeCb$1(r, i2, 4), n, a);
  };
}
var reduce$1$1 = createReduce$1(1), reduceRight$1 = createReduce$1(-1);
function filter$2(e2, t2, r) {
  var n = [];
  return t2 = cb$1(t2, r), each$2(e2, (function(e3, r2, i2) {
    t2(e3, r2, i2) && n.push(e3);
  })), n;
}
function reject$1(e2, t2, r) {
  return filter$2(e2, negate$1(cb$1(t2)), r);
}
function every$1(e2, t2, r) {
  t2 = cb$1(t2, r);
  for (var n = !isArrayLike$1(e2) && keys$2(e2), i2 = (n || e2).length, a = 0; a < i2; a++) {
    var o = n ? n[a] : a;
    if (!t2(e2[o], o, e2)) return false;
  }
  return true;
}
function some$1(e2, t2, r) {
  t2 = cb$1(t2, r);
  for (var n = !isArrayLike$1(e2) && keys$2(e2), i2 = (n || e2).length, a = 0; a < i2; a++) {
    var o = n ? n[a] : a;
    if (t2(e2[o], o, e2)) return true;
  }
  return false;
}
function contains$4(e2, t2, r, n) {
  return isArrayLike$1(e2) || (e2 = values$1(e2)), ("number" != typeof r || n) && (r = 0), indexOf$1(e2, t2, r) >= 0;
}
var invoke$1 = restArguments$1((function(e2, t2, r) {
  var n, i2;
  return isFunction$1$1(t2) ? i2 = t2 : (t2 = toPath$2(t2), n = t2.slice(0, -1), t2 = t2[t2.length - 1]), map$2(e2, (function(e3) {
    var a = i2;
    if (!a) {
      if (n && n.length && (e3 = deepGet$1(e3, n)), null == e3) return;
      a = e3[t2];
    }
    return null == a ? a : a.apply(e3, r);
  }));
}));
function pluck$1(e2, t2) {
  return map$2(e2, property$1(t2));
}
function where$1(e2, t2) {
  return filter$2(e2, matcher$1(t2));
}
function max$3(e2, t2, r) {
  var n, i2, a = -1 / 0, o = -1 / 0;
  if (null == t2 || "number" == typeof t2 && "object" != typeof e2[0] && null != e2) for (var s = 0, u = (e2 = isArrayLike$1(e2) ? e2 : values$1(e2)).length; s < u; s++) null != (n = e2[s]) && n > a && (a = n);
  else t2 = cb$1(t2, r), each$2(e2, (function(e3, r2, n3) {
    ((i2 = t2(e3, r2, n3)) > o || i2 === -1 / 0 && a === -1 / 0) && (a = e3, o = i2);
  }));
  return a;
}
function min$3(e2, t2, r) {
  var n, i2, a = 1 / 0, o = 1 / 0;
  if (null == t2 || "number" == typeof t2 && "object" != typeof e2[0] && null != e2) for (var s = 0, u = (e2 = isArrayLike$1(e2) ? e2 : values$1(e2)).length; s < u; s++) null != (n = e2[s]) && n < a && (a = n);
  else t2 = cb$1(t2, r), each$2(e2, (function(e3, r2, n3) {
    ((i2 = t2(e3, r2, n3)) < o || i2 === 1 / 0 && a === 1 / 0) && (a = e3, o = i2);
  }));
  return a;
}
var reStrSymbol$1 = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray$2(e2) {
  return e2 ? isArray$3(e2) ? slice$1.call(e2) : isString$2(e2) ? e2.match(reStrSymbol$1) : isArrayLike$1(e2) ? map$2(e2, identity$3) : values$1(e2) : [];
}
function sample$1(e2, t2, r) {
  if (null == t2 || r) return isArrayLike$1(e2) || (e2 = values$1(e2)), e2[random$2(e2.length - 1)];
  var n = toArray$2(e2), i2 = getLength$1(n);
  t2 = Math.max(Math.min(t2, i2), 0);
  for (var a = i2 - 1, o = 0; o < t2; o++) {
    var s = random$2(o, a), u = n[o];
    n[o] = n[s], n[s] = u;
  }
  return n.slice(0, t2);
}
function shuffle$1(e2) {
  return sample$1(e2, 1 / 0);
}
function sortBy$1(e2, t2, r) {
  var n = 0;
  return t2 = cb$1(t2, r), pluck$1(map$2(e2, (function(e3, r2, i2) {
    return { value: e3, index: n++, criteria: t2(e3, r2, i2) };
  })).sort((function(e3, t3) {
    var r2 = e3.criteria, n3 = t3.criteria;
    if (r2 !== n3) {
      if (r2 > n3 || void 0 === r2) return 1;
      if (r2 < n3 || void 0 === n3) return -1;
    }
    return e3.index - t3.index;
  })), "value");
}
function group$3(e2, t2) {
  return function(r, n, i2) {
    var a = t2 ? [[], []] : {};
    return n = cb$1(n, i2), each$2(r, (function(t3, i3) {
      var o = n(t3, i3, r);
      e2(a, t3, o);
    })), a;
  };
}
var groupBy$1 = group$3((function(e2, t2, r) {
  has$1$1(e2, r) ? e2[r].push(t2) : e2[r] = [t2];
})), indexBy$1 = group$3((function(e2, t2, r) {
  e2[r] = t2;
})), countBy$1 = group$3((function(e2, t2, r) {
  has$1$1(e2, r) ? e2[r]++ : e2[r] = 1;
})), partition$1 = group$3((function(e2, t2, r) {
  e2[r ? 0 : 1].push(t2);
}), true);
function size$3(e2) {
  return null == e2 ? 0 : isArrayLike$1(e2) ? e2.length : keys$2(e2).length;
}
function keyInObj$1(e2, t2, r) {
  return t2 in r;
}
var pick$3 = restArguments$1((function(e2, t2) {
  var r = {}, n = t2[0];
  if (null == e2) return r;
  isFunction$1$1(n) ? (t2.length > 1 && (n = optimizeCb$1(n, t2[1])), t2 = allKeys$1(e2)) : (n = keyInObj$1, t2 = flatten$3$1(t2, false, false), e2 = Object(e2));
  for (var i2 = 0, a = t2.length; i2 < a; i2++) {
    var o = t2[i2], s = e2[o];
    n(s, o, e2) && (r[o] = s);
  }
  return r;
})), omit$3 = restArguments$1((function(e2, t2) {
  var r, n = t2[0];
  return isFunction$1$1(n) ? (n = negate$1(n), t2.length > 1 && (r = t2[1])) : (t2 = map$2(flatten$3$1(t2, false, false), String), n = function(e3, r2) {
    return !contains$4(t2, r2);
  }), pick$3(e2, n, r);
}));
function initial$1(e2, t2, r) {
  return slice$1.call(e2, 0, Math.max(0, e2.length - (null == t2 || r ? 1 : t2)));
}
function first$1(e2, t2, r) {
  return null == e2 || e2.length < 1 ? null == t2 || r ? void 0 : [] : null == t2 || r ? e2[0] : initial$1(e2, e2.length - t2);
}
function rest$1(e2, t2, r) {
  return slice$1.call(e2, null == t2 || r ? 1 : t2);
}
function last$1(e2, t2, r) {
  return null == e2 || e2.length < 1 ? null == t2 || r ? void 0 : [] : null == t2 || r ? e2[e2.length - 1] : rest$1(e2, Math.max(0, e2.length - t2));
}
function compact$1(e2) {
  return filter$2(e2, Boolean);
}
function flatten$2$1(e2, t2) {
  return flatten$3$1(e2, t2, false);
}
var difference$1 = restArguments$1((function(e2, t2) {
  return t2 = flatten$3$1(t2, true, true), filter$2(e2, (function(e3) {
    return !contains$4(t2, e3);
  }));
})), without$1 = restArguments$1((function(e2, t2) {
  return difference$1(e2, t2);
}));
function uniq$1(e2, t2, r, n) {
  isBoolean$4(t2) || (n = r, r = t2, t2 = false), null != r && (r = cb$1(r, n));
  for (var i2 = [], a = [], o = 0, s = getLength$1(e2); o < s; o++) {
    var u = e2[o], c2 = r ? r(u, o, e2) : u;
    t2 && !r ? (o && a === c2 || i2.push(u), a = c2) : r ? contains$4(a, c2) || (a.push(c2), i2.push(u)) : contains$4(i2, u) || i2.push(u);
  }
  return i2;
}
var union$1 = restArguments$1((function(e2) {
  return uniq$1(flatten$3$1(e2, true, true));
}));
function intersection$1(e2) {
  for (var t2 = [], r = arguments.length, n = 0, i2 = getLength$1(e2); n < i2; n++) {
    var a = e2[n];
    if (!contains$4(t2, a)) {
      var o;
      for (o = 1; o < r && contains$4(arguments[o], a); o++) ;
      o === r && t2.push(a);
    }
  }
  return t2;
}
function unzip$1(e2) {
  for (var t2 = e2 && max$3(e2, getLength$1).length || 0, r = Array(t2), n = 0; n < t2; n++) r[n] = pluck$1(e2, n);
  return r;
}
var zip$1 = restArguments$1(unzip$1);
function object$1(e2, t2) {
  for (var r = {}, n = 0, i2 = getLength$1(e2); n < i2; n++) t2 ? r[e2[n]] = t2[n] : r[e2[n][0]] = e2[n][1];
  return r;
}
function range$1(e2, t2, r) {
  null == t2 && (t2 = e2 || 0, e2 = 0), r || (r = t2 < e2 ? -1 : 1);
  for (var n = Math.max(Math.ceil((t2 - e2) / r), 0), i2 = Array(n), a = 0; a < n; a++, e2 += r) i2[a] = e2;
  return i2;
}
function chunk$1(e2, t2) {
  if (null == t2 || t2 < 1) return [];
  for (var r = [], n = 0, i2 = e2.length; n < i2; ) r.push(slice$1.call(e2, n, n += t2));
  return r;
}
function chainResult$1(e2, t2) {
  return e2._chain ? _$1$1(t2).chain() : t2;
}
function mixin$2(e2) {
  return each$2(functions$1$1(e2), (function(t2) {
    var r = _$1$1[t2] = e2[t2];
    _$1$1.prototype[t2] = function() {
      var e3 = [this._wrapped];
      return push$2.apply(e3, arguments), chainResult$1(this, r.apply(_$1$1, e3));
    };
  })), _$1$1;
}
each$2(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], (function(e2) {
  var t2 = ArrayProto$1[e2];
  _$1$1.prototype[e2] = function() {
    var r = this._wrapped;
    return null != r && (t2.apply(r, arguments), "shift" !== e2 && "splice" !== e2 || 0 !== r.length || delete r[0]), chainResult$1(this, r);
  };
})), each$2(["concat", "join", "slice"], (function(e2) {
  var t2 = ArrayProto$1[e2];
  _$1$1.prototype[e2] = function() {
    var e3 = this._wrapped;
    return null != e3 && (e3 = t2.apply(e3, arguments)), chainResult$1(this, e3);
  };
}));
var allExports$1 = Object.freeze({ __proto__: null, VERSION: VERSION$1, restArguments: restArguments$1, isObject: isObject$3, isNull: isNull$2, isUndefined: isUndefined$2, isBoolean: isBoolean$4, isElement: isElement$3, isString: isString$2, isNumber: isNumber$2, isDate: isDate$3, isRegExp: isRegExp$2, isError: isError$2, isSymbol: isSymbol$1, isArrayBuffer: isArrayBuffer$1, isDataView: isDataView$1$1, isArray: isArray$3, isFunction: isFunction$1$1, isArguments: isArguments$1$1, isFinite: isFinite$1$1, isNaN: isNaN$1$1, isTypedArray: isTypedArray$1$1, isEmpty: isEmpty$1, isMatch: isMatch$1, isEqual: isEqual$1, isMap: isMap$3, isWeakMap: isWeakMap$1, isSet: isSet$2, isWeakSet: isWeakSet$1, keys: keys$2, allKeys: allKeys$1, values: values$1, pairs: pairs$1, invert: invert$1, functions: functions$1$1, methods: functions$1$1, extend: extend$1$3, extendOwn: extendOwn$1, assign: extendOwn$1, defaults: defaults$3, create: create$2, clone: clone$4, tap: tap$1, get: get$4, has: has$3, mapObject: mapObject$2, identity: identity$3, constant: constant$1, noop: noop$1$2, toPath: toPath$1$1, property: property$1, propertyOf: propertyOf$1, matcher: matcher$1, matches: matcher$1, times: times$1, random: random$2, now: now$1, escape: escape$3, unescape: unescape$1, templateSettings: templateSettings$1, template: template$1, result: result$1, uniqueId: uniqueId$1, chain: chain$3, iteratee: iteratee$1, partial: partial$1, bind: bind$1, bindAll: bindAll$1, memoize: memoize$2, delay: delay$1, defer: defer$1, throttle: throttle$1, debounce: debounce$2, wrap: wrap$4, negate: negate$1, compose: compose$2, after: after$1, before: before$1, once: once$1$1, findKey: findKey$1, findIndex: findIndex$1, findLastIndex: findLastIndex$2, sortedIndex: sortedIndex$1, indexOf: indexOf$1, lastIndexOf: lastIndexOf$1, find: find$2, detect: find$2, findWhere: findWhere$1, each: each$2, forEach: each$2, map: map$2, collect: map$2, reduce: reduce$1$1, foldl: reduce$1$1, inject: reduce$1$1, reduceRight: reduceRight$1, foldr: reduceRight$1, filter: filter$2, select: filter$2, reject: reject$1, every: every$1, all: every$1, some: some$1, any: some$1, contains: contains$4, includes: contains$4, include: contains$4, invoke: invoke$1, pluck: pluck$1, where: where$1, max: max$3, min: min$3, shuffle: shuffle$1, sample: sample$1, sortBy: sortBy$1, groupBy: groupBy$1, indexBy: indexBy$1, countBy: countBy$1, partition: partition$1, toArray: toArray$2, size: size$3, pick: pick$3, omit: omit$3, first: first$1, head: first$1, take: first$1, initial: initial$1, last: last$1, rest: rest$1, tail: rest$1, drop: rest$1, compact: compact$1, flatten: flatten$2$1, without: without$1, uniq: uniq$1, unique: uniq$1, union: union$1, intersection: intersection$1, difference: difference$1, unzip: unzip$1, transpose: unzip$1, zip: zip$1, object: object$1, range: range$1, chunk: chunk$1, mixin: mixin$2, default: _$1$1 }), _$3 = mixin$2(allExports$1);
_$3._ = _$3;
var indexAll$1 = Object.freeze({ __proto__: null, default: _$3, VERSION: VERSION$1, restArguments: restArguments$1, isObject: isObject$3, isNull: isNull$2, isUndefined: isUndefined$2, isBoolean: isBoolean$4, isElement: isElement$3, isString: isString$2, isNumber: isNumber$2, isDate: isDate$3, isRegExp: isRegExp$2, isError: isError$2, isSymbol: isSymbol$1, isArrayBuffer: isArrayBuffer$1, isDataView: isDataView$1$1, isArray: isArray$3, isFunction: isFunction$1$1, isArguments: isArguments$1$1, isFinite: isFinite$1$1, isNaN: isNaN$1$1, isTypedArray: isTypedArray$1$1, isEmpty: isEmpty$1, isMatch: isMatch$1, isEqual: isEqual$1, isMap: isMap$3, isWeakMap: isWeakMap$1, isSet: isSet$2, isWeakSet: isWeakSet$1, keys: keys$2, allKeys: allKeys$1, values: values$1, pairs: pairs$1, invert: invert$1, functions: functions$1$1, methods: functions$1$1, extend: extend$1$3, extendOwn: extendOwn$1, assign: extendOwn$1, defaults: defaults$3, create: create$2, clone: clone$4, tap: tap$1, get: get$4, has: has$3, mapObject: mapObject$2, identity: identity$3, constant: constant$1, noop: noop$1$2, toPath: toPath$1$1, property: property$1, propertyOf: propertyOf$1, matcher: matcher$1, matches: matcher$1, times: times$1, random: random$2, now: now$1, escape: escape$3, unescape: unescape$1, templateSettings: templateSettings$1, template: template$1, result: result$1, uniqueId: uniqueId$1, chain: chain$3, iteratee: iteratee$1, partial: partial$1, bind: bind$1, bindAll: bindAll$1, memoize: memoize$2, delay: delay$1, defer: defer$1, throttle: throttle$1, debounce: debounce$2, wrap: wrap$4, negate: negate$1, compose: compose$2, after: after$1, before: before$1, once: once$1$1, findKey: findKey$1, findIndex: findIndex$1, findLastIndex: findLastIndex$2, sortedIndex: sortedIndex$1, indexOf: indexOf$1, lastIndexOf: lastIndexOf$1, find: find$2, detect: find$2, findWhere: findWhere$1, each: each$2, forEach: each$2, map: map$2, collect: map$2, reduce: reduce$1$1, foldl: reduce$1$1, inject: reduce$1$1, reduceRight: reduceRight$1, foldr: reduceRight$1, filter: filter$2, select: filter$2, reject: reject$1, every: every$1, all: every$1, some: some$1, any: some$1, contains: contains$4, includes: contains$4, include: contains$4, invoke: invoke$1, pluck: pluck$1, where: where$1, max: max$3, min: min$3, shuffle: shuffle$1, sample: sample$1, sortBy: sortBy$1, groupBy: groupBy$1, indexBy: indexBy$1, countBy: countBy$1, partition: partition$1, toArray: toArray$2, size: size$3, pick: pick$3, omit: omit$3, first: first$1, head: first$1, take: first$1, initial: initial$1, last: last$1, rest: rest$1, tail: rest$1, drop: rest$1, compact: compact$1, flatten: flatten$2$1, without: without$1, uniq: uniq$1, unique: uniq$1, union: union$1, intersection: intersection$1, difference: difference$1, unzip: unzip$1, transpose: unzip$1, zip: zip$1, object: object$1, range: range$1, chunk: chunk$1, mixin: mixin$2 });
const nonTupleVectorOperators$1 = ["vector", "altvector"];
function coerce_tuple_array_vectors$1({ operator1: e2, operator2: t2, operands1: r, operands2: n, coerce_tuples_arrays: i2, coerce_vectors: a }) {
  let o = e2 === t2;
  if (!o) {
    if (i2) {
      if ("tuple" === e2) {
        if (nonTupleVectorOperators$1.includes(t2)) e2 = t2, o = true;
        else if ("interval" === t2 && 2 === r.length) {
          let t3 = n[1];
          t3[1] || t3[2] || (o = true, e2 = "interval", r = [["tuple", ...r], ["tuple", false, false]]);
        }
      } else if ("tuple" === t2) {
        if (nonTupleVectorOperators$1.includes(e2)) t2 = e2, o = true;
        else if ("interval" === e2 && 2 === n.length) {
          let e3 = r[1];
          e3[1] || e3[2] || (o = true, t2 = "interval", n = [["tuple", ...n], ["tuple", false, false]]);
        }
      }
      if (!o) {
        if ("array" === e2 && 2 === r.length) {
          if ("interval" === t2) {
            let t3 = n[1];
            t3[1] && t3[2] && (o = true, e2 = "interval", r = [["tuple", ...r], ["tuple", true, true]]);
          }
        } else if ("array" === t2 && 2 === n.length && "interval" === e2) {
          let e3 = r[1];
          e3[1] && e3[2] && (o = true, t2 = "interval", n = [["tuple", ...n], ["tuple", true, true]]);
        }
      }
    }
    !o && a && nonTupleVectorOperators$1.includes(e2) && nonTupleVectorOperators$1.includes(t2) && (o = true, e2 = t2 = "vector");
  }
  return { operator1: e2, operator2: t2, operands1: r, operands2: n };
}
function handleNaNInfinityStringify$1(e2, t2) {
  return t2 != t2 ? "0/0" : t2 === 1 / 0 ? "1/0" : t2 === -1 / 0 ? "-1/0" : t2;
}
function handleNaNInfinityParse$1(e2, t2) {
  return "0/0" === t2 ? NaN : "1/0" === t2 ? 1 / 0 : "-1/0" === t2 ? -1 / 0 : t2;
}
function deepClone$1(e2) {
  return JSON.parse(JSON.stringify(e2, handleNaNInfinityStringify$1), handleNaNInfinityParse$1);
}
const equal$1 = function(e2, t2, { allowed_error_in_numbers: r = 0, include_error_in_number_exponents: n = false, allowed_error_is_absolute: i2 = false, coerce_tuples_arrays: a = true, coerce_vectors: o = true } = {}) {
  if (!Array.isArray(e2) || !Array.isArray(t2)) {
    if (typeof e2 != typeof t2) return false;
    if ("number" == typeof e2 && Number.isFinite(e2)) {
      let n3 = 1e-14, a2 = Math.min(Math.abs(e2), Math.abs(t2));
      return i2 ? (n3 *= a2, r > n3 && (n3 = r)) : (r > n3 && (n3 = r), n3 *= a2), Math.abs(e2 - t2) <= n3;
    }
    return e2 === t2;
  }
  var s = e2[0], u = e2.slice(1), c2 = t2[0], l = t2.slice(1);
  if (s !== c2 && ({ operator1: s, operator2: c2, operands1: u, operands2: l } = coerce_tuple_array_vectors$1({ operator1: s, operator2: c2, operands1: u, operands2: l, coerce_tuples_arrays: a, coerce_vectors: o })), s !== c2) return false;
  if (u.length !== l.length) return false;
  if (r > 0 && !n && "^" === s) {
    return !!equal$1(u[0], l[0], { allowed_error_in_numbers: r, include_error_in_number_exponents: n, allowed_error_is_absolute: i2, coerce_tuples_arrays: a, coerce_vectors: o }) && equal$1(u[1], l[1], { coerce_tuples_arrays: a, coerce_vectors: o });
  }
  return _$3.every(_$3.zip(u, l), (function(e3) {
    return equal$1(e3[0], e3[1], { allowed_error_in_numbers: r, include_error_in_number_exponents: n, allowed_error_is_absolute: i2, coerce_tuples_arrays: a, coerce_vectors: o });
  }));
}, match$2$1 = function(e2, t2, r) {
  var n = false;
  void 0 === r ? r = {} : r.allow_extended_match && (n = true, delete (r = Object.assign({}, r)).allow_extended_match);
  var i2 = r.variables;
  if (void 0 === i2) {
    i2 = {};
    let e3 = variables$2(t2);
    for (let t3 = 0; t3 < e3.length; t3++) i2[e3[t3]] = true;
    (r = Object.assign({}, r)).variables = i2;
  }
  if (t2 in i2) {
    let r2 = i2[t2];
    if (true !== r2) if (r2 instanceof RegExp) {
      if ("string" == typeof e2) {
        if (!e2.match(r2)) return false;
      } else if (!JSON.stringify(e2).match(r2)) return false;
    } else {
      if ("function" != typeof i2[t2]) return false;
      if (!i2[t2](e2)) return false;
    }
    let n3 = {};
    return n3[t2] = e2, n3;
  }
  if (r.allow_permutations && (e2 = default_order$1(e2), t2 = default_order$1(t2)), !Array.isArray(t2)) return e2 === t2 && {};
  var a = allChildren$1(e2), o = t2[0], s = t2.slice(1);
  if (!Array.isArray(e2) || e2[0] !== o || a.length < s.length) {
    if (Array.isArray(r.allow_implicit_identities)) {
      let n3 = matchImplicitIdentity$1(e2, t2, r);
      if (n3) return n3;
    }
    if ("*" !== o || !Array.isArray(e2) || "-" !== e2[0] || !Array.isArray(e2[1]) || "*" !== e2[1][0]) return false;
    (a = allChildren$1(e2[1]))[0] = ["-", a[0]];
  }
  let u = matchOperands$1(o, a, s, r, n);
  return u || !!Array.isArray(r.allow_implicit_identities) && matchImplicitIdentity$1([o].concat(a), t2, r);
};
function matchOperands$1(e2, t2, r, n, i2) {
  var a = r.map(((e3) => Object())), o = r.length, s = false;
  function u(c3, l2, f2) {
    let p, m = 1, d = 1;
    if ((is_associative$1$1[e2] || ["tuple", "vector", "altvector"].includes(e2)) && (m = c3.length - (o - l2 - 1), d = c3.length), void 0 !== n.max_group && (m = n.max_group < m ? n.max_group : m), void 0 !== n.max_last_group && (d = n.max_last_group < d ? n.max_last_group : d), i2 || l2 !== o - 1) if (s) p = subsets$1(c3, m);
    else {
      p = [];
      for (let e3 = 1; e3 <= m; e3++) p.push(c3.slice(0, e3));
    }
    else {
      if (!(c3.length <= d)) return false;
      p = [c3];
    }
    for (let i3 of p) {
      let s2 = a[l2][i3];
      if (void 0 === s2) {
        let o2 = i3.reduce((function(e3, r2) {
          return e3.concat([t2[r2]]);
        }), []);
        o2 = o2.length > 1 ? [e2].concat(o2) : o2[0], s2 = match$2$1(o2, r[l2], n), a[l2][i3] = s2;
      }
      if (!s2) continue;
      if (!_$3.every(_$3.intersection(Object.keys(f2), Object.keys(s2)), (function(e3) {
        return equal$1(f2[e3], s2[e3]);
      }))) continue;
      let p2 = Object.assign({}, s2);
      Object.assign(p2, f2);
      let m2 = c3.filter(((e3) => !i3.includes(e3)));
      if (l2 === o - 1) {
        return { matches: p2, skipped: m2.reduce((function(e3, r2) {
          return e3.concat([t2[r2]]);
        }), []) };
      }
      let d2 = u(m2, l2 + 1, p2);
      if (d2) return d2;
    }
    return false;
  }
  n.allow_permutations && ("*" === e2 ? s = ![...t2, ...r].some(((e3) => ["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(e3[0]))) : "+" !== e2 && "=" !== e2 && "and" !== e2 && "or" !== e2 && "ne" !== e2 && "union" !== e2 && "intersect" !== e2 || (s = true));
  var c2 = {}, l = [...Array(t2.length).keys()];
  if (s) {
    let e3 = u(l, 0, {});
    return !!e3 && (c2 = e3.matches, e3.skipped.length > 0 && (c2._skipped = e3.skipped), c2);
  }
  {
    let e3, r2 = i2 ? t2.length - o : 0, n3 = [];
    for (let i3 = 0; i3 <= r2 && (e3 = u(l, 0, {}), !e3); i3++) l = l.slice(1), n3.push(t2[i3]);
    return !!e3 && (c2 = e3.matches, e3.skipped.length > 0 && (c2._skipped = e3.skipped), n3.length > 0 && (c2._skipped_before = n3), c2);
  }
}
function matchImplicitIdentity$1(e2, t2, r) {
  var n = t2[0], i2 = t2.slice(1);
  if ("+" !== n && "*" !== n && "^" !== n) return false;
  var a = [];
  for (let e3 = 0; e3 < i2.length; e3++) {
    let t3 = i2[e3];
    "string" == typeof t3 && r.allow_implicit_identities.includes(t3) && a.push(t3);
  }
  if (0 === a.length) return false;
  for (let n3 of a) {
    let i3 = match_one_implicit_identity$1(e2, t2, r, n3);
    if (i3) return i3;
  }
  return false;
}
function match_one_implicit_identity$1(e2, t2, r, n) {
  var i2 = t2[0], a = t2.slice(1), o = {};
  o[n] = "+" === i2 ? 0 : 1, "*" === i2 && a.includes(n) && Array.isArray(e2) && "-" === e2[0] && (o[n] = -1, e2 = e2[1]);
  var s = a.indexOf(n);
  if (a.splice(s, 1), "^" === i2 && 0 === s) return false;
  t2 = 1 === a.length ? a[0] : [i2].concat(a);
  var u = match$2$1(e2, t2, r);
  return !!u && (!(n in u && !equal$1(u[n], o[n])) && (Object.assign(o, u), o));
}
const substitute$1$1 = function(e2, t2) {
  return "number" == typeof e2 || "boolean" == typeof e2 ? e2 : "string" == typeof e2 ? void 0 !== t2[e2] ? deepClone$1(t2[e2]) : e2 : Array.isArray(e2) ? [e2[0]].concat(e2.slice(1).map((function(e3) {
    return substitute$1$1(e3, t2);
  }))) : [];
}, transform$1 = function(e2, t2) {
  if (Array.isArray(e2)) {
    let r = [e2[0]];
    for (let n = 1; n < e2.length; n++) r.push(transform$1(e2[n], t2));
    return t2(r);
  }
  return t2(e2);
}, applyAllTransformations$1 = function(e2, t2, r) {
  void 0 === r && (r = 5);
  for (var n, i2 = e2; r > 0; r--) {
    n = i2;
    for (let e3 = 0; e3 < t2.length; e3++) {
      let r2 = t2[e3][0], n3 = t2[e3][1], a = t2[e3][2];
      void 0 === a && (a = {}), i2 = transform$1(i2, (function(e4) {
        let t3 = match$2$1(e4, r2, a);
        if (t3) {
          let e5 = substitute$1$1(n3, t3);
          a.evaluate_numbers && (e5 = evaluate_numbers$1(e5, { max_digits: a.max_digits }));
          let i3 = [], o = [];
          return t3._skipped && (i3 = t3._skipped), t3._skipped_before && (o = t3._skipped_before), (o.length > 0 || i3.length > 0) && (Array.isArray(e5) && (e5 = e5[0] === r2[0] ? e5.slice(1) : [e5]), e5 = [r2[0]].concat(o, e5, i3)), a.evaluate_numbers && (e5 = evaluate_numbers$1(e5, { max_digits: a.max_digits })), e5;
        }
        return e4;
      }));
    }
    if (equal$1(n, i2)) return i2;
  }
  return i2;
};
var math$2 = math$1$1;
const operators$2$1 = { "+": function(e2) {
  return 1 === e2.length ? e2[0] : new math$2.OperatorNode("+", "add", e2);
}, "*": function(e2) {
  return new math$2.OperatorNode("*", "multiply", e2);
}, "/": function(e2) {
  return new math$2.OperatorNode("/", "divide", e2);
}, "-": function(e2) {
  return new math$2.OperatorNode("-", "unaryMinus", [e2[0]]);
}, "^": function(e2) {
  return new math$2.OperatorNode("^", "pow", e2);
}, vector: function(e2) {
  return new math$2.ArrayNode(e2);
}, altvector: function(e2) {
  return new math$2.ArrayNode(e2);
}, and: function(e2) {
  return new math$2.OperatorNode("and", "and", e2);
}, or: function(e2) {
  return new math$2.OperatorNode("or", "or", e2);
}, not: function(e2) {
  return new math$2.OperatorNode("not", "not", [e2[0]]);
}, "<": function(e2) {
  return new math$2.OperatorNode("<", "smaller", e2);
}, ">": function(e2) {
  return new math$2.OperatorNode(">", "larger", e2);
}, le: function(e2) {
  return new math$2.OperatorNode("<=", "smallerEq", e2);
}, ge: function(e2) {
  return new math$2.OperatorNode(">=", "largerEq", e2);
}, ne: function(e2) {
  return new math$2.OperatorNode("!=", "unequal", e2);
}, binom: function(e2) {
  const t2 = new math$2.SymbolNode("combinations");
  return new math$2.FunctionNode(t2, e2);
} }, functionConverstions$1 = { nCr: "combinations", nPr: "permutations", binom: "combinations" };
let astToMathjs$1$1 = class astToMathjs$12 {
  constructor({ mathjs: e2 = null } = {}) {
    e2 && (math$2 = e2);
  }
  convert(e2) {
    if ("number" == typeof e2) return Number.isFinite(e2) ? new math$2.ConstantNode(e2) : Number.isNaN(e2) ? new math$2.SymbolNode("NaN") : e2 < 0 ? operators$2$1["-"]([new math$2.SymbolNode("Infinity")]) : new math$2.SymbolNode("Infinity");
    if ("string" == typeof e2) return new math$2.SymbolNode(e2);
    if ("boolean" == typeof e2) throw Error("no support for boolean");
    if (!Array.isArray(e2)) throw Error("Invalid ast");
    const t2 = e2[0], r = e2.slice(1);
    if ("apply" === t2) {
      if ("string" != typeof r[0]) throw Error("Non string functions not implemented for conversion to mathjs");
      if ("factorial" === r[0]) return new math$2.OperatorNode("!", "factorial", [this.convert(r[1])]);
      let e3 = functionConverstions$1[r[0]];
      e3 || (e3 = r[0]);
      const t3 = new math$2.SymbolNode(e3), n = r[1];
      let i2;
      return i2 = "tuple" === n[0] ? n.slice(1).map((function(e4, t4) {
        return this.convert(e4);
      }).bind(this)) : [this.convert(n)], "count" === r[0] && (!(i2.length > 2) && i2[0] instanceof math$2.ArrayNode || (i2 = [new math$2.ArrayNode(i2)])), new math$2.FunctionNode(t3, i2);
    }
    if ("lts" === t2 || "gts" === t2) {
      const e3 = r[0], n = r[1];
      if ("tuple" !== e3[0] || "tuple" !== n[0]) throw new Error("Badly formed ast");
      const i2 = e3.slice(1).map((function(e4, t3) {
        return this.convert(e4);
      }).bind(this));
      let a = [];
      for (let r2 = 1; r2 < e3.length - 1; r2++) n[r2] ? "lts" === t2 ? a.push(new math$2.OperatorNode("<", "smaller", i2.slice(r2 - 1, r2 + 1))) : a.push(new math$2.OperatorNode(">", "larger", i2.slice(r2 - 1, r2 + 1))) : "lts" === t2 ? a.push(new math$2.OperatorNode("<=", "smallerEq", i2.slice(r2 - 1, r2 + 1))) : a.push(new math$2.OperatorNode(">=", "largerEq", i2.slice(r2 - 1, r2 + 1)));
      let o = new math$2.OperatorNode("and", "and", a.slice(0, 2));
      for (let e4 = 2; e4 < a.length; e4++) o = new math$2.OperatorNode("and", "and", [o, a[e4]]);
      return o;
    }
    if ("=" === t2) {
      let e3 = r.map((function(e4, t4) {
        return this.convert(e4);
      }).bind(this)), t3 = [];
      for (let r2 = 1; r2 < e3.length; r2++) t3.push(new math$2.OperatorNode("==", "equal", e3.slice(r2 - 1, r2 + 1)));
      if (1 === t3.length) return t3[0];
      let n = new math$2.OperatorNode("and", "and", t3.slice(0, 2));
      for (let e4 = 2; e4 < t3.length; e4++) n = new math$2.OperatorNode("and", "and", [n, t3[e4]]);
      return n;
    }
    if ("in" === t2 || "notin" === t2 || "ni" === t2 || "notni" === t2) {
      let e3, n;
      if ("in" === t2 || "notin" === t2 ? (e3 = r[0], n = r[1]) : (e3 = r[1], n = r[0]), "number" != typeof e3 && "string" != typeof e3) throw Error("Set membership non-string variables not implemented for conversion to mathjs");
      if (e3 = this.convert(e3), "interval" !== n[0]) throw Error("Set membership in non-intervals not implemented for conversion to mathjs");
      let i2 = n[1], a = n[2];
      if ("tuple" !== i2[0] || "tuple" !== a[0]) throw new Error("Badly formed ast");
      let o = this.convert(i2[1]), s = this.convert(i2[2]), u = [];
      a[1] ? u.push(new math$2.OperatorNode(">=", "largerEq", [e3, o])) : u.push(new math$2.OperatorNode(">", "larger", [e3, o])), a[2] ? u.push(new math$2.OperatorNode("<=", "smallerEq", [e3, s])) : u.push(new math$2.OperatorNode("<", "smaller", [e3, s]));
      let c2 = new math$2.OperatorNode("and", "and", u);
      return "notin" !== t2 && "notni" !== t2 || (c2 = new math$2.OperatorNode("not", "not", [c2])), c2;
    }
    if ("subset" === t2 || "notsubset" === t2 || "superset" === t2 || "notsuperset" === t2) {
      let e3, n;
      if ("subset" === t2 || "notsubset" === t2 ? (n = r[0], e3 = r[1]) : (n = r[1], e3 = r[0]), "interval" !== n[0] || "interval" !== e3[0]) throw Error("Set containment of non-intervals not implemented for conversion to mathjs");
      let i2 = n[1], a = n[2], o = e3[1], s = e3[2];
      if ("tuple" !== i2[0] || "tuple" !== a[0] || "tuple" !== o[0] || "tuple" !== s[0]) throw Error("Badly formed ast");
      let u = this.convert(i2[1]), c2 = this.convert(i2[2]), l = this.convert(o[1]), f2 = this.convert(o[2]), p = [];
      a[1] && !s[1] ? p.push(new math$2.OperatorNode(">", "larger", [u, l])) : p.push(new math$2.OperatorNode(">=", "largerEq", [u, l])), a[2] && !s[2] ? p.push(new math$2.OperatorNode("<", "smaller", [c2, f2])) : p.push(new math$2.OperatorNode("<=", "smallerEq", [c2, f2]));
      let m = new math$2.OperatorNode("and", "and", p);
      return "notsubset" !== t2 && "notsuperset" !== t2 || (m = new math$2.OperatorNode("not", "not", [m])), m;
    }
    if ("matrix" === t2) {
      let e3 = r[0], t3 = e3[1], n = e3[2], i2 = r[1];
      if (!Number.isInteger(t3) || !Number.isInteger(n)) throw Error("Matrix must have integer dimensions");
      let a = [];
      for (let e4 = 1; e4 <= t3; e4++) {
        let t4 = [];
        for (let r2 = 1; r2 <= n; r2++) t4.push(this.convert(i2[e4][r2]));
        a.push(new math$2.ArrayNode(t4));
      }
      return new math$2.ArrayNode(a);
    }
    if ("array" === t2) {
      let e3 = r.map(((e4) => this.convert(e4)));
      return new math$2.ArrayNode(e3);
    }
    if (t2 in operators$2$1) return operators$2$1[t2](r.map((function(e3, t3) {
      return this.convert(e3);
    }).bind(this)));
    throw Error("Operator " + t2 + " not implemented for conversion to mathjs");
  }
};
var sieve$1, hasRequiredSieve$1, factor$1, hasRequiredFactor$1, inc_mixed$1, hasRequiredInc_mixed$1, divisors$1, hasRequiredDivisors$1, prime_factors$1, hasRequiredPrime_factors$1, euler_phi$1, hasRequiredEuler_phi$1, gcd$1$1, hasRequiredGcd$1, find_divisor$1, hasRequiredFind_divisor$1, inverse_mod$1, hasRequiredInverse_mod$1, is_abundant$1, hasRequiredIs_abundant$1, is_deficient$1, hasRequiredIs_deficient$1, is_heptagonal$1, hasRequiredIs_heptagonal$1, is_hexagonal$1, hasRequiredIs_hexagonal$1, is_octagonal$1, hasRequiredIs_octagonal$1, is_pentagonal$1, hasRequiredIs_pentagonal$1, is_perfect$1, hasRequiredIs_perfect$1, is_prime$1, hasRequiredIs_prime$1, multiply_mod$1, hasRequiredMultiply_mod$1, power_mod$1, hasRequiredPower_mod$1, miller$1, hasRequiredMiller$1, is_square$1, hasRequiredIs_square$1, is_triangular$1, hasRequiredIs_triangular$1, jacobi_symbol$1, hasRequiredJacobi_symbol$1, log_mod$1, hasRequiredLog_mod$1;
function requireSieve$1() {
  return hasRequiredSieve$1 ? sieve$1 : (hasRequiredSieve$1 = 1, sieve$1 = function(e2) {
    for (var t2 = new Array(e2), r = 0; r < e2; r++) t2[r] = true;
    for (r = 2; r < Math.sqrt(e2); r++) for (var n = r * r; n < e2; n += r) t2[n] = false;
    var i2 = [];
    for (r = 2; r < e2; r++) t2[r] && i2.push(r);
    return i2;
  });
}
function requireFactor$1() {
  if (hasRequiredFactor$1) return factor$1;
  hasRequiredFactor$1 = 1;
  var e2 = requireSieve$1(), t2 = e2(1e5);
  return factor$1 = function(r) {
    (!t2 || t2[t2.length - 1] < r) && (t2 = e2(r));
    for (var n = [], i2 = 0; i2 < t2.length && r > 1; i2++) {
      var a = t2[i2];
      if (r % a == 0) {
        for (var o = { prime: a, power: 0 }; r % a == 0; ) o.power++, r /= a;
        n.push(o);
      }
    }
    return r > 1 && n.push({ prime: r, power: 1 }), n;
  };
}
function requireInc_mixed$1() {
  return hasRequiredInc_mixed$1 || (hasRequiredInc_mixed$1 = 1, inc_mixed$1 = function(e2, t2) {
    var r = e2.map((function(e3) {
      return e3;
    }));
    r[0]++;
    for (var n = 0; n < e2.length && !(r[n] <= t2[n]); n++) n !== e2.length - 1 ? (r[n] = 0, r[n + 1]++) : r[n] = 0;
    return r;
  }), inc_mixed$1;
}
function requireDivisors$1() {
  if (hasRequiredDivisors$1) return divisors$1;
  hasRequiredDivisors$1 = 1;
  var e2 = requireFactor$1(), t2 = requireInc_mixed$1();
  return divisors$1 = function(r) {
    for (var n = e2(r), i2 = n.map((function(e3) {
      return 0;
    })), a = n.map((function(e3) {
      return e3.power;
    })), o = [1]; ; ) {
      var s = (i2 = t2(i2, a)).map((function(e3, t3) {
        return Math.pow(n[t3].prime, e3);
      })).reduce((function(e3, t3) {
        return e3 * t3;
      }), 1);
      if (1 === s) break;
      o.push(s);
    }
    return o.sort((function(e3, t3) {
      return parseInt(e3) - parseInt(t3);
    })), o;
  };
}
function requirePrime_factors$1() {
  if (hasRequiredPrime_factors$1) return prime_factors$1;
  hasRequiredPrime_factors$1 = 1;
  var e2 = requireFactor$1();
  return prime_factors$1 = function(t2) {
    return e2(t2).map((function(e3) {
      return e3.prime;
    }));
  }, prime_factors$1;
}
function requireEuler_phi$1() {
  if (hasRequiredEuler_phi$1) return euler_phi$1;
  hasRequiredEuler_phi$1 = 1;
  var e2 = requirePrime_factors$1();
  return euler_phi$1 = function(t2) {
    var r = function(e3) {
      return e3.reduce((function(e4, t3) {
        return e4 * t3;
      }), 1);
    }, n = e2(t2);
    return t2 * r(n.map((function(e3) {
      return e3 - 1;
    }))) / r(n);
  }, euler_phi$1;
}
function requireGcd$1() {
  return hasRequiredGcd$1 ? gcd$1$1 : (hasRequiredGcd$1 = 1, gcd$1$1 = function(e2, t2) {
    for (e2 < 0 && (e2 = -e2), t2 < 0 && (t2 = -t2); ; ) {
      if (0 === t2) return e2;
      if (0 === (e2 %= t2)) return t2;
      t2 %= e2;
    }
  });
}
function requireFind_divisor$1() {
  if (hasRequiredFind_divisor$1) return find_divisor$1;
  hasRequiredFind_divisor$1 = 1;
  var e2 = requireGcd$1();
  return find_divisor$1 = function(t2) {
    for (var r, n = 2 * Math.floor(Math.sqrt(Math.sqrt(t2))), i2 = 2, a = i2, o = 1; o < n; o++) if (1 != (r = e2((a = ((a = (a * a + 1) % t2) * a + 1) % t2) - (i2 = (i2 * i2 + 1) % t2), t2))) return r;
    return 1;
  };
}
function requireInverse_mod$1() {
  return hasRequiredInverse_mod$1 ? inverse_mod$1 : (hasRequiredInverse_mod$1 = 1, inverse_mod$1 = function(e2, t2) {
    e2 < 0 && (e2 = e2 % t2 + t2);
    for (var r = 0, n = 1, i2 = t2, a = e2; 0 !== a; ) {
      var o = Math.floor(i2 / a), s = r;
      r = n, n = s - o * n;
      var u = i2;
      i2 = a, a = u - o * a;
    }
    return i2 > 1 ? NaN : r > 0 ? r : r + t2;
  });
}
function requireIs_abundant$1() {
  if (hasRequiredIs_abundant$1) return is_abundant$1;
  hasRequiredIs_abundant$1 = 1;
  var e2 = requireDivisors$1();
  return is_abundant$1 = function(t2) {
    if (1 === t2) return false;
    var r = e2(t2);
    return r.pop(), t2 < r.reduce((function(e3, t3) {
      return e3 + t3;
    }));
  };
}
function requireIs_deficient$1() {
  if (hasRequiredIs_deficient$1) return is_deficient$1;
  hasRequiredIs_deficient$1 = 1;
  var e2 = requireDivisors$1();
  return is_deficient$1 = function(t2) {
    if (1 === t2) return true;
    var r = e2(t2);
    return r.pop(), t2 > r.reduce((function(e3, t3) {
      return e3 + t3;
    }));
  };
}
function requireIs_heptagonal$1() {
  return hasRequiredIs_heptagonal$1 ? is_heptagonal$1 : (hasRequiredIs_heptagonal$1 = 1, is_heptagonal$1 = function(e2) {
    return (Math.sqrt(40 * e2 + 9) + 3) / 10 % 1 == 0;
  });
}
function requireIs_hexagonal$1() {
  return hasRequiredIs_hexagonal$1 ? is_hexagonal$1 : (hasRequiredIs_hexagonal$1 = 1, is_hexagonal$1 = function(e2) {
    return (Math.sqrt(8 * e2 + 1) + 1) / 4 % 1 == 0;
  });
}
function requireIs_octagonal$1() {
  return hasRequiredIs_octagonal$1 ? is_octagonal$1 : (hasRequiredIs_octagonal$1 = 1, is_octagonal$1 = function(e2) {
    return (Math.sqrt(3 * e2 + 1) + 1) / 3 % 1 == 0;
  });
}
function requireIs_pentagonal$1() {
  return hasRequiredIs_pentagonal$1 ? is_pentagonal$1 : (hasRequiredIs_pentagonal$1 = 1, is_pentagonal$1 = function(e2) {
    return (Math.sqrt(24 * e2 + 1) + 1) / 6 % 1 == 0;
  });
}
function requireIs_perfect$1() {
  if (hasRequiredIs_perfect$1) return is_perfect$1;
  hasRequiredIs_perfect$1 = 1;
  var e2 = requireDivisors$1();
  return is_perfect$1 = function(t2) {
    if (1 === t2) return false;
    var r = e2(t2);
    return r.pop(), t2 === r.reduce((function(e3, t3) {
      return e3 + t3;
    }));
  };
}
function requireIs_prime$1() {
  if (hasRequiredIs_prime$1) return is_prime$1;
  hasRequiredIs_prime$1 = 1;
  var e2 = requireFactor$1();
  return is_prime$1 = function(t2) {
    var r = e2(t2);
    return 1 == r.length && 1 === r[0].power;
  };
}
function requireMultiply_mod$1() {
  return hasRequiredMultiply_mod$1 ? multiply_mod$1 : (hasRequiredMultiply_mod$1 = 1, multiply_mod$1 = function(e2, t2, r) {
    if (e2 < 94906265 && t2 < 94906265) return e2 * t2 % r;
    var n = 0, i2 = r / 2;
    e2 >= r && (e2 %= r), t2 >= r && (t2 %= r);
    for (var a = 0; a < 53; a++) n = n >= i2 ? 2 * n - r : 2 * n, e2 >= 4503599627370496 && (n += t2, e2 -= 4503599627370495), n > r && (n -= r), e2 *= 2;
    return n;
  });
}
function requirePower_mod$1() {
  if (hasRequiredPower_mod$1) return power_mod$1;
  hasRequiredPower_mod$1 = 1;
  var e2 = requireMultiply_mod$1(), t2 = requireInverse_mod$1();
  return power_mod$1 = function r(n, i2, a) {
    if (i2 < 0) return t2(r(n, -i2, a), a);
    var o = 1;
    for (n %= a; i2 > 0; ) i2 % 2 == 1 && (o = e2(o, n, a), i2 -= 1), i2 /= 2, n = e2(n, n, a);
    return o;
  }, power_mod$1;
}
function requireMiller$1() {
  if (hasRequiredMiller$1) return miller$1;
  hasRequiredMiller$1 = 1;
  var e2 = requireMultiply_mod$1(), t2 = requirePower_mod$1();
  return miller$1 = function(r) {
    if (r < 2) return false;
    if (2 == r || 3 == r) return true;
    if (!(1 & r) || r % 3 == 0) return false;
    for (var n, i2 = r - 1, a = 0; i2 % 2 == 0; ) i2 /= 2, a += 1;
    n = r < 1373653 ? [2, 3] : r < 9080191 ? [31, 73] : r < 4759123141 ? [2, 7, 61] : r < 1122004669633 ? [2, 13, 23, 1662803] : r < 2152302898747 ? [2, 3, 5, 7, 11] : r < 3474749660383 ? [2, 3, 5, 7, 11, 13] : [2, 3, 5, 7, 11, 13, 17];
    for (var o = 0; o < n.length; o++) {
      for (var s = n[o], u = t2(s, i2, r), c2 = 0, l = a; l > 0; ) {
        if (1 === (c2 = e2(u, u, r)) && 1 !== u && u !== r - 1) return false;
        u = c2, --l;
      }
      if (1 !== c2) return false;
    }
    return true;
  };
}
function requireIs_square$1() {
  return hasRequiredIs_square$1 ? is_square$1 : (hasRequiredIs_square$1 = 1, is_square$1 = function(e2) {
    return Math.sqrt(e2) % 1 == 0;
  });
}
function requireIs_triangular$1() {
  return hasRequiredIs_triangular$1 ? is_triangular$1 : (hasRequiredIs_triangular$1 = 1, is_triangular$1 = function(e2) {
    return Math.sqrt(8 * e2 + 1) % 1 == 0;
  });
}
function requireJacobi_symbol$1() {
  return hasRequiredJacobi_symbol$1 ? jacobi_symbol$1 : (hasRequiredJacobi_symbol$1 = 1, jacobi_symbol$1 = function(e2, t2) {
    if (t2 % 2 == 0) return NaN;
    if (t2 < 0) return NaN;
    e2 < 0 && (e2 = e2 % t2 + t2);
    for (var r = 0; ; ) {
      if (0 === (e2 %= t2)) return 0;
      for (; e2 % 2 == 0; ) r ^= (t2 % 8 * (t2 % 8) - 1) / 8, e2 /= 2;
      if (1 == e2) return 1 & r ? -1 : 1;
      r ^= (e2 % 4 - 1) * (t2 % 4 - 1) / 4;
      var n = e2;
      e2 = t2, t2 = n;
    }
    return NaN;
  });
}
function requireLog_mod$1() {
  if (hasRequiredLog_mod$1) return log_mod$1;
  hasRequiredLog_mod$1 = 1;
  var e2 = requirePower_mod$1(), t2 = requireMultiply_mod$1(), r = {};
  return log_mod$1 = function(n, i2, a) {
    n = (n % a + a) % a;
    var o = Math.ceil(Math.sqrt(a)), s = {};
    if (void 0 === r[a] && (r[a] = {}), void 0 === r[a][i2]) {
      r[a][i2] = {}, s = r[a][i2];
      for (var u = 0; u < o; u++) s[e2(i2, u, a)] = u;
    } else s = r[a][i2];
    for (var c2 = e2(i2, -o, a), l = n, f2 = 0; f2 < o; f2++) {
      if (void 0 !== s[l]) return (t2(f2, o, a) + s[l]) % a;
      l = t2(l, c2, a);
    }
    return NaN;
  };
}
var require$$0$2 = getAugmentedNamespace$2(indexAll$1), primitive_root$1, hasRequiredPrimitive_root$1, quadratic_nonresidue$1, hasRequiredQuadratic_nonresidue$1, random_primitive_root$1, hasRequiredRandom_primitive_root$1, square_root_mod_prime$1, hasRequiredSquare_root_mod_prime$1, square_root_mod$1, hasRequiredSquare_root_mod$1, numberTheory$1$1, hasRequiredNumberTheory$1;
function requirePrimitive_root$1() {
  if (hasRequiredPrimitive_root$1) return primitive_root$1;
  hasRequiredPrimitive_root$1 = 1;
  var e2 = require$$0$2, t2 = requireEuler_phi$1(), r = requirePrime_factors$1(), n = requirePower_mod$1();
  return primitive_root$1 = function(i2) {
    for (var a = t2(i2), o = r(a), s = 2; s < i2; s++) {
      if (e2.every(o, (function(e3) {
        return 1 != n(s, a / e3, i2);
      }))) return s;
    }
    return NaN;
  };
}
function requireQuadratic_nonresidue$1() {
  if (hasRequiredQuadratic_nonresidue$1) return quadratic_nonresidue$1;
  hasRequiredQuadratic_nonresidue$1 = 1;
  var e2 = requireJacobi_symbol$1();
  return quadratic_nonresidue$1 = function(t2) {
    for (var r = 2; r < t2; r++) if (-1 == e2(r, t2)) return r;
    return NaN;
  };
}
function requireRandom_primitive_root$1() {
  if (hasRequiredRandom_primitive_root$1) return random_primitive_root$1;
  hasRequiredRandom_primitive_root$1 = 1;
  var e2 = requirePrimitive_root$1(), t2 = requireEuler_phi$1(), r = requireGcd$1(), n = requirePower_mod$1();
  return random_primitive_root$1 = function(i2) {
    for (var a = e2(i2), o = t2(i2), s = 0; s < 100; s++) {
      var u = Math.floor(Math.random() * o);
      if (1 == r(u, o)) return n(a, u, i2);
    }
    return a;
  };
}
function requireSquare_root_mod_prime$1() {
  if (hasRequiredSquare_root_mod_prime$1) return square_root_mod_prime$1;
  hasRequiredSquare_root_mod_prime$1 = 1;
  var e2 = requireJacobi_symbol$1(), t2 = requirePower_mod$1(), r = requireQuadratic_nonresidue$1();
  return square_root_mod_prime$1 = function(n, i2) {
    if (1 != e2(n, i2)) return NaN;
    for (var a = i2 - 1, o = 0; a % 2 == 0; ) a /= 2, o++;
    if (i2 % 4 == 3) return t2(n, (i2 + 1) / 4, i2);
    for (var s = r(i2), u = t2(s, a, i2), c2 = t2(n, (a + 1) / 2, i2), l = t2(n, a, i2), f2 = o; ; ) {
      if (l % i2 == 1) return c2;
      for (var p = l, m = 1; m < f2 && 1 != (p = p * p % i2); m++) ;
      var d = m;
      m++;
      for (var h = u; m < f2; ) h = h * h % i2, m++;
      f2 = d, c2 = c2 * h % i2, l = l * h * h % i2, u = h * h % i2;
    }
    return NaN;
  }, square_root_mod_prime$1;
}
function requireSquare_root_mod$1() {
  if (hasRequiredSquare_root_mod$1) return square_root_mod$1;
  hasRequiredSquare_root_mod$1 = 1;
  var e2 = require$$0$2, t2 = requireFactor$1(), r = requireSquare_root_mod_prime$1(), n = requireJacobi_symbol$1(), i2 = requireInverse_mod$1(), a = requireMultiply_mod$1();
  return square_root_mod$1 = function(o, s) {
    var u = 1, c2 = [0];
    return t2(s).forEach((function(t3) {
      var s2 = t3.prime, l = t3.power, f2 = r(o, s2), p = [];
      if (1 != n(o, s2)) return [];
      c2.forEach((function(e3) {
        p.unshift(e3 * s2 * i2(s2, u) + f2 * u * i2(u, s2)), p.unshift(e3 * s2 * i2(s2, u) - f2 * u * i2(u, s2));
      })), p.sort(), c2 = e2.unique(p), u *= s2;
      for (l--; l > 0; ) {
        var m = Math.pow(s2, Math.min(1, l));
        l -= Math.min(1, l), c2 = c2.map((function(e3) {
          var t4 = -(e3 * e3 - o) / u, r2 = i2(2 * e3, m);
          return e3 + u * a(t4, r2, m);
        })), u *= m;
      }
    })), c2.map((function(e3) {
      return (e3 % s + s) % s;
    }));
  }, square_root_mod$1;
}
function requireNumberTheory$1() {
  return hasRequiredNumberTheory$1 ? numberTheory$1$1 : (hasRequiredNumberTheory$1 = 1, numberTheory$1$1 = { divisors: requireDivisors$1(), eulerPhi: requireEuler_phi$1(), factor: requireFactor$1(), findDivisor: requireFind_divisor$1(), gcd: requireGcd$1(), incMixed: requireInc_mixed$1(), inverseMod: requireInverse_mod$1(), isAbundant: requireIs_abundant$1(), isDeficient: requireIs_deficient$1(), isHeptagonal: requireIs_heptagonal$1(), isHexagonal: requireIs_hexagonal$1(), isOctagonal: requireIs_octagonal$1(), isPentagonal: requireIs_pentagonal$1(), isPerfect: requireIs_perfect$1(), isPrime: requireIs_prime$1(), isProbablyPrime: requireMiller$1(), isSquare: requireIs_square$1(), isTriangular: requireIs_triangular$1(), jacobiSymbol: requireJacobi_symbol$1(), logMod: requireLog_mod$1(), miller: requireMiller$1(), multiplyMod: requireMultiply_mod$1(), powerMod: requirePower_mod$1(), primeFactors: requirePrime_factors$1(), primitiveRoot: requirePrimitive_root$1(), quadraticNonresidue: requireQuadratic_nonresidue$1(), randomPrimitiveRoot: requireRandom_primitive_root$1(), sieve: requireSieve$1(), squareRootMod: requireSquare_root_mod$1(), squareRootModPrime: requireSquare_root_mod_prime$1(), totient: requireEuler_phi$1() });
}
var numberTheoryExports$1 = requireNumberTheory$1(), numberTheory$2 = getDefaultExportFromCjs$5(numberTheoryExports$1);
function gcd$3(e2, t2) {
  return Number.isNaN(e2) || Number.isNaN(t2) ? NaN : numberTheory$2.gcd(e2, t2);
}
function flatten$1$1(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.concat(t2);
  }), []);
}
function positiveModulo$1(e2, t2) {
  return (e2 % t2 + t2) % t2;
}
let ZmodN$1 = class ZmodN2 {
  constructor(e2, t2, r = false) {
    this.values = e2.map((function(e3) {
      return positiveModulo$1(e3, t2);
    })), this.modulus = t2, this.approximate = r;
  }
  apply(e2, t2, r) {
    if (null == r || Number.isNaN(r)) {
      if (Number.isNaN(this.modulus) || Number.isNaN(e2.modulus)) return new ZmodN2([NaN], NaN, this.approximate || e2.approximate);
      r = gcd$3(this.modulus, e2.modulus);
    }
    return new ZmodN2(flatten$1$1(this.values.map((function(n) {
      return e2.values.map((function(e3) {
        return Number.isNaN(n) || Number.isNaN(e3) ? NaN : (r + t2(n, e3)) % r;
      }));
    }))), r, this.approximate || e2.approximate);
  }
  add(e2) {
    return this.apply(e2, (function(e3, t2) {
      return e3 + t2;
    }));
  }
  power(e2) {
    var t2 = this.modulus;
    return e2.modulus != numberTheory$2.eulerPhi(t2) ? new ZmodN2([NaN], NaN, this.approximate || e2.approximate) : this.apply(e2, (function(e3, r) {
      return numberTheory$2.powerMod(e3, r, t2);
    }), t2);
  }
  isNaN() {
    for (var e2 of this.values) if (isNaN(e2)) return true;
    return false;
  }
  subtract(e2) {
    return this.apply(e2, (function(e3, t2) {
      return e3 - t2;
    }));
  }
  multiply(e2) {
    var t2 = gcd$3(this.modulus, e2.modulus);
    return this.apply(e2, (function(e3, r) {
      return numberTheory$2.multiplyMod(e3, r, t2);
    }));
  }
  inverse() {
    var e2 = this.modulus;
    return new ZmodN2(this.values.map((function(t2) {
      return numberTheory$2.inverseMod(t2, e2);
    })), this.modulus, this.approximate);
  }
  negate() {
    var e2 = this.modulus;
    return new ZmodN2(this.values.map((function(t2) {
      return e2 - t2;
    })), this.modulus, this.approximate);
  }
  divide(e2) {
    var t2 = gcd$3(this.modulus, e2.modulus), r = flatten$1$1(flatten$1$1(this.values.map((function(r2) {
      return e2.values.map((function(e3) {
        if (r2 % e3 == 0) return [r2 / e3];
        var n = gcd$3(e3, t2);
        if (r2 % n != 0) return [];
        var i2, a = e3 / n, o = r2 / n, s = numberTheory$2.multiplyMod(o, numberTheory$2.inverseMod(a, t2), t2), u = [];
        for (i2 = 0; i2 < n; i2++) u.unshift(s + numberTheory$2.multiplyMod(i2, t2 / n, t2));
        return u;
      }));
    }))));
    return new ZmodN2(r, t2, this.approximate || e2.approximate);
  }
  sqrt() {
    var e2 = this.modulus;
    return new ZmodN2(flatten$1$1(this.values.map((function(t2) {
      return numberTheory$2.squareRootMod(t2, e2);
    }))), this.modulus, this.approximate);
  }
  toString = function() {
    return "{" + this.values.sort().toString() + "}/" + this.modulus.toString();
  };
  equals(e2) {
    return this.toString() == e2.toString();
  }
};
var PRIME$1 = 10739999, levelFunctions$1 = { "+": function(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.add(t2);
  }));
}, "*": function(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.multiply(t2);
  }));
}, "/": function(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.divide(t2);
  }));
}, "-": function(e2) {
  return e2[0].negate();
}, "~": function(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.subtract(t2);
  }), new ZmodN$1([0], e2[0].modulus));
}, factorial: function(e2) {
  return ZmodN$1([NaN], 1);
}, gamma: function(e2) {
  return ZmodN$1([NaN], 1);
} };
function rationalApproximation$1(e2, t2 = 1e15) {
  let r, n = [[1, 0], [0, 1]];
  for (; n[1][0] * (r = Math.floor(e2)) + n[1][1] <= t2; ) {
    let t3;
    if (t3 = n[0][0] * r + n[0][1], n[0][1] = n[0][0], n[0][0] = t3, t3 = n[1][0] * r + n[1][1], n[1][1] = n[1][0], n[1][0] = t3, e2 == r) break;
    if ((e2 = 1 / (e2 - r)) > 2147483647) break;
  }
  const i2 = n[1][0] * r + n[1][1] > t2;
  return { numerator: n[0][0], denominator: n[1][0], approximate: i2 };
}
function finite_field_evaluate_ast$1(e2, t2, r, n) {
  if ("string" == typeof e2) return "e" === e2 ? new ZmodN$1([numberTheory$2.primitiveRoot(r)], r) : "pi" === e2 ? new ZmodN$1(r % 2 == 0 ? [r / 2] : [NaN], r) : "i" === e2 ? new ZmodN$1([0], 1) : e2 in t2 ? new ZmodN$1([t2[e2]], r) : e2;
  if ("number" == typeof e2) {
    if (Number.isInteger(e2)) return new ZmodN$1([e2], r);
    {
      let t3 = rationalApproximation$1(e2), n3 = new ZmodN$1([t3.numerator], r, t3.approximate), i3 = new ZmodN$1([t3.denominator], r, t3.approximate);
      return n3.divide(i3);
    }
  }
  var i2 = e2[0], a = e2.slice(1);
  if ("apply" === i2) {
    if ("string" != typeof a[0]) throw Error("Non string functions not implemented for finite fields");
    if ("exp" === a[0]) {
      var o = finite_field_evaluate_ast$1("e", {}, r), s = finite_field_evaluate_ast$1(a[1], t2, numberTheory$2.eulerPhi(r));
      return o.power(s);
    }
    if ("sec" === a[0]) return finite_field_evaluate_ast$1(["/", 1, ["apply", "cos", a[1]]], t2, r);
    if ("csc" === a[0]) return finite_field_evaluate_ast$1(["/", 1, ["apply", "sin", a[1]]], t2, r);
    if ("cot" === a[0]) return finite_field_evaluate_ast$1(["/", 1, ["apply", "tan", a[1]]], t2, r);
    if ("tan" === a[0]) {
      var u = numberTheory$2.eulerPhi(r);
      return finite_field_evaluate_ast$1(["/", ["apply", "sin", a[1]], ["apply", "cos", a[1]]], t2, r);
    }
    if ("sin" === a[0]) {
      var c2 = numberTheory$2.primitiveRoot(r), l = new ZmodN$1([c2], r);
      if ((u = numberTheory$2.eulerPhi(r)) % 4 != 0) return new ZmodN$1([NaN], r);
      var f2 = new ZmodN$1([numberTheory$2.powerMod(c2, u / 4, r)], r), p = finite_field_evaluate_ast$1(a[1], t2, u);
      return l.power(p).subtract(l.power(p.negate())).divide(f2.add(f2));
    }
    if ("cos" === a[0]) {
      l = new ZmodN$1([numberTheory$2.primitiveRoot(r)], r), p = finite_field_evaluate_ast$1(a[1], t2, numberTheory$2.eulerPhi(r));
      return l.power(p).add(l.power(p.negate())).divide(new ZmodN$1([2], r));
    }
    if ("log" === a[0]) return new ZmodN$1([NaN], NaN);
    if ("sqrt" === a[0]) return finite_field_evaluate_ast$1(a[1], t2, r).sqrt();
    if ("abs" === a[0]) {
      let e3 = finite_field_evaluate_ast$1(a[1], t2, r);
      return e3.multiply(e3).sqrt();
    }
  }
  if ("^" == i2) {
    o = finite_field_evaluate_ast$1(a[0], t2, r), s = finite_field_evaluate_ast$1(a[1], t2, numberTheory$2.eulerPhi(r));
    return o.power(s);
  }
  return i2 in levelFunctions$1 ? levelFunctions$1[i2](a.map((function(e3, n3) {
    return finite_field_evaluate_ast$1(e3, t2, r);
  }))) : new ZmodN$1([NaN], r);
}
let astToFiniteField$1$1 = class astToFiniteField$12 {
  constructor() {
  }
  convert(e2, t2, r = PRIME$1) {
    return finite_field_evaluate_ast$1(e2, t2, r);
  }
};
var function_normalizations$1 = { ln: "log", arccos: "acos", arccosh: "acosh", arcsin: "asin", arcsinh: "asinh", arctan: "atan", arctanh: "atanh", arcsec: "asec", arcsech: "asech", arccsc: "acsc", arccsch: "acsch", arccot: "acot", arccoth: "acoth", cosec: "csc" }, create_trig_inverses_for$1 = ["cos", "cosh", "sin", "sinh", "tan", "tanh", "sec", "sech", "csc", "csch", "cot", "coth"], move_exponents_outside_for$1 = ["cos", "cosh", "sin", "sinh", "tan", "tanh", "sec", "sech", "csc", "csch", "cot", "coth", "log", "ln"];
function normalize_function_names$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("apply" === r) {
    if ("sqrt" === n[0]) return ["^", normalize_function_names$1(n[1]), 0.5];
    var i2 = normalize_function_names_sub$1(n[0]);
    i2 = ["apply", i2];
    var a = n.slice(1).map((function(e3) {
      return normalize_function_names$1(e3);
    }));
    return a = a.length > 1 ? ["tuple"].concat(a) : a[0], i2.push(a), i2;
  }
  return "^" === r && "e" === n[0] && math$1$1.define_e ? ["apply", "exp", normalize_function_names$1(n[1])] : "binom" === r ? ["apply", "nCr", ["tuple", normalize_function_names$1(n[0]), normalize_function_names$1(n[1])]] : [r].concat(n.map((function(e3) {
    return normalize_function_names$1(e3);
  })));
}
function normalize_function_names_sub$1(e2) {
  if ("string" == typeof e2) return e2 in function_normalizations$1 ? function_normalizations$1[e2] : e2;
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if ("^" === t2 && 2 === r.length && -1 === r[1]) {
    let e3 = normalize_function_names_sub$1(r[0]);
    if (create_trig_inverses_for$1.includes(e3)) return "a" + e3;
  }
  return [t2].concat(r.map((function(e3) {
    return normalize_function_names_sub$1(e3);
  })));
}
function normalize_applied_functions$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("apply" === r) {
    let e3 = n[0];
    if ("^" === e3[0]) {
      let t4 = e3[1], r3 = e3[2];
      return -1 !== r3 && move_exponents_outside_for$1.includes(t4) ? ["^", ["apply", t4, normalize_applied_functions$1(n[1])], r3] : ["apply", e3, normalize_applied_functions$1(n[1])];
    }
    let t3 = 0;
    for (; "prime" === e3[0]; ) t3 += 1, e3 = e3[1];
    let r2 = ["apply", e3, normalize_applied_functions$1(n[1])];
    for (let e4 = 0; e4 < t3; e4++) r2 = ["prime", r2];
    return r2;
  }
  return [r].concat(n.map((function(e3, t3) {
    return normalize_applied_functions$1(e3);
  })));
}
function log_subscript_to_two_arg_log$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  if ("apply" === r && 2 === n.length) {
    let e3 = n[0];
    if (Array.isArray(e3) && 3 === e3.length && "_" === e3[0] && "log" === e3[1]) return ["apply", "log", ["tuple", n[1], e3[2]]];
  }
  return [r, ...n.map(log_subscript_to_two_arg_log$1)];
}
function substitute_abs$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  return "apply" === r && "abs" === n[0] ? ["^", ["^", substitute_abs$1(n[1]), 2], 0.5] : [r].concat(n.map((function(e3) {
    return substitute_abs$1(e3);
  })));
}
function constants_to_floats$1(e2) {
  var t2 = get_tree$1(e2);
  if (!math$1$1.define_e && !math$1$1.define_pi) return t2;
  if ("string" == typeof t2) {
    if ("e" === t2) {
      if (math$1$1.define_e) return math$1$1.e;
    } else if ("pi" === t2 && math$1$1.define_pi) return math$1$1.pi;
    return t2;
  }
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  return "^" === r && "e" === n[0] ? ["^", "e", constants_to_floats$1(n[1])] : [r, ...n.map(constants_to_floats$1)];
}
function normalize_angle_linesegment_arg_order$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  return "angle" === r && 3 === n.length && 1 === compare_function$1(n[0], n[2]) || "linesegment" === r && 2 === n.length && 1 === compare_function$1(n[0], n[1]) ? (n.reverse(), [r, ...n]) : [r, ...n.map(normalize_angle_linesegment_arg_order$1)];
}
function normalize_negative_numbers$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  if ("-" === r && 1 === n.length) {
    if ("number" == typeof n[0] && n[0] >= 0) return -n[0];
    if (Array.isArray(n[0]) && "*" === n[0][0] && "number" == typeof n[0][1] && n[0][1] >= 0) return ["*", -n[0][1], ...n[0].slice(2).map(normalize_negative_numbers$1)];
  }
  return [r, ...n.map(normalize_negative_numbers$1)];
}
var astToMathjs$2 = new astToMathjs$1$1({ mathjs: math$1$1 }), astToFiniteField$2 = new astToFiniteField$1$1();
const f$1 = function(e2) {
  var t2 = get_tree$1(e2), r = factorial_to_gamma_function$1(astToMathjs$2.convert(log_subscript_to_two_arg_log$1(normalize_function_names$1(normalize_applied_functions$1(t2)))));
  return r.evaluate.bind(r);
}, evaluate$2 = function(e2, t2) {
  return f$1(e2)(t2);
}, finite_field_evaluate$1 = function(e2, t2, r) {
  return astToFiniteField$2.convert(e2.tree, t2, r);
}, evaluate_to_constant$1 = function(e2, { remove_units_first: t2 = true, scale_based_on_unit: r = true, nan_for_non_numeric: n = true } = {}) {
  var i2 = get_tree$1(e2);
  if (t2 && (i2 = remove_units$1(i2, r)), "number" == typeof i2) return i2;
  if ("string" == typeof i2) return "pi" === i2 && math$1$1.define_pi ? Math.PI : "e" === i2 && math$1$1.define_e ? Math.E : "i" === i2 && math$1$1.define_i ? { re: 0, im: 1 } : n ? NaN : null;
  if (!Array.isArray(i2)) return n ? NaN : null;
  var a = [];
  a.push([["^", "x", ["/", "m", "n"]], ["^", ["apply", "nthRoot", ["tuple", "x", "n"]], "m"], { variables: { x: (e3) => e3 < 0, n: (e3) => Number.isInteger(e3) && Number.isInteger((e3 - 1) / 2), m: (e3) => Number.isInteger(e3) } }]), a.push([["^", "x", ["-", ["/", "m", "n"]]], ["^", ["apply", "nthRoot", ["tuple", "x", "n"]], ["-", "m"]], { variables: { x: (e3) => e3 < 0, n: (e3) => Number.isInteger(e3) && Number.isInteger((e3 - 1) / 2), m: (e3) => Number.isInteger(e3) } }]), i2 = applyAllTransformations$1(i2, a, 40);
  var o = n ? NaN : null;
  try {
    o = f$1(i2)();
  } catch (e3) {
  }
  if (!Number.isNaN(o) && ("number" == typeof o || "number" == typeof o?.re && "number" == typeof o?.im)) {
    if (o.re === 1 / 0 || o.re === -1 / 0 || o.im === 1 / 0 || o.im === -1 / 0) {
      let e3;
      if ("number" == typeof o?.re && "number" == typeof o?.im) if (0 === o.im) e3 = o.re;
      else {
        let t3;
        t3 = 1 === o.im ? "i" : -1 === o.im ? ["-", "i"] : ["*", o.im, "i"], e3 = 0 === o.re ? t3 : ["+", o.re, t3];
      }
      else e3 = o;
      o = n ? NaN : null;
      try {
        o = f$1(e3)();
      } catch (e4) {
      }
    } else 0 === o.im && (o = o.re);
    return o;
  }
  return "object" == typeof o && (o = n ? NaN : null), o;
};
function factorial_to_gamma_function$1(e2) {
  return e2.transform((function(e3, t2, r) {
    if (e3.isOperatorNode && "!" === e3.op && "factorial" === e3.fn) {
      var n = [new math$1$1.OperatorNode("+", "add", [e3.args[0], new math$1$1.ConstantNode(1)])];
      return new math$1$1.FunctionNode(new math$1$1.SymbolNode("gamma"), n);
    }
    return e3;
  }));
}
var evaluation$1 = Object.freeze({ __proto__: null, f: f$1, evaluate: evaluate$2, finite_field_evaluate: finite_field_evaluate$1, evaluate_to_constant: evaluate_to_constant$1 }), functions$3 = { C: {}, R: {}, nonzeroC: {}, nonneg: {}, pos: {} };
function negate_adjust$1(e2, t2) {
  return e2 ? !t2 : false === e2 ? t2 : void 0;
}
function narrow_assumptions$1(e2, t2) {
  if (!Array.isArray(t2)) return [];
  var r = t2[0], n = t2.slice(1);
  if ("and" !== r) return [];
  for (var i2 = [], a = 0; a < n.length; a++) equal$1(n[a], e2) || i2.push(n[a]);
  return 0 === i2.length ? [] : 1 === i2.legnth ? i2[0] : [r].concat(i2);
}
function simple_assumption_combination$1(e2, t2, r) {
  return "and" === e2 ? void 0 === t2 ? r : void 0 === r ? t2 : t2 || r : void 0 !== t2 && void 0 !== r && t2 === r ? t2 : void 0;
}
function is_integer_ast$1(e2, t2, r) {
  if ("object" != typeof t2 && (t2 = []), void 0 === r && (r = t2), "number" == typeof e2) return Number.isInteger(e2);
  var n = evaluate_to_constant$1(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== n) return Number.isInteger(n);
  if ("string" == typeof e2) {
    let n3;
    if (n3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(n3)) return;
    let i2 = n3, a = n3[0], o = n3.slice(1), s = false;
    for (; "not" === a; ) {
      if (s = !s, n3 = o[0], !Array.isArray(n3)) return;
      a = n3[0], o = n3.slice(1);
    }
    if ("in" === a && o[0] === e2 && "Z" === o[1]) return negate_adjust$1(true, s);
    if ("notin" === a && o[0] === e2 && "Z" === o[1]) return negate_adjust$1(false, s);
    if (false === s) {
      if ("notin" === a) {
        if (o[0] === e2 && "R" === o[1]) return false;
        if (o[0] === e2 && "C" === o[1]) return false;
      }
    } else if ("in" === a) {
      if (o[0] === e2 && "R" === o[1]) return false;
      if (o[0] === e2 && "Z" === o[1]) return false;
    }
    if ("=" === a && !s || "ne" === a && s) {
      let t3 = narrow_assumptions$1(i2, r);
      if (o[0] === e2) return is_integer_ast$1(o[1], t3);
      if (o[1] === e2) return is_integer_ast$1(o[0], t3);
    }
    if ("and" !== a && "or" !== a) return;
    if (s) return;
    return o.length > 2 && (n3 = unflattenRight$1(n3), o = n3.slice(1)), simple_assumption_combination$1(a, is_integer_ast$1(e2, o[0], r), is_integer_ast$1(e2, o[1], r));
  }
  if (Array.isArray(e2)) {
    let n3;
    n3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables$2(e2)]);
    let i2 = e2[0], a = e2.slice(1);
    if ("-" === i2) return is_integer_ast$1(a[0], n3, r);
    if ("*" === i2) {
      return !!a.every((function(e3) {
        return is_integer_ast$1(e3, n3, r);
      })) || void 0;
    }
    if ("^" === i2) {
      let e3 = is_nonzero_ast$1(a[0], n3, r);
      if (e3) {
        if (false === is_nonzero_ast$1(a[1], n3, r)) return a[0] !== 1 / 0 && a[0] !== -1 / 0;
      } else {
        if (Number.isNaN(a[0])) return false;
        if (!is_positive_ast$1(a[1], n3, true, r)) return;
        if (false === e3) return true;
      }
      let t3 = is_integer_ast$1(a[0], n3, r), i3 = is_integer_ast$1(a[1], n3, r);
      if (!t3) return t3;
      if (!i3) return;
      return !!is_positive_ast$1(a[1], n3, false, r) || void 0;
    }
    if ("+" === i2) {
      let e3 = 0;
      for (let t3 = 0; t3 < a.length; t3++) {
        let i3 = is_integer_ast$1(a[t3], n3, r);
        if (false === i3) {
          if (e3 > 0) return;
          e3 += 1;
        }
        if (void 0 === i3) return;
      }
      return 0 === e3;
    }
    if ("apply" === i2) return !!(functions$3.C.Z && functions$3.C.Z.includes(a[0]) && is_complex_ast$1(a[1], n3, r)) || (!!(functions$3.R.Z && functions$3.R.Z.includes(a[0]) && is_real_ast$1(a[1], n3, r)) || (!!(functions$3.nonzeroC.Z && functions$3.nonzeroC.Z.includes(a[0]) && is_nonzero_ast$1(a[1], n3, r) && is_complex_ast$1(a[1], n3, r)) || (!!(functions$3.nonneg.Z && functions$3.nonneg.Z.includes(a[0]) && is_positive_ast$1(a[1], n3, false, r)) || (!!(functions$3.pos.Z && functions$3.pos.Z.includes(a[0]) && is_positive_ast$1(a[1], n3, true, r)) || void 0))));
    if ("/" === i2 || "prime" === i2) return;
    return false;
  }
  return false;
}
function is_real_ast$1(e2, t2, r) {
  if ("object" != typeof t2 && (t2 = []), void 0 === r && (r = t2), "number" == typeof e2) return Number.isFinite(e2);
  var n = evaluate_to_constant$1(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== n) return "number" == typeof n && Number.isFinite(n);
  if ("string" == typeof e2) {
    let n3;
    if (n3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(n3)) return;
    let i2 = n3, a = n3[0], o = n3.slice(1), s = false;
    for (; "not" === a; ) {
      if (s = !s, n3 = o[0], !Array.isArray(n3)) return;
      a = n3[0], o = n3.slice(1);
    }
    if ("in" === a && o[0] === e2 && "R" === o[1]) return negate_adjust$1(true, s);
    if ("notin" === a && o[0] === e2 && "R" === o[1]) return negate_adjust$1(false, s);
    if (false === s) {
      if ("in" === a && o[0] === e2 && "Z" === o[1]) return true;
    } else if ("notin" === a && o[0] === e2 && "Z" === o[1]) return true;
    if ("<" === a || "le" === a) {
      let t3 = variables$2(n3), r2 = functions$2$1(n3);
      if (-1 !== t3.indexOf(e2) && 0 === r2.length) return true;
    }
    if ("=" === a && !s || "ne" === a && s) {
      let t3 = narrow_assumptions$1(i2, r);
      if (o[0] === e2) return is_real_ast$1(o[1], t3);
      if (o[1] === e2) return is_real_ast$1(o[0], t3);
    }
    if ("and" !== a && "or" !== a) return;
    if (s) return;
    return o.length > 2 && (n3 = unflattenRight$1(n3), o = n3.slice(1)), simple_assumption_combination$1(a, is_real_ast$1(e2, o[0], r), is_real_ast$1(e2, o[1], r));
  }
  if (Array.isArray(e2)) {
    let n3;
    n3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables$2(e2)]);
    let i2 = e2[0], a = e2.slice(1);
    if ("-" === i2) return is_real_ast$1(a[0], n3, r);
    if ("*" === i2 || "+" === i2) {
      if (a.length > 2 && (a = (e2 = unflattenRight$1(e2)).slice(1)), "*" === i2 && (false === is_nonzero_ast$1(a[0], n3, r) || false === is_nonzero_ast$1(a[1], n3, r))) return true;
      let t3 = is_real_ast$1(a[0], n3, r), o = is_real_ast$1(a[1], n3, r);
      return !(!t3 || !o) || !(t3 && false === o || o && false === t3) && void 0;
    }
    if ("^" === i2) {
      let e3 = is_nonzero_ast$1(a[0], n3, r), t3 = is_positive_ast$1(a[1], n3, true, r);
      if (e3) {
        if (false === is_nonzero_ast$1(a[1], n3, r)) return a[0] !== 1 / 0 && a[0] !== -1 / 0;
      } else {
        if (Number.isNaN(a[0])) return false;
        if (!t3) return;
        if (false === e3) return true;
      }
      let i3 = is_real_ast$1(a[0], n3, r), o = is_real_ast$1(a[1], n3, r);
      if (!i3 || !o) return;
      if (!is_positive_ast$1(a[0], n3, false, r)) {
        return !!is_integer_ast$1(a[1], n3, r) || void 0;
      }
      return !!is_positive_ast$1(a[0], n3, true, r) || (!!t3 || void 0);
    }
    if ("/" === i2) {
      if (!is_nonzero_ast$1(a[1], n3, r)) return;
      if (false === is_nonzero_ast$1(a[0], n3, r)) return true;
      if (!is_real_ast$1(a[0], n3, r) || !is_real_ast$1(a[1], n3, r)) return;
      return true;
    }
    if ("apply" === i2) return !!(functions$3.C.R && functions$3.C.R.includes(a[0]) && is_complex_ast$1(a[1], n3, r)) || (!!(functions$3.R.R && functions$3.R.R.includes(a[0]) && is_real_ast$1(a[1], n3, r)) || (!!(functions$3.nonzeroC.R && functions$3.nonzeroC.R.includes(a[0]) && is_nonzero_ast$1(a[1], n3, r) && is_complex_ast$1(a[1], n3, r)) || (!!(functions$3.nonneg.R && functions$3.nonneg.R.includes(a[0]) && is_positive_ast$1(a[1], n3, false, r)) || (!!(functions$3.pos.R && functions$3.pos.R.includes(a[0]) && is_positive_ast$1(a[1], n3, true, r)) || void 0))));
    if ("prime" === i2) return;
    return false;
  }
  return false;
}
function is_complex_ast$1(e2, t2, r) {
  if ("object" != typeof t2 && (t2 = []), void 0 === r && (r = t2), "number" == typeof e2) return Number.isFinite(e2);
  var n = evaluate_to_constant$1(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== n) return "number" == typeof n ? Number.isFinite(n) : !(void 0 === n.re || !Number.isFinite(n.re) || void 0 === n.im || !Number.isFinite(n.im));
  if ("string" == typeof e2) {
    let n3;
    if (n3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(n3)) return;
    let i2 = n3, a = n3[0], o = n3.slice(1), s = false;
    for (; "not" === a; ) {
      if (s = !s, n3 = o[0], !Array.isArray(n3)) return;
      a = n3[0], o = n3.slice(1);
    }
    if ("in" === a && o[0] === e2 && "C" === o[1]) return negate_adjust$1(true, s);
    if ("notin" === a && o[0] === e2 && "C" === o[1]) return negate_adjust$1(false, s);
    if (false === s) {
      if ("in" === a) {
        if (o[0] === e2 && "Z" === o[1]) return true;
        if (o[0] === e2 && "R" === o[1]) return true;
      }
    } else if ("notin" === a) {
      if (o[0] === e2 && "Z" === o[1]) return true;
      if (o[0] === e2 && "R" === o[1]) return true;
    }
    if ("<" === a || "le" === a) {
      let t3 = variables$2(n3), r2 = functions$2$1(n3);
      if (-1 !== t3.indexOf(e2) && 0 === r2.length) return true;
    }
    if ("=" === a && !s || "ne" === a && s) {
      let t3 = narrow_assumptions$1(i2, r);
      if (o[0] === e2) return is_complex_ast$1(o[1], t3);
      if (o[1] === e2) return is_complex_ast$1(o[0], t3);
    }
    if ("and" !== a && "or" !== a) return;
    if (s) return;
    return o.length > 2 && (n3 = unflattenRight$1(n3), o = n3.slice(1)), simple_assumption_combination$1(a, is_complex_ast$1(e2, o[0], r), is_complex_ast$1(e2, o[1], r));
  }
  if (Array.isArray(e2)) {
    let n3;
    n3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables$2(e2)]);
    let i2 = e2[0], a = e2.slice(1);
    if ("-" === i2) return is_complex_ast$1(a[0], n3, r);
    if ("*" === i2 || "+" === i2) {
      if ("*" === i2 && !a.every(((e3) => false !== is_nonzero_ast$1(e3, n3, r)))) return true;
      return !!a.every(((e3) => is_complex_ast$1(e3, n3, r))) || void 0;
    }
    if ("^" === i2) {
      let e3 = is_nonzero_ast$1(a[0], n3, r), t3 = is_positive_ast$1(a[1], n3, true, r);
      if (e3) {
        if (false === is_nonzero_ast$1(a[1], n3, r)) return a[0] !== 1 / 0 && a[0] !== -1 / 0;
      } else {
        if (Number.isNaN(a[0])) return false;
        if (!t3) return;
        if (false === e3) return true;
      }
      let i3 = is_complex_ast$1(a[0], n3, r), o = is_complex_ast$1(a[1], n3, r);
      return !(!i3 || !o) || void 0;
    }
    if ("/" === i2) {
      if (!is_nonzero_ast$1(a[1], n3, r)) return;
      if (false === is_nonzero_ast$1(a[0], n3, r)) return true;
      if (!is_complex_ast$1(a[0], n3, r) || !is_complex_ast$1(a[1], n3, r)) return;
      return true;
    }
    if ("apply" === i2) return !!(functions$3.C.C && functions$3.C.C.includes(a[0]) && is_complex_ast$1(a[1], n3, r)) || (!!(functions$3.R.C && functions$3.R.C.includes(a[0]) && is_real_ast$1(a[1], n3, r)) || (!!(functions$3.nonzeroC.C && functions$3.nonzeroC.C.includes(a[0]) && is_nonzero_ast$1(a[1], n3, r) && is_complex_ast$1(a[1], n3, r)) || (!!(functions$3.nonneg.C && functions$3.nonneg.C.includes(a[0]) && is_positive_ast$1(a[1], n3, false, r)) || (!!(functions$3.pos.C && functions$3.pos.C.includes(a[0]) && is_positive_ast$1(a[1], n3, true, r)) || void 0))));
    if ("prime" === i2) return;
    return false;
  }
  return false;
}
function is_nonzero_ast$1(e2, t2, r) {
  if ("object" != typeof t2 && (t2 = []), void 0 === r && (r = t2), "number" == typeof e2) {
    if (Number.isFinite(e2)) return 0 !== e2;
    if (Number.isNaN(e2)) return;
    return true;
  }
  var n = evaluate_to_constant$1(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== n) {
    if ("number" == typeof n) {
      if (Number.isFinite(n)) return 0 !== n;
      if (Number.isNaN(n)) return;
      return true;
    }
    return void 0 !== n.re && void 0 !== n.im && (0 !== n.re || 0 !== n.im) || void 0;
  }
  if ("string" == typeof e2) {
    let n3;
    if (n3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(n3)) return;
    let i2 = n3, a = n3[0], o = n3.slice(1), s = false;
    for (; "not" === a; ) {
      if (s = !s, n3 = o[0], !Array.isArray(n3)) return;
      a = n3[0], o = n3.slice(1);
    }
    let u = narrow_assumptions$1(i2, r);
    if ("=" === a && !s || "ne" === a && s) {
      if (o[0] === e2) return is_nonzero_ast$1(o[1], u);
      if (o[1] === e2) return is_nonzero_ast$1(o[0], u);
    }
    if ("ne" === a && !s || "=" === a && s) {
      if (o[0] === e2 && false === is_nonzero_ast$1(o[1], u)) return true;
      if (o[1] === e2 && false === is_nonzero_ast$1(o[0], u)) return true;
    }
    if ("<" === a) if (s) {
      if (o[0] === e2 && is_positive_ast$1(o[1], u, true)) return true;
      if (o[1] === e2 && is_negative_ast$1(o[0], u, true)) return true;
    } else {
      if (o[0] === e2 && is_negative_ast$1(o[1], u, false)) return true;
      if (o[1] === e2 && is_positive_ast$1(o[0], u, false)) return true;
    }
    if ("le" === a) if (s) {
      if (o[0] === e2 && is_positive_ast$1(o[1], u, false)) return true;
      if (o[1] === e2 && is_negative_ast$1(o[0], u, false)) return true;
    } else {
      if (o[0] === e2 && is_negative_ast$1(o[1], u, true)) return true;
      if (o[1] === e2 && is_positive_ast$1(o[0], u, true)) return true;
    }
    if ("and" !== a && "or" !== a) return;
    if (s) return;
    return o.length > 2 && (n3 = unflattenRight$1(n3), o = n3.slice(1)), simple_assumption_combination$1(a, is_nonzero_ast$1(e2, o[0], r), is_nonzero_ast$1(e2, o[1], r));
  }
  if (Array.isArray(e2)) {
    let n3;
    n3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables$2(e2)]);
    let i2 = e2[0], a = e2.slice(1);
    if ("-" === i2) return is_nonzero_ast$1(a[0], n3, r);
    if ("+" === i2) {
      if (a.length > 2 && (a = (e2 = unflattenRight$1(e2)).slice(1)), equal$1(a[0], simplify$2(["-", a[1]], r))) return false;
      let t3 = is_nonzero_ast$1(a[0], n3, r), i3 = is_nonzero_ast$1(a[1], n3, r);
      if (false === t3) return i3;
      if (false === i3) return t3;
      let o = is_real_ast$1(a[0], n3, r), s = is_real_ast$1(a[1], n3, r);
      if (!o || !s) return true === o ? false === s || void 0 : true === s && false === o || void 0;
      let u = is_positive_ast$1(a[0], n3, false, r), c2 = is_positive_ast$1(a[1], n3, false, r), l = is_positive_ast$1(a[0], n3, true, r), f2 = is_positive_ast$1(a[1], n3, true, r);
      return !!(u && f2 || l && c2) || (false === u && false === f2 || false === l && false === c2 || void 0);
    }
    if ("*" === i2) {
      let e3 = true;
      for (let t3 = 0; t3 < a.length; t3++) {
        let i3 = is_nonzero_ast$1(a[t3], n3, r);
        if (false === i3) return false;
        void 0 === i3 && (e3 = false);
      }
      return !!e3 || void 0;
    }
    if ("/" === i2) {
      let e3 = is_nonzero_ast$1(a[0], n3, r);
      return is_nonzero_ast$1(a[1], n3, r) ? e3 : void 0;
    }
    if ("^" === i2) {
      let e3 = is_nonzero_ast$1(a[0], n3, r);
      if (e3) {
        if (a[0] === 1 / 0 || a[0] === -1 / 0) {
          if (false === is_nonzero_ast$1(a[1], n3, r)) return;
        }
        return true;
      }
      return (!is_positive_ast$1(a[1], n3, true, r) || false !== e3) && void 0;
    }
    if ("apply" === i2) return !!(functions$3.C.nonzero && functions$3.C.nonzero.includes(a[0]) && is_complex_ast$1(a[1], n3, r)) || (!!(functions$3.R.nonzero && functions$3.R.nonzero.includes(a[0]) && is_real_ast$1(a[1], n3, r)) || (!!(functions$3.nonzeroC.nonzero && functions$3.nonzeroC.nonzero.includes(a[0]) && is_nonzero_ast$1(a[1], n3, r) && is_complex_ast$1(a[1], n3, r)) || (!!(functions$3.nonneg.nonzero && functions$3.nonneg.nonzero.includes(a[0]) && is_positive_ast$1(a[1], n3, false, r)) || (!!(functions$3.pos.nonzero && functions$3.pos.nonzero.includes(a[0]) && is_positive_ast$1(a[1], n3, true, r)) || void 0))));
    if ("prime" === i2) return;
    return false;
  }
  return false;
}
function is_positive_ast$1(e2, t2, r, n) {
  if ("object" != typeof t2 && (t2 = []), void 0 === n && (n = t2), void 0 === r && (r = true), "number" == typeof e2) return !!Number.isFinite(e2) && (r ? e2 > 0 : e2 >= 0);
  var i2 = is_real_ast$1(e2, t2, n);
  if (!i2) return i2;
  var a = evaluate_to_constant$1(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== a) return "number" == typeof a && (!!Number.isFinite(a) && (r ? a > 0 : a >= 0));
  if ("string" == typeof e2) {
    let i3;
    if (i3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(i3)) return;
    let a2 = i3, o = i3[0], s = i3.slice(1), u = false;
    for (; "not" === o; ) {
      if (u = !u, i3 = s[0], !Array.isArray(i3)) return;
      o = i3[0], s = i3.slice(1);
    }
    let c2 = narrow_assumptions$1(a2, n);
    if ("=" === o && !u || "ne" === o && u) {
      if (s[0] === e2) return is_positive_ast$1(s[1], c2, r);
      if (s[1] === e2) return is_positive_ast$1(s[0], c2, r);
    }
    if ("<" === o) if (u) {
      if (s[0] === e2 && is_positive_ast$1(s[1], c2, r)) return true;
      if (s[1] === e2 && is_negative_ast$1(s[0], c2, !r)) return false;
    } else {
      if (s[0] === e2 && is_negative_ast$1(s[1], c2, false)) return false;
      if (s[1] === e2 && is_positive_ast$1(s[0], c2, false)) return true;
    }
    if ("le" === o) if (u) {
      if (s[0] === e2 && is_positive_ast$1(s[1], c2, false)) return true;
      if (s[1] === e2 && is_negative_ast$1(s[0], c2, false)) return false;
    } else {
      if (s[0] === e2 && is_negative_ast$1(s[1], c2, !r)) return false;
      if (s[1] === e2 && is_positive_ast$1(s[0], c2, r)) return true;
    }
    if ("and" !== o && "or" !== o) return;
    if (u) return;
    return s.length > 2 && (i3 = unflattenRight$1(i3), s = i3.slice(1)), simple_assumption_combination$1(o, is_positive_ast$1(e2, s[0], r, n), is_positive_ast$1(e2, s[1], r, n));
  }
  if (Array.isArray(e2)) {
    let i3;
    i3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables$2(e2)]);
    let a2 = e2[0], o = e2.slice(1);
    if ("-" === a2) return is_negative_ast$1(o[0], i3, r, n);
    if ("+" === a2) {
      o.length > 2 && (o = (e2 = unflattenRight$1(e2)).slice(1));
      let t3 = is_positive_ast$1(o[0], i3, false, n), a3 = is_positive_ast$1(o[1], i3, false, n), s = is_positive_ast$1(o[0], i3, true, n), u = is_positive_ast$1(o[1], i3, true, n);
      if (r) {
        if (t3 && u || s && a3) return true;
      } else if (t3 && a3) return true;
      if (r) {
        if (false === s && false === u) return false;
      } else if (false === t3 && false === u || false === s && false === a3) return false;
      return;
    }
    if ("*" === a2) {
      if (!o.every(((e3) => false !== is_nonzero_ast$1(e3, i3, n)))) return !r;
      o.length > 2 && (o = (e2 = unflattenRight$1(e2)).slice(1));
      let t3 = is_real_ast$1(o[0], i3, n), a3 = is_real_ast$1(o[1], i3, n);
      if (void 0 === t3 || void 0 === a3) return;
      if (false === t3) return false === a3 && void 0;
      if (false === a3) return false;
      let s = is_positive_ast$1(o[0], i3, false, n), u = is_positive_ast$1(o[1], i3, false, n), c2 = is_positive_ast$1(o[0], i3, true, n), l = is_positive_ast$1(o[1], i3, true, n);
      if (r) {
        if (c2 && l || false === s && false === u) return true;
        if (false === c2 && u || s && false === l) return false;
      } else {
        if (s && u || false === c2 && false === l) return true;
        if (c2 && false === u || false === s && l) return false;
      }
      return;
    }
    if ("/" === a2) {
      if (!is_nonzero_ast$1(o[1], i3, n)) return;
      if (false === is_nonzero_ast$1(o[0], i3, n)) return !r;
      let e3 = is_positive_ast$1(o[1], i3, true, n);
      if (void 0 === e3) return;
      let t3 = e3 ? r : !r, a3 = is_positive_ast$1(o[0], i3, t3, n);
      if (void 0 === a3) return;
      return true === a3 ? true === e3 : true !== e3;
    }
    if ("^" === a2) {
      let e3 = is_nonzero_ast$1(o[0], i3, n);
      if (e3) {
        if (false === is_nonzero_ast$1(o[1], i3, n)) {
          if (o[0] === 1 / 0 || o[0] === -1 / 0) return;
          return true;
        }
      } else {
        if (!is_positive_ast$1(o[1], i3, true, n)) return;
        if (false === e3) return !r;
        if (r) return;
      }
      if (true !== is_real_ast$1(o[0], i3, n)) return;
      if (!is_positive_ast$1(o[0], i3, r, n)) {
        return !!is_integer_ast$1(simplify$2(["/", o[1], 2], n), i3, n) || void 0;
      }
      return !!is_real_ast$1(o[1], i3, n) || void 0;
    }
    if ("apply" === a2 && !r) return !!(functions$3.C.nonneg && functions$3.C.nonneg.includes(o[0]) && is_complex_ast$1(o[1], i3, n)) || (!!(functions$3.R.nonneg && functions$3.R.nonneg.includes(o[0]) && is_real_ast$1(o[1], i3, n)) || (!!(functions$3.nonzeroC.nonneg && functions$3.nonzeroC.nonneg.includes(o[0]) && is_nonzero_ast$1(o[1], i3, n) && is_complex_ast$1(o[1], i3, n)) || (!!(functions$3.nonneg.nonneg && functions$3.nonneg.nonneg.includes(o[0]) && is_positive_ast$1(o[1], i3, false, n)) || (!!(functions$3.pos.nonneg && functions$3.pos.nonneg.includes(o[0]) && is_positive_ast$1(o[1], i3, true, n)) || void 0))));
    if ("apply" === a2 && r) return !!(functions$3.C.pos && functions$3.C.pos.includes(o[0]) && is_complex_ast$1(o[1], i3, n)) || (!!(functions$3.R.pos && functions$3.R.pos.includes(o[0]) && is_real_ast$1(o[1], i3, n)) || (!!(functions$3.nonzeroC.pos && functions$3.nonzeroC.pos.includes(o[0]) && is_nonzero_ast$1(o[1], i3, n) && is_complex_ast$1(o[1], i3, n)) || (!!(functions$3.nonneg.pos && functions$3.nonneg.pos.includes(o[0]) && is_positive_ast$1(o[1], i3, false, n)) || (!!(functions$3.pos.pos && functions$3.pos.pos.includes(o[0]) && is_positive_ast$1(o[1], i3, true, n)) || void 0))));
    if ("prime" === a2) return;
    return false;
  }
  return false;
}
function is_negative_ast$1(e2, t2, r, n) {
  void 0 === r && (r = true);
  var i2 = is_real_ast$1(e2, t2, n);
  if (true === i2) {
    let i3 = is_positive_ast$1(e2, t2, !r, n);
    return false === i3 || true !== i3 && void 0;
  }
  return i2;
}
function tuples_to_vectors$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("tuple" === r) {
    return ["vector"].concat(n.map((function(e3, t3) {
      return tuples_to_vectors$1(e3);
    })));
  }
  if ("apply" === r) {
    if ("tuple" === n[1][0]) {
      let e3 = tuples_to_vectors$1(n[0]), t3 = n[1].slice(1);
      return ["apply", e3, ["tuple"].concat(t3.map((function(e4, t4) {
        return tuples_to_vectors$1(e4);
      })))];
    }
  } else {
    if ("gts" === r || "lts" === r || "interval" === r) {
      let e3 = n[0], t3 = n[1];
      if ("tuple" !== e3[0] || "tuple" !== t3[0]) throw new Error("Badly formed ast");
      return [r, ["tuple"].concat(e3.slice(1).map((function(e4, t4) {
        return tuples_to_vectors$1(e4);
      }))), t3];
    }
    if ("matrix" === r) {
      let e3 = n[0], t3 = n[1];
      return e3 = ["tuple"].concat(e3.slice(1).map(tuples_to_vectors$1)), t3 = ["tuple"].concat(t3.slice(1).map(((e4) => ["tuple"].concat(e4.slice(1).map(tuples_to_vectors$1))))), ["matrix", e3, t3];
    }
  }
  return [r].concat(n.map((function(e3, t3) {
    return tuples_to_vectors$1(e3);
  })));
}
function to_intervals$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("tuple" === r && 2 === n.length) {
    let e3 = ["tuple"].concat(n.map((function(e4, t3) {
      return to_intervals$1(e4);
    })));
    return e3 = ["interval", e3, ["tuple", false, false]], e3;
  }
  if ("array" === r && 2 === n.length) {
    let e3 = ["tuple"].concat(n.map((function(e4, t3) {
      return to_intervals$1(e4);
    })));
    return e3 = ["interval", e3, ["tuple", true, true]], e3;
  }
  if ("apply" === r) {
    if ("tuple" === n[1][0]) {
      let e3 = to_intervals$1(n[0]), t3 = n[1].slice(1);
      return ["apply", e3, ["tuple"].concat(t3.map((function(e4, t4) {
        return to_intervals$1(e4);
      })))];
    }
  } else if ("gts" === r || "lts" === r || "interval" === r) {
    let e3 = n[0], t3 = n[1];
    if ("tuple" !== e3[0] || "tuple" !== t3[0]) throw new Error("Badly formed ast");
    return [r, ["tuple"].concat(e3.slice(1).map((function(e4, t4) {
      return to_intervals$1(e4);
    }))), t3];
  }
  return [r].concat(n.map((function(e3, t3) {
    return to_intervals$1(e3);
  })));
}
function altvectors_to_vectors$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("altvector" === r) {
    return ["vector"].concat(n.map((function(e3, t3) {
      return altvectors_to_vectors$1(e3);
    })));
  }
  return [r].concat(n.map((function(e3, t3) {
    return altvectors_to_vectors$1(e3);
  })));
}
function ParseError$1(e2, t2) {
  this.name = "ParseError", this.message = e2 || "Error parsing input", this.stack = new Error().stack, this.location = t2;
}
functions$3.C.nonneg = ["abs"], functions$3.C.nonzero = ["exp"], functions$3.C.R = ["abs", "arg"], functions$3.C.C = ["abs", "arg", "exp", "sign", "cos", "cosh", "sin", "sinh", "erf", "sqrt", "log", "ln", "log10"], functions$3.R.pos = ["exp"], functions$3.R.nonneg = ["abs", "exp", "arg"], functions$3.R.R = ["abs", "arg", "exp", "sign", "cos", "cosh", "sin", "sinh", "erf"], functions$3.R.Z = ["sign"], functions$3.nonzeroC.pos = ["abs"], functions$3.nonneg.nonneg = ["abs", "exp", "arg", "sqrt", "erf"], functions$3.nonzeroC.nonzero = ["abs"], functions$3.nonneg.R = [...new Set(functions$3.R.R.concat(functions$3.nonneg.nonneg))], functions$3.pos.pos = ["abs", "exp", "sqrt", "erf"], functions$3.pos.nonneg = functions$3.pos.pos, functions$3.pos.nonzero = ["abs", "exp", "sqrt", "erf"], functions$3.pos.R = functions$3.nonneg.R.concat(["log", "ln", "log10"]), ParseError$1.prototype = Object.create(Error.prototype), ParseError$1.prototype.constructor = ParseError$1;
let lexer$1 = class lexer2 {
  constructor(e2, t2 = "\\s") {
    this.input = "", this.location = 0, this.token_rules = [], this.initial_whitespace = new RegExp("^(" + t2 + ")+");
    for (let t3 of e2) this.token_rules.push([new RegExp("^" + t3[0])].concat(t3.slice(1)));
  }
  set_input(e2) {
    if ("string" != typeof e2) throw new Error("Input must be a string");
    this.input = e2, this.location = 0;
  }
  return_state() {
    return { input: this.input, location: this.location };
  }
  set_state({ input: e2 = null, location: t2 = 0 } = {}) {
    null !== e2 && (this.input = e2, this.location = t2);
  }
  advance({ remove_initial_space: e2 = true } = {}) {
    let t2 = this.initial_whitespace.exec(this.input);
    if (t2) {
      let r2 = t2[0].length;
      if (this.input = this.input.slice(r2), this.location += r2, !e2) return { token_type: "SPACE", token_text: t2[0], original_text: t2[0] };
    }
    if (0 === this.input.length) return { token_type: "EOF", token_text: "", original_text: "" };
    for (var r of (t2 = null, this.token_rules)) if (t2 = r[0].exec(this.input), t2) {
      let e3 = t2[0].length;
      this.input = this.input.slice(e3), this.location += e3;
      break;
    }
    return null === t2 ? { token_type: "INVALID", token_text: this.input[0], original_text: this.input[0] } : r.length > 2 ? { token_type: r[1], token_text: r[2], original_text: t2[0] } : { token_type: r[1], token_text: t2[0], original_text: t2[0] };
  }
  unput(e2) {
    if ("string" != typeof e2) throw new Error("Input must be a string");
    this.location -= e2.length, this.input = e2 + this.input;
  }
};
var is_associative$2 = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$7(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if (r = r.map((function(e3, t3) {
    return flatten$7(e3);
  })), is_associative$2[t2]) {
    for (var n = [], i2 = 0; i2 < r.length; i2++) Array.isArray(r[i2]) && r[i2][0] === t2 && r[i2].length > 2 ? n = n.concat(r[i2].slice(1)) : n.push(r[i2]);
    r = n;
  }
  return [t2].concat(r);
}
const sci_notat_exp_regex$1$1 = "(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?", number_rules_sci$1$1 = [["[0-9]+(\\.[0-9]*)?" + sci_notat_exp_regex$1$1, "NUMBER"], ["\\.[0-9]+" + sci_notat_exp_regex$1$1, "NUMBER"]], number_rules_non_sci$1$1 = [["[0-9]+(\\.[0-9]*)?", "NUMBER"], ["\\.[0-9]+", "NUMBER"]], base_text_rules$1 = [["\\*\\*", "^"], ["\\*", "*"], ["\\xB7", "*"], ["·", "*"], ["•", "*"], ["⋅", "*"], ["×", "*"], ["/", "/"], ["-", "-"], ["֊", "-"], ["־", "-"], ["᠆", "-"], ["‐", "-"], ["‑", "-"], ["‒", "-"], ["–", "-"], ["—", "-"], ["―", "-"], ["⁻", "-"], ["₋", "-"], ["−", "-"], ["⸺", "-"], ["⸻", "-"], ["﹘", "-"], ["﹣", "-"], ["－", "-"], ["\\+", "+"], ["\\^", "^"], ["‸", "^"], ["ʌ", "^"], ["′", "'"], ["\\|", "|"], ["\\(", "("], ["\\)", ")"], ["\\[", "["], ["\\]", "]"], ["\\{", "{"], ["\\}", "}"], ["⟨", "LANGLE"], ["⟩", "RANGLE"], ["〈", "LANGLE"], ["〉", "RANGLE"], [",", ","], [":", ":"], ["α", "VARMULTICHAR", "alpha"], ["β", "VARMULTICHAR", "beta"], ["ϐ", "VARMULTICHAR", "beta"], ["Γ", "VARMULTICHAR", "Gamma"], ["γ", "VARMULTICHAR", "gamma"], ["Δ", "VARMULTICHAR", "Delta"], ["δ", "VARMULTICHAR", "delta"], ["ε", "VARMULTICHAR", "epsilon"], ["ϵ", "VARMULTICHAR", "epsilon"], ["ζ", "VARMULTICHAR", "zeta"], ["η", "VARMULTICHAR", "eta"], ["Θ", "VARMULTICHAR", "Theta"], ["ϴ", "VARMULTICHAR", "Theta"], ["θ", "VARMULTICHAR", "theta"], ["ᶿ", "VARMULTICHAR", "theta"], ["ϑ", "VARMULTICHAR", "theta"], ["ι", "VARMULTICHAR", "iota"], ["κ", "VARMULTICHAR", "kappa"], ["Λ", "VARMULTICHAR", "Lambda"], ["λ", "VARMULTICHAR", "lambda"], ["μ", "VARMULTICHAR", "mu"], ["µ", "VARMULTICHAR", "mu"], ["ν", "VARMULTICHAR", "nu"], ["Ξ", "VARMULTICHAR", "Xi"], ["ξ", "VARMULTICHAR", "xi"], ["Π", "VARMULTICHAR", "Pi"], ["π", "VARMULTICHAR", "pi"], ["ϖ", "VARMULTICHAR", "pi"], ["ρ", "VARMULTICHAR", "rho"], ["ϱ", "VARMULTICHAR", "rho"], ["Σ", "VARMULTICHAR", "Sigma"], ["σ", "VARMULTICHAR", "sigma"], ["ς", "VARMULTICHAR", "sigma"], ["τ", "VARMULTICHAR", "tau"], ["Υ", "VARMULTICHAR", "Upsilon"], ["υ", "VARMULTICHAR", "upsilon"], ["Φ", "VARMULTICHAR", "Phi"], ["φ", "VARMULTICHAR", "phi"], ["ϕ", "VARMULTICHAR", "phi"], ["Ψ", "VARMULTICHAR", "Psi"], ["ψ", "VARMULTICHAR", "psi"], ["Ω", "VARMULTICHAR", "Omega"], ["ω", "VARMULTICHAR", "omega"], ["∅", "VARMULTICHAR", "emptyset"], ["oo(?![a-zA-Z0-9])", "INFINITY"], ["OO(?![a-zA-Z0-9])", "INFINITY"], ["infty(?![a-zA-Z0-9])", "INFINITY"], ["infinity(?![a-zA-Z0-9])", "INFINITY"], ["Infinity(?![a-zA-Z0-9])", "INFINITY"], ["∞", "INFINITY"], ["ℯ", "VAR", "e"], ["♠", "VARMULTICHAR", "spade"], ["♡", "VARMULTICHAR", "heart"], ["♢", "VARMULTICHAR", "diamond"], ["♣", "VARMULTICHAR", "club"], ["★", "VARMULTICHAR", "bigstar"], ["◯", "VARMULTICHAR", "bigcirc"], ["◊", "VARMULTICHAR", "lozenge"], ["△", "VARMULTICHAR", "bigtriangleup"], ["▽", "VARMULTICHAR", "bigtriangledown"], ["⧫", "VARMULTICHAR", "blacklozenge"], ["■", "VARMULTICHAR", "blacksquare"], ["▲", "VARMULTICHAR", "blacktriangle"], ["▼", "VARMULTICHAR", "blacktriangledown"], ["◀", "VARMULTICHAR", "blacktriangleleft"], ["▶", "VARMULTICHAR", "blacktriangleright"], ["□", "VARMULTICHAR", "Box"], ["∘", "VARMULTICHAR", "circ"], ["⋆", "VARMULTICHAR", "star"], ["and(?![a-zA-Z0-9])", "AND"], ["\\&\\&?", "AND"], ["∧", "AND"], ["or(?![a-zA-Z0-9])", "OR"], ["∨", "OR"], ["not(?![a-zA-Z0-9])", "NOT"], ["¬", "NOT"], ["=", "="], ["᐀", "="], ["゠", "="], ["!=", "NE"], ["≠", "NE"], ["<=", "LE"], ["≤", "LE"], [">=", "GE"], ["≥", "GE"], ["<", "<"], [">", ">"], ["forall(?![a-zA-Z0-9])", "FORALL"], ["∀", "FORALL"], ["exists(?![a-zA-Z0-9])", "EXISTS"], ["∃", "EXISTS"], ["elementof(?![a-zA-Z0-9])", "IN"], ["∈", "IN"], ["notelementof(?![a-zA-Z0-9])", "NOTIN"], ["∉", "NOTIN"], ["containselement(?![a-zA-Z0-9])", "NI"], ["∋", "NI"], ["notcontainselement(?![a-zA-Z0-9])", "NOTNI"], ["∌", "NOTNI"], ["subset(?![a-zA-Z0-9])", "SUBSET"], ["⊂", "SUBSET"], ["subseteq(?![a-zA-Z0-9])", "SUBSETEQ"], ["⊆", "SUBSETEQ"], ["notsubset(?![a-zA-Z0-9])", "NOTSUBSET"], ["⊄", "NOTSUBSET"], ["notsubseteq(?![a-zA-Z0-9])", "NOTSUBSETEQ"], ["⊈", "NOTSUBSETEQ"], ["superset(?![a-zA-Z0-9])", "SUPERSET"], ["⊃", "SUPERSET"], ["superseteq(?![a-zA-Z0-9])", "SUPERSETEQ"], ["⊇", "SUPERSETEQ"], ["notsuperset(?![a-zA-Z0-9])", "NOTSUPERSET"], ["⊅", "NOTSUPERSET"], ["notsuperseteq(?![a-zA-Z0-9])", "NOTSUPERSETEQ"], ["⊉", "NOTSUPERSETEQ"], ["union(?![a-zA-Z0-9])", "UNION"], ["∪", "UNION"], ["intersect(?![a-zA-Z0-9])", "INTERSECT"], ["∩", "INTERSECT"], ["rightarrow(?![a-zA-Z0-9])", "RIGHTARROW"], ["→", "RIGHTARROW"], ["⟶", "RIGHTARROW"], ["leftarrow(?![a-zA-Z0-9])", "LEFTARROW"], ["←", "LEFTARROW"], ["⟵", "LEFTARROW"], ["leftrightarrow(?![a-zA-Z0-9])", "LEFTRIGHTARROW"], ["↔", "LEFTRIGHTARROW"], ["⟷", "LEFTRIGHTARROW"], ["implies(?![a-zA-Z0-9])", "IMPLIES"], ["⇒", "IMPLIES"], ["⟹", "IMPLIES"], ["impliedby(?![a-zA-Z0-9])", "IMPLIEDBY"], ["⇐", "IMPLIEDBY"], ["⟸", "IMPLIEDBY"], ["iff(?![a-zA-Z0-9])", "IFF"], ["⇔", "IFF"], ["⟺", "IFF"], ["perp(?![a-zA-Z0-9])", "PERP"], ["⟂", "PERP"], ["parallel(?![a-zA-Z0-9])", "PARALLEL"], ["∥", "PARALLEL"], ["angle(?![a-zA-Z0-9])", "ANGLE"], ["∠", "ANGLE"], ["int(?![a-zA-Z0-9])", "INT"], ["∫", "INT"], ["!", "!"], ["'", "'"], ["_", "_"], ["\\.\\.\\.", "LDOTS"], ["[a-zA-Z∂][a-zA-Z∂0-9]*", "VAR"], ["[＿$%]", "VAR"]], allowSimplifiedFunctionApplicationDefault$1$1 = true, splitSymbolsDefault$1 = true, unsplitSymbolsDefault$1 = ["alpha", "beta", "gamma", "Gamma", "delta", "Delta", "epsilon", "zeta", "eta", "theta", "Theta", "iota", "kappa", "lambda", "Lambda", "mu", "nu", "xi", "Xi", "pi", "Pi", "rho", "sigma", "Sigma", "tau", "Tau", "upsilon", "Upsilon", "phi", "Phi", "chi", "psi", "Psi", "omega", "Omega", "angle", "deg", "emptyset"], appliedFunctionSymbolsDefault$1$1 = ["abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "cos", "cosh", "acos", "acosh", "arccos", "arccosh", "cot", "coth", "acot", "acoth", "arccot", "arccoth", "csc", "csch", "acsc", "acsch", "arccsc", "arccsch", "sec", "sech", "asec", "asech", "arcsec", "arcsech", "sin", "sinh", "asin", "asinh", "arcsin", "arcsinh", "tan", "tanh", "atan", "atan2", "atanh", "arctan", "arctanh", "arg", "conj", "re", "im", "det", "trace", "nPr", "nCr", "floor", "ceil", "round"], functionSymbolsDefault$1$1 = ["f", "g"], operatorSymbolsDefault$1$1 = ["binom", "vec", "linesegment"], unitsDefault$1$1 = get_all_units$1(), parseLeibnizNotationDefault$1$1 = true;
let textToAst$4$1 = class textToAst$42 {
  constructor({ allowSimplifiedFunctionApplication: e2 = allowSimplifiedFunctionApplicationDefault$1$1, splitSymbols: t2 = splitSymbolsDefault$1, unsplitSymbols: r = unsplitSymbolsDefault$1, appliedFunctionSymbols: n = appliedFunctionSymbolsDefault$1$1, functionSymbols: i2 = functionSymbolsDefault$1$1, operatorSymbols: a = operatorSymbolsDefault$1$1, units: o = unitsDefault$1$1, parseLeibnizNotation: s = parseLeibnizNotationDefault$1$1, parseScientificNotation: u = true } = {}) {
    this.allowSimplifiedFunctionApplication = e2, this.splitSymbols = t2, this.unsplitSymbols = r, this.appliedFunctionSymbols = n, this.functionSymbols = i2, this.operatorSymbols = a, this.units = o, this.parseLeibnizNotation = s;
    let c2 = base_text_rules$1;
    c2 = u ? [...number_rules_sci$1$1, ...c2] : [...number_rules_non_sci$1$1, ...c2], this.lexer = new lexer$1(c2);
  }
  advance(e2) {
    if (this.token = this.lexer.advance(e2), "INVALID" === this.token.token_type) throw new ParseError$1("Invalid symbol '" + this.token.original_text + "'", this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(e2) {
    this.lexer.set_state(e2.lexer_state), this.token = Object.assign({}, e2.token);
  }
  convert(e2) {
    this.lexer.set_input(e2), this.advance();
    var t2 = this.statement_list();
    if ("EOF" !== this.token.token_type) throw new ParseError$1("Invalid location of '" + this.token.original_text + "'", this.lexer.location);
    return flatten$7(t2);
  }
  statement_list() {
    for (var e2 = [this.statement()]; "," === this.token.token_type; ) this.advance(), e2.push(this.statement());
    return e2 = e2.length > 1 ? ["list"].concat(e2) : e2[0];
  }
  statement({ inside_absolute_value: e2 = 0 } = {}) {
    if ("LDOTS" === this.token.token_type) return this.advance(), ["ldots"];
    var t2;
    try {
      t2 = this.return_state();
      let r = this.statement_a({ inside_absolute_value: e2 });
      return ":" !== this.token.token_type ? r : (this.advance(), [":", r, this.statement_a()]);
    } catch (e3) {
      try {
        this.set_state(t2);
        let r = this.statement_a({ parse_absolute_value: false });
        if ("|" !== this.token.token_type) throw e3;
        return this.advance(), ["|", r, this.statement_a({ parse_absolute_value: false })];
      } catch (t3) {
        throw e3;
      }
    }
  }
  statement_a({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true } = {}) {
    for (var r = this.statement_b({ inside_absolute_value: e2, parse_absolute_value: t2 }); ["IMPLIES", "IMPLIEDBY", "IFF", "LEFTARROW", "RIGHTARROW", "LEFTRIGHTARROW"].includes(this.token.token_type); ) {
      let n = this.token.token_type.toLowerCase();
      this.advance(), r = [n, r, this.statement_b({ inside_absolute_value: e2, parse_absolute_value: t2 })];
    }
    return r;
  }
  statement_b({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true } = {}) {
    for (var r = this.statement_c({ inside_absolute_value: e2, parse_absolute_value: t2 }); "OR" === this.token.token_type; ) {
      let n = this.token.token_type.toLowerCase();
      this.advance(), r = [n, r, this.statement_c({ inside_absolute_value: e2, parse_absolute_value: t2 })];
    }
    return r;
  }
  statement_c(e2) {
    for (var t2 = this.relation(e2); "AND" === this.token.token_type; ) {
      let r = this.token.token_type.toLowerCase();
      this.advance(), t2 = [r, t2, this.relation(e2)];
    }
    return t2;
  }
  relation(e2) {
    if ("NOT" === this.token.token_type || "!" === this.token.token_type) return this.advance(), ["not", this.relation(e2)];
    if ("FORALL" === this.token.token_type || "EXISTS" === this.token.token_type) {
      let t3 = this.token.token_type.toLowerCase();
      return this.advance(), [t3, this.relation(e2)];
    }
    for (var t2 = this.expression(e2); "=" === this.token.token_type || "NE" === this.token.token_type || "<" === this.token.token_type || ">" === this.token.token_type || "LE" === this.token.token_type || "GE" === this.token.token_type || "IN" === this.token.token_type || "NOTIN" === this.token.token_type || "NI" === this.token.token_type || "NOTNI" === this.token.token_type || "SUBSET" === this.token.token_type || "NOTSUBSET" === this.token.token_type || "SUBSETEQ" === this.token.token_type || "NOTSUBSETEQ" === this.token.token_type || "SUPERSET" === this.token.token_type || "NOTSUPERSET" === this.token.token_type || "SUPERSETEQ" === this.token.token_type || "NOTSUPERSETEQ" === this.token.token_type; ) {
      let r = this.token.token_type.toLowerCase(), n = 0;
      "<" === this.token.token_type || "LE" === this.token.token_type ? n = -1 : ">" !== this.token.token_type && "GE" !== this.token.token_type || (n = 1), this.advance();
      let i2 = this.expression(e2);
      if (-1 === n) if ("<" === this.token.token_type || "LE" === this.token.token_type) {
        let n3 = ["tuple"];
        "<" === r ? n3.push(true) : n3.push(false);
        let a = ["tuple", t2, i2];
        for (; "<" === this.token.token_type || "LE" === this.token.token_type; ) "<" === this.token.token_type ? n3.push(true) : n3.push(false), this.advance(), a.push(this.expression(e2));
        t2 = ["lts", a, n3];
      } else t2 = [r, t2, i2];
      else if (1 === n) if (">" === this.token.token_type || "GE" === this.token.token_type) {
        let n3 = ["tuple"];
        ">" === r ? n3.push(true) : n3.push(false);
        let a = ["tuple", t2, i2];
        for (; ">" === this.token.token_type || "GE" === this.token.token_type; ) ">" === this.token.token_type ? n3.push(true) : n3.push(false), this.advance(), a.push(this.expression(e2));
        t2 = ["gts", a, n3];
      } else t2 = [r, t2, i2];
      else if ("=" === r) for (t2 = ["=", t2, i2]; "=" === this.token.token_type; ) this.advance(), t2.push(this.expression(e2));
      else t2 = [r, t2, i2];
    }
    return t2;
  }
  expression(e2) {
    if ("NOT" === this.token.token_type || "!" === this.token.token_type) return this.advance(), ["not", this.expression(e2)];
    let t2 = false;
    "+" === this.token.token_type && (t2 = true, this.advance());
    let r = false;
    "-" === this.token.token_type && (r = true, this.advance());
    var n = this.term(e2);
    if (r || t2) {
      if (false === n) return (t2 ? "+" : "") + (r ? "-" : "");
      if ("string" == typeof n && [...n].every(((e3) => ["+", "-"].includes(e3)))) return (t2 ? "+" : "") + (r ? "-" : "") + n;
    }
    for (false === n && (n = "＿"), r && (n = n > 0 ? -n : ["-", n]), t2 && (n = ["+", n]); ["+", "-", "UNION", "INTERSECT", "PERP", "PARALLEL"].includes(this.token.token_type); ) {
      let t3 = this.token.token_type.toLowerCase(), r2 = false, i2 = false;
      "-" === this.token.token_type ? (t3 = "+", r2 = true, this.advance()) : (this.advance(), "+" === t3 && "-" === this.token.token_type && (r2 = true, i2 = true, this.advance()));
      let a = this.term(e2);
      if ("+" === t3) {
        if (false === a && ("number" == typeof n || "string" == typeof n)) return i2 ? n + "+-" : r2 ? n + "-" : n + "+";
        if ("string" == typeof a && [...a].every(((e3) => ["+", "-"].includes(e3))) && ("number" == typeof n || "string" == typeof n)) return i2 ? n + "+-" + a : r2 ? n + "-" + a : n + "+" + a;
      }
      false === a && (a = "＿"), r2 && (a = a > 0 ? -a : ["-", a]), n = [t3, n, a];
    }
    return n;
  }
  term(e2) {
    var t2 = this.factor(e2), r = false;
    do {
      if (r = false, "*" === this.token.token_type) {
        this.advance(), false === t2 && (t2 = "＿");
        let n = this.factor(e2);
        false === n && (n = "＿"), t2 = ["*", t2, n], r = true;
      } else if ("/" === this.token.token_type) {
        this.advance(), false === t2 && (t2 = "＿");
        let n = this.factor(e2);
        false === n && (n = "＿"), t2 = ["/", t2, n], r = true;
      } else {
        let n = Object.assign({}, e2);
        n.allow_absolute_value_closing = true;
        let i2 = this.nonMinusFactor(n);
        false !== i2 && (false === t2 && (t2 = "＿"), t2 = ["*", t2, i2], r = true);
      }
    } while (r);
    return this.convert_units_in_term(flatten$7(t2));
  }
  convert_units_in_term(e2) {
    if (!Array.isArray(e2)) return e2;
    let t2 = e2[0], r = e2.slice(1);
    if ("*" === t2) {
      let t3 = r.length;
      for (let [e3, n] of r.entries()) {
        let i2 = this.units[n];
        if (i2) {
          if (i2.prefix && e3 < t3 - 1) {
            let a;
            a = e3 === t3 - 2 ? r[t3 - 1] : this.convert_units_in_term(["*", ...r.slice(e3 + 1)]);
            let o = n;
            i2.substitute && (o = i2.substitute);
            let s = ["unit", o, a];
            return 0 === e3 ? s : ["*", ...r.slice(0, e3), s];
          }
          if (!i2.prefix && e3 > 0) {
            let a, o = n;
            return i2.substitute && (o = i2.substitute), a = 1 === e3 ? ["unit", r[0], o] : ["unit", ["*", ...r.slice(0, e3)], o], e3 === t3 - 1 ? a : this.convert_units_in_term(["*", a, ...r.slice(e3 + 1)]);
          }
        }
      }
      return e2;
    }
    return "/" === t2 ? ["/", this.convert_units_in_term(r[0]), this.convert_units_in_term(r[1])] : e2;
  }
  factor(e2) {
    if ("+" === this.token.token_text) {
      this.advance();
      let t3 = this.factor(e2);
      return false === t3 ? "+" : "string" == typeof t3 && [...t3].every(((e3) => ["+", "-"].includes(e3))) ? "+" + t3 : ["+", t3];
    }
    if ("-" === this.token.token_type) {
      this.advance();
      let t3 = this.factor(e2);
      return t3 > 0 ? -t3 : false === t3 ? "-" : "string" == typeof t3 && [...t3].every(((e3) => ["+", "-"].includes(e3))) ? "-" + t3 : ["-", t3];
    }
    let t2 = this.nonMinusFactor(e2);
    return false === t2 && "PERP" === this.token.token_type && (t2 = "perp", this.advance()), t2;
  }
  nonMinusFactor(e2) {
    for (var t2 = this.baseFactor(e2); "^" === this.token.token_type || "!" === this.token.token_type || "'" === this.token.token_type; ) if (false === t2 && (t2 = "＿"), "^" === this.token.token_type) {
      this.advance(), t2 = ["^", t2, this.get_subsuperscript(e2)];
    } else "!" === this.token.token_type ? (t2 = ["apply", "factorial", t2], this.advance()) : (t2 = ["prime", t2], this.advance());
    return t2;
  }
  get_subsuperscript({ parse_absolute_value: e2 }) {
    if (["+", "-", "PERP"].includes(this.token.token_type)) {
      let e3 = this.token.token_type.toLowerCase();
      return this.advance(), e3;
    }
    {
      let t2 = this.baseFactor({ parse_absolute_value: e2, in_subsuperscript_with_no_delimiters: true });
      return false === t2 && (t2 = "＿"), t2;
    }
  }
  baseFactor({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true, allow_absolute_value_closing: r = false, in_subsuperscript_with_no_delimiters: n = false } = {}) {
    var i2 = false;
    if ("NUMBER" === this.token.token_type) i2 = parseFloat(this.token.token_text), this.advance();
    else if ("INFINITY" === this.token.token_type) i2 = 1 / 0, this.advance();
    else if ("VAR" === this.token.token_type || "VARMULTICHAR" === this.token.token_type) {
      if (i2 = this.token.token_text, this.appliedFunctionSymbols.includes(i2) || this.functionSymbols.includes(i2)) {
        let e3 = false;
        if (this.appliedFunctionSymbols.includes(i2) && (e3 = true), this.advance(), "_" === this.token.token_type) {
          this.advance();
          let e4 = this.get_subsuperscript({ parse_absolute_value: t2 });
          i2 = "log" === i2 && 10 === e4 ? "log10" : ["_", i2, e4];
        }
        if (n) e3 && (i2 = ["apply", i2, "＿"]);
        else {
          for (; "'" === this.token.token_type; ) i2 = ["prime", i2], this.advance();
          for (; "^" === this.token.token_type; ) {
            this.advance(), i2 = ["^", i2, this.get_subsuperscript({ parse_absolute_value: t2 })];
          }
          if ("(" === this.token.token_type) {
            this.advance();
            let e4 = this.statement_list();
            if (")" !== this.token.token_type) throw new ParseError$1("Expecting )", this.lexer.location);
            this.advance(), "list" === e4[0] && (e4[0] = "tuple"), i2 = ["apply", i2, e4];
          } else if (e3) {
            if (!this.allowSimplifiedFunctionApplication) throw new ParseError$1("Expecting ( after function", this.lexer.location);
            let e4 = this.factor({ parse_absolute_value: t2 });
            false === e4 && (e4 = "＿"), i2 = ["apply", i2, e4];
          }
        }
        return i2;
      }
      if (this.operatorSymbols.includes(i2)) if (this.advance(), "(" === this.token.token_type) {
        this.advance();
        let e3 = this.statement_list();
        if (")" !== this.token.token_type) throw new ParseError$1("Expecting )", this.lexer.location);
        this.advance(), i2 = "list" === e3[0] ? [i2, ...e3.slice(1)] : [i2, e3];
      } else {
        let e3 = this.factor({ parse_absolute_value: t2 });
        false === e3 && (e3 = "＿"), i2 = [i2, e3];
      }
      else {
        if (this.parseLeibnizNotation) {
          let e3 = this.return_state(), t3 = this.leibniz_notation();
          if (t3) return t3;
          this.set_state(e3);
        }
        let n3 = this.splitSymbols;
        if (n3 && ("VARMULTICHAR" === this.token.token_type || this.unsplitSymbols.includes(i2) || 1 === i2.length || i2.match(/[\d]/g)) && (n3 = false), n3) {
          for (let e3 = i2.length - 1; e3 >= 0; e3--) this.lexer.unput(" "), this.lexer.unput(i2[e3]);
          return this.advance(), this.baseFactor({ inside_absolute_value: e2, parse_absolute_value: t2, allow_absolute_value_closing: r });
        }
        this.advance();
      }
    } else if ("(" === this.token.token_type || "[" === this.token.token_type || "{" === this.token.token_type || "LANGLE" === this.token.token_type) {
      let e3, t3, r2 = this.token.token_type;
      "(" === this.token.token_type ? (e3 = ")", t3 = "]") : "[" === this.token.token_type ? (e3 = "]", t3 = ")") : "{" === this.token.token_type ? (e3 = "}", t3 = null) : (e3 = "RANGLE", t3 = null), this.advance();
      let n3 = 1;
      if ("list" === (i2 = this.statement_list())[0] && (n3 = i2.length - 1), this.token.token_type !== e3) {
        if (2 !== n3 || null === t3) throw new ParseError$1("Expecting " + e3, this.lexer.location);
        if (this.token.token_type !== t3) throw new ParseError$1("Expecting ) or ]", this.lexer.location);
        let a;
        i2[0] = "tuple", a = "(" === r2 ? ["tuple", false, true] : ["tuple", true, false], (i2 = ["interval", i2]).push(a);
      } else n3 >= 2 ? i2[0] = "(" === r2 ? "tuple" : "[" === r2 ? "array" : "{" === r2 ? "set" : "altvector" : "{" === r2 && (i2 = ("|" === i2[0] || i2[0], ["set", i2]));
      this.advance();
    } else if ("|" !== this.token.token_type || !t2 || 0 !== e2 && r) {
      if ("ANGLE" === this.token.token_type) if (this.advance(), "(" === this.token.token_type) {
        this.advance();
        let e3 = this.statement_list();
        if (")" !== this.token.token_type) throw new ParseError$1("Expecting )", this.lexer.location);
        this.advance(), "list" === e3[0] ? i2 = ["angle", ...e3.slice(1)] : "*" === e3[0] && (i2 = ["angle", e3]);
      } else {
        let e3 = [], r2 = this.nonMinusFactor({ parse_absolute_value: t2 });
        for (; false !== r2; ) e3.push(r2), r2 = this.nonMinusFactor({ parse_absolute_value: t2 });
        i2 = 0 === e3.length ? "angle" : ["angle", ...e3];
      }
      else if ("INT" === this.token.token_type) {
        this.advance();
        let e3 = "int";
        if ("_" === this.token.token_type) {
          this.advance(), e3 = ["_", e3, this.get_subsuperscript({ parse_absolute_value: t2 })];
        }
        if ("^" === this.token.token_type) {
          this.advance(), e3 = ["^", e3, this.get_subsuperscript({ parse_absolute_value: t2 })];
        }
        let r2 = flatten$7(this.term({ parse_absolute_value: t2 }));
        if (Array.isArray(r2) && "*" === r2[0]) {
          let e4 = [];
          for (let t3 = 0; t3 < r2.length - 1; t3++) {
            if ("d" === r2[t3]) {
              let n3 = r2[t3 + 1];
              r2.splice(t3, 2), e4.push(["d", n3]), t3--;
            }
          }
          r2.push(...e4);
        }
        return ["apply", e3, r2];
      }
    } else {
      if (e2 += 1, this.advance(), i2 = ["apply", "abs", i2 = this.statement({ inside_absolute_value: e2 })], "|" !== this.token.token_type) throw new ParseError$1("Expecting |", this.lexer.location);
      this.advance();
    }
    if ("_" === this.token.token_type) {
      false === i2 && (i2 = "＿"), this.advance(), i2 = ["_", i2, this.get_subsuperscript({ parse_absolute_value: t2 })];
    }
    return i2;
  }
  leibniz_notation() {
    var e2 = this.token.token_text;
    if ("VAR" !== this.token.token_type || "d" !== e2[0] && "∂" !== e2[0] || !(1 === e2.length || 2 === e2.length && /[a-zA-Z]/.exec(e2[1]))) return false;
    let t2 = e2[0], r = 1, n = "", i2 = [], a = [];
    if (2 === e2.length) n = e2[1];
    else if (this.advance(), "VARMULTICHAR" === this.token.token_type || "VAR" === this.token.token_type && !this.token.token_text.includes("∂")) n = this.token.token_text;
    else {
      if ("^" !== this.token.token_type) return false;
      if (this.advance(), "NUMBER" !== this.token.token_type) return false;
      if (r = parseFloat(this.token.token_text), !Number.isInteger(r)) return false;
      if (this.advance(), ("VAR" !== this.token.token_type || this.token.token_text.includes("∂")) && "VARMULTICHAR" !== this.token.token_type) return false;
      n = this.token.token_text;
    }
    if (this.advance(), "/" !== this.token.token_type) return false;
    let o = 0;
    for (this.advance(); ; ) {
      if ("VAR" !== this.token.token_type || this.token.token_text[0] !== t2) return false;
      this.token.token_text.length > 2 && (this.lexer.unput(this.token.token_text.slice(2)), this.token.token_text = this.token.token_text.slice(0, 2));
      let s = this.token.token_text;
      if (2 === s.length) {
        if (!/[a-zA-Z]/.exec(s[1])) return false;
        i2.push(s[1]);
      } else {
        if (this.advance(), ("VAR" !== this.token.token_type || this.token.token_text.includes("∂")) && "VARMULTICHAR" !== this.token.token_type) return false;
        i2.push(this.token.token_text);
      }
      let u = 1, c2 = false;
      if (this.advance({ remove_initial_space: false }), "SPACE" === this.token.token_type && (c2 = true, this.advance()), "^" === this.token.token_type) {
        if (this.advance(), "NUMBER" !== this.token.token_type) return false;
        if (u = parseFloat(this.token.token_text), !Number.isInteger(u)) return false;
        c2 = false, this.advance({ remove_initial_space: false }), "SPACE" === this.token.token_type && (c2 = true, this.advance());
      }
      if (a.push(u), o += u, o > r) return false;
      if (o === r) {
        if (!c2 && ("VAR" === this.token.token_type || "VARMULTICHAR" === this.token.token_type)) return false;
        "SPACE" === this.token.token_type && this.advance();
        let o2 = "derivative_leibniz";
        "∂" === t2 && (o2 = "partial_" + o2), e2 = [o2], 1 === r ? e2.push(n) : e2.push(["tuple", n, r]);
        let s2 = [];
        for (let e3 = 0; e3 < i2.length; e3 += 1) 1 === a[e3] ? s2.push(i2[e3]) : s2.push(["tuple", i2[e3], a[e3]]);
        return s2 = ["tuple"].concat(s2), e2.push(s2), e2;
      }
    }
  }
};
var textToAst$3$1 = new textToAst$4$1();
function expand$1(e2, t2) {
  var r = get_tree$1(e2);
  r = perform_vector_matrix_additions_scalar_multiplications$1(r = perform_matrix_multiplications$1(r));
  const n = (e3) => !Array.isArray(e3) || !["d", "*"].includes(e3[0]) || "*" === e3[0] && e3.slice(1).every(((e4) => !Array.isArray(e4) || "d" !== e4[0]));
  var i2 = [];
  return i2.push([textToAst$3$1.convert("a*(b+c)"), textToAst$3$1.convert("a*b+a*c"), ["^", "x", ["+", "n", "m"]], { variables: { a: n, b: true, c: true }, allow_extended_match: true }]), i2.push([textToAst$3$1.convert("(a+b)*c"), textToAst$3$1.convert("a*c+b*c"), { variables: { a: true, b: true, c: n }, allow_extended_match: true }]), t2 || i2.push([textToAst$3$1.convert("(a+b)/c"), textToAst$3$1.convert("a/c+b/c")]), i2.push([textToAst$3$1.convert("-(a+b)"), textToAst$3$1.convert("-a-b")]), i2.push([textToAst$3$1.convert("a(-b)"), textToAst$3$1.convert("-ab")]), i2.push([textToAst$3$1.convert("(a+b)^2"), textToAst$3$1.convert("a^2+2ab+b^2")]), i2.push([textToAst$3$1.convert("(a+b)^3"), textToAst$3$1.convert("a^3+3a^2b+3ab^2+b^3")]), i2.push([textToAst$3$1.convert("(a+b)^4"), textToAst$3$1.convert("a^4+4a^3b+6a^2b^2+4ab^3+b^4")]), i2.push([textToAst$3$1.convert("a*(b+c)*d"), textToAst$3$1.convert("(a*b+a*c)*d")]), r = normalize_negatives$1(r = collect_like_terms_factors$1(r = evaluate_numbers$1(r = flatten$5$1(r = applyAllTransformations$1(r, i2, 20)))));
}
function perform_matrix_multiplications$1(e2, t2 = true, r = true) {
  var n = get_tree$1(e2);
  function i2(e3, t3) {
    let r2 = e3[1][1], n3 = e3[1][2], i3 = t3[1][2];
    if (t3[1][1] !== n3) return { success: false };
    let a2 = e3[2], o2 = t3[2], s = ["tuple"];
    for (let e4 = 0; e4 < r2; e4++) {
      let t4 = a2[e4 + 1].slice(1), r3 = ["tuple"];
      for (let e5 = 0; e5 < i3; e5++) {
        let i4 = o2.slice(1).map(((t5) => t5[e5 + 1]));
        if (t4.length !== n3 || i4.length !== n3) return subtree;
        let a3 = ["+", ...t4.map(((e6, t5) => ["*", e6, i4[t5]]))];
        r3.push(a3);
      }
      s.push(r3);
    }
    return { success: true, newMatrix: ["matrix", ["tuple", r2, i3], s] };
  }
  function a(e3, t3) {
    if (!Number.isInteger(t3) || t3 < 1) return { success: false };
    if (1 === t3) return { success: true, newMatrix: e3 };
    let r2 = e3[1][1];
    if (e3[1][2] !== r2) return { success: false };
    let n3 = e3[2], i3 = JSON.parse(JSON.stringify(n3));
    for (let e4 = 1; e4 < t3; e4++) {
      const e5 = i3;
      i3 = ["tuple"];
      for (let t4 = 0; t4 < r2; t4++) {
        let a2 = e5[t4 + 1].slice(1), o2 = ["tuple"];
        for (let e6 = 0; e6 < r2; e6++) {
          let t5 = n3.slice(1).map(((t6) => t6[e6 + 1]));
          if (a2.length !== r2 || t5.length !== r2) return subtree;
          let i4 = ["+", ...a2.map(((e7, r3) => ["*", e7, t5[r3]]))];
          o2.push(i4);
        }
        i3.push(o2);
      }
    }
    return { success: true, newMatrix: ["matrix", ["tuple", r2, r2], i3] };
  }
  function o(e3, t3) {
    let r2 = e3[1][1], n3 = e3[1][2], i3 = e3[2], a2 = ["tuple"];
    for (let e4 = 0; e4 < r2; e4++) {
      let r3 = ["tuple"], o2 = i3[e4 + 1];
      for (let e5 = 0; e5 < n3; e5++) r3.push(["*", t3, o2[e5 + 1]]);
      a2.push(r3);
    }
    return ["matrix", ["tuple", r2, n3], a2];
  }
  return (function() {
    let e3 = ["^", ["matrix", "size", "matrixData"], "p"], t3 = { variables: { p: (e4) => Number.isInteger(e4) && e4 > 0, size: true, matrixData: true } };
    n = transform$1(n, (function(r2) {
      let n3 = match$2$1(r2, e3, t3);
      if (n3) {
        let e4 = a(["matrix", n3.size, n3.matrixData], n3.p);
        return e4.success ? e4.newMatrix : r2;
      }
      return r2;
    }));
  })(), (function() {
    let e3 = ["*", "a", ["matrix", "size", "matrixData"], "b"], t3 = { variables: { a: true, b: true, size: true, matrixData: true }, allow_implicit_identities: ["a", "b"] };
    n = transform$1(n, (function(r2) {
      let n3 = match$2$1(r2, e3, t3);
      if (n3) {
        let e4 = ["matrix", n3.size, n3.matrixData], t4 = [], r3 = [];
        Array.isArray(n3.a) && "*" === n3.a[0] ? t4.push(...n3.a.slice(1)) : t4.push(n3.a), Array.isArray(n3.b) && "*" === n3.b[0] ? r3.push(...n3.b.slice(1)) : r3.push(n3.b);
        for (let r4 = t4.length - 1; r4 >= 0; r4--) {
          let n4 = t4[r4][0];
          if ("matrix" === n4) {
            let n5 = i2(t4[r4], e4);
            if (!n5.success) break;
            e4 = n5.newMatrix, t4.pop();
          } else {
            if (["tuple", "list", "vector", "altvector", "interval", "set", "array"].includes(n4)) break;
            1 !== t4[r4] && (e4 = o(e4, t4[r4])), t4.pop();
          }
        }
        for (; r3.length > 0; ) {
          let t5 = r3[0][0];
          if ("matrix" === t5) {
            let t6 = i2(e4, r3[0]);
            if (!t6.success) break;
            e4 = t6.newMatrix, r3.splice(0, 1);
          } else {
            if (["tuple", "list", "vector", "altvector", "interval", "set", "array"].includes(t5)) break;
            1 !== r3[0] && (e4 = o(e4, r3[0])), r3.splice(0, 1);
          }
        }
        return t4.length > 0 || r3.length > 0 ? ["*", ...t4, e4, ...r3] : e4;
      }
      return r2;
    }));
  })(), (t2 || r) && (function() {
    let e3 = ["*", ["matrix", ["tuple", "m", "n"], "matrixData"], "b"], i3 = { variables: { n: Number.isInteger, m: Number.isInteger, matrixData: true, b: true } };
    n = transform$1(n, (function(n3) {
      let a2 = match$2$1(n3, e3, i3);
      if (a2) {
        let e4, i4 = a2.m, o2 = a2.n, s = a2.b, u = a2.matrixData, c2 = [];
        t2 && (c2.push("vector"), c2.push("altvector")), r && c2.push("tuple");
        let l = [];
        if (c2.includes(s[0])) e4 = s;
        else {
          if (!Array.isArray(s) || "*" !== s[0] || !c2.includes(s[1][0])) return n3;
          e4 = s[1], l = s.slice(2);
        }
        let f2 = e4.slice(1);
        if (f2.length !== o2) return n3;
        let p = [e4[0]];
        for (let e5 = 0; e5 < i4; e5++) {
          let t3 = ["+", ...u[e5 + 1].slice(1).map(((e6, t4) => ["*", e6, f2[t4]]))];
          p.push(t3);
        }
        return l.length > 0 ? ["*", p, ...l] : p;
      }
      return n3;
    }));
  })(), n;
}
function perform_vector_scalar_multiplications$1(e2, t2 = true) {
  var r = get_tree$1(e2);
  let n = function(e3, t3) {
    let r2 = ["*", "a", [t3, "vectorData"], "b"], n3 = { allow_implicit_identities: ["a", "b"] };
    return e3 = transform$1(e3, (function(e4) {
      let i2 = match$2$1(e4, r2, n3);
      if (i2) {
        if (1 === i2.a && 1 === i2.b) return e4;
        let r3 = i2.vectorData;
        r3 = Array.isArray(r3) && r3[0] === t3 ? r3.slice(1) : [r3];
        let n4 = [], a = [];
        Array.isArray(i2.a) && "*" === i2.a[0] ? n4.push(...i2.a.slice(1)) : n4.push(i2.a), Array.isArray(i2.b) && "*" === i2.b[0] ? a.push(...i2.b.slice(1)) : a.push(i2.b);
        for (let e5 = n4.length - 1; e5 >= 0; e5--) {
          let t4 = n4[e5][0];
          if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(t4)) break;
          1 !== n4[e5] && (r3 = r3.map(((t5) => ["*", t5, n4[e5]]))), n4.pop();
        }
        for (; a.length > 0; ) {
          let e5 = a[0][0];
          if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(e5)) break;
          1 !== a[0] && (r3 = r3.map(((e6) => ["*", e6, a[0]]))), a.splice(0, 1);
        }
        let o = [t3, ...r3];
        return n4.length > 0 || a.length > 0 ? ["*", ...n4, o, ...a] : o;
      }
      return e4;
    }));
  };
  return r = n(r, "vector"), r = n(r, "altvector"), t2 && (r = n(r, "tuple")), r;
}
function perform_matrix_scalar_multiplications$1(e2) {
  var t2 = get_tree$1(e2);
  let r = ["*", "a", ["matrix", "size", "matrixData"], "b"], n = { allow_implicit_identities: ["a", "b"] };
  return t2 = transform$1(t2, (function(e3) {
    let t3 = match$2$1(e3, r, n);
    if (t3) {
      if (1 === t3.a && 1 === t3.b) return e3;
      let r2 = t3.matrixData, n3 = [], i2 = [];
      Array.isArray(t3.a) && "*" === t3.a[0] ? n3.push(...t3.a.slice(1)) : n3.push(t3.a), Array.isArray(t3.b) && "*" === t3.b[0] ? i2.push(...t3.b.slice(1)) : i2.push(t3.b);
      for (let e4 = n3.length - 1; e4 >= 0; e4--) {
        let t4 = n3[e4][0];
        if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(t4)) break;
        1 !== n3[e4] && (r2 = r2.map(((t5) => "tuple" === t5 ? t5 : t5.map(((t6) => "tuple" === t6 ? t6 : ["*", t6, n3[e4]]))))), n3.pop();
      }
      for (; i2.length > 0; ) {
        let e4 = i2[0][0];
        if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(e4)) break;
        1 !== i2[0] && (r2 = r2.map(((e5) => "tuple" === e5 ? e5 : e5.map(((e6) => "tuple" === e6 ? e6 : ["*", e6, i2[0]]))))), i2.splice(0, 1);
      }
      let a = ["matrix", t3.size, r2];
      return n3.length > 0 || i2.length > 0 ? ["*", ...n3, a, ...i2] : a;
    }
    return e3;
  }));
}
function expand_relations$1(e2) {
  var t2 = get_tree$1(e2);
  return transform$1(t2, expand_relations_transform$1);
}
function expand_relations_transform$1(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if ("=" === t2) {
    if (r.length <= 2) return e2;
    let t3 = ["and"];
    for (let e3 = 0; e3 < r.length - 1; e3++) t3.push(["=", r[e3], r[e3 + 1]]);
    return t3;
  }
  if ("gts" === t2 || "lts" === t2) {
    let e3 = r[0], n = r[1];
    if ("tuple" !== e3[0] || "tuple" !== n[0]) throw new Error("Badly formed ast");
    let i2 = [];
    for (let r2 = 1; r2 < e3.length - 1; r2++) {
      let a2;
      a2 = n[r2] ? "lts" === t2 ? "<" : ">" : "lts" === t2 ? "le" : "ge", i2.push([a2, e3[r2], e3[r2 + 1]]);
    }
    let a = ["and", i2[0], i2[1]];
    for (let e4 = 2; e4 < i2.length; e4++) a = ["and", a, i2[e4]];
    return a;
  }
  if ("in" === t2 || "notin" === t2 || "ni" === t2 || "notni" === t2) {
    let n, i2, a = false;
    if ("notin" !== t2 && "notni" !== t2 || (a = true), "in" === t2 || "notin" === t2 ? (n = r[0], i2 = r[1]) : (n = r[1], i2 = r[0]), i2 = to_intervals$1(i2), "interval" !== i2[0]) return e2;
    let o = i2[1], s = i2[2];
    if ("tuple" !== o[0] || "tuple" !== s[0]) throw new Error("Badly formed ast");
    let u, c2 = o[1], l = o[2], f2 = [];
    return s[1] ? a ? f2.push(["<", n, c2]) : f2.push(["ge", n, c2]) : a ? f2.push(["le", n, c2]) : f2.push([">", n, c2]), s[2] ? a ? f2.push([">", n, l]) : f2.push(["le", n, l]) : a ? f2.push(["ge", n, l]) : f2.push(["<", n, l]), u = a ? ["or"].concat(f2) : ["and"].concat(f2), u;
  }
  if ("subset" === t2 || "notsubset" === t2 || "superset" === t2 || "notsuperset" === t2) {
    let n, i2, a = false;
    if ("notsubset" !== t2 && "notsuperset" !== t2 || (a = true), "subset" === t2 || "notsubset" === t2 ? (n = r[0], i2 = r[1]) : (n = r[1], i2 = r[0]), n = to_intervals$1(n), i2 = to_intervals$1(i2), "interval" !== n[0] || "interval" !== i2[0]) return e2;
    let o = n[1], s = n[2], u = i2[1], c2 = i2[2];
    if ("tuple" !== o[0] || "tuple" !== s[0] || "tuple" !== u[0] || "tuple" !== c2[0]) throw new Error("Badly formed ast");
    let l, f2 = o[1], p = o[2], m = u[1], d = u[2], h = [];
    return s[1] && !c2[1] ? a ? h.push(["le", f2, m]) : h.push([">", f2, m]) : a ? h.push(["<", f2, m]) : h.push(["ge", f2, m]), s[2] && !c2[2] ? a ? h.push(["ge", p, d]) : h.push(["<", p, d]) : a ? h.push([">", p, d]) : h.push(["le", p, d]), l = a ? ["or"].concat(h) : ["and"].concat(h), l;
  }
  return e2;
}
function substitute$2(e2, t2) {
  var r = get_tree$1(e2), n = {};
  for (let e3 in t2) n[e3] = get_tree$1(t2[e3]);
  return substitute$1$1(r, n);
}
function substitute_component$1(e2, t2, r) {
  let n = get_tree$1(e2);
  if (get_tree$1(r), "number" == typeof t2) t2 = [t2];
  else if (!Array.isArray(t2)) throw Error("Invalid substitute_component: " + t2);
  let i2 = ["list", "tuple", "vector", "altvector", "array"];
  return (function e3(t3, n3, a) {
    if (0 === n3.length) return r;
    if (!Array.isArray(t3)) throw Error("Invalid substitute_component: expected list, tuple, vector, or array");
    let o = t3[0], s = t3.slice(1);
    if (!i2.includes(o)) throw Error("Invalid substitute_component: expected list, tuple, vector, or array");
    let u = n3[0];
    if (u < 0 || u > s.length - 1) throw Error("Invalid substitute_component: component out of range");
    let c2 = n3.slice(1), l = e3(s[u], c2);
    return [o, ...s.slice(0, u), l, ...s.slice(u + 1)];
  })(n, t2);
}
function get_component$1(e2, t2) {
  let r = get_tree$1(e2);
  if ("number" == typeof t2) t2 = [t2];
  else if (!Array.isArray(t2)) throw Error("Invalid get_component: " + t2);
  let n = ["list", "tuple", "vector", "altvector", "array"];
  return (function e3(t3, r2) {
    if (0 === r2.length) return t3;
    if (!Array.isArray(t3)) throw Error("Invalid get_component: expected list, tuple, vector, or array");
    let i2 = t3[0], a = t3.slice(1);
    if (!n.includes(i2)) throw Error("Invalid get_component: expected list, tuple, vector, or array");
    let o = r2[0];
    if (o < 0 || o > a.length - 1) throw Error("Invalid get_component: component out of range");
    let s = r2.slice(1);
    return e3(a[o], s);
  })(r, t2);
}
var transformation$1 = Object.freeze({ __proto__: null, expand: expand$1, expand_relations: expand_relations$1, substitute: substitute$2, substitute_component: substitute_component$1, get_component: get_component$1, perform_vector_scalar_multiplications: perform_vector_scalar_multiplications$1, perform_matrix_scalar_multiplications: perform_matrix_scalar_multiplications$1, perform_matrix_multiplications: perform_matrix_multiplications$1 });
function clean$2(e2) {
  return flatten$5$1(get_tree$1(e2));
}
function evalf$1(e2, t2) {
  return parseFloat(math$1$1.format(e2, { notation: "exponential", precision: t2 }));
}
function collapse_unary_minus$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if (n = n.map(((e3) => collapse_unary_minus$1(e3))), "-" === r) {
    if ("number" == typeof n[0]) return -n[0];
    if (Array.isArray(n[0]) && "*" === n[0][0] && "number" == typeof n[0][1]) return ["*", -n[0][1]].concat(n[0].slice(2));
    if (Array.isArray(n[0]) && "/" === n[0][0]) {
      if ("number" == typeof n[0][1]) return ["/", -n[0][1], n[0][2]];
      if (Array.isArray(n[0][1]) && "*" === n[0][1][0] && "number" == typeof n[0][1][1]) return ["/", ["*", -n[0][1][1]].concat(n[0][1].slice(2)), n[0][2]];
    }
  }
  return [r].concat(n);
}
function simplify$2(e2, t2, r) {
  var n = get_tree$1(e2);
  return contains_blank$1(n) ? n : (void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), n = evaluate_numbers$1(n, { assumptions: t2, max_digits: r, evaluate_functions: true }), Array.isArray(n) ? n = collect_like_terms_factors$1(n = simplify_integer_square_roots$1(n = perform_vector_matrix_additions_scalar_multiplications$1(n = simplify_logical$1(n, t2))), t2, r) : n);
}
function simplify_logical$1(e2, t2) {
  var r = get_tree$1(e2);
  if (contains_blank$1(r)) return r;
  void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), r = evaluate_numbers$1(r, { assumptions: t2 }), r = unflattenRight$1(r);
  var n = [];
  return n.push([["not", ["not", "a"]], "a"]), n.push([["not", ["and", "a", "b"]], ["or", ["not", "a"], ["not", "b"]]]), n.push([["not", ["or", "a", "b"]], ["and", ["not", "a"], ["not", "b"]]]), n.push([["not", ["=", "a", "b"]], ["ne", "a", "b"]]), n.push([["not", ["ne", "a", "b"]], ["=", "a", "b"]]), n.push([["not", ["<", "a", "b"]], ["le", "b", "a"]]), n.push([["not", ["le", "a", "b"]], ["not", ["le", "a", "b"]]]), n.push([["not", ["in", "a", "b"]], ["notin", "a", "b"]]), n.push([["not", ["subset", "a", "b"]], ["notsubset", "a", "b"]]), r = flatten$5$1(r = applyAllTransformations$1(r, n, 20));
}
function simplify_integer_square_roots$1(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if ("apply" === t2 && "sqrt" === r[0] && Number.isInteger(r[1])) {
    let t3 = r[1], n = 1, i2 = 2, a = 4;
    for (; a <= Math.abs(t3); ) t3 % a == 0 ? (t3 /= a, n *= i2) : (i2++, a = i2 * i2);
    return n > 1 ? ["*", n, ["apply", "sqrt", t3]] : e2;
  }
  return [t2, ...r.map(simplify_integer_square_roots$1)];
}
function perform_vector_matrix_additions_scalar_multiplications$1(e2, t2 = true) {
  var r = get_tree$1(e2);
  r = perform_vector_scalar_multiplications$1(r = perform_matrix_scalar_multiplications$1(r), t2);
  let n = ["+", "a", "b"];
  return r = transform$1(r, (function(e3) {
    let r2 = match$2$1(e3, n, { allow_permutations: true });
    if (r2) {
      let n3 = ["vector", "altvector"];
      t2 && n3.push("tuple");
      let i2 = {}, a = {}, o = [];
      if (n3.includes(r2.a[0])) {
        let e4 = r2.a.length - 1;
        i2[e4] || (i2[e4] = []), i2[e4].push(r2.a);
      } else if ("matrix" === r2.a[0]) {
        let e4 = r2.a[1].slice(1).toString();
        a[e4] || (a[e4] = []), a[e4].push(r2.a);
      } else o.push(r2.a);
      if (n3.includes(r2.b[0])) {
        let e4 = r2.b.length - 1;
        i2[e4] || (i2[e4] = []), i2[e4].push(r2.b);
      } else if ("matrix" === r2.b[0]) {
        let e4 = r2.b[1].slice(1).toString();
        a[e4] || (a[e4] = []), a[e4].push(r2.b);
      } else if ("+" === r2.b[0]) for (let e4 of r2.b.slice(1)) if (n3.includes(e4[0])) {
        let t3 = e4.length - 1;
        i2[t3] || (i2[t3] = []), i2[t3].push(e4);
      } else if ("matrix" === e4[0]) {
        let t3 = e4[1].slice(1).toString();
        a[t3] || (a[t3] = []), a[t3].push(e4);
      } else o.push(e4);
      else o.push(r2.b);
      if (Object.values(i2).every(((e4) => e4.length < 2)) && Object.values(a).every(((e4) => e4.length < 2))) return e3;
      let s = o;
      for (let e4 in i2) if (i2[e4].length < 2) s.push(...i2[e4]);
      else {
        let t3, r3 = i2[e4].some(((e5) => "vector" === e5[0])), n4 = i2[e4].some(((e5) => "tuple" === e5[0])), a2 = i2[e4].some(((e5) => "altvector" === e5[0]));
        t3 = r3 || n4 && a2 ? ["vector"] : a2 ? ["altvector"] : ["tuple"];
        for (let r4 = 0; r4 < e4; r4++) t3.push(["+", ...i2[e4].map(((e5) => e5[r4 + 1]))]);
        s.push(t3);
      }
      for (let e4 in a) if (a[e4].length < 2) s.push(...a[e4]);
      else {
        let [t3, r3] = e4.split(",").map(Number), n4 = ["tuple"];
        for (let i4 = 0; i4 < t3; i4++) {
          let t4 = ["tuple"];
          for (let n5 = 0; n5 < r3; n5++) t4.push(["+", ...a[e4].map(((e5) => e5[2][i4 + 1][n5 + 1]))]);
          n4.push(t4);
        }
        let i3 = ["matrix", ["tuple", t3, r3], n4];
        s.push(i3);
      }
      return 1 === s.length ? s[0] : ["+", ...s];
    }
    return e3;
  })), r;
}
function contains_decimal_number$1(e2) {
  return "string" != typeof e2 && ("number" == typeof e2 ? !(!Number.isFinite(e2) || Number.isInteger(e2)) : !!Array.isArray(e2) && e2.slice(1).some(((e3) => contains_decimal_number$1(e3))));
}
function contains_only_numbers$1(e2, { include_number_symbols: t2 = false, evaluate_functions: r = false } = {}) {
  if ("string" == typeof e2) {
    if (t2) {
      if ("e" === e2 && math$1$1.define_e) return true;
      if ("pi" === e2 && math$1$1.define_pi) return true;
    }
    return !("i" !== e2 || !math$1$1.define_i);
  }
  return "number" == typeof e2 || !!Array.isArray(e2) && (r && "apply" === e2[0] ? e2.slice(2).every(((e3) => contains_only_numbers$1(e3, { include_number_symbols: t2 }))) : e2.slice(1).every(((e3) => contains_only_numbers$1(e3, { include_number_symbols: t2 }))));
}
function try_evaluate_sum_of_numbers$1(e2, t2, r) {
  if ("number" == typeof e2) {
    if (0 === e2) return t2;
    if ("number" == typeof t2) return e2 + t2;
    if (Array.isArray(t2) && "+" === t2[0] && "number" == typeof t2[1]) return ["+", e2 + t2[1], t2[2]];
    if (!r && Array.isArray(t2) && "+" === t2[0] && "number" == typeof t2[2]) return ["+", e2 + t2[2], t2[1]];
  }
  return "number" == typeof t2 && 0 === t2 ? e2 : null;
}
function try_evaluate_negate_number$1(e2) {
  if ("number" == typeof e2) return -e2;
  if (Array.isArray(e2) && "*" === e2[0] && "number" == typeof e2[1]) return ["*", -e2[1]].concat(e2.slice(2));
  if (Array.isArray(e2) && "/" === e2[0]) {
    if ("number" == typeof e2[1]) return ["/", -e2[1], e2[2]];
    if (Array.isArray(e2[1]) && "*" === e2[1][0] && "number" == typeof e2[1][1]) return ["/", ["*", -e2[1][1]].concat(e2[1].slice(2)), e2[2]];
  }
  return null;
}
function try_evaluate_product_of_numbers$1(e2, t2) {
  if ("number" == typeof e2) {
    if (isNaN(e2)) return NaN;
    if ("number" == typeof t2) return e2 * t2;
    if (!isFinite(e2)) return e2 === 1 / 0 && is_negative_ast$1(t2) || e2 === -1 / 0 && is_positive_ast$1(t2) ? -1 / 0 : false === is_nonzero_ast$1(t2) ? NaN : 1 / 0;
    if (0 === e2) return 0;
    if (1 === e2) return t2;
    if (-1 === e2) return ["-", t2];
    if (Array.isArray(t2) && "*" === t2[0] && "number" == typeof t2[1]) return e2 *= t2[1], t2 = t2[2], 1 === e2 ? t2 : -1 === e2 ? ["-", t2] : ["*", e2, t2];
  }
  if ("number" == typeof t2) {
    if (isNaN(t2)) return NaN;
    if (!isFinite(t2)) return t2 === 1 / 0 && is_negative_ast$1(e2) || t2 === -1 / 0 && is_positive_ast$1(e2) ? -1 / 0 : false === is_nonzero_ast$1(e2) ? NaN : 1 / 0;
    if (0 === t2) return 0;
    if (1 === t2) return e2;
    if (-1 === t2) return ["-", e2];
    if (Array.isArray(e2) && "*" === e2[0] && "number" == typeof e2[1]) return t2 *= e2[1], e2 = e2[2], 1 === t2 ? e2 : -1 === t2 ? ["-", e2] : ["*", e2, t2];
  }
  if (math$1$1.define_i && "i" === e2) {
    if ("i" === t2) return -1;
    if (Array.isArray(t2) && "*" === t2[0] && "i" === t2[1]) return ["-", t2[2]];
  } else if (math$1$1.define_i && "i" === t2 && Array.isArray(e2) && "*" === e2[0] && "i" === e2[1]) return ["-", e2[2]];
  return null;
}
function try_evaluate_quotient_of_numbers$1(e2, t2, r, n) {
  if ("number" == typeof e2) {
    if (0 === e2) {
      let e3 = is_nonzero_ast$1(t2, r);
      if (e3) return 0;
      if (false === e3) return NaN;
    }
    if ("number" == typeof t2) {
      let r2 = e2 / t2;
      if (n === 1 / 0 || math$1$1.round(r2, n) === r2) return r2;
      if (t2 < 0) return ["/", -e2, -t2];
    }
    if (Array.isArray(t2) && "*" === t2[0] && "number" == typeof t2[1]) {
      let r2 = e2 / t2[1];
      if (n === 1 / 0 || math$1$1.round(r2, n) === r2) return ["/", r2, t2[2]];
    }
  } else if ("number" == typeof t2) {
    if (Array.isArray(e2) && "*" === e2[0] && "number" == typeof e2[1]) {
      let r3 = e2[1] / t2;
      if (n === 1 / 0 || math$1$1.round(r3, n) === r3) return 1 === r3 ? e2[2] : ["*", r3, e2[2]];
      if (t2 < 0) return ["/", ["*", -e2[1], e2[2]], -t2];
    }
    let r2 = 1 / t2;
    if (n === 1 / 0 || math$1$1.round(r2, n) === r2) return ["*", r2, e2];
    if (t2 < 0) return Array.isArray(e2) && "-" === e2[0] ? ["/", e2[1], -t2] : ["-", ["/", e2, -t2]];
  }
  return null;
}
function set_small_zero$1(e2, t2 = 1e-14) {
  var r = get_tree$1(e2);
  return "number" == typeof r ? math$1$1.abs(r) < t2 ? 0 : r : Array.isArray(r) ? [r[0], ...r.slice(1).map(((e3) => set_small_zero$1(e3, t2)))] : r;
}
function evaluate_numbers_sub$1(e2, t2, r, n, i2, a) {
  if (void 0 === e2) return e2;
  if ("number" == typeof e2) return a > 0 && math$1$1.abs(e2) < a ? 0 : e2;
  if (contains_only_numbers$1(e2, { include_number_symbols: true, evaluate_functions: i2 })) {
    let t3 = function(t4) {
      if (a > 0 && math$1$1.abs(t4) < a) return 0;
      if (r === 1 / 0) return t4;
      if (Number.isInteger(t4)) return t4;
      let n3 = evalf$1(t4, 14), o2 = evalf$1(t4, r);
      if (0 === r && (o2 = math$1$1.round(t4)), o2 === n3) return t4;
      if (contains_decimal_number$1(e2) && contains_only_numbers$1(e2, { include_number_symbols: true, evaluate_functions: i2 })) return t4;
      let s2 = math$1$1.fraction(t4), u2 = { n: math$1$1.number(s2.n), d: math$1$1.number(s2.d), s: math$1$1.number(s2.s) }, c2 = evalf$1(u2.d, 3);
      if (u2.n < 1e4 || c2 === u2.d) {
        if (evalf$1(u2.s * u2.n / u2.d, 14) === n3) return 1 === u2.d ? u2.s * u2.n : ["/", u2.s * u2.n, u2.d];
      }
      return null;
    };
    var o = evaluate_to_constant$1(e2, { remove_units_first: false });
    if (!Number.isNaN(o)) {
      if ("number" == typeof o) {
        if (Number.isFinite(o)) {
          let e3 = t3(o);
          if (null !== e3) return e3;
        }
      } else if (o && Number.isFinite(o.re) && Number.isFinite(o.im)) {
        let e3 = t3(o.re), r2 = t3(o.im);
        if (null !== e3 && null !== r2) {
          if (0 === r2) return e3;
          {
            let t4;
            return t4 = 1 === r2 ? "i" : -1 === r2 ? ["-", "i"] : ["*", r2, "i"], 0 === e3 ? t4 : ["+", e3, t4];
          }
        }
      }
    }
  }
  if (!Array.isArray(e2)) return e2;
  var s = e2[0], u = e2.slice(1).map(((e3) => evaluate_numbers_sub$1(e3, t2, r, n, i2, a)));
  if ("+" === s) {
    let e3 = u[0], t3 = u[1];
    if (void 0 === t3) return e3;
    let r2 = try_evaluate_sum_of_numbers$1(e3, t3, n);
    if (null !== r2) return r2;
    if ("unit" === e3[0] && "unit" === t3[0]) {
      let r3 = get_unit_of_tree$1(e3), i3 = get_unit_of_tree$1(t3);
      if (r3 && r3 === i3) {
        let i4 = try_evaluate_sum_of_numbers$1(remove_units$1(e3, false), remove_units$1(t3, false), n);
        if (null !== i4) return add_unit$1(i4, r3);
      }
    }
    return [s].concat(u);
  }
  if ("-" === s) {
    let e3 = try_evaluate_negate_number$1(u[0]);
    if (null !== e3) return e3;
    if ("unit" === u[0][0]) {
      let e4 = get_unit_of_tree$1(u[0]);
      if (e4) {
        let t3 = try_evaluate_negate_number$1(remove_units$1(u[0], false));
        if (null !== t3) return add_unit$1(t3, e4);
      }
    }
    return [s].concat(u);
  }
  if ("*" === s) {
    let e3 = u[0], t3 = u[1];
    if (void 0 === t3) return e3;
    let r2 = try_evaluate_product_of_numbers$1(e3, t3);
    if (null !== r2) return r2;
    if ("unit" === e3[0] && "unit" !== t3[0]) {
      let r3 = get_unit_of_tree$1(e3);
      if (r3) {
        let n3 = try_evaluate_product_of_numbers$1(remove_units$1(e3, false), t3);
        if (null !== n3) return add_unit$1(n3, r3);
      }
    }
    if ("unit" !== e3[0] && "unit" === t3[0]) {
      let r3 = get_unit_of_tree$1(t3);
      if (r3) {
        let n3 = try_evaluate_product_of_numbers$1(e3, remove_units$1(t3, false));
        if (null !== n3) return add_unit$1(n3, r3);
      }
    }
    return [s].concat(u);
  }
  if ("/" === s) {
    let e3 = u[0], n3 = u[1], i3 = try_evaluate_quotient_of_numbers$1(e3, n3, t2, r);
    if (null !== i3) return i3;
    if ("unit" === e3[0] && "unit" !== n3[0]) {
      let i4 = get_unit_of_tree$1(e3);
      if (i4) {
        let a2 = try_evaluate_quotient_of_numbers$1(remove_units$1(e3, false), n3, t2, r);
        if (null !== a2) return add_unit$1(a2, i4);
      }
    }
    return [s].concat(u);
  }
  if ("^" === s) {
    let e3 = u[0], n3 = u[1];
    if ("number" == typeof n3) if (0 === n3) {
      if (!math$1$1.pow_strict) return 1;
      let r2 = is_nonzero_ast$1(e3, t2);
      if (r2 && e3 !== 1 / 0 && e3 !== -1 / 0) return 1;
      if (false === r2) return NaN;
    } else {
      if (1 === n3) return e3;
      if ("number" == typeof e3) {
        let t3 = math$1$1.pow(e3, n3);
        if (r === 1 / 0 || math$1$1.round(t3, r) === t3) return t3;
      }
    }
    else if (1 === e3) return 1;
    return [s].concat(u);
  }
  return [s].concat(u);
}
function evaluate_numbers$1(e2, { assumptions: t2, max_digits: r, skip_ordering: n = false, evaluate_functions: i2 = false, set_small_zero: a = 0 } = {}) {
  (void 0 === r || !Number.isInteger(r) && r !== 1 / 0) && (r = 0), true === a && (a = 1e-14);
  var o, s = get_tree$1(e2);
  return contains_blank$1(s) ? s : (void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), n ? o = evaluate_numbers_sub$1(s = unflattenRight$1(flatten$5$1(s)), t2, r, n, i2, a) : (s = move_units_outside_products$1(s), s = unflattenRight$1(default_order$1(flatten$5$1(s))), o = default_order$1(evaluate_numbers_sub$1(s, t2, r, n, i2, a)), o = default_order$1(evaluate_numbers_sub$1(unflattenRight$1(o), t2, r, n, i2, a))), flatten$5$1(o = set_negative_zeros_to_zero$1(o)));
}
function set_negative_zeros_to_zero$1(e2) {
  return 0 === e2 ? 0 : Array.isArray(e2) ? [e2[0], ...e2.slice(1).map(set_negative_zeros_to_zero$1)] : e2;
}
function collect_like_terms_factors$1(e2, t2, r) {
  function n(e3) {
    return "number" == typeof e3 || !(!Array.isArray(e3) || "-" !== e3[0] || "number" != typeof e3[1]);
  }
  function i2(e3) {
    return "number" == typeof e3 && e3 < 0 || !!(Array.isArray(e3) && "-" === e3[0] && "number" == typeof e3[1] && e3 > 0);
  }
  function a(e3) {
    if ("number" == typeof e3) return true;
    if (Array.isArray(e3) && "-" === e3[0] && "number" == typeof e3[1]) return true;
    var t3 = evaluate_to_constant$1(e3, { remove_units_first: false });
    return !!Number.isFinite(t3);
  }
  var o = get_tree$1(e2);
  if (contains_blank$1(o)) return o;
  void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), o = evaluate_numbers$1(o, { assumptions: t2, max_digits: r, evaluate_functions: true });
  var s = [];
  s.push([["/", "x", ["^", "y", "a"]], ["*", "x", ["^", "y", ["-", "a"]]], { evaluate_numbers: true, max_digits: r }]), s.push([["/", "x", ["apply", "exp", "a"]], ["*", "x", ["apply", "exp", ["-", "a"]]], { evaluate_numbers: true, max_digits: r, variables: { x: true, a: true } }]), s.push([["/", "x", "y"], ["*", "x", ["^", "y", ["-", 1]]], { evaluate_numbers: true, max_digits: r }]), o = applyAllTransformations$1(o, s, 40), s = [];
  for (let e3 in all_units$2) {
    all_units$2[e3].prefix ? (s.push([["+", ["unit", e3, "x"], ["unit", e3, "y"]], ["unit", e3, ["+", "x", "y"]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["unit", e3, "x"], ["-", ["unit", e3, "y"]]], ["unit", e3, ["+", "x", ["-", "y"]]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }])) : (s.push([["+", ["unit", "x", e3], ["unit", "y", e3]], ["unit", ["+", "x", "y"], e3], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["unit", "x", e3], ["-", ["unit", "y", e3]]], ["unit", ["+", "x", ["-", "y"]], e3], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]));
  }
  return s.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: (e3) => is_nonzero_ast$1(e3, t2), n, m: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: true, n: (e3) => n(e3) && is_positive_ast$1(e3, t2), m: (e3) => n(e3) && is_positive_ast$1(e3, t2) }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["^", ["-", "x"], "n"], ["^", "x", "n"], { variables: { x: true, n: (e3) => Number.isInteger(e3) && Number.isInteger(e3 / 2) }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, max_group: 1 }]), s.push([["^", ["-", "x"], "n"], ["-", ["^", "x", "n"]], { variables: { x: true, n: (e3) => Number.isInteger(e3) && !Number.isInteger(e3 / 2) }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, max_group: 1 }]), s.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: true, n: (e3) => n(e3) && is_negative_ast$1(e3, t2), m: (e3) => n(e3) && is_negative_ast$1(e3, t2) }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["*", ["apply", "exp", "n"], ["apply", "exp", "m"]], ["apply", "exp", ["+", "n", "m"]], { variables: { n, m: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", "n", "x"], ["*", "m", "x"]], ["*", ["+", "n", "m"], "x"], { variables: { x: true, n, m: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", "n1", "x"], ["*", ["/", "n2", "m2"], "x"]], ["*", ["+", "n1", ["/", "n2", "m2"]], "x"], { variables: { x: true, n1: n, n2: n, m2: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m2", "n1", "n2"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", "n1", "x"], ["*", ["-", ["/", "n2", "m2"]], "x"]], ["*", ["+", "n1", ["-", ["/", "n2", "m2"]]], "x"], { variables: { x: true, n1: n, n2: n, m2: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m2", "n1", "n2"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", ["/", "n1", "m1"], "x"], ["*", ["/", "n2", "m2"], "x"]], ["*", ["+", ["/", "n1", "m1"], ["/", "n2", "m2"]], "x"], { variables: { x: true, n1: n, m1: n, n2: n, m2: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m1", "m2", "n1", "n2"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", ["/", "n1", "m1"], "x"], ["*", ["-", ["/", "n2", "m2"]], "x"]], ["*", ["+", ["/", "n1", "m1"], ["-", ["/", "n2", "m2"]]], "x"], { variables: { x: true, n1: n, m1: n, n2: n, m2: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m1", "m2", "n1", "n2"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", "n", "x"], ["-", ["*", "m", "x"]]], ["*", ["+", "n", ["-", "m"]], "x"], { variables: { x: true, n, m: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["^", ["*", "x", "y"], "a"], ["*", ["^", "x", "a"], ["^", "y", "a"]], { allow_permutations: true }]), s.push([["^", ["^", "x", "n"], "m"], ["^", "x", ["*", "n", "m"]], { variables: { x: true, n, m: n }, evaluate_numbers: true, max_digits: r, allow_permutations: true }]), s.push([["-", ["+", "a", "b"]], ["+", ["-", "a"], ["-", "b"]]]), s.push([["*", "x", "y"], ["*", "x", "y"], { variables: { x: a, y: a }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), o = applyAllTransformations$1(o, s, 40), (s = []).push([["*", "x", ["^", "y", ["-", "a"]]], ["/", "x", ["^", "y", "a"]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r, max_group: 1 }]), s.push([["*", "x", ["apply", "exp", ["-", "a"]]], ["/", "x", ["apply", "exp", "a"]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r, max_group: 1, variables: { x: true, a: true } }]), s.push([["*", "x", ["^", "y", "n"]], ["/", "x", ["^", "y", ["-", "n"]]], { variables: { x: true, y: true, n: i2 }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["*", "x", ["apply", "exp", "n"]], ["/", "x", ["apply", "exp", ["-", "n"]]], { variables: { x: true, n: i2 }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), o = applyAllTransformations$1(o, s, 40), (s = []).push([["^", "y", "n"], ["/", 1, ["^", "y", ["-", "n"]]], { variables: { y: true, n: i2 }, evaluate_numbers: true, max_digits: r }]), s.push([["apply", "exp", "n"], ["/", 1, ["apply", "exp", ["-", "n"]]], { variables: { n: i2 }, evaluate_numbers: true, max_digits: r }]), o = applyAllTransformations$1(o, s, 40), (s = []).push([["*", "x", ["/", "y", "z"]], ["/", ["*", "x", "y"], "z"], { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["/", ["/", "x", "y"], "z"], ["/", "x", ["*", "y", "z"]], { allow_extended_match: true, allow_permutations: true }]), s.push([["/", "x", ["/", "y", "z"]], ["/", ["*", "x", "z"], "y"], { allow_extended_match: true, allow_permutations: true }]), o = evaluate_numbers$1(o = applyAllTransformations$1(o, s, 40), { assumptions: t2, max_digits: r });
}
function simplify_ratios$1(e2, t2) {
  function r(e3) {
    var t3 = 1;
    return e3 = e3.map((function(e4) {
      if ("number" == typeof e4) return e4 < 0 ? (t3 *= -1, -e4) : e4;
      if (!Array.isArray(e4)) return e4;
      if ("-" === e4[0]) return t3 *= -1, e4[1];
      if ("+" !== e4[0]) return e4;
      var r2 = false;
      if (("number" == typeof e4[1] && e4[1] < 0 || Array.isArray(e4[1]) && "-" === e4[1][0] || Array.isArray(e4[1]) && "*" === e4[1][0] && Number(e4[1][1]) < 0) && (r2 = true), r2) {
        t3 *= -1;
        var n3 = e4.slice(1).map(((e5) => ["-", e5]));
        return evaluate_numbers$1(["+"].concat(n3));
      }
      return e4;
    })), { factors: e3, sign_change: t3 };
  }
  var n = get_tree$1(e2);
  return contains_blank$1(n) ? n : (void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), (function e3(t3, n3) {
    if (!Array.isArray(t3)) return n3 ? ["-", t3] : t3;
    var i2 = t3[0];
    if ("-" === i2) return e3(t3[1], n3 = true);
    var a = t3.slice(1).map(((t4) => e3(t4)));
    if ("/" !== i2) return n3 ? ["-", [i2, ...a]] : [i2, ...a];
    var o, s = a[0], u = a[1];
    s = default_order$1(s, { ignore_negatives: true });
    var c2, l = r(o = Array.isArray(s) && "*" === s[0] ? s.slice(1) : [s]);
    o = l.factors, n3 && (l.sign_change *= -1), u = default_order$1(u, { ignore_negatives: true });
    var f2 = r(c2 = Array.isArray(u) && "*" === u[0] ? u.slice(1) : [u]);
    return c2 = f2.factors, l.sign_change * f2.sign_change < 0 && (o[0] = ["-", o[0]]), ["/", s = 1 === o.length ? o[0] : ["*"].concat(o), u = 1 === c2.length ? c2[0] : ["*"].concat(c2)];
  })(n));
}
function contains_blank$1(e2) {
  return "＿" === e2 || !!Array.isArray(e2) && e2.some(contains_blank$1);
}
let all_units$2 = get_all_units$1();
function remove_units$1(e2, t2 = true) {
  var r = get_tree$1(e2);
  if (!Array.isArray(r)) return r;
  let n = r[0], i2 = r.slice(1);
  if ("unit" === n) {
    let e3 = all_units$2[get_unit_of_tree$1(r)];
    if (!e3) return r;
    let n3 = remove_units$1(e3.prefix ? i2[1] : i2[0], t2);
    return t2 ? e3.scale(n3) : n3;
  }
  return [n, ...i2.map(((e3) => remove_units$1(e3, t2)))];
}
function remove_scaling_units$1(e2) {
  var t2 = get_tree$1(e2);
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  if ("unit" === r) {
    let e3 = all_units$2[get_unit_of_tree$1(t2)];
    if (!e3 || !e3.only_scales) return t2;
    let r2 = remove_scaling_units$1(e3.prefix ? n[1] : n[0]);
    return e3.scale(r2);
  }
  return [r, ...n.map(((e3) => remove_scaling_units$1(e3)))];
}
function add_unit$1(e2, t2) {
  var r = get_tree$1(e2);
  let n = all_units$2[t2];
  return n ? n.prefix ? ["unit", t2, r] : ["unit", r, t2] : r;
}
function move_units_outside_products$1(e2) {
  if (!Array.isArray(e2)) return e2;
  let t2 = e2[0], r = e2.slice(1);
  if ("*" === t2) {
    let e3 = [], t3 = [];
    for (let n3 of r) {
      let r2 = get_unit_value_of_tree$1(n3);
      r2 ? (e3.push(r2[0]), t3.push(r2[1])) : t3.push(n3);
    }
    let n = ["*", ...t3];
    for (let t4 of e3) n = add_unit$1(n, t4);
    return n;
  }
  return [t2, ...r.map(move_units_outside_products$1)];
}
var simplify$1$1 = Object.freeze({ __proto__: null, clean: clean$2, simplify: simplify$2, simplify_logical: simplify_logical$1, set_small_zero: set_small_zero$1, evaluate_numbers: evaluate_numbers$1, collect_like_terms_factors: collect_like_terms_factors$1, collapse_unary_minus: collapse_unary_minus$1, simplify_ratios: simplify_ratios$1, default_order: default_order$1, perform_vector_matrix_additions_scalar_multiplications: perform_vector_matrix_additions_scalar_multiplications$1, remove_units: remove_units$1, add_unit: add_unit$1, remove_scaling_units: remove_scaling_units$1 });
function solve_linear$1(e2, t2, r) {
  if ("string" == typeof t2) {
    void 0 === r && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (r = e2.context.get_assumptions([e2.variables()]));
    var n = simplify$2(get_tree$1(e2), r);
    if (Array.isArray(n)) {
      var i2 = n[0], a = n.slice(1);
      if ("=" === i2 || "ne" === i2 || "<" === i2 || "le" === i2 || ">" === i2 || "ge" === i2) {
        var o = simplify$2(["+", a[0], ["-", a[1]]], r), s = (e3) => !variables$2(e3).includes(t2);
        if (variables$2(o = simplify$2(applyAllTransformations$1(o, [[["+", ["*", "_a", t2], ["*", "_b", t2]], ["*", ["+", "_a", "_b"], t2], { variables: { _a: s, _b: s }, allow_permutations: true, allow_extended_match: true, allow_implicit_identities: ["_a", "_b"], evaluate_numbers: true }]], 20))).includes(t2)) {
          var u = match$2$1(o, ["+", ["*", "_a", t2], "_b"], { variables: { _a: s, _b: s }, allow_permutations: true, allow_implicit_identities: ["_a", "_b"] });
          if (u) {
            var c2 = simplify$2(u._a), l = simplify$2(u._b);
            if (is_nonzero_ast$1(c2, r)) {
              if ("=" === i2 || "ne" === i2 || is_positive_ast$1(c2, r)) {
                let e3 = simplify$2(["/", ["-", l], c2]);
                return [i2, t2, e3];
              }
              if (is_negative_ast$1(c2, r)) {
                var f2 = simplify$2(["/", ["-", l], c2]);
                return [i2 = "<" === i2 ? ">" : "le" === i2 ? "ge" : ">" === i2 ? "<" : "le", t2, f2];
              }
            }
          }
        }
      }
    }
  }
}
var solve$1 = Object.freeze({ __proto__: null, solve_linear: solve_linear$1 });
function clean_assumptions$1(e2, t2) {
  if (!Array.isArray(e2) || 0 === e2.length) return e2;
  var r = (e2 = flatten$5$1(default_order$1(simplify_logical$1(expand_relations$1(e2)))))[0], n = e2.slice(1);
  if ("and" === r || "or" === r) {
    if (n = n.reduce((function(e3, t3) {
      return e3.every((function(e4) {
        return !equal$1(e4, t3);
      })) && e3.push(t3), e3;
    }), []), "and" === r && t2 && Array.isArray(t2)) {
      let e3;
      e3 = "and" === t2[0] ? t2.slice(1) : [t2], n = n.filter(((t3) => e3.every(((e4) => !equal$1(e4, t3)))));
    }
    e2 = 1 === n.length ? n[0] : [r].concat(n);
  }
  if ("and" !== r && t2 && Array.isArray(t2)) {
    let r2;
    if (r2 = "and" === t2[0] ? t2.slice(1) : [t2], !r2.every(((t3) => !equal$1(t3, e2)))) return;
  }
  return e2;
}
function calculate_derived_assumptions$1(e2, t2) {
  if (void 0 === t2) {
    t2 = [];
    for (let r2 in e2.byvar) {
      let n3 = e2.byvar[r2];
      n3.length > 0 && t2.push(n3);
    }
    if (0 === t2.length) return {};
    t2 = clean_assumptions$1(t2 = 1 === t2.length ? t2[0] : ["and"].concat(t2));
  }
  if (!Array.isArray(t2) || 0 === t2.length) return {};
  var r = t2[0], n = t2.slice(1);
  if ("and" === r || "or" === r) {
    let t3 = n.map((function(t4) {
      return calculate_derived_assumptions$1(e2, t4);
    })), i3 = [...new Set(t3.reduce(((e3, t4) => [...e3, ...Object.keys(t4)]), []))], a2 = {};
    for (let n3 of i3) {
      let i4 = t3.reduce((function(e3, t4) {
        return void 0 !== t4[n3] && e3.push(t4[n3]), e3;
      }), []);
      if ("and" === r || i4.length === t3.length) {
        let t4 = a2[n3];
        t4 = void 0 === t4 ? i4.length > 1 ? [r].concat(i4) : i4[0] : i4.length > 1 ? ["and", t4, [r].concat(i4)] : ["and", t4, i4[0]], a2[n3] = clean_assumptions$1(t4, get_assumptions$1(e2, n3, { omit_derived: true }));
      }
    }
    return a2;
  }
  let i2 = {};
  if ("=" === r || "ne" === r || "<" === r || "le" === r || "in" === r || "subset" === r || "notin" === r || "notsubset" === r) {
    var a = false;
    for (let t3 = 0; t3 < 2; t3++) {
      let s2 = n[t3], u = n[1 - t3], c2 = variables$2(u);
      if ("string" != typeof s2 || 0 === c2.length || c2.includes(s2)) continue;
      a = true;
      var o = r;
      1 === t3 && ("<" === r ? o = ">" : "le" === r ? o = "ge" : "in" === r ? o = "ni" : "subset" === r ? o = "superset" : "notin" === r ? o = "notni" : "notsubset" === r && (o = "notsuperset"));
      let l = get_assumptions_for_expr$1(e2, u, [s2]);
      if (l = combine_assumptions$1(s2, o, u, l), void 0 !== l) {
        let t4 = i2[s2];
        t4 = void 0 === t4 ? l : ["and", t4, l], i2[s2] = clean_assumptions$1(t4, get_assumptions$1(e2, s2, { omit_derived: true }));
      }
    }
    if (a) return i2;
  }
  let s = [];
  for (let t3 of n) {
    let r2 = get_assumptions_for_expr$1(e2, t3, []);
    void 0 !== r2 && s.push(r2);
  }
  if (0 === s.length) return {};
  s = 1 === s.length ? s[0] : ["and"].concat(s);
  for (let r2 of variables$2(t2)) i2[r2] = clean_assumptions$1(s, get_assumptions$1(e2, r2, { omit_derived: true }));
  return i2;
}
function get_assumptions_for_expr$1(e2, t2, r) {
  let n = variables$2(t2);
  if (n = n.filter(((e3) => !r.includes(e3))), 0 === n.length) return;
  function i2(e3) {
    return "number" == typeof e3 || !(!Array.isArray(e3) || "-" !== e3[0] || "number" != typeof e3[1]);
  }
  var a = ["_b"], o = ["_b"], s = { _b: i2 }, u = {};
  for (let e3 = 0; e3 < n.length; e3++) {
    let t3 = "_a" + e3;
    u[n[e3]] = t3, a.push(["*", t3, n[e3]]), o.push(t3), s[t3] = i2;
  }
  a = ["+"].concat(a);
  var c2 = match$2$1(t2, a, { variables: s, allow_permutations: true, allow_extended_match: false, allow_implicit_identities: o, max_group: 1 });
  if (!c2) {
    let n3 = [];
    for (let i3 of variables$2(t2)) {
      let t3 = get_assumptions_for_expr$1(e2, i3, r);
      void 0 !== t3 && n3.push(t3);
    }
    if (0 === n3.length) return;
    return 1 === n3.length ? n3[0] : ["and"].concat(n3);
  }
  for (let e3 of n) u[e3] = c2[u[e3]];
  let l = false;
  var f2;
  if (0 === c2._b && 1 === c2._a0 && 1 === n.length && (l = true), void 0 !== (f2 = get_assumptions$1(e2, [n], { exclude_variables: r }))) return clean_assumptions$1((function i3(a2) {
    if (!Array.isArray(a2)) return;
    var o2 = a2[0], s2 = a2.slice(1);
    if ("and" === o2 || "or" === o2) {
      let e3 = s2.map(i3).filter(((e4) => void 0 !== e4));
      if (0 === e3.length) return;
      return "or" === o2 ? e3.length === s2.length ? ["or"].concat(e3) : void 0 : 1 === e3.length ? e3[0] : ["and"].concat(e3);
    }
    if (!(["=", "ne", "<", "le"].includes(o2) || ["in", "notin", "subset", "notsubset"].includes(o2) && l)) {
      let n3 = r.concat(variables$2(t2)), i4 = [];
      for (let t3 of variables$2(a2)) {
        if (n3.includes(t3)) continue;
        let r2 = get_assumptions_for_expr$1(e2, t3, n3);
        void 0 !== r2 && i4.push(r2);
      }
      return 0 === i4.length ? a2 : 1 === i4.length ? ["and", a2, i4[0]] : ["and", a2].concat(i4);
    }
    let c3 = [];
    for (let i4 = 0; i4 <= 1; i4++) {
      let a3 = s2[i4], l2 = s2[1 - i4];
      if ("string" == typeof a3 && n.includes(a3)) {
        var f3 = {};
        f3[a3] = l2;
        var p = simplify$2(substitute$1$1(t2, f3)), m = false, d = o2;
        (1 === i4 && u[a3] > 0 || 0 === i4 && u[a3] < 0) && ("<" === o2 ? (m = true, d = ">") : "le" === o2 ? (m = true, d = "ge") : "in" === o2 ? (m = true, d = "ni") : "subset" === o2 ? (m = true, d = "superset") : "notin" === o2 ? (m = true, d = "notni") : "notsubset" === o2 && (m = true, d = "notsuperset")), m ? c3.push([o2, p, t2]) : c3.push([o2, t2, p]);
        let n3 = r.concat([a3]), s3 = get_assumptions_for_expr$1(e2, p, n3);
        s3 = combine_assumptions$1(t2, d, p, s3), void 0 !== s3 && c3.push(s3);
      }
    }
    if (1 === c3.length) return c3[0];
    if (c3.length > 1) return ["and"].concat(c3);
    let h = r.concat(variables$2(t2));
    c3 = [];
    for (let t3 of variables$2(a2)) {
      if (h.includes(t3)) continue;
      let r2 = get_assumptions_for_expr$1(e2, t3, h);
      void 0 !== r2 && c3.push(r2);
    }
    return 0 === c3.length ? a2 : 1 === c3.length ? ["and", a2, c3[0]] : ["and", a2].concat(c3);
  })(f2));
}
function combine_assumptions$1(e2, t2, r, n) {
  if (!["=", "ne", "<", "le", ">", "ge", "in", "notin", "ni", "notni", "subset", "notsubset", "superset", "notsuperset"].includes(t2)) return n;
  if (Array.isArray(n)) {
    var i2 = n[0], a = n.slice(1);
    if ("and" === i2 || "or" === i2) {
      let n3 = a.map(((n4) => combine_assumptions$1(e2, t2, r, n4))).filter(((e3) => void 0 !== e3));
      if (0 === n3.length) return;
      return "or" === i2 ? n3.length === a.length ? [["or"].concat(n3)] : void 0 : 1 === n3.length ? n3[0] : ["and"].concat(n3);
    }
    if (!["=", "ne", "<", "le", "in", "notin", "subset", "notsubset"].includes(i2)) return n;
    var o, s, u = i2;
    if (equal$1(a[0], r)) o = a[1];
    else {
      if (!equal$1(a[1], r)) return n;
      o = a[0], "<" === i2 ? u = ">" : "le" === i2 ? u = "ge" : "in" === i2 ? u = "ni" : "notin" === i2 ? u = "notni" : "subset" === i2 ? u = "superset" : "notsubset" === i2 && (u = "notsuperset");
    }
    if ("=" === t2) s = u;
    else if ("=" === u) s = t2;
    else if ("<" === t2) {
      if ("<" !== u && "le" !== u) return "in" === u || "notin" === u ? n : void 0;
      s = "<";
    } else if ("le" === t2) if ("<" === u) s = "<";
    else {
      if ("le" !== u) return "in" === u || "notin" === u ? n : void 0;
      s = "le";
    }
    else if (">" === t2) {
      if (">" !== u && "ge" !== u) return "in" === u || "notin" === u ? n : void 0;
      s = ">";
    } else if ("ge" === t2) if (">" === u) s = ">";
    else {
      if ("ge" !== u) return "in" === u || "notin" === u ? n : void 0;
      s = "ge";
    }
    else if ("in" === t2) {
      if ("subset" !== u) return;
      s = "in";
    } else if ("notin" === t2) {
      if ("superset" !== u) return;
      s = "notin";
    } else if ("ni" === t2) {
      if ("notin" !== u) return;
      s = "notsubset";
    } else if ("notni" === t2) {
      if ("in" !== u) return;
      s = "notsuperset";
    } else if ("subset" === t2) if ("subset" === u) s = "subset";
    else if ("notni" === u) s = "notni";
    else {
      if ("notsuperset" !== u) return;
      s = "notsuperset";
    }
    else if ("notsubset" === t2) {
      if ("superset" !== u) return;
      s = "notsubset";
    } else if ("superset" === t2) if ("superset" === u) s = "superset";
    else if ("ni" === u) s = "ni";
    else {
      if ("notsubset" !== u) return;
      s = "notsubset";
    }
    else {
      if ("notsuperset" !== t2) return;
      if ("subset" !== u) return;
      s = "notsuperset";
    }
    return ">" === s ? ["<", o, e2] : "ge" === s ? ["le", o, e2] : "ni" === s ? ["in", o, e2] : "notni" === s ? ["notin", o, e2] : "superset" === s ? ["subset", o, e2] : "notsuperset" === s ? ["notsubset", o, e2] : [s, e2, o];
  }
}
function filter_assumptions_from_tree$1(e2, t2) {
  if (Array.isArray(e2) && 0 !== e2.length) {
    Array.isArray(t2) || (t2 = [t2]);
    var r = e2[0], n = e2.slice(1);
    if ("and" === r) {
      var i2 = n.map((function(e3) {
        return filter_assumptions_from_tree$1(e3, t2);
      }));
      return 0 === (i2 = i2.filter(((e3) => void 0 !== e3))).length ? void 0 : 1 === i2.length ? i2[0] : ["and"].concat(i2);
    }
    var a = variables$2(e2);
    return t2.filter(((e3) => a.includes(e3))).length > 0 ? void 0 : e2;
  }
}
function get_assumptions_sub$1(e2, t2, r, n) {
  Array.isArray(t2) || (t2 = [t2]);
  var i2 = [];
  return t2.forEach((function(t3) {
    if (e2.byvar[t3] || e2.derived[t3]) {
      if (e2.byvar[t3] && e2.byvar[t3].length > 0) {
        var a = filter_assumptions_from_tree$1(e2.byvar[t3], r);
        void 0 !== a && i2.push(a);
      }
      if (e2.derived[t3] && e2.derived[t3].length > 0 && !n) {
        var o = filter_assumptions_from_tree$1(e2.derived[t3], r);
        void 0 !== o && i2.push(o);
      }
    } else e2.generic.length > 0 && ("x" !== t3 && variables$2(e2.generic).includes(t3) || i2.push(substitute$1$1(e2.generic, { x: t3 })));
  })), 1 === i2.length ? i2 = i2[0] : i2.length > 1 && (i2 = ["and"].concat(i2)), i2.length > 0 ? clean_assumptions$1(i2) : void 0;
}
function get_assumptions$1(e2, t2, r) {
  void 0 === r && (r = {});
  var n, i2 = r.exclude_variables;
  void 0 === i2 ? i2 = [] : Array.isArray(i2) || (i2 = [i2]);
  var a = get_tree$1(t2);
  if ("string" == typeof a) n = [a];
  else {
    if (!Array.isArray(a)) return;
    Array.isArray(a[0]) && (n = a[0]);
  }
  return n ? get_assumptions_sub$1(e2, n, i2, r.omit_derived) : get_assumptions_for_expr$1(e2, a, i2);
}
function add_assumption$1(e2, t2, r) {
  var n = get_tree$1(t2);
  if (!Array.isArray(n)) return 0;
  var i2 = add_assumption_sub$1(e2, n = clean_assumptions$1(simplify$2(n, e2)), r);
  return i2 && (e2.derived = calculate_derived_assumptions$1(e2)), i2;
}
function add_assumption_sub$1(e2, t2, r) {
  if ("and" === t2[0]) return t2.slice(1).map(((t3) => add_assumption_sub$1(e2, t3, r))).reduce((function(e3, t3) {
    return e3 + t3;
  }));
  var n = variables$2(t2);
  if (0 === n.length) return 0;
  let i2 = 0;
  !r && e2.generic.length > 0 && n.forEach((function(t3) {
    void 0 === e2.byvar[t3] && ("x" !== t3 && variables$2(e2.generic).includes(t3) || (add_assumption_sub$1(e2, substitute$1$1(e2.generic, { x: t3 }), true), i2 += 1));
  }));
  for (let r2 of n) {
    let n3 = solve_linear$1(t2, r2, e2), a = t2;
    n3 && (a = n3);
    let o = e2.byvar[r2];
    void 0 !== o && 0 !== o.length && (a = ["and", o, a]), a = clean_assumptions$1(a), equal$1(a, o) || (e2.byvar[r2] = a, i2 += 1);
  }
  return i2;
}
function add_generic_assumption$1(e2, t2) {
  var r = get_tree$1(t2);
  if (!Array.isArray(r)) return 0;
  var n = add_generic_assumption_sub$1(e2, r = clean_assumptions$1(simplify$2(r, e2)));
  return n && (e2.derived = calculate_derived_assumptions$1(e2)), n;
}
function add_generic_assumption_sub$1(e2, t2) {
  if ("and" === t2[0]) return t2.slice(1).map(((t3) => add_generic_assumption_sub$1(e2, t3))).reduce((function(e3, t3) {
    return e3 + t3;
  }));
  if (!variables$2(t2).includes("x")) return 0;
  let r = solve_linear$1(t2, "x", e2), n = t2;
  r && (n = r);
  let i2 = e2.generic;
  return 0 !== i2.length && (n = ["and", i2, n]), n = clean_assumptions$1(n), equal$1(n, i2) ? 0 : (e2.generic = n, 1);
}
function remove_assumption$1(e2, t2) {
  var r = get_tree$1(t2);
  if (!Array.isArray(r)) return 0;
  var n = remove_assumption_sub$1(e2, r = clean_assumptions$1(simplify$2(r, e2)));
  return n && (e2.derived = calculate_derived_assumptions$1(e2)), n;
}
function remove_assumption_sub$1(e2, t2) {
  if ("and" === t2[0]) return t2.slice(1).map(((t3) => remove_assumption_sub$1(e2, t3))).reduce((function(e3, t3) {
    return e3 + t3;
  }));
  var r = variables$2(t2);
  if (0 === r.length) return 0;
  var n = 0;
  for (let i2 of r) {
    let r2 = solve_linear$1(t2, i2, e2), a = e2.byvar[i2];
    if (!a || 0 === a.length) continue;
    let o, s = a[0], u = a.slice(1), c2 = u.length;
    if ("and" === s) if (u = u.filter(((e3) => !(equal$1(e3, t2) || equal$1(e3, r2)))), 0 === u.length) o = [];
    else if (1 === u.length) o = u[0];
    else {
      if (!(u.length < c2)) continue;
      o = [s].concat(u);
    }
    else {
      if (!equal$1(a, t2) && !equal$1(a, r2)) continue;
      o = [];
    }
    n += 1, e2.byvar[i2] = o;
  }
  return n;
}
function remove_generic_assumption$1(e2, t2) {
  var r = get_tree$1(t2);
  if (!Array.isArray(r)) return 0;
  var n = remove_generic_assumption_sub$1(e2, r = clean_assumptions$1(simplify$2(r, e2)));
  return n && (e2.derived = calculate_derived_assumptions$1(e2)), n;
}
function remove_generic_assumption_sub$1(e2, t2) {
  if ("and" === t2[0]) return t2.slice(1).map(((t3) => remove_generic_assumption_sub$1(e2, t3))).reduce((function(e3, t3) {
    return e3 + t3;
  }));
  if (!variables$2(t2).includes("x")) return 0;
  var r = e2.generic;
  if (0 === r.length) return 0;
  let n = solve_linear$1(t2, "x", e2);
  var i2, a = r[0], o = r.slice(1), s = o.length;
  if ("and" === a) if (0 === (o = o.filter(((e3) => !(equal$1(e3, t2) || equal$1(e3, n))))).length) i2 = [];
  else if (1 === o.length) i2 = o[0];
  else {
    if (!(o.length < s)) return 0;
    i2 = [a].concat(o);
  }
  else {
    if (!equal$1(r, t2) && !equal$1(r, n)) return 0;
    i2 = [];
  }
  return e2.generic = i2, 1;
}
function initialize_assumptions$1() {
  var e2 = { byvar: {}, derived: {}, generic: [], not_commutative: [], get_assumptions: function(t2, r) {
    return get_assumptions$1(e2, t2, r);
  }, add_assumption: function(t2, r) {
    return add_assumption$1(e2, t2, r);
  }, add_generic_assumption: function(t2) {
    return add_generic_assumption$1(e2, t2);
  }, remove_assumption: function(t2) {
    return remove_assumption$1(e2, t2);
  }, remove_generic_assumption: function(t2) {
    return remove_generic_assumption$1(e2, t2);
  } };
  return e2;
}
function padNumberStringToDigits$1(e2, t2) {
  let r = Math.floor(t2);
  if (r > 0) {
    if (e2.includes(".")) {
      if ("0" !== e2[0] ? r++ : r += e2.match(/^0\.0*/)[0].length, e2.length < r) {
        let t3 = r - e2.length;
        e2 += "0".repeat(t3);
      }
    } else if (e2.length < r) {
      let t3 = r - e2.length;
      e2 += "." + "0".repeat(t3);
    }
  }
  return e2;
}
function padNumberStringToDecimals$1(e2, t2) {
  let r = Math.floor(t2);
  if (r > 0) if (e2.includes(".")) {
    let t3 = e2.match(/\.\d*$/)[0].length - 1;
    if (t3 < r) {
      e2 += "0".repeat(r - t3);
    }
  } else e2 += "." + "0".repeat(r);
  return e2;
}
function padNumberStringToDigitsAndDecimals$1(e2, t2, r) {
  let n = Math.floor(t2);
  if (!(n > 0)) return padNumberStringToDecimals$1(e2, r);
  let i2 = Math.floor(r);
  if (!(i2 > 0)) return padNumberStringToDigits$1(e2, t2);
  if (e2.includes(".")) {
    "0" !== e2[0] ? n++ : n += e2.match(/^0\.0*/)[0].length;
    let t3 = 0;
    e2.length < n && (t3 = n - e2.length);
    let r2 = e2.match(/\.\d*$/)[0].length - 1;
    r2 < i2 && (t3 = Math.max(t3, i2 - r2)), t3 > 0 && (e2 += "0".repeat(t3));
  } else {
    let t3 = 0;
    e2.length < n && (t3 = n - e2.length), t3 = Math.max(t3, i2), e2 += "." + "0".repeat(t3);
  }
  return e2;
}
const operators$1$1 = { "+": function(e2) {
  return e2.join(" ");
}, "-": function(e2) {
  return "-" + e2[0];
}, "*": function(e2) {
  return e2.join(" ");
}, "/": function(e2) {
  return "\\frac{" + e2[0] + "}{" + e2[1] + "}";
}, _: function(e2) {
  return e2[0] + "_{" + e2[1] + "}";
}, "^": function(e2) {
  return e2[0] + "^{" + e2[1] + "}";
}, prime: function(e2) {
  return e2[0] + "'";
}, tuple: function(e2) {
  return "\\left( " + e2.join(", ") + " \\right)";
}, array: function(e2) {
  return "\\left[ " + e2.join(", ") + " \\right]";
}, list: function(e2) {
  return e2.join(", ");
}, set: function(e2) {
  return "\\left\\{ " + e2.join(", ") + " \\right\\}";
}, vector: function(e2) {
  return "\\left( " + e2.join(", ") + " \\right)";
}, altvector: function(e2) {
  return "\\left\\langle " + e2.join(", ") + " \\right\\rangle";
}, interval: function(e2) {
  return "\\left( " + e2.join(", ") + " \\right)";
}, matrix: function(e2) {
  return "\\left( " + e2.join(", ") + " \\right)";
}, and: function(e2) {
  return e2.join(" \\land ");
}, or: function(e2) {
  return e2.join(" \\lor ");
}, not: function(e2) {
  return "\\lnot " + e2[0];
}, "=": function(e2) {
  return e2.join(" = ");
}, "<": function(e2) {
  return e2.join(" < ");
}, ">": function(e2) {
  return e2.join(" > ");
}, lts: function(e2) {
  return e2.join(" < ");
}, gts: function(e2) {
  return e2.join(" > ");
}, le: function(e2) {
  return e2.join(" \\le ");
}, ge: function(e2) {
  return e2.join(" \\ge ");
}, ne: function(e2) {
  return e2.join(" \\ne ");
}, forall: function(e2) {
  return "\\forall " + e2[0];
}, exists: function(e2) {
  return "\\exists " + e2[0];
}, in: function(e2) {
  return e2[0] + " \\in " + e2[1];
}, notin: function(e2) {
  return e2[0] + " \\notin " + e2[1];
}, ni: function(e2) {
  return e2[0] + " \\ni " + e2[1];
}, notni: function(e2) {
  return e2[0] + " \\not\\ni " + e2[1];
}, subset: function(e2) {
  return e2[0] + " \\subset " + e2[1];
}, subseteq: function(e2) {
  return e2[0] + " \\subseteq " + e2[1];
}, notsubset: function(e2) {
  return e2[0] + " \\not\\subset " + e2[1];
}, notsubseteq: function(e2) {
  return e2[0] + " \\not\\subseteq " + e2[1];
}, superset: function(e2) {
  return e2[0] + " \\supset " + e2[1];
}, superseteq: function(e2) {
  return e2[0] + " \\supseteq " + e2[1];
}, notsuperset: function(e2) {
  return e2[0] + " \\not\\supset " + e2[1];
}, notsuperseteq: function(e2) {
  return e2[0] + " \\not\\supseteq " + e2[1];
}, union: function(e2) {
  return e2.join(" \\cup ");
}, intersect: function(e2) {
  return e2.join(" \\cap ");
}, implies: function(e2) {
  return e2.join(" \\implies ");
}, impliedby: function(e2) {
  return e2.join(" \\impliedby ");
}, iff: function(e2) {
  return e2.join(" \\iff ");
}, leftarrow: function(e2) {
  return e2.join(" \\leftarrow ");
}, rightarrow: function(e2) {
  return e2.join(" \\rightarrow ");
}, leftrightarrow: function(e2) {
  return e2.join(" \\leftrightarrow ");
}, perp: function(e2) {
  return e2.join(" \\perp ");
}, parallel: function(e2) {
  return e2.join(" \\parallel ");
}, derivative_leibniz: function(e2) {
  return "\\frac{d" + e2[0] + "}{d" + e2[1] + "}";
}, partial_derivative_leibniz: function(e2) {
  return "\\frac{d" + e2[0] + "}{d" + e2[1] + "}";
}, "|": function(e2) {
  return e2[0] + " \\mid " + e2[1];
}, ":": function(e2) {
  return e2[0] + " : " + e2[1];
}, binom: function(e2) {
  return "\\binom{" + e2[0] + "}{" + e2[1] + "}";
}, vec: function(e2) {
  return "\\vec{" + e2[0] + "}";
}, linesegment: function(e2) {
  return "\\overline{" + e2.join(" ") + "}";
}, angle: function(e2, t2) {
  return t2 ? "\\angle " + e2.join("") : "\\angle\\left( " + e2.join(", ") + " \\right)";
}, unit: function(e2) {
  return "\\circ" === e2[1] ? e2[0] + "^{\\circ}" : e2[0] + " " + e2[1];
} }, allowedLatexSymbolsDefault$1$1 = ["alpha", "beta", "gamma", "Gamma", "delta", "Delta", "epsilon", "zeta", "eta", "theta", "Theta", "iota", "kappa", "lambda", "Lambda", "mu", "nu", "xi", "Xi", "pi", "Pi", "rho", "sigma", "Sigma", "tau", "Tau", "upsilon", "Upsilon", "phi", "Phi", "chi", "psi", "Psi", "omega", "Omega", "partial", "abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "cos", "cosh", "cot", "coth", "csc", "csch", "sec", "sech", "sin", "sinh", "tan", "tanh", "arcsin", "arccos", "arctan", "arccsc", "arcsec", "arccot", "arg", "Re", "Im", "det", "angle", "perp", "circ", "%", "$", "int", "varnothing"], convertLatexSymbolsDefault$1 = { acos: "arccos", acosh: "arccosh", acot: "arccot", acoth: "arccoth", acsc: "arccsc", acsch: "arccsch", asec: "arcsec", asech: "arcsech", asin: "arcsin", asinh: "arcsinh", atan: "arctan", atanh: "arctanh", deg: "circ", emptyset: "varnothing" }, matrixEnvironmentDefault$1 = "bmatrix";
let astToLatex$1$1 = class astToLatex$12 {
  constructor({ allowedLatexSymbols: e2 = allowedLatexSymbolsDefault$1$1, convertLatexSymbols: t2 = convertLatexSymbolsDefault$1, matrixEnvironment: r = matrixEnvironmentDefault$1, padToDigits: n = null, padToDecimals: i2 = null, showBlanks: a = true } = {}) {
    this.allowedLatexSymbols = e2, this.convertLatexSymbols = t2, this.matrixEnvironment = r, this.padToDigits = n, this.padToDecimals = i2, this.showBlanks = a;
  }
  convert(e2) {
    return this.statement(e2);
  }
  statement(e2) {
    if (!Array.isArray(e2)) return this.single_statement(e2);
    var t2 = e2[0], r = e2.slice(1);
    if ("ldots" === t2) return "\\ldots";
    if (!(t2 in operators$1$1) && "apply" !== t2) throw new Error("Badly formed ast: operator " + t2 + " not recognized.");
    return ["implies", "impliedby", "iff", "rightarrow", "leftarrow", "leftrightarrow"].includes(t2) ? operators$1$1[t2](r.map(((e3) => this.statement(e3)))) : "and" === t2 || "or" === t2 ? operators$1$1[t2](r.map((function(e3, t3) {
      let r2 = this.single_statement(e3);
      return r2.match(/ /) && !r2.match(/^\\left\(.*\\right\)$/) ? "\\left(" + r2 + "\\right)" : r2;
    }).bind(this))) : this.single_statement(e2);
  }
  single_statement(e2) {
    if (!Array.isArray(e2)) return this.expression(e2);
    var t2 = e2[0], r = e2.slice(1);
    if ("not" === t2) return operators$1$1[t2](r.map((function(e3, t3) {
      let r2 = this.single_statement(e3);
      return r2.match(/ /) && !r2.match(/^\\left\(.*\\right\)$/) ? "\\left(" + r2 + "\\right)" : r2;
    }).bind(this)));
    if ("exists" === t2 || "forall" === t2) return operators$1$1[t2]([this.single_statement(r[0])]);
    if ("=" === t2 || "ne" === t2 || "<" === t2 || ">" === t2 || "le" === t2 || "ge" === t2 || "in" === t2 || "notin" === t2 || "ni" === t2 || "notni" === t2 || "subset" === t2 || "notsubset" === t2 || "subseteq" === t2 || "notsubseteq" === t2 || "superset" === t2 || "notsuperset" === t2 || "superseteq" === t2 || "notsuperseteq" === t2) return operators$1$1[t2](r.map((function(e3, t3) {
      return this.expression(e3);
    }).bind(this)));
    if ("lts" === t2 || "gts" === t2) {
      let e3 = r[0], n = r[1];
      if ("tuple" !== e3[0] || "tuple" !== n[0]) throw new Error("Badly formed ast");
      let i2 = this.expression(e3[1]);
      for (let r2 = 1; r2 < e3.length - 1; r2++) n[r2] ? i2 += "lts" === t2 ? " < " : " > " : i2 += "lts" === t2 ? " \\le " : " \\ge ", i2 += this.expression(e3[r2 + 1]);
      return i2;
    }
    return this.expression(e2);
  }
  expression(e2) {
    if (!Array.isArray(e2)) return this.term(e2);
    var t2 = e2[0], r = e2.slice(1);
    return "+" === t2 ? 1 === r.length ? "+" + this.term(r[0]) : operators$1$1[t2](r.map((function(e3, t3) {
      return t3 > 0 ? this.termWithPlusIfNotNegated(e3) : this.term(e3);
    }).bind(this))) : ["union", "intersect", "perp", "parallel"].includes(t2) ? operators$1$1[t2](r.map((function(e3, t3) {
      return this.term(e3);
    }).bind(this))) : this.term(e2);
  }
  term(e2) {
    if (!Array.isArray(e2)) return this.factor(e2);
    var t2 = e2[0], r = e2.slice(1);
    return "-" === t2 ? operators$1$1[t2](r.map((function(e3, t3) {
      return this.term(e3);
    }).bind(this))) : "*" === t2 ? operators$1$1[t2](r.map((function(e3, t3) {
      let n;
      return t3 > 0 ? (n = this.factorWithParenthesesIfNegatedExplicitPlusOrFraction(e3), n.match(/^[0-9]/) ? "\\cdot " + n : "angle" === e3[0] && r.length > 1 ? "\\left( " + n + " \\right)" : n) : (n = this.factor(e3), "angle" === e3[0] && r.length > 1 ? "\\left( " + n + " \\right)" : n);
    }).bind(this))) : "/" === t2 || "unit" === t2 ? operators$1$1[t2](r.map((function(e3, t3) {
      return this.expression(e3);
    }).bind(this))) : this.factor(e2);
  }
  simple_factor_or_function_or_parens(e2) {
    var t2 = this.factor(e2);
    return !!(t2.length <= 1 || "string" == typeof e2 && e2.match(/^\w+$/) || Array.isArray(e2) && "apply" === e2[0] && "sqrt" !== e2[1] || t2.match(/^\\left\(.*\\right\)$/) || t2.match(/^\\left\\langle.*\\right\\rangle$/)) || "number" == typeof e2 && (e2 >= 0 && !e2.toString().includes("e"));
  }
  stringConvert(e2) {
    return e2.length > 1 ? (this.convertLatexSymbols[e2] && (e2 = this.convertLatexSymbols[e2]), this.allowedLatexSymbols.includes(e2) ? "\\" + e2 : "\\operatorname{" + e2 + "}") : this.allowedLatexSymbols.includes(e2) ? "\\" + e2 : "＿" !== e2 || this.showBlanks ? e2 : "";
  }
  factor(e2) {
    if ("string" == typeof e2) return this.stringConvert(e2);
    if ("number" == typeof e2) {
      if (e2 === 1 / 0) return "\\infty";
      if (e2 === -1 / 0) return "-\\infty";
      if (Number.isNaN(e2)) return "NaN";
      {
        let t3 = e2.toString(), r2 = t3.indexOf("e");
        if (-1 === r2) return null === this.padToDigits && null === this.padToDecimals || (t3 = padNumberStringToDigitsAndDecimals$1(t3, this.padToDigits, this.padToDecimals)), t3;
        let n = t3.substring(0, r2), i2 = t3.substring(r2 + 1);
        if ("+" === i2[0] && (i2 = i2.slice(1)), null !== this.padToDigits || null !== this.padToDecimals) {
          let r3 = Number(i2);
          if (r3 > 0 && null !== this.padToDecimals) return t3 = e2.toLocaleString("fullwide", { useGrouping: false }), padNumberStringToDigitsAndDecimals$1(t3, this.padToDigits, this.padToDecimals);
          {
            let e3 = null;
            null !== this.padToDecimals && (e3 = this.padToDecimals + r3), n = padNumberStringToDigitsAndDecimals$1(n, this.padToDigits, e3);
          }
        }
        return n + " \\cdot 10^{" + i2 + "}";
      }
    }
    if (!Array.isArray(e2)) return "";
    var t2 = e2[0], r = e2.slice(1);
    if ("^" === t2) {
      if (Number.isInteger(r[0]) && Number.isInteger(r[1])) return r[0] < 0 ? "\\left(" + r[0].toString() + "\\right)^{" + r[1].toString() + "}" : r[0].toString() + "^{" + r[1].toString() + "}";
      let e3 = this.factor(r[0]), t3 = r[0];
      for (; "prime" === t3[0]; ) t3 = t3[1];
      return this.simple_factor_or_function_or_parens(t3) || "_" === t3[0] && "string" == typeof t3[1] || (e3 = "\\left(" + e3.toString() + "\\right)"), e3 + "^{" + this.statement(r[1]) + "}";
    }
    if ("_" === t2) {
      let e3 = this.factor(r[0]);
      return this.simple_factor_or_function_or_parens(r[0]) || (e3 = "\\left(" + e3.toString() + "\\right)"), e3 + "_{" + this.statement(r[1]) + "}";
    }
    if ("prime" === t2) {
      let e3 = r[0], t3 = 1;
      for (; "prime" === e3[0]; ) t3 += 1, e3 = e3[1];
      let n = this.factor(e3);
      this.simple_factor_or_function_or_parens(e3) || "_" === e3[0] && "string" == typeof e3[1] || (n = "\\left(" + n + "\\right)");
      for (let e4 = 0; e4 < t3; e4++) n += "'";
      return n;
    }
    if ("/" === t2) return this.term(e2);
    if ("-" === t2) return operators$1$1[t2](r.map((function(e3, t3) {
      return this.factor(e3);
    }).bind(this)));
    if ("tuple" === t2 || "array" === t2 || "list" === t2 || "set" === t2 || "vector" === t2 || "altvector" === t2 || "|" === t2 || ":" === t2 || "binom" === t2 || "vec" === t2 || "linesegment" === t2) return operators$1$1[t2](r.map((function(e3, t3) {
      return this.statement(e3);
    }).bind(this)));
    if ("interval" === t2) {
      let e3 = r[0], t3 = r[1];
      if ("tuple" !== e3[0] || "tuple" !== t3[0]) throw new Error("Badly formed ast");
      let n = this.statement(e3[1]) + ", " + this.statement(e3[2]);
      return n = t3[1] ? "\\left[ " + n : "\\left( " + n, t3[2] ? n += " \\right]" : n += " \\right)", n;
    }
    if ("matrix" === t2) {
      let e3 = r[0], t3 = r[1], n = "\\begin{" + this.matrixEnvironment + "} ";
      for (let r2 = 0; r2 < e3[1]; r2 += 1) {
        for (let i2 = 0; i2 < e3[2]; i2 += 1) n += this.statement(t3[r2 + 1][i2 + 1]), i2 < e3[2] - 1 && (n += " & ");
        r2 < e3[1] - 1 && (n += " \\\\ ");
      }
      return n = n + " \\end{" + this.matrixEnvironment + "}", n;
    }
    if ("derivative_leibniz" === t2 || "partial_derivative_leibniz" === t2) {
      let e3 = "d";
      "partial_derivative_leibniz" === t2 && (e3 = "\\partial ");
      let n = r[0], i2 = r[1], a = 1, o = "";
      Array.isArray(n) ? (o = n[1], a = n[2]) : o = n;
      let s = e3;
      a > 1 ? s = s.trimRight() + "^{" + a + "}" + this.stringConvert(o) : s += this.stringConvert(o), s = "\\frac{ " + s + " }{ ";
      let u = 1;
      Array.isArray(i2) && (u = i2.length - 1);
      for (let t3 = 1; t3 <= u; t3++) {
        let r2 = i2[t3], n3 = 1, a2 = "";
        Array.isArray(r2) ? (a2 = r2[1], n3 = r2[2]) : a2 = r2, s = s + e3 + this.stringConvert(a2), n3 > 1 && (s = s + "^{" + n3 + "}"), s += " ";
      }
      return s += "}", s;
    }
    if ("apply" === t2) {
      if ("abs" === r[0]) return "\\left|" + this.statement(r[1]) + "\\right|";
      if ("floor" === r[0]) return "\\left\\lfloor " + this.statement(r[1]) + " \\right\\rfloor";
      if ("ceil" === r[0]) return "\\left\\lceil " + this.statement(r[1]) + " \\right\\rceil";
      if ("factorial" === r[0]) {
        let e4 = this.factor(r[1]);
        return this.simple_factor_or_function_or_parens(r[1]) || "_" === r[1][0] && "string" == typeof r[1][1] ? e4 + "!" : "\\left(" + e4 + "\\right)!";
      }
      if ("sqrt" === r[0]) return "\\sqrt{" + this.statement(r[1]) + "}";
      let e3, t3 = r[0];
      if ("^" === t3[0] && (t3 = t3[1]), "_" === t3[0] && (t3 = t3[1]), "int" === t3) {
        let e4, t4 = this.factor(r[0]), n3 = r[1];
        if (Array.isArray(n3) && "*" === n3[0]) {
          let t5 = [], r2 = ["*"];
          for (let e5 = 1; e5 < n3.length; e5++) {
            let i2 = n3[e5];
            Array.isArray(i2) && "d" === i2[0] ? t5.push(i2) : r2.push(i2);
          }
          e4 = this.term(r2), t5.length > 0 && (e4[e4.length - 1].match(/[a-zA-Z]/) && (e4 += "\\,"), e4 += t5.map(((e5) => "d" + this.factor(e5[1]))).join("\\,"));
        }
        return e4 || (e4 = this.term(r[1])), t4 + " " + e4;
      }
      e3 = "log10" === r[0] ? "\\log_{10}" : "re" === r[0] ? "\\Re" : "im" === r[0] ? "\\Im" : this.factor(r[0]);
      let n = this.statement(r[1]);
      return "tuple" !== r[1][0] && (n = "\\left(" + n + "\\right)"), e3 + n;
    }
    if ("angle" === t2) {
      let e3 = r.every(((e4) => {
        if ("string" == typeof e4 && 1 === e4.length) return true;
        if (!Array.isArray(e4)) return false;
        let t3 = e4[0];
        return "_" === t3 || "^" === t3 || "prime" === t3;
      }));
      return operators$1$1[t2](r.map((function(e4, t3) {
        return this.statement(e4);
      }).bind(this)), e3);
    }
    return "+" === t2 && 2 === e2.length ? "+ " + this.factor(e2[1]) : "\\left(" + this.statement(e2) + "\\right)";
  }
  factorWithParenthesesIfNegatedExplicitPlusOrFraction(e2) {
    var t2 = this.factor(e2);
    return t2.match(/^-/) || t2.match(/^\+/) || "/" === e2[0] ? "\\left(" + t2 + "\\right)" : t2;
  }
  termWithPlusIfNotNegated(e2) {
    var t2 = this.term(e2);
    return t2.match(/^-/) ? t2.match(/^-[^ ]/) ? "- " + t2.slice(1) : t2 : "+ " + t2;
  }
};
const textToAst$2$1 = new textToAst$4$1(), astToLatex$2 = new astToLatex$1$1();
var derivatives$1 = { sin: textToAst$2$1.convert("cos x"), cos: textToAst$2$1.convert("-(sin x)"), tan: textToAst$2$1.convert("(sec x)^2"), cot: textToAst$2$1.convert("-((csc x)^2)"), sec: textToAst$2$1.convert("(sec x)*(tan x)"), csc: textToAst$2$1.convert("-(csc x)*(cot x)"), sqrt: textToAst$2$1.convert("1/(2*sqrt(x))"), log: textToAst$2$1.convert("1/x"), ln: textToAst$2$1.convert("1/x"), exp: textToAst$2$1.convert("exp(x)"), arcsin: textToAst$2$1.convert("1/sqrt(1 - x^2)"), arccos: textToAst$2$1.convert("-1/sqrt(1 - x^2)"), arctan: textToAst$2$1.convert("1/(1 + x^2)"), arccsc: textToAst$2$1.convert("-1/(sqrt(-1/x^2 + 1)*x^2)"), arcsec: textToAst$2$1.convert("1/(sqrt(-1/x^2 + 1)*x^2)"), arccot: textToAst$2$1.convert("-1/(1 + x^2)"), abs: textToAst$2$1.convert("abs(x)/x") };
function derivative$1(e2, t2, r = []) {
  var n = get_tree$1(e2), i2 = "\\frac{d}{d" + t2 + "} ";
  if ("number" == typeof n) return r.push("The derivative of a constant is zero, that is, \\(" + i2 + astToLatex$2.convert(n) + " = 0\\)."), 0;
  if (variables$2(n).indexOf(t2) < 0) return r.push("The derivative of a constant is zero, that is, \\(" + i2 + astToLatex$2.convert(n) + " = 0\\)."), 0;
  if ("string" == typeof n) return t2 === n ? (r.push("We know the derivative of the identity function is one, that is, \\(" + i2 + astToLatex$2.convert(n) + " = 1\\)."), 1) : (r.push("As far as \\(" + astToLatex$2.convert(t2) + "\\) is concerned, \\(" + astToLatex$2.convert(n) + "\\) is constant, so " + i2 + astToLatex$2.convert(n) + " = 0\\)."), 0);
  if (!Array.isArray(n)) return null;
  var a = n[0], o = n.slice(1);
  if ("+" === a || "-" === a || "~" === a) {
    r.push("Using the sum rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + o.map((function(e4, t3) {
      return i2 + astToLatex$2.convert(e4);
    })).join(" + ") + "\\).");
    let e3 = [a].concat(o.map((function(e4, n3) {
      return derivative$1(e4, t2, r);
    })));
    return e3 = simplify$2(e3), r.push("So using the sum rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(e3) + "\\)."), e3;
  }
  if ("*" === a) {
    let e3 = [], a2 = [];
    for (let r2 = 0; r2 < o.length; r2++) "number" == typeof o[r2] || variables$2(o[r2]).indexOf(t2) < 0 ? a2.push(o[r2]) : e3.push(o[r2]);
    if (a2.length > 0) {
      if (0 === e3.length) {
        return r.push("Since the derivative of a constant is zero, \\(" + i2 + astToLatex$2.convert(n) + " = 0.\\)"), 0;
      }
      let o2 = ["*"].concat(e3);
      if (1 === e3.length && (o2 = e3[0]), o2 === t2) {
        r.push("By the constant multiple rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + a2.map((function(e5, t3) {
          return astToLatex$2.convert(e5);
        })).join(" \\cdot ") + "\\).");
        let e4 = ["*"].concat(a2);
        return e4 = simplify$2(e4), e4;
      }
      r.push("By the constant multiple rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + a2.map((function(e4, t3) {
        return astToLatex$2.convert(e4);
      })).join(" \\cdot ") + " \\cdot " + i2 + "\\left(" + astToLatex$2.convert(o2) + "\\right)\\).");
      let s2 = derivative$1(o2, t2, r), u2 = ["*"].concat(a2.concat([s2]));
      return u2 = simplify$2(u2), r.push("And so \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(u2) + "\\)."), u2;
    }
    r.push("Using the product rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + o.map((function(e4, t3) {
      return o.map((function(r2, n3) {
        return t3 === n3 ? i2 + "\\left(" + astToLatex$2.convert(e4) + "\\right)" : astToLatex$2.convert(r2);
      })).join(" \\cdot ");
    })).join(" + ") + "\\).");
    let s = o.slice(), u = ["+"].concat(o.map((function(e4, n3) {
      return ["*"].concat(s.map((function(e5, i3) {
        if (n3 === i3) {
          let n4 = derivative$1(e5, t2, r);
          return 1 === n4 ? null : n4;
        }
        return e5;
      })).filter((function(e5) {
        return null != e5;
      })));
    })));
    return u = simplify$2(u), r.push("So using the product rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(u) + "\\)."), u;
  }
  if ("/" === a) {
    let e3 = o[0], a2 = o[1];
    if (variables$2(a2).indexOf(t2) < 0) {
      r.push("By the constant multiple rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(["/", 1, a2]) + " \\cdot " + i2 + "\\left(" + astToLatex$2.convert(e3) + "\\right)\\).");
      let o2 = derivative$1(e3, t2, r), s2 = textToAst$2$1.convert("(1/g)*d"), u2 = substitute$1$1(s2, { d: o2, g: a2 });
      return u2 = simplify$2(u2), r.push("So \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(u2) + "\\)."), u2;
    }
    if (variables$2(e3).indexOf(t2) < 0) {
      1 !== e3 && r.push("By the constant multiple rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(e3) + " \\cdot " + i2 + "\\left(" + astToLatex$2.convert(["/", 1, a2]) + "\\right)\\)."), r.push("Since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(e3) + "\\cdot \\frac{-1}{ " + astToLatex$2.convert(a2) + "^2} \\cdot " + i2 + astToLatex$2.convert(a2) + "\\).");
      let o2 = derivative$1(a2, t2, r), s2 = textToAst$2$1.convert("f * (-a/(g^2))"), u2 = substitute$1$1(s2, { f: e3, a: o2, g: a2 });
      return u2 = simplify$2(u2), r.push("So since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(u2) + "\\)."), u2;
    }
    r.push("Using the quotient rule, \\(" + i2 + astToLatex$2.convert(n) + " = \\frac{" + i2 + "\\left(" + astToLatex$2.convert(e3) + "\\right) \\cdot " + astToLatex$2.convert(a2) + " - " + astToLatex$2.convert(e3) + "\\cdot " + i2 + "\\left(" + astToLatex$2.convert(a2) + "\\right)}{ \\left( " + astToLatex$2.convert(a2) + " \\right)^2} \\).");
    let s = derivative$1(e3, t2, r), u = derivative$1(a2, t2, r), c2 = textToAst$2$1.convert("(a * g - f * b)/(g^2)"), l = substitute$1$1(c2, { a: s, b: u, f: e3, g: a2 });
    return l = simplify$2(l), r.push("So using the quotient rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(l) + "\\)."), l;
  }
  if ("^" === a) {
    let e3 = o[0], a2 = o[1];
    if (variables$2(a2).indexOf(t2) < 0) {
      if ("string" == typeof e3 && "x" === e3) {
        if ("number" == typeof a2) {
          let t4 = textToAst$2$1.convert("n * (f^m)"), o4 = substitute$1$1(t4, { n: a2, m: a2 - 1, f: e3 });
          return o4 = simplify$2(o4), r.push("By the power rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(a2) + " \\cdot \\left(" + astToLatex$2.convert(e3) + "\\right)^{" + astToLatex$2.convert(["-", a2, 1]) + "}\\)."), o4;
        }
        let t3 = textToAst$2$1.convert("n * (f^(n-1))"), o3 = substitute$1$1(t3, { n: a2, f: e3 });
        return o3 = simplify$2(o3), r.push("By the power rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(a2) + " \\cdot \\left(" + astToLatex$2.convert(e3) + "\\right)^{" + astToLatex$2.convert(["-", a2, 1]) + "}\\)."), o3;
      }
      1 !== a2 && r.push("By the power rule and the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(a2) + " \\cdot \\left(" + astToLatex$2.convert(e3) + "\\right)^{" + astToLatex$2.convert(["-", a2, 1]) + "} \\cdot " + i2 + astToLatex$2.convert(e3) + "\\).");
      let o2 = derivative$1(e3, t2, r);
      if (1 === a2) return o2;
      if ("number" == typeof a2) {
        let t3 = textToAst$2$1.convert("n * (f^m) * a"), s3 = substitute$1$1(t3, { n: a2, m: a2 - 1, f: e3, a: o2 });
        return s3 = simplify$2(s3), r.push("So by the power rule and the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(s3) + "\\)."), s3;
      }
      let s2 = textToAst$2$1.convert("n * (f^(n-1)) * a"), u2 = substitute$1$1(s2, { n: a2, f: e3, a: o2 });
      return u2 = simplify$2(u2), r.push("So by the power rule and the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(u2) + "\\)."), u2;
    }
    if ("e" === e3 && math$1$1.define_e) {
      if ("string" == typeof a2 && a2 === t2) {
        let e5 = textToAst$2$1.convert("e^(f)"), o3 = substitute$1$1(e5, { f: a2 });
        return o3 = simplify$2(o3), r.push("The derivative of \\(e^" + astToLatex$2.convert(t2) + "\\) is itself, that is, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(n) + "\\)."), o3;
      }
      r.push("Using the rule for \\(e^x\\) and the chain rule, we know \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(n) + " \\cdot " + i2 + astToLatex$2.convert(a2) + "\\).");
      let e4 = textToAst$2$1.convert("e^(f)*d"), o2 = derivative$1(a2, t2, r), s2 = substitute$1$1(e4, { f: a2, d: o2 });
      return s2 = simplify$2(s2), r.push("So using the rule for \\(e^x\\) and the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(s2) + "\\)."), s2;
    }
    if ("number" == typeof e3) {
      if ("string" == typeof a2 && a2 === t2) {
        let o3 = textToAst$2$1.convert("a^(f) * log(a)"), s3 = substitute$1$1(o3, { a: e3, f: a2 });
        return s3 = simplify$2(s3), r.push("The derivative of \\(a^" + astToLatex$2.convert(t2) + "\\) is \\(a^{" + astToLatex$2.convert(t2) + "} \\, \\log a\\), that is, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(s3) + "\\)."), s3;
      }
      let o2 = textToAst$2$1.convert("a^(f) * log(a)"), s2 = substitute$1$1(o2, { a: e3, f: a2 });
      r.push("Using the rule for \\(a^x\\) and the chain rule, we know \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(s2) + " \\cdot " + i2 + astToLatex$2.convert(a2) + "\\).");
      let u2 = textToAst$2$1.convert("a^(b)*log(a)*d"), c3 = derivative$1(a2, t2, r), l2 = substitute$1$1(u2, { a: e3, b: a2, d: c3 });
      return l2 = simplify$2(l2), r.push("So using the rule for \\(a^x\\) and the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(l2) + "\\)."), l2;
    }
    let s = e3, u = a2;
    r.push("Recall the general rule for exponents, namely that \\(\\frac{d}{dx} u(x)^{v(x)} = u(x)^{v(x)} \\cdot \\left( v'(x) \\cdot \\log u(x) + \\frac{v(x) \\cdot u'(x)}{u(x)} \\right)\\).  In this case, \\(u(x) = " + astToLatex$2.convert(s) + "\\) and \\(v(x) = " + astToLatex$2.convert(u) + "\\).");
    let c2 = derivative$1(s, t2, r), l = derivative$1(u, t2, r), f2 = textToAst$2$1.convert("(f^g)*(b * log(f) + (g * a)/f)"), p = substitute$1$1(f2, { a: c2, b: l, f: s, g: u });
    return p = simplify$2(p), r.push("So by the general rule for exponents, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(p) + "\\)."), p;
  }
  if ("apply" === a && !(o[0] in derivatives$1)) {
    let e3 = o[1];
    r.push("By the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(substitute$1$1(["apply", o[0] + "'", "x"], { x: e3 })) + " \\cdot " + i2 + astToLatex$2.convert(e3) + "\\).");
    let a2 = ["*", substitute$1$1(["apply", o[0] + "'", "x"], { x: e3 }), derivative$1(e3, t2, r)];
    return a2 = simplify$2(a2), r.push("So by the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(a2) + "\\)."), a2;
  }
  if ("apply" === a && o[0] in derivatives$1 || a in derivatives$1) {
    let e3 = false;
    "apply" === a && (a = o[0], o = o.slice(1), e3 = true);
    let s = o[0];
    if ("number" == typeof s) {
      let e4 = 0;
      return r.push("The derivative of a constant is zero so \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(e4) + "\\)."), e4;
    }
    if ("string" == typeof s && s === t2) {
      let e4 = ["*", substitute$1$1(derivatives$1[a], { x: s })];
      return e4 = simplify$2(e4), r.push("It is the case that \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(e4) + "\\)."), e4;
    }
    if ("string" == typeof s && s !== t2) {
      let e4 = 0;
      return r.push("Since the derivative of a constant is zero, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(e4) + "\\)."), e4;
    }
    {
      let o2 = [a, "u"];
      e3 && (o2 = ["apply"].concat(o2)), r.push("Recall \\(\\frac{d}{du}" + astToLatex$2.convert(o2) + " = " + astToLatex$2.convert(derivative$1(o2, "u", [])) + "\\)."), r.push("By the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(substitute$1$1(derivatives$1[a], { x: s })) + " \\cdot " + i2 + astToLatex$2.convert(s) + "\\).");
      let u = ["*", substitute$1$1(derivatives$1[a], { x: s }), derivative$1(s, t2, r)];
      return u = simplify$2(u), r.push("So by the chain rule, \\(" + i2 + astToLatex$2.convert(n) + " = " + astToLatex$2.convert(u) + "\\)."), u;
    }
  }
  return 0;
}
function lowercaseFirstLetter$1(e2) {
  return e2.charAt(0).toLowerCase() + e2.slice(1);
}
function simplify_story$1(e2) {
  for (let t2 = e2.length - 1; t2 >= 1; t2--) e2[t2] === e2[t2 - 1] && e2.splice(t2, 1);
  for (let t2 = 0; t2 < e2.length; t2++) for (let r = t2 + 1; r < e2.length; r++) e2[t2] === e2[r] && (e2[r] = "Again, " + lowercaseFirstLetter$1(e2[r]));
  return e2;
}
function derivative_story$1(e2, t2) {
  var r = [];
  return derivative$1(e2, t2, r), r = simplify_story$1(r);
}
const derivativeStory$1 = derivative_story$1;
var differentiation$1 = Object.freeze({ __proto__: null, derivative: derivative$1, derivative_story: derivative_story$1, derivativeStory: derivativeStory$1 });
const unicode_operators$1 = { "+": function(e2) {
  return e2.join(" ");
}, "-": function(e2) {
  return "-" + e2[0];
}, "*": function(e2) {
  return e2.join(" ");
}, "/": function(e2) {
  return e2[0] + "/" + e2[1];
}, _: function(e2) {
  return e2[0] + "_" + e2[1];
}, "^": function(e2) {
  return e2[0] + "^" + e2[1];
}, prime: function(e2) {
  return e2[0] + "'";
}, tuple: function(e2) {
  return "( " + e2.join(", ") + " )";
}, array: function(e2) {
  return "[ " + e2.join(", ") + " ]";
}, list: function(e2) {
  return e2.join(", ");
}, set: function(e2) {
  return "{ " + e2.join(", ") + " }";
}, vector: function(e2) {
  return "( " + e2.join(", ") + " )";
}, altvector: function(e2) {
  return "⟨ " + e2.join(", ") + " ⟩";
}, interval: function(e2) {
  return "( " + e2.join(", ") + " )";
}, matrix: function(e2) {
  return "( " + e2.join(", ") + " )";
}, and: function(e2) {
  return e2.join(" and ");
}, or: function(e2) {
  return e2.join(" or ");
}, not: function(e2) {
  return "not " + e2[0];
}, "=": function(e2) {
  return e2.join(" = ");
}, "<": function(e2) {
  return e2.join(" < ");
}, ">": function(e2) {
  return e2.join(" > ");
}, lts: function(e2) {
  return e2.join(" < ");
}, gts: function(e2) {
  return e2.join(" > ");
}, le: function(e2) {
  return e2.join(" ≤ ");
}, ge: function(e2) {
  return e2.join(" ≥ ");
}, ne: function(e2) {
  return e2.join(" ≠ ");
}, forall: function(e2) {
  return "∀ " + e2[0];
}, exists: function(e2) {
  return "∃ " + e2[0];
}, in: function(e2) {
  return e2[0] + " ∈ " + e2[1];
}, notin: function(e2) {
  return e2[0] + " ∉ " + e2[1];
}, ni: function(e2) {
  return e2[0] + " ∋ " + e2[1];
}, notni: function(e2) {
  return e2[0] + " ∌ " + e2[1];
}, subset: function(e2) {
  return e2[0] + " ⊂ " + e2[1];
}, subseteq: function(e2) {
  return e2[0] + " ⊆ " + e2[1];
}, notsubset: function(e2) {
  return e2[0] + " ⊄ " + e2[1];
}, notsubseteq: function(e2) {
  return e2[0] + " ⊈ " + e2[1];
}, superset: function(e2) {
  return e2[0] + " ⊃ " + e2[1];
}, superseteq: function(e2) {
  return e2[0] + " ⊇ " + e2[1];
}, notsuperset: function(e2) {
  return e2[0] + " ⊅ " + e2[1];
}, notsuperseteq: function(e2) {
  return e2[0] + " ⊉ " + e2[1];
}, union: function(e2) {
  return e2.join(" ∪ ");
}, intersect: function(e2) {
  return e2.join(" ∩ ");
}, rightarrow: function(e2) {
  return e2.join(" → ");
}, leftarrow: function(e2) {
  return e2.join(" ← ");
}, leftrightarrow: function(e2) {
  return e2.join(" ↔ ");
}, implies: function(e2) {
  return e2.join(" ⟹ ");
}, impliedby: function(e2) {
  return e2.join(" ⟸ ");
}, iff: function(e2) {
  return e2.join(" ⟺ ");
}, perp: function(e2) {
  return e2.join(" ⟂ ");
}, parallel: function(e2) {
  return e2.join(" ∥ ");
}, derivative_leibniz: function(e2) {
  return "d" + e2[0] + "/d" + e2[1];
}, partial_derivative_leibniz: function(e2) {
  return "∂" + e2[0] + "/∂" + e2[1];
}, "|": function(e2) {
  return e2[0] + " | " + e2[1];
}, ":": function(e2) {
  return e2[0] + " : " + e2[1];
}, binom: function(e2) {
  return "binom( " + e2[0] + ", " + e2[1] + " )";
}, vec: function(e2) {
  return "vec(" + e2[0] + ")";
}, linesegment: function(e2) {
  return "linesegment( " + e2.join(", ") + " )";
}, angle: function(e2, t2) {
  return t2 ? "∠" + e2.join("") : "∠( " + e2.join(", ") + " )";
}, unit: function(e2) {
  return e2[0] + " " + e2[1];
} }, nonunicode_operators$1 = { "+": function(e2) {
  return e2.join(" ");
}, "-": function(e2) {
  return "-" + e2[0];
}, "*": function(e2) {
  return e2.join(" ");
}, "/": function(e2) {
  return e2[0] + "/" + e2[1];
}, _: function(e2) {
  return e2[0] + "_" + e2[1];
}, "^": function(e2) {
  return e2[0] + "^" + e2[1];
}, prime: function(e2) {
  return e2[0] + "'";
}, tuple: function(e2) {
  return "( " + e2.join(", ") + " )";
}, array: function(e2) {
  return "[ " + e2.join(", ") + " ]";
}, list: function(e2) {
  return e2.join(", ");
}, set: function(e2) {
  return "{ " + e2.join(", ") + " }";
}, vector: function(e2) {
  return "( " + e2.join(", ") + " )";
}, altvector: function(e2) {
  return "( " + e2.join(", ") + " )";
}, interval: function(e2) {
  return "( " + e2.join(", ") + " )";
}, matrix: function(e2) {
  return "( " + e2.join(", ") + " )";
}, and: function(e2) {
  return e2.join(" and ");
}, or: function(e2) {
  return e2.join(" or ");
}, not: function(e2) {
  return "not " + e2[0];
}, "=": function(e2) {
  return e2.join(" = ");
}, "<": function(e2) {
  return e2.join(" < ");
}, ">": function(e2) {
  return e2.join(" > ");
}, lts: function(e2) {
  return e2.join(" < ");
}, gts: function(e2) {
  return e2.join(" > ");
}, le: function(e2) {
  return e2.join(" <= ");
}, ge: function(e2) {
  return e2.join(" >= ");
}, ne: function(e2) {
  return e2.join(" ne ");
}, forall: function(e2) {
  return "forall " + e2[0];
}, exists: function(e2) {
  return "exists " + e2[0];
}, in: function(e2) {
  return e2[0] + " elementof " + e2[1];
}, notin: function(e2) {
  return e2[0] + " notelementof " + e2[1];
}, ni: function(e2) {
  return e2[0] + " containselement " + e2[1];
}, notni: function(e2) {
  return e2[0] + " notcontainselement " + e2[1];
}, subset: function(e2) {
  return e2[0] + " subset " + e2[1];
}, subseteq: function(e2) {
  return e2[0] + " subseteq " + e2[1];
}, notsubset: function(e2) {
  return e2[0] + " notsubset " + e2[1];
}, notsubseteq: function(e2) {
  return e2[0] + " notsubseteq " + e2[1];
}, superset: function(e2) {
  return e2[0] + " superset " + e2[1];
}, superseteq: function(e2) {
  return e2[0] + " superseteq " + e2[1];
}, notsuperset: function(e2) {
  return e2[0] + " notsuperset " + e2[1];
}, notsuperseteq: function(e2) {
  return e2[0] + " notsuperseteq " + e2[1];
}, union: function(e2) {
  return e2.join(" union ");
}, intersect: function(e2) {
  return e2.join(" intersect ");
}, rightarrow: function(e2) {
  return e2.join(" rightarrow ");
}, leftarrow: function(e2) {
  return e2.join(" leftarrow ");
}, leftrightarrow: function(e2) {
  return e2.join(" leftrightarrow ");
}, implies: function(e2) {
  return e2.join(" implies ");
}, impliedby: function(e2) {
  return e2.join(" impliedby ");
}, iff: function(e2) {
  return e2.join(" iff ");
}, perp: function(e2) {
  return e2.join(" perp ");
}, parallel: function(e2) {
  return e2.join(" parallel ");
}, derivative_leibniz: function(e2) {
  return "d" + e2[0] + "/d" + e2[1];
}, partial_derivative_leibniz: function(e2) {
  return "∂" + e2[0] + "/∂" + e2[1];
}, "|": function(e2) {
  return e2[0] + " | " + e2[1];
}, ":": function(e2) {
  return e2[0] + " : " + e2[1];
}, binom: function(e2) {
  return "binom( " + e2[0] + ", " + e2[1] + " )";
}, vec: function(e2) {
  return "vec(" + e2[0] + ")";
}, linesegment: function(e2) {
  return "linesegment( " + e2.join(", ") + " )";
}, angle: function(e2, t2) {
  return t2 ? "angle " + e2.join("") : "angle( " + e2.join(", ") + " )";
}, unit: function(e2) {
  return e2[0] + " " + e2[1];
} }, output_unicodeDefault$1 = true;
let astToText$2$1 = class astToText$22 {
  constructor({ output_unicode: e2 = output_unicodeDefault$1, padToDigits: t2 = null, padToDecimals: r = null, showBlanks: n = true } = {}) {
    this.output_unicode = e2, this.operators = unicode_operators$1, e2 || (this.operators = nonunicode_operators$1), this.padToDigits = t2, this.padToDecimals = r, this.showBlanks = n;
  }
  convert(e2) {
    return this.statement(e2);
  }
  statement(e2) {
    if (!Array.isArray(e2)) return this.single_statement(e2);
    let t2 = e2[0], r = e2.slice(1);
    if ("ldots" === t2) return "...";
    if (!(t2 in this.operators) && "apply" !== t2) throw new Error("Badly formed ast: operator " + t2 + " not recognized.");
    return ["implies", "impliedby", "iff", "rightarrow", "leftarrow", "leftrightarrow"].includes(t2) ? this.operators[t2](r.map(((e3) => this.statement(e3)))) : "and" === t2 || "or" === t2 ? this.operators[t2](r.map((function(e3, t3) {
      let r2 = this.single_statement(e3);
      return r2.match(/ /) && !r2.match(/^\(.*\)$/) ? "(" + r2 + ")" : r2;
    }).bind(this))) : this.single_statement(e2);
  }
  single_statement(e2) {
    if (!Array.isArray(e2)) return this.expression(e2);
    let t2 = e2[0], r = e2.slice(1);
    if ("not" === t2) return this.operators[t2](r.map((function(e3, t3) {
      let r2 = this.single_statement(e3);
      return r2.match(/ /) && !r2.match(/^\(.*\)$/) ? "(" + r2 + ")" : r2;
    }).bind(this)));
    if ("exists" === t2 || "forall" === t2) return this.operators[t2]([this.single_statement(r[0])]);
    if ("=" === t2 || "ne" === t2 || "<" === t2 || ">" === t2 || "le" === t2 || "ge" === t2 || "in" === t2 || "notin" === t2 || "ni" === t2 || "notni" === t2 || "subset" === t2 || "notsubset" === t2 || "subseteq" === t2 || "notsubseteq" === t2 || "superset" === t2 || "notsuperset" === t2 || "superseteq" === t2 || "notsuperseteq" === t2) return this.operators[t2](r.map((function(e3, t3) {
      return this.expression(e3);
    }).bind(this)));
    if ("lts" === t2 || "gts" === t2) {
      let e3 = r[0], n = r[1];
      if ("tuple" !== e3[0] || "tuple" !== n[0]) throw new Error("Badly formed ast");
      let i2 = this.expression(e3[1]);
      for (let r2 = 1; r2 < e3.length - 1; r2++) n[r2] ? i2 += "lts" === t2 ? " < " : " > " : "lts" === t2 ? this.output_unicode ? i2 += " ≤ " : i2 += " <= " : this.output_unicode ? i2 += " ≥ " : i2 += " >= ", i2 += this.expression(e3[r2 + 1]);
      return i2;
    }
    return this.expression(e2);
  }
  expression(e2) {
    if (!Array.isArray(e2)) return this.term(e2);
    let t2 = e2[0], r = e2.slice(1);
    return "+" === t2 ? 1 === r.length ? "+" + this.term(r[0]) : this.operators[t2](r.map((function(e3, t3) {
      return t3 > 0 ? this.termWithPlusIfNotNegated(e3) : this.term(e3);
    }).bind(this))) : ["union", "intersect", "perp", "parallel"].includes(t2) ? this.operators[t2](r.map((function(e3, t3) {
      return this.term(e3);
    }).bind(this))) : this.term(e2);
  }
  term(e2) {
    if (!Array.isArray(e2)) return this.factor(e2);
    let t2 = e2[0], r = e2.slice(1);
    if ("-" === t2) return this.operators[t2](r.map((function(e3, t3) {
      return this.term(e3);
    }).bind(this)));
    if ("*" === t2) return this.operators[t2](r.map((function(e3, t3) {
      let n;
      return t3 > 0 ? (n = this.factorWithParenthesesIfNegatedOrExplicitPlus(e3), n.match(/^[0-9]/) ? "* " + n : "angle" === e3[0] && r.length > 1 ? "( " + n + " )" : n) : (n = this.factor(e3), "angle" === e3[0] && r.length > 1 ? "( " + n + " )" : n);
    }).bind(this)));
    if ("/" === t2) {
      let e3 = this.factor(r[0]), n = this.factor(r[1]);
      return this.simple_factor_or_function_or_parens(r[0]) || (e3 = "(" + e3 + ")"), this.simple_factor_or_function_or_parens(r[1]) || (n = "(" + n + ")"), this.operators[t2]([e3, n]);
    }
    return "unit" === t2 ? this.operators[t2](r.map((function(e3, t3) {
      return this.expression(e3);
    }).bind(this))) : this.factor(e2);
  }
  symbolConvert(e2) {
    let t2 = { alpha: "α", beta: "β", Gamma: "Γ", gamma: "γ", Delta: "Δ", delta: "δ", epsilon: "ε", zeta: "ζ", eta: "η", Theta: "ϴ", theta: "θ", iota: "ι", kappa: "κ", Lambda: "Λ", lambda: "λ", mu: "μ", nu: "ν", Xi: "Ξ", xi: "ξ", Pi: "Π", pi: "π", rho: "ρ", Sigma: "Σ", sigma: "σ", tau: "τ", Upsilon: "Υ", upsilon: "υ", Phi: "Φ", phi: "ϕ", Psi: "Ψ", psi: "ψ", Omega: "Ω", omega: "ω", perp: "⟂", int: "∫", emptyset: "∅" };
    return this.output_unicode && e2 in t2 ? t2[e2] : this.showBlanks || "＿" !== e2 ? e2 : "";
  }
  simple_factor_or_function_or_parens(e2) {
    let t2 = this.factor(e2);
    return !!(t2.length <= 1 || "string" == typeof e2 && e2.match(/^\w+$/) || Array.isArray(e2) && "apply" === e2[0] || t2.match(/^\(.*\)$/) || t2.match(/^⟨.*⟩$/)) || "number" == typeof e2 && (e2 >= 0 && !e2.toString().includes("e"));
  }
  factor(e2) {
    if ("string" == typeof e2) return this.symbolConvert(e2);
    if ("number" == typeof e2) {
      if (e2 === 1 / 0) return this.output_unicode ? "∞" : "infinity";
      if (e2 === -1 / 0) return this.output_unicode ? "-∞" : "-infinity";
      if (Number.isNaN(e2)) return "NaN";
      {
        let t3 = e2.toString(), r2 = t3.indexOf("e");
        if (-1 === r2) return null === this.padToDigits && null === this.padToDecimals || (t3 = padNumberStringToDigitsAndDecimals$1(t3, this.padToDigits, this.padToDecimals)), t3;
        let n = t3.substring(0, r2), i2 = t3.substring(r2 + 1);
        if (null !== this.padToDigits || null !== this.padToDecimals) {
          let r3 = Number(i2);
          if (r3 > 0 && null !== this.padToDecimals) return t3 = e2.toLocaleString("fullwide", { useGrouping: false }), padNumberStringToDigitsAndDecimals$1(t3, this.padToDigits, this.padToDecimals);
          {
            let e3 = null;
            null !== this.padToDecimals && (e3 = this.padToDecimals + r3), n = padNumberStringToDigitsAndDecimals$1(n, this.padToDigits, e3);
          }
        }
        return "+" === i2[0] ? n + " * 10^" + i2.substring(1) : n + " * 10^(" + i2 + ")";
      }
    }
    if (!Array.isArray(e2)) return "";
    let t2 = e2[0], r = e2.slice(1);
    if ("^" === t2) {
      if (Number.isInteger(r[0]) && Number.isInteger(r[1])) {
        let e4;
        return e4 = r[0] < 0 ? "(" + r[0].toString() + ")" : r[0].toString(), r[1] < 0 ? e4 + "^(" + r[1].toString() + ")" : e4 + "^" + r[1].toString();
      }
      let e3 = this.factor(r[0]), t3 = r[0];
      for (; "prime" === t3[0]; ) t3 = t3[1];
      this.simple_factor_or_function_or_parens(t3) || "_" === t3[0] && "string" == typeof t3[1] || (e3 = "(" + e3.toString() + ")");
      let n = this.factor(r[1]);
      return this.simple_factor_or_function_or_parens(r[1]) || (n = "(" + n.toString() + ")"), e3 + "^" + n;
    }
    if ("_" === t2) return this.operators[t2](r.map((function(e3, t3) {
      let r2 = this.factor(e3);
      return this.simple_factor_or_function_or_parens(e3) ? r2 : "(" + r2 + ")";
    }).bind(this)));
    if ("prime" === t2) {
      let e3 = r[0], t3 = 1;
      for (; "prime" === e3[0]; ) t3 += 1, e3 = e3[1];
      let n = this.factor(e3);
      this.simple_factor_or_function_or_parens(e3) || "_" === e3[0] && "string" == typeof e3[1] || (n = "(" + n + ")");
      for (let e4 = 0; e4 < t3; e4++) n += "'";
      return n;
    }
    if ("-" === t2) return this.operators[t2](r.map((function(e3, t3) {
      return this.factor(e3);
    }).bind(this)));
    if ("tuple" === t2 || "array" === t2 || "list" === t2 || "set" === t2 || "vector" === t2 || "altvector" === t2 || "|" === t2 || ":" === t2 || "binom" === t2 || "vec" === t2 || "linesegment" === t2) return this.operators[t2](r.map((function(e3, t3) {
      return this.statement(e3);
    }).bind(this)));
    if ("interval" === t2) {
      let e3 = r[0], t3 = r[1];
      if ("tuple" !== e3[0] || "tuple" !== t3[0]) throw new Error("Badly formed ast");
      let n = this.statement(e3[1]) + ", " + this.statement(e3[2]);
      return n = t3[1] ? "[ " + n : "( " + n, t3[2] ? n += " ]" : n += " )", n;
    }
    if ("matrix" === t2) {
      let e3 = r[0], t3 = r[1], n = "[ ";
      for (let r2 = 0; r2 < e3[1]; r2 += 1) {
        n += "[ ";
        for (let i2 = 0; i2 < e3[2]; i2 += 1) n += this.statement(t3[r2 + 1][i2 + 1]), i2 < e3[2] - 1 && (n += ","), n += " ";
        n += "]", r2 < e3[1] - 1 && (n += ","), n += " ";
      }
      return n += "]", n;
    }
    if ("derivative_leibniz" === t2 || "partial_derivative_leibniz" === t2) {
      let e3 = "d";
      "partial_derivative_leibniz" === t2 && (e3 = "∂");
      let n = r[0], i2 = r[1], a = 1, o = "";
      Array.isArray(n) ? (o = n[1], a = n[2]) : o = n;
      let s = e3;
      a > 1 && (s = s + "^" + a), s = s + this.symbolConvert(o) + "/";
      let u = 1;
      Array.isArray(i2) && (u = i2.length - 1);
      for (let t3 = 1; t3 <= u; t3++) {
        let r2 = i2[t3], n3 = 1, a2 = "";
        Array.isArray(r2) ? (a2 = r2[1], n3 = r2[2]) : a2 = r2, s = s + e3 + this.symbolConvert(a2), n3 > 1 && (s = s + "^" + n3);
      }
      return s;
    }
    if ("apply" === t2) {
      if ("abs" === r[0]) return "|" + this.statement(r[1]) + "|";
      if ("factorial" === r[0]) {
        let e4 = this.factor(r[1]);
        return this.simple_factor_or_function_or_parens(r[1]) || "_" === r[1][0] && "string" == typeof r[1][1] ? e4 + "!" : "(" + e4 + ")!";
      }
      let e3 = r[0];
      if ("^" === e3[0] && (e3 = e3[1]), "_" === e3[0] && (e3 = e3[1]), "int" === e3) {
        let e4, t4 = this.factor(r[0]), n3 = r[1];
        if (Array.isArray(n3) && "*" === n3[0]) {
          let t5 = [], r2 = ["*"];
          for (let e5 = 1; e5 < n3.length; e5++) {
            let i2 = n3[e5];
            Array.isArray(i2) && "d" === i2[0] ? t5.push(i2) : r2.push(i2);
          }
          e4 = this.term(r2), t5.length > 0 && (e4 += " " + t5.map(((e5) => "d" + this.factor(e5[1]))).join(" "));
        }
        return e4 || (e4 = this.term(r[1])), t4 + " " + e4;
      }
      let t3 = this.factor(r[0]), n = this.statement(r[1]);
      return "tuple" !== r[1][0] && (n = "(" + n + ")"), t3 + n;
    }
    if ("angle" === t2) {
      let e3 = r.every(((e4) => {
        if ("string" == typeof e4 && 1 === e4.length) return true;
        if (!Array.isArray(e4)) return false;
        let t3 = e4[0];
        return "_" === t3 || "^" === t3 || "prime" === t3;
      }));
      return this.operators[t2](r.map((function(e4, t3) {
        return this.statement(e4);
      }).bind(this)), e3);
    }
    return "+" === t2 && 2 === e2.length ? "+ " + this.factor(e2[1]) : "(" + this.statement(e2) + ")";
  }
  factorWithParenthesesIfNegatedOrExplicitPlus(e2) {
    var t2 = this.factor(e2);
    return t2.match(/^-/) || t2.match(/^\+/) ? "(" + t2 + ")" : t2;
  }
  termWithPlusIfNotNegated(e2) {
    let t2 = this.term(e2);
    return t2.match(/^-/) ? t2.match(/^-[^ ]/) ? "- " + t2.slice(1) : t2 : "+ " + t2;
  }
};
var astToText$1$1 = new astToText$2$1();
function subscripts_to_strings$1(e2, t2 = false) {
  var r = get_tree$1(e2);
  if (!Array.isArray(r)) return r;
  let n = r[0], i2 = r.slice(1);
  return "_" === n && (t2 || i2.every(((e3) => ["number", "string"].includes(typeof e3)))) ? astToText$1$1.convert(r) : [n].concat(i2.map(((e3) => subscripts_to_strings$1(e3, t2))));
}
function strings_to_subscripts$1(e2) {
  var t2 = get_tree$1(e2);
  if ("string" == typeof t2) {
    let e3 = t2.match(/^([0-9a-zA-Z]+)_([a-zA-Z]+|[0-9]+)$/);
    if (e3) {
      let t3 = Number(e3[1]);
      isNaN(t3) && (t3 = e3[1]);
      let r2 = Number(e3[2]);
      return isNaN(r2) && (r2 = e3[2]), ["_", t3, r2];
    }
    return t2;
  }
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  return [r].concat(n.map(strings_to_subscripts$1));
}
var normalization$1 = Object.freeze({ __proto__: null, normalize_function_names: normalize_function_names$1, normalize_applied_functions: normalize_applied_functions$1, log_subscript_to_two_arg_log: log_subscript_to_two_arg_log$1, substitute_abs: substitute_abs$1, default_order: default_order$1, constants_to_floats: constants_to_floats$1, normalize_angle_linesegment_arg_order: normalize_angle_linesegment_arg_order$1, normalize_negative_numbers: normalize_negative_numbers$1, tuples_to_vectors: tuples_to_vectors$1, to_intervals: to_intervals$1, altvectors_to_vectors: altvectors_to_vectors$1, subscripts_to_strings: subscripts_to_strings$1, strings_to_subscripts: strings_to_subscripts$1 }), astToText$3 = new astToText$2$1();
function generate_random_integer$1(e2, t2, r) {
  return e2 = math$1$1.ceil(e2), t2 = math$1$1.floor(t2), math$1$1.floor(r() * (t2 - e2 + 1)) + e2;
}
const equals$6$1 = function({ expr: e2, other: t2, randomBindings: r, expr_context: n, other_context: i2, relative_tolerance: a = 1e-12, absolute_tolerance: o = 0, tolerance_for_zero: s = 1e-15, allowed_error_in_numbers: u = 0, include_error_in_number_exponents: c2 = false, allowed_error_is_absolute: l = false, coerce_tuples_arrays: f2 = true, coerce_vectors: p = true, rng: m }) {
  if (Array.isArray(e2.tree) && Array.isArray(t2.tree)) {
    let d = e2.tree[0], h = e2.tree.slice(1), g = t2.tree[0], y = t2.tree.slice(1);
    if ("tuple" === d || "vector" === d || "altvector" === d || "list" === d || "array" === d || "matrix" === d || "interval" === d) {
      if (g !== d && ({ operator1: d, operator2: g, operands1: h, operands2: y } = coerce_tuple_array_vectors$1({ operator1: d, operator2: g, operands1: h, operands2: y, coerce_tuples_arrays: f2, coerce_vectors: p })), g !== d) return false;
      if (y.length !== h.length) return false;
      for (let e3 = 0; e3 < h.length; e3++) if (!equals$6$1({ expr: n.fromAst(h[e3]), other: i2.fromAst(y[e3]), randomBindings: r, expr_context: n, other_context: i2, relative_tolerance: a, absolute_tolerance: o, tolerance_for_zero: s, allowed_error_in_numbers: u, include_error_in_number_exponents: c2, allowed_error_is_absolute: l, coerce_tuples_arrays: f2, coerce_vectors: p, rng: m })) return false;
      return true;
    }
    if (2 === h.length && ["=", ">", "<", "ge", "le"].includes(d)) {
      if (2 !== y.length) return false;
      if (">" === d ? (d = "<", h = [h[1], h[0]]) : "ge" === d && (d = "le", h = [h[1], h[0]]), ">" === g ? (g = "<", y = [y[1], y[0]]) : "ge" === g && (g = "le", y = [y[1], y[0]]), d !== g) return false;
      let e3 = ["+", h[0], ["-", h[1]]], t3 = ["+", y[0], ["-", y[1]]], v2 = "=" !== d;
      return component_equals$1$1({ expr: n.fromAst(e3), other: i2.fromAst(t3), randomBindings: r, expr_context: n, other_context: i2, allow_proportional: true, require_positive_proportion: v2, relative_tolerance: a, absolute_tolerance: o, tolerance_for_zero: s, allowed_error_in_numbers: u, include_error_in_number_exponents: c2, allowed_error_is_absolute: l, coerce_tuples_arrays: f2, coerce_vectors: p, rng: m });
    }
  }
  return component_equals$1$1({ expr: e2, other: t2, randomBindings: r, expr_context: n, other_context: i2, relative_tolerance: a, absolute_tolerance: o, tolerance_for_zero: s, allowed_error_in_numbers: u, include_error_in_number_exponents: c2, allowed_error_is_absolute: l, coerce_tuples_arrays: f2, coerce_vectors: p, rng: m });
}, component_equals$1$1 = function({ expr: e2, other: t2, randomBindings: r, expr_context: n, other_context: i2, allow_proportional: a = false, require_positive_proportion: o = false, relative_tolerance: s, absolute_tolerance: u, tolerance_for_zero: c2, allowed_error_in_numbers: l, include_error_in_number_exponents: f2, allowed_error_is_absolute: p, coerce_tuples_arrays: m, coerce_vectors: d, rng: h }) {
  var g, y, v2, x2 = 1e-20 * Number.MAX_VALUE;
  ({ variables: g, integer_variables: y, functions: v2, expr: e2, other: t2 } = prepare_exprs_numerical_eval$1(e2, t2, n, i2));
  try {
    var b2 = e2.f(), _2 = t2.f();
  } catch (a2) {
    if (e2.equalsViaSyntax(t2, { allow_blanks: true, allowed_error_in_numbers: l, include_error_in_number_exponents: f2, allowed_error_is_absolute: p, coerce_tuples_arrays: m, coerce_vectors: d })) return true;
    if (!Array.isArray(e2.tree) || !Array.isArray(t2.tree)) return false;
    if (e2.tree[0] !== t2.tree[0]) return false;
    let o2 = e2.tree.slice(1), g2 = t2.tree.slice(1);
    for (let e3 = 0; e3 < o2.length; e3++) if (!equals$6$1({ expr: n.fromAst(o2[e3]), other: i2.fromAst(g2[e3]), randomBindings: r, expr_context: n, other_context: i2, relative_tolerance: s, absolute_tolerance: u, tolerance_for_zero: c2, allowed_error_in_numbers: l, include_error_in_number_exponents: f2, allowed_error_is_absolute: p, coerce_tuples_arrays: m, coerce_vectors: d, rng: h })) return false;
    return true;
  }
  let w2, A2, N;
  if (l > 0) {
    let t3 = replace_numbers_with_parameters$1({ expr: e2, variables: g, include_exponents: f2 });
    w2 = n.fromAst(t3.expr_with_params), A2 = t3.parameters;
    let r2 = Object.keys(A2);
    if (r2.length > 0) {
      let e3 = w2.derivative(r2[0]);
      if (p || (e3 = e3.multiply(A2[r2[0]])), r2.length > 1) for (let t5 of r2.slice(1)) {
        let r3 = w2.derivative(t5);
        p || (r3 = r3.multiply(A2[t5])), e3 = e3.add(r3);
      }
      let t4 = e3.multiply(l);
      try {
        N = t4.f();
      } catch (e4) {
      }
    }
  }
  var D = [10, 1, 100, 0.1, 1e3, 0.01], E = 0;
  let $2 = 0, S2 = true, C2 = 0;
  for (let e3 = 0; e3 < 1e3; e3++) {
    try {
      var M2 = T2(D[E], h);
    } catch (e4) {
      continue;
    }
    if (false === M2.always_zero && (S2 = false), !M2.equal && !M2.out_of_bounds && !M2.always_zero && false !== M2.sufficient_finite_values && (C2++, C2 > 100)) return false;
    if (M2.equal) {
      if (M2.always_zero) {
        if (!S2) continue;
        if ($2 += 1, $2 > 5 && (E += 1, $2 = 0), E >= D.length) return true;
        continue;
      }
      return true;
    }
  }
  return false;
  function T2(e3, t3) {
    var n3, i3 = r(t3, g, e3);
    for (let e4 = 0; e4 < y.length; e4++) i3[y[e4]] = generate_random_integer$1(-10, 10, t3);
    for (let e4 = 0; e4 < v2.length; e4++) {
      let r2 = 1 * (t3() - 0.5), n4 = 2 * (t3() - 0.5), a2 = 6 * (t3() - 0.5), o2 = 24 * (t3() - 0.5);
      i3[v2[e4]] = function(e5) {
        return math$1$1.add(math$1$1.multiply(math$1$1.add(math$1$1.multiply(math$1$1.add(math$1$1.multiply(r2, e5), n4), e5), a2), e5), o2);
      };
    }
    N && (n3 = Object.assign({}, i3, A2));
    var l2 = b2(i3), f3 = _2(i3);
    if ("boolean" == typeof l2 || "boolean" == typeof f3) return { out_of_bounds: true, always_zero: false };
    var p2 = math$1$1.abs(l2), m2 = math$1$1.abs(f3);
    if (!(p2 < x2 && m2 < x2)) return { out_of_bounds: true, always_zero: false };
    if (!(0 === p2 || p2 > 0) || !(0 === m2 || m2 > 0)) return { out_of_bounds: true, always_zero: false };
    var d2 = Math.min(p2, m2), h2 = Math.max(p2, m2), w3 = 1;
    let D2 = 0;
    if (N) {
      try {
        D2 = math$1$1.abs(N(n3));
      } catch (e4) {
        return { equal_at_start: false, always_zero: false };
      }
      if (!Number.isFinite(D2)) return { equal_at_start: false, always_zero: false };
    }
    if (D2 += d2 * s, D2 = Math.min(D2, 0.1 * d2), D2 += 0 !== D2 || 0 !== l2 && 0 !== f3 ? u : c2, !(0 === h2 || math$1$1.abs(math$1$1.subtract(l2, f3)) < D2)) {
      if (!a) return { equal_at_start: false, always_zero: false };
      if (0 === p2 || 0 === m2) return { equal_at_start: false, always_zero: false };
      if (w3 = math$1$1.divide(l2, f3), o && !(w3 > 0)) return { equal_at_start: false, always_zero: false };
    }
    var E2 = 0 === h2, $3 = 0;
    for (let e4 = 0; e4 < 100; e4++) {
      var S3, C3 = r(t3, g, 0.01, i3);
      for (let e5 = 0; e5 < y.length; e5++) C3[y[e5]] = generate_random_integer$1(-10, 10, t3);
      for (let e5 = 0; e5 < v2.length; e5++) {
        let r2 = 1 * (t3() - 0.5), n4 = 2 * (t3() - 0.5), i4 = 6 * (t3() - 0.5), a2 = 24 * (t3() - 0.5);
        C3[v2[e5]] = function(e6) {
          return math$1$1.add(math$1$1.multiply(math$1$1.add(math$1$1.multiply(math$1$1.add(math$1$1.multiply(r2, e6), n4), e6), i4), e6), a2);
        };
      }
      N && (S3 = Object.assign({}, C3, A2));
      try {
        l2 = b2(C3), f3 = math$1$1.multiply(_2(C3), w3);
      } catch (e5) {
        continue;
      }
      if (p2 = math$1$1.abs(l2), m2 = math$1$1.abs(f3), p2 < x2 && m2 < x2) {
        d2 = Math.min(p2, m2), h2 = Math.max(p2, m2), $3++;
        let e5 = 0;
        if (N) {
          try {
            e5 = math$1$1.abs(N(S3));
          } catch (e6) {
            continue;
          }
          if (!Number.isFinite(e5)) continue;
        }
        if (e5 += d2 * s, e5 = Math.min(e5, 0.1 * d2), e5 += 0 !== e5 || 0 !== l2 && 0 !== f3 ? u : c2, !(0 === h2 || math$1$1.abs(math$1$1.subtract(l2, f3)) < e5)) return { equality_in_middle: false, always_zero: false };
        if (E2 = E2 && 0 === h2, $3 >= 10) return { equal: true, always_zero: E2 };
      }
    }
    return { sufficient_finite_values: false, always_zero: E2 };
  }
};
function prepare_exprs_numerical_eval$1(e2, t2, r, n) {
  r || (r = e2.context), n || (n = t2.context), { expr: e2, other: t2 } = normalize_for_equality_checking$1(e2, t2, r, n);
  var i2 = [.../* @__PURE__ */ new Set([...e2.variables(), ...t2.variables()])];
  math$1$1.define_pi && (i2 = i2.filter((function(e3) {
    return "pi" !== e3;
  }))), math$1$1.define_i && (i2 = i2.filter((function(e3) {
    return "i" !== e3;
  }))), math$1$1.define_e && (i2 = i2.filter((function(e3) {
    return "e" !== e3;
  })));
  var a = [];
  for (let e3 = 0; e3 < i2.length; e3++) (is_integer_ast$1(i2[e3], r.assumptions) || is_integer_ast$1(i2[e3], n.assumptions)) && a.push(i2[e3]);
  var o = [.../* @__PURE__ */ new Set([...e2.functions(), ...t2.functions()])].filter(((e3) => 1 === e3.length || e3.includes("_") || e3.includes("^"))), s = o.filter(((e3) => i2.includes(e3)));
  if (o = o.filter(((e3) => !i2.includes(e3))), s.length > 0) {
    let a2 = e2.tree, u = t2.tree, c2 = "x1";
    for (; [...o, ...i2].includes(c2); ) c2 += "x1";
    let l = "x2";
    for (; [...o, ...i2].includes(l); ) l += "x2";
    for (let e3 of s) {
      let t3 = e3 + e3;
      for (; [...o, ...i2].includes(t3); ) t3 += e3;
      let r2 = [[["apply", e3, c2], ["apply", t3, c2], { variables: { [c2]: true } }]];
      a2 = applyAllTransformations$1(a2, r2), u = applyAllTransformations$1(u, r2), o.push(t3);
    }
    e2 = r.fromAst(a2), t2 = n.fromAst(u);
  }
  return { variables: i2, integer_variables: a, functions: o, expr: e2, other: t2 };
}
function normalize_for_equality_checking$1(e2, t2, r, n) {
  r || (r = e2.context), n || (n = t2.context), e2 = e2.normalize_function_names(), t2 = t2.normalize_function_names(), e2 = e2.log_subscript_to_two_arg_log(), t2 = t2.log_subscript_to_two_arg_log(), e2 = e2.subscripts_to_strings(), t2 = t2.subscripts_to_strings(), e2 = e2.normalize_applied_functions(), t2 = t2.normalize_applied_functions();
  let i2 = rename_functions_with_exponents$1(e2.tree), a = rename_functions_with_exponents$1(t2.tree);
  return { expr: e2 = r.fromAst(rename_vecs$1(i2)), other: t2 = n.fromAst(rename_vecs$1(a)) };
}
function replace_numbers_with_parameters$1({ expr: e2, variables: t2, include_exponents: r = false }) {
  let n = {}, i2 = 0;
  function a() {
    i2++;
    let e3 = "par" + i2;
    for (; t2.includes(e3); ) i2++, e3 = "par" + i2;
    return e3;
  }
  return { expr_with_params: (function e3(t3) {
    if ("number" == typeof t3) {
      if (0 === t3) return t3;
      {
        let e4 = a();
        return n[e4] = t3, e4;
      }
    }
    if ("string" == typeof t3) {
      if ("pi" === t3) {
        if (math$1$1.define_pi) {
          let e4 = a();
          return n[e4] = math$1$1.PI, e4;
        }
      } else if ("e" === t3 && math$1$1.define_e) {
        let e4 = a();
        return n[e4] = math$1$1.e, e4;
      }
      return t3;
    }
    if (!Array.isArray(t3)) return t3;
    let i3 = t3[0], o = t3.slice(1);
    return "^" !== i3 || r ? [i3, ...o.map(e3)] : [i3, e3(o[0]), o[1]];
  })((e2 = e2.evaluate_numbers({ max_digits: 1 / 0 })).tree), parameters: n };
}
function rename_functions_with_exponents$1(e2) {
  if (!Array.isArray(e2)) return e2;
  let t2 = e2[0], r = e2.slice(1);
  if ("apply" === t2) {
    let e3 = r[0];
    return Array.isArray(e3) && "^" === e3[0] && e3.slice(1).every(((e4) => ["number", "string"].includes(typeof e4))) && (e3 = astToText$3.convert(e3)), ["apply", e3, r[1]];
  }
  return [t2, ...r.map(rename_functions_with_exponents$1)];
}
function rename_vecs$1(e2) {
  if (!Array.isArray(e2)) return e2;
  let t2 = e2[0], r = e2.slice(1);
  return "vec" === t2 && 1 === r.length ? "__vec_" + astToText$3.convert(r[0]) : [t2, ...r.map(rename_vecs$1)];
}
function randomComplexBindings$1(e2, t2, r, n) {
  var i2 = {};
  return void 0 === n ? t2.forEach((function(t3) {
    i2[t3] = math$1$1.complex(2 * e2() * r - r, 2 * e2() * r - r);
  })) : t2.forEach((function(t3) {
    i2[t3] = math$1$1.complex(n[t3].re + 2 * e2() * r - r, n[t3].im + 2 * e2() * r - r);
  })), i2;
}
const equals$5$1 = function(e2, t2, { relative_tolerance: r = 1e-12, absolute_tolerance: n = 0, tolerance_for_zero: i2 = 1e-15, allowed_error_in_numbers: a = 0, include_error_in_number_exponents: o = false, allowed_error_is_absolute: s = false, allow_blanks: u = false, coerce_tuples_arrays: c2 = true, coerce_vectors: l = true } = {}) {
  if (!u && (e2.variables().includes("＿") || t2.variables().includes("＿"))) return false;
  let f2 = seedrandom$1$1("complex_seed");
  return e2 = e2.remove_scaling_units(), t2 = t2.remove_scaling_units(), equals$6$1({ expr: e2, other: t2, randomBindings: randomComplexBindings$1, expr_context: e2.context, other_context: t2.context, relative_tolerance: r, absolute_tolerance: n, tolerance_for_zero: i2, allowed_error_in_numbers: a, include_error_in_number_exponents: o, allowed_error_is_absolute: s, coerce_tuples_arrays: c2, coerce_vectors: l, rng: f2 });
};
function randomRealBindings$1(e2, t2, r, n) {
  var i2 = {};
  return void 0 === n ? t2.forEach((function(t3) {
    i2[t3] = 2 * e2() * r - r;
  })) : t2.forEach((function(t3) {
    i2[t3] = n[t3] + 2 * e2() * r - r;
  })), i2;
}
const equals$4$1 = function(e2, t2, { relative_tolerance: r = 1e-12, absolute_tolerance: n = 0, tolerance_for_zero: i2 = 1e-15, allowed_error_in_numbers: a = 0, include_error_in_number_exponents: o = false, allowed_error_is_absolute: s = false } = {}) {
  if (!e2.isAnalytic() || !t2.isAnalytic()) return false;
  let u = seedrandom("real_seed");
  return equals$6$1({ expr: e2, other: t2, randomBindings: randomRealBindings$1, expr_context: e2.context, other_content: t2.context, relative_tolerance: r, absolute_tolerance: n, tolerance_for_zero: i2, allowed_error_in_numbers: a, include_error_in_number_exponents: o, allowed_error_is_absolute: s, rng: u });
}, equals$3$1 = function(e2, t2, { allowed_error_in_numbers: r = 0, include_error_in_number_exponents: n = false, allowed_error_is_absolute: i2 = false, allow_blanks: a = false, coerce_tuples_arrays: o = true, coerce_vectors: s = true } = {}) {
  if (!a && (e2.variables().includes("＿") || t2.variables().includes("＿"))) return false;
  let u = e2.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order(), c2 = t2.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order();
  return equal$1(u.tree, c2.tree, { allowed_error_in_numbers: r, include_error_in_number_exponents: n, allowed_error_is_absolute: i2, coerce_tuples_arrays: o, coerce_vectors: s });
};
function randomFiniteFieldBindings$1(e2, t2, r) {
  var n = {};
  return t2.forEach((function(t3) {
    n[t3] = Math.floor(e2() * r);
  })), n;
}
const equals$2$1 = function(e2, t2, { allow_blanks: r = false, coerce_tuples_arrays: n = true, coerce_vectors: i2 = true } = {}) {
  if (!r && (e2.variables().includes("＿") || t2.variables().includes("＿"))) return false;
  let a = seedrandom$1$1("finite_field_seed");
  if (Array.isArray(e2.tree) && Array.isArray(t2.tree)) {
    let r2 = e2.tree[0], f2 = e2.tree.slice(1), p = t2.tree[0], m = t2.tree.slice(1);
    if ("tuple" === r2 || "vector" === r2 || "altvector" === r2 || "list" === r2 || "array" === r2 || "matrix" === r2 || "interval" === r2) {
      if (p !== r2 && ({ operator1: r2, operator2: p, operands1: f2, operands2: m } = coerce_tuple_array_vectors$1({ operator1: r2, operator2: p, operands1: f2, operands2: m, coerce_tuples_arrays: n, coerce_vectors: i2 })), p !== r2) return false;
      if (m.length !== f2.length) return false;
      for (let r3 = 0; r3 < f2.length; r3++) if (false === equals$2$1(e2.context.fromAst(f2[r3]), t2.context.fromAst(m[r3]), a)) return false;
      return;
    }
    if (2 === f2.length && ["=", ">", "<", "ge", "le"].includes(r2)) {
      if (2 !== m.length) return false;
      if (">" === r2 ? (r2 = "<", f2 = [f2[1], f2[0]]) : "ge" === r2 && (r2 = "le", f2 = [f2[1], f2[0]]), ">" === p ? (p = "<", m = [m[1], m[0]]) : "ge" === p && (p = "le", m = [m[1], m[0]]), r2 !== p) return false;
      let n3 = ["+", f2[0], ["-", f2[1]]], i3 = ["+", m[0], ["-", m[1]]], d = "=" !== r2, h = e2.context.fromAst(n3), g = t2.context.fromAst(i3);
      try {
        let e3 = prepare_exprs_numerical_eval$1(h, g);
        if (0 === e3.functions.length) {
          var o = e3.expr.f(), s = e3.other.f();
          let r3 = 1e-20 * Number.MAX_VALUE;
          for (let n4 = 0; n4 < 10; n4++) {
            var u = {};
            e3.variables.forEach((function(e4) {
              u[e4] = 2 * a() - 1;
            }));
            for (let t3 = 0; t3 < e3.integer_variables.length; t3++) u[e3.integer_variables[t3]] = math$1$1.floor(21 * a()) - 10;
            let n5 = o(u), f3 = s(u);
            var c2 = math$1$1.abs(n5), l = math$1$1.abs(f3);
            if (!(c2 < r3 && l < r3)) continue;
            if (0 == c2 || 0 === l) continue;
            let p2 = math$1$1.divide(n5, f3);
            if (d && !(p2 > 0)) return false;
            if (1 !== p2) {
              const e4 = rationalApproximation$1(p2);
              g = t2.context.fromAst(["*", ["/", e4.numerator, e4.denominator], i3]);
            }
            break;
          }
        }
      } catch (e3) {
        return;
      }
      return component_equals$2(h, g, a);
    }
  }
  return component_equals$2(e2, t2, a);
}, component_equals$2 = function(e2, t2, r) {
  ({ expr: e2, other: t2 } = normalize_for_equality_checking$1(e2, t2));
  let n = [1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231];
  var i2 = [.../* @__PURE__ */ new Set([...e2.variables(), ...t2.variables()])];
  for (let a of n) {
    let n3 = randomFiniteFieldBindings$1(r, i2, a);
    try {
      let r2 = e2.finite_field_evaluate(n3, a), i3 = t2.finite_field_evaluate(n3, a);
      if (!r2.approximate && !i3.approximate && !r2.isNaN() && !i3.isNaN() && r2.values.length > 0 && i3.values.length > 0 && !r2.equals(i3)) return false;
    } catch (e3) {
      return;
    }
  }
}, equals$1$1 = function(e2, t2, { min_elements_match: r = 3, match_partial: n = false } = {}) {
  if (!is_discrete_infinite_set$1(e2)) return false;
  if (is_discrete_infinite_set$1(t2)) {
    var i2 = [];
    let r2 = e2.context.get_assumptions(e2);
    if (void 0 !== r2 && i2.push(r2), r2 = t2.context.get_assumptions(t2), void 0 !== r2 && i2.push(r2), i2 = 0 === i2.length ? void 0 : 1 === i2.length ? i2[0] : clean_assumptions$1(["and"].concat(i2)), n) {
      let r3 = contained_in$1(e2.tree, t2.tree, i2, n);
      if (false === r3) return 0;
      let a = contained_in$1(t2.tree, e2.tree, i2, n);
      return false === a ? 0 : true === r3 ? true === a ? 1 : a : true === a ? r3 : Math.min(r3, a);
    }
    return contained_in$1(e2.tree, t2.tree, i2, n) && contained_in$1(t2.tree, e2.tree, i2, n);
  }
  {
    let n3 = t2.tree;
    if ("list" !== n3[0]) return false;
    let i3 = n3.length - 2;
    if ("ldots" !== n3[i3 + 1][0]) return false;
    if (i3 < r) return false;
    let a = n3.slice(0, i3 + 1), o = sequence_from_discrete_infinite$1(e2, i3);
    return !!o && (o = ["list"].concat(o), equals$7(e2.context.from(o), t2.context.from(a)));
  }
};
function is_discrete_infinite_set$1(e2) {
  var t2 = e2.tree;
  if (!Array.isArray(t2)) return false;
  if ("discrete_infinite_set" !== t2[0]) return false;
  var r = t2.slice(1);
  for (var n of r) {
    if (!Array.isArray(n)) return false;
    if ("tuple" !== n[0]) return false;
    if (5 !== n.length) return false;
  }
  return true;
}
function contained_in$1(e2, t2, r, n) {
  if ("discrete_infinite_set" === e2[0]) {
    if (n) {
      let i3 = 0;
      for (let a3 of e2.slice(1)) {
        let e3 = contained_in$1(a3, t2, r, n);
        true === e3 ? i3++ : false !== e3 && (i3 += e3);
      }
      let a2 = e2.length - 1;
      return i3 === a2 || 0 !== i3 && i3 / a2;
    }
    return e2.slice(1).every(((e3) => contained_in$1(e3, t2, r)));
  }
  var i2 = e2[1], a = e2[2], o = evaluate_numbers$1(e2[3], r), s = e2[4];
  if (o !== -1 / 0 || s !== 1 / 0) return false;
  i2 = simplify$2(["/", i2, a], r, 1 / 0);
  var u = t2.slice(1), c2 = [];
  for (let e3 = 0; e3 < u.length; e3++) {
    let t3 = evaluate_numbers$1(u[e3][3]), n3 = u[e3][4];
    if (t3 !== -1 / 0 || n3 !== 1 / 0) return false;
    let i3 = simplify$2(["/", u[e3][1], a], r, 1 / 0), o2 = simplify$2(["/", u[e3][2], a], r, 1 / 0);
    if ("number" != typeof o2) return false;
    let s2 = math$1$1.fraction(o2), l2 = math$1$1.number(s2.n), f3 = math$1$1.number(s2.d);
    c2.push([l2, f3, i3, o2]);
  }
  for (c2.sort(); ; ) {
    if (1 !== c2[0][0]) break;
    let e3 = c2[0][2], t3 = c2[0][3], n3 = simplify$2(expand$1(["+", e3, ["-", i2]]), r, 1 / 0);
    if (Number.isFinite(n3) && Number.isFinite(t3) && (n3 = math$1$1.mod(n3, t3), math$1$1.min(n3, t3 - n3) < 1e-10 * t3)) return true;
    if (c2.splice(0, 1), 0 === c2.length) return false;
  }
  var l = [...new Set(c2.map(((e3) => e3[0])))];
  let f2 = 0;
  for (let e3 of l) {
    let t3 = c2.map((function(t4, r2) {
      if (0 === math$1$1.mod(e3, t4[0])) {
        let n3 = e3 / t4[0];
        return [t4[0], n3, r2];
      }
    })).filter(((e4) => e4)), a2 = [];
    for (let n3 of t3) {
      let t4 = n3[0], o2 = n3[1], s2 = n3[2], u2 = c2[s2][2], l2 = c2[s2][3];
      for (let n4 = 0; n4 < t4; n4++) {
        let s3 = simplify$2(expand$1(["+", u2, ["-", ["+", i2, n4]]]), r, 1 / 0);
        if (Number.isFinite(s3) && Number.isFinite(l2) && (s3 = math$1$1.mod(s3, l2), math$1$1.min(s3, l2 - s3) < 1e-10 * l2)) {
          for (let e4 = 0; e4 < o2; e4++) a2[n4 + e4 * t4] = true;
          let r2 = true;
          for (let t5 = 0; t5 < e3; t5++) if (!a2[t5]) {
            r2 = false;
            break;
          }
          if (r2) return true;
          break;
        }
      }
    }
    if (n) {
      let t4 = 0;
      for (let r2 = 0; r2 < e3; r2++) a2[r2] && t4++;
      t4 /= e3, t4 > f2 && (f2 = t4);
    }
  }
  return !!(n && f2 > 0) && f2;
}
function sequence_from_discrete_infinite$1(e2, t2) {
  var r = e2.tree.slice(1);
  if (r.length > 1) return;
  let n = r[0][1], i2 = r[0][2], a = evaluate_numbers$1(r[0][3]), o = r[0][4];
  if (!Number.isInteger(a) || o !== 1 / 0) return;
  let s = [];
  for (let e3 = 0; e3 < t2; e3++) s.push(evaluate_numbers$1(["+", ["*", i2, a + e3], n]));
  return s;
}
const equals$7 = function(e2, t2, { relative_tolerance: r = 1e-12, absolute_tolerance: n = 0, tolerance_for_zero: i2 = 1e-15, allowed_error_in_numbers: a = 0, include_error_in_number_exponents: o = false, allowed_error_is_absolute: s = false, allow_blanks: u = false, coerce_tuples_arrays: c2 = true, coerce_vectors: l = true } = {}) {
  if (!u && (e2.variables().includes("＿") || t2.variables().includes("＿"))) return false;
  let f2 = e2.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify(), p = t2.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify();
  return !!f2.equalsViaSyntax(p, { allowed_error_in_numbers: a, include_error_in_number_exponents: o, allowed_error_is_absolute: s, allow_blanks: true, coerce_tuples_arrays: c2, coerce_vectors: l }) || (0 !== a || 0 != e2.equalsViaFiniteField(t2, { allow_blanks: true, coerce_tuples_arrays: c2, coerce_vectors: l })) && (!!e2.equalsViaComplex(t2, { relative_tolerance: r, absolute_tolerance: n, tolerance_for_zero: i2, allowed_error_in_numbers: a, include_error_in_number_exponents: o, allowed_error_is_absolute: s, allow_blanks: true, coerce_tuples_arrays: c2, coerce_vectors: l }) || !!equals$1$1(e2, t2));
};
var equality$1 = Object.freeze({ __proto__: null, equals: equals$7, equalsViaComplex: equals$5$1, equalsViaReal: equals$4$1, equalsViaSyntax: equals$3$1, equalsViaFiniteField: equals$2$1, equalsDiscreteInfinite: equals$1$1 });
const equalWithSignErrors$1 = function(e2, t2, { equalityFunction: r = equals$7, max_sign_errors: n = 1 } = {}) {
  if (r(e2, t2)) return { matched: true, n_sign_errors: 0 };
  for (let i2 = 1; i2 <= n; i2++) if (equalSpecifiedSignErrors$1(e2, t2, { equalityFunction: r, n_sign_errors: i2 })) return { matched: true, n_sign_errors: i2 };
  return { matched: false };
}, equalSpecifiedSignErrors$1 = function(e2, t2, { equalityFunction: r = c, n_sign_errors: n = 1 } = {}) {
  if (0 === n) return r(e2, t2);
  if (!(Number.isInteger(n) && n > 0)) throw Error(`Have not implemented equality check with ${n} sign errors.`);
  if (n > 1) {
    let e3 = r;
    r = function(t3, r2) {
      return equalSpecifiedSignErrors$1(t3, r2, { equalityFunction: e3, n_sign_errors: n - 1 });
    };
  }
  var i2, a, o = e2.tree, s = [[o]], u = 0;
  e2.tree = ["-", o];
  var c2 = r(e2, t2);
  if (e2.tree = o, c2) return true;
  for (; i2 = s[u++]; ) if (i2 = i2[0], Array.isArray(i2)) {
    for (a = 1; a < i2.length; a++) if (s.push([i2[a]]), i2[a] = ["-", i2[a]], c2 = r(e2, t2), i2[a] = i2[a][1], c2) return true;
  }
  return false;
};
var sign_error$1 = Object.freeze({ __proto__: null, equalSpecifiedSignErrors: equalSpecifiedSignErrors$1, equalWithSignErrors: equalWithSignErrors$1 });
function add$3(e2, t2) {
  return clean$2(["+", get_tree$1(e2), get_tree$1(t2)]);
}
function subtract$1(e2, t2) {
  return clean$2(["+", get_tree$1(e2), ["-", get_tree$1(t2)]]);
}
function multiply$1(e2, t2) {
  return clean$2(["*", get_tree$1(e2), get_tree$1(t2)]);
}
function divide$2(e2, t2) {
  return clean$2(["/", get_tree$1(e2), get_tree$1(t2)]);
}
function pow$2(e2, t2) {
  return clean$2(["^", get_tree$1(e2), get_tree$1(t2)]);
}
function mod$2(e2, t2) {
  return clean$2(["apply", "mod", ["tuple", get_tree$1(e2), get_tree$1(t2)]]);
}
function copy$1(e2) {
  return get_tree$1(e2);
}
var arithmetic$1 = Object.freeze({ __proto__: null, add: add$3, subtract: subtract$1, multiply: multiply$1, divide: divide$2, pow: pow$2, mod: mod$2, copy: copy$1 }), analytic_operators$1 = ["+", "-", "*", "/", "^", "tuple", "vector", "altvector", "list", "array", "matrix", "interval", "vec"], non_analytic_functions$1 = ["abs", "sign", "arg"], relation_operators$1 = ["=", "le", "ge", "<", ">"];
function isAnalytic$1(e2, { allow_abs: t2 = false, allow_arg: r = false, allow_relation: n = false } = {}) {
  var i2 = normalize_applied_functions$1(normalize_function_names$1(e2)), a = operators$3$1(i2 = subscripts_to_strings$1(i2));
  for (let e3 = 0; e3 < a.length; e3++) {
    let t3 = a[e3];
    if (-1 === analytic_operators$1.indexOf(t3)) {
      if (!n) return false;
      if (-1 === relation_operators$1.indexOf(t3)) return false;
    }
  }
  var o = functions$2$1(i2);
  for (let e3 = 0; e3 < o.length; e3++) {
    let n3 = o[e3];
    if (non_analytic_functions$1.includes(n3) && !(t2 && "abs" == n3 || r && "arg" == n3)) return false;
  }
  return true;
}
var analytic$1 = Object.freeze({ __proto__: null, isAnalytic: isAnalytic$1 });
function create_discrete_infinite_set$1({ offsets: e2, periods: t2, min_index: r = ["-", 1 / 0], max_index: n = 1 / 0 } = {}) {
  if (e2 = get_tree$1(e2), t2 = get_tree$1(t2), r = get_tree$1(r), n = get_tree$1(n), void 0 === e2 || void 0 === t2) return;
  let i2 = [];
  if ("list" === e2[0]) if ("list" === t2[0]) {
    if (e2.length !== t2.length || 1 === e2.length) return;
    for (let a = 1; a < e2.length; a++) i2.push(["tuple", e2[a], t2[a], r, n]);
  } else for (let a = 1; a < e2.length; a++) i2.push(["tuple", e2[a], t2, r, n]);
  else i2.push(["tuple", e2, t2, r, n]);
  return ["discrete_infinite_set"].concat(i2);
}
var sets$1 = Object.freeze({ __proto__: null, create_discrete_infinite_set: create_discrete_infinite_set$1 });
function tuple$1(e2) {
  var t2 = [];
  t2.push("tuple");
  var r = e2.length;
  for (let n = 0; n < r; n++) t2.push(e2[n]);
  return t2;
}
function matrix$2(e2) {
  var t2 = [];
  t2.push("matrix");
  var r = e2.length, n = e2[0].length;
  for (let t3 = 1; t3 < r; t3++) if (e2[t3].length !== n) throw new Error("Matrix dimensions mismatch");
  t2.push(tuple$1([r, n]));
  let i2 = [];
  for (let t3 = 0; t3 < r; t3++) i2.push(tuple$1(e2[t3].map((function(e3) {
    return e3.tree;
  }))));
  return t2.push(tuple$1(i2)), t2;
}
function vector_add$1(e2, t2) {
  if (e2 = get_tree$1(e2), t2 = get_tree$1(t2), e2.length !== t2.length || "tuple" !== e2[0] && "vector" !== e2[0] && "altvector" !== e2[0] || "tuple" !== t2[0] && "vector" !== t2[0] && "altvector" !== t2[0]) throw new Error("Can't add. Those aren't vectors, or the dimensions don't match");
  var r = "altvector" === e2[0] && "altvector" === t2[0] ? ["altvector"] : ["vector"], n = e2.length;
  for (let i2 = 1; i2 < n; i2 += 1) r.push(["+", e2[i2], t2[i2]]);
  return simplify$2(r);
}
function scalar_mul$1(e2, t2) {
  if ("tuple" !== (t2 = get_tree$1(t2))[0] && "vector" !== t2[0] && "altvector" !== t2[0]) throw new Error("Can't scalar multiply. Isn't a vector");
  var r = "altvector" === t2[0] ? ["altvector"] : ["vector"], n = t2.length;
  for (let i2 = 1; i2 < n; i2 += 1) r.push(["*", t2[i2], e2]);
  return simplify$2(r);
}
function vector_sub$1(e2, t2) {
  return vector_add$1(e2, scalar_mul$1(-1, t2));
}
function dot_prod$1(e2, t2) {
  if (e2 = get_tree$1(e2), t2 = get_tree$1(t2), e2.length !== t2.length || "tuple" !== e2[0] && "vector" !== e2[0] && "altvector" !== e2[0] || "tuple" !== t2[0] && "vector" !== t2[0] && "altvector" !== t2[0]) throw new Error("Can't take dot product. Those aren't vectors, or the dimensions don't match");
  var r = 0, n = e2.length;
  for (let i2 = 1; i2 < n; i2 += 1) r = ["+", r, ["*", e2[i2], t2[i2]]];
  return simplify$2(r);
}
function cross_prod$1(e2, t2) {
  if (e2 = get_tree$1(e2), t2 = get_tree$1(t2), "tuple" !== e2[0] && "vector" !== e2[0] && "altvector" !== e2[0] || "tuple" !== t2[0] && "vector" !== t2[0] && "altvector" !== t2[0]) throw new Error("Can't take cross product. Those aren't vectors");
  if (3 === e2.length && 3 === t2.length) return simplify$2(["+", ["*", e2[1], t2[2]], ["-", ["*", e2[2], t2[1]]]]);
  if (4 === e2.length && 4 === t2.length) {
    var r = ["+", ["*", e2[2], t2[3]], ["-", ["*", e2[3], t2[2]]]], n = ["+", ["*", e2[3], t2[1]], ["-", ["*", e2[1], t2[3]]]], i2 = ["+", ["*", e2[1], t2[2]], ["-", ["*", e2[2], t2[1]]]];
    return simplify$2(["altvector" === e2[0] && "altvector" === t2[0] ? "altvector" : "vector", r, n, i2]);
  }
  throw new Error("Can't take cross product. The dimensions aren't both 2 or 3.");
}
var matrix$1$1 = Object.freeze({ __proto__: null, matrix: matrix$2, vector_add: vector_add$1, scalar_mul: scalar_mul$1, vector_sub: vector_sub$1, dot_prod: dot_prod$1, cross_prod: cross_prod$1 });
let astToGuppy$1$1 = class astToGuppy$12 {
  constructor() {
    this.operators = { "+": function(e2) {
      return e2.join("<e>+</e>");
    }, "-": function(e2) {
      return "<e>-" + e2.join("-") + "</e>";
    }, "*": function(e2) {
      return e2.join('<f type="*" group="operations" c="yes"><b p="latex">\\cdot</b><b p="text">*</b></f>');
    }, "/": function(e2) {
      return astToGuppy$12.dfrac(e2[0], e2[1]);
    }, "^": function(e2) {
      return astToGuppy$12.power(e2[0], e2[1]);
    }, sin: function(e2) {
      return astToGuppy$12.trig("sin", e2[0]);
    }, cos: function(e2) {
      return astToGuppy$12.trig("cos", e2[0]);
    }, tan: function(e2) {
      return astToGuppy$12.trig("tan", e2[0]);
    }, arcsin: function(e2) {
      return astToGuppy$12.trig("arcsin", e2[0]);
    }, arccos: function(e2) {
      return astToGuppy$12.trig("arccos", e2[0]);
    }, arctan: function(e2) {
      return astToGuppy$12.trig("arctan", e2[0]);
    }, arccsc: function(e2) {
      return astToGuppy$12.trig("arccsc", e2[0]);
    }, arcsec: function(e2) {
      return astToGuppy$12.trig("arcsec", e2[0]);
    }, arccot: function(e2) {
      return astToGuppy$12.trig("arccot", e2[0]);
    }, csc: function(e2) {
      return astToGuppy$12.trig("csc", e2[0]);
    }, sec: function(e2) {
      return astToGuppy$12.trig("sec", e2[0]);
    }, cot: function(e2) {
      return astToGuppy$12.trig("cot", e2[0]);
    }, log: function(e2) {
      return astToGuppy$12.trig("log", e2[0]);
    }, exp: function(e2) {
      return astToGuppy$12.trig("exp", e2[0]);
    }, ln: function(e2) {
      return astToGuppy$12.trig("ln", e2[0]);
    }, sqrt: function(e2) {
      return astToGuppy$12.sqrt(e2[0]);
    }, abs: function(e2) {
      return astToGuppy$12.abs(e2[0]);
    } };
  }
  static dfrac(e2, t2) {
    return '<f type="fraction" group="functions"><b p="latex">\\dfrac{<r ref="1"/>}{<r ref="2"/>}</b><b p="small_latex">\\frac{<r ref="1"/>}{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)/(<r ref="2"/>)</b><c up="1" down="2" name="numerator"><e></e>' + e2 + '<e></e></c><c up="1" down="2" name="denominator"><e></e>' + t2 + "<e></e></c></f>";
  }
  static trig(e2, t2) {
    return '<f type="' + e2 + '" group="functions"><b p="latex">\\' + e2 + '\\left(<r ref="1"/>\\right)</b><b p="text"> ' + e2 + '(<r ref="1"/>)</b><c delete="1"><e></e>' + t2 + "<e></e></c></f>";
  }
  static sqrt(e2) {
    return '<f type="square_root" group="functions"><b p="latex">\\sqrt{<r ref="1"/>}</b><b p="text">sqrt(<r ref="1"/>)</b><c delete="1"><e></e>' + e2 + "<e></e></c></f>";
  }
  static power(e2, t2) {
    return '<f type="exponential" group="functions"><b p="latex">{<r ref="1"/>}^{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)^(<r ref="2"/>)</b><c up="2" bracket="yes" delete="1" name="base"><e></e>' + e2 + '<e></e></c><c down="1" delete="1" name="exponent" small="yes"><e></e>' + t2 + "<e></e></c></f>";
  }
  static abs(e2) {
    return '<f type="absolute_value" group="functions"><b p="latex">\\left|<r ref="1"/>\\right|</b><b p="text">abs(<r ref="1"/>)</b><c delete="1"><e></e>' + e2 + "<e></e></c></f>";
  }
  static paren(e2) {
    return '<f type="bracket" group="functions"><b p="latex">\\left(<r ref="1"/>\\right)</b><b p="text">(<r ref="1"/>)</b><c delete="1" is_bracket="yes"><e></e>' + e2 + "<e></e></c></f>";
  }
  static isFunctionSymbol(e2) {
    return -1 !== ["sin", "cos", "tan", "csc", "sec", "cot", "arcsin", "arccos", "arctan", "arccsc", "arcsec", "arccot", "log", "ln", "exp", "sqrt", "abs", "this.factorial"].indexOf(e2);
  }
  static isGreekLetterSymbol(e2) {
    return -1 !== ["pi", "theta", "theta", "Theta", "alpha", "nu", "beta", "xi", "Xi", "gamma", "Gamma", "delta", "Delta", "pi", "Pi", "epsilon", "epsilon", "rho", "rho", "zeta", "sigma", "Sigma", "eta", "tau", "upsilon", "Upsilon", "iota", "phi", "phi", "Phi", "kappa", "chi", "lambda", "Lambda", "psi", "Psi", "omega", "Omega"].indexOf(e2);
  }
  factorWithParenthesesIfNegated(e2) {
    var t2 = this.factor(e2);
    return t2.toString().match(/^<e>-/) ? astToGuppy$12.paren(t2.toString()) : t2;
  }
  factor(e2) {
    if ("string" == typeof e2) return astToGuppy$12.isGreekLetterSymbol(e2) ? '<f type="' + e2 + '" group="greek" c="yes"><b p="latex">\\' + e2 + '</b><b p="text"> $' + e2 + "</b></f>" : "<e>" + e2 + "</e>";
    if ("number" == typeof e2) return "<e>" + e2 + "</e>";
    if (!Array.isArray(e2)) return "<e></e>";
    var t2 = e2[0], r = e2.slice(1);
    return "apply" === t2 && (t2 = e2[1], r = e2.slice(2)), "abs" === t2 ? this.operators[t2](r.map((function(e3, t3) {
      return this.expression(e3);
    }).bind(this))) : astToGuppy$12.isFunctionSymbol(t2) ? "this.factorial" !== t2 || 1 !== r[0].toString().length && !r[0].toString().match(/^[0-9]*$/) ? this.operators[t2](r.map((function(e3, t3) {
      return this.factor(e3);
    }).bind(this))) : this.operators[t2](r) : "^" === t2 || "~" === t2 ? this.operators[t2](r.map((function(e3, t3) {
      return this.factor(e3);
    }).bind(this))) : astToGuppy$12.paren(this.expression(e2));
  }
  term(e2) {
    if (!Array.isArray(e2)) return this.factor(e2);
    var t2 = e2[0], r = e2.slice(1);
    return "*" === t2 ? this.operators[t2](r.map((function(e3, t3) {
      var r2 = this.factorWithParenthesesIfNegated(e3);
      return r2.toString().match(/^[0-9]/) && t3 > 0 ? " * " + r2 : r2;
    }).bind(this))) : "/" === t2 ? this.operators[t2](r.map((function(e3, t3) {
      return this.factor(e3);
    }).bind(this))) : this.factor(e2);
  }
  expression(e2) {
    if (!Array.isArray(e2)) return this.term(e2);
    var t2 = e2[0], r = e2.slice(1);
    return "+" === t2 || "-" === t2 ? this.operators[t2](r.map((function(e3, t3) {
      return this.factorWithParenthesesIfNegated(e3);
    }).bind(this))) : this.term(e2);
  }
  convert(e2) {
    return ("<m><e></e>" + this.expression(e2) + "<e></e></m>").replace(/<\/e><e>/g, "");
  }
};
const glslOperators$1 = { "+": function(e2) {
  var t2 = e2[0];
  return e2.slice(1).forEach((function(e3) {
    t2 = t2 + "+" + e3;
  })), t2;
}, "-": function(e2) {
  var t2 = "-" + e2[0];
  return e2.slice(1).forEach((function(e3) {
    t2 = t2 + "-" + e3;
  })), t2;
}, "~": function(e2) {
  var t2 = "vec2(0.0,0.0)";
  return e2.forEach((function(e3) {
    t2 = t2 + "-" + e3;
  })), t2;
}, "*": function(e2) {
  var t2 = e2[0];
  return e2.slice(1).forEach((function(e3) {
    t2 = "cmul(" + t2 + "," + e3 + ")";
  })), t2;
}, "/": function(e2) {
  var t2 = e2[0];
  return e2.slice(1).forEach((function(e3) {
    t2 = "cdiv(" + t2 + "," + e3 + ")";
  })), t2;
}, sin: function(e2) {
  return "csin(" + e2[0] + ")";
}, cos: function(e2) {
  return "ccos(" + e2[0] + ")";
}, tan: function(e2) {
  return "ctan(" + e2[0] + ")";
}, sinh: function(e2) {
  return "csinh(" + e2[0] + ")";
}, cosh: function(e2) {
  return "ccosh(" + e2[0] + ")";
}, arcsin: function(e2) {
  return "carcsin(" + e2[0] + ")";
}, arccos: function(e2) {
  return "carccos(" + e2[0] + ")";
}, arctan: function(e2) {
  return "carctan(" + e2[0] + ")";
}, arccsc: function(e2) {
  return "carcsin(cdiv(vec2(1.0,0)," + e2[0] + "))";
}, arcsec: function(e2) {
  return "carccos(cdiv(vec2(1.0,0)," + e2[0] + "))";
}, arccot: function(e2) {
  return "carctan(cdiv(vec2(1.0,0)," + e2[0] + "))";
}, csc: function(e2) {
  return "ccsc(" + e2[0] + ")";
}, sec: function(e2) {
  return "csec(" + e2[0] + ")";
}, cot: function(e2) {
  return "ccot(" + e2[0] + ")";
}, exp: function(e2) {
  return "cexp(" + e2[0] + ")";
}, conj: function(e2) {
  return "conjugate(" + e2[0] + ")";
}, sqrt: function(e2) {
  return "cpower(" + e2[0] + ",vec2(0.5,0.0))";
}, log: function(e2) {
  return "clog(" + e2[0] + ")";
}, ln: function(e2) {
  return "clog(" + e2[0] + ")";
}, "^": function(e2) {
  return "cpower(" + e2[0] + "," + e2[1] + ")";
}, abs: function(e2) {
  return "cabs(" + e2[0] + ")";
}, apply: function(e2) {
  return "vec2(NaN,NaN)";
} };
let astToGLSL$1$1 = class astToGLSL$12 {
  constructor() {
  }
  convert(e2) {
    if ("boolean" == typeof e2) throw Error("no support for boolean");
    if ("string" == typeof e2) return "e" === e2 ? "vec2(2.71828182845905,0.0)" : "pi" === e2 ? "vec2(3.14159265358979,0.0)" : "i" === e2 ? "vec2(0.0,1.0)" : String(e2);
    if ("number" == typeof e2) return "vec2(" + String(e2) + ",0.0)";
    if ("real" in e2 && "imaginary" in e2) return e2;
    if (!Array.isArray(e2)) throw Error("Invalid ast");
    var t2 = e2[0], r = e2.slice(1);
    if ("apply" === t2) {
      if ("string" != typeof r[0]) throw Error("Non string functions not implemented for conversion to GLSL");
      t2 = r[0], r = r.slice(1);
      return glslOperators$1[t2](r.map((function(e3, t3) {
        return this.convert(e3);
      }).bind(this)));
    }
    if (t2 in glslOperators$1) return glslOperators$1[t2](r.map((function(e3, t3) {
      return this.convert(e3);
    }).bind(this)));
    throw Error("Operator " + t2 + " not implemented for conversion to mathjs");
  }
};
var astToGuppy$2 = new astToGuppy$1$1(), astToGLSL$2 = new astToGLSL$1$1();
const tex$1 = function(e2, t2) {
  return new astToLatex$1$1(t2).convert(e2.tree);
}, toLatex$1 = tex$1, toString$2 = function(e2, t2) {
  return new astToText$2$1(t2).convert(e2.tree);
}, toGLSL$1 = function(e2) {
  return astToGLSL$2.convert(e2.tree);
}, toXML$1 = function(e2) {
  return astToGuppy$2.convert(e2.tree);
};
var printing$1 = Object.freeze({ __proto__: null, tex: tex$1, toLatex: toLatex$1, toString: toString$2, toXML: toXML$1, toGLSL: toGLSL$1 });
const integrateNumerically$1 = function(e2, t2, r, n) {
  for (var i2 = 0, a = {}, o = 0; o < 100; o++) {
    var s = r + (n - r) * (o + 0.5) / 100;
    a[t2] = s, i2 += e2.evaluate(a);
  }
  return i2 * (n - r) / 100;
};
var integration$1 = Object.freeze({ __proto__: null, integrateNumerically: integrateNumerically$1 });
function expression_to_polynomial$1(e2) {
  var t2 = get_tree$1(e2);
  if ("string" == typeof t2) return "pi" === t2 && math$1$1.define_pi || "i" === t2 && math$1$1.define_i || "e" === t2 && math$1$1.define_e ? t2 : ["polynomial", t2, [[1, 1]]];
  if ("number" == typeof t2) return t2;
  var r = evaluate_to_constant$1(t2, { remove_units_first: false });
  if (Number.isFinite(r)) return simplify$2(t2);
  if (!Array.isArray(t2)) return false;
  if (!operators$3$1(t2).every(((e3) => ["+", "-", "*", "^", "/", "_", "prime"].includes(e3)))) return false;
  var n = t2[0], i2 = t2.slice(1);
  if ("+" === n) {
    let e3 = i2.map(expression_to_polynomial$1);
    return !!e3.every(((e4) => false !== e4)) && e3.reduce(((e4, t3) => polynomial_add$1(e4, t3)));
  }
  if ("-" === n) {
    let e3 = expression_to_polynomial$1(i2[0]);
    return !!e3 && polynomial_neg$1(e3);
  }
  if ("*" === n) {
    let e3 = i2.map(expression_to_polynomial$1);
    return !!e3.every(((e4) => false !== e4)) && e3.reduce(((e4, t3) => polynomial_mul$1(e4, t3)));
  }
  if ("^" === n) {
    let e3 = i2[0], r2 = expression_to_polynomial$1(e3);
    if (false === r2) return false;
    let n3 = simplify$2(i2[1]);
    if ("number" != typeof n3 || n3 < 0 || !Number.isInteger(n3)) {
      let r3 = evaluate_to_constant$1(n3, { remove_units_first: false });
      if (Number.isFinite(r3)) {
        let t3 = math$1$1.fraction(r3), n4 = { n: math$1$1.number(t3.n), d: math$1$1.number(t3.d), s: math$1$1.number(t3.s) };
        if (n4.d <= 100) {
          e3 = n4.s < 0 ? ["^", e3, ["/", -1, n4.d]] : ["^", e3, ["/", 1, n4.d]];
          var a = ["polynomial", simplify$2(e3), []];
          return a[2].push([n4.n, 1]), a;
        }
      }
      return ["polynomial", t2, [[1, 1]]];
    }
    return 0 === n3 ? 1 : 1 === n3 ? r2 : polynomial_pow$1(r2, n3);
  }
  if ("/" === n) {
    var o = i2[1], s = evaluate_to_constant$1(o, { remove_units_first: false });
    return Number.isFinite(s) ? polynomial_mul$1(expression_to_polynomial$1(i2[0]), ["/", 1, s]) : ["polynomial", t2, [[1, 1]]];
  }
  return ["polynomial", t2, [[1, 1]]];
}
function polynomials_in_same_leading_variable$1(e2, t2) {
  return e2[1] !== t2[1] && (compare_function$1(e2[1], t2[1]) < 0 ? t2 = ["polynomial", e2[1], [[0, t2]]] : e2 = ["polynomial", t2[1], [[0, e2]]]), [e2, t2];
}
function polynomial_add$1(e2, t2) {
  if ("polynomial" !== e2[0]) {
    if ("polynomial" !== t2[0]) return simplify$2(["+", e2, t2]);
    e2 = ["polynomial", t2[1], [[0, e2]]];
  } else if ("polynomial" !== t2[0]) t2 = ["polynomial", e2[1], [[0, t2]]];
  else {
    let r2 = polynomials_in_same_leading_variable$1(e2, t2);
    e2 = r2[0], t2 = r2[1];
  }
  let r = ["polynomial", e2[1], []], n = e2[2], i2 = t2[2], a = r[2], o = n.length, s = i2.length, u = 0, c2 = 0;
  for (; u < o || c2 < s; ) if (u === o) i2[c2][1] && a.push(i2[c2]), c2 += 1;
  else if (c2 === s) n[u][1] && a.push(n[u]), u += 1;
  else if (n[u][0] === i2[c2][0]) {
    let e3 = polynomial_add$1(n[u][1], i2[c2][1]);
    e3 && a.push([n[u][0], e3]), u += 1, c2 += 1;
  } else n[u][0] < i2[c2][0] ? (n[u][1] && a.push(n[u]), u += 1) : (i2[c2][1] && a.push(i2[c2]), c2 += 1);
  return 0 === a.length ? 0 : 1 === a.length && 0 === a[0][0] ? a[0][1] : r;
}
function polynomial_neg$1(e2) {
  if ("polynomial" !== e2[0]) return simplify$2(["-", e2]);
  let t2 = ["polynomial", e2[1], []], r = e2[2], n = t2[2], i2 = r.length;
  for (var a = 0; a < i2; a += 1) n.push([r[a][0], polynomial_neg$1(r[a][1])]);
  return t2;
}
function polynomial_sub$1(e2, t2) {
  return polynomial_add$1(e2, polynomial_neg$1(t2));
}
function polynomial_mul$1(e2, t2) {
  if ("polynomial" !== e2[0]) {
    if ("polynomial" !== t2[0]) return simplify$2(["*", e2, t2]);
    if (e2) {
      let r2 = ["polynomial", t2[1], []], n3 = t2[2], i3 = r2[2];
      for (let t3 of n3) t3[1] && i3.push([t3[0], polynomial_mul$1(e2, t3[1])]);
      return r2;
    }
  } else if (t2 && "polynomial" !== t2[0]) {
    let r2 = ["polynomial", e2[1], []], n3 = e2[2], i3 = r2[2];
    for (let e3 of n3) e3[1] && i3.push([e3[0], polynomial_mul$1(e3[1], t2)]);
    return r2;
  }
  let r = polynomials_in_same_leading_variable$1(e2, t2);
  e2 = r[0], t2 = r[1];
  let n = e2[2], i2 = t2[2], a = ["polynomial", e2[1], []], o = a[2], s = n.length, u = i2.length, c2 = [];
  for (let e3 of n) for (let t3 of i2) {
    let r2 = false, n3 = e3[0] + t3[0];
    for (let e4 of c2) if (n3 === e4) {
      r2 = true;
      break;
    }
    r2 || c2.push(n3);
  }
  c2.sort((function(e3, t3) {
    return e3 - t3;
  }));
  for (let e3 of c2) {
    let t3 = 0, r2 = 0;
    for (; r2 < s && n[r2][0] <= e3; ) {
      let a2 = 0;
      for (; a2 < u && i2[a2][0] <= e3; ) {
        if (n[r2][0] + i2[a2][0] === e3) {
          t3 = polynomial_add$1(t3, polynomial_mul$1(n[r2][1], i2[a2][1]));
          break;
        }
        a2 += 1;
      }
      r2 += 1;
    }
    t3 && o.push([e3, t3]);
  }
  return a;
}
function polynomial_pow$1(e2, t2) {
  if (isNaN(t2) || t2 < 0 || !Number.isInteger(t2)) return;
  let r = 1;
  for (; t2 > 0; ) 1 & t2 && (r = polynomial_mul$1(r, e2)), e2 = polynomial_mul$1(e2, e2), t2 >>= 1;
  return r;
}
function polynomial_to_expression$1(e2) {
  if (!Array.isArray(e2) || "polynomial" !== e2[0]) return e2;
  let t2 = e2[1], r = e2[2], n = [], i2 = r.length;
  for (var a = 0; a < i2; a += 1) r[a][1] && (0 === r[a][0] ? n.push(polynomial_to_expression$1(r[a][1])) : 1 === r[a][0] ? n.push(["*", polynomial_to_expression$1(r[a][1]), t2]) : n.push(["*", polynomial_to_expression$1(r[a][1]), ["^", t2, r[a][0]]]));
  return 0 === n.length ? 0 : (1 === n.length ? n = n[0] : n.unshift("+"), simplify$2(n));
}
function initial_term$1(e2) {
  if (!Array.isArray(e2) || "polynomial" !== e2[0]) return e2;
  let t2 = [];
  for (; Array.isArray(e2) && "polynomial" === e2[0]; ) {
    let r = e2[1], n = e2[2], i2 = n[n.length - 1][0];
    e2 = n[n.length - 1][1], t2.push([r, i2]);
  }
  return ["monomial", e2, t2];
}
function mono_less_than$1(e2, t2) {
  if (!Array.isArray(t2) || "monomial" !== t2[0]) return false;
  if (!Array.isArray(e2) || "monomial" !== e2[0]) return true;
  let r = e2[2], n = t2[2], i2 = r.length, a = n.length;
  var o;
  o = i2 < a ? i2 : a;
  for (var s = 0; s < o; s++) {
    if (r[s][0] !== n[s][0]) return !(compare_function$1(r[s][0], n[s][0]) < 0);
    if (r[s][1] < n[s][1]) return true;
    if (r[s][1] > n[s][1]) return false;
  }
  return i2 !== a && o !== a;
}
function mono_gcd$1(e2, t2) {
  if (!Array.isArray(e2) || !Array.isArray(t2) || "monomial" !== e2[0] || "monomial" !== t2[0]) return 1;
  let r = e2[2], n = t2[2], i2 = [], a = r.length, o = n.length, s = 0, u = 0;
  for (; s < a && u < o; ) r[s][0] === n[u][0] ? (r[s][1] < n[u][1] ? i2.push(r[s]) : i2.push(n[u]), s += 1, u += 1) : compare_function$1(r[s][0], n[u][0]) < 0 ? s += 1 : compare_function$1(n[u][0], r[s][0]) < 0 && (u += 1);
  return 0 === i2.length ? 1 : ["monomial", 1, i2];
}
function mono_div$1(e2, t2) {
  if (!Array.isArray(t2) || "monomial" !== t2[0]) return 1 === t2 ? e2 : Array.isArray(e2) && "monomial" === e2[0] ? [e2[0], evaluate_numbers$1(["/", e2[1], t2]), e2[2]] : evaluate_numbers$1(["/", e2, t2]);
  if (!Array.isArray(e2) || "monomial" !== e2[0]) return;
  let r = e2[2], n = t2[2], i2 = [], a = r.length, o = n.length, s = 0, u = 0;
  for (; s < a && u < o; ) if (r[s][0] === n[u][0]) {
    if (r[s][1] < n[u][1]) return;
    {
      let e3 = r[s][1] - n[u][1];
      0 !== e3 && i2.push([r[s][0], e3]);
    }
    s += 1, u += 1;
  } else if (compare_function$1(r[s][0], n[u][0]) < 0) i2.push(r[s]), s += 1;
  else if (compare_function$1(n[u][0], r[s][0]) < 0) return;
  if (!(u < o)) {
    for (; s < a; ) i2.push(r[s]), s += 1;
    return 0 === i2.length ? 1 === t2[1] ? e2[1] : evaluate_numbers$1(["/", e2[1], t2[1]]) : 1 === t2[1] ? ["monomial", e2[1], i2] : ["monomial", evaluate_numbers$1(["/", e2[1], t2[1]]), i2];
  }
}
function mono_is_div$1(e2, t2) {
  if (0 === t2) return false;
  if (!Array.isArray(t2) || "monomial" !== t2[0]) return true;
  if (!Array.isArray(e2) || "monomial" !== e2[0]) return false;
  let r = e2[2], n = t2[2], i2 = [], a = r.length, o = n.length, s = 0, u = 0;
  for (; s < a && u < o; ) if (r[s][0] === n[u][0]) {
    if (r[s][1] < n[u][1]) return false;
    {
      let e3 = r[s][1] - n[u][1];
      0 !== e3 && i2.push([r[s][0], e3]);
    }
    s += 1, u += 1;
  } else if (compare_function$1(r[s][0], n[u][0]) < 0) i2.push(r[s]), s += 1;
  else if (compare_function$1(n[u][0], r[s][0]) < 0) return false;
  return !(u < o);
}
function mono_to_poly$1(e2) {
  if (!Array.isArray(e2) || "monomial" !== e2[0]) return e2;
  let t2 = e2[2].length - 1, r = e2[1];
  for (; t2 >= 0; ) {
    var n = [];
    n.push([e2[2][t2][1], r]), r = ["polynomial", e2[2][t2][0], n], t2 -= 1;
  }
  return r;
}
function max_div_init$1(e2, t2) {
  if (0 === e2) return 0;
  let r = e2, n = [];
  for (; Array.isArray(r) && "polynomial" === r[0]; ) {
    let e3 = r[1], t3 = r[2], i3 = t3[t3.length - 1][0];
    r = t3[t3.length - 1][1], n.push([e3, i3]);
  }
  let i2 = ["monomial", r, n], a = t2.length;
  for (var o = 0; o < a; o += 1) if (mono_is_div$1(i2, t2[o])) return [i2, o];
  return max_div_init$1(polynomial_sub$1(e2, mono_to_poly$1(i2)), t2);
}
function poly_div$1(e2, t2) {
  let r = [], n = [], i2 = [], a = [], o = e2;
  for (var s of t2) r.push(initial_term$1(s));
  let u = max_div_init$1(o, r);
  for (; 0 !== u; ) i2 = u[1], a = mono_div$1(u[0], r[i2]), n.push([i2, a]), o = polynomial_sub$1(o, polynomial_mul$1(mono_to_poly$1(a), t2[i2])), u = max_div_init$1(o, r);
  return [n, o];
}
function prereduce$1(e2) {
  let t2 = e2.length, r = [];
  for (var n = 0; n < t2; n++) {
    if (0 !== e2[n] && (!Array.isArray(e2[n]) || "polynomial" !== e2[n][0])) return [1];
    0 !== e2[n] && r.push(e2[n]);
  }
  return 0 === r.length ? [0] : r;
}
function reduce_ith$1(e2, t2) {
  let r = [], n = [], i2 = [], a = t2[e2], o = t2.length;
  for (var s = 0; s < o; s += 1) s === e2 ? r.push(0) : r.push(initial_term$1(t2[s]));
  let u = max_div_init$1(a, r);
  for (; 0 !== u; ) n = u[1], i2 = mono_div$1(u[0], r[n]), a = polynomial_sub$1(a, polynomial_mul$1(mono_to_poly$1(i2), t2[n])), u = max_div_init$1(a, r);
  return a;
}
function reduce$3(e2) {
  let t2 = 0, r = [], n = prereduce$1(e2), i2 = n.length;
  if (1 === i2) return n;
  let a = true;
  for (; a; ) for (a = false, n = prereduce$1(n), i2 = n.length, t2 = 0; t2 < i2; ) r = reduce_ith$1(t2, n), _$3.isEqual(r, n[t2]) || (n[t2] = r, a = true), t2 += 1;
  t2 = 0;
  let o = [], s = 0;
  for (; t2 < i2; ) o = initial_term$1(n[t2]), Array.isArray(o) && "monomial" === o[0] ? (s = o[1], 1 !== s && (n[t2] = polynomial_mul$1(n[t2], ["/", 1, s]))) : n[t2] = 1, t2 += 1;
  return n;
}
function hij$1(e2, t2, r) {
  let n = initial_term$1(r[e2]), i2 = initial_term$1(r[t2]), a = mono_gcd$1(n, i2), o = mono_to_poly$1(mono_div$1(n, a));
  return poly_div$1(polynomial_sub$1(polynomial_mul$1(mono_to_poly$1(mono_div$1(i2, a)), r[e2]), polynomial_mul$1(o, r[t2])), r)[1];
}
function build_hij_table$1(e2, t2) {
  let r = t2.length, n = 0, i2 = 1, a = [];
  for (; i2 < r; ) {
    for (; n < i2; ) e2[[n, i2]] = hij$1(n, i2, t2), 0 !== e2[[n, i2]] && a.push(e2[[n, i2]]), n += 1;
    n = 0, i2 += 1;
  }
  return a.length > 0 ? choice_lowest_degree$1(a) : 0;
}
function update_hij_table$1(e2, t2, r) {
  let n = t2.length;
  t2.push(r);
  let i2 = 0, a = 1, o = [];
  for (; a < n; ) {
    for (; i2 < a; ) 0 !== e2[[i2, a]] && (e2[[i2, a]] = hij$1(i2, a, t2), 0 !== e2[[i2, a]] && o.push(e2[[i2, a]])), i2 += 1;
    i2 = 0, a += 1;
  }
  for (; i2 < n; ) e2[[i2, n]] = hij$1(i2, n, t2), 0 !== e2[[i2, n]] && o.push(e2[[i2, n]]), i2 += 1;
  return o.length > 0 ? choice_lowest_degree$1(o) : 0;
}
function choice_lowest_degree$1(e2) {
  let t2 = [], r = e2.length;
  for (i2 = 0; i2 < r; i2 += 1) t2.push(initial_term$1(e2[i2]));
  let n = 0;
  for (var i2 = 1; i2 < r; i2 += 1) {
    if (1 === t2[i2]) return 1;
    mono_less_than$1(t2[i2], t2[n]) && (n = i2);
  }
  return e2[n];
}
function reduced_grobner$1(e2) {
  let t2 = reduce$3(e2), r = {}, n = build_hij_table$1(r, t2);
  for (; 0 !== n; ) n = update_hij_table$1(r, t2, n);
  return t2 = reduce$3(t2), t2;
}
function poly_lcm$1(e2, t2) {
  let r = reduced_grobner$1([polynomial_mul$1(["polynomial", "_t", [[1, 1]]], e2), polynomial_mul$1(["polynomial", "_t", [[0, 1], [1, -1]]], t2)]), n = r.length;
  for (var i2 = 0; i2 < n; i2 += 1) {
    if (!Array.isArray(r[i2]) || "polynomial" !== r[i2][0]) return 1;
    if ("_t" !== r[i2][1]) return r[i2];
  }
}
function poly_gcd$1(e2, t2) {
  let r = poly_lcm$1(e2, t2), n = poly_div$1(polynomial_mul$1(e2, t2), [r]), i2 = 0, a = n[0].length;
  for (var o = 0; o < a; o += 1) i2 = polynomial_add$1(i2, mono_to_poly$1(n[0][o][1]));
  let s = initial_term$1(i2);
  if (Array.isArray(s) && "monomial" === s[0]) {
    let e3 = s[1];
    1 !== e3 && (i2 = polynomial_mul$1(i2, ["/", 1, e3]));
  } else i2 = 1;
  return i2;
}
function poly_by_divisor$1(e2, t2) {
  let r = poly_div$1(e2, [t2]), n = 0, i2 = r[0].length;
  for (var a = 0; a < i2; a += 1) n = polynomial_add$1(n, mono_to_poly$1(r[0][a][1]));
  return n;
}
function reduce_rational_expression$1(e2, t2) {
  let r = stringify_vars$1(e2), n = stringify_vars$1(t2), i2 = polynomial_mul$1(poly_gcd$1(e2 = r[0], t2 = n[0]), initial_term$1(t2)[1]), a = poly_by_divisor$1(e2, i2), o = poly_by_divisor$1(t2, i2);
  return [destringify_vars$1(destringify_vars$1(a, r[1]), n[1]), destringify_vars$1(destringify_vars$1(o, r[1]), n[1])];
}
function stringify_vars$1(e2) {
  if (!Array.isArray(e2) || "polynomial" !== e2[0]) return [e2, {}];
  let t2 = {}, r = "z" + JSON.stringify(e2[1]);
  t2[r] = e2[1], e2[1] = r;
  let n = e2[2], i2 = [];
  for (let e3 of n) {
    i2 = stringify_vars$1(e3[1]), e3[1] = i2[0];
    for (let e4 in i2[1]) t2[e4] = i2[1][e4];
  }
  return [e2, t2];
}
function destringify_vars$1(e2, t2) {
  if (!Array.isArray(e2) || "polynomial" !== e2[0]) return e2;
  t2[e2[1]] && (e2[1] = t2[e2[1]]);
  let r = e2[2];
  for (let e3 of r) e3[1] = destringify_vars$1(e3[1], t2);
  return e2;
}
var textToAst$1$1 = new textToAst$4$1();
function common_denominator$1(e2, t2) {
  e2 = simplify$2(e2, t2);
  var r = [];
  return r.push([textToAst$1$1.convert("a/c+b/c"), textToAst$1$1.convert("(a+b)/c"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1$1.convert("a/c-b/c"), textToAst$1$1.convert("(a-b)/c"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1$1.convert("a+b/c"), textToAst$1$1.convert("(ac+b)/c"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1$1.convert("a-b/c"), textToAst$1$1.convert("(ac-b)/c"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1$1.convert("a/d+b/c"), textToAst$1$1.convert("(ac+bd)/(cd)"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1$1.convert("a/d-b/c"), textToAst$1$1.convert("(ac-bd)/(cd)"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1$1.convert("x*(y/z)"), textToAst$1$1.convert("(x*y)/z"), { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1$1.convert("(x/y)/z"), textToAst$1$1.convert("x/(y*z)"), { allow_extended_match: true, allow_permutations: true }]), r.push([textToAst$1$1.convert("x/(y/z)"), textToAst$1$1.convert("xz/y"), { allow_extended_match: true, allow_permutations: true }]), e2 = expand$1(e2 = applyAllTransformations$1(e2, r, 40), true);
}
function as_num_denom$1(e2) {
  var t2 = get_tree$1(e2);
  return "/" === (t2 = common_denominator$1(t2))[0] ? [t2[1], t2[2]] : [t2, 1];
}
function reduce_rational$1(e2) {
  var t2 = get_tree$1(e2), r = as_num_denom$1(t2);
  if (1 === r[1]) return t2;
  var n = reduce_rational_expression$1(expression_to_polynomial$1(r[0]), expression_to_polynomial$1(r[1])), i2 = polynomial_to_expression$1(n[0]), a = polynomial_to_expression$1(n[1]);
  return 1 === a ? i2 : ["/", i2, a];
}
const common_demoninator$1 = common_denominator$1;
var rational$1 = Object.freeze({ __proto__: null, reduce_rational: reduce_rational$1, common_demoninator: common_demoninator$1 });
function toFixed$3(e2, t2) {
  return math$1$1.format(e2, { notation: "fixed", precision: t2 });
}
function round_numbers_to_precision$1(e2, t2 = 14) {
  var r = get_tree$1(e2);
  if (t2 < 1) throw Error("For round_numbers_to_precision, digits must be positive");
  if (!Number.isFinite(t2)) throw Error("For round_numbers_to_precision, digits must be a number");
  return t2 > 15 ? r : (t2 = Math.round(t2), round_numbers_to_precision_sub$1(r, t2));
}
const round_numbers_to_precision_sub$1 = function(e2, t2 = 14) {
  if ("number" == typeof e2 && Number.isFinite(e2) && 0 !== e2) {
    const r = math$1$1.floor(math$1$1.log10(math$1$1.abs(e2))), n = t2 - r - 1;
    return n < 0 ? parseFloat(toFixed$3(e2, n) + "0".repeat(math$1$1.abs(n))) : parseFloat(toFixed$3(e2, n));
  }
  if (!Array.isArray(e2)) return e2;
  return [e2[0], ...e2.slice(1).map(((e3) => round_numbers_to_precision_sub$1(e3, t2)))];
};
function round_numbers_to_decimals$1(e2, t2 = 14) {
  var r = get_tree$1(e2);
  if (!Number.isFinite(t2)) throw Error("For round_numbers_to_decimals, ndecimals must be a number");
  return t2 = Math.round(t2), t2 = Math.max(-330, Math.min(330, t2)), round_numbers_to_decimals_sub$1(r, t2);
}
const round_numbers_to_decimals_sub$1 = function(e2, t2 = 0) {
  if ("number" == typeof e2) return t2 < 0 ? parseFloat(toFixed$3(e2, t2) + "0".repeat(math$1$1.abs(t2))) : parseFloat(toFixed$3(e2, t2));
  if (!Array.isArray(e2)) return e2;
  return [e2[0], ...e2.slice(1).map(((e3) => round_numbers_to_decimals_sub$1(e3, t2)))];
};
function round_numbers_to_precision_plus_decimals$1(e2, t2 = 4, r = 2) {
  var n = get_tree$1(e2);
  let i2 = true, a = true;
  if (t2 >= 1) {
    if ((t2 = Math.round(t2)) > 15) return n;
  } else i2 = false;
  return Number.isFinite(r) ? (r = Math.round(r), r = Math.max(-330, Math.min(330, r))) : a = false, i2 ? a ? round_numbers_to_precision_plus_decimals_sub$1(n, t2, r) : round_numbers_to_precision_sub$1(n, t2) : a ? round_numbers_to_decimals_sub$1(n, r) : n;
}
const round_numbers_to_precision_plus_decimals_sub$1 = function(e2, t2 = 4, r = 2) {
  if ("number" == typeof e2 && Number.isFinite(e2) && 0 !== e2) {
    const n = math$1$1.floor(math$1$1.log10(math$1$1.abs(e2))), i2 = Math.max(t2 - n - 1, r);
    return i2 < 0 ? parseFloat(toFixed$3(e2, i2) + "0".repeat(math$1$1.abs(i2))) : parseFloat(toFixed$3(e2, i2));
  }
  if (!Array.isArray(e2)) return e2;
  return [e2[0], ...e2.slice(1).map(((e3) => round_numbers_to_precision_plus_decimals_sub$1(e3, t2, r)))];
};
var round$3 = Object.freeze({ __proto__: null, round_numbers_to_precision: round_numbers_to_precision$1, round_numbers_to_decimals: round_numbers_to_decimals$1, round_numbers_to_precision_plus_decimals: round_numbers_to_precision_plus_decimals$1 });
const match$3 = function(e2, t2, r) {
  let n = get_tree$1(e2), i2 = get_tree$1(t2);
  return match$2$1(n, i2, r);
};
var match$1$1 = Object.freeze({ __proto__: null, match: match$3 });
const expression_to_tree$1$1 = [simplify$1$1, differentiation$1, normalization$1, arithmetic$1, transformation$1, solve$1, sets$1, matrix$1$1, rational$1, round$3], expression_to_other$1 = [variables$1$1, printing$1, equality$1, integration$1, evaluation$1, analytic$1, sign_error$1, match$1$1];
function abs$2(e2) {
  return ["apply", "abs", get_tree$1(e2)];
}
function exp$2(e2) {
  return ["apply", "exp", get_tree$1(e2)];
}
function log$2(e2) {
  return ["apply", "log", get_tree$1(e2)];
}
function log10$3(e2) {
  return ["apply", "log10", get_tree$1(e2)];
}
function sign$3(e2) {
  return ["apply", "sign", get_tree$1(e2)];
}
function sqrt$2(e2) {
  return ["apply", "sqrt", get_tree$1(e2)];
}
function conj$1(e2) {
  return ["apply", "conj", get_tree$1(e2)];
}
function im$1(e2) {
  return ["apply", "im", get_tree$1(e2)];
}
function re$1(e2) {
  return ["apply", "re", get_tree$1(e2)];
}
function factorial$1(e2) {
  return ["apply", "factorial", get_tree$1(e2)];
}
function gamma$1(e2) {
  return ["apply", "gamma", get_tree$1(e2)];
}
function erf$1(e2) {
  return ["apply", "erf", get_tree$1(e2)];
}
function acos$2(e2) {
  return ["apply", "acos", get_tree$1(e2)];
}
function acosh$3(e2) {
  return ["apply", "acosh", get_tree$1(e2)];
}
function acot$1(e2) {
  return ["apply", "acot", get_tree$1(e2)];
}
function acoth$1(e2) {
  return ["apply", "acoth", get_tree$1(e2)];
}
function acsc$1(e2) {
  return ["apply", "acsc", get_tree$1(e2)];
}
function acsch$1(e2) {
  return ["apply", "acsch", get_tree$1(e2)];
}
function asec$1(e2) {
  return ["apply", "asec", get_tree$1(e2)];
}
function asech$1(e2) {
  return ["apply", "asech", get_tree$1(e2)];
}
function asin$2(e2) {
  return ["apply", "asin", get_tree$1(e2)];
}
function asinh$3(e2) {
  return ["apply", "asinh", get_tree$1(e2)];
}
function atan$2(e2) {
  return ["apply", "atan", get_tree$1(e2)];
}
function atanh$3(e2) {
  return ["apply", "atanh", get_tree$1(e2)];
}
function cos$2(e2) {
  return ["apply", "cos", get_tree$1(e2)];
}
function cosh$4(e2) {
  return ["apply", "cosh", get_tree$1(e2)];
}
function cot$1(e2) {
  return ["apply", "cot", get_tree$1(e2)];
}
function coth$1(e2) {
  return ["apply", "coth", get_tree$1(e2)];
}
function csc$1(e2) {
  return ["apply", "csc", get_tree$1(e2)];
}
function csch$1(e2) {
  return ["apply", "csch", get_tree$1(e2)];
}
function sec$1(e2) {
  return ["apply", "sec", get_tree$1(e2)];
}
function sech$1(e2) {
  return ["apply", "sech", get_tree$1(e2)];
}
function sin$2(e2) {
  return ["apply", "sin", get_tree$1(e2)];
}
function sinh$4(e2) {
  return ["apply", "sinh", get_tree$1(e2)];
}
function tan$2(e2) {
  return ["apply", "tan", get_tree$1(e2)];
}
function tanh$3(e2) {
  return ["apply", "tanh", get_tree$1(e2)];
}
function atan2$2(e2, t2) {
  return ["apply", "atan2", ["tuple", get_tree$1(e2), get_tree$1(t2)]];
}
var standard$1 = Object.freeze({ __proto__: null, abs: abs$2, exp: exp$2, log: log$2, log10: log10$3, sign: sign$3, sqrt: sqrt$2, conj: conj$1, im: im$1, re: re$1, factorial: factorial$1, gamma: gamma$1, erf: erf$1, acos: acos$2, acosh: acosh$3, acot: acot$1, acoth: acoth$1, acsc: acsc$1, acsch: acsch$1, asec: asec$1, asech: asech$1, asin: asin$2, asinh: asinh$3, atan: atan$2, atanh: atanh$3, cos: cos$2, cosh: cosh$4, cot: cot$1, coth: coth$1, csc: csc$1, csch: csch$1, sec: sec$1, sech: sech$1, sin: sin$2, sinh: sinh$4, tan: tan$2, tanh: tanh$3, atan2: atan2$2 });
const expression_to_tree$2 = [standard$1], whitespace_rule$1 = "\\s|\\\\,|\\\\!|\\\\ |\\\\>|\\\\;|\\\\:|\\\\quad\\b|\\\\qquad\\b", sci_notat_exp_regex$2 = "(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?", number_rules_sci$2 = [["[0-9]+(\\.[0-9]*)?" + sci_notat_exp_regex$2, "NUMBER"], ["\\.[0-9]+" + sci_notat_exp_regex$2, "NUMBER"]], number_rules_non_sci$2 = [["[0-9]+(\\.[0-9]*)?", "NUMBER"], ["\\.[0-9]+", "NUMBER"]], base_latex_rules$1 = [["\\*", "*"], ["\\/", "/"], ["-", "-"], ["\\+", "+"], ["\\^", "^"], ["\\(", "("], ["\\\\left\\s*\\(", "("], ["\\\\bigl\\s*\\(", "("], ["\\\\Bigl\\s*\\(", "("], ["\\\\biggl\\s*\\(", "("], ["\\\\Biggl\\s*\\(", "("], ["\\)", ")"], ["\\\\right\\s*\\)", ")"], ["\\\\bigr\\s*\\)", ")"], ["\\\\Bigr\\s*\\)", ")"], ["\\\\biggr\\s*\\)", ")"], ["\\\\Biggr\\s*\\)", ")"], ["\\[", "["], ["\\\\left\\s*\\[", "["], ["\\\\bigl\\s*\\[", "["], ["\\\\Bigl\\s*\\[", "["], ["\\\\biggl\\s*\\[", "["], ["\\\\Biggl\\s*\\[", "["], ["\\]", "]"], ["\\\\right\\s*\\]", "]"], ["\\\\bigr\\s*\\]", "]"], ["\\\\Bigr\\s*\\]", "]"], ["\\\\biggr\\s*\\]", "]"], ["\\\\Biggr\\s*\\]", "]"], ["\\|", "|"], ["\\\\left\\s*\\|", "|L"], ["\\\\bigl\\s*\\|", "|L"], ["\\\\Bigl\\s*\\|", "|L"], ["\\\\biggl\\s*\\|", "|L"], ["\\\\Biggl\\s*\\|", "|L"], ["\\\\right\\s*\\|", "|"], ["\\\\bigr\\s*\\|", "|"], ["\\\\Bigr\\s*\\|", "|"], ["\\\\biggr\\s*\\|", "|"], ["\\\\Biggr\\s*\\|", "|"], ["\\\\big\\s*\\|", "|"], ["\\\\Big\\s*\\|", "|"], ["\\\\bigg\\s*\\|", "|"], ["\\\\Bigg\\s*\\|", "|"], ["{", "{"], ["}", "}"], ["\\\\{", "LBRACE"], ["\\\\left\\s*\\\\{", "LBRACE"], ["\\\\bigl\\s*\\\\{", "LBRACE"], ["\\\\Bigl\\s*\\\\{", "LBRACE"], ["\\\\biggl\\s*\\\\{", "LBRACE"], ["\\\\Biggl\\s*\\\\{", "LBRACE"], ["\\\\}", "RBRACE"], ["\\\\right\\s*\\\\}", "RBRACE"], ["\\\\bigr\\s*\\\\}", "RBRACE"], ["\\\\Bigr\\s*\\\\}", "RBRACE"], ["\\\\biggr\\s*\\\\}", "RBRACE"], ["\\\\Biggr\\s*\\\\}", "RBRACE"], ["\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\left\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\bigl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\Bigl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\biggl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\Biggl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\right\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\bigr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\Bigr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\biggr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\Biggr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\left\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\bigl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\Bigl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\biggl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\Biggl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\right\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\bigr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\Bigr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\biggr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\Biggr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\left\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\bigl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\Bigl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\biggl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\Biggl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\right\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\bigr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\Bigr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\biggr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\Biggr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\cdot(?![a-zA-Z])", "*"], ["\\\\div(?![a-zA-Z])", "/"], ["\\\\times(?![a-zA-Z])", "*"], [",", ","], [":", ":"], ["\\\\mid(?![a-zA-Z])", "MID"], ["\\\\varnothing(?![a-zA-Z])", "LATEXCOMMAND", "\\emptyset"], ["\\\\vartheta(?![a-zA-Z])", "LATEXCOMMAND", "\\theta"], ["\\\\varepsilon(?![a-zA-Z])", "LATEXCOMMAND", "\\epsilon"], ["\\\\varrho(?![a-zA-Z])", "LATEXCOMMAND", "\\rho"], ["\\\\varphi(?![a-zA-Z])", "LATEXCOMMAND", "\\phi"], ["\\\\infty(?![a-zA-Z])", "INFINITY"], ["\\\\asin(?![a-zA-Z])", "LATEXCOMMAND", "\\arcsin"], ["\\\\acos(?![a-zA-Z])", "LATEXCOMMAND", "\\arccos"], ["\\\\atan(?![a-zA-Z])", "LATEXCOMMAND", "\\arctan"], ["\\\\sqrt(?![a-zA-Z])", "SQRT"], ["\\\\land(?![a-zA-Z])", "AND"], ["\\\\wedge(?![a-zA-Z])", "AND"], ["\\\\lor(?![a-zA-Z])", "OR"], ["\\\\vee(?![a-zA-Z])", "OR"], ["\\\\lnot(?![a-zA-Z])", "NOT"], ["\\\\neg(?![a-zA-Z])", "NOT"], ["=", "="], ["\\\\neq(?![a-zA-Z])", "NE"], ["\\\\ne(?![a-zA-Z])", "NE"], ["\\\\not\\s*=", "NE"], ["\\\\leq(?![a-zA-Z])", "LE"], ["\\\\le(?![a-zA-Z])", "LE"], ["\\\\geq(?![a-zA-Z])", "GE"], ["\\\\ge(?![a-zA-Z])", "GE"], ["<", "<"], ["\\\\lt(?![a-zA-Z])", "<"], [">", ">"], ["\\\\gt(?![a-zA-Z])", ">"], ["\\\\forall(?![a-zA-Z])", "FORALL"], ["\\\\exists(?![a-zA-Z])", "EXISTS"], ["\\\\in(?![a-zA-Z])", "IN"], ["\\\\notin(?![a-zA-Z])", "NOTIN"], ["\\\\not\\s*\\\\in(?![a-zA-Z])", "NOTIN"], ["\\\\ni(?![a-zA-Z])", "NI"], ["\\\\not\\s*\\\\ni(?![a-zA-Z])", "NOTNI"], ["\\\\subset(?![a-zA-Z])", "SUBSET"], ["\\\\subseteq(?![a-zA-Z])", "SUBSETEQ"], ["\\\\not\\s*\\\\subset(?![a-zA-Z])", "NOTSUBSET"], ["\\\\not\\s*\\\\subseteq(?![a-zA-Z])", "NOTSUBSETEQ"], ["\\\\supset(?![a-zA-Z])", "SUPERSET"], ["\\\\supseteq(?![a-zA-Z])", "SUPERSETEQ"], ["\\\\not\\s*\\\\supset(?![a-zA-Z])", "NOTSUPERSET"], ["\\\\not\\s*\\\\supseteq(?![a-zA-Z])", "NOTSUPERSETEQ"], ["\\\\cup(?![a-zA-Z])", "UNION"], ["\\\\cap(?![a-zA-Z])", "INTERSECT"], ["\\\\to(?![a-zA-Z])", "RIGHTARROW"], ["\\\\rightarrow(?![a-zA-Z])", "RIGHTARROW"], ["\\\\longrightarrow(?![a-zA-Z])", "RIGHTARROW"], ["\\\\gets(?![a-zA-Z])", "LEFTARROW"], ["\\\\leftarrow(?![a-zA-Z])", "LEFTARROW"], ["\\\\longleftarrow(?![a-zA-Z])", "LEFTARROW"], ["\\\\leftrightarrow(?![a-zA-Z])", "LEFTRIGHTARROW"], ["\\\\longleftrightarrow(?![a-zA-Z])", "LEFTRIGHTARROW"], ["\\\\implies(?![a-zA-Z])", "IMPLIES"], ["\\\\Longrightarrow(?![a-zA-Z])", "IMPLIES"], ["\\\\Rightarrow(?![a-zA-Z])", "IMPLIES"], ["\\\\impliedby(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\Longleftarrow(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\Leftarrow(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\iff(?![a-zA-Z])", "IFF"], ["\\\\Longleftrightarrow(?![a-zA-Z])", "IFF"], ["\\\\Leftrightarrow(?![a-zA-Z])", "IFF"], ["\\\\perp(?![a-zA-Z])", "PERP"], ["\\\\bot(?![a-zA-Z])", "PERP"], ["\\\\parallel(?![a-zA-Z])", "PARALLEL"], ["\\\\\\|", "PARALLEL"], ["\\\\angle(?![a-zA-Z])", "ANGLE"], ["\\\\int(?![a-zA-Z])", "INT"], ["!", "!"], ["'", "'"], ["_", "_"], ["&", "&"], ["\\\\ldots(?![a-zA-Z])", "LDOTS"], ["\\\\\\\\", "LINEBREAK"], ["\\\\begin\\s*{\\s*[a-zA-Z0-9]+\\s*}", "BEGINENVIRONMENT"], ["\\\\end\\s*{\\s*[a-zA-Z0-9]+\\s*}", "ENDENVIRONMENT"], ["\\\\operatorname\\s*{\\s*[a-zA-Z0-9\\+\\-]+\\s*}", "VARMULTICHAR"], ["\\\\[a-zA-Z]+(?![a-zA-Z])", "LATEXCOMMAND"], ["\\\\[$%]", "LATEXCOMMAND"], ["[a-zA-Z＿$%]", "VAR"]], allowSimplifiedFunctionApplicationDefault$2 = true, allowedLatexSymbolsDefault$2 = ["alpha", "beta", "gamma", "Gamma", "delta", "Delta", "epsilon", "zeta", "eta", "theta", "Theta", "iota", "kappa", "lambda", "Lambda", "mu", "nu", "xi", "Xi", "pi", "Pi", "rho", "sigma", "Sigma", "tau", "Tau", "upsilon", "Upsilon", "phi", "Phi", "chi", "psi", "Psi", "omega", "Omega", "partial", "angle", "circ", "%", "$", "emptyset"], appliedFunctionSymbolsDefault$2 = ["abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "cos", "cosh", "acos", "acosh", "arccos", "arccosh", "cot", "coth", "acot", "acoth", "arccot", "arccoth", "csc", "csch", "acsc", "acsch", "arccsc", "arccsch", "sec", "sech", "asec", "asech", "arcsec", "arcsech", "sin", "sinh", "asin", "asinh", "arcsin", "arcsinh", "tan", "tanh", "atan", "atan2", "atanh", "arctan", "arctanh", "arg", "conj", "Re", "Im", "det", "trace", "nPr", "nCr", "floor", "ceil", "round"], functionSymbolsDefault$2 = ["f", "g"], operatorSymbolsDefault$2 = { frac: { nargs: 2, substitute: "/" }, binom: { nargs: 2 }, vec: { nargs: 1 }, overline: { nargs: 1, substitute: "linesegment", remove_products: true } }, unitsDefault$2 = get_all_units$1();
unitsDefault$2.circ = unitsDefault$2.deg, unitsDefault$2.circ.substitute = "deg", unitsDefault$2.circ.isExponent = true, delete unitsDefault$2.deg;
const parseLeibnizNotationDefault$2 = true;
let latexToAst$1$1 = class latexToAst$12 {
  constructor({ allowSimplifiedFunctionApplication: e2 = allowSimplifiedFunctionApplicationDefault$2, allowedLatexSymbols: t2 = allowedLatexSymbolsDefault$2, appliedFunctionSymbols: r = appliedFunctionSymbolsDefault$2, functionSymbols: n = functionSymbolsDefault$2, operatorSymbols: i2 = operatorSymbolsDefault$2, units: a = unitsDefault$2, parseLeibnizNotation: o = parseLeibnizNotationDefault$2, parseScientificNotation: s = true } = {}) {
    this.allowSimplifiedFunctionApplication = e2, this.allowedLatexSymbols = t2, this.appliedFunctionSymbols = r, this.functionSymbols = n, this.operatorSymbols = i2, this.units = a, this.parseLeibnizNotation = o;
    let u = base_latex_rules$1;
    u = s ? [...number_rules_sci$2, ...u] : [...number_rules_non_sci$2, ...u], this.lexer = new lexer$1(u, whitespace_rule$1);
  }
  advance(e2) {
    if (this.token = this.lexer.advance(e2), "INVALID" === this.token.token_type) throw new ParseError$1("Invalid symbol '" + this.token.original_text + "'", this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(e2) {
    this.lexer.set_state(e2.lexer_state), this.token = Object.assign({}, e2.token);
  }
  convert(e2) {
    this.lexer.set_input(e2), this.advance();
    var t2 = this.statement_list();
    if ("EOF" !== this.token.token_type) throw new ParseError$1("Invalid location of '" + this.token.original_text + "'", this.lexer.location);
    return flatten$7(t2);
  }
  statement_list() {
    for (var e2 = [this.statement()]; "," === this.token.token_type; ) this.advance(), e2.push(this.statement());
    return e2 = e2.length > 1 ? ["list"].concat(e2) : e2[0];
  }
  statement({ inside_absolute_value: e2 = 0 } = {}) {
    if ("LDOTS" === this.token.token_type) return this.advance(), ["ldots"];
    var t2;
    try {
      t2 = this.return_state();
      let r = this.statement_a({ inside_absolute_value: e2 });
      if (":" !== this.token.token_type && "MID" !== this.token.token_type) return r;
      let n = ":" === this.token.token_type ? ":" : "|";
      return this.advance(), [n, r, this.statement_a()];
    } catch (e3) {
      try {
        this.set_state(t2);
        let r = this.statement_a({ parse_absolute_value: false });
        if ("|" !== this.token.token_type[0]) throw e3;
        return this.advance(), ["|", r, this.statement_a({ parse_absolute_value: false })];
      } catch (t3) {
        throw e3;
      }
    }
  }
  statement_a({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true } = {}) {
    for (var r = this.statement_b({ inside_absolute_value: e2, parse_absolute_value: t2 }); ["IMPLIES", "IMPLIEDBY", "IFF", "LEFTARROW", "RIGHTARROW", "LEFTRIGHTARROW"].includes(this.token.token_type); ) {
      let n = this.token.token_type.toLowerCase();
      this.advance(), r = [n, r, this.statement_b({ inside_absolute_value: e2, parse_absolute_value: t2 })];
    }
    return r;
  }
  statement_b({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true } = {}) {
    for (var r = this.statement_c({ inside_absolute_value: e2, parse_absolute_value: t2 }); "OR" === this.token.token_type; ) {
      let n = this.token.token_type.toLowerCase();
      this.advance(), r = [n, r, this.statement_c({ inside_absolute_value: e2, parse_absolute_value: t2 })];
    }
    return r;
  }
  statement_c(e2) {
    for (var t2 = this.relation(e2); "AND" === this.token.token_type; ) {
      let r = this.token.token_type.toLowerCase();
      this.advance(), t2 = [r, t2, this.relation(e2)];
    }
    return t2;
  }
  relation(e2) {
    if ("NOT" === this.token.token_type || "!" === this.token.token_type) return this.advance(), ["not", this.relation(e2)];
    if ("FORALL" === this.token.token_type || "EXISTS" === this.token.token_type) {
      let t3 = this.token.token_type.toLowerCase();
      return this.advance(), [t3, this.relation(e2)];
    }
    for (var t2 = this.expression(e2); "=" === this.token.token_type || "NE" === this.token.token_type || "<" === this.token.token_type || ">" === this.token.token_type || "LE" === this.token.token_type || "GE" === this.token.token_type || "IN" === this.token.token_type || "NOTIN" === this.token.token_type || "NI" === this.token.token_type || "NOTNI" === this.token.token_type || "SUBSET" === this.token.token_type || "NOTSUBSET" === this.token.token_type || "SUBSETEQ" === this.token.token_type || "NOTSUBSETEQ" === this.token.token_type || "SUPERSET" === this.token.token_type || "NOTSUPERSET" === this.token.token_type || "SUPERSETEQ" === this.token.token_type || "NOTSUPERSETEQ" === this.token.token_type; ) {
      let r = this.token.token_type.toLowerCase(), n = 0;
      "<" === this.token.token_type || "LE" === this.token.token_type ? n = -1 : ">" !== this.token.token_type && "GE" !== this.token.token_type || (n = 1), this.advance();
      let i2 = this.expression(e2);
      if (-1 === n) if ("<" === this.token.token_type || "LE" === this.token.token_type) {
        let n3 = ["tuple"];
        "<" === r ? n3.push(true) : n3.push(false);
        let a = ["tuple", t2, i2];
        for (; "<" === this.token.token_type || "LE" === this.token.token_type; ) "<" === this.token.token_type ? n3.push(true) : n3.push(false), this.advance(), a.push(this.expression(e2));
        t2 = ["lts", a, n3];
      } else t2 = [r, t2, i2];
      else if (1 === n) if (">" === this.token.token_type || "GE" === this.token.token_type) {
        let n3 = ["tuple"];
        ">" === r ? n3.push(true) : n3.push(false);
        let a = ["tuple", t2, i2];
        for (; ">" === this.token.token_type || "GE" === this.token.token_type; ) ">" === this.token.token_type ? n3.push(true) : n3.push(false), this.advance(), a.push(this.expression(e2));
        t2 = ["gts", a, n3];
      } else t2 = [r, t2, i2];
      else if ("=" === r) for (t2 = ["=", t2, i2]; "=" === this.token.token_type; ) this.advance(), t2.push(this.expression(e2));
      else t2 = [r, t2, i2];
    }
    return t2;
  }
  expression(e2) {
    if ("NOT" === this.token.token_type || "!" === this.token.token_type) return this.advance(), ["not", this.expression(e2)];
    let t2 = false;
    "+" === this.token.token_type && (t2 = true, this.advance());
    let r = false;
    "-" === this.token.token_type && (r = true, this.advance());
    var n = this.term(e2);
    if (r || t2) {
      if (false === n) return (t2 ? "+" : "") + (r ? "-" : "");
      if ("string" == typeof n && [...n].every(((e3) => ["+", "-"].includes(e3)))) return (t2 ? "+" : "") + (r ? "-" : "") + n;
    }
    for (false === n && (n = "＿"), r && (n = n > 0 ? -n : ["-", n]), t2 && (n = ["+", n]); ["+", "-", "UNION", "INTERSECT", "PERP", "PARALLEL"].includes(this.token.token_type); ) {
      let t3 = this.token.token_type.toLowerCase(), r2 = false, i2 = false;
      "-" === this.token.token_type ? (t3 = "+", r2 = true, this.advance()) : (this.advance(), "+" === t3 && "-" === this.token.token_type && (r2 = true, i2 = true, this.advance()));
      let a = this.term(e2);
      if ("+" === t3) {
        if (false === a && ("number" == typeof n || "string" == typeof n)) return i2 ? n + "+-" : r2 ? n + "-" : n + "+";
        if ("string" == typeof a && [...a].every(((e3) => ["+", "-"].includes(e3))) && ("number" == typeof n || "string" == typeof n)) return i2 ? n + "+-" + a : r2 ? n + "-" + a : n + "+" + a;
      }
      false === a && (a = "＿"), r2 && (a = a > 0 ? -a : ["-", a]), n = [t3, n, a];
    }
    return n;
  }
  term(e2) {
    var t2 = this.factor(e2), r = false;
    do {
      if (r = false, "*" === this.token.token_type) {
        this.advance(), false === t2 && (t2 = "＿");
        let n = this.factor(e2);
        false === n && (n = "＿"), t2 = ["*", t2, n], r = true;
      } else if ("/" === this.token.token_type) {
        this.advance(), false === t2 && (t2 = "＿");
        let n = this.factor(e2);
        false === n && (n = "＿"), t2 = ["/", t2, n], r = true;
      } else {
        let n = Object.assign({}, e2);
        n.allow_absolute_value_closing = true;
        let i2 = this.nonMinusFactor(n);
        false !== i2 && (false === t2 && (t2 = "＿"), t2 = ["*", t2, i2], r = true);
      }
    } while (r);
    return this.convert_units_in_term(flatten$7(t2));
  }
  convert_units_in_term(e2) {
    if (!Array.isArray(e2)) return e2;
    let t2 = e2[0], r = e2.slice(1);
    if ("*" === t2) {
      let e3 = r.length;
      for (let [t3, n] of r.entries()) {
        let i2 = this.units[n];
        if (i2) {
          if (i2.prefix && t3 < e3 - 1) {
            let a;
            a = t3 === e3 - 2 ? r[e3 - 1] : this.convert_units_in_term(["*", ...r.slice(t3 + 1)]);
            let o = n;
            i2.substitute && (o = i2.substitute);
            let s = ["unit", o, a];
            return 0 === t3 ? s : ["*", ...r.slice(0, t3).map(this.convert_units_in_term.bind(this)), s];
          }
          if (!i2.prefix && t3 > 0) {
            let a, o = n;
            return i2.substitute && (o = i2.substitute), a = 1 === t3 ? ["unit", r[0], o] : ["unit", ["*", ...r.slice(0, t3).map(this.convert_units_in_term.bind(this))], o], t3 === e3 - 1 ? a : this.convert_units_in_term(["*", a, ...r.slice(t3 + 1)]);
          }
        }
      }
      return [t2, ...r.map(this.convert_units_in_term.bind(this))];
    }
    if ("/" === t2) return ["/", this.convert_units_in_term(r[0]), this.convert_units_in_term(r[1])];
    if ("^" === t2) {
      let e3 = this.units[r[1]];
      if (e3 && e3.isExponent) {
        let t3 = r[1];
        return e3.substitute && (t3 = e3.substitute), ["unit", r[0], t3];
      }
      return [t2, ...r.map(this.convert_units_in_term.bind(this))];
    }
    return [t2, ...r.map(this.convert_units_in_term.bind(this))];
  }
  factor(e2) {
    if ("+" === this.token.token_text) {
      this.advance();
      let t3 = this.factor(e2);
      return false === t3 ? "+" : "string" == typeof t3 && [...t3].every(((e3) => ["+", "-"].includes(e3))) ? "+" + t3 : ["+", t3];
    }
    if ("-" === this.token.token_type) {
      this.advance();
      let t3 = this.factor(e2);
      return t3 > 0 ? -t3 : false === t3 ? "-" : "string" == typeof t3 && [...t3].every(((e3) => ["+", "-"].includes(e3))) ? "-" + t3 : ["-", t3];
    }
    let t2 = this.nonMinusFactor(e2);
    return false === t2 && "PERP" === this.token.token_type && (t2 = "perp", this.advance()), t2;
  }
  nonMinusFactor(e2) {
    for (var t2 = this.baseFactor(e2); "^" === this.token.token_type || "!" === this.token.token_type || "'" === this.token.token_type; ) if (false === t2 && (t2 = "＿"), "^" === this.token.token_type) {
      this.advance(), t2 = ["^", t2, this.get_subsuperscript(e2)];
    } else "!" === this.token.token_type ? (t2 = ["apply", "factorial", t2], this.advance()) : (t2 = ["prime", t2], this.advance());
    return t2;
  }
  get_single_digit_as_number() {
    if ("NUMBER" === this.token.token_type && "." !== this.token.token_text[0]) {
      let e2 = Number(this.token.token_text[0]);
      return this.token.token_text.length > 1 && this.lexer.unput(this.token.token_text.slice(1)), this.advance(), e2;
    }
    return null;
  }
  get_subsuperscript({ parse_absolute_value: e2 }) {
    let t2 = this.get_single_digit_as_number();
    if (null !== t2) return t2;
    if (["+", "-", "PERP"].includes(this.token.token_type)) {
      let e3 = this.token.token_type.toLowerCase();
      return this.advance(), e3;
    }
    {
      let t3 = this.baseFactor({ parse_absolute_value: e2, in_subsuperscript_with_no_delimiters: true });
      return false === t3 && (t3 = "＿"), t3;
    }
  }
  baseFactor({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true, allow_absolute_value_closing: r = false, in_subsuperscript_with_no_delimiters: n = false } = {}) {
    var i2 = false;
    if ("BEGINENVIRONMENT" === this.token.token_type) {
      let e3 = /\\begin\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1];
      if (["matrix", "pmatrix", "bmatrix"].includes(e3)) {
        let r2 = 0, n3 = 0, a = [], o = [], s = 0, u = this.token.token_type;
        for (this.advance(); "ENDENVIRONMENT" !== this.token.token_type; ) "&" === this.token.token_type ? ("&" !== u && "LINEBREAK" !== u || (o.push(0), s += 1), u = this.token.token_type, this.advance()) : "LINEBREAK" === this.token.token_type ? ("&" !== u && "LINEBREAK" !== u || (o.push(0), s += 1), a.push(o), s > n3 && (n3 = s), r2 += 1, s = 0, o = [], u = this.token.token_type, this.advance()) : (o.push(this.statement({ parse_absolute_value: t2 })), s += 1, u = " ");
        if (/\\end\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1] !== e3) throw new ParseError$1("Expecting \\end{" + e3 + "}", this.lexer.location);
        "&" === u && (o.push(0), s += 1), a.push(o), s > n3 && (n3 = s), r2 += 1, this.advance(), i2 = ["matrix", ["tuple", r2, n3]];
        let c2 = ["tuple"];
        for (let e4 of a) {
          let t3 = ["tuple"].concat(e4);
          for (let r3 = e4.length; r3 < n3; r3 += 1) t3.push(0);
          c2.push(t3);
        }
        return i2.push(c2), i2;
      }
      throw new ParseError$1("Unrecognized environment " + e3, this.lexer.location);
    }
    if ("NUMBER" === this.token.token_type) i2 = parseFloat(this.token.token_text), this.advance();
    else if ("INFINITY" === this.token.token_type) i2 = 1 / 0, this.advance();
    else if ("SQRT" === this.token.token_type) {
      this.advance();
      let e3 = 2;
      if ("[" === this.token.token_type) {
        this.advance();
        let r3 = this.statement({ parse_absolute_value: t2 });
        if ("]" !== this.token.token_type) throw new ParseError$1("Expecting ]", this.lexer.location);
        this.advance(), e3 = r3;
      }
      if ("{" !== this.token.token_type) throw new ParseError$1("Expecting {", this.lexer.location);
      this.advance();
      let r2 = this.statement({ parse_absolute_value: t2 });
      if ("}" !== this.token.token_type) throw new ParseError$1("Expecting }", this.lexer.location);
      this.advance(), i2 = 2 === e3 ? ["apply", "sqrt", r2] : ["^", r2, ["/", 1, e3]];
    } else if ("VAR" === this.token.token_type || "LATEXCOMMAND" === this.token.token_type || "VARMULTICHAR" === this.token.token_type) {
      if (i2 = this.token.token_text, "LATEXCOMMAND" === this.token.token_type) {
        if (i2 = i2.slice(1), !(this.appliedFunctionSymbols.includes(i2) || this.functionSymbols.includes(i2) || this.allowedLatexSymbols.includes(i2) || i2 in this.operatorSymbols)) throw new ParseError$1("Unrecognized latex command " + this.token.original_text, this.lexer.location);
      } else "VARMULTICHAR" === this.token.token_type && (i2 = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(i2)[1]);
      if (this.appliedFunctionSymbols.includes(i2) || this.functionSymbols.includes(i2)) {
        let e3 = false;
        if (this.appliedFunctionSymbols.includes(i2) && (e3 = true), ["Re", "Im"].includes(i2) && (i2 = i2.toLowerCase()), this.advance(), "_" === this.token.token_type) {
          this.advance();
          let e4 = this.get_subsuperscript({ parse_absolute_value: t2 });
          i2 = "log" === i2 && 10 === e4 ? "log10" : ["_", i2, e4];
        }
        if (n) e3 && (i2 = ["apply", i2, "＿"]);
        else {
          for (; "'" === this.token.token_type; ) i2 = ["prime", i2], this.advance();
          for (; "^" === this.token.token_type; ) {
            this.advance(), i2 = ["^", i2, this.get_subsuperscript({ parse_absolute_value: t2 })];
          }
          if ("{" === this.token.token_type || "(" === this.token.token_type) {
            let e4;
            e4 = "{" === this.token.token_type ? "}" : ")", this.advance();
            let t3 = this.statement_list();
            if (this.token.token_type !== e4) throw new ParseError$1("Expecting " + e4, this.lexer.location);
            this.advance(), "list" === t3[0] && (t3[0] = "tuple"), i2 = ["apply", i2, t3];
          } else if (e3) {
            if (!this.allowSimplifiedFunctionApplication) throw new ParseError$1("Expecting ( after function", this.lexer.location);
            let e4 = this.factor({ parse_absolute_value: t2 });
            false === e4 && (e4 = "＿"), i2 = ["apply", i2, e4];
          }
        }
        return i2;
      }
      if (i2 in this.operatorSymbols) {
        if (this.advance(), "frac" === i2 && this.parseLeibnizNotation) {
          let e4 = this.return_state(), t3 = this.leibniz_notation();
          if (t3) return t3;
          this.set_state(e4);
        }
        let e3 = i2;
        this.operatorSymbols[i2].substitute && (e3 = this.operatorSymbols[i2].substitute);
        let r2 = this.operatorSymbols[i2].nargs, n3 = this.operatorSymbols[i2].remove_products, a = [];
        for (let e4 = 0; e4 < r2; e4++) if ("{" === this.token.token_type) {
          this.advance();
          let e5 = this.statement({ parse_absolute_value: t2 });
          if (n3 && Array.isArray(e5) && "*" === e5[0] ? a.push(...e5.slice(1)) : a.push(e5), "}" !== this.token.token_type) throw new ParseError$1("Expecting }", this.lexer.location);
          this.advance();
        } else {
          let e5 = this.get_single_digit_as_number();
          if (null === e5) {
            if ("VAR" !== this.token.token_type) throw new ParseError$1("Expecting {", this.lexer.location);
            e5 = this.token.token_text, this.advance();
          }
          a.push(e5);
        }
        i2 = [e3, ...a];
      } else this.advance();
    } else if ("(" === this.token.token_type || "[" === this.token.token_type || "{" === this.token.token_type || "LBRACE" === this.token.token_type || "LANGLE" === this.token.token_type) {
      let e3, t3, r2 = this.token.token_type;
      "(" === this.token.token_type ? (e3 = ")", t3 = "]") : "[" === this.token.token_type ? (e3 = "]", t3 = ")") : "{" === this.token.token_type ? (e3 = "}", t3 = null) : "LBRACE" === this.token.token_type ? (e3 = "RBRACE", t3 = null) : (e3 = "RANGLE", t3 = null), this.advance();
      let n3 = 1;
      if ("list" === (i2 = this.statement_list())[0] && (n3 = i2.length - 1), this.token.token_type !== e3) {
        if (2 !== n3 || null === t3) throw new ParseError$1("Expecting " + e3, this.lexer.location);
        if (this.token.token_type !== t3) throw new ParseError$1("Expecting ) or ]", this.lexer.location);
        let a;
        i2[0] = "tuple", a = "(" === r2 ? ["tuple", false, true] : ["tuple", true, false], (i2 = ["interval", i2]).push(a);
      } else n3 >= 2 ? i2[0] = "(" === r2 || "{" === r2 ? "tuple" : "[" === r2 ? "array" : "LBRACE" === r2 ? "set" : "altvector" : "LBRACE" === r2 && (i2 = ("|" === i2[0] || i2[0], ["set", i2]));
      this.advance();
    } else if ("|" !== this.token.token_type[0] || !t2 || 0 !== e2 && r && "L" !== this.token.token_type[1]) {
      if ("LFLOOR" === this.token.token_type || "LCEIL" === this.token.token_type) {
        let e3, t3;
        if ("LFLOOR" === this.token.token_type ? (e3 = "RFLOOR", t3 = "floor") : "LCEIL" === this.token.token_type && (e3 = "RCEIL", t3 = "ceil"), this.advance(), i2 = ["apply", t3, i2 = this.statement()], this.token.token_type !== e3) throw new ParseError$1("Expecting " + e3, this.lexer.location);
        this.advance();
      } else if ("ANGLE" === this.token.token_type) if (this.advance(), "{" === this.token.token_type || "(" === this.token.token_type) {
        let e3;
        e3 = "{" === this.token.token_type ? "}" : ")", this.advance();
        let t3 = this.statement_list();
        if (this.token.token_type !== e3) throw new ParseError$1("Expecting " + e3, this.lexer.location);
        this.advance(), "list" === t3[0] ? i2 = ["angle", ...t3.slice(1)] : "*" === t3[0] && (i2 = ["angle", t3]);
      } else {
        let e3 = [], r2 = this.nonMinusFactor({ parse_absolute_value: t2 });
        for (; false !== r2; ) e3.push(r2), r2 = this.nonMinusFactor({ parse_absolute_value: t2 });
        i2 = 0 === e3.length ? "angle" : ["angle", ...e3];
      }
      else if ("INT" === this.token.token_type) {
        this.advance();
        let e3 = "int";
        if ("_" === this.token.token_type) {
          this.advance(), e3 = ["_", e3, this.get_subsuperscript({ parse_absolute_value: t2 })];
        }
        if ("^" === this.token.token_type) {
          this.advance(), e3 = ["^", e3, this.get_subsuperscript({ parse_absolute_value: t2 })];
        }
        let r2 = flatten$7(this.term({ parse_absolute_value: t2 }));
        if (Array.isArray(r2) && "*" === r2[0]) {
          let e4 = [];
          for (let t3 = 0; t3 < r2.length - 1; t3++) {
            if ("d" === r2[t3]) {
              let n3 = r2[t3 + 1];
              r2.splice(t3, 2), e4.push(["d", n3]), t3--;
            }
          }
          r2.push(...e4);
        }
        return ["apply", e3, r2];
      }
    } else {
      if (e2 += 1, this.advance(), i2 = ["apply", "abs", i2 = this.statement({ inside_absolute_value: e2 })], "|" !== this.token.token_type) throw new ParseError$1("Expecting |", this.lexer.location);
      this.advance();
    }
    if ("_" === this.token.token_type) {
      false === i2 && (i2 = "＿"), this.advance(), i2 = ["_", i2, this.get_subsuperscript({ parse_absolute_value: t2 })];
    }
    return i2;
  }
  leibniz_notation() {
    if ("{" !== this.token.token_type) return false;
    this.advance();
    var e2 = this.token.token_text;
    let t2 = "", r = 1, n = "", i2 = [], a = [];
    if ("LATEXCOMMAND" === this.token.token_type && "partial" === e2.slice(1)) t2 = "∂";
    else {
      if ("VAR" !== this.token.token_type || "d" !== e2) return false;
      t2 = "d";
    }
    if (this.advance(), "^" === this.token.token_type) {
      this.advance();
      let e3 = false;
      if ("{" === this.token.token_type && (e3 = true, this.advance()), "NUMBER" !== this.token.token_type) return false;
      if (r = parseFloat(this.token.token_text), !Number.isInteger(r)) return false;
      if (e3 && (this.advance(), "}" !== this.token.token_type)) return false;
      this.advance();
    }
    if ("VAR" === this.token.token_type) n = this.token.token_text;
    else if ("VARMULTICHAR" === this.token.token_type) n = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1];
    else if ("LATEXCOMMAND" === this.token.token_type) {
      if (e2 = this.token.token_text.slice(1), !this.allowedLatexSymbols.includes(e2)) return false;
      n = e2;
    }
    if (this.advance(), "}" !== this.token.token_type) return false;
    if (this.advance(), "{" !== this.token.token_type) return false;
    this.advance();
    let o = 0;
    for (; ; ) {
      if (!("d" === t2 && "VAR" === this.token.token_type && "d" === this.token.token_text || "∂" === t2 && "LATEXCOMMAND" === this.token.token_type && "partial" === this.token.token_text.slice(1))) return false;
      if (this.advance(), "VAR" === this.token.token_type) i2.push(this.token.token_text);
      else if ("VARMULTICHAR" === this.token.token_type) i2.push(/\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1]);
      else {
        if ("LATEXCOMMAND" !== this.token.token_type) return false;
        {
          let e3 = this.token.token_text.slice(1);
          if (!this.allowedLatexSymbols.includes(e3)) return false;
          i2.push(e3);
        }
      }
      let s = 1;
      if (this.advance(), "^" === this.token.token_type) {
        this.advance();
        let e3 = false;
        if ("{" === this.token.token_type && (e3 = true, this.advance()), "NUMBER" !== this.token.token_type) return false;
        if (s = parseFloat(this.token.token_text), !Number.isInteger(s)) return false;
        if (e3 && (this.advance(), "}" !== this.token.token_type)) return false;
        this.advance();
      }
      if (a.push(s), o += s, o > r) return false;
      if (o === r) {
        if ("}" !== this.token.token_type) return false;
        this.advance();
        let o2 = "derivative_leibniz";
        "∂" === t2 && (o2 = "partial_" + o2), e2 = [o2], 1 === r ? e2.push(n) : e2.push(["tuple", n, r]);
        let s2 = [];
        for (let e3 = 0; e3 < i2.length; e3 += 1) 1 === a[e3] ? s2.push(i2[e3]) : s2.push(["tuple", i2[e3], a[e3]]);
        return s2 = ["tuple"].concat(s2), e2.push(s2), e2;
      }
    }
  }
};
let latexToGuppy$1 = class latexToGuppy2 {
  constructor() {
    this.latexToAst = new latexToAst$1$1(), this.astToGuppy = new astToGuppy$1$1();
  }
  convert(e2) {
    return this.astToGuppy.convert(this.latexToAst.convert(e2));
  }
};
let latexToMathjs$1 = class latexToMathjs2 {
  constructor() {
    this.latexToAst = new latexToAst$1$1(), this.astToMathjs = new astToMathjs$1$1();
  }
  convert(e2) {
    return this.astToMathjs.convert(this.latexToAst.convert(e2));
  }
};
let latexToText$1 = class latexToText2 {
  constructor() {
    this.latexToAst = new latexToAst$1$1(), this.astToText = new astToText$2$1();
  }
  convert(e2) {
    return this.astToText.convert(this.latexToAst.convert(e2));
  }
};
const operators$4 = { "+,add": function(e2) {
  return ["+"].concat(e2);
}, "*,multiply": function(e2) {
  return ["*"].concat(e2);
}, "/,divide": function(e2) {
  return ["/", e2[0], e2[1]];
}, "-,unaryMinus": function(e2) {
  return ["-", e2[0]];
}, "-,subtract": function(e2) {
  return ["+", e2[0], ["-", e2[1]]];
}, "^,pow": function(e2) {
  return ["^", e2[0], e2[1]];
}, "and,and": function(e2) {
  return ["and"].concat(e2);
}, "or,or": function(e2) {
  return ["or"].concat(e2);
}, "not,not": function(e2) {
  return ["not", e2[0]];
}, "==,equal": function(e2) {
  return ["="].concat(e2);
}, "<,smaller": function(e2) {
  return ["<", e2[0], e2[1]];
}, ">,larger": function(e2) {
  return [">", e2[0], e2[1]];
}, "<=,smallerEq": function(e2) {
  return ["le", e2[0], e2[1]];
}, ">=,largerEq": function(e2) {
  return ["ge", e2[0], e2[1]];
}, "!=,unequal": function(e2) {
  return ["ne", e2[0], e2[1]];
}, "!,factorial": function(e2) {
  return ["apply", "factorial", e2[0]];
} };
let mathjsToAst$1 = class mathjsToAst2 {
  convert(e2) {
    if (e2.isConstantNode) return e2.value;
    if (e2.isSymbolNode) return e2.name;
    if (e2.isOperatorNode) {
      var t2 = [e2.op, e2.fn].join(",");
      if (t2 in operators$4) return operators$4[t2](e2.args.map((function(e3, t3) {
        return this.convert(e3);
      }).bind(this)));
      throw Error("Unsupported operator: " + e2.op + ", " + e2.fn);
    }
    if (e2.isFunctionNode) {
      var r = e2.args.map((function(e3, t3) {
        return this.convert(e3);
      }).bind(this));
      r = r.length > 1 ? ["tuple"].concat(r) : r[0];
      var n = ["apply", e2.name];
      return n.push(r), n;
    }
    if (e2.isArrayNode) return ["vector"].concat(e2.args.map((function(e3, t3) {
      return this.convert(e3);
    }).bind(this)));
    if (e2.isParenthesisNode) return this.convert(e2.content);
    throw Error("Unsupported node type: " + e2.type);
  }
};
let mathjsToGuppy$1 = class mathjsToGuppy2 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToGuppy = new astToGuppy$1$1();
  }
  convert(e2) {
    return this.astToGuppy.convert(this.mathjsToAst.convert(e2));
  }
};
let mathjsToLatex$1 = class mathjsToLatex2 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToLatex = new astToLatex$1$1();
  }
  convert(e2) {
    return this.astToLatex.convert(this.mathjsToAst.convert(e2));
  }
};
let mathjsToText$1 = class mathjsToText2 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToText = new astToText$2$1();
  }
  convert(e2) {
    return this.astToText.convert(this.mathjsToAst.convert(e2));
  }
};
function defaultSetTimout$1() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout$1() {
  throw new Error("clearTimeout has not been defined");
}
var cachedSetTimeout$1 = defaultSetTimout$1, cachedClearTimeout$1 = defaultClearTimeout$1;
function runTimeout$1(e2) {
  if (cachedSetTimeout$1 === setTimeout) return setTimeout(e2, 0);
  if ((cachedSetTimeout$1 === defaultSetTimout$1 || !cachedSetTimeout$1) && setTimeout) return cachedSetTimeout$1 = setTimeout, setTimeout(e2, 0);
  try {
    return cachedSetTimeout$1(e2, 0);
  } catch (t2) {
    try {
      return cachedSetTimeout$1.call(null, e2, 0);
    } catch (t3) {
      return cachedSetTimeout$1.call(this, e2, 0);
    }
  }
}
function runClearTimeout$1(e2) {
  if (cachedClearTimeout$1 === clearTimeout) return clearTimeout(e2);
  if ((cachedClearTimeout$1 === defaultClearTimeout$1 || !cachedClearTimeout$1) && clearTimeout) return cachedClearTimeout$1 = clearTimeout, clearTimeout(e2);
  try {
    return cachedClearTimeout$1(e2);
  } catch (t2) {
    try {
      return cachedClearTimeout$1.call(null, e2);
    } catch (t3) {
      return cachedClearTimeout$1.call(this, e2);
    }
  }
}
"function" == typeof global$1$1.setTimeout && (cachedSetTimeout$1 = setTimeout), "function" == typeof global$1$1.clearTimeout && (cachedClearTimeout$1 = clearTimeout);
var queue$1 = [], draining$1 = false, currentQueue$1, queueIndex$1 = -1;
function cleanUpNextTick$1() {
  draining$1 && currentQueue$1 && (draining$1 = false, currentQueue$1.length ? queue$1 = currentQueue$1.concat(queue$1) : queueIndex$1 = -1, queue$1.length && drainQueue$1());
}
function drainQueue$1() {
  if (!draining$1) {
    var e2 = runTimeout$1(cleanUpNextTick$1);
    draining$1 = true;
    for (var t2 = queue$1.length; t2; ) {
      for (currentQueue$1 = queue$1, queue$1 = []; ++queueIndex$1 < t2; ) currentQueue$1 && currentQueue$1[queueIndex$1].run();
      queueIndex$1 = -1, t2 = queue$1.length;
    }
    currentQueue$1 = null, draining$1 = false, runClearTimeout$1(e2);
  }
}
function nextTick$1(e2) {
  var t2 = new Array(arguments.length - 1);
  if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) t2[r - 1] = arguments[r];
  queue$1.push(new Item$1(e2, t2)), 1 !== queue$1.length || draining$1 || runTimeout$1(drainQueue$1);
}
function Item$1(e2, t2) {
  this.fun = e2, this.array = t2;
}
Item$1.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var title$1 = "browser", platform$2 = "browser", browser$1$2 = true, env$1 = {}, argv$1 = [], version$2 = "", versions$1 = {}, release$1 = {}, config$3 = {};
function noop$5() {
}
var on$2 = noop$5, addListener$1 = noop$5, once$2 = noop$5, off$1 = noop$5, removeListener$1 = noop$5, removeAllListeners$1 = noop$5, emit$1 = noop$5;
function binding$1(e2) {
  throw new Error("process.binding is not supported");
}
function cwd$3() {
  return "/";
}
function chdir$1(e2) {
  throw new Error("process.chdir is not supported");
}
function umask$1() {
  return 0;
}
var performance$2 = global$1$1.performance || {}, performanceNow$1 = performance$2.now || performance$2.mozNow || performance$2.msNow || performance$2.oNow || performance$2.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function hrtime$1(e2) {
  var t2 = 1e-3 * performanceNow$1.call(performance$2), r = Math.floor(t2), n = Math.floor(t2 % 1 * 1e9);
  return e2 && (r -= e2[0], (n -= e2[1]) < 0 && (r--, n += 1e9)), [r, n];
}
var startTime$1 = /* @__PURE__ */ new Date();
function uptime$1() {
  return (/* @__PURE__ */ new Date() - startTime$1) / 1e3;
}
var browser$1$1$2 = { nextTick: nextTick$1, title: title$1, browser: browser$1$2, env: env$1, argv: argv$1, version: version$2, versions: versions$1, on: on$2, addListener: addListener$1, once: once$2, off: off$1, removeListener: removeListener$1, removeAllListeners: removeAllListeners$1, emit: emit$1, binding: binding$1, cwd: cwd$3, chdir: chdir$1, umask: umask$1, hrtime: hrtime$1, platform: platform$2, release: release$1, config: config$3, uptime: uptime$1 }, browser$4 = { exports: {} }, debug$1 = { exports: {} }, ms$1, hasRequiredMs$1, hasRequiredDebug$1, hasRequiredBrowser$3, xmlParser$1, hasRequiredXmlParser$1;
function requireMs$1() {
  if (hasRequiredMs$1) return ms$1;
  hasRequiredMs$1 = 1;
  var e2 = 1e3, t2 = 60 * e2, r = 60 * t2, n = 24 * r, i2 = 365.25 * n;
  function a(e3, t3, r2) {
    if (!(e3 < t3)) return e3 < 1.5 * t3 ? Math.floor(e3 / t3) + " " + r2 : Math.ceil(e3 / t3) + " " + r2 + "s";
  }
  return ms$1 = function(o, s) {
    s = s || {};
    var u = typeof o;
    if ("string" === u && o.length > 0) return (function(a2) {
      if ((a2 = String(a2)).length > 100) return;
      var o2 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(a2);
      if (!o2) return;
      var s2 = parseFloat(o2[1]);
      switch ((o2[2] || "ms").toLowerCase()) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return s2 * i2;
        case "days":
        case "day":
        case "d":
          return s2 * n;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return s2 * r;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return s2 * t2;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return s2 * e2;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return s2;
        default:
          return;
      }
    })(o);
    if ("number" === u && false === isNaN(o)) return s.long ? (function(i3) {
      return a(i3, n, "day") || a(i3, r, "hour") || a(i3, t2, "minute") || a(i3, e2, "second") || i3 + " ms";
    })(o) : (function(i3) {
      if (i3 >= n) return Math.round(i3 / n) + "d";
      if (i3 >= r) return Math.round(i3 / r) + "h";
      if (i3 >= t2) return Math.round(i3 / t2) + "m";
      if (i3 >= e2) return Math.round(i3 / e2) + "s";
      return i3 + "ms";
    })(o);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(o));
  }, ms$1;
}
function requireDebug$1() {
  return hasRequiredDebug$1 || (hasRequiredDebug$1 = 1, (function(e2, t2) {
    var r;
    function n(e3) {
      function n3() {
        if (n3.enabled) {
          var e4 = n3, i2 = +/* @__PURE__ */ new Date(), a = i2 - (r || i2);
          e4.diff = a, e4.prev = r, e4.curr = i2, r = i2;
          for (var o = new Array(arguments.length), s = 0; s < o.length; s++) o[s] = arguments[s];
          o[0] = t2.coerce(o[0]), "string" != typeof o[0] && o.unshift("%O");
          var u = 0;
          o[0] = o[0].replace(/%([a-zA-Z%])/g, (function(r2, n4) {
            if ("%%" === r2) return r2;
            u++;
            var i3 = t2.formatters[n4];
            if ("function" == typeof i3) {
              var a2 = o[u];
              r2 = i3.call(e4, a2), o.splice(u, 1), u--;
            }
            return r2;
          })), t2.formatArgs.call(e4, o), (n3.log || t2.log || console.log.bind(console)).apply(e4, o);
        }
      }
      return n3.namespace = e3, n3.enabled = t2.enabled(e3), n3.useColors = t2.useColors(), n3.color = (function(e4) {
        var r2, n4 = 0;
        for (r2 in e4) n4 = (n4 << 5) - n4 + e4.charCodeAt(r2), n4 |= 0;
        return t2.colors[Math.abs(n4) % t2.colors.length];
      })(e3), "function" == typeof t2.init && t2.init(n3), n3;
    }
    (t2 = e2.exports = n.debug = n.default = n).coerce = function(e3) {
      return e3 instanceof Error ? e3.stack || e3.message : e3;
    }, t2.disable = function() {
      t2.enable("");
    }, t2.enable = function(e3) {
      t2.save(e3), t2.names = [], t2.skips = [];
      for (var r2 = ("string" == typeof e3 ? e3 : "").split(/[\s,]+/), n3 = r2.length, i2 = 0; i2 < n3; i2++) r2[i2] && ("-" === (e3 = r2[i2].replace(/\*/g, ".*?"))[0] ? t2.skips.push(new RegExp("^" + e3.substr(1) + "$")) : t2.names.push(new RegExp("^" + e3 + "$")));
    }, t2.enabled = function(e3) {
      var r2, n3;
      for (r2 = 0, n3 = t2.skips.length; r2 < n3; r2++) if (t2.skips[r2].test(e3)) return false;
      for (r2 = 0, n3 = t2.names.length; r2 < n3; r2++) if (t2.names[r2].test(e3)) return true;
      return false;
    }, t2.humanize = requireMs$1(), t2.names = [], t2.skips = [], t2.formatters = {};
  })(debug$1, debug$1.exports)), debug$1.exports;
}
function requireBrowser$3() {
  return hasRequiredBrowser$3 || (hasRequiredBrowser$3 = 1, (function(e2, t2) {
    function r() {
      var e3;
      try {
        e3 = t2.storage.debug;
      } catch (e4) {
      }
      return !e3 && void 0 !== browser$1$1$2 && "env" in browser$1$1$2 && (e3 = browser$1$1$2.env.DEBUG), e3;
    }
    (t2 = e2.exports = requireDebug$1()).log = function() {
      return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }, t2.formatArgs = function(e3) {
      var r2 = this.useColors;
      if (e3[0] = (r2 ? "%c" : "") + this.namespace + (r2 ? " %c" : " ") + e3[0] + (r2 ? "%c " : " ") + "+" + t2.humanize(this.diff), !r2) return;
      var n = "color: " + this.color;
      e3.splice(1, 0, n, "color: inherit");
      var i2 = 0, a = 0;
      e3[0].replace(/%[a-zA-Z%]/g, (function(e4) {
        "%%" !== e4 && (i2++, "%c" === e4 && (a = i2));
      })), e3.splice(a, 0, n);
    }, t2.save = function(e3) {
      try {
        null == e3 ? t2.storage.removeItem("debug") : t2.storage.debug = e3;
      } catch (e4) {
      }
    }, t2.load = r, t2.useColors = function() {
      if ("undefined" != typeof window && window.process && "renderer" === window.process.type) return true;
      return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }, t2.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : (function() {
      try {
        return window.localStorage;
      } catch (e3) {
      }
    })(), t2.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"], t2.formatters.j = function(e3) {
      try {
        return JSON.stringify(e3);
      } catch (e4) {
        return "[UnexpectedJSONParseError]: " + e4.message;
      }
    }, t2.enable(r());
  })(browser$4, browser$4.exports)), browser$4.exports;
}
function requireXmlParser$1() {
  if (hasRequiredXmlParser$1) return xmlParser$1;
  hasRequiredXmlParser$1 = 1;
  var e2 = requireBrowser$3()("xml-parser");
  return xmlParser$1 = function(t2) {
    return t2 = (t2 = t2.trim()).replace(/<!--[\s\S]*?-->/g, ""), r();
    function r() {
      return { declaration: n(), root: i2() };
    }
    function n() {
      if (o(/^<\?xml\s*/)) {
        for (var e3 = { attributes: {} }; !s() && !u("?>"); ) {
          var t3 = a();
          if (!t3) return e3;
          e3.attributes[t3.name] = t3.value;
        }
        return o(/\?>\s*/), e3;
      }
    }
    function i2() {
      e2("tag %j", t2);
      var r2 = o(/^<([\w-:.]+)\s*/);
      if (r2) {
        for (var n3, c2 = { name: r2[1], attributes: {}, children: [] }; !(s() || u(">") || u("?>") || u("/>")); ) {
          var l = a();
          if (!l) return c2;
          c2.attributes[l.name] = l.value;
        }
        if (o(/^\s*\/>\s*/)) return c2;
        for (o(/\??>\s*/), c2.content = (function() {
          e2("content %j", t2);
          var r3 = o(/^([^<]*)/);
          return r3 ? r3[1] : "";
        })(); n3 = i2(); ) c2.children.push(n3);
        return o(/^<\/[\w-:.]+>\s*/), c2;
      }
    }
    function a() {
      e2("attribute %j", t2);
      var r2, n3 = o(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/);
      if (n3) return { name: n3[1], value: (r2 = n3[2], r2.replace(/^['"]|['"]$/g, "")) };
    }
    function o(e3) {
      var r2 = t2.match(e3);
      if (r2) return t2 = t2.slice(r2[0].length), r2;
    }
    function s() {
      return 0 == t2.length;
    }
    function u(e3) {
      return 0 == t2.indexOf(e3);
    }
  }, xmlParser$1;
}
var xmlParserExports$1 = requireXmlParser$1(), parseString$1 = getDefaultExportFromCjs$5(xmlParserExports$1);
const entities$1 = { "&#913;": "\\Alpha", "&Alpha;": "\\Alpha", "&#x0391;": "\\Alpha", "\\u0391;": "\\Alpha", "&#914;": "\\Beta", "&Beta;": "\\Beta", "&#x0392;": "\\Beta", "\\u0392;": "\\Beta", "&#915;": "\\Gamma", "&Gamma;": "\\Gamma", "&#x0393;": "\\Gamma", "\\u0393;": "\\Gamma", "&#916;": "\\Delta", "&Delta;": "\\Delta", "&#x0394;": "\\Delta", "\\u0394;": "\\Delta", "&#917;": "\\Epsilon", "&Epsilon;": "\\Epsilon", "&#x0395;": "\\Epsilon", "\\u0395;": "\\Epsilon", "&#918;": "\\Zeta", "&Zeta;": "\\Zeta", "&#x0396;": "\\Zeta", "\\u0396;": "\\Zeta", "&#919;": "\\Eta", "&Eta;": "\\Eta", "&#x0397;": "\\Eta", "\\u0397;": "\\Eta", "&#920;": "\\Theta", "&Theta;": "\\Theta", "&#x0398;": "\\Theta", "\\u0398;": "\\Theta", "&#921;": "\\Iota", "&Iota;": "\\Iota", "&#x0399;": "\\Iota", "\\u0399;": "\\Iota", "&#922;": "\\Kappa", "&Kappa;": "\\Kappa", "&#x039A;": "\\Kappa", "\\u039A;": "\\Kappa", "&#923;": "\\Lambda", "&Lambda;": "\\Lambda", "&#x039B;": "\\Lambda", "\\u039B;": "\\Lambda", "&#924;": "\\Mu", "&Mu;": "\\Mu", "&#x039C;": "\\Mu", "\\u039C;": "\\Mu", "&#925;": "\\Nu", "&Nu;": "\\Nu", "&#x039D;": "\\Nu", "\\u039D;": "\\Nu", "&#926;": "\\Xi", "&Xi;": "\\Xi", "&#x039E;": "\\Xi", "\\u039E;": "\\Xi", "&#927;": "\\Omicron", "&Omicron;": "\\Omicron", "&#x039F;": "\\Omicron", "\\u039F;": "\\Omicron", "&#928;": "\\Pi", "&Pi;": "\\Pi", "&#x03A0;": "\\Pi", "\\u03A0;": "\\Pi", "&#929;": "\\Rho", "&Rho;": "\\Rho", "&#x03A1;": "\\Rho", "\\u03A1;": "\\Rho", "&#931;": "\\Sigma", "&Sigma;": "\\Sigma", "&#x03A3;": "\\Sigma", "\\u03A3;": "\\Sigma", "&#932;": "\\Tau", "&Tau;": "\\Tau", "&#x03A4;": "\\Tau", "\\u03A4;": "\\Tau", "&#933;": "\\Upsilon", "&Upsilon;": "\\Upsilon", "&#x03A5;": "\\Upsilon", "\\u03A5;": "\\Upsilon", "&#934;": "\\Phi", "&Phi;": "\\Phi", "&#x03A6;": "\\Phi", "\\u03A6;": "\\Phi", "&#935;": "\\Chi", "&Chi;": "\\Chi", "&#x03A7;": "\\Chi", "\\u03A7;": "\\Chi", "&#936;": "\\Psi", "&Psi;": "\\Psi", "&#x03A8;": "\\Psi", "\\u03A8;": "\\Psi", "&#937;": "\\Omega", "&Omega;": "\\Omega", "&#x03A9;": "\\Omega", "\\u03A9;": "\\Omega", "&#945;": "\\alpha", "&alpha;": "\\alpha", "&#x03B1;": "\\alpha", "\\u03B1;": "\\alpha", "&#946;": "\\beta", "&beta;": "\\beta", "&#x03B2;": "\\beta", "\\u03B2;": "\\beta", "&#947;": "\\gamma", "&gamma;": "\\gamma", "&#x03B3;": "\\gamma", "\\u03B3;": "\\gamma", "&#948;": "\\delta", "&delta;": "\\delta", "&#x03B4;": "\\delta", "\\u03B4;": "\\delta", "&#949;": "\\epsilon", "&epsilon;": "\\epsilon", "&#x03B5;": "\\epsilon", "\\u03B5;": "\\epsilon", "&#950;": "\\zeta", "&zeta;": "\\zeta", "&#x03B6;": "\\zeta", "\\u03B6;": "\\zeta", "&#951;": "\\eta", "&eta;": "\\eta", "&#x03B7;": "\\eta", "\\u03B7;": "\\eta", "&#952;": "\\theta", "&theta;": "\\theta", "&#x03B8;": "\\theta", "\\u03B8;": "\\theta", "&#953;": "\\iota", "&iota;": "\\iota", "&#x03B9;": "\\iota", "\\u03B9;": "\\iota", "&#954;": "\\kappa", "&kappa;": "\\kappa", "&#x03BA;": "\\kappa", "\\u03BA;": "\\kappa", "&#955;": "\\lambda", "&lambda;": "\\lambda", "&#x03BB;": "\\lambda", "\\u03BB;": "\\lambda", "&#956;": "\\mu", "&mu;": "\\mu", "&#x03BC;": "\\mu", "\\u03BC;": "\\mu", "&#957;": "\\nu", "&nu;": "\\nu", "&#x03BD;": "\\nu", "\\u03BD;": "\\nu", "&#958;": "\\xi", "&xi;": "\\xi", "&#x03BE;": "\\xi", "\\u03BE;": "\\xi", "&#959;": "\\omicron", "&omicron;": "\\omicron", "&#x03BF;": "\\omicron", "\\u03BF;": "\\omicron", "&#960;": "\\pi", "&pi;": "\\pi", "&#x03C0;": "\\pi", "\\u03C0;": "\\pi", "&#961;": "\\rho", "&rho;": "\\rho", "&#x03C1;": "\\rho", "\\u03C1;": "\\rho", "&#962;": "\\sigma", ";": "\\sigma", "&#x03C2;": "\\sigma", "\\u03C2;": "\\sigma", "&#963;": "\\sigma", "&sigma;": "\\sigma", "&#x03C3;": "\\sigma", "\\u03C3;": "\\sigma", "&#964;": "\\tau", "&tau;": "\\tau", "&#x03C4;": "\\tau", "\\u03C4;": "\\tau", "&#965;": "\\upsilon", "&upsilon;": "\\upsilon", "&#x03C5;": "\\upsilon", "\\u03C5;": "\\upsilon", "&#966;": "\\phi", "&phi;": "\\phi", "&#x03C6;": "\\phi", "\\u03C6;": "\\phi", "&#967;": "\\chi", "&chi;": "\\chi", "&#x03C7;": "\\chi", "\\u03C7;": "\\chi", "&#968;": "\\psi", "&psi;": "\\psi", "&#x03C8;": "\\psi", "\\u03C8;": "\\psi", "&#969;": "\\omega", "&omega;": "\\omega", "&#x03C9;": "\\omega", "\\u03C9;": "\\omega", "&#x2212;": "-", "&minus;": "-", "&#x221E;": "\\infty", "&#8734;": "\\infty", "&infin;": "\\infty", "&sdot;": "\\cdot", "&#x22C5;": "\\cdot", "&#8901;": "\\cdot", "&times;": "\\times", "&#x00D7;": "\\times", "&#215;": "\\times" };
let mmlToLatex$1 = class mmlToLatex2 {
  parse(e2) {
    return "mi" === e2.name ? entities$1[e2.content] ? entities$1[e2.content] : e2.content.length > 1 ? "\\" + e2.content : e2.content : "mn" === e2.name ? e2.content : "msup" === e2.name ? this.parse(e2.children[0]) + "^{" + this.parse(e2.children[1]) + "}" : "mroot" === e2.name ? "\\sqrt[" + this.parse(e2.children[1]) + "]{" + this.parse(e2.children[1]) + "}" : "mfrac" === e2.name ? "\\frac{" + this.parse(e2.children[0]) + "}{" + this.parse(e2.children[1]) + "}" : "msqrt" === e2.name ? "\\sqrt{" + e2.children.map((function(e3, t2) {
      return this.parse(e3);
    }).bind(this)).join(" ") + "}" : "mo" === e2.name ? entities$1[e2.content] ? entities$1[e2.content] : "&#x2061;" === e2.content ? " " : e2.content : "mrow" === e2.name && "MJX-TeXAtom-ORD" === e2.attributes.class ? e2.children.map((function(e3, t2) {
      return this.parse(e3);
    }).bind(this)).join(" ") : "math" === e2.name || "mrow" === e2.name ? "(" + e2.children.map((function(e3, t2) {
      return this.parse(e3);
    }).bind(this)).join(" ") + ")" : void 0;
  }
  convert(e2) {
    return this.parse(parseString$1(e2).root);
  }
};
let mmlToAst$1$1 = class mmlToAst$12 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$1(), this.latexToAst = new latexToAst$1$1();
  }
  convert(e2) {
    return this.latexToAst.convert(this.mmlToLatex.convert(e2));
  }
};
let mmlToGuppy$1 = class mmlToGuppy2 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$1(), this.latexToAst = new latexToAst$1$1(), this.astToGuppy = new astToGuppy$1$1();
  }
  convert(e2) {
    return this.astToGuppy.convert(this.latexToAst.convert(this.mmlToLatex.convert(e2)));
  }
};
let mmlToMathjs$1 = class mmlToMathjs2 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$1(), this.latexToAst = new latexToAst$1$1(), this.astToMathjs = new astToMathjs$1$1();
  }
  convert(e2) {
    return this.astToMathjs.convert(this.latexToAst.convert(this.mmlToLatex.convert(e2)));
  }
};
let mmlToText$1 = class mmlToText2 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$1(), this.latexToAst = new latexToAst$1$1(), this.astToText = new astToText$2$1();
  }
  convert(e2) {
    return this.astToText.convert(this.latexToAst.convert(this.mmlToLatex.convert(e2)));
  }
};
let textToGuppy$1 = class textToGuppy2 {
  constructor() {
    this.textToAst = new textToAst$4$1(), this.astToGuppy = new astToGuppy$1$1();
  }
  convert(e2) {
    return this.astToGuppy.convert(this.textToAst.convert(e2));
  }
};
let textToLatex$1 = class textToLatex2 {
  constructor() {
    this.textToAst = new textToAst$4$1(), this.astToLatex = new astToLatex$1$1();
  }
  convert(e2) {
    return this.astToLatex.convert(this.textToAst.convert(e2));
  }
};
let textToMathjs$1 = class textToMathjs2 {
  constructor() {
    this.textToAst = new textToAst$4$1(), this.astToMathjs = new astToMathjs$1$1();
  }
  convert(e2) {
    return this.astToMathjs.convert(this.textToAst.convert(e2));
  }
};
var converters$1 = Object.freeze({ __proto__: null, astToLatexObj: astToLatex$1$1, astToTextObj: astToText$2$1, astToGuppyObj: astToGuppy$1$1, astToMathjsObj: astToMathjs$1$1, astToFiniteFieldObj: astToFiniteField$1$1, latexToAstObj: latexToAst$1$1, latexToGuppyObj: latexToGuppy$1, latexToMathjsObj: latexToMathjs$1, latexToTextObj: latexToText$1, mathjsToAstObj: mathjsToAst$1, mathjsToGuppyObj: mathjsToGuppy$1, mathjsToLatexObj: mathjsToLatex$1, mathjsToTextObj: mathjsToText$1, mmlToAstObj: mmlToAst$1$1, mmlToGuppyObj: mmlToGuppy$1, mmlToLatexObj: mmlToLatex$1, mmlToMathjsObj: mmlToMathjs$1, mmlToTextObj: mmlToText$1, textToAstObj: textToAst$4$1, textToGuppyObj: textToGuppy$1, textToLatexObj: textToLatex$1, textToMathjsObj: textToMathjs$1, astToGLSL: astToGLSL$1$1 }), textToAst$5 = new textToAst$4$1(), latexToAst$2 = new latexToAst$1$1(), mmlToAst$2 = new mmlToAst$1$1(), utils$2 = { match: match$2$1, flatten: flatten$5$1, unflattenLeft: unflattenLeft$1, unflattenRight: unflattenRight$1 };
function Expression$1(e2, t2) {
  this.tree = flatten$5$1(e2), this.context = t2, this.toJSON = function() {
    let e3 = { objectType: "math-expression", tree: this.tree }, t3 = {};
    for (let e4 in this.context.assumptions) Object.keys(this.context.assumptions[e4]).length > 0 && (t3[e4] = this.context.assumptions[e4]);
    return Object.keys(t3).length > 0 && (e3.assumptions = t3), e3;
  };
}
function extend$5(e2, t2) {
  return flatten_array$1(Array.prototype.slice.call(arguments, 2)).forEach((function(r) {
    if (r) for (var n in r) t2 ? (function() {
      var t3 = n;
      e2[t3] = function() {
        return this.fromAst(r[t3].apply(null, arguments));
      };
    })() : e2[n] = r[n];
  })), e2;
}
function extend_prototype$1(e2, t2) {
  return flatten_array$1(Array.prototype.slice.call(arguments, 2)).forEach((function(r) {
    if (r) for (var n in r) !(function() {
      var i2 = n;
      e2[i2] = function() {
        var e3 = [this].concat(Array.prototype.slice.call(arguments));
        return t2 ? this.context.fromAst(r[i2].apply(null, e3)) : r[i2].apply(null, e3);
      };
    })();
  })), e2;
}
function create_from_multiple$1(e2, t2) {
  if (Array.isArray(e2) || "number" == typeof e2) return new Expression$1(e2, Context$1);
  if ("string" == typeof e2) try {
    return new Expression$1(textToAst$5.convert(e2), Context$1);
  } catch (t3) {
    try {
      return new Expression$1(latexToAst$2.convert(e2), Context$1);
    } catch (r) {
      try {
        return new Expression$1(mmlToAst$2.convert(e2), Context$1);
      } catch (n) {
        if (-1 !== e2.indexOf("\\")) throw r;
        if (-1 !== e2.indexOf("</")) throw n;
        throw t3;
      }
    }
  }
}
function parseText$1(e2, t2) {
  return new Expression$1(textToAst$5.convert(e2), Context$1);
}
function parseLatex$1(e2, t2) {
  return new Expression$1(latexToAst$2.convert(e2), Context$1);
}
function parseMml$1(e2, t2) {
  return new Expression$1(mmlToAst$2.convert(e2), Context$1);
}
var Context$1 = { ZmodN: ZmodN$1, assumptions: initialize_assumptions$1(), parser_parameters: {}, from: create_from_multiple$1, fromText: parseText$1, parse: parseText$1, fromLaTeX: parseLatex$1, fromLatex: parseLatex$1, fromTeX: parseLatex$1, fromTex: parseLatex$1, fromMml: parseMml$1, parse_tex: parseLatex$1, converters: converters$1, utils: utils$2, fromAst: function(e2) {
  return new Expression$1(e2, this);
}, set_to_default: function() {
  this.assumptions = initialize_assumptions$1();
}, get_assumptions: function(e2, t2) {
  return get_assumptions$1(this.assumptions, e2, t2);
}, add_assumption: function(e2, t2) {
  return add_assumption$1(this.assumptions, e2, t2);
}, add_generic_assumption: function(e2) {
  return add_generic_assumption$1(this.assumptions, e2);
}, remove_assumption: function(e2) {
  return remove_assumption$1(this.assumptions, e2);
}, remove_generic_assumption: function(e2) {
  return remove_generic_assumption$1(this.assumptions, e2);
}, clear_assumptions: function() {
  this.assumptions = initialize_assumptions$1();
}, math: math$1$1, reviver: function(e2, t2) {
  if (t2 && "math-expression" === t2.objectType && void 0 !== t2.tree) {
    let e3 = Context$1.fromAst(t2.tree);
    return void 0 !== t2.assumptions && (e3.assumptions = t2.assumptions), e3;
  }
  return t2;
}, class: Expression$1 };
function flatten_array$1(e2, t2) {
  t2 = void 0 === t2 ? [] : t2;
  for (var r = 0; r < e2.length; r++) Array.isArray(e2[r]) ? flatten_array$1(e2[r], t2) : t2.push(e2[r]);
  return t2;
}
Context$1.set_to_default(), extend$5(Context$1, true, expression_to_tree$1$1, expression_to_tree$2), extend$5(Context$1, false, expression_to_other$1), extend_prototype$1(Expression$1.prototype, true, expression_to_tree$1$1), extend_prototype$1(Expression$1.prototype, false, expression_to_other$1);
var commonjsGlobal$2 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$4(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var base32$1$1 = { exports: {} };
var hasRequiredBase32$1;
function requireBase32$1() {
  if (hasRequiredBase32$1) return base32$1$1.exports;
  hasRequiredBase32$1 = 1;
  (function(module) {
    (function() {
      var root2 = typeof window === "object" ? window : {};
      var NODE_JS = !root2.HI_BASE32_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
      if (NODE_JS) {
        root2 = commonjsGlobal$2;
      }
      var COMMON_JS = !root2.HI_BASE32_NO_COMMON_JS && true && module.exports;
      var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
      var BASE32_DECODE_CHAR = {
        "A": 0,
        "B": 1,
        "C": 2,
        "D": 3,
        "E": 4,
        "F": 5,
        "G": 6,
        "H": 7,
        "I": 8,
        "J": 9,
        "K": 10,
        "L": 11,
        "M": 12,
        "N": 13,
        "O": 14,
        "P": 15,
        "Q": 16,
        "R": 17,
        "S": 18,
        "T": 19,
        "U": 20,
        "V": 21,
        "W": 22,
        "X": 23,
        "Y": 24,
        "Z": 25,
        "2": 26,
        "3": 27,
        "4": 28,
        "5": 29,
        "6": 30,
        "7": 31
      };
      var blocks = [0, 0, 0, 0, 0, 0, 0, 0];
      var throwInvalidUtf8 = function(position2, partial2) {
        if (partial2.length > 10) {
          partial2 = "..." + partial2.substr(-10);
        }
        var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position2 + " bytes: " + partial2 + " <-");
        err.position = position2;
        throw err;
      };
      var toUtf8String = function(bytes) {
        var str = "", length = bytes.length, i2 = 0, followingChars = 0, b2, c2;
        while (i2 < length) {
          b2 = bytes[i2++];
          if (b2 <= 127) {
            str += String.fromCharCode(b2);
            continue;
          } else if (b2 > 191 && b2 <= 223) {
            c2 = b2 & 31;
            followingChars = 1;
          } else if (b2 <= 239) {
            c2 = b2 & 15;
            followingChars = 2;
          } else if (b2 <= 247) {
            c2 = b2 & 7;
            followingChars = 3;
          } else {
            throwInvalidUtf8(i2, str);
          }
          for (var j2 = 0; j2 < followingChars; ++j2) {
            b2 = bytes[i2++];
            if (b2 < 128 || b2 > 191) {
              throwInvalidUtf8(i2, str);
            }
            c2 <<= 6;
            c2 += b2 & 63;
          }
          if (c2 >= 55296 && c2 <= 57343) {
            throwInvalidUtf8(i2, str);
          }
          if (c2 > 1114111) {
            throwInvalidUtf8(i2, str);
          }
          if (c2 <= 65535) {
            str += String.fromCharCode(c2);
          } else {
            c2 -= 65536;
            str += String.fromCharCode((c2 >> 10) + 55296);
            str += String.fromCharCode((c2 & 1023) + 56320);
          }
        }
        return str;
      };
      var decodeAsBytes = function(base32Str) {
        if (base32Str === "") {
          return [];
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        base32Str = base32Str.replace(/=/g, "");
        var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index2 = 0, length = base32Str.length;
        for (var i2 = 0, count = length >> 3 << 3; i2 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
          bytes[index2++] = (v7 << 5 | v8) & 255;
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
        }
        return bytes;
      };
      var encodeAscii = function(str) {
        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
        for (var i2 = 0, count = parseInt(length / 5) * 5; i2 < count; ) {
          v1 = str.charCodeAt(i2++);
          v2 = str.charCodeAt(i2++);
          v3 = str.charCodeAt(i2++);
          v4 = str.charCodeAt(i2++);
          v5 = str.charCodeAt(i2++);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = str.charCodeAt(i2);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = str.charCodeAt(i2++);
          v2 = str.charCodeAt(i2);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = str.charCodeAt(i2++);
          v2 = str.charCodeAt(i2++);
          v3 = str.charCodeAt(i2);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = str.charCodeAt(i2++);
          v2 = str.charCodeAt(i2++);
          v3 = str.charCodeAt(i2++);
          v4 = str.charCodeAt(i2);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encodeUtf8 = function(str) {
        var v1, v2, v3, v4, v5, code2, end = false, base32Str = "", index2 = 0, i2, start = 0, length = str.length;
        if (str === "") {
          return base32Str;
        }
        do {
          blocks[0] = blocks[5];
          blocks[1] = blocks[6];
          blocks[2] = blocks[7];
          for (i2 = start; index2 < length && i2 < 5; ++index2) {
            code2 = str.charCodeAt(index2);
            if (code2 < 128) {
              blocks[i2++] = code2;
            } else if (code2 < 2048) {
              blocks[i2++] = 192 | code2 >> 6;
              blocks[i2++] = 128 | code2 & 63;
            } else if (code2 < 55296 || code2 >= 57344) {
              blocks[i2++] = 224 | code2 >> 12;
              blocks[i2++] = 128 | code2 >> 6 & 63;
              blocks[i2++] = 128 | code2 & 63;
            } else {
              code2 = 65536 + ((code2 & 1023) << 10 | str.charCodeAt(++index2) & 1023);
              blocks[i2++] = 240 | code2 >> 18;
              blocks[i2++] = 128 | code2 >> 12 & 63;
              blocks[i2++] = 128 | code2 >> 6 & 63;
              blocks[i2++] = 128 | code2 & 63;
            }
          }
          start = i2 - 5;
          if (index2 === length) {
            ++index2;
          }
          if (index2 > length && i2 < 6) {
            end = true;
          }
          v1 = blocks[0];
          if (i2 > 4) {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            v5 = blocks[4];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
          } else if (i2 === 1) {
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
          } else if (i2 === 2) {
            v2 = blocks[1];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
          } else if (i2 === 3) {
            v2 = blocks[1];
            v3 = blocks[2];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
          } else {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
          }
        } while (!end);
        return base32Str;
      };
      var encodeBytes = function(bytes) {
        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
        for (var i2 = 0, count = parseInt(length / 5) * 5; i2 < count; ) {
          v1 = bytes[i2++];
          v2 = bytes[i2++];
          v3 = bytes[i2++];
          v4 = bytes[i2++];
          v5 = bytes[i2++];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = bytes[i2];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = bytes[i2++];
          v2 = bytes[i2];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = bytes[i2++];
          v2 = bytes[i2++];
          v3 = bytes[i2];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = bytes[i2++];
          v2 = bytes[i2++];
          v3 = bytes[i2++];
          v4 = bytes[i2];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encode2 = function(input, asciiOnly) {
        var notString = typeof input !== "string";
        if (notString && input.constructor === ArrayBuffer) {
          input = new Uint8Array(input);
        }
        if (notString) {
          return encodeBytes(input);
        } else if (asciiOnly) {
          return encodeAscii(input);
        } else {
          return encodeUtf8(input);
        }
      };
      var decode = function(base32Str, asciiOnly) {
        if (!asciiOnly) {
          return toUtf8String(decodeAsBytes(base32Str));
        }
        if (base32Str === "") {
          return "";
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
        if (length === -1) {
          length = base32Str.length;
        }
        for (var i2 = 0, count = length >> 3 << 3; i2 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
        }
        return str;
      };
      var exports$12 = {
        encode: encode2,
        decode
      };
      decode.asBytes = decodeAsBytes;
      if (COMMON_JS) {
        module.exports = exports$12;
      } else {
        root2.base32 = exports$12;
      }
    })();
  })(base32$1$1);
  return base32$1$1.exports;
}
var base32Exports = requireBase32$1();
const base32 = /* @__PURE__ */ getDefaultExportFromCjs$4(base32Exports);
async function cidFromText(text2) {
  let encoder = new TextEncoder();
  let data = encoder.encode(text2);
  return await cidFromArrayBuffer(data);
}
async function cidFromArrayBuffer(data) {
  let hashBuffer = await crypto.subtle.digest("SHA-256", data);
  let cidArray = new Uint8Array(36);
  cidArray.set([1, 85, 18, 32]);
  cidArray.set(new Uint8Array(hashBuffer), 4);
  let cid = "b" + base32.encode(cidArray).toLowerCase().replace(/=+/, "");
  return cid;
}
const textByCid = {};
function retrieveTextFileForCid(cid, ext = "doenet") {
  if (textByCid[cid] !== void 0) {
    return Promise.resolve(textByCid[cid]);
  }
  let resultServer = retrieveTextFileFromServer(cid, ext);
  return resultServer.promise.then((res) => {
    textByCid[cid] = res;
    return res;
  });
}
function retrieveTextFileFromServer(cid, ext) {
  let controller = new AbortController();
  let signal = controller.signal;
  let retrieveFromServer = async function() {
    try {
      let response = await fetch(`/media/${cid}.${ext}`, { signal });
      if (response.ok) {
        let doenetML = await response.text();
        let CidRetrieved = await cidFromText(doenetML);
        if (CidRetrieved === cid) {
          return doenetML;
        } else {
          console.warn(`cid mismatch, ${cid}, ${CidRetrieved}`);
          return Promise.reject(new Error("cid mismatch"));
        }
      } else {
        return Promise.reject(new Error(`cid not found: ${cid}`));
      }
    } catch (e2) {
      return Promise.reject(new Error(`cid not found: ${cid}`));
    }
  };
  let promise = retrieveFromServer();
  return { promise, controller };
}
const genericMethods = {
  union: function(A2, B2) {
    return A2.complement().intersect(B2.complement()).complement();
  },
  intersectWithOpenInterval: function(A2, B2) {
    return A2.intersect(B2);
  },
  setMinus: function(A2, B2) {
    return A2.intersect(B2.complement());
  },
  symmetricDifference: function(A2, B2) {
    return A2.setMinus(B2).union(B2.setMinus(A2));
  },
  containsSubset: function(A2, B2) {
    return A2.intersect(B2).equals(B2);
  },
  isSubsetOf: function(A2, B2) {
    return genericMethods.containsSubset(B2, A2);
  },
  equals: function(A2, B2) {
    return A2.symmetricDifference(B2).isEmpty();
  }
};
function subsetReviver(_key, value) {
  if (typeof value === "object" && value !== null && "objectType" in value && value.objectType === "subset" && "data" in value && typeof value.data === "object" && value.data !== null && "type" in value.data && value.data.type !== void 0) {
    if (value.data.type === "empty") {
      return EmptySet();
    } else if (value.data.type === "realLine") {
      return RealLine();
    } else if (value.data.type === "singleton") {
      if ("element" in value.data && typeof value.data.element === "number") {
        return Singleton(value.data.element);
      }
    } else if (value.data.type === "union") {
      if ("subsets" in value.data && Array.isArray(value.data.subsets) && value.data.subsets.every(
        (s) => s instanceof Constructors.Singleton || s instanceof Constructors.OpenInterval
      )) {
        return Union(value.data.subsets);
      }
    } else if (value.data.type === "openInterval") {
      if ("left" in value.data && typeof value.data.left === "number" && "right" in value.data && typeof value.data.right === "number") {
        return OpenInterval(value.data.left, value.data.right);
      }
    }
  }
  return value;
}
const Constructors = {
  EmptySet: class {
    constructor() {
      this.type = "empty";
    }
    union(that) {
      return that;
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    intersect() {
      return EmptySet();
    }
    containsElement() {
      return false;
    }
    isEmpty() {
      return true;
    }
    complement() {
      return RealLine();
    }
    isValid() {
      return true;
    }
    toString() {
      return "∅";
    }
    toMathExpression() {
      return Context$1.fromAst("emptyset");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "empty" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  InvalidSet: class {
    constructor() {
      this.type = "invalid";
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    union() {
      return InvalidSet();
    }
    intersect() {
      return InvalidSet();
    }
    containsElement() {
      return false;
    }
    isEmpty() {
      return true;
    }
    complement() {
      return InvalidSet();
    }
    isValid() {
      return false;
    }
    toString() {
      return "＿";
    }
    toMathExpression() {
      return Context$1.fromAst("＿");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "invalid" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  RealLine: class {
    constructor() {
      this.type = "realLine";
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    union() {
      return RealLine();
    }
    intersect(that) {
      return that;
    }
    containsElement() {
      return true;
    }
    complement() {
      return EmptySet();
    }
    isEmpty() {
      return false;
    }
    toString() {
      return "ℝ";
    }
    toMathExpression() {
      return Context$1.fromAst("R");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "realLine" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  Singleton: class {
    constructor(element2) {
      this.type = "singleton";
      this.element = element2;
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    union(that) {
      if (that.containsElement(this.element)) {
        return that;
      } else {
        return Union([that, this]);
      }
    }
    intersect(subset) {
      if (subset.containsElement(this.element)) {
        return Singleton(this.element);
      } else {
        return EmptySet();
      }
    }
    isEmpty() {
      return false;
    }
    containsElement(element2) {
      return element2 === this.element;
    }
    complement() {
      return Union([
        OpenInterval(-Infinity, this.element),
        OpenInterval(this.element, Infinity)
      ]);
    }
    toString() {
      return `{${this.element}}`;
    }
    toMathExpression() {
      return Context$1.fromAst(["set", this.element]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "singleton", element: this.element }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  OpenInterval: class {
    constructor(left, right) {
      this.type = "openInterval";
      this.left = left;
      this.right = right;
    }
    union(that) {
      return genericMethods.union(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    intersect(subset) {
      return subset.intersectWithOpenInterval(this);
    }
    intersectWithOpenInterval(that) {
      return OpenInterval(
        Math.max(this.left, that.left),
        Math.min(this.right, that.right)
      );
    }
    complement() {
      return Union([
        OpenClosedInterval(-Infinity, this.left),
        ClosedOpenInterval(this.right, Infinity)
      ]);
    }
    isEmpty() {
      return this.left >= this.right;
    }
    containsElement(element2) {
      return element2 > this.left && element2 < this.right;
    }
    toString() {
      return `(${this.left.toString()},${this.right.toString()})`;
    }
    toMathExpression() {
      return Context$1.fromAst([
        "interval",
        ["tuple", this.left, this.right],
        ["tuple", false, false]
      ]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: {
          type: "openInterval",
          left: this.left,
          right: this.right
        }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  Union: class {
    constructor(subsets2) {
      this.type = "union";
      this.subsets = subsets2;
    }
    union(that) {
      return genericMethods.union(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    intersectWithOpenInterval(that) {
      return this.intersect(that);
    }
    containsElement(element2) {
      return this.subsets.some((s) => s.containsElement(element2));
    }
    isEmpty() {
      return this.subsets.every((s) => s.isEmpty());
    }
    complement() {
      return this.subsets.map((s) => s.complement()).reduce((a, b2) => a.intersect(b2));
    }
    intersect(subset) {
      return Union(this.subsets.map((s) => subset.intersect(s)));
    }
    toString() {
      return this.subsets.map((s) => s.toString()).join(" U ");
    }
    toMathExpression() {
      return Context$1.fromAst([
        "union",
        ...this.subsets.map((s) => s.toMathExpression().tree)
      ]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: {
          type: "union",
          subsets: this.subsets.map((s) => s.toJSON())
        }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  }
};
function EmptySet() {
  return new Constructors.EmptySet();
}
function InvalidSet() {
  return new Constructors.InvalidSet();
}
function RealLine() {
  return new Constructors.RealLine();
}
function Singleton(element2) {
  if (!Number.isFinite(element2)) {
    return new Constructors.EmptySet();
  }
  return new Constructors.Singleton(element2);
}
function OpenInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    return new Constructors.OpenInterval(left, right);
  }
}
function Union(subsets2) {
  if (subsets2.some((s) => s.type === "invalid")) {
    return new Constructors.InvalidSet();
  }
  const flattenedSubsets = subsets2.reduce(
    (acc, val) => val.type === "union" ? [...acc, ...val.subsets] : [...acc, val],
    []
  );
  const filtered = [];
  for (const sub2 of flattenedSubsets) {
    if (sub2.type === "realLine") {
      return new Constructors.RealLine();
    } else if (sub2.type !== "empty" && !sub2.isEmpty()) {
      filtered.push(sub2);
    }
  }
  if (filtered.length === 0) {
    return new Constructors.EmptySet();
  }
  const newSubsets = [];
  for (let ind1 = 0; ind1 < filtered.length; ind1++) {
    let sub1 = filtered[ind1];
    let addSub1 = true;
    if (sub1.type === "openInterval") {
      let left = sub1.left;
      let right = sub1.right;
      for (let ind2 = ind1 + 1; ind2 < filtered.length; ind2++) {
        let sub2 = filtered[ind2];
        if (sub2.type === "openInterval") {
          if (left < sub2.right && sub2.left < right) {
            left = Math.min(left, sub2.left);
            right = Math.max(right, sub2.right);
            filtered.splice(ind2, 1);
            ind2--;
            addSub1 = false;
            ind1--;
            break;
          } else if (left === sub2.right || right === sub2.left) {
            let gap = left === sub2.right ? left : right;
            let foundSingleton = false;
            for (let ind3 = 0; ind3 < newSubsets.length; ind3++) {
              let sub3 = newSubsets[ind3];
              if (sub3.type === "singleton" && sub3.element === gap) {
                newSubsets.splice(ind3, 1);
                foundSingleton = true;
                break;
              }
            }
            if (!foundSingleton) {
              for (let ind3 = ind1 + 1; ind3 < filtered.length; ind3++) {
                let sub3 = filtered[ind3];
                if (sub3.type === "singleton" && sub3.element === gap) {
                  filtered.splice(ind3, 1);
                  foundSingleton = true;
                  if (ind3 < ind2) {
                    ind2--;
                  }
                  break;
                }
              }
            }
            if (foundSingleton) {
              left = Math.min(left, sub2.left);
              right = Math.max(right, sub2.right);
              filtered.splice(ind2, 1);
              ind2--;
              addSub1 = false;
              ind1--;
              break;
            }
          }
        } else {
          if (sub2.element > left && sub2.element < right) {
            filtered.splice(ind2, 1);
            ind2--;
          }
        }
      }
      sub1.left = left;
      sub1.right = right;
      if (sub1.left === -Infinity && sub1.right === Infinity) {
        return new Constructors.RealLine();
      }
    } else {
      let val = sub1.element;
      for (let ind2 = ind1 + 1; ind2 < filtered.length; ind2++) {
        let sub2 = filtered[ind2];
        if (sub2.type === "openInterval") {
          if (val > sub2.left && val < sub2.right) {
            filtered.splice(ind1, 1);
            ind1--;
            addSub1 = false;
            break;
          }
        } else if (sub2.element === val) {
          filtered.splice(ind2, 1);
          ind2--;
        }
      }
    }
    if (addSub1) {
      newSubsets.push(sub1);
    }
  }
  if (newSubsets.length === 1) {
    return newSubsets[0];
  }
  return new Constructors.Union(newSubsets);
}
function OpenClosedInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    const pieces = [
      new Constructors.OpenInterval(left, right)
    ];
    if (Number.isFinite(right)) {
      pieces.push(new Constructors.Singleton(right));
    }
    return Union(pieces);
  }
}
function ClosedOpenInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    const pieces = [
      new Constructors.OpenInterval(left, right)
    ];
    if (Number.isFinite(left)) {
      pieces.push(new Constructors.Singleton(left));
    }
    return Union(pieces);
  }
}
function deepCompare(a, b2, BaseComponent) {
  var leftChain, rightChain;
  function compare2Objects(x2, y) {
    var p;
    if (Number.isNaN(x2) && Number.isNaN(y)) {
      return true;
    }
    if (x2 === y) {
      return true;
    }
    if (x2 instanceof Context$1.class && y instanceof Context$1.class) {
      return compare2Objects(x2.tree, y.tree);
    }
    if (typeof x2 === "function" && typeof y === "function" || x2 instanceof Date && y instanceof Date || x2 instanceof RegExp && y instanceof RegExp || x2 instanceof String && y instanceof String || x2 instanceof Number && y instanceof Number) {
      return x2.toString() === y.toString();
    }
    if (!(x2 instanceof Object && y instanceof Object)) {
      return false;
    }
    if (x2.isPrototypeOf(y) || y.isPrototypeOf(x2)) {
      return false;
    }
    if (x2.constructor !== y.constructor) {
      return false;
    }
    if (x2.prototype !== y.prototype) {
      return false;
    }
    if (leftChain.indexOf(x2) > -1 || rightChain.indexOf(y) > -1) {
      return false;
    }
    for (p in y) {
      if (y.hasOwnProperty(p) !== x2.hasOwnProperty(p)) {
        return false;
      } else if (typeof y[p] !== typeof x2[p]) {
        return false;
      }
    }
    for (p in x2) {
      if (y.hasOwnProperty(p) !== x2.hasOwnProperty(p)) {
        return false;
      } else if (typeof y[p] !== typeof x2[p]) {
        return false;
      }
      switch (typeof x2[p]) {
        case "object":
        case "function":
          leftChain.push(x2);
          rightChain.push(y);
          if (!compare2Objects(x2[p], y[p])) {
            return false;
          }
          leftChain.pop();
          rightChain.pop();
          break;
        default:
          if (x2[p] !== y[p] && !(Number.isNaN(x2[p]) && Number.isNaN(y[p]))) {
            return false;
          }
          break;
      }
    }
    return true;
  }
  leftChain = [];
  rightChain = [];
  return compare2Objects(a, b2);
}
function serializedComponentsReplacer(key, value) {
  if (value !== value) {
    return { objectType: "special-numeric", stringValue: "NaN" };
  } else if (value === Infinity) {
    return { objectType: "special-numeric", stringValue: "Infinity" };
  } else if (value === -Infinity) {
    return { objectType: "special-numeric", stringValue: "-Infinity" };
  }
  return value;
}
function nanInfinityReviver(key, value) {
  if (value && value.objectType === "special-numeric") {
    if (value.stringValue === "NaN") {
      return NaN;
    } else if (value.stringValue === "Infinity") {
      return Infinity;
    } else if (value.stringValue === "-Infinity") {
      return -Infinity;
    }
  }
  return value;
}
function serializedComponentsReviver(key, value) {
  return Context$1.reviver(key, subsetReviver(key, nanInfinityReviver(key, value)));
}
function find_effective_domain({
  domain,
  truncateToFiniteDomain = false,
  xscale = 1
}) {
  let minx = -Infinity;
  let maxx = Infinity;
  let openMin = true, openMax = true;
  if (domain !== null) {
    let domain1 = domain[0];
    if (domain1 !== void 0) {
      minx = Context$1.fromAst(domain1.tree[1][1]).evaluate_to_constant();
      if (!Number.isFinite(minx)) {
        minx = -Infinity;
      } else {
        openMin = !domain1.tree[2][1];
      }
      maxx = Context$1.fromAst(domain1.tree[1][2]).evaluate_to_constant();
      if (!Number.isFinite(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !domain1.tree[2][2];
      }
    }
  }
  if (truncateToFiniteDomain) {
    if (minx === -Infinity) {
      if (maxx === Infinity) {
        minx = -100 * xscale;
        maxx = 100 * xscale;
      } else {
        minx = maxx - 200 * xscale;
      }
    } else if (maxx === Infinity) {
      maxx = minx + 200 * xscale;
    }
  } else {
    if (minx === -Infinity) {
      openMin = false;
    }
    if (maxx === Infinity) {
      openMax = false;
    }
  }
  return { minx, maxx, openMin, openMax };
}
function convertValueToMathExpression(value) {
  if (value instanceof Context$1.class) {
    return value;
  } else if (typeof value === "number" || typeof value === "string") {
    return Context$1.fromAst(value);
  } else if (Array.isArray(value)) {
    return Context$1.fromAst(value);
  } else {
    return Context$1.fromAst("＿");
  }
}
const vectorOperators = ["vector", "altvector", "tuple"];
function createFunctionFromDefinition(fDefinition) {
  if (fDefinition.functionType === "formula") {
    return returnNumericalFunctionFromFormula({
      formula: Context$1.fromAst(fDefinition.formula),
      numInputs: fDefinition.numInputs,
      variables: fDefinition.variables.map((x2) => Context$1.fromAst(x2)),
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => Context$1.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "reevaluatedFormula") {
    let evaluateChildrenToReevaluate = {};
    for (let code2 in fDefinition.evaluateChildrenToReevaluate) {
      evaluateChildrenToReevaluate[code2] = {
        fReevaluate: createFunctionFromDefinition(
          fDefinition.evaluateChildrenToReevaluate[code2].fReevaluateDefinition
        ),
        inputMathFs: fDefinition.evaluateChildrenToReevaluate[code2].inputMaths.map(
          (x2) => Context$1.fromAst(x2).subscripts_to_strings().f()
        )
      };
    }
    return returnNumericalFunctionFromReevaluatedFormula({
      formulaExpressionWithCodes: Context$1.fromAst(
        fDefinition.formulaExpressionWithCodes
      ),
      evaluateChildrenToReevaluate,
      numInputs: fDefinition.numInputs,
      variables: fDefinition.variables.map((x2) => Context$1.fromAst(x2)),
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => Context$1.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "numericForEvaluate") {
    return returnNumericFunctionForEvaluate({
      numInputs: fDefinition.numInputs,
      numericalfs: fDefinition.fDefinitions.map(
        (fdef) => createFunctionFromDefinition(fdef)
      )
    });
  } else if (fDefinition.functionType === "bezier") {
    return returnBezierFunctions({
      numThroughPoints: fDefinition.numThroughPoints,
      numericalThroughPoints: fDefinition.numericalThroughPoints,
      splineCoeffs: fDefinition.splineCoeffs,
      extrapolateForward: fDefinition.extrapolateForward,
      extrapolateForwardCoeffs: fDefinition.extrapolateForwardCoeffs,
      extrapolateBackward: fDefinition.extrapolateBackward,
      extrapolateBackwardCoeffs: fDefinition.extrapolateBackwardCoeffs,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "interpolated") {
    return returnInterpolatedFunction({
      xs: fDefinition.xs,
      coeffs: fDefinition.coeffs,
      interpolationPoints: fDefinition.interpolationPoints,
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => Context$1.fromAst(x2)) : null
    });
  } else if (fDefinition.functionType === "functionOperator") {
    return returnFunctionOperatorFunction({
      componentType: fDefinition.componentType,
      functionOperatorArguments: fDefinition.functionOperatorArguments,
      operatorComposesWithOriginal: fDefinition.operatorComposesWithOriginal,
      originalFDefinition: fDefinition.originalFDefinition,
      numOutputs: fDefinition.numOutputs,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "ODESolution") {
    return returnODESolutionFunction({
      numDimensions: fDefinition.numDimensions,
      t0: fDefinition.t0,
      x0s: fDefinition.x0s,
      chunkSize: fDefinition.chunkSize,
      tolerance: fDefinition.tolerance,
      numericalRHSfDefinitions: fDefinition.numericalRHSfDefinitions,
      maxIterations: fDefinition.maxIterations,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "piecewise") {
    return returnPiecewiseNumericalFunctionFromChildren({
      numericalFsOfChildren: fDefinition.fDefinitionsOfChildren.map(
        (fDef) => createFunctionFromDefinition(fDef)
      ),
      numericalDomainsOfChildren: fDefinition.numericalDomainsOfChildren,
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => Context$1.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else {
    return () => NaN;
  }
}
function returnNumericalFunctionFromFormula({
  formula,
  numInputs,
  variables: variables2,
  domain,
  component = 0
}) {
  component = Number(component);
  let formulaIsVectorValued = Array.isArray(formula.tree) && vectorOperators.includes(formula.tree[0]);
  if (formulaIsVectorValued) {
    try {
      formula = formula.get_component(component);
    } catch (e2) {
      return () => NaN;
    }
  } else if (component !== 0) {
    return () => NaN;
  }
  let formula_f;
  try {
    formula_f = formula.subscripts_to_strings().f();
  } catch (e2) {
    return () => NaN;
  }
  if (numInputs === 1) {
    let varString = variables2[0].subscripts_to_strings().tree;
    let minx = -Infinity, maxx = Infinity;
    let openMin = false, openMax = false;
    if (domain !== null) {
      let domain0 = domain[0];
      if (domain0 !== void 0) {
        minx = Context$1.fromAst(domain0.tree[1][1]).evaluate_to_constant();
        if (typeof minx !== "number" || Number.isNaN(minx)) {
          minx = -Infinity;
        } else {
          openMin = !domain0.tree[2][1];
        }
        maxx = Context$1.fromAst(domain0.tree[1][2]).evaluate_to_constant();
        if (typeof maxx !== "number" || Number.isNaN(maxx)) {
          maxx = Infinity;
        } else {
          openMax = !domain0.tree[2][2];
        }
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
    }
    return function(x2, overrideDomain = false) {
      if (overrideDomain) {
        if (isNaN(x2)) {
          return NaN;
        }
      } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
        return NaN;
      }
      try {
        return formula_f({ [varString]: x2 });
      } catch (e2) {
        return NaN;
      }
    };
  }
  let varStrings = [];
  for (let i2 = 0; i2 < numInputs; i2++) {
    varStrings.push(variables2[i2].subscripts_to_strings().tree);
  }
  let haveDomain = false;
  let domainIntervals = [];
  let domainOpens = [];
  if (domain !== null) {
    haveDomain = true;
    for (let i2 = 0; i2 < numInputs; i2++) {
      let thisDomain = domain[i2];
      if (!thisDomain) {
        haveDomain = false;
        break;
      }
      let minx = -Infinity, maxx = Infinity;
      let openMin = false, openMax = false;
      minx = Context$1.fromAst(thisDomain.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !thisDomain.tree[2][1];
      }
      maxx = Context$1.fromAst(thisDomain.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !thisDomain.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
      domainIntervals.push([minx, maxx]);
      domainOpens.push([openMin, openMax]);
    }
  }
  return function(...xs) {
    let fArgs = {};
    for (let i2 = 0; i2 < numInputs; i2++) {
      let x2 = xs[i2];
      if (isNaN(x2)) {
        return NaN;
      } else if (haveDomain) {
        let [minx, maxx] = domainIntervals[i2];
        let [openMin, openMax] = domainOpens[i2];
        if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
          return NaN;
        }
      }
      fArgs[varStrings[i2]] = x2;
    }
    try {
      return formula_f(fArgs);
    } catch (e2) {
      return NaN;
    }
  };
}
function returnNumericalFunctionFromReevaluatedFormula({
  formulaExpressionWithCodes,
  evaluateChildrenToReevaluate,
  numInputs,
  variables: variables2,
  domain,
  component = 0
}) {
  component = Number(component);
  let formulaIsVectorValued = Array.isArray(formulaExpressionWithCodes.tree) && vectorOperators.includes(formulaExpressionWithCodes.tree[0]);
  if (formulaIsVectorValued) {
    try {
      formulaExpressionWithCodes = formulaExpressionWithCodes.get_component(Number(component));
    } catch (e2) {
      return () => NaN;
    }
  } else if (component !== 0) {
    return () => NaN;
  }
  let formula_f;
  try {
    formula_f = formulaExpressionWithCodes.subscripts_to_strings().f();
  } catch (e2) {
    return () => NaN;
  }
  if (numInputs === 1) {
    let varString = variables2[0].subscripts_to_strings().tree;
    let minx = -Infinity, maxx = Infinity;
    let openMin = false, openMax = false;
    if (domain !== null) {
      let domain0 = domain[0];
      if (domain0 !== void 0) {
        minx = Context$1.fromAst(domain0.tree[1][1]).evaluate_to_constant();
        if (typeof minx !== "number" || Number.isNaN(minx)) {
          minx = -Infinity;
        } else {
          openMin = !domain0.tree[2][1];
        }
        maxx = Context$1.fromAst(domain0.tree[1][2]).evaluate_to_constant();
        if (typeof maxx !== "number" || Number.isNaN(maxx)) {
          maxx = Infinity;
        } else {
          openMax = !domain0.tree[2][2];
        }
      }
    }
    if (minx === -Infinity) {
      openMin = false;
    }
    if (maxx === Infinity) {
      openMax = false;
    }
    return function(x2, overrideDomain = false) {
      if (overrideDomain) {
        if (isNaN(x2)) {
          return NaN;
        }
      } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
        return NaN;
      }
      let argsForInputs = { [varString]: x2 };
      let fArgs = { [varString]: x2 };
      for (let code2 in evaluateChildrenToReevaluate) {
        let childF = evaluateChildrenToReevaluate[code2].fReevaluate;
        let inputFs = evaluateChildrenToReevaluate[code2].inputMathFs;
        try {
          let input = inputFs.map(
            (f2) => Context$1.fromAst(f2(argsForInputs))
          );
          fArgs[code2] = childF(input).evaluate_to_constant();
        } catch (e2) {
          return NaN;
        }
      }
      try {
        return formula_f(fArgs);
      } catch (e2) {
        return NaN;
      }
    };
  }
  let varStrings = [];
  for (let i2 = 0; i2 < numInputs; i2++) {
    varStrings.push(variables2[i2].subscripts_to_strings().tree);
  }
  let haveDomain = false;
  let domainIntervals = [];
  let domainOpens = [];
  if (domain !== null) {
    haveDomain = true;
    for (let i2 = 0; i2 < numInputs; i2++) {
      let thisDomain = domain[i2];
      if (!thisDomain) {
        haveDomain = false;
        break;
      }
      let minx = -Infinity, maxx = Infinity;
      let openMin = false, openMax = false;
      minx = Context$1.fromAst(thisDomain.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !thisDomain.tree[2][1];
      }
      maxx = Context$1.fromAst(thisDomain.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !thisDomain.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
      domainIntervals.push([minx, maxx]);
      domainOpens.push([openMin, openMax]);
    }
  }
  return function(...xs) {
    let fArgs = {};
    for (let i2 = 0; i2 < numInputs; i2++) {
      let x2 = xs[i2];
      if (isNaN(x2)) {
        return NaN;
      } else if (haveDomain) {
        let [minx, maxx] = domainIntervals[i2];
        let [openMin, openMax] = domainOpens[i2];
        if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
          return NaN;
        }
      }
      fArgs[varStrings[i2]] = x2;
    }
    let argsForInputs = { ...fArgs };
    for (let code2 in evaluateChildrenToReevaluate) {
      let childF = evaluateChildrenToReevaluate[code2].fReevaluate;
      let inputFs = evaluateChildrenToReevaluate[code2].inputMathFs;
      try {
        let input = inputFs.map((f2) => Context$1.fromAst(f2(argsForInputs)));
        fArgs[code2] = childF(input).evaluate_to_constant();
      } catch (e2) {
        return NaN;
      }
    }
    try {
      return formula_f(fArgs);
    } catch (e2) {
      return NaN;
    }
  };
}
function returnPiecewiseNumericalFunctionFromChildren({
  numericalFsOfChildren,
  numericalDomainsOfChildren,
  domain,
  component = 0
}) {
  component = Number(component);
  if (component !== 0) {
    return () => NaN;
  }
  let { minx, maxx, openMin, openMax } = find_effective_domain({ domain });
  return function(x2, overrideDomain = false) {
    if (overrideDomain) {
      if (isNaN(x2)) {
        return NaN;
      }
    } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
      return NaN;
    }
    for (let [ind, childDomain] of numericalDomainsOfChildren.entries()) {
      let childMinX = childDomain[0][0];
      let childMaxX = childDomain[0][1];
      let childMinXClosed = childDomain[1][0];
      let childMaxXClosed = childDomain[1][1];
      if ((x2 > childMinX || childMinXClosed && x2 === childMinX) && (x2 < childMaxX || childMaxXClosed && x2 === childMaxX)) {
        return numericalFsOfChildren[ind](x2);
      }
    }
    return NaN;
  };
}
function returnNumericFunctionForEvaluate({ numericalfs, numInputs }) {
  return function(input) {
    if (input.length === 1) {
      let inputTree = input[0].tree;
      if (Array.isArray(inputTree) && vectorOperators.includes(inputTree[0])) {
        input = inputTree.slice(1).map((x2) => Context$1.fromAst(x2));
      }
    }
    if (input.length !== numInputs) {
      return Context$1.fromAst("＿");
    }
    let numericInput = input.map((x2) => x2.evaluate_to_constant());
    let components = numericalfs.map((f2) => f2(...numericInput));
    let value;
    if (components.length === 1) {
      value = Context$1.fromAst(components[0]);
    } else {
      value = Context$1.fromAst(["vector", ...components]);
    }
    return value;
  };
}
function returnBezierFunctions({
  numThroughPoints,
  numericalThroughPoints,
  splineCoeffs,
  extrapolateForward,
  extrapolateForwardCoeffs,
  extrapolateBackward,
  extrapolateBackwardCoeffs,
  component
}) {
  if (numThroughPoints < 1) {
    return () => NaN;
  }
  let len = numThroughPoints - 1;
  let lastPointX = numericalThroughPoints[len][component];
  let cs = splineCoeffs.map((x2) => x2[component]);
  let cB;
  if (extrapolateBackward) {
    cB = extrapolateBackwardCoeffs[component];
  }
  let cF;
  if (extrapolateForward) {
    cF = extrapolateForwardCoeffs[component];
  }
  return function(t2) {
    if (isNaN(t2)) {
      return NaN;
    }
    if (t2 < 0) {
      if (extrapolateBackward) {
        return (cB[2] * t2 + cB[1]) * t2 + cB[0];
      } else {
        return NaN;
      }
    }
    if (t2 >= len) {
      if (extrapolateForward) {
        t2 -= len;
        return (cF[2] * t2 + cF[1]) * t2 + cF[0];
      } else if (t2 === len) {
        return lastPointX;
      } else {
        return NaN;
      }
    }
    let z2 = Math.floor(t2);
    t2 -= z2;
    let c2 = cs[z2];
    return ((c2[3] * t2 + c2[2]) * t2 + c2[1]) * t2 + c2[0];
  };
}
function returnInterpolatedFunction({
  xs,
  coeffs,
  interpolationPoints,
  domain
}) {
  let interpolationPointYs = [];
  if (interpolationPoints) {
    interpolationPointYs = interpolationPoints.map((x2) => x2.y);
  }
  if (xs === null) {
    return () => NaN;
  }
  let minx = -Infinity, maxx = Infinity;
  let openMin = false, openMax = false;
  if (domain !== null) {
    let domain0 = domain[0];
    if (domain0 !== void 0) {
      minx = Context$1.fromAst(domain0.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !domain0.tree[2][1];
      }
      maxx = Context$1.fromAst(domain0.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !domain0.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
    }
  }
  let x0 = xs[0], xL = xs[xs.length - 1];
  return function(x2, overrideDomain = false) {
    if (overrideDomain) {
      if (isNaN(x2)) {
        return NaN;
      }
    } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
      return NaN;
    }
    if (x2 <= x0) {
      x2 -= x0;
      let c22 = coeffs[0];
      if (x2 === -Infinity) {
        if (c22[3] === 0) {
          if (c22[2] === 0) {
            if (c22[1] === 0) {
              return c22[0];
            } else {
              return -Math.sign(c22[1]) * Infinity;
            }
          } else {
            return Math.sign(c22[2]) * Infinity;
          }
        } else {
          return -Math.sign(c22[3]) * Infinity;
        }
      }
      return ((c22[3] * x2 + c22[2]) * x2 + c22[1]) * x2 + c22[0];
    }
    if (x2 >= xL) {
      let i22 = xs.length - 2;
      x2 -= xs[i22];
      let c22 = coeffs[i22];
      if (x2 === Infinity) {
        if (c22[3] === 0) {
          if (c22[2] === 0) {
            if (c22[1] === 0) {
              return c22[0];
            } else {
              return Math.sign(c22[1]) * Infinity;
            }
          } else {
            return Math.sign(c22[2]) * Infinity;
          }
        } else {
          return Math.sign(c22[3]) * Infinity;
        }
      }
      if (x2 === Infinity && c22[1] === 0 && c22[2] === 0 && c22[3] === 0) {
        return c22[0];
      }
      return ((c22[3] * x2 + c22[2]) * x2 + c22[1]) * x2 + c22[0];
    }
    var low = 0, mid, high = xs.length - 1;
    while (low <= high) {
      mid = Math.floor(0.5 * (low + high));
      let xHere = xs[mid];
      if (xHere < x2) {
        low = mid + 1;
      } else if (xHere > x2) {
        high = mid - 1;
      } else {
        return interpolationPointYs[mid];
      }
    }
    let i2 = Math.max(0, high);
    x2 -= xs[i2];
    let c2 = coeffs[i2];
    return ((c2[3] * x2 + c2[2]) * x2 + c2[1]) * x2 + c2[0];
  };
}
function returnReturnDerivativesOfInterpolatedFunction({
  xs,
  coeffs,
  variables: variables2
}) {
  if (!xs) {
    return () => () => NaN;
  }
  let variable1Trans = variables2[0].subscripts_to_strings().tree;
  let x0 = xs[0], xL = xs[xs.length - 1];
  return function(derivVariables) {
    let derivVariablesTrans = derivVariables.map(
      (x2) => x2.subscripts_to_strings().tree
    );
    let order2 = derivVariablesTrans.length;
    if (order2 > 3 || !derivVariablesTrans.every((x2) => x2 === variable1Trans) || derivVariablesTrans.includes("＿")) {
      return () => 0;
    }
    if (order2 === 0 || xs === null) {
      return () => NaN;
    }
    return function(x2) {
      if (isNaN(x2)) {
        return NaN;
      }
      if (x2 <= x0) {
        x2 -= x0;
        let c22 = coeffs[0];
        if (order2 === 1) {
          return (3 * c22[3] * x2 + 2 * c22[2]) * x2 + c22[1];
        } else if (order2 === 2) {
          return 6 * c22[3] * x2 + 2 * c22[2];
        } else {
          return 6 * c22[3];
        }
      }
      if (x2 >= xL) {
        let i22 = xs.length - 2;
        x2 -= xs[i22];
        let c22 = coeffs[i22];
        if (order2 === 1) {
          return (3 * c22[3] * x2 + 2 * c22[2]) * x2 + c22[1];
        } else if (order2 === 2) {
          return 6 * c22[3] * x2 + 2 * c22[2];
        } else {
          return 6 * c22[3];
        }
      }
      var low = 0, mid, high = xs.length - 1;
      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        let xHere = xs[mid];
        if (xHere < x2) {
          low = mid + 1;
        } else if (xHere > x2) {
          high = mid - 1;
        } else {
          if (order2 === 1) {
            return coeffs[mid][1];
          } else if (order2 === 2) {
            return 2 * coeffs[mid][2];
          } else {
            return 6 * coeffs[mid][3];
          }
        }
      }
      let i2 = Math.max(0, high);
      x2 -= xs[i2];
      let c2 = coeffs[i2];
      if (order2 === 1) {
        return (3 * c2[3] * x2 + 2 * c2[2]) * x2 + c2[1];
      } else if (order2 === 2) {
        return 6 * c2[3] * x2 + 2 * c2[2];
      } else {
        return 6 * c2[3];
      }
    };
  };
}
function returnFunctionOperatorFunction({
  componentType,
  functionOperatorArguments,
  operatorComposesWithOriginal,
  originalFDefinition,
  numOutputs,
  component
}) {
  if (operatorComposesWithOriginal) {
    let childFs = [];
    for (let ind = 0; ind < numOutputs; ind++) {
      childFs.push(
        createFunctionFromDefinition(originalFDefinition)
      );
    }
    let functionOperator = functionOperatorDefinitions[componentType](
      ...functionOperatorArguments
    );
    return (...xs) => functionOperator(...childFs.map((cf) => cf(...xs)));
  } else {
    return functionOperatorDefinitions[componentType](
      ...functionOperatorArguments
    );
  }
}
var functionOperatorDefinitions = {
  clampFunction: function(lowerValue, upperValue) {
    return function(x2) {
      if (!Number.isFinite(x2)) {
        return NaN;
      }
      return Math.max(lowerValue, Math.min(upperValue, x2));
    };
  },
  wrapFunctionPeriodic: function(lowerValue, upperValue) {
    return function(x2) {
      if (!Number.isFinite(x2)) {
        return NaN;
      }
      let lower = lowerValue;
      let upper = upperValue;
      if (lower === upper) {
        return lower;
      }
      if (lower > upper) {
        [upper, lower] = [lower, upper];
      }
      return lower + Context$1.math.mod(x2 - lower, upper - lower);
    };
  },
  derivative: function(derivDefinition, derivVariables) {
    if (derivDefinition.derivativeType === "interpolatedFunction") {
      let derivGenerator = returnReturnDerivativesOfInterpolatedFunction({
        xs: derivDefinition.xs,
        coeffs: derivDefinition.coeffs,
        variables: derivDefinition.variables.map(
          convertValueToMathExpression
        )
      });
      let vars = derivVariables.map(convertValueToMathExpression);
      if (derivDefinition.additionalDerivVariables) {
        let additionalVars = derivDefinition.additionalDerivVariables.map(
          convertValueToMathExpression
        );
        vars = [...additionalVars, ...vars];
      }
      if (derivDefinition.variableMappings) {
        for (let variableMapping of derivDefinition.variableMappings) {
          let mappedDerivVariables = [];
          for (let dVar of vars) {
            let mapped = variableMapping[dVar.subscripts_to_strings().tree];
            if (mapped) {
              mappedDerivVariables.push(
                convertValueToMathExpression(mapped)
              );
            } else {
              mappedDerivVariables.push(Context$1.fromAst("＿"));
            }
          }
          vars = mappedDerivVariables;
        }
      }
      let deriv = derivGenerator(vars);
      return deriv;
    } else {
      return () => NaN;
    }
  }
};
function returnODESolutionFunction({
  numDimensions,
  t0,
  x0s,
  chunkSize,
  tolerance,
  numericalRHSfDefinitions,
  maxIterations,
  component
}) {
  var workspace = {};
  workspace.calculatedNumericSolutions = [];
  workspace.endingNumericalValues = [];
  workspace.maxPossibleTime = void 0;
  let numericalRHSfcomponents = numericalRHSfDefinitions.map(
    (x2) => createFunctionFromDefinition(x2)
  );
  let numericalRHSf = function(t2, x2) {
    let fargs = [t2];
    if (Array.isArray(x2)) {
      fargs.push(...x2);
    } else {
      fargs.push(x2);
    }
    try {
      return numericalRHSfcomponents.map((f2) => f2(...fargs));
    } catch (e2) {
      return NaN;
    }
  };
  return function f2(t2) {
    if (!Number.isFinite(t2)) {
      return NaN;
    }
    if (t2 === t0) {
      return x0s[component];
    }
    let nChunksCalculated = workspace.calculatedNumericSolutions.length;
    let chunk2 = Math.ceil((t2 - t0) / chunkSize) - 1;
    if (chunk2 < 0) {
      return NaN;
    }
    if (workspace.maxPossibleTime === void 0 && chunk2 >= nChunksCalculated) {
      for (let tind = nChunksCalculated; tind <= chunk2; tind++) {
        let x0 = workspace.endingNumericalValues[tind - 1];
        if (x0 === void 0) {
          x0 = x0s;
        }
        let t0shifted = t0 + tind * chunkSize;
        let result2 = Context$1.math.dopri(
          t0shifted,
          t0shifted + chunkSize,
          x0,
          numericalRHSf,
          tolerance,
          maxIterations
        );
        workspace.endingNumericalValues.push(
          result2.y[result2.y.length - 1]
        );
        workspace.calculatedNumericSolutions.push(
          result2.at.bind(result2)
        );
        let endingTime = result2.x[result2.x.length - 1];
        if (endingTime < (t0shifted + chunkSize) * (1 - 1e-6)) {
          workspace.maxPossibleTime = endingTime;
          break;
        }
      }
    }
    if (t2 > workspace.maxPossibleTime) {
      return NaN;
    }
    let value = workspace.calculatedNumericSolutions[chunk2](t2)[component];
    return value;
  };
}
const mathjaxConfig$1 = {
  tex: {
    tags: "ams",
    macros: {
      lt: "<",
      gt: ">",
      amp: "&",
      var: ["\\mathrm{#1}", 1],
      csch: "\\operatorname{csch}",
      sech: "\\operatorname{sech}",
      erf: "\\operatorname{erf}"
    },
    displayMath: [["\\[", "\\]"]]
  },
  output: {
    displayOverflow: "linebreak"
  }
};
function textRendererStyle(darkMode, selectedStyle) {
  let textColor = darkMode === "dark" ? selectedStyle.textColorDarkMode : selectedStyle.textColor;
  let backgroundColor = darkMode === "dark" ? selectedStyle.backgroundColorDarkMode : selectedStyle.backgroundColor;
  let style = { color: textColor };
  if (backgroundColor) {
    style.backgroundColor = backgroundColor;
  }
  return style;
}
var cssesc_1$1;
var hasRequiredCssesc$1;
function requireCssesc$1() {
  if (hasRequiredCssesc$1) return cssesc_1$1;
  hasRequiredCssesc$1 = 1;
  var object2 = {};
  var hasOwnProperty2 = object2.hasOwnProperty;
  var merge = function merge2(options2, defaults2) {
    if (!options2) {
      return defaults2;
    }
    var result2 = {};
    for (var key in defaults2) {
      result2[key] = hasOwnProperty2.call(options2, key) ? options2[key] : defaults2[key];
    }
    return result2;
  };
  var regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
  var regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
  var regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
  var cssesc2 = function cssesc3(string2, options2) {
    options2 = merge(options2, cssesc3.options);
    if (options2.quotes != "single" && options2.quotes != "double") {
      options2.quotes = "single";
    }
    var quote2 = options2.quotes == "double" ? '"' : "'";
    var isIdentifier = options2.isIdentifier;
    var firstChar = string2.charAt(0);
    var output = "";
    var counter2 = 0;
    var length = string2.length;
    while (counter2 < length) {
      var character = string2.charAt(counter2++);
      var codePoint = character.charCodeAt();
      var value = void 0;
      if (codePoint < 32 || codePoint > 126) {
        if (codePoint >= 55296 && codePoint <= 56319 && counter2 < length) {
          var extra = string2.charCodeAt(counter2++);
          if ((extra & 64512) == 56320) {
            codePoint = ((codePoint & 1023) << 10) + (extra & 1023) + 65536;
          } else {
            counter2--;
          }
        }
        value = "\\" + codePoint.toString(16).toUpperCase() + " ";
      } else {
        if (options2.escapeEverything) {
          if (regexAnySingleEscape.test(character)) {
            value = "\\" + character;
          } else {
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
          }
        } else if (/[\t\n\f\r\x0B]/.test(character)) {
          value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else if (character == "\\" || !isIdentifier && (character == '"' && quote2 == character || character == "'" && quote2 == character) || isIdentifier && regexSingleEscape.test(character)) {
          value = "\\" + character;
        } else {
          value = character;
        }
      }
      output += value;
    }
    if (isIdentifier) {
      if (/^-[-\d]/.test(output)) {
        output = "\\-" + output.slice(1);
      } else if (/\d/.test(firstChar)) {
        output = "\\3" + firstChar + " " + output.slice(1);
      }
    }
    output = output.replace(regexExcessiveSpaces, function($0, $1, $2) {
      if ($1 && $1.length % 2) {
        return $0;
      }
      return ($1 || "") + $2;
    });
    if (!isIdentifier && options2.wrap) {
      return quote2 + output + quote2;
    }
    return output;
  };
  cssesc2.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
  };
  cssesc2.version = "3.0.0";
  cssesc_1$1 = cssesc2;
  return cssesc_1$1;
}
var cssescExports = requireCssesc$1();
const cssesc = /* @__PURE__ */ getDefaultExportFromCjs$4(cssescExports);
function cesc(s) {
  s = cssesc(s, { isIdentifier: true });
  if (s.slice(0, 2) === "\\#") {
    s = s.slice(1);
  }
  return s;
}
const data_format_version = "0.7.0";
const proxyMarker = Symbol("Comlink.proxy");
const createEndpoint = Symbol("Comlink.endpoint");
const releaseProxy = Symbol("Comlink.releaseProxy");
const finalizer = Symbol("Comlink.finalizer");
const throwMarker = Symbol("Comlink.thrown");
const isObject$2 = (val) => typeof val === "object" && val !== null || typeof val === "function";
const proxyTransferHandler = {
  canHandle: (val) => isObject$2(val) && val[proxyMarker],
  serialize(obj) {
    const { port1, port2 } = new MessageChannel();
    expose(obj, port1);
    return [port2, [port2]];
  },
  deserialize(port) {
    port.start();
    return wrap$3(port);
  }
};
const throwTransferHandler = {
  canHandle: (value) => isObject$2(value) && throwMarker in value,
  serialize({ value }) {
    let serialized;
    if (value instanceof Error) {
      serialized = {
        isError: true,
        value: {
          message: value.message,
          name: value.name,
          stack: value.stack
        }
      };
    } else {
      serialized = { isError: false, value };
    }
    return [serialized, []];
  },
  deserialize(serialized) {
    if (serialized.isError) {
      throw Object.assign(new Error(serialized.value.message), serialized.value);
    }
    throw serialized.value;
  }
};
const transferHandlers = /* @__PURE__ */ new Map([
  ["proxy", proxyTransferHandler],
  ["throw", throwTransferHandler]
]);
function isAllowedOrigin(allowedOrigins, origin) {
  for (const allowedOrigin of allowedOrigins) {
    if (origin === allowedOrigin || allowedOrigin === "*") {
      return true;
    }
    if (allowedOrigin instanceof RegExp && allowedOrigin.test(origin)) {
      return true;
    }
  }
  return false;
}
function expose(obj, ep = globalThis, allowedOrigins = ["*"]) {
  ep.addEventListener("message", function callback(ev) {
    if (!ev || !ev.data) {
      return;
    }
    if (!isAllowedOrigin(allowedOrigins, ev.origin)) {
      console.warn(`Invalid origin '${ev.origin}' for comlink proxy`);
      return;
    }
    const { id: id2, type, path } = Object.assign({ path: [] }, ev.data);
    const argumentList = (ev.data.argumentList || []).map(fromWireValue);
    let returnValue;
    try {
      const parent = path.slice(0, -1).reduce((obj2, prop) => obj2[prop], obj);
      const rawValue = path.reduce((obj2, prop) => obj2[prop], obj);
      switch (type) {
        case "GET":
          {
            returnValue = rawValue;
          }
          break;
        case "SET":
          {
            parent[path.slice(-1)[0]] = fromWireValue(ev.data.value);
            returnValue = true;
          }
          break;
        case "APPLY":
          {
            returnValue = rawValue.apply(parent, argumentList);
          }
          break;
        case "CONSTRUCT":
          {
            const value = new rawValue(...argumentList);
            returnValue = proxy(value);
          }
          break;
        case "ENDPOINT":
          {
            const { port1, port2 } = new MessageChannel();
            expose(obj, port2);
            returnValue = transfer(port1, [port1]);
          }
          break;
        case "RELEASE":
          {
            returnValue = void 0;
          }
          break;
        default:
          return;
      }
    } catch (value) {
      returnValue = { value, [throwMarker]: 0 };
    }
    Promise.resolve(returnValue).catch((value) => {
      return { value, [throwMarker]: 0 };
    }).then((returnValue2) => {
      const [wireValue, transferables] = toWireValue(returnValue2);
      ep.postMessage(Object.assign(Object.assign({}, wireValue), { id: id2 }), transferables);
      if (type === "RELEASE") {
        ep.removeEventListener("message", callback);
        closeEndPoint(ep);
        if (finalizer in obj && typeof obj[finalizer] === "function") {
          obj[finalizer]();
        }
      }
    }).catch((error) => {
      const [wireValue, transferables] = toWireValue({
        value: new TypeError("Unserializable return value"),
        [throwMarker]: 0
      });
      ep.postMessage(Object.assign(Object.assign({}, wireValue), { id: id2 }), transferables);
    });
  });
  if (ep.start) {
    ep.start();
  }
}
function isMessagePort(endpoint) {
  return endpoint.constructor.name === "MessagePort";
}
function closeEndPoint(endpoint) {
  if (isMessagePort(endpoint))
    endpoint.close();
}
function wrap$3(ep, target) {
  const pendingListeners = /* @__PURE__ */ new Map();
  ep.addEventListener("message", function handleMessage(ev) {
    const { data } = ev;
    if (!data || !data.id) {
      return;
    }
    const resolver2 = pendingListeners.get(data.id);
    if (!resolver2) {
      return;
    }
    try {
      resolver2(data);
    } finally {
      pendingListeners.delete(data.id);
    }
  });
  return createProxy$1(ep, pendingListeners, [], target);
}
function throwIfProxyReleased(isReleased) {
  if (isReleased) {
    throw new Error("Proxy has been released and is not useable");
  }
}
function releaseEndpoint(ep) {
  return requestResponseMessage(ep, /* @__PURE__ */ new Map(), {
    type: "RELEASE"
  }).then(() => {
    closeEndPoint(ep);
  });
}
const proxyCounter = /* @__PURE__ */ new WeakMap();
const proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((ep) => {
  const newCount = (proxyCounter.get(ep) || 0) - 1;
  proxyCounter.set(ep, newCount);
  if (newCount === 0) {
    releaseEndpoint(ep);
  }
});
function registerProxy(proxy2, ep) {
  const newCount = (proxyCounter.get(ep) || 0) + 1;
  proxyCounter.set(ep, newCount);
  if (proxyFinalizers) {
    proxyFinalizers.register(proxy2, ep, proxy2);
  }
}
function unregisterProxy(proxy2) {
  if (proxyFinalizers) {
    proxyFinalizers.unregister(proxy2);
  }
}
function createProxy$1(ep, pendingListeners, path = [], target = function() {
}) {
  let isProxyReleased = false;
  const proxy2 = new Proxy(target, {
    get(_target, prop) {
      throwIfProxyReleased(isProxyReleased);
      if (prop === releaseProxy) {
        return () => {
          unregisterProxy(proxy2);
          releaseEndpoint(ep);
          pendingListeners.clear();
          isProxyReleased = true;
        };
      }
      if (prop === "then") {
        if (path.length === 0) {
          return { then: () => proxy2 };
        }
        const r = requestResponseMessage(ep, pendingListeners, {
          type: "GET",
          path: path.map((p) => p.toString())
        }).then(fromWireValue);
        return r.then.bind(r);
      }
      return createProxy$1(ep, pendingListeners, [...path, prop]);
    },
    set(_target, prop, rawValue) {
      throwIfProxyReleased(isProxyReleased);
      const [value, transferables] = toWireValue(rawValue);
      return requestResponseMessage(ep, pendingListeners, {
        type: "SET",
        path: [...path, prop].map((p) => p.toString()),
        value
      }, transferables).then(fromWireValue);
    },
    apply(_target, _thisArg, rawArgumentList) {
      throwIfProxyReleased(isProxyReleased);
      const last2 = path[path.length - 1];
      if (last2 === createEndpoint) {
        return requestResponseMessage(ep, pendingListeners, {
          type: "ENDPOINT"
        }).then(fromWireValue);
      }
      if (last2 === "bind") {
        return createProxy$1(ep, pendingListeners, path.slice(0, -1));
      }
      const [argumentList, transferables] = processArguments(rawArgumentList);
      return requestResponseMessage(ep, pendingListeners, {
        type: "APPLY",
        path: path.map((p) => p.toString()),
        argumentList
      }, transferables).then(fromWireValue);
    },
    construct(_target, rawArgumentList) {
      throwIfProxyReleased(isProxyReleased);
      const [argumentList, transferables] = processArguments(rawArgumentList);
      return requestResponseMessage(ep, pendingListeners, {
        type: "CONSTRUCT",
        path: path.map((p) => p.toString()),
        argumentList
      }, transferables).then(fromWireValue);
    }
  });
  registerProxy(proxy2, ep);
  return proxy2;
}
function myFlat(arr) {
  return Array.prototype.concat.apply([], arr);
}
function processArguments(argumentList) {
  const processed = argumentList.map(toWireValue);
  return [processed.map((v2) => v2[0]), myFlat(processed.map((v2) => v2[1]))];
}
const transferCache = /* @__PURE__ */ new WeakMap();
function transfer(obj, transfers) {
  transferCache.set(obj, transfers);
  return obj;
}
function proxy(obj) {
  return Object.assign(obj, { [proxyMarker]: true });
}
function toWireValue(value) {
  for (const [name2, handler] of transferHandlers) {
    if (handler.canHandle(value)) {
      const [serializedValue, transferables] = handler.serialize(value);
      return [
        {
          type: "HANDLER",
          name: name2,
          value: serializedValue
        },
        transferables
      ];
    }
  }
  return [
    {
      type: "RAW",
      value
    },
    transferCache.get(value) || []
  ];
}
function fromWireValue(value) {
  switch (value.type) {
    case "HANDLER":
      return transferHandlers.get(value.name).deserialize(value.value);
    case "RAW":
      return value.value;
  }
}
function requestResponseMessage(ep, pendingListeners, msg, transfers) {
  return new Promise((resolve) => {
    const id2 = generateUUID();
    pendingListeners.set(id2, resolve);
    if (ep.start) {
      ep.start();
    }
    ep.postMessage(Object.assign({ id: id2 }, msg), transfers);
  });
}
function generateUUID() {
  return new Array(4).fill(0).map(() => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}
var DefaultContext$1 = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext$1 = React__default.createContext && /* @__PURE__ */ React__default.createContext(DefaultContext$1);
var _excluded$2 = ["attr", "size", "title"];
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function ownKeys$5(e2, r) {
  var t2 = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e2);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e2, r2).enumerable;
    })), t2.push.apply(t2, o);
  }
  return t2;
}
function _objectSpread$5(e2) {
  for (var r = 1; r < arguments.length; r++) {
    var t2 = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$5(Object(t2), true).forEach(function(r2) {
      _defineProperty$2(e2, r2, t2[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)) : ownKeys$5(Object(t2)).forEach(function(r2) {
      Object.defineProperty(e2, r2, Object.getOwnPropertyDescriptor(t2, r2));
    });
  }
  return e2;
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$1(t2) {
  var i2 = _toPrimitive$1(t2, "string");
  return "symbol" == typeof i2 ? i2 : i2 + "";
}
function _toPrimitive$1(t2, r) {
  if ("object" != typeof t2 || !t2) return t2;
  var e2 = t2[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i2 = e2.call(t2, r);
    if ("object" != typeof i2) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t2);
}
function Tree2Element$1(tree) {
  return tree && tree.map((node, i2) => /* @__PURE__ */ React__default.createElement(node.tag, _objectSpread$5({
    key: i2
  }, node.attr), Tree2Element$1(node.child)));
}
function GenIcon$1(data) {
  return (props2) => /* @__PURE__ */ React__default.createElement(IconBase$1, _extends$3({
    attr: _objectSpread$5({}, data.attr)
  }, props2), Tree2Element$1(data.child));
}
function IconBase$1(props2) {
  var elem = (conf) => {
    var {
      attr,
      size: size2,
      title: title2
    } = props2, svgProps = _objectWithoutProperties$1(props2, _excluded$2);
    var computedSize = size2 || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props2.className) className = (className ? className + " " : "") + props2.className;
    return /* @__PURE__ */ React__default.createElement("svg", _extends$3({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: _objectSpread$5(_objectSpread$5({
        color: props2.color || conf.color
      }, conf.style), props2.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title2 && /* @__PURE__ */ React__default.createElement("title", null, title2), props2.children);
  };
  return IconContext$1 !== void 0 ? /* @__PURE__ */ React__default.createElement(IconContext$1.Consumer, null, (conf) => elem(conf)) : elem(DefaultContext$1);
}
function MdError(props2) {
  return GenIcon$1({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }, "child": [] }] })(props2);
}
function promisifyRequest(request) {
  return new Promise((resolve, reject2) => {
    request.oncomplete = request.onsuccess = () => resolve(request.result);
    request.onabort = request.onerror = () => reject2(request.error);
  });
}
function createStore$4(dbName, storeName) {
  let dbp;
  const getDB = () => {
    if (dbp)
      return dbp;
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = () => request.result.createObjectStore(storeName);
    dbp = promisifyRequest(request);
    dbp.then((db) => {
      db.onclose = () => dbp = void 0;
    }, () => {
    });
    return dbp;
  };
  return (txMode, callback) => getDB().then((db) => callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let defaultGetStoreFunc;
function defaultGetStore() {
  if (!defaultGetStoreFunc) {
    defaultGetStoreFunc = createStore$4("keyval-store", "keyval");
  }
  return defaultGetStoreFunc;
}
function get$3(key, customStore = defaultGetStore()) {
  return customStore("readonly", (store2) => promisifyRequest(store2.get(key)));
}
if (typeof window === "undefined") {
  globalThis.window = globalThis;
}
const doenetGlobalConfig = {
  doenetWorkerUrl: getWorkerUrl()
};
window.doenetGlobalConfig = doenetGlobalConfig;
function getWorkerUrl() {
  try {
    return new URL(
      "/doenetml-worker/index.js",
      window?.location?.href || "https://doenet.org"
    ).href;
  } catch (e2) {
    return "https://doenet.org/doenetml-worker/index.js";
  }
}
const DefaultBufferLength$2 = 1024;
let nextPropID$2 = 0;
class Range {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
}
class NodeProp {
  /**
  Create a new node prop type.
  */
  constructor(config2 = {}) {
    this.id = nextPropID$2++;
    this.perNode = !!config2.perNode;
    this.deserialize = config2.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
    this.combine = config2.combine || null;
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(match2) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    if (typeof match2 != "function")
      match2 = NodeType.match(match2);
    return (type) => {
      let result2 = match2(type);
      return result2 === void 0 ? null : [this, result2];
    };
  }
}
NodeProp.closedBy = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.openedBy = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.group = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.isolate = new NodeProp({ deserialize: (value) => {
  if (value && value != "rtl" && value != "ltr" && value != "auto")
    throw new RangeError("Invalid value for isolate: " + value);
  return value || "auto";
} });
NodeProp.contextHash = new NodeProp({ perNode: true });
NodeProp.lookAhead = new NodeProp({ perNode: true });
NodeProp.mounted = new NodeProp({ perNode: true });
class MountedTree {
  constructor(tree, overlay, parser2) {
    this.tree = tree;
    this.overlay = overlay;
    this.parser = parser2;
  }
  /**
  @internal
  */
  static get(tree) {
    return tree && tree.props && tree.props[NodeProp.mounted.id];
  }
}
const noProps$2 = /* @__PURE__ */ Object.create(null);
class NodeType {
  /**
  @internal
  */
  constructor(name2, props2, id2, flags = 0) {
    this.name = name2;
    this.props = props2;
    this.id = id2;
    this.flags = flags;
  }
  /**
  Define a node type.
  */
  static define(spec) {
    let props2 = spec.props && spec.props.length ? /* @__PURE__ */ Object.create(null) : noProps$2;
    let flags = (spec.top ? 1 : 0) | (spec.skipped ? 2 : 0) | (spec.error ? 4 : 0) | (spec.name == null ? 8 : 0);
    let type = new NodeType(spec.name || "", props2, spec.id, flags);
    if (spec.props)
      for (let src of spec.props) {
        if (!Array.isArray(src))
          src = src(type);
        if (src) {
          if (src[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          props2[src[0].id] = src[1];
        }
      }
    return type;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(prop) {
    return this.props[prop.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(name2) {
    if (typeof name2 == "string") {
      if (this.name == name2)
        return true;
      let group2 = this.prop(NodeProp.group);
      return group2 ? group2.indexOf(name2) > -1 : false;
    }
    return this.id == name2;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(map2) {
    let direct = /* @__PURE__ */ Object.create(null);
    for (let prop in map2)
      for (let name2 of prop.split(" "))
        direct[name2] = map2[prop];
    return (node) => {
      for (let groups = node.prop(NodeProp.group), i2 = -1; i2 < (groups ? groups.length : 0); i2++) {
        let found = direct[i2 < 0 ? node.name : groups[i2]];
        if (found)
          return found;
      }
    };
  }
}
NodeType.none = new NodeType(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
let NodeSet$1 = class NodeSet2 {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(types2) {
    this.types = types2;
    for (let i2 = 0; i2 < types2.length; i2++)
      if (types2[i2].id != i2)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...props2) {
    let newTypes = [];
    for (let type of this.types) {
      let newProps = null;
      for (let source of props2) {
        let add2 = source(type);
        if (add2) {
          if (!newProps)
            newProps = Object.assign({}, type.props);
          let value = add2[1], prop = add2[0];
          if (prop.combine && prop.id in newProps)
            value = prop.combine(newProps[prop.id], value);
          newProps[prop.id] = value;
        }
      }
      newTypes.push(newProps ? new NodeType(type.name, newProps, type.id, type.flags) : type);
    }
    return new NodeSet2(newTypes);
  }
};
const CachedNode$2 = /* @__PURE__ */ new WeakMap(), CachedInnerNode$2 = /* @__PURE__ */ new WeakMap();
var IterMode$2;
(function(IterMode2) {
  IterMode2[IterMode2["ExcludeBuffers"] = 1] = "ExcludeBuffers";
  IterMode2[IterMode2["IncludeAnonymous"] = 2] = "IncludeAnonymous";
  IterMode2[IterMode2["IgnoreMounts"] = 4] = "IgnoreMounts";
  IterMode2[IterMode2["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})(IterMode$2 || (IterMode$2 = {}));
class Tree {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(type, children, positions, length, props2) {
    this.type = type;
    this.children = children;
    this.positions = positions;
    this.length = length;
    this.props = null;
    if (props2 && props2.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [prop, value] of props2)
        this.props[typeof prop == "number" ? prop : prop.id] = value;
    }
  }
  /**
  @internal
  */
  toString() {
    let mounted = MountedTree.get(this);
    if (mounted && !mounted.overlay)
      return mounted.tree.toString();
    let children = "";
    for (let ch of this.children) {
      let str = ch.toString();
      if (str) {
        if (children)
          children += ",";
        children += str;
      }
    }
    return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(mode = 0) {
    return new TreeCursor(this.topNode, mode);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(pos, side = 0, mode = 0) {
    let scope = CachedNode$2.get(this) || this.topNode;
    let cursor2 = new TreeCursor(scope);
    cursor2.moveTo(pos, side);
    CachedNode$2.set(this, cursor2._tree);
    return cursor2;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new TreeNode(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(pos, side = 0) {
    let node = resolveNode$2(CachedNode$2.get(this) || this.topNode, pos, side, false);
    CachedNode$2.set(this, node);
    return node;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(pos, side = 0) {
    let node = resolveNode$2(CachedInnerNode$2.get(this) || this.topNode, pos, side, true);
    CachedInnerNode$2.set(this, node);
    return node;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(pos, side = 0) {
    return stackIterator$2(this, pos, side);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(spec) {
    let { enter, leave, from = 0, to: to2 = this.length } = spec;
    let mode = spec.mode || 0, anon = (mode & IterMode$2.IncludeAnonymous) > 0;
    for (let c2 = this.cursor(mode | IterMode$2.IncludeAnonymous); ; ) {
      let entered = false;
      if (c2.from <= to2 && c2.to >= from && (!anon && c2.type.isAnonymous || enter(c2) !== false)) {
        if (c2.firstChild())
          continue;
        entered = true;
      }
      for (; ; ) {
        if (entered && leave && (anon || !c2.type.isAnonymous))
          leave(c2);
        if (c2.nextSibling())
          break;
        if (!c2.parent())
          return;
        entered = true;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(prop) {
    return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : void 0;
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let result2 = [];
    if (this.props)
      for (let id2 in this.props)
        result2.push([+id2, this.props[id2]]);
    return result2;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(config2 = {}) {
    return this.children.length <= 8 ? this : balanceRange$2(NodeType.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length) => new Tree(this.type, children, positions, length, this.propValues), config2.makeTree || ((children, positions, length) => new Tree(NodeType.none, children, positions, length)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(data) {
    return buildTree$2(data);
  }
}
Tree.empty = new Tree(NodeType.none, [], [], 0);
class FlatBufferCursor {
  constructor(buffer, index2) {
    this.buffer = buffer;
    this.index = index2;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new FlatBufferCursor(this.buffer, this.index);
  }
}
class TreeBuffer {
  /**
  Create a tree buffer.
  */
  constructor(buffer, length, set2) {
    this.buffer = buffer;
    this.length = length;
    this.set = set2;
  }
  /**
  @internal
  */
  get type() {
    return NodeType.none;
  }
  /**
  @internal
  */
  toString() {
    let result2 = [];
    for (let index2 = 0; index2 < this.buffer.length; ) {
      result2.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2.join(",");
  }
  /**
  @internal
  */
  childString(index2) {
    let id2 = this.buffer[index2], endIndex = this.buffer[index2 + 3];
    let type = this.set.types[id2], result2 = type.name;
    if (/\W/.test(result2) && !type.isError)
      result2 = JSON.stringify(result2);
    index2 += 4;
    if (endIndex == index2)
      return result2;
    let children = [];
    while (index2 < endIndex) {
      children.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2 + "(" + children.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(startIndex, endIndex, dir, pos, side) {
    let { buffer } = this, pick3 = -1;
    for (let i2 = startIndex; i2 != endIndex; i2 = buffer[i2 + 3]) {
      if (checkSide$2(side, pos, buffer[i2 + 1], buffer[i2 + 2])) {
        pick3 = i2;
        if (dir > 0)
          break;
      }
    }
    return pick3;
  }
  /**
  @internal
  */
  slice(startI, endI, from) {
    let b2 = this.buffer;
    let copy2 = new Uint16Array(endI - startI), len = 0;
    for (let i2 = startI, j2 = 0; i2 < endI; ) {
      copy2[j2++] = b2[i2++];
      copy2[j2++] = b2[i2++] - from;
      let to2 = copy2[j2++] = b2[i2++] - from;
      copy2[j2++] = b2[i2++] - startI;
      len = Math.max(len, to2);
    }
    return new TreeBuffer(copy2, len, this.set);
  }
}
function checkSide$2(side, pos, from, to2) {
  switch (side) {
    case -2:
      return from < pos;
    case -1:
      return to2 >= pos && from < pos;
    case 0:
      return from < pos && to2 > pos;
    case 1:
      return from <= pos && to2 > pos;
    case 2:
      return to2 > pos;
    case 4:
      return true;
  }
}
function resolveNode$2(node, pos, side, overlays) {
  var _a2;
  while (node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)) {
    let parent = !overlays && node instanceof TreeNode && node.index < 0 ? null : node.parent;
    if (!parent)
      return node;
    node = parent;
  }
  let mode = overlays ? 0 : IterMode$2.IgnoreOverlays;
  if (overlays)
    for (let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent) {
      if (scan instanceof TreeNode && scan.index < 0 && ((_a2 = parent.enter(pos, side, mode)) === null || _a2 === void 0 ? void 0 : _a2.from) != scan.from)
        node = parent;
    }
  for (; ; ) {
    let inner = node.enter(pos, side, mode);
    if (!inner)
      return node;
    node = inner;
  }
}
class BaseNode {
  cursor(mode = 0) {
    return new TreeCursor(this, mode);
  }
  getChild(type, before2 = null, after2 = null) {
    let r = getChildren$2(this, type, before2, after2);
    return r.length ? r[0] : null;
  }
  getChildren(type, before2 = null, after2 = null) {
    return getChildren$2(this, type, before2, after2);
  }
  resolve(pos, side = 0) {
    return resolveNode$2(this, pos, side, false);
  }
  resolveInner(pos, side = 0) {
    return resolveNode$2(this, pos, side, true);
  }
  matchContext(context) {
    return matchNodeContext$2(this.parent, context);
  }
  enterUnfinishedNodesBefore(pos) {
    let scan = this.childBefore(pos), node = this;
    while (scan) {
      let last2 = scan.lastChild;
      if (!last2 || last2.to != scan.to)
        break;
      if (last2.type.isError && last2.from == last2.to) {
        node = scan;
        scan = last2.prevSibling;
      } else {
        scan = last2;
      }
    }
    return node;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class TreeNode extends BaseNode {
  constructor(_tree, from, index2, _parent) {
    super();
    this._tree = _tree;
    this.from = from;
    this.index = index2;
    this._parent = _parent;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(i2, dir, pos, side, mode = 0) {
    for (let parent = this; ; ) {
      for (let { children, positions } = parent._tree, e2 = dir > 0 ? children.length : -1; i2 != e2; i2 += dir) {
        let next = children[i2], start = positions[i2] + parent.from;
        if (!checkSide$2(side, pos, start, start + next.length))
          continue;
        if (next instanceof TreeBuffer) {
          if (mode & IterMode$2.ExcludeBuffers)
            continue;
          let index2 = next.findChild(0, next.buffer.length, dir, pos - start, side);
          if (index2 > -1)
            return new BufferNode(new BufferContext(parent, next, i2, start), null, index2);
        } else if (mode & IterMode$2.IncludeAnonymous || (!next.type.isAnonymous || hasChild$2(next))) {
          let mounted;
          if (!(mode & IterMode$2.IgnoreMounts) && (mounted = MountedTree.get(next)) && !mounted.overlay)
            return new TreeNode(mounted.tree, start, i2, parent);
          let inner = new TreeNode(next, start, i2, parent);
          return mode & IterMode$2.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
        }
      }
      if (mode & IterMode$2.IncludeAnonymous || !parent.type.isAnonymous)
        return null;
      if (parent.index >= 0)
        i2 = parent.index + dir;
      else
        i2 = dir < 0 ? -1 : parent._parent._tree.children.length;
      parent = parent._parent;
      if (!parent)
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.nextChild(
      0,
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this._tree.prop(prop);
  }
  enter(pos, side, mode = 0) {
    let mounted;
    if (!(mode & IterMode$2.IgnoreOverlays) && (mounted = MountedTree.get(this._tree)) && mounted.overlay) {
      let rPos = pos - this.from;
      for (let { from, to: to2 } of mounted.overlay) {
        if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to2 >= rPos : to2 > rPos))
          return new TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
      }
    }
    return this.nextChild(0, 1, pos, side, mode);
  }
  nextSignificantParent() {
    let val = this;
    while (val.type.isAnonymous && val._parent)
      val = val._parent;
    return val;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function getChildren$2(node, type, before2, after2) {
  let cur2 = node.cursor(), result2 = [];
  if (!cur2.firstChild())
    return result2;
  if (before2 != null)
    for (let found = false; !found; ) {
      found = cur2.type.is(before2);
      if (!cur2.nextSibling())
        return result2;
    }
  for (; ; ) {
    if (after2 != null && cur2.type.is(after2))
      return result2;
    if (cur2.type.is(type))
      result2.push(cur2.node);
    if (!cur2.nextSibling())
      return after2 == null ? result2 : [];
  }
}
function matchNodeContext$2(node, context, i2 = context.length - 1) {
  for (let p = node; i2 >= 0; p = p.parent) {
    if (!p)
      return false;
    if (!p.type.isAnonymous) {
      if (context[i2] && context[i2] != p.name)
        return false;
      i2--;
    }
  }
  return true;
}
class BufferContext {
  constructor(parent, buffer, index2, start) {
    this.parent = parent;
    this.buffer = buffer;
    this.index = index2;
    this.start = start;
  }
}
class BufferNode extends BaseNode {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(context, _parent, index2) {
    super();
    this.context = context;
    this._parent = _parent;
    this.index = index2;
    this.type = context.buffer.set.types[context.buffer.buffer[index2]];
  }
  child(dir, pos, side) {
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode(this.context, this, index2);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.child(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.child(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this.type.prop(prop);
  }
  enter(pos, side, mode = 0) {
    if (mode & IterMode$2.ExcludeBuffers)
      return null;
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode(this.context, this, index2);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(dir) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + dir,
      dir,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer } = this.context;
    let after2 = buffer.buffer[this.index + 3];
    if (after2 < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length))
      return new BufferNode(this.context, this._parent, after2);
    return this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer } = this.context;
    let parentStart = this._parent ? this._parent.index + 4 : 0;
    if (this.index == parentStart)
      return this.externalSibling(-1);
    return new BufferNode(this.context, this._parent, buffer.findChild(
      parentStart,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let children = [], positions = [];
    let { buffer } = this.context;
    let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
    if (endI > startI) {
      let from = buffer.buffer[this.index + 1];
      children.push(buffer.slice(startI, endI, from));
      positions.push(0);
    }
    return new Tree(this.type, children, positions, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function iterStack$2(heads) {
  if (!heads.length)
    return null;
  let pick3 = 0, picked = heads[0];
  for (let i2 = 1; i2 < heads.length; i2++) {
    let node = heads[i2];
    if (node.from > picked.from || node.to < picked.to) {
      picked = node;
      pick3 = i2;
    }
  }
  let next = picked instanceof TreeNode && picked.index < 0 ? null : picked.parent;
  let newHeads = heads.slice();
  if (next)
    newHeads[pick3] = next;
  else
    newHeads.splice(pick3, 1);
  return new StackIterator(newHeads, picked);
}
class StackIterator {
  constructor(heads, node) {
    this.heads = heads;
    this.node = node;
  }
  get next() {
    return iterStack$2(this.heads);
  }
}
function stackIterator$2(tree, pos, side) {
  let inner = tree.resolveInner(pos, side), layers = null;
  for (let scan = inner instanceof TreeNode ? inner : inner.context.parent; scan; scan = scan.parent) {
    if (scan.index < 0) {
      let parent = scan.parent;
      (layers || (layers = [inner])).push(parent.resolve(pos, side));
      scan = parent;
    } else {
      let mount = MountedTree.get(scan.tree);
      if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
        let root2 = new TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
        (layers || (layers = [inner])).push(resolveNode$2(root2, pos, side, false));
      }
    }
  }
  return layers ? iterStack$2(layers) : inner;
}
class TreeCursor {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(node, mode = 0) {
    this.mode = mode;
    this.buffer = null;
    this.stack = [];
    this.index = 0;
    this.bufferNode = null;
    if (node instanceof TreeNode) {
      this.yieldNode(node);
    } else {
      this._tree = node.context.parent;
      this.buffer = node.context;
      for (let n = node._parent; n; n = n._parent)
        this.stack.unshift(n.index);
      this.bufferNode = node;
      this.yieldBuf(node.index);
    }
  }
  yieldNode(node) {
    if (!node)
      return false;
    this._tree = node;
    this.type = node.type;
    this.from = node.from;
    this.to = node.to;
    return true;
  }
  yieldBuf(index2, type) {
    this.index = index2;
    let { start, buffer } = this.buffer;
    this.type = type || buffer.set.types[buffer.buffer[index2]];
    this.from = start + buffer.buffer[index2 + 1];
    this.to = start + buffer.buffer[index2 + 2];
    return true;
  }
  /**
  @internal
  */
  yield(node) {
    if (!node)
      return false;
    if (node instanceof TreeNode) {
      this.buffer = null;
      return this.yieldNode(node);
    }
    this.buffer = node.context;
    return this.yieldBuf(node.index, node.type);
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(dir, pos, side) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
    let { buffer } = this.buffer;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
    if (index2 < 0)
      return false;
    this.stack.push(this.index);
    return this.yieldBuf(index2);
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(pos) {
    return this.enterChild(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(pos) {
    return this.enterChild(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(pos, side, mode = this.mode) {
    if (!this.buffer)
      return this.yield(this._tree.enter(pos, side, mode));
    return mode & IterMode$2.ExcludeBuffers ? false : this.enterChild(1, pos, side);
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & IterMode$2.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let parent = this.mode & IterMode$2.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    this.buffer = null;
    return this.yieldNode(parent);
  }
  /**
  @internal
  */
  sibling(dir) {
    if (!this.buffer)
      return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4, this.mode));
    let { buffer } = this.buffer, d = this.stack.length - 1;
    if (dir < 0) {
      let parentStart = d < 0 ? 0 : this.stack[d] + 4;
      if (this.index != parentStart)
        return this.yieldBuf(buffer.findChild(
          parentStart,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let after2 = buffer.buffer[this.index + 3];
      if (after2 < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3]))
        return this.yieldBuf(after2);
    }
    return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4, this.mode)) : false;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(dir) {
    let index2, parent, { buffer } = this;
    if (buffer) {
      if (dir > 0) {
        if (this.index < buffer.buffer.buffer.length)
          return false;
      } else {
        for (let i2 = 0; i2 < this.index; i2++)
          if (buffer.buffer.buffer[i2 + 3] < this.index)
            return false;
      }
      ({ index: index2, parent } = buffer);
    } else {
      ({ index: index2, _parent: parent } = this._tree);
    }
    for (; parent; { index: index2, _parent: parent } = parent) {
      if (index2 > -1)
        for (let i2 = index2 + dir, e2 = dir < 0 ? -1 : parent._tree.children.length; i2 != e2; i2 += dir) {
          let child = parent._tree.children[i2];
          if (this.mode & IterMode$2.IncludeAnonymous || child instanceof TreeBuffer || !child.type.isAnonymous || hasChild$2(child))
            return false;
        }
    }
    return true;
  }
  move(dir, enter) {
    if (enter && this.enterChild(
      dir,
      0,
      4
      /* Side.DontCare */
    ))
      return true;
    for (; ; ) {
      if (this.sibling(dir))
        return true;
      if (this.atLastNode(dir) || !this.parent())
        return false;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(enter = true) {
    return this.move(1, enter);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(enter = true) {
    return this.move(-1, enter);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(pos, side = 0) {
    while (this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))
      if (!this.parent())
        break;
    while (this.enterChild(1, pos, side)) {
    }
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let cache = this.bufferNode, result2 = null, depth = 0;
    if (cache && cache.context == this.buffer) {
      scan: for (let index2 = this.index, d = this.stack.length; d >= 0; ) {
        for (let c2 = cache; c2; c2 = c2._parent)
          if (c2.index == index2) {
            if (index2 == this.index)
              return c2;
            result2 = c2;
            depth = d + 1;
            break scan;
          }
        index2 = this.stack[--d];
      }
    }
    for (let i2 = depth; i2 < this.stack.length; i2++)
      result2 = new BufferNode(this.buffer, result2, this.stack[i2]);
    return this.bufferNode = new BufferNode(this.buffer, result2, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(enter, leave) {
    for (let depth = 0; ; ) {
      let mustLeave = false;
      if (this.type.isAnonymous || enter(this) !== false) {
        if (this.firstChild()) {
          depth++;
          continue;
        }
        if (!this.type.isAnonymous)
          mustLeave = true;
      }
      for (; ; ) {
        if (mustLeave && leave)
          leave(this);
        mustLeave = this.type.isAnonymous;
        if (!depth)
          return;
        if (this.nextSibling())
          break;
        this.parent();
        depth--;
        mustLeave = true;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(context) {
    if (!this.buffer)
      return matchNodeContext$2(this.node.parent, context);
    let { buffer } = this.buffer, { types: types2 } = buffer.set;
    for (let i2 = context.length - 1, d = this.stack.length - 1; i2 >= 0; d--) {
      if (d < 0)
        return matchNodeContext$2(this._tree, context, i2);
      let type = types2[buffer.buffer[this.stack[d]]];
      if (!type.isAnonymous) {
        if (context[i2] && context[i2] != type.name)
          return false;
        i2--;
      }
    }
    return true;
  }
}
function hasChild$2(tree) {
  return tree.children.some((ch) => ch instanceof TreeBuffer || !ch.type.isAnonymous || hasChild$2(ch));
}
function buildTree$2(data) {
  var _a2;
  let { buffer, nodeSet, maxBufferLength = DefaultBufferLength$2, reused = [], minRepeatType = nodeSet.types.length } = data;
  let cursor2 = Array.isArray(buffer) ? new FlatBufferCursor(buffer, buffer.length) : buffer;
  let types2 = nodeSet.types;
  let contextHash = 0, lookAhead = 0;
  function takeNode(parentStart, minPos, children2, positions2, inRepeat, depth) {
    let { id: id2, start, end, size: size2 } = cursor2;
    let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
    if (size2 < 0) {
      cursor2.next();
      if (size2 == -1) {
        let node2 = reused[id2];
        children2.push(node2);
        positions2.push(start - parentStart);
        return;
      } else if (size2 == -3) {
        contextHash = id2;
        return;
      } else if (size2 == -4) {
        lookAhead = id2;
        return;
      } else {
        throw new RangeError(`Unrecognized record size: ${size2}`);
      }
    }
    let type = types2[id2], node, buffer2;
    let startPos = start - parentStart;
    if (end - start <= maxBufferLength && (buffer2 = findBufferSize(cursor2.pos - minPos, inRepeat))) {
      let data2 = new Uint16Array(buffer2.size - buffer2.skip);
      let endPos = cursor2.pos - buffer2.size, index2 = data2.length;
      while (cursor2.pos > endPos)
        index2 = copyToBuffer(buffer2.start, data2, index2);
      node = new TreeBuffer(data2, end - buffer2.start, nodeSet);
      startPos = buffer2.start - parentStart;
    } else {
      let endPos = cursor2.pos - size2;
      cursor2.next();
      let localChildren = [], localPositions = [];
      let localInRepeat = id2 >= minRepeatType ? id2 : -1;
      let lastGroup = 0, lastEnd = end;
      while (cursor2.pos > endPos) {
        if (localInRepeat >= 0 && cursor2.id == localInRepeat && cursor2.size >= 0) {
          if (cursor2.end <= lastEnd - maxBufferLength) {
            makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor2.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            lastGroup = localChildren.length;
            lastEnd = cursor2.end;
          }
          cursor2.next();
        } else if (depth > 2500) {
          takeFlatNode(start, endPos, localChildren, localPositions);
        } else {
          takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
        }
      }
      if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length)
        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
      localChildren.reverse();
      localPositions.reverse();
      if (localInRepeat > -1 && lastGroup > 0) {
        let make = makeBalanced(type, contextAtStart);
        node = balanceRange$2(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
      } else {
        node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
      }
    }
    children2.push(node);
    positions2.push(startPos);
  }
  function takeFlatNode(parentStart, minPos, children2, positions2) {
    let nodes = [];
    let nodeCount = 0, stopAt = -1;
    while (cursor2.pos > minPos) {
      let { id: id2, start, end, size: size2 } = cursor2;
      if (size2 > 4) {
        cursor2.next();
      } else if (stopAt > -1 && start < stopAt) {
        break;
      } else {
        if (stopAt < 0)
          stopAt = end - maxBufferLength;
        nodes.push(id2, start, end);
        nodeCount++;
        cursor2.next();
      }
    }
    if (nodeCount) {
      let buffer2 = new Uint16Array(nodeCount * 4);
      let start = nodes[nodes.length - 2];
      for (let i2 = nodes.length - 3, j2 = 0; i2 >= 0; i2 -= 3) {
        buffer2[j2++] = nodes[i2];
        buffer2[j2++] = nodes[i2 + 1] - start;
        buffer2[j2++] = nodes[i2 + 2] - start;
        buffer2[j2++] = j2;
      }
      children2.push(new TreeBuffer(buffer2, nodes[2] - start, nodeSet));
      positions2.push(start - parentStart);
    }
  }
  function makeBalanced(type, contextHash2) {
    return (children2, positions2, length2) => {
      let lookAhead2 = 0, lastI = children2.length - 1, last2, lookAheadProp;
      if (lastI >= 0 && (last2 = children2[lastI]) instanceof Tree) {
        if (!lastI && last2.type == type && last2.length == length2)
          return last2;
        if (lookAheadProp = last2.prop(NodeProp.lookAhead))
          lookAhead2 = positions2[lastI] + last2.length + lookAheadProp;
      }
      return makeTree(type, children2, positions2, length2, lookAhead2, contextHash2);
    };
  }
  function makeRepeatLeaf(children2, positions2, base2, i2, from, to2, type, lookAhead2, contextHash2) {
    let localChildren = [], localPositions = [];
    while (children2.length > i2) {
      localChildren.push(children2.pop());
      localPositions.push(positions2.pop() + base2 - from);
    }
    children2.push(makeTree(nodeSet.types[type], localChildren, localPositions, to2 - from, lookAhead2 - to2, contextHash2));
    positions2.push(from - base2);
  }
  function makeTree(type, children2, positions2, length2, lookAhead2, contextHash2, props2) {
    if (contextHash2) {
      let pair2 = [NodeProp.contextHash, contextHash2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    if (lookAhead2 > 25) {
      let pair2 = [NodeProp.lookAhead, lookAhead2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    return new Tree(type, children2, positions2, length2, props2);
  }
  function findBufferSize(maxSize, inRepeat) {
    let fork = cursor2.fork();
    let size2 = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
    let result2 = { size: 0, start: 0, skip: 0 };
    scan: for (let minPos = fork.pos - maxSize; fork.pos > minPos; ) {
      let nodeSize2 = fork.size;
      if (fork.id == inRepeat && nodeSize2 >= 0) {
        result2.size = size2;
        result2.start = start;
        result2.skip = skip;
        skip += 4;
        size2 += 4;
        fork.next();
        continue;
      }
      let startPos = fork.pos - nodeSize2;
      if (nodeSize2 < 0 || startPos < minPos || fork.start < minStart)
        break;
      let localSkipped = fork.id >= minRepeatType ? 4 : 0;
      let nodeStart2 = fork.start;
      fork.next();
      while (fork.pos > startPos) {
        if (fork.size < 0) {
          if (fork.size == -3 || fork.size == -4)
            localSkipped += 4;
          else
            break scan;
        } else if (fork.id >= minRepeatType) {
          localSkipped += 4;
        }
        fork.next();
      }
      start = nodeStart2;
      size2 += nodeSize2;
      skip += localSkipped;
    }
    if (inRepeat < 0 || size2 == maxSize) {
      result2.size = size2;
      result2.start = start;
      result2.skip = skip;
    }
    return result2.size > 4 ? result2 : void 0;
  }
  function copyToBuffer(bufferStart, buffer2, index2) {
    let { id: id2, start, end, size: size2 } = cursor2;
    cursor2.next();
    if (size2 >= 0 && id2 < minRepeatType) {
      let startIndex = index2;
      if (size2 > 4) {
        let endPos = cursor2.pos - (size2 - 4);
        while (cursor2.pos > endPos)
          index2 = copyToBuffer(bufferStart, buffer2, index2);
      }
      buffer2[--index2] = startIndex;
      buffer2[--index2] = end - bufferStart;
      buffer2[--index2] = start - bufferStart;
      buffer2[--index2] = id2;
    } else if (size2 == -3) {
      contextHash = id2;
    } else if (size2 == -4) {
      lookAhead = id2;
    }
    return index2;
  }
  let children = [], positions = [];
  while (cursor2.pos > 0)
    takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
  let length = (_a2 = data.length) !== null && _a2 !== void 0 ? _a2 : children.length ? positions[0] + children[0].length : 0;
  return new Tree(types2[data.topID], children.reverse(), positions.reverse(), length);
}
const nodeSizeCache$2 = /* @__PURE__ */ new WeakMap();
function nodeSize$2(balanceType, node) {
  if (!balanceType.isAnonymous || node instanceof TreeBuffer || node.type != balanceType)
    return 1;
  let size2 = nodeSizeCache$2.get(node);
  if (size2 == null) {
    size2 = 1;
    for (let child of node.children) {
      if (child.type != balanceType || !(child instanceof Tree)) {
        size2 = 1;
        break;
      }
      size2 += nodeSize$2(balanceType, child);
    }
    nodeSizeCache$2.set(node, size2);
  }
  return size2;
}
function balanceRange$2(balanceType, children, positions, from, to2, start, length, mkTop, mkTree) {
  let total = 0;
  for (let i2 = from; i2 < to2; i2++)
    total += nodeSize$2(balanceType, children[i2]);
  let maxChild = Math.ceil(
    total * 1.5 / 8
    /* Balance.BranchFactor */
  );
  let localChildren = [], localPositions = [];
  function divide2(children2, positions2, from2, to22, offset2) {
    for (let i2 = from2; i2 < to22; ) {
      let groupFrom = i2, groupStart = positions2[i2], groupSize = nodeSize$2(balanceType, children2[i2]);
      i2++;
      for (; i2 < to22; i2++) {
        let nextSize = nodeSize$2(balanceType, children2[i2]);
        if (groupSize + nextSize >= maxChild)
          break;
        groupSize += nextSize;
      }
      if (i2 == groupFrom + 1) {
        if (groupSize > maxChild) {
          let only = children2[groupFrom];
          divide2(only.children, only.positions, 0, only.children.length, positions2[groupFrom] + offset2);
          continue;
        }
        localChildren.push(children2[groupFrom]);
      } else {
        let length2 = positions2[i2 - 1] + children2[i2 - 1].length - groupStart;
        localChildren.push(balanceRange$2(balanceType, children2, positions2, groupFrom, i2, groupStart, length2, null, mkTree));
      }
      localPositions.push(groupStart + offset2 - start);
    }
  }
  divide2(children, positions, from, to2, 0);
  return (mkTop || mkTree)(localChildren, localPositions, length);
}
class Parser {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(input, fragments, ranges) {
    if (typeof input == "string")
      input = new StringInput(input);
    ranges = !ranges ? [new Range(0, input.length)] : ranges.length ? ranges.map((r) => new Range(r.from, r.to)) : [new Range(0, 0)];
    return this.createParse(input, fragments || [], ranges);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(input, fragments, ranges) {
    let parse2 = this.startParse(input, fragments, ranges);
    for (; ; ) {
      let done = parse2.advance();
      if (done)
        return done;
    }
  }
}
class StringInput {
  constructor(string2) {
    this.string = string2;
  }
  get length() {
    return this.string.length;
  }
  chunk(from) {
    return this.string.slice(from);
  }
  get lineChunks() {
    return false;
  }
  read(from, to2) {
    return this.string.slice(from, to2);
  }
}
new NodeProp({ perNode: true });
let Stack$1 = class Stack2 {
  /**
  @internal
  */
  constructor(p, stack, state, reducePos, pos, score2, buffer, bufferBase, curContext, lookAhead = 0, parent) {
    this.p = p;
    this.stack = stack;
    this.state = state;
    this.reducePos = reducePos;
    this.pos = pos;
    this.score = score2;
    this.buffer = buffer;
    this.bufferBase = bufferBase;
    this.curContext = curContext;
    this.lookAhead = lookAhead;
    this.parent = parent;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((_2, i2) => i2 % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(p, state, pos = 0) {
    let cx = p.parser.context;
    return new Stack2(p, [], state, pos, pos, 0, [], 0, cx ? new StackContext$1(cx, cx.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(state, start) {
    this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
    this.state = state;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(action) {
    var _a2;
    let depth = action >> 19, type = action & 65535;
    let { parser: parser2 } = this.p;
    let lookaheadRecord = this.reducePos < this.pos - 25 && this.setLookAhead(this.pos);
    let dPrec = parser2.dynamicPrecedence(type);
    if (dPrec)
      this.score += dPrec;
    if (depth == 0) {
      this.pushState(parser2.getGoto(this.state, type, true), this.reducePos);
      if (type < parser2.minRepeatTerm)
        this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
      this.reduceContext(type, this.reducePos);
      return;
    }
    let base2 = this.stack.length - (depth - 1) * 3 - (action & 262144 ? 6 : 0);
    let start = base2 ? this.stack[base2 - 2] : this.p.ranges[0].from, size2 = this.reducePos - start;
    if (size2 >= 2e3 && !((_a2 = this.p.parser.nodeSet.types[type]) === null || _a2 === void 0 ? void 0 : _a2.isAnonymous)) {
      if (start == this.p.lastBigReductionStart) {
        this.p.bigReductionCount++;
        this.p.lastBigReductionSize = size2;
      } else if (this.p.lastBigReductionSize < size2) {
        this.p.bigReductionCount = 1;
        this.p.lastBigReductionStart = start;
        this.p.lastBigReductionSize = size2;
      }
    }
    let bufferBase = base2 ? this.stack[base2 - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
    if (type < parser2.minRepeatTerm || action & 131072) {
      let pos = parser2.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(type, start, pos, count + 4, true);
    }
    if (action & 262144) {
      this.state = this.stack[base2];
    } else {
      let baseStateID = this.stack[base2 - 3];
      this.state = parser2.getGoto(baseStateID, type, true);
    }
    while (this.stack.length > base2)
      this.stack.pop();
    this.reduceContext(type, start);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(term, start, end, size2 = 4, mustSink = false) {
    if (term == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let cur2 = this, top2 = this.buffer.length;
      if (top2 == 0 && cur2.parent) {
        top2 = cur2.bufferBase - cur2.parent.bufferBase;
        cur2 = cur2.parent;
      }
      if (top2 > 0 && cur2.buffer[top2 - 4] == 0 && cur2.buffer[top2 - 1] > -1) {
        if (start == end)
          return;
        if (cur2.buffer[top2 - 2] >= start) {
          cur2.buffer[top2 - 2] = end;
          return;
        }
      }
    }
    if (!mustSink || this.pos == end) {
      this.buffer.push(term, start, end, size2);
    } else {
      let index2 = this.buffer.length;
      if (index2 > 0 && (this.buffer[index2 - 4] != 0 || this.buffer[index2 - 1] < 0)) {
        let mustMove = false;
        for (let scan = index2; scan > 0 && this.buffer[scan - 2] > end; scan -= 4) {
          if (this.buffer[scan - 1] >= 0) {
            mustMove = true;
            break;
          }
        }
        if (mustMove)
          while (index2 > 0 && this.buffer[index2 - 2] > end) {
            this.buffer[index2] = this.buffer[index2 - 4];
            this.buffer[index2 + 1] = this.buffer[index2 - 3];
            this.buffer[index2 + 2] = this.buffer[index2 - 2];
            this.buffer[index2 + 3] = this.buffer[index2 - 1];
            index2 -= 4;
            if (size2 > 4)
              size2 -= 4;
          }
      }
      this.buffer[index2] = term;
      this.buffer[index2 + 1] = start;
      this.buffer[index2 + 2] = end;
      this.buffer[index2 + 3] = size2;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(action, type, start, end) {
    if (action & 131072) {
      this.pushState(action & 65535, this.pos);
    } else if ((action & 262144) == 0) {
      let nextState = action, { parser: parser2 } = this.p;
      if (end > this.pos || type <= parser2.maxNode) {
        this.pos = end;
        if (!parser2.stateFlag(
          nextState,
          1
          /* StateFlag.Skipped */
        ))
          this.reducePos = end;
      }
      this.pushState(nextState, start);
      this.shiftContext(type, start);
      if (type <= parser2.maxNode)
        this.buffer.push(type, start, end, 4);
    } else {
      this.pos = end;
      this.shiftContext(type, start);
      if (type <= this.p.parser.maxNode)
        this.buffer.push(type, start, end, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(action, next, nextStart, nextEnd) {
    if (action & 65536)
      this.reduce(action);
    else
      this.shift(action, next, nextStart, nextEnd);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(value, next) {
    let index2 = this.p.reused.length - 1;
    if (index2 < 0 || this.p.reused[index2] != value) {
      this.p.reused.push(value);
      index2++;
    }
    let start = this.pos;
    this.reducePos = this.pos = start + value.length;
    this.pushState(next, start);
    this.buffer.push(
      index2,
      start,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    );
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let parent = this;
    let off2 = parent.buffer.length;
    while (off2 > 0 && parent.buffer[off2 - 2] > parent.reducePos)
      off2 -= 4;
    let buffer = parent.buffer.slice(off2), base2 = parent.bufferBase + off2;
    while (parent && base2 == parent.bufferBase)
      parent = parent.parent;
    return new Stack2(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base2, this.curContext, this.lookAhead, parent);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(next, nextEnd) {
    let isNode2 = next <= this.p.parser.maxNode;
    if (isNode2)
      this.storeNode(next, this.pos, nextEnd, 4);
    this.storeNode(0, this.pos, nextEnd, isNode2 ? 8 : 4);
    this.pos = this.reducePos = nextEnd;
    this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(term) {
    for (let sim = new SimulatedStack$1(this); ; ) {
      let action = this.p.parser.stateSlot(
        sim.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(sim.state, term);
      if (action == 0)
        return false;
      if ((action & 65536) == 0)
        return true;
      sim.reduce(action);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(next) {
    if (this.stack.length >= 300)
      return [];
    let nextStates = this.p.parser.nextStates(this.state);
    if (nextStates.length > 4 << 1 || this.stack.length >= 120) {
      let best = [];
      for (let i2 = 0, s; i2 < nextStates.length; i2 += 2) {
        if ((s = nextStates[i2 + 1]) != this.state && this.p.parser.hasAction(s, next))
          best.push(nextStates[i2], s);
      }
      if (this.stack.length < 120)
        for (let i2 = 0; best.length < 4 << 1 && i2 < nextStates.length; i2 += 2) {
          let s = nextStates[i2 + 1];
          if (!best.some((v2, i22) => i22 & 1 && v2 == s))
            best.push(nextStates[i2], s);
        }
      nextStates = best;
    }
    let result2 = [];
    for (let i2 = 0; i2 < nextStates.length && result2.length < 4; i2 += 2) {
      let s = nextStates[i2 + 1];
      if (s == this.state)
        continue;
      let stack = this.split();
      stack.pushState(s, this.pos);
      stack.storeNode(0, stack.pos, stack.pos, 4, true);
      stack.shiftContext(nextStates[i2], this.pos);
      stack.reducePos = this.pos;
      stack.score -= 200;
      result2.push(stack);
    }
    return result2;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: parser2 } = this.p;
    let reduce2 = parser2.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((reduce2 & 65536) == 0)
      return false;
    if (!parser2.validAction(this.state, reduce2)) {
      let depth = reduce2 >> 19, term = reduce2 & 65535;
      let target = this.stack.length - depth * 3;
      if (target < 0 || parser2.getGoto(this.stack[target], term, false) < 0) {
        let backup = this.findForcedReduction();
        if (backup == null)
          return false;
        reduce2 = backup;
      }
      this.storeNode(0, this.pos, this.pos, 4, true);
      this.score -= 100;
    }
    this.reducePos = this.pos;
    this.reduce(reduce2);
    return true;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: parser2 } = this.p, seen = [];
    let explore = (state, depth) => {
      if (seen.includes(state))
        return;
      seen.push(state);
      return parser2.allActions(state, (action) => {
        if (action & (262144 | 131072)) ;
        else if (action & 65536) {
          let rDepth = (action >> 19) - depth;
          if (rDepth > 1) {
            let term = action & 65535, target = this.stack.length - rDepth * 3;
            if (target >= 0 && parser2.getGoto(this.stack[target], term, false) >= 0)
              return rDepth << 19 | 65536 | term;
          }
        } else {
          let found = explore(action, depth + 1);
          if (found != null)
            return found;
        }
      });
    };
    return explore(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    while (!this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    )) {
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, true);
        break;
      }
    }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return false;
    let { parser: parser2 } = this.p;
    return parser2.data[parser2.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !parser2.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, true);
    this.state = this.stack[0];
    this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(other) {
    if (this.state != other.state || this.stack.length != other.stack.length)
      return false;
    for (let i2 = 0; i2 < this.stack.length; i2 += 3)
      if (this.stack[i2] != other.stack[i2])
        return false;
    return true;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(dialectID) {
    return this.p.parser.dialect.flags[dialectID];
  }
  shiftContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  reduceContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  /**
  @internal
  */
  emitContext() {
    let last2 = this.buffer.length - 1;
    if (last2 < 0 || this.buffer[last2] != -3)
      this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let last2 = this.buffer.length - 1;
    if (last2 < 0 || this.buffer[last2] != -4)
      this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(context) {
    if (context != this.curContext.context) {
      let newCx = new StackContext$1(this.curContext.tracker, context);
      if (newCx.hash != this.curContext.hash)
        this.emitContext();
      this.curContext = newCx;
    }
  }
  /**
  @internal
  */
  setLookAhead(lookAhead) {
    if (lookAhead <= this.lookAhead)
      return false;
    this.emitLookAhead();
    this.lookAhead = lookAhead;
    return true;
  }
  /**
  @internal
  */
  close() {
    if (this.curContext && this.curContext.tracker.strict)
      this.emitContext();
    if (this.lookAhead > 0)
      this.emitLookAhead();
  }
};
let StackContext$1 = class StackContext2 {
  constructor(tracker, context) {
    this.tracker = tracker;
    this.context = context;
    this.hash = tracker.strict ? tracker.hash(context) : 0;
  }
};
let SimulatedStack$1 = class SimulatedStack2 {
  constructor(start) {
    this.start = start;
    this.state = start.state;
    this.stack = start.stack;
    this.base = this.stack.length;
  }
  reduce(action) {
    let term = action & 65535, depth = action >> 19;
    if (depth == 0) {
      if (this.stack == this.start.stack)
        this.stack = this.stack.slice();
      this.stack.push(this.state, 0, 0);
      this.base += 3;
    } else {
      this.base -= (depth - 1) * 3;
    }
    let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
    this.state = goto;
  }
};
let StackBufferCursor$1 = class StackBufferCursor2 {
  constructor(stack, pos, index2) {
    this.stack = stack;
    this.pos = pos;
    this.index = index2;
    this.buffer = stack.buffer;
    if (this.index == 0)
      this.maybeNext();
  }
  static create(stack, pos = stack.bufferBase + stack.buffer.length) {
    return new StackBufferCursor2(stack, pos, pos - stack.bufferBase);
  }
  maybeNext() {
    let next = this.stack.parent;
    if (next != null) {
      this.index = this.stack.bufferBase - next.bufferBase;
      this.stack = next;
      this.buffer = next.buffer;
    }
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4;
    this.pos -= 4;
    if (this.index == 0)
      this.maybeNext();
  }
  fork() {
    return new StackBufferCursor2(this.stack, this.pos, this.index);
  }
};
function decodeArray$1(input, Type = Uint16Array) {
  if (typeof input != "string")
    return input;
  let array = null;
  for (let pos = 0, out = 0; pos < input.length; ) {
    let value = 0;
    for (; ; ) {
      let next = input.charCodeAt(pos++), stop = false;
      if (next == 126) {
        value = 65535;
        break;
      }
      if (next >= 92)
        next--;
      if (next >= 34)
        next--;
      let digit = next - 32;
      if (digit >= 46) {
        digit -= 46;
        stop = true;
      }
      value += digit;
      if (stop)
        break;
      value *= 46;
    }
    if (array)
      array[out++] = value;
    else
      array = new Type(value);
  }
  return array;
}
let CachedToken$1 = class CachedToken2 {
  constructor() {
    this.start = -1;
    this.value = -1;
    this.end = -1;
    this.extended = -1;
    this.lookAhead = 0;
    this.mask = 0;
    this.context = 0;
  }
};
const nullToken$1 = new CachedToken$1();
let InputStream$1 = class InputStream2 {
  /**
  @internal
  */
  constructor(input, ranges) {
    this.input = input;
    this.ranges = ranges;
    this.chunk = "";
    this.chunkOff = 0;
    this.chunk2 = "";
    this.chunk2Pos = 0;
    this.next = -1;
    this.token = nullToken$1;
    this.rangeIndex = 0;
    this.pos = this.chunkPos = ranges[0].from;
    this.range = ranges[0];
    this.end = ranges[ranges.length - 1].to;
    this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(offset2, assoc) {
    let range2 = this.range, index2 = this.rangeIndex;
    let pos = this.pos + offset2;
    while (pos < range2.from) {
      if (!index2)
        return null;
      let next = this.ranges[--index2];
      pos -= range2.from - next.to;
      range2 = next;
    }
    while (assoc < 0 ? pos > range2.to : pos >= range2.to) {
      if (index2 == this.ranges.length - 1)
        return null;
      let next = this.ranges[++index2];
      pos += next.from - range2.to;
      range2 = next;
    }
    return pos;
  }
  /**
  @internal
  */
  clipPos(pos) {
    if (pos >= this.range.from && pos < this.range.to)
      return pos;
    for (let range2 of this.ranges)
      if (range2.to > pos)
        return Math.max(pos, range2.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(offset2) {
    let idx = this.chunkOff + offset2, pos, result2;
    if (idx >= 0 && idx < this.chunk.length) {
      pos = this.pos + offset2;
      result2 = this.chunk.charCodeAt(idx);
    } else {
      let resolved = this.resolveOffset(offset2, 1);
      if (resolved == null)
        return -1;
      pos = resolved;
      if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) {
        result2 = this.chunk2.charCodeAt(pos - this.chunk2Pos);
      } else {
        let i2 = this.rangeIndex, range2 = this.range;
        while (range2.to <= pos)
          range2 = this.ranges[++i2];
        this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
        if (pos + this.chunk2.length > range2.to)
          this.chunk2 = this.chunk2.slice(0, range2.to - pos);
        result2 = this.chunk2.charCodeAt(0);
      }
    }
    if (pos >= this.token.lookAhead)
      this.token.lookAhead = pos + 1;
    return result2;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(token, endOffset = 0) {
    let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
    if (end == null || end < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = token;
    this.token.end = end;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(token, endPos) {
    this.token.value = token;
    this.token.end = endPos;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: chunk2, chunkPos } = this;
      this.chunk = this.chunk2;
      this.chunkPos = this.chunk2Pos;
      this.chunk2 = chunk2;
      this.chunk2Pos = chunkPos;
      this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk;
      this.chunk2Pos = this.chunkPos;
      let nextChunk = this.input.chunk(this.pos);
      let end = this.pos + nextChunk.length;
      this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
      this.chunkPos = this.pos;
      this.chunkOff = 0;
    }
  }
  readNext() {
    if (this.chunkOff >= this.chunk.length) {
      this.getChunk();
      if (this.chunkOff == this.chunk.length)
        return this.next = -1;
    }
    return this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(n = 1) {
    this.chunkOff += n;
    while (this.pos + n >= this.range.to) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      n -= this.range.to - this.pos;
      this.range = this.ranges[++this.rangeIndex];
      this.pos = this.range.from;
    }
    this.pos += n;
    if (this.pos >= this.token.lookAhead)
      this.token.lookAhead = this.pos + 1;
    return this.readNext();
  }
  setDone() {
    this.pos = this.chunkPos = this.end;
    this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
    this.chunk = "";
    return this.next = -1;
  }
  /**
  @internal
  */
  reset(pos, token) {
    if (token) {
      this.token = token;
      token.start = pos;
      token.lookAhead = pos + 1;
      token.value = token.extended = -1;
    } else {
      this.token = nullToken$1;
    }
    if (this.pos != pos) {
      this.pos = pos;
      if (pos == this.end) {
        this.setDone();
        return this;
      }
      while (pos < this.range.from)
        this.range = this.ranges[--this.rangeIndex];
      while (pos >= this.range.to)
        this.range = this.ranges[++this.rangeIndex];
      if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) {
        this.chunkOff = pos - this.chunkPos;
      } else {
        this.chunk = "";
        this.chunkOff = 0;
      }
      this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(from, to2) {
    if (from >= this.chunkPos && to2 <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(from - this.chunkPos, to2 - this.chunkPos);
    if (from >= this.chunk2Pos && to2 <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(from - this.chunk2Pos, to2 - this.chunk2Pos);
    if (from >= this.range.from && to2 <= this.range.to)
      return this.input.read(from, to2);
    let result2 = "";
    for (let r of this.ranges) {
      if (r.from >= to2)
        break;
      if (r.to > from)
        result2 += this.input.read(Math.max(r.from, from), Math.min(r.to, to2));
    }
    return result2;
  }
};
let TokenGroup$1 = class TokenGroup2 {
  constructor(data, id2) {
    this.data = data;
    this.id = id2;
  }
  token(input, stack) {
    let { parser: parser2 } = stack.p;
    readToken$1(this.data, input, stack, this.id, parser2.data, parser2.tokenPrecTable);
  }
};
TokenGroup$1.prototype.contextual = TokenGroup$1.prototype.fallback = TokenGroup$1.prototype.extend = false;
TokenGroup$1.prototype.fallback = TokenGroup$1.prototype.extend = false;
let ExternalTokenizer$1 = class ExternalTokenizer2 {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(token, options2 = {}) {
    this.token = token;
    this.contextual = !!options2.contextual;
    this.fallback = !!options2.fallback;
    this.extend = !!options2.extend;
  }
};
function readToken$1(data, input, stack, group2, precTable, precOffset) {
  let state = 0, groupMask = 1 << group2, { dialect } = stack.p.parser;
  scan: for (; ; ) {
    if ((groupMask & data[state]) == 0)
      break;
    let accEnd = data[state + 1];
    for (let i2 = state + 3; i2 < accEnd; i2 += 2)
      if ((data[i2 + 1] & groupMask) > 0) {
        let term = data[i2];
        if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || overrides$1(term, input.token.value, precTable, precOffset))) {
          input.acceptToken(term);
          break;
        }
      }
    let next = input.next, low = 0, high = data[state + 2];
    if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535) {
      state = data[accEnd + high * 3 - 1];
      continue scan;
    }
    for (; low < high; ) {
      let mid = low + high >> 1;
      let index2 = accEnd + mid + (mid << 1);
      let from = data[index2], to2 = data[index2 + 1] || 65536;
      if (next < from)
        high = mid;
      else if (next >= to2)
        low = mid + 1;
      else {
        state = data[index2 + 2];
        input.advance();
        continue scan;
      }
    }
    break;
  }
}
function findOffset$1(data, start, term) {
  for (let i2 = start, next; (next = data[i2]) != 65535; i2++)
    if (next == term)
      return i2 - start;
  return -1;
}
function overrides$1(token, prev, tableData, tableOffset) {
  let iPrev = findOffset$1(tableData, tableOffset, prev);
  return iPrev < 0 || findOffset$1(tableData, tableOffset, token) < iPrev;
}
const verbose$1 = typeof process != "undefined" && process.env && /\bparse\b/.test(process.env.LOG);
let stackIDs$1 = null;
function cutAt$1(tree, pos, side) {
  let cursor2 = tree.cursor(IterMode$2.IncludeAnonymous);
  cursor2.moveTo(pos);
  for (; ; ) {
    if (!(side < 0 ? cursor2.childBefore(pos) : cursor2.childAfter(pos)))
      for (; ; ) {
        if ((side < 0 ? cursor2.to < pos : cursor2.from > pos) && !cursor2.type.isError)
          return side < 0 ? Math.max(0, Math.min(
            cursor2.to - 1,
            pos - 25
            /* Lookahead.Margin */
          )) : Math.min(tree.length, Math.max(
            cursor2.from + 1,
            pos + 25
            /* Lookahead.Margin */
          ));
        if (side < 0 ? cursor2.prevSibling() : cursor2.nextSibling())
          break;
        if (!cursor2.parent())
          return side < 0 ? 0 : tree.length;
      }
  }
}
let FragmentCursor$1 = class FragmentCursor2 {
  constructor(fragments, nodeSet) {
    this.fragments = fragments;
    this.nodeSet = nodeSet;
    this.i = 0;
    this.fragment = null;
    this.safeFrom = -1;
    this.safeTo = -1;
    this.trees = [];
    this.start = [];
    this.index = [];
    this.nextFragment();
  }
  nextFragment() {
    let fr2 = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (fr2) {
      this.safeFrom = fr2.openStart ? cutAt$1(fr2.tree, fr2.from + fr2.offset, 1) - fr2.offset : fr2.from;
      this.safeTo = fr2.openEnd ? cutAt$1(fr2.tree, fr2.to + fr2.offset, -1) - fr2.offset : fr2.to;
      while (this.trees.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
      }
      this.trees.push(fr2.tree);
      this.start.push(-fr2.offset);
      this.index.push(0);
      this.nextStart = this.safeFrom;
    } else {
      this.nextStart = 1e9;
    }
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(pos) {
    if (pos < this.nextStart)
      return null;
    while (this.fragment && this.safeTo <= pos)
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let last2 = this.trees.length - 1;
      if (last2 < 0) {
        this.nextFragment();
        return null;
      }
      let top2 = this.trees[last2], index2 = this.index[last2];
      if (index2 == top2.children.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
        continue;
      }
      let next = top2.children[index2];
      let start = this.start[last2] + top2.positions[index2];
      if (start > pos) {
        this.nextStart = start;
        return null;
      }
      if (next instanceof Tree) {
        if (start == pos) {
          if (start < this.safeFrom)
            return null;
          let end = start + next.length;
          if (end <= this.safeTo) {
            let lookAhead = next.prop(NodeProp.lookAhead);
            if (!lookAhead || end + lookAhead < this.fragment.to)
              return next;
          }
        }
        this.index[last2]++;
        if (start + next.length >= Math.max(this.safeFrom, pos)) {
          this.trees.push(next);
          this.start.push(start);
          this.index.push(0);
        }
      } else {
        this.index[last2]++;
        this.nextStart = start + next.length;
      }
    }
  }
};
let TokenCache$1 = class TokenCache2 {
  constructor(parser2, stream) {
    this.stream = stream;
    this.tokens = [];
    this.mainToken = null;
    this.actions = [];
    this.tokens = parser2.tokenizers.map((_2) => new CachedToken$1());
  }
  getActions(stack) {
    let actionIndex = 0;
    let main2 = null;
    let { parser: parser2 } = stack.p, { tokenizers } = parser2;
    let mask = parser2.stateSlot(
      stack.state,
      3
      /* ParseState.TokenizerMask */
    );
    let context = stack.curContext ? stack.curContext.hash : 0;
    let lookAhead = 0;
    for (let i2 = 0; i2 < tokenizers.length; i2++) {
      if ((1 << i2 & mask) == 0)
        continue;
      let tokenizer = tokenizers[i2], token = this.tokens[i2];
      if (main2 && !tokenizer.fallback)
        continue;
      if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
        this.updateCachedToken(token, tokenizer, stack);
        token.mask = mask;
        token.context = context;
      }
      if (token.lookAhead > token.end + 25)
        lookAhead = Math.max(token.lookAhead, lookAhead);
      if (token.value != 0) {
        let startIndex = actionIndex;
        if (token.extended > -1)
          actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
        actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
        if (!tokenizer.extend) {
          main2 = token;
          if (actionIndex > startIndex)
            break;
        }
      }
    }
    while (this.actions.length > actionIndex)
      this.actions.pop();
    if (lookAhead)
      stack.setLookAhead(lookAhead);
    if (!main2 && stack.pos == this.stream.end) {
      main2 = new CachedToken$1();
      main2.value = stack.p.parser.eofTerm;
      main2.start = main2.end = stack.pos;
      actionIndex = this.addActions(stack, main2.value, main2.end, actionIndex);
    }
    this.mainToken = main2;
    return this.actions;
  }
  getMainToken(stack) {
    if (this.mainToken)
      return this.mainToken;
    let main2 = new CachedToken$1(), { pos, p } = stack;
    main2.start = pos;
    main2.end = Math.min(pos + 1, p.stream.end);
    main2.value = pos == p.stream.end ? p.parser.eofTerm : 0;
    return main2;
  }
  updateCachedToken(token, tokenizer, stack) {
    let start = this.stream.clipPos(stack.pos);
    tokenizer.token(this.stream.reset(start, token), stack);
    if (token.value > -1) {
      let { parser: parser2 } = stack.p;
      for (let i2 = 0; i2 < parser2.specialized.length; i2++)
        if (parser2.specialized[i2] == token.value) {
          let result2 = parser2.specializers[i2](this.stream.read(token.start, token.end), stack);
          if (result2 >= 0 && stack.p.parser.dialect.allows(result2 >> 1)) {
            if ((result2 & 1) == 0)
              token.value = result2 >> 1;
            else
              token.extended = result2 >> 1;
            break;
          }
        }
    } else {
      token.value = 0;
      token.end = this.stream.clipPos(start + 1);
    }
  }
  putAction(action, token, end, index2) {
    for (let i2 = 0; i2 < index2; i2 += 3)
      if (this.actions[i2] == action)
        return index2;
    this.actions[index2++] = action;
    this.actions[index2++] = token;
    this.actions[index2++] = end;
    return index2;
  }
  addActions(stack, token, end, index2) {
    let { state } = stack, { parser: parser2 } = stack.p, { data } = parser2;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = parser2.stateSlot(
        state,
        set2 ? 2 : 1
        /* ParseState.Actions */
      ); ; i2 += 3) {
        if (data[i2] == 65535) {
          if (data[i2 + 1] == 1) {
            i2 = pair$1(data, i2 + 2);
          } else {
            if (index2 == 0 && data[i2 + 1] == 2)
              index2 = this.putAction(pair$1(data, i2 + 2), token, end, index2);
            break;
          }
        }
        if (data[i2] == token)
          index2 = this.putAction(pair$1(data, i2 + 1), token, end, index2);
      }
    }
    return index2;
  }
};
let Parse$1 = class Parse2 {
  constructor(parser2, input, fragments, ranges) {
    this.parser = parser2;
    this.input = input;
    this.ranges = ranges;
    this.recovering = 0;
    this.nextStackID = 9812;
    this.minStackPos = 0;
    this.reused = [];
    this.stoppedAt = null;
    this.lastBigReductionStart = -1;
    this.lastBigReductionSize = 0;
    this.bigReductionCount = 0;
    this.stream = new InputStream$1(input, ranges);
    this.tokens = new TokenCache$1(parser2, this.stream);
    this.topTerm = parser2.top[1];
    let { from } = ranges[0];
    this.stacks = [Stack$1.start(this, parser2.top[0], from)];
    this.fragments = fragments.length && this.stream.end - from > parser2.bufferLength * 4 ? new FragmentCursor$1(fragments, parser2.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let stacks = this.stacks, pos = this.minStackPos;
    let newStacks = this.stacks = [];
    let stopped, stoppedTokens;
    if (this.bigReductionCount > 300 && stacks.length == 1) {
      let [s] = stacks;
      while (s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart) {
      }
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack = stacks[i2];
      for (; ; ) {
        this.tokens.mainToken = null;
        if (stack.pos > pos) {
          newStacks.push(stack);
        } else if (this.advanceStack(stack, newStacks, stacks)) {
          continue;
        } else {
          if (!stopped) {
            stopped = [];
            stoppedTokens = [];
          }
          stopped.push(stack);
          let tok = this.tokens.getMainToken(stack);
          stoppedTokens.push(tok.value, tok.end);
        }
        break;
      }
    }
    if (!newStacks.length) {
      let finished = stopped && findFinished$1(stopped);
      if (finished) {
        if (verbose$1)
          console.log("Finish with " + this.stackID(finished));
        return this.stackToTree(finished);
      }
      if (this.parser.strict) {
        if (verbose$1 && stopped)
          console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
        throw new SyntaxError("No parse at " + pos);
      }
      if (!this.recovering)
        this.recovering = 5;
    }
    if (this.recovering && stopped) {
      let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
      if (finished) {
        if (verbose$1)
          console.log("Force-finish " + this.stackID(finished));
        return this.stackToTree(finished.forceAll());
      }
    }
    if (this.recovering) {
      let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3;
      if (newStacks.length > maxRemaining) {
        newStacks.sort((a, b2) => b2.score - a.score);
        while (newStacks.length > maxRemaining)
          newStacks.pop();
      }
      if (newStacks.some((s) => s.reducePos > pos))
        this.recovering--;
    } else if (newStacks.length > 1) {
      outer: for (let i2 = 0; i2 < newStacks.length - 1; i2++) {
        let stack = newStacks[i2];
        for (let j2 = i2 + 1; j2 < newStacks.length; j2++) {
          let other = newStacks[j2];
          if (stack.sameState(other) || stack.buffer.length > 500 && other.buffer.length > 500) {
            if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) {
              newStacks.splice(j2--, 1);
            } else {
              newStacks.splice(i2--, 1);
              continue outer;
            }
          }
        }
      }
      if (newStacks.length > 12)
        newStacks.splice(
          12,
          newStacks.length - 12
          /* Rec.MaxStackCount */
        );
    }
    this.minStackPos = newStacks[0].pos;
    for (let i2 = 1; i2 < newStacks.length; i2++)
      if (newStacks[i2].pos < this.minStackPos)
        this.minStackPos = newStacks[i2].pos;
    return null;
  }
  stopAt(pos) {
    if (this.stoppedAt != null && this.stoppedAt < pos)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = pos;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(stack, stacks, split) {
    let start = stack.pos, { parser: parser2 } = this;
    let base2 = verbose$1 ? this.stackID(stack) + " -> " : "";
    if (this.stoppedAt != null && start > this.stoppedAt)
      return stack.forceReduce() ? stack : null;
    if (this.fragments) {
      let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
      for (let cached = this.fragments.nodeAt(start); cached; ) {
        let match2 = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser2.getGoto(stack.state, cached.type.id) : -1;
        if (match2 > -1 && cached.length && (!strictCx || (cached.prop(NodeProp.contextHash) || 0) == cxHash)) {
          stack.useNode(cached, match2);
          if (verbose$1)
            console.log(base2 + this.stackID(stack) + ` (via reuse of ${parser2.getName(cached.type.id)})`);
          return true;
        }
        if (!(cached instanceof Tree) || cached.children.length == 0 || cached.positions[0] > 0)
          break;
        let inner = cached.children[0];
        if (inner instanceof Tree && cached.positions[0] == 0)
          cached = inner;
        else
          break;
      }
    }
    let defaultReduce = parser2.stateSlot(
      stack.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (defaultReduce > 0) {
      stack.reduce(defaultReduce);
      if (verbose$1)
        console.log(base2 + this.stackID(stack) + ` (via always-reduce ${parser2.getName(
          defaultReduce & 65535
          /* Action.ValueMask */
        )})`);
      return true;
    }
    if (stack.stack.length >= 8400) {
      while (stack.stack.length > 6e3 && stack.forceReduce()) {
      }
    }
    let actions = this.tokens.getActions(stack);
    for (let i2 = 0; i2 < actions.length; ) {
      let action = actions[i2++], term = actions[i2++], end = actions[i2++];
      let last2 = i2 == actions.length || !split;
      let localStack = last2 ? stack : stack.split();
      let main2 = this.tokens.mainToken;
      localStack.apply(action, term, main2 ? main2.start : localStack.pos, end);
      if (verbose$1)
        console.log(base2 + this.stackID(localStack) + ` (via ${(action & 65536) == 0 ? "shift" : `reduce of ${parser2.getName(
          action & 65535
          /* Action.ValueMask */
        )}`} for ${parser2.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
      if (last2)
        return true;
      else if (localStack.pos > start)
        stacks.push(localStack);
      else
        split.push(localStack);
    }
    return false;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(stack, newStacks) {
    let pos = stack.pos;
    for (; ; ) {
      if (!this.advanceStack(stack, null, null))
        return false;
      if (stack.pos > pos) {
        pushStackDedup$1(stack, newStacks);
        return true;
      }
    }
  }
  runRecovery(stacks, tokens, newStacks) {
    let finished = null, restarted = false;
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack = stacks[i2], token = tokens[i2 << 1], tokenEnd = tokens[(i2 << 1) + 1];
      let base2 = verbose$1 ? this.stackID(stack) + " -> " : "";
      if (stack.deadEnd) {
        if (restarted)
          continue;
        restarted = true;
        stack.restart();
        if (verbose$1)
          console.log(base2 + this.stackID(stack) + " (restarted)");
        let done = this.advanceFully(stack, newStacks);
        if (done)
          continue;
      }
      let force = stack.split(), forceBase = base2;
      for (let j2 = 0; j2 < 10 && force.forceReduce(); j2++) {
        if (verbose$1)
          console.log(forceBase + this.stackID(force) + " (via force-reduce)");
        let done = this.advanceFully(force, newStacks);
        if (done)
          break;
        if (verbose$1)
          forceBase = this.stackID(force) + " -> ";
      }
      for (let insert2 of stack.recoverByInsert(token)) {
        if (verbose$1)
          console.log(base2 + this.stackID(insert2) + " (via recover-insert)");
        this.advanceFully(insert2, newStacks);
      }
      if (this.stream.end > stack.pos) {
        if (tokenEnd == stack.pos) {
          tokenEnd++;
          token = 0;
        }
        stack.recoverByDelete(token, tokenEnd);
        if (verbose$1)
          console.log(base2 + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
        pushStackDedup$1(stack, newStacks);
      } else if (!finished || finished.score < stack.score) {
        finished = stack;
      }
    }
    return finished;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(stack) {
    stack.close();
    return Tree.build({
      buffer: StackBufferCursor$1.create(stack),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: stack.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(stack) {
    let id2 = (stackIDs$1 || (stackIDs$1 = /* @__PURE__ */ new WeakMap())).get(stack);
    if (!id2)
      stackIDs$1.set(stack, id2 = String.fromCodePoint(this.nextStackID++));
    return id2 + stack;
  }
};
function pushStackDedup$1(stack, newStacks) {
  for (let i2 = 0; i2 < newStacks.length; i2++) {
    let other = newStacks[i2];
    if (other.pos == stack.pos && other.sameState(stack)) {
      if (newStacks[i2].score < stack.score)
        newStacks[i2] = stack;
      return;
    }
  }
  newStacks.push(stack);
}
let Dialect$1 = class Dialect2 {
  constructor(source, flags, disabled) {
    this.source = source;
    this.flags = flags;
    this.disabled = disabled;
  }
  allows(term) {
    return !this.disabled || this.disabled[term] == 0;
  }
};
const id$1 = (x2) => x2;
let ContextTracker$1 = class ContextTracker2 {
  /**
  Define a context tracker.
  */
  constructor(spec) {
    this.start = spec.start;
    this.shift = spec.shift || id$1;
    this.reduce = spec.reduce || id$1;
    this.reuse = spec.reuse || id$1;
    this.hash = spec.hash || (() => 0);
    this.strict = spec.strict !== false;
  }
};
let LRParser$1 = class LRParser2 extends Parser {
  /**
  @internal
  */
  constructor(spec) {
    super();
    this.wrappers = [];
    if (spec.version != 14)
      throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14})`);
    let nodeNames = spec.nodeNames.split(" ");
    this.minRepeatTerm = nodeNames.length;
    for (let i2 = 0; i2 < spec.repeatNodeCount; i2++)
      nodeNames.push("");
    let topTerms = Object.keys(spec.topRules).map((r) => spec.topRules[r][1]);
    let nodeProps = [];
    for (let i2 = 0; i2 < nodeNames.length; i2++)
      nodeProps.push([]);
    function setProp(nodeID, prop, value) {
      nodeProps[nodeID].push([prop, prop.deserialize(String(value))]);
    }
    if (spec.nodeProps)
      for (let propSpec of spec.nodeProps) {
        let prop = propSpec[0];
        if (typeof prop == "string")
          prop = NodeProp[prop];
        for (let i2 = 1; i2 < propSpec.length; ) {
          let next = propSpec[i2++];
          if (next >= 0) {
            setProp(next, prop, propSpec[i2++]);
          } else {
            let value = propSpec[i2 + -next];
            for (let j2 = -next; j2 > 0; j2--)
              setProp(propSpec[i2++], prop, value);
            i2++;
          }
        }
      }
    this.nodeSet = new NodeSet$1(nodeNames.map((name2, i2) => NodeType.define({
      name: i2 >= this.minRepeatTerm ? void 0 : name2,
      id: i2,
      props: nodeProps[i2],
      top: topTerms.indexOf(i2) > -1,
      error: i2 == 0,
      skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i2) > -1
    })));
    if (spec.propSources)
      this.nodeSet = this.nodeSet.extend(...spec.propSources);
    this.strict = false;
    this.bufferLength = DefaultBufferLength$2;
    let tokenArray = decodeArray$1(spec.tokenData);
    this.context = spec.context;
    this.specializerSpecs = spec.specialized || [];
    this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let i2 = 0; i2 < this.specializerSpecs.length; i2++)
      this.specialized[i2] = this.specializerSpecs[i2].term;
    this.specializers = this.specializerSpecs.map(getSpecializer$1);
    this.states = decodeArray$1(spec.states, Uint32Array);
    this.data = decodeArray$1(spec.stateData);
    this.goto = decodeArray$1(spec.goto);
    this.maxTerm = spec.maxTerm;
    this.tokenizers = spec.tokenizers.map((value) => typeof value == "number" ? new TokenGroup$1(tokenArray, value) : value);
    this.topRules = spec.topRules;
    this.dialects = spec.dialects || {};
    this.dynamicPrecedences = spec.dynamicPrecedences || null;
    this.tokenPrecTable = spec.tokenPrec;
    this.termNames = spec.termNames || null;
    this.maxNode = this.nodeSet.types.length - 1;
    this.dialect = this.parseDialect();
    this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(input, fragments, ranges) {
    let parse2 = new Parse$1(this, input, fragments, ranges);
    for (let w2 of this.wrappers)
      parse2 = w2(parse2, input, fragments, ranges);
    return parse2;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(state, term, loose = false) {
    let table = this.goto;
    if (term >= table[0])
      return -1;
    for (let pos = table[term + 1]; ; ) {
      let groupTag = table[pos++], last2 = groupTag & 1;
      let target = table[pos++];
      if (last2 && loose)
        return target;
      for (let end = pos + (groupTag >> 1); pos < end; pos++)
        if (table[pos] == state)
          return target;
      if (last2)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(state, terminal) {
    let data = this.data;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = this.stateSlot(
        state,
        set2 ? 2 : 1
        /* ParseState.Actions */
      ), next; ; i2 += 3) {
        if ((next = data[i2]) == 65535) {
          if (data[i2 + 1] == 1)
            next = data[i2 = pair$1(data, i2 + 2)];
          else if (data[i2 + 1] == 2)
            return pair$1(data, i2 + 2);
          else
            break;
        }
        if (next == terminal || next == 0)
          return pair$1(data, i2 + 1);
      }
    }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(state, slot) {
    return this.states[state * 6 + slot];
  }
  /**
  @internal
  */
  stateFlag(state, flag) {
    return (this.stateSlot(
      state,
      0
      /* ParseState.Flags */
    ) & flag) > 0;
  }
  /**
  @internal
  */
  validAction(state, action) {
    return !!this.allActions(state, (a) => a == action ? true : null);
  }
  /**
  @internal
  */
  allActions(state, action) {
    let deflt = this.stateSlot(
      state,
      4
      /* ParseState.DefaultReduce */
    );
    let result2 = deflt ? action(deflt) : void 0;
    for (let i2 = this.stateSlot(
      state,
      1
      /* ParseState.Actions */
    ); result2 == null; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair$1(this.data, i2 + 2);
        else
          break;
      }
      result2 = action(pair$1(this.data, i2 + 1));
    }
    return result2;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(state) {
    let result2 = [];
    for (let i2 = this.stateSlot(
      state,
      1
      /* ParseState.Actions */
    ); ; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair$1(this.data, i2 + 2);
        else
          break;
      }
      if ((this.data[i2 + 2] & 65536 >> 16) == 0) {
        let value = this.data[i2 + 1];
        if (!result2.some((v2, i22) => i22 & 1 && v2 == value))
          result2.push(this.data[i2], value);
      }
    }
    return result2;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(config2) {
    let copy2 = Object.assign(Object.create(LRParser2.prototype), this);
    if (config2.props)
      copy2.nodeSet = this.nodeSet.extend(...config2.props);
    if (config2.top) {
      let info = this.topRules[config2.top];
      if (!info)
        throw new RangeError(`Invalid top rule name ${config2.top}`);
      copy2.top = info;
    }
    if (config2.tokenizers)
      copy2.tokenizers = this.tokenizers.map((t2) => {
        let found = config2.tokenizers.find((r) => r.from == t2);
        return found ? found.to : t2;
      });
    if (config2.specializers) {
      copy2.specializers = this.specializers.slice();
      copy2.specializerSpecs = this.specializerSpecs.map((s, i2) => {
        let found = config2.specializers.find((r) => r.from == s.external);
        if (!found)
          return s;
        let spec = Object.assign(Object.assign({}, s), { external: found.to });
        copy2.specializers[i2] = getSpecializer$1(spec);
        return spec;
      });
    }
    if (config2.contextTracker)
      copy2.context = config2.contextTracker;
    if (config2.dialect)
      copy2.dialect = this.parseDialect(config2.dialect);
    if (config2.strict != null)
      copy2.strict = config2.strict;
    if (config2.wrap)
      copy2.wrappers = copy2.wrappers.concat(config2.wrap);
    if (config2.bufferLength != null)
      copy2.bufferLength = config2.bufferLength;
    return copy2;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(term) {
    return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(term) {
    let prec2 = this.dynamicPrecedences;
    return prec2 == null ? 0 : prec2[term] || 0;
  }
  /**
  @internal
  */
  parseDialect(dialect) {
    let values2 = Object.keys(this.dialects), flags = values2.map(() => false);
    if (dialect)
      for (let part of dialect.split(" ")) {
        let id2 = values2.indexOf(part);
        if (id2 >= 0)
          flags[id2] = true;
      }
    let disabled = null;
    for (let i2 = 0; i2 < values2.length; i2++)
      if (!flags[i2]) {
        for (let j2 = this.dialects[values2[i2]], id2; (id2 = this.data[j2++]) != 65535; )
          (disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id2] = 1;
      }
    return new Dialect$1(dialect, flags, disabled);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(spec) {
    return new LRParser2(spec);
  }
};
function pair$1(data, off2) {
  return data[off2] | data[off2 + 1] << 16;
}
function findFinished$1(stacks) {
  let best = null;
  for (let stack of stacks) {
    let stopped = stack.p.stoppedAt;
    if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(
      stack.state,
      2
      /* StateFlag.Accepting */
    ) && (!best || best.score < stack.score))
      best = stack;
  }
  return best;
}
function getSpecializer$1(spec) {
  if (spec.external) {
    let mask = spec.extend ? 1 : 0;
    return (value, stack) => spec.external(value, stack) << 1 | mask;
  }
  return spec.get;
}
const StartTag$1 = 1, StartCloseTag$1 = 2, MissingCloseTag$1 = 3, mismatchedStartCloseTag$1 = 4, incompleteStartCloseTag$1 = 5, commentContent$1$1 = 36, piContent$1$1 = 37, cdataContent$1$1 = 38, Text = 7, Element$2 = 12, EndTag = 13, OpenTag$1 = 14, TagName$y = 15, Attribute = 16, AttributeValue = 19, CloseTag = 20, SelfCloseEndTag = 21, SelfClosingTag = 22, MismatchedCloseTag = 25;
function nameChar$1(ch) {
  return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
function isSpace$1(ch) {
  return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}
let cachedName$1 = null, cachedInput$1 = null, cachedPos$1 = 0;
function tagNameAfter$1(input, offset2) {
  let pos = input.pos + offset2;
  if (cachedInput$1 == input && cachedPos$1 == pos) return cachedName$1;
  while (isSpace$1(input.peek(offset2))) offset2++;
  let name2 = "";
  for (; ; ) {
    let next = input.peek(offset2);
    if (!nameChar$1(next)) break;
    name2 += String.fromCharCode(next);
    offset2++;
  }
  cachedInput$1 = input;
  cachedPos$1 = pos;
  return cachedName$1 = name2 || null;
}
let ElementContext$1 = class ElementContext2 {
  constructor(name2, parent) {
    this.name = name2;
    this.parent = parent ?? null;
    this.hash = parent ? parent.hash : 0;
    for (let i2 = 0; i2 < name2.length; i2++) {
      this.hash += (this.hash << 4) + name2.charCodeAt(i2) + (name2.charCodeAt(i2) << 8);
    }
  }
};
const elementContext$1 = new ContextTracker$1({
  start: null,
  shift(context, term, stack, input) {
    return term == StartTag$1 ? new ElementContext$1(tagNameAfter$1(input, 1) || "", context) : context;
  },
  reduce(context, term) {
    return term == Element$2 && context ? context.parent : context;
  },
  reuse(context, node, _stack, input) {
    let type = node.type.id;
    return type == StartTag$1 || type == OpenTag$1 ? new ElementContext$1(tagNameAfter$1(input, 1) || "", context) : context;
  },
  hash(context) {
    return context ? context.hash : 0;
  },
  strict: false
});
const startTag$1 = new ExternalTokenizer$1(
  (input, stack) => {
    if (input.next !== 60) {
      return;
    }
    const nextNext = input.peek(1);
    if (nextNext === 61) {
      return;
    }
    input.advance();
    if (input.next === 47) {
      input.advance();
      let name2 = tagNameAfter$1(input, 0);
      if (!name2) {
        return input.acceptToken(incompleteStartCloseTag$1);
      }
      if (stack.context && name2.toLowerCase() == stack.context.name.toLowerCase()) {
        return input.acceptToken(StartCloseTag$1);
      }
      for (let cx = stack.context; cx; cx = cx.parent) {
        if (cx.name === name2) {
          return input.acceptToken(MissingCloseTag$1, -2);
        }
      }
      input.acceptToken(mismatchedStartCloseTag$1);
    } else if (
      // @ts-ignore
      input.next !== 33 && // @ts-ignore
      input.next !== 63 && !isSpace$1(input.next)
    ) {
      return input.acceptToken(StartTag$1);
    }
  },
  { contextual: true }
);
const textLessThan$1 = new ExternalTokenizer$1((input) => {
  if (input.next !== 60) {
    return;
  }
  const nextNext = input.peek(1);
  if (nextNext === 60) {
    return input.acceptToken(Text, 1);
  }
});
function scanTo$1(type, end) {
  return new ExternalTokenizer$1((input) => {
    for (let endPos = 0, len = 0; ; len++) {
      if (input.next < 0) {
        if (len) {
          input.acceptToken(type);
        }
        break;
      }
      if (input.next == end.charCodeAt(endPos)) {
        endPos++;
        if (endPos == end.length) {
          if (len > end.length) {
            input.acceptToken(type, 1 - end.length);
          }
          break;
        }
      } else {
        endPos = 0;
      }
      input.advance();
    }
  });
}
const commentContent$2 = scanTo$1(commentContent$1$1, "-->");
const piContent$2 = scanTo$1(piContent$1$1, "?>");
const cdataContent$2 = scanTo$1(cdataContent$1$1, "]]>");
const parser$1 = LRParser$1.deserialize({
  version: 14,
  states: "(jOVOqOOOzO!jO'#CgO!SQ!bO'#CjO!|OqO'#ChOOOP'#Ch'#ChO#TO!dO'#CsO#]O!fO'#CtO#eQ!bO'#CuOOOP'#DW'#DWOOOP'#Cw'#CwQVOqOOOOOW'#Cx'#CxO#jO!jO,59ROOOP,59R,59RO#rQ#tO,59UOOOP'#C|'#C|O#}OqO,59SO$UQ!bO'#CpOOOP,59S,59SOOOQ'#C}'#C}O$ZO!dO,59_OOOP,59_,59_OOOS'#DO'#DOO$cO!fO,59`OOOP,59`,59`O$kQ!bO,59aOOOP-E6u-E6uOOOW-E6v-E6vOOOP1G.m1G.mO$pQ#tO'#ClOOQO'#Cy'#CyO%OQ#tO1G.pOOOP1G.p1G.pOOOP1G.x1G.xOOOP-E6z-E6zOOOP1G.n1G.nO%ZQ!bO,59[OOOQ-E6{-E6{OOOP1G.y1G.yOOOS-E6|-E6|OOOP1G.z1G.zOOOP1G.{1G.{O%`Q!bO,59WOOQO-E6w-E6wOOOP7+$[7+$[OOOP7+$d7+$dOOOP1G.v1G.vO%hO&jO'#CoO%yO,UO'#CoOOQO1G.r1G.rOOOO'#Cz'#CzO&[O&jO,59ZOOQO,59Z,59ZOOOO'#C{'#C{O&mO,UO,59ZOOOO-E6x-E6xOOQO1G.u1G.uOOOO-E6y-E6y",
  stateData: "'T~OyOS~OPQOSVOTWOVWOWWOXWOYWOjXO|PO!STO!UUO~OvZO{]O~O_^O~OPQOQaOSVOTWOVWOWWOXWOYWO|PO!STO!UUO~ORbO~P!XOtcO!ReO~OufO!ThO~O_iO~OvZO{lO~O]pOamOeqO~ORsO~P!XO_tO~OtcO!RvO~OufO!TxO~O]yO~ObzO]`Xa`Xe`X~O]|OamOe}O~O]!OO~O}!PO!P!QO~OW!SOX!SOY!SO}!UO!O!SO~OW!VOX!VOY!VO!P!UO!Q!VO~OW!SOX!SOY!SO}!YO!O!SO~OW!VOX!VOY!VO!P!YO!Q!VO~OXWYW~",
  goto: "#w{PPPPPPPPPPP||P!SP!YPP!^!aP!g|||P!m!s!y#P#V#]#c#iPPPPPPP#oXWORY`XRORY`Tn^oR!RzQbRRs`XSORY`QYORjYQ[PRk[Qo^R{oQ!T!PR!X!TQ!W!QR!Z!WQ`RRr`QdTRudQgURwgSXOYT_R`",
  nodeNames: "⚠ StartTag StartCloseTag MissingCloseTag StartCloseTag StartCloseTag Document Text EntityReference CharacterReference Ampersand Cdata Element EndTag OpenTag TagName Attribute AttributeName Is AttributeValue CloseTag SelfCloseEndTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag DoctypeDecl",
  maxTerm: 52,
  context: elementContext$1,
  nodeProps: [
    [
      "closedBy",
      1,
      "SelfCloseEndTag EndTag",
      14,
      "CloseTag MissingCloseTag"
    ],
    [
      "openedBy",
      13,
      "StartTag StartCloseTag",
      20,
      "OpenTag",
      21,
      "StartTag"
    ]
  ],
  skippedNodes: [0],
  repeatNodeCount: 8,
  tokenData: "!2c~R!YOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs2wsv$qvw3gwx7lx}$q}!O8_!O!P$q!P!Q:}!Q![$q![!]<q!]!^$q!^!_@X!_!`!,a!`!a!-X!a!b!.P!b!c$q!c!}<q!}#P$q#P#Q!/s#Q#R$q#R#S<q#S#T$q#T#o<q#o%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U$q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;'S<q;'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qi$zXVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qa%nVVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%gP&YUVPOv&Tw!^&T!^!_&l!_;'S&T;'S;=`'|<%lO&TP&oTXY'OYZ'O]^'Opq'O!_!`&TP'T]VPOX&TXY'OYZ'OZ]&T]^'O^p&Tpq'Oqv&Tw!^&T!^!_&l!_;'S&T;'S;=`'|<%lO&TP(PP;=`<%l&Ta(X]!Q`OX)QXY)iYZ)iZ])Q]^)i^p)Qpq)iqv)Qx!_)Q!_!`%g!`;'S)Q;'S;=`)c<%lO)Q`)VS!Q`Ov)Qx;'S)Q;'S;=`)c<%lO)Q`)fP;=`<%l)Qa)p^VP!Q`OX%gXY)iYZ)iZ]%g]^)i^p%gpq)iqv%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%ga*oP;=`<%l%gX*yWVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rX+h^!OWOX,dXY-OYZ-OZ],d]^-O^p,dpq-Oqr,dsv,dw!_,d!_!`*r!`;'S,d;'S;=`,x<%lO,dW,iT!OWOr,dsv,dw;'S,d;'S;=`,x<%lO,dW,{P;=`<%l,dX-V_VP!OWOX*rXY-OYZ-OZ]*r]^-O^p*rpq-Oqr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rX.XP;=`<%l*ri.c`!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0Xqr/ers)Qsv/ewx,dx!_/e!_!`$q!`;'S/e;'S;=`0R<%lO/eh/lV!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eh0UP;=`<%l/ei0b`VP!OW!Q`OX$qXY0XYZ0XZ]$q]^0X^p$qpq0Xqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qi1gP;=`<%l$qo1u`VP!OW!Q`yUOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk3QV}YVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%g~3laY~st4q![!]5u!c!}5u#R#S5u#T#o5u%W%o5u%p&a5u&b1p5u4U4d5u4e$IS5u$I`$Ib5u$Kh%#t5u&/x&Et5u&FV;'S5u;'S;:j7f?&r?Ah5u?BY?Mn5u~4tQ!Q![4z#l#m5Y~4}Q!Q![4z!]!^5T~5YOX~~5]R!Q![5f!c!i5f#T#Z5f~5iS!Q![5f!]!^5T!c!i5f#T#Z5f~5xg}!O5u!O!P5u!Q![5u![!]5u!]!^7a!c!}5u#R#S5u#T#o5u$}%O5u%W%o5u%p&a5u&b1p5u1p4U5u4U4d5u4e$IS5u$I`$Ib5u$Je$Jg5u$Kh%#t5u&/x&Et5u&FV;'S5u;'S;:j7f?&r?Ah5u?BY?Mn5u~7fOW~~7iP;=`<%l5uk7uW!PbVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rk8hZVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O9Z!O!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk9dZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a:V!a;'S$q;'S;=`1d<%lO$qk:bX!RQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qm;WZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a;y!a;'S$q;'S;=`1d<%lO$qm<UXeSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qo=O!PaS_QVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O<q!O!P<q!P!Q$q!Q![<q![!]<q!]!^$q!^!_.[!_!c$q!c!}<q!}#R$q#R#S<q#S#T$q#T#o<q#o$}$q$}%O<q%O%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U<q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Je$q$Je$Jg<q$Jg$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;'S<q;'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qo@UP;=`<%l<qi@`b!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0XqrAhrs)Qsv/ewx,dx!_/e!_!`$q!`!a/e!a!b!+q!b;'S/e;'S;=`0R<%lO/eiAo_!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OBn!O!f/e!f!gDQ!g!}/e!}#OMT#O#W/e#W#X!']#X;'S/e;'S;=`0R<%lO/eiBuX!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OCb!O;'S/e;'S;=`0R<%lO/eiCkV!SP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eiDXX!OW!Q`Or/ers)Qsv/ewx,dx!q/e!q!rDt!r;'S/e;'S;=`0R<%lO/eiD{X!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fEh!f;'S/e;'S;=`0R<%lO/eiEoX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!wF[!w;'S/e;'S;=`0R<%lO/eiFcX!OW!Q`Or/ers)Qsv/ewx,dx!{/e!{!|GO!|;'S/e;'S;=`0R<%lO/eiGVX!OW!Q`Or/ers)Qsv/ewx,dx!r/e!r!sGr!s;'S/e;'S;=`0R<%lO/eiGyX!OW!Q`Or/ers)Qsv/ewx,dx!g/e!g!hHf!h;'S/e;'S;=`0R<%lO/eiHmY!OW!Q`OrHfrsI]svHfvwIwwxKPx!`Hf!`!aL_!a;'SHf;'S;=`L}<%lOHfaIbV!Q`OvI]vxIwx!`I]!`!aJf!a;'SI];'S;=`Jy<%lOI]PIzTO!`Iw!`!aJZ!a;'SIw;'S;=`J`<%lOIwPJ`OjPPJcP;=`<%lIwaJmSjP!Q`Ov)Qx;'S)Q;'S;=`)c<%lO)QaJ|P;=`<%lI]XKUX!OWOrKPrsIwsvKPvwIww!`KP!`!aKq!a;'SKP;'S;=`LX<%lOKPXKxTjP!OWOr,dsv,dw;'S,d;'S;=`,x<%lO,dXL[P;=`<%lKPiLhVjP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eiMQP;=`<%lHfiM[Z!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fM}!f#V/e#V#W!$_#W;'S/e;'S;=`0R<%lO/eiNUX!OW!Q`Or/ers)Qsv/ewx,dx!f/e!f!gNq!g;'S/e;'S;=`0R<%lO/eiNxX!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d! e!d;'S/e;'S;=`0R<%lO/ei! lX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!w!!X!w;'S/e;'S;=`0R<%lO/ei!!`X!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d!!{!d;'S/e;'S;=`0R<%lO/ei!#SX!OW!Q`Or/ers)Qsv/ewx,dx!}/e!}#O!#o#O;'S/e;'S;=`0R<%lO/ei!#xV|P!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/ei!$fX!OW!Q`Or/ers)Qsv/ewx,dx#W/e#W#X!%R#X;'S/e;'S;=`0R<%lO/ei!%YX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!%u#U;'S/e;'S;=`0R<%lO/ei!%|X!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!&i#i;'S/e;'S;=`0R<%lO/ei!&pX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!!{#U;'S/e;'S;=`0R<%lO/ei!'dX!OW!Q`Or/ers)Qsv/ewx,dx#c/e#c#d!(P#d;'S/e;'S;=`0R<%lO/ei!(WX!OW!Q`Or/ers)Qsv/ewx,dx#V/e#V#W!(s#W;'S/e;'S;=`0R<%lO/ei!(zX!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!)g#i;'S/e;'S;=`0R<%lO/ei!)nX!OW!Q`Or/ers)Qsv/ewx,dx#m/e#m#n!*Z#n;'S/e;'S;=`0R<%lO/ei!*bX!OW!Q`Or/ers)Qsv/ewx,dx#d/e#d#e!*}#e;'S/e;'S;=`0R<%lO/ei!+UX!OW!Q`Or/ers)Qsv/ewx,dx#X/e#X#YHf#Y;'S/e;'S;=`0R<%lO/ei!+zV!UP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/em!,lXbSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qo!-dX]UVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk!.YZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!.{!a;'S$q;'S;=`1d<%lO$qk!/WX!TQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk!/|ZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_#P$q#P#Q!0o#Q;'S$q;'S;=`1d<%lO$qk!0xZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!1k!a;'S$q;'S;=`1d<%lO$qk!1vX{QVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$q",
  tokenizers: [
    startTag$1,
    commentContent$2,
    piContent$2,
    cdataContent$2,
    textLessThan$1,
    0,
    1,
    2,
    3,
    4
  ],
  topRules: { Document: [0, 6] },
  tokenPrec: 276
});
const _ENTITY_MAP = { "AEli": "Æ", "AElig": "Æ", "AM": "&", "AMP": "&", "Aacut": "Á", "Aacute": "Á", "Abreve": "Ă", "Acir": "Â", "Acirc": "Â", "Acy": "А", "Afr": "𝔄", "Agrav": "À", "Agrave": "À", "Alpha": "Α", "Amacr": "Ā", "And": "⩓", "Aogon": "Ą", "Aopf": "𝔸", "ApplyFunction": "⁡", "Arin": "Å", "Aring": "Å", "Ascr": "𝒜", "Assign": "≔", "Atild": "Ã", "Atilde": "Ã", "Aum": "Ä", "Auml": "Ä", "Backslash": "∖", "Barv": "⫧", "Barwed": "⌆", "Bcy": "Б", "Because": "∵", "Bernoullis": "ℬ", "Beta": "Β", "Bfr": "𝔅", "Bopf": "𝔹", "Breve": "˘", "Bscr": "ℬ", "Bumpeq": "≎", "CHcy": "Ч", "COP": "©", "COPY": "©", "Cacute": "Ć", "Cap": "⋒", "CapitalDifferentialD": "ⅅ", "Cayleys": "ℭ", "Ccaron": "Č", "Ccedi": "Ç", "Ccedil": "Ç", "Ccirc": "Ĉ", "Cconint": "∰", "Cdot": "Ċ", "Cedilla": "¸", "CenterDot": "·", "Cfr": "ℭ", "Chi": "Χ", "CircleDot": "⊙", "CircleMinus": "⊖", "CirclePlus": "⊕", "CircleTimes": "⊗", "ClockwiseContourIntegral": "∲", "CloseCurlyDoubleQuote": "”", "CloseCurlyQuote": "’", "Colon": "∷", "Colone": "⩴", "Congruent": "≡", "Conint": "∯", "ContourIntegral": "∮", "Copf": "ℂ", "Coproduct": "∐", "CounterClockwiseContourIntegral": "∳", "Cross": "⨯", "Cscr": "𝒞", "Cup": "⋓", "CupCap": "≍", "DD": "ⅅ", "DDotrahd": "⤑", "DJcy": "Ђ", "DScy": "Ѕ", "DZcy": "Џ", "Dagger": "‡", "Darr": "↡", "Dashv": "⫤", "Dcaron": "Ď", "Dcy": "Д", "Del": "∇", "Delta": "Δ", "Dfr": "𝔇", "DiacriticalAcute": "´", "DiacriticalDot": "˙", "DiacriticalDoubleAcute": "˝", "DiacriticalGrave": "`", "DiacriticalTilde": "˜", "Diamond": "⋄", "DifferentialD": "ⅆ", "Dopf": "𝔻", "Dot": "¨", "DotDot": "⃜", "DotEqual": "≐", "DoubleContourIntegral": "∯", "DoubleDot": "¨", "DoubleDownArrow": "⇓", "DoubleLeftArrow": "⇐", "DoubleLeftRightArrow": "⇔", "DoubleLeftTee": "⫤", "DoubleLongLeftArrow": "⟸", "DoubleLongLeftRightArrow": "⟺", "DoubleLongRightArrow": "⟹", "DoubleRightArrow": "⇒", "DoubleRightTee": "⊨", "DoubleUpArrow": "⇑", "DoubleUpDownArrow": "⇕", "DoubleVerticalBar": "∥", "DownArrow": "↓", "DownArrowBar": "⤓", "DownArrowUpArrow": "⇵", "DownBreve": "̑", "DownLeftRightVector": "⥐", "DownLeftTeeVector": "⥞", "DownLeftVector": "↽", "DownLeftVectorBar": "⥖", "DownRightTeeVector": "⥟", "DownRightVector": "⇁", "DownRightVectorBar": "⥗", "DownTee": "⊤", "DownTeeArrow": "↧", "Downarrow": "⇓", "Dscr": "𝒟", "Dstrok": "Đ", "ENG": "Ŋ", "ET": "Ð", "ETH": "Ð", "Eacut": "É", "Eacute": "É", "Ecaron": "Ě", "Ecir": "Ê", "Ecirc": "Ê", "Ecy": "Э", "Edot": "Ė", "Efr": "𝔈", "Egrav": "È", "Egrave": "È", "Element": "∈", "Emacr": "Ē", "EmptySmallSquare": "◻", "EmptyVerySmallSquare": "▫", "Eogon": "Ę", "Eopf": "𝔼", "Epsilon": "Ε", "Equal": "⩵", "EqualTilde": "≂", "Equilibrium": "⇌", "Escr": "ℰ", "Esim": "⩳", "Eta": "Η", "Eum": "Ë", "Euml": "Ë", "Exists": "∃", "ExponentialE": "ⅇ", "Fcy": "Ф", "Ffr": "𝔉", "FilledSmallSquare": "◼", "FilledVerySmallSquare": "▪", "Fopf": "𝔽", "ForAll": "∀", "Fouriertrf": "ℱ", "Fscr": "ℱ", "GJcy": "Ѓ", "G": ">", "GT": ">", "Gamma": "Γ", "Gammad": "Ϝ", "Gbreve": "Ğ", "Gcedil": "Ģ", "Gcirc": "Ĝ", "Gcy": "Г", "Gdot": "Ġ", "Gfr": "𝔊", "Gg": "⋙", "Gopf": "𝔾", "GreaterEqual": "≥", "GreaterEqualLess": "⋛", "GreaterFullEqual": "≧", "GreaterGreater": "⪢", "GreaterLess": "≷", "GreaterSlantEqual": "⩾", "GreaterTilde": "≳", "Gscr": "𝒢", "Gt": "≫", "HARDcy": "Ъ", "Hacek": "ˇ", "Hat": "^", "Hcirc": "Ĥ", "Hfr": "ℌ", "HilbertSpace": "ℋ", "Hopf": "ℍ", "HorizontalLine": "─", "Hscr": "ℋ", "Hstrok": "Ħ", "HumpDownHump": "≎", "HumpEqual": "≏", "IEcy": "Е", "IJlig": "Ĳ", "IOcy": "Ё", "Iacut": "Í", "Iacute": "Í", "Icir": "Î", "Icirc": "Î", "Icy": "И", "Idot": "İ", "Ifr": "ℑ", "Igrav": "Ì", "Igrave": "Ì", "Im": "ℑ", "Imacr": "Ī", "ImaginaryI": "ⅈ", "Implies": "⇒", "Int": "∬", "Integral": "∫", "Intersection": "⋂", "InvisibleComma": "⁣", "InvisibleTimes": "⁢", "Iogon": "Į", "Iopf": "𝕀", "Iota": "Ι", "Iscr": "ℐ", "Itilde": "Ĩ", "Iukcy": "І", "Ium": "Ï", "Iuml": "Ï", "Jcirc": "Ĵ", "Jcy": "Й", "Jfr": "𝔍", "Jopf": "𝕁", "Jscr": "𝒥", "Jsercy": "Ј", "Jukcy": "Є", "KHcy": "Х", "KJcy": "Ќ", "Kappa": "Κ", "Kcedil": "Ķ", "Kcy": "К", "Kfr": "𝔎", "Kopf": "𝕂", "Kscr": "𝒦", "LJcy": "Љ", "L": "<", "LT": "<", "Lacute": "Ĺ", "Lambda": "Λ", "Lang": "⟪", "Laplacetrf": "ℒ", "Larr": "↞", "Lcaron": "Ľ", "Lcedil": "Ļ", "Lcy": "Л", "LeftAngleBracket": "⟨", "LeftArrow": "←", "LeftArrowBar": "⇤", "LeftArrowRightArrow": "⇆", "LeftCeiling": "⌈", "LeftDoubleBracket": "⟦", "LeftDownTeeVector": "⥡", "LeftDownVector": "⇃", "LeftDownVectorBar": "⥙", "LeftFloor": "⌊", "LeftRightArrow": "↔", "LeftRightVector": "⥎", "LeftTee": "⊣", "LeftTeeArrow": "↤", "LeftTeeVector": "⥚", "LeftTriangle": "⊲", "LeftTriangleBar": "⧏", "LeftTriangleEqual": "⊴", "LeftUpDownVector": "⥑", "LeftUpTeeVector": "⥠", "LeftUpVector": "↿", "LeftUpVectorBar": "⥘", "LeftVector": "↼", "LeftVectorBar": "⥒", "Leftarrow": "⇐", "Leftrightarrow": "⇔", "LessEqualGreater": "⋚", "LessFullEqual": "≦", "LessGreater": "≶", "LessLess": "⪡", "LessSlantEqual": "⩽", "LessTilde": "≲", "Lfr": "𝔏", "Ll": "⋘", "Lleftarrow": "⇚", "Lmidot": "Ŀ", "LongLeftArrow": "⟵", "LongLeftRightArrow": "⟷", "LongRightArrow": "⟶", "Longleftarrow": "⟸", "Longleftrightarrow": "⟺", "Longrightarrow": "⟹", "Lopf": "𝕃", "LowerLeftArrow": "↙", "LowerRightArrow": "↘", "Lscr": "ℒ", "Lsh": "↰", "Lstrok": "Ł", "Lt": "≪", "Map": "⤅", "Mcy": "М", "MediumSpace": " ", "Mellintrf": "ℳ", "Mfr": "𝔐", "MinusPlus": "∓", "Mopf": "𝕄", "Mscr": "ℳ", "Mu": "Μ", "NJcy": "Њ", "Nacute": "Ń", "Ncaron": "Ň", "Ncedil": "Ņ", "Ncy": "Н", "NegativeMediumSpace": "​", "NegativeThickSpace": "​", "NegativeThinSpace": "​", "NegativeVeryThinSpace": "​", "NestedGreaterGreater": "≫", "NestedLessLess": "≪", "NewLine": "\n", "Nfr": "𝔑", "NoBreak": "⁠", "NonBreakingSpace": " ", "Nopf": "ℕ", "Not": "⫬", "NotCongruent": "≢", "NotCupCap": "≭", "NotDoubleVerticalBar": "∦", "NotElement": "∉", "NotEqual": "≠", "NotEqualTilde": "≂̸", "NotExists": "∄", "NotGreater": "≯", "NotGreaterEqual": "≱", "NotGreaterFullEqual": "≧̸", "NotGreaterGreater": "≫̸", "NotGreaterLess": "≹", "NotGreaterSlantEqual": "⩾̸", "NotGreaterTilde": "≵", "NotHumpDownHump": "≎̸", "NotHumpEqual": "≏̸", "NotLeftTriangle": "⋪", "NotLeftTriangleBar": "⧏̸", "NotLeftTriangleEqual": "⋬", "NotLess": "≮", "NotLessEqual": "≰", "NotLessGreater": "≸", "NotLessLess": "≪̸", "NotLessSlantEqual": "⩽̸", "NotLessTilde": "≴", "NotNestedGreaterGreater": "⪢̸", "NotNestedLessLess": "⪡̸", "NotPrecedes": "⊀", "NotPrecedesEqual": "⪯̸", "NotPrecedesSlantEqual": "⋠", "NotReverseElement": "∌", "NotRightTriangle": "⋫", "NotRightTriangleBar": "⧐̸", "NotRightTriangleEqual": "⋭", "NotSquareSubset": "⊏̸", "NotSquareSubsetEqual": "⋢", "NotSquareSuperset": "⊐̸", "NotSquareSupersetEqual": "⋣", "NotSubset": "⊂⃒", "NotSubsetEqual": "⊈", "NotSucceeds": "⊁", "NotSucceedsEqual": "⪰̸", "NotSucceedsSlantEqual": "⋡", "NotSucceedsTilde": "≿̸", "NotSuperset": "⊃⃒", "NotSupersetEqual": "⊉", "NotTilde": "≁", "NotTildeEqual": "≄", "NotTildeFullEqual": "≇", "NotTildeTilde": "≉", "NotVerticalBar": "∤", "Nscr": "𝒩", "Ntild": "Ñ", "Ntilde": "Ñ", "Nu": "Ν", "OElig": "Œ", "Oacut": "Ó", "Oacute": "Ó", "Ocir": "Ô", "Ocirc": "Ô", "Ocy": "О", "Odblac": "Ő", "Ofr": "𝔒", "Ograv": "Ò", "Ograve": "Ò", "Omacr": "Ō", "Omega": "Ω", "Omicron": "Ο", "Oopf": "𝕆", "OpenCurlyDoubleQuote": "“", "OpenCurlyQuote": "‘", "Or": "⩔", "Oscr": "𝒪", "Oslas": "Ø", "Oslash": "Ø", "Otild": "Õ", "Otilde": "Õ", "Otimes": "⨷", "Oum": "Ö", "Ouml": "Ö", "OverBar": "‾", "OverBrace": "⏞", "OverBracket": "⎴", "OverParenthesis": "⏜", "PartialD": "∂", "Pcy": "П", "Pfr": "𝔓", "Phi": "Φ", "Pi": "Π", "PlusMinus": "±", "Poincareplane": "ℌ", "Popf": "ℙ", "Pr": "⪻", "Precedes": "≺", "PrecedesEqual": "⪯", "PrecedesSlantEqual": "≼", "PrecedesTilde": "≾", "Prime": "″", "Product": "∏", "Proportion": "∷", "Proportional": "∝", "Pscr": "𝒫", "Psi": "Ψ", "QUO": '"', "QUOT": '"', "Qfr": "𝔔", "Qopf": "ℚ", "Qscr": "𝒬", "RBarr": "⤐", "RE": "®", "REG": "®", "Racute": "Ŕ", "Rang": "⟫", "Rarr": "↠", "Rarrtl": "⤖", "Rcaron": "Ř", "Rcedil": "Ŗ", "Rcy": "Р", "Re": "ℜ", "ReverseElement": "∋", "ReverseEquilibrium": "⇋", "ReverseUpEquilibrium": "⥯", "Rfr": "ℜ", "Rho": "Ρ", "RightAngleBracket": "⟩", "RightArrow": "→", "RightArrowBar": "⇥", "RightArrowLeftArrow": "⇄", "RightCeiling": "⌉", "RightDoubleBracket": "⟧", "RightDownTeeVector": "⥝", "RightDownVector": "⇂", "RightDownVectorBar": "⥕", "RightFloor": "⌋", "RightTee": "⊢", "RightTeeArrow": "↦", "RightTeeVector": "⥛", "RightTriangle": "⊳", "RightTriangleBar": "⧐", "RightTriangleEqual": "⊵", "RightUpDownVector": "⥏", "RightUpTeeVector": "⥜", "RightUpVector": "↾", "RightUpVectorBar": "⥔", "RightVector": "⇀", "RightVectorBar": "⥓", "Rightarrow": "⇒", "Ropf": "ℝ", "RoundImplies": "⥰", "Rrightarrow": "⇛", "Rscr": "ℛ", "Rsh": "↱", "RuleDelayed": "⧴", "SHCHcy": "Щ", "SHcy": "Ш", "SOFTcy": "Ь", "Sacute": "Ś", "Sc": "⪼", "Scaron": "Š", "Scedil": "Ş", "Scirc": "Ŝ", "Scy": "С", "Sfr": "𝔖", "ShortDownArrow": "↓", "ShortLeftArrow": "←", "ShortRightArrow": "→", "ShortUpArrow": "↑", "Sigma": "Σ", "SmallCircle": "∘", "Sopf": "𝕊", "Sqrt": "√", "Square": "□", "SquareIntersection": "⊓", "SquareSubset": "⊏", "SquareSubsetEqual": "⊑", "SquareSuperset": "⊐", "SquareSupersetEqual": "⊒", "SquareUnion": "⊔", "Sscr": "𝒮", "Star": "⋆", "Sub": "⋐", "Subset": "⋐", "SubsetEqual": "⊆", "Succeeds": "≻", "SucceedsEqual": "⪰", "SucceedsSlantEqual": "≽", "SucceedsTilde": "≿", "SuchThat": "∋", "Sum": "∑", "Sup": "⋑", "Superset": "⊃", "SupersetEqual": "⊇", "Supset": "⋑", "THOR": "Þ", "THORN": "Þ", "TRADE": "™", "TSHcy": "Ћ", "TScy": "Ц", "Tab": "	", "Tau": "Τ", "Tcaron": "Ť", "Tcedil": "Ţ", "Tcy": "Т", "Tfr": "𝔗", "Therefore": "∴", "Theta": "Θ", "ThickSpace": "  ", "ThinSpace": " ", "Tilde": "∼", "TildeEqual": "≃", "TildeFullEqual": "≅", "TildeTilde": "≈", "Topf": "𝕋", "TripleDot": "⃛", "Tscr": "𝒯", "Tstrok": "Ŧ", "Uacut": "Ú", "Uacute": "Ú", "Uarr": "↟", "Uarrocir": "⥉", "Ubrcy": "Ў", "Ubreve": "Ŭ", "Ucir": "Û", "Ucirc": "Û", "Ucy": "У", "Udblac": "Ű", "Ufr": "𝔘", "Ugrav": "Ù", "Ugrave": "Ù", "Umacr": "Ū", "UnderBar": "_", "UnderBrace": "⏟", "UnderBracket": "⎵", "UnderParenthesis": "⏝", "Union": "⋃", "UnionPlus": "⊎", "Uogon": "Ų", "Uopf": "𝕌", "UpArrow": "↑", "UpArrowBar": "⤒", "UpArrowDownArrow": "⇅", "UpDownArrow": "↕", "UpEquilibrium": "⥮", "UpTee": "⊥", "UpTeeArrow": "↥", "Uparrow": "⇑", "Updownarrow": "⇕", "UpperLeftArrow": "↖", "UpperRightArrow": "↗", "Upsi": "ϒ", "Upsilon": "Υ", "Uring": "Ů", "Uscr": "𝒰", "Utilde": "Ũ", "Uum": "Ü", "Uuml": "Ü", "VDash": "⊫", "Vbar": "⫫", "Vcy": "В", "Vdash": "⊩", "Vdashl": "⫦", "Vee": "⋁", "Verbar": "‖", "Vert": "‖", "VerticalBar": "∣", "VerticalLine": "|", "VerticalSeparator": "❘", "VerticalTilde": "≀", "VeryThinSpace": " ", "Vfr": "𝔙", "Vopf": "𝕍", "Vscr": "𝒱", "Vvdash": "⊪", "Wcirc": "Ŵ", "Wedge": "⋀", "Wfr": "𝔚", "Wopf": "𝕎", "Wscr": "𝒲", "Xfr": "𝔛", "Xi": "Ξ", "Xopf": "𝕏", "Xscr": "𝒳", "YAcy": "Я", "YIcy": "Ї", "YUcy": "Ю", "Yacut": "Ý", "Yacute": "Ý", "Ycirc": "Ŷ", "Ycy": "Ы", "Yfr": "𝔜", "Yopf": "𝕐", "Yscr": "𝒴", "Yuml": "Ÿ", "ZHcy": "Ж", "Zacute": "Ź", "Zcaron": "Ž", "Zcy": "З", "Zdot": "Ż", "ZeroWidthSpace": "​", "Zeta": "Ζ", "Zfr": "ℨ", "Zopf": "ℤ", "Zscr": "𝒵", "aacut": "á", "aacute": "á", "abreve": "ă", "ac": "∾", "acE": "∾̳", "acd": "∿", "acir": "â", "acirc": "â", "acut": "´", "acute": "´", "acy": "а", "aeli": "æ", "aelig": "æ", "af": "⁡", "afr": "𝔞", "agrav": "à", "agrave": "à", "alefsym": "ℵ", "aleph": "ℵ", "alpha": "α", "amacr": "ā", "amalg": "⨿", "am": "&", "amp": "&", "and": "∧", "andand": "⩕", "andd": "⩜", "andslope": "⩘", "andv": "⩚", "ang": "∠", "ange": "⦤", "angle": "∠", "angmsd": "∡", "angmsdaa": "⦨", "angmsdab": "⦩", "angmsdac": "⦪", "angmsdad": "⦫", "angmsdae": "⦬", "angmsdaf": "⦭", "angmsdag": "⦮", "angmsdah": "⦯", "angrt": "∟", "angrtvb": "⊾", "angrtvbd": "⦝", "angsph": "∢", "angst": "Å", "angzarr": "⍼", "aogon": "ą", "aopf": "𝕒", "ap": "≈", "apE": "⩰", "apacir": "⩯", "ape": "≊", "apid": "≋", "apos": "'", "approx": "≈", "approxeq": "≊", "arin": "å", "aring": "å", "ascr": "𝒶", "ast": "*", "asymp": "≈", "asympeq": "≍", "atild": "ã", "atilde": "ã", "aum": "ä", "auml": "ä", "awconint": "∳", "awint": "⨑", "bNot": "⫭", "backcong": "≌", "backepsilon": "϶", "backprime": "‵", "backsim": "∽", "backsimeq": "⋍", "barvee": "⊽", "barwed": "⌅", "barwedge": "⌅", "bbrk": "⎵", "bbrktbrk": "⎶", "bcong": "≌", "bcy": "б", "bdquo": "„", "becaus": "∵", "because": "∵", "bemptyv": "⦰", "bepsi": "϶", "bernou": "ℬ", "beta": "β", "beth": "ℶ", "between": "≬", "bfr": "𝔟", "bigcap": "⋂", "bigcirc": "◯", "bigcup": "⋃", "bigodot": "⨀", "bigoplus": "⨁", "bigotimes": "⨂", "bigsqcup": "⨆", "bigstar": "★", "bigtriangledown": "▽", "bigtriangleup": "△", "biguplus": "⨄", "bigvee": "⋁", "bigwedge": "⋀", "bkarow": "⤍", "blacklozenge": "⧫", "blacksquare": "▪", "blacktriangle": "▴", "blacktriangledown": "▾", "blacktriangleleft": "◂", "blacktriangleright": "▸", "blank": "␣", "blk12": "▒", "blk14": "░", "blk34": "▓", "block": "█", "bne": "=⃥", "bnequiv": "≡⃥", "bnot": "⌐", "bopf": "𝕓", "bot": "⊥", "bottom": "⊥", "bowtie": "⋈", "boxDL": "╗", "boxDR": "╔", "boxDl": "╖", "boxDr": "╓", "boxH": "═", "boxHD": "╦", "boxHU": "╩", "boxHd": "╤", "boxHu": "╧", "boxUL": "╝", "boxUR": "╚", "boxUl": "╜", "boxUr": "╙", "boxV": "║", "boxVH": "╬", "boxVL": "╣", "boxVR": "╠", "boxVh": "╫", "boxVl": "╢", "boxVr": "╟", "boxbox": "⧉", "boxdL": "╕", "boxdR": "╒", "boxdl": "┐", "boxdr": "┌", "boxh": "─", "boxhD": "╥", "boxhU": "╨", "boxhd": "┬", "boxhu": "┴", "boxminus": "⊟", "boxplus": "⊞", "boxtimes": "⊠", "boxuL": "╛", "boxuR": "╘", "boxul": "┘", "boxur": "└", "boxv": "│", "boxvH": "╪", "boxvL": "╡", "boxvR": "╞", "boxvh": "┼", "boxvl": "┤", "boxvr": "├", "bprime": "‵", "breve": "˘", "brvba": "¦", "brvbar": "¦", "bscr": "𝒷", "bsemi": "⁏", "bsim": "∽", "bsime": "⋍", "bsol": "\\", "bsolb": "⧅", "bsolhsub": "⟈", "bull": "•", "bullet": "•", "bump": "≎", "bumpE": "⪮", "bumpe": "≏", "bumpeq": "≏", "cacute": "ć", "cap": "∩", "capand": "⩄", "capbrcup": "⩉", "capcap": "⩋", "capcup": "⩇", "capdot": "⩀", "caps": "∩︀", "caret": "⁁", "caron": "ˇ", "ccaps": "⩍", "ccaron": "č", "ccedi": "ç", "ccedil": "ç", "ccirc": "ĉ", "ccups": "⩌", "ccupssm": "⩐", "cdot": "ċ", "cedi": "¸", "cedil": "¸", "cemptyv": "⦲", "cen": "¢", "cent": "¢", "centerdot": "·", "cfr": "𝔠", "chcy": "ч", "check": "✓", "checkmark": "✓", "chi": "χ", "cir": "○", "cirE": "⧃", "circ": "ˆ", "circeq": "≗", "circlearrowleft": "↺", "circlearrowright": "↻", "circledR": "®", "circledS": "Ⓢ", "circledast": "⊛", "circledcirc": "⊚", "circleddash": "⊝", "cire": "≗", "cirfnint": "⨐", "cirmid": "⫯", "cirscir": "⧂", "clubs": "♣", "clubsuit": "♣", "colon": ":", "colone": "≔", "coloneq": "≔", "comma": ",", "commat": "@", "comp": "∁", "compfn": "∘", "complement": "∁", "complexes": "ℂ", "cong": "≅", "congdot": "⩭", "conint": "∮", "copf": "𝕔", "coprod": "∐", "cop": "©", "copy": "©", "copysr": "℗", "crarr": "↵", "cross": "✗", "cscr": "𝒸", "csub": "⫏", "csube": "⫑", "csup": "⫐", "csupe": "⫒", "ctdot": "⋯", "cudarrl": "⤸", "cudarrr": "⤵", "cuepr": "⋞", "cuesc": "⋟", "cularr": "↶", "cularrp": "⤽", "cup": "∪", "cupbrcap": "⩈", "cupcap": "⩆", "cupcup": "⩊", "cupdot": "⊍", "cupor": "⩅", "cups": "∪︀", "curarr": "↷", "curarrm": "⤼", "curlyeqprec": "⋞", "curlyeqsucc": "⋟", "curlyvee": "⋎", "curlywedge": "⋏", "curre": "¤", "curren": "¤", "curvearrowleft": "↶", "curvearrowright": "↷", "cuvee": "⋎", "cuwed": "⋏", "cwconint": "∲", "cwint": "∱", "cylcty": "⌭", "dArr": "⇓", "dHar": "⥥", "dagger": "†", "daleth": "ℸ", "darr": "↓", "dash": "‐", "dashv": "⊣", "dbkarow": "⤏", "dblac": "˝", "dcaron": "ď", "dcy": "д", "dd": "ⅆ", "ddagger": "‡", "ddarr": "⇊", "ddotseq": "⩷", "de": "°", "deg": "°", "delta": "δ", "demptyv": "⦱", "dfisht": "⥿", "dfr": "𝔡", "dharl": "⇃", "dharr": "⇂", "diam": "⋄", "diamond": "⋄", "diamondsuit": "♦", "diams": "♦", "die": "¨", "digamma": "ϝ", "disin": "⋲", "div": "÷", "divid": "÷", "divide": "÷", "divideontimes": "⋇", "divonx": "⋇", "djcy": "ђ", "dlcorn": "⌞", "dlcrop": "⌍", "dollar": "$", "dopf": "𝕕", "dot": "˙", "doteq": "≐", "doteqdot": "≑", "dotminus": "∸", "dotplus": "∔", "dotsquare": "⊡", "doublebarwedge": "⌆", "downarrow": "↓", "downdownarrows": "⇊", "downharpoonleft": "⇃", "downharpoonright": "⇂", "drbkarow": "⤐", "drcorn": "⌟", "drcrop": "⌌", "dscr": "𝒹", "dscy": "ѕ", "dsol": "⧶", "dstrok": "đ", "dtdot": "⋱", "dtri": "▿", "dtrif": "▾", "duarr": "⇵", "duhar": "⥯", "dwangle": "⦦", "dzcy": "џ", "dzigrarr": "⟿", "eDDot": "⩷", "eDot": "≑", "eacut": "é", "eacute": "é", "easter": "⩮", "ecaron": "ě", "ecir": "ê", "ecirc": "ê", "ecolon": "≕", "ecy": "э", "edot": "ė", "ee": "ⅇ", "efDot": "≒", "efr": "𝔢", "eg": "⪚", "egrav": "è", "egrave": "è", "egs": "⪖", "egsdot": "⪘", "el": "⪙", "elinters": "⏧", "ell": "ℓ", "els": "⪕", "elsdot": "⪗", "emacr": "ē", "empty": "∅", "emptyset": "∅", "emptyv": "∅", "emsp13": " ", "emsp14": " ", "emsp": " ", "eng": "ŋ", "ensp": " ", "eogon": "ę", "eopf": "𝕖", "epar": "⋕", "eparsl": "⧣", "eplus": "⩱", "epsi": "ε", "epsilon": "ε", "epsiv": "ϵ", "eqcirc": "≖", "eqcolon": "≕", "eqsim": "≂", "eqslantgtr": "⪖", "eqslantless": "⪕", "equals": "=", "equest": "≟", "equiv": "≡", "equivDD": "⩸", "eqvparsl": "⧥", "erDot": "≓", "erarr": "⥱", "escr": "ℯ", "esdot": "≐", "esim": "≂", "eta": "η", "et": "ð", "eth": "ð", "eum": "ë", "euml": "ë", "euro": "€", "excl": "!", "exist": "∃", "expectation": "ℰ", "exponentiale": "ⅇ", "fallingdotseq": "≒", "fcy": "ф", "female": "♀", "ffilig": "ﬃ", "fflig": "ﬀ", "ffllig": "ﬄ", "ffr": "𝔣", "filig": "ﬁ", "fjlig": "fj", "flat": "♭", "fllig": "ﬂ", "fltns": "▱", "fnof": "ƒ", "fopf": "𝕗", "forall": "∀", "fork": "⋔", "forkv": "⫙", "fpartint": "⨍", "frac1": "¼", "frac12": "½", "frac13": "⅓", "frac14": "¼", "frac15": "⅕", "frac16": "⅙", "frac18": "⅛", "frac23": "⅔", "frac25": "⅖", "frac3": "¾", "frac34": "¾", "frac35": "⅗", "frac38": "⅜", "frac45": "⅘", "frac56": "⅚", "frac58": "⅝", "frac78": "⅞", "frasl": "⁄", "frown": "⌢", "fscr": "𝒻", "gE": "≧", "gEl": "⪌", "gacute": "ǵ", "gamma": "γ", "gammad": "ϝ", "gap": "⪆", "gbreve": "ğ", "gcirc": "ĝ", "gcy": "г", "gdot": "ġ", "ge": "≥", "gel": "⋛", "geq": "≥", "geqq": "≧", "geqslant": "⩾", "ges": "⩾", "gescc": "⪩", "gesdot": "⪀", "gesdoto": "⪂", "gesdotol": "⪄", "gesl": "⋛︀", "gesles": "⪔", "gfr": "𝔤", "gg": "≫", "ggg": "⋙", "gimel": "ℷ", "gjcy": "ѓ", "gl": "≷", "glE": "⪒", "gla": "⪥", "glj": "⪤", "gnE": "≩", "gnap": "⪊", "gnapprox": "⪊", "gne": "⪈", "gneq": "⪈", "gneqq": "≩", "gnsim": "⋧", "gopf": "𝕘", "grave": "`", "gscr": "ℊ", "gsim": "≳", "gsime": "⪎", "gsiml": "⪐", "g": ">", "gt": ">", "gtcc": "⪧", "gtcir": "⩺", "gtdot": "⋗", "gtlPar": "⦕", "gtquest": "⩼", "gtrapprox": "⪆", "gtrarr": "⥸", "gtrdot": "⋗", "gtreqless": "⋛", "gtreqqless": "⪌", "gtrless": "≷", "gtrsim": "≳", "gvertneqq": "≩︀", "gvnE": "≩︀", "hArr": "⇔", "hairsp": " ", "half": "½", "hamilt": "ℋ", "hardcy": "ъ", "harr": "↔", "harrcir": "⥈", "harrw": "↭", "hbar": "ℏ", "hcirc": "ĥ", "hearts": "♥", "heartsuit": "♥", "hellip": "…", "hercon": "⊹", "hfr": "𝔥", "hksearow": "⤥", "hkswarow": "⤦", "hoarr": "⇿", "homtht": "∻", "hookleftarrow": "↩", "hookrightarrow": "↪", "hopf": "𝕙", "horbar": "―", "hscr": "𝒽", "hslash": "ℏ", "hstrok": "ħ", "hybull": "⁃", "hyphen": "‐", "iacut": "í", "iacute": "í", "ic": "⁣", "icir": "î", "icirc": "î", "icy": "и", "iecy": "е", "iexc": "¡", "iexcl": "¡", "iff": "⇔", "ifr": "𝔦", "igrav": "ì", "igrave": "ì", "ii": "ⅈ", "iiiint": "⨌", "iiint": "∭", "iinfin": "⧜", "iiota": "℩", "ijlig": "ĳ", "imacr": "ī", "image": "ℑ", "imagline": "ℐ", "imagpart": "ℑ", "imath": "ı", "imof": "⊷", "imped": "Ƶ", "in": "∈", "incare": "℅", "infin": "∞", "infintie": "⧝", "inodot": "ı", "int": "∫", "intcal": "⊺", "integers": "ℤ", "intercal": "⊺", "intlarhk": "⨗", "intprod": "⨼", "iocy": "ё", "iogon": "į", "iopf": "𝕚", "iota": "ι", "iprod": "⨼", "iques": "¿", "iquest": "¿", "iscr": "𝒾", "isin": "∈", "isinE": "⋹", "isindot": "⋵", "isins": "⋴", "isinsv": "⋳", "isinv": "∈", "it": "⁢", "itilde": "ĩ", "iukcy": "і", "ium": "ï", "iuml": "ï", "jcirc": "ĵ", "jcy": "й", "jfr": "𝔧", "jmath": "ȷ", "jopf": "𝕛", "jscr": "𝒿", "jsercy": "ј", "jukcy": "є", "kappa": "κ", "kappav": "ϰ", "kcedil": "ķ", "kcy": "к", "kfr": "𝔨", "kgreen": "ĸ", "khcy": "х", "kjcy": "ќ", "kopf": "𝕜", "kscr": "𝓀", "lAarr": "⇚", "lArr": "⇐", "lAtail": "⤛", "lBarr": "⤎", "lE": "≦", "lEg": "⪋", "lHar": "⥢", "lacute": "ĺ", "laemptyv": "⦴", "lagran": "ℒ", "lambda": "λ", "lang": "⟨", "langd": "⦑", "langle": "⟨", "lap": "⪅", "laqu": "«", "laquo": "«", "larr": "←", "larrb": "⇤", "larrbfs": "⤟", "larrfs": "⤝", "larrhk": "↩", "larrlp": "↫", "larrpl": "⤹", "larrsim": "⥳", "larrtl": "↢", "lat": "⪫", "latail": "⤙", "late": "⪭", "lates": "⪭︀", "lbarr": "⤌", "lbbrk": "❲", "lbrace": "{", "lbrack": "[", "lbrke": "⦋", "lbrksld": "⦏", "lbrkslu": "⦍", "lcaron": "ľ", "lcedil": "ļ", "lceil": "⌈", "lcub": "{", "lcy": "л", "ldca": "⤶", "ldquo": "“", "ldquor": "„", "ldrdhar": "⥧", "ldrushar": "⥋", "ldsh": "↲", "le": "≤", "leftarrow": "←", "leftarrowtail": "↢", "leftharpoondown": "↽", "leftharpoonup": "↼", "leftleftarrows": "⇇", "leftrightarrow": "↔", "leftrightarrows": "⇆", "leftrightharpoons": "⇋", "leftrightsquigarrow": "↭", "leftthreetimes": "⋋", "leg": "⋚", "leq": "≤", "leqq": "≦", "leqslant": "⩽", "les": "⩽", "lescc": "⪨", "lesdot": "⩿", "lesdoto": "⪁", "lesdotor": "⪃", "lesg": "⋚︀", "lesges": "⪓", "lessapprox": "⪅", "lessdot": "⋖", "lesseqgtr": "⋚", "lesseqqgtr": "⪋", "lessgtr": "≶", "lesssim": "≲", "lfisht": "⥼", "lfloor": "⌊", "lfr": "𝔩", "lg": "≶", "lgE": "⪑", "lhard": "↽", "lharu": "↼", "lharul": "⥪", "lhblk": "▄", "ljcy": "љ", "ll": "≪", "llarr": "⇇", "llcorner": "⌞", "llhard": "⥫", "lltri": "◺", "lmidot": "ŀ", "lmoust": "⎰", "lmoustache": "⎰", "lnE": "≨", "lnap": "⪉", "lnapprox": "⪉", "lne": "⪇", "lneq": "⪇", "lneqq": "≨", "lnsim": "⋦", "loang": "⟬", "loarr": "⇽", "lobrk": "⟦", "longleftarrow": "⟵", "longleftrightarrow": "⟷", "longmapsto": "⟼", "longrightarrow": "⟶", "looparrowleft": "↫", "looparrowright": "↬", "lopar": "⦅", "lopf": "𝕝", "loplus": "⨭", "lotimes": "⨴", "lowast": "∗", "lowbar": "_", "loz": "◊", "lozenge": "◊", "lozf": "⧫", "lpar": "(", "lparlt": "⦓", "lrarr": "⇆", "lrcorner": "⌟", "lrhar": "⇋", "lrhard": "⥭", "lrm": "‎", "lrtri": "⊿", "lsaquo": "‹", "lscr": "𝓁", "lsh": "↰", "lsim": "≲", "lsime": "⪍", "lsimg": "⪏", "lsqb": "[", "lsquo": "‘", "lsquor": "‚", "lstrok": "ł", "l": "<", "lt": "<", "ltcc": "⪦", "ltcir": "⩹", "ltdot": "⋖", "lthree": "⋋", "ltimes": "⋉", "ltlarr": "⥶", "ltquest": "⩻", "ltrPar": "⦖", "ltri": "◃", "ltrie": "⊴", "ltrif": "◂", "lurdshar": "⥊", "luruhar": "⥦", "lvertneqq": "≨︀", "lvnE": "≨︀", "mDDot": "∺", "mac": "¯", "macr": "¯", "male": "♂", "malt": "✠", "maltese": "✠", "map": "↦", "mapsto": "↦", "mapstodown": "↧", "mapstoleft": "↤", "mapstoup": "↥", "marker": "▮", "mcomma": "⨩", "mcy": "м", "mdash": "—", "measuredangle": "∡", "mfr": "𝔪", "mho": "℧", "micr": "µ", "micro": "µ", "mid": "∣", "midast": "*", "midcir": "⫰", "middo": "·", "middot": "·", "minus": "−", "minusb": "⊟", "minusd": "∸", "minusdu": "⨪", "mlcp": "⫛", "mldr": "…", "mnplus": "∓", "models": "⊧", "mopf": "𝕞", "mp": "∓", "mscr": "𝓂", "mstpos": "∾", "mu": "μ", "multimap": "⊸", "mumap": "⊸", "nGg": "⋙̸", "nGt": "≫⃒", "nGtv": "≫̸", "nLeftarrow": "⇍", "nLeftrightarrow": "⇎", "nLl": "⋘̸", "nLt": "≪⃒", "nLtv": "≪̸", "nRightarrow": "⇏", "nVDash": "⊯", "nVdash": "⊮", "nabla": "∇", "nacute": "ń", "nang": "∠⃒", "nap": "≉", "napE": "⩰̸", "napid": "≋̸", "napos": "ŉ", "napprox": "≉", "natur": "♮", "natural": "♮", "naturals": "ℕ", "nbs": " ", "nbsp": " ", "nbump": "≎̸", "nbumpe": "≏̸", "ncap": "⩃", "ncaron": "ň", "ncedil": "ņ", "ncong": "≇", "ncongdot": "⩭̸", "ncup": "⩂", "ncy": "н", "ndash": "–", "ne": "≠", "neArr": "⇗", "nearhk": "⤤", "nearr": "↗", "nearrow": "↗", "nedot": "≐̸", "nequiv": "≢", "nesear": "⤨", "nesim": "≂̸", "nexist": "∄", "nexists": "∄", "nfr": "𝔫", "ngE": "≧̸", "nge": "≱", "ngeq": "≱", "ngeqq": "≧̸", "ngeqslant": "⩾̸", "nges": "⩾̸", "ngsim": "≵", "ngt": "≯", "ngtr": "≯", "nhArr": "⇎", "nharr": "↮", "nhpar": "⫲", "ni": "∋", "nis": "⋼", "nisd": "⋺", "niv": "∋", "njcy": "њ", "nlArr": "⇍", "nlE": "≦̸", "nlarr": "↚", "nldr": "‥", "nle": "≰", "nleftarrow": "↚", "nleftrightarrow": "↮", "nleq": "≰", "nleqq": "≦̸", "nleqslant": "⩽̸", "nles": "⩽̸", "nless": "≮", "nlsim": "≴", "nlt": "≮", "nltri": "⋪", "nltrie": "⋬", "nmid": "∤", "nopf": "𝕟", "no": "¬", "not": "¬", "notin": "∉", "notinE": "⋹̸", "notindot": "⋵̸", "notinva": "∉", "notinvb": "⋷", "notinvc": "⋶", "notni": "∌", "notniva": "∌", "notnivb": "⋾", "notnivc": "⋽", "npar": "∦", "nparallel": "∦", "nparsl": "⫽⃥", "npart": "∂̸", "npolint": "⨔", "npr": "⊀", "nprcue": "⋠", "npre": "⪯̸", "nprec": "⊀", "npreceq": "⪯̸", "nrArr": "⇏", "nrarr": "↛", "nrarrc": "⤳̸", "nrarrw": "↝̸", "nrightarrow": "↛", "nrtri": "⋫", "nrtrie": "⋭", "nsc": "⊁", "nsccue": "⋡", "nsce": "⪰̸", "nscr": "𝓃", "nshortmid": "∤", "nshortparallel": "∦", "nsim": "≁", "nsime": "≄", "nsimeq": "≄", "nsmid": "∤", "nspar": "∦", "nsqsube": "⋢", "nsqsupe": "⋣", "nsub": "⊄", "nsubE": "⫅̸", "nsube": "⊈", "nsubset": "⊂⃒", "nsubseteq": "⊈", "nsubseteqq": "⫅̸", "nsucc": "⊁", "nsucceq": "⪰̸", "nsup": "⊅", "nsupE": "⫆̸", "nsupe": "⊉", "nsupset": "⊃⃒", "nsupseteq": "⊉", "nsupseteqq": "⫆̸", "ntgl": "≹", "ntild": "ñ", "ntilde": "ñ", "ntlg": "≸", "ntriangleleft": "⋪", "ntrianglelefteq": "⋬", "ntriangleright": "⋫", "ntrianglerighteq": "⋭", "nu": "ν", "num": "#", "numero": "№", "numsp": " ", "nvDash": "⊭", "nvHarr": "⤄", "nvap": "≍⃒", "nvdash": "⊬", "nvge": "≥⃒", "nvgt": ">⃒", "nvinfin": "⧞", "nvlArr": "⤂", "nvle": "≤⃒", "nvlt": "<⃒", "nvltrie": "⊴⃒", "nvrArr": "⤃", "nvrtrie": "⊵⃒", "nvsim": "∼⃒", "nwArr": "⇖", "nwarhk": "⤣", "nwarr": "↖", "nwarrow": "↖", "nwnear": "⤧", "oS": "Ⓢ", "oacut": "ó", "oacute": "ó", "oast": "⊛", "ocir": "ô", "ocirc": "ô", "ocy": "о", "odash": "⊝", "odblac": "ő", "odiv": "⨸", "odot": "⊙", "odsold": "⦼", "oelig": "œ", "ofcir": "⦿", "ofr": "𝔬", "ogon": "˛", "ograv": "ò", "ograve": "ò", "ogt": "⧁", "ohbar": "⦵", "ohm": "Ω", "oint": "∮", "olarr": "↺", "olcir": "⦾", "olcross": "⦻", "oline": "‾", "olt": "⧀", "omacr": "ō", "omega": "ω", "omicron": "ο", "omid": "⦶", "ominus": "⊖", "oopf": "𝕠", "opar": "⦷", "operp": "⦹", "oplus": "⊕", "or": "∨", "orarr": "↻", "ord": "º", "order": "ℴ", "orderof": "ℴ", "ordf": "ª", "ordm": "º", "origof": "⊶", "oror": "⩖", "orslope": "⩗", "orv": "⩛", "oscr": "ℴ", "oslas": "ø", "oslash": "ø", "osol": "⊘", "otild": "õ", "otilde": "õ", "otimes": "⊗", "otimesas": "⨶", "oum": "ö", "ouml": "ö", "ovbar": "⌽", "par": "¶", "para": "¶", "parallel": "∥", "parsim": "⫳", "parsl": "⫽", "part": "∂", "pcy": "п", "percnt": "%", "period": ".", "permil": "‰", "perp": "⊥", "pertenk": "‱", "pfr": "𝔭", "phi": "φ", "phiv": "ϕ", "phmmat": "ℳ", "phone": "☎", "pi": "π", "pitchfork": "⋔", "piv": "ϖ", "planck": "ℏ", "planckh": "ℎ", "plankv": "ℏ", "plus": "+", "plusacir": "⨣", "plusb": "⊞", "pluscir": "⨢", "plusdo": "∔", "plusdu": "⨥", "pluse": "⩲", "plusm": "±", "plusmn": "±", "plussim": "⨦", "plustwo": "⨧", "pm": "±", "pointint": "⨕", "popf": "𝕡", "poun": "£", "pound": "£", "pr": "≺", "prE": "⪳", "prap": "⪷", "prcue": "≼", "pre": "⪯", "prec": "≺", "precapprox": "⪷", "preccurlyeq": "≼", "preceq": "⪯", "precnapprox": "⪹", "precneqq": "⪵", "precnsim": "⋨", "precsim": "≾", "prime": "′", "primes": "ℙ", "prnE": "⪵", "prnap": "⪹", "prnsim": "⋨", "prod": "∏", "profalar": "⌮", "profline": "⌒", "profsurf": "⌓", "prop": "∝", "propto": "∝", "prsim": "≾", "prurel": "⊰", "pscr": "𝓅", "psi": "ψ", "puncsp": " ", "qfr": "𝔮", "qint": "⨌", "qopf": "𝕢", "qprime": "⁗", "qscr": "𝓆", "quaternions": "ℍ", "quatint": "⨖", "quest": "?", "questeq": "≟", "quo": '"', "quot": '"', "rAarr": "⇛", "rArr": "⇒", "rAtail": "⤜", "rBarr": "⤏", "rHar": "⥤", "race": "∽̱", "racute": "ŕ", "radic": "√", "raemptyv": "⦳", "rang": "⟩", "rangd": "⦒", "range": "⦥", "rangle": "⟩", "raqu": "»", "raquo": "»", "rarr": "→", "rarrap": "⥵", "rarrb": "⇥", "rarrbfs": "⤠", "rarrc": "⤳", "rarrfs": "⤞", "rarrhk": "↪", "rarrlp": "↬", "rarrpl": "⥅", "rarrsim": "⥴", "rarrtl": "↣", "rarrw": "↝", "ratail": "⤚", "ratio": "∶", "rationals": "ℚ", "rbarr": "⤍", "rbbrk": "❳", "rbrace": "}", "rbrack": "]", "rbrke": "⦌", "rbrksld": "⦎", "rbrkslu": "⦐", "rcaron": "ř", "rcedil": "ŗ", "rceil": "⌉", "rcub": "}", "rcy": "р", "rdca": "⤷", "rdldhar": "⥩", "rdquo": "”", "rdquor": "”", "rdsh": "↳", "real": "ℜ", "realine": "ℛ", "realpart": "ℜ", "reals": "ℝ", "rect": "▭", "re": "®", "reg": "®", "rfisht": "⥽", "rfloor": "⌋", "rfr": "𝔯", "rhard": "⇁", "rharu": "⇀", "rharul": "⥬", "rho": "ρ", "rhov": "ϱ", "rightarrow": "→", "rightarrowtail": "↣", "rightharpoondown": "⇁", "rightharpoonup": "⇀", "rightleftarrows": "⇄", "rightleftharpoons": "⇌", "rightrightarrows": "⇉", "rightsquigarrow": "↝", "rightthreetimes": "⋌", "ring": "˚", "risingdotseq": "≓", "rlarr": "⇄", "rlhar": "⇌", "rlm": "‏", "rmoust": "⎱", "rmoustache": "⎱", "rnmid": "⫮", "roang": "⟭", "roarr": "⇾", "robrk": "⟧", "ropar": "⦆", "ropf": "𝕣", "roplus": "⨮", "rotimes": "⨵", "rpar": ")", "rpargt": "⦔", "rppolint": "⨒", "rrarr": "⇉", "rsaquo": "›", "rscr": "𝓇", "rsh": "↱", "rsqb": "]", "rsquo": "’", "rsquor": "’", "rthree": "⋌", "rtimes": "⋊", "rtri": "▹", "rtrie": "⊵", "rtrif": "▸", "rtriltri": "⧎", "ruluhar": "⥨", "rx": "℞", "sacute": "ś", "sbquo": "‚", "sc": "≻", "scE": "⪴", "scap": "⪸", "scaron": "š", "sccue": "≽", "sce": "⪰", "scedil": "ş", "scirc": "ŝ", "scnE": "⪶", "scnap": "⪺", "scnsim": "⋩", "scpolint": "⨓", "scsim": "≿", "scy": "с", "sdot": "⋅", "sdotb": "⊡", "sdote": "⩦", "seArr": "⇘", "searhk": "⤥", "searr": "↘", "searrow": "↘", "sec": "§", "sect": "§", "semi": ";", "seswar": "⤩", "setminus": "∖", "setmn": "∖", "sext": "✶", "sfr": "𝔰", "sfrown": "⌢", "sharp": "♯", "shchcy": "щ", "shcy": "ш", "shortmid": "∣", "shortparallel": "∥", "sh": "­", "shy": "­", "sigma": "σ", "sigmaf": "ς", "sigmav": "ς", "sim": "∼", "simdot": "⩪", "sime": "≃", "simeq": "≃", "simg": "⪞", "simgE": "⪠", "siml": "⪝", "simlE": "⪟", "simne": "≆", "simplus": "⨤", "simrarr": "⥲", "slarr": "←", "smallsetminus": "∖", "smashp": "⨳", "smeparsl": "⧤", "smid": "∣", "smile": "⌣", "smt": "⪪", "smte": "⪬", "smtes": "⪬︀", "softcy": "ь", "sol": "/", "solb": "⧄", "solbar": "⌿", "sopf": "𝕤", "spades": "♠", "spadesuit": "♠", "spar": "∥", "sqcap": "⊓", "sqcaps": "⊓︀", "sqcup": "⊔", "sqcups": "⊔︀", "sqsub": "⊏", "sqsube": "⊑", "sqsubset": "⊏", "sqsubseteq": "⊑", "sqsup": "⊐", "sqsupe": "⊒", "sqsupset": "⊐", "sqsupseteq": "⊒", "squ": "□", "square": "□", "squarf": "▪", "squf": "▪", "srarr": "→", "sscr": "𝓈", "ssetmn": "∖", "ssmile": "⌣", "sstarf": "⋆", "star": "☆", "starf": "★", "straightepsilon": "ϵ", "straightphi": "ϕ", "strns": "¯", "sub": "⊂", "subE": "⫅", "subdot": "⪽", "sube": "⊆", "subedot": "⫃", "submult": "⫁", "subnE": "⫋", "subne": "⊊", "subplus": "⪿", "subrarr": "⥹", "subset": "⊂", "subseteq": "⊆", "subseteqq": "⫅", "subsetneq": "⊊", "subsetneqq": "⫋", "subsim": "⫇", "subsub": "⫕", "subsup": "⫓", "succ": "≻", "succapprox": "⪸", "succcurlyeq": "≽", "succeq": "⪰", "succnapprox": "⪺", "succneqq": "⪶", "succnsim": "⋩", "succsim": "≿", "sum": "∑", "sung": "♪", "sup": "⊃", "sup1": "¹", "sup2": "²", "sup3": "³", "supE": "⫆", "supdot": "⪾", "supdsub": "⫘", "supe": "⊇", "supedot": "⫄", "suphsol": "⟉", "suphsub": "⫗", "suplarr": "⥻", "supmult": "⫂", "supnE": "⫌", "supne": "⊋", "supplus": "⫀", "supset": "⊃", "supseteq": "⊇", "supseteqq": "⫆", "supsetneq": "⊋", "supsetneqq": "⫌", "supsim": "⫈", "supsub": "⫔", "supsup": "⫖", "swArr": "⇙", "swarhk": "⤦", "swarr": "↙", "swarrow": "↙", "swnwar": "⤪", "szli": "ß", "szlig": "ß", "target": "⌖", "tau": "τ", "tbrk": "⎴", "tcaron": "ť", "tcedil": "ţ", "tcy": "т", "tdot": "⃛", "telrec": "⌕", "tfr": "𝔱", "there4": "∴", "therefore": "∴", "theta": "θ", "thetasym": "ϑ", "thetav": "ϑ", "thickapprox": "≈", "thicksim": "∼", "thinsp": " ", "thkap": "≈", "thksim": "∼", "thor": "þ", "thorn": "þ", "tilde": "˜", "time": "×", "times": "×", "timesb": "⊠", "timesbar": "⨱", "timesd": "⨰", "tint": "∭", "toea": "⤨", "top": "⊤", "topbot": "⌶", "topcir": "⫱", "topf": "𝕥", "topfork": "⫚", "tosa": "⤩", "tprime": "‴", "trade": "™", "triangle": "▵", "triangledown": "▿", "triangleleft": "◃", "trianglelefteq": "⊴", "triangleq": "≜", "triangleright": "▹", "trianglerighteq": "⊵", "tridot": "◬", "trie": "≜", "triminus": "⨺", "triplus": "⨹", "trisb": "⧍", "tritime": "⨻", "trpezium": "⏢", "tscr": "𝓉", "tscy": "ц", "tshcy": "ћ", "tstrok": "ŧ", "twixt": "≬", "twoheadleftarrow": "↞", "twoheadrightarrow": "↠", "uArr": "⇑", "uHar": "⥣", "uacut": "ú", "uacute": "ú", "uarr": "↑", "ubrcy": "ў", "ubreve": "ŭ", "ucir": "û", "ucirc": "û", "ucy": "у", "udarr": "⇅", "udblac": "ű", "udhar": "⥮", "ufisht": "⥾", "ufr": "𝔲", "ugrav": "ù", "ugrave": "ù", "uharl": "↿", "uharr": "↾", "uhblk": "▀", "ulcorn": "⌜", "ulcorner": "⌜", "ulcrop": "⌏", "ultri": "◸", "umacr": "ū", "um": "¨", "uml": "¨", "uogon": "ų", "uopf": "𝕦", "uparrow": "↑", "updownarrow": "↕", "upharpoonleft": "↿", "upharpoonright": "↾", "uplus": "⊎", "upsi": "υ", "upsih": "ϒ", "upsilon": "υ", "upuparrows": "⇈", "urcorn": "⌝", "urcorner": "⌝", "urcrop": "⌎", "uring": "ů", "urtri": "◹", "uscr": "𝓊", "utdot": "⋰", "utilde": "ũ", "utri": "▵", "utrif": "▴", "uuarr": "⇈", "uum": "ü", "uuml": "ü", "uwangle": "⦧", "vArr": "⇕", "vBar": "⫨", "vBarv": "⫩", "vDash": "⊨", "vangrt": "⦜", "varepsilon": "ϵ", "varkappa": "ϰ", "varnothing": "∅", "varphi": "ϕ", "varpi": "ϖ", "varpropto": "∝", "varr": "↕", "varrho": "ϱ", "varsigma": "ς", "varsubsetneq": "⊊︀", "varsubsetneqq": "⫋︀", "varsupsetneq": "⊋︀", "varsupsetneqq": "⫌︀", "vartheta": "ϑ", "vartriangleleft": "⊲", "vartriangleright": "⊳", "vcy": "в", "vdash": "⊢", "vee": "∨", "veebar": "⊻", "veeeq": "≚", "vellip": "⋮", "verbar": "|", "vert": "|", "vfr": "𝔳", "vltri": "⊲", "vnsub": "⊂⃒", "vnsup": "⊃⃒", "vopf": "𝕧", "vprop": "∝", "vrtri": "⊳", "vscr": "𝓋", "vsubnE": "⫋︀", "vsubne": "⊊︀", "vsupnE": "⫌︀", "vsupne": "⊋︀", "vzigzag": "⦚", "wcirc": "ŵ", "wedbar": "⩟", "wedge": "∧", "wedgeq": "≙", "weierp": "℘", "wfr": "𝔴", "wopf": "𝕨", "wp": "℘", "wr": "≀", "wreath": "≀", "wscr": "𝓌", "xcap": "⋂", "xcirc": "◯", "xcup": "⋃", "xdtri": "▽", "xfr": "𝔵", "xhArr": "⟺", "xharr": "⟷", "xi": "ξ", "xlArr": "⟸", "xlarr": "⟵", "xmap": "⟼", "xnis": "⋻", "xodot": "⨀", "xopf": "𝕩", "xoplus": "⨁", "xotime": "⨂", "xrArr": "⟹", "xrarr": "⟶", "xscr": "𝓍", "xsqcup": "⨆", "xuplus": "⨄", "xutri": "△", "xvee": "⋁", "xwedge": "⋀", "yacut": "ý", "yacute": "ý", "yacy": "я", "ycirc": "ŷ", "ycy": "ы", "ye": "¥", "yen": "¥", "yfr": "𝔶", "yicy": "ї", "yopf": "𝕪", "yscr": "𝓎", "yucy": "ю", "yum": "ÿ", "yuml": "ÿ", "zacute": "ź", "zcaron": "ž", "zcy": "з", "zdot": "ż", "zeetrf": "ℨ", "zeta": "ζ", "zfr": "𝔷", "zhcy": "ж", "zigrarr": "⇝", "zopf": "𝕫", "zscr": "𝓏", "zwj": "‍", "zwnj": "‌" };
const ENTITY_MAP = _ENTITY_MAP;
function entityStringToRawString(entityStr) {
  if (!entityStr.startsWith("&")) {
    entityStr = "&" + entityStr;
  }
  if (!entityStr.endsWith(";")) {
    entityStr += ";";
  }
  try {
    if (entityStr.charAt(1) === "#") {
      const val = entityStr.charAt(2) === "x" ? parseInt(entityStr.slice(3, entityStr.length - 1), 16) : parseInt(entityStr.slice(2, entityStr.length - 1), 10);
      return String.fromCharCode(val);
    }
    const trimmedEntityString = entityStr.slice(1, entityStr.length - 1);
    if (trimmedEntityString in ENTITY_MAP) {
      return ENTITY_MAP[trimmedEntityString];
    }
  } catch (e2) {
    console.warn(
      `Encountered error when converting entity "${entityStr}": ${e2.message}`
    );
  }
  console.warn(`Cannot convert XML entity "${entityStr}"`);
  return entityStr;
}
function entityToString(node, source) {
  switch (node.name) {
    case "CharacterReference":
    case "EntityReference": {
      const entity = extractContent(node, source);
      const converted = entityStringToRawString(entity);
      if (converted === "$" && /[a-zA-Z_]/.test(source.charAt(node.to))) {
        return converted + "​";
      }
      return converted;
    }
  }
  throw new Error(
    `Cannot use entityToString to convert a node of type ${node.name}`
  );
}
function removeQuotes(str) {
  if (str.startsWith("'") || str.startsWith('"')) {
    str = str.slice(1);
  }
  if (str.endsWith("'") || str.endsWith('"')) {
    str = str.slice(0, str.length - 1);
  }
  return str;
}
function unescapeEntities(node, source) {
  const rawValue = extractContent(node, source);
  const entities2 = node.getChildren("EntityReference");
  if (entities2.length === 0) {
    return rawValue;
  }
  let i2 = 0;
  let ret = "";
  for (const entity of entities2) {
    ret += rawValue.slice(i2, entity.from - node.from);
    ret += entityToString(entity, source);
    i2 = entity.to - node.from;
  }
  ret += rawValue.slice(i2);
  return ret;
}
function textNodeToText(node, source) {
  if (node.name !== "Text") {
    throw new Error(
      `Can only convert node of type "Text", not the passed-in type of "${node.name}"`
    );
  }
  return unescapeEntities(node, source);
}
function attributeValueText(node, source) {
  if (node.name !== "AttributeValue") {
    throw new Error(
      `Can only get the text of an "AttributeValue" type node, not "${node.name}"`
    );
  }
  return removeQuotes(unescapeEntities(node, source));
}
function lezerNodeToPosition(node, offsetToPositionMap) {
  const { rowMap, columnMap } = offsetToPositionMap;
  const { from, to: to2 } = node;
  return {
    start: {
      line: rowMap[from] + 1,
      column: columnMap[from] + 1,
      offset: from
    },
    end: { line: rowMap[to2] + 1, column: columnMap[to2] + 1, offset: to2 }
  };
}
function extractContent(node, source) {
  return source.slice(node.from, node.to);
}
function createOffsetToPositionMap(source) {
  const rowMap = new Uint32Array(source.length + 1);
  const columnMap = new Uint32Array(source.length + 1);
  const len = source.length;
  let currentRow = 0;
  let currentColumn = 0;
  for (let i2 = 0; i2 < len; i2++) {
    rowMap[i2] = currentRow;
    columnMap[i2] = currentColumn;
    if (source.charAt(i2) === "\n") {
      currentRow += 1;
      currentColumn = 0;
    } else {
      currentColumn += 1;
    }
  }
  rowMap[len] = currentRow;
  columnMap[len] = currentColumn;
  return { rowMap, columnMap };
}
function extractDoctypeInfo(rawDoctype) {
  if (rawDoctype.startsWith("<!DOCTYPE")) {
    rawDoctype = rawDoctype.slice(10);
  }
  if (rawDoctype.endsWith(">")) {
    rawDoctype = rawDoctype.slice(0, rawDoctype.length - 1);
  }
  rawDoctype = rawDoctype.trim();
  const match2 = rawDoctype.match(/^[\w-]*/);
  const name2 = match2?.[0] || "";
  if (name2) {
    rawDoctype = rawDoctype.slice(name2.length).trim();
  }
  let _public = null;
  let system = null;
  if (rawDoctype.startsWith("PUBLIC")) {
    rawDoctype = rawDoctype.slice(6);
    const match22 = rawDoctype.match(/(["'])(.*?)\1/g);
    if (match22) {
      if (match22[0]) {
        _public = match22[0].slice(1, match22[0].length - 1);
      }
      if (match22[1]) {
        system = match22[1].slice(1, match22[1].length - 1);
      }
    }
  }
  if (rawDoctype.startsWith("SYSTEM")) {
    rawDoctype = rawDoctype.slice(6);
    const match22 = rawDoctype.match(/(["'])(.*?)\1/g);
    if (match22 && match22[0]) {
      system = match22[0].slice(1, match22[0].length - 1);
    }
  }
  return { name: name2, public: _public, system };
}
function findFirstErrorInChild(node) {
  if (node.type.name === "⚠") {
    return node;
  }
  let child = node.firstChild;
  while (child) {
    const error = findFirstErrorInChild(child);
    if (error) {
      return error;
    }
    child = child.nextSibling;
  }
  return null;
}
function getLezerChildren(node) {
  const ret = [];
  let child = node.firstChild;
  while (child) {
    ret.push(child);
    child = child.nextSibling;
  }
  return ret;
}
function updateNodePositionData(nodeToUpdate, referenceNode, offsetToPositionMap) {
  if (!nodeToUpdate.position || !referenceNode.position) {
    return;
  }
  const offset2 = referenceNode.position.start.offset;
  if (nodeToUpdate.position.start.offset != null && offset2 != null) {
    nodeToUpdate.position.start.offset += offset2;
  }
  if (nodeToUpdate.position.end.offset != null && offset2 != null) {
    nodeToUpdate.position.end.offset += offset2;
  }
  const startOffset = nodeToUpdate.position.start.offset;
  const endOffset = nodeToUpdate.position.end.offset;
  if (startOffset != null && endOffset != null) {
    nodeToUpdate.position.start.line = offsetToPositionMap.rowMap[startOffset] + 1;
    nodeToUpdate.position.start.column = offsetToPositionMap.columnMap[startOffset] + 1;
    nodeToUpdate.position.end.line = offsetToPositionMap.rowMap[endOffset] + 1;
    nodeToUpdate.position.end.column = offsetToPositionMap.columnMap[endOffset] + 1;
  }
}
function createErrorNode(node, source, offsetToPositionMap) {
  if (!node.type.isError && !node.type.is(MissingCloseTag$1)) {
    throw new Error("Function can only be called on a node of type error.");
  }
  function errorNode(message, options2) {
    const { startNode = node, endNode = node } = options2 ?? {};
    const startPos = lezerNodeToPosition(startNode, offsetToPositionMap);
    const endPos = startNode !== endNode ? lezerNodeToPosition(endNode, offsetToPositionMap) : startPos;
    return {
      type: "error",
      message,
      position: { start: startPos.start, end: endPos.end }
    };
  }
  const parent = node.parent;
  if (!parent) {
    const message = `Invalid DoenetML: ${extractContent(node, source)}`;
    return {
      type: "error",
      message,
      position: lezerNodeToPosition(node, offsetToPositionMap)
    };
  }
  switch (parent.type.id) {
    case Element$2: {
      const openTag = parent.getChild(OpenTag$1);
      const closeTag = parent.getChild(CloseTag);
      const tagNameTag = (openTag || parent.getChild(SelfClosingTag) || closeTag)?.getChild(TagName$y);
      const openTagName = tagNameTag ? extractContent(tagNameTag, source) : "";
      if (openTag && !closeTag) {
        const openTagName2 = tagNameTag ? extractContent(tagNameTag, source) : "";
        const message = `Invalid DoenetML: The tag \`${extractContent(
          openTag,
          source
        )}\` has no closing tag. Expected a self-closing tag or a \`</${openTagName2}>\` tag.`;
        return errorNode(message, {
          startNode: openTag,
          endNode: openTag
        });
      }
      return errorNode(
        `Invalid DoenetML: Error in tag \`<${openTagName}>\``
      );
    }
    case Attribute: {
      const value = extractContent(parent, source);
      const attributeNameNode = parent.getChild("AttributeName");
      const isNode2 = parent.getChild("Is");
      if (attributeNameNode && isNode2) {
        return errorNode(
          `Invalid DoenetML: Invalid attribute \`${value}\` appears to be missing a value.`
        );
      }
      return errorNode(
        `Invalid DoenetML: Invalid attribute \`${value}\``
      );
    }
    case AttributeValue: {
      const attribute = parent.parent;
      const value = extractContent(parent, source);
      const openQuote = value[0];
      const closeQuote = value[value.length - 1];
      if (!attribute || openQuote === closeQuote) {
        return errorNode(
          `Invalid DoenetML: Invalid attribute value \`${value}\``
        );
      }
      const correctQuote = openQuote.match(/['"]/) ? openQuote : closeQuote.match(/['"]/) ? closeQuote : '"';
      return errorNode(
        `Invalid DoenetML: Invalid attribute value \`${value}\`. The quote marks do not match. You appear to be missing a \`${correctQuote}\``
      );
    }
    case OpenTag$1: {
      const tagName = parent.getChild(TagName$y);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a tag without a tag name, e.g. \`<\``
        );
      }
      const endTag = parent.getChild(EndTag);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent(
            parent,
            source
          )}\` was not closed (a \`>\` appears to be missing).`,
          { startNode: parent, endNode: tagName }
        );
      }
    }
    case SelfClosingTag: {
      const tagName = parent.getChild(TagName$y);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a tag without a tag name \`<${extractContent(
            node,
            source
          )}>\``
        );
      }
      const endTag = parent.getChild(SelfCloseEndTag);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent(
            parent,
            source
          )}\` was not closed (\`/>\` appears to be missing).`
        );
      }
      return errorNode(
        `Invalid DoenetML: Tag \`${extractContent(
          parent,
          source
        )}\` is not valid. It may have incorrect attributes.`
      );
    }
    case MismatchedCloseTag:
    case CloseTag: {
      const tagName = parent.getChild(TagName$y);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a closing tag without a tag name, e.g. \`</\``
        );
      }
      const endTag = parent.getChild(EndTag);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent(
            parent,
            source
          )}\` was not closed (a \`>\` appears to be missing).`,
          { startNode: parent, endNode: tagName }
        );
      }
    }
  }
  return errorNode(`Could not convert node ${node} to Dast node.`);
}
const defaultSubsetRegex = /["&'<>`]/g;
const surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const controlCharactersRegex = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
);
const regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
const subsetToRegexCache = /* @__PURE__ */ new WeakMap();
function core(value, options2) {
  value = value.replace(
    options2.subset ? charactersToExpressionCached(options2.subset) : defaultSubsetRegex,
    basic
  );
  if (options2.subset || options2.escapeOnly) {
    return value;
  }
  return value.replace(surrogatePairsRegex, surrogate).replace(controlCharactersRegex, basic);
  function surrogate(pair2, index2, all2) {
    return options2.format(
      (pair2.charCodeAt(0) - 55296) * 1024 + pair2.charCodeAt(1) - 56320 + 65536,
      all2.charCodeAt(index2 + 2),
      options2
    );
  }
  function basic(character, index2, all2) {
    return options2.format(
      character.charCodeAt(0),
      all2.charCodeAt(index2 + 1),
      options2
    );
  }
}
function charactersToExpressionCached(subset) {
  let cached = subsetToRegexCache.get(subset);
  if (!cached) {
    cached = charactersToExpression(subset);
    subsetToRegexCache.set(subset, cached);
  }
  return cached;
}
function charactersToExpression(subset) {
  const groups = [];
  let index2 = -1;
  while (++index2 < subset.length) {
    groups.push(subset[index2].replace(regexEscapeRegex, "\\$&"));
  }
  return new RegExp("(?:" + groups.join("|") + ")", "g");
}
function formatBasic(code2) {
  return "&#x" + code2.toString(16).toUpperCase() + ";";
}
function stringifyEntitiesLight(value, options2) {
  return core(value, Object.assign({ format: formatBasic }, options2));
}
function escape$2(value, subset, unsafe) {
  const result2 = clean$1(value);
  return unsafe ? result2.replace(unsafe, encode2) : encode2(result2);
  function encode2(value2) {
    return stringifyEntitiesLight(value2, { subset }).replace(/&#x3C;/g, "&lt;").replace(/&#x26;/g, "&amp;");
  }
}
const nonCharacter = /[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g;
function clean$1(value) {
  return String(value || "").replace(nonCharacter, "");
}
function name$51(value) {
  const subset = ["	", "\n", " ", '"', "&", "'", "/", "<", "=", ">"];
  return escape$2(value, subset);
}
function mergeAdjacentTextInArray(nodes) {
  const needsMerging = nodes.some(
    (n, i2) => n.type === "text" && nodes[i2 + 1]?.type === "text"
  );
  if (!needsMerging) {
    return nodes;
  }
  const ret = [];
  for (let i2 = 0; i2 < nodes.length; i2++) {
    let node = nodes[i2];
    let nextNode = nodes[i2 + 1];
    if (!nextNode) {
      ret.push(node);
      continue;
    }
    if (node.type === "text" && nextNode.type === "text") {
      node = { ...node };
      ret.push(node);
      while (nextNode?.type === "text") {
        node.value += nextNode.value;
        if (node.position && nextNode.position) {
          node.position.end = nextNode.position.end;
        }
        i2++;
        nextNode = nodes[i2 + 1];
      }
    } else {
      ret.push(node);
    }
  }
  return ret;
}
function findNodesWithPositionInfo(nodes) {
  if (typeof nodes !== "object" || nodes === null) {
    return [];
  }
  if (Array.isArray(nodes)) {
    return nodes.flatMap(findNodesWithPositionInfo);
  }
  if (!("type" in nodes)) {
    return [];
  }
  const ret = "position" in nodes ? [nodes] : [];
  for (const value of Object.values(nodes)) {
    if (Array.isArray(value)) {
      ret.push(...findNodesWithPositionInfo(value));
    }
  }
  return ret;
}
function ccount(value, character) {
  const source = String(value);
  if (typeof character !== "string") {
    throw new TypeError("Expected character");
  }
  let count = 0;
  let index2 = source.indexOf(character);
  while (index2 !== -1) {
    count++;
    index2 = source.indexOf(character, index2 + character.length);
  }
  return count;
}
function macroToString(node) {
  if (Array.isArray(node)) {
    return node.map((n) => macroToString(n)).join("");
  }
  switch (node.type) {
    case "macro": {
      const macro = unwrappedMacroToString$1(node);
      let start = "$";
      let end = "";
      if (macroNeedsParens$1(node)) {
        start += "(";
        end += ")";
      }
      return start + macro + end;
    }
    case "function": {
      const macro = unwrappedMacroToString$1(node.macro);
      let start = "$$";
      let end = "";
      if (macroNeedsParens$1(node)) {
        start += "(";
        end += ")";
      }
      const args = node.input ? `(${node.input.map(macroToString).join(", ")})` : "";
      return start + macro + end + args;
    }
    case "text":
      return toXml(node);
    default:
      console.warn("Unhandled node type", node);
  }
  return "$ERROR";
}
function unwrappedMacroToString$1(nodes) {
  const path = macroPathToString$1(nodes.path);
  const attrs = Object.values(nodes.attributes || {}).map(attrToString$1).join(" ");
  let attrsStr = attrs.length > 0 ? `{${attrs}}` : "";
  let propAccess = "";
  if (nodes.accessedProp) {
    propAccess = "." + unwrappedMacroToString$1(nodes.accessedProp);
  }
  return path + attrsStr + propAccess;
}
function macroPathToString$1(path) {
  return path.map(macroPathPartToString$1).join("/");
}
function macroPathPartToString$1(pathPart) {
  return pathPart.name + pathPart.index.map((part) => `[${macroToString(part.value)}]`).join("");
}
function attrToString$1(attr) {
  const name2 = attr.name;
  if (attr.children.length === 0) {
    return name2;
  }
  const value = attr.children.map(macroToString).join("");
  return `${name2}=${quote(value)}`;
}
function macroNeedsParens$1(macro) {
  if (macro.type === "function") {
    return macroNeedsParens$1(macro.macro);
  }
  if (macro.path.length > 1) {
    return true;
  }
  return macro.path.some((part) => part.name.includes("-")) || macro.accessedProp != null && macroNeedsParens$1(macro.accessedProp);
}
function toXml(tree, options2) {
  options2 = options2 || {};
  if (!tree) {
    return "";
  }
  const node = Array.isArray(tree) ? { type: "root", children: tree } : tree;
  return nodesToXml(node, options2);
}
function nodesToXml(node, options2) {
  if (Array.isArray(node)) {
    if (!node.some((n) => n.type === "pathPart")) {
      return mergeAdjacentTextInArray(node).map((child) => nodesToXml(child, options2)).join("");
    } else {
      return node.map((part) => nodesToXml(part, options2)).join(".");
    }
  }
  const type = node && node.type;
  switch (node?.type) {
    case "root":
      return nodesToXml(node.children, options2);
    case "cdata": {
      const unsafe = /]]>/g;
      const subset = [">"];
      return "<![CDATA[" + escape$2(node.value, subset, unsafe) + "]]>";
    }
    case "comment":
      return "<!--" + escape$2(node.value, ["-"]) + "-->";
    case "doctype": {
      const nodeName = name$51(node.name);
      const pub = node.public;
      const sys = node.system;
      let result2 = "<!DOCTYPE";
      if (nodeName !== "") {
        result2 += " " + nodeName;
      }
      if (pub) {
        result2 += " PUBLIC " + quote(pub);
      } else if (sys) {
        result2 += " SYSTEM";
      }
      if (sys) {
        result2 += " " + quote(sys);
      }
      return result2 + ">";
    }
    case "attribute": {
      return attrToString(node, options2);
    }
    case "element": {
      const nodeName = name$51(node.name);
      const content2 = nodesToXml(node.children, options2);
      const attributes = node.attributes || [];
      const attrs = Object.values(attributes).map(
        (attr) => attrToString(attr, options2)
      );
      const printedAttrs = (attrs.length > 0 ? " " : "") + attrs.join(" ");
      if (node.children.length === 0 || !options2.inlineErrors && node.children.every((c2) => c2.type === "error")) {
        return `<${nodeName}${printedAttrs} />`;
      }
      return `<${nodeName}${printedAttrs}>${content2}</${nodeName}>`;
    }
    case "instruction": {
      const unsafe = /\?>/g;
      const subset = [">"];
      const nodeName = name$51(node.name);
      const result2 = escape$2(node.value, subset, unsafe);
      return "<?" + nodeName + (result2 ? " " + result2 : "") + "?>";
    }
    case "text": {
      let escapedText = escape$2(node.value, ["&", "<"]);
      if (options2.doenetSyntax) {
        escapedText = escapedText.replace(/&lt;(?=\s|=)/g, "<");
        escapedText = escapedText.replace(/&amp;(?!\S*;)/g, "&");
      }
      return escapedText;
    }
    case "error": {
      if (options2.inlineErrors) {
        const errorElement = {
          type: "element",
          name: "_error",
          attributes: {
            message: {
              type: "attribute",
              name: "message",
              children: [{ type: "text", value: node.message }]
            }
          },
          children: [{ type: "text", value: node.message }]
        };
        return nodesToXml(errorElement, options2);
      }
      return "";
    }
    case "macro": {
      if (node.version === "0.6") {
        return macroToString(node);
      }
      const macro = unwrappedMacroToString(node, options2);
      let start = "$";
      let end = "";
      if (macroNeedsParens(node)) {
        start += "(";
        end += ")";
      }
      return start + macro + end;
    }
    case "function": {
      if (node.version === "0.6") {
        return macroToString(node);
      }
      const macro = unwrappedMacroToString(node, options2);
      let start = "$$";
      let end = "";
      if (macroNeedsParens(node)) {
        start += "(";
        end += ")";
      }
      const args = node.input ? `(${node.input.map((a) => nodesToXml(a, options2)).join(", ")})` : "";
      return start + macro + end + args;
    }
    case "pathPart": {
      return node.name + node.index.map((ind) => `[${nodesToXml(ind.value, options2)}]`).join("");
    }
  }
  if (!type) {
    throw new Error("Expected node, not `" + node + "`");
  }
  throw new Error("Cannot compile unknown node `" + type + "`");
}
function quote(value) {
  const result2 = String(value);
  let quoteMark = '"';
  const other = quoteMark === '"' ? "'" : '"';
  if (ccount(result2, quoteMark) > ccount(result2, other)) {
    quoteMark = other;
  }
  return quoteMark + escape$2(result2, ["<", quoteMark]) + quoteMark;
}
function unwrappedMacroToString(nodes, options2) {
  const path = macroPathToString(nodes.path, options2);
  let attrsStr = "";
  if (nodes.type === "macro") {
    const attrs = Object.values(nodes.attributes || {}).map((a) => attrToString(a, options2)).join(" ");
    attrsStr = attrs.length > 0 ? `{${attrs}}` : "";
  }
  let propAccess = "";
  return path + attrsStr + propAccess;
}
function macroPathToString(path, options2) {
  return path.map((part) => macroPathPartToString(part, options2)).join(".");
}
function macroPathPartToString(pathPart, options2) {
  return pathPart.name + pathPart.index.map((part) => `[${nodesToXml(part.value, options2)}]`).join("");
}
function attrToString(attr, options2) {
  if (attr.children.length === 0) {
    if (options2.doenetSyntax) {
      return name$51(attr.name);
    }
    return `${name$51(attr.name)}="true"`;
  }
  return `${name$51(attr.name)}=${quote(nodesToXml(attr.children, options2))}`;
}
function macroNeedsParens(macro) {
  return macro.path.some((part) => part.name.includes("-"));
}
const _MacroParser = (
  // @generated by Peggy 5.0.6.
  //
  // https://peggyjs.org/
  /* @__PURE__ */ (function() {
    class peg$SyntaxError extends SyntaxError {
      constructor(message, expected, found, location) {
        super(message);
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
      }
      format(sources) {
        let str = "Error: " + this.message;
        if (this.location) {
          let src = null;
          const st2 = sources.find((s2) => s2.source === this.location.source);
          if (st2) {
            src = st2.text.split(/\r\n|\n|\r/g);
          }
          const s = this.location.start;
          const offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s) : s;
          const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
          if (src) {
            const e2 = this.location.end;
            const filler = "".padEnd(offset_s.line.toString().length, " ");
            const line2 = src[s.line - 1];
            const last2 = s.line === e2.line ? e2.column : line2.length + 1;
            const hatLen = last2 - s.column || 1;
            str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line2 + "\n" + filler + " | " + "".padEnd(s.column - 1, " ") + "".padEnd(hatLen, "^");
          } else {
            str += "\n at " + loc;
          }
        }
        return str;
      }
      static buildMessage(expected, found) {
        function hex(ch) {
          return ch.codePointAt(0).toString(16).toUpperCase();
        }
        const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode") ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu") : null;
        function unicodeEscape(s) {
          if (nonPrintable) {
            return s.replace(nonPrintable, (ch) => "\\u{" + hex(ch) + "}");
          }
          return s;
        }
        function literalEscape(s) {
          return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch)));
        }
        function classEscape(s) {
          return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch)));
        }
        const DESCRIBE_EXPECTATION_FNS = {
          literal(expectation) {
            return '"' + literalEscape(expectation.text) + '"';
          },
          class(expectation) {
            const escapedParts = expectation.parts.map(
              (part) => Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part)
            );
            return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
          },
          any() {
            return "any character";
          },
          end() {
            return "end of input";
          },
          other(expectation) {
            return expectation.description;
          }
        };
        function describeExpectation(expectation) {
          return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected2) {
          const descriptions = expected2.map(describeExpectation);
          descriptions.sort();
          if (descriptions.length > 0) {
            let j2 = 1;
            for (let i2 = 1; i2 < descriptions.length; i2++) {
              if (descriptions[i2 - 1] !== descriptions[i2]) {
                descriptions[j2] = descriptions[i2];
                j2++;
              }
            }
            descriptions.length = j2;
          }
          switch (descriptions.length) {
            case 1:
              return descriptions[0];
            case 2:
              return descriptions[0] + " or " + descriptions[1];
            default:
              return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
          }
        }
        function describeFound(found2) {
          return found2 ? '"' + literalEscape(found2) + '"' : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
      }
    }
    function peg$parse(input, options2) {
      options2 = options2 !== void 0 ? options2 : {};
      const peg$FAILED = {};
      const peg$source = options2.grammarSource;
      const peg$startRuleFunctions = {
        top: peg$parsetop
      };
      let peg$startRuleFunction = peg$parsetop;
      const peg$c0 = ".";
      const peg$c1 = "$";
      const peg$c2 = "(";
      const peg$c3 = ")";
      const peg$c4 = "$$";
      const peg$c5 = ",";
      const peg$c6 = "{";
      const peg$c7 = "}";
      const peg$c8 = "[";
      const peg$c9 = "]";
      const peg$c10 = "=";
      const peg$c11 = '"';
      const peg$c12 = "'";
      const peg$r0 = /^[a-zA-Z_]/;
      const peg$r1 = /^[a-zA-Z0-9_]/;
      const peg$r2 = /^[a-zA-Z0-9_\-]/;
      const peg$r3 = /^[a-zA-Z0-9_:\-]/;
      const peg$r4 = /^[^$]/;
      const peg$r5 = /^[^(),$]/;
      const peg$r6 = /^[^(),]/;
      const peg$r7 = /^[^()$]/;
      const peg$r8 = /^[^()]/;
      const peg$r9 = /^[^'$]/;
      const peg$r10 = /^[^']/;
      const peg$r11 = /^[^\]$]/;
      const peg$r12 = /^[^\]]/;
      const peg$r13 = /^[^"$]/;
      const peg$r14 = /^[^"]/;
      const peg$r15 = /^[ \t\r\n]/;
      const peg$e0 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false, false);
      const peg$e1 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false, false);
      const peg$e2 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_", "-"], false, false, false);
      const peg$e3 = peg$literalExpectation(".", false);
      const peg$e4 = peg$literalExpectation("$", false);
      const peg$e5 = peg$literalExpectation("(", false);
      const peg$e6 = peg$literalExpectation(")", false);
      const peg$e7 = peg$literalExpectation("$$", false);
      const peg$e8 = peg$literalExpectation(",", false);
      const peg$e9 = peg$literalExpectation("{", false);
      const peg$e10 = peg$literalExpectation("}", false);
      const peg$e11 = peg$literalExpectation("[", false);
      const peg$e12 = peg$literalExpectation("]", false);
      const peg$e13 = peg$literalExpectation("=", false);
      const peg$e14 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_", ":", "-"], false, false, false);
      const peg$e15 = peg$literalExpectation('"', false);
      const peg$e16 = peg$literalExpectation("'", false);
      const peg$e17 = peg$classExpectation(["$"], true, false, false);
      const peg$e18 = peg$anyExpectation();
      const peg$e19 = peg$classExpectation(["(", ")", ",", "$"], true, false, false);
      const peg$e20 = peg$classExpectation(["(", ")", ","], true, false, false);
      const peg$e21 = peg$classExpectation(["(", ")", "$"], true, false, false);
      const peg$e22 = peg$classExpectation(["(", ")"], true, false, false);
      const peg$e23 = peg$classExpectation(["'", "$"], true, false, false);
      const peg$e24 = peg$classExpectation(["'"], true, false, false);
      const peg$e25 = peg$classExpectation(["]", "$"], true, false, false);
      const peg$e26 = peg$classExpectation(["]"], true, false, false);
      const peg$e27 = peg$classExpectation(['"', "$"], true, false, false);
      const peg$e28 = peg$classExpectation(['"'], true, false, false);
      const peg$e29 = peg$classExpectation([" ", "	", "\r", "\n"], false, false, false);
      function peg$f0(name2, index2) {
        return withPosition({ type: "pathPart", name: name2, index: index2 });
      }
      function peg$f1(name2, index2) {
        return withPosition({ type: "pathPart", name: name2, index: index2 });
      }
      function peg$f2(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f3(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f4(macro) {
        return withPosition(macro);
      }
      function peg$f5(macro) {
        return withPosition(macro);
      }
      function peg$f6(path, attrs) {
        return withPosition({
          type: "macro",
          path,
          attributes: attrs || {}
        });
      }
      function peg$f7(path, attrs) {
        return withPosition({
          type: "macro",
          path,
          attributes: attrs || {}
        });
      }
      function peg$f8(path, input2) {
        return withPosition({
          type: "function",
          path,
          input: input2
        });
      }
      function peg$f9(path, input2) {
        return withPosition({
          type: "function",
          path,
          input: input2
        });
      }
      function peg$f10(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f11(a, rest2, b2) {
        return [a, ...rest2, b2];
      }
      function peg$f12(x2) {
        return x2.flat();
      }
      function peg$f13(a, rest2, b2) {
        return [a, ...rest2, b2];
      }
      function peg$f14(x2) {
        return x2.flat();
      }
      function peg$f15(attrs) {
        return Object.fromEntries(attrs.map((a) => [a.name, a]));
      }
      function peg$f16(value) {
        return withPosition({ type: "index", value });
      }
      function peg$f17(name2, children) {
        return withPosition({ type: "attribute", name: name2, children });
      }
      function peg$f18(name2) {
        return withPosition({
          type: "attribute",
          name: name2,
          children: []
        });
      }
      function peg$f19(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f21() {
        return withPosition({ type: "text", value: "(" });
      }
      function peg$f22() {
        return withPosition({ type: "text", value: ")" });
      }
      function peg$f23(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f24(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f25(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f26(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f27(value) {
        return withPosition({ type: "text", value });
      }
      let peg$currPos = options2.peg$currPos | 0;
      let peg$savedPos = peg$currPos;
      const peg$posDetailsCache = [{ line: 1, column: 1 }];
      let peg$maxFailPos = peg$currPos;
      let peg$maxFailExpected = options2.peg$maxFailExpected || [];
      let peg$silentFails = options2.peg$silentFails | 0;
      let peg$result;
      if (options2.startRule) {
        if (!(options2.startRule in peg$startRuleFunctions)) {
          throw new Error(`Can't start parsing from rule "` + options2.startRule + '".');
        }
        peg$startRuleFunction = peg$startRuleFunctions[options2.startRule];
      }
      function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
      }
      function peg$getUnicode(pos = peg$currPos) {
        const cp = input.codePointAt(pos);
        if (cp === void 0) {
          return "";
        }
        return String.fromCodePoint(cp);
      }
      function peg$literalExpectation(text2, ignoreCase) {
        return { type: "literal", text: text2, ignoreCase };
      }
      function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
        return { type: "class", parts, inverted, ignoreCase, unicode };
      }
      function peg$anyExpectation() {
        return { type: "any" };
      }
      function peg$endExpectation() {
        return { type: "end" };
      }
      function peg$computePosDetails(pos) {
        let details = peg$posDetailsCache[pos];
        let p;
        if (details) {
          return details;
        } else {
          if (pos >= peg$posDetailsCache.length) {
            p = peg$posDetailsCache.length - 1;
          } else {
            p = pos;
            while (!peg$posDetailsCache[--p]) {
            }
          }
          details = peg$posDetailsCache[p];
          details = {
            line: details.line,
            column: details.column
          };
          while (p < pos) {
            if (input.charCodeAt(p) === 10) {
              details.line++;
              details.column = 1;
            } else {
              details.column++;
            }
            p++;
          }
          peg$posDetailsCache[pos] = details;
          return details;
        }
      }
      function peg$computeLocation(startPos, endPos, offset2) {
        const startPosDetails = peg$computePosDetails(startPos);
        const endPosDetails = peg$computePosDetails(endPos);
        const res = {
          source: peg$source,
          start: {
            offset: startPos,
            line: startPosDetails.line,
            column: startPosDetails.column
          },
          end: {
            offset: endPos,
            line: endPosDetails.line,
            column: endPosDetails.column
          }
        };
        return res;
      }
      function peg$fail(expected2) {
        if (peg$currPos < peg$maxFailPos) {
          return;
        }
        if (peg$currPos > peg$maxFailPos) {
          peg$maxFailPos = peg$currPos;
          peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected2);
      }
      function peg$buildStructuredError(expected2, found, location2) {
        return new peg$SyntaxError(
          peg$SyntaxError.buildMessage(expected2, found),
          expected2,
          found,
          location2
        );
      }
      function peg$parsetop() {
        let s0, s1;
        s0 = [];
        s1 = peg$parseMacro();
        if (s1 === peg$FAILED) {
          s1 = peg$parseFunctionMacro();
          if (s1 === peg$FAILED) {
            s1 = peg$parseText();
          }
        }
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          s1 = peg$parseMacro();
          if (s1 === peg$FAILED) {
            s1 = peg$parseFunctionMacro();
            if (s1 === peg$FAILED) {
              s1 = peg$parseText();
            }
          }
        }
        return s0;
      }
      function peg$parseSimpleIdent() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = input.charAt(peg$currPos);
        if (peg$r0.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e0);
          }
        }
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = input.charAt(peg$currPos);
          if (peg$r1.test(s4)) {
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e1);
            }
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = input.charAt(peg$currPos);
            if (peg$r1.test(s4)) {
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e1);
              }
            }
          }
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseIdent() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r2.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e2);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r2.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e2);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseSimplePathPart() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parseSimpleIdent();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parsePropIndex();
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parsePropIndex();
          }
          peg$savedPos = s0;
          s0 = peg$f0(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePathPart() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parseIdent();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parsePropIndex();
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parsePropIndex();
          }
          peg$savedPos = s0;
          s0 = peg$f1(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseSimplePath() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parseSimplePathPart();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 46) {
            s4 = peg$c0;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e3);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseSimplePathPart();
            if (s5 !== peg$FAILED) {
              s3 = s5;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 46) {
              s4 = peg$c0;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e3);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parseSimplePathPart();
              if (s5 !== peg$FAILED) {
                s3 = s5;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          }
          peg$savedPos = s0;
          s0 = peg$f2(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePath() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parsePathPart();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 46) {
            s4 = peg$c0;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e3);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parsePathPart();
            if (s5 !== peg$FAILED) {
              s3 = s5;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 46) {
              s4 = peg$c0;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e3);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parsePathPart();
              if (s5 !== peg$FAILED) {
                s3 = s5;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          }
          peg$savedPos = s0;
          s0 = peg$f3(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseMacro() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 36) {
          s1 = peg$c1;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e4);
          }
        }
        if (s1 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 40) {
            s2 = peg$c2;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e5);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parseFullAddressMacro();
            if (s3 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s4 = peg$c3;
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e6);
                }
              }
              if (s4 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f4(s3);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 36) {
            s1 = peg$c1;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e4);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseSimpleAddressMacro();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f5(s2);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseSimpleAddressMacro() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parseSimplePath();
        if (s1 !== peg$FAILED) {
          s2 = peg$parsePropAttrs();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f6(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFullAddressMacro() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsePath();
        if (s1 !== peg$FAILED) {
          s2 = peg$parsePropAttrs();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f7(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFunctionMacro() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c4) {
          s1 = peg$c4;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e7);
          }
        }
        if (s1 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 40) {
            s2 = peg$c2;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e5);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parsePath();
            if (s3 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s4 = peg$c3;
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e6);
                }
              }
              if (s4 !== peg$FAILED) {
                s5 = peg$parseFunctionInput();
                if (s5 === peg$FAILED) {
                  s5 = null;
                }
                peg$savedPos = s0;
                s0 = peg$f8(s3, s5);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c4) {
            s1 = peg$c4;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e7);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseSimplePath();
            if (s2 !== peg$FAILED) {
              s3 = peg$parseFunctionInput();
              if (s3 === peg$FAILED) {
                s3 = null;
              }
              peg$savedPos = s0;
              s0 = peg$f9(s2, s3);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseFunctionInput() {
        let s0, s1, s3, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 40) {
          s1 = peg$c2;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e5);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = peg$parseFunctionArgumentList();
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 41) {
            s5 = peg$c3;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e6);
            }
          }
          if (s5 !== peg$FAILED) {
            s0 = s3;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFunctionArgumentList() {
        let s0, s1, s2, s3, s5, s7;
        s0 = peg$currPos;
        s1 = peg$parseBalancedParenTextNoComma();
        s2 = [];
        s3 = peg$currPos;
        peg$parse_();
        if (input.charCodeAt(peg$currPos) === 44) {
          s5 = peg$c5;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e8);
          }
        }
        if (s5 !== peg$FAILED) {
          peg$parse_();
          s7 = peg$parseBalancedParenTextNoComma();
          s3 = s7;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 44) {
            s5 = peg$c5;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e8);
            }
          }
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s7 = peg$parseBalancedParenTextNoComma();
            s3 = s7;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        peg$savedPos = s0;
        s0 = peg$f10(s1, s2);
        return s0;
      }
      function peg$parseBalancedParenTextNoComma() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parseMacro();
        if (s2 === peg$FAILED) {
          s2 = peg$parseFunctionMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseTextWithoutParenOrComma();
            if (s2 === peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parseOpenParen();
              if (s3 !== peg$FAILED) {
                s4 = peg$parseBalancedParenText();
                s5 = peg$parseCloseParen();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s2;
                  s2 = peg$f11(s3, s4, s5);
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            }
          }
        }
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parseMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseFunctionMacro();
            if (s2 === peg$FAILED) {
              s2 = peg$parseTextWithoutParenOrComma();
              if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseOpenParen();
                if (s3 !== peg$FAILED) {
                  s4 = peg$parseBalancedParenText();
                  s5 = peg$parseCloseParen();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s2;
                    s2 = peg$f11(s3, s4, s5);
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              }
            }
          }
        }
        peg$savedPos = s0;
        s1 = peg$f12(s1);
        s0 = s1;
        return s0;
      }
      function peg$parseBalancedParenText() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parseMacro();
        if (s2 === peg$FAILED) {
          s2 = peg$parseFunctionMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseTextWithoutParen();
            if (s2 === peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parseOpenParen();
              if (s3 !== peg$FAILED) {
                s4 = peg$parseBalancedParenText();
                s5 = peg$parseCloseParen();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s2;
                  s2 = peg$f13(s3, s4, s5);
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            }
          }
        }
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parseMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseFunctionMacro();
            if (s2 === peg$FAILED) {
              s2 = peg$parseTextWithoutParen();
              if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseOpenParen();
                if (s3 !== peg$FAILED) {
                  s4 = peg$parseBalancedParenText();
                  s5 = peg$parseCloseParen();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s2;
                    s2 = peg$f13(s3, s4, s5);
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              }
            }
          }
        }
        peg$savedPos = s0;
        s1 = peg$f14(s1);
        s0 = s1;
        return s0;
      }
      function peg$parsePropAttrs() {
        let s0, s1, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
          s1 = peg$c6;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e9);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = [];
          s4 = peg$currPos;
          s5 = peg$parseAttr();
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s4 = s5;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$currPos;
            s5 = peg$parseAttr();
            if (s5 !== peg$FAILED) {
              peg$parse_();
              s4 = s5;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }
          if (input.charCodeAt(peg$currPos) === 125) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e10);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f15(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePropIndex() {
        let s0, s1, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 91) {
          s1 = peg$c8;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e11);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = [];
          s4 = peg$currPos;
          s5 = peg$parseFunctionMacro();
          if (s5 === peg$FAILED) {
            s5 = peg$parseMacro();
            if (s5 === peg$FAILED) {
              s5 = peg$parseTextWithoutClosingSquareBrace();
            }
          }
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s4 = s5;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$currPos;
            s5 = peg$parseFunctionMacro();
            if (s5 === peg$FAILED) {
              s5 = peg$parseMacro();
              if (s5 === peg$FAILED) {
                s5 = peg$parseTextWithoutClosingSquareBrace();
              }
            }
            if (s5 !== peg$FAILED) {
              peg$parse_();
              s4 = s5;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }
          if (input.charCodeAt(peg$currPos) === 93) {
            s4 = peg$c9;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e12);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f16(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseAttr() {
        let s0, s1, s3, s5;
        s0 = peg$currPos;
        s1 = peg$parseAttrName();
        if (s1 !== peg$FAILED) {
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 61) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e13);
            }
          }
          if (s3 !== peg$FAILED) {
            peg$parse_();
            s5 = peg$parseAttrValue();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f17(s1, s5);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseAttrName();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f18(s1);
          }
          s0 = s1;
        }
        return s0;
      }
      function peg$parseAttrName() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r3.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e14);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r3.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e14);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseAttrValue() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 34) {
          s1 = peg$c11;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e15);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parseMacro();
          if (s3 === peg$FAILED) {
            s3 = peg$parseFunctionMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseTextWithoutDoubleQuote();
            }
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parseMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseFunctionMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseTextWithoutDoubleQuote();
              }
            }
          }
          if (input.charCodeAt(peg$currPos) === 34) {
            s3 = peg$c11;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e15);
            }
          }
          if (s3 !== peg$FAILED) {
            s0 = s2;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c12;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e16);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseFunctionMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseTextWithoutQuote();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parseMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseFunctionMacro();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseTextWithoutQuote();
                }
              }
            }
            if (input.charCodeAt(peg$currPos) === 39) {
              s3 = peg$c12;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e16);
              }
            }
            if (s3 !== peg$FAILED) {
              s0 = s2;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseText() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r4.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e17);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r4.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e17);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          if (input.length > peg$currPos) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e18);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f19(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseOpenParen() {
        let s0, s1;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 40) {
          s1 = peg$c2;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e5);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f21();
        }
        s0 = s1;
        return s0;
      }
      function peg$parseCloseParen() {
        let s0, s1;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 41) {
          s1 = peg$c3;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e6);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f22();
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutParenOrComma() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r5.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e19);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r5.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e19);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r6.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e20);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f23(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutParen() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r7.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e21);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r7.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e21);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r8.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e22);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f24(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutQuote() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r9.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e23);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r9.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e23);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 === peg$FAILED) {
          s2 = input.charAt(peg$currPos);
          if (peg$r10.test(s2)) {
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e24);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f25(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutClosingSquareBrace() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r11.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e25);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r11.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e25);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 === peg$FAILED) {
          s2 = input.charAt(peg$currPos);
          if (peg$r12.test(s2)) {
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e26);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f26(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutDoubleQuote() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r13.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e27);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r13.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e27);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r14.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e28);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f27(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parse_() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r15.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e29);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r15.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e29);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function withPosition(node) {
        const { start, end } = location();
        return { ...node, position: { start, end } };
      }
      peg$result = peg$startRuleFunction();
      const peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
      function peg$throw() {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
          peg$fail(peg$endExpectation());
        }
        throw peg$buildStructuredError(
          peg$maxFailExpected,
          peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
          peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
        );
      }
      if (options2.peg$library) {
        return (
          /** @type {any} */
          {
            peg$result,
            peg$currPos,
            peg$FAILED,
            peg$maxFailExpected,
            peg$maxFailPos,
            peg$success,
            peg$throw: peg$success ? void 0 : peg$throw
          }
        );
      }
      if (peg$success) {
        return peg$result;
      } else {
        peg$throw();
      }
    }
    return {
      StartRules: ["top"],
      SyntaxError: peg$SyntaxError,
      parse: peg$parse
    };
  })()
);
const MacroParser = _MacroParser;
function parseMacros(str) {
  return MacroParser.parse(str);
}
function gobbleFunctionArguments(nodes) {
  if (!nodes.some((node) => node.type === "function" && node.input == null)) {
    return nodes;
  }
  nodes = nodes.map(
    (node) => node.type === "text" ? splitTextAtSpecialChars(node) : node
  ).flat();
  const ret = [];
  let functionNode = null;
  for (let i2 = 0; i2 < nodes.length; i2++) {
    const node = nodes[i2];
    if (node.type === "function" && node.input == null) {
      functionNode = node;
      ret.push(node);
      continue;
    }
    if (!functionNode) {
      ret.push(node);
      continue;
    }
    if (!(node.type === "text" && node.value === "(") || !hasClosingParen(nodes.slice(i2))) {
      functionNode = null;
      ret.push(node);
      continue;
    }
    let currentFunctionArg = [];
    functionNode.input = [];
    let parenDepth = 1;
    i2++;
    while (functionNode) {
      const nextNode = nodes[i2];
      if (!nextNode) {
        throw new Error(
          "Failed to find next node when search for function arguments"
        );
      }
      if (nextNode.type !== "text") {
        currentFunctionArg.push(nextNode);
        i2++;
        continue;
      }
      if (nextNode.value === "(") {
        parenDepth++;
      }
      if (nextNode.value === "," && parenDepth <= 1) {
        functionNode.input.push(
          trimWhitespace(currentFunctionArg)
        );
        currentFunctionArg = [];
        i2++;
        continue;
      }
      if (nextNode.value === ")") {
        parenDepth--;
        if (parenDepth === 0) {
          functionNode.input.push(
            trimWhitespace(
              gobbleFunctionArguments(
                currentFunctionArg
              )
            )
          );
          currentFunctionArg = [];
          if (nextNode.position) {
            functionNode.position.end = {
              ...nextNode.position.end
            };
          }
          functionNode = null;
          i2++;
          continue;
        }
      }
      i2++;
      currentFunctionArg.push(nextNode);
    }
    i2--;
  }
  return ret;
}
function splitTextAtSpecialChars(node) {
  const pos = node.value.search(/[\(\),]/);
  if (pos < 0) {
    return [node];
  }
  const [left, middle, right] = splitTextNodeAt(node, pos);
  const ret = [left, middle, ...splitTextAtSpecialChars(right)];
  return ret.filter((node2) => node2.value !== "");
}
const DEFAULT_POSITION = {
  start: { offset: 0, line: 1, column: 1 },
  end: { offset: 0, line: 1, column: 1 }
};
function splitTextNodeAt(node, pos) {
  const { value, position: position2 = DEFAULT_POSITION } = node;
  if (pos < 0 || pos > value.length) {
    throw new Error(
      `Cannot split a string at a value larger than its length (got pos:${pos} for text node "${value}")`
    );
  }
  const { rowMap, columnMap } = createOffsetToPositionMap(value);
  const leftValue = value.slice(0, pos);
  const left = {
    type: "text",
    value: leftValue,
    position: {
      start: { ...position2.start },
      end: {
        offset: (position2.start.offset || 0) + leftValue.length,
        line: rowMap[pos] + position2.start.line,
        column: columnMap[pos] + position2.start.column
      }
    }
  };
  const middleValue = value.slice(pos, pos + 1);
  const middle = {
    type: "text",
    value: middleValue,
    position: {
      start: {
        offset: (position2.start.offset || 0) + pos,
        line: rowMap[pos] + position2.start.line,
        column: columnMap[pos] + position2.start.column
      },
      end: {
        offset: (position2.start.offset || 0) + pos + 1,
        line: rowMap[pos + 1] + position2.start.line,
        column: columnMap[pos + 1] + position2.start.column
      }
    }
  };
  const rightValue = value.slice(pos + 1);
  const right = {
    type: "text",
    value: rightValue,
    position: {
      end: { ...position2.end },
      start: {
        offset: (position2.start.offset || 0) + pos + 1,
        line: rowMap[pos + 1] + position2.start.line,
        column: columnMap[pos + 1] + position2.start.column
      }
    }
  };
  return [left, middle, right];
}
function hasClosingParen(nodes) {
  return nodes.some(
    (node) => node.type === "text" && node.value.includes(")")
  );
}
function trimWhitespace(nodes) {
  const firstNode = nodes[0];
  const lastNode = nodes[nodes.length - 1];
  if (!firstNode || !lastNode) {
    return nodes;
  }
  if (firstNode.type === "text") {
    firstNode.value = firstNode.value.trimStart();
    if (firstNode.value === "") {
      nodes.shift();
    }
  }
  if (lastNode.type === "text") {
    lastNode.value = lastNode.value.trimEnd();
    if (lastNode.value === "") {
      nodes.pop();
    }
  }
  return nodes;
}
function lezerToDast(node, source) {
  if (typeof node === "string") {
    const tree = parser$1.parse(node);
    source = node;
    return _lezerToDast(tree.topNode, source);
  }
  if (source == null) {
    throw new Error(
      `If you provide a SyntaxNode, you must also provide the source string`
    );
  }
  return _lezerToDast(node, source);
}
function _lezerToDast(node, source) {
  const offsetMap = createOffsetToPositionMap(source);
  return {
    type: "root",
    children: gobbleFunctionArguments(lezerNodeToDastNode(node)),
    position: lezerNodeToPosition(node, offsetMap),
    sources: [source]
  };
  function lezerNodeToDastNode(node2) {
    if (!node2) {
      throw new Error(`Expecting node but got ${JSON.stringify(node2)}`);
    }
    const name2 = node2.type.name;
    switch (name2) {
      case "Document":
        return getLezerChildren(node2).flatMap(lezerNodeToDastNode);
      case "Element": {
        const openTag = node2.getChild("OpenTag") || node2.getChild("SelfClosingTag");
        if (!openTag) {
          console.warn(
            `Could not find open tag for element ${extractContent(
              node2,
              source
            )}`
          );
          return [];
        }
        let children = [];
        const openTagError = findFirstErrorInChild(openTag);
        if (openTagError) {
          const errorNode = createErrorNode(
            openTagError,
            source,
            offsetMap
          );
          children.push(errorNode);
        }
        let elementError = node2.getChild("⚠") || node2.getChild(MissingCloseTag$1);
        if (openTag.type.name === "OpenTag" && !node2.getChild("CloseTag") && !openTagError && elementError) {
          const errorNode = createErrorNode(
            elementError,
            source,
            offsetMap
          );
          children.push(errorNode);
        }
        const tag2 = openTag.getChild("TagName");
        const name22 = tag2 ? extractContent(tag2, source) : "";
        const attributesList = [];
        for (const attrTag of openTag.getChildren("Attribute")) {
          const error = findFirstErrorInChild(attrTag);
          if (error) {
            const errorNode = createErrorNode(
              error,
              source,
              offsetMap
            );
            children.push(errorNode);
          }
          const attrName = attrTag.getChild("AttributeName");
          const attrValue = attrTag.getChild("AttributeValue");
          if (!attrName) {
            continue;
          }
          let attrChildren = attrValue ? [
            ...reprocessTextForMacros(
              {
                type: "text",
                value: attributeValueText(
                  attrValue,
                  source
                ),
                position: lezerNodeToPosition(
                  attrValue,
                  offsetMap
                )
              },
              offsetMap
            )
          ] : [];
          attributesList.push({
            type: "attribute",
            name: extractContent(attrName, source),
            children: attrChildren,
            position: lezerNodeToPosition(attrTag, offsetMap)
          });
        }
        children.push(
          ...getLezerChildren(node2).flatMap(
            (n) => lezerNodeToDastNode(n)
          )
        );
        children = gobbleFunctionArguments(
          children
        );
        return [
          {
            type: "element",
            name: name22,
            attributes: Object.fromEntries(
              attributesList.map((a) => [a.name, a])
            ),
            children,
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "Text": {
        const textNode = {
          type: "text",
          value: textNodeToText(node2, source),
          position: lezerNodeToPosition(node2, offsetMap)
        };
        return reprocessTextForMacros(textNode, offsetMap);
      }
      case "Ampersand":
        return [
          {
            type: "text",
            value: "&",
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      case "CharacterReference":
      case "EntityReference":
        return [
          {
            type: "text",
            value: entityToString(node2, source),
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      case "ProcessingInst": {
        const fullContent = extractContent(node2, source);
        let value = fullContent.slice(2, fullContent.length - 2);
        const match2 = value.match(/^[\w-]*/);
        const name22 = match2?.[0] || "";
        if (name22) {
          value = value.slice(name22.length).trim();
        }
        return [
          {
            type: "instruction",
            name: name22,
            value,
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "Comment": {
        const fullContent = extractContent(node2, source);
        return [
          {
            type: "comment",
            value: fullContent.slice(4, fullContent.length - 3),
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "Cdata": {
        const fullContent = extractContent(node2, source);
        return [
          {
            type: "cdata",
            value: fullContent.slice(9, fullContent.length - 3),
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "DoctypeDecl": {
        const fullContent = extractContent(node2, source);
        let value = fullContent.slice(10, fullContent.length - 1);
        const doctypeInfo = extractDoctypeInfo(value);
        return [
          {
            type: "doctype",
            ...doctypeInfo,
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "Attribute":
      case "AttributeName":
      case "AttributeValue":
      case "EndTag":
      case "Is":
      case "OpenTag":
      case "SelfCloseEndTag":
      case "SelfClosingTag":
      case "TagName":
      case "StartTag":
      case "StartCloseTag":
        return [];
      case "CloseTag": {
        const errorNode = findFirstErrorInChild(node2);
        if (errorNode) {
          return [createErrorNode(errorNode, source, offsetMap)];
        }
        return [];
      }
      case "MismatchedCloseTag": {
        const closeTagError = findFirstErrorInChild(node2);
        if (closeTagError) {
          return [createErrorNode(closeTagError, source, offsetMap)];
        }
        const parent = node2.parent;
        const openTag = parent?.getChild(OpenTag$1);
        const closeTag = parent?.getChild(CloseTag);
        if (!parent || !openTag) {
          const message2 = `Invalid DoenetML: Found closing tag \`${extractContent(
            node2,
            source
          )}\`, but no corresponding opening tag`;
          return [
            {
              type: "error",
              message: message2,
              position: lezerNodeToPosition(node2, offsetMap)
            }
          ];
        }
        if (closeTag) {
          const message2 = `Invalid DoenetML: Found closing tag \`${extractContent(
            node2,
            source
          )}\`, but no corresponding opening tag`;
          return [
            {
              type: "error",
              message: message2,
              position: lezerNodeToPosition(node2, offsetMap)
            }
          ];
        }
        const tagNameTag = openTag.getChild(TagName$y);
        const openTagName = tagNameTag ? extractContent(tagNameTag, source) : "";
        const message = `Invalid DoenetML: Mismatched closing tag. Expected \`</${openTagName}>\`. Found \`${extractContent(
          node2,
          source
        )}\``;
        return [
          {
            type: "error",
            message,
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "MissingCloseTag":
      case "⚠":
        return [];
      default:
        const unhandledName = name2;
        console.log(
          `Encountered Lezer node of unknown type ${unhandledName}`
        );
    }
    return [];
  }
}
function reprocessTextForMacros(textNode, offsetToPositionMap) {
  if (!textNode.value.includes("$")) {
    return [textNode];
  }
  const parsed = parseMacros(textNode.value);
  const nodesToProcess = findNodesWithPositionInfo(parsed);
  nodesToProcess.forEach((n) => {
    updateNodePositionData(n, textNode, offsetToPositionMap);
  });
  return parsed;
}
const CONTINUE = Symbol("continue");
const SKIP = Symbol("skip");
const EXIT = Symbol("exit");
const DEFAULT_CONTEXT = {};
function visit(tree, visitor, options2) {
  const {
    startingContext = DEFAULT_CONTEXT,
    test = () => true,
    includeArrays = false
  } = {};
  let enter;
  let leave;
  if (typeof visitor === "function") {
    enter = visitor;
  } else if (visitor && typeof visitor === "object") {
    enter = visitor.enter;
    leave = visitor.leave;
  }
  walk(tree, {
    key: void 0,
    index: void 0,
    parents: [],
    containingArray: void 0,
    context: { ...startingContext }
  });
  function walk(node, { key, index: index2, parents, context, containingArray }) {
    const nodePassesTest = includeArrays ? test(node, { key, index: index2, parents, context, containingArray }) : !Array.isArray(node) && test(node, { key, index: index2, parents, context, containingArray });
    const result2 = enter && nodePassesTest ? toResult(
      enter(node, {
        key,
        index: index2,
        parents,
        context,
        containingArray
      })
    ) : [CONTINUE];
    if (result2[0] === EXIT) {
      return result2;
    }
    if (result2[0] === SKIP) {
      return leave && nodePassesTest ? toResult(
        leave(node, {
          key,
          index: index2,
          parents,
          context,
          containingArray
        })
      ) : result2;
    }
    if (Array.isArray(node)) {
      for (let index22 = 0; index22 > -1 && index22 < node.length; index22++) {
        const item = node[index22];
        const result22 = walk(item, {
          key,
          index: index22,
          parents,
          context,
          containingArray: node
        });
        if (result22[0] === EXIT) {
          return result22;
        }
        if (typeof result22[1] === "number") {
          index22 = result22[1] - 1;
        }
      }
    } else if (node.type === "function" && node.input) {
      for (let index22 = 0; index22 > -1 && index22 < node.input.length; index22++) {
        const item = node.input[index22];
        const result22 = walk(item, {
          key,
          index: index22,
          parents,
          context,
          // `node.input` is an array of arrays; the containing array should be, for example, `node.input[0]` so we set it to `undefined` here.
          containingArray: void 0
        });
        if (result22[0] === EXIT) {
          return result22;
        }
        if (typeof result22[1] === "number") {
          index22 = result22[1] - 1;
        }
      }
    } else {
      const key2 = "children";
      if (key2 in node) {
        const grandparents = node.type === "root" ? parents : [node, ...parents];
        const result22 = walk(node.children, {
          key: key2,
          index: void 0,
          parents: grandparents,
          context,
          containingArray: void 0
        });
        if (result22[0] === EXIT) {
          return result22;
        }
      }
    }
    return leave && nodePassesTest ? toResult(
      leave(node, {
        key,
        index: index2,
        parents,
        context,
        containingArray
      })
    ) : result2;
  }
}
function toResult(value) {
  if (value == null) {
    return [CONTINUE];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "number") {
    return [CONTINUE, value];
  }
  return [value];
}
function replaceNode(ast, visitor) {
  visit(ast, {
    leave: (node, info) => {
      let replacement = visitor(node, info);
      if (typeof replacement === "undefined" || replacement === node) {
        return;
      }
      if (!info.containingArray || info.index == null) {
        throw new Error(
          "Trying to replace node, but cannot find containing array"
        );
      }
      if (replacement === null || Array.isArray(replacement) && replacement.length === 0) {
        info.containingArray.splice(info.index, 1);
        return info.index;
      }
      if (!Array.isArray(replacement)) {
        replacement = [replacement];
      }
      info.containingArray.splice(info.index, 1, ...replacement);
      return info.index + replacement.length;
    }
  });
}
function bail$1(error) {
  if (error) {
    throw error;
  }
}
function getDefaultExportFromCjs$3(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var extend$1$2;
var hasRequiredExtend$1;
function requireExtend$1() {
  if (hasRequiredExtend$1) return extend$1$2;
  hasRequiredExtend$1 = 1;
  var hasOwn = Object.prototype.hasOwnProperty;
  var toStr = Object.prototype.toString;
  var defineProperty = Object.defineProperty;
  var gOPD = Object.getOwnPropertyDescriptor;
  var isArray2 = function isArray22(arr) {
    if (typeof Array.isArray === "function") {
      return Array.isArray(arr);
    }
    return toStr.call(arr) === "[object Array]";
  };
  var isPlainObject2 = function isPlainObject3(obj) {
    if (!obj || toStr.call(obj) !== "[object Object]") {
      return false;
    }
    var hasOwnConstructor = hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
      return false;
    }
    var key;
    for (key in obj) {
    }
    return typeof key === "undefined" || hasOwn.call(obj, key);
  };
  var setProperty2 = function setProperty22(target, options2) {
    if (defineProperty && options2.name === "__proto__") {
      defineProperty(target, options2.name, {
        enumerable: true,
        configurable: true,
        value: options2.newValue,
        writable: true
      });
    } else {
      target[options2.name] = options2.newValue;
    }
  };
  var getProperty = function getProperty2(obj, name2) {
    if (name2 === "__proto__") {
      if (!hasOwn.call(obj, name2)) {
        return void 0;
      } else if (gOPD) {
        return gOPD(obj, name2).value;
      }
    }
    return obj[name2];
  };
  extend$1$2 = function extend2() {
    var options2, name2, src, copy2, copyIsArray, clone2;
    var target = arguments[0];
    var i2 = 1;
    var length = arguments.length;
    var deep = false;
    if (typeof target === "boolean") {
      deep = target;
      target = arguments[1] || {};
      i2 = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") {
      target = {};
    }
    for (; i2 < length; ++i2) {
      options2 = arguments[i2];
      if (options2 != null) {
        for (name2 in options2) {
          src = getProperty(target, name2);
          copy2 = getProperty(options2, name2);
          if (target !== copy2) {
            if (deep && copy2 && (isPlainObject2(copy2) || (copyIsArray = isArray2(copy2)))) {
              if (copyIsArray) {
                copyIsArray = false;
                clone2 = src && isArray2(src) ? src : [];
              } else {
                clone2 = src && isPlainObject2(src) ? src : {};
              }
              setProperty2(target, { name: name2, newValue: extend2(deep, clone2, copy2) });
            } else if (typeof copy2 !== "undefined") {
              setProperty2(target, { name: name2, newValue: copy2 });
            }
          }
        }
      }
    }
    return target;
  };
  return extend$1$2;
}
var extendExports$1 = requireExtend$1();
const extend$4 = /* @__PURE__ */ getDefaultExportFromCjs$3(extendExports$1);
function isPlainObject$4(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}
function trough$1() {
  const fns = [];
  const pipeline = { run, use };
  return pipeline;
  function run(...values2) {
    let middlewareIndex = -1;
    const callback = values2.pop();
    if (typeof callback !== "function") {
      throw new TypeError("Expected function as last argument, not " + callback);
    }
    next(null, ...values2);
    function next(error, ...output) {
      const fn = fns[++middlewareIndex];
      let index2 = -1;
      if (error) {
        callback(error);
        return;
      }
      while (++index2 < values2.length) {
        if (output[index2] === null || output[index2] === void 0) {
          output[index2] = values2[index2];
        }
      }
      values2 = output;
      if (fn) {
        wrap$2(fn, next)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }
  function use(middelware) {
    if (typeof middelware !== "function") {
      throw new TypeError(
        "Expected `middelware` to be a function, not " + middelware
      );
    }
    fns.push(middelware);
    return pipeline;
  }
}
function wrap$2(middleware, callback) {
  let called;
  return wrapped;
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    let result2;
    if (fnExpectsCallback) {
      parameters.push(done);
    }
    try {
      result2 = middleware.apply(this, parameters);
    } catch (error) {
      const exception = (
        /** @type {Error} */
        error
      );
      if (fnExpectsCallback && called) {
        throw exception;
      }
      return done(exception);
    }
    if (!fnExpectsCallback) {
      if (result2 && result2.then && typeof result2.then === "function") {
        result2.then(then, done);
      } else if (result2 instanceof Error) {
        done(result2);
      } else {
        then(result2);
      }
    }
  }
  function done(error, ...output) {
    if (!called) {
      called = true;
      callback(error, ...output);
    }
  }
  function then(value) {
    done(null, value);
  }
}
function stringifyPosition$1(value) {
  if (!value || typeof value !== "object") {
    return "";
  }
  if ("position" in value || "type" in value) {
    return position$1(value.position);
  }
  if ("start" in value || "end" in value) {
    return position$1(value);
  }
  if ("line" in value || "column" in value) {
    return point$1(value);
  }
  return "";
}
function point$1(point2) {
  return index$1(point2 && point2.line) + ":" + index$1(point2 && point2.column);
}
function position$1(pos) {
  return point$1(pos && pos.start) + "-" + point$1(pos && pos.end);
}
function index$1(value) {
  return value && typeof value === "number" ? value : 1;
}
let VFileMessage$1 = class VFileMessage2 extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super();
    if (typeof optionsOrParentOrPlace === "string") {
      origin = optionsOrParentOrPlace;
      optionsOrParentOrPlace = void 0;
    }
    let reason = "";
    let options2 = {};
    let legacyCause = false;
    if (optionsOrParentOrPlace) {
      if ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace) {
        options2 = { place: optionsOrParentOrPlace };
      } else if ("start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace) {
        options2 = { place: optionsOrParentOrPlace };
      } else if ("type" in optionsOrParentOrPlace) {
        options2 = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        };
      } else {
        options2 = { ...optionsOrParentOrPlace };
      }
    }
    if (typeof causeOrReason === "string") {
      reason = causeOrReason;
    } else if (!options2.cause && causeOrReason) {
      legacyCause = true;
      reason = causeOrReason.message;
      options2.cause = causeOrReason;
    }
    if (!options2.ruleId && !options2.source && typeof origin === "string") {
      const index2 = origin.indexOf(":");
      if (index2 === -1) {
        options2.ruleId = origin;
      } else {
        options2.source = origin.slice(0, index2);
        options2.ruleId = origin.slice(index2 + 1);
      }
    }
    if (!options2.place && options2.ancestors && options2.ancestors) {
      const parent = options2.ancestors[options2.ancestors.length - 1];
      if (parent) {
        options2.place = parent.position;
      }
    }
    const start = options2.place && "start" in options2.place ? options2.place.start : options2.place;
    this.ancestors = options2.ancestors || void 0;
    this.cause = options2.cause || void 0;
    this.column = start ? start.column : void 0;
    this.fatal = void 0;
    this.file = "";
    this.message = reason;
    this.line = start ? start.line : void 0;
    this.name = stringifyPosition$1(options2.place) || "1:1";
    this.place = options2.place || void 0;
    this.reason = this.message;
    this.ruleId = options2.ruleId || void 0;
    this.source = options2.source || void 0;
    this.stack = legacyCause && options2.cause && typeof options2.cause.stack === "string" ? options2.cause.stack : "";
    this.actual = void 0;
    this.expected = void 0;
    this.note = void 0;
    this.url = void 0;
  }
};
VFileMessage$1.prototype.file = "";
VFileMessage$1.prototype.name = "";
VFileMessage$1.prototype.reason = "";
VFileMessage$1.prototype.message = "";
VFileMessage$1.prototype.stack = "";
VFileMessage$1.prototype.column = void 0;
VFileMessage$1.prototype.line = void 0;
VFileMessage$1.prototype.ancestors = void 0;
VFileMessage$1.prototype.cause = void 0;
VFileMessage$1.prototype.fatal = void 0;
VFileMessage$1.prototype.place = void 0;
VFileMessage$1.prototype.ruleId = void 0;
VFileMessage$1.prototype.source = void 0;
const minpath$1 = { basename: basename$1, dirname: dirname$1, extname: extname$1, join: join$4, sep: "/" };
function basename$1(path, extname2) {
  if (extname2 !== void 0 && typeof extname2 !== "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  assertPath$1$1(path);
  let start = 0;
  let end = -1;
  let index2 = path.length;
  let seenNonSlash;
  if (extname2 === void 0 || extname2.length === 0 || extname2.length > path.length) {
    while (index2--) {
      if (path.codePointAt(index2) === 47) {
        if (seenNonSlash) {
          start = index2 + 1;
          break;
        }
      } else if (end < 0) {
        seenNonSlash = true;
        end = index2 + 1;
      }
    }
    return end < 0 ? "" : path.slice(start, end);
  }
  if (extname2 === path) {
    return "";
  }
  let firstNonSlashEnd = -1;
  let extnameIndex = extname2.length - 1;
  while (index2--) {
    if (path.codePointAt(index2) === 47) {
      if (seenNonSlash) {
        start = index2 + 1;
        break;
      }
    } else {
      if (firstNonSlashEnd < 0) {
        seenNonSlash = true;
        firstNonSlashEnd = index2 + 1;
      }
      if (extnameIndex > -1) {
        if (path.codePointAt(index2) === extname2.codePointAt(extnameIndex--)) {
          if (extnameIndex < 0) {
            end = index2;
          }
        } else {
          extnameIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }
  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path.length;
  }
  return path.slice(start, end);
}
function dirname$1(path) {
  assertPath$1$1(path);
  if (path.length === 0) {
    return ".";
  }
  let end = -1;
  let index2 = path.length;
  let unmatchedSlash;
  while (--index2) {
    if (path.codePointAt(index2) === 47) {
      if (unmatchedSlash) {
        end = index2;
        break;
      }
    } else if (!unmatchedSlash) {
      unmatchedSlash = true;
    }
  }
  return end < 0 ? path.codePointAt(0) === 47 ? "/" : "." : end === 1 && path.codePointAt(0) === 47 ? "//" : path.slice(0, end);
}
function extname$1(path) {
  assertPath$1$1(path);
  let index2 = path.length;
  let end = -1;
  let startPart = 0;
  let startDot = -1;
  let preDotState = 0;
  let unmatchedSlash;
  while (index2--) {
    const code2 = path.codePointAt(index2);
    if (code2 === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    if (end < 0) {
      unmatchedSlash = true;
      end = index2 + 1;
    }
    if (code2 === 46) {
      if (startDot < 0) {
        startDot = index2;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      preDotState = -1;
    }
  }
  if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return "";
  }
  return path.slice(startDot, end);
}
function join$4(...segments) {
  let index2 = -1;
  let joined;
  while (++index2 < segments.length) {
    assertPath$1$1(segments[index2]);
    if (segments[index2]) {
      joined = joined === void 0 ? segments[index2] : joined + "/" + segments[index2];
    }
  }
  return joined === void 0 ? "." : normalize$2(joined);
}
function normalize$2(path) {
  assertPath$1$1(path);
  const absolute = path.codePointAt(0) === 47;
  let value = normalizeString$2(path, !absolute);
  if (value.length === 0 && !absolute) {
    value = ".";
  }
  if (value.length > 0 && path.codePointAt(path.length - 1) === 47) {
    value += "/";
  }
  return absolute ? "/" + value : value;
}
function normalizeString$2(path, allowAboveRoot) {
  let result2 = "";
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index2 = -1;
  let code2;
  let lastSlashIndex;
  while (++index2 <= path.length) {
    if (index2 < path.length) {
      code2 = path.codePointAt(index2);
    } else if (code2 === 47) {
      break;
    } else {
      code2 = 47;
    }
    if (code2 === 47) {
      if (lastSlash === index2 - 1 || dots === 1) ;
      else if (lastSlash !== index2 - 1 && dots === 2) {
        if (result2.length < 2 || lastSegmentLength !== 2 || result2.codePointAt(result2.length - 1) !== 46 || result2.codePointAt(result2.length - 2) !== 46) {
          if (result2.length > 2) {
            lastSlashIndex = result2.lastIndexOf("/");
            if (lastSlashIndex !== result2.length - 1) {
              if (lastSlashIndex < 0) {
                result2 = "";
                lastSegmentLength = 0;
              } else {
                result2 = result2.slice(0, lastSlashIndex);
                lastSegmentLength = result2.length - 1 - result2.lastIndexOf("/");
              }
              lastSlash = index2;
              dots = 0;
              continue;
            }
          } else if (result2.length > 0) {
            result2 = "";
            lastSegmentLength = 0;
            lastSlash = index2;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          result2 = result2.length > 0 ? result2 + "/.." : "..";
          lastSegmentLength = 2;
        }
      } else {
        if (result2.length > 0) {
          result2 += "/" + path.slice(lastSlash + 1, index2);
        } else {
          result2 = path.slice(lastSlash + 1, index2);
        }
        lastSegmentLength = index2 - lastSlash - 1;
      }
      lastSlash = index2;
      dots = 0;
    } else if (code2 === 46 && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }
  return result2;
}
function assertPath$1$1(path) {
  if (typeof path !== "string") {
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path)
    );
  }
}
const minproc$1 = { cwd: cwd$2 };
function cwd$2() {
  return "/";
}
function isUrl$1(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === void 0
  );
}
function urlToPath$1(path) {
  if (typeof path === "string") {
    path = new URL(path);
  } else if (!isUrl$1(path)) {
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + path + "`"
    );
    error.code = "ERR_INVALID_ARG_TYPE";
    throw error;
  }
  if (path.protocol !== "file:") {
    const error = new TypeError("The URL must be of scheme file");
    error.code = "ERR_INVALID_URL_SCHEME";
    throw error;
  }
  return getPathFromURLPosix$1(path);
}
function getPathFromURLPosix$1(url) {
  if (url.hostname !== "") {
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error.code = "ERR_INVALID_FILE_URL_HOST";
    throw error;
  }
  const pathname = url.pathname;
  let index2 = -1;
  while (++index2 < pathname.length) {
    if (pathname.codePointAt(index2) === 37 && pathname.codePointAt(index2 + 1) === 50) {
      const third = pathname.codePointAt(index2 + 2);
      if (third === 70 || third === 102) {
        const error = new TypeError(
          "File URL path must not include encoded / characters"
        );
        error.code = "ERR_INVALID_FILE_URL_PATH";
        throw error;
      }
    }
  }
  return decodeURIComponent(pathname);
}
const order$1 = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
let VFile$1 = class VFile2 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    let options2;
    if (!value) {
      options2 = {};
    } else if (isUrl$1(value)) {
      options2 = { path: value };
    } else if (typeof value === "string" || isUint8Array$1$1(value)) {
      options2 = { value };
    } else {
      options2 = value;
    }
    this.cwd = "cwd" in options2 ? "" : minproc$1.cwd();
    this.data = {};
    this.history = [];
    this.messages = [];
    this.value;
    this.map;
    this.result;
    this.stored;
    let index2 = -1;
    while (++index2 < order$1.length) {
      const field2 = order$1[index2];
      if (field2 in options2 && options2[field2] !== void 0 && options2[field2] !== null) {
        this[field2] = field2 === "history" ? [...options2[field2]] : options2[field2];
      }
    }
    let field;
    for (field in options2) {
      if (!order$1.includes(field)) {
        this[field] = options2[field];
      }
    }
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === "string" ? minpath$1.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename2) {
    assertNonEmpty$1(basename2, "basename");
    assertPart$1(basename2, "basename");
    this.path = minpath$1.join(this.dirname || "", basename2);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === "string" ? minpath$1.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname2) {
    assertPath$2(this.basename, "dirname");
    this.path = minpath$1.join(dirname2 || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === "string" ? minpath$1.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname2) {
    assertPart$1(extname2, "extname");
    assertPath$2(this.dirname, "extname");
    if (extname2) {
      if (extname2.codePointAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (extname2.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = minpath$1.join(this.dirname, this.stem + (extname2 || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path) {
    if (isUrl$1(path)) {
      path = urlToPath$1(path);
    }
    assertNonEmpty$1(path, "path");
    if (this.path !== path) {
      this.history.push(path);
    }
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === "string" ? minpath$1.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty$1(stem, "stem");
    assertPart$1(stem, "stem");
    this.path = minpath$1.join(this.dirname || "", stem + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = true;
    throw message;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = void 0;
    return message;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new VFileMessage$1(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    );
    if (this.path) {
      message.name = this.path + ":" + message.name;
      message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === void 0) {
      return "";
    }
    if (typeof this.value === "string") {
      return this.value;
    }
    const decoder = new TextDecoder(encoding || void 0);
    return decoder.decode(this.value);
  }
};
function assertPart$1(part, name2) {
  if (part && part.includes(minpath$1.sep)) {
    throw new Error(
      "`" + name2 + "` cannot be a path: did not expect `" + minpath$1.sep + "`"
    );
  }
}
function assertNonEmpty$1(part, name2) {
  if (!part) {
    throw new Error("`" + name2 + "` cannot be empty");
  }
}
function assertPath$2(path, name2) {
  if (!path) {
    throw new Error("Setting `" + name2 + "` requires `path` to be set too");
  }
}
function isUint8Array$1$1(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const CallableInstance$1 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(property2) {
    const self2 = this;
    const constr = self2.constructor;
    const proto = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      constr.prototype
    );
    const value = proto[property2];
    const apply = function() {
      return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    return apply;
  })
);
const own$1 = {}.hasOwnProperty;
let Processor$1 = class Processor2 extends CallableInstance$1 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy");
    this.Compiler = void 0;
    this.Parser = void 0;
    this.attachers = [];
    this.compiler = void 0;
    this.freezeIndex = -1;
    this.frozen = void 0;
    this.namespace = {};
    this.parser = void 0;
    this.transformers = trough$1();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const destination = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor2()
    );
    let index2 = -1;
    while (++index2 < this.attachers.length) {
      const attacher = this.attachers[index2];
      destination.use(...attacher);
    }
    destination.data(extend$4(true, {}, this.namespace));
    return destination;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    if (typeof key === "string") {
      if (arguments.length === 2) {
        assertUnfrozen$1("data", this.frozen);
        this.namespace[key] = value;
        return this;
      }
      return own$1.call(this.namespace, key) && this.namespace[key] || void 0;
    }
    if (key) {
      assertUnfrozen$1("data", this.frozen);
      this.namespace = key;
      return this;
    }
    return this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this;
    }
    const self2 = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options2] = this.attachers[this.freezeIndex];
      if (options2[0] === false) {
        continue;
      }
      if (options2[0] === true) {
        options2[0] = void 0;
      }
      const transformer = attacher.call(self2, ...options2);
      if (typeof transformer === "function") {
        this.transformers.use(transformer);
      }
    }
    this.frozen = true;
    this.freezeIndex = Number.POSITIVE_INFINITY;
    return this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile$1(file);
    const parser2 = this.parser || this.Parser;
    assertParser$1("parse", parser2);
    return parser2(String(realFile), realFile);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self2 = this;
    this.freeze();
    assertParser$1("process", this.parser || this.Parser);
    assertCompiler$1("process", this.compiler || this.Compiler);
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject2) {
      const realFile = vfile$1(file);
      const parseTree = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        self2.parse(realFile)
      );
      self2.run(parseTree, realFile, function(error, tree, file2) {
        if (error || !tree || !file2) {
          return realDone(error);
        }
        const compileTree = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          tree
        );
        const compileResult = self2.stringify(compileTree, file2);
        if (looksLikeAValue$1(compileResult)) {
          file2.value = compileResult;
        } else {
          file2.result = compileResult;
        }
        realDone(
          error,
          /** @type {VFileWithOutput<CompileResult>} */
          file2
        );
      });
      function realDone(error, file2) {
        if (error || !file2) {
          reject2(error);
        } else if (resolve) {
          resolve(file2);
        } else {
          done(void 0, file2);
        }
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    let complete = false;
    let result2;
    this.freeze();
    assertParser$1("processSync", this.parser || this.Parser);
    assertCompiler$1("processSync", this.compiler || this.Compiler);
    this.process(file, realDone);
    assertDone$1("processSync", "process", complete);
    return result2;
    function realDone(error, file2) {
      complete = true;
      bail$1(error);
      result2 = file2;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode$1(tree);
    this.freeze();
    const transformers = this.transformers;
    if (!done && typeof file === "function") {
      done = file;
      file = void 0;
    }
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject2) {
      const realFile = vfile$1(file);
      transformers.run(tree, realFile, realDone);
      function realDone(error, outputTree, file2) {
        const resultingTree = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          outputTree || tree
        );
        if (error) {
          reject2(error);
        } else if (resolve) {
          resolve(resultingTree);
        } else {
          done(void 0, resultingTree, file2);
        }
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    let complete = false;
    let result2;
    this.run(tree, file, realDone);
    assertDone$1("runSync", "run", complete);
    return result2;
    function realDone(error, tree2) {
      bail$1(error);
      result2 = tree2;
      complete = true;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile$1(file);
    const compiler = this.compiler || this.Compiler;
    assertCompiler$1("stringify", compiler);
    assertNode$1(tree);
    return compiler(tree, realFile);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers;
    const namespace = this.namespace;
    assertUnfrozen$1("use", this.frozen);
    if (value === null || value === void 0) ;
    else if (typeof value === "function") {
      addPlugin(value, parameters);
    } else if (typeof value === "object") {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError("Expected usable value, not `" + value + "`");
    }
    return this;
    function add2(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2, []);
      } else if (typeof value2 === "object") {
        if (Array.isArray(value2)) {
          const [plugin, ...parameters2] = (
            /** @type {PluginTuple<Array<unknown>>} */
            value2
          );
          addPlugin(plugin, parameters2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + value2 + "`");
      }
    }
    function addPreset(result2) {
      if (!("plugins" in result2) && !("settings" in result2)) {
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      }
      addList(result2.plugins);
      if (result2.settings) {
        namespace.settings = extend$4(true, namespace.settings, result2.settings);
      }
    }
    function addList(plugins2) {
      let index2 = -1;
      if (plugins2 === null || plugins2 === void 0) ;
      else if (Array.isArray(plugins2)) {
        while (++index2 < plugins2.length) {
          const thing = plugins2[index2];
          add2(thing);
        }
      } else {
        throw new TypeError("Expected a list of plugins, not `" + plugins2 + "`");
      }
    }
    function addPlugin(plugin, parameters2) {
      let index2 = -1;
      let entryIndex = -1;
      while (++index2 < attachers.length) {
        if (attachers[index2][0] === plugin) {
          entryIndex = index2;
          break;
        }
      }
      if (entryIndex === -1) {
        attachers.push([plugin, ...parameters2]);
      } else if (parameters2.length > 0) {
        let [primary, ...rest2] = parameters2;
        const currentPrimary = attachers[entryIndex][1];
        if (isPlainObject$4(currentPrimary) && isPlainObject$4(primary)) {
          primary = extend$4(true, currentPrimary, primary);
        }
        attachers[entryIndex] = [plugin, primary, ...rest2];
      }
    }
  }
};
const unified = new Processor$1().freeze();
function assertParser$1(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `parser`");
  }
}
function assertCompiler$1(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `compiler`");
  }
}
function assertUnfrozen$1(name2, frozen) {
  if (frozen) {
    throw new Error(
      "Cannot call `" + name2 + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
  }
}
function assertNode$1(node) {
  if (!isPlainObject$4(node) || typeof node.type !== "string") {
    throw new TypeError("Expected node, got `" + node + "`");
  }
}
function assertDone$1(name2, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name2 + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
function vfile$1(value) {
  return looksLikeAVFile$1(value) ? value : new VFile$1(value);
}
function looksLikeAVFile$1(value) {
  return Boolean(
    value && typeof value === "object" && "message" in value && "messages" in value
  );
}
function looksLikeAValue$1(value) {
  return typeof value === "string" || isUint8Array$2(value);
}
function isUint8Array$2(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const isDastElement = (rootContent) => rootContent && typeof rootContent === "object" && rootContent.type === "element";
const ELEMENT_EXPANSIONS = {
  chapter: {
    to: "division",
    attributes: {
      type: "chapter"
    }
  },
  part: {
    to: "division",
    attributes: {
      type: "part"
    }
  },
  section: {
    to: "division",
    attributes: {
      type: "section"
    }
  },
  subsection: {
    to: "division",
    attributes: {
      type: "subsection"
    }
  },
  subsubsection: {
    to: "division",
    attributes: {
      type: "subsubsection"
    }
  },
  paragraphs: {
    to: "division",
    attributes: {
      type: "paragraphs"
    }
  }
};
const pluginConvertPretextAttributes = () => {
  return (tree) => {
    visit(tree, (node) => {
      if (!isDastElement(node)) {
        return;
      }
      if (node.attributes["xml:id"]) {
        const attr = node.attributes["xml:id"];
        attr.name = "name";
        delete node.attributes["xml:id"];
        node.attributes.name = attr;
      }
      if (node.name === "xref") {
        const refAttr = node.attributes.ref;
        if (!refAttr) {
          return;
        }
        const hasMacroChild = refAttr.children.some(
          (child) => child.type === "macro"
        );
        const hasNonWhitespaceTextChild = refAttr.children.some(
          (child) => child.type === "text" && child.value.trim() !== ""
        );
        if (hasMacroChild || !hasNonWhitespaceTextChild) {
          return;
        }
        const refText = refAttr.children.map((child) => child.type === "text" ? child.value : "").join("");
        refAttr.position;
        let macro = {
          type: "macro",
          attributes: {},
          path: [
            {
              type: "pathPart",
              index: [],
              name: refText
            }
          ]
        };
        refAttr.children.length = 0;
        refAttr.children.push(macro);
      }
    });
  };
};
function groupTextAndReferencesBySpacesOutsideParens({
  children,
  componentType,
  wrapSingleNonTextNodes = true
}) {
  for (const child of children) {
    if (!["text", "macro", "function"].includes(child.type)) {
      return { success: false };
    }
  }
  const newChildren = [];
  let currentGroup = [];
  let nParens = 0;
  for (const child of children) {
    switch (child.type) {
      case "macro":
      case "function":
        currentGroup.push(child);
        continue;
      case "text":
        const splitNodes = splitAtParensOrSpace(child);
        let currentText = "";
        let currentTextStartPos = splitNodes[0]?.position?.start;
        for (const node of splitNodes) {
          if (node.value === "(") {
            currentText += node.value;
            nParens++;
          } else if (node.value === ")") {
            if (nParens === 0) {
              return { success: false };
            } else {
              currentText += node.value;
              nParens--;
            }
          } else if (nParens === 0 && node.value.match(/\s/)) {
            if (currentText.length > 0) {
              currentGroup.push(
                createNewTextNode(
                  currentText,
                  currentTextStartPos,
                  child.source_doc
                )
              );
            }
            if (currentGroup.length > 0) {
              newChildren.push(
                createElementFromChildren(
                  componentType,
                  currentGroup,
                  wrapSingleNonTextNodes,
                  child.source_doc
                )
              );
              currentGroup = [];
            }
            currentText = "";
            currentTextStartPos = node.position?.end;
          } else {
            currentText += node.value;
          }
        }
        if (currentText.length > 0) {
          currentGroup.push(
            createNewTextNode(
              currentText,
              currentTextStartPos,
              child.source_doc
            )
          );
        }
        break;
      default:
        throw Error("Unreachable");
    }
  }
  if (nParens > 0) {
    return { success: false };
  }
  if (currentGroup.length > 0) {
    newChildren.push(
      createElementFromChildren(
        componentType,
        currentGroup,
        wrapSingleNonTextNodes
      )
    );
  }
  return { success: true, newChildren };
}
function createElementFromChildren(name2, children, wrapSingleNonTextNodes, source_doc) {
  if (!wrapSingleNonTextNodes && children.length === 1 && children[0].type !== "text") {
    return children[0];
  }
  const newChild = {
    type: "element",
    name: name2,
    children,
    attributes: {},
    source_doc
  };
  const startPos = children[0].position?.start;
  const endPos = children[children.length - 1].position?.end;
  if (startPos && endPos) {
    newChild.position = {
      start: startPos,
      end: endPos
    };
  }
  return newChild;
}
function createNewTextNode(text2, startPos, source_doc) {
  const newNode = {
    type: "text",
    value: text2,
    source_doc
  };
  if (startPos) {
    newNode.position = {
      start: startPos,
      end: computeEndPosition(text2, startPos)
    };
  }
  return newNode;
}
function splitAtParensOrSpace(node) {
  let startPos = node.position.start;
  const splitText = [];
  for (const match2 of node.value.matchAll(/([()]|\s+|[^()\s]+)/g)) {
    const newNode = {
      type: "text",
      value: match2[0],
      source_doc: node.source_doc
    };
    if (startPos) {
      newNode.position = {
        start: startPos,
        end: computeEndPosition(match2[0], startPos)
      };
      startPos = newNode.position.end;
    }
    splitText.push(newNode);
  }
  return splitText;
}
function computeEndPosition(text2, startPos) {
  const byLines = text2.split("\n");
  const endPos = {
    line: startPos.line + byLines.length - 1,
    column: startPos.column + byLines[byLines.length - 1].length
  };
  if (startPos.offset != void 0) {
    endPos.offset = startPos.offset + text2.length;
  }
  return endPos;
}
function repeatSugar(node) {
  if (node.name !== "repeat" && node.name !== "repeatForSequence") {
    throw Error(
      "Repeat sugar can only be applied to a `<repeat>` or a `<repeatForSequence>`"
    );
  }
  let setupChildren = [];
  if (node.attributes.valueName) {
    const attrChildren = node.attributes.valueName.children;
    if (attrChildren.length === 1 && attrChildren[0].type === "text") {
      setupChildren.push({
        type: "element",
        name: "_placeholder",
        children: [],
        attributes: {
          name: {
            type: "attribute",
            name: "name",
            children: [
              { type: "text", value: attrChildren[0].value }
            ]
          }
        },
        source_doc: node.source_doc
      });
    }
  }
  if (node.attributes.indexName) {
    const attrChildren = node.attributes.indexName.children;
    if (attrChildren.length === 1 && attrChildren[0].type === "text") {
      setupChildren.push({
        type: "element",
        name: "integer",
        children: [],
        attributes: {
          name: {
            type: "attribute",
            name: "name",
            children: [
              { type: "text", value: attrChildren[0].value }
            ]
          }
        },
        source_doc: node.source_doc
      });
    }
  }
  if (setupChildren.length > 0) {
    node.children.push({
      type: "element",
      name: "_repeatSetup",
      children: setupChildren,
      attributes: {},
      source_doc: node.source_doc
    });
  }
  if (node.name === "repeat") {
    let type = "math";
    if (node.attributes.type) {
      const attrChildren = node.attributes.type.children;
      if (attrChildren.length === 1 && attrChildren[0].type === "text") {
        type = attrChildren[0].value;
        if (!["math", "text", "number", "boolean"].includes(type)) {
          type = "math";
        }
      }
    }
    if (node.attributes.for) {
      const attrChildren = node.attributes.for.children;
      const groupResult = groupTextAndReferencesBySpacesOutsideParens({
        children: attrChildren,
        componentType: type,
        wrapSingleNonTextNodes: false
      });
      if (groupResult.success) {
        node.attributes.for.children = groupResult.newChildren;
      }
    }
  }
}
function conditionalContentSugar(node) {
  if (node.name !== "conditionalContent") {
    throw Error(
      "Conditional content sugar can only be applied to a `<conditionalContent>`"
    );
  }
  let nCaseChildren = 0;
  for (const child of node.children) {
    if (!isDastElement(child)) {
      continue;
    }
    if (child.name === "case") {
      nCaseChildren++;
    } else if (child.name === "else") {
      child.name = "case";
      nCaseChildren++;
    }
  }
  if (nCaseChildren === 0) {
    const attributes = {};
    node.children = [
      {
        type: "element",
        name: "case",
        children: node.children,
        attributes,
        source_doc: node.source_doc
      }
    ];
    if (node.attributes.condition) {
      attributes.condition = node.attributes.condition;
      delete node.attributes.condition;
    }
  }
}
function selectSugar(node) {
  if (node.name !== "select") {
    throw Error("Select sugar can only be applied to a `<select>`");
  }
  let insertType = "math";
  if (node.attributes.type) {
    const children = node.attributes.type.children;
    if (children.length === 1 && children[0].type === "text") {
      insertType = children[0].value;
      if (!["math", "text", "number", "boolean"].includes(insertType)) {
        insertType = "math";
      }
    }
  }
  const groupResult = groupTextAndReferencesBySpacesOutsideParens({
    children: node.children,
    componentType: insertType
  });
  if (groupResult.success) {
    let newChildren = groupResult.newChildren.map(
      (child) => ({
        type: "element",
        name: "option",
        children: [child],
        attributes: {},
        source_doc: child.source_doc
      })
    );
    node.children = newChildren;
  }
}
function postponeRenderSugar(node) {
  if (!["solution", "givenAnswer", "aside", "proof"].includes(node.name)) {
    throw Error(
      "Postpone render sugar can only be applied to a `<solution>`, `<givenAnswer>`, `<aside>`, or `<proof>`"
    );
  }
  const titleChildren = [];
  const postponedChildren = [];
  for (const child of node.children) {
    if (child.type === "element" && child.name === "title") {
      titleChildren.push(child);
    } else {
      postponedChildren.push(child);
    }
  }
  node.children = [
    ...titleChildren,
    {
      type: "element",
      name: "_postponeRenderContainer",
      children: postponedChildren,
      attributes: {},
      source_doc: node.source_doc
    }
  ];
}
function startsWithNonLetter(str) {
  return typeof str === "string" && !str.charAt(0).match(/[a-zA-Z]/);
}
function containsInvalidNameCharacters(str) {
  return typeof str === "string" && !str.match(/^[a-zA-Z0-9-_]+$/);
}
const pluginEnforceValidNames = () => {
  return (tree) => {
    visit(tree, (node, info) => {
      if (!isDastElement(node)) {
        return;
      }
      if (startsWithNonLetter(node.name) && node.name !== "_error") {
        const name2 = node.name;
        const dastError = {
          type: "error",
          message: `Invalid component name "${name2}". Names must start with a letter.`,
          position: node.position
        };
        if (info.index !== void 0 && info.parents[0]) {
          info.parents[0].children.splice(info.index, 1, dastError);
        } else {
          console.warn(
            "No index found for error element, appending to root."
          );
          tree.children.push(dastError);
        }
      }
      if (node.attributes.name) {
        const name2 = toXml(node.attributes.name.children);
        const nonLetter = startsWithNonLetter(name2);
        const invalidChar = containsInvalidNameCharacters(name2);
        if (nonLetter || invalidChar) {
          const message = `Invalid attribute name='${name2}'. ${nonLetter ? "Names must start with a letter." : "Names can contain only letters, numbers, underscores or hyphens."}`;
          const dastError = {
            type: "error",
            message,
            position: node.attributes.name?.position
          };
          delete node.attributes.name;
          if (info.index !== void 0 && info.parents[0]) {
            info.parents[0].children.splice(
              info.index + 1,
              0,
              dastError
            );
          } else {
            console.warn(
              "No index found for error element, appending to root."
            );
            tree.children.push(dastError);
          }
        }
      }
    });
  };
};
function pretzelSugar(node) {
  if (node.name !== "pretzel") {
    throw Error("Pretzel sugar can only be applied to a `<pretzel>`");
  }
  node.children = [
    {
      type: "element",
      name: "_pretzelArranger",
      children: node.children,
      attributes: {},
      source_doc: node.source_doc,
      position: node.position
    }
  ];
}
function normalizeDocumentDast(dast, addCompatibilityNames = false) {
  let processor = unified().use(pluginRemoveCommentsInstructionsAndDocStrings).use(pluginChangeCdataToText).use(pluginEnsureDocumentElement).use(pluginConvertPretextAttributes).use(pluginEnforceValidNames).use(pluginExpandAliasedElements);
  if (addCompatibilityNames) {
    processor = processor.use(pluginAddCompatibilityNames);
  }
  processor = processor.use(pluginComponentSugar);
  return processor.runSync(dast);
}
const pluginChangeCdataToText = () => {
  return (tree) => {
    visit(tree, (node) => {
      if (node.type === "cdata") {
        node.type = "text";
      }
    });
  };
};
const pluginRemoveCommentsInstructionsAndDocStrings = () => {
  return (tree) => {
    visit(tree, (node) => {
      if (node.type === "element" || node.type === "root") {
        node.children = node.children.filter(
          (n) => n.type !== "comment" && n.type !== "instruction" && n.type !== "doctype"
        );
      }
    });
  };
};
const pluginEnsureDocumentElement = () => {
  return (tree) => {
    const existingDocument = tree.children.find(
      (n) => n.type === "element" && n.name === "document"
    );
    if (existingDocument) {
      existingDocument.children = trimWhitespaceNodes(
        existingDocument.children
      );
      if (tree.children.length > 1) {
        tree.children = [existingDocument];
      }
    } else {
      const children = trimWhitespaceNodes(
        // This filtering may be redundant, but it should also be very fast.
        filterNonDoenetXml(tree.children)
      );
      tree.children = [
        {
          type: "element",
          name: "document",
          attributes: {},
          children
        }
      ];
    }
  };
};
const pluginExpandAliasedElements = () => {
  return (tree) => {
    visit(tree, (node) => {
      if (isDastElement(node)) {
        const expansion = ELEMENT_EXPANSIONS[node.name];
        if (expansion) {
          let newAttributes = Object.fromEntries(
            Object.entries(expansion.attributes || {}).map(
              ([key, value]) => {
                let newAttr = {
                  type: "attribute",
                  name: key,
                  children: [{ type: "text", value }]
                };
                return [key, newAttr];
              }
            )
          );
          node.name = expansion.to;
          node.attributes = {
            ...node.attributes,
            ...newAttributes
          };
        }
      }
    });
  };
};
const pluginAddCompatibilityNames = () => {
  const counts = {};
  return (tree) => {
    visit(tree, (node) => {
      if (isDastElement(node)) {
        const typeCount = counts[node.name] = (counts[node.name] ?? 0) + 1;
        if (!node.attributes.name) {
          const name2 = `_${node.name}${typeCount}`;
          node.attributes.name = {
            type: "attribute",
            name: "name",
            children: [{ type: "text", value: name2 }]
          };
        }
      }
    });
  };
};
const pluginComponentSugar = () => {
  return (tree) => {
    visit(tree, (node) => {
      if (!isDastElement(node)) {
        return;
      }
      switch (node.name) {
        case "repeat":
        case "repeatForSequence":
          repeatSugar(node);
          break;
        case "conditionalContent":
          conditionalContentSugar(node);
          break;
        case "select":
          selectSugar(node);
          break;
        case "solution":
        case "givenAnswer":
          postponeRenderSugar(node);
          break;
        case "aside":
        case "proof":
          if (node.attributes.postponeRendering) {
            const children = node.attributes.postponeRendering.children;
            if (children.length === 0 || children.length === 1 && children[0].type === "text" && children[0].value.toLowerCase() === "true") {
              postponeRenderSugar(node);
            }
          }
          break;
        case "pretzel":
          pretzelSugar(node);
          break;
      }
    });
  };
};
function filterNonDoenetXml(nodes) {
  return nodes.filter(
    (n) => n.type !== "doctype" && n.type !== "instruction"
  );
}
function trimWhitespaceNodes(nodes) {
  if (nodes.length === 0) {
    return nodes;
  }
  const firstNonWhitespaceIdx = nodes.findIndex(
    (n) => n.type !== "text" || /\S/.test(n.value)
  );
  if (firstNonWhitespaceIdx === -1) {
    return [];
  }
  const lastNonWhitespaceIdx = findLastIndex$1(
    nodes,
    (n) => n.type !== "text" || /\S/.test(n.value)
  );
  const trimmed = nodes.slice(
    firstNonWhitespaceIdx,
    lastNonWhitespaceIdx + 1
  );
  const first2 = trimmed[0];
  const last2 = trimmed[trimmed.length - 1];
  if (first2?.type === "text" && /^\s/.test(first2.value)) {
    trimmed[0] = {
      ...first2,
      value: first2.value.trimStart()
    };
  }
  if (last2?.type === "text" && /\s$/.test(last2.value)) {
    trimmed[trimmed.length - 1] = {
      ...last2,
      value: last2.value.trimEnd()
    };
  }
  return trimmed;
}
function findLastIndex$1(arr, predicate) {
  for (let i2 = arr.length - 1; i2 >= 0; i2--) {
    if (predicate(arr[i2])) {
      return i2;
    }
  }
  return -1;
}
async function expandExternalReferences(dast, fetchExternalDoenetML) {
  const pluginSubstituteExternalReferences = () => {
    return async (tree) => {
      const promiseStack = [];
      let maxRecursion = 10;
      let counter2 = 0;
      const findExternalReferenceAttribute = (node) => {
        if (!isDastElement(node)) {
          return;
        }
        const sourceAttributeName = Object.keys(node.attributes).find(
          (attrName) => ["extend", "copy"].includes(attrName.toLowerCase())
        );
        if (sourceAttributeName === void 0) {
          return;
        }
        const sourceAttribute = node.attributes[sourceAttributeName];
        const sourceUri = toXml(sourceAttribute.children);
        if (!sourceUri.startsWith("doenet:")) {
          return;
        }
        promiseStack.push({
          sourceUri,
          source: fetchExternalDoenetML(sourceUri),
          parent: node,
          sourceAttribute,
          recursionLevel: counter2
        });
      };
      visit(tree, findExternalReferenceAttribute);
      let unresolved;
      while (unresolved = promiseStack.pop()) {
        const parent = unresolved.parent;
        if (unresolved.recursionLevel > maxRecursion) {
          const dastError = {
            type: "error",
            message: `Unable to retrieve external DoenetML due to too many levels of recursion. Is there a circular reference?`,
            position: unresolved.sourceAttribute.position
          };
          parent.children.unshift(dastError);
          continue;
        }
        let externalDoenetML;
        try {
          externalDoenetML = await unresolved.source;
        } catch (e2) {
          console.error(e2);
          const dastError = {
            type: "error",
            message: `Unable to retrieve DoenetML from ${unresolved.sourceAttribute.name}="${unresolved.sourceUri}"`,
            position: unresolved.sourceAttribute.position
          };
          parent.children.unshift(dastError);
          continue;
        }
        const externalDast = lezerToDast(externalDoenetML);
        const matchResult = findMatchingChild(
          externalDast,
          parent.name
        );
        if (!matchResult.success) {
          const dastError = {
            type: "error",
            message: `Invalid DoenetML retrieved from ${unresolved.sourceAttribute.name}="${unresolved.sourceUri}": it did not match the component type "${parent.name}"`,
            position: unresolved.sourceAttribute.position
          };
          parent.children.unshift(dastError);
          continue;
        }
        const child = matchResult.child;
        if (!dast.sources) {
          dast.sources = [""];
        }
        const source_doc = dast.sources.length;
        dast.sources.push(externalDoenetML);
        for (const attrName in parent.attributes) {
          if (["extend", "copy"].includes(attrName.toLowerCase())) {
            delete parent.attributes[attrName];
          }
        }
        counter2 = unresolved.recursionLevel + 1;
        mergeExternalChildIntoParent(
          parent,
          child,
          source_doc,
          findExternalReferenceAttribute
        );
      }
    };
  };
  let processor = unified().use(pluginSubstituteExternalReferences);
  return await processor.run(dast);
}
function mergeExternalChildIntoParent(parent, child, source_doc, findExternalReferenceAttribute) {
  const addDocSource = (node) => {
    node.source_doc = source_doc;
    switch (node.type) {
      case "element":
        for (const attrName in node.attributes) {
          const attribute = node.attributes[attrName];
          attribute.source_doc = source_doc;
          for (const attrChild of attribute.children) {
            visit(attrChild, addDocSource);
          }
        }
        break;
      case "macro":
      case "function":
        for (const path of node.path) {
          path.source_doc = source_doc;
          for (const index2 of path.index) {
            index2.source_doc = source_doc;
            for (const value of index2.value) {
              visit(value, addDocSource);
            }
          }
        }
        break;
    }
  };
  visit(child, addDocSource);
  const parentAttributes = { ...child.attributes };
  if (parentAttributes.name) {
    const annotated_name = `source-${source_doc}:name`;
    parentAttributes[annotated_name] = parentAttributes.name;
    parentAttributes[annotated_name].name = annotated_name;
    delete parentAttributes.name;
  }
  Object.assign(parentAttributes, parent.attributes);
  parent.attributes = parentAttributes;
  if (!parent.attributes[`source:sequence`]) {
    parent.attributes[`source:sequence`] = {
      type: "attribute",
      name: "source:sequence",
      children: [
        {
          type: "text",
          value: parent.source_doc?.toString() ?? "0"
        }
      ]
    };
  }
  parent.attributes["source:sequence"].children.push({
    type: "text",
    value: source_doc.toString()
  });
  findExternalReferenceAttribute(parent);
  for (const newChild of child.children) {
    visit(newChild, findExternalReferenceAttribute);
  }
  parent.children.unshift(...child.children);
}
function findMatchingChild(dastRoot, elementName) {
  const rootChildren = dastRoot.children.filter(
    (node) => node.type !== "text" || node.value.trim() !== ""
  );
  if (rootChildren.length === 1 && isDastElement(rootChildren[0])) {
    let child = rootChildren[0];
    if (child.name === elementName) {
      return { success: true, child };
    }
    if (child.name === "document") {
      const documentChildren = child.children.filter(
        (node) => node.type !== "text" || node.value.trim() !== ""
      );
      if (documentChildren.length === 1 && isDastElement(documentChildren[0])) {
        child = documentChildren[0];
        if (child.name === elementName) {
          return { success: true, child };
        }
      }
    }
  }
  return { success: false };
}
function createCoreWorker() {
  const worker = new Worker(doenetGlobalConfig.doenetWorkerUrl, {
    type: "classic"
  });
  return wrap$3(worker);
}
async function initializeCoreWorker({
  coreWorker,
  doenetML,
  flags,
  activityId,
  docId,
  requestedVariantIndex,
  attemptNumber,
  documentStructureCallback,
  fetchExternalDoenetML
}) {
  let dast = lezerToDast(doenetML);
  if (fetchExternalDoenetML) {
    dast = await expandExternalReferences(dast, fetchExternalDoenetML);
  }
  dast = normalizeDocumentDast(dast, true);
  await coreWorker.setCoreType("javascript");
  await coreWorker.setSource({ source: doenetML, dast });
  await coreWorker.setFlags({ flags });
  const result2 = await coreWorker.initializeJavascriptCore({
    activityId,
    docId,
    requestedVariantIndex,
    attemptNumber
  });
  if (result2.success) {
    documentStructureCallback?.({
      activityId,
      docId,
      args: {
        allPossibleVariants: result2.allPossibleVariants,
        baseComponentCounts: result2.baseComponentCounts
      }
    });
  }
  return result2;
}
function formatProdErrorMessage$1(code2) {
  return `Minified Redux error #${code2}; visit https://redux.js.org/Errors?code=${code2} for the full message or use the non-minified dev environment for full errors. `;
}
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
function isPlainObject$3(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
function miniKindOf(val) {
  if (val === void 0)
    return "undefined";
  if (val === null)
    return "null";
  const type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val))
    return "array";
  if (isDate$2(val))
    return "date";
  if (isError$1(val))
    return "error";
  const constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError$1(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate$2(val) {
  if (val instanceof Date)
    return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  let typeOfVal = typeof val;
  if (process.env.NODE_ENV !== "production") {
    typeOfVal = miniKindOf(val);
  }
  return typeOfVal;
}
function createStore$3(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(2) : `Expected the root reducer to be a function. Instead, received: '${kindOf(reducer)}'`);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(1) : `Expected the enhancer to be a function. Instead, received: '${kindOf(enhancer)}'`);
    }
    return enhancer(createStore$3)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    }
    return currentState;
  }
  function subscribe2(listener) {
    if (typeof listener !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(4) : `Expected the listener to be a function. Instead, received: '${kindOf(listener)}'`);
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$3(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(7) : `Actions must be plain objects. Instead, the actual type was: '${kindOf(action)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    }
    if (typeof action.type === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }
    if (typeof action.type !== "string") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(17) : `Action "type" property must be a string. Instead, the actual type was: '${kindOf(action.type)}'. Value was: '${action.type}' (stringified)`);
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(9) : "Reducers may not dispatch actions.");
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(10) : `Expected the nextReducer to be a function. Instead, received: '${kindOf(nextReducer)}`);
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe2;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(11) : `Expected the observer to be an object. Instead, received: '${kindOf(observer)}'`);
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store2 = {
    dispatch,
    subscribe: subscribe2,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store2;
}
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e2) {
  }
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  const reducerKeys = Object.keys(reducers);
  const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (reducerKeys.length === 0) {
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  }
  if (!isPlainObject$3(inputState)) {
    return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
  }
  const unexpectedKeys = Object.keys(inputState).filter((key) => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
  unexpectedKeys.forEach((key) => {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === actionTypes_default.REPLACE)
    return;
  if (unexpectedKeys.length > 0) {
    return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState2 = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState2 === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(12) : `The slice reducer for key "${key}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(13) : `The slice reducer for key "${key}" returned undefined when probed with a random type. Don't try to handle '${actionTypes_default.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i2 = 0; i2 < reducerKeys.length; i2++) {
    const key = reducerKeys[i2];
    if (process.env.NODE_ENV !== "production") {
      if (typeof reducers[key] === "undefined") {
        warning(`No reducer provided for key "${key}"`);
      }
    }
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let unexpectedKeyCache;
  if (process.env.NODE_ENV !== "production") {
    unexpectedKeyCache = {};
  }
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e2) {
    shapeAssertionError = e2;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (process.env.NODE_ENV !== "production") {
      const warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }
    let hasChanged = false;
    const nextState = {};
    for (let i2 = 0; i2 < finalReducerKeys.length; i2++) {
      const key = finalReducerKeys[i2];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        const actionType = action && action.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(14) : `When called with an action of type ${actionType ? `"${String(actionType)}"` : "(unknown type)"}, the slice reducer for key "${key}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}
function compose$1(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b2) => (...args) => a(b2(...args)));
}
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store2 = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const middlewareAPI = {
      getState: store2.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain2 = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose$1(...chain2)(store2.dispatch);
    return {
      ...store2,
      dispatch
    };
  };
}
function isAction(action) {
  return isPlainObject$3(action) && "type" in action && typeof action.type === "string";
}
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
var errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(plugin) {
    return `The plugin for '${plugin}' has not been loaded into Immer. To enable the plugin, import and call \`enable${plugin}()\` when initializing your application.`;
  },
  function(thing) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${thing}'`;
  },
  "This object has been frozen and should not be mutated",
  function(data) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + data;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(thing) {
    return `'current' expects a draft, got: ${thing}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(thing) {
    return `'original' expects a draft, got: ${thing}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(error, ...args) {
  if (process.env.NODE_ENV !== "production") {
    const e2 = errors[error];
    const msg = isFunction$3(e2) ? e2.apply(null, args) : e2;
    throw new Error(`[Immer] ${msg}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var O$1 = Object;
var getPrototypeOf = O$1.getPrototypeOf;
var CONSTRUCTOR = "constructor";
var PROTOTYPE = "prototype";
var CONFIGURABLE = "configurable";
var ENUMERABLE = "enumerable";
var WRITABLE = "writable";
var VALUE = "value";
var isDraft = (value) => !!value && !!value[DRAFT_STATE];
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject$2(value) || isArray$2(value) || !!value[DRAFTABLE] || !!value[CONSTRUCTOR]?.[DRAFTABLE] || isMap$2(value) || isSet$1(value);
}
var objectCtorString = O$1[PROTOTYPE][CONSTRUCTOR].toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject$2(value) {
  if (!value || !isObjectish(value))
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null || proto === O$1[PROTOTYPE])
    return true;
  const Ctor = O$1.hasOwnProperty.call(proto, CONSTRUCTOR) && proto[CONSTRUCTOR];
  if (Ctor === Object)
    return true;
  if (!isFunction$3(Ctor))
    return false;
  let ctorString = cachedCtorStrings.get(Ctor);
  if (ctorString === void 0) {
    ctorString = Function.toString.call(Ctor);
    cachedCtorStrings.set(Ctor, ctorString);
  }
  return ctorString === objectCtorString;
}
function each$1(obj, iter, strict = true) {
  if (getArchtype(obj) === 0) {
    const keys2 = strict ? Reflect.ownKeys(obj) : O$1.keys(obj);
    keys2.forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index2) => iter(index2, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : isArray$2(thing) ? 1 : isMap$2(thing) ? 2 : isSet$1(thing) ? 3 : 0;
}
var has$2 = (thing, prop, type = getArchtype(thing)) => type === 2 ? thing.has(prop) : O$1[PROTOTYPE].hasOwnProperty.call(thing, prop);
var get$2 = (thing, prop, type = getArchtype(thing)) => (
  // @ts-ignore
  type === 2 ? thing.get(prop) : thing[prop]
);
var set = (thing, propOrOldValue, value, type = getArchtype(thing)) => {
  if (type === 2)
    thing.set(propOrOldValue, value);
  else if (type === 3) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
};
function is$2(x2, y) {
  if (x2 === y) {
    return x2 !== 0 || 1 / x2 === 1 / y;
  } else {
    return x2 !== x2 && y !== y;
  }
}
var isArray$2 = Array.isArray;
var isMap$2 = (target) => target instanceof Map;
var isSet$1 = (target) => target instanceof Set;
var isObjectish = (target) => typeof target === "object";
var isFunction$3 = (target) => typeof target === "function";
var isBoolean$3 = (target) => typeof target === "boolean";
var latest = (state) => state.copy_ || state.base_;
var getFinalValue = (state) => state.modified_ ? state.copy_ : state.base_;
function shallowCopy(base2, strict) {
  if (isMap$2(base2)) {
    return new Map(base2);
  }
  if (isSet$1(base2)) {
    return new Set(base2);
  }
  if (isArray$2(base2))
    return Array[PROTOTYPE].slice.call(base2);
  const isPlain2 = isPlainObject$2(base2);
  if (strict === true || strict === "class_only" && !isPlain2) {
    const descriptors = O$1.getOwnPropertyDescriptors(base2);
    delete descriptors[DRAFT_STATE];
    let keys2 = Reflect.ownKeys(descriptors);
    for (let i2 = 0; i2 < keys2.length; i2++) {
      const key = keys2[i2];
      const desc = descriptors[key];
      if (desc[WRITABLE] === false) {
        desc[WRITABLE] = true;
        desc[CONFIGURABLE] = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          [CONFIGURABLE]: true,
          [WRITABLE]: true,
          // could live with !!desc.set as well here...
          [ENUMERABLE]: desc[ENUMERABLE],
          [VALUE]: base2[key]
        };
    }
    return O$1.create(getPrototypeOf(base2), descriptors);
  } else {
    const proto = getPrototypeOf(base2);
    if (proto !== null && isPlain2) {
      return { ...base2 };
    }
    const obj = O$1.create(proto);
    return O$1.assign(obj, base2);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    O$1.defineProperties(obj, {
      set: dontMutateMethodOverride,
      add: dontMutateMethodOverride,
      clear: dontMutateMethodOverride,
      delete: dontMutateMethodOverride
    });
  }
  O$1.freeze(obj);
  if (deep)
    each$1(
      obj,
      (_key, value) => {
        freeze(value, true);
      },
      false
    );
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  [VALUE]: dontMutateFrozenCollections
};
function isFrozen(obj) {
  if (obj === null || !isObjectish(obj))
    return true;
  return O$1.isFrozen(obj);
}
var PluginMapSet = "MapSet";
var PluginPatches = "Patches";
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
var isPluginLoaded = (pluginKey) => !!plugins[pluginKey];
var currentScope;
var getCurrentScope = () => currentScope;
var createScope = (parent_, immer_) => ({
  drafts_: [],
  parent_,
  immer_,
  // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.
  canAutoFreeze_: true,
  unfinalizedDrafts_: 0,
  handledSet_: /* @__PURE__ */ new Set(),
  processedForPatches_: /* @__PURE__ */ new Set(),
  mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin(PluginMapSet) : void 0
});
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    scope.patchPlugin_ = getPlugin(PluginPatches);
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
var enterScope = (immer2) => currentScope = createScope(currentScope, immer2);
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 || state.type_ === 1)
    state.revoke_();
  else
    state.revoked_ = true;
}
function processResult(result2, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result2 !== void 0 && result2 !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result2)) {
      result2 = finalize(scope, result2);
    }
    const { patchPlugin_ } = scope;
    if (patchPlugin_) {
      patchPlugin_.generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result2,
        scope
      );
    }
  } else {
    result2 = finalize(scope, baseDraft);
  }
  maybeFreeze(scope, result2, true);
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result2 !== NOTHING ? result2 : void 0;
}
function finalize(rootScope, value) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    const finalValue = handleValue(value, rootScope.handledSet_, rootScope);
    return finalValue;
  }
  if (!isSameScope(state, rootScope)) {
    return value;
  }
  if (!state.modified_) {
    return state.base_;
  }
  if (!state.finalized_) {
    const { callbacks_ } = state;
    if (callbacks_) {
      while (callbacks_.length > 0) {
        const callback = callbacks_.pop();
        callback(rootScope);
      }
    }
    generatePatchesAndFinalize(state, rootScope);
  }
  return state.copy_;
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}
function markStateFinalized(state) {
  state.finalized_ = true;
  state.scope_.unfinalizedDrafts_--;
}
var isSameScope = (state, rootScope) => state.scope_ === rootScope;
var EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
  const parentCopy = latest(parent);
  const parentType = parent.type_;
  if (originalKey !== void 0) {
    const currentValue = get$2(parentCopy, originalKey, parentType);
    if (currentValue === draftValue) {
      set(parentCopy, originalKey, finalizedValue, parentType);
      return;
    }
  }
  if (!parent.draftLocations_) {
    const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
    each$1(parentCopy, (key, value) => {
      if (isDraft(value)) {
        const keys2 = draftLocations.get(value) || [];
        keys2.push(key);
        draftLocations.set(value, keys2);
      }
    });
  }
  const locations = parent.draftLocations_.get(draftValue) ?? EMPTY_LOCATIONS_RESULT;
  for (const location of locations) {
    set(parentCopy, location, finalizedValue, parentType);
  }
}
function registerChildFinalizationCallback(parent, child, key) {
  parent.callbacks_.push(function childCleanup(rootScope) {
    const state = child;
    if (!state || !isSameScope(state, rootScope)) {
      return;
    }
    rootScope.mapSetPlugin_?.fixSetContents(state);
    const finalizedValue = getFinalValue(state);
    updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
    generatePatchesAndFinalize(state, rootScope);
  });
}
function generatePatchesAndFinalize(state, rootScope) {
  const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 || (state.assigned_?.size ?? 0) > 0);
  if (shouldFinalize) {
    const { patchPlugin_ } = rootScope;
    if (patchPlugin_) {
      const basePath = patchPlugin_.getPath(state);
      if (basePath) {
        patchPlugin_.generatePatches_(state, basePath, rootScope);
      }
    }
    markStateFinalized(state);
  }
}
function handleCrossReference(target, key, value) {
  const { scope_ } = target;
  if (isDraft(value)) {
    const state = value[DRAFT_STATE];
    if (isSameScope(state, scope_)) {
      state.callbacks_.push(function crossReferenceCleanup() {
        prepareCopy(target);
        const finalizedValue = getFinalValue(state);
        updateDraftInParent(target, value, finalizedValue, key);
      });
    }
  } else if (isDraftable(value)) {
    target.callbacks_.push(function nestedDraftCleanup() {
      const targetCopy = latest(target);
      if (get$2(targetCopy, key, target.type_) === value) {
        if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) {
          handleValue(
            get$2(target.copy_, key, target.type_),
            scope_.handledSet_,
            scope_
          );
        }
      }
    });
  }
}
function handleValue(target, handledSet, rootScope) {
  if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
    return target;
  }
  if (isDraft(target) || handledSet.has(target) || !isDraftable(target) || isFrozen(target)) {
    return target;
  }
  handledSet.add(target);
  each$1(target, (key, value) => {
    if (isDraft(value)) {
      const state = value[DRAFT_STATE];
      if (isSameScope(state, rootScope)) {
        const updatedValue = getFinalValue(state);
        set(target, key, updatedValue, target.type_);
        markStateFinalized(state);
      }
    } else if (isDraftable(value)) {
      handleValue(value, handledSet, rootScope);
    }
  });
  return target;
}
function createProxyProxy(base2, parent) {
  const baseIsArray = isArray$2(base2);
  const state = {
    type_: baseIsArray ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    // actually instantiated in `prepareCopy()`
    assigned_: void 0,
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base2,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false,
    // `callbacks` actually gets assigned in `createProxy`
    callbacks_: void 0
  };
  let target = state;
  let traps = objectTraps;
  if (baseIsArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy: proxy2 } = Proxy.revocable(target, traps);
  state.draft_ = proxy2;
  state.revoke_ = revoke;
  return [proxy2, state];
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has$2(source, prop, state.type_)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      const childKey = state.type_ === 1 ? +prop : prop;
      const childDraft = createProxy(state.scope_, value, state, childKey);
      return state.copy_[childKey] = childDraft;
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_.set(prop, false);
        return true;
      }
      if (is$2(value, current2) && (value !== void 0 || has$2(state.base_, prop, state.type_)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_.set(prop, true);
    handleCrossReference(state, prop, value);
    return true;
  },
  deleteProperty(state, prop) {
    prepareCopy(state);
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_.set(prop, false);
      markChanged(state);
    } else {
      state.assigned_.delete(prop);
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      [WRITABLE]: true,
      [CONFIGURABLE]: state.type_ !== 1 || prop !== "length",
      [ENUMERABLE]: desc[ENUMERABLE],
      [VALUE]: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each$1(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    const args = arguments;
    args[0] = args[0][0];
    return fn.apply(this, args);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (process.env.NODE_ENV !== "production" && isNaN(parseInt(prop)))
    die(13);
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (process.env.NODE_ENV !== "production" && prop !== "length" && isNaN(parseInt(prop)))
    die(14);
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? VALUE in desc ? desc[VALUE] : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.assigned_ = /* @__PURE__ */ new Map();
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}
var Immer2 = class {
  constructor(config2) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    this.useStrictIteration_ = false;
    this.produce = (base2, recipe, patchListener) => {
      if (isFunction$3(base2) && !isFunction$3(recipe)) {
        const defaultBase = recipe;
        recipe = base2;
        const self2 = this;
        return function curriedProduce(base22 = defaultBase, ...args) {
          return self2.produce(base22, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (!isFunction$3(recipe))
        die(6);
      if (patchListener !== void 0 && !isFunction$3(patchListener))
        die(7);
      let result2;
      if (isDraftable(base2)) {
        const scope = enterScope(this);
        const proxy2 = createProxy(scope, base2, void 0);
        let hasError = true;
        try {
          result2 = recipe(proxy2);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result2, scope);
      } else if (!base2 || !isObjectish(base2)) {
        result2 = recipe(base2);
        if (result2 === void 0)
          result2 = base2;
        if (result2 === NOTHING)
          result2 = void 0;
        if (this.autoFreeze_)
          freeze(result2, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin(PluginPatches).generateReplacementPatches_(base2, result2, {
            patches_: p,
            inversePatches_: ip
          });
          patchListener(p, ip);
        }
        return result2;
      } else
        die(1, base2);
    };
    this.produceWithPatches = (base2, recipe) => {
      if (isFunction$3(base2)) {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base2(draft, ...args));
      }
      let patches, inversePatches;
      const result2 = this.produce(base2, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result2, patches, inversePatches];
    };
    if (isBoolean$3(config2?.autoFreeze))
      this.setAutoFreeze(config2.autoFreeze);
    if (isBoolean$3(config2?.useStrictShallowCopy))
      this.setUseStrictShallowCopy(config2.useStrictShallowCopy);
    if (isBoolean$3(config2?.useStrictIteration))
      this.setUseStrictIteration(config2.useStrictIteration);
  }
  createDraft(base2) {
    if (!isDraftable(base2))
      die(8);
    if (isDraft(base2))
      base2 = current(base2);
    const scope = enterScope(this);
    const proxy2 = createProxy(scope, base2, void 0);
    proxy2[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy2;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(value) {
    this.useStrictIteration_ = value;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(base2, patches) {
    let i2;
    for (i2 = patches.length - 1; i2 >= 0; i2--) {
      const patch = patches[i2];
      if (patch.path.length === 0 && patch.op === "replace") {
        base2 = patch.value;
        break;
      }
    }
    if (i2 > -1) {
      patches = patches.slice(i2 + 1);
    }
    const applyPatchesImpl = getPlugin(PluginPatches).applyPatches_;
    if (isDraft(base2)) {
      return applyPatchesImpl(base2, patches);
    }
    return this.produce(
      base2,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(rootScope, value, parent, key) {
  const [draft, state] = isMap$2(value) ? getPlugin(PluginMapSet).proxyMap_(value, parent) : isSet$1(value) ? getPlugin(PluginMapSet).proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent?.scope_ ?? getCurrentScope();
  scope.drafts_.push(draft);
  state.callbacks_ = parent?.callbacks_ ?? [];
  state.key_ = key;
  if (parent && key !== void 0) {
    registerChildFinalizationCallback(parent, state, key);
  } else {
    state.callbacks_.push(function rootDraftCleanup(rootScope2) {
      rootScope2.mapSetPlugin_?.fixSetContents(state);
      const { patchPlugin_ } = rootScope2;
      if (state.modified_ && patchPlugin_) {
        patchPlugin_.generatePatches_(state, [], rootScope2);
      }
    });
  }
  return draft;
}
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy2;
  let strict = true;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy2 = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    strict = state.scope_.immer_.shouldUseStrictIteration();
  } else {
    copy2 = shallowCopy(value, true);
  }
  each$1(
    copy2,
    (key, childValue) => {
      set(copy2, key, currentImpl(childValue));
    },
    strict
  );
  if (state) {
    state.finalized_ = false;
  }
  return copy2;
}
var immer = new Immer2();
var produce = immer.produce;
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose$1;
  return compose$1.apply(null, arguments);
};
var hasMatchFunction = (v2) => {
  return v2 && typeof v2.match === "function";
};
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "prepareAction did not return an object");
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => isAction(action) && action.type === type;
  return actionCreator;
}
function isActionCreator(action) {
  return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  hasMatchFunction(action);
}
function getMessage(type) {
  const splitType = type ? `${type}`.split("/") : [];
  const actionName = splitType[splitType.length - 1] || "actionCreator";
  return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options2 = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  }
  const {
    isActionCreator: isActionCreator2 = isActionCreator
  } = options2;
  return () => (next) => (action) => {
    if (isActionCreator2(action)) {
      console.warn(getMessage(action.type));
    }
    return next(action);
  };
}
function getTimeMeasureUtils(maxDelay, fnName) {
  let elapsed = 0;
  return {
    measureTime(fn) {
      const started = Date.now();
      try {
        return fn();
      } finally {
        const finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded() {
      if (elapsed > maxDelay) {
        console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
      }
    }
  };
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function getOrInsertComputed(map2, key, compute) {
  if (map2.has(key)) return map2.get(key);
  return map2.set(key, compute(key)).get(key);
}
function isImmutableDefault(value) {
  return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignoredPaths, obj) {
  const trackedProperties = trackProperties(isImmutable, ignoredPaths, obj);
  return {
    detectMutations() {
      return detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
    }
  };
}
function trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
  const tracked = {
    value: obj
  };
  if (!isImmutable(obj) && !checkedObjects.has(obj)) {
    checkedObjects.add(obj);
    tracked.children = {};
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const key in obj) {
      const nestedPath = path ? path + "." + key : key;
      if (hasIgnoredPaths) {
        const hasMatches = ignoredPaths.some((ignored) => {
          if (ignored instanceof RegExp) {
            return ignored.test(nestedPath);
          }
          return nestedPath === ignored;
        });
        if (hasMatches) {
          continue;
        }
      }
      tracked.children[key] = trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
    }
  }
  return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
  const prevObj = trackedProperty ? trackedProperty.value : void 0;
  const sameRef = prevObj === obj;
  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path
    };
  }
  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  }
  const keysToDetect = {};
  for (let key in trackedProperty.children) {
    keysToDetect[key] = true;
  }
  for (let key in obj) {
    keysToDetect[key] = true;
  }
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (let key in keysToDetect) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    const result2 = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
    if (result2.wasMutated) {
      return result2;
    }
  }
  return {
    wasMutated: false
  };
}
function createImmutableStateInvariantMiddleware(options2 = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  } else {
    let stringify2 = function(obj, serializer, indent2, decycler) {
      return JSON.stringify(obj, getSerialize2(serializer, decycler), indent2);
    }, getSerialize2 = function(serializer, decycler) {
      let stack = [], keys2 = [];
      if (!decycler) decycler = function(_2, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys2.slice(0, stack.indexOf(value)).join(".") + "]";
      };
      return function(key, value) {
        if (stack.length > 0) {
          var thisPos = stack.indexOf(this);
          ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
          ~thisPos ? keys2.splice(thisPos, Infinity, key) : keys2.push(key);
          if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
      };
    };
    let {
      isImmutable = isImmutableDefault,
      ignoredPaths,
      warnAfter = 32
    } = options2;
    const track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return ({
      getState
    }) => {
      let state = getState();
      let tracker = track(state);
      let result2;
      return (next) => (action) => {
        const measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
        measureUtils.measureTime(() => {
          state = getState();
          result2 = tracker.detectMutations();
          tracker = track(state);
          if (result2.wasMutated) {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(19) : `A state mutation was detected between dispatches, in the path '${result2.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
          }
        });
        const dispatchedAction = next(action);
        measureUtils.measureTime(() => {
          state = getState();
          result2 = tracker.detectMutations();
          tracker = track(state);
          if (result2.wasMutated) {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(20) : `A state mutation was detected inside a dispatch, in the path: ${result2.path || ""}. Take a look at the reducer(s) handling the action ${stringify2(action)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
          }
        });
        measureUtils.warnIfExceeded();
        return dispatchedAction;
      };
    };
  }
}
function isPlain(val) {
  const type = typeof val;
  return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject$3(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
  let foundNestedSerializable;
  if (!isSerializable(value)) {
    return {
      keyPath: path || "<root>",
      value
    };
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (cache?.has(value)) return false;
  const entries = getEntries != null ? getEntries(value) : Object.entries(value);
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (const [key, nestedValue] of entries) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath,
        value: nestedValue
      };
    }
    if (typeof nestedValue === "object") {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }
  if (cache && isNestedFrozen(value)) cache.add(value);
  return false;
}
function isNestedFrozen(value) {
  if (!Object.isFrozen(value)) return false;
  for (const nestedValue of Object.values(value)) {
    if (typeof nestedValue !== "object" || nestedValue === null) continue;
    if (!isNestedFrozen(nestedValue)) return false;
  }
  return true;
}
function createSerializableStateInvariantMiddleware(options2 = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  } else {
    const {
      isSerializable = isPlain,
      getEntries,
      ignoredActions = [],
      ignoredActionPaths = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths = [],
      warnAfter = 32,
      ignoreState = false,
      ignoreActions = false,
      disableCache = false
    } = options2;
    const cache = !disableCache && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (storeAPI) => (next) => (action) => {
      if (!isAction(action)) {
        return next(action);
      }
      const result2 = next(action);
      const measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
      if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
        measureUtils.measureTime(() => {
          const foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
          if (foundActionNonSerializableValue) {
            const {
              keyPath,
              value
            } = foundActionNonSerializableValue;
            console.error(`A non-serializable value was detected in an action, in the path: \`${keyPath}\`. Value:`, value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
          }
        });
      }
      if (!ignoreState) {
        measureUtils.measureTime(() => {
          const state = storeAPI.getState();
          const foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
          if (foundStateNonSerializableValue) {
            const {
              keyPath,
              value
            } = foundStateNonSerializableValue;
            console.error(`A non-serializable value was detected in the state, in the path: \`${keyPath}\`. Value:`, value, `
Take a look at the reducer(s) handling this action type: ${action.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        });
        measureUtils.warnIfExceeded();
      }
      return result2;
    };
  }
}
function isBoolean$2(x2) {
  return typeof x2 === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options2) {
  const {
    thunk: thunk$1 = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options2 ?? {};
  let middlewareArray = new Tuple();
  if (thunk$1) {
    if (isBoolean$2(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk$1.extraArgument));
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (immutableCheck) {
      let immutableOptions = {};
      if (!isBoolean$2(immutableCheck)) {
        immutableOptions = immutableCheck;
      }
      middlewareArray.unshift(createImmutableStateInvariantMiddleware(immutableOptions));
    }
    if (serializableCheck) {
      let serializableOptions = {};
      if (!isBoolean$2(serializableCheck)) {
        serializableOptions = serializableCheck;
      }
      middlewareArray.push(createSerializableStateInvariantMiddleware(serializableOptions));
    }
    if (actionCreatorCheck) {
      let actionCreatorOptions = {};
      if (!isBoolean$2(actionCreatorCheck)) {
        actionCreatorOptions = actionCreatorCheck;
      }
      middlewareArray.unshift(createActionCreatorInvariantMiddleware(actionCreatorOptions));
    }
  }
  return middlewareArray;
};
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var autoBatchEnhancer = (options2 = {
  type: "raf"
}) => (next) => (...args) => {
  const store2 = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options2.type === "tick" ? queueMicrotask : options2.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10)
  ) : options2.type === "callback" ? options2.queueNotification : createQueueWithTimer(options2.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l) => l());
    }
  };
  return Object.assign({}, store2, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store2.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      try {
        notifying = !action?.meta?.[SHOULD_AUTOBATCH];
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store2.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options2) {
  const {
    autoBatch = true
  } = options2 ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};
function configureStore(options2) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    duplicateMiddlewareCheck = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options2 || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$3(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  }
  if (process.env.NODE_ENV !== "production" && middleware && typeof middleware !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "`middleware` field must be a callback");
  }
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
    if (process.env.NODE_ENV !== "production" && !Array.isArray(finalMiddleware)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "when using a middleware builder function, an array of middleware must be returned");
    }
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  if (process.env.NODE_ENV !== "production" && finalMiddleware.some((item) => typeof item !== "function")) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "each middleware provided to configureStore must be a function");
  }
  if (process.env.NODE_ENV !== "production" && duplicateMiddlewareCheck) {
    let middlewareReferences = /* @__PURE__ */ new Set();
    finalMiddleware.forEach((middleware2) => {
      if (middlewareReferences.has(middleware2)) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(42) : "Duplicate middleware references found when creating the store. Ensure that each middleware is only included once.");
      }
      middlewareReferences.add(middleware2);
    });
  }
  let finalCompose = compose$1;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: process.env.NODE_ENV !== "production",
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  if (process.env.NODE_ENV !== "production" && enhancers && typeof enhancers !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "`enhancers` field must be a callback");
  }
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(storeEnhancers)) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "`enhancers` callback must return an array");
  }
  if (process.env.NODE_ENV !== "production" && storeEnhancers.some((item) => typeof item !== "function")) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "each enhancer provided to configureStore must be a function");
  }
  if (process.env.NODE_ENV !== "production" && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) {
    console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  }
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore$3(rootReducer, preloadedState, composedEnhancer);
}
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (actionMatchers.length > 0) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        }
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
        }
      }
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(28) : "`builder.addCase` cannot be called with an empty action type");
      }
      if (type in actionsMap) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${type}'`);
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addAsyncThunk(asyncThunk, reducers) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(43) : "`builder.addAsyncThunk` should only be called before calling `builder.addDefaultCase`");
        }
      }
      if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
      if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
      if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
      if (reducers.settled) actionMatchers.push({
        matcher: asyncThunk.settled,
        reducer: reducers.settled
      });
      return builder;
    },
    addMatcher(matcher2, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
        }
      }
      actionMatchers.push({
        matcher: matcher2,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(31) : "`builder.addDefaultCase` can only be called once");
        }
      }
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}
function isStateFunction(x2) {
  return typeof x2 === "function";
}
function createReducer(initialState2, mapOrBuilderCallback) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof mapOrBuilderCallback === "object") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
    }
  }
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState2)) {
    getInitialState = () => freezeDraftable(initialState2());
  } else {
    const frozenInitialState = freezeDraftable(initialState2);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher: matcher2
    }) => matcher2(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr2) => !!cr2).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (isDraft(previousState)) {
          const draft = previousState;
          const result2 = caseReducer(draft, action);
          if (result2 === void 0) {
            return previousState;
          }
          return result2;
        } else if (!isDraftable(previousState)) {
          const result2 = caseReducer(previousState, action);
          if (result2 === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result2;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}
var matches = (matcher2, action) => {
  if (hasMatchFunction(matcher2)) {
    return matcher2.match(action);
  } else {
    return matcher2(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher2) => matches(matcher2, action));
  };
}
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size2 = 21) => {
  let id2 = "";
  let i2 = size2;
  while (i2--) {
    id2 += urlAlphabet[Math.random() * 64 | 0];
  }
  return id2;
};
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta2) {
    this.payload = payload;
    this.meta = meta2;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var FulfillWithMeta = class {
  constructor(payload, meta2) {
    this.payload = payload;
    this.meta = meta2;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property2 of commonProperties) {
      if (typeof value[property2] === "string") {
        simpleError[property2] = value[property2];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var externalAbortMessage = "External signal was aborted";
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options2) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta2) => ({
      payload,
      meta: {
        ...meta2 || {},
        arg,
        requestId,
        requestStatus: "fulfilled"
      }
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta2) => ({
      payload: void 0,
      meta: {
        ...meta2 || {},
        arg,
        requestId,
        requestStatus: "pending"
      }
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta2) => ({
      payload,
      error: (options2 && options2.serializeError || miniSerializeError)(error || "Rejected"),
      meta: {
        ...meta2 || {},
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: error?.name === "AbortError",
        condition: error?.name === "ConditionError"
      }
    }));
    function actionCreator(arg, {
      signal
    } = {}) {
      return (dispatch, getState, extra) => {
        const requestId = options2?.idGenerator ? options2.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        if (signal) {
          if (signal.aborted) {
            abort(externalAbortMessage);
          } else {
            signal.addEventListener("abort", () => abort(externalAbortMessage), {
              once: true
            });
          }
        }
        const promise = (async function() {
          let finalAction;
          try {
            let conditionResult = options2?.condition?.(arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_2, reject2) => {
              abortHandler = () => {
                reject2({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler);
            });
            dispatch(pending(requestId, arg, options2?.getPendingMeta?.({
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: (value, meta2) => {
                return new RejectWithValue(value, meta2);
              },
              fulfillWithValue: (value, meta2) => {
                return new FulfillWithMeta(value, meta2);
              }
            })).then((result2) => {
              if (result2 instanceof RejectWithValue) {
                throw result2;
              }
              if (result2 instanceof FulfillWithMeta) {
                return fulfilled(result2.payload, requestId, arg, result2.meta);
              }
              return fulfilled(result2, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options2 && !options2.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        })();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function getType(slice2, actionKey) {
  return `${slice2}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  const cAT = creators?.asyncThunk?.[asyncThunkSymbol];
  return function createSlice2(options2) {
    const {
      name: name2,
      reducerPath = name2
    } = options2;
    if (!name2) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
      if (options2.initialState === void 0) {
        console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
      }
    }
    const reducers = (typeof options2.reducers === "function" ? options2.reducers(buildReducerCreators()) : options2.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer2) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : "`context.addCase` cannot be called with an empty action type");
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + type);
        }
        context.sliceCaseReducersByType[type] = reducer2;
        return contextMethods;
      },
      addMatcher(matcher2, reducer2) {
        context.sliceMatchers.push({
          matcher: matcher2,
          reducer: reducer2
        });
        return contextMethods;
      },
      exposeAction(name22, actionCreator) {
        context.actionCreators[name22] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name22, reducer2) {
        context.sliceCaseReducersByName[name22] = reducer2;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name2, reducerName),
        createNotation: typeof options2.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      if (process.env.NODE_ENV !== "production") {
        if (typeof options2.extraReducers === "object") {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
        }
      }
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = void 0] = typeof options2.extraReducers === "function" ? executeReducerBuilderCallback(options2.extraReducers) : [options2.extraReducers];
      const finalCaseReducers = {
        ...extraReducers,
        ...context.sliceCaseReducersByType
      };
      return createReducer(options2.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m of actionMatchers) {
          builder.addMatcher(m.matcher, m.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new Map();
    const injectedStateCache = /* @__PURE__ */ new WeakMap();
    let _reducer;
    function reducer(state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    }
    function getInitialState() {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
    function makeSelectorProps(reducerPath2, injected = false) {
      function selectSlice(state) {
        let sliceState = state[reducerPath2];
        if (typeof sliceState === "undefined") {
          if (injected) {
            sliceState = getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
          } else if (process.env.NODE_ENV !== "production") {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "selectSlice returned undefined for an uninjected slice reducer");
          }
        }
        return sliceState;
      }
      function getSelectors(selectState = selectSelf) {
        const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, () => /* @__PURE__ */ new WeakMap());
        return getOrInsertComputed(selectorCache, selectState, () => {
          const map2 = {};
          for (const [name22, selector2] of Object.entries(options2.selectors ?? {})) {
            map2[name22] = wrapSelector(selector2, selectState, () => getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
          }
          return map2;
        });
      }
      return {
        reducerPath: reducerPath2,
        getSelectors,
        get selectors() {
          return getSelectors(selectSlice);
        },
        selectSlice
      };
    }
    const slice2 = {
      name: name2,
      reducer,
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState,
      ...makeSelectorProps(reducerPath),
      injectInto(injectable, {
        reducerPath: pathOpt,
        ...config2
      } = {}) {
        const newReducerPath = pathOpt ?? reducerPath;
        injectable.inject({
          reducerPath: newReducerPath,
          reducer
        }, config2);
        return {
          ...slice2,
          ...makeSelectorProps(newReducerPath, true)
        };
      }
    };
    return slice2;
  };
}
function wrapSelector(selector2, selectState, getInitialState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState(rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = getInitialState();
      } else if (process.env.NODE_ENV !== "production") {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "selectState returned undefined for an uninjected slice reducer");
      }
    }
    return selector2(sliceState, ...args);
  }
  wrapper.unwrapped = selector2;
  return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config2) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator,
      ...config2
    };
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk";
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare";
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options: options2
  } = reducerDefinition;
  const thunk2 = cAT(type, payloadCreator, options2);
  context.exposeAction(reducerName, thunk2);
  if (fulfilled) {
    context.addCase(thunk2.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk2.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk2.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk2.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop$4,
    pending: pending || noop$4,
    rejected: rejected || noop$4,
    settled: settled || noop$4
  });
}
function noop$4() {
}
function formatProdErrorMessage(code2) {
  return `Minified Redux Toolkit error #${code2}; visit https://redux-toolkit.js.org/Errors?code=${code2} for the full message or use the non-minified dev environment for full errors. `;
}
var withSelector = { exports: {} };
var useSyncExternalStoreWithSelector_production = {};
var hasRequiredUseSyncExternalStoreWithSelector_production;
function requireUseSyncExternalStoreWithSelector_production() {
  if (hasRequiredUseSyncExternalStoreWithSelector_production) return useSyncExternalStoreWithSelector_production;
  hasRequiredUseSyncExternalStoreWithSelector_production = 1;
  var React2 = React__default;
  function is2(x2, y) {
    return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useSyncExternalStore2 = React2.useSyncExternalStore, useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue = React2.useDebugValue;
  useSyncExternalStoreWithSelector_production.useSyncExternalStoreWithSelector = function(subscribe2, getSnapshot, getServerSnapshot, selector2, isEqual2) {
    var instRef = useRef2(null);
    if (null === instRef.current) {
      var inst = { hasValue: false, value: null };
      instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo2(
      function() {
        function memoizedSelector(nextSnapshot) {
          if (!hasMemo) {
            hasMemo = true;
            memoizedSnapshot = nextSnapshot;
            nextSnapshot = selector2(nextSnapshot);
            if (void 0 !== isEqual2 && inst.hasValue) {
              var currentSelection = inst.value;
              if (isEqual2(currentSelection, nextSnapshot))
                return memoizedSelection = currentSelection;
            }
            return memoizedSelection = nextSnapshot;
          }
          currentSelection = memoizedSelection;
          if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
          var nextSelection = selector2(nextSnapshot);
          if (void 0 !== isEqual2 && isEqual2(currentSelection, nextSelection))
            return memoizedSnapshot = nextSnapshot, currentSelection;
          memoizedSnapshot = nextSnapshot;
          return memoizedSelection = nextSelection;
        }
        var hasMemo = false, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
          function() {
            return memoizedSelector(getSnapshot());
          },
          null === maybeGetServerSnapshot ? void 0 : function() {
            return memoizedSelector(maybeGetServerSnapshot());
          }
        ];
      },
      [getSnapshot, getServerSnapshot, selector2, isEqual2]
    );
    var value = useSyncExternalStore2(subscribe2, instRef[0], instRef[1]);
    useEffect2(
      function() {
        inst.hasValue = true;
        inst.value = value;
      },
      [value]
    );
    useDebugValue(value);
    return value;
  };
  return useSyncExternalStoreWithSelector_production;
}
var useSyncExternalStoreWithSelector_development = {};
var hasRequiredUseSyncExternalStoreWithSelector_development;
function requireUseSyncExternalStoreWithSelector_development() {
  if (hasRequiredUseSyncExternalStoreWithSelector_development) return useSyncExternalStoreWithSelector_development;
  hasRequiredUseSyncExternalStoreWithSelector_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function is2(x2, y) {
      return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is2, useSyncExternalStore2 = React2.useSyncExternalStore, useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue = React2.useDebugValue;
    useSyncExternalStoreWithSelector_development.useSyncExternalStoreWithSelector = function(subscribe2, getSnapshot, getServerSnapshot, selector2, isEqual2) {
      var instRef = useRef2(null);
      if (null === instRef.current) {
        var inst = { hasValue: false, value: null };
        instRef.current = inst;
      } else inst = instRef.current;
      instRef = useMemo2(
        function() {
          function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
              hasMemo = true;
              memoizedSnapshot = nextSnapshot;
              nextSnapshot = selector2(nextSnapshot);
              if (void 0 !== isEqual2 && inst.hasValue) {
                var currentSelection = inst.value;
                if (isEqual2(currentSelection, nextSnapshot))
                  return memoizedSelection = currentSelection;
              }
              return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot))
              return currentSelection;
            var nextSelection = selector2(nextSnapshot);
            if (void 0 !== isEqual2 && isEqual2(currentSelection, nextSelection))
              return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
          }
          var hasMemo = false, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
          return [
            function() {
              return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
              return memoizedSelector(maybeGetServerSnapshot());
            }
          ];
        },
        [getSnapshot, getServerSnapshot, selector2, isEqual2]
      );
      var value = useSyncExternalStore2(subscribe2, instRef[0], instRef[1]);
      useEffect2(
        function() {
          inst.hasValue = true;
          inst.value = value;
        },
        [value]
      );
      useDebugValue(value);
      return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return useSyncExternalStoreWithSelector_development;
}
var hasRequiredWithSelector;
function requireWithSelector() {
  if (hasRequiredWithSelector) return withSelector.exports;
  hasRequiredWithSelector = 1;
  if (process.env.NODE_ENV === "production") {
    withSelector.exports = requireUseSyncExternalStoreWithSelector_production();
  } else {
    withSelector.exports = requireUseSyncExternalStoreWithSelector_development();
  }
  return withSelector.exports;
}
var withSelectorExports = requireWithSelector();
function defaultNoopBatch(callback) {
  callback();
}
function createListenerCollection() {
  let first2 = null;
  let last2 = null;
  return {
    clear() {
      first2 = null;
      last2 = null;
    },
    notify() {
      defaultNoopBatch(() => {
        let listener = first2;
        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get() {
      const listeners = [];
      let listener = first2;
      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }
      return listeners;
    },
    subscribe(callback) {
      let isSubscribed = true;
      const listener = last2 = {
        callback,
        next: null,
        prev: last2
      };
      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first2 = listener;
      }
      return function unsubscribe() {
        if (!isSubscribed || first2 === null) return;
        isSubscribed = false;
        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last2 = listener.prev;
        }
        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first2 = listener.next;
        }
      };
    }
  };
}
var nullListeners = {
  notify() {
  },
  get: () => []
};
function createSubscription(store2, parentSub) {
  let unsubscribe;
  let listeners = nullListeners;
  let subscriptionsAmount = 0;
  let selfSubscribed = false;
  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener);
    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }
  function notifyNestedSubs() {
    listeners.notify();
  }
  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }
  function isSubscribed() {
    return selfSubscribed;
  }
  function trySubscribe() {
    subscriptionsAmount++;
    if (!unsubscribe) {
      unsubscribe = store2.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }
  function tryUnsubscribe() {
    subscriptionsAmount--;
    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = void 0;
      listeners.clear();
      listeners = nullListeners;
    }
  }
  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }
  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }
  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
var canUseDOM$3 = () => !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isDOM = /* @__PURE__ */ canUseDOM$3();
var isRunningInReactNative = () => typeof navigator !== "undefined" && navigator.product === "ReactNative";
var isReactNative = /* @__PURE__ */ isRunningInReactNative();
var getUseIsomorphicLayoutEffect = () => isDOM || isReactNative ? React.useLayoutEffect : React.useEffect;
var useIsomorphicLayoutEffect$1 = /* @__PURE__ */ getUseIsomorphicLayoutEffect();
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function getContext() {
  if (!React.createContext) return {};
  const contextMap = gT[ContextKey] ??= /* @__PURE__ */ new Map();
  let realContext = contextMap.get(React.createContext);
  if (!realContext) {
    realContext = React.createContext(
      null
    );
    if (process.env.NODE_ENV !== "production") {
      realContext.displayName = "ReactRedux";
    }
    contextMap.set(React.createContext, realContext);
  }
  return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();
function Provider(providerProps) {
  const { children, context, serverState, store: store2 } = providerProps;
  const contextValue = React.useMemo(() => {
    const subscription = createSubscription(store2);
    const baseContextValue = {
      store: store2,
      subscription,
      getServerState: serverState ? () => serverState : void 0
    };
    if (process.env.NODE_ENV === "production") {
      return baseContextValue;
    } else {
      const { identityFunctionCheck = "once", stabilityCheck = "once" } = providerProps;
      return /* @__PURE__ */ Object.assign(baseContextValue, {
        stabilityCheck,
        identityFunctionCheck
      });
    }
  }, [store2, serverState]);
  const previousState = React.useMemo(() => store2.getState(), [store2]);
  useIsomorphicLayoutEffect$1(() => {
    const { subscription } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();
    if (previousState !== store2.getState()) {
      subscription.notifyNestedSubs();
    }
    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = void 0;
    };
  }, [contextValue, previousState]);
  const Context2 = context || ReactReduxContext;
  return /* @__PURE__ */ React.createElement(Context2.Provider, { value: contextValue }, children);
}
var Provider_default = Provider;
function createReduxContextHook(context = ReactReduxContext) {
  return function useReduxContext2() {
    const contextValue = React.useContext(context);
    if (process.env.NODE_ENV !== "production" && !contextValue) {
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    }
    return contextValue;
  };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();
function createStoreHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : (
    // @ts-ignore
    createReduxContextHook(context)
  );
  const useStore2 = () => {
    const { store: store2 } = useReduxContext2();
    return store2;
  };
  Object.assign(useStore2, {
    withTypes: () => useStore2
  });
  return useStore2;
}
var useStore$3 = /* @__PURE__ */ createStoreHook();
function createDispatchHook(context = ReactReduxContext) {
  const useStore2 = context === ReactReduxContext ? useStore$3 : createStoreHook(context);
  const useDispatch2 = () => {
    const store2 = useStore2();
    return store2.dispatch;
  };
  Object.assign(useDispatch2, {
    withTypes: () => useDispatch2
  });
  return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a, b2) => a === b2;
function createSelectorHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
  const useSelector2 = (selector2, equalityFnOrOptions = {}) => {
    const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? { equalityFn: equalityFnOrOptions } : equalityFnOrOptions;
    if (process.env.NODE_ENV !== "production") {
      if (!selector2) {
        throw new Error(`You must pass a selector to useSelector`);
      }
      if (typeof selector2 !== "function") {
        throw new Error(`You must pass a function as a selector to useSelector`);
      }
      if (typeof equalityFn !== "function") {
        throw new Error(
          `You must pass a function as an equality function to useSelector`
        );
      }
    }
    const reduxContext = useReduxContext2();
    const { store: store2, subscription, getServerState } = reduxContext;
    const firstRun = React.useRef(true);
    const wrappedSelector = React.useCallback(
      {
        [selector2.name](state) {
          const selected = selector2(state);
          if (process.env.NODE_ENV !== "production") {
            const { devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {} : equalityFnOrOptions;
            const { identityFunctionCheck, stabilityCheck } = reduxContext;
            const {
              identityFunctionCheck: finalIdentityFunctionCheck,
              stabilityCheck: finalStabilityCheck
            } = {
              stabilityCheck,
              identityFunctionCheck,
              ...devModeChecks
            };
            if (finalStabilityCheck === "always" || finalStabilityCheck === "once" && firstRun.current) {
              const toCompare = selector2(state);
              if (!equalityFn(selected, toCompare)) {
                let stack = void 0;
                try {
                  throw new Error();
                } catch (e2) {
                  ({ stack } = e2);
                }
                console.warn(
                  "Selector " + (selector2.name || "unknown") + " returned a different result when called with the same parameters. This can lead to unnecessary rerenders.\nSelectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization",
                  {
                    state,
                    selected,
                    selected2: toCompare,
                    stack
                  }
                );
              }
            }
            if (finalIdentityFunctionCheck === "always" || finalIdentityFunctionCheck === "once" && firstRun.current) {
              if (selected === state) {
                let stack = void 0;
                try {
                  throw new Error();
                } catch (e2) {
                  ({ stack } = e2);
                }
                console.warn(
                  "Selector " + (selector2.name || "unknown") + " returned the root state when called. This can lead to unnecessary rerenders.\nSelectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.",
                  { stack }
                );
              }
            }
            if (firstRun.current) firstRun.current = false;
          }
          return selected;
        }
      }[selector2.name],
      [selector2]
    );
    const selectedState = withSelectorExports.useSyncExternalStoreWithSelector(
      subscription.addNestedSub,
      store2.getState,
      getServerState || store2.getState,
      wrappedSelector,
      equalityFn
    );
    React.useDebugValue(selectedState);
    return selectedState;
  };
  Object.assign(useSelector2, {
    withTypes: () => useSelector2
  });
  return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();
const useAppDispatch = useDispatch.withTypes();
const useAppSelector = useSelector.withTypes();
const createLoggingAsyncThunk = (typePrefix, payloadCreator) => {
  const wrappedPayloadCreator = (async (...args) => {
    try {
      return await payloadCreator(...args);
    } catch (e2) {
      console.warn(e2);
      throw e2;
    }
  });
  return createAsyncThunk(typePrefix, wrappedPayloadCreator);
};
function actionIdentifier(actionId, componentIdx) {
  return `${actionId}|${componentIdx}`;
}
const initialState$1 = {
  componentInfo: {}
};
const mainSlice = createSlice({
  name: "main",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: initialState$1,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setComponentInfo: (state, action) => {
      let newVal = action.payload.componentInfo;
      state.componentInfo[action.payload.key] = newVal;
    }
  },
  selectors: {
    componentInfo: (state) => state.componentInfo
  }
});
const mainThunks = {
  /**
   * Updates the state variables for a specific component.
   */
  updateRendererSVs: createLoggingAsyncThunk(
    "main/updateRendererSVs",
    async ({
      coreId,
      componentIdx,
      stateValues,
      childrenInstructions,
      sourceOfUpdate,
      baseStateVariable,
      actionId,
      updatesToIgnoreRef,
      prefixForIds = ""
    }, { dispatch, getState }) => {
      let ignoreUpdate = false;
      let rendererName = coreId + componentIdx;
      if (baseStateVariable) {
        const updatesToIgnore = updatesToIgnoreRef.current;
        if (updatesToIgnore.size > 0) {
          let valueFromRenderer = updatesToIgnore.get(
            actionIdentifier(actionId || "", componentIdx)
          );
          let valueFromCore = stateValues[baseStateVariable];
          if (valueFromRenderer === valueFromCore || Array.isArray(valueFromRenderer) && Array.isArray(valueFromCore) && valueFromRenderer.length == valueFromCore.length && valueFromRenderer.every(
            (v2, i2) => valueFromCore[i2] === v2
          )) {
            ignoreUpdate = true;
            updatesToIgnore.delete(
              actionIdentifier(actionId || "", componentIdx)
            );
          } else {
            updatesToIgnore.clear();
          }
        }
      }
      let childrenInstructions2;
      if (childrenInstructions === void 0) {
        let previousRendererState = mainSlice.selectors.componentInfo(getState())[rendererName];
        childrenInstructions2 = previousRendererState?.childrenInstructions ?? null;
      } else {
        childrenInstructions2 = childrenInstructions;
      }
      let newRendererState = {
        stateValues,
        childrenInstructions: childrenInstructions2,
        sourceOfUpdate,
        ignoreUpdate,
        prefixForIds
      };
      dispatch(
        mainSlice.actions.setComponentInfo({
          key: rendererName,
          componentInfo: newRendererState
        })
      );
    }
  )
};
const initialState = {
  keyboardInput: []
};
const keyboardSlice = createSlice({
  name: "keyboard",
  initialState,
  reducers: {
    setKeyboardInput: (state, action) => {
      state.keyboardInput = action.payload;
    },
    clearKeyboardInput: (state) => {
      state.keyboardInput = [];
    }
  },
  selectors: {
    keyboardInput: (state) => state.keyboardInput
  }
});
const store = configureStore({
  reducer: {
    main: mainSlice.reducer,
    keyboard: keyboardSlice.reducer
  }
});
const DocContext = createContext({});
function DocViewer({
  doenetML,
  userId,
  activityId = "a",
  docId = "1",
  render = true,
  hidden = false,
  attemptNumber = 1,
  forceDisable = false,
  forceShowCorrectness = false,
  forceShowSolution = false,
  forceUnsuppressCheckWork = false,
  generatedVariantCallback,
  flags,
  requestedVariantIndex,
  initialState: initialState2,
  setErrorsAndWarningsCallback,
  reportScoreAndStateCallback: specifiedReportScoreAndStateCallback,
  documentStructureCallback,
  initializedCallback,
  setIsInErrorState,
  prefixForIds = "",
  doenetViewerUrl,
  darkMode,
  showAnswerResponseButton = false,
  answerResponseCounts = {},
  initializeCounters: prescribedInitializeCounters = {},
  fetchExternalDoenetML,
  requestScrollTo
}) {
  const updatesToIgnoreRef = useRef(
    /* @__PURE__ */ new Map()
  );
  const dispatch = useAppDispatch();
  const [errMsg, setErrMsg] = useState(null);
  const cid = useRef(null);
  const lastDoenetML = useRef(null);
  const lastActivityId = useRef(null);
  const lastDocId = useRef(null);
  const lastAttemptNumber = useRef(null);
  const lastRequestedVariantIndex = useRef(null);
  const [stage, setStage] = useState("initial");
  const [documentRenderer, setDocumentRenderer] = useState(null);
  const initialCoreData = useRef(null);
  const initializeCounters = useRef(
    prescribedInitializeCounters
  );
  useEffect(() => {
    initializeCounters.current = prescribedInitializeCounters;
  }, [prescribedInitializeCounters]);
  const rendererClasses = useRef({});
  const coreInfo = useRef(null);
  const loadedInitialRendererState = useRef(false);
  const coreCreated = useRef(false);
  const coreCreationInProgress = useRef(false);
  const coreId = useRef("");
  const errorWarnings = useRef({ errors: [], warnings: [] });
  const actionsBeforeCoreCreated = useRef([]);
  const preventMoreAnimations = useRef(false);
  const animationInfo = useRef({});
  const onActionCallbacks = useRef(
    /* @__PURE__ */ new Map()
  );
  const lastSkippableAction = useRef(null);
  const messageIdFromGetState = useRef(null);
  const requestSolutionViewPromises = useRef({});
  const errorInitializingRenderers = useRef(false);
  const errorInsideRenderers = useRef(false);
  const [ignoreRendererError, setIgnoreRendererError] = useState(false);
  const coreWorker = useRef(null);
  const contextForRenderers = {
    doenetViewerUrl,
    darkMode,
    showAnswerResponseButton,
    answerResponseCounts
  };
  useEffect(() => {
    return () => {
      coreWorker.current?.terminate();
      coreWorker.current = null;
      coreCreated.current = false;
    };
  }, []);
  useEffect(() => {
    const listener = async function(e2) {
      if (e2.origin !== window.location.origin && e2.origin !== window.parent.location.origin) {
        return;
      }
      if (typeof e2.data !== "object") {
        return;
      }
      if (e2.data.subject === "SPLICE.getState.response") {
        if (messageIdFromGetState.current === e2.data.message_id) {
          if (e2.data.state) {
            if (errMsg !== null) {
              setErrMsg(null);
              setIsInErrorState?.(false);
            }
            coreId.current = nanoid$1();
            initialCoreData.current = null;
            coreInfo.current = null;
            setDocumentRenderer(null);
            coreCreated.current = false;
            coreCreationInProgress.current = false;
            loadedInitialRendererState.current = false;
            processLoadedDocState(e2.data.state);
            if (render) {
              startCore();
            } else {
              setStage("readyToCreateCore");
            }
          }
        } else if (e2.data.error) {
          const error = e2.data.error;
          setIsInErrorState?.(true);
          if (typeof error === "object" && "code" in error && "message" in error) {
            console.log(
              `error ${error.code} getting state: ${error.message}`
            );
            setErrMsg(error.message);
          } else {
            setErrMsg("Invalid response to getState");
          }
        }
      } else if (e2.data.subject === "SPLICE.requestSolutionView.response") {
        let promiseInfo = requestSolutionViewPromises.current[e2.data.messageId];
        if (!promiseInfo) {
          return;
        }
        promiseInfo.resolve({ allowView: e2.data.allowView === true });
      } else if (e2.data.subject === "SPLICE.submitAllAnswers") {
        if (coreInfo.current) {
          const actionResult = await callAction({
            action: {
              actionName: "submitAllAnswers",
              componentIdx: coreInfo.current.documentToRender.componentIdx
            },
            args: {}
          });
          const message = {
            subject: "SPLICE.submitAllAnswers.response",
            success: actionResult
          };
          if (flags.messageParent && window.parent) {
            window.parent.postMessage(message);
          } else {
            window.postMessage(message);
          }
        }
      }
    };
    window.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
    };
  }, []);
  useEffect(() => {
    if (!coreWorker.current) {
      return;
    }
    if (docId !== null) {
      const postfixForWindowFunctions = prefixForIds.replaceAll("::", "").replaceAll(":", "_").replaceAll(".", "_").replaceAll("-", "_") || "1";
      window["returnAllStateVariables" + postfixForWindowFunctions] = async function() {
        const allStateVariables = await coreWorker.current?.returnAllStateVariables(true);
        console.log(allStateVariables);
        return allStateVariables;
      };
      window["returnErrorWarnings" + postfixForWindowFunctions] = function() {
        return errorWarnings.current;
      };
      window["callAction" + postfixForWindowFunctions] = async function({
        actionName,
        componentIdx,
        args
      }) {
        return await callAction({
          action: { actionName, componentIdx },
          args
        });
      };
      window["resolvePath" + postfixForWindowFunctions] = async function(name2, origin = 0) {
        if (coreWorker.current) {
          return await coreWorker.current.resolvePathJavascript(
            name2,
            origin
          );
        } else {
          console.error("No core worker present");
          return -1;
        }
      };
    }
  }, [docId, coreWorker.current, prefixForIds]);
  useEffect(() => {
    return () => {
      preventMoreAnimations.current = true;
      for (let id2 in animationInfo.current) {
        cancelAnimationFrame2(id2);
      }
      animationInfo.current = {};
    };
  }, []);
  useEffect(() => {
    if (!coreWorker.current) {
      return;
    }
    function documentVisibilityListener() {
      coreWorker.current?.handleVisibilityChange(
        document.visibilityState === "visible"
      );
    }
    document.addEventListener(
      "visibilitychange",
      documentVisibilityListener
    );
    return () => {
      document.removeEventListener(
        "visibilitychange",
        documentVisibilityListener
      );
    };
  }, [coreWorker.current]);
  useEffect(() => {
    callAction({
      action: { actionName: "setTheme" },
      args: { theme: darkMode, doNotIgnore: true }
    });
  }, [darkMode]);
  async function reinitializeCoreAndTerminateAnimations() {
    if (coreWorker.current !== null) {
      preventMoreAnimations.current = true;
      await coreWorker.current.terminate();
      actionsBeforeCoreCreated.current = [];
      for (let id2 in animationInfo.current) {
        cancelAnimationFrame2(id2);
      }
      animationInfo.current = {};
    }
    const newCoreWorker = createCoreWorker();
    coreWorker.current = newCoreWorker;
    coreCreated.current = false;
    coreCreationInProgress.current = false;
    const initializeResult = await initializeCoreWorker({
      coreWorker: newCoreWorker,
      doenetML,
      flags,
      activityId,
      docId,
      requestedVariantIndex,
      attemptNumber,
      documentStructureCallback,
      fetchExternalDoenetML
    });
    if (initializeResult.success === false) {
      setErrMsg(
        `Error initializing activity: ${initializeResult.errMsg}`
      );
    }
    return newCoreWorker;
  }
  function callAction({
    action,
    args,
    baseVariableValue,
    componentIdx,
    rendererType,
    promiseResolve
  }) {
    let ignoreActionsWithoutCore = rendererClasses.current[rendererType ?? ""]?.ignoreActionsWithoutCore || rendererClasses.current[rendererType ?? ""]?.type?.ignoreActionsWithoutCore;
    if (!coreCreated.current && (ignoreActionsWithoutCore?.(action.actionName) || !coreCreationInProgress.current) && !args?.doNotIgnore) {
      if (promiseResolve) {
        promiseResolve(false);
        return;
      } else {
        return Promise.resolve(false);
      }
    }
    if (lastSkippableAction.current) {
      lastSkippableAction.current.promiseResolve?.(false);
      lastSkippableAction.current = null;
    }
    if (args?.skippable) {
      if (onActionCallbacks.current.size > 0) {
        let newPromise;
        if (!promiseResolve) {
          newPromise = new Promise((resolve, reject2) => {
            promiseResolve = resolve;
          });
        }
        lastSkippableAction.current = {
          action,
          args,
          baseVariableValue,
          componentIdx,
          rendererType,
          promiseResolve
        };
        if (newPromise) {
          return newPromise;
        } else {
          return;
        }
      }
    }
    let actionId = nanoid$1();
    args = { ...args };
    args.actionId = actionId;
    if (baseVariableValue !== void 0 && componentIdx != null) {
      updatesToIgnoreRef.current.set(
        actionIdentifier(actionId, componentIdx),
        baseVariableValue
      );
    }
    let actionArgs = {
      actionName: action.actionName,
      componentIdx: action.componentIdx,
      args
    };
    executeAction(actionArgs);
    if (promiseResolve) {
      onActionCallbacks.current.set(actionId, promiseResolve);
      return;
    } else {
      return new Promise((resolve, reject2) => {
        onActionCallbacks.current.set(actionId, resolve);
      });
    }
  }
  async function executeAction(actionArgs) {
    if (!coreCreated.current) {
      actionsBeforeCoreCreated.current.push(actionArgs);
      return;
    }
    const actionResult = await coreWorker.current?.dispatchActionJavascript(actionArgs);
    resolveAction(actionResult);
  }
  function forceRendererState({
    rendererState,
    forceDisable: forceDisable2,
    forceShowCorrectness: forceShowCorrectness2,
    forceShowSolution: forceShowSolution2,
    forceUnsuppressCheckWork: forceUnsuppressCheckWork2
  }) {
    for (let componentIdx in rendererState) {
      let stateValues = rendererState[componentIdx].stateValues;
      if (forceDisable2 && stateValues.disabled === false) {
        stateValues.disabled = true;
      }
      if (forceShowCorrectness2 && stateValues.showCorrectness === false) {
        stateValues.showCorrectness = true;
      }
      if (forceUnsuppressCheckWork2 && stateValues.suppressCheckWork === true) {
        stateValues.suppressCheckWork = false;
      }
      if (forceShowSolution2 && rendererState[componentIdx].childrenInstructions?.length > 0) {
        for (let childInst of rendererState[componentIdx].childrenInstructions) {
          if (childInst?.componentType === "solution") {
            let solComponentIdx = childInst.componentIdx;
            if (rendererState[solComponentIdx].stateValues.hidden) {
              rendererState[solComponentIdx].stateValues.hidden = false;
            }
          }
        }
      }
    }
  }
  function initializeRenderers(args) {
    if (args.rendererState) {
      if (forceDisable || forceShowCorrectness || forceShowSolution || forceUnsuppressCheckWork) {
        forceRendererState({
          rendererState: args.rendererState,
          forceDisable,
          forceShowCorrectness,
          forceShowSolution,
          forceUnsuppressCheckWork
        });
      }
      for (let componentIdx in args.rendererState) {
        dispatch(
          mainThunks.updateRendererSVs({
            coreId: coreId.current,
            componentIdx,
            stateValues: args.rendererState[componentIdx].stateValues,
            childrenInstructions: args.rendererState[componentIdx].childrenInstructions,
            updatesToIgnoreRef,
            prefixForIds
          })
        );
      }
    }
    coreInfo.current = args.coreInfo;
    if (!coreInfo.current) {
      return;
    }
    generatedVariantCallback?.({
      variantInfo: JSON.parse(
        coreInfo.current.generatedVariantString,
        serializedComponentsReviver
      ),
      allPossibleVariants: coreInfo.current.allPossibleVariants,
      activityId,
      docId
    });
    let renderPromises = [];
    let rendererClassNames = [];
    for (let rendererClassName of coreInfo.current.rendererTypesInDocument) {
      rendererClassNames.push(rendererClassName);
      renderPromises.push(__variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./renderers/_error.tsx": () => import("./_error-BrARk5Fx.js"), "./renderers/alert.tsx": () => import("./alert-DfLMIJuf.js"), "./renderers/angle.tsx": () => import("./angle-Cgzhzg0n.js"), "./renderers/answer.tsx": () => import("./answer-18Cp2Pm0.js"), "./renderers/asList.tsx": () => import("./asList-DI0LB2Ml.js"), "./renderers/blockQuote.tsx": () => import("./blockQuote-B-pRp9mk.js"), "./renderers/boolean.tsx": () => import("./boolean-Bh-uG4Kk.js"), "./renderers/booleanInput.tsx": () => import("./booleanInput-B3eP77t2.js"), "./renderers/br.tsx": () => import("./br-CHaEnqQZ.js"), "./renderers/button.tsx": () => import("./button-C5_qKwMr.js"), "./renderers/c.tsx": () => import("./c-D83tkoY-.js"), "./renderers/cell.tsx": () => import("./cell-gcpABQHb.js"), "./renderers/choiceInput.tsx": () => import("./choiceInput-CIweZgnj.js"), "./renderers/circle.tsx": () => import("./circle-D8x7L58k.js"), "./renderers/cobwebPolyline.tsx": () => import("./cobwebPolyline-B-PF70nu.js"), "./renderers/codeEditor.tsx": () => import("./codeEditor-C7JRQ30n.js"), "./renderers/containerBlock.tsx": () => import("./containerBlock-q8zkAcAo.js"), "./renderers/containerInline.tsx": () => import("./containerInline-Z9K4BoDE.js"), "./renderers/curve.tsx": () => import("./curve-DQQ_i75j.js"), "./renderers/ellipsis.tsx": () => import("./ellipsis-BLSUnRdh.js"), "./renderers/em.tsx": () => import("./em-MZuySG0G.js"), "./renderers/embed.tsx": () => import("./embed-7Wp0RcoT.js"), "./renderers/feedback.tsx": () => import("./feedback-BcehF_7L.js"), "./renderers/figure.tsx": () => import("./figure-SpAf6tQb.js"), "./renderers/footnote.tsx": () => import("./footnote-Dr_pVPk9.js"), "./renderers/graph.tsx": () => import("./graph-BnCXdKYm.js"), "./renderers/hint.tsx": () => import("./hint-C-VckoiW.js"), "./renderers/hr.tsx": () => import("./hr-CXSU5Oif.js"), "./renderers/image.tsx": () => import("./image-D8QPz-J7.js"), "./renderers/label.tsx": () => import("./label-DGgSGSs2.js"), "./renderers/legend.tsx": () => import("./legend-DMzfTBYa.js"), "./renderers/line.tsx": () => import("./line-cFSBunBC.js"), "./renderers/lineSegment.tsx": () => import("./lineSegment-hnx1NqdL.js"), "./renderers/list.tsx": () => import("./list-D2CwsUUP.js"), "./renderers/lq.tsx": () => import("./lq-d-Ji-mUH.js"), "./renderers/lsq.tsx": () => import("./lsq-DkTVJc5V.js"), "./renderers/math.tsx": () => import("./math-CNEtKCI7.js"), "./renderers/mathInput.tsx": () => import("./mathInput-CX_uwjPd.js"), "./renderers/matrixInput.tsx": () => import("./matrixInput-5CijX7lS.js"), "./renderers/mdash.tsx": () => import("./mdash-Bs6HPbX1.js"), "./renderers/nbsp.tsx": () => import("./nbsp-BQlbE_ub.js"), "./renderers/ndash.tsx": () => import("./ndash-BG8r5c8d.js"), "./renderers/number.tsx": () => import("./number-CBPH0jPR.js"), "./renderers/orbitalDiagram.tsx": () => import("./orbitalDiagram-C0HvdDZX.js"), "./renderers/orbitalDiagramInput.tsx": () => import("./orbitalDiagramInput-CSpvyh09.js"), "./renderers/p.tsx": () => import("./p-DD64r37C.js"), "./renderers/paginatorControls.tsx": () => import("./paginatorControls-CsgeacGg.js"), "./renderers/pegboard.tsx": () => import("./pegboard-0Wx-yPVj.js"), "./renderers/point.tsx": () => import("./point-CaZ-4F3P.js"), "./renderers/polygon.tsx": () => import("./polygon-DBMvZ5GT.js"), "./renderers/polyline.tsx": () => import("./polyline-DqW30STC.js"), "./renderers/pre.tsx": () => import("./pre-MtfB0_w2.js"), "./renderers/pretzel.tsx": () => import("./pretzel-CInR_-wU.js"), "./renderers/q.tsx": () => import("./q-CD7bAFEY.js"), "./renderers/ray.tsx": () => import("./ray-DsMD9jnR.js"), "./renderers/ref.tsx": () => import("./ref-ZneYHOUr.js"), "./renderers/regionBetweenCurveXAxis.tsx": () => import("./regionBetweenCurveXAxis-CJoVI5Lt.js"), "./renderers/regionBetweenCurves.tsx": () => import("./regionBetweenCurves-BMhw0Boa.js"), "./renderers/row.tsx": () => import("./row-YXg8D46e.js"), "./renderers/rq.tsx": () => import("./rq-CAor4h45.js"), "./renderers/rsq.tsx": () => import("./rsq-BUcmomj7.js"), "./renderers/section.tsx": () => import("./section-DApLx4Um.js"), "./renderers/sideBySide.tsx": () => import("./sideBySide-DsE4E5fz.js"), "./renderers/slider.tsx": () => import("./slider-CULT6y8Q.js"), "./renderers/solution.tsx": () => import("./solution-Bop9h1JU.js"), "./renderers/spreadsheet.tsx": () => import("./spreadsheet-CT1OsIcA.js"), "./renderers/sq.tsx": () => import("./sq-CVq0CAKv.js"), "./renderers/subsetOfRealsInput.tsx": () => import("./subsetOfRealsInput-DOuwuD0S.js"), "./renderers/summaryStatistics.tsx": () => import("./summaryStatistics-UkLlnT-n.js"), "./renderers/table.tsx": () => import("./table-jxsuCrwt.js"), "./renderers/tabular.tsx": () => import("./tabular-BF3RRZsS.js"), "./renderers/tag.tsx": () => import("./tag-KGFz2xPN.js"), "./renderers/text.tsx": () => import("./text-DsAFp_VY.js"), "./renderers/textInput.tsx": () => import("./textInput-DY_pGVok.js"), "./renderers/vector.tsx": () => import("./vector-PxTMsQM7.js"), "./renderers/video.tsx": () => import("./video-CWCqGFjO.js") }), `./renderers/${rendererClassName}.tsx`, 3));
    }
    let documentComponentInstructions = coreInfo.current.documentToRender;
    renderersLoadComponent(renderPromises, rendererClassNames).then((newRendererClasses) => {
      rendererClasses.current = newRendererClasses;
      let documentRendererClass = newRendererClasses[documentComponentInstructions.rendererType];
      setDocumentRenderer(
        React__default.createElement(documentRendererClass, {
          key: coreId.current + documentComponentInstructions.componentIdx,
          componentInstructions: documentComponentInstructions,
          rendererClasses: newRendererClasses,
          flags,
          coreId: coreId.current,
          docId,
          activityId,
          callAction,
          doenetViewerUrl,
          fetchExternalDoenetML,
          requestScrollTo
        })
      );
    }).catch((e2) => {
      errorInitializingRenderers.current = true;
    });
  }
  function updateRenderers({
    updateInstructions,
    actionId,
    errorWarnings: newErrorWarnings,
    init: init2 = false
  }) {
    if (newErrorWarnings) {
      errorWarnings.current = newErrorWarnings;
      setErrorsAndWarningsCallback?.(errorWarnings.current);
    }
    if (init2 && loadedInitialRendererState.current && !errorInitializingRenderers.current && !errorInsideRenderers.current && !hidden) {
      return;
    }
    for (let instruction of updateInstructions) {
      if (instruction.instructionType === "updateRendererStates") {
        for (let {
          componentIdx,
          stateValues,
          rendererType,
          childrenInstructions
        } of instruction.rendererStatesToUpdate) {
          dispatch(
            mainThunks.updateRendererSVs({
              coreId: coreId.current,
              componentIdx,
              stateValues,
              childrenInstructions,
              sourceOfUpdate: instruction.sourceOfUpdate,
              // Note: the reason we check both the renderer class and .type
              // is that if the renderer was memoized, then the renderer class itself is on .type,
              // Otherwise, the renderer class is the value of the rendererClasses entry.
              baseStateVariable: rendererClasses.current[rendererType]?.baseStateVariable || rendererClasses.current[rendererType]?.type?.baseStateVariable,
              actionId,
              prefixForIds,
              updatesToIgnoreRef
            })
          );
        }
      }
    }
    resolveAction({ actionId });
  }
  function resolveAction({ actionId }) {
    if (!actionId) {
      return;
    }
    const callback = onActionCallbacks.current.get(actionId);
    if (callback) {
      callback(true);
      onActionCallbacks.current.delete(actionId);
    }
    if (lastSkippableAction.current && onActionCallbacks.current.size === 0) {
      let actionToCall = lastSkippableAction.current;
      lastSkippableAction.current = null;
      callAction(actionToCall);
    }
  }
  function reportScoreAndStateCallback({
    score: score2,
    state
  }) {
    if (specifiedReportScoreAndStateCallback) {
      specifiedReportScoreAndStateCallback({
        score: score2,
        state,
        activityId,
        docId
      });
    } else {
      let messageId = nanoid$1();
      const message = {
        score: score2,
        state,
        subject: "SPLICE.reportScoreAndState",
        activity_id: activityId,
        doc_id: docId,
        message_id: messageId
      };
      console.log(message);
      if (flags.messageParent && window.parent) {
        window.parent.postMessage(message);
      } else {
        window.postMessage(message);
      }
    }
  }
  async function loadStateAndInitialize() {
    const coreIdWhenCalled = coreId.current;
    let loadedState = false;
    cid.current = await cidFromText(doenetML);
    if (flags.allowLocalState) {
      let localInfo;
      try {
        localInfo = await get$3(
          `${activityId}|${docId}|${attemptNumber}|${cid.current}`
        );
        if (localInfo.data_format_version !== data_format_version) {
          localInfo = void 0;
        }
      } catch (e2) {
      }
      if (localInfo) {
        const coreState = JSON.parse(
          localInfo.coreState,
          serializedComponentsReviver
        );
        const rendererState = localInfo.rendererState && JSON.parse(
          localInfo.rendererState,
          serializedComponentsReviver
        );
        const coreInfo2 = JSON.parse(
          localInfo.coreInfo,
          serializedComponentsReviver
        );
        loadedInitialRendererState.current = Boolean(rendererState);
        initializeRenderers({
          rendererState,
          coreInfo: coreInfo2
        });
        initialCoreData.current = {
          coreState,
          requestedVariant: JSON.parse(
            coreInfo2.generatedVariantString,
            serializedComponentsReviver
          )
        };
        loadedState = true;
      }
    }
    if (!loadedState) {
      if (flags.allowLoadState) {
        try {
          if (initialState2) {
            processLoadedDocState(initialState2);
          } else if (initialState2 === void 0) {
            requestStateViaSplice({
              cid: cid.current,
              activityId,
              docId,
              attemptNumber,
              userId
            });
          }
        } catch (e2) {
          setIsInErrorState?.(true);
          let message = "";
          if ("message" in e2) {
            message = e2.message;
          }
          setErrMsg(`Error loading doc state: ${message}`);
          return;
        }
      }
    }
    if (coreIdWhenCalled === coreId.current) {
      if (render) {
        startCore();
      } else {
        setStage("readyToCreateCore");
      }
    }
  }
  function requestStateViaSplice({
    cid: cid2,
    activityId: activityId2,
    docId: docId2,
    attemptNumber: attemptNumber2,
    userId: userId2
  }) {
    let messageId = nanoid$1();
    messageIdFromGetState.current = messageId;
    const message = {
      subject: "SPLICE.getState",
      message_id: messageId,
      cid: cid2,
      domain_id: "Doenet",
      activity_id: activityId2,
      doc_id: docId2,
      attempt_number: attemptNumber2,
      user_id: userId2
    };
    console.log(message);
    if (flags.messageParent && window.parent) {
      window.parent.postMessage(message);
    } else {
      window.postMessage(message);
    }
  }
  function processLoadedDocState(data) {
    let coreInfo2 = JSON.parse(data.coreInfo, serializedComponentsReviver);
    let rendererState = data.rendererState && JSON.parse(data.rendererState, serializedComponentsReviver);
    loadedInitialRendererState.current = Boolean(rendererState);
    initializeRenderers({
      rendererState,
      coreInfo: coreInfo2
    });
    initialCoreData.current = {
      coreState: JSON.parse(data.coreState, serializedComponentsReviver),
      requestedVariant: JSON.parse(
        coreInfo2.generatedVariantString,
        serializedComponentsReviver
      )
    };
    initializeCounters.current = data.initializeCounters;
  }
  async function startCore() {
    let thisCoreWorker = coreWorker.current;
    if (coreCreated.current || !thisCoreWorker) {
      thisCoreWorker = await reinitializeCoreAndTerminateAnimations();
    } else {
      let initializeResult = await initializeCoreWorker({
        coreWorker: thisCoreWorker,
        doenetML,
        flags,
        activityId,
        docId,
        requestedVariantIndex,
        attemptNumber,
        documentStructureCallback,
        fetchExternalDoenetML
      });
      if (initializeResult.success === false) {
        setErrMsg(
          `Error initializing activity: ${initializeResult.errMsg}`
        );
        return;
      }
    }
    onActionCallbacks.current.clear();
    coreCreationInProgress.current = true;
    const dastResult = await thisCoreWorker.generateJavascriptDast(
      {
        coreId: coreId.current,
        userId,
        cid: cid.current,
        theme: darkMode,
        requestedVariant: initialCoreData.current?.requestedVariant,
        stateVariableChanges: initialCoreData.current?.coreState ? JSON.stringify(
          initialCoreData.current.coreState,
          serializedComponentsReplacer
        ) : void 0,
        initializeCounters: initializeCounters.current
      },
      proxy(updateRenderers),
      proxy(reportScoreAndStateCallback),
      proxy(requestAnimationFrame2),
      proxy(cancelAnimationFrame2),
      proxy(copyToClipboard),
      proxy(sendEvent),
      proxy(requestSolutionView)
    );
    if (dastResult.success) {
      if (coreInfo.current && JSON.stringify(coreInfo.current) === JSON.stringify(dastResult.coreInfo) && !errorInitializingRenderers.current && !errorInsideRenderers.current) ;
      else {
        initializeRenderers({ coreInfo: dastResult.coreInfo });
        if (errorInsideRenderers.current) {
          setIgnoreRendererError(true);
          setIsInErrorState?.(false);
        }
      }
      if (dastResult.errorWarnings) {
        errorWarnings.current = dastResult.errorWarnings;
        setErrorsAndWarningsCallback?.(errorWarnings.current);
      }
    } else {
      setIsInErrorState?.(true);
      setErrMsg(dastResult.errMsg);
    }
    coreCreated.current = true;
    coreCreationInProgress.current = false;
    preventMoreAnimations.current = false;
    for (let actionArgs of actionsBeforeCoreCreated.current) {
      executeAction(actionArgs);
    }
    setStage("coreCreated");
    initializedCallback?.({ activityId, docId });
  }
  function requestAnimationFrame2({
    action,
    actionArgs,
    delay: delay2,
    animationId
  }) {
    if (!preventMoreAnimations.current) {
      if (delay2) {
        let timeoutId = window.setTimeout(
          () => _requestAnimationFrame({
            action,
            actionArgs,
            animationId
          }),
          delay2
        );
        animationInfo.current[animationId] = { timeoutId };
      } else {
        animationInfo.current[animationId] = {};
        _requestAnimationFrame({ action, actionArgs, animationId });
      }
    }
  }
  function _requestAnimationFrame({
    action,
    actionArgs,
    animationId
  }) {
    let animationFrameID = window.requestAnimationFrame(
      () => callAction({
        action,
        args: actionArgs
      })
    );
    let animationInfoObj = animationInfo.current[animationId];
    delete animationInfoObj.timeoutId;
    animationInfoObj.animationFrameID = animationFrameID;
  }
  async function cancelAnimationFrame2(animationId) {
    let animationInfoObj = animationInfo.current[animationId];
    let timeoutId = animationInfoObj?.timeoutId;
    if (timeoutId !== void 0) {
      window.clearTimeout(timeoutId);
    }
    let animationFrameID = animationInfoObj?.animationFrameID;
    if (animationFrameID !== void 0) {
      window.cancelAnimationFrame(animationFrameID);
    }
    delete animationInfo.current[animationId];
  }
  function sendEvent(data) {
    const message = {
      data,
      subject: "SPLICE.sendEvent",
      message_id: nanoid$1(),
      name: data.verb
    };
    console.log(message);
    if (flags.messageParent && window.parent) {
      window.parent.postMessage(message);
    } else {
      window.postMessage(message);
    }
  }
  function requestSolutionView(componentIdx) {
    let messageId = nanoid$1();
    let requestSolutionPromiseResolve, requestSolutionPromiseReject;
    const requestSolutionViewPromise = new Promise(
      (resolve, reject2) => {
        requestSolutionPromiseResolve = resolve;
        requestSolutionPromiseReject = reject2;
        const message = {
          subject: "SPLICE.requestSolutionView",
          message_id: messageId,
          activity_id: activityId,
          doc_id: docId,
          attempt_number: attemptNumber,
          user_id: userId,
          component_idx: componentIdx
        };
        console.log(message);
        if (flags.messageParent && window.parent) {
          window.parent.postMessage(message);
        } else {
          window.postMessage(message);
        }
      }
    );
    requestSolutionViewPromises.current[messageId] = {
      resolve: requestSolutionPromiseResolve,
      reject: requestSolutionPromiseReject
    };
    return requestSolutionViewPromise;
  }
  async function copyToClipboard({
    text: text2,
    actionId
  }) {
    if (typeof text2 === "string") {
      await navigator.clipboard.writeText(text2);
    }
    resolveAction({ actionId });
  }
  function errorHandler() {
    errorInsideRenderers.current = true;
    if (ignoreRendererError) {
      setIgnoreRendererError(false);
    }
  }
  let changedState = false;
  const initialPass = lastDoenetML.current === null;
  if (initialPass && !render) {
    let newCoreWorker = createCoreWorker();
    coreWorker.current = newCoreWorker;
    initializeCoreWorker({
      coreWorker: newCoreWorker,
      doenetML,
      flags,
      activityId,
      docId,
      requestedVariantIndex,
      attemptNumber,
      documentStructureCallback,
      fetchExternalDoenetML
    });
    return null;
  }
  if (lastDoenetML.current !== doenetML) {
    lastDoenetML.current = doenetML;
    changedState = true;
  }
  if (lastDocId.current !== docId) {
    lastDocId.current = docId;
    changedState = true;
  }
  if (lastActivityId.current !== activityId) {
    lastActivityId.current = activityId;
    changedState = true;
  }
  if (lastAttemptNumber.current !== attemptNumber) {
    lastAttemptNumber.current = attemptNumber;
    changedState = true;
  }
  if (lastRequestedVariantIndex.current !== requestedVariantIndex) {
    lastRequestedVariantIndex.current = requestedVariantIndex;
    changedState = true;
  }
  if (changedState) {
    if (errMsg !== null) {
      setErrMsg(null);
      setIsInErrorState?.(false);
    }
    coreId.current = nanoid$1();
    initialCoreData.current = null;
    coreInfo.current = null;
    setDocumentRenderer(null);
    coreCreated.current = false;
    coreCreationInProgress.current = false;
    loadedInitialRendererState.current = false;
    setStage("wait");
    loadStateAndInitialize();
    return null;
  }
  if (errMsg !== null) {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
      "div",
      {
        style: {
          fontSize: "1.3em",
          marginLeft: "20px",
          marginTop: "20px"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx(MdError, { color: "red", fontSize: "24pt" }),
          " ",
          errMsg
        ]
      }
    );
  }
  if (stage === "wait") {
    return null;
  }
  if (stage === "readyToCreateCore" && render) {
    startCore();
  } else if (stage === "waitingOnCore" && !render && !coreCreated.current) {
    reinitializeCoreAndTerminateAnimations();
    setStage("readyToCreateCore");
  }
  if (hidden || !render) {
    return null;
  }
  let noCoreWarning = null;
  let viewerStyle = {
    maxWidth: "850px",
    paddingLeft: "20px",
    paddingRight: "20px",
    backgroundColor: "inherit",
    containerType: "inline-size"
  };
  if (!coreCreated.current) {
    if (!documentRenderer) {
      noCoreWarning = /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { style: { backgroundColor: "lightCyan" }, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { children: "Initializing...." }) });
    }
    viewerStyle.backgroundColor = "#F0F0F0";
  }
  let errorOverview = null;
  if (documentRenderer && errorWarnings.current?.errors.length > 0) {
    let errorStyle = {
      backgroundColor: "#ff9999",
      textAlign: "center",
      borderWidth: 3,
      borderStyle: "solid"
    };
    errorOverview = /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { style: errorStyle, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("b", { children: "This document contains errors!" }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
    ErrorBoundary,
    {
      setIsInErrorState,
      errorHandler,
      ignoreError: ignoreRendererError,
      coreCreated: coreCreated.current,
      children: [
        noCoreWarning,
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { style: viewerStyle, className: "doenet-viewer", children: [
          errorOverview,
          /* @__PURE__ */ jsxRuntimeExports$3.jsx(DocContext.Provider, { value: contextForRenderers, children: documentRenderer })
        ] })
      ]
    }
  );
}
async function renderersLoadComponent(promises, rendererClassNames) {
  var rendererClasses = {};
  for (let [index2, promise] of promises.entries()) {
    try {
      let module = await promise;
      rendererClasses[rendererClassNames[index2]] = module.default;
    } catch (error) {
      console.log("here:", error);
      throw Error(`loading ${rendererClassNames[index2]} failed.`);
    }
  }
  return rendererClasses;
}
class ErrorBoundary extends React__default.Component {
  constructor(props2) {
    super(props2);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(_2) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    this.props.setIsInErrorState?.(true);
    this.props.errorHandler?.();
  }
  render() {
    if (this.state.hasError && !this.props.ignoreError) {
      if (!this.props.coreCreated) {
        return null;
      } else {
        return /* @__PURE__ */ jsxRuntimeExports$3.jsx("h1", { children: "Something went wrong." });
      }
    }
    return this.props.children;
  }
}
var __assign$1 = function() {
  return (__assign$1 = Object.assign || function(e2) {
    for (var t2, o = 1, n = arguments.length; o < n; o++) for (var i2 in t2 = arguments[o]) Object.prototype.hasOwnProperty.call(t2, i2) && (e2[i2] = t2[i2]);
    return e2;
  }).apply(this, arguments);
};
var v2Promise, v3Promise, v4Promise, MathJaxBaseContext = createContext(void 0), DEFAULT_V2_SRC = "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.9/MathJax.js?config=TeX-MML-AM_CHTML", DEFAULT_V3_SRC = "https://cdnjs.cloudflare.com/ajax/libs/mathjax/3.2.2/es5/tex-mml-chtml.js", DEFAULT_V4_SRC = "https://cdn.jsdelivr.net/npm/mathjax@4/tex-mml-chtml.js", MathJaxContext = function(e2) {
  var n = e2.config, t2 = e2.version, t2 = void 0 === t2 ? 4 : t2, o = e2.src, o = void 0 === o ? 2 === t2 ? DEFAULT_V2_SRC : 3 === t2 ? DEFAULT_V3_SRC : DEFAULT_V4_SRC : o, i2 = e2.onStartup, r = e2.onLoad, a = e2.asyncLoad, s = void 0 !== a && a, d = e2.onError, a = e2.typesettingOptions, c2 = e2.renderMode, c2 = void 0 === c2 ? "post" : c2, h = e2.hideUntilTypeset, e2 = e2.children, v2 = useContext(MathJaxBaseContext);
  if (void 0 !== (null == v2 ? void 0 : v2.version) && (null == v2 ? void 0 : v2.version) !== t2) throw Error("Cannot nest MathJaxContexts with different versions. MathJaxContexts should not be nested at all but if they are, they cannot have different versions. Stick with one version of MathJax in your app and avoid using more than one MathJaxContext.");
  if (2 === t2 && (void 0 !== v3Promise || void 0 !== v4Promise) || 3 === t2 && (void 0 !== v2Promise || void 0 !== v4Promise) || 4 === t2 && (void 0 !== v2Promise || void 0 !== v3Promise)) throw Error("Cannot use two MathJax versions simultaneously in the same app due to how MathJax is set up in the browser; either you have multiple MathJaxContexts with different versions or you have mounted and unmounted MathJaxContexts with different versions. Please stick with one version of MathJax in your app. File an issue in the project Github page if you need this feature.");
  var u = useRef(v2), v2 = useRef((null == v2 ? void 0 : v2.version) || null);
  if (null === v2.current) v2.current = t2;
  else if (v2.current !== t2) throw Error("Cannot change version of MathJax in a MathJaxContext after it has mounted. Reload the page with a new version when this must happen.");
  var m = o || (2 === t2 ? DEFAULT_V2_SRC : 3 === t2 ? DEFAULT_V3_SRC : DEFAULT_V4_SRC);
  function f2(t3, o2) {
    n && (window.MathJax = n);
    var e3 = document.createElement("script");
    e3.type = "text/javascript", e3.src = m, e3.async = s, e3.addEventListener("load", function() {
      var e4 = window.MathJax;
      i2 && i2(e4), t3(e4), r && r();
    }), e3.addEventListener("error", function(e4) {
      return o2(e4);
    }), document.getElementsByTagName("head")[0].appendChild(e3);
  }
  return void 0 === u.current && (v2 = { typesettingOptions: a, renderMode: c2, hideUntilTypeset: h }, 2 === t2 ? void 0 === v2Promise && ("undefined" != typeof window ? (v2Promise = new Promise(f2)).catch(function(e3) {
    if (!d) throw Error("Failed to download MathJax version 2 from '".concat(m, "' due to: ").concat(JSON.stringify(e3)));
    d(e3);
  }) : (v2Promise = Promise.reject()).catch(function(e3) {
  })) : 3 === t2 ? void 0 === v3Promise && ("undefined" != typeof window ? (v3Promise = new Promise(f2)).catch(function(e3) {
    if (!d) throw Error("Failed to download MathJax version 3 from '".concat(m, "' due to: ").concat(e3));
    d(e3);
  }) : (v3Promise = Promise.reject()).catch(function(e3) {
  })) : void 0 === v4Promise && ("undefined" != typeof window ? (v4Promise = new Promise(f2)).catch(function(e3) {
    if (!d) throw Error("Failed to download MathJax version 4 from '".concat(m, "' due to: ").concat(e3));
    d(e3);
  }) : (v4Promise = Promise.reject()).catch(function(e3) {
  })), u.current = __assign$1(__assign$1({}, v2), 2 === t2 ? { version: 2, promise: v2Promise } : 3 === t2 ? { version: 3, promise: v3Promise } : { version: 4, promise: v4Promise })), React__default.createElement(MathJaxBaseContext.Provider, { value: u.current }, e2);
};
var __assign = function() {
  return (__assign = Object.assign || function(e2) {
    for (var t2, n = 1, r = arguments.length; n < r; n++) for (var i2 in t2 = arguments[n]) Object.prototype.hasOwnProperty.call(t2, i2) && (e2[i2] = t2[i2]);
    return e2;
  }).apply(this, arguments);
}, __rest = function(e2, t2) {
  var n = {};
  for (i2 in e2) Object.prototype.hasOwnProperty.call(e2, i2) && t2.indexOf(i2) < 0 && (n[i2] = e2[i2]);
  if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) for (var r = 0, i2 = Object.getOwnPropertySymbols(e2); r < i2.length; r++) t2.indexOf(i2[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, i2[r]) && (n[i2[r]] = e2[i2[r]]);
  return n;
};
var typesettingFailed = function(e2) {
  return "Typesetting failed: ".concat(void 0 !== e2.message ? e2.message : JSON.stringify(e2));
}, MathJax = function(e2) {
  function r() {
    var e3;
    "every" === h && m && "post" === v2 && null !== f2.current && (f2.current.style.visibility = null != (e3 = null == (e3 = p.style) ? void 0 : e3.visibility) ? e3 : "visible"), _2.current || ("first" === h && null !== f2.current && (f2.current.style.visibility = "visible"), n && n(), _2.current = true), o && o(), b2.current = false;
  }
  var t2 = e2.inline, i2 = void 0 !== t2 && t2, t2 = e2.hideUntilTypeset, n = e2.onInitTypeset, o = e2.onTypeset, s = e2.text, u = e2.dynamic, a = e2.typesettingOptions, l = e2.renderMode, c2 = e2.children, p = __rest(e2, ["inline", "hideUntilTypeset", "onInitTypeset", "onTypeset", "text", "dynamic", "typesettingOptions", "renderMode", "children"]), y = useRef(""), f2 = useRef(null), d = useContext(MathJaxBaseContext), h = null != t2 ? t2 : null == d ? void 0 : d.hideUntilTypeset, v2 = null != l ? l : null == d ? void 0 : d.renderMode, g = null != a ? a : null == d ? void 0 : d.typesettingOptions, m = false !== u && (u || "production" !== process.env.NODE_ENV), _2 = useRef(false), b2 = useRef(false);
  return !b2.current && null !== f2.current && m && "every" === h && "post" === v2 && (f2.current.style.visibility = "hidden"), ("undefined" != typeof window ? useLayoutEffect : useEffect)(function() {
    if ((m || !_2.current) && null !== f2.current) {
      if (!d) throw Error("MathJax was not loaded, did you use the MathJax component outside of a MathJaxContext?");
      if ("pre" === v2) {
        if (!("string" == typeof (e3 = s) && 0 < e3.length)) throw Error(`Render mode 'pre' requires text prop to be set and non-empty, which was currently "`.concat(s, '"'));
        if (!a || !a.fn) throw Error("Render mode 'pre' requires 'typesettingOptions' prop with 'fn' property to be set on MathJax element or in the MathJaxContext");
        if (2 === d.version) throw Error("Render mode 'pre' only available with MathJax 3 and 4, and version 2 is currently in use");
      }
      "post" !== v2 && s === y.current || b2.current || (b2.current = true, 3 === d.version || 4 === d.version ? d.promise.then(function(t3) {
        var n3;
        "pre" === v2 ? (n3 = function(e4) {
          y.current = s, t3.startup.document.clear(), t3.startup.document.updateDocument(), null !== f2.current && (f2.current.innerHTML = e4.outerHTML), r();
        }, a.fn.endsWith("Promise") ? t3.startup.promise.then(function() {
          return t3[g.fn](s, __assign(__assign({}, (null == g ? void 0 : g.options) || {}), { display: !i2 }));
        }).then(n3).catch(function(e4) {
          throw r(), Error(typesettingFailed(e4));
        }) : t3.startup.promise.then(function() {
          var e4 = t3[g.fn](s, __assign(__assign({}, (null == g ? void 0 : g.options) || {}), { display: !i2 }));
          n3(e4);
        }).catch(function(e4) {
          throw r(), Error(typesettingFailed(e4));
        })) : t3.startup.promise.then(function() {
          return t3.typesetClear([f2.current]), t3.typesetPromise([f2.current]);
        }).then(r).catch(function(e4) {
          throw r(), Error(typesettingFailed(e4));
        });
      }).catch(function(e4) {
        throw r(), Error(typesettingFailed(e4));
      }) : d.promise.then(function(e4) {
        e4.Hub.Queue(["Typeset", e4.Hub, f2.current]), e4.Hub.Queue(r);
      }).catch(function(e4) {
        throw r(), Error(typesettingFailed(e4));
      }));
    }
    var e3;
  }), React__default.createElement("span", __assign({}, p, { style: __assign(__assign({ display: i2 ? "inline" : "block" }, p.style), { visibility: h ? "hidden" : null == (e2 = p.style) ? void 0 : e2.visibility }), ref: f2 }), c2);
};
var client = { exports: {} };
var reactDomClient_production = {};
var scheduler = { exports: {} };
var scheduler_production = {};
var hasRequiredScheduler_production;
function requireScheduler_production() {
  if (hasRequiredScheduler_production) return scheduler_production;
  hasRequiredScheduler_production = 1;
  (function(exports$12) {
    function push2(heap, node) {
      var index2 = heap.length;
      heap.push(node);
      a: for (; 0 < index2; ) {
        var parentIndex = index2 - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare2(parent, node))
          heap[parentIndex] = node, heap[index2] = parent, index2 = parentIndex;
        else break a;
      }
    }
    function peek2(heap) {
      return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
      if (0 === heap.length) return null;
      var first2 = heap[0], last2 = heap.pop();
      if (last2 !== first2) {
        heap[0] = last2;
        a: for (var index2 = 0, length = heap.length, halfLength = length >>> 1; index2 < halfLength; ) {
          var leftIndex = 2 * (index2 + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
          if (0 > compare2(left, last2))
            rightIndex < length && 0 > compare2(right, left) ? (heap[index2] = right, heap[rightIndex] = last2, index2 = rightIndex) : (heap[index2] = left, heap[leftIndex] = last2, index2 = leftIndex);
          else if (rightIndex < length && 0 > compare2(right, last2))
            heap[index2] = right, heap[rightIndex] = last2, index2 = rightIndex;
          else break a;
        }
      }
      return first2;
    }
    function compare2(a, b2) {
      var diff = a.sortIndex - b2.sortIndex;
      return 0 !== diff ? diff : a.id - b2.id;
    }
    exports$12.unstable_now = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var localPerformance = performance;
      exports$12.unstable_now = function() {
        return localPerformance.now();
      };
    } else {
      var localDate = Date, initialTime = localDate.now();
      exports$12.unstable_now = function() {
        return localDate.now() - initialTime;
      };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = false, isHostCallbackScheduled = false, isHostTimeoutScheduled = false, needsPaint = false, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
    function advanceTimers(currentTime) {
      for (var timer = peek2(timerQueue); null !== timer; ) {
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime)
          pop(timerQueue), timer.sortIndex = timer.expirationTime, push2(taskQueue, timer);
        else break;
        timer = peek2(timerQueue);
      }
    }
    function handleTimeout(currentTime) {
      isHostTimeoutScheduled = false;
      advanceTimers(currentTime);
      if (!isHostCallbackScheduled)
        if (null !== peek2(taskQueue))
          isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline());
        else {
          var firstTimer = peek2(timerQueue);
          null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
    var isMessageLoopRunning = false, taskTimeoutID = -1, frameInterval = 5, startTime2 = -1;
    function shouldYieldToHost() {
      return needsPaint ? true : exports$12.unstable_now() - startTime2 < frameInterval ? false : true;
    }
    function performWorkUntilDeadline() {
      needsPaint = false;
      if (isMessageLoopRunning) {
        var currentTime = exports$12.unstable_now();
        startTime2 = currentTime;
        var hasMoreWork = true;
        try {
          a: {
            isHostCallbackScheduled = false;
            isHostTimeoutScheduled && (isHostTimeoutScheduled = false, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
            isPerformingWork = true;
            var previousPriorityLevel = currentPriorityLevel;
            try {
              b: {
                advanceTimers(currentTime);
                for (currentTask = peek2(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost()); ) {
                  var callback = currentTask.callback;
                  if ("function" === typeof callback) {
                    currentTask.callback = null;
                    currentPriorityLevel = currentTask.priorityLevel;
                    var continuationCallback = callback(
                      currentTask.expirationTime <= currentTime
                    );
                    currentTime = exports$12.unstable_now();
                    if ("function" === typeof continuationCallback) {
                      currentTask.callback = continuationCallback;
                      advanceTimers(currentTime);
                      hasMoreWork = true;
                      break b;
                    }
                    currentTask === peek2(taskQueue) && pop(taskQueue);
                    advanceTimers(currentTime);
                  } else pop(taskQueue);
                  currentTask = peek2(taskQueue);
                }
                if (null !== currentTask) hasMoreWork = true;
                else {
                  var firstTimer = peek2(timerQueue);
                  null !== firstTimer && requestHostTimeout(
                    handleTimeout,
                    firstTimer.startTime - currentTime
                  );
                  hasMoreWork = false;
                }
              }
              break a;
            } finally {
              currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = false;
            }
            hasMoreWork = void 0;
          }
        } finally {
          hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = false;
        }
      }
    }
    var schedulePerformWorkUntilDeadline;
    if ("function" === typeof localSetImmediate)
      schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
      };
    else if ("undefined" !== typeof MessageChannel) {
      var channel = new MessageChannel(), port = channel.port2;
      channel.port1.onmessage = performWorkUntilDeadline;
      schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
      };
    } else
      schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
      };
    function requestHostTimeout(callback, ms2) {
      taskTimeoutID = localSetTimeout(function() {
        callback(exports$12.unstable_now());
      }, ms2);
    }
    exports$12.unstable_IdlePriority = 5;
    exports$12.unstable_ImmediatePriority = 1;
    exports$12.unstable_LowPriority = 4;
    exports$12.unstable_NormalPriority = 3;
    exports$12.unstable_Profiling = null;
    exports$12.unstable_UserBlockingPriority = 2;
    exports$12.unstable_cancelCallback = function(task) {
      task.callback = null;
    };
    exports$12.unstable_forceFrameRate = function(fps) {
      0 > fps || 125 < fps ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    exports$12.unstable_getCurrentPriorityLevel = function() {
      return currentPriorityLevel;
    };
    exports$12.unstable_next = function(eventHandler) {
      switch (currentPriorityLevel) {
        case 1:
        case 2:
        case 3:
          var priorityLevel = 3;
          break;
        default:
          priorityLevel = currentPriorityLevel;
      }
      var previousPriorityLevel = currentPriorityLevel;
      currentPriorityLevel = priorityLevel;
      try {
        return eventHandler();
      } finally {
        currentPriorityLevel = previousPriorityLevel;
      }
    };
    exports$12.unstable_requestPaint = function() {
      needsPaint = true;
    };
    exports$12.unstable_runWithPriority = function(priorityLevel, eventHandler) {
      switch (priorityLevel) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          priorityLevel = 3;
      }
      var previousPriorityLevel = currentPriorityLevel;
      currentPriorityLevel = priorityLevel;
      try {
        return eventHandler();
      } finally {
        currentPriorityLevel = previousPriorityLevel;
      }
    };
    exports$12.unstable_scheduleCallback = function(priorityLevel, callback, options2) {
      var currentTime = exports$12.unstable_now();
      "object" === typeof options2 && null !== options2 ? (options2 = options2.delay, options2 = "number" === typeof options2 && 0 < options2 ? currentTime + options2 : currentTime) : options2 = currentTime;
      switch (priorityLevel) {
        case 1:
          var timeout = -1;
          break;
        case 2:
          timeout = 250;
          break;
        case 5:
          timeout = 1073741823;
          break;
        case 4:
          timeout = 1e4;
          break;
        default:
          timeout = 5e3;
      }
      timeout = options2 + timeout;
      priorityLevel = {
        id: taskIdCounter++,
        callback,
        priorityLevel,
        startTime: options2,
        expirationTime: timeout,
        sortIndex: -1
      };
      options2 > currentTime ? (priorityLevel.sortIndex = options2, push2(timerQueue, priorityLevel), null === peek2(taskQueue) && priorityLevel === peek2(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = true, requestHostTimeout(handleTimeout, options2 - currentTime))) : (priorityLevel.sortIndex = timeout, push2(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline())));
      return priorityLevel;
    };
    exports$12.unstable_shouldYield = shouldYieldToHost;
    exports$12.unstable_wrapCallback = function(callback) {
      var parentPriorityLevel = currentPriorityLevel;
      return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
          return callback.apply(this, arguments);
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
    };
  })(scheduler_production);
  return scheduler_production;
}
var scheduler_development = {};
var hasRequiredScheduler_development;
function requireScheduler_development() {
  if (hasRequiredScheduler_development) return scheduler_development;
  hasRequiredScheduler_development = 1;
  (function(exports$12) {
    "production" !== process.env.NODE_ENV && (function() {
      function performWorkUntilDeadline() {
        needsPaint = false;
        if (isMessageLoopRunning) {
          var currentTime = exports$12.unstable_now();
          startTime2 = currentTime;
          var hasMoreWork = true;
          try {
            a: {
              isHostCallbackScheduled = false;
              isHostTimeoutScheduled && (isHostTimeoutScheduled = false, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
              isPerformingWork = true;
              var previousPriorityLevel = currentPriorityLevel;
              try {
                b: {
                  advanceTimers(currentTime);
                  for (currentTask = peek2(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost()); ) {
                    var callback = currentTask.callback;
                    if ("function" === typeof callback) {
                      currentTask.callback = null;
                      currentPriorityLevel = currentTask.priorityLevel;
                      var continuationCallback = callback(
                        currentTask.expirationTime <= currentTime
                      );
                      currentTime = exports$12.unstable_now();
                      if ("function" === typeof continuationCallback) {
                        currentTask.callback = continuationCallback;
                        advanceTimers(currentTime);
                        hasMoreWork = true;
                        break b;
                      }
                      currentTask === peek2(taskQueue) && pop(taskQueue);
                      advanceTimers(currentTime);
                    } else pop(taskQueue);
                    currentTask = peek2(taskQueue);
                  }
                  if (null !== currentTask) hasMoreWork = true;
                  else {
                    var firstTimer = peek2(timerQueue);
                    null !== firstTimer && requestHostTimeout(
                      handleTimeout,
                      firstTimer.startTime - currentTime
                    );
                    hasMoreWork = false;
                  }
                }
                break a;
              } finally {
                currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = false;
              }
              hasMoreWork = void 0;
            }
          } finally {
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = false;
          }
        }
      }
      function push2(heap, node) {
        var index2 = heap.length;
        heap.push(node);
        a: for (; 0 < index2; ) {
          var parentIndex = index2 - 1 >>> 1, parent = heap[parentIndex];
          if (0 < compare2(parent, node))
            heap[parentIndex] = node, heap[index2] = parent, index2 = parentIndex;
          else break a;
        }
      }
      function peek2(heap) {
        return 0 === heap.length ? null : heap[0];
      }
      function pop(heap) {
        if (0 === heap.length) return null;
        var first2 = heap[0], last2 = heap.pop();
        if (last2 !== first2) {
          heap[0] = last2;
          a: for (var index2 = 0, length = heap.length, halfLength = length >>> 1; index2 < halfLength; ) {
            var leftIndex = 2 * (index2 + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare2(left, last2))
              rightIndex < length && 0 > compare2(right, left) ? (heap[index2] = right, heap[rightIndex] = last2, index2 = rightIndex) : (heap[index2] = left, heap[leftIndex] = last2, index2 = leftIndex);
            else if (rightIndex < length && 0 > compare2(right, last2))
              heap[index2] = right, heap[rightIndex] = last2, index2 = rightIndex;
            else break a;
          }
        }
        return first2;
      }
      function compare2(a, b2) {
        var diff = a.sortIndex - b2.sortIndex;
        return 0 !== diff ? diff : a.id - b2.id;
      }
      function advanceTimers(currentTime) {
        for (var timer = peek2(timerQueue); null !== timer; ) {
          if (null === timer.callback) pop(timerQueue);
          else if (timer.startTime <= currentTime)
            pop(timerQueue), timer.sortIndex = timer.expirationTime, push2(taskQueue, timer);
          else break;
          timer = peek2(timerQueue);
        }
      }
      function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled)
          if (null !== peek2(taskQueue))
            isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline());
          else {
            var firstTimer = peek2(timerQueue);
            null !== firstTimer && requestHostTimeout(
              handleTimeout,
              firstTimer.startTime - currentTime
            );
          }
      }
      function shouldYieldToHost() {
        return needsPaint ? true : exports$12.unstable_now() - startTime2 < frameInterval ? false : true;
      }
      function requestHostTimeout(callback, ms2) {
        taskTimeoutID = localSetTimeout(function() {
          callback(exports$12.unstable_now());
        }, ms2);
      }
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      exports$12.unstable_now = void 0;
      if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        exports$12.unstable_now = function() {
          return localPerformance.now();
        };
      } else {
        var localDate = Date, initialTime = localDate.now();
        exports$12.unstable_now = function() {
          return localDate.now() - initialTime;
        };
      }
      var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = false, isHostCallbackScheduled = false, isHostTimeoutScheduled = false, needsPaint = false, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null, isMessageLoopRunning = false, taskTimeoutID = -1, frameInterval = 5, startTime2 = -1;
      if ("function" === typeof localSetImmediate)
        var schedulePerformWorkUntilDeadline = function() {
          localSetImmediate(performWorkUntilDeadline);
        };
      else if ("undefined" !== typeof MessageChannel) {
        var channel = new MessageChannel(), port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
          port.postMessage(null);
        };
      } else
        schedulePerformWorkUntilDeadline = function() {
          localSetTimeout(performWorkUntilDeadline, 0);
        };
      exports$12.unstable_IdlePriority = 5;
      exports$12.unstable_ImmediatePriority = 1;
      exports$12.unstable_LowPriority = 4;
      exports$12.unstable_NormalPriority = 3;
      exports$12.unstable_Profiling = null;
      exports$12.unstable_UserBlockingPriority = 2;
      exports$12.unstable_cancelCallback = function(task) {
        task.callback = null;
      };
      exports$12.unstable_forceFrameRate = function(fps) {
        0 > fps || 125 < fps ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
      };
      exports$12.unstable_getCurrentPriorityLevel = function() {
        return currentPriorityLevel;
      };
      exports$12.unstable_next = function(eventHandler) {
        switch (currentPriorityLevel) {
          case 1:
          case 2:
          case 3:
            var priorityLevel = 3;
            break;
          default:
            priorityLevel = currentPriorityLevel;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
      exports$12.unstable_requestPaint = function() {
        needsPaint = true;
      };
      exports$12.unstable_runWithPriority = function(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            priorityLevel = 3;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
      exports$12.unstable_scheduleCallback = function(priorityLevel, callback, options2) {
        var currentTime = exports$12.unstable_now();
        "object" === typeof options2 && null !== options2 ? (options2 = options2.delay, options2 = "number" === typeof options2 && 0 < options2 ? currentTime + options2 : currentTime) : options2 = currentTime;
        switch (priorityLevel) {
          case 1:
            var timeout = -1;
            break;
          case 2:
            timeout = 250;
            break;
          case 5:
            timeout = 1073741823;
            break;
          case 4:
            timeout = 1e4;
            break;
          default:
            timeout = 5e3;
        }
        timeout = options2 + timeout;
        priorityLevel = {
          id: taskIdCounter++,
          callback,
          priorityLevel,
          startTime: options2,
          expirationTime: timeout,
          sortIndex: -1
        };
        options2 > currentTime ? (priorityLevel.sortIndex = options2, push2(timerQueue, priorityLevel), null === peek2(taskQueue) && priorityLevel === peek2(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = true, requestHostTimeout(handleTimeout, options2 - currentTime))) : (priorityLevel.sortIndex = timeout, push2(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline())));
        return priorityLevel;
      };
      exports$12.unstable_shouldYield = shouldYieldToHost;
      exports$12.unstable_wrapCallback = function(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;
          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      };
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(scheduler_development);
  return scheduler_development;
}
var hasRequiredScheduler;
function requireScheduler() {
  if (hasRequiredScheduler) return scheduler.exports;
  hasRequiredScheduler = 1;
  if (process.env.NODE_ENV === "production") {
    scheduler.exports = requireScheduler_production();
  } else {
    scheduler.exports = requireScheduler_development();
  }
  return scheduler.exports;
}
var hasRequiredReactDomClient_production;
function requireReactDomClient_production() {
  if (hasRequiredReactDomClient_production) return reactDomClient_production;
  hasRequiredReactDomClient_production = 1;
  var Scheduler2 = requireScheduler(), React2 = React__default, ReactDOM = require$$2;
  function formatProdErrorMessage2(code2) {
    var url = "https://react.dev/errors/" + code2;
    if (1 < arguments.length) {
      url += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i2 = 2; i2 < arguments.length; i2++)
        url += "&args[]=" + encodeURIComponent(arguments[i2]);
    }
    return "Minified React error #" + code2 + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
  }
  function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for (; node.return; ) node = node.return;
    else {
      fiber = node;
      do
        node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
      while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
  }
  function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
      var suspenseState = fiber.memoizedState;
      null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
      if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
  }
  function getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
      var activityState = fiber.memoizedState;
      null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
      if (null !== activityState) return activityState.dehydrated;
    }
    return null;
  }
  function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber)
      throw Error(formatProdErrorMessage2(188));
  }
  function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
      alternate = getNearestMountedFiber(fiber);
      if (null === alternate) throw Error(formatProdErrorMessage2(188));
      return alternate !== fiber ? null : fiber;
    }
    for (var a = fiber, b2 = alternate; ; ) {
      var parentA = a.return;
      if (null === parentA) break;
      var parentB = parentA.alternate;
      if (null === parentB) {
        b2 = parentA.return;
        if (null !== b2) {
          a = b2;
          continue;
        }
        break;
      }
      if (parentA.child === parentB.child) {
        for (parentB = parentA.child; parentB; ) {
          if (parentB === a) return assertIsMounted(parentA), fiber;
          if (parentB === b2) return assertIsMounted(parentA), alternate;
          parentB = parentB.sibling;
        }
        throw Error(formatProdErrorMessage2(188));
      }
      if (a.return !== b2.return) a = parentA, b2 = parentB;
      else {
        for (var didFindChild = false, child$0 = parentA.child; child$0; ) {
          if (child$0 === a) {
            didFindChild = true;
            a = parentA;
            b2 = parentB;
            break;
          }
          if (child$0 === b2) {
            didFindChild = true;
            b2 = parentA;
            a = parentB;
            break;
          }
          child$0 = child$0.sibling;
        }
        if (!didFindChild) {
          for (child$0 = parentB.child; child$0; ) {
            if (child$0 === a) {
              didFindChild = true;
              a = parentB;
              b2 = parentA;
              break;
            }
            if (child$0 === b2) {
              didFindChild = true;
              b2 = parentB;
              a = parentA;
              break;
            }
            child$0 = child$0.sibling;
          }
          if (!didFindChild) throw Error(formatProdErrorMessage2(189));
        }
      }
      if (a.alternate !== b2) throw Error(formatProdErrorMessage2(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage2(188));
    return a.stateNode.current === a ? fiber : alternate;
  }
  function findCurrentHostFiberImpl(node) {
    var tag2 = node.tag;
    if (5 === tag2 || 26 === tag2 || 27 === tag2 || 6 === tag2) return node;
    for (node = node.child; null !== node; ) {
      tag2 = findCurrentHostFiberImpl(node);
      if (null !== tag2) return tag2;
      node = node.sibling;
    }
    return null;
  }
  var assign2 = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
  var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
  var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
  var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
  function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
  }
  var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
  function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type)
      return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch (type) {
      case REACT_FRAGMENT_TYPE:
        return "Fragment";
      case REACT_PROFILER_TYPE:
        return "Profiler";
      case REACT_STRICT_MODE_TYPE:
        return "StrictMode";
      case REACT_SUSPENSE_TYPE:
        return "Suspense";
      case REACT_SUSPENSE_LIST_TYPE:
        return "SuspenseList";
      case REACT_ACTIVITY_TYPE:
        return "Activity";
    }
    if ("object" === typeof type)
      switch (type.$$typeof) {
        case REACT_PORTAL_TYPE:
          return "Portal";
        case REACT_CONTEXT_TYPE:
          return type.displayName || "Context";
        case REACT_CONSUMER_TYPE:
          return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
          var innerType = type.render;
          type = type.displayName;
          type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
          return type;
        case REACT_MEMO_TYPE:
          return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
          innerType = type._payload;
          type = type._init;
          try {
            return getComponentNameFromType(type(innerType));
          } catch (x2) {
          }
      }
    return null;
  }
  var isArrayImpl = Array.isArray, ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: false,
    data: null,
    method: null,
    action: null
  }, valueStack = [], index2 = -1;
  function createCursor(defaultValue2) {
    return { current: defaultValue2 };
  }
  function pop(cursor2) {
    0 > index2 || (cursor2.current = valueStack[index2], valueStack[index2] = null, index2--);
  }
  function push2(cursor2, value) {
    index2++;
    valueStack[index2] = cursor2.current;
    cursor2.current = value;
  }
  var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
  function pushHostContainer(fiber, nextRootInstance) {
    push2(rootInstanceStackCursor, nextRootInstance);
    push2(contextFiberStackCursor, fiber);
    push2(contextStackCursor, null);
    switch (nextRootInstance.nodeType) {
      case 9:
      case 11:
        fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
        break;
      default:
        if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI)
          nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
        else
          switch (fiber) {
            case "svg":
              fiber = 1;
              break;
            case "math":
              fiber = 2;
              break;
            default:
              fiber = 0;
          }
    }
    pop(contextStackCursor);
    push2(contextStackCursor, fiber);
  }
  function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
  }
  function pushHostContext(fiber) {
    null !== fiber.memoizedState && push2(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push2(contextFiberStackCursor, fiber), push2(contextStackCursor, JSCompiler_inline_result));
  }
  function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
  }
  var prefix, suffix;
  function describeBuiltInComponentFrame(name2) {
    if (void 0 === prefix)
      try {
        throw Error();
      } catch (x2) {
        var match2 = x2.stack.trim().match(/\n( *(at )?)/);
        prefix = match2 && match2[1] || "";
        suffix = -1 < x2.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x2.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return "\n" + prefix + name2 + suffix;
  }
  var reentry = false;
  function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = true;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var RunInRootFrame = {
        DetermineComponentFrameRoot: function() {
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if ("object" === typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x2) {
                  var control = x2;
                }
                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x$1) {
                  control = x$1;
                }
                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x$2) {
                control = x$2;
              }
              (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {
              });
            }
          } catch (sample2) {
            if (sample2 && control && "string" === typeof sample2.stack)
              return [sample2.stack, control.stack];
          }
          return [null, null];
        }
      };
      RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var namePropDescriptor = Object.getOwnPropertyDescriptor(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name"
      );
      namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
      if (sampleStack && controlStack) {
        var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
        for (namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot"); )
          RunInRootFrame++;
        for (; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes(
          "DetermineComponentFrameRoot"
        ); )
          namePropDescriptor++;
        if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length)
          for (RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]; )
            namePropDescriptor--;
        for (; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)
          if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
            if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
              do
                if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                  var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                  fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                  return frame;
                }
              while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
            }
            break;
          }
      }
    } finally {
      reentry = false, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
  }
  function describeFiber(fiber, childFiber) {
    switch (fiber.tag) {
      case 26:
      case 27:
      case 5:
        return describeBuiltInComponentFrame(fiber.type);
      case 16:
        return describeBuiltInComponentFrame("Lazy");
      case 13:
        return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
      case 19:
        return describeBuiltInComponentFrame("SuspenseList");
      case 0:
      case 15:
        return describeNativeComponentFrame(fiber.type, false);
      case 11:
        return describeNativeComponentFrame(fiber.type.render, false);
      case 1:
        return describeNativeComponentFrame(fiber.type, true);
      case 31:
        return describeBuiltInComponentFrame("Activity");
      default:
        return "";
    }
  }
  function getStackByFiberInDevAndProd(workInProgress2) {
    try {
      var info = "", previous2 = null;
      do
        info += describeFiber(workInProgress2, previous2), previous2 = workInProgress2, workInProgress2 = workInProgress2.return;
      while (workInProgress2);
      return info;
    } catch (x2) {
      return "\nError generating stack: " + x2.message + "\n" + x2.stack;
    }
  }
  var hasOwnProperty2 = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler2.unstable_scheduleCallback, cancelCallback$1 = Scheduler2.unstable_cancelCallback, shouldYield = Scheduler2.unstable_shouldYield, requestPaint = Scheduler2.unstable_requestPaint, now2 = Scheduler2.unstable_now, getCurrentPriorityLevel = Scheduler2.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler2.unstable_ImmediatePriority, UserBlockingPriority = Scheduler2.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler2.unstable_NormalPriority, LowPriority = Scheduler2.unstable_LowPriority, IdlePriority = Scheduler2.unstable_IdlePriority, log$12 = Scheduler2.log, unstable_setDisableYieldValue = Scheduler2.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
  function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$12 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode)
      try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
      } catch (err) {
      }
  }
  var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log3 = Math.log, LN2 = Math.LN2;
  function clz32Fallback(x2) {
    x2 >>>= 0;
    return 0 === x2 ? 32 : 31 - (log3(x2) / LN2 | 0) | 0;
  }
  var nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304;
  function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch (lanes & -lanes) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return lanes & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return lanes & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return lanes & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return lanes;
    }
  }
  function getNextLanes(root3, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root3.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes;
    root3 = root3.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root3, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root3, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
  }
  function checkIfRootIsPrerendering(root3, renderLanes2) {
    return 0 === (root3.pendingLanes & ~(root3.suspendedLanes & ~root3.pingedLanes) & renderLanes2);
  }
  function computeExpirationTime(lane, currentTime) {
    switch (lane) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return currentTime + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return currentTime + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
  }
  function createLaneMap(initial2) {
    for (var laneMap = [], i2 = 0; 31 > i2; i2++) laneMap.push(initial2);
    return laneMap;
  }
  function markRootUpdated$1(root3, updateLane) {
    root3.pendingLanes |= updateLane;
    268435456 !== updateLane && (root3.suspendedLanes = 0, root3.pingedLanes = 0, root3.warmLanes = 0);
  }
  function markRootFinished(root3, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root3.pendingLanes;
    root3.pendingLanes = remainingLanes;
    root3.suspendedLanes = 0;
    root3.pingedLanes = 0;
    root3.warmLanes = 0;
    root3.expiredLanes &= remainingLanes;
    root3.entangledLanes &= remainingLanes;
    root3.errorRecoveryDisabledLanes &= remainingLanes;
    root3.shellSuspendCounter = 0;
    var entanglements = root3.entanglements, expirationTimes = root3.expirationTimes, hiddenUpdates = root3.hiddenUpdates;
    for (remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes; ) {
      var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
      entanglements[index$7] = 0;
      expirationTimes[index$7] = -1;
      var hiddenUpdatesForLane = hiddenUpdates[index$7];
      if (null !== hiddenUpdatesForLane)
        for (hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++) {
          var update = hiddenUpdatesForLane[index$7];
          null !== update && (update.lane &= -536870913);
        }
      remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root3, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root3.tag && (root3.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
  }
  function markSpawnedDeferredLane(root3, spawnedLane, entangledLanes) {
    root3.pendingLanes |= spawnedLane;
    root3.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root3.entangledLanes |= spawnedLane;
    root3.entanglements[spawnedLaneIndex] = root3.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
  }
  function markRootEntangled(root3, entangledLanes) {
    var rootEntangledLanes = root3.entangledLanes |= entangledLanes;
    for (root3 = root3.entanglements; rootEntangledLanes; ) {
      var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
      lane & entangledLanes | root3[index$8] & entangledLanes && (root3[index$8] |= entangledLanes);
      rootEntangledLanes &= ~lane;
    }
  }
  function getBumpedLaneForHydration(root3, renderLanes2) {
    var renderLane = renderLanes2 & -renderLanes2;
    renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root3.suspendedLanes | renderLanes2)) ? 0 : renderLane;
  }
  function getBumpedLaneForHydrationByLane(lane) {
    switch (lane) {
      case 2:
        lane = 1;
        break;
      case 8:
        lane = 4;
        break;
      case 32:
        lane = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        lane = 128;
        break;
      case 268435456:
        lane = 134217728;
        break;
      default:
        lane = 0;
    }
    return lane;
  }
  function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
  }
  function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
  }
  function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      return ReactDOMSharedInternals.p = priority, fn();
    } finally {
      ReactDOMSharedInternals.p = previousPriority;
    }
  }
  var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
  function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
  }
  function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for (var parentNode = targetNode.parentNode; parentNode; ) {
      if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
        parentNode = targetInst.alternate;
        if (null !== targetInst.child || null !== parentNode && null !== parentNode.child)
          for (targetNode = getParentHydrationBoundary(targetNode); null !== targetNode; ) {
            if (parentNode = targetNode[internalInstanceKey]) return parentNode;
            targetNode = getParentHydrationBoundary(targetNode);
          }
        return targetInst;
      }
      targetNode = parentNode;
      parentNode = targetNode.parentNode;
    }
    return null;
  }
  function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
      var tag2 = node.tag;
      if (5 === tag2 || 6 === tag2 || 13 === tag2 || 31 === tag2 || 26 === tag2 || 27 === tag2 || 3 === tag2)
        return node;
    }
    return null;
  }
  function getNodeFromInstance(inst) {
    var tag2 = inst.tag;
    if (5 === tag2 || 26 === tag2 || 27 === tag2 || 6 === tag2) return inst.stateNode;
    throw Error(formatProdErrorMessage2(33));
  }
  function getResourcesFromRoot(root3) {
    var resources = root3[internalRootNodeResourcesKey];
    resources || (resources = root3[internalRootNodeResourcesKey] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() });
    return resources;
  }
  function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = true;
  }
  var allNativeEvents = /* @__PURE__ */ new Set(), registrationNameDependencies = {};
  function registerTwoPhaseEvent(registrationName, dependencies2) {
    registerDirectEvent(registrationName, dependencies2);
    registerDirectEvent(registrationName + "Capture", dependencies2);
  }
  function registerDirectEvent(registrationName, dependencies2) {
    registrationNameDependencies[registrationName] = dependencies2;
    for (registrationName = 0; registrationName < dependencies2.length; registrationName++)
      allNativeEvents.add(dependencies2[registrationName]);
  }
  var VALID_ATTRIBUTE_NAME_REGEX = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
  function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty2.call(validatedAttributeNameCache, attributeName))
      return true;
    if (hasOwnProperty2.call(illegalAttributeNameCache, attributeName)) return false;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
      return validatedAttributeNameCache[attributeName] = true;
    illegalAttributeNameCache[attributeName] = true;
    return false;
  }
  function setValueForAttribute(node, name2, value) {
    if (isAttributeNameSafe(name2))
      if (null === value) node.removeAttribute(name2);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
            node.removeAttribute(name2);
            return;
          case "boolean":
            var prefix$10 = name2.toLowerCase().slice(0, 5);
            if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
              node.removeAttribute(name2);
              return;
            }
        }
        node.setAttribute(name2, "" + value);
      }
  }
  function setValueForKnownAttribute(node, name2, value) {
    if (null === value) node.removeAttribute(name2);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          node.removeAttribute(name2);
          return;
      }
      node.setAttribute(name2, "" + value);
    }
  }
  function setValueForNamespacedAttribute(node, namespace, name2, value) {
    if (null === value) node.removeAttribute(name2);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          node.removeAttribute(name2);
          return;
      }
      node.setAttributeNS(namespace, name2, "" + value);
    }
  }
  function getToStringValue(value) {
    switch (typeof value) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return value;
      case "object":
        return value;
      default:
        return "";
    }
  }
  function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
  }
  function trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(
      node.constructor.prototype,
      valueField
    );
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
      var get2 = descriptor.get, set2 = descriptor.set;
      Object.defineProperty(node, valueField, {
        configurable: true,
        get: function() {
          return get2.call(this);
        },
        set: function(value) {
          currentValue = "" + value;
          set2.call(this, value);
        }
      });
      Object.defineProperty(node, valueField, {
        enumerable: descriptor.enumerable
      });
      return {
        getValue: function() {
          return currentValue;
        },
        setValue: function(value) {
          currentValue = "" + value;
        },
        stopTracking: function() {
          node._valueTracker = null;
          delete node[valueField];
        }
      };
    }
  }
  function track(node) {
    if (!node._valueTracker) {
      var valueField = isCheckable(node) ? "checked" : "value";
      node._valueTracker = trackValueOnNode(
        node,
        valueField,
        "" + node[valueField]
      );
    }
  }
  function updateValueIfChanged(node) {
    if (!node) return false;
    var tracker = node._valueTracker;
    if (!tracker) return true;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), true) : false;
  }
  function getActiveElement2(doc2) {
    doc2 = doc2 || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc2) return null;
    try {
      return doc2.activeElement || doc2.body;
    } catch (e2) {
      return doc2.body;
    }
  }
  var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
  function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(
      escapeSelectorAttributeValueInsideDoubleQuotesRegex,
      function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function updateInput(element2, value, defaultValue2, lastDefaultValue, checked, defaultChecked, type, name2) {
    element2.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element2.type = type : element2.removeAttribute("type");
    if (null != value)
      if ("number" === type) {
        if (0 === value && "" === element2.value || element2.value != value)
          element2.value = "" + getToStringValue(value);
      } else
        element2.value !== "" + getToStringValue(value) && (element2.value = "" + getToStringValue(value));
    else
      "submit" !== type && "reset" !== type || element2.removeAttribute("value");
    null != value ? setDefaultValue(element2, type, getToStringValue(value)) : null != defaultValue2 ? setDefaultValue(element2, type, getToStringValue(defaultValue2)) : null != lastDefaultValue && element2.removeAttribute("value");
    null == checked && null != defaultChecked && (element2.defaultChecked = !!defaultChecked);
    null != checked && (element2.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name2 && "function" !== typeof name2 && "symbol" !== typeof name2 && "boolean" !== typeof name2 ? element2.name = "" + getToStringValue(name2) : element2.removeAttribute("name");
  }
  function initInput(element2, value, defaultValue2, checked, defaultChecked, type, name2, isHydrating2) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element2.type = type);
    if (null != value || null != defaultValue2) {
      if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
        track(element2);
        return;
      }
      defaultValue2 = null != defaultValue2 ? "" + getToStringValue(defaultValue2) : "";
      value = null != value ? "" + getToStringValue(value) : defaultValue2;
      isHydrating2 || value === element2.value || (element2.value = value);
      element2.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element2.checked = isHydrating2 ? element2.checked : !!checked;
    element2.defaultChecked = !!checked;
    null != name2 && "function" !== typeof name2 && "symbol" !== typeof name2 && "boolean" !== typeof name2 && (element2.name = name2);
    track(element2);
  }
  function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement2(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
  }
  function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
      multiple = {};
      for (var i2 = 0; i2 < propValue.length; i2++)
        multiple["$" + propValue[i2]] = true;
      for (propValue = 0; propValue < node.length; propValue++)
        i2 = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i2 && (node[propValue].selected = i2), i2 && setDefaultSelected && (node[propValue].defaultSelected = true);
    } else {
      propValue = "" + getToStringValue(propValue);
      multiple = null;
      for (i2 = 0; i2 < node.length; i2++) {
        if (node[i2].value === propValue) {
          node[i2].selected = true;
          setDefaultSelected && (node[i2].defaultSelected = true);
          return;
        }
        null !== multiple || node[i2].disabled || (multiple = node[i2]);
      }
      null !== multiple && (multiple.selected = true);
    }
  }
  function updateTextarea(element2, value, defaultValue2) {
    if (null != value && (value = "" + getToStringValue(value), value !== element2.value && (element2.value = value), null == defaultValue2)) {
      element2.defaultValue !== value && (element2.defaultValue = value);
      return;
    }
    element2.defaultValue = null != defaultValue2 ? "" + getToStringValue(defaultValue2) : "";
  }
  function initTextarea(element2, value, defaultValue2, children) {
    if (null == value) {
      if (null != children) {
        if (null != defaultValue2) throw Error(formatProdErrorMessage2(92));
        if (isArrayImpl(children)) {
          if (1 < children.length) throw Error(formatProdErrorMessage2(93));
          children = children[0];
        }
        defaultValue2 = children;
      }
      null == defaultValue2 && (defaultValue2 = "");
      value = defaultValue2;
    }
    defaultValue2 = getToStringValue(value);
    element2.defaultValue = defaultValue2;
    children = element2.textContent;
    children === defaultValue2 && "" !== children && null !== children && (element2.value = children);
    track(element2);
  }
  function setTextContent(node, text2) {
    if (text2) {
      var firstChild = node.firstChild;
      if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
        firstChild.nodeValue = text2;
        return;
      }
    }
    node.textContent = text2;
  }
  var unitlessNumbers = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function setValueForStyle(style2, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style2.setProperty(styleName, "") : "float" === styleName ? style2.cssFloat = "" : style2[styleName] = "" : isCustomProperty ? style2.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style2.cssFloat = value : style2[styleName] = ("" + value).trim() : style2[styleName] = value + "px";
  }
  function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles)
      throw Error(formatProdErrorMessage2(62));
    node = node.style;
    if (null != prevStyles) {
      for (var styleName in prevStyles)
        !prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
      for (var styleName$16 in styles)
        styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else
      for (var styleName$17 in styles)
        styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
  }
  function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return false;
    switch (tagName) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return false;
      default:
        return true;
    }
  }
  var aliases = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
  }
  function noop$12() {
  }
  var currentReplayingEvent = null;
  function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
  }
  var restoreTarget = null, restoreQueue = null;
  function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
      var props2 = target[internalPropsKey] || null;
      a: switch (target = internalInstance.stateNode, internalInstance.type) {
        case "input":
          updateInput(
            target,
            props2.value,
            props2.defaultValue,
            props2.defaultValue,
            props2.checked,
            props2.defaultChecked,
            props2.type,
            props2.name
          );
          internalInstance = props2.name;
          if ("radio" === props2.type && null != internalInstance) {
            for (props2 = target; props2.parentNode; ) props2 = props2.parentNode;
            props2 = props2.querySelectorAll(
              'input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes(
                "" + internalInstance
              ) + '"][type="radio"]'
            );
            for (internalInstance = 0; internalInstance < props2.length; internalInstance++) {
              var otherNode = props2[internalInstance];
              if (otherNode !== target && otherNode.form === target.form) {
                var otherProps = otherNode[internalPropsKey] || null;
                if (!otherProps) throw Error(formatProdErrorMessage2(90));
                updateInput(
                  otherNode,
                  otherProps.value,
                  otherProps.defaultValue,
                  otherProps.defaultValue,
                  otherProps.checked,
                  otherProps.defaultChecked,
                  otherProps.type,
                  otherProps.name
                );
              }
            }
            for (internalInstance = 0; internalInstance < props2.length; internalInstance++)
              otherNode = props2[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
          }
          break a;
        case "textarea":
          updateTextarea(target, props2.value, props2.defaultValue);
          break a;
        case "select":
          internalInstance = props2.value, null != internalInstance && updateOptions(target, !!props2.multiple, internalInstance, false);
      }
    }
  }
  var isInsideEventHandler = false;
  function batchedUpdates$1(fn, a, b2) {
    if (isInsideEventHandler) return fn(a, b2);
    isInsideEventHandler = true;
    try {
      var JSCompiler_inline_result = fn(a);
      return JSCompiler_inline_result;
    } finally {
      if (isInsideEventHandler = false, null !== restoreTarget || null !== restoreQueue) {
        if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn))
          for (a = 0; a < fn.length; a++) restoreStateOfTarget(fn[a]);
      }
    }
  }
  function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props2 = stateNode[internalPropsKey] || null;
    if (null === props2) return null;
    stateNode = props2[registrationName];
    a: switch (registrationName) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (props2 = !props2.disabled) || (inst = inst.type, props2 = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
        inst = !props2;
        break a;
      default:
        inst = false;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode)
      throw Error(
        formatProdErrorMessage2(231, registrationName, typeof stateNode)
      );
    return stateNode;
  }
  var canUseDOM2 = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = false;
  if (canUseDOM2)
    try {
      var options2 = {};
      Object.defineProperty(options2, "passive", {
        get: function() {
          passiveBrowserEventsSupported = true;
        }
      });
      window.addEventListener("test", options2, options2);
      window.removeEventListener("test", options2, options2);
    } catch (e2) {
      passiveBrowserEventsSupported = false;
    }
  var root2 = null, startText = null, fallbackText = null;
  function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root2 ? root2.value : root2.textContent, endLength = endValue.length;
    for (start = 0; start < startLength && startValue[start] === endValue[start]; start++) ;
    var minEnd = startLength - start;
    for (end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++) ;
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
  }
  function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
  }
  function functionThatReturnsTrue() {
    return true;
  }
  function functionThatReturnsFalse() {
    return false;
  }
  function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
      this._reactName = reactName;
      this._targetInst = targetInst;
      this.type = reactEventType;
      this.nativeEvent = nativeEvent;
      this.target = nativeEventTarget;
      this.currentTarget = null;
      for (var propName in Interface)
        Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
      this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : false === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
      this.isPropagationStopped = functionThatReturnsFalse;
      return this;
    }
    assign2(SyntheticBaseEvent.prototype, {
      preventDefault: function() {
        this.defaultPrevented = true;
        var event = this.nativeEvent;
        event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = false), this.isDefaultPrevented = functionThatReturnsTrue);
      },
      stopPropagation: function() {
        var event = this.nativeEvent;
        event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = true), this.isPropagationStopped = functionThatReturnsTrue);
      },
      persist: function() {
      },
      isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
  }
  var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
      return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign2({}, EventInterface, { view: 0, detail: 0 }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign2({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
      return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
      if ("movementX" in event) return event.movementX;
      event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
      return lastMovementX;
    },
    movementY: function(event) {
      return "movementY" in event ? event.movementY : lastMovementY;
    }
  }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign2({}, MouseEventInterface, { dataTransfer: 0 }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign2({}, UIEventInterface, { relatedTarget: 0 }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign2({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign2({}, EventInterface, {
    clipboardData: function(event) {
      return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
  }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign2({}, EventInterface, { data: 0 }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : false;
  }
  function getEventModifierState() {
    return modifierStateGetter;
  }
  var KeyboardEventInterface = assign2({}, UIEventInterface, {
    key: function(nativeEvent) {
      if (nativeEvent.key) {
        var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
        if ("Unidentified" !== key) return key;
      }
      return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
      return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
      return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
      return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
  }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign2({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign2({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
  }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign2({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign2({}, MouseEventInterface, {
    deltaX: function(event) {
      return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
      return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign2({}, EventInterface, {
    newState: 0,
    oldState: 0
  }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [9, 13, 27, 32], canUseCompositionEvent = canUseDOM2 && "CompositionEvent" in window, documentMode = null;
  canUseDOM2 && "documentMode" in document && (documentMode = document.documentMode);
  var canUseTextInputEvent = canUseDOM2 && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM2 && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = false;
  function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch (domEventName) {
      case "keyup":
        return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
      case "keydown":
        return 229 !== nativeEvent.keyCode;
      case "keypress":
      case "mousedown":
      case "focusout":
        return true;
      default:
        return false;
    }
  }
  function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
  }
  var isComposing = false;
  function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch (domEventName) {
      case "compositionend":
        return getDataFromCustomEvent(nativeEvent);
      case "keypress":
        if (32 !== nativeEvent.which) return null;
        hasSpaceKeypress = true;
        return SPACEBAR_CHAR;
      case "textInput":
        return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
      default:
        return null;
    }
  }
  function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing)
      return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root2 = null, isComposing = false, domEventName) : null;
    switch (domEventName) {
      case "paste":
        return null;
      case "keypress":
        if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
          if (nativeEvent.char && 1 < nativeEvent.char.length)
            return nativeEvent.char;
          if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
        }
        return null;
      case "compositionend":
        return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
      default:
        return null;
    }
  }
  var supportedInputTypes = {
    color: true,
    date: true,
    datetime: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    password: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true
  };
  function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? true : false;
  }
  function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [target] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent(
      "onChange",
      "change",
      null,
      nativeEvent,
      target
    ), dispatchQueue.push({ event: nativeEvent, listeners: inst }));
  }
  var activeElement$1 = null, activeElementInst$1 = null;
  function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
  }
  function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
  }
  function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
  }
  var isInputEventSupported = false;
  if (canUseDOM2) {
    var JSCompiler_inline_result$jscomp$286;
    if (canUseDOM2) {
      var isSupported$jscomp$inline_427 = "oninput" in document;
      if (!isSupported$jscomp$inline_427) {
        var element$jscomp$inline_428 = document.createElement("div");
        element$jscomp$inline_428.setAttribute("oninput", "return;");
        isSupported$jscomp$inline_427 = "function" === typeof element$jscomp$inline_428.oninput;
      }
      JSCompiler_inline_result$jscomp$286 = isSupported$jscomp$inline_427;
    } else JSCompiler_inline_result$jscomp$286 = false;
    isInputEventSupported = JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
  }
  function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
  }
  function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
      var dispatchQueue = [];
      createAndAccumulateChangeEvent(
        dispatchQueue,
        activeElementInst$1,
        nativeEvent,
        getEventTarget(nativeEvent)
      );
      batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
  }
  function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
  }
  function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName)
      return getInstIfValueChanged(activeElementInst$1);
  }
  function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
  }
  function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName)
      return getInstIfValueChanged(targetInst);
  }
  function is2(x2, y) {
    return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2;
  function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return true;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB)
      return false;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (keysB = 0; keysB < keysA.length; keysB++) {
      var currentKey = keysA[keysB];
      if (!hasOwnProperty2.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey]))
        return false;
    }
    return true;
  }
  function getLeafNode(node) {
    for (; node && node.firstChild; ) node = node.firstChild;
    return node;
  }
  function getNodeForCharacterOffset(root3, offset2) {
    var node = getLeafNode(root3);
    root3 = 0;
    for (var nodeEnd; node; ) {
      if (3 === node.nodeType) {
        nodeEnd = root3 + node.textContent.length;
        if (root3 <= offset2 && nodeEnd >= offset2)
          return { node, offset: offset2 - root3 };
        root3 = nodeEnd;
      }
      a: {
        for (; node; ) {
          if (node.nextSibling) {
            node = node.nextSibling;
            break a;
          }
          node = node.parentNode;
        }
        node = void 0;
      }
      node = getLeafNode(node);
    }
  }
  function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? true : outerNode && 3 === outerNode.nodeType ? false : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : false : false;
  }
  function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for (var element2 = getActiveElement2(containerInfo.document); element2 instanceof containerInfo.HTMLIFrameElement; ) {
      try {
        var JSCompiler_inline_result = "string" === typeof element2.contentWindow.location.href;
      } catch (err) {
        JSCompiler_inline_result = false;
      }
      if (JSCompiler_inline_result) containerInfo = element2.contentWindow;
      else break;
      element2 = getActiveElement2(containerInfo.document);
    }
    return element2;
  }
  function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
  }
  var skipSelectionChangeEvent = canUseDOM2 && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = false;
  function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc2 = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement2(doc2) || (doc2 = activeElement, "selectionStart" in doc2 && hasSelectionCapabilities(doc2) ? doc2 = { start: doc2.selectionStart, end: doc2.selectionEnd } : (doc2 = (doc2.ownerDocument && doc2.ownerDocument.defaultView || window).getSelection(), doc2 = {
      anchorNode: doc2.anchorNode,
      anchorOffset: doc2.anchorOffset,
      focusNode: doc2.focusNode,
      focusOffset: doc2.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc2) || (lastSelection = doc2, doc2 = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc2.length && (nativeEvent = new SyntheticEvent(
      "onSelect",
      "select",
      null,
      nativeEvent,
      nativeEventTarget
    ), dispatchQueue.push({ event: nativeEvent, listeners: doc2 }), nativeEvent.target = activeElement)));
  }
  function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
  }
  var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  }, prefixedEventNames = {}, style = {};
  canUseDOM2 && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
  function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for (styleProp in prefixMap)
      if (prefixMap.hasOwnProperty(styleProp) && styleProp in style)
        return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
  }
  var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = /* @__PURE__ */ new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  simpleEventPluginEvents.push("scrollEnd");
  function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [domEventName]);
  }
  var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
      var event = new window.ErrorEvent("error", {
        bubbles: true,
        cancelable: true,
        message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
        error
      });
      if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof process && "function" === typeof process.emit) {
      process.emit("uncaughtException", error);
      return;
    }
    console.error(error);
  }, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
  function finishQueueingConcurrentUpdates() {
    for (var endIndex = concurrentQueuesIndex, i2 = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i2 < endIndex; ) {
      var fiber = concurrentQueues[i2];
      concurrentQueues[i2++] = null;
      var queue2 = concurrentQueues[i2];
      concurrentQueues[i2++] = null;
      var update = concurrentQueues[i2];
      concurrentQueues[i2++] = null;
      var lane = concurrentQueues[i2];
      concurrentQueues[i2++] = null;
      if (null !== queue2 && null !== update) {
        var pending = queue2.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue2.pending = update;
      }
      0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
  }
  function enqueueUpdate$1(fiber, queue2, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue2;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
  }
  function enqueueConcurrentHookUpdate(fiber, queue2, update, lane) {
    enqueueUpdate$1(fiber, queue2, update, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for (var isHidden2 = false, parent = sourceFiber.return; null !== parent; )
      parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden2 = true)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden2 && null !== update && (isHidden2 = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden2], null === alternate ? sourceFiber[isHidden2] = [update] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
  }
  function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount)
      throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage2(185));
    for (var parent = sourceFiber.return; null !== parent; )
      sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
  }
  var emptyContextObject = {};
  function FiberNode(tag2, pendingProps, key, mode) {
    this.tag = tag2;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }
  function createFiberImplClass(tag2, pendingProps, key, mode) {
    return new FiberNode(tag2, pendingProps, key, mode);
  }
  function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
  }
  function createWorkInProgress(current2, pendingProps) {
    var workInProgress2 = current2.alternate;
    null === workInProgress2 ? (workInProgress2 = createFiberImplClass(
      current2.tag,
      pendingProps,
      current2.key,
      current2.mode
    ), workInProgress2.elementType = current2.elementType, workInProgress2.type = current2.type, workInProgress2.stateNode = current2.stateNode, workInProgress2.alternate = current2, current2.alternate = workInProgress2) : (workInProgress2.pendingProps = pendingProps, workInProgress2.type = current2.type, workInProgress2.flags = 0, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null);
    workInProgress2.flags = current2.flags & 65011712;
    workInProgress2.childLanes = current2.childLanes;
    workInProgress2.lanes = current2.lanes;
    workInProgress2.child = current2.child;
    workInProgress2.memoizedProps = current2.memoizedProps;
    workInProgress2.memoizedState = current2.memoizedState;
    workInProgress2.updateQueue = current2.updateQueue;
    pendingProps = current2.dependencies;
    workInProgress2.dependencies = null === pendingProps ? null : { lanes: pendingProps.lanes, firstContext: pendingProps.firstContext };
    workInProgress2.sibling = current2.sibling;
    workInProgress2.index = current2.index;
    workInProgress2.ref = current2.ref;
    workInProgress2.refCleanup = current2.refCleanup;
    return workInProgress2;
  }
  function resetWorkInProgress(workInProgress2, renderLanes2) {
    workInProgress2.flags &= 65011714;
    var current2 = workInProgress2.alternate;
    null === current2 ? (workInProgress2.childLanes = 0, workInProgress2.lanes = renderLanes2, workInProgress2.child = null, workInProgress2.subtreeFlags = 0, workInProgress2.memoizedProps = null, workInProgress2.memoizedState = null, workInProgress2.updateQueue = null, workInProgress2.dependencies = null, workInProgress2.stateNode = null) : (workInProgress2.childLanes = current2.childLanes, workInProgress2.lanes = current2.lanes, workInProgress2.child = current2.child, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.memoizedProps = current2.memoizedProps, workInProgress2.memoizedState = current2.memoizedState, workInProgress2.updateQueue = current2.updateQueue, workInProgress2.type = current2.type, renderLanes2 = current2.dependencies, workInProgress2.dependencies = null === renderLanes2 ? null : {
      lanes: renderLanes2.lanes,
      firstContext: renderLanes2.firstContext
    });
    return workInProgress2;
  }
  function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type)
      fiberTag = isHostHoistableType(
        type,
        pendingProps,
        contextStackCursor.current
      ) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else
      a: switch (type) {
        case REACT_ACTIVITY_TYPE:
          return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
          return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
          fiberTag = 8;
          mode |= 24;
          break;
        case REACT_PROFILER_TYPE:
          return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
          return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
          return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
          if ("object" === typeof type && null !== type)
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                fiberTag = 10;
                break a;
              case REACT_CONSUMER_TYPE:
                fiberTag = 9;
                break a;
              case REACT_FORWARD_REF_TYPE:
                fiberTag = 11;
                break a;
              case REACT_MEMO_TYPE:
                fiberTag = 14;
                break a;
              case REACT_LAZY_TYPE:
                fiberTag = 16;
                owner = null;
                break a;
            }
          fiberTag = 29;
          pendingProps = Error(
            formatProdErrorMessage2(130, null === type ? "null" : typeof type, "")
          );
          owner = null;
      }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
  }
  function createFiberFromFragment(elements2, mode, lanes, key) {
    elements2 = createFiberImplClass(7, elements2, key, mode);
    elements2.lanes = lanes;
    return elements2;
  }
  function createFiberFromText(content2, mode, lanes) {
    content2 = createFiberImplClass(6, content2, null, mode);
    content2.lanes = lanes;
    return content2;
  }
  function createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
  }
  function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(
      4,
      null !== portal.children ? portal.children : [],
      portal.key,
      mode
    );
    mode.lanes = lanes;
    mode.stateNode = {
      containerInfo: portal.containerInfo,
      pendingChildren: null,
      implementation: portal.implementation
    };
    return mode;
  }
  var CapturedStacks = /* @__PURE__ */ new WeakMap();
  function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
      var existing = CapturedStacks.get(value);
      if (void 0 !== existing) return existing;
      source = {
        value,
        source,
        stack: getStackByFiberInDevAndProd(source)
      };
      CapturedStacks.set(value, source);
      return source;
    }
    return {
      value,
      source,
      stack: getStackByFiberInDevAndProd(source)
    };
  }
  var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
  function pushTreeFork(workInProgress2, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress2;
    treeForkCount = totalChildren;
  }
  function pushTreeId(workInProgress2, totalChildren, index3) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress2;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress2 = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index3 += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
      var numberOfOverflowBits = baseLength - baseLength % 5;
      length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
      baseIdWithLeadingBit >>= numberOfOverflowBits;
      baseLength -= numberOfOverflowBits;
      treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index3 << baseLength | baseIdWithLeadingBit;
      treeContextOverflow = length + workInProgress2;
    } else
      treeContextId = 1 << length | index3 << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress2;
  }
  function pushMaterializedTreeId(workInProgress2) {
    null !== workInProgress2.return && (pushTreeFork(workInProgress2, 1), pushTreeId(workInProgress2, 1, 0));
  }
  function popTreeContext(workInProgress2) {
    for (; workInProgress2 === treeForkProvider; )
      treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for (; workInProgress2 === treeContextProvider; )
      treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
  }
  function restoreSuspendedTreeContext(workInProgress2, suspendedContext) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextId = suspendedContext.id;
    treeContextOverflow = suspendedContext.overflow;
    treeContextProvider = workInProgress2;
  }
  var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = false, hydrationErrors = null, rootOrSingletonContext = false, HydrationMismatchException = Error(formatProdErrorMessage2(519));
  function throwOnHydrationMismatch(fiber) {
    var error = Error(
      formatProdErrorMessage2(
        418,
        1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
  }
  function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props2 = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props2;
    switch (type) {
      case "dialog":
        listenToNonDelegatedEvent("cancel", instance);
        listenToNonDelegatedEvent("close", instance);
        break;
      case "iframe":
      case "object":
      case "embed":
        listenToNonDelegatedEvent("load", instance);
        break;
      case "video":
      case "audio":
        for (type = 0; type < mediaEventTypes.length; type++)
          listenToNonDelegatedEvent(mediaEventTypes[type], instance);
        break;
      case "source":
        listenToNonDelegatedEvent("error", instance);
        break;
      case "img":
      case "image":
      case "link":
        listenToNonDelegatedEvent("error", instance);
        listenToNonDelegatedEvent("load", instance);
        break;
      case "details":
        listenToNonDelegatedEvent("toggle", instance);
        break;
      case "input":
        listenToNonDelegatedEvent("invalid", instance);
        initInput(
          instance,
          props2.value,
          props2.defaultValue,
          props2.checked,
          props2.defaultChecked,
          props2.type,
          props2.name,
          true
        );
        break;
      case "select":
        listenToNonDelegatedEvent("invalid", instance);
        break;
      case "textarea":
        listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props2.value, props2.defaultValue, props2.children);
    }
    type = props2.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || true === props2.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props2.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props2.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props2.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props2.onClick && (instance.onclick = noop$12), instance = true) : instance = false;
    instance || throwOnHydrationMismatch(fiber, true);
  }
  function popToNextHostParent(fiber) {
    for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
      switch (hydrationParentFiber.tag) {
        case 5:
        case 31:
        case 13:
          rootOrSingletonContext = false;
          return;
        case 27:
        case 3:
          rootOrSingletonContext = true;
          return;
        default:
          hydrationParentFiber = hydrationParentFiber.return;
      }
  }
  function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return false;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = true, false;
    var tag2 = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag2 && 27 !== tag2) {
      if (JSCompiler_temp = 5 === tag2)
        JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
      JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag2) {
      fiber = fiber.memoizedState;
      fiber = null !== fiber ? fiber.dehydrated : null;
      if (!fiber) throw Error(formatProdErrorMessage2(317));
      nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag2) {
      fiber = fiber.memoizedState;
      fiber = null !== fiber ? fiber.dehydrated : null;
      if (!fiber) throw Error(formatProdErrorMessage2(317));
      nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else
      27 === tag2 ? (tag2 = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag2) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return true;
  }
  function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = false;
  }
  function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(
      workInProgressRootRecoverableErrors,
      queuedErrors
    ), hydrationErrors = null);
    return queuedErrors;
  }
  function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [error] : hydrationErrors.push(error);
  }
  var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
  function pushProvider(providerFiber, context, nextValue) {
    push2(valueCursor, context._currentValue);
    context._currentValue = nextValue;
  }
  function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
  }
  function scheduleContextWorkOnParentPath(parent, renderLanes2, propagationRoot) {
    for (; null !== parent; ) {
      var alternate = parent.alternate;
      (parent.childLanes & renderLanes2) !== renderLanes2 ? (parent.childLanes |= renderLanes2, null !== alternate && (alternate.childLanes |= renderLanes2)) : null !== alternate && (alternate.childLanes & renderLanes2) !== renderLanes2 && (alternate.childLanes |= renderLanes2);
      if (parent === propagationRoot) break;
      parent = parent.return;
    }
  }
  function propagateContextChanges(workInProgress2, contexts, renderLanes2, forcePropagateEntireTree) {
    var fiber = workInProgress2.child;
    null !== fiber && (fiber.return = workInProgress2);
    for (; null !== fiber; ) {
      var list2 = fiber.dependencies;
      if (null !== list2) {
        var nextFiber = fiber.child;
        list2 = list2.firstContext;
        a: for (; null !== list2; ) {
          var dependency = list2;
          list2 = fiber;
          for (var i2 = 0; i2 < contexts.length; i2++)
            if (dependency.context === contexts[i2]) {
              list2.lanes |= renderLanes2;
              dependency = list2.alternate;
              null !== dependency && (dependency.lanes |= renderLanes2);
              scheduleContextWorkOnParentPath(
                list2.return,
                renderLanes2,
                workInProgress2
              );
              forcePropagateEntireTree || (nextFiber = null);
              break a;
            }
          list2 = dependency.next;
        }
      } else if (18 === fiber.tag) {
        nextFiber = fiber.return;
        if (null === nextFiber) throw Error(formatProdErrorMessage2(341));
        nextFiber.lanes |= renderLanes2;
        list2 = nextFiber.alternate;
        null !== list2 && (list2.lanes |= renderLanes2);
        scheduleContextWorkOnParentPath(nextFiber, renderLanes2, workInProgress2);
        nextFiber = null;
      } else nextFiber = fiber.child;
      if (null !== nextFiber) nextFiber.return = fiber;
      else
        for (nextFiber = fiber; null !== nextFiber; ) {
          if (nextFiber === workInProgress2) {
            nextFiber = null;
            break;
          }
          fiber = nextFiber.sibling;
          if (null !== fiber) {
            fiber.return = nextFiber.return;
            nextFiber = fiber;
            break;
          }
          nextFiber = nextFiber.return;
        }
      fiber = nextFiber;
    }
  }
  function propagateParentContextChanges(current2, workInProgress2, renderLanes2, forcePropagateEntireTree) {
    current2 = null;
    for (var parent = workInProgress2, isInsidePropagationBailout = false; null !== parent; ) {
      if (!isInsidePropagationBailout) {
        if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
        else if (0 !== (parent.flags & 262144)) break;
      }
      if (10 === parent.tag) {
        var currentParent = parent.alternate;
        if (null === currentParent) throw Error(formatProdErrorMessage2(387));
        currentParent = currentParent.memoizedProps;
        if (null !== currentParent) {
          var context = parent.type;
          objectIs(parent.pendingProps.value, currentParent.value) || (null !== current2 ? current2.push(context) : current2 = [context]);
        }
      } else if (parent === hostTransitionProviderCursor.current) {
        currentParent = parent.alternate;
        if (null === currentParent) throw Error(formatProdErrorMessage2(387));
        currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current2 ? current2.push(HostTransitionContext) : current2 = [HostTransitionContext]);
      }
      parent = parent.return;
    }
    null !== current2 && propagateContextChanges(
      workInProgress2,
      current2,
      renderLanes2,
      forcePropagateEntireTree
    );
    workInProgress2.flags |= 262144;
  }
  function checkIfContextChanged(currentDependencies) {
    for (currentDependencies = currentDependencies.firstContext; null !== currentDependencies; ) {
      if (!objectIs(
        currentDependencies.context._currentValue,
        currentDependencies.memoizedValue
      ))
        return true;
      currentDependencies = currentDependencies.next;
    }
    return false;
  }
  function prepareToReadContext(workInProgress2) {
    currentlyRenderingFiber$1 = workInProgress2;
    lastContextDependency = null;
    workInProgress2 = workInProgress2.dependencies;
    null !== workInProgress2 && (workInProgress2.firstContext = null);
  }
  function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
  }
  function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
  }
  function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = { context, memoizedValue: value, next: null };
    if (null === lastContextDependency) {
      if (null === consumer) throw Error(formatProdErrorMessage2(308));
      lastContextDependency = context;
      consumer.dependencies = { lanes: 0, firstContext: context };
      consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
  }
  var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
      aborted: false,
      addEventListener: function(type, listener) {
        listeners.push(listener);
      }
    };
    this.abort = function() {
      signal.aborted = true;
      listeners.forEach(function(listener) {
        return listener();
      });
    };
  }, scheduleCallback$2 = Scheduler2.unstable_scheduleCallback, NormalPriority = Scheduler2.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function createCache() {
    return {
      controller: new AbortControllerLocal(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
      cache.controller.abort();
    });
  }
  var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
  function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
      var entangledListeners = currentEntangledListeners = [];
      currentEntangledPendingCount = 0;
      currentEntangledLane = requestTransitionLane();
      currentEntangledActionThenable = {
        status: "pending",
        value: void 0,
        then: function(resolve) {
          entangledListeners.push(resolve);
        }
      };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
  }
  function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
      null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
      var listeners = currentEntangledListeners;
      currentEntangledListeners = null;
      currentEntangledLane = 0;
      currentEntangledActionThenable = null;
      for (var i2 = 0; i2 < listeners.length; i2++) (0, listeners[i2])();
    }
  }
  function chainThenableValue(thenable, result2) {
    var listeners = [], thenableWithOverride = {
      status: "pending",
      value: null,
      reason: null,
      then: function(resolve) {
        listeners.push(resolve);
      }
    };
    thenable.then(
      function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result2;
        for (var i2 = 0; i2 < listeners.length; i2++) (0, listeners[i2])(result2);
      },
      function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for (error = 0; error < listeners.length; error++)
          (0, listeners[error])(void 0);
      }
    );
    return thenableWithOverride;
  }
  var prevOnStartTransitionFinish = ReactSharedInternals.S;
  ReactSharedInternals.S = function(transition, returnValue) {
    globalMostRecentTransitionTime = now2();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
  };
  var resumedCache = createCursor(null);
  function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
  }
  function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push2(resumedCache, resumedCache.current) : push2(resumedCache, prevCachePool.pool);
  }
  function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : { parent: CacheContext._currentValue, pool: cacheFromPool };
  }
  var SuspenseException = Error(formatProdErrorMessage2(460)), SuspenseyCommitException = Error(formatProdErrorMessage2(474)), SuspenseActionException = Error(formatProdErrorMessage2(542)), noopSuspenseyCommitThenable = { then: function() {
  } };
  function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
  }
  function trackUsedThenable(thenableState2, thenable, index3) {
    index3 = thenableState2[index3];
    void 0 === index3 ? thenableState2.push(thenable) : index3 !== thenable && (thenable.then(noop$12, noop$12), thenable = index3);
    switch (thenable.status) {
      case "fulfilled":
        return thenable.value;
      case "rejected":
        throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
      default:
        if ("string" === typeof thenable.status) thenable.then(noop$12, noop$12);
        else {
          thenableState2 = workInProgressRoot;
          if (null !== thenableState2 && 100 < thenableState2.shellSuspendCounter)
            throw Error(formatProdErrorMessage2(482));
          thenableState2 = thenable;
          thenableState2.status = "pending";
          thenableState2.then(
            function(fulfilledValue) {
              if ("pending" === thenable.status) {
                var fulfilledThenable = thenable;
                fulfilledThenable.status = "fulfilled";
                fulfilledThenable.value = fulfilledValue;
              }
            },
            function(error) {
              if ("pending" === thenable.status) {
                var rejectedThenable = thenable;
                rejectedThenable.status = "rejected";
                rejectedThenable.reason = error;
              }
            }
          );
        }
        switch (thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
        }
        suspendedThenable = thenable;
        throw SuspenseException;
    }
  }
  function resolveLazy(lazyType) {
    try {
      var init2 = lazyType._init;
      return init2(lazyType._payload);
    } catch (x2) {
      if (null !== x2 && "object" === typeof x2 && "function" === typeof x2.then)
        throw suspendedThenable = x2, SuspenseException;
      throw x2;
    }
  }
  var suspendedThenable = null;
  function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage2(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
  }
  function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException)
      throw Error(formatProdErrorMessage2(483));
  }
  var thenableState$1 = null, thenableIndexCounter$1 = 0;
  function unwrapThenable(thenable) {
    var index3 = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    return trackUsedThenable(thenableState$1, thenable, index3);
  }
  function coerceRef(workInProgress2, element2) {
    element2 = element2.props.ref;
    workInProgress2.ref = void 0 !== element2 ? element2 : null;
  }
  function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
      throw Error(formatProdErrorMessage2(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(
      formatProdErrorMessage2(
        31,
        "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber
      )
    );
  }
  function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
      if (shouldTrackSideEffects) {
        var deletions = returnFiber.deletions;
        null === deletions ? (returnFiber.deletions = [childToDelete], returnFiber.flags |= 16) : deletions.push(childToDelete);
      }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
      if (!shouldTrackSideEffects) return null;
      for (; null !== currentFirstChild; )
        deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
      return null;
    }
    function mapRemainingChildren(currentFirstChild) {
      for (var existingChildren = /* @__PURE__ */ new Map(); null !== currentFirstChild; )
        null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
      return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
      fiber = createWorkInProgress(fiber, pendingProps);
      fiber.index = 0;
      fiber.sibling = null;
      return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
      newFiber.index = newIndex;
      if (!shouldTrackSideEffects)
        return newFiber.flags |= 1048576, lastPlacedIndex;
      newIndex = newFiber.alternate;
      if (null !== newIndex)
        return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
      newFiber.flags |= 67108866;
      return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
      shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
      return newFiber;
    }
    function updateTextNode(returnFiber, current2, textContent, lanes) {
      if (null === current2 || 6 !== current2.tag)
        return current2 = createFiberFromText(textContent, returnFiber.mode, lanes), current2.return = returnFiber, current2;
      current2 = useFiber(current2, textContent);
      current2.return = returnFiber;
      return current2;
    }
    function updateElement(returnFiber, current2, element2, lanes) {
      var elementType = element2.type;
      if (elementType === REACT_FRAGMENT_TYPE)
        return updateFragment(
          returnFiber,
          current2,
          element2.props.children,
          lanes,
          element2.key
        );
      if (null !== current2 && (current2.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current2.type))
        return current2 = useFiber(current2, element2.props), coerceRef(current2, element2), current2.return = returnFiber, current2;
      current2 = createFiberFromTypeAndProps(
        element2.type,
        element2.key,
        element2.props,
        null,
        returnFiber.mode,
        lanes
      );
      coerceRef(current2, element2);
      current2.return = returnFiber;
      return current2;
    }
    function updatePortal(returnFiber, current2, portal, lanes) {
      if (null === current2 || 4 !== current2.tag || current2.stateNode.containerInfo !== portal.containerInfo || current2.stateNode.implementation !== portal.implementation)
        return current2 = createFiberFromPortal(portal, returnFiber.mode, lanes), current2.return = returnFiber, current2;
      current2 = useFiber(current2, portal.children || []);
      current2.return = returnFiber;
      return current2;
    }
    function updateFragment(returnFiber, current2, fragment, lanes, key) {
      if (null === current2 || 7 !== current2.tag)
        return current2 = createFiberFromFragment(
          fragment,
          returnFiber.mode,
          lanes,
          key
        ), current2.return = returnFiber, current2;
      current2 = useFiber(current2, fragment);
      current2.return = returnFiber;
      return current2;
    }
    function createChild(returnFiber, newChild, lanes) {
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return newChild = createFiberFromText(
          "" + newChild,
          returnFiber.mode,
          lanes
        ), newChild.return = returnFiber, newChild;
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return lanes = createFiberFromTypeAndProps(
              newChild.type,
              newChild.key,
              newChild.props,
              null,
              returnFiber.mode,
              lanes
            ), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
          case REACT_PORTAL_TYPE:
            return newChild = createFiberFromPortal(
              newChild,
              returnFiber.mode,
              lanes
            ), newChild.return = returnFiber, newChild;
          case REACT_LAZY_TYPE:
            return newChild = resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return newChild = createFiberFromFragment(
            newChild,
            returnFiber.mode,
            lanes,
            null
          ), newChild.return = returnFiber, newChild;
        if ("function" === typeof newChild.then)
          return createChild(returnFiber, unwrapThenable(newChild), lanes);
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return createChild(
            returnFiber,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
      }
      return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
      var key = null !== oldFiber ? oldFiber.key : null;
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
          case REACT_PORTAL_TYPE:
            return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
          case REACT_LAZY_TYPE:
            return newChild = resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
        if ("function" === typeof newChild.then)
          return updateSlot(
            returnFiber,
            oldFiber,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return updateSlot(
            returnFiber,
            oldFiber,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
      }
      return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return existingChildren = existingChildren.get(
              null === newChild.key ? newIdx : newChild.key
            ) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
          case REACT_PORTAL_TYPE:
            return existingChildren = existingChildren.get(
              null === newChild.key ? newIdx : newChild.key
            ) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
          case REACT_LAZY_TYPE:
            return newChild = resolveLazy(newChild), updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              newChild,
              lanes
            );
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
        if ("function" === typeof newChild.then)
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
      }
      return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
      for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++) {
        oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
        var newFiber = updateSlot(
          returnFiber,
          oldFiber,
          newChildren[newIdx],
          lanes
        );
        if (null === newFiber) {
          null === oldFiber && (oldFiber = nextOldFiber);
          break;
        }
        shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
        null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
        previousNewFiber = newFiber;
        oldFiber = nextOldFiber;
      }
      if (newIdx === newChildren.length)
        return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
      if (null === oldFiber) {
        for (; newIdx < newChildren.length; newIdx++)
          oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(
            oldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      for (oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)
        nextOldFiber = updateFromMap(
          oldFiber,
          returnFiber,
          newIdx,
          newChildren[newIdx],
          lanes
        ), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
          null === nextOldFiber.key ? newIdx : nextOldFiber.key
        ), currentFirstChild = placeChild(
          nextOldFiber,
          currentFirstChild,
          newIdx
        ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
      shouldTrackSideEffects && oldFiber.forEach(function(child) {
        return deleteChild(returnFiber, child);
      });
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
      if (null == newChildren) throw Error(formatProdErrorMessage2(151));
      for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()) {
        oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
        var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
        if (null === newFiber) {
          null === oldFiber && (oldFiber = nextOldFiber);
          break;
        }
        shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
        null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
        previousNewFiber = newFiber;
        oldFiber = nextOldFiber;
      }
      if (step.done)
        return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
      if (null === oldFiber) {
        for (; !step.done; newIdx++, step = newChildren.next())
          step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      for (oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())
        step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
      shouldTrackSideEffects && oldFiber.forEach(function(child) {
        return deleteChild(returnFiber, child);
      });
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
      "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            a: {
              for (var key = newChild.key; null !== currentFirstChild; ) {
                if (currentFirstChild.key === key) {
                  key = newChild.type;
                  if (key === REACT_FRAGMENT_TYPE) {
                    if (7 === currentFirstChild.tag) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(
                        currentFirstChild,
                        newChild.props.children
                      );
                      lanes.return = returnFiber;
                      returnFiber = lanes;
                      break a;
                    }
                  } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(currentFirstChild, newChild.props);
                    coerceRef(lanes, newChild);
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  }
                  deleteRemainingChildren(returnFiber, currentFirstChild);
                  break;
                } else deleteChild(returnFiber, currentFirstChild);
                currentFirstChild = currentFirstChild.sibling;
              }
              newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(
                newChild.props.children,
                returnFiber.mode,
                lanes,
                newChild.key
              ), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(
                newChild.type,
                newChild.key,
                newChild.props,
                null,
                returnFiber.mode,
                lanes
              ), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
            }
            return placeSingleChild(returnFiber);
          case REACT_PORTAL_TYPE:
            a: {
              for (key = newChild.key; null !== currentFirstChild; ) {
                if (currentFirstChild.key === key)
                  if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(currentFirstChild, newChild.children || []);
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  } else {
                    deleteRemainingChildren(returnFiber, currentFirstChild);
                    break;
                  }
                else deleteChild(returnFiber, currentFirstChild);
                currentFirstChild = currentFirstChild.sibling;
              }
              lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
              lanes.return = returnFiber;
              returnFiber = lanes;
            }
            return placeSingleChild(returnFiber);
          case REACT_LAZY_TYPE:
            return newChild = resolveLazy(newChild), reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              newChild,
              lanes
            );
        }
        if (isArrayImpl(newChild))
          return reconcileChildrenArray(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
        if (getIteratorFn(newChild)) {
          key = getIteratorFn(newChild);
          if ("function" !== typeof key) throw Error(formatProdErrorMessage2(150));
          newChild = key.call(newChild);
          return reconcileChildrenIterator(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
        }
        if ("function" === typeof newChild.then)
          return reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
      }
      return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
      try {
        thenableIndexCounter$1 = 0;
        var firstChildFiber = reconcileChildFibersImpl(
          returnFiber,
          currentFirstChild,
          newChild,
          lanes
        );
        thenableState$1 = null;
        return firstChildFiber;
      } catch (x2) {
        if (x2 === SuspenseException || x2 === SuspenseActionException) throw x2;
        var fiber = createFiberImplClass(29, x2, null, returnFiber.mode);
        fiber.lanes = lanes;
        fiber.return = returnFiber;
        return fiber;
      } finally {
      }
    };
  }
  var reconcileChildFibers = createChildReconciler(true), mountChildFibers = createChildReconciler(false), hasForceUpdate = false;
  function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
      baseState: fiber.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function cloneUpdateQueue(current2, workInProgress2) {
    current2 = current2.updateQueue;
    workInProgress2.updateQueue === current2 && (workInProgress2.updateQueue = {
      baseState: current2.baseState,
      firstBaseUpdate: current2.firstBaseUpdate,
      lastBaseUpdate: current2.lastBaseUpdate,
      shared: current2.shared,
      callbacks: null
    });
  }
  function createUpdate(lane) {
    return { lane, tag: 0, payload: null, callback: null, next: null };
  }
  function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
      var pending = updateQueue.pending;
      null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
      updateQueue.pending = update;
      update = getRootForUpdatedFiber(fiber);
      markUpdateLaneFromFiberToRoot(fiber, null, lane);
      return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function entangleTransitions(root3, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
      var queueLanes = fiber.lanes;
      queueLanes &= root3.pendingLanes;
      lane |= queueLanes;
      fiber.lanes = lane;
      markRootEntangled(root3, lane);
    }
  }
  function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
    var queue2 = workInProgress2.updateQueue, current2 = workInProgress2.alternate;
    if (null !== current2 && (current2 = current2.updateQueue, queue2 === current2)) {
      var newFirst = null, newLast = null;
      queue2 = queue2.firstBaseUpdate;
      if (null !== queue2) {
        do {
          var clone2 = {
            lane: queue2.lane,
            tag: queue2.tag,
            payload: queue2.payload,
            callback: null,
            next: null
          };
          null === newLast ? newFirst = newLast = clone2 : newLast = newLast.next = clone2;
          queue2 = queue2.next;
        } while (null !== queue2);
        null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
      } else newFirst = newLast = capturedUpdate;
      queue2 = {
        baseState: current2.baseState,
        firstBaseUpdate: newFirst,
        lastBaseUpdate: newLast,
        shared: current2.shared,
        callbacks: current2.callbacks
      };
      workInProgress2.updateQueue = queue2;
      return;
    }
    workInProgress2 = queue2.lastBaseUpdate;
    null === workInProgress2 ? queue2.firstBaseUpdate = capturedUpdate : workInProgress2.next = capturedUpdate;
    queue2.lastBaseUpdate = capturedUpdate;
  }
  var didReadFromEntangledAsyncAction = false;
  function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
      var entangledActionThenable = currentEntangledActionThenable;
      if (null !== entangledActionThenable) throw entangledActionThenable;
    }
  }
  function processUpdateQueue(workInProgress$jscomp$0, props2, instance$jscomp$0, renderLanes2) {
    didReadFromEntangledAsyncAction = false;
    var queue2 = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = false;
    var firstBaseUpdate = queue2.firstBaseUpdate, lastBaseUpdate = queue2.lastBaseUpdate, pendingQueue = queue2.shared.pending;
    if (null !== pendingQueue) {
      queue2.shared.pending = null;
      var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
      lastPendingUpdate.next = null;
      null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
      lastBaseUpdate = lastPendingUpdate;
      var current2 = workInProgress$jscomp$0.alternate;
      null !== current2 && (current2 = current2.updateQueue, pendingQueue = current2.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current2.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current2.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
      var newState = queue2.baseState;
      lastBaseUpdate = 0;
      current2 = firstPendingUpdate = lastPendingUpdate = null;
      pendingQueue = firstBaseUpdate;
      do {
        var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
        if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes2 & updateLane) === updateLane) {
          0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = true);
          null !== current2 && (current2 = current2.next = {
            lane: 0,
            tag: pendingQueue.tag,
            payload: pendingQueue.payload,
            callback: null,
            next: null
          });
          a: {
            var workInProgress2 = workInProgress$jscomp$0, update = pendingQueue;
            updateLane = props2;
            var instance = instance$jscomp$0;
            switch (update.tag) {
              case 1:
                workInProgress2 = update.payload;
                if ("function" === typeof workInProgress2) {
                  newState = workInProgress2.call(instance, newState, updateLane);
                  break a;
                }
                newState = workInProgress2;
                break a;
              case 3:
                workInProgress2.flags = workInProgress2.flags & -65537 | 128;
              case 0:
                workInProgress2 = update.payload;
                updateLane = "function" === typeof workInProgress2 ? workInProgress2.call(instance, newState, updateLane) : workInProgress2;
                if (null === updateLane || void 0 === updateLane) break a;
                newState = assign2({}, newState, updateLane);
                break a;
              case 2:
                hasForceUpdate = true;
            }
          }
          updateLane = pendingQueue.callback;
          null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue2.callbacks, null === isHiddenUpdate ? queue2.callbacks = [updateLane] : isHiddenUpdate.push(updateLane));
        } else
          isHiddenUpdate = {
            lane: updateLane,
            tag: pendingQueue.tag,
            payload: pendingQueue.payload,
            callback: pendingQueue.callback,
            next: null
          }, null === current2 ? (firstPendingUpdate = current2 = isHiddenUpdate, lastPendingUpdate = newState) : current2 = current2.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
        pendingQueue = pendingQueue.next;
        if (null === pendingQueue)
          if (pendingQueue = queue2.shared.pending, null === pendingQueue)
            break;
          else
            isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue2.lastBaseUpdate = isHiddenUpdate, queue2.shared.pending = null;
      } while (1);
      null === current2 && (lastPendingUpdate = newState);
      queue2.baseState = lastPendingUpdate;
      queue2.firstBaseUpdate = firstPendingUpdate;
      queue2.lastBaseUpdate = current2;
      null === firstBaseUpdate && (queue2.shared.lanes = 0);
      workInProgressRootSkippedLanes |= lastBaseUpdate;
      workInProgress$jscomp$0.lanes = lastBaseUpdate;
      workInProgress$jscomp$0.memoizedState = newState;
    }
  }
  function callCallback(callback, context) {
    if ("function" !== typeof callback)
      throw Error(formatProdErrorMessage2(191, callback));
    callback.call(context);
  }
  function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks)
      for (updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)
        callCallback(callbacks[updateQueue], context);
  }
  var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
  function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push2(prevEntangledRenderLanesCursor, fiber);
    push2(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
  }
  function reuseHiddenContextOnStack() {
    push2(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push2(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
  }
  function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
  }
  var suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
  function pushPrimaryTreeSuspenseHandler(handler) {
    var current2 = handler.alternate;
    push2(suspenseStackCursor, suspenseStackCursor.current & 1);
    push2(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current2 || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current2.memoizedState && (shellBoundary = handler));
  }
  function pushDehydratedActivitySuspenseHandler(fiber) {
    push2(suspenseStackCursor, suspenseStackCursor.current);
    push2(suspenseHandlerStackCursor, fiber);
    null === shellBoundary && (shellBoundary = fiber);
  }
  function pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? (push2(suspenseStackCursor, suspenseStackCursor.current), push2(suspenseHandlerStackCursor, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack();
  }
  function reuseSuspenseHandlerOnStack() {
    push2(suspenseStackCursor, suspenseStackCursor.current);
    push2(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
  }
  function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
  }
  var suspenseStackCursor = createCursor(0);
  function findFirstSuspended(row) {
    for (var node = row; null !== node; ) {
      if (13 === node.tag) {
        var state = node.memoizedState;
        if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state)))
          return node;
      } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
        if (0 !== (node.flags & 128)) return node;
      } else if (null !== node.child) {
        node.child.return = node;
        node = node.child;
        continue;
      }
      if (node === row) break;
      for (; null === node.sibling; ) {
        if (null === node.return || node.return === row) return null;
        node = node.return;
      }
      node.sibling.return = node.return;
      node = node.sibling;
    }
    return null;
  }
  var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = false, didScheduleRenderPhaseUpdateDuringThisPass = false, shouldDoubleInvokeUserFnsInHooksDEV = false, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
  function throwInvalidHookError() {
    throw Error(formatProdErrorMessage2(321));
  }
  function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return false;
    for (var i2 = 0; i2 < prevDeps.length && i2 < nextDeps.length; i2++)
      if (!objectIs(nextDeps[i2], prevDeps[i2])) return false;
    return true;
  }
  function renderWithHooks(current2, workInProgress2, Component, props2, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress2;
    workInProgress2.memoizedState = null;
    workInProgress2.updateQueue = null;
    workInProgress2.lanes = 0;
    ReactSharedInternals.H = null === current2 || null === current2.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = false;
    nextRenderLanes = Component(props2, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = false;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(
      workInProgress2,
      Component,
      props2,
      secondArg
    ));
    finishRenderingHooks(current2);
    return nextRenderLanes;
  }
  function finishRenderingHooks(current2) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = false;
    thenableIndexCounter = 0;
    thenableState = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage2(300));
    null === current2 || didReceiveUpdate || (current2 = current2.dependencies, null !== current2 && checkIfContextChanged(current2) && (didReceiveUpdate = true));
  }
  function renderWithHooksAgain(workInProgress2, Component, props2, secondArg) {
    currentlyRenderingFiber = workInProgress2;
    var numberOfReRenders = 0;
    do {
      didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
      thenableIndexCounter = 0;
      didScheduleRenderPhaseUpdateDuringThisPass = false;
      if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage2(301));
      numberOfReRenders += 1;
      workInProgressHook = currentHook = null;
      if (null != workInProgress2.updateQueue) {
        var children = workInProgress2.updateQueue;
        children.lastEffect = null;
        children.events = null;
        children.stores = null;
        null != children.memoCache && (children.memoCache.index = 0);
      }
      ReactSharedInternals.H = HooksDispatcherOnRerender;
      children = Component(props2, secondArg);
    } while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
  }
  function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
  }
  function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
  }
  function bailoutHooks(current2, workInProgress2, lanes) {
    workInProgress2.updateQueue = current2.updateQueue;
    workInProgress2.flags &= -2053;
    current2.lanes &= ~lanes;
  }
  function resetHooksOnUnwind(workInProgress2) {
    if (didScheduleRenderPhaseUpdate) {
      for (workInProgress2 = workInProgress2.memoizedState; null !== workInProgress2; ) {
        var queue2 = workInProgress2.queue;
        null !== queue2 && (queue2.pending = null);
        workInProgress2 = workInProgress2.next;
      }
      didScheduleRenderPhaseUpdate = false;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = false;
    thenableIndexCounter = localIdCounter = 0;
    thenableState = null;
  }
  function mountWorkInProgressHook() {
    var hook = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
  }
  function updateWorkInProgressHook() {
    if (null === currentHook) {
      var nextCurrentHook = currentlyRenderingFiber.alternate;
      nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook)
      workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
      if (null === nextCurrentHook) {
        if (null === currentlyRenderingFiber.alternate)
          throw Error(formatProdErrorMessage2(467));
        throw Error(formatProdErrorMessage2(310));
      }
      currentHook = nextCurrentHook;
      nextCurrentHook = {
        memoizedState: currentHook.memoizedState,
        baseState: currentHook.baseState,
        baseQueue: currentHook.baseQueue,
        queue: currentHook.queue,
        next: null
      };
      null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
  }
  function createFunctionComponentUpdateQueue() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function useThenable(thenable) {
    var index3 = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    thenable = trackUsedThenable(thenableState, thenable, index3);
    index3 = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index3.memoizedState : workInProgressHook.next) && (index3 = index3.alternate, ReactSharedInternals.H = null === index3 || null === index3.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
  }
  function use(usable) {
    if (null !== usable && "object" === typeof usable) {
      if ("function" === typeof usable.then) return useThenable(usable);
      if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage2(438, String(usable)));
  }
  function useMemoCache(size2) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
      var current2 = currentlyRenderingFiber.alternate;
      null !== current2 && (current2 = current2.updateQueue, null !== current2 && (current2 = current2.memoCache, null != current2 && (memoCache = {
        data: current2.data.map(function(array) {
          return array.slice();
        }),
        index: 0
      })));
    }
    null == memoCache && (memoCache = { data: [], index: 0 });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue)
      for (updateQueue = memoCache.data[memoCache.index] = Array(size2), current2 = 0; current2 < size2; current2++)
        updateQueue[current2] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
  }
  function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
  }
  function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
  }
  function updateReducerImpl(hook, current2, reducer) {
    var queue2 = hook.queue;
    if (null === queue2) throw Error(formatProdErrorMessage2(311));
    queue2.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue2.pending;
    if (null !== pendingQueue) {
      if (null !== baseQueue) {
        var baseFirst = baseQueue.next;
        baseQueue.next = pendingQueue.next;
        pendingQueue.next = baseFirst;
      }
      current2.baseQueue = baseQueue = pendingQueue;
      queue2.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
      current2 = baseQueue.next;
      var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current2, didReadFromEntangledAsyncAction$60 = false;
      do {
        var updateLane = update.lane & -536870913;
        if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
          var revertLane = update.revertLane;
          if (0 === revertLane)
            null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: update.action,
              hasEagerState: update.hasEagerState,
              eagerState: update.eagerState,
              next: null
            }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = true);
          else if ((renderLanes & revertLane) === revertLane) {
            update = update.next;
            revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = true);
            continue;
          } else
            updateLane = {
              lane: 0,
              revertLane: update.revertLane,
              gesture: null,
              action: update.action,
              hasEagerState: update.hasEagerState,
              eagerState: update.eagerState,
              next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
          updateLane = update.action;
          shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
          pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
        } else
          revertLane = {
            lane: updateLane,
            revertLane: update.revertLane,
            gesture: update.gesture,
            action: update.action,
            hasEagerState: update.hasEagerState,
            eagerState: update.eagerState,
            next: null
          }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
        update = update.next;
      } while (null !== update && update !== current2);
      null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
      if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = true, didReadFromEntangledAsyncAction$60 && (reducer = currentEntangledActionThenable, null !== reducer)))
        throw reducer;
      hook.memoizedState = pendingQueue;
      hook.baseState = baseFirst;
      hook.baseQueue = newBaseQueueLast;
      queue2.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue2.lanes = 0);
    return [hook.memoizedState, queue2.dispatch];
  }
  function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue2 = hook.queue;
    if (null === queue2) throw Error(formatProdErrorMessage2(311));
    queue2.lastRenderedReducer = reducer;
    var dispatch = queue2.dispatch, lastRenderPhaseUpdate = queue2.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
      queue2.pending = null;
      var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
      do
        newState = reducer(newState, update.action), update = update.next;
      while (update !== lastRenderPhaseUpdate);
      objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
      hook.memoizedState = newState;
      null === hook.baseQueue && (hook.baseState = newState);
      queue2.lastRenderedState = newState;
    }
    return [newState, dispatch];
  }
  function updateSyncExternalStore(subscribe2, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
      if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage2(407));
      getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs(
      (currentHook || hook).memoizedState,
      getServerSnapshot
    );
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = true);
    hook = hook.queue;
    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe2), [
      subscribe2
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        { destroy: void 0 },
        updateStoreInstance.bind(
          null,
          fiber,
          hook,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      if (null === workInProgressRoot) throw Error(formatProdErrorMessage2(349));
      isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
  }
  function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = { getSnapshot, value: renderedSnapshot };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [fiber]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [fiber] : renderedSnapshot.push(fiber));
  }
  function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
  }
  function subscribeToStore(fiber, inst, subscribe2) {
    return subscribe2(function() {
      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function forceStoreRerender(fiber) {
    var root3 = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2);
  }
  function mountStateImpl(initialState2) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState2) {
      var initialStateInitializer = initialState2;
      initialState2 = initialStateInitializer();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          initialStateInitializer();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
    }
    hook.memoizedState = hook.baseState = initialState2;
    hook.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: initialState2
    };
    return hook;
  }
  function updateOptimisticImpl(hook, current2, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(
      hook,
      currentHook,
      "function" === typeof reducer ? reducer : basicStateReducer
    );
  }
  function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage2(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
      var actionNode = {
        payload,
        action: fiber,
        next: null,
        isTransition: true,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(listener) {
          actionNode.listeners.push(listener);
        }
      };
      null !== ReactSharedInternals.T ? setPendingState(true) : actionNode.isTransition = false;
      setState(actionNode);
      setPendingState = actionQueue.pending;
      null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
  }
  function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
      var prevTransition = ReactSharedInternals.T, currentTransition = {};
      ReactSharedInternals.T = currentTransition;
      try {
        var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        handleActionReturnValue(actionQueue, node, returnValue);
      } catch (error) {
        onActionError(actionQueue, node, error);
      } finally {
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
      }
    } else
      try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
      } catch (error$66) {
        onActionError(actionQueue, node, error$66);
      }
  }
  function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(
      function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
      },
      function(error) {
        return onActionError(actionQueue, node, error);
      }
    ) : onActionSuccess(actionQueue, node, returnValue);
  }
  function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
  }
  function onActionError(actionQueue, actionNode, error) {
    var last2 = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last2) {
      last2 = last2.next;
      do
        actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
      while (actionNode !== last2);
    }
    actionQueue.action = null;
  }
  function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for (var i2 = 0; i2 < actionNode.length; i2++) (0, actionNode[i2])();
  }
  function actionStateReducer(oldState, newState) {
    return newState;
  }
  function mountActionState(action, initialStateProp) {
    if (isHydrating) {
      var ssrFormState = workInProgressRoot.formState;
      if (null !== ssrFormState) {
        a: {
          var JSCompiler_inline_result = currentlyRenderingFiber;
          if (isHydrating) {
            if (nextHydratableInstance) {
              b: {
                var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                for (var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType; ) {
                  if (!inRootOrSingleton) {
                    JSCompiler_inline_result$jscomp$0 = null;
                    break b;
                  }
                  JSCompiler_inline_result$jscomp$0 = getNextHydratable(
                    JSCompiler_inline_result$jscomp$0.nextSibling
                  );
                  if (null === JSCompiler_inline_result$jscomp$0) {
                    JSCompiler_inline_result$jscomp$0 = null;
                    break b;
                  }
                }
                inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
              }
              if (JSCompiler_inline_result$jscomp$0) {
                nextHydratableInstance = getNextHydratable(
                  JSCompiler_inline_result$jscomp$0.nextSibling
                );
                JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                break a;
              }
            }
            throwOnHydrationMismatch(JSCompiler_inline_result);
          }
          JSCompiler_inline_result = false;
        }
        JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
      }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: actionStateReducer,
      lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(
      null,
      currentlyRenderingFiber,
      JSCompiler_inline_result
    );
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(false);
    inRootOrSingleton = dispatchOptimisticSetState.bind(
      null,
      currentlyRenderingFiber,
      false,
      JSCompiler_inline_result.queue
    );
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
      state: initialStateProp,
      dispatch: null,
      action,
      pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(
      null,
      currentlyRenderingFiber,
      JSCompiler_inline_result$jscomp$0,
      inRootOrSingleton,
      ssrFormState
    );
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [initialStateProp, ssrFormState, false];
  }
  function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
  }
  function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(
      stateHook,
      currentStateHook,
      actionStateReducer
    )[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then)
      try {
        var state = useThenable(currentStateHook);
      } catch (x2) {
        if (x2 === SuspenseException) throw SuspenseActionException;
        throw x2;
      }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(
      9,
      { destroy: void 0 },
      actionStateActionEffect.bind(null, actionQueue, action),
      null
    ));
    return [state, dispatch, stateHook];
  }
  function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
  }
  function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook)
      return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [stateHook, dispatch, false];
  }
  function pushSimpleEffect(tag2, inst, create2, deps) {
    tag2 = { tag: tag2, create: create2, deps, inst, next: null };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create2 = inst.lastEffect;
    null === create2 ? inst.lastEffect = tag2.next = tag2 : (deps = create2.next, create2.next = tag2, tag2.next = deps, inst.lastEffect = tag2);
    return tag2;
  }
  function updateRef() {
    return updateWorkInProgressHook().memoizedState;
  }
  function mountEffectImpl(fiberFlags, hookFlags, create2, deps) {
    var hook = mountWorkInProgressHook();
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(
      1 | hookFlags,
      { destroy: void 0 },
      create2,
      void 0 === deps ? null : deps
    );
  }
  function updateEffectImpl(fiberFlags, hookFlags, create2, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create2, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(
      1 | hookFlags,
      inst,
      create2,
      deps
    ));
  }
  function mountEffect(create2, deps) {
    mountEffectImpl(8390656, 8, create2, deps);
  }
  function updateEffect(create2, deps) {
    updateEffectImpl(2048, 8, create2, deps);
  }
  function useEffectEventImpl(payload) {
    currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue)
      componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [payload];
    else {
      var events2 = componentUpdateQueue.events;
      null === events2 ? componentUpdateQueue.events = [payload] : events2.push(payload);
    }
  }
  function updateEvent(callback) {
    var ref = updateWorkInProgressHook().memoizedState;
    useEffectEventImpl({ ref, nextImpl: callback });
    return function() {
      if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage2(440));
      return ref.impl.apply(void 0, arguments);
    };
  }
  function updateInsertionEffect(create2, deps) {
    return updateEffectImpl(4, 2, create2, deps);
  }
  function updateLayoutEffect(create2, deps) {
    return updateEffectImpl(4, 4, create2, deps);
  }
  function imperativeHandleEffect(create2, ref) {
    if ("function" === typeof ref) {
      create2 = create2();
      var refCleanup = ref(create2);
      return function() {
        "function" === typeof refCleanup ? refCleanup() : ref(null);
      };
    }
    if (null !== ref && void 0 !== ref)
      return create2 = create2(), ref.current = create2, function() {
        ref.current = null;
      };
  }
  function updateImperativeHandle(ref, create2, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create2, ref), deps);
  }
  function mountDebugValue() {
  }
  function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
      return prevState[0];
    hook.memoizedState = [callback, deps];
    return callback;
  }
  function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
      return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
      setIsStrictModeForDevtools(true);
      try {
        nextCreate();
      } finally {
        setIsStrictModeForDevtools(false);
      }
    }
    hook.memoizedState = [prevState, deps];
    return prevState;
  }
  function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930))
      return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
  }
  function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current)
      return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = true), hook;
    if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930))
      return didReceiveUpdate = true, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
  }
  function startTransition(fiber, queue2, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, false, queue2, pendingState);
    try {
      var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
      null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
      if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
        var thenableForFinishedState = chainThenableValue(
          returnValue,
          finishedState
        );
        dispatchSetStateInternal(
          fiber,
          queue2,
          thenableForFinishedState,
          requestUpdateLane(fiber)
        );
      } else
        dispatchSetStateInternal(
          fiber,
          queue2,
          finishedState,
          requestUpdateLane(fiber)
        );
    } catch (error) {
      dispatchSetStateInternal(
        fiber,
        queue2,
        { then: function() {
        }, status: "rejected", reason: error },
        requestUpdateLane()
      );
    } finally {
      ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
  }
  function noop2() {
  }
  function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage2(476));
    var queue2 = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(
      formFiber,
      queue2,
      pendingState,
      sharedNotPendingObject,
      null === action ? noop2 : function() {
        requestFormReset$1(formFiber);
        return action(formData);
      }
    );
  }
  function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
      memoizedState: sharedNotPendingObject,
      baseState: sharedNotPendingObject,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: sharedNotPendingObject
      },
      next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
      memoizedState: initialResetState,
      baseState: initialResetState,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialResetState
      },
      next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
  }
  function requestFormReset$1(formFiber) {
    var stateHook = ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    dispatchSetStateInternal(
      formFiber,
      stateHook.next.queue,
      {},
      requestUpdateLane()
    );
  }
  function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
  }
  function updateId() {
    return updateWorkInProgressHook().memoizedState;
  }
  function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
  }
  function refreshCache(fiber) {
    for (var provider = fiber.return; null !== provider; ) {
      switch (provider.tag) {
        case 24:
        case 3:
          var lane = requestUpdateLane();
          fiber = createUpdate(lane);
          var root$69 = enqueueUpdate(provider, fiber, lane);
          null !== root$69 && (scheduleUpdateOnFiber(root$69, provider, lane), entangleTransitions(root$69, provider, lane));
          provider = { cache: createCache() };
          fiber.payload = provider;
          return;
      }
      provider = provider.return;
    }
  }
  function dispatchReducerAction(fiber, queue2, action) {
    var lane = requestUpdateLane();
    action = {
      lane,
      revertLane: 0,
      gesture: null,
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue2, action) : (action = enqueueConcurrentHookUpdate(fiber, queue2, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue2, lane)));
  }
  function dispatchSetState(fiber, queue2, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue2, action, lane);
  }
  function dispatchSetStateInternal(fiber, queue2, action, lane) {
    var update = {
      lane,
      revertLane: 0,
      gesture: null,
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue2, update);
    else {
      var alternate = fiber.alternate;
      if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue2.lastRenderedReducer, null !== alternate))
        try {
          var currentState = queue2.lastRenderedState, eagerState = alternate(currentState, action);
          update.hasEagerState = true;
          update.eagerState = eagerState;
          if (objectIs(eagerState, currentState))
            return enqueueUpdate$1(fiber, queue2, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), false;
        } catch (error) {
        } finally {
        }
      action = enqueueConcurrentHookUpdate(fiber, queue2, update, lane);
      if (null !== action)
        return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue2, lane), true;
    }
    return false;
  }
  function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue2, action) {
    action = {
      lane: 2,
      revertLane: requestTransitionLane(),
      gesture: null,
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
      if (throwIfDuringRender) throw Error(formatProdErrorMessage2(479));
    } else
      throwIfDuringRender = enqueueConcurrentHookUpdate(
        fiber,
        queue2,
        action,
        2
      ), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
  }
  function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
  }
  function enqueueRenderPhaseUpdate(queue2, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
    var pending = queue2.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue2.pending = update;
  }
  function entangleTransitionUpdate(root3, queue2, lane) {
    if (0 !== (lane & 4194048)) {
      var queueLanes = queue2.lanes;
      queueLanes &= root3.pendingLanes;
      lane |= queueLanes;
      queue2.lanes = lane;
      markRootEntangled(root3, lane);
    }
  }
  var ContextOnlyDispatcher = {
    readContext,
    use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
  };
  ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
  var HooksDispatcherOnMount = {
    readContext,
    use,
    useCallback: function(callback, deps) {
      mountWorkInProgressHook().memoizedState = [
        callback,
        void 0 === deps ? null : deps
      ];
      return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create2, deps) {
      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
      mountEffectImpl(
        4194308,
        4,
        imperativeHandleEffect.bind(null, create2, ref),
        deps
      );
    },
    useLayoutEffect: function(create2, deps) {
      return mountEffectImpl(4194308, 4, create2, deps);
    },
    useInsertionEffect: function(create2, deps) {
      mountEffectImpl(4, 2, create2, deps);
    },
    useMemo: function(nextCreate, deps) {
      var hook = mountWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var nextValue = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [nextValue, deps];
      return nextValue;
    },
    useReducer: function(reducer, initialArg, init2) {
      var hook = mountWorkInProgressHook();
      if (void 0 !== init2) {
        var initialState2 = init2(initialArg);
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            init2(initialArg);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      } else initialState2 = initialArg;
      hook.memoizedState = hook.baseState = initialState2;
      reducer = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: reducer,
        lastRenderedState: initialState2
      };
      hook.queue = reducer;
      reducer = reducer.dispatch = dispatchReducerAction.bind(
        null,
        currentlyRenderingFiber,
        reducer
      );
      return [hook.memoizedState, reducer];
    },
    useRef: function(initialValue) {
      var hook = mountWorkInProgressHook();
      initialValue = { current: initialValue };
      return hook.memoizedState = initialValue;
    },
    useState: function(initialState2) {
      initialState2 = mountStateImpl(initialState2);
      var queue2 = initialState2.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue2);
      queue2.dispatch = dispatch;
      return [initialState2.memoizedState, dispatch];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = mountWorkInProgressHook();
      return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
      var stateHook = mountStateImpl(false);
      stateHook = startTransition.bind(
        null,
        currentlyRenderingFiber,
        stateHook.queue,
        true,
        false
      );
      mountWorkInProgressHook().memoizedState = stateHook;
      return [false, stateHook];
    },
    useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
      if (isHydrating) {
        if (void 0 === getServerSnapshot)
          throw Error(formatProdErrorMessage2(407));
        getServerSnapshot = getServerSnapshot();
      } else {
        getServerSnapshot = getSnapshot();
        if (null === workInProgressRoot)
          throw Error(formatProdErrorMessage2(349));
        0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
      }
      hook.memoizedState = getServerSnapshot;
      var inst = { value: getServerSnapshot, getSnapshot };
      hook.queue = inst;
      mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe2), [
        subscribe2
      ]);
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        { destroy: void 0 },
        updateStoreInstance.bind(
          null,
          fiber,
          inst,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      return getServerSnapshot;
    },
    useId: function() {
      var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
      if (isHydrating) {
        var JSCompiler_inline_result = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
        identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
        JSCompiler_inline_result = localIdCounter++;
        0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
        identifierPrefix += "_";
      } else
        JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
      return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
      var hook = mountWorkInProgressHook();
      hook.memoizedState = hook.baseState = passthrough;
      var queue2 = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      hook.queue = queue2;
      hook = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        true,
        queue2
      );
      queue2.dispatch = hook;
      return [passthrough, hook];
    },
    useMemoCache,
    useCacheRefresh: function() {
      return mountWorkInProgressHook().memoizedState = refreshCache.bind(
        null,
        currentlyRenderingFiber
      );
    },
    useEffectEvent: function(callback) {
      var hook = mountWorkInProgressHook(), ref = { impl: callback };
      hook.memoizedState = ref;
      return function() {
        if (0 !== (executionContext & 2))
          throw Error(formatProdErrorMessage2(440));
        return ref.impl.apply(void 0, arguments);
      };
    }
  }, HooksDispatcherOnUpdate = {
    readContext,
    use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
      return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function() {
      var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache,
    useCacheRefresh: updateRefresh
  };
  HooksDispatcherOnUpdate.useEffectEvent = updateEvent;
  var HooksDispatcherOnRerender = {
    readContext,
    use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
      return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function() {
      var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      if (null !== currentHook)
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
      hook.baseState = passthrough;
      return [passthrough, hook.queue.dispatch];
    },
    useMemoCache,
    useCacheRefresh: updateRefresh
  };
  HooksDispatcherOnRerender.useEffectEvent = updateEvent;
  function applyDerivedStateFromProps(workInProgress2, ctor2, getDerivedStateFromProps, nextProps) {
    ctor2 = workInProgress2.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor2);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor2 : assign2({}, ctor2, getDerivedStateFromProps);
    workInProgress2.memoizedState = getDerivedStateFromProps;
    0 === workInProgress2.lanes && (workInProgress2.updateQueue.baseState = getDerivedStateFromProps);
  }
  var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.payload = payload;
      void 0 !== callback && null !== callback && (update.callback = callback);
      payload = enqueueUpdate(inst, update, lane);
      null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.tag = 1;
      update.payload = payload;
      void 0 !== callback && null !== callback && (update.callback = callback);
      payload = enqueueUpdate(inst, update, lane);
      null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.tag = 2;
      void 0 !== callback && null !== callback && (update.callback = callback);
      callback = enqueueUpdate(inst, update, lane);
      null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
  };
  function checkShouldComponentUpdate(workInProgress2, ctor2, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress2 = workInProgress2.stateNode;
    return "function" === typeof workInProgress2.shouldComponentUpdate ? workInProgress2.shouldComponentUpdate(newProps, newState, nextContext) : ctor2.prototype && ctor2.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : true;
  }
  function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
    workInProgress2 = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress2 && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
  function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
      newProps = {};
      for (var propName in baseProps)
        "ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
      newProps === baseProps && (newProps = assign2({}, newProps));
      for (var propName$73 in Component)
        void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
  }
  function defaultOnUncaughtError(error) {
    reportGlobalError(error);
  }
  function defaultOnCaughtError(error) {
    console.error(error);
  }
  function defaultOnRecoverableError(error) {
    reportGlobalError(error);
  }
  function logUncaughtError(root3, errorInfo) {
    try {
      var onUncaughtError = root3.onUncaughtError;
      onUncaughtError(errorInfo.value, { componentStack: errorInfo.stack });
    } catch (e$74) {
      setTimeout(function() {
        throw e$74;
      });
    }
  }
  function logCaughtError(root3, boundary, errorInfo) {
    try {
      var onCaughtError = root3.onCaughtError;
      onCaughtError(errorInfo.value, {
        componentStack: errorInfo.stack,
        errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
      });
    } catch (e$75) {
      setTimeout(function() {
        throw e$75;
      });
    }
  }
  function createRootErrorUpdate(root3, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = { element: null };
    lane.callback = function() {
      logUncaughtError(root3, errorInfo);
    };
    return lane;
  }
  function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
  }
  function initializeClassErrorUpdate(update, root3, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
      var error = errorInfo.value;
      update.payload = function() {
        return getDerivedStateFromError(error);
      };
      update.callback = function() {
        logCaughtError(root3, fiber, errorInfo);
      };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
      logCaughtError(root3, fiber, errorInfo);
      "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([this]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
      var stack = errorInfo.stack;
      this.componentDidCatch(errorInfo.value, {
        componentStack: null !== stack ? stack : ""
      });
    });
  }
  function throwException(root3, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
      returnFiber = sourceFiber.alternate;
      null !== returnFiber && propagateParentContextChanges(
        returnFiber,
        sourceFiber,
        rootRenderLanes,
        true
      );
      sourceFiber = suspenseHandlerStackCursor.current;
      if (null !== sourceFiber) {
        switch (sourceFiber.tag) {
          case 31:
          case 13:
            return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = /* @__PURE__ */ new Set([value]) : returnFiber.add(value), attachPingListener(root3, value, rootRenderLanes)), false;
          case 22:
            return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([value])
            }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = /* @__PURE__ */ new Set([value]) : sourceFiber.add(value)), attachPingListener(root3, value, rootRenderLanes)), false;
        }
        throw Error(formatProdErrorMessage2(435, sourceFiber.tag));
      }
      attachPingListener(root3, value, rootRenderLanes);
      renderDidSuspendDelayIfPossible();
      return false;
    }
    if (isHydrating)
      return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root3 = Error(formatProdErrorMessage2(422), { cause: value }), queueHydrationError(createCapturedValueAtFiber(root3, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage2(423), {
        cause: value
      }), queueHydrationError(
        createCapturedValueAtFiber(returnFiber, sourceFiber)
      )), root3 = root3.current.alternate, root3.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root3.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(
        root3.stateNode,
        value,
        rootRenderLanes
      ), enqueueCapturedUpdate(root3, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), false;
    var wrapperError = Error(formatProdErrorMessage2(520), { cause: value });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [wrapperError] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return true;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
      switch (sourceFiber.tag) {
        case 3:
          return sourceFiber.flags |= 65536, root3 = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root3, root3 = createRootErrorUpdate(sourceFiber.stateNode, value, root3), enqueueCapturedUpdate(sourceFiber, root3), false;
        case 1:
          if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError))))
            return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(
              rootRenderLanes,
              root3,
              sourceFiber,
              value
            ), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), false;
      }
      sourceFiber = sourceFiber.return;
    } while (null !== sourceFiber);
    return false;
  }
  var SelectiveHydrationException = Error(formatProdErrorMessage2(461)), didReceiveUpdate = false;
  function reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2) {
    workInProgress2.child = null === current2 ? mountChildFibers(workInProgress2, null, nextChildren, renderLanes2) : reconcileChildFibers(
      workInProgress2,
      current2.child,
      nextChildren,
      renderLanes2
    );
  }
  function updateForwardRef(current2, workInProgress2, Component, nextProps, renderLanes2) {
    Component = Component.render;
    var ref = workInProgress2.ref;
    if ("ref" in nextProps) {
      var propsWithoutRef = {};
      for (var key in nextProps)
        "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress2);
    nextProps = renderWithHooks(
      current2,
      workInProgress2,
      Component,
      propsWithoutRef,
      ref,
      renderLanes2
    );
    key = checkDidRenderIdHook();
    if (null !== current2 && !didReceiveUpdate)
      return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    isHydrating && key && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
    return workInProgress2.child;
  }
  function updateMemoComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
    if (null === current2) {
      var type = Component.type;
      if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare)
        return workInProgress2.tag = 15, workInProgress2.type = type, updateSimpleMemoComponent(
          current2,
          workInProgress2,
          type,
          nextProps,
          renderLanes2
        );
      current2 = createFiberFromTypeAndProps(
        Component.type,
        null,
        nextProps,
        workInProgress2,
        workInProgress2.mode,
        renderLanes2
      );
      current2.ref = workInProgress2.ref;
      current2.return = workInProgress2;
      return workInProgress2.child = current2;
    }
    type = current2.child;
    if (!checkScheduledUpdateOrContext(current2, renderLanes2)) {
      var prevProps = type.memoizedProps;
      Component = Component.compare;
      Component = null !== Component ? Component : shallowEqual;
      if (Component(prevProps, nextProps) && current2.ref === workInProgress2.ref)
        return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    }
    workInProgress2.flags |= 1;
    current2 = createWorkInProgress(type, nextProps);
    current2.ref = workInProgress2.ref;
    current2.return = workInProgress2;
    return workInProgress2.child = current2;
  }
  function updateSimpleMemoComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
    if (null !== current2) {
      var prevProps = current2.memoizedProps;
      if (shallowEqual(prevProps, nextProps) && current2.ref === workInProgress2.ref)
        if (didReceiveUpdate = false, workInProgress2.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current2, renderLanes2))
          0 !== (current2.flags & 131072) && (didReceiveUpdate = true);
        else
          return workInProgress2.lanes = current2.lanes, bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    }
    return updateFunctionComponent(
      current2,
      workInProgress2,
      Component,
      nextProps,
      renderLanes2
    );
  }
  function updateOffscreenComponent(current2, workInProgress2, renderLanes2, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current2 ? current2.memoizedState : null;
    null === current2 && null === workInProgress2.stateNode && (workInProgress2.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    });
    if ("hidden" === nextProps.mode) {
      if (0 !== (workInProgress2.flags & 128)) {
        prevState = null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2;
        if (null !== current2) {
          nextProps = workInProgress2.child = current2.child;
          for (nextChildren = 0; null !== nextProps; )
            nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
          nextProps = nextChildren & ~prevState;
        } else nextProps = 0, workInProgress2.child = null;
        return deferHiddenOffscreenComponent(
          current2,
          workInProgress2,
          prevState,
          renderLanes2,
          nextProps
        );
      }
      if (0 !== (renderLanes2 & 536870912))
        workInProgress2.memoizedState = { baseLanes: 0, cachePool: null }, null !== current2 && pushTransition(
          workInProgress2,
          null !== prevState ? prevState.cachePool : null
        ), null !== prevState ? pushHiddenContext(workInProgress2, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress2);
      else
        return nextProps = workInProgress2.lanes = 536870912, deferHiddenOffscreenComponent(
          current2,
          workInProgress2,
          null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2,
          renderLanes2,
          nextProps
        );
    } else
      null !== prevState ? (pushTransition(workInProgress2, prevState.cachePool), pushHiddenContext(workInProgress2, prevState), reuseSuspenseHandlerOnStack(), workInProgress2.memoizedState = null) : (null !== current2 && pushTransition(workInProgress2, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack());
    reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
    return workInProgress2.child;
  }
  function bailoutOffscreenComponent(current2, workInProgress2) {
    null !== current2 && 22 === current2.tag || null !== workInProgress2.stateNode || (workInProgress2.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    });
    return workInProgress2.sibling;
  }
  function deferHiddenOffscreenComponent(current2, workInProgress2, nextBaseLanes, renderLanes2, remainingChildLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : { parent: CacheContext._currentValue, pool: JSCompiler_inline_result };
    workInProgress2.memoizedState = {
      baseLanes: nextBaseLanes,
      cachePool: JSCompiler_inline_result
    };
    null !== current2 && pushTransition(workInProgress2, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress2);
    null !== current2 && propagateParentContextChanges(current2, workInProgress2, renderLanes2, true);
    workInProgress2.childLanes = remainingChildLanes;
    return null;
  }
  function mountActivityChildren(workInProgress2, nextProps) {
    nextProps = mountWorkInProgressOffscreenFiber(
      { mode: nextProps.mode, children: nextProps.children },
      workInProgress2.mode
    );
    nextProps.ref = workInProgress2.ref;
    workInProgress2.child = nextProps;
    nextProps.return = workInProgress2;
    return nextProps;
  }
  function retryActivityComponentWithoutHydrating(current2, workInProgress2, renderLanes2) {
    reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
    current2 = mountActivityChildren(workInProgress2, workInProgress2.pendingProps);
    current2.flags |= 2;
    popSuspenseHandler(workInProgress2);
    workInProgress2.memoizedState = null;
    return current2;
  }
  function updateActivityComponent(current2, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, didSuspend = 0 !== (workInProgress2.flags & 128);
    workInProgress2.flags &= -129;
    if (null === current2) {
      if (isHydrating) {
        if ("hidden" === nextProps.mode)
          return current2 = mountActivityChildren(workInProgress2, nextProps), workInProgress2.lanes = 536870912, bailoutOffscreenComponent(null, current2);
        pushDehydratedActivitySuspenseHandler(workInProgress2);
        (current2 = nextHydratableInstance) ? (current2 = canHydrateHydrationBoundary(
          current2,
          rootOrSingletonContext
        ), current2 = null !== current2 && "&" === current2.data ? current2 : null, null !== current2 && (workInProgress2.memoizedState = {
          dehydrated: current2,
          treeContext: null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, renderLanes2 = createFiberFromDehydratedFragment(current2), renderLanes2.return = workInProgress2, workInProgress2.child = renderLanes2, hydrationParentFiber = workInProgress2, nextHydratableInstance = null)) : current2 = null;
        if (null === current2) throw throwOnHydrationMismatch(workInProgress2);
        workInProgress2.lanes = 536870912;
        return null;
      }
      return mountActivityChildren(workInProgress2, nextProps);
    }
    var prevState = current2.memoizedState;
    if (null !== prevState) {
      var dehydrated = prevState.dehydrated;
      pushDehydratedActivitySuspenseHandler(workInProgress2);
      if (didSuspend)
        if (workInProgress2.flags & 256)
          workInProgress2.flags &= -257, workInProgress2 = retryActivityComponentWithoutHydrating(
            current2,
            workInProgress2,
            renderLanes2
          );
        else if (null !== workInProgress2.memoizedState)
          workInProgress2.child = current2.child, workInProgress2.flags |= 128, workInProgress2 = null;
        else throw Error(formatProdErrorMessage2(558));
      else if (didReceiveUpdate || propagateParentContextChanges(current2, workInProgress2, renderLanes2, false), didSuspend = 0 !== (renderLanes2 & current2.childLanes), didReceiveUpdate || didSuspend) {
        nextProps = workInProgressRoot;
        if (null !== nextProps && (dehydrated = getBumpedLaneForHydration(nextProps, renderLanes2), 0 !== dehydrated && dehydrated !== prevState.retryLane))
          throw prevState.retryLane = dehydrated, enqueueConcurrentRenderForLane(current2, dehydrated), scheduleUpdateOnFiber(nextProps, current2, dehydrated), SelectiveHydrationException;
        renderDidSuspendDelayIfPossible();
        workInProgress2 = retryActivityComponentWithoutHydrating(
          current2,
          workInProgress2,
          renderLanes2
        );
      } else
        current2 = prevState.treeContext, nextHydratableInstance = getNextHydratable(dehydrated.nextSibling), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, rootOrSingletonContext = false, null !== current2 && restoreSuspendedTreeContext(workInProgress2, current2), workInProgress2 = mountActivityChildren(workInProgress2, nextProps), workInProgress2.flags |= 4096;
      return workInProgress2;
    }
    current2 = createWorkInProgress(current2.child, {
      mode: nextProps.mode,
      children: nextProps.children
    });
    current2.ref = workInProgress2.ref;
    workInProgress2.child = current2;
    current2.return = workInProgress2;
    return current2;
  }
  function markRef(current2, workInProgress2) {
    var ref = workInProgress2.ref;
    if (null === ref)
      null !== current2 && null !== current2.ref && (workInProgress2.flags |= 4194816);
    else {
      if ("function" !== typeof ref && "object" !== typeof ref)
        throw Error(formatProdErrorMessage2(284));
      if (null === current2 || current2.ref !== ref)
        workInProgress2.flags |= 4194816;
    }
  }
  function updateFunctionComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
    prepareToReadContext(workInProgress2);
    Component = renderWithHooks(
      current2,
      workInProgress2,
      Component,
      nextProps,
      void 0,
      renderLanes2
    );
    nextProps = checkDidRenderIdHook();
    if (null !== current2 && !didReceiveUpdate)
      return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current2, workInProgress2, Component, renderLanes2);
    return workInProgress2.child;
  }
  function replayFunctionComponent(current2, workInProgress2, nextProps, Component, secondArg, renderLanes2) {
    prepareToReadContext(workInProgress2);
    workInProgress2.updateQueue = null;
    nextProps = renderWithHooksAgain(
      workInProgress2,
      Component,
      nextProps,
      secondArg
    );
    finishRenderingHooks(current2);
    Component = checkDidRenderIdHook();
    if (null !== current2 && !didReceiveUpdate)
      return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    isHydrating && Component && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
    return workInProgress2.child;
  }
  function updateClassComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
    prepareToReadContext(workInProgress2);
    if (null === workInProgress2.stateNode) {
      var context = emptyContextObject, contextType = Component.contextType;
      "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
      context = new Component(nextProps, context);
      workInProgress2.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
      context.updater = classComponentUpdater;
      workInProgress2.stateNode = context;
      context._reactInternals = workInProgress2;
      context = workInProgress2.stateNode;
      context.props = nextProps;
      context.state = workInProgress2.memoizedState;
      context.refs = {};
      initializeUpdateQueue(workInProgress2);
      contextType = Component.contextType;
      context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
      context.state = workInProgress2.memoizedState;
      contextType = Component.getDerivedStateFromProps;
      "function" === typeof contextType && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        contextType,
        nextProps
      ), context.state = workInProgress2.memoizedState);
      "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress2, nextProps, context, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress2.memoizedState);
      "function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308);
      nextProps = true;
    } else if (null === current2) {
      context = workInProgress2.stateNode;
      var unresolvedOldProps = workInProgress2.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
      context.props = oldProps;
      var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
      contextType = emptyContextObject;
      "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
      var getDerivedStateFromProps = Component.getDerivedStateFromProps;
      contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
      unresolvedOldProps = workInProgress2.pendingProps !== unresolvedOldProps;
      contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(
        workInProgress2,
        context,
        nextProps,
        contextType
      );
      hasForceUpdate = false;
      var oldState = workInProgress2.memoizedState;
      context.state = oldState;
      processUpdateQueue(workInProgress2, nextProps, context, renderLanes2);
      suspendIfUpdateReadFromEntangledAsyncAction();
      oldContext = workInProgress2.memoizedState;
      unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        getDerivedStateFromProps,
        nextProps
      ), oldContext = workInProgress2.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(
        workInProgress2,
        Component,
        oldProps,
        nextProps,
        oldState,
        oldContext,
        contextType
      )) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308), nextProps = false);
    } else {
      context = workInProgress2.stateNode;
      cloneUpdateQueue(current2, workInProgress2);
      contextType = workInProgress2.memoizedProps;
      contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
      context.props = contextType$jscomp$0;
      getDerivedStateFromProps = workInProgress2.pendingProps;
      oldState = context.context;
      oldContext = Component.contextType;
      oldProps = emptyContextObject;
      "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
      unresolvedOldProps = Component.getDerivedStateFromProps;
      (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(
        workInProgress2,
        context,
        nextProps,
        oldProps
      );
      hasForceUpdate = false;
      oldState = workInProgress2.memoizedState;
      context.state = oldState;
      processUpdateQueue(workInProgress2, nextProps, context, renderLanes2);
      suspendIfUpdateReadFromEntangledAsyncAction();
      var newState = workInProgress2.memoizedState;
      contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current2 && null !== current2.dependencies && checkIfContextChanged(current2.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        unresolvedOldProps,
        nextProps
      ), newState = workInProgress2.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(
        workInProgress2,
        Component,
        contextType$jscomp$0,
        nextProps,
        oldState,
        newState,
        oldProps
      ) || null !== current2 && null !== current2.dependencies && checkIfContextChanged(current2.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(
        nextProps,
        newState,
        oldProps
      )), "function" === typeof context.componentDidUpdate && (workInProgress2.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress2.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 1024), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 1024), nextProps = false);
    }
    context = nextProps;
    markRef(current2, workInProgress2);
    nextProps = 0 !== (workInProgress2.flags & 128);
    context || nextProps ? (context = workInProgress2.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress2.flags |= 1, null !== current2 && nextProps ? (workInProgress2.child = reconcileChildFibers(
      workInProgress2,
      current2.child,
      null,
      renderLanes2
    ), workInProgress2.child = reconcileChildFibers(
      workInProgress2,
      null,
      Component,
      renderLanes2
    )) : reconcileChildren(current2, workInProgress2, Component, renderLanes2), workInProgress2.memoizedState = context.state, current2 = workInProgress2.child) : current2 = bailoutOnAlreadyFinishedWork(
      current2,
      workInProgress2,
      renderLanes2
    );
    return current2;
  }
  function mountHostRootWithoutHydrating(current2, workInProgress2, nextChildren, renderLanes2) {
    resetHydrationState();
    workInProgress2.flags |= 256;
    reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
    return workInProgress2.child;
  }
  var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function mountSuspenseOffscreenState(renderLanes2) {
    return { baseLanes: renderLanes2, cachePool: getSuspendedCache() };
  }
  function getRemainingWorkInPrimaryTree(current2, primaryTreeDidDefer, renderLanes2) {
    current2 = null !== current2 ? current2.childLanes & ~renderLanes2 : 0;
    primaryTreeDidDefer && (current2 |= workInProgressDeferredLane);
    return current2;
  }
  function updateSuspenseComponent(current2, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, showFallback = false, didSuspend = 0 !== (workInProgress2.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current2 && null === current2.memoizedState ? false : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = true, workInProgress2.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress2.flags & 32);
    workInProgress2.flags &= -33;
    if (null === current2) {
      if (isHydrating) {
        showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress2) : reuseSuspenseHandlerOnStack();
        (current2 = nextHydratableInstance) ? (current2 = canHydrateHydrationBoundary(
          current2,
          rootOrSingletonContext
        ), current2 = null !== current2 && "&" !== current2.data ? current2 : null, null !== current2 && (workInProgress2.memoizedState = {
          dehydrated: current2,
          treeContext: null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, renderLanes2 = createFiberFromDehydratedFragment(current2), renderLanes2.return = workInProgress2, workInProgress2.child = renderLanes2, hydrationParentFiber = workInProgress2, nextHydratableInstance = null)) : current2 = null;
        if (null === current2) throw throwOnHydrationMismatch(workInProgress2);
        isSuspenseInstanceFallback(current2) ? workInProgress2.lanes = 32 : workInProgress2.lanes = 536870912;
        return null;
      }
      var nextPrimaryChildren = nextProps.children;
      nextProps = nextProps.fallback;
      if (showFallback)
        return reuseSuspenseHandlerOnStack(), showFallback = workInProgress2.mode, nextPrimaryChildren = mountWorkInProgressOffscreenFiber(
          { mode: "hidden", children: nextPrimaryChildren },
          showFallback
        ), nextProps = createFiberFromFragment(
          nextProps,
          showFallback,
          renderLanes2,
          null
        ), nextPrimaryChildren.return = workInProgress2, nextProps.return = workInProgress2, nextPrimaryChildren.sibling = nextProps, workInProgress2.child = nextPrimaryChildren, nextProps = workInProgress2.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes2), nextProps.childLanes = getRemainingWorkInPrimaryTree(
          current2,
          JSCompiler_temp,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
      pushPrimaryTreeSuspenseHandler(workInProgress2);
      return mountSuspensePrimaryChildren(workInProgress2, nextPrimaryChildren);
    }
    var prevState = current2.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
      if (didSuspend)
        workInProgress2.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags &= -257, workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current2,
          workInProgress2,
          renderLanes2
        )) : null !== workInProgress2.memoizedState ? (reuseSuspenseHandlerOnStack(), workInProgress2.child = current2.child, workInProgress2.flags |= 128, workInProgress2 = null) : (reuseSuspenseHandlerOnStack(), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress2.mode, nextProps = mountWorkInProgressOffscreenFiber(
          { mode: "visible", children: nextProps.children },
          showFallback
        ), nextPrimaryChildren = createFiberFromFragment(
          nextPrimaryChildren,
          showFallback,
          renderLanes2,
          null
        ), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress2, nextPrimaryChildren.return = workInProgress2, nextProps.sibling = nextPrimaryChildren, workInProgress2.child = nextProps, reconcileChildFibers(
          workInProgress2,
          current2.child,
          null,
          renderLanes2
        ), nextProps = workInProgress2.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes2), nextProps.childLanes = getRemainingWorkInPrimaryTree(
          current2,
          JSCompiler_temp,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, workInProgress2 = bailoutOffscreenComponent(null, nextProps));
      else if (pushPrimaryTreeSuspenseHandler(workInProgress2), isSuspenseInstanceFallback(nextPrimaryChildren)) {
        JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
        if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
        JSCompiler_temp = digest;
        nextProps = Error(formatProdErrorMessage2(419));
        nextProps.stack = "";
        nextProps.digest = JSCompiler_temp;
        queueHydrationError({ value: nextProps, source: null, stack: null });
        workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current2,
          workInProgress2,
          renderLanes2
        );
      } else if (didReceiveUpdate || propagateParentContextChanges(current2, workInProgress2, renderLanes2, false), JSCompiler_temp = 0 !== (renderLanes2 & current2.childLanes), didReceiveUpdate || JSCompiler_temp) {
        JSCompiler_temp = workInProgressRoot;
        if (null !== JSCompiler_temp && (nextProps = getBumpedLaneForHydration(JSCompiler_temp, renderLanes2), 0 !== nextProps && nextProps !== prevState.retryLane))
          throw prevState.retryLane = nextProps, enqueueConcurrentRenderForLane(current2, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current2, nextProps), SelectiveHydrationException;
        isSuspenseInstancePending(nextPrimaryChildren) || renderDidSuspendDelayIfPossible();
        workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current2,
          workInProgress2,
          renderLanes2
        );
      } else
        isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress2.flags |= 192, workInProgress2.child = current2.child, workInProgress2 = null) : (current2 = prevState.treeContext, nextHydratableInstance = getNextHydratable(
          nextPrimaryChildren.nextSibling
        ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, rootOrSingletonContext = false, null !== current2 && restoreSuspendedTreeContext(workInProgress2, current2), workInProgress2 = mountSuspensePrimaryChildren(
          workInProgress2,
          nextProps.children
        ), workInProgress2.flags |= 4096);
      return workInProgress2;
    }
    if (showFallback)
      return reuseSuspenseHandlerOnStack(), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress2.mode, prevState = current2.child, digest = prevState.sibling, nextProps = createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
      }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = createWorkInProgress(
        digest,
        nextPrimaryChildren
      ) : (nextPrimaryChildren = createFiberFromFragment(
        nextPrimaryChildren,
        showFallback,
        renderLanes2,
        null
      ), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress2, nextProps.return = workInProgress2, nextProps.sibling = nextPrimaryChildren, workInProgress2.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress2.child, nextPrimaryChildren = current2.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes2) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? { parent: prevState, pool: prevState } : showFallback) : showFallback = getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes2,
        cachePool: showFallback
      }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = getRemainingWorkInPrimaryTree(
        current2,
        JSCompiler_temp,
        renderLanes2
      ), workInProgress2.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current2.child, nextProps);
    pushPrimaryTreeSuspenseHandler(workInProgress2);
    renderLanes2 = current2.child;
    current2 = renderLanes2.sibling;
    renderLanes2 = createWorkInProgress(renderLanes2, {
      mode: "visible",
      children: nextProps.children
    });
    renderLanes2.return = workInProgress2;
    renderLanes2.sibling = null;
    null !== current2 && (JSCompiler_temp = workInProgress2.deletions, null === JSCompiler_temp ? (workInProgress2.deletions = [current2], workInProgress2.flags |= 16) : JSCompiler_temp.push(current2));
    workInProgress2.child = renderLanes2;
    workInProgress2.memoizedState = null;
    return renderLanes2;
  }
  function mountSuspensePrimaryChildren(workInProgress2, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber(
      { mode: "visible", children: primaryChildren },
      workInProgress2.mode
    );
    primaryChildren.return = workInProgress2;
    return workInProgress2.child = primaryChildren;
  }
  function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
  }
  function retrySuspenseComponentWithoutHydrating(current2, workInProgress2, renderLanes2) {
    reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
    current2 = mountSuspensePrimaryChildren(
      workInProgress2,
      workInProgress2.pendingProps.children
    );
    current2.flags |= 2;
    workInProgress2.memoizedState = null;
    return current2;
  }
  function scheduleSuspenseWorkOnFiber(fiber, renderLanes2, propagationRoot) {
    fiber.lanes |= renderLanes2;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes2);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes2, propagationRoot);
  }
  function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode, treeForkCount2) {
    var renderState = workInProgress2.memoizedState;
    null === renderState ? workInProgress2.memoizedState = {
      isBackwards,
      rendering: null,
      renderingStartTime: 0,
      last: lastContentRow,
      tail,
      tailMode,
      treeForkCount: treeForkCount2
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount2);
  }
  function updateSuspenseListComponent(current2, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress2.flags |= 128) : suspenseContext &= 1;
    push2(suspenseStackCursor, suspenseContext);
    reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
    nextProps = isHydrating ? treeForkCount : 0;
    if (!shouldForceFallback && null !== current2 && 0 !== (current2.flags & 128))
      a: for (current2 = workInProgress2.child; null !== current2; ) {
        if (13 === current2.tag)
          null !== current2.memoizedState && scheduleSuspenseWorkOnFiber(current2, renderLanes2, workInProgress2);
        else if (19 === current2.tag)
          scheduleSuspenseWorkOnFiber(current2, renderLanes2, workInProgress2);
        else if (null !== current2.child) {
          current2.child.return = current2;
          current2 = current2.child;
          continue;
        }
        if (current2 === workInProgress2) break a;
        for (; null === current2.sibling; ) {
          if (null === current2.return || current2.return === workInProgress2)
            break a;
          current2 = current2.return;
        }
        current2.sibling.return = current2.return;
        current2 = current2.sibling;
      }
    switch (revealOrder) {
      case "forwards":
        renderLanes2 = workInProgress2.child;
        for (revealOrder = null; null !== renderLanes2; )
          current2 = renderLanes2.alternate, null !== current2 && null === findFirstSuspended(current2) && (revealOrder = renderLanes2), renderLanes2 = renderLanes2.sibling;
        renderLanes2 = revealOrder;
        null === renderLanes2 ? (revealOrder = workInProgress2.child, workInProgress2.child = null) : (revealOrder = renderLanes2.sibling, renderLanes2.sibling = null);
        initSuspenseListRenderState(
          workInProgress2,
          false,
          revealOrder,
          renderLanes2,
          tailMode,
          nextProps
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        renderLanes2 = null;
        revealOrder = workInProgress2.child;
        for (workInProgress2.child = null; null !== revealOrder; ) {
          current2 = revealOrder.alternate;
          if (null !== current2 && null === findFirstSuspended(current2)) {
            workInProgress2.child = revealOrder;
            break;
          }
          current2 = revealOrder.sibling;
          revealOrder.sibling = renderLanes2;
          renderLanes2 = revealOrder;
          revealOrder = current2;
        }
        initSuspenseListRenderState(
          workInProgress2,
          true,
          renderLanes2,
          null,
          tailMode,
          nextProps
        );
        break;
      case "together":
        initSuspenseListRenderState(
          workInProgress2,
          false,
          null,
          null,
          void 0,
          nextProps
        );
        break;
      default:
        workInProgress2.memoizedState = null;
    }
    return workInProgress2.child;
  }
  function bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2) {
    null !== current2 && (workInProgress2.dependencies = current2.dependencies);
    workInProgressRootSkippedLanes |= workInProgress2.lanes;
    if (0 === (renderLanes2 & workInProgress2.childLanes))
      if (null !== current2) {
        if (propagateParentContextChanges(
          current2,
          workInProgress2,
          renderLanes2,
          false
        ), 0 === (renderLanes2 & workInProgress2.childLanes))
          return null;
      } else return null;
    if (null !== current2 && workInProgress2.child !== current2.child)
      throw Error(formatProdErrorMessage2(153));
    if (null !== workInProgress2.child) {
      current2 = workInProgress2.child;
      renderLanes2 = createWorkInProgress(current2, current2.pendingProps);
      workInProgress2.child = renderLanes2;
      for (renderLanes2.return = workInProgress2; null !== current2.sibling; )
        current2 = current2.sibling, renderLanes2 = renderLanes2.sibling = createWorkInProgress(current2, current2.pendingProps), renderLanes2.return = workInProgress2;
      renderLanes2.sibling = null;
    }
    return workInProgress2.child;
  }
  function checkScheduledUpdateOrContext(current2, renderLanes2) {
    if (0 !== (current2.lanes & renderLanes2)) return true;
    current2 = current2.dependencies;
    return null !== current2 && checkIfContextChanged(current2) ? true : false;
  }
  function attemptEarlyBailoutIfNoScheduledUpdate(current2, workInProgress2, renderLanes2) {
    switch (workInProgress2.tag) {
      case 3:
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        pushProvider(workInProgress2, CacheContext, current2.memoizedState.cache);
        resetHydrationState();
        break;
      case 27:
      case 5:
        pushHostContext(workInProgress2);
        break;
      case 4:
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        break;
      case 10:
        pushProvider(
          workInProgress2,
          workInProgress2.type,
          workInProgress2.memoizedProps.value
        );
        break;
      case 31:
        if (null !== workInProgress2.memoizedState)
          return workInProgress2.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress2), null;
        break;
      case 13:
        var state$102 = workInProgress2.memoizedState;
        if (null !== state$102) {
          if (null !== state$102.dehydrated)
            return pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags |= 128, null;
          if (0 !== (renderLanes2 & workInProgress2.child.childLanes))
            return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
          pushPrimaryTreeSuspenseHandler(workInProgress2);
          current2 = bailoutOnAlreadyFinishedWork(
            current2,
            workInProgress2,
            renderLanes2
          );
          return null !== current2 ? current2.sibling : null;
        }
        pushPrimaryTreeSuspenseHandler(workInProgress2);
        break;
      case 19:
        var didSuspendBefore = 0 !== (current2.flags & 128);
        state$102 = 0 !== (renderLanes2 & workInProgress2.childLanes);
        state$102 || (propagateParentContextChanges(
          current2,
          workInProgress2,
          renderLanes2,
          false
        ), state$102 = 0 !== (renderLanes2 & workInProgress2.childLanes));
        if (didSuspendBefore) {
          if (state$102)
            return updateSuspenseListComponent(
              current2,
              workInProgress2,
              renderLanes2
            );
          workInProgress2.flags |= 128;
        }
        didSuspendBefore = workInProgress2.memoizedState;
        null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
        push2(suspenseStackCursor, suspenseStackCursor.current);
        if (state$102) break;
        else return null;
      case 22:
        return workInProgress2.lanes = 0, updateOffscreenComponent(
          current2,
          workInProgress2,
          renderLanes2,
          workInProgress2.pendingProps
        );
      case 24:
        pushProvider(workInProgress2, CacheContext, current2.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
  }
  function beginWork(current2, workInProgress2, renderLanes2) {
    if (null !== current2)
      if (current2.memoizedProps !== workInProgress2.pendingProps)
        didReceiveUpdate = true;
      else {
        if (!checkScheduledUpdateOrContext(current2, renderLanes2) && 0 === (workInProgress2.flags & 128))
          return didReceiveUpdate = false, attemptEarlyBailoutIfNoScheduledUpdate(
            current2,
            workInProgress2,
            renderLanes2
          );
        didReceiveUpdate = 0 !== (current2.flags & 131072) ? true : false;
      }
    else
      didReceiveUpdate = false, isHydrating && 0 !== (workInProgress2.flags & 1048576) && pushTreeId(workInProgress2, treeForkCount, workInProgress2.index);
    workInProgress2.lanes = 0;
    switch (workInProgress2.tag) {
      case 16:
        a: {
          var props2 = workInProgress2.pendingProps;
          current2 = resolveLazy(workInProgress2.elementType);
          workInProgress2.type = current2;
          if ("function" === typeof current2)
            shouldConstruct(current2) ? (props2 = resolveClassComponentProps(current2, props2), workInProgress2.tag = 1, workInProgress2 = updateClassComponent(
              null,
              workInProgress2,
              current2,
              props2,
              renderLanes2
            )) : (workInProgress2.tag = 0, workInProgress2 = updateFunctionComponent(
              null,
              workInProgress2,
              current2,
              props2,
              renderLanes2
            ));
          else {
            if (void 0 !== current2 && null !== current2) {
              var $$typeof = current2.$$typeof;
              if ($$typeof === REACT_FORWARD_REF_TYPE) {
                workInProgress2.tag = 11;
                workInProgress2 = updateForwardRef(
                  null,
                  workInProgress2,
                  current2,
                  props2,
                  renderLanes2
                );
                break a;
              } else if ($$typeof === REACT_MEMO_TYPE) {
                workInProgress2.tag = 14;
                workInProgress2 = updateMemoComponent(
                  null,
                  workInProgress2,
                  current2,
                  props2,
                  renderLanes2
                );
                break a;
              }
            }
            workInProgress2 = getComponentNameFromType(current2) || current2;
            throw Error(formatProdErrorMessage2(306, workInProgress2, ""));
          }
        }
        return workInProgress2;
      case 0:
        return updateFunctionComponent(
          current2,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 1:
        return props2 = workInProgress2.type, $$typeof = resolveClassComponentProps(
          props2,
          workInProgress2.pendingProps
        ), updateClassComponent(
          current2,
          workInProgress2,
          props2,
          $$typeof,
          renderLanes2
        );
      case 3:
        a: {
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          if (null === current2) throw Error(formatProdErrorMessage2(387));
          props2 = workInProgress2.pendingProps;
          var prevState = workInProgress2.memoizedState;
          $$typeof = prevState.element;
          cloneUpdateQueue(current2, workInProgress2);
          processUpdateQueue(workInProgress2, props2, null, renderLanes2);
          var nextState = workInProgress2.memoizedState;
          props2 = nextState.cache;
          pushProvider(workInProgress2, CacheContext, props2);
          props2 !== prevState.cache && propagateContextChanges(
            workInProgress2,
            [CacheContext],
            renderLanes2,
            true
          );
          suspendIfUpdateReadFromEntangledAsyncAction();
          props2 = nextState.element;
          if (prevState.isDehydrated)
            if (prevState = {
              element: props2,
              isDehydrated: false,
              cache: nextState.cache
            }, workInProgress2.updateQueue.baseState = prevState, workInProgress2.memoizedState = prevState, workInProgress2.flags & 256) {
              workInProgress2 = mountHostRootWithoutHydrating(
                current2,
                workInProgress2,
                props2,
                renderLanes2
              );
              break a;
            } else if (props2 !== $$typeof) {
              $$typeof = createCapturedValueAtFiber(
                Error(formatProdErrorMessage2(424)),
                workInProgress2
              );
              queueHydrationError($$typeof);
              workInProgress2 = mountHostRootWithoutHydrating(
                current2,
                workInProgress2,
                props2,
                renderLanes2
              );
              break a;
            } else {
              current2 = workInProgress2.stateNode.containerInfo;
              switch (current2.nodeType) {
                case 9:
                  current2 = current2.body;
                  break;
                default:
                  current2 = "HTML" === current2.nodeName ? current2.ownerDocument.body : current2;
              }
              nextHydratableInstance = getNextHydratable(current2.firstChild);
              hydrationParentFiber = workInProgress2;
              isHydrating = true;
              hydrationErrors = null;
              rootOrSingletonContext = true;
              renderLanes2 = mountChildFibers(
                workInProgress2,
                null,
                props2,
                renderLanes2
              );
              for (workInProgress2.child = renderLanes2; renderLanes2; )
                renderLanes2.flags = renderLanes2.flags & -3 | 4096, renderLanes2 = renderLanes2.sibling;
            }
          else {
            resetHydrationState();
            if (props2 === $$typeof) {
              workInProgress2 = bailoutOnAlreadyFinishedWork(
                current2,
                workInProgress2,
                renderLanes2
              );
              break a;
            }
            reconcileChildren(current2, workInProgress2, props2, renderLanes2);
          }
          workInProgress2 = workInProgress2.child;
        }
        return workInProgress2;
      case 26:
        return markRef(current2, workInProgress2), null === current2 ? (renderLanes2 = getResource(
          workInProgress2.type,
          null,
          workInProgress2.pendingProps,
          null
        )) ? workInProgress2.memoizedState = renderLanes2 : isHydrating || (renderLanes2 = workInProgress2.type, current2 = workInProgress2.pendingProps, props2 = getOwnerDocumentFromRootContainer(
          rootInstanceStackCursor.current
        ).createElement(renderLanes2), props2[internalInstanceKey] = workInProgress2, props2[internalPropsKey] = current2, setInitialProperties(props2, renderLanes2, current2), markNodeAsHoistable(props2), workInProgress2.stateNode = props2) : workInProgress2.memoizedState = getResource(
          workInProgress2.type,
          current2.memoizedProps,
          workInProgress2.pendingProps,
          current2.memoizedState
        ), null;
      case 27:
        return pushHostContext(workInProgress2), null === current2 && isHydrating && (props2 = workInProgress2.stateNode = resolveSingletonInstance(
          workInProgress2.type,
          workInProgress2.pendingProps,
          rootInstanceStackCursor.current
        ), hydrationParentFiber = workInProgress2, rootOrSingletonContext = true, $$typeof = nextHydratableInstance, isSingletonScope(workInProgress2.type) ? (previousHydratableOnEnteringScopedSingleton = $$typeof, nextHydratableInstance = getNextHydratable(props2.firstChild)) : nextHydratableInstance = $$typeof), reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), markRef(current2, workInProgress2), null === current2 && (workInProgress2.flags |= 4194304), workInProgress2.child;
      case 5:
        if (null === current2 && isHydrating) {
          if ($$typeof = props2 = nextHydratableInstance)
            props2 = canHydrateInstance(
              props2,
              workInProgress2.type,
              workInProgress2.pendingProps,
              rootOrSingletonContext
            ), null !== props2 ? (workInProgress2.stateNode = props2, hydrationParentFiber = workInProgress2, nextHydratableInstance = getNextHydratable(props2.firstChild), rootOrSingletonContext = false, $$typeof = true) : $$typeof = false;
          $$typeof || throwOnHydrationMismatch(workInProgress2);
        }
        pushHostContext(workInProgress2);
        $$typeof = workInProgress2.type;
        prevState = workInProgress2.pendingProps;
        nextState = null !== current2 ? current2.memoizedProps : null;
        props2 = prevState.children;
        shouldSetTextContent($$typeof, prevState) ? props2 = null : null !== nextState && shouldSetTextContent($$typeof, nextState) && (workInProgress2.flags |= 32);
        null !== workInProgress2.memoizedState && ($$typeof = renderWithHooks(
          current2,
          workInProgress2,
          TransitionAwareHostComponent,
          null,
          null,
          renderLanes2
        ), HostTransitionContext._currentValue = $$typeof);
        markRef(current2, workInProgress2);
        reconcileChildren(current2, workInProgress2, props2, renderLanes2);
        return workInProgress2.child;
      case 6:
        if (null === current2 && isHydrating) {
          if (current2 = renderLanes2 = nextHydratableInstance)
            renderLanes2 = canHydrateTextInstance(
              renderLanes2,
              workInProgress2.pendingProps,
              rootOrSingletonContext
            ), null !== renderLanes2 ? (workInProgress2.stateNode = renderLanes2, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, current2 = true) : current2 = false;
          current2 || throwOnHydrationMismatch(workInProgress2);
        }
        return null;
      case 13:
        return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
      case 4:
        return pushHostContainer(
          workInProgress2,
          workInProgress2.stateNode.containerInfo
        ), props2 = workInProgress2.pendingProps, null === current2 ? workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          null,
          props2,
          renderLanes2
        ) : reconcileChildren(current2, workInProgress2, props2, renderLanes2), workInProgress2.child;
      case 11:
        return updateForwardRef(
          current2,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 7:
        return reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps,
          renderLanes2
        ), workInProgress2.child;
      case 8:
        return reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 12:
        return reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 10:
        return props2 = workInProgress2.pendingProps, pushProvider(workInProgress2, workInProgress2.type, props2.value), reconcileChildren(current2, workInProgress2, props2.children, renderLanes2), workInProgress2.child;
      case 9:
        return $$typeof = workInProgress2.type._context, props2 = workInProgress2.pendingProps.children, prepareToReadContext(workInProgress2), $$typeof = readContext($$typeof), props2 = props2($$typeof), workInProgress2.flags |= 1, reconcileChildren(current2, workInProgress2, props2, renderLanes2), workInProgress2.child;
      case 14:
        return updateMemoComponent(
          current2,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 15:
        return updateSimpleMemoComponent(
          current2,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 19:
        return updateSuspenseListComponent(current2, workInProgress2, renderLanes2);
      case 31:
        return updateActivityComponent(current2, workInProgress2, renderLanes2);
      case 22:
        return updateOffscreenComponent(
          current2,
          workInProgress2,
          renderLanes2,
          workInProgress2.pendingProps
        );
      case 24:
        return prepareToReadContext(workInProgress2), props2 = readContext(CacheContext), null === current2 ? ($$typeof = peekCacheFromPool(), null === $$typeof && ($$typeof = workInProgressRoot, prevState = createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes2), $$typeof = prevState), workInProgress2.memoizedState = { parent: props2, cache: $$typeof }, initializeUpdateQueue(workInProgress2), pushProvider(workInProgress2, CacheContext, $$typeof)) : (0 !== (current2.lanes & renderLanes2) && (cloneUpdateQueue(current2, workInProgress2), processUpdateQueue(workInProgress2, null, null, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current2.memoizedState, prevState = workInProgress2.memoizedState, $$typeof.parent !== props2 ? ($$typeof = { parent: props2, cache: props2 }, workInProgress2.memoizedState = $$typeof, 0 === workInProgress2.lanes && (workInProgress2.memoizedState = workInProgress2.updateQueue.baseState = $$typeof), pushProvider(workInProgress2, CacheContext, props2)) : (props2 = prevState.cache, pushProvider(workInProgress2, CacheContext, props2), props2 !== $$typeof.cache && propagateContextChanges(
          workInProgress2,
          [CacheContext],
          renderLanes2,
          true
        ))), reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 29:
        throw workInProgress2.pendingProps;
    }
    throw Error(formatProdErrorMessage2(156, workInProgress2.tag));
  }
  function markUpdate(workInProgress2) {
    workInProgress2.flags |= 4;
  }
  function preloadInstanceAndSuspendIfNeeded(workInProgress2, type, oldProps, newProps, renderLanes2) {
    if (type = 0 !== (workInProgress2.mode & 32)) type = false;
    if (type) {
      if (workInProgress2.flags |= 16777216, (renderLanes2 & 335544128) === renderLanes2)
        if (workInProgress2.stateNode.complete) workInProgress2.flags |= 8192;
        else if (shouldRemainOnPreviousScreen()) workInProgress2.flags |= 8192;
        else
          throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    } else workInProgress2.flags &= -16777217;
  }
  function preloadResourceAndSuspendIfNeeded(workInProgress2, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4))
      workInProgress2.flags &= -16777217;
    else if (workInProgress2.flags |= 16777216, !preloadResource(resource))
      if (shouldRemainOnPreviousScreen()) workInProgress2.flags |= 8192;
      else
        throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
  }
  function scheduleRetryEffect(workInProgress2, retryQueue) {
    null !== retryQueue && (workInProgress2.flags |= 4);
    workInProgress2.flags & 16384 && (retryQueue = 22 !== workInProgress2.tag ? claimNextRetryLane() : 536870912, workInProgress2.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
  }
  function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating)
      switch (renderState.tailMode) {
        case "hidden":
          hasRenderedATailFallback = renderState.tail;
          for (var lastTailNode = null; null !== hasRenderedATailFallback; )
            null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
          null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
          break;
        case "collapsed":
          lastTailNode = renderState.tail;
          for (var lastTailNode$106 = null; null !== lastTailNode; )
            null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
          null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
      }
  }
  function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout)
      for (var child$107 = completedWork.child; null !== child$107; )
        newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else
      for (child$107 = completedWork.child; null !== child$107; )
        newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
  }
  function completeWork(current2, workInProgress2, renderLanes2) {
    var newProps = workInProgress2.pendingProps;
    popTreeContext(workInProgress2);
    switch (workInProgress2.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return bubbleProperties(workInProgress2), null;
      case 1:
        return bubbleProperties(workInProgress2), null;
      case 3:
        renderLanes2 = workInProgress2.stateNode;
        newProps = null;
        null !== current2 && (newProps = current2.memoizedState.cache);
        workInProgress2.memoizedState.cache !== newProps && (workInProgress2.flags |= 2048);
        popProvider(CacheContext);
        popHostContainer();
        renderLanes2.pendingContext && (renderLanes2.context = renderLanes2.pendingContext, renderLanes2.pendingContext = null);
        if (null === current2 || null === current2.child)
          popHydrationState(workInProgress2) ? markUpdate(workInProgress2) : null === current2 || current2.memoizedState.isDehydrated && 0 === (workInProgress2.flags & 256) || (workInProgress2.flags |= 1024, upgradeHydrationErrorsToRecoverable());
        bubbleProperties(workInProgress2);
        return null;
      case 26:
        var type = workInProgress2.type, nextResource = workInProgress2.memoizedState;
        null === current2 ? (markUpdate(workInProgress2), null !== nextResource ? (bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(workInProgress2, nextResource)) : (bubbleProperties(workInProgress2), preloadInstanceAndSuspendIfNeeded(
          workInProgress2,
          type,
          null,
          newProps,
          renderLanes2
        ))) : nextResource ? nextResource !== current2.memoizedState ? (markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(workInProgress2, nextResource)) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217) : (current2 = current2.memoizedProps, current2 !== newProps && markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadInstanceAndSuspendIfNeeded(
          workInProgress2,
          type,
          current2,
          newProps,
          renderLanes2
        ));
        return null;
      case 27:
        popHostContext(workInProgress2);
        renderLanes2 = rootInstanceStackCursor.current;
        type = workInProgress2.type;
        if (null !== current2 && null != workInProgress2.stateNode)
          current2.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if (!newProps) {
            if (null === workInProgress2.stateNode)
              throw Error(formatProdErrorMessage2(166));
            bubbleProperties(workInProgress2);
            return null;
          }
          current2 = contextStackCursor.current;
          popHydrationState(workInProgress2) ? prepareToHydrateHostInstance(workInProgress2) : (current2 = resolveSingletonInstance(type, newProps, renderLanes2), workInProgress2.stateNode = current2, markUpdate(workInProgress2));
        }
        bubbleProperties(workInProgress2);
        return null;
      case 5:
        popHostContext(workInProgress2);
        type = workInProgress2.type;
        if (null !== current2 && null != workInProgress2.stateNode)
          current2.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if (!newProps) {
            if (null === workInProgress2.stateNode)
              throw Error(formatProdErrorMessage2(166));
            bubbleProperties(workInProgress2);
            return null;
          }
          nextResource = contextStackCursor.current;
          if (popHydrationState(workInProgress2))
            prepareToHydrateHostInstance(workInProgress2);
          else {
            var ownerDocument = getOwnerDocumentFromRootContainer(
              rootInstanceStackCursor.current
            );
            switch (nextResource) {
              case 1:
                nextResource = ownerDocument.createElementNS(
                  "http://www.w3.org/2000/svg",
                  type
                );
                break;
              case 2:
                nextResource = ownerDocument.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  type
                );
                break;
              default:
                switch (type) {
                  case "svg":
                    nextResource = ownerDocument.createElementNS(
                      "http://www.w3.org/2000/svg",
                      type
                    );
                    break;
                  case "math":
                    nextResource = ownerDocument.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      type
                    );
                    break;
                  case "script":
                    nextResource = ownerDocument.createElement("div");
                    nextResource.innerHTML = "<script><\/script>";
                    nextResource = nextResource.removeChild(
                      nextResource.firstChild
                    );
                    break;
                  case "select":
                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                      is: newProps.is
                    }) : ownerDocument.createElement("select");
                    newProps.multiple ? nextResource.multiple = true : newProps.size && (nextResource.size = newProps.size);
                    break;
                  default:
                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, { is: newProps.is }) : ownerDocument.createElement(type);
                }
            }
            nextResource[internalInstanceKey] = workInProgress2;
            nextResource[internalPropsKey] = newProps;
            a: for (ownerDocument = workInProgress2.child; null !== ownerDocument; ) {
              if (5 === ownerDocument.tag || 6 === ownerDocument.tag)
                nextResource.appendChild(ownerDocument.stateNode);
              else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                ownerDocument.child.return = ownerDocument;
                ownerDocument = ownerDocument.child;
                continue;
              }
              if (ownerDocument === workInProgress2) break a;
              for (; null === ownerDocument.sibling; ) {
                if (null === ownerDocument.return || ownerDocument.return === workInProgress2)
                  break a;
                ownerDocument = ownerDocument.return;
              }
              ownerDocument.sibling.return = ownerDocument.return;
              ownerDocument = ownerDocument.sibling;
            }
            workInProgress2.stateNode = nextResource;
            a: switch (setInitialProperties(nextResource, type, newProps), type) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                newProps = !!newProps.autoFocus;
                break a;
              case "img":
                newProps = true;
                break a;
              default:
                newProps = false;
            }
            newProps && markUpdate(workInProgress2);
          }
        }
        bubbleProperties(workInProgress2);
        preloadInstanceAndSuspendIfNeeded(
          workInProgress2,
          workInProgress2.type,
          null === current2 ? null : current2.memoizedProps,
          workInProgress2.pendingProps,
          renderLanes2
        );
        return null;
      case 6:
        if (current2 && null != workInProgress2.stateNode)
          current2.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if ("string" !== typeof newProps && null === workInProgress2.stateNode)
            throw Error(formatProdErrorMessage2(166));
          current2 = rootInstanceStackCursor.current;
          if (popHydrationState(workInProgress2)) {
            current2 = workInProgress2.stateNode;
            renderLanes2 = workInProgress2.memoizedProps;
            newProps = null;
            type = hydrationParentFiber;
            if (null !== type)
              switch (type.tag) {
                case 27:
                case 5:
                  newProps = type.memoizedProps;
              }
            current2[internalInstanceKey] = workInProgress2;
            current2 = current2.nodeValue === renderLanes2 || null !== newProps && true === newProps.suppressHydrationWarning || checkForUnmatchedText(current2.nodeValue, renderLanes2) ? true : false;
            current2 || throwOnHydrationMismatch(workInProgress2, true);
          } else
            current2 = getOwnerDocumentFromRootContainer(current2).createTextNode(
              newProps
            ), current2[internalInstanceKey] = workInProgress2, workInProgress2.stateNode = current2;
        }
        bubbleProperties(workInProgress2);
        return null;
      case 31:
        renderLanes2 = workInProgress2.memoizedState;
        if (null === current2 || null !== current2.memoizedState) {
          newProps = popHydrationState(workInProgress2);
          if (null !== renderLanes2) {
            if (null === current2) {
              if (!newProps) throw Error(formatProdErrorMessage2(318));
              current2 = workInProgress2.memoizedState;
              current2 = null !== current2 ? current2.dehydrated : null;
              if (!current2) throw Error(formatProdErrorMessage2(557));
              current2[internalInstanceKey] = workInProgress2;
            } else
              resetHydrationState(), 0 === (workInProgress2.flags & 128) && (workInProgress2.memoizedState = null), workInProgress2.flags |= 4;
            bubbleProperties(workInProgress2);
            current2 = false;
          } else
            renderLanes2 = upgradeHydrationErrorsToRecoverable(), null !== current2 && null !== current2.memoizedState && (current2.memoizedState.hydrationErrors = renderLanes2), current2 = true;
          if (!current2) {
            if (workInProgress2.flags & 256)
              return popSuspenseHandler(workInProgress2), workInProgress2;
            popSuspenseHandler(workInProgress2);
            return null;
          }
          if (0 !== (workInProgress2.flags & 128))
            throw Error(formatProdErrorMessage2(558));
        }
        bubbleProperties(workInProgress2);
        return null;
      case 13:
        newProps = workInProgress2.memoizedState;
        if (null === current2 || null !== current2.memoizedState && null !== current2.memoizedState.dehydrated) {
          type = popHydrationState(workInProgress2);
          if (null !== newProps && null !== newProps.dehydrated) {
            if (null === current2) {
              if (!type) throw Error(formatProdErrorMessage2(318));
              type = workInProgress2.memoizedState;
              type = null !== type ? type.dehydrated : null;
              if (!type) throw Error(formatProdErrorMessage2(317));
              type[internalInstanceKey] = workInProgress2;
            } else
              resetHydrationState(), 0 === (workInProgress2.flags & 128) && (workInProgress2.memoizedState = null), workInProgress2.flags |= 4;
            bubbleProperties(workInProgress2);
            type = false;
          } else
            type = upgradeHydrationErrorsToRecoverable(), null !== current2 && null !== current2.memoizedState && (current2.memoizedState.hydrationErrors = type), type = true;
          if (!type) {
            if (workInProgress2.flags & 256)
              return popSuspenseHandler(workInProgress2), workInProgress2;
            popSuspenseHandler(workInProgress2);
            return null;
          }
        }
        popSuspenseHandler(workInProgress2);
        if (0 !== (workInProgress2.flags & 128))
          return workInProgress2.lanes = renderLanes2, workInProgress2;
        renderLanes2 = null !== newProps;
        current2 = null !== current2 && null !== current2.memoizedState;
        renderLanes2 && (newProps = workInProgress2.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
        renderLanes2 !== current2 && renderLanes2 && (workInProgress2.child.flags |= 8192);
        scheduleRetryEffect(workInProgress2, workInProgress2.updateQueue);
        bubbleProperties(workInProgress2);
        return null;
      case 4:
        return popHostContainer(), null === current2 && listenToAllSupportedEvents(workInProgress2.stateNode.containerInfo), bubbleProperties(workInProgress2), null;
      case 10:
        return popProvider(workInProgress2.type), bubbleProperties(workInProgress2), null;
      case 19:
        pop(suspenseStackCursor);
        newProps = workInProgress2.memoizedState;
        if (null === newProps) return bubbleProperties(workInProgress2), null;
        type = 0 !== (workInProgress2.flags & 128);
        nextResource = newProps.rendering;
        if (null === nextResource)
          if (type) cutOffTailIfNeeded(newProps, false);
          else {
            if (0 !== workInProgressRootExitStatus || null !== current2 && 0 !== (current2.flags & 128))
              for (current2 = workInProgress2.child; null !== current2; ) {
                nextResource = findFirstSuspended(current2);
                if (null !== nextResource) {
                  workInProgress2.flags |= 128;
                  cutOffTailIfNeeded(newProps, false);
                  current2 = nextResource.updateQueue;
                  workInProgress2.updateQueue = current2;
                  scheduleRetryEffect(workInProgress2, current2);
                  workInProgress2.subtreeFlags = 0;
                  current2 = renderLanes2;
                  for (renderLanes2 = workInProgress2.child; null !== renderLanes2; )
                    resetWorkInProgress(renderLanes2, current2), renderLanes2 = renderLanes2.sibling;
                  push2(
                    suspenseStackCursor,
                    suspenseStackCursor.current & 1 | 2
                  );
                  isHydrating && pushTreeFork(workInProgress2, newProps.treeForkCount);
                  return workInProgress2.child;
                }
                current2 = current2.sibling;
              }
            null !== newProps.tail && now2() > workInProgressRootRenderTargetTime && (workInProgress2.flags |= 128, type = true, cutOffTailIfNeeded(newProps, false), workInProgress2.lanes = 4194304);
          }
        else {
          if (!type)
            if (current2 = findFirstSuspended(nextResource), null !== current2) {
              if (workInProgress2.flags |= 128, type = true, current2 = current2.updateQueue, workInProgress2.updateQueue = current2, scheduleRetryEffect(workInProgress2, current2), cutOffTailIfNeeded(newProps, true), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating)
                return bubbleProperties(workInProgress2), null;
            } else
              2 * now2() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes2 && (workInProgress2.flags |= 128, type = true, cutOffTailIfNeeded(newProps, false), workInProgress2.lanes = 4194304);
          newProps.isBackwards ? (nextResource.sibling = workInProgress2.child, workInProgress2.child = nextResource) : (current2 = newProps.last, null !== current2 ? current2.sibling = nextResource : workInProgress2.child = nextResource, newProps.last = nextResource);
        }
        if (null !== newProps.tail)
          return current2 = newProps.tail, newProps.rendering = current2, newProps.tail = current2.sibling, newProps.renderingStartTime = now2(), current2.sibling = null, renderLanes2 = suspenseStackCursor.current, push2(
            suspenseStackCursor,
            type ? renderLanes2 & 1 | 2 : renderLanes2 & 1
          ), isHydrating && pushTreeFork(workInProgress2, newProps.treeForkCount), current2;
        bubbleProperties(workInProgress2);
        return null;
      case 22:
      case 23:
        return popSuspenseHandler(workInProgress2), popHiddenContext(), newProps = null !== workInProgress2.memoizedState, null !== current2 ? null !== current2.memoizedState !== newProps && (workInProgress2.flags |= 8192) : newProps && (workInProgress2.flags |= 8192), newProps ? 0 !== (renderLanes2 & 536870912) && 0 === (workInProgress2.flags & 128) && (bubbleProperties(workInProgress2), workInProgress2.subtreeFlags & 6 && (workInProgress2.flags |= 8192)) : bubbleProperties(workInProgress2), renderLanes2 = workInProgress2.updateQueue, null !== renderLanes2 && scheduleRetryEffect(workInProgress2, renderLanes2.retryQueue), renderLanes2 = null, null !== current2 && null !== current2.memoizedState && null !== current2.memoizedState.cachePool && (renderLanes2 = current2.memoizedState.cachePool.pool), newProps = null, null !== workInProgress2.memoizedState && null !== workInProgress2.memoizedState.cachePool && (newProps = workInProgress2.memoizedState.cachePool.pool), newProps !== renderLanes2 && (workInProgress2.flags |= 2048), null !== current2 && pop(resumedCache), null;
      case 24:
        return renderLanes2 = null, null !== current2 && (renderLanes2 = current2.memoizedState.cache), workInProgress2.memoizedState.cache !== renderLanes2 && (workInProgress2.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress2), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(formatProdErrorMessage2(156, workInProgress2.tag));
  }
  function unwindWork(current2, workInProgress2) {
    popTreeContext(workInProgress2);
    switch (workInProgress2.tag) {
      case 1:
        return current2 = workInProgress2.flags, current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 3:
        return popProvider(CacheContext), popHostContainer(), current2 = workInProgress2.flags, 0 !== (current2 & 65536) && 0 === (current2 & 128) ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 26:
      case 27:
      case 5:
        return popHostContext(workInProgress2), null;
      case 31:
        if (null !== workInProgress2.memoizedState) {
          popSuspenseHandler(workInProgress2);
          if (null === workInProgress2.alternate)
            throw Error(formatProdErrorMessage2(340));
          resetHydrationState();
        }
        current2 = workInProgress2.flags;
        return current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 13:
        popSuspenseHandler(workInProgress2);
        current2 = workInProgress2.memoizedState;
        if (null !== current2 && null !== current2.dehydrated) {
          if (null === workInProgress2.alternate)
            throw Error(formatProdErrorMessage2(340));
          resetHydrationState();
        }
        current2 = workInProgress2.flags;
        return current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 19:
        return pop(suspenseStackCursor), null;
      case 4:
        return popHostContainer(), null;
      case 10:
        return popProvider(workInProgress2.type), null;
      case 22:
      case 23:
        return popSuspenseHandler(workInProgress2), popHiddenContext(), null !== current2 && pop(resumedCache), current2 = workInProgress2.flags, current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 24:
        return popProvider(CacheContext), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function unwindInterruptedWork(current2, interruptedWork) {
    popTreeContext(interruptedWork);
    switch (interruptedWork.tag) {
      case 3:
        popProvider(CacheContext);
        popHostContainer();
        break;
      case 26:
      case 27:
      case 5:
        popHostContext(interruptedWork);
        break;
      case 4:
        popHostContainer();
        break;
      case 31:
        null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
        break;
      case 13:
        popSuspenseHandler(interruptedWork);
        break;
      case 19:
        pop(suspenseStackCursor);
        break;
      case 10:
        popProvider(interruptedWork.type);
        break;
      case 22:
      case 23:
        popSuspenseHandler(interruptedWork);
        popHiddenContext();
        null !== current2 && pop(resumedCache);
        break;
      case 24:
        popProvider(CacheContext);
    }
  }
  function commitHookEffectListMount(flags, finishedWork) {
    try {
      var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
      if (null !== lastEffect) {
        var firstEffect = lastEffect.next;
        updateQueue = firstEffect;
        do {
          if ((updateQueue.tag & flags) === flags) {
            lastEffect = void 0;
            var create2 = updateQueue.create, inst = updateQueue.inst;
            lastEffect = create2();
            inst.destroy = lastEffect;
          }
          updateQueue = updateQueue.next;
        } while (updateQueue !== firstEffect);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
      var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
      if (null !== lastEffect) {
        var firstEffect = lastEffect.next;
        updateQueue = firstEffect;
        do {
          if ((updateQueue.tag & flags) === flags) {
            var inst = updateQueue.inst, destroy = inst.destroy;
            if (void 0 !== destroy) {
              inst.destroy = void 0;
              lastEffect = finishedWork;
              var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
              try {
                destroy_();
              } catch (error) {
                captureCommitPhaseError(
                  lastEffect,
                  nearestMountedAncestor,
                  error
                );
              }
            }
          }
          updateQueue = updateQueue.next;
        } while (updateQueue !== firstEffect);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
      var instance = finishedWork.stateNode;
      try {
        commitCallbacks(updateQueue, instance);
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
  }
  function safelyCallComponentWillUnmount(current2, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(
      current2.type,
      current2.memoizedProps
    );
    instance.state = current2.memoizedState;
    try {
      instance.componentWillUnmount();
    } catch (error) {
      captureCommitPhaseError(current2, nearestMountedAncestor, error);
    }
  }
  function safelyAttachRef(current2, nearestMountedAncestor) {
    try {
      var ref = current2.ref;
      if (null !== ref) {
        switch (current2.tag) {
          case 26:
          case 27:
          case 5:
            var instanceToUse = current2.stateNode;
            break;
          case 30:
            instanceToUse = current2.stateNode;
            break;
          default:
            instanceToUse = current2.stateNode;
        }
        "function" === typeof ref ? current2.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
      }
    } catch (error) {
      captureCommitPhaseError(current2, nearestMountedAncestor, error);
    }
  }
  function safelyDetachRef(current2, nearestMountedAncestor) {
    var ref = current2.ref, refCleanup = current2.refCleanup;
    if (null !== ref)
      if ("function" === typeof refCleanup)
        try {
          refCleanup();
        } catch (error) {
          captureCommitPhaseError(current2, nearestMountedAncestor, error);
        } finally {
          current2.refCleanup = null, current2 = current2.alternate, null != current2 && (current2.refCleanup = null);
        }
      else if ("function" === typeof ref)
        try {
          ref(null);
        } catch (error$140) {
          captureCommitPhaseError(current2, nearestMountedAncestor, error$140);
        }
      else ref.current = null;
  }
  function commitHostMount(finishedWork) {
    var type = finishedWork.type, props2 = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
      a: switch (type) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          props2.autoFocus && instance.focus();
          break a;
        case "img":
          props2.src ? instance.src = props2.src : props2.srcSet && (instance.srcset = props2.srcSet);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
      var domElement = finishedWork.stateNode;
      updateProperties(domElement, finishedWork.type, oldProps, newProps);
      domElement[internalPropsKey] = newProps;
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
  }
  function getHostSibling(fiber) {
    a: for (; ; ) {
      for (; null === fiber.sibling; ) {
        if (null === fiber.return || isHostParent(fiber.return)) return null;
        fiber = fiber.return;
      }
      fiber.sibling.return = fiber.return;
      for (fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag; ) {
        if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
        if (fiber.flags & 2) continue a;
        if (null === fiber.child || 4 === fiber.tag) continue a;
        else fiber.child.return = fiber, fiber = fiber.child;
      }
      if (!(fiber.flags & 2)) return fiber.stateNode;
    }
  }
  function insertOrAppendPlacementNodeIntoContainer(node, before2, parent) {
    var tag2 = node.tag;
    if (5 === tag2 || 6 === tag2)
      node = node.stateNode, before2 ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before2) : (before2 = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before2.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before2.onclick || (before2.onclick = noop$12));
    else if (4 !== tag2 && (27 === tag2 && isSingletonScope(node.type) && (parent = node.stateNode, before2 = null), node = node.child, null !== node))
      for (insertOrAppendPlacementNodeIntoContainer(node, before2, parent), node = node.sibling; null !== node; )
        insertOrAppendPlacementNodeIntoContainer(node, before2, parent), node = node.sibling;
  }
  function insertOrAppendPlacementNode(node, before2, parent) {
    var tag2 = node.tag;
    if (5 === tag2 || 6 === tag2)
      node = node.stateNode, before2 ? parent.insertBefore(node, before2) : parent.appendChild(node);
    else if (4 !== tag2 && (27 === tag2 && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node))
      for (insertOrAppendPlacementNode(node, before2, parent), node = node.sibling; null !== node; )
        insertOrAppendPlacementNode(node, before2, parent), node = node.sibling;
  }
  function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props2 = finishedWork.memoizedProps;
    try {
      for (var type = finishedWork.type, attributes = singleton.attributes; attributes.length; )
        singleton.removeAttributeNode(attributes[0]);
      setInitialProperties(singleton, type, props2);
      singleton[internalInstanceKey] = finishedWork;
      singleton[internalPropsKey] = props2;
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  var offscreenSubtreeIsHidden = false, offscreenSubtreeWasHidden = false, needsFormReset = false, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
  function commitBeforeMutationEffects(root3, firstChild) {
    root3 = root3.containerInfo;
    eventsEnabled = _enabled;
    root3 = getActiveElementDeep(root3);
    if (hasSelectionCapabilities(root3)) {
      if ("selectionStart" in root3)
        var JSCompiler_temp = {
          start: root3.selectionStart,
          end: root3.selectionEnd
        };
      else
        a: {
          JSCompiler_temp = (JSCompiler_temp = root3.ownerDocument) && JSCompiler_temp.defaultView || window;
          var selection2 = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
          if (selection2 && 0 !== selection2.rangeCount) {
            JSCompiler_temp = selection2.anchorNode;
            var anchorOffset = selection2.anchorOffset, focusNode = selection2.focusNode;
            selection2 = selection2.focusOffset;
            try {
              JSCompiler_temp.nodeType, focusNode.nodeType;
            } catch (e$20) {
              JSCompiler_temp = null;
              break a;
            }
            var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root3, parentNode = null;
            b: for (; ; ) {
              for (var next; ; ) {
                node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                node !== focusNode || 0 !== selection2 && 3 !== node.nodeType || (end = length + selection2);
                3 === node.nodeType && (length += node.nodeValue.length);
                if (null === (next = node.firstChild)) break;
                parentNode = node;
                node = next;
              }
              for (; ; ) {
                if (node === root3) break b;
                parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                parentNode === focusNode && ++indexWithinFocus === selection2 && (end = length);
                if (null !== (next = node.nextSibling)) break;
                node = parentNode;
                parentNode = node.parentNode;
              }
              node = next;
            }
            JSCompiler_temp = -1 === start || -1 === end ? null : { start, end };
          } else JSCompiler_temp = null;
        }
      JSCompiler_temp = JSCompiler_temp || { start: 0, end: 0 };
    } else JSCompiler_temp = null;
    selectionInformation = { focusedElem: root3, selectionRange: JSCompiler_temp };
    _enabled = false;
    for (nextEffect = firstChild; null !== nextEffect; )
      if (firstChild = nextEffect, root3 = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root3)
        root3.return = firstChild, nextEffect = root3;
      else
        for (; null !== nextEffect; ) {
          firstChild = nextEffect;
          focusNode = firstChild.alternate;
          root3 = firstChild.flags;
          switch (firstChild.tag) {
            case 0:
              if (0 !== (root3 & 4) && (root3 = firstChild.updateQueue, root3 = null !== root3 ? root3.events : null, null !== root3))
                for (JSCompiler_temp = 0; JSCompiler_temp < root3.length; JSCompiler_temp++)
                  anchorOffset = root3[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if (0 !== (root3 & 1024) && null !== focusNode) {
                root3 = void 0;
                JSCompiler_temp = firstChild;
                anchorOffset = focusNode.memoizedProps;
                focusNode = focusNode.memoizedState;
                selection2 = JSCompiler_temp.stateNode;
                try {
                  var resolvedPrevProps = resolveClassComponentProps(
                    JSCompiler_temp.type,
                    anchorOffset
                  );
                  root3 = selection2.getSnapshotBeforeUpdate(
                    resolvedPrevProps,
                    focusNode
                  );
                  selection2.__reactInternalSnapshotBeforeUpdate = root3;
                } catch (error) {
                  captureCommitPhaseError(
                    JSCompiler_temp,
                    JSCompiler_temp.return,
                    error
                  );
                }
              }
              break;
            case 3:
              if (0 !== (root3 & 1024)) {
                if (root3 = firstChild.stateNode.containerInfo, JSCompiler_temp = root3.nodeType, 9 === JSCompiler_temp)
                  clearContainerSparingly(root3);
                else if (1 === JSCompiler_temp)
                  switch (root3.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      clearContainerSparingly(root3);
                      break;
                    default:
                      root3.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if (0 !== (root3 & 1024)) throw Error(formatProdErrorMessage2(163));
          }
          root3 = firstChild.sibling;
          if (null !== root3) {
            root3.return = firstChild.return;
            nextEffect = root3;
            break;
          }
          nextEffect = firstChild.return;
        }
  }
  function commitLayoutEffectOnFiber(finishedRoot, current2, finishedWork) {
    var flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags & 4 && commitHookEffectListMount(5, finishedWork);
        break;
      case 1:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        if (flags & 4)
          if (finishedRoot = finishedWork.stateNode, null === current2)
            try {
              finishedRoot.componentDidMount();
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          else {
            var prevProps = resolveClassComponentProps(
              finishedWork.type,
              current2.memoizedProps
            );
            current2 = current2.memoizedState;
            try {
              finishedRoot.componentDidUpdate(
                prevProps,
                current2,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              );
            } catch (error$139) {
              captureCommitPhaseError(
                finishedWork,
                finishedWork.return,
                error$139
              );
            }
          }
        flags & 64 && commitClassCallbacks(finishedWork);
        flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 3:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
          current2 = null;
          if (null !== finishedWork.child)
            switch (finishedWork.child.tag) {
              case 27:
              case 5:
                current2 = finishedWork.child.stateNode;
                break;
              case 1:
                current2 = finishedWork.child.stateNode;
            }
          try {
            commitCallbacks(finishedRoot, current2);
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        break;
      case 27:
        null === current2 && flags & 4 && commitHostSingletonAcquisition(finishedWork);
      case 26:
      case 5:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        null === current2 && flags & 4 && commitHostMount(finishedWork);
        flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 12:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        break;
      case 31:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
        break;
      case 13:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
        flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(
          null,
          finishedWork
        ), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
        break;
      case 22:
        flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
        if (!flags) {
          current2 = null !== current2 && null !== current2.memoizedState || offscreenSubtreeWasHidden;
          prevProps = offscreenSubtreeIsHidden;
          var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = flags;
          (offscreenSubtreeWasHidden = current2) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            0 !== (finishedWork.subtreeFlags & 8772)
          ) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          offscreenSubtreeIsHidden = prevProps;
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
        }
        break;
      case 30:
        break;
      default:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
  }
  function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
  }
  var hostParent = null, hostParentIsContainer = false;
  function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for (parent = parent.child; null !== parent; )
      commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
  }
  function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
      try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
      } catch (err) {
      }
    switch (deletedFiber.tag) {
      case 26:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
        break;
      case 27:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
        isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = false);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        releaseSingletonInstance(deletedFiber.stateNode);
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        break;
      case 5:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
      case 6:
        prevHostParent = hostParent;
        prevHostParentIsContainer = hostParentIsContainer;
        hostParent = null;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        if (null !== hostParent)
          if (hostParentIsContainer)
            try {
              (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
            } catch (error) {
              captureCommitPhaseError(
                deletedFiber,
                nearestMountedAncestor,
                error
              );
            }
          else
            try {
              hostParent.removeChild(deletedFiber.stateNode);
            } catch (error) {
              captureCommitPhaseError(
                deletedFiber,
                nearestMountedAncestor,
                error
              );
            }
        break;
      case 18:
        null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(
          9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot,
          deletedFiber.stateNode
        ), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
        break;
      case 4:
        prevHostParent = hostParent;
        prevHostParentIsContainer = hostParentIsContainer;
        hostParent = deletedFiber.stateNode.containerInfo;
        hostParentIsContainer = true;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
        offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 1:
        offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(
          deletedFiber,
          nearestMountedAncestor,
          prevHostParent
        ));
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 21:
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 22:
        offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        offscreenSubtreeWasHidden = prevHostParent;
        break;
      default:
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
    }
  }
  function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
      finishedRoot = finishedRoot.dehydrated;
      try {
        retryIfBlockedOn(finishedRoot);
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
  }
  function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot))))
      try {
        retryIfBlockedOn(finishedRoot);
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
  }
  function getRetryCache(finishedWork) {
    switch (finishedWork.tag) {
      case 31:
      case 13:
      case 19:
        var retryCache = finishedWork.stateNode;
        null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
        return retryCache;
      case 22:
        return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
      default:
        throw Error(formatProdErrorMessage2(435, finishedWork.tag));
    }
  }
  function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
      if (!retryCache.has(wakeable)) {
        retryCache.add(wakeable);
        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
        wakeable.then(retry, retry);
      }
    });
  }
  function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions)
      for (var i2 = 0; i2 < deletions.length; i2++) {
        var childToDelete = deletions[i2], root3 = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for (; null !== parent; ) {
          switch (parent.tag) {
            case 27:
              if (isSingletonScope(parent.type)) {
                hostParent = parent.stateNode;
                hostParentIsContainer = false;
                break a;
              }
              break;
            case 5:
              hostParent = parent.stateNode;
              hostParentIsContainer = false;
              break a;
            case 3:
            case 4:
              hostParent = parent.stateNode.containerInfo;
              hostParentIsContainer = true;
              break a;
          }
          parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage2(160));
        commitDeletionEffectsOnFiber(root3, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = false;
        root3 = childToDelete.alternate;
        null !== root3 && (root3.return = null);
        childToDelete.return = null;
      }
    if (parentFiber.subtreeFlags & 13886)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
  }
  var currentHoistableRoot = null;
  function commitMutationEffectsOnFiber(finishedWork, root3) {
    var current2 = finishedWork.alternate, flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
        break;
      case 1:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
        flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current2 = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current2 ? flags : current2.concat(flags))));
        break;
      case 26:
        var hoistableRoot = currentHoistableRoot;
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
        if (flags & 4) {
          var currentResource = null !== current2 ? current2.memoizedState : null;
          flags = finishedWork.memoizedState;
          if (null === current2)
            if (null === flags)
              if (null === finishedWork.stateNode) {
                a: {
                  flags = finishedWork.type;
                  current2 = finishedWork.memoizedProps;
                  hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                  b: switch (flags) {
                    case "title":
                      currentResource = hoistableRoot.getElementsByTagName("title")[0];
                      if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop"))
                        currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(
                          currentResource,
                          hoistableRoot.querySelector("head > title")
                        );
                      setInitialProperties(currentResource, flags, current2);
                      currentResource[internalInstanceKey] = finishedWork;
                      markNodeAsHoistable(currentResource);
                      flags = currentResource;
                      break a;
                    case "link":
                      var maybeNodes = getHydratableHoistableCache(
                        "link",
                        "href",
                        hoistableRoot
                      ).get(flags + (current2.href || ""));
                      if (maybeNodes) {
                        for (var i2 = 0; i2 < maybeNodes.length; i2++)
                          if (currentResource = maybeNodes[i2], currentResource.getAttribute("href") === (null == current2.href || "" === current2.href ? null : current2.href) && currentResource.getAttribute("rel") === (null == current2.rel ? null : current2.rel) && currentResource.getAttribute("title") === (null == current2.title ? null : current2.title) && currentResource.getAttribute("crossorigin") === (null == current2.crossOrigin ? null : current2.crossOrigin)) {
                            maybeNodes.splice(i2, 1);
                            break b;
                          }
                      }
                      currentResource = hoistableRoot.createElement(flags);
                      setInitialProperties(currentResource, flags, current2);
                      hoistableRoot.head.appendChild(currentResource);
                      break;
                    case "meta":
                      if (maybeNodes = getHydratableHoistableCache(
                        "meta",
                        "content",
                        hoistableRoot
                      ).get(flags + (current2.content || ""))) {
                        for (i2 = 0; i2 < maybeNodes.length; i2++)
                          if (currentResource = maybeNodes[i2], currentResource.getAttribute("content") === (null == current2.content ? null : "" + current2.content) && currentResource.getAttribute("name") === (null == current2.name ? null : current2.name) && currentResource.getAttribute("property") === (null == current2.property ? null : current2.property) && currentResource.getAttribute("http-equiv") === (null == current2.httpEquiv ? null : current2.httpEquiv) && currentResource.getAttribute("charset") === (null == current2.charSet ? null : current2.charSet)) {
                            maybeNodes.splice(i2, 1);
                            break b;
                          }
                      }
                      currentResource = hoistableRoot.createElement(flags);
                      setInitialProperties(currentResource, flags, current2);
                      hoistableRoot.head.appendChild(currentResource);
                      break;
                    default:
                      throw Error(formatProdErrorMessage2(468, flags));
                  }
                  currentResource[internalInstanceKey] = finishedWork;
                  markNodeAsHoistable(currentResource);
                  flags = currentResource;
                }
                finishedWork.stateNode = flags;
              } else
                mountHoistable(
                  hoistableRoot,
                  finishedWork.type,
                  finishedWork.stateNode
                );
            else
              finishedWork.stateNode = acquireResource(
                hoistableRoot,
                flags,
                finishedWork.memoizedProps
              );
          else
            currentResource !== flags ? (null === currentResource ? null !== current2.stateNode && (current2 = current2.stateNode, current2.parentNode.removeChild(current2)) : currentResource.count--, null === flags ? mountHoistable(
              hoistableRoot,
              finishedWork.type,
              finishedWork.stateNode
            ) : acquireResource(
              hoistableRoot,
              flags,
              finishedWork.memoizedProps
            )) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(
              finishedWork,
              finishedWork.memoizedProps,
              current2.memoizedProps
            );
        }
        break;
      case 27:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
        null !== current2 && flags & 4 && commitHostUpdate(
          finishedWork,
          finishedWork.memoizedProps,
          current2.memoizedProps
        );
        break;
      case 5:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
        if (finishedWork.flags & 32) {
          hoistableRoot = finishedWork.stateNode;
          try {
            setTextContent(hoistableRoot, "");
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(
          finishedWork,
          hoistableRoot,
          null !== current2 ? current2.memoizedProps : hoistableRoot
        ));
        flags & 1024 && (needsFormReset = true);
        break;
      case 6:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        if (flags & 4) {
          if (null === finishedWork.stateNode)
            throw Error(formatProdErrorMessage2(162));
          flags = finishedWork.memoizedProps;
          current2 = finishedWork.stateNode;
          try {
            current2.nodeValue = flags;
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        break;
      case 3:
        tagCaches = null;
        hoistableRoot = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(root3.containerInfo);
        recursivelyTraverseMutationEffects(root3, finishedWork);
        currentHoistableRoot = hoistableRoot;
        commitReconciliationEffects(finishedWork);
        if (flags & 4 && null !== current2 && current2.memoizedState.isDehydrated)
          try {
            retryIfBlockedOn(root3.containerInfo);
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        needsFormReset && (needsFormReset = false, recursivelyResetForms(finishedWork));
        break;
      case 4:
        flags = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(
          finishedWork.stateNode.containerInfo
        );
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        currentHoistableRoot = flags;
        break;
      case 12:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        break;
      case 31:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
        break;
      case 13:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current2 && null !== current2.memoizedState) && (globalMostRecentFallbackTime = now2());
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
        break;
      case 22:
        hoistableRoot = null !== finishedWork.memoizedState;
        var wasHidden = null !== current2 && null !== current2.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
        recursivelyTraverseMutationEffects(root3, finishedWork);
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
        commitReconciliationEffects(finishedWork);
        if (flags & 8192)
          a: for (root3 = finishedWork.stateNode, root3._visibility = hoistableRoot ? root3._visibility & -2 : root3._visibility | 1, hoistableRoot && (null === current2 || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current2 = null, root3 = finishedWork; ; ) {
            if (5 === root3.tag || 26 === root3.tag) {
              if (null === current2) {
                wasHidden = current2 = root3;
                try {
                  if (currentResource = wasHidden.stateNode, hoistableRoot)
                    maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                  else {
                    i2 = wasHidden.stateNode;
                    var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    i2.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                  }
                } catch (error) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error);
                }
              }
            } else if (6 === root3.tag) {
              if (null === current2) {
                wasHidden = root3;
                try {
                  wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                } catch (error) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error);
                }
              }
            } else if (18 === root3.tag) {
              if (null === current2) {
                wasHidden = root3;
                try {
                  var instance = wasHidden.stateNode;
                  hoistableRoot ? hideOrUnhideDehydratedBoundary(instance, true) : hideOrUnhideDehydratedBoundary(wasHidden.stateNode, false);
                } catch (error) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error);
                }
              }
            } else if ((22 !== root3.tag && 23 !== root3.tag || null === root3.memoizedState || root3 === finishedWork) && null !== root3.child) {
              root3.child.return = root3;
              root3 = root3.child;
              continue;
            }
            if (root3 === finishedWork) break a;
            for (; null === root3.sibling; ) {
              if (null === root3.return || root3.return === finishedWork) break a;
              current2 === root3 && (current2 = null);
              root3 = root3.return;
            }
            current2 === root3 && (current2 = null);
            root3.sibling.return = root3.return;
            root3 = root3.sibling;
          }
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current2 = flags.retryQueue, null !== current2 && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current2))));
        break;
      case 19:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        recursivelyTraverseMutationEffects(root3, finishedWork), commitReconciliationEffects(finishedWork);
    }
  }
  function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
      try {
        for (var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber; ) {
          if (isHostParent(parentFiber)) {
            hostParentFiber = parentFiber;
            break;
          }
          parentFiber = parentFiber.return;
        }
        if (null == hostParentFiber) throw Error(formatProdErrorMessage2(160));
        switch (hostParentFiber.tag) {
          case 27:
            var parent = hostParentFiber.stateNode, before2 = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before2, parent);
            break;
          case 5:
            var parent$141 = hostParentFiber.stateNode;
            hostParentFiber.flags & 32 && (setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
            var before$142 = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
            break;
          case 3:
          case 4:
            var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = getHostSibling(finishedWork);
            insertOrAppendPlacementNodeIntoContainer(
              finishedWork,
              before$144,
              parent$143
            );
            break;
          default:
            throw Error(formatProdErrorMessage2(161));
        }
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
      finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
  }
  function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024)
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
      }
  }
  function recursivelyTraverseLayoutEffects(root3, parentFiber) {
    if (parentFiber.subtreeFlags & 8772)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitLayoutEffectOnFiber(root3, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
  }
  function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedWork = parentFiber;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 1:
          safelyDetachRef(finishedWork, finishedWork.return);
          var instance = finishedWork.stateNode;
          "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(
            finishedWork,
            finishedWork.return,
            instance
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 27:
          releaseSingletonInstance(finishedWork.stateNode);
        case 26:
        case 5:
          safelyDetachRef(finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 30:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        default:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var current2 = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          commitHookEffectListMount(4, finishedWork);
          break;
        case 1:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          current2 = finishedWork;
          finishedRoot = current2.stateNode;
          if ("function" === typeof finishedRoot.componentDidMount)
            try {
              finishedRoot.componentDidMount();
            } catch (error) {
              captureCommitPhaseError(current2, current2.return, error);
            }
          current2 = finishedWork;
          finishedRoot = current2.updateQueue;
          if (null !== finishedRoot) {
            var instance = current2.stateNode;
            try {
              var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
              if (null !== hiddenCallbacks)
                for (finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)
                  callCallback(hiddenCallbacks[finishedRoot], instance);
            } catch (error) {
              captureCommitPhaseError(current2, current2.return, error);
            }
          }
          includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 27:
          commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && null === current2 && flags & 4 && commitHostMount(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          break;
        case 31:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 13:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 30:
          break;
        default:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function commitOffscreenPassiveMountEffects(current2, finishedWork) {
    var previousCache = null;
    null !== current2 && null !== current2.memoizedState && null !== current2.memoizedState.cachePool && (previousCache = current2.memoizedState.cachePool.pool);
    current2 = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current2 = finishedWork.memoizedState.cachePool.pool);
    current2 !== previousCache && (null != current2 && current2.refCount++, null != previousCache && releaseCache(previousCache));
  }
  function commitCachePassiveMountEffect(current2, finishedWork) {
    current2 = null;
    null !== finishedWork.alternate && (current2 = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current2 && (finishedWork.refCount++, null != current2 && releaseCache(current2));
  }
  function recursivelyTraversePassiveMountEffects(root3, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitPassiveMountOnFiber(
          root3,
          parentFiber,
          committedLanes,
          committedTransitions
        ), parentFiber = parentFiber.sibling;
  }
  function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && commitHookEffectListMount(9, finishedWork);
        break;
      case 1:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 3:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
        break;
      case 12:
        if (flags & 2048) {
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          finishedRoot = finishedWork.stateNode;
          try {
            var _finishedWork$memoize2 = finishedWork.memoizedProps, id2 = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
            "function" === typeof onPostCommit && onPostCommit(
              id2,
              null === finishedWork.alternate ? "mount" : "update",
              finishedRoot.passiveEffectDuration,
              -0
            );
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        } else
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
        break;
      case 31:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 13:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 23:
        break;
      case 22:
        _finishedWork$memoize2 = finishedWork.stateNode;
        id2 = finishedWork.alternate;
        null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        ) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        ) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions,
          0 !== (finishedWork.subtreeFlags & 10256) || false
        ));
        flags & 2048 && commitOffscreenPassiveMountEffects(id2, finishedWork);
        break;
      case 24:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
        break;
      default:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
    }
  }
  function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || false);
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          commitHookEffectListMount(8, finishedWork);
          break;
        case 23:
          break;
        case 22:
          var instance = finishedWork.stateNode;
          null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork
          ) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ));
          includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(
            finishedWork.alternate,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch (finishedWork.tag) {
          case 22:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            flags & 2048 && commitOffscreenPassiveMountEffects(
              finishedWork.alternate,
              finishedWork
            );
            break;
          case 24:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
          default:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
      }
  }
  var suspenseyCommitFlag = 8192;
  function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        accumulateSuspenseyCommitOnFiber(
          parentFiber,
          committedLanes,
          suspendedState
        ), parentFiber = parentFiber.sibling;
  }
  function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch (fiber.tag) {
      case 26:
        recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        );
        fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(
          suspendedState,
          currentHoistableRoot,
          fiber.memoizedState,
          fiber.memoizedProps
        );
        break;
      case 5:
        recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        );
        break;
      case 3:
      case 4:
        var previousHoistableRoot = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
        recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        );
        currentHoistableRoot = previousHoistableRoot;
        break;
      case 22:
        null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        ), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        ));
        break;
      default:
        recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        );
    }
  }
  function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
      previousFiber.child = null;
      do
        previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
      while (null !== parentFiber);
    }
  }
  function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
      if (null !== deletions)
        for (var i2 = 0; i2 < deletions.length; i2++) {
          var childToDelete = deletions[i2];
          nextEffect = childToDelete;
          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
            childToDelete,
            parentFiber
          );
        }
      detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
  }
  function commitPassiveUnmountOnFiber(finishedWork) {
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
        break;
      case 3:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      case 12:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      case 22:
        var instance = finishedWork.stateNode;
        null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      default:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
  }
  function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
      if (null !== deletions)
        for (var i2 = 0; i2 < deletions.length; i2++) {
          var childToDelete = deletions[i2];
          nextEffect = childToDelete;
          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
            childToDelete,
            parentFiber
          );
        }
      detachAlternateSiblings(parentFiber);
    }
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      deletions = parentFiber;
      switch (deletions.tag) {
        case 0:
        case 11:
        case 15:
          commitHookEffectListUnmount(8, deletions, deletions.return);
          recursivelyTraverseDisconnectPassiveEffects(deletions);
          break;
        case 22:
          i2 = deletions.stateNode;
          i2._visibility & 2 && (i2._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
          break;
        default:
          recursivelyTraverseDisconnectPassiveEffects(deletions);
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for (; null !== nextEffect; ) {
      var fiber = nextEffect;
      switch (fiber.tag) {
        case 0:
        case 11:
        case 15:
          commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
          break;
        case 23:
        case 22:
          if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
            var cache = fiber.memoizedState.cachePool.pool;
            null != cache && cache.refCount++;
          }
          break;
        case 24:
          releaseCache(fiber.memoizedState.cache);
      }
      cache = fiber.child;
      if (null !== cache) cache.return = fiber, nextEffect = cache;
      else
        a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
          cache = nextEffect;
          var sibling = cache.sibling, returnFiber = cache.return;
          detachFiberAfterEffects(cache);
          if (cache === fiber) {
            nextEffect = null;
            break a;
          }
          if (null !== sibling) {
            sibling.return = returnFiber;
            nextEffect = sibling;
            break a;
          }
          nextEffect = returnFiber;
        }
    }
  }
  var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
      var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
      void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
      return cacheForType;
    },
    cacheSignal: function() {
      return readContext(CacheContext).controller.signal;
    }
  }, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = false, workInProgressRootIsPrerendering = false, workInProgressRootDidAttachPingListener = false, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = false, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
  function requestUpdateLane() {
    return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes : null !== ReactSharedInternals.T ? requestTransitionLane() : resolveUpdatePriority();
  }
  function requestDeferredLane() {
    if (0 === workInProgressDeferredLane)
      if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
        var lane = nextTransitionDeferredLane;
        nextTransitionDeferredLane <<= 1;
        0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
        workInProgressDeferredLane = lane;
      } else workInProgressDeferredLane = 536870912;
    lane = suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return workInProgressDeferredLane;
  }
  function scheduleUpdateOnFiber(root3, fiber, lane) {
    if (root3 === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root3.cancelPendingCommit)
      prepareFreshStack(root3, 0), markRootSuspended(
        root3,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      );
    markRootUpdated$1(root3, lane);
    if (0 === (executionContext & 2) || root3 !== workInProgressRoot)
      root3 === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(
        root3,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      )), ensureRootIsScheduled(root3);
  }
  function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage2(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, true), renderWasConcurrent = shouldTimeSlice;
    do {
      if (0 === exitStatus) {
        workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, false);
        break;
      } else {
        forceSync = root$jscomp$0.current.alternate;
        if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
          exitStatus = renderRootSync(root$jscomp$0, lanes, false);
          renderWasConcurrent = false;
          continue;
        }
        if (2 === exitStatus) {
          renderWasConcurrent = lanes;
          if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent)
            var JSCompiler_inline_result = 0;
          else
            JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
          if (0 !== JSCompiler_inline_result) {
            lanes = JSCompiler_inline_result;
            a: {
              var root3 = root$jscomp$0;
              exitStatus = workInProgressRootConcurrentErrors;
              var wasRootDehydrated = root3.current.memoizedState.isDehydrated;
              wasRootDehydrated && (prepareFreshStack(root3, JSCompiler_inline_result).flags |= 256);
              JSCompiler_inline_result = renderRootSync(
                root3,
                JSCompiler_inline_result,
                false
              );
              if (2 !== JSCompiler_inline_result) {
                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                  root3.errorRecoveryDisabledLanes |= renderWasConcurrent;
                  workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                  exitStatus = 4;
                  break a;
                }
                renderWasConcurrent = workInProgressRootRecoverableErrors;
                workInProgressRootRecoverableErrors = exitStatus;
                null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(
                  workInProgressRootRecoverableErrors,
                  renderWasConcurrent
                ));
              }
              exitStatus = JSCompiler_inline_result;
            }
            renderWasConcurrent = false;
            if (2 !== exitStatus) continue;
          }
        }
        if (1 === exitStatus) {
          prepareFreshStack(root$jscomp$0, 0);
          markRootSuspended(root$jscomp$0, lanes, 0, true);
          break;
        }
        a: {
          shouldTimeSlice = root$jscomp$0;
          renderWasConcurrent = exitStatus;
          switch (renderWasConcurrent) {
            case 0:
            case 1:
              throw Error(formatProdErrorMessage2(345));
            case 4:
              if ((lanes & 4194048) !== lanes) break;
            case 6:
              markRootSuspended(
                shouldTimeSlice,
                lanes,
                workInProgressDeferredLane,
                !workInProgressRootDidSkipSuspendedSiblings
              );
              break a;
            case 2:
              workInProgressRootRecoverableErrors = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(formatProdErrorMessage2(329));
          }
          if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now2(), 10 < exitStatus)) {
            markRootSuspended(
              shouldTimeSlice,
              lanes,
              workInProgressDeferredLane,
              !workInProgressRootDidSkipSuspendedSiblings
            );
            if (0 !== getNextLanes(shouldTimeSlice, 0, true)) break a;
            pendingEffectsLanes = lanes;
            shouldTimeSlice.timeoutHandle = scheduleTimeout(
              commitRootWhenReady.bind(
                null,
                shouldTimeSlice,
                forceSync,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                lanes,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                workInProgressRootDidSkipSuspendedSiblings,
                renderWasConcurrent,
                "Throttled",
                -0,
                0
              ),
              exitStatus
            );
            break a;
          }
          commitRootWhenReady(
            shouldTimeSlice,
            forceSync,
            workInProgressRootRecoverableErrors,
            workInProgressTransitions,
            workInProgressRootDidIncludeRecursiveRenderUpdate,
            lanes,
            workInProgressDeferredLane,
            workInProgressRootInterleavedUpdatedLanes,
            workInProgressSuspendedRetryLanes,
            workInProgressRootDidSkipSuspendedSiblings,
            renderWasConcurrent,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (1);
    ensureRootIsScheduled(root$jscomp$0);
  }
  function commitRootWhenReady(root3, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root3.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
      suspendedCommitReason = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: true,
        waitingForViewTransition: false,
        unsuspend: noop$12
      };
      accumulateSuspenseyCommitOnFiber(
        finishedWork,
        lanes,
        suspendedCommitReason
      );
      var timeoutOffset = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now2() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now2() : 0;
      timeoutOffset = waitForCommitToBeReady(
        suspendedCommitReason,
        timeoutOffset
      );
      if (null !== timeoutOffset) {
        pendingEffectsLanes = lanes;
        root3.cancelPendingCommit = timeoutOffset(
          commitRoot.bind(
            null,
            root3,
            finishedWork,
            lanes,
            recoverableErrors,
            transitions,
            didIncludeRenderPhaseUpdate,
            spawnedLane,
            updatedLanes,
            suspendedRetryLanes,
            exitStatus,
            suspendedCommitReason,
            null,
            completedRenderStartTime,
            completedRenderEndTime
          )
        );
        markRootSuspended(root3, lanes, spawnedLane, !didSkipSuspendedSiblings);
        return;
      }
    }
    commitRoot(
      root3,
      finishedWork,
      lanes,
      recoverableErrors,
      transitions,
      didIncludeRenderPhaseUpdate,
      spawnedLane,
      updatedLanes,
      suspendedRetryLanes
    );
  }
  function isRenderConsistentWithExternalStores(finishedWork) {
    for (var node = finishedWork; ; ) {
      var tag2 = node.tag;
      if ((0 === tag2 || 11 === tag2 || 15 === tag2) && node.flags & 16384 && (tag2 = node.updateQueue, null !== tag2 && (tag2 = tag2.stores, null !== tag2)))
        for (var i2 = 0; i2 < tag2.length; i2++) {
          var check = tag2[i2], getSnapshot = check.getSnapshot;
          check = check.value;
          try {
            if (!objectIs(getSnapshot(), check)) return false;
          } catch (error) {
            return false;
          }
        }
      tag2 = node.child;
      if (node.subtreeFlags & 16384 && null !== tag2)
        tag2.return = node, node = tag2;
      else {
        if (node === finishedWork) break;
        for (; null === node.sibling; ) {
          if (null === node.return || node.return === finishedWork) return true;
          node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
      }
    }
    return true;
  }
  function markRootSuspended(root3, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root3.suspendedLanes |= suspendedLanes;
    root3.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root3.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root3.expirationTimes;
    for (var lanes = suspendedLanes; 0 < lanes; ) {
      var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
      didAttemptEntireTree[index$6] = -1;
      lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root3, spawnedLane, suspendedLanes);
  }
  function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0), false) : true;
  }
  function resetWorkInProgressStack() {
    if (null !== workInProgress) {
      if (0 === workInProgressSuspendedReason)
        var interruptedWork = workInProgress.return;
      else
        interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
      for (; null !== interruptedWork; )
        unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
      workInProgress = null;
    }
  }
  function prepareFreshStack(root3, lanes) {
    var timeoutHandle = root3.timeoutHandle;
    -1 !== timeoutHandle && (root3.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root3.cancelPendingCommit;
    null !== timeoutHandle && (root3.cancelPendingCommit = null, timeoutHandle());
    pendingEffectsLanes = 0;
    resetWorkInProgressStack();
    workInProgressRoot = root3;
    workInProgress = timeoutHandle = createWorkInProgress(root3.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = false;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root3, lanes);
    workInProgressRootDidAttachPingListener = false;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = false;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root3.entangledLanes;
    if (0 !== allEntangledLanes)
      for (root3 = root3.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes; ) {
        var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root3[index$4];
        allEntangledLanes &= ~lane;
      }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
  }
  function handleThrow(root3, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(
      root3,
      createCapturedValueAtFiber(thrownValue, root3.current)
    ));
  }
  function shouldRemainOnPreviousScreen() {
    var handler = suspenseHandlerStackCursor.current;
    return null === handler ? true : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? true : false : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : false;
  }
  function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
  }
  function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
  }
  function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = true);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(
      workInProgressRoot,
      workInProgressRootRenderLanes,
      workInProgressDeferredLane,
      false
    );
  }
  function renderRootSync(root3, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root3 || workInProgressRootRenderLanes !== lanes)
      workInProgressTransitions = null, prepareFreshStack(root3, lanes);
    lanes = false;
    var exitStatus = workInProgressRootExitStatus;
    a: do
      try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
          var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
          switch (workInProgressSuspendedReason) {
            case 8:
              resetWorkInProgressStack();
              exitStatus = 6;
              break a;
            case 3:
            case 2:
            case 9:
            case 6:
              null === suspenseHandlerStackCursor.current && (lanes = true);
              var reason = workInProgressSuspendedReason;
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, reason);
              if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                exitStatus = 0;
                break a;
              }
              break;
            default:
              reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, reason);
          }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
      } catch (thrownValue$165) {
        handleThrow(root3, thrownValue$165);
      }
    while (1);
    lanes && root3.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
  }
  function workLoopSync() {
    for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
  }
  function renderRootConcurrent(root3, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root3 || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now2() + 500, prepareFreshStack(root3, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
      root3,
      lanes
    );
    a: do
      try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
          lanes = workInProgress;
          var thrownValue = workInProgressThrownValue;
          b: switch (workInProgressSuspendedReason) {
            case 1:
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root3, lanes, thrownValue, 1);
              break;
            case 2:
            case 9:
              if (isThenableResolved(thrownValue)) {
                workInProgressSuspendedReason = 0;
                workInProgressThrownValue = null;
                replaySuspendedUnitOfWork(lanes);
                break;
              }
              lanes = function() {
                2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root3 || (workInProgressSuspendedReason = 7);
                ensureRootIsScheduled(root3);
              };
              thrownValue.then(lanes, lanes);
              break a;
            case 3:
              workInProgressSuspendedReason = 7;
              break a;
            case 4:
              workInProgressSuspendedReason = 5;
              break a;
            case 7:
              isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root3, lanes, thrownValue, 7));
              break;
            case 5:
              var resource = null;
              switch (workInProgress.tag) {
                case 26:
                  resource = workInProgress.memoizedState;
                case 5:
                case 27:
                  var hostFiber = workInProgress;
                  if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    var sibling = hostFiber.sibling;
                    if (null !== sibling) workInProgress = sibling;
                    else {
                      var returnFiber = hostFiber.return;
                      null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                    }
                    break b;
                  }
              }
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root3, lanes, thrownValue, 5);
              break;
            case 6:
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root3, lanes, thrownValue, 6);
              break;
            case 8:
              resetWorkInProgressStack();
              workInProgressRootExitStatus = 6;
              break a;
            default:
              throw Error(formatProdErrorMessage2(462));
          }
        }
        workLoopConcurrentByScheduler();
        break;
      } catch (thrownValue$167) {
        handleThrow(root3, thrownValue$167);
      }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
  }
  function workLoopConcurrentByScheduler() {
    for (; null !== workInProgress && !shouldYield(); )
      performUnitOfWork(workInProgress);
  }
  function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
  }
  function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current2 = next.alternate;
    switch (next.tag) {
      case 15:
      case 0:
        next = replayFunctionComponent(
          current2,
          next,
          next.pendingProps,
          next.type,
          void 0,
          workInProgressRootRenderLanes
        );
        break;
      case 11:
        next = replayFunctionComponent(
          current2,
          next,
          next.pendingProps,
          next.type.render,
          next.ref,
          workInProgressRootRenderLanes
        );
        break;
      case 5:
        resetHooksOnUnwind(next);
      default:
        unwindInterruptedWork(current2, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current2, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
  }
  function throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState$1 = null;
    thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
      if (throwException(
        root3,
        returnFiber,
        unitOfWork,
        thrownValue,
        workInProgressRootRenderLanes
      )) {
        workInProgressRootExitStatus = 1;
        logUncaughtError(
          root3,
          createCapturedValueAtFiber(thrownValue, root3.current)
        );
        workInProgress = null;
        return;
      }
    } catch (error) {
      if (null !== returnFiber) throw workInProgress = returnFiber, error;
      workInProgressRootExitStatus = 1;
      logUncaughtError(
        root3,
        createCapturedValueAtFiber(thrownValue, root3.current)
      );
      workInProgress = null;
      return;
    }
    if (unitOfWork.flags & 32768) {
      if (isHydrating || 1 === suspendedReason) root3 = true;
      else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912))
        root3 = false;
      else if (workInProgressRootDidSkipSuspendedSiblings = root3 = true, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason)
        suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
      unwindUnitOfWork(unitOfWork, root3);
    } else completeUnitOfWork(unitOfWork);
  }
  function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
      if (0 !== (completedWork.flags & 32768)) {
        unwindUnitOfWork(
          completedWork,
          workInProgressRootDidSkipSuspendedSiblings
        );
        return;
      }
      unitOfWork = completedWork.return;
      var next = completeWork(
        completedWork.alternate,
        completedWork,
        entangledRenderLanes
      );
      if (null !== next) {
        workInProgress = next;
        return;
      }
      completedWork = completedWork.sibling;
      if (null !== completedWork) {
        workInProgress = completedWork;
        return;
      }
      workInProgress = completedWork = unitOfWork;
    } while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
  }
  function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
      var next = unwindWork(unitOfWork.alternate, unitOfWork);
      if (null !== next) {
        next.flags &= 32767;
        workInProgress = next;
        return;
      }
      next = unitOfWork.return;
      null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
      if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
        workInProgress = unitOfWork;
        return;
      }
      workInProgress = unitOfWork = next;
    } while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
  }
  function commitRoot(root3, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root3.cancelPendingCommit = null;
    do
      flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage2(327));
    if (null !== finishedWork) {
      if (finishedWork === root3.current) throw Error(formatProdErrorMessage2(177));
      didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
      didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
      markRootFinished(
        root3,
        lanes,
        didIncludeRenderPhaseUpdate,
        spawnedLane,
        updatedLanes,
        suspendedRetryLanes
      );
      root3 === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
      pendingFinishedWork = finishedWork;
      pendingEffectsRoot = root3;
      pendingEffectsLanes = lanes;
      pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
      pendingPassiveTransitions = transitions;
      pendingRecoverableErrors = recoverableErrors;
      0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root3.callbackNode = null, root3.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
        flushPassiveEffects();
        return null;
      })) : (root3.callbackNode = null, root3.callbackPriority = 0);
      recoverableErrors = 0 !== (finishedWork.flags & 13878);
      if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
        recoverableErrors = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        transitions = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        spawnedLane = executionContext;
        executionContext |= 4;
        try {
          commitBeforeMutationEffects(root3, finishedWork, lanes);
        } finally {
          executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
        }
      }
      pendingEffectsStatus = 1;
      flushMutationEffects();
      flushLayoutEffects();
      flushSpawnedWork();
    }
  }
  function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      var root3 = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
      if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
        rootMutationHasEffect = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        try {
          commitMutationEffectsOnFiber(finishedWork, root3);
          var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root3.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
          if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(
            priorFocusedElem.ownerDocument.documentElement,
            priorFocusedElem
          )) {
            if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
              var start = priorSelectionRange.start, end = priorSelectionRange.end;
              void 0 === end && (end = start);
              if ("selectionStart" in priorFocusedElem)
                priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(
                  end,
                  priorFocusedElem.value.length
                );
              else {
                var doc2 = priorFocusedElem.ownerDocument || document, win = doc2 && doc2.defaultView || window;
                if (win.getSelection) {
                  var selection2 = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                  !selection2.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                  var startMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    start$jscomp$0
                  ), endMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    end$jscomp$0
                  );
                  if (startMarker && endMarker && (1 !== selection2.rangeCount || selection2.anchorNode !== startMarker.node || selection2.anchorOffset !== startMarker.offset || selection2.focusNode !== endMarker.node || selection2.focusOffset !== endMarker.offset)) {
                    var range2 = doc2.createRange();
                    range2.setStart(startMarker.node, startMarker.offset);
                    selection2.removeAllRanges();
                    start$jscomp$0 > end$jscomp$0 ? (selection2.addRange(range2), selection2.extend(endMarker.node, endMarker.offset)) : (range2.setEnd(endMarker.node, endMarker.offset), selection2.addRange(range2));
                  }
                }
              }
            }
            doc2 = [];
            for (selection2 = priorFocusedElem; selection2 = selection2.parentNode; )
              1 === selection2.nodeType && doc2.push({
                element: selection2,
                left: selection2.scrollLeft,
                top: selection2.scrollTop
              });
            "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
            for (priorFocusedElem = 0; priorFocusedElem < doc2.length; priorFocusedElem++) {
              var info = doc2[priorFocusedElem];
              info.element.scrollLeft = info.left;
              info.element.scrollTop = info.top;
            }
          }
          _enabled = !!eventsEnabled;
          selectionInformation = eventsEnabled = null;
        } finally {
          executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
        }
      }
      root3.current = finishedWork;
      pendingEffectsStatus = 2;
    }
  }
  function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      var root3 = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
      if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
        rootHasLayoutEffect = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        try {
          commitLayoutEffectOnFiber(root3, finishedWork.alternate, finishedWork);
        } finally {
          executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
        }
      }
      pendingEffectsStatus = 3;
    }
  }
  function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      requestPaint();
      var root3 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
      0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root3, root3.pendingLanes));
      var remainingLanes = root3.pendingLanes;
      0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
      lanesToEventPriority(lanes);
      finishedWork = finishedWork.stateNode;
      if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
        try {
          injectedHook.onCommitFiberRoot(
            rendererID,
            finishedWork,
            void 0,
            128 === (finishedWork.current.flags & 128)
          );
        } catch (err) {
        }
      if (null !== recoverableErrors) {
        finishedWork = ReactSharedInternals.T;
        remainingLanes = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        ReactSharedInternals.T = null;
        try {
          for (var onRecoverableError = root3.onRecoverableError, i2 = 0; i2 < recoverableErrors.length; i2++) {
            var recoverableError = recoverableErrors[i2];
            onRecoverableError(recoverableError.value, {
              componentStack: recoverableError.stack
            });
          }
        } finally {
          ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
        }
      }
      0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
      ensureRootIsScheduled(root3);
      remainingLanes = root3.pendingLanes;
      0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root3 === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root3) : nestedUpdateCount = 0;
      flushSyncWorkAcrossRoots_impl(0);
    }
  }
  function releaseRootPooledCache(root3, remainingLanes) {
    0 === (root3.pooledCacheLanes &= remainingLanes) && (remainingLanes = root3.pooledCache, null != remainingLanes && (root3.pooledCache = null, releaseCache(remainingLanes)));
  }
  function flushPendingEffects() {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
  }
  function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return false;
    var root3 = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
      ReactSharedInternals.T = null;
      renderPriority = pendingPassiveTransitions;
      pendingPassiveTransitions = null;
      var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
      pendingEffectsStatus = 0;
      pendingFinishedWork = pendingEffectsRoot = null;
      pendingEffectsLanes = 0;
      if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage2(331));
      var prevExecutionContext = executionContext;
      executionContext |= 4;
      commitPassiveUnmountOnFiber(root$jscomp$0.current);
      commitPassiveMountOnFiber(
        root$jscomp$0,
        root$jscomp$0.current,
        lanes,
        renderPriority
      );
      executionContext = prevExecutionContext;
      flushSyncWorkAcrossRoots_impl(0, false);
      if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot)
        try {
          injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {
        }
      return true;
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root3, remainingLanes);
    }
  }
  function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
  }
  function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag)
      captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else
      for (; null !== nearestMountedAncestor; ) {
        if (3 === nearestMountedAncestor.tag) {
          captureCommitPhaseErrorOnRoot(
            nearestMountedAncestor,
            sourceFiber,
            error
          );
          break;
        } else if (1 === nearestMountedAncestor.tag) {
          var instance = nearestMountedAncestor.stateNode;
          if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
            sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
            error = createClassErrorUpdate(2);
            instance = enqueueUpdate(nearestMountedAncestor, error, 2);
            null !== instance && (initializeClassErrorUpdate(
              error,
              instance,
              nearestMountedAncestor,
              sourceFiber
            ), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
            break;
          }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
      }
  }
  function attachPingListener(root3, wakeable, lanes) {
    var pingCache = root3.pingCache;
    if (null === pingCache) {
      pingCache = root3.pingCache = new PossiblyWeakMap();
      var threadIDs = /* @__PURE__ */ new Set();
      pingCache.set(wakeable, threadIDs);
    } else
      threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = /* @__PURE__ */ new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = true, threadIDs.add(lanes), root3 = pingSuspendedRoot.bind(null, root3, wakeable, lanes), wakeable.then(root3, root3));
  }
  function pingSuspendedRoot(root3, wakeable, pingedLanes) {
    var pingCache = root3.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root3.pingedLanes |= root3.suspendedLanes & pingedLanes;
    root3.warmLanes &= ~pingedLanes;
    workInProgressRoot === root3 && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now2() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root3, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root3);
  }
  function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
  }
  function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
  }
  function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch (boundaryFiber.tag) {
      case 31:
      case 13:
        var retryCache = boundaryFiber.stateNode;
        var suspenseState = boundaryFiber.memoizedState;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        break;
      case 19:
        retryCache = boundaryFiber.stateNode;
        break;
      case 22:
        retryCache = boundaryFiber.stateNode._retryCache;
        break;
      default:
        throw Error(formatProdErrorMessage2(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
  }
  function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
  }
  var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = false, mightHavePendingSyncWork = false, isFlushingWork = false, currentEventTransitionLane = 0;
  function ensureRootIsScheduled(root3) {
    root3 !== lastScheduledRoot && null === root3.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root3 : lastScheduledRoot = lastScheduledRoot.next = root3);
    mightHavePendingSyncWork = true;
    didScheduleMicrotask || (didScheduleMicrotask = true, scheduleImmediateRootScheduleTask());
  }
  function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
      isFlushingWork = true;
      do {
        var didPerformSomeWork = false;
        for (var root$170 = firstScheduledRoot; null !== root$170; ) {
          if (0 !== syncTransitionLanes) {
            var pendingLanes = root$170.pendingLanes;
            if (0 === pendingLanes) var JSCompiler_inline_result = 0;
            else {
              var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
              JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
              JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
              JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
            }
            0 !== JSCompiler_inline_result && (didPerformSomeWork = true, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
          } else
            JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(
              root$170,
              root$170 === workInProgressRoot ? JSCompiler_inline_result : 0,
              null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle
            ), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = true, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
          root$170 = root$170.next;
        }
      } while (didPerformSomeWork);
      isFlushingWork = false;
    }
  }
  function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
  }
  function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = false;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
    for (var currentTime = now2(), prev = null, root3 = firstScheduledRoot; null !== root3; ) {
      var next = root3.next, nextLanes = scheduleTaskForRootDuringMicrotask(root3, currentTime);
      if (0 === nextLanes)
        root3.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
      else if (prev = root3, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
        mightHavePendingSyncWork = true;
      root3 = next;
    }
    0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus || flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
    0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
  }
  function scheduleTaskForRootDuringMicrotask(root3, currentTime) {
    for (var suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes, expirationTimes = root3.expirationTimes, lanes = root3.pendingLanes & -62914561; 0 < lanes; ) {
      var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
      if (-1 === expirationTime) {
        if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
          expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
      } else expirationTime <= currentTime && (root3.expiredLanes |= lane);
      lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(
      root3,
      root3 === currentTime ? suspendedLanes : 0,
      null !== root3.cancelPendingCommit || -1 !== root3.timeoutHandle
    );
    pingedLanes = root3.callbackNode;
    if (0 === suspendedLanes || root3 === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root3.cancelPendingCommit)
      return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root3.callbackNode = null, root3.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root3, suspendedLanes)) {
      currentTime = suspendedLanes & -suspendedLanes;
      if (currentTime === root3.callbackPriority) return currentTime;
      null !== pingedLanes && cancelCallback$1(pingedLanes);
      switch (lanesToEventPriority(suspendedLanes)) {
        case 2:
        case 8:
          suspendedLanes = UserBlockingPriority;
          break;
        case 32:
          suspendedLanes = NormalPriority$1;
          break;
        case 268435456:
          suspendedLanes = IdlePriority;
          break;
        default:
          suspendedLanes = NormalPriority$1;
      }
      pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root3);
      suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
      root3.callbackPriority = currentTime;
      root3.callbackNode = suspendedLanes;
      return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root3.callbackPriority = 2;
    root3.callbackNode = null;
    return 2;
  }
  function performWorkOnRootViaSchedulerTask(root3, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus)
      return root3.callbackNode = null, root3.callbackPriority = 0, null;
    var originalCallbackNode = root3.callbackNode;
    if (flushPendingEffects() && root3.callbackNode !== originalCallbackNode)
      return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
      root3,
      root3 === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
      null !== root3.cancelPendingCommit || -1 !== root3.timeoutHandle
    );
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root3, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root3, now2());
    return null != root3.callbackNode && root3.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root3) : null;
  }
  function performSyncWorkOnRoot(root3, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root3, lanes, true);
  }
  function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
      0 !== (executionContext & 6) ? scheduleCallback$3(
        ImmediatePriority,
        processRootScheduleInImmediateTask
      ) : processRootScheduleInMicrotask();
    });
  }
  function requestTransitionLane() {
    if (0 === currentEventTransitionLane) {
      var actionScopeLane = currentEntangledLane;
      0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
      currentEventTransitionLane = actionScopeLane;
    }
    return currentEventTransitionLane;
  }
  function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
  }
  function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
  }
  function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
      var action = coerceFormActionProp(
        (nativeEventTarget[internalPropsKey] || null).action
      ), submitter = nativeEvent.submitter;
      submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
      var event = new SyntheticEvent(
        "action",
        "action",
        null,
        nativeEvent,
        nativeEventTarget
      );
      dispatchQueue.push({
        event,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (nativeEvent.defaultPrevented) {
                if (0 !== currentEventTransitionLane) {
                  var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                  startHostTransition(
                    maybeTargetInst,
                    {
                      pending: true,
                      data: formData,
                      method: nativeEventTarget.method,
                      action
                    },
                    null,
                    formData
                  );
                }
              } else
                "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(
                  maybeTargetInst,
                  {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action
                  },
                  action,
                  formData
                ));
            },
            currentTarget: nativeEventTarget
          }
        ]
      });
    }
  }
  for (var i$jscomp$inline_1577 = 0; i$jscomp$inline_1577 < simpleEventPluginEvents.length; i$jscomp$inline_1577++) {
    var eventName$jscomp$inline_1578 = simpleEventPluginEvents[i$jscomp$inline_1577], domEventName$jscomp$inline_1579 = eventName$jscomp$inline_1578.toLowerCase(), capitalizedEvent$jscomp$inline_1580 = eventName$jscomp$inline_1578[0].toUpperCase() + eventName$jscomp$inline_1578.slice(1);
    registerSimpleEvent(
      domEventName$jscomp$inline_1579,
      "on" + capitalizedEvent$jscomp$inline_1580
    );
  }
  registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
  registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
  registerSimpleEvent(ANIMATION_START, "onAnimationStart");
  registerSimpleEvent("dblclick", "onDoubleClick");
  registerSimpleEvent("focusin", "onFocus");
  registerSimpleEvent("focusout", "onBlur");
  registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
  registerSimpleEvent(TRANSITION_START, "onTransitionStart");
  registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
  registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
  registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
  registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
  registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
  registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
  registerTwoPhaseEvent(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  );
  registerTwoPhaseEvent(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  );
  registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]);
  registerTwoPhaseEvent(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  );
  registerTwoPhaseEvent(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  );
  registerTwoPhaseEvent(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), nonDelegatedEvents = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)
  );
  function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for (var i2 = 0; i2 < dispatchQueue.length; i2++) {
      var _dispatchQueue$i = dispatchQueue[i2], event = _dispatchQueue$i.event;
      _dispatchQueue$i = _dispatchQueue$i.listeners;
      a: {
        var previousInstance = void 0;
        if (eventSystemFlags)
          for (var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--) {
            var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
            _dispatchListeners$i = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped())
              break a;
            previousInstance = _dispatchListeners$i;
            event.currentTarget = currentTarget;
            try {
              previousInstance(event);
            } catch (error) {
              reportGlobalError(error);
            }
            event.currentTarget = null;
            previousInstance = instance;
          }
        else
          for (i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++) {
            _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
            instance = _dispatchListeners$i.instance;
            currentTarget = _dispatchListeners$i.currentTarget;
            _dispatchListeners$i = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped())
              break a;
            previousInstance = _dispatchListeners$i;
            event.currentTarget = currentTarget;
            try {
              previousInstance(event);
            } catch (error) {
              reportGlobalError(error);
            }
            event.currentTarget = null;
            previousInstance = instance;
          }
      }
    }
  }
  function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = /* @__PURE__ */ new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, false), JSCompiler_inline_result.add(listenerSetKey));
  }
  function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(
      target,
      domEventName,
      eventSystemFlags,
      isCapturePhaseListener
    );
  }
  var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
  function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
      rootContainerElement[listeningMarker] = true;
      allNativeEvents.forEach(function(domEventName) {
        "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, false, rootContainerElement), listenToNativeEvent(domEventName, true, rootContainerElement));
      });
      var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
      null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = true, listenToNativeEvent("selectionchange", false, ownerDocument));
    }
  }
  function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch (getEventPriority(domEventName)) {
      case 2:
        var listenerWrapper = dispatchDiscreteEvent;
        break;
      case 8:
        listenerWrapper = dispatchContinuousEvent;
        break;
      default:
        listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(
      null,
      domEventName,
      eventSystemFlags,
      targetContainer
    );
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = true);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
      capture: true,
      passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, true) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
      passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, false);
  }
  function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0)
      a: for (; ; ) {
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
          var container = targetInst$jscomp$0.stateNode.containerInfo;
          if (container === targetContainer) break;
          if (4 === nodeTag)
            for (nodeTag = targetInst$jscomp$0.return; null !== nodeTag; ) {
              var grandTag = nodeTag.tag;
              if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer)
                return;
              nodeTag = nodeTag.return;
            }
          for (; null !== container; ) {
            nodeTag = getClosestInstanceFromNode(container);
            if (null === nodeTag) return;
            grandTag = nodeTag.tag;
            if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
              targetInst$jscomp$0 = ancestorInst = nodeTag;
              continue a;
            }
            container = container.parentNode;
          }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
      }
    batchedUpdates$1(function() {
      var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
      a: {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (void 0 !== reactName) {
          var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
          switch (domEventName) {
            case "keypress":
              if (0 === getEventCharCode(nativeEvent)) break a;
            case "keydown":
            case "keyup":
              SyntheticEventCtor = SyntheticKeyboardEvent;
              break;
            case "focusin":
              reactEventType = "focus";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "focusout":
              reactEventType = "blur";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "beforeblur":
            case "afterblur":
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "click":
              if (2 === nativeEvent.button) break a;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              SyntheticEventCtor = SyntheticMouseEvent;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              SyntheticEventCtor = SyntheticDragEvent;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              SyntheticEventCtor = SyntheticTouchEvent;
              break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
              SyntheticEventCtor = SyntheticAnimationEvent;
              break;
            case TRANSITION_END:
              SyntheticEventCtor = SyntheticTransitionEvent;
              break;
            case "scroll":
            case "scrollend":
              SyntheticEventCtor = SyntheticUIEvent;
              break;
            case "wheel":
              SyntheticEventCtor = SyntheticWheelEvent;
              break;
            case "copy":
            case "cut":
            case "paste":
              SyntheticEventCtor = SyntheticClipboardEvent;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              SyntheticEventCtor = SyntheticPointerEvent;
              break;
            case "toggle":
            case "beforetoggle":
              SyntheticEventCtor = SyntheticToggleEvent;
          }
          var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
          inCapturePhase = [];
          for (var instance = targetInst, lastHostComponent; null !== instance; ) {
            var _instance = instance;
            lastHostComponent = _instance.stateNode;
            _instance = _instance.tag;
            5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(
              createDispatchListener(instance, _instance, lastHostComponent)
            ));
            if (accumulateTargetOnly) break;
            instance = instance.return;
          }
          0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(
            reactName,
            reactEventType,
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({ event: reactName, listeners: inCapturePhase }));
        }
      }
      if (0 === (eventSystemFlags & 7)) {
        a: {
          reactName = "mouseover" === domEventName || "pointerover" === domEventName;
          SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
          if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey]))
            break a;
          if (SyntheticEventCtor || reactName) {
            reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
            if (SyntheticEventCtor) {
              if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase))
                reactEventType = null;
            } else SyntheticEventCtor = null, reactEventType = targetInst;
            if (SyntheticEventCtor !== reactEventType) {
              inCapturePhase = SyntheticMouseEvent;
              _instance = "onMouseLeave";
              reactEventName = "onMouseEnter";
              instance = "mouse";
              if ("pointerout" === domEventName || "pointerover" === domEventName)
                inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
              accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
              lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
              reactName = new inCapturePhase(
                _instance,
                instance + "leave",
                SyntheticEventCtor,
                nativeEvent,
                nativeEventTarget
              );
              reactName.target = accumulateTargetOnly;
              reactName.relatedTarget = lastHostComponent;
              _instance = null;
              getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(
                reactEventName,
                instance + "enter",
                reactEventType,
                nativeEvent,
                nativeEventTarget
              ), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
              accumulateTargetOnly = _instance;
              if (SyntheticEventCtor && reactEventType)
                b: {
                  inCapturePhase = getParent;
                  reactEventName = SyntheticEventCtor;
                  instance = reactEventType;
                  lastHostComponent = 0;
                  for (_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))
                    lastHostComponent++;
                  _instance = 0;
                  for (var tempB = instance; tempB; tempB = inCapturePhase(tempB))
                    _instance++;
                  for (; 0 < lastHostComponent - _instance; )
                    reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                  for (; 0 < _instance - lastHostComponent; )
                    instance = inCapturePhase(instance), _instance--;
                  for (; lastHostComponent--; ) {
                    if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                      inCapturePhase = reactEventName;
                      break b;
                    }
                    reactEventName = inCapturePhase(reactEventName);
                    instance = inCapturePhase(instance);
                  }
                  inCapturePhase = null;
                }
              else inCapturePhase = null;
              null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                reactName,
                SyntheticEventCtor,
                inCapturePhase,
                false
              );
              null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                accumulateTargetOnly,
                reactEventType,
                inCapturePhase,
                true
              );
            }
          }
        }
        a: {
          reactName = targetInst ? getNodeFromInstance(targetInst) : window;
          SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
          if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type)
            var getTargetInstFunc = getTargetInstForChangeEvent;
          else if (isTextInputElement(reactName))
            if (isInputEventSupported)
              getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
              getTargetInstFunc = getTargetInstForInputEventPolyfill;
              var handleEventFunc = handleEventsForInputEventPolyfill;
            }
          else
            SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
          if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
            createAndAccumulateChangeEvent(
              dispatchQueue,
              getTargetInstFunc,
              nativeEvent,
              nativeEventTarget
            );
            break a;
          }
          handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
          "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
        }
        handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
        switch (domEventName) {
          case "focusin":
            if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable)
              activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
            break;
          case "focusout":
            lastSelection = activeElementInst = activeElement = null;
            break;
          case "mousedown":
            mouseDown = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            mouseDown = false;
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            break;
          case "selectionchange":
            if (skipSelectionChangeEvent) break;
          case "keydown":
          case "keyup":
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
        var fallbackData;
        if (canUseCompositionEvent)
          b: {
            switch (domEventName) {
              case "compositionstart":
                var eventType = "onCompositionStart";
                break b;
              case "compositionend":
                eventType = "onCompositionEnd";
                break b;
              case "compositionupdate":
                eventType = "onCompositionUpdate";
                break b;
            }
            eventType = void 0;
          }
        else
          isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
        eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root2 = nativeEventTarget, startText = "value" in root2 ? root2.value : root2.textContent, isComposing = true)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(
          eventType,
          domEventName,
          null,
          nativeEvent,
          nativeEventTarget
        ), dispatchQueue.push({ event: eventType, listeners: handleEventFunc }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
        if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent))
          eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent(
            "onBeforeInput",
            "beforeinput",
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({
            event: handleEventFunc,
            listeners: eventType
          }), handleEventFunc.data = fallbackData);
        extractEvents$1(
          dispatchQueue,
          domEventName,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
  }
  function createDispatchListener(instance, listener, currentTarget) {
    return {
      instance,
      listener,
      currentTarget
    };
  }
  function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for (var captureName = reactName + "Capture", listeners = []; null !== targetFiber; ) {
      var _instance2 = targetFiber, stateNode = _instance2.stateNode;
      _instance2 = _instance2.tag;
      5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(
        createDispatchListener(targetFiber, _instance2, stateNode)
      ), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(
        createDispatchListener(targetFiber, _instance2, stateNode)
      ));
      if (3 === targetFiber.tag) return listeners;
      targetFiber = targetFiber.return;
    }
    return [];
  }
  function getParent(inst) {
    if (null === inst) return null;
    do
      inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
  }
  function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for (var registrationName = event._reactName, listeners = []; null !== target && target !== common; ) {
      var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
      _instance3 = _instance3.tag;
      if (null !== alternate && alternate === common) break;
      5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(
        createDispatchListener(target, stateNode, alternate)
      )) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(
        createDispatchListener(target, stateNode, alternate)
      )));
      target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({ event, listeners });
  }
  var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
  function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
  }
  function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? true : false;
  }
  function setProp(domElement, tag2, key, value, props2, prevValue) {
    switch (key) {
      case "children":
        "string" === typeof value ? "body" === tag2 || "textarea" === tag2 && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag2 && setTextContent(domElement, "" + value);
        break;
      case "className":
        setValueForKnownAttribute(domElement, "class", value);
        break;
      case "tabIndex":
        setValueForKnownAttribute(domElement, "tabindex", value);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        setValueForKnownAttribute(domElement, key, value);
        break;
      case "style":
        setValueForStyles(domElement, value, prevValue);
        break;
      case "data":
        if ("object" !== tag2) {
          setValueForKnownAttribute(domElement, "data", value);
          break;
        }
      case "src":
      case "href":
        if ("" === value && ("a" !== tag2 || "href" !== key)) {
          domElement.removeAttribute(key);
          break;
        }
        if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
          domElement.removeAttribute(key);
          break;
        }
        value = sanitizeURL("" + value);
        domElement.setAttribute(key, value);
        break;
      case "action":
      case "formAction":
        if ("function" === typeof value) {
          domElement.setAttribute(
            key,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag2 && setProp(domElement, tag2, "name", props2.name, props2, null), setProp(
            domElement,
            tag2,
            "formEncType",
            props2.formEncType,
            props2,
            null
          ), setProp(
            domElement,
            tag2,
            "formMethod",
            props2.formMethod,
            props2,
            null
          ), setProp(
            domElement,
            tag2,
            "formTarget",
            props2.formTarget,
            props2,
            null
          )) : (setProp(domElement, tag2, "encType", props2.encType, props2, null), setProp(domElement, tag2, "method", props2.method, props2, null), setProp(domElement, tag2, "target", props2.target, props2, null)));
        if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
          domElement.removeAttribute(key);
          break;
        }
        value = sanitizeURL("" + value);
        domElement.setAttribute(key, value);
        break;
      case "onClick":
        null != value && (domElement.onclick = noop$12);
        break;
      case "onScroll":
        null != value && listenToNonDelegatedEvent("scroll", domElement);
        break;
      case "onScrollEnd":
        null != value && listenToNonDelegatedEvent("scrollend", domElement);
        break;
      case "dangerouslySetInnerHTML":
        if (null != value) {
          if ("object" !== typeof value || !("__html" in value))
            throw Error(formatProdErrorMessage2(61));
          key = value.__html;
          if (null != key) {
            if (null != props2.children) throw Error(formatProdErrorMessage2(60));
            domElement.innerHTML = key;
          }
        }
        break;
      case "multiple":
        domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
        break;
      case "muted":
        domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
          domElement.removeAttribute("xlink:href");
          break;
        }
        key = sanitizeURL("" + value);
        domElement.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          key
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
        break;
      case "capture":
      case "download":
        true === value ? domElement.setAttribute(key, "") : false !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
        break;
      case "rowSpan":
      case "start":
        null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
        break;
      case "popover":
        listenToNonDelegatedEvent("beforetoggle", domElement);
        listenToNonDelegatedEvent("toggle", domElement);
        setValueForAttribute(domElement, "popover", value);
        break;
      case "xlinkActuate":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          value
        );
        break;
      case "xlinkArcrole":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          value
        );
        break;
      case "xlinkRole":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          value
        );
        break;
      case "xlinkShow":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          value
        );
        break;
      case "xlinkTitle":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          value
        );
        break;
      case "xlinkType":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          value
        );
        break;
      case "xmlBase":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          value
        );
        break;
      case "xmlLang":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          value
        );
        break;
      case "xmlSpace":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          value
        );
        break;
      case "is":
        setValueForAttribute(domElement, "is", value);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1])
          key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
  }
  function setPropOnCustomElement(domElement, tag2, key, value, props2, prevValue) {
    switch (key) {
      case "style":
        setValueForStyles(domElement, value, prevValue);
        break;
      case "dangerouslySetInnerHTML":
        if (null != value) {
          if ("object" !== typeof value || !("__html" in value))
            throw Error(formatProdErrorMessage2(61));
          key = value.__html;
          if (null != key) {
            if (null != props2.children) throw Error(formatProdErrorMessage2(60));
            domElement.innerHTML = key;
          }
        }
        break;
      case "children":
        "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
        break;
      case "onScroll":
        null != value && listenToNonDelegatedEvent("scroll", domElement);
        break;
      case "onScrollEnd":
        null != value && listenToNonDelegatedEvent("scrollend", domElement);
        break;
      case "onClick":
        null != value && (domElement.onclick = noop$12);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!registrationNameDependencies.hasOwnProperty(key))
          a: {
            if ("o" === key[0] && "n" === key[1] && (props2 = key.endsWith("Capture"), tag2 = key.slice(2, props2 ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag2, prevValue, props2), "function" === typeof value)) {
              "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
              domElement.addEventListener(tag2, value, props2);
              break a;
            }
            key in domElement ? domElement[key] = value : true === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
          }
    }
  }
  function setInitialProperties(domElement, tag2, props2) {
    switch (tag2) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        listenToNonDelegatedEvent("error", domElement);
        listenToNonDelegatedEvent("load", domElement);
        var hasSrc = false, hasSrcSet = false, propKey;
        for (propKey in props2)
          if (props2.hasOwnProperty(propKey)) {
            var propValue = props2[propKey];
            if (null != propValue)
              switch (propKey) {
                case "src":
                  hasSrc = true;
                  break;
                case "srcSet":
                  hasSrcSet = true;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage2(137, tag2));
                default:
                  setProp(domElement, tag2, propKey, propValue, props2, null);
              }
          }
        hasSrcSet && setProp(domElement, tag2, "srcSet", props2.srcSet, props2, null);
        hasSrc && setProp(domElement, tag2, "src", props2.src, props2, null);
        return;
      case "input":
        listenToNonDelegatedEvent("invalid", domElement);
        var defaultValue2 = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
        for (hasSrc in props2)
          if (props2.hasOwnProperty(hasSrc)) {
            var propValue$184 = props2[hasSrc];
            if (null != propValue$184)
              switch (hasSrc) {
                case "name":
                  hasSrcSet = propValue$184;
                  break;
                case "type":
                  propValue = propValue$184;
                  break;
                case "checked":
                  checked = propValue$184;
                  break;
                case "defaultChecked":
                  defaultChecked = propValue$184;
                  break;
                case "value":
                  propKey = propValue$184;
                  break;
                case "defaultValue":
                  defaultValue2 = propValue$184;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != propValue$184)
                    throw Error(formatProdErrorMessage2(137, tag2));
                  break;
                default:
                  setProp(domElement, tag2, hasSrc, propValue$184, props2, null);
              }
          }
        initInput(
          domElement,
          propKey,
          defaultValue2,
          checked,
          defaultChecked,
          propValue,
          hasSrcSet,
          false
        );
        return;
      case "select":
        listenToNonDelegatedEvent("invalid", domElement);
        hasSrc = propValue = propKey = null;
        for (hasSrcSet in props2)
          if (props2.hasOwnProperty(hasSrcSet) && (defaultValue2 = props2[hasSrcSet], null != defaultValue2))
            switch (hasSrcSet) {
              case "value":
                propKey = defaultValue2;
                break;
              case "defaultValue":
                propValue = defaultValue2;
                break;
              case "multiple":
                hasSrc = defaultValue2;
              default:
                setProp(domElement, tag2, hasSrcSet, defaultValue2, props2, null);
            }
        tag2 = propKey;
        props2 = propValue;
        domElement.multiple = !!hasSrc;
        null != tag2 ? updateOptions(domElement, !!hasSrc, tag2, false) : null != props2 && updateOptions(domElement, !!hasSrc, props2, true);
        return;
      case "textarea":
        listenToNonDelegatedEvent("invalid", domElement);
        propKey = hasSrcSet = hasSrc = null;
        for (propValue in props2)
          if (props2.hasOwnProperty(propValue) && (defaultValue2 = props2[propValue], null != defaultValue2))
            switch (propValue) {
              case "value":
                hasSrc = defaultValue2;
                break;
              case "defaultValue":
                hasSrcSet = defaultValue2;
                break;
              case "children":
                propKey = defaultValue2;
                break;
              case "dangerouslySetInnerHTML":
                if (null != defaultValue2) throw Error(formatProdErrorMessage2(91));
                break;
              default:
                setProp(domElement, tag2, propValue, defaultValue2, props2, null);
            }
        initTextarea(domElement, hasSrc, hasSrcSet, propKey);
        return;
      case "option":
        for (checked in props2)
          if (props2.hasOwnProperty(checked) && (hasSrc = props2[checked], null != hasSrc))
            switch (checked) {
              case "selected":
                domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                break;
              default:
                setProp(domElement, tag2, checked, hasSrc, props2, null);
            }
        return;
      case "dialog":
        listenToNonDelegatedEvent("beforetoggle", domElement);
        listenToNonDelegatedEvent("toggle", domElement);
        listenToNonDelegatedEvent("cancel", domElement);
        listenToNonDelegatedEvent("close", domElement);
        break;
      case "iframe":
      case "object":
        listenToNonDelegatedEvent("load", domElement);
        break;
      case "video":
      case "audio":
        for (hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)
          listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
        break;
      case "image":
        listenToNonDelegatedEvent("error", domElement);
        listenToNonDelegatedEvent("load", domElement);
        break;
      case "details":
        listenToNonDelegatedEvent("toggle", domElement);
        break;
      case "embed":
      case "source":
      case "link":
        listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (defaultChecked in props2)
          if (props2.hasOwnProperty(defaultChecked) && (hasSrc = props2[defaultChecked], null != hasSrc))
            switch (defaultChecked) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(formatProdErrorMessage2(137, tag2));
              default:
                setProp(domElement, tag2, defaultChecked, hasSrc, props2, null);
            }
        return;
      default:
        if (isCustomElement(tag2)) {
          for (propValue$184 in props2)
            props2.hasOwnProperty(propValue$184) && (hasSrc = props2[propValue$184], void 0 !== hasSrc && setPropOnCustomElement(
              domElement,
              tag2,
              propValue$184,
              hasSrc,
              props2,
              void 0
            ));
          return;
        }
    }
    for (defaultValue2 in props2)
      props2.hasOwnProperty(defaultValue2) && (hasSrc = props2[defaultValue2], null != hasSrc && setProp(domElement, tag2, defaultValue2, hasSrc, props2, null));
  }
  function updateProperties(domElement, tag2, lastProps, nextProps) {
    switch (tag2) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var name2 = null, type = null, value = null, defaultValue2 = null, lastDefaultValue = null, checked = null, defaultChecked = null;
        for (propKey in lastProps) {
          var lastProp = lastProps[propKey];
          if (lastProps.hasOwnProperty(propKey) && null != lastProp)
            switch (propKey) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                lastDefaultValue = lastProp;
              default:
                nextProps.hasOwnProperty(propKey) || setProp(domElement, tag2, propKey, null, nextProps, lastProp);
            }
        }
        for (var propKey$201 in nextProps) {
          var propKey = nextProps[propKey$201];
          lastProp = lastProps[propKey$201];
          if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp))
            switch (propKey$201) {
              case "type":
                type = propKey;
                break;
              case "name":
                name2 = propKey;
                break;
              case "checked":
                checked = propKey;
                break;
              case "defaultChecked":
                defaultChecked = propKey;
                break;
              case "value":
                value = propKey;
                break;
              case "defaultValue":
                defaultValue2 = propKey;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propKey)
                  throw Error(formatProdErrorMessage2(137, tag2));
                break;
              default:
                propKey !== lastProp && setProp(
                  domElement,
                  tag2,
                  propKey$201,
                  propKey,
                  nextProps,
                  lastProp
                );
            }
        }
        updateInput(
          domElement,
          value,
          defaultValue2,
          lastDefaultValue,
          checked,
          defaultChecked,
          type,
          name2
        );
        return;
      case "select":
        propKey = value = defaultValue2 = propKey$201 = null;
        for (type in lastProps)
          if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue)
            switch (type) {
              case "value":
                break;
              case "multiple":
                propKey = lastDefaultValue;
              default:
                nextProps.hasOwnProperty(type) || setProp(
                  domElement,
                  tag2,
                  type,
                  null,
                  nextProps,
                  lastDefaultValue
                );
            }
        for (name2 in nextProps)
          if (type = nextProps[name2], lastDefaultValue = lastProps[name2], nextProps.hasOwnProperty(name2) && (null != type || null != lastDefaultValue))
            switch (name2) {
              case "value":
                propKey$201 = type;
                break;
              case "defaultValue":
                defaultValue2 = type;
                break;
              case "multiple":
                value = type;
              default:
                type !== lastDefaultValue && setProp(
                  domElement,
                  tag2,
                  name2,
                  type,
                  nextProps,
                  lastDefaultValue
                );
            }
        tag2 = defaultValue2;
        lastProps = value;
        nextProps = propKey;
        null != propKey$201 ? updateOptions(domElement, !!lastProps, propKey$201, false) : !!nextProps !== !!lastProps && (null != tag2 ? updateOptions(domElement, !!lastProps, tag2, true) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", false));
        return;
      case "textarea":
        propKey = propKey$201 = null;
        for (defaultValue2 in lastProps)
          if (name2 = lastProps[defaultValue2], lastProps.hasOwnProperty(defaultValue2) && null != name2 && !nextProps.hasOwnProperty(defaultValue2))
            switch (defaultValue2) {
              case "value":
                break;
              case "children":
                break;
              default:
                setProp(domElement, tag2, defaultValue2, null, nextProps, name2);
            }
        for (value in nextProps)
          if (name2 = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name2 || null != type))
            switch (value) {
              case "value":
                propKey$201 = name2;
                break;
              case "defaultValue":
                propKey = name2;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (null != name2) throw Error(formatProdErrorMessage2(91));
                break;
              default:
                name2 !== type && setProp(domElement, tag2, value, name2, nextProps, type);
            }
        updateTextarea(domElement, propKey$201, propKey);
        return;
      case "option":
        for (var propKey$217 in lastProps)
          if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217))
            switch (propKey$217) {
              case "selected":
                domElement.selected = false;
                break;
              default:
                setProp(
                  domElement,
                  tag2,
                  propKey$217,
                  null,
                  nextProps,
                  propKey$201
                );
            }
        for (lastDefaultValue in nextProps)
          if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey))
            switch (lastDefaultValue) {
              case "selected":
                domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                break;
              default:
                setProp(
                  domElement,
                  tag2,
                  lastDefaultValue,
                  propKey$201,
                  nextProps,
                  propKey
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var propKey$222 in lastProps)
          propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && setProp(domElement, tag2, propKey$222, null, nextProps, propKey$201);
        for (checked in nextProps)
          if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey))
            switch (checked) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propKey$201)
                  throw Error(formatProdErrorMessage2(137, tag2));
                break;
              default:
                setProp(
                  domElement,
                  tag2,
                  checked,
                  propKey$201,
                  nextProps,
                  propKey
                );
            }
        return;
      default:
        if (isCustomElement(tag2)) {
          for (var propKey$227 in lastProps)
            propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && setPropOnCustomElement(
              domElement,
              tag2,
              propKey$227,
              void 0,
              nextProps,
              propKey$201
            );
          for (defaultChecked in nextProps)
            propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || setPropOnCustomElement(
              domElement,
              tag2,
              defaultChecked,
              propKey$201,
              nextProps,
              propKey
            );
          return;
        }
    }
    for (var propKey$232 in lastProps)
      propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && setProp(domElement, tag2, propKey$232, null, nextProps, propKey$201);
    for (lastProp in nextProps)
      propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || setProp(domElement, tag2, lastProp, propKey$201, nextProps, propKey);
  }
  function isLikelyStaticResource(initiatorType) {
    switch (initiatorType) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return true;
      default:
        return false;
    }
  }
  function estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
      for (var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i2 = 0; i2 < resourceEntries.length; i2++) {
        var entry = resourceEntries[i2], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
        if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
          initiatorType = 0;
          duration = entry.responseEnd;
          for (i2 += 1; i2 < resourceEntries.length; i2++) {
            var overlapEntry = resourceEntries[i2], overlapStartTime = overlapEntry.startTime;
            if (overlapStartTime > duration) break;
            var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
            overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
          }
          --i2;
          bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
          count++;
          if (10 < count) break;
        }
      }
      if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
  }
  var eventsEnabled = null, selectionInformation = null;
  function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
  }
  function getOwnHostContext(namespaceURI) {
    switch (namespaceURI) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace)
      switch (type) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
  }
  function shouldSetTextContent(type, props2) {
    return "textarea" === type || "noscript" === type || "string" === typeof props2.children || "number" === typeof props2.children || "bigint" === typeof props2.children || "object" === typeof props2.dangerouslySetInnerHTML && null !== props2.dangerouslySetInnerHTML && null != props2.dangerouslySetInnerHTML.__html;
  }
  var currentPopstateTransitionEvent = null;
  function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
      if (event === currentPopstateTransitionEvent) return false;
      currentPopstateTransitionEvent = event;
      return true;
    }
    currentPopstateTransitionEvent = null;
    return false;
  }
  var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
  } : scheduleTimeout;
  function handleErrorInNextTick(error) {
    setTimeout(function() {
      throw error;
    });
  }
  function isSingletonScope(type) {
    return "head" === type;
  }
  function clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
      var nextNode = node.nextSibling;
      parentInstance.removeChild(node);
      if (nextNode && 8 === nextNode.nodeType)
        if (node = nextNode.data, "/$" === node || "/&" === node) {
          if (0 === depth) {
            parentInstance.removeChild(nextNode);
            retryIfBlockedOn(hydrationInstance);
            return;
          }
          depth--;
        } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node)
          depth++;
        else if ("html" === node)
          releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
        else if ("head" === node) {
          node = parentInstance.ownerDocument.head;
          releaseSingletonInstance(node);
          for (var node$jscomp$0 = node.firstChild; node$jscomp$0; ) {
            var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
            node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
            node$jscomp$0 = nextNode$jscomp$0;
          }
        } else
          "body" === node && releaseSingletonInstance(parentInstance.ownerDocument.body);
      node = nextNode;
    } while (node);
    retryIfBlockedOn(hydrationInstance);
  }
  function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden2) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
      var nextNode = node.nextSibling;
      1 === node.nodeType ? isHidden2 ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden2 ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
      if (nextNode && 8 === nextNode.nodeType)
        if (node = nextNode.data, "/$" === node)
          if (0 === suspenseInstance) break;
          else suspenseInstance--;
        else
          "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
      node = nextNode;
    } while (node);
  }
  function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for (; nextNode; ) {
      var node = nextNode;
      nextNode = nextNode.nextSibling;
      switch (node.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          clearContainerSparingly(node);
          detachDeletedInstance(node);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if ("stylesheet" === node.rel.toLowerCase()) continue;
      }
      container.removeChild(node);
    }
  }
  function canHydrateInstance(instance, type, props2, inRootOrSingleton) {
    for (; 1 === instance.nodeType; ) {
      var anyProps = props2;
      if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
        if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type))
          break;
      } else if (!inRootOrSingleton)
        if ("input" === type && "hidden" === instance.type) {
          var name2 = null == anyProps.name ? null : "" + anyProps.name;
          if ("hidden" === anyProps.type && instance.getAttribute("name") === name2)
            return instance;
        } else return instance;
      else if (!instance[internalHoistableMarker])
        switch (type) {
          case "meta":
            if (!instance.hasAttribute("itemprop")) break;
            return instance;
          case "link":
            name2 = instance.getAttribute("rel");
            if ("stylesheet" === name2 && instance.hasAttribute("data-precedence"))
              break;
            else if (name2 !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title))
              break;
            return instance;
          case "style":
            if (instance.hasAttribute("data-precedence")) break;
            return instance;
          case "script":
            name2 = instance.getAttribute("src");
            if ((name2 !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name2 && instance.hasAttribute("async") && !instance.hasAttribute("itemprop"))
              break;
            return instance;
          default:
            return instance;
        }
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) break;
    }
    return null;
  }
  function canHydrateTextInstance(instance, text2, inRootOrSingleton) {
    if ("" === text2) return null;
    for (; 3 !== instance.nodeType; ) {
      if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
        return null;
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) return null;
    }
    return instance;
  }
  function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for (; 8 !== instance.nodeType; ) {
      if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
        return null;
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) return null;
    }
    return instance;
  }
  function isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
  }
  function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
  }
  function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState)
      callback();
    else {
      var listener = function() {
        callback();
        ownerDocument.removeEventListener("DOMContentLoaded", listener);
      };
      ownerDocument.addEventListener("DOMContentLoaded", listener);
      instance._reactRetry = listener;
    }
  }
  function getNextHydratable(node) {
    for (; null != node; node = node.nextSibling) {
      var nodeType = node.nodeType;
      if (1 === nodeType || 3 === nodeType) break;
      if (8 === nodeType) {
        nodeType = node.data;
        if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType)
          break;
        if ("/$" === nodeType || "/&" === nodeType) return null;
      }
    }
    return node;
  }
  var previousHydratableOnEnteringScopedSingleton = null;
  function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for (var depth = 0; hydrationInstance; ) {
      if (8 === hydrationInstance.nodeType) {
        var data = hydrationInstance.data;
        if ("/$" === data || "/&" === data) {
          if (0 === depth)
            return getNextHydratable(hydrationInstance.nextSibling);
          depth--;
        } else
          "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
      }
      hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
  }
  function getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for (var depth = 0; targetInstance; ) {
      if (8 === targetInstance.nodeType) {
        var data = targetInstance.data;
        if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
          if (0 === depth) return targetInstance;
          depth--;
        } else "/$" !== data && "/&" !== data || depth++;
      }
      targetInstance = targetInstance.previousSibling;
    }
    return null;
  }
  function resolveSingletonInstance(type, props2, rootContainerInstance) {
    props2 = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch (type) {
      case "html":
        type = props2.documentElement;
        if (!type) throw Error(formatProdErrorMessage2(452));
        return type;
      case "head":
        type = props2.head;
        if (!type) throw Error(formatProdErrorMessage2(453));
        return type;
      case "body":
        type = props2.body;
        if (!type) throw Error(formatProdErrorMessage2(454));
        return type;
      default:
        throw Error(formatProdErrorMessage2(451));
    }
  }
  function releaseSingletonInstance(instance) {
    for (var attributes = instance.attributes; attributes.length; )
      instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
  }
  var preloadPropsMap = /* @__PURE__ */ new Map(), preconnectsSet = /* @__PURE__ */ new Set();
  function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
  }
  var previousDispatcher = ReactDOMSharedInternals.d;
  ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
  };
  function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
  }
  function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
  }
  var globalDocument = "undefined" === typeof document ? null : document;
  function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
      var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
      limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
      "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
      preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = { rel, crossOrigin, href }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
  }
  function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
  }
  function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
  }
  function preload(href, as, options3) {
    previousDispatcher.L(href, as, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
      var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
      "image" === as ? options3 && options3.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(
        options3.imageSrcSet
      ) + '"]', "string" === typeof options3.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(
        options3.imageSizes
      ) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
      var key = preloadSelector;
      switch (as) {
        case "style":
          key = getStyleKey(href);
          break;
        case "script":
          key = getScriptKey(href);
      }
      preloadPropsMap.has(key) || (href = assign2(
        {
          rel: "preload",
          href: "image" === as && options3 && options3.imageSrcSet ? void 0 : href,
          as
        },
        options3
      ), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
  }
  function preloadModule(href, options3) {
    previousDispatcher.m(href, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
      var as = options3 && "string" === typeof options3.as ? options3.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
      switch (as) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          key = getScriptKey(href);
      }
      if (!preloadPropsMap.has(key) && (href = assign2({ rel: "modulepreload", href }, options3), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
        switch (as) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (ownerDocument.querySelector(getScriptSelectorFromKey(key)))
              return;
        }
        as = ownerDocument.createElement("link");
        setInitialProperties(as, "link", href);
        markNodeAsHoistable(as);
        ownerDocument.head.appendChild(as);
      }
    }
  }
  function preinitStyle(href, precedence, options3) {
    previousDispatcher.S(href, precedence, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
      var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
      precedence = precedence || "default";
      var resource = styles.get(key);
      if (!resource) {
        var state = { loading: 0, preload: null };
        if (resource = ownerDocument.querySelector(
          getStylesheetSelectorFromKey(key)
        ))
          state.loading = 5;
        else {
          href = assign2(
            { rel: "stylesheet", href, "data-precedence": precedence },
            options3
          );
          (options3 = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options3);
          var link = resource = ownerDocument.createElement("link");
          markNodeAsHoistable(link);
          setInitialProperties(link, "link", href);
          link._p = new Promise(function(resolve, reject2) {
            link.onload = resolve;
            link.onerror = reject2;
          });
          link.addEventListener("load", function() {
            state.loading |= 1;
          });
          link.addEventListener("error", function() {
            state.loading |= 2;
          });
          state.loading |= 4;
          insertStylesheet(resource, precedence, ownerDocument);
        }
        resource = {
          type: "stylesheet",
          instance: resource,
          count: 1,
          state
        };
        styles.set(key, resource);
      }
    }
  }
  function preinitScript(src, options3) {
    previousDispatcher.X(src, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
      var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
      resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign2({ src, async: true }, options3), (options3 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options3), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }, scripts.set(key, resource));
    }
  }
  function preinitModuleScript(src, options3) {
    previousDispatcher.M(src, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
      var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
      resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign2({ src, async: true, type: "module" }, options3), (options3 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options3), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }, scripts.set(key, resource));
    }
  }
  function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage2(446));
    switch (type) {
      case "meta":
      case "title":
        return null;
      case "style":
        return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(
          JSCompiler_inline_result
        ).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, pendingProps.set(currentProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
          type = getStyleKey(pendingProps.href);
          var styles$243 = getResourcesFromRoot(
            JSCompiler_inline_result
          ).hoistableStyles, resource$244 = styles$243.get(type);
          resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector(
            getStylesheetSelectorFromKey(type)
          )) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
            rel: "preload",
            as: "style",
            href: pendingProps.href,
            crossOrigin: pendingProps.crossOrigin,
            integrity: pendingProps.integrity,
            media: pendingProps.media,
            hrefLang: pendingProps.hrefLang,
            referrerPolicy: pendingProps.referrerPolicy
          }, preloadPropsMap.set(type, pendingProps), styles$243 || preloadStylesheet(
            JSCompiler_inline_result,
            type,
            pendingProps,
            resource$244.state
          )));
          if (currentProps && null === currentResource)
            throw Error(formatProdErrorMessage2(528, ""));
          return resource$244;
        }
        if (currentProps && null !== currentResource)
          throw Error(formatProdErrorMessage2(529, ""));
        return null;
      case "script":
        return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(
          JSCompiler_inline_result
        ).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, pendingProps.set(currentProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(formatProdErrorMessage2(444, type));
    }
  }
  function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
  }
  function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
  }
  function stylesheetPropsFromRawProps(rawProps) {
    return assign2({}, rawProps, {
      "data-precedence": rawProps.precedence,
      precedence: null
    });
  }
  function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
      return state.loading |= 1;
    }), key.addEventListener("error", function() {
      return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
  }
  function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
  }
  function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
  }
  function acquireResource(hoistableRoot, resource, props2) {
    resource.count++;
    if (null === resource.instance)
      switch (resource.type) {
        case "style":
          var instance = hoistableRoot.querySelector(
            'style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props2.href) + '"]'
          );
          if (instance)
            return resource.instance = instance, markNodeAsHoistable(instance), instance;
          var styleProps = assign2({}, props2, {
            "data-href": props2.href,
            "data-precedence": props2.precedence,
            href: null,
            precedence: null
          });
          instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement(
            "style"
          );
          markNodeAsHoistable(instance);
          setInitialProperties(instance, "style", styleProps);
          insertStylesheet(instance, props2.precedence, hoistableRoot);
          return resource.instance = instance;
        case "stylesheet":
          styleProps = getStyleKey(props2.href);
          var instance$249 = hoistableRoot.querySelector(
            getStylesheetSelectorFromKey(styleProps)
          );
          if (instance$249)
            return resource.state.loading |= 4, resource.instance = instance$249, markNodeAsHoistable(instance$249), instance$249;
          instance = stylesheetPropsFromRawProps(props2);
          (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
          instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
          markNodeAsHoistable(instance$249);
          var linkInstance = instance$249;
          linkInstance._p = new Promise(function(resolve, reject2) {
            linkInstance.onload = resolve;
            linkInstance.onerror = reject2;
          });
          setInitialProperties(instance$249, "link", instance);
          resource.state.loading |= 4;
          insertStylesheet(instance$249, props2.precedence, hoistableRoot);
          return resource.instance = instance$249;
        case "script":
          instance$249 = getScriptKey(props2.src);
          if (styleProps = hoistableRoot.querySelector(
            getScriptSelectorFromKey(instance$249)
          ))
            return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
          instance = props2;
          if (styleProps = preloadPropsMap.get(instance$249))
            instance = assign2({}, props2), adoptPreloadPropsForScript(instance, styleProps);
          hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
          styleProps = hoistableRoot.createElement("script");
          markNodeAsHoistable(styleProps);
          setInitialProperties(styleProps, "link", instance);
          hoistableRoot.head.appendChild(styleProps);
          return resource.instance = styleProps;
        case "void":
          return null;
        default:
          throw Error(formatProdErrorMessage2(443, resource.type));
      }
    else
      "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props2.precedence, hoistableRoot));
    return resource.instance;
  }
  function insertStylesheet(instance, precedence, root3) {
    for (var nodes = root3.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), last2 = nodes.length ? nodes[nodes.length - 1] : null, prior = last2, i2 = 0; i2 < nodes.length; i2++) {
      var node = nodes[i2];
      if (node.dataset.precedence === precedence) prior = node;
      else if (prior !== last2) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root3.nodeType ? root3.head : root3, precedence.insertBefore(instance, precedence.firstChild));
  }
  function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
  }
  function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
  }
  var tagCaches = null;
  function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
      var cache = /* @__PURE__ */ new Map();
      var caches = tagCaches = /* @__PURE__ */ new Map();
      caches.set(ownerDocument, cache);
    } else
      caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = /* @__PURE__ */ new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for (caches = 0; caches < ownerDocument.length; caches++) {
      var node = ownerDocument[caches];
      if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
        var nodeKey = node.getAttribute(keyAttribute) || "";
        nodeKey = type + nodeKey;
        var existing = cache.get(nodeKey);
        existing ? existing.push(node) : cache.set(nodeKey, [node]);
      }
    }
    return cache;
  }
  function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(
      instance,
      "title" === type ? hoistableRoot.querySelector("head > title") : null
    );
  }
  function isHostHoistableType(type, props2, hostContext) {
    if (1 === hostContext || null != props2.itemProp) return false;
    switch (type) {
      case "meta":
      case "title":
        return true;
      case "style":
        if ("string" !== typeof props2.precedence || "string" !== typeof props2.href || "" === props2.href)
          break;
        return true;
      case "link":
        if ("string" !== typeof props2.rel || "string" !== typeof props2.href || "" === props2.href || props2.onLoad || props2.onError)
          break;
        switch (props2.rel) {
          case "stylesheet":
            return type = props2.disabled, "string" === typeof props2.precedence && null == type;
          default:
            return true;
        }
      case "script":
        if (props2.async && "function" !== typeof props2.async && "symbol" !== typeof props2.async && !props2.onLoad && !props2.onError && props2.src && "string" === typeof props2.src)
          return true;
    }
    return false;
  }
  function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? false : true;
  }
  function suspendResource(state, hoistableRoot, resource, props2) {
    if ("stylesheet" === resource.type && ("string" !== typeof props2.media || false !== matchMedia(props2.media).matches) && 0 === (resource.state.loading & 4)) {
      if (null === resource.instance) {
        var key = getStyleKey(props2.href), instance = hoistableRoot.querySelector(
          getStylesheetSelectorFromKey(key)
        );
        if (instance) {
          hoistableRoot = instance._p;
          null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
          resource.state.loading |= 4;
          resource.instance = instance;
          markNodeAsHoistable(instance);
          return;
        }
        instance = hoistableRoot.ownerDocument || hoistableRoot;
        props2 = stylesheetPropsFromRawProps(props2);
        (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props2, key);
        instance = instance.createElement("link");
        markNodeAsHoistable(instance);
        var linkInstance = instance;
        linkInstance._p = new Promise(function(resolve, reject2) {
          linkInstance.onload = resolve;
          linkInstance.onerror = reject2;
        });
        setInitialProperties(instance, "link", props2);
        resource.instance = instance;
      }
      null === state.stylesheets && (state.stylesheets = /* @__PURE__ */ new Map());
      state.stylesheets.set(resource, hoistableRoot);
      (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
  }
  var estimatedBytesWithinLimit = 0;
  function waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
      var stylesheetTimer = setTimeout(function() {
        state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
        if (state.unsuspend) {
          var unsuspend = state.unsuspend;
          state.unsuspend = null;
          unsuspend();
        }
      }, 6e4 + timeoutOffset);
      0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 62500 * estimateBandwidth());
      var imgTimer = setTimeout(
        function() {
          state.waitingForImages = false;
          if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
          }
        },
        (state.imgBytes > estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset
      );
      state.unsuspend = commit;
      return function() {
        state.unsuspend = null;
        clearTimeout(stylesheetTimer);
        clearTimeout(imgTimer);
      };
    } : null;
  }
  function onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
      if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
      else if (this.unsuspend) {
        var unsuspend = this.unsuspend;
        this.unsuspend = null;
        unsuspend();
      }
    }
  }
  var precedencesByRoot = null;
  function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = /* @__PURE__ */ new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
  }
  function insertStylesheetIntoRoot(root3, resource) {
    if (!(resource.state.loading & 4)) {
      var precedences = precedencesByRoot.get(root3);
      if (precedences) var last2 = precedences.get(null);
      else {
        precedences = /* @__PURE__ */ new Map();
        precedencesByRoot.set(root3, precedences);
        for (var nodes = root3.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), i2 = 0; i2 < nodes.length; i2++) {
          var node = nodes[i2];
          if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media"))
            precedences.set(node.dataset.precedence, node), last2 = node;
        }
        last2 && precedences.set(null, last2);
      }
      nodes = resource.instance;
      node = nodes.getAttribute("data-precedence");
      i2 = precedences.get(node) || last2;
      i2 === last2 && precedences.set(null, nodes);
      precedences.set(node, nodes);
      this.count++;
      last2 = onUnsuspend.bind(this);
      nodes.addEventListener("load", last2);
      nodes.addEventListener("error", last2);
      i2 ? i2.parentNode.insertBefore(nodes, i2.nextSibling) : (root3 = 9 === root3.nodeType ? root3.head : root3, root3.insertBefore(nodes, root3.firstChild));
      resource.state.loading |= 4;
    }
  }
  var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
  };
  function FiberRootNode(containerInfo, tag2, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function createFiberRoot(containerInfo, tag2, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new FiberRootNode(
      containerInfo,
      tag2,
      hydrate,
      identifierPrefix,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      onDefaultTransitionIndicator,
      formState
    );
    tag2 = 1;
    true === isStrictMode && (tag2 |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag2);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag2 = createCache();
    tag2.refCount++;
    containerInfo.pooledCache = tag2;
    tag2.refCount++;
    isStrictMode.memoizedState = {
      element: initialChildren,
      isDehydrated: hydrate,
      cache: tag2
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
  }
  function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
  }
  function updateContainerImpl(rootFiber, lane, element2, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = { element: element2 };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element2 = enqueueUpdate(rootFiber, container, lane);
    null !== element2 && (scheduleUpdateOnFiber(element2, rootFiber, lane), entangleTransitions(element2, rootFiber, lane));
  }
  function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
      var a = fiber.retryLane;
      fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
  }
  function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
  }
  function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
      var root3 = enqueueConcurrentRenderForLane(fiber, 67108864);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, 67108864);
      markRetryLaneIfNotHydrated(fiber, 67108864);
    }
  }
  function attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
      var lane = requestUpdateLane();
      lane = getBumpedLaneForHydrationByLane(lane);
      var root3 = enqueueConcurrentRenderForLane(fiber, lane);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, lane);
      markRetryLaneIfNotHydrated(fiber, lane);
    }
  }
  var _enabled = true;
  function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
      var blockedOn = findInstanceBlockingEvent(nativeEvent);
      if (null === blockedOn)
        dispatchEventForPluginEventSystem(
          domEventName,
          eventSystemFlags,
          nativeEvent,
          return_targetInst,
          targetContainer
        ), clearIfContinuousEvent(domEventName, nativeEvent);
      else if (queueIfContinuousEvent(
        blockedOn,
        domEventName,
        eventSystemFlags,
        targetContainer,
        nativeEvent
      ))
        nativeEvent.stopPropagation();
      else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
        for (; null !== blockedOn; ) {
          var fiber = getInstanceFromNode(blockedOn);
          if (null !== fiber)
            switch (fiber.tag) {
              case 3:
                fiber = fiber.stateNode;
                if (fiber.current.memoizedState.isDehydrated) {
                  var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                  if (0 !== lanes) {
                    var root3 = fiber;
                    root3.pendingLanes |= 2;
                    for (root3.entangledLanes |= 2; lanes; ) {
                      var lane = 1 << 31 - clz32(lanes);
                      root3.entanglements[1] |= lane;
                      lanes &= ~lane;
                    }
                    ensureRootIsScheduled(fiber);
                    0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now2() + 500, flushSyncWorkAcrossRoots_impl(0));
                  }
                }
                break;
              case 31:
              case 13:
                root3 = enqueueConcurrentRenderForLane(fiber, 2), null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
            }
          fiber = findInstanceBlockingEvent(nativeEvent);
          null === fiber && dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            return_targetInst,
            targetContainer
          );
          if (fiber === blockedOn) break;
          blockedOn = fiber;
        }
        null !== blockedOn && nativeEvent.stopPropagation();
      } else
        dispatchEventForPluginEventSystem(
          domEventName,
          eventSystemFlags,
          nativeEvent,
          null,
          targetContainer
        );
    }
  }
  function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
  }
  var return_targetInst = null;
  function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
      var nearestMounted = getNearestMountedFiber(targetNode);
      if (null === nearestMounted) targetNode = null;
      else {
        var tag2 = nearestMounted.tag;
        if (13 === tag2) {
          targetNode = getSuspenseInstanceFromFiber(nearestMounted);
          if (null !== targetNode) return targetNode;
          targetNode = null;
        } else if (31 === tag2) {
          targetNode = getActivityInstanceFromFiber(nearestMounted);
          if (null !== targetNode) return targetNode;
          targetNode = null;
        } else if (3 === tag2) {
          if (nearestMounted.stateNode.current.memoizedState.isDehydrated)
            return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
          targetNode = null;
        } else nearestMounted !== targetNode && (targetNode = null);
      }
    }
    return_targetInst = targetNode;
    return null;
  }
  function getEventPriority(domEventName) {
    switch (domEventName) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (getCurrentPriorityLevel()) {
          case ImmediatePriority:
            return 2;
          case UserBlockingPriority:
            return 8;
          case NormalPriority$1:
          case LowPriority:
            return 32;
          case IdlePriority:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var hasScheduledReplayAttempt = false, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = /* @__PURE__ */ new Map(), queuedPointerCaptures = /* @__PURE__ */ new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch (domEventName) {
      case "focusin":
      case "focusout":
        queuedFocus = null;
        break;
      case "dragenter":
      case "dragleave":
        queuedDrag = null;
        break;
      case "mouseover":
      case "mouseout":
        queuedMouse = null;
        break;
      case "pointerover":
      case "pointerout":
        queuedPointers.delete(nativeEvent.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
  }
  function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent)
      return existingQueuedEvent = {
        blockedOn,
        domEventName,
        eventSystemFlags,
        nativeEvent,
        targetContainers: [targetContainer]
      }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
  }
  function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch (domEventName) {
      case "focusin":
        return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedFocus,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "dragenter":
        return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedDrag,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "mouseover":
        return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedMouse,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "pointerover":
        var pointerId = nativeEvent.pointerId;
        queuedPointers.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointers.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        );
        return true;
      case "gotpointercapture":
        return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointerCaptures.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        ), true;
    }
    return false;
  }
  function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
      var nearestMounted = getNearestMountedFiber(targetInst);
      if (null !== nearestMounted) {
        if (targetInst = nearestMounted.tag, 13 === targetInst) {
          if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
            queuedTarget.blockedOn = targetInst;
            runWithPriority(queuedTarget.priority, function() {
              attemptHydrationAtCurrentPriority(nearestMounted);
            });
            return;
          }
        } else if (31 === targetInst) {
          if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
            queuedTarget.blockedOn = targetInst;
            runWithPriority(queuedTarget.priority, function() {
              attemptHydrationAtCurrentPriority(nearestMounted);
            });
            return;
          }
        } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
          queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
          return;
        }
      }
    }
    queuedTarget.blockedOn = null;
  }
  function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return false;
    for (var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length; ) {
      var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
      if (null === nextBlockedOn) {
        nextBlockedOn = queuedEvent.nativeEvent;
        var nativeEventClone = new nextBlockedOn.constructor(
          nextBlockedOn.type,
          nextBlockedOn
        );
        currentReplayingEvent = nativeEventClone;
        nextBlockedOn.target.dispatchEvent(nativeEventClone);
        currentReplayingEvent = null;
      } else
        return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, false;
      targetContainers.shift();
    }
    return true;
  }
  function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map2) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map2.delete(key);
  }
  function replayUnblockedEvents() {
    hasScheduledReplayAttempt = false;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
  }
  function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = true, Scheduler2.unstable_scheduleCallback(
      Scheduler2.unstable_NormalPriority,
      replayUnblockedEvents
    )));
  }
  var lastScheduledReplayQueue = null;
  function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler2.unstable_scheduleCallback(
      Scheduler2.unstable_NormalPriority,
      function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for (var i2 = 0; i2 < formReplayingQueue.length; i2 += 3) {
          var form = formReplayingQueue[i2], submitterOrAction = formReplayingQueue[i2 + 1], formData = formReplayingQueue[i2 + 2];
          if ("function" !== typeof submitterOrAction)
            if (null === findInstanceBlockingTarget(submitterOrAction || form))
              continue;
            else break;
          var formInst = getInstanceFromNode(form);
          null !== formInst && (formReplayingQueue.splice(i2, 3), i2 -= 3, startHostTransition(
            formInst,
            {
              pending: true,
              data: formData,
              method: form.method,
              action: submitterOrAction
            },
            submitterOrAction,
            formData
          ));
        }
      }
    ));
  }
  function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
      return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for (var i2 = 0; i2 < queuedExplicitHydrationTargets.length; i2++) {
      var queuedTarget = queuedExplicitHydrationTargets[i2];
      queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for (; 0 < queuedExplicitHydrationTargets.length && (i2 = queuedExplicitHydrationTargets[0], null === i2.blockedOn); )
      attemptExplicitHydrationTarget(i2), null === i2.blockedOn && queuedExplicitHydrationTargets.shift();
    i2 = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i2)
      for (queuedTarget = 0; queuedTarget < i2.length; queuedTarget += 3) {
        var form = i2[queuedTarget], submitterOrAction = i2[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction)
          formProps || scheduleReplayQueueIfNeeded(i2);
        else if (formProps) {
          var action = null;
          if (submitterOrAction && submitterOrAction.hasAttribute("formAction"))
            if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null)
              action = formProps.formAction;
            else {
              if (null !== findInstanceBlockingTarget(form)) continue;
            }
          else action = formProps.action;
          "function" === typeof action ? i2[queuedTarget + 1] = action : (i2.splice(queuedTarget, 3), queuedTarget -= 3);
          scheduleReplayQueueIfNeeded(i2);
        }
      }
  }
  function defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
      event.canIntercept && "react-transition" === event.info && event.intercept({
        handler: function() {
          return new Promise(function(resolve) {
            return pendingResolve = resolve;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function handleNavigateComplete() {
      null !== pendingResolve && (pendingResolve(), pendingResolve = null);
      isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
      if (!isCancelled && !navigation.transition) {
        var currentEntry = navigation.currentEntry;
        currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
          state: currentEntry.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if ("object" === typeof navigation) {
      var isCancelled = false, pendingResolve = null;
      navigation.addEventListener("navigate", handleNavigate);
      navigation.addEventListener("navigatesuccess", handleNavigateComplete);
      navigation.addEventListener("navigateerror", handleNavigateComplete);
      setTimeout(startFakeNavigation, 100);
      return function() {
        isCancelled = true;
        navigation.removeEventListener("navigate", handleNavigate);
        navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
        navigation.removeEventListener("navigateerror", handleNavigateComplete);
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
      };
    }
  }
  function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
  }
  ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root3 = this._internalRoot;
    if (null === root3) throw Error(formatProdErrorMessage2(409));
    var current2 = root3.current, lane = requestUpdateLane();
    updateContainerImpl(current2, lane, children, root3, null, null);
  };
  ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root3 = this._internalRoot;
    if (null !== root3) {
      this._internalRoot = null;
      var container = root3.containerInfo;
      updateContainerImpl(root3.current, 2, null, root3, null, null);
      flushSyncWork$1();
      container[internalContainerInstanceKey] = null;
    }
  };
  function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
  }
  ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
      var updatePriority = resolveUpdatePriority();
      target = { blockedOn: null, target, priority: updatePriority };
      for (var i2 = 0; i2 < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i2].priority; i2++) ;
      queuedExplicitHydrationTargets.splice(i2, 0, target);
      0 === i2 && attemptExplicitHydrationTarget(target);
    }
  };
  var isomorphicReactPackageVersion$jscomp$inline_1840 = React2.version;
  if ("19.2.1" !== isomorphicReactPackageVersion$jscomp$inline_1840)
    throw Error(
      formatProdErrorMessage2(
        527,
        isomorphicReactPackageVersion$jscomp$inline_1840,
        "19.2.1"
      )
    );
  ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
      if ("function" === typeof componentOrElement.render)
        throw Error(formatProdErrorMessage2(188));
      componentOrElement = Object.keys(componentOrElement).join(",");
      throw Error(formatProdErrorMessage2(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
  };
  var internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.2.1"
  };
  if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2348.isDisabled && hook$jscomp$inline_2348.supportsFiber)
      try {
        rendererID = hook$jscomp$inline_2348.inject(
          internals$jscomp$inline_2347
        ), injectedHook = hook$jscomp$inline_2348;
      } catch (err) {
      }
  }
  reactDomClient_production.createRoot = function(container, options3) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage2(299));
    var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
    null !== options3 && void 0 !== options3 && (true === options3.unstable_strictMode && (isStrictMode = true), void 0 !== options3.identifierPrefix && (identifierPrefix = options3.identifierPrefix), void 0 !== options3.onUncaughtError && (onUncaughtError = options3.onUncaughtError), void 0 !== options3.onCaughtError && (onCaughtError = options3.onCaughtError), void 0 !== options3.onRecoverableError && (onRecoverableError = options3.onRecoverableError));
    options3 = createFiberRoot(
      container,
      1,
      false,
      null,
      null,
      isStrictMode,
      identifierPrefix,
      null,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      defaultOnDefaultTransitionIndicator
    );
    container[internalContainerInstanceKey] = options3.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options3);
  };
  reactDomClient_production.hydrateRoot = function(container, initialChildren, options3) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage2(299));
    var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
    null !== options3 && void 0 !== options3 && (true === options3.unstable_strictMode && (isStrictMode = true), void 0 !== options3.identifierPrefix && (identifierPrefix = options3.identifierPrefix), void 0 !== options3.onUncaughtError && (onUncaughtError = options3.onUncaughtError), void 0 !== options3.onCaughtError && (onCaughtError = options3.onCaughtError), void 0 !== options3.onRecoverableError && (onRecoverableError = options3.onRecoverableError), void 0 !== options3.formState && (formState = options3.formState));
    initialChildren = createFiberRoot(
      container,
      1,
      true,
      initialChildren,
      null != options3 ? options3 : null,
      isStrictMode,
      identifierPrefix,
      formState,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      defaultOnDefaultTransitionIndicator
    );
    initialChildren.context = getContextForSubtree(null);
    options3 = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options3, identifierPrefix, isStrictMode);
    options3 = isStrictMode;
    initialChildren.current.lanes = options3;
    markRootUpdated$1(initialChildren, options3);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
  };
  reactDomClient_production.version = "19.2.1";
  return reactDomClient_production;
}
var reactDomClient_development = {};
var hasRequiredReactDomClient_development;
function requireReactDomClient_development() {
  if (hasRequiredReactDomClient_development) return reactDomClient_development;
  hasRequiredReactDomClient_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function findHook(fiber, id2) {
      for (fiber = fiber.memoizedState; null !== fiber && 0 < id2; )
        fiber = fiber.next, id2--;
      return fiber;
    }
    function copyWithSetImpl(obj, path, index2, value) {
      if (index2 >= path.length) return value;
      var key = path[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      updated[key] = copyWithSetImpl(obj[key], path, index2 + 1, value);
      return updated;
    }
    function copyWithRename(obj, oldPath, newPath) {
      if (oldPath.length !== newPath.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var i2 = 0; i2 < newPath.length - 1; i2++)
          if (oldPath[i2] !== newPath[i2]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
      }
    }
    function copyWithRenameImpl(obj, oldPath, newPath, index2) {
      var oldKey = oldPath[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      index2 + 1 === oldPath.length ? (updated[newPath[index2]] = updated[oldKey], isArrayImpl(updated) ? updated.splice(oldKey, 1) : delete updated[oldKey]) : updated[oldKey] = copyWithRenameImpl(
        obj[oldKey],
        oldPath,
        newPath,
        index2 + 1
      );
      return updated;
    }
    function copyWithDeleteImpl(obj, path, index2) {
      var key = path[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      if (index2 + 1 === path.length)
        return isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key], updated;
      updated[key] = copyWithDeleteImpl(obj[key], path, index2 + 1);
      return updated;
    }
    function shouldSuspendImpl() {
      return false;
    }
    function shouldErrorImpl() {
      return null;
    }
    function warnInvalidHookAccess() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function warnInvalidContextAccess() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function noop2() {
    }
    function warnForMissingKey() {
    }
    function setToSortedString(set2) {
      var array = [];
      set2.forEach(function(value) {
        array.push(value);
      });
      return array.sort().join(", ");
    }
    function createFiber(tag2, pendingProps, key, mode) {
      return new FiberNode(tag2, pendingProps, key, mode);
    }
    function scheduleRoot(root3, element2) {
      root3.context === emptyContextObject && (updateContainerImpl(root3.current, 2, element2, root3, null, null), flushSyncWork$1());
    }
    function scheduleRefresh(root3, update) {
      if (null !== resolveFamily) {
        var staleFamilies = update.staleFamilies;
        update = update.updatedFamilies;
        flushPendingEffects();
        scheduleFibersWithFamiliesRecursively(
          root3.current,
          update,
          staleFamilies
        );
        flushSyncWork$1();
      }
    }
    function setRefreshHandler(handler) {
      resolveFamily = handler;
    }
    function isValidContainer(node) {
      return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
    }
    function getNearestMountedFiber(fiber) {
      var node = fiber, nearestMounted = fiber;
      if (fiber.alternate) for (; node.return; ) node = node.return;
      else {
        fiber = node;
        do
          node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
      }
      return 3 === node.tag ? nearestMounted : null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
      if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
      }
      return null;
    }
    function getActivityInstanceFromFiber(fiber) {
      if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
      }
      return null;
    }
    function assertIsMounted(fiber) {
      if (getNearestMountedFiber(fiber) !== fiber)
        throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
      var alternate = fiber.alternate;
      if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate)
          throw Error("Unable to find node on an unmounted component.");
        return alternate !== fiber ? null : fiber;
      }
      for (var a = fiber, b2 = alternate; ; ) {
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
          b2 = parentA.return;
          if (null !== b2) {
            a = b2;
            continue;
          }
          break;
        }
        if (parentA.child === parentB.child) {
          for (parentB = parentA.child; parentB; ) {
            if (parentB === a) return assertIsMounted(parentA), fiber;
            if (parentB === b2) return assertIsMounted(parentA), alternate;
            parentB = parentB.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (a.return !== b2.return) a = parentA, b2 = parentB;
        else {
          for (var didFindChild = false, _child = parentA.child; _child; ) {
            if (_child === a) {
              didFindChild = true;
              a = parentA;
              b2 = parentB;
              break;
            }
            if (_child === b2) {
              didFindChild = true;
              b2 = parentA;
              a = parentB;
              break;
            }
            _child = _child.sibling;
          }
          if (!didFindChild) {
            for (_child = parentB.child; _child; ) {
              if (_child === a) {
                didFindChild = true;
                a = parentB;
                b2 = parentA;
                break;
              }
              if (_child === b2) {
                didFindChild = true;
                b2 = parentB;
                a = parentA;
                break;
              }
              _child = _child.sibling;
            }
            if (!didFindChild)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (a.alternate !== b2)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (3 !== a.tag)
        throw Error("Unable to find node on an unmounted component.");
      return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
      var tag2 = node.tag;
      if (5 === tag2 || 26 === tag2 || 27 === tag2 || 6 === tag2) return node;
      for (node = node.child; null !== node; ) {
        tag2 = findCurrentHostFiberImpl(node);
        if (null !== tag2) return tag2;
        node = node.sibling;
      }
      return null;
    }
    function getIteratorFn(maybeIterable) {
      if (null === maybeIterable || "object" !== typeof maybeIterable)
        return null;
      maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
      return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function getComponentNameFromOwner(owner) {
      return "number" === typeof owner.tag ? getComponentNameFromFiber(owner) : "string" === typeof owner.name ? owner.name : null;
    }
    function getComponentNameFromFiber(fiber) {
      var type = fiber.type;
      switch (fiber.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (type._context.displayName || "Context") + ".Consumer";
        case 10:
          return type.displayName || "Context";
        case 18:
          return "DehydratedFragment";
        case 11:
          return fiber = type.render, fiber = fiber.displayName || fiber.name || "", type.displayName || ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return type;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return getComponentNameFromType(type);
        case 8:
          return type === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if ("function" === typeof type)
            return type.displayName || type.name || null;
          if ("string" === typeof type) return type;
          break;
        case 29:
          type = fiber._debugInfo;
          if (null != type) {
            for (var i2 = type.length - 1; 0 <= i2; i2--)
              if ("string" === typeof type[i2].name) return type[i2].name;
          }
          if (null !== fiber.return)
            return getComponentNameFromFiber(fiber.return);
      }
      return null;
    }
    function createCursor(defaultValue2) {
      return { current: defaultValue2 };
    }
    function pop(cursor2, fiber) {
      0 > index$jscomp$0 ? console.error("Unexpected pop.") : (fiber !== fiberStack[index$jscomp$0] && console.error("Unexpected Fiber popped."), cursor2.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, fiberStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push2(cursor2, value, fiber) {
      index$jscomp$0++;
      valueStack[index$jscomp$0] = cursor2.current;
      fiberStack[index$jscomp$0] = fiber;
      cursor2.current = value;
    }
    function requiredContext(c2) {
      null === c2 && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      );
      return c2;
    }
    function pushHostContainer(fiber, nextRootInstance) {
      push2(rootInstanceStackCursor, nextRootInstance, fiber);
      push2(contextFiberStackCursor, fiber, fiber);
      push2(contextStackCursor, null, fiber);
      var nextRootContext = nextRootInstance.nodeType;
      switch (nextRootContext) {
        case 9:
        case 11:
          nextRootContext = 9 === nextRootContext ? "#document" : "#fragment";
          nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : HostContextNamespaceNone : HostContextNamespaceNone;
          break;
        default:
          if (nextRootContext = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI)
            nextRootInstance = getOwnHostContext(nextRootInstance), nextRootInstance = getChildHostContextProd(
              nextRootInstance,
              nextRootContext
            );
          else
            switch (nextRootContext) {
              case "svg":
                nextRootInstance = HostContextNamespaceSvg;
                break;
              case "math":
                nextRootInstance = HostContextNamespaceMath;
                break;
              default:
                nextRootInstance = HostContextNamespaceNone;
            }
      }
      nextRootContext = nextRootContext.toLowerCase();
      nextRootContext = updatedAncestorInfoDev(null, nextRootContext);
      nextRootContext = {
        context: nextRootInstance,
        ancestorInfo: nextRootContext
      };
      pop(contextStackCursor, fiber);
      push2(contextStackCursor, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
      pop(contextStackCursor, fiber);
      pop(contextFiberStackCursor, fiber);
      pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
      return requiredContext(contextStackCursor.current);
    }
    function pushHostContext(fiber) {
      null !== fiber.memoizedState && push2(hostTransitionProviderCursor, fiber, fiber);
      var context = requiredContext(contextStackCursor.current);
      var type = fiber.type;
      var nextContext = getChildHostContextProd(context.context, type);
      type = updatedAncestorInfoDev(context.ancestorInfo, type);
      nextContext = { context: nextContext, ancestorInfo: type };
      context !== nextContext && (push2(contextFiberStackCursor, fiber, fiber), push2(contextStackCursor, nextContext, fiber));
    }
    function popHostContext(fiber) {
      contextFiberStackCursor.current === fiber && (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
      hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor, fiber), HostTransitionContext._currentValue = NotPendingTransition);
    }
    function disabledLog() {
    }
    function disableLogs() {
      if (0 === disabledDepth) {
        prevLog = console.log;
        prevInfo = console.info;
        prevWarn = console.warn;
        prevError = console.error;
        prevGroup = console.group;
        prevGroupCollapsed = console.groupCollapsed;
        prevGroupEnd = console.groupEnd;
        var props2 = {
          configurable: true,
          enumerable: true,
          value: disabledLog,
          writable: true
        };
        Object.defineProperties(console, {
          info: props2,
          log: props2,
          warn: props2,
          error: props2,
          group: props2,
          groupCollapsed: props2,
          groupEnd: props2
        });
      }
      disabledDepth++;
    }
    function reenableLogs() {
      disabledDepth--;
      if (0 === disabledDepth) {
        var props2 = { configurable: true, enumerable: true, writable: true };
        Object.defineProperties(console, {
          log: assign2({}, props2, { value: prevLog }),
          info: assign2({}, props2, { value: prevInfo }),
          warn: assign2({}, props2, { value: prevWarn }),
          error: assign2({}, props2, { value: prevError }),
          group: assign2({}, props2, { value: prevGroup }),
          groupCollapsed: assign2({}, props2, { value: prevGroupCollapsed }),
          groupEnd: assign2({}, props2, { value: prevGroupEnd })
        });
      }
      0 > disabledDepth && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function formatOwnerStack(error) {
      var prevPrepareStackTrace = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      error = error.stack;
      Error.prepareStackTrace = prevPrepareStackTrace;
      error.startsWith("Error: react-stack-top-frame\n") && (error = error.slice(29));
      prevPrepareStackTrace = error.indexOf("\n");
      -1 !== prevPrepareStackTrace && (error = error.slice(prevPrepareStackTrace + 1));
      prevPrepareStackTrace = error.indexOf("react_stack_bottom_frame");
      -1 !== prevPrepareStackTrace && (prevPrepareStackTrace = error.lastIndexOf(
        "\n",
        prevPrepareStackTrace
      ));
      if (-1 !== prevPrepareStackTrace)
        error = error.slice(0, prevPrepareStackTrace);
      else return "";
      return error;
    }
    function describeBuiltInComponentFrame(name2) {
      if (void 0 === prefix)
        try {
          throw Error();
        } catch (x2) {
          var match2 = x2.stack.trim().match(/\n( *(at )?)/);
          prefix = match2 && match2[1] || "";
          suffix = -1 < x2.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x2.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return "\n" + prefix + name2 + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
      if (!fn || reentry) return "";
      var frame = componentFrameCache.get(fn);
      if (void 0 !== frame) return frame;
      reentry = true;
      frame = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var previousDispatcher2 = null;
      previousDispatcher2 = ReactSharedInternals.H;
      ReactSharedInternals.H = null;
      disableLogs();
      try {
        var RunInRootFrame = {
          DetermineComponentFrameRoot: function() {
            try {
              if (construct) {
                var Fake = function() {
                  throw Error();
                };
                Object.defineProperty(Fake.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                });
                if ("object" === typeof Reflect && Reflect.construct) {
                  try {
                    Reflect.construct(Fake, []);
                  } catch (x2) {
                    var control = x2;
                  }
                  Reflect.construct(fn, [], Fake);
                } else {
                  try {
                    Fake.call();
                  } catch (x$0) {
                    control = x$0;
                  }
                  fn.call(Fake.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (x$1) {
                  control = x$1;
                }
                (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {
                });
              }
            } catch (sample2) {
              if (sample2 && control && "string" === typeof sample2.stack)
                return [sample2.stack, control.stack];
            }
            return [null, null];
          }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(
          RunInRootFrame.DetermineComponentFrameRoot,
          "name"
        );
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
          RunInRootFrame.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
          var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
          for (_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes(
            "DetermineComponentFrameRoot"
          ); )
            namePropDescriptor++;
          for (; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes(
            "DetermineComponentFrameRoot"
          ); )
            _RunInRootFrame$Deter++;
          if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length)
            for (namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]; )
              _RunInRootFrame$Deter--;
          for (; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)
            if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
              if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                do
                  if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    var _frame = "\n" + sampleLines[namePropDescriptor].replace(
                      " at new ",
                      " at "
                    );
                    fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
                    "function" === typeof fn && componentFrameCache.set(fn, _frame);
                    return _frame;
                  }
                while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
              }
              break;
            }
        }
      } finally {
        reentry = false, ReactSharedInternals.H = previousDispatcher2, reenableLogs(), Error.prepareStackTrace = frame;
      }
      sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
      "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
      return sampleLines;
    }
    function describeFiber(fiber, childFiber) {
      switch (fiber.tag) {
        case 26:
        case 27:
        case 5:
          return describeBuiltInComponentFrame(fiber.type);
        case 16:
          return describeBuiltInComponentFrame("Lazy");
        case 13:
          return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
        case 19:
          return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
          return describeNativeComponentFrame(fiber.type, false);
        case 11:
          return describeNativeComponentFrame(fiber.type.render, false);
        case 1:
          return describeNativeComponentFrame(fiber.type, true);
        case 31:
          return describeBuiltInComponentFrame("Activity");
        default:
          return "";
      }
    }
    function getStackByFiberInDevAndProd(workInProgress2) {
      try {
        var info = "", previous2 = null;
        do {
          info += describeFiber(workInProgress2, previous2);
          var debugInfo = workInProgress2._debugInfo;
          if (debugInfo)
            for (var i2 = debugInfo.length - 1; 0 <= i2; i2--) {
              var entry = debugInfo[i2];
              if ("string" === typeof entry.name) {
                var JSCompiler_temp_const = info;
                a: {
                  var name2 = entry.name, env2 = entry.env, location = entry.debugLocation;
                  if (null != location) {
                    var childStack = formatOwnerStack(location), idx = childStack.lastIndexOf("\n"), lastLine = -1 === idx ? childStack : childStack.slice(idx + 1);
                    if (-1 !== lastLine.indexOf(name2)) {
                      var JSCompiler_inline_result = "\n" + lastLine;
                      break a;
                    }
                  }
                  JSCompiler_inline_result = describeBuiltInComponentFrame(
                    name2 + (env2 ? " [" + env2 + "]" : "")
                  );
                }
                info = JSCompiler_temp_const + JSCompiler_inline_result;
              }
            }
          previous2 = workInProgress2;
          workInProgress2 = workInProgress2.return;
        } while (workInProgress2);
        return info;
      } catch (x2) {
        return "\nError generating stack: " + x2.message + "\n" + x2.stack;
      }
    }
    function describeFunctionComponentFrameWithoutLineNumber(fn) {
      return (fn = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(fn) : "";
    }
    function getCurrentFiberOwnerNameInDevOrNull() {
      if (null === current2) return null;
      var owner = current2._debugOwner;
      return null != owner ? getComponentNameFromOwner(owner) : null;
    }
    function getCurrentFiberStackInDev() {
      if (null === current2) return "";
      var workInProgress2 = current2;
      try {
        var info = "";
        6 === workInProgress2.tag && (workInProgress2 = workInProgress2.return);
        switch (workInProgress2.tag) {
          case 26:
          case 27:
          case 5:
            info += describeBuiltInComponentFrame(workInProgress2.type);
            break;
          case 13:
            info += describeBuiltInComponentFrame("Suspense");
            break;
          case 19:
            info += describeBuiltInComponentFrame("SuspenseList");
            break;
          case 31:
            info += describeBuiltInComponentFrame("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            workInProgress2._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(
              workInProgress2.type
            ));
            break;
          case 11:
            workInProgress2._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(
              workInProgress2.type.render
            ));
        }
        for (; workInProgress2; )
          if ("number" === typeof workInProgress2.tag) {
            var fiber = workInProgress2;
            workInProgress2 = fiber._debugOwner;
            var debugStack = fiber._debugStack;
            if (workInProgress2 && debugStack) {
              var formattedStack = formatOwnerStack(debugStack);
              "" !== formattedStack && (info += "\n" + formattedStack);
            }
          } else if (null != workInProgress2.debugStack) {
            var ownerStack = workInProgress2.debugStack;
            (workInProgress2 = workInProgress2.owner) && ownerStack && (info += "\n" + formatOwnerStack(ownerStack));
          } else break;
        var JSCompiler_inline_result = info;
      } catch (x2) {
        JSCompiler_inline_result = "\nError generating stack: " + x2.message + "\n" + x2.stack;
      }
      return JSCompiler_inline_result;
    }
    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
      var previousFiber = current2;
      setCurrentFiber(fiber);
      try {
        return null !== fiber && fiber._debugTask ? fiber._debugTask.run(
          callback.bind(null, arg0, arg1, arg2, arg3, arg4)
        ) : callback(arg0, arg1, arg2, arg3, arg4);
      } finally {
        setCurrentFiber(previousFiber);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function setCurrentFiber(fiber) {
      ReactSharedInternals.getCurrentStack = null === fiber ? null : getCurrentFiberStackInDev;
      isRendering = false;
      current2 = fiber;
    }
    function typeName2(value) {
      return "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
    }
    function willCoercionThrow(value) {
      try {
        return testStringCoercion(value), false;
      } catch (e2) {
        return true;
      }
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
      if (willCoercionThrow(value))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          attributeName,
          typeName2(value)
        ), testStringCoercion(value);
    }
    function checkCSSPropertyStringCoercion(value, propName) {
      if (willCoercionThrow(value))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          propName,
          typeName2(value)
        ), testStringCoercion(value);
    }
    function checkFormFieldValueStringCoercion(value) {
      if (willCoercionThrow(value))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          typeName2(value)
        ), testStringCoercion(value);
    }
    function injectInternals(internals) {
      if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return false;
      var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (hook.isDisabled) return true;
      if (!hook.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), true;
      try {
        rendererID = hook.inject(internals), injectedHook = hook;
      } catch (err) {
        console.error("React instrumentation encountered an error: %o.", err);
      }
      return hook.checkDCE ? true : false;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
      "function" === typeof log$12 && unstable_setDisableYieldValue(newIsStrictMode);
      if (injectedHook && "function" === typeof injectedHook.setStrictMode)
        try {
          injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %o",
            err
          ));
        }
    }
    function clz32Fallback(x2) {
      x2 >>>= 0;
      return 0 === x2 ? 32 : 31 - (log3(x2) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
      var pendingSyncLanes = lanes & 42;
      if (0 !== pendingSyncLanes) return pendingSyncLanes;
      switch (lanes & -lanes) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
          return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return lanes & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), lanes;
      }
    }
    function getNextLanes(root3, wipLanes, rootHasPendingCommit) {
      var pendingLanes = root3.pendingLanes;
      if (0 === pendingLanes) return 0;
      var nextLanes = 0, suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes;
      root3 = root3.warmLanes;
      var nonIdlePendingLanes = pendingLanes & 134217727;
      0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root3, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root3, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
      return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root3, renderLanes2) {
      return 0 === (root3.pendingLanes & ~(root3.suspendedLanes & ~root3.pingedLanes) & renderLanes2);
    }
    function computeExpirationTime(lane, currentTime) {
      switch (lane) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function claimNextRetryLane() {
      var lane = nextRetryLane;
      nextRetryLane <<= 1;
      0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
      return lane;
    }
    function createLaneMap(initial2) {
      for (var laneMap = [], i2 = 0; 31 > i2; i2++) laneMap.push(initial2);
      return laneMap;
    }
    function markRootUpdated$1(root3, updateLane) {
      root3.pendingLanes |= updateLane;
      268435456 !== updateLane && (root3.suspendedLanes = 0, root3.pingedLanes = 0, root3.warmLanes = 0);
    }
    function markRootFinished(root3, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
      var previouslyPendingLanes = root3.pendingLanes;
      root3.pendingLanes = remainingLanes;
      root3.suspendedLanes = 0;
      root3.pingedLanes = 0;
      root3.warmLanes = 0;
      root3.expiredLanes &= remainingLanes;
      root3.entangledLanes &= remainingLanes;
      root3.errorRecoveryDisabledLanes &= remainingLanes;
      root3.shellSuspendCounter = 0;
      var entanglements = root3.entanglements, expirationTimes = root3.expirationTimes, hiddenUpdates = root3.hiddenUpdates;
      for (remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes; ) {
        var index2 = 31 - clz32(remainingLanes), lane = 1 << index2;
        entanglements[index2] = 0;
        expirationTimes[index2] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index2];
        if (null !== hiddenUpdatesForLane)
          for (hiddenUpdates[index2] = null, index2 = 0; index2 < hiddenUpdatesForLane.length; index2++) {
            var update = hiddenUpdatesForLane[index2];
            null !== update && (update.lane &= -536870913);
          }
        remainingLanes &= ~lane;
      }
      0 !== spawnedLane && markSpawnedDeferredLane(root3, spawnedLane, 0);
      0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root3.tag && (root3.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root3, spawnedLane, entangledLanes) {
      root3.pendingLanes |= spawnedLane;
      root3.suspendedLanes &= ~spawnedLane;
      var spawnedLaneIndex = 31 - clz32(spawnedLane);
      root3.entangledLanes |= spawnedLane;
      root3.entanglements[spawnedLaneIndex] = root3.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
    }
    function markRootEntangled(root3, entangledLanes) {
      var rootEntangledLanes = root3.entangledLanes |= entangledLanes;
      for (root3 = root3.entanglements; rootEntangledLanes; ) {
        var index2 = 31 - clz32(rootEntangledLanes), lane = 1 << index2;
        lane & entangledLanes | root3[index2] & entangledLanes && (root3[index2] |= entangledLanes);
        rootEntangledLanes &= ~lane;
      }
    }
    function getBumpedLaneForHydration(root3, renderLanes2) {
      var renderLane = renderLanes2 & -renderLanes2;
      renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
      return 0 !== (renderLane & (root3.suspendedLanes | renderLanes2)) ? 0 : renderLane;
    }
    function getBumpedLaneForHydrationByLane(lane) {
      switch (lane) {
        case 2:
          lane = 1;
          break;
        case 8:
          lane = 4;
          break;
        case 32:
          lane = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          lane = 128;
          break;
        case 268435456:
          lane = 134217728;
          break;
        default:
          lane = 0;
      }
      return lane;
    }
    function addFiberToLanesMap(root3, fiber, lanes) {
      if (isDevToolsPresent)
        for (root3 = root3.pendingUpdatersLaneMap; 0 < lanes; ) {
          var index2 = 31 - clz32(lanes), lane = 1 << index2;
          root3[index2].add(fiber);
          lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root3, lanes) {
      if (isDevToolsPresent)
        for (var pendingUpdatersLaneMap = root3.pendingUpdatersLaneMap, memoizedUpdaters = root3.memoizedUpdaters; 0 < lanes; ) {
          var index2 = 31 - clz32(lanes);
          root3 = 1 << index2;
          index2 = pendingUpdatersLaneMap[index2];
          0 < index2.size && (index2.forEach(function(fiber) {
            var alternate = fiber.alternate;
            null !== alternate && memoizedUpdaters.has(alternate) || memoizedUpdaters.add(fiber);
          }), index2.clear());
          lanes &= ~root3;
        }
    }
    function lanesToEventPriority(lanes) {
      lanes &= -lanes;
      return DiscreteEventPriority < lanes ? ContinuousEventPriority < lanes ? 0 !== (lanes & 134217727) ? DefaultEventPriority : IdleEventPriority : ContinuousEventPriority : DiscreteEventPriority;
    }
    function resolveUpdatePriority() {
      var updatePriority = ReactDOMSharedInternals.p;
      if (0 !== updatePriority) return updatePriority;
      updatePriority = window.event;
      return void 0 === updatePriority ? DefaultEventPriority : getEventPriority(updatePriority.type);
    }
    function runWithPriority(priority, fn) {
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        return ReactDOMSharedInternals.p = priority, fn();
      } finally {
        ReactDOMSharedInternals.p = previousPriority;
      }
    }
    function detachDeletedInstance(node) {
      delete node[internalInstanceKey];
      delete node[internalPropsKey];
      delete node[internalEventHandlersKey];
      delete node[internalEventHandlerListenersKey];
      delete node[internalEventHandlesSetKey];
    }
    function getClosestInstanceFromNode(targetNode) {
      var targetInst = targetNode[internalInstanceKey];
      if (targetInst) return targetInst;
      for (var parentNode = targetNode.parentNode; parentNode; ) {
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
          parentNode = targetInst.alternate;
          if (null !== targetInst.child || null !== parentNode && null !== parentNode.child)
            for (targetNode = getParentHydrationBoundary(targetNode); null !== targetNode; ) {
              if (parentNode = targetNode[internalInstanceKey])
                return parentNode;
              targetNode = getParentHydrationBoundary(targetNode);
            }
          return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
      }
      return null;
    }
    function getInstanceFromNode(node) {
      if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag2 = node.tag;
        if (5 === tag2 || 6 === tag2 || 13 === tag2 || 31 === tag2 || 26 === tag2 || 27 === tag2 || 3 === tag2)
          return node;
      }
      return null;
    }
    function getNodeFromInstance(inst) {
      var tag2 = inst.tag;
      if (5 === tag2 || 26 === tag2 || 27 === tag2 || 6 === tag2)
        return inst.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getResourcesFromRoot(root3) {
      var resources = root3[internalRootNodeResourcesKey];
      resources || (resources = root3[internalRootNodeResourcesKey] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() });
      return resources;
    }
    function markNodeAsHoistable(node) {
      node[internalHoistableMarker] = true;
    }
    function registerTwoPhaseEvent(registrationName, dependencies2) {
      registerDirectEvent(registrationName, dependencies2);
      registerDirectEvent(registrationName + "Capture", dependencies2);
    }
    function registerDirectEvent(registrationName, dependencies2) {
      registrationNameDependencies[registrationName] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        registrationName
      );
      registrationNameDependencies[registrationName] = dependencies2;
      var lowerCasedName = registrationName.toLowerCase();
      possibleRegistrationNames[lowerCasedName] = registrationName;
      "onDoubleClick" === registrationName && (possibleRegistrationNames.ondblclick = registrationName);
      for (registrationName = 0; registrationName < dependencies2.length; registrationName++)
        allNativeEvents.add(dependencies2[registrationName]);
    }
    function checkControlledValueProps(tagName, props2) {
      hasReadOnlyValue[props2.type] || props2.onChange || props2.onInput || props2.readOnly || props2.disabled || null == props2.value || ("select" === tagName ? console.error(
        "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`."
      ) : console.error(
        "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ));
      props2.onChange || props2.readOnly || props2.disabled || null == props2.checked || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function isAttributeNameSafe(attributeName) {
      if (hasOwnProperty2.call(validatedAttributeNameCache, attributeName))
        return true;
      if (hasOwnProperty2.call(illegalAttributeNameCache, attributeName))
        return false;
      if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
        return validatedAttributeNameCache[attributeName] = true;
      illegalAttributeNameCache[attributeName] = true;
      console.error("Invalid attribute name: `%s`", attributeName);
      return false;
    }
    function getValueForAttributeOnCustomComponent(node, name2, expected) {
      if (isAttributeNameSafe(name2)) {
        if (!node.hasAttribute(name2)) {
          switch (typeof expected) {
            case "symbol":
            case "object":
              return expected;
            case "function":
              return expected;
            case "boolean":
              if (false === expected) return expected;
          }
          return void 0 === expected ? void 0 : null;
        }
        node = node.getAttribute(name2);
        if ("" === node && true === expected) return true;
        checkAttributeStringCoercion(expected, name2);
        return node === "" + expected ? expected : node;
      }
    }
    function setValueForAttribute(node, name2, value) {
      if (isAttributeNameSafe(name2))
        if (null === value) node.removeAttribute(name2);
        else {
          switch (typeof value) {
            case "undefined":
            case "function":
            case "symbol":
              node.removeAttribute(name2);
              return;
            case "boolean":
              var prefix2 = name2.toLowerCase().slice(0, 5);
              if ("data-" !== prefix2 && "aria-" !== prefix2) {
                node.removeAttribute(name2);
                return;
              }
          }
          checkAttributeStringCoercion(value, name2);
          node.setAttribute(name2, "" + value);
        }
    }
    function setValueForKnownAttribute(node, name2, value) {
      if (null === value) node.removeAttribute(name2);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            node.removeAttribute(name2);
            return;
        }
        checkAttributeStringCoercion(value, name2);
        node.setAttribute(name2, "" + value);
      }
    }
    function setValueForNamespacedAttribute(node, namespace, name2, value) {
      if (null === value) node.removeAttribute(name2);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            node.removeAttribute(name2);
            return;
        }
        checkAttributeStringCoercion(value, name2);
        node.setAttributeNS(namespace, name2, "" + value);
      }
    }
    function getToStringValue(value) {
      switch (typeof value) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return value;
        case "object":
          return checkFormFieldValueStringCoercion(value), value;
        default:
          return "";
      }
    }
    function isCheckable(elem) {
      var type = elem.type;
      return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
    }
    function trackValueOnNode(node, valueField, currentValue) {
      var descriptor = Object.getOwnPropertyDescriptor(
        node.constructor.prototype,
        valueField
      );
      if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get2 = descriptor.get, set2 = descriptor.set;
        Object.defineProperty(node, valueField, {
          configurable: true,
          get: function() {
            return get2.call(this);
          },
          set: function(value) {
            checkFormFieldValueStringCoercion(value);
            currentValue = "" + value;
            set2.call(this, value);
          }
        });
        Object.defineProperty(node, valueField, {
          enumerable: descriptor.enumerable
        });
        return {
          getValue: function() {
            return currentValue;
          },
          setValue: function(value) {
            checkFormFieldValueStringCoercion(value);
            currentValue = "" + value;
          },
          stopTracking: function() {
            node._valueTracker = null;
            delete node[valueField];
          }
        };
      }
    }
    function track(node) {
      if (!node._valueTracker) {
        var valueField = isCheckable(node) ? "checked" : "value";
        node._valueTracker = trackValueOnNode(
          node,
          valueField,
          "" + node[valueField]
        );
      }
    }
    function updateValueIfChanged(node) {
      if (!node) return false;
      var tracker = node._valueTracker;
      if (!tracker) return true;
      var lastValue = tracker.getValue();
      var value = "";
      node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
      node = value;
      return node !== lastValue ? (tracker.setValue(node), true) : false;
    }
    function getActiveElement2(doc2) {
      doc2 = doc2 || ("undefined" !== typeof document ? document : void 0);
      if ("undefined" === typeof doc2) return null;
      try {
        return doc2.activeElement || doc2.body;
      } catch (e2) {
        return doc2.body;
      }
    }
    function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
      return value.replace(
        escapeSelectorAttributeValueInsideDoubleQuotesRegex,
        function(ch) {
          return "\\" + ch.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function validateInputProps(element2, props2) {
      void 0 === props2.checked || void 0 === props2.defaultChecked || didWarnCheckedDefaultChecked || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component",
        props2.type
      ), didWarnCheckedDefaultChecked = true);
      void 0 === props2.value || void 0 === props2.defaultValue || didWarnValueDefaultValue$1 || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component",
        props2.type
      ), didWarnValueDefaultValue$1 = true);
    }
    function updateInput(element2, value, defaultValue2, lastDefaultValue, checked, defaultChecked, type, name2) {
      element2.name = "";
      null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? (checkAttributeStringCoercion(type, "type"), element2.type = type) : element2.removeAttribute("type");
      if (null != value)
        if ("number" === type) {
          if (0 === value && "" === element2.value || element2.value != value)
            element2.value = "" + getToStringValue(value);
        } else
          element2.value !== "" + getToStringValue(value) && (element2.value = "" + getToStringValue(value));
      else
        "submit" !== type && "reset" !== type || element2.removeAttribute("value");
      null != value ? setDefaultValue(element2, type, getToStringValue(value)) : null != defaultValue2 ? setDefaultValue(element2, type, getToStringValue(defaultValue2)) : null != lastDefaultValue && element2.removeAttribute("value");
      null == checked && null != defaultChecked && (element2.defaultChecked = !!defaultChecked);
      null != checked && (element2.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
      null != name2 && "function" !== typeof name2 && "symbol" !== typeof name2 && "boolean" !== typeof name2 ? (checkAttributeStringCoercion(name2, "name"), element2.name = "" + getToStringValue(name2)) : element2.removeAttribute("name");
    }
    function initInput(element2, value, defaultValue2, checked, defaultChecked, type, name2, isHydrating2) {
      null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (checkAttributeStringCoercion(type, "type"), element2.type = type);
      if (null != value || null != defaultValue2) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
          track(element2);
          return;
        }
        defaultValue2 = null != defaultValue2 ? "" + getToStringValue(defaultValue2) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue2;
        isHydrating2 || value === element2.value || (element2.value = value);
        element2.defaultValue = value;
      }
      checked = null != checked ? checked : defaultChecked;
      checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
      element2.checked = isHydrating2 ? element2.checked : !!checked;
      element2.defaultChecked = !!checked;
      null != name2 && "function" !== typeof name2 && "symbol" !== typeof name2 && "boolean" !== typeof name2 && (checkAttributeStringCoercion(name2, "name"), element2.name = name2);
      track(element2);
    }
    function setDefaultValue(node, type, value) {
      "number" === type && getActiveElement2(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
    }
    function validateOptionProps(element2, props2) {
      null == props2.value && ("object" === typeof props2.children && null !== props2.children ? React2.Children.forEach(props2.children, function(child) {
        null == child || "string" === typeof child || "number" === typeof child || "bigint" === typeof child || didWarnInvalidChild || (didWarnInvalidChild = true, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : null == props2.dangerouslySetInnerHTML || didWarnInvalidInnerHTML || (didWarnInvalidInnerHTML = true, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      )));
      null == props2.selected || didWarnSelectedSetOnOption || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), didWarnSelectedSetOnOption = true);
    }
    function getDeclarationErrorAddendum() {
      var ownerName = getCurrentFiberOwnerNameInDevOrNull();
      return ownerName ? "\n\nCheck the render method of `" + ownerName + "`." : "";
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
      node = node.options;
      if (multiple) {
        multiple = {};
        for (var i2 = 0; i2 < propValue.length; i2++)
          multiple["$" + propValue[i2]] = true;
        for (propValue = 0; propValue < node.length; propValue++)
          i2 = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i2 && (node[propValue].selected = i2), i2 && setDefaultSelected && (node[propValue].defaultSelected = true);
      } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for (i2 = 0; i2 < node.length; i2++) {
          if (node[i2].value === propValue) {
            node[i2].selected = true;
            setDefaultSelected && (node[i2].defaultSelected = true);
            return;
          }
          null !== multiple || node[i2].disabled || (multiple = node[i2]);
        }
        null !== multiple && (multiple.selected = true);
      }
    }
    function validateSelectProps(element2, props2) {
      for (element2 = 0; element2 < valuePropNames.length; element2++) {
        var propName = valuePropNames[element2];
        if (null != props2[propName]) {
          var propNameIsArray = isArrayImpl(props2[propName]);
          props2.multiple && !propNameIsArray ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            propName,
            getDeclarationErrorAddendum()
          ) : !props2.multiple && propNameIsArray && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            propName,
            getDeclarationErrorAddendum()
          );
        }
      }
      void 0 === props2.value || void 0 === props2.defaultValue || didWarnValueDefaultValue || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), didWarnValueDefaultValue = true);
    }
    function validateTextareaProps(element2, props2) {
      void 0 === props2.value || void 0 === props2.defaultValue || didWarnValDefaultVal || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component"
      ), didWarnValDefaultVal = true);
      null != props2.children && null == props2.value && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function updateTextarea(element2, value, defaultValue2) {
      if (null != value && (value = "" + getToStringValue(value), value !== element2.value && (element2.value = value), null == defaultValue2)) {
        element2.defaultValue !== value && (element2.defaultValue = value);
        return;
      }
      element2.defaultValue = null != defaultValue2 ? "" + getToStringValue(defaultValue2) : "";
    }
    function initTextarea(element2, value, defaultValue2, children) {
      if (null == value) {
        if (null != children) {
          if (null != defaultValue2)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (isArrayImpl(children)) {
            if (1 < children.length)
              throw Error("<textarea> can only have at most one child.");
            children = children[0];
          }
          defaultValue2 = children;
        }
        null == defaultValue2 && (defaultValue2 = "");
        value = defaultValue2;
      }
      defaultValue2 = getToStringValue(value);
      element2.defaultValue = defaultValue2;
      children = element2.textContent;
      children === defaultValue2 && "" !== children && null !== children && (element2.value = children);
      track(element2);
    }
    function findNotableNode(node, indent2) {
      return void 0 === node.serverProps && 0 === node.serverTail.length && 1 === node.children.length && 3 < node.distanceFromLeaf && node.distanceFromLeaf > 15 - indent2 ? findNotableNode(node.children[0], indent2) : node;
    }
    function indentation(indent2) {
      return "  " + "  ".repeat(indent2);
    }
    function added(indent2) {
      return "+ " + "  ".repeat(indent2);
    }
    function removed(indent2) {
      return "- " + "  ".repeat(indent2);
    }
    function describeFiberType(fiber) {
      switch (fiber.tag) {
        case 26:
        case 27:
        case 5:
          return fiber.type;
        case 16:
          return "Lazy";
        case 31:
          return "Activity";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return fiber = fiber.type, fiber.displayName || fiber.name || null;
        case 11:
          return fiber = fiber.type.render, fiber.displayName || fiber.name || null;
        case 1:
          return fiber = fiber.type, fiber.displayName || fiber.name || null;
        default:
          return null;
      }
    }
    function describeTextNode(content2, maxLength) {
      return needsEscaping.test(content2) ? (content2 = JSON.stringify(content2), content2.length > maxLength - 2 ? 8 > maxLength ? '{"..."}' : "{" + content2.slice(0, maxLength - 7) + '..."}' : "{" + content2 + "}") : content2.length > maxLength ? 5 > maxLength ? '{"..."}' : content2.slice(0, maxLength - 3) + "..." : content2;
    }
    function describeTextDiff(clientText, serverProps, indent2) {
      var maxLength = 120 - 2 * indent2;
      if (null === serverProps)
        return added(indent2) + describeTextNode(clientText, maxLength) + "\n";
      if ("string" === typeof serverProps) {
        for (var firstDiff = 0; firstDiff < serverProps.length && firstDiff < clientText.length && serverProps.charCodeAt(firstDiff) === clientText.charCodeAt(firstDiff); firstDiff++) ;
        firstDiff > maxLength - 8 && 10 < firstDiff && (clientText = "..." + clientText.slice(firstDiff - 8), serverProps = "..." + serverProps.slice(firstDiff - 8));
        return added(indent2) + describeTextNode(clientText, maxLength) + "\n" + removed(indent2) + describeTextNode(serverProps, maxLength) + "\n";
      }
      return indentation(indent2) + describeTextNode(clientText, maxLength) + "\n";
    }
    function objectName(object2) {
      return Object.prototype.toString.call(object2).replace(/^\[object (.*)\]$/, function(m, p0) {
        return p0;
      });
    }
    function describeValue(value, maxLength) {
      switch (typeof value) {
        case "string":
          return value = JSON.stringify(value), value.length > maxLength ? 5 > maxLength ? '"..."' : value.slice(0, maxLength - 4) + '..."' : value;
        case "object":
          if (null === value) return "null";
          if (isArrayImpl(value)) return "[...]";
          if (value.$$typeof === REACT_ELEMENT_TYPE)
            return (maxLength = getComponentNameFromType(value.type)) ? "<" + maxLength + ">" : "<...>";
          var name2 = objectName(value);
          if ("Object" === name2) {
            name2 = "";
            maxLength -= 2;
            for (var propName in value)
              if (value.hasOwnProperty(propName)) {
                var jsonPropName = JSON.stringify(propName);
                jsonPropName !== '"' + propName + '"' && (propName = jsonPropName);
                maxLength -= propName.length - 2;
                jsonPropName = describeValue(
                  value[propName],
                  15 > maxLength ? maxLength : 15
                );
                maxLength -= jsonPropName.length;
                if (0 > maxLength) {
                  name2 += "" === name2 ? "..." : ", ...";
                  break;
                }
                name2 += ("" === name2 ? "" : ",") + propName + ":" + jsonPropName;
              }
            return "{" + name2 + "}";
          }
          return name2;
        case "function":
          return (maxLength = value.displayName || value.name) ? "function " + maxLength : "function";
        default:
          return String(value);
      }
    }
    function describePropValue(value, maxLength) {
      return "string" !== typeof value || needsEscaping.test(value) ? "{" + describeValue(value, maxLength - 2) + "}" : value.length > maxLength - 2 ? 5 > maxLength ? '"..."' : '"' + value.slice(0, maxLength - 5) + '..."' : '"' + value + '"';
    }
    function describeExpandedElement(type, props2, rowPrefix) {
      var remainingRowLength = 120 - rowPrefix.length - type.length, properties2 = [], propName;
      for (propName in props2)
        if (props2.hasOwnProperty(propName) && "children" !== propName) {
          var propValue = describePropValue(
            props2[propName],
            120 - rowPrefix.length - propName.length - 1
          );
          remainingRowLength -= propName.length + propValue.length + 2;
          properties2.push(propName + "=" + propValue);
        }
      return 0 === properties2.length ? rowPrefix + "<" + type + ">\n" : 0 < remainingRowLength ? rowPrefix + "<" + type + " " + properties2.join(" ") + ">\n" : rowPrefix + "<" + type + "\n" + rowPrefix + "  " + properties2.join("\n" + rowPrefix + "  ") + "\n" + rowPrefix + ">\n";
    }
    function describePropertiesDiff(clientObject, serverObject, indent2) {
      var properties2 = "", remainingServerProperties = assign2({}, serverObject), propName;
      for (propName in clientObject)
        if (clientObject.hasOwnProperty(propName)) {
          delete remainingServerProperties[propName];
          var maxLength = 120 - 2 * indent2 - propName.length - 2, clientPropValue = describeValue(clientObject[propName], maxLength);
          serverObject.hasOwnProperty(propName) ? (maxLength = describeValue(serverObject[propName], maxLength), properties2 += added(indent2) + propName + ": " + clientPropValue + "\n", properties2 += removed(indent2) + propName + ": " + maxLength + "\n") : properties2 += added(indent2) + propName + ": " + clientPropValue + "\n";
        }
      for (var _propName in remainingServerProperties)
        remainingServerProperties.hasOwnProperty(_propName) && (clientObject = describeValue(
          remainingServerProperties[_propName],
          120 - 2 * indent2 - _propName.length - 2
        ), properties2 += removed(indent2) + _propName + ": " + clientObject + "\n");
      return properties2;
    }
    function describeElementDiff(type, clientProps, serverProps, indent2) {
      var content2 = "", serverPropNames = /* @__PURE__ */ new Map();
      for (propName$jscomp$0 in serverProps)
        serverProps.hasOwnProperty(propName$jscomp$0) && serverPropNames.set(
          propName$jscomp$0.toLowerCase(),
          propName$jscomp$0
        );
      if (1 === serverPropNames.size && serverPropNames.has("children"))
        content2 += describeExpandedElement(
          type,
          clientProps,
          indentation(indent2)
        );
      else {
        for (var _propName2 in clientProps)
          if (clientProps.hasOwnProperty(_propName2) && "children" !== _propName2) {
            var maxLength$jscomp$0 = 120 - 2 * (indent2 + 1) - _propName2.length - 1, serverPropName = serverPropNames.get(_propName2.toLowerCase());
            if (void 0 !== serverPropName) {
              serverPropNames.delete(_propName2.toLowerCase());
              var propName$jscomp$0 = clientProps[_propName2];
              serverPropName = serverProps[serverPropName];
              var clientPropValue = describePropValue(
                propName$jscomp$0,
                maxLength$jscomp$0
              );
              maxLength$jscomp$0 = describePropValue(
                serverPropName,
                maxLength$jscomp$0
              );
              "object" === typeof propName$jscomp$0 && null !== propName$jscomp$0 && "object" === typeof serverPropName && null !== serverPropName && "Object" === objectName(propName$jscomp$0) && "Object" === objectName(serverPropName) && (2 < Object.keys(propName$jscomp$0).length || 2 < Object.keys(serverPropName).length || -1 < clientPropValue.indexOf("...") || -1 < maxLength$jscomp$0.indexOf("...")) ? content2 += indentation(indent2 + 1) + _propName2 + "={{\n" + describePropertiesDiff(
                propName$jscomp$0,
                serverPropName,
                indent2 + 2
              ) + indentation(indent2 + 1) + "}}\n" : (content2 += added(indent2 + 1) + _propName2 + "=" + clientPropValue + "\n", content2 += removed(indent2 + 1) + _propName2 + "=" + maxLength$jscomp$0 + "\n");
            } else
              content2 += indentation(indent2 + 1) + _propName2 + "=" + describePropValue(clientProps[_propName2], maxLength$jscomp$0) + "\n";
          }
        serverPropNames.forEach(function(propName) {
          if ("children" !== propName) {
            var maxLength = 120 - 2 * (indent2 + 1) - propName.length - 1;
            content2 += removed(indent2 + 1) + propName + "=" + describePropValue(serverProps[propName], maxLength) + "\n";
          }
        });
        content2 = "" === content2 ? indentation(indent2) + "<" + type + ">\n" : indentation(indent2) + "<" + type + "\n" + content2 + indentation(indent2) + ">\n";
      }
      type = serverProps.children;
      clientProps = clientProps.children;
      if ("string" === typeof type || "number" === typeof type || "bigint" === typeof type) {
        serverPropNames = "";
        if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps)
          serverPropNames = "" + clientProps;
        content2 += describeTextDiff(serverPropNames, "" + type, indent2 + 1);
      } else if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps)
        content2 = null == type ? content2 + describeTextDiff("" + clientProps, null, indent2 + 1) : content2 + describeTextDiff("" + clientProps, void 0, indent2 + 1);
      return content2;
    }
    function describeSiblingFiber(fiber, indent2) {
      var type = describeFiberType(fiber);
      if (null === type) {
        type = "";
        for (fiber = fiber.child; fiber; )
          type += describeSiblingFiber(fiber, indent2), fiber = fiber.sibling;
        return type;
      }
      return indentation(indent2) + "<" + type + ">\n";
    }
    function describeNode(node, indent2) {
      var skipToNode = findNotableNode(node, indent2);
      if (skipToNode !== node && (1 !== node.children.length || node.children[0] !== skipToNode))
        return indentation(indent2) + "...\n" + describeNode(skipToNode, indent2 + 1);
      skipToNode = "";
      var debugInfo = node.fiber._debugInfo;
      if (debugInfo)
        for (var i2 = 0; i2 < debugInfo.length; i2++) {
          var serverComponentName = debugInfo[i2].name;
          "string" === typeof serverComponentName && (skipToNode += indentation(indent2) + "<" + serverComponentName + ">\n", indent2++);
        }
      debugInfo = "";
      i2 = node.fiber.pendingProps;
      if (6 === node.fiber.tag)
        debugInfo = describeTextDiff(i2, node.serverProps, indent2), indent2++;
      else if (serverComponentName = describeFiberType(node.fiber), null !== serverComponentName)
        if (void 0 === node.serverProps) {
          debugInfo = indent2;
          var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2, content2 = "";
          for (propName in i2)
            if (i2.hasOwnProperty(propName) && "children" !== propName) {
              var propValue = describePropValue(i2[propName], 15);
              maxLength -= propName.length + propValue.length + 2;
              if (0 > maxLength) {
                content2 += " ...";
                break;
              }
              content2 += " " + propName + "=" + propValue;
            }
          debugInfo = indentation(debugInfo) + "<" + serverComponentName + content2 + ">\n";
          indent2++;
        } else
          null === node.serverProps ? (debugInfo = describeExpandedElement(
            serverComponentName,
            i2,
            added(indent2)
          ), indent2++) : "string" === typeof node.serverProps ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (debugInfo = describeElementDiff(
            serverComponentName,
            i2,
            node.serverProps,
            indent2
          ), indent2++);
      var propName = "";
      i2 = node.fiber.child;
      for (serverComponentName = 0; i2 && serverComponentName < node.children.length; )
        maxLength = node.children[serverComponentName], maxLength.fiber === i2 ? (propName += describeNode(maxLength, indent2), serverComponentName++) : propName += describeSiblingFiber(i2, indent2), i2 = i2.sibling;
      i2 && 0 < node.children.length && (propName += indentation(indent2) + "...\n");
      i2 = node.serverTail;
      null === node.serverProps && indent2--;
      for (node = 0; node < i2.length; node++)
        serverComponentName = i2[node], propName = "string" === typeof serverComponentName ? propName + (removed(indent2) + describeTextNode(serverComponentName, 120 - 2 * indent2) + "\n") : propName + describeExpandedElement(
          serverComponentName.type,
          serverComponentName.props,
          removed(indent2)
        );
      return skipToNode + debugInfo + propName;
    }
    function describeDiff(rootNode) {
      try {
        return "\n\n" + describeNode(rootNode, 0);
      } catch (x2) {
        return "";
      }
    }
    function describeAncestors(ancestor, child, props2) {
      for (var fiber = child, node = null, distanceFromLeaf = 0; fiber; )
        fiber === ancestor && (distanceFromLeaf = 0), node = {
          fiber,
          children: null !== node ? [node] : [],
          serverProps: fiber === child ? props2 : fiber === ancestor ? null : void 0,
          serverTail: [],
          distanceFromLeaf
        }, distanceFromLeaf++, fiber = fiber.return;
      return null !== node ? describeDiff(node).replaceAll(/^[+-]/gm, ">") : "";
    }
    function updatedAncestorInfoDev(oldInfo, tag2) {
      var ancestorInfo = assign2({}, oldInfo || emptyAncestorInfoDev), info = { tag: tag2 };
      -1 !== inScopeTags.indexOf(tag2) && (ancestorInfo.aTagInScope = null, ancestorInfo.buttonTagInScope = null, ancestorInfo.nobrTagInScope = null);
      -1 !== buttonScopeTags.indexOf(tag2) && (ancestorInfo.pTagInButtonScope = null);
      -1 !== specialTags.indexOf(tag2) && "address" !== tag2 && "div" !== tag2 && "p" !== tag2 && (ancestorInfo.listItemTagAutoclosing = null, ancestorInfo.dlItemTagAutoclosing = null);
      ancestorInfo.current = info;
      "form" === tag2 && (ancestorInfo.formTag = info);
      "a" === tag2 && (ancestorInfo.aTagInScope = info);
      "button" === tag2 && (ancestorInfo.buttonTagInScope = info);
      "nobr" === tag2 && (ancestorInfo.nobrTagInScope = info);
      "p" === tag2 && (ancestorInfo.pTagInButtonScope = info);
      "li" === tag2 && (ancestorInfo.listItemTagAutoclosing = info);
      if ("dd" === tag2 || "dt" === tag2)
        ancestorInfo.dlItemTagAutoclosing = info;
      "#document" === tag2 || "html" === tag2 ? ancestorInfo.containerTagInScope = null : ancestorInfo.containerTagInScope || (ancestorInfo.containerTagInScope = info);
      null !== oldInfo || "#document" !== tag2 && "html" !== tag2 && "body" !== tag2 ? true === ancestorInfo.implicitRootScope && (ancestorInfo.implicitRootScope = false) : ancestorInfo.implicitRootScope = true;
      return ancestorInfo;
    }
    function isTagValidWithParent(tag2, parentTag, implicitRootScope) {
      switch (parentTag) {
        case "select":
          return "hr" === tag2 || "option" === tag2 || "optgroup" === tag2 || "script" === tag2 || "template" === tag2 || "#text" === tag2;
        case "optgroup":
          return "option" === tag2 || "#text" === tag2;
        case "option":
          return "#text" === tag2;
        case "tr":
          return "th" === tag2 || "td" === tag2 || "style" === tag2 || "script" === tag2 || "template" === tag2;
        case "tbody":
        case "thead":
        case "tfoot":
          return "tr" === tag2 || "style" === tag2 || "script" === tag2 || "template" === tag2;
        case "colgroup":
          return "col" === tag2 || "template" === tag2;
        case "table":
          return "caption" === tag2 || "colgroup" === tag2 || "tbody" === tag2 || "tfoot" === tag2 || "thead" === tag2 || "style" === tag2 || "script" === tag2 || "template" === tag2;
        case "head":
          return "base" === tag2 || "basefont" === tag2 || "bgsound" === tag2 || "link" === tag2 || "meta" === tag2 || "title" === tag2 || "noscript" === tag2 || "noframes" === tag2 || "style" === tag2 || "script" === tag2 || "template" === tag2;
        case "html":
          if (implicitRootScope) break;
          return "head" === tag2 || "body" === tag2 || "frameset" === tag2;
        case "frameset":
          return "frame" === tag2;
        case "#document":
          if (!implicitRootScope) return "html" === tag2;
      }
      switch (tag2) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return "h1" !== parentTag && "h2" !== parentTag && "h3" !== parentTag && "h4" !== parentTag && "h5" !== parentTag && "h6" !== parentTag;
        case "rp":
        case "rt":
          return -1 === impliedEndTags.indexOf(parentTag);
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return null == parentTag;
        case "head":
          return implicitRootScope || null === parentTag;
        case "html":
          return implicitRootScope && "#document" === parentTag || null === parentTag;
        case "body":
          return implicitRootScope && ("#document" === parentTag || "html" === parentTag) || null === parentTag;
      }
      return true;
    }
    function findInvalidAncestorForTag(tag2, ancestorInfo) {
      switch (tag2) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return ancestorInfo.pTagInButtonScope;
        case "form":
          return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
        case "li":
          return ancestorInfo.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return ancestorInfo.dlItemTagAutoclosing;
        case "button":
          return ancestorInfo.buttonTagInScope;
        case "a":
          return ancestorInfo.aTagInScope;
        case "nobr":
          return ancestorInfo.nobrTagInScope;
      }
      return null;
    }
    function findAncestor(parent, tagName) {
      for (; parent; ) {
        switch (parent.tag) {
          case 5:
          case 26:
          case 27:
            if (parent.type === tagName) return parent;
        }
        parent = parent.return;
      }
      return null;
    }
    function validateDOMNesting(childTag, ancestorInfo) {
      ancestorInfo = ancestorInfo || emptyAncestorInfoDev;
      var parentInfo = ancestorInfo.current;
      ancestorInfo = (parentInfo = isTagValidWithParent(
        childTag,
        parentInfo && parentInfo.tag,
        ancestorInfo.implicitRootScope
      ) ? null : parentInfo) ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
      ancestorInfo = parentInfo || ancestorInfo;
      if (!ancestorInfo) return true;
      var ancestorTag = ancestorInfo.tag;
      ancestorInfo = String(!!parentInfo) + "|" + childTag + "|" + ancestorTag;
      if (didWarn[ancestorInfo]) return false;
      didWarn[ancestorInfo] = true;
      var ancestor = (ancestorInfo = current2) ? findAncestor(ancestorInfo.return, ancestorTag) : null, ancestorDescription = null !== ancestorInfo && null !== ancestor ? describeAncestors(ancestor, ancestorInfo, null) : "", tagDisplayName = "<" + childTag + ">";
      parentInfo ? (parentInfo = "", "table" === ancestorTag && "tr" === childTag && (parentInfo += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        "In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s",
        tagDisplayName,
        ancestorTag,
        parentInfo,
        ancestorDescription
      )) : console.error(
        "In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s",
        tagDisplayName,
        ancestorTag,
        ancestorDescription
      );
      ancestorInfo && (childTag = ancestorInfo.return, null === ancestor || null === childTag || ancestor === childTag && childTag._debugOwner === ancestorInfo._debugOwner || runWithFiberInDEV(ancestor, function() {
        console.error(
          "<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.",
          ancestorTag,
          tagDisplayName
        );
      }));
      return false;
    }
    function validateTextNesting(childText, parentTag, implicitRootScope) {
      if (implicitRootScope || isTagValidWithParent("#text", parentTag, false))
        return true;
      implicitRootScope = "#text|" + parentTag;
      if (didWarn[implicitRootScope]) return false;
      didWarn[implicitRootScope] = true;
      var ancestor = (implicitRootScope = current2) ? findAncestor(implicitRootScope, parentTag) : null;
      implicitRootScope = null !== implicitRootScope && null !== ancestor ? describeAncestors(
        ancestor,
        implicitRootScope,
        6 !== implicitRootScope.tag ? { children: null } : null
      ) : "";
      /\S/.test(childText) ? console.error(
        "In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s",
        parentTag,
        implicitRootScope
      ) : console.error(
        "In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s",
        parentTag,
        implicitRootScope
      );
      return false;
    }
    function setTextContent(node, text2) {
      if (text2) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
          firstChild.nodeValue = text2;
          return;
        }
      }
      node.textContent = text2;
    }
    function camelize(string2) {
      return string2.replace(hyphenPattern, function(_2, character) {
        return character.toUpperCase();
      });
    }
    function setValueForStyle(style2, styleName, value) {
      var isCustomProperty = 0 === styleName.indexOf("--");
      isCustomProperty || (-1 < styleName.indexOf("-") ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = true, console.error(
        "Unsupported style property %s. Did you mean %s?",
        styleName,
        camelize(styleName.replace(msPattern, "ms-"))
      )) : badVendoredStyleNamePattern.test(styleName) ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = true, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        styleName,
        styleName.charAt(0).toUpperCase() + styleName.slice(1)
      )) : !badStyleValueWithSemicolonPattern.test(value) || warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value] || (warnedStyleValues[value] = true, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        styleName,
        value.replace(badStyleValueWithSemicolonPattern, "")
      )), "number" === typeof value && (isNaN(value) ? warnedForNaNValue || (warnedForNaNValue = true, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        styleName
      )) : isFinite(value) || warnedForInfinityValue || (warnedForInfinityValue = true, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        styleName
      ))));
      null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style2.setProperty(styleName, "") : "float" === styleName ? style2.cssFloat = "" : style2[styleName] = "" : isCustomProperty ? style2.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style2.cssFloat = value : (checkCSSPropertyStringCoercion(value, styleName), style2[styleName] = ("" + value).trim()) : style2[styleName] = value + "px";
    }
    function setValueForStyles(node, styles, prevStyles) {
      if (null != styles && "object" !== typeof styles)
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      styles && Object.freeze(styles);
      node = node.style;
      if (null != prevStyles) {
        if (styles) {
          var expandedUpdates = {};
          if (prevStyles) {
            for (var key in prevStyles)
              if (prevStyles.hasOwnProperty(key) && !styles.hasOwnProperty(key))
                for (var longhands = shorthandToLonghand[key] || [key], i2 = 0; i2 < longhands.length; i2++)
                  expandedUpdates[longhands[i2]] = key;
          }
          for (var _key in styles)
            if (styles.hasOwnProperty(_key) && (!prevStyles || prevStyles[_key] !== styles[_key]))
              for (key = shorthandToLonghand[_key] || [_key], longhands = 0; longhands < key.length; longhands++)
                expandedUpdates[key[longhands]] = _key;
          _key = {};
          for (var key$jscomp$0 in styles)
            for (key = shorthandToLonghand[key$jscomp$0] || [key$jscomp$0], longhands = 0; longhands < key.length; longhands++)
              _key[key[longhands]] = key$jscomp$0;
          key$jscomp$0 = {};
          for (var _key2 in expandedUpdates)
            if (key = expandedUpdates[_key2], (longhands = _key[_key2]) && key !== longhands && (i2 = key + "," + longhands, !key$jscomp$0[i2])) {
              key$jscomp$0[i2] = true;
              i2 = console;
              var value = styles[key];
              i2.error.call(
                i2,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                null == value || "boolean" === typeof value || "" === value ? "Removing" : "Updating",
                key,
                longhands
              );
            }
        }
        for (var styleName in prevStyles)
          !prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for (var _styleName in styles)
          _key2 = styles[_styleName], styles.hasOwnProperty(_styleName) && prevStyles[_styleName] !== _key2 && setValueForStyle(node, _styleName, _key2);
      } else
        for (expandedUpdates in styles)
          styles.hasOwnProperty(expandedUpdates) && setValueForStyle(node, expandedUpdates, styles[expandedUpdates]);
    }
    function isCustomElement(tagName) {
      if (-1 === tagName.indexOf("-")) return false;
      switch (tagName) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return false;
        default:
          return true;
      }
    }
    function getAttributeAlias(name2) {
      return aliases.get(name2) || name2;
    }
    function validateProperty$1(tagName, name2) {
      if (hasOwnProperty2.call(warnedProperties$1, name2) && warnedProperties$1[name2])
        return true;
      if (rARIACamel$1.test(name2)) {
        tagName = "aria-" + name2.slice(4).toLowerCase();
        tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
        if (null == tagName)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            name2
          ), warnedProperties$1[name2] = true;
        if (name2 !== tagName)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            name2,
            tagName
          ), warnedProperties$1[name2] = true;
      }
      if (rARIA$1.test(name2)) {
        tagName = name2.toLowerCase();
        tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
        if (null == tagName) return warnedProperties$1[name2] = true, false;
        name2 !== tagName && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          name2,
          tagName
        ), warnedProperties$1[name2] = true);
      }
      return true;
    }
    function validateProperties$2(type, props2) {
      var invalidProps = [], key;
      for (key in props2)
        validateProperty$1(type, key) || invalidProps.push(key);
      props2 = invalidProps.map(function(prop) {
        return "`" + prop + "`";
      }).join(", ");
      1 === invalidProps.length ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        props2,
        type
      ) : 1 < invalidProps.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        props2,
        type
      );
    }
    function validateProperty(tagName, name2, value, eventRegistry) {
      if (hasOwnProperty2.call(warnedProperties, name2) && warnedProperties[name2])
        return true;
      var lowerCasedName = name2.toLowerCase();
      if ("onfocusin" === lowerCasedName || "onfocusout" === lowerCasedName)
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), warnedProperties[name2] = true;
      if ("function" === typeof value && ("form" === tagName && "action" === name2 || "input" === tagName && "formAction" === name2 || "button" === tagName && "formAction" === name2))
        return true;
      if (null != eventRegistry) {
        tagName = eventRegistry.possibleRegistrationNames;
        if (eventRegistry.registrationNameDependencies.hasOwnProperty(name2))
          return true;
        eventRegistry = tagName.hasOwnProperty(lowerCasedName) ? tagName[lowerCasedName] : null;
        if (null != eventRegistry)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            name2,
            eventRegistry
          ), warnedProperties[name2] = true;
        if (EVENT_NAME_REGEX.test(name2))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            name2
          ), warnedProperties[name2] = true;
      } else if (EVENT_NAME_REGEX.test(name2))
        return INVALID_EVENT_NAME_REGEX.test(name2) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          name2
        ), warnedProperties[name2] = true;
      if (rARIA.test(name2) || rARIACamel.test(name2)) return true;
      if ("innerhtml" === lowerCasedName)
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), warnedProperties[name2] = true;
      if ("aria" === lowerCasedName)
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), warnedProperties[name2] = true;
      if ("is" === lowerCasedName && null !== value && void 0 !== value && "string" !== typeof value)
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof value
        ), warnedProperties[name2] = true;
      if ("number" === typeof value && isNaN(value))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          name2
        ), warnedProperties[name2] = true;
      if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
        if (lowerCasedName = possibleStandardNames[lowerCasedName], lowerCasedName !== name2)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            name2,
            lowerCasedName
          ), warnedProperties[name2] = true;
      } else if (name2 !== lowerCasedName)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          name2,
          lowerCasedName
        ), warnedProperties[name2] = true;
      switch (name2) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return true;
        case "innerText":
        case "textContent":
          return true;
      }
      switch (typeof value) {
        case "boolean":
          switch (name2) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return true;
            default:
              lowerCasedName = name2.toLowerCase().slice(0, 5);
              if ("data-" === lowerCasedName || "aria-" === lowerCasedName)
                return true;
              value ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                value,
                name2,
                name2,
                value,
                name2
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                value,
                name2,
                name2,
                value,
                name2,
                name2,
                name2
              );
              return warnedProperties[name2] = true;
          }
        case "function":
        case "symbol":
          return warnedProperties[name2] = true, false;
        case "string":
          if ("false" === value || "true" === value) {
            switch (name2) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return true;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              value,
              name2,
              "false" === value ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              name2,
              value
            );
            warnedProperties[name2] = true;
          }
      }
      return true;
    }
    function warnUnknownProperties(type, props2, eventRegistry) {
      var unknownProps = [], key;
      for (key in props2)
        validateProperty(type, key, props2[key], eventRegistry) || unknownProps.push(key);
      props2 = unknownProps.map(function(prop) {
        return "`" + prop + "`";
      }).join(", ");
      1 === unknownProps.length ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        props2,
        type
      ) : 1 < unknownProps.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        props2,
        type
      );
    }
    function sanitizeURL(url) {
      return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
    }
    function noop$12() {
    }
    function getEventTarget(nativeEvent) {
      nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
      nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
      return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
    }
    function restoreStateOfTarget(target) {
      var internalInstance = getInstanceFromNode(target);
      if (internalInstance && (target = internalInstance.stateNode)) {
        var props2 = target[internalPropsKey] || null;
        a: switch (target = internalInstance.stateNode, internalInstance.type) {
          case "input":
            updateInput(
              target,
              props2.value,
              props2.defaultValue,
              props2.defaultValue,
              props2.checked,
              props2.defaultChecked,
              props2.type,
              props2.name
            );
            internalInstance = props2.name;
            if ("radio" === props2.type && null != internalInstance) {
              for (props2 = target; props2.parentNode; ) props2 = props2.parentNode;
              checkAttributeStringCoercion(internalInstance, "name");
              props2 = props2.querySelectorAll(
                'input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes(
                  "" + internalInstance
                ) + '"][type="radio"]'
              );
              for (internalInstance = 0; internalInstance < props2.length; internalInstance++) {
                var otherNode = props2[internalInstance];
                if (otherNode !== target && otherNode.form === target.form) {
                  var otherProps = otherNode[internalPropsKey] || null;
                  if (!otherProps)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  updateInput(
                    otherNode,
                    otherProps.value,
                    otherProps.defaultValue,
                    otherProps.defaultValue,
                    otherProps.checked,
                    otherProps.defaultChecked,
                    otherProps.type,
                    otherProps.name
                  );
                }
              }
              for (internalInstance = 0; internalInstance < props2.length; internalInstance++)
                otherNode = props2[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
            }
            break a;
          case "textarea":
            updateTextarea(target, props2.value, props2.defaultValue);
            break a;
          case "select":
            internalInstance = props2.value, null != internalInstance && updateOptions(target, !!props2.multiple, internalInstance, false);
        }
      }
    }
    function batchedUpdates$1(fn, a, b2) {
      if (isInsideEventHandler) return fn(a, b2);
      isInsideEventHandler = true;
      try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
      } finally {
        if (isInsideEventHandler = false, null !== restoreTarget || null !== restoreQueue) {
          if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn))
            for (a = 0; a < fn.length; a++) restoreStateOfTarget(fn[a]);
        }
      }
    }
    function getListener(inst, registrationName) {
      var stateNode = inst.stateNode;
      if (null === stateNode) return null;
      var props2 = stateNode[internalPropsKey] || null;
      if (null === props2) return null;
      stateNode = props2[registrationName];
      a: switch (registrationName) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (props2 = !props2.disabled) || (inst = inst.type, props2 = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
          inst = !props2;
          break a;
        default:
          inst = false;
      }
      if (inst) return null;
      if (stateNode && "function" !== typeof stateNode)
        throw Error(
          "Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof stateNode + "` type."
        );
      return stateNode;
    }
    function getData() {
      if (fallbackText) return fallbackText;
      var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root2 ? root2.value : root2.textContent, endLength = endValue.length;
      for (start = 0; start < startLength && startValue[start] === endValue[start]; start++) ;
      var minEnd = startLength - start;
      for (end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++) ;
      return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
    }
    function getEventCharCode(nativeEvent) {
      var keyCode = nativeEvent.keyCode;
      "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
      10 === nativeEvent && (nativeEvent = 13);
      return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
    }
    function functionThatReturnsTrue() {
      return true;
    }
    function functionThatReturnsFalse() {
      return false;
    }
    function createSyntheticEvent(Interface) {
      function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for (var propName in Interface)
          Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : false === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
      }
      assign2(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
          this.defaultPrevented = true;
          var event = this.nativeEvent;
          event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = false), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
          var event = this.nativeEvent;
          event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = true), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {
        },
        isPersistent: functionThatReturnsTrue
      });
      return SyntheticBaseEvent;
    }
    function modifierStateGetter(keyArg) {
      var nativeEvent = this.nativeEvent;
      return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : false;
    }
    function getEventModifierState() {
      return modifierStateGetter;
    }
    function isFallbackCompositionEnd(domEventName, nativeEvent) {
      switch (domEventName) {
        case "keyup":
          return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
          return nativeEvent.keyCode !== START_KEYCODE;
        case "keypress":
        case "mousedown":
        case "focusout":
          return true;
        default:
          return false;
      }
    }
    function getDataFromCustomEvent(nativeEvent) {
      nativeEvent = nativeEvent.detail;
      return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
      switch (domEventName) {
        case "compositionend":
          return getDataFromCustomEvent(nativeEvent);
        case "keypress":
          if (nativeEvent.which !== SPACEBAR_CODE) return null;
          hasSpaceKeypress = true;
          return SPACEBAR_CHAR;
        case "textInput":
          return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
          return null;
      }
    }
    function getFallbackBeforeInputChars(domEventName, nativeEvent) {
      if (isComposing)
        return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root2 = null, isComposing = false, domEventName) : null;
      switch (domEventName) {
        case "paste":
          return null;
        case "keypress":
          if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
            if (nativeEvent.char && 1 < nativeEvent.char.length)
              return nativeEvent.char;
            if (nativeEvent.which)
              return String.fromCharCode(nativeEvent.which);
          }
          return null;
        case "compositionend":
          return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
          return null;
      }
    }
    function isTextInputElement(elem) {
      var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
      return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? true : false;
    }
    function isEventSupported(eventNameSuffix) {
      if (!canUseDOM2) return false;
      eventNameSuffix = "on" + eventNameSuffix;
      var isSupported = eventNameSuffix in document;
      isSupported || (isSupported = document.createElement("div"), isSupported.setAttribute(eventNameSuffix, "return;"), isSupported = "function" === typeof isSupported[eventNameSuffix]);
      return isSupported;
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
      restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [target] : restoreTarget = target;
      inst = accumulateTwoPhaseListeners(inst, "onChange");
      0 < inst.length && (nativeEvent = new SyntheticEvent(
        "onChange",
        "change",
        null,
        nativeEvent,
        target
      ), dispatchQueue.push({ event: nativeEvent, listeners: inst }));
    }
    function runEventInBatch(dispatchQueue) {
      processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
      var targetNode = getNodeFromInstance(targetInst);
      if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
      if ("change" === domEventName) return targetInst;
    }
    function stopWatchingForValueChange() {
      activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
    }
    function handlePropertyChange(nativeEvent) {
      if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(
          dispatchQueue,
          activeElementInst$1,
          nativeEvent,
          getEventTarget(nativeEvent)
        );
        batchedUpdates$1(runEventInBatch, dispatchQueue);
      }
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
      "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
    }
    function getTargetInstForInputEventPolyfill(domEventName) {
      if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName)
        return getInstIfValueChanged(activeElementInst$1);
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
      if ("click" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
      if ("input" === domEventName || "change" === domEventName)
        return getInstIfValueChanged(targetInst);
    }
    function is2(x2, y) {
      return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
    }
    function shallowEqual(objA, objB) {
      if (objectIs(objA, objB)) return true;
      if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB)
        return false;
      var keysA = Object.keys(objA), keysB = Object.keys(objB);
      if (keysA.length !== keysB.length) return false;
      for (keysB = 0; keysB < keysA.length; keysB++) {
        var currentKey = keysA[keysB];
        if (!hasOwnProperty2.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey]))
          return false;
      }
      return true;
    }
    function getLeafNode(node) {
      for (; node && node.firstChild; ) node = node.firstChild;
      return node;
    }
    function getNodeForCharacterOffset(root3, offset2) {
      var node = getLeafNode(root3);
      root3 = 0;
      for (var nodeEnd; node; ) {
        if (3 === node.nodeType) {
          nodeEnd = root3 + node.textContent.length;
          if (root3 <= offset2 && nodeEnd >= offset2)
            return { node, offset: offset2 - root3 };
          root3 = nodeEnd;
        }
        a: {
          for (; node; ) {
            if (node.nextSibling) {
              node = node.nextSibling;
              break a;
            }
            node = node.parentNode;
          }
          node = void 0;
        }
        node = getLeafNode(node);
      }
    }
    function containsNode(outerNode, innerNode) {
      return outerNode && innerNode ? outerNode === innerNode ? true : outerNode && 3 === outerNode.nodeType ? false : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : false : false;
    }
    function getActiveElementDeep(containerInfo) {
      containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
      for (var element2 = getActiveElement2(containerInfo.document); element2 instanceof containerInfo.HTMLIFrameElement; ) {
        try {
          var JSCompiler_inline_result = "string" === typeof element2.contentWindow.location.href;
        } catch (err) {
          JSCompiler_inline_result = false;
        }
        if (JSCompiler_inline_result) containerInfo = element2.contentWindow;
        else break;
        element2 = getActiveElement2(containerInfo.document);
      }
      return element2;
    }
    function hasSelectionCapabilities(elem) {
      var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
      return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
    }
    function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
      var doc2 = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
      mouseDown || null == activeElement || activeElement !== getActiveElement2(doc2) || (doc2 = activeElement, "selectionStart" in doc2 && hasSelectionCapabilities(doc2) ? doc2 = { start: doc2.selectionStart, end: doc2.selectionEnd } : (doc2 = (doc2.ownerDocument && doc2.ownerDocument.defaultView || window).getSelection(), doc2 = {
        anchorNode: doc2.anchorNode,
        anchorOffset: doc2.anchorOffset,
        focusNode: doc2.focusNode,
        focusOffset: doc2.focusOffset
      }), lastSelection && shallowEqual(lastSelection, doc2) || (lastSelection = doc2, doc2 = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc2.length && (nativeEvent = new SyntheticEvent(
        "onSelect",
        "select",
        null,
        nativeEvent,
        nativeEventTarget
      ), dispatchQueue.push({ event: nativeEvent, listeners: doc2 }), nativeEvent.target = activeElement)));
    }
    function makePrefixMap(styleProp, eventName) {
      var prefixes = {};
      prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
      prefixes["Webkit" + styleProp] = "webkit" + eventName;
      prefixes["Moz" + styleProp] = "moz" + eventName;
      return prefixes;
    }
    function getVendorPrefixedEventName(eventName) {
      if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
      if (!vendorPrefixes[eventName]) return eventName;
      var prefixMap = vendorPrefixes[eventName], styleProp;
      for (styleProp in prefixMap)
        if (prefixMap.hasOwnProperty(styleProp) && styleProp in style)
          return prefixedEventNames[eventName] = prefixMap[styleProp];
      return eventName;
    }
    function registerSimpleEvent(domEventName, reactName) {
      topLevelEventsToReactNames.set(domEventName, reactName);
      registerTwoPhaseEvent(reactName, [domEventName]);
    }
    function getArrayKind(array) {
      for (var kind = EMPTY_ARRAY, i2 = 0; i2 < array.length; i2++) {
        var value = array[i2];
        if ("object" === typeof value && null !== value)
          if (isArrayImpl(value) && 2 === value.length && "string" === typeof value[0]) {
            if (kind !== EMPTY_ARRAY && kind !== ENTRIES_ARRAY)
              return COMPLEX_ARRAY;
            kind = ENTRIES_ARRAY;
          } else return COMPLEX_ARRAY;
        else {
          if ("function" === typeof value || "string" === typeof value && 50 < value.length || kind !== EMPTY_ARRAY && kind !== PRIMITIVE_ARRAY)
            return COMPLEX_ARRAY;
          kind = PRIMITIVE_ARRAY;
        }
      }
      return kind;
    }
    function addObjectToProperties(object2, properties2, indent2, prefix2) {
      for (var key in object2)
        hasOwnProperty2.call(object2, key) && "_" !== key[0] && addValueToProperties(key, object2[key], properties2, indent2, prefix2);
    }
    function addValueToProperties(propertyName2, value, properties2, indent2, prefix2) {
      switch (typeof value) {
        case "object":
          if (null === value) {
            value = "null";
            break;
          } else {
            if (value.$$typeof === REACT_ELEMENT_TYPE) {
              var typeName3 = getComponentNameFromType(value.type) || "…", key = value.key;
              value = value.props;
              var propsKeys = Object.keys(value), propsLength = propsKeys.length;
              if (null == key && 0 === propsLength) {
                value = "<" + typeName3 + " />";
                break;
              }
              if (3 > indent2 || 1 === propsLength && "children" === propsKeys[0] && null == key) {
                value = "<" + typeName3 + " … />";
                break;
              }
              properties2.push([
                prefix2 + "  ".repeat(indent2) + propertyName2,
                "<" + typeName3
              ]);
              null !== key && addValueToProperties(
                "key",
                key,
                properties2,
                indent2 + 1,
                prefix2
              );
              propertyName2 = false;
              for (var propKey in value)
                "children" === propKey ? null != value.children && (!isArrayImpl(value.children) || 0 < value.children.length) && (propertyName2 = true) : hasOwnProperty2.call(value, propKey) && "_" !== propKey[0] && addValueToProperties(
                  propKey,
                  value[propKey],
                  properties2,
                  indent2 + 1,
                  prefix2
                );
              properties2.push([
                "",
                propertyName2 ? ">…</" + typeName3 + ">" : "/>"
              ]);
              return;
            }
            typeName3 = Object.prototype.toString.call(value);
            typeName3 = typeName3.slice(8, typeName3.length - 1);
            if ("Array" === typeName3) {
              if (propKey = getArrayKind(value), propKey === PRIMITIVE_ARRAY || propKey === EMPTY_ARRAY) {
                value = JSON.stringify(value);
                break;
              } else if (propKey === ENTRIES_ARRAY) {
                properties2.push([
                  prefix2 + "  ".repeat(indent2) + propertyName2,
                  ""
                ]);
                for (propertyName2 = 0; propertyName2 < value.length; propertyName2++)
                  typeName3 = value[propertyName2], addValueToProperties(
                    typeName3[0],
                    typeName3[1],
                    properties2,
                    indent2 + 1,
                    prefix2
                  );
                return;
              }
            }
            if ("Promise" === typeName3) {
              if ("fulfilled" === value.status) {
                if (typeName3 = properties2.length, addValueToProperties(
                  propertyName2,
                  value.value,
                  properties2,
                  indent2,
                  prefix2
                ), properties2.length > typeName3) {
                  properties2 = properties2[typeName3];
                  properties2[1] = "Promise<" + (properties2[1] || "Object") + ">";
                  return;
                }
              } else if ("rejected" === value.status && (typeName3 = properties2.length, addValueToProperties(
                propertyName2,
                value.reason,
                properties2,
                indent2,
                prefix2
              ), properties2.length > typeName3)) {
                properties2 = properties2[typeName3];
                properties2[1] = "Rejected Promise<" + properties2[1] + ">";
                return;
              }
              properties2.push([
                "  ".repeat(indent2) + propertyName2,
                "Promise"
              ]);
              return;
            }
            "Object" === typeName3 && (propKey = Object.getPrototypeOf(value)) && "function" === typeof propKey.constructor && (typeName3 = propKey.constructor.name);
            properties2.push([
              prefix2 + "  ".repeat(indent2) + propertyName2,
              "Object" === typeName3 ? 3 > indent2 ? "" : "…" : typeName3
            ]);
            3 > indent2 && addObjectToProperties(value, properties2, indent2 + 1, prefix2);
            return;
          }
        case "function":
          value = "" === value.name ? "() => {}" : value.name + "() {}";
          break;
        case "string":
          value = value === OMITTED_PROP_ERROR ? "…" : JSON.stringify(value);
          break;
        case "undefined":
          value = "undefined";
          break;
        case "boolean":
          value = value ? "true" : "false";
          break;
        default:
          value = String(value);
      }
      properties2.push([
        prefix2 + "  ".repeat(indent2) + propertyName2,
        value
      ]);
    }
    function addObjectDiffToProperties(prev, next, properties2, indent2) {
      var isDeeplyEqual = true;
      for (key in prev)
        key in next || (properties2.push([
          REMOVED + "  ".repeat(indent2) + key,
          "…"
        ]), isDeeplyEqual = false);
      for (var _key in next)
        if (_key in prev) {
          var key = prev[_key];
          var nextValue = next[_key];
          if (key !== nextValue) {
            if (0 === indent2 && "children" === _key)
              isDeeplyEqual = "  ".repeat(indent2) + _key, properties2.push(
                [REMOVED + isDeeplyEqual, "…"],
                [ADDED + isDeeplyEqual, "…"]
              );
            else {
              if (!(3 <= indent2)) {
                if ("object" === typeof key && "object" === typeof nextValue && null !== key && null !== nextValue && key.$$typeof === nextValue.$$typeof)
                  if (nextValue.$$typeof === REACT_ELEMENT_TYPE) {
                    if (key.type === nextValue.type && key.key === nextValue.key) {
                      key = getComponentNameFromType(nextValue.type) || "…";
                      isDeeplyEqual = "  ".repeat(indent2) + _key;
                      key = "<" + key + " … />";
                      properties2.push(
                        [REMOVED + isDeeplyEqual, key],
                        [ADDED + isDeeplyEqual, key]
                      );
                      isDeeplyEqual = false;
                      continue;
                    }
                  } else {
                    var prevKind = Object.prototype.toString.call(key), nextKind = Object.prototype.toString.call(nextValue);
                    if (prevKind === nextKind && ("[object Object]" === nextKind || "[object Array]" === nextKind)) {
                      prevKind = [
                        UNCHANGED + "  ".repeat(indent2) + _key,
                        "[object Array]" === nextKind ? "Array" : ""
                      ];
                      properties2.push(prevKind);
                      nextKind = properties2.length;
                      addObjectDiffToProperties(
                        key,
                        nextValue,
                        properties2,
                        indent2 + 1
                      ) ? nextKind === properties2.length && (prevKind[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : isDeeplyEqual = false;
                      continue;
                    }
                  }
                else if ("function" === typeof key && "function" === typeof nextValue && key.name === nextValue.name && key.length === nextValue.length && (prevKind = Function.prototype.toString.call(key), nextKind = Function.prototype.toString.call(nextValue), prevKind === nextKind)) {
                  key = "" === nextValue.name ? "() => {}" : nextValue.name + "() {}";
                  properties2.push([
                    UNCHANGED + "  ".repeat(indent2) + _key,
                    key + " Referentially unequal function closure. Consider memoization."
                  ]);
                  continue;
                }
              }
              addValueToProperties(_key, key, properties2, indent2, REMOVED);
              addValueToProperties(_key, nextValue, properties2, indent2, ADDED);
            }
            isDeeplyEqual = false;
          }
        } else
          properties2.push([
            ADDED + "  ".repeat(indent2) + _key,
            "…"
          ]), isDeeplyEqual = false;
      return isDeeplyEqual;
    }
    function setCurrentTrackFromLanes(lanes) {
      currentTrack = lanes & 63 ? "Blocking" : lanes & 64 ? "Gesture" : lanes & 4194176 ? "Transition" : lanes & 62914560 ? "Suspense" : lanes & 2080374784 ? "Idle" : "Other";
    }
    function logComponentTrigger(fiber, startTime2, endTime, trigger) {
      supportsUserTiming && (reusableComponentOptions.start = startTime2, reusableComponentOptions.end = endTime, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = trigger, reusableComponentDevToolDetails.properties = null, (fiber = fiber._debugTask) ? fiber.run(
        performance.measure.bind(
          performance,
          trigger,
          reusableComponentOptions
        )
      ) : performance.measure(trigger, reusableComponentOptions));
    }
    function logComponentReappeared(fiber, startTime2, endTime) {
      logComponentTrigger(fiber, startTime2, endTime, "Reconnect");
    }
    function logComponentRender(fiber, startTime2, endTime, wasHydrated, committedLanes) {
      var name2 = getComponentNameFromFiber(fiber);
      if (null !== name2 && supportsUserTiming) {
        var alternate = fiber.alternate, selfTime = fiber.actualDuration;
        if (null === alternate || alternate.child !== fiber.child)
          for (var child = fiber.child; null !== child; child = child.sibling)
            selfTime -= child.actualDuration;
        wasHydrated = 0.5 > selfTime ? wasHydrated ? "tertiary-light" : "primary-light" : 10 > selfTime ? wasHydrated ? "tertiary" : "primary" : 100 > selfTime ? wasHydrated ? "tertiary-dark" : "primary-dark" : "error";
        var props2 = fiber.memoizedProps;
        selfTime = fiber._debugTask;
        null !== props2 && null !== alternate && alternate.memoizedProps !== props2 ? (child = [resuableChangedPropsEntry], props2 = addObjectDiffToProperties(
          alternate.memoizedProps,
          props2,
          child,
          0
        ), 1 < child.length && (props2 && !alreadyWarnedForDeepEquality && 0 === (alternate.lanes & committedLanes) && 100 < fiber.actualDuration ? (alreadyWarnedForDeepEquality = true, child[0] = reusableDeeplyEqualPropsEntry, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = DEEP_EQUALITY_WARNING) : (reusableComponentDevToolDetails.color = wasHydrated, reusableComponentDevToolDetails.tooltipText = name2), reusableComponentDevToolDetails.properties = child, reusableComponentOptions.start = startTime2, reusableComponentOptions.end = endTime, null != selfTime ? selfTime.run(
          performance.measure.bind(
            performance,
            "​" + name2,
            reusableComponentOptions
          )
        ) : performance.measure(
          "​" + name2,
          reusableComponentOptions
        ))) : null != selfTime ? selfTime.run(
          console.timeStamp.bind(
            console,
            name2,
            startTime2,
            endTime,
            COMPONENTS_TRACK,
            void 0,
            wasHydrated
          )
        ) : console.timeStamp(
          name2,
          startTime2,
          endTime,
          COMPONENTS_TRACK,
          void 0,
          wasHydrated
        );
      }
    }
    function logComponentErrored(fiber, startTime2, endTime, errors2) {
      if (supportsUserTiming) {
        var name2 = getComponentNameFromFiber(fiber);
        if (null !== name2) {
          for (var debugTask = null, properties2 = [], i2 = 0; i2 < errors2.length; i2++) {
            var capturedValue = errors2[i2];
            null == debugTask && null !== capturedValue.source && (debugTask = capturedValue.source._debugTask);
            capturedValue = capturedValue.value;
            properties2.push([
              "Error",
              "object" === typeof capturedValue && null !== capturedValue && "string" === typeof capturedValue.message ? String(capturedValue.message) : String(capturedValue)
            ]);
          }
          null !== fiber.key && addValueToProperties("key", fiber.key, properties2, 0, "");
          null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, properties2, 0, "");
          null == debugTask && (debugTask = fiber._debugTask);
          fiber = {
            start: startTime2,
            end: endTime,
            detail: {
              devtools: {
                color: "error",
                track: COMPONENTS_TRACK,
                tooltipText: 13 === fiber.tag ? "Hydration failed" : "Error boundary caught an error",
                properties: properties2
              }
            }
          };
          debugTask ? debugTask.run(
            performance.measure.bind(performance, "​" + name2, fiber)
          ) : performance.measure("​" + name2, fiber);
        }
      }
    }
    function logComponentEffect(fiber, startTime2, endTime, selfTime, errors2) {
      if (null !== errors2) {
        if (supportsUserTiming) {
          var name2 = getComponentNameFromFiber(fiber);
          if (null !== name2) {
            selfTime = [];
            for (var i2 = 0; i2 < errors2.length; i2++) {
              var error = errors2[i2].value;
              selfTime.push([
                "Error",
                "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
              ]);
            }
            null !== fiber.key && addValueToProperties("key", fiber.key, selfTime, 0, "");
            null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, selfTime, 0, "");
            startTime2 = {
              start: startTime2,
              end: endTime,
              detail: {
                devtools: {
                  color: "error",
                  track: COMPONENTS_TRACK,
                  tooltipText: "A lifecycle or effect errored",
                  properties: selfTime
                }
              }
            };
            (fiber = fiber._debugTask) ? fiber.run(
              performance.measure.bind(
                performance,
                "​" + name2,
                startTime2
              )
            ) : performance.measure("​" + name2, startTime2);
          }
        }
      } else
        name2 = getComponentNameFromFiber(fiber), null !== name2 && supportsUserTiming && (errors2 = 1 > selfTime ? "secondary-light" : 100 > selfTime ? "secondary" : 500 > selfTime ? "secondary-dark" : "error", (fiber = fiber._debugTask) ? fiber.run(
          console.timeStamp.bind(
            console,
            name2,
            startTime2,
            endTime,
            COMPONENTS_TRACK,
            void 0,
            errors2
          )
        ) : console.timeStamp(
          name2,
          startTime2,
          endTime,
          COMPONENTS_TRACK,
          void 0,
          errors2
        ));
    }
    function logRenderPhase(startTime2, endTime, lanes, debugTask) {
      if (supportsUserTiming && !(endTime <= startTime2)) {
        var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark";
        lanes = (lanes & 536870912) === lanes ? "Prepared" : (lanes & 201326741) === lanes ? "Hydrated" : "Render";
        debugTask ? debugTask.run(
          console.timeStamp.bind(
            console,
            lanes,
            startTime2,
            endTime,
            currentTrack,
            LANES_TRACK_GROUP,
            color
          )
        ) : console.timeStamp(
          lanes,
          startTime2,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          color
        );
      }
    }
    function logSuspendedRenderPhase(startTime2, endTime, lanes, debugTask) {
      !supportsUserTiming || endTime <= startTime2 || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(
        console.timeStamp.bind(
          console,
          "Prewarm",
          startTime2,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          lanes
        )
      ) : console.timeStamp(
        "Prewarm",
        startTime2,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        lanes
      ));
    }
    function logSuspendedWithDelayPhase(startTime2, endTime, lanes, debugTask) {
      !supportsUserTiming || endTime <= startTime2 || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(
        console.timeStamp.bind(
          console,
          "Suspended",
          startTime2,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          lanes
        )
      ) : console.timeStamp(
        "Suspended",
        startTime2,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        lanes
      ));
    }
    function logRecoveredRenderPhase(startTime2, endTime, lanes, recoverableErrors, hydrationFailed, debugTask) {
      if (supportsUserTiming && !(endTime <= startTime2)) {
        lanes = [];
        for (var i2 = 0; i2 < recoverableErrors.length; i2++) {
          var error = recoverableErrors[i2].value;
          lanes.push([
            "Recoverable Error",
            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
          ]);
        }
        startTime2 = {
          start: startTime2,
          end: endTime,
          detail: {
            devtools: {
              color: "primary-dark",
              track: currentTrack,
              trackGroup: LANES_TRACK_GROUP,
              tooltipText: hydrationFailed ? "Hydration Failed" : "Recovered after Error",
              properties: lanes
            }
          }
        };
        debugTask ? debugTask.run(
          performance.measure.bind(performance, "Recovered", startTime2)
        ) : performance.measure("Recovered", startTime2);
      }
    }
    function logErroredRenderPhase(startTime2, endTime, lanes, debugTask) {
      !supportsUserTiming || endTime <= startTime2 || (debugTask ? debugTask.run(
        console.timeStamp.bind(
          console,
          "Errored",
          startTime2,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          "error"
        )
      ) : console.timeStamp(
        "Errored",
        startTime2,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        "error"
      ));
    }
    function logSuspendedCommitPhase(startTime2, endTime, reason, debugTask) {
      !supportsUserTiming || endTime <= startTime2 || (debugTask ? debugTask.run(
        console.timeStamp.bind(
          console,
          reason,
          startTime2,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          "secondary-light"
        )
      ) : console.timeStamp(
        reason,
        startTime2,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        "secondary-light"
      ));
    }
    function logCommitErrored(startTime2, endTime, errors2, passive, debugTask) {
      if (supportsUserTiming && !(endTime <= startTime2)) {
        for (var properties2 = [], i2 = 0; i2 < errors2.length; i2++) {
          var error = errors2[i2].value;
          properties2.push([
            "Error",
            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
          ]);
        }
        startTime2 = {
          start: startTime2,
          end: endTime,
          detail: {
            devtools: {
              color: "error",
              track: currentTrack,
              trackGroup: LANES_TRACK_GROUP,
              tooltipText: passive ? "Remaining Effects Errored" : "Commit Errored",
              properties: properties2
            }
          }
        };
        debugTask ? debugTask.run(
          performance.measure.bind(performance, "Errored", startTime2)
        ) : performance.measure("Errored", startTime2);
      }
    }
    function logAnimatingPhase(startTime2, endTime, debugTask) {
      !supportsUserTiming || endTime <= startTime2 || console.timeStamp(
        "Animating",
        startTime2,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        "secondary-dark"
      );
    }
    function finishQueueingConcurrentUpdates() {
      for (var endIndex = concurrentQueuesIndex, i2 = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i2 < endIndex; ) {
        var fiber = concurrentQueues[i2];
        concurrentQueues[i2++] = null;
        var queue2 = concurrentQueues[i2];
        concurrentQueues[i2++] = null;
        var update = concurrentQueues[i2];
        concurrentQueues[i2++] = null;
        var lane = concurrentQueues[i2];
        concurrentQueues[i2++] = null;
        if (null !== queue2 && null !== update) {
          var pending = queue2.pending;
          null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
          queue2.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
      }
    }
    function enqueueUpdate$1(fiber, queue2, update, lane) {
      concurrentQueues[concurrentQueuesIndex++] = fiber;
      concurrentQueues[concurrentQueuesIndex++] = queue2;
      concurrentQueues[concurrentQueuesIndex++] = update;
      concurrentQueues[concurrentQueuesIndex++] = lane;
      concurrentlyUpdatedLanes |= lane;
      fiber.lanes |= lane;
      fiber = fiber.alternate;
      null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue2, update, lane) {
      enqueueUpdate$1(fiber, queue2, update, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
      enqueueUpdate$1(fiber, null, null, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
      sourceFiber.lanes |= lane;
      var alternate = sourceFiber.alternate;
      null !== alternate && (alternate.lanes |= lane);
      for (var isHidden2 = false, parent = sourceFiber.return; null !== parent; )
        parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & OffscreenVisible || (isHidden2 = true)), sourceFiber = parent, parent = parent.return;
      return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden2 && null !== update && (isHidden2 = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden2], null === alternate ? sourceFiber[isHidden2] = [update] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
      if (nestedUpdateCount > NESTED_UPDATE_LIMIT)
        throw nestedPassiveUpdateCount = nestedUpdateCount = 0, rootWithPassiveNestedUpdates = rootWithNestedUpdates = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT && (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      ));
      null === sourceFiber.alternate && 0 !== (sourceFiber.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
      for (var node = sourceFiber, parent = node.return; null !== parent; )
        null === node.alternate && 0 !== (node.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber), node = parent, parent = node.return;
      return 3 === node.tag ? node.stateNode : null;
    }
    function resolveFunctionForHotReloading(type) {
      if (null === resolveFamily) return type;
      var family = resolveFamily(type);
      return void 0 === family ? type : family.current;
    }
    function resolveForwardRefForHotReloading(type) {
      if (null === resolveFamily) return type;
      var family = resolveFamily(type);
      return void 0 === family ? null !== type && void 0 !== type && "function" === typeof type.render && (family = resolveFunctionForHotReloading(type.render), type.render !== family) ? (family = { $$typeof: REACT_FORWARD_REF_TYPE, render: family }, void 0 !== type.displayName && (family.displayName = type.displayName), family) : type : family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element2) {
      if (null === resolveFamily) return false;
      var prevType = fiber.elementType;
      element2 = element2.type;
      var needsCompareFamilies = false, $$typeofNextType = "object" === typeof element2 && null !== element2 ? element2.$$typeof : null;
      switch (fiber.tag) {
        case 1:
          "function" === typeof element2 && (needsCompareFamilies = true);
          break;
        case 0:
          "function" === typeof element2 ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        case 11:
          $$typeofNextType === REACT_FORWARD_REF_TYPE ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        case 14:
        case 15:
          $$typeofNextType === REACT_MEMO_TYPE ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        default:
          return false;
      }
      return needsCompareFamilies && (fiber = resolveFamily(prevType), void 0 !== fiber && fiber === resolveFamily(element2)) ? true : false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
      null !== resolveFamily && "function" === typeof WeakSet && (null === failedBoundaries && (failedBoundaries = /* @__PURE__ */ new WeakSet()), failedBoundaries.add(fiber));
    }
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
      do {
        var _fiber = fiber, alternate = _fiber.alternate, child = _fiber.child, sibling = _fiber.sibling, tag2 = _fiber.tag;
        _fiber = _fiber.type;
        var candidateType = null;
        switch (tag2) {
          case 0:
          case 15:
          case 1:
            candidateType = _fiber;
            break;
          case 11:
            candidateType = _fiber.render;
        }
        if (null === resolveFamily)
          throw Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        _fiber = false;
        null !== candidateType && (candidateType = resolveFamily(candidateType), void 0 !== candidateType && (staleFamilies.has(candidateType) ? _fiber = true : updatedFamilies.has(candidateType) && (1 === tag2 ? _fiber = true : needsRender = true)));
        null !== failedBoundaries && (failedBoundaries.has(fiber) || null !== alternate && failedBoundaries.has(alternate)) && (_fiber = true);
        _fiber && (fiber._debugNeedsRemount = true);
        if (_fiber || needsRender)
          alternate = enqueueConcurrentRenderForLane(fiber, 2), null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
        null === child || _fiber || scheduleFibersWithFamiliesRecursively(
          child,
          updatedFamilies,
          staleFamilies
        );
        if (null === sibling) break;
        fiber = sibling;
      } while (1);
    }
    function FiberNode(tag2, pendingProps, key, mode) {
      this.tag = tag2;
      this.key = key;
      this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
      this.index = 0;
      this.refCleanup = this.ref = null;
      this.pendingProps = pendingProps;
      this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
      this.mode = mode;
      this.subtreeFlags = this.flags = 0;
      this.deletions = null;
      this.childLanes = this.lanes = 0;
      this.alternate = null;
      this.actualDuration = -0;
      this.actualStartTime = -1.1;
      this.treeBaseDuration = this.selfBaseDuration = -0;
      this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null;
      this._debugNeedsRemount = false;
      this._debugHookTypes = null;
      hasBadMapPolyfill || "function" !== typeof Object.preventExtensions || Object.preventExtensions(this);
    }
    function shouldConstruct(Component) {
      Component = Component.prototype;
      return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current3, pendingProps) {
      var workInProgress2 = current3.alternate;
      null === workInProgress2 ? (workInProgress2 = createFiber(
        current3.tag,
        pendingProps,
        current3.key,
        current3.mode
      ), workInProgress2.elementType = current3.elementType, workInProgress2.type = current3.type, workInProgress2.stateNode = current3.stateNode, workInProgress2._debugOwner = current3._debugOwner, workInProgress2._debugStack = current3._debugStack, workInProgress2._debugTask = current3._debugTask, workInProgress2._debugHookTypes = current3._debugHookTypes, workInProgress2.alternate = current3, current3.alternate = workInProgress2) : (workInProgress2.pendingProps = pendingProps, workInProgress2.type = current3.type, workInProgress2.flags = 0, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.actualDuration = -0, workInProgress2.actualStartTime = -1.1);
      workInProgress2.flags = current3.flags & 65011712;
      workInProgress2.childLanes = current3.childLanes;
      workInProgress2.lanes = current3.lanes;
      workInProgress2.child = current3.child;
      workInProgress2.memoizedProps = current3.memoizedProps;
      workInProgress2.memoizedState = current3.memoizedState;
      workInProgress2.updateQueue = current3.updateQueue;
      pendingProps = current3.dependencies;
      workInProgress2.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext,
        _debugThenableState: pendingProps._debugThenableState
      };
      workInProgress2.sibling = current3.sibling;
      workInProgress2.index = current3.index;
      workInProgress2.ref = current3.ref;
      workInProgress2.refCleanup = current3.refCleanup;
      workInProgress2.selfBaseDuration = current3.selfBaseDuration;
      workInProgress2.treeBaseDuration = current3.treeBaseDuration;
      workInProgress2._debugInfo = current3._debugInfo;
      workInProgress2._debugNeedsRemount = current3._debugNeedsRemount;
      switch (workInProgress2.tag) {
        case 0:
        case 15:
          workInProgress2.type = resolveFunctionForHotReloading(current3.type);
          break;
        case 1:
          workInProgress2.type = resolveFunctionForHotReloading(current3.type);
          break;
        case 11:
          workInProgress2.type = resolveForwardRefForHotReloading(current3.type);
      }
      return workInProgress2;
    }
    function resetWorkInProgress(workInProgress2, renderLanes2) {
      workInProgress2.flags &= 65011714;
      var current3 = workInProgress2.alternate;
      null === current3 ? (workInProgress2.childLanes = 0, workInProgress2.lanes = renderLanes2, workInProgress2.child = null, workInProgress2.subtreeFlags = 0, workInProgress2.memoizedProps = null, workInProgress2.memoizedState = null, workInProgress2.updateQueue = null, workInProgress2.dependencies = null, workInProgress2.stateNode = null, workInProgress2.selfBaseDuration = 0, workInProgress2.treeBaseDuration = 0) : (workInProgress2.childLanes = current3.childLanes, workInProgress2.lanes = current3.lanes, workInProgress2.child = current3.child, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.memoizedProps = current3.memoizedProps, workInProgress2.memoizedState = current3.memoizedState, workInProgress2.updateQueue = current3.updateQueue, workInProgress2.type = current3.type, renderLanes2 = current3.dependencies, workInProgress2.dependencies = null === renderLanes2 ? null : {
        lanes: renderLanes2.lanes,
        firstContext: renderLanes2.firstContext,
        _debugThenableState: renderLanes2._debugThenableState
      }, workInProgress2.selfBaseDuration = current3.selfBaseDuration, workInProgress2.treeBaseDuration = current3.treeBaseDuration);
      return workInProgress2;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
      var fiberTag = 0, resolvedType = type;
      if ("function" === typeof type)
        shouldConstruct(type) && (fiberTag = 1), resolvedType = resolveFunctionForHotReloading(resolvedType);
      else if ("string" === typeof type)
        fiberTag = getHostContext(), fiberTag = isHostHoistableType(type, pendingProps, fiberTag) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
      else
        a: switch (type) {
          case REACT_ACTIVITY_TYPE:
            return key = createFiber(31, pendingProps, key, mode), key.elementType = REACT_ACTIVITY_TYPE, key.lanes = lanes, key;
          case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(
              pendingProps.children,
              mode,
              lanes,
              key
            );
          case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= StrictLegacyMode;
            mode |= StrictEffectsMode;
            break;
          case REACT_PROFILER_TYPE:
            return type = pendingProps, owner = mode, "string" !== typeof type.id && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof type.id
            ), key = createFiber(12, type, key, owner | ProfileMode), key.elementType = REACT_PROFILER_TYPE, key.lanes = lanes, key.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, key;
          case REACT_SUSPENSE_TYPE:
            return key = createFiber(13, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_TYPE, key.lanes = lanes, key;
          case REACT_SUSPENSE_LIST_TYPE:
            return key = createFiber(19, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_LIST_TYPE, key.lanes = lanes, key;
          default:
            if ("object" === typeof type && null !== type)
              switch (type.$$typeof) {
                case REACT_CONTEXT_TYPE:
                  fiberTag = 10;
                  break a;
                case REACT_CONSUMER_TYPE:
                  fiberTag = 9;
                  break a;
                case REACT_FORWARD_REF_TYPE:
                  fiberTag = 11;
                  resolvedType = resolveForwardRefForHotReloading(resolvedType);
                  break a;
                case REACT_MEMO_TYPE:
                  fiberTag = 14;
                  break a;
                case REACT_LAZY_TYPE:
                  fiberTag = 16;
                  resolvedType = null;
                  break a;
              }
            resolvedType = "";
            if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length)
              resolvedType += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            null === type ? pendingProps = "null" : isArrayImpl(type) ? pendingProps = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (pendingProps = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", resolvedType = " Did you accidentally export a JSX literal instead of a component?") : pendingProps = typeof type;
            (fiberTag = owner ? getComponentNameFromOwner(owner) : null) && (resolvedType += "\n\nCheck the render method of `" + fiberTag + "`.");
            fiberTag = 29;
            pendingProps = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (pendingProps + "." + resolvedType)
            );
            resolvedType = null;
        }
      key = createFiber(fiberTag, pendingProps, key, mode);
      key.elementType = type;
      key.type = resolvedType;
      key.lanes = lanes;
      key._debugOwner = owner;
      return key;
    }
    function createFiberFromElement(element2, mode, lanes) {
      mode = createFiberFromTypeAndProps(
        element2.type,
        element2.key,
        element2.props,
        element2._owner,
        mode,
        lanes
      );
      mode._debugOwner = element2._owner;
      mode._debugStack = element2._debugStack;
      mode._debugTask = element2._debugTask;
      return mode;
    }
    function createFiberFromFragment(elements2, mode, lanes, key) {
      elements2 = createFiber(7, elements2, key, mode);
      elements2.lanes = lanes;
      return elements2;
    }
    function createFiberFromText(content2, mode, lanes) {
      content2 = createFiber(6, content2, null, mode);
      content2.lanes = lanes;
      return content2;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
      var fiber = createFiber(18, null, null, NoMode);
      fiber.stateNode = dehydratedNode;
      return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
      mode = createFiber(
        4,
        null !== portal.children ? portal.children : [],
        portal.key,
        mode
      );
      mode.lanes = lanes;
      mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
      };
      return mode;
    }
    function createCapturedValueAtFiber(value, source) {
      if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
          value,
          source,
          stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
      }
      return {
        value,
        source,
        stack: getStackByFiberInDevAndProd(source)
      };
    }
    function pushTreeFork(workInProgress2, totalChildren) {
      warnIfNotHydrating();
      forkStack[forkStackIndex++] = treeForkCount;
      forkStack[forkStackIndex++] = treeForkProvider;
      treeForkProvider = workInProgress2;
      treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress2, totalChildren, index2) {
      warnIfNotHydrating();
      idStack[idStackIndex++] = treeContextId;
      idStack[idStackIndex++] = treeContextOverflow;
      idStack[idStackIndex++] = treeContextProvider;
      treeContextProvider = workInProgress2;
      var baseIdWithLeadingBit = treeContextId;
      workInProgress2 = treeContextOverflow;
      var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
      baseIdWithLeadingBit &= ~(1 << baseLength);
      index2 += 1;
      var length = 32 - clz32(totalChildren) + baseLength;
      if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index2 << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress2;
      } else
        treeContextId = 1 << length | index2 << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress2;
    }
    function pushMaterializedTreeId(workInProgress2) {
      warnIfNotHydrating();
      null !== workInProgress2.return && (pushTreeFork(workInProgress2, 1), pushTreeId(workInProgress2, 1, 0));
    }
    function popTreeContext(workInProgress2) {
      for (; workInProgress2 === treeForkProvider; )
        treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
      for (; workInProgress2 === treeContextProvider; )
        treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function getSuspendedTreeContext() {
      warnIfNotHydrating();
      return null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null;
    }
    function restoreSuspendedTreeContext(workInProgress2, suspendedContext) {
      warnIfNotHydrating();
      idStack[idStackIndex++] = treeContextId;
      idStack[idStackIndex++] = treeContextOverflow;
      idStack[idStackIndex++] = treeContextProvider;
      treeContextId = suspendedContext.id;
      treeContextOverflow = suspendedContext.overflow;
      treeContextProvider = workInProgress2;
    }
    function warnIfNotHydrating() {
      isHydrating || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
      if (null === fiber.return) {
        if (null === hydrationDiffRootDEV)
          hydrationDiffRootDEV = {
            fiber,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf
          };
        else {
          if (hydrationDiffRootDEV.fiber !== fiber)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf && (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
        }
        return hydrationDiffRootDEV;
      }
      var siblings = buildHydrationDiffNode(
        fiber.return,
        distanceFromLeaf + 1
      ).children;
      if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber)
        return siblings = siblings[siblings.length - 1], siblings.distanceFromLeaf > distanceFromLeaf && (siblings.distanceFromLeaf = distanceFromLeaf), siblings;
      distanceFromLeaf = {
        fiber,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf
      };
      siblings.push(distanceFromLeaf);
      return distanceFromLeaf;
    }
    function warnIfHydrating() {
      isHydrating && console.error(
        "We should not be hydrating here. This is a bug in React. Please file a bug."
      );
    }
    function warnNonHydratedInstance(fiber, rejectedCandidate) {
      didSuspendOrErrorDEV || (fiber = buildHydrationDiffNode(fiber, 0), fiber.serverProps = null, null !== rejectedCandidate && (rejectedCandidate = describeHydratableInstanceForDevWarnings(rejectedCandidate), fiber.serverTail.push(rejectedCandidate)));
    }
    function throwOnHydrationMismatch(fiber) {
      var fromText = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : false, diff = "", diffRoot = hydrationDiffRootDEV;
      null !== diffRoot && (hydrationDiffRootDEV = null, diff = describeDiff(diffRoot));
      queueHydrationError(
        createCapturedValueAtFiber(
          Error(
            "Hydration failed because the server rendered " + (fromText ? "text" : "HTML") + " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + diff
          ),
          fiber
        )
      );
      throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber) {
      var didHydrate = fiber.stateNode;
      var type = fiber.type, props2 = fiber.memoizedProps;
      didHydrate[internalInstanceKey] = fiber;
      didHydrate[internalPropsKey] = props2;
      validatePropertiesInDevelopment(type, props2);
      switch (type) {
        case "dialog":
          listenToNonDelegatedEvent("cancel", didHydrate);
          listenToNonDelegatedEvent("close", didHydrate);
          break;
        case "iframe":
        case "object":
        case "embed":
          listenToNonDelegatedEvent("load", didHydrate);
          break;
        case "video":
        case "audio":
          for (type = 0; type < mediaEventTypes.length; type++)
            listenToNonDelegatedEvent(mediaEventTypes[type], didHydrate);
          break;
        case "source":
          listenToNonDelegatedEvent("error", didHydrate);
          break;
        case "img":
        case "image":
        case "link":
          listenToNonDelegatedEvent("error", didHydrate);
          listenToNonDelegatedEvent("load", didHydrate);
          break;
        case "details":
          listenToNonDelegatedEvent("toggle", didHydrate);
          break;
        case "input":
          checkControlledValueProps("input", props2);
          listenToNonDelegatedEvent("invalid", didHydrate);
          validateInputProps(didHydrate, props2);
          initInput(
            didHydrate,
            props2.value,
            props2.defaultValue,
            props2.checked,
            props2.defaultChecked,
            props2.type,
            props2.name,
            true
          );
          break;
        case "option":
          validateOptionProps(didHydrate, props2);
          break;
        case "select":
          checkControlledValueProps("select", props2);
          listenToNonDelegatedEvent("invalid", didHydrate);
          validateSelectProps(didHydrate, props2);
          break;
        case "textarea":
          checkControlledValueProps("textarea", props2), listenToNonDelegatedEvent("invalid", didHydrate), validateTextareaProps(didHydrate, props2), initTextarea(
            didHydrate,
            props2.value,
            props2.defaultValue,
            props2.children
          );
      }
      type = props2.children;
      "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || didHydrate.textContent === "" + type || true === props2.suppressHydrationWarning || checkForUnmatchedText(didHydrate.textContent, type) ? (null != props2.popover && (listenToNonDelegatedEvent("beforetoggle", didHydrate), listenToNonDelegatedEvent("toggle", didHydrate)), null != props2.onScroll && listenToNonDelegatedEvent("scroll", didHydrate), null != props2.onScrollEnd && listenToNonDelegatedEvent("scrollend", didHydrate), null != props2.onClick && (didHydrate.onclick = noop$12), didHydrate = true) : didHydrate = false;
      didHydrate || throwOnHydrationMismatch(fiber, true);
    }
    function popToNextHostParent(fiber) {
      for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
        switch (hydrationParentFiber.tag) {
          case 5:
          case 31:
          case 13:
            rootOrSingletonContext = false;
            return;
          case 27:
          case 3:
            rootOrSingletonContext = true;
            return;
          default:
            hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
      if (fiber !== hydrationParentFiber) return false;
      if (!isHydrating)
        return popToNextHostParent(fiber), isHydrating = true, false;
      var tag2 = fiber.tag, JSCompiler_temp;
      if (JSCompiler_temp = 3 !== tag2 && 27 !== tag2) {
        if (JSCompiler_temp = 5 === tag2)
          JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
      }
      if (JSCompiler_temp && nextHydratableInstance) {
        for (JSCompiler_temp = nextHydratableInstance; JSCompiler_temp; ) {
          var diffNode = buildHydrationDiffNode(fiber, 0), description = describeHydratableInstanceForDevWarnings(JSCompiler_temp);
          diffNode.serverTail.push(description);
          JSCompiler_temp = "Suspense" === description.type ? getNextHydratableInstanceAfterHydrationBoundary(JSCompiler_temp) : getNextHydratable(JSCompiler_temp.nextSibling);
        }
        throwOnHydrationMismatch(fiber);
      }
      popToNextHostParent(fiber);
      if (13 === tag2) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
      } else if (31 === tag2) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
      } else
        27 === tag2 ? (tag2 = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag2) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
      return true;
    }
    function resetHydrationState() {
      nextHydratableInstance = hydrationParentFiber = null;
      didSuspendOrErrorDEV = isHydrating = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
      var queuedErrors = hydrationErrors;
      null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(
        workInProgressRootRecoverableErrors,
        queuedErrors
      ), hydrationErrors = null);
      return queuedErrors;
    }
    function queueHydrationError(error) {
      null === hydrationErrors ? hydrationErrors = [error] : hydrationErrors.push(error);
    }
    function emitPendingHydrationWarnings() {
      var diffRoot = hydrationDiffRootDEV;
      if (null !== diffRoot) {
        hydrationDiffRootDEV = null;
        for (var diff = describeDiff(diffRoot); 0 < diffRoot.children.length; )
          diffRoot = diffRoot.children[0];
        runWithFiberInDEV(diffRoot.fiber, function() {
          console.error(
            "A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s",
            "https://react.dev/link/hydration-mismatch",
            diff
          );
        });
      }
    }
    function resetContextDependencies() {
      lastContextDependency = currentlyRenderingFiber$1 = null;
      isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
      push2(valueCursor, context._currentValue, providerFiber);
      context._currentValue = nextValue;
      push2(rendererCursorDEV, context._currentRenderer, providerFiber);
      void 0 !== context._currentRenderer && null !== context._currentRenderer && context._currentRenderer !== rendererSigil && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      );
      context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
      context._currentValue = valueCursor.current;
      var currentRenderer = rendererCursorDEV.current;
      pop(rendererCursorDEV, providerFiber);
      context._currentRenderer = currentRenderer;
      pop(valueCursor, providerFiber);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes2, propagationRoot) {
      for (; null !== parent; ) {
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes2) !== renderLanes2 ? (parent.childLanes |= renderLanes2, null !== alternate && (alternate.childLanes |= renderLanes2)) : null !== alternate && (alternate.childLanes & renderLanes2) !== renderLanes2 && (alternate.childLanes |= renderLanes2);
        if (parent === propagationRoot) break;
        parent = parent.return;
      }
      parent !== propagationRoot && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function propagateContextChanges(workInProgress2, contexts, renderLanes2, forcePropagateEntireTree) {
      var fiber = workInProgress2.child;
      null !== fiber && (fiber.return = workInProgress2);
      for (; null !== fiber; ) {
        var list2 = fiber.dependencies;
        if (null !== list2) {
          var nextFiber = fiber.child;
          list2 = list2.firstContext;
          a: for (; null !== list2; ) {
            var dependency = list2;
            list2 = fiber;
            for (var i2 = 0; i2 < contexts.length; i2++)
              if (dependency.context === contexts[i2]) {
                list2.lanes |= renderLanes2;
                dependency = list2.alternate;
                null !== dependency && (dependency.lanes |= renderLanes2);
                scheduleContextWorkOnParentPath(
                  list2.return,
                  renderLanes2,
                  workInProgress2
                );
                forcePropagateEntireTree || (nextFiber = null);
                break a;
              }
            list2 = dependency.next;
          }
        } else if (18 === fiber.tag) {
          nextFiber = fiber.return;
          if (null === nextFiber)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          nextFiber.lanes |= renderLanes2;
          list2 = nextFiber.alternate;
          null !== list2 && (list2.lanes |= renderLanes2);
          scheduleContextWorkOnParentPath(
            nextFiber,
            renderLanes2,
            workInProgress2
          );
          nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else
          for (nextFiber = fiber; null !== nextFiber; ) {
            if (nextFiber === workInProgress2) {
              nextFiber = null;
              break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
              fiber.return = nextFiber.return;
              nextFiber = fiber;
              break;
            }
            nextFiber = nextFiber.return;
          }
        fiber = nextFiber;
      }
    }
    function propagateParentContextChanges(current3, workInProgress2, renderLanes2, forcePropagateEntireTree) {
      current3 = null;
      for (var parent = workInProgress2, isInsidePropagationBailout = false; null !== parent; ) {
        if (!isInsidePropagationBailout) {
          if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
          else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
          var currentParent = parent.alternate;
          if (null === currentParent)
            throw Error("Should have a current fiber. This is a bug in React.");
          currentParent = currentParent.memoizedProps;
          if (null !== currentParent) {
            var context = parent.type;
            objectIs(parent.pendingProps.value, currentParent.value) || (null !== current3 ? current3.push(context) : current3 = [context]);
          }
        } else if (parent === hostTransitionProviderCursor.current) {
          currentParent = parent.alternate;
          if (null === currentParent)
            throw Error("Should have a current fiber. This is a bug in React.");
          currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current3 ? current3.push(HostTransitionContext) : current3 = [HostTransitionContext]);
        }
        parent = parent.return;
      }
      null !== current3 && propagateContextChanges(
        workInProgress2,
        current3,
        renderLanes2,
        forcePropagateEntireTree
      );
      workInProgress2.flags |= 262144;
    }
    function checkIfContextChanged(currentDependencies) {
      for (currentDependencies = currentDependencies.firstContext; null !== currentDependencies; ) {
        if (!objectIs(
          currentDependencies.context._currentValue,
          currentDependencies.memoizedValue
        ))
          return true;
        currentDependencies = currentDependencies.next;
      }
      return false;
    }
    function prepareToReadContext(workInProgress2) {
      currentlyRenderingFiber$1 = workInProgress2;
      lastContextDependency = null;
      workInProgress2 = workInProgress2.dependencies;
      null !== workInProgress2 && (workInProgress2.firstContext = null);
    }
    function readContext(context) {
      isDisallowedContextReadInDEV && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
      return readContextForConsumer(currentlyRenderingFiber$1, context);
    }
    function readContextDuringReconciliation(consumer, context) {
      null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
      return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
      var value = context._currentValue;
      context = { context, memoizedValue: value, next: null };
      if (null === lastContextDependency) {
        if (null === consumer)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        lastContextDependency = context;
        consumer.dependencies = {
          lanes: 0,
          firstContext: context,
          _debugThenableState: null
        };
        consumer.flags |= 524288;
      } else lastContextDependency = lastContextDependency.next = context;
      return value;
    }
    function createCache() {
      return {
        controller: new AbortControllerLocal(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function retainCache(cache) {
      cache.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      );
      cache.refCount++;
    }
    function releaseCache(cache) {
      cache.refCount--;
      0 > cache.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      );
      0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
      });
    }
    function startUpdateTimerByLane(lane, method, fiber) {
      if (0 !== (lane & 127))
        0 > blockingUpdateTime && (blockingUpdateTime = now2(), blockingUpdateTask = createTask(method), blockingUpdateMethodName = method, null != fiber && (blockingUpdateComponentName = getComponentNameFromFiber(fiber)), (executionContext & (RenderContext | CommitContext)) !== NoContext && (componentEffectSpawnedUpdate = true, blockingUpdateType = SPAWNED_UPDATE), lane = resolveEventTimeStamp(), method = resolveEventType(), lane !== blockingEventRepeatTime || method !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== method && (blockingUpdateType = SPAWNED_UPDATE), blockingEventTime = lane, blockingEventType = method);
      else if (0 !== (lane & 4194048) && 0 > transitionUpdateTime && (transitionUpdateTime = now2(), transitionUpdateTask = createTask(method), transitionUpdateMethodName = method, null != fiber && (transitionUpdateComponentName = getComponentNameFromFiber(fiber)), 0 > transitionStartTime)) {
        lane = resolveEventTimeStamp();
        method = resolveEventType();
        if (lane !== transitionEventRepeatTime || method !== transitionEventType)
          transitionEventRepeatTime = -1.1;
        transitionEventTime = lane;
        transitionEventType = method;
      }
    }
    function startHostActionTimer(fiber) {
      if (0 > blockingUpdateTime) {
        blockingUpdateTime = now2();
        blockingUpdateTask = null != fiber._debugTask ? fiber._debugTask : null;
        (executionContext & (RenderContext | CommitContext)) !== NoContext && (blockingUpdateType = SPAWNED_UPDATE);
        var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
        newEventTime !== blockingEventRepeatTime || newEventType !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== newEventType && (blockingUpdateType = SPAWNED_UPDATE);
        blockingEventTime = newEventTime;
        blockingEventType = newEventType;
      }
      if (0 > transitionUpdateTime && (transitionUpdateTime = now2(), transitionUpdateTask = null != fiber._debugTask ? fiber._debugTask : null, 0 > transitionStartTime)) {
        fiber = resolveEventTimeStamp();
        newEventTime = resolveEventType();
        if (fiber !== transitionEventRepeatTime || newEventTime !== transitionEventType)
          transitionEventRepeatTime = -1.1;
        transitionEventTime = fiber;
        transitionEventType = newEventTime;
      }
    }
    function pushNestedEffectDurations() {
      var prevEffectDuration = profilerEffectDuration;
      profilerEffectDuration = 0;
      return prevEffectDuration;
    }
    function popNestedEffectDurations(prevEffectDuration) {
      var elapsedTime = profilerEffectDuration;
      profilerEffectDuration = prevEffectDuration;
      return elapsedTime;
    }
    function bubbleNestedEffectDurations(prevEffectDuration) {
      var elapsedTime = profilerEffectDuration;
      profilerEffectDuration += prevEffectDuration;
      return elapsedTime;
    }
    function resetComponentEffectTimers() {
      componentEffectEndTime = componentEffectStartTime = -1.1;
    }
    function pushComponentEffectStart() {
      var prevEffectStart = componentEffectStartTime;
      componentEffectStartTime = -1.1;
      return prevEffectStart;
    }
    function popComponentEffectStart(prevEffectStart) {
      0 <= prevEffectStart && (componentEffectStartTime = prevEffectStart);
    }
    function pushComponentEffectDuration() {
      var prevEffectDuration = componentEffectDuration;
      componentEffectDuration = -0;
      return prevEffectDuration;
    }
    function popComponentEffectDuration(prevEffectDuration) {
      0 <= prevEffectDuration && (componentEffectDuration = prevEffectDuration);
    }
    function pushComponentEffectErrors() {
      var prevErrors = componentEffectErrors;
      componentEffectErrors = null;
      return prevErrors;
    }
    function pushComponentEffectDidSpawnUpdate() {
      var prev = componentEffectSpawnedUpdate;
      componentEffectSpawnedUpdate = false;
      return prev;
    }
    function startProfilerTimer(fiber) {
      profilerStartTime = now2();
      0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
    }
    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
      if (0 <= profilerStartTime) {
        var elapsedTime = now2() - profilerStartTime;
        fiber.actualDuration += elapsedTime;
        fiber.selfBaseDuration = elapsedTime;
        profilerStartTime = -1;
      }
    }
    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
      if (0 <= profilerStartTime) {
        var elapsedTime = now2() - profilerStartTime;
        fiber.actualDuration += elapsedTime;
        profilerStartTime = -1;
      }
    }
    function recordEffectDuration() {
      if (0 <= profilerStartTime) {
        var endTime = now2(), elapsedTime = endTime - profilerStartTime;
        profilerStartTime = -1;
        profilerEffectDuration += elapsedTime;
        componentEffectDuration += elapsedTime;
        componentEffectEndTime = endTime;
      }
    }
    function recordEffectError(errorInfo) {
      null === componentEffectErrors && (componentEffectErrors = []);
      componentEffectErrors.push(errorInfo);
      null === commitErrors && (commitErrors = []);
      commitErrors.push(errorInfo);
    }
    function startEffectTimer() {
      profilerStartTime = now2();
      0 > componentEffectStartTime && (componentEffectStartTime = profilerStartTime);
    }
    function transferActualDuration(fiber) {
      for (var child = fiber.child; child; )
        fiber.actualDuration += child.actualDuration, child = child.sibling;
    }
    function entangleAsyncAction(transition, thenable) {
      if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
          status: "pending",
          value: void 0,
          then: function(resolve) {
            entangledListeners.push(resolve);
          }
        };
      }
      currentEntangledPendingCount++;
      thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
      return thenable;
    }
    function pingEngtangledActionScope() {
      if (0 === --currentEntangledPendingCount && (-1 < transitionUpdateTime || (transitionStartTime = -1.1), null !== currentEntangledListeners)) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for (var i2 = 0; i2 < listeners.length; i2++) (0, listeners[i2])();
      }
    }
    function chainThenableValue(thenable, result2) {
      var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
          listeners.push(resolve);
        }
      };
      thenable.then(
        function() {
          thenableWithOverride.status = "fulfilled";
          thenableWithOverride.value = result2;
          for (var i2 = 0; i2 < listeners.length; i2++) (0, listeners[i2])(result2);
        },
        function(error) {
          thenableWithOverride.status = "rejected";
          thenableWithOverride.reason = error;
          for (error = 0; error < listeners.length; error++)
            (0, listeners[error])(void 0);
        }
      );
      return thenableWithOverride;
    }
    function peekCacheFromPool() {
      var cacheResumedFromPreviousRender = resumedCache.current;
      return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
      null === prevCachePool ? push2(resumedCache, resumedCache.current, offscreenWorkInProgress) : push2(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
    }
    function getSuspendedCache() {
      var cacheFromPool = peekCacheFromPool();
      return null === cacheFromPool ? null : { parent: CacheContext._currentValue, pool: cacheFromPool };
    }
    function createThenableState() {
      return { didWarnAboutUncachedPromise: false, thenables: [] };
    }
    function isThenableResolved(thenable) {
      thenable = thenable.status;
      return "fulfilled" === thenable || "rejected" === thenable;
    }
    function trackUsedThenable(thenableState2, thenable, index2) {
      null !== ReactSharedInternals.actQueue && (ReactSharedInternals.didUsePromise = true);
      var trackedThenables = thenableState2.thenables;
      index2 = trackedThenables[index2];
      void 0 === index2 ? trackedThenables.push(thenable) : index2 !== thenable && (thenableState2.didWarnAboutUncachedPromise || (thenableState2.didWarnAboutUncachedPromise = true, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), thenable.then(noop$12, noop$12), thenable = index2);
      if (void 0 === thenable._debugInfo) {
        thenableState2 = performance.now();
        trackedThenables = thenable.displayName;
        var ioInfo = {
          name: "string" === typeof trackedThenables ? trackedThenables : "Promise",
          start: thenableState2,
          end: thenableState2,
          value: thenable
        };
        thenable._debugInfo = [{ awaited: ioInfo }];
        "fulfilled" !== thenable.status && "rejected" !== thenable.status && (thenableState2 = function() {
          ioInfo.end = performance.now();
        }, thenable.then(thenableState2, thenableState2));
      }
      switch (thenable.status) {
        case "fulfilled":
          return thenable.value;
        case "rejected":
          throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
        default:
          if ("string" === typeof thenable.status)
            thenable.then(noop$12, noop$12);
          else {
            thenableState2 = workInProgressRoot;
            if (null !== thenableState2 && 100 < thenableState2.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            thenableState2 = thenable;
            thenableState2.status = "pending";
            thenableState2.then(
              function(fulfilledValue) {
                if ("pending" === thenable.status) {
                  var fulfilledThenable = thenable;
                  fulfilledThenable.status = "fulfilled";
                  fulfilledThenable.value = fulfilledValue;
                }
              },
              function(error) {
                if ("pending" === thenable.status) {
                  var rejectedThenable = thenable;
                  rejectedThenable.status = "rejected";
                  rejectedThenable.reason = error;
                }
              }
            );
          }
          switch (thenable.status) {
            case "fulfilled":
              return thenable.value;
            case "rejected":
              throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
          }
          suspendedThenable = thenable;
          needsToResetSuspendedThenableDEV = true;
          throw SuspenseException;
      }
    }
    function resolveLazy(lazyType) {
      try {
        return callLazyInitInDEV(lazyType);
      } catch (x2) {
        if (null !== x2 && "object" === typeof x2 && "function" === typeof x2.then)
          throw suspendedThenable = x2, needsToResetSuspendedThenableDEV = true, SuspenseException;
        throw x2;
      }
    }
    function getSuspendedThenable() {
      if (null === suspendedThenable)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var thenable = suspendedThenable;
      suspendedThenable = null;
      needsToResetSuspendedThenableDEV = false;
      return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
      if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function pushDebugInfo(debugInfo) {
      var previousDebugInfo = currentDebugInfo;
      null != debugInfo && (currentDebugInfo = null === previousDebugInfo ? debugInfo : previousDebugInfo.concat(debugInfo));
      return previousDebugInfo;
    }
    function getCurrentDebugTask() {
      var debugInfo = currentDebugInfo;
      if (null != debugInfo) {
        for (var i2 = debugInfo.length - 1; 0 <= i2; i2--)
          if (null != debugInfo[i2].name) {
            var debugTask = debugInfo[i2].debugTask;
            if (null != debugTask) return debugTask;
          }
      }
      return null;
    }
    function validateFragmentProps(element2, fiber, returnFiber) {
      for (var keys2 = Object.keys(element2.props), i2 = 0; i2 < keys2.length; i2++) {
        var key = keys2[i2];
        if ("children" !== key && "key" !== key) {
          null === fiber && (fiber = createFiberFromElement(element2, returnFiber.mode, 0), fiber._debugInfo = currentDebugInfo, fiber.return = returnFiber);
          runWithFiberInDEV(
            fiber,
            function(erroredKey) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                erroredKey
              );
            },
            key
          );
          break;
        }
      }
    }
    function unwrapThenable(thenable) {
      var index2 = thenableIndexCounter$1;
      thenableIndexCounter$1 += 1;
      null === thenableState$1 && (thenableState$1 = createThenableState());
      return trackUsedThenable(thenableState$1, thenable, index2);
    }
    function coerceRef(workInProgress2, element2) {
      element2 = element2.props.ref;
      workInProgress2.ref = void 0 !== element2 ? element2 : null;
    }
    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
      if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
        throw Error(
          'A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.'
        );
      returnFiber = Object.prototype.toString.call(newChild);
      throw Error(
        "Objects are not valid as a React child (found: " + ("[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
      var debugTask = getCurrentDebugTask();
      null !== debugTask ? debugTask.run(
        throwOnInvalidObjectTypeImpl.bind(null, returnFiber, newChild)
      ) : throwOnInvalidObjectTypeImpl(returnFiber, newChild);
    }
    function warnOnFunctionTypeImpl(returnFiber, invalidChild) {
      var parentName = getComponentNameFromFiber(returnFiber) || "Component";
      ownerHasFunctionTypeWarning[parentName] || (ownerHasFunctionTypeWarning[parentName] = true, invalidChild = invalidChild.displayName || invalidChild.name || "Component", 3 === returnFiber.tag ? console.error(
        "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)",
        invalidChild,
        invalidChild,
        invalidChild
      ) : console.error(
        "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>",
        invalidChild,
        invalidChild,
        parentName,
        invalidChild,
        parentName
      ));
    }
    function warnOnFunctionType(returnFiber, invalidChild) {
      var debugTask = getCurrentDebugTask();
      null !== debugTask ? debugTask.run(
        warnOnFunctionTypeImpl.bind(null, returnFiber, invalidChild)
      ) : warnOnFunctionTypeImpl(returnFiber, invalidChild);
    }
    function warnOnSymbolTypeImpl(returnFiber, invalidChild) {
      var parentName = getComponentNameFromFiber(returnFiber) || "Component";
      ownerHasSymbolTypeWarning[parentName] || (ownerHasSymbolTypeWarning[parentName] = true, invalidChild = String(invalidChild), 3 === returnFiber.tag ? console.error(
        "Symbols are not valid as a React child.\n  root.render(%s)",
        invalidChild
      ) : console.error(
        "Symbols are not valid as a React child.\n  <%s>%s</%s>",
        parentName,
        invalidChild,
        parentName
      ));
    }
    function warnOnSymbolType(returnFiber, invalidChild) {
      var debugTask = getCurrentDebugTask();
      null !== debugTask ? debugTask.run(
        warnOnSymbolTypeImpl.bind(null, returnFiber, invalidChild)
      ) : warnOnSymbolTypeImpl(returnFiber, invalidChild);
    }
    function createChildReconciler(shouldTrackSideEffects) {
      function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
          var deletions = returnFiber.deletions;
          null === deletions ? (returnFiber.deletions = [childToDelete], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
      }
      function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for (; null !== currentFirstChild; )
          deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
      }
      function mapRemainingChildren(currentFirstChild) {
        for (var existingChildren = /* @__PURE__ */ new Map(); null !== currentFirstChild; )
          null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
      }
      function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
      }
      function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects)
          return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex)
          return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
      }
      function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
      }
      function updateTextNode(returnFiber, current3, textContent, lanes) {
        if (null === current3 || 6 !== current3.tag)
          return current3 = createFiberFromText(
            textContent,
            returnFiber.mode,
            lanes
          ), current3.return = returnFiber, current3._debugOwner = returnFiber, current3._debugTask = returnFiber._debugTask, current3._debugInfo = currentDebugInfo, current3;
        current3 = useFiber(current3, textContent);
        current3.return = returnFiber;
        current3._debugInfo = currentDebugInfo;
        return current3;
      }
      function updateElement(returnFiber, current3, element2, lanes) {
        var elementType = element2.type;
        if (elementType === REACT_FRAGMENT_TYPE)
          return current3 = updateFragment(
            returnFiber,
            current3,
            element2.props.children,
            lanes,
            element2.key
          ), validateFragmentProps(element2, current3, returnFiber), current3;
        if (null !== current3 && (current3.elementType === elementType || isCompatibleFamilyForHotReloading(current3, element2) || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current3.type))
          return current3 = useFiber(current3, element2.props), coerceRef(current3, element2), current3.return = returnFiber, current3._debugOwner = element2._owner, current3._debugInfo = currentDebugInfo, current3;
        current3 = createFiberFromElement(element2, returnFiber.mode, lanes);
        coerceRef(current3, element2);
        current3.return = returnFiber;
        current3._debugInfo = currentDebugInfo;
        return current3;
      }
      function updatePortal(returnFiber, current3, portal, lanes) {
        if (null === current3 || 4 !== current3.tag || current3.stateNode.containerInfo !== portal.containerInfo || current3.stateNode.implementation !== portal.implementation)
          return current3 = createFiberFromPortal(portal, returnFiber.mode, lanes), current3.return = returnFiber, current3._debugInfo = currentDebugInfo, current3;
        current3 = useFiber(current3, portal.children || []);
        current3.return = returnFiber;
        current3._debugInfo = currentDebugInfo;
        return current3;
      }
      function updateFragment(returnFiber, current3, fragment, lanes, key) {
        if (null === current3 || 7 !== current3.tag)
          return current3 = createFiberFromFragment(
            fragment,
            returnFiber.mode,
            lanes,
            key
          ), current3.return = returnFiber, current3._debugOwner = returnFiber, current3._debugTask = returnFiber._debugTask, current3._debugInfo = currentDebugInfo, current3;
        current3 = useFiber(current3, fragment);
        current3.return = returnFiber;
        current3._debugInfo = currentDebugInfo;
        return current3;
      }
      function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return newChild = createFiberFromText(
            "" + newChild,
            returnFiber.mode,
            lanes
          ), newChild.return = returnFiber, newChild._debugOwner = returnFiber, newChild._debugTask = returnFiber._debugTask, newChild._debugInfo = currentDebugInfo, newChild;
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return lanes = createFiberFromElement(
                newChild,
                returnFiber.mode,
                lanes
              ), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
            case REACT_PORTAL_TYPE:
              return newChild = createFiberFromPortal(
                newChild,
                returnFiber.mode,
                lanes
              ), newChild.return = returnFiber, newChild._debugInfo = currentDebugInfo, newChild;
            case REACT_LAZY_TYPE:
              var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
              newChild = resolveLazy(newChild);
              returnFiber = createChild(returnFiber, newChild, lanes);
              currentDebugInfo = _prevDebugInfo;
              return returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild))
            return lanes = createFiberFromFragment(
              newChild,
              returnFiber.mode,
              lanes,
              null
            ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
          if ("function" === typeof newChild.then)
            return _prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = createChild(
              returnFiber,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = _prevDebugInfo, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return createChild(
              returnFiber,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return newChild.key === key ? (key = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(
                returnFiber,
                oldFiber,
                newChild,
                lanes
              ), currentDebugInfo = key, returnFiber) : null;
            case REACT_PORTAL_TYPE:
              return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
            case REACT_LAZY_TYPE:
              return key = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = updateSlot(
                returnFiber,
                oldFiber,
                newChild,
                lanes
              ), currentDebugInfo = key, returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
            if (null !== key) return null;
            key = pushDebugInfo(newChild._debugInfo);
            returnFiber = updateFragment(
              returnFiber,
              oldFiber,
              newChild,
              lanes,
              null
            );
            currentDebugInfo = key;
            return returnFiber;
          }
          if ("function" === typeof newChild.then)
            return key = pushDebugInfo(newChild._debugInfo), returnFiber = updateSlot(
              returnFiber,
              oldFiber,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = key, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return updateSlot(
              returnFiber,
              oldFiber,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return newIdx = existingChildren.get(
                null === newChild.key ? newIdx : newChild.key
              ) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(
                returnFiber,
                newIdx,
                newChild,
                lanes
              ), currentDebugInfo = existingChildren, returnFiber;
            case REACT_PORTAL_TYPE:
              return existingChildren = existingChildren.get(
                null === newChild.key ? newIdx : newChild.key
              ) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
            case REACT_LAZY_TYPE:
              var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
              newChild = resolveLazy(newChild);
              returnFiber = updateFromMap(
                existingChildren,
                returnFiber,
                newIdx,
                newChild,
                lanes
              );
              currentDebugInfo = _prevDebugInfo7;
              return returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild))
            return newIdx = existingChildren.get(newIdx) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateFragment(
              returnFiber,
              newIdx,
              newChild,
              lanes,
              null
            ), currentDebugInfo = existingChildren, returnFiber;
          if ("function" === typeof newChild.then)
            return _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo), returnFiber = updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = _prevDebugInfo7, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function warnOnInvalidKey(returnFiber, workInProgress2, child, knownKeys) {
        if ("object" !== typeof child || null === child) return knownKeys;
        switch (child.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            warnForMissingKey(returnFiber, workInProgress2, child);
            var key = child.key;
            if ("string" !== typeof key) break;
            if (null === knownKeys) {
              knownKeys = /* @__PURE__ */ new Set();
              knownKeys.add(key);
              break;
            }
            if (!knownKeys.has(key)) {
              knownKeys.add(key);
              break;
            }
            runWithFiberInDEV(workInProgress2, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                key
              );
            });
            break;
          case REACT_LAZY_TYPE:
            child = resolveLazy(child), warnOnInvalidKey(returnFiber, workInProgress2, child, knownKeys);
        }
        return knownKeys;
      }
      function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for (var knownKeys = null, resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++) {
          oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
          var newFiber = updateSlot(
            returnFiber,
            oldFiber,
            newChildren[newIdx],
            lanes
          );
          if (null === newFiber) {
            null === oldFiber && (oldFiber = nextOldFiber);
            break;
          }
          knownKeys = warnOnInvalidKey(
            returnFiber,
            newFiber,
            newChildren[newIdx],
            knownKeys
          );
          shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
          currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
          null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
          previousNewFiber = newFiber;
          oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length)
          return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
          for (; newIdx < newChildren.length; newIdx++)
            oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(
              returnFiber,
              oldFiber,
              newChildren[newIdx],
              knownKeys
            ), currentFirstChild = placeChild(
              oldFiber,
              currentFirstChild,
              newIdx
            ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
          isHydrating && pushTreeFork(returnFiber, newIdx);
          return resultingFirstChild;
        }
        for (oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)
          nextOldFiber = updateFromMap(
            oldFiber,
            returnFiber,
            newIdx,
            newChildren[newIdx],
            lanes
          ), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(
            returnFiber,
            nextOldFiber,
            newChildren[newIdx],
            knownKeys
          ), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
            null === nextOldFiber.key ? newIdx : nextOldFiber.key
          ), currentFirstChild = placeChild(
            nextOldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
          return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren)
          throw Error("An iterable object provided no iterator.");
        for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, knownKeys = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()) {
          oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
          var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
          if (null === newFiber) {
            null === oldFiber && (oldFiber = nextOldFiber);
            break;
          }
          knownKeys = warnOnInvalidKey(
            returnFiber,
            newFiber,
            step.value,
            knownKeys
          );
          shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
          currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
          null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
          previousNewFiber = newFiber;
          oldFiber = nextOldFiber;
        }
        if (step.done)
          return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
          for (; !step.done; newIdx++, step = newChildren.next())
            oldFiber = createChild(returnFiber, step.value, lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(
              returnFiber,
              oldFiber,
              step.value,
              knownKeys
            ), currentFirstChild = placeChild(
              oldFiber,
              currentFirstChild,
              newIdx
            ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
          isHydrating && pushTreeFork(returnFiber, newIdx);
          return resultingFirstChild;
        }
        for (oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())
          nextOldFiber = updateFromMap(
            oldFiber,
            returnFiber,
            newIdx,
            step.value,
            lanes
          ), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(
            returnFiber,
            nextOldFiber,
            step.value,
            knownKeys
          ), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
            null === nextOldFiber.key ? newIdx : nextOldFiber.key
          ), currentFirstChild = placeChild(
            nextOldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
          return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (validateFragmentProps(newChild, null, returnFiber), newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
              a: {
                for (var key = newChild.key; null !== currentFirstChild; ) {
                  if (currentFirstChild.key === key) {
                    key = newChild.type;
                    if (key === REACT_FRAGMENT_TYPE) {
                      if (7 === currentFirstChild.tag) {
                        deleteRemainingChildren(
                          returnFiber,
                          currentFirstChild.sibling
                        );
                        lanes = useFiber(
                          currentFirstChild,
                          newChild.props.children
                        );
                        lanes.return = returnFiber;
                        lanes._debugOwner = newChild._owner;
                        lanes._debugInfo = currentDebugInfo;
                        validateFragmentProps(newChild, lanes, returnFiber);
                        returnFiber = lanes;
                        break a;
                      }
                    } else if (currentFirstChild.elementType === key || isCompatibleFamilyForHotReloading(
                      currentFirstChild,
                      newChild
                    ) || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(currentFirstChild, newChild.props);
                      coerceRef(lanes, newChild);
                      lanes.return = returnFiber;
                      lanes._debugOwner = newChild._owner;
                      lanes._debugInfo = currentDebugInfo;
                      returnFiber = lanes;
                      break a;
                    }
                    deleteRemainingChildren(returnFiber, currentFirstChild);
                    break;
                  } else deleteChild(returnFiber, currentFirstChild);
                  currentFirstChild = currentFirstChild.sibling;
                }
                newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(
                  newChild.props.children,
                  returnFiber.mode,
                  lanes,
                  newChild.key
                ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, validateFragmentProps(newChild, lanes, returnFiber), returnFiber = lanes) : (lanes = createFiberFromElement(
                  newChild,
                  returnFiber.mode,
                  lanes
                ), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugInfo = currentDebugInfo, returnFiber = lanes);
              }
              returnFiber = placeSingleChild(returnFiber);
              currentDebugInfo = prevDebugInfo;
              return returnFiber;
            case REACT_PORTAL_TYPE:
              a: {
                prevDebugInfo = newChild;
                for (newChild = prevDebugInfo.key; null !== currentFirstChild; ) {
                  if (currentFirstChild.key === newChild)
                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === prevDebugInfo.containerInfo && currentFirstChild.stateNode.implementation === prevDebugInfo.implementation) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(
                        currentFirstChild,
                        prevDebugInfo.children || []
                      );
                      lanes.return = returnFiber;
                      returnFiber = lanes;
                      break a;
                    } else {
                      deleteRemainingChildren(returnFiber, currentFirstChild);
                      break;
                    }
                  else deleteChild(returnFiber, currentFirstChild);
                  currentFirstChild = currentFirstChild.sibling;
                }
                lanes = createFiberFromPortal(
                  prevDebugInfo,
                  returnFiber.mode,
                  lanes
                );
                lanes.return = returnFiber;
                returnFiber = lanes;
              }
              return placeSingleChild(returnFiber);
            case REACT_LAZY_TYPE:
              return prevDebugInfo = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = reconcileChildFibersImpl(
                returnFiber,
                currentFirstChild,
                newChild,
                lanes
              ), currentDebugInfo = prevDebugInfo, returnFiber;
          }
          if (isArrayImpl(newChild))
            return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildrenArray(
              returnFiber,
              currentFirstChild,
              newChild,
              lanes
            ), currentDebugInfo = prevDebugInfo, returnFiber;
          if (getIteratorFn(newChild)) {
            prevDebugInfo = pushDebugInfo(newChild._debugInfo);
            key = getIteratorFn(newChild);
            if ("function" !== typeof key)
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var newChildren = key.call(newChild);
            if (newChildren === newChild) {
              if (0 !== returnFiber.tag || "[object GeneratorFunction]" !== Object.prototype.toString.call(returnFiber.type) || "[object Generator]" !== Object.prototype.toString.call(newChildren))
                didWarnAboutGenerators || console.error(
                  "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
                ), didWarnAboutGenerators = true;
            } else
              newChild.entries !== key || didWarnAboutMaps || (console.error(
                "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
              ), didWarnAboutMaps = true);
            returnFiber = reconcileChildrenIterator(
              returnFiber,
              currentFirstChild,
              newChildren,
              lanes
            );
            currentDebugInfo = prevDebugInfo;
            return returnFiber;
          }
          if ("function" === typeof newChild.then)
            return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = prevDebugInfo, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return prevDebugInfo = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(
            returnFiber,
            currentFirstChild.sibling
          ), lanes = useFiber(currentFirstChild, prevDebugInfo), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(
            prevDebugInfo,
            returnFiber.mode,
            lanes
          ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, returnFiber = lanes), placeSingleChild(returnFiber);
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return deleteRemainingChildren(returnFiber, currentFirstChild);
      }
      return function(returnFiber, currentFirstChild, newChild, lanes) {
        var prevDebugInfo = currentDebugInfo;
        currentDebugInfo = null;
        try {
          thenableIndexCounter$1 = 0;
          var firstChildFiber = reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
          thenableState$1 = null;
          return firstChildFiber;
        } catch (x2) {
          if (x2 === SuspenseException || x2 === SuspenseActionException) throw x2;
          var fiber = createFiber(29, x2, null, returnFiber.mode);
          fiber.lanes = lanes;
          fiber.return = returnFiber;
          var debugInfo = fiber._debugInfo = currentDebugInfo;
          fiber._debugOwner = returnFiber._debugOwner;
          fiber._debugTask = returnFiber._debugTask;
          if (null != debugInfo) {
            for (var i2 = debugInfo.length - 1; 0 <= i2; i2--)
              if ("string" === typeof debugInfo[i2].stack) {
                fiber._debugOwner = debugInfo[i2];
                fiber._debugTask = debugInfo[i2].debugTask;
                break;
              }
          }
          return fiber;
        } finally {
          currentDebugInfo = prevDebugInfo;
        }
      };
    }
    function validateSuspenseListNestedChild(childSlot, index2) {
      var isAnArray = isArrayImpl(childSlot);
      childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
      return isAnArray || childSlot ? (isAnArray = isAnArray ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        isAnArray,
        index2,
        isAnArray
      ), false) : true;
    }
    function initializeUpdateQueue(fiber) {
      fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function cloneUpdateQueue(current3, workInProgress2) {
      current3 = current3.updateQueue;
      workInProgress2.updateQueue === current3 && (workInProgress2.updateQueue = {
        baseState: current3.baseState,
        firstBaseUpdate: current3.firstBaseUpdate,
        lastBaseUpdate: current3.lastBaseUpdate,
        shared: current3.shared,
        callbacks: null
      });
    }
    function createUpdate(lane) {
      return {
        lane,
        tag: UpdateState,
        payload: null,
        callback: null,
        next: null
      };
    }
    function enqueueUpdate(fiber, update, lane) {
      var updateQueue = fiber.updateQueue;
      if (null === updateQueue) return null;
      updateQueue = updateQueue.shared;
      if (currentlyProcessingQueue === updateQueue && !didWarnUpdateInsideUpdate) {
        var componentName2 = getComponentNameFromFiber(fiber);
        console.error(
          "An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s",
          componentName2
        );
        didWarnUpdateInsideUpdate = true;
      }
      if ((executionContext & RenderContext) !== NoContext)
        return componentName2 = updateQueue.pending, null === componentName2 ? update.next = update : (update.next = componentName2.next, componentName2.next = update), updateQueue.pending = update, update = getRootForUpdatedFiber(fiber), markUpdateLaneFromFiberToRoot(fiber, null, lane), update;
      enqueueUpdate$1(fiber, updateQueue, update, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root3, fiber, lane) {
      fiber = fiber.updateQueue;
      if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root3.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root3, lane);
      }
    }
    function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
      var queue2 = workInProgress2.updateQueue, current3 = workInProgress2.alternate;
      if (null !== current3 && (current3 = current3.updateQueue, queue2 === current3)) {
        var newFirst = null, newLast = null;
        queue2 = queue2.firstBaseUpdate;
        if (null !== queue2) {
          do {
            var clone2 = {
              lane: queue2.lane,
              tag: queue2.tag,
              payload: queue2.payload,
              callback: null,
              next: null
            };
            null === newLast ? newFirst = newLast = clone2 : newLast = newLast.next = clone2;
            queue2 = queue2.next;
          } while (null !== queue2);
          null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue2 = {
          baseState: current3.baseState,
          firstBaseUpdate: newFirst,
          lastBaseUpdate: newLast,
          shared: current3.shared,
          callbacks: current3.callbacks
        };
        workInProgress2.updateQueue = queue2;
        return;
      }
      workInProgress2 = queue2.lastBaseUpdate;
      null === workInProgress2 ? queue2.firstBaseUpdate = capturedUpdate : workInProgress2.next = capturedUpdate;
      queue2.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
      if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
      }
    }
    function processUpdateQueue(workInProgress2, props2, instance$jscomp$0, renderLanes2) {
      didReadFromEntangledAsyncAction = false;
      var queue2 = workInProgress2.updateQueue;
      hasForceUpdate = false;
      currentlyProcessingQueue = queue2.shared;
      var firstBaseUpdate = queue2.firstBaseUpdate, lastBaseUpdate = queue2.lastBaseUpdate, pendingQueue = queue2.shared.pending;
      if (null !== pendingQueue) {
        queue2.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current3 = workInProgress2.alternate;
        null !== current3 && (current3 = current3.updateQueue, pendingQueue = current3.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current3.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current3.lastBaseUpdate = lastPendingUpdate));
      }
      if (null !== firstBaseUpdate) {
        var newState = queue2.baseState;
        lastBaseUpdate = 0;
        current3 = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
          var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
          if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes2 & updateLane) === updateLane) {
            0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = true);
            null !== current3 && (current3 = current3.next = {
              lane: 0,
              tag: pendingQueue.tag,
              payload: pendingQueue.payload,
              callback: null,
              next: null
            });
            a: {
              updateLane = workInProgress2;
              var partialState = pendingQueue;
              var nextProps = props2, instance = instance$jscomp$0;
              switch (partialState.tag) {
                case ReplaceState:
                  partialState = partialState.payload;
                  if ("function" === typeof partialState) {
                    isDisallowedContextReadInDEV = true;
                    var nextState = partialState.call(
                      instance,
                      newState,
                      nextProps
                    );
                    if (updateLane.mode & StrictLegacyMode) {
                      setIsStrictModeForDevtools(true);
                      try {
                        partialState.call(instance, newState, nextProps);
                      } finally {
                        setIsStrictModeForDevtools(false);
                      }
                    }
                    isDisallowedContextReadInDEV = false;
                    newState = nextState;
                    break a;
                  }
                  newState = partialState;
                  break a;
                case CaptureUpdate:
                  updateLane.flags = updateLane.flags & -65537 | 128;
                case UpdateState:
                  nextState = partialState.payload;
                  if ("function" === typeof nextState) {
                    isDisallowedContextReadInDEV = true;
                    partialState = nextState.call(
                      instance,
                      newState,
                      nextProps
                    );
                    if (updateLane.mode & StrictLegacyMode) {
                      setIsStrictModeForDevtools(true);
                      try {
                        nextState.call(instance, newState, nextProps);
                      } finally {
                        setIsStrictModeForDevtools(false);
                      }
                    }
                    isDisallowedContextReadInDEV = false;
                  } else partialState = nextState;
                  if (null === partialState || void 0 === partialState) break a;
                  newState = assign2({}, newState, partialState);
                  break a;
                case ForceUpdate:
                  hasForceUpdate = true;
              }
            }
            updateLane = pendingQueue.callback;
            null !== updateLane && (workInProgress2.flags |= 64, isHiddenUpdate && (workInProgress2.flags |= 8192), isHiddenUpdate = queue2.callbacks, null === isHiddenUpdate ? queue2.callbacks = [updateLane] : isHiddenUpdate.push(updateLane));
          } else
            isHiddenUpdate = {
              lane: updateLane,
              tag: pendingQueue.tag,
              payload: pendingQueue.payload,
              callback: pendingQueue.callback,
              next: null
            }, null === current3 ? (firstPendingUpdate = current3 = isHiddenUpdate, lastPendingUpdate = newState) : current3 = current3.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
          pendingQueue = pendingQueue.next;
          if (null === pendingQueue)
            if (pendingQueue = queue2.shared.pending, null === pendingQueue)
              break;
            else
              isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue2.lastBaseUpdate = isHiddenUpdate, queue2.shared.pending = null;
        } while (1);
        null === current3 && (lastPendingUpdate = newState);
        queue2.baseState = lastPendingUpdate;
        queue2.firstBaseUpdate = firstPendingUpdate;
        queue2.lastBaseUpdate = current3;
        null === firstBaseUpdate && (queue2.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress2.lanes = lastBaseUpdate;
        workInProgress2.memoizedState = newState;
      }
      currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
      if ("function" !== typeof callback)
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + callback
        );
      callback.call(context);
    }
    function commitHiddenCallbacks(updateQueue, context) {
      var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
      if (null !== hiddenCallbacks)
        for (updateQueue.shared.hiddenCallbacks = null, updateQueue = 0; updateQueue < hiddenCallbacks.length; updateQueue++)
          callCallback(hiddenCallbacks[updateQueue], context);
    }
    function commitCallbacks(updateQueue, context) {
      var callbacks = updateQueue.callbacks;
      if (null !== callbacks)
        for (updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)
          callCallback(callbacks[updateQueue], context);
    }
    function pushHiddenContext(fiber, context) {
      var prevEntangledRenderLanes = entangledRenderLanes;
      push2(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
      push2(currentTreeHiddenStackCursor, context, fiber);
      entangledRenderLanes = prevEntangledRenderLanes | context.baseLanes;
    }
    function reuseHiddenContextOnStack(fiber) {
      push2(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
      push2(
        currentTreeHiddenStackCursor,
        currentTreeHiddenStackCursor.current,
        fiber
      );
    }
    function popHiddenContext(fiber) {
      entangledRenderLanes = prevEntangledRenderLanesCursor.current;
      pop(currentTreeHiddenStackCursor, fiber);
      pop(prevEntangledRenderLanesCursor, fiber);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
      var current3 = handler.alternate;
      push2(
        suspenseStackCursor,
        suspenseStackCursor.current & SubtreeSuspenseContextMask,
        handler
      );
      push2(suspenseHandlerStackCursor, handler, handler);
      null === shellBoundary && (null === current3 || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current3.memoizedState && (shellBoundary = handler));
    }
    function pushDehydratedActivitySuspenseHandler(fiber) {
      push2(suspenseStackCursor, suspenseStackCursor.current, fiber);
      push2(suspenseHandlerStackCursor, fiber, fiber);
      null === shellBoundary && (shellBoundary = fiber);
    }
    function pushOffscreenSuspenseHandler(fiber) {
      22 === fiber.tag ? (push2(suspenseStackCursor, suspenseStackCursor.current, fiber), push2(suspenseHandlerStackCursor, fiber, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack(fiber) {
      push2(suspenseStackCursor, suspenseStackCursor.current, fiber);
      push2(
        suspenseHandlerStackCursor,
        suspenseHandlerStackCursor.current,
        fiber
      );
    }
    function popSuspenseHandler(fiber) {
      pop(suspenseHandlerStackCursor, fiber);
      shellBoundary === fiber && (shellBoundary = null);
      pop(suspenseStackCursor, fiber);
    }
    function findFirstSuspended(row) {
      for (var node = row; null !== node; ) {
        if (13 === node.tag) {
          var state = node.memoizedState;
          if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state)))
            return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
          if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
          node.child.return = node;
          node = node.child;
          continue;
        }
        if (node === row) break;
        for (; null === node.sibling; ) {
          if (null === node.return || node.return === row) return null;
          node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
      }
      return null;
    }
    function mountHookTypesDev() {
      var hookName = currentHookNameInDev;
      null === hookTypesDev ? hookTypesDev = [hookName] : hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
      var hookName = currentHookNameInDev;
      if (null !== hookTypesDev && (hookTypesUpdateIndexDev++, hookTypesDev[hookTypesUpdateIndexDev] !== hookName)) {
        var componentName2 = getComponentNameFromFiber(currentlyRenderingFiber);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName2) && (didWarnAboutMismatchedHooksForComponent.add(componentName2), null !== hookTypesDev)) {
          for (var table = "", i2 = 0; i2 <= hookTypesUpdateIndexDev; i2++) {
            var oldHookName = hookTypesDev[i2], newHookName = i2 === hookTypesUpdateIndexDev ? hookName : oldHookName;
            for (oldHookName = i2 + 1 + ". " + oldHookName; 30 > oldHookName.length; )
              oldHookName += " ";
            oldHookName += newHookName + "\n";
            table += oldHookName;
          }
          console.error(
            "React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n",
            componentName2,
            table
          );
        }
      }
    }
    function checkDepsAreArrayDev(deps) {
      void 0 === deps || null === deps || isArrayImpl(deps) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        currentHookNameInDev,
        typeof deps
      );
    }
    function warnOnUseFormStateInDev() {
      var componentName2 = getComponentNameFromFiber(currentlyRenderingFiber);
      didWarnAboutUseFormState.has(componentName2) || (didWarnAboutUseFormState.add(componentName2), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        componentName2
      ));
    }
    function throwInvalidHookError() {
      throw Error(
        "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."
      );
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
      if (ignorePreviousDependencies) return false;
      if (null === prevDeps)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          currentHookNameInDev
        ), false;
      nextDeps.length !== prevDeps.length && console.error(
        "The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s",
        currentHookNameInDev,
        "[" + prevDeps.join(", ") + "]",
        "[" + nextDeps.join(", ") + "]"
      );
      for (var i2 = 0; i2 < prevDeps.length && i2 < nextDeps.length; i2++)
        if (!objectIs(nextDeps[i2], prevDeps[i2])) return false;
      return true;
    }
    function renderWithHooks(current3, workInProgress2, Component, props2, secondArg, nextRenderLanes) {
      renderLanes = nextRenderLanes;
      currentlyRenderingFiber = workInProgress2;
      hookTypesDev = null !== current3 ? current3._debugHookTypes : null;
      hookTypesUpdateIndexDev = -1;
      ignorePreviousDependencies = null !== current3 && current3.type !== workInProgress2.type;
      if ("[object AsyncFunction]" === Object.prototype.toString.call(Component) || "[object AsyncGeneratorFunction]" === Object.prototype.toString.call(Component))
        nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber), didWarnAboutAsyncClientComponent.has(nextRenderLanes) || (didWarnAboutAsyncClientComponent.add(nextRenderLanes), console.error(
          "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
          null === nextRenderLanes ? "An unknown Component" : "<" + nextRenderLanes + ">"
        ));
      workInProgress2.memoizedState = null;
      workInProgress2.updateQueue = null;
      workInProgress2.lanes = 0;
      ReactSharedInternals.H = null !== current3 && null !== current3.memoizedState ? HooksDispatcherOnUpdateInDEV : null !== hookTypesDev ? HooksDispatcherOnMountWithHookTypesInDEV : HooksDispatcherOnMountInDEV;
      shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes = (workInProgress2.mode & StrictLegacyMode) !== NoMode;
      var children = callComponentInDEV(Component, props2, secondArg);
      shouldDoubleInvokeUserFnsInHooksDEV = false;
      didScheduleRenderPhaseUpdateDuringThisPass && (children = renderWithHooksAgain(
        workInProgress2,
        Component,
        props2,
        secondArg
      ));
      if (nextRenderLanes) {
        setIsStrictModeForDevtools(true);
        try {
          children = renderWithHooksAgain(
            workInProgress2,
            Component,
            props2,
            secondArg
          );
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      finishRenderingHooks(current3, workInProgress2);
      return children;
    }
    function finishRenderingHooks(current3, workInProgress2) {
      workInProgress2._debugHookTypes = hookTypesDev;
      null === workInProgress2.dependencies ? null !== thenableState && (workInProgress2.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: thenableState
      }) : workInProgress2.dependencies._debugThenableState = thenableState;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
      renderLanes = 0;
      hookTypesDev = currentHookNameInDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
      hookTypesUpdateIndexDev = -1;
      null !== current3 && (current3.flags & 65011712) !== (workInProgress2.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      );
      didScheduleRenderPhaseUpdate = false;
      thenableIndexCounter = 0;
      thenableState = null;
      if (didRenderTooFewHooks)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      null === current3 || didReceiveUpdate || (current3 = current3.dependencies, null !== current3 && checkIfContextChanged(current3) && (didReceiveUpdate = true));
      needsToResetSuspendedThenableDEV ? (needsToResetSuspendedThenableDEV = false, current3 = true) : current3 = false;
      current3 && (workInProgress2 = getComponentNameFromFiber(workInProgress2) || "Unknown", didWarnAboutUseWrappedInTryCatch.has(workInProgress2) || didWarnAboutAsyncClientComponent.has(workInProgress2) || (didWarnAboutUseWrappedInTryCatch.add(workInProgress2), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function renderWithHooksAgain(workInProgress2, Component, props2, secondArg) {
      currentlyRenderingFiber = workInProgress2;
      var numberOfReRenders = 0;
      do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
        thenableIndexCounter = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        if (numberOfReRenders >= RE_RENDER_LIMIT)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        numberOfReRenders += 1;
        ignorePreviousDependencies = false;
        workInProgressHook = currentHook = null;
        if (null != workInProgress2.updateQueue) {
          var children = workInProgress2.updateQueue;
          children.lastEffect = null;
          children.events = null;
          children.stores = null;
          null != children.memoCache && (children.memoCache.index = 0);
        }
        hookTypesUpdateIndexDev = -1;
        ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
        children = callComponentInDEV(Component, props2, secondArg);
      } while (didScheduleRenderPhaseUpdateDuringThisPass);
      return children;
    }
    function TransitionAwareHostComponent() {
      var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
      maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
      dispatcher = dispatcher.useState()[0];
      (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
      return maybeThenable;
    }
    function checkDidRenderIdHook() {
      var didRenderIdHook = 0 !== localIdCounter;
      localIdCounter = 0;
      return didRenderIdHook;
    }
    function bailoutHooks(current3, workInProgress2, lanes) {
      workInProgress2.updateQueue = current3.updateQueue;
      workInProgress2.flags = (workInProgress2.mode & StrictEffectsMode) !== NoMode ? workInProgress2.flags & -402655237 : workInProgress2.flags & -2053;
      current3.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress2) {
      if (didScheduleRenderPhaseUpdate) {
        for (workInProgress2 = workInProgress2.memoizedState; null !== workInProgress2; ) {
          var queue2 = workInProgress2.queue;
          null !== queue2 && (queue2.pending = null);
          workInProgress2 = workInProgress2.next;
        }
        didScheduleRenderPhaseUpdate = false;
      }
      renderLanes = 0;
      hookTypesDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
      hookTypesUpdateIndexDev = -1;
      currentHookNameInDev = null;
      didScheduleRenderPhaseUpdateDuringThisPass = false;
      thenableIndexCounter = localIdCounter = 0;
      thenableState = null;
    }
    function mountWorkInProgressHook() {
      var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
      return workInProgressHook;
    }
    function updateWorkInProgressHook() {
      if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
      } else nextCurrentHook = currentHook.next;
      var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
      if (null !== nextWorkInProgressHook)
        workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
      else {
        if (null === nextCurrentHook) {
          if (null === currentlyRenderingFiber.alternate)
            throw Error(
              "Update hook called on initial render. This is likely a bug in React. Please file an issue."
            );
          throw Error("Rendered more hooks than during the previous render.");
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
          memoizedState: currentHook.memoizedState,
          baseState: currentHook.baseState,
          baseQueue: currentHook.baseQueue,
          queue: currentHook.queue,
          next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
      }
      return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function useThenable(thenable) {
      var index2 = thenableIndexCounter;
      thenableIndexCounter += 1;
      null === thenableState && (thenableState = createThenableState());
      thenable = trackUsedThenable(thenableState, thenable, index2);
      index2 = currentlyRenderingFiber;
      null === (null === workInProgressHook ? index2.memoizedState : workInProgressHook.next) && (index2 = index2.alternate, ReactSharedInternals.H = null !== index2 && null !== index2.memoizedState ? HooksDispatcherOnUpdateInDEV : HooksDispatcherOnMountInDEV);
      return thenable;
    }
    function use(usable) {
      if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
      }
      throw Error("An unsupported type was passed to use(): " + String(usable));
    }
    function useMemoCache(size2) {
      var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
      null !== updateQueue && (memoCache = updateQueue.memoCache);
      if (null == memoCache) {
        var current3 = currentlyRenderingFiber.alternate;
        null !== current3 && (current3 = current3.updateQueue, null !== current3 && (current3 = current3.memoCache, null != current3 && (memoCache = {
          data: current3.data.map(function(array) {
            return array.slice();
          }),
          index: 0
        })));
      }
      null == memoCache && (memoCache = { data: [], index: 0 });
      null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
      updateQueue.memoCache = memoCache;
      updateQueue = memoCache.data[memoCache.index];
      if (void 0 === updateQueue || ignorePreviousDependencies)
        for (updateQueue = memoCache.data[memoCache.index] = Array(size2), current3 = 0; current3 < size2; current3++)
          updateQueue[current3] = REACT_MEMO_CACHE_SENTINEL;
      else
        updateQueue.length !== size2 && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          updateQueue.length,
          size2
        );
      memoCache.index++;
      return updateQueue;
    }
    function basicStateReducer(state, action) {
      return "function" === typeof action ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init2) {
      var hook = mountWorkInProgressHook();
      if (void 0 !== init2) {
        var initialState2 = init2(initialArg);
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            init2(initialArg);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      } else initialState2 = initialArg;
      hook.memoizedState = hook.baseState = initialState2;
      reducer = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: reducer,
        lastRenderedState: initialState2
      };
      hook.queue = reducer;
      reducer = reducer.dispatch = dispatchReducerAction.bind(
        null,
        currentlyRenderingFiber,
        reducer
      );
      return [hook.memoizedState, reducer];
    }
    function updateReducer(reducer) {
      var hook = updateWorkInProgressHook();
      return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current3, reducer) {
      var queue2 = hook.queue;
      if (null === queue2)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      queue2.lastRenderedReducer = reducer;
      var baseQueue = hook.baseQueue, pendingQueue = queue2.pending;
      if (null !== pendingQueue) {
        if (null !== baseQueue) {
          var baseFirst = baseQueue.next;
          baseQueue.next = pendingQueue.next;
          pendingQueue.next = baseFirst;
        }
        current3.baseQueue !== baseQueue && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        );
        current3.baseQueue = baseQueue = pendingQueue;
        queue2.pending = null;
      }
      pendingQueue = hook.baseState;
      if (null === baseQueue) hook.memoizedState = pendingQueue;
      else {
        current3 = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current3, didReadFromEntangledAsyncAction2 = false;
        do {
          var updateLane = update.lane & -536870913;
          if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
            var revertLane = update.revertLane;
            if (0 === revertLane)
              null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                lane: 0,
                revertLane: 0,
                gesture: null,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
              }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction2 = true);
            else if ((renderLanes & revertLane) === revertLane) {
              update = update.next;
              revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction2 = true);
              continue;
            } else
              updateLane = {
                lane: 0,
                revertLane: update.revertLane,
                gesture: null,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
              }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
            updateLane = update.action;
            shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
            pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
          } else
            revertLane = {
              lane: updateLane,
              revertLane: update.revertLane,
              gesture: update.gesture,
              action: update.action,
              hasEagerState: update.hasEagerState,
              eagerState: update.eagerState,
              next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
          update = update.next;
        } while (null !== update && update !== current3);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = true, didReadFromEntangledAsyncAction2 && (reducer = currentEntangledActionThenable, null !== reducer)))
          throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue2.lastRenderedState = pendingQueue;
      }
      null === baseQueue && (queue2.lanes = 0);
      return [hook.memoizedState, queue2.dispatch];
    }
    function rerenderReducer(reducer) {
      var hook = updateWorkInProgressHook(), queue2 = hook.queue;
      if (null === queue2)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      queue2.lastRenderedReducer = reducer;
      var dispatch = queue2.dispatch, lastRenderPhaseUpdate = queue2.pending, newState = hook.memoizedState;
      if (null !== lastRenderPhaseUpdate) {
        queue2.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do
          newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue2.lastRenderedState = newState;
      }
      return [newState, dispatch];
    }
    function mountSyncExternalStore(subscribe2, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
      if (isHydrating) {
        if (void 0 === getServerSnapshot)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var nextSnapshot = getServerSnapshot();
        didWarnUncachedGetSnapshot || nextSnapshot === getServerSnapshot() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      } else {
        nextSnapshot = getSnapshot();
        didWarnUncachedGetSnapshot || (getServerSnapshot = getSnapshot(), objectIs(nextSnapshot, getServerSnapshot) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true));
        if (null === workInProgressRoot)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
      }
      hook.memoizedState = nextSnapshot;
      getServerSnapshot = { value: nextSnapshot, getSnapshot };
      hook.queue = getServerSnapshot;
      mountEffect(
        subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe2),
        [subscribe2]
      );
      fiber.flags |= 2048;
      pushSimpleEffect(
        HasEffect | Passive,
        { destroy: void 0 },
        updateStoreInstance.bind(
          null,
          fiber,
          getServerSnapshot,
          nextSnapshot,
          getSnapshot
        ),
        null
      );
      return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe2, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
      if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        getServerSnapshot = getServerSnapshot();
      } else if (getServerSnapshot = getSnapshot(), !didWarnUncachedGetSnapshot) {
        var cachedSnapshot = getSnapshot();
        objectIs(getServerSnapshot, cachedSnapshot) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      if (cachedSnapshot = !objectIs(
        (currentHook || hook).memoizedState,
        getServerSnapshot
      ))
        hook.memoizedState = getServerSnapshot, didReceiveUpdate = true;
      hook = hook.queue;
      var create2 = subscribeToStore.bind(null, fiber, hook, subscribe2);
      updateEffectImpl(2048, Passive, create2, [subscribe2]);
      if (hook.getSnapshot !== getSnapshot || cachedSnapshot || null !== workInProgressHook && workInProgressHook.memoizedState.tag & HasEffect) {
        fiber.flags |= 2048;
        pushSimpleEffect(
          HasEffect | Passive,
          { destroy: void 0 },
          updateStoreInstance.bind(
            null,
            fiber,
            hook,
            getServerSnapshot,
            getSnapshot
          ),
          null
        );
        if (null === workInProgressRoot)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
      }
      return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
      fiber.flags |= 16384;
      fiber = { getSnapshot, value: renderedSnapshot };
      getSnapshot = currentlyRenderingFiber.updateQueue;
      null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [fiber]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [fiber] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
      inst.value = nextSnapshot;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe2) {
      return subscribe2(function() {
        checkIfSnapshotChanged(inst) && (startUpdateTimerByLane(2, "updateSyncExternalStore()", fiber), forceStoreRerender(fiber));
      });
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error) {
        return true;
      }
    }
    function forceStoreRerender(fiber) {
      var root3 = enqueueConcurrentRenderForLane(fiber, 2);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2);
    }
    function mountStateImpl(initialState2) {
      var hook = mountWorkInProgressHook();
      if ("function" === typeof initialState2) {
        var initialStateInitializer = initialState2;
        initialState2 = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            initialStateInitializer();
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      }
      hook.memoizedState = hook.baseState = initialState2;
      hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState2
      };
      return hook;
    }
    function mountState(initialState2) {
      initialState2 = mountStateImpl(initialState2);
      var queue2 = initialState2.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue2);
      queue2.dispatch = dispatch;
      return [initialState2.memoizedState, dispatch];
    }
    function mountOptimistic(passthrough) {
      var hook = mountWorkInProgressHook();
      hook.memoizedState = hook.baseState = passthrough;
      var queue2 = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      hook.queue = queue2;
      hook = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        true,
        queue2
      );
      queue2.dispatch = hook;
      return [passthrough, hook];
    }
    function updateOptimistic(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    }
    function updateOptimisticImpl(hook, current3, passthrough, reducer) {
      hook.baseState = passthrough;
      return updateReducerImpl(
        hook,
        currentHook,
        "function" === typeof reducer ? reducer : basicStateReducer
      );
    }
    function rerenderOptimistic(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      if (null !== currentHook)
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
      hook.baseState = passthrough;
      return [passthrough, hook.queue.dispatch];
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
      if (isRenderPhaseUpdate(fiber))
        throw Error("Cannot update form state while rendering.");
      fiber = actionQueue.action;
      if (null !== fiber) {
        var actionNode = {
          payload,
          action: fiber,
          next: null,
          isTransition: true,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(listener) {
            actionNode.listeners.push(listener);
          }
        };
        null !== ReactSharedInternals.T ? setPendingState(true) : actionNode.isTransition = false;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
      }
    }
    function runActionStateAction(actionQueue, node) {
      var action = node.action, payload = node.payload, prevState = actionQueue.state;
      if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition._updatedFibers = /* @__PURE__ */ new Set();
        ReactSharedInternals.T = currentTransition;
        try {
          var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
          null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
          handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
          onActionError(actionQueue, node, error);
        } finally {
          null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (actionQueue = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < actionQueue && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          currentTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, currentTransition);
        } catch (error$4) {
          onActionError(actionQueue, node, error$4);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
      null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(
        function(nextState) {
          onActionSuccess(actionQueue, node, nextState);
        },
        function(error) {
          return onActionError(actionQueue, node, error);
        }
      ), node.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
      actionNode.status = "fulfilled";
      actionNode.value = nextState;
      notifyActionListeners(actionNode);
      actionQueue.state = nextState;
      actionNode = actionQueue.pending;
      null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
      var last2 = actionQueue.pending;
      actionQueue.pending = null;
      if (null !== last2) {
        last2 = last2.next;
        do
          actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last2);
      }
      actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
      actionNode = actionNode.listeners;
      for (var i2 = 0; i2 < actionNode.length; i2++) (0, actionNode[i2])();
    }
    function actionStateReducer(oldState, newState) {
      return newState;
    }
    function mountActionState(action, initialStateProp) {
      if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
          a: {
            var isMatching = currentlyRenderingFiber;
            if (isHydrating) {
              if (nextHydratableInstance) {
                b: {
                  var markerInstance = nextHydratableInstance;
                  for (var inRootOrSingleton = rootOrSingletonContext; 8 !== markerInstance.nodeType; ) {
                    if (!inRootOrSingleton) {
                      markerInstance = null;
                      break b;
                    }
                    markerInstance = getNextHydratable(
                      markerInstance.nextSibling
                    );
                    if (null === markerInstance) {
                      markerInstance = null;
                      break b;
                    }
                  }
                  inRootOrSingleton = markerInstance.data;
                  markerInstance = inRootOrSingleton === FORM_STATE_IS_MATCHING || inRootOrSingleton === FORM_STATE_IS_NOT_MATCHING ? markerInstance : null;
                }
                if (markerInstance) {
                  nextHydratableInstance = getNextHydratable(
                    markerInstance.nextSibling
                  );
                  isMatching = markerInstance.data === FORM_STATE_IS_MATCHING;
                  break a;
                }
              }
              throwOnHydrationMismatch(isMatching);
            }
            isMatching = false;
          }
          isMatching && (initialStateProp = ssrFormState[0]);
        }
      }
      ssrFormState = mountWorkInProgressHook();
      ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
      isMatching = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
      };
      ssrFormState.queue = isMatching;
      ssrFormState = dispatchSetState.bind(
        null,
        currentlyRenderingFiber,
        isMatching
      );
      isMatching.dispatch = ssrFormState;
      isMatching = mountStateImpl(false);
      inRootOrSingleton = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        false,
        isMatching.queue
      );
      isMatching = mountWorkInProgressHook();
      markerInstance = {
        state: initialStateProp,
        dispatch: null,
        action,
        pending: null
      };
      isMatching.queue = markerInstance;
      ssrFormState = dispatchActionState.bind(
        null,
        currentlyRenderingFiber,
        markerInstance,
        inRootOrSingleton,
        ssrFormState
      );
      markerInstance.dispatch = ssrFormState;
      isMatching.memoizedState = action;
      return [initialStateProp, ssrFormState, false];
    }
    function updateActionState(action) {
      var stateHook = updateWorkInProgressHook();
      return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
      currentStateHook = updateReducerImpl(
        stateHook,
        currentStateHook,
        actionStateReducer
      )[0];
      stateHook = updateReducer(basicStateReducer)[0];
      if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then)
        try {
          var state = useThenable(currentStateHook);
        } catch (x2) {
          if (x2 === SuspenseException) throw SuspenseActionException;
          throw x2;
        }
      else state = currentStateHook;
      currentStateHook = updateWorkInProgressHook();
      var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
      action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(
        HasEffect | Passive,
        { destroy: void 0 },
        actionStateActionEffect.bind(null, actionQueue, action),
        null
      ));
      return [state, dispatch, stateHook];
    }
    function actionStateActionEffect(actionQueue, action) {
      actionQueue.action = action;
    }
    function rerenderActionState(action) {
      var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
      if (null !== currentStateHook)
        return updateActionStateImpl(stateHook, currentStateHook, action);
      updateWorkInProgressHook();
      stateHook = stateHook.memoizedState;
      currentStateHook = updateWorkInProgressHook();
      var dispatch = currentStateHook.queue.dispatch;
      currentStateHook.memoizedState = action;
      return [stateHook, dispatch, false];
    }
    function pushSimpleEffect(tag2, inst, create2, deps) {
      tag2 = { tag: tag2, create: create2, deps, inst, next: null };
      inst = currentlyRenderingFiber.updateQueue;
      null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
      create2 = inst.lastEffect;
      null === create2 ? inst.lastEffect = tag2.next = tag2 : (deps = create2.next, create2.next = tag2, tag2.next = deps, inst.lastEffect = tag2);
      return tag2;
    }
    function mountRef(initialValue) {
      var hook = mountWorkInProgressHook();
      initialValue = { current: initialValue };
      return hook.memoizedState = initialValue;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create2, deps) {
      var hook = mountWorkInProgressHook();
      currentlyRenderingFiber.flags |= fiberFlags;
      hook.memoizedState = pushSimpleEffect(
        HasEffect | hookFlags,
        { destroy: void 0 },
        create2,
        void 0 === deps ? null : deps
      );
    }
    function updateEffectImpl(fiberFlags, hookFlags, create2, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var inst = hook.memoizedState.inst;
      null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create2, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(
        HasEffect | hookFlags,
        inst,
        create2,
        deps
      ));
    }
    function mountEffect(create2, deps) {
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode ? mountEffectImpl(276826112, Passive, create2, deps) : mountEffectImpl(8390656, Passive, create2, deps);
    }
    function useEffectEventImpl(payload) {
      currentlyRenderingFiber.flags |= 4;
      var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
      if (null === componentUpdateQueue)
        componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [payload];
      else {
        var events2 = componentUpdateQueue.events;
        null === events2 ? componentUpdateQueue.events = [payload] : events2.push(payload);
      }
    }
    function mountEvent(callback) {
      var hook = mountWorkInProgressHook(), ref = { impl: callback };
      hook.memoizedState = ref;
      return function() {
        if ((executionContext & RenderContext) !== NoContext)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return ref.impl.apply(void 0, arguments);
      };
    }
    function updateEvent(callback) {
      var ref = updateWorkInProgressHook().memoizedState;
      useEffectEventImpl({ ref, nextImpl: callback });
      return function() {
        if ((executionContext & RenderContext) !== NoContext)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return ref.impl.apply(void 0, arguments);
      };
    }
    function mountLayoutEffect(create2, deps) {
      var fiberFlags = 4194308;
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
      return mountEffectImpl(fiberFlags, Layout, create2, deps);
    }
    function imperativeHandleEffect(create2, ref) {
      if ("function" === typeof ref) {
        create2 = create2();
        var refCleanup = ref(create2);
        return function() {
          "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
      }
      if (null !== ref && void 0 !== ref)
        return ref.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(ref).join(", ") + "}"
        ), create2 = create2(), ref.current = create2, function() {
          ref.current = null;
        };
    }
    function mountImperativeHandle(ref, create2, deps) {
      "function" !== typeof create2 && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        null !== create2 ? typeof create2 : "null"
      );
      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
      var fiberFlags = 4194308;
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
      mountEffectImpl(
        fiberFlags,
        Layout,
        imperativeHandleEffect.bind(null, create2, ref),
        deps
      );
    }
    function updateImperativeHandle(ref, create2, deps) {
      "function" !== typeof create2 && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        null !== create2 ? typeof create2 : "null"
      );
      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
      updateEffectImpl(
        4,
        Layout,
        imperativeHandleEffect.bind(null, create2, ref),
        deps
      );
    }
    function mountCallback(callback, deps) {
      mountWorkInProgressHook().memoizedState = [
        callback,
        void 0 === deps ? null : deps
      ];
      return callback;
    }
    function updateCallback(callback, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var prevState = hook.memoizedState;
      if (null !== deps && areHookInputsEqual(deps, prevState[1]))
        return prevState[0];
      hook.memoizedState = [callback, deps];
      return callback;
    }
    function mountMemo(nextCreate, deps) {
      var hook = mountWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var nextValue = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [nextValue, deps];
      return nextValue;
    }
    function updateMemo(nextCreate, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var prevState = hook.memoizedState;
      if (null !== deps && areHookInputsEqual(deps, prevState[1]))
        return prevState[0];
      prevState = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [prevState, deps];
      return prevState;
    }
    function mountDeferredValue(value, initialValue) {
      var hook = mountWorkInProgressHook();
      return mountDeferredValueImpl(hook, value, initialValue);
    }
    function updateDeferredValue(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    }
    function rerenderDeferredValue(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
      if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930))
        return hook.memoizedState = value;
      hook.memoizedState = initialValue;
      hook = requestDeferredLane();
      currentlyRenderingFiber.lanes |= hook;
      workInProgressRootSkippedLanes |= hook;
      return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
      if (objectIs(value, prevValue)) return value;
      if (null !== currentTreeHiddenStackCursor.current)
        return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = true), hook;
      if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930))
        return didReceiveUpdate = true, hook.memoizedState = value;
      hook = requestDeferredLane();
      currentlyRenderingFiber.lanes |= hook;
      workInProgressRootSkippedLanes |= hook;
      return prevValue;
    }
    function releaseAsyncTransition() {
      ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(fiber, queue2, pendingState, finishedState, callback) {
      var previousPriority = ReactDOMSharedInternals.p;
      ReactDOMSharedInternals.p = 0 !== previousPriority && previousPriority < ContinuousEventPriority ? previousPriority : ContinuousEventPriority;
      var prevTransition = ReactSharedInternals.T, currentTransition = {};
      currentTransition._updatedFibers = /* @__PURE__ */ new Set();
      ReactSharedInternals.T = currentTransition;
      dispatchOptimisticSetState(fiber, false, queue2, pendingState);
      try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
          ReactSharedInternals.asyncTransitions++;
          returnValue.then(releaseAsyncTransition, releaseAsyncTransition);
          var thenableForFinishedState = chainThenableValue(
            returnValue,
            finishedState
          );
          dispatchSetStateInternal(
            fiber,
            queue2,
            thenableForFinishedState,
            requestUpdateLane(fiber)
          );
        } else
          dispatchSetStateInternal(
            fiber,
            queue2,
            finishedState,
            requestUpdateLane(fiber)
          );
      } catch (error) {
        dispatchSetStateInternal(
          fiber,
          queue2,
          { then: function() {
          }, status: "rejected", reason: error },
          requestUpdateLane(fiber)
        );
      } finally {
        ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error(
          "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
        ), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (fiber = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < fiber && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function startHostTransition(formFiber, pendingState, action, formData) {
      if (5 !== formFiber.tag)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var queue2 = ensureFormComponentIsStateful(formFiber).queue;
      startHostActionTimer(formFiber);
      startTransition(
        formFiber,
        queue2,
        pendingState,
        NotPendingTransition,
        null === action ? noop2 : function() {
          requestFormReset$1(formFiber);
          return action(formData);
        }
      );
    }
    function ensureFormComponentIsStateful(formFiber) {
      var existingStateHook = formFiber.memoizedState;
      if (null !== existingStateHook) return existingStateHook;
      existingStateHook = {
        memoizedState: NotPendingTransition,
        baseState: NotPendingTransition,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: NotPendingTransition
        },
        next: null
      };
      var initialResetState = {};
      existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialResetState
        },
        next: null
      };
      formFiber.memoizedState = existingStateHook;
      formFiber = formFiber.alternate;
      null !== formFiber && (formFiber.memoizedState = existingStateHook);
      return existingStateHook;
    }
    function requestFormReset$1(formFiber) {
      null === ReactSharedInternals.T && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var stateHook = ensureFormComponentIsStateful(formFiber);
      null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
      dispatchSetStateInternal(
        formFiber,
        stateHook.next.queue,
        {},
        requestUpdateLane(formFiber)
      );
    }
    function mountTransition() {
      var stateHook = mountStateImpl(false);
      stateHook = startTransition.bind(
        null,
        currentlyRenderingFiber,
        stateHook.queue,
        true,
        false
      );
      mountWorkInProgressHook().memoizedState = stateHook;
      return [false, stateHook];
    }
    function updateTransition() {
      var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    }
    function rerenderTransition() {
      var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    }
    function useHostTransitionStatus() {
      return readContext(HostTransitionContext);
    }
    function mountId() {
      var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
      if (isHydrating) {
        var treeId = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        treeId = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + treeId;
        identifierPrefix = "_" + identifierPrefix + "R_" + treeId;
        treeId = localIdCounter++;
        0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
        identifierPrefix += "_";
      } else
        treeId = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + treeId.toString(32) + "_";
      return hook.memoizedState = identifierPrefix;
    }
    function mountRefresh() {
      return mountWorkInProgressHook().memoizedState = refreshCache.bind(
        null,
        currentlyRenderingFiber
      );
    }
    function refreshCache(fiber, seedKey) {
      for (var provider = fiber.return; null !== provider; ) {
        switch (provider.tag) {
          case 24:
          case 3:
            var lane = requestUpdateLane(provider), refreshUpdate = createUpdate(lane), root3 = enqueueUpdate(provider, refreshUpdate, lane);
            null !== root3 && (startUpdateTimerByLane(lane, "refresh()", fiber), scheduleUpdateOnFiber(root3, provider, lane), entangleTransitions(root3, provider, lane));
            fiber = createCache();
            null !== seedKey && void 0 !== seedKey && null !== root3 && console.error(
              "The seed argument is not enabled outside experimental channels."
            );
            refreshUpdate.payload = { cache: fiber };
            return;
        }
        provider = provider.return;
      }
    }
    function dispatchReducerAction(fiber, queue2, action) {
      var args = arguments;
      "function" === typeof args[3] && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      );
      args = requestUpdateLane(fiber);
      var update = {
        lane: args,
        revertLane: 0,
        gesture: null,
        action,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue2, update) : (update = enqueueConcurrentHookUpdate(fiber, queue2, update, args), null !== update && (startUpdateTimerByLane(args, "dispatch()", fiber), scheduleUpdateOnFiber(update, fiber, args), entangleTransitionUpdate(update, queue2, args)));
    }
    function dispatchSetState(fiber, queue2, action) {
      var args = arguments;
      "function" === typeof args[3] && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      );
      args = requestUpdateLane(fiber);
      dispatchSetStateInternal(fiber, queue2, action, args) && startUpdateTimerByLane(args, "setState()", fiber);
    }
    function dispatchSetStateInternal(fiber, queue2, action, lane) {
      var update = {
        lane,
        revertLane: 0,
        gesture: null,
        action,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue2, update);
      else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue2.lastRenderedReducer, null !== alternate)) {
          var prevDispatcher = ReactSharedInternals.H;
          ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
          try {
            var currentState = queue2.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = true;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState))
              return enqueueUpdate$1(fiber, queue2, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), false;
          } catch (error) {
          } finally {
            ReactSharedInternals.H = prevDispatcher;
          }
        }
        action = enqueueConcurrentHookUpdate(fiber, queue2, update, lane);
        if (null !== action)
          return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue2, lane), true;
      }
      return false;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue2, action) {
      null === ReactSharedInternals.T && 0 === currentEntangledLane && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      );
      action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        gesture: null,
        action,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        throwIfDuringRender = enqueueConcurrentHookUpdate(
          fiber,
          queue2,
          action,
          2
        ), null !== throwIfDuringRender && (startUpdateTimerByLane(2, "setOptimistic()", fiber), scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2));
    }
    function isRenderPhaseUpdate(fiber) {
      var alternate = fiber.alternate;
      return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue2, update) {
      didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
      var pending = queue2.pending;
      null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
      queue2.pending = update;
    }
    function entangleTransitionUpdate(root3, queue2, lane) {
      if (0 !== (lane & 4194048)) {
        var queueLanes = queue2.lanes;
        queueLanes &= root3.pendingLanes;
        lane |= queueLanes;
        queue2.lanes = lane;
        markRootEntangled(root3, lane);
      }
    }
    function warnOnInvalidCallback(callback) {
      if (null !== callback && "function" !== typeof callback) {
        var key = String(callback);
        didWarnOnInvalidCallback.has(key) || (didWarnOnInvalidCallback.add(key), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          callback
        ));
      }
    }
    function applyDerivedStateFromProps(workInProgress2, ctor2, getDerivedStateFromProps, nextProps) {
      var prevState = workInProgress2.memoizedState, partialState = getDerivedStateFromProps(nextProps, prevState);
      if (workInProgress2.mode & StrictLegacyMode) {
        setIsStrictModeForDevtools(true);
        try {
          partialState = getDerivedStateFromProps(nextProps, prevState);
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      void 0 === partialState && (ctor2 = getComponentNameFromType(ctor2) || "Component", didWarnAboutUndefinedDerivedState.has(ctor2) || (didWarnAboutUndefinedDerivedState.add(ctor2), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        ctor2
      )));
      prevState = null === partialState || void 0 === partialState ? prevState : assign2({}, prevState, partialState);
      workInProgress2.memoizedState = prevState;
      0 === workInProgress2.lanes && (workInProgress2.updateQueue.baseState = prevState);
    }
    function checkShouldComponentUpdate(workInProgress2, ctor2, oldProps, newProps, oldState, newState, nextContext) {
      var instance = workInProgress2.stateNode;
      if ("function" === typeof instance.shouldComponentUpdate) {
        oldProps = instance.shouldComponentUpdate(
          newProps,
          newState,
          nextContext
        );
        if (workInProgress2.mode & StrictLegacyMode) {
          setIsStrictModeForDevtools(true);
          try {
            oldProps = instance.shouldComponentUpdate(
              newProps,
              newState,
              nextContext
            );
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
        void 0 === oldProps && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          getComponentNameFromType(ctor2) || "Component"
        );
        return oldProps;
      }
      return ctor2.prototype && ctor2.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : true;
    }
    function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
      var oldState = instance.state;
      "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
      "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
      instance.state !== oldState && (workInProgress2 = getComponentNameFromFiber(workInProgress2) || "Component", didWarnAboutStateAssignmentForComponent.has(workInProgress2) || (didWarnAboutStateAssignmentForComponent.add(workInProgress2), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        workInProgress2
      )), classComponentUpdater.enqueueReplaceState(
        instance,
        instance.state,
        null
      ));
    }
    function resolveClassComponentProps(Component, baseProps) {
      var newProps = baseProps;
      if ("ref" in baseProps) {
        newProps = {};
        for (var propName in baseProps)
          "ref" !== propName && (newProps[propName] = baseProps[propName]);
      }
      if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign2({}, newProps));
        for (var _propName in Component)
          void 0 === newProps[_propName] && (newProps[_propName] = Component[_propName]);
      }
      return newProps;
    }
    function defaultOnUncaughtError(error) {
      reportGlobalError(error);
      console.warn(
        "%s\n\n%s\n",
        componentName ? "An error occurred in the <" + componentName + "> component." : "An error occurred in one of your React components.",
        "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries."
      );
    }
    function defaultOnCaughtError(error) {
      var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component." : "The above error occurred in one of your React components.", recreateMessage = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((errorBoundaryName || "Anonymous") + ".");
      if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
        var JSCompiler_inline_result = error.environmentName;
        error = [
          "%o\n\n%s\n\n%s\n",
          error,
          componentNameMessage,
          recreateMessage
        ].slice(0);
        "string" === typeof error[0] ? error.splice(
          0,
          1,
          badgeFormat + " " + error[0],
          badgeStyle,
          pad + JSCompiler_inline_result + pad,
          resetStyle
        ) : error.splice(
          0,
          0,
          badgeFormat,
          badgeStyle,
          pad + JSCompiler_inline_result + pad,
          resetStyle
        );
        error.unshift(console);
        JSCompiler_inline_result = bind2.apply(console.error, error);
        JSCompiler_inline_result();
      } else
        console.error(
          "%o\n\n%s\n\n%s\n",
          error,
          componentNameMessage,
          recreateMessage
        );
    }
    function defaultOnRecoverableError(error) {
      reportGlobalError(error);
    }
    function logUncaughtError(root3, errorInfo) {
      try {
        componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
        errorBoundaryName = null;
        var error = errorInfo.value;
        if (null !== ReactSharedInternals.actQueue)
          ReactSharedInternals.thrownErrors.push(error);
        else {
          var onUncaughtError = root3.onUncaughtError;
          onUncaughtError(error, { componentStack: errorInfo.stack });
        }
      } catch (e$5) {
        setTimeout(function() {
          throw e$5;
        });
      }
    }
    function logCaughtError(root3, boundary, errorInfo) {
      try {
        componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
        errorBoundaryName = getComponentNameFromFiber(boundary);
        var onCaughtError = root3.onCaughtError;
        onCaughtError(errorInfo.value, {
          componentStack: errorInfo.stack,
          errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
      } catch (e$6) {
        setTimeout(function() {
          throw e$6;
        });
      }
    }
    function createRootErrorUpdate(root3, errorInfo, lane) {
      lane = createUpdate(lane);
      lane.tag = CaptureUpdate;
      lane.payload = { element: null };
      lane.callback = function() {
        runWithFiberInDEV(errorInfo.source, logUncaughtError, root3, errorInfo);
      };
      return lane;
    }
    function createClassErrorUpdate(lane) {
      lane = createUpdate(lane);
      lane.tag = CaptureUpdate;
      return lane;
    }
    function initializeClassErrorUpdate(update, root3, fiber, errorInfo) {
      var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
      if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
          return getDerivedStateFromError(error);
        };
        update.callback = function() {
          markFailedErrorBoundaryForHotReloading(fiber);
          runWithFiberInDEV(
            errorInfo.source,
            logCaughtError,
            root3,
            fiber,
            errorInfo
          );
        };
      }
      var inst = fiber.stateNode;
      null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        markFailedErrorBoundaryForHotReloading(fiber);
        runWithFiberInDEV(
          errorInfo.source,
          logCaughtError,
          root3,
          fiber,
          errorInfo
        );
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([this]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        callComponentDidCatchInDEV(this, errorInfo);
        "function" === typeof getDerivedStateFromError || 0 === (fiber.lanes & 2) && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          getComponentNameFromFiber(fiber) || "Unknown"
        );
      });
    }
    function throwException(root3, returnFiber, sourceFiber, value, rootRenderLanes) {
      sourceFiber.flags |= 32768;
      isDevToolsPresent && restorePendingUpdaters(root3, rootRenderLanes);
      if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(
          returnFiber,
          sourceFiber,
          rootRenderLanes,
          true
        );
        isHydrating && (didSuspendOrErrorDEV = true);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
          switch (sourceFiber.tag) {
            case 31:
            case 13:
              return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootSuspended), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = /* @__PURE__ */ new Set([value]) : returnFiber.add(value), attachPingListener(root3, value, rootRenderLanes)), false;
            case 22:
              return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([value])
              }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = /* @__PURE__ */ new Set([value]) : sourceFiber.add(value)), attachPingListener(root3, value, rootRenderLanes)), false;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + sourceFiber.tag + "). This is a bug in React."
          );
        }
        attachPingListener(root3, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return false;
      }
      if (isHydrating)
        return didSuspendOrErrorDEV = true, returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && queueHydrationError(
          createCapturedValueAtFiber(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: value }
            ),
            sourceFiber
          )
        )) : (value !== HydrationMismatchException && queueHydrationError(
          createCapturedValueAtFiber(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: value }
            ),
            sourceFiber
          )
        ), root3 = root3.current.alternate, root3.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root3.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(
          root3.stateNode,
          value,
          rootRenderLanes
        ), enqueueCapturedUpdate(root3, rootRenderLanes), workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored)), false;
      var error = createCapturedValueAtFiber(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: value }
        ),
        sourceFiber
      );
      null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [error] : workInProgressRootConcurrentErrors.push(error);
      workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored);
      if (null === returnFiber) return true;
      value = createCapturedValueAtFiber(value, sourceFiber);
      sourceFiber = returnFiber;
      do {
        switch (sourceFiber.tag) {
          case 3:
            return sourceFiber.flags |= 65536, root3 = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root3, root3 = createRootErrorUpdate(
              sourceFiber.stateNode,
              value,
              root3
            ), enqueueCapturedUpdate(sourceFiber, root3), false;
          case 1:
            if (returnFiber = sourceFiber.type, error = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== error && "function" === typeof error.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(error))))
              return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(
                rootRenderLanes,
                root3,
                sourceFiber,
                value
              ), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), false;
        }
        sourceFiber = sourceFiber.return;
      } while (null !== sourceFiber);
      return false;
    }
    function reconcileChildren(current3, workInProgress2, nextChildren, renderLanes2) {
      workInProgress2.child = null === current3 ? mountChildFibers(workInProgress2, null, nextChildren, renderLanes2) : reconcileChildFibers(
        workInProgress2,
        current3.child,
        nextChildren,
        renderLanes2
      );
    }
    function updateForwardRef(current3, workInProgress2, Component, nextProps, renderLanes2) {
      Component = Component.render;
      var ref = workInProgress2.ref;
      if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for (var key in nextProps)
          "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
      } else propsWithoutRef = nextProps;
      prepareToReadContext(workInProgress2);
      nextProps = renderWithHooks(
        current3,
        workInProgress2,
        Component,
        propsWithoutRef,
        ref,
        renderLanes2
      );
      key = checkDidRenderIdHook();
      if (null !== current3 && !didReceiveUpdate)
        return bailoutHooks(current3, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
      isHydrating && key && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current3, workInProgress2, nextProps, renderLanes2);
      return workInProgress2.child;
    }
    function updateMemoComponent(current3, workInProgress2, Component, nextProps, renderLanes2) {
      if (null === current3) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare)
          return Component = resolveFunctionForHotReloading(type), workInProgress2.tag = 15, workInProgress2.type = Component, validateFunctionComponentInDev(workInProgress2, type), updateSimpleMemoComponent(
            current3,
            workInProgress2,
            Component,
            nextProps,
            renderLanes2
          );
        current3 = createFiberFromTypeAndProps(
          Component.type,
          null,
          nextProps,
          workInProgress2,
          workInProgress2.mode,
          renderLanes2
        );
        current3.ref = workInProgress2.ref;
        current3.return = workInProgress2;
        return workInProgress2.child = current3;
      }
      type = current3.child;
      if (!checkScheduledUpdateOrContext(current3, renderLanes2)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current3.ref === workInProgress2.ref)
          return bailoutOnAlreadyFinishedWork(
            current3,
            workInProgress2,
            renderLanes2
          );
      }
      workInProgress2.flags |= 1;
      current3 = createWorkInProgress(type, nextProps);
      current3.ref = workInProgress2.ref;
      current3.return = workInProgress2;
      return workInProgress2.child = current3;
    }
    function updateSimpleMemoComponent(current3, workInProgress2, Component, nextProps, renderLanes2) {
      if (null !== current3) {
        var prevProps = current3.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current3.ref === workInProgress2.ref && workInProgress2.type === current3.type)
          if (didReceiveUpdate = false, workInProgress2.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current3, renderLanes2))
            0 !== (current3.flags & 131072) && (didReceiveUpdate = true);
          else
            return workInProgress2.lanes = current3.lanes, bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
      }
      return updateFunctionComponent(
        current3,
        workInProgress2,
        Component,
        nextProps,
        renderLanes2
      );
    }
    function updateOffscreenComponent(current3, workInProgress2, renderLanes2, nextProps) {
      var nextChildren = nextProps.children, prevState = null !== current3 ? current3.memoizedState : null;
      null === current3 && null === workInProgress2.stateNode && (workInProgress2.stateNode = {
        _visibility: OffscreenVisible,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      });
      if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress2.flags & 128)) {
          prevState = null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2;
          if (null !== current3) {
            nextProps = workInProgress2.child = current3.child;
            for (nextChildren = 0; null !== nextProps; )
              nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
            nextProps = nextChildren & ~prevState;
          } else nextProps = 0, workInProgress2.child = null;
          return deferHiddenOffscreenComponent(
            current3,
            workInProgress2,
            prevState,
            renderLanes2,
            nextProps
          );
        }
        if (0 !== (renderLanes2 & 536870912))
          workInProgress2.memoizedState = { baseLanes: 0, cachePool: null }, null !== current3 && pushTransition(
            workInProgress2,
            null !== prevState ? prevState.cachePool : null
          ), null !== prevState ? pushHiddenContext(workInProgress2, prevState) : reuseHiddenContextOnStack(workInProgress2), pushOffscreenSuspenseHandler(workInProgress2);
        else
          return nextProps = workInProgress2.lanes = 536870912, deferHiddenOffscreenComponent(
            current3,
            workInProgress2,
            null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2,
            renderLanes2,
            nextProps
          );
      } else
        null !== prevState ? (pushTransition(workInProgress2, prevState.cachePool), pushHiddenContext(workInProgress2, prevState), reuseSuspenseHandlerOnStack(workInProgress2), workInProgress2.memoizedState = null) : (null !== current3 && pushTransition(workInProgress2, null), reuseHiddenContextOnStack(workInProgress2), reuseSuspenseHandlerOnStack(workInProgress2));
      reconcileChildren(current3, workInProgress2, nextChildren, renderLanes2);
      return workInProgress2.child;
    }
    function bailoutOffscreenComponent(current3, workInProgress2) {
      null !== current3 && 22 === current3.tag || null !== workInProgress2.stateNode || (workInProgress2.stateNode = {
        _visibility: OffscreenVisible,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      });
      return workInProgress2.sibling;
    }
    function deferHiddenOffscreenComponent(current3, workInProgress2, nextBaseLanes, renderLanes2, remainingChildLanes) {
      var JSCompiler_inline_result = peekCacheFromPool();
      JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
      };
      workInProgress2.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
      };
      null !== current3 && pushTransition(workInProgress2, null);
      reuseHiddenContextOnStack(workInProgress2);
      pushOffscreenSuspenseHandler(workInProgress2);
      null !== current3 && propagateParentContextChanges(current3, workInProgress2, renderLanes2, true);
      workInProgress2.childLanes = remainingChildLanes;
      return null;
    }
    function mountActivityChildren(workInProgress2, nextProps) {
      var hiddenProp = nextProps.hidden;
      void 0 !== hiddenProp && console.error(
        `<Activity> doesn't accept a hidden prop. Use mode="hidden" instead.
- <Activity %s>
+ <Activity %s>`,
        true === hiddenProp ? "hidden" : false === hiddenProp ? "hidden={false}" : "hidden={...}",
        hiddenProp ? 'mode="hidden"' : 'mode="visible"'
      );
      nextProps = mountWorkInProgressOffscreenFiber(
        { mode: nextProps.mode, children: nextProps.children },
        workInProgress2.mode
      );
      nextProps.ref = workInProgress2.ref;
      workInProgress2.child = nextProps;
      nextProps.return = workInProgress2;
      return nextProps;
    }
    function retryActivityComponentWithoutHydrating(current3, workInProgress2, renderLanes2) {
      reconcileChildFibers(workInProgress2, current3.child, null, renderLanes2);
      current3 = mountActivityChildren(
        workInProgress2,
        workInProgress2.pendingProps
      );
      current3.flags |= 2;
      popSuspenseHandler(workInProgress2);
      workInProgress2.memoizedState = null;
      return current3;
    }
    function updateActivityComponent(current3, workInProgress2, renderLanes2) {
      var nextProps = workInProgress2.pendingProps, didSuspend = 0 !== (workInProgress2.flags & 128);
      workInProgress2.flags &= -129;
      if (null === current3) {
        if (isHydrating) {
          if ("hidden" === nextProps.mode)
            return current3 = mountActivityChildren(workInProgress2, nextProps), workInProgress2.lanes = 536870912, bailoutOffscreenComponent(null, current3);
          pushDehydratedActivitySuspenseHandler(workInProgress2);
          (current3 = nextHydratableInstance) ? (renderLanes2 = canHydrateHydrationBoundary(
            current3,
            rootOrSingletonContext
          ), renderLanes2 = null !== renderLanes2 && renderLanes2.data === ACTIVITY_START_DATA ? renderLanes2 : null, null !== renderLanes2 && (nextProps = {
            dehydrated: renderLanes2,
            treeContext: getSuspendedTreeContext(),
            retryLane: 536870912,
            hydrationErrors: null
          }, workInProgress2.memoizedState = nextProps, nextProps = createFiberFromDehydratedFragment(renderLanes2), nextProps.return = workInProgress2, workInProgress2.child = nextProps, hydrationParentFiber = workInProgress2, nextHydratableInstance = null)) : renderLanes2 = null;
          if (null === renderLanes2)
            throw warnNonHydratedInstance(workInProgress2, current3), throwOnHydrationMismatch(workInProgress2);
          workInProgress2.lanes = 536870912;
          return null;
        }
        return mountActivityChildren(workInProgress2, nextProps);
      }
      var prevState = current3.memoizedState;
      if (null !== prevState) {
        var activityInstance = prevState.dehydrated;
        pushDehydratedActivitySuspenseHandler(workInProgress2);
        if (didSuspend)
          if (workInProgress2.flags & 256)
            workInProgress2.flags &= -257, workInProgress2 = retryActivityComponentWithoutHydrating(
              current3,
              workInProgress2,
              renderLanes2
            );
          else if (null !== workInProgress2.memoizedState)
            workInProgress2.child = current3.child, workInProgress2.flags |= 128, workInProgress2 = null;
          else
            throw Error(
              "Client rendering an Activity suspended it again. This is a bug in React."
            );
        else if (warnIfHydrating(), 0 !== (renderLanes2 & 536870912) && markRenderDerivedCause(workInProgress2), didReceiveUpdate || propagateParentContextChanges(
          current3,
          workInProgress2,
          renderLanes2,
          false
        ), didSuspend = 0 !== (renderLanes2 & current3.childLanes), didReceiveUpdate || didSuspend) {
          nextProps = workInProgressRoot;
          if (null !== nextProps && (activityInstance = getBumpedLaneForHydration(
            nextProps,
            renderLanes2
          ), 0 !== activityInstance && activityInstance !== prevState.retryLane))
            throw prevState.retryLane = activityInstance, enqueueConcurrentRenderForLane(current3, activityInstance), scheduleUpdateOnFiber(nextProps, current3, activityInstance), SelectiveHydrationException;
          renderDidSuspendDelayIfPossible();
          workInProgress2 = retryActivityComponentWithoutHydrating(
            current3,
            workInProgress2,
            renderLanes2
          );
        } else
          current3 = prevState.treeContext, nextHydratableInstance = getNextHydratable(
            activityInstance.nextSibling
          ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, didSuspendOrErrorDEV = false, hydrationDiffRootDEV = null, rootOrSingletonContext = false, null !== current3 && restoreSuspendedTreeContext(workInProgress2, current3), workInProgress2 = mountActivityChildren(workInProgress2, nextProps), workInProgress2.flags |= 4096;
        return workInProgress2;
      }
      prevState = current3.child;
      nextProps = { mode: nextProps.mode, children: nextProps.children };
      0 !== (renderLanes2 & 536870912) && 0 !== (renderLanes2 & current3.lanes) && markRenderDerivedCause(workInProgress2);
      current3 = createWorkInProgress(prevState, nextProps);
      current3.ref = workInProgress2.ref;
      workInProgress2.child = current3;
      current3.return = workInProgress2;
      return current3;
    }
    function markRef(current3, workInProgress2) {
      var ref = workInProgress2.ref;
      if (null === ref)
        null !== current3 && null !== current3.ref && (workInProgress2.flags |= 4194816);
      else {
        if ("function" !== typeof ref && "object" !== typeof ref)
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        if (null === current3 || current3.ref !== ref)
          workInProgress2.flags |= 4194816;
      }
    }
    function updateFunctionComponent(current3, workInProgress2, Component, nextProps, renderLanes2) {
      if (Component.prototype && "function" === typeof Component.prototype.render) {
        var componentName2 = getComponentNameFromType(Component) || "Unknown";
        didWarnAboutBadClass[componentName2] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          componentName2,
          componentName2
        ), didWarnAboutBadClass[componentName2] = true);
      }
      workInProgress2.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(
        workInProgress2,
        null
      );
      null === current3 && (validateFunctionComponentInDev(workInProgress2, workInProgress2.type), Component.contextTypes && (componentName2 = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypes[componentName2] || (didWarnAboutContextTypes[componentName2] = true, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        componentName2
      ))));
      prepareToReadContext(workInProgress2);
      Component = renderWithHooks(
        current3,
        workInProgress2,
        Component,
        nextProps,
        void 0,
        renderLanes2
      );
      nextProps = checkDidRenderIdHook();
      if (null !== current3 && !didReceiveUpdate)
        return bailoutHooks(current3, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
      isHydrating && nextProps && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current3, workInProgress2, Component, renderLanes2);
      return workInProgress2.child;
    }
    function replayFunctionComponent(current3, workInProgress2, nextProps, Component, secondArg, renderLanes2) {
      prepareToReadContext(workInProgress2);
      hookTypesUpdateIndexDev = -1;
      ignorePreviousDependencies = null !== current3 && current3.type !== workInProgress2.type;
      workInProgress2.updateQueue = null;
      nextProps = renderWithHooksAgain(
        workInProgress2,
        Component,
        nextProps,
        secondArg
      );
      finishRenderingHooks(current3, workInProgress2);
      Component = checkDidRenderIdHook();
      if (null !== current3 && !didReceiveUpdate)
        return bailoutHooks(current3, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
      isHydrating && Component && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current3, workInProgress2, nextProps, renderLanes2);
      return workInProgress2.child;
    }
    function updateClassComponent(current3, workInProgress2, Component, nextProps, renderLanes2) {
      switch (shouldErrorImpl(workInProgress2)) {
        case false:
          var _instance = workInProgress2.stateNode, state = new workInProgress2.type(
            workInProgress2.memoizedProps,
            _instance.context
          ).state;
          _instance.updater.enqueueSetState(_instance, state, null);
          break;
        case true:
          workInProgress2.flags |= 128;
          workInProgress2.flags |= 65536;
          _instance = Error("Simulated error coming from DevTools");
          var lane = renderLanes2 & -renderLanes2;
          workInProgress2.lanes |= lane;
          state = workInProgressRoot;
          if (null === state)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          lane = createClassErrorUpdate(lane);
          initializeClassErrorUpdate(
            lane,
            state,
            workInProgress2,
            createCapturedValueAtFiber(_instance, workInProgress2)
          );
          enqueueCapturedUpdate(workInProgress2, lane);
      }
      prepareToReadContext(workInProgress2);
      if (null === workInProgress2.stateNode) {
        state = emptyContextObject;
        _instance = Component.contextType;
        "contextType" in Component && null !== _instance && (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) && !didWarnAboutInvalidateContextType.has(Component) && (didWarnAboutInvalidateContextType.add(Component), lane = void 0 === _instance ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" !== typeof _instance ? " However, it is set to a " + typeof _instance + "." : _instance.$$typeof === REACT_CONSUMER_TYPE ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(_instance).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          getComponentNameFromType(Component) || "Component",
          lane
        ));
        "object" === typeof _instance && null !== _instance && (state = readContext(_instance));
        _instance = new Component(nextProps, state);
        if (workInProgress2.mode & StrictLegacyMode) {
          setIsStrictModeForDevtools(true);
          try {
            _instance = new Component(nextProps, state);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
        state = workInProgress2.memoizedState = null !== _instance.state && void 0 !== _instance.state ? _instance.state : null;
        _instance.updater = classComponentUpdater;
        workInProgress2.stateNode = _instance;
        _instance._reactInternals = workInProgress2;
        _instance._reactInternalInstance = fakeInternalInstance;
        "function" === typeof Component.getDerivedStateFromProps && null === state && (state = getComponentNameFromType(Component) || "Component", didWarnAboutUninitializedState.has(state) || (didWarnAboutUninitializedState.add(state), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          state,
          null === _instance.state ? "null" : "undefined",
          state
        )));
        if ("function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate) {
          var foundWillUpdateName = lane = state = null;
          "function" === typeof _instance.componentWillMount && true !== _instance.componentWillMount.__suppressDeprecationWarning ? state = "componentWillMount" : "function" === typeof _instance.UNSAFE_componentWillMount && (state = "UNSAFE_componentWillMount");
          "function" === typeof _instance.componentWillReceiveProps && true !== _instance.componentWillReceiveProps.__suppressDeprecationWarning ? lane = "componentWillReceiveProps" : "function" === typeof _instance.UNSAFE_componentWillReceiveProps && (lane = "UNSAFE_componentWillReceiveProps");
          "function" === typeof _instance.componentWillUpdate && true !== _instance.componentWillUpdate.__suppressDeprecationWarning ? foundWillUpdateName = "componentWillUpdate" : "function" === typeof _instance.UNSAFE_componentWillUpdate && (foundWillUpdateName = "UNSAFE_componentWillUpdate");
          if (null !== state || null !== lane || null !== foundWillUpdateName) {
            _instance = getComponentNameFromType(Component) || "Component";
            var newApiName = "function" === typeof Component.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) || (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance), console.error(
              "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles",
              _instance,
              newApiName,
              null !== state ? "\n  " + state : "",
              null !== lane ? "\n  " + lane : "",
              null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""
            ));
          }
        }
        _instance = workInProgress2.stateNode;
        state = getComponentNameFromType(Component) || "Component";
        _instance.render || (Component.prototype && "function" === typeof Component.prototype.render ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          state
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          state
        ));
        !_instance.getInitialState || _instance.getInitialState.isReactClassApproved || _instance.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          state
        );
        _instance.getDefaultProps && !_instance.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          state
        );
        _instance.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          state
        );
        Component.childContextTypes && !didWarnAboutChildContextTypes.has(Component) && (didWarnAboutChildContextTypes.add(Component), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          state
        ));
        Component.contextTypes && !didWarnAboutContextTypes$1.has(Component) && (didWarnAboutContextTypes$1.add(Component), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          state
        ));
        "function" === typeof _instance.componentShouldUpdate && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          state
        );
        Component.prototype && Component.prototype.isPureReactComponent && "undefined" !== typeof _instance.shouldComponentUpdate && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          getComponentNameFromType(Component) || "A pure component"
        );
        "function" === typeof _instance.componentDidUnmount && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          state
        );
        "function" === typeof _instance.componentDidReceiveProps && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          state
        );
        "function" === typeof _instance.componentWillRecieveProps && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          state
        );
        "function" === typeof _instance.UNSAFE_componentWillRecieveProps && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          state
        );
        lane = _instance.props !== nextProps;
        void 0 !== _instance.props && lane && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          state
        );
        _instance.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          state,
          state
        );
        "function" !== typeof _instance.getSnapshotBeforeUpdate || "function" === typeof _instance.componentDidUpdate || didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component) || (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          getComponentNameFromType(Component)
        ));
        "function" === typeof _instance.getDerivedStateFromProps && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          state
        );
        "function" === typeof _instance.getDerivedStateFromError && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          state
        );
        "function" === typeof Component.getSnapshotBeforeUpdate && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          state
        );
        (lane = _instance.state) && ("object" !== typeof lane || isArrayImpl(lane)) && console.error("%s.state: must be set to an object or null", state);
        "function" === typeof _instance.getChildContext && "object" !== typeof Component.childContextTypes && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          state
        );
        _instance = workInProgress2.stateNode;
        _instance.props = nextProps;
        _instance.state = workInProgress2.memoizedState;
        _instance.refs = {};
        initializeUpdateQueue(workInProgress2);
        state = Component.contextType;
        _instance.context = "object" === typeof state && null !== state ? readContext(state) : emptyContextObject;
        _instance.state === nextProps && (state = getComponentNameFromType(Component) || "Component", didWarnAboutDirectlyAssigningPropsToState.has(state) || (didWarnAboutDirectlyAssigningPropsToState.add(state), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          state
        )));
        workInProgress2.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(
          workInProgress2,
          _instance
        );
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(
          workInProgress2,
          _instance
        );
        _instance.state = workInProgress2.memoizedState;
        state = Component.getDerivedStateFromProps;
        "function" === typeof state && (applyDerivedStateFromProps(
          workInProgress2,
          Component,
          state,
          nextProps
        ), _instance.state = workInProgress2.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || (state = _instance.state, "function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount(), state !== _instance.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          getComponentNameFromFiber(workInProgress2) || "Component"
        ), classComponentUpdater.enqueueReplaceState(
          _instance,
          _instance.state,
          null
        )), processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction(), _instance.state = workInProgress2.memoizedState);
        "function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308);
        (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728);
        _instance = true;
      } else if (null === current3) {
        _instance = workInProgress2.stateNode;
        var unresolvedOldProps = workInProgress2.memoizedProps;
        lane = resolveClassComponentProps(Component, unresolvedOldProps);
        _instance.props = lane;
        var oldContext = _instance.context;
        foundWillUpdateName = Component.contextType;
        state = emptyContextObject;
        "object" === typeof foundWillUpdateName && null !== foundWillUpdateName && (state = readContext(foundWillUpdateName));
        newApiName = Component.getDerivedStateFromProps;
        foundWillUpdateName = "function" === typeof newApiName || "function" === typeof _instance.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress2.pendingProps !== unresolvedOldProps;
        foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (unresolvedOldProps || oldContext !== state) && callComponentWillReceiveProps(
          workInProgress2,
          _instance,
          nextProps,
          state
        );
        hasForceUpdate = false;
        var oldState = workInProgress2.memoizedState;
        _instance.state = oldState;
        processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress2.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof newApiName && (applyDerivedStateFromProps(
          workInProgress2,
          Component,
          newApiName,
          nextProps
        ), oldContext = workInProgress2.memoizedState), (lane = hasForceUpdate || checkShouldComponentUpdate(
          workInProgress2,
          Component,
          lane,
          nextProps,
          oldState,
          oldContext,
          state
        )) ? (foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || ("function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount()), "function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728)) : ("function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = oldContext), _instance.props = nextProps, _instance.state = oldContext, _instance.context = state, _instance = lane) : ("function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728), _instance = false);
      } else {
        _instance = workInProgress2.stateNode;
        cloneUpdateQueue(current3, workInProgress2);
        state = workInProgress2.memoizedProps;
        foundWillUpdateName = resolveClassComponentProps(Component, state);
        _instance.props = foundWillUpdateName;
        newApiName = workInProgress2.pendingProps;
        oldState = _instance.context;
        oldContext = Component.contextType;
        lane = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (lane = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof _instance.getSnapshotBeforeUpdate) || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (state !== newApiName || oldState !== lane) && callComponentWillReceiveProps(
          workInProgress2,
          _instance,
          nextProps,
          lane
        );
        hasForceUpdate = false;
        oldState = workInProgress2.memoizedState;
        _instance.state = oldState;
        processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress2.memoizedState;
        state !== newApiName || oldState !== newState || hasForceUpdate || null !== current3 && null !== current3.dependencies && checkIfContextChanged(current3.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(
          workInProgress2,
          Component,
          unresolvedOldProps,
          nextProps
        ), newState = workInProgress2.memoizedState), (foundWillUpdateName = hasForceUpdate || checkShouldComponentUpdate(
          workInProgress2,
          Component,
          foundWillUpdateName,
          nextProps,
          oldState,
          newState,
          lane
        ) || null !== current3 && null !== current3.dependencies && checkIfContextChanged(current3.dependencies)) ? (oldContext || "function" !== typeof _instance.UNSAFE_componentWillUpdate && "function" !== typeof _instance.componentWillUpdate || ("function" === typeof _instance.componentWillUpdate && _instance.componentWillUpdate(nextProps, newState, lane), "function" === typeof _instance.UNSAFE_componentWillUpdate && _instance.UNSAFE_componentWillUpdate(
          nextProps,
          newState,
          lane
        )), "function" === typeof _instance.componentDidUpdate && (workInProgress2.flags |= 4), "function" === typeof _instance.getSnapshotBeforeUpdate && (workInProgress2.flags |= 1024)) : ("function" !== typeof _instance.componentDidUpdate || state === current3.memoizedProps && oldState === current3.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current3.memoizedProps && oldState === current3.memoizedState || (workInProgress2.flags |= 1024), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = newState), _instance.props = nextProps, _instance.state = newState, _instance.context = lane, _instance = foundWillUpdateName) : ("function" !== typeof _instance.componentDidUpdate || state === current3.memoizedProps && oldState === current3.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current3.memoizedProps && oldState === current3.memoizedState || (workInProgress2.flags |= 1024), _instance = false);
      }
      lane = _instance;
      markRef(current3, workInProgress2);
      state = 0 !== (workInProgress2.flags & 128);
      if (lane || state) {
        lane = workInProgress2.stateNode;
        setCurrentFiber(workInProgress2);
        if (state && "function" !== typeof Component.getDerivedStateFromError)
          Component = null, profilerStartTime = -1;
        else if (Component = callRenderInDEV(lane), workInProgress2.mode & StrictLegacyMode) {
          setIsStrictModeForDevtools(true);
          try {
            callRenderInDEV(lane);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
        workInProgress2.flags |= 1;
        null !== current3 && state ? (workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          current3.child,
          null,
          renderLanes2
        ), workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          null,
          Component,
          renderLanes2
        )) : reconcileChildren(current3, workInProgress2, Component, renderLanes2);
        workInProgress2.memoizedState = lane.state;
        current3 = workInProgress2.child;
      } else
        current3 = bailoutOnAlreadyFinishedWork(
          current3,
          workInProgress2,
          renderLanes2
        );
      renderLanes2 = workInProgress2.stateNode;
      _instance && renderLanes2.props !== nextProps && (didWarnAboutReassigningProps || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        getComponentNameFromFiber(workInProgress2) || "a component"
      ), didWarnAboutReassigningProps = true);
      return current3;
    }
    function mountHostRootWithoutHydrating(current3, workInProgress2, nextChildren, renderLanes2) {
      resetHydrationState();
      workInProgress2.flags |= 256;
      reconcileChildren(current3, workInProgress2, nextChildren, renderLanes2);
      return workInProgress2.child;
    }
    function validateFunctionComponentInDev(workInProgress2, Component) {
      Component && Component.childContextTypes && console.error(
        "childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...",
        Component.displayName || Component.name || "Component"
      );
      "function" === typeof Component.getDerivedStateFromProps && (workInProgress2 = getComponentNameFromType(Component) || "Unknown", didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress2] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        workInProgress2
      ), didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress2] = true));
      "object" === typeof Component.contextType && null !== Component.contextType && (Component = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypeOnFunctionComponent[Component] || (console.error(
        "%s: Function components do not support contextType.",
        Component
      ), didWarnAboutContextTypeOnFunctionComponent[Component] = true));
    }
    function mountSuspenseOffscreenState(renderLanes2) {
      return { baseLanes: renderLanes2, cachePool: getSuspendedCache() };
    }
    function getRemainingWorkInPrimaryTree(current3, primaryTreeDidDefer, renderLanes2) {
      current3 = null !== current3 ? current3.childLanes & ~renderLanes2 : 0;
      primaryTreeDidDefer && (current3 |= workInProgressDeferredLane);
      return current3;
    }
    function updateSuspenseComponent(current3, workInProgress2, renderLanes2) {
      var JSCompiler_object_inline_digest_2724;
      var JSCompiler_object_inline_stack_2725 = workInProgress2.pendingProps;
      shouldSuspendImpl(workInProgress2) && (workInProgress2.flags |= 128);
      var JSCompiler_object_inline_message_2723 = false;
      var didSuspend = 0 !== (workInProgress2.flags & 128);
      (JSCompiler_object_inline_digest_2724 = didSuspend) || (JSCompiler_object_inline_digest_2724 = null !== current3 && null === current3.memoizedState ? false : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
      JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_message_2723 = true, workInProgress2.flags &= -129);
      JSCompiler_object_inline_digest_2724 = 0 !== (workInProgress2.flags & 32);
      workInProgress2.flags &= -33;
      if (null === current3) {
        if (isHydrating) {
          JSCompiler_object_inline_message_2723 ? pushPrimaryTreeSuspenseHandler(workInProgress2) : reuseSuspenseHandlerOnStack(workInProgress2);
          (current3 = nextHydratableInstance) ? (renderLanes2 = canHydrateHydrationBoundary(
            current3,
            rootOrSingletonContext
          ), renderLanes2 = null !== renderLanes2 && renderLanes2.data !== ACTIVITY_START_DATA ? renderLanes2 : null, null !== renderLanes2 && (JSCompiler_object_inline_digest_2724 = {
            dehydrated: renderLanes2,
            treeContext: getSuspendedTreeContext(),
            retryLane: 536870912,
            hydrationErrors: null
          }, workInProgress2.memoizedState = JSCompiler_object_inline_digest_2724, JSCompiler_object_inline_digest_2724 = createFiberFromDehydratedFragment(renderLanes2), JSCompiler_object_inline_digest_2724.return = workInProgress2, workInProgress2.child = JSCompiler_object_inline_digest_2724, hydrationParentFiber = workInProgress2, nextHydratableInstance = null)) : renderLanes2 = null;
          if (null === renderLanes2)
            throw warnNonHydratedInstance(workInProgress2, current3), throwOnHydrationMismatch(workInProgress2);
          isSuspenseInstanceFallback(renderLanes2) ? workInProgress2.lanes = 32 : workInProgress2.lanes = 536870912;
          return null;
        }
        var nextPrimaryChildren = JSCompiler_object_inline_stack_2725.children;
        JSCompiler_object_inline_stack_2725 = JSCompiler_object_inline_stack_2725.fallback;
        if (JSCompiler_object_inline_message_2723) {
          reuseSuspenseHandlerOnStack(workInProgress2);
          var mode = workInProgress2.mode;
          nextPrimaryChildren = mountWorkInProgressOffscreenFiber(
            { mode: "hidden", children: nextPrimaryChildren },
            mode
          );
          JSCompiler_object_inline_stack_2725 = createFiberFromFragment(
            JSCompiler_object_inline_stack_2725,
            mode,
            renderLanes2,
            null
          );
          nextPrimaryChildren.return = workInProgress2;
          JSCompiler_object_inline_stack_2725.return = workInProgress2;
          nextPrimaryChildren.sibling = JSCompiler_object_inline_stack_2725;
          workInProgress2.child = nextPrimaryChildren;
          JSCompiler_object_inline_stack_2725 = workInProgress2.child;
          JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes2);
          JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(
            current3,
            JSCompiler_object_inline_digest_2724,
            renderLanes2
          );
          workInProgress2.memoizedState = SUSPENDED_MARKER;
          return bailoutOffscreenComponent(
            null,
            JSCompiler_object_inline_stack_2725
          );
        }
        pushPrimaryTreeSuspenseHandler(workInProgress2);
        return mountSuspensePrimaryChildren(
          workInProgress2,
          nextPrimaryChildren
        );
      }
      var prevState = current3.memoizedState;
      if (null !== prevState) {
        var JSCompiler_object_inline_componentStack_2726 = prevState.dehydrated;
        if (null !== JSCompiler_object_inline_componentStack_2726) {
          if (didSuspend)
            workInProgress2.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags &= -257, workInProgress2 = retrySuspenseComponentWithoutHydrating(
              current3,
              workInProgress2,
              renderLanes2
            )) : null !== workInProgress2.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress2), workInProgress2.child = current3.child, workInProgress2.flags |= 128, workInProgress2 = null) : (reuseSuspenseHandlerOnStack(workInProgress2), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress2.mode, JSCompiler_object_inline_stack_2725 = mountWorkInProgressOffscreenFiber(
              {
                mode: "visible",
                children: JSCompiler_object_inline_stack_2725.children
              },
              mode
            ), nextPrimaryChildren = createFiberFromFragment(
              nextPrimaryChildren,
              mode,
              renderLanes2,
              null
            ), nextPrimaryChildren.flags |= 2, JSCompiler_object_inline_stack_2725.return = workInProgress2, nextPrimaryChildren.return = workInProgress2, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress2.child = JSCompiler_object_inline_stack_2725, reconcileChildFibers(
              workInProgress2,
              current3.child,
              null,
              renderLanes2
            ), JSCompiler_object_inline_stack_2725 = workInProgress2.child, JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes2), JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(
              current3,
              JSCompiler_object_inline_digest_2724,
              renderLanes2
            ), workInProgress2.memoizedState = SUSPENDED_MARKER, workInProgress2 = bailoutOffscreenComponent(
              null,
              JSCompiler_object_inline_stack_2725
            ));
          else if (pushPrimaryTreeSuspenseHandler(workInProgress2), warnIfHydrating(), 0 !== (renderLanes2 & 536870912) && markRenderDerivedCause(workInProgress2), isSuspenseInstanceFallback(
            JSCompiler_object_inline_componentStack_2726
          )) {
            JSCompiler_object_inline_digest_2724 = JSCompiler_object_inline_componentStack_2726.nextSibling && JSCompiler_object_inline_componentStack_2726.nextSibling.dataset;
            if (JSCompiler_object_inline_digest_2724) {
              nextPrimaryChildren = JSCompiler_object_inline_digest_2724.dgst;
              var message = JSCompiler_object_inline_digest_2724.msg;
              mode = JSCompiler_object_inline_digest_2724.stck;
              var componentStack = JSCompiler_object_inline_digest_2724.cstck;
            }
            JSCompiler_object_inline_message_2723 = message;
            JSCompiler_object_inline_digest_2724 = nextPrimaryChildren;
            JSCompiler_object_inline_stack_2725 = mode;
            JSCompiler_object_inline_componentStack_2726 = componentStack;
            nextPrimaryChildren = JSCompiler_object_inline_message_2723;
            mode = JSCompiler_object_inline_componentStack_2726;
            nextPrimaryChildren = nextPrimaryChildren ? Error(nextPrimaryChildren) : Error(
              "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."
            );
            nextPrimaryChildren.stack = JSCompiler_object_inline_stack_2725 || "";
            nextPrimaryChildren.digest = JSCompiler_object_inline_digest_2724;
            JSCompiler_object_inline_digest_2724 = void 0 === mode ? null : mode;
            JSCompiler_object_inline_stack_2725 = {
              value: nextPrimaryChildren,
              source: null,
              stack: JSCompiler_object_inline_digest_2724
            };
            "string" === typeof JSCompiler_object_inline_digest_2724 && CapturedStacks.set(
              nextPrimaryChildren,
              JSCompiler_object_inline_stack_2725
            );
            queueHydrationError(JSCompiler_object_inline_stack_2725);
            workInProgress2 = retrySuspenseComponentWithoutHydrating(
              current3,
              workInProgress2,
              renderLanes2
            );
          } else if (didReceiveUpdate || propagateParentContextChanges(
            current3,
            workInProgress2,
            renderLanes2,
            false
          ), JSCompiler_object_inline_digest_2724 = 0 !== (renderLanes2 & current3.childLanes), didReceiveUpdate || JSCompiler_object_inline_digest_2724) {
            JSCompiler_object_inline_digest_2724 = workInProgressRoot;
            if (null !== JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_stack_2725 = getBumpedLaneForHydration(
              JSCompiler_object_inline_digest_2724,
              renderLanes2
            ), 0 !== JSCompiler_object_inline_stack_2725 && JSCompiler_object_inline_stack_2725 !== prevState.retryLane))
              throw prevState.retryLane = JSCompiler_object_inline_stack_2725, enqueueConcurrentRenderForLane(
                current3,
                JSCompiler_object_inline_stack_2725
              ), scheduleUpdateOnFiber(
                JSCompiler_object_inline_digest_2724,
                current3,
                JSCompiler_object_inline_stack_2725
              ), SelectiveHydrationException;
            isSuspenseInstancePending(
              JSCompiler_object_inline_componentStack_2726
            ) || renderDidSuspendDelayIfPossible();
            workInProgress2 = retrySuspenseComponentWithoutHydrating(
              current3,
              workInProgress2,
              renderLanes2
            );
          } else
            isSuspenseInstancePending(
              JSCompiler_object_inline_componentStack_2726
            ) ? (workInProgress2.flags |= 192, workInProgress2.child = current3.child, workInProgress2 = null) : (current3 = prevState.treeContext, nextHydratableInstance = getNextHydratable(
              JSCompiler_object_inline_componentStack_2726.nextSibling
            ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, didSuspendOrErrorDEV = false, hydrationDiffRootDEV = null, rootOrSingletonContext = false, null !== current3 && restoreSuspendedTreeContext(workInProgress2, current3), workInProgress2 = mountSuspensePrimaryChildren(
              workInProgress2,
              JSCompiler_object_inline_stack_2725.children
            ), workInProgress2.flags |= 4096);
          return workInProgress2;
        }
      }
      if (JSCompiler_object_inline_message_2723)
        return reuseSuspenseHandlerOnStack(workInProgress2), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress2.mode, componentStack = current3.child, JSCompiler_object_inline_componentStack_2726 = componentStack.sibling, JSCompiler_object_inline_stack_2725 = createWorkInProgress(
          componentStack,
          {
            mode: "hidden",
            children: JSCompiler_object_inline_stack_2725.children
          }
        ), JSCompiler_object_inline_stack_2725.subtreeFlags = componentStack.subtreeFlags & 65011712, null !== JSCompiler_object_inline_componentStack_2726 ? nextPrimaryChildren = createWorkInProgress(
          JSCompiler_object_inline_componentStack_2726,
          nextPrimaryChildren
        ) : (nextPrimaryChildren = createFiberFromFragment(
          nextPrimaryChildren,
          mode,
          renderLanes2,
          null
        ), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress2, JSCompiler_object_inline_stack_2725.return = workInProgress2, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress2.child = JSCompiler_object_inline_stack_2725, bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725), JSCompiler_object_inline_stack_2725 = workInProgress2.child, nextPrimaryChildren = current3.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes2) : (mode = nextPrimaryChildren.cachePool, null !== mode ? (componentStack = CacheContext._currentValue, mode = mode.parent !== componentStack ? { parent: componentStack, pool: componentStack } : mode) : mode = getSuspendedCache(), nextPrimaryChildren = {
          baseLanes: nextPrimaryChildren.baseLanes | renderLanes2,
          cachePool: mode
        }), JSCompiler_object_inline_stack_2725.memoizedState = nextPrimaryChildren, JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(
          current3,
          JSCompiler_object_inline_digest_2724,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(
          current3.child,
          JSCompiler_object_inline_stack_2725
        );
      null !== prevState && (renderLanes2 & 62914560) === renderLanes2 && 0 !== (renderLanes2 & current3.lanes) && markRenderDerivedCause(workInProgress2);
      pushPrimaryTreeSuspenseHandler(workInProgress2);
      renderLanes2 = current3.child;
      current3 = renderLanes2.sibling;
      renderLanes2 = createWorkInProgress(renderLanes2, {
        mode: "visible",
        children: JSCompiler_object_inline_stack_2725.children
      });
      renderLanes2.return = workInProgress2;
      renderLanes2.sibling = null;
      null !== current3 && (JSCompiler_object_inline_digest_2724 = workInProgress2.deletions, null === JSCompiler_object_inline_digest_2724 ? (workInProgress2.deletions = [current3], workInProgress2.flags |= 16) : JSCompiler_object_inline_digest_2724.push(current3));
      workInProgress2.child = renderLanes2;
      workInProgress2.memoizedState = null;
      return renderLanes2;
    }
    function mountSuspensePrimaryChildren(workInProgress2, primaryChildren) {
      primaryChildren = mountWorkInProgressOffscreenFiber(
        { mode: "visible", children: primaryChildren },
        workInProgress2.mode
      );
      primaryChildren.return = workInProgress2;
      return workInProgress2.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
      offscreenProps = createFiber(22, offscreenProps, null, mode);
      offscreenProps.lanes = 0;
      return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current3, workInProgress2, renderLanes2) {
      reconcileChildFibers(workInProgress2, current3.child, null, renderLanes2);
      current3 = mountSuspensePrimaryChildren(
        workInProgress2,
        workInProgress2.pendingProps.children
      );
      current3.flags |= 2;
      workInProgress2.memoizedState = null;
      return current3;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes2, propagationRoot) {
      fiber.lanes |= renderLanes2;
      var alternate = fiber.alternate;
      null !== alternate && (alternate.lanes |= renderLanes2);
      scheduleContextWorkOnParentPath(
        fiber.return,
        renderLanes2,
        propagationRoot
      );
    }
    function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode, treeForkCount2) {
      var renderState = workInProgress2.memoizedState;
      null === renderState ? workInProgress2.memoizedState = {
        isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail,
        tailMode,
        treeForkCount: treeForkCount2
      } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount2);
    }
    function updateSuspenseListComponent(current3, workInProgress2, renderLanes2) {
      var nextProps = workInProgress2.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail, newChildren = nextProps.children, suspenseContext = suspenseStackCursor.current;
      (nextProps = 0 !== (suspenseContext & ForceSuspenseFallback)) ? (suspenseContext = suspenseContext & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress2.flags |= 128) : suspenseContext &= SubtreeSuspenseContextMask;
      push2(suspenseStackCursor, suspenseContext, workInProgress2);
      suspenseContext = null == revealOrder ? "null" : revealOrder;
      if ("forwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && "together" !== revealOrder && "independent" !== revealOrder && !didWarnAboutRevealOrder[suspenseContext])
        if (didWarnAboutRevealOrder[suspenseContext] = true, null == revealOrder)
          console.error(
            'The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".'
          );
        else if ("backwards" === revealOrder)
          console.error(
            'The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.'
          );
        else if ("string" === typeof revealOrder)
          switch (revealOrder.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
            case "independent":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                revealOrder,
                revealOrder.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                revealOrder,
                revealOrder.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
                revealOrder
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
            revealOrder
          );
      suspenseContext = null == tailMode ? "null" : tailMode;
      if (!didWarnAboutTailOptions[suspenseContext])
        if (null == tailMode) {
          if ("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder)
            didWarnAboutTailOptions[suspenseContext] = true, console.error(
              'The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".'
            );
        } else
          "visible" !== tailMode && "collapsed" !== tailMode && "hidden" !== tailMode ? (didWarnAboutTailOptions[suspenseContext] = true, console.error(
            '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?',
            tailMode
          )) : "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && (didWarnAboutTailOptions[suspenseContext] = true, console.error(
            '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
            tailMode
          ));
      a: if (("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) && void 0 !== newChildren && null !== newChildren && false !== newChildren)
        if (isArrayImpl(newChildren))
          for (suspenseContext = 0; suspenseContext < newChildren.length; suspenseContext++) {
            if (!validateSuspenseListNestedChild(
              newChildren[suspenseContext],
              suspenseContext
            ))
              break a;
          }
        else if (suspenseContext = getIteratorFn(newChildren), "function" === typeof suspenseContext) {
          if (suspenseContext = suspenseContext.call(newChildren))
            for (var step = suspenseContext.next(), _i = 0; !step.done; step = suspenseContext.next()) {
              if (!validateSuspenseListNestedChild(step.value, _i)) break a;
              _i++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            revealOrder
          );
      reconcileChildren(current3, workInProgress2, newChildren, renderLanes2);
      isHydrating ? (warnIfNotHydrating(), newChildren = treeForkCount) : newChildren = 0;
      if (!nextProps && null !== current3 && 0 !== (current3.flags & 128))
        a: for (current3 = workInProgress2.child; null !== current3; ) {
          if (13 === current3.tag)
            null !== current3.memoizedState && scheduleSuspenseWorkOnFiber(current3, renderLanes2, workInProgress2);
          else if (19 === current3.tag)
            scheduleSuspenseWorkOnFiber(current3, renderLanes2, workInProgress2);
          else if (null !== current3.child) {
            current3.child.return = current3;
            current3 = current3.child;
            continue;
          }
          if (current3 === workInProgress2) break a;
          for (; null === current3.sibling; ) {
            if (null === current3.return || current3.return === workInProgress2)
              break a;
            current3 = current3.return;
          }
          current3.sibling.return = current3.return;
          current3 = current3.sibling;
        }
      switch (revealOrder) {
        case "forwards":
          renderLanes2 = workInProgress2.child;
          for (revealOrder = null; null !== renderLanes2; )
            current3 = renderLanes2.alternate, null !== current3 && null === findFirstSuspended(current3) && (revealOrder = renderLanes2), renderLanes2 = renderLanes2.sibling;
          renderLanes2 = revealOrder;
          null === renderLanes2 ? (revealOrder = workInProgress2.child, workInProgress2.child = null) : (revealOrder = renderLanes2.sibling, renderLanes2.sibling = null);
          initSuspenseListRenderState(
            workInProgress2,
            false,
            revealOrder,
            renderLanes2,
            tailMode,
            newChildren
          );
          break;
        case "backwards":
        case "unstable_legacy-backwards":
          renderLanes2 = null;
          revealOrder = workInProgress2.child;
          for (workInProgress2.child = null; null !== revealOrder; ) {
            current3 = revealOrder.alternate;
            if (null !== current3 && null === findFirstSuspended(current3)) {
              workInProgress2.child = revealOrder;
              break;
            }
            current3 = revealOrder.sibling;
            revealOrder.sibling = renderLanes2;
            renderLanes2 = revealOrder;
            revealOrder = current3;
          }
          initSuspenseListRenderState(
            workInProgress2,
            true,
            renderLanes2,
            null,
            tailMode,
            newChildren
          );
          break;
        case "together":
          initSuspenseListRenderState(
            workInProgress2,
            false,
            null,
            null,
            void 0,
            newChildren
          );
          break;
        default:
          workInProgress2.memoizedState = null;
      }
      return workInProgress2.child;
    }
    function bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2) {
      null !== current3 && (workInProgress2.dependencies = current3.dependencies);
      profilerStartTime = -1;
      workInProgressRootSkippedLanes |= workInProgress2.lanes;
      if (0 === (renderLanes2 & workInProgress2.childLanes))
        if (null !== current3) {
          if (propagateParentContextChanges(
            current3,
            workInProgress2,
            renderLanes2,
            false
          ), 0 === (renderLanes2 & workInProgress2.childLanes))
            return null;
        } else return null;
      if (null !== current3 && workInProgress2.child !== current3.child)
        throw Error("Resuming work not yet implemented.");
      if (null !== workInProgress2.child) {
        current3 = workInProgress2.child;
        renderLanes2 = createWorkInProgress(current3, current3.pendingProps);
        workInProgress2.child = renderLanes2;
        for (renderLanes2.return = workInProgress2; null !== current3.sibling; )
          current3 = current3.sibling, renderLanes2 = renderLanes2.sibling = createWorkInProgress(current3, current3.pendingProps), renderLanes2.return = workInProgress2;
        renderLanes2.sibling = null;
      }
      return workInProgress2.child;
    }
    function checkScheduledUpdateOrContext(current3, renderLanes2) {
      if (0 !== (current3.lanes & renderLanes2)) return true;
      current3 = current3.dependencies;
      return null !== current3 && checkIfContextChanged(current3) ? true : false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current3, workInProgress2, renderLanes2) {
      switch (workInProgress2.tag) {
        case 3:
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          pushProvider(
            workInProgress2,
            CacheContext,
            current3.memoizedState.cache
          );
          resetHydrationState();
          break;
        case 27:
        case 5:
          pushHostContext(workInProgress2);
          break;
        case 4:
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          break;
        case 10:
          pushProvider(
            workInProgress2,
            workInProgress2.type,
            workInProgress2.memoizedProps.value
          );
          break;
        case 12:
          0 !== (renderLanes2 & workInProgress2.childLanes) && (workInProgress2.flags |= 4);
          workInProgress2.flags |= 2048;
          var stateNode = workInProgress2.stateNode;
          stateNode.effectDuration = -0;
          stateNode.passiveEffectDuration = -0;
          break;
        case 31:
          if (null !== workInProgress2.memoizedState)
            return workInProgress2.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress2), null;
          break;
        case 13:
          stateNode = workInProgress2.memoizedState;
          if (null !== stateNode) {
            if (null !== stateNode.dehydrated)
              return pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags |= 128, null;
            if (0 !== (renderLanes2 & workInProgress2.child.childLanes))
              return updateSuspenseComponent(
                current3,
                workInProgress2,
                renderLanes2
              );
            pushPrimaryTreeSuspenseHandler(workInProgress2);
            current3 = bailoutOnAlreadyFinishedWork(
              current3,
              workInProgress2,
              renderLanes2
            );
            return null !== current3 ? current3.sibling : null;
          }
          pushPrimaryTreeSuspenseHandler(workInProgress2);
          break;
        case 19:
          var didSuspendBefore = 0 !== (current3.flags & 128);
          stateNode = 0 !== (renderLanes2 & workInProgress2.childLanes);
          stateNode || (propagateParentContextChanges(
            current3,
            workInProgress2,
            renderLanes2,
            false
          ), stateNode = 0 !== (renderLanes2 & workInProgress2.childLanes));
          if (didSuspendBefore) {
            if (stateNode)
              return updateSuspenseListComponent(
                current3,
                workInProgress2,
                renderLanes2
              );
            workInProgress2.flags |= 128;
          }
          didSuspendBefore = workInProgress2.memoizedState;
          null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
          push2(
            suspenseStackCursor,
            suspenseStackCursor.current,
            workInProgress2
          );
          if (stateNode) break;
          else return null;
        case 22:
          return workInProgress2.lanes = 0, updateOffscreenComponent(
            current3,
            workInProgress2,
            renderLanes2,
            workInProgress2.pendingProps
          );
        case 24:
          pushProvider(
            workInProgress2,
            CacheContext,
            current3.memoizedState.cache
          );
      }
      return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
    }
    function beginWork(current3, workInProgress2, renderLanes2) {
      if (workInProgress2._debugNeedsRemount && null !== current3) {
        renderLanes2 = createFiberFromTypeAndProps(
          workInProgress2.type,
          workInProgress2.key,
          workInProgress2.pendingProps,
          workInProgress2._debugOwner || null,
          workInProgress2.mode,
          workInProgress2.lanes
        );
        renderLanes2._debugStack = workInProgress2._debugStack;
        renderLanes2._debugTask = workInProgress2._debugTask;
        var returnFiber = workInProgress2.return;
        if (null === returnFiber) throw Error("Cannot swap the root fiber.");
        current3.alternate = null;
        workInProgress2.alternate = null;
        renderLanes2.index = workInProgress2.index;
        renderLanes2.sibling = workInProgress2.sibling;
        renderLanes2.return = workInProgress2.return;
        renderLanes2.ref = workInProgress2.ref;
        renderLanes2._debugInfo = workInProgress2._debugInfo;
        if (workInProgress2 === returnFiber.child)
          returnFiber.child = renderLanes2;
        else {
          var prevSibling = returnFiber.child;
          if (null === prevSibling)
            throw Error("Expected parent to have a child.");
          for (; prevSibling.sibling !== workInProgress2; )
            if (prevSibling = prevSibling.sibling, null === prevSibling)
              throw Error("Expected to find the previous sibling.");
          prevSibling.sibling = renderLanes2;
        }
        workInProgress2 = returnFiber.deletions;
        null === workInProgress2 ? (returnFiber.deletions = [current3], returnFiber.flags |= 16) : workInProgress2.push(current3);
        renderLanes2.flags |= 2;
        return renderLanes2;
      }
      if (null !== current3)
        if (current3.memoizedProps !== workInProgress2.pendingProps || workInProgress2.type !== current3.type)
          didReceiveUpdate = true;
        else {
          if (!checkScheduledUpdateOrContext(current3, renderLanes2) && 0 === (workInProgress2.flags & 128))
            return didReceiveUpdate = false, attemptEarlyBailoutIfNoScheduledUpdate(
              current3,
              workInProgress2,
              renderLanes2
            );
          didReceiveUpdate = 0 !== (current3.flags & 131072) ? true : false;
        }
      else {
        didReceiveUpdate = false;
        if (returnFiber = isHydrating)
          warnIfNotHydrating(), returnFiber = 0 !== (workInProgress2.flags & 1048576);
        returnFiber && (returnFiber = workInProgress2.index, warnIfNotHydrating(), pushTreeId(workInProgress2, treeForkCount, returnFiber));
      }
      workInProgress2.lanes = 0;
      switch (workInProgress2.tag) {
        case 16:
          a: if (returnFiber = workInProgress2.pendingProps, current3 = resolveLazy(workInProgress2.elementType), workInProgress2.type = current3, "function" === typeof current3)
            shouldConstruct(current3) ? (returnFiber = resolveClassComponentProps(
              current3,
              returnFiber
            ), workInProgress2.tag = 1, workInProgress2.type = current3 = resolveFunctionForHotReloading(current3), workInProgress2 = updateClassComponent(
              null,
              workInProgress2,
              current3,
              returnFiber,
              renderLanes2
            )) : (workInProgress2.tag = 0, validateFunctionComponentInDev(workInProgress2, current3), workInProgress2.type = current3 = resolveFunctionForHotReloading(current3), workInProgress2 = updateFunctionComponent(
              null,
              workInProgress2,
              current3,
              returnFiber,
              renderLanes2
            ));
          else {
            if (void 0 !== current3 && null !== current3) {
              if (prevSibling = current3.$$typeof, prevSibling === REACT_FORWARD_REF_TYPE) {
                workInProgress2.tag = 11;
                workInProgress2.type = current3 = resolveForwardRefForHotReloading(current3);
                workInProgress2 = updateForwardRef(
                  null,
                  workInProgress2,
                  current3,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else if (prevSibling === REACT_MEMO_TYPE) {
                workInProgress2.tag = 14;
                workInProgress2 = updateMemoComponent(
                  null,
                  workInProgress2,
                  current3,
                  returnFiber,
                  renderLanes2
                );
                break a;
              }
            }
            workInProgress2 = "";
            null !== current3 && "object" === typeof current3 && current3.$$typeof === REACT_LAZY_TYPE && (workInProgress2 = " Did you wrap a component in React.lazy() more than once?");
            renderLanes2 = getComponentNameFromType(current3) || current3;
            throw Error(
              "Element type is invalid. Received a promise that resolves to: " + renderLanes2 + ". Lazy element type must resolve to a class or function." + workInProgress2
            );
          }
          return workInProgress2;
        case 0:
          return updateFunctionComponent(
            current3,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 1:
          return returnFiber = workInProgress2.type, prevSibling = resolveClassComponentProps(
            returnFiber,
            workInProgress2.pendingProps
          ), updateClassComponent(
            current3,
            workInProgress2,
            returnFiber,
            prevSibling,
            renderLanes2
          );
        case 3:
          a: {
            pushHostContainer(
              workInProgress2,
              workInProgress2.stateNode.containerInfo
            );
            if (null === current3)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            returnFiber = workInProgress2.pendingProps;
            var prevState = workInProgress2.memoizedState;
            prevSibling = prevState.element;
            cloneUpdateQueue(current3, workInProgress2);
            processUpdateQueue(workInProgress2, returnFiber, null, renderLanes2);
            var nextState = workInProgress2.memoizedState;
            returnFiber = nextState.cache;
            pushProvider(workInProgress2, CacheContext, returnFiber);
            returnFiber !== prevState.cache && propagateContextChanges(
              workInProgress2,
              [CacheContext],
              renderLanes2,
              true
            );
            suspendIfUpdateReadFromEntangledAsyncAction();
            returnFiber = nextState.element;
            if (prevState.isDehydrated)
              if (prevState = {
                element: returnFiber,
                isDehydrated: false,
                cache: nextState.cache
              }, workInProgress2.updateQueue.baseState = prevState, workInProgress2.memoizedState = prevState, workInProgress2.flags & 256) {
                workInProgress2 = mountHostRootWithoutHydrating(
                  current3,
                  workInProgress2,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else if (returnFiber !== prevSibling) {
                prevSibling = createCapturedValueAtFiber(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  workInProgress2
                );
                queueHydrationError(prevSibling);
                workInProgress2 = mountHostRootWithoutHydrating(
                  current3,
                  workInProgress2,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else {
                current3 = workInProgress2.stateNode.containerInfo;
                switch (current3.nodeType) {
                  case 9:
                    current3 = current3.body;
                    break;
                  default:
                    current3 = "HTML" === current3.nodeName ? current3.ownerDocument.body : current3;
                }
                nextHydratableInstance = getNextHydratable(current3.firstChild);
                hydrationParentFiber = workInProgress2;
                isHydrating = true;
                hydrationErrors = null;
                didSuspendOrErrorDEV = false;
                hydrationDiffRootDEV = null;
                rootOrSingletonContext = true;
                renderLanes2 = mountChildFibers(
                  workInProgress2,
                  null,
                  returnFiber,
                  renderLanes2
                );
                for (workInProgress2.child = renderLanes2; renderLanes2; )
                  renderLanes2.flags = renderLanes2.flags & -3 | 4096, renderLanes2 = renderLanes2.sibling;
              }
            else {
              resetHydrationState();
              if (returnFiber === prevSibling) {
                workInProgress2 = bailoutOnAlreadyFinishedWork(
                  current3,
                  workInProgress2,
                  renderLanes2
                );
                break a;
              }
              reconcileChildren(
                current3,
                workInProgress2,
                returnFiber,
                renderLanes2
              );
            }
            workInProgress2 = workInProgress2.child;
          }
          return workInProgress2;
        case 26:
          return markRef(current3, workInProgress2), null === current3 ? (renderLanes2 = getResource(
            workInProgress2.type,
            null,
            workInProgress2.pendingProps,
            null
          )) ? workInProgress2.memoizedState = renderLanes2 : isHydrating || (renderLanes2 = workInProgress2.type, current3 = workInProgress2.pendingProps, returnFiber = requiredContext(
            rootInstanceStackCursor.current
          ), returnFiber = getOwnerDocumentFromRootContainer(
            returnFiber
          ).createElement(renderLanes2), returnFiber[internalInstanceKey] = workInProgress2, returnFiber[internalPropsKey] = current3, setInitialProperties(returnFiber, renderLanes2, current3), markNodeAsHoistable(returnFiber), workInProgress2.stateNode = returnFiber) : workInProgress2.memoizedState = getResource(
            workInProgress2.type,
            current3.memoizedProps,
            workInProgress2.pendingProps,
            current3.memoizedState
          ), null;
        case 27:
          return pushHostContext(workInProgress2), null === current3 && isHydrating && (returnFiber = requiredContext(rootInstanceStackCursor.current), prevSibling = getHostContext(), returnFiber = workInProgress2.stateNode = resolveSingletonInstance(
            workInProgress2.type,
            workInProgress2.pendingProps,
            returnFiber,
            prevSibling,
            false
          ), didSuspendOrErrorDEV || (prevSibling = diffHydratedProperties(
            returnFiber,
            workInProgress2.type,
            workInProgress2.pendingProps,
            prevSibling
          ), null !== prevSibling && (buildHydrationDiffNode(workInProgress2, 0).serverProps = prevSibling)), hydrationParentFiber = workInProgress2, rootOrSingletonContext = true, prevSibling = nextHydratableInstance, isSingletonScope(workInProgress2.type) ? (previousHydratableOnEnteringScopedSingleton = prevSibling, nextHydratableInstance = getNextHydratable(
            returnFiber.firstChild
          )) : nextHydratableInstance = prevSibling), reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), markRef(current3, workInProgress2), null === current3 && (workInProgress2.flags |= 4194304), workInProgress2.child;
        case 5:
          return null === current3 && isHydrating && (prevState = getHostContext(), returnFiber = validateDOMNesting(
            workInProgress2.type,
            prevState.ancestorInfo
          ), prevSibling = nextHydratableInstance, (nextState = !prevSibling) || (nextState = canHydrateInstance(
            prevSibling,
            workInProgress2.type,
            workInProgress2.pendingProps,
            rootOrSingletonContext
          ), null !== nextState ? (workInProgress2.stateNode = nextState, didSuspendOrErrorDEV || (prevState = diffHydratedProperties(
            nextState,
            workInProgress2.type,
            workInProgress2.pendingProps,
            prevState
          ), null !== prevState && (buildHydrationDiffNode(workInProgress2, 0).serverProps = prevState)), hydrationParentFiber = workInProgress2, nextHydratableInstance = getNextHydratable(
            nextState.firstChild
          ), rootOrSingletonContext = false, prevState = true) : prevState = false, nextState = !prevState), nextState && (returnFiber && warnNonHydratedInstance(workInProgress2, prevSibling), throwOnHydrationMismatch(workInProgress2))), pushHostContext(workInProgress2), prevSibling = workInProgress2.type, prevState = workInProgress2.pendingProps, nextState = null !== current3 ? current3.memoizedProps : null, returnFiber = prevState.children, shouldSetTextContent(prevSibling, prevState) ? returnFiber = null : null !== nextState && shouldSetTextContent(prevSibling, nextState) && (workInProgress2.flags |= 32), null !== workInProgress2.memoizedState && (prevSibling = renderWithHooks(
            current3,
            workInProgress2,
            TransitionAwareHostComponent,
            null,
            null,
            renderLanes2
          ), HostTransitionContext._currentValue = prevSibling), markRef(current3, workInProgress2), reconcileChildren(
            current3,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 6:
          return null === current3 && isHydrating && (renderLanes2 = workInProgress2.pendingProps, current3 = getHostContext(), returnFiber = current3.ancestorInfo.current, renderLanes2 = null != returnFiber ? validateTextNesting(
            renderLanes2,
            returnFiber.tag,
            current3.ancestorInfo.implicitRootScope
          ) : true, current3 = nextHydratableInstance, (returnFiber = !current3) || (returnFiber = canHydrateTextInstance(
            current3,
            workInProgress2.pendingProps,
            rootOrSingletonContext
          ), null !== returnFiber ? (workInProgress2.stateNode = returnFiber, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, returnFiber = true) : returnFiber = false, returnFiber = !returnFiber), returnFiber && (renderLanes2 && warnNonHydratedInstance(workInProgress2, current3), throwOnHydrationMismatch(workInProgress2))), null;
        case 13:
          return updateSuspenseComponent(current3, workInProgress2, renderLanes2);
        case 4:
          return pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          ), returnFiber = workInProgress2.pendingProps, null === current3 ? workInProgress2.child = reconcileChildFibers(
            workInProgress2,
            null,
            returnFiber,
            renderLanes2
          ) : reconcileChildren(
            current3,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 11:
          return updateForwardRef(
            current3,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 7:
          return reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps,
            renderLanes2
          ), workInProgress2.child;
        case 8:
          return reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 12:
          return workInProgress2.flags |= 4, workInProgress2.flags |= 2048, returnFiber = workInProgress2.stateNode, returnFiber.effectDuration = -0, returnFiber.passiveEffectDuration = -0, reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 10:
          return returnFiber = workInProgress2.type, prevSibling = workInProgress2.pendingProps, prevState = prevSibling.value, "value" in prevSibling || hasWarnedAboutUsingNoValuePropOnContextProvider || (hasWarnedAboutUsingNoValuePropOnContextProvider = true, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), pushProvider(workInProgress2, returnFiber, prevState), reconcileChildren(
            current3,
            workInProgress2,
            prevSibling.children,
            renderLanes2
          ), workInProgress2.child;
        case 9:
          return prevSibling = workInProgress2.type._context, returnFiber = workInProgress2.pendingProps.children, "function" !== typeof returnFiber && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), prepareToReadContext(workInProgress2), prevSibling = readContext(prevSibling), returnFiber = callComponentInDEV(
            returnFiber,
            prevSibling,
            void 0
          ), workInProgress2.flags |= 1, reconcileChildren(
            current3,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 14:
          return updateMemoComponent(
            current3,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 15:
          return updateSimpleMemoComponent(
            current3,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 19:
          return updateSuspenseListComponent(
            current3,
            workInProgress2,
            renderLanes2
          );
        case 31:
          return updateActivityComponent(current3, workInProgress2, renderLanes2);
        case 22:
          return updateOffscreenComponent(
            current3,
            workInProgress2,
            renderLanes2,
            workInProgress2.pendingProps
          );
        case 24:
          return prepareToReadContext(workInProgress2), returnFiber = readContext(CacheContext), null === current3 ? (prevSibling = peekCacheFromPool(), null === prevSibling && (prevSibling = workInProgressRoot, prevState = createCache(), prevSibling.pooledCache = prevState, retainCache(prevState), null !== prevState && (prevSibling.pooledCacheLanes |= renderLanes2), prevSibling = prevState), workInProgress2.memoizedState = {
            parent: returnFiber,
            cache: prevSibling
          }, initializeUpdateQueue(workInProgress2), pushProvider(workInProgress2, CacheContext, prevSibling)) : (0 !== (current3.lanes & renderLanes2) && (cloneUpdateQueue(current3, workInProgress2), processUpdateQueue(workInProgress2, null, null, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction()), prevSibling = current3.memoizedState, prevState = workInProgress2.memoizedState, prevSibling.parent !== returnFiber ? (prevSibling = {
            parent: returnFiber,
            cache: returnFiber
          }, workInProgress2.memoizedState = prevSibling, 0 === workInProgress2.lanes && (workInProgress2.memoizedState = workInProgress2.updateQueue.baseState = prevSibling), pushProvider(workInProgress2, CacheContext, returnFiber)) : (returnFiber = prevState.cache, pushProvider(workInProgress2, CacheContext, returnFiber), returnFiber !== prevSibling.cache && propagateContextChanges(
            workInProgress2,
            [CacheContext],
            renderLanes2,
            true
          ))), reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 29:
          throw workInProgress2.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function markUpdate(workInProgress2) {
      workInProgress2.flags |= 4;
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress2, type, oldProps, newProps, renderLanes2) {
      if (type = (workInProgress2.mode & SuspenseyImagesMode) !== NoMode)
        type = false;
      if (type) {
        if (workInProgress2.flags |= 16777216, (renderLanes2 & 335544128) === renderLanes2)
          if (workInProgress2.stateNode.complete) workInProgress2.flags |= 8192;
          else if (shouldRemainOnPreviousScreen()) workInProgress2.flags |= 8192;
          else
            throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
      } else workInProgress2.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress2, resource) {
      if ("stylesheet" !== resource.type || (resource.state.loading & Inserted) !== NotLoaded)
        workInProgress2.flags &= -16777217;
      else if (workInProgress2.flags |= 16777216, !preloadResource(resource))
        if (shouldRemainOnPreviousScreen()) workInProgress2.flags |= 8192;
        else
          throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    }
    function scheduleRetryEffect(workInProgress2, retryQueue) {
      null !== retryQueue && (workInProgress2.flags |= 4);
      workInProgress2.flags & 16384 && (retryQueue = 22 !== workInProgress2.tag ? claimNextRetryLane() : 536870912, workInProgress2.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
      if (!isHydrating)
        switch (renderState.tailMode) {
          case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for (var lastTailNode = null; null !== hasRenderedATailFallback; )
              null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
          case "collapsed":
            lastTailNode = renderState.tail;
            for (var _lastTailNode = null; null !== lastTailNode; )
              null !== lastTailNode.alternate && (_lastTailNode = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === _lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : _lastTailNode.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
      var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
      if (didBailout)
        if ((completedWork.mode & ProfileMode) !== NoMode) {
          for (var _treeBaseDuration = completedWork.selfBaseDuration, _child2 = completedWork.child; null !== _child2; )
            newChildLanes |= _child2.lanes | _child2.childLanes, subtreeFlags |= _child2.subtreeFlags & 65011712, subtreeFlags |= _child2.flags & 65011712, _treeBaseDuration += _child2.treeBaseDuration, _child2 = _child2.sibling;
          completedWork.treeBaseDuration = _treeBaseDuration;
        } else
          for (_treeBaseDuration = completedWork.child; null !== _treeBaseDuration; )
            newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags & 65011712, subtreeFlags |= _treeBaseDuration.flags & 65011712, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
      else if ((completedWork.mode & ProfileMode) !== NoMode) {
        _treeBaseDuration = completedWork.actualDuration;
        _child2 = completedWork.selfBaseDuration;
        for (var child = completedWork.child; null !== child; )
          newChildLanes |= child.lanes | child.childLanes, subtreeFlags |= child.subtreeFlags, subtreeFlags |= child.flags, _treeBaseDuration += child.actualDuration, _child2 += child.treeBaseDuration, child = child.sibling;
        completedWork.actualDuration = _treeBaseDuration;
        completedWork.treeBaseDuration = _child2;
      } else
        for (_treeBaseDuration = completedWork.child; null !== _treeBaseDuration; )
          newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags, subtreeFlags |= _treeBaseDuration.flags, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
      completedWork.subtreeFlags |= subtreeFlags;
      completedWork.childLanes = newChildLanes;
      return didBailout;
    }
    function completeWork(current3, workInProgress2, renderLanes2) {
      var newProps = workInProgress2.pendingProps;
      popTreeContext(workInProgress2);
      switch (workInProgress2.tag) {
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return bubbleProperties(workInProgress2), null;
        case 1:
          return bubbleProperties(workInProgress2), null;
        case 3:
          renderLanes2 = workInProgress2.stateNode;
          newProps = null;
          null !== current3 && (newProps = current3.memoizedState.cache);
          workInProgress2.memoizedState.cache !== newProps && (workInProgress2.flags |= 2048);
          popProvider(CacheContext, workInProgress2);
          popHostContainer(workInProgress2);
          renderLanes2.pendingContext && (renderLanes2.context = renderLanes2.pendingContext, renderLanes2.pendingContext = null);
          if (null === current3 || null === current3.child)
            popHydrationState(workInProgress2) ? (emitPendingHydrationWarnings(), markUpdate(workInProgress2)) : null === current3 || current3.memoizedState.isDehydrated && 0 === (workInProgress2.flags & 256) || (workInProgress2.flags |= 1024, upgradeHydrationErrorsToRecoverable());
          bubbleProperties(workInProgress2);
          return null;
        case 26:
          var type = workInProgress2.type, nextResource = workInProgress2.memoizedState;
          null === current3 ? (markUpdate(workInProgress2), null !== nextResource ? (bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(
            workInProgress2,
            nextResource
          )) : (bubbleProperties(workInProgress2), preloadInstanceAndSuspendIfNeeded(
            workInProgress2,
            type,
            null,
            newProps,
            renderLanes2
          ))) : nextResource ? nextResource !== current3.memoizedState ? (markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(
            workInProgress2,
            nextResource
          )) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217) : (current3 = current3.memoizedProps, current3 !== newProps && markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadInstanceAndSuspendIfNeeded(
            workInProgress2,
            type,
            current3,
            newProps,
            renderLanes2
          ));
          return null;
        case 27:
          popHostContext(workInProgress2);
          renderLanes2 = requiredContext(rootInstanceStackCursor.current);
          type = workInProgress2.type;
          if (null !== current3 && null != workInProgress2.stateNode)
            current3.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if (!newProps) {
              if (null === workInProgress2.stateNode)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              bubbleProperties(workInProgress2);
              return null;
            }
            current3 = getHostContext();
            popHydrationState(workInProgress2) ? prepareToHydrateHostInstance(workInProgress2) : (current3 = resolveSingletonInstance(
              type,
              newProps,
              renderLanes2,
              current3,
              true
            ), workInProgress2.stateNode = current3, markUpdate(workInProgress2));
          }
          bubbleProperties(workInProgress2);
          return null;
        case 5:
          popHostContext(workInProgress2);
          type = workInProgress2.type;
          if (null !== current3 && null != workInProgress2.stateNode)
            current3.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if (!newProps) {
              if (null === workInProgress2.stateNode)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              bubbleProperties(workInProgress2);
              return null;
            }
            var _currentHostContext = getHostContext();
            if (popHydrationState(workInProgress2))
              prepareToHydrateHostInstance(workInProgress2);
            else {
              nextResource = requiredContext(rootInstanceStackCursor.current);
              validateDOMNesting(type, _currentHostContext.ancestorInfo);
              _currentHostContext = _currentHostContext.context;
              nextResource = getOwnerDocumentFromRootContainer(nextResource);
              switch (_currentHostContext) {
                case HostContextNamespaceSvg:
                  nextResource = nextResource.createElementNS(
                    SVG_NAMESPACE,
                    type
                  );
                  break;
                case HostContextNamespaceMath:
                  nextResource = nextResource.createElementNS(
                    MATH_NAMESPACE,
                    type
                  );
                  break;
                default:
                  switch (type) {
                    case "svg":
                      nextResource = nextResource.createElementNS(
                        SVG_NAMESPACE,
                        type
                      );
                      break;
                    case "math":
                      nextResource = nextResource.createElementNS(
                        MATH_NAMESPACE,
                        type
                      );
                      break;
                    case "script":
                      nextResource = nextResource.createElement("div");
                      nextResource.innerHTML = "<script><\/script>";
                      nextResource = nextResource.removeChild(
                        nextResource.firstChild
                      );
                      break;
                    case "select":
                      nextResource = "string" === typeof newProps.is ? nextResource.createElement("select", {
                        is: newProps.is
                      }) : nextResource.createElement("select");
                      newProps.multiple ? nextResource.multiple = true : newProps.size && (nextResource.size = newProps.size);
                      break;
                    default:
                      nextResource = "string" === typeof newProps.is ? nextResource.createElement(type, {
                        is: newProps.is
                      }) : nextResource.createElement(type), -1 === type.indexOf("-") && (type !== type.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        type
                      ), "[object HTMLUnknownElement]" !== Object.prototype.toString.call(nextResource) || hasOwnProperty2.call(warnedUnknownTags, type) || (warnedUnknownTags[type] = true, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        type
                      )));
                  }
              }
              nextResource[internalInstanceKey] = workInProgress2;
              nextResource[internalPropsKey] = newProps;
              a: for (_currentHostContext = workInProgress2.child; null !== _currentHostContext; ) {
                if (5 === _currentHostContext.tag || 6 === _currentHostContext.tag)
                  nextResource.appendChild(_currentHostContext.stateNode);
                else if (4 !== _currentHostContext.tag && 27 !== _currentHostContext.tag && null !== _currentHostContext.child) {
                  _currentHostContext.child.return = _currentHostContext;
                  _currentHostContext = _currentHostContext.child;
                  continue;
                }
                if (_currentHostContext === workInProgress2) break a;
                for (; null === _currentHostContext.sibling; ) {
                  if (null === _currentHostContext.return || _currentHostContext.return === workInProgress2)
                    break a;
                  _currentHostContext = _currentHostContext.return;
                }
                _currentHostContext.sibling.return = _currentHostContext.return;
                _currentHostContext = _currentHostContext.sibling;
              }
              workInProgress2.stateNode = nextResource;
              a: switch (setInitialProperties(nextResource, type, newProps), type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  newProps = !!newProps.autoFocus;
                  break a;
                case "img":
                  newProps = true;
                  break a;
                default:
                  newProps = false;
              }
              newProps && markUpdate(workInProgress2);
            }
          }
          bubbleProperties(workInProgress2);
          preloadInstanceAndSuspendIfNeeded(
            workInProgress2,
            workInProgress2.type,
            null === current3 ? null : current3.memoizedProps,
            workInProgress2.pendingProps,
            renderLanes2
          );
          return null;
        case 6:
          if (current3 && null != workInProgress2.stateNode)
            current3.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if ("string" !== typeof newProps && null === workInProgress2.stateNode)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            current3 = requiredContext(rootInstanceStackCursor.current);
            renderLanes2 = getHostContext();
            if (popHydrationState(workInProgress2)) {
              current3 = workInProgress2.stateNode;
              renderLanes2 = workInProgress2.memoizedProps;
              type = !didSuspendOrErrorDEV;
              newProps = null;
              nextResource = hydrationParentFiber;
              if (null !== nextResource)
                switch (nextResource.tag) {
                  case 3:
                    type && (type = diffHydratedTextForDevWarnings(
                      current3,
                      renderLanes2,
                      newProps
                    ), null !== type && (buildHydrationDiffNode(workInProgress2, 0).serverProps = type));
                    break;
                  case 27:
                  case 5:
                    newProps = nextResource.memoizedProps, type && (type = diffHydratedTextForDevWarnings(
                      current3,
                      renderLanes2,
                      newProps
                    ), null !== type && (buildHydrationDiffNode(
                      workInProgress2,
                      0
                    ).serverProps = type));
                }
              current3[internalInstanceKey] = workInProgress2;
              current3 = current3.nodeValue === renderLanes2 || null !== newProps && true === newProps.suppressHydrationWarning || checkForUnmatchedText(current3.nodeValue, renderLanes2) ? true : false;
              current3 || throwOnHydrationMismatch(workInProgress2, true);
            } else
              type = renderLanes2.ancestorInfo.current, null != type && validateTextNesting(
                newProps,
                type.tag,
                renderLanes2.ancestorInfo.implicitRootScope
              ), current3 = getOwnerDocumentFromRootContainer(current3).createTextNode(
                newProps
              ), current3[internalInstanceKey] = workInProgress2, workInProgress2.stateNode = current3;
          }
          bubbleProperties(workInProgress2);
          return null;
        case 31:
          renderLanes2 = workInProgress2.memoizedState;
          if (null === current3 || null !== current3.memoizedState) {
            newProps = popHydrationState(workInProgress2);
            if (null !== renderLanes2) {
              if (null === current3) {
                if (!newProps)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                current3 = workInProgress2.memoizedState;
                current3 = null !== current3 ? current3.dehydrated : null;
                if (!current3)
                  throw Error(
                    "Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                current3[internalInstanceKey] = workInProgress2;
                bubbleProperties(workInProgress2);
                (workInProgress2.mode & ProfileMode) !== NoMode && null !== renderLanes2 && (current3 = workInProgress2.child, null !== current3 && (workInProgress2.treeBaseDuration -= current3.treeBaseDuration));
              } else
                emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress2.flags & 128) && (renderLanes2 = workInProgress2.memoizedState = null), workInProgress2.flags |= 4, bubbleProperties(workInProgress2), (workInProgress2.mode & ProfileMode) !== NoMode && null !== renderLanes2 && (current3 = workInProgress2.child, null !== current3 && (workInProgress2.treeBaseDuration -= current3.treeBaseDuration));
              current3 = false;
            } else
              renderLanes2 = upgradeHydrationErrorsToRecoverable(), null !== current3 && null !== current3.memoizedState && (current3.memoizedState.hydrationErrors = renderLanes2), current3 = true;
            if (!current3) {
              if (workInProgress2.flags & 256)
                return popSuspenseHandler(workInProgress2), workInProgress2;
              popSuspenseHandler(workInProgress2);
              return null;
            }
            if (0 !== (workInProgress2.flags & 128))
              throw Error(
                "Client rendering an Activity suspended it again. This is a bug in React."
              );
          }
          bubbleProperties(workInProgress2);
          return null;
        case 13:
          newProps = workInProgress2.memoizedState;
          if (null === current3 || null !== current3.memoizedState && null !== current3.memoizedState.dehydrated) {
            type = newProps;
            nextResource = popHydrationState(workInProgress2);
            if (null !== type && null !== type.dehydrated) {
              if (null === current3) {
                if (!nextResource)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                nextResource = workInProgress2.memoizedState;
                nextResource = null !== nextResource ? nextResource.dehydrated : null;
                if (!nextResource)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                nextResource[internalInstanceKey] = workInProgress2;
                bubbleProperties(workInProgress2);
                (workInProgress2.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress2.child, null !== type && (workInProgress2.treeBaseDuration -= type.treeBaseDuration));
              } else
                emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress2.flags & 128) && (type = workInProgress2.memoizedState = null), workInProgress2.flags |= 4, bubbleProperties(workInProgress2), (workInProgress2.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress2.child, null !== type && (workInProgress2.treeBaseDuration -= type.treeBaseDuration));
              type = false;
            } else
              type = upgradeHydrationErrorsToRecoverable(), null !== current3 && null !== current3.memoizedState && (current3.memoizedState.hydrationErrors = type), type = true;
            if (!type) {
              if (workInProgress2.flags & 256)
                return popSuspenseHandler(workInProgress2), workInProgress2;
              popSuspenseHandler(workInProgress2);
              return null;
            }
          }
          popSuspenseHandler(workInProgress2);
          if (0 !== (workInProgress2.flags & 128))
            return workInProgress2.lanes = renderLanes2, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2;
          renderLanes2 = null !== newProps;
          current3 = null !== current3 && null !== current3.memoizedState;
          renderLanes2 && (newProps = workInProgress2.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
          renderLanes2 !== current3 && renderLanes2 && (workInProgress2.child.flags |= 8192);
          scheduleRetryEffect(workInProgress2, workInProgress2.updateQueue);
          bubbleProperties(workInProgress2);
          (workInProgress2.mode & ProfileMode) !== NoMode && renderLanes2 && (current3 = workInProgress2.child, null !== current3 && (workInProgress2.treeBaseDuration -= current3.treeBaseDuration));
          return null;
        case 4:
          return popHostContainer(workInProgress2), null === current3 && listenToAllSupportedEvents(
            workInProgress2.stateNode.containerInfo
          ), bubbleProperties(workInProgress2), null;
        case 10:
          return popProvider(workInProgress2.type, workInProgress2), bubbleProperties(workInProgress2), null;
        case 19:
          pop(suspenseStackCursor, workInProgress2);
          newProps = workInProgress2.memoizedState;
          if (null === newProps) return bubbleProperties(workInProgress2), null;
          type = 0 !== (workInProgress2.flags & 128);
          nextResource = newProps.rendering;
          if (null === nextResource)
            if (type) cutOffTailIfNeeded(newProps, false);
            else {
              if (workInProgressRootExitStatus !== RootInProgress || null !== current3 && 0 !== (current3.flags & 128))
                for (current3 = workInProgress2.child; null !== current3; ) {
                  nextResource = findFirstSuspended(current3);
                  if (null !== nextResource) {
                    workInProgress2.flags |= 128;
                    cutOffTailIfNeeded(newProps, false);
                    current3 = nextResource.updateQueue;
                    workInProgress2.updateQueue = current3;
                    scheduleRetryEffect(workInProgress2, current3);
                    workInProgress2.subtreeFlags = 0;
                    current3 = renderLanes2;
                    for (renderLanes2 = workInProgress2.child; null !== renderLanes2; )
                      resetWorkInProgress(renderLanes2, current3), renderLanes2 = renderLanes2.sibling;
                    push2(
                      suspenseStackCursor,
                      suspenseStackCursor.current & SubtreeSuspenseContextMask | ForceSuspenseFallback,
                      workInProgress2
                    );
                    isHydrating && pushTreeFork(workInProgress2, newProps.treeForkCount);
                    return workInProgress2.child;
                  }
                  current3 = current3.sibling;
                }
              null !== newProps.tail && now$12() > workInProgressRootRenderTargetTime && (workInProgress2.flags |= 128, type = true, cutOffTailIfNeeded(newProps, false), workInProgress2.lanes = 4194304);
            }
          else {
            if (!type)
              if (current3 = findFirstSuspended(nextResource), null !== current3) {
                if (workInProgress2.flags |= 128, type = true, current3 = current3.updateQueue, workInProgress2.updateQueue = current3, scheduleRetryEffect(workInProgress2, current3), cutOffTailIfNeeded(newProps, true), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating)
                  return bubbleProperties(workInProgress2), null;
              } else
                2 * now$12() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes2 && (workInProgress2.flags |= 128, type = true, cutOffTailIfNeeded(newProps, false), workInProgress2.lanes = 4194304);
            newProps.isBackwards ? (nextResource.sibling = workInProgress2.child, workInProgress2.child = nextResource) : (current3 = newProps.last, null !== current3 ? current3.sibling = nextResource : workInProgress2.child = nextResource, newProps.last = nextResource);
          }
          if (null !== newProps.tail)
            return current3 = newProps.tail, newProps.rendering = current3, newProps.tail = current3.sibling, newProps.renderingStartTime = now$12(), current3.sibling = null, renderLanes2 = suspenseStackCursor.current, renderLanes2 = type ? renderLanes2 & SubtreeSuspenseContextMask | ForceSuspenseFallback : renderLanes2 & SubtreeSuspenseContextMask, push2(suspenseStackCursor, renderLanes2, workInProgress2), isHydrating && pushTreeFork(workInProgress2, newProps.treeForkCount), current3;
          bubbleProperties(workInProgress2);
          return null;
        case 22:
        case 23:
          return popSuspenseHandler(workInProgress2), popHiddenContext(workInProgress2), newProps = null !== workInProgress2.memoizedState, null !== current3 ? null !== current3.memoizedState !== newProps && (workInProgress2.flags |= 8192) : newProps && (workInProgress2.flags |= 8192), newProps ? 0 !== (renderLanes2 & 536870912) && 0 === (workInProgress2.flags & 128) && (bubbleProperties(workInProgress2), workInProgress2.subtreeFlags & 6 && (workInProgress2.flags |= 8192)) : bubbleProperties(workInProgress2), renderLanes2 = workInProgress2.updateQueue, null !== renderLanes2 && scheduleRetryEffect(workInProgress2, renderLanes2.retryQueue), renderLanes2 = null, null !== current3 && null !== current3.memoizedState && null !== current3.memoizedState.cachePool && (renderLanes2 = current3.memoizedState.cachePool.pool), newProps = null, null !== workInProgress2.memoizedState && null !== workInProgress2.memoizedState.cachePool && (newProps = workInProgress2.memoizedState.cachePool.pool), newProps !== renderLanes2 && (workInProgress2.flags |= 2048), null !== current3 && pop(resumedCache, workInProgress2), null;
        case 24:
          return renderLanes2 = null, null !== current3 && (renderLanes2 = current3.memoizedState.cache), workInProgress2.memoizedState.cache !== renderLanes2 && (workInProgress2.flags |= 2048), popProvider(CacheContext, workInProgress2), bubbleProperties(workInProgress2), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function unwindWork(current3, workInProgress2) {
      popTreeContext(workInProgress2);
      switch (workInProgress2.tag) {
        case 1:
          return current3 = workInProgress2.flags, current3 & 65536 ? (workInProgress2.flags = current3 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 3:
          return popProvider(CacheContext, workInProgress2), popHostContainer(workInProgress2), current3 = workInProgress2.flags, 0 !== (current3 & 65536) && 0 === (current3 & 128) ? (workInProgress2.flags = current3 & -65537 | 128, workInProgress2) : null;
        case 26:
        case 27:
        case 5:
          return popHostContext(workInProgress2), null;
        case 31:
          if (null !== workInProgress2.memoizedState) {
            popSuspenseHandler(workInProgress2);
            if (null === workInProgress2.alternate)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            resetHydrationState();
          }
          current3 = workInProgress2.flags;
          return current3 & 65536 ? (workInProgress2.flags = current3 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 13:
          popSuspenseHandler(workInProgress2);
          current3 = workInProgress2.memoizedState;
          if (null !== current3 && null !== current3.dehydrated) {
            if (null === workInProgress2.alternate)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            resetHydrationState();
          }
          current3 = workInProgress2.flags;
          return current3 & 65536 ? (workInProgress2.flags = current3 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 19:
          return pop(suspenseStackCursor, workInProgress2), null;
        case 4:
          return popHostContainer(workInProgress2), null;
        case 10:
          return popProvider(workInProgress2.type, workInProgress2), null;
        case 22:
        case 23:
          return popSuspenseHandler(workInProgress2), popHiddenContext(workInProgress2), null !== current3 && pop(resumedCache, workInProgress2), current3 = workInProgress2.flags, current3 & 65536 ? (workInProgress2.flags = current3 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 24:
          return popProvider(CacheContext, workInProgress2), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function unwindInterruptedWork(current3, interruptedWork) {
      popTreeContext(interruptedWork);
      switch (interruptedWork.tag) {
        case 3:
          popProvider(CacheContext, interruptedWork);
          popHostContainer(interruptedWork);
          break;
        case 26:
        case 27:
        case 5:
          popHostContext(interruptedWork);
          break;
        case 4:
          popHostContainer(interruptedWork);
          break;
        case 31:
          null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
          break;
        case 13:
          popSuspenseHandler(interruptedWork);
          break;
        case 19:
          pop(suspenseStackCursor, interruptedWork);
          break;
        case 10:
          popProvider(interruptedWork.type, interruptedWork);
          break;
        case 22:
        case 23:
          popSuspenseHandler(interruptedWork);
          popHiddenContext(interruptedWork);
          null !== current3 && pop(resumedCache, interruptedWork);
          break;
        case 24:
          popProvider(CacheContext, interruptedWork);
      }
    }
    function shouldProfile(current3) {
      return (current3.mode & ProfileMode) !== NoMode;
    }
    function commitHookLayoutEffects(finishedWork, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookLayoutUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      ), recordEffectDuration()) : commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      );
    }
    function commitHookEffectListMount(flags, finishedWork) {
      try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
          var firstEffect = lastEffect.next;
          updateQueue = firstEffect;
          do {
            if ((updateQueue.tag & flags) === flags && (lastEffect = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = true), lastEffect = runWithFiberInDEV(
              finishedWork,
              callCreateInDEV,
              updateQueue
            ), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = false), void 0 !== lastEffect && "function" !== typeof lastEffect)) {
              var hookName = void 0;
              hookName = 0 !== (updateQueue.tag & Layout) ? "useLayoutEffect" : 0 !== (updateQueue.tag & Insertion) ? "useInsertionEffect" : "useEffect";
              var addendum = void 0;
              addendum = null === lastEffect ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" === typeof lastEffect.then ? "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + lastEffect;
              runWithFiberInDEV(
                finishedWork,
                function(n, a) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    n,
                    a
                  );
                },
                hookName,
                addendum
              );
            }
            updateQueue = updateQueue.next;
          } while (updateQueue !== firstEffect);
        }
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
      try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
          var firstEffect = lastEffect.next;
          updateQueue = firstEffect;
          do {
            if ((updateQueue.tag & flags) === flags) {
              var inst = updateQueue.inst, destroy = inst.destroy;
              void 0 !== destroy && (inst.destroy = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = true), lastEffect = finishedWork, runWithFiberInDEV(
                lastEffect,
                callDestroyInDEV,
                lastEffect,
                nearestMountedAncestor,
                destroy
              ), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = false));
            }
            updateQueue = updateQueue.next;
          } while (updateQueue !== firstEffect);
        }
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookPassiveUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      ), recordEffectDuration()) : commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      );
    }
    function commitClassCallbacks(finishedWork) {
      var updateQueue = finishedWork.updateQueue;
      if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (instance.props !== finishedWork.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          getComponentNameFromFiber(finishedWork) || "instance"
        ), instance.state !== finishedWork.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          getComponentNameFromFiber(finishedWork) || "instance"
        ));
        try {
          runWithFiberInDEV(
            finishedWork,
            commitCallbacks,
            updateQueue,
            instance
          );
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
    }
    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
      return instance.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    function commitClassSnapshot(finishedWork, current3) {
      var prevProps = current3.memoizedProps, prevState = current3.memoizedState;
      current3 = finishedWork.stateNode;
      finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (current3.props !== finishedWork.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        getComponentNameFromFiber(finishedWork) || "instance"
      ), current3.state !== finishedWork.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        getComponentNameFromFiber(finishedWork) || "instance"
      ));
      try {
        var resolvedPrevProps = resolveClassComponentProps(
          finishedWork.type,
          prevProps
        );
        var snapshot = runWithFiberInDEV(
          finishedWork,
          callGetSnapshotBeforeUpdates,
          current3,
          resolvedPrevProps,
          prevState
        );
        prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
        void 0 !== snapshot || prevProps.has(finishedWork.type) || (prevProps.add(finishedWork.type), runWithFiberInDEV(finishedWork, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            getComponentNameFromFiber(finishedWork)
          );
        }));
        current3.__reactInternalSnapshotBeforeUpdate = snapshot;
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function safelyCallComponentWillUnmount(current3, nearestMountedAncestor, instance) {
      instance.props = resolveClassComponentProps(
        current3.type,
        current3.memoizedProps
      );
      instance.state = current3.memoizedState;
      shouldProfile(current3) ? (startEffectTimer(), runWithFiberInDEV(
        current3,
        callComponentWillUnmountInDEV,
        current3,
        nearestMountedAncestor,
        instance
      ), recordEffectDuration()) : runWithFiberInDEV(
        current3,
        callComponentWillUnmountInDEV,
        current3,
        nearestMountedAncestor,
        instance
      );
    }
    function commitAttachRef(finishedWork) {
      var ref = finishedWork.ref;
      if (null !== ref) {
        switch (finishedWork.tag) {
          case 26:
          case 27:
          case 5:
            var instanceToUse = finishedWork.stateNode;
            break;
          case 30:
            instanceToUse = finishedWork.stateNode;
            break;
          default:
            instanceToUse = finishedWork.stateNode;
        }
        if ("function" === typeof ref)
          if (shouldProfile(finishedWork))
            try {
              startEffectTimer(), finishedWork.refCleanup = ref(instanceToUse);
            } finally {
              recordEffectDuration();
            }
          else finishedWork.refCleanup = ref(instanceToUse);
        else
          "string" === typeof ref ? console.error("String refs are no longer supported.") : ref.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            getComponentNameFromFiber(finishedWork)
          ), ref.current = instanceToUse;
      }
    }
    function safelyAttachRef(current3, nearestMountedAncestor) {
      try {
        runWithFiberInDEV(current3, commitAttachRef, current3);
      } catch (error) {
        captureCommitPhaseError(current3, nearestMountedAncestor, error);
      }
    }
    function safelyDetachRef(current3, nearestMountedAncestor) {
      var ref = current3.ref, refCleanup = current3.refCleanup;
      if (null !== ref)
        if ("function" === typeof refCleanup)
          try {
            if (shouldProfile(current3))
              try {
                startEffectTimer(), runWithFiberInDEV(current3, refCleanup);
              } finally {
                recordEffectDuration(current3);
              }
            else runWithFiberInDEV(current3, refCleanup);
          } catch (error) {
            captureCommitPhaseError(current3, nearestMountedAncestor, error);
          } finally {
            current3.refCleanup = null, current3 = current3.alternate, null != current3 && (current3.refCleanup = null);
          }
        else if ("function" === typeof ref)
          try {
            if (shouldProfile(current3))
              try {
                startEffectTimer(), runWithFiberInDEV(current3, ref, null);
              } finally {
                recordEffectDuration(current3);
              }
            else runWithFiberInDEV(current3, ref, null);
          } catch (error$7) {
            captureCommitPhaseError(current3, nearestMountedAncestor, error$7);
          }
        else ref.current = null;
    }
    function commitProfiler(finishedWork, current3, commitStartTime2, effectDuration) {
      var _finishedWork$memoize = finishedWork.memoizedProps, id2 = _finishedWork$memoize.id, onCommit = _finishedWork$memoize.onCommit;
      _finishedWork$memoize = _finishedWork$memoize.onRender;
      current3 = null === current3 ? "mount" : "update";
      currentUpdateIsNested && (current3 = "nested-update");
      "function" === typeof _finishedWork$memoize && _finishedWork$memoize(
        id2,
        current3,
        finishedWork.actualDuration,
        finishedWork.treeBaseDuration,
        finishedWork.actualStartTime,
        commitStartTime2
      );
      "function" === typeof onCommit && onCommit(id2, current3, effectDuration, commitStartTime2);
    }
    function commitProfilerPostCommitImpl(finishedWork, current3, commitStartTime2, passiveEffectDuration) {
      var _finishedWork$memoize2 = finishedWork.memoizedProps;
      finishedWork = _finishedWork$memoize2.id;
      _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
      current3 = null === current3 ? "mount" : "update";
      currentUpdateIsNested && (current3 = "nested-update");
      "function" === typeof _finishedWork$memoize2 && _finishedWork$memoize2(
        finishedWork,
        current3,
        passiveEffectDuration,
        commitStartTime2
      );
    }
    function commitHostMount(finishedWork) {
      var type = finishedWork.type, props2 = finishedWork.memoizedProps, instance = finishedWork.stateNode;
      try {
        runWithFiberInDEV(
          finishedWork,
          commitMount,
          instance,
          type,
          props2,
          finishedWork
        );
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
      try {
        runWithFiberInDEV(
          finishedWork,
          commitUpdate,
          finishedWork.stateNode,
          finishedWork.type,
          oldProps,
          newProps,
          finishedWork
        );
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function isHostParent(fiber) {
      return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
      a: for (; ; ) {
        for (; null === fiber.sibling; ) {
          if (null === fiber.return || isHostParent(fiber.return)) return null;
          fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for (fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag; ) {
          if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
          if (fiber.flags & 2) continue a;
          if (null === fiber.child || 4 === fiber.tag) continue a;
          else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
      }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before2, parent) {
      var tag2 = node.tag;
      if (5 === tag2 || 6 === tag2)
        node = node.stateNode, before2 ? (warnForReactChildrenConflict(parent), (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before2)) : (warnForReactChildrenConflict(parent), before2 = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before2.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before2.onclick || (before2.onclick = noop$12));
      else if (4 !== tag2 && (27 === tag2 && isSingletonScope(node.type) && (parent = node.stateNode, before2 = null), node = node.child, null !== node))
        for (insertOrAppendPlacementNodeIntoContainer(node, before2, parent), node = node.sibling; null !== node; )
          insertOrAppendPlacementNodeIntoContainer(node, before2, parent), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before2, parent) {
      var tag2 = node.tag;
      if (5 === tag2 || 6 === tag2)
        node = node.stateNode, before2 ? parent.insertBefore(node, before2) : parent.appendChild(node);
      else if (4 !== tag2 && (27 === tag2 && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node))
        for (insertOrAppendPlacementNode(node, before2, parent), node = node.sibling; null !== node; )
          insertOrAppendPlacementNode(node, before2, parent), node = node.sibling;
    }
    function commitPlacement(finishedWork) {
      for (var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber; ) {
        if (isHostParent(parentFiber)) {
          hostParentFiber = parentFiber;
          break;
        }
        parentFiber = parentFiber.return;
      }
      if (null == hostParentFiber)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (hostParentFiber.tag) {
        case 27:
          hostParentFiber = hostParentFiber.stateNode;
          parentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNode(
            finishedWork,
            parentFiber,
            hostParentFiber
          );
          break;
        case 5:
          parentFiber = hostParentFiber.stateNode;
          hostParentFiber.flags & 32 && (resetTextContent(parentFiber), hostParentFiber.flags &= -33);
          hostParentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNode(
            finishedWork,
            hostParentFiber,
            parentFiber
          );
          break;
        case 3:
        case 4:
          hostParentFiber = hostParentFiber.stateNode.containerInfo;
          parentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNodeIntoContainer(
            finishedWork,
            parentFiber,
            hostParentFiber
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function commitHostSingletonAcquisition(finishedWork) {
      var singleton = finishedWork.stateNode, props2 = finishedWork.memoizedProps;
      try {
        runWithFiberInDEV(
          finishedWork,
          acquireSingletonInstance,
          finishedWork.type,
          props2,
          singleton,
          finishedWork
        );
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function isHydratingParent(current3, finishedWork) {
      return 31 === finishedWork.tag ? (finishedWork = finishedWork.memoizedState, null !== current3.memoizedState && null === finishedWork) : 13 === finishedWork.tag ? (current3 = current3.memoizedState, finishedWork = finishedWork.memoizedState, null !== current3 && null !== current3.dehydrated && (null === finishedWork || null === finishedWork.dehydrated)) : 3 === finishedWork.tag ? current3.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256) : false;
    }
    function commitBeforeMutationEffects(root3, firstChild) {
      root3 = root3.containerInfo;
      eventsEnabled = _enabled;
      root3 = getActiveElementDeep(root3);
      if (hasSelectionCapabilities(root3)) {
        if ("selectionStart" in root3)
          var JSCompiler_temp = {
            start: root3.selectionStart,
            end: root3.selectionEnd
          };
        else
          a: {
            JSCompiler_temp = (JSCompiler_temp = root3.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection2 = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection2 && 0 !== selection2.rangeCount) {
              JSCompiler_temp = selection2.anchorNode;
              var anchorOffset = selection2.anchorOffset, focusNode = selection2.focusNode;
              selection2 = selection2.focusOffset;
              try {
                JSCompiler_temp.nodeType, focusNode.nodeType;
              } catch (e$2) {
                JSCompiler_temp = null;
                break a;
              }
              var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root3, parentNode = null;
              b: for (; ; ) {
                for (var next; ; ) {
                  node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                  node !== focusNode || 0 !== selection2 && 3 !== node.nodeType || (end = length + selection2);
                  3 === node.nodeType && (length += node.nodeValue.length);
                  if (null === (next = node.firstChild)) break;
                  parentNode = node;
                  node = next;
                }
                for (; ; ) {
                  if (node === root3) break b;
                  parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                  parentNode === focusNode && ++indexWithinFocus === selection2 && (end = length);
                  if (null !== (next = node.nextSibling)) break;
                  node = parentNode;
                  parentNode = node.parentNode;
                }
                node = next;
              }
              JSCompiler_temp = -1 === start || -1 === end ? null : { start, end };
            } else JSCompiler_temp = null;
          }
        JSCompiler_temp = JSCompiler_temp || { start: 0, end: 0 };
      } else JSCompiler_temp = null;
      selectionInformation = {
        focusedElem: root3,
        selectionRange: JSCompiler_temp
      };
      _enabled = false;
      for (nextEffect = firstChild; null !== nextEffect; )
        if (firstChild = nextEffect, root3 = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root3)
          root3.return = firstChild, nextEffect = root3;
        else
          for (; null !== nextEffect; ) {
            root3 = firstChild = nextEffect;
            JSCompiler_temp = root3.alternate;
            anchorOffset = root3.flags;
            switch (root3.tag) {
              case 0:
                if (0 !== (anchorOffset & 4) && (root3 = root3.updateQueue, root3 = null !== root3 ? root3.events : null, null !== root3))
                  for (JSCompiler_temp = 0; JSCompiler_temp < root3.length; JSCompiler_temp++)
                    anchorOffset = root3[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
              case 11:
              case 15:
                break;
              case 1:
                0 !== (anchorOffset & 1024) && null !== JSCompiler_temp && commitClassSnapshot(root3, JSCompiler_temp);
                break;
              case 3:
                if (0 !== (anchorOffset & 1024)) {
                  if (root3 = root3.stateNode.containerInfo, JSCompiler_temp = root3.nodeType, 9 === JSCompiler_temp)
                    clearContainerSparingly(root3);
                  else if (1 === JSCompiler_temp)
                    switch (root3.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        clearContainerSparingly(root3);
                        break;
                      default:
                        root3.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if (0 !== (anchorOffset & 1024))
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            root3 = firstChild.sibling;
            if (null !== root3) {
              root3.return = firstChild.return;
              nextEffect = root3;
              break;
            }
            nextEffect = firstChild.return;
          }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current3, finishedWork) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          flags & 4 && commitHookLayoutEffects(finishedWork, Layout | HasEffect);
          break;
        case 1:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          if (flags & 4)
            if (finishedRoot = finishedWork.stateNode, null === current3)
              finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ), finishedRoot.state !== finishedWork.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              )), shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(
                finishedWork,
                callComponentDidMountInDEV,
                finishedWork,
                finishedRoot
              ), recordEffectDuration()) : runWithFiberInDEV(
                finishedWork,
                callComponentDidMountInDEV,
                finishedWork,
                finishedRoot
              );
            else {
              var prevProps = resolveClassComponentProps(
                finishedWork.type,
                current3.memoizedProps
              );
              current3 = current3.memoizedState;
              finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ), finishedRoot.state !== finishedWork.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ));
              shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(
                finishedWork,
                callComponentDidUpdateInDEV,
                finishedWork,
                finishedRoot,
                prevProps,
                current3,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              ), recordEffectDuration()) : runWithFiberInDEV(
                finishedWork,
                callComponentDidUpdateInDEV,
                finishedWork,
                finishedRoot,
                prevProps,
                current3,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              );
            }
          flags & 64 && commitClassCallbacks(finishedWork);
          flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 3:
          current3 = pushNestedEffectDurations();
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
            prevProps = null;
            if (null !== finishedWork.child)
              switch (finishedWork.child.tag) {
                case 27:
                case 5:
                  prevProps = finishedWork.child.stateNode;
                  break;
                case 1:
                  prevProps = finishedWork.child.stateNode;
              }
            try {
              runWithFiberInDEV(
                finishedWork,
                commitCallbacks,
                flags,
                prevProps
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          }
          finishedRoot.effectDuration += popNestedEffectDurations(current3);
          break;
        case 27:
          null === current3 && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          if (null === current3) {
            if (flags & 4) commitHostMount(finishedWork);
            else if (flags & 64) {
              finishedRoot = finishedWork.type;
              current3 = finishedWork.memoizedProps;
              prevProps = finishedWork.stateNode;
              try {
                runWithFiberInDEV(
                  finishedWork,
                  commitHydratedInstance,
                  prevProps,
                  finishedRoot,
                  current3,
                  finishedWork
                );
              } catch (error) {
                captureCommitPhaseError(
                  finishedWork,
                  finishedWork.return,
                  error
                );
              }
            }
          }
          flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          if (flags & 4) {
            flags = pushNestedEffectDurations();
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            finishedRoot = finishedWork.stateNode;
            finishedRoot.effectDuration += bubbleNestedEffectDurations(flags);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfiler,
                finishedWork,
                current3,
                commitStartTime,
                finishedRoot.effectDuration
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          break;
        case 31:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 13:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (flags = retryDehydratedSuspenseBoundary.bind(
            null,
            finishedWork
          ), registerSuspenseInstanceRetry(finishedRoot, flags))));
          break;
        case 22:
          flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
          if (!flags) {
            current3 = null !== current3 && null !== current3.memoizedState || offscreenSubtreeWasHidden;
            prevProps = offscreenSubtreeIsHidden;
            var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = flags;
            (offscreenSubtreeWasHidden = current3) && !prevOffscreenSubtreeWasHidden ? (recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              0 !== (finishedWork.subtreeFlags & 8772)
            ), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(
              finishedWork,
              componentEffectStartTime,
              componentEffectEndTime
            )) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            offscreenSubtreeIsHidden = prevProps;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
          }
          break;
        case 30:
          break;
        default:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      ), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(
        finishedWork.return.alternate,
        finishedWork.return
      ) || logComponentTrigger(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        "Mount"
      )));
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function detachFiberAfterEffects(fiber) {
      var alternate = fiber.alternate;
      null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
      fiber.child = null;
      fiber.deletions = null;
      fiber.sibling = null;
      5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
      fiber.stateNode = null;
      fiber._debugOwner = null;
      fiber.return = null;
      fiber.dependencies = null;
      fiber.memoizedProps = null;
      fiber.memoizedState = null;
      fiber.pendingProps = null;
      fiber.stateNode = null;
      fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
      for (parent = parent.child; null !== parent; )
        commitDeletionEffectsOnFiber(
          finishedRoot,
          nearestMountedAncestor,
          parent
        ), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
      if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
        try {
          injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %o",
            err
          ));
        }
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
      switch (deletedFiber.tag) {
        case 26:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (finishedRoot = deletedFiber.stateNode, finishedRoot.parentNode.removeChild(finishedRoot));
          break;
        case 27:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
          var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
          isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = false);
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          runWithFiberInDEV(
            deletedFiber,
            releaseSingletonInstance,
            deletedFiber.stateNode
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          break;
        case 5:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
          prevHostParent = hostParent;
          prevHostParentIsContainer = hostParentIsContainer;
          hostParent = null;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          if (null !== hostParent)
            if (hostParentIsContainer)
              try {
                runWithFiberInDEV(
                  deletedFiber,
                  removeChildFromContainer,
                  hostParent,
                  deletedFiber.stateNode
                );
              } catch (error) {
                captureCommitPhaseError(
                  deletedFiber,
                  nearestMountedAncestor,
                  error
                );
              }
            else
              try {
                runWithFiberInDEV(
                  deletedFiber,
                  removeChild,
                  hostParent,
                  deletedFiber.stateNode
                );
              } catch (error) {
                captureCommitPhaseError(
                  deletedFiber,
                  nearestMountedAncestor,
                  error
                );
              }
          break;
        case 18:
          null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(
            9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot,
            deletedFiber.stateNode
          ), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
          break;
        case 4:
          prevHostParent = hostParent;
          prevHostParentIsContainer = hostParentIsContainer;
          hostParent = deletedFiber.stateNode.containerInfo;
          hostParentIsContainer = true;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookEffectListUnmount(
            Insertion,
            deletedFiber,
            nearestMountedAncestor
          );
          offscreenSubtreeWasHidden || commitHookLayoutUnmountEffects(
            deletedFiber,
            nearestMountedAncestor,
            Layout
          );
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 1:
          offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(
            deletedFiber,
            nearestMountedAncestor,
            prevHostParent
          ));
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 21:
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 22:
          offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          offscreenSubtreeWasHidden = prevHostParent;
          break;
        default:
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
      }
      (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        deletedFiber,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
      if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
          runWithFiberInDEV(
            finishedWork,
            commitHydratedActivityInstance,
            finishedRoot
          );
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
      if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot))))
        try {
          runWithFiberInDEV(
            finishedWork,
            commitHydratedSuspenseInstance,
            finishedRoot
          );
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
      switch (finishedWork.tag) {
        case 31:
        case 13:
        case 19:
          var retryCache = finishedWork.stateNode;
          null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
          return retryCache;
        case 22:
          return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + finishedWork.tag + "). This is a bug in React."
          );
      }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
      var retryCache = getRetryCache(finishedWork);
      wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
          retryCache.add(wakeable);
          if (isDevToolsPresent)
            if (null !== inProgressLanes && null !== inProgressRoot)
              restorePendingUpdaters(inProgressRoot, inProgressLanes);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
          wakeable.then(retry, retry);
        }
      });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
      var deletions = parentFiber.deletions;
      if (null !== deletions)
        for (var i2 = 0; i2 < deletions.length; i2++) {
          var root3 = root$jscomp$0, returnFiber = parentFiber, deletedFiber = deletions[i2], prevEffectStart = pushComponentEffectStart(), parent = returnFiber;
          a: for (; null !== parent; ) {
            switch (parent.tag) {
              case 27:
                if (isSingletonScope(parent.type)) {
                  hostParent = parent.stateNode;
                  hostParentIsContainer = false;
                  break a;
                }
                break;
              case 5:
                hostParent = parent.stateNode;
                hostParentIsContainer = false;
                break a;
              case 3:
              case 4:
                hostParent = parent.stateNode.containerInfo;
                hostParentIsContainer = true;
                break a;
            }
            parent = parent.return;
          }
          if (null === hostParent)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          commitDeletionEffectsOnFiber(root3, returnFiber, deletedFiber);
          hostParent = null;
          hostParentIsContainer = false;
          (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
            deletedFiber,
            componentEffectStartTime,
            componentEffectEndTime,
            "Unmount"
          );
          popComponentEffectStart(prevEffectStart);
          root3 = deletedFiber;
          returnFiber = root3.alternate;
          null !== returnFiber && (returnFiber.return = null);
          root3.return = null;
        }
      if (parentFiber.subtreeFlags & 13886)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root3) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), current3 = finishedWork.alternate, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 4 && (commitHookEffectListUnmount(
            Insertion | HasEffect,
            finishedWork,
            finishedWork.return
          ), commitHookEffectListMount(Insertion | HasEffect, finishedWork), commitHookLayoutUnmountEffects(
            finishedWork,
            finishedWork.return,
            Layout | HasEffect
          ));
          break;
        case 1:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 512 && (offscreenSubtreeWasHidden || null === current3 || safelyDetachRef(current3, current3.return));
          if (flags & 64 && offscreenSubtreeIsHidden && (flags = finishedWork.updateQueue, null !== flags && (current3 = flags.callbacks, null !== current3))) {
            var existingHiddenCallbacks = flags.shared.hiddenCallbacks;
            flags.shared.hiddenCallbacks = null === existingHiddenCallbacks ? current3 : existingHiddenCallbacks.concat(current3);
          }
          break;
        case 26:
          existingHiddenCallbacks = currentHoistableRoot;
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 512 && (offscreenSubtreeWasHidden || null === current3 || safelyDetachRef(current3, current3.return));
          if (flags & 4) {
            var currentResource = null !== current3 ? current3.memoizedState : null;
            flags = finishedWork.memoizedState;
            if (null === current3)
              if (null === flags)
                if (null === finishedWork.stateNode) {
                  a: {
                    flags = finishedWork.type;
                    current3 = finishedWork.memoizedProps;
                    existingHiddenCallbacks = existingHiddenCallbacks.ownerDocument || existingHiddenCallbacks;
                    b: switch (flags) {
                      case "title":
                        currentResource = existingHiddenCallbacks.getElementsByTagName(
                          "title"
                        )[0];
                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || currentResource.namespaceURI === SVG_NAMESPACE || currentResource.hasAttribute("itemprop"))
                          currentResource = existingHiddenCallbacks.createElement(flags), existingHiddenCallbacks.head.insertBefore(
                            currentResource,
                            existingHiddenCallbacks.querySelector(
                              "head > title"
                            )
                          );
                        setInitialProperties(currentResource, flags, current3);
                        currentResource[internalInstanceKey] = finishedWork;
                        markNodeAsHoistable(currentResource);
                        flags = currentResource;
                        break a;
                      case "link":
                        var maybeNodes = getHydratableHoistableCache(
                          "link",
                          "href",
                          existingHiddenCallbacks
                        ).get(flags + (current3.href || ""));
                        if (maybeNodes) {
                          for (var i2 = 0; i2 < maybeNodes.length; i2++)
                            if (currentResource = maybeNodes[i2], currentResource.getAttribute("href") === (null == current3.href || "" === current3.href ? null : current3.href) && currentResource.getAttribute("rel") === (null == current3.rel ? null : current3.rel) && currentResource.getAttribute("title") === (null == current3.title ? null : current3.title) && currentResource.getAttribute("crossorigin") === (null == current3.crossOrigin ? null : current3.crossOrigin)) {
                              maybeNodes.splice(i2, 1);
                              break b;
                            }
                        }
                        currentResource = existingHiddenCallbacks.createElement(flags);
                        setInitialProperties(currentResource, flags, current3);
                        existingHiddenCallbacks.head.appendChild(
                          currentResource
                        );
                        break;
                      case "meta":
                        if (maybeNodes = getHydratableHoistableCache(
                          "meta",
                          "content",
                          existingHiddenCallbacks
                        ).get(flags + (current3.content || ""))) {
                          for (i2 = 0; i2 < maybeNodes.length; i2++)
                            if (currentResource = maybeNodes[i2], checkAttributeStringCoercion(
                              current3.content,
                              "content"
                            ), currentResource.getAttribute("content") === (null == current3.content ? null : "" + current3.content) && currentResource.getAttribute("name") === (null == current3.name ? null : current3.name) && currentResource.getAttribute("property") === (null == current3.property ? null : current3.property) && currentResource.getAttribute("http-equiv") === (null == current3.httpEquiv ? null : current3.httpEquiv) && currentResource.getAttribute("charset") === (null == current3.charSet ? null : current3.charSet)) {
                              maybeNodes.splice(i2, 1);
                              break b;
                            }
                        }
                        currentResource = existingHiddenCallbacks.createElement(flags);
                        setInitialProperties(currentResource, flags, current3);
                        existingHiddenCallbacks.head.appendChild(
                          currentResource
                        );
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + flags + '". This is a bug in React.'
                        );
                    }
                    currentResource[internalInstanceKey] = finishedWork;
                    markNodeAsHoistable(currentResource);
                    flags = currentResource;
                  }
                  finishedWork.stateNode = flags;
                } else
                  mountHoistable(
                    existingHiddenCallbacks,
                    finishedWork.type,
                    finishedWork.stateNode
                  );
              else
                finishedWork.stateNode = acquireResource(
                  existingHiddenCallbacks,
                  flags,
                  finishedWork.memoizedProps
                );
            else
              currentResource !== flags ? (null === currentResource ? null !== current3.stateNode && (current3 = current3.stateNode, current3.parentNode.removeChild(current3)) : currentResource.count--, null === flags ? mountHoistable(
                existingHiddenCallbacks,
                finishedWork.type,
                finishedWork.stateNode
              ) : acquireResource(
                existingHiddenCallbacks,
                flags,
                finishedWork.memoizedProps
              )) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(
                finishedWork,
                finishedWork.memoizedProps,
                current3.memoizedProps
              );
          }
          break;
        case 27:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 512 && (offscreenSubtreeWasHidden || null === current3 || safelyDetachRef(current3, current3.return));
          null !== current3 && flags & 4 && commitHostUpdate(
            finishedWork,
            finishedWork.memoizedProps,
            current3.memoizedProps
          );
          break;
        case 5:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 512 && (offscreenSubtreeWasHidden || null === current3 || safelyDetachRef(current3, current3.return));
          if (finishedWork.flags & 32) {
            existingHiddenCallbacks = finishedWork.stateNode;
            try {
              runWithFiberInDEV(
                finishedWork,
                resetTextContent,
                existingHiddenCallbacks
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          }
          flags & 4 && null != finishedWork.stateNode && (existingHiddenCallbacks = finishedWork.memoizedProps, commitHostUpdate(
            finishedWork,
            existingHiddenCallbacks,
            null !== current3 ? current3.memoizedProps : existingHiddenCallbacks
          ));
          flags & 1024 && (needsFormReset = true, "form" !== finishedWork.type && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          if (flags & 4) {
            if (null === finishedWork.stateNode)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            flags = finishedWork.memoizedProps;
            current3 = null !== current3 ? current3.memoizedProps : flags;
            existingHiddenCallbacks = finishedWork.stateNode;
            try {
              runWithFiberInDEV(
                finishedWork,
                commitTextUpdate,
                existingHiddenCallbacks,
                current3,
                flags
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          }
          break;
        case 3:
          existingHiddenCallbacks = pushNestedEffectDurations();
          tagCaches = null;
          currentResource = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(root3.containerInfo);
          recursivelyTraverseMutationEffects(root3, finishedWork);
          currentHoistableRoot = currentResource;
          commitReconciliationEffects(finishedWork);
          if (flags & 4 && null !== current3 && current3.memoizedState.isDehydrated)
            try {
              runWithFiberInDEV(
                finishedWork,
                commitHydratedContainer,
                root3.containerInfo
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          needsFormReset && (needsFormReset = false, recursivelyResetForms(finishedWork));
          root3.effectDuration += popNestedEffectDurations(
            existingHiddenCallbacks
          );
          break;
        case 4:
          flags = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(
            finishedWork.stateNode.containerInfo
          );
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          currentHoistableRoot = flags;
          break;
        case 12:
          flags = pushNestedEffectDurations();
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          finishedWork.stateNode.effectDuration += bubbleNestedEffectDurations(flags);
          break;
        case 31:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
          break;
        case 13:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current3 && null !== current3.memoizedState) && (globalMostRecentFallbackTime = now$12());
          flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
          break;
        case 22:
          existingHiddenCallbacks = null !== finishedWork.memoizedState;
          var wasHidden = null !== current3 && null !== current3.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || existingHiddenCallbacks;
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
          recursivelyTraverseMutationEffects(root3, finishedWork);
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
          wasHidden && !existingHiddenCallbacks && !prevOffscreenSubtreeIsHidden && !prevOffscreenSubtreeWasHidden && (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(
            finishedWork,
            componentEffectStartTime,
            componentEffectEndTime
          );
          commitReconciliationEffects(finishedWork);
          if (flags & 8192)
            a: for (root3 = finishedWork.stateNode, root3._visibility = existingHiddenCallbacks ? root3._visibility & ~OffscreenVisible : root3._visibility | OffscreenVisible, !existingHiddenCallbacks || null === current3 || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || (recursivelyTraverseDisappearLayoutEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
              finishedWork,
              componentEffectStartTime,
              componentEffectEndTime,
              "Disconnect"
            )), current3 = null, root3 = finishedWork; ; ) {
              if (5 === root3.tag || 26 === root3.tag) {
                if (null === current3) {
                  wasHidden = current3 = root3;
                  try {
                    currentResource = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(
                      wasHidden,
                      hideInstance,
                      currentResource
                    ) : runWithFiberInDEV(
                      wasHidden,
                      unhideInstance,
                      wasHidden.stateNode,
                      wasHidden.memoizedProps
                    );
                  } catch (error) {
                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                  }
                }
              } else if (6 === root3.tag) {
                if (null === current3) {
                  wasHidden = root3;
                  try {
                    maybeNodes = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(
                      wasHidden,
                      hideTextInstance,
                      maybeNodes
                    ) : runWithFiberInDEV(
                      wasHidden,
                      unhideTextInstance,
                      maybeNodes,
                      wasHidden.memoizedProps
                    );
                  } catch (error) {
                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                  }
                }
              } else if (18 === root3.tag) {
                if (null === current3) {
                  wasHidden = root3;
                  try {
                    i2 = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(
                      wasHidden,
                      hideDehydratedBoundary,
                      i2
                    ) : runWithFiberInDEV(
                      wasHidden,
                      unhideDehydratedBoundary,
                      wasHidden.stateNode
                    );
                  } catch (error) {
                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                  }
                }
              } else if ((22 !== root3.tag && 23 !== root3.tag || null === root3.memoizedState || root3 === finishedWork) && null !== root3.child) {
                root3.child.return = root3;
                root3 = root3.child;
                continue;
              }
              if (root3 === finishedWork) break a;
              for (; null === root3.sibling; ) {
                if (null === root3.return || root3.return === finishedWork)
                  break a;
                current3 === root3 && (current3 = null);
                root3 = root3.return;
              }
              current3 === root3 && (current3 = null);
              root3.sibling.return = root3.return;
              root3 = root3.sibling;
            }
          flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current3 = flags.retryQueue, null !== current3 && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current3))));
          break;
        case 19:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          recursivelyTraverseMutationEffects(root3, finishedWork), commitReconciliationEffects(finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      ), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(
        finishedWork.return.alternate,
        finishedWork.return
      ) || logComponentTrigger(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        "Mount"
      )));
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitReconciliationEffects(finishedWork) {
      var flags = finishedWork.flags;
      if (flags & 2) {
        try {
          runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
      }
      flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
      if (parentFiber.subtreeFlags & 1024)
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var fiber = parentFiber;
          recursivelyResetForms(fiber);
          5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
          parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseLayoutEffects(root3, parentFiber) {
      if (parentFiber.subtreeFlags & 8772)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitLayoutEffectOnFiber(root3, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function disappearLayoutEffects(finishedWork) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookLayoutUnmountEffects(
            finishedWork,
            finishedWork.return,
            Layout
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 1:
          safelyDetachRef(finishedWork, finishedWork.return);
          var instance = finishedWork.stateNode;
          "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(
            finishedWork,
            finishedWork.return,
            instance
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 27:
          runWithFiberInDEV(
            finishedWork,
            releaseSingletonInstance,
            finishedWork.stateNode
          );
        case 26:
        case 5:
          safelyDetachRef(finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 30:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        default:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        disappearLayoutEffects(parentFiber), parentFiber = parentFiber.sibling;
    }
    function reappearLayoutEffects(finishedRoot, current3, finishedWork, includeWorkInProgressEffects) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          commitHookLayoutEffects(finishedWork, Layout);
          break;
        case 1:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          current3 = finishedWork.stateNode;
          "function" === typeof current3.componentDidMount && runWithFiberInDEV(
            finishedWork,
            callComponentDidMountInDEV,
            finishedWork,
            current3
          );
          current3 = finishedWork.updateQueue;
          if (null !== current3) {
            finishedRoot = finishedWork.stateNode;
            try {
              runWithFiberInDEV(
                finishedWork,
                commitHiddenCallbacks,
                current3,
                finishedRoot
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          }
          includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 27:
          commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && null === current3 && flags & 4 && commitHostMount(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          if (includeWorkInProgressEffects && flags & 4) {
            flags = pushNestedEffectDurations();
            recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              includeWorkInProgressEffects
            );
            includeWorkInProgressEffects = finishedWork.stateNode;
            includeWorkInProgressEffects.effectDuration += bubbleNestedEffectDurations(flags);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfiler,
                finishedWork,
                current3,
                commitStartTime,
                includeWorkInProgressEffects.effectDuration
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          } else
            recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              includeWorkInProgressEffects
            );
          break;
        case 31:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 13:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 30:
          break;
        default:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot, parentFiber, includeWorkInProgressEffects) {
      includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        reappearLayoutEffects(
          finishedRoot,
          parentFiber.alternate,
          parentFiber,
          includeWorkInProgressEffects
        ), parentFiber = parentFiber.sibling;
    }
    function commitOffscreenPassiveMountEffects(current3, finishedWork) {
      var previousCache = null;
      null !== current3 && null !== current3.memoizedState && null !== current3.memoizedState.cachePool && (previousCache = current3.memoizedState.cachePool.pool);
      current3 = null;
      null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current3 = finishedWork.memoizedState.cachePool.pool);
      current3 !== previousCache && (null != current3 && retainCache(current3), null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current3, finishedWork) {
      current3 = null;
      null !== finishedWork.alternate && (current3 = finishedWork.alternate.memoizedState.cache);
      finishedWork = finishedWork.memoizedState.cache;
      finishedWork !== current3 && (retainCache(finishedWork), null != current3 && releaseCache(current3));
    }
    function recursivelyTraversePassiveMountEffects(root3, parentFiber, committedLanes, committedTransitions, endTime) {
      if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child))
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var nextSibling = parentFiber.sibling;
          commitPassiveMountOnFiber(
            root3,
            parentFiber,
            committedLanes,
            committedTransitions,
            null !== nextSibling ? nextSibling.actualStartTime : endTime
          );
          parentFiber = nextSibling;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            inHydratedSubtree,
            committedLanes
          );
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          flags & 2048 && commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
          break;
        case 1:
          (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && (0 !== (finishedWork.flags & 128) ? logComponentErrored(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            []
          ) : 0 !== (finishedWork.flags & 1) && logComponentRender(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            inHydratedSubtree,
            committedLanes
          ));
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          break;
        case 3:
          var prevProfilerEffectDuration = pushNestedEffectDurations(), wasInHydratedSubtree = inHydratedSubtree;
          inHydratedSubtree = null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256);
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          inHydratedSubtree = wasInHydratedSubtree;
          flags & 2048 && (committedLanes = null, null !== finishedWork.alternate && (committedLanes = finishedWork.alternate.memoizedState.cache), committedTransitions = finishedWork.memoizedState.cache, committedTransitions !== committedLanes && (retainCache(committedTransitions), null != committedLanes && releaseCache(committedLanes)));
          finishedRoot.passiveEffectDuration += popNestedEffectDurations(
            prevProfilerEffectDuration
          );
          break;
        case 12:
          if (flags & 2048) {
            flags = pushNestedEffectDurations();
            recursivelyTraversePassiveMountEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions,
              endTime
            );
            finishedRoot = finishedWork.stateNode;
            finishedRoot.passiveEffectDuration += bubbleNestedEffectDurations(flags);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfilerPostCommitImpl,
                finishedWork,
                finishedWork.alternate,
                commitStartTime,
                finishedRoot.passiveEffectDuration
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          } else
            recursivelyTraversePassiveMountEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions,
              endTime
            );
          break;
        case 31:
          flags = inHydratedSubtree;
          prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
          wasInHydratedSubtree = finishedWork.memoizedState;
          null !== prevProfilerEffectDuration && null === wasInHydratedSubtree ? (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = false, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            prevProfilerEffectDuration
          )) : inHydratedSubtree = true) : inHydratedSubtree = false;
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          inHydratedSubtree = flags;
          break;
        case 13:
          flags = inHydratedSubtree;
          prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
          wasInHydratedSubtree = finishedWork.memoizedState;
          null === prevProfilerEffectDuration || null === prevProfilerEffectDuration.dehydrated || null !== wasInHydratedSubtree && null !== wasInHydratedSubtree.dehydrated ? inHydratedSubtree = false : (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = false, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            prevProfilerEffectDuration
          )) : inHydratedSubtree = true);
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          inHydratedSubtree = flags;
          break;
        case 23:
          break;
        case 22:
          wasInHydratedSubtree = finishedWork.stateNode;
          prevProfilerEffectDuration = finishedWork.alternate;
          null !== finishedWork.memoizedState ? wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          ) : wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          ) : (wasInHydratedSubtree._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            0 !== (finishedWork.subtreeFlags & 10256) || 0 !== finishedWork.actualDuration && (null === finishedWork.alternate || finishedWork.alternate.child !== finishedWork.child),
            endTime
          ), (finishedWork.mode & ProfileMode) === NoMode || inHydratedSubtree || (finishedRoot = finishedWork.actualStartTime, 0 <= finishedRoot && 0.05 < endTime - finishedRoot && logComponentReappeared(finishedWork, finishedRoot, endTime), 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(
            finishedWork,
            componentEffectStartTime,
            componentEffectEndTime
          )));
          flags & 2048 && commitOffscreenPassiveMountEffects(
            prevProfilerEffectDuration,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
      }
      if ((finishedWork.mode & ProfileMode) !== NoMode) {
        if (finishedRoot = !inHydratedSubtree && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate)
          committedLanes = finishedWork.actualStartTime, 0 <= committedLanes && 0.05 < endTime - committedLanes && logComponentTrigger(
            finishedWork,
            committedLanes,
            endTime,
            "Mount"
          );
        0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
          finishedWork,
          componentEffectStartTime,
          componentEffectEndTime,
          componentEffectDuration,
          componentEffectErrors
        ), finishedRoot && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
          finishedWork,
          componentEffectStartTime,
          componentEffectEndTime,
          "Mount"
        ));
      }
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
      alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
      includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child));
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var nextSibling = parentFiber.sibling;
        reconnectPassiveEffects(
          finishedRoot,
          parentFiber,
          committedLanes,
          committedTransitions,
          includeWorkInProgressEffects,
          null !== nextSibling ? nextSibling.actualStartTime : endTime
        );
        parentFiber = nextSibling;
      }
    }
    function reconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality;
      includeWorkInProgressEffects && (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(
        finishedWork,
        finishedWork.actualStartTime,
        endTime,
        inHydratedSubtree,
        committedLanes
      );
      var flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          );
          commitHookPassiveMountEffects(finishedWork, Passive);
          break;
        case 23:
          break;
        case 22:
          var _instance2 = finishedWork.stateNode;
          null !== finishedWork.memoizedState ? _instance2._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          ) : (_instance2._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          ));
          includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(
            finishedWork.alternate,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          );
          includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          );
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
      alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, endTime$jscomp$0) {
      if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child))
        for (var child = parentFiber.child; null !== child; ) {
          parentFiber = child.sibling;
          var finishedRoot = finishedRoot$jscomp$0, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, endTime = null !== parentFiber ? parentFiber.actualStartTime : endTime$jscomp$0, prevDeepEquality = alreadyWarnedForDeepEquality;
          (child.mode & ProfileMode) !== NoMode && 0 < child.actualStartTime && 0 !== (child.flags & 1) && logComponentRender(
            child,
            child.actualStartTime,
            endTime,
            inHydratedSubtree,
            committedLanes
          );
          var flags = child.flags;
          switch (child.tag) {
            case 22:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                child,
                committedLanes,
                committedTransitions,
                endTime
              );
              flags & 2048 && commitOffscreenPassiveMountEffects(child.alternate, child);
              break;
            case 24:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                child,
                committedLanes,
                committedTransitions,
                endTime
              );
              flags & 2048 && commitCachePassiveMountEffect(child.alternate, child);
              break;
            default:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                child,
                committedLanes,
                committedTransitions,
                endTime
              );
          }
          alreadyWarnedForDeepEquality = prevDeepEquality;
          child = parentFiber;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
      if (parentFiber.subtreeFlags & suspenseyCommitFlag)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          accumulateSuspenseyCommitOnFiber(
            parentFiber,
            committedLanes,
            suspendedState
          ), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
      switch (fiber.tag) {
        case 26:
          recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          );
          fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(
            suspendedState,
            currentHoistableRoot,
            fiber.memoizedState,
            fiber.memoizedProps
          );
          break;
        case 5:
          recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          );
          break;
        case 3:
        case 4:
          var previousHoistableRoot = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(
            fiber.stateNode.containerInfo
          );
          recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          );
          currentHoistableRoot = previousHoistableRoot;
          break;
        case 22:
          null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          ), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          ));
          break;
        default:
          recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          );
      }
    }
    function detachAlternateSiblings(parentFiber) {
      var previousFiber = parentFiber.alternate;
      if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do
          previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
      }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
      var deletions = parentFiber.deletions;
      if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions)
          for (var i2 = 0; i2 < deletions.length; i2++) {
            var childToDelete = deletions[i2], prevEffectStart = pushComponentEffectStart();
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
              childToDelete,
              parentFiber
            );
            (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
              childToDelete,
              componentEffectStartTime,
              componentEffectEndTime,
              "Unmount"
            );
            popComponentEffectStart(prevEffectStart);
          }
        detachAlternateSiblings(parentFiber);
      }
      if (parentFiber.subtreeFlags & 10256)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.flags & 2048 && commitHookPassiveUnmountEffects(
            finishedWork,
            finishedWork.return,
            Passive | HasEffect
          );
          break;
        case 3:
          var prevProfilerEffectDuration = pushNestedEffectDurations();
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.stateNode.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
          break;
        case 12:
          prevProfilerEffectDuration = pushNestedEffectDurations();
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.stateNode.passiveEffectDuration += bubbleNestedEffectDurations(prevProfilerEffectDuration);
          break;
        case 22:
          prevProfilerEffectDuration = finishedWork.stateNode;
          null !== finishedWork.memoizedState && prevProfilerEffectDuration._visibility & OffscreenPassiveEffectsConnected && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (prevProfilerEffectDuration._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
            finishedWork,
            componentEffectStartTime,
            componentEffectEndTime,
            "Disconnect"
          )) : recursivelyTraversePassiveUnmountEffects(finishedWork);
          break;
        default:
          recursivelyTraversePassiveUnmountEffects(finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
      componentEffectErrors = prevEffectErrors;
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
      var deletions = parentFiber.deletions;
      if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions)
          for (var i2 = 0; i2 < deletions.length; i2++) {
            var childToDelete = deletions[i2], prevEffectStart = pushComponentEffectStart();
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
              childToDelete,
              parentFiber
            );
            (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
              childToDelete,
              componentEffectStartTime,
              componentEffectEndTime,
              "Unmount"
            );
            popComponentEffectStart(prevEffectStart);
          }
        detachAlternateSiblings(parentFiber);
      }
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        disconnectPassiveEffect(parentFiber), parentFiber = parentFiber.sibling;
    }
    function disconnectPassiveEffect(finishedWork) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          commitHookPassiveUnmountEffects(
            finishedWork,
            finishedWork.return,
            Passive
          );
          recursivelyTraverseDisconnectPassiveEffects(finishedWork);
          break;
        case 22:
          var instance = finishedWork.stateNode;
          instance._visibility & OffscreenPassiveEffectsConnected && (instance._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork));
          break;
        default:
          recursivelyTraverseDisconnectPassiveEffects(finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
      componentEffectErrors = prevEffectErrors;
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor$jscomp$0) {
      for (; null !== nextEffect; ) {
        var fiber = nextEffect, current3 = fiber, nearestMountedAncestor = nearestMountedAncestor$jscomp$0, prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch (current3.tag) {
          case 0:
          case 11:
          case 15:
            commitHookPassiveUnmountEffects(
              current3,
              nearestMountedAncestor,
              Passive
            );
            break;
          case 23:
          case 22:
            null !== current3.memoizedState && null !== current3.memoizedState.cachePool && (nearestMountedAncestor = current3.memoizedState.cachePool.pool, null != nearestMountedAncestor && retainCache(nearestMountedAncestor));
            break;
          case 24:
            releaseCache(current3.memoizedState.cache);
        }
        (current3.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
          current3,
          componentEffectStartTime,
          componentEffectEndTime,
          componentEffectDuration,
          componentEffectErrors
        );
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
        current3 = fiber.child;
        if (null !== current3) current3.return = fiber, nextEffect = current3;
        else
          a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
            current3 = nextEffect;
            prevEffectStart = current3.sibling;
            prevEffectDuration = current3.return;
            detachFiberAfterEffects(current3);
            if (current3 === fiber) {
              nextEffect = null;
              break a;
            }
            if (null !== prevEffectStart) {
              prevEffectStart.return = prevEffectDuration;
              nextEffect = prevEffectStart;
              break a;
            }
            nextEffect = prevEffectDuration;
          }
      }
    }
    function onCommitRoot() {
      commitHooks.forEach(function(commitHook) {
        return commitHook();
      });
    }
    function isConcurrentActEnvironment() {
      var isReactActEnvironmentGlobal = "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
      isReactActEnvironmentGlobal || null === ReactSharedInternals.actQueue || console.error(
        "The current testing environment is not configured to support act(...)"
      );
      return isReactActEnvironmentGlobal;
    }
    function requestUpdateLane(fiber) {
      if ((executionContext & RenderContext) !== NoContext && 0 !== workInProgressRootRenderLanes)
        return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
      var transition = ReactSharedInternals.T;
      return null !== transition ? (transition._updatedFibers || (transition._updatedFibers = /* @__PURE__ */ new Set()), transition._updatedFibers.add(fiber), requestTransitionLane()) : resolveUpdatePriority();
    }
    function requestDeferredLane() {
      if (0 === workInProgressDeferredLane)
        if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
          var lane = nextTransitionDeferredLane;
          nextTransitionDeferredLane <<= 1;
          0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
          workInProgressDeferredLane = lane;
        } else workInProgressDeferredLane = 536870912;
      lane = suspenseHandlerStackCursor.current;
      null !== lane && (lane.flags |= 32);
      return workInProgressDeferredLane;
    }
    function scheduleUpdateOnFiber(root3, fiber, lane) {
      isRunningInsertionEffect && console.error("useInsertionEffect must not schedule updates.");
      isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = true);
      if (root3 === workInProgressRoot && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root3.cancelPendingCommit)
        prepareFreshStack(root3, 0), markRootSuspended(
          root3,
          workInProgressRootRenderLanes,
          workInProgressDeferredLane,
          false
        );
      markRootUpdated$1(root3, lane);
      if ((executionContext & RenderContext) !== NoContext && root3 === workInProgressRoot) {
        if (isRendering)
          switch (fiber.tag) {
            case 0:
            case 11:
            case 15:
              root3 = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
              didWarnAboutUpdateInRenderForAnotherComponent.has(root3) || (didWarnAboutUpdateInRenderForAnotherComponent.add(root3), fiber = getComponentNameFromFiber(fiber) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                fiber,
                root3,
                root3
              ));
              break;
            case 1:
              didWarnAboutUpdateInRender || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), didWarnAboutUpdateInRender = true);
          }
      } else
        isDevToolsPresent && addFiberToLanesMap(root3, fiber, lane), warnIfUpdatesNotWrappedWithActDEV(fiber), root3 === workInProgressRoot && ((executionContext & RenderContext) === NoContext && (workInProgressRootInterleavedUpdatedLanes |= lane), workInProgressRootExitStatus === RootSuspendedWithDelay && markRootSuspended(
          root3,
          workInProgressRootRenderLanes,
          workInProgressDeferredLane,
          false
        )), ensureRootIsScheduled(root3);
    }
    function performWorkOnRoot(root3, lanes, forceSync) {
      if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
        throw Error("Should not already be working.");
      if (0 !== workInProgressRootRenderLanes && null !== workInProgress) {
        var yieldedFiber = workInProgress, yieldEndTime = now$12();
        switch (yieldReason) {
          case SuspendedOnImmediate:
          case SuspendedOnData:
            var startTime2 = yieldStartTime;
            supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(
              console.timeStamp.bind(
                console,
                "Suspended",
                startTime2,
                yieldEndTime,
                COMPONENTS_TRACK,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Suspended",
              startTime2,
              yieldEndTime,
              COMPONENTS_TRACK,
              void 0,
              "primary-light"
            ));
            break;
          case SuspendedOnAction:
            startTime2 = yieldStartTime;
            supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(
              console.timeStamp.bind(
                console,
                "Action",
                startTime2,
                yieldEndTime,
                COMPONENTS_TRACK,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Action",
              startTime2,
              yieldEndTime,
              COMPONENTS_TRACK,
              void 0,
              "primary-light"
            ));
            break;
          default:
            supportsUserTiming && (yieldedFiber = yieldEndTime - yieldStartTime, 3 > yieldedFiber || console.timeStamp(
              "Blocked",
              yieldStartTime,
              yieldEndTime,
              COMPONENTS_TRACK,
              void 0,
              5 > yieldedFiber ? "primary-light" : 10 > yieldedFiber ? "primary" : 100 > yieldedFiber ? "primary-dark" : "error"
            ));
        }
      }
      startTime2 = (forceSync = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root3.expiredLanes) || checkIfRootIsPrerendering(root3, lanes)) ? renderRootConcurrent(root3, lanes) : renderRootSync(root3, lanes, true);
      var renderWasConcurrent = forceSync;
      do {
        if (startTime2 === RootInProgress) {
          workInProgressRootIsPrerendering && !forceSync && markRootSuspended(root3, lanes, 0, false);
          lanes = workInProgressSuspendedReason;
          yieldStartTime = now2();
          yieldReason = lanes;
          break;
        } else {
          yieldedFiber = now$12();
          yieldEndTime = root3.current.alternate;
          if (renderWasConcurrent && !isRenderConsistentWithExternalStores(yieldEndTime)) {
            setCurrentTrackFromLanes(lanes);
            yieldEndTime = renderStartTime;
            startTime2 = yieldedFiber;
            !supportsUserTiming || startTime2 <= yieldEndTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(
              console.timeStamp.bind(
                console,
                "Teared Render",
                yieldEndTime,
                startTime2,
                currentTrack,
                LANES_TRACK_GROUP,
                "error"
              )
            ) : console.timeStamp(
              "Teared Render",
              yieldEndTime,
              startTime2,
              currentTrack,
              LANES_TRACK_GROUP,
              "error"
            ));
            finalizeRender(lanes, yieldedFiber);
            startTime2 = renderRootSync(root3, lanes, false);
            renderWasConcurrent = false;
            continue;
          }
          if (startTime2 === RootErrored) {
            renderWasConcurrent = lanes;
            if (root3.errorRecoveryDisabledLanes & renderWasConcurrent)
              var errorRetryLanes = 0;
            else
              errorRetryLanes = root3.pendingLanes & -536870913, errorRetryLanes = 0 !== errorRetryLanes ? errorRetryLanes : errorRetryLanes & 536870912 ? 536870912 : 0;
            if (0 !== errorRetryLanes) {
              setCurrentTrackFromLanes(lanes);
              logErroredRenderPhase(
                renderStartTime,
                yieldedFiber,
                lanes,
                workInProgressUpdateTask
              );
              finalizeRender(lanes, yieldedFiber);
              lanes = errorRetryLanes;
              a: {
                yieldedFiber = root3;
                startTime2 = renderWasConcurrent;
                renderWasConcurrent = workInProgressRootConcurrentErrors;
                var wasRootDehydrated = yieldedFiber.current.memoizedState.isDehydrated;
                wasRootDehydrated && (prepareFreshStack(yieldedFiber, errorRetryLanes).flags |= 256);
                errorRetryLanes = renderRootSync(
                  yieldedFiber,
                  errorRetryLanes,
                  false
                );
                if (errorRetryLanes !== RootErrored) {
                  if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                    yieldedFiber.errorRecoveryDisabledLanes |= startTime2;
                    workInProgressRootInterleavedUpdatedLanes |= startTime2;
                    startTime2 = RootSuspendedWithDelay;
                    break a;
                  }
                  yieldedFiber = workInProgressRootRecoverableErrors;
                  workInProgressRootRecoverableErrors = renderWasConcurrent;
                  null !== yieldedFiber && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = yieldedFiber : workInProgressRootRecoverableErrors.push.apply(
                    workInProgressRootRecoverableErrors,
                    yieldedFiber
                  ));
                }
                startTime2 = errorRetryLanes;
              }
              renderWasConcurrent = false;
              if (startTime2 !== RootErrored) continue;
              else yieldedFiber = now$12();
            }
          }
          if (startTime2 === RootFatalErrored) {
            setCurrentTrackFromLanes(lanes);
            logErroredRenderPhase(
              renderStartTime,
              yieldedFiber,
              lanes,
              workInProgressUpdateTask
            );
            finalizeRender(lanes, yieldedFiber);
            prepareFreshStack(root3, 0);
            markRootSuspended(root3, lanes, 0, true);
            break;
          }
          a: {
            forceSync = root3;
            switch (startTime2) {
              case RootInProgress:
              case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
              case RootSuspendedWithDelay:
                if ((lanes & 4194048) !== lanes) break;
              case RootSuspendedAtTheShell:
                setCurrentTrackFromLanes(lanes);
                logSuspendedRenderPhase(
                  renderStartTime,
                  yieldedFiber,
                  lanes,
                  workInProgressUpdateTask
                );
                finalizeRender(lanes, yieldedFiber);
                yieldEndTime = lanes;
                0 !== (yieldEndTime & 127) ? blockingSuspendedTime = yieldedFiber : 0 !== (yieldEndTime & 4194048) && (transitionSuspendedTime = yieldedFiber);
                markRootSuspended(
                  forceSync,
                  lanes,
                  workInProgressDeferredLane,
                  !workInProgressRootDidSkipSuspendedSiblings
                );
                break a;
              case RootErrored:
                workInProgressRootRecoverableErrors = null;
                break;
              case RootSuspended:
              case RootCompleted:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (null !== ReactSharedInternals.actQueue)
              commitRoot(
                forceSync,
                yieldEndTime,
                lanes,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                startTime2,
                null,
                null,
                renderStartTime,
                yieldedFiber
              );
            else {
              if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$12(), 10 < renderWasConcurrent)) {
                markRootSuspended(
                  forceSync,
                  lanes,
                  workInProgressDeferredLane,
                  !workInProgressRootDidSkipSuspendedSiblings
                );
                if (0 !== getNextLanes(forceSync, 0, true)) break a;
                pendingEffectsLanes = lanes;
                forceSync.timeoutHandle = scheduleTimeout(
                  commitRootWhenReady.bind(
                    null,
                    forceSync,
                    yieldEndTime,
                    workInProgressRootRecoverableErrors,
                    workInProgressTransitions,
                    workInProgressRootDidIncludeRecursiveRenderUpdate,
                    lanes,
                    workInProgressDeferredLane,
                    workInProgressRootInterleavedUpdatedLanes,
                    workInProgressSuspendedRetryLanes,
                    workInProgressRootDidSkipSuspendedSiblings,
                    startTime2,
                    "Throttled",
                    renderStartTime,
                    yieldedFiber
                  ),
                  renderWasConcurrent
                );
                break a;
              }
              commitRootWhenReady(
                forceSync,
                yieldEndTime,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                lanes,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                workInProgressRootDidSkipSuspendedSiblings,
                startTime2,
                null,
                renderStartTime,
                yieldedFiber
              );
            }
          }
        }
        break;
      } while (1);
      ensureRootIsScheduled(root3);
    }
    function commitRootWhenReady(root3, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
      root3.timeoutHandle = noTimeout;
      var subtreeFlags = finishedWork.subtreeFlags, suspendedState = null;
      if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedState = {
          stylesheets: null,
          count: 0,
          imgCount: 0,
          imgBytes: 0,
          suspenseyImages: [],
          waitingForImages: true,
          waitingForViewTransition: false,
          unsuspend: noop$12
        }, accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedState), subtreeFlags = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now$12() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now$12() : 0, subtreeFlags = waitForCommitToBeReady(suspendedState, subtreeFlags), null !== subtreeFlags) {
          pendingEffectsLanes = lanes;
          root3.cancelPendingCommit = subtreeFlags(
            commitRoot.bind(
              null,
              root3,
              finishedWork,
              lanes,
              recoverableErrors,
              transitions,
              didIncludeRenderPhaseUpdate,
              spawnedLane,
              updatedLanes,
              suspendedRetryLanes,
              exitStatus,
              suspendedState,
              suspendedState.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < suspendedState.count ? 0 < suspendedState.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : 1 === suspendedState.imgCount ? "Suspended on an Image" : 0 < suspendedState.imgCount ? "Suspended on Images" : null,
              completedRenderStartTime,
              completedRenderEndTime
            )
          );
          markRootSuspended(
            root3,
            lanes,
            spawnedLane,
            !didSkipSuspendedSiblings
          );
          return;
        }
      }
      commitRoot(
        root3,
        finishedWork,
        lanes,
        recoverableErrors,
        transitions,
        didIncludeRenderPhaseUpdate,
        spawnedLane,
        updatedLanes,
        suspendedRetryLanes,
        exitStatus,
        suspendedState,
        suspendedCommitReason,
        completedRenderStartTime,
        completedRenderEndTime
      );
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
      for (var node = finishedWork; ; ) {
        var tag2 = node.tag;
        if ((0 === tag2 || 11 === tag2 || 15 === tag2) && node.flags & 16384 && (tag2 = node.updateQueue, null !== tag2 && (tag2 = tag2.stores, null !== tag2)))
          for (var i2 = 0; i2 < tag2.length; i2++) {
            var check = tag2[i2], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
              if (!objectIs(getSnapshot(), check)) return false;
            } catch (error) {
              return false;
            }
          }
        tag2 = node.child;
        if (node.subtreeFlags & 16384 && null !== tag2)
          tag2.return = node, node = tag2;
        else {
          if (node === finishedWork) break;
          for (; null === node.sibling; ) {
            if (null === node.return || node.return === finishedWork) return true;
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      return true;
    }
    function markRootSuspended(root3, suspendedLanes, spawnedLane, didAttemptEntireTree) {
      suspendedLanes &= ~workInProgressRootPingedLanes;
      suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
      root3.suspendedLanes |= suspendedLanes;
      root3.pingedLanes &= ~suspendedLanes;
      didAttemptEntireTree && (root3.warmLanes |= suspendedLanes);
      didAttemptEntireTree = root3.expirationTimes;
      for (var lanes = suspendedLanes; 0 < lanes; ) {
        var index2 = 31 - clz32(lanes), lane = 1 << index2;
        didAttemptEntireTree[index2] = -1;
        lanes &= ~lane;
      }
      0 !== spawnedLane && markSpawnedDeferredLane(root3, spawnedLane, suspendedLanes);
    }
    function flushSyncWork$1() {
      return (executionContext & (RenderContext | CommitContext)) === NoContext ? (flushSyncWorkAcrossRoots_impl(0), false) : true;
    }
    function resetWorkInProgressStack() {
      if (null !== workInProgress) {
        if (workInProgressSuspendedReason === NotSuspended)
          var interruptedWork = workInProgress.return;
        else
          interruptedWork = workInProgress, resetContextDependencies(), resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
        for (; null !== interruptedWork; )
          unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
      }
    }
    function finalizeRender(lanes, finalizationTime) {
      0 !== (lanes & 127) && (blockingClampTime = finalizationTime);
      0 !== (lanes & 4194048) && (transitionClampTime = finalizationTime);
      0 !== (lanes & 62914560) && (retryClampTime = finalizationTime);
      0 !== (lanes & 2080374784) && (idleClampTime = finalizationTime);
    }
    function prepareFreshStack(root3, lanes) {
      supportsUserTiming && (console.timeStamp(
        "Blocking Track",
        3e-3,
        3e-3,
        "Blocking",
        LANES_TRACK_GROUP,
        "primary-light"
      ), console.timeStamp(
        "Transition Track",
        3e-3,
        3e-3,
        "Transition",
        LANES_TRACK_GROUP,
        "primary-light"
      ), console.timeStamp(
        "Suspense Track",
        3e-3,
        3e-3,
        "Suspense",
        LANES_TRACK_GROUP,
        "primary-light"
      ), console.timeStamp(
        "Idle Track",
        3e-3,
        3e-3,
        "Idle",
        LANES_TRACK_GROUP,
        "primary-light"
      ));
      var previousRenderStartTime = renderStartTime;
      renderStartTime = now2();
      if (0 !== workInProgressRootRenderLanes && 0 < previousRenderStartTime) {
        setCurrentTrackFromLanes(workInProgressRootRenderLanes);
        if (workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootSuspendedWithDelay)
          logSuspendedRenderPhase(
            previousRenderStartTime,
            renderStartTime,
            lanes,
            workInProgressUpdateTask
          );
        else {
          var endTime = renderStartTime, debugTask = workInProgressUpdateTask;
          if (supportsUserTiming && !(endTime <= previousRenderStartTime)) {
            var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", label2 = (lanes & 536870912) === lanes ? "Prewarm" : (lanes & 201326741) === lanes ? "Interrupted Hydration" : "Interrupted Render";
            debugTask ? debugTask.run(
              console.timeStamp.bind(
                console,
                label2,
                previousRenderStartTime,
                endTime,
                currentTrack,
                LANES_TRACK_GROUP,
                color
              )
            ) : console.timeStamp(
              label2,
              previousRenderStartTime,
              endTime,
              currentTrack,
              LANES_TRACK_GROUP,
              color
            );
          }
        }
        finalizeRender(workInProgressRootRenderLanes, renderStartTime);
      }
      previousRenderStartTime = workInProgressUpdateTask;
      workInProgressUpdateTask = null;
      if (0 !== (lanes & 127)) {
        workInProgressUpdateTask = blockingUpdateTask;
        debugTask = 0 <= blockingUpdateTime && blockingUpdateTime < blockingClampTime ? blockingClampTime : blockingUpdateTime;
        endTime = 0 <= blockingEventTime && blockingEventTime < blockingClampTime ? blockingClampTime : blockingEventTime;
        color = 0 <= endTime ? endTime : 0 <= debugTask ? debugTask : renderStartTime;
        0 <= blockingSuspendedTime ? (setCurrentTrackFromLanes(2), logSuspendedWithDelayPhase(
          blockingSuspendedTime,
          color,
          lanes,
          previousRenderStartTime
        )) : 0 !== (animatingLanes & 127);
        previousRenderStartTime = debugTask;
        var eventTime = endTime, eventType = blockingEventType, eventIsRepeat = 0 < blockingEventRepeatTime, isSpawnedUpdate = blockingUpdateType === SPAWNED_UPDATE, isPingedUpdate = blockingUpdateType === PINGED_UPDATE;
        debugTask = renderStartTime;
        endTime = blockingUpdateTask;
        color = blockingUpdateMethodName;
        label2 = blockingUpdateComponentName;
        if (supportsUserTiming) {
          currentTrack = "Blocking";
          0 < previousRenderStartTime ? previousRenderStartTime > debugTask && (previousRenderStartTime = debugTask) : previousRenderStartTime = debugTask;
          0 < eventTime ? eventTime > previousRenderStartTime && (eventTime = previousRenderStartTime) : eventTime = previousRenderStartTime;
          if (null !== eventType && previousRenderStartTime > eventTime) {
            var color$jscomp$0 = eventIsRepeat ? "secondary-light" : "warning";
            endTime ? endTime.run(
              console.timeStamp.bind(
                console,
                eventIsRepeat ? "Consecutive" : "Event: " + eventType,
                eventTime,
                previousRenderStartTime,
                currentTrack,
                LANES_TRACK_GROUP,
                color$jscomp$0
              )
            ) : console.timeStamp(
              eventIsRepeat ? "Consecutive" : "Event: " + eventType,
              eventTime,
              previousRenderStartTime,
              currentTrack,
              LANES_TRACK_GROUP,
              color$jscomp$0
            );
          }
          debugTask > previousRenderStartTime && (eventTime = isSpawnedUpdate ? "error" : (lanes & 738197653) === lanes ? "tertiary-light" : "primary-light", isSpawnedUpdate = isPingedUpdate ? "Promise Resolved" : isSpawnedUpdate ? "Cascading Update" : 5 < debugTask - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != label2 && isPingedUpdate.push(["Component name", label2]), null != color && isPingedUpdate.push(["Method name", color]), previousRenderStartTime = {
            start: previousRenderStartTime,
            end: debugTask,
            detail: {
              devtools: {
                properties: isPingedUpdate,
                track: currentTrack,
                trackGroup: LANES_TRACK_GROUP,
                color: eventTime
              }
            }
          }, endTime ? endTime.run(
            performance.measure.bind(
              performance,
              isSpawnedUpdate,
              previousRenderStartTime
            )
          ) : performance.measure(isSpawnedUpdate, previousRenderStartTime));
        }
        blockingUpdateTime = -1.1;
        blockingUpdateType = 0;
        blockingUpdateComponentName = blockingUpdateMethodName = null;
        blockingSuspendedTime = -1.1;
        blockingEventRepeatTime = blockingEventTime;
        blockingEventTime = -1.1;
        blockingClampTime = now2();
      }
      0 !== (lanes & 4194048) && (workInProgressUpdateTask = transitionUpdateTask, debugTask = 0 <= transitionStartTime && transitionStartTime < transitionClampTime ? transitionClampTime : transitionStartTime, previousRenderStartTime = 0 <= transitionUpdateTime && transitionUpdateTime < transitionClampTime ? transitionClampTime : transitionUpdateTime, endTime = 0 <= transitionEventTime && transitionEventTime < transitionClampTime ? transitionClampTime : transitionEventTime, color = 0 <= endTime ? endTime : 0 <= previousRenderStartTime ? previousRenderStartTime : renderStartTime, 0 <= transitionSuspendedTime ? (setCurrentTrackFromLanes(256), logSuspendedWithDelayPhase(
        transitionSuspendedTime,
        color,
        lanes,
        workInProgressUpdateTask
      )) : 0 !== (animatingLanes & 4194048), isPingedUpdate = endTime, eventTime = transitionEventType, eventType = 0 < transitionEventRepeatTime, eventIsRepeat = transitionUpdateType === PINGED_UPDATE, color = renderStartTime, endTime = transitionUpdateTask, label2 = transitionUpdateMethodName, isSpawnedUpdate = transitionUpdateComponentName, supportsUserTiming && (currentTrack = "Transition", 0 < previousRenderStartTime ? previousRenderStartTime > color && (previousRenderStartTime = color) : previousRenderStartTime = color, 0 < debugTask ? debugTask > previousRenderStartTime && (debugTask = previousRenderStartTime) : debugTask = previousRenderStartTime, 0 < isPingedUpdate ? isPingedUpdate > debugTask && (isPingedUpdate = debugTask) : isPingedUpdate = debugTask, debugTask > isPingedUpdate && null !== eventTime && (color$jscomp$0 = eventType ? "secondary-light" : "warning", endTime ? endTime.run(
        console.timeStamp.bind(
          console,
          eventType ? "Consecutive" : "Event: " + eventTime,
          isPingedUpdate,
          debugTask,
          currentTrack,
          LANES_TRACK_GROUP,
          color$jscomp$0
        )
      ) : console.timeStamp(
        eventType ? "Consecutive" : "Event: " + eventTime,
        isPingedUpdate,
        debugTask,
        currentTrack,
        LANES_TRACK_GROUP,
        color$jscomp$0
      )), previousRenderStartTime > debugTask && (endTime ? endTime.run(
        console.timeStamp.bind(
          console,
          "Action",
          debugTask,
          previousRenderStartTime,
          currentTrack,
          LANES_TRACK_GROUP,
          "primary-dark"
        )
      ) : console.timeStamp(
        "Action",
        debugTask,
        previousRenderStartTime,
        currentTrack,
        LANES_TRACK_GROUP,
        "primary-dark"
      )), color > previousRenderStartTime && (debugTask = eventIsRepeat ? "Promise Resolved" : 5 < color - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != isSpawnedUpdate && isPingedUpdate.push(["Component name", isSpawnedUpdate]), null != label2 && isPingedUpdate.push(["Method name", label2]), previousRenderStartTime = {
        start: previousRenderStartTime,
        end: color,
        detail: {
          devtools: {
            properties: isPingedUpdate,
            track: currentTrack,
            trackGroup: LANES_TRACK_GROUP,
            color: "primary-light"
          }
        }
      }, endTime ? endTime.run(
        performance.measure.bind(
          performance,
          debugTask,
          previousRenderStartTime
        )
      ) : performance.measure(debugTask, previousRenderStartTime))), transitionUpdateTime = transitionStartTime = -1.1, transitionUpdateType = 0, transitionSuspendedTime = -1.1, transitionEventRepeatTime = transitionEventTime, transitionEventTime = -1.1, transitionClampTime = now2());
      0 !== (lanes & 62914560) && 0 !== (animatingLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, renderStartTime));
      0 !== (lanes & 2080374784) && 0 !== (animatingLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, renderStartTime));
      previousRenderStartTime = root3.timeoutHandle;
      previousRenderStartTime !== noTimeout && (root3.timeoutHandle = noTimeout, cancelTimeout(previousRenderStartTime));
      previousRenderStartTime = root3.cancelPendingCommit;
      null !== previousRenderStartTime && (root3.cancelPendingCommit = null, previousRenderStartTime());
      pendingEffectsLanes = 0;
      resetWorkInProgressStack();
      workInProgressRoot = root3;
      workInProgress = previousRenderStartTime = createWorkInProgress(
        root3.current,
        null
      );
      workInProgressRootRenderLanes = lanes;
      workInProgressSuspendedReason = NotSuspended;
      workInProgressThrownValue = null;
      workInProgressRootDidSkipSuspendedSiblings = false;
      workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root3, lanes);
      workInProgressRootDidAttachPingListener = false;
      workInProgressRootExitStatus = RootInProgress;
      workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = 0;
      workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
      workInProgressRootDidIncludeRecursiveRenderUpdate = false;
      0 !== (lanes & 8) && (lanes |= lanes & 32);
      endTime = root3.entangledLanes;
      if (0 !== endTime)
        for (root3 = root3.entanglements, endTime &= lanes; 0 < endTime; )
          debugTask = 31 - clz32(endTime), color = 1 << debugTask, lanes |= root3[debugTask], endTime &= ~color;
      entangledRenderLanes = lanes;
      finishQueueingConcurrentUpdates();
      root3 = getCurrentTime();
      1e3 < root3 - lastResetTime && (ReactSharedInternals.recentlyCreatedOwnerStacks = 0, lastResetTime = root3);
      ReactStrictModeWarnings.discardPendingWarnings();
      return previousRenderStartTime;
    }
    function handleThrow(root3, thrownValue) {
      currentlyRenderingFiber = null;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      ReactSharedInternals.getCurrentStack = null;
      isRendering = false;
      current2 = null;
      thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnImmediate) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnInstance) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? SuspendedOnHydration : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? SuspendedOnDeprecatedThrowPromise : SuspendedOnError;
      workInProgressThrownValue = thrownValue;
      var erroredWork = workInProgress;
      null === erroredWork ? (workInProgressRootExitStatus = RootFatalErrored, logUncaughtError(
        root3,
        createCapturedValueAtFiber(thrownValue, root3.current)
      )) : erroredWork.mode & ProfileMode && stopProfilerTimerIfRunningAndRecordDuration(erroredWork);
    }
    function shouldRemainOnPreviousScreen() {
      var handler = suspenseHandlerStackCursor.current;
      return null === handler ? true : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? true : false : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : false;
    }
    function pushDispatcher() {
      var prevDispatcher = ReactSharedInternals.H;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
      var prevAsyncDispatcher = ReactSharedInternals.A;
      ReactSharedInternals.A = DefaultAsyncDispatcher;
      return prevAsyncDispatcher;
    }
    function markRenderDerivedCause(fiber) {
      null === workInProgressUpdateTask && (workInProgressUpdateTask = null == fiber._debugTask ? null : fiber._debugTask);
    }
    function renderDidSuspendDelayIfPossible() {
      workInProgressRootExitStatus = RootSuspendedWithDelay;
      workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = true);
      0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(
        workInProgressRoot,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      );
    }
    function renderRootSync(root3, lanes, shouldYieldForPrerendering) {
      var prevExecutionContext = executionContext;
      executionContext |= RenderContext;
      var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
      if (workInProgressRoot !== root3 || workInProgressRootRenderLanes !== lanes) {
        if (isDevToolsPresent) {
          var memoizedUpdaters = root3.memoizedUpdaters;
          0 < memoizedUpdaters.size && (restorePendingUpdaters(root3, workInProgressRootRenderLanes), memoizedUpdaters.clear());
          movePendingFibersToMemoized(root3, lanes);
        }
        workInProgressTransitions = null;
        prepareFreshStack(root3, lanes);
      }
      lanes = false;
      memoizedUpdaters = workInProgressRootExitStatus;
      a: do
        try {
          if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch (workInProgressSuspendedReason) {
              case SuspendedOnHydration:
                resetWorkInProgressStack();
                memoizedUpdaters = RootSuspendedAtTheShell;
                break a;
              case SuspendedOnImmediate:
              case SuspendedOnData:
              case SuspendedOnAction:
              case SuspendedOnDeprecatedThrowPromise:
                null === suspenseHandlerStackCursor.current && (lanes = true);
                var reason = workInProgressSuspendedReason;
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, reason);
                if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                  memoizedUpdaters = RootInProgress;
                  break a;
                }
                break;
              default:
                reason = workInProgressSuspendedReason, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, reason);
            }
          }
          workLoopSync();
          memoizedUpdaters = workInProgressRootExitStatus;
          break;
        } catch (thrownValue$8) {
          handleThrow(root3, thrownValue$8);
        }
      while (1);
      lanes && root3.shellSuspendCounter++;
      resetContextDependencies();
      executionContext = prevExecutionContext;
      ReactSharedInternals.H = prevDispatcher;
      ReactSharedInternals.A = prevAsyncDispatcher;
      null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
      return memoizedUpdaters;
    }
    function workLoopSync() {
      for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root3, lanes) {
      var prevExecutionContext = executionContext;
      executionContext |= RenderContext;
      var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
      if (workInProgressRoot !== root3 || workInProgressRootRenderLanes !== lanes) {
        if (isDevToolsPresent) {
          var memoizedUpdaters = root3.memoizedUpdaters;
          0 < memoizedUpdaters.size && (restorePendingUpdaters(root3, workInProgressRootRenderLanes), memoizedUpdaters.clear());
          movePendingFibersToMemoized(root3, lanes);
        }
        workInProgressTransitions = null;
        workInProgressRootRenderTargetTime = now$12() + RENDER_TIMEOUT_MS;
        prepareFreshStack(root3, lanes);
      } else
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
          root3,
          lanes
        );
      a: do
        try {
          if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress)
            b: switch (lanes = workInProgress, memoizedUpdaters = workInProgressThrownValue, workInProgressSuspendedReason) {
              case SuspendedOnError:
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root3,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnError
                );
                break;
              case SuspendedOnData:
              case SuspendedOnAction:
                if (isThenableResolved(memoizedUpdaters)) {
                  workInProgressSuspendedReason = NotSuspended;
                  workInProgressThrownValue = null;
                  replaySuspendedUnitOfWork(lanes);
                  break;
                }
                lanes = function() {
                  workInProgressSuspendedReason !== SuspendedOnData && workInProgressSuspendedReason !== SuspendedOnAction || workInProgressRoot !== root3 || (workInProgressSuspendedReason = SuspendedAndReadyToContinue);
                  ensureRootIsScheduled(root3);
                };
                memoizedUpdaters.then(lanes, lanes);
                break a;
              case SuspendedOnImmediate:
                workInProgressSuspendedReason = SuspendedAndReadyToContinue;
                break a;
              case SuspendedOnInstance:
                workInProgressSuspendedReason = SuspendedOnInstanceAndReadyToContinue;
                break a;
              case SuspendedAndReadyToContinue:
                isThenableResolved(memoizedUpdaters) ? (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(
                  root3,
                  lanes,
                  memoizedUpdaters,
                  SuspendedAndReadyToContinue
                ));
                break;
              case SuspendedOnInstanceAndReadyToContinue:
                var resource = null;
                switch (workInProgress.tag) {
                  case 26:
                    resource = workInProgress.memoizedState;
                  case 5:
                  case 27:
                    var hostFiber = workInProgress;
                    if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                      workInProgressSuspendedReason = NotSuspended;
                      workInProgressThrownValue = null;
                      var sibling = hostFiber.sibling;
                      if (null !== sibling) workInProgress = sibling;
                      else {
                        var returnFiber = hostFiber.return;
                        null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                      }
                      break b;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root3,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnInstanceAndReadyToContinue
                );
                break;
              case SuspendedOnDeprecatedThrowPromise:
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root3,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnDeprecatedThrowPromise
                );
                break;
              case SuspendedOnHydration:
                resetWorkInProgressStack();
                workInProgressRootExitStatus = RootSuspendedAtTheShell;
                break a;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          null !== ReactSharedInternals.actQueue ? workLoopSync() : workLoopConcurrentByScheduler();
          break;
        } catch (thrownValue$9) {
          handleThrow(root3, thrownValue$9);
        }
      while (1);
      resetContextDependencies();
      ReactSharedInternals.H = prevDispatcher;
      ReactSharedInternals.A = prevAsyncDispatcher;
      executionContext = prevExecutionContext;
      if (null !== workInProgress) return RootInProgress;
      workInProgressRoot = null;
      workInProgressRootRenderLanes = 0;
      finishQueueingConcurrentUpdates();
      return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
      for (; null !== workInProgress && !shouldYield(); )
        performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
      var current3 = unitOfWork.alternate;
      (unitOfWork.mode & ProfileMode) !== NoMode ? (startProfilerTimer(unitOfWork), current3 = runWithFiberInDEV(
        unitOfWork,
        beginWork,
        current3,
        unitOfWork,
        entangledRenderLanes
      ), stopProfilerTimerIfRunningAndRecordDuration(unitOfWork)) : current3 = runWithFiberInDEV(
        unitOfWork,
        beginWork,
        current3,
        unitOfWork,
        entangledRenderLanes
      );
      unitOfWork.memoizedProps = unitOfWork.pendingProps;
      null === current3 ? completeUnitOfWork(unitOfWork) : workInProgress = current3;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
      var next = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
      unitOfWork.memoizedProps = unitOfWork.pendingProps;
      null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replayBeginWork(unitOfWork) {
      var current3 = unitOfWork.alternate, isProfilingMode = (unitOfWork.mode & ProfileMode) !== NoMode;
      isProfilingMode && startProfilerTimer(unitOfWork);
      switch (unitOfWork.tag) {
        case 15:
        case 0:
          current3 = replayFunctionComponent(
            current3,
            unitOfWork,
            unitOfWork.pendingProps,
            unitOfWork.type,
            void 0,
            workInProgressRootRenderLanes
          );
          break;
        case 11:
          current3 = replayFunctionComponent(
            current3,
            unitOfWork,
            unitOfWork.pendingProps,
            unitOfWork.type.render,
            unitOfWork.ref,
            workInProgressRootRenderLanes
          );
          break;
        case 5:
          resetHooksOnUnwind(unitOfWork);
        default:
          unwindInterruptedWork(current3, unitOfWork), unitOfWork = workInProgress = resetWorkInProgress(unitOfWork, entangledRenderLanes), current3 = beginWork(current3, unitOfWork, entangledRenderLanes);
      }
      isProfilingMode && stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
      return current3;
    }
    function throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, suspendedReason) {
      resetContextDependencies();
      resetHooksOnUnwind(unitOfWork);
      thenableState$1 = null;
      thenableIndexCounter$1 = 0;
      var returnFiber = unitOfWork.return;
      try {
        if (throwException(
          root3,
          returnFiber,
          unitOfWork,
          thrownValue,
          workInProgressRootRenderLanes
        )) {
          workInProgressRootExitStatus = RootFatalErrored;
          logUncaughtError(
            root3,
            createCapturedValueAtFiber(thrownValue, root3.current)
          );
          workInProgress = null;
          return;
        }
      } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = RootFatalErrored;
        logUncaughtError(
          root3,
          createCapturedValueAtFiber(thrownValue, root3.current)
        );
        workInProgress = null;
        return;
      }
      if (unitOfWork.flags & 32768) {
        if (isHydrating || suspendedReason === SuspendedOnError) root3 = true;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912))
          root3 = false;
        else if (workInProgressRootDidSkipSuspendedSiblings = root3 = true, suspendedReason === SuspendedOnData || suspendedReason === SuspendedOnAction || suspendedReason === SuspendedOnImmediate || suspendedReason === SuspendedOnDeprecatedThrowPromise)
          suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root3);
      } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
      var completedWork = unitOfWork;
      do {
        if (0 !== (completedWork.flags & 32768)) {
          unwindUnitOfWork(
            completedWork,
            workInProgressRootDidSkipSuspendedSiblings
          );
          return;
        }
        var current3 = completedWork.alternate;
        unitOfWork = completedWork.return;
        startProfilerTimer(completedWork);
        current3 = runWithFiberInDEV(
          completedWork,
          completeWork,
          current3,
          completedWork,
          entangledRenderLanes
        );
        (completedWork.mode & ProfileMode) !== NoMode && stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
        if (null !== current3) {
          workInProgress = current3;
          return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
          workInProgress = completedWork;
          return;
        }
        workInProgress = completedWork = unitOfWork;
      } while (null !== completedWork);
      workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootCompleted);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
      do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
          next.flags &= 32767;
          workInProgress = next;
          return;
        }
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
          next = unitOfWork.actualDuration;
          for (var child = unitOfWork.child; null !== child; )
            next += child.actualDuration, child = child.sibling;
          unitOfWork.actualDuration = next;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
          workInProgress = unitOfWork;
          return;
        }
        workInProgress = unitOfWork = next;
      } while (null !== unitOfWork);
      workInProgressRootExitStatus = RootSuspendedAtTheShell;
      workInProgress = null;
    }
    function commitRoot(root3, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
      root3.cancelPendingCommit = null;
      do
        flushPendingEffects();
      while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
      ReactStrictModeWarnings.flushLegacyContextWarning();
      ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
      if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
        throw Error("Should not already be working.");
      setCurrentTrackFromLanes(lanes);
      exitStatus === RootErrored ? logErroredRenderPhase(
        completedRenderStartTime,
        completedRenderEndTime,
        lanes,
        workInProgressUpdateTask
      ) : null !== recoverableErrors ? logRecoveredRenderPhase(
        completedRenderStartTime,
        completedRenderEndTime,
        lanes,
        recoverableErrors,
        null !== finishedWork && null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 !== (finishedWork.flags & 256),
        workInProgressUpdateTask
      ) : logRenderPhase(
        completedRenderStartTime,
        completedRenderEndTime,
        lanes,
        workInProgressUpdateTask
      );
      if (null !== finishedWork) {
        0 === lanes && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        );
        if (finishedWork === root3.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(
          root3,
          lanes,
          didIncludeRenderPhaseUpdate,
          spawnedLane,
          updatedLanes,
          suspendedRetryLanes
        );
        root3 === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root3;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        pendingEffectsRenderEndTime = completedRenderEndTime;
        pendingSuspendedCommitReason = suspendedCommitReason;
        pendingDelayedCommitReason = IMMEDIATE_COMMIT;
        pendingSuspendedViewTransitionReason = null;
        0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root3.callbackNode = null, root3.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
          schedulerEvent = window.event;
          pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
          flushPassiveEffects();
          return null;
        })) : (root3.callbackNode = null, root3.callbackPriority = 0);
        commitErrors = null;
        commitStartTime = now2();
        null !== suspendedCommitReason && logSuspendedCommitPhase(
          completedRenderEndTime,
          commitStartTime,
          suspendedCommitReason,
          workInProgressUpdateTask
        );
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
          recoverableErrors = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          transitions = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          spawnedLane = executionContext;
          executionContext |= CommitContext;
          try {
            commitBeforeMutationEffects(root3, finishedWork, lanes);
          } finally {
            executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
          }
        }
        pendingEffectsStatus = PENDING_MUTATION_PHASE;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
      }
    }
    function flushMutationEffects() {
      if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        var root3 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
          rootMutationHasEffect = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          var previousPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          try {
            inProgressLanes = lanes;
            inProgressRoot = root3;
            resetComponentEffectTimers();
            commitMutationEffectsOnFiber(finishedWork, root3);
            inProgressRoot = inProgressLanes = null;
            lanes = selectionInformation;
            var curFocusedElem = getActiveElementDeep(root3.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
            if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(
              priorFocusedElem.ownerDocument.documentElement,
              priorFocusedElem
            )) {
              if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                var start = priorSelectionRange.start, end = priorSelectionRange.end;
                void 0 === end && (end = start);
                if ("selectionStart" in priorFocusedElem)
                  priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(
                    end,
                    priorFocusedElem.value.length
                  );
                else {
                  var doc2 = priorFocusedElem.ownerDocument || document, win = doc2 && doc2.defaultView || window;
                  if (win.getSelection) {
                    var selection2 = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(
                      priorSelectionRange.start,
                      length
                    ), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                    !selection2.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                    var startMarker = getNodeForCharacterOffset(
                      priorFocusedElem,
                      start$jscomp$0
                    ), endMarker = getNodeForCharacterOffset(
                      priorFocusedElem,
                      end$jscomp$0
                    );
                    if (startMarker && endMarker && (1 !== selection2.rangeCount || selection2.anchorNode !== startMarker.node || selection2.anchorOffset !== startMarker.offset || selection2.focusNode !== endMarker.node || selection2.focusOffset !== endMarker.offset)) {
                      var range2 = doc2.createRange();
                      range2.setStart(startMarker.node, startMarker.offset);
                      selection2.removeAllRanges();
                      start$jscomp$0 > end$jscomp$0 ? (selection2.addRange(range2), selection2.extend(endMarker.node, endMarker.offset)) : (range2.setEnd(endMarker.node, endMarker.offset), selection2.addRange(range2));
                    }
                  }
                }
              }
              doc2 = [];
              for (selection2 = priorFocusedElem; selection2 = selection2.parentNode; )
                1 === selection2.nodeType && doc2.push({
                  element: selection2,
                  left: selection2.scrollLeft,
                  top: selection2.scrollTop
                });
              "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
              for (priorFocusedElem = 0; priorFocusedElem < doc2.length; priorFocusedElem++) {
                var info = doc2[priorFocusedElem];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
              }
            }
            _enabled = !!eventsEnabled;
            selectionInformation = eventsEnabled = null;
          } finally {
            executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
          }
        }
        root3.current = finishedWork;
        pendingEffectsStatus = PENDING_LAYOUT_PHASE;
      }
    }
    function flushLayoutEffects() {
      if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        var suspendedViewTransitionReason = pendingSuspendedViewTransitionReason;
        if (null !== suspendedViewTransitionReason) {
          commitStartTime = now2();
          var startTime2 = commitEndTime, endTime = commitStartTime;
          !supportsUserTiming || endTime <= startTime2 || console.timeStamp(
            suspendedViewTransitionReason,
            startTime2,
            endTime,
            currentTrack,
            LANES_TRACK_GROUP,
            "secondary-light"
          );
        }
        suspendedViewTransitionReason = pendingEffectsRoot;
        startTime2 = pendingFinishedWork;
        endTime = pendingEffectsLanes;
        var rootHasLayoutEffect = 0 !== (startTime2.flags & 8772);
        if (0 !== (startTime2.subtreeFlags & 8772) || rootHasLayoutEffect) {
          rootHasLayoutEffect = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          var _previousPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          var _prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          try {
            inProgressLanes = endTime, inProgressRoot = suspendedViewTransitionReason, resetComponentEffectTimers(), commitLayoutEffectOnFiber(
              suspendedViewTransitionReason,
              startTime2.alternate,
              startTime2
            ), inProgressRoot = inProgressLanes = null;
          } finally {
            executionContext = _prevExecutionContext, ReactDOMSharedInternals.p = _previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
          }
        }
        suspendedViewTransitionReason = pendingEffectsRenderEndTime;
        startTime2 = pendingSuspendedCommitReason;
        commitEndTime = now2();
        suspendedViewTransitionReason = null === startTime2 ? suspendedViewTransitionReason : commitStartTime;
        startTime2 = commitEndTime;
        endTime = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
        rootHasLayoutEffect = workInProgressUpdateTask;
        null !== commitErrors ? logCommitErrored(
          suspendedViewTransitionReason,
          startTime2,
          commitErrors,
          false,
          rootHasLayoutEffect
        ) : !supportsUserTiming || startTime2 <= suspendedViewTransitionReason || (rootHasLayoutEffect ? rootHasLayoutEffect.run(
          console.timeStamp.bind(
            console,
            endTime ? "Commit Interrupted View Transition" : "Commit",
            suspendedViewTransitionReason,
            startTime2,
            currentTrack,
            LANES_TRACK_GROUP,
            endTime ? "error" : "secondary-dark"
          )
        ) : console.timeStamp(
          endTime ? "Commit Interrupted View Transition" : "Commit",
          suspendedViewTransitionReason,
          startTime2,
          currentTrack,
          LANES_TRACK_GROUP,
          endTime ? "error" : "secondary-dark"
        ));
        pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
      }
    }
    function flushSpawnedWork() {
      if (pendingEffectsStatus === PENDING_SPAWNED_WORK || pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE) {
        if (pendingEffectsStatus === PENDING_SPAWNED_WORK) {
          var startViewTransitionStartTime = commitEndTime;
          commitEndTime = now2();
          var endTime = commitEndTime, abortedViewTransition = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
          !supportsUserTiming || endTime <= startViewTransitionStartTime || console.timeStamp(
            abortedViewTransition ? "Interrupted View Transition" : "Starting Animation",
            startViewTransitionStartTime,
            endTime,
            currentTrack,
            LANES_TRACK_GROUP,
            abortedViewTransition ? " error" : "secondary-light"
          );
          pendingDelayedCommitReason !== ABORTED_VIEW_TRANSITION_COMMIT && (pendingDelayedCommitReason = ANIMATION_STARTED_COMMIT);
        }
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        requestPaint();
        startViewTransitionStartTime = pendingEffectsRoot;
        var finishedWork = pendingFinishedWork;
        endTime = pendingEffectsLanes;
        abortedViewTransition = pendingRecoverableErrors;
        var rootDidHavePassiveEffects = 0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256);
        rootDidHavePassiveEffects ? pendingEffectsStatus = PENDING_PASSIVE_PHASE : (pendingEffectsStatus = NO_PENDING_EFFECTS, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(
          startViewTransitionStartTime,
          startViewTransitionStartTime.pendingLanes
        ), nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null);
        var remainingLanes = startViewTransitionStartTime.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        rootDidHavePassiveEffects || commitDoubleInvokeEffectsInDEV(startViewTransitionStartTime);
        remainingLanes = lanesToEventPriority(endTime);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
          try {
            var didError = 128 === (finishedWork.current.flags & 128);
            switch (remainingLanes) {
              case DiscreteEventPriority:
                var schedulerPriority = ImmediatePriority;
                break;
              case ContinuousEventPriority:
                schedulerPriority = UserBlockingPriority;
                break;
              case DefaultEventPriority:
                schedulerPriority = NormalPriority$1;
                break;
              case IdleEventPriority:
                schedulerPriority = IdlePriority;
                break;
              default:
                schedulerPriority = NormalPriority$1;
            }
            injectedHook.onCommitFiberRoot(
              rendererID,
              finishedWork,
              schedulerPriority,
              didError
            );
          } catch (err) {
            hasLoggedError || (hasLoggedError = true, console.error(
              "React instrumentation encountered an error: %o",
              err
            ));
          }
        isDevToolsPresent && startViewTransitionStartTime.memoizedUpdaters.clear();
        onCommitRoot();
        if (null !== abortedViewTransition) {
          didError = ReactSharedInternals.T;
          schedulerPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          ReactSharedInternals.T = null;
          try {
            var onRecoverableError = startViewTransitionStartTime.onRecoverableError;
            for (finishedWork = 0; finishedWork < abortedViewTransition.length; finishedWork++) {
              var recoverableError = abortedViewTransition[finishedWork], errorInfo = makeErrorInfo(recoverableError.stack);
              runWithFiberInDEV(
                recoverableError.source,
                onRecoverableError,
                recoverableError.value,
                errorInfo
              );
            }
          } finally {
            ReactSharedInternals.T = didError, ReactDOMSharedInternals.p = schedulerPriority;
          }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(startViewTransitionStartTime);
        remainingLanes = startViewTransitionStartTime.pendingLanes;
        0 !== (endTime & 261930) && 0 !== (remainingLanes & 42) ? (nestedUpdateScheduled = true, startViewTransitionStartTime === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = startViewTransitionStartTime)) : nestedUpdateCount = 0;
        rootDidHavePassiveEffects || finalizeRender(endTime, commitEndTime);
        flushSyncWorkAcrossRoots_impl(0);
      }
    }
    function makeErrorInfo(componentStack) {
      componentStack = { componentStack };
      Object.defineProperty(componentStack, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      });
      return componentStack;
    }
    function releaseRootPooledCache(root3, remainingLanes) {
      0 === (root3.pooledCacheLanes &= remainingLanes) && (remainingLanes = root3.pooledCache, null != remainingLanes && (root3.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects() {
      flushMutationEffects();
      flushLayoutEffects();
      flushSpawnedWork();
      return flushPassiveEffects();
    }
    function flushPassiveEffects() {
      if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return false;
      var root3 = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
      pendingEffectsRemainingLanes = 0;
      var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = DefaultEventPriority > renderPriority ? DefaultEventPriority : renderPriority;
      renderPriority = ReactSharedInternals.T;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = priority;
        ReactSharedInternals.T = null;
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        priority = pendingEffectsRoot;
        var lanes = pendingEffectsLanes;
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
          throw Error("Cannot flush passive effects while already rendering.");
        setCurrentTrackFromLanes(lanes);
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        var passiveEffectStartTime = 0;
        commitErrors = null;
        passiveEffectStartTime = now$12();
        if (pendingDelayedCommitReason === ANIMATION_STARTED_COMMIT)
          logAnimatingPhase(
            commitEndTime,
            passiveEffectStartTime,
            animatingTask
          );
        else {
          var startTime2 = commitEndTime, endTime = passiveEffectStartTime, delayedUntilPaint = pendingDelayedCommitReason === DELAYED_PASSIVE_COMMIT;
          !supportsUserTiming || endTime <= startTime2 || (workInProgressUpdateTask ? workInProgressUpdateTask.run(
            console.timeStamp.bind(
              console,
              delayedUntilPaint ? "Waiting for Paint" : "Waiting",
              startTime2,
              endTime,
              currentTrack,
              LANES_TRACK_GROUP,
              "secondary-light"
            )
          ) : console.timeStamp(
            delayedUntilPaint ? "Waiting for Paint" : "Waiting",
            startTime2,
            endTime,
            currentTrack,
            LANES_TRACK_GROUP,
            "secondary-light"
          ));
        }
        startTime2 = executionContext;
        executionContext |= CommitContext;
        var finishedWork = priority.current;
        resetComponentEffectTimers();
        commitPassiveUnmountOnFiber(finishedWork);
        var finishedWork$jscomp$0 = priority.current;
        finishedWork = pendingEffectsRenderEndTime;
        resetComponentEffectTimers();
        commitPassiveMountOnFiber(
          priority,
          finishedWork$jscomp$0,
          lanes,
          transitions,
          finishedWork
        );
        commitDoubleInvokeEffectsInDEV(priority);
        executionContext = startTime2;
        var passiveEffectsEndTime = now$12();
        finishedWork$jscomp$0 = passiveEffectStartTime;
        finishedWork = workInProgressUpdateTask;
        null !== commitErrors ? logCommitErrored(
          finishedWork$jscomp$0,
          passiveEffectsEndTime,
          commitErrors,
          true,
          finishedWork
        ) : !supportsUserTiming || passiveEffectsEndTime <= finishedWork$jscomp$0 || (finishedWork ? finishedWork.run(
          console.timeStamp.bind(
            console,
            "Remaining Effects",
            finishedWork$jscomp$0,
            passiveEffectsEndTime,
            currentTrack,
            LANES_TRACK_GROUP,
            "secondary-dark"
          )
        ) : console.timeStamp(
          "Remaining Effects",
          finishedWork$jscomp$0,
          passiveEffectsEndTime,
          currentTrack,
          LANES_TRACK_GROUP,
          "secondary-dark"
        ));
        finalizeRender(lanes, passiveEffectsEndTime);
        flushSyncWorkAcrossRoots_impl(0, false);
        didScheduleUpdateDuringPassiveEffects ? priority === rootWithPassiveNestedUpdates ? nestedPassiveUpdateCount++ : (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = priority) : nestedPassiveUpdateCount = 0;
        didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = false;
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot)
          try {
            injectedHook.onPostCommitFiberRoot(rendererID, priority);
          } catch (err) {
            hasLoggedError || (hasLoggedError = true, console.error(
              "React instrumentation encountered an error: %o",
              err
            ));
          }
        var stateNode = priority.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root3, remainingLanes);
      }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
      sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
      recordEffectError(sourceFiber);
      sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
      rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
      null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
      isRunningInsertionEffect = false;
      if (3 === sourceFiber.tag)
        captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
      else {
        for (; null !== nearestMountedAncestor; ) {
          if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(
              nearestMountedAncestor,
              sourceFiber,
              error
            );
            return;
          }
          if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
              sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
              recordEffectError(sourceFiber);
              error = createClassErrorUpdate(2);
              instance = enqueueUpdate(nearestMountedAncestor, error, 2);
              null !== instance && (initializeClassErrorUpdate(
                error,
                instance,
                nearestMountedAncestor,
                sourceFiber
              ), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
              return;
            }
          }
          nearestMountedAncestor = nearestMountedAncestor.return;
        }
        console.error(
          "Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s",
          error
        );
      }
    }
    function attachPingListener(root3, wakeable, lanes) {
      var pingCache = root3.pingCache;
      if (null === pingCache) {
        pingCache = root3.pingCache = new PossiblyWeakMap();
        var threadIDs = /* @__PURE__ */ new Set();
        pingCache.set(wakeable, threadIDs);
      } else
        threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = /* @__PURE__ */ new Set(), pingCache.set(wakeable, threadIDs));
      threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = true, threadIDs.add(lanes), pingCache = pingSuspendedRoot.bind(null, root3, wakeable, lanes), isDevToolsPresent && restorePendingUpdaters(root3, lanes), wakeable.then(pingCache, pingCache));
    }
    function pingSuspendedRoot(root3, wakeable, pingedLanes) {
      var pingCache = root3.pingCache;
      null !== pingCache && pingCache.delete(wakeable);
      root3.pingedLanes |= root3.suspendedLanes & pingedLanes;
      root3.warmLanes &= ~pingedLanes;
      0 !== (pingedLanes & 127) ? 0 > blockingUpdateTime && (blockingClampTime = blockingUpdateTime = now2(), blockingUpdateTask = createTask("Promise Resolved"), blockingUpdateType = PINGED_UPDATE) : 0 !== (pingedLanes & 4194048) && 0 > transitionUpdateTime && (transitionClampTime = transitionUpdateTime = now2(), transitionUpdateTask = createTask("Promise Resolved"), transitionUpdateType = PINGED_UPDATE);
      isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && console.error(
        "A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act"
      );
      workInProgressRoot === root3 && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && now$12() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS ? (executionContext & RenderContext) === NoContext && prepareFreshStack(root3, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
      ensureRootIsScheduled(root3);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
      0 === retryLane && (retryLane = claimNextRetryLane());
      boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
      null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
      var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
      null !== suspenseState && (retryLane = suspenseState.retryLane);
      retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
      var retryLane = 0;
      switch (boundaryFiber.tag) {
        case 31:
        case 13:
          var retryCache = boundaryFiber.stateNode;
          var suspenseState = boundaryFiber.memoizedState;
          null !== suspenseState && (retryLane = suspenseState.retryLane);
          break;
        case 19:
          retryCache = boundaryFiber.stateNode;
          break;
        case 22:
          retryCache = boundaryFiber.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      null !== retryCache && retryCache.delete(wakeable);
      retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(root$jscomp$0, parentFiber, isInStrictMode) {
      if (0 !== (parentFiber.subtreeFlags & 67117056))
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var root3 = root$jscomp$0, fiber = parentFiber, isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
          isStrictModeFiber = isInStrictMode || isStrictModeFiber;
          22 !== fiber.tag ? fiber.flags & 67108864 ? isStrictModeFiber && runWithFiberInDEV(
            fiber,
            doubleInvokeEffectsOnFiber,
            root3,
            fiber
          ) : recursivelyTraverseAndDoubleInvokeEffectsInDEV(
            root3,
            fiber,
            isStrictModeFiber
          ) : null === fiber.memoizedState && (isStrictModeFiber && fiber.flags & 8192 ? runWithFiberInDEV(
            fiber,
            doubleInvokeEffectsOnFiber,
            root3,
            fiber
          ) : fiber.subtreeFlags & 67108864 && runWithFiberInDEV(
            fiber,
            recursivelyTraverseAndDoubleInvokeEffectsInDEV,
            root3,
            fiber,
            isStrictModeFiber
          ));
          parentFiber = parentFiber.sibling;
        }
    }
    function doubleInvokeEffectsOnFiber(root3, fiber) {
      setIsStrictModeForDevtools(true);
      try {
        disappearLayoutEffects(fiber), disconnectPassiveEffect(fiber), reappearLayoutEffects(root3, fiber.alternate, fiber, false), reconnectPassiveEffects(root3, fiber, 0, null, false, 0);
      } finally {
        setIsStrictModeForDevtools(false);
      }
    }
    function commitDoubleInvokeEffectsInDEV(root3) {
      var doubleInvokeEffects = true;
      root3.current.mode & (StrictLegacyMode | StrictEffectsMode) || (doubleInvokeEffects = false);
      recursivelyTraverseAndDoubleInvokeEffectsInDEV(
        root3,
        root3.current,
        doubleInvokeEffects
      );
    }
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
      if ((executionContext & RenderContext) === NoContext) {
        var tag2 = fiber.tag;
        if (3 === tag2 || 1 === tag2 || 0 === tag2 || 11 === tag2 || 14 === tag2 || 15 === tag2) {
          tag2 = getComponentNameFromFiber(fiber) || "ReactComponent";
          if (null !== didWarnStateUpdateForNotYetMountedComponent) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(tag2)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(tag2);
          } else didWarnStateUpdateForNotYetMountedComponent = /* @__PURE__ */ new Set([tag2]);
          runWithFiberInDEV(fiber, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function restorePendingUpdaters(root3, lanes) {
      isDevToolsPresent && root3.memoizedUpdaters.forEach(function(schedulingFiber) {
        addFiberToLanesMap(root3, schedulingFiber, lanes);
      });
    }
    function scheduleCallback$1(priorityLevel, callback) {
      var actQueue = ReactSharedInternals.actQueue;
      return null !== actQueue ? (actQueue.push(callback), fakeActCallbackNode$1) : scheduleCallback$3(priorityLevel, callback);
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
      isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && runWithFiberInDEV(fiber, function() {
        console.error(
          "An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act",
          getComponentNameFromFiber(fiber)
        );
      });
    }
    function ensureRootIsScheduled(root3) {
      root3 !== lastScheduledRoot && null === root3.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root3 : lastScheduledRoot = lastScheduledRoot.next = root3);
      mightHavePendingSyncWork = true;
      null !== ReactSharedInternals.actQueue ? didScheduleMicrotask_act || (didScheduleMicrotask_act = true, scheduleImmediateRootScheduleTask()) : didScheduleMicrotask || (didScheduleMicrotask = true, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
      if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = true;
        do {
          var didPerformSomeWork = false;
          for (var root3 = firstScheduledRoot; null !== root3; ) {
            if (0 !== syncTransitionLanes) {
              var pendingLanes = root3.pendingLanes;
              if (0 === pendingLanes) var nextLanes = 0;
              else {
                var suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes;
                nextLanes = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                nextLanes = nextLanes & 201326741 ? nextLanes & 201326741 | 1 : nextLanes ? nextLanes | 2 : 0;
              }
              0 !== nextLanes && (didPerformSomeWork = true, performSyncWorkOnRoot(root3, nextLanes));
            } else
              nextLanes = workInProgressRootRenderLanes, nextLanes = getNextLanes(
                root3,
                root3 === workInProgressRoot ? nextLanes : 0,
                null !== root3.cancelPendingCommit || root3.timeoutHandle !== noTimeout
              ), 0 === (nextLanes & 3) || checkIfRootIsPrerendering(root3, nextLanes) || (didPerformSomeWork = true, performSyncWorkOnRoot(root3, nextLanes));
            root3 = root3.next;
          }
        } while (didPerformSomeWork);
        isFlushingWork = false;
      }
    }
    function processRootScheduleInImmediateTask() {
      schedulerEvent = window.event;
      processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
      mightHavePendingSyncWork = didScheduleMicrotask_act = didScheduleMicrotask = false;
      var syncTransitionLanes = 0;
      0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
      for (var currentTime = now$12(), prev = null, root3 = firstScheduledRoot; null !== root3; ) {
        var next = root3.next, nextLanes = scheduleTaskForRootDuringMicrotask(root3, currentTime);
        if (0 === nextLanes)
          root3.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root3, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
          mightHavePendingSyncWork = true;
        root3 = next;
      }
      pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE || flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
      0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
    }
    function scheduleTaskForRootDuringMicrotask(root3, currentTime) {
      for (var suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes, expirationTimes = root3.expirationTimes, lanes = root3.pendingLanes & -62914561; 0 < lanes; ) {
        var index2 = 31 - clz32(lanes), lane = 1 << index2, expirationTime = expirationTimes[index2];
        if (-1 === expirationTime) {
          if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
            expirationTimes[index2] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root3.expiredLanes |= lane);
        lanes &= ~lane;
      }
      currentTime = workInProgressRoot;
      suspendedLanes = workInProgressRootRenderLanes;
      suspendedLanes = getNextLanes(
        root3,
        root3 === currentTime ? suspendedLanes : 0,
        null !== root3.cancelPendingCommit || root3.timeoutHandle !== noTimeout
      );
      pingedLanes = root3.callbackNode;
      if (0 === suspendedLanes || root3 === currentTime && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root3.cancelPendingCommit)
        return null !== pingedLanes && cancelCallback(pingedLanes), root3.callbackNode = null, root3.callbackPriority = 0;
      if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root3, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime !== root3.callbackPriority || null !== ReactSharedInternals.actQueue && pingedLanes !== fakeActCallbackNode)
          cancelCallback(pingedLanes);
        else return currentTime;
        switch (lanesToEventPriority(suspendedLanes)) {
          case DiscreteEventPriority:
          case ContinuousEventPriority:
            suspendedLanes = UserBlockingPriority;
            break;
          case DefaultEventPriority:
            suspendedLanes = NormalPriority$1;
            break;
          case IdleEventPriority:
            suspendedLanes = IdlePriority;
            break;
          default:
            suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root3);
        null !== ReactSharedInternals.actQueue ? (ReactSharedInternals.actQueue.push(pingedLanes), suspendedLanes = fakeActCallbackNode) : suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root3.callbackPriority = currentTime;
        root3.callbackNode = suspendedLanes;
        return currentTime;
      }
      null !== pingedLanes && cancelCallback(pingedLanes);
      root3.callbackPriority = 2;
      root3.callbackNode = null;
      return 2;
    }
    function performWorkOnRootViaSchedulerTask(root3, didTimeout) {
      nestedUpdateScheduled = currentUpdateIsNested = false;
      schedulerEvent = window.event;
      if (pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE)
        return root3.callbackNode = null, root3.callbackPriority = 0, null;
      var originalCallbackNode = root3.callbackNode;
      pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
      if (flushPendingEffects() && root3.callbackNode !== originalCallbackNode)
        return null;
      var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
      workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
        root3,
        root3 === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
        null !== root3.cancelPendingCommit || root3.timeoutHandle !== noTimeout
      );
      if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
      performWorkOnRoot(
        root3,
        workInProgressRootRenderLanes$jscomp$0,
        didTimeout
      );
      scheduleTaskForRootDuringMicrotask(root3, now$12());
      return null != root3.callbackNode && root3.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root3) : null;
    }
    function performSyncWorkOnRoot(root3, lanes) {
      if (flushPendingEffects()) return null;
      currentUpdateIsNested = nestedUpdateScheduled;
      nestedUpdateScheduled = false;
      performWorkOnRoot(root3, lanes, true);
    }
    function cancelCallback(callbackNode) {
      callbackNode !== fakeActCallbackNode && null !== callbackNode && cancelCallback$1(callbackNode);
    }
    function scheduleImmediateRootScheduleTask() {
      null !== ReactSharedInternals.actQueue && ReactSharedInternals.actQueue.push(function() {
        processRootScheduleInMicrotask();
        return null;
      });
      scheduleMicrotask(function() {
        (executionContext & (RenderContext | CommitContext)) !== NoContext ? scheduleCallback$3(
          ImmediatePriority,
          processRootScheduleInImmediateTask
        ) : processRootScheduleInMicrotask();
      });
    }
    function requestTransitionLane() {
      if (0 === currentEventTransitionLane) {
        var actionScopeLane = currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
        currentEventTransitionLane = actionScopeLane;
      }
      return currentEventTransitionLane;
    }
    function coerceFormActionProp(actionProp) {
      if (null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp)
        return null;
      if ("function" === typeof actionProp) return actionProp;
      checkAttributeStringCoercion(actionProp, "action");
      return sanitizeURL("" + actionProp);
    }
    function createFormDataWithSubmitter(form, submitter) {
      var temp = submitter.ownerDocument.createElement("input");
      temp.name = submitter.name;
      temp.value = submitter.value;
      form.id && temp.setAttribute("form", form.id);
      submitter.parentNode.insertBefore(temp, submitter);
      form = new FormData(form);
      temp.parentNode.removeChild(temp);
      return form;
    }
    function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
      if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp(
          (nativeEventTarget[internalPropsKey] || null).action
        ), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent(
          "action",
          "action",
          null,
          nativeEvent,
          nativeEventTarget
        );
        dispatchQueue.push({
          event,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (nativeEvent.defaultPrevented) {
                  if (0 !== currentEventTransitionLane) {
                    var formData = submitter ? createFormDataWithSubmitter(
                      nativeEventTarget,
                      submitter
                    ) : new FormData(nativeEventTarget), pendingState = {
                      pending: true,
                      data: formData,
                      method: nativeEventTarget.method,
                      action
                    };
                    Object.freeze(pendingState);
                    startHostTransition(
                      maybeTargetInst,
                      pendingState,
                      null,
                      formData
                    );
                  }
                } else
                  "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(
                    nativeEventTarget,
                    submitter
                  ) : new FormData(nativeEventTarget), pendingState = {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action
                  }, Object.freeze(pendingState), startHostTransition(
                    maybeTargetInst,
                    pendingState,
                    action,
                    formData
                  ));
              },
              currentTarget: nativeEventTarget
            }
          ]
        });
      }
    }
    function executeDispatch(event, listener, currentTarget) {
      event.currentTarget = currentTarget;
      try {
        listener(event);
      } catch (error) {
        reportGlobalError(error);
      }
      event.currentTarget = null;
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
      eventSystemFlags = 0 !== (eventSystemFlags & 4);
      for (var i2 = 0; i2 < dispatchQueue.length; i2++) {
        var _dispatchQueue$i = dispatchQueue[i2];
        a: {
          var previousInstance = void 0, event = _dispatchQueue$i.event;
          _dispatchQueue$i = _dispatchQueue$i.listeners;
          if (eventSystemFlags)
            for (var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--) {
              var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
              _dispatchListeners$i = _dispatchListeners$i.listener;
              if (instance !== previousInstance && event.isPropagationStopped())
                break a;
              null !== instance ? runWithFiberInDEV(
                instance,
                executeDispatch,
                event,
                _dispatchListeners$i,
                currentTarget
              ) : executeDispatch(event, _dispatchListeners$i, currentTarget);
              previousInstance = instance;
            }
          else
            for (i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++) {
              _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
              instance = _dispatchListeners$i.instance;
              currentTarget = _dispatchListeners$i.currentTarget;
              _dispatchListeners$i = _dispatchListeners$i.listener;
              if (instance !== previousInstance && event.isPropagationStopped())
                break a;
              null !== instance ? runWithFiberInDEV(
                instance,
                executeDispatch,
                event,
                _dispatchListeners$i,
                currentTarget
              ) : executeDispatch(event, _dispatchListeners$i, currentTarget);
              previousInstance = instance;
            }
        }
      }
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
      nonDelegatedEvents.has(domEventName) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        domEventName
      );
      var listenerSet = targetElement[internalEventHandlersKey];
      void 0 === listenerSet && (listenerSet = targetElement[internalEventHandlersKey] = /* @__PURE__ */ new Set());
      var listenerSetKey = domEventName + "__bubble";
      listenerSet.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, false), listenerSet.add(listenerSetKey));
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
      nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        domEventName
      );
      var eventSystemFlags = 0;
      isCapturePhaseListener && (eventSystemFlags |= 4);
      addTrappedEventListener(
        target,
        domEventName,
        eventSystemFlags,
        isCapturePhaseListener
      );
    }
    function listenToAllSupportedEvents(rootContainerElement) {
      if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = true;
        allNativeEvents.forEach(function(domEventName) {
          "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, false, rootContainerElement), listenToNativeEvent(domEventName, true, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = true, listenToNativeEvent("selectionchange", false, ownerDocument));
      }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
      switch (getEventPriority(domEventName)) {
        case DiscreteEventPriority:
          var listenerWrapper = dispatchDiscreteEvent;
          break;
        case ContinuousEventPriority:
          listenerWrapper = dispatchContinuousEvent;
          break;
        default:
          listenerWrapper = dispatchEvent;
      }
      eventSystemFlags = listenerWrapper.bind(
        null,
        domEventName,
        eventSystemFlags,
        targetContainer
      );
      listenerWrapper = void 0;
      !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = true);
      isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: true,
        passive: listenerWrapper
      }) : targetContainer.addEventListener(domEventName, eventSystemFlags, true) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
      }) : targetContainer.addEventListener(
        domEventName,
        eventSystemFlags,
        false
      );
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
      var ancestorInst = targetInst$jscomp$0;
      if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0)
        a: for (; ; ) {
          if (null === targetInst$jscomp$0) return;
          var nodeTag = targetInst$jscomp$0.tag;
          if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag)
              for (nodeTag = targetInst$jscomp$0.return; null !== nodeTag; ) {
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer)
                  return;
                nodeTag = nodeTag.return;
              }
            for (; null !== container; ) {
              nodeTag = getClosestInstanceFromNode(container);
              if (null === nodeTag) return;
              grandTag = nodeTag.tag;
              if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                targetInst$jscomp$0 = ancestorInst = nodeTag;
                continue a;
              }
              container = container.parentNode;
            }
          }
          targetInst$jscomp$0 = targetInst$jscomp$0.return;
        }
      batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
          var reactName = topLevelEventsToReactNames.get(domEventName);
          if (void 0 !== reactName) {
            var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
            switch (domEventName) {
              case "keypress":
                if (0 === getEventCharCode(nativeEvent)) break a;
              case "keydown":
              case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
              case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "beforeblur":
              case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "click":
                if (2 === nativeEvent.button) break a;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
              case ANIMATION_END:
              case ANIMATION_ITERATION:
              case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
              case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
              case "scroll":
              case "scrollend":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
              case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
              case "copy":
              case "cut":
              case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
              case "toggle":
              case "beforetoggle":
                SyntheticEventCtor = SyntheticToggleEvent;
            }
            var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
            inCapturePhase = [];
            for (var instance = targetInst, lastHostComponent; null !== instance; ) {
              var _instance2 = instance;
              lastHostComponent = _instance2.stateNode;
              _instance2 = _instance2.tag;
              5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === lastHostComponent || null === reactEventName || (_instance2 = getListener(instance, reactEventName), null != _instance2 && inCapturePhase.push(
                createDispatchListener(
                  instance,
                  _instance2,
                  lastHostComponent
                )
              ));
              if (accumulateTargetOnly) break;
              instance = instance.return;
            }
            0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(
              reactName,
              reactEventType,
              null,
              nativeEvent,
              nativeEventTarget
            ), dispatchQueue.push({
              event: reactName,
              listeners: inCapturePhase
            }));
          }
        }
        if (0 === (eventSystemFlags & 7)) {
          a: {
            reactName = "mouseover" === domEventName || "pointerover" === domEventName;
            SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
            if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey]))
              break a;
            if (SyntheticEventCtor || reactName) {
              reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
              if (SyntheticEventCtor) {
                if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase))
                  reactEventType = null;
              } else SyntheticEventCtor = null, reactEventType = targetInst;
              if (SyntheticEventCtor !== reactEventType) {
                inCapturePhase = SyntheticMouseEvent;
                _instance2 = "onMouseLeave";
                reactEventName = "onMouseEnter";
                instance = "mouse";
                if ("pointerout" === domEventName || "pointerover" === domEventName)
                  inCapturePhase = SyntheticPointerEvent, _instance2 = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                reactName = new inCapturePhase(
                  _instance2,
                  instance + "leave",
                  SyntheticEventCtor,
                  nativeEvent,
                  nativeEventTarget
                );
                reactName.target = accumulateTargetOnly;
                reactName.relatedTarget = lastHostComponent;
                _instance2 = null;
                getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(
                  reactEventName,
                  instance + "enter",
                  reactEventType,
                  nativeEvent,
                  nativeEventTarget
                ), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance2 = inCapturePhase);
                accumulateTargetOnly = _instance2;
                if (SyntheticEventCtor && reactEventType)
                  b: {
                    inCapturePhase = getParent;
                    reactEventName = SyntheticEventCtor;
                    instance = reactEventType;
                    lastHostComponent = 0;
                    for (_instance2 = reactEventName; _instance2; _instance2 = inCapturePhase(_instance2))
                      lastHostComponent++;
                    _instance2 = 0;
                    for (var tempB = instance; tempB; tempB = inCapturePhase(tempB))
                      _instance2++;
                    for (; 0 < lastHostComponent - _instance2; )
                      reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                    for (; 0 < _instance2 - lastHostComponent; )
                      instance = inCapturePhase(instance), _instance2--;
                    for (; lastHostComponent--; ) {
                      if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                        inCapturePhase = reactEventName;
                        break b;
                      }
                      reactEventName = inCapturePhase(reactEventName);
                      instance = inCapturePhase(instance);
                    }
                    inCapturePhase = null;
                  }
                else inCapturePhase = null;
                null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(
                  dispatchQueue,
                  reactName,
                  SyntheticEventCtor,
                  inCapturePhase,
                  false
                );
                null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(
                  dispatchQueue,
                  accumulateTargetOnly,
                  reactEventType,
                  inCapturePhase,
                  true
                );
              }
            }
          }
          a: {
            reactName = targetInst ? getNodeFromInstance(targetInst) : window;
            SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
            if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type)
              var getTargetInstFunc = getTargetInstForChangeEvent;
            else if (isTextInputElement(reactName))
              if (isInputEventSupported)
                getTargetInstFunc = getTargetInstForInputOrChangeEvent;
              else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                var handleEventFunc = handleEventsForInputEventPolyfill;
              }
            else
              SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
            if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
              createAndAccumulateChangeEvent(
                dispatchQueue,
                getTargetInstFunc,
                nativeEvent,
                nativeEventTarget
              );
              break a;
            }
            handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
          }
          handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
          switch (domEventName) {
            case "focusin":
              if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable)
                activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
              break;
            case "focusout":
              lastSelection = activeElementInst = activeElement = null;
              break;
            case "mousedown":
              mouseDown = true;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              mouseDown = false;
              constructSelectEvent(
                dispatchQueue,
                nativeEvent,
                nativeEventTarget
              );
              break;
            case "selectionchange":
              if (skipSelectionChangeEvent) break;
            case "keydown":
            case "keyup":
              constructSelectEvent(
                dispatchQueue,
                nativeEvent,
                nativeEventTarget
              );
          }
          var fallbackData;
          if (canUseCompositionEvent)
            b: {
              switch (domEventName) {
                case "compositionstart":
                  var eventType = "onCompositionStart";
                  break b;
                case "compositionend":
                  eventType = "onCompositionEnd";
                  break b;
                case "compositionupdate":
                  eventType = "onCompositionUpdate";
                  break b;
              }
              eventType = void 0;
            }
          else
            isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && nativeEvent.keyCode === START_KEYCODE && (eventType = "onCompositionStart");
          eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root2 = nativeEventTarget, startText = "value" in root2 ? root2.value : root2.textContent, isComposing = true)), handleEventFunc = accumulateTwoPhaseListeners(
            targetInst,
            eventType
          ), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(
            eventType,
            domEventName,
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({
            event: eventType,
            listeners: handleEventFunc
          }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
          if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent))
            eventType = accumulateTwoPhaseListeners(
              targetInst,
              "onBeforeInput"
            ), 0 < eventType.length && (handleEventFunc = new SyntheticInputEvent(
              "onBeforeInput",
              "beforeinput",
              null,
              nativeEvent,
              nativeEventTarget
            ), dispatchQueue.push({
              event: handleEventFunc,
              listeners: eventType
            }), handleEventFunc.data = fallbackData);
          extractEvents$1(
            dispatchQueue,
            domEventName,
            targetInst,
            nativeEvent,
            nativeEventTarget
          );
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
      });
    }
    function createDispatchListener(instance, listener, currentTarget) {
      return {
        instance,
        listener,
        currentTarget
      };
    }
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
      for (var captureName = reactName + "Capture", listeners = []; null !== targetFiber; ) {
        var _instance3 = targetFiber, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (_instance3 = getListener(targetFiber, captureName), null != _instance3 && listeners.unshift(
          createDispatchListener(targetFiber, _instance3, stateNode)
        ), _instance3 = getListener(targetFiber, reactName), null != _instance3 && listeners.push(
          createDispatchListener(targetFiber, _instance3, stateNode)
        ));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
      }
      return [];
    }
    function getParent(inst) {
      if (null === inst) return null;
      do
        inst = inst.return;
      while (inst && 5 !== inst.tag && 27 !== inst.tag);
      return inst ? inst : null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
      for (var registrationName = event._reactName, listeners = []; null !== target && target !== common; ) {
        var _instance4 = target, alternate = _instance4.alternate, stateNode = _instance4.stateNode;
        _instance4 = _instance4.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance4 && 26 !== _instance4 && 27 !== _instance4 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(
          createDispatchListener(target, stateNode, alternate)
        )) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(
          createDispatchListener(target, stateNode, alternate)
        )));
        target = target.return;
      }
      0 !== listeners.length && dispatchQueue.push({ event, listeners });
    }
    function validatePropertiesInDevelopment(type, props2) {
      validateProperties$2(type, props2);
      "input" !== type && "textarea" !== type && "select" !== type || null == props2 || null !== props2.value || didWarnValueNull || (didWarnValueNull = true, "select" === type && props2.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        type
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        type
      ));
      var eventRegistry = {
        registrationNameDependencies,
        possibleRegistrationNames
      };
      isCustomElement(type) || "string" === typeof props2.is || warnUnknownProperties(type, props2, eventRegistry);
      props2.contentEditable && !props2.suppressContentEditableWarning && null != props2.children && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function warnForPropDifference(propName, serverValue, clientValue, serverDifferences) {
      serverValue !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(serverValue) !== clientValue && (serverDifferences[propName] = serverValue));
    }
    function warnForExtraAttributes(domElement, attributeNames, serverDifferences) {
      attributeNames.forEach(function(attributeName) {
        serverDifferences[getPropNameFromAttributeName(attributeName)] = "style" === attributeName ? getStylesObjectFromElement(domElement) : domElement.getAttribute(attributeName);
      });
    }
    function warnForInvalidEventListener(registrationName, listener) {
      false === listener ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        registrationName,
        registrationName,
        registrationName
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        registrationName,
        typeof listener
      );
    }
    function normalizeHTML(parent, html) {
      parent = parent.namespaceURI === MATH_NAMESPACE || parent.namespaceURI === SVG_NAMESPACE ? parent.ownerDocument.createElementNS(
        parent.namespaceURI,
        parent.tagName
      ) : parent.ownerDocument.createElement(parent.tagName);
      parent.innerHTML = html;
      return parent.innerHTML;
    }
    function normalizeMarkupForTextOrAttribute(markup) {
      willCoercionThrow(markup) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        typeName2(markup)
      ), testStringCoercion(markup));
      return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText) {
      clientText = normalizeMarkupForTextOrAttribute(clientText);
      return normalizeMarkupForTextOrAttribute(serverText) === clientText ? true : false;
    }
    function setProp(domElement, tag2, key, value, props2, prevValue) {
      switch (key) {
        case "children":
          if ("string" === typeof value)
            validateTextNesting(value, tag2, false), "body" === tag2 || "textarea" === tag2 && "" === value || setTextContent(domElement, value);
          else if ("number" === typeof value || "bigint" === typeof value)
            validateTextNesting("" + value, tag2, false), "body" !== tag2 && setTextContent(domElement, "" + value);
          break;
        case "className":
          setValueForKnownAttribute(domElement, "class", value);
          break;
        case "tabIndex":
          setValueForKnownAttribute(domElement, "tabindex", value);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          setValueForKnownAttribute(domElement, key, value);
          break;
        case "style":
          setValueForStyles(domElement, value, prevValue);
          break;
        case "data":
          if ("object" !== tag2) {
            setValueForKnownAttribute(domElement, "data", value);
            break;
          }
        case "src":
        case "href":
          if ("" === value && ("a" !== tag2 || "href" !== key)) {
            "src" === key ? console.error(
              'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              key,
              key
            ) : console.error(
              'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              key,
              key
            );
            domElement.removeAttribute(key);
            break;
          }
          if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
            domElement.removeAttribute(key);
            break;
          }
          checkAttributeStringCoercion(value, key);
          value = sanitizeURL("" + value);
          domElement.setAttribute(key, value);
          break;
        case "action":
        case "formAction":
          null != value && ("form" === tag2 ? "formAction" === key ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : "function" === typeof value && (null == props2.encType && null == props2.method || didWarnFormActionMethod || (didWarnFormActionMethod = true, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), null == props2.target || didWarnFormActionTarget || (didWarnFormActionTarget = true, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : "input" === tag2 || "button" === tag2 ? "action" === key ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : "input" !== tag2 || "submit" === props2.type || "image" === props2.type || didWarnFormActionType ? "button" !== tag2 || null == props2.type || "submit" === props2.type || didWarnFormActionType ? "function" === typeof value && (null == props2.name || didWarnFormActionName || (didWarnFormActionName = true, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), null == props2.formEncType && null == props2.formMethod || didWarnFormActionMethod || (didWarnFormActionMethod = true, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), null == props2.formTarget || didWarnFormActionTarget || (didWarnFormActionTarget = true, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (didWarnFormActionType = true, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (didWarnFormActionType = true, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : "action" === key ? console.error(
            "You can only pass the action prop to <form>."
          ) : console.error(
            "You can only pass the formAction prop to <input> or <button>."
          ));
          if ("function" === typeof value) {
            domElement.setAttribute(
              key,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag2 && setProp(domElement, tag2, "name", props2.name, props2, null), setProp(
              domElement,
              tag2,
              "formEncType",
              props2.formEncType,
              props2,
              null
            ), setProp(
              domElement,
              tag2,
              "formMethod",
              props2.formMethod,
              props2,
              null
            ), setProp(
              domElement,
              tag2,
              "formTarget",
              props2.formTarget,
              props2,
              null
            )) : (setProp(
              domElement,
              tag2,
              "encType",
              props2.encType,
              props2,
              null
            ), setProp(domElement, tag2, "method", props2.method, props2, null), setProp(
              domElement,
              tag2,
              "target",
              props2.target,
              props2,
              null
            )));
          if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
            domElement.removeAttribute(key);
            break;
          }
          checkAttributeStringCoercion(value, key);
          value = sanitizeURL("" + value);
          domElement.setAttribute(key, value);
          break;
        case "onClick":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$12);
          break;
        case "onScroll":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
          break;
        case "onScrollEnd":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
          break;
        case "dangerouslySetInnerHTML":
          if (null != value) {
            if ("object" !== typeof value || !("__html" in value))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            key = value.__html;
            if (null != key) {
              if (null != props2.children)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              domElement.innerHTML = key;
            }
          }
          break;
        case "multiple":
          domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
          break;
        case "muted":
          domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
            domElement.removeAttribute("xlink:href");
            break;
          }
          checkAttributeStringCoercion(value, key);
          key = sanitizeURL("" + value);
          domElement.setAttributeNS(xlinkNamespace, "xlink:href", key);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, "" + value)) : domElement.removeAttribute(key);
          break;
        case "inert":
          "" !== value || didWarnForNewBooleanPropsWithEmptyValue[key] || (didWarnForNewBooleanPropsWithEmptyValue[key] = true, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            key
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
          break;
        case "capture":
        case "download":
          true === value ? domElement.setAttribute(key, "") : false !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
          break;
        case "rowSpan":
        case "start":
          null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value));
          break;
        case "popover":
          listenToNonDelegatedEvent("beforetoggle", domElement);
          listenToNonDelegatedEvent("toggle", domElement);
          setValueForAttribute(domElement, "popover", value);
          break;
        case "xlinkActuate":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:actuate",
            value
          );
          break;
        case "xlinkArcrole":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:arcrole",
            value
          );
          break;
        case "xlinkRole":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:role",
            value
          );
          break;
        case "xlinkShow":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:show",
            value
          );
          break;
        case "xlinkTitle":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:title",
            value
          );
          break;
        case "xlinkType":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:type",
            value
          );
          break;
        case "xmlBase":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:base",
            value
          );
          break;
        case "xmlLang":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:lang",
            value
          );
          break;
        case "xmlSpace":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:space",
            value
          );
          break;
        case "is":
          null != prevValue && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          );
          setValueForAttribute(domElement, "is", value);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          didWarnPopoverTargetObject || null == value || "object" !== typeof value || (didWarnPopoverTargetObject = true, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            value
          ));
        default:
          !(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1] ? (key = getAttributeAlias(key), setValueForAttribute(domElement, key, value)) : registrationNameDependencies.hasOwnProperty(key) && null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
      }
    }
    function setPropOnCustomElement(domElement, tag2, key, value, props2, prevValue) {
      switch (key) {
        case "style":
          setValueForStyles(domElement, value, prevValue);
          break;
        case "dangerouslySetInnerHTML":
          if (null != value) {
            if ("object" !== typeof value || !("__html" in value))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            key = value.__html;
            if (null != key) {
              if (null != props2.children)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              domElement.innerHTML = key;
            }
          }
          break;
        case "children":
          "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
          break;
        case "onScroll":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
          break;
        case "onScrollEnd":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
          break;
        case "onClick":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$12);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (registrationNameDependencies.hasOwnProperty(key))
            null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
          else
            a: {
              if ("o" === key[0] && "n" === key[1] && (props2 = key.endsWith("Capture"), tag2 = key.slice(2, props2 ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag2, prevValue, props2), "function" === typeof value)) {
                "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                domElement.addEventListener(tag2, value, props2);
                break a;
              }
              key in domElement ? domElement[key] = value : true === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
      }
    }
    function setInitialProperties(domElement, tag2, props2) {
      validatePropertiesInDevelopment(tag2, props2);
      switch (tag2) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          listenToNonDelegatedEvent("error", domElement);
          listenToNonDelegatedEvent("load", domElement);
          var hasSrc = false, hasSrcSet = false, propKey;
          for (propKey in props2)
            if (props2.hasOwnProperty(propKey)) {
              var propValue = props2[propKey];
              if (null != propValue)
                switch (propKey) {
                  case "src":
                    hasSrc = true;
                    break;
                  case "srcSet":
                    hasSrcSet = true;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    setProp(domElement, tag2, propKey, propValue, props2, null);
                }
            }
          hasSrcSet && setProp(domElement, tag2, "srcSet", props2.srcSet, props2, null);
          hasSrc && setProp(domElement, tag2, "src", props2.src, props2, null);
          return;
        case "input":
          checkControlledValueProps("input", props2);
          listenToNonDelegatedEvent("invalid", domElement);
          var defaultValue2 = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
          for (hasSrc in props2)
            if (props2.hasOwnProperty(hasSrc)) {
              var _propValue = props2[hasSrc];
              if (null != _propValue)
                switch (hasSrc) {
                  case "name":
                    hasSrcSet = _propValue;
                    break;
                  case "type":
                    propValue = _propValue;
                    break;
                  case "checked":
                    checked = _propValue;
                    break;
                  case "defaultChecked":
                    defaultChecked = _propValue;
                    break;
                  case "value":
                    propKey = _propValue;
                    break;
                  case "defaultValue":
                    defaultValue2 = _propValue;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (null != _propValue)
                      throw Error(
                        tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    setProp(domElement, tag2, hasSrc, _propValue, props2, null);
                }
            }
          validateInputProps(domElement, props2);
          initInput(
            domElement,
            propKey,
            defaultValue2,
            checked,
            defaultChecked,
            propValue,
            hasSrcSet,
            false
          );
          return;
        case "select":
          checkControlledValueProps("select", props2);
          listenToNonDelegatedEvent("invalid", domElement);
          hasSrc = propValue = propKey = null;
          for (hasSrcSet in props2)
            if (props2.hasOwnProperty(hasSrcSet) && (defaultValue2 = props2[hasSrcSet], null != defaultValue2))
              switch (hasSrcSet) {
                case "value":
                  propKey = defaultValue2;
                  break;
                case "defaultValue":
                  propValue = defaultValue2;
                  break;
                case "multiple":
                  hasSrc = defaultValue2;
                default:
                  setProp(
                    domElement,
                    tag2,
                    hasSrcSet,
                    defaultValue2,
                    props2,
                    null
                  );
              }
          validateSelectProps(domElement, props2);
          tag2 = propKey;
          props2 = propValue;
          domElement.multiple = !!hasSrc;
          null != tag2 ? updateOptions(domElement, !!hasSrc, tag2, false) : null != props2 && updateOptions(domElement, !!hasSrc, props2, true);
          return;
        case "textarea":
          checkControlledValueProps("textarea", props2);
          listenToNonDelegatedEvent("invalid", domElement);
          propKey = hasSrcSet = hasSrc = null;
          for (propValue in props2)
            if (props2.hasOwnProperty(propValue) && (defaultValue2 = props2[propValue], null != defaultValue2))
              switch (propValue) {
                case "value":
                  hasSrc = defaultValue2;
                  break;
                case "defaultValue":
                  hasSrcSet = defaultValue2;
                  break;
                case "children":
                  propKey = defaultValue2;
                  break;
                case "dangerouslySetInnerHTML":
                  if (null != defaultValue2)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  setProp(
                    domElement,
                    tag2,
                    propValue,
                    defaultValue2,
                    props2,
                    null
                  );
              }
          validateTextareaProps(domElement, props2);
          initTextarea(domElement, hasSrc, hasSrcSet, propKey);
          return;
        case "option":
          validateOptionProps(domElement, props2);
          for (checked in props2)
            if (props2.hasOwnProperty(checked) && (hasSrc = props2[checked], null != hasSrc))
              switch (checked) {
                case "selected":
                  domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                  break;
                default:
                  setProp(domElement, tag2, checked, hasSrc, props2, null);
              }
          return;
        case "dialog":
          listenToNonDelegatedEvent("beforetoggle", domElement);
          listenToNonDelegatedEvent("toggle", domElement);
          listenToNonDelegatedEvent("cancel", domElement);
          listenToNonDelegatedEvent("close", domElement);
          break;
        case "iframe":
        case "object":
          listenToNonDelegatedEvent("load", domElement);
          break;
        case "video":
        case "audio":
          for (hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)
            listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
          break;
        case "image":
          listenToNonDelegatedEvent("error", domElement);
          listenToNonDelegatedEvent("load", domElement);
          break;
        case "details":
          listenToNonDelegatedEvent("toggle", domElement);
          break;
        case "embed":
        case "source":
        case "link":
          listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (defaultChecked in props2)
            if (props2.hasOwnProperty(defaultChecked) && (hasSrc = props2[defaultChecked], null != hasSrc))
              switch (defaultChecked) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  setProp(domElement, tag2, defaultChecked, hasSrc, props2, null);
              }
          return;
        default:
          if (isCustomElement(tag2)) {
            for (_propValue in props2)
              props2.hasOwnProperty(_propValue) && (hasSrc = props2[_propValue], void 0 !== hasSrc && setPropOnCustomElement(
                domElement,
                tag2,
                _propValue,
                hasSrc,
                props2,
                void 0
              ));
            return;
          }
      }
      for (defaultValue2 in props2)
        props2.hasOwnProperty(defaultValue2) && (hasSrc = props2[defaultValue2], null != hasSrc && setProp(domElement, tag2, defaultValue2, hasSrc, props2, null));
    }
    function updateProperties(domElement, tag2, lastProps, nextProps) {
      validatePropertiesInDevelopment(tag2, nextProps);
      switch (tag2) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var name2 = null, type = null, value = null, defaultValue2 = null, lastDefaultValue = null, checked = null, defaultChecked = null;
          for (propKey in lastProps) {
            var lastProp = lastProps[propKey];
            if (lastProps.hasOwnProperty(propKey) && null != lastProp)
              switch (propKey) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  lastDefaultValue = lastProp;
                default:
                  nextProps.hasOwnProperty(propKey) || setProp(
                    domElement,
                    tag2,
                    propKey,
                    null,
                    nextProps,
                    lastProp
                  );
              }
          }
          for (var _propKey8 in nextProps) {
            var propKey = nextProps[_propKey8];
            lastProp = lastProps[_propKey8];
            if (nextProps.hasOwnProperty(_propKey8) && (null != propKey || null != lastProp))
              switch (_propKey8) {
                case "type":
                  type = propKey;
                  break;
                case "name":
                  name2 = propKey;
                  break;
                case "checked":
                  checked = propKey;
                  break;
                case "defaultChecked":
                  defaultChecked = propKey;
                  break;
                case "value":
                  value = propKey;
                  break;
                case "defaultValue":
                  defaultValue2 = propKey;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != propKey)
                    throw Error(
                      tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  propKey !== lastProp && setProp(
                    domElement,
                    tag2,
                    _propKey8,
                    propKey,
                    nextProps,
                    lastProp
                  );
              }
          }
          tag2 = "checkbox" === lastProps.type || "radio" === lastProps.type ? null != lastProps.checked : null != lastProps.value;
          nextProps = "checkbox" === nextProps.type || "radio" === nextProps.type ? null != nextProps.checked : null != nextProps.value;
          tag2 || !nextProps || didWarnUncontrolledToControlled || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), didWarnUncontrolledToControlled = true);
          !tag2 || nextProps || didWarnControlledToUncontrolled || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), didWarnControlledToUncontrolled = true);
          updateInput(
            domElement,
            value,
            defaultValue2,
            lastDefaultValue,
            checked,
            defaultChecked,
            type,
            name2
          );
          return;
        case "select":
          propKey = value = defaultValue2 = _propKey8 = null;
          for (type in lastProps)
            if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue)
              switch (type) {
                case "value":
                  break;
                case "multiple":
                  propKey = lastDefaultValue;
                default:
                  nextProps.hasOwnProperty(type) || setProp(
                    domElement,
                    tag2,
                    type,
                    null,
                    nextProps,
                    lastDefaultValue
                  );
              }
          for (name2 in nextProps)
            if (type = nextProps[name2], lastDefaultValue = lastProps[name2], nextProps.hasOwnProperty(name2) && (null != type || null != lastDefaultValue))
              switch (name2) {
                case "value":
                  _propKey8 = type;
                  break;
                case "defaultValue":
                  defaultValue2 = type;
                  break;
                case "multiple":
                  value = type;
                default:
                  type !== lastDefaultValue && setProp(
                    domElement,
                    tag2,
                    name2,
                    type,
                    nextProps,
                    lastDefaultValue
                  );
              }
          nextProps = defaultValue2;
          tag2 = value;
          lastProps = propKey;
          null != _propKey8 ? updateOptions(domElement, !!tag2, _propKey8, false) : !!lastProps !== !!tag2 && (null != nextProps ? updateOptions(domElement, !!tag2, nextProps, true) : updateOptions(domElement, !!tag2, tag2 ? [] : "", false));
          return;
        case "textarea":
          propKey = _propKey8 = null;
          for (defaultValue2 in lastProps)
            if (name2 = lastProps[defaultValue2], lastProps.hasOwnProperty(defaultValue2) && null != name2 && !nextProps.hasOwnProperty(defaultValue2))
              switch (defaultValue2) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  setProp(domElement, tag2, defaultValue2, null, nextProps, name2);
              }
          for (value in nextProps)
            if (name2 = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name2 || null != type))
              switch (value) {
                case "value":
                  _propKey8 = name2;
                  break;
                case "defaultValue":
                  propKey = name2;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (null != name2)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  name2 !== type && setProp(domElement, tag2, value, name2, nextProps, type);
              }
          updateTextarea(domElement, _propKey8, propKey);
          return;
        case "option":
          for (var _propKey13 in lastProps)
            if (_propKey8 = lastProps[_propKey13], lastProps.hasOwnProperty(_propKey13) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey13))
              switch (_propKey13) {
                case "selected":
                  domElement.selected = false;
                  break;
                default:
                  setProp(
                    domElement,
                    tag2,
                    _propKey13,
                    null,
                    nextProps,
                    _propKey8
                  );
              }
          for (lastDefaultValue in nextProps)
            if (_propKey8 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && _propKey8 !== propKey && (null != _propKey8 || null != propKey))
              switch (lastDefaultValue) {
                case "selected":
                  domElement.selected = _propKey8 && "function" !== typeof _propKey8 && "symbol" !== typeof _propKey8;
                  break;
                default:
                  setProp(
                    domElement,
                    tag2,
                    lastDefaultValue,
                    _propKey8,
                    nextProps,
                    propKey
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var _propKey15 in lastProps)
            _propKey8 = lastProps[_propKey15], lastProps.hasOwnProperty(_propKey15) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey15) && setProp(
              domElement,
              tag2,
              _propKey15,
              null,
              nextProps,
              _propKey8
            );
          for (checked in nextProps)
            if (_propKey8 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && _propKey8 !== propKey && (null != _propKey8 || null != propKey))
              switch (checked) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != _propKey8)
                    throw Error(
                      tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  setProp(
                    domElement,
                    tag2,
                    checked,
                    _propKey8,
                    nextProps,
                    propKey
                  );
              }
          return;
        default:
          if (isCustomElement(tag2)) {
            for (var _propKey17 in lastProps)
              _propKey8 = lastProps[_propKey17], lastProps.hasOwnProperty(_propKey17) && void 0 !== _propKey8 && !nextProps.hasOwnProperty(_propKey17) && setPropOnCustomElement(
                domElement,
                tag2,
                _propKey17,
                void 0,
                nextProps,
                _propKey8
              );
            for (defaultChecked in nextProps)
              _propKey8 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || _propKey8 === propKey || void 0 === _propKey8 && void 0 === propKey || setPropOnCustomElement(
                domElement,
                tag2,
                defaultChecked,
                _propKey8,
                nextProps,
                propKey
              );
            return;
          }
      }
      for (var _propKey19 in lastProps)
        _propKey8 = lastProps[_propKey19], lastProps.hasOwnProperty(_propKey19) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey19) && setProp(domElement, tag2, _propKey19, null, nextProps, _propKey8);
      for (lastProp in nextProps)
        _propKey8 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || _propKey8 === propKey || null == _propKey8 && null == propKey || setProp(domElement, tag2, lastProp, _propKey8, nextProps, propKey);
    }
    function getPropNameFromAttributeName(attrName) {
      switch (attrName) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return attrName;
      }
    }
    function getStylesObjectFromElement(domElement) {
      var serverValueInObjectForm = {};
      domElement = domElement.style;
      for (var i2 = 0; i2 < domElement.length; i2++) {
        var styleName = domElement[i2];
        serverValueInObjectForm[styleName] = domElement.getPropertyValue(styleName);
      }
      return serverValueInObjectForm;
    }
    function diffHydratedStyles(domElement, value$jscomp$0, serverDifferences) {
      if (null != value$jscomp$0 && "object" !== typeof value$jscomp$0)
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var clientValue;
        var delimiter = clientValue = "", styleName;
        for (styleName in value$jscomp$0)
          if (value$jscomp$0.hasOwnProperty(styleName)) {
            var value = value$jscomp$0[styleName];
            null != value && "boolean" !== typeof value && "" !== value && (0 === styleName.indexOf("--") ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName + ":" + ("" + value).trim()) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + ("" + value).trim()) : clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + value + "px", delimiter = ";");
          }
        clientValue = clientValue || null;
        value$jscomp$0 = domElement.getAttribute("style");
        value$jscomp$0 !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(value$jscomp$0) !== clientValue && (serverDifferences.style = getStylesObjectFromElement(domElement)));
      }
    }
    function hydrateAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (checkAttributeStringCoercion(value, propKey), domElement === "" + value)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement) {
        switch (typeof value) {
          case "function":
          case "symbol":
            return;
        }
        if (!value) return;
      } else
        switch (typeof value) {
          case "function":
          case "symbol":
            break;
          default:
            if (value) return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanishAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
            break;
          default:
            if (checkAttributeStringCoercion(value, attributeName), domElement === "" + value)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateNumericAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(value)) return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(value) && (checkAttributeStringCoercion(value, propKey), domElement === "" + value))
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateSanitizedAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (checkAttributeStringCoercion(value, propKey), attributeName = sanitizeURL("" + value), domElement === attributeName)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function diffHydratedProperties(domElement, tag2, props2, hostContext) {
      for (var serverDifferences = {}, extraAttributes = /* @__PURE__ */ new Set(), attributes = domElement.attributes, i2 = 0; i2 < attributes.length; i2++)
        switch (attributes[i2].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            extraAttributes.add(attributes[i2].name);
        }
      if (isCustomElement(tag2))
        for (var propKey in props2) {
          if (props2.hasOwnProperty(propKey)) {
            var value = props2[propKey];
            if (null != value) {
              if (registrationNameDependencies.hasOwnProperty(propKey))
                "function" !== typeof value && warnForInvalidEventListener(propKey, value);
              else if (true !== props2.suppressHydrationWarning)
                switch (propKey) {
                  case "children":
                    "string" !== typeof value && "number" !== typeof value || warnForPropDifference(
                      "children",
                      domElement.textContent,
                      value,
                      serverDifferences
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    attributes = domElement.innerHTML;
                    value = value ? value.__html : void 0;
                    null != value && (value = normalizeHTML(domElement, value), warnForPropDifference(
                      propKey,
                      attributes,
                      value,
                      serverDifferences
                    ));
                    continue;
                  case "style":
                    extraAttributes.delete(propKey);
                    diffHydratedStyles(domElement, value, serverDifferences);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    extraAttributes.delete(propKey.toLowerCase());
                    console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      propKey
                    );
                    continue;
                  case "className":
                    extraAttributes.delete("class");
                    attributes = getValueForAttributeOnCustomComponent(
                      domElement,
                      "class",
                      value
                    );
                    warnForPropDifference(
                      "className",
                      attributes,
                      value,
                      serverDifferences
                    );
                    continue;
                  default:
                    hostContext.context === HostContextNamespaceNone && "svg" !== tag2 && "math" !== tag2 ? extraAttributes.delete(propKey.toLowerCase()) : extraAttributes.delete(propKey), attributes = getValueForAttributeOnCustomComponent(
                      domElement,
                      propKey,
                      value
                    ), warnForPropDifference(
                      propKey,
                      attributes,
                      value,
                      serverDifferences
                    );
                }
            }
          }
        }
      else
        for (value in props2)
          if (props2.hasOwnProperty(value) && (propKey = props2[value], null != propKey)) {
            if (registrationNameDependencies.hasOwnProperty(value))
              "function" !== typeof propKey && warnForInvalidEventListener(value, propKey);
            else if (true !== props2.suppressHydrationWarning)
              switch (value) {
                case "children":
                  "string" !== typeof propKey && "number" !== typeof propKey || warnForPropDifference(
                    "children",
                    domElement.textContent,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  attributes = domElement.innerHTML;
                  propKey = propKey ? propKey.__html : void 0;
                  null != propKey && (propKey = normalizeHTML(domElement, propKey), attributes !== propKey && (serverDifferences[value] = { __html: attributes }));
                  continue;
                case "className":
                  hydrateAttribute(
                    domElement,
                    value,
                    "class",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "tabIndex":
                  hydrateAttribute(
                    domElement,
                    value,
                    "tabindex",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "style":
                  extraAttributes.delete(value);
                  diffHydratedStyles(domElement, propKey, serverDifferences);
                  continue;
                case "multiple":
                  extraAttributes.delete(value);
                  warnForPropDifference(
                    value,
                    domElement.multiple,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "muted":
                  extraAttributes.delete(value);
                  warnForPropDifference(
                    value,
                    domElement.muted,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "autoFocus":
                  extraAttributes.delete("autofocus");
                  warnForPropDifference(
                    value,
                    domElement.autofocus,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "data":
                  if ("object" !== tag2) {
                    extraAttributes.delete(value);
                    attributes = domElement.getAttribute("data");
                    warnForPropDifference(
                      value,
                      attributes,
                      propKey,
                      serverDifferences
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!("" !== propKey || "a" === tag2 && "href" === value || "object" === tag2 && "data" === value)) {
                    "src" === value ? console.error(
                      'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      value,
                      value
                    ) : console.error(
                      'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      value,
                      value
                    );
                    continue;
                  }
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "action":
                case "formAction":
                  attributes = domElement.getAttribute(value);
                  if ("function" === typeof propKey) {
                    extraAttributes.delete(value.toLowerCase());
                    "formAction" === value ? (extraAttributes.delete("name"), extraAttributes.delete("formenctype"), extraAttributes.delete("formmethod"), extraAttributes.delete("formtarget")) : (extraAttributes.delete("enctype"), extraAttributes.delete("method"), extraAttributes.delete("target"));
                    continue;
                  } else if (attributes === EXPECTED_FORM_ACTION_URL) {
                    extraAttributes.delete(value.toLowerCase());
                    warnForPropDifference(
                      value,
                      "function",
                      propKey,
                      serverDifferences
                    );
                    continue;
                  }
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    value.toLowerCase(),
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkHref":
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    "xlink:href",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "contentEditable":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    "contenteditable",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "spellCheck":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    "spellcheck",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  hydrateBooleanAttribute(
                    domElement,
                    value,
                    value.toLowerCase(),
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "capture":
                case "download":
                  a: {
                    i2 = domElement;
                    var attributeName = attributes = value, serverDifferences$jscomp$0 = serverDifferences;
                    extraAttributes.delete(attributeName);
                    i2 = i2.getAttribute(attributeName);
                    if (null === i2)
                      switch (typeof propKey) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break a;
                        default:
                          if (false === propKey) break a;
                      }
                    else if (null != propKey)
                      switch (typeof propKey) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (true === propKey && "" === i2) break a;
                          break;
                        default:
                          if (checkAttributeStringCoercion(propKey, attributes), i2 === "" + propKey)
                            break a;
                      }
                    warnForPropDifference(
                      attributes,
                      i2,
                      propKey,
                      serverDifferences$jscomp$0
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  a: {
                    i2 = domElement;
                    attributeName = attributes = value;
                    serverDifferences$jscomp$0 = serverDifferences;
                    extraAttributes.delete(attributeName);
                    i2 = i2.getAttribute(attributeName);
                    if (null === i2)
                      switch (typeof propKey) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break a;
                        default:
                          if (isNaN(propKey) || 1 > propKey) break a;
                      }
                    else if (null != propKey)
                      switch (typeof propKey) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(propKey) || 1 > propKey) && (checkAttributeStringCoercion(propKey, attributes), i2 === "" + propKey))
                            break a;
                      }
                    warnForPropDifference(
                      attributes,
                      i2,
                      propKey,
                      serverDifferences$jscomp$0
                    );
                  }
                  continue;
                case "rowSpan":
                  hydrateNumericAttribute(
                    domElement,
                    value,
                    "rowspan",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "start":
                  hydrateNumericAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xHeight":
                  hydrateAttribute(
                    domElement,
                    value,
                    "x-height",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkActuate":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:actuate",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkArcrole":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:arcrole",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkRole":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:role",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkShow":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:show",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkTitle":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:title",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkType":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:type",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlBase":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:base",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlLang":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:lang",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlSpace":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:space",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "inert":
                  "" !== propKey || didWarnForNewBooleanPropsWithEmptyValue[value] || (didWarnForNewBooleanPropsWithEmptyValue[value] = true, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    value
                  ));
                  hydrateBooleanAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                default:
                  if (!(2 < value.length) || "o" !== value[0] && "O" !== value[0] || "n" !== value[1] && "N" !== value[1]) {
                    i2 = getAttributeAlias(value);
                    attributes = false;
                    hostContext.context === HostContextNamespaceNone && "svg" !== tag2 && "math" !== tag2 ? extraAttributes.delete(i2.toLowerCase()) : (attributeName = value.toLowerCase(), attributeName = possibleStandardNames.hasOwnProperty(
                      attributeName
                    ) ? possibleStandardNames[attributeName] || null : null, null !== attributeName && attributeName !== value && (attributes = true, extraAttributes.delete(attributeName)), extraAttributes.delete(i2));
                    a: if (attributeName = domElement, serverDifferences$jscomp$0 = i2, i2 = propKey, isAttributeNameSafe(serverDifferences$jscomp$0))
                      if (attributeName.hasAttribute(serverDifferences$jscomp$0))
                        attributeName = attributeName.getAttribute(
                          serverDifferences$jscomp$0
                        ), checkAttributeStringCoercion(
                          i2,
                          serverDifferences$jscomp$0
                        ), i2 = attributeName === "" + i2 ? i2 : attributeName;
                      else {
                        switch (typeof i2) {
                          case "function":
                          case "symbol":
                            break a;
                          case "boolean":
                            if (attributeName = serverDifferences$jscomp$0.toLowerCase().slice(0, 5), "data-" !== attributeName && "aria-" !== attributeName)
                              break a;
                        }
                        i2 = void 0 === i2 ? void 0 : null;
                      }
                    else i2 = void 0;
                    attributes || warnForPropDifference(
                      value,
                      i2,
                      propKey,
                      serverDifferences
                    );
                  }
              }
          }
      0 < extraAttributes.size && true !== props2.suppressHydrationWarning && warnForExtraAttributes(domElement, extraAttributes, serverDifferences);
      return 0 === Object.keys(serverDifferences).length ? null : serverDifferences;
    }
    function propNamesListJoin(list2, combinator) {
      switch (list2.length) {
        case 0:
          return "";
        case 1:
          return list2[0];
        case 2:
          return list2[0] + " " + combinator + " " + list2[1];
        default:
          return list2.slice(0, -1).join(", ") + ", " + combinator + " " + list2[list2.length - 1];
      }
    }
    function isLikelyStaticResource(initiatorType) {
      switch (initiatorType) {
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
          return true;
        default:
          return false;
      }
    }
    function estimateBandwidth() {
      if ("function" === typeof performance.getEntriesByType) {
        for (var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i2 = 0; i2 < resourceEntries.length; i2++) {
          var entry = resourceEntries[i2], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
          if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
            initiatorType = 0;
            duration = entry.responseEnd;
            for (i2 += 1; i2 < resourceEntries.length; i2++) {
              var overlapEntry = resourceEntries[i2], overlapStartTime = overlapEntry.startTime;
              if (overlapStartTime > duration) break;
              var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
              overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
            }
            --i2;
            bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
            count++;
            if (10 < count) break;
          }
        }
        if (0 < count) return bits / count / 1e6;
      }
      return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
      return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function getOwnHostContext(namespaceURI) {
      switch (namespaceURI) {
        case SVG_NAMESPACE:
          return HostContextNamespaceSvg;
        case MATH_NAMESPACE:
          return HostContextNamespaceMath;
        default:
          return HostContextNamespaceNone;
      }
    }
    function getChildHostContextProd(parentNamespace, type) {
      if (parentNamespace === HostContextNamespaceNone)
        switch (type) {
          case "svg":
            return HostContextNamespaceSvg;
          case "math":
            return HostContextNamespaceMath;
          default:
            return HostContextNamespaceNone;
        }
      return parentNamespace === HostContextNamespaceSvg && "foreignObject" === type ? HostContextNamespaceNone : parentNamespace;
    }
    function shouldSetTextContent(type, props2) {
      return "textarea" === type || "noscript" === type || "string" === typeof props2.children || "number" === typeof props2.children || "bigint" === typeof props2.children || "object" === typeof props2.dangerouslySetInnerHTML && null !== props2.dangerouslySetInnerHTML && null != props2.dangerouslySetInnerHTML.__html;
    }
    function shouldAttemptEagerTransition() {
      var event = window.event;
      if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return false;
        currentPopstateTransitionEvent = event;
        return true;
      }
      currentPopstateTransitionEvent = null;
      return false;
    }
    function resolveEventType() {
      var event = window.event;
      return event && event !== schedulerEvent ? event.type : null;
    }
    function resolveEventTimeStamp() {
      var event = window.event;
      return event && event !== schedulerEvent ? event.timeStamp : -1.1;
    }
    function handleErrorInNextTick(error) {
      setTimeout(function() {
        throw error;
      });
    }
    function commitMount(domElement, type, newProps) {
      switch (type) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          newProps.autoFocus && domElement.focus();
          break;
        case "img":
          newProps.src ? domElement.src = newProps.src : newProps.srcSet && (domElement.srcset = newProps.srcSet);
      }
    }
    function commitHydratedInstance() {
    }
    function commitUpdate(domElement, type, oldProps, newProps) {
      updateProperties(domElement, type, oldProps, newProps);
      domElement[internalPropsKey] = newProps;
    }
    function resetTextContent(domElement) {
      setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
      textInstance.nodeValue = newText;
    }
    function warnForReactChildrenConflict(container) {
      if (!container.__reactWarnedAboutChildrenConflict) {
        var props2 = container[internalPropsKey] || null;
        if (null !== props2) {
          var fiber = getInstanceFromNode(container);
          null !== fiber && ("string" === typeof props2.children || "number" === typeof props2.children ? (container.__reactWarnedAboutChildrenConflict = true, runWithFiberInDEV(fiber, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })) : null != props2.dangerouslySetInnerHTML && (container.__reactWarnedAboutChildrenConflict = true, runWithFiberInDEV(fiber, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })));
        }
      }
    }
    function isSingletonScope(type) {
      return "head" === type;
    }
    function removeChild(parentInstance, child) {
      parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
      (9 === container.nodeType ? container.body : "HTML" === container.nodeName ? container.ownerDocument.body : container).removeChild(child);
    }
    function clearHydrationBoundary(parentInstance, hydrationInstance) {
      var node = hydrationInstance, depth = 0;
      do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType)
          if (node = nextNode.data, node === SUSPENSE_END_DATA || node === ACTIVITY_END_DATA) {
            if (0 === depth) {
              parentInstance.removeChild(nextNode);
              retryIfBlockedOn(hydrationInstance);
              return;
            }
            depth--;
          } else if (node === SUSPENSE_START_DATA || node === SUSPENSE_PENDING_START_DATA || node === SUSPENSE_QUEUED_START_DATA || node === SUSPENSE_FALLBACK_START_DATA || node === ACTIVITY_START_DATA)
            depth++;
          else if (node === PREAMBLE_CONTRIBUTION_HTML)
            releaseSingletonInstance(
              parentInstance.ownerDocument.documentElement
            );
          else if (node === PREAMBLE_CONTRIBUTION_HEAD) {
            node = parentInstance.ownerDocument.head;
            releaseSingletonInstance(node);
            for (var node$jscomp$0 = node.firstChild; node$jscomp$0; ) {
              var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
              node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
              node$jscomp$0 = nextNode$jscomp$0;
            }
          } else
            node === PREAMBLE_CONTRIBUTION_BODY && releaseSingletonInstance(parentInstance.ownerDocument.body);
        node = nextNode;
      } while (node);
      retryIfBlockedOn(hydrationInstance);
    }
    function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden2) {
      var node = suspenseInstance;
      suspenseInstance = 0;
      do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden2 ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden2 ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType)
          if (node = nextNode.data, node === SUSPENSE_END_DATA)
            if (0 === suspenseInstance) break;
            else suspenseInstance--;
          else
            node !== SUSPENSE_START_DATA && node !== SUSPENSE_PENDING_START_DATA && node !== SUSPENSE_QUEUED_START_DATA && node !== SUSPENSE_FALLBACK_START_DATA || suspenseInstance++;
        node = nextNode;
      } while (node);
    }
    function hideDehydratedBoundary(suspenseInstance) {
      hideOrUnhideDehydratedBoundary(suspenseInstance, true);
    }
    function hideInstance(instance) {
      instance = instance.style;
      "function" === typeof instance.setProperty ? instance.setProperty("display", "none", "important") : instance.display = "none";
    }
    function hideTextInstance(textInstance) {
      textInstance.nodeValue = "";
    }
    function unhideDehydratedBoundary(dehydratedInstance) {
      hideOrUnhideDehydratedBoundary(dehydratedInstance, false);
    }
    function unhideInstance(instance, props2) {
      props2 = props2[STYLE];
      props2 = void 0 !== props2 && null !== props2 && props2.hasOwnProperty("display") ? props2.display : null;
      instance.style.display = null == props2 || "boolean" === typeof props2 ? "" : ("" + props2).trim();
    }
    function unhideTextInstance(textInstance, text2) {
      textInstance.nodeValue = text2;
    }
    function clearContainerSparingly(container) {
      var nextNode = container.firstChild;
      nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
      for (; nextNode; ) {
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch (node.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            clearContainerSparingly(node);
            detachDeletedInstance(node);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
      }
    }
    function canHydrateInstance(instance, type, props2, inRootOrSingleton) {
      for (; 1 === instance.nodeType; ) {
        var anyProps = props2;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
          if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type))
            break;
        } else if (!inRootOrSingleton)
          if ("input" === type && "hidden" === instance.type) {
            checkAttributeStringCoercion(anyProps.name, "name");
            var name2 = null == anyProps.name ? null : "" + anyProps.name;
            if ("hidden" === anyProps.type && instance.getAttribute("name") === name2)
              return instance;
          } else return instance;
        else if (!instance[internalHoistableMarker])
          switch (type) {
            case "meta":
              if (!instance.hasAttribute("itemprop")) break;
              return instance;
            case "link":
              name2 = instance.getAttribute("rel");
              if ("stylesheet" === name2 && instance.hasAttribute("data-precedence"))
                break;
              else if (name2 !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title))
                break;
              return instance;
            case "style":
              if (instance.hasAttribute("data-precedence")) break;
              return instance;
            case "script":
              name2 = instance.getAttribute("src");
              if ((name2 !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name2 && instance.hasAttribute("async") && !instance.hasAttribute("itemprop"))
                break;
              return instance;
            default:
              return instance;
          }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
      }
      return null;
    }
    function canHydrateTextInstance(instance, text2, inRootOrSingleton) {
      if ("" === text2) return null;
      for (; 3 !== instance.nodeType; ) {
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
          return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
      }
      return instance;
    }
    function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
      for (; 8 !== instance.nodeType; ) {
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
          return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
      }
      return instance;
    }
    function isSuspenseInstancePending(instance) {
      return instance.data === SUSPENSE_PENDING_START_DATA || instance.data === SUSPENSE_QUEUED_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
      return instance.data === SUSPENSE_FALLBACK_START_DATA || instance.data === SUSPENSE_PENDING_START_DATA && instance.ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
      var ownerDocument = instance.ownerDocument;
      if (instance.data === SUSPENSE_QUEUED_START_DATA)
        instance._reactRetry = callback;
      else if (instance.data !== SUSPENSE_PENDING_START_DATA || ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING)
        callback();
      else {
        var listener = function() {
          callback();
          ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
      }
    }
    function getNextHydratable(node) {
      for (; null != node; node = node.nextSibling) {
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
          nodeType = node.data;
          if (nodeType === SUSPENSE_START_DATA || nodeType === SUSPENSE_FALLBACK_START_DATA || nodeType === SUSPENSE_PENDING_START_DATA || nodeType === SUSPENSE_QUEUED_START_DATA || nodeType === ACTIVITY_START_DATA || nodeType === FORM_STATE_IS_MATCHING || nodeType === FORM_STATE_IS_NOT_MATCHING)
            break;
          if (nodeType === SUSPENSE_END_DATA || nodeType === ACTIVITY_END_DATA)
            return null;
        }
      }
      return node;
    }
    function describeHydratableInstanceForDevWarnings(instance) {
      if (1 === instance.nodeType) {
        for (var JSCompiler_temp_const = instance.nodeName.toLowerCase(), serverDifferences = {}, attributes = instance.attributes, i2 = 0; i2 < attributes.length; i2++) {
          var attr = attributes[i2];
          serverDifferences[getPropNameFromAttributeName(attr.name)] = "style" === attr.name.toLowerCase() ? getStylesObjectFromElement(instance) : attr.value;
        }
        return { type: JSCompiler_temp_const, props: serverDifferences };
      }
      return 8 === instance.nodeType ? instance.data === ACTIVITY_START_DATA ? { type: "Activity", props: {} } : { type: "Suspense", props: {} } : instance.nodeValue;
    }
    function diffHydratedTextForDevWarnings(textInstance, text2, parentProps) {
      return null === parentProps || true !== parentProps[SUPPRESS_HYDRATION_WARNING] ? (textInstance.nodeValue === text2 ? textInstance = null : (text2 = normalizeMarkupForTextOrAttribute(text2), textInstance = normalizeMarkupForTextOrAttribute(textInstance.nodeValue) === text2 ? null : textInstance.nodeValue), textInstance) : null;
    }
    function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
      hydrationInstance = hydrationInstance.nextSibling;
      for (var depth = 0; hydrationInstance; ) {
        if (8 === hydrationInstance.nodeType) {
          var data = hydrationInstance.data;
          if (data === SUSPENSE_END_DATA || data === ACTIVITY_END_DATA) {
            if (0 === depth)
              return getNextHydratable(hydrationInstance.nextSibling);
            depth--;
          } else
            data !== SUSPENSE_START_DATA && data !== SUSPENSE_FALLBACK_START_DATA && data !== SUSPENSE_PENDING_START_DATA && data !== SUSPENSE_QUEUED_START_DATA && data !== ACTIVITY_START_DATA || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
      }
      return null;
    }
    function getParentHydrationBoundary(targetInstance) {
      targetInstance = targetInstance.previousSibling;
      for (var depth = 0; targetInstance; ) {
        if (8 === targetInstance.nodeType) {
          var data = targetInstance.data;
          if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_QUEUED_START_DATA || data === ACTIVITY_START_DATA) {
            if (0 === depth) return targetInstance;
            depth--;
          } else
            data !== SUSPENSE_END_DATA && data !== ACTIVITY_END_DATA || depth++;
        }
        targetInstance = targetInstance.previousSibling;
      }
      return null;
    }
    function commitHydratedContainer(container) {
      retryIfBlockedOn(container);
    }
    function commitHydratedActivityInstance(activityInstance) {
      retryIfBlockedOn(activityInstance);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
      retryIfBlockedOn(suspenseInstance);
    }
    function resolveSingletonInstance(type, props2, rootContainerInstance, hostContext, validateDOMNestingDev) {
      validateDOMNestingDev && validateDOMNesting(type, hostContext.ancestorInfo);
      props2 = getOwnerDocumentFromRootContainer(rootContainerInstance);
      switch (type) {
        case "html":
          type = props2.documentElement;
          if (!type)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type;
        case "head":
          type = props2.head;
          if (!type)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type;
        case "body":
          type = props2.body;
          if (!type)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function acquireSingletonInstance(type, props2, instance, internalInstanceHandle) {
      if (!instance[internalContainerInstanceKey] && getInstanceFromNode(instance)) {
        var tagName = instance.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          tagName,
          tagName,
          tagName
        );
      }
      switch (type) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (tagName = instance.attributes; tagName.length; )
        instance.removeAttributeNode(tagName[0]);
      setInitialProperties(instance, type, props2);
      instance[internalInstanceKey] = internalInstanceHandle;
      instance[internalPropsKey] = props2;
    }
    function releaseSingletonInstance(instance) {
      for (var attributes = instance.attributes; attributes.length; )
        instance.removeAttributeNode(attributes[0]);
      detachDeletedInstance(instance);
    }
    function getHoistableRoot(container) {
      return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
    }
    function preconnectAs(rel, href, crossOrigin) {
      var ownerDocument = globalDocument;
      if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = { rel, crossOrigin, href }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
      }
    }
    function getResource(type, currentProps, pendingProps, currentResource) {
      var resourceRoot = (resourceRoot = rootInstanceStackCursor.current) ? getHoistableRoot(resourceRoot) : null;
      if (!resourceRoot)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (type) {
        case "meta":
        case "title":
          return null;
        case "style":
          return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(resourceRoot).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, currentProps.set(pendingProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
            type = getStyleKey(pendingProps.href);
            var _styles = getResourcesFromRoot(resourceRoot).hoistableStyles, _resource = _styles.get(type);
            if (!_resource && (resourceRoot = resourceRoot.ownerDocument || resourceRoot, _resource = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: NotLoaded, preload: null }
            }, _styles.set(type, _resource), (_styles = resourceRoot.querySelector(
              getStylesheetSelectorFromKey(type)
            )) && !_styles._p && (_resource.instance = _styles, _resource.state.loading = Loaded | Inserted), !preloadPropsMap.has(type))) {
              var preloadProps = {
                rel: "preload",
                as: "style",
                href: pendingProps.href,
                crossOrigin: pendingProps.crossOrigin,
                integrity: pendingProps.integrity,
                media: pendingProps.media,
                hrefLang: pendingProps.hrefLang,
                referrerPolicy: pendingProps.referrerPolicy
              };
              preloadPropsMap.set(type, preloadProps);
              _styles || preloadStylesheet(
                resourceRoot,
                type,
                preloadProps,
                _resource.state
              );
            }
            if (currentProps && null === currentResource)
              throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps
              );
            return _resource;
          }
          if (currentProps && null !== currentResource)
            throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps
            );
          return null;
        case "script":
          return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(resourceRoot).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, currentProps.set(pendingProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + type + '". this is a bug in React.'
          );
      }
    }
    function describeLinkForResourceErrorDEV(props2) {
      var describedProps = 0, description = "<link";
      "string" === typeof props2.rel ? (describedProps++, description += ' rel="' + props2.rel + '"') : hasOwnProperty2.call(props2, "rel") && (describedProps++, description += ' rel="' + (null === props2.rel ? "null" : "invalid type " + typeof props2.rel) + '"');
      "string" === typeof props2.href ? (describedProps++, description += ' href="' + props2.href + '"') : hasOwnProperty2.call(props2, "href") && (describedProps++, description += ' href="' + (null === props2.href ? "null" : "invalid type " + typeof props2.href) + '"');
      "string" === typeof props2.precedence ? (describedProps++, description += ' precedence="' + props2.precedence + '"') : hasOwnProperty2.call(props2, "precedence") && (describedProps++, description += " precedence={" + (null === props2.precedence ? "null" : "invalid type " + typeof props2.precedence) + "}");
      Object.getOwnPropertyNames(props2).length > describedProps && (description += " ...");
      return description + " />";
    }
    function getStyleKey(href) {
      return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
    }
    function getStylesheetSelectorFromKey(key) {
      return 'link[rel="stylesheet"][' + key + "]";
    }
    function stylesheetPropsFromRawProps(rawProps) {
      return assign2({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
      });
    }
    function preloadStylesheet(ownerDocument, key, preloadProps, state) {
      ownerDocument.querySelector(
        'link[rel="preload"][as="style"][' + key + "]"
      ) ? state.loading = Loaded : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= Loaded;
      }), key.addEventListener("error", function() {
        return state.loading |= Errored;
      }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
    }
    function getScriptKey(src) {
      return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
    }
    function getScriptSelectorFromKey(key) {
      return "script[async]" + key;
    }
    function acquireResource(hoistableRoot, resource, props2) {
      resource.count++;
      if (null === resource.instance)
        switch (resource.type) {
          case "style":
            var instance = hoistableRoot.querySelector(
              'style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props2.href) + '"]'
            );
            if (instance)
              return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign2({}, props2, {
              "data-href": props2.href,
              "data-precedence": props2.precedence,
              href: null,
              precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props2.precedence, hoistableRoot);
            return resource.instance = instance;
          case "stylesheet":
            styleProps = getStyleKey(props2.href);
            var _instance = hoistableRoot.querySelector(
              getStylesheetSelectorFromKey(styleProps)
            );
            if (_instance)
              return resource.state.loading |= Inserted, resource.instance = _instance, markNodeAsHoistable(_instance), _instance;
            instance = stylesheetPropsFromRawProps(props2);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            _instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(_instance);
            var linkInstance = _instance;
            linkInstance._p = new Promise(function(resolve, reject2) {
              linkInstance.onload = resolve;
              linkInstance.onerror = reject2;
            });
            setInitialProperties(_instance, "link", instance);
            resource.state.loading |= Inserted;
            insertStylesheet(_instance, props2.precedence, hoistableRoot);
            return resource.instance = _instance;
          case "script":
            _instance = getScriptKey(props2.src);
            if (styleProps = hoistableRoot.querySelector(
              getScriptSelectorFromKey(_instance)
            ))
              return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props2;
            if (styleProps = preloadPropsMap.get(_instance))
              instance = assign2({}, props2), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + resource.type + '". this is a bug in React.'
            );
        }
      else
        "stylesheet" === resource.type && (resource.state.loading & Inserted) === NotLoaded && (instance = resource.instance, resource.state.loading |= Inserted, insertStylesheet(instance, props2.precedence, hoistableRoot));
      return resource.instance;
    }
    function insertStylesheet(instance, precedence, root3) {
      for (var nodes = root3.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), last2 = nodes.length ? nodes[nodes.length - 1] : null, prior = last2, i2 = 0; i2 < nodes.length; i2++) {
        var node = nodes[i2];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last2) break;
      }
      prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root3.nodeType ? root3.head : root3, precedence.insertBefore(instance, precedence.firstChild));
    }
    function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
      null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
      null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
      null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
    }
    function adoptPreloadPropsForScript(scriptProps, preloadProps) {
      null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
      null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
      null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
    }
    function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
      if (null === tagCaches) {
        var cache = /* @__PURE__ */ new Map();
        var caches = tagCaches = /* @__PURE__ */ new Map();
        caches.set(ownerDocument, cache);
      } else
        caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = /* @__PURE__ */ new Map(), caches.set(ownerDocument, cache));
      if (cache.has(type)) return cache;
      cache.set(type, null);
      ownerDocument = ownerDocument.getElementsByTagName(type);
      for (caches = 0; caches < ownerDocument.length; caches++) {
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && node.namespaceURI !== SVG_NAMESPACE) {
          var nodeKey = node.getAttribute(keyAttribute) || "";
          nodeKey = type + nodeKey;
          var existing = cache.get(nodeKey);
          existing ? existing.push(node) : cache.set(nodeKey, [node]);
        }
      }
      return cache;
    }
    function mountHoistable(hoistableRoot, type, instance) {
      hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
      hoistableRoot.head.insertBefore(
        instance,
        "title" === type ? hoistableRoot.querySelector("head > title") : null
      );
    }
    function isHostHoistableType(type, props2, hostContext) {
      var outsideHostContainerContext = !hostContext.ancestorInfo.containerTagInScope;
      if (hostContext.context === HostContextNamespaceSvg || null != props2.itemProp)
        return !outsideHostContainerContext || null == props2.itemProp || "meta" !== type && "title" !== type && "style" !== type && "link" !== type && "script" !== type || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          type,
          type
        ), false;
      switch (type) {
        case "meta":
        case "title":
          return true;
        case "style":
          if ("string" !== typeof props2.precedence || "string" !== typeof props2.href || "" === props2.href) {
            outsideHostContainerContext && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return true;
        case "link":
          if ("string" !== typeof props2.rel || "string" !== typeof props2.href || "" === props2.href || props2.onLoad || props2.onError) {
            if ("stylesheet" === props2.rel && "string" === typeof props2.precedence) {
              type = props2.href;
              var onError = props2.onError, disabled = props2.disabled;
              hostContext = [];
              props2.onLoad && hostContext.push("`onLoad`");
              onError && hostContext.push("`onError`");
              null != disabled && hostContext.push("`disabled`");
              onError = propNamesListJoin(hostContext, "and");
              onError += 1 === hostContext.length ? " prop" : " props";
              disabled = 1 === hostContext.length ? "an " + onError : "the " + onError;
              hostContext.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                type,
                disabled,
                onError
              );
            }
            outsideHostContainerContext && ("string" !== typeof props2.rel || "string" !== typeof props2.href || "" === props2.href ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (props2.onError || props2.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (props2.rel) {
            case "stylesheet":
              return type = props2.precedence, props2 = props2.disabled, "string" !== typeof type && outsideHostContainerContext && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), "string" === typeof type && null == props2;
            default:
              return true;
          }
        case "script":
          type = props2.async && "function" !== typeof props2.async && "symbol" !== typeof props2.async;
          if (!type || props2.onLoad || props2.onError || !props2.src || "string" !== typeof props2.src) {
            outsideHostContainerContext && (type ? props2.onLoad || props2.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return true;
        case "noscript":
        case "template":
          outsideHostContainerContext && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            type
          );
      }
      return false;
    }
    function preloadResource(resource) {
      return "stylesheet" === resource.type && (resource.state.loading & Settled) === NotLoaded ? false : true;
    }
    function suspendResource(state, hoistableRoot, resource, props2) {
      if ("stylesheet" === resource.type && ("string" !== typeof props2.media || false !== matchMedia(props2.media).matches) && (resource.state.loading & Inserted) === NotLoaded) {
        if (null === resource.instance) {
          var key = getStyleKey(props2.href), instance = hoistableRoot.querySelector(
            getStylesheetSelectorFromKey(key)
          );
          if (instance) {
            hoistableRoot = instance._p;
            null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
            resource.state.loading |= Inserted;
            resource.instance = instance;
            markNodeAsHoistable(instance);
            return;
          }
          instance = hoistableRoot.ownerDocument || hoistableRoot;
          props2 = stylesheetPropsFromRawProps(props2);
          (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props2, key);
          instance = instance.createElement("link");
          markNodeAsHoistable(instance);
          var linkInstance = instance;
          linkInstance._p = new Promise(function(resolve, reject2) {
            linkInstance.onload = resolve;
            linkInstance.onerror = reject2;
          });
          setInitialProperties(instance, "link", props2);
          resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = /* @__PURE__ */ new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && (resource.state.loading & Settled) === NotLoaded && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
      }
    }
    function waitForCommitToBeReady(state, timeoutOffset) {
      state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
      return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
          state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
          if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
          }
        }, SUSPENSEY_STYLESHEET_TIMEOUT + timeoutOffset);
        0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 125 * estimateBandwidth() * SUSPENSEY_IMAGE_TIME_ESTIMATE);
        var imgTimer = setTimeout(
          function() {
            state.waitingForImages = false;
            if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
              var unsuspend = state.unsuspend;
              state.unsuspend = null;
              unsuspend();
            }
          },
          (state.imgBytes > estimatedBytesWithinLimit ? 50 : SUSPENSEY_IMAGE_TIMEOUT) + timeoutOffset
        );
        state.unsuspend = commit;
        return function() {
          state.unsuspend = null;
          clearTimeout(stylesheetTimer);
          clearTimeout(imgTimer);
        };
      } : null;
    }
    function onUnsuspend() {
      this.count--;
      if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets)
          insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
          var unsuspend = this.unsuspend;
          this.unsuspend = null;
          unsuspend();
        }
      }
    }
    function insertSuspendedStylesheets(state, resources) {
      state.stylesheets = null;
      null !== state.unsuspend && (state.count++, precedencesByRoot = /* @__PURE__ */ new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
    }
    function insertStylesheetIntoRoot(root3, resource) {
      if (!(resource.state.loading & Inserted)) {
        var precedences = precedencesByRoot.get(root3);
        if (precedences) var last2 = precedences.get(LAST_PRECEDENCE);
        else {
          precedences = /* @__PURE__ */ new Map();
          precedencesByRoot.set(root3, precedences);
          for (var nodes = root3.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), i2 = 0; i2 < nodes.length; i2++) {
            var node = nodes[i2];
            if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media"))
              precedences.set(node.dataset.precedence, node), last2 = node;
          }
          last2 && precedences.set(LAST_PRECEDENCE, last2);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i2 = precedences.get(node) || last2;
        i2 === last2 && precedences.set(LAST_PRECEDENCE, nodes);
        precedences.set(node, nodes);
        this.count++;
        last2 = onUnsuspend.bind(this);
        nodes.addEventListener("load", last2);
        nodes.addEventListener("error", last2);
        i2 ? i2.parentNode.insertBefore(nodes, i2.nextSibling) : (root3 = 9 === root3.nodeType ? root3.head : root3, root3.insertBefore(nodes, root3.firstChild));
        resource.state.loading |= Inserted;
      }
    }
    function FiberRootNode(containerInfo, tag2, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
      this.tag = 1;
      this.containerInfo = containerInfo;
      this.pingCache = this.current = this.pendingChildren = null;
      this.timeoutHandle = noTimeout;
      this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
      this.callbackPriority = 0;
      this.expirationTimes = createLaneMap(-1);
      this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
      this.entanglements = createLaneMap(0);
      this.hiddenUpdates = createLaneMap(null);
      this.identifierPrefix = identifierPrefix;
      this.onUncaughtError = onUncaughtError;
      this.onCaughtError = onCaughtError;
      this.onRecoverableError = onRecoverableError;
      this.pooledCache = null;
      this.pooledCacheLanes = 0;
      this.formState = formState;
      this.incompleteTransitions = /* @__PURE__ */ new Map();
      this.passiveEffectDuration = this.effectDuration = -0;
      this.memoizedUpdaters = /* @__PURE__ */ new Set();
      containerInfo = this.pendingUpdatersLaneMap = [];
      for (tag2 = 0; 31 > tag2; tag2++) containerInfo.push(/* @__PURE__ */ new Set());
      this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
    }
    function createFiberRoot(containerInfo, tag2, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
      containerInfo = new FiberRootNode(
        containerInfo,
        tag2,
        hydrate,
        identifierPrefix,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        onDefaultTransitionIndicator,
        formState
      );
      tag2 = ConcurrentMode;
      true === isStrictMode && (tag2 |= StrictLegacyMode | StrictEffectsMode);
      tag2 |= ProfileMode;
      isStrictMode = createFiber(3, null, null, tag2);
      containerInfo.current = isStrictMode;
      isStrictMode.stateNode = containerInfo;
      tag2 = createCache();
      retainCache(tag2);
      containerInfo.pooledCache = tag2;
      retainCache(tag2);
      isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag2
      };
      initializeUpdateQueue(isStrictMode);
      return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
      if (!parentComponent) return emptyContextObject;
      parentComponent = emptyContextObject;
      return parentComponent;
    }
    function updateContainerImpl(rootFiber, lane, element2, container, parentComponent, callback) {
      if (injectedHook && "function" === typeof injectedHook.onScheduleFiberRoot)
        try {
          injectedHook.onScheduleFiberRoot(rendererID, container, element2);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %o",
            err
          ));
        }
      parentComponent = getContextForSubtree(parentComponent);
      null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
      isRendering && null !== current2 && !didWarnAboutNestedUpdates && (didWarnAboutNestedUpdates = true, console.error(
        "Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.",
        getComponentNameFromFiber(current2) || "Unknown"
      ));
      container = createUpdate(lane);
      container.payload = { element: element2 };
      callback = void 0 === callback ? null : callback;
      null !== callback && ("function" !== typeof callback && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        callback
      ), container.callback = callback);
      element2 = enqueueUpdate(rootFiber, container, lane);
      null !== element2 && (startUpdateTimerByLane(lane, "root.render()", null), scheduleUpdateOnFiber(element2, rootFiber, lane), entangleTransitions(element2, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
      fiber = fiber.memoizedState;
      if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
      }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
      markRetryLaneImpl(fiber, retryLane);
      (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    function attemptContinuousHydration(fiber) {
      if (13 === fiber.tag || 31 === fiber.tag) {
        var root3 = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root3 && scheduleUpdateOnFiber(root3, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
      }
    }
    function attemptHydrationAtCurrentPriority(fiber) {
      if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = requestUpdateLane(fiber);
        lane = getBumpedLaneForHydrationByLane(lane);
        var root3 = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root3 && scheduleUpdateOnFiber(root3, fiber, lane);
        markRetryLaneIfNotHydrated(fiber, lane);
      }
    }
    function getCurrentFiberForDevTools() {
      return current2;
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
      var prevTransition = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = DiscreteEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
      }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
      var prevTransition = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = ContinuousEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
      }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn)
          dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            return_targetInst,
            targetContainer
          ), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ))
          nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
          for (; null !== blockedOn; ) {
            var fiber = getInstanceFromNode(blockedOn);
            if (null !== fiber)
              switch (fiber.tag) {
                case 3:
                  fiber = fiber.stateNode;
                  if (fiber.current.memoizedState.isDehydrated) {
                    var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                    if (0 !== lanes) {
                      var root3 = fiber;
                      root3.pendingLanes |= 2;
                      for (root3.entangledLanes |= 2; lanes; ) {
                        var lane = 1 << 31 - clz32(lanes);
                        root3.entanglements[1] |= lane;
                        lanes &= ~lane;
                      }
                      ensureRootIsScheduled(fiber);
                      (executionContext & (RenderContext | CommitContext)) === NoContext && (workInProgressRootRenderTargetTime = now$12() + RENDER_TIMEOUT_MS, flushSyncWorkAcrossRoots_impl(0));
                    }
                  }
                  break;
                case 31:
                case 13:
                  root3 = enqueueConcurrentRenderForLane(fiber, 2), null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
              }
            fiber = findInstanceBlockingEvent(nativeEvent);
            null === fiber && dispatchEventForPluginEventSystem(
              domEventName,
              eventSystemFlags,
              nativeEvent,
              return_targetInst,
              targetContainer
            );
            if (fiber === blockedOn) break;
            blockedOn = fiber;
          }
          null !== blockedOn && nativeEvent.stopPropagation();
        } else
          dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            null,
            targetContainer
          );
      }
    }
    function findInstanceBlockingEvent(nativeEvent) {
      nativeEvent = getEventTarget(nativeEvent);
      return findInstanceBlockingTarget(nativeEvent);
    }
    function findInstanceBlockingTarget(targetNode) {
      return_targetInst = null;
      targetNode = getClosestInstanceFromNode(targetNode);
      if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
          var tag2 = nearestMounted.tag;
          if (13 === tag2) {
            targetNode = getSuspenseInstanceFromFiber(nearestMounted);
            if (null !== targetNode) return targetNode;
            targetNode = null;
          } else if (31 === tag2) {
            targetNode = getActivityInstanceFromFiber(nearestMounted);
            if (null !== targetNode) return targetNode;
            targetNode = null;
          } else if (3 === tag2) {
            if (nearestMounted.stateNode.current.memoizedState.isDehydrated)
              return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
            targetNode = null;
          } else nearestMounted !== targetNode && (targetNode = null);
        }
      }
      return_targetInst = targetNode;
      return null;
    }
    function getEventPriority(domEventName) {
      switch (domEventName) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return DiscreteEventPriority;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return ContinuousEventPriority;
        case "message":
          switch (getCurrentPriorityLevel()) {
            case ImmediatePriority:
              return DiscreteEventPriority;
            case UserBlockingPriority:
              return ContinuousEventPriority;
            case NormalPriority$1:
            case LowPriority:
              return DefaultEventPriority;
            case IdlePriority:
              return IdleEventPriority;
            default:
              return DefaultEventPriority;
          }
        default:
          return DefaultEventPriority;
      }
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
      switch (domEventName) {
        case "focusin":
        case "focusout":
          queuedFocus = null;
          break;
        case "dragenter":
        case "dragleave":
          queuedDrag = null;
          break;
        case "mouseover":
        case "mouseout":
          queuedMouse = null;
          break;
        case "pointerover":
        case "pointerout":
          queuedPointers.delete(nativeEvent.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          queuedPointerCaptures.delete(nativeEvent.pointerId);
      }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent)
        return existingQueuedEvent = {
          blockedOn,
          domEventName,
          eventSystemFlags,
          nativeEvent,
          targetContainers: [targetContainer]
        }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
      existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
      blockedOn = existingQueuedEvent.targetContainers;
      null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
      return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      switch (domEventName) {
        case "focusin":
          return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedFocus,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "dragenter":
          return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedDrag,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "mouseover":
          return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedMouse,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "pointerover":
          var pointerId = nativeEvent.pointerId;
          queuedPointers.set(
            pointerId,
            accumulateOrCreateContinuousQueuedReplayableEvent(
              queuedPointers.get(pointerId) || null,
              blockedOn,
              domEventName,
              eventSystemFlags,
              targetContainer,
              nativeEvent
            )
          );
          return true;
        case "gotpointercapture":
          return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(
            pointerId,
            accumulateOrCreateContinuousQueuedReplayableEvent(
              queuedPointerCaptures.get(pointerId) || null,
              blockedOn,
              domEventName,
              eventSystemFlags,
              targetContainer,
              nativeEvent
            )
          ), true;
      }
      return false;
    }
    function attemptExplicitHydrationTarget(queuedTarget) {
      var targetInst = getClosestInstanceFromNode(queuedTarget.target);
      if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
          if (targetInst = nearestMounted.tag, 13 === targetInst) {
            if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
              queuedTarget.blockedOn = targetInst;
              runWithPriority(queuedTarget.priority, function() {
                attemptHydrationAtCurrentPriority(nearestMounted);
              });
              return;
            }
          } else if (31 === targetInst) {
            if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
              queuedTarget.blockedOn = targetInst;
              runWithPriority(queuedTarget.priority, function() {
                attemptHydrationAtCurrentPriority(nearestMounted);
              });
              return;
            }
          } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
            queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
            return;
          }
        }
      }
      queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
      if (null !== queuedEvent.blockedOn) return false;
      for (var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length; ) {
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
          nextBlockedOn = queuedEvent.nativeEvent;
          var nativeEventClone = new nextBlockedOn.constructor(
            nextBlockedOn.type,
            nextBlockedOn
          ), event = nativeEventClone;
          null !== currentReplayingEvent && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          );
          currentReplayingEvent = event;
          nextBlockedOn.target.dispatchEvent(nativeEventClone);
          null === currentReplayingEvent && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          );
          currentReplayingEvent = null;
        } else
          return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, false;
        targetContainers.shift();
      }
      return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map2) {
      attemptReplayContinuousQueuedEvent(queuedEvent) && map2.delete(key);
    }
    function replayUnblockedEvents() {
      hasScheduledReplayAttempt = false;
      null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
      null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
      null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
      queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
      queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
      queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = true, Scheduler2.unstable_scheduleCallback(
        Scheduler2.unstable_NormalPriority,
        replayUnblockedEvents
      )));
    }
    function scheduleReplayQueueIfNeeded(formReplayingQueue) {
      lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler2.unstable_scheduleCallback(
        Scheduler2.unstable_NormalPriority,
        function() {
          lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
          for (var i2 = 0; i2 < formReplayingQueue.length; i2 += 3) {
            var form = formReplayingQueue[i2], submitterOrAction = formReplayingQueue[i2 + 1], formData = formReplayingQueue[i2 + 2];
            if ("function" !== typeof submitterOrAction)
              if (null === findInstanceBlockingTarget(submitterOrAction || form))
                continue;
              else break;
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i2, 3), i2 -= 3, form = {
              pending: true,
              data: formData,
              method: form.method,
              action: submitterOrAction
            }, Object.freeze(form), startHostTransition(
              formInst,
              form,
              submitterOrAction,
              formData
            ));
          }
        }
      ));
    }
    function retryIfBlockedOn(unblocked) {
      function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
      }
      null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
      null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
      null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
      queuedPointers.forEach(unblock);
      queuedPointerCaptures.forEach(unblock);
      for (var i2 = 0; i2 < queuedExplicitHydrationTargets.length; i2++) {
        var queuedTarget = queuedExplicitHydrationTargets[i2];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
      }
      for (; 0 < queuedExplicitHydrationTargets.length && (i2 = queuedExplicitHydrationTargets[0], null === i2.blockedOn); )
        attemptExplicitHydrationTarget(i2), null === i2.blockedOn && queuedExplicitHydrationTargets.shift();
      i2 = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
      if (null != i2)
        for (queuedTarget = 0; queuedTarget < i2.length; queuedTarget += 3) {
          var form = i2[queuedTarget], submitterOrAction = i2[queuedTarget + 1], formProps = form[internalPropsKey] || null;
          if ("function" === typeof submitterOrAction)
            formProps || scheduleReplayQueueIfNeeded(i2);
          else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction"))
              if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null)
                action = formProps.formAction;
              else {
                if (null !== findInstanceBlockingTarget(form)) continue;
              }
            else action = formProps.action;
            "function" === typeof action ? i2[queuedTarget + 1] = action : (i2.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i2);
          }
        }
    }
    function defaultOnDefaultTransitionIndicator() {
      function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
          handler: function() {
            return new Promise(function(resolve) {
              return pendingResolve = resolve;
            });
          },
          focusReset: "manual",
          scroll: "manual"
        });
      }
      function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
      }
      function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
          var currentEntry = navigation.currentEntry;
          currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
            state: currentEntry.getState(),
            info: "react-transition",
            history: "replace"
          });
        }
      }
      if ("object" === typeof navigation) {
        var isCancelled = false, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
          isCancelled = true;
          navigation.removeEventListener("navigate", handleNavigate);
          navigation.removeEventListener(
            "navigatesuccess",
            handleNavigateComplete
          );
          navigation.removeEventListener(
            "navigateerror",
            handleNavigateComplete
          );
          null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
      }
    }
    function ReactDOMRoot(internalRoot) {
      this._internalRoot = internalRoot;
    }
    function ReactDOMHydrationRoot(internalRoot) {
      this._internalRoot = internalRoot;
    }
    function warnIfReactDOMContainerInDEV(container) {
      container[internalContainerInstanceKey] && (container._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Scheduler2 = requireScheduler(), React2 = React__default, ReactDOM = require$$2, assign2 = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, NotPending = Object.freeze({
      pending: false,
      data: null,
      method: null,
      action: null
    }), valueStack = [];
    var fiberStack = [];
    var index$jscomp$0 = -1, contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = true;
    var prefix, suffix, reentry = false;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var current2 = null, isRendering = false, hasOwnProperty2 = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler2.unstable_scheduleCallback, cancelCallback$1 = Scheduler2.unstable_cancelCallback, shouldYield = Scheduler2.unstable_shouldYield, requestPaint = Scheduler2.unstable_requestPaint, now$12 = Scheduler2.unstable_now, getCurrentPriorityLevel = Scheduler2.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler2.unstable_ImmediatePriority, UserBlockingPriority = Scheduler2.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler2.unstable_NormalPriority, LowPriority = Scheduler2.unstable_LowPriority, IdlePriority = Scheduler2.unstable_IdlePriority, log$12 = Scheduler2.log, unstable_setDisableYieldValue = Scheduler2.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, hasLoggedError = false, isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log3 = Math.log, LN2 = Math.LN2, nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304, DiscreteEventPriority = 2, ContinuousEventPriority = 8, DefaultEventPriority = 32, IdleEventPriority = 268435456, randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, allNativeEvents = /* @__PURE__ */ new Set(), registrationNameDependencies = {}, possibleRegistrationNames = {}, hasReadOnlyValue = {
      button: true,
      checkbox: true,
      image: true,
      hidden: true,
      radio: true,
      reset: true,
      submit: true
    }, VALID_ATTRIBUTE_NAME_REGEX = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {}, escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g, didWarnValueDefaultValue$1 = false, didWarnCheckedDefaultChecked = false, didWarnSelectedSetOnOption = false, didWarnInvalidChild = false, didWarnInvalidInnerHTML = false;
    var didWarnValueDefaultValue = false;
    var valuePropNames = ["value", "defaultValue"], didWarnValDefaultVal = false, needsEscaping = /["'&<>\n\t]|^\s|\s$/, specialTags = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), inScopeTags = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), buttonScopeTags = inScopeTags.concat(["button"]), impliedEndTags = "dd dt li option optgroup p rp rt".split(" "), emptyAncestorInfoDev = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: false
    }, didWarn = {}, shorthandToLonghand = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, uppercasePattern = /([A-Z])/g, msPattern$1 = /^ms-/, badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, badStyleValueWithSemicolonPattern = /;\s*$/, warnedStyleNames = {}, warnedStyleValues = {}, warnedForNaNValue = false, warnedForInfinityValue = false, unitlessNumbers = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML", SVG_NAMESPACE = "http://www.w3.org/2000/svg", aliases = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), possibleStandardNames = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, ariaProperties = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0,
      "aria-braillelabel": 0,
      "aria-brailleroledescription": 0,
      "aria-colindextext": 0,
      "aria-rowindextext": 0
    }, warnedProperties$1 = {}, rARIA$1 = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), rARIACamel$1 = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), didWarnValueNull = false, warnedProperties = {}, EVENT_NAME_REGEX = /^on./, INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/, rARIA = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), rARIACamel = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, currentReplayingEvent = null, restoreTarget = null, restoreQueue = null, isInsideEventHandler = false, canUseDOM2 = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = false;
    if (canUseDOM2)
      try {
        var options$jscomp$0 = {};
        Object.defineProperty(options$jscomp$0, "passive", {
          get: function() {
            passiveBrowserEventsSupported = true;
          }
        });
        window.addEventListener("test", options$jscomp$0, options$jscomp$0);
        window.removeEventListener("test", options$jscomp$0, options$jscomp$0);
      } catch (e2) {
        passiveBrowserEventsSupported = false;
      }
    var root2 = null, startText = null, fallbackText = null, EventInterface = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(event) {
        return event.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign2({}, EventInterface, { view: 0, detail: 0 }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign2({}, UIEventInterface, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: getEventModifierState,
      button: 0,
      buttons: 0,
      relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
      },
      movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
      },
      movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
      }
    }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign2({}, MouseEventInterface, { dataTransfer: 0 }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign2({}, UIEventInterface, { relatedTarget: 0 }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign2({}, EventInterface, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign2({}, EventInterface, {
      clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
      }
    }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign2({}, EventInterface, { data: 0 }), SyntheticCompositionEvent = createSyntheticEvent(
      CompositionEventInterface
    ), SyntheticInputEvent = SyntheticCompositionEvent, normalizeKey = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, translateToKey = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, modifierKeyToProp = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, KeyboardEventInterface = assign2({}, UIEventInterface, {
      key: function(nativeEvent) {
        if (nativeEvent.key) {
          var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
          if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: getEventModifierState,
      charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
      },
      keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
      },
      which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
      }
    }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign2({}, MouseEventInterface, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign2({}, UIEventInterface, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: getEventModifierState
    }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign2({}, EventInterface, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign2({}, MouseEventInterface, {
      deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
      },
      deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign2({}, EventInterface, {
      newState: 0,
      oldState: 0
    }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [9, 13, 27, 32], START_KEYCODE = 229, canUseCompositionEvent = canUseDOM2 && "CompositionEvent" in window, documentMode = null;
    canUseDOM2 && "documentMode" in document && (documentMode = document.documentMode);
    var canUseTextInputEvent = canUseDOM2 && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM2 && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CODE = 32, SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE), hasSpaceKeypress = false, isComposing = false, supportedInputTypes = {
      color: true,
      date: true,
      datetime: true,
      "datetime-local": true,
      email: true,
      month: true,
      number: true,
      password: true,
      range: true,
      search: true,
      tel: true,
      text: true,
      time: true,
      url: true,
      week: true
    }, activeElement$1 = null, activeElementInst$1 = null, isInputEventSupported = false;
    canUseDOM2 && (isInputEventSupported = isEventSupported("input") && (!document.documentMode || 9 < document.documentMode));
    var objectIs = "function" === typeof Object.is ? Object.is : is2, skipSelectionChangeEvent = canUseDOM2 && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = false, vendorPrefixes = {
      animationend: makePrefixMap("Animation", "AnimationEnd"),
      animationiteration: makePrefixMap("Animation", "AnimationIteration"),
      animationstart: makePrefixMap("Animation", "AnimationStart"),
      transitionrun: makePrefixMap("Transition", "TransitionRun"),
      transitionstart: makePrefixMap("Transition", "TransitionStart"),
      transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
      transitionend: makePrefixMap("Transition", "TransitionEnd")
    }, prefixedEventNames = {}, style = {};
    canUseDOM2 && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
    var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = /* @__PURE__ */ new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    simpleEventPluginEvents.push("scrollEnd");
    var lastResetTime = 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var localPerformance = performance;
      var getCurrentTime = function() {
        return localPerformance.now();
      };
    } else {
      var localDate = Date;
      getCurrentTime = function() {
        return localDate.now();
      };
    }
    var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
      if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
          bubbles: true,
          cancelable: true,
          message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
          error
        });
        if (!window.dispatchEvent(event)) return;
      } else if ("object" === typeof process && "function" === typeof process.emit) {
        process.emit("uncaughtException", error);
        return;
      }
      console.error(error);
    }, OMITTED_PROP_ERROR = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", EMPTY_ARRAY = 0, COMPLEX_ARRAY = 1, PRIMITIVE_ARRAY = 2, ENTRIES_ARRAY = 3, REMOVED = "– ", ADDED = "+ ", UNCHANGED = "  ", supportsUserTiming = "undefined" !== typeof console && "function" === typeof console.timeStamp && "undefined" !== typeof performance && "function" === typeof performance.measure, COMPONENTS_TRACK = "Components ⚛", LANES_TRACK_GROUP = "Scheduler ⚛", currentTrack = "Blocking", alreadyWarnedForDeepEquality = false, reusableComponentDevToolDetails = {
      color: "primary",
      properties: null,
      tooltipText: "",
      track: COMPONENTS_TRACK
    }, reusableComponentOptions = {
      start: -0,
      end: -0,
      detail: { devtools: reusableComponentDevToolDetails }
    }, resuableChangedPropsEntry = ["Changed Props", ""], DEEP_EQUALITY_WARNING = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", reusableDeeplyEqualPropsEntry = ["Changed Props", DEEP_EQUALITY_WARNING], OffscreenVisible = 1, OffscreenPassiveEffectsConnected = 2, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var resolveFamily = null, failedBoundaries = null, NoMode = 0, ConcurrentMode = 1, ProfileMode = 2, StrictLegacyMode = 8, StrictEffectsMode = 16, SuspenseyImagesMode = 32;
    var hasBadMapPolyfill = false;
    try {
      var nonExtensibleObject = Object.preventExtensions({});
      /* @__PURE__ */ new Map([[nonExtensibleObject, null]]);
      /* @__PURE__ */ new Set([nonExtensibleObject]);
    } catch (e$3) {
      hasBadMapPolyfill = true;
    }
    var CapturedStacks = /* @__PURE__ */ new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = false, didSuspendOrErrorDEV = false, hydrationDiffRootDEV = null, hydrationErrors = null, rootOrSingletonContext = false, HydrationMismatchException = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), valueCursor = createCursor(null);
    var rendererCursorDEV = createCursor(null);
    var rendererSigil = {};
    var currentlyRenderingFiber$1 = null, lastContextDependency = null, isDisallowedContextReadInDEV = false, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
      var listeners = [], signal = this.signal = {
        aborted: false,
        addEventListener: function(type, listener) {
          listeners.push(listener);
        }
      };
      this.abort = function() {
        signal.aborted = true;
        listeners.forEach(function(listener) {
          return listener();
        });
      };
    }, scheduleCallback$2 = Scheduler2.unstable_scheduleCallback, NormalPriority = Scheduler2.unstable_NormalPriority, CacheContext = {
      $$typeof: REACT_CONTEXT_TYPE,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, now2 = Scheduler2.unstable_now, createTask = console.createTask ? console.createTask : function() {
      return null;
    }, SPAWNED_UPDATE = 1, PINGED_UPDATE = 2, renderStartTime = -0, commitStartTime = -0, commitEndTime = -0, commitErrors = null, profilerStartTime = -1.1, profilerEffectDuration = -0, componentEffectDuration = -0, componentEffectStartTime = -1.1, componentEffectEndTime = -1.1, componentEffectErrors = null, componentEffectSpawnedUpdate = false, blockingClampTime = -0, blockingUpdateTime = -1.1, blockingUpdateTask = null, blockingUpdateType = 0, blockingUpdateMethodName = null, blockingUpdateComponentName = null, blockingEventTime = -1.1, blockingEventType = null, blockingEventRepeatTime = -1.1, blockingSuspendedTime = -1.1, transitionClampTime = -0, transitionStartTime = -1.1, transitionUpdateTime = -1.1, transitionUpdateType = 0, transitionUpdateTask = null, transitionUpdateMethodName = null, transitionUpdateComponentName = null, transitionEventTime = -1.1, transitionEventType = null, transitionEventRepeatTime = -1.1, transitionSuspendedTime = -1.1, retryClampTime = -0, idleClampTime = -0, animatingLanes = 0, animatingTask = null, yieldReason = 0, yieldStartTime = -1.1, currentUpdateIsNested = false, nestedUpdateScheduled = false, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
      globalMostRecentTransitionTime = now$12();
      if ("object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then) {
        if (0 > transitionStartTime && 0 > transitionUpdateTime) {
          transitionStartTime = now2();
          var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
          if (newEventTime !== transitionEventRepeatTime || newEventType !== transitionEventType)
            transitionEventRepeatTime = -1.1;
          transitionEventTime = newEventTime;
          transitionEventType = newEventType;
        }
        entangleAsyncAction(transition, returnValue);
      }
      null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), ReactStrictModeWarnings = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, pendingComponentWillMountWarnings = [], pendingUNSAFE_ComponentWillMountWarnings = [], pendingComponentWillReceivePropsWarnings = [], pendingUNSAFE_ComponentWillReceivePropsWarnings = [], pendingComponentWillUpdateWarnings = [], pendingUNSAFE_ComponentWillUpdateWarnings = [], didWarnAboutUnsafeLifecycles = /* @__PURE__ */ new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
      didWarnAboutUnsafeLifecycles.has(fiber.type) || ("function" === typeof instance.componentWillMount && true !== instance.componentWillMount.__suppressDeprecationWarning && pendingComponentWillMountWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillMount && pendingUNSAFE_ComponentWillMountWarnings.push(fiber), "function" === typeof instance.componentWillReceiveProps && true !== instance.componentWillReceiveProps.__suppressDeprecationWarning && pendingComponentWillReceivePropsWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillReceiveProps && pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber), "function" === typeof instance.componentWillUpdate && true !== instance.componentWillUpdate.__suppressDeprecationWarning && pendingComponentWillUpdateWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillUpdate && pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
      var componentWillMountUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillMountWarnings.length && (pendingComponentWillMountWarnings.forEach(function(fiber) {
        componentWillMountUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillMountWarnings = []);
      var UNSAFE_componentWillMountUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillMountWarnings.length && (pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
        UNSAFE_componentWillMountUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingUNSAFE_ComponentWillMountWarnings = []);
      var componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillReceivePropsWarnings.length && (pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
        componentWillReceivePropsUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillReceivePropsWarnings = []);
      var UNSAFE_componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length && (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(
        function(fiber) {
          UNSAFE_componentWillReceivePropsUniqueNames.add(
            getComponentNameFromFiber(fiber) || "Component"
          );
          didWarnAboutUnsafeLifecycles.add(fiber.type);
        }
      ), pendingUNSAFE_ComponentWillReceivePropsWarnings = []);
      var componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillUpdateWarnings.length && (pendingComponentWillUpdateWarnings.forEach(function(fiber) {
        componentWillUpdateUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillUpdateWarnings = []);
      var UNSAFE_componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillUpdateWarnings.length && (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
        UNSAFE_componentWillUpdateUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingUNSAFE_ComponentWillUpdateWarnings = []);
      if (0 < UNSAFE_componentWillMountUniqueNames.size) {
        var sortedNames = setToSortedString(
          UNSAFE_componentWillMountUniqueNames
        );
        console.error(
          "Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s",
          sortedNames
        );
      }
      0 < UNSAFE_componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(
        UNSAFE_componentWillReceivePropsUniqueNames
      ), console.error(
        "Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < UNSAFE_componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(
        UNSAFE_componentWillUpdateUniqueNames
      ), console.error(
        "Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillMountUniqueNames.size && (sortedNames = setToSortedString(componentWillMountUniqueNames), console.warn(
        "componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(
        componentWillReceivePropsUniqueNames
      ), console.warn(
        "componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(componentWillUpdateUniqueNames), console.warn(
        "componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
    };
    var pendingLegacyContextWarning = /* @__PURE__ */ new Map(), didWarnAboutLegacyContext = /* @__PURE__ */ new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
      var strictRoot = null;
      for (var node = fiber; null !== node; )
        node.mode & StrictLegacyMode && (strictRoot = node), node = node.return;
      null === strictRoot ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !didWarnAboutLegacyContext.has(fiber.type) && (node = pendingLegacyContextWarning.get(strictRoot), null != fiber.type.contextTypes || null != fiber.type.childContextTypes || null !== instance && "function" === typeof instance.getChildContext) && (void 0 === node && (node = [], pendingLegacyContextWarning.set(strictRoot, node)), node.push(fiber));
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
      pendingLegacyContextWarning.forEach(function(fiberArray) {
        if (0 !== fiberArray.length) {
          var firstFiber = fiberArray[0], uniqueNames = /* @__PURE__ */ new Set();
          fiberArray.forEach(function(fiber) {
            uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutLegacyContext.add(fiber.type);
          });
          var sortedNames = setToSortedString(uniqueNames);
          runWithFiberInDEV(firstFiber, function() {
            console.error(
              "Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context",
              sortedNames
            );
          });
        }
      });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
      pendingComponentWillMountWarnings = [];
      pendingUNSAFE_ComponentWillMountWarnings = [];
      pendingComponentWillReceivePropsWarnings = [];
      pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
      pendingComponentWillUpdateWarnings = [];
      pendingUNSAFE_ComponentWillUpdateWarnings = [];
      pendingLegacyContextWarning = /* @__PURE__ */ new Map();
    };
    var callComponent = {
      react_stack_bottom_frame: function(Component, props2, secondArg) {
        var wasRendering = isRendering;
        isRendering = true;
        try {
          return Component(props2, secondArg);
        } finally {
          isRendering = wasRendering;
        }
      }
    }, callComponentInDEV = callComponent.react_stack_bottom_frame.bind(callComponent), callRender = {
      react_stack_bottom_frame: function(instance) {
        var wasRendering = isRendering;
        isRendering = true;
        try {
          return instance.render();
        } finally {
          isRendering = wasRendering;
        }
      }
    }, callRenderInDEV = callRender.react_stack_bottom_frame.bind(callRender), callComponentDidMount = {
      react_stack_bottom_frame: function(finishedWork, instance) {
        try {
          instance.componentDidMount();
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
    }, callComponentDidMountInDEV = callComponentDidMount.react_stack_bottom_frame.bind(
      callComponentDidMount
    ), callComponentDidUpdate = {
      react_stack_bottom_frame: function(finishedWork, instance, prevProps, prevState, snapshot) {
        try {
          instance.componentDidUpdate(prevProps, prevState, snapshot);
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
    }, callComponentDidUpdateInDEV = callComponentDidUpdate.react_stack_bottom_frame.bind(
      callComponentDidUpdate
    ), callComponentDidCatch = {
      react_stack_bottom_frame: function(instance, errorInfo) {
        var stack = errorInfo.stack;
        instance.componentDidCatch(errorInfo.value, {
          componentStack: null !== stack ? stack : ""
        });
      }
    }, callComponentDidCatchInDEV = callComponentDidCatch.react_stack_bottom_frame.bind(
      callComponentDidCatch
    ), callComponentWillUnmount = {
      react_stack_bottom_frame: function(current3, nearestMountedAncestor, instance) {
        try {
          instance.componentWillUnmount();
        } catch (error) {
          captureCommitPhaseError(current3, nearestMountedAncestor, error);
        }
      }
    }, callComponentWillUnmountInDEV = callComponentWillUnmount.react_stack_bottom_frame.bind(
      callComponentWillUnmount
    ), callCreate = {
      react_stack_bottom_frame: function(effect) {
        var create2 = effect.create;
        effect = effect.inst;
        create2 = create2();
        return effect.destroy = create2;
      }
    }, callCreateInDEV = callCreate.react_stack_bottom_frame.bind(callCreate), callDestroy = {
      react_stack_bottom_frame: function(current3, nearestMountedAncestor, destroy) {
        try {
          destroy();
        } catch (error) {
          captureCommitPhaseError(current3, nearestMountedAncestor, error);
        }
      }
    }, callDestroyInDEV = callDestroy.react_stack_bottom_frame.bind(callDestroy), callLazyInit = {
      react_stack_bottom_frame: function(lazy2) {
        var init2 = lazy2._init;
        return init2(lazy2._payload);
      }
    }, callLazyInitInDEV = callLazyInit.react_stack_bottom_frame.bind(callLazyInit), SuspenseException = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), SuspenseyCommitException = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), SuspenseActionException = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), noopSuspenseyCommitThenable = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, suspendedThenable = null, needsToResetSuspendedThenableDEV = false, thenableState$1 = null, thenableIndexCounter$1 = 0, currentDebugInfo = null, didWarnAboutMaps;
    var didWarnAboutGenerators = didWarnAboutMaps = false;
    var ownerHasKeyUseWarning = {};
    var ownerHasFunctionTypeWarning = {};
    var ownerHasSymbolTypeWarning = {};
    warnForMissingKey = function(returnFiber, workInProgress2, child) {
      if (null !== child && "object" === typeof child && child._store && (!child._store.validated && null == child.key || 2 === child._store.validated)) {
        if ("object" !== typeof child._store)
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        child._store.validated = 1;
        var componentName2 = getComponentNameFromFiber(returnFiber), componentKey = componentName2 || "null";
        if (!ownerHasKeyUseWarning[componentKey]) {
          ownerHasKeyUseWarning[componentKey] = true;
          child = child._owner;
          returnFiber = returnFiber._debugOwner;
          var currentComponentErrorInfo = "";
          returnFiber && "number" === typeof returnFiber.tag && (componentKey = getComponentNameFromFiber(returnFiber)) && (currentComponentErrorInfo = "\n\nCheck the render method of `" + componentKey + "`.");
          currentComponentErrorInfo || componentName2 && (currentComponentErrorInfo = "\n\nCheck the top-level render call using <" + componentName2 + ">.");
          var childOwnerAppendix = "";
          null != child && returnFiber !== child && (componentName2 = null, "number" === typeof child.tag ? componentName2 = getComponentNameFromFiber(child) : "string" === typeof child.name && (componentName2 = child.name), componentName2 && (childOwnerAppendix = " It was passed a child from " + componentName2 + "."));
          runWithFiberInDEV(workInProgress2, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              currentComponentErrorInfo,
              childOwnerAppendix
            );
          });
        }
      }
    };
    var reconcileChildFibers = createChildReconciler(true), mountChildFibers = createChildReconciler(false), UpdateState = 0, ReplaceState = 1, ForceUpdate = 2, CaptureUpdate = 3, hasForceUpdate = false;
    var didWarnUpdateInsideUpdate = false;
    var currentlyProcessingQueue = null;
    var didReadFromEntangledAsyncAction = false, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, SubtreeSuspenseContextMask = 1, ForceSuspenseFallback = 2, suspenseStackCursor = createCursor(0), NoFlags = 0, HasEffect = 1, Insertion = 2, Layout = 4, Passive = 8, didWarnUncachedGetSnapshot;
    var didWarnAboutMismatchedHooksForComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUseWrappedInTryCatch = /* @__PURE__ */ new Set();
    var didWarnAboutAsyncClientComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUseFormState = /* @__PURE__ */ new Set();
    var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = false, didScheduleRenderPhaseUpdateDuringThisPass = false, shouldDoubleInvokeUserFnsInHooksDEV = false, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0, RE_RENDER_LIMIT = 25, currentHookNameInDev = null, hookTypesDev = null, hookTypesUpdateIndexDev = -1, ignorePreviousDependencies = false, ContextOnlyDispatcher = {
      readContext,
      use,
      useCallback: throwInvalidHookError,
      useContext: throwInvalidHookError,
      useEffect: throwInvalidHookError,
      useImperativeHandle: throwInvalidHookError,
      useLayoutEffect: throwInvalidHookError,
      useInsertionEffect: throwInvalidHookError,
      useMemo: throwInvalidHookError,
      useReducer: throwInvalidHookError,
      useRef: throwInvalidHookError,
      useState: throwInvalidHookError,
      useDebugValue: throwInvalidHookError,
      useDeferredValue: throwInvalidHookError,
      useTransition: throwInvalidHookError,
      useSyncExternalStore: throwInvalidHookError,
      useId: throwInvalidHookError,
      useHostTransitionStatus: throwInvalidHookError,
      useFormState: throwInvalidHookError,
      useActionState: throwInvalidHookError,
      useOptimistic: throwInvalidHookError,
      useMemoCache: throwInvalidHookError,
      useCacheRefresh: throwInvalidHookError
    };
    ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
    var HooksDispatcherOnMountInDEV = null, HooksDispatcherOnMountWithHookTypesInDEV = null, HooksDispatcherOnUpdateInDEV = null, HooksDispatcherOnRerenderInDEV = null, InvalidNestedHooksDispatcherOnMountInDEV = null, InvalidNestedHooksDispatcherOnUpdateInDEV = null, InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    HooksDispatcherOnMountInDEV = {
      readContext: function(context) {
        return readContext(context);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        mountHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountEffect(create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        mountEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountLayoutEffect(create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        mountHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        mountHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        mountHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        mountHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        mountHookTypesDev();
        return mountSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        mountHookTypesDev();
        return mountId();
      },
      useFormState: function(action, initialState2) {
        currentHookNameInDev = "useFormState";
        mountHookTypesDev();
        warnOnUseFormStateInDev();
        return mountActionState(action, initialState2);
      },
      useActionState: function(action, initialState2) {
        currentHookNameInDev = "useActionState";
        mountHookTypesDev();
        return mountActionState(action, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        mountHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        mountHookTypesDev();
        return mountRefresh();
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        mountHookTypesDev();
        return mountEvent(callback);
      }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
      readContext: function(context) {
        return readContext(context);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return mountCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        return mountEffect(create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return mountImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        mountEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return mountLayoutEffect(create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return mountSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return mountId();
      },
      useActionState: function(action, initialState2) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return mountActionState(action, initialState2);
      },
      useFormState: function(action, initialState2) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return mountActionState(action, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return mountRefresh();
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        updateHookTypesDev();
        return mountEvent(callback);
      }
    };
    HooksDispatcherOnUpdateInDEV = {
      readContext: function(context) {
        return readContext(context);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return updateImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return updateDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return updateTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return updateActionState(action);
      },
      useActionState: function(action) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return updateActionState(action);
      },
      useOptimistic: function(passthrough, reducer) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return updateOptimistic(passthrough, reducer);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        updateHookTypesDev();
        return updateEvent(callback);
      }
    };
    HooksDispatcherOnRerenderInDEV = {
      readContext: function(context) {
        return readContext(context);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return updateImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return updateMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return rerenderReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return rerenderReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return rerenderDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return rerenderTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return rerenderActionState(action);
      },
      useActionState: function(action) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return rerenderActionState(action);
      },
      useOptimistic: function(passthrough, reducer) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return rerenderOptimistic(passthrough, reducer);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        updateHookTypesDev();
        return updateEvent(callback);
      }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
      readContext: function(context) {
        warnInvalidContextAccess();
        return readContext(context);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountEffect(create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        mountEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountLayoutEffect(create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        mountHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountId();
      },
      useFormState: function(action, initialState2) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountActionState(action, initialState2);
      },
      useActionState: function(action, initialState2) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountActionState(action, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        mountHookTypesDev();
        return mountRefresh();
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountEvent(callback);
      }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
      readContext: function(context) {
        warnInvalidContextAccess();
        return readContext(context);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateActionState(action);
      },
      useActionState: function(action) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateActionState(action);
      },
      useOptimistic: function(passthrough, reducer) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateOptimistic(passthrough, reducer);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEvent(callback);
      }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
      readContext: function(context) {
        warnInvalidContextAccess();
        return readContext(context);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return rerenderReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return rerenderReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderActionState(action);
      },
      useActionState: function(action) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderActionState(action);
      },
      useOptimistic: function(passthrough, reducer) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderOptimistic(passthrough, reducer);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEvent(callback);
      }
    };
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUninitializedState = /* @__PURE__ */ new Set();
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */ new Set();
    var didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */ new Set();
    var didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */ new Set();
    var didWarnAboutUndefinedDerivedState = /* @__PURE__ */ new Set();
    var didWarnAboutContextTypes$1 = /* @__PURE__ */ new Set();
    var didWarnAboutChildContextTypes = /* @__PURE__ */ new Set();
    var didWarnAboutInvalidateContextType = /* @__PURE__ */ new Set();
    var didWarnOnInvalidCallback = /* @__PURE__ */ new Set();
    Object.freeze(fakeInternalInstance);
    var classComponentUpdater = {
      enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (startUpdateTimerByLane(lane, "this.setState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
      },
      enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update = createUpdate(lane);
        update.tag = ReplaceState;
        update.payload = payload;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (startUpdateTimerByLane(lane, "this.replaceState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
      },
      enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update = createUpdate(lane);
        update.tag = ForceUpdate;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (startUpdateTimerByLane(lane, "this.forceUpdate()", inst), scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
      }
    }, componentName = null, errorBoundaryName = null, SelectiveHydrationException = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), didReceiveUpdate = false;
    var didWarnAboutBadClass = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutContextTypes = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = false;
    var didWarnAboutRevealOrder = {};
    var didWarnAboutTailOptions = {};
    var SUSPENDED_MARKER = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, hasWarnedAboutUsingNoValuePropOnContextProvider = false, didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = /* @__PURE__ */ new Set();
    var offscreenSubtreeIsHidden = false, offscreenSubtreeWasHidden = false, needsFormReset = false, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, inProgressLanes = null, inProgressRoot = null, hostParent = null, hostParentIsContainer = false, currentHoistableRoot = null, inHydratedSubtree = false, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
      getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
      },
      cacheSignal: function() {
        return readContext(CacheContext).controller.signal;
      },
      getOwner: function() {
        return current2;
      }
    };
    if ("function" === typeof Symbol && Symbol.for) {
      var symbolFor = Symbol.for;
      symbolFor("selector.component");
      symbolFor("selector.has_pseudo_class");
      symbolFor("selector.role");
      symbolFor("selector.test_id");
      symbolFor("selector.text");
    }
    var commitHooks = [], PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, NoContext = 0, RenderContext = 2, CommitContext = 4, RootInProgress = 0, RootFatalErrored = 1, RootErrored = 2, RootSuspended = 3, RootSuspendedWithDelay = 4, RootSuspendedAtTheShell = 6, RootCompleted = 5, executionContext = NoContext, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, NotSuspended = 0, SuspendedOnError = 1, SuspendedOnData = 2, SuspendedOnImmediate = 3, SuspendedOnInstance = 4, SuspendedOnInstanceAndReadyToContinue = 5, SuspendedOnDeprecatedThrowPromise = 6, SuspendedAndReadyToContinue = 7, SuspendedOnHydration = 8, SuspendedOnAction = 9, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = false, workInProgressRootIsPrerendering = false, workInProgressRootDidAttachPingListener = false, entangledRenderLanes = 0, workInProgressRootExitStatus = RootInProgress, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = false, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, FALLBACK_THROTTLE_MS = 300, workInProgressRootRenderTargetTime = Infinity, RENDER_TIMEOUT_MS = 500, workInProgressTransitions = null, workInProgressUpdateTask = null, legacyErrorBoundariesThatAlreadyFailed = null, IMMEDIATE_COMMIT = 0, ABORTED_VIEW_TRANSITION_COMMIT = 1, DELAYED_PASSIVE_COMMIT = 2, ANIMATION_STARTED_COMMIT = 3, NO_PENDING_EFFECTS = 0, PENDING_MUTATION_PHASE = 1, PENDING_LAYOUT_PHASE = 2, PENDING_AFTER_MUTATION_PHASE = 3, PENDING_SPAWNED_WORK = 4, PENDING_PASSIVE_PHASE = 5, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingEffectsRenderEndTime = -0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, pendingSuspendedCommitReason = null, pendingDelayedCommitReason = IMMEDIATE_COMMIT, pendingSuspendedViewTransitionReason = null, NESTED_UPDATE_LIMIT = 50, nestedUpdateCount = 0, rootWithNestedUpdates = null, isFlushingPassiveEffects = false, didScheduleUpdateDuringPassiveEffects = false, NESTED_PASSIVE_UPDATE_LIMIT = 50, nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, isRunningInsertionEffect = false, didWarnStateUpdateForNotYetMountedComponent = null, didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent = /* @__PURE__ */ new Set();
    var fakeActCallbackNode$1 = {}, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = false, didScheduleMicrotask_act = false, mightHavePendingSyncWork = false, isFlushingWork = false, currentEventTransitionLane = 0, fakeActCallbackNode = {};
    (function() {
      for (var i2 = 0; i2 < simpleEventPluginEvents.length; i2++) {
        var eventName = simpleEventPluginEvents[i2], domEventName = eventName.toLowerCase();
        eventName = eventName[0].toUpperCase() + eventName.slice(1);
        registerSimpleEvent(domEventName, "on" + eventName);
      }
      registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
      registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
      registerSimpleEvent(ANIMATION_START, "onAnimationStart");
      registerSimpleEvent("dblclick", "onDoubleClick");
      registerSimpleEvent("focusin", "onFocus");
      registerSimpleEvent("focusout", "onBlur");
      registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
      registerSimpleEvent(TRANSITION_START, "onTransitionStart");
      registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
      registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    })();
    registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
    registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
    registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
    registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
    registerTwoPhaseEvent(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    );
    registerTwoPhaseEvent(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    );
    registerTwoPhaseEvent("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]);
    registerTwoPhaseEvent(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    );
    registerTwoPhaseEvent(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    );
    registerTwoPhaseEvent(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), nonDelegatedEvents = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)
    ), listeningMarker = "_reactListening" + Math.random().toString(36).slice(2), didWarnControlledToUncontrolled = false, didWarnUncontrolledToControlled = false, didWarnFormActionType = false, didWarnFormActionName = false, didWarnFormActionTarget = false, didWarnFormActionMethod = false, didWarnPopoverTargetObject = false;
    var didWarnForNewBooleanPropsWithEmptyValue = {};
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g, xlinkNamespace = "http://www.w3.org/1999/xlink", xmlNamespace = "http://www.w3.org/XML/1998/namespace", EXPECTED_FORM_ACTION_URL = "javascript:throw new Error('React form unexpectedly submitted.')", SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning", ACTIVITY_START_DATA = "&", ACTIVITY_END_DATA = "/&", SUSPENSE_START_DATA = "$", SUSPENSE_END_DATA = "/$", SUSPENSE_PENDING_START_DATA = "$?", SUSPENSE_QUEUED_START_DATA = "$~", SUSPENSE_FALLBACK_START_DATA = "$!", PREAMBLE_CONTRIBUTION_HTML = "html", PREAMBLE_CONTRIBUTION_BODY = "body", PREAMBLE_CONTRIBUTION_HEAD = "head", FORM_STATE_IS_MATCHING = "F!", FORM_STATE_IS_NOT_MATCHING = "F", DOCUMENT_READY_STATE_LOADING = "loading", STYLE = "style", HostContextNamespaceNone = 0, HostContextNamespaceSvg = 1, HostContextNamespaceMath = 2, eventsEnabled = null, selectionInformation = null, warnedUnknownTags = { dialog: true, webview: true }, currentPopstateTransitionEvent = null, schedulerEvent = void 0, scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, noTimeout = -1, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
      return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout, previousHydratableOnEnteringScopedSingleton = null, NotLoaded = 0, Loaded = 1, Errored = 2, Settled = 3, Inserted = 4, preloadPropsMap = /* @__PURE__ */ new Map(), preconnectsSet = /* @__PURE__ */ new Set(), previousDispatcher = ReactDOMSharedInternals.d;
    ReactDOMSharedInternals.d = {
      f: function() {
        var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
        return previousWasRendering || wasRendering;
      },
      r: function(form) {
        var formInst = getInstanceFromNode(form);
        null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
      },
      D: function(href) {
        previousDispatcher.D(href);
        preconnectAs("dns-prefetch", href, null);
      },
      C: function(href, crossOrigin) {
        previousDispatcher.C(href, crossOrigin);
        preconnectAs("preconnect", href, crossOrigin);
      },
      L: function(href, as, options2) {
        previousDispatcher.L(href, as, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && href && as) {
          var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
          "image" === as ? options2 && options2.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(
            options2.imageSrcSet
          ) + '"]', "string" === typeof options2.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(
            options2.imageSizes
          ) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
          var key = preloadSelector;
          switch (as) {
            case "style":
              key = getStyleKey(href);
              break;
            case "script":
              key = getScriptKey(href);
          }
          preloadPropsMap.has(key) || (href = assign2(
            {
              rel: "preload",
              href: "image" === as && options2 && options2.imageSrcSet ? void 0 : href,
              as
            },
            options2
          ), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(
            getStylesheetSelectorFromKey(key)
          ) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
        }
      },
      m: function(href, options2) {
        previousDispatcher.m(href, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && href) {
          var as = options2 && "string" === typeof options2.as ? options2.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
          switch (as) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              key = getScriptKey(href);
          }
          if (!preloadPropsMap.has(key) && (href = assign2({ rel: "modulepreload", href }, options2), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch (as) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (ownerDocument.querySelector(getScriptSelectorFromKey(key)))
                  return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
          }
        }
      },
      X: function(src, options2) {
        previousDispatcher.X(src, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && src) {
          var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
          resource || (resource = ownerDocument.querySelector(
            getScriptSelectorFromKey(key)
          ), resource || (src = assign2({ src, async: true }, options2), (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options2), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
          }, scripts.set(key, resource));
        }
      },
      S: function(href, precedence, options2) {
        previousDispatcher.S(href, precedence, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && href) {
          var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
          precedence = precedence || "default";
          var resource = styles.get(key);
          if (!resource) {
            var state = { loading: NotLoaded, preload: null };
            if (resource = ownerDocument.querySelector(
              getStylesheetSelectorFromKey(key)
            ))
              state.loading = Loaded | Inserted;
            else {
              href = assign2(
                {
                  rel: "stylesheet",
                  href,
                  "data-precedence": precedence
                },
                options2
              );
              (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options2);
              var link = resource = ownerDocument.createElement("link");
              markNodeAsHoistable(link);
              setInitialProperties(link, "link", href);
              link._p = new Promise(function(resolve, reject2) {
                link.onload = resolve;
                link.onerror = reject2;
              });
              link.addEventListener("load", function() {
                state.loading |= Loaded;
              });
              link.addEventListener("error", function() {
                state.loading |= Errored;
              });
              state.loading |= Inserted;
              insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
              type: "stylesheet",
              instance: resource,
              count: 1,
              state
            };
            styles.set(key, resource);
          }
        }
      },
      M: function(src, options2) {
        previousDispatcher.M(src, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && src) {
          var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
          resource || (resource = ownerDocument.querySelector(
            getScriptSelectorFromKey(key)
          ), resource || (src = assign2({ src, async: true, type: "module" }, options2), (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options2), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
          }, scripts.set(key, resource));
        }
      }
    };
    var globalDocument = "undefined" === typeof document ? null : document, tagCaches = null, SUSPENSEY_STYLESHEET_TIMEOUT = 6e4, SUSPENSEY_IMAGE_TIMEOUT = 800, SUSPENSEY_IMAGE_TIME_ESTIMATE = 500, estimatedBytesWithinLimit = 0, LAST_PRECEDENCE = null, precedencesByRoot = null, NotPendingTransition = NotPending, HostTransitionContext = {
      $$typeof: REACT_CONTEXT_TYPE,
      Provider: null,
      Consumer: null,
      _currentValue: NotPendingTransition,
      _currentValue2: NotPendingTransition,
      _threadCount: 0
    }, badgeFormat = "%c%s%c", badgeStyle = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", resetStyle = "", pad = " ", bind2 = Function.prototype.bind;
    var didWarnAboutNestedUpdates = false;
    var overrideHookState = null, overrideHookStateDeletePath = null, overrideHookStateRenamePath = null, overrideProps = null, overridePropsDeletePath = null, overridePropsRenamePath = null, scheduleUpdate = null, scheduleRetry = null, setErrorHandler = null, setSuspenseHandler = null;
    overrideHookState = function(fiber, id2, path, value) {
      id2 = findHook(fiber, id2);
      null !== id2 && (path = copyWithSetImpl(id2.memoizedState, path, 0, value), id2.memoizedState = path, id2.baseState = path, fiber.memoizedProps = assign2({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateDeletePath = function(fiber, id2, path) {
      id2 = findHook(fiber, id2);
      null !== id2 && (path = copyWithDeleteImpl(id2.memoizedState, path, 0), id2.memoizedState = path, id2.baseState = path, fiber.memoizedProps = assign2({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateRenamePath = function(fiber, id2, oldPath, newPath) {
      id2 = findHook(fiber, id2);
      null !== id2 && (oldPath = copyWithRename(id2.memoizedState, oldPath, newPath), id2.memoizedState = oldPath, id2.baseState = oldPath, fiber.memoizedProps = assign2({}, fiber.memoizedProps), oldPath = enqueueConcurrentRenderForLane(fiber, 2), null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
    };
    overrideProps = function(fiber, path, value) {
      fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path, 0, value);
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      path = enqueueConcurrentRenderForLane(fiber, 2);
      null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsDeletePath = function(fiber, path) {
      fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path, 0);
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      path = enqueueConcurrentRenderForLane(fiber, 2);
      null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
      fiber.pendingProps = copyWithRename(
        fiber.memoizedProps,
        oldPath,
        newPath
      );
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      oldPath = enqueueConcurrentRenderForLane(fiber, 2);
      null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
    };
    scheduleUpdate = function(fiber) {
      var root3 = enqueueConcurrentRenderForLane(fiber, 2);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2);
    };
    scheduleRetry = function(fiber) {
      var lane = claimNextRetryLane(), root3 = enqueueConcurrentRenderForLane(fiber, lane);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, lane);
    };
    setErrorHandler = function(newShouldErrorImpl) {
      shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
      shouldSuspendImpl = newShouldSuspendImpl;
    };
    var _enabled = true, return_targetInst = null, hasScheduledReplayAttempt = false, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = /* @__PURE__ */ new Map(), queuedPointerCaptures = /* @__PURE__ */ new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), lastScheduledReplayQueue = null;
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
      var root3 = this._internalRoot;
      if (null === root3) throw Error("Cannot update an unmounted root.");
      var args = arguments;
      "function" === typeof args[1] ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : isValidContainer(args[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : "undefined" !== typeof args[1] && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      );
      args = children;
      var current3 = root3.current, lane = requestUpdateLane(current3);
      updateContainerImpl(current3, lane, args, root3, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
      var args = arguments;
      "function" === typeof args[0] && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      );
      args = this._internalRoot;
      if (null !== args) {
        this._internalRoot = null;
        var container = args.containerInfo;
        (executionContext & (RenderContext | CommitContext)) !== NoContext && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        );
        updateContainerImpl(args.current, 2, null, args, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
      }
    };
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
      if (target) {
        var updatePriority = resolveUpdatePriority();
        target = { blockedOn: null, target, priority: updatePriority };
        for (var i2 = 0; i2 < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i2].priority; i2++) ;
        queuedExplicitHydrationTargets.splice(i2, 0, target);
        0 === i2 && attemptExplicitHydrationTarget(target);
      }
    };
    (function() {
      var isomorphicReactPackageVersion = React2.version;
      if ("19.2.1" !== isomorphicReactPackageVersion)
        throw Error(
          'Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:\n  - react:      ' + (isomorphicReactPackageVersion + "\n  - react-dom:  19.2.1\nLearn more: https://react.dev/warnings/version-mismatch")
        );
    })();
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    );
    ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
      var fiber = componentOrElement._reactInternals;
      if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render)
          throw Error("Unable to find node on an unmounted component.");
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(
          "Argument appears to not be a ReactComponent. Keys: " + componentOrElement
        );
      }
      componentOrElement = findCurrentFiberUsingSlowPath(fiber);
      componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
      componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
      return componentOrElement;
    };
    if (!(function() {
      var internals = {
        bundleType: 1,
        version: "19.2.1",
        rendererPackageName: "react-dom",
        currentDispatcherRef: ReactSharedInternals,
        reconcilerVersion: "19.2.1"
      };
      internals.overrideHookState = overrideHookState;
      internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
      internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
      internals.overrideProps = overrideProps;
      internals.overridePropsDeletePath = overridePropsDeletePath;
      internals.overridePropsRenamePath = overridePropsRenamePath;
      internals.scheduleUpdate = scheduleUpdate;
      internals.scheduleRetry = scheduleRetry;
      internals.setErrorHandler = setErrorHandler;
      internals.setSuspenseHandler = setSuspenseHandler;
      internals.scheduleRefresh = scheduleRefresh;
      internals.scheduleRoot = scheduleRoot;
      internals.setRefreshHandler = setRefreshHandler;
      internals.getCurrentFiber = getCurrentFiberForDevTools;
      return injectInternals(internals);
    })() && canUseDOM2 && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Edge") || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var protocol2 = window.location.protocol;
      /^(https?|file):$/.test(protocol2) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + ("file:" === protocol2 ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""),
        "font-weight:bold"
      );
    }
    reactDomClient_development.createRoot = function(container, options2) {
      if (!isValidContainer(container))
        throw Error("Target container is not a DOM element.");
      warnIfReactDOMContainerInDEV(container);
      var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
      null !== options2 && void 0 !== options2 && (options2.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : "object" === typeof options2 && null !== options2 && options2.$$typeof === REACT_ELEMENT_TYPE && console.error(
        "You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"
      ), true === options2.unstable_strictMode && (isStrictMode = true), void 0 !== options2.identifierPrefix && (identifierPrefix = options2.identifierPrefix), void 0 !== options2.onUncaughtError && (onUncaughtError = options2.onUncaughtError), void 0 !== options2.onCaughtError && (onCaughtError = options2.onCaughtError), void 0 !== options2.onRecoverableError && (onRecoverableError = options2.onRecoverableError));
      options2 = createFiberRoot(
        container,
        1,
        false,
        null,
        null,
        isStrictMode,
        identifierPrefix,
        null,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        defaultOnDefaultTransitionIndicator
      );
      container[internalContainerInstanceKey] = options2.current;
      listenToAllSupportedEvents(container);
      return new ReactDOMRoot(options2);
    };
    reactDomClient_development.hydrateRoot = function(container, initialChildren, options2) {
      if (!isValidContainer(container))
        throw Error("Target container is not a DOM element.");
      warnIfReactDOMContainerInDEV(container);
      void 0 === initialChildren && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
      null !== options2 && void 0 !== options2 && (true === options2.unstable_strictMode && (isStrictMode = true), void 0 !== options2.identifierPrefix && (identifierPrefix = options2.identifierPrefix), void 0 !== options2.onUncaughtError && (onUncaughtError = options2.onUncaughtError), void 0 !== options2.onCaughtError && (onCaughtError = options2.onCaughtError), void 0 !== options2.onRecoverableError && (onRecoverableError = options2.onRecoverableError), void 0 !== options2.formState && (formState = options2.formState));
      initialChildren = createFiberRoot(
        container,
        1,
        true,
        initialChildren,
        null != options2 ? options2 : null,
        isStrictMode,
        identifierPrefix,
        formState,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        defaultOnDefaultTransitionIndicator
      );
      initialChildren.context = getContextForSubtree(null);
      options2 = initialChildren.current;
      isStrictMode = requestUpdateLane(options2);
      isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
      identifierPrefix = createUpdate(isStrictMode);
      identifierPrefix.callback = null;
      enqueueUpdate(options2, identifierPrefix, isStrictMode);
      startUpdateTimerByLane(isStrictMode, "hydrateRoot()", null);
      options2 = isStrictMode;
      initialChildren.current.lanes = options2;
      markRootUpdated$1(initialChildren, options2);
      ensureRootIsScheduled(initialChildren);
      container[internalContainerInstanceKey] = initialChildren.current;
      listenToAllSupportedEvents(container);
      return new ReactDOMHydrationRoot(initialChildren);
    };
    reactDomClient_development.version = "19.2.1";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return reactDomClient_development;
}
var hasRequiredClient;
function requireClient() {
  if (hasRequiredClient) return client.exports;
  hasRequiredClient = 1;
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      throw new Error("^_^");
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  if (process.env.NODE_ENV === "production") {
    checkDCE();
    client.exports = requireReactDomClient_production();
  } else {
    client.exports = requireReactDomClient_development();
  }
  return client.exports;
}
var clientExports = requireClient();
const TEX_NAMES_LOWER = [
  "phi",
  "varsigma",
  "epsilon",
  "rho",
  "tau",
  "upsilon",
  "theta",
  "iota",
  null,
  "pi",
  "alpha",
  "sigma",
  "delta",
  "varphi",
  "gamma",
  "eta",
  "xi",
  "kappa",
  "lambda",
  "zeta",
  "chi",
  "psi",
  "omega",
  "beta",
  "nu",
  "mu"
];
const TEX_NAMES_UPPER = [
  "Phi",
  "Sigma",
  null,
  null,
  null,
  null,
  "Theta",
  null,
  null,
  "Pi",
  null,
  "Sigma",
  "Delta",
  "Phi",
  "Gamma",
  null,
  "Xi",
  null,
  "Lambda",
  null,
  null,
  "Psi",
  "Omega",
  null,
  null,
  null
];
const KEYS = {
  alpha_lower: "qwertyuiopasdfghjklzxcvbnm,'".split("").map((c2) => ({
    displayName: c2,
    name: c2,
    commands: [{ type: "write", command: c2 }]
  })),
  alpha_upper: "QWERTYUIOPASDFGHJKLZXCVBNM,'".split("").map((c2) => ({
    displayName: c2,
    name: c2,
    commands: [{ type: "write", command: c2 }]
  })),
  numeric: "1234567890.".split("").map((c2) => ({
    displayName: c2,
    name: c2 === "." ? "dot" : c2,
    commands: [{ type: "write", command: c2 }]
  })),
  // lower-case greek letters in QWERTY order
  // Use `...` rather than `.split` to properly handle unicode characters
  greek_lower: [..."ϕ𝜍ερτυθιοπασδφγηξκλζχψωβνμ,'"].map((c2, i2) => ({
    displayName: c2,
    name: c2,
    commands: [
      {
        type: "write",
        command: TEX_NAMES_LOWER[i2] ? `\\${TEX_NAMES_LOWER[i2]}` : c2
      }
    ]
  })),
  // upper-case greek letters in QWERTY order
  greek_upper: [..."ΦΣΕΡΤΥΘΙΟΠΑΣΔΦΓΗΞΚΛΖΧΨΩΒΝΜ,'"].map((c2, i2) => ({
    displayName: c2,
    name: c2,
    commands: [
      {
        type: "write",
        command: TEX_NAMES_UPPER[i2] ? `\\${TEX_NAMES_UPPER[i2]}` : c2
      }
    ]
  }))
  // var-sigma greek letter
  //greek_lower: "",
};
const SPECIAL_KEYS = {
  shift: {
    displayName: "⇧",
    name: "shift",
    commands: [{ type: "cmd", command: "Shift" }]
  },
  backspace: {
    displayName: "⌫",
    name: "backspace",
    commands: [{ type: "keystroke", command: "Backspace" }]
  },
  space: {
    displayName: "␣",
    name: "space",
    commands: [{ type: "write", command: "\\ " }]
  },
  left: {
    displayName: "←",
    name: "left",
    commands: [{ type: "keystroke", command: "Left" }]
  },
  right: {
    displayName: "→",
    name: "right",
    commands: [{ type: "keystroke", command: "Right" }]
  },
  enter: {
    displayName: "Enter",
    name: "enter",
    commands: [{ type: "keystroke", command: "Enter" }]
  }
};
const OPERATOR_KEYS = {
  times: {
    displayName: "×",
    name: "times",
    commands: [{ type: "write", command: "\\times" }]
  },
  divide: {
    displayName: "÷",
    name: "divide",
    commands: [{ type: "cmd", command: "/" }]
  },
  plus: {
    displayName: "+",
    name: "plus",
    commands: [{ type: "write", command: "+" }]
  },
  minus: {
    displayName: "−",
    name: "minus",
    commands: [{ type: "write", command: "-" }]
  },
  equals: {
    displayName: "=",
    name: "equals",
    commands: [{ type: "write", command: "=" }]
  }
};
const VAR_KEYS = {
  x: {
    // displayName: "x",
    displayName: " x",
    name: "x",
    commands: [{ type: "write", command: "x" }]
  },
  y: {
    // displayName: "y",
    displayName: " y",
    name: "y",
    commands: [{ type: "write", command: "y" }]
  },
  pi: {
    // displayName: "π",
    displayName: "\\pi",
    name: "pi",
    commands: [{ type: "write", command: "\\pi" }]
  },
  e: {
    // displayName: "e",
    displayName: " e",
    name: "e",
    commands: [{ type: "write", command: "e" }]
  },
  square: {
    // displayName: "a²",
    displayName: "a^2",
    name: "square",
    commands: [
      { type: "type", command: "^2" },
      { type: "keystroke", command: "Right" }
    ]
  },
  exponent: {
    // displayName: "aᵇ",
    displayName: "b^a",
    name: "exponent",
    commands: [{ type: "cmd", command: "^" }]
  },
  sqrt: {
    // displayName: "√a",
    displayName: "\\sqrt{a}",
    name: "sqrt",
    commands: [{ type: "type", command: "sqrt" }]
  },
  abs: {
    displayName: "|a|",
    name: "abs",
    commands: [
      { type: "cmd", command: "|" },
      { type: "cmd", command: "|" },
      { type: "keystroke", command: "Left" }
    ]
  },
  lt: {
    displayName: "<",
    name: "lt",
    commands: [{ type: "write", command: "<" }]
  },
  gt: {
    displayName: ">",
    name: "gt",
    commands: [{ type: "write", command: ">" }]
  },
  leq: {
    displayName: "≤",
    name: "leq",
    commands: [{ type: "type", command: "<=" }]
  },
  geq: {
    displayName: "≥",
    name: "geq",
    commands: [{ type: "type", command: ">=" }]
  },
  comma: {
    displayName: ",",
    name: "comma",
    commands: [{ type: "write", command: "," }]
  },
  leftParen: {
    displayName: "(",
    name: "leftParen",
    commands: [{ type: "cmd", command: "(" }]
  },
  rightParen: {
    displayName: ")",
    name: "rightParen",
    commands: [{ type: "cmd", command: ")" }]
  }
};
const SYMBOL_KEYS = {
  openBrace: {
    displayName: "\\{",
    name: "openBrace",
    commands: [{ type: "cmd", command: "{" }]
  },
  closeBrace: {
    displayName: "\\}",
    name: "closeBrace",
    commands: [{ type: "cmd", command: "}" }]
  },
  comma: {
    displayName: ",",
    name: "comma",
    commands: [{ type: "write", command: "," }]
  },
  colon: {
    displayName: ":",
    name: "colon",
    commands: [{ type: "write", command: ":" }]
  },
  vert: {
    displayName: "|",
    name: "vert",
    commands: [{ type: "write", command: "\\vert" }]
  },
  subset: {
    displayName: "⊂",
    name: "subset",
    commands: [{ type: "write", command: "\\subset" }]
  },
  subseteq: {
    displayName: "⊆",
    name: "subseteq",
    commands: [{ type: "write", command: "\\subseteq" }]
  },
  neq: {
    displayName: "≠",
    name: "neq",
    commands: [{ type: "write", command: "\\neq" }]
  },
  elementOf: {
    displayName: "∈",
    name: "elementOf",
    commands: [{ type: "write", command: "\\in" }]
  },
  infty: {
    displayName: "∞",
    name: "infinity",
    commands: [{ type: "write", command: "\\infty" }]
  },
  openParen: {
    displayName: "(",
    name: "openParen",
    commands: [{ type: "cmd", command: "(" }]
  },
  closeParen: {
    displayName: ")",
    name: "closeParen",
    commands: [{ type: "cmd", command: ")" }]
  },
  openSquareBracket: {
    displayName: "[",
    name: "openSquareBracket",
    commands: [{ type: "cmd", command: "[" }]
  },
  closeSquareBracket: {
    displayName: "]",
    name: "closeSquareBracket",
    commands: [{ type: "cmd", command: "]" }]
  },
  emptySet: {
    displayName: "∅",
    name: "emptySet",
    commands: [{ type: "write", command: "\\emptyset" }]
  }
};
const OTHER_SYMBOLS = {
  vec: {
    displayName: "a⃗",
    name: "vec",
    commands: [
      { type: "write", command: "\\vec{}" },
      { type: "keystroke", command: "Left" }
    ]
  },
  langle: {
    displayName: "⟨",
    name: "langle",
    commands: [{ type: "cmd", command: "\\langle" }]
  },
  rangle: {
    displayName: "⟩",
    name: "rangle",
    commands: [{ type: "cmd", command: "\\rangle" }]
  },
  cdot: {
    displayName: "⋅",
    name: "cdot",
    commands: [{ type: "write", command: "\\cdot" }]
  },
  times: {
    displayName: "×",
    name: "times",
    commands: [{ type: "write", command: "\\times" }]
  },
  conj: {
    displayName: "ā",
    name: "conj",
    commands: [{ type: "cmd", command: "\\overline" }]
  },
  perp: {
    displayName: "⊥",
    name: "perp",
    commands: [{ type: "write", command: "\\perp" }]
  },
  parallel: {
    displayName: "∥",
    name: "parallel",
    commands: [{ type: "write", command: "\\parallel" }]
  },
  angle: {
    displayName: "∠",
    name: "angle",
    commands: [{ type: "write", command: "\\angle" }]
  },
  degree: {
    displayName: "a°",
    name: "degree",
    commands: [{ type: "write", command: "\\degree" }]
  },
  exists: {
    displayName: "∃",
    name: "exists",
    commands: [{ type: "write", command: "\\exists" }]
  },
  forall: {
    displayName: "∀",
    name: "forall",
    commands: [{ type: "write", command: "\\forall" }]
  },
  percent: {
    displayName: "\\%",
    name: "percent",
    commands: [{ type: "write", command: "%" }]
  },
  dollar: {
    displayName: "$",
    name: "dollar",
    commands: [{ type: "write", command: "$" }]
  },
  subscript: {
    displayName: "bₐ",
    name: "subscript",
    commands: [{ type: "cmd", command: "_" }]
  }
};
const TRIG_KEYS = {
  sin: {
    // displayName: "sin",
    displayName: "\\sin",
    name: "sin",
    commands: [{ type: "type", command: "sin(" }]
  },
  cos: {
    // displayName: "cos",
    displayName: "\\cos",
    name: "cos",
    commands: [{ type: "type", command: "cos(" }]
  },
  tan: {
    // displayName: "tan",
    displayName: "\\tan",
    name: "tan",
    commands: [{ type: "type", command: "tan(" }]
  },
  arcsin: {
    // displayName: "sin⁻¹",
    displayName: "\\sin^{-1}",
    name: "arcsin",
    commands: [
      { type: "write", command: "sin^{-1}" },
      { type: "type", command: "(" }
    ]
  },
  arccos: {
    // displayName: "cos⁻¹",
    displayName: "\\cos^{-1}",
    name: "arccos",
    commands: [
      { type: "write", command: "cos^{-1}" },
      { type: "type", command: "(" }
    ]
  },
  arctan: {
    // displayName: "tan⁻¹",
    displayName: "\\tan^{-1}",
    name: "arctan",
    commands: [
      { type: "write", command: "tan^{-1}" },
      { type: "type", command: "(" }
    ]
  },
  ln: {
    // displayName: "ln",
    displayName: "\\ln",
    name: "ln",
    commands: [{ type: "type", command: "ln(" }]
  },
  logBaseA: {
    // displayName: "logₐ",
    displayName: "\\log_{b}",
    name: "logBaseA",
    commands: [
      { type: "write", command: "log_{}" },
      { type: "keystroke", command: "Left" }
    ]
  },
  lg: {
    // displayName: "log",
    displayName: "\\log",
    name: "lg",
    commands: [{ type: "write", command: "log_{10}" }]
  },
  exp: {
    // displayName: "eᵃ",
    displayName: "e^a",
    name: "exp",
    commands: [
      { type: "write", command: "e^{}" },
      { type: "keystroke", command: "Left" }
    ]
  },
  tenToTheA: {
    // displayName: "10ᵃ",
    displayName: "10^a",
    name: "tenToTheA",
    commands: [
      { type: "write", command: "10^{}" },
      { type: "keystroke", command: "Left" }
    ]
  },
  athRootOfB: {
    // displayName: "ᵃ√b",
    displayName: "\\sqrt[a]{b}",
    name: "athRootOfB",
    commands: [
      { type: "write", command: "\\sqrt[]{}" },
      { type: "keystroke", command: "Left" },
      { type: "keystroke", command: "Left" }
    ]
  }
};
const FUNCTION_KEYS = {
  deriv: {
    // displayName: "d/dx",
    displayName: "\\frac{d}{dx}",
    name: "deriv",
    commands: [{ type: "write", command: "\\frac{d}{dx}" }]
  },
  int: {
    // displayName: "∫",
    displayName: "\\int_a^b",
    name: "int",
    commands: [
      { type: "write", command: "\\int_{}^{}" },
      { type: "keystroke", command: "Left" },
      { type: "keystroke", command: "Left" }
    ]
  },
  nPr: {
    displayName: "nPr",
    name: "nPr",
    commands: [{ type: "type", command: "nPr(" }]
  },
  nCr: {
    displayName: "nCr",
    name: "nCr",
    commands: [{ type: "type", command: "nCr(" }]
  },
  factorial: {
    displayName: "n!",
    name: "factorial",
    commands: [{ type: "write", command: "!" }]
  },
  floor: {
    displayName: "⌊a⌋",
    name: "floor",
    commands: [
      { type: "write", command: "\\lfloor" },
      { type: "write", command: "\\rfloor" },
      { type: "keystroke", command: "Left" }
    ]
  },
  ceil: {
    displayName: "⌈a⌉",
    name: "ceil",
    commands: [
      { type: "write", command: "\\lceil" },
      { type: "write", command: "\\rceil" },
      { type: "keystroke", command: "Left" }
    ]
  }
};
for (const key of [
  ...Object.values(SYMBOL_KEYS),
  ...Object.values(OTHER_SYMBOLS),
  ...Object.values(FUNCTION_KEYS),
  ...Object.values(TRIG_KEYS),
  ...Object.values(OPERATOR_KEYS),
  ...Object.values(VAR_KEYS)
]) {
  key.isMath = true;
}
const BackspaceIcon = /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "delete-left",
    className: "svg-inline--fa fa-delete-left ",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512"
  },
  /* @__PURE__ */ React__default.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    }
  )
);
function Keyboard({
  style,
  onClick
}) {
  switch (style) {
    case "alpha_lower":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard alpha" }, /* @__PURE__ */ React__default.createElement(Qwerty, { type: "lower", onClick }));
    case "alpha_upper":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard alpha" }, /* @__PURE__ */ React__default.createElement(Qwerty, { type: "upper", onClick }));
    case "numeric":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard numeric" }, /* @__PURE__ */ React__default.createElement(Numeric, { onClick }));
    case "greek_lower":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard greek" }, /* @__PURE__ */ React__default.createElement(Greek, { type: "lower", onClick }));
    case "greek_upper":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard greek" }, /* @__PURE__ */ React__default.createElement(Greek, { type: "upper", onClick }));
    case "symbol":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard symbol" }, /* @__PURE__ */ React__default.createElement(Symbol$1, { onClick }));
    case "function":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard composite" }, /* @__PURE__ */ React__default.createElement(Composite, { onClick }));
  }
}
function Key({
  keyInfo,
  onClick
}) {
  let content2 = keyInfo.displayName;
  if (keyInfo.isMath) {
    content2 = /* @__PURE__ */ React__default.createElement("div", { style: { pointerEvents: "none" } }, /* @__PURE__ */ React__default.createElement(MathJax, null, "\\(" + content2 + "\\)"));
  }
  if (keyInfo.name === "backspace") {
    content2 = BackspaceIcon;
  }
  return /* @__PURE__ */ React__default.createElement(
    "button",
    {
      className: `key key-${keyInfo.name} ${keyInfo.isMath ? "math" : ""}`,
      onClick: (e2) => {
        e2.stopPropagation();
        onClick(keyInfo.commands);
      },
      title: `Type ${keyInfo.name}`
    },
    content2
  );
}
function Qwerty({
  type,
  onClick
}) {
  const keys2 = type === "upper" ? KEYS.alpha_upper : KEYS.alpha_lower;
  const row1 = keys2.slice(0, 10);
  const row2 = keys2.slice(10, 19);
  const row3 = [
    SPECIAL_KEYS.shift,
    ...keys2.slice(19, 26),
    SPECIAL_KEYS.backspace
  ];
  const row4 = [
    ...keys2.slice(26, 29),
    SPECIAL_KEYS.space,
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.enter
  ];
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, [row1, row2, row3, row4].map((row, i2) => /* @__PURE__ */ React__default.createElement("div", { key: i2, className: "row" }, row.map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name })))));
}
function Numeric({ onClick }) {
  const row1 = [
    ...KEYS.numeric.slice(0, 3),
    OPERATOR_KEYS.times,
    OPERATOR_KEYS.divide
  ];
  const row2 = [
    ...KEYS.numeric.slice(3, 6),
    OPERATOR_KEYS.plus,
    OPERATOR_KEYS.minus
  ];
  const row3 = [
    ...KEYS.numeric.slice(6, 9),
    OPERATOR_KEYS.equals,
    SPECIAL_KEYS.backspace
  ];
  const row4 = [
    ...KEYS.numeric.slice(9),
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.enter
  ];
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(VAR_KEYS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))), /* @__PURE__ */ React__default.createElement("div", { className: "sub-keyboard" }, [row1, row2, row3, row4].map((row, i2) => /* @__PURE__ */ React__default.createElement("div", { key: i2, className: "row" }, row.map((key) => /* @__PURE__ */ React__default.createElement(
    Key,
    {
      keyInfo: key,
      onClick,
      key: key.name
    }
  ))))));
}
function Symbol$1({ onClick }) {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(SYMBOL_KEYS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))), /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(OTHER_SYMBOLS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name })), [
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.backspace,
    SPECIAL_KEYS.enter
  ].map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))));
}
function Greek({
  type,
  onClick
}) {
  const keys2 = type === "upper" ? KEYS.greek_upper : KEYS.greek_lower;
  const row1 = keys2.slice(0, 10);
  const row2 = keys2.slice(10, 19);
  const row3 = [
    SPECIAL_KEYS.shift,
    ...keys2.slice(19, 26),
    SPECIAL_KEYS.backspace
  ];
  const row4 = [
    ...keys2.slice(26, 29),
    SPECIAL_KEYS.space,
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.enter
  ];
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, [row1, row2, row3, row4].map((row, i2) => /* @__PURE__ */ React__default.createElement("div", { key: i2, className: "row" }, row.map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name })))));
}
function Composite({ onClick }) {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(TRIG_KEYS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))), /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(FUNCTION_KEYS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name })), [
    SPECIAL_KEYS.backspace,
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.enter
  ].map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))));
}
function noop$2$1(..._2) {
}
function applyState$2(argument, currentValue) {
  if (isUpdater$2(argument)) {
    const value = isLazyValue$2(currentValue) ? currentValue() : currentValue;
    return argument(value);
  }
  return argument;
}
function isUpdater$2(argument) {
  return typeof argument === "function";
}
function isLazyValue$2(value) {
  return typeof value === "function";
}
function hasOwnProperty$2$1(object2, prop) {
  if (typeof Object.hasOwn === "function") {
    return Object.hasOwn(object2, prop);
  }
  return Object.prototype.hasOwnProperty.call(object2, prop);
}
function chain$1$1(...fns) {
  return (...args) => {
    for (const fn of fns) {
      if (typeof fn === "function") {
        fn(...args);
      }
    }
  };
}
function omit$1$1(object2, keys2) {
  const result2 = { ...object2 };
  for (const key of keys2) {
    if (hasOwnProperty$2$1(result2, key)) {
      delete result2[key];
    }
  }
  return result2;
}
function pick$1$1(object2, paths) {
  const result2 = {};
  for (const key of paths) {
    if (hasOwnProperty$2$1(object2, key)) {
      result2[key] = object2[key];
    }
  }
  return result2;
}
function identity$1$1(value) {
  return value;
}
function invariant$2(condition, message) {
  if (condition) return;
  if (typeof message !== "string") throw new Error("Invariant failed");
  throw new Error(message);
}
function getKeys$2(obj) {
  return Object.keys(obj);
}
function disabledFromProps$2(props2) {
  return props2.disabled || props2["aria-disabled"] === true || props2["aria-disabled"] === "true";
}
function removeUndefinedValues$2(obj) {
  const result2 = {};
  for (const key in obj) {
    if (obj[key] !== void 0) {
      result2[key] = obj[key];
    }
  }
  return result2;
}
function defaultValue$2(...values2) {
  for (const value of values2) {
    if (value !== void 0) return value;
  }
  return void 0;
}
function setRef$2(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function isValidElementWithRef$2(element2) {
  if (!element2) return false;
  if (!isValidElement$1(element2)) return false;
  if ("ref" in element2.props) return true;
  if ("ref" in element2) return true;
  return false;
}
function getRefProperty$2(element2) {
  if (!isValidElementWithRef$2(element2)) return null;
  const props2 = { ...element2.props };
  return props2.ref || element2.ref;
}
function mergeProps$2(base2, overrides2) {
  const props2 = { ...base2 };
  for (const key in overrides2) {
    if (!hasOwnProperty$2$1(overrides2, key)) continue;
    if (key === "className") {
      const prop = "className";
      props2[prop] = base2[prop] ? `${base2[prop]} ${overrides2[prop]}` : overrides2[prop];
      continue;
    }
    if (key === "style") {
      const prop = "style";
      props2[prop] = base2[prop] ? { ...base2[prop], ...overrides2[prop] } : overrides2[prop];
      continue;
    }
    const overrideValue = overrides2[key];
    if (typeof overrideValue === "function" && key.startsWith("on")) {
      const baseValue = base2[key];
      if (typeof baseValue === "function") {
        props2[key] = (...args) => {
          overrideValue(...args);
          baseValue(...args);
        };
        continue;
      }
    }
    props2[key] = overrideValue;
  }
  return props2;
}
var canUseDOM$2 = checkIsBrowser$2();
function checkIsBrowser$2() {
  var _a2;
  return typeof window !== "undefined" && !!((_a2 = window.document) == null ? void 0 : _a2.createElement);
}
function getDocument$2(node) {
  if (!node) return document;
  if ("self" in node) return node.document;
  return node.ownerDocument || document;
}
function getActiveElement$2(node, activeDescendant = false) {
  const { activeElement } = getDocument$2(node);
  if (!(activeElement == null ? void 0 : activeElement.nodeName)) {
    return null;
  }
  if (isFrame$2(activeElement) && activeElement.contentDocument) {
    return getActiveElement$2(
      activeElement.contentDocument.body,
      activeDescendant
    );
  }
  if (activeDescendant) {
    const id2 = activeElement.getAttribute("aria-activedescendant");
    if (id2) {
      const element2 = getDocument$2(activeElement).getElementById(id2);
      if (element2) {
        return element2;
      }
    }
  }
  return activeElement;
}
function contains$1$1(parent, child) {
  return parent === child || parent.contains(child);
}
function isFrame$2(element2) {
  return element2.tagName === "IFRAME";
}
function isButton$2(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "button") return true;
  if (tagName === "input" && element2.type) {
    return buttonInputTypes$2.indexOf(element2.type) !== -1;
  }
  return false;
}
var buttonInputTypes$2 = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function isVisible$2(element2) {
  if (typeof element2.checkVisibility === "function") {
    return element2.checkVisibility();
  }
  const htmlElement = element2;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element2.getClientRects().length > 0;
}
function isTextField$2(element2) {
  try {
    const isTextInput = element2 instanceof HTMLInputElement && element2.selectionStart !== null;
    const isTextArea = element2.tagName === "TEXTAREA";
    return isTextInput || isTextArea || false;
  } catch (_error) {
    return false;
  }
}
function isTextbox$2(element2) {
  return element2.isContentEditable || isTextField$2(element2);
}
function getTextboxValue$2(element2) {
  if (isTextField$2(element2)) {
    return element2.value;
  }
  if (element2.isContentEditable) {
    const range2 = getDocument$2(element2).createRange();
    range2.selectNodeContents(element2);
    return range2.toString();
  }
  return "";
}
function getTextboxSelection$2(element2) {
  let start = 0;
  let end = 0;
  if (isTextField$2(element2)) {
    start = element2.selectionStart || 0;
    end = element2.selectionEnd || 0;
  } else if (element2.isContentEditable) {
    const selection2 = getDocument$2(element2).getSelection();
    if ((selection2 == null ? void 0 : selection2.rangeCount) && selection2.anchorNode && contains$1$1(element2, selection2.anchorNode) && selection2.focusNode && contains$1$1(element2, selection2.focusNode)) {
      const range2 = selection2.getRangeAt(0);
      const nextRange = range2.cloneRange();
      nextRange.selectNodeContents(element2);
      nextRange.setEnd(range2.startContainer, range2.startOffset);
      start = nextRange.toString().length;
      nextRange.setEnd(range2.endContainer, range2.endOffset);
      end = nextRange.toString().length;
    }
  }
  return { start, end };
}
function getScrollingElement$2(element2) {
  if (!element2) return null;
  const isScrollableOverflow = (overflow) => {
    if (overflow === "auto") return true;
    if (overflow === "scroll") return true;
    return false;
  };
  if (element2.clientHeight && element2.scrollHeight > element2.clientHeight) {
    const { overflowY } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowY)) return element2;
  } else if (element2.clientWidth && element2.scrollWidth > element2.clientWidth) {
    const { overflowX } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowX)) return element2;
  }
  return getScrollingElement$2(element2.parentElement) || document.scrollingElement || document.body;
}
function sortBasedOnDOMPosition$2(items, getElement) {
  const pairs2 = items.map((item, index2) => [index2, item]);
  let isOrderDifferent = false;
  pairs2.sort(([indexA, a], [indexB, b2]) => {
    const elementA = getElement(a);
    const elementB = getElement(b2);
    if (elementA === elementB) return 0;
    if (!elementA || !elementB) return 0;
    if (isElementPreceding$2(elementA, elementB)) {
      if (indexA > indexB) {
        isOrderDifferent = true;
      }
      return -1;
    }
    if (indexA < indexB) {
      isOrderDifferent = true;
    }
    return 1;
  });
  if (isOrderDifferent) {
    return pairs2.map(([_2, item]) => item);
  }
  return items;
}
function isElementPreceding$2(a, b2) {
  return Boolean(
    b2.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING
  );
}
function isApple$2() {
  if (!canUseDOM$2) return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform);
}
function isSafari$2() {
  return canUseDOM$2 && isApple$2() && /apple/i.test(navigator.vendor);
}
function isFirefox$2() {
  return canUseDOM$2 && /firefox\//i.test(navigator.userAgent);
}
function isPortalEvent$2(event) {
  return Boolean(
    event.currentTarget && !contains$1$1(event.currentTarget, event.target)
  );
}
function isSelfTarget$2(event) {
  return event.target === event.currentTarget;
}
function fireBlurEvent$2(element2, eventInit) {
  const event = new FocusEvent("blur", eventInit);
  const defaultAllowed = element2.dispatchEvent(event);
  const bubbleInit = { ...eventInit, bubbles: true };
  element2.dispatchEvent(new FocusEvent("focusout", bubbleInit));
  return defaultAllowed;
}
function fireKeyboardEvent$2(element2, type, eventInit) {
  const event = new KeyboardEvent(type, eventInit);
  return element2.dispatchEvent(event);
}
function fireClickEvent$2(element2, eventInit) {
  const event = new MouseEvent("click", eventInit);
  return element2.dispatchEvent(event);
}
function isFocusEventOutside$2(event, container) {
  const containerElement = event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains$1$1(containerElement, relatedTarget);
}
function queueBeforeEvent$2(element2, type, callback, timeout) {
  const createTimer = (callback2) => {
    const timerId = requestAnimationFrame(callback2);
    return () => cancelAnimationFrame(timerId);
  };
  const cancelTimer = createTimer(() => {
    element2.removeEventListener(type, callSync, true);
    callback();
  });
  const callSync = () => {
    cancelTimer();
    callback();
  };
  element2.addEventListener(type, callSync, { once: true, capture: true });
  return cancelTimer;
}
function addGlobalEventListener$2(type, listener, options2, scope = window) {
  const children = [];
  try {
    scope.document.addEventListener(type, listener, options2);
    for (const frame of Array.from(scope.frames)) {
      children.push(addGlobalEventListener$2(type, listener, options2, frame));
    }
  } catch (e2) {
  }
  const removeEventListener2 = () => {
    try {
      scope.document.removeEventListener(type, listener, options2);
    } catch (e2) {
    }
    for (const remove2 of children) {
      remove2();
    }
  };
  return removeEventListener2;
}
var _React$2 = { ...React };
var useReactId$2 = _React$2.useId;
var useReactInsertionEffect$2 = _React$2.useInsertionEffect;
var useSafeLayoutEffect$2 = canUseDOM$2 ? useLayoutEffect : useEffect;
function useLiveRef$2(value) {
  const ref = useRef(value);
  useSafeLayoutEffect$2(() => {
    ref.current = value;
  });
  return ref;
}
function useEvent$2(callback) {
  const ref = useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  if (useReactInsertionEffect$2) {
    useReactInsertionEffect$2(() => {
      ref.current = callback;
    });
  } else {
    ref.current = callback;
  }
  return useCallback((...args) => {
    var _a2;
    return (_a2 = ref.current) == null ? void 0 : _a2.call(ref, ...args);
  }, []);
}
function useTransactionState$2(callback) {
  const [state, setState] = useState(null);
  useSafeLayoutEffect$2(() => {
    if (state == null) return;
    if (!callback) return;
    let prevState = null;
    callback((prev) => {
      prevState = prev;
      return state;
    });
    return () => {
      callback(prevState);
    };
  }, [state, callback]);
  return [state, setState];
}
function useMergeRefs$2(...refs) {
  return useMemo(() => {
    if (!refs.some(Boolean)) return;
    return (value) => {
      for (const ref of refs) {
        setRef$2(ref, value);
      }
    };
  }, refs);
}
function useId$3(defaultId) {
  if (useReactId$2) {
    const reactId = useReactId$2();
    if (defaultId) return defaultId;
    return reactId;
  }
  const [id2, setId] = useState(defaultId);
  useSafeLayoutEffect$2(() => {
    if (defaultId || id2) return;
    const random2 = Math.random().toString(36).slice(2, 8);
    setId(`id-${random2}`);
  }, [defaultId, id2]);
  return defaultId || id2;
}
function useTagName$2(refOrElement, type) {
  const stringOrUndefined = (type2) => {
    return;
  };
  const [tagName, setTagName] = useState(() => stringOrUndefined());
  useSafeLayoutEffect$2(() => {
    const element2 = refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement;
    setTagName((element2 == null ? void 0 : element2.tagName.toLowerCase()) || stringOrUndefined());
  }, [refOrElement, type]);
  return tagName;
}
function useUpdateEffect$2(effect, deps) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) {
      return effect();
    }
    mounted.current = true;
  }, deps);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );
}
function useBooleanEvent$2(booleanOrCallback) {
  return useEvent$2(
    typeof booleanOrCallback === "function" ? booleanOrCallback : () => booleanOrCallback
  );
}
function useWrapElement$2(props2, callback, deps = []) {
  const wrapElement = useCallback(
    (element2) => {
      if (props2.wrapElement) {
        element2 = props2.wrapElement(element2);
      }
      return callback(element2);
    },
    [...deps, props2.wrapElement]
  );
  return { ...props2, wrapElement };
}
function useMetadataProps$2(props2, key, value) {
  const parent = props2.onLoadedMetadataCapture;
  const onLoadedMetadataCapture = useMemo(() => {
    return Object.assign(() => {
    }, { ...parent, [key]: value });
  }, [parent, key, value]);
  return [parent == null ? void 0 : parent[key], { onLoadedMetadataCapture }];
}
function getDefaultExportFromCjs$1$1(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var jsxRuntime$2 = { exports: {} };
var reactJsxRuntime_production$2 = {};
var hasRequiredReactJsxRuntime_production$2;
function requireReactJsxRuntime_production$2() {
  if (hasRequiredReactJsxRuntime_production$2) return reactJsxRuntime_production$2;
  hasRequiredReactJsxRuntime_production$2 = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production$2.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production$2.jsx = jsxProd;
  reactJsxRuntime_production$2.jsxs = jsxProd;
  return reactJsxRuntime_production$2;
}
var reactJsxRuntime_development$2 = {};
var hasRequiredReactJsxRuntime_development$2;
function requireReactJsxRuntime_development$2() {
  if (hasRequiredReactJsxRuntime_development$2) return reactJsxRuntime_development$2;
  hasRequiredReactJsxRuntime_development$2 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name2 = getComponentNameFromType(type);
        return name2 ? "<" + name2 + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props2, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props2, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props2, owner, debugStack, debugTask) {
      var refProp = props2.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props: props2,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node) {
      isValidElement2(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement2(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement2(object2) {
      return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React2 = React__default, REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React2 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React2.react_stack_bottom_frame.bind(
      React2,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development$2.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development$2.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development$2.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development$2;
}
var hasRequiredJsxRuntime$2;
function requireJsxRuntime$2() {
  if (hasRequiredJsxRuntime$2) return jsxRuntime$2.exports;
  hasRequiredJsxRuntime$2 = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime$2.exports = requireReactJsxRuntime_production$2();
  } else {
    jsxRuntime$2.exports = requireReactJsxRuntime_development$2();
  }
  return jsxRuntime$2.exports;
}
var jsxRuntimeExports$2 = requireJsxRuntime$2();
function forwardRef2$2(render) {
  const Role3 = React.forwardRef((props2, ref) => render({ ...props2, ref }));
  Role3.displayName = render.displayName || render.name;
  return Role3;
}
function memo2$2(Component, propsAreEqual) {
  return React.memo(Component, propsAreEqual);
}
function createElement$2(Type, props2) {
  const { wrapElement, render, ...rest2 } = props2;
  const mergedRef = useMergeRefs$2(props2.ref, getRefProperty$2(render));
  let element2;
  if (React.isValidElement(render)) {
    const renderProps = { ...render.props, ref: mergedRef };
    element2 = React.cloneElement(render, mergeProps$2(rest2, renderProps));
  } else if (render) {
    element2 = render(rest2);
  } else {
    element2 = /* @__PURE__ */ jsxRuntimeExports$2.jsx(Type, { ...rest2 });
  }
  if (wrapElement) {
    return wrapElement(element2);
  }
  return element2;
}
function createHook$2(useProps) {
  const useRole = (props2 = {}) => {
    return useProps(props2);
  };
  useRole.displayName = useProps.name;
  return useRole;
}
function createStoreContext$2(providers = [], scopedProviders = []) {
  const context = React.createContext(void 0);
  const scopedContext = React.createContext(void 0);
  const useContext2 = () => React.useContext(context);
  const useScopedContext = (onlyScoped = false) => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (onlyScoped) return scoped;
    return scoped || store2;
  };
  const useProviderContext = () => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (scoped && scoped === store2) return;
    return store2;
  };
  const ContextProvider = (props2) => {
    return providers.reduceRight(
      (children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(Provider2, { ...props2, children }),
      /* @__PURE__ */ jsxRuntimeExports$2.jsx(context.Provider, { ...props2 })
    );
  };
  const ScopedContextProvider = (props2) => {
    return /* @__PURE__ */ jsxRuntimeExports$2.jsx(ContextProvider, { ...props2, children: scopedProviders.reduceRight(
      (children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(Provider2, { ...props2, children }),
      /* @__PURE__ */ jsxRuntimeExports$2.jsx(scopedContext.Provider, { ...props2 })
    ) });
  };
  return {
    context,
    scopedContext,
    useContext: useContext2,
    useScopedContext,
    useProviderContext,
    ContextProvider,
    ScopedContextProvider
  };
}
var ctx$7$1 = createStoreContext$2();
var useCollectionContext$2 = ctx$7$1.useContext;
var CollectionContextProvider$2 = ctx$7$1.ContextProvider;
var CollectionScopedContextProvider$2 = ctx$7$1.ScopedContextProvider;
var ctx$6$1 = createStoreContext$2(
  [CollectionContextProvider$2],
  [CollectionScopedContextProvider$2]
);
var useCompositeContext$2 = ctx$6$1.useContext;
var useCompositeProviderContext$2 = ctx$6$1.useProviderContext;
var CompositeContextProvider$2 = ctx$6$1.ContextProvider;
var CompositeScopedContextProvider$2 = ctx$6$1.ScopedContextProvider;
var CompositeItemContext$2 = createContext(
  void 0
);
var CompositeRowContext$2 = createContext(
  void 0
);
var ctx$5$1 = createStoreContext$2(
  [CompositeContextProvider$2],
  [CompositeScopedContextProvider$2]
);
var useTabScopedContext$1 = ctx$5$1.useScopedContext;
var useTabProviderContext$1 = ctx$5$1.useProviderContext;
var TabContextProvider$1 = ctx$5$1.ContextProvider;
var TabScopedContextProvider$1 = ctx$5$1.ScopedContextProvider;
function findFirstEnabledItem$1$2(items, excludeId) {
  return items.find((item) => {
    return !item.disabled;
  });
}
function getEnabledItem$2(store2, id2) {
  if (!id2) return null;
  return store2.item(id2) || null;
}
function groupItemsByRows$1$2(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => {
      var _a2;
      return ((_a2 = currentRow[0]) == null ? void 0 : _a2.rowId) === item.rowId;
    });
    if (row) {
      row.push(item);
    } else {
      rows.push([item]);
    }
  }
  return rows;
}
function selectTextField$2(element2, collapseToEnd = false) {
  if (isTextField$2(element2)) {
    element2.setSelectionRange(
      collapseToEnd ? element2.value.length : 0,
      element2.value.length
    );
  } else if (element2.isContentEditable) {
    const selection2 = getDocument$2(element2).getSelection();
    selection2 == null ? void 0 : selection2.selectAllChildren(element2);
    if (collapseToEnd) {
      selection2 == null ? void 0 : selection2.collapseToEnd();
    }
  }
}
var FOCUS_SILENTLY$2 = Symbol("FOCUS_SILENTLY");
function focusSilently$2(element2) {
  element2[FOCUS_SILENTLY$2] = true;
  element2.focus({ preventScroll: true });
}
function silentlyFocused$2(element2) {
  const isSilentlyFocused = element2[FOCUS_SILENTLY$2];
  delete element2[FOCUS_SILENTLY$2];
  return isSilentlyFocused;
}
function isItem$2(store2, element2, exclude) {
  if (!element2) return false;
  if (element2 === exclude) return false;
  const item = store2.item(element2.id);
  if (!item) return false;
  return true;
}
var TagName$6$2 = "div";
var useCollectionItem$2 = createHook$2(
  function useCollectionItem2({
    store: store2,
    shouldRegisterItem = true,
    getItem = identity$1$1,
    // @ts-expect-error This prop may come from a collection renderer.
    element: element2,
    ...props2
  }) {
    const context = useCollectionContext$2();
    store2 = store2 || context;
    const id2 = useId$3(props2.id);
    const ref = useRef(element2);
    useEffect(() => {
      const element22 = ref.current;
      if (!id2) return;
      if (!element22) return;
      if (!shouldRegisterItem) return;
      const item = getItem({ id: id2, element: element22 });
      return store2 == null ? void 0 : store2.renderItem(item);
    }, [id2, shouldRegisterItem, getItem, store2]);
    props2 = {
      ...props2,
      ref: useMergeRefs$2(ref, props2.ref)
    };
    return removeUndefinedValues$2(props2);
  }
);
forwardRef2$2(function CollectionItem2(props2) {
  const htmlProps = useCollectionItem$2(props2);
  return createElement$2(TagName$6$2, htmlProps);
});
var FocusableContext$2 = createContext(true);
var selector$2 = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function isFocusable$2(element2) {
  if (!element2.matches(selector$2)) return false;
  if (!isVisible$2(element2)) return false;
  if (element2.closest("[inert]")) return false;
  return true;
}
function getClosestFocusable$2(element2) {
  while (element2 && !isFocusable$2(element2)) {
    element2 = element2.closest(selector$2);
  }
  return element2 || null;
}
function hasFocus$2(element2) {
  const activeElement = getActiveElement$2(element2);
  if (!activeElement) return false;
  if (activeElement === element2) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  return activeDescendant === element2.id;
}
function hasFocusWithin$2(element2) {
  const activeElement = getActiveElement$2(element2);
  if (!activeElement) return false;
  if (contains$1$1(element2, activeElement)) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  if (!("id" in element2)) return false;
  if (activeDescendant === element2.id) return true;
  return !!element2.querySelector(`#${CSS.escape(activeDescendant)}`);
}
function focusIfNeeded$2(element2) {
  if (!hasFocusWithin$2(element2) && isFocusable$2(element2)) {
    element2.focus();
  }
}
function focusIntoView$2(element2, options2) {
  if (!("scrollIntoView" in element2)) {
    element2.focus();
  } else {
    element2.focus({ preventScroll: true });
    element2.scrollIntoView({ block: "nearest", inline: "nearest", ...options2 });
  }
}
var TagName$5$2 = "div";
var isSafariBrowser$3 = isSafari$2();
var alwaysFocusVisibleInputTypes$2 = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
var safariFocusAncestorSymbol$2 = Symbol("safariFocusAncestor");
function markSafariFocusAncestor$2(element2, value) {
  if (!element2) return;
  element2[safariFocusAncestorSymbol$2] = value;
}
function isAlwaysFocusVisible$2(element2) {
  const { tagName, readOnly: readOnly2, type } = element2;
  if (tagName === "TEXTAREA" && !readOnly2) return true;
  if (tagName === "SELECT" && !readOnly2) return true;
  if (tagName === "INPUT" && !readOnly2) {
    return alwaysFocusVisibleInputTypes$2.includes(type);
  }
  if (element2.isContentEditable) return true;
  const role = element2.getAttribute("role");
  if (role === "combobox" && element2.dataset.name) {
    return true;
  }
  return false;
}
function getLabels$2(element2) {
  if ("labels" in element2) {
    return element2.labels;
  }
  return null;
}
function isNativeCheckboxOrRadio$2(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "input" && element2.type) {
    return element2.type === "radio" || element2.type === "checkbox";
  }
  return false;
}
function isNativeTabbable$2(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "summary" || tagName === "input" || tagName === "select" || tagName === "textarea" || tagName === "a";
}
function supportsDisabledAttribute$2(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea";
}
function getTabIndex$2(focusable, trulyDisabled, nativeTabbable, supportsDisabled, tabIndexProp) {
  if (!focusable) {
    return tabIndexProp;
  }
  if (trulyDisabled) {
    if (nativeTabbable && !supportsDisabled) {
      return -1;
    }
    return;
  }
  if (nativeTabbable) {
    return tabIndexProp;
  }
  return tabIndexProp || 0;
}
function useDisableEvent$2(onEvent, disabled) {
  return useEvent$2((event) => {
    onEvent == null ? void 0 : onEvent(event);
    if (event.defaultPrevented) return;
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  });
}
var hasInstalledGlobalEventListeners$3 = false;
var isKeyboardModality$2 = true;
function onGlobalMouseDown$2(event) {
  const target = event.target;
  if (target && "hasAttribute" in target) {
    if (!target.hasAttribute("data-focus-visible")) {
      isKeyboardModality$2 = false;
    }
  }
}
function onGlobalKeyDown$2(event) {
  if (event.metaKey) return;
  if (event.ctrlKey) return;
  if (event.altKey) return;
  isKeyboardModality$2 = true;
}
var useFocusable$2 = createHook$2(
  function useFocusable2({
    focusable = true,
    accessibleWhenDisabled,
    autoFocus,
    onFocusVisible,
    ...props2
  }) {
    const ref = useRef(null);
    useEffect(() => {
      if (!focusable) return;
      if (hasInstalledGlobalEventListeners$3) return;
      addGlobalEventListener$2("mousedown", onGlobalMouseDown$2, true);
      addGlobalEventListener$2("keydown", onGlobalKeyDown$2, true);
      hasInstalledGlobalEventListeners$3 = true;
    }, [focusable]);
    if (isSafariBrowser$3) {
      useEffect(() => {
        if (!focusable) return;
        const element2 = ref.current;
        if (!element2) return;
        if (!isNativeCheckboxOrRadio$2(element2)) return;
        const labels = getLabels$2(element2);
        if (!labels) return;
        const onMouseUp = () => queueMicrotask(() => element2.focus());
        for (const label2 of labels) {
          label2.addEventListener("mouseup", onMouseUp);
        }
        return () => {
          for (const label2 of labels) {
            label2.removeEventListener("mouseup", onMouseUp);
          }
        };
      }, [focusable]);
    }
    const disabled = focusable && disabledFromProps$2(props2);
    const trulyDisabled = !!disabled && !accessibleWhenDisabled;
    const [focusVisible, setFocusVisible] = useState(false);
    useEffect(() => {
      if (!focusable) return;
      if (trulyDisabled && focusVisible) {
        setFocusVisible(false);
      }
    }, [focusable, trulyDisabled, focusVisible]);
    useEffect(() => {
      if (!focusable) return;
      if (!focusVisible) return;
      const element2 = ref.current;
      if (!element2) return;
      if (typeof IntersectionObserver === "undefined") return;
      const observer = new IntersectionObserver(() => {
        if (!isFocusable$2(element2)) {
          setFocusVisible(false);
        }
      });
      observer.observe(element2);
      return () => observer.disconnect();
    }, [focusable, focusVisible]);
    const onKeyPressCapture = useDisableEvent$2(
      props2.onKeyPressCapture,
      disabled
    );
    const onMouseDownCapture = useDisableEvent$2(
      props2.onMouseDownCapture,
      disabled
    );
    const onClickCapture = useDisableEvent$2(props2.onClickCapture, disabled);
    const onMouseDownProp = props2.onMouseDown;
    const onMouseDown = useEvent$2((event) => {
      onMouseDownProp == null ? void 0 : onMouseDownProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      const element2 = event.currentTarget;
      if (!isSafariBrowser$3) return;
      if (isPortalEvent$2(event)) return;
      if (!isButton$2(element2) && !isNativeCheckboxOrRadio$2(element2)) return;
      let receivedFocus = false;
      const onFocus = () => {
        receivedFocus = true;
      };
      const options2 = { capture: true, once: true };
      element2.addEventListener("focusin", onFocus, options2);
      const focusableContainer = getClosestFocusable$2(element2.parentElement);
      markSafariFocusAncestor$2(focusableContainer, true);
      queueBeforeEvent$2(element2, "mouseup", () => {
        element2.removeEventListener("focusin", onFocus, true);
        markSafariFocusAncestor$2(focusableContainer, false);
        if (receivedFocus) return;
        focusIfNeeded$2(element2);
      });
    });
    const handleFocusVisible = (event, currentTarget) => {
      if (currentTarget) {
        event.currentTarget = currentTarget;
      }
      if (!focusable) return;
      const element2 = event.currentTarget;
      if (!element2) return;
      if (!hasFocus$2(element2)) return;
      onFocusVisible == null ? void 0 : onFocusVisible(event);
      if (event.defaultPrevented) return;
      element2.dataset.focusVisible = "true";
      setFocusVisible(true);
    };
    const onKeyDownCaptureProp = props2.onKeyDownCapture;
    const onKeyDownCapture = useEvent$2((event) => {
      onKeyDownCaptureProp == null ? void 0 : onKeyDownCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      if (focusVisible) return;
      if (event.metaKey) return;
      if (event.altKey) return;
      if (event.ctrlKey) return;
      if (!isSelfTarget$2(event)) return;
      const element2 = event.currentTarget;
      const applyFocusVisible = () => handleFocusVisible(event, element2);
      queueBeforeEvent$2(element2, "focusout", applyFocusVisible);
    });
    const onFocusCaptureProp = props2.onFocusCapture;
    const onFocusCapture = useEvent$2((event) => {
      onFocusCaptureProp == null ? void 0 : onFocusCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      if (!isSelfTarget$2(event)) {
        setFocusVisible(false);
        return;
      }
      const element2 = event.currentTarget;
      const applyFocusVisible = () => handleFocusVisible(event, element2);
      if (isKeyboardModality$2 || isAlwaysFocusVisible$2(event.target)) {
        queueBeforeEvent$2(event.target, "focusout", applyFocusVisible);
      } else {
        setFocusVisible(false);
      }
    });
    const onBlurProp = props2.onBlur;
    const onBlur = useEvent$2((event) => {
      onBlurProp == null ? void 0 : onBlurProp(event);
      if (!focusable) return;
      if (!isFocusEventOutside$2(event)) return;
      event.currentTarget.removeAttribute("data-focus-visible");
      setFocusVisible(false);
    });
    const autoFocusOnShow = useContext(FocusableContext$2);
    const autoFocusRef = useEvent$2((element2) => {
      if (!focusable) return;
      if (!autoFocus) return;
      if (!element2) return;
      if (!autoFocusOnShow) return;
      queueMicrotask(() => {
        if (hasFocus$2(element2)) return;
        if (!isFocusable$2(element2)) return;
        element2.focus();
      });
    });
    const tagName = useTagName$2(ref);
    const nativeTabbable = focusable && isNativeTabbable$2(tagName);
    const supportsDisabled = focusable && supportsDisabledAttribute$2(tagName);
    const styleProp = props2.style;
    const style = useMemo(() => {
      if (trulyDisabled) {
        return { pointerEvents: "none", ...styleProp };
      }
      return styleProp;
    }, [trulyDisabled, styleProp]);
    props2 = {
      "data-focus-visible": focusable && focusVisible || void 0,
      "data-autofocus": autoFocus || void 0,
      "aria-disabled": disabled || void 0,
      ...props2,
      ref: useMergeRefs$2(ref, autoFocusRef, props2.ref),
      style,
      tabIndex: getTabIndex$2(
        focusable,
        trulyDisabled,
        nativeTabbable,
        supportsDisabled,
        props2.tabIndex
      ),
      disabled: supportsDisabled && trulyDisabled ? true : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: disabled ? void 0 : props2.contentEditable,
      onKeyPressCapture,
      onClickCapture,
      onMouseDownCapture,
      onMouseDown,
      onKeyDownCapture,
      onFocusCapture,
      onBlur
    };
    return removeUndefinedValues$2(props2);
  }
);
forwardRef2$2(function Focusable2(props2) {
  const htmlProps = useFocusable$2(props2);
  return createElement$2(TagName$5$2, htmlProps);
});
var TagName$4$2 = "button";
function isNativeClick$2(event) {
  if (!event.isTrusted) return false;
  const element2 = event.currentTarget;
  if (event.key === "Enter") {
    return isButton$2(element2) || element2.tagName === "SUMMARY" || element2.tagName === "A";
  }
  if (event.key === " ") {
    return isButton$2(element2) || element2.tagName === "SUMMARY" || element2.tagName === "INPUT" || element2.tagName === "SELECT";
  }
  return false;
}
var symbol$4 = Symbol("command");
var useCommand$2 = createHook$2(
  function useCommand2({ clickOnEnter = true, clickOnSpace = true, ...props2 }) {
    const ref = useRef(null);
    const [isNativeButton, setIsNativeButton] = useState(false);
    useEffect(() => {
      if (!ref.current) return;
      setIsNativeButton(isButton$2(ref.current));
    }, []);
    const [active, setActive] = useState(false);
    const activeRef = useRef(false);
    const disabled = disabledFromProps$2(props2);
    const [isDuplicate, metadataProps] = useMetadataProps$2(props2, symbol$4, true);
    const onKeyDownProp = props2.onKeyDown;
    const onKeyDown = useEvent$2((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      const element2 = event.currentTarget;
      if (event.defaultPrevented) return;
      if (isDuplicate) return;
      if (disabled) return;
      if (!isSelfTarget$2(event)) return;
      if (isTextField$2(element2)) return;
      if (element2.isContentEditable) return;
      const isEnter = clickOnEnter && event.key === "Enter";
      const isSpace2 = clickOnSpace && event.key === " ";
      const shouldPreventEnter = event.key === "Enter" && !clickOnEnter;
      const shouldPreventSpace = event.key === " " && !clickOnSpace;
      if (shouldPreventEnter || shouldPreventSpace) {
        event.preventDefault();
        return;
      }
      if (isEnter || isSpace2) {
        const nativeClick = isNativeClick$2(event);
        if (isEnter) {
          if (!nativeClick) {
            event.preventDefault();
            const { view, ...eventInit } = event;
            const click = () => fireClickEvent$2(element2, eventInit);
            if (isFirefox$2()) {
              queueBeforeEvent$2(element2, "keyup", click);
            } else {
              queueMicrotask(click);
            }
          }
        } else if (isSpace2) {
          activeRef.current = true;
          if (!nativeClick) {
            event.preventDefault();
            setActive(true);
          }
        }
      }
    });
    const onKeyUpProp = props2.onKeyUp;
    const onKeyUp = useEvent$2((event) => {
      onKeyUpProp == null ? void 0 : onKeyUpProp(event);
      if (event.defaultPrevented) return;
      if (isDuplicate) return;
      if (disabled) return;
      if (event.metaKey) return;
      const isSpace2 = clickOnSpace && event.key === " ";
      if (activeRef.current && isSpace2) {
        activeRef.current = false;
        if (!isNativeClick$2(event)) {
          event.preventDefault();
          setActive(false);
          const element2 = event.currentTarget;
          const { view, ...eventInit } = event;
          queueMicrotask(() => fireClickEvent$2(element2, eventInit));
        }
      }
    });
    props2 = {
      "data-active": active || void 0,
      type: isNativeButton ? "button" : void 0,
      ...metadataProps,
      ...props2,
      ref: useMergeRefs$2(ref, props2.ref),
      onKeyDown,
      onKeyUp
    };
    props2 = useFocusable$2(props2);
    return props2;
  }
);
forwardRef2$2(function Command2(props2) {
  const htmlProps = useCommand$2(props2);
  return createElement$2(TagName$4$2, htmlProps);
});
function getInternal$2(store2, key) {
  const internals = store2.__unstableInternals;
  invariant$2(internals, "Invalid store");
  return internals[key];
}
function createStore$2(initialState2, ...stores) {
  let state = initialState2;
  let prevStateBatch = state;
  let lastUpdate = Symbol();
  let destroy = noop$2$1;
  const instances = /* @__PURE__ */ new Set();
  const updatedKeys = /* @__PURE__ */ new Set();
  const setups = /* @__PURE__ */ new Set();
  const listeners = /* @__PURE__ */ new Set();
  const batchListeners = /* @__PURE__ */ new Set();
  const disposables = /* @__PURE__ */ new WeakMap();
  const listenerKeys = /* @__PURE__ */ new WeakMap();
  const storeSetup = (callback) => {
    setups.add(callback);
    return () => setups.delete(callback);
  };
  const storeInit = () => {
    const initialized = instances.size;
    const instance = Symbol();
    instances.add(instance);
    const maybeDestroy = () => {
      instances.delete(instance);
      if (instances.size) return;
      destroy();
    };
    if (initialized) return maybeDestroy;
    const desyncs = getKeys$2(state).map(
      (key) => chain$1$1(
        ...stores.map((store2) => {
          var _a2;
          const storeState = (_a2 = store2 == null ? void 0 : store2.getState) == null ? void 0 : _a2.call(store2);
          if (!storeState) return;
          if (!hasOwnProperty$2$1(storeState, key)) return;
          return sync$2(store2, [key], (state2) => {
            setState(
              key,
              state2[key],
              // @ts-expect-error - Not public API. This is just to prevent
              // infinite loops.
              true
            );
          });
        })
      )
    );
    const teardowns = [];
    for (const setup2 of setups) {
      teardowns.push(setup2());
    }
    const cleanups2 = stores.map(init$2);
    destroy = chain$1$1(...desyncs, ...teardowns, ...cleanups2);
    return maybeDestroy;
  };
  const sub2 = (keys2, listener, set2 = listeners) => {
    set2.add(listener);
    listenerKeys.set(listener, keys2);
    return () => {
      var _a2;
      (_a2 = disposables.get(listener)) == null ? void 0 : _a2();
      disposables.delete(listener);
      listenerKeys.delete(listener);
      set2.delete(listener);
    };
  };
  const storeSubscribe = (keys2, listener) => sub2(keys2, listener);
  const storeSync = (keys2, listener) => {
    disposables.set(listener, listener(state, state));
    return sub2(keys2, listener);
  };
  const storeBatch = (keys2, listener) => {
    disposables.set(listener, listener(state, prevStateBatch));
    return sub2(keys2, listener, batchListeners);
  };
  const storePick = (keys2) => createStore$2(pick$1$1(state, keys2), finalStore);
  const storeOmit = (keys2) => createStore$2(omit$1$1(state, keys2), finalStore);
  const getState = () => state;
  const setState = (key, value, fromStores = false) => {
    var _a2;
    if (!hasOwnProperty$2$1(state, key)) return;
    const nextValue = applyState$2(value, state[key]);
    if (nextValue === state[key]) return;
    if (!fromStores) {
      for (const store2 of stores) {
        (_a2 = store2 == null ? void 0 : store2.setState) == null ? void 0 : _a2.call(store2, key, nextValue);
      }
    }
    const prevState = state;
    state = { ...state, [key]: nextValue };
    const thisUpdate = Symbol();
    lastUpdate = thisUpdate;
    updatedKeys.add(key);
    const run = (listener, prev, uKeys) => {
      var _a22;
      const keys2 = listenerKeys.get(listener);
      const updated = (k2) => uKeys ? uKeys.has(k2) : k2 === key;
      if (!keys2 || keys2.some(updated)) {
        (_a22 = disposables.get(listener)) == null ? void 0 : _a22();
        disposables.set(listener, listener(state, prev));
      }
    };
    for (const listener of listeners) {
      run(listener, prevState);
    }
    queueMicrotask(() => {
      if (lastUpdate !== thisUpdate) return;
      const snapshot = state;
      for (const listener of batchListeners) {
        run(listener, prevStateBatch, updatedKeys);
      }
      prevStateBatch = snapshot;
      updatedKeys.clear();
    });
  };
  const finalStore = {
    getState,
    setState,
    __unstableInternals: {
      setup: storeSetup,
      init: storeInit,
      subscribe: storeSubscribe,
      sync: storeSync,
      batch: storeBatch,
      pick: storePick,
      omit: storeOmit
    }
  };
  return finalStore;
}
function setup$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "setup")(...args);
}
function init$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "init")(...args);
}
function subscribe$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "subscribe")(...args);
}
function sync$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "sync")(...args);
}
function batch$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "batch")(...args);
}
function omit2$1(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "omit")(...args);
}
function mergeStore$1(...stores) {
  var _a2;
  const initialState2 = {};
  for (const store22 of stores) {
    const nextState = (_a2 = store22 == null ? void 0 : store22.getState) == null ? void 0 : _a2.call(store22);
    if (nextState) {
      Object.assign(initialState2, nextState);
    }
  }
  const store2 = createStore$2(initialState2, ...stores);
  return Object.assign({}, ...stores, store2);
}
function throwOnConflictingProps$2(props2, store2) {
  if (process.env.NODE_ENV === "production") return;
  if (!store2) return;
  const defaultKeys = Object.entries(props2).filter(([key, value]) => key.startsWith("default") && value !== void 0).map(([key]) => {
    var _a2;
    const stateKey = key.replace("default", "");
    return `${((_a2 = stateKey[0]) == null ? void 0 : _a2.toLowerCase()) || ""}${stateKey.slice(1)}`;
  });
  if (!defaultKeys.length) return;
  const storeState = store2.getState();
  const conflictingProps = defaultKeys.filter(
    (key) => hasOwnProperty$2$1(storeState, key)
  );
  if (!conflictingProps.length) return;
  throw new Error(
    `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
  );
}
var shim$2 = { exports: {} };
var useSyncExternalStoreShim_production$2 = {};
var hasRequiredUseSyncExternalStoreShim_production$2;
function requireUseSyncExternalStoreShim_production$2() {
  if (hasRequiredUseSyncExternalStoreShim_production$2) return useSyncExternalStoreShim_production$2;
  hasRequiredUseSyncExternalStoreShim_production$2 = 1;
  var React2 = React__default;
  function is2(x2, y) {
    return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue;
  function useSyncExternalStore$22(subscribe2, getSnapshot) {
    var value = getSnapshot(), _useState = useState2({ inst: { value, getSnapshot } }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect2(
      function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
      },
      [subscribe2, value, getSnapshot]
    );
    useEffect2(
      function() {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        return subscribe2(function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        });
      },
      [subscribe2]
    );
    useDebugValue(value);
    return value;
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function useSyncExternalStore$12(subscribe2, getSnapshot) {
    return getSnapshot();
  }
  var shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$12 : useSyncExternalStore$22;
  useSyncExternalStoreShim_production$2.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
  return useSyncExternalStoreShim_production$2;
}
var useSyncExternalStoreShim_development$2 = {};
var hasRequiredUseSyncExternalStoreShim_development$2;
function requireUseSyncExternalStoreShim_development$2() {
  if (hasRequiredUseSyncExternalStoreShim_development$2) return useSyncExternalStoreShim_development$2;
  hasRequiredUseSyncExternalStoreShim_development$2 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function is2(x2, y) {
      return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
    }
    function useSyncExternalStore$22(subscribe2, getSnapshot) {
      didWarnOld18Alpha || void 0 === React2.startTransition || (didWarnOld18Alpha = true, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var value = getSnapshot();
      if (!didWarnUncachedGetSnapshot) {
        var cachedValue = getSnapshot();
        objectIs(value, cachedValue) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      cachedValue = useState2({
        inst: { value, getSnapshot }
      });
      var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
      useLayoutEffect2(
        function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        },
        [subscribe2, value, getSnapshot]
      );
      useEffect2(
        function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          return subscribe2(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          });
        },
        [subscribe2]
      );
      useDebugValue(value);
      return value;
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error) {
        return true;
      }
    }
    function useSyncExternalStore$12(subscribe2, getSnapshot) {
      return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue, didWarnOld18Alpha = false, didWarnUncachedGetSnapshot = false, shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$12 : useSyncExternalStore$22;
    useSyncExternalStoreShim_development$2.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return useSyncExternalStoreShim_development$2;
}
var hasRequiredShim$2;
function requireShim$2() {
  if (hasRequiredShim$2) return shim$2.exports;
  hasRequiredShim$2 = 1;
  if (process.env.NODE_ENV === "production") {
    shim$2.exports = requireUseSyncExternalStoreShim_production$2();
  } else {
    shim$2.exports = requireUseSyncExternalStoreShim_development$2();
  }
  return shim$2.exports;
}
var shimExports$2 = requireShim$2();
const useSyncExternalStoreExports$2 = /* @__PURE__ */ getDefaultExportFromCjs$1$1(shimExports$2);
var { useSyncExternalStore: useSyncExternalStore$2 } = useSyncExternalStoreExports$2;
var noopSubscribe$2 = () => () => {
};
function useStoreState$2(store2, keyOrSelector = identity$1$1) {
  const storeSubscribe = React.useCallback(
    (callback) => {
      if (!store2) return noopSubscribe$2();
      return subscribe$2(store2, null, callback);
    },
    [store2]
  );
  const getSnapshot = () => {
    const key = typeof keyOrSelector === "string" ? keyOrSelector : null;
    const selector2 = typeof keyOrSelector === "function" ? keyOrSelector : null;
    const state = store2 == null ? void 0 : store2.getState();
    if (selector2) return selector2(state);
    if (!state) return;
    if (!key) return;
    if (!hasOwnProperty$2$1(state, key)) return;
    return state[key];
  };
  return useSyncExternalStore$2(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreStateObject$2(store2, object2) {
  const objRef = React.useRef(
    {}
  );
  const storeSubscribe = React.useCallback(
    (callback) => {
      if (!store2) return noopSubscribe$2();
      return subscribe$2(store2, null, callback);
    },
    [store2]
  );
  const getSnapshot = () => {
    const state = store2 == null ? void 0 : store2.getState();
    let updated = false;
    const obj = objRef.current;
    for (const prop in object2) {
      const keyOrSelector = object2[prop];
      if (typeof keyOrSelector === "function") {
        const value = keyOrSelector(state);
        if (value !== obj[prop]) {
          obj[prop] = value;
          updated = true;
        }
      }
      if (typeof keyOrSelector === "string") {
        if (!state) continue;
        if (!hasOwnProperty$2$1(state, keyOrSelector)) continue;
        const value = state[keyOrSelector];
        if (value !== obj[prop]) {
          obj[prop] = value;
          updated = true;
        }
      }
    }
    if (updated) {
      objRef.current = { ...obj };
    }
    return objRef.current;
  };
  return useSyncExternalStore$2(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreProps$2(store2, props2, key, setKey) {
  const value = hasOwnProperty$2$1(props2, key) ? props2[key] : void 0;
  const setValue = setKey ? props2[setKey] : void 0;
  const propsRef = useLiveRef$2({ value, setValue });
  useSafeLayoutEffect$2(() => {
    return sync$2(store2, [key], (state, prev) => {
      const { value: value2, setValue: setValue2 } = propsRef.current;
      if (!setValue2) return;
      if (state[key] === prev[key]) return;
      if (state[key] === value2) return;
      setValue2(state[key]);
    });
  }, [store2, key]);
  useSafeLayoutEffect$2(() => {
    if (value === void 0) return;
    store2.setState(key, value);
    return batch$2(store2, [key], () => {
      if (value === void 0) return;
      store2.setState(key, value);
    });
  });
}
function useStore$2(createStore2, props2) {
  const [store2, setStore] = React.useState(() => createStore2(props2));
  useSafeLayoutEffect$2(() => init$2(store2), [store2]);
  const useState2 = React.useCallback(
    (keyOrSelector) => useStoreState$2(store2, keyOrSelector),
    [store2]
  );
  const memoizedStore = React.useMemo(
    () => ({ ...store2, useState: useState2 }),
    [store2, useState2]
  );
  const updateStore = useEvent$2(() => {
    setStore((store22) => createStore2({ ...props2, ...store22.getState() }));
  });
  return [memoizedStore, updateStore];
}
var TagName$3$2 = "button";
function isEditableElement$2(element2) {
  if (isTextbox$2(element2)) return true;
  return element2.tagName === "INPUT" && !isButton$2(element2);
}
function getNextPageOffset$2(scrollingElement, pageUp = false) {
  const height = scrollingElement.clientHeight;
  const { top: top2 } = scrollingElement.getBoundingClientRect();
  const pageSize = Math.max(height * 0.875, height - 40) * 1.5;
  const pageOffset = pageUp ? height - pageSize + top2 : pageSize + top2;
  if (scrollingElement.tagName === "HTML") {
    return pageOffset + scrollingElement.scrollTop;
  }
  return pageOffset;
}
function getItemOffset$2(itemElement, pageUp = false) {
  const { top: top2 } = itemElement.getBoundingClientRect();
  if (pageUp) {
    return top2 + itemElement.clientHeight;
  }
  return top2;
}
function findNextPageItemId$2(element2, store2, next, pageUp = false) {
  var _a2;
  if (!store2) return;
  if (!next) return;
  const { renderedItems } = store2.getState();
  const scrollingElement = getScrollingElement$2(element2);
  if (!scrollingElement) return;
  const nextPageOffset = getNextPageOffset$2(scrollingElement, pageUp);
  let id2;
  let prevDifference;
  for (let i2 = 0; i2 < renderedItems.length; i2 += 1) {
    const previousId = id2;
    id2 = next(i2);
    if (!id2) break;
    if (id2 === previousId) continue;
    const itemElement = (_a2 = getEnabledItem$2(store2, id2)) == null ? void 0 : _a2.element;
    if (!itemElement) continue;
    const itemOffset = getItemOffset$2(itemElement, pageUp);
    const difference2 = itemOffset - nextPageOffset;
    const absDifference = Math.abs(difference2);
    if (pageUp && difference2 <= 0 || !pageUp && difference2 >= 0) {
      if (prevDifference !== void 0 && prevDifference < absDifference) {
        id2 = previousId;
      }
      break;
    }
    prevDifference = absDifference;
  }
  return id2;
}
function targetIsAnotherItem$2(event, store2) {
  if (isSelfTarget$2(event)) return false;
  return isItem$2(store2, event.target);
}
var useCompositeItem$2 = createHook$2(
  function useCompositeItem2({
    store: store2,
    rowId: rowIdProp,
    preventScrollOnKeyDown = false,
    moveOnKeyPress = true,
    tabbable = false,
    getItem: getItemProp,
    "aria-setsize": ariaSetSizeProp,
    "aria-posinset": ariaPosInSetProp,
    ...props2
  }) {
    const context = useCompositeContext$2();
    store2 = store2 || context;
    const id2 = useId$3(props2.id);
    const ref = useRef(null);
    const row = useContext(CompositeRowContext$2);
    const disabled = disabledFromProps$2(props2);
    const trulyDisabled = disabled && !props2.accessibleWhenDisabled;
    const {
      rowId,
      baseElement,
      isActiveItem,
      ariaSetSize,
      ariaPosInSet,
      isTabbable: isTabbable2
    } = useStoreStateObject$2(store2, {
      rowId(state) {
        if (rowIdProp) return rowIdProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.baseElement)) return;
        if (row.baseElement !== state.baseElement) return;
        return row.id;
      },
      baseElement(state) {
        return (state == null ? void 0 : state.baseElement) || void 0;
      },
      isActiveItem(state) {
        return !!state && state.activeId === id2;
      },
      ariaSetSize(state) {
        if (ariaSetSizeProp != null) return ariaSetSizeProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.ariaSetSize)) return;
        if (row.baseElement !== state.baseElement) return;
        return row.ariaSetSize;
      },
      ariaPosInSet(state) {
        if (ariaPosInSetProp != null) return ariaPosInSetProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.ariaPosInSet)) return;
        if (row.baseElement !== state.baseElement) return;
        const itemsInRow = state.renderedItems.filter(
          (item) => item.rowId === rowId
        );
        return row.ariaPosInSet + itemsInRow.findIndex((item) => item.id === id2);
      },
      isTabbable(state) {
        if (!(state == null ? void 0 : state.renderedItems.length)) return true;
        if (state.virtualFocus) return false;
        if (tabbable) return true;
        if (state.activeId === null) return false;
        const item = store2 == null ? void 0 : store2.item(state.activeId);
        if (item == null ? void 0 : item.disabled) return true;
        if (!(item == null ? void 0 : item.element)) return true;
        return state.activeId === id2;
      }
    });
    const getItem = useCallback(
      (item) => {
        var _a2;
        const nextItem = {
          ...item,
          id: id2 || item.id,
          rowId,
          disabled: !!trulyDisabled,
          children: (_a2 = item.element) == null ? void 0 : _a2.textContent
        };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [id2, rowId, trulyDisabled, getItemProp]
    );
    const onFocusProp = props2.onFocus;
    const hasFocusedComposite = useRef(false);
    const onFocus = useEvent$2((event) => {
      onFocusProp == null ? void 0 : onFocusProp(event);
      if (event.defaultPrevented) return;
      if (isPortalEvent$2(event)) return;
      if (!id2) return;
      if (!store2) return;
      if (targetIsAnotherItem$2(event, store2)) return;
      const { virtualFocus, baseElement: baseElement2 } = store2.getState();
      store2.setActiveId(id2);
      if (isTextbox$2(event.currentTarget)) {
        selectTextField$2(event.currentTarget);
      }
      if (!virtualFocus) return;
      if (!isSelfTarget$2(event)) return;
      if (isEditableElement$2(event.currentTarget)) return;
      if (!(baseElement2 == null ? void 0 : baseElement2.isConnected)) return;
      if (isSafari$2() && event.currentTarget.hasAttribute("data-autofocus")) {
        event.currentTarget.scrollIntoView({
          block: "nearest",
          inline: "nearest"
        });
      }
      hasFocusedComposite.current = true;
      const fromComposite = event.relatedTarget === baseElement2 || isItem$2(store2, event.relatedTarget);
      if (fromComposite) {
        focusSilently$2(baseElement2);
      } else {
        baseElement2.focus();
      }
    });
    const onBlurCaptureProp = props2.onBlurCapture;
    const onBlurCapture = useEvent$2((event) => {
      onBlurCaptureProp == null ? void 0 : onBlurCaptureProp(event);
      if (event.defaultPrevented) return;
      const state = store2 == null ? void 0 : store2.getState();
      if ((state == null ? void 0 : state.virtualFocus) && hasFocusedComposite.current) {
        hasFocusedComposite.current = false;
        event.preventDefault();
        event.stopPropagation();
      }
    });
    const onKeyDownProp = props2.onKeyDown;
    const preventScrollOnKeyDownProp = useBooleanEvent$2(preventScrollOnKeyDown);
    const moveOnKeyPressProp = useBooleanEvent$2(moveOnKeyPress);
    const onKeyDown = useEvent$2((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.defaultPrevented) return;
      if (!isSelfTarget$2(event)) return;
      if (!store2) return;
      const { currentTarget } = event;
      const state = store2.getState();
      const item = store2.item(id2);
      const isGrid2 = !!(item == null ? void 0 : item.rowId);
      const isVertical = state.orientation !== "horizontal";
      const isHorizontal = state.orientation !== "vertical";
      const canHomeEnd = () => {
        if (isGrid2) return true;
        if (isHorizontal) return true;
        if (!state.baseElement) return true;
        if (!isTextField$2(state.baseElement)) return true;
        return false;
      };
      const keyMap = {
        ArrowUp: (isGrid2 || isVertical) && store2.up,
        ArrowRight: (isGrid2 || isHorizontal) && store2.next,
        ArrowDown: (isGrid2 || isVertical) && store2.down,
        ArrowLeft: (isGrid2 || isHorizontal) && store2.previous,
        Home: () => {
          if (!canHomeEnd()) return;
          if (!isGrid2 || event.ctrlKey) {
            return store2 == null ? void 0 : store2.first();
          }
          return store2 == null ? void 0 : store2.previous(-1);
        },
        End: () => {
          if (!canHomeEnd()) return;
          if (!isGrid2 || event.ctrlKey) {
            return store2 == null ? void 0 : store2.last();
          }
          return store2 == null ? void 0 : store2.next(-1);
        },
        PageUp: () => {
          return findNextPageItemId$2(currentTarget, store2, store2 == null ? void 0 : store2.up, true);
        },
        PageDown: () => {
          return findNextPageItemId$2(currentTarget, store2, store2 == null ? void 0 : store2.down);
        }
      };
      const action = keyMap[event.key];
      if (action) {
        if (isTextbox$2(currentTarget)) {
          const selection2 = getTextboxSelection$2(currentTarget);
          const isLeft = isHorizontal && event.key === "ArrowLeft";
          const isRight = isHorizontal && event.key === "ArrowRight";
          const isUp = isVertical && event.key === "ArrowUp";
          const isDown = isVertical && event.key === "ArrowDown";
          if (isRight || isDown) {
            const { length: valueLength } = getTextboxValue$2(currentTarget);
            if (selection2.end !== valueLength) return;
          } else if ((isLeft || isUp) && selection2.start !== 0) return;
        }
        const nextId = action();
        if (preventScrollOnKeyDownProp(event) || nextId !== void 0) {
          if (!moveOnKeyPressProp(event)) return;
          event.preventDefault();
          store2.move(nextId);
        }
      }
    });
    const providerValue = useMemo(
      () => ({ id: id2, baseElement }),
      [id2, baseElement]
    );
    props2 = useWrapElement$2(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(CompositeItemContext$2.Provider, { value: providerValue, children: element2 }),
      [providerValue]
    );
    props2 = {
      id: id2,
      "data-active-item": isActiveItem || void 0,
      ...props2,
      ref: useMergeRefs$2(ref, props2.ref),
      tabIndex: isTabbable2 ? props2.tabIndex : -1,
      onFocus,
      onBlurCapture,
      onKeyDown
    };
    props2 = useCommand$2(props2);
    props2 = useCollectionItem$2({
      store: store2,
      ...props2,
      getItem,
      shouldRegisterItem: id2 ? props2.shouldRegisterItem : false
    });
    return removeUndefinedValues$2({
      ...props2,
      "aria-setsize": ariaSetSize,
      "aria-posinset": ariaPosInSet
    });
  }
);
var CompositeItem$1 = memo2$2(
  forwardRef2$2(function CompositeItem2(props2) {
    const htmlProps = useCompositeItem$2(props2);
    return createElement$2(TagName$3$2, htmlProps);
  })
);
var TagName$2$2 = "button";
var useTab$1 = createHook$2(function useTab2({
  store: store2,
  getItem: getItemProp,
  ...props2
}) {
  var _a2;
  const context = useTabScopedContext$1();
  store2 = store2 || context;
  invariant$2(
    store2,
    process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component."
  );
  const defaultId = useId$3();
  const id2 = props2.id || defaultId;
  const dimmed = disabledFromProps$2(props2);
  const getItem = useCallback(
    (item) => {
      const nextItem = { ...item, dimmed };
      if (getItemProp) {
        return getItemProp(nextItem);
      }
      return nextItem;
    },
    [dimmed, getItemProp]
  );
  const onClickProp = props2.onClick;
  const onClick = useEvent$2((event) => {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    store2 == null ? void 0 : store2.setSelectedId(id2);
  });
  const panelId = store2.panels.useState(
    (state) => {
      var _a22;
      return (_a22 = state.items.find((item) => item.tabId === id2)) == null ? void 0 : _a22.id;
    }
  );
  const shouldRegisterItem = defaultId ? props2.shouldRegisterItem : false;
  const isActive = store2.useState((state) => !!id2 && state.activeId === id2);
  const selected = store2.useState((state) => !!id2 && state.selectedId === id2);
  const hasActiveItem = store2.useState((state) => !!store2.item(state.activeId));
  const canRegisterComposedItem = isActive || selected && !hasActiveItem;
  const accessibleWhenDisabled = selected || ((_a2 = props2.accessibleWhenDisabled) != null ? _a2 : true);
  const isWithinVirtualFocusComposite = useStoreState$2(
    store2.combobox || store2.composite,
    "virtualFocus"
  );
  if (isWithinVirtualFocusComposite) {
    props2 = {
      ...props2,
      tabIndex: -1
    };
  }
  props2 = {
    id: id2,
    role: "tab",
    "aria-selected": selected,
    "aria-controls": panelId || void 0,
    ...props2,
    onClick
  };
  if (store2.composite) {
    const defaultProps = {
      id: id2,
      accessibleWhenDisabled,
      store: store2.composite,
      shouldRegisterItem: canRegisterComposedItem && shouldRegisterItem,
      rowId: props2.rowId,
      render: props2.render
    };
    props2 = {
      ...props2,
      render: /* @__PURE__ */ jsxRuntimeExports$2.jsx(
        CompositeItem$1,
        {
          ...defaultProps,
          render: store2.combobox && store2.composite !== store2.combobox ? /* @__PURE__ */ jsxRuntimeExports$2.jsx(CompositeItem$1, { ...defaultProps, store: store2.combobox }) : defaultProps.render
        }
      )
    };
  }
  props2 = useCompositeItem$2({
    store: store2,
    ...props2,
    accessibleWhenDisabled,
    getItem,
    shouldRegisterItem
  });
  return props2;
});
var Tab$1 = memo2$2(
  forwardRef2$2(function Tab2(props2) {
    const htmlProps = useTab$1(props2);
    return createElement$2(TagName$2$2, htmlProps);
  })
);
function flatten2DArray$2(array) {
  const flattened2 = [];
  for (const row of array) {
    flattened2.push(...row);
  }
  return flattened2;
}
function reverseArray$2(array) {
  return array.slice().reverse();
}
var TagName$1$2 = "div";
function isGrid$2(items) {
  return items.some((item) => !!item.rowId);
}
function isPrintableKey$2(event) {
  const target = event.target;
  if (target && !isTextField$2(target)) return false;
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
function isModifierKey$2(event) {
  return event.key === "Shift" || event.key === "Control" || event.key === "Alt" || event.key === "Meta";
}
function useKeyboardEventProxy$2(store2, onKeyboardEvent, previousElementRef) {
  return useEvent$2((event) => {
    var _a2;
    onKeyboardEvent == null ? void 0 : onKeyboardEvent(event);
    if (event.defaultPrevented) return;
    if (event.isPropagationStopped()) return;
    if (!isSelfTarget$2(event)) return;
    if (isModifierKey$2(event)) return;
    if (isPrintableKey$2(event)) return;
    const state = store2.getState();
    const activeElement = (_a2 = getEnabledItem$2(store2, state.activeId)) == null ? void 0 : _a2.element;
    if (!activeElement) return;
    const { view, ...eventInit } = event;
    const previousElement = previousElementRef == null ? void 0 : previousElementRef.current;
    if (activeElement !== previousElement) {
      activeElement.focus();
    }
    if (!fireKeyboardEvent$2(activeElement, event.type, eventInit)) {
      event.preventDefault();
    }
    if (event.currentTarget.contains(activeElement)) {
      event.stopPropagation();
    }
  });
}
function findFirstEnabledItemInTheLastRow$2(items) {
  return findFirstEnabledItem$1$2(
    flatten2DArray$2(reverseArray$2(groupItemsByRows$1$2(items)))
  );
}
function useScheduleFocus$2(store2) {
  const [scheduled, setScheduled] = useState(false);
  const schedule = useCallback(() => setScheduled(true), []);
  const activeItem = store2.useState(
    (state) => getEnabledItem$2(store2, state.activeId)
  );
  useEffect(() => {
    const activeElement = activeItem == null ? void 0 : activeItem.element;
    if (!scheduled) return;
    if (!activeElement) return;
    setScheduled(false);
    activeElement.focus({ preventScroll: true });
  }, [activeItem, scheduled]);
  return schedule;
}
var useComposite$2 = createHook$2(
  function useComposite2({
    store: store2,
    composite = true,
    focusOnMove = composite,
    moveOnKeyPress = true,
    ...props2
  }) {
    const context = useCompositeProviderContext$2();
    store2 = store2 || context;
    invariant$2(
      store2,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const ref = useRef(null);
    const previousElementRef = useRef(null);
    const scheduleFocus = useScheduleFocus$2(store2);
    const moves = store2.useState("moves");
    const [, setBaseElement] = useTransactionState$2(
      composite ? store2.setBaseElement : null
    );
    useEffect(() => {
      var _a2;
      if (!store2) return;
      if (!moves) return;
      if (!composite) return;
      if (!focusOnMove) return;
      const { activeId: activeId2 } = store2.getState();
      const itemElement = (_a2 = getEnabledItem$2(store2, activeId2)) == null ? void 0 : _a2.element;
      if (!itemElement) return;
      focusIntoView$2(itemElement);
    }, [store2, moves, composite, focusOnMove]);
    useSafeLayoutEffect$2(() => {
      if (!store2) return;
      if (!moves) return;
      if (!composite) return;
      const { baseElement, activeId: activeId2 } = store2.getState();
      const isSelfAcive = activeId2 === null;
      if (!isSelfAcive) return;
      if (!baseElement) return;
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (previousElement) {
        fireBlurEvent$2(previousElement, { relatedTarget: baseElement });
      }
      if (!hasFocus$2(baseElement)) {
        baseElement.focus();
      }
    }, [store2, moves, composite]);
    const activeId = store2.useState("activeId");
    const virtualFocus = store2.useState("virtualFocus");
    useSafeLayoutEffect$2(() => {
      var _a2;
      if (!store2) return;
      if (!composite) return;
      if (!virtualFocus) return;
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (!previousElement) return;
      const activeElement = (_a2 = getEnabledItem$2(store2, activeId)) == null ? void 0 : _a2.element;
      const relatedTarget = activeElement || getActiveElement$2(previousElement);
      if (relatedTarget === previousElement) return;
      fireBlurEvent$2(previousElement, { relatedTarget });
    }, [store2, activeId, virtualFocus, composite]);
    const onKeyDownCapture = useKeyboardEventProxy$2(
      store2,
      props2.onKeyDownCapture,
      previousElementRef
    );
    const onKeyUpCapture = useKeyboardEventProxy$2(
      store2,
      props2.onKeyUpCapture,
      previousElementRef
    );
    const onFocusCaptureProp = props2.onFocusCapture;
    const onFocusCapture = useEvent$2((event) => {
      onFocusCaptureProp == null ? void 0 : onFocusCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!store2) return;
      const { virtualFocus: virtualFocus2 } = store2.getState();
      if (!virtualFocus2) return;
      const previousActiveElement = event.relatedTarget;
      const isSilentlyFocused = silentlyFocused$2(event.currentTarget);
      if (isSelfTarget$2(event) && isSilentlyFocused) {
        event.stopPropagation();
        previousElementRef.current = previousActiveElement;
      }
    });
    const onFocusProp = props2.onFocus;
    const onFocus = useEvent$2((event) => {
      onFocusProp == null ? void 0 : onFocusProp(event);
      if (event.defaultPrevented) return;
      if (!composite) return;
      if (!store2) return;
      const { relatedTarget } = event;
      const { virtualFocus: virtualFocus2 } = store2.getState();
      if (virtualFocus2) {
        if (isSelfTarget$2(event) && !isItem$2(store2, relatedTarget)) {
          queueMicrotask(scheduleFocus);
        }
      } else if (isSelfTarget$2(event)) {
        store2.setActiveId(null);
      }
    });
    const onBlurCaptureProp = props2.onBlurCapture;
    const onBlurCapture = useEvent$2((event) => {
      var _a2;
      onBlurCaptureProp == null ? void 0 : onBlurCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!store2) return;
      const { virtualFocus: virtualFocus2, activeId: activeId2 } = store2.getState();
      if (!virtualFocus2) return;
      const activeElement = (_a2 = getEnabledItem$2(store2, activeId2)) == null ? void 0 : _a2.element;
      const nextActiveElement = event.relatedTarget;
      const nextActiveElementIsItem = isItem$2(store2, nextActiveElement);
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (isSelfTarget$2(event) && nextActiveElementIsItem) {
        if (nextActiveElement === activeElement) {
          if (previousElement && previousElement !== nextActiveElement) {
            fireBlurEvent$2(previousElement, event);
          }
        } else if (activeElement) {
          fireBlurEvent$2(activeElement, event);
        } else if (previousElement) {
          fireBlurEvent$2(previousElement, event);
        }
        event.stopPropagation();
      } else {
        const targetIsItem = isItem$2(store2, event.target);
        if (!targetIsItem && activeElement) {
          fireBlurEvent$2(activeElement, event);
        }
      }
    });
    const onKeyDownProp = props2.onKeyDown;
    const moveOnKeyPressProp = useBooleanEvent$2(moveOnKeyPress);
    const onKeyDown = useEvent$2((event) => {
      var _a2;
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.nativeEvent.isComposing) return;
      if (event.defaultPrevented) return;
      if (!store2) return;
      if (!isSelfTarget$2(event)) return;
      const { orientation, renderedItems, activeId: activeId2 } = store2.getState();
      const activeItem = getEnabledItem$2(store2, activeId2);
      if ((_a2 = activeItem == null ? void 0 : activeItem.element) == null ? void 0 : _a2.isConnected) return;
      const isVertical = orientation !== "horizontal";
      const isHorizontal = orientation !== "vertical";
      const grid = isGrid$2(renderedItems);
      const isHorizontalKey = event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Home" || event.key === "End";
      if (isHorizontalKey && isTextField$2(event.currentTarget)) return;
      const up = () => {
        if (grid) {
          const item = findFirstEnabledItemInTheLastRow$2(renderedItems);
          return item == null ? void 0 : item.id;
        }
        return store2 == null ? void 0 : store2.last();
      };
      const keyMap = {
        ArrowUp: (grid || isVertical) && up,
        ArrowRight: (grid || isHorizontal) && store2.first,
        ArrowDown: (grid || isVertical) && store2.first,
        ArrowLeft: (grid || isHorizontal) && store2.last,
        Home: store2.first,
        End: store2.last,
        PageUp: store2.first,
        PageDown: store2.last
      };
      const action = keyMap[event.key];
      if (action) {
        const id2 = action();
        if (id2 !== void 0) {
          if (!moveOnKeyPressProp(event)) return;
          event.preventDefault();
          store2.move(id2);
        }
      }
    });
    props2 = useWrapElement$2(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(CompositeContextProvider$2, { value: store2, children: element2 }),
      [store2]
    );
    const activeDescendant = store2.useState((state) => {
      var _a2;
      if (!store2) return;
      if (!composite) return;
      if (!state.virtualFocus) return;
      return (_a2 = getEnabledItem$2(store2, state.activeId)) == null ? void 0 : _a2.id;
    });
    props2 = {
      "aria-activedescendant": activeDescendant,
      ...props2,
      ref: useMergeRefs$2(ref, setBaseElement, props2.ref),
      onKeyDownCapture,
      onKeyUpCapture,
      onFocusCapture,
      onFocus,
      onBlurCapture,
      onKeyDown
    };
    const focusable = store2.useState(
      (state) => composite && (state.virtualFocus || state.activeId === null)
    );
    props2 = useFocusable$2({ focusable, ...props2 });
    return props2;
  }
);
forwardRef2$2(function Composite2(props2) {
  const htmlProps = useComposite$2(props2);
  return createElement$2(TagName$1$2, htmlProps);
});
var TagName$x = "div";
var useTabList$1 = createHook$2(
  function useTabList2({ store: store2, ...props2 }) {
    const context = useTabProviderContext$1();
    store2 = store2 || context;
    invariant$2(
      store2,
      process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const orientation = store2.useState(
      (state) => state.orientation === "both" ? void 0 : state.orientation
    );
    props2 = useWrapElement$2(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(TabScopedContextProvider$1, { value: store2, children: element2 }),
      [store2]
    );
    if (store2.composite) {
      props2 = {
        focusable: false,
        ...props2
      };
    }
    props2 = {
      role: "tablist",
      "aria-orientation": orientation,
      ...props2
    };
    props2 = useComposite$2({ store: store2, ...props2 });
    return props2;
  }
);
var TabList$1 = forwardRef2$2(function TabList2(props2) {
  const htmlProps = useTabList$1(props2);
  return createElement$2(TagName$x, htmlProps);
});
var ctx$4$1 = createStoreContext$2();
var DisclosureContextProvider$1 = ctx$4$1.ContextProvider;
var DisclosureScopedContextProvider$1 = ctx$4$1.ScopedContextProvider;
var ctx$3$2 = createStoreContext$2(
  [DisclosureContextProvider$1],
  [DisclosureScopedContextProvider$1]
);
var DialogContextProvider$1 = ctx$3$2.ContextProvider;
var DialogScopedContextProvider$1 = ctx$3$2.ScopedContextProvider;
createContext(void 0);
createContext(void 0);
var ctx$2$2 = createStoreContext$2(
  [DialogContextProvider$1],
  [DialogScopedContextProvider$1]
);
var PopoverContextProvider$1 = ctx$2$2.ContextProvider;
var PopoverScopedContextProvider$1 = ctx$2$2.ScopedContextProvider;
var ctx$1$2 = createStoreContext$2(
  [PopoverContextProvider$1, CompositeContextProvider$2],
  [PopoverScopedContextProvider$1, CompositeScopedContextProvider$2]
);
var useSelectContext$1 = ctx$1$2.useContext;
createContext(false);
createContext(null);
function getCommonParent$2(items) {
  var _a2;
  const firstItem = items.find((item) => !!item.element);
  const lastItem = [...items].reverse().find((item) => !!item.element);
  let parentElement = (_a2 = firstItem == null ? void 0 : firstItem.element) == null ? void 0 : _a2.parentElement;
  while (parentElement && (lastItem == null ? void 0 : lastItem.element)) {
    const parent = parentElement;
    if (lastItem && parent.contains(lastItem.element)) {
      return parentElement;
    }
    parentElement = parentElement.parentElement;
  }
  return getDocument$2(parentElement).body;
}
function getPrivateStore$2(store2) {
  return store2 == null ? void 0 : store2.__unstablePrivateStore;
}
function createCollectionStore$2(props2 = {}) {
  var _a2;
  throwOnConflictingProps$2(props2, props2.store);
  const syncState = (_a2 = props2.store) == null ? void 0 : _a2.getState();
  const items = defaultValue$2(
    props2.items,
    syncState == null ? void 0 : syncState.items,
    props2.defaultItems,
    []
  );
  const itemsMap = new Map(items.map((item) => [item.id, item]));
  const initialState2 = {
    items,
    renderedItems: defaultValue$2(syncState == null ? void 0 : syncState.renderedItems, [])
  };
  const syncPrivateStore = getPrivateStore$2(props2.store);
  const privateStore = createStore$2(
    { items, renderedItems: initialState2.renderedItems },
    syncPrivateStore
  );
  const collection = createStore$2(initialState2, props2.store);
  const sortItems = (renderedItems) => {
    const sortedItems = sortBasedOnDOMPosition$2(renderedItems, (i2) => i2.element);
    privateStore.setState("renderedItems", sortedItems);
    collection.setState("renderedItems", sortedItems);
  };
  setup$2(collection, () => init$2(privateStore));
  setup$2(privateStore, () => {
    return batch$2(privateStore, ["items"], (state) => {
      collection.setState("items", state.items);
    });
  });
  setup$2(privateStore, () => {
    return batch$2(privateStore, ["renderedItems"], (state) => {
      let firstRun = true;
      let raf = requestAnimationFrame(() => {
        const { renderedItems } = collection.getState();
        if (state.renderedItems === renderedItems) return;
        sortItems(state.renderedItems);
      });
      if (typeof IntersectionObserver !== "function") {
        return () => cancelAnimationFrame(raf);
      }
      const ioCallback = () => {
        if (firstRun) {
          firstRun = false;
          return;
        }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => sortItems(state.renderedItems));
      };
      const root2 = getCommonParent$2(state.renderedItems);
      const observer = new IntersectionObserver(ioCallback, { root: root2 });
      for (const item of state.renderedItems) {
        if (!item.element) continue;
        observer.observe(item.element);
      }
      return () => {
        cancelAnimationFrame(raf);
        observer.disconnect();
      };
    });
  });
  const mergeItem = (item, setItems, canDeleteFromMap = false) => {
    let prevItem;
    setItems((items2) => {
      const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
      const nextItems = items2.slice();
      if (index2 !== -1) {
        prevItem = items2[index2];
        const nextItem = { ...prevItem, ...item };
        nextItems[index2] = nextItem;
        itemsMap.set(item.id, nextItem);
      } else {
        nextItems.push(item);
        itemsMap.set(item.id, item);
      }
      return nextItems;
    });
    const unmergeItem = () => {
      setItems((items2) => {
        if (!prevItem) {
          if (canDeleteFromMap) {
            itemsMap.delete(item.id);
          }
          return items2.filter(({ id: id2 }) => id2 !== item.id);
        }
        const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
        if (index2 === -1) return items2;
        const nextItems = items2.slice();
        nextItems[index2] = prevItem;
        itemsMap.set(item.id, prevItem);
        return nextItems;
      });
    };
    return unmergeItem;
  };
  const registerItem = (item) => mergeItem(
    item,
    (getItems) => privateStore.setState("items", getItems),
    true
  );
  return {
    ...collection,
    registerItem,
    renderItem: (item) => chain$1$1(
      registerItem(item),
      mergeItem(
        item,
        (getItems) => privateStore.setState("renderedItems", getItems)
      )
    ),
    item: (id2) => {
      if (!id2) return null;
      let item = itemsMap.get(id2);
      if (!item) {
        const { items: items2 } = privateStore.getState();
        item = items2.find((item2) => item2.id === id2);
        if (item) {
          itemsMap.set(id2, item);
        }
      }
      return item || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: privateStore
  };
}
function useCollectionStoreProps$2(store2, update, props2) {
  useUpdateEffect$2(update, [props2.store]);
  useStoreProps$2(store2, props2, "items", "setItems");
  return store2;
}
var NULL_ITEM$3 = { id: null };
function findFirstEnabledItem$3(items, excludeId) {
  return items.find((item) => {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getEnabledItems$3(items, excludeId) {
  return items.filter((item) => {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getItemsInRow$2(items, rowId) {
  return items.filter((item) => item.rowId === rowId);
}
function flipItems$3(items, activeId, shouldInsertNullItem = false) {
  const index2 = items.findIndex((item) => item.id === activeId);
  return [
    ...items.slice(index2 + 1),
    ...shouldInsertNullItem ? [NULL_ITEM$3] : [],
    ...items.slice(0, index2)
  ];
}
function groupItemsByRows$3(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => {
      var _a2;
      return ((_a2 = currentRow[0]) == null ? void 0 : _a2.rowId) === item.rowId;
    });
    if (row) {
      row.push(item);
    } else {
      rows.push([item]);
    }
  }
  return rows;
}
function getMaxRowLength$2(array) {
  let maxLength = 0;
  for (const { length } of array) {
    if (length > maxLength) {
      maxLength = length;
    }
  }
  return maxLength;
}
function createEmptyItem$2(rowId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    rowId
  };
}
function normalizeRows$2(rows, activeId, focusShift) {
  const maxLength = getMaxRowLength$2(rows);
  for (const row of rows) {
    for (let i2 = 0; i2 < maxLength; i2 += 1) {
      const item = row[i2];
      if (!item || focusShift && item.disabled) {
        const isFirst = i2 === 0;
        const previousItem = isFirst && focusShift ? findFirstEnabledItem$3(row) : row[i2 - 1];
        row[i2] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem$2(previousItem == null ? void 0 : previousItem.rowId);
      }
    }
  }
  return rows;
}
function verticalizeItems$2(items) {
  const rows = groupItemsByRows$3(items);
  const maxLength = getMaxRowLength$2(rows);
  const verticalized = [];
  for (let i2 = 0; i2 < maxLength; i2 += 1) {
    for (const row of rows) {
      const item = row[i2];
      if (item) {
        verticalized.push({
          ...item,
          // If there's no rowId, it means that it's not a grid composite, but
          // a single row instead. So, instead of verticalizing it, that is,
          // assigning a different rowId based on the column index, we keep it
          // undefined so they will be part of the same row. This is useful
          // when using up/down on one-dimensional composites.
          rowId: item.rowId ? `${i2}` : void 0
        });
      }
    }
  }
  return verticalized;
}
function createCompositeStore$2(props2 = {}) {
  var _a2;
  const syncState = (_a2 = props2.store) == null ? void 0 : _a2.getState();
  const collection = createCollectionStore$2(props2);
  const activeId = defaultValue$2(
    props2.activeId,
    syncState == null ? void 0 : syncState.activeId,
    props2.defaultActiveId
  );
  const initialState2 = {
    ...collection.getState(),
    id: defaultValue$2(
      props2.id,
      syncState == null ? void 0 : syncState.id,
      `id-${Math.random().toString(36).slice(2, 8)}`
    ),
    activeId,
    baseElement: defaultValue$2(syncState == null ? void 0 : syncState.baseElement, null),
    includesBaseElement: defaultValue$2(
      props2.includesBaseElement,
      syncState == null ? void 0 : syncState.includesBaseElement,
      activeId === null
    ),
    moves: defaultValue$2(syncState == null ? void 0 : syncState.moves, 0),
    orientation: defaultValue$2(
      props2.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "both"
    ),
    rtl: defaultValue$2(props2.rtl, syncState == null ? void 0 : syncState.rtl, false),
    virtualFocus: defaultValue$2(
      props2.virtualFocus,
      syncState == null ? void 0 : syncState.virtualFocus,
      false
    ),
    focusLoop: defaultValue$2(props2.focusLoop, syncState == null ? void 0 : syncState.focusLoop, false),
    focusWrap: defaultValue$2(props2.focusWrap, syncState == null ? void 0 : syncState.focusWrap, false),
    focusShift: defaultValue$2(props2.focusShift, syncState == null ? void 0 : syncState.focusShift, false)
  };
  const composite = createStore$2(initialState2, collection, props2.store);
  setup$2(
    composite,
    () => sync$2(composite, ["renderedItems", "activeId"], (state) => {
      composite.setState("activeId", (activeId2) => {
        var _a22;
        if (activeId2 !== void 0) return activeId2;
        return (_a22 = findFirstEnabledItem$3(state.renderedItems)) == null ? void 0 : _a22.id;
      });
    })
  );
  const getNextId = (direction = "next", options2 = {}) => {
    var _a22, _b;
    const defaultState = composite.getState();
    const {
      skip = 0,
      activeId: activeId2 = defaultState.activeId,
      focusShift = defaultState.focusShift,
      focusLoop = defaultState.focusLoop,
      focusWrap = defaultState.focusWrap,
      includesBaseElement = defaultState.includesBaseElement,
      renderedItems = defaultState.renderedItems,
      rtl = defaultState.rtl
    } = options2;
    const isVerticalDirection = direction === "up" || direction === "down";
    const isNextDirection = direction === "next" || direction === "down";
    const canReverse = isNextDirection ? rtl && !isVerticalDirection : !rtl || isVerticalDirection;
    const canShift = focusShift && !skip;
    let items = !isVerticalDirection ? renderedItems : flatten2DArray$2(
      normalizeRows$2(groupItemsByRows$3(renderedItems), activeId2, canShift)
    );
    items = canReverse ? reverseArray$2(items) : items;
    items = isVerticalDirection ? verticalizeItems$2(items) : items;
    if (activeId2 == null) {
      return (_a22 = findFirstEnabledItem$3(items)) == null ? void 0 : _a22.id;
    }
    const activeItem = items.find((item) => item.id === activeId2);
    if (!activeItem) {
      return (_b = findFirstEnabledItem$3(items)) == null ? void 0 : _b.id;
    }
    const isGrid2 = items.some((item) => item.rowId);
    const activeIndex = items.indexOf(activeItem);
    const nextItems = items.slice(activeIndex + 1);
    const nextItemsInRow = getItemsInRow$2(nextItems, activeItem.rowId);
    if (skip) {
      const nextEnabledItemsInRow = getEnabledItems$3(nextItemsInRow, activeId2);
      const nextItem2 = nextEnabledItemsInRow.slice(skip)[0] || // If we can't find an item, just return the last one.
      nextEnabledItemsInRow[nextEnabledItemsInRow.length - 1];
      return nextItem2 == null ? void 0 : nextItem2.id;
    }
    const canLoop = focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical");
    const canWrap = isGrid2 && focusWrap && (isVerticalDirection ? focusWrap !== "horizontal" : focusWrap !== "vertical");
    const hasNullItem = isNextDirection ? (!isGrid2 || isVerticalDirection) && canLoop && includesBaseElement : isVerticalDirection ? includesBaseElement : false;
    if (canLoop) {
      const loopItems = canWrap && !hasNullItem ? items : getItemsInRow$2(items, activeItem.rowId);
      const sortedItems = flipItems$3(loopItems, activeId2, hasNullItem);
      const nextItem2 = findFirstEnabledItem$3(sortedItems, activeId2);
      return nextItem2 == null ? void 0 : nextItem2.id;
    }
    if (canWrap) {
      const nextItem2 = findFirstEnabledItem$3(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        hasNullItem ? nextItemsInRow : nextItems,
        activeId2
      );
      const nextId = hasNullItem ? (nextItem2 == null ? void 0 : nextItem2.id) || null : nextItem2 == null ? void 0 : nextItem2.id;
      return nextId;
    }
    const nextItem = findFirstEnabledItem$3(nextItemsInRow, activeId2);
    if (!nextItem && hasNullItem) {
      return null;
    }
    return nextItem == null ? void 0 : nextItem.id;
  };
  return {
    ...collection,
    ...composite,
    setBaseElement: (element2) => composite.setState("baseElement", element2),
    setActiveId: (id2) => composite.setState("activeId", id2),
    move: (id2) => {
      if (id2 === void 0) return;
      composite.setState("activeId", id2);
      composite.setState("moves", (moves) => moves + 1);
    },
    first: () => {
      var _a22;
      return (_a22 = findFirstEnabledItem$3(composite.getState().renderedItems)) == null ? void 0 : _a22.id;
    },
    last: () => {
      var _a22;
      return (_a22 = findFirstEnabledItem$3(reverseArray$2(composite.getState().renderedItems))) == null ? void 0 : _a22.id;
    },
    next: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("next", options2);
    },
    previous: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("previous", options2);
    },
    down: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("down", options2);
    },
    up: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("up", options2);
    }
  };
}
function useCompositeStoreProps$2(store2, update, props2) {
  store2 = useCollectionStoreProps$2(store2, update, props2);
  useStoreProps$2(store2, props2, "activeId", "setActiveId");
  useStoreProps$2(store2, props2, "includesBaseElement");
  useStoreProps$2(store2, props2, "virtualFocus");
  useStoreProps$2(store2, props2, "orientation");
  useStoreProps$2(store2, props2, "rtl");
  useStoreProps$2(store2, props2, "focusLoop");
  useStoreProps$2(store2, props2, "focusWrap");
  useStoreProps$2(store2, props2, "focusShift");
  return store2;
}
createContext(
  void 0
);
var ctx$a = createStoreContext$2(
  [PopoverContextProvider$1, CompositeContextProvider$2],
  [PopoverScopedContextProvider$1, CompositeScopedContextProvider$2]
);
var useComboboxContext$1 = ctx$a.useContext;
createContext(
  void 0
);
createContext(false);
function createTabStore$1({
  composite: parentComposite,
  combobox,
  ...props2
} = {}) {
  const independentKeys = [
    "items",
    "renderedItems",
    "moves",
    "orientation",
    "virtualFocus",
    "includesBaseElement",
    "baseElement",
    "focusLoop",
    "focusShift",
    "focusWrap"
  ];
  const store2 = mergeStore$1(
    props2.store,
    omit2$1(parentComposite, independentKeys),
    omit2$1(combobox, independentKeys)
  );
  const syncState = store2 == null ? void 0 : store2.getState();
  const composite = createCompositeStore$2({
    ...props2,
    store: store2,
    // We need to explicitly set the default value of `includesBaseElement` to
    // `false` since we don't want the composite store to default it to `true`
    // when the activeId state is null, which could be the case when rendering
    // combobox with tab.
    includesBaseElement: defaultValue$2(
      props2.includesBaseElement,
      syncState == null ? void 0 : syncState.includesBaseElement,
      false
    ),
    orientation: defaultValue$2(
      props2.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "horizontal"
    ),
    focusLoop: defaultValue$2(props2.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  });
  const panels = createCollectionStore$2();
  const initialState2 = {
    ...composite.getState(),
    selectedId: defaultValue$2(
      props2.selectedId,
      syncState == null ? void 0 : syncState.selectedId,
      props2.defaultSelectedId
    ),
    selectOnMove: defaultValue$2(
      props2.selectOnMove,
      syncState == null ? void 0 : syncState.selectOnMove,
      true
    )
  };
  const tab2 = createStore$2(initialState2, composite, store2);
  setup$2(
    tab2,
    () => sync$2(tab2, ["moves"], () => {
      const { activeId, selectOnMove } = tab2.getState();
      if (!selectOnMove) return;
      if (!activeId) return;
      const tabItem = composite.item(activeId);
      if (!tabItem) return;
      if (tabItem.dimmed) return;
      if (tabItem.disabled) return;
      tab2.setState("selectedId", tabItem.id);
    })
  );
  let syncActiveId = true;
  setup$2(
    tab2,
    () => batch$2(tab2, ["selectedId"], (state, prev) => {
      if (!syncActiveId) {
        syncActiveId = true;
        return;
      }
      if (parentComposite && state.selectedId === prev.selectedId) return;
      tab2.setState("activeId", state.selectedId);
    })
  );
  setup$2(
    tab2,
    () => sync$2(tab2, ["selectedId", "renderedItems"], (state) => {
      if (state.selectedId !== void 0) return;
      const { activeId, renderedItems } = tab2.getState();
      const tabItem = composite.item(activeId);
      if (tabItem && !tabItem.disabled && !tabItem.dimmed) {
        tab2.setState("selectedId", tabItem.id);
      } else {
        const tabItem2 = renderedItems.find(
          (item) => !item.disabled && !item.dimmed
        );
        tab2.setState("selectedId", tabItem2 == null ? void 0 : tabItem2.id);
      }
    })
  );
  setup$2(
    tab2,
    () => sync$2(tab2, ["renderedItems"], (state) => {
      const tabs = state.renderedItems;
      if (!tabs.length) return;
      return sync$2(panels, ["renderedItems"], (state2) => {
        const items = state2.renderedItems;
        const hasOrphanPanels = items.some((panel) => !panel.tabId);
        if (!hasOrphanPanels) return;
        items.forEach((panel, i2) => {
          if (panel.tabId) return;
          const tabItem = tabs[i2];
          if (!tabItem) return;
          panels.renderItem({ ...panel, tabId: tabItem.id });
        });
      });
    })
  );
  let selectedIdFromSelectedValue = null;
  setup$2(tab2, () => {
    const backupSelectedId = () => {
      selectedIdFromSelectedValue = tab2.getState().selectedId;
    };
    const restoreSelectedId = () => {
      syncActiveId = false;
      tab2.setState("selectedId", selectedIdFromSelectedValue);
    };
    if (parentComposite && "setSelectElement" in parentComposite) {
      return chain$1$1(
        sync$2(parentComposite, ["value"], backupSelectedId),
        sync$2(parentComposite, ["mounted"], restoreSelectedId)
      );
    }
    if (!combobox) return;
    return chain$1$1(
      sync$2(combobox, ["selectedValue"], backupSelectedId),
      sync$2(combobox, ["mounted"], restoreSelectedId)
    );
  });
  return {
    ...composite,
    ...tab2,
    panels,
    setSelectedId: (id2) => tab2.setState("selectedId", id2),
    select: (id2) => {
      tab2.setState("selectedId", id2);
      composite.move(id2);
    }
  };
}
function useTabStoreProps$1(store2, update, props2) {
  useUpdateEffect$2(update, [props2.composite, props2.combobox]);
  store2 = useCompositeStoreProps$2(store2, update, props2);
  useStoreProps$2(store2, props2, "selectedId", "setSelectedId");
  useStoreProps$2(store2, props2, "selectOnMove");
  const [panels, updatePanels] = useStore$2(() => store2.panels, {});
  useUpdateEffect$2(updatePanels, [store2, updatePanels]);
  return Object.assign(
    useMemo(() => ({ ...store2, panels }), [store2, panels]),
    { composite: props2.composite, combobox: props2.combobox }
  );
}
function useTabStore$1(props2 = {}) {
  const combobox = useComboboxContext$1();
  const composite = useSelectContext$1() || combobox;
  props2 = {
    ...props2,
    composite: props2.composite !== void 0 ? props2.composite : composite,
    combobox: props2.combobox !== void 0 ? props2.combobox : combobox
  };
  const [store2, update] = useStore$2(createTabStore$1, props2);
  return useTabStoreProps$1(store2, update, props2);
}
function TabProvider$1(props2 = {}) {
  const store2 = useTabStore$1(props2);
  return /* @__PURE__ */ jsxRuntimeExports$2.jsx(TabContextProvider$1, { value: store2, children: props2.children });
}
function ManagedKeyboard({ onClick }) {
  const [style, setStyle] = React__default.useState("numeric");
  const store2 = useTabStore$1();
  const storeState = store2.useState();
  React__default.useEffect(() => {
    if (!storeState.activeId) {
      return;
    }
    if (style !== storeState.activeId) {
      if (["alpha_lower", "alpha_upper"].includes(storeState.activeId) && ["alpha_lower", "alpha_upper"].includes(style)) {
        return;
      }
      if (["greek_lower", "greek_upper"].includes(storeState.activeId) && ["greek_lower", "greek_upper"].includes(style)) {
        return;
      }
      setStyle(storeState.activeId);
    }
  }, [storeState, style]);
  const wrappedOnClick = React__default.useCallback(
    (e2) => {
      const firstPress = e2[0];
      if (!firstPress) {
        return;
      }
      if (firstPress.type === "cmd" && firstPress.command === "Shift") {
        switch (style) {
          case "alpha_lower":
            setStyle("alpha_upper");
            break;
          case "alpha_upper":
            setStyle("alpha_lower");
            break;
          case "greek_lower":
            setStyle("greek_upper");
            break;
          case "greek_upper":
            setStyle("greek_lower");
            break;
        }
        return;
      }
      onClick(e2);
    },
    [style]
  );
  return /* @__PURE__ */ React__default.createElement(TabProvider$1, null, /* @__PURE__ */ React__default.createElement(TabList$1, { className: "virtual-keyboard-tab-list" }, /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "numeric" }, "123"), /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "function" }, "f(x)"), /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "alpha_lower" }, "ABC"), /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "greek_lower" }, "αβγ"), /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "symbol" }, "$%∞")), /* @__PURE__ */ React__default.createElement(Keyboard, { style, onClick: wrappedOnClick }));
}
var classnames$1 = { exports: {} };
var hasRequiredClassnames$1;
function requireClassnames$1() {
  if (hasRequiredClassnames$1) return classnames$1.exports;
  hasRequiredClassnames$1 = 1;
  (function(module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i2 = 0; i2 < arguments.length; i2++) {
          var arg = arguments[i2];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else {
        window.classNames = classNames2;
      }
    })();
  })(classnames$1);
  return classnames$1.exports;
}
var classnamesExports$1 = requireClassnames$1();
const classNames$1 = /* @__PURE__ */ getDefaultExportFromCjs$1$1(classnamesExports$1);
const KeyboardIcon = () => /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 576 512",
    "aria-hidden": "true",
    focusable: "false",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React__default.createElement("path", { d: "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z" })
);
function KeyboardTray({ onClick }) {
  const [open, setOpen] = React__default.useState(false);
  return createPortal(
    /* @__PURE__ */ React__default.createElement(
      "div",
      {
        id: "virtual-keyboard-tray",
        className: classNames$1({ open }),
        onMouseDown: () => {
          onClick([
            { type: "accessed", command: "", timestamp: +/* @__PURE__ */ new Date() }
          ]);
        },
        onClick: () => {
          onClick([
            { type: "accessed", command: "", timestamp: +/* @__PURE__ */ new Date() }
          ]);
        }
      },
      /* @__PURE__ */ React__default.createElement(
        "button",
        {
          className: "open-keyboard-button",
          onClick: () => setOpen((old) => !old),
          title: open ? "Close Keyboard" : "Open Keyboard",
          "aria-label": open ? "Close Keyboard" : "Open Keyboard"
        },
        /* @__PURE__ */ React__default.createElement(KeyboardIcon, null)
      ),
      /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-container" }, /* @__PURE__ */ React__default.createElement(
        "button",
        {
          className: "close-keyboard-button",
          onClick: () => setOpen(false),
          title: "Close Keyboard",
          "aria-label": "Close Keyboard"
        },
        "×"
      ), /* @__PURE__ */ React__default.createElement(ManagedKeyboard, { onClick }))
    ),
    document.body
  );
}
const get_tree = function(e2) {
  if (null != e2) return void 0 !== e2.tree ? e2.tree : e2;
};
function* subsets(e2, t2) {
  var r = e2.length;
  if (void 0 === t2 && (t2 = r), 0 !== t2) {
    for (let t22 = 0; t22 < r; t22++) yield [e2[t22]];
    if (1 !== t2) for (let n = 0; n < r; n++) {
      let r2 = subsets(e2.slice(n + 1), t2 - 1);
      for (let t22 of r2) yield [e2[n]].concat(t22);
    }
  }
}
var is_associative$1 = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$5(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if (n = n.map((function(e3, t22) {
    return flatten$5(e3);
  })), is_associative$1[r]) {
    for (var i2 = [], a = 0; a < n.length; a++) Array.isArray(n[a]) && n[a][0] === r && n[a].length > 2 ? i2 = i2.concat(n[a].slice(1)) : i2.push(n[a]);
    n = i2;
  }
  return [r].concat(n);
}
const unflattenRight = function(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ((n = n.map((function(e3, t22) {
    return unflattenRight(e3);
  }))).length > 2 && is_associative$1[r]) {
    for (var i2 = [r, n[0], void 0], a = i2, o = 1; o < n.length - 1; o++) a[2] = [r, n[o], void 0], a = a[2];
    return a[2] = n[n.length - 1], i2;
  }
  return [r].concat(n);
}, unflattenLeft = function(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ((n = n.map((function(e3, t22) {
    return unflattenLeft(e3);
  }))).length > 2 && is_associative$1[r]) {
    for (var i2 = [r, void 0, n[n.length - 1]], a = i2, o = n.length - 2; o > 0; o--) a[1] = [r, void 0, n[o]], a = a[1];
    return a[1] = n[0], i2;
  }
  return [r].concat(n);
}, allChildren = function(e2) {
  if (!Array.isArray(e2)) return [];
  var t2 = e2[0], r = e2.slice(1);
  return is_associative$1[t2] ? r.reduce((function(e3, r2) {
    return Array.isArray(r2) && r2[0] === t2 ? e3.concat(allChildren(r2)) : e3.concat([r2]);
  }), []) : r;
};
function get_all_units() {
  return { "%": { scale: (e2) => ["/", e2, 100], only_scales: true }, $: { prefix: true, scale: (e2) => e2 }, deg: { scale: (e2) => ["/", ["*", e2, "pi"], 180], only_scales: true } };
}
let all_units$1 = get_all_units();
function get_unit_of_tree(e2) {
  if ("unit" === e2[0]) {
    for (let t2 in all_units$1) if (all_units$1[t2].prefix) {
      if (e2[1] === t2) return t2;
    } else if (e2[2] === t2) return t2;
  }
  return null;
}
function get_unit_value_of_tree(e2) {
  if ("unit" === e2[0]) {
    for (let t2 in all_units$1) if (all_units$1[t2].prefix) {
      if (e2[1] === t2) return [t2, e2[2]];
    } else if (e2[2] === t2) return [t2, e2[1]];
  }
  return null;
}
function remove_duplicate_negatives(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  return "-" === t2 && Array.isArray(r[0]) && "-" === r[0][0] ? remove_duplicate_negatives(r[0][1]) : (r = r.map(remove_duplicate_negatives), [t2].concat(r));
}
function normalize_negatives_in_factors(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if (r = r.map(normalize_negatives_in_factors), "*" !== t2 && "/" !== t2) return [t2].concat(r);
  for (var n = 1, i2 = [], a = 0; a < r.length; a++) Array.isArray(r[a]) && "-" === r[a][0] ? (n *= -1, i2.push(r[a][1])) : i2.push(r[a]);
  var o = [t2].concat(i2);
  return -1 === n && (o = ["-", o]), o;
}
function normalize_negatives(e2) {
  var t2 = get_tree(e2);
  return t2 = remove_duplicate_negatives(t2), t2 = remove_duplicate_negatives(t2 = normalize_negatives_in_factors(t2));
}
function sort_key(e2, t2 = {}) {
  if ("number" == typeof e2) return t2.ignore_negatives ? [0, "number", Math.abs(e2)] : [0, "number", e2];
  if ("string" == typeof e2) return "-" === e2 || "+" === e2 ? [8, "plus_minus_string", e2] : [1, "symbol", e2];
  if ("boolean" == typeof e2) return [1, "boolean", e2];
  if (!Array.isArray(e2)) return [-1, "unknown", e2];
  var r = e2[0], n = e2.slice(1);
  if ("apply" === r) {
    var i2 = [2, "function", n[0]], a = n[1], o = 1, s = [];
    return Array.isArray(a) ? (o = (a = a.slice(1)).length, s = a.map(((e3) => sort_key(e3, t2)))) : s = [sort_key(a, t2)], i2.push([o, s]), i2;
  }
  if ("unit" === r) {
    let [r2, n3] = get_unit_value_of_tree(e2);
    if (r2) {
      let e3 = sort_key(n3, t2);
      return e3[1] += "_" + r2, e3;
    }
  }
  var u = n.length, c2 = n.map(sort_key, t2);
  return "*" === r ? [4, "product", u, c2] : "/" === r ? [4, "quotient", u, c2] : "+" === r ? [5, "sum", u, c2] : "-" === r ? t2.ignore_negatives ? c2[0] : [6, "minus", u, c2] : ["tuple", "vector", "altvector"].includes(r) ? [7, u, c2] : "interval" === r ? false === n[1][1] ? false === n[1][2] ? [7, ...c2[0].slice(1)] : [8, u, c2] : false === n[1][2] ? [8, u, c2] : [9, ...c2[0].slice(1)] : "array" === r ? [9, u, c2] : [10, r, u, c2];
}
function arrayCompare(e2, t2) {
  if (Array.isArray(e2)) {
    if (Array.isArray(t2)) {
      let r = Math.min(e2.length, t2.length);
      for (let n = 0; n < r; n++) {
        let r2 = arrayCompare(e2[n], t2[n]);
        if (0 !== r2) return r2;
      }
      return e2.length < t2.length ? -1 : e2.length > t2.length ? 1 : 0;
    }
    return 1;
  }
  return Array.isArray(t2) || e2 < t2 ? -1 : e2 > t2 ? 1 : 0;
}
function compare_function(e2, t2, r = {}) {
  return arrayCompare(sort_key(e2, r), sort_key(t2, r));
}
function coeff_factors_from_term(e2, t2) {
  if ("string" == typeof e2) {
    let r = t2.indexOf(e2);
    -1 === r && (t2.push(e2), r = t2.length - 1);
    let n = [];
    return n[r] = 1, { factor_contains: n, coeff: 1 };
  }
  if (Array.isArray(e2)) {
    let r = e2[0], n = e2.slice(1);
    if ("*" === r) {
      let e3 = [], r2 = [];
      for (let i2 of n) if ("string" != typeof i2) if (!Array.isArray(i2) || "^" !== i2[0] && "-" !== i2[0]) e3.push(i2);
      else {
        let n3 = coeff_factors_from_term(i2, t2);
        for (let e4 in n3.factor_contains) void 0 === r2[e4] && (r2[e4] = 0), r2[e4] += n3.factor_contains[e4];
        1 !== n3.coeff && e3.push(n3.coeff);
      }
      else {
        let e4 = t2.indexOf(i2);
        -1 === e4 && (t2.push(i2), e4 = t2.length - 1), void 0 === r2[e4] && (r2[e4] = 0), r2[e4]++;
      }
      return e3 = 0 === e3.length ? 1 : 1 === e3.length ? e3[0] : ["*", ...e3], { factor_contains: r2, coeff: e3 };
    }
    if ("^" === r) {
      let e3 = n[0], r2 = n[1], i2 = [];
      if ("string" == typeof e3 && Number.isFinite(r2)) {
        let n3 = t2.indexOf(e3);
        return -1 === n3 && (t2.push(e3), n3 = t2.length - 1), i2[n3] = r2, { factor_contains: i2, coeff: 1 };
      }
    } else {
      if ("-" === r) {
        let e3 = coeff_factors_from_term(n[0], t2), r2 = -1;
        return "number" == typeof e3.coeff ? r2 *= e3.coeff : r2 = ["-", e3.coeff], { factor_contains: e3.factor_contains, coeff: r2 };
      }
      if ("/" === r) {
        let e3 = coeff_factors_from_term(n[0], t2), r2 = ["/", e3.coeff, n[1]];
        return { factor_contains: e3.factor_contains, coeff: r2 };
      }
    }
  }
  return { factor_contains: [], coeff: e2 };
}
function default_order(e2, t2) {
  void 0 === t2 && (t2 = {});
  var r = get_tree(e2);
  return r = normalize_negatives(r = flatten$5(r)), normalize_negatives((function e3(r2) {
    if (!Array.isArray(r2)) return r2;
    var n = r2[0], i2 = r2.slice(1);
    if (i2 = i2.map(e3), "+" === n) {
      let e4 = [], r3 = [], n3 = [];
      for (let t22 of i2) {
        let i22 = coeff_factors_from_term(t22, e4);
        r3.push(i22.factor_contains), n3.push(i22.coeff);
      }
      let a2 = [];
      for (let [t22, n4] of e4.entries()) {
        let e5 = { varname: n4, exponents_in_term: [] };
        for (let n5 = 0; n5 < r3.length; n5++) e5.exponents_in_term.push(r3[n5][t22] || 0);
        a2.push(e5);
      }
      a2.sort(((e5, t22) => e5.varname < t22.varname ? -1 : 1));
      let o2 = [];
      for (let e5 = 0; e5 < n3.length; e5++) {
        let r4 = a2.reduce(((t22, r5) => [...t22, -r5.exponents_in_term[e5]]), []);
        r4.push(sort_key(n3[e5], t2)), o2.push(r4);
      }
      let s = [];
      for (let [e5, t22] of i2.entries()) s.push({ term: t22, sort_key: o2[e5] });
      s.sort(((e5, t22) => arrayCompare(e5.sort_key, t22.sort_key))), i2 = s.map(((e5) => e5.term));
    } else if ("*" === n) {
      let e4 = [], r3 = [];
      for (let t22 of i2) ["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(t22[0]) ? r3.push(t22) : e4.push(t22);
      e4.sort(((e5, r4) => compare_function(e5, r4, t2))), i2 = [...e4, ...r3];
    } else if ("=" === n || "and" === n || "or" === n || "ne" === n || "union" === n || "intersect" === n) i2.sort(((e4, r3) => compare_function(e4, r3, t2)));
    else if (">" === n || "ge" === n) i2 = i2.reverse(), n = ">" === n ? "<" : "le";
    else if ("gts" === n) {
      var a = i2[0], o = i2[1];
      if ("tuple" !== a[0] || "tuple" !== o[0]) throw new Error("Badly formed ast");
      n = "lts", i2 = [a = ["tuple"].concat(a.slice(1).reverse()), o = ["tuple"].concat(o.slice(1).reverse())];
    } else if ("ni" === n || "notni" === n || "superset" === n || "notsuperset" === n || "superseteq" === n || "notsuperseteq" === n) i2 = i2.reverse(), "ni" === n ? n = "in" : "notni" === n ? n = "notin" : "superset" === n ? n = "subset" : "notsuperset" === n ? n = "notsubset" : "superseteq" === n ? n = "subseteq" : "notsuperseteq" === n && (n = "notsubseteq");
    else if ("-" === n && "*" === i2[0][0]) return i2[0][1] = ["-", i2[0][1]], i2[0];
    return [n].concat(i2);
  })(r));
}
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var r = arguments[t2];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e2[n] = r[n]);
    }
    return e2;
  }, _extends$2.apply(null, arguments);
}
var DEFAULT_CONFIG = { relTol: 1e-12, absTol: 1e-15, matrix: "Matrix", number: "number", numberFallback: "number", precision: 64, predictable: false, randomSeed: null, legacySubset: false };
function getSafeProperty(e2, t2) {
  if (isSafeProperty(e2, t2)) return e2[t2];
  if ("function" == typeof e2[t2] && isSafeMethod(e2, t2)) throw new Error('Cannot access method "' + t2 + '" as a property');
  throw new Error('No access to property "' + t2 + '"');
}
function setSafeProperty(e2, t2, r) {
  if (isSafeProperty(e2, t2)) return e2[t2] = r, r;
  throw new Error('No access to property "' + t2 + '"');
}
function isSafeProperty(e2, t2) {
  return !(!isPlainObject$1(e2) && !Array.isArray(e2)) && (!!hasOwnProperty$1$1(safeNativeProperties, t2) || !(t2 in Object.prototype) && !(t2 in Function.prototype));
}
function getSafeMethod(e2, t2) {
  if (!isSafeMethod(e2, t2)) throw new Error('No access to method "' + t2 + '"');
  return e2[t2];
}
function isSafeMethod(e2, t2) {
  return null != e2 && "function" == typeof e2[t2] && (!(hasOwnProperty$1$1(e2, t2) && Object.getPrototypeOf && t2 in Object.getPrototypeOf(e2)) && (!!hasOwnProperty$1$1(safeNativeMethods, t2) || !(t2 in Object.prototype) && !(t2 in Function.prototype)));
}
function isPlainObject$1(e2) {
  return "object" == typeof e2 && e2 && e2.constructor === Object;
}
var safeNativeProperties = { length: true, name: true }, safeNativeMethods = { toString: true, valueOf: true, toLocaleString: true };
class ObjectWrappingMap {
  constructor(e2) {
    this.wrappedObject = e2, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter(((e2) => this.has(e2))).values();
  }
  get(e2) {
    return getSafeProperty(this.wrappedObject, e2);
  }
  set(e2, t2) {
    return setSafeProperty(this.wrappedObject, e2, t2), this;
  }
  has(e2) {
    return isSafeProperty(this.wrappedObject, e2) && e2 in this.wrappedObject;
  }
  entries() {
    return mapIterator(this.keys(), ((e2) => [e2, this.get(e2)]));
  }
  forEach(e2) {
    for (var t2 of this.keys()) e2(this.get(t2), t2, this);
  }
  delete(e2) {
    isSafeProperty(this.wrappedObject, e2) && delete this.wrappedObject[e2];
  }
  clear() {
    for (var e2 of this.keys()) this.delete(e2);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}
class PartitionedMap {
  constructor(e2, t2, r) {
    this.a = e2, this.b = t2, this.bKeys = r, this[Symbol.iterator] = this.entries;
  }
  get(e2) {
    return this.bKeys.has(e2) ? this.b.get(e2) : this.a.get(e2);
  }
  set(e2, t2) {
    return this.bKeys.has(e2) ? this.b.set(e2, t2) : this.a.set(e2, t2), this;
  }
  has(e2) {
    return this.b.has(e2) || this.a.has(e2);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return mapIterator(this.keys(), ((e2) => [e2, this.get(e2)]));
  }
  forEach(e2) {
    for (var t2 of this.keys()) e2(this.get(t2), t2, this);
  }
  delete(e2) {
    return this.bKeys.has(e2) ? this.b.delete(e2) : this.a.delete(e2);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
}
function mapIterator(e2, t2) {
  return { next: () => {
    var r = e2.next();
    return r.done ? r : { value: t2(r.value), done: false };
  } };
}
function createEmptyMap() {
  return /* @__PURE__ */ new Map();
}
function createMap$1(e2) {
  if (!e2) return createEmptyMap();
  if (isMap$1(e2)) return e2;
  if (isObject$1(e2)) return new ObjectWrappingMap(e2);
  throw new Error("createMap can create maps from objects or Maps");
}
function toObject(e2) {
  if (e2 instanceof ObjectWrappingMap) return e2.wrappedObject;
  var t2 = {};
  for (var r of e2.keys()) {
    setSafeProperty(t2, r, e2.get(r));
  }
  return t2;
}
function isNumber$1(e2) {
  return "number" == typeof e2;
}
function isBigNumber(e2) {
  return !(!e2 || "object" != typeof e2 || "function" != typeof e2.constructor) && (true === e2.isBigNumber && "object" == typeof e2.constructor.prototype && true === e2.constructor.prototype.isBigNumber || "function" == typeof e2.constructor.isDecimal && true === e2.constructor.isDecimal(e2));
}
function isBigInt(e2) {
  return "bigint" == typeof e2;
}
function isComplex(e2) {
  return e2 && "object" == typeof e2 && true === Object.getPrototypeOf(e2).isComplex || false;
}
function isFraction(e2) {
  return e2 && "object" == typeof e2 && true === Object.getPrototypeOf(e2).isFraction || false;
}
function isUnit(e2) {
  return e2 && true === e2.constructor.prototype.isUnit || false;
}
function isString$1(e2) {
  return "string" == typeof e2;
}
var isArray$1 = Array.isArray;
function isMatrix(e2) {
  return e2 && true === e2.constructor.prototype.isMatrix || false;
}
function isCollection(e2) {
  return Array.isArray(e2) || isMatrix(e2);
}
function isDenseMatrix(e2) {
  return e2 && e2.isDenseMatrix && true === e2.constructor.prototype.isMatrix || false;
}
function isSparseMatrix(e2) {
  return e2 && e2.isSparseMatrix && true === e2.constructor.prototype.isMatrix || false;
}
function isRange(e2) {
  return e2 && true === e2.constructor.prototype.isRange || false;
}
function isIndex(e2) {
  return e2 && true === e2.constructor.prototype.isIndex || false;
}
function isBoolean$1(e2) {
  return "boolean" == typeof e2;
}
function isResultSet(e2) {
  return e2 && true === e2.constructor.prototype.isResultSet || false;
}
function isHelp(e2) {
  return e2 && true === e2.constructor.prototype.isHelp || false;
}
function isFunction$2(e2) {
  return "function" == typeof e2;
}
function isDate$1(e2) {
  return e2 instanceof Date;
}
function isRegExp$1(e2) {
  return e2 instanceof RegExp;
}
function isObject$1(e2) {
  return !(!e2 || "object" != typeof e2 || e2.constructor !== Object || isComplex(e2) || isFraction(e2));
}
function isMap$1(e2) {
  return !!e2 && (e2 instanceof Map || e2 instanceof ObjectWrappingMap || "function" == typeof e2.set && "function" == typeof e2.get && "function" == typeof e2.keys && "function" == typeof e2.has);
}
function isPartitionedMap(e2) {
  return isMap$1(e2) && isMap$1(e2.a) && isMap$1(e2.b);
}
function isObjectWrappingMap(e2) {
  return isMap$1(e2) && isObject$1(e2.wrappedObject);
}
function isNull$1(e2) {
  return null === e2;
}
function isUndefined$1(e2) {
  return void 0 === e2;
}
function isAccessorNode(e2) {
  return e2 && true === e2.isAccessorNode && true === e2.constructor.prototype.isNode || false;
}
function isArrayNode(e2) {
  return e2 && true === e2.isArrayNode && true === e2.constructor.prototype.isNode || false;
}
function isAssignmentNode(e2) {
  return e2 && true === e2.isAssignmentNode && true === e2.constructor.prototype.isNode || false;
}
function isBlockNode(e2) {
  return e2 && true === e2.isBlockNode && true === e2.constructor.prototype.isNode || false;
}
function isConditionalNode(e2) {
  return e2 && true === e2.isConditionalNode && true === e2.constructor.prototype.isNode || false;
}
function isConstantNode(e2) {
  return e2 && true === e2.isConstantNode && true === e2.constructor.prototype.isNode || false;
}
function rule2Node(e2) {
  return isConstantNode(e2) || isOperatorNode(e2) && 1 === e2.args.length && isConstantNode(e2.args[0]) && "-+~".includes(e2.op);
}
function isFunctionAssignmentNode(e2) {
  return e2 && true === e2.isFunctionAssignmentNode && true === e2.constructor.prototype.isNode || false;
}
function isFunctionNode(e2) {
  return e2 && true === e2.isFunctionNode && true === e2.constructor.prototype.isNode || false;
}
function isIndexNode(e2) {
  return e2 && true === e2.isIndexNode && true === e2.constructor.prototype.isNode || false;
}
function isNode$1(e2) {
  return e2 && true === e2.isNode && true === e2.constructor.prototype.isNode || false;
}
function isObjectNode(e2) {
  return e2 && true === e2.isObjectNode && true === e2.constructor.prototype.isNode || false;
}
function isOperatorNode(e2) {
  return e2 && true === e2.isOperatorNode && true === e2.constructor.prototype.isNode || false;
}
function isParenthesisNode(e2) {
  return e2 && true === e2.isParenthesisNode && true === e2.constructor.prototype.isNode || false;
}
function isRangeNode(e2) {
  return e2 && true === e2.isRangeNode && true === e2.constructor.prototype.isNode || false;
}
function isRelationalNode(e2) {
  return e2 && true === e2.isRelationalNode && true === e2.constructor.prototype.isNode || false;
}
function isSymbolNode(e2) {
  return e2 && true === e2.isSymbolNode && true === e2.constructor.prototype.isNode || false;
}
function isChain(e2) {
  return e2 && true === e2.constructor.prototype.isChain || false;
}
function typeOf(e2) {
  var t2 = typeof e2;
  return "object" === t2 ? null === e2 ? "null" : isBigNumber(e2) ? "BigNumber" : e2.constructor && e2.constructor.name ? e2.constructor.name : "Object" : t2;
}
function clone$3(e2) {
  var t2 = typeof e2;
  if ("number" === t2 || "bigint" === t2 || "string" === t2 || "boolean" === t2 || null == e2) return e2;
  if ("function" == typeof e2.clone) return e2.clone();
  if (Array.isArray(e2)) return e2.map((function(e3) {
    return clone$3(e3);
  }));
  if (e2 instanceof Date) return new Date(e2.valueOf());
  if (isBigNumber(e2)) return e2;
  if (isObject$1(e2)) return mapObject$1(e2, clone$3);
  if ("function" === t2) return e2;
  throw new TypeError("Cannot clone: unknown type of value (value: ".concat(e2, ")"));
}
function mapObject$1(e2, t2) {
  var r = {};
  for (var n in e2) hasOwnProperty$1$1(e2, n) && (r[n] = t2(e2[n]));
  return r;
}
function extend$2(e2, t2) {
  for (var r in t2) hasOwnProperty$1$1(t2, r) && (e2[r] = t2[r]);
  return e2;
}
function deepExtend(e2, t2) {
  if (Array.isArray(t2)) throw new TypeError("Arrays are not supported by deepExtend");
  for (var r in t2) if (hasOwnProperty$1$1(t2, r) && !(r in Object.prototype) && !(r in Function.prototype)) if (t2[r] && t2[r].constructor === Object) void 0 === e2[r] && (e2[r] = {}), e2[r] && e2[r].constructor === Object ? deepExtend(e2[r], t2[r]) : e2[r] = t2[r];
  else {
    if (Array.isArray(t2[r])) throw new TypeError("Arrays are not supported by deepExtend");
    e2[r] = t2[r];
  }
  return e2;
}
function deepStrictEqual(e2, t2) {
  var r, n, i2;
  if (Array.isArray(e2)) {
    if (!Array.isArray(t2)) return false;
    if (e2.length !== t2.length) return false;
    for (n = 0, i2 = e2.length; n < i2; n++) if (!deepStrictEqual(e2[n], t2[n])) return false;
    return true;
  }
  if ("function" == typeof e2) return e2 === t2;
  if (e2 instanceof Object) {
    if (Array.isArray(t2) || !(t2 instanceof Object)) return false;
    for (r in e2) if (!(r in t2) || !deepStrictEqual(e2[r], t2[r])) return false;
    for (r in t2) if (!(r in e2)) return false;
    return true;
  }
  return e2 === t2;
}
function deepFlatten(e2) {
  var t2 = {};
  return _deepFlatten(e2, t2), t2;
}
function _deepFlatten(e2, t2) {
  for (var r in e2) if (hasOwnProperty$1$1(e2, r)) {
    var n = e2[r];
    "object" == typeof n && null !== n ? _deepFlatten(n, t2) : t2[r] = n;
  }
}
function lazy(e2, t2, r) {
  var n, i2 = true;
  Object.defineProperty(e2, t2, { get: function() {
    return i2 && (n = r(), i2 = false), n;
  }, set: function(e3) {
    n = e3, i2 = false;
  }, configurable: true, enumerable: true });
}
function hasOwnProperty$1$1(e2, t2) {
  return e2 && Object.hasOwnProperty.call(e2, t2);
}
function isLegacyFactory(e2) {
  return e2 && "function" == typeof e2.factory;
}
function pickShallow(e2, t2) {
  for (var r = {}, n = 0; n < t2.length; n++) {
    var i2 = t2[n], a = e2[i2];
    void 0 !== a && (r[i2] = a);
  }
  return r;
}
var MATRIX_OPTIONS = ["Matrix", "Array"], NUMBER_OPTIONS = ["number", "BigNumber", "bigint", "Fraction"];
function configFactory(e2, t2) {
  function r(n) {
    if (n) {
      if (void 0 !== n.epsilon) {
        console.warn('Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.');
        var i2 = clone$3(n);
        return i2.relTol = n.epsilon, i2.absTol = 1e-3 * n.epsilon, delete i2.epsilon, r(i2);
      }
      true === n.legacySubset && console.warn('Warning: The configuration option "legacySubset" is for compatibility only and might be deprecated in the future.');
      var a = clone$3(e2);
      validateOption(n, "matrix", MATRIX_OPTIONS), validateOption(n, "number", NUMBER_OPTIONS), deepExtend(e2, n);
      var o = clone$3(e2), s = clone$3(n);
      return t2("config", o, a, s), o;
    }
    return clone$3(e2);
  }
  return r.MATRIX_OPTIONS = MATRIX_OPTIONS, r.NUMBER_OPTIONS = NUMBER_OPTIONS, Object.keys(DEFAULT_CONFIG).forEach(((t22) => {
    Object.defineProperty(r, t22, { get: () => e2[t22], enumerable: true, configurable: true });
  })), r;
}
function validateOption(e2, t2, r) {
  void 0 === e2[t2] || r.includes(e2[t2]) || console.warn('Warning: Unknown value "' + e2[t2] + '" for configuration option "' + t2 + '". Available options: ' + r.map(((e3) => JSON.stringify(e3))).join(", ") + ".");
}
var commonjsGlobal$1 = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function getDefaultExportFromCjs$2(e2) {
  return e2 && e2.__esModule && Object.prototype.hasOwnProperty.call(e2, "default") ? e2.default : e2;
}
function getAugmentedNamespace$1(e2) {
  if (e2.__esModule) return e2;
  var t2 = e2.default;
  if ("function" == typeof t2) {
    var r = function e3() {
      return this instanceof e3 ? Reflect.construct(t2, arguments, this.constructor) : t2.apply(this, arguments);
    };
    r.prototype = t2.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: true }), Object.keys(e2).forEach((function(t22) {
    var n = Object.getOwnPropertyDescriptor(e2, t22);
    Object.defineProperty(r, t22, n.get ? n : { enumerable: true, get: function() {
      return e2[t22];
    } });
  })), r;
}
var typedFunction$2 = { exports: {} };
typedFunction$2.exports;
var hasRequiredTypedFunction;
function requireTypedFunction() {
  return hasRequiredTypedFunction || (hasRequiredTypedFunction = 1, e2 = typedFunction$2, typedFunction$2.exports, e2.exports = (function() {
    function e3() {
      return true;
    }
    function t2() {
      return false;
    }
    function r() {
    }
    const n = "Argument is not a typed-function.";
    function i2() {
      function a2(e4) {
        return "object" == typeof e4 && null !== e4 && e4.constructor === Object;
      }
      const o = [{ name: "number", test: function(e4) {
        return "number" == typeof e4;
      } }, { name: "string", test: function(e4) {
        return "string" == typeof e4;
      } }, { name: "boolean", test: function(e4) {
        return "boolean" == typeof e4;
      } }, { name: "Function", test: function(e4) {
        return "function" == typeof e4;
      } }, { name: "Array", test: Array.isArray }, { name: "Date", test: function(e4) {
        return e4 instanceof Date;
      } }, { name: "RegExp", test: function(e4) {
        return e4 instanceof RegExp;
      } }, { name: "Object", test: a2 }, { name: "null", test: function(e4) {
        return null === e4;
      } }, { name: "undefined", test: function(e4) {
        return void 0 === e4;
      } }], s = { name: "any", test: e3, isAny: true };
      let u, c2, l = 0, f2 = { createCount: 0 };
      function p(e4) {
        const t22 = u.get(e4);
        if (t22) return t22;
        let r2 = 'Unknown type "' + e4 + '"';
        const n3 = e4.toLowerCase();
        let i22;
        for (i22 of c2) if (i22.toLowerCase() === n3) {
          r2 += '. Did you mean "' + i22 + '" ?';
          break;
        }
        throw new TypeError(r2);
      }
      function m(e4) {
        let t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "any";
        const r2 = t22 ? p(t22).index : c2.length, n3 = [];
        for (let t3 = 0; t3 < e4.length; ++t3) {
          if (!e4[t3] || "string" != typeof e4[t3].name || "function" != typeof e4[t3].test) throw new TypeError("Object with properties {name: string, test: function} expected");
          const i3 = e4[t3].name;
          if (u.has(i3)) throw new TypeError('Duplicate type name "' + i3 + '"');
          n3.push(i3), u.set(i3, { name: i3, test: e4[t3].test, isAny: e4[t3].isAny, index: r2 + t3, conversionsTo: [] });
        }
        const i22 = c2.slice(r2);
        c2 = c2.slice(0, r2).concat(n3).concat(i22);
        for (let e5 = r2 + n3.length; e5 < c2.length; ++e5) u.get(c2[e5]).index = e5;
      }
      function d() {
        u = /* @__PURE__ */ new Map(), c2 = [], l = 0, m([s], false);
      }
      function h() {
        let e4;
        for (e4 of c2) u.get(e4).conversionsTo = [];
        l = 0;
      }
      function g(e4) {
        const t22 = c2.filter(((t3) => {
          const r2 = u.get(t3);
          return !r2.isAny && r2.test(e4);
        }));
        return t22.length ? t22 : ["any"];
      }
      function y(e4) {
        return e4 && "function" == typeof e4 && "_typedFunctionData" in e4;
      }
      function v2(e4, t22, r2) {
        if (!y(e4)) throw new TypeError(n);
        const i22 = r2 && r2.exact, a3 = D(Array.isArray(t22) ? t22.join(",") : t22), o2 = _2(a3);
        if (!i22 || o2 in e4.signatures) {
          const t3 = e4._typedFunctionData.signatureMap.get(o2);
          if (t3) return t3;
        }
        const s2 = a3.length;
        let u2, c3;
        if (i22) {
          let t3;
          for (t3 in u2 = [], e4.signatures) u2.push(e4._typedFunctionData.signatureMap.get(t3));
        } else u2 = e4._typedFunctionData.signatures;
        for (let e5 = 0; e5 < s2; ++e5) {
          const t3 = a3[e5], r3 = [];
          let n3;
          for (n3 of u2) {
            const i3 = C2(n3.params, e5);
            if (i3 && (!t3.restParam || i3.restParam)) {
              if (!i3.hasAny) {
                const e6 = N(i3);
                if (t3.types.some(((t4) => !e6.has(t4.name)))) continue;
              }
              r3.push(n3);
            }
          }
          if (u2 = r3, 0 === u2.length) break;
        }
        for (c3 of u2) if (c3.params.length <= s2) return c3;
        throw new TypeError("Signature not found (signature: " + (e4.name || "unnamed") + "(" + _2(a3, ", ") + "))");
      }
      function x2(e4, t22, r2) {
        return v2(e4, t22, r2).implementation;
      }
      function b2(e4, t22) {
        const r2 = p(t22);
        if (r2.test(e4)) return e4;
        const n3 = r2.conversionsTo;
        if (0 === n3.length) throw new Error("There are no conversions to " + t22 + " defined.");
        for (let t3 = 0; t3 < n3.length; t3++) if (p(n3[t3].from).test(e4)) return n3[t3].convert(e4);
        throw new Error("Cannot convert " + e4 + " to " + t22);
      }
      function _2(e4) {
        let t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",";
        return e4.map(((e5) => e5.name)).join(t22);
      }
      function w2(e4) {
        const t22 = 0 === e4.indexOf("..."), r2 = (t22 ? e4.length > 3 ? e4.slice(3) : "any" : e4).split("|").map(((e5) => p(e5.trim())));
        let n3 = false, i22 = t22 ? "..." : "";
        return { types: r2.map((function(e5) {
          return n3 = e5.isAny || n3, i22 += e5.name + "|", { name: e5.name, typeIndex: e5.index, test: e5.test, isAny: e5.isAny, conversion: null, conversionIndex: -1 };
        })), name: i22.slice(0, -1), hasAny: n3, hasConversion: false, restParam: t22 };
      }
      function A2(e4) {
        const t22 = q2(e4.types.map(((e5) => e5.name)));
        let r2 = e4.hasAny, n3 = e4.name;
        const i22 = t22.map((function(e5) {
          const t3 = p(e5.from);
          return r2 = t3.isAny || r2, n3 += "|" + e5.from, { name: e5.from, typeIndex: t3.index, test: t3.test, isAny: t3.isAny, conversion: e5, conversionIndex: e5.index };
        }));
        return { types: e4.types.concat(i22), name: n3, hasAny: r2, hasConversion: i22.length > 0, restParam: e4.restParam };
      }
      function N(e4) {
        return e4.typeSet || (e4.typeSet = /* @__PURE__ */ new Set(), e4.types.forEach(((t22) => e4.typeSet.add(t22.name)))), e4.typeSet;
      }
      function D(e4) {
        const t22 = [];
        if ("string" != typeof e4) throw new TypeError("Signatures must be strings");
        const r2 = e4.trim();
        if ("" === r2) return t22;
        const n3 = r2.split(",");
        for (let e5 = 0; e5 < n3.length; ++e5) {
          const r3 = w2(n3[e5].trim());
          if (r3.restParam && e5 !== n3.length - 1) throw new SyntaxError('Unexpected rest parameter "' + n3[e5] + '": only allowed for the last parameter');
          if (0 === r3.types.length) return null;
          t22.push(r3);
        }
        return t22;
      }
      function E(e4) {
        const t22 = Q2(e4);
        return !!t22 && t22.restParam;
      }
      function $2(t22) {
        if (t22 && 0 !== t22.types.length) {
          if (1 === t22.types.length) return p(t22.types[0].name).test;
          if (2 === t22.types.length) {
            const e4 = p(t22.types[0].name).test, r2 = p(t22.types[1].name).test;
            return function(t3) {
              return e4(t3) || r2(t3);
            };
          }
          {
            const e4 = t22.types.map((function(e5) {
              return p(e5.name).test;
            }));
            return function(t3) {
              for (let r2 = 0; r2 < e4.length; r2++) if (e4[r2](t3)) return true;
              return false;
            };
          }
        }
        return e3;
      }
      function S2(e4) {
        let t22, r2, n3;
        if (E(e4)) {
          t22 = W2(e4).map($2);
          const r3 = t22.length, n4 = $2(Q2(e4)), i22 = function(e5) {
            for (let t3 = r3; t3 < e5.length; t3++) if (!n4(e5[t3])) return false;
            return true;
          };
          return function(e5) {
            for (let r4 = 0; r4 < t22.length; r4++) if (!t22[r4](e5[r4])) return false;
            return i22(e5) && e5.length >= r3 + 1;
          };
        }
        return 0 === e4.length ? function(e5) {
          return 0 === e5.length;
        } : 1 === e4.length ? (r2 = $2(e4[0]), function(e5) {
          return r2(e5[0]) && 1 === e5.length;
        }) : 2 === e4.length ? (r2 = $2(e4[0]), n3 = $2(e4[1]), function(e5) {
          return r2(e5[0]) && n3(e5[1]) && 2 === e5.length;
        }) : (t22 = e4.map($2), function(e5) {
          for (let r3 = 0; r3 < t22.length; r3++) if (!t22[r3](e5[r3])) return false;
          return e5.length === t22.length;
        });
      }
      function C2(e4, t22) {
        return t22 < e4.length ? e4[t22] : E(e4) ? Q2(e4) : null;
      }
      function M2(e4, t22) {
        const r2 = C2(e4, t22);
        return r2 ? N(r2) : /* @__PURE__ */ new Set();
      }
      function T2(e4) {
        return null === e4.conversion || void 0 === e4.conversion;
      }
      function F(e4, t22) {
        const r2 = /* @__PURE__ */ new Set();
        return e4.forEach(((e5) => {
          const n3 = M2(e5.params, t22);
          let i22;
          for (i22 of n3) r2.add(i22);
        })), r2.has("any") ? ["any"] : Array.from(r2);
      }
      function O2(e4, t22, r2) {
        let n3, i22;
        const a3 = e4 || "unnamed";
        let o2, s2 = r2;
        for (o2 = 0; o2 < t22.length; o2++) {
          const e5 = [];
          if (s2.forEach(((r3) => {
            const n4 = $2(C2(r3.params, o2));
            (o2 < r3.params.length || E(r3.params)) && n4(t22[o2]) && e5.push(r3);
          })), 0 === e5.length) {
            if (i22 = F(s2, o2), i22.length > 0) {
              const e6 = g(t22[o2]);
              return n3 = new TypeError("Unexpected type of argument in function " + a3 + " (expected: " + i22.join(" or ") + ", actual: " + e6.join(" | ") + ", index: " + o2 + ")"), n3.data = { category: "wrongType", fn: a3, index: o2, actual: e6, expected: i22 }, n3;
            }
          } else s2 = e5;
        }
        const u2 = s2.map((function(e5) {
          return E(e5.params) ? 1 / 0 : e5.params.length;
        }));
        if (t22.length < Math.min.apply(null, u2)) return i22 = F(s2, o2), n3 = new TypeError("Too few arguments in function " + a3 + " (expected: " + i22.join(" or ") + ", index: " + t22.length + ")"), n3.data = { category: "tooFewArgs", fn: a3, index: t22.length, expected: i22 }, n3;
        const c3 = Math.max.apply(null, u2);
        if (t22.length > c3) return n3 = new TypeError("Too many arguments in function " + a3 + " (expected: " + c3 + ", actual: " + t22.length + ")"), n3.data = { category: "tooManyArgs", fn: a3, index: t22.length, expectedLength: c3 }, n3;
        const l2 = [];
        for (let e5 = 0; e5 < t22.length; ++e5) l2.push(g(t22[e5]).join("|"));
        return n3 = new TypeError('Arguments of type "' + l2.join(", ") + '" do not match any of the defined signatures of function ' + a3 + "."), n3.data = { category: "mismatch", actual: l2 }, n3;
      }
      function k2(e4) {
        let t22 = c2.length + 1;
        for (let r2 = 0; r2 < e4.types.length; r2++) T2(e4.types[r2]) && (t22 = Math.min(t22, e4.types[r2].typeIndex));
        return t22;
      }
      function B2(e4) {
        let t22 = l + 1;
        for (let r2 = 0; r2 < e4.types.length; r2++) T2(e4.types[r2]) || (t22 = Math.min(t22, e4.types[r2].conversionIndex));
        return t22;
      }
      function I2(e4, t22) {
        if (e4.hasAny) {
          if (!t22.hasAny) return 1;
        } else if (t22.hasAny) return -1;
        if (e4.restParam) {
          if (!t22.restParam) return 1;
        } else if (t22.restParam) return -1;
        if (e4.hasConversion) {
          if (!t22.hasConversion) return 1;
        } else if (t22.hasConversion) return -1;
        const r2 = k2(e4) - k2(t22);
        if (r2 < 0) return -1;
        if (r2 > 0) return 1;
        const n3 = B2(e4) - B2(t22);
        return n3 < 0 ? -1 : n3 > 0 ? 1 : 0;
      }
      function R2(e4, t22) {
        const r2 = e4.params, n3 = t22.params, i22 = Q2(r2), a3 = Q2(n3), o2 = E(r2), s2 = E(n3);
        if (o2 && i22.hasAny) {
          if (!s2 || !a3.hasAny) return 1;
        } else if (s2 && a3.hasAny) return -1;
        let u2, c3 = 0, l2 = 0;
        for (u2 of r2) u2.hasAny && ++c3, u2.hasConversion && ++l2;
        let f3 = 0, p2 = 0;
        for (u2 of n3) u2.hasAny && ++f3, u2.hasConversion && ++p2;
        if (c3 !== f3) return c3 - f3;
        if (o2 && i22.hasConversion) {
          if (!s2 || !a3.hasConversion) return 1;
        } else if (s2 && a3.hasConversion) return -1;
        if (l2 !== p2) return l2 - p2;
        if (o2) {
          if (!s2) return 1;
        } else if (s2) return -1;
        const m2 = (r2.length - n3.length) * (o2 ? -1 : 1);
        if (0 !== m2) return m2;
        const d2 = [];
        let h2, g2 = 0;
        for (let e5 = 0; e5 < r2.length; ++e5) {
          const t3 = I2(r2[e5], n3[e5]);
          d2.push(t3), g2 += t3;
        }
        if (0 !== g2) return g2;
        for (h2 of d2) if (0 !== h2) return h2;
        return 0;
      }
      function q2(e4) {
        if (0 === e4.length) return [];
        const t22 = e4.map(p);
        e4.length > 1 && t22.sort(((e5, t3) => e5.index - t3.index));
        let r2 = t22[0].conversionsTo;
        if (1 === e4.length) return r2;
        r2 = r2.concat([]);
        const n3 = new Set(e4);
        for (let e5 = 1; e5 < t22.length; ++e5) {
          let i22;
          for (i22 of t22[e5].conversionsTo) n3.has(i22.from) || (r2.push(i22), n3.add(i22.from));
        }
        return r2;
      }
      function z2(e4, t22) {
        let r2 = t22;
        if (e4.some(((e5) => e5.hasConversion))) {
          const n4 = E(e4), i22 = e4.map(P2);
          r2 = function() {
            const e5 = [], r3 = n4 ? arguments.length - 1 : arguments.length;
            for (let t3 = 0; t3 < r3; t3++) e5[t3] = i22[t3](arguments[t3]);
            return n4 && (e5[r3] = arguments[r3].map(i22[r3])), t22.apply(this, e5);
          };
        }
        let n3 = r2;
        if (E(e4)) {
          const t3 = e4.length - 1;
          n3 = function() {
            return r2.apply(this, Y2(arguments, 0, t3).concat([Y2(arguments, t3)]));
          };
        }
        return n3;
      }
      function P2(e4) {
        let t22, r2, n3, i22;
        const a3 = [], o2 = [];
        switch (e4.types.forEach((function(e5) {
          e5.conversion && (a3.push(p(e5.conversion.from).test), o2.push(e5.conversion.convert));
        })), o2.length) {
          case 0:
            return function(e5) {
              return e5;
            };
          case 1:
            return t22 = a3[0], n3 = o2[0], function(e5) {
              return t22(e5) ? n3(e5) : e5;
            };
          case 2:
            return t22 = a3[0], r2 = a3[1], n3 = o2[0], i22 = o2[1], function(e5) {
              return t22(e5) ? n3(e5) : r2(e5) ? i22(e5) : e5;
            };
          default:
            return function(e5) {
              for (let t3 = 0; t3 < o2.length; t3++) if (a3[t3](e5)) return o2[t3](e5);
              return e5;
            };
        }
      }
      function L2(e4) {
        function t22(e5, r2, n3) {
          if (r2 < e5.length) {
            const i22 = e5[r2];
            let a3 = [];
            if (i22.restParam) {
              const e6 = i22.types.filter(T2);
              e6.length < i22.types.length && a3.push({ types: e6, name: "..." + e6.map(((e7) => e7.name)).join("|"), hasAny: e6.some(((e7) => e7.isAny)), hasConversion: false, restParam: true }), a3.push(i22);
            } else a3 = i22.types.map((function(e6) {
              return { types: [e6], name: e6.name, hasAny: e6.isAny, hasConversion: e6.conversion, restParam: false };
            }));
            return K2(a3, (function(i3) {
              return t22(e5, r2 + 1, n3.concat([i3]));
            }));
          }
          return [n3];
        }
        return t22(e4, 0, []);
      }
      function j2(e4, t22) {
        const r2 = Math.max(e4.length, t22.length);
        for (let n4 = 0; n4 < r2; n4++) {
          const r3 = M2(e4, n4), i3 = M2(t22, n4);
          let a4, o3 = false;
          for (a4 of i3) if (r3.has(a4)) {
            o3 = true;
            break;
          }
          if (!o3) return false;
        }
        const n3 = e4.length, i22 = t22.length, a3 = E(e4), o2 = E(t22);
        return a3 ? o2 ? n3 === i22 : i22 >= n3 : o2 ? n3 >= i22 : n3 === i22;
      }
      function U2(e4) {
        return e4.map(((e5) => ie2(e5) ? re2(e5.referToSelf.callback) : ne(e5) ? te2(e5.referTo.references, e5.referTo.callback) : e5));
      }
      function Z2(e4, t22, r2) {
        const n3 = [];
        let i22;
        for (i22 of e4) {
          let e5 = r2[i22];
          if ("number" != typeof e5) throw new TypeError('No definition for referenced signature "' + i22 + '"');
          if (e5 = t22[e5], "function" != typeof e5) return false;
          n3.push(e5);
        }
        return n3;
      }
      function G2(e4, t22, r2) {
        const n3 = U2(e4), i22 = new Array(n3.length).fill(false);
        let a3 = true;
        for (; a3; ) {
          a3 = false;
          let e5 = true;
          for (let o2 = 0; o2 < n3.length; ++o2) {
            if (i22[o2]) continue;
            const s2 = n3[o2];
            if (ie2(s2)) n3[o2] = s2.referToSelf.callback(r2), n3[o2].referToSelf = s2.referToSelf, i22[o2] = true, e5 = false;
            else if (ne(s2)) {
              const r3 = Z2(s2.referTo.references, n3, t22);
              r3 ? (n3[o2] = s2.referTo.callback.apply(this, r3), n3[o2].referTo = s2.referTo, i22[o2] = true, e5 = false) : a3 = true;
            }
          }
          if (e5 && a3) throw new SyntaxError("Circular reference detected in resolving typed.referTo");
        }
        return n3;
      }
      function V2(e4) {
        const t22 = /\bthis(\(|\.signatures\b)/;
        Object.keys(e4).forEach(((r2) => {
          const n3 = e4[r2];
          if (t22.test(n3.toString())) throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
        }));
      }
      function H2(e4, n3) {
        if (f2.createCount++, 0 === Object.keys(n3).length) throw new SyntaxError("No signatures provided");
        f2.warnAgainstDeprecatedThis && V2(n3);
        const i22 = [], a3 = [], o2 = {}, s2 = [];
        let u2;
        for (u2 in n3) {
          if (!Object.prototype.hasOwnProperty.call(n3, u2)) continue;
          const e5 = D(u2);
          if (!e5) continue;
          i22.forEach((function(t3) {
            if (j2(t3, e5)) throw new TypeError('Conflicting signatures "' + _2(t3) + '" and "' + _2(e5) + '".');
          })), i22.push(e5);
          const t22 = a3.length;
          a3.push(n3[u2]);
          const r2 = e5.map(A2);
          let c4;
          for (c4 of L2(r2)) {
            const e6 = _2(c4);
            s2.push({ params: c4, name: e6, fn: t22 }), c4.every(((e7) => !e7.hasConversion)) && (o2[e6] = t22);
          }
        }
        s2.sort(R2);
        const c3 = G2(a3, o2, ue22);
        let l2;
        for (l2 in o2) Object.prototype.hasOwnProperty.call(o2, l2) && (o2[l2] = c3[o2[l2]]);
        const p2 = [], m2 = /* @__PURE__ */ new Map();
        for (l2 of s2) m2.has(l2.name) || (l2.fn = c3[l2.fn], p2.push(l2), m2.set(l2.name, l2));
        const d2 = p2[0] && p2[0].params.length <= 2 && !E(p2[0].params), h2 = p2[1] && p2[1].params.length <= 2 && !E(p2[1].params), g2 = p2[2] && p2[2].params.length <= 2 && !E(p2[2].params), y2 = p2[3] && p2[3].params.length <= 2 && !E(p2[3].params), v22 = p2[4] && p2[4].params.length <= 2 && !E(p2[4].params), x22 = p2[5] && p2[5].params.length <= 2 && !E(p2[5].params), b22 = d2 && h2 && g2 && y2 && v22 && x22;
        for (let e5 = 0; e5 < p2.length; ++e5) p2[e5].test = S2(p2[e5].params);
        const w22 = d2 ? $2(p2[0].params[0]) : t2, N2 = h2 ? $2(p2[1].params[0]) : t2, C3 = g2 ? $2(p2[2].params[0]) : t2, M22 = y2 ? $2(p2[3].params[0]) : t2, T3 = v22 ? $2(p2[4].params[0]) : t2, F2 = x22 ? $2(p2[5].params[0]) : t2, O22 = d2 ? $2(p2[0].params[1]) : t2, k3 = h2 ? $2(p2[1].params[1]) : t2, B3 = g2 ? $2(p2[2].params[1]) : t2, I22 = y2 ? $2(p2[3].params[1]) : t2, q22 = v22 ? $2(p2[4].params[1]) : t2, P3 = x22 ? $2(p2[5].params[1]) : t2;
        for (let e5 = 0; e5 < p2.length; ++e5) p2[e5].implementation = z2(p2[e5].params, p2[e5].fn);
        const U22 = d2 ? p2[0].implementation : r, Z22 = h2 ? p2[1].implementation : r, H22 = g2 ? p2[2].implementation : r, X22 = y2 ? p2[3].implementation : r, W22 = v22 ? p2[4].implementation : r, Q3 = x22 ? p2[5].implementation : r, Y22 = d2 ? p2[0].params.length : -1, J2 = h2 ? p2[1].params.length : -1, K22 = g2 ? p2[2].params.length : -1, ee22 = y2 ? p2[3].params.length : -1, te22 = v22 ? p2[4].params.length : -1, re3 = x22 ? p2[5].params.length : -1, ne2 = b22 ? 6 : 0, ie22 = p2.length, ae22 = p2.map(((e5) => e5.test)), oe22 = p2.map(((e5) => e5.implementation)), se22 = function() {
          for (let e5 = ne2; e5 < ie22; e5++) if (ae22[e5](arguments)) return oe22[e5].apply(this, arguments);
          return f2.onMismatch(e4, arguments, p2);
        };
        function ue22(e5, t22) {
          return arguments.length === Y22 && w22(e5) && O22(t22) ? U22.apply(this, arguments) : arguments.length === J2 && N2(e5) && k3(t22) ? Z22.apply(this, arguments) : arguments.length === K22 && C3(e5) && B3(t22) ? H22.apply(this, arguments) : arguments.length === ee22 && M22(e5) && I22(t22) ? X22.apply(this, arguments) : arguments.length === te22 && T3(e5) && q22(t22) ? W22.apply(this, arguments) : arguments.length === re3 && F2(e5) && P3(t22) ? Q3.apply(this, arguments) : se22.apply(this, arguments);
        }
        try {
          Object.defineProperty(ue22, "name", { value: e4 });
        } catch (e5) {
        }
        return ue22.signatures = o2, ue22._typedFunctionData = { signatures: p2, signatureMap: m2 }, ue22;
      }
      function X2(e4, t22, r2) {
        throw O2(e4, t22, r2);
      }
      function W2(e4) {
        return Y2(e4, 0, e4.length - 1);
      }
      function Q2(e4) {
        return e4[e4.length - 1];
      }
      function Y2(e4, t22, r2) {
        return Array.prototype.slice.call(e4, t22, r2);
      }
      function J(e4, t22) {
        for (let r2 = 0; r2 < e4.length; r2++) if (t22(e4[r2])) return e4[r2];
      }
      function K2(e4, t22) {
        return Array.prototype.concat.apply([], e4.map(t22));
      }
      function ee2() {
        const e4 = W2(arguments).map(((e5) => _2(D(e5)))), t22 = Q2(arguments);
        if ("function" != typeof t22) throw new TypeError("Callback function expected as last argument");
        return te2(e4, t22);
      }
      function te2(e4, t22) {
        return { referTo: { references: e4, callback: t22 } };
      }
      function re2(e4) {
        if ("function" != typeof e4) throw new TypeError("Callback function expected as first argument");
        return { referToSelf: { callback: e4 } };
      }
      function ne(e4) {
        return e4 && "object" == typeof e4.referTo && Array.isArray(e4.referTo.references) && "function" == typeof e4.referTo.callback;
      }
      function ie2(e4) {
        return e4 && "object" == typeof e4.referToSelf && "function" == typeof e4.referToSelf.callback;
      }
      function ae2(e4, t22) {
        if (!e4) return t22;
        if (t22 && t22 !== e4) {
          const r2 = new Error("Function names do not match (expected: " + e4 + ", actual: " + t22 + ")");
          throw r2.data = { actual: t22, expected: e4 }, r2;
        }
        return e4;
      }
      function oe2(e4) {
        let t22;
        for (const r2 in e4) Object.prototype.hasOwnProperty.call(e4, r2) && (y(e4[r2]) || "string" == typeof e4[r2].signature) && (t22 = ae2(t22, e4[r2].name));
        return t22;
      }
      function se2(e4, t22) {
        let r2;
        for (r2 in t22) if (Object.prototype.hasOwnProperty.call(t22, r2)) {
          if (r2 in e4 && t22[r2] !== e4[r2]) {
            const n3 = new Error('Signature "' + r2 + '" is defined twice');
            throw n3.data = { signature: r2, sourceFunction: t22[r2], destFunction: e4[r2] }, n3;
          }
          e4[r2] = t22[r2];
        }
      }
      d(), m(o);
      const ue2 = f2;
      function ce2(e4) {
        if (!e4 || "string" != typeof e4.from || "string" != typeof e4.to || "function" != typeof e4.convert) throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
        if (e4.to === e4.from) throw new SyntaxError('Illegal to define conversion from "' + e4.from + '" to itself.');
      }
      return f2 = function(e4) {
        const t22 = "string" == typeof e4;
        let r2 = t22 ? e4 : "";
        const n3 = {};
        for (let e5 = t22 ? 1 : 0; e5 < arguments.length; ++e5) {
          const i22 = arguments[e5];
          let o2, s2 = {};
          if ("function" == typeof i22 ? (o2 = i22.name, "string" == typeof i22.signature ? s2[i22.signature] = i22 : y(i22) && (s2 = i22.signatures)) : a2(i22) && (s2 = i22, t22 || (o2 = oe2(i22))), 0 === Object.keys(s2).length) {
            const t3 = new TypeError("Argument to 'typed' at index " + e5 + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
            throw t3.data = { index: e5, argument: i22 }, t3;
          }
          t22 || (r2 = ae2(r2, o2)), se2(n3, s2);
        }
        return H2(r2 || "", n3);
      }, f2.create = i2, f2.createCount = ue2.createCount, f2.onMismatch = X2, f2.throwMismatchError = X2, f2.createError = O2, f2.clear = d, f2.clearConversions = h, f2.addTypes = m, f2._findType = p, f2.referTo = ee2, f2.referToSelf = re2, f2.convert = b2, f2.findSignature = v2, f2.find = x2, f2.isTypedFunction = y, f2.warnAgainstDeprecatedThis = true, f2.addType = function(e4, t22) {
        let r2 = "any";
        false !== t22 && u.has("Object") && (r2 = "Object"), f2.addTypes([e4], r2);
      }, f2.addConversion = function(e4) {
        let t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { override: false };
        ce2(e4);
        const r2 = p(e4.to), n3 = r2.conversionsTo.find(((t3) => t3.from === e4.from));
        if (n3) {
          if (!t22 || !t22.override) throw new Error('There is already a conversion from "' + e4.from + '" to "' + r2.name + '"');
          f2.removeConversion({ from: n3.from, to: e4.to, convert: n3.convert });
        }
        r2.conversionsTo.push({ from: e4.from, convert: e4.convert, index: l++ });
      }, f2.addConversions = function(e4, t22) {
        e4.forEach(((e5) => f2.addConversion(e5, t22)));
      }, f2.removeConversion = function(e4) {
        ce2(e4);
        const t22 = p(e4.to), r2 = J(t22.conversionsTo, ((t3) => t3.from === e4.from));
        if (!r2) throw new Error("Attempt to remove nonexistent conversion from " + e4.from + " to " + e4.to);
        if (r2.convert !== e4.convert) throw new Error("Conversion to remove does not match existing conversion");
        const n3 = t22.conversionsTo.indexOf(r2);
        t22.conversionsTo.splice(n3, 1);
      }, f2.resolve = function(e4, t22) {
        if (!y(e4)) throw new TypeError(n);
        const r2 = e4._typedFunctionData.signatures;
        for (let e5 = 0; e5 < r2.length; ++e5) if (r2[e5].test(t22)) return r2[e5];
        return null;
      }, f2;
    }
    var a = i2();
    return a;
  })()), typedFunction$2.exports;
  var e2;
}
var typedFunctionExports = requireTypedFunction(), typedFunction = getDefaultExportFromCjs$2(typedFunctionExports);
function factory(e2, t2, r, n) {
  function i2(n3) {
    var i22 = pickShallow(n3, t2.map(stripOptionalNotation));
    return assertDependencies(e2, t2, n3), r(i22);
  }
  return i2.isFactory = true, i2.fn = e2, i2.dependencies = t2.slice().sort(), n && (i2.meta = n), i2;
}
function isFactory(e2) {
  return "function" == typeof e2 && "string" == typeof e2.fn && Array.isArray(e2.dependencies);
}
function assertDependencies(e2, t2, r) {
  if (!t2.filter(((e3) => !isOptionalDependency(e3))).every(((e3) => void 0 !== r[e3]))) {
    var n = t2.filter(((e3) => void 0 === r[e3]));
    throw new Error('Cannot create function "'.concat(e2, '", ') + "some dependencies are missing: ".concat(n.map(((e3) => '"'.concat(e3, '"'))).join(", "), "."));
  }
}
function isOptionalDependency(e2) {
  return e2 && "?" === e2[0];
}
function stripOptionalNotation(e2) {
  return e2 && "?" === e2[0] ? e2.slice(1) : e2;
}
function isInteger(e2) {
  return "boolean" == typeof e2 || !!Number.isFinite(e2) && e2 === Math.round(e2);
}
function safeNumberType(e2, t2) {
  if ("bigint" === t2.number) try {
    BigInt(e2);
  } catch (e3) {
    return t2.numberFallback;
  }
  return t2.number;
}
var sign$2 = Math.sign || function(e2) {
  return e2 > 0 ? 1 : e2 < 0 ? -1 : 0;
}, log2$1 = Math.log2 || function(e2) {
  return Math.log(e2) / Math.LN2;
}, log10$2 = Math.log10 || function(e2) {
  return Math.log(e2) / Math.LN10;
}, log1p = Math.log1p || function(e2) {
  return Math.log(e2 + 1);
}, cbrt$1 = Math.cbrt || function(e2) {
  if (0 === e2) return e2;
  var t2, r = e2 < 0;
  return r && (e2 = -e2), t2 = Number.isFinite(e2) ? (e2 / ((t2 = Math.exp(Math.log(e2) / 3)) * t2) + 2 * t2) / 3 : e2, r ? -t2 : t2;
}, expm1 = Math.expm1 || function(e2) {
  return e2 >= 2e-4 || e2 <= -2e-4 ? Math.exp(e2) - 1 : e2 + e2 * e2 / 2 + e2 * e2 * e2 / 6;
};
function formatNumberToBase(e2, t2, r) {
  var n = { 2: "0b", 8: "0o", 16: "0x" }[t2], i2 = "";
  if (r) {
    if (r < 1) throw new Error("size must be in greater than 0");
    if (!isInteger(r)) throw new Error("size must be an integer");
    if (e2 > 2 ** (r - 1) - 1 || e2 < -(2 ** (r - 1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
    if (!isInteger(e2)) throw new Error("Value must be an integer");
    e2 < 0 && (e2 += 2 ** r), i2 = "i".concat(r);
  }
  var a = "";
  return e2 < 0 && (e2 = -e2, a = "-"), "".concat(a).concat(n).concat(e2.toString(t2)).concat(i2);
}
function format$2(e2, t2) {
  if ("function" == typeof t2) return t2(e2);
  if (e2 === 1 / 0) return "Infinity";
  if (e2 === -1 / 0) return "-Infinity";
  if (isNaN(e2)) return "NaN";
  var { notation: r, precision: n, wordSize: i2 } = normalizeFormatOptions(t2);
  switch (r) {
    case "fixed":
      return toFixed$2(e2, n);
    case "exponential":
      return toExponential$1(e2, n);
    case "engineering":
      return toEngineering$1(e2, n);
    case "bin":
      return formatNumberToBase(e2, 2, i2);
    case "oct":
      return formatNumberToBase(e2, 8, i2);
    case "hex":
      return formatNumberToBase(e2, 16, i2);
    case "auto":
      return toPrecision(e2, n, t2).replace(/((\.\d*?)(0+))($|e)/, (function() {
        var e3 = arguments[2], t22 = arguments[4];
        return "." !== e3 ? e3 + t22 : t22;
      }));
    default:
      throw new Error('Unknown notation "' + r + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function normalizeFormatOptions(e2) {
  var t2, r, n = "auto";
  if (void 0 !== e2) if (isNumber$1(e2)) t2 = e2;
  else if (isBigNumber(e2)) t2 = e2.toNumber();
  else {
    if (!isObject$1(e2)) throw new Error("Unsupported type of options, number, BigNumber, or object expected");
    void 0 !== e2.precision && (t2 = _toNumberOrThrow(e2.precision, (() => {
      throw new Error('Option "precision" must be a number or BigNumber');
    }))), void 0 !== e2.wordSize && (r = _toNumberOrThrow(e2.wordSize, (() => {
      throw new Error('Option "wordSize" must be a number or BigNumber');
    }))), e2.notation && (n = e2.notation);
  }
  return { notation: n, precision: t2, wordSize: r };
}
function splitNumber(e2) {
  var t2 = String(e2).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!t2) throw new SyntaxError("Invalid number " + e2);
  var r = t2[1], n = t2[2], i2 = parseFloat(t2[4] || "0"), a = n.indexOf(".");
  i2 += -1 !== a ? a - 1 : n.length - 1;
  var o = n.replace(".", "").replace(/^0*/, (function(e3) {
    return i2 -= e3.length, "";
  })).replace(/0*$/, "").split("").map((function(e3) {
    return parseInt(e3);
  }));
  return 0 === o.length && (o.push(0), i2++), { sign: r, coefficients: o, exponent: i2 };
}
function toEngineering$1(e2, t2) {
  if (isNaN(e2) || !Number.isFinite(e2)) return String(e2);
  var r = roundDigits(splitNumber(e2), t2), n = r.exponent, i2 = r.coefficients, a = n % 3 == 0 ? n : n < 0 ? n - 3 - n % 3 : n - n % 3;
  if (isNumber$1(t2)) for (; t2 > i2.length || n - a + 1 > i2.length; ) i2.push(0);
  else for (var o = Math.abs(n - a) - (i2.length - 1), s = 0; s < o; s++) i2.push(0);
  for (var u = Math.abs(n - a), c2 = 1; u > 0; ) c2++, u--;
  var l = i2.slice(c2).join(""), f2 = isNumber$1(t2) && l.length || l.match(/[1-9]/) ? "." + l : "", p = i2.slice(0, c2).join("") + f2 + "e" + (n >= 0 ? "+" : "") + a.toString();
  return r.sign + p;
}
function toFixed$2(e2, t2) {
  if (isNaN(e2) || !Number.isFinite(e2)) return String(e2);
  var r = splitNumber(e2), n = "number" == typeof t2 ? roundDigits(r, r.exponent + 1 + t2) : r, i2 = n.coefficients, a = n.exponent + 1, o = a + (t2 || 0);
  return i2.length < o && (i2 = i2.concat(zeros(o - i2.length))), a < 0 && (i2 = zeros(1 - a).concat(i2), a = 1), a < i2.length && i2.splice(a, 0, 0 === a ? "0." : "."), n.sign + i2.join("");
}
function toExponential$1(e2, t2) {
  if (isNaN(e2) || !Number.isFinite(Number(e2))) return String(e2);
  var r = splitNumber(e2), n = t2 ? roundDigits(r, t2) : r, i2 = n.coefficients, a = n.exponent;
  i2.length < t2 && (i2 = i2.concat(zeros(t2 - i2.length)));
  var o = i2.shift();
  return n.sign + o + (i2.length > 0 ? "." + i2.join("") : "") + "e" + (a >= 0 ? "+" : "") + a;
}
function toPrecision(e2, t2, r) {
  if (isNaN(e2) || !Number.isFinite(e2)) return String(e2);
  var n = _toNumberOrDefault$1(null == r ? void 0 : r.lowerExp, -3), i2 = _toNumberOrDefault$1(null == r ? void 0 : r.upperExp, 5), a = splitNumber(e2), o = t2 ? roundDigits(a, t2) : a;
  if (o.exponent < n || o.exponent >= i2) return toExponential$1(e2, t2);
  var s = o.coefficients, u = o.exponent;
  s.length < t2 && (s = s.concat(zeros(t2 - s.length))), s = s.concat(zeros(u - s.length + 1 + (s.length < t2 ? t2 - s.length : 0)));
  var c2 = u > 0 ? u : 0;
  return c2 < (s = zeros(-u).concat(s)).length - 1 && s.splice(c2 + 1, 0, "."), o.sign + s.join("");
}
function roundDigits(e2, t2) {
  for (var r = { sign: e2.sign, coefficients: e2.coefficients, exponent: e2.exponent }, n = r.coefficients; t2 <= 0; ) n.unshift(0), r.exponent++, t2++;
  if (n.length > t2 && n.splice(t2, n.length - t2)[0] >= 5) {
    var i2 = t2 - 1;
    for (n[i2]++; 10 === n[i2]; ) n.pop(), 0 === i2 && (n.unshift(0), r.exponent++, i2++), n[--i2]++;
  }
  return r;
}
function zeros(e2) {
  for (var t2 = [], r = 0; r < e2; r++) t2.push(0);
  return t2;
}
function digits(e2) {
  return e2.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
function nearlyEqual$1(e2, t2) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e-8, n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
  if (r <= 0) throw new Error("Relative tolerance must be greater than 0");
  if (n < 0) throw new Error("Absolute tolerance must be at least 0");
  return !isNaN(e2) && !isNaN(t2) && (Number.isFinite(e2) && Number.isFinite(t2) ? e2 === t2 || Math.abs(e2 - t2) <= Math.max(r * Math.max(Math.abs(e2), Math.abs(t2)), n) : e2 === t2);
}
var acosh$2 = Math.acosh || function(e2) {
  return Math.log(Math.sqrt(e2 * e2 - 1) + e2);
}, asinh$2 = Math.asinh || function(e2) {
  return Math.log(Math.sqrt(e2 * e2 + 1) + e2);
}, atanh$2 = Math.atanh || function(e2) {
  return Math.log((1 + e2) / (1 - e2)) / 2;
}, cosh$3 = Math.cosh || function(e2) {
  return (Math.exp(e2) + Math.exp(-e2)) / 2;
}, sinh$3 = Math.sinh || function(e2) {
  return (Math.exp(e2) - Math.exp(-e2)) / 2;
}, tanh$2 = Math.tanh || function(e2) {
  var t2 = Math.exp(2 * e2);
  return (t2 - 1) / (t2 + 1);
};
function copysign(e2, t2) {
  return e2 > 0 ^ (t2 > 0 || !(t2 < 0) && 1 / t2 == 1 / 0) ? -e2 : e2;
}
function _toNumberOrThrow(e2, t2) {
  return isNumber$1(e2) ? e2 : isBigNumber(e2) ? e2.toNumber() : void t2();
}
function _toNumberOrDefault$1(e2, t2) {
  return isNumber$1(e2) ? e2 : isBigNumber(e2) ? e2.toNumber() : t2;
}
var _createTyped2 = function() {
  return _createTyped2 = typedFunction.create, typedFunction;
}, dependencies$50 = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], createTyped = factory("typed", dependencies$50, (function(e2) {
  var { BigNumber: t2, Complex: r, DenseMatrix: n, Fraction: i2 } = e2, a = _createTyped2();
  return a.clear(), a.addTypes([{ name: "number", test: isNumber$1 }, { name: "Complex", test: isComplex }, { name: "BigNumber", test: isBigNumber }, { name: "bigint", test: isBigInt }, { name: "Fraction", test: isFraction }, { name: "Unit", test: isUnit }, { name: "identifier", test: (e3) => isString$1 && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(e3) }, { name: "string", test: isString$1 }, { name: "Chain", test: isChain }, { name: "Array", test: isArray$1 }, { name: "Matrix", test: isMatrix }, { name: "DenseMatrix", test: isDenseMatrix }, { name: "SparseMatrix", test: isSparseMatrix }, { name: "Range", test: isRange }, { name: "Index", test: isIndex }, { name: "boolean", test: isBoolean$1 }, { name: "ResultSet", test: isResultSet }, { name: "Help", test: isHelp }, { name: "function", test: isFunction$2 }, { name: "Date", test: isDate$1 }, { name: "RegExp", test: isRegExp$1 }, { name: "null", test: isNull$1 }, { name: "undefined", test: isUndefined$1 }, { name: "AccessorNode", test: isAccessorNode }, { name: "ArrayNode", test: isArrayNode }, { name: "AssignmentNode", test: isAssignmentNode }, { name: "BlockNode", test: isBlockNode }, { name: "ConditionalNode", test: isConditionalNode }, { name: "ConstantNode", test: isConstantNode }, { name: "FunctionNode", test: isFunctionNode }, { name: "FunctionAssignmentNode", test: isFunctionAssignmentNode }, { name: "IndexNode", test: isIndexNode }, { name: "Node", test: isNode$1 }, { name: "ObjectNode", test: isObjectNode }, { name: "OperatorNode", test: isOperatorNode }, { name: "ParenthesisNode", test: isParenthesisNode }, { name: "RangeNode", test: isRangeNode }, { name: "RelationalNode", test: isRelationalNode }, { name: "SymbolNode", test: isSymbolNode }, { name: "Map", test: isMap$1 }, { name: "Object", test: isObject$1 }]), a.addConversions([{ from: "number", to: "BigNumber", convert: function(e3) {
    if (t2 || throwNoBignumber(e3), digits(e3) > 15) throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + e3 + "). Use function bignumber(x) to convert to BigNumber.");
    return new t2(e3);
  } }, { from: "number", to: "Complex", convert: function(e3) {
    return r || throwNoComplex(e3), new r(e3, 0);
  } }, { from: "BigNumber", to: "Complex", convert: function(e3) {
    return r || throwNoComplex(e3), new r(e3.toNumber(), 0);
  } }, { from: "bigint", to: "number", convert: function(e3) {
    if (e3 > Number.MAX_SAFE_INTEGER) throw new TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + e3 + ")");
    return Number(e3);
  } }, { from: "bigint", to: "BigNumber", convert: function(e3) {
    return t2 || throwNoBignumber(e3), new t2(e3.toString());
  } }, { from: "bigint", to: "Fraction", convert: function(e3) {
    return i2 || throwNoFraction(e3), new i2(e3);
  } }, { from: "Fraction", to: "BigNumber", convert: function(e3) {
    throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
  } }, { from: "Fraction", to: "Complex", convert: function(e3) {
    return r || throwNoComplex(e3), new r(e3.valueOf(), 0);
  } }, { from: "number", to: "Fraction", convert: function(e3) {
    i2 || throwNoFraction(e3);
    var t22 = new i2(e3);
    if (t22.valueOf() !== e3) throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + e3 + "). Use function fraction(x) to convert to Fraction.");
    return t22;
  } }, { from: "string", to: "number", convert: function(e3) {
    var t22 = Number(e3);
    if (isNaN(t22)) throw new Error('Cannot convert "' + e3 + '" to a number');
    return t22;
  } }, { from: "string", to: "BigNumber", convert: function(e3) {
    t2 || throwNoBignumber(e3);
    try {
      return new t2(e3);
    } catch (t22) {
      throw new Error('Cannot convert "' + e3 + '" to BigNumber');
    }
  } }, { from: "string", to: "bigint", convert: function(e3) {
    try {
      return BigInt(e3);
    } catch (t22) {
      throw new Error('Cannot convert "' + e3 + '" to BigInt');
    }
  } }, { from: "string", to: "Fraction", convert: function(e3) {
    i2 || throwNoFraction(e3);
    try {
      return new i2(e3);
    } catch (t22) {
      throw new Error('Cannot convert "' + e3 + '" to Fraction');
    }
  } }, { from: "string", to: "Complex", convert: function(e3) {
    r || throwNoComplex(e3);
    try {
      return new r(e3);
    } catch (t22) {
      throw new Error('Cannot convert "' + e3 + '" to Complex');
    }
  } }, { from: "boolean", to: "number", convert: function(e3) {
    return +e3;
  } }, { from: "boolean", to: "BigNumber", convert: function(e3) {
    return t2 || throwNoBignumber(e3), new t2(+e3);
  } }, { from: "boolean", to: "bigint", convert: function(e3) {
    return BigInt(+e3);
  } }, { from: "boolean", to: "Fraction", convert: function(e3) {
    return i2 || throwNoFraction(e3), new i2(+e3);
  } }, { from: "boolean", to: "string", convert: function(e3) {
    return String(e3);
  } }, { from: "Array", to: "Matrix", convert: function(e3) {
    return n || throwNoMatrix(), new n(e3);
  } }, { from: "Matrix", to: "Array", convert: function(e3) {
    return e3.valueOf();
  } }]), a.onMismatch = (e3, t22, r2) => {
    var n3 = a.createError(e3, t22, r2);
    if (["wrongType", "mismatch"].includes(n3.data.category) && 1 === t22.length && isCollection(t22[0]) && r2.some(((e4) => !e4.params.includes(",")))) {
      var i22 = new TypeError("Function '".concat(e3, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(e3, ")'."));
      throw i22.data = n3.data, i22;
    }
    throw n3;
  }, a.onMismatch = (e3, t22, r2) => {
    var n3 = a.createError(e3, t22, r2);
    if (["wrongType", "mismatch"].includes(n3.data.category) && 1 === t22.length && isCollection(t22[0]) && r2.some(((e4) => !e4.params.includes(",")))) {
      var i22 = new TypeError("Function '".concat(e3, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(e3, ")'."));
      throw i22.data = n3.data, i22;
    }
    throw n3;
  }, a;
}));
function throwNoBignumber(e2) {
  throw new Error("Cannot convert value ".concat(e2, " into a BigNumber: no class 'BigNumber' provided"));
}
function throwNoComplex(e2) {
  throw new Error("Cannot convert value ".concat(e2, " into a Complex number: no class 'Complex' provided"));
}
function throwNoMatrix() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function throwNoFraction(e2) {
  throw new Error("Cannot convert value ".concat(e2, " into a Fraction, no class 'Fraction' provided."));
}
var name$4$ = "ResultSet", dependencies$4$ = [], createResultSet = factory(name$4$, dependencies$4$, (() => {
  function e2(t2) {
    if (!(this instanceof e2)) throw new SyntaxError("Constructor must be called with the new operator");
    this.entries = t2 || [];
  }
  return e2.prototype.type = "ResultSet", e2.prototype.isResultSet = true, e2.prototype.valueOf = function() {
    return this.entries;
  }, e2.prototype.toString = function() {
    return "[" + this.entries.map(String).join(", ") + "]";
  }, e2.prototype.toJSON = function() {
    return { mathjs: "ResultSet", entries: this.entries };
  }, e2.fromJSON = function(t2) {
    return new e2(t2.entries);
  }, e2;
}), { isClass: true }), EXP_LIMIT = 9e15, MAX_DIGITS = 1e9, NUMERALS = "0123456789abcdef", LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", DEFAULTS = { precision: 20, rounding: 4, modulo: 1, toExpNeg: -7, toExpPos: 21, minE: -EXP_LIMIT, maxE: EXP_LIMIT, crypto: false }, inexact, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, P$3 = { toStringTag: tag };
function digitsToString(e2) {
  var t2, r, n, i2 = e2.length - 1, a = "", o = e2[0];
  if (i2 > 0) {
    for (a += o, t2 = 1; t2 < i2; t2++) n = e2[t2] + "", (r = LOG_BASE - n.length) && (a += getZeroString(r)), a += n;
    o = e2[t2], (r = LOG_BASE - (n = o + "").length) && (a += getZeroString(r));
  } else if (0 === o) return "0";
  for (; o % 10 == 0; ) o /= 10;
  return a + o;
}
function checkInt32(e2, t2, r) {
  if (e2 !== ~~e2 || e2 < t2 || e2 > r) throw Error(invalidArgument + e2);
}
function checkRoundingDigits(e2, t2, r, n) {
  var i2, a, o, s;
  for (a = e2[0]; a >= 10; a /= 10) --t2;
  return --t2 < 0 ? (t2 += LOG_BASE, i2 = 0) : (i2 = Math.ceil((t2 + 1) / LOG_BASE), t2 %= LOG_BASE), a = mathpow(10, LOG_BASE - t2), s = e2[i2] % a | 0, null == n ? t2 < 3 ? (0 == t2 ? s = s / 100 | 0 : 1 == t2 && (s = s / 10 | 0), o = r < 4 && 99999 == s || r > 3 && 49999 == s || 5e4 == s || 0 == s) : o = (r < 4 && s + 1 == a || r > 3 && s + 1 == a / 2) && (e2[i2 + 1] / a / 100 | 0) == mathpow(10, t2 - 2) - 1 || (s == a / 2 || 0 == s) && !(e2[i2 + 1] / a / 100 | 0) : t2 < 4 ? (0 == t2 ? s = s / 1e3 | 0 : 1 == t2 ? s = s / 100 | 0 : 2 == t2 && (s = s / 10 | 0), o = (n || r < 4) && 9999 == s || !n && r > 3 && 4999 == s) : o = ((n || r < 4) && s + 1 == a || !n && r > 3 && s + 1 == a / 2) && (e2[i2 + 1] / a / 1e3 | 0) == mathpow(10, t2 - 3) - 1, o;
}
function convertBase(e2, t2, r) {
  for (var n, i2, a = [0], o = 0, s = e2.length; o < s; ) {
    for (i2 = a.length; i2--; ) a[i2] *= t2;
    for (a[0] += NUMERALS.indexOf(e2.charAt(o++)), n = 0; n < a.length; n++) a[n] > r - 1 && (void 0 === a[n + 1] && (a[n + 1] = 0), a[n + 1] += a[n] / r | 0, a[n] %= r);
  }
  return a.reverse();
}
function cosine(e2, t2) {
  var r, n, i2;
  if (t2.isZero()) return t2;
  (n = t2.d.length) < 32 ? i2 = (1 / tinyPow(4, r = Math.ceil(n / 3))).toString() : (r = 16, i2 = "2.3283064365386962890625e-10"), e2.precision += r, t2 = taylorSeries(e2, 1, t2.times(i2), new e2(1));
  for (var a = r; a--; ) {
    var o = t2.times(t2);
    t2 = o.times(o).minus(o).times(8).plus(1);
  }
  return e2.precision -= r, t2;
}
P$3.absoluteValue = P$3.abs = function() {
  var e2 = new this.constructor(this);
  return e2.s < 0 && (e2.s = 1), finalise(e2);
}, P$3.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
}, P$3.clampedTo = P$3.clamp = function(e2, t2) {
  var r = this, n = r.constructor;
  if (e2 = new n(e2), t2 = new n(t2), !e2.s || !t2.s) return new n(NaN);
  if (e2.gt(t2)) throw Error(invalidArgument + t2);
  return r.cmp(e2) < 0 ? e2 : r.cmp(t2) > 0 ? t2 : new n(r);
}, P$3.comparedTo = P$3.cmp = function(e2) {
  var t2, r, n, i2, a = this, o = a.d, s = (e2 = new a.constructor(e2)).d, u = a.s, c2 = e2.s;
  if (!o || !s) return u && c2 ? u !== c2 ? u : o === s ? 0 : !o ^ u < 0 ? 1 : -1 : NaN;
  if (!o[0] || !s[0]) return o[0] ? u : s[0] ? -c2 : 0;
  if (u !== c2) return u;
  if (a.e !== e2.e) return a.e > e2.e ^ u < 0 ? 1 : -1;
  for (t2 = 0, r = (n = o.length) < (i2 = s.length) ? n : i2; t2 < r; ++t2) if (o[t2] !== s[t2]) return o[t2] > s[t2] ^ u < 0 ? 1 : -1;
  return n === i2 ? 0 : n > i2 ^ u < 0 ? 1 : -1;
}, P$3.cosine = P$3.cos = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.d ? r.d[0] ? (e2 = n.precision, t2 = n.rounding, n.precision = e2 + Math.max(r.e, r.sd()) + LOG_BASE, n.rounding = 1, r = cosine(n, toLessThanHalfPi(n, r)), n.precision = e2, n.rounding = t2, finalise(2 == quadrant || 3 == quadrant ? r.neg() : r, e2, t2, true)) : new n(1) : new n(NaN);
}, P$3.cubeRoot = P$3.cbrt = function() {
  var e2, t2, r, n, i2, a, o, s, u, c2, l = this, f2 = l.constructor;
  if (!l.isFinite() || l.isZero()) return new f2(l);
  for (external = false, (a = l.s * mathpow(l.s * l, 1 / 3)) && Math.abs(a) != 1 / 0 ? n = new f2(a.toString()) : (r = digitsToString(l.d), (a = ((e2 = l.e) - r.length + 1) % 3) && (r += 1 == a || -2 == a ? "0" : "00"), a = mathpow(r, 1 / 3), e2 = mathfloor((e2 + 1) / 3) - (e2 % 3 == (e2 < 0 ? -1 : 2)), (n = new f2(r = a == 1 / 0 ? "5e" + e2 : (r = a.toExponential()).slice(0, r.indexOf("e") + 1) + e2)).s = l.s), o = (e2 = f2.precision) + 3; ; ) if (c2 = (u = (s = n).times(s).times(s)).plus(l), n = divide$1(c2.plus(l).times(s), c2.plus(u), o + 2, 1), digitsToString(s.d).slice(0, o) === (r = digitsToString(n.d)).slice(0, o)) {
    if ("9999" != (r = r.slice(o - 3, o + 1)) && (i2 || "4999" != r)) {
      +r && (+r.slice(1) || "5" != r.charAt(0)) || (finalise(n, e2 + 1, 1), t2 = !n.times(n).times(n).eq(l));
      break;
    }
    if (!i2 && (finalise(s, e2 + 1, 0), s.times(s).times(s).eq(l))) {
      n = s;
      break;
    }
    o += 4, i2 = 1;
  }
  return external = true, finalise(n, e2, f2.rounding, t2);
}, P$3.decimalPlaces = P$3.dp = function() {
  var e2, t2 = this.d, r = NaN;
  if (t2) {
    if (r = ((e2 = t2.length - 1) - mathfloor(this.e / LOG_BASE)) * LOG_BASE, e2 = t2[e2]) for (; e2 % 10 == 0; e2 /= 10) r--;
    r < 0 && (r = 0);
  }
  return r;
}, P$3.dividedBy = P$3.div = function(e2) {
  return divide$1(this, new this.constructor(e2));
}, P$3.dividedToIntegerBy = P$3.divToInt = function(e2) {
  var t2 = this.constructor;
  return finalise(divide$1(this, new t2(e2), 0, 1, 1), t2.precision, t2.rounding);
}, P$3.equals = P$3.eq = function(e2) {
  return 0 === this.cmp(e2);
}, P$3.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
}, P$3.greaterThan = P$3.gt = function(e2) {
  return this.cmp(e2) > 0;
}, P$3.greaterThanOrEqualTo = P$3.gte = function(e2) {
  var t2 = this.cmp(e2);
  return 1 == t2 || 0 === t2;
}, P$3.hyperbolicCosine = P$3.cosh = function() {
  var e2, t2, r, n, i2, a = this, o = a.constructor, s = new o(1);
  if (!a.isFinite()) return new o(a.s ? 1 / 0 : NaN);
  if (a.isZero()) return s;
  r = o.precision, n = o.rounding, o.precision = r + Math.max(a.e, a.sd()) + 4, o.rounding = 1, (i2 = a.d.length) < 32 ? t2 = (1 / tinyPow(4, e2 = Math.ceil(i2 / 3))).toString() : (e2 = 16, t2 = "2.3283064365386962890625e-10"), a = taylorSeries(o, 1, a.times(t2), new o(1), true);
  for (var u, c2 = e2, l = new o(8); c2--; ) u = a.times(a), a = s.minus(u.times(l.minus(u.times(l))));
  return finalise(a, o.precision = r, o.rounding = n, true);
}, P$3.hyperbolicSine = P$3.sinh = function() {
  var e2, t2, r, n, i2 = this, a = i2.constructor;
  if (!i2.isFinite() || i2.isZero()) return new a(i2);
  if (t2 = a.precision, r = a.rounding, a.precision = t2 + Math.max(i2.e, i2.sd()) + 4, a.rounding = 1, (n = i2.d.length) < 3) i2 = taylorSeries(a, 2, i2, i2, true);
  else {
    e2 = (e2 = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | e2, i2 = taylorSeries(a, 2, i2 = i2.times(1 / tinyPow(5, e2)), i2, true);
    for (var o, s = new a(5), u = new a(16), c2 = new a(20); e2--; ) o = i2.times(i2), i2 = i2.times(s.plus(o.times(u.times(o).plus(c2))));
  }
  return a.precision = t2, a.rounding = r, finalise(i2, t2, r, true);
}, P$3.hyperbolicTangent = P$3.tanh = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e2 = n.precision, t2 = n.rounding, n.precision = e2 + 7, n.rounding = 1, divide$1(r.sinh(), r.cosh(), n.precision = e2, n.rounding = t2)) : new n(r.s);
}, P$3.inverseCosine = P$3.acos = function() {
  var e2, t2 = this, r = t2.constructor, n = t2.abs().cmp(1), i2 = r.precision, a = r.rounding;
  return -1 !== n ? 0 === n ? t2.isNeg() ? getPi(r, i2, a) : new r(0) : new r(NaN) : t2.isZero() ? getPi(r, i2 + 4, a).times(0.5) : (r.precision = i2 + 6, r.rounding = 1, t2 = t2.asin(), e2 = getPi(r, i2 + 4, a).times(0.5), r.precision = i2, r.rounding = a, e2.minus(t2));
}, P$3.inverseHyperbolicCosine = P$3.acosh = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.lte(1) ? new n(r.eq(1) ? 0 : NaN) : r.isFinite() ? (e2 = n.precision, t2 = n.rounding, n.precision = e2 + Math.max(Math.abs(r.e), r.sd()) + 4, n.rounding = 1, external = false, r = r.times(r).minus(1).sqrt().plus(r), external = true, n.precision = e2, n.rounding = t2, r.ln()) : new n(r);
}, P$3.inverseHyperbolicSine = P$3.asinh = function() {
  var e2, t2, r = this, n = r.constructor;
  return !r.isFinite() || r.isZero() ? new n(r) : (e2 = n.precision, t2 = n.rounding, n.precision = e2 + 2 * Math.max(Math.abs(r.e), r.sd()) + 6, n.rounding = 1, external = false, r = r.times(r).plus(1).sqrt().plus(r), external = true, n.precision = e2, n.rounding = t2, r.ln());
}, P$3.inverseHyperbolicTangent = P$3.atanh = function() {
  var e2, t2, r, n, i2 = this, a = i2.constructor;
  return i2.isFinite() ? i2.e >= 0 ? new a(i2.abs().eq(1) ? i2.s / 0 : i2.isZero() ? i2 : NaN) : (e2 = a.precision, t2 = a.rounding, n = i2.sd(), Math.max(n, e2) < 2 * -i2.e - 1 ? finalise(new a(i2), e2, t2, true) : (a.precision = r = n - i2.e, i2 = divide$1(i2.plus(1), new a(1).minus(i2), r + e2, 1), a.precision = e2 + 4, a.rounding = 1, i2 = i2.ln(), a.precision = e2, a.rounding = t2, i2.times(0.5))) : new a(NaN);
}, P$3.inverseSine = P$3.asin = function() {
  var e2, t2, r, n, i2 = this, a = i2.constructor;
  return i2.isZero() ? new a(i2) : (t2 = i2.abs().cmp(1), r = a.precision, n = a.rounding, -1 !== t2 ? 0 === t2 ? ((e2 = getPi(a, r + 4, n).times(0.5)).s = i2.s, e2) : new a(NaN) : (a.precision = r + 6, a.rounding = 1, i2 = i2.div(new a(1).minus(i2.times(i2)).sqrt().plus(1)).atan(), a.precision = r, a.rounding = n, i2.times(2)));
}, P$3.inverseTangent = P$3.atan = function() {
  var e2, t2, r, n, i2, a, o, s, u, c2 = this, l = c2.constructor, f2 = l.precision, p = l.rounding;
  if (c2.isFinite()) {
    if (c2.isZero()) return new l(c2);
    if (c2.abs().eq(1) && f2 + 4 <= PI_PRECISION) return (o = getPi(l, f2 + 4, p).times(0.25)).s = c2.s, o;
  } else {
    if (!c2.s) return new l(NaN);
    if (f2 + 4 <= PI_PRECISION) return (o = getPi(l, f2 + 4, p).times(0.5)).s = c2.s, o;
  }
  for (l.precision = s = f2 + 10, l.rounding = 1, e2 = r = Math.min(28, s / LOG_BASE + 2 | 0); e2; --e2) c2 = c2.div(c2.times(c2).plus(1).sqrt().plus(1));
  for (external = false, t2 = Math.ceil(s / LOG_BASE), n = 1, u = c2.times(c2), o = new l(c2), i2 = c2; -1 !== e2; ) if (i2 = i2.times(u), a = o.minus(i2.div(n += 2)), i2 = i2.times(u), void 0 !== (o = a.plus(i2.div(n += 2))).d[t2]) for (e2 = t2; o.d[e2] === a.d[e2] && e2--; ) ;
  return r && (o = o.times(2 << r - 1)), external = true, finalise(o, l.precision = f2, l.rounding = p, true);
}, P$3.isFinite = function() {
  return !!this.d;
}, P$3.isInteger = P$3.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
}, P$3.isNaN = function() {
  return !this.s;
}, P$3.isNegative = P$3.isNeg = function() {
  return this.s < 0;
}, P$3.isPositive = P$3.isPos = function() {
  return this.s > 0;
}, P$3.isZero = function() {
  return !!this.d && 0 === this.d[0];
}, P$3.lessThan = P$3.lt = function(e2) {
  return this.cmp(e2) < 0;
}, P$3.lessThanOrEqualTo = P$3.lte = function(e2) {
  return this.cmp(e2) < 1;
}, P$3.logarithm = P$3.log = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2 = this, l = c2.constructor, f2 = l.precision, p = l.rounding;
  if (null == e2) e2 = new l(10), t2 = true;
  else {
    if (r = (e2 = new l(e2)).d, e2.s < 0 || !r || !r[0] || e2.eq(1)) return new l(NaN);
    t2 = e2.eq(10);
  }
  if (r = c2.d, c2.s < 0 || !r || !r[0] || c2.eq(1)) return new l(r && !r[0] ? -1 / 0 : 1 != c2.s ? NaN : r ? 0 : 1 / 0);
  if (t2) if (r.length > 1) a = true;
  else {
    for (i2 = r[0]; i2 % 10 == 0; ) i2 /= 10;
    a = 1 !== i2;
  }
  if (external = false, o = naturalLogarithm(c2, s = f2 + 5), n = t2 ? getLn10(l, s + 10) : naturalLogarithm(e2, s), checkRoundingDigits((u = divide$1(o, n, s, 1)).d, i2 = f2, p)) do {
    if (o = naturalLogarithm(c2, s += 10), n = t2 ? getLn10(l, s + 10) : naturalLogarithm(e2, s), u = divide$1(o, n, s, 1), !a) {
      +digitsToString(u.d).slice(i2 + 1, i2 + 15) + 1 == 1e14 && (u = finalise(u, f2 + 1, 0));
      break;
    }
  } while (checkRoundingDigits(u.d, i2 += 10, p));
  return external = true, finalise(u, f2, p);
}, P$3.minus = P$3.sub = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2, l, f2, p, m = this, d = m.constructor;
  if (e2 = new d(e2), !m.d || !e2.d) return m.s && e2.s ? m.d ? e2.s = -e2.s : e2 = new d(e2.d || m.s !== e2.s ? m : NaN) : e2 = new d(NaN), e2;
  if (m.s != e2.s) return e2.s = -e2.s, m.plus(e2);
  if (c2 = m.d, p = e2.d, s = d.precision, u = d.rounding, !c2[0] || !p[0]) {
    if (p[0]) e2.s = -e2.s;
    else {
      if (!c2[0]) return new d(3 === u ? -0 : 0);
      e2 = new d(m);
    }
    return external ? finalise(e2, s, u) : e2;
  }
  if (r = mathfloor(e2.e / LOG_BASE), l = mathfloor(m.e / LOG_BASE), c2 = c2.slice(), a = l - r) {
    for ((f2 = a < 0) ? (t2 = c2, a = -a, o = p.length) : (t2 = p, r = l, o = c2.length), a > (n = Math.max(Math.ceil(s / LOG_BASE), o) + 2) && (a = n, t2.length = 1), t2.reverse(), n = a; n--; ) t2.push(0);
    t2.reverse();
  } else {
    for ((f2 = (n = c2.length) < (o = p.length)) && (o = n), n = 0; n < o; n++) if (c2[n] != p[n]) {
      f2 = c2[n] < p[n];
      break;
    }
    a = 0;
  }
  for (f2 && (t2 = c2, c2 = p, p = t2, e2.s = -e2.s), o = c2.length, n = p.length - o; n > 0; --n) c2[o++] = 0;
  for (n = p.length; n > a; ) {
    if (c2[--n] < p[n]) {
      for (i2 = n; i2 && 0 === c2[--i2]; ) c2[i2] = BASE - 1;
      --c2[i2], c2[n] += BASE;
    }
    c2[n] -= p[n];
  }
  for (; 0 === c2[--o]; ) c2.pop();
  for (; 0 === c2[0]; c2.shift()) --r;
  return c2[0] ? (e2.d = c2, e2.e = getBase10Exponent(c2, r), external ? finalise(e2, s, u) : e2) : new d(3 === u ? -0 : 0);
}, P$3.modulo = P$3.mod = function(e2) {
  var t2, r = this, n = r.constructor;
  return e2 = new n(e2), !r.d || !e2.s || e2.d && !e2.d[0] ? new n(NaN) : !e2.d || r.d && !r.d[0] ? finalise(new n(r), n.precision, n.rounding) : (external = false, 9 == n.modulo ? (t2 = divide$1(r, e2.abs(), 0, 3, 1)).s *= e2.s : t2 = divide$1(r, e2, 0, n.modulo, 1), t2 = t2.times(e2), external = true, r.minus(t2));
}, P$3.naturalExponential = P$3.exp = function() {
  return naturalExponential(this);
}, P$3.naturalLogarithm = P$3.ln = function() {
  return naturalLogarithm(this);
}, P$3.negated = P$3.neg = function() {
  var e2 = new this.constructor(this);
  return e2.s = -e2.s, finalise(e2);
}, P$3.plus = P$3.add = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2, l, f2 = this, p = f2.constructor;
  if (e2 = new p(e2), !f2.d || !e2.d) return f2.s && e2.s ? f2.d || (e2 = new p(e2.d || f2.s === e2.s ? f2 : NaN)) : e2 = new p(NaN), e2;
  if (f2.s != e2.s) return e2.s = -e2.s, f2.minus(e2);
  if (c2 = f2.d, l = e2.d, s = p.precision, u = p.rounding, !c2[0] || !l[0]) return l[0] || (e2 = new p(f2)), external ? finalise(e2, s, u) : e2;
  if (a = mathfloor(f2.e / LOG_BASE), n = mathfloor(e2.e / LOG_BASE), c2 = c2.slice(), i2 = a - n) {
    for (i2 < 0 ? (r = c2, i2 = -i2, o = l.length) : (r = l, n = a, o = c2.length), i2 > (o = (a = Math.ceil(s / LOG_BASE)) > o ? a + 1 : o + 1) && (i2 = o, r.length = 1), r.reverse(); i2--; ) r.push(0);
    r.reverse();
  }
  for ((o = c2.length) - (i2 = l.length) < 0 && (i2 = o, r = l, l = c2, c2 = r), t2 = 0; i2; ) t2 = (c2[--i2] = c2[i2] + l[i2] + t2) / BASE | 0, c2[i2] %= BASE;
  for (t2 && (c2.unshift(t2), ++n), o = c2.length; 0 == c2[--o]; ) c2.pop();
  return e2.d = c2, e2.e = getBase10Exponent(c2, n), external ? finalise(e2, s, u) : e2;
}, P$3.precision = P$3.sd = function(e2) {
  var t2, r = this;
  if (void 0 !== e2 && e2 !== !!e2 && 1 !== e2 && 0 !== e2) throw Error(invalidArgument + e2);
  return r.d ? (t2 = getPrecision(r.d), e2 && r.e + 1 > t2 && (t2 = r.e + 1)) : t2 = NaN, t2;
}, P$3.round = function() {
  var e2 = this, t2 = e2.constructor;
  return finalise(new t2(e2), e2.e + 1, t2.rounding);
}, P$3.sine = P$3.sin = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e2 = n.precision, t2 = n.rounding, n.precision = e2 + Math.max(r.e, r.sd()) + LOG_BASE, n.rounding = 1, r = sine(n, toLessThanHalfPi(n, r)), n.precision = e2, n.rounding = t2, finalise(quadrant > 2 ? r.neg() : r, e2, t2, true)) : new n(NaN);
}, P$3.squareRoot = P$3.sqrt = function() {
  var e2, t2, r, n, i2, a, o = this, s = o.d, u = o.e, c2 = o.s, l = o.constructor;
  if (1 !== c2 || !s || !s[0]) return new l(!c2 || c2 < 0 && (!s || s[0]) ? NaN : s ? o : 1 / 0);
  for (external = false, 0 == (c2 = Math.sqrt(+o)) || c2 == 1 / 0 ? (((t2 = digitsToString(s)).length + u) % 2 == 0 && (t2 += "0"), c2 = Math.sqrt(t2), u = mathfloor((u + 1) / 2) - (u < 0 || u % 2), n = new l(t2 = c2 == 1 / 0 ? "5e" + u : (t2 = c2.toExponential()).slice(0, t2.indexOf("e") + 1) + u)) : n = new l(c2.toString()), r = (u = l.precision) + 3; ; ) if (n = (a = n).plus(divide$1(o, a, r + 2, 1)).times(0.5), digitsToString(a.d).slice(0, r) === (t2 = digitsToString(n.d)).slice(0, r)) {
    if ("9999" != (t2 = t2.slice(r - 3, r + 1)) && (i2 || "4999" != t2)) {
      +t2 && (+t2.slice(1) || "5" != t2.charAt(0)) || (finalise(n, u + 1, 1), e2 = !n.times(n).eq(o));
      break;
    }
    if (!i2 && (finalise(a, u + 1, 0), a.times(a).eq(o))) {
      n = a;
      break;
    }
    r += 4, i2 = 1;
  }
  return external = true, finalise(n, u, l.rounding, e2);
}, P$3.tangent = P$3.tan = function() {
  var e2, t2, r = this, n = r.constructor;
  return r.isFinite() ? r.isZero() ? new n(r) : (e2 = n.precision, t2 = n.rounding, n.precision = e2 + 10, n.rounding = 1, (r = r.sin()).s = 1, r = divide$1(r, new n(1).minus(r.times(r)).sqrt(), e2 + 10, 0), n.precision = e2, n.rounding = t2, finalise(2 == quadrant || 4 == quadrant ? r.neg() : r, e2, t2, true)) : new n(NaN);
}, P$3.times = P$3.mul = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2, l = this, f2 = l.constructor, p = l.d, m = (e2 = new f2(e2)).d;
  if (e2.s *= l.s, !(p && p[0] && m && m[0])) return new f2(!e2.s || p && !p[0] && !m || m && !m[0] && !p ? NaN : p && m ? 0 * e2.s : e2.s / 0);
  for (r = mathfloor(l.e / LOG_BASE) + mathfloor(e2.e / LOG_BASE), (u = p.length) < (c2 = m.length) && (a = p, p = m, m = a, o = u, u = c2, c2 = o), a = [], n = o = u + c2; n--; ) a.push(0);
  for (n = c2; --n >= 0; ) {
    for (t2 = 0, i2 = u + n; i2 > n; ) s = a[i2] + m[n] * p[i2 - n - 1] + t2, a[i2--] = s % BASE | 0, t2 = s / BASE | 0;
    a[i2] = (a[i2] + t2) % BASE | 0;
  }
  for (; !a[--o]; ) a.pop();
  return t2 ? ++r : a.shift(), e2.d = a, e2.e = getBase10Exponent(a, r), external ? finalise(e2, f2.precision, f2.rounding) : e2;
}, P$3.toBinary = function(e2, t2) {
  return toStringBinary(this, 2, e2, t2);
}, P$3.toDecimalPlaces = P$3.toDP = function(e2, t2) {
  var r = this, n = r.constructor;
  return r = new n(r), void 0 === e2 ? r : (checkInt32(e2, 0, MAX_DIGITS), void 0 === t2 ? t2 = n.rounding : checkInt32(t2, 0, 8), finalise(r, e2 + r.e + 1, t2));
}, P$3.toExponential = function(e2, t2) {
  var r, n = this, i2 = n.constructor;
  return void 0 === e2 ? r = finiteToString(n, true) : (checkInt32(e2, 0, MAX_DIGITS), void 0 === t2 ? t2 = i2.rounding : checkInt32(t2, 0, 8), r = finiteToString(n = finalise(new i2(n), e2 + 1, t2), true, e2 + 1)), n.isNeg() && !n.isZero() ? "-" + r : r;
}, P$3.toFixed = function(e2, t2) {
  var r, n, i2 = this, a = i2.constructor;
  return void 0 === e2 ? r = finiteToString(i2) : (checkInt32(e2, 0, MAX_DIGITS), void 0 === t2 ? t2 = a.rounding : checkInt32(t2, 0, 8), r = finiteToString(n = finalise(new a(i2), e2 + i2.e + 1, t2), false, e2 + n.e + 1)), i2.isNeg() && !i2.isZero() ? "-" + r : r;
}, P$3.toFraction = function(e2) {
  var t2, r, n, i2, a, o, s, u, c2, l, f2, p, m = this, d = m.d, h = m.constructor;
  if (!d) return new h(m);
  if (c2 = r = new h(1), n = u = new h(0), o = (a = (t2 = new h(n)).e = getPrecision(d) - m.e - 1) % LOG_BASE, t2.d[0] = mathpow(10, o < 0 ? LOG_BASE + o : o), null == e2) e2 = a > 0 ? t2 : c2;
  else {
    if (!(s = new h(e2)).isInt() || s.lt(c2)) throw Error(invalidArgument + s);
    e2 = s.gt(t2) ? a > 0 ? t2 : c2 : s;
  }
  for (external = false, s = new h(digitsToString(d)), l = h.precision, h.precision = a = d.length * LOG_BASE * 2; f2 = divide$1(s, t2, 0, 1, 1), 1 != (i2 = r.plus(f2.times(n))).cmp(e2); ) r = n, n = i2, i2 = c2, c2 = u.plus(f2.times(i2)), u = i2, i2 = t2, t2 = s.minus(f2.times(i2)), s = i2;
  return i2 = divide$1(e2.minus(r), n, 0, 1, 1), u = u.plus(i2.times(c2)), r = r.plus(i2.times(n)), u.s = c2.s = m.s, p = divide$1(c2, n, a, 1).minus(m).abs().cmp(divide$1(u, r, a, 1).minus(m).abs()) < 1 ? [c2, n] : [u, r], h.precision = l, external = true, p;
}, P$3.toHexadecimal = P$3.toHex = function(e2, t2) {
  return toStringBinary(this, 16, e2, t2);
}, P$3.toNearest = function(e2, t2) {
  var r = this, n = r.constructor;
  if (r = new n(r), null == e2) {
    if (!r.d) return r;
    e2 = new n(1), t2 = n.rounding;
  } else {
    if (e2 = new n(e2), void 0 === t2 ? t2 = n.rounding : checkInt32(t2, 0, 8), !r.d) return e2.s ? r : e2;
    if (!e2.d) return e2.s && (e2.s = r.s), e2;
  }
  return e2.d[0] ? (external = false, r = divide$1(r, e2, 0, t2, 1).times(e2), external = true, finalise(r)) : (e2.s = r.s, r = e2), r;
}, P$3.toNumber = function() {
  return +this;
}, P$3.toOctal = function(e2, t2) {
  return toStringBinary(this, 8, e2, t2);
}, P$3.toPower = P$3.pow = function(e2) {
  var t2, r, n, i2, a, o, s = this, u = s.constructor, c2 = +(e2 = new u(e2));
  if (!(s.d && e2.d && s.d[0] && e2.d[0])) return new u(mathpow(+s, c2));
  if ((s = new u(s)).eq(1)) return s;
  if (n = u.precision, a = u.rounding, e2.eq(1)) return finalise(s, n, a);
  if ((t2 = mathfloor(e2.e / LOG_BASE)) >= e2.d.length - 1 && (r = c2 < 0 ? -c2 : c2) <= MAX_SAFE_INTEGER) return i2 = intPow(u, s, r, n), e2.s < 0 ? new u(1).div(i2) : finalise(i2, n, a);
  if ((o = s.s) < 0) {
    if (t2 < e2.d.length - 1) return new u(NaN);
    if (1 & e2.d[t2] || (o = 1), 0 == s.e && 1 == s.d[0] && 1 == s.d.length) return s.s = o, s;
  }
  return (t2 = 0 != (r = mathpow(+s, c2)) && isFinite(r) ? new u(r + "").e : mathfloor(c2 * (Math.log("0." + digitsToString(s.d)) / Math.LN10 + s.e + 1))) > u.maxE + 1 || t2 < u.minE - 1 ? new u(t2 > 0 ? o / 0 : 0) : (external = false, u.rounding = s.s = 1, r = Math.min(12, (t2 + "").length), (i2 = naturalExponential(e2.times(naturalLogarithm(s, n + r)), n)).d && checkRoundingDigits((i2 = finalise(i2, n + 5, 1)).d, n, a) && (t2 = n + 10, +digitsToString((i2 = finalise(naturalExponential(e2.times(naturalLogarithm(s, t2 + r)), t2), t2 + 5, 1)).d).slice(n + 1, n + 15) + 1 == 1e14 && (i2 = finalise(i2, n + 1, 0))), i2.s = o, external = true, u.rounding = a, finalise(i2, n, a));
}, P$3.toPrecision = function(e2, t2) {
  var r, n = this, i2 = n.constructor;
  return void 0 === e2 ? r = finiteToString(n, n.e <= i2.toExpNeg || n.e >= i2.toExpPos) : (checkInt32(e2, 1, MAX_DIGITS), void 0 === t2 ? t2 = i2.rounding : checkInt32(t2, 0, 8), r = finiteToString(n = finalise(new i2(n), e2, t2), e2 <= n.e || n.e <= i2.toExpNeg, e2)), n.isNeg() && !n.isZero() ? "-" + r : r;
}, P$3.toSignificantDigits = P$3.toSD = function(e2, t2) {
  var r = this.constructor;
  return void 0 === e2 ? (e2 = r.precision, t2 = r.rounding) : (checkInt32(e2, 1, MAX_DIGITS), void 0 === t2 ? t2 = r.rounding : checkInt32(t2, 0, 8)), finalise(new r(this), e2, t2);
}, P$3.toString = function() {
  var e2 = this, t2 = e2.constructor, r = finiteToString(e2, e2.e <= t2.toExpNeg || e2.e >= t2.toExpPos);
  return e2.isNeg() && !e2.isZero() ? "-" + r : r;
}, P$3.truncated = P$3.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
}, P$3.valueOf = P$3.toJSON = function() {
  var e2 = this, t2 = e2.constructor, r = finiteToString(e2, e2.e <= t2.toExpNeg || e2.e >= t2.toExpPos);
  return e2.isNeg() ? "-" + r : r;
};
var divide$1 = /* @__PURE__ */ (function() {
  function e2(e3, t22, r2) {
    var n, i2 = 0, a = e3.length;
    for (e3 = e3.slice(); a--; ) n = e3[a] * t22 + i2, e3[a] = n % r2 | 0, i2 = n / r2 | 0;
    return i2 && e3.unshift(i2), e3;
  }
  function t2(e3, t22, r2, n) {
    var i2, a;
    if (r2 != n) a = r2 > n ? 1 : -1;
    else for (i2 = a = 0; i2 < r2; i2++) if (e3[i2] != t22[i2]) {
      a = e3[i2] > t22[i2] ? 1 : -1;
      break;
    }
    return a;
  }
  function r(e3, t22, r2, n) {
    for (var i2 = 0; r2--; ) e3[r2] -= i2, i2 = e3[r2] < t22[r2] ? 1 : 0, e3[r2] = i2 * n + e3[r2] - t22[r2];
    for (; !e3[0] && e3.length > 1; ) e3.shift();
  }
  return function(n, i2, a, o, s, u) {
    var c2, l, f2, p, m, d, h, g, y, v2, x2, b2, _2, w2, A2, N, D, E, $2, S2, C2 = n.constructor, M2 = n.s == i2.s ? 1 : -1, T2 = n.d, F = i2.d;
    if (!(T2 && T2[0] && F && F[0])) return new C2(n.s && i2.s && (T2 ? !F || T2[0] != F[0] : F) ? T2 && 0 == T2[0] || !F ? 0 * M2 : M2 / 0 : NaN);
    for (u ? (m = 1, l = n.e - i2.e) : (u = BASE, m = LOG_BASE, l = mathfloor(n.e / m) - mathfloor(i2.e / m)), $2 = F.length, D = T2.length, v2 = (y = new C2(M2)).d = [], f2 = 0; F[f2] == (T2[f2] || 0); f2++) ;
    if (F[f2] > (T2[f2] || 0) && l--, null == a ? (w2 = a = C2.precision, o = C2.rounding) : w2 = s ? a + (n.e - i2.e) + 1 : a, w2 < 0) v2.push(1), d = true;
    else {
      if (w2 = w2 / m + 2 | 0, f2 = 0, 1 == $2) {
        for (p = 0, F = F[0], w2++; (f2 < D || p) && w2--; f2++) A2 = p * u + (T2[f2] || 0), v2[f2] = A2 / F | 0, p = A2 % F | 0;
        d = p || f2 < D;
      } else {
        for ((p = u / (F[0] + 1) | 0) > 1 && (F = e2(F, p, u), T2 = e2(T2, p, u), $2 = F.length, D = T2.length), N = $2, b2 = (x2 = T2.slice(0, $2)).length; b2 < $2; ) x2[b2++] = 0;
        (S2 = F.slice()).unshift(0), E = F[0], F[1] >= u / 2 && ++E;
        do {
          p = 0, (c2 = t2(F, x2, $2, b2)) < 0 ? (_2 = x2[0], $2 != b2 && (_2 = _2 * u + (x2[1] || 0)), (p = _2 / E | 0) > 1 ? (p >= u && (p = u - 1), 1 == (c2 = t2(h = e2(F, p, u), x2, g = h.length, b2 = x2.length)) && (p--, r(h, $2 < g ? S2 : F, g, u))) : (0 == p && (c2 = p = 1), h = F.slice()), (g = h.length) < b2 && h.unshift(0), r(x2, h, b2, u), -1 == c2 && (c2 = t2(F, x2, $2, b2 = x2.length)) < 1 && (p++, r(x2, $2 < b2 ? S2 : F, b2, u)), b2 = x2.length) : 0 === c2 && (p++, x2 = [0]), v2[f2++] = p, c2 && x2[0] ? x2[b2++] = T2[N] || 0 : (x2 = [T2[N]], b2 = 1);
        } while ((N++ < D || void 0 !== x2[0]) && w2--);
        d = void 0 !== x2[0];
      }
      v2[0] || v2.shift();
    }
    if (1 == m) y.e = l, inexact = d;
    else {
      for (f2 = 1, p = v2[0]; p >= 10; p /= 10) f2++;
      y.e = f2 + l * m - 1, finalise(y, s ? a + y.e + 1 : a, o, d);
    }
    return y;
  };
})();
function finalise(e2, t2, r, n) {
  var i2, a, o, s, u, c2, l, f2, p, m = e2.constructor;
  e: if (null != t2) {
    if (!(f2 = e2.d)) return e2;
    for (i2 = 1, s = f2[0]; s >= 10; s /= 10) i2++;
    if ((a = t2 - i2) < 0) a += LOG_BASE, o = t2, u = (l = f2[p = 0]) / mathpow(10, i2 - o - 1) % 10 | 0;
    else if ((p = Math.ceil((a + 1) / LOG_BASE)) >= (s = f2.length)) {
      if (!n) break e;
      for (; s++ <= p; ) f2.push(0);
      l = u = 0, i2 = 1, o = (a %= LOG_BASE) - LOG_BASE + 1;
    } else {
      for (l = s = f2[p], i2 = 1; s >= 10; s /= 10) i2++;
      u = (o = (a %= LOG_BASE) - LOG_BASE + i2) < 0 ? 0 : l / mathpow(10, i2 - o - 1) % 10 | 0;
    }
    if (n = n || t2 < 0 || void 0 !== f2[p + 1] || (o < 0 ? l : l % mathpow(10, i2 - o - 1)), c2 = r < 4 ? (u || n) && (0 == r || r == (e2.s < 0 ? 3 : 2)) : u > 5 || 5 == u && (4 == r || n || 6 == r && (a > 0 ? o > 0 ? l / mathpow(10, i2 - o) : 0 : f2[p - 1]) % 10 & 1 || r == (e2.s < 0 ? 8 : 7)), t2 < 1 || !f2[0]) return f2.length = 0, c2 ? (t2 -= e2.e + 1, f2[0] = mathpow(10, (LOG_BASE - t2 % LOG_BASE) % LOG_BASE), e2.e = -t2 || 0) : f2[0] = e2.e = 0, e2;
    if (0 == a ? (f2.length = p, s = 1, p--) : (f2.length = p + 1, s = mathpow(10, LOG_BASE - a), f2[p] = o > 0 ? (l / mathpow(10, i2 - o) % mathpow(10, o) | 0) * s : 0), c2) for (; ; ) {
      if (0 == p) {
        for (a = 1, o = f2[0]; o >= 10; o /= 10) a++;
        for (o = f2[0] += s, s = 1; o >= 10; o /= 10) s++;
        a != s && (e2.e++, f2[0] == BASE && (f2[0] = 1));
        break;
      }
      if (f2[p] += s, f2[p] != BASE) break;
      f2[p--] = 0, s = 1;
    }
    for (a = f2.length; 0 === f2[--a]; ) f2.pop();
  }
  return external && (e2.e > m.maxE ? (e2.d = null, e2.e = NaN) : e2.e < m.minE && (e2.e = 0, e2.d = [0])), e2;
}
function finiteToString(e2, t2, r) {
  if (!e2.isFinite()) return nonFiniteToString(e2);
  var n, i2 = e2.e, a = digitsToString(e2.d), o = a.length;
  return t2 ? (r && (n = r - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + getZeroString(n) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (e2.e < 0 ? "e" : "e+") + e2.e) : i2 < 0 ? (a = "0." + getZeroString(-i2 - 1) + a, r && (n = r - o) > 0 && (a += getZeroString(n))) : i2 >= o ? (a += getZeroString(i2 + 1 - o), r && (n = r - i2 - 1) > 0 && (a = a + "." + getZeroString(n))) : ((n = i2 + 1) < o && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - o) > 0 && (i2 + 1 === o && (a += "."), a += getZeroString(n))), a;
}
function getBase10Exponent(e2, t2) {
  var r = e2[0];
  for (t2 *= LOG_BASE; r >= 10; r /= 10) t2++;
  return t2;
}
function getLn10(e2, t2, r) {
  if (t2 > LN10_PRECISION) throw external = true, r && (e2.precision = r), Error(precisionLimitExceeded);
  return finalise(new e2(LN10), t2, 1, true);
}
function getPi(e2, t2, r) {
  if (t2 > PI_PRECISION) throw Error(precisionLimitExceeded);
  return finalise(new e2(PI), t2, r, true);
}
function getPrecision(e2) {
  var t2 = e2.length - 1, r = t2 * LOG_BASE + 1;
  if (t2 = e2[t2]) {
    for (; t2 % 10 == 0; t2 /= 10) r--;
    for (t2 = e2[0]; t2 >= 10; t2 /= 10) r++;
  }
  return r;
}
function getZeroString(e2) {
  for (var t2 = ""; e2--; ) t2 += "0";
  return t2;
}
function intPow(e2, t2, r, n) {
  var i2, a = new e2(1), o = Math.ceil(n / LOG_BASE + 4);
  for (external = false; ; ) {
    if (r % 2 && truncate((a = a.times(t2)).d, o) && (i2 = true), 0 === (r = mathfloor(r / 2))) {
      r = a.d.length - 1, i2 && 0 === a.d[r] && ++a.d[r];
      break;
    }
    truncate((t2 = t2.times(t2)).d, o);
  }
  return external = true, a;
}
function isOdd(e2) {
  return 1 & e2.d[e2.d.length - 1];
}
function maxOrMin(e2, t2, r) {
  for (var n, i2 = new e2(t2[0]), a = 0; ++a < t2.length; ) {
    if (!(n = new e2(t2[a])).s) {
      i2 = n;
      break;
    }
    i2[r](n) && (i2 = n);
  }
  return i2;
}
function naturalExponential(e2, t2) {
  var r, n, i2, a, o, s, u, c2 = 0, l = 0, f2 = 0, p = e2.constructor, m = p.rounding, d = p.precision;
  if (!e2.d || !e2.d[0] || e2.e > 17) return new p(e2.d ? e2.d[0] ? e2.s < 0 ? 0 : 1 / 0 : 1 : e2.s ? e2.s < 0 ? 0 : e2 : NaN);
  for (null == t2 ? (external = false, u = d) : u = t2, s = new p(0.03125); e2.e > -2; ) e2 = e2.times(s), f2 += 5;
  for (u += n = Math.log(mathpow(2, f2)) / Math.LN10 * 2 + 5 | 0, r = a = o = new p(1), p.precision = u; ; ) {
    if (a = finalise(a.times(e2), u, 1), r = r.times(++l), digitsToString((s = o.plus(divide$1(a, r, u, 1))).d).slice(0, u) === digitsToString(o.d).slice(0, u)) {
      for (i2 = f2; i2--; ) o = finalise(o.times(o), u, 1);
      if (null != t2) return p.precision = d, o;
      if (!(c2 < 3 && checkRoundingDigits(o.d, u - n, m, c2))) return finalise(o, p.precision = d, m, external = true);
      p.precision = u += 10, r = a = s = new p(1), l = 0, c2++;
    }
    o = s;
  }
}
function naturalLogarithm(e2, t2) {
  var r, n, i2, a, o, s, u, c2, l, f2, p, m = 1, d = e2, h = d.d, g = d.constructor, y = g.rounding, v2 = g.precision;
  if (d.s < 0 || !h || !h[0] || !d.e && 1 == h[0] && 1 == h.length) return new g(h && !h[0] ? -1 / 0 : 1 != d.s ? NaN : h ? 0 : d);
  if (null == t2 ? (external = false, l = v2) : l = t2, g.precision = l += 10, n = (r = digitsToString(h)).charAt(0), !(Math.abs(a = d.e) < 15e14)) return c2 = getLn10(g, l + 2, v2).times(a + ""), d = naturalLogarithm(new g(n + "." + r.slice(1)), l - 10).plus(c2), g.precision = v2, null == t2 ? finalise(d, v2, y, external = true) : d;
  for (; n < 7 && 1 != n || 1 == n && r.charAt(1) > 3; ) n = (r = digitsToString((d = d.times(e2)).d)).charAt(0), m++;
  for (a = d.e, n > 1 ? (d = new g("0." + r), a++) : d = new g(n + "." + r.slice(1)), f2 = d, u = o = d = divide$1(d.minus(1), d.plus(1), l, 1), p = finalise(d.times(d), l, 1), i2 = 3; ; ) {
    if (o = finalise(o.times(p), l, 1), digitsToString((c2 = u.plus(divide$1(o, new g(i2), l, 1))).d).slice(0, l) === digitsToString(u.d).slice(0, l)) {
      if (u = u.times(2), 0 !== a && (u = u.plus(getLn10(g, l + 2, v2).times(a + ""))), u = divide$1(u, new g(m), l, 1), null != t2) return g.precision = v2, u;
      if (!checkRoundingDigits(u.d, l - 10, y, s)) return finalise(u, g.precision = v2, y, external = true);
      g.precision = l += 10, c2 = o = d = divide$1(f2.minus(1), f2.plus(1), l, 1), p = finalise(d.times(d), l, 1), i2 = s = 1;
    }
    u = c2, i2 += 2;
  }
}
function nonFiniteToString(e2) {
  return String(e2.s * e2.s / 0);
}
function parseDecimal(e2, t2) {
  var r, n, i2;
  for ((r = t2.indexOf(".")) > -1 && (t2 = t2.replace(".", "")), (n = t2.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t2.slice(n + 1), t2 = t2.substring(0, n)) : r < 0 && (r = t2.length), n = 0; 48 === t2.charCodeAt(n); n++) ;
  for (i2 = t2.length; 48 === t2.charCodeAt(i2 - 1); --i2) ;
  if (t2 = t2.slice(n, i2)) {
    if (i2 -= n, e2.e = r = r - n - 1, e2.d = [], n = (r + 1) % LOG_BASE, r < 0 && (n += LOG_BASE), n < i2) {
      for (n && e2.d.push(+t2.slice(0, n)), i2 -= LOG_BASE; n < i2; ) e2.d.push(+t2.slice(n, n += LOG_BASE));
      t2 = t2.slice(n), n = LOG_BASE - t2.length;
    } else n -= i2;
    for (; n--; ) t2 += "0";
    e2.d.push(+t2), external && (e2.e > e2.constructor.maxE ? (e2.d = null, e2.e = NaN) : e2.e < e2.constructor.minE && (e2.e = 0, e2.d = [0]));
  } else e2.e = 0, e2.d = [0];
  return e2;
}
function parseOther(e2, t2) {
  var r, n, i2, a, o, s, u, c2, l;
  if (t2.indexOf("_") > -1) {
    if (t2 = t2.replace(/(\d)_(?=\d)/g, "$1"), isDecimal.test(t2)) return parseDecimal(e2, t2);
  } else if ("Infinity" === t2 || "NaN" === t2) return +t2 || (e2.s = NaN), e2.e = NaN, e2.d = null, e2;
  if (isHex.test(t2)) r = 16, t2 = t2.toLowerCase();
  else if (isBinary.test(t2)) r = 2;
  else {
    if (!isOctal.test(t2)) throw Error(invalidArgument + t2);
    r = 8;
  }
  for ((a = t2.search(/p/i)) > 0 ? (u = +t2.slice(a + 1), t2 = t2.substring(2, a)) : t2 = t2.slice(2), o = (a = t2.indexOf(".")) >= 0, n = e2.constructor, o && (a = (s = (t2 = t2.replace(".", "")).length) - a, i2 = intPow(n, new n(r), a, 2 * a)), a = l = (c2 = convertBase(t2, r, BASE)).length - 1; 0 === c2[a]; --a) c2.pop();
  return a < 0 ? new n(0 * e2.s) : (e2.e = getBase10Exponent(c2, l), e2.d = c2, external = false, o && (e2 = divide$1(e2, i2, 4 * s)), u && (e2 = e2.times(Math.abs(u) < 54 ? mathpow(2, u) : Decimal.pow(2, u))), external = true, e2);
}
function sine(e2, t2) {
  var r, n = t2.d.length;
  if (n < 3) return t2.isZero() ? t2 : taylorSeries(e2, 2, t2, t2);
  r = (r = 1.4 * Math.sqrt(n)) > 16 ? 16 : 0 | r, t2 = taylorSeries(e2, 2, t2 = t2.times(1 / tinyPow(5, r)), t2);
  for (var i2, a = new e2(5), o = new e2(16), s = new e2(20); r--; ) i2 = t2.times(t2), t2 = t2.times(a.plus(i2.times(o.times(i2).minus(s))));
  return t2;
}
function taylorSeries(e2, t2, r, n, i2) {
  var a, o, s, u, c2 = e2.precision, l = Math.ceil(c2 / LOG_BASE);
  for (external = false, u = r.times(r), s = new e2(n); ; ) {
    if (o = divide$1(s.times(u), new e2(t2++ * t2++), c2, 1), s = i2 ? n.plus(o) : n.minus(o), n = divide$1(o.times(u), new e2(t2++ * t2++), c2, 1), void 0 !== (o = s.plus(n)).d[l]) {
      for (a = l; o.d[a] === s.d[a] && a--; ) ;
      if (-1 == a) break;
    }
    a = s, s = n, n = o, o = a;
  }
  return external = true, o.d.length = l + 1, o;
}
function tinyPow(e2, t2) {
  for (var r = e2; --t2; ) r *= e2;
  return r;
}
function toLessThanHalfPi(e2, t2) {
  var r, n = t2.s < 0, i2 = getPi(e2, e2.precision, 1), a = i2.times(0.5);
  if ((t2 = t2.abs()).lte(a)) return quadrant = n ? 4 : 1, t2;
  if ((r = t2.divToInt(i2)).isZero()) quadrant = n ? 3 : 2;
  else {
    if ((t2 = t2.minus(r.times(i2))).lte(a)) return quadrant = isOdd(r) ? n ? 2 : 3 : n ? 4 : 1, t2;
    quadrant = isOdd(r) ? n ? 1 : 4 : n ? 3 : 2;
  }
  return t2.minus(i2).abs();
}
function toStringBinary(e2, t2, r, n) {
  var i2, a, o, s, u, c2, l, f2, p, m = e2.constructor, d = void 0 !== r;
  if (d ? (checkInt32(r, 1, MAX_DIGITS), void 0 === n ? n = m.rounding : checkInt32(n, 0, 8)) : (r = m.precision, n = m.rounding), e2.isFinite()) {
    for (d ? (i2 = 2, 16 == t2 ? r = 4 * r - 3 : 8 == t2 && (r = 3 * r - 2)) : i2 = t2, (o = (l = finiteToString(e2)).indexOf(".")) >= 0 && (l = l.replace(".", ""), (p = new m(1)).e = l.length - o, p.d = convertBase(finiteToString(p), 10, i2), p.e = p.d.length), a = u = (f2 = convertBase(l, 10, i2)).length; 0 == f2[--u]; ) f2.pop();
    if (f2[0]) {
      if (o < 0 ? a-- : ((e2 = new m(e2)).d = f2, e2.e = a, f2 = (e2 = divide$1(e2, p, r, n, 0, i2)).d, a = e2.e, c2 = inexact), o = f2[r], s = i2 / 2, c2 = c2 || void 0 !== f2[r + 1], c2 = n < 4 ? (void 0 !== o || c2) && (0 === n || n === (e2.s < 0 ? 3 : 2)) : o > s || o === s && (4 === n || c2 || 6 === n && 1 & f2[r - 1] || n === (e2.s < 0 ? 8 : 7)), f2.length = r, c2) for (; ++f2[--r] > i2 - 1; ) f2[r] = 0, r || (++a, f2.unshift(1));
      for (u = f2.length; !f2[u - 1]; --u) ;
      for (o = 0, l = ""; o < u; o++) l += NUMERALS.charAt(f2[o]);
      if (d) {
        if (u > 1) if (16 == t2 || 8 == t2) {
          for (o = 16 == t2 ? 4 : 3, --u; u % o; u++) l += "0";
          for (u = (f2 = convertBase(l, i2, t2)).length; !f2[u - 1]; --u) ;
          for (o = 1, l = "1."; o < u; o++) l += NUMERALS.charAt(f2[o]);
        } else l = l.charAt(0) + "." + l.slice(1);
        l = l + (a < 0 ? "p" : "p+") + a;
      } else if (a < 0) {
        for (; ++a; ) l = "0" + l;
        l = "0." + l;
      } else if (++a > u) for (a -= u; a--; ) l += "0";
      else a < u && (l = l.slice(0, a) + "." + l.slice(a));
    } else l = d ? "0p+0" : "0";
    l = (16 == t2 ? "0x" : 2 == t2 ? "0b" : 8 == t2 ? "0o" : "") + l;
  } else l = nonFiniteToString(e2);
  return e2.s < 0 ? "-" + l : l;
}
function truncate(e2, t2) {
  if (e2.length > t2) return e2.length = t2, true;
}
function abs$1(e2) {
  return new this(e2).abs();
}
function acos$1(e2) {
  return new this(e2).acos();
}
function acosh$1(e2) {
  return new this(e2).acosh();
}
function add$1(e2, t2) {
  return new this(e2).plus(t2);
}
function asin$1(e2) {
  return new this(e2).asin();
}
function asinh$1(e2) {
  return new this(e2).asinh();
}
function atan$1(e2) {
  return new this(e2).atan();
}
function atanh$1(e2) {
  return new this(e2).atanh();
}
function atan2$1(e2, t2) {
  e2 = new this(e2), t2 = new this(t2);
  var r, n = this.precision, i2 = this.rounding, a = n + 4;
  return e2.s && t2.s ? e2.d || t2.d ? !t2.d || e2.isZero() ? (r = t2.s < 0 ? getPi(this, n, i2) : new this(0)).s = e2.s : !e2.d || t2.isZero() ? (r = getPi(this, a, 1).times(0.5)).s = e2.s : t2.s < 0 ? (this.precision = a, this.rounding = 1, r = this.atan(divide$1(e2, t2, a, 1)), t2 = getPi(this, a, 1), this.precision = n, this.rounding = i2, r = e2.s < 0 ? r.minus(t2) : r.plus(t2)) : r = this.atan(divide$1(e2, t2, a, 1)) : (r = getPi(this, a, 1).times(t2.s > 0 ? 0.25 : 0.75)).s = e2.s : r = new this(NaN), r;
}
function cbrt(e2) {
  return new this(e2).cbrt();
}
function ceil(e2) {
  return finalise(e2 = new this(e2), e2.e + 1, 2);
}
function clamp$1(e2, t2, r) {
  return new this(e2).clamp(t2, r);
}
function config$1(e2) {
  if (!e2 || "object" != typeof e2) throw Error(decimalError + "Object expected");
  var t2, r, n, i2 = true === e2.defaults, a = ["precision", 1, MAX_DIGITS, "rounding", 0, 8, "toExpNeg", -EXP_LIMIT, 0, "toExpPos", 0, EXP_LIMIT, "maxE", 0, EXP_LIMIT, "minE", -EXP_LIMIT, 0, "modulo", 0, 9];
  for (t2 = 0; t2 < a.length; t2 += 3) if (r = a[t2], i2 && (this[r] = DEFAULTS[r]), void 0 !== (n = e2[r])) {
    if (!(mathfloor(n) === n && n >= a[t2 + 1] && n <= a[t2 + 2])) throw Error(invalidArgument + r + ": " + n);
    this[r] = n;
  }
  if (r = "crypto", i2 && (this[r] = DEFAULTS[r]), void 0 !== (n = e2[r])) {
    if (true !== n && false !== n && 0 !== n && 1 !== n) throw Error(invalidArgument + r + ": " + n);
    if (n) {
      if ("undefined" == typeof crypto || !crypto || !crypto.getRandomValues && !crypto.randomBytes) throw Error(cryptoUnavailable);
      this[r] = true;
    } else this[r] = false;
  }
  return this;
}
function cos$1(e2) {
  return new this(e2).cos();
}
function cosh$2(e2) {
  return new this(e2).cosh();
}
function clone$2(e2) {
  var t2, r, n;
  function i2(e3) {
    var t22, r2, n3, a = this;
    if (!(a instanceof i2)) return new i2(e3);
    if (a.constructor = i2, isDecimalInstance(e3)) return a.s = e3.s, void (external ? !e3.d || e3.e > i2.maxE ? (a.e = NaN, a.d = null) : e3.e < i2.minE ? (a.e = 0, a.d = [0]) : (a.e = e3.e, a.d = e3.d.slice()) : (a.e = e3.e, a.d = e3.d ? e3.d.slice() : e3.d));
    if ("number" === (n3 = typeof e3)) {
      if (0 === e3) return a.s = 1 / e3 < 0 ? -1 : 1, a.e = 0, void (a.d = [0]);
      if (e3 < 0 ? (e3 = -e3, a.s = -1) : a.s = 1, e3 === ~~e3 && e3 < 1e7) {
        for (t22 = 0, r2 = e3; r2 >= 10; r2 /= 10) t22++;
        return void (external ? t22 > i2.maxE ? (a.e = NaN, a.d = null) : t22 < i2.minE ? (a.e = 0, a.d = [0]) : (a.e = t22, a.d = [e3]) : (a.e = t22, a.d = [e3]));
      }
      return 0 * e3 != 0 ? (e3 || (a.s = NaN), a.e = NaN, void (a.d = null)) : parseDecimal(a, e3.toString());
    }
    if ("string" !== n3) throw Error(invalidArgument + e3);
    return 45 === (r2 = e3.charCodeAt(0)) ? (e3 = e3.slice(1), a.s = -1) : (43 === r2 && (e3 = e3.slice(1)), a.s = 1), isDecimal.test(e3) ? parseDecimal(a, e3) : parseOther(a, e3);
  }
  if (i2.prototype = P$3, i2.ROUND_UP = 0, i2.ROUND_DOWN = 1, i2.ROUND_CEIL = 2, i2.ROUND_FLOOR = 3, i2.ROUND_HALF_UP = 4, i2.ROUND_HALF_DOWN = 5, i2.ROUND_HALF_EVEN = 6, i2.ROUND_HALF_CEIL = 7, i2.ROUND_HALF_FLOOR = 8, i2.EUCLID = 9, i2.config = i2.set = config$1, i2.clone = clone$2, i2.isDecimal = isDecimalInstance, i2.abs = abs$1, i2.acos = acos$1, i2.acosh = acosh$1, i2.add = add$1, i2.asin = asin$1, i2.asinh = asinh$1, i2.atan = atan$1, i2.atanh = atanh$1, i2.atan2 = atan2$1, i2.cbrt = cbrt, i2.ceil = ceil, i2.clamp = clamp$1, i2.cos = cos$1, i2.cosh = cosh$2, i2.div = div, i2.exp = exp$1, i2.floor = floor$1, i2.hypot = hypot$1, i2.ln = ln, i2.log = log$1, i2.log10 = log10$1, i2.log2 = log2, i2.max = max$1, i2.min = min$1, i2.mod = mod$1, i2.mul = mul, i2.pow = pow$1, i2.random = random$1, i2.round = round$1, i2.sign = sign$1, i2.sin = sin$1, i2.sinh = sinh$2, i2.sqrt = sqrt$1, i2.sub = sub, i2.sum = sum, i2.tan = tan$1, i2.tanh = tanh$1, i2.trunc = trunc$1, void 0 === e2 && (e2 = {}), e2 && true !== e2.defaults) for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], t2 = 0; t2 < n.length; ) e2.hasOwnProperty(r = n[t2++]) || (e2[r] = this[r]);
  return i2.config(e2), i2;
}
function div(e2, t2) {
  return new this(e2).div(t2);
}
function exp$1(e2) {
  return new this(e2).exp();
}
function floor$1(e2) {
  return finalise(e2 = new this(e2), e2.e + 1, 3);
}
function hypot$1() {
  var e2, t2, r = new this(0);
  for (external = false, e2 = 0; e2 < arguments.length; ) if ((t2 = new this(arguments[e2++])).d) r.d && (r = r.plus(t2.times(t2)));
  else {
    if (t2.s) return external = true, new this(1 / 0);
    r = t2;
  }
  return external = true, r.sqrt();
}
function isDecimalInstance(e2) {
  return e2 instanceof Decimal || e2 && e2.toStringTag === tag || false;
}
function ln(e2) {
  return new this(e2).ln();
}
function log$1(e2, t2) {
  return new this(e2).log(t2);
}
function log2(e2) {
  return new this(e2).log(2);
}
function log10$1(e2) {
  return new this(e2).log(10);
}
function max$1() {
  return maxOrMin(this, arguments, "lt");
}
function min$1() {
  return maxOrMin(this, arguments, "gt");
}
function mod$1(e2, t2) {
  return new this(e2).mod(t2);
}
function mul(e2, t2) {
  return new this(e2).mul(t2);
}
function pow$1(e2, t2) {
  return new this(e2).pow(t2);
}
function random$1(e2) {
  var t2, r, n, i2, a = 0, o = new this(1), s = [];
  if (void 0 === e2 ? e2 = this.precision : checkInt32(e2, 1, MAX_DIGITS), n = Math.ceil(e2 / LOG_BASE), this.crypto) if (crypto.getRandomValues) for (t2 = crypto.getRandomValues(new Uint32Array(n)); a < n; ) (i2 = t2[a]) >= 429e7 ? t2[a] = crypto.getRandomValues(new Uint32Array(1))[0] : s[a++] = i2 % 1e7;
  else {
    if (!crypto.randomBytes) throw Error(cryptoUnavailable);
    for (t2 = crypto.randomBytes(n *= 4); a < n; ) (i2 = t2[a] + (t2[a + 1] << 8) + (t2[a + 2] << 16) + ((127 & t2[a + 3]) << 24)) >= 214e7 ? crypto.randomBytes(4).copy(t2, a) : (s.push(i2 % 1e7), a += 4);
    a = n / 4;
  }
  else for (; a < n; ) s[a++] = 1e7 * Math.random() | 0;
  for (n = s[--a], e2 %= LOG_BASE, n && e2 && (i2 = mathpow(10, LOG_BASE - e2), s[a] = (n / i2 | 0) * i2); 0 === s[a]; a--) s.pop();
  if (a < 0) r = 0, s = [0];
  else {
    for (r = -1; 0 === s[0]; r -= LOG_BASE) s.shift();
    for (n = 1, i2 = s[0]; i2 >= 10; i2 /= 10) n++;
    n < LOG_BASE && (r -= LOG_BASE - n);
  }
  return o.e = r, o.d = s, o;
}
function round$1(e2) {
  return finalise(e2 = new this(e2), e2.e + 1, this.rounding);
}
function sign$1(e2) {
  return (e2 = new this(e2)).d ? e2.d[0] ? e2.s : 0 * e2.s : e2.s || NaN;
}
function sin$1(e2) {
  return new this(e2).sin();
}
function sinh$2(e2) {
  return new this(e2).sinh();
}
function sqrt$1(e2) {
  return new this(e2).sqrt();
}
function sub(e2, t2) {
  return new this(e2).sub(t2);
}
function sum() {
  var e2 = 0, t2 = arguments, r = new this(t2[e2]);
  for (external = false; r.s && ++e2 < t2.length; ) r = r.plus(t2[e2]);
  return external = true, finalise(r, this.precision, this.rounding);
}
function tan$1(e2) {
  return new this(e2).tan();
}
function tanh$1(e2) {
  return new this(e2).tanh();
}
function trunc$1(e2) {
  return finalise(e2 = new this(e2), e2.e + 1, 1);
}
P$3[Symbol.for("nodejs.util.inspect.custom")] = P$3.toString, P$3[Symbol.toStringTag] = "Decimal";
var Decimal = P$3.constructor = clone$2(DEFAULTS);
LN10 = new Decimal(LN10), PI = new Decimal(PI);
var name$4_ = "BigNumber", dependencies$4_ = ["?on", "config"], createBigNumberClass = factory(name$4_, dependencies$4_, ((e2) => {
  var { on: t2, config: r } = e2, n = Decimal.clone({ precision: r.precision, modulo: Decimal.EUCLID });
  return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = true, n.prototype.toJSON = function() {
    return { mathjs: "BigNumber", value: this.toString() };
  }, n.fromJSON = function(e3) {
    return new n(e3.value);
  }, t2 && t2("config", (function(e3, t22) {
    e3.precision !== t22.precision && n.config({ precision: e3.precision });
  })), n;
}), { isClass: true });
const cosh$1 = Math.cosh || function(e2) {
  return Math.abs(e2) < 1e-9 ? 1 - e2 : 0.5 * (Math.exp(e2) + Math.exp(-e2));
}, sinh$1 = Math.sinh || function(e2) {
  return Math.abs(e2) < 1e-9 ? e2 : 0.5 * (Math.exp(e2) - Math.exp(-e2));
}, cosm1 = function(e2) {
  const t2 = Math.PI / 4;
  if (-t2 > e2 || e2 > t2) return Math.cos(e2) - 1;
  const r = e2 * e2;
  return r * (r * (r * (r * (r * (r * (r * (r / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 0.5);
}, hypot = function(e2, t2) {
  return (e2 = Math.abs(e2)) < (t2 = Math.abs(t2)) && ([e2, t2] = [t2, e2]), e2 < 1e8 ? Math.sqrt(e2 * e2 + t2 * t2) : (t2 /= e2, e2 * Math.sqrt(1 + t2 * t2));
}, parser_exit = function() {
  throw SyntaxError("Invalid Param");
};
function logHypot(e2, t2) {
  const r = Math.abs(e2), n = Math.abs(t2);
  return 0 === e2 ? Math.log(n) : 0 === t2 ? Math.log(r) : r < 3e3 && n < 3e3 ? 0.5 * Math.log(e2 * e2 + t2 * t2) : (e2 *= 0.5, t2 *= 0.5, 0.5 * Math.log(e2 * e2 + t2 * t2) + Math.LN2);
}
const P$2 = { re: 0, im: 0 }, parse$1 = function(e2, t2) {
  const r = P$2;
  if (null == e2) r.re = r.im = 0;
  else if (void 0 !== t2) r.re = e2, r.im = t2;
  else switch (typeof e2) {
    case "object":
      if ("im" in e2 && "re" in e2) r.re = e2.re, r.im = e2.im;
      else if ("abs" in e2 && "arg" in e2) {
        if (!isFinite(e2.abs) && isFinite(e2.arg)) return Complex.INFINITY;
        r.re = e2.abs * Math.cos(e2.arg), r.im = e2.abs * Math.sin(e2.arg);
      } else if ("r" in e2 && "phi" in e2) {
        if (!isFinite(e2.r) && isFinite(e2.phi)) return Complex.INFINITY;
        r.re = e2.r * Math.cos(e2.phi), r.im = e2.r * Math.sin(e2.phi);
      } else 2 === e2.length ? (r.re = e2[0], r.im = e2[1]) : parser_exit();
      break;
    case "string":
      r.im = r.re = 0;
      const t22 = e2.replace(/_/g, "").match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g);
      let n = 1, i2 = 0;
      null === t22 && parser_exit();
      for (let e3 = 0; e3 < t22.length; e3++) {
        const a = t22[e3];
        " " === a || "	" === a || "\n" === a || ("+" === a ? n++ : "-" === a ? i2++ : "i" === a || "I" === a ? (n + i2 === 0 && parser_exit(), " " === t22[e3 + 1] || isNaN(t22[e3 + 1]) ? r.im += parseFloat((i2 % 2 ? "-" : "") + "1") : (r.im += parseFloat((i2 % 2 ? "-" : "") + t22[e3 + 1]), e3++), n = i2 = 0) : ((n + i2 === 0 || isNaN(a)) && parser_exit(), "i" === t22[e3 + 1] || "I" === t22[e3 + 1] ? (r.im += parseFloat((i2 % 2 ? "-" : "") + a), e3++) : r.re += parseFloat((i2 % 2 ? "-" : "") + a), n = i2 = 0));
      }
      n + i2 > 0 && parser_exit();
      break;
    case "number":
      r.im = 0, r.re = e2;
      break;
    default:
      parser_exit();
  }
  return isNaN(r.re) || isNaN(r.im), r;
};
function Complex(e2, t2) {
  if (!(this instanceof Complex)) return new Complex(e2, t2);
  const r = parse$1(e2, t2);
  this.re = r.re, this.im = r.im;
}
Complex.prototype = { re: 0, im: 0, sign: function() {
  const e2 = hypot(this.re, this.im);
  return new Complex(this.re / e2, this.im / e2);
}, add: function(e2, t2) {
  const r = parse$1(e2, t2), n = this.isInfinite(), i2 = !(isFinite(r.re) && isFinite(r.im));
  return n || i2 ? n && i2 ? Complex.NAN : Complex.INFINITY : new Complex(this.re + r.re, this.im + r.im);
}, sub: function(e2, t2) {
  const r = parse$1(e2, t2), n = this.isInfinite(), i2 = !(isFinite(r.re) && isFinite(r.im));
  return n || i2 ? n && i2 ? Complex.NAN : Complex.INFINITY : new Complex(this.re - r.re, this.im - r.im);
}, mul: function(e2, t2) {
  const r = parse$1(e2, t2), n = this.isInfinite(), i2 = !(isFinite(r.re) && isFinite(r.im)), a = 0 === this.re && 0 === this.im, o = 0 === r.re && 0 === r.im;
  return n && o || i2 && a ? Complex.NAN : n || i2 ? Complex.INFINITY : 0 === r.im && 0 === this.im ? new Complex(this.re * r.re, 0) : new Complex(this.re * r.re - this.im * r.im, this.re * r.im + this.im * r.re);
}, div: function(e2, t2) {
  const r = parse$1(e2, t2), n = this.isInfinite(), i2 = !(isFinite(r.re) && isFinite(r.im)), a = 0 === this.re && 0 === this.im, o = 0 === r.re && 0 === r.im;
  if (a && o || n && i2) return Complex.NAN;
  if (o || n) return Complex.INFINITY;
  if (a || i2) return Complex.ZERO;
  if (0 === r.im) return new Complex(this.re / r.re, this.im / r.re);
  if (Math.abs(r.re) < Math.abs(r.im)) {
    const e3 = r.re / r.im, t22 = r.re * e3 + r.im;
    return new Complex((this.re * e3 + this.im) / t22, (this.im * e3 - this.re) / t22);
  }
  {
    const e3 = r.im / r.re, t22 = r.im * e3 + r.re;
    return new Complex((this.re + this.im * e3) / t22, (this.im - this.re * e3) / t22);
  }
}, pow: function(e2, t2) {
  const r = parse$1(e2, t2), n = 0 === this.re && 0 === this.im;
  if (0 === r.re && 0 === r.im) return Complex.ONE;
  if (0 === r.im) {
    if (0 === this.im && this.re > 0) return new Complex(Math.pow(this.re, r.re), 0);
    if (0 === this.re) switch ((r.re % 4 + 4) % 4) {
      case 0:
        return new Complex(Math.pow(this.im, r.re), 0);
      case 1:
        return new Complex(0, Math.pow(this.im, r.re));
      case 2:
        return new Complex(-Math.pow(this.im, r.re), 0);
      case 3:
        return new Complex(0, -Math.pow(this.im, r.re));
    }
  }
  if (n && r.re > 0) return Complex.ZERO;
  const i2 = Math.atan2(this.im, this.re), a = logHypot(this.re, this.im);
  let o = Math.exp(r.re * a - r.im * i2), s = r.im * a + r.re * i2;
  return new Complex(o * Math.cos(s), o * Math.sin(s));
}, sqrt: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === t2) return e2 >= 0 ? new Complex(Math.sqrt(e2), 0) : new Complex(0, Math.sqrt(-e2));
  const r = hypot(e2, t2);
  let n = Math.sqrt(0.5 * (r + Math.abs(e2))), i2 = Math.abs(t2) / (2 * n);
  return e2 >= 0 ? new Complex(n, t2 < 0 ? -i2 : i2) : new Complex(i2, t2 < 0 ? -n : n);
}, exp: function() {
  const e2 = Math.exp(this.re);
  return 0 === this.im ? new Complex(e2, 0) : new Complex(e2 * Math.cos(this.im), e2 * Math.sin(this.im));
}, expm1: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex(Math.expm1(e2) * Math.cos(t2) + cosm1(t2), Math.exp(e2) * Math.sin(t2));
}, log: function() {
  const e2 = this.re, t2 = this.im;
  return 0 === t2 && e2 > 0 ? new Complex(Math.log(e2), 0) : new Complex(logHypot(e2, t2), Math.atan2(t2, e2));
}, abs: function() {
  return hypot(this.re, this.im);
}, arg: function() {
  return Math.atan2(this.im, this.re);
}, sin: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex(Math.sin(e2) * cosh$1(t2), Math.cos(e2) * sinh$1(t2));
}, cos: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex(Math.cos(e2) * cosh$1(t2), -Math.sin(e2) * sinh$1(t2));
}, tan: function() {
  const e2 = 2 * this.re, t2 = 2 * this.im, r = Math.cos(e2) + cosh$1(t2);
  return new Complex(Math.sin(e2) / r, sinh$1(t2) / r);
}, cot: function() {
  const e2 = 2 * this.re, t2 = 2 * this.im, r = Math.cos(e2) - cosh$1(t2);
  return new Complex(-Math.sin(e2) / r, sinh$1(t2) / r);
}, sec: function() {
  const e2 = this.re, t2 = this.im, r = 0.5 * cosh$1(2 * t2) + 0.5 * Math.cos(2 * e2);
  return new Complex(Math.cos(e2) * cosh$1(t2) / r, Math.sin(e2) * sinh$1(t2) / r);
}, csc: function() {
  const e2 = this.re, t2 = this.im, r = 0.5 * cosh$1(2 * t2) - 0.5 * Math.cos(2 * e2);
  return new Complex(Math.sin(e2) * cosh$1(t2) / r, -Math.cos(e2) * sinh$1(t2) / r);
}, asin: function() {
  const e2 = this.re, t2 = this.im, r = new Complex(t2 * t2 - e2 * e2 + 1, -2 * e2 * t2).sqrt(), n = new Complex(r.re - t2, r.im + e2).log();
  return new Complex(n.im, -n.re);
}, acos: function() {
  const e2 = this.re, t2 = this.im, r = new Complex(t2 * t2 - e2 * e2 + 1, -2 * e2 * t2).sqrt(), n = new Complex(r.re - t2, r.im + e2).log();
  return new Complex(Math.PI / 2 - n.im, n.re);
}, atan: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === e2) {
    if (1 === t2) return new Complex(0, 1 / 0);
    if (-1 === t2) return new Complex(0, -1 / 0);
  }
  const r = e2 * e2 + (1 - t2) * (1 - t2), n = new Complex((1 - t2 * t2 - e2 * e2) / r, -2 * e2 / r).log();
  return new Complex(-0.5 * n.im, 0.5 * n.re);
}, acot: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === t2) return new Complex(Math.atan2(1, e2), 0);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex(e2 / r, -t2 / r).atan() : new Complex(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).atan();
}, asec: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === e2 && 0 === t2) return new Complex(0, 1 / 0);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex(e2 / r, -t2 / r).acos() : new Complex(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).acos();
}, acsc: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === e2 && 0 === t2) return new Complex(Math.PI / 2, 1 / 0);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex(e2 / r, -t2 / r).asin() : new Complex(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).asin();
}, sinh: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex(sinh$1(e2) * Math.cos(t2), cosh$1(e2) * Math.sin(t2));
}, cosh: function() {
  const e2 = this.re, t2 = this.im;
  return new Complex(cosh$1(e2) * Math.cos(t2), sinh$1(e2) * Math.sin(t2));
}, tanh: function() {
  const e2 = 2 * this.re, t2 = 2 * this.im, r = cosh$1(e2) + Math.cos(t2);
  return new Complex(sinh$1(e2) / r, Math.sin(t2) / r);
}, coth: function() {
  const e2 = 2 * this.re, t2 = 2 * this.im, r = cosh$1(e2) - Math.cos(t2);
  return new Complex(sinh$1(e2) / r, -Math.sin(t2) / r);
}, csch: function() {
  const e2 = this.re, t2 = this.im, r = Math.cos(2 * t2) - cosh$1(2 * e2);
  return new Complex(-2 * sinh$1(e2) * Math.cos(t2) / r, 2 * cosh$1(e2) * Math.sin(t2) / r);
}, sech: function() {
  const e2 = this.re, t2 = this.im, r = Math.cos(2 * t2) + cosh$1(2 * e2);
  return new Complex(2 * cosh$1(e2) * Math.cos(t2) / r, -2 * sinh$1(e2) * Math.sin(t2) / r);
}, asinh: function() {
  let e2 = this.im;
  this.im = -this.re, this.re = e2;
  const t2 = this.asin();
  return this.re = -this.im, this.im = e2, e2 = t2.re, t2.re = -t2.im, t2.im = e2, t2;
}, acosh: function() {
  const e2 = this.acos();
  if (e2.im <= 0) {
    const t2 = e2.re;
    e2.re = -e2.im, e2.im = t2;
  } else {
    const t2 = e2.im;
    e2.im = -e2.re, e2.re = t2;
  }
  return e2;
}, atanh: function() {
  const e2 = this.re, t2 = this.im, r = e2 > 1 && 0 === t2, n = 1 - e2, i2 = 1 + e2, a = n * n + t2 * t2, o = 0 !== a ? new Complex((i2 * n - t2 * t2) / a, (t2 * n + i2 * t2) / a) : new Complex(-1 !== e2 ? e2 / 0 : 0, 0 !== t2 ? t2 / 0 : 0), s = o.re;
  return o.re = logHypot(o.re, o.im) / 2, o.im = Math.atan2(o.im, s) / 2, r && (o.im = -o.im), o;
}, acoth: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === e2 && 0 === t2) return new Complex(0, Math.PI / 2);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex(e2 / r, -t2 / r).atanh() : new Complex(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).atanh();
}, acsch: function() {
  const e2 = this.re, t2 = this.im;
  if (0 === t2) return new Complex(0 !== e2 ? Math.log(e2 + Math.sqrt(e2 * e2 + 1)) : 1 / 0, 0);
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex(e2 / r, -t2 / r).asinh() : new Complex(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).asinh();
}, asech: function() {
  const e2 = this.re, t2 = this.im;
  if (this.isZero()) return Complex.INFINITY;
  const r = e2 * e2 + t2 * t2;
  return 0 !== r ? new Complex(e2 / r, -t2 / r).acosh() : new Complex(0 !== e2 ? e2 / 0 : 0, 0 !== t2 ? -t2 / 0 : 0).acosh();
}, inverse: function() {
  if (this.isZero()) return Complex.INFINITY;
  if (this.isInfinite()) return Complex.ZERO;
  const e2 = this.re, t2 = this.im, r = e2 * e2 + t2 * t2;
  return new Complex(e2 / r, -t2 / r);
}, conjugate: function() {
  return new Complex(this.re, -this.im);
}, neg: function() {
  return new Complex(-this.re, -this.im);
}, ceil: function(e2) {
  return e2 = Math.pow(10, e2 || 0), new Complex(Math.ceil(this.re * e2) / e2, Math.ceil(this.im * e2) / e2);
}, floor: function(e2) {
  return e2 = Math.pow(10, e2 || 0), new Complex(Math.floor(this.re * e2) / e2, Math.floor(this.im * e2) / e2);
}, round: function(e2) {
  return e2 = Math.pow(10, e2 || 0), new Complex(Math.round(this.re * e2) / e2, Math.round(this.im * e2) / e2);
}, equals: function(e2, t2) {
  const r = parse$1(e2, t2);
  return Math.abs(r.re - this.re) <= Complex.EPSILON && Math.abs(r.im - this.im) <= Complex.EPSILON;
}, clone: function() {
  return new Complex(this.re, this.im);
}, toString: function() {
  let e2 = this.re, t2 = this.im, r = "";
  return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(e2) < Complex.EPSILON && (e2 = 0), Math.abs(t2) < Complex.EPSILON && (t2 = 0), 0 === t2 ? r + e2 : (0 !== e2 ? (r += e2, r += " ", t2 < 0 ? (t2 = -t2, r += "-") : r += "+", r += " ") : t2 < 0 && (t2 = -t2, r += "-"), 1 !== t2 && (r += t2), r + "i"));
}, toVector: function() {
  return [this.re, this.im];
}, valueOf: function() {
  return 0 === this.im ? this.re : null;
}, isNaN: function() {
  return isNaN(this.re) || isNaN(this.im);
}, isZero: function() {
  return 0 === this.im && 0 === this.re;
}, isFinite: function() {
  return isFinite(this.re) && isFinite(this.im);
}, isInfinite: function() {
  return !this.isFinite();
} }, Complex.ZERO = new Complex(0, 0), Complex.ONE = new Complex(1, 0), Complex.I = new Complex(0, 1), Complex.PI = new Complex(Math.PI, 0), Complex.E = new Complex(Math.E, 0), Complex.INFINITY = new Complex(1 / 0, 1 / 0), Complex.NAN = new Complex(NaN, NaN), Complex.EPSILON = 1e-15;
var name$4Z = "Complex", dependencies$4Z = [], createComplexClass = factory(name$4Z, dependencies$4Z, (() => (Object.defineProperty(Complex, "name", { value: "Complex" }), Complex.prototype.constructor = Complex, Complex.prototype.type = "Complex", Complex.prototype.isComplex = true, Complex.prototype.toJSON = function() {
  return { mathjs: "Complex", re: this.re, im: this.im };
}, Complex.prototype.toPolar = function() {
  return { r: this.abs(), phi: this.arg() };
}, Complex.prototype.format = function(e2) {
  var t2 = this.im, r = this.re, n = format$2(this.re, e2), i2 = format$2(this.im, e2), a = isNumber$1(e2) ? e2 : e2 ? e2.precision : null;
  if (null !== a) {
    var o = Math.pow(10, -a);
    Math.abs(r / t2) < o && (r = 0), Math.abs(t2 / r) < o && (t2 = 0);
  }
  return 0 === t2 ? n : 0 === r ? 1 === t2 ? "i" : -1 === t2 ? "-i" : i2 + "i" : t2 < 0 ? -1 === t2 ? n + " - i" : n + " - " + i2.substring(1) + "i" : 1 === t2 ? n + " + i" : n + " + " + i2 + "i";
}, Complex.fromPolar = function(e2) {
  switch (arguments.length) {
    case 1:
      var t2 = arguments[0];
      if ("object" == typeof t2) return Complex(t2);
      throw new TypeError("Input has to be an object with r and phi keys.");
    case 2:
      var r = arguments[0], n = arguments[1];
      if (isNumber$1(r)) {
        if (isUnit(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), isNumber$1(n)) return new Complex({ r, phi: n });
        throw new TypeError("Phi is not a number nor an angle unit.");
      }
      throw new TypeError("Radius r is not a number.");
    default:
      throw new SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, Complex.prototype.valueOf = Complex.prototype.toString, Complex.fromJSON = function(e2) {
  return new Complex(e2);
}, Complex.compare = function(e2, t2) {
  return e2.re > t2.re ? 1 : e2.re < t2.re ? -1 : e2.im > t2.im ? 1 : e2.im < t2.im ? -1 : 0;
}, Complex)), { isClass: true });
"undefined" == typeof BigInt && (BigInt = function(e2) {
  if (isNaN(e2)) throw new Error("");
  return e2;
});
const C_ZERO = BigInt(0), C_ONE = BigInt(1), C_TWO = BigInt(2), C_FIVE = BigInt(5), C_TEN = BigInt(10), MAX_CYCLE_LEN = 2e3, P$1 = { s: C_ONE, n: C_ZERO, d: C_ONE };
function assign(e2, t2) {
  try {
    e2 = BigInt(e2);
  } catch (e3) {
    throw InvalidParameter();
  }
  return e2 * t2;
}
function trunc(e2) {
  return "bigint" == typeof e2 ? e2 : Math.floor(e2);
}
function newFraction(e2, t2) {
  if (t2 === C_ZERO) throw DivisionByZero();
  const r = Object.create(Fraction.prototype);
  r.s = e2 < C_ZERO ? -C_ONE : C_ONE;
  const n = gcd$2(e2 = e2 < C_ZERO ? -e2 : e2, t2);
  return r.n = e2 / n, r.d = t2 / n, r;
}
function factorize(e2) {
  const t2 = {};
  let r = e2, n = C_TWO, i2 = C_FIVE - C_ONE;
  for (; i2 <= r; ) {
    for (; r % n === C_ZERO; ) r /= n, t2[n] = (t2[n] || C_ZERO) + C_ONE;
    i2 += C_ONE + C_TWO * n++;
  }
  return r !== e2 ? r > 1 && (t2[r] = (t2[r] || C_ZERO) + C_ONE) : t2[e2] = (t2[e2] || C_ZERO) + C_ONE, t2;
}
const parse$2 = function(e2, t2) {
  let r = C_ZERO, n = C_ONE, i2 = C_ONE;
  if (null == e2) ;
  else if (void 0 !== t2) {
    if ("bigint" == typeof e2) r = e2;
    else {
      if (isNaN(e2)) throw InvalidParameter();
      if (e2 % 1 != 0) throw NonIntegerParameter();
      r = BigInt(e2);
    }
    if ("bigint" == typeof t2) n = t2;
    else {
      if (isNaN(t2)) throw InvalidParameter();
      if (t2 % 1 != 0) throw NonIntegerParameter();
      n = BigInt(t2);
    }
    i2 = r * n;
  } else if ("object" == typeof e2) {
    if ("d" in e2 && "n" in e2) r = BigInt(e2.n), n = BigInt(e2.d), "s" in e2 && (r *= BigInt(e2.s));
    else if (0 in e2) r = BigInt(e2[0]), 1 in e2 && (n = BigInt(e2[1]));
    else {
      if ("bigint" != typeof e2) throw InvalidParameter();
      r = e2;
    }
    i2 = r * n;
  } else if ("number" == typeof e2) {
    if (isNaN(e2)) throw InvalidParameter();
    if (e2 < 0 && (i2 = -C_ONE, e2 = -e2), e2 % 1 == 0) r = BigInt(e2);
    else {
      let t22 = 1, i22 = 0, a = 1, o = 1, s = 1, u = 1e7;
      for (e2 >= 1 && (t22 = 10 ** Math.floor(1 + Math.log10(e2)), e2 /= t22); a <= u && s <= u; ) {
        let t3 = (i22 + o) / (a + s);
        if (e2 === t3) {
          a + s <= u ? (r = i22 + o, n = a + s) : s > a ? (r = o, n = s) : (r = i22, n = a);
          break;
        }
        e2 > t3 ? (i22 += o, a += s) : (o += i22, s += a), a > u ? (r = o, n = s) : (r = i22, n = a);
      }
      r = BigInt(r) * BigInt(t22), n = BigInt(n);
    }
  } else if ("string" == typeof e2) {
    let t22 = 0, a = C_ZERO, o = C_ZERO, s = C_ZERO, u = C_ONE, c2 = C_ONE, l = e2.replace(/_/g, "").match(/\d+|./g);
    if (null === l) throw InvalidParameter();
    if ("-" === l[t22] ? (i2 = -C_ONE, t22++) : "+" === l[t22] && t22++, l.length === t22 + 1 ? o = assign(l[t22++], i2) : "." === l[t22 + 1] || "." === l[t22] ? ("." !== l[t22] && (a = assign(l[t22++], i2)), t22++, (t22 + 1 === l.length || "(" === l[t22 + 1] && ")" === l[t22 + 3] || "'" === l[t22 + 1] && "'" === l[t22 + 3]) && (o = assign(l[t22], i2), u = C_TEN ** BigInt(l[t22].length), t22++), ("(" === l[t22] && ")" === l[t22 + 2] || "'" === l[t22] && "'" === l[t22 + 2]) && (s = assign(l[t22 + 1], i2), c2 = C_TEN ** BigInt(l[t22 + 1].length) - C_ONE, t22 += 3)) : "/" === l[t22 + 1] || ":" === l[t22 + 1] ? (o = assign(l[t22], i2), u = assign(l[t22 + 2], C_ONE), t22 += 3) : "/" === l[t22 + 3] && " " === l[t22 + 1] && (a = assign(l[t22], i2), o = assign(l[t22 + 2], i2), u = assign(l[t22 + 4], C_ONE), t22 += 5), !(l.length <= t22)) throw InvalidParameter();
    n = u * c2, i2 = r = s + n * a + c2 * o;
  } else {
    if ("bigint" != typeof e2) throw InvalidParameter();
    r = e2, i2 = e2, n = C_ONE;
  }
  if (n === C_ZERO) throw DivisionByZero();
  P$1.s = i2 < C_ZERO ? -C_ONE : C_ONE, P$1.n = r < C_ZERO ? -r : r, P$1.d = n < C_ZERO ? -n : n;
};
function modpow(e2, t2, r) {
  let n = C_ONE;
  for (; t2 > C_ZERO; e2 = e2 * e2 % r, t2 >>= C_ONE) t2 & C_ONE && (n = n * e2 % r);
  return n;
}
function cycleLen(e2, t2) {
  for (; t2 % C_TWO === C_ZERO; t2 /= C_TWO) ;
  for (; t2 % C_FIVE === C_ZERO; t2 /= C_FIVE) ;
  if (t2 === C_ONE) return C_ZERO;
  let r = C_TEN % t2, n = 1;
  for (; r !== C_ONE; n++) if (r = r * C_TEN % t2, n > MAX_CYCLE_LEN) return C_ZERO;
  return BigInt(n);
}
function cycleStart(e2, t2, r) {
  let n = C_ONE, i2 = modpow(C_TEN, r, t2);
  for (let e3 = 0; e3 < 300; e3++) {
    if (n === i2) return BigInt(e3);
    n = n * C_TEN % t2, i2 = i2 * C_TEN % t2;
  }
  return 0;
}
function gcd$2(e2, t2) {
  if (!e2) return t2;
  if (!t2) return e2;
  for (; ; ) {
    if (!(e2 %= t2)) return t2;
    if (!(t2 %= e2)) return e2;
  }
}
function Fraction(e2, t2) {
  if (parse$2(e2, t2), !(this instanceof Fraction)) return newFraction(P$1.s * P$1.n, P$1.d);
  e2 = gcd$2(P$1.d, P$1.n), this.s = P$1.s, this.n = P$1.n / e2, this.d = P$1.d / e2;
}
var DivisionByZero = function() {
  return new Error("Division by Zero");
}, InvalidParameter = function() {
  return new Error("Invalid argument");
}, NonIntegerParameter = function() {
  return new Error("Parameters must be integer");
};
Fraction.prototype = { s: C_ONE, n: C_ZERO, d: C_ONE, abs: function() {
  return newFraction(this.n, this.d);
}, neg: function() {
  return newFraction(-this.s * this.n, this.d);
}, add: function(e2, t2) {
  return parse$2(e2, t2), newFraction(this.s * this.n * P$1.d + P$1.s * this.d * P$1.n, this.d * P$1.d);
}, sub: function(e2, t2) {
  return parse$2(e2, t2), newFraction(this.s * this.n * P$1.d - P$1.s * this.d * P$1.n, this.d * P$1.d);
}, mul: function(e2, t2) {
  return parse$2(e2, t2), newFraction(this.s * P$1.s * this.n * P$1.n, this.d * P$1.d);
}, div: function(e2, t2) {
  return parse$2(e2, t2), newFraction(this.s * P$1.s * this.n * P$1.d, this.d * P$1.n);
}, clone: function() {
  return newFraction(this.s * this.n, this.d);
}, mod: function(e2, t2) {
  if (void 0 === e2) return newFraction(this.s * this.n % this.d, C_ONE);
  if (parse$2(e2, t2), C_ZERO === P$1.n * this.d) throw DivisionByZero();
  return newFraction(this.s * (P$1.d * this.n) % (P$1.n * this.d), P$1.d * this.d);
}, gcd: function(e2, t2) {
  return parse$2(e2, t2), newFraction(gcd$2(P$1.n, this.n) * gcd$2(P$1.d, this.d), P$1.d * this.d);
}, lcm: function(e2, t2) {
  return parse$2(e2, t2), P$1.n === C_ZERO && this.n === C_ZERO ? newFraction(C_ZERO, C_ONE) : newFraction(P$1.n * this.n, gcd$2(P$1.n, this.n) * gcd$2(P$1.d, this.d));
}, inverse: function() {
  return newFraction(this.s * this.d, this.n);
}, pow: function(e2, t2) {
  if (parse$2(e2, t2), P$1.d === C_ONE) return P$1.s < C_ZERO ? newFraction((this.s * this.d) ** P$1.n, this.n ** P$1.n) : newFraction((this.s * this.n) ** P$1.n, this.d ** P$1.n);
  if (this.s < C_ZERO) return null;
  let r = factorize(this.n), n = factorize(this.d), i2 = C_ONE, a = C_ONE;
  for (let e3 in r) if ("1" !== e3) {
    if ("0" === e3) {
      i2 = C_ZERO;
      break;
    }
    if (r[e3] *= P$1.n, r[e3] % P$1.d !== C_ZERO) return null;
    r[e3] /= P$1.d, i2 *= BigInt(e3) ** r[e3];
  }
  for (let e3 in n) if ("1" !== e3) {
    if (n[e3] *= P$1.n, n[e3] % P$1.d !== C_ZERO) return null;
    n[e3] /= P$1.d, a *= BigInt(e3) ** n[e3];
  }
  return P$1.s < C_ZERO ? newFraction(a, i2) : newFraction(i2, a);
}, log: function(e2, t2) {
  if (parse$2(e2, t2), this.s <= C_ZERO || P$1.s <= C_ZERO) return null;
  const r = {}, n = factorize(P$1.n), i2 = factorize(P$1.d), a = factorize(this.n), o = factorize(this.d);
  for (const e3 in i2) n[e3] = (n[e3] || C_ZERO) - i2[e3];
  for (const e3 in o) a[e3] = (a[e3] || C_ZERO) - o[e3];
  for (const e3 in n) "1" !== e3 && (r[e3] = true);
  for (const e3 in a) "1" !== e3 && (r[e3] = true);
  let s = null, u = null;
  for (const e3 in r) {
    const t22 = n[e3] || C_ZERO, r2 = a[e3] || C_ZERO;
    if (t22 === C_ZERO) {
      if (r2 !== C_ZERO) return null;
      continue;
    }
    let i22 = r2, o2 = t22;
    const c2 = gcd$2(i22, o2);
    if (i22 /= c2, o2 /= c2, null === s && null === u) s = i22, u = o2;
    else if (i22 * u != s * o2) return null;
  }
  return null !== s && null !== u ? newFraction(s, u) : null;
}, equals: function(e2, t2) {
  return parse$2(e2, t2), this.s * this.n * P$1.d == P$1.s * P$1.n * this.d;
}, lt: function(e2, t2) {
  return parse$2(e2, t2), this.s * this.n * P$1.d < P$1.s * P$1.n * this.d;
}, lte: function(e2, t2) {
  return parse$2(e2, t2), this.s * this.n * P$1.d <= P$1.s * P$1.n * this.d;
}, gt: function(e2, t2) {
  return parse$2(e2, t2), this.s * this.n * P$1.d > P$1.s * P$1.n * this.d;
}, gte: function(e2, t2) {
  return parse$2(e2, t2), this.s * this.n * P$1.d >= P$1.s * P$1.n * this.d;
}, compare: function(e2, t2) {
  parse$2(e2, t2);
  let r = this.s * this.n * P$1.d - P$1.s * P$1.n * this.d;
  return (C_ZERO < r) - (r < C_ZERO);
}, ceil: function(e2) {
  return e2 = C_TEN ** BigInt(e2 || 0), newFraction(trunc(this.s * e2 * this.n / this.d) + (e2 * this.n % this.d > C_ZERO && this.s >= C_ZERO ? C_ONE : C_ZERO), e2);
}, floor: function(e2) {
  return e2 = C_TEN ** BigInt(e2 || 0), newFraction(trunc(this.s * e2 * this.n / this.d) - (e2 * this.n % this.d > C_ZERO && this.s < C_ZERO ? C_ONE : C_ZERO), e2);
}, round: function(e2) {
  return e2 = C_TEN ** BigInt(e2 || 0), newFraction(trunc(this.s * e2 * this.n / this.d) + this.s * ((this.s >= C_ZERO ? C_ONE : C_ZERO) + C_TWO * (e2 * this.n % this.d) > this.d ? C_ONE : C_ZERO), e2);
}, roundTo: function(e2, t2) {
  parse$2(e2, t2);
  const r = this.n * P$1.d, n = this.d * P$1.n, i2 = r % n;
  let a = trunc(r / n);
  return i2 + i2 >= n && a++, newFraction(this.s * a * P$1.n, P$1.d);
}, divisible: function(e2, t2) {
  return parse$2(e2, t2), !(!(P$1.n * this.d) || this.n * P$1.d % (P$1.n * this.d));
}, valueOf: function() {
  return Number(this.s * this.n) / Number(this.d);
}, toString: function(e2) {
  let t2 = this.n, r = this.d;
  e2 = e2 || 15;
  let n = cycleLen(t2, r), i2 = cycleStart(t2, r, n), a = this.s < C_ZERO ? "-" : "";
  if (a += trunc(t2 / r), t2 %= r, t2 *= C_TEN, t2 && (a += "."), n) {
    for (let e3 = i2; e3--; ) a += trunc(t2 / r), t2 %= r, t2 *= C_TEN;
    a += "(";
    for (let e3 = n; e3--; ) a += trunc(t2 / r), t2 %= r, t2 *= C_TEN;
    a += ")";
  } else for (let n3 = e2; t2 && n3--; ) a += trunc(t2 / r), t2 %= r, t2 *= C_TEN;
  return a;
}, toFraction: function(e2) {
  let t2 = this.n, r = this.d, n = this.s < C_ZERO ? "-" : "";
  if (r === C_ONE) n += t2;
  else {
    let i2 = trunc(t2 / r);
    e2 && i2 > C_ZERO && (n += i2, n += " ", t2 %= r), n += t2, n += "/", n += r;
  }
  return n;
}, toLatex: function(e2) {
  let t2 = this.n, r = this.d, n = this.s < C_ZERO ? "-" : "";
  if (r === C_ONE) n += t2;
  else {
    let i2 = trunc(t2 / r);
    e2 && i2 > C_ZERO && (n += i2, t2 %= r), n += "\\frac{", n += t2, n += "}{", n += r, n += "}";
  }
  return n;
}, toContinued: function() {
  let e2 = this.n, t2 = this.d, r = [];
  do {
    r.push(trunc(e2 / t2));
    let n = e2 % t2;
    e2 = t2, t2 = n;
  } while (e2 !== C_ONE);
  return r;
}, simplify: function(e2) {
  const t2 = BigInt(1 / (e2 || 1e-3) | 0), r = this.abs(), n = r.toContinued();
  for (let e3 = 1; e3 < n.length; e3++) {
    let i2 = newFraction(n[e3 - 1], C_ONE);
    for (let t22 = e3 - 2; t22 >= 0; t22--) i2 = i2.inverse().add(n[t22]);
    let a = i2.sub(r);
    if (a.n * t2 < a.d) return i2.mul(this.s);
  }
  return this;
} };
var name$4Y = "Fraction", dependencies$4Y = [], createFractionClass = factory(name$4Y, dependencies$4Y, (() => (Object.defineProperty(Fraction, "name", { value: "Fraction" }), Fraction.prototype.constructor = Fraction, Fraction.prototype.type = "Fraction", Fraction.prototype.isFraction = true, Fraction.prototype.toJSON = function() {
  return { mathjs: "Fraction", n: String(this.s * this.n), d: String(this.d) };
}, Fraction.fromJSON = function(e2) {
  return new Fraction(e2);
}, Fraction)), { isClass: true }), name$4X = "Range", dependencies$4X = [], createRangeClass = factory(name$4X, dependencies$4X, (() => {
  function e2(t2, r, n) {
    if (!(this instanceof e2)) throw new SyntaxError("Constructor must be called with the new operator");
    var i2 = null != t2, a = null != r, o = null != n;
    if (i2) {
      if (isBigNumber(t2)) t2 = t2.toNumber();
      else if ("number" != typeof t2 && !isBigInt(t2)) throw new TypeError("Parameter start must be a number or bigint");
    }
    if (a) {
      if (isBigNumber(r)) r = r.toNumber();
      else if ("number" != typeof r && !isBigInt(r)) throw new TypeError("Parameter end must be a number or bigint");
    }
    if (o) {
      if (isBigNumber(n)) n = n.toNumber();
      else if ("number" != typeof n && !isBigInt(n)) throw new TypeError("Parameter step must be a number or bigint");
    }
    if (this.start = i2 ? parseFloat(t2) : 0, this.end = a ? parseFloat(r) : 0, this.step = o ? parseFloat(n) : 1, o && nearlyEqual$1(this.step, 0)) throw new Error("Step must not be zero");
  }
  return e2.prototype.type = "Range", e2.prototype.isRange = true, e2.parse = function(t2) {
    if ("string" != typeof t2) return null;
    var r = t2.split(":").map((function(e3) {
      return parseFloat(e3);
    }));
    if (r.some((function(e3) {
      return isNaN(e3);
    }))) return null;
    switch (r.length) {
      case 2:
        return new e2(r[0], r[1]);
      case 3:
        return new e2(r[0], r[2], r[1]);
      default:
        return null;
    }
  }, e2.prototype.clone = function() {
    return new e2(this.start, this.end, this.step);
  }, e2.prototype.size = function() {
    var e3 = 0, t2 = this.start, r = this.step, n = this.end - t2;
    return sign$2(r) === sign$2(n) ? e3 = Math.ceil(n / r) : 0 === n && (e3 = 0), isNaN(e3) && (e3 = 0), [e3];
  }, e2.prototype.min = function() {
    var e3 = this.size()[0];
    return e3 > 0 ? this.step > 0 ? this.start : this.start + (e3 - 1) * this.step : void 0;
  }, e2.prototype.max = function() {
    var e3 = this.size()[0];
    return e3 > 0 ? this.step > 0 ? this.start + (e3 - 1) * this.step : this.start : void 0;
  }, e2.prototype.forEach = function(e3) {
    var t2 = this.start, r = this.step, n = this.end, i2 = 0;
    if (r > 0) for (; t2 < n; ) e3(t2, [i2], this), t2 += r, i2++;
    else if (r < 0) for (; t2 > n; ) e3(t2, [i2], this), t2 += r, i2++;
  }, e2.prototype.map = function(e3) {
    var t2 = [];
    return this.forEach((function(r, n, i2) {
      t2[n[0]] = e3(r, n, i2);
    })), t2;
  }, e2.prototype.toArray = function() {
    var e3 = [];
    return this.forEach((function(t2, r) {
      e3[r[0]] = t2;
    })), e3;
  }, e2.prototype.valueOf = function() {
    return this.toArray();
  }, e2.prototype.format = function(e3) {
    var t2 = format$2(this.start, e3);
    return 1 !== this.step && (t2 += ":" + format$2(this.step, e3)), t2 += ":" + format$2(this.end, e3);
  }, e2.prototype.toString = function() {
    return this.format();
  }, e2.prototype.toJSON = function() {
    return { mathjs: "Range", start: this.start, end: this.end, step: this.step };
  }, e2.fromJSON = function(t2) {
    return new e2(t2.start, t2.end, t2.step);
  }, e2;
}), { isClass: true }), name$4W = "Matrix", dependencies$4W = [], createMatrixClass = factory(name$4W, dependencies$4W, (() => {
  function e2() {
    if (!(this instanceof e2)) throw new SyntaxError("Constructor must be called with the new operator");
  }
  return e2.prototype.type = "Matrix", e2.prototype.isMatrix = true, e2.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, e2.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, e2.prototype.create = function(e3, t2) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, e2.prototype.subset = function(e3, t2, r) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, e2.prototype.get = function(e3) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, e2.prototype.set = function(e3, t2, r) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, e2.prototype.resize = function(e3, t2) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, e2.prototype.reshape = function(e3, t2) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, e2.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, e2.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, e2.prototype.map = function(e3, t2) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, e2.prototype.forEach = function(e3) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, e2.prototype[Symbol.iterator] = function() {
    throw new Error("Cannot iterate a Matrix interface");
  }, e2.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, e2.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, e2.prototype.format = function(e3) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, e2.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, e2;
}), { isClass: true });
function formatBigNumberToBase(e2, t2, r) {
  var n = new e2.constructor(2), i2 = "";
  if (r) {
    if (r < 1) throw new Error("size must be in greater than 0");
    if (!isInteger(r)) throw new Error("size must be an integer");
    if (e2.greaterThan(n.pow(r - 1).sub(1)) || e2.lessThan(n.pow(r - 1).mul(-1))) throw new Error("Value must be in range [-2^".concat(r - 1, ", 2^").concat(r - 1, "-1]"));
    if (!e2.isInteger()) throw new Error("Value must be an integer");
    e2.lessThan(0) && (e2 = e2.add(n.pow(r))), i2 = "i".concat(r);
  }
  switch (t2) {
    case 2:
      return "".concat(e2.toBinary()).concat(i2);
    case 8:
      return "".concat(e2.toOctal()).concat(i2);
    case 16:
      return "".concat(e2.toHexadecimal()).concat(i2);
    default:
      throw new Error("Base ".concat(t2, " not supported "));
  }
}
function format$1(e2, t2) {
  if ("function" == typeof t2) return t2(e2);
  if (!e2.isFinite()) return e2.isNaN() ? "NaN" : e2.gt(0) ? "Infinity" : "-Infinity";
  var { notation: r, precision: n, wordSize: i2 } = normalizeFormatOptions(t2);
  switch (r) {
    case "fixed":
      return toFixed$1(e2, n);
    case "exponential":
      return toExponential(e2, n);
    case "engineering":
      return toEngineering(e2, n);
    case "bin":
      return formatBigNumberToBase(e2, 2, i2);
    case "oct":
      return formatBigNumberToBase(e2, 8, i2);
    case "hex":
      return formatBigNumberToBase(e2, 16, i2);
    case "auto":
      var a = _toNumberOrDefault(null == t2 ? void 0 : t2.lowerExp, -3), o = _toNumberOrDefault(null == t2 ? void 0 : t2.upperExp, 5);
      if (e2.isZero()) return "0";
      var s = e2.toSignificantDigits(n), u = s.e;
      return (u >= a && u < o ? s.toFixed() : toExponential(e2, n)).replace(/((\.\d*?)(0+))($|e)/, (function() {
        var e3 = arguments[2], t22 = arguments[4];
        return "." !== e3 ? e3 + t22 : t22;
      }));
    default:
      throw new Error('Unknown notation "' + r + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function toEngineering(e2, t2) {
  var r = e2.e, n = r % 3 == 0 ? r : r < 0 ? r - 3 - r % 3 : r - r % 3, i2 = e2.mul(Math.pow(10, -n)).toPrecision(t2);
  i2.includes("e") && (i2 = new e2.constructor(i2).toFixed());
  return i2 + "e" + (r >= 0 ? "+" : "") + n.toString();
}
function toExponential(e2, t2) {
  return void 0 !== t2 ? e2.toExponential(t2 - 1) : e2.toExponential();
}
function toFixed$1(e2, t2) {
  return e2.toFixed(t2);
}
function _toNumberOrDefault(e2, t2) {
  return isNumber$1(e2) ? e2 : isBigNumber(e2) ? e2.toNumber() : t2;
}
function endsWith(e2, t2) {
  var r = e2.length - t2.length, n = e2.length;
  return e2.substring(r, n) === t2;
}
function format(e2, t2) {
  var r = _format(e2, t2);
  return t2 && "object" == typeof t2 && "truncate" in t2 && r.length > t2.truncate ? r.substring(0, t2.truncate - 3) + "..." : r;
}
function _format(e2, t2) {
  return "number" == typeof e2 ? format$2(e2, t2) : isBigNumber(e2) ? format$1(e2, t2) : looksLikeFraction(e2) ? t2 && "decimal" === t2.fraction ? e2.toString() : "".concat(e2.s * e2.n, "/").concat(e2.d) : Array.isArray(e2) ? formatArray(e2, t2) : isString$1(e2) ? stringify(e2) : "function" == typeof e2 ? e2.syntax ? String(e2.syntax) : "function" : e2 && "object" == typeof e2 ? "function" == typeof e2.format ? e2.format(t2) : e2 && e2.toString(t2) !== {}.toString() ? e2.toString(t2) : "{" + Object.keys(e2).map(((r) => stringify(r) + ": " + format(e2[r], t2))).join(", ") + "}" : String(e2);
}
function stringify(e2) {
  for (var t2 = String(e2), r = "", n = 0; n < t2.length; ) {
    var i2 = t2.charAt(n);
    r += i2 in controlCharacters ? controlCharacters[i2] : i2, n++;
  }
  return '"' + r + '"';
}
var controlCharacters = { '"': '\\"', "\\": "\\\\", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t" };
function escape$1(e2) {
  var t2 = String(e2);
  return t2 = t2.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function formatArray(e2, t2) {
  if (Array.isArray(e2)) {
    for (var r = "[", n = e2.length, i2 = 0; i2 < n; i2++) 0 !== i2 && (r += ", "), r += formatArray(e2[i2], t2);
    return r += "]";
  }
  return format(e2, t2);
}
function looksLikeFraction(e2) {
  return e2 && "object" == typeof e2 && "bigint" == typeof e2.s && "bigint" == typeof e2.n && "bigint" == typeof e2.d || false;
}
function compareText(e2, t2) {
  if (!isString$1(e2)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + typeOf(e2) + ", index: 0)");
  if (!isString$1(t2)) throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + typeOf(t2) + ", index: 1)");
  return e2 === t2 ? 0 : e2 > t2 ? 1 : -1;
}
function DimensionError(e2, t2, r) {
  if (!(this instanceof DimensionError)) throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = e2, this.expected = t2, this.relation = r, this.message = "Dimension mismatch (" + (Array.isArray(e2) ? "[" + e2.join(", ") + "]" : e2) + " " + (this.relation || "!=") + " " + (Array.isArray(t2) ? "[" + t2.join(", ") + "]" : t2) + ")", this.stack = new Error().stack;
}
function IndexError(e2, t2, r) {
  if (!(this instanceof IndexError)) throw new SyntaxError("Constructor must be called with the new operator");
  this.index = e2, arguments.length < 3 ? (this.min = 0, this.max = t2) : (this.min = t2, this.max = r), void 0 !== this.min && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : void 0 !== this.max && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
function arraySize(e2) {
  for (var t2 = []; Array.isArray(e2); ) t2.push(e2.length), e2 = e2[0];
  return t2;
}
function _validate(e2, t2, r) {
  var n, i2 = e2.length;
  if (i2 !== t2[r]) throw new DimensionError(i2, t2[r]);
  if (r < t2.length - 1) {
    var a = r + 1;
    for (n = 0; n < i2; n++) {
      var o = e2[n];
      if (!Array.isArray(o)) throw new DimensionError(t2.length - 1, t2.length, "<");
      _validate(e2[n], t2, a);
    }
  } else for (n = 0; n < i2; n++) if (Array.isArray(e2[n])) throw new DimensionError(t2.length + 1, t2.length, ">");
}
function validate(e2, t2) {
  if (0 === t2.length) {
    if (Array.isArray(e2)) throw new DimensionError(e2.length, 0);
  } else _validate(e2, t2, 0);
}
function validateIndexSourceSize(e2, t2) {
  var r = e2.isMatrix ? e2._size : arraySize(e2);
  t2._sourceSize.forEach(((e3, t22) => {
    if (null !== e3 && e3 !== r[t22]) throw new DimensionError(e3, r[t22]);
  }));
}
function validateIndex(e2, t2) {
  if (void 0 !== e2) {
    if (!isNumber$1(e2) || !isInteger(e2)) throw new TypeError("Index must be an integer (value: " + e2 + ")");
    if (e2 < 0 || "number" == typeof t2 && e2 >= t2) throw new IndexError(e2, t2);
  }
}
function isEmptyIndex(e2) {
  for (var t2 = 0; t2 < e2._dimensions.length; ++t2) {
    var r = e2._dimensions[t2];
    if (r._data && isArray$1(r._data)) {
      if (0 === r._size[0]) return true;
    } else if (r.isRange) {
      if (r.start === r.end) return true;
    } else if (isString$1(r) && 0 === r.length) return true;
  }
  return false;
}
function resize(e2, t2, r) {
  if (!Array.isArray(t2)) throw new TypeError("Array expected");
  if (0 === t2.length) throw new Error("Resizing to scalar is not supported");
  return t2.forEach((function(e3) {
    if (!isNumber$1(e3) || !isInteger(e3) || e3 < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + format(t2) + ")");
  })), (isNumber$1(e2) || isBigNumber(e2)) && (e2 = [e2]), _resize(e2, t2, 0, void 0 !== r ? r : 0), e2;
}
function _resize(e2, t2, r, n) {
  var i2, a, o = e2.length, s = t2[r], u = Math.min(o, s);
  if (e2.length = s, r < t2.length - 1) {
    var c2 = r + 1;
    for (i2 = 0; i2 < u; i2++) a = e2[i2], Array.isArray(a) || (a = [a], e2[i2] = a), _resize(a, t2, c2, n);
    for (i2 = u; i2 < s; i2++) a = [], e2[i2] = a, _resize(a, t2, c2, n);
  } else {
    for (i2 = 0; i2 < u; i2++) for (; Array.isArray(e2[i2]); ) e2[i2] = e2[i2][0];
    for (i2 = u; i2 < s; i2++) e2[i2] = n;
  }
}
function reshape(e2, t2) {
  var r = flatten$4(e2, true), n = r.length;
  if (!Array.isArray(e2) || !Array.isArray(t2)) throw new TypeError("Array expected");
  if (0 === t2.length) throw new DimensionError(0, n, "!=");
  var i2 = product$1(t2 = processSizesWildcard(t2, n));
  if (n !== i2) throw new DimensionError(i2, n, "!=");
  try {
    return _reshape(r, t2);
  } catch (e3) {
    if (e3 instanceof DimensionError) throw new DimensionError(i2, n, "!=");
    throw e3;
  }
}
function processSizesWildcard(e2, t2) {
  var r = product$1(e2), n = e2.slice(), i2 = e2.indexOf(-1);
  if (e2.indexOf(-1, i2 + 1) >= 0) throw new Error("More than one wildcard in sizes");
  if (i2 >= 0) {
    if (!(t2 % r == 0)) throw new Error("Could not replace wildcard, since " + t2 + " is no multiple of " + -r);
    n[i2] = -t2 / r;
  }
  return n;
}
function product$1(e2) {
  return e2.reduce(((e3, t2) => e3 * t2), 1);
}
function _reshape(e2, t2) {
  for (var r, n = e2, i2 = t2.length - 1; i2 > 0; i2--) {
    var a = t2[i2];
    r = [];
    for (var o = n.length / a, s = 0; s < o; s++) r.push(n.slice(s * a, (s + 1) * a));
    n = r;
  }
  return n;
}
function squeeze(e2, t2) {
  for (var r = arraySize(e2); Array.isArray(e2) && 1 === e2.length; ) e2 = e2[0], r.shift();
  for (var n = r.length; 1 === r[n - 1]; ) n--;
  return n < r.length && (e2 = _squeeze(e2, n, 0), r.length = n), e2;
}
function _squeeze(e2, t2, r) {
  var n, i2;
  if (r < t2) {
    var a = r + 1;
    for (n = 0, i2 = e2.length; n < i2; n++) e2[n] = _squeeze(e2[n], t2, a);
  } else for (; Array.isArray(e2); ) e2 = e2[0];
  return e2;
}
function unsqueeze(e2, t2, r, n) {
  var i2 = n || arraySize(e2);
  if (r) for (var a = 0; a < r; a++) e2 = [e2], i2.unshift(1);
  for (e2 = _unsqueeze(e2, t2, 0); i2.length < t2; ) i2.push(1);
  return e2;
}
function _unsqueeze(e2, t2, r) {
  var n, i2;
  if (Array.isArray(e2)) {
    var a = r + 1;
    for (n = 0, i2 = e2.length; n < i2; n++) e2[n] = _unsqueeze(e2[n], t2, a);
  } else for (var o = r; o < t2; o++) e2 = [e2];
  return e2;
}
function flatten$4(e2) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
  if (!Array.isArray(e2)) return e2;
  if ("boolean" != typeof t2) throw new TypeError("Boolean expected for second argument of flatten");
  var r = [];
  return t2 ? (function e3(t22) {
    if (Array.isArray(t22[0])) for (var n = 0; n < t22.length; n++) e3(t22[n]);
    else for (var i2 = 0; i2 < t22.length; i2++) r.push(t22[i2]);
  })(e2) : (function e3(t22) {
    for (var n = 0; n < t22.length; n++) {
      var i2 = t22[n];
      Array.isArray(i2) ? e3(i2) : r.push(i2);
    }
  })(e2), r;
}
function map$1(e2, t2) {
  return Array.prototype.map.call(e2, t2);
}
function forEach(e2, t2) {
  Array.prototype.forEach.call(e2, t2);
}
function filter$1(e2, t2) {
  if (1 !== arraySize(e2).length) throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(e2, t2);
}
function filterRegExp(e2, t2) {
  if (1 !== arraySize(e2).length) throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(e2, ((e3) => t2.test(e3)));
}
function join$3(e2, t2) {
  return Array.prototype.join.call(e2, t2);
}
function identify(e2) {
  if (!Array.isArray(e2)) throw new TypeError("Array input expected");
  if (0 === e2.length) return e2;
  var t2 = [], r = 0;
  t2[0] = { value: e2[0], identifier: 0 };
  for (var n = 1; n < e2.length; n++) e2[n] === e2[n - 1] ? r++ : r = 0, t2.push({ value: e2[n], identifier: r });
  return t2;
}
function generalize(e2) {
  if (!Array.isArray(e2)) throw new TypeError("Array input expected");
  if (0 === e2.length) return e2;
  for (var t2 = [], r = 0; r < e2.length; r++) t2.push(e2[r].value);
  return t2;
}
function getArrayDataType(e2, t2) {
  for (var r, n = 0, i2 = 0; i2 < e2.length; i2++) {
    var a = e2[i2], o = Array.isArray(a);
    if (0 === i2 && o && (n = a.length), o && a.length !== n) return;
    var s = o ? getArrayDataType(a, t2) : t2(a);
    if (void 0 === r) r = s;
    else if (r !== s) return "mixed";
  }
  return r;
}
function concatRecursive(e2, t2, r, n) {
  if (n < r) {
    if (e2.length !== t2.length) throw new DimensionError(e2.length, t2.length);
    for (var i2 = [], a = 0; a < e2.length; a++) i2[a] = concatRecursive(e2[a], t2[a], r, n + 1);
    return i2;
  }
  return e2.concat(t2);
}
function concat() {
  var e2 = Array.prototype.slice.call(arguments, 0, -1), t2 = Array.prototype.slice.call(arguments, -1);
  if (1 === e2.length) return e2[0];
  if (e2.length > 1) return e2.slice(1).reduce((function(e3, r) {
    return concatRecursive(e3, r, t2, 0);
  }), e2[0]);
  throw new Error("Wrong number of arguments in function concat");
}
function broadcastSizes() {
  for (var e2 = arguments.length, t2 = new Array(e2), r = 0; r < e2; r++) t2[r] = arguments[r];
  for (var n = t2.map(((e3) => e3.length)), i2 = Math.max(...n), a = new Array(i2).fill(null), o = 0; o < t2.length; o++) for (var s = t2[o], u = n[o], c2 = 0; c2 < u; c2++) {
    var l = i2 - u + c2;
    s[c2] > a[l] && (a[l] = s[c2]);
  }
  for (var f2 = 0; f2 < t2.length; f2++) checkBroadcastingRules(t2[f2], a);
  return a;
}
function checkBroadcastingRules(e2, t2) {
  for (var r = t2.length, n = e2.length, i2 = 0; i2 < n; i2++) {
    var a = r - n + i2;
    if (e2[i2] < t2[a] && e2[i2] > 1 || e2[i2] > t2[a]) throw new Error("shape mismatch: mismatch is found in arg with shape (".concat(e2, ") not possible to broadcast dimension ").concat(n, " with size ").concat(e2[i2], " to size ").concat(t2[a]));
  }
}
function broadcastTo(e2, t2) {
  var r = arraySize(e2);
  if (deepStrictEqual(r, t2)) return e2;
  checkBroadcastingRules(r, t2);
  var n = broadcastSizes(r, t2), i2 = n.length, a = [...Array(i2 - r.length).fill(1), ...r], o = clone$1(e2);
  r.length < i2 && (r = arraySize(o = reshape(o, a)));
  for (var s = 0; s < i2; s++) r[s] < n[s] && (r = arraySize(o = stretch(o, n[s], s)));
  return o;
}
function stretch(e2, t2, r) {
  return concat(...Array(t2).fill(e2), r);
}
function get$1(e2, t2) {
  if (!Array.isArray(e2)) throw new Error("Array expected");
  var r = arraySize(e2);
  if (t2.length !== r.length) throw new DimensionError(t2.length, r.length);
  for (var n = 0; n < t2.length; n++) validateIndex(t2[n], r[n]);
  return t2.reduce(((e3, t22) => e3[t22]), e2);
}
function deepMap$1(e2, t2) {
  var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
  if (0 === e2.length) return [];
  if (r) return (function e3(r2) {
    if (Array.isArray(r2)) {
      for (var n3 = r2.length, i2 = Array(n3), a = 0; a < n3; a++) i2[a] = e3(r2[a]);
      return i2;
    }
    return t2(r2);
  })(e2);
  var n = [];
  return (function r2(i2, a) {
    if (Array.isArray(i2)) {
      for (var o = i2.length, s = Array(o), u = 0; u < o; u++) n[a] = u, s[u] = r2(i2[u], a + 1);
      return s;
    }
    return t2(i2, n.slice(0, a), e2);
  })(e2, 0);
}
function deepForEach$1(e2, t2) {
  var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
  if (0 !== e2.length) if (r) (function e3(r2) {
    if (Array.isArray(r2)) for (var n3 = r2.length, i2 = 0; i2 < n3; i2++) e3(r2[i2]);
    else t2(r2);
  })(e2);
  else {
    var n = [];
    !(function r2(i2, a) {
      if (Array.isArray(i2)) for (var o = i2.length, s = 0; s < o; s++) n[a] = s, r2(i2[s], a + 1);
      else t2(i2, n.slice(0, a), e2);
    })(e2, 0);
  }
}
function clone$1(e2) {
  return _extends$2([], e2);
}
function optimizeCallback(e2, t2, r, n) {
  if (typedFunction.isTypedFunction(e2)) {
    var i2, a;
    if (n) i2 = 1;
    else {
      var o = t2.isMatrix ? t2.size() : arraySize(t2);
      if (!o.length || 0 === o[o.length - 1]) return { isUnary: n, fn: e2 };
      var s = o.map((() => 0)), u = t2.isMatrix ? t2.get(s) : get$1(t2, s);
      i2 = _findNumberOfArgumentsTyped(e2, u, s, t2);
    }
    if (t2.isMatrix && "mixed" !== t2.dataType && void 0 !== t2.dataType) {
      var c2 = _findSingleSignatureWithArity(e2, i2);
      a = void 0 !== c2 ? c2 : e2;
    } else a = e2;
    return i2 >= 1 && i2 <= 3 ? { isUnary: 1 === i2, fn: function() {
      for (var t22 = arguments.length, n3 = new Array(t22), o2 = 0; o2 < t22; o2++) n3[o2] = arguments[o2];
      return _tryFunctionWithArgs(a, n3.slice(0, i2), r, e2.name);
    } } : { isUnary: false, fn: function() {
      for (var t22 = arguments.length, n3 = new Array(t22), i22 = 0; i22 < t22; i22++) n3[i22] = arguments[i22];
      return _tryFunctionWithArgs(a, n3, r, e2.name);
    } };
  }
  return void 0 === n ? { isUnary: _findIfCallbackIsUnary(e2), fn: e2 } : { isUnary: n, fn: e2 };
}
function _findSingleSignatureWithArity(e2, t2) {
  var r = [];
  if (Object.entries(e2.signatures).forEach(((e3) => {
    var [n, i2] = e3;
    n.split(",").length === t2 && r.push(i2);
  })), 1 === r.length) return r[0];
}
function _findIfCallbackIsUnary(e2) {
  if (1 !== e2.length) return false;
  var t2 = e2.toString();
  if (/arguments/.test(t2)) return false;
  var r = t2.match(/\(.*?\)/);
  return !/\.\.\./.test(r);
}
function _findNumberOfArgumentsTyped(e2, t2, r, n) {
  for (var i2 = [t2, r, n], a = 3; a > 0; a--) {
    var o = i2.slice(0, a);
    if (null !== typedFunction.resolve(e2, o)) return a;
  }
}
function _tryFunctionWithArgs(e2, t2, r, n) {
  try {
    return e2(...t2);
  } catch (e3) {
    _createCallbackError(e3, t2, r, n);
  }
}
function _createCallbackError(e2, t2, r, n) {
  var i2;
  if (e2 instanceof TypeError && "wrongType" === (null === (i2 = e2.data) || void 0 === i2 ? void 0 : i2.category)) {
    var a = [];
    throw a.push("value: ".concat(typeOf(t2[0]))), t2.length >= 2 && a.push("index: ".concat(typeOf(t2[1]))), t2.length >= 3 && a.push("array: ".concat(typeOf(t2[2]))), new TypeError("Function ".concat(r, " cannot apply callback arguments ") + "".concat(n, "(").concat(a.join(", "), ") at index ").concat(JSON.stringify(t2[1])));
  }
  throw new TypeError("Function ".concat(r, " cannot apply callback arguments ") + "to function ".concat(n, ": ").concat(e2.message));
}
DimensionError.prototype = new RangeError(), DimensionError.prototype.constructor = RangeError, DimensionError.prototype.name = "DimensionError", DimensionError.prototype.isDimensionError = true, IndexError.prototype = new RangeError(), IndexError.prototype.constructor = RangeError, IndexError.prototype.name = "IndexError", IndexError.prototype.isIndexError = true;
var name$4V = "DenseMatrix", dependencies$4V = ["Matrix", "config"], createDenseMatrixClass = factory(name$4V, dependencies$4V, ((e2) => {
  var { Matrix: t2, config: r } = e2;
  function n(e3, t22) {
    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
    if (t22 && !isString$1(t22)) throw new Error("Invalid datatype: " + t22);
    if (isMatrix(e3)) "DenseMatrix" === e3.type ? (this._data = clone$3(e3._data), this._size = clone$3(e3._size), this._datatype = t22 || e3._datatype) : (this._data = e3.toArray(), this._size = e3.size(), this._datatype = t22 || e3._datatype);
    else if (e3 && isArray$1(e3.data) && isArray$1(e3.size)) this._data = e3.data, this._size = e3.size, validate(this._data, this._size), this._datatype = t22 || e3.datatype;
    else if (isArray$1(e3)) this._data = o(e3), this._size = arraySize(this._data), validate(this._data, this._size), this._datatype = t22;
    else {
      if (e3) throw new TypeError("Unsupported type of data (" + typeOf(e3) + ")");
      this._data = [], this._size = [0], this._datatype = t22;
    }
  }
  function i2(e3, t22, r2) {
    if (0 === t22.length) {
      for (var n3 = e3._data; isArray$1(n3); ) n3 = n3[0];
      return n3;
    }
    return e3._size = t22.slice(0), e3._data = resize(e3._data, e3._size, r2), e3;
  }
  function a(e3, t22, r2) {
    for (var n3 = e3._size.slice(0), a2 = false; n3.length < t22.length; ) n3.push(0), a2 = true;
    for (var o2 = 0, s = t22.length; o2 < s; o2++) t22[o2] > n3[o2] && (n3[o2] = t22[o2], a2 = true);
    a2 && i2(e3, n3, r2);
  }
  function o(e3) {
    return isMatrix(e3) ? o(e3.valueOf()) : isArray$1(e3) ? e3.map(o) : e3;
  }
  return n.prototype = new t2(), n.prototype.createDenseMatrix = function(e3, t22) {
    return new n(e3, t22);
  }, Object.defineProperty(n, "name", { value: "DenseMatrix" }), n.prototype.constructor = n, n.prototype.type = "DenseMatrix", n.prototype.isDenseMatrix = true, n.prototype.getDataType = function() {
    return getArrayDataType(this._data, typeOf);
  }, n.prototype.storage = function() {
    return "dense";
  }, n.prototype.datatype = function() {
    return this._datatype;
  }, n.prototype.create = function(e3, t22) {
    return new n(e3, t22);
  }, n.prototype.subset = function(e3, t22, i22) {
    switch (arguments.length) {
      case 1:
        return (function(e4, t3) {
          if (!isIndex(t3)) throw new TypeError("Invalid index");
          var i3 = r.legacySubset ? t3.size().every(((e5) => 1 === e5)) : t3.isScalar();
          if (i3) return e4.get(t3.min());
          var a2 = t3.size();
          if (a2.length !== e4._size.length) throw new DimensionError(a2.length, e4._size.length);
          for (var o2 = t3.min(), s = t3.max(), u = 0, c2 = e4._size.length; u < c2; u++) validateIndex(o2[u], e4._size[u]), validateIndex(s[u], e4._size[u]);
          var l = new n(), f2 = (function(e5, t4) {
            var r2 = t4.size().length - 1, n3 = Array(r2);
            return { data: i4(e5), size: n3.filter(((e6) => null !== e6)) };
            function i4(e6) {
              var a3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, o3 = t4.dimension(a3);
              function s2(e7, t5) {
                return isNumber$1(e7) ? t5(e7) : e7.map(t5).valueOf();
              }
              return isNumber$1(o3) ? n3[a3] = null : n3[a3] = o3.size()[0], s2(o3, a3 < r2 ? (t5) => (validateIndex(t5, e6.length), i4(e6[t5], a3 + 1)) : (t5) => (validateIndex(t5, e6.length), e6[t5]));
            }
          })(e4._data, t3);
          return l._size = f2.size, l._datatype = e4._datatype, l._data = f2.data, r.legacySubset ? l.reshape(t3.size()) : l;
        })(this, e3);
      case 2:
      case 3:
        return (function(e4, t3, r2, n3) {
          if (!t3 || true !== t3.isIndex) throw new TypeError("Invalid index");
          var i3, o2 = t3.size(), s = t3.isScalar();
          isMatrix(r2) ? (i3 = r2.size(), r2 = r2.valueOf()) : i3 = arraySize(r2);
          if (s) {
            if (0 !== i3.length) throw new TypeError("Scalar expected");
            e4.set(t3.min(), r2, n3);
          } else {
            if (!deepStrictEqual(i3, o2)) {
              if (0 === i3.length) r2 = broadcastTo([r2], o2);
              else try {
                r2 = broadcastTo(r2, o2);
              } catch (e5) {
              }
              i3 = arraySize(r2);
            }
            if (o2.length < e4._size.length) throw new DimensionError(o2.length, e4._size.length, "<");
            if (i3.length < o2.length) {
              for (var u = 0, c2 = 0; 1 === o2[u] && 1 === i3[u]; ) u++;
              for (; 1 === o2[u]; ) c2++, u++;
              r2 = unsqueeze(r2, o2.length, c2, i3);
            }
            if (!deepStrictEqual(o2, i3)) throw new DimensionError(o2, i3, ">");
            var l = t3.max().map((function(e5) {
              return e5 + 1;
            }));
            a(e4, l, n3), (function(e5, t4, r3) {
              var n4 = t4.size().length - 1;
              function i4(e6, r4) {
                var a2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, o3 = t4.dimension(a2), s2 = (t5, n5) => {
                  validateIndex(t5, e6.length), i4(e6[t5], r4[n5[0]], a2 + 1);
                }, u2 = (t5, n5) => {
                  validateIndex(t5, e6.length), e6[t5] = r4[n5[0]];
                };
                a2 < n4 ? isNumber$1(o3) ? s2(o3, [0]) : o3.forEach(s2) : isNumber$1(o3) ? u2(o3, [0]) : o3.forEach(u2);
              }
              i4(e5, r3);
            })(e4._data, t3, r2);
          }
          return e4;
        })(this, e3, t22, i22);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.get = function(e3) {
    return get$1(this._data, e3);
  }, n.prototype.set = function(e3, t22, r2) {
    if (!isArray$1(e3)) throw new TypeError("Array expected");
    if (e3.length < this._size.length) throw new DimensionError(e3.length, this._size.length, "<");
    var n3, i22, o2, s = e3.map((function(e4) {
      return e4 + 1;
    }));
    a(this, s, r2);
    var u = this._data;
    for (n3 = 0, i22 = e3.length - 1; n3 < i22; n3++) validateIndex(o2 = e3[n3], u.length), u = u[o2];
    return validateIndex(o2 = e3[e3.length - 1], u.length), u[o2] = t22, this;
  }, n.prototype.resize = function(e3, t22, r2) {
    if (!isCollection(e3)) throw new TypeError("Array or Matrix expected");
    var n3 = e3.valueOf().map(((e4) => Array.isArray(e4) && 1 === e4.length ? e4[0] : e4));
    return i2(r2 ? this.clone() : this, n3, t22);
  }, n.prototype.reshape = function(e3, t22) {
    var r2 = t22 ? this.clone() : this;
    r2._data = reshape(r2._data, e3);
    var n3 = r2._size.reduce(((e4, t3) => e4 * t3));
    return r2._size = processSizesWildcard(e3, n3), r2;
  }, n.prototype.clone = function() {
    return new n({ data: clone$3(this._data), size: clone$3(this._size), datatype: this._datatype });
  }, n.prototype.size = function() {
    return this._size.slice(0);
  }, n.prototype.map = function(e3) {
    var t22 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r2 = this, n3 = r2._size.length - 1;
    if (n3 < 0) return r2.clone();
    var i22 = optimizeCallback(e3, r2, "map", t22), a2 = i22.fn, o2 = r2.create(void 0, r2._datatype);
    if (o2._size = r2._size, t22 || i22.isUnary) return o2._data = (function e4(t3) {
      var r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i3 = Array(t3.length);
      if (r3 < n3) for (var o3 = 0; o3 < t3.length; o3++) i3[o3] = e4(t3[o3], r3 + 1);
      else for (var s2 = 0; s2 < t3.length; s2++) i3[s2] = a2(t3[s2]);
      return i3;
    })(r2._data), o2;
    if (0 === n3) {
      for (var s = r2.valueOf(), u = Array(s.length), c2 = 0; c2 < s.length; c2++) u[c2] = a2(s[c2], [c2], r2);
      return o2._data = u, o2;
    }
    var l = [];
    return o2._data = (function e4(t3) {
      var i3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, o3 = Array(t3.length);
      if (i3 < n3) for (var s2 = 0; s2 < t3.length; s2++) l[i3] = s2, o3[s2] = e4(t3[s2], i3 + 1);
      else for (var u2 = 0; u2 < t3.length; u2++) l[i3] = u2, o3[u2] = a2(t3[u2], l.slice(), r2);
      return o3;
    })(r2._data), o2;
  }, n.prototype.forEach = function(e3) {
    var t22 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r2 = this, n3 = r2._size.length - 1;
    if (!(n3 < 0)) {
      var i22 = optimizeCallback(e3, r2, "map", t22), a2 = i22.fn;
      if (t22 || i22.isUnary) (function e4(t3) {
        var r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (r3 < n3) for (var i3 = 0; i3 < t3.length; i3++) e4(t3[i3], r3 + 1);
        else for (var o3 = 0; o3 < t3.length; o3++) a2(t3[o3]);
      })(r2._data);
      else if (0 !== n3) {
        var o2 = [];
        !(function e4(t3) {
          var i3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          if (i3 < n3) for (var s2 = 0; s2 < t3.length; s2++) o2[i3] = s2, e4(t3[s2], i3 + 1);
          else for (var u = 0; u < t3.length; u++) o2[i3] = u, a2(t3[u], o2.slice(), r2);
        })(r2._data);
      } else for (var s = 0; s < r2._data.length; s++) a2(r2._data[s], [s], r2);
    }
  }, n.prototype[Symbol.iterator] = function* () {
    var e3 = this._size.length - 1;
    if (!(e3 < 0)) if (0 !== e3) for (var t22 = Array(e3 + 1).fill(0), r2 = this._size.reduce(((e4, t3) => e4 * t3), 1), n3 = 0; n3 < r2; n3++) {
      for (var i22 = this._data, a2 = 0; a2 < e3; a2++) i22 = i22[t22[a2]];
      yield { value: i22[t22[e3]], index: t22.slice() };
      for (var o2 = e3; o2 >= 0 && (t22[o2]++, !(t22[o2] < this._size[o2])); o2--) t22[o2] = 0;
    }
    else for (var s = 0; s < this._data.length; s++) yield { value: this._data[s], index: [s] };
  }, n.prototype.rows = function() {
    var e3 = [];
    if (2 !== this.size().length) throw new TypeError("Rows can only be returned for a 2D matrix.");
    var t22 = this._data;
    for (var r2 of t22) e3.push(new n([r2], this._datatype));
    return e3;
  }, n.prototype.columns = function() {
    var e3 = this, t22 = [], r2 = this.size();
    if (2 !== r2.length) throw new TypeError("Rows can only be returned for a 2D matrix.");
    for (var i22 = this._data, a2 = function(r3) {
      var a3 = i22.map(((e4) => [e4[r3]]));
      t22.push(new n(a3, e3._datatype));
    }, o2 = 0; o2 < r2[1]; o2++) a2(o2);
    return t22;
  }, n.prototype.toArray = function() {
    return clone$3(this._data);
  }, n.prototype.valueOf = function() {
    return this._data;
  }, n.prototype.format = function(e3) {
    return format(this._data, e3);
  }, n.prototype.toString = function() {
    return format(this._data);
  }, n.prototype.toJSON = function() {
    return { mathjs: "DenseMatrix", data: this._data, size: this._size, datatype: this._datatype };
  }, n.prototype.diagonal = function(e3) {
    if (e3) {
      if (isBigNumber(e3) && (e3 = e3.toNumber()), !isNumber$1(e3) || !isInteger(e3)) throw new TypeError("The parameter k must be an integer number");
    } else e3 = 0;
    for (var t22 = e3 > 0 ? e3 : 0, r2 = e3 < 0 ? -e3 : 0, i22 = this._size[0], a2 = this._size[1], o2 = Math.min(i22 - r2, a2 - t22), s = [], u = 0; u < o2; u++) s[u] = this._data[u + r2][u + t22];
    return new n({ data: s, size: [o2], datatype: this._datatype });
  }, n.diagonal = function(e3, t22, r2, i22) {
    if (!isArray$1(e3)) throw new TypeError("Array expected, size parameter");
    if (2 !== e3.length) throw new Error("Only two dimensions matrix are supported");
    if (e3 = e3.map((function(e4) {
      if (isBigNumber(e4) && (e4 = e4.toNumber()), !isNumber$1(e4) || !isInteger(e4) || e4 < 1) throw new Error("Size values must be positive integers");
      return e4;
    })), r2) {
      if (isBigNumber(r2) && (r2 = r2.toNumber()), !isNumber$1(r2) || !isInteger(r2)) throw new TypeError("The parameter k must be an integer number");
    } else r2 = 0;
    var a2, o2 = r2 > 0 ? r2 : 0, s = r2 < 0 ? -r2 : 0, u = e3[0], c2 = e3[1], l = Math.min(u - s, c2 - o2);
    if (isArray$1(t22)) {
      if (t22.length !== l) throw new Error("Invalid value array length");
      a2 = function(e4) {
        return t22[e4];
      };
    } else if (isMatrix(t22)) {
      var f2 = t22.size();
      if (1 !== f2.length || f2[0] !== l) throw new Error("Invalid matrix length");
      a2 = function(e4) {
        return t22.get([e4]);
      };
    } else a2 = function() {
      return t22;
    };
    i22 || (i22 = isBigNumber(a2(0)) ? a2(0).mul(0) : 0);
    var p = [];
    if (e3.length > 0) {
      p = resize(p, e3, i22);
      for (var m = 0; m < l; m++) p[m + s][m + o2] = a2(m);
    }
    return new n({ data: p, size: [u, c2] });
  }, n.fromJSON = function(e3) {
    return new n(e3);
  }, n.prototype.swapRows = function(e3, t22) {
    if (!(isNumber$1(e3) && isInteger(e3) && isNumber$1(t22) && isInteger(t22))) throw new Error("Row index must be positive integers");
    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
    return validateIndex(e3, this._size[0]), validateIndex(t22, this._size[0]), n._swapRows(e3, t22, this._data), this;
  }, n._swapRows = function(e3, t22, r2) {
    var n3 = r2[e3];
    r2[e3] = r2[t22], r2[t22] = n3;
  }, n;
}), { isClass: true }), name$4U = "clone", dependencies$4U = ["typed"], createClone = factory(name$4U, dependencies$4U, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4U, { any: clone$3 });
}));
function _switch$1(e2) {
  var t2, r, n = e2.length, i2 = e2[0].length, a = [];
  for (r = 0; r < i2; r++) {
    var o = [];
    for (t2 = 0; t2 < n; t2++) o.push(e2[t2][r]);
    a.push(o);
  }
  return a;
}
function containsCollections(e2) {
  for (var t2 = 0; t2 < e2.length; t2++) if (isCollection(e2[t2])) return true;
  return false;
}
function deepForEach(e2, t2) {
  isMatrix(e2) ? e2.forEach(((e3) => t2(e3)), false, true) : deepForEach$1(e2, t2, true);
}
function deepMap(e2, t2, r) {
  if (!r) return isMatrix(e2) ? e2.map(((e3) => t2(e3)), false, true) : deepMap$1(e2, t2, true);
  var n = (e3) => 0 === e3 ? e3 : t2(e3);
  return isMatrix(e2) ? e2.map(((e3) => n(e3)), false, true) : deepMap$1(e2, n, true);
}
function reduce$2(e2, t2, r) {
  var n = Array.isArray(e2) ? arraySize(e2) : e2.size();
  if (t2 < 0 || t2 >= n.length) throw new IndexError(t2, n.length);
  return isMatrix(e2) ? e2.create(_reduce(e2.valueOf(), t2, r), e2.datatype()) : _reduce(e2, t2, r);
}
function _reduce(e2, t2, r) {
  var n, i2, a, o;
  if (t2 <= 0) {
    if (Array.isArray(e2[0])) {
      for (o = _switch$1(e2), i2 = [], n = 0; n < o.length; n++) i2[n] = _reduce(o[n], t2 - 1, r);
      return i2;
    }
    for (a = e2[0], n = 1; n < e2.length; n++) a = r(a, e2[n]);
    return a;
  }
  for (i2 = [], n = 0; n < e2.length; n++) i2[n] = _reduce(e2[n], t2 - 1, r);
  return i2;
}
function scatter(e2, t2, r, n, i2, a, o, s, u, c2, l) {
  var f2, p, m, d, h = e2._values, g = e2._index, y = e2._ptr;
  if (n) for (p = y[t2], m = y[t2 + 1], f2 = p; f2 < m; f2++) r[d = g[f2]] !== a ? (r[d] = a, o.push(d), n[d] = h[f2]) : (n[d] = s(n[d], h[f2]), i2[d] = a);
  else for (p = y[t2], m = y[t2 + 1], f2 = p; f2 < m; f2++) r[d = g[f2]] !== a ? (r[d] = a, o.push(d)) : i2[d] = a;
}
var name$4T = "isInteger", dependencies$4T = ["typed", "equal"], createIsInteger = factory(name$4T, dependencies$4T, ((e2) => {
  var { typed: t2, equal: r } = e2;
  return t2(name$4T, { number: (e3) => !!Number.isFinite(e3) && r(e3, Math.round(e3)), BigNumber: (e3) => !!e3.isFinite() && r(e3.round(), e3), bigint: (e3) => true, Fraction: (e3) => 1n === e3.d, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), n1$4 = "number", n2$2 = "number, number";
function absNumber(e2) {
  return Math.abs(e2);
}
function addNumber(e2, t2) {
  return e2 + t2;
}
function subtractNumber(e2, t2) {
  return e2 - t2;
}
function multiplyNumber(e2, t2) {
  return e2 * t2;
}
function unaryMinusNumber(e2) {
  return -e2;
}
function unaryPlusNumber(e2) {
  return e2;
}
function cbrtNumber(e2) {
  return cbrt$1(e2);
}
function cubeNumber(e2) {
  return e2 * e2 * e2;
}
function expNumber(e2) {
  return Math.exp(e2);
}
function expm1Number(e2) {
  return expm1(e2);
}
function lcmNumber(e2, t2) {
  if (!isInteger(e2) || !isInteger(t2)) throw new Error("Parameters in function lcm must be integer numbers");
  if (0 === e2 || 0 === t2) return 0;
  for (var r, n = e2 * t2; 0 !== t2; ) t2 = e2 % (r = t2), e2 = r;
  return Math.abs(n / e2);
}
function logNumber(e2, t2) {
  return t2 ? Math.log(e2) / Math.log(t2) : Math.log(e2);
}
function log10Number(e2) {
  return log10$2(e2);
}
function log2Number(e2) {
  return log2$1(e2);
}
function nthRootNumber(e2) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2, r = t2 < 0;
  if (r && (t2 = -t2), 0 === t2) throw new Error("Root must be non-zero");
  if (e2 < 0 && Math.abs(t2) % 2 != 1) throw new Error("Root must be odd when a is negative.");
  if (0 === e2) return r ? 1 / 0 : 0;
  if (!isFinite(e2)) return r ? 0 : e2;
  var n = Math.pow(Math.abs(e2), 1 / t2);
  return n = e2 < 0 ? -n : n, r ? 1 / n : n;
}
function signNumber(e2) {
  return sign$2(e2);
}
function squareNumber(e2) {
  return e2 * e2;
}
function xgcdNumber(e2, t2) {
  var r, n, i2, a = 0, o = 1, s = 1, u = 0;
  if (!isInteger(e2) || !isInteger(t2)) throw new Error("Parameters in function xgcd must be integer numbers");
  for (; t2; ) i2 = e2 - (n = Math.floor(e2 / t2)) * t2, r = a, a = o - n * a, o = r, r = s, s = u - n * s, u = r, e2 = t2, t2 = i2;
  return e2 < 0 ? [-e2, -o, -u] : [e2, e2 ? o : 0, u];
}
function powNumber(e2, t2) {
  return e2 * e2 < 1 && t2 === 1 / 0 || e2 * e2 > 1 && t2 === -1 / 0 ? 0 : Math.pow(e2, t2);
}
function roundNumber(e2) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
  if (!isInteger(t2) || t2 < 0 || t2 > 15) throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
  return parseFloat(toFixed$2(e2, t2));
}
absNumber.signature = n1$4, addNumber.signature = n2$2, subtractNumber.signature = n2$2, multiplyNumber.signature = n2$2, unaryMinusNumber.signature = n1$4, unaryPlusNumber.signature = n1$4, cbrtNumber.signature = n1$4, cubeNumber.signature = n1$4, expNumber.signature = n1$4, expm1Number.signature = n1$4, lcmNumber.signature = n2$2, log10Number.signature = n1$4, log2Number.signature = n1$4, signNumber.signature = n1$4, squareNumber.signature = n1$4, xgcdNumber.signature = n2$2, powNumber.signature = n2$2;
var n1$3 = "number", n2$1 = "number, number";
function bitAndNumber(e2, t2) {
  if (!isInteger(e2) || !isInteger(t2)) throw new Error("Integers expected in function bitAnd");
  return e2 & t2;
}
function bitNotNumber(e2) {
  if (!isInteger(e2)) throw new Error("Integer expected in function bitNot");
  return ~e2;
}
function bitOrNumber(e2, t2) {
  if (!isInteger(e2) || !isInteger(t2)) throw new Error("Integers expected in function bitOr");
  return e2 | t2;
}
function bitXorNumber(e2, t2) {
  if (!isInteger(e2) || !isInteger(t2)) throw new Error("Integers expected in function bitXor");
  return e2 ^ t2;
}
function leftShiftNumber(e2, t2) {
  if (!isInteger(e2) || !isInteger(t2)) throw new Error("Integers expected in function leftShift");
  return e2 << t2;
}
function rightArithShiftNumber(e2, t2) {
  if (!isInteger(e2) || !isInteger(t2)) throw new Error("Integers expected in function rightArithShift");
  return e2 >> t2;
}
function rightLogShiftNumber(e2, t2) {
  if (!isInteger(e2) || !isInteger(t2)) throw new Error("Integers expected in function rightLogShift");
  return e2 >>> t2;
}
function product(e2, t2) {
  if (t2 < e2) return 1;
  if (t2 === e2) return t2;
  var r = t2 + e2 >> 1;
  return product(e2, r) * product(r + 1, t2);
}
function combinationsNumber(e2, t2) {
  if (!isInteger(e2) || e2 < 0) throw new TypeError("Positive integer value expected in function combinations");
  if (!isInteger(t2) || t2 < 0) throw new TypeError("Positive integer value expected in function combinations");
  if (t2 > e2) throw new TypeError("k must be less than or equal to n");
  for (var r = e2 - t2, n = 1, i2 = 2, a = t2 < r ? t2 : r, o = t2 < r ? r + 1 : t2 + 1; o <= e2; ++o) for (n *= o; i2 <= a && n % i2 == 0; ) n /= i2, ++i2;
  return i2 <= a && (n /= product(i2, a)), n;
}
bitAndNumber.signature = n2$1, bitNotNumber.signature = n1$3, bitOrNumber.signature = n2$1, bitXorNumber.signature = n2$1, leftShiftNumber.signature = n2$1, rightArithShiftNumber.signature = n2$1, rightLogShiftNumber.signature = n2$1, combinationsNumber.signature = "number, number";
var pi = Math.PI, tau = 2 * Math.PI, e = Math.E, phi = 1.618033988749895, n1$2 = "number", n2 = "number, number";
function notNumber(e2) {
  return !e2;
}
function orNumber(e2, t2) {
  return !(!e2 && !t2);
}
function xorNumber(e2, t2) {
  return !!e2 != !!t2;
}
function andNumber(e2, t2) {
  return !(!e2 || !t2);
}
function gammaNumber(e2) {
  var t2;
  if (isInteger(e2)) return e2 <= 0 ? Number.isFinite(e2) ? 1 / 0 : NaN : e2 > 171 ? 1 / 0 : product(1, e2 - 1);
  if (e2 < 0.5) return Math.PI / (Math.sin(Math.PI * e2) * gammaNumber(1 - e2));
  if (e2 >= 171.35) return 1 / 0;
  if (e2 > 85) {
    var r = e2 * e2, n = r * e2, i2 = n * e2, a = i2 * e2;
    return Math.sqrt(2 * Math.PI / e2) * Math.pow(e2 / Math.E, e2) * (1 + 1 / (12 * e2) + 1 / (288 * r) - 139 / (51840 * n) - 571 / (2488320 * i2) + 163879 / (209018880 * a) + 5246819 / (75246796800 * a * e2));
  }
  --e2, t2 = gammaP[0];
  for (var o = 1; o < gammaP.length; ++o) t2 += gammaP[o] / (e2 + o);
  var s = e2 + gammaG + 0.5;
  return Math.sqrt(2 * Math.PI) * Math.pow(s, e2 + 0.5) * Math.exp(-s) * t2;
}
notNumber.signature = n1$2, orNumber.signature = n2, xorNumber.signature = n2, andNumber.signature = n2, gammaNumber.signature = "number";
var gammaG = 4.7421875, gammaP = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], lnSqrt2PI = 0.9189385332046728, lgammaG = 5, lgammaN = 7, lgammaSeries = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function lgammaNumber(e2) {
  if (e2 < 0) return NaN;
  if (0 === e2) return 1 / 0;
  if (!Number.isFinite(e2)) return e2;
  if (e2 < 0.5) return Math.log(Math.PI / Math.sin(Math.PI * e2)) - lgammaNumber(1 - e2);
  for (var t2 = (e2 -= 1) + lgammaG + 0.5, r = lgammaSeries[0], n = lgammaN - 1; n >= 1; n--) r += lgammaSeries[n] / (e2 + n);
  return lnSqrt2PI + (e2 + 0.5) * Math.log(t2) - t2 + Math.log(r);
}
lgammaNumber.signature = "number";
var n1$1 = "number";
function acoshNumber(e2) {
  return acosh$2(e2);
}
function acotNumber(e2) {
  return Math.atan(1 / e2);
}
function acothNumber(e2) {
  return Number.isFinite(e2) ? (Math.log((e2 + 1) / e2) + Math.log(e2 / (e2 - 1))) / 2 : 0;
}
function acscNumber(e2) {
  return Math.asin(1 / e2);
}
function acschNumber(e2) {
  var t2 = 1 / e2;
  return Math.log(t2 + Math.sqrt(t2 * t2 + 1));
}
function asecNumber(e2) {
  return Math.acos(1 / e2);
}
function asechNumber(e2) {
  var t2 = 1 / e2, r = Math.sqrt(t2 * t2 - 1);
  return Math.log(r + t2);
}
function asinhNumber(e2) {
  return asinh$2(e2);
}
function atanhNumber(e2) {
  return atanh$2(e2);
}
function cotNumber(e2) {
  return 1 / Math.tan(e2);
}
function cothNumber(e2) {
  var t2 = Math.exp(2 * e2);
  return (t2 + 1) / (t2 - 1);
}
function cscNumber(e2) {
  return 1 / Math.sin(e2);
}
function cschNumber(e2) {
  return 0 === e2 ? Number.POSITIVE_INFINITY : Math.abs(2 / (Math.exp(e2) - Math.exp(-e2))) * sign$2(e2);
}
function secNumber(e2) {
  return 1 / Math.cos(e2);
}
function sechNumber(e2) {
  return 2 / (Math.exp(e2) + Math.exp(-e2));
}
function sinhNumber(e2) {
  return sinh$3(e2);
}
acoshNumber.signature = n1$1, acotNumber.signature = n1$1, acothNumber.signature = n1$1, acscNumber.signature = n1$1, acschNumber.signature = n1$1, asecNumber.signature = n1$1, asechNumber.signature = n1$1, asinhNumber.signature = n1$1, atanhNumber.signature = n1$1, cotNumber.signature = n1$1, cothNumber.signature = n1$1, cscNumber.signature = n1$1, cschNumber.signature = n1$1, secNumber.signature = n1$1, sechNumber.signature = n1$1, sinhNumber.signature = n1$1;
var n1 = "number";
function isNegativeNumber(e2) {
  return e2 < 0;
}
function isPositiveNumber(e2) {
  return e2 > 0;
}
function isNaNNumber(e2) {
  return Number.isNaN(e2);
}
function nearlyEqual(e2, t2) {
  var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e-9, n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
  if (r <= 0) throw new Error("Relative tolerance must be greater than 0");
  if (n < 0) throw new Error("Absolute tolerance must be at least 0");
  return !e2.isNaN() && !t2.isNaN() && (e2.isFinite() && t2.isFinite() ? !!e2.eq(t2) || e2.minus(t2).abs().lte(e2.constructor.max(e2.constructor.max(e2.abs(), t2.abs()).mul(r), n)) : e2.eq(t2));
}
isNegativeNumber.signature = n1, isPositiveNumber.signature = n1, isNaNNumber.signature = n1;
var name$4S = "isNegative", dependencies$4S = ["typed", "config"], createIsNegative = factory(name$4S, dependencies$4S, ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$4S, { number: (e3) => !nearlyEqual$1(e3, 0, r.relTol, r.absTol) && isNegativeNumber(e3), BigNumber: (e3) => !nearlyEqual(e3, new e3.constructor(0), r.relTol, r.absTol) && (e3.isNeg() && !e3.isZero() && !e3.isNaN()), bigint: (e3) => e3 < 0n, Fraction: (e3) => e3.s < 0n, Unit: t2.referToSelf(((e3) => (r2) => t2.find(e3, r2.valueType())(r2.value))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4R = "isNumeric", dependencies$4R = ["typed"], createIsNumeric = factory(name$4R, dependencies$4R, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4R, { "number | BigNumber | bigint | Fraction | boolean": () => true, "Complex | Unit | string | null | undefined | Node": () => false, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4Q = "hasNumericValue", dependencies$4Q = ["typed", "isNumeric"], createHasNumericValue = factory(name$4Q, dependencies$4Q, ((e2) => {
  var { typed: t2, isNumeric: r } = e2;
  return t2(name$4Q, { boolean: () => true, string: function(e3) {
    return e3.trim().length > 0 && !isNaN(Number(e3));
  }, any: function(e3) {
    return r(e3);
  } });
})), name$4P = "isPositive", dependencies$4P = ["typed", "config"], createIsPositive = factory(name$4P, dependencies$4P, ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$4P, { number: (e3) => !nearlyEqual$1(e3, 0, r.relTol, r.absTol) && isPositiveNumber(e3), BigNumber: (e3) => !nearlyEqual(e3, new e3.constructor(0), r.relTol, r.absTol) && (!e3.isNeg() && !e3.isZero() && !e3.isNaN()), bigint: (e3) => e3 > 0n, Fraction: (e3) => e3.s > 0n && e3.n > 0n, Unit: t2.referToSelf(((e3) => (r2) => t2.find(e3, r2.valueType())(r2.value))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4O = "isZero", dependencies$4O = ["typed", "equalScalar"], createIsZero = factory(name$4O, dependencies$4O, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return t2(name$4O, { "number | BigNumber | Complex | Fraction": (e3) => r(e3, 0), bigint: (e3) => 0n === e3, Unit: t2.referToSelf(((e3) => (r2) => t2.find(e3, r2.valueType())(r2.value))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4N = "isNaN", dependencies$4N = ["typed"], createIsNaN = factory(name$4N, dependencies$4N, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4N, { number: isNaNNumber, BigNumber: function(e3) {
    return e3.isNaN();
  }, bigint: function(e3) {
    return false;
  }, Fraction: function(e3) {
    return false;
  }, Complex: function(e3) {
    return e3.isNaN();
  }, Unit: function(e3) {
    return Number.isNaN(e3.value);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4M = "isBounded", dependencies$4M = ["typed"], createIsBounded = factory(name$4M, dependencies$4M, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4M, { number: (e3) => Number.isFinite(e3), "BigNumber | Complex": (e3) => e3.isFinite(), "bigint | Fraction": () => true, "null | undefined": () => false, Unit: t2.referToSelf(((e3) => (t22) => e3(t22.value))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => (Array.isArray(t22) || (t22 = t22.valueOf()), t22.every(((t3) => e3(t3)))))) });
})), name$4L = "isFinite", dependencies$4L = ["typed", "isBounded", "map"], createIsFinite = factory(name$4L, dependencies$4L, ((e2) => {
  var { typed: t2, isBounded: r, map: n } = e2;
  return t2(name$4L, { "Array | Matrix": (e3) => n(e3, r), any: (e3) => r(e3) });
})), name$4K = "typeOf", dependencies$4K = ["typed"], createTypeOf = factory(name$4K, dependencies$4K, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4K, { any: typeOf });
}));
function complexEquals(e2, t2, r, n) {
  return nearlyEqual$1(e2.re, t2.re, r, n) && nearlyEqual$1(e2.im, t2.im, r, n);
}
var createCompareUnits = factory("compareUnits", ["typed"], ((e2) => {
  var { typed: t2 } = e2;
  return { "Unit, Unit": t2.referToSelf(((e3) => (r, n) => {
    if (!r.equalBase(n)) throw new Error("Cannot compare units with different base");
    return t2.find(e3, [r.valueType(), n.valueType()])(r.value, n.value);
  })) };
})), name$4J = "equalScalar", dependencies$4J = ["typed", "config"], createEqualScalar = factory(name$4J, dependencies$4J, ((e2) => {
  var { typed: t2, config: r } = e2, n = createCompareUnits({ typed: t2 });
  return t2(name$4J, { "boolean, boolean": function(e3, t22) {
    return e3 === t22;
  }, "number, number": function(e3, t22) {
    return nearlyEqual$1(e3, t22, r.relTol, r.absTol);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return e3.eq(t22) || nearlyEqual(e3, t22, r.relTol, r.absTol);
  }, "bigint, bigint": function(e3, t22) {
    return e3 === t22;
  }, "Fraction, Fraction": function(e3, t22) {
    return e3.equals(t22);
  }, "Complex, Complex": function(e3, t22) {
    return complexEquals(e3, t22, r.relTol, r.absTol);
  } }, n);
}));
factory(name$4J, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$4J, { "number, number": function(e3, t22) {
    return nearlyEqual$1(e3, t22, r.relTol, r.absTol);
  } });
}));
var name$4I = "SparseMatrix", dependencies$4I = ["typed", "equalScalar", "Matrix"], createSparseMatrixClass = factory(name$4I, dependencies$4I, ((e2) => {
  var { typed: t2, equalScalar: r, Matrix: n } = e2;
  function i2(e3, t22) {
    if (!(this instanceof i2)) throw new SyntaxError("Constructor must be called with the new operator");
    if (t22 && !isString$1(t22)) throw new Error("Invalid datatype: " + t22);
    if (isMatrix(e3)) !(function(e4, t3, r2) {
      "SparseMatrix" === t3.type ? (e4._values = t3._values ? clone$3(t3._values) : void 0, e4._index = clone$3(t3._index), e4._ptr = clone$3(t3._ptr), e4._size = clone$3(t3._size), e4._datatype = r2 || t3._datatype) : a(e4, t3.valueOf(), r2 || t3._datatype);
    })(this, e3, t22);
    else if (e3 && isArray$1(e3.index) && isArray$1(e3.ptr) && isArray$1(e3.size)) this._values = e3.values, this._index = e3.index, this._ptr = e3.ptr, this._size = e3.size, this._datatype = t22 || e3.datatype;
    else if (isArray$1(e3)) a(this, e3, t22);
    else {
      if (e3) throw new TypeError("Unsupported type of data (" + typeOf(e3) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = t22;
    }
  }
  function a(e3, n3, i22) {
    e3._values = [], e3._index = [], e3._ptr = [], e3._datatype = i22;
    var a2 = n3.length, o2 = 0, s2 = r, u2 = 0;
    if (isString$1(i22) && (s2 = t2.find(r, [i22, i22]) || r, u2 = t2.convert(0, i22)), a2 > 0) {
      var c3 = 0;
      do {
        e3._ptr.push(e3._index.length);
        for (var l = 0; l < a2; l++) {
          var f2 = n3[l];
          if (isArray$1(f2)) {
            if (0 === c3 && o2 < f2.length && (o2 = f2.length), c3 < f2.length) {
              var p = f2[c3];
              s2(p, u2) || (e3._values.push(p), e3._index.push(l));
            }
          } else 0 === c3 && o2 < 1 && (o2 = 1), s2(f2, u2) || (e3._values.push(f2), e3._index.push(l));
        }
        c3++;
      } while (c3 < o2);
    }
    for (; e3._ptr.length <= o2; ) e3._ptr.push(e3._index.length);
    e3._size = [a2, o2];
  }
  function o(e3, t22, r2, n3) {
    if (r2 - t22 == 0) return r2;
    for (var i22 = t22; i22 < r2; i22++) if (n3[i22] === e3) return i22;
    return t22;
  }
  function s(e3, t22, r2, n3, i22, a2, o2) {
    i22.splice(e3, 0, n3), a2.splice(e3, 0, t22);
    for (var s2 = r2 + 1; s2 < o2.length; s2++) o2[s2]++;
  }
  function u(e3, n3, i22, a2) {
    var o2 = a2 || 0, s2 = r, u2 = 0;
    isString$1(e3._datatype) && (s2 = t2.find(r, [e3._datatype, e3._datatype]) || r, u2 = t2.convert(0, e3._datatype), o2 = t2.convert(o2, e3._datatype));
    var c3, l, f2, p = !s2(o2, u2), m = e3._size[0], d = e3._size[1];
    if (i22 > d) {
      for (l = d; l < i22; l++) if (e3._ptr[l] = e3._values.length, p) for (c3 = 0; c3 < m; c3++) e3._values.push(o2), e3._index.push(c3);
      e3._ptr[i22] = e3._values.length;
    } else i22 < d && (e3._ptr.splice(i22 + 1, d - i22), e3._values.splice(e3._ptr[i22], e3._values.length), e3._index.splice(e3._ptr[i22], e3._index.length));
    if (d = i22, n3 > m) {
      if (p) {
        var h = 0;
        for (l = 0; l < d; l++) {
          e3._ptr[l] = e3._ptr[l] + h, f2 = e3._ptr[l + 1] + h;
          var g = 0;
          for (c3 = m; c3 < n3; c3++, g++) e3._values.splice(f2 + g, 0, o2), e3._index.splice(f2 + g, 0, c3), h++;
        }
        e3._ptr[d] = e3._values.length;
      }
    } else if (n3 < m) {
      var y = 0;
      for (l = 0; l < d; l++) {
        e3._ptr[l] = e3._ptr[l] - y;
        var v2 = e3._ptr[l], x2 = e3._ptr[l + 1] - y;
        for (f2 = v2; f2 < x2; f2++) (c3 = e3._index[f2]) > n3 - 1 && (e3._values.splice(f2, 1), e3._index.splice(f2, 1), y++);
      }
      e3._ptr[l] = e3._values.length;
    }
    return e3._size[0] = n3, e3._size[1] = i22, e3;
  }
  function c2(e3, t22, r2, n3, i22) {
    var a2, o2, s2 = n3[0], u2 = n3[1], c3 = [];
    for (a2 = 0; a2 < s2; a2++) for (c3[a2] = [], o2 = 0; o2 < u2; o2++) c3[a2][o2] = 0;
    for (o2 = 0; o2 < u2; o2++) for (var l = r2[o2], f2 = r2[o2 + 1], p = l; p < f2; p++) c3[a2 = t22[p]][o2] = e3 ? i22 ? clone$3(e3[p]) : e3[p] : 1;
    return c3;
  }
  return i2.prototype = new n(), i2.prototype.createSparseMatrix = function(e3, t22) {
    return new i2(e3, t22);
  }, Object.defineProperty(i2, "name", { value: "SparseMatrix" }), i2.prototype.constructor = i2, i2.prototype.type = "SparseMatrix", i2.prototype.isSparseMatrix = true, i2.prototype.getDataType = function() {
    return getArrayDataType(this._values, typeOf);
  }, i2.prototype.storage = function() {
    return "sparse";
  }, i2.prototype.datatype = function() {
    return this._datatype;
  }, i2.prototype.create = function(e3, t22) {
    return new i2(e3, t22);
  }, i2.prototype.density = function() {
    var e3 = this._size[0], t22 = this._size[1];
    return 0 !== e3 && 0 !== t22 ? this._index.length / (e3 * t22) : 0;
  }, i2.prototype.subset = function(e3, t22, r2) {
    if (!this._values) throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return (function(e4, t3) {
          if (!isIndex(t3)) throw new TypeError("Invalid index");
          if (t3.isScalar()) return e4.get(t3.min());
          var r3, n3, a2, o2, s2 = t3.size();
          if (s2.length !== e4._size.length) throw new DimensionError(s2.length, e4._size.length);
          var u2 = t3.min(), c3 = t3.max();
          for (r3 = 0, n3 = e4._size.length; r3 < n3; r3++) validateIndex(u2[r3], e4._size[r3]), validateIndex(c3[r3], e4._size[r3]);
          var l = e4._values, f2 = e4._index, p = e4._ptr, m = t3.dimension(0), d = t3.dimension(1), h = [], g = [];
          function y(e5, t4) {
            g[e5] = t4[0], h[e5] = true;
          }
          Number.isInteger(m) ? y(m, [0]) : m.forEach(y);
          var v2 = l ? [] : void 0, x2 = [], b2 = [];
          function _2(e5) {
            for (b2.push(x2.length), a2 = p[e5], o2 = p[e5 + 1]; a2 < o2; a2++) r3 = f2[a2], true === h[r3] && (x2.push(g[r3]), v2 && v2.push(l[a2]));
          }
          Number.isInteger(d) ? _2(d) : d.forEach(_2);
          return b2.push(x2.length), new i2({ values: v2, index: x2, ptr: b2, size: s2, datatype: e4._datatype });
        })(this, e3);
      case 2:
      case 3:
        return (function(e4, t3, r3, n3) {
          if (!t3 || true !== t3.isIndex) throw new TypeError("Invalid index");
          var i22, a2 = t3.size(), o2 = t3.isScalar();
          isMatrix(r3) ? (i22 = r3.size(), r3 = r3.toArray()) : i22 = arraySize(r3);
          if (o2) {
            if (0 !== i22.length) throw new TypeError("Scalar expected");
            e4.set(t3.min(), r3, n3);
          } else {
            if (1 !== a2.length && 2 !== a2.length) throw new DimensionError(a2.length, e4._size.length, "<");
            if (i22.length < a2.length) {
              for (var s2 = 0, u2 = 0; 1 === a2[s2] && 1 === i22[s2]; ) s2++;
              for (; 1 === a2[s2]; ) u2++, s2++;
              r3 = unsqueeze(r3, a2.length, u2, i22);
            }
            if (!deepStrictEqual(a2, i22)) throw new DimensionError(a2, i22, ">");
            if (1 === a2.length) {
              f2(t3.dimension(0), ((t4, i3) => {
                validateIndex(t4), e4.set([t4, 0], r3[i3[0]], n3);
              }));
            } else {
              var c3 = t3.dimension(0), l = t3.dimension(1);
              f2(c3, ((t4, i3) => {
                validateIndex(t4), f2(l, ((a3, o3) => {
                  validateIndex(a3), e4.set([t4, a3], r3[i3[0]][o3[0]], n3);
                }));
              }));
            }
          }
          return e4;
          function f2(e5, t4) {
            isNumber$1(e5) ? t4(e5, [0]) : e5.forEach(t4);
          }
        })(this, e3, t22, r2);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, i2.prototype.get = function(e3) {
    if (!isArray$1(e3)) throw new TypeError("Array expected");
    if (e3.length !== this._size.length) throw new DimensionError(e3.length, this._size.length);
    if (!this._values) throw new Error("Cannot invoke get on a Pattern only matrix");
    var t22 = e3[0], r2 = e3[1];
    validateIndex(t22, this._size[0]), validateIndex(r2, this._size[1]);
    var n3 = o(t22, this._ptr[r2], this._ptr[r2 + 1], this._index);
    return n3 < this._ptr[r2 + 1] && this._index[n3] === t22 ? this._values[n3] : 0;
  }, i2.prototype.set = function(e3, n3, i22) {
    if (!isArray$1(e3)) throw new TypeError("Array expected");
    if (e3.length !== this._size.length) throw new DimensionError(e3.length, this._size.length);
    if (!this._values) throw new Error("Cannot invoke set on a Pattern only matrix");
    var a2 = e3[0], c3 = e3[1], l = this._size[0], f2 = this._size[1], p = r, m = 0;
    isString$1(this._datatype) && (p = t2.find(r, [this._datatype, this._datatype]) || r, m = t2.convert(0, this._datatype)), (a2 > l - 1 || c3 > f2 - 1) && (u(this, Math.max(a2 + 1, l), Math.max(c3 + 1, f2), i22), l = this._size[0], f2 = this._size[1]), validateIndex(a2, l), validateIndex(c3, f2);
    var d = o(a2, this._ptr[c3], this._ptr[c3 + 1], this._index);
    return d < this._ptr[c3 + 1] && this._index[d] === a2 ? p(n3, m) ? (function(e4, t22, r2, n4, i3) {
      r2.splice(e4, 1), n4.splice(e4, 1);
      for (var a3 = t22 + 1; a3 < i3.length; a3++) i3[a3]--;
    })(d, c3, this._values, this._index, this._ptr) : this._values[d] = n3 : p(n3, m) || s(d, a2, c3, n3, this._values, this._index, this._ptr), this;
  }, i2.prototype.resize = function(e3, t22, r2) {
    if (!isCollection(e3)) throw new TypeError("Array or Matrix expected");
    var n3 = e3.valueOf().map(((e4) => Array.isArray(e4) && 1 === e4.length ? e4[0] : e4));
    if (2 !== n3.length) throw new Error("Only two dimensions matrix are supported");
    return n3.forEach((function(e4) {
      if (!isNumber$1(e4) || !isInteger(e4) || e4 < 0) throw new TypeError("Invalid size, must contain positive integers (size: " + format(n3) + ")");
    })), u(r2 ? this.clone() : this, n3[0], n3[1], t22);
  }, i2.prototype.reshape = function(e3, t22) {
    if (!isArray$1(e3)) throw new TypeError("Array expected");
    if (2 !== e3.length) throw new Error("Sparse matrices can only be reshaped in two dimensions");
    e3.forEach((function(t3) {
      if (!isNumber$1(t3) || !isInteger(t3) || t3 <= -2 || 0 === t3) throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + format(e3) + ")");
    }));
    var r2 = this._size[0] * this._size[1];
    if (r2 !== (e3 = processSizesWildcard(e3, r2))[0] * e3[1]) throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var n3 = t22 ? this.clone() : this;
    if (this._size[0] === e3[0] && this._size[1] === e3[1]) return n3;
    for (var i22 = [], a2 = 0; a2 < n3._ptr.length; a2++) for (var u2 = 0; u2 < n3._ptr[a2 + 1] - n3._ptr[a2]; u2++) i22.push(a2);
    for (var c3 = n3._values.slice(), l = n3._index.slice(), f2 = 0; f2 < n3._index.length; f2++) {
      var p = l[f2], m = i22[f2], d = p * n3._size[1] + m;
      i22[f2] = d % e3[1], l[f2] = Math.floor(d / e3[1]);
    }
    n3._values.length = 0, n3._index.length = 0, n3._ptr.length = e3[1] + 1, n3._size = e3.slice();
    for (var h = 0; h < n3._ptr.length; h++) n3._ptr[h] = 0;
    for (var g = 0; g < c3.length; g++) {
      var y = l[g], v2 = i22[g], x2 = c3[g];
      s(o(y, n3._ptr[v2], n3._ptr[v2 + 1], n3._index), y, v2, x2, n3._values, n3._index, n3._ptr);
    }
    return n3;
  }, i2.prototype.clone = function() {
    return new i2({ values: this._values ? clone$3(this._values) : void 0, index: clone$3(this._index), ptr: clone$3(this._ptr), size: clone$3(this._size), datatype: this._datatype });
  }, i2.prototype.size = function() {
    return this._size.slice(0);
  }, i2.prototype.map = function(e3, n3) {
    if (!this._values) throw new Error("Cannot invoke map on a Pattern only matrix");
    var a2 = this, o2 = this._size[0], s2 = this._size[1], u2 = optimizeCallback(e3, a2, "map");
    return (function(e4, n4, a3, o3, s3, u3, c3) {
      var l = [], f2 = [], p = [], m = r, d = 0;
      isString$1(e4._datatype) && (m = t2.find(r, [e4._datatype, e4._datatype]) || r, d = t2.convert(0, e4._datatype));
      for (var h = function(e5, t22, r2) {
        var n5 = u3(e5, t22, r2);
        m(n5, d) || (l.push(n5), f2.push(t22));
      }, g = o3; g <= s3; g++) {
        p.push(l.length);
        var y = e4._ptr[g], v2 = e4._ptr[g + 1];
        if (c3) for (var x2 = y; x2 < v2; x2++) {
          var b2 = e4._index[x2];
          b2 >= n4 && b2 <= a3 && h(e4._values[x2], b2 - n4, g - o3);
        }
        else {
          for (var _2 = {}, w2 = y; w2 < v2; w2++) {
            _2[e4._index[w2]] = e4._values[w2];
          }
          for (var A2 = n4; A2 <= a3; A2++) {
            h(A2 in _2 ? _2[A2] : 0, A2 - n4, g - o3);
          }
        }
      }
      return p.push(l.length), new i2({ values: l, index: f2, ptr: p, size: [a3 - n4 + 1, s3 - o3 + 1] });
    })(this, 0, o2 - 1, 0, s2 - 1, (function(e4, t22, r2) {
      return u2.fn(e4, [t22, r2], a2);
    }), n3);
  }, i2.prototype.forEach = function(e3, t22) {
    if (!this._values) throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var r2 = this, n3 = this._size[0], i22 = this._size[1], a2 = optimizeCallback(e3, r2, "forEach"), o2 = 0; o2 < i22; o2++) {
      var s2 = this._ptr[o2], u2 = this._ptr[o2 + 1];
      if (t22) for (var c3 = s2; c3 < u2; c3++) {
        var l = this._index[c3];
        a2.fn(this._values[c3], [l, o2], r2);
      }
      else {
        for (var f2 = {}, p = s2; p < u2; p++) {
          f2[this._index[p]] = this._values[p];
        }
        for (var m = 0; m < n3; m++) {
          var d = m in f2 ? f2[m] : 0;
          a2.fn(d, [m, o2], r2);
        }
      }
    }
  }, i2.prototype[Symbol.iterator] = function* () {
    if (!this._values) throw new Error("Cannot iterate a Pattern only matrix");
    for (var e3 = this._size[1], t22 = 0; t22 < e3; t22++) for (var r2 = this._ptr[t22], n3 = this._ptr[t22 + 1], i22 = r2; i22 < n3; i22++) {
      var a2 = this._index[i22];
      yield { value: this._values[i22], index: [a2, t22] };
    }
  }, i2.prototype.toArray = function() {
    return c2(this._values, this._index, this._ptr, this._size, true);
  }, i2.prototype.valueOf = function() {
    return c2(this._values, this._index, this._ptr, this._size, false);
  }, i2.prototype.format = function(e3) {
    for (var t22 = this._size[0], r2 = this._size[1], n3 = this.density(), i22 = "Sparse Matrix [" + format(t22, e3) + " x " + format(r2, e3) + "] density: " + format(n3, e3) + "\n", a2 = 0; a2 < r2; a2++) for (var o2 = this._ptr[a2], s2 = this._ptr[a2 + 1], u2 = o2; u2 < s2; u2++) {
      i22 += "\n    (" + format(this._index[u2], e3) + ", " + format(a2, e3) + ") ==> " + (this._values ? format(this._values[u2], e3) : "X");
    }
    return i22;
  }, i2.prototype.toString = function() {
    return format(this.toArray());
  }, i2.prototype.toJSON = function() {
    return { mathjs: "SparseMatrix", values: this._values, index: this._index, ptr: this._ptr, size: this._size, datatype: this._datatype };
  }, i2.prototype.diagonal = function(e3) {
    if (e3) {
      if (isBigNumber(e3) && (e3 = e3.toNumber()), !isNumber$1(e3) || !isInteger(e3)) throw new TypeError("The parameter k must be an integer number");
    } else e3 = 0;
    var t22 = e3 > 0 ? e3 : 0, r2 = e3 < 0 ? -e3 : 0, n3 = this._size[0], a2 = this._size[1], o2 = Math.min(n3 - r2, a2 - t22), s2 = [], u2 = [], c3 = [];
    c3[0] = 0;
    for (var l = t22; l < a2 && s2.length < o2; l++) for (var f2 = this._ptr[l], p = this._ptr[l + 1], m = f2; m < p; m++) {
      var d = this._index[m];
      if (d === l - t22 + r2) {
        s2.push(this._values[m]), u2[s2.length - 1] = d - r2;
        break;
      }
    }
    return c3.push(s2.length), new i2({ values: s2, index: u2, ptr: c3, size: [o2, 1] });
  }, i2.fromJSON = function(e3) {
    return new i2(e3);
  }, i2.diagonal = function(e3, n3, a2, o2, s2) {
    if (!isArray$1(e3)) throw new TypeError("Array expected, size parameter");
    if (2 !== e3.length) throw new Error("Only two dimensions matrix are supported");
    if (e3 = e3.map((function(e4) {
      if (isBigNumber(e4) && (e4 = e4.toNumber()), !isNumber$1(e4) || !isInteger(e4) || e4 < 1) throw new Error("Size values must be positive integers");
      return e4;
    })), a2) {
      if (isBigNumber(a2) && (a2 = a2.toNumber()), !isNumber$1(a2) || !isInteger(a2)) throw new TypeError("The parameter k must be an integer number");
    } else a2 = 0;
    var u2 = r, c3 = 0;
    isString$1(s2) && (u2 = t2.find(r, [s2, s2]) || r, c3 = t2.convert(0, s2));
    var l, f2 = a2 > 0 ? a2 : 0, p = a2 < 0 ? -a2 : 0, m = e3[0], d = e3[1], h = Math.min(m - p, d - f2);
    if (isArray$1(n3)) {
      if (n3.length !== h) throw new Error("Invalid value array length");
      l = function(e4) {
        return n3[e4];
      };
    } else if (isMatrix(n3)) {
      var g = n3.size();
      if (1 !== g.length || g[0] !== h) throw new Error("Invalid matrix length");
      l = function(e4) {
        return n3.get([e4]);
      };
    } else l = function() {
      return n3;
    };
    for (var y = [], v2 = [], x2 = [], b2 = 0; b2 < d; b2++) {
      x2.push(y.length);
      var _2 = b2 - f2;
      if (_2 >= 0 && _2 < h) {
        var w2 = l(_2);
        u2(w2, c3) || (v2.push(_2 + p), y.push(w2));
      }
    }
    return x2.push(y.length), new i2({ values: y, index: v2, ptr: x2, size: [m, d] });
  }, i2.prototype.swapRows = function(e3, t22) {
    if (!(isNumber$1(e3) && isInteger(e3) && isNumber$1(t22) && isInteger(t22))) throw new Error("Row index must be positive integers");
    if (2 !== this._size.length) throw new Error("Only two dimensional matrix is supported");
    return validateIndex(e3, this._size[0]), validateIndex(t22, this._size[0]), i2._swapRows(e3, t22, this._size[1], this._values, this._index, this._ptr), this;
  }, i2._forEachRow = function(e3, t22, r2, n3, i22) {
    for (var a2 = n3[e3], o2 = n3[e3 + 1], s2 = a2; s2 < o2; s2++) i22(r2[s2], t22[s2]);
  }, i2._swapRows = function(e3, t22, r2, n3, i22, a2) {
    for (var s2 = 0; s2 < r2; s2++) {
      var u2 = a2[s2], c3 = a2[s2 + 1], l = o(e3, u2, c3, i22), f2 = o(t22, u2, c3, i22);
      if (l < c3 && f2 < c3 && i22[l] === e3 && i22[f2] === t22) {
        if (n3) {
          var p = n3[l];
          n3[l] = n3[f2], n3[f2] = p;
        }
      } else if (l < c3 && i22[l] === e3 && (f2 >= c3 || i22[f2] !== t22)) {
        var m = n3 ? n3[l] : void 0;
        i22.splice(f2, 0, t22), n3 && n3.splice(f2, 0, m), i22.splice(f2 <= l ? l + 1 : l, 1), n3 && n3.splice(f2 <= l ? l + 1 : l, 1);
      } else if (f2 < c3 && i22[f2] === t22 && (l >= c3 || i22[l] !== e3)) {
        var d = n3 ? n3[f2] : void 0;
        i22.splice(l, 0, e3), n3 && n3.splice(l, 0, d), i22.splice(l <= f2 ? f2 + 1 : f2, 1), n3 && n3.splice(l <= f2 ? f2 + 1 : f2, 1);
      }
    }
  }, i2;
}), { isClass: true }), name$4H = "number", dependencies$4H = ["typed"];
function getNonDecimalNumberParts(e2) {
  var t2 = e2.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  return t2 ? { input: e2, radix: { "0b": 2, "0o": 8, "0x": 16 }[t2[1]], integerPart: t2[2], fractionalPart: t2[3] } : null;
}
function makeNumberFromNonDecimalParts(e2) {
  for (var t2 = parseInt(e2.integerPart, e2.radix), r = 0, n = 0; n < e2.fractionalPart.length; n++) {
    r += parseInt(e2.fractionalPart[n], e2.radix) / Math.pow(e2.radix, n + 1);
  }
  var i2 = t2 + r;
  if (isNaN(i2)) throw new SyntaxError('String "' + e2.input + '" is not a valid number');
  return i2;
}
var createNumber = factory(name$4H, dependencies$4H, ((e2) => {
  var { typed: t2 } = e2, r = t2("number", { "": function() {
    return 0;
  }, number: function(e3) {
    return e3;
  }, string: function(e3) {
    if ("NaN" === e3) return NaN;
    var t22 = getNonDecimalNumberParts(e3);
    if (t22) return makeNumberFromNonDecimalParts(t22);
    var r2 = 0, n = e3.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    n && (r2 = Number(n[2]), e3 = n[1]);
    var i2 = Number(e3);
    if (isNaN(i2)) throw new SyntaxError('String "' + e3 + '" is not a valid number');
    if (n) {
      if (i2 > 2 ** r2 - 1) throw new SyntaxError('String "'.concat(e3, '" is out of range'));
      i2 >= 2 ** (r2 - 1) && (i2 -= 2 ** r2);
    }
    return i2;
  }, BigNumber: function(e3) {
    return e3.toNumber();
  }, bigint: function(e3) {
    return Number(e3);
  }, Fraction: function(e3) {
    return e3.valueOf();
  }, Unit: t2.referToSelf(((e3) => (t22) => {
    var r2 = t22.clone();
    return r2.value = e3(t22.value), r2;
  })), null: function(e3) {
    return 0;
  }, "Unit, string | Unit": function(e3, t22) {
    return e3.toNumber(t22);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
  return r.fromJSON = function(e3) {
    return parseFloat(e3.value);
  }, r;
})), name$4G = "bigint", dependencies$4G = ["typed"], createBigint = factory(name$4G, dependencies$4G, ((e2) => {
  var { typed: t2 } = e2, r = t2("bigint", { "": function() {
    return 0n;
  }, bigint: function(e3) {
    return e3;
  }, number: function(e3) {
    return BigInt(e3.toFixed());
  }, BigNumber: function(e3) {
    return BigInt(e3.round().toString());
  }, Fraction: function(e3) {
    return BigInt(e3.valueOf().toFixed());
  }, "string | boolean": function(e3) {
    return BigInt(e3);
  }, null: function(e3) {
    return 0n;
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
  return r.fromJSON = function(e3) {
    return BigInt(e3.value);
  }, r;
})), name$4F = "string", dependencies$4F = ["typed"], createString = factory(name$4F, dependencies$4F, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4F, { "": function() {
    return "";
  }, number: format$2, null: function(e3) {
    return "null";
  }, boolean: function(e3) {
    return e3 + "";
  }, string: function(e3) {
    return e3;
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))), any: function(e3) {
    return String(e3);
  } });
})), name$4E = "boolean", dependencies$4E = ["typed"], createBoolean = factory(name$4E, dependencies$4E, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4E, { "": function() {
    return false;
  }, boolean: function(e3) {
    return e3;
  }, number: function(e3) {
    return !!e3;
  }, null: function(e3) {
    return false;
  }, BigNumber: function(e3) {
    return !e3.isZero();
  }, string: function(e3) {
    var t22 = e3.toLowerCase();
    if ("true" === t22) return true;
    if ("false" === t22) return false;
    var r = Number(e3);
    if ("" !== e3 && !isNaN(r)) return !!r;
    throw new Error('Cannot convert "' + e3 + '" to a boolean');
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4D = "bignumber", dependencies$4D = ["typed", "BigNumber"], createBignumber = factory(name$4D, dependencies$4D, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2("bignumber", { "": function() {
    return new r(0);
  }, number: function(e3) {
    return new r(e3 + "");
  }, string: function(e3) {
    var t22 = e3.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    if (t22) {
      var n = t22[2], i2 = r(t22[1]), a = new r(2).pow(Number(n));
      if (i2.gt(a.sub(1))) throw new SyntaxError('String "'.concat(e3, '" is out of range'));
      var o = new r(2).pow(Number(n) - 1);
      return i2.gte(o) ? i2.sub(a) : i2;
    }
    return new r(e3);
  }, BigNumber: function(e3) {
    return e3;
  }, bigint: function(e3) {
    return new r(e3.toString());
  }, Unit: t2.referToSelf(((e3) => (t22) => {
    var r2 = t22.clone();
    return r2.value = e3(t22.value), r2;
  })), Fraction: function(e3) {
    return new r(String(e3.n)).div(String(e3.d)).times(String(e3.s));
  }, null: function(e3) {
    return new r(0);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4C = "complex", dependencies$4C = ["typed", "Complex"], createComplex = factory(name$4C, dependencies$4C, ((e2) => {
  var { typed: t2, Complex: r } = e2;
  return t2("complex", { "": function() {
    return r.ZERO;
  }, number: function(e3) {
    return new r(e3, 0);
  }, "number, number": function(e3, t22) {
    return new r(e3, t22);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return new r(e3.toNumber(), t22.toNumber());
  }, Fraction: function(e3) {
    return new r(e3.valueOf(), 0);
  }, Complex: function(e3) {
    return e3.clone();
  }, string: function(e3) {
    return r(e3);
  }, null: function(e3) {
    return r(0);
  }, Object: function(e3) {
    if ("re" in e3 && "im" in e3) return new r(e3.re, e3.im);
    if ("r" in e3 && "phi" in e3 || "abs" in e3 && "arg" in e3) return new r(e3);
    throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4B = "fraction", dependencies$4B = ["typed", "Fraction"], createFraction = factory(name$4B, dependencies$4B, ((e2) => {
  var { typed: t2, Fraction: r } = e2;
  return t2("fraction", { number: function(e3) {
    if (!Number.isFinite(e3) || isNaN(e3)) throw new Error(e3 + " cannot be represented as a fraction");
    return new r(e3);
  }, string: function(e3) {
    return new r(e3);
  }, "number, number": function(e3, t22) {
    return new r(e3, t22);
  }, "bigint, bigint": function(e3, t22) {
    return new r(e3, t22);
  }, null: function(e3) {
    return new r(0);
  }, BigNumber: function(e3) {
    return new r(e3.toString());
  }, bigint: function(e3) {
    return new r(e3.toString());
  }, Fraction: function(e3) {
    return e3;
  }, Unit: t2.referToSelf(((e3) => (t22) => {
    var r2 = t22.clone();
    return r2.value = e3(t22.value), r2;
  })), Object: function(e3) {
    return new r(e3);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$4A = "matrix", dependencies$4A = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], createMatrix = factory(name$4A, dependencies$4A, ((e2) => {
  var { typed: t2, Matrix: r, DenseMatrix: n, SparseMatrix: i2 } = e2;
  return t2(name$4A, { "": function() {
    return a([]);
  }, string: function(e3) {
    return a([], e3);
  }, "string, string": function(e3, t22) {
    return a([], e3, t22);
  }, Array: function(e3) {
    return a(e3);
  }, Matrix: function(e3) {
    return a(e3, e3.storage());
  }, "Array | Matrix, string": a, "Array | Matrix, string, string": a });
  function a(e3, t22, r2) {
    if ("dense" === t22 || "default" === t22 || void 0 === t22) return new n(e3, r2);
    if ("sparse" === t22) return new i2(e3, r2);
    throw new TypeError("Unknown matrix type " + JSON.stringify(t22) + ".");
  }
})), name$4z = "matrixFromFunction", dependencies$4z = ["typed", "matrix", "isZero"], createMatrixFromFunction = factory(name$4z, dependencies$4z, ((e2) => {
  var { typed: t2, matrix: r, isZero: n } = e2;
  return t2(name$4z, { "Array | Matrix, function, string, string": function(e3, t22, r2, n3) {
    return i2(e3, t22, r2, n3);
  }, "Array | Matrix, function, string": function(e3, t22, r2) {
    return i2(e3, t22, r2);
  }, "Matrix, function": function(e3, t22) {
    return i2(e3, t22, "dense");
  }, "Array, function": function(e3, t22) {
    return i2(e3, t22, "dense").toArray();
  }, "Array | Matrix, string, function": function(e3, t22, r2) {
    return i2(e3, r2, t22);
  }, "Array | Matrix, string, string, function": function(e3, t22, r2, n3) {
    return i2(e3, n3, t22, r2);
  } });
  function i2(e3, t22, i22, a) {
    var o;
    return (o = void 0 !== a ? r(i22, a) : r(i22)).resize(e3), o.forEach((function(e4, r2) {
      var i3 = t22(r2);
      n(i3) || o.set(r2, i3);
    })), o;
  }
})), name$4y = "matrixFromRows", dependencies$4y = ["typed", "matrix", "flatten", "size"], createMatrixFromRows = factory(name$4y, dependencies$4y, ((e2) => {
  var { typed: t2, matrix: r, flatten: n, size: i2 } = e2;
  return t2(name$4y, { "...Array": function(e3) {
    return a(e3);
  }, "...Matrix": function(e3) {
    return r(a(e3.map(((e4) => e4.toArray()))));
  } });
  function a(e3) {
    if (0 === e3.length) throw new TypeError("At least one row is needed to construct a matrix.");
    var t22 = o(e3[0]), r2 = [];
    for (var i22 of e3) {
      var a2 = o(i22);
      if (a2 !== t22) throw new TypeError("The vectors had different length: " + (0 | t22) + " ≠ " + (0 | a2));
      r2.push(n(i22));
    }
    return r2;
  }
  function o(e3) {
    var t22 = i2(e3);
    if (1 === t22.length) return t22[0];
    if (2 === t22.length) {
      if (1 === t22[0]) return t22[1];
      if (1 === t22[1]) return t22[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    }
    throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
})), name$4x = "matrixFromColumns", dependencies$4x = ["typed", "matrix", "flatten", "size"], createMatrixFromColumns = factory(name$4x, dependencies$4x, ((e2) => {
  var { typed: t2, matrix: r, flatten: n, size: i2 } = e2;
  return t2(name$4x, { "...Array": function(e3) {
    return a(e3);
  }, "...Matrix": function(e3) {
    return r(a(e3.map(((e4) => e4.toArray()))));
  } });
  function a(e3) {
    if (0 === e3.length) throw new TypeError("At least one column is needed to construct a matrix.");
    for (var t22 = o(e3[0]), r2 = [], i22 = 0; i22 < t22; i22++) r2[i22] = [];
    for (var a2 of e3) {
      var s = o(a2);
      if (s !== t22) throw new TypeError("The vectors had different length: " + (0 | t22) + " ≠ " + (0 | s));
      for (var u = n(a2), c2 = 0; c2 < t22; c2++) r2[c2].push(u[c2]);
    }
    return r2;
  }
  function o(e3) {
    var t22 = i2(e3);
    if (1 === t22.length) return t22[0];
    if (2 === t22.length) {
      if (1 === t22[0]) return t22[1];
      if (1 === t22[1]) return t22[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    }
    throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
})), name$4w = "splitUnit", dependencies$4w = ["typed"], createSplitUnit = factory(name$4w, dependencies$4w, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4w, { "Unit, Array": function(e3, t22) {
    return e3.splitUnit(t22);
  } });
})), name$4v = "unaryMinus", dependencies$4v = ["typed"], createUnaryMinus = factory(name$4v, dependencies$4v, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4v, { number: unaryMinusNumber, "Complex | BigNumber | Fraction": (e3) => e3.neg(), bigint: (e3) => -e3, Unit: t2.referToSelf(((e3) => (r) => {
    var n = r.clone();
    return n.value = t2.find(e3, n.valueType())(r.value), n;
  })), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3, true))) });
})), name$4u = "unaryPlus", dependencies$4u = ["typed", "config", "numeric"], createUnaryPlus = factory(name$4u, dependencies$4u, ((e2) => {
  var { typed: t2, config: r, numeric: n } = e2;
  return t2(name$4u, { number: unaryPlusNumber, Complex: function(e3) {
    return e3;
  }, BigNumber: function(e3) {
    return e3;
  }, bigint: function(e3) {
    return e3;
  }, Fraction: function(e3) {
    return e3;
  }, Unit: function(e3) {
    return e3.clone();
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3, true))), boolean: function(e3) {
    return n(e3 ? 1 : 0, r.number);
  }, string: function(e3) {
    return n(e3, safeNumberType(e3, r));
  } });
})), name$4t = "abs", dependencies$4t = ["typed"], createAbs = factory(name$4t, dependencies$4t, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4t, { number: absNumber, "Complex | BigNumber | Fraction | Unit": (e3) => e3.abs(), bigint: (e3) => e3 < 0n ? -e3 : e3, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3, true))) });
})), name$4s = "mapSlices", dependencies$4s = ["typed", "isInteger"], createMapSlices = factory(name$4s, dependencies$4s, ((e2) => {
  var { typed: t2, isInteger: r } = e2;
  return t2(name$4s, { "Array | Matrix, number | BigNumber, function": function(e3, t22, n) {
    if (!r(t22)) throw new TypeError("Integer number expected for dimension");
    var i2 = Array.isArray(e3) ? arraySize(e3) : e3.size();
    if (t22 < 0 || t22 >= i2.length) throw new IndexError(t22, i2.length);
    return isMatrix(e3) ? e3.create(_mapSlices(e3.valueOf(), t22, n), e3.datatype()) : _mapSlices(e3, t22, n);
  } });
}), { formerly: "apply" });
function _mapSlices(e2, t2, r) {
  var n, i2, a;
  if (t2 <= 0) {
    if (Array.isArray(e2[0])) {
      for (a = _switch(e2), i2 = [], n = 0; n < a.length; n++) i2[n] = _mapSlices(a[n], t2 - 1, r);
      return i2;
    }
    return r(e2);
  }
  for (i2 = [], n = 0; n < e2.length; n++) i2[n] = _mapSlices(e2[n], t2 - 1, r);
  return i2;
}
function _switch(e2) {
  var t2, r, n = e2.length, i2 = e2[0].length, a = [];
  for (r = 0; r < i2; r++) {
    var o = [];
    for (t2 = 0; t2 < n; t2++) o.push(e2[t2][r]);
    a.push(o);
  }
  return a;
}
var name$4r = "addScalar", dependencies$4r = ["typed"], createAddScalar = factory(name$4r, dependencies$4r, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4r, { "number, number": addNumber, "Complex, Complex": function(e3, t22) {
    return e3.add(t22);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return e3.plus(t22);
  }, "bigint, bigint": function(e3, t22) {
    return e3 + t22;
  }, "Fraction, Fraction": function(e3, t22) {
    return e3.add(t22);
  }, "Unit, Unit": t2.referToSelf(((e3) => (r, n) => {
    if (null === r.value || void 0 === r.value) throw new Error("Parameter x contains a unit with undefined value");
    if (null === n.value || void 0 === n.value) throw new Error("Parameter y contains a unit with undefined value");
    if (!r.equalBase(n)) throw new Error("Units do not match");
    var i2 = r.clone();
    return i2.value = t2.find(e3, [i2.valueType(), n.valueType()])(i2.value, n.value), i2.fixPrefix = false, i2;
  })) });
})), name$4q = "subtractScalar", dependencies$4q = ["typed"], createSubtractScalar = factory(name$4q, dependencies$4q, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4q, { "number, number": subtractNumber, "Complex, Complex": function(e3, t22) {
    return e3.sub(t22);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return e3.minus(t22);
  }, "bigint, bigint": function(e3, t22) {
    return e3 - t22;
  }, "Fraction, Fraction": function(e3, t22) {
    return e3.sub(t22);
  }, "Unit, Unit": t2.referToSelf(((e3) => (r, n) => {
    if (null === r.value || void 0 === r.value) throw new Error("Parameter x contains a unit with undefined value");
    if (null === n.value || void 0 === n.value) throw new Error("Parameter y contains a unit with undefined value");
    if (!r.equalBase(n)) throw new Error("Units do not match");
    var i2 = r.clone();
    return i2.value = t2.find(e3, [i2.valueType(), n.valueType()])(i2.value, n.value), i2.fixPrefix = false, i2;
  })) });
})), name$4p = "cbrt", dependencies$4p = ["config", "typed", "isNegative", "unaryMinus", "matrix", "Complex", "BigNumber", "Fraction"], createCbrt = factory(name$4p, dependencies$4p, ((e2) => {
  var { config: t2, typed: r, isNegative: n, unaryMinus: i2, matrix: a, Complex: o, BigNumber: s, Fraction: u } = e2;
  return r(name$4p, { number: cbrtNumber, Complex: c2, "Complex, boolean": c2, BigNumber: function(e3) {
    return e3.cbrt();
  }, Unit: function(e3) {
    if (e3.value && isComplex(e3.value)) {
      var t22 = e3.clone();
      return t22.value = 1, (t22 = t22.pow(1 / 3)).value = c2(e3.value), t22;
    }
    var r2, a2 = n(e3.value);
    a2 && (e3.value = i2(e3.value)), r2 = isBigNumber(e3.value) ? new s(1).div(3) : isFraction(e3.value) ? new u(1, 3) : 1 / 3;
    var o2 = e3.pow(r2);
    return a2 && (o2.value = i2(o2.value)), o2;
  } });
  function c2(e3, r2) {
    var n3 = e3.arg() / 3, i22 = e3.abs(), s2 = new o(cbrtNumber(i22), 0).mul(new o(0, n3).exp());
    if (r2) {
      var u2 = [s2, new o(cbrtNumber(i22), 0).mul(new o(0, n3 + 2 * Math.PI / 3).exp()), new o(cbrtNumber(i22), 0).mul(new o(0, n3 - 2 * Math.PI / 3).exp())];
      return "Array" === t2.matrix ? u2 : a(u2);
    }
    return s2;
  }
})), name$4o = "matAlgo11xS0s", dependencies$4o = ["typed", "equalScalar"], createMatAlgo11xS0s = factory(name$4o, dependencies$4o, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2, a) {
    var o = e3._values, s = e3._index, u = e3._ptr, c2 = e3._size, l = e3._datatype;
    if (!o) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f2, p = c2[0], m = c2[1], d = r, h = 0, g = i2;
    "string" == typeof l && (f2 = l, d = t2.find(r, [f2, f2]), h = t2.convert(0, f2), n = t2.convert(n, f2), g = t2.find(i2, [f2, f2]));
    for (var y = [], v2 = [], x2 = [], b2 = 0; b2 < m; b2++) {
      x2[b2] = v2.length;
      for (var _2 = u[b2], w2 = u[b2 + 1], A2 = _2; A2 < w2; A2++) {
        var N = s[A2], D = a ? g(n, o[A2]) : g(o[A2], n);
        d(D, h) || (v2.push(N), y.push(D));
      }
    }
    return x2[m] = v2.length, e3.createSparseMatrix({ values: y, index: v2, ptr: x2, size: [p, m], datatype: f2 });
  };
})), name$4n = "matAlgo12xSfs", dependencies$4n = ["typed", "DenseMatrix"], createMatAlgo12xSfs = factory(name$4n, dependencies$4n, ((e2) => {
  var { typed: t2, DenseMatrix: r } = e2;
  return function(e3, n, i2, a) {
    var o = e3._values, s = e3._index, u = e3._ptr, c2 = e3._size, l = e3._datatype;
    if (!o) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f2, p = c2[0], m = c2[1], d = i2;
    "string" == typeof l && (f2 = l, n = t2.convert(n, f2), d = t2.find(i2, [f2, f2]));
    for (var h = [], g = [], y = [], v2 = 0; v2 < m; v2++) {
      for (var x2 = v2 + 1, b2 = u[v2], _2 = u[v2 + 1], w2 = b2; w2 < _2; w2++) {
        var A2 = s[w2];
        g[A2] = o[w2], y[A2] = x2;
      }
      for (var N = 0; N < p; N++) 0 === v2 && (h[N] = []), y[N] === x2 ? h[N][v2] = a ? d(n, g[N]) : d(g[N], n) : h[N][v2] = a ? d(n, 0) : d(0, n);
    }
    return new r({ data: h, size: [p, m], datatype: f2 });
  };
})), name$4m = "matAlgo14xDs", dependencies$4m = ["typed"], createMatAlgo14xDs = factory(name$4m, dependencies$4m, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, n, i2, a) {
    var o, s = e3._data, u = e3._size, c2 = e3._datatype, l = i2;
    "string" == typeof c2 && (o = c2, n = t2.convert(n, o), l = t2.find(i2, [o, o]));
    var f2 = u.length > 0 ? r(l, 0, u, u[0], s, n, a) : [];
    return e3.createDenseMatrix({ data: f2, size: clone$3(u), datatype: o });
  };
  function r(e3, t22, n, i2, a, o, s) {
    var u = [];
    if (t22 === n.length - 1) for (var c2 = 0; c2 < i2; c2++) u[c2] = s ? e3(o, a[c2]) : e3(a[c2], o);
    else for (var l = 0; l < i2; l++) u[l] = r(e3, t22 + 1, n, n[t22 + 1], a[l], o, s);
    return u;
  }
})), name$4l = "ceil", dependencies$4l = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], bigTen$1 = new Decimal(10), createCeilNumber = factory(name$4l, ["typed", "config", "round"], ((e2) => {
  var { typed: t2, config: r, round: n } = e2;
  function i2(e3) {
    var t22 = Math.ceil(e3), i22 = n(e3);
    return t22 === i22 ? t22 : nearlyEqual$1(e3, i22, r.relTol, r.absTol) && !nearlyEqual$1(e3, t22, r.relTol, r.absTol) ? i22 : t22;
  }
  return t2(name$4l, { number: i2, "number, number": function(e3, t22) {
    if (!isInteger(t22)) throw new RangeError("number of decimals in function ceil must be an integer");
    if (t22 < 0 || t22 > 15) throw new RangeError("number of decimals in ceil number must be in range 0-15");
    var r2 = 10 ** t22;
    return i2(e3 * r2) / r2;
  } });
})), createCeil = factory(name$4l, dependencies$4l, ((e2) => {
  var { typed: t2, config: r, round: n, matrix: i2, equalScalar: a, zeros: o, DenseMatrix: s } = e2, u = createMatAlgo11xS0s({ typed: t2, equalScalar: a }), c2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: s }), l = createMatAlgo14xDs({ typed: t2 }), f2 = createCeilNumber({ typed: t2, config: r, round: n });
  function p(e3) {
    var t22 = (e4, t3) => nearlyEqual(e4, t3, r.relTol, r.absTol), i22 = e3.ceil(), a2 = n(e3);
    return i22.eq(a2) ? i22 : t22(e3, a2) && !t22(e3, i22) ? a2 : i22;
  }
  return t2("ceil", { number: f2.signatures.number, "number,number": f2.signatures["number,number"], Complex: function(e3) {
    return e3.ceil();
  }, "Complex, number": function(e3, t22) {
    return e3.ceil(t22);
  }, "Complex, BigNumber": function(e3, t22) {
    return e3.ceil(t22.toNumber());
  }, BigNumber: p, "BigNumber, BigNumber": function(e3, t22) {
    var r2 = bigTen$1.pow(t22);
    return p(e3.mul(r2)).div(r2);
  }, bigint: (e3) => e3, "bigint, number": (e3, t22) => e3, "bigint, BigNumber": (e3, t22) => e3, Fraction: function(e3) {
    return e3.ceil();
  }, "Fraction, number": function(e3, t22) {
    return e3.ceil(t22);
  }, "Fraction, BigNumber": function(e3, t22) {
    return e3.ceil(t22.toNumber());
  }, "Unit, number, Unit": t2.referToSelf(((e3) => function(t22, r2, n3) {
    var i22 = t22.toNumeric(n3);
    return n3.multiply(e3(i22, r2));
  })), "Unit, BigNumber, Unit": t2.referToSelf(((e3) => (t22, r2, n3) => e3(t22, r2.toNumber(), n3))), "Array | Matrix, number | BigNumber, Unit": t2.referToSelf(((e3) => (t22, r2, n3) => deepMap(t22, ((t3) => e3(t3, r2, n3)), true))), "Array | Matrix | Unit, Unit": t2.referToSelf(((e3) => (t22, r2) => e3(t22, 0, r2))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3, true))), "Array, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => deepMap(t22, ((t3) => e3(t3, r2)), true))), "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => u(t22, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => l(t22, r2, e3, false))), "number | Complex | Fraction | BigNumber, Array": t2.referToSelf(((e3) => (t22, r2) => l(i2(r2), t22, e3, true).valueOf())), "number | Complex | Fraction | BigNumber, Matrix": t2.referToSelf(((e3) => (t22, r2) => a(t22, 0) ? o(r2.size(), r2.storage()) : "dense" === r2.storage() ? l(r2, t22, e3, true) : c2(r2, t22, e3, true))) });
})), name$4k = "cube", dependencies$4k = ["typed"], createCube = factory(name$4k, dependencies$4k, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4k, { number: cubeNumber, Complex: function(e3) {
    return e3.mul(e3).mul(e3);
  }, BigNumber: function(e3) {
    return e3.times(e3).times(e3);
  }, bigint: function(e3) {
    return e3 * e3 * e3;
  }, Fraction: function(e3) {
    return e3.pow(3);
  }, Unit: function(e3) {
    return e3.pow(3);
  } });
})), name$4j = "exp", dependencies$4j = ["typed"], createExp = factory(name$4j, dependencies$4j, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$4j, { number: expNumber, Complex: function(e3) {
    return e3.exp();
  }, BigNumber: function(e3) {
    return e3.exp();
  } });
})), name$4i = "expm1", dependencies$4i = ["typed", "Complex"], createExpm1 = factory(name$4i, dependencies$4i, ((e2) => {
  var { typed: t2, Complex: r } = e2;
  return t2(name$4i, { number: expm1Number, Complex: function(e3) {
    var t22 = Math.exp(e3.re);
    return new r(t22 * Math.cos(e3.im) - 1, t22 * Math.sin(e3.im));
  }, BigNumber: function(e3) {
    return e3.exp().minus(1);
  } });
})), name$4h = "fix", dependencies$4h = ["typed", "Complex", "matrix", "ceil", "floor", "equalScalar", "zeros", "DenseMatrix"], createFixNumber = factory(name$4h, ["typed", "ceil", "floor"], ((e2) => {
  var { typed: t2, ceil: r, floor: n } = e2;
  return t2(name$4h, { number: function(e3) {
    return e3 > 0 ? n(e3) : r(e3);
  }, "number, number": function(e3, t22) {
    return e3 > 0 ? n(e3, t22) : r(e3, t22);
  } });
})), createFix = factory(name$4h, dependencies$4h, ((e2) => {
  var { typed: t2, Complex: r, matrix: n, ceil: i2, floor: a, equalScalar: o, zeros: s, DenseMatrix: u } = e2, c2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: u }), l = createMatAlgo14xDs({ typed: t2 }), f2 = createFixNumber({ typed: t2, ceil: i2, floor: a });
  return t2("fix", { number: f2.signatures.number, "number, number | BigNumber": f2.signatures["number,number"], Complex: function(e3) {
    return new r(e3.re > 0 ? Math.floor(e3.re) : Math.ceil(e3.re), e3.im > 0 ? Math.floor(e3.im) : Math.ceil(e3.im));
  }, "Complex, number": function(e3, t22) {
    return new r(e3.re > 0 ? a(e3.re, t22) : i2(e3.re, t22), e3.im > 0 ? a(e3.im, t22) : i2(e3.im, t22));
  }, "Complex, BigNumber": function(e3, t22) {
    var n3 = t22.toNumber();
    return new r(e3.re > 0 ? a(e3.re, n3) : i2(e3.re, n3), e3.im > 0 ? a(e3.im, n3) : i2(e3.im, n3));
  }, BigNumber: function(e3) {
    return e3.isNegative() ? i2(e3) : a(e3);
  }, "BigNumber, number | BigNumber": function(e3, t22) {
    return e3.isNegative() ? i2(e3, t22) : a(e3, t22);
  }, bigint: (e3) => e3, "bigint, number": (e3, t22) => e3, "bigint, BigNumber": (e3, t22) => e3, Fraction: function(e3) {
    return e3.s < 0n ? e3.ceil() : e3.floor();
  }, "Fraction, number | BigNumber": function(e3, t22) {
    return e3.s < 0n ? i2(e3, t22) : a(e3, t22);
  }, "Unit, number, Unit": t2.referToSelf(((e3) => function(t22, r2, n3) {
    var i22 = t22.toNumeric(n3);
    return n3.multiply(e3(i22, r2));
  })), "Unit, BigNumber, Unit": t2.referToSelf(((e3) => (t22, r2, n3) => e3(t22, r2.toNumber(), n3))), "Array | Matrix, number | BigNumber, Unit": t2.referToSelf(((e3) => (t22, r2, n3) => deepMap(t22, ((t3) => e3(t3, r2, n3)), true))), "Array | Matrix | Unit, Unit": t2.referToSelf(((e3) => (t22, r2) => e3(t22, 0, r2))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3, true))), "Array | Matrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => deepMap(t22, ((t3) => e3(t3, r2)), true))), "number | Complex | Fraction | BigNumber, Array": t2.referToSelf(((e3) => (t22, r2) => l(n(r2), t22, e3, true).valueOf())), "number | Complex | Fraction | BigNumber, Matrix": t2.referToSelf(((e3) => (t22, r2) => o(t22, 0) ? s(r2.size(), r2.storage()) : "dense" === r2.storage() ? l(r2, t22, e3, true) : c2(r2, t22, e3, true))) });
})), name$4g = "floor", dependencies$4g = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], bigTen = new Decimal(10), createFloorNumber = factory(name$4g, ["typed", "config", "round"], ((e2) => {
  var { typed: t2, config: r, round: n } = e2;
  function i2(e3) {
    var t22 = Math.floor(e3), i22 = n(e3);
    return t22 === i22 ? t22 : nearlyEqual$1(e3, i22, r.relTol, r.absTol) && !nearlyEqual$1(e3, t22, r.relTol, r.absTol) ? i22 : t22;
  }
  return t2(name$4g, { number: i2, "number, number": function(e3, t22) {
    if (!isInteger(t22)) throw new RangeError("number of decimals in function floor must be an integer");
    if (t22 < 0 || t22 > 15) throw new RangeError("number of decimals in floor number must be in range 0 - 15");
    var r2 = 10 ** t22;
    return i2(e3 * r2) / r2;
  } });
})), createFloor = factory(name$4g, dependencies$4g, ((e2) => {
  var { typed: t2, config: r, round: n, matrix: i2, equalScalar: a, zeros: o, DenseMatrix: s } = e2, u = createMatAlgo11xS0s({ typed: t2, equalScalar: a }), c2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: s }), l = createMatAlgo14xDs({ typed: t2 }), f2 = createFloorNumber({ typed: t2, config: r, round: n });
  function p(e3) {
    var t22 = (e4, t3) => nearlyEqual(e4, t3, r.relTol, r.absTol), i22 = e3.floor(), a2 = n(e3);
    return i22.eq(a2) ? i22 : t22(e3, a2) && !t22(e3, i22) ? a2 : i22;
  }
  return t2("floor", { number: f2.signatures.number, "number,number": f2.signatures["number,number"], Complex: function(e3) {
    return e3.floor();
  }, "Complex, number": function(e3, t22) {
    return e3.floor(t22);
  }, "Complex, BigNumber": function(e3, t22) {
    return e3.floor(t22.toNumber());
  }, BigNumber: p, "BigNumber, BigNumber": function(e3, t22) {
    var r2 = bigTen.pow(t22);
    return p(e3.mul(r2)).div(r2);
  }, bigint: (e3) => e3, "bigint, number": (e3, t22) => e3, "bigint, BigNumber": (e3, t22) => e3, Fraction: function(e3) {
    return e3.floor();
  }, "Fraction, number": function(e3, t22) {
    return e3.floor(t22);
  }, "Fraction, BigNumber": function(e3, t22) {
    return e3.floor(t22.toNumber());
  }, "Unit, number, Unit": t2.referToSelf(((e3) => function(t22, r2, n3) {
    var i22 = t22.toNumeric(n3);
    return n3.multiply(e3(i22, r2));
  })), "Unit, BigNumber, Unit": t2.referToSelf(((e3) => (t22, r2, n3) => e3(t22, r2.toNumber(), n3))), "Array | Matrix, number | BigNumber, Unit": t2.referToSelf(((e3) => (t22, r2, n3) => deepMap(t22, ((t3) => e3(t3, r2, n3)), true))), "Array | Matrix | Unit, Unit": t2.referToSelf(((e3) => (t22, r2) => e3(t22, 0, r2))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3, true))), "Array, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => deepMap(t22, ((t3) => e3(t3, r2)), true))), "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => u(t22, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => l(t22, r2, e3, false))), "number | Complex | Fraction | BigNumber, Array": t2.referToSelf(((e3) => (t22, r2) => l(i2(r2), t22, e3, true).valueOf())), "number | Complex | Fraction | BigNumber, Matrix": t2.referToSelf(((e3) => (t22, r2) => a(t22, 0) ? o(r2.size(), r2.storage()) : "dense" === r2.storage() ? l(r2, t22, e3, true) : c2(r2, t22, e3, true))) });
})), name$4f = "matAlgo02xDS0", dependencies$4f = ["typed", "equalScalar"], createMatAlgo02xDS0 = factory(name$4f, dependencies$4f, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2, a) {
    var o = e3._data, s = e3._size, u = e3._datatype || e3.getDataType(), c2 = n._values, l = n._index, f2 = n._ptr, p = n._size, m = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (s.length !== p.length) throw new DimensionError(s.length, p.length);
    if (s[0] !== p[0] || s[1] !== p[1]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + p + ")");
    if (!c2) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var d, h = s[0], g = s[1], y = r, v2 = 0, x2 = i2;
    "string" == typeof u && u === m && "mixed" !== u && (d = u, y = t2.find(r, [d, d]), v2 = t2.convert(0, d), x2 = t2.find(i2, [d, d]));
    for (var b2 = [], _2 = [], w2 = [], A2 = 0; A2 < g; A2++) {
      w2[A2] = _2.length;
      for (var N = f2[A2], D = f2[A2 + 1], E = N; E < D; E++) {
        var $2 = l[E], S2 = a ? x2(c2[E], o[$2][A2]) : x2(o[$2][A2], c2[E]);
        y(S2, v2) || (_2.push($2), b2.push(S2));
      }
    }
    return w2[g] = _2.length, n.createSparseMatrix({ values: b2, index: _2, ptr: w2, size: [h, g], datatype: u === e3._datatype && m === n._datatype ? d : void 0 });
  };
})), name$4e = "matAlgo03xDSf", dependencies$4e = ["typed"], createMatAlgo03xDSf = factory(name$4e, dependencies$4e, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, r, n, i2) {
    var a = e3._data, o = e3._size, s = e3._datatype || e3.getDataType(), u = r._values, c2 = r._index, l = r._ptr, f2 = r._size, p = r._datatype || void 0 === r._data ? r._datatype : r.getDataType();
    if (o.length !== f2.length) throw new DimensionError(o.length, f2.length);
    if (o[0] !== f2[0] || o[1] !== f2[1]) throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + f2 + ")");
    if (!u) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var m, d = o[0], h = o[1], g = 0, y = n;
    "string" == typeof s && s === p && "mixed" !== s && (m = s, g = t2.convert(0, m), y = t2.find(n, [m, m]));
    for (var v2 = [], x2 = 0; x2 < d; x2++) v2[x2] = [];
    for (var b2 = [], _2 = [], w2 = 0; w2 < h; w2++) {
      for (var A2 = w2 + 1, N = l[w2], D = l[w2 + 1], E = N; E < D; E++) {
        var $2 = c2[E];
        b2[$2] = i2 ? y(u[E], a[$2][w2]) : y(a[$2][w2], u[E]), _2[$2] = A2;
      }
      for (var S2 = 0; S2 < d; S2++) _2[S2] === A2 ? v2[S2][w2] = b2[S2] : v2[S2][w2] = i2 ? y(g, a[S2][w2]) : y(a[S2][w2], g);
    }
    return e3.createDenseMatrix({ data: v2, size: [d, h], datatype: s === e3._datatype && p === r._datatype ? m : void 0 });
  };
})), name$4d = "matAlgo05xSfSf", dependencies$4d = ["typed", "equalScalar"], createMatAlgo05xSfSf = factory(name$4d, dependencies$4d, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._index, s = e3._ptr, u = e3._size, c2 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l = n._values, f2 = n._index, p = n._ptr, m = n._size, d = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (u.length !== m.length) throw new DimensionError(u.length, m.length);
    if (u[0] !== m[0] || u[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + m + ")");
    var h, g = u[0], y = u[1], v2 = r, x2 = 0, b2 = i2;
    "string" == typeof c2 && c2 === d && "mixed" !== c2 && (h = c2, v2 = t2.find(r, [h, h]), x2 = t2.convert(0, h), b2 = t2.find(i2, [h, h]));
    var _2, w2, A2, N, D = a && l ? [] : void 0, E = [], $2 = [], S2 = D ? [] : void 0, C2 = D ? [] : void 0, M2 = [], T2 = [];
    for (w2 = 0; w2 < y; w2++) {
      $2[w2] = E.length;
      var F = w2 + 1;
      for (A2 = s[w2], N = s[w2 + 1]; A2 < N; A2++) _2 = o[A2], E.push(_2), M2[_2] = F, S2 && (S2[_2] = a[A2]);
      for (A2 = p[w2], N = p[w2 + 1]; A2 < N; A2++) M2[_2 = f2[A2]] !== F && E.push(_2), T2[_2] = F, C2 && (C2[_2] = l[A2]);
      if (D) for (A2 = $2[w2]; A2 < E.length; ) {
        var O2 = M2[_2 = E[A2]], k2 = T2[_2];
        if (O2 === F || k2 === F) {
          var B2 = b2(O2 === F ? S2[_2] : x2, k2 === F ? C2[_2] : x2);
          v2(B2, x2) ? E.splice(A2, 1) : (D.push(B2), A2++);
        }
      }
    }
    return $2[y] = E.length, e3.createSparseMatrix({ values: D, index: E, ptr: $2, size: [g, y], datatype: c2 === e3._datatype && d === n._datatype ? h : void 0 });
  };
})), name$4c = "matAlgo13xDD", dependencies$4c = ["typed"], createMatAlgo13xDD = factory(name$4c, dependencies$4c, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, n, i2) {
    var a, o = e3._data, s = e3._size, u = e3._datatype, c2 = n._data, l = n._size, f2 = n._datatype, p = [];
    if (s.length !== l.length) throw new DimensionError(s.length, l.length);
    for (var m = 0; m < s.length; m++) {
      if (s[m] !== l[m]) throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + l + ")");
      p[m] = s[m];
    }
    var d = i2;
    "string" == typeof u && u === f2 && (a = u, d = t2.find(i2, [a, a]));
    var h = p.length > 0 ? r(d, 0, p, p[0], o, c2) : [];
    return e3.createDenseMatrix({ data: h, size: p, datatype: a });
  };
  function r(e3, t22, n, i2, a, o) {
    var s = [];
    if (t22 === n.length - 1) for (var u = 0; u < i2; u++) s[u] = e3(a[u], o[u]);
    else for (var c2 = 0; c2 < i2; c2++) s[c2] = r(e3, t22 + 1, n, n[t22 + 1], a[c2], o[c2]);
    return s;
  }
}));
function broadcast(e2, t2) {
  if (deepStrictEqual(e2.size(), t2.size())) return [e2, t2];
  var r = broadcastSizes(e2.size(), t2.size());
  return [e2, t2].map(((e3) => _broadcastTo(e3, r)));
}
function _broadcastTo(e2, t2) {
  return deepStrictEqual(e2.size(), t2) ? e2 : e2.create(broadcastTo(e2.valueOf(), t2), e2.datatype());
}
var name$4b = "matrixAlgorithmSuite", dependencies$4b = ["typed", "matrix"], createMatrixAlgorithmSuite = factory(name$4b, dependencies$4b, ((e2) => {
  var { typed: t2, matrix: r } = e2, n = createMatAlgo13xDD({ typed: t2 }), i2 = createMatAlgo14xDs({ typed: t2 });
  return function(e3) {
    var a, o = e3.elop, s = e3.SD || e3.DS;
    o ? (a = { "DenseMatrix, DenseMatrix": (e4, t22) => n(...broadcast(e4, t22), o), "Array, Array": (e4, t22) => n(...broadcast(r(e4), r(t22)), o).valueOf(), "Array, DenseMatrix": (e4, t22) => n(...broadcast(r(e4), t22), o), "DenseMatrix, Array": (e4, t22) => n(...broadcast(e4, r(t22)), o) }, e3.SS && (a["SparseMatrix, SparseMatrix"] = (t22, r2) => e3.SS(...broadcast(t22, r2), o, false)), e3.DS && (a["DenseMatrix, SparseMatrix"] = (t22, r2) => e3.DS(...broadcast(t22, r2), o, false), a["Array, SparseMatrix"] = (t22, n3) => e3.DS(...broadcast(r(t22), n3), o, false)), s && (a["SparseMatrix, DenseMatrix"] = (e4, t22) => s(...broadcast(t22, e4), o, true), a["SparseMatrix, Array"] = (e4, t22) => s(...broadcast(r(t22), e4), o, true))) : (a = { "DenseMatrix, DenseMatrix": t2.referToSelf(((e4) => (t22, r2) => n(...broadcast(t22, r2), e4))), "Array, Array": t2.referToSelf(((e4) => (t22, i22) => n(...broadcast(r(t22), r(i22)), e4).valueOf())), "Array, DenseMatrix": t2.referToSelf(((e4) => (t22, i22) => n(...broadcast(r(t22), i22), e4))), "DenseMatrix, Array": t2.referToSelf(((e4) => (t22, i22) => n(...broadcast(t22, r(i22)), e4))) }, e3.SS && (a["SparseMatrix, SparseMatrix"] = t2.referToSelf(((t22) => (r2, n3) => e3.SS(...broadcast(r2, n3), t22, false)))), e3.DS && (a["DenseMatrix, SparseMatrix"] = t2.referToSelf(((t22) => (r2, n3) => e3.DS(...broadcast(r2, n3), t22, false))), a["Array, SparseMatrix"] = t2.referToSelf(((t22) => (n3, i22) => e3.DS(...broadcast(r(n3), i22), t22, false)))), s && (a["SparseMatrix, DenseMatrix"] = t2.referToSelf(((e4) => (t22, r2) => s(...broadcast(r2, t22), e4, true))), a["SparseMatrix, Array"] = t2.referToSelf(((e4) => (t22, n3) => s(...broadcast(r(n3), t22), e4, true)))));
    var u = e3.scalar || "any";
    (e3.Ds || e3.Ss) && (o ? (a["DenseMatrix," + u] = (e4, t22) => i2(e4, t22, o, false), a[u + ", DenseMatrix"] = (e4, t22) => i2(t22, e4, o, true), a["Array," + u] = (e4, t22) => i2(r(e4), t22, o, false).valueOf(), a[u + ", Array"] = (e4, t22) => i2(r(t22), e4, o, true).valueOf()) : (a["DenseMatrix," + u] = t2.referToSelf(((e4) => (t22, r2) => i2(t22, r2, e4, false))), a[u + ", DenseMatrix"] = t2.referToSelf(((e4) => (t22, r2) => i2(r2, t22, e4, true))), a["Array," + u] = t2.referToSelf(((e4) => (t22, n3) => i2(r(t22), n3, e4, false).valueOf())), a[u + ", Array"] = t2.referToSelf(((e4) => (t22, n3) => i2(r(n3), t22, e4, true).valueOf()))));
    var c2 = void 0 !== e3.sS ? e3.sS : e3.Ss;
    return o ? (e3.Ss && (a["SparseMatrix," + u] = (t22, r2) => e3.Ss(t22, r2, o, false)), c2 && (a[u + ", SparseMatrix"] = (e4, t22) => c2(t22, e4, o, true))) : (e3.Ss && (a["SparseMatrix," + u] = t2.referToSelf(((t22) => (r2, n3) => e3.Ss(r2, n3, t22, false)))), c2 && (a[u + ", SparseMatrix"] = t2.referToSelf(((e4) => (t22, r2) => c2(r2, t22, e4, true))))), o && o.signatures && extend$2(a, o.signatures), a;
  };
})), name$4a = "mod", dependencies$4a = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createMod = factory(name$4a, dependencies$4a, ((e2) => {
  var { typed: t2, config: r, round: n, matrix: i2, equalScalar: a, zeros: o, DenseMatrix: s, concat: u } = e2, c2 = createFloor({ typed: t2, config: r, round: n, matrix: i2, equalScalar: a, zeros: o, DenseMatrix: s }), l = createMatAlgo02xDS0({ typed: t2, equalScalar: a }), f2 = createMatAlgo03xDSf({ typed: t2 }), p = createMatAlgo05xSfSf({ typed: t2, equalScalar: a }), m = createMatAlgo11xS0s({ typed: t2, equalScalar: a }), d = createMatAlgo12xSfs({ typed: t2, DenseMatrix: s }), h = createMatrixAlgorithmSuite({ typed: t2, matrix: i2, concat: u });
  return t2(name$4a, { "number, number": function(e3, t22) {
    return 0 === t22 ? e3 : e3 - t22 * c2(e3 / t22);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return t22.isZero() ? e3 : e3.sub(t22.mul(c2(e3.div(t22))));
  }, "bigint, bigint": function(e3, t22) {
    if (0n === t22) return e3;
    if (e3 < 0) {
      var r2 = e3 % t22;
      return 0n === r2 ? r2 : r2 + t22;
    }
    return e3 % t22;
  }, "Fraction, Fraction": function(e3, t22) {
    return t22.equals(0) ? e3 : e3.sub(t22.mul(c2(e3.div(t22))));
  } }, h({ SS: p, DS: f2, SD: l, Ss: m, sS: d }));
})), name$49 = "matAlgo01xDSid", dependencies$49 = ["typed"], createMatAlgo01xDSid = factory(name$49, dependencies$49, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, r, n, i2) {
    var a = e3._data, o = e3._size, s = e3._datatype || e3.getDataType(), u = r._values, c2 = r._index, l = r._ptr, f2 = r._size, p = r._datatype || void 0 === r._data ? r._datatype : r.getDataType();
    if (o.length !== f2.length) throw new DimensionError(o.length, f2.length);
    if (o[0] !== f2[0] || o[1] !== f2[1]) throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + f2 + ")");
    if (!u) throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var m, d, h = o[0], g = o[1], y = "string" == typeof s && "mixed" !== s && s === p ? s : void 0, v2 = y ? t2.find(n, [y, y]) : n, x2 = [];
    for (m = 0; m < h; m++) x2[m] = [];
    var b2 = [], _2 = [];
    for (d = 0; d < g; d++) {
      for (var w2 = d + 1, A2 = l[d], N = l[d + 1], D = A2; D < N; D++) b2[m = c2[D]] = i2 ? v2(u[D], a[m][d]) : v2(a[m][d], u[D]), _2[m] = w2;
      for (m = 0; m < h; m++) _2[m] === w2 ? x2[m][d] = b2[m] : x2[m][d] = a[m][d];
    }
    return e3.createDenseMatrix({ data: x2, size: [h, g], datatype: s === e3._datatype && p === r._datatype ? y : void 0 });
  };
})), name$48 = "matAlgo04xSidSid", dependencies$48 = ["typed", "equalScalar"], createMatAlgo04xSidSid = factory(name$48, dependencies$48, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._index, s = e3._ptr, u = e3._size, c2 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l = n._values, f2 = n._index, p = n._ptr, m = n._size, d = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (u.length !== m.length) throw new DimensionError(u.length, m.length);
    if (u[0] !== m[0] || u[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + m + ")");
    var h, g = u[0], y = u[1], v2 = r, x2 = 0, b2 = i2;
    "string" == typeof c2 && c2 === d && "mixed" !== c2 && (h = c2, v2 = t2.find(r, [h, h]), x2 = t2.convert(0, h), b2 = t2.find(i2, [h, h]));
    var _2, w2, A2, N, D, E = a && l ? [] : void 0, $2 = [], S2 = [], C2 = a && l ? [] : void 0, M2 = a && l ? [] : void 0, T2 = [], F = [];
    for (w2 = 0; w2 < y; w2++) {
      S2[w2] = $2.length;
      var O2 = w2 + 1;
      for (N = s[w2], D = s[w2 + 1], A2 = N; A2 < D; A2++) _2 = o[A2], $2.push(_2), T2[_2] = O2, C2 && (C2[_2] = a[A2]);
      for (N = p[w2], D = p[w2 + 1], A2 = N; A2 < D; A2++) if (T2[_2 = f2[A2]] === O2) {
        if (C2) {
          var k2 = b2(C2[_2], l[A2]);
          v2(k2, x2) ? T2[_2] = null : C2[_2] = k2;
        }
      } else $2.push(_2), F[_2] = O2, M2 && (M2[_2] = l[A2]);
      if (C2 && M2) for (A2 = S2[w2]; A2 < $2.length; ) T2[_2 = $2[A2]] === O2 ? (E[A2] = C2[_2], A2++) : F[_2] === O2 ? (E[A2] = M2[_2], A2++) : $2.splice(A2, 1);
    }
    return S2[y] = $2.length, e3.createSparseMatrix({ values: E, index: $2, ptr: S2, size: [g, y], datatype: c2 === e3._datatype && d === n._datatype ? h : void 0 });
  };
})), name$47 = "matAlgo10xSids", dependencies$47 = ["typed", "DenseMatrix"], createMatAlgo10xSids = factory(name$47, dependencies$47, ((e2) => {
  var { typed: t2, DenseMatrix: r } = e2;
  return function(e3, n, i2, a) {
    var o = e3._values, s = e3._index, u = e3._ptr, c2 = e3._size, l = e3._datatype;
    if (!o) throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var f2, p = c2[0], m = c2[1], d = i2;
    "string" == typeof l && (f2 = l, n = t2.convert(n, f2), d = t2.find(i2, [f2, f2]));
    for (var h = [], g = [], y = [], v2 = 0; v2 < m; v2++) {
      for (var x2 = v2 + 1, b2 = u[v2], _2 = u[v2 + 1], w2 = b2; w2 < _2; w2++) {
        var A2 = s[w2];
        g[A2] = o[w2], y[A2] = x2;
      }
      for (var N = 0; N < p; N++) 0 === v2 && (h[N] = []), y[N] === x2 ? h[N][v2] = a ? d(n, g[N]) : d(g[N], n) : h[N][v2] = n;
    }
    return new r({ data: h, size: [p, m], datatype: f2 });
  };
}));
function ArgumentsError(e2, t2, r, n) {
  if (!(this instanceof ArgumentsError)) throw new SyntaxError("Constructor must be called with the new operator");
  this.fn = e2, this.count = t2, this.min = r, this.max = n, this.message = "Wrong number of arguments in function " + e2 + " (" + t2 + " provided, " + r + (null != n ? "-" + n : "") + " expected)", this.stack = new Error().stack;
}
ArgumentsError.prototype = new Error(), ArgumentsError.prototype.constructor = Error, ArgumentsError.prototype.name = "ArgumentsError", ArgumentsError.prototype.isArgumentsError = true;
var name$46 = "gcd", dependencies$46 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix", "concat"], gcdTypes = "number | BigNumber | Fraction | Matrix | Array", gcdManyTypesSignature = "".concat(gcdTypes, ", ").concat(gcdTypes, ", ...").concat(gcdTypes);
function is1d(e2) {
  return !e2.some(((e3) => Array.isArray(e3)));
}
var createGcd = factory(name$46, dependencies$46, ((e2) => {
  var { typed: t2, matrix: r, config: n, round: i2, equalScalar: a, zeros: o, BigNumber: s, DenseMatrix: u, concat: c2 } = e2, l = createMod({ typed: t2, config: n, round: i2, matrix: r, equalScalar: a, zeros: o, DenseMatrix: u, concat: c2 }), f2 = createMatAlgo01xDSid({ typed: t2 }), p = createMatAlgo04xSidSid({ typed: t2, equalScalar: a }), m = createMatAlgo10xSids({ typed: t2, DenseMatrix: u }), d = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: c2 });
  return t2(name$46, { "number, number": function(e3, t22) {
    if (!isInteger(e3) || !isInteger(t22)) throw new Error("Parameters in function gcd must be integer numbers");
    var r2;
    for (; 0 !== t22; ) r2 = l(e3, t22), e3 = t22, t22 = r2;
    return e3 < 0 ? -e3 : e3;
  }, "BigNumber, BigNumber": function(e3, t22) {
    if (!e3.isInt() || !t22.isInt()) throw new Error("Parameters in function gcd must be integer numbers");
    var r2 = new s(0);
    for (; !t22.isZero(); ) {
      var n3 = l(e3, t22);
      e3 = t22, t22 = n3;
    }
    return e3.lt(r2) ? e3.neg() : e3;
  }, "Fraction, Fraction": (e3, t22) => e3.gcd(t22) }, d({ SS: p, DS: f2, Ss: m }), { [gcdManyTypesSignature]: t2.referToSelf(((e3) => (t22, r2, n3) => {
    for (var i22 = e3(t22, r2), a2 = 0; a2 < n3.length; a2++) i22 = e3(i22, n3[a2]);
    return i22;
  })), Array: t2.referToSelf(((e3) => (t22) => {
    if (1 === t22.length && Array.isArray(t22[0]) && is1d(t22[0])) return e3(...t22[0]);
    if (is1d(t22)) return e3(...t22);
    throw new ArgumentsError("gcd() supports only 1d matrices!");
  })), Matrix: t2.referToSelf(((e3) => (t22) => e3(t22.toArray()))) });
})), name$45 = "matAlgo06xS0S0", dependencies$45 = ["typed", "equalScalar"], createMatAlgo06xS0S0 = factory(name$45, dependencies$45, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._size, s = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), u = n._values, c2 = n._size, l = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (o.length !== c2.length) throw new DimensionError(o.length, c2.length);
    if (o[0] !== c2[0] || o[1] !== c2[1]) throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + c2 + ")");
    var f2, p = o[0], m = o[1], d = r, h = 0, g = i2;
    "string" == typeof s && s === l && "mixed" !== s && (f2 = s, d = t2.find(r, [f2, f2]), h = t2.convert(0, f2), g = t2.find(i2, [f2, f2]));
    for (var y = a && u ? [] : void 0, v2 = [], x2 = [], b2 = y ? [] : void 0, _2 = [], w2 = [], A2 = 0; A2 < m; A2++) {
      x2[A2] = v2.length;
      var N = A2 + 1;
      if (scatter(e3, A2, _2, b2, w2, N, v2, g), scatter(n, A2, _2, b2, w2, N, v2, g), b2) for (var D = x2[A2]; D < v2.length; ) {
        var E = v2[D];
        if (w2[E] === N) {
          var $2 = b2[E];
          d($2, h) ? v2.splice(D, 1) : (y.push($2), D++);
        } else v2.splice(D, 1);
      }
      else for (var S2 = x2[A2]; S2 < v2.length; ) {
        w2[v2[S2]] !== N ? v2.splice(S2, 1) : S2++;
      }
    }
    return x2[m] = v2.length, e3.createSparseMatrix({ values: y, index: v2, ptr: x2, size: [p, m], datatype: s === e3._datatype && l === n._datatype ? f2 : void 0 });
  };
})), name$44 = "lcm", dependencies$44 = ["typed", "matrix", "equalScalar", "concat"], createLcm = factory(name$44, dependencies$44, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, concat: i2 } = e2, a = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), o = createMatAlgo06xS0S0({ typed: t2, equalScalar: n }), s = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), u = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: i2 }), c2 = "number | BigNumber | Fraction | Matrix | Array", l = {};
  return l["".concat(c2, ", ").concat(c2, ", ...").concat(c2)] = t2.referToSelf(((e3) => (t22, r2, n3) => {
    for (var i22 = e3(t22, r2), a2 = 0; a2 < n3.length; a2++) i22 = e3(i22, n3[a2]);
    return i22;
  })), t2(name$44, { "number, number": lcmNumber, "BigNumber, BigNumber": function(e3, t22) {
    if (!e3.isInt() || !t22.isInt()) throw new Error("Parameters in function lcm must be integer numbers");
    if (e3.isZero()) return e3;
    if (t22.isZero()) return t22;
    var r2 = e3.times(t22);
    for (; !t22.isZero(); ) {
      var n3 = t22;
      t22 = e3.mod(n3), e3 = n3;
    }
    return r2.div(e3).abs();
  }, "Fraction, Fraction": (e3, t22) => e3.lcm(t22) }, u({ SS: o, DS: a, Ss: s }), l);
}));
function promoteLogarithm(e2, t2, r, n) {
  return function(i2) {
    if (i2 > 0 || r.predictable) {
      if (i2 <= 0) return NaN;
      var a = i2.toString(16), o = a.substring(0, 15);
      return e2 * (a.length - o.length) + t2(Number("0x" + o));
    }
    return n(i2.toNumber());
  };
}
var name$43 = "log10", dependencies$43 = ["typed", "config", "Complex"], log16 = log10Number(16), createLog10 = factory(name$43, dependencies$43, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  function i2(e3) {
    return e3.log().div(Math.LN10);
  }
  function a(e3) {
    return i2(new n(e3, 0));
  }
  return t2(name$43, { number: function(e3) {
    return e3 >= 0 || r.predictable ? log10Number(e3) : a(e3);
  }, bigint: promoteLogarithm(log16, log10Number, r, a), Complex: i2, BigNumber: function(e3) {
    return !e3.isNegative() || r.predictable ? e3.log() : a(e3.toNumber());
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$42 = "log2", dependencies$42 = ["typed", "config", "Complex"], createLog2 = factory(name$42, dependencies$42, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  function i2(e3) {
    return a(new n(e3, 0));
  }
  return t2(name$42, { number: function(e3) {
    return e3 >= 0 || r.predictable ? log2Number(e3) : i2(e3);
  }, bigint: promoteLogarithm(4, log2Number, r, i2), Complex: a, BigNumber: function(e3) {
    return !e3.isNegative() || r.predictable ? e3.log(2) : i2(e3.toNumber());
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
  function a(e3) {
    var t22 = Math.sqrt(e3.re * e3.re + e3.im * e3.im);
    return new n(Math.log2 ? Math.log2(t22) : Math.log(t22) / Math.LN2, Math.atan2(e3.im, e3.re) / Math.LN2);
  }
})), name$41 = "multiplyScalar", dependencies$41 = ["typed"], createMultiplyScalar = factory(name$41, dependencies$41, ((e2) => {
  var { typed: t2 } = e2;
  return t2("multiplyScalar", { "number, number": multiplyNumber, "Complex, Complex": function(e3, t22) {
    return e3.mul(t22);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return e3.times(t22);
  }, "bigint, bigint": function(e3, t22) {
    return e3 * t22;
  }, "Fraction, Fraction": function(e3, t22) {
    return e3.mul(t22);
  }, "number | Fraction | BigNumber | Complex, Unit": (e3, t22) => t22.multiply(e3), "Unit, number | Fraction | BigNumber | Complex | Unit": (e3, t22) => e3.multiply(t22) });
})), name$40 = "multiply", dependencies$40 = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], createMultiply = factory(name$40, dependencies$40, ((e2) => {
  var { typed: t2, matrix: r, addScalar: n, multiplyScalar: i2, equalScalar: a, dot: o } = e2, s = createMatAlgo11xS0s({ typed: t2, equalScalar: a }), u = createMatAlgo14xDs({ typed: t2 });
  function c2(e3, t22) {
    switch (e3.length) {
      case 1:
        switch (t22.length) {
          case 1:
            if (e3[0] !== t22[0]) throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (e3[0] !== t22[0]) throw new RangeError("Dimension mismatch in multiplication. Vector length (" + e3[0] + ") must match Matrix rows (" + t22[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + t22.length + " dimensions)");
        }
        break;
      case 2:
        switch (t22.length) {
          case 1:
            if (e3[1] !== t22[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + e3[1] + ") must match Vector length (" + t22[0] + ")");
            break;
          case 2:
            if (e3[1] !== t22[0]) throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + e3[1] + ") must match Matrix B rows (" + t22[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + t22.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + e3.length + " dimensions)");
    }
  }
  function l(e3, r2) {
    if ("dense" !== r2.storage()) throw new Error("Support for SparseMatrix not implemented");
    return (function(e4, r3) {
      var a2, o2 = e4._data, s2 = e4._size, u2 = e4._datatype || e4.getDataType(), c3 = r3._data, l2 = r3._size, f3 = r3._datatype || r3.getDataType(), p2 = s2[0], m = l2[1], d = n, h = i2;
      u2 && f3 && u2 === f3 && "string" == typeof u2 && "mixed" !== u2 && (a2 = u2, d = t2.find(n, [a2, a2]), h = t2.find(i2, [a2, a2]));
      for (var g = [], y = 0; y < m; y++) {
        for (var v2 = h(o2[0], c3[0][y]), x2 = 1; x2 < p2; x2++) v2 = d(v2, h(o2[x2], c3[x2][y]));
        g[y] = v2;
      }
      return e4.createDenseMatrix({ data: g, size: [m], datatype: u2 === e4._datatype && f3 === r3._datatype ? a2 : void 0 });
    })(e3, r2);
  }
  var f2 = t2("_multiplyMatrixVector", { "DenseMatrix, any": function(e3, r2) {
    var a2, o2 = e3._data, s2 = e3._size, u2 = e3._datatype || e3.getDataType(), c3 = r2._data, l2 = r2._datatype || r2.getDataType(), f3 = s2[0], p2 = s2[1], m = n, d = i2;
    u2 && l2 && u2 === l2 && "string" == typeof u2 && "mixed" !== u2 && (a2 = u2, m = t2.find(n, [a2, a2]), d = t2.find(i2, [a2, a2]));
    for (var h = [], g = 0; g < f3; g++) {
      for (var y = o2[g], v2 = d(y[0], c3[0]), x2 = 1; x2 < p2; x2++) v2 = m(v2, d(y[x2], c3[x2]));
      h[g] = v2;
    }
    return e3.createDenseMatrix({ data: h, size: [f3], datatype: u2 === e3._datatype && l2 === r2._datatype ? a2 : void 0 });
  }, "SparseMatrix, any": function(e3, r2) {
    var o2 = e3._values, s2 = e3._index, u2 = e3._ptr, c3 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType();
    if (!o2) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var l2, f3 = r2._data, p2 = r2._datatype || r2.getDataType(), m = e3._size[0], d = r2._size[0], h = [], g = [], y = [], v2 = n, x2 = i2, b2 = a, _2 = 0;
    c3 && p2 && c3 === p2 && "string" == typeof c3 && "mixed" !== c3 && (l2 = c3, v2 = t2.find(n, [l2, l2]), x2 = t2.find(i2, [l2, l2]), b2 = t2.find(a, [l2, l2]), _2 = t2.convert(0, l2));
    var w2 = [], A2 = [];
    y[0] = 0;
    for (var N = 0; N < d; N++) {
      var D = f3[N];
      if (!b2(D, _2)) for (var E = u2[N], $2 = u2[N + 1], S2 = E; S2 < $2; S2++) {
        var C2 = s2[S2];
        A2[C2] ? w2[C2] = v2(w2[C2], x2(D, o2[S2])) : (A2[C2] = true, g.push(C2), w2[C2] = x2(D, o2[S2]));
      }
    }
    for (var M2 = g.length, T2 = 0; T2 < M2; T2++) {
      var F = g[T2];
      h[T2] = w2[F];
    }
    return y[1] = g.length, e3.createSparseMatrix({ values: h, index: g, ptr: y, size: [m, 1], datatype: c3 === e3._datatype && p2 === r2._datatype ? l2 : void 0 });
  } }), p = t2("_multiplyMatrixMatrix", { "DenseMatrix, DenseMatrix": function(e3, r2) {
    var a2, o2 = e3._data, s2 = e3._size, u2 = e3._datatype || e3.getDataType(), c3 = r2._data, l2 = r2._size, f3 = r2._datatype || r2.getDataType(), p2 = s2[0], m = s2[1], d = l2[1], h = n, g = i2;
    u2 && f3 && u2 === f3 && "string" == typeof u2 && "mixed" !== u2 && "mixed" !== u2 && (a2 = u2, h = t2.find(n, [a2, a2]), g = t2.find(i2, [a2, a2]));
    for (var y = [], v2 = 0; v2 < p2; v2++) {
      var x2 = o2[v2];
      y[v2] = [];
      for (var b2 = 0; b2 < d; b2++) {
        for (var _2 = g(x2[0], c3[0][b2]), w2 = 1; w2 < m; w2++) _2 = h(_2, g(x2[w2], c3[w2][b2]));
        y[v2][b2] = _2;
      }
    }
    return e3.createDenseMatrix({ data: y, size: [p2, d], datatype: u2 === e3._datatype && f3 === r2._datatype ? a2 : void 0 });
  }, "DenseMatrix, SparseMatrix": function(e3, r2) {
    var o2 = e3._data, s2 = e3._size, u2 = e3._datatype || e3.getDataType(), c3 = r2._values, l2 = r2._index, f3 = r2._ptr, p2 = r2._size, m = r2._datatype || void 0 === r2._data ? r2._datatype : r2.getDataType();
    if (!c3) throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var d, h = s2[0], g = p2[1], y = n, v2 = i2, x2 = a, b2 = 0;
    u2 && m && u2 === m && "string" == typeof u2 && "mixed" !== u2 && (d = u2, y = t2.find(n, [d, d]), v2 = t2.find(i2, [d, d]), x2 = t2.find(a, [d, d]), b2 = t2.convert(0, d));
    for (var _2 = [], w2 = [], A2 = [], N = r2.createSparseMatrix({ values: _2, index: w2, ptr: A2, size: [h, g], datatype: u2 === e3._datatype && m === r2._datatype ? d : void 0 }), D = 0; D < g; D++) {
      A2[D] = w2.length;
      var E = f3[D], $2 = f3[D + 1];
      if ($2 > E) for (var S2 = 0, C2 = 0; C2 < h; C2++) {
        for (var M2 = C2 + 1, T2 = void 0, F = E; F < $2; F++) {
          var O2 = l2[F];
          S2 !== M2 ? (T2 = v2(o2[C2][O2], c3[F]), S2 = M2) : T2 = y(T2, v2(o2[C2][O2], c3[F]));
        }
        S2 !== M2 || x2(T2, b2) || (w2.push(C2), _2.push(T2));
      }
    }
    return A2[g] = w2.length, N;
  }, "SparseMatrix, DenseMatrix": function(e3, r2) {
    var o2 = e3._values, s2 = e3._index, u2 = e3._ptr, c3 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType();
    if (!o2) throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var l2, f3 = r2._data, p2 = r2._datatype || r2.getDataType(), m = e3._size[0], d = r2._size[0], h = r2._size[1], g = n, y = i2, v2 = a, x2 = 0;
    c3 && p2 && c3 === p2 && "string" == typeof c3 && "mixed" !== c3 && (l2 = c3, g = t2.find(n, [l2, l2]), y = t2.find(i2, [l2, l2]), v2 = t2.find(a, [l2, l2]), x2 = t2.convert(0, l2));
    for (var b2 = [], _2 = [], w2 = [], A2 = e3.createSparseMatrix({ values: b2, index: _2, ptr: w2, size: [m, h], datatype: c3 === e3._datatype && p2 === r2._datatype ? l2 : void 0 }), N = [], D = [], E = 0; E < h; E++) {
      w2[E] = _2.length;
      for (var $2 = E + 1, S2 = 0; S2 < d; S2++) {
        var C2 = f3[S2][E];
        if (!v2(C2, x2)) for (var M2 = u2[S2], T2 = u2[S2 + 1], F = M2; F < T2; F++) {
          var O2 = s2[F];
          D[O2] !== $2 ? (D[O2] = $2, _2.push(O2), N[O2] = y(C2, o2[F])) : N[O2] = g(N[O2], y(C2, o2[F]));
        }
      }
      for (var k2 = w2[E], B2 = _2.length, I2 = k2; I2 < B2; I2++) {
        var R2 = _2[I2];
        b2[I2] = N[R2];
      }
    }
    return w2[h] = _2.length, A2;
  }, "SparseMatrix, SparseMatrix": function(e3, r2) {
    var a2, o2 = e3._values, s2 = e3._index, u2 = e3._ptr, c3 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l2 = r2._values, f3 = r2._index, p2 = r2._ptr, m = r2._datatype || void 0 === r2._data ? r2._datatype : r2.getDataType(), d = e3._size[0], h = r2._size[1], g = o2 && l2, y = n, v2 = i2;
    c3 && m && c3 === m && "string" == typeof c3 && "mixed" !== c3 && (a2 = c3, y = t2.find(n, [a2, a2]), v2 = t2.find(i2, [a2, a2]));
    for (var x2, b2, _2, w2, A2, N, D, E, $2 = g ? [] : void 0, S2 = [], C2 = [], M2 = e3.createSparseMatrix({ values: $2, index: S2, ptr: C2, size: [d, h], datatype: c3 === e3._datatype && m === r2._datatype ? a2 : void 0 }), T2 = g ? [] : void 0, F = [], O2 = 0; O2 < h; O2++) {
      C2[O2] = S2.length;
      var k2 = O2 + 1;
      for (A2 = p2[O2], N = p2[O2 + 1], w2 = A2; w2 < N; w2++) if (E = f3[w2], g) for (b2 = u2[E], _2 = u2[E + 1], x2 = b2; x2 < _2; x2++) F[D = s2[x2]] !== k2 ? (F[D] = k2, S2.push(D), T2[D] = v2(l2[w2], o2[x2])) : T2[D] = y(T2[D], v2(l2[w2], o2[x2]));
      else for (b2 = u2[E], _2 = u2[E + 1], x2 = b2; x2 < _2; x2++) F[D = s2[x2]] !== k2 && (F[D] = k2, S2.push(D));
      if (g) for (var B2 = C2[O2], I2 = S2.length, R2 = B2; R2 < I2; R2++) {
        var q2 = S2[R2];
        $2[R2] = T2[q2];
      }
    }
    return C2[h] = S2.length, M2;
  } });
  return t2(name$40, i2, { "Array, Array": t2.referTo("Matrix, Matrix", ((e3) => (t22, n3) => {
    c2(arraySize(t22), arraySize(n3));
    var i22 = e3(r(t22), r(n3));
    return isMatrix(i22) ? i22.valueOf() : i22;
  })), "Matrix, Matrix": function(e3, t22) {
    var r2 = e3.size(), n3 = t22.size();
    return c2(r2, n3), 1 === r2.length ? 1 === n3.length ? (function(e4, t3, r3) {
      if (0 === r3) throw new Error("Cannot multiply two empty vectors");
      return o(e4, t3);
    })(e3, t22, r2[0]) : l(e3, t22) : 1 === n3.length ? f2(e3, t22) : p(e3, t22);
  }, "Matrix, Array": t2.referTo("Matrix,Matrix", ((e3) => (t22, n3) => e3(t22, r(n3)))), "Array, Matrix": t2.referToSelf(((e3) => (t22, n3) => e3(r(t22, n3.storage()), n3))), "SparseMatrix, any": function(e3, t22) {
    return s(e3, t22, i2, false);
  }, "DenseMatrix, any": function(e3, t22) {
    return u(e3, t22, i2, false);
  }, "any, SparseMatrix": function(e3, t22) {
    return s(t22, e3, i2, true);
  }, "any, DenseMatrix": function(e3, t22) {
    return u(t22, e3, i2, true);
  }, "Array, any": function(e3, t22) {
    return u(r(e3), t22, i2, false).valueOf();
  }, "any, Array": function(e3, t22) {
    return u(r(t22), e3, i2, true).valueOf();
  }, "any, any": i2, "any, any, ...any": t2.referToSelf(((e3) => (t22, r2, n3) => {
    for (var i22 = e3(t22, r2), a2 = 0; a2 < n3.length; a2++) i22 = e3(i22, n3[a2]);
    return i22;
  })) });
})), name$3$ = "nthRoot", dependencies$3$ = ["typed", "matrix", "equalScalar", "BigNumber", "concat"], createNthRoot = factory(name$3$, dependencies$3$, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, BigNumber: i2, concat: a } = e2, o = createMatAlgo01xDSid({ typed: t2 }), s = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), u = createMatAlgo06xS0S0({ typed: t2, equalScalar: n }), c2 = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), l = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: a });
  function f2() {
    throw new Error("Complex number not supported in function nthRoot. Use nthRoots instead.");
  }
  return t2(name$3$, { number: nthRootNumber, "number, number": nthRootNumber, BigNumber: (e3) => p(e3, new i2(2)), "BigNumber, BigNumber": p, Complex: f2, "Complex, number": f2, Array: t2.referTo("DenseMatrix,number", ((e3) => (t22) => e3(r(t22), 2).valueOf())), DenseMatrix: t2.referTo("DenseMatrix,number", ((e3) => (t22) => e3(t22, 2))), SparseMatrix: t2.referTo("SparseMatrix,number", ((e3) => (t22) => e3(t22, 2))), "SparseMatrix, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => {
    if (1 === r2.density()) return u(t22, r2, e3);
    throw new Error("Root must be non-zero");
  })), "DenseMatrix, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => {
    if (1 === r2.density()) return o(t22, r2, e3, false);
    throw new Error("Root must be non-zero");
  })), "Array, SparseMatrix": t2.referTo("DenseMatrix,SparseMatrix", ((e3) => (t22, n3) => e3(r(t22), n3))), "number | BigNumber, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => {
    if (1 === r2.density()) return c2(r2, t22, e3, true);
    throw new Error("Root must be non-zero");
  })) }, l({ scalar: "number | BigNumber", SD: s, Ss: c2, sS: false }));
  function p(e3, t22) {
    var r2 = i2.precision, n3 = i2.clone({ precision: r2 + 2 }), a2 = new i2(0), o2 = new n3(1), s2 = t22.isNegative();
    if (s2 && (t22 = t22.neg()), t22.isZero()) throw new Error("Root must be non-zero");
    if (e3.isNegative() && !t22.abs().mod(2).equals(1)) throw new Error("Root must be odd when a is negative.");
    if (e3.isZero()) return s2 ? new n3(1 / 0) : 0;
    if (!e3.isFinite()) return s2 ? a2 : e3;
    var u2 = e3.abs().pow(o2.div(t22));
    return u2 = e3.isNeg() ? u2.neg() : u2, new i2((s2 ? o2.div(u2) : u2).toPrecision(r2));
  }
})), name$3_ = "sign", dependencies$3_ = ["typed", "BigNumber", "Fraction", "complex"], createSign = factory(name$3_, dependencies$3_, ((e2) => {
  var { typed: t2, BigNumber: r, complex: n, Fraction: i2 } = e2;
  return t2(name$3_, { number: signNumber, Complex: function(e3) {
    return 0 === e3.im ? n(signNumber(e3.re)) : e3.sign();
  }, BigNumber: function(e3) {
    return new r(e3.cmp(0));
  }, bigint: function(e3) {
    return e3 > 0n ? 1n : e3 < 0n ? -1n : 0n;
  }, Fraction: function(e3) {
    return 0n === e3.n ? new i2(0) : new i2(e3.s);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3, true))), Unit: t2.referToSelf(((e3) => (r2) => {
    if (!r2._isDerived() && 0 !== r2.units[0].unit.offset) throw new TypeError("sign is ambiguous for units with offset");
    return t2.find(e3, r2.valueType())(r2.value);
  })) });
})), name$3Z = "sqrt", dependencies$3Z = ["config", "typed", "Complex"], createSqrt = factory(name$3Z, dependencies$3Z, ((e2) => {
  var { config: t2, typed: r, Complex: n } = e2;
  return r("sqrt", { number: i2, Complex: function(e3) {
    return e3.sqrt();
  }, BigNumber: function(e3) {
    return !e3.isNegative() || t2.predictable ? e3.sqrt() : i2(e3.toNumber());
  }, Unit: function(e3) {
    return e3.pow(0.5);
  } });
  function i2(e3) {
    return isNaN(e3) ? NaN : e3 >= 0 || t2.predictable ? Math.sqrt(e3) : new n(e3, 0).sqrt();
  }
})), name$3Y = "square", dependencies$3Y = ["typed"], createSquare = factory(name$3Y, dependencies$3Y, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3Y, { number: squareNumber, Complex: function(e3) {
    return e3.mul(e3);
  }, BigNumber: function(e3) {
    return e3.times(e3);
  }, bigint: function(e3) {
    return e3 * e3;
  }, Fraction: function(e3) {
    return e3.mul(e3);
  }, Unit: function(e3) {
    return e3.pow(2);
  } });
})), name$3X = "subtract", dependencies$3X = ["typed", "matrix", "equalScalar", "subtractScalar", "unaryMinus", "DenseMatrix", "concat"], createSubtract = factory(name$3X, dependencies$3X, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, subtractScalar: i2, unaryMinus: a, DenseMatrix: o, concat: s } = e2, u = createMatAlgo01xDSid({ typed: t2 }), c2 = createMatAlgo03xDSf({ typed: t2 }), l = createMatAlgo05xSfSf({ typed: t2, equalScalar: n }), f2 = createMatAlgo10xSids({ typed: t2, DenseMatrix: o }), p = createMatAlgo12xSfs({ typed: t2, DenseMatrix: o }), m = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: s });
  return t2(name$3X, { "any, any": i2 }, m({ elop: i2, SS: l, DS: u, SD: c2, Ss: p, sS: f2 }));
})), name$3W = "xgcd", dependencies$3W = ["typed", "config", "matrix", "BigNumber"], createXgcd = factory(name$3W, dependencies$3W, ((e2) => {
  var { typed: t2, config: r, matrix: n, BigNumber: i2 } = e2;
  return t2(name$3W, { "number, number": function(e3, t22) {
    var i22 = xgcdNumber(e3, t22);
    return "Array" === r.matrix ? i22 : n(i22);
  }, "BigNumber, BigNumber": function(e3, t22) {
    var a, o, s, u, c2 = new i2(0), l = new i2(1), f2 = c2, p = l, m = l, d = c2;
    if (!e3.isInt() || !t22.isInt()) throw new Error("Parameters in function xgcd must be integer numbers");
    for (; !t22.isZero(); ) o = e3.div(t22).floor(), s = e3.mod(t22), a = f2, f2 = p.minus(o.times(f2)), p = a, a = m, m = d.minus(o.times(m)), d = a, e3 = t22, t22 = s;
    u = e3.lt(c2) ? [e3.neg(), p.neg(), d.neg()] : [e3, e3.isZero() ? 0 : p, d];
    return "Array" === r.matrix ? u : n(u);
  } });
})), name$3V = "invmod", dependencies$3V = ["typed", "config", "BigNumber", "xgcd", "equal", "smaller", "mod", "add", "isInteger"], createInvmod = factory(name$3V, dependencies$3V, ((e2) => {
  var { typed: t2, config: r, BigNumber: n, xgcd: i2, equal: a, smaller: o, mod: s, add: u, isInteger: c2 } = e2;
  return t2(name$3V, { "number, number": l, "BigNumber, BigNumber": l });
  function l(e3, t22) {
    if (!c2(e3) || !c2(t22)) throw new Error("Parameters in function invmod must be integer numbers");
    if (e3 = s(e3, t22), a(t22, 0)) throw new Error("Divisor must be non zero");
    var r2 = i2(e3, t22);
    r2 = r2.valueOf();
    var [l2, f2] = r2;
    return a(l2, n(1)) ? (f2 = s(f2, t22), o(f2, n(0)) && (f2 = u(f2, t22)), f2) : NaN;
  }
})), name$3U = "matAlgo09xS0Sf", dependencies$3U = ["typed", "equalScalar"], createMatAlgo09xS0Sf = factory(name$3U, dependencies$3U, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._index, s = e3._ptr, u = e3._size, c2 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l = n._values, f2 = n._index, p = n._ptr, m = n._size, d = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (u.length !== m.length) throw new DimensionError(u.length, m.length);
    if (u[0] !== m[0] || u[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + m + ")");
    var h, g = u[0], y = u[1], v2 = r, x2 = 0, b2 = i2;
    "string" == typeof c2 && c2 === d && "mixed" !== c2 && (h = c2, v2 = t2.find(r, [h, h]), x2 = t2.convert(0, h), b2 = t2.find(i2, [h, h]));
    var _2, w2, A2, N, D, E = a && l ? [] : void 0, $2 = [], S2 = [], C2 = E ? [] : void 0, M2 = [];
    for (w2 = 0; w2 < y; w2++) {
      S2[w2] = $2.length;
      var T2 = w2 + 1;
      if (C2) for (N = p[w2], D = p[w2 + 1], A2 = N; A2 < D; A2++) M2[_2 = f2[A2]] = T2, C2[_2] = l[A2];
      for (N = s[w2], D = s[w2 + 1], A2 = N; A2 < D; A2++) if (_2 = o[A2], C2) {
        var F = M2[_2] === T2 ? C2[_2] : x2, O2 = b2(a[A2], F);
        v2(O2, x2) || ($2.push(_2), E.push(O2));
      } else $2.push(_2);
    }
    return S2[y] = $2.length, e3.createSparseMatrix({ values: E, index: $2, ptr: S2, size: [g, y], datatype: c2 === e3._datatype && d === n._datatype ? h : void 0 });
  };
})), name$3T = "dotMultiply", dependencies$3T = ["typed", "matrix", "equalScalar", "multiplyScalar", "concat"], createDotMultiply = factory(name$3T, dependencies$3T, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, multiplyScalar: i2, concat: a } = e2, o = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), s = createMatAlgo09xS0Sf({ typed: t2, equalScalar: n }), u = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), c2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: a });
  return t2(name$3T, c2({ elop: i2, SS: s, DS: o, Ss: u }));
}));
function bitAndBigNumber(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function bitAnd");
  var r = e2.constructor;
  if (e2.isNaN() || t2.isNaN()) return new r(NaN);
  if (e2.isZero() || t2.eq(-1) || e2.eq(t2)) return e2;
  if (t2.isZero() || e2.eq(-1)) return t2;
  if (!e2.isFinite() || !t2.isFinite()) {
    if (!e2.isFinite() && !t2.isFinite()) return e2.isNegative() === t2.isNegative() ? e2 : new r(0);
    if (!e2.isFinite()) return t2.isNegative() ? e2 : e2.isNegative() ? new r(0) : t2;
    if (!t2.isFinite()) return e2.isNegative() ? t2 : t2.isNegative() ? new r(0) : e2;
  }
  return bitwise(e2, t2, (function(e3, t22) {
    return e3 & t22;
  }));
}
function bitNotBigNumber(e2) {
  if (e2.isFinite() && !e2.isInteger()) throw new Error("Integer expected in function bitNot");
  var t2 = e2.constructor, r = t2.precision;
  t2.config({ precision: 1e9 });
  var n = e2.plus(new t2(1));
  return n.s = -n.s || null, t2.config({ precision: r }), n;
}
function bitOrBigNumber(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function bitOr");
  var r = e2.constructor;
  if (e2.isNaN() || t2.isNaN()) return new r(NaN);
  var n = new r(-1);
  return e2.isZero() || t2.eq(n) || e2.eq(t2) ? t2 : t2.isZero() || e2.eq(n) ? e2 : e2.isFinite() && t2.isFinite() ? bitwise(e2, t2, (function(e3, t22) {
    return e3 | t22;
  })) : !e2.isFinite() && !e2.isNegative() && t2.isNegative() || e2.isNegative() && !t2.isNegative() && !t2.isFinite() ? n : e2.isNegative() && t2.isNegative() ? e2.isFinite() ? e2 : t2 : e2.isFinite() ? t2 : e2;
}
function bitwise(e2, t2, r) {
  var n, i2, a, o, s, u = e2.constructor, c2 = +(e2.s < 0), l = +(t2.s < 0);
  if (c2) {
    n = decCoefficientToBinaryString(bitNotBigNumber(e2));
    for (var f2 = 0; f2 < n.length; ++f2) n[f2] ^= 1;
  } else n = decCoefficientToBinaryString(e2);
  if (l) {
    i2 = decCoefficientToBinaryString(bitNotBigNumber(t2));
    for (var p = 0; p < i2.length; ++p) i2[p] ^= 1;
  } else i2 = decCoefficientToBinaryString(t2);
  n.length <= i2.length ? (a = n, o = i2, s = c2) : (a = i2, o = n, s = l);
  var m = a.length, d = o.length, h = 1 ^ r(c2, l), g = new u(1 ^ h), y = new u(1), v2 = new u(2), x2 = u.precision;
  for (u.config({ precision: 1e9 }); m > 0; ) r(a[--m], o[--d]) === h && (g = g.plus(y)), y = y.times(v2);
  for (; d > 0; ) r(s, o[--d]) === h && (g = g.plus(y)), y = y.times(v2);
  return u.config({ precision: x2 }), 0 === h && (g.s = -g.s), g;
}
function decCoefficientToBinaryString(e2) {
  for (var t2 = e2.d, r = t2[0] + "", n = 1; n < t2.length; ++n) {
    for (var i2 = t2[n] + "", a = 7 - i2.length; a--; ) i2 = "0" + i2;
    r += i2;
  }
  for (var o = r.length; "0" === r.charAt(o); ) o--;
  var s = e2.e, u = r.slice(0, o + 1 || 1), c2 = u.length;
  if (s > 0) if (++s > c2) for (s -= c2; s--; ) u += "0";
  else s < c2 && (u = u.slice(0, s) + "." + u.slice(s));
  for (var l = [0], f2 = 0; f2 < u.length; ) {
    for (var p = l.length; p--; ) l[p] *= 10;
    l[0] += parseInt(u.charAt(f2++));
    for (var m = 0; m < l.length; ++m) l[m] > 1 && (null !== l[m + 1] && void 0 !== l[m + 1] || (l[m + 1] = 0), l[m + 1] += l[m] >> 1, l[m] &= 1);
  }
  return l.reverse();
}
function bitXor(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function bitXor");
  var r = e2.constructor;
  if (e2.isNaN() || t2.isNaN()) return new r(NaN);
  if (e2.isZero()) return t2;
  if (t2.isZero()) return e2;
  if (e2.eq(t2)) return new r(0);
  var n = new r(-1);
  return e2.eq(n) ? bitNotBigNumber(t2) : t2.eq(n) ? bitNotBigNumber(e2) : e2.isFinite() && t2.isFinite() ? bitwise(e2, t2, (function(e3, t22) {
    return e3 ^ t22;
  })) : e2.isFinite() || t2.isFinite() ? new r(e2.isNegative() === t2.isNegative() ? 1 / 0 : -1 / 0) : n;
}
function leftShiftBigNumber(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function leftShift");
  var r = e2.constructor;
  return e2.isNaN() || t2.isNaN() || t2.isNegative() && !t2.isZero() ? new r(NaN) : e2.isZero() || t2.isZero() ? e2 : e2.isFinite() || t2.isFinite() ? t2.lt(55) ? e2.times(Math.pow(2, t2.toNumber()) + "") : e2.times(new r(2).pow(t2)) : new r(NaN);
}
function rightArithShiftBigNumber(e2, t2) {
  if (e2.isFinite() && !e2.isInteger() || t2.isFinite() && !t2.isInteger()) throw new Error("Integers expected in function rightArithShift");
  var r = e2.constructor;
  return e2.isNaN() || t2.isNaN() || t2.isNegative() && !t2.isZero() ? new r(NaN) : e2.isZero() || t2.isZero() ? e2 : t2.isFinite() ? t2.lt(55) ? e2.div(Math.pow(2, t2.toNumber()) + "").floor() : e2.div(new r(2).pow(t2)).floor() : e2.isNegative() ? new r(-1) : e2.isFinite() ? new r(0) : new r(NaN);
}
var name$3S = "bitAnd", dependencies$3S = ["typed", "matrix", "equalScalar", "concat"], createBitAnd = factory(name$3S, dependencies$3S, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, concat: i2 } = e2, a = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), o = createMatAlgo06xS0S0({ typed: t2, equalScalar: n }), s = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), u = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: i2 });
  return t2(name$3S, { "number, number": bitAndNumber, "BigNumber, BigNumber": bitAndBigNumber, "bigint, bigint": (e3, t22) => e3 & t22 }, u({ SS: o, DS: a, Ss: s }));
})), name$3R = "bitNot", dependencies$3R = ["typed"], createBitNot = factory(name$3R, dependencies$3R, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3R, { number: bitNotNumber, BigNumber: bitNotBigNumber, bigint: (e3) => ~e3, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$3Q = "bitOr", dependencies$3Q = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createBitOr = factory(name$3Q, dependencies$3Q, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a } = e2, o = createMatAlgo01xDSid({ typed: t2 }), s = createMatAlgo04xSidSid({ typed: t2, equalScalar: n }), u = createMatAlgo10xSids({ typed: t2, DenseMatrix: i2 }), c2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: a });
  return t2(name$3Q, { "number, number": bitOrNumber, "BigNumber, BigNumber": bitOrBigNumber, "bigint, bigint": (e3, t22) => e3 | t22 }, c2({ SS: s, DS: o, Ss: u }));
})), name$3P = "matAlgo07xSSf", dependencies$3P = ["typed", "SparseMatrix"], createMatAlgo07xSSf = factory(name$3P, dependencies$3P, ((e2) => {
  var { typed: t2, SparseMatrix: r } = e2;
  return function(e3, i2, a) {
    var o = e3._size, s = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), u = i2._size, c2 = i2._datatype || void 0 === i2._data ? i2._datatype : i2.getDataType();
    if (o.length !== u.length) throw new DimensionError(o.length, u.length);
    if (o[0] !== u[0] || o[1] !== u[1]) throw new RangeError("Dimension mismatch. Matrix A (" + o + ") must match Matrix B (" + u + ")");
    var l, f2 = o[0], p = o[1], m = 0, d = a;
    "string" == typeof s && s === c2 && "mixed" !== s && (l = s, m = t2.convert(0, l), d = t2.find(a, [l, l]));
    for (var h = [], g = [], y = new Array(p + 1).fill(0), v2 = [], x2 = [], b2 = [], _2 = [], w2 = 0; w2 < p; w2++) {
      var A2 = w2 + 1, N = 0;
      n(e3, w2, b2, v2, A2), n(i2, w2, _2, x2, A2);
      for (var D = 0; D < f2; D++) {
        var E = d(b2[D] === A2 ? v2[D] : m, _2[D] === A2 ? x2[D] : m);
        0 !== E && false !== E && (g.push(D), h.push(E), N++);
      }
      y[w2 + 1] = y[w2] + N;
    }
    return new r({ values: h, index: g, ptr: y, size: [f2, p], datatype: s === e3._datatype && c2 === i2._datatype ? l : void 0 });
  };
  function n(e3, t22, r2, n3, i2) {
    for (var a = e3._values, o = e3._index, s = e3._ptr, u = s[t22], c2 = s[t22 + 1]; u < c2; u++) {
      var l = o[u];
      r2[l] = i2, n3[l] = a[u];
    }
  }
})), name$3O = "bitXor", dependencies$3O = ["typed", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createBitXor = factory(name$3O, dependencies$3O, ((e2) => {
  var { typed: t2, matrix: r, DenseMatrix: n, concat: i2, SparseMatrix: a } = e2, o = createMatAlgo03xDSf({ typed: t2 }), s = createMatAlgo07xSSf({ typed: t2, SparseMatrix: a }), u = createMatAlgo12xSfs({ typed: t2, DenseMatrix: n }), c2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: i2 });
  return t2(name$3O, { "number, number": bitXorNumber, "BigNumber, BigNumber": bitXor, "bigint, bigint": (e3, t22) => e3 ^ t22 }, c2({ SS: s, DS: o, Ss: u }));
})), name$3N = "arg", dependencies$3N = ["typed"], createArg = factory(name$3N, dependencies$3N, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3N, { number: function(e3) {
    return Math.atan2(0, e3);
  }, BigNumber: function(e3) {
    return e3.constructor.atan2(0, e3);
  }, Complex: function(e3) {
    return e3.arg();
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$3M = "conj", dependencies$3M = ["typed"], createConj = factory(name$3M, dependencies$3M, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3M, { "number | BigNumber | Fraction": (e3) => e3, Complex: (e3) => e3.conjugate(), Unit: t2.referToSelf(((e3) => (t22) => new t22.constructor(e3(t22.toNumeric()), t22.formatUnits()))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$3L = "im", dependencies$3L = ["typed"], createIm = factory(name$3L, dependencies$3L, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3L, { number: () => 0, "BigNumber | Fraction": (e3) => e3.mul(0), Complex: (e3) => e3.im, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$3K = "re", dependencies$3K = ["typed"], createRe = factory(name$3K, dependencies$3K, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3K, { "number | BigNumber | Fraction": (e3) => e3, Complex: (e3) => e3.re, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$3J = "not", dependencies$3J = ["typed"], createNot = factory(name$3J, dependencies$3J, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3J, { "null | undefined": () => true, number: notNumber, Complex: function(e3) {
    return 0 === e3.re && 0 === e3.im;
  }, BigNumber: function(e3) {
    return e3.isZero() || e3.isNaN();
  }, bigint: (e3) => !e3, Unit: t2.referToSelf(((e3) => (r) => t2.find(e3, r.valueType())(r.value))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$3I = "nullish", dependencies$3I = ["typed", "matrix", "size", "flatten", "deepEqual"], createNullish = factory(name$3I, dependencies$3I, ((e2) => {
  var { typed: t2, matrix: r, size: n, flatten: i2, deepEqual: a } = e2, o = createMatAlgo03xDSf({ typed: t2 }), s = createMatAlgo14xDs({ typed: t2 }), u = createMatAlgo13xDD({ typed: t2 });
  return t2(name$3I, { "number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any": (e3, t22) => e3, "null, any": (e3, t22) => t22, "undefined, any": (e3, t22) => t22, "SparseMatrix, Array | Matrix": (e3, t22) => {
    var r2 = n(e3), i22 = n(t22);
    if (a(r2, i22)) return e3;
    throw new DimensionError(r2, i22);
  }, "DenseMatrix, DenseMatrix": t2.referToSelf(((e3) => (t22, r2) => u(t22, r2, e3))), "DenseMatrix, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => o(t22, r2, e3, false))), "DenseMatrix, Array": t2.referToSelf(((e3) => (t22, n3) => u(t22, r(n3), e3))), "DenseMatrix, any": t2.referToSelf(((e3) => (t22, r2) => s(t22, r2, e3, false))), "Array, Array": t2.referToSelf(((e3) => (t22, n3) => u(r(t22), r(n3), e3).valueOf())), "Array, DenseMatrix": t2.referToSelf(((e3) => (t22, n3) => u(r(t22), n3, e3))), "Array, SparseMatrix": t2.referToSelf(((e3) => (t22, n3) => o(r(t22), n3, e3, false))), "Array, any": t2.referToSelf(((e3) => (t22, n3) => s(r(t22), n3, e3, false).valueOf())) });
})), name$3H = "or", dependencies$3H = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createOr = factory(name$3H, dependencies$3H, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a } = e2, o = createMatAlgo03xDSf({ typed: t2 }), s = createMatAlgo05xSfSf({ typed: t2, equalScalar: n }), u = createMatAlgo12xSfs({ typed: t2, DenseMatrix: i2 }), c2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: a });
  return t2(name$3H, { "number, number": orNumber, "Complex, Complex": function(e3, t22) {
    return 0 !== e3.re || 0 !== e3.im || 0 !== t22.re || 0 !== t22.im;
  }, "BigNumber, BigNumber": function(e3, t22) {
    return !e3.isZero() && !e3.isNaN() || !t22.isZero() && !t22.isNaN();
  }, "bigint, bigint": orNumber, "Unit, Unit": t2.referToSelf(((e3) => (t22, r2) => e3(t22.value || 0, r2.value || 0))) }, c2({ SS: s, DS: o, Ss: u }));
})), name$3G = "xor", dependencies$3G = ["typed", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createXor = factory(name$3G, dependencies$3G, ((e2) => {
  var { typed: t2, matrix: r, DenseMatrix: n, concat: i2, SparseMatrix: a } = e2, o = createMatAlgo03xDSf({ typed: t2 }), s = createMatAlgo07xSSf({ typed: t2, SparseMatrix: a }), u = createMatAlgo12xSfs({ typed: t2, DenseMatrix: n }), c2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: i2 });
  return t2(name$3G, { "number, number": xorNumber, "Complex, Complex": function(e3, t22) {
    return (0 !== e3.re || 0 !== e3.im) != (0 !== t22.re || 0 !== t22.im);
  }, "bigint, bigint": xorNumber, "BigNumber, BigNumber": function(e3, t22) {
    return (!e3.isZero() && !e3.isNaN()) != (!t22.isZero() && !t22.isNaN());
  }, "Unit, Unit": t2.referToSelf(((e3) => (t22, r2) => e3(t22.value || 0, r2.value || 0))) }, c2({ SS: s, DS: o, Ss: u }));
})), name$3F = "concat", dependencies$3F = ["typed", "matrix", "isInteger"], createConcat = factory(name$3F, dependencies$3F, ((e2) => {
  var { typed: t2, matrix: r, isInteger: n } = e2;
  return t2(name$3F, { "...Array | Matrix | number | BigNumber": function(e3) {
    var t22, i2, a = e3.length, o = -1, s = false, u = [];
    for (t22 = 0; t22 < a; t22++) {
      var c2 = e3[t22];
      if (isMatrix(c2) && (s = true), isNumber$1(c2) || isBigNumber(c2)) {
        if (t22 !== a - 1) throw new Error("Dimension must be specified as last argument");
        if (i2 = o, o = c2.valueOf(), !n(o)) throw new TypeError("Integer number expected for dimension");
        if (o < 0 || t22 > 0 && o > i2) throw new IndexError(o, i2 + 1);
      } else {
        var l = clone$3(c2).valueOf(), f2 = arraySize(l);
        if (u[t22] = l, i2 = o, o = f2.length - 1, t22 > 0 && o !== i2) throw new DimensionError(i2 + 1, o + 1);
      }
    }
    if (0 === u.length) throw new SyntaxError("At least one matrix expected");
    for (var p = u.shift(); u.length; ) p = concat(p, u.shift(), o);
    return s ? r(p) : p;
  }, "...string": function(e3) {
    return e3.join("");
  } });
})), name$3E = "column", dependencies$3E = ["typed", "Index", "matrix", "range"], createColumn = factory(name$3E, dependencies$3E, ((e2) => {
  var { typed: t2, Index: r, matrix: n, range: i2 } = e2;
  return t2(name$3E, { "Matrix, number": a, "Array, number": function(e3, t22) {
    return a(n(clone$3(e3)), t22).valueOf();
  } });
  function a(e3, t22) {
    if (2 !== e3.size().length) throw new Error("Only two dimensional matrix is supported");
    validateIndex(t22, e3.size()[1]);
    var a2 = i2(0, e3.size()[0]), o = new r(a2, [t22]), s = e3.subset(o);
    return isMatrix(s) ? s : n([[s]]);
  }
})), name$3D = "count", dependencies$3D = ["typed", "size", "prod"], createCount = factory(name$3D, dependencies$3D, ((e2) => {
  var { typed: t2, size: r, prod: n } = e2;
  return t2(name$3D, { string: function(e3) {
    return e3.length;
  }, "Matrix | Array": function(e3) {
    return n(r(e3));
  } });
})), name$3C = "cross", dependencies$3C = ["typed", "matrix", "subtract", "multiply"], createCross = factory(name$3C, dependencies$3C, ((e2) => {
  var { typed: t2, matrix: r, subtract: n, multiply: i2 } = e2;
  return t2(name$3C, { "Matrix, Matrix": function(e3, t22) {
    return r(a(e3.toArray(), t22.toArray()));
  }, "Matrix, Array": function(e3, t22) {
    return r(a(e3.toArray(), t22));
  }, "Array, Matrix": function(e3, t22) {
    return r(a(e3, t22.toArray()));
  }, "Array, Array": a });
  function a(e3, t22) {
    var r2 = Math.max(arraySize(e3).length, arraySize(t22).length);
    e3 = squeeze(e3), t22 = squeeze(t22);
    var a2 = arraySize(e3), o = arraySize(t22);
    if (1 !== a2.length || 1 !== o.length || 3 !== a2[0] || 3 !== o[0]) throw new RangeError("Vectors with length 3 expected (Size A = [" + a2.join(", ") + "], B = [" + o.join(", ") + "])");
    var s = [n(i2(e3[1], t22[2]), i2(e3[2], t22[1])), n(i2(e3[2], t22[0]), i2(e3[0], t22[2])), n(i2(e3[0], t22[1]), i2(e3[1], t22[0]))];
    return r2 > 1 ? [s] : s;
  }
})), name$3B = "diag", dependencies$3B = ["typed", "matrix", "DenseMatrix", "SparseMatrix"], createDiag = factory(name$3B, dependencies$3B, ((e2) => {
  var { typed: t2, matrix: r, DenseMatrix: n, SparseMatrix: i2 } = e2;
  return t2(name$3B, { Array: function(e3) {
    return a(e3, 0, arraySize(e3), null);
  }, "Array, number": function(e3, t22) {
    return a(e3, t22, arraySize(e3), null);
  }, "Array, BigNumber": function(e3, t22) {
    return a(e3, t22.toNumber(), arraySize(e3), null);
  }, "Array, string": function(e3, t22) {
    return a(e3, 0, arraySize(e3), t22);
  }, "Array, number, string": function(e3, t22, r2) {
    return a(e3, t22, arraySize(e3), r2);
  }, "Array, BigNumber, string": function(e3, t22, r2) {
    return a(e3, t22.toNumber(), arraySize(e3), r2);
  }, Matrix: function(e3) {
    return a(e3, 0, e3.size(), e3.storage());
  }, "Matrix, number": function(e3, t22) {
    return a(e3, t22, e3.size(), e3.storage());
  }, "Matrix, BigNumber": function(e3, t22) {
    return a(e3, t22.toNumber(), e3.size(), e3.storage());
  }, "Matrix, string": function(e3, t22) {
    return a(e3, 0, e3.size(), t22);
  }, "Matrix, number, string": function(e3, t22, r2) {
    return a(e3, t22, e3.size(), r2);
  }, "Matrix, BigNumber, string": function(e3, t22, r2) {
    return a(e3, t22.toNumber(), e3.size(), r2);
  } });
  function a(e3, t22, a2, o) {
    if (!isInteger(t22)) throw new TypeError("Second parameter in function diag must be an integer");
    var s = t22 > 0 ? t22 : 0, u = t22 < 0 ? -t22 : 0;
    switch (a2.length) {
      case 1:
        return (function(e4, t3, r2, a3, o2, s2) {
          var u2 = [a3 + o2, a3 + s2];
          if (r2 && "sparse" !== r2 && "dense" !== r2) throw new TypeError("Unknown matrix type ".concat(r2, '"'));
          var c2 = "sparse" === r2 ? i2.diagonal(u2, e4, t3) : n.diagonal(u2, e4, t3);
          return null !== r2 ? c2 : c2.valueOf();
        })(e3, t22, o, a2[0], u, s);
      case 2:
        return (function(e4, t3, n3, i22, a3, o2) {
          if (isMatrix(e4)) {
            var s2 = e4.diagonal(t3);
            return null !== n3 ? n3 !== s2.storage() ? r(s2, n3) : s2 : s2.valueOf();
          }
          for (var u2 = Math.min(i22[0] - a3, i22[1] - o2), c2 = [], l = 0; l < u2; l++) c2[l] = e4[l + a3][l + o2];
          return null !== n3 ? r(c2) : c2;
        })(e3, t22, o, a2, u, s);
    }
    throw new RangeError("Matrix for function diag must be 2 dimensional");
  }
})), name$3A = "filter", dependencies$3A = ["typed"], createFilter = factory(name$3A, dependencies$3A, ((e2) => {
  var { typed: t2 } = e2;
  return t2("filter", { "Array, function": _filterCallback, "Matrix, function": function(e3, t22) {
    return e3.create(_filterCallback(e3.valueOf(), t22), e3.datatype());
  }, "Array, RegExp": filterRegExp, "Matrix, RegExp": function(e3, t22) {
    return e3.create(filterRegExp(e3.valueOf(), t22), e3.datatype());
  } });
}));
function _filterCallback(e2, t2) {
  var r = optimizeCallback(t2, e2, "filter");
  return r.isUnary ? filter$1(e2, r.fn) : filter$1(e2, (function(e3, t22, n) {
    return r.fn(e3, [t22], n);
  }));
}
var name$3z = "flatten", dependencies$3z = ["typed"], createFlatten = factory(name$3z, dependencies$3z, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3z, { Array: function(e3) {
    return flatten$4(e3);
  }, DenseMatrix: function(e3) {
    return e3.create(flatten$4(e3.valueOf(), true), e3.datatype());
  }, SparseMatrix: function(e3) {
    throw new TypeError("SparseMatrix is not supported by function flatten because it does not support 1D vectors. Convert to a DenseMatrix or Array first. Example: flatten(x.toArray())");
  } });
})), name$3y = "forEach", dependencies$3y = ["typed"], createForEach = factory(name$3y, dependencies$3y, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3y, { "Array, function": _forEach, "Matrix, function": function(e3, t22) {
    e3.forEach(t22);
  } });
}));
function _forEach(e2, t2) {
  var r = optimizeCallback(t2, e2, name$3y);
  deepForEach$1(e2, r.fn, r.isUnary);
}
var name$3x = "getMatrixDataType", dependencies$3x = ["typed"], createGetMatrixDataType = factory(name$3x, dependencies$3x, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3x, { Array: function(e3) {
    return getArrayDataType(e3, typeOf);
  }, Matrix: function(e3) {
    return e3.getDataType();
  } });
})), name$3w = "identity", dependencies$3w = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], createIdentity = factory(name$3w, dependencies$3w, ((e2) => {
  var { typed: t2, config: r, matrix: n, BigNumber: i2, DenseMatrix: a, SparseMatrix: o } = e2;
  return t2(name$3w, { "": function() {
    return "Matrix" === r.matrix ? n([]) : [];
  }, string: function(e3) {
    return n(e3);
  }, "number | BigNumber": function(e3) {
    return u(e3, e3, "Matrix" === r.matrix ? "dense" : void 0);
  }, "number | BigNumber, string": function(e3, t22) {
    return u(e3, e3, t22);
  }, "number | BigNumber, number | BigNumber": function(e3, t22) {
    return u(e3, t22, "Matrix" === r.matrix ? "dense" : void 0);
  }, "number | BigNumber, number | BigNumber, string": function(e3, t22, r2) {
    return u(e3, t22, r2);
  }, Array: function(e3) {
    return s(e3);
  }, "Array, string": function(e3, t22) {
    return s(e3, t22);
  }, Matrix: function(e3) {
    return s(e3.valueOf(), e3.storage());
  }, "Matrix, string": function(e3, t22) {
    return s(e3.valueOf(), t22);
  } });
  function s(e3, t22) {
    switch (e3.length) {
      case 0:
        return t22 ? n(t22) : [];
      case 1:
        return u(e3[0], e3[0], t22);
      case 2:
        return u(e3[0], e3[1], t22);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function u(e3, t22, r2) {
    var n3 = isBigNumber(e3) || isBigNumber(t22) ? i2 : null;
    if (isBigNumber(e3) && (e3 = e3.toNumber()), isBigNumber(t22) && (t22 = t22.toNumber()), !isInteger(e3) || e3 < 1) throw new Error("Parameters in function identity must be positive integers");
    if (!isInteger(t22) || t22 < 1) throw new Error("Parameters in function identity must be positive integers");
    var s2 = n3 ? new i2(1) : 1, u2 = n3 ? new n3(0) : 0, c2 = [e3, t22];
    if (r2) {
      if ("sparse" === r2) return o.diagonal(c2, s2, 0, u2);
      if ("dense" === r2) return a.diagonal(c2, s2, 0, u2);
      throw new TypeError('Unknown matrix type "'.concat(r2, '"'));
    }
    for (var l = resize([], c2, u2), f2 = e3 < t22 ? e3 : t22, p = 0; p < f2; p++) l[p][p] = s2;
    return l;
  }
})), name$3v = "kron", dependencies$3v = ["typed", "matrix", "multiplyScalar"], createKron = factory(name$3v, dependencies$3v, ((e2) => {
  var { typed: t2, matrix: r, multiplyScalar: n } = e2;
  return t2(name$3v, { "Matrix, Matrix": function(e3, t22) {
    return r(i2(e3.toArray(), t22.toArray()));
  }, "Matrix, Array": function(e3, t22) {
    return r(i2(e3.toArray(), t22));
  }, "Array, Matrix": function(e3, t22) {
    return r(i2(e3, t22.toArray()));
  }, "Array, Array": i2 });
  function i2(e3, t22) {
    var r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -1;
    if (r2 < 0) {
      var a = arraySize(e3).length, o = arraySize(t22).length;
      for (r2 = Math.max(a, o); a++ < r2; ) e3 = [e3];
      for (; o++ < r2; ) t22 = [t22];
    }
    return 1 === r2 ? (function(e4, t3) {
      return e4.flatMap(((e5) => t3.map(((t4) => n(e5, t4)))));
    })(e3, t22) : e3.flatMap(((e4) => t22.map(((t3) => i2(e4, t3, r2 - 1)))));
  }
})), name$3u = "map", dependencies$3u = ["typed"], createMap = factory(name$3u, dependencies$3u, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3u, { "Array, function": n, "Matrix, function": function(e3, t22) {
    return e3.map(t22);
  }, "Array|Matrix, Array|Matrix, ...Array|Matrix|function": (e3, i2, a) => (function(e4, i22) {
    if ("function" != typeof i22) throw new Error("Last argument must be a callback function");
    var a2 = e4[0].isMatrix, o = e4.map(((e5) => e5.isMatrix ? e5.size() : arraySize(e5))), s = broadcastSizes(...o), u = e4.length, c2 = a2 ? (e5, t22) => e5.get(t22) : get$1, l = e4.map(((e5, t22) => {
      var r2 = o[t22].map((() => 0));
      return e5.isMatrix ? e5.get(r2) : get$1(e5, r2);
    })), f2 = t2.isTypedFunction(i22) ? (function(e5, r2, n3, i3) {
      if (null !== t2.resolve(e5, [...r2, n3, ...i3])) return 2;
      if (null !== t2.resolve(e5, [...r2, n3])) return 1;
      if (null !== t2.resolve(e5, r2)) return 0;
      return 0;
    })(i22, l, s.map((() => 0)), e4) : (function(e5, t22) {
      var r2 = e5.toString();
      if (/arguments/.test(r2)) return 2;
      var n3 = r2.match(/\(.*?\)/);
      if (/\.\.\./.test(n3)) return 2;
      if (e5.length > t22 + 1) return 2;
      if (e5.length === t22 + 1) return 1;
      return 0;
    })(i22, u);
    if (f2 < 2) {
      var p = r(f2, i22, null);
      return (function(e5, t22) {
        var r2 = e5[0], n3 = e5.map(((e6) => e6.isMatrix ? e6.valueOf() : e6)), i3 = e5.map(((e6) => e6.isMatrix ? e6.size() : arraySize(e6))), a3 = broadcastSizes(...i3), o2 = i3.map(((e6) => a3.length - e6.length)), s2 = a3.length - 1, u2 = t22.length > 1, c3 = u2 ? [] : null, l2 = p2(n3, 0);
        if (r2.isMatrix) {
          var f3 = r2.create();
          return f3._data = l2, f3._size = a3, f3;
        }
        return l2;
        function p2(e6) {
          var r3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n4 = a3[r3], i4 = Array(n4);
          if (r3 < s2) for (var u3 = function(t3) {
            c3 && (c3[r3] = t3), i4[t3] = p2(e6.map(((e7, n5) => o2[n5] > r3 ? e7 : 1 === e7.length ? e7[0] : e7[t3])), r3 + 1);
          }, l3 = 0; l3 < n4; l3++) u3(l3);
          else for (var f4 = function(n5) {
            c3 && (c3[r3] = n5), i4[n5] = t22(e6.map(((e7) => 1 === e7.length ? e7[0] : e7[n5])), c3 ? c3.slice() : void 0);
          }, m2 = 0; m2 < n4; m2++) f4(m2);
          return i4;
        }
      })(e4, p);
    }
    var m = a2 ? e4.map(((t22) => t22.isMatrix ? t22.create(broadcastTo(t22.toArray(), s), t22.datatype()) : e4[0].create(broadcastTo(t22.valueOf(), s)))) : e4.map(((e5) => e5.isMatrix ? broadcastTo(e5.toArray(), s) : broadcastTo(e5, s))), d = r(f2, i22, m), h = (e5, t22) => d([e5, ...m.slice(1).map(((e6) => c2(e6, t22)))], t22);
    return a2 ? m[0].map(h) : n(m[0], h);
  })([e3, i2, ...a.slice(0, a.length - 1)], a[a.length - 1]) });
  function r(e3, t22, r2) {
    switch (e3) {
      case 0:
        return (e4) => t22(...e4);
      case 1:
        return (e4, r3) => t22(...e4, r3);
      case 2:
        return (e4, n3) => t22(...e4, n3, ...r2);
    }
  }
  function n(e3, t22) {
    var r2 = optimizeCallback(t22, e3, name$3u);
    return deepMap$1(e3, r2.fn, r2.isUnary);
  }
})), name$3t = "diff", dependencies$3t = ["typed", "matrix", "subtract", "number"], createDiff = factory(name$3t, dependencies$3t, ((e2) => {
  var { typed: t2, matrix: r, subtract: n, number: i2 } = e2;
  return t2(name$3t, { "Array | Matrix": function(e3) {
    return isMatrix(e3) ? r(o(e3.toArray())) : o(e3);
  }, "Array | Matrix, number": function(e3, t22) {
    if (!isInteger(t22)) throw new RangeError("Dimension must be a whole number");
    return isMatrix(e3) ? r(a(e3.toArray(), t22)) : a(e3, t22);
  }, "Array, BigNumber": t2.referTo("Array,number", ((e3) => (t22, r2) => e3(t22, i2(r2)))), "Matrix, BigNumber": t2.referTo("Matrix,number", ((e3) => (t22, r2) => e3(t22, i2(r2)))) });
  function a(e3, t22) {
    if (isMatrix(e3) && (e3 = e3.toArray()), !Array.isArray(e3)) throw RangeError("Array/Matrix does not have that many dimensions");
    if (t22 > 0) {
      var r2 = [];
      return e3.forEach(((e4) => {
        r2.push(a(e4, t22 - 1));
      })), r2;
    }
    if (0 === t22) return o(e3);
    throw RangeError("Cannot have negative dimension");
  }
  function o(e3) {
    for (var t22 = [], r2 = e3.length, n3 = 1; n3 < r2; n3++) t22.push(s(e3[n3 - 1], e3[n3]));
    return t22;
  }
  function s(e3, t22) {
    isMatrix(e3) && (e3 = e3.toArray()), isMatrix(t22) && (t22 = t22.toArray());
    var r2 = Array.isArray(e3), i22 = Array.isArray(t22);
    if (r2 && i22) return (function(e4, t3) {
      if (e4.length !== t3.length) throw RangeError("Not all sub-arrays have the same length");
      for (var r3 = [], n3 = e4.length, i3 = 0; i3 < n3; i3++) r3.push(s(e4[i3], t3[i3]));
      return r3;
    })(e3, t22);
    if (!r2 && !i22) return n(t22, e3);
    throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
  }
})), name$3s = "ones", dependencies$3s = ["typed", "config", "matrix", "BigNumber"], createOnes = factory(name$3s, dependencies$3s, ((e2) => {
  var { typed: t2, config: r, matrix: n, BigNumber: i2 } = e2;
  return t2("ones", { "": function() {
    return "Array" === r.matrix ? a([]) : a([], "default");
  }, "...number | BigNumber | string": function(e3) {
    if ("string" == typeof e3[e3.length - 1]) {
      var t22 = e3.pop();
      return a(e3, t22);
    }
    return "Array" === r.matrix ? a(e3) : a(e3, "default");
  }, Array: a, Matrix: function(e3) {
    var t22 = e3.storage();
    return a(e3.valueOf(), t22);
  }, "Array | Matrix, string": function(e3, t22) {
    return a(e3.valueOf(), t22);
  } });
  function a(e3, t22) {
    var r2 = (function(e4) {
      var t3 = false;
      return e4.forEach((function(e5, r3, n3) {
        isBigNumber(e5) && (t3 = true, n3[r3] = e5.toNumber());
      })), t3;
    })(e3), a2 = r2 ? new i2(1) : 1;
    if ((function(e4) {
      e4.forEach((function(e5) {
        if ("number" != typeof e5 || !isInteger(e5) || e5 < 0) throw new Error("Parameters in function ones must be positive integers");
      }));
    })(e3), t22) {
      var o = n(t22);
      return e3.length > 0 ? o.resize(e3, a2) : o;
    }
    var s = [];
    return e3.length > 0 ? resize(s, e3, a2) : s;
  }
}));
function noBignumber() {
  throw new Error('No "bignumber" implementation available');
}
function noFraction() {
  throw new Error('No "fraction" implementation available');
}
function noMatrix() {
  throw new Error('No "matrix" implementation available');
}
var name$3r = "range", dependencies$3r = ["typed", "config", "?matrix", "?bignumber", "equal", "smaller", "smallerEq", "larger", "largerEq", "add", "isZero", "isPositive"], createRange = factory(name$3r, dependencies$3r, ((e2) => {
  var { typed: t2, config: r, matrix: n, bignumber: i2, smaller: a, smallerEq: o, larger: s, largerEq: u, add: c2, isZero: l, isPositive: f2 } = e2;
  return t2(name$3r, { string: m, "string, boolean": m, number: function(e3) {
    throw new TypeError("Too few arguments to function range(): ".concat(e3));
  }, boolean: function(e3) {
    throw new TypeError("Unexpected type of argument 1 to function range(): ".concat(e3, ", number|bigint|BigNumber|Fraction"));
  }, "number, number": function(e3, t22) {
    return p(d(e3, t22, 1, false));
  }, "number, number, number": function(e3, t22, r2) {
    return p(d(e3, t22, r2, false));
  }, "number, number, boolean": function(e3, t22, r2) {
    return p(d(e3, t22, 1, r2));
  }, "number, number, number, boolean": function(e3, t22, r2, n3) {
    return p(d(e3, t22, r2, n3));
  }, "bigint, bigint|number": function(e3, t22) {
    return p(d(e3, t22, 1n, false));
  }, "number, bigint": function(e3, t22) {
    return p(d(BigInt(e3), t22, 1n, false));
  }, "bigint, bigint|number, bigint|number": function(e3, t22, r2) {
    return p(d(e3, t22, BigInt(r2), false));
  }, "number, bigint, bigint|number": function(e3, t22, r2) {
    return p(d(BigInt(e3), t22, BigInt(r2), false));
  }, "bigint, bigint|number, boolean": function(e3, t22, r2) {
    return p(d(e3, t22, 1n, r2));
  }, "number, bigint, boolean": function(e3, t22, r2) {
    return p(d(BigInt(e3), t22, 1n, r2));
  }, "bigint, bigint|number, bigint|number, boolean": function(e3, t22, r2, n3) {
    return p(d(e3, t22, BigInt(r2), n3));
  }, "number, bigint, bigint|number, boolean": function(e3, t22, r2, n3) {
    return p(d(BigInt(e3), t22, BigInt(r2), n3));
  }, "BigNumber, BigNumber": function(e3, t22) {
    return p(d(e3, t22, new e3.constructor(1), false));
  }, "BigNumber, BigNumber, BigNumber": function(e3, t22, r2) {
    return p(d(e3, t22, r2, false));
  }, "BigNumber, BigNumber, boolean": function(e3, t22, r2) {
    return p(d(e3, t22, new e3.constructor(1), r2));
  }, "BigNumber, BigNumber, BigNumber, boolean": function(e3, t22, r2, n3) {
    return p(d(e3, t22, r2, n3));
  }, "Fraction, Fraction": function(e3, t22) {
    return p(d(e3, t22, 1, false));
  }, "Fraction, Fraction, Fraction": function(e3, t22, r2) {
    return p(d(e3, t22, r2, false));
  }, "Fraction, Fraction, boolean": function(e3, t22, r2) {
    return p(d(e3, t22, 1, r2));
  }, "Fraction, Fraction, Fraction, boolean": function(e3, t22, r2, n3) {
    return p(d(e3, t22, r2, n3));
  }, "Unit, Unit, Unit": function(e3, t22, r2) {
    return p(d(e3, t22, r2, false));
  }, "Unit, Unit, Unit, boolean": function(e3, t22, r2, n3) {
    return p(d(e3, t22, r2, n3));
  } });
  function p(e3) {
    return "Matrix" === r.matrix ? n ? n(e3) : noMatrix() : e3;
  }
  function m(e3, t22) {
    var n3 = (function(e4) {
      var t3 = e4.split(":"), r2 = t3.map((function(e5) {
        return Number(e5);
      }));
      if (r2.some((function(e5) {
        return isNaN(e5);
      }))) return null;
      switch (r2.length) {
        case 2:
          return { start: r2[0], end: r2[1], step: 1 };
        case 3:
          return { start: r2[0], end: r2[2], step: r2[1] };
        default:
          return null;
      }
    })(e3);
    if (!n3) throw new SyntaxError('String "' + e3 + '" is no valid range');
    return "BigNumber" === r.number ? (void 0 === i2 && noBignumber(), p(d(i2(n3.start), i2(n3.end), i2(n3.step)))) : p(d(n3.start, n3.end, n3.step, t22));
  }
  function d(e3, t22, r2, n3) {
    var i22 = [];
    if (l(r2)) throw new Error("Step must be non-zero");
    for (var p2 = f2(r2) ? n3 ? o : a : n3 ? u : s, m2 = e3; p2(m2, t22); ) i22.push(m2), m2 = c2(m2, r2);
    return i22;
  }
})), name$3q = "reshape", dependencies$3q = ["typed", "isInteger", "matrix"], createReshape = factory(name$3q, dependencies$3q, ((e2) => {
  var { typed: t2, isInteger: r } = e2;
  return t2(name$3q, { "Matrix, Array": function(e3, t22) {
    return e3.reshape(t22, true);
  }, "Array, Array": function(e3, t22) {
    return t22.forEach((function(e4) {
      if (!r(e4)) throw new TypeError("Invalid size for dimension: " + e4);
    })), reshape(e3, t22);
  } });
})), name$3p = "resize", dependencies$3p = ["config", "matrix"], createResize = factory(name$3p, dependencies$3p, ((e2) => {
  var { config: t2, matrix: r } = e2;
  return function(e3, n, i2) {
    if (2 !== arguments.length && 3 !== arguments.length) throw new ArgumentsError("resize", arguments.length, 2, 3);
    if (isMatrix(n) && (n = n.valueOf()), isBigNumber(n[0]) && (n = n.map((function(e4) {
      return isBigNumber(e4) ? e4.toNumber() : e4;
    }))), isMatrix(e3)) return e3.resize(n, i2, true);
    if ("string" == typeof e3) return (function(e4, t22, r2) {
      if (void 0 !== r2) {
        if ("string" != typeof r2 || 1 !== r2.length) throw new TypeError("Single character expected as defaultValue");
      } else r2 = " ";
      if (1 !== t22.length) throw new DimensionError(t22.length, 1);
      var n3 = t22[0];
      if ("number" != typeof n3 || !isInteger(n3)) throw new TypeError("Invalid size, must contain positive integers (size: " + format(t22) + ")");
      if (e4.length > n3) return e4.substring(0, n3);
      if (e4.length < n3) {
        for (var i22 = e4, a2 = 0, o2 = n3 - e4.length; a2 < o2; a2++) i22 += r2;
        return i22;
      }
      return e4;
    })(e3, n, i2);
    var a = !Array.isArray(e3) && "Array" !== t2.matrix;
    if (0 === n.length) {
      for (; Array.isArray(e3); ) e3 = e3[0];
      return clone$3(e3);
    }
    Array.isArray(e3) || (e3 = [e3]);
    var o = resize(e3 = clone$3(e3), n, i2);
    return a ? r(o) : o;
  };
})), name$3o = "rotate", dependencies$3o = ["typed", "multiply", "rotationMatrix"], createRotate = factory(name$3o, dependencies$3o, ((e2) => {
  var { typed: t2, multiply: r, rotationMatrix: n } = e2;
  return t2(name$3o, { "Array , number | BigNumber | Complex | Unit": function(e3, t22) {
    return i2(e3, 2), r(n(t22), e3).toArray();
  }, "Matrix , number | BigNumber | Complex | Unit": function(e3, t22) {
    return i2(e3, 2), r(n(t22), e3);
  }, "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(e3, t22, a) {
    return i2(e3, 3), r(n(t22, a), e3);
  }, "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(e3, t22, a) {
    return i2(e3, 3), r(n(t22, a), e3);
  } });
  function i2(e3, t22) {
    var r2 = Array.isArray(e3) ? arraySize(e3) : e3.size();
    if (r2.length > 2) throw new RangeError("Vector must be of dimensions 1x".concat(t22));
    if (2 === r2.length && 1 !== r2[1]) throw new RangeError("Vector must be of dimensions 1x".concat(t22));
    if (r2[0] !== t22) throw new RangeError("Vector must be of dimensions 1x".concat(t22));
  }
})), name$3n = "rotationMatrix", dependencies$3n = ["typed", "config", "multiplyScalar", "addScalar", "unaryMinus", "norm", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix", "cos", "sin"], createRotationMatrix = factory(name$3n, dependencies$3n, ((e2) => {
  var { typed: t2, config: r, multiplyScalar: n, addScalar: i2, unaryMinus: a, norm: o, BigNumber: s, matrix: u, DenseMatrix: c2, SparseMatrix: l, cos: f2, sin: p } = e2;
  return t2(name$3n, { "": function() {
    return "Matrix" === r.matrix ? u([]) : [];
  }, string: function(e3) {
    return u(e3);
  }, "number | BigNumber | Complex | Unit": function(e3) {
    return m(e3, "Matrix" === r.matrix ? "dense" : void 0);
  }, "number | BigNumber | Complex | Unit, string": function(e3, t22) {
    return m(e3, t22);
  }, "number | BigNumber | Complex | Unit, Array": function(e3, t22) {
    var r2 = u(t22);
    return d(r2), y(e3, r2, void 0);
  }, "number | BigNumber | Complex | Unit, Matrix": function(e3, t22) {
    d(t22);
    var n3 = t22.storage() || ("Matrix" === r.matrix ? "dense" : void 0);
    return y(e3, t22, n3);
  }, "number | BigNumber | Complex | Unit, Array, string": function(e3, t22, r2) {
    var n3 = u(t22);
    return d(n3), y(e3, n3, r2);
  }, "number | BigNumber | Complex | Unit, Matrix, string": function(e3, t22, r2) {
    return d(t22), y(e3, t22, r2);
  } });
  function m(e3, t22) {
    var r2 = isBigNumber(e3) ? new s(-1) : -1, i22 = f2(e3), a2 = p(e3);
    return g([[i22, n(r2, a2)], [a2, i22]], t22);
  }
  function d(e3) {
    var t22 = e3.size();
    if (t22.length < 1 || 3 !== t22[0]) throw new RangeError("Vector must be of dimensions 1x3");
  }
  function h(e3) {
    return e3.reduce(((e4, t22) => n(e4, t22)));
  }
  function g(e3, t22) {
    if (t22) {
      if ("sparse" === t22) return new l(e3);
      if ("dense" === t22) return new c2(e3);
      throw new TypeError('Unknown matrix type "'.concat(t22, '"'));
    }
    return e3;
  }
  function y(e3, t22, r2) {
    var n3 = o(t22);
    if (0 === n3) throw new RangeError("Rotation around zero vector");
    var u2 = isBigNumber(e3) ? s : null, c3 = u2 ? new u2(1) : 1, l2 = u2 ? new u2(-1) : -1, m2 = u2 ? new u2(t22.get([0]) / n3) : t22.get([0]) / n3, d2 = u2 ? new u2(t22.get([1]) / n3) : t22.get([1]) / n3, y2 = u2 ? new u2(t22.get([2]) / n3) : t22.get([2]) / n3, v2 = f2(e3), x2 = i2(c3, a(v2)), b2 = p(e3);
    return g([[i2(v2, h([m2, m2, x2])), i2(h([m2, d2, x2]), h([l2, y2, b2])), i2(h([m2, y2, x2]), h([d2, b2]))], [i2(h([m2, d2, x2]), h([y2, b2])), i2(v2, h([d2, d2, x2])), i2(h([d2, y2, x2]), h([l2, m2, b2]))], [i2(h([m2, y2, x2]), h([l2, d2, b2])), i2(h([d2, y2, x2]), h([m2, b2])), i2(v2, h([y2, y2, x2]))]], r2);
  }
})), name$3m = "row", dependencies$3m = ["typed", "Index", "matrix", "range"], createRow = factory(name$3m, dependencies$3m, ((e2) => {
  var { typed: t2, Index: r, matrix: n, range: i2 } = e2;
  return t2(name$3m, { "Matrix, number": a, "Array, number": function(e3, t22) {
    return a(n(clone$3(e3)), t22).valueOf();
  } });
  function a(e3, t22) {
    if (2 !== e3.size().length) throw new Error("Only two dimensional matrix is supported");
    validateIndex(t22, e3.size()[0]);
    var a2 = i2(0, e3.size()[1]), o = new r([t22], a2), s = e3.subset(o);
    return isMatrix(s) ? s : n([[s]]);
  }
})), name$3l = "size", dependencies$3l = ["typed"], createSize = factory(name$3l, dependencies$3l, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3l, { Matrix: (e3) => e3.size(), Array: arraySize, string: (e3) => [e3.length], "number | Complex | BigNumber | Unit | boolean | null": (e3) => [] });
})), name$3k = "squeeze", dependencies$3k = ["typed"], createSqueeze = factory(name$3k, dependencies$3k, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$3k, { Array: function(e3) {
    return squeeze(clone$3(e3));
  }, Matrix: function(e3) {
    var t22 = squeeze(e3.toArray());
    return Array.isArray(t22) ? e3.create(t22, e3.datatype()) : t22;
  }, any: function(e3) {
    return clone$3(e3);
  } });
})), name$3j = "subset", dependencies$3j = ["typed", "matrix", "zeros", "add"], createSubset = factory(name$3j, dependencies$3j, ((e2) => {
  var { typed: t2, matrix: r, zeros: n, add: i2 } = e2;
  return t2(name$3j, { "Matrix, Index": function(e3, t22) {
    return isEmptyIndex(t22) ? r() : (validateIndexSourceSize(e3, t22), e3.subset(t22));
  }, "Array, Index": t2.referTo("Matrix, Index", (function(e3) {
    return function(t22, n3) {
      var i22 = e3(r(t22), n3);
      return n3.isScalar() ? i22 : i22.valueOf();
    };
  })), "Object, Index": _getObjectProperty, "string, Index": _getSubstring, "Matrix, Index, any, any": function(e3, t22, r2, a) {
    return isEmptyIndex(t22) ? e3 : (validateIndexSourceSize(e3, t22), e3.clone().subset(t22, (function(e4, t3) {
      if ("string" == typeof e4) throw new Error("can't boradcast a string");
      if (t3.isScalar()) return e4;
      var r3 = t3.size();
      if (!r3.every(((e5) => e5 > 0))) return e4;
      try {
        return i2(e4, n(r3));
      } catch (t4) {
        return e4;
      }
    })(r2, t22), a));
  }, "Array, Index, any, any": t2.referTo("Matrix, Index, any, any", (function(e3) {
    return function(t22, n3, i22, a) {
      var o = e3(r(t22), n3, i22, a);
      return o.isMatrix ? o.valueOf() : o;
    };
  })), "Array, Index, any": t2.referTo("Matrix, Index, any, any", (function(e3) {
    return function(t22, n3, i22) {
      return e3(r(t22), n3, i22, void 0).valueOf();
    };
  })), "Matrix, Index, any": t2.referTo("Matrix, Index, any, any", (function(e3) {
    return function(t22, r2, n3) {
      return e3(t22, r2, n3, void 0);
    };
  })), "string, Index, string": _setSubstring, "string, Index, string, string": _setSubstring, "Object, Index, any": _setObjectProperty });
}));
function _getSubstring(e2, t2) {
  if (!isIndex(t2)) throw new TypeError("Index expected");
  if (isEmptyIndex(t2)) return "";
  if (validateIndexSourceSize(Array.from(e2), t2), 1 !== t2.size().length) throw new DimensionError(t2.size().length, 1);
  var r = e2.length;
  validateIndex(t2.min()[0], r), validateIndex(t2.max()[0], r);
  var n = t2.dimension(0), i2 = "";
  function a(t22) {
    i2 += e2.charAt(t22);
  }
  return Number.isInteger(n) ? a(n) : n.forEach(a), i2;
}
function _setSubstring(e2, t2, r, n) {
  if (!t2 || true !== t2.isIndex) throw new TypeError("Index expected");
  if (isEmptyIndex(t2)) return e2;
  if (validateIndexSourceSize(Array.from(e2), t2), 1 !== t2.size().length) throw new DimensionError(t2.size().length, 1);
  if (void 0 !== n) {
    if ("string" != typeof n || 1 !== n.length) throw new TypeError("Single character expected as defaultValue");
  } else n = " ";
  var i2 = t2.dimension(0);
  if ((Number.isInteger(i2) ? 1 : i2.size()[0]) !== r.length) throw new DimensionError(i2.size()[0], r.length);
  var a = e2.length;
  validateIndex(t2.min()[0]), validateIndex(t2.max()[0]);
  for (var o = [], s = 0; s < a; s++) o[s] = e2.charAt(s);
  function u(e3, t22) {
    o[e3] = r.charAt(t22[0]);
  }
  if (Number.isInteger(i2) ? u(i2, [0]) : i2.forEach(u), o.length > a) for (var c2 = a - 1, l = o.length; c2 < l; c2++) o[c2] || (o[c2] = n);
  return o.join("");
}
function _getObjectProperty(e2, t2) {
  if (!isEmptyIndex(t2)) {
    if (1 !== t2.size().length) throw new DimensionError(t2.size(), 1);
    var r = t2.dimension(0);
    if ("string" != typeof r) throw new TypeError("String expected as index to retrieve an object property");
    return getSafeProperty(e2, r);
  }
}
function _setObjectProperty(e2, t2, r) {
  if (isEmptyIndex(t2)) return e2;
  if (1 !== t2.size().length) throw new DimensionError(t2.size(), 1);
  var n = t2.dimension(0);
  if ("string" != typeof n) throw new TypeError("String expected as index to retrieve an object property");
  var i2 = clone$3(e2);
  return setSafeProperty(i2, n, r), i2;
}
var name$3i = "transpose", dependencies$3i = ["typed", "matrix"], createTranspose = factory(name$3i, dependencies$3i, ((e2) => {
  var { typed: t2, matrix: r } = e2;
  return t2(name$3i, { Array: (e3) => n(r(e3)).valueOf(), Matrix: n, any: clone$3 });
  function n(e3) {
    var t22, r2 = e3.size();
    switch (r2.length) {
      case 1:
        t22 = e3.clone();
        break;
      case 2:
        var n3 = r2[0], i2 = r2[1];
        if (0 === i2) throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + format(r2) + ")");
        switch (e3.storage()) {
          case "dense":
            t22 = (function(e4, t3, r3) {
              for (var n4, i22 = e4._data, a = [], o = 0; o < r3; o++) {
                n4 = a[o] = [];
                for (var s = 0; s < t3; s++) n4[s] = clone$3(i22[s][o]);
              }
              return e4.createDenseMatrix({ data: a, size: [r3, t3], datatype: e4._datatype });
            })(e3, n3, i2);
            break;
          case "sparse":
            t22 = (function(e4, t3, r3) {
              for (var n4, i22, a, o = e4._values, s = e4._index, u = e4._ptr, c2 = o ? [] : void 0, l = [], f2 = [], p = [], m = 0; m < t3; m++) p[m] = 0;
              for (n4 = 0, i22 = s.length; n4 < i22; n4++) p[s[n4]]++;
              for (var d = 0, h = 0; h < t3; h++) f2.push(d), d += p[h], p[h] = f2[h];
              for (f2.push(d), a = 0; a < r3; a++) for (var g = u[a], y = u[a + 1], v2 = g; v2 < y; v2++) {
                var x2 = p[s[v2]]++;
                l[x2] = a, o && (c2[x2] = clone$3(o[v2]));
              }
              return e4.createSparseMatrix({ values: c2, index: l, ptr: f2, size: [r3, t3], datatype: e4._datatype });
            })(e3, n3, i2);
        }
        break;
      default:
        throw new RangeError("Matrix must be a vector or two dimensional (size: " + format(r2) + ")");
    }
    return t22;
  }
})), name$3h = "ctranspose", dependencies$3h = ["typed", "transpose", "conj"], createCtranspose = factory(name$3h, dependencies$3h, ((e2) => {
  var { typed: t2, transpose: r, conj: n } = e2;
  return t2(name$3h, { any: function(e3) {
    return n(r(e3));
  } });
})), name$3g = "zeros", dependencies$3g = ["typed", "config", "matrix", "BigNumber"], createZeros = factory(name$3g, dependencies$3g, ((e2) => {
  var { typed: t2, config: r, matrix: n, BigNumber: i2 } = e2;
  return t2(name$3g, { "": function() {
    return "Array" === r.matrix ? a([]) : a([], "default");
  }, "...number | BigNumber | string": function(e3) {
    if ("string" == typeof e3[e3.length - 1]) {
      var t22 = e3.pop();
      return a(e3, t22);
    }
    return "Array" === r.matrix ? a(e3) : a(e3, "default");
  }, Array: a, Matrix: function(e3) {
    var t22 = e3.storage();
    return a(e3.valueOf(), t22);
  }, "Array | Matrix, string": function(e3, t22) {
    return a(e3.valueOf(), t22);
  } });
  function a(e3, t22) {
    var r2 = (function(e4) {
      var t3 = false;
      return e4.forEach((function(e5, r3, n3) {
        isBigNumber(e5) && (t3 = true, n3[r3] = e5.toNumber());
      })), t3;
    })(e3), a2 = r2 ? new i2(0) : 0;
    if ((function(e4) {
      e4.forEach((function(e5) {
        if ("number" != typeof e5 || !isInteger(e5) || e5 < 0) throw new Error("Parameters in function zeros must be positive integers");
      }));
    })(e3), t22) {
      var o = n(t22);
      return e3.length > 0 ? o.resize(e3, a2) : o;
    }
    var s = [];
    return e3.length > 0 ? resize(s, e3, a2) : s;
  }
})), name$3f = "fft", dependencies$3f = ["typed", "matrix", "addScalar", "multiplyScalar", "divideScalar", "exp", "tau", "i", "dotDivide", "conj", "pow", "ceil", "log2"], createFft = factory(name$3f, dependencies$3f, ((e2) => {
  var { typed: t2, matrix: r, addScalar: n, multiplyScalar: i2, divideScalar: a, exp: o, tau: s, i: u, dotDivide: c2, conj: l, pow: f2, ceil: p, log2: m } = e2;
  return t2(name$3f, { Array: d, Matrix: function(e3) {
    return e3.create(d(e3.valueOf()), e3.datatype());
  } });
  function d(e3) {
    var t22 = arraySize(e3);
    return 1 === t22.length ? g(e3, t22[0]) : h(e3.map(((e4) => d(e4, t22.slice(1)))), 0);
  }
  function h(e3, t22) {
    var r2 = arraySize(e3);
    if (0 !== t22) return new Array(r2[0]).fill(0).map(((r3, n4) => h(e3[n4], t22 - 1)));
    if (1 === r2.length) return g(e3);
    function n3(e4) {
      var t3 = arraySize(e4);
      return new Array(t3[1]).fill(0).map(((r3, n4) => new Array(t3[0]).fill(0).map(((t4, r4) => e4[r4][n4]))));
    }
    return n3(h(n3(e3), 1));
  }
  function g(e3) {
    var t22 = e3.length;
    if (1 === t22) return [e3[0]];
    if (t22 % 2 == 0) {
      for (var r2 = [...g(e3.filter(((e4, t3) => t3 % 2 == 0))), ...g(e3.filter(((e4, t3) => t3 % 2 == 1)))], h2 = 0; h2 < t22 / 2; h2++) {
        var y = r2[h2], v2 = i2(r2[h2 + t22 / 2], o(i2(i2(s, u), a(-h2, t22))));
        r2[h2] = n(y, v2), r2[h2 + t22 / 2] = n(y, i2(-1, v2));
      }
      return r2;
    }
    return (function(e4) {
      for (var t3 = e4.length, r3 = o(a(i2(-1, i2(u, s)), t3)), n3 = [], h3 = 1 - t3; h3 < t3; h3++) n3.push(f2(r3, a(f2(h3, 2), 2)));
      for (var y2 = f2(2, p(m(t3 + t3 - 1))), v22 = [...new Array(t3).fill(0).map(((r4, a2) => i2(e4[a2], n3[t3 - 1 + a2]))), ...new Array(y2 - t3).fill(0)], x2 = [...new Array(t3 + t3 - 1).fill(0).map(((e5, t4) => a(1, n3[t4]))), ...new Array(y2 - (t3 + t3 - 1)).fill(0)], b2 = g(v22), _2 = g(x2), w2 = new Array(y2).fill(0).map(((e5, t4) => i2(b2[t4], _2[t4]))), A2 = c2(l(d(l(w2))), y2), N = [], D = t3 - 1; D < t3 + t3 - 1; D++) N.push(i2(A2[D], n3[D]));
      return N;
    })(e3);
  }
})), name$3e = "ifft", dependencies$3e = ["typed", "fft", "dotDivide", "conj"], createIfft = factory(name$3e, dependencies$3e, ((e2) => {
  var { typed: t2, fft: r, dotDivide: n, conj: i2 } = e2;
  return t2(name$3e, { "Array | Matrix": function(e3) {
    var t22 = isMatrix(e3) ? e3.size() : arraySize(e3);
    return n(i2(r(i2(e3))), t22.reduce(((e4, t3) => e4 * t3), 1));
  } });
}));
function _typeof(e2) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e3) {
    return typeof e3;
  } : function(e3) {
    return e3 && "function" == typeof Symbol && e3.constructor === Symbol && e3 !== Symbol.prototype ? "symbol" : typeof e3;
  }, _typeof(e2);
}
function toPrimitive(e2, t2) {
  if ("object" != _typeof(e2) || !e2) return e2;
  var r = e2[Symbol.toPrimitive];
  if (void 0 !== r) {
    var n = r.call(e2, t2);
    if ("object" != _typeof(n)) return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === t2 ? String : Number)(e2);
}
function toPropertyKey(e2) {
  var t2 = toPrimitive(e2, "string");
  return "symbol" == _typeof(t2) ? t2 : t2 + "";
}
function _defineProperty$1(e2, t2, r) {
  return (t2 = toPropertyKey(t2)) in e2 ? Object.defineProperty(e2, t2, { value: r, enumerable: true, configurable: true, writable: true }) : e2[t2] = r, e2;
}
function ownKeys$3(e2, t2) {
  var r = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e2);
    t2 && (n = n.filter((function(t22) {
      return Object.getOwnPropertyDescriptor(e2, t22).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread$3(e2) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? ownKeys$3(Object(r), true).forEach((function(t22) {
      _defineProperty$1(e2, t22, r[t22]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r)) : ownKeys$3(Object(r)).forEach((function(t22) {
      Object.defineProperty(e2, t22, Object.getOwnPropertyDescriptor(r, t22));
    }));
  }
  return e2;
}
var name$3d = "solveODE", dependencies$3d = ["typed", "add", "subtract", "multiply", "divide", "max", "map", "abs", "isPositive", "isNegative", "larger", "smaller", "matrix", "bignumber", "unaryMinus"], createSolveODE = factory(name$3d, dependencies$3d, ((e2) => {
  var { typed: t2, add: r, subtract: n, multiply: i2, divide: a, max: o, map: s, abs: u, isPositive: c2, isNegative: l, larger: f2, smaller: p, matrix: m, bignumber: d, unaryMinus: h } = e2;
  function g(e3) {
    return function(t22, m2, g2, y2) {
      if (!(2 === m2.length && (m2.every(b2) || m2.every(isUnit)))) throw new Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
      var v22 = m2[0], x22 = m2[1], _3 = f2(x22, v22), w2 = y2.firstStep;
      if (void 0 !== w2 && !c2(w2)) throw new Error('"firstStep" must be positive');
      var A2 = y2.maxStep;
      if (void 0 !== A2 && !c2(A2)) throw new Error('"maxStep" must be positive');
      var N = y2.minStep;
      if (N && l(N)) throw new Error('"minStep" must be positive or zero');
      var D = [v22, x22, w2, N, A2].filter(((e4) => void 0 !== e4));
      if (!D.every(b2) && !D.every(isUnit)) throw new Error('Inconsistent type of "t" dependant variables');
      for (var E = y2.tol ? y2.tol : 1e-4, $2 = y2.minDelta ? y2.minDelta : 0.2, S2 = y2.maxDelta ? y2.maxDelta : 5, C2 = y2.maxIter ? y2.maxIter : 1e4, M2 = [v22, x22, ...g2, A2, N].some(isBigNumber), [T2, F, O2, k2] = M2 ? [d(e3.a), d(e3.c), d(e3.b), d(e3.bp)] : [e3.a, e3.c, e3.b, e3.bp], B2 = w2 ? _3 ? w2 : h(w2) : a(n(x22, v22), 1), I2 = [v22], R2 = [g2], q2 = n(O2, k2), z2 = 0, P2 = 0, L2 = /* @__PURE__ */ (function(e4) {
        return e4 ? p : f2;
      })(_3), j2 = /* @__PURE__ */ (function(e4) {
        var t3 = e4 ? f2 : p;
        return function(e5, i22, a2) {
          var o2 = r(e5, a2);
          return t3(o2, i22) ? n(i22, e5) : a2;
        };
      })(_3); L2(I2[z2], x22); ) {
        var U2 = [];
        B2 = j2(I2[z2], x22, B2), U2.push(t22(I2[z2], R2[z2]));
        for (var Z2 = 1; Z2 < F.length; ++Z2) U2.push(t22(r(I2[z2], i2(F[Z2], B2)), r(R2[z2], i2(B2, T2[Z2], U2))));
        var G2 = o(u(s(i2(q2, U2), ((e4) => isUnit(e4) ? e4.value : e4))));
        G2 < E && E / G2 > 1 / 4 && (I2.push(r(I2[z2], B2)), R2.push(r(R2[z2], i2(B2, O2, U2))), z2++);
        var V2 = 0.84 * (E / G2) ** 0.2;
        if (p(V2, $2) ? V2 = $2 : f2(V2, S2) && (V2 = S2), V2 = M2 ? d(V2) : V2, B2 = i2(B2, V2), A2 && f2(u(B2), A2) ? B2 = _3 ? A2 : h(A2) : N && p(u(B2), N) && (B2 = _3 ? N : h(N)), ++P2 > C2) throw new Error("Maximum number of iterations reached, try changing options");
      }
      return { t: I2, y: R2 };
    };
  }
  function y(e3, t22, r2, n3) {
    return g({ a: [[], [0.5], [0, 3 / 4], [2 / 9, 1 / 3, 4 / 9]], c: [null, 0.5, 3 / 4, 1], b: [2 / 9, 1 / 3, 4 / 9, 0], bp: [7 / 24, 1 / 4, 1 / 3, 1 / 8] })(e3, t22, r2, n3);
  }
  function v2(e3, t22, r2, n3) {
    return g({ a: [[], [0.2], [3 / 40, 9 / 40], [44 / 45, -56 / 15, 32 / 9], [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84]], c: [null, 0.2, 0.3, 0.8, 8 / 9, 1, 1], b: [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], bp: [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40] })(e3, t22, r2, n3);
  }
  function x2(e3, t22, r2, n3) {
    var i22 = n3.method ? n3.method : "RK45", a2 = { RK23: y, RK45: v2 };
    if (i22.toUpperCase() in a2) {
      var o2 = _objectSpread$3({}, n3);
      return delete o2.method, a2[i22.toUpperCase()](e3, t22, r2, o2);
    }
    var s2 = Object.keys(a2).map(((e4) => '"'.concat(e4, '"'))), u2 = "".concat(s2.slice(0, -1).join(", "), " and ").concat(s2.slice(-1));
    throw new Error('Unavailable method "'.concat(i22, '". Available methods are ').concat(u2));
  }
  function b2(e3) {
    return isBigNumber(e3) || isNumber$1(e3);
  }
  function _2(e3, t22, r2, n3) {
    var i22 = x2(e3, t22.toArray(), r2.toArray(), n3);
    return { t: m(i22.t), y: m(i22.y) };
  }
  return t2("solveODE", { "function, Array, Array, Object": x2, "function, Matrix, Matrix, Object": _2, "function, Array, Array": (e3, t22, r2) => x2(e3, t22, r2, {}), "function, Matrix, Matrix": (e3, t22, r2) => _2(e3, t22, r2, {}), "function, Array, number | BigNumber | Unit": (e3, t22, r2) => {
    var n3 = x2(e3, t22, [r2], {});
    return { t: n3.t, y: n3.y.map(((e4) => e4[0])) };
  }, "function, Matrix, number | BigNumber | Unit": (e3, t22, r2) => {
    var n3 = x2(e3, t22.toArray(), [r2], {});
    return { t: m(n3.t), y: m(n3.y.map(((e4) => e4[0]))) };
  }, "function, Array, number | BigNumber | Unit, Object": (e3, t22, r2, n3) => {
    var i22 = x2(e3, t22, [r2], n3);
    return { t: i22.t, y: i22.y.map(((e4) => e4[0])) };
  }, "function, Matrix, number | BigNumber | Unit, Object": (e3, t22, r2, n3) => {
    var i22 = x2(e3, t22.toArray(), [r2], n3);
    return { t: m(i22.t), y: m(i22.y.map(((e4) => e4[0]))) };
  } });
})), name$3c = "erf", dependencies$3c = ["typed"], createErf = factory(name$3c, dependencies$3c, ((e2) => {
  var { typed: t2 } = e2;
  return t2("name", { number: function(e3) {
    var t22 = Math.abs(e3);
    return t22 >= MAX_NUM ? sign$2(e3) : t22 <= THRESH ? sign$2(e3) * (function(e4) {
      var t3, r = e4 * e4, n = P$4[0][4] * r, i2 = r;
      for (t3 = 0; t3 < 3; t3 += 1) n = (n + P$4[0][t3]) * r, i2 = (i2 + Q[0][t3]) * r;
      return e4 * (n + P$4[0][3]) / (i2 + Q[0][3]);
    })(t22) : t22 <= 4 ? sign$2(e3) * (1 - (function(e4) {
      var t3, r = P$4[1][8] * e4, n = e4;
      for (t3 = 0; t3 < 7; t3 += 1) r = (r + P$4[1][t3]) * e4, n = (n + Q[1][t3]) * e4;
      var i2 = (r + P$4[1][7]) / (n + Q[1][7]), a = parseInt(16 * e4) / 16, o = (e4 - a) * (e4 + a);
      return Math.exp(-a * a) * Math.exp(-o) * i2;
    })(t22)) : sign$2(e3) * (1 - (function(e4) {
      var t3, r = 1 / (e4 * e4), n = P$4[2][5] * r, i2 = r;
      for (t3 = 0; t3 < 4; t3 += 1) n = (n + P$4[2][t3]) * r, i2 = (i2 + Q[2][t3]) * r;
      var a = r * (n + P$4[2][4]) / (i2 + Q[2][4]);
      a = (SQRPI - a) / e4, r = parseInt(16 * e4) / 16;
      var o = (e4 - r) * (e4 + r);
      return Math.exp(-r * r) * Math.exp(-o) * a;
    })(t22));
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), THRESH = 0.46875, SQRPI = 0.5641895835477563, P$4 = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Q = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], MAX_NUM = Math.pow(2, 53), name$3b = "zeta", dependencies$3b = ["typed", "config", "multiply", "pow", "divide", "factorial", "equal", "smallerEq", "isBounded", "isNegative", "gamma", "sin", "subtract", "add", "?Complex", "?BigNumber", "pi"], createZeta = factory(name$3b, dependencies$3b, ((e2) => {
  var { typed: t2, config: r, multiply: n, pow: i2, divide: a, factorial: o, equal: s, smallerEq: u, isBounded: c2, isNegative: l, gamma: f2, sin: p, subtract: m, add: d, Complex: h, BigNumber: g, pi: y } = e2;
  return t2(name$3b, { number: (e3) => v2(e3, ((e4) => e4), (() => 20)), BigNumber: (e3) => v2(e3, ((e4) => new g(e4)), (() => Math.abs(Math.log10(r.relTol)))), Complex: function(e3) {
    if (0 === e3.re && 0 === e3.im) return new h(-0.5);
    if (1 === e3.re) return new h(NaN, NaN);
    if (e3.re === 1 / 0 && 0 === e3.im) return new h(1);
    if (e3.im === 1 / 0 || e3.re === -1 / 0) return new h(NaN, NaN);
    return x2(e3, ((e4) => e4), ((e4) => Math.round(19.5 + 0.9 * Math.abs(e4.im))), ((e4) => e4.re));
  } });
  function v2(e3, t22, r2) {
    return s(e3, 0) ? t22(-0.5) : s(e3, 1) ? t22(NaN) : c2(e3) ? x2(e3, t22, r2, ((e4) => e4)) : l(e3) ? t22(NaN) : t22(1);
  }
  function x2(e3, t22, r2, o2) {
    var s2 = r2(e3);
    if (o2(e3) > -(s2 - 1) / 2) return (function(e4, t3, r3) {
      for (var o3 = a(1, n(b2(r3(0), t3), m(1, i2(2, m(1, e4))))), s3 = r3(0), c4 = r3(1); u(c4, t3); c4 = d(c4, 1)) s3 = d(s3, a(n((-1) ** (c4 - 1), b2(c4, t3)), i2(c4, e4)));
      return n(o3, s3);
    })(e3, t22(s2), t22);
    var c3 = n(i2(2, e3), i2(t22(y), m(e3, 1)));
    return c3 = n(c3, p(n(a(t22(y), 2), e3))), c3 = n(c3, f2(m(1, e3))), n(c3, x2(m(1, e3), t22, r2, o2));
  }
  function b2(e3, t22) {
    for (var r2 = e3, s2 = e3; u(s2, t22); s2 = d(s2, 1)) {
      var c3 = a(n(o(d(t22, m(s2, 1))), i2(4, s2)), n(o(m(t22, s2)), o(n(2, s2))));
      r2 = d(r2, c3);
    }
    return n(t22, r2);
  }
})), name$3a = "mode", dependencies$3a = ["typed", "isNaN", "isNumeric"], createMode = factory(name$3a, dependencies$3a, ((e2) => {
  var { typed: t2, isNaN: r, isNumeric: n } = e2;
  return t2(name$3a, { "Array | Matrix": i2, "...": function(e3) {
    return i2(e3);
  } });
  function i2(e3) {
    if (0 === (e3 = flatten$4(e3.valueOf())).length) throw new Error("Cannot calculate mode of an empty array");
    for (var t22 = {}, i22 = [], a = 0, o = 0; o < e3.length; o++) {
      var s = e3[o];
      if (n(s) && r(s)) throw new Error("Cannot calculate mode of an array containing NaN values");
      s in t22 || (t22[s] = 0), t22[s]++, t22[s] === a ? i22.push(s) : t22[s] > a && (a = t22[s], i22 = [s]);
    }
    return i22;
  }
}));
function improveErrorMessage(e2, t2, r) {
  var n;
  return String(e2).includes("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + typeOf(r) + ", value: " + JSON.stringify(r) + ")" : " (type: " + e2.data.actual + ")", new TypeError("Cannot calculate " + t2 + ", unexpected type of argument" + n)) : String(e2).includes("complex numbers") ? (n = arguments.length > 2 ? " (type: " + typeOf(r) + ", value: " + JSON.stringify(r) + ")" : "", new TypeError("Cannot calculate " + t2 + ", no ordering relation is defined for complex numbers" + n)) : e2;
}
var name$39 = "prod", dependencies$39 = ["typed", "config", "multiplyScalar", "numeric"], createProd = factory(name$39, dependencies$39, ((e2) => {
  var { typed: t2, config: r, multiplyScalar: n, numeric: i2 } = e2;
  return t2(name$39, { "Array | Matrix": a, "Array | Matrix, number | BigNumber": function(e3, t22) {
    throw new Error("prod(A, dim) is not yet supported");
  }, "...": function(e3) {
    return a(e3);
  } });
  function a(e3) {
    var t22;
    if (deepForEach(e3, (function(e4) {
      try {
        t22 = void 0 === t22 ? e4 : n(t22, e4);
      } catch (t3) {
        throw improveErrorMessage(t3, "prod", e4);
      }
    })), "string" == typeof t22 && (t22 = i2(t22, safeNumberType(t22, r))), void 0 === t22) throw new Error("Cannot calculate prod of an empty array");
    return t22;
  }
})), name$38 = "format", dependencies$38 = ["typed"], createFormat = factory(name$38, dependencies$38, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$38, { any: format, "any, Object | function | number | BigNumber": format });
})), name$37 = "bin", dependencies$37 = ["typed", "format"], createBin = factory(name$37, dependencies$37, ((e2) => {
  var { typed: t2, format: r } = e2;
  return t2(name$37, { "number | BigNumber": function(e3) {
    return r(e3, { notation: "bin" });
  }, "number | BigNumber, number | BigNumber": function(e3, t22) {
    return r(e3, { notation: "bin", wordSize: t22 });
  } });
})), name$36 = "oct", dependencies$36 = ["typed", "format"], createOct = factory(name$36, dependencies$36, ((e2) => {
  var { typed: t2, format: r } = e2;
  return t2(name$36, { "number | BigNumber": function(e3) {
    return r(e3, { notation: "oct" });
  }, "number | BigNumber, number | BigNumber": function(e3, t22) {
    return r(e3, { notation: "oct", wordSize: t22 });
  } });
})), name$35 = "hex", dependencies$35 = ["typed", "format"], createHex = factory(name$35, dependencies$35, ((e2) => {
  var { typed: t2, format: r } = e2;
  return t2(name$35, { "number | BigNumber": function(e3) {
    return r(e3, { notation: "hex" });
  }, "number | BigNumber, number | BigNumber": function(e3, t22) {
    return r(e3, { notation: "hex", wordSize: t22 });
  } });
})), printTemplate = /\$([\w.]+)/g, name$34 = "print", dependencies$34 = ["typed"], createPrint = factory(name$34, dependencies$34, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$34, { "string, Object | Array": _print, "string, Object | Array, number | Object": _print });
}));
function _print(e2, t2, r) {
  return e2.replace(printTemplate, (function(e3, n) {
    var i2 = n.split("."), a = t2[i2.shift()];
    for (void 0 !== a && a.isMatrix && (a = a.toArray()); i2.length && void 0 !== a; ) {
      var o = i2.shift();
      a = o ? a[o] : a + ".";
    }
    return void 0 !== a ? isString$1(a) ? a : format(a, r) : e3;
  }));
}
var name$33 = "to", dependencies$33 = ["typed", "matrix", "concat"], createTo = factory(name$33, dependencies$33, ((e2) => {
  var { typed: t2, matrix: r, concat: n } = e2, i2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: n });
  return t2(name$33, { "Unit, Unit | string": (e3, t22) => e3.to(t22) }, i2({ Ds: true }));
})), name$32 = "toBest", dependencies$32 = ["typed"], createToBest = factory(name$32, dependencies$32, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$32, { Unit: (e3) => e3.toBest(), "Unit, string": (e3, t22) => e3.toBest(t22.split(",")), "Unit, string, Object": (e3, t22, r) => e3.toBest(t22.split(","), r), "Unit, Array": (e3, t22) => e3.toBest(t22), "Unit, Array, Object": (e3, t22, r) => e3.toBest(t22, r) });
})), name$31 = "isPrime", dependencies$31 = ["typed"], createIsPrime = factory(name$31, dependencies$31, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$31, { number: function(e3) {
    if (e3 <= 3) return e3 > 1;
    if (e3 % 2 == 0 || e3 % 3 == 0) return false;
    for (var t22 = 5; t22 * t22 <= e3; t22 += 6) if (e3 % t22 == 0 || e3 % (t22 + 2) == 0) return false;
    return true;
  }, bigint: function(e3) {
    if (e3 <= 3n) return e3 > 1n;
    if (e3 % 2n === 0n || e3 % 3n === 0n) return false;
    for (var t22 = 5n; t22 * t22 <= e3; t22 += 6n) if (e3 % t22 === 0n || e3 % (t22 + 2n) === 0n) return false;
    return true;
  }, BigNumber: function(e3) {
    if (e3.lte(3)) return e3.gt(1);
    if (e3.mod(2).eq(0) || e3.mod(3).eq(0)) return false;
    if (e3.lt(Math.pow(2, 32))) {
      for (var t22 = e3.toNumber(), r = 5; r * r <= t22; r += 6) if (t22 % r == 0 || t22 % (r + 2) == 0) return false;
      return true;
    }
    function n(e4, t3, r2) {
      for (var n3 = 1; !t3.eq(0); ) t3.mod(2).eq(0) ? (t3 = t3.div(2), e4 = e4.mul(e4).mod(r2)) : (t3 = t3.sub(1), n3 = e4.mul(n3).mod(r2));
      return n3;
    }
    for (var i2 = e3.constructor.clone({ precision: 2 * e3.toFixed(0).length }), a = 0, o = (e3 = new i2(e3)).sub(1); o.mod(2).eq(0); ) o = o.div(2), a += 1;
    var s = null;
    if (e3.lt("3317044064679887385961981")) s = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter(((t3) => t3 < e3));
    else {
      var u = Math.min(e3.toNumber() - 2, Math.floor(2 * Math.pow(e3.toFixed(0).length * Math.log(10), 2)));
      s = [];
      for (var c2 = 2; c2 <= u; c2 += 1) s.push(u);
    }
    for (var l = 0; l < s.length; l += 1) {
      var f2 = s[l], p = n(e3.sub(e3).add(f2), o, e3);
      if (!p.eq(1)) {
        for (var m = 0, d = p; !d.eq(e3.sub(1)); m += 1, d = d.mul(d).mod(e3)) if (m === a - 1) return false;
      }
    }
    return true;
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$30 = "numeric", dependencies$30 = ["number", "?bignumber", "?fraction"], createNumeric = factory(name$30, dependencies$30, ((e2) => {
  var { number: t2, bignumber: r, fraction: n } = e2, i2 = { string: true, number: true, BigNumber: true, Fraction: true }, a = { number: (e3) => t2(e3), BigNumber: r ? (e3) => r(e3) : noBignumber, bigint: (e3) => BigInt(e3), Fraction: n ? (e3) => n(e3) : noFraction };
  return function(e3) {
    var t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "number";
    if (void 0 !== (arguments.length > 2 ? arguments[2] : void 0)) throw new SyntaxError("numeric() takes one or two arguments");
    var r2 = typeOf(e3);
    if (!(r2 in i2)) throw new TypeError("Cannot convert " + e3 + ' of type "' + r2 + '"; valid input types are ' + Object.keys(i2).join(", "));
    if (!(t22 in a)) throw new TypeError("Cannot convert " + e3 + ' to type "' + t22 + '"; valid output types are ' + Object.keys(a).join(", "));
    return t22 === r2 ? e3 : a[t22](e3);
  };
})), name$2$ = "divideScalar", dependencies$2$ = ["typed", "numeric"], createDivideScalar = factory(name$2$, dependencies$2$, ((e2) => {
  var { typed: t2, numeric: r } = e2;
  return t2(name$2$, { "number, number": function(e3, t22) {
    return e3 / t22;
  }, "Complex, Complex": function(e3, t22) {
    return e3.div(t22);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return e3.div(t22);
  }, "bigint, bigint": function(e3, t22) {
    return e3 / t22;
  }, "Fraction, Fraction": function(e3, t22) {
    return e3.div(t22);
  }, "Unit, number | Complex | Fraction | BigNumber | Unit": (e3, t22) => e3.divide(t22), "number | Fraction | Complex | BigNumber, Unit": (e3, t22) => t22.divideInto(e3) });
})), name$2_ = "pow", dependencies$2_ = ["typed", "config", "identity", "multiply", "matrix", "inv", "fraction", "number", "Complex"], createPow = factory(name$2_, dependencies$2_, ((e2) => {
  var { typed: t2, config: r, identity: n, multiply: i2, matrix: a, inv: o, number: s, fraction: u, Complex: c2 } = e2;
  return t2(name$2_, { "number, number": l, "Complex, Complex": function(e3, t22) {
    return e3.pow(t22);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return t22.isInteger() || e3 >= 0 || r.predictable ? e3.pow(t22) : new c2(e3.toNumber(), 0).pow(t22.toNumber(), 0);
  }, "bigint, bigint": (e3, t22) => e3 ** t22, "Fraction, Fraction": function(e3, t22) {
    var n3 = e3.pow(t22);
    if (null != n3) return n3;
    if (r.predictable) throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
    return l(e3.valueOf(), t22.valueOf());
  }, "Array, number": f2, "Array, BigNumber": function(e3, t22) {
    return f2(e3, t22.toNumber());
  }, "Matrix, number": p, "Matrix, BigNumber": function(e3, t22) {
    return p(e3, t22.toNumber());
  }, "Unit, number | BigNumber": function(e3, t22) {
    return e3.pow(t22);
  } });
  function l(e3, t22) {
    if (r.predictable && !isInteger(t22) && e3 < 0) try {
      var n3 = u(t22), i22 = s(n3);
      if ((t22 === i22 || Math.abs((t22 - i22) / t22) < 1e-14) && n3.d % 2n === 1n) return (n3.n % 2n === 0n ? 1 : -1) * Math.pow(-e3, t22);
    } catch (e4) {
    }
    return r.predictable && (e3 < -1 && t22 === 1 / 0 || e3 > -1 && e3 < 0 && t22 === -1 / 0) ? NaN : isInteger(t22) || e3 >= 0 || r.predictable ? powNumber(e3, t22) : e3 * e3 < 1 && t22 === 1 / 0 || e3 * e3 > 1 && t22 === -1 / 0 ? 0 : new c2(e3, 0).pow(t22, 0);
  }
  function f2(e3, t22) {
    if (!isInteger(t22)) throw new TypeError("For A^b, b must be an integer (value is " + t22 + ")");
    var r2 = arraySize(e3);
    if (2 !== r2.length) throw new Error("For A^b, A must be 2 dimensional (A has " + r2.length + " dimensions)");
    if (r2[0] !== r2[1]) throw new Error("For A^b, A must be square (size is " + r2[0] + "x" + r2[1] + ")");
    if (t22 < 0) try {
      return f2(o(e3), -t22);
    } catch (e4) {
      if ("Cannot calculate inverse, determinant is zero" === e4.message) throw new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + t22 + ")");
      throw e4;
    }
    for (var a2 = n(r2[0]).valueOf(), s2 = e3; t22 >= 1; ) 1 & ~t22 || (a2 = i2(s2, a2)), t22 >>= 1, s2 = i2(s2, s2);
    return a2;
  }
  function p(e3, t22) {
    return a(f2(e3.valueOf(), t22));
  }
})), NO_INT = "Number of decimals in function round must be an integer", name$2Z = "round", dependencies$2Z = ["typed", "config", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix"], createRound = factory(name$2Z, dependencies$2Z, ((e2) => {
  var { typed: t2, config: r, matrix: n, equalScalar: i2, zeros: a, BigNumber: o, DenseMatrix: s } = e2, u = createMatAlgo11xS0s({ typed: t2, equalScalar: i2 }), c2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: s }), l = createMatAlgo14xDs({ typed: t2 });
  function f2(e3) {
    return Math.abs(splitNumber(e3).exponent);
  }
  return t2(name$2Z, { number: function(e3) {
    var t22 = roundNumber(e3, f2(r.relTol));
    return roundNumber(nearlyEqual$1(e3, t22, r.relTol, r.absTol) ? t22 : e3);
  }, "number, number": function(e3, t22) {
    var n3 = f2(r.relTol);
    if (t22 >= n3) return roundNumber(e3, t22);
    var i22 = roundNumber(e3, n3);
    return roundNumber(nearlyEqual$1(e3, i22, r.relTol, r.absTol) ? i22 : e3, t22);
  }, "number, BigNumber": function(e3, t22) {
    if (!t22.isInteger()) throw new TypeError(NO_INT);
    return new o(e3).toDecimalPlaces(t22.toNumber());
  }, Complex: function(e3) {
    return e3.round();
  }, "Complex, number": function(e3, t22) {
    if (t22 % 1) throw new TypeError(NO_INT);
    return e3.round(t22);
  }, "Complex, BigNumber": function(e3, t22) {
    if (!t22.isInteger()) throw new TypeError(NO_INT);
    var r2 = t22.toNumber();
    return e3.round(r2);
  }, BigNumber: function(e3) {
    var t22 = new o(e3).toDecimalPlaces(f2(r.relTol));
    return (nearlyEqual(e3, t22, r.relTol, r.absTol) ? t22 : e3).toDecimalPlaces(0);
  }, "BigNumber, BigNumber": function(e3, t22) {
    if (!t22.isInteger()) throw new TypeError(NO_INT);
    var n3 = f2(r.relTol);
    if (t22 >= n3) return e3.toDecimalPlaces(t22.toNumber());
    var i22 = e3.toDecimalPlaces(n3);
    return (nearlyEqual(e3, i22, r.relTol, r.absTol) ? i22 : e3).toDecimalPlaces(t22.toNumber());
  }, bigint: (e3) => e3, "bigint, number": (e3, t22) => e3, "bigint, BigNumber": (e3, t22) => e3, Fraction: function(e3) {
    return e3.round();
  }, "Fraction, number": function(e3, t22) {
    if (t22 % 1) throw new TypeError(NO_INT);
    return e3.round(t22);
  }, "Fraction, BigNumber": function(e3, t22) {
    if (!t22.isInteger()) throw new TypeError(NO_INT);
    return e3.round(t22.toNumber());
  }, "Unit, number, Unit": t2.referToSelf(((e3) => function(t22, r2, n3) {
    var i22 = t22.toNumeric(n3);
    return n3.multiply(e3(i22, r2));
  })), "Unit, BigNumber, Unit": t2.referToSelf(((e3) => (t22, r2, n3) => e3(t22, r2.toNumber(), n3))), "Array | Matrix, number | BigNumber, Unit": t2.referToSelf(((e3) => (t22, r2, n3) => deepMap(t22, ((t3) => e3(t3, r2, n3)), true))), "Array | Matrix | Unit, Unit": t2.referToSelf(((e3) => (t22, r2) => e3(t22, 0, r2))), "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3, true))), "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => u(t22, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => l(t22, r2, e3, false))), "Array, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => l(n(t22), r2, e3, false).valueOf())), "number | Complex | BigNumber | Fraction, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => i2(t22, 0) ? a(r2.size(), r2.storage()) : c2(r2, t22, e3, true))), "number | Complex | BigNumber | Fraction, DenseMatrix": t2.referToSelf(((e3) => (t22, r2) => i2(t22, 0) ? a(r2.size(), r2.storage()) : l(r2, t22, e3, true))), "number | Complex | BigNumber | Fraction, Array": t2.referToSelf(((e3) => (t22, r2) => l(n(r2), t22, e3, true).valueOf())) });
})), name$2Y = "log", dependencies$2Y = ["config", "typed", "typeOf", "divideScalar", "Complex"], nlg16 = Math.log(16), createLog = factory(name$2Y, dependencies$2Y, ((e2) => {
  var { typed: t2, typeOf: r, config: n, divideScalar: i2, Complex: a } = e2;
  function o(e3) {
    return e3.log();
  }
  function s(e3) {
    return o(new a(e3, 0));
  }
  return t2(name$2Y, { number: function(e3) {
    return e3 >= 0 || n.predictable ? logNumber(e3) : s(e3);
  }, bigint: promoteLogarithm(nlg16, logNumber, n, s), Complex: o, BigNumber: function(e3) {
    return !e3.isNegative() || n.predictable ? e3.ln() : s(e3.toNumber());
  }, "any, any": t2.referToSelf(((e3) => (t22, n3) => {
    if ("Fraction" === r(t22) && "Fraction" === r(n3)) {
      var a2 = t22.log(n3);
      if (null !== a2) return a2;
    }
    return i2(e3(t22), e3(n3));
  })) });
})), name$2X = "log1p", dependencies$2X = ["typed", "config", "divideScalar", "log", "Complex"], createLog1p = factory(name$2X, dependencies$2X, ((e2) => {
  var { typed: t2, config: r, divideScalar: n, log: i2, Complex: a } = e2;
  return t2(name$2X, { number: function(e3) {
    return e3 >= -1 || r.predictable ? log1p(e3) : o(new a(e3, 0));
  }, Complex: o, BigNumber: function(e3) {
    var t22 = e3.plus(1);
    return !t22.isNegative() || r.predictable ? t22.ln() : o(new a(e3.toNumber(), 0));
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))), "any, any": t2.referToSelf(((e3) => (t22, r2) => n(e3(t22), i2(r2)))) });
  function o(e3) {
    var t22 = e3.re + 1;
    return new a(Math.log(Math.sqrt(t22 * t22 + e3.im * e3.im)), Math.atan2(e3.im, t22));
  }
})), name$2W = "nthRoots", dependencies$2W = ["config", "typed", "divideScalar", "Complex"], createNthRoots = factory(name$2W, dependencies$2W, ((e2) => {
  var { typed: t2, config: r, divideScalar: n, Complex: i2 } = e2, a = [function(e3) {
    return new i2(e3, 0);
  }, function(e3) {
    return new i2(0, e3);
  }, function(e3) {
    return new i2(-e3, 0);
  }, function(e3) {
    return new i2(0, -e3);
  }];
  function o(e3, t22) {
    if (t22 < 0) throw new Error("Root must be greater than zero");
    if (0 === t22) throw new Error("Root must be non-zero");
    if (t22 % 1 != 0) throw new Error("Root must be an integer");
    if (0 === e3 || 0 === e3.abs()) return [new i2(0, 0)];
    var r2, n3 = "number" == typeof e3;
    (n3 || 0 === e3.re || 0 === e3.im) && (r2 = n3 ? 2 * +(e3 < 0) : 0 === e3.im ? 2 * +(e3.re < 0) : 2 * +(e3.im < 0) + 1);
    for (var o2 = e3.arg(), s = e3.abs(), u = [], c2 = Math.pow(s, 1 / t22), l = 0; l < t22; l++) {
      var f2 = (r2 + 4 * l) / t22;
      f2 !== Math.round(f2) ? u.push(new i2({ r: c2, phi: (o2 + 2 * Math.PI * l) / t22 })) : u.push(a[f2 % 4](c2));
    }
    return u;
  }
  return t2(name$2W, { Complex: function(e3) {
    return o(e3, 2);
  }, "Complex, number": o });
})), name$2V = "dotPow", dependencies$2V = ["typed", "equalScalar", "matrix", "pow", "DenseMatrix", "concat", "SparseMatrix"], createDotPow = factory(name$2V, dependencies$2V, ((e2) => {
  var { typed: t2, equalScalar: r, matrix: n, pow: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo03xDSf({ typed: t2 }), c2 = createMatAlgo07xSSf({ typed: t2, SparseMatrix: s }), l = createMatAlgo11xS0s({ typed: t2, equalScalar: r }), f2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: a }), p = createMatrixAlgorithmSuite({ typed: t2, matrix: n, concat: o }), m = {};
  for (var d in i2.signatures) Object.prototype.hasOwnProperty.call(i2.signatures, d) && (d.includes("Matrix") || d.includes("Array") || (m[d] = i2.signatures[d]));
  var h = t2(m);
  return t2(name$2V, p({ elop: h, SS: c2, DS: u, Ss: l, sS: f2 }));
})), name$2U = "dotDivide", dependencies$2U = ["typed", "matrix", "equalScalar", "divideScalar", "DenseMatrix", "concat", "SparseMatrix"], createDotDivide = factory(name$2U, dependencies$2U, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, divideScalar: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), c2 = createMatAlgo03xDSf({ typed: t2 }), l = createMatAlgo07xSSf({ typed: t2, SparseMatrix: s }), f2 = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), p = createMatAlgo12xSfs({ typed: t2, DenseMatrix: a }), m = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: o });
  return t2(name$2U, m({ elop: i2, SS: l, DS: c2, SD: u, Ss: f2, sS: p }));
}));
function createSolveValidation(e2) {
  var { DenseMatrix: t2 } = e2;
  return function(e3, r, n) {
    var i2 = e3.size();
    if (2 !== i2.length) throw new RangeError("Matrix must be two dimensional (size: " + format(i2) + ")");
    var a = i2[0];
    if (a !== i2[1]) throw new RangeError("Matrix must be square (size: " + format(i2) + ")");
    var o = [];
    if (isMatrix(r)) {
      var s = r.size(), u = r._data;
      if (1 === s.length) {
        if (s[0] !== a) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var c2 = 0; c2 < a; c2++) o[c2] = [u[c2]];
        return new t2({ data: o, size: [a, 1], datatype: r._datatype });
      }
      if (2 === s.length) {
        if (s[0] !== a || 1 !== s[1]) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        if (isDenseMatrix(r)) {
          if (n) {
            o = [];
            for (var l = 0; l < a; l++) o[l] = [u[l][0]];
            return new t2({ data: o, size: [a, 1], datatype: r._datatype });
          }
          return r;
        }
        if (isSparseMatrix(r)) {
          for (var f2 = 0; f2 < a; f2++) o[f2] = [0];
          for (var p = r._values, m = r._index, d = r._ptr, h = d[1], g = d[0]; g < h; g++) {
            o[m[g]][0] = p[g];
          }
          return new t2({ data: o, size: [a, 1], datatype: r._datatype });
        }
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
    if (isArray$1(r)) {
      var y = arraySize(r);
      if (1 === y.length) {
        if (y[0] !== a) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var v2 = 0; v2 < a; v2++) o[v2] = [r[v2]];
        return new t2({ data: o, size: [a, 1] });
      }
      if (2 === y.length) {
        if (y[0] !== a || 1 !== y[1]) throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var x2 = 0; x2 < a; x2++) o[x2] = [r[x2][0]];
        return new t2({ data: o, size: [a, 1] });
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
  };
}
var name$2T = "lsolve", dependencies$2T = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createLsolve = factory(name$2T, dependencies$2T, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, multiplyScalar: i2, subtractScalar: a, equalScalar: o, DenseMatrix: s } = e2, u = createSolveValidation({ DenseMatrix: s });
  return t2(name$2T, { "SparseMatrix, Array | Matrix": function(e3, t22) {
    return (function(e4, t3) {
      for (var r2 = (t3 = u(e4, t3, true))._data, c3 = e4._size[0], l = e4._size[1], f2 = e4._values, p = e4._index, m = e4._ptr, d = [], h = 0; h < l; h++) {
        var g = r2[h][0] || 0;
        if (o(g, 0)) d[h] = [0];
        else {
          for (var y = 0, v2 = [], x2 = [], b2 = m[h], _2 = m[h + 1], w2 = b2; w2 < _2; w2++) {
            var A2 = p[w2];
            A2 === h ? y = f2[w2] : A2 > h && (v2.push(f2[w2]), x2.push(A2));
          }
          if (o(y, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
          for (var N = n(g, y), D = 0, E = x2.length; D < E; D++) {
            var $2 = x2[D];
            r2[$2] = [a(r2[$2][0] || 0, i2(N, v2[D]))];
          }
          d[h] = [N];
        }
      }
      return new s({ data: d, size: [c3, 1] });
    })(e3, t22);
  }, "DenseMatrix, Array | Matrix": function(e3, t22) {
    return c2(e3, t22);
  }, "Array, Array | Matrix": function(e3, t22) {
    return c2(r(e3), t22).valueOf();
  } });
  function c2(e3, t22) {
    for (var r2 = (t22 = u(e3, t22, true))._data, c3 = e3._size[0], l = e3._size[1], f2 = [], p = e3._data, m = 0; m < l; m++) {
      var d = r2[m][0] || 0, h = void 0;
      if (o(d, 0)) h = 0;
      else {
        var g = p[m][m];
        if (o(g, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
        h = n(d, g);
        for (var y = m + 1; y < c3; y++) r2[y] = [a(r2[y][0] || 0, i2(h, p[y][m]))];
      }
      f2[m] = [h];
    }
    return new s({ data: f2, size: [c3, 1] });
  }
})), name$2S = "usolve", dependencies$2S = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createUsolve = factory(name$2S, dependencies$2S, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, multiplyScalar: i2, subtractScalar: a, equalScalar: o, DenseMatrix: s } = e2, u = createSolveValidation({ DenseMatrix: s });
  return t2(name$2S, { "SparseMatrix, Array | Matrix": function(e3, t22) {
    return (function(e4, t3) {
      for (var r2 = (t3 = u(e4, t3, true))._data, c3 = e4._size[0], l = e4._size[1], f2 = e4._values, p = e4._index, m = e4._ptr, d = [], h = l - 1; h >= 0; h--) {
        var g = r2[h][0] || 0;
        if (o(g, 0)) d[h] = [0];
        else {
          for (var y = 0, v2 = [], x2 = [], b2 = m[h], _2 = m[h + 1] - 1; _2 >= b2; _2--) {
            var w2 = p[_2];
            w2 === h ? y = f2[_2] : w2 < h && (v2.push(f2[_2]), x2.push(w2));
          }
          if (o(y, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
          for (var A2 = n(g, y), N = 0, D = x2.length; N < D; N++) {
            var E = x2[N];
            r2[E] = [a(r2[E][0], i2(A2, v2[N]))];
          }
          d[h] = [A2];
        }
      }
      return new s({ data: d, size: [c3, 1] });
    })(e3, t22);
  }, "DenseMatrix, Array | Matrix": function(e3, t22) {
    return c2(e3, t22);
  }, "Array, Array | Matrix": function(e3, t22) {
    return c2(r(e3), t22).valueOf();
  } });
  function c2(e3, t22) {
    for (var r2 = (t22 = u(e3, t22, true))._data, c3 = e3._size[0], l = e3._size[1], f2 = [], p = e3._data, m = l - 1; m >= 0; m--) {
      var d = r2[m][0] || 0, h = void 0;
      if (o(d, 0)) h = 0;
      else {
        var g = p[m][m];
        if (o(g, 0)) throw new Error("Linear system cannot be solved since matrix is singular");
        h = n(d, g);
        for (var y = m - 1; y >= 0; y--) r2[y] = [a(r2[y][0] || 0, i2(h, p[y][m]))];
      }
      f2[m] = [h];
    }
    return new s({ data: f2, size: [c3, 1] });
  }
})), name$2R = "lsolveAll", dependencies$2R = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createLsolveAll = factory(name$2R, dependencies$2R, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, multiplyScalar: i2, subtractScalar: a, equalScalar: o, DenseMatrix: s } = e2, u = createSolveValidation({ DenseMatrix: s });
  return t2(name$2R, { "SparseMatrix, Array | Matrix": function(e3, t22) {
    return (function(e4, t3) {
      for (var r2 = [u(e4, t3, true)._data.map(((e5) => e5[0]))], c3 = e4._size[0], l = e4._size[1], f2 = e4._values, p = e4._index, m = e4._ptr, d = 0; d < l; d++) for (var h = r2.length, g = 0; g < h; g++) {
        for (var y = r2[g], v2 = [], x2 = [], b2 = m[d], _2 = m[d + 1], w2 = 0, A2 = b2; A2 < _2; A2++) {
          var N = p[A2];
          N === d ? w2 = f2[A2] : N > d && (v2.push(f2[A2]), x2.push(N));
        }
        if (o(w2, 0)) if (o(y[d], 0)) {
          if (0 === g) {
            var D = [...y];
            D[d] = 1;
            for (var E = 0, $2 = x2.length; E < $2; E++) {
              var S2 = x2[E];
              D[S2] = a(D[S2], v2[E]);
            }
            r2.push(D);
          }
        } else {
          if (0 === g) return [];
          r2.splice(g, 1), g -= 1, h -= 1;
        }
        else {
          y[d] = n(y[d], w2);
          for (var C2 = 0, M2 = x2.length; C2 < M2; C2++) {
            var T2 = x2[C2];
            y[T2] = a(y[T2], i2(y[d], v2[C2]));
          }
        }
      }
      return r2.map(((e5) => new s({ data: e5.map(((e6) => [e6])), size: [c3, 1] })));
    })(e3, t22);
  }, "DenseMatrix, Array | Matrix": function(e3, t22) {
    return c2(e3, t22);
  }, "Array, Array | Matrix": function(e3, t22) {
    return c2(r(e3), t22).map(((e4) => e4.valueOf()));
  } });
  function c2(e3, t22) {
    for (var r2 = [u(e3, t22, true)._data.map(((e4) => e4[0]))], c3 = e3._data, l = e3._size[0], f2 = e3._size[1], p = 0; p < f2; p++) for (var m = r2.length, d = 0; d < m; d++) {
      var h = r2[d];
      if (o(c3[p][p], 0)) if (o(h[p], 0)) {
        if (0 === d) {
          var g = [...h];
          g[p] = 1;
          for (var y = p + 1; y < f2; y++) g[y] = a(g[y], c3[y][p]);
          r2.push(g);
        }
      } else {
        if (0 === d) return [];
        r2.splice(d, 1), d -= 1, m -= 1;
      }
      else {
        h[p] = n(h[p], c3[p][p]);
        for (var v2 = p + 1; v2 < f2; v2++) h[v2] = a(h[v2], i2(h[p], c3[v2][p]));
      }
    }
    return r2.map(((e4) => new s({ data: e4.map(((e5) => [e5])), size: [l, 1] })));
  }
})), name$2Q = "usolveAll", dependencies$2Q = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], createUsolveAll = factory(name$2Q, dependencies$2Q, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, multiplyScalar: i2, subtractScalar: a, equalScalar: o, DenseMatrix: s } = e2, u = createSolveValidation({ DenseMatrix: s });
  return t2(name$2Q, { "SparseMatrix, Array | Matrix": function(e3, t22) {
    return (function(e4, t3) {
      for (var r2 = [u(e4, t3, true)._data.map(((e5) => e5[0]))], c3 = e4._size[0], l = e4._size[1], f2 = e4._values, p = e4._index, m = e4._ptr, d = l - 1; d >= 0; d--) for (var h = r2.length, g = 0; g < h; g++) {
        for (var y = r2[g], v2 = [], x2 = [], b2 = m[d], _2 = 0, w2 = m[d + 1] - 1; w2 >= b2; w2--) {
          var A2 = p[w2];
          A2 === d ? _2 = f2[w2] : A2 < d && (v2.push(f2[w2]), x2.push(A2));
        }
        if (o(_2, 0)) if (o(y[d], 0)) {
          if (0 === g) {
            var N = [...y];
            N[d] = 1;
            for (var D = 0, E = x2.length; D < E; D++) {
              var $2 = x2[D];
              N[$2] = a(N[$2], v2[D]);
            }
            r2.push(N);
          }
        } else {
          if (0 === g) return [];
          r2.splice(g, 1), g -= 1, h -= 1;
        }
        else {
          y[d] = n(y[d], _2);
          for (var S2 = 0, C2 = x2.length; S2 < C2; S2++) {
            var M2 = x2[S2];
            y[M2] = a(y[M2], i2(y[d], v2[S2]));
          }
        }
      }
      return r2.map(((e5) => new s({ data: e5.map(((e6) => [e6])), size: [c3, 1] })));
    })(e3, t22);
  }, "DenseMatrix, Array | Matrix": function(e3, t22) {
    return c2(e3, t22);
  }, "Array, Array | Matrix": function(e3, t22) {
    return c2(r(e3), t22).map(((e4) => e4.valueOf()));
  } });
  function c2(e3, t22) {
    for (var r2 = [u(e3, t22, true)._data.map(((e4) => e4[0]))], c3 = e3._data, l = e3._size[0], f2 = e3._size[1] - 1; f2 >= 0; f2--) for (var p = r2.length, m = 0; m < p; m++) {
      var d = r2[m];
      if (o(c3[f2][f2], 0)) if (o(d[f2], 0)) {
        if (0 === m) {
          var h = [...d];
          h[f2] = 1;
          for (var g = f2 - 1; g >= 0; g--) h[g] = a(h[g], c3[g][f2]);
          r2.push(h);
        }
      } else {
        if (0 === m) return [];
        r2.splice(m, 1), m -= 1, p -= 1;
      }
      else {
        d[f2] = n(d[f2], c3[f2][f2]);
        for (var y = f2 - 1; y >= 0; y--) d[y] = a(d[y], i2(d[f2], c3[y][f2]));
      }
    }
    return r2.map(((e4) => new s({ data: e4.map(((e5) => [e5])), size: [l, 1] })));
  }
})), name$2P = "matAlgo08xS0Sid", dependencies$2P = ["typed", "equalScalar"], createMatAlgo08xS0Sid = factory(name$2P, dependencies$2P, ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return function(e3, n, i2) {
    var a = e3._values, o = e3._index, s = e3._ptr, u = e3._size, c2 = e3._datatype || void 0 === e3._data ? e3._datatype : e3.getDataType(), l = n._values, f2 = n._index, p = n._ptr, m = n._size, d = n._datatype || void 0 === n._data ? n._datatype : n.getDataType();
    if (u.length !== m.length) throw new DimensionError(u.length, m.length);
    if (u[0] !== m[0] || u[1] !== m[1]) throw new RangeError("Dimension mismatch. Matrix A (" + u + ") must match Matrix B (" + m + ")");
    if (!a || !l) throw new Error("Cannot perform operation on Pattern Sparse Matrices");
    var h, g = u[0], y = u[1], v2 = r, x2 = 0, b2 = i2;
    "string" == typeof c2 && c2 === d && "mixed" !== c2 && (h = c2, v2 = t2.find(r, [h, h]), x2 = t2.convert(0, h), b2 = t2.find(i2, [h, h]));
    for (var _2, w2, A2, N, D = [], E = [], $2 = [], S2 = [], C2 = [], M2 = 0; M2 < y; M2++) {
      $2[M2] = E.length;
      var T2 = M2 + 1;
      for (w2 = s[M2], A2 = s[M2 + 1], _2 = w2; _2 < A2; _2++) C2[N = o[_2]] = T2, S2[N] = a[_2], E.push(N);
      for (w2 = p[M2], A2 = p[M2 + 1], _2 = w2; _2 < A2; _2++) C2[N = f2[_2]] === T2 && (S2[N] = b2(S2[N], l[_2]));
      for (_2 = $2[M2]; _2 < E.length; ) {
        var F = S2[N = E[_2]];
        v2(F, x2) ? E.splice(_2, 1) : (D.push(F), _2++);
      }
    }
    return $2[y] = E.length, e3.createSparseMatrix({ values: D, index: E, ptr: $2, size: [g, y], datatype: c2 === e3._datatype && d === n._datatype ? h : void 0 });
  };
})), createUseMatrixForArrayScalar = factory("useMatrixForArrayScalar", ["typed", "matrix"], ((e2) => {
  var { typed: t2, matrix: r } = e2;
  return { "Array, number": t2.referTo("DenseMatrix, number", ((e3) => (t22, n) => e3(r(t22), n).valueOf())), "Array, BigNumber": t2.referTo("DenseMatrix, BigNumber", ((e3) => (t22, n) => e3(r(t22), n).valueOf())), "number, Array": t2.referTo("number, DenseMatrix", ((e3) => (t22, n) => e3(t22, r(n)).valueOf())), "BigNumber, Array": t2.referTo("BigNumber, DenseMatrix", ((e3) => (t22, n) => e3(t22, r(n)).valueOf())) };
})), name$2O = "leftShift", dependencies$2O = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createLeftShift = factory(name$2O, dependencies$2O, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, DenseMatrix: a, concat: o } = e2, s = createMatAlgo01xDSid({ typed: t2 }), u = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), c2 = createMatAlgo08xS0Sid({ typed: t2, equalScalar: n }), l = createMatAlgo10xSids({ typed: t2, DenseMatrix: a }), f2 = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), p = createMatAlgo14xDs({ typed: t2 }), m = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: o }), d = createUseMatrixForArrayScalar({ typed: t2, matrix: r });
  return t2(name$2O, { "number, number": leftShiftNumber, "BigNumber, BigNumber": leftShiftBigNumber, "bigint, bigint": (e3, t22) => e3 << t22, "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => n(r2, 0) ? t22.clone() : f2(t22, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => n(r2, 0) ? t22.clone() : p(t22, r2, e3, false))), "number | BigNumber, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => n(t22, 0) ? i2(r2.size(), r2.storage()) : l(r2, t22, e3, true))), "number | BigNumber, DenseMatrix": t2.referToSelf(((e3) => (t22, r2) => n(t22, 0) ? i2(r2.size(), r2.storage()) : p(r2, t22, e3, true))) }, d, m({ SS: c2, DS: s, SD: u }));
})), name$2N = "rightArithShift", dependencies$2N = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createRightArithShift = factory(name$2N, dependencies$2N, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, DenseMatrix: a, concat: o } = e2, s = createMatAlgo01xDSid({ typed: t2 }), u = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), c2 = createMatAlgo08xS0Sid({ typed: t2, equalScalar: n }), l = createMatAlgo10xSids({ typed: t2, DenseMatrix: a }), f2 = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), p = createMatAlgo14xDs({ typed: t2 }), m = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: o }), d = createUseMatrixForArrayScalar({ typed: t2, matrix: r });
  return t2(name$2N, { "number, number": rightArithShiftNumber, "BigNumber, BigNumber": rightArithShiftBigNumber, "bigint, bigint": (e3, t22) => e3 >> t22, "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => n(r2, 0) ? t22.clone() : f2(t22, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => n(r2, 0) ? t22.clone() : p(t22, r2, e3, false))), "number | BigNumber, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => n(t22, 0) ? i2(r2.size(), r2.storage()) : l(r2, t22, e3, true))), "number | BigNumber, DenseMatrix": t2.referToSelf(((e3) => (t22, r2) => n(t22, 0) ? i2(r2.size(), r2.storage()) : p(r2, t22, e3, true))) }, d, m({ SS: c2, DS: s, SD: u }));
})), name$2M = "rightLogShift", dependencies$2M = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], createRightLogShift = factory(name$2M, dependencies$2M, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, DenseMatrix: a, concat: o } = e2, s = createMatAlgo01xDSid({ typed: t2 }), u = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), c2 = createMatAlgo08xS0Sid({ typed: t2, equalScalar: n }), l = createMatAlgo10xSids({ typed: t2, DenseMatrix: a }), f2 = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), p = createMatAlgo14xDs({ typed: t2 }), m = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: o }), d = createUseMatrixForArrayScalar({ typed: t2, matrix: r });
  return t2(name$2M, { "number, number": rightLogShiftNumber, "SparseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => n(r2, 0) ? t22.clone() : f2(t22, r2, e3, false))), "DenseMatrix, number | BigNumber": t2.referToSelf(((e3) => (t22, r2) => n(r2, 0) ? t22.clone() : p(t22, r2, e3, false))), "number | BigNumber, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => n(t22, 0) ? i2(r2.size(), r2.storage()) : l(r2, t22, e3, true))), "number | BigNumber, DenseMatrix": t2.referToSelf(((e3) => (t22, r2) => n(t22, 0) ? i2(r2.size(), r2.storage()) : p(r2, t22, e3, true))) }, d, m({ SS: c2, DS: s, SD: u }));
})), name$2L = "and", dependencies$2L = ["typed", "matrix", "equalScalar", "zeros", "not", "concat"], createAnd = factory(name$2L, dependencies$2L, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o } = e2, s = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), u = createMatAlgo06xS0S0({ typed: t2, equalScalar: n }), c2 = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), l = createMatAlgo14xDs({ typed: t2 }), f2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: o });
  return t2(name$2L, { "number, number": andNumber, "Complex, Complex": function(e3, t22) {
    return !(0 === e3.re && 0 === e3.im || 0 === t22.re && 0 === t22.im);
  }, "BigNumber, BigNumber": function(e3, t22) {
    return !(e3.isZero() || t22.isZero() || e3.isNaN() || t22.isNaN());
  }, "bigint, bigint": andNumber, "Unit, Unit": t2.referToSelf(((e3) => (t22, r2) => e3(t22.value || 0, r2.value || 0))), "SparseMatrix, any": t2.referToSelf(((e3) => (t22, r2) => a(r2) ? i2(t22.size(), t22.storage()) : c2(t22, r2, e3, false))), "DenseMatrix, any": t2.referToSelf(((e3) => (t22, r2) => a(r2) ? i2(t22.size(), t22.storage()) : l(t22, r2, e3, false))), "any, SparseMatrix": t2.referToSelf(((e3) => (t22, r2) => a(t22) ? i2(t22.size(), t22.storage()) : c2(r2, t22, e3, true))), "any, DenseMatrix": t2.referToSelf(((e3) => (t22, r2) => a(t22) ? i2(t22.size(), t22.storage()) : l(r2, t22, e3, true))), "Array, any": t2.referToSelf(((e3) => (t22, n3) => e3(r(t22), n3).valueOf())), "any, Array": t2.referToSelf(((e3) => (t22, n3) => e3(t22, r(n3)).valueOf())) }, f2({ SS: u, DS: s }));
})), name$2K = "compare", dependencies$2K = ["typed", "config", "matrix", "equalScalar", "BigNumber", "Fraction", "DenseMatrix", "concat"], createCompare = factory(name$2K, dependencies$2K, ((e2) => {
  var { typed: t2, config: r, equalScalar: n, matrix: i2, BigNumber: a, Fraction: o, DenseMatrix: s, concat: u } = e2, c2 = createMatAlgo03xDSf({ typed: t2 }), l = createMatAlgo05xSfSf({ typed: t2, equalScalar: n }), f2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: s }), p = createMatrixAlgorithmSuite({ typed: t2, matrix: i2, concat: u }), m = createCompareUnits({ typed: t2 });
  return t2(name$2K, createCompareNumber({ typed: t2, config: r }), { "boolean, boolean": function(e3, t22) {
    return e3 === t22 ? 0 : e3 > t22 ? 1 : -1;
  }, "BigNumber, BigNumber": function(e3, t22) {
    return nearlyEqual(e3, t22, r.relTol, r.absTol) ? new a(0) : new a(e3.cmp(t22));
  }, "bigint, bigint": function(e3, t22) {
    return e3 === t22 ? 0n : e3 > t22 ? 1n : -1n;
  }, "Fraction, Fraction": function(e3, t22) {
    return new o(e3.compare(t22));
  }, "Complex, Complex": function() {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, m, p({ SS: l, DS: c2, Ss: f2 }));
})), createCompareNumber = factory(name$2K, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2K, { "number, number": function(e3, t22) {
    return nearlyEqual$1(e3, t22, r.relTol, r.absTol) ? 0 : e3 > t22 ? 1 : -1;
  } });
})), naturalSort$1, hasRequiredNaturalSort;
function requireNaturalSort() {
  return hasRequiredNaturalSort || (hasRequiredNaturalSort = 1, naturalSort$1 = function e2(t2, r) {
    var n, i2, a = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, o = /(^[ ]*|[ ]*$)/g, s = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, u = /^0x[0-9a-f]+$/i, c2 = /^0/, l = function(t22) {
      return e2.insensitive && ("" + t22).toLowerCase() || "" + t22;
    }, f2 = l(t2).replace(o, "") || "", p = l(r).replace(o, "") || "", m = f2.replace(a, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), d = p.replace(a, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), h = parseInt(f2.match(u), 16) || 1 !== m.length && f2.match(s) && Date.parse(f2), g = parseInt(p.match(u), 16) || h && p.match(s) && Date.parse(p) || null;
    if (g) {
      if (h < g) return -1;
      if (h > g) return 1;
    }
    for (var y = 0, v2 = Math.max(m.length, d.length); y < v2; y++) {
      if (n = !(m[y] || "").match(c2) && parseFloat(m[y]) || m[y] || 0, i2 = !(d[y] || "").match(c2) && parseFloat(d[y]) || d[y] || 0, isNaN(n) !== isNaN(i2)) return isNaN(n) ? 1 : -1;
      if (typeof n != typeof i2 && (n += "", i2 += ""), n < i2) return -1;
      if (n > i2) return 1;
    }
    return 0;
  }), naturalSort$1;
}
var naturalSortExports = requireNaturalSort(), naturalSort = getDefaultExportFromCjs$2(naturalSortExports), name$2J = "compareNatural", dependencies$2J = ["typed", "compare"], createCompareNatural = factory(name$2J, dependencies$2J, ((e2) => {
  var { typed: t2, compare: r } = e2, n = r.signatures["boolean,boolean"];
  return t2(name$2J, { "any, any": function e3(t22, o) {
    var s, u = typeOf(t22), c2 = typeOf(o);
    if (!("number" !== u && "BigNumber" !== u && "Fraction" !== u || "number" !== c2 && "BigNumber" !== c2 && "Fraction" !== c2)) return "0" !== (s = r(t22, o)).toString() ? s > 0 ? 1 : -1 : naturalSort(u, c2);
    var l = ["Array", "DenseMatrix", "SparseMatrix"];
    if (l.includes(u) || l.includes(c2)) return 0 !== (s = i2(e3, t22, o)) ? s : naturalSort(u, c2);
    if (u !== c2) return naturalSort(u, c2);
    if ("Complex" === u) return compareComplexNumbers(t22, o);
    if ("Unit" === u) return t22.equalBase(o) ? e3(t22.value, o.value) : a(e3, t22.formatUnits(), o.formatUnits());
    if ("boolean" === u) return n(t22, o);
    if ("string" === u) return naturalSort(t22, o);
    if ("Object" === u) return (function(e4, t3, r2) {
      var n3 = Object.keys(t3), i22 = Object.keys(r2);
      n3.sort(naturalSort), i22.sort(naturalSort);
      var o2 = a(e4, n3, i22);
      if (0 !== o2) return o2;
      for (var s2 = 0; s2 < n3.length; s2++) {
        var u2 = e4(t3[n3[s2]], r2[i22[s2]]);
        if (0 !== u2) return u2;
      }
      return 0;
    })(e3, t22, o);
    if ("null" === u) return 0;
    if ("undefined" === u) return 0;
    throw new TypeError('Unsupported type of value "' + u + '"');
  } });
  function i2(e3, t22, r2) {
    return isSparseMatrix(t22) && isSparseMatrix(r2) ? a(e3, t22.toJSON().values, r2.toJSON().values) : isSparseMatrix(t22) ? i2(e3, t22.toArray(), r2) : isSparseMatrix(r2) ? i2(e3, t22, r2.toArray()) : isDenseMatrix(t22) ? i2(e3, t22.toJSON().data, r2) : isDenseMatrix(r2) ? i2(e3, t22, r2.toJSON().data) : Array.isArray(t22) ? Array.isArray(r2) ? a(e3, t22, r2) : i2(e3, t22, [r2]) : i2(e3, [t22], r2);
  }
  function a(e3, t22, r2) {
    for (var n3 = 0, i22 = Math.min(t22.length, r2.length); n3 < i22; n3++) {
      var a2 = e3(t22[n3], r2[n3]);
      if (0 !== a2) return a2;
    }
    return t22.length > r2.length ? 1 : t22.length < r2.length ? -1 : 0;
  }
}));
function compareComplexNumbers(e2, t2) {
  return e2.re > t2.re ? 1 : e2.re < t2.re ? -1 : e2.im > t2.im ? 1 : e2.im < t2.im ? -1 : 0;
}
var name$2I = "compareText", dependencies$2I = ["typed", "matrix", "concat"];
compareText.signature = "any, any";
var createCompareText = factory(name$2I, dependencies$2I, ((e2) => {
  var { typed: t2, matrix: r, concat: n } = e2, i2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: n });
  return t2(name$2I, compareText, i2({ elop: compareText, Ds: true }));
})), name$2H = "equal", dependencies$2H = ["typed", "matrix", "equalScalar", "DenseMatrix", "SparseMatrix"], createEqual = factory(name$2H, dependencies$2H, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a, SparseMatrix: o } = e2, s = createMatAlgo03xDSf({ typed: t2 }), u = createMatAlgo07xSSf({ typed: t2, SparseMatrix: o }), c2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: i2 }), l = createMatrixAlgorithmSuite({ typed: t2, matrix: r });
  return t2(name$2H, createEqualNumber({ typed: t2, equalScalar: n }), l({ elop: n, SS: u, DS: s, Ss: c2 }));
})), createEqualNumber = factory(name$2H, ["typed", "equalScalar"], ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return t2(name$2H, { "any, any": function(e3, t22) {
    return null === e3 ? null === t22 : null === t22 ? null === e3 : void 0 === e3 ? void 0 === t22 : void 0 === t22 ? void 0 === e3 : r(e3, t22);
  } });
})), name$2G = "equalText", dependencies$2G = ["typed", "compareText", "isZero"], createEqualText = factory(name$2G, dependencies$2G, ((e2) => {
  var { typed: t2, compareText: r, isZero: n } = e2;
  return t2(name$2G, { "any, any": function(e3, t22) {
    return n(r(e3, t22));
  } });
})), name$2F = "smaller", dependencies$2F = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createSmaller = factory(name$2F, dependencies$2F, ((e2) => {
  var { typed: t2, config: r, bignumber: n, matrix: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo03xDSf({ typed: t2 }), c2 = createMatAlgo07xSSf({ typed: t2, SparseMatrix: s }), l = createMatAlgo12xSfs({ typed: t2, DenseMatrix: a }), f2 = createMatrixAlgorithmSuite({ typed: t2, matrix: i2, concat: o }), p = createCompareUnits({ typed: t2 });
  function m(e3, t22) {
    return e3.lt(t22) && !nearlyEqual(e3, t22, r.relTol, r.absTol);
  }
  return t2(name$2F, createSmallerNumber({ typed: t2, config: r }), { "boolean, boolean": (e3, t22) => e3 < t22, "BigNumber, BigNumber": m, "bigint, bigint": (e3, t22) => e3 < t22, "Fraction, Fraction": (e3, t22) => -1 === e3.compare(t22), "Fraction, BigNumber": function(e3, t22) {
    return m(n(e3), t22);
  }, "BigNumber, Fraction": function(e3, t22) {
    return m(e3, n(t22));
  }, "Complex, Complex": function(e3, t22) {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, p, f2({ SS: c2, DS: u, Ss: l }));
})), createSmallerNumber = factory(name$2F, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2F, { "number, number": function(e3, t22) {
    return e3 < t22 && !nearlyEqual$1(e3, t22, r.relTol, r.absTol);
  } });
})), name$2E = "smallerEq", dependencies$2E = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createSmallerEq = factory(name$2E, dependencies$2E, ((e2) => {
  var { typed: t2, config: r, matrix: n, DenseMatrix: i2, concat: a, SparseMatrix: o } = e2, s = createMatAlgo03xDSf({ typed: t2 }), u = createMatAlgo07xSSf({ typed: t2, SparseMatrix: o }), c2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: i2 }), l = createMatrixAlgorithmSuite({ typed: t2, matrix: n, concat: a }), f2 = createCompareUnits({ typed: t2 });
  return t2(name$2E, createSmallerEqNumber({ typed: t2, config: r }), { "boolean, boolean": (e3, t22) => e3 <= t22, "BigNumber, BigNumber": function(e3, t22) {
    return e3.lte(t22) || nearlyEqual(e3, t22, r.relTol, r.absTol);
  }, "bigint, bigint": (e3, t22) => e3 <= t22, "Fraction, Fraction": (e3, t22) => 1 !== e3.compare(t22), "Complex, Complex": function() {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, f2, l({ SS: u, DS: s, Ss: c2 }));
})), createSmallerEqNumber = factory(name$2E, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2E, { "number, number": function(e3, t22) {
    return e3 <= t22 || nearlyEqual$1(e3, t22, r.relTol, r.absTol);
  } });
})), name$2D = "larger", dependencies$2D = ["typed", "config", "bignumber", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createLarger = factory(name$2D, dependencies$2D, ((e2) => {
  var { typed: t2, config: r, bignumber: n, matrix: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo03xDSf({ typed: t2 }), c2 = createMatAlgo07xSSf({ typed: t2, SparseMatrix: s }), l = createMatAlgo12xSfs({ typed: t2, DenseMatrix: a }), f2 = createMatrixAlgorithmSuite({ typed: t2, matrix: i2, concat: o }), p = createCompareUnits({ typed: t2 });
  function m(e3, t22) {
    return e3.gt(t22) && !nearlyEqual(e3, t22, r.relTol, r.absTol);
  }
  return t2(name$2D, createLargerNumber({ typed: t2, config: r }), { "boolean, boolean": (e3, t22) => e3 > t22, "BigNumber, BigNumber": m, "bigint, bigint": (e3, t22) => e3 > t22, "Fraction, Fraction": (e3, t22) => 1 === e3.compare(t22), "Fraction, BigNumber": function(e3, t22) {
    return m(n(e3), t22);
  }, "BigNumber, Fraction": function(e3, t22) {
    return m(e3, n(t22));
  }, "Complex, Complex": function() {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, p, f2({ SS: c2, DS: u, Ss: l }));
})), createLargerNumber = factory(name$2D, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2D, { "number, number": function(e3, t22) {
    return e3 > t22 && !nearlyEqual$1(e3, t22, r.relTol, r.absTol);
  } });
})), name$2C = "largerEq", dependencies$2C = ["typed", "config", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createLargerEq = factory(name$2C, dependencies$2C, ((e2) => {
  var { typed: t2, config: r, matrix: n, DenseMatrix: i2, concat: a, SparseMatrix: o } = e2, s = createMatAlgo03xDSf({ typed: t2 }), u = createMatAlgo07xSSf({ typed: t2, SparseMatrix: o }), c2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: i2 }), l = createMatrixAlgorithmSuite({ typed: t2, matrix: n, concat: a }), f2 = createCompareUnits({ typed: t2 });
  return t2(name$2C, createLargerEqNumber({ typed: t2, config: r }), { "boolean, boolean": (e3, t22) => e3 >= t22, "BigNumber, BigNumber": function(e3, t22) {
    return e3.gte(t22) || nearlyEqual(e3, t22, r.relTol, r.absTol);
  }, "bigint, bigint": function(e3, t22) {
    return e3 >= t22;
  }, "Fraction, Fraction": (e3, t22) => -1 !== e3.compare(t22), "Complex, Complex": function() {
    throw new TypeError("No ordering relation is defined for complex numbers");
  } }, f2, l({ SS: u, DS: s, Ss: c2 }));
})), createLargerEqNumber = factory(name$2C, ["typed", "config"], ((e2) => {
  var { typed: t2, config: r } = e2;
  return t2(name$2C, { "number, number": function(e3, t22) {
    return e3 >= t22 || nearlyEqual$1(e3, t22, r.relTol, r.absTol);
  } });
})), name$2B = "deepEqual", dependencies$2B = ["typed", "equal"], createDeepEqual = factory(name$2B, dependencies$2B, ((e2) => {
  var { typed: t2, equal: r } = e2;
  return t2(name$2B, { "any, any": function(e3, t22) {
    return n(e3.valueOf(), t22.valueOf());
  } });
  function n(e3, t22) {
    if (Array.isArray(e3)) {
      if (Array.isArray(t22)) {
        var i2 = e3.length;
        if (i2 !== t22.length) return false;
        for (var a = 0; a < i2; a++) if (!n(e3[a], t22[a])) return false;
        return true;
      }
      return false;
    }
    return !Array.isArray(t22) && r(e3, t22);
  }
})), name$2A = "unequal", dependencies$2A = ["typed", "config", "equalScalar", "matrix", "DenseMatrix", "concat", "SparseMatrix"], createUnequal = factory(name$2A, dependencies$2A, ((e2) => {
  var { typed: t2, config: r, equalScalar: n, matrix: i2, DenseMatrix: a, concat: o, SparseMatrix: s } = e2, u = createMatAlgo03xDSf({ typed: t2 }), c2 = createMatAlgo07xSSf({ typed: t2, SparseMatrix: s }), l = createMatAlgo12xSfs({ typed: t2, DenseMatrix: a }), f2 = createMatrixAlgorithmSuite({ typed: t2, matrix: i2, concat: o });
  return t2(name$2A, createUnequalNumber({ typed: t2, equalScalar: n }), f2({ elop: function(e3, t22) {
    return !n(e3, t22);
  }, SS: c2, DS: u, Ss: l }));
})), createUnequalNumber = factory(name$2A, ["typed", "equalScalar"], ((e2) => {
  var { typed: t2, equalScalar: r } = e2;
  return t2(name$2A, { "any, any": function(e3, t22) {
    return null === e3 ? null !== t22 : null === t22 ? null !== e3 : void 0 === e3 ? void 0 !== t22 : void 0 === t22 ? void 0 !== e3 : !r(e3, t22);
  } });
})), name$2z = "partitionSelect", dependencies$2z = ["typed", "isNumeric", "isNaN", "compare"], createPartitionSelect = factory(name$2z, dependencies$2z, ((e2) => {
  var { typed: t2, isNumeric: r, isNaN: n, compare: i2 } = e2, a = i2, o = (e3, t22) => -i2(e3, t22);
  return t2(name$2z, { "Array | Matrix, number": function(e3, t22) {
    return s(e3, t22, a);
  }, "Array | Matrix, number, string": function(e3, t22, r2) {
    if ("asc" === r2) return s(e3, t22, a);
    if ("desc" === r2) return s(e3, t22, o);
    throw new Error('Compare string must be "asc" or "desc"');
  }, "Array | Matrix, number, function": s });
  function s(e3, t22, r2) {
    if (!isInteger(t22) || t22 < 0) throw new Error("k must be a non-negative integer");
    if (isMatrix(e3)) {
      if (e3.size().length > 1) throw new Error("Only one dimensional matrices supported");
      return u(e3.valueOf(), t22, r2);
    }
    if (Array.isArray(e3)) return u(e3, t22, r2);
  }
  function u(e3, t22, i22) {
    if (t22 >= e3.length) throw new Error("k out of bounds");
    for (var a2 = 0; a2 < e3.length; a2++) if (r(e3[a2]) && n(e3[a2])) return e3[a2];
    for (var o2 = 0, s2 = e3.length - 1; o2 < s2; ) {
      for (var u2 = o2, c2 = s2, l = e3[Math.floor(Math.random() * (s2 - o2 + 1)) + o2]; u2 < c2; ) if (i22(e3[u2], l) >= 0) {
        var f2 = e3[c2];
        e3[c2] = e3[u2], e3[u2] = f2, --c2;
      } else ++u2;
      i22(e3[u2], l) > 0 && --u2, t22 <= u2 ? s2 = u2 : o2 = u2 + 1;
    }
    return e3[t22];
  }
})), name$2y = "sort", dependencies$2y = ["typed", "matrix", "compare", "compareNatural"], createSort = factory(name$2y, dependencies$2y, ((e2) => {
  var { typed: t2, matrix: r, compare: n, compareNatural: i2 } = e2, a = n, o = (e3, t22) => -n(e3, t22);
  return t2(name$2y, { Array: function(e3) {
    return u(e3), e3.sort(a);
  }, Matrix: function(e3) {
    return c2(e3), r(e3.toArray().sort(a), e3.storage());
  }, "Array, function": function(e3, t22) {
    return u(e3), e3.sort(t22);
  }, "Matrix, function": function(e3, t22) {
    return c2(e3), r(e3.toArray().sort(t22), e3.storage());
  }, "Array, string": function(e3, t22) {
    return u(e3), e3.sort(s(t22));
  }, "Matrix, string": function(e3, t22) {
    return c2(e3), r(e3.toArray().sort(s(t22)), e3.storage());
  } });
  function s(e3) {
    if ("asc" === e3) return a;
    if ("desc" === e3) return o;
    if ("natural" === e3) return i2;
    throw new Error('String "asc", "desc", or "natural" expected');
  }
  function u(e3) {
    if (1 !== arraySize(e3).length) throw new Error("One dimensional array expected");
  }
  function c2(e3) {
    if (1 !== e3.size().length) throw new Error("One dimensional matrix expected");
  }
})), name$2x = "max", dependencies$2x = ["typed", "config", "numeric", "larger", "isNaN"], createMax = factory(name$2x, dependencies$2x, ((e2) => {
  var { typed: t2, config: r, numeric: n, larger: i2, isNaN: a } = e2;
  return t2(name$2x, { "Array | Matrix": s, "Array | Matrix, number | BigNumber": function(e3, t22) {
    return reduce$2(e3, t22.valueOf(), o);
  }, "...": function(e3) {
    if (containsCollections(e3)) throw new TypeError("Scalar values expected in function max");
    return s(e3);
  } });
  function o(e3, t22) {
    try {
      return i2(e3, t22) ? e3 : t22;
    } catch (e4) {
      throw improveErrorMessage(e4, "max", t22);
    }
  }
  function s(e3) {
    var t22;
    if (deepForEach(e3, (function(e4) {
      try {
        (a(e4) || void 0 === t22 || i2(e4, t22)) && (t22 = e4);
      } catch (t3) {
        throw improveErrorMessage(t3, "max", e4);
      }
    })), void 0 === t22) throw new Error("Cannot calculate max of an empty array");
    return "string" == typeof t22 && (t22 = n(t22, safeNumberType(t22, r))), t22;
  }
})), name$2w = "min", dependencies$2w = ["typed", "config", "numeric", "smaller", "isNaN"], createMin = factory(name$2w, dependencies$2w, ((e2) => {
  var { typed: t2, config: r, numeric: n, smaller: i2, isNaN: a } = e2;
  return t2(name$2w, { "Array | Matrix": s, "Array | Matrix, number | BigNumber": function(e3, t22) {
    return reduce$2(e3, t22.valueOf(), o);
  }, "...": function(e3) {
    if (containsCollections(e3)) throw new TypeError("Scalar values expected in function min");
    return s(e3);
  } });
  function o(e3, t22) {
    try {
      return i2(e3, t22) ? e3 : t22;
    } catch (e4) {
      throw improveErrorMessage(e4, "min", t22);
    }
  }
  function s(e3) {
    var t22;
    if (deepForEach(e3, (function(e4) {
      try {
        (a(e4) || void 0 === t22 || i2(e4, t22)) && (t22 = e4);
      } catch (t3) {
        throw improveErrorMessage(t3, "min", e4);
      }
    })), void 0 === t22) throw new Error("Cannot calculate min of an empty array");
    return "string" == typeof t22 && (t22 = n(t22, safeNumberType(t22, r))), t22;
  }
})), name$2v = "ImmutableDenseMatrix", dependencies$2v = ["smaller", "DenseMatrix"], createImmutableDenseMatrixClass = factory(name$2v, dependencies$2v, ((e2) => {
  var { smaller: t2, DenseMatrix: r } = e2;
  function n(e3, t22) {
    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
    if (t22 && !isString$1(t22)) throw new Error("Invalid datatype: " + t22);
    if (isMatrix(e3) || isArray$1(e3)) {
      var i2 = new r(e3, t22);
      this._data = i2._data, this._size = i2._size, this._datatype = i2._datatype, this._min = null, this._max = null;
    } else if (e3 && isArray$1(e3.data) && isArray$1(e3.size)) this._data = e3.data, this._size = e3.size, this._datatype = e3.datatype, this._min = void 0 !== e3.min ? e3.min : null, this._max = void 0 !== e3.max ? e3.max : null;
    else {
      if (e3) throw new TypeError("Unsupported type of data (" + typeOf(e3) + ")");
      this._data = [], this._size = [0], this._datatype = t22, this._min = null, this._max = null;
    }
  }
  return n.prototype = new r(), n.prototype.type = "ImmutableDenseMatrix", n.prototype.isImmutableDenseMatrix = true, n.prototype.subset = function(e3) {
    switch (arguments.length) {
      case 1:
        var t22 = r.prototype.subset.call(this, e3);
        return isMatrix(t22) ? new n({ data: t22._data, size: t22._size, datatype: t22._datatype }) : t22;
      case 2:
      case 3:
        throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.set = function() {
    throw new Error("Cannot invoke set on an Immutable Matrix instance");
  }, n.prototype.resize = function() {
    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
  }, n.prototype.reshape = function() {
    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, n.prototype.clone = function() {
    return new n({ data: clone$3(this._data), size: clone$3(this._size), datatype: this._datatype });
  }, n.prototype.toJSON = function() {
    return { mathjs: "ImmutableDenseMatrix", data: this._data, size: this._size, datatype: this._datatype };
  }, n.fromJSON = function(e3) {
    return new n(e3);
  }, n.prototype.swapRows = function() {
    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, n.prototype.min = function() {
    if (null === this._min) {
      var e3 = null;
      this.forEach((function(r2) {
        (null === e3 || t2(r2, e3)) && (e3 = r2);
      })), this._min = null !== e3 ? e3 : void 0;
    }
    return this._min;
  }, n.prototype.max = function() {
    if (null === this._max) {
      var e3 = null;
      this.forEach((function(r2) {
        (null === e3 || t2(e3, r2)) && (e3 = r2);
      })), this._max = null !== e3 ? e3 : void 0;
    }
    return this._max;
  }, n;
}), { isClass: true }), name$2u = "Index", dependencies$2u = ["ImmutableDenseMatrix", "getMatrixDataType"], createIndexClass = factory(name$2u, dependencies$2u, ((e2) => {
  var { ImmutableDenseMatrix: t2, getMatrixDataType: r } = e2;
  function n() {
    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._sourceSize = [], this._isScalar = true;
    for (var e3 = 0, t22 = arguments.length; e3 < t22; e3++) {
      var a = e3 < 0 || arguments.length <= e3 ? void 0 : arguments[e3], o = isArray$1(a), s = isMatrix(a), u = typeof a, c2 = null;
      if (isRange(a)) this._dimensions.push(a), this._isScalar = false;
      else if (o || s) {
        var l = void 0;
        this._isScalar = false, "boolean" === r(a) ? (o && (l = i2(_booleansArrayToNumbersForIndex(a).valueOf())), s && (l = i2(_booleansArrayToNumbersForIndex(a._data).valueOf())), c2 = a.valueOf().length) : l = i2(a.valueOf()), this._dimensions.push(l);
      } else if ("number" === u) this._dimensions.push(a);
      else if ("bigint" === u) this._dimensions.push(Number(a));
      else {
        if ("string" !== u) throw new TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
        this._dimensions.push(a);
      }
      this._sourceSize.push(c2);
    }
  }
  function i2(e3) {
    for (var r2 = 0, n3 = e3.length; r2 < n3; r2++) if (!isNumber$1(e3[r2]) || !isInteger(e3[r2])) throw new TypeError("Index parameters must be positive integer numbers");
    var i22 = new t2();
    return i22._data = e3, i22._size = [e3.length], i22;
  }
  return n.prototype.type = "Index", n.prototype.isIndex = true, n.prototype.clone = function() {
    var e3 = new n();
    return e3._dimensions = clone$3(this._dimensions), e3._isScalar = this._isScalar, e3._sourceSize = this._sourceSize, e3;
  }, n.create = function(e3) {
    var t22 = new n();
    return n.apply(t22, e3), t22;
  }, n.prototype.size = function() {
    for (var e3 = [], t22 = 0, r2 = this._dimensions.length; t22 < r2; t22++) {
      var n3 = this._dimensions[t22];
      e3[t22] = isString$1(n3) || isNumber$1(n3) ? 1 : n3.size()[0];
    }
    return e3;
  }, n.prototype.max = function() {
    for (var e3 = [], t22 = 0, r2 = this._dimensions.length; t22 < r2; t22++) {
      var n3 = this._dimensions[t22];
      e3[t22] = isString$1(n3) || isNumber$1(n3) ? n3 : n3.max();
    }
    return e3;
  }, n.prototype.min = function() {
    for (var e3 = [], t22 = 0, r2 = this._dimensions.length; t22 < r2; t22++) {
      var n3 = this._dimensions[t22];
      e3[t22] = isString$1(n3) || isNumber$1(n3) ? n3 : n3.min();
    }
    return e3;
  }, n.prototype.forEach = function(e3) {
    for (var t22 = 0, r2 = this._dimensions.length; t22 < r2; t22++) e3(this._dimensions[t22], t22, this);
  }, n.prototype.dimension = function(e3) {
    var t22;
    return isNumber$1(e3) && null !== (t22 = this._dimensions[e3]) && void 0 !== t22 ? t22 : null;
  }, n.prototype.isObjectProperty = function() {
    return 1 === this._dimensions.length && isString$1(this._dimensions[0]);
  }, n.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, n.prototype.isScalar = function() {
    return this._isScalar;
  }, n.prototype.toArray = function() {
    for (var e3 = [], t22 = 0, r2 = this._dimensions.length; t22 < r2; t22++) {
      var n3 = this._dimensions[t22];
      e3.push(isString$1(n3) || isNumber$1(n3) ? n3 : n3.toArray());
    }
    return e3;
  }, n.prototype.valueOf = n.prototype.toArray, n.prototype.toString = function() {
    for (var e3 = [], t22 = 0, r2 = this._dimensions.length; t22 < r2; t22++) {
      var n3 = this._dimensions[t22];
      isString$1(n3) ? e3.push(JSON.stringify(n3)) : e3.push(n3.toString());
    }
    return "[" + e3.join(", ") + "]";
  }, n.prototype.toJSON = function() {
    return { mathjs: "Index", dimensions: this._dimensions };
  }, n.fromJSON = function(e3) {
    return n.create(e3.dimensions);
  }, n;
}), { isClass: true });
function _booleansArrayToNumbersForIndex(e2) {
  var t2 = [];
  return e2.forEach(((e3, r) => {
    e3 && t2.push(r);
  })), t2;
}
var name$2t = "FibonacciHeap", dependencies$2t = ["smaller", "larger"], createFibonacciHeapClass = factory(name$2t, dependencies$2t, ((e2) => {
  var { smaller: t2, larger: r } = e2, n = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function i2() {
    if (!(this instanceof i2)) throw new SyntaxError("Constructor must be called with the new operator");
    this._minimum = null, this._size = 0;
  }
  function a(e3, t22, r2) {
    t22.left.right = t22.right, t22.right.left = t22.left, r2.degree--, r2.child === t22 && (r2.child = t22.right), 0 === r2.degree && (r2.child = null), t22.left = e3, t22.right = e3.right, e3.right = t22, t22.right.left = t22, t22.parent = null, t22.mark = false;
  }
  function o(e3, t22) {
    var r2 = t22.parent;
    r2 && (t22.mark ? (a(e3, t22, r2), o(r2)) : t22.mark = true);
  }
  i2.prototype.type = "FibonacciHeap", i2.prototype.isFibonacciHeap = true, i2.prototype.insert = function(e3, r2) {
    var n3 = { key: e3, value: r2, degree: 0 };
    if (this._minimum) {
      var i22 = this._minimum;
      n3.left = i22, n3.right = i22.right, i22.right = n3, n3.right.left = n3, t2(e3, i22.key) && (this._minimum = n3);
    } else n3.left = n3, n3.right = n3, this._minimum = n3;
    return this._size++, n3;
  }, i2.prototype.size = function() {
    return this._size;
  }, i2.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, i2.prototype.isEmpty = function() {
    return 0 === this._size;
  }, i2.prototype.extractMinimum = function() {
    var e3 = this._minimum;
    if (null === e3) return e3;
    for (var i22 = this._minimum, a2 = e3.degree, o2 = e3.child; a2 > 0; ) {
      var u = o2.right;
      o2.left.right = o2.right, o2.right.left = o2.left, o2.left = i22, o2.right = i22.right, i22.right = o2, o2.right.left = o2, o2.parent = null, o2 = u, a2--;
    }
    return e3.left.right = e3.right, e3.right.left = e3.left, i22 = e3 === e3.right ? null : (function(e4, i3) {
      var a3, o3 = Math.floor(Math.log(i3) * n) + 1, u2 = new Array(o3), c2 = 0, l = e4;
      if (l) for (c2++, l = l.right; l !== e4; ) c2++, l = l.right;
      for (; c2 > 0; ) {
        for (var f2 = l.degree, p = l.right; a3 = u2[f2]; ) {
          if (r(l.key, a3.key)) {
            var m = a3;
            a3 = l, l = m;
          }
          s(a3, l), u2[f2] = null, f2++;
        }
        u2[f2] = l, l = p, c2--;
      }
      e4 = null;
      for (var d = 0; d < o3; d++) (a3 = u2[d]) && (e4 ? (a3.left.right = a3.right, a3.right.left = a3.left, a3.left = e4, a3.right = e4.right, e4.right = a3, a3.right.left = a3, t2(a3.key, e4.key) && (e4 = a3)) : e4 = a3);
      return e4;
    })(i22 = e3.right, this._size), this._size--, this._minimum = i22, e3;
  }, i2.prototype.remove = function(e3) {
    this._minimum = (function(e4, r2, n3) {
      r2.key = n3;
      var i22 = r2.parent;
      i22 && t2(r2.key, i22.key) && (a(e4, r2, i22), o(e4, i22));
      t2(r2.key, e4.key) && (e4 = r2);
      return e4;
    })(this._minimum, e3, -1), this.extractMinimum();
  };
  var s = function(e3, t22) {
    e3.left.right = e3.right, e3.right.left = e3.left, e3.parent = t22, t22.child ? (e3.left = t22.child, e3.right = t22.child.right, t22.child.right = e3, e3.right.left = e3) : (t22.child = e3, e3.right = e3, e3.left = e3), t22.degree++, e3.mark = false;
  };
  return i2;
}), { isClass: true }), name$2s = "Spa", dependencies$2s = ["addScalar", "equalScalar", "FibonacciHeap"], createSpaClass = factory(name$2s, dependencies$2s, ((e2) => {
  var { addScalar: t2, equalScalar: r, FibonacciHeap: n } = e2;
  function i2() {
    if (!(this instanceof i2)) throw new SyntaxError("Constructor must be called with the new operator");
    this._values = [], this._heap = new n();
  }
  return i2.prototype.type = "Spa", i2.prototype.isSpa = true, i2.prototype.set = function(e3, t22) {
    if (this._values[e3]) this._values[e3].value = t22;
    else {
      var r2 = this._heap.insert(e3, t22);
      this._values[e3] = r2;
    }
  }, i2.prototype.get = function(e3) {
    var t22 = this._values[e3];
    return t22 ? t22.value : 0;
  }, i2.prototype.accumulate = function(e3, r2) {
    var n3 = this._values[e3];
    n3 ? n3.value = t2(n3.value, r2) : (n3 = this._heap.insert(e3, r2), this._values[e3] = n3);
  }, i2.prototype.forEach = function(e3, t22, n3) {
    var i22 = this._heap, a = this._values, o = [], s = i22.extractMinimum();
    for (s && o.push(s); s && s.key <= t22; ) s.key >= e3 && (r(s.value, 0) || n3(s.key, s.value, this)), (s = i22.extractMinimum()) && o.push(s);
    for (var u = 0; u < o.length; u++) {
      var c2 = o[u];
      a[(s = i22.insert(c2.key, c2.value)).key] = s;
    }
  }, i2.prototype.swap = function(e3, t22) {
    var r2 = this._values[e3], n3 = this._values[t22];
    if (!r2 && n3) r2 = this._heap.insert(e3, n3.value), this._heap.remove(n3), this._values[e3] = r2, this._values[t22] = void 0;
    else if (r2 && !n3) n3 = this._heap.insert(t22, r2.value), this._heap.remove(r2), this._values[t22] = n3, this._values[e3] = void 0;
    else if (r2 && n3) {
      var i22 = r2.value;
      r2.value = n3.value, n3.value = i22;
    }
  }, i2;
}), { isClass: true });
function lruQueue(e2) {
  var t2 = 0, r = 1, n = /* @__PURE__ */ Object.create(null), i2 = /* @__PURE__ */ Object.create(null), a = 0, o = function(e3) {
    var o2 = i2[e3];
    if (o2 && (delete n[o2], delete i2[e3], --t2, r === o2)) {
      if (!t2) return a = 0, void (r = 1);
      for (; !Object.prototype.hasOwnProperty.call(n, ++r); ) ;
    }
  };
  return e2 = Math.abs(e2), { hit: function(s) {
    var u = i2[s], c2 = ++a;
    if (n[c2] = s, i2[s] = c2, !u) {
      if (++t2 <= e2) return;
      return s = n[r], o(s), s;
    }
    if (delete n[u], r === u) for (; !Object.prototype.hasOwnProperty.call(n, ++r); ) ;
  }, delete: o, clear: function() {
    t2 = a = 0, r = 1, n = /* @__PURE__ */ Object.create(null), i2 = /* @__PURE__ */ Object.create(null);
  } };
}
function memoize$1(e2) {
  var { hasher: t2, limit: r } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  return r = null == r ? Number.POSITIVE_INFINITY : r, t2 = null == t2 ? JSON.stringify : t2, function n() {
    "object" != typeof n.cache && (n.cache = { values: /* @__PURE__ */ new Map(), lru: lruQueue(r || Number.POSITIVE_INFINITY) });
    for (var i2 = [], a = 0; a < arguments.length; a++) i2[a] = arguments[a];
    var o = t2(i2);
    if (n.cache.values.has(o)) return n.cache.lru.hit(o), n.cache.values.get(o);
    var s = e2.apply(e2, i2);
    return n.cache.values.set(o, s), n.cache.values.delete(n.cache.lru.hit(o)), s;
  };
}
var createBigNumberE = memoize$1((function(e2) {
  return new e2(1).exp();
}), { hasher }), createBigNumberPhi = memoize$1((function(e2) {
  return new e2(1).plus(new e2(5).sqrt()).div(2);
}), { hasher }), createBigNumberPi = memoize$1((function(e2) {
  return e2.acos(-1);
}), { hasher }), createBigNumberTau = memoize$1((function(e2) {
  return createBigNumberPi(e2).times(2);
}), { hasher });
function hasher(e2) {
  return e2[0].precision;
}
function ownKeys$2(e2, t2) {
  var r = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e2);
    t2 && (n = n.filter((function(t22) {
      return Object.getOwnPropertyDescriptor(e2, t22).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread$2(e2) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? ownKeys$2(Object(r), true).forEach((function(t22) {
      _defineProperty$1(e2, t22, r[t22]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r)) : ownKeys$2(Object(r)).forEach((function(t22) {
      Object.defineProperty(e2, t22, Object.getOwnPropertyDescriptor(r, t22));
    }));
  }
  return e2;
}
var name$2r = "Unit", dependencies$2r = ["?on", "config", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "abs", "fix", "round", "equal", "isNumeric", "format", "number", "Complex", "BigNumber", "Fraction"], createUnitClass = factory(name$2r, dependencies$2r, ((e2) => {
  var t2, r, n, { on: i2, config: a, addScalar: o, subtractScalar: s, multiplyScalar: u, divideScalar: c2, pow: l, abs: f2, fix: p, round: m, equal: d, isNumeric: h, format: g, number: y, Complex: v2, BigNumber: x2, Fraction: b2 } = e2, _2 = y, w2 = false, A2 = true;
  function N(e3, t22) {
    if (!(this instanceof N)) throw new Error("Constructor must be called with the new operator");
    if (null != e3 && !h(e3) && !isComplex(e3)) throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
    if (this.fixPrefix = w2, this.skipAutomaticSimplification = A2, void 0 === t22) this.units = [], this.dimensions = R2.map(((e4) => 0));
    else if ("string" == typeof t22) {
      var r2 = N.parse(t22);
      this.units = r2.units, this.dimensions = r2.dimensions;
    } else {
      if (!isUnit(t22) || null !== t22.value) throw new TypeError("Second parameter in Unit constructor must be a string or valueless Unit");
      this.fixPrefix = t22.fixPrefix, this.skipAutomaticSimplification = t22.skipAutomaticSimplification, this.dimensions = t22.dimensions.slice(0), this.units = t22.units.map(((e4) => _extends$2({}, e4)));
    }
    this.value = this._normalize(e3);
  }
  function D() {
    for (; " " === n || "	" === n; ) $2();
  }
  function E(e3) {
    return e3 >= "0" && e3 <= "9";
  }
  function $2() {
    r++, n = t2.charAt(r);
  }
  function S2(e3) {
    r = e3, n = t2.charAt(r);
  }
  function C2() {
    var e3 = "", t22 = r;
    if ("+" === n ? $2() : "-" === n && (e3 += n, $2()), !(function(e4) {
      return e4 >= "0" && e4 <= "9" || "." === e4;
    })(n)) return S2(t22), null;
    if ("." === n) {
      if (e3 += n, $2(), !E(n)) return S2(t22), null;
    } else {
      for (; E(n); ) e3 += n, $2();
      "." === n && (e3 += n, $2());
    }
    for (; E(n); ) e3 += n, $2();
    if ("E" === n || "e" === n) {
      var i22 = "", a2 = r;
      if (i22 += n, $2(), "+" !== n && "-" !== n || (i22 += n, $2()), !E(n)) return S2(a2), e3;
      for (e3 += i22; E(n); ) e3 += n, $2();
    }
    return e3;
  }
  function M2() {
    for (var e3 = ""; E(n) || N.isValidAlpha(n); ) e3 += n, $2();
    var t22 = e3.charAt(0);
    return N.isValidAlpha(t22) ? e3 : null;
  }
  function T2(e3) {
    return n === e3 ? ($2(), e3) : null;
  }
  Object.defineProperty(N, "name", { value: "Unit" }), N.prototype.constructor = N, N.prototype.type = "Unit", N.prototype.isUnit = true, N.parse = function(e3, i22) {
    if (i22 = i22 || {}, r = -1, n = "", "string" != typeof (t2 = e3)) throw new TypeError("Invalid argument in Unit.parse, string expected");
    var o2 = new N();
    o2.units = [];
    var s2 = 1, u2 = false;
    $2(), D();
    var c3 = C2(), l2 = null;
    if (c3) {
      if ("BigNumber" === a.number) l2 = new x2(c3);
      else if ("Fraction" === a.number) try {
        l2 = new b2(c3);
      } catch (e4) {
        l2 = parseFloat(c3);
      }
      else l2 = parseFloat(c3);
      D(), T2("*") ? (s2 = 1, u2 = true) : T2("/") && (s2 = -1, u2 = true);
    }
    for (var f3 = [], p2 = 1; ; ) {
      for (D(); "(" === n; ) f3.push(s2), p2 *= s2, s2 = 1, $2(), D();
      var m2 = void 0;
      if (!n) break;
      var d2 = n;
      if (null === (m2 = M2())) throw new SyntaxError('Unexpected "' + d2 + '" in "' + t2 + '" at index ' + r.toString());
      var h2 = F(m2);
      if (null === h2) throw new SyntaxError('Unit "' + m2 + '" not found.');
      var g2 = s2 * p2;
      if (D(), T2("^")) {
        D();
        var y2 = C2();
        if (null === y2) throw new SyntaxError('In "' + e3 + '", "^" must be followed by a floating-point number');
        g2 *= y2;
      }
      o2.units.push({ unit: h2.unit, prefix: h2.prefix, power: g2 });
      for (var v22 = 0; v22 < R2.length; v22++) o2.dimensions[v22] += (h2.unit.dimensions[v22] || 0) * g2;
      for (D(); ")" === n; ) {
        if (0 === f3.length) throw new SyntaxError('Unmatched ")" in "' + t2 + '" at index ' + r.toString());
        p2 /= f3.pop(), $2(), D();
      }
      if (u2 = false, T2("*") ? (s2 = 1, u2 = true) : T2("/") ? (s2 = -1, u2 = true) : s2 = 1, h2.unit.base) {
        var _3 = h2.unit.base.key;
        Z2.auto[_3] = { unit: h2.unit, prefix: h2.prefix };
      }
    }
    if (D(), n) throw new SyntaxError('Could not parse: "' + e3 + '"');
    if (u2) throw new SyntaxError('Trailing characters: "' + e3 + '"');
    if (0 !== f3.length) throw new SyntaxError('Unmatched "(" in "' + t2 + '"');
    if (0 === o2.units.length && !i22.allowNoUnits) throw new SyntaxError('"' + e3 + '" contains no units');
    return o2.value = void 0 !== l2 ? o2._normalize(l2) : null, o2;
  }, N.prototype.clone = function() {
    var e3 = new N();
    e3.fixPrefix = this.fixPrefix, e3.skipAutomaticSimplification = this.skipAutomaticSimplification, e3.value = clone$3(this.value), e3.dimensions = this.dimensions.slice(0), e3.units = [];
    for (var t22 = 0; t22 < this.units.length; t22++) for (var r2 in e3.units[t22] = {}, this.units[t22]) hasOwnProperty$1$1(this.units[t22], r2) && (e3.units[t22][r2] = this.units[t22][r2]);
    return e3;
  }, N.prototype.valueType = function() {
    return typeOf(this.value);
  }, N.prototype._isDerived = function() {
    return 0 !== this.units.length && (this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15);
  }, N.prototype._normalize = function(e3) {
    if (null == e3 || 0 === this.units.length) return e3;
    for (var t22 = e3, r2 = N._getNumberConverter(typeOf(e3)), n3 = 0; n3 < this.units.length; n3++) {
      var i22 = r2(this.units[n3].unit.value), a2 = r2(this.units[n3].prefix.value), o2 = r2(this.units[n3].power);
      t22 = u(t22, l(u(i22, a2), o2));
    }
    return t22;
  }, N.prototype._denormalize = function(e3, t22) {
    if (null == e3 || 0 === this.units.length) return e3;
    for (var r2 = e3, n3 = N._getNumberConverter(typeOf(e3)), i22 = 0; i22 < this.units.length; i22++) {
      var a2 = n3(this.units[i22].unit.value), o2 = n3(this.units[i22].prefix.value), s2 = n3(this.units[i22].power);
      r2 = c2(r2, l(u(a2, o2), s2));
    }
    return r2;
  };
  var F = memoize$1(((e3) => {
    if (hasOwnProperty$1$1(L2, e3)) {
      var t22 = L2[e3];
      return { unit: t22, prefix: t22.prefixes[""] };
    }
    for (var r2 in L2) if (hasOwnProperty$1$1(L2, r2) && endsWith(e3, r2)) {
      var n3 = L2[r2], i22 = e3.length - r2.length, a2 = e3.substring(0, i22), o2 = hasOwnProperty$1$1(n3.prefixes, a2) ? n3.prefixes[a2] : void 0;
      if (void 0 !== o2) return { unit: n3, prefix: o2 };
    }
    return null;
  }), { hasher: (e3) => e3[0], limit: 100 });
  function O2(e3) {
    return e3.equalBase(q2.NONE) && null !== e3.value && !a.predictable ? e3.value : e3;
  }
  function k2(e3) {
    return N._getNumberConverter(typeOf(e3))(1);
  }
  function B2(e3) {
    var t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = e3.skipAutomaticSimplification || null === e3.value ? e3.clone() : e3.simplify();
    !(function(e4) {
      var t3 = false;
      void 0 !== e4.value && null !== e4.value && isComplex(e4.value) && (t3 = Math.abs(e4.value.re) < 1e-14);
      for (var r3 in e4.units) hasOwnProperty$1$1(e4.units, r3) && e4.units[r3].unit && ("VA" === e4.units[r3].unit.name && t3 ? e4.units[r3].unit = L2.VAR : "VAR" !== e4.units[r3].unit.name || t3 || (e4.units[r3].unit = L2.VA));
    })(r2), (function(e4, t3) {
      1 !== e4.units.length || e4.fixPrefix || Math.abs(e4.units[0].power - Math.round(e4.units[0].power)) < 1e-14 && (e4.units[0].prefix = e4._bestPrefix(t3));
    })(r2, t22.offset);
    var n3 = r2._denormalize(r2.value), i22 = null !== r2.value ? g(n3, t22 || {}) : "", a2 = r2.formatUnits();
    return { simp: r2, valueStr: i22, unitStr: a2 };
  }
  N.isValuelessUnit = function(e3) {
    return null !== F(e3);
  }, N.prototype.hasBase = function(e3) {
    if ("string" == typeof e3 && (e3 = q2[e3]), !e3) return false;
    for (var t22 = 0; t22 < R2.length; t22++) if (Math.abs((this.dimensions[t22] || 0) - (e3.dimensions[t22] || 0)) > 1e-12) return false;
    return true;
  }, N.prototype.equalBase = function(e3) {
    for (var t22 = 0; t22 < R2.length; t22++) if (Math.abs((this.dimensions[t22] || 0) - (e3.dimensions[t22] || 0)) > 1e-12) return false;
    return true;
  }, N.prototype.equals = function(e3) {
    return this.equalBase(e3) && d(this.value, e3.value);
  }, N.prototype.multiply = function(e3) {
    for (var t22 = this.clone(), r2 = isUnit(e3) ? e3 : new N(e3), n3 = 0; n3 < R2.length; n3++) t22.dimensions[n3] = (this.dimensions[n3] || 0) + (r2.dimensions[n3] || 0);
    for (var i22 = 0; i22 < r2.units.length; i22++) {
      var a2 = _objectSpread$2({}, r2.units[i22]);
      t22.units.push(a2);
    }
    if (null !== this.value || null !== r2.value) {
      var o2 = null === this.value ? this._normalize(k2(r2.value)) : this.value, s2 = null === r2.value ? r2._normalize(k2(this.value)) : r2.value;
      t22.value = u(o2, s2);
    } else t22.value = null;
    return isUnit(e3) && (t22.skipAutomaticSimplification = false), O2(t22);
  }, N.prototype.divideInto = function(e3) {
    return new N(e3).divide(this);
  }, N.prototype.divide = function(e3) {
    for (var t22 = this.clone(), r2 = isUnit(e3) ? e3 : new N(e3), n3 = 0; n3 < R2.length; n3++) t22.dimensions[n3] = (this.dimensions[n3] || 0) - (r2.dimensions[n3] || 0);
    for (var i22 = 0; i22 < r2.units.length; i22++) {
      var a2 = _objectSpread$2(_objectSpread$2({}, r2.units[i22]), {}, { power: -r2.units[i22].power });
      t22.units.push(a2);
    }
    if (null !== this.value || null !== r2.value) {
      var o2 = null === this.value ? this._normalize(k2(r2.value)) : this.value, s2 = null === r2.value ? r2._normalize(k2(this.value)) : r2.value;
      t22.value = c2(o2, s2);
    } else t22.value = null;
    return isUnit(e3) && (t22.skipAutomaticSimplification = false), O2(t22);
  }, N.prototype.pow = function(e3) {
    for (var t22 = this.clone(), r2 = 0; r2 < R2.length; r2++) t22.dimensions[r2] = (this.dimensions[r2] || 0) * e3;
    for (var n3 = 0; n3 < t22.units.length; n3++) t22.units[n3].power *= e3;
    return null !== t22.value ? t22.value = l(t22.value, e3) : t22.value = null, t22.skipAutomaticSimplification = false, O2(t22);
  }, N.prototype.abs = function() {
    var e3 = this.clone();
    if (null !== e3.value) if (e3._isDerived() || 0 === e3.units.length || 0 === e3.units[0].unit.offset) e3.value = f2(e3.value);
    else {
      var t22 = e3._numberConverter(), r2 = t22(e3.units[0].unit.value), n3 = t22(e3.units[0].unit.offset), i22 = u(r2, n3);
      e3.value = s(f2(o(e3.value, i22)), i22);
    }
    for (var a2 in e3.units) "VA" !== e3.units[a2].unit.name && "VAR" !== e3.units[a2].unit.name || (e3.units[a2].unit = L2.W);
    return e3;
  }, N.prototype.to = function(e3) {
    var t22, r2 = null === this.value ? this._normalize(1) : this.value;
    if ("string" == typeof e3) t22 = N.parse(e3);
    else {
      if (!isUnit(e3)) throw new Error("String or Unit expected as parameter");
      t22 = e3.clone();
    }
    if (!this.equalBase(t22)) throw new Error("Units do not match ('".concat(t22.toString(), "' != '").concat(this.toString(), "')"));
    if (null !== t22.value) throw new Error("Cannot convert to a unit with a value");
    if (null === this.value || this._isDerived() || 0 === this.units.length || 0 === t22.units.length || this.units[0].unit.offset === t22.units[0].unit.offset) t22.value = clone$3(r2);
    else {
      var n3 = N._getNumberConverter(typeOf(r2)), i22 = this.units[0].unit.value, a2 = this.units[0].unit.offset, c3 = u(i22, a2), l2 = t22.units[0].unit.value, f3 = t22.units[0].unit.offset, p2 = u(l2, f3);
      t22.value = o(r2, n3(s(c3, p2)));
    }
    return t22.fixPrefix = true, t22.skipAutomaticSimplification = true, t22;
  }, N.prototype.toNumber = function(e3) {
    return _2(this.toNumeric(e3));
  }, N.prototype.toNumeric = function(e3) {
    var t22;
    return (t22 = e3 ? this.to(e3) : this.clone())._isDerived() || 0 === t22.units.length ? t22._denormalize(t22.value) : t22._denormalize(t22.value, t22.units[0].prefix.value);
  }, N.prototype.toString = function() {
    return this.format();
  }, N.prototype.toJSON = function() {
    return { mathjs: "Unit", value: this._denormalize(this.value), unit: this.units.length > 0 ? this.formatUnits() : null, fixPrefix: this.fixPrefix, skipSimp: this.skipAutomaticSimplification };
  }, N.fromJSON = function(e3) {
    var t22, r2, n3, i22 = new N(e3.value, null !== (t22 = e3.unit) && void 0 !== t22 ? t22 : void 0);
    return i22.fixPrefix = null !== (r2 = e3.fixPrefix) && void 0 !== r2 ? r2 : w2, i22.skipAutomaticSimplification = null !== (n3 = e3.skipSimp) && void 0 !== n3 ? n3 : A2, i22;
  }, N.prototype.valueOf = N.prototype.toString, N.prototype.simplify = function() {
    var e3, t22, r2 = this.clone(), n3 = [];
    for (var i22 in G2) if (hasOwnProperty$1$1(G2, i22) && r2.hasBase(q2[i22])) {
      e3 = i22;
      break;
    }
    if ("NONE" === e3) r2.units = [];
    else if (e3 && hasOwnProperty$1$1(G2, e3) && (t22 = G2[e3]), t22) r2.units = [{ unit: t22.unit, prefix: t22.prefix, power: 1 }];
    else {
      for (var a2 = false, o2 = 0; o2 < R2.length; o2++) {
        var s2 = R2[o2];
        Math.abs(r2.dimensions[o2] || 0) > 1e-12 && (hasOwnProperty$1$1(G2, s2) ? n3.push({ unit: G2[s2].unit, prefix: G2[s2].prefix, power: r2.dimensions[o2] || 0 }) : a2 = true);
      }
      n3.length < r2.units.length && !a2 && (r2.units = n3);
    }
    return r2;
  }, N.prototype.toSI = function() {
    for (var e3 = this.clone(), t22 = [], r2 = 0; r2 < R2.length; r2++) {
      var n3 = R2[r2];
      if (Math.abs(e3.dimensions[r2] || 0) > 1e-12) {
        if (!hasOwnProperty$1$1(Z2.si, n3)) throw new Error("Cannot express custom unit " + n3 + " in SI units");
        t22.push({ unit: Z2.si[n3].unit, prefix: Z2.si[n3].prefix, power: e3.dimensions[r2] || 0 });
      }
    }
    return e3.units = t22, e3.fixPrefix = true, e3.skipAutomaticSimplification = true, null !== this.value ? (e3.value = null, this.to(e3)) : e3;
  }, N.prototype.formatUnits = function() {
    for (var e3 = "", t22 = "", r2 = 0, n3 = 0, i22 = 0; i22 < this.units.length; i22++) this.units[i22].power > 0 ? (r2++, e3 += " " + this.units[i22].prefix.name + this.units[i22].unit.name, Math.abs(this.units[i22].power - 1) > 1e-15 && (e3 += "^" + this.units[i22].power)) : this.units[i22].power < 0 && n3++;
    if (n3 > 0) for (var a2 = 0; a2 < this.units.length; a2++) this.units[a2].power < 0 && (r2 > 0 ? (t22 += " " + this.units[a2].prefix.name + this.units[a2].unit.name, Math.abs(this.units[a2].power + 1) > 1e-15 && (t22 += "^" + -this.units[a2].power)) : (t22 += " " + this.units[a2].prefix.name + this.units[a2].unit.name, t22 += "^" + this.units[a2].power));
    e3 = e3.substr(1), t22 = t22.substr(1), r2 > 1 && n3 > 0 && (e3 = "(" + e3 + ")"), n3 > 1 && r2 > 0 && (t22 = "(" + t22 + ")");
    var o2 = e3;
    return r2 > 0 && n3 > 0 && (o2 += " / "), o2 += t22;
  }, N.prototype.toBest = function() {
    var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    if (e3 && !Array.isArray(e3)) throw new Error("Invalid unit type. Expected string or Unit.");
    var r2 = this.units[0].unit.prefixes;
    if (e3 && e3.length > 0) {
      var n3 = e3.map(((e4) => {
        var t3 = null;
        if ("string" == typeof e4) {
          if (!(t3 = N.parse(e4))) throw new Error("Invalid unit type. Expected compatible string or Unit.");
        } else if (!isUnit(e4)) throw new Error("Invalid unit type. Expected compatible string or Unit.");
        null === t3 && (t3 = e4.clone());
        try {
          return this.to(t3.formatUnits()), t3;
        } catch (e5) {
          throw new Error("Invalid unit type. Expected compatible string or Unit.");
        }
      })), i22 = n3.map(((e4) => e4.units[0].prefix));
      this.units[0].unit.prefixes = i22.reduce(((e4, t3) => (e4[t3.name] = t3, e4)), {}), this.units[0].prefix = i22[0];
    }
    var a2 = B2(this, t22).simp;
    return this.units[0].unit.prefixes = r2, a2.fixPrefix = true, a2;
  }, N.prototype.format = function(e3) {
    var { simp: t22, valueStr: r2, unitStr: n3 } = B2(this, e3), i22 = r2;
    return t22.value && isComplex(t22.value) && (i22 = "(" + i22 + ")"), n3.length > 0 && i22.length > 0 && (i22 += " "), i22 += n3;
  }, N.prototype._bestPrefix = function() {
    var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1.2;
    if (1 !== this.units.length) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    var t22 = null !== this.value ? f2(this.value) : 0, r2 = f2(this.units[0].unit.value), n3 = this.units[0].prefix;
    if (0 === t22) return n3;
    var i22 = this.units[0].power, a2 = Math.log(t22 / Math.pow(n3.value * r2, i22)) / Math.LN10 - e3;
    if (a2 > -2.200001 && a2 < 1.800001) return n3;
    a2 = Math.abs(a2);
    var o2 = this.units[0].unit.prefixes;
    for (var s2 in o2) if (hasOwnProperty$1$1(o2, s2)) {
      var u2 = o2[s2];
      if (u2.scientific) {
        var c3 = Math.abs(Math.log(t22 / Math.pow(u2.value * r2, i22)) / Math.LN10 - e3);
        (c3 < a2 || c3 === a2 && u2.name.length < n3.name.length) && (n3 = u2, a2 = c3);
      }
    }
    return n3;
  }, N.prototype.splitUnit = function(e3) {
    for (var t22 = this.clone(), r2 = [], n3 = 0; n3 < e3.length && (t22 = t22.to(e3[n3]), n3 !== e3.length - 1); n3++) {
      var i22 = t22.toNumeric(), a2 = m(i22), u2 = new N(d(a2, i22) ? a2 : p(t22.toNumeric()), e3[n3].toString());
      r2.push(u2), t22 = s(t22, u2);
    }
    for (var c3 = 0, l2 = 0; l2 < r2.length; l2++) c3 = o(c3, r2[l2].value);
    return d(c3, this.value) && (t22.value = 0), r2.push(t22), r2;
  };
  var I2 = { NONE: { "": { name: "", value: 1, scientific: true } }, SHORT: { "": { name: "", value: 1, scientific: true }, da: { name: "da", value: 10, scientific: false }, h: { name: "h", value: 100, scientific: false }, k: { name: "k", value: 1e3, scientific: true }, M: { name: "M", value: 1e6, scientific: true }, G: { name: "G", value: 1e9, scientific: true }, T: { name: "T", value: 1e12, scientific: true }, P: { name: "P", value: 1e15, scientific: true }, E: { name: "E", value: 1e18, scientific: true }, Z: { name: "Z", value: 1e21, scientific: true }, Y: { name: "Y", value: 1e24, scientific: true }, R: { name: "R", value: 1e27, scientific: true }, Q: { name: "Q", value: 1e30, scientific: true }, d: { name: "d", value: 0.1, scientific: false }, c: { name: "c", value: 0.01, scientific: false }, m: { name: "m", value: 1e-3, scientific: true }, u: { name: "u", value: 1e-6, scientific: true }, n: { name: "n", value: 1e-9, scientific: true }, p: { name: "p", value: 1e-12, scientific: true }, f: { name: "f", value: 1e-15, scientific: true }, a: { name: "a", value: 1e-18, scientific: true }, z: { name: "z", value: 1e-21, scientific: true }, y: { name: "y", value: 1e-24, scientific: true }, r: { name: "r", value: 1e-27, scientific: true }, q: { name: "q", value: 1e-30, scientific: true } }, LONG: { "": { name: "", value: 1, scientific: true }, deca: { name: "deca", value: 10, scientific: false }, hecto: { name: "hecto", value: 100, scientific: false }, kilo: { name: "kilo", value: 1e3, scientific: true }, mega: { name: "mega", value: 1e6, scientific: true }, giga: { name: "giga", value: 1e9, scientific: true }, tera: { name: "tera", value: 1e12, scientific: true }, peta: { name: "peta", value: 1e15, scientific: true }, exa: { name: "exa", value: 1e18, scientific: true }, zetta: { name: "zetta", value: 1e21, scientific: true }, yotta: { name: "yotta", value: 1e24, scientific: true }, ronna: { name: "ronna", value: 1e27, scientific: true }, quetta: { name: "quetta", value: 1e30, scientific: true }, deci: { name: "deci", value: 0.1, scientific: false }, centi: { name: "centi", value: 0.01, scientific: false }, milli: { name: "milli", value: 1e-3, scientific: true }, micro: { name: "micro", value: 1e-6, scientific: true }, nano: { name: "nano", value: 1e-9, scientific: true }, pico: { name: "pico", value: 1e-12, scientific: true }, femto: { name: "femto", value: 1e-15, scientific: true }, atto: { name: "atto", value: 1e-18, scientific: true }, zepto: { name: "zepto", value: 1e-21, scientific: true }, yocto: { name: "yocto", value: 1e-24, scientific: true }, ronto: { name: "ronto", value: 1e-27, scientific: true }, quecto: { name: "quecto", value: 1e-30, scientific: true } }, SQUARED: { "": { name: "", value: 1, scientific: true }, da: { name: "da", value: 100, scientific: false }, h: { name: "h", value: 1e4, scientific: false }, k: { name: "k", value: 1e6, scientific: true }, M: { name: "M", value: 1e12, scientific: true }, G: { name: "G", value: 1e18, scientific: true }, T: { name: "T", value: 1e24, scientific: true }, P: { name: "P", value: 1e30, scientific: true }, E: { name: "E", value: 1e36, scientific: true }, Z: { name: "Z", value: 1e42, scientific: true }, Y: { name: "Y", value: 1e48, scientific: true }, R: { name: "R", value: 1e54, scientific: true }, Q: { name: "Q", value: 1e60, scientific: true }, d: { name: "d", value: 0.01, scientific: false }, c: { name: "c", value: 1e-4, scientific: false }, m: { name: "m", value: 1e-6, scientific: true }, u: { name: "u", value: 1e-12, scientific: true }, n: { name: "n", value: 1e-18, scientific: true }, p: { name: "p", value: 1e-24, scientific: true }, f: { name: "f", value: 1e-30, scientific: true }, a: { name: "a", value: 1e-36, scientific: true }, z: { name: "z", value: 1e-42, scientific: true }, y: { name: "y", value: 1e-48, scientific: true }, r: { name: "r", value: 1e-54, scientific: true }, q: { name: "q", value: 1e-60, scientific: true } }, CUBIC: { "": { name: "", value: 1, scientific: true }, da: { name: "da", value: 1e3, scientific: false }, h: { name: "h", value: 1e6, scientific: false }, k: { name: "k", value: 1e9, scientific: true }, M: { name: "M", value: 1e18, scientific: true }, G: { name: "G", value: 1e27, scientific: true }, T: { name: "T", value: 1e36, scientific: true }, P: { name: "P", value: 1e45, scientific: true }, E: { name: "E", value: 1e54, scientific: true }, Z: { name: "Z", value: 1e63, scientific: true }, Y: { name: "Y", value: 1e72, scientific: true }, R: { name: "R", value: 1e81, scientific: true }, Q: { name: "Q", value: 1e90, scientific: true }, d: { name: "d", value: 1e-3, scientific: false }, c: { name: "c", value: 1e-6, scientific: false }, m: { name: "m", value: 1e-9, scientific: true }, u: { name: "u", value: 1e-18, scientific: true }, n: { name: "n", value: 1e-27, scientific: true }, p: { name: "p", value: 1e-36, scientific: true }, f: { name: "f", value: 1e-45, scientific: true }, a: { name: "a", value: 1e-54, scientific: true }, z: { name: "z", value: 1e-63, scientific: true }, y: { name: "y", value: 1e-72, scientific: true }, r: { name: "r", value: 1e-81, scientific: true }, q: { name: "q", value: 1e-90, scientific: true } }, BINARY_SHORT_SI: { "": { name: "", value: 1, scientific: true }, k: { name: "k", value: 1e3, scientific: true }, M: { name: "M", value: 1e6, scientific: true }, G: { name: "G", value: 1e9, scientific: true }, T: { name: "T", value: 1e12, scientific: true }, P: { name: "P", value: 1e15, scientific: true }, E: { name: "E", value: 1e18, scientific: true }, Z: { name: "Z", value: 1e21, scientific: true }, Y: { name: "Y", value: 1e24, scientific: true } }, BINARY_SHORT_IEC: { "": { name: "", value: 1, scientific: true }, Ki: { name: "Ki", value: 1024, scientific: true }, Mi: { name: "Mi", value: Math.pow(1024, 2), scientific: true }, Gi: { name: "Gi", value: Math.pow(1024, 3), scientific: true }, Ti: { name: "Ti", value: Math.pow(1024, 4), scientific: true }, Pi: { name: "Pi", value: Math.pow(1024, 5), scientific: true }, Ei: { name: "Ei", value: Math.pow(1024, 6), scientific: true }, Zi: { name: "Zi", value: Math.pow(1024, 7), scientific: true }, Yi: { name: "Yi", value: Math.pow(1024, 8), scientific: true } }, BINARY_LONG_SI: { "": { name: "", value: 1, scientific: true }, kilo: { name: "kilo", value: 1e3, scientific: true }, mega: { name: "mega", value: 1e6, scientific: true }, giga: { name: "giga", value: 1e9, scientific: true }, tera: { name: "tera", value: 1e12, scientific: true }, peta: { name: "peta", value: 1e15, scientific: true }, exa: { name: "exa", value: 1e18, scientific: true }, zetta: { name: "zetta", value: 1e21, scientific: true }, yotta: { name: "yotta", value: 1e24, scientific: true } }, BINARY_LONG_IEC: { "": { name: "", value: 1, scientific: true }, kibi: { name: "kibi", value: 1024, scientific: true }, mebi: { name: "mebi", value: Math.pow(1024, 2), scientific: true }, gibi: { name: "gibi", value: Math.pow(1024, 3), scientific: true }, tebi: { name: "tebi", value: Math.pow(1024, 4), scientific: true }, pebi: { name: "pebi", value: Math.pow(1024, 5), scientific: true }, exi: { name: "exi", value: Math.pow(1024, 6), scientific: true }, zebi: { name: "zebi", value: Math.pow(1024, 7), scientific: true }, yobi: { name: "yobi", value: Math.pow(1024, 8), scientific: true } }, BTU: { "": { name: "", value: 1, scientific: true }, MM: { name: "MM", value: 1e6, scientific: true } } };
  I2.SHORTLONG = _extends$2({}, I2.SHORT, I2.LONG), I2.BINARY_SHORT = _extends$2({}, I2.BINARY_SHORT_SI, I2.BINARY_SHORT_IEC), I2.BINARY_LONG = _extends$2({}, I2.BINARY_LONG_SI, I2.BINARY_LONG_IEC);
  var R2 = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"], q2 = { NONE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0] }, MASS: { dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0] }, LENGTH: { dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0] }, TIME: { dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0] }, CURRENT: { dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0] }, TEMPERATURE: { dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0] }, LUMINOUS_INTENSITY: { dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0] }, AMOUNT_OF_SUBSTANCE: { dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0] }, FORCE: { dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0] }, SURFACE: { dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0] }, VOLUME: { dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0] }, ENERGY: { dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0] }, POWER: { dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0] }, PRESSURE: { dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0] }, ELECTRIC_CHARGE: { dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0] }, ELECTRIC_CAPACITANCE: { dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0] }, ELECTRIC_POTENTIAL: { dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0] }, ELECTRIC_RESISTANCE: { dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0] }, ELECTRIC_INDUCTANCE: { dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0] }, ELECTRIC_CONDUCTANCE: { dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX: { dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX_DENSITY: { dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0] }, FREQUENCY: { dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0] }, ANGLE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0] }, BIT: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1] } };
  for (var z2 in q2) hasOwnProperty$1$1(q2, z2) && (q2[z2].key = z2);
  var P2 = { name: "", base: {}, value: 1, offset: 0, dimensions: R2.map(((e3) => 0)) }, L2 = { meter: { name: "meter", base: q2.LENGTH, prefixes: I2.LONG, value: 1, offset: 0 }, inch: { name: "inch", base: q2.LENGTH, prefixes: I2.NONE, value: 0.0254, offset: 0 }, foot: { name: "foot", base: q2.LENGTH, prefixes: I2.NONE, value: 0.3048, offset: 0 }, yard: { name: "yard", base: q2.LENGTH, prefixes: I2.NONE, value: 0.9144, offset: 0 }, mile: { name: "mile", base: q2.LENGTH, prefixes: I2.NONE, value: 1609.344, offset: 0 }, link: { name: "link", base: q2.LENGTH, prefixes: I2.NONE, value: 0.201168, offset: 0 }, rod: { name: "rod", base: q2.LENGTH, prefixes: I2.NONE, value: 5.0292, offset: 0 }, chain: { name: "chain", base: q2.LENGTH, prefixes: I2.NONE, value: 20.1168, offset: 0 }, angstrom: { name: "angstrom", base: q2.LENGTH, prefixes: I2.NONE, value: 1e-10, offset: 0 }, m: { name: "m", base: q2.LENGTH, prefixes: I2.SHORT, value: 1, offset: 0 }, in: { name: "in", base: q2.LENGTH, prefixes: I2.NONE, value: 0.0254, offset: 0 }, ft: { name: "ft", base: q2.LENGTH, prefixes: I2.NONE, value: 0.3048, offset: 0 }, yd: { name: "yd", base: q2.LENGTH, prefixes: I2.NONE, value: 0.9144, offset: 0 }, mi: { name: "mi", base: q2.LENGTH, prefixes: I2.NONE, value: 1609.344, offset: 0 }, li: { name: "li", base: q2.LENGTH, prefixes: I2.NONE, value: 0.201168, offset: 0 }, rd: { name: "rd", base: q2.LENGTH, prefixes: I2.NONE, value: 5.02921, offset: 0 }, ch: { name: "ch", base: q2.LENGTH, prefixes: I2.NONE, value: 20.1168, offset: 0 }, mil: { name: "mil", base: q2.LENGTH, prefixes: I2.NONE, value: 254e-7, offset: 0 }, m2: { name: "m2", base: q2.SURFACE, prefixes: I2.SQUARED, value: 1, offset: 0 }, sqin: { name: "sqin", base: q2.SURFACE, prefixes: I2.NONE, value: 64516e-8, offset: 0 }, sqft: { name: "sqft", base: q2.SURFACE, prefixes: I2.NONE, value: 0.09290304, offset: 0 }, sqyd: { name: "sqyd", base: q2.SURFACE, prefixes: I2.NONE, value: 0.83612736, offset: 0 }, sqmi: { name: "sqmi", base: q2.SURFACE, prefixes: I2.NONE, value: 2589988110336e-6, offset: 0 }, sqrd: { name: "sqrd", base: q2.SURFACE, prefixes: I2.NONE, value: 25.29295, offset: 0 }, sqch: { name: "sqch", base: q2.SURFACE, prefixes: I2.NONE, value: 404.6873, offset: 0 }, sqmil: { name: "sqmil", base: q2.SURFACE, prefixes: I2.NONE, value: 64516e-14, offset: 0 }, acre: { name: "acre", base: q2.SURFACE, prefixes: I2.NONE, value: 4046.86, offset: 0 }, hectare: { name: "hectare", base: q2.SURFACE, prefixes: I2.NONE, value: 1e4, offset: 0 }, m3: { name: "m3", base: q2.VOLUME, prefixes: I2.CUBIC, value: 1, offset: 0 }, L: { name: "L", base: q2.VOLUME, prefixes: I2.SHORT, value: 1e-3, offset: 0 }, l: { name: "l", base: q2.VOLUME, prefixes: I2.SHORT, value: 1e-3, offset: 0 }, litre: { name: "litre", base: q2.VOLUME, prefixes: I2.LONG, value: 1e-3, offset: 0 }, cuin: { name: "cuin", base: q2.VOLUME, prefixes: I2.NONE, value: 16387064e-12, offset: 0 }, cuft: { name: "cuft", base: q2.VOLUME, prefixes: I2.NONE, value: 0.028316846592, offset: 0 }, cuyd: { name: "cuyd", base: q2.VOLUME, prefixes: I2.NONE, value: 0.764554857984, offset: 0 }, teaspoon: { name: "teaspoon", base: q2.VOLUME, prefixes: I2.NONE, value: 5e-6, offset: 0 }, tablespoon: { name: "tablespoon", base: q2.VOLUME, prefixes: I2.NONE, value: 15e-6, offset: 0 }, drop: { name: "drop", base: q2.VOLUME, prefixes: I2.NONE, value: 5e-8, offset: 0 }, gtt: { name: "gtt", base: q2.VOLUME, prefixes: I2.NONE, value: 5e-8, offset: 0 }, minim: { name: "minim", base: q2.VOLUME, prefixes: I2.NONE, value: 61611519921875e-21, offset: 0 }, fluiddram: { name: "fluiddram", base: q2.VOLUME, prefixes: I2.NONE, value: 36966911953125e-19, offset: 0 }, fluidounce: { name: "fluidounce", base: q2.VOLUME, prefixes: I2.NONE, value: 295735295625e-16, offset: 0 }, gill: { name: "gill", base: q2.VOLUME, prefixes: I2.NONE, value: 11829411825e-14, offset: 0 }, cc: { name: "cc", base: q2.VOLUME, prefixes: I2.NONE, value: 1e-6, offset: 0 }, cup: { name: "cup", base: q2.VOLUME, prefixes: I2.NONE, value: 2365882365e-13, offset: 0 }, pint: { name: "pint", base: q2.VOLUME, prefixes: I2.NONE, value: 473176473e-12, offset: 0 }, quart: { name: "quart", base: q2.VOLUME, prefixes: I2.NONE, value: 946352946e-12, offset: 0 }, gallon: { name: "gallon", base: q2.VOLUME, prefixes: I2.NONE, value: 0.003785411784, offset: 0 }, beerbarrel: { name: "beerbarrel", base: q2.VOLUME, prefixes: I2.NONE, value: 0.117347765304, offset: 0 }, oilbarrel: { name: "oilbarrel", base: q2.VOLUME, prefixes: I2.NONE, value: 0.158987294928, offset: 0 }, hogshead: { name: "hogshead", base: q2.VOLUME, prefixes: I2.NONE, value: 0.238480942392, offset: 0 }, g: { name: "g", base: q2.MASS, prefixes: I2.SHORT, value: 1e-3, offset: 0 }, gram: { name: "gram", base: q2.MASS, prefixes: I2.LONG, value: 1e-3, offset: 0 }, ton: { name: "ton", base: q2.MASS, prefixes: I2.SHORT, value: 907.18474, offset: 0 }, t: { name: "t", base: q2.MASS, prefixes: I2.SHORT, value: 1e3, offset: 0 }, tonne: { name: "tonne", base: q2.MASS, prefixes: I2.LONG, value: 1e3, offset: 0 }, grain: { name: "grain", base: q2.MASS, prefixes: I2.NONE, value: 6479891e-11, offset: 0 }, dram: { name: "dram", base: q2.MASS, prefixes: I2.NONE, value: 0.0017718451953125, offset: 0 }, ounce: { name: "ounce", base: q2.MASS, prefixes: I2.NONE, value: 0.028349523125, offset: 0 }, poundmass: { name: "poundmass", base: q2.MASS, prefixes: I2.NONE, value: 0.45359237, offset: 0 }, hundredweight: { name: "hundredweight", base: q2.MASS, prefixes: I2.NONE, value: 45.359237, offset: 0 }, stick: { name: "stick", base: q2.MASS, prefixes: I2.NONE, value: 0.115, offset: 0 }, stone: { name: "stone", base: q2.MASS, prefixes: I2.NONE, value: 6.35029318, offset: 0 }, gr: { name: "gr", base: q2.MASS, prefixes: I2.NONE, value: 6479891e-11, offset: 0 }, dr: { name: "dr", base: q2.MASS, prefixes: I2.NONE, value: 0.0017718451953125, offset: 0 }, oz: { name: "oz", base: q2.MASS, prefixes: I2.NONE, value: 0.028349523125, offset: 0 }, lbm: { name: "lbm", base: q2.MASS, prefixes: I2.NONE, value: 0.45359237, offset: 0 }, cwt: { name: "cwt", base: q2.MASS, prefixes: I2.NONE, value: 45.359237, offset: 0 }, s: { name: "s", base: q2.TIME, prefixes: I2.SHORT, value: 1, offset: 0 }, min: { name: "min", base: q2.TIME, prefixes: I2.NONE, value: 60, offset: 0 }, h: { name: "h", base: q2.TIME, prefixes: I2.NONE, value: 3600, offset: 0 }, second: { name: "second", base: q2.TIME, prefixes: I2.LONG, value: 1, offset: 0 }, sec: { name: "sec", base: q2.TIME, prefixes: I2.LONG, value: 1, offset: 0 }, minute: { name: "minute", base: q2.TIME, prefixes: I2.NONE, value: 60, offset: 0 }, hour: { name: "hour", base: q2.TIME, prefixes: I2.NONE, value: 3600, offset: 0 }, day: { name: "day", base: q2.TIME, prefixes: I2.NONE, value: 86400, offset: 0 }, week: { name: "week", base: q2.TIME, prefixes: I2.NONE, value: 604800, offset: 0 }, month: { name: "month", base: q2.TIME, prefixes: I2.NONE, value: 2629800, offset: 0 }, year: { name: "year", base: q2.TIME, prefixes: I2.NONE, value: 31557600, offset: 0 }, decade: { name: "decade", base: q2.TIME, prefixes: I2.NONE, value: 315576e3, offset: 0 }, century: { name: "century", base: q2.TIME, prefixes: I2.NONE, value: 315576e4, offset: 0 }, millennium: { name: "millennium", base: q2.TIME, prefixes: I2.NONE, value: 315576e5, offset: 0 }, hertz: { name: "Hertz", base: q2.FREQUENCY, prefixes: I2.LONG, value: 1, offset: 0, reciprocal: true }, Hz: { name: "Hz", base: q2.FREQUENCY, prefixes: I2.SHORT, value: 1, offset: 0, reciprocal: true }, rad: { name: "rad", base: q2.ANGLE, prefixes: I2.SHORT, value: 1, offset: 0 }, radian: { name: "radian", base: q2.ANGLE, prefixes: I2.LONG, value: 1, offset: 0 }, deg: { name: "deg", base: q2.ANGLE, prefixes: I2.SHORT, value: null, offset: 0 }, degree: { name: "degree", base: q2.ANGLE, prefixes: I2.LONG, value: null, offset: 0 }, grad: { name: "grad", base: q2.ANGLE, prefixes: I2.SHORT, value: null, offset: 0 }, gradian: { name: "gradian", base: q2.ANGLE, prefixes: I2.LONG, value: null, offset: 0 }, cycle: { name: "cycle", base: q2.ANGLE, prefixes: I2.NONE, value: null, offset: 0 }, arcsec: { name: "arcsec", base: q2.ANGLE, prefixes: I2.NONE, value: null, offset: 0 }, arcmin: { name: "arcmin", base: q2.ANGLE, prefixes: I2.NONE, value: null, offset: 0 }, A: { name: "A", base: q2.CURRENT, prefixes: I2.SHORT, value: 1, offset: 0 }, ampere: { name: "ampere", base: q2.CURRENT, prefixes: I2.LONG, value: 1, offset: 0 }, K: { name: "K", base: q2.TEMPERATURE, prefixes: I2.SHORT, value: 1, offset: 0 }, degC: { name: "degC", base: q2.TEMPERATURE, prefixes: I2.SHORT, value: 1, offset: 273.15 }, degF: { name: "degF", base: q2.TEMPERATURE, prefixes: I2.SHORT, value: new b2(5, 9), offset: 459.67 }, degR: { name: "degR", base: q2.TEMPERATURE, prefixes: I2.SHORT, value: new b2(5, 9), offset: 0 }, kelvin: { name: "kelvin", base: q2.TEMPERATURE, prefixes: I2.LONG, value: 1, offset: 0 }, celsius: { name: "celsius", base: q2.TEMPERATURE, prefixes: I2.LONG, value: 1, offset: 273.15 }, fahrenheit: { name: "fahrenheit", base: q2.TEMPERATURE, prefixes: I2.LONG, value: new b2(5, 9), offset: 459.67 }, rankine: { name: "rankine", base: q2.TEMPERATURE, prefixes: I2.LONG, value: new b2(5, 9), offset: 0 }, mol: { name: "mol", base: q2.AMOUNT_OF_SUBSTANCE, prefixes: I2.SHORT, value: 1, offset: 0 }, mole: { name: "mole", base: q2.AMOUNT_OF_SUBSTANCE, prefixes: I2.LONG, value: 1, offset: 0 }, cd: { name: "cd", base: q2.LUMINOUS_INTENSITY, prefixes: I2.SHORT, value: 1, offset: 0 }, candela: { name: "candela", base: q2.LUMINOUS_INTENSITY, prefixes: I2.LONG, value: 1, offset: 0 }, N: { name: "N", base: q2.FORCE, prefixes: I2.SHORT, value: 1, offset: 0 }, newton: { name: "newton", base: q2.FORCE, prefixes: I2.LONG, value: 1, offset: 0 }, dyn: { name: "dyn", base: q2.FORCE, prefixes: I2.SHORT, value: 1e-5, offset: 0 }, dyne: { name: "dyne", base: q2.FORCE, prefixes: I2.LONG, value: 1e-5, offset: 0 }, lbf: { name: "lbf", base: q2.FORCE, prefixes: I2.NONE, value: 4.4482216152605, offset: 0 }, poundforce: { name: "poundforce", base: q2.FORCE, prefixes: I2.NONE, value: 4.4482216152605, offset: 0 }, kip: { name: "kip", base: q2.FORCE, prefixes: I2.LONG, value: 4448.2216, offset: 0 }, kilogramforce: { name: "kilogramforce", base: q2.FORCE, prefixes: I2.NONE, value: 9.80665, offset: 0 }, J: { name: "J", base: q2.ENERGY, prefixes: I2.SHORT, value: 1, offset: 0 }, joule: { name: "joule", base: q2.ENERGY, prefixes: I2.LONG, value: 1, offset: 0 }, erg: { name: "erg", base: q2.ENERGY, prefixes: I2.SHORTLONG, value: 1e-7, offset: 0 }, Wh: { name: "Wh", base: q2.ENERGY, prefixes: I2.SHORT, value: 3600, offset: 0 }, BTU: { name: "BTU", base: q2.ENERGY, prefixes: I2.BTU, value: 1055.05585262, offset: 0 }, eV: { name: "eV", base: q2.ENERGY, prefixes: I2.SHORT, value: 1602176565e-28, offset: 0 }, electronvolt: { name: "electronvolt", base: q2.ENERGY, prefixes: I2.LONG, value: 1602176565e-28, offset: 0 }, W: { name: "W", base: q2.POWER, prefixes: I2.SHORT, value: 1, offset: 0 }, watt: { name: "watt", base: q2.POWER, prefixes: I2.LONG, value: 1, offset: 0 }, hp: { name: "hp", base: q2.POWER, prefixes: I2.NONE, value: 745.6998715386, offset: 0 }, VAR: { name: "VAR", base: q2.POWER, prefixes: I2.SHORT, value: v2.I, offset: 0 }, VA: { name: "VA", base: q2.POWER, prefixes: I2.SHORT, value: 1, offset: 0 }, Pa: { name: "Pa", base: q2.PRESSURE, prefixes: I2.SHORT, value: 1, offset: 0 }, psi: { name: "psi", base: q2.PRESSURE, prefixes: I2.NONE, value: 6894.75729276459, offset: 0 }, atm: { name: "atm", base: q2.PRESSURE, prefixes: I2.NONE, value: 101325, offset: 0 }, bar: { name: "bar", base: q2.PRESSURE, prefixes: I2.SHORTLONG, value: 1e5, offset: 0 }, torr: { name: "torr", base: q2.PRESSURE, prefixes: I2.NONE, value: 133.322, offset: 0 }, mmHg: { name: "mmHg", base: q2.PRESSURE, prefixes: I2.NONE, value: 133.322, offset: 0 }, mmH2O: { name: "mmH2O", base: q2.PRESSURE, prefixes: I2.NONE, value: 9.80665, offset: 0 }, cmH2O: { name: "cmH2O", base: q2.PRESSURE, prefixes: I2.NONE, value: 98.0665, offset: 0 }, coulomb: { name: "coulomb", base: q2.ELECTRIC_CHARGE, prefixes: I2.LONG, value: 1, offset: 0 }, C: { name: "C", base: q2.ELECTRIC_CHARGE, prefixes: I2.SHORT, value: 1, offset: 0 }, farad: { name: "farad", base: q2.ELECTRIC_CAPACITANCE, prefixes: I2.LONG, value: 1, offset: 0 }, F: { name: "F", base: q2.ELECTRIC_CAPACITANCE, prefixes: I2.SHORT, value: 1, offset: 0 }, volt: { name: "volt", base: q2.ELECTRIC_POTENTIAL, prefixes: I2.LONG, value: 1, offset: 0 }, V: { name: "V", base: q2.ELECTRIC_POTENTIAL, prefixes: I2.SHORT, value: 1, offset: 0 }, ohm: { name: "ohm", base: q2.ELECTRIC_RESISTANCE, prefixes: I2.SHORTLONG, value: 1, offset: 0 }, henry: { name: "henry", base: q2.ELECTRIC_INDUCTANCE, prefixes: I2.LONG, value: 1, offset: 0 }, H: { name: "H", base: q2.ELECTRIC_INDUCTANCE, prefixes: I2.SHORT, value: 1, offset: 0 }, siemens: { name: "siemens", base: q2.ELECTRIC_CONDUCTANCE, prefixes: I2.LONG, value: 1, offset: 0 }, S: { name: "S", base: q2.ELECTRIC_CONDUCTANCE, prefixes: I2.SHORT, value: 1, offset: 0 }, weber: { name: "weber", base: q2.MAGNETIC_FLUX, prefixes: I2.LONG, value: 1, offset: 0 }, Wb: { name: "Wb", base: q2.MAGNETIC_FLUX, prefixes: I2.SHORT, value: 1, offset: 0 }, tesla: { name: "tesla", base: q2.MAGNETIC_FLUX_DENSITY, prefixes: I2.LONG, value: 1, offset: 0 }, T: { name: "T", base: q2.MAGNETIC_FLUX_DENSITY, prefixes: I2.SHORT, value: 1, offset: 0 }, b: { name: "b", base: q2.BIT, prefixes: I2.BINARY_SHORT, value: 1, offset: 0 }, bits: { name: "bits", base: q2.BIT, prefixes: I2.BINARY_LONG, value: 1, offset: 0 }, B: { name: "B", base: q2.BIT, prefixes: I2.BINARY_SHORT, value: 8, offset: 0 }, bytes: { name: "bytes", base: q2.BIT, prefixes: I2.BINARY_LONG, value: 8, offset: 0 } }, j2 = { meters: "meter", inches: "inch", feet: "foot", yards: "yard", miles: "mile", links: "link", rods: "rod", chains: "chain", angstroms: "angstrom", lt: "l", litres: "litre", liter: "litre", liters: "litre", teaspoons: "teaspoon", tablespoons: "tablespoon", minims: "minim", fldr: "fluiddram", fluiddrams: "fluiddram", floz: "fluidounce", fluidounces: "fluidounce", gi: "gill", gills: "gill", cp: "cup", cups: "cup", pt: "pint", pints: "pint", qt: "quart", quarts: "quart", gal: "gallon", gallons: "gallon", bbl: "beerbarrel", beerbarrels: "beerbarrel", obl: "oilbarrel", oilbarrels: "oilbarrel", hogsheads: "hogshead", gtts: "gtt", grams: "gram", tons: "ton", tonnes: "tonne", grains: "grain", drams: "dram", ounces: "ounce", poundmasses: "poundmass", hundredweights: "hundredweight", sticks: "stick", lb: "lbm", lbs: "lbm", kips: "kip", kgf: "kilogramforce", acres: "acre", hectares: "hectare", sqfeet: "sqft", sqyard: "sqyd", sqmile: "sqmi", sqmiles: "sqmi", mmhg: "mmHg", mmh2o: "mmH2O", cmh2o: "cmH2O", seconds: "second", secs: "second", minutes: "minute", mins: "minute", hours: "hour", hr: "hour", hrs: "hour", days: "day", weeks: "week", months: "month", years: "year", decades: "decade", centuries: "century", millennia: "millennium", hertz: "hertz", radians: "radian", degrees: "degree", gradians: "gradian", cycles: "cycle", arcsecond: "arcsec", arcseconds: "arcsec", arcminute: "arcmin", arcminutes: "arcmin", BTUs: "BTU", watts: "watt", joules: "joule", amperes: "ampere", amps: "ampere", amp: "ampere", coulombs: "coulomb", volts: "volt", ohms: "ohm", farads: "farad", webers: "weber", teslas: "tesla", electronvolts: "electronvolt", moles: "mole", bit: "bits", byte: "bytes" };
  function U2(e3) {
    if ("BigNumber" === e3.number) {
      var t22 = createBigNumberPi(x2);
      L2.rad.value = new x2(1), L2.deg.value = t22.div(180), L2.grad.value = t22.div(200), L2.cycle.value = t22.times(2), L2.arcsec.value = t22.div(648e3), L2.arcmin.value = t22.div(10800);
    } else L2.rad.value = 1, L2.deg.value = Math.PI / 180, L2.grad.value = Math.PI / 200, L2.cycle.value = 2 * Math.PI, L2.arcsec.value = Math.PI / 648e3, L2.arcmin.value = Math.PI / 10800;
    L2.radian.value = L2.rad.value, L2.degree.value = L2.deg.value, L2.gradian.value = L2.grad.value;
  }
  U2(a), i2 && i2("config", (function(e3, t22) {
    e3.number !== t22.number && U2(e3);
  }));
  var Z2 = { si: { NONE: { unit: P2, prefix: I2.NONE[""] }, LENGTH: { unit: L2.m, prefix: I2.SHORT[""] }, MASS: { unit: L2.g, prefix: I2.SHORT.k }, TIME: { unit: L2.s, prefix: I2.SHORT[""] }, CURRENT: { unit: L2.A, prefix: I2.SHORT[""] }, TEMPERATURE: { unit: L2.K, prefix: I2.SHORT[""] }, LUMINOUS_INTENSITY: { unit: L2.cd, prefix: I2.SHORT[""] }, AMOUNT_OF_SUBSTANCE: { unit: L2.mol, prefix: I2.SHORT[""] }, ANGLE: { unit: L2.rad, prefix: I2.SHORT[""] }, BIT: { unit: L2.bits, prefix: I2.SHORT[""] }, FORCE: { unit: L2.N, prefix: I2.SHORT[""] }, ENERGY: { unit: L2.J, prefix: I2.SHORT[""] }, POWER: { unit: L2.W, prefix: I2.SHORT[""] }, PRESSURE: { unit: L2.Pa, prefix: I2.SHORT[""] }, ELECTRIC_CHARGE: { unit: L2.C, prefix: I2.SHORT[""] }, ELECTRIC_CAPACITANCE: { unit: L2.F, prefix: I2.SHORT[""] }, ELECTRIC_POTENTIAL: { unit: L2.V, prefix: I2.SHORT[""] }, ELECTRIC_RESISTANCE: { unit: L2.ohm, prefix: I2.SHORT[""] }, ELECTRIC_INDUCTANCE: { unit: L2.H, prefix: I2.SHORT[""] }, ELECTRIC_CONDUCTANCE: { unit: L2.S, prefix: I2.SHORT[""] }, MAGNETIC_FLUX: { unit: L2.Wb, prefix: I2.SHORT[""] }, MAGNETIC_FLUX_DENSITY: { unit: L2.T, prefix: I2.SHORT[""] }, FREQUENCY: { unit: L2.Hz, prefix: I2.SHORT[""] } } };
  Z2.cgs = JSON.parse(JSON.stringify(Z2.si)), Z2.cgs.LENGTH = { unit: L2.m, prefix: I2.SHORT.c }, Z2.cgs.MASS = { unit: L2.g, prefix: I2.SHORT[""] }, Z2.cgs.FORCE = { unit: L2.dyn, prefix: I2.SHORT[""] }, Z2.cgs.ENERGY = { unit: L2.erg, prefix: I2.NONE[""] }, Z2.us = JSON.parse(JSON.stringify(Z2.si)), Z2.us.LENGTH = { unit: L2.ft, prefix: I2.NONE[""] }, Z2.us.MASS = { unit: L2.lbm, prefix: I2.NONE[""] }, Z2.us.TEMPERATURE = { unit: L2.degF, prefix: I2.NONE[""] }, Z2.us.FORCE = { unit: L2.lbf, prefix: I2.NONE[""] }, Z2.us.ENERGY = { unit: L2.BTU, prefix: I2.BTU[""] }, Z2.us.POWER = { unit: L2.hp, prefix: I2.NONE[""] }, Z2.us.PRESSURE = { unit: L2.psi, prefix: I2.NONE[""] }, Z2.auto = JSON.parse(JSON.stringify(Z2.si));
  var G2 = Z2.auto;
  for (var V2 in N.setUnitSystem = function(e3) {
    if (!hasOwnProperty$1$1(Z2, e3)) throw new Error("Unit system " + e3 + " does not exist. Choices are: " + Object.keys(Z2).join(", "));
    G2 = Z2[e3];
  }, N.getUnitSystem = function() {
    for (var e3 in Z2) if (hasOwnProperty$1$1(Z2, e3) && Z2[e3] === G2) return e3;
  }, N.typeConverters = { BigNumber: function(e3) {
    return null != e3 && e3.isFraction ? new x2(String(e3.n)).div(String(e3.d)).times(String(e3.s)) : new x2(e3 + "");
  }, Fraction: function(e3) {
    return new b2(e3);
  }, Complex: function(e3) {
    return e3;
  }, number: function(e3) {
    return null != e3 && e3.isFraction ? y(e3) : e3;
  } }, N.prototype._numberConverter = function() {
    var e3 = N.typeConverters[this.valueType()];
    if (e3) return e3;
    throw new TypeError('Unsupported Unit value type "' + this.valueType() + '"');
  }, N._getNumberConverter = function(e3) {
    if (!N.typeConverters[e3]) throw new TypeError('Unsupported type "' + e3 + '"');
    return N.typeConverters[e3];
  }, L2) if (hasOwnProperty$1$1(L2, V2)) {
    var H2 = L2[V2];
    H2.dimensions = H2.base.dimensions;
  }
  for (var X2 in j2) if (hasOwnProperty$1$1(j2, X2)) {
    var W2 = L2[j2[X2]], Q2 = {};
    for (var Y2 in W2) hasOwnProperty$1$1(W2, Y2) && (Q2[Y2] = W2[Y2]);
    Q2.name = X2, L2[X2] = Q2;
  }
  return N.isValidAlpha = function(e3) {
    return /^[a-zA-Z]$/.test(e3);
  }, N.createUnit = function(e3, t22) {
    if ("object" != typeof e3) throw new TypeError("createUnit expects first parameter to be of type 'Object'");
    if (t22 && t22.override) {
      for (var r2 in e3) if (hasOwnProperty$1$1(e3, r2) && N.deleteUnit(r2), e3[r2].aliases) for (var n3 = 0; n3 < e3[r2].aliases.length; n3++) N.deleteUnit(e3[r2].aliases[n3]);
    }
    var i22;
    for (var a2 in e3) hasOwnProperty$1$1(e3, a2) && (i22 = N.createUnitSingle(a2, e3[a2]));
    return i22;
  }, N.createUnitSingle = function(e3, t22) {
    if (null == t22 && (t22 = {}), "string" != typeof e3) throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
    if (hasOwnProperty$1$1(L2, e3)) throw new Error('Cannot create unit "' + e3 + '": a unit with that name already exists');
    !(function(e4) {
      for (var t3 = 0; t3 < e4.length; t3++) {
        if (n = e4.charAt(t3), 0 === t3 && !N.isValidAlpha(n)) throw new Error('Invalid unit name (must begin with alpha character): "' + e4 + '"');
        if (t3 > 0 && !N.isValidAlpha(n) && !E(n)) throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + e4 + '"');
      }
    })(e3);
    var r2, i22, a2, o2 = null, s2 = [], u2 = 0;
    if (t22 && "Unit" === t22.type) o2 = t22.clone();
    else if ("string" == typeof t22) "" !== t22 && (r2 = t22);
    else {
      if ("object" != typeof t22) throw new TypeError('Cannot create unit "' + e3 + '" from "' + t22.toString() + '": expecting "string" or "Unit" or "Object"');
      r2 = t22.definition, i22 = t22.prefixes, u2 = t22.offset, a2 = t22.baseName, t22.aliases && (s2 = t22.aliases.valueOf());
    }
    if (s2) {
      for (var c3 = 0; c3 < s2.length; c3++) if (hasOwnProperty$1$1(L2, s2[c3])) throw new Error('Cannot create alias "' + s2[c3] + '": a unit with that name already exists');
    }
    if (r2 && "string" == typeof r2 && !o2) try {
      o2 = N.parse(r2, { allowNoUnits: true });
    } catch (t3) {
      throw t3.message = 'Could not create unit "' + e3 + '" from "' + r2 + '": ' + t3.message, t3;
    }
    else r2 && "Unit" === r2.type && (o2 = r2.clone());
    s2 = s2 || [], u2 = u2 || 0, i22 = i22 && i22.toUpperCase && I2[i22.toUpperCase()] || I2.NONE;
    var l2 = {};
    if (o2) {
      l2 = { name: e3, value: o2.value, dimensions: o2.dimensions.slice(0), prefixes: i22, offset: u2 };
      var f3 = false;
      for (var p2 in q2) if (hasOwnProperty$1$1(q2, p2)) {
        for (var m2 = true, d2 = 0; d2 < R2.length; d2++) if (Math.abs((l2.dimensions[d2] || 0) - (q2[p2].dimensions[d2] || 0)) > 1e-12) {
          m2 = false;
          break;
        }
        if (m2) {
          f3 = true, l2.base = q2[p2];
          break;
        }
      }
      if (!f3) {
        a2 = a2 || e3 + "_STUFF";
        var h2 = { dimensions: o2.dimensions.slice(0) };
        h2.key = a2, q2[a2] = h2, G2[a2] = { unit: l2, prefix: I2.NONE[""] }, l2.base = q2[a2];
      }
    } else {
      if (a2 = a2 || e3 + "_STUFF", R2.indexOf(a2) >= 0) throw new Error('Cannot create new base unit "' + e3 + '": a base unit with that name already exists (and cannot be overridden)');
      for (var g2 in R2.push(a2), q2) hasOwnProperty$1$1(q2, g2) && (q2[g2].dimensions[R2.length - 1] = 0);
      for (var y2 = { dimensions: [] }, v22 = 0; v22 < R2.length; v22++) y2.dimensions[v22] = 0;
      y2.dimensions[R2.length - 1] = 1, y2.key = a2, q2[a2] = y2, l2 = { name: e3, value: 1, dimensions: q2[a2].dimensions.slice(0), prefixes: i22, offset: u2, base: q2[a2] }, G2[a2] = { unit: l2, prefix: I2.NONE[""] };
    }
    N.UNITS[e3] = l2;
    for (var x22 = 0; x22 < s2.length; x22++) {
      var b22 = s2[x22], _3 = {};
      for (var w22 in l2) hasOwnProperty$1$1(l2, w22) && (_3[w22] = l2[w22]);
      _3.name = b22, N.UNITS[b22] = _3;
    }
    return delete F.cache, new N(null, e3);
  }, N.deleteUnit = function(e3) {
    delete N.UNITS[e3], delete F.cache;
  }, N.PREFIXES = I2, N.BASE_DIMENSIONS = R2, N.BASE_UNITS = q2, N.UNIT_SYSTEMS = Z2, N.UNITS = L2, N;
}), { isClass: true }), name$2q = "unit", dependencies$2q = ["typed", "Unit"], createUnitFunction = factory(name$2q, dependencies$2q, ((e2) => {
  var { typed: t2, Unit: r } = e2;
  return t2(name$2q, { Unit: function(e3) {
    return e3.clone();
  }, string: function(e3) {
    return r.isValuelessUnit(e3) ? new r(null, e3) : r.parse(e3, { allowNoUnits: true });
  }, "number | BigNumber | Fraction | Complex, string | Unit": function(e3, t22) {
    return new r(e3, t22);
  }, "number | BigNumber | Fraction": function(e3) {
    return new r(e3);
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$2p = "sparse", dependencies$2p = ["typed", "SparseMatrix"], createSparse = factory(name$2p, dependencies$2p, ((e2) => {
  var { typed: t2, SparseMatrix: r } = e2;
  return t2(name$2p, { "": function() {
    return new r([]);
  }, string: function(e3) {
    return new r([], e3);
  }, "Array | Matrix": function(e3) {
    return new r(e3);
  }, "Array | Matrix, string": function(e3, t22) {
    return new r(e3, t22);
  } });
})), name$2o = "createUnit", dependencies$2o = ["typed", "Unit"], createCreateUnit = factory(name$2o, dependencies$2o, ((e2) => {
  var { typed: t2, Unit: r } = e2;
  return t2(name$2o, { "Object, Object": function(e3, t22) {
    return r.createUnit(e3, t22);
  }, Object: function(e3) {
    return r.createUnit(e3, {});
  }, "string, Unit | string | Object, Object": function(e3, t22, n) {
    var i2 = {};
    return i2[e3] = t22, r.createUnit(i2, n);
  }, "string, Unit | string | Object": function(e3, t22) {
    var n = {};
    return n[e3] = t22, r.createUnit(n, {});
  }, string: function(e3) {
    var t22 = {};
    return t22[e3] = {}, r.createUnit(t22, {});
  } });
})), name$2n = "acos", dependencies$2n = ["typed", "config", "Complex"], createAcos = factory(name$2n, dependencies$2n, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  return t2(name$2n, { number: function(e3) {
    return e3 >= -1 && e3 <= 1 || r.predictable ? Math.acos(e3) : new n(e3, 0).acos();
  }, Complex: function(e3) {
    return e3.acos();
  }, BigNumber: function(e3) {
    return e3.acos();
  } });
})), name$2m = "acosh", dependencies$2m = ["typed", "config", "Complex"], createAcosh = factory(name$2m, dependencies$2m, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  return t2(name$2m, { number: function(e3) {
    return e3 >= 1 || r.predictable ? acoshNumber(e3) : e3 <= -1 ? new n(Math.log(Math.sqrt(e3 * e3 - 1) - e3), Math.PI) : new n(e3, 0).acosh();
  }, Complex: function(e3) {
    return e3.acosh();
  }, BigNumber: function(e3) {
    return e3.acosh();
  } });
})), name$2l = "acot", dependencies$2l = ["typed", "BigNumber"], createAcot = factory(name$2l, dependencies$2l, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$2l, { number: acotNumber, Complex: function(e3) {
    return e3.acot();
  }, BigNumber: function(e3) {
    return new r(1).div(e3).atan();
  } });
})), name$2k = "acoth", dependencies$2k = ["typed", "config", "Complex", "BigNumber"], createAcoth = factory(name$2k, dependencies$2k, ((e2) => {
  var { typed: t2, config: r, Complex: n, BigNumber: i2 } = e2;
  return t2(name$2k, { number: function(e3) {
    return e3 >= 1 || e3 <= -1 || r.predictable ? acothNumber(e3) : new n(e3, 0).acoth();
  }, Complex: function(e3) {
    return e3.acoth();
  }, BigNumber: function(e3) {
    return new i2(1).div(e3).atanh();
  } });
})), name$2j = "acsc", dependencies$2j = ["typed", "config", "Complex", "BigNumber"], createAcsc = factory(name$2j, dependencies$2j, ((e2) => {
  var { typed: t2, config: r, Complex: n, BigNumber: i2 } = e2;
  return t2(name$2j, { number: function(e3) {
    return e3 <= -1 || e3 >= 1 || r.predictable ? acscNumber(e3) : new n(e3, 0).acsc();
  }, Complex: function(e3) {
    return e3.acsc();
  }, BigNumber: function(e3) {
    return new i2(1).div(e3).asin();
  } });
})), name$2i = "acsch", dependencies$2i = ["typed", "BigNumber"], createAcsch = factory(name$2i, dependencies$2i, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$2i, { number: acschNumber, Complex: function(e3) {
    return e3.acsch();
  }, BigNumber: function(e3) {
    return new r(1).div(e3).asinh();
  } });
})), name$2h = "asec", dependencies$2h = ["typed", "config", "Complex", "BigNumber"], createAsec = factory(name$2h, dependencies$2h, ((e2) => {
  var { typed: t2, config: r, Complex: n, BigNumber: i2 } = e2;
  return t2(name$2h, { number: function(e3) {
    return e3 <= -1 || e3 >= 1 || r.predictable ? asecNumber(e3) : new n(e3, 0).asec();
  }, Complex: function(e3) {
    return e3.asec();
  }, BigNumber: function(e3) {
    return new i2(1).div(e3).acos();
  } });
})), name$2g = "asech", dependencies$2g = ["typed", "config", "Complex", "BigNumber"], createAsech = factory(name$2g, dependencies$2g, ((e2) => {
  var { typed: t2, config: r, Complex: n, BigNumber: i2 } = e2;
  return t2(name$2g, { number: function(e3) {
    if (e3 <= 1 && e3 >= -1 || r.predictable) {
      var t22 = 1 / e3;
      if (t22 > 0 || r.predictable) return asechNumber(e3);
      var i22 = Math.sqrt(t22 * t22 - 1);
      return new n(Math.log(i22 - t22), Math.PI);
    }
    return new n(e3, 0).asech();
  }, Complex: function(e3) {
    return e3.asech();
  }, BigNumber: function(e3) {
    return new i2(1).div(e3).acosh();
  } });
})), name$2f = "asin", dependencies$2f = ["typed", "config", "Complex"], createAsin = factory(name$2f, dependencies$2f, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  return t2(name$2f, { number: function(e3) {
    return e3 >= -1 && e3 <= 1 || r.predictable ? Math.asin(e3) : new n(e3, 0).asin();
  }, Complex: function(e3) {
    return e3.asin();
  }, BigNumber: function(e3) {
    return e3.asin();
  } });
})), name$2e = "asinh", dependencies$2e = ["typed"], createAsinh = factory(name$2e, dependencies$2e, ((e2) => {
  var { typed: t2 } = e2;
  return t2("asinh", { number: asinhNumber, Complex: function(e3) {
    return e3.asinh();
  }, BigNumber: function(e3) {
    return e3.asinh();
  } });
})), name$2d = "atan", dependencies$2d = ["typed"], createAtan = factory(name$2d, dependencies$2d, ((e2) => {
  var { typed: t2 } = e2;
  return t2("atan", { number: function(e3) {
    return Math.atan(e3);
  }, Complex: function(e3) {
    return e3.atan();
  }, BigNumber: function(e3) {
    return e3.atan();
  } });
})), name$2c = "atan2", dependencies$2c = ["typed", "matrix", "equalScalar", "BigNumber", "DenseMatrix", "concat"], createAtan2 = factory(name$2c, dependencies$2c, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, BigNumber: i2, DenseMatrix: a, concat: o } = e2, s = createMatAlgo02xDS0({ typed: t2, equalScalar: n }), u = createMatAlgo03xDSf({ typed: t2 }), c2 = createMatAlgo09xS0Sf({ typed: t2, equalScalar: n }), l = createMatAlgo11xS0s({ typed: t2, equalScalar: n }), f2 = createMatAlgo12xSfs({ typed: t2, DenseMatrix: a }), p = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: o });
  return t2(name$2c, { "number, number": Math.atan2, "BigNumber, BigNumber": (e3, t22) => i2.atan2(e3, t22) }, p({ scalar: "number | BigNumber", SS: c2, DS: u, SD: s, Ss: l, sS: f2 }));
})), name$2b = "atanh", dependencies$2b = ["typed", "config", "Complex"], createAtanh = factory(name$2b, dependencies$2b, ((e2) => {
  var { typed: t2, config: r, Complex: n } = e2;
  return t2(name$2b, { number: function(e3) {
    return e3 <= 1 && e3 >= -1 || r.predictable ? atanhNumber(e3) : new n(e3, 0).atanh();
  }, Complex: function(e3) {
    return e3.atanh();
  }, BigNumber: function(e3) {
    return e3.atanh();
  } });
})), createTrigUnit = factory("trigUnit", ["typed"], ((e2) => {
  var { typed: t2 } = e2;
  return { Unit: t2.referToSelf(((e3) => (r) => {
    if (!r.hasBase(r.constructor.BASE_UNITS.ANGLE)) throw new TypeError("Unit in function cot is no angle");
    return t2.find(e3, r.valueType())(r.value);
  })) };
})), name$2a = "cos", dependencies$2a = ["typed"], createCos = factory(name$2a, dependencies$2a, ((e2) => {
  var { typed: t2 } = e2, r = createTrigUnit({ typed: t2 });
  return t2(name$2a, { number: Math.cos, "Complex | BigNumber": (e3) => e3.cos() }, r);
})), name$29 = "cosh", dependencies$29 = ["typed"], createCosh = factory(name$29, dependencies$29, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$29, { number: cosh$3, "Complex | BigNumber": (e3) => e3.cosh() });
})), name$28 = "cot", dependencies$28 = ["typed", "BigNumber"], createCot = factory(name$28, dependencies$28, ((e2) => {
  var { typed: t2, BigNumber: r } = e2, n = createTrigUnit({ typed: t2 });
  return t2(name$28, { number: cotNumber, Complex: (e3) => e3.cot(), BigNumber: (e3) => new r(1).div(e3.tan()) }, n);
})), name$27 = "coth", dependencies$27 = ["typed", "BigNumber"], createCoth = factory(name$27, dependencies$27, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$27, { number: cothNumber, Complex: (e3) => e3.coth(), BigNumber: (e3) => new r(1).div(e3.tanh()) });
})), name$26 = "csc", dependencies$26 = ["typed", "BigNumber"], createCsc = factory(name$26, dependencies$26, ((e2) => {
  var { typed: t2, BigNumber: r } = e2, n = createTrigUnit({ typed: t2 });
  return t2(name$26, { number: cscNumber, Complex: (e3) => e3.csc(), BigNumber: (e3) => new r(1).div(e3.sin()) }, n);
})), name$25 = "csch", dependencies$25 = ["typed", "BigNumber"], createCsch = factory(name$25, dependencies$25, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$25, { number: cschNumber, Complex: (e3) => e3.csch(), BigNumber: (e3) => new r(1).div(e3.sinh()) });
})), name$24 = "sec", dependencies$24 = ["typed", "BigNumber"], createSec = factory(name$24, dependencies$24, ((e2) => {
  var { typed: t2, BigNumber: r } = e2, n = createTrigUnit({ typed: t2 });
  return t2(name$24, { number: secNumber, Complex: (e3) => e3.sec(), BigNumber: (e3) => new r(1).div(e3.cos()) }, n);
})), name$23 = "sech", dependencies$23 = ["typed", "BigNumber"], createSech = factory(name$23, dependencies$23, ((e2) => {
  var { typed: t2, BigNumber: r } = e2;
  return t2(name$23, { number: sechNumber, Complex: (e3) => e3.sech(), BigNumber: (e3) => new r(1).div(e3.cosh()) });
})), name$22 = "sin", dependencies$22 = ["typed"], createSin = factory(name$22, dependencies$22, ((e2) => {
  var { typed: t2 } = e2, r = createTrigUnit({ typed: t2 });
  return t2(name$22, { number: Math.sin, "Complex | BigNumber": (e3) => e3.sin() }, r);
})), name$21 = "sinh", dependencies$21 = ["typed"], createSinh = factory(name$21, dependencies$21, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$21, { number: sinhNumber, "Complex | BigNumber": (e3) => e3.sinh() });
})), name$20 = "tan", dependencies$20 = ["typed"], createTan = factory(name$20, dependencies$20, ((e2) => {
  var { typed: t2 } = e2, r = createTrigUnit({ typed: t2 });
  return t2(name$20, { number: Math.tan, "Complex | BigNumber": (e3) => e3.tan() }, r);
})), name$1$ = "tanh", dependencies$1$ = ["typed"], createTanh = factory(name$1$, dependencies$1$, ((e2) => {
  var { typed: t2 } = e2;
  return t2("tanh", { number: tanh$2, "Complex | BigNumber": (e3) => e3.tanh() });
})), name$1_ = "setCartesian", dependencies$1_ = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetCartesian = factory(name$1_, dependencies$1_, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a, DenseMatrix: o } = e2;
  return t2(name$1_, { "Array | Matrix, Array | Matrix": function(e3, t22) {
    var s = [];
    if (0 !== n(r(e3), new a(0)) && 0 !== n(r(t22), new a(0))) {
      var u = flatten$4(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2), c2 = flatten$4(Array.isArray(t22) ? t22 : t22.toArray()).sort(i2);
      s = [];
      for (var l = 0; l < u.length; l++) for (var f2 = 0; f2 < c2.length; f2++) s.push([u[l], c2[f2]]);
    }
    return Array.isArray(e3) && Array.isArray(t22) ? s : new o(s);
  } });
})), name$1Z = "setDifference", dependencies$1Z = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetDifference = factory(name$1Z, dependencies$1Z, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a, DenseMatrix: o } = e2;
  return t2(name$1Z, { "Array | Matrix, Array | Matrix": function(e3, t22) {
    var s;
    if (0 === n(r(e3), new a(0))) s = [];
    else {
      if (0 === n(r(t22), new a(0))) return flatten$4(e3.toArray());
      var u, c2 = identify(flatten$4(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2)), l = identify(flatten$4(Array.isArray(t22) ? t22 : t22.toArray()).sort(i2));
      s = [];
      for (var f2 = 0; f2 < c2.length; f2++) {
        u = false;
        for (var p = 0; p < l.length; p++) if (0 === i2(c2[f2].value, l[p].value) && c2[f2].identifier === l[p].identifier) {
          u = true;
          break;
        }
        u || s.push(c2[f2]);
      }
    }
    return Array.isArray(e3) && Array.isArray(t22) ? generalize(s) : new o(generalize(s));
  } });
})), name$1Y = "setDistinct", dependencies$1Y = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetDistinct = factory(name$1Y, dependencies$1Y, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a, DenseMatrix: o } = e2;
  return t2(name$1Y, { "Array | Matrix": function(e3) {
    var t22;
    if (0 === n(r(e3), new a(0))) t22 = [];
    else {
      var s = flatten$4(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2);
      (t22 = []).push(s[0]);
      for (var u = 1; u < s.length; u++) 0 !== i2(s[u], s[u - 1]) && t22.push(s[u]);
    }
    return Array.isArray(e3) ? t22 : new o(t22);
  } });
})), name$1X = "setIntersect", dependencies$1X = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], createSetIntersect = factory(name$1X, dependencies$1X, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a, DenseMatrix: o } = e2;
  return t2(name$1X, { "Array | Matrix, Array | Matrix": function(e3, t22) {
    var s;
    if (0 === n(r(e3), new a(0)) || 0 === n(r(t22), new a(0))) s = [];
    else {
      var u = identify(flatten$4(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2)), c2 = identify(flatten$4(Array.isArray(t22) ? t22 : t22.toArray()).sort(i2));
      s = [];
      for (var l = 0; l < u.length; l++) for (var f2 = 0; f2 < c2.length; f2++) if (0 === i2(u[l].value, c2[f2].value) && u[l].identifier === c2[f2].identifier) {
        s.push(u[l]);
        break;
      }
    }
    return Array.isArray(e3) && Array.isArray(t22) ? generalize(s) : new o(generalize(s));
  } });
})), name$1W = "setIsSubset", dependencies$1W = ["typed", "size", "subset", "compareNatural", "Index"], createSetIsSubset = factory(name$1W, dependencies$1W, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a } = e2;
  return t2(name$1W, { "Array | Matrix, Array | Matrix": function(e3, t22) {
    if (0 === n(r(e3), new a(0))) return true;
    if (0 === n(r(t22), new a(0))) return false;
    for (var o, s = identify(flatten$4(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2)), u = identify(flatten$4(Array.isArray(t22) ? t22 : t22.toArray()).sort(i2)), c2 = 0; c2 < s.length; c2++) {
      o = false;
      for (var l = 0; l < u.length; l++) if (0 === i2(s[c2].value, u[l].value) && s[c2].identifier === u[l].identifier) {
        o = true;
        break;
      }
      if (false === o) return false;
    }
    return true;
  } });
})), name$1V = "setMultiplicity", dependencies$1V = ["typed", "size", "subset", "compareNatural", "Index"], createSetMultiplicity = factory(name$1V, dependencies$1V, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a } = e2;
  return t2(name$1V, { "number | BigNumber | Fraction | Complex, Array | Matrix": function(e3, t22) {
    if (0 === n(r(t22), new a(0))) return 0;
    for (var o = flatten$4(Array.isArray(t22) ? t22 : t22.toArray()), s = 0, u = 0; u < o.length; u++) 0 === i2(o[u], e3) && s++;
    return s;
  } });
})), name$1U = "setPowerset", dependencies$1U = ["typed", "size", "subset", "compareNatural", "Index"], createSetPowerset = factory(name$1U, dependencies$1U, ((e2) => {
  var { typed: t2, size: r, subset: n, compareNatural: i2, Index: a } = e2;
  return t2(name$1U, { "Array | Matrix": function(e3) {
    if (0 === n(r(e3), new a(0))) return [];
    for (var t22 = flatten$4(Array.isArray(e3) ? e3 : e3.toArray()).sort(i2), s = [], u = 0; u.toString(2).length <= t22.length; ) s.push(o(t22, u.toString(2).split("").reverse())), u++;
    return (function(e4) {
      for (var t3 = [], r2 = e4.length - 1; r2 > 0; r2--) for (var n3 = 0; n3 < r2; n3++) e4[n3].length > e4[n3 + 1].length && (t3 = e4[n3], e4[n3] = e4[n3 + 1], e4[n3 + 1] = t3);
      return e4;
    })(s);
  } });
  function o(e3, t22) {
    for (var r2 = [], n3 = 0; n3 < t22.length; n3++) "1" === t22[n3] && r2.push(e3[n3]);
    return r2;
  }
})), name$1T = "setSize", dependencies$1T = ["typed", "compareNatural"], createSetSize = factory(name$1T, dependencies$1T, ((e2) => {
  var { typed: t2, compareNatural: r } = e2;
  return t2(name$1T, { "Array | Matrix": function(e3) {
    return Array.isArray(e3) ? flatten$4(e3).length : flatten$4(e3.toArray()).length;
  }, "Array | Matrix, boolean": function(e3, t22) {
    if (false === t22 || 0 === e3.length) return Array.isArray(e3) ? flatten$4(e3).length : flatten$4(e3.toArray()).length;
    for (var n = flatten$4(Array.isArray(e3) ? e3 : e3.toArray()).sort(r), i2 = 1, a = 1; a < n.length; a++) 0 !== r(n[a], n[a - 1]) && i2++;
    return i2;
  } });
})), name$1S = "setSymDifference", dependencies$1S = ["typed", "size", "concat", "subset", "setDifference", "Index"], createSetSymDifference = factory(name$1S, dependencies$1S, ((e2) => {
  var { typed: t2, size: r, concat: n, subset: i2, setDifference: a, Index: o } = e2;
  return t2(name$1S, { "Array | Matrix, Array | Matrix": function(e3, t22) {
    if (0 === i2(r(e3), new o(0))) return flatten$4(t22);
    if (0 === i2(r(t22), new o(0))) return flatten$4(e3);
    var s = flatten$4(e3), u = flatten$4(t22);
    return n(a(s, u), a(u, s));
  } });
})), name$1R = "setUnion", dependencies$1R = ["typed", "size", "concat", "subset", "setIntersect", "setSymDifference", "Index"], createSetUnion = factory(name$1R, dependencies$1R, ((e2) => {
  var { typed: t2, size: r, concat: n, subset: i2, setIntersect: a, setSymDifference: o, Index: s } = e2;
  return t2(name$1R, { "Array | Matrix, Array | Matrix": function(e3, t22) {
    if (0 === i2(r(e3), new s(0))) return flatten$4(t22);
    if (0 === i2(r(t22), new s(0))) return flatten$4(e3);
    var u = flatten$4(e3), c2 = flatten$4(t22);
    return n(o(u, c2), a(u, c2));
  } });
})), name$1Q = "add", dependencies$1Q = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix", "concat"], createAdd = factory(name$1Q, dependencies$1Q, ((e2) => {
  var { typed: t2, matrix: r, addScalar: n, equalScalar: i2, DenseMatrix: a, SparseMatrix: o, concat: s } = e2, u = createMatAlgo01xDSid({ typed: t2 }), c2 = createMatAlgo04xSidSid({ typed: t2, equalScalar: i2 }), l = createMatAlgo10xSids({ typed: t2, DenseMatrix: a }), f2 = createMatrixAlgorithmSuite({ typed: t2, matrix: r, concat: s });
  return t2(name$1Q, { "any, any": n, "any, any, ...any": t2.referToSelf(((e3) => (t22, r2, n3) => {
    for (var i22 = e3(t22, r2), a2 = 0; a2 < n3.length; a2++) i22 = e3(i22, n3[a2]);
    return i22;
  })) }, f2({ elop: n, DS: u, SS: c2, Ss: l }));
})), name$1P = "hypot", dependencies$1P = ["typed", "abs", "addScalar", "divideScalar", "multiplyScalar", "sqrt", "smaller", "isPositive"], createHypot = factory(name$1P, dependencies$1P, ((e2) => {
  var { typed: t2, abs: r, addScalar: n, divideScalar: i2, multiplyScalar: a, sqrt: o, smaller: s, isPositive: u } = e2;
  return t2(name$1P, { "... number | BigNumber": c2, Array: c2, Matrix: (e3) => c2(flatten$4(e3.toArray(), true)) });
  function c2(e3) {
    for (var t22 = 0, c3 = 0, l = 0; l < e3.length; l++) {
      if (isComplex(e3[l])) throw new TypeError("Unexpected type of argument to hypot");
      var f2 = r(e3[l]);
      s(c3, f2) ? (t22 = a(t22, a(i2(c3, f2), i2(c3, f2))), t22 = n(t22, 1), c3 = f2) : t22 = n(t22, u(f2) ? a(i2(f2, c3), i2(f2, c3)) : f2);
    }
    return a(c3, o(t22));
  }
})), name$1O = "norm", dependencies$1O = ["typed", "abs", "add", "pow", "conj", "sqrt", "multiply", "equalScalar", "larger", "smaller", "matrix", "ctranspose", "eigs"], createNorm = factory(name$1O, dependencies$1O, ((e2) => {
  var { typed: t2, abs: r, add: n, pow: i2, conj: a, sqrt: o, multiply: s, equalScalar: u, larger: c2, smaller: l, matrix: f2, ctranspose: p, eigs: m } = e2;
  return t2(name$1O, { number: Math.abs, Complex: function(e3) {
    return e3.abs();
  }, BigNumber: function(e3) {
    return e3.abs();
  }, boolean: function(e3) {
    return Math.abs(e3);
  }, Array: function(e3) {
    return g(f2(e3), 2);
  }, Matrix: function(e3) {
    return g(e3, 2);
  }, "Array, number | BigNumber | string": function(e3, t22) {
    return g(f2(e3), t22);
  }, "Matrix, number | BigNumber | string": function(e3, t22) {
    return g(e3, t22);
  } });
  function d(e3, t22) {
    if (t22 === Number.POSITIVE_INFINITY || "inf" === t22) return (function(e4) {
      var t3 = 0;
      return e4.forEach((function(e5) {
        var n3 = r(e5);
        c2(n3, t3) && (t3 = n3);
      }), true), t3;
    })(e3);
    if (t22 === Number.NEGATIVE_INFINITY || "-inf" === t22) return (function(e4) {
      var t3;
      return e4.forEach((function(e5) {
        var n3 = r(e5);
        t3 && !l(n3, t3) || (t3 = n3);
      }), true), t3 || 0;
    })(e3);
    if ("fro" === t22) return g(e3, 2);
    if ("number" == typeof t22 && !isNaN(t22)) {
      if (!u(t22, 0)) {
        var a2 = 0;
        return e3.forEach((function(e4) {
          a2 = n(i2(r(e4), t22), a2);
        }), true), i2(a2, 1 / t22);
      }
      return Number.POSITIVE_INFINITY;
    }
    throw new Error("Unsupported parameter value");
  }
  function h(e3, t22) {
    if (1 === t22) return (function(e4) {
      var t3 = [], i22 = 0;
      return e4.forEach((function(e5, a2) {
        var o2 = a2[1], s2 = n(t3[o2] || 0, r(e5));
        c2(s2, i22) && (i22 = s2), t3[o2] = s2;
      }), true), i22;
    })(e3);
    if (t22 === Number.POSITIVE_INFINITY || "inf" === t22) return (function(e4) {
      var t3 = [], i22 = 0;
      return e4.forEach((function(e5, a2) {
        var o2 = a2[0], s2 = n(t3[o2] || 0, r(e5));
        c2(s2, i22) && (i22 = s2), t3[o2] = s2;
      }), true), i22;
    })(e3);
    if ("fro" === t22) return (function(e4) {
      var t3 = 0;
      return e4.forEach((function(e5, r2) {
        t3 = n(t3, s(e5, a(e5)));
      })), r(o(t3));
    })(e3);
    if (2 === t22) return (function(e4) {
      var t3 = e4.size();
      if (t3[0] !== t3[1]) throw new RangeError("Invalid matrix dimensions");
      var n3 = p(e4), i22 = s(n3, e4), a2 = m(i22).values.toArray(), u2 = a2[a2.length - 1];
      return r(o(u2));
    })(e3);
    throw new Error("Unsupported parameter value " + t22);
  }
  function g(e3, t22) {
    var r2 = e3.size();
    if (1 === r2.length) return d(e3, t22);
    if (2 === r2.length) {
      if (r2[0] && r2[1]) return h(e3, t22);
      throw new RangeError("Invalid matrix dimensions");
    }
  }
})), name$1N = "dot", dependencies$1N = ["typed", "addScalar", "multiplyScalar", "conj", "size"], createDot = factory(name$1N, dependencies$1N, ((e2) => {
  var { typed: t2, addScalar: r, multiplyScalar: n, conj: i2, size: a } = e2;
  return t2(name$1N, { "Array | DenseMatrix, Array | DenseMatrix": function(e3, s) {
    var u = o(e3, s), c2 = isMatrix(e3) ? e3._data : e3, l = isMatrix(e3) ? e3._datatype || e3.getDataType() : void 0, f2 = isMatrix(s) ? s._data : s, p = isMatrix(s) ? s._datatype || s.getDataType() : void 0, m = 2 === a(e3).length, d = 2 === a(s).length, h = r, g = n;
    if (l && p && l === p && "string" == typeof l && "mixed" !== l) {
      var y = l;
      h = t2.find(r, [y, y]), g = t2.find(n, [y, y]);
    }
    if (!m && !d) {
      for (var v2 = g(i2(c2[0]), f2[0]), x2 = 1; x2 < u; x2++) v2 = h(v2, g(i2(c2[x2]), f2[x2]));
      return v2;
    }
    if (!m && d) {
      for (var b2 = g(i2(c2[0]), f2[0][0]), _2 = 1; _2 < u; _2++) b2 = h(b2, g(i2(c2[_2]), f2[_2][0]));
      return b2;
    }
    if (m && !d) {
      for (var w2 = g(i2(c2[0][0]), f2[0]), A2 = 1; A2 < u; A2++) w2 = h(w2, g(i2(c2[A2][0]), f2[A2]));
      return w2;
    }
    if (m && d) {
      for (var N = g(i2(c2[0][0]), f2[0][0]), D = 1; D < u; D++) N = h(N, g(i2(c2[D][0]), f2[D][0]));
      return N;
    }
  }, "SparseMatrix, SparseMatrix": function(e3, t22) {
    o(e3, t22);
    var i22 = e3._index, a2 = e3._values, s = t22._index, u = t22._values, c2 = 0, l = r, f2 = n, p = 0, m = 0;
    for (; p < i22.length && m < s.length; ) {
      var d = i22[p], h = s[m];
      d < h ? p++ : d > h ? m++ : d === h && (c2 = l(c2, f2(a2[p], u[m])), p++, m++);
    }
    return c2;
  } });
  function o(e3, t22) {
    var r2, n3, i22 = a(e3), o2 = a(t22);
    if (1 === i22.length) r2 = i22[0];
    else {
      if (2 !== i22.length || 1 !== i22[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + i22.join(", ") + ")");
      r2 = i22[0];
    }
    if (1 === o2.length) n3 = o2[0];
    else {
      if (2 !== o2.length || 1 !== o2[1]) throw new RangeError("Expected a column vector, instead got a matrix of size (" + o2.join(", ") + ")");
      n3 = o2[0];
    }
    if (r2 !== n3) throw new RangeError("Vectors must have equal length (" + r2 + " != " + n3 + ")");
    if (0 === r2) throw new RangeError("Cannot calculate the dot product of empty vectors");
    return r2;
  }
})), name$1M = "trace", dependencies$1M = ["typed", "matrix", "add"], createTrace = factory(name$1M, dependencies$1M, ((e2) => {
  var { typed: t2, matrix: r, add: n } = e2;
  return t2("trace", { Array: function(e3) {
    return i2(r(e3));
  }, SparseMatrix: function(e3) {
    var t22 = e3._values, r2 = e3._index, i22 = e3._ptr, a = e3._size, o = a[0], s = a[1];
    if (o === s) {
      var u = 0;
      if (t22.length > 0) for (var c2 = 0; c2 < s; c2++) for (var l = i22[c2], f2 = i22[c2 + 1], p = l; p < f2; p++) {
        var m = r2[p];
        if (m === c2) {
          u = n(u, t22[p]);
          break;
        }
        if (m > c2) break;
      }
      return u;
    }
    throw new RangeError("Matrix must be square (size: " + format(a) + ")");
  }, DenseMatrix: i2, any: clone$3 });
  function i2(e3) {
    var t22 = e3._size, r2 = e3._data;
    switch (t22.length) {
      case 1:
        if (1 === t22[0]) return clone$3(r2[0]);
        throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
      case 2:
        var i22 = t22[0];
        if (i22 === t22[1]) {
          for (var a = 0, o = 0; o < i22; o++) a = n(a, r2[o][o]);
          return a;
        }
        throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + format(t22) + ")");
    }
  }
})), name$1L = "index", dependencies$1L = ["typed", "Index"], createIndex = factory(name$1L, dependencies$1L, ((e2) => {
  var { typed: t2, Index: r } = e2;
  return t2(name$1L, { "...number | string | BigNumber | Range | Array | Matrix": function(e3) {
    var t22 = e3.map((function(e4) {
      return isBigNumber(e4) ? e4.toNumber() : isArray$1(e4) || isMatrix(e4) ? e4.map((function(e5) {
        return isBigNumber(e5) ? e5.toNumber() : e5;
      })) : e4;
    })), n = new r();
    return r.apply(n, t22), n;
  } });
})), keywords = /* @__PURE__ */ new Set(["end"]), name$1K = "Node", dependencies$1K = ["mathWithTransform"], createNode = factory(name$1K, dependencies$1K, ((e2) => {
  var { mathWithTransform: t2 } = e2;
  return class {
    get type() {
      return "Node";
    }
    get isNode() {
      return true;
    }
    evaluate(e3) {
      return this.compile().evaluate(e3);
    }
    compile() {
      var e3 = this._compile(t2, {}), r = {};
      return { evaluate: function(t22) {
        var n = createMap$1(t22);
        return (function(e4) {
          for (var t3 of [...keywords]) if (e4.has(t3)) throw new Error('Scope contains an illegal symbol, "' + t3 + '" is a reserved keyword');
        })(n), e3(n, r, null);
      } };
    }
    _compile(e3, t22) {
      throw new Error("Method _compile must be implemented by type " + this.type);
    }
    forEach(e3) {
      throw new Error("Cannot run forEach on a Node interface");
    }
    map(e3) {
      throw new Error("Cannot run map on a Node interface");
    }
    _ifNode(e3) {
      if (!isNode$1(e3)) throw new TypeError("Callback function must return a Node");
      return e3;
    }
    traverse(e3) {
      e3(this, null, null), (function e4(t22, r) {
        t22.forEach((function(t3, n, i2) {
          r(t3, n, i2), e4(t3, r);
        }));
      })(this, e3);
    }
    transform(e3) {
      return (function t22(r, n, i2) {
        var a = e3(r, n, i2);
        return a !== r ? a : r.map(t22);
      })(this, null, null);
    }
    filter(e3) {
      var t22 = [];
      return this.traverse((function(r, n, i2) {
        e3(r, n, i2) && t22.push(r);
      })), t22;
    }
    clone() {
      throw new Error("Cannot clone a Node interface");
    }
    cloneDeep() {
      return this.map((function(e3) {
        return e3.cloneDeep();
      }));
    }
    equals(e3) {
      return !!e3 && (this.type === e3.type && deepStrictEqual(this, e3));
    }
    toString(e3) {
      var t22 = this._getCustomString(e3);
      return void 0 !== t22 ? t22 : this._toString(e3);
    }
    _toString() {
      throw new Error("_toString not implemented for " + this.type);
    }
    toJSON() {
      throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
    }
    toHTML(e3) {
      var t22 = this._getCustomString(e3);
      return void 0 !== t22 ? t22 : this._toHTML(e3);
    }
    _toHTML() {
      throw new Error("_toHTML not implemented for " + this.type);
    }
    toTex(e3) {
      var t22 = this._getCustomString(e3);
      return void 0 !== t22 ? t22 : this._toTex(e3);
    }
    _toTex(e3) {
      throw new Error("_toTex not implemented for " + this.type);
    }
    _getCustomString(e3) {
      if (e3 && "object" == typeof e3) switch (typeof e3.handler) {
        case "object":
        case "undefined":
          return;
        case "function":
          return e3.handler(this, e3);
        default:
          throw new TypeError("Object or function expected as callback");
      }
    }
    getIdentifier() {
      return this.type;
    }
    getContent() {
      return this;
    }
  };
}), { isClass: true, isNode: true });
function errorTransform(e2) {
  return e2 && e2.isIndexError ? new IndexError(e2.index + 1, e2.min + 1, void 0 !== e2.max ? e2.max + 1 : void 0) : e2;
}
function accessFactory(e2) {
  var { subset: t2 } = e2;
  return function(e3, r) {
    try {
      if (Array.isArray(e3)) return t2(e3, r);
      if (e3 && "function" == typeof e3.subset) return e3.subset(r);
      if ("string" == typeof e3) return t2(e3, r);
      if ("object" == typeof e3) {
        if (!r.isObjectProperty()) throw new TypeError("Cannot apply a numeric index as object property");
        return getSafeProperty(e3, r.getObjectProperty());
      }
      throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (e4) {
      throw errorTransform(e4);
    }
  };
}
var name$1J = "AccessorNode", dependencies$1J = ["subset", "Node"], createAccessorNode = factory(name$1J, dependencies$1J, ((e2) => {
  var { subset: t2, Node: r } = e2, n = accessFactory({ subset: t2 });
  function i2(e3) {
    return !(isAccessorNode(e3) || isArrayNode(e3) || isConstantNode(e3) || isFunctionNode(e3) || isObjectNode(e3) || isParenthesisNode(e3) || isSymbolNode(e3));
  }
  class a extends r {
    constructor(e3, t22) {
      var r2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      if (super(), !isNode$1(e3)) throw new TypeError('Node expected for parameter "object"');
      if (!isIndexNode(t22)) throw new TypeError('IndexNode expected for parameter "index"');
      this.object = e3, this.index = t22, this.optionalChaining = r2;
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return name$1J;
    }
    get isAccessorNode() {
      return true;
    }
    _compile(e3, t22) {
      var r2 = this.object._compile(e3, t22), i22 = this.index._compile(e3, t22), a2 = this.optionalChaining, o = isAccessorNode(this.object) && this.object.optionalChaining;
      if (this.index.isObjectProperty()) {
        var s = this.index.getObjectProperty();
        return function(e4, t3, n3) {
          var i3 = n3 || {}, u = r2(e4, t3, i3);
          if (a2 && null == u) i3.optionalShortCircuit = true;
          else if (!o || null == i3 || !i3.optionalShortCircuit) return getSafeProperty(u, s);
        };
      }
      return function(e4, t3, s2) {
        var u = s2 || {}, c2 = r2(e4, t3, u);
        if (a2 && null == c2) u.optionalShortCircuit = true;
        else if (!o || null == u || !u.optionalShortCircuit) {
          var l = i22(e4, t3, c2);
          return n(c2, l);
        }
      };
    }
    forEach(e3) {
      e3(this.object, "object", this), e3(this.index, "index", this);
    }
    map(e3) {
      return new a(this._ifNode(e3(this.object, "object", this)), this._ifNode(e3(this.index, "index", this)), this.optionalChaining);
    }
    clone() {
      return new a(this.object, this.index, this.optionalChaining);
    }
    _toString(e3) {
      var t22 = this.object.toString(e3);
      return i2(this.object) && (t22 = "(" + t22 + ")"), t22 + (this.optionalChaining ? this.index.dotNotation ? "?" : "?." : "") + this.index.toString(e3);
    }
    _toHTML(e3) {
      var t22 = this.object.toHTML(e3);
      return i2(this.object) && (t22 = '<span class="math-parenthesis math-round-parenthesis">(</span>' + t22 + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t22 + this.index.toHTML(e3);
    }
    _toTex(e3) {
      var t22 = this.object.toTex(e3);
      return i2(this.object) && (t22 = "\\left(' + object + '\\right)"), t22 + this.index.toTex(e3);
    }
    toJSON() {
      return { mathjs: name$1J, object: this.object, index: this.index, optionalChaining: this.optionalChaining };
    }
    static fromJSON(e3) {
      return new a(e3.object, e3.index, e3.optionalChaining);
    }
  }
  return _defineProperty$1(a, "name", name$1J), a;
}), { isClass: true, isNode: true }), name$1I = "ArrayNode", dependencies$1I = ["Node"], createArrayNode = factory(name$1I, dependencies$1I, ((e2) => {
  var { Node: t2 } = e2;
  class r extends t2 {
    constructor(e3) {
      if (super(), this.items = e3 || [], !Array.isArray(this.items) || !this.items.every(isNode$1)) throw new TypeError("Array containing Nodes expected");
    }
    get type() {
      return name$1I;
    }
    get isArrayNode() {
      return true;
    }
    _compile(e3, t22) {
      var r2 = map$1(this.items, (function(r3) {
        return r3._compile(e3, t22);
      }));
      if ("Array" !== e3.config.matrix) {
        var n = e3.matrix;
        return function(e4, t3, i2) {
          return n(map$1(r2, (function(r3) {
            return r3(e4, t3, i2);
          })));
        };
      }
      return function(e4, t3, n3) {
        return map$1(r2, (function(r3) {
          return r3(e4, t3, n3);
        }));
      };
    }
    forEach(e3) {
      for (var t22 = 0; t22 < this.items.length; t22++) {
        e3(this.items[t22], "items[" + t22 + "]", this);
      }
    }
    map(e3) {
      for (var t22 = [], n = 0; n < this.items.length; n++) t22[n] = this._ifNode(e3(this.items[n], "items[" + n + "]", this));
      return new r(t22);
    }
    clone() {
      return new r(this.items.slice(0));
    }
    _toString(e3) {
      return "[" + this.items.map((function(t22) {
        return t22.toString(e3);
      })).join(", ") + "]";
    }
    toJSON() {
      return { mathjs: name$1I, items: this.items };
    }
    static fromJSON(e3) {
      return new r(e3.items);
    }
    _toHTML(e3) {
      return '<span class="math-parenthesis math-square-parenthesis">[</span>' + this.items.map((function(t22) {
        return t22.toHTML(e3);
      })).join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    _toTex(e3) {
      return (function t22(r2, n) {
        var i2 = r2.some(isArrayNode) && !r2.every(isArrayNode), a = n || i2, o = a ? "&" : "\\\\", s = r2.map((function(r3) {
          return r3.items ? t22(r3.items, !n) : r3.toTex(e3);
        })).join(o);
        return i2 || !a || a && !n ? "\\begin{bmatrix}" + s + "\\end{bmatrix}" : s;
      })(this.items, false);
    }
  }
  return _defineProperty$1(r, "name", name$1I), r;
}), { isClass: true, isNode: true });
function assignFactory(e2) {
  var { subset: t2, matrix: r } = e2;
  return function(e3, n, i2) {
    try {
      if (Array.isArray(e3)) return r(e3).subset(n, i2).valueOf().forEach(((t22, r2) => {
        e3[r2] = t22;
      })), e3;
      if (e3 && "function" == typeof e3.subset) return e3.subset(n, i2);
      if ("string" == typeof e3) return t2(e3, n, i2);
      if ("object" == typeof e3) {
        if (!n.isObjectProperty()) throw TypeError("Cannot apply a numeric index as object property");
        return setSafeProperty(e3, n.getObjectProperty(), i2), e3;
      }
      throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (e4) {
      throw errorTransform(e4);
    }
  };
}
var properties = [{ AssignmentNode: {}, FunctionAssignmentNode: {} }, { ConditionalNode: { latexLeftParens: false, latexRightParens: false, latexParens: false } }, { "OperatorNode:or": { op: "or", associativity: "left", associativeWith: [] } }, { "OperatorNode:xor": { op: "xor", associativity: "left", associativeWith: [] } }, { "OperatorNode:and": { op: "and", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitOr": { op: "|", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitXor": { op: "^|", associativity: "left", associativeWith: [] } }, { "OperatorNode:bitAnd": { op: "&", associativity: "left", associativeWith: [] } }, { "OperatorNode:equal": { op: "==", associativity: "left", associativeWith: [] }, "OperatorNode:unequal": { op: "!=", associativity: "left", associativeWith: [] }, "OperatorNode:smaller": { op: "<", associativity: "left", associativeWith: [] }, "OperatorNode:larger": { op: ">", associativity: "left", associativeWith: [] }, "OperatorNode:smallerEq": { op: "<=", associativity: "left", associativeWith: [] }, "OperatorNode:largerEq": { op: ">=", associativity: "left", associativeWith: [] }, RelationalNode: { associativity: "left", associativeWith: [] } }, { "OperatorNode:leftShift": { op: "<<", associativity: "left", associativeWith: [] }, "OperatorNode:rightArithShift": { op: ">>", associativity: "left", associativeWith: [] }, "OperatorNode:rightLogShift": { op: ">>>", associativity: "left", associativeWith: [] } }, { "OperatorNode:to": { op: "to", associativity: "left", associativeWith: [] } }, { RangeNode: {} }, { "OperatorNode:add": { op: "+", associativity: "left", associativeWith: ["OperatorNode:add", "OperatorNode:subtract"] }, "OperatorNode:subtract": { op: "-", associativity: "left", associativeWith: [] } }, { "OperatorNode:multiply": { op: "*", associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"] }, "OperatorNode:divide": { op: "/", associativity: "left", associativeWith: [], latexLeftParens: false, latexRightParens: false, latexParens: false }, "OperatorNode:dotMultiply": { op: ".*", associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "OperatorNode:dotMultiply", "OperatorNode:doDivide"] }, "OperatorNode:dotDivide": { op: "./", associativity: "left", associativeWith: [] }, "OperatorNode:mod": { op: "mod", associativity: "left", associativeWith: [] } }, { "OperatorNode:multiply": { associativity: "left", associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"] } }, { "OperatorNode:unaryPlus": { op: "+", associativity: "right" }, "OperatorNode:unaryMinus": { op: "-", associativity: "right" }, "OperatorNode:bitNot": { op: "~", associativity: "right" }, "OperatorNode:not": { op: "not", associativity: "right" } }, { "OperatorNode:pow": { op: "^", associativity: "right", associativeWith: [], latexRightParens: false }, "OperatorNode:dotPow": { op: ".^", associativity: "right", associativeWith: [] } }, { "OperatorNode:nullish": { op: "??", associativity: "left", associativeWith: [] } }, { "OperatorNode:factorial": { op: "!", associativity: "left" } }, { "OperatorNode:ctranspose": { op: "'", associativity: "left" } }];
function unwrapParen(e2, t2) {
  if (!t2 || "auto" !== t2) return e2;
  for (var r = e2; isParenthesisNode(r); ) r = r.content;
  return r;
}
function getPrecedence(e2, t2, r, n) {
  var i2 = e2;
  "keep" !== t2 && (i2 = e2.getContent());
  for (var a = i2.getIdentifier(), o = null, s = 0; s < properties.length; s++) if (a in properties[s]) {
    o = s;
    break;
  }
  if ("OperatorNode:multiply" === a && i2.implicit && "show" !== r) {
    var u = unwrapParen(i2.args[0], t2);
    isConstantNode(u) && n && "OperatorNode:divide" === n.getIdentifier() && rule2Node(unwrapParen(n.args[0], t2)) || "OperatorNode:divide" === u.getIdentifier() && rule2Node(unwrapParen(u.args[0], t2)) && isConstantNode(unwrapParen(u.args[1])) || (o += 1);
  }
  return o;
}
function getAssociativity(e2, t2) {
  var r = e2;
  "keep" !== t2 && (r = e2.getContent());
  var n = r.getIdentifier(), i2 = getPrecedence(r, t2);
  if (null === i2) return null;
  var a = properties[i2][n];
  if (hasOwnProperty$1$1(a, "associativity")) {
    if ("left" === a.associativity) return "left";
    if ("right" === a.associativity) return "right";
    throw Error("'" + n + "' has the invalid associativity '" + a.associativity + "'.");
  }
  return null;
}
function isAssociativeWith(e2, t2, r) {
  var n = "keep" !== r ? e2.getContent() : e2, i2 = "keep" !== r ? e2.getContent() : t2, a = n.getIdentifier(), o = i2.getIdentifier(), s = getPrecedence(n, r);
  if (null === s) return null;
  var u = properties[s][a];
  if (hasOwnProperty$1$1(u, "associativeWith") && u.associativeWith instanceof Array) {
    for (var c2 = 0; c2 < u.associativeWith.length; c2++) if (u.associativeWith[c2] === o) return true;
    return false;
  }
  return null;
}
function getOperator(e2) {
  var t2 = "OperatorNode:" + e2;
  for (var r of properties) if (t2 in r) return r[t2].op;
  return null;
}
var name$1H = "AssignmentNode", dependencies$1H = ["subset", "?matrix", "Node"], createAssignmentNode = factory(name$1H, dependencies$1H, ((e2) => {
  var { subset: t2, matrix: r, Node: n } = e2, i2 = accessFactory({ subset: t2 }), a = assignFactory({ subset: t2, matrix: r });
  function o(e3, t22, r2) {
    t22 || (t22 = "keep");
    var n3 = getPrecedence(e3, t22, r2), i22 = getPrecedence(e3.value, t22, r2);
    return "all" === t22 || null !== i22 && i22 <= n3;
  }
  class s extends n {
    constructor(e3, t22, r2) {
      if (super(), this.object = e3, this.index = r2 ? t22 : null, this.value = r2 || t22, !isSymbolNode(e3) && !isAccessorNode(e3)) throw new TypeError('SymbolNode or AccessorNode expected as "object"');
      if (isSymbolNode(e3) && "end" === e3.name) throw new Error('Cannot assign to symbol "end"');
      if (this.index && !isIndexNode(this.index)) throw new TypeError('IndexNode expected as "index"');
      if (!isNode$1(this.value)) throw new TypeError('Node expected as "value"');
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return name$1H;
    }
    get isAssignmentNode() {
      return true;
    }
    _compile(e3, t22) {
      var r2 = this.object._compile(e3, t22), n3 = this.index ? this.index._compile(e3, t22) : null, o2 = this.value._compile(e3, t22), s2 = this.object.name;
      if (this.index) {
        if (this.index.isObjectProperty()) {
          var u = this.index.getObjectProperty();
          return function(e4, t3, n4) {
            var i22 = r2(e4, t3, n4), a2 = o2(e4, t3, n4);
            return setSafeProperty(i22, u, a2), a2;
          };
        }
        if (isSymbolNode(this.object)) return function(e4, t3, i22) {
          var u2 = r2(e4, t3, i22), c3 = o2(e4, t3, i22), l2 = n3(e4, t3, u2);
          return e4.set(s2, a(u2, l2, c3)), c3;
        };
        var c2 = this.object.object._compile(e3, t22);
        if (this.object.index.isObjectProperty()) {
          var l = this.object.index.getObjectProperty();
          return function(e4, t3, r3) {
            var i22 = c2(e4, t3, r3), s3 = getSafeProperty(i22, l), u2 = n3(e4, t3, s3), f3 = o2(e4, t3, r3);
            return setSafeProperty(i22, l, a(s3, u2, f3)), f3;
          };
        }
        var f2 = this.object.index._compile(e3, t22);
        return function(e4, t3, r3) {
          var s3 = c2(e4, t3, r3), u2 = f2(e4, t3, s3), l2 = i2(s3, u2), p = n3(e4, t3, l2), m = o2(e4, t3, r3);
          return a(s3, u2, a(l2, p, m)), m;
        };
      }
      if (!isSymbolNode(this.object)) throw new TypeError("SymbolNode expected as object");
      return function(e4, t3, r3) {
        var n4 = o2(e4, t3, r3);
        return e4.set(s2, n4), n4;
      };
    }
    forEach(e3) {
      e3(this.object, "object", this), this.index && e3(this.index, "index", this), e3(this.value, "value", this);
    }
    map(e3) {
      var t22 = this._ifNode(e3(this.object, "object", this)), r2 = this.index ? this._ifNode(e3(this.index, "index", this)) : null, n3 = this._ifNode(e3(this.value, "value", this));
      return new s(t22, r2, n3);
    }
    clone() {
      return new s(this.object, this.index, this.value);
    }
    _toString(e3) {
      var t22 = this.object.toString(e3), r2 = this.index ? this.index.toString(e3) : "", n3 = this.value.toString(e3);
      return o(this, e3 && e3.parenthesis, e3 && e3.implicit) && (n3 = "(" + n3 + ")"), t22 + r2 + " = " + n3;
    }
    toJSON() {
      return { mathjs: name$1H, object: this.object, index: this.index, value: this.value };
    }
    static fromJSON(e3) {
      return new s(e3.object, e3.index, e3.value);
    }
    _toHTML(e3) {
      var t22 = this.object.toHTML(e3), r2 = this.index ? this.index.toHTML(e3) : "", n3 = this.value.toHTML(e3);
      return o(this, e3 && e3.parenthesis, e3 && e3.implicit) && (n3 = '<span class="math-paranthesis math-round-parenthesis">(</span>' + n3 + '<span class="math-paranthesis math-round-parenthesis">)</span>'), t22 + r2 + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + n3;
    }
    _toTex(e3) {
      var t22 = this.object.toTex(e3), r2 = this.index ? this.index.toTex(e3) : "", n3 = this.value.toTex(e3);
      return o(this, e3 && e3.parenthesis, e3 && e3.implicit) && (n3 = "\\left(".concat(n3, "\\right)")), t22 + r2 + "=" + n3;
    }
  }
  return _defineProperty$1(s, "name", name$1H), s;
}), { isClass: true, isNode: true }), name$1G = "BlockNode", dependencies$1G = ["ResultSet", "Node"], createBlockNode = factory(name$1G, dependencies$1G, ((e2) => {
  var { ResultSet: t2, Node: r } = e2;
  class n extends r {
    constructor(e3) {
      if (super(), !Array.isArray(e3)) throw new Error("Array expected");
      this.blocks = e3.map((function(e4) {
        var t22 = e4 && e4.node, r2 = !e4 || void 0 === e4.visible || e4.visible;
        if (!isNode$1(t22)) throw new TypeError('Property "node" must be a Node');
        if ("boolean" != typeof r2) throw new TypeError('Property "visible" must be a boolean');
        return { node: t22, visible: r2 };
      }));
    }
    get type() {
      return name$1G;
    }
    get isBlockNode() {
      return true;
    }
    _compile(e3, r2) {
      var n3 = map$1(this.blocks, (function(t22) {
        return { evaluate: t22.node._compile(e3, r2), visible: t22.visible };
      }));
      return function(e4, r3, i2) {
        var a = [];
        return forEach(n3, (function(t22) {
          var n4 = t22.evaluate(e4, r3, i2);
          t22.visible && a.push(n4);
        })), new t2(a);
      };
    }
    forEach(e3) {
      for (var t22 = 0; t22 < this.blocks.length; t22++) e3(this.blocks[t22].node, "blocks[" + t22 + "].node", this);
    }
    map(e3) {
      for (var t22 = [], r2 = 0; r2 < this.blocks.length; r2++) {
        var i2 = this.blocks[r2], a = this._ifNode(e3(i2.node, "blocks[" + r2 + "].node", this));
        t22[r2] = { node: a, visible: i2.visible };
      }
      return new n(t22);
    }
    clone() {
      var e3 = this.blocks.map((function(e4) {
        return { node: e4.node, visible: e4.visible };
      }));
      return new n(e3);
    }
    _toString(e3) {
      return this.blocks.map((function(t22) {
        return t22.node.toString(e3) + (t22.visible ? "" : ";");
      })).join("\n");
    }
    toJSON() {
      return { mathjs: name$1G, blocks: this.blocks };
    }
    static fromJSON(e3) {
      return new n(e3.blocks);
    }
    _toHTML(e3) {
      return this.blocks.map((function(t22) {
        return t22.node.toHTML(e3) + (t22.visible ? "" : '<span class="math-separator">;</span>');
      })).join('<span class="math-separator"><br /></span>');
    }
    _toTex(e3) {
      return this.blocks.map((function(t22) {
        return t22.node.toTex(e3) + (t22.visible ? "" : ";");
      })).join("\\;\\;\n");
    }
  }
  return _defineProperty$1(n, "name", name$1G), n;
}), { isClass: true, isNode: true }), name$1F = "ConditionalNode", dependencies$1F = ["Node"], createConditionalNode = factory(name$1F, dependencies$1F, ((e2) => {
  var { Node: t2 } = e2;
  class r extends t2 {
    constructor(e3, t22, r2) {
      if (super(), !isNode$1(e3)) throw new TypeError("Parameter condition must be a Node");
      if (!isNode$1(t22)) throw new TypeError("Parameter trueExpr must be a Node");
      if (!isNode$1(r2)) throw new TypeError("Parameter falseExpr must be a Node");
      this.condition = e3, this.trueExpr = t22, this.falseExpr = r2;
    }
    get type() {
      return name$1F;
    }
    get isConditionalNode() {
      return true;
    }
    _compile(e3, t22) {
      var r2 = this.condition._compile(e3, t22), n = this.trueExpr._compile(e3, t22), i2 = this.falseExpr._compile(e3, t22);
      return function(e4, t3, a) {
        return (function(e5) {
          if ("number" == typeof e5 || "boolean" == typeof e5 || "string" == typeof e5) return !!e5;
          if (e5) {
            if (isBigNumber(e5)) return !e5.isZero();
            if (isComplex(e5)) return !(!e5.re && !e5.im);
            if (isUnit(e5)) return !!e5.value;
          }
          if (null == e5) return false;
          throw new TypeError('Unsupported type of condition "' + typeOf(e5) + '"');
        })(r2(e4, t3, a)) ? n(e4, t3, a) : i2(e4, t3, a);
      };
    }
    forEach(e3) {
      e3(this.condition, "condition", this), e3(this.trueExpr, "trueExpr", this), e3(this.falseExpr, "falseExpr", this);
    }
    map(e3) {
      return new r(this._ifNode(e3(this.condition, "condition", this)), this._ifNode(e3(this.trueExpr, "trueExpr", this)), this._ifNode(e3(this.falseExpr, "falseExpr", this)));
    }
    clone() {
      return new r(this.condition, this.trueExpr, this.falseExpr);
    }
    _toString(e3) {
      var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = getPrecedence(this, t22, e3 && e3.implicit), n = this.condition.toString(e3), i2 = getPrecedence(this.condition, t22, e3 && e3.implicit);
      ("all" === t22 || "OperatorNode" === this.condition.type || null !== i2 && i2 <= r2) && (n = "(" + n + ")");
      var a = this.trueExpr.toString(e3), o = getPrecedence(this.trueExpr, t22, e3 && e3.implicit);
      ("all" === t22 || "OperatorNode" === this.trueExpr.type || null !== o && o <= r2) && (a = "(" + a + ")");
      var s = this.falseExpr.toString(e3), u = getPrecedence(this.falseExpr, t22, e3 && e3.implicit);
      return ("all" === t22 || "OperatorNode" === this.falseExpr.type || null !== u && u <= r2) && (s = "(" + s + ")"), n + " ? " + a + " : " + s;
    }
    toJSON() {
      return { mathjs: name$1F, condition: this.condition, trueExpr: this.trueExpr, falseExpr: this.falseExpr };
    }
    static fromJSON(e3) {
      return new r(e3.condition, e3.trueExpr, e3.falseExpr);
    }
    _toHTML(e3) {
      var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = getPrecedence(this, t22, e3 && e3.implicit), n = this.condition.toHTML(e3), i2 = getPrecedence(this.condition, t22, e3 && e3.implicit);
      ("all" === t22 || "OperatorNode" === this.condition.type || null !== i2 && i2 <= r2) && (n = '<span class="math-parenthesis math-round-parenthesis">(</span>' + n + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var a = this.trueExpr.toHTML(e3), o = getPrecedence(this.trueExpr, t22, e3 && e3.implicit);
      ("all" === t22 || "OperatorNode" === this.trueExpr.type || null !== o && o <= r2) && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var s = this.falseExpr.toHTML(e3), u = getPrecedence(this.falseExpr, t22, e3 && e3.implicit);
      return ("all" === t22 || "OperatorNode" === this.falseExpr.type || null !== u && u <= r2) && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), n + '<span class="math-operator math-conditional-operator">?</span>' + a + '<span class="math-operator math-conditional-operator">:</span>' + s;
    }
    _toTex(e3) {
      return "\\begin{cases} {" + this.trueExpr.toTex(e3) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(e3) + "}\\\\{" + this.falseExpr.toTex(e3) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    }
  }
  return _defineProperty$1(r, "name", name$1F), r;
}), { isClass: true, isNode: true }), dist$1, hasRequiredDist;
function requireDist() {
  if (hasRequiredDist) return dist$1;
  hasRequiredDist = 1;
  var e2 = Object.assign || function(e3) {
    for (var t22 = 1; t22 < arguments.length; t22++) {
      var r2 = arguments[t22];
      for (var n3 in r2) Object.prototype.hasOwnProperty.call(r2, n3) && (e3[n3] = r2[n3]);
    }
    return e3;
  }, t2 = { "{": "\\{", "}": "\\}", "\\": "\\textbackslash{}", "#": "\\#", $: "\\$", "%": "\\%", "&": "\\&", "^": "\\textasciicircum{}", _: "\\_", "~": "\\textasciitilde{}" }, r = { "–": "\\--", "—": "\\---", " ": "~", "	": "\\qquad{}", "\r\n": "\\newline{}", "\n": "\\newline{}" }, n = function(t22, r2) {
    return e2({}, t22, r2);
  };
  return dist$1 = function(i2) {
    for (var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o = a.preserveFormatting, s = void 0 !== o && o, u = a.escapeMapFn, c2 = void 0 === u ? n : u, l = String(i2), f2 = "", p = c2(e2({}, t2), s ? e2({}, r) : {}), m = Object.keys(p), d = function() {
      var e3 = false;
      m.forEach((function(t22, r2) {
        e3 || l.length >= t22.length && l.slice(0, t22.length) === t22 && (f2 += p[m[r2]], l = l.slice(t22.length, l.length), e3 = true);
      })), e3 || (f2 += l.slice(0, 1), l = l.slice(1, l.length));
    }; l; ) d();
    return f2;
  }, dist$1;
}
var distExports = requireDist(), escapeLatexLib = getDefaultExportFromCjs$2(distExports), latexSymbols = { Alpha: "A", alpha: "\\alpha", Beta: "B", beta: "\\beta", Gamma: "\\Gamma", gamma: "\\gamma", Delta: "\\Delta", delta: "\\delta", Epsilon: "E", epsilon: "\\epsilon", varepsilon: "\\varepsilon", Zeta: "Z", zeta: "\\zeta", Eta: "H", eta: "\\eta", Theta: "\\Theta", theta: "\\theta", vartheta: "\\vartheta", Iota: "I", iota: "\\iota", Kappa: "K", kappa: "\\kappa", varkappa: "\\varkappa", Lambda: "\\Lambda", lambda: "\\lambda", Mu: "M", mu: "\\mu", Nu: "N", nu: "\\nu", Xi: "\\Xi", xi: "\\xi", Omicron: "O", omicron: "o", Pi: "\\Pi", pi: "\\pi", varpi: "\\varpi", Rho: "P", rho: "\\rho", varrho: "\\varrho", Sigma: "\\Sigma", sigma: "\\sigma", varsigma: "\\varsigma", Tau: "T", tau: "\\tau", Upsilon: "\\Upsilon", upsilon: "\\upsilon", Phi: "\\Phi", phi: "\\phi", varphi: "\\varphi", Chi: "X", chi: "\\chi", Psi: "\\Psi", psi: "\\psi", Omega: "\\Omega", omega: "\\omega", true: "\\mathrm{True}", false: "\\mathrm{False}", i: "i", inf: "\\infty", Inf: "\\infty", infinity: "\\infty", Infinity: "\\infty", oo: "\\infty", lim: "\\lim", undefined: "\\mathbf{?}" }, latexOperators = { transpose: "^\\top", ctranspose: "^H", factorial: "!", pow: "^", dotPow: ".^\\wedge", unaryPlus: "+", unaryMinus: "-", bitNot: "\\~", not: "\\neg", multiply: "\\cdot", divide: "\\frac", dotMultiply: ".\\cdot", dotDivide: ".:", mod: "\\mod", add: "+", subtract: "-", to: "\\rightarrow", leftShift: "<<", rightArithShift: ">>", rightLogShift: ">>>", equal: "=", unequal: "\\neq", smaller: "<", larger: ">", smallerEq: "\\leq", largerEq: "\\geq", bitAnd: "\\&", bitXor: "\\underline{|}", bitOr: "|", and: "\\wedge", xor: "\\veebar", or: "\\vee" }, latexFunctions = { abs: { 1: "\\left|${args[0]}\\right|" }, add: { 2: "\\left(${args[0]}".concat(latexOperators.add, "${args[1]}\\right)") }, cbrt: { 1: "\\sqrt[3]{${args[0]}}" }, ceil: { 1: "\\left\\lceil${args[0]}\\right\\rceil" }, cube: { 1: "\\left(${args[0]}\\right)^3" }, divide: { 2: "\\frac{${args[0]}}{${args[1]}}" }, dotDivide: { 2: "\\left(${args[0]}".concat(latexOperators.dotDivide, "${args[1]}\\right)") }, dotMultiply: { 2: "\\left(${args[0]}".concat(latexOperators.dotMultiply, "${args[1]}\\right)") }, dotPow: { 2: "\\left(${args[0]}".concat(latexOperators.dotPow, "${args[1]}\\right)") }, exp: { 1: "\\exp\\left(${args[0]}\\right)" }, expm1: "\\left(e".concat(latexOperators.pow, "{${args[0]}}-1\\right)"), fix: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, floor: { 1: "\\left\\lfloor${args[0]}\\right\\rfloor" }, fraction: { 2: "\\frac{${args[0]}}{${args[1]}}" }, gcd: "\\gcd\\left(${args}\\right)", hypot: "\\hypot\\left(${args}\\right)", log: { 1: "\\ln\\left(${args[0]}\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}\\right)" }, log10: { 1: "\\log_{10}\\left(${args[0]}\\right)" }, log1p: { 1: "\\ln\\left(${args[0]}+1\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)" }, log2: "\\log_{2}\\left(${args[0]}\\right)", mod: { 2: "\\left(${args[0]}".concat(latexOperators.mod, "${args[1]}\\right)") }, multiply: { 2: "\\left(${args[0]}".concat(latexOperators.multiply, "${args[1]}\\right)") }, norm: { 1: "\\left\\|${args[0]}\\right\\|", 2: void 0 }, nthRoot: { 2: "\\sqrt[${args[1]}]{${args[0]}}" }, nthRoots: { 2: "\\{y : y^${args[1]} = {${args[0]}}\\}" }, pow: { 2: "\\left(${args[0]}\\right)".concat(latexOperators.pow, "{${args[1]}}") }, round: { 1: "\\left\\lfloor${args[0]}\\right\\rceil", 2: void 0 }, sign: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, sqrt: { 1: "\\sqrt{${args[0]}}" }, square: { 1: "\\left(${args[0]}\\right)^2" }, subtract: { 2: "\\left(${args[0]}".concat(latexOperators.subtract, "${args[1]}\\right)") }, unaryMinus: { 1: "".concat(latexOperators.unaryMinus, "\\left(${args[0]}\\right)") }, unaryPlus: { 1: "".concat(latexOperators.unaryPlus, "\\left(${args[0]}\\right)") }, bitAnd: { 2: "\\left(${args[0]}".concat(latexOperators.bitAnd, "${args[1]}\\right)") }, bitNot: { 1: latexOperators.bitNot + "\\left(${args[0]}\\right)" }, bitOr: { 2: "\\left(${args[0]}".concat(latexOperators.bitOr, "${args[1]}\\right)") }, bitXor: { 2: "\\left(${args[0]}".concat(latexOperators.bitXor, "${args[1]}\\right)") }, leftShift: { 2: "\\left(${args[0]}".concat(latexOperators.leftShift, "${args[1]}\\right)") }, rightArithShift: { 2: "\\left(${args[0]}".concat(latexOperators.rightArithShift, "${args[1]}\\right)") }, rightLogShift: { 2: "\\left(${args[0]}".concat(latexOperators.rightLogShift, "${args[1]}\\right)") }, bellNumbers: { 1: "\\mathrm{B}_{${args[0]}}" }, catalan: { 1: "\\mathrm{C}_{${args[0]}}" }, stirlingS2: { 2: "\\mathrm{S}\\left(${args}\\right)" }, arg: { 1: "\\arg\\left(${args[0]}\\right)" }, conj: { 1: "\\left(${args[0]}\\right)^*" }, im: { 1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace" }, re: { 1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace" }, and: { 2: "\\left(${args[0]}".concat(latexOperators.and, "${args[1]}\\right)") }, not: { 1: latexOperators.not + "\\left(${args[0]}\\right)" }, or: { 2: "\\left(${args[0]}".concat(latexOperators.or, "${args[1]}\\right)") }, xor: { 2: "\\left(${args[0]}".concat(latexOperators.xor, "${args[1]}\\right)") }, cross: { 2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)" }, ctranspose: { 1: "\\left(${args[0]}\\right)".concat(latexOperators.ctranspose) }, det: { 1: "\\det\\left(${args[0]}\\right)" }, dot: { 2: "\\left(${args[0]}\\cdot${args[1]}\\right)" }, expm: { 1: "\\exp\\left(${args[0]}\\right)" }, inv: { 1: "\\left(${args[0]}\\right)^{-1}" }, pinv: { 1: "\\left(${args[0]}\\right)^{+}" }, sqrtm: { 1: "{${args[0]}}".concat(latexOperators.pow, "{\\frac{1}{2}}") }, trace: { 1: "\\mathrm{tr}\\left(${args[0]}\\right)" }, transpose: { 1: "\\left(${args[0]}\\right)".concat(latexOperators.transpose) }, combinations: { 2: "\\binom{${args[0]}}{${args[1]}}" }, combinationsWithRep: { 2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)" }, factorial: { 1: "\\left(${args[0]}\\right)".concat(latexOperators.factorial) }, gamma: { 1: "\\Gamma\\left(${args[0]}\\right)" }, lgamma: { 1: "\\ln\\Gamma\\left(${args[0]}\\right)" }, equal: { 2: "\\left(${args[0]}".concat(latexOperators.equal, "${args[1]}\\right)") }, larger: { 2: "\\left(${args[0]}".concat(latexOperators.larger, "${args[1]}\\right)") }, largerEq: { 2: "\\left(${args[0]}".concat(latexOperators.largerEq, "${args[1]}\\right)") }, smaller: { 2: "\\left(${args[0]}".concat(latexOperators.smaller, "${args[1]}\\right)") }, smallerEq: { 2: "\\left(${args[0]}".concat(latexOperators.smallerEq, "${args[1]}\\right)") }, unequal: { 2: "\\left(${args[0]}".concat(latexOperators.unequal, "${args[1]}\\right)") }, erf: { 1: "erf\\left(${args[0]}\\right)" }, max: "\\max\\left(${args}\\right)", min: "\\min\\left(${args}\\right)", variance: "\\mathrm{Var}\\left(${args}\\right)", acos: { 1: "\\cos^{-1}\\left(${args[0]}\\right)" }, acosh: { 1: "\\cosh^{-1}\\left(${args[0]}\\right)" }, acot: { 1: "\\cot^{-1}\\left(${args[0]}\\right)" }, acoth: { 1: "\\coth^{-1}\\left(${args[0]}\\right)" }, acsc: { 1: "\\csc^{-1}\\left(${args[0]}\\right)" }, acsch: { 1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)" }, asec: { 1: "\\sec^{-1}\\left(${args[0]}\\right)" }, asech: { 1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)" }, asin: { 1: "\\sin^{-1}\\left(${args[0]}\\right)" }, asinh: { 1: "\\sinh^{-1}\\left(${args[0]}\\right)" }, atan: { 1: "\\tan^{-1}\\left(${args[0]}\\right)" }, atan2: { 2: "\\mathrm{atan2}\\left(${args}\\right)" }, atanh: { 1: "\\tanh^{-1}\\left(${args[0]}\\right)" }, cos: { 1: "\\cos\\left(${args[0]}\\right)" }, cosh: { 1: "\\cosh\\left(${args[0]}\\right)" }, cot: { 1: "\\cot\\left(${args[0]}\\right)" }, coth: { 1: "\\coth\\left(${args[0]}\\right)" }, csc: { 1: "\\csc\\left(${args[0]}\\right)" }, csch: { 1: "\\mathrm{csch}\\left(${args[0]}\\right)" }, sec: { 1: "\\sec\\left(${args[0]}\\right)" }, sech: { 1: "\\mathrm{sech}\\left(${args[0]}\\right)" }, sin: { 1: "\\sin\\left(${args[0]}\\right)" }, sinh: { 1: "\\sinh\\left(${args[0]}\\right)" }, tan: { 1: "\\tan\\left(${args[0]}\\right)" }, tanh: { 1: "\\tanh\\left(${args[0]}\\right)" }, to: { 2: "\\left(${args[0]}".concat(latexOperators.to, "${args[1]}\\right)") }, numeric: function(e2, t2) {
  return e2.args[0].toTex();
}, number: { 0: "0", 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" }, string: { 0: '\\mathtt{""}', 1: "\\mathrm{string}\\left(${args[0]}\\right)" }, bignumber: { 0: "0", 1: "\\left(${args[0]}\\right)" }, bigint: { 0: "0", 1: "\\left(${args[0]}\\right)" }, complex: { 0: "0", 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)+".concat(latexSymbols.i, "\\cdot\\left(${args[1]}\\right)\\right)") }, matrix: { 0: "\\begin{bmatrix}\\end{bmatrix}", 1: "\\left(${args[0]}\\right)", 2: "\\left(${args[0]}\\right)" }, sparse: { 0: "\\begin{bsparse}\\end{bsparse}", 1: "\\left(${args[0]}\\right)" }, unit: { 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" } }, defaultTemplate = "\\mathrm{${name}}\\left(${args}\\right)", latexUnits = { deg: "^\\circ" };
function escapeLatex(e2) {
  return escapeLatexLib(e2, { preserveFormatting: true });
}
function toSymbol(e2, t2) {
  return (t2 = void 0 !== t2 && t2) ? hasOwnProperty$1$1(latexUnits, e2) ? latexUnits[e2] : "\\mathrm{" + escapeLatex(e2) + "}" : hasOwnProperty$1$1(latexSymbols, e2) ? latexSymbols[e2] : escapeLatex(e2);
}
var name$1E = "ConstantNode", dependencies$1E = ["Node", "isBounded"], createConstantNode = factory(name$1E, dependencies$1E, ((e2) => {
  var { Node: t2, isBounded: r } = e2;
  class n extends t2 {
    constructor(e3) {
      super(), this.value = e3;
    }
    get type() {
      return name$1E;
    }
    get isConstantNode() {
      return true;
    }
    _compile(e3, t22) {
      var r2 = this.value;
      return function() {
        return r2;
      };
    }
    forEach(e3) {
    }
    map(e3) {
      return this.clone();
    }
    clone() {
      return new n(this.value);
    }
    _toString(e3) {
      return format(this.value, e3);
    }
    _toHTML(e3) {
      var t22 = this._toString(e3);
      switch (typeOf(this.value)) {
        case "number":
        case "bigint":
        case "BigNumber":
        case "Fraction":
          return '<span class="math-number">' + t22 + "</span>";
        case "string":
          return '<span class="math-string">' + t22 + "</span>";
        case "boolean":
          return '<span class="math-boolean">' + t22 + "</span>";
        case "null":
          return '<span class="math-null-symbol">' + t22 + "</span>";
        case "undefined":
          return '<span class="math-undefined">' + t22 + "</span>";
        default:
          return '<span class="math-symbol">' + t22 + "</span>";
      }
    }
    toJSON() {
      return { mathjs: name$1E, value: this.value };
    }
    static fromJSON(e3) {
      return new n(e3.value);
    }
    _toTex(e3) {
      var t22 = this._toString(e3);
      switch (typeOf(this.value)) {
        case "string":
          return "\\mathtt{" + escapeLatex(t22) + "}";
        case "number":
        case "BigNumber":
          if (!r(this.value)) return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
          var n3 = t22.toLowerCase().indexOf("e");
          return -1 !== n3 ? t22.substring(0, n3) + "\\cdot10^{" + t22.substring(n3 + 1) + "}" : t22;
        case "bigint":
          return t22.toString();
        case "Fraction":
          return this.value.toLatex();
        default:
          return t22;
      }
    }
  }
  return _defineProperty$1(n, "name", name$1E), n;
}), { isClass: true, isNode: true }), name$1D = "FunctionAssignmentNode", dependencies$1D = ["typed", "Node"], createFunctionAssignmentNode = factory(name$1D, dependencies$1D, ((e2) => {
  var { typed: t2, Node: r } = e2;
  function n(e3, t22, r2) {
    var n3 = getPrecedence(e3, t22, r2), i22 = getPrecedence(e3.expr, t22, r2);
    return "all" === t22 || null !== i22 && i22 <= n3;
  }
  class i2 extends r {
    constructor(e3, t22, r2) {
      if (super(), "string" != typeof e3) throw new TypeError('String expected for parameter "name"');
      if (!Array.isArray(t22)) throw new TypeError('Array containing strings or objects expected for parameter "params"');
      if (!isNode$1(r2)) throw new TypeError('Node expected for parameter "expr"');
      if (keywords.has(e3)) throw new Error('Illegal function name, "' + e3 + '" is a reserved keyword');
      var n3 = /* @__PURE__ */ new Set();
      for (var i22 of t22) {
        var a = "string" == typeof i22 ? i22 : i22.name;
        if (n3.has(a)) throw new Error('Duplicate parameter name "'.concat(a, '"'));
        n3.add(a);
      }
      this.name = e3, this.params = t22.map((function(e4) {
        return e4 && e4.name || e4;
      })), this.types = t22.map((function(e4) {
        return e4 && e4.type || "any";
      })), this.expr = r2;
    }
    get type() {
      return name$1D;
    }
    get isFunctionAssignmentNode() {
      return true;
    }
    _compile(e3, r2) {
      var n3 = Object.create(r2);
      forEach(this.params, (function(e4) {
        n3[e4] = true;
      }));
      var i22 = this.expr, a = i22._compile(e3, n3), o = this.name, s = this.params, u = join$3(this.types, ","), c2 = o + "(" + join$3(this.params, ", ") + ")";
      return function(e4, r3, n4) {
        var l = {};
        l[u] = function() {
          for (var t22 = Object.create(r3), i3 = 0; i3 < s.length; i3++) t22[s[i3]] = arguments[i3];
          return a(e4, t22, n4);
        };
        var f2 = t2(o, l);
        return f2.syntax = c2, f2.expr = i22.toString(), e4.set(o, f2), f2;
      };
    }
    forEach(e3) {
      e3(this.expr, "expr", this);
    }
    map(e3) {
      var t22 = this._ifNode(e3(this.expr, "expr", this));
      return new i2(this.name, this.params.slice(0), t22);
    }
    clone() {
      return new i2(this.name, this.params.slice(0), this.expr);
    }
    _toString(e3) {
      var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = this.expr.toString(e3);
      return n(this, t22, e3 && e3.implicit) && (r2 = "(" + r2 + ")"), this.name + "(" + this.params.join(", ") + ") = " + r2;
    }
    toJSON() {
      var e3 = this.types;
      return { mathjs: name$1D, name: this.name, params: this.params.map((function(t22, r2) {
        return { name: t22, type: e3[r2] };
      })), expr: this.expr };
    }
    static fromJSON(e3) {
      return new i2(e3.name, e3.params, e3.expr);
    }
    _toHTML(e3) {
      for (var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = [], i22 = 0; i22 < this.params.length; i22++) r2.push('<span class="math-symbol math-parameter">' + escape$1(this.params[i22]) + "</span>");
      var a = this.expr.toHTML(e3);
      return n(this, t22, e3 && e3.implicit) && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>'), '<span class="math-function">' + escape$1(this.name) + '</span><span class="math-parenthesis math-round-parenthesis">(</span>' + r2.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + a;
    }
    _toTex(e3) {
      var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = this.expr.toTex(e3);
      return n(this, t22, e3 && e3.implicit) && (r2 = "\\left(".concat(r2, "\\right)")), "\\mathrm{" + this.name + "}\\left(" + this.params.map(toSymbol).join(",") + "\\right)=" + r2;
    }
  }
  return _defineProperty$1(i2, "name", name$1D), i2;
}), { isClass: true, isNode: true }), name$1C = "IndexNode", dependencies$1C = ["Node", "size"], createIndexNode = factory(name$1C, dependencies$1C, ((e2) => {
  var { Node: t2, size: r } = e2;
  class n extends t2 {
    constructor(e3, t22) {
      if (super(), this.dimensions = e3, this.dotNotation = t22 || false, !Array.isArray(e3) || !e3.every(isNode$1)) throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
      if (this.dotNotation && !this.isObjectProperty()) throw new Error("dotNotation only applicable for object properties");
    }
    get type() {
      return name$1C;
    }
    get isIndexNode() {
      return true;
    }
    _compile(e3, t22) {
      var n3 = map$1(this.dimensions, (function(n4, i22) {
        if (n4.filter(((e4) => e4.isSymbolNode && "end" === e4.name)).length > 0) {
          var a = Object.create(t22);
          a.end = true;
          var o = n4._compile(e3, a);
          return function(e4, t3, n5) {
            if (!isMatrix(n5) && !isArray$1(n5) && !isString$1(n5)) throw new TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + typeOf(n5));
            var a2 = r(n5), s = Object.create(t3);
            return s.end = a2[i22], o(e4, s, n5);
          };
        }
        return n4._compile(e3, t22);
      })), i2 = getSafeProperty(e3, "index");
      return function(e4, t3, r2) {
        var a = map$1(n3, (function(n4) {
          return n4(e4, t3, r2);
        }));
        return i2(...a);
      };
    }
    forEach(e3) {
      for (var t22 = 0; t22 < this.dimensions.length; t22++) e3(this.dimensions[t22], "dimensions[" + t22 + "]", this);
    }
    map(e3) {
      for (var t22 = [], r2 = 0; r2 < this.dimensions.length; r2++) t22[r2] = this._ifNode(e3(this.dimensions[r2], "dimensions[" + r2 + "]", this));
      return new n(t22, this.dotNotation);
    }
    clone() {
      return new n(this.dimensions.slice(0), this.dotNotation);
    }
    isObjectProperty() {
      return 1 === this.dimensions.length && isConstantNode(this.dimensions[0]) && "string" == typeof this.dimensions[0].value;
    }
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    _toString(e3) {
      return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    }
    toJSON() {
      return { mathjs: name$1C, dimensions: this.dimensions, dotNotation: this.dotNotation };
    }
    static fromJSON(e3) {
      return new n(e3.dimensions, e3.dotNotation);
    }
    _toHTML(e3) {
      for (var t22 = [], r2 = 0; r2 < this.dimensions.length; r2++) t22[r2] = this.dimensions[r2].toHTML();
      return this.dotNotation ? '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + escape$1(this.getObjectProperty()) + "</span>" : '<span class="math-parenthesis math-square-parenthesis">[</span>' + t22.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    _toTex(e3) {
      var t22 = this.dimensions.map((function(t3) {
        return t3.toTex(e3);
      }));
      return this.dotNotation ? "." + this.getObjectProperty() : "_{" + t22.join(",") + "}";
    }
  }
  return _defineProperty$1(n, "name", name$1C), n;
}), { isClass: true, isNode: true }), name$1B = "ObjectNode", dependencies$1B = ["Node"], createObjectNode = factory(name$1B, dependencies$1B, ((e2) => {
  var { Node: t2 } = e2;
  class r extends t2 {
    constructor(e3) {
      if (super(), this.properties = e3 || {}, e3 && ("object" != typeof e3 || !Object.keys(e3).every((function(t22) {
        return isNode$1(e3[t22]);
      })))) throw new TypeError("Object containing Nodes expected");
    }
    get type() {
      return name$1B;
    }
    get isObjectNode() {
      return true;
    }
    _compile(e3, t22) {
      var r2 = {};
      for (var n in this.properties) if (hasOwnProperty$1$1(this.properties, n)) {
        var i2 = stringify(n), a = JSON.parse(i2), o = getSafeProperty(this.properties, n);
        r2[a] = o._compile(e3, t22);
      }
      return function(e4, t3, n3) {
        var i22 = {};
        for (var a2 in r2) hasOwnProperty$1$1(r2, a2) && (i22[a2] = r2[a2](e4, t3, n3));
        return i22;
      };
    }
    forEach(e3) {
      for (var t22 in this.properties) hasOwnProperty$1$1(this.properties, t22) && e3(this.properties[t22], "properties[" + stringify(t22) + "]", this);
    }
    map(e3) {
      var t22 = {};
      for (var n in this.properties) hasOwnProperty$1$1(this.properties, n) && (t22[n] = this._ifNode(e3(this.properties[n], "properties[" + stringify(n) + "]", this)));
      return new r(t22);
    }
    clone() {
      var e3 = {};
      for (var t22 in this.properties) hasOwnProperty$1$1(this.properties, t22) && (e3[t22] = this.properties[t22]);
      return new r(e3);
    }
    _toString(e3) {
      var t22 = [];
      for (var r2 in this.properties) hasOwnProperty$1$1(this.properties, r2) && t22.push(stringify(r2) + ": " + this.properties[r2].toString(e3));
      return "{" + t22.join(", ") + "}";
    }
    toJSON() {
      return { mathjs: name$1B, properties: this.properties };
    }
    static fromJSON(e3) {
      return new r(e3.properties);
    }
    _toHTML(e3) {
      var t22 = [];
      for (var r2 in this.properties) hasOwnProperty$1$1(this.properties, r2) && t22.push('<span class="math-symbol math-property">' + escape$1(r2) + '</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[r2].toHTML(e3));
      return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + t22.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    }
    _toTex(e3) {
      var t22 = [];
      for (var r2 in this.properties) hasOwnProperty$1$1(this.properties, r2) && t22.push("\\mathbf{" + r2 + ":} & " + this.properties[r2].toTex(e3) + "\\\\");
      return "\\left\\{\\begin{array}{ll}" + t22.join("\n") + "\\end{array}\\right\\}";
    }
  }
  return _defineProperty$1(r, "name", name$1B), r;
}), { isClass: true, isNode: true });
function createSubScope(e2, t2) {
  return new PartitionedMap(e2, new ObjectWrappingMap(t2), new Set(Object.keys(t2)));
}
var name$1A = "OperatorNode", dependencies$1A = ["Node"], createOperatorNode = factory(name$1A, dependencies$1A, ((e2) => {
  var { Node: t2 } = e2;
  function r(e3, t22) {
    var n3 = e3;
    if ("auto" === t22) for (; isParenthesisNode(n3); ) n3 = n3.content;
    return !!isConstantNode(n3) || !!isOperatorNode(n3) && r(n3.args[0], t22);
  }
  function n(e3, t22, n3, i22, a) {
    var o, s = getPrecedence(e3, t22, n3), u = getAssociativity(e3, t22);
    if ("all" === t22 || i22.length > 2 && "OperatorNode:add" !== e3.getIdentifier() && "OperatorNode:multiply" !== e3.getIdentifier()) return i22.map((function(e4) {
      switch (e4.getContent().type) {
        case "ArrayNode":
        case "ConstantNode":
        case "SymbolNode":
        case "ParenthesisNode":
          return false;
        default:
          return true;
      }
    }));
    switch (i22.length) {
      case 0:
        o = [];
        break;
      case 1:
        var c2 = getPrecedence(i22[0], t22, n3, e3);
        if (a && null !== c2) {
          var l, f2;
          if ("keep" === t22 ? (l = i22[0].getIdentifier(), f2 = e3.getIdentifier()) : (l = i22[0].getContent().getIdentifier(), f2 = e3.getContent().getIdentifier()), false === properties[s][f2].latexLeftParens) {
            o = [false];
            break;
          }
          if (false === properties[c2][l].latexParens) {
            o = [false];
            break;
          }
        }
        if (null === c2) {
          o = [false];
          break;
        }
        if (c2 <= s) {
          o = [true];
          break;
        }
        o = [false];
        break;
      case 2:
        var p, m, d = getPrecedence(i22[0], t22, n3, e3), h = isAssociativeWith(e3, i22[0], t22);
        p = null !== d && (d === s && "right" === u && !h || d < s);
        var g, y, v2, x2 = getPrecedence(i22[1], t22, n3, e3), b2 = isAssociativeWith(e3, i22[1], t22);
        if (m = null !== x2 && (x2 === s && "left" === u && !b2 || x2 < s), a) "keep" === t22 ? (g = e3.getIdentifier(), y = e3.args[0].getIdentifier(), v2 = e3.args[1].getIdentifier()) : (g = e3.getContent().getIdentifier(), y = e3.args[0].getContent().getIdentifier(), v2 = e3.args[1].getContent().getIdentifier()), null !== d && (false === properties[s][g].latexLeftParens && (p = false), false === properties[d][y].latexParens && (p = false)), null !== x2 && (false === properties[s][g].latexRightParens && (m = false), false === properties[x2][v2].latexParens && (m = false));
        o = [p, m];
        break;
      default:
        "OperatorNode:add" !== e3.getIdentifier() && "OperatorNode:multiply" !== e3.getIdentifier() || (o = i22.map((function(r2) {
          var i3 = getPrecedence(r2, t22, n3, e3), a2 = isAssociativeWith(e3, r2, t22), o2 = getAssociativity(r2, t22);
          return null !== i3 && (s === i3 && u === o2 && !a2 || i3 < s);
        })));
    }
    if (i22.length >= 2 && "OperatorNode:multiply" === e3.getIdentifier() && e3.implicit && "all" !== t22 && "hide" === n3) for (var _2 = 1; _2 < o.length; ++_2) !r(i22[_2], t22) || o[_2 - 1] || "keep" === t22 && isParenthesisNode(i22[_2 - 1]) || (o[_2] = true);
    return o;
  }
  class i2 extends t2 {
    constructor(e3, t22, r2, n3, i22) {
      if (super(), "string" != typeof e3) throw new TypeError('string expected for parameter "op"');
      if ("string" != typeof t22) throw new TypeError('string expected for parameter "fn"');
      if (!Array.isArray(r2) || !r2.every(isNode$1)) throw new TypeError('Array containing Nodes expected for parameter "args"');
      this.implicit = true === n3, this.isPercentage = true === i22, this.op = e3, this.fn = t22, this.args = r2 || [];
    }
    get type() {
      return name$1A;
    }
    get isOperatorNode() {
      return true;
    }
    _compile(e3, t22) {
      if ("string" != typeof this.fn || !isSafeMethod(e3, this.fn)) throw e3[this.fn] ? new Error('No access to function "' + this.fn + '"') : new Error("Function " + this.fn + ' missing in provided namespace "math"');
      var r2 = getSafeProperty(e3, this.fn), n3 = map$1(this.args, (function(r3) {
        return r3._compile(e3, t22);
      }));
      if ("function" == typeof r2 && true === r2.rawArgs) {
        var i22 = this.args;
        return function(t3, n4, a2) {
          return r2(i22, e3, createSubScope(t3, n4));
        };
      }
      if (1 === n3.length) {
        var a = n3[0];
        return function(e4, t3, n4) {
          return r2(a(e4, t3, n4));
        };
      }
      if (2 === n3.length) {
        var o = n3[0], s = n3[1];
        return function(e4, t3, n4) {
          return r2(o(e4, t3, n4), s(e4, t3, n4));
        };
      }
      return function(e4, t3, i3) {
        return r2.apply(null, map$1(n3, (function(r3) {
          return r3(e4, t3, i3);
        })));
      };
    }
    forEach(e3) {
      for (var t22 = 0; t22 < this.args.length; t22++) e3(this.args[t22], "args[" + t22 + "]", this);
    }
    map(e3) {
      for (var t22 = [], r2 = 0; r2 < this.args.length; r2++) t22[r2] = this._ifNode(e3(this.args[r2], "args[" + r2 + "]", this));
      return new i2(this.op, this.fn, t22, this.implicit, this.isPercentage);
    }
    clone() {
      return new i2(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    isUnary() {
      return 1 === this.args.length;
    }
    isBinary() {
      return 2 === this.args.length;
    }
    _toString(e3) {
      var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = e3 && e3.implicit ? e3.implicit : "hide", i22 = this.args, a = n(this, t22, r2, i22, false);
      if (1 === i22.length) {
        var o = getAssociativity(this, t22), s = i22[0].toString(e3);
        a[0] && (s = "(" + s + ")");
        var u = /[a-zA-Z]+/.test(this.op);
        return "right" === o ? this.op + (u ? " " : "") + s : "left" === o ? s + (u ? " " : "") + this.op : s + this.op;
      }
      if (2 === i22.length) {
        var c2 = i22[0].toString(e3), l = i22[1].toString(e3);
        return a[0] && (c2 = "(" + c2 + ")"), a[1] && (l = "(" + l + ")"), this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r2 ? c2 + " " + l : c2 + " " + this.op + " " + l;
      }
      if (i22.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier())) {
        var f2 = i22.map((function(t3, r3) {
          return t3 = t3.toString(e3), a[r3] && (t3 = "(" + t3 + ")"), t3;
        }));
        return this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r2 ? f2.join(" ") : f2.join(" " + this.op + " ");
      }
      return this.fn + "(" + this.args.join(", ") + ")";
    }
    toJSON() {
      return { mathjs: name$1A, op: this.op, fn: this.fn, args: this.args, implicit: this.implicit, isPercentage: this.isPercentage };
    }
    static fromJSON(e3) {
      return new i2(e3.op, e3.fn, e3.args, e3.implicit, e3.isPercentage);
    }
    _toHTML(e3) {
      var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = e3 && e3.implicit ? e3.implicit : "hide", i22 = this.args, a = n(this, t22, r2, i22, false);
      if (1 === i22.length) {
        var o = getAssociativity(this, t22), s = i22[0].toHTML(e3);
        return a[0] && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), "right" === o ? '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + escape$1(this.op) + "</span>" + s : s + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + escape$1(this.op) + "</span>";
      }
      if (2 === i22.length) {
        var u = i22[0].toHTML(e3), c2 = i22[1].toHTML(e3);
        return a[0] && (u = '<span class="math-parenthesis math-round-parenthesis">(</span>' + u + '<span class="math-parenthesis math-round-parenthesis">)</span>'), a[1] && (c2 = '<span class="math-parenthesis math-round-parenthesis">(</span>' + c2 + '<span class="math-parenthesis math-round-parenthesis">)</span>'), this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r2 ? u + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + c2 : u + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape$1(this.op) + "</span>" + c2;
      }
      var l = i22.map((function(t3, r3) {
        return t3 = t3.toHTML(e3), a[r3] && (t3 = '<span class="math-parenthesis math-round-parenthesis">(</span>' + t3 + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t3;
      }));
      return i22.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier()) ? this.implicit && "OperatorNode:multiply" === this.getIdentifier() && "hide" === r2 ? l.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>') : l.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape$1(this.op) + "</span>") : '<span class="math-function">' + escape$1(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + l.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
    _toTex(e3) {
      var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = e3 && e3.implicit ? e3.implicit : "hide", i22 = this.args, a = n(this, t22, r2, i22, true), o = latexOperators[this.fn];
      if (o = void 0 === o ? this.op : o, 1 === i22.length) {
        var s = getAssociativity(this, t22), u = i22[0].toTex(e3);
        return a[0] && (u = "\\left(".concat(u, "\\right)")), "right" === s ? o + u : u + o;
      }
      if (2 === i22.length) {
        var c2 = i22[0], l = c2.toTex(e3);
        a[0] && (l = "\\left(".concat(l, "\\right)"));
        var f2, p = i22[1].toTex(e3);
        switch (a[1] && (p = "\\left(".concat(p, "\\right)")), f2 = "keep" === t22 ? c2.getIdentifier() : c2.getContent().getIdentifier(), this.getIdentifier()) {
          case "OperatorNode:divide":
            return o + "{" + l + "}{" + p + "}";
          case "OperatorNode:pow":
            switch (l = "{" + l + "}", p = "{" + p + "}", f2) {
              case "ConditionalNode":
              case "OperatorNode:divide":
                l = "\\left(".concat(l, "\\right)");
            }
            break;
          case "OperatorNode:multiply":
            if (this.implicit && "hide" === r2) return l + "~" + p;
        }
        return l + o + p;
      }
      if (i22.length > 2 && ("OperatorNode:add" === this.getIdentifier() || "OperatorNode:multiply" === this.getIdentifier())) {
        var m = i22.map((function(t3, r3) {
          return t3 = t3.toTex(e3), a[r3] && (t3 = "\\left(".concat(t3, "\\right)")), t3;
        }));
        return "OperatorNode:multiply" === this.getIdentifier() && this.implicit && "hide" === r2 ? m.join("~") : m.join(o);
      }
      return "\\mathrm{" + this.fn + "}\\left(" + i22.map((function(t3) {
        return t3.toTex(e3);
      })).join(",") + "\\right)";
    }
    getIdentifier() {
      return this.type + ":" + this.fn;
    }
  }
  return _defineProperty$1(i2, "name", name$1A), i2;
}), { isClass: true, isNode: true }), name$1z = "ParenthesisNode", dependencies$1z = ["Node"], createParenthesisNode = factory(name$1z, dependencies$1z, ((e2) => {
  var { Node: t2 } = e2;
  class r extends t2 {
    constructor(e3) {
      if (super(), !isNode$1(e3)) throw new TypeError('Node expected for parameter "content"');
      this.content = e3;
    }
    get type() {
      return name$1z;
    }
    get isParenthesisNode() {
      return true;
    }
    _compile(e3, t22) {
      return this.content._compile(e3, t22);
    }
    getContent() {
      return this.content.getContent();
    }
    forEach(e3) {
      e3(this.content, "content", this);
    }
    map(e3) {
      var t22 = e3(this.content, "content", this);
      return new r(t22);
    }
    clone() {
      return new r(this.content);
    }
    _toString(e3) {
      return !e3 || e3 && !e3.parenthesis || e3 && "keep" === e3.parenthesis ? "(" + this.content.toString(e3) + ")" : this.content.toString(e3);
    }
    toJSON() {
      return { mathjs: name$1z, content: this.content };
    }
    static fromJSON(e3) {
      return new r(e3.content);
    }
    _toHTML(e3) {
      return !e3 || e3 && !e3.parenthesis || e3 && "keep" === e3.parenthesis ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(e3) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : this.content.toHTML(e3);
    }
    _toTex(e3) {
      return !e3 || e3 && !e3.parenthesis || e3 && "keep" === e3.parenthesis ? "\\left(".concat(this.content.toTex(e3), "\\right)") : this.content.toTex(e3);
    }
  }
  return _defineProperty$1(r, "name", name$1z), r;
}), { isClass: true, isNode: true }), name$1y = "RangeNode", dependencies$1y = ["Node"], createRangeNode = factory(name$1y, dependencies$1y, ((e2) => {
  var { Node: t2 } = e2;
  function r(e3, t22, r2) {
    var n3 = getPrecedence(e3, t22, r2), i2 = {}, a = getPrecedence(e3.start, t22, r2);
    if (i2.start = null !== a && a <= n3 || "all" === t22, e3.step) {
      var o = getPrecedence(e3.step, t22, r2);
      i2.step = null !== o && o <= n3 || "all" === t22;
    }
    var s = getPrecedence(e3.end, t22, r2);
    return i2.end = null !== s && s <= n3 || "all" === t22, i2;
  }
  class n extends t2 {
    constructor(e3, t22, r2) {
      if (super(), !isNode$1(e3)) throw new TypeError("Node expected");
      if (!isNode$1(t22)) throw new TypeError("Node expected");
      if (r2 && !isNode$1(r2)) throw new TypeError("Node expected");
      if (arguments.length > 3) throw new Error("Too many arguments");
      this.start = e3, this.end = t22, this.step = r2 || null;
    }
    get type() {
      return name$1y;
    }
    get isRangeNode() {
      return true;
    }
    needsEnd() {
      return this.filter((function(e3) {
        return isSymbolNode(e3) && "end" === e3.name;
      })).length > 0;
    }
    _compile(e3, t22) {
      var r2 = e3.range, n3 = this.start._compile(e3, t22), i2 = this.end._compile(e3, t22);
      if (this.step) {
        var a = this.step._compile(e3, t22);
        return function(e4, t3, o) {
          return r2(n3(e4, t3, o), i2(e4, t3, o), a(e4, t3, o));
        };
      }
      return function(e4, t3, a2) {
        return r2(n3(e4, t3, a2), i2(e4, t3, a2));
      };
    }
    forEach(e3) {
      e3(this.start, "start", this), e3(this.end, "end", this), this.step && e3(this.step, "step", this);
    }
    map(e3) {
      return new n(this._ifNode(e3(this.start, "start", this)), this._ifNode(e3(this.end, "end", this)), this.step && this._ifNode(e3(this.step, "step", this)));
    }
    clone() {
      return new n(this.start, this.end, this.step && this.step);
    }
    _toString(e3) {
      var t22, n3 = r(this, e3 && e3.parenthesis ? e3.parenthesis : "keep", e3 && e3.implicit), i2 = this.start.toString(e3);
      if (n3.start && (i2 = "(" + i2 + ")"), t22 = i2, this.step) {
        var a = this.step.toString(e3);
        n3.step && (a = "(" + a + ")"), t22 += ":" + a;
      }
      var o = this.end.toString(e3);
      return n3.end && (o = "(" + o + ")"), t22 += ":" + o;
    }
    toJSON() {
      return { mathjs: name$1y, start: this.start, end: this.end, step: this.step };
    }
    static fromJSON(e3) {
      return new n(e3.start, e3.end, e3.step);
    }
    _toHTML(e3) {
      var t22, n3 = r(this, e3 && e3.parenthesis ? e3.parenthesis : "keep", e3 && e3.implicit), i2 = this.start.toHTML(e3);
      if (n3.start && (i2 = '<span class="math-parenthesis math-round-parenthesis">(</span>' + i2 + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t22 = i2, this.step) {
        var a = this.step.toHTML(e3);
        n3.step && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t22 += '<span class="math-operator math-range-operator">:</span>' + a;
      }
      var o = this.end.toHTML(e3);
      return n3.end && (o = '<span class="math-parenthesis math-round-parenthesis">(</span>' + o + '<span class="math-parenthesis math-round-parenthesis">)</span>'), t22 += '<span class="math-operator math-range-operator">:</span>' + o;
    }
    _toTex(e3) {
      var t22 = r(this, e3 && e3.parenthesis ? e3.parenthesis : "keep", e3 && e3.implicit), n3 = this.start.toTex(e3);
      if (t22.start && (n3 = "\\left(".concat(n3, "\\right)")), this.step) {
        var i2 = this.step.toTex(e3);
        t22.step && (i2 = "\\left(".concat(i2, "\\right)")), n3 += ":" + i2;
      }
      var a = this.end.toTex(e3);
      return t22.end && (a = "\\left(".concat(a, "\\right)")), n3 += ":" + a;
    }
  }
  return _defineProperty$1(n, "name", name$1y), n;
}), { isClass: true, isNode: true }), name$1x = "RelationalNode", dependencies$1x = ["Node"], createRelationalNode = factory(name$1x, dependencies$1x, ((e2) => {
  var { Node: t2 } = e2, r = { equal: "==", unequal: "!=", smaller: "<", larger: ">", smallerEq: "<=", largerEq: ">=" };
  class n extends t2 {
    constructor(e3, t22) {
      if (super(), !Array.isArray(e3)) throw new TypeError("Parameter conditionals must be an array");
      if (!Array.isArray(t22)) throw new TypeError("Parameter params must be an array");
      if (e3.length !== t22.length - 1) throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
      this.conditionals = e3, this.params = t22;
    }
    get type() {
      return name$1x;
    }
    get isRelationalNode() {
      return true;
    }
    _compile(e3, t22) {
      var r2 = this, n3 = this.params.map(((r3) => r3._compile(e3, t22)));
      return function(t3, i2, a) {
        for (var o, s = n3[0](t3, i2, a), u = 0; u < r2.conditionals.length; u++) {
          if (o = s, s = n3[u + 1](t3, i2, a), !getSafeProperty(e3, r2.conditionals[u])(o, s)) return false;
        }
        return true;
      };
    }
    forEach(e3) {
      this.params.forEach(((t22, r2) => e3(t22, "params[" + r2 + "]", this)), this);
    }
    map(e3) {
      return new n(this.conditionals.slice(), this.params.map(((t22, r2) => this._ifNode(e3(t22, "params[" + r2 + "]", this))), this));
    }
    clone() {
      return new n(this.conditionals, this.params);
    }
    _toString(e3) {
      for (var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", n3 = getPrecedence(this, t22, e3 && e3.implicit), i2 = this.params.map((function(r2, i22) {
        var a2 = getPrecedence(r2, t22, e3 && e3.implicit);
        return "all" === t22 || null !== a2 && a2 <= n3 ? "(" + r2.toString(e3) + ")" : r2.toString(e3);
      })), a = i2[0], o = 0; o < this.conditionals.length; o++) a += " " + r[this.conditionals[o]], a += " " + i2[o + 1];
      return a;
    }
    toJSON() {
      return { mathjs: name$1x, conditionals: this.conditionals, params: this.params };
    }
    static fromJSON(e3) {
      return new n(e3.conditionals, e3.params);
    }
    _toHTML(e3) {
      for (var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", n3 = getPrecedence(this, t22, e3 && e3.implicit), i2 = this.params.map((function(r2, i22) {
        var a2 = getPrecedence(r2, t22, e3 && e3.implicit);
        return "all" === t22 || null !== a2 && a2 <= n3 ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + r2.toHTML(e3) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : r2.toHTML(e3);
      })), a = i2[0], o = 0; o < this.conditionals.length; o++) a += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + escape$1(r[this.conditionals[o]]) + "</span>" + i2[o + 1];
      return a;
    }
    _toTex(e3) {
      for (var t22 = e3 && e3.parenthesis ? e3.parenthesis : "keep", r2 = getPrecedence(this, t22, e3 && e3.implicit), n3 = this.params.map((function(n4, i22) {
        var a2 = getPrecedence(n4, t22, e3 && e3.implicit);
        return "all" === t22 || null !== a2 && a2 <= r2 ? "\\left(" + n4.toTex(e3) + "\right)" : n4.toTex(e3);
      })), i2 = n3[0], a = 0; a < this.conditionals.length; a++) i2 += latexOperators[this.conditionals[a]] + n3[a + 1];
      return i2;
    }
  }
  return _defineProperty$1(n, "name", name$1x), n;
}), { isClass: true, isNode: true }), name$1w = "SymbolNode", dependencies$1w = ["math", "?Unit", "Node"], createSymbolNode = factory(name$1w, dependencies$1w, ((e2) => {
  var { math: t2, Unit: r, Node: n } = e2;
  function i2(e3) {
    return !!r && r.isValuelessUnit(e3);
  }
  class a extends n {
    constructor(e3) {
      if (super(), "string" != typeof e3) throw new TypeError('String expected for parameter "name"');
      this.name = e3;
    }
    get type() {
      return "SymbolNode";
    }
    get isSymbolNode() {
      return true;
    }
    _compile(e3, t22) {
      var n3 = this.name;
      if (true === t22[n3]) return function(e4, t3, r2) {
        return getSafeProperty(t3, n3);
      };
      if (n3 in e3) return function(t3, r2, i22) {
        return t3.has(n3) ? t3.get(n3) : getSafeProperty(e3, n3);
      };
      var o = i2(n3);
      return function(e4, t3, i22) {
        return e4.has(n3) ? e4.get(n3) : o ? new r(null, n3) : a.onUndefinedSymbol(n3);
      };
    }
    forEach(e3) {
    }
    map(e3) {
      return this.clone();
    }
    static onUndefinedSymbol(e3) {
      throw new Error("Undefined symbol " + e3);
    }
    clone() {
      return new a(this.name);
    }
    _toString(e3) {
      return this.name;
    }
    _toHTML(e3) {
      var t22 = escape$1(this.name);
      return "true" === t22 || "false" === t22 ? '<span class="math-symbol math-boolean">' + t22 + "</span>" : "i" === t22 ? '<span class="math-symbol math-imaginary-symbol">' + t22 + "</span>" : "Infinity" === t22 ? '<span class="math-symbol math-infinity-symbol">' + t22 + "</span>" : "NaN" === t22 ? '<span class="math-symbol math-nan-symbol">' + t22 + "</span>" : "null" === t22 ? '<span class="math-symbol math-null-symbol">' + t22 + "</span>" : "undefined" === t22 ? '<span class="math-symbol math-undefined-symbol">' + t22 + "</span>" : '<span class="math-symbol">' + t22 + "</span>";
    }
    toJSON() {
      return { mathjs: "SymbolNode", name: this.name };
    }
    static fromJSON(e3) {
      return new a(e3.name);
    }
    _toTex(e3) {
      var r2 = false;
      void 0 === t2[this.name] && i2(this.name) && (r2 = true);
      var n3 = toSymbol(this.name, r2);
      return "\\" === n3[0] ? n3 : " " + n3;
    }
  }
  return a;
}), { isClass: true, isNode: true }), name$1v = "FunctionNode", dependencies$1v = ["math", "Node", "SymbolNode"], createFunctionNode = factory(name$1v, dependencies$1v, ((e2) => {
  var t2, { math: r, Node: n, SymbolNode: i2 } = e2, a = (e3) => format(e3, { truncate: 78 });
  function o(e3, t22, r2) {
    for (var n3, i22 = "", a2 = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, o2 = 0; null !== (n3 = a2.exec(e3)); ) if (i22 += e3.substring(o2, n3.index), o2 = n3.index, "$$" === n3[0]) i22 += "$", o2++;
    else {
      o2 += n3[0].length;
      var s2 = t22[n3[1]];
      if (!s2) throw new ReferenceError("Template: Property " + n3[1] + " does not exist.");
      if (void 0 === n3[2]) switch (typeof s2) {
        case "string":
          i22 += s2;
          break;
        case "object":
          if (isNode$1(s2)) i22 += s2.toTex(r2);
          else {
            if (!Array.isArray(s2)) throw new TypeError("Template: " + n3[1] + " has to be a Node, String or array of Nodes");
            i22 += s2.map((function(e4, t3) {
              if (isNode$1(e4)) return e4.toTex(r2);
              throw new TypeError("Template: " + n3[1] + "[" + t3 + "] is not a Node.");
            })).join(",");
          }
          break;
        default:
          throw new TypeError("Template: " + n3[1] + " has to be a Node, String or array of Nodes");
      }
      else {
        if (!isNode$1(s2[n3[2]] && s2[n3[2]])) throw new TypeError("Template: " + n3[1] + "[" + n3[2] + "] is not a Node.");
        i22 += s2[n3[2]].toTex(r2);
      }
    }
    return i22 += e3.slice(o2);
  }
  class s extends n {
    constructor(e3, t22, r2) {
      if (super(), "string" == typeof e3 && (e3 = new i2(e3)), !isNode$1(e3)) throw new TypeError('Node expected as parameter "fn"');
      if (!Array.isArray(t22) || !t22.every(isNode$1)) throw new TypeError('Array containing Nodes expected for parameter "args"');
      var n3 = typeof r2;
      if ("undefined" !== n3 && "boolean" !== n3) throw new TypeError("optional flag, if specified, must be boolean");
      this.fn = e3, this.args = t22 || [], this.optional = !!r2;
    }
    get name() {
      return this.fn.name || "";
    }
    get type() {
      return name$1v;
    }
    get isFunctionNode() {
      return true;
    }
    _compile(e3, t22) {
      var r2 = this.args.map(((r3) => r3._compile(e3, t22))), n3 = this.optional || isAccessorNode(this.fn) && this.fn.optionalChaining;
      if (!isSymbolNode(this.fn)) {
        if (isAccessorNode(this.fn) && isIndexNode(this.fn.index) && this.fn.index.isObjectProperty()) {
          var i22 = this.fn.object._compile(e3, t22), o2 = this.fn.index.getObjectProperty(), u = this.args;
          return function(t3, a2, s2) {
            var c3 = i22(t3, a2, s2);
            if (!n3 || null != c3 && void 0 !== c3[o2]) {
              var l2 = getSafeMethod(c3, o2);
              if (null != l2 && l2.rawArgs) return l2(u, e3, createSubScope(t3, a2));
              var f3 = r2.map(((e4) => e4(t3, a2, s2)));
              return l2.apply(c3, f3);
            }
          };
        }
        var c2 = this.fn.toString(), l = this.fn._compile(e3, t22), f2 = this.args;
        return function(t3, i3, o3) {
          var s2 = l(t3, i3, o3);
          if (!n3 || void 0 !== s2) {
            if ("function" != typeof s2) throw new TypeError("Expression '".concat(c2, "' did not evaluate to a function; value is:") + "\n  ".concat(a(s2)));
            if (s2.rawArgs) return s2(f2, e3, createSubScope(t3, i3));
            var u2 = r2.map(((e4) => e4(t3, i3, o3)));
            return s2.apply(s2, u2);
          }
        };
      }
      var p = this.fn.name;
      if (t22[p]) {
        var m = this.args;
        return function(t3, i3, o3) {
          var s2 = getSafeProperty(i3, p);
          if (!n3 || void 0 !== s2) {
            if ("function" != typeof s2) throw new TypeError("Argument '".concat(p, "' was not a function; received: ").concat(a(s2)));
            if (s2.rawArgs) return s2(m, e3, createSubScope(t3, i3));
            var u2 = r2.map(((e4) => e4(t3, i3, o3)));
            return s2.apply(s2, u2);
          }
        };
      }
      var d = p in e3 ? getSafeProperty(e3, p) : void 0, h = "function" == typeof d && true === d.rawArgs, g = (t3) => {
        var r3;
        if (t3.has(p)) r3 = t3.get(p);
        else if (p in e3) r3 = getSafeProperty(e3, p);
        else {
          if (!n3) return s.onUndefinedFunction(p);
          r3 = void 0;
        }
        if ("function" == typeof r3 || n3 && void 0 === r3) return r3;
        throw new TypeError("'".concat(p, "' is not a function; its value is:\n  ").concat(a(r3)));
      };
      if (h) {
        var y = this.args;
        return function(t3, n4, i3) {
          var a2 = g(t3);
          return true === a2.rawArgs ? a2(y, e3, createSubScope(t3, n4)) : a2(...r2.map(((e4) => e4(t3, n4, i3))));
        };
      }
      switch (r2.length) {
        case 0:
          return function(e4, t3, r3) {
            var i3 = g(e4);
            if (!n3 || void 0 !== i3) return i3();
          };
        case 1:
          return function(e4, t3, i3) {
            var a2 = g(e4);
            if (!n3 || void 0 !== a2) return a2((0, r2[0])(e4, t3, i3));
          };
        case 2:
          return function(e4, t3, i3) {
            var a2 = g(e4);
            if (!n3 || void 0 !== a2) {
              var o3 = r2[0], s2 = r2[1];
              return a2(o3(e4, t3, i3), s2(e4, t3, i3));
            }
          };
        default:
          return function(e4, t3, i3) {
            var a2 = g(e4);
            if (!n3 || void 0 !== a2) return a2(...r2.map(((r3) => r3(e4, t3, i3))));
          };
      }
    }
    forEach(e3) {
      e3(this.fn, "fn", this);
      for (var t22 = 0; t22 < this.args.length; t22++) e3(this.args[t22], "args[" + t22 + "]", this);
    }
    map(e3) {
      for (var t22 = this._ifNode(e3(this.fn, "fn", this)), r2 = [], n3 = 0; n3 < this.args.length; n3++) r2[n3] = this._ifNode(e3(this.args[n3], "args[" + n3 + "]", this));
      return new s(t22, r2);
    }
    clone() {
      return new s(this.fn, this.args.slice(0));
    }
    toString(e3) {
      var t22, r2 = this.fn.toString(e3);
      return e3 && "object" == typeof e3.handler && hasOwnProperty$1$1(e3.handler, r2) && (t22 = e3.handler[r2](this, e3)), void 0 !== t22 ? t22 : super.toString(e3);
    }
    _toString(e3) {
      var t22 = this.args.map((function(t3) {
        return t3.toString(e3);
      }));
      return (isFunctionAssignmentNode(this.fn) ? "(" + this.fn.toString(e3) + ")" : this.fn.toString(e3)) + "(" + t22.join(", ") + ")";
    }
    toJSON() {
      return { mathjs: name$1v, fn: this.fn, args: this.args };
    }
    _toHTML(e3) {
      var t22 = this.args.map((function(t3) {
        return t3.toHTML(e3);
      }));
      return '<span class="math-function">' + escape$1(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + t22.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
    toTex(e3) {
      var t22;
      return e3 && "object" == typeof e3.handler && hasOwnProperty$1$1(e3.handler, this.name) && (t22 = e3.handler[this.name](this, e3)), void 0 !== t22 ? t22 : super.toTex(e3);
    }
    _toTex(e3) {
      var t22, n3, i22 = this.args.map((function(t3) {
        return t3.toTex(e3);
      }));
      switch (latexFunctions[this.name] && (t22 = latexFunctions[this.name]), !r[this.name] || "function" != typeof r[this.name].toTex && "object" != typeof r[this.name].toTex && "string" != typeof r[this.name].toTex || (t22 = r[this.name].toTex), typeof t22) {
        case "function":
          n3 = t22(this, e3);
          break;
        case "string":
          n3 = o(t22, this, e3);
          break;
        case "object":
          switch (typeof t22[i22.length]) {
            case "function":
              n3 = t22[i22.length](this, e3);
              break;
            case "string":
              n3 = o(t22[i22.length], this, e3);
          }
      }
      return void 0 !== n3 ? n3 : o(defaultTemplate, this, e3);
    }
    getIdentifier() {
      return this.type + ":" + this.name;
    }
  }
  return t2 = s, _defineProperty$1(s, "name", name$1v), _defineProperty$1(s, "onUndefinedFunction", (function(e3) {
    throw new Error("Undefined function " + e3);
  })), _defineProperty$1(s, "fromJSON", (function(e3) {
    return new t2(e3.fn, e3.args);
  })), s;
}), { isClass: true, isNode: true }), name$1u = "parse", dependencies$1u = ["typed", "numeric", "config", "AccessorNode", "ArrayNode", "AssignmentNode", "BlockNode", "ConditionalNode", "ConstantNode", "FunctionAssignmentNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "RangeNode", "RelationalNode", "SymbolNode"], createParse = factory(name$1u, dependencies$1u, ((e2) => {
  var { typed: t2, numeric: r, config: n, AccessorNode: i2, ArrayNode: a, AssignmentNode: o, BlockNode: s, ConditionalNode: u, ConstantNode: c2, FunctionAssignmentNode: l, FunctionNode: f2, IndexNode: p, ObjectNode: m, OperatorNode: d, ParenthesisNode: h, RangeNode: g, RelationalNode: y, SymbolNode: v2 } = e2, x2 = t2(name$1u, { string: function(e3) {
    return I2(e3, {});
  }, "Array | Matrix": function(e3) {
    return b2(e3, {});
  }, "string, Object": function(e3, t22) {
    return I2(e3, void 0 !== t22.nodes ? t22.nodes : {});
  }, "Array | Matrix, Object": b2 });
  function b2(e3) {
    var t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = void 0 !== t22.nodes ? t22.nodes : {};
    return deepMap(e3, (function(e4) {
      if ("string" != typeof e4) throw new TypeError("String expected");
      return I2(e4, r2);
    }));
  }
  var _2 = { NULL: 0, DELIMITER: 1, NUMBER: 2, SYMBOL: 3, UNKNOWN: 4 }, w2 = { ",": true, "(": true, ")": true, "[": true, "]": true, "{": true, "}": true, '"': true, "'": true, ";": true, "+": true, "-": true, "*": true, ".*": true, "/": true, "./": true, "%": true, "^": true, ".^": true, "~": true, "!": true, "&": true, "|": true, "^|": true, "=": true, ":": true, "?": true, "?.": true, "??": true, "==": true, "!=": true, "<": true, ">": true, "<=": true, ">=": true, "<<": true, ">>": true, ">>>": true }, A2 = { mod: true, to: true, in: true, and: true, xor: true, or: true, not: true }, N = { true: true, false: false, null: null, undefined: void 0 }, D = ["NaN", "Infinity"], E = { '"': '"', "'": "'", "\\": "\\", "/": "/", b: "\b", f: "\f", n: "\n", r: "\r", t: "	" };
  function $2(e3, t22) {
    return e3.expression.substr(e3.index, t22);
  }
  function S2(e3) {
    return $2(e3, 1);
  }
  function C2(e3) {
    e3.index++;
  }
  function M2(e3) {
    return e3.expression.charAt(e3.index - 1);
  }
  function T2(e3) {
    return e3.expression.charAt(e3.index + 1);
  }
  function F(e3) {
    for (e3.tokenType = _2.NULL, e3.token = "", e3.comment = ""; ; ) {
      if ("#" === S2(e3)) for (; "\n" !== S2(e3) && "" !== S2(e3); ) e3.comment += S2(e3), C2(e3);
      if (!x2.isWhitespace(S2(e3), e3.nestingLevel)) break;
      C2(e3);
    }
    if ("" !== S2(e3)) {
      if ("\n" === S2(e3) && !e3.nestingLevel) return e3.tokenType = _2.DELIMITER, e3.token = S2(e3), void C2(e3);
      var t22 = S2(e3), r2 = $2(e3, 2), n3 = $2(e3, 3);
      if (3 === n3.length && w2[n3]) return e3.tokenType = _2.DELIMITER, e3.token = n3, C2(e3), C2(e3), void C2(e3);
      if (2 === r2.length && w2[r2] && ("?." !== r2 || !x2.isDigit(e3.expression.charAt(e3.index + 2)))) return e3.tokenType = _2.DELIMITER, e3.token = r2, C2(e3), void C2(e3);
      if (w2[t22]) return e3.tokenType = _2.DELIMITER, e3.token = t22, void C2(e3);
      if (x2.isDigitDot(t22)) {
        e3.tokenType = _2.NUMBER;
        var i22 = $2(e3, 2);
        if ("0b" === i22 || "0o" === i22 || "0x" === i22) {
          for (e3.token += S2(e3), C2(e3), e3.token += S2(e3), C2(e3); x2.isAlpha(S2(e3), M2(e3), T2(e3)) || x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
          if ("." === S2(e3)) for (e3.token += ".", C2(e3); x2.isAlpha(S2(e3), M2(e3), T2(e3)) || x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
          else if ("i" === S2(e3)) for (e3.token += "i", C2(e3); x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
          return;
        }
        if ("." === S2(e3)) {
          if (e3.token += S2(e3), C2(e3), !x2.isDigit(S2(e3))) return void (e3.tokenType = _2.DELIMITER);
        } else {
          for (; x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
          x2.isDecimalMark(S2(e3), T2(e3)) && (e3.token += S2(e3), C2(e3));
        }
        for (; x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
        if ("E" === S2(e3) || "e" === S2(e3)) {
          if (x2.isDigit(T2(e3)) || "-" === T2(e3) || "+" === T2(e3)) {
            if (e3.token += S2(e3), C2(e3), "+" !== S2(e3) && "-" !== S2(e3) || (e3.token += S2(e3), C2(e3)), !x2.isDigit(S2(e3))) throw ie2(e3, 'Digit expected, got "' + S2(e3) + '"');
            for (; x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
            if (x2.isDecimalMark(S2(e3), T2(e3))) throw ie2(e3, 'Digit expected, got "' + S2(e3) + '"');
          } else if (x2.isDecimalMark(T2(e3), e3.expression.charAt(e3.index + 2))) throw C2(e3), ie2(e3, 'Digit expected, got "' + S2(e3) + '"');
        }
      } else {
        if (!x2.isAlpha(S2(e3), M2(e3), T2(e3))) {
          for (e3.tokenType = _2.UNKNOWN; "" !== S2(e3); ) e3.token += S2(e3), C2(e3);
          throw ie2(e3, 'Syntax error in part "' + e3.token + '"');
        }
        for (; x2.isAlpha(S2(e3), M2(e3), T2(e3)) || x2.isDigit(S2(e3)); ) e3.token += S2(e3), C2(e3);
        hasOwnProperty$1$1(A2, e3.token) ? e3.tokenType = _2.DELIMITER : e3.tokenType = _2.SYMBOL;
      }
    } else e3.tokenType = _2.DELIMITER;
  }
  function O2(e3) {
    do {
      F(e3);
    } while ("\n" === e3.token);
  }
  function k2(e3) {
    e3.nestingLevel++;
  }
  function B2(e3) {
    e3.nestingLevel--;
  }
  function I2(e3, t22) {
    var r2 = { extraNodes: {}, expression: "", comment: "", index: 0, token: "", tokenType: _2.NULL, nestingLevel: 0, conditionalLevel: null };
    _extends$2(r2, { expression: e3, extraNodes: t22 }), F(r2);
    var n3 = (function(e4) {
      var t3, r3, n4 = [];
      "" !== e4.token && "\n" !== e4.token && ";" !== e4.token && (t3 = R2(e4), e4.comment && (t3.comment = e4.comment));
      for (; "\n" === e4.token || ";" === e4.token; ) 0 === n4.length && t3 && (r3 = ";" !== e4.token, n4.push({ node: t3, visible: r3 })), F(e4), "\n" !== e4.token && ";" !== e4.token && "" !== e4.token && (t3 = R2(e4), e4.comment && (t3.comment = e4.comment), r3 = ";" !== e4.token, n4.push({ node: t3, visible: r3 }));
      return n4.length > 0 ? new s(n4) : (t3 || (t3 = new c2(void 0), e4.comment && (t3.comment = e4.comment)), t3);
    })(r2);
    if ("" !== r2.token) throw r2.tokenType === _2.DELIMITER ? ae2(r2, "Unexpected operator " + r2.token) : ie2(r2, 'Unexpected part "' + r2.token + '"');
    return n3;
  }
  function R2(e3) {
    var t22, r2, n3, i22, a2 = (function(e4) {
      var t3 = (function(e5) {
        var t4 = q2(e5);
        for (; "or" === e5.token; ) O2(e5), t4 = new d("or", "or", [t4, q2(e5)]);
        return t4;
      })(e4);
      for (; "?" === e4.token; ) {
        var r3 = e4.conditionalLevel;
        e4.conditionalLevel = e4.nestingLevel, O2(e4);
        var n4 = t3, i3 = R2(e4);
        if (":" !== e4.token) throw ie2(e4, "False part of conditional expression expected");
        e4.conditionalLevel = null, O2(e4);
        var a3 = R2(e4);
        t3 = new u(n4, i3, a3), e4.conditionalLevel = r3;
      }
      return t3;
    })(e3);
    if ("=" === e3.token) {
      if (isSymbolNode(a2)) return t22 = a2.name, O2(e3), n3 = R2(e3), new o(new v2(t22), n3);
      if (isAccessorNode(a2)) {
        if (a2.optionalChaining) throw ie2(e3, "Cannot assign to optional chain");
        return O2(e3), n3 = R2(e3), new o(a2.object, a2.index, n3);
      }
      if (isFunctionNode(a2) && isSymbolNode(a2.fn) && (i22 = true, r2 = [], t22 = a2.name, a2.args.forEach((function(e4, t3) {
        isSymbolNode(e4) ? r2[t3] = e4.name : i22 = false;
      })), i22)) return O2(e3), n3 = R2(e3), new l(t22, r2, n3);
      throw ie2(e3, "Invalid left hand side of assignment operator =");
    }
    return a2;
  }
  function q2(e3) {
    for (var t22 = z2(e3); "xor" === e3.token; ) O2(e3), t22 = new d("xor", "xor", [t22, z2(e3)]);
    return t22;
  }
  function z2(e3) {
    for (var t22 = P2(e3); "and" === e3.token; ) O2(e3), t22 = new d("and", "and", [t22, P2(e3)]);
    return t22;
  }
  function P2(e3) {
    for (var t22 = L2(e3); "|" === e3.token; ) O2(e3), t22 = new d("|", "bitOr", [t22, L2(e3)]);
    return t22;
  }
  function L2(e3) {
    for (var t22 = j2(e3); "^|" === e3.token; ) O2(e3), t22 = new d("^|", "bitXor", [t22, j2(e3)]);
    return t22;
  }
  function j2(e3) {
    for (var t22 = U2(e3); "&" === e3.token; ) O2(e3), t22 = new d("&", "bitAnd", [t22, U2(e3)]);
    return t22;
  }
  function U2(e3) {
    for (var t22 = [Z2(e3)], r2 = [], n3 = { "==": "equal", "!=": "unequal", "<": "smaller", ">": "larger", "<=": "smallerEq", ">=": "largerEq" }; hasOwnProperty$1$1(n3, e3.token); ) {
      var i22 = { name: e3.token, fn: n3[e3.token] };
      r2.push(i22), O2(e3), t22.push(Z2(e3));
    }
    return 1 === t22.length ? t22[0] : 2 === t22.length ? new d(r2[0].name, r2[0].fn, t22) : new y(r2.map(((e4) => e4.fn)), t22);
  }
  function Z2(e3) {
    var t22, r2, n3, i22;
    t22 = G2(e3);
    for (var a2 = { "<<": "leftShift", ">>": "rightArithShift", ">>>": "rightLogShift" }; hasOwnProperty$1$1(a2, e3.token); ) n3 = a2[r2 = e3.token], O2(e3), i22 = [t22, G2(e3)], t22 = new d(r2, n3, i22);
    return t22;
  }
  function G2(e3) {
    var t22, r2, n3, i22;
    t22 = V2(e3);
    for (var a2 = { to: "to", in: "to" }; hasOwnProperty$1$1(a2, e3.token); ) n3 = a2[r2 = e3.token], O2(e3), "in" === r2 && "])},;".includes(e3.token) ? t22 = new d("*", "multiply", [t22, new v2("in")], true) : (i22 = [t22, V2(e3)], t22 = new d(r2, n3, i22));
    return t22;
  }
  function V2(e3) {
    var t22, r2 = [];
    if (t22 = ":" === e3.token ? new c2(1) : H2(e3), ":" === e3.token && e3.conditionalLevel !== e3.nestingLevel) {
      for (r2.push(t22); ":" === e3.token && r2.length < 3; ) O2(e3), ")" === e3.token || "]" === e3.token || "," === e3.token || "" === e3.token ? r2.push(new v2("end")) : r2.push(H2(e3));
      t22 = 3 === r2.length ? new g(r2[0], r2[2], r2[1]) : new g(r2[0], r2[1]);
    }
    return t22;
  }
  function H2(e3) {
    var t22, r2, n3, i22;
    t22 = X2(e3);
    for (var a2 = { "+": "add", "-": "subtract" }; hasOwnProperty$1$1(a2, e3.token); ) {
      n3 = a2[r2 = e3.token], O2(e3);
      var o2 = X2(e3);
      i22 = o2.isPercentage ? [t22, new d("*", "multiply", [t22, o2])] : [t22, o2], t22 = new d(r2, n3, i22);
    }
    return t22;
  }
  function X2(e3) {
    var t22, r2, n3, i22;
    r2 = t22 = W2(e3);
    for (var a2 = { "*": "multiply", ".*": "dotMultiply", "/": "divide", "./": "dotDivide", "%": "mod", mod: "mod" }; hasOwnProperty$1$1(a2, e3.token); ) i22 = a2[n3 = e3.token], O2(e3), r2 = W2(e3), t22 = new d(n3, i22, [t22, r2]);
    return t22;
  }
  function W2(e3) {
    var t22, r2;
    for (r2 = t22 = Q2(e3); e3.tokenType === _2.SYMBOL || "in" === e3.token && isConstantNode(t22) || "in" === e3.token && isOperatorNode(t22) && "unaryMinus" === t22.fn && isConstantNode(t22.args[0]) || !(e3.tokenType !== _2.NUMBER || isConstantNode(r2) || isOperatorNode(r2) && "!" !== r2.op) || "(" === e3.token; ) r2 = Q2(e3), t22 = new d("*", "multiply", [t22, r2], true);
    return t22;
  }
  function Q2(e3) {
    for (var t22 = Y2(e3), r2 = t22, n3 = []; "/" === e3.token && rule2Node(r2); ) {
      if (n3.push(_extends$2({}, e3)), O2(e3), e3.tokenType !== _2.NUMBER) {
        _extends$2(e3, n3.pop());
        break;
      }
      if (n3.push(_extends$2({}, e3)), O2(e3), e3.tokenType !== _2.SYMBOL && "(" !== e3.token && "in" !== e3.token) {
        n3.pop(), _extends$2(e3, n3.pop());
        break;
      }
      _extends$2(e3, n3.pop()), n3.pop(), r2 = Y2(e3), t22 = new d("/", "divide", [t22, r2]);
    }
    return t22;
  }
  function Y2(e3) {
    var t22 = J(e3);
    if ("%" === e3.token) {
      var r2 = _extends$2({}, e3);
      O2(e3);
      try {
        J(e3), _extends$2(e3, r2);
      } catch (e4) {
        t22 = new d("/", "divide", [t22, new c2(100)], false, true);
      }
    }
    return t22;
  }
  function J(e3) {
    var t22, r2, n3, i22 = { "-": "unaryMinus", "+": "unaryPlus", "~": "bitNot", not: "not" };
    return hasOwnProperty$1$1(i22, e3.token) ? (n3 = i22[e3.token], t22 = e3.token, O2(e3), r2 = [J(e3)], new d(t22, n3, r2)) : (function(e4) {
      var t3, r3, n4, i3;
      t3 = (function(e5) {
        var t4 = K2(e5);
        for (; "??" === e5.token; ) O2(e5), t4 = new d("??", "nullish", [t4, K2(e5)]);
        return t4;
      })(e4), ("^" === e4.token || ".^" === e4.token) && (n4 = "^" === (r3 = e4.token) ? "pow" : "dotPow", O2(e4), i3 = [t3, J(e4)], t3 = new d(r3, n4, i3));
      return t3;
    })(e3);
  }
  function K2(e3) {
    var t22, i22, o2;
    t22 = (function(e4) {
      var t3 = [];
      if (e4.tokenType === _2.SYMBOL && hasOwnProperty$1$1(e4.extraNodes, e4.token)) {
        var i3 = e4.extraNodes[e4.token];
        if (F(e4), "(" === e4.token) {
          if (t3 = [], k2(e4), F(e4), ")" !== e4.token) for (t3.push(R2(e4)); "," === e4.token; ) F(e4), t3.push(R2(e4));
          if (")" !== e4.token) throw ie2(e4, "Parenthesis ) expected");
          B2(e4), F(e4);
        }
        return new i3(t3);
      }
      return (function(e5) {
        var t4;
        if (e5.tokenType === _2.SYMBOL || e5.tokenType === _2.DELIMITER && e5.token in A2) return t4 = e5.token, F(e5), ee2(e5, hasOwnProperty$1$1(N, t4) ? new c2(N[t4]) : D.includes(t4) ? new c2(r(t4, "number")) : new v2(t4));
        return (function(e6) {
          var t5;
          if ('"' === e6.token || "'" === e6.token) return t5 = te2(e6, e6.token), ee2(e6, new c2(t5));
          return (function(e7) {
            var t6, i4, o3, s3;
            if ("[" === e7.token) {
              if (k2(e7), F(e7), "]" !== e7.token) {
                var u2 = re2(e7);
                if (";" === e7.token) {
                  for (o3 = 1, i4 = [u2]; ";" === e7.token; ) F(e7), "]" !== e7.token && (i4[o3] = re2(e7), o3++);
                  if ("]" !== e7.token) throw ie2(e7, "End of matrix ] expected");
                  B2(e7), F(e7), s3 = i4[0].items.length;
                  for (var l2 = 1; l2 < o3; l2++) if (i4[l2].items.length !== s3) throw ae2(e7, "Column dimensions mismatch (" + i4[l2].items.length + " !== " + s3 + ")");
                  t6 = new a(i4);
                } else {
                  if ("]" !== e7.token) throw ie2(e7, "End of matrix ] expected");
                  B2(e7), F(e7), t6 = u2;
                }
              } else B2(e7), F(e7), t6 = new a([]);
              return ee2(e7, t6);
            }
            return (function(e8) {
              if ("{" === e8.token) {
                var t7;
                k2(e8);
                var i5 = {};
                do {
                  if (F(e8), "}" !== e8.token) {
                    if ('"' === e8.token || "'" === e8.token) t7 = te2(e8, e8.token);
                    else {
                      if (!(e8.tokenType === _2.SYMBOL || e8.tokenType === _2.DELIMITER && e8.token in A2)) throw ie2(e8, "Symbol or string expected as object key");
                      t7 = e8.token, F(e8);
                    }
                    if (":" !== e8.token) throw ie2(e8, "Colon : expected after object key");
                    F(e8), i5[t7] = R2(e8);
                  }
                } while ("," === e8.token);
                if ("}" !== e8.token) throw ie2(e8, "Comma , or bracket } expected after object value");
                B2(e8), F(e8);
                var a2 = new m(i5);
                return a2 = ee2(e8, a2);
              }
              return (function(e9) {
                var t8;
                if (e9.tokenType === _2.NUMBER) {
                  t8 = e9.token, F(e9);
                  var i6 = safeNumberType(t8, n), a3 = r(t8, i6);
                  return new c2(a3);
                }
                return (function(e10) {
                  var t9;
                  if ("(" === e10.token) {
                    if (k2(e10), F(e10), t9 = R2(e10), ")" !== e10.token) throw ie2(e10, "Parenthesis ) expected");
                    return B2(e10), F(e10), t9 = ee2(e10, t9 = new h(t9));
                  }
                  return (function(e11) {
                    throw "" === e11.token ? ie2(e11, "Unexpected end of expression") : ie2(e11, "Value expected");
                  })(e10);
                })(e9);
              })(e8);
            })(e7);
          })(e6);
        })(e5);
      })(e4);
    })(e3);
    for (var s2 = { "!": "factorial", "'": "ctranspose" }; hasOwnProperty$1$1(s2, e3.token); ) o2 = s2[i22 = e3.token], F(e3), t22 = ee2(e3, t22 = new d(i22, o2, [t22]));
    return t22;
  }
  function ee2(e3, t22, r2) {
    for (var n3; ; ) {
      var a2 = false;
      "?." === e3.token && (a2 = true, F(e3));
      var o2 = ("(" === e3.token || "[" === e3.token || "." === e3.token) && true;
      if (!a2 && !o2) break;
      if (n3 = [], "(" === e3.token) {
        if (!(a2 || isSymbolNode(t22) || isAccessorNode(t22))) return t22;
        if (k2(e3), F(e3), ")" !== e3.token) for (n3.push(R2(e3)); "," === e3.token; ) F(e3), n3.push(R2(e3));
        if (")" !== e3.token) throw ie2(e3, "Parenthesis ) expected");
        B2(e3), F(e3), t22 = new f2(t22, n3, a2);
      } else if ("[" === e3.token) {
        if (k2(e3), F(e3), "]" !== e3.token) for (n3.push(R2(e3)); "," === e3.token; ) F(e3), n3.push(R2(e3));
        if ("]" !== e3.token) throw ie2(e3, "Parenthesis ] expected");
        B2(e3), F(e3), t22 = new i2(t22, new p(n3), a2);
      } else {
        if (a2 || F(e3), !(e3.tokenType === _2.SYMBOL || e3.tokenType === _2.DELIMITER && e3.token in A2)) {
          var s2 = "Property name expected after ";
          throw ie2(e3, s2 += a2 ? "optional chain" : "dot");
        }
        n3.push(new c2(e3.token)), F(e3);
        t22 = new i2(t22, new p(n3, true), a2);
      }
    }
    return t22;
  }
  function te2(e3, t22) {
    for (var r2 = ""; "" !== S2(e3) && S2(e3) !== t22; ) if ("\\" === S2(e3)) {
      C2(e3);
      var n3 = S2(e3), i22 = E[n3];
      if (void 0 !== i22) r2 += i22, e3.index += 1;
      else {
        if ("u" !== n3) throw ie2(e3, "Bad escape character \\".concat(n3));
        var a2 = e3.expression.slice(e3.index + 1, e3.index + 5);
        if (!/^[0-9A-Fa-f]{4}$/.test(a2)) throw ie2(e3, "Invalid unicode character \\u".concat(a2));
        r2 += String.fromCharCode(parseInt(a2, 16)), e3.index += 5;
      }
    } else r2 += S2(e3), C2(e3);
    if (F(e3), e3.token !== t22) throw ie2(e3, "End of string ".concat(t22, " expected"));
    return F(e3), r2;
  }
  function re2(e3) {
    for (var t22 = [R2(e3)], r2 = 1; "," === e3.token; ) F(e3), "]" !== e3.token && ";" !== e3.token && (t22[r2] = R2(e3), r2++);
    return new a(t22);
  }
  function ne(e3) {
    return e3.index - e3.token.length + 1;
  }
  function ie2(e3, t22) {
    var r2 = ne(e3), n3 = new SyntaxError(t22 + " (char " + r2 + ")");
    return n3.char = r2, n3;
  }
  function ae2(e3, t22) {
    var r2 = ne(e3), n3 = new SyntaxError(t22 + " (char " + r2 + ")");
    return n3.char = r2, n3;
  }
  return x2.isAlpha = function(e3, t22, r2) {
    return x2.isValidLatinOrGreek(e3) || x2.isValidMathSymbol(e3, r2) || x2.isValidMathSymbol(t22, e3);
  }, x2.isValidLatinOrGreek = function(e3) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(e3);
  }, x2.isValidMathSymbol = function(e3, t22) {
    return /^[\uD835]$/.test(e3) && /^[\uDC00-\uDFFF]$/.test(t22) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(t22);
  }, x2.isWhitespace = function(e3, t22) {
    return " " === e3 || "	" === e3 || " " === e3 || "\n" === e3 && t22 > 0;
  }, x2.isDecimalMark = function(e3, t22) {
    return "." === e3 && "/" !== t22 && "*" !== t22 && "^" !== t22;
  }, x2.isDigitDot = function(e3) {
    return e3 >= "0" && e3 <= "9" || "." === e3;
  }, x2.isDigit = function(e3) {
    return e3 >= "0" && e3 <= "9";
  }, t2.addConversion({ from: "string", to: "Node", convert: x2 }), x2;
})), name$1t = "compile", dependencies$1t = ["typed", "parse"], createCompile = factory(name$1t, dependencies$1t, ((e2) => {
  var { typed: t2, parse: r } = e2;
  return t2(name$1t, { string: function(e3) {
    return r(e3).compile();
  }, "Array | Matrix": function(e3) {
    return deepMap(e3, (function(e4) {
      return r(e4).compile();
    }));
  } });
})), name$1s = "evaluate", dependencies$1s = ["typed", "parse"], createEvaluate = factory(name$1s, dependencies$1s, ((e2) => {
  var { typed: t2, parse: r } = e2;
  return t2(name$1s, { string: function(e3) {
    var t22 = createEmptyMap();
    return r(e3).compile().evaluate(t22);
  }, "string, Map | Object": function(e3, t22) {
    return r(e3).compile().evaluate(t22);
  }, "Array | Matrix": function(e3) {
    var t22 = createEmptyMap();
    return deepMap(e3, (function(e4) {
      return r(e4).compile().evaluate(t22);
    }));
  }, "Array | Matrix, Map | Object": function(e3, t22) {
    return deepMap(e3, (function(e4) {
      return r(e4).compile().evaluate(t22);
    }));
  } });
})), name$1r = "Parser", dependencies$1r = ["evaluate", "parse"], createParserClass = factory(name$1r, dependencies$1r, ((e2) => {
  var { evaluate: t2, parse: r } = e2;
  function n() {
    if (!(this instanceof n)) throw new SyntaxError("Constructor must be called with the new operator");
    Object.defineProperty(this, "scope", { value: createEmptyMap(), writable: false });
  }
  return n.prototype.type = "Parser", n.prototype.isParser = true, n.prototype.evaluate = function(e3) {
    return t2(e3, this.scope);
  }, n.prototype.get = function(e3) {
    if (this.scope.has(e3)) return this.scope.get(e3);
  }, n.prototype.getAll = function() {
    return toObject(this.scope);
  }, n.prototype.getAllAsMap = function() {
    return this.scope;
  }, n.prototype.set = function(e3, t22) {
    if (!(function(e4) {
      if (0 === e4.length) return false;
      for (var t3 = 0; t3 < e4.length; t3++) {
        var n3 = e4.charAt(t3 - 1), i2 = e4.charAt(t3), a = e4.charAt(t3 + 1);
        if (!(r.isAlpha(i2, n3, a) || t3 > 0 && r.isDigit(i2))) return false;
      }
      return true;
    })(e3)) throw new Error("Invalid variable name: '".concat(e3, "'. Variable names must follow the specified rules."));
    return this.scope.set(e3, t22), t22;
  }, n.prototype.remove = function(e3) {
    this.scope.delete(e3);
  }, n.prototype.clear = function() {
    this.scope.clear();
  }, n.prototype.toJSON = function() {
    var e3 = { mathjs: "Parser", variables: {}, functions: {} };
    for (var [t22, r2] of this.scope) if (isFunction$2(r2)) {
      if (!isExpressionFunction(r2)) throw new Error("Cannot serialize external function ".concat(t22));
      e3.functions[t22] = "".concat(r2.syntax, " = ").concat(r2.expr);
    } else e3.variables[t22] = r2;
    return e3;
  }, n.fromJSON = function(e3) {
    var t22 = new n();
    return Object.entries(e3.variables).forEach(((e4) => {
      var [r2, n3] = e4;
      return t22.set(r2, n3);
    })), Object.entries(e3.functions).forEach(((e4) => {
      var [r2, n3] = e4;
      return t22.evaluate(n3);
    })), t22;
  }, n;
}), { isClass: true });
function isExpressionFunction(e2) {
  return "function" == typeof e2 && "string" == typeof e2.syntax && "string" == typeof e2.expr;
}
var name$1q = "parser", dependencies$1q = ["typed", "Parser"], createParser = factory(name$1q, dependencies$1q, ((e2) => {
  var { typed: t2, Parser: r } = e2;
  return t2(name$1q, { "": function() {
    return new r();
  } });
})), name$1p = "lup", dependencies$1p = ["typed", "matrix", "abs", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "larger", "equalScalar", "unaryMinus", "DenseMatrix", "SparseMatrix", "Spa"], createLup = factory(name$1p, dependencies$1p, ((e2) => {
  var { typed: t2, matrix: r, abs: n, addScalar: i2, divideScalar: a, multiplyScalar: o, subtractScalar: s, larger: u, equalScalar: c2, unaryMinus: l, DenseMatrix: f2, SparseMatrix: p, Spa: m } = e2;
  return t2(name$1p, { DenseMatrix: function(e3) {
    return d(e3);
  }, SparseMatrix: function(e3) {
    return h(e3);
  }, Array: function(e3) {
    var t22 = d(r(e3));
    return { L: t22.L.valueOf(), U: t22.U.valueOf(), p: t22.p };
  } });
  function d(e3) {
    var t22, r2, l2, p2 = e3._size[0], m2 = e3._size[1], d2 = Math.min(p2, m2), h2 = clone$3(e3._data), g = [], y = [p2, d2], v2 = [], x2 = [d2, m2], b2 = [];
    for (t22 = 0; t22 < p2; t22++) b2[t22] = t22;
    for (r2 = 0; r2 < m2; r2++) {
      if (r2 > 0) for (t22 = 0; t22 < p2; t22++) {
        var _2 = Math.min(t22, r2), w2 = 0;
        for (l2 = 0; l2 < _2; l2++) w2 = i2(w2, o(h2[t22][l2], h2[l2][r2]));
        h2[t22][r2] = s(h2[t22][r2], w2);
      }
      var A2 = r2, N = 0, D = 0;
      for (t22 = r2; t22 < p2; t22++) {
        var E = h2[t22][r2], $2 = n(E);
        u($2, N) && (A2 = t22, N = $2, D = E);
      }
      if (r2 !== A2 && (b2[r2] = [b2[A2], b2[A2] = b2[r2]][0], f2._swapRows(r2, A2, h2)), r2 < p2) for (t22 = r2 + 1; t22 < p2; t22++) {
        var S2 = h2[t22][r2];
        c2(S2, 0) || (h2[t22][r2] = a(h2[t22][r2], D));
      }
    }
    for (r2 = 0; r2 < m2; r2++) for (t22 = 0; t22 < p2; t22++) 0 === r2 && (t22 < m2 && (v2[t22] = []), g[t22] = []), t22 < r2 ? (t22 < m2 && (v2[t22][r2] = h2[t22][r2]), r2 < p2 && (g[t22][r2] = 0)) : t22 !== r2 ? (t22 < m2 && (v2[t22][r2] = 0), r2 < p2 && (g[t22][r2] = h2[t22][r2])) : (t22 < m2 && (v2[t22][r2] = h2[t22][r2]), r2 < p2 && (g[t22][r2] = 1));
    var C2 = new f2({ data: g, size: y }), M2 = new f2({ data: v2, size: x2 }), T2 = [];
    for (t22 = 0, d2 = b2.length; t22 < d2; t22++) T2[b2[t22]] = t22;
    return { L: C2, U: M2, p: T2, toString: function() {
      return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
    } };
  }
  function h(e3) {
    var t22, r2, i22, s2 = e3._size[0], f3 = e3._size[1], d2 = Math.min(s2, f3), h2 = e3._values, g = e3._index, y = e3._ptr, v2 = [], x2 = [], b2 = [], _2 = [s2, d2], w2 = [], A2 = [], N = [], D = [d2, f3], E = [], $2 = [];
    for (t22 = 0; t22 < s2; t22++) E[t22] = t22, $2[t22] = t22;
    var S2 = function() {
      var e4 = new m();
      r2 < s2 && (b2.push(v2.length), v2.push(1), x2.push(r2)), N.push(w2.length);
      var f4 = y[r2], d3 = y[r2 + 1];
      for (i22 = f4; i22 < d3; i22++) t22 = g[i22], e4.set(E[t22], h2[i22]);
      r2 > 0 && e4.forEach(0, r2 - 1, (function(t3, r3) {
        p._forEachRow(t3, v2, x2, b2, (function(n3, i3) {
          n3 > t3 && e4.accumulate(n3, l(o(i3, r3)));
        }));
      }));
      var S22, C2, M2, T2, F = r2, O2 = e4.get(r2), k2 = n(O2);
      e4.forEach(r2 + 1, s2 - 1, (function(e5, t3) {
        var r3 = n(t3);
        u(r3, k2) && (F = e5, k2 = r3, O2 = t3);
      })), r2 !== F && (p._swapRows(r2, F, _2[1], v2, x2, b2), p._swapRows(r2, F, D[1], w2, A2, N), e4.swap(r2, F), C2 = F, M2 = $2[S22 = r2], T2 = $2[C2], E[M2] = C2, E[T2] = S22, $2[S22] = T2, $2[C2] = M2), e4.forEach(0, s2 - 1, (function(e5, t3) {
        e5 <= r2 ? (w2.push(t3), A2.push(e5)) : (t3 = a(t3, O2), c2(t3, 0) || (v2.push(t3), x2.push(e5)));
      }));
    };
    for (r2 = 0; r2 < f3; r2++) S2();
    return N.push(w2.length), b2.push(v2.length), { L: new p({ values: v2, index: x2, ptr: b2, size: _2 }), U: new p({ values: w2, index: A2, ptr: N, size: D }), p: E, toString: function() {
      return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\nP: " + this.p;
    } };
  }
})), name$1o = "qr", dependencies$1o = ["typed", "matrix", "zeros", "identity", "isZero", "equal", "sign", "sqrt", "conj", "unaryMinus", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "complex"], createQr = factory(name$1o, dependencies$1o, ((e2) => {
  var { typed: t2, matrix: r, zeros: n, identity: i2, isZero: a, equal: o, sign: s, sqrt: u, conj: c2, unaryMinus: l, addScalar: f2, divideScalar: p, multiplyScalar: m, subtractScalar: d, complex: h } = e2;
  return _extends$2(t2(name$1o, { DenseMatrix: function(e3) {
    return y(e3);
  }, SparseMatrix: function(e3) {
    return (function() {
      throw new Error("qr not implemented for sparse matrices yet");
    })();
  }, Array: function(e3) {
    var t22 = y(r(e3));
    return { Q: t22.Q.valueOf(), R: t22.R.valueOf() };
  } }), { _denseQRimpl: g });
  function g(e3) {
    var t22, r2, h2, g2 = e3._size[0], y2 = e3._size[1], v2 = i2([g2], "dense"), x2 = v2._data, b2 = e3.clone(), _2 = b2._data, w2 = n([g2], "");
    for (h2 = 0; h2 < Math.min(y2, g2); ++h2) {
      var A2 = _2[h2][h2], N = l(o(A2, 0) ? 1 : s(A2)), D = c2(N), E = 0;
      for (t22 = h2; t22 < g2; t22++) E = f2(E, m(_2[t22][h2], c2(_2[t22][h2])));
      var $2 = m(N, u(E));
      if (!a($2)) {
        var S2 = d(A2, $2);
        for (w2[h2] = 1, t22 = h2 + 1; t22 < g2; t22++) w2[t22] = p(_2[t22][h2], S2);
        var C2 = l(c2(p(S2, $2))), M2 = void 0;
        for (r2 = h2; r2 < y2; r2++) {
          for (M2 = 0, t22 = h2; t22 < g2; t22++) M2 = f2(M2, m(c2(w2[t22]), _2[t22][r2]));
          for (M2 = m(M2, C2), t22 = h2; t22 < g2; t22++) _2[t22][r2] = m(d(_2[t22][r2], m(w2[t22], M2)), D);
        }
        for (t22 = 0; t22 < g2; t22++) {
          for (M2 = 0, r2 = h2; r2 < g2; r2++) M2 = f2(M2, m(x2[t22][r2], w2[r2]));
          for (M2 = m(M2, C2), r2 = h2; r2 < g2; ++r2) x2[t22][r2] = p(d(x2[t22][r2], m(M2, c2(w2[r2]))), D);
        }
      }
    }
    return { Q: v2, R: b2, toString: function() {
      return "Q: " + this.Q.toString() + "\nR: " + this.R.toString();
    } };
  }
  function y(e3) {
    var t22 = g(e3), r2 = t22.R._data;
    if (e3._data.length > 0) for (var n3 = "Complex" === r2[0][0].type ? h(0) : 0, i22 = 0; i22 < r2.length; ++i22) for (var a2 = 0; a2 < i22 && a2 < (r2[0] || []).length; ++a2) r2[i22][a2] = n3;
    return t22;
  }
}));
function csPermute(e2, t2, r, n) {
  for (var i2 = e2._values, a = e2._index, o = e2._ptr, s = e2._size, u = e2._datatype, c2 = s[0], l = s[1], f2 = null, p = [], m = [], d = 0, h = 0; h < l; h++) {
    m[h] = d;
    for (var g = r ? r[h] : h, y = o[g], v2 = o[g + 1], x2 = y; x2 < v2; x2++) {
      var b2 = a[x2];
      p[d] = b2, f2 && (f2[d] = i2[x2]), d++;
    }
  }
  return m[l] = d, e2.createSparseMatrix({ values: f2, index: p, ptr: m, size: [c2, l], datatype: u });
}
function csTdfs(e2, t2, r, n, i2, a, o) {
  var s = 0;
  for (r[o] = e2; s >= 0; ) {
    var u = r[o + s], c2 = r[n + u];
    -1 === c2 ? (s--, a[t2++] = u) : (r[n + u] = r[i2 + c2], r[o + ++s] = c2);
  }
  return t2;
}
function csPost(e2, t2) {
  if (!e2) return null;
  var r, n = 0, i2 = [], a = [], o = t2, s = 2 * t2;
  for (r = 0; r < t2; r++) a[0 + r] = -1;
  for (r = t2 - 1; r >= 0; r--) -1 !== e2[r] && (a[o + r] = a[0 + e2[r]], a[0 + e2[r]] = r);
  for (r = 0; r < t2; r++) -1 === e2[r] && (n = csTdfs(r, n, a, 0, o, i2, s));
  return i2;
}
function csEtree(e2, t2) {
  if (!e2) return null;
  var r, n, i2 = e2._index, a = e2._ptr, o = e2._size, s = o[0], u = o[1], c2 = [], l = [], f2 = u;
  for (r = 0; r < s; r++) l[f2 + r] = -1;
  for (var p = 0; p < u; p++) {
    c2[p] = -1, l[0 + p] = -1;
    for (var m = a[p], d = a[p + 1], h = m; h < d; h++) {
      var g = i2[h];
      for (r = l[f2 + g]; -1 !== r && r < p; r = n) n = l[0 + r], l[0 + r] = p, -1 === n && (c2[r] = p);
      l[f2 + g] = p;
    }
  }
  return c2;
}
function csFkeep(e2, t2, r) {
  for (var n = e2._values, i2 = e2._index, a = e2._ptr, o = e2._size[1], s = 0, u = 0; u < o; u++) {
    var c2 = a[u];
    for (a[u] = s; c2 < a[u + 1]; c2++) t2(i2[c2], u, n ? n[c2] : 1, r) && (i2[s] = i2[c2], n && (n[s] = n[c2]), s++);
  }
  return a[o] = s, i2.splice(s, i2.length - s), n && n.splice(s, n.length - s), s;
}
function csFlip(e2) {
  return -e2 - 2;
}
var name$1n = "csAmd", dependencies$1n = ["add", "multiply", "transpose"], createCsAmd = factory(name$1n, dependencies$1n, ((e2) => {
  var { add: t2, multiply: r, transpose: n } = e2;
  return function(e3, o) {
    if (!o || e3 <= 0 || e3 > 3) return null;
    var s = o._size, u = s[0], c2 = s[1], l = 0, f2 = Math.max(16, 10 * Math.sqrt(c2)), p = (function(e4, i22, a2, o2, s2) {
      var u2 = n(i22);
      if (1 === e4 && o2 === a2) return t2(i22, u2);
      if (2 === e4) {
        for (var c3 = u2._index, l2 = u2._ptr, f3 = 0, p2 = 0; p2 < a2; p2++) {
          var m2 = l2[p2];
          if (l2[p2] = f3, !(l2[p2 + 1] - m2 > s2)) for (var d2 = l2[p2 + 1]; m2 < d2; m2++) c3[f3++] = c3[m2];
        }
        return l2[a2] = f3, i22 = n(u2), r(u2, i22);
      }
      return r(u2, i22);
    })(e3, o, u, c2, f2 = Math.min(c2 - 2, f2));
    csFkeep(p, a, null);
    for (var m, d, h, g, y, v2, x2, b2, _2, w2, A2, N, D, E, $2, S2, C2 = p._index, M2 = p._ptr, T2 = M2[c2], F = [], O2 = [], k2 = c2 + 1, B2 = 2 * (c2 + 1), I2 = 3 * (c2 + 1), R2 = 4 * (c2 + 1), q2 = 5 * (c2 + 1), z2 = 6 * (c2 + 1), P2 = 7 * (c2 + 1), L2 = F, j2 = (function(e4, t22, r2, n3, a2, o2, s2, u2, c3, l2, f3, p2) {
      for (var m2 = 0; m2 < e4; m2++) r2[n3 + m2] = t22[m2 + 1] - t22[m2];
      r2[n3 + e4] = 0;
      for (var d2 = 0; d2 <= e4; d2++) r2[a2 + d2] = -1, o2[d2] = -1, r2[s2 + d2] = -1, r2[u2 + d2] = -1, r2[c3 + d2] = 1, r2[l2 + d2] = 1, r2[f3 + d2] = 0, r2[p2 + d2] = r2[n3 + d2];
      var h2 = i2(0, 0, r2, l2, e4);
      return r2[f3 + e4] = -2, t22[e4] = -1, r2[l2 + e4] = 0, h2;
    })(c2, M2, O2, 0, I2, L2, B2, P2, k2, z2, R2, q2), U2 = (function(e4, t22, r2, n3, i22, a2, o2, s2, u2, c3, l2) {
      for (var f3 = 0, p2 = 0; p2 < e4; p2++) {
        var m2 = r2[n3 + p2];
        if (0 === m2) r2[i22 + p2] = -2, f3++, t22[p2] = -1, r2[a2 + p2] = 0;
        else if (m2 > o2) r2[s2 + p2] = 0, r2[i22 + p2] = -1, f3++, t22[p2] = csFlip(e4), r2[s2 + e4]++;
        else {
          var d2 = r2[u2 + m2];
          -1 !== d2 && (c3[d2] = p2), r2[l2 + p2] = r2[u2 + m2], r2[u2 + m2] = p2;
        }
      }
      return f3;
    })(c2, M2, O2, q2, R2, z2, f2, k2, I2, L2, B2), Z2 = 0; U2 < c2; ) {
      for (h = -1; Z2 < c2 && -1 === (h = O2[I2 + Z2]); Z2++) ;
      -1 !== O2[B2 + h] && (L2[O2[B2 + h]] = -1), O2[I2 + Z2] = O2[B2 + h];
      var G2 = O2[R2 + h], V2 = O2[k2 + h];
      U2 += V2;
      var H2 = 0;
      O2[k2 + h] = -V2;
      var X2 = M2[h], W2 = 0 === G2 ? X2 : T2, Q2 = W2;
      for (g = 1; g <= G2 + 1; g++) {
        for (g > G2 ? (v2 = h, x2 = X2, b2 = O2[0 + h] - G2) : (x2 = M2[v2 = C2[X2++]], b2 = O2[0 + v2]), y = 1; y <= b2; y++) (_2 = O2[k2 + (m = C2[x2++])]) <= 0 || (H2 += _2, O2[k2 + m] = -_2, C2[Q2++] = m, -1 !== O2[B2 + m] && (L2[O2[B2 + m]] = L2[m]), -1 !== L2[m] ? O2[B2 + L2[m]] = O2[B2 + m] : O2[I2 + O2[q2 + m]] = O2[B2 + m]);
        v2 !== h && (M2[v2] = csFlip(h), O2[z2 + v2] = 0);
      }
      for (0 !== G2 && (T2 = Q2), O2[q2 + h] = H2, M2[h] = W2, O2[0 + h] = Q2 - W2, O2[R2 + h] = -2, j2 = i2(j2, l, O2, z2, c2), w2 = W2; w2 < Q2; w2++) if (!((A2 = O2[R2 + (m = C2[w2])]) <= 0)) {
        var Y2 = j2 - (_2 = -O2[k2 + m]);
        for (X2 = M2[m], N = M2[m] + A2 - 1; X2 <= N; X2++) O2[z2 + (v2 = C2[X2])] >= j2 ? O2[z2 + v2] -= _2 : 0 !== O2[z2 + v2] && (O2[z2 + v2] = O2[q2 + v2] + Y2);
      }
      for (w2 = W2; w2 < Q2; w2++) {
        for (D = (N = M2[m = C2[w2]]) + O2[R2 + m] - 1, E = N, $2 = 0, S2 = 0, X2 = N; X2 <= D; X2++) if (0 !== O2[z2 + (v2 = C2[X2])]) {
          var J = O2[z2 + v2] - j2;
          J > 0 ? (S2 += J, C2[E++] = v2, $2 += v2) : (M2[v2] = csFlip(h), O2[z2 + v2] = 0);
        }
        O2[R2 + m] = E - N + 1;
        var K2 = E, ee2 = N + O2[0 + m];
        for (X2 = D + 1; X2 < ee2; X2++) {
          var te2 = O2[k2 + (d = C2[X2])];
          te2 <= 0 || (S2 += te2, C2[E++] = d, $2 += d);
        }
        0 === S2 ? (M2[m] = csFlip(h), H2 -= _2 = -O2[k2 + m], V2 += _2, U2 += _2, O2[k2 + m] = 0, O2[R2 + m] = -1) : (O2[q2 + m] = Math.min(O2[q2 + m], S2), C2[E] = C2[K2], C2[K2] = C2[N], C2[N] = h, O2[0 + m] = E - N + 1, $2 = ($2 < 0 ? -$2 : $2) % c2, O2[B2 + m] = O2[P2 + $2], O2[P2 + $2] = m, L2[m] = $2);
      }
      for (O2[q2 + h] = H2, j2 = i2(j2 + (l = Math.max(l, H2)), l, O2, z2, c2), w2 = W2; w2 < Q2; w2++) if (!(O2[k2 + (m = C2[w2])] >= 0)) for (m = O2[P2 + ($2 = L2[m])], O2[P2 + $2] = -1; -1 !== m && -1 !== O2[B2 + m]; m = O2[B2 + m], j2++) {
        for (b2 = O2[0 + m], A2 = O2[R2 + m], X2 = M2[m] + 1; X2 <= M2[m] + b2 - 1; X2++) O2[z2 + C2[X2]] = j2;
        var re2 = m;
        for (d = O2[B2 + m]; -1 !== d; ) {
          var ne = O2[0 + d] === b2 && O2[R2 + d] === A2;
          for (X2 = M2[d] + 1; ne && X2 <= M2[d] + b2 - 1; X2++) O2[z2 + C2[X2]] !== j2 && (ne = 0);
          ne ? (M2[d] = csFlip(m), O2[k2 + m] += O2[k2 + d], O2[k2 + d] = 0, O2[R2 + d] = -1, d = O2[B2 + d], O2[B2 + re2] = d) : (re2 = d, d = O2[B2 + d]);
        }
      }
      for (X2 = W2, w2 = W2; w2 < Q2; w2++) (_2 = -O2[k2 + (m = C2[w2])]) <= 0 || (O2[k2 + m] = _2, S2 = O2[q2 + m] + H2 - _2, -1 !== O2[I2 + (S2 = Math.min(S2, c2 - U2 - _2))] && (L2[O2[I2 + S2]] = m), O2[B2 + m] = O2[I2 + S2], L2[m] = -1, O2[I2 + S2] = m, Z2 = Math.min(Z2, S2), O2[q2 + m] = S2, C2[X2++] = m);
      O2[k2 + h] = V2, 0 == (O2[0 + h] = X2 - W2) && (M2[h] = -1, O2[z2 + h] = 0), 0 !== G2 && (T2 = X2);
    }
    for (m = 0; m < c2; m++) M2[m] = csFlip(M2[m]);
    for (d = 0; d <= c2; d++) O2[I2 + d] = -1;
    for (d = c2; d >= 0; d--) O2[k2 + d] > 0 || (O2[B2 + d] = O2[I2 + M2[d]], O2[I2 + M2[d]] = d);
    for (v2 = c2; v2 >= 0; v2--) O2[k2 + v2] <= 0 || -1 !== M2[v2] && (O2[B2 + v2] = O2[I2 + M2[v2]], O2[I2 + M2[v2]] = v2);
    for (h = 0, m = 0; m <= c2; m++) -1 === M2[m] && (h = csTdfs(m, h, O2, I2, B2, F, z2));
    return F.splice(F.length - 1, 1), F;
  };
  function i2(e3, t22, r2, n3, i22) {
    if (e3 < 2 || e3 + t22 < 0) {
      for (var a2 = 0; a2 < i22; a2++) 0 !== r2[n3 + a2] && (r2[n3 + a2] = 1);
      e3 = 2;
    }
    return e3;
  }
  function a(e3, t22) {
    return e3 !== t22;
  }
}));
function csLeaf(e2, t2, r, n, i2, a, o) {
  var s, u, c2, l = 0;
  if (e2 <= t2 || r[n + t2] <= r[i2 + e2]) return -1;
  r[i2 + e2] = r[n + t2];
  var f2 = r[a + e2];
  if (r[a + e2] = t2, -1 === f2) l = 1, c2 = e2;
  else {
    for (l = 2, c2 = f2; c2 !== r[o + c2]; c2 = r[o + c2]) ;
    for (s = f2; s !== c2; s = u) u = r[o + s], r[o + s] = c2;
  }
  return { jleaf: l, q: c2 };
}
var name$1m = "csCounts", dependencies$1m = ["transpose"], createCsCounts = factory(name$1m, dependencies$1m, ((e2) => {
  var { transpose: t2 } = e2;
  return function(e3, r, n, i2) {
    if (!e3 || !r || !n) return null;
    var a, o, s, u, c2, l, f2, p = e3._size, m = p[0], d = p[1], h = 4 * d + (i2 ? d + m + 1 : 0), g = [], y = d, v2 = 2 * d, x2 = 3 * d, b2 = 4 * d, _2 = 5 * d + 1;
    for (s = 0; s < h; s++) g[s] = -1;
    var w2 = [], A2 = t2(e3), N = A2._index, D = A2._ptr;
    for (s = 0; s < d; s++) for (w2[o = n[s]] = -1 === g[x2 + o] ? 1 : 0; -1 !== o && -1 === g[x2 + o]; o = r[o]) g[x2 + o] = s;
    if (i2) {
      for (s = 0; s < d; s++) g[n[s]] = s;
      for (a = 0; a < m; a++) {
        for (s = d, l = D[a], f2 = D[a + 1], c2 = l; c2 < f2; c2++) s = Math.min(s, g[N[c2]]);
        g[_2 + a] = g[b2 + s], g[b2 + s] = a;
      }
    }
    for (a = 0; a < d; a++) g[0 + a] = a;
    for (s = 0; s < d; s++) {
      for (-1 !== r[o = n[s]] && w2[r[o]]--, u = i2 ? g[b2 + s] : o; -1 !== u; u = i2 ? g[_2 + u] : -1) for (c2 = D[u]; c2 < D[u + 1]; c2++) {
        var E = csLeaf(a = N[c2], o, g, x2, y, v2, 0);
        E.jleaf >= 1 && w2[o]++, 2 === E.jleaf && w2[E.q]--;
      }
      -1 !== r[o] && (g[0 + o] = r[o]);
    }
    for (o = 0; o < d; o++) -1 !== r[o] && (w2[r[o]] += w2[o]);
    return w2;
  };
})), name$1l = "csSqr", dependencies$1l = ["add", "multiply", "transpose"], createCsSqr = factory(name$1l, dependencies$1l, ((e2) => {
  var { add: t2, multiply: r, transpose: n } = e2, i2 = createCsAmd({ add: t2, multiply: r, transpose: n }), a = createCsCounts({ transpose: n });
  return function(e3, t22, r2) {
    var n3, o = t22._ptr, s = t22._size[1], u = {};
    if (u.q = i2(e3, t22), e3 && !u.q) return null;
    if (r2) {
      var c2 = e3 ? csPermute(t22, null, u.q) : t22;
      u.parent = csEtree(c2);
      var l = csPost(u.parent, s);
      if (u.cp = a(c2, u.parent, l, 1), c2 && u.parent && u.cp && (function(e4, t3) {
        var r3 = e4._ptr, n4 = e4._index, i22 = e4._size, a2 = i22[0], o2 = i22[1];
        t3.pinv = [], t3.leftmost = [];
        var s2, u2, c3, l2, f2, p = t3.parent, m = t3.pinv, d = t3.leftmost, h = [], g = 0, y = a2, v2 = a2 + o2, x2 = a2 + 2 * o2;
        for (u2 = 0; u2 < o2; u2++) h[y + u2] = -1, h[v2 + u2] = -1, h[x2 + u2] = 0;
        for (s2 = 0; s2 < a2; s2++) d[s2] = -1;
        for (u2 = o2 - 1; u2 >= 0; u2--) for (l2 = r3[u2], f2 = r3[u2 + 1], c3 = l2; c3 < f2; c3++) d[n4[c3]] = u2;
        for (s2 = a2 - 1; s2 >= 0; s2--) m[s2] = -1, -1 !== (u2 = d[s2]) && (0 == h[x2 + u2]++ && (h[v2 + u2] = s2), h[g + s2] = h[y + u2], h[y + u2] = s2);
        for (t3.lnz = 0, t3.m2 = a2, u2 = 0; u2 < o2; u2++) if (s2 = h[y + u2], t3.lnz++, s2 < 0 && (s2 = t3.m2++), m[s2] = u2, !(--x2[u2] <= 0)) {
          t3.lnz += h[x2 + u2];
          var b2 = p[u2];
          -1 !== b2 && (0 === h[x2 + b2] && (h[v2 + b2] = h[v2 + u2]), h[g + h[v2 + u2]] = h[y + b2], h[y + b2] = h[g + s2], h[x2 + b2] += h[x2 + u2]);
        }
        for (s2 = 0; s2 < a2; s2++) m[s2] < 0 && (m[s2] = u2++);
        return true;
      })(c2, u)) for (u.unz = 0, n3 = 0; n3 < s; n3++) u.unz += u.cp[n3];
    } else u.unz = 4 * o[s] + s, u.lnz = u.unz;
    return u;
  };
}));
function csMarked(e2, t2) {
  return e2[t2] < 0;
}
function csMark(e2, t2) {
  e2[t2] = csFlip(e2[t2]);
}
function csUnflip(e2) {
  return e2 < 0 ? csFlip(e2) : e2;
}
function csDfs(e2, t2, r, n, i2) {
  var a, o, s, u = t2._index, c2 = t2._ptr, l = t2._size[1], f2 = 0;
  for (n[0] = e2; f2 >= 0; ) {
    e2 = n[f2];
    var p = i2 ? i2[e2] : e2;
    csMarked(c2, e2) || (csMark(c2, e2), n[l + f2] = p < 0 ? 0 : csUnflip(c2[p]));
    var m = 1;
    for (o = n[l + f2], s = p < 0 ? 0 : csUnflip(c2[p + 1]); o < s; o++) if (!csMarked(c2, a = u[o])) {
      n[l + f2] = o, n[++f2] = a, m = 0;
      break;
    }
    m && (f2--, n[--r] = e2);
  }
  return r;
}
function csReach(e2, t2, r, n, i2) {
  var a, o, s, u = e2._ptr, c2 = e2._size, l = t2._index, f2 = t2._ptr, p = c2[1], m = p;
  for (o = f2[r], s = f2[r + 1], a = o; a < s; a++) {
    var d = l[a];
    csMarked(u, d) || (m = csDfs(d, e2, m, n, i2));
  }
  for (a = m; a < p; a++) csMark(u, n[a]);
  return m;
}
var name$1k = "csSpsolve", dependencies$1k = ["divideScalar", "multiply", "subtract"], createCsSpsolve = factory(name$1k, dependencies$1k, ((e2) => {
  var { divideScalar: t2, multiply: r, subtract: n } = e2;
  return function(e3, i2, a, o, s, u, c2) {
    var l, f2, p, m, d = e3._values, h = e3._index, g = e3._ptr, y = e3._size[1], v2 = i2._values, x2 = i2._index, b2 = i2._ptr, _2 = csReach(e3, i2, a, o, u);
    for (l = _2; l < y; l++) s[o[l]] = 0;
    for (f2 = b2[a], p = b2[a + 1], l = f2; l < p; l++) s[x2[l]] = v2[l];
    for (var w2 = _2; w2 < y; w2++) {
      var A2 = o[w2], N = u ? u[A2] : A2;
      if (!(N < 0)) for (f2 = g[N], p = g[N + 1], s[A2] = t2(s[A2], d[c2 ? f2 : p - 1]), l = c2 ? f2 + 1 : f2, m = c2 ? p : p - 1; l < m; l++) {
        var D = h[l];
        s[D] = n(s[D], r(d[l], s[A2]));
      }
    }
    return _2;
  };
})), name$1j = "csLu", dependencies$1j = ["abs", "divideScalar", "multiply", "subtract", "larger", "largerEq", "SparseMatrix"], createCsLu = factory(name$1j, dependencies$1j, ((e2) => {
  var { abs: t2, divideScalar: r, multiply: n, subtract: i2, larger: a, largerEq: o, SparseMatrix: s } = e2, u = createCsSpsolve({ divideScalar: r, multiply: n, subtract: i2 });
  return function(e3, i22, c2) {
    if (!e3) return null;
    var l, f2 = e3._size[1], p = 100, m = 100;
    i22 && (l = i22.q, p = i22.lnz || p, m = i22.unz || m);
    var d, h, g = [], y = [], v2 = [], x2 = new s({ values: g, index: y, ptr: v2, size: [f2, f2] }), b2 = [], _2 = [], w2 = [], A2 = new s({ values: b2, index: _2, ptr: w2, size: [f2, f2] }), N = [], D = [], E = [];
    for (d = 0; d < f2; d++) D[d] = 0, N[d] = -1, v2[d + 1] = 0;
    p = 0, m = 0;
    for (var $2 = 0; $2 < f2; $2++) {
      v2[$2] = p, w2[$2] = m;
      var S2 = l ? l[$2] : $2, C2 = u(x2, e3, S2, E, D, N, 1), M2 = -1, T2 = -1;
      for (h = C2; h < f2; h++) if (N[d = E[h]] < 0) {
        var F = t2(D[d]);
        a(F, T2) && (T2 = F, M2 = d);
      } else _2[m] = N[d], b2[m++] = D[d];
      if (-1 === M2 || T2 <= 0) return null;
      N[S2] < 0 && o(t2(D[S2]), n(T2, c2)) && (M2 = S2);
      var O2 = D[M2];
      for (_2[m] = $2, b2[m++] = O2, N[M2] = $2, y[p] = M2, g[p++] = 1, h = C2; h < f2; h++) N[d = E[h]] < 0 && (y[p] = d, g[p++] = r(D[d], O2)), D[d] = 0;
    }
    for (v2[f2] = p, w2[f2] = m, h = 0; h < p; h++) y[h] = N[y[h]];
    return g.splice(p, g.length - p), y.splice(p, y.length - p), b2.splice(m, b2.length - m), _2.splice(m, _2.length - m), { L: x2, U: A2, pinv: N };
  };
})), name$1i = "slu", dependencies$1i = ["typed", "abs", "add", "multiply", "transpose", "divideScalar", "subtract", "larger", "largerEq", "SparseMatrix"], createSlu = factory(name$1i, dependencies$1i, ((e2) => {
  var { typed: t2, abs: r, add: n, multiply: i2, transpose: a, divideScalar: o, subtract: s, larger: u, largerEq: c2, SparseMatrix: l } = e2, f2 = createCsSqr({ add: n, multiply: i2, transpose: a }), p = createCsLu({ abs: r, divideScalar: o, multiply: i2, subtract: s, larger: u, largerEq: c2, SparseMatrix: l });
  return t2(name$1i, { "SparseMatrix, number, number": function(e3, t22, r2) {
    if (!isInteger(t22) || t22 < 0 || t22 > 3) throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
    if (r2 < 0 || r2 > 1) throw new Error("Partial pivoting threshold must be a number from 0 to 1");
    var n3 = f2(t22, e3, false), i22 = p(e3, n3, r2);
    return { L: i22.L, U: i22.U, p: i22.pinv, q: n3.q, toString: function() {
      return "L: " + this.L.toString() + "\nU: " + this.U.toString() + "\np: " + this.p.toString() + (this.q ? "\nq: " + this.q.toString() : "") + "\n";
    } };
  } });
}));
function csIpvec(e2, t2) {
  var r, n = t2.length, i2 = [];
  if (e2) for (r = 0; r < n; r++) i2[e2[r]] = t2[r];
  else for (r = 0; r < n; r++) i2[r] = t2[r];
  return i2;
}
var name$1h = "lusolve", dependencies$1h = ["typed", "matrix", "lup", "slu", "usolve", "lsolve", "DenseMatrix"], createLusolve = factory(name$1h, dependencies$1h, ((e2) => {
  var { typed: t2, matrix: r, lup: n, slu: i2, usolve: a, lsolve: o, DenseMatrix: s } = e2, u = createSolveValidation({ DenseMatrix: s });
  return t2(name$1h, { "Array, Array | Matrix": function(e3, t22) {
    e3 = r(e3);
    var i22 = n(e3);
    return l(i22.L, i22.U, i22.p, null, t22).valueOf();
  }, "DenseMatrix, Array | Matrix": function(e3, t22) {
    var r2 = n(e3);
    return l(r2.L, r2.U, r2.p, null, t22);
  }, "SparseMatrix, Array | Matrix": function(e3, t22) {
    var r2 = n(e3);
    return l(r2.L, r2.U, r2.p, null, t22);
  }, "SparseMatrix, Array | Matrix, number, number": function(e3, t22, r2, n3) {
    var a2 = i2(e3, r2, n3);
    return l(a2.L, a2.U, a2.p, a2.q, t22);
  }, "Object, Array | Matrix": function(e3, t22) {
    return l(e3.L, e3.U, e3.p, e3.q, t22);
  } });
  function c2(e3) {
    if (isMatrix(e3)) return e3;
    if (isArray$1(e3)) return r(e3);
    throw new TypeError("Invalid Matrix LU decomposition");
  }
  function l(e3, t22, r2, n3, i22) {
    e3 = c2(e3), t22 = c2(t22), r2 && ((i22 = u(e3, i22, true))._data = csIpvec(r2, i22._data));
    var s2 = o(e3, i22), l2 = a(t22, s2);
    return n3 && (l2._data = csIpvec(n3, l2._data)), l2;
  }
})), name$1g = "polynomialRoot", dependencies$1g = ["typed", "isZero", "equalScalar", "add", "subtract", "multiply", "divide", "sqrt", "unaryMinus", "cbrt", "typeOf", "im", "re"], createPolynomialRoot = factory(name$1g, dependencies$1g, ((e2) => {
  var { typed: t2, isZero: r, equalScalar: n, add: i2, subtract: a, multiply: o, divide: s, sqrt: u, unaryMinus: c2, cbrt: l, typeOf: f2, im: p, re: m } = e2;
  return t2(name$1g, { "number|Complex, ...number|Complex": (e3, t22) => {
    for (var d = [e3, ...t22]; d.length > 0 && r(d[d.length - 1]); ) d.pop();
    if (d.length < 2) throw new RangeError("Polynomial [".concat(e3, ", ").concat(t22, "] must have a non-zero non-constant coefficient"));
    switch (d.length) {
      case 2:
        return [c2(s(d[0], d[1]))];
      case 3:
        var [h, g, y] = d, v2 = o(2, y), x2 = o(g, g), b2 = o(4, y, h);
        if (n(x2, b2)) return [s(c2(g), v2)];
        var _2 = u(a(x2, b2));
        return [s(a(_2, g), v2), s(a(c2(_2), g), v2)];
      case 4:
        var [w2, A2, N, D] = d, E = c2(o(3, D)), $2 = o(N, N), S2 = o(3, D, A2), C2 = i2(o(2, N, N, N), o(27, D, D, w2)), M2 = o(9, D, N, A2);
        if (n($2, S2) && n(C2, M2)) return [s(N, E)];
        var T2, F = a($2, S2), O2 = a(C2, M2), k2 = i2(o(18, D, N, A2, w2), o(N, N, A2, A2)), B2 = i2(o(4, N, N, N, w2), o(4, D, A2, A2, A2), o(27, D, D, w2, w2));
        if (n(k2, B2)) return [s(a(o(4, D, N, A2), i2(o(9, D, D, w2), o(N, N, N))), o(D, F)), s(a(o(9, D, w2), o(N, A2)), o(2, F))];
        T2 = n($2, S2) ? O2 : s(i2(O2, u(a(o(O2, O2), o(4, F, F, F)))), 2);
        return l(T2, true).toArray().map(((e4) => s(i2(N, e4, s(F, e4)), E))).map(((e4) => "Complex" === f2(e4) && n(m(e4), m(e4) + p(e4)) ? m(e4) : e4));
      default:
        throw new RangeError("only implemented for cubic or lower-order polynomials, not ".concat(d));
    }
  } });
})), name$1f = "Help", dependencies$1f = ["evaluate"], createHelpClass = factory(name$1f, dependencies$1f, ((e2) => {
  var { evaluate: t2 } = e2;
  function r(e3) {
    if (!(this instanceof r)) throw new SyntaxError("Constructor must be called with the new operator");
    if (!e3) throw new Error('Argument "doc" missing');
    this.doc = e3;
  }
  return r.prototype.type = "Help", r.prototype.isHelp = true, r.prototype.toString = function() {
    var e3 = this.doc || {}, r2 = "\n";
    if (e3.name && (r2 += "Name: " + e3.name + "\n\n"), e3.category && (r2 += "Category: " + e3.category + "\n\n"), e3.description && (r2 += "Description:\n    " + e3.description + "\n\n"), e3.syntax && (r2 += "Syntax:\n    " + e3.syntax.join("\n    ") + "\n\n"), e3.examples) {
      r2 += "Examples:\n";
      for (var n = false, i2 = t2("config()"), a = { config: (e4) => (n = true, t2("config(newConfig)", { newConfig: e4 })) }, o = 0; o < e3.examples.length; o++) {
        var s = e3.examples[o];
        r2 += "    " + s + "\n";
        var u = void 0;
        try {
          u = t2(s, a);
        } catch (e4) {
          u = e4;
        }
        void 0 === u || isHelp(u) || (r2 += "        " + format(u, { precision: 14 }) + "\n");
      }
      r2 += "\n", n && t2("config(originalConfig)", { originalConfig: i2 });
    }
    return e3.mayThrow && e3.mayThrow.length && (r2 += "Throws: " + e3.mayThrow.join(", ") + "\n\n"), e3.seealso && e3.seealso.length && (r2 += "See also: " + e3.seealso.join(", ") + "\n"), r2;
  }, r.prototype.toJSON = function() {
    var e3 = clone$3(this.doc);
    return e3.mathjs = "Help", e3;
  }, r.fromJSON = function(e3) {
    var t22 = {};
    return Object.keys(e3).filter(((e4) => "mathjs" !== e4)).forEach(((r2) => {
      t22[r2] = e3[r2];
    })), new r(t22);
  }, r.prototype.valueOf = r.prototype.toString, r;
}), { isClass: true }), name$1e = "Chain", dependencies$1e = ["?on", "math", "typed"], createChainClass = factory(name$1e, dependencies$1e, ((e2) => {
  var { on: t2, math: r, typed: n } = e2;
  function i2(e3) {
    if (!(this instanceof i2)) throw new SyntaxError("Constructor must be called with the new operator");
    isChain(e3) ? this.value = e3.value : this.value = e3;
  }
  function a(e3, t22) {
    lazy(i2.prototype, e3, (function() {
      var e4 = t22();
      if ("function" == typeof e4) return o(e4);
    }));
  }
  function o(e3) {
    return function() {
      if (0 === arguments.length) return new i2(e3(this.value));
      for (var t22 = [this.value], r2 = 0; r2 < arguments.length; r2++) t22[r2 + 1] = arguments[r2];
      if (n.isTypedFunction(e3)) {
        var a2 = n.resolve(e3, t22);
        if (1 === a2.params.length) throw new Error("chain function " + e3.name + " cannot match rest parameter between chain value and additional arguments.");
        return new i2(a2.implementation.apply(e3, t22));
      }
      return new i2(e3.apply(e3, t22));
    };
  }
  i2.prototype.type = "Chain", i2.prototype.isChain = true, i2.prototype.done = function() {
    return this.value;
  }, i2.prototype.valueOf = function() {
    return this.value;
  }, i2.prototype.toString = function() {
    return format(this.value);
  }, i2.prototype.toJSON = function() {
    return { mathjs: "Chain", value: this.value };
  }, i2.fromJSON = function(e3) {
    return new i2(e3.value);
  }, i2.createProxy = function(e3, t22) {
    if ("string" == typeof e3) !(function(e4, t3) {
      "function" == typeof t3 && (i2.prototype[e4] = o(t3));
    })(e3, t22);
    else {
      var r2 = function(t3) {
        hasOwnProperty$1$1(e3, t3) && void 0 === s[t3] && a(t3, (() => e3[t3]));
      };
      for (var n3 in e3) r2(n3);
    }
  };
  var s = { expression: true, docs: true, type: true, classes: true, json: true, error: true, isChain: true };
  return i2.createProxy(r), t2 && t2("import", (function(e3, t22, r2) {
    r2 || a(e3, t22);
  })), i2;
}), { isClass: true }), eDocs = { name: "e", category: "Constants", syntax: ["e"], description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828", examples: ["e", "e ^ 2", "exp(2)", "log(e)"], seealso: ["exp"] }, falseDocs = { name: "false", category: "Constants", syntax: ["false"], description: "Boolean value false", examples: ["false"], seealso: ["true"] }, iDocs = { name: "i", category: "Constants", syntax: ["i"], description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.", examples: ["i", "i * i", "sqrt(-1)"], seealso: [] }, InfinityDocs = { name: "Infinity", category: "Constants", syntax: ["Infinity"], description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.", examples: ["Infinity", "1 / 0"], seealso: [] }, LN10Docs = { name: "LN10", category: "Constants", syntax: ["LN10"], description: "Returns the natural logarithm of 10, approximately equal to 2.302", examples: ["LN10", "log(10)"], seealso: [] }, LN2Docs = { name: "LN2", category: "Constants", syntax: ["LN2"], description: "Returns the natural logarithm of 2, approximately equal to 0.693", examples: ["LN2", "log(2)"], seealso: [] }, LOG10EDocs = { name: "LOG10E", category: "Constants", syntax: ["LOG10E"], description: "Returns the base-10 logarithm of E, approximately equal to 0.434", examples: ["LOG10E", "log(e, 10)"], seealso: [] }, LOG2EDocs = { name: "LOG2E", category: "Constants", syntax: ["LOG2E"], description: "Returns the base-2 logarithm of E, approximately equal to 1.442", examples: ["LOG2E", "log(e, 2)"], seealso: [] }, NaNDocs = { name: "NaN", category: "Constants", syntax: ["NaN"], description: "Not a number", examples: ["NaN", "0 / 0"], seealso: [] }, nullDocs = { name: "null", category: "Constants", syntax: ["null"], description: "Value null", examples: ["null"], seealso: ["true", "false"] }, phiDocs = { name: "phi", category: "Constants", syntax: ["phi"], description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...", examples: ["phi"], seealso: [] }, piDocs = { name: "pi", category: "Constants", syntax: ["pi"], description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159", examples: ["pi", "sin(pi/2)"], seealso: ["tau"] }, SQRT12Docs = { name: "SQRT1_2", category: "Constants", syntax: ["SQRT1_2"], description: "Returns the square root of 1/2, approximately equal to 0.707", examples: ["SQRT1_2", "sqrt(1/2)"], seealso: [] }, SQRT2Docs = { name: "SQRT2", category: "Constants", syntax: ["SQRT2"], description: "Returns the square root of 2, approximately equal to 1.414", examples: ["SQRT2", "sqrt(2)"], seealso: [] }, tauDocs = { name: "tau", category: "Constants", syntax: ["tau"], description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.", examples: ["tau", "2 * pi"], seealso: ["pi"] }, trueDocs = { name: "true", category: "Constants", syntax: ["true"], description: "Boolean value true", examples: ["true"], seealso: ["false"] }, versionDocs = { name: "version", category: "Constants", syntax: ["version"], description: "A string with the version number of math.js", examples: ["version"], seealso: [] }, bignumberDocs = { name: "bignumber", category: "Construction", syntax: ["bignumber(x)"], description: "Create a big number from a number or string.", examples: ["0.1 + 0.2", "bignumber(0.1) + bignumber(0.2)", 'bignumber("7.2")', 'bignumber("7.2e500")', "bignumber([0.1, 0.2, 0.3])"], seealso: ["boolean", "bigint", "complex", "fraction", "index", "matrix", "string", "unit"] }, bigintDocs = { name: "bigint", category: "Construction", syntax: ["bigint(x)"], description: "Create a bigint, an integer with an arbitrary number of digits, from a number or string.", examples: ["123123123123123123 # a large number will lose digits", 'bigint("123123123123123123")', 'bignumber(["1", "3", "5"])'], seealso: ["boolean", "bignumber", "number", "complex", "fraction", "index", "matrix", "string", "unit"] }, booleanDocs = { name: "boolean", category: "Construction", syntax: ["x", "boolean(x)"], description: "Convert a string or number into a boolean.", examples: ["boolean(0)", "boolean(1)", "boolean(3)", 'boolean("true")', 'boolean("false")', "boolean([1, 0, 1, 1])"], seealso: ["bignumber", "complex", "index", "matrix", "number", "string", "unit"] }, complexDocs = { name: "complex", category: "Construction", syntax: ["complex()", "complex(re, im)", "complex(string)"], description: "Create a complex number.", examples: ["complex()", "complex(2, 3)", 'complex("7 - 2i")'], seealso: ["bignumber", "boolean", "index", "matrix", "number", "string", "unit"] }, createUnitDocs = { name: "createUnit", category: "Construction", syntax: ["createUnit(definitions)", "createUnit(name, definition)"], description: "Create a user-defined unit and register it with the Unit type.", examples: ['createUnit("foo")', 'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})', 'createUnit("mph", "1 mile/hour")'], seealso: ["unit", "splitUnit"] }, fractionDocs = { name: "fraction", category: "Construction", syntax: ["fraction(num)", "fraction(matrix)", "fraction(num,den)", "fraction({n: num, d: den})"], description: "Create a fraction from a number or from integer numerator and denominator.", examples: ["fraction(0.125)", "fraction(1, 3) + fraction(2, 5)", "fraction({n: 333, d: 53})", "fraction([sqrt(9), sqrt(10), sqrt(11)])"], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "string", "unit"] }, indexDocs = { name: "index", category: "Construction", syntax: ["[start]", "[start:end]", "[start:step:end]", "[start1, start 2, ...]", "[start1:end1, start2:end2, ...]", "[start1:step1:end1, start2:step2:end2, ...]"], description: "Create an index to get or replace a subset of a matrix", examples: ["A = [1, 2, 3; 4, 5, 6]", "A[1, :]", "A[1, 2] = 50", "A[1:2, 1:2] = 1", "B = [1, 2, 3]", "B[B>1 and B<3]"], seealso: ["bignumber", "boolean", "complex", "matrix", "number", "range", "string", "unit"] }, matrixDocs = { name: "matrix", category: "Construction", syntax: ["[]", "[a1, b1, ...; a2, b2, ...]", "matrix()", 'matrix("dense")', "matrix([...])"], description: "Create a matrix.", examples: ["[]", "[1, 2, 3]", "[1, 2, 3; 4, 5, 6]", "matrix()", "matrix([3, 4])", 'matrix([3, 4; 5, 6], "sparse")', 'matrix([3, 4; 5, 6], "sparse", "number")'], seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "sparse"] }, numberDocs = { name: "number", category: "Construction", syntax: ["x", "number(x)", "number(unit, valuelessUnit)"], description: "Create a number or convert a string or boolean into a number.", examples: ["2", "2e3", "4.05", "number(2)", 'number("7.2")', "number(true)", "number([true, false, true, true])", 'number(unit("52cm"), "m")'], seealso: ["bignumber", "bigint", "boolean", "complex", "fraction", "index", "matrix", "string", "unit"] }, sparseDocs = { name: "sparse", category: "Construction", syntax: ["sparse()", "sparse([a1, b1, ...; a1, b2, ...])", 'sparse([a1, b1, ...; a1, b2, ...], "number")'], description: "Create a sparse matrix.", examples: ["sparse()", "sparse([3, 4; 5, 6])", 'sparse([3, 0; 5, 0], "number")'], seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "matrix"] }, splitUnitDocs = { name: "splitUnit", category: "Construction", syntax: ["splitUnit(unit: Unit, parts: Unit[])"], description: "Split a unit in an array of units whose sum is equal to the original unit.", examples: ['splitUnit(1 m, ["feet", "inch"])'], seealso: ["unit", "createUnit"] }, stringDocs = { name: "string", category: "Construction", syntax: ['"text"', "string(x)"], description: "Create a string or convert a value to a string", examples: ['"Hello World!"', "string(4.2)", "string(3 + 2i)"], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "unit"] }, unitDocs = { name: "unit", category: "Construction", syntax: ["value unit", "unit(value, unit)", "unit(string)"], description: "Create a unit.", examples: ["5.5 mm", "3 inch", 'unit(7.1, "kilogram")', 'unit("23 deg")'], seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "string"] }, configDocs = { name: "config", category: "Core", syntax: ["config()", "config(options)"], description: "Get configuration or change configuration.", examples: ["config()", "1/3 + 1/4", 'config({number: "Fraction"})', "1/3 + 1/4"], seealso: [] }, importDocs = { name: "import", category: "Core", syntax: ["import(functions)", "import(functions, options)"], description: "Import functions or constants from an object.", examples: ["import({myFn: f(x)=x^2, myConstant: 32 })", "myFn(2)", "myConstant"], seealso: [] }, typedDocs = { name: "typed", category: "Core", syntax: ["typed(signatures)", "typed(name, signatures)"], description: "Create a typed function.", examples: ['double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })', "double(2)", 'double("hello")'], seealso: [] }, derivativeDocs = { name: "derivative", category: "Algebra", syntax: ["derivative(expr, variable)", "derivative(expr, variable, {simplify: boolean})"], description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.", examples: ['derivative("2x^3", "x")', 'derivative("2x^3", "x", {simplify: false})', 'derivative("2x^2 + 3x + 4", "x")', 'derivative("sin(2x)", "x")', 'f = parse("x^2 + x")', 'x = parse("x")', "df = derivative(f, x)", "df.evaluate({x: 3})"], seealso: ["simplify", "parse", "evaluate"] }, leafCountDocs = { name: "leafCount", category: "Algebra", syntax: ["leafCount(expr)"], description: "Computes the number of leaves in the parse tree of the given expression", examples: ['leafCount("e^(i*pi)-1")', 'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'], seealso: ["simplify"] }, lsolveDocs = { name: "lsolve", category: "Algebra", syntax: ["x=lsolve(L, b)"], description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"], seealso: ["lsolveAll", "lup", "lusolve", "usolve", "matrix", "sparse"] }, lsolveAllDocs = { name: "lsolveAll", category: "Algebra", syntax: ["x=lsolveAll(L, b)"], description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"], seealso: ["lsolve", "lup", "lusolve", "usolve", "matrix", "sparse"] }, lupDocs = { name: "lup", category: "Algebra", syntax: ["lup(m)"], description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U", examples: ["lup([[2, 1], [1, 4]])", "lup(matrix([[2, 1], [1, 4]]))", "lup(sparse([[2, 1], [1, 4]]))"], seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "slu", "qr"] }, lusolveDocs = { name: "lusolve", category: "Algebra", syntax: ["x=lusolve(A, b)", "x=lusolve(lu, b)"], description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.", examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lusolve(a, b)"], seealso: ["lup", "slu", "lsolve", "usolve", "matrix", "sparse"] }, polynomialRootDocs = { name: "polynomialRoot", category: "Algebra", syntax: ["x=polynomialRoot(-6, 3)", "x=polynomialRoot(4, -4, 1)", "x=polynomialRoot(-8, 12, -6, 1)"], description: "Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.", examples: ["a = polynomialRoot(-6, 11, -6, 1)"], seealso: ["cbrt", "sqrt"] }, qrDocs = { name: "qr", category: "Algebra", syntax: ["qr(A)"], description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.", examples: ["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"], seealso: ["lup", "slu", "matrix"] }, rationalizeDocs = { name: "rationalize", category: "Algebra", syntax: ["rationalize(expr)", "rationalize(expr, scope)", "rationalize(expr, scope, detailed)"], description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.", examples: ['rationalize("2x/y - y/(x+1)")', 'rationalize("2x/y - y/(x+1)", true)'], seealso: ["simplify"] }, resolveDocs = { name: "resolve", category: "Algebra", syntax: ["resolve(node, scope)"], description: "Recursively substitute variables in an expression tree.", examples: ['resolve(parse("1 + x"), { x: 7 })', 'resolve(parse("size(text)"), { text: "Hello World" })', 'resolve(parse("x + y"), { x: parse("3z") })', 'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'], seealso: ["simplify", "evaluate"], mayThrow: ["ReferenceError"] }, simplifyDocs = { name: "simplify", category: "Algebra", syntax: ["simplify(expr)", "simplify(expr, rules)"], description: "Simplify an expression tree.", examples: ['simplify("3 + 2 / 4")', 'simplify("2x + x")', 'f = parse("x * (x + 2 + x)")', "simplified = simplify(f)", "simplified.evaluate({x: 2})"], seealso: ["simplifyCore", "derivative", "evaluate", "parse", "rationalize", "resolve"] }, simplifyConstantDocs = { name: "simplifyConstant", category: "Algebra", syntax: ["simplifyConstant(expr)", "simplifyConstant(expr, options)"], description: "Replace constant subexpressions of node with their values.", examples: ['simplifyConstant("(3-3)*x")', 'simplifyConstant(parse("z-cos(tau/8)"))'], seealso: ["simplify", "simplifyCore", "evaluate"] }, simplifyCoreDocs = { name: "simplifyCore", category: "Algebra", syntax: ["simplifyCore(node)"], description: "Perform simple one-pass simplifications on an expression tree.", examples: ['simplifyCore(parse("0*x"))', 'simplifyCore(parse("(x+0)*2"))'], seealso: ["simplify", "simplifyConstant", "evaluate"] }, sluDocs = { name: "slu", category: "Algebra", syntax: ["slu(A, order, threshold)"], description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U", examples: ["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"], seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "lup", "qr"] }, symbolicEqualDocs = { name: "symbolicEqual", category: "Algebra", syntax: ["symbolicEqual(expr1, expr2)", "symbolicEqual(expr1, expr2, options)"], description: "Returns true if the difference of the expressions simplifies to 0", examples: ['symbolicEqual("x*y","y*x")', 'symbolicEqual("abs(x^2)", "x^2")', 'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'], seealso: ["simplify", "evaluate"] }, usolveDocs = { name: "usolve", category: "Algebra", syntax: ["x=usolve(U, b)"], description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.", examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"], seealso: ["usolveAll", "lup", "lusolve", "lsolve", "matrix", "sparse"] }, usolveAllDocs = { name: "usolveAll", category: "Algebra", syntax: ["x=usolve(U, b)"], description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.", examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"], seealso: ["usolve", "lup", "lusolve", "lsolve", "matrix", "sparse"] }, absDocs = { name: "abs", category: "Arithmetic", syntax: ["abs(x)"], description: "Compute the absolute value.", examples: ["abs(3.5)", "abs(-4.2)"], seealso: ["sign"] }, addDocs = { name: "add", category: "Operators", syntax: ["x + y", "add(x, y)"], description: "Add two values.", examples: ["a = 2.1 + 3.6", "a - 3.6", "3 + 2i", "3 cm + 2 inch", '"2.3" + "4"'], seealso: ["subtract"] }, cbrtDocs = { name: "cbrt", category: "Arithmetic", syntax: ["cbrt(x)", "cbrt(x, allRoots)"], description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned", examples: ["cbrt(64)", "cube(4)", "cbrt(-8)", "cbrt(2 + 3i)", "cbrt(8i)", "cbrt(8i, true)", "cbrt(27 m^3)"], seealso: ["square", "sqrt", "cube", "multiply"] }, ceilDocs = { name: "ceil", category: "Arithmetic", syntax: ["ceil(x)", "ceil(x, n)", "ceil(unit, valuelessUnit)", "ceil(unit, n, valuelessUnit)"], description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.", examples: ["ceil(3.2)", "ceil(3.8)", "ceil(-4.2)", "ceil(3.241cm, cm)", "ceil(3.241cm, 2, cm)"], seealso: ["floor", "fix", "round"] }, cubeDocs = { name: "cube", category: "Arithmetic", syntax: ["cube(x)"], description: "Compute the cube of a value. The cube of x is x * x * x.", examples: ["cube(2)", "2^3", "2 * 2 * 2"], seealso: ["multiply", "square", "pow"] }, divideDocs = { name: "divide", category: "Operators", syntax: ["x / y", "divide(x, y)"], description: "Divide two values.", examples: ["a = 2 / 3", "a * 3", "4.5 / 2", "3 + 4 / 2", "(3 + 4) / 2", "18 km / 4.5"], seealso: ["multiply"] }, dotDivideDocs = { name: "dotDivide", category: "Operators", syntax: ["x ./ y", "dotDivide(x, y)"], description: "Divide two values element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a ./ b"], seealso: ["multiply", "dotMultiply", "divide"] }, dotMultiplyDocs = { name: "dotMultiply", category: "Operators", syntax: ["x .* y", "dotMultiply(x, y)"], description: "Multiply two values element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a .* b"], seealso: ["multiply", "divide", "dotDivide"] }, dotPowDocs = { name: "dotPow", category: "Operators", syntax: ["x .^ y", "dotPow(x, y)"], description: "Calculates the power of x to y element wise.", examples: ["a = [1, 2, 3; 4, 5, 6]", "a .^ 2"], seealso: ["pow"] }, expDocs = { name: "exp", category: "Arithmetic", syntax: ["exp(x)"], description: "Calculate the exponent of a value.", examples: ["exp(1.3)", "e ^ 1.3", "log(exp(1.3))", "x = 2.4", "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"], seealso: ["expm", "expm1", "pow", "log"] }, expmDocs = { name: "expm", category: "Arithmetic", syntax: ["exp(x)"], description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.", examples: ["expm([[0,2],[0,0]])"], seealso: ["exp"] }, expm1Docs = { name: "expm1", category: "Arithmetic", syntax: ["expm1(x)"], description: "Calculate the value of subtracting 1 from the exponential value.", examples: ["expm1(2)", "pow(e, 2) - 1", "log(expm1(2) + 1)"], seealso: ["exp", "pow", "log"] }, fixDocs = { name: "fix", category: "Arithmetic", syntax: ["fix(x)", "fix(x, n)", "fix(unit, valuelessUnit)", "fix(unit, n, valuelessUnit)"], description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.", examples: ["fix(3.2)", "fix(3.8)", "fix(-4.2)", "fix(-4.8)", "fix(3.241cm, cm)", "fix(3.241cm, 2, cm)"], seealso: ["ceil", "floor", "round"] }, floorDocs = { name: "floor", category: "Arithmetic", syntax: ["floor(x)", "floor(x, n)", "floor(unit, valuelessUnit)", "floor(unit, n, valuelessUnit)"], description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.", examples: ["floor(3.2)", "floor(3.8)", "floor(-4.2)", "floor(3.241cm, cm)", "floor(3.241cm, 2, cm)"], seealso: ["ceil", "fix", "round"] }, gcdDocs = { name: "gcd", category: "Arithmetic", syntax: ["gcd(a, b)", "gcd(a, b, c, ...)"], description: "Compute the greatest common divisor.", examples: ["gcd(8, 12)", "gcd(-4, 6)", "gcd(25, 15, -10)"], seealso: ["lcm", "xgcd"] }, hypotDocs = { name: "hypot", category: "Arithmetic", syntax: ["hypot(a, b, c, ...)", "hypot([a, b, c, ...])"], description: "Calculate the hypotenuse of a list with values.", examples: ["hypot(3, 4)", "sqrt(3^2 + 4^2)", "hypot(-2)", "hypot([3, 4, 5])"], seealso: ["abs", "norm"] }, invmodDocs = { name: "invmod", category: "Arithmetic", syntax: ["invmod(a, b)"], description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)", examples: ["invmod(8, 12)", "invmod(7, 13)", "invmod(15151, 15122)"], seealso: ["gcd", "xgcd"] }, lcmDocs = { name: "lcm", category: "Arithmetic", syntax: ["lcm(x, y)"], description: "Compute the least common multiple.", examples: ["lcm(4, 6)", "lcm(6, 21)", "lcm(6, 21, 5)"], seealso: ["gcd"] }, logDocs = { name: "log", category: "Arithmetic", syntax: ["log(x)", "log(x, base)"], description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).", examples: ["log(3.5)", "a = log(2.4)", "exp(a)", "10 ^ 4", "log(10000, 10)", "log(10000) / log(10)", "b = log(1024, 2)", "2 ^ b"], seealso: ["exp", "log1p", "log2", "log10"] }, log10Docs = { name: "log10", category: "Arithmetic", syntax: ["log10(x)"], description: "Compute the 10-base logarithm of a value.", examples: ["log10(0.00001)", "log10(10000)", "10 ^ 4", "log(10000) / log(10)", "log(10000, 10)"], seealso: ["exp", "log"] }, log1pDocs = { name: "log1p", category: "Arithmetic", syntax: ["log1p(x)", "log1p(x, base)"], description: "Calculate the logarithm of a `value+1`", examples: ["log1p(2.5)", "exp(log1p(1.4))", "pow(10, 4)", "log1p(9999, 10)", "log1p(9999) / log(10)"], seealso: ["exp", "log", "log2", "log10"] }, log2Docs = { name: "log2", category: "Arithmetic", syntax: ["log2(x)"], description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.", examples: ["log2(0.03125)", "log2(16)", "log2(16) / log2(2)", "pow(2, 4)"], seealso: ["exp", "log1p", "log", "log10"] }, modDocs = { name: "mod", category: "Operators", syntax: ["x % y", "x mod y", "mod(x, y)"], description: "Calculates the modulus, the remainder of an integer division.", examples: ["7 % 3", "11 % 2", "10 mod 4", "isOdd(x) = x % 2", "isOdd(2)", "isOdd(3)"], seealso: ["divide"] }, multiplyDocs = { name: "multiply", category: "Operators", syntax: ["x * y", "multiply(x, y)"], description: "multiply two values.", examples: ["a = 2.1 * 3.4", "a / 3.4", "2 * 3 + 4", "2 * (3 + 4)", "3 * 2.1 km"], seealso: ["divide"] }, normDocs = { name: "norm", category: "Arithmetic", syntax: ["norm(x)", "norm(x, p)"], description: "Calculate the norm of a number, vector or matrix.", examples: ["abs(-3.5)", "norm(-3.5)", "norm(3 - 4i)", "norm([1, 2, -3], Infinity)", "norm([1, 2, -3], -Infinity)", "norm([3, 4], 2)", "norm([[1, 2], [3, 4]], 1)", 'norm([[1, 2], [3, 4]], "inf")', 'norm([[1, 2], [3, 4]], "fro")'] }, nthRootDocs = { name: "nthRoot", category: "Arithmetic", syntax: ["nthRoot(a)", "nthRoot(a, root)"], description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".', examples: ["4 ^ 3", "nthRoot(64, 3)", "nthRoot(9, 2)", "sqrt(9)"], seealso: ["nthRoots", "pow", "sqrt"] }, nthRootsDocs = { name: "nthRoots", category: "Arithmetic", syntax: ["nthRoots(A)", "nthRoots(A, root)"], description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.', examples: ["nthRoots(1)", "nthRoots(1, 3)"], seealso: ["sqrt", "pow", "nthRoot"] }, powDocs = { name: "pow", category: "Operators", syntax: ["x ^ y", "pow(x, y)"], description: "Calculates the power of x to y, x^y.", examples: ["2^3", "2*2*2", "1 + e ^ (pi * i)", "pow([[1, 2], [4, 3]], 2)", "pow([[1, 2], [4, 3]], -1)"], seealso: ["multiply", "nthRoot", "nthRoots", "sqrt"] }, roundDocs = { name: "round", category: "Arithmetic", syntax: ["round(x)", "round(x, n)", "round(unit, valuelessUnit)", "round(unit, n, valuelessUnit)"], description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.", examples: ["round(3.2)", "round(3.8)", "round(-4.2)", "round(-4.8)", "round(pi, 3)", "round(123.45678, 2)", "round(3.241cm, 2, cm)", "round([3.2, 3.8, -4.7])"], seealso: ["ceil", "floor", "fix"] }, signDocs = { name: "sign", category: "Arithmetic", syntax: ["sign(x)"], description: "Compute the sign of a value. The sign of a value x is 1 when x>0, -1 when x<0, and 0 when x=0.", examples: ["sign(3.5)", "sign(-4.2)", "sign(0)"], seealso: ["abs"] }, sqrtDocs = { name: "sqrt", category: "Arithmetic", syntax: ["sqrt(x)"], description: "Compute the square root value. If x = y * y, then y is the square root of x.", examples: ["sqrt(25)", "5 * 5", "sqrt(-1)"], seealso: ["square", "sqrtm", "multiply", "nthRoot", "nthRoots", "pow"] }, sqrtmDocs = { name: "sqrtm", category: "Arithmetic", syntax: ["sqrtm(x)"], description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.", examples: ["sqrtm([[33, 24], [48, 57]])"], seealso: ["sqrt", "abs", "square", "multiply"] }, sylvesterDocs = { name: "sylvester", category: "Algebra", syntax: ["sylvester(A,B,C)"], description: "Solves the real-valued Sylvester equation AX+XB=C for X", examples: ["sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])", "A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]", "sylvester(A, B, C)"], seealso: ["schur", "lyap"] }, schurDocs = { name: "schur", category: "Algebra", syntax: ["schur(A)"], description: "Performs a real Schur decomposition of the real matrix A = UTU'", examples: ["schur([[1, 0], [-4, 3]])", "A = [[1, 0], [-4, 3]]", "schur(A)"], seealso: ["lyap", "sylvester"] }, lyapDocs = { name: "lyap", category: "Algebra", syntax: ["lyap(A,Q)"], description: "Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P", examples: ["lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])", "A = [[-2, 0], [1, -4]]", "Q = [[3, 1], [1, 3]]", "lyap(A,Q)"], seealso: ["schur", "sylvester"] }, squareDocs = { name: "square", category: "Arithmetic", syntax: ["square(x)"], description: "Compute the square of a value. The square of x is x * x.", examples: ["square(3)", "sqrt(9)", "3^2", "3 * 3"], seealso: ["multiply", "pow", "sqrt", "cube"] }, subtractDocs = { name: "subtract", category: "Operators", syntax: ["x - y", "subtract(x, y)"], description: "subtract two values.", examples: ["a = 5.3 - 2", "a + 2", "2/3 - 1/6", "2 * 3 - 3", "2.1 km - 500m"], seealso: ["add"] }, unaryMinusDocs = { name: "unaryMinus", category: "Operators", syntax: ["-x", "unaryMinus(x)"], description: "Inverse the sign of a value. Converts booleans and strings to numbers.", examples: ["-4.5", "-(-5.6)", '-"22"'], seealso: ["add", "subtract", "unaryPlus"] }, unaryPlusDocs = { name: "unaryPlus", category: "Operators", syntax: ["+x", "unaryPlus(x)"], description: "Converts booleans and strings to numbers.", examples: ["+true", '+"2"'], seealso: ["add", "subtract", "unaryMinus"] }, xgcdDocs = { name: "xgcd", category: "Arithmetic", syntax: ["xgcd(a, b)"], description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.", examples: ["xgcd(8, 12)", "gcd(8, 12)", "xgcd(36163, 21199)"], seealso: ["gcd", "lcm"] }, bitAndDocs = { name: "bitAnd", category: "Bitwise", syntax: ["x & y", "bitAnd(x, y)"], description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0", examples: ["5 & 3", "bitAnd(53, 131)", "[1, 12, 31] & 42"], seealso: ["bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitNotDocs = { name: "bitNot", category: "Bitwise", syntax: ["~x", "bitNot(x)"], description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.", examples: ["~1", "~2", "bitNot([2, -3, 4])"], seealso: ["bitAnd", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitOrDocs = { name: "bitOr", category: "Bitwise", syntax: ["x | y", "bitOr(x, y)"], description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.", examples: ["5 | 3", "bitOr([1, 2, 3], 4)"], seealso: ["bitAnd", "bitNot", "bitXor", "leftShift", "rightArithShift", "rightLogShift"] }, bitXorDocs = { name: "bitXor", category: "Bitwise", syntax: ["bitXor(x, y)"], description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.", examples: ["bitOr(1, 2)", "bitXor([2, 3, 4], 4)"], seealso: ["bitAnd", "bitNot", "bitOr", "leftShift", "rightArithShift", "rightLogShift"] }, leftShiftDocs = { name: "leftShift", category: "Bitwise", syntax: ["x << y", "leftShift(x, y)"], description: "Bitwise left logical shift of a value x by y number of bits.", examples: ["4 << 1", "8 >> 1"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "rightArithShift", "rightLogShift"] }, rightArithShiftDocs = { name: "rightArithShift", category: "Bitwise", syntax: ["x >> y", "rightArithShift(x, y)"], description: "Bitwise right arithmetic shift of a value x by y number of bits.", examples: ["8 >> 1", "4 << 1", "-12 >> 2"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightLogShift"] }, rightLogShiftDocs = { name: "rightLogShift", category: "Bitwise", syntax: ["x >>> y", "rightLogShift(x, y)"], description: "Bitwise right logical shift of a value x by y number of bits.", examples: ["8 >>> 1", "4 << 1", "-12 >>> 2"], seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift"] }, bellNumbersDocs = { name: "bellNumbers", category: "Combinatorics", syntax: ["bellNumbers(n)"], description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.", examples: ["bellNumbers(3)", "bellNumbers(8)"], seealso: ["stirlingS2"] }, catalanDocs = { name: "catalan", category: "Combinatorics", syntax: ["catalan(n)"], description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.", examples: ["catalan(3)", "catalan(8)"], seealso: ["bellNumbers"] }, compositionDocs = { name: "composition", category: "Combinatorics", syntax: ["composition(n, k)"], description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.", examples: ["composition(5, 3)"], seealso: ["combinations"] }, stirlingS2Docs = { name: "stirlingS2", category: "Combinatorics", syntax: ["stirlingS2(n, k)"], description: "The Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.", examples: ["stirlingS2(5, 3)"], seealso: ["bellNumbers", "bernoulli"] }, argDocs = { name: "arg", category: "Complex", syntax: ["arg(x)"], description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).", examples: ["arg(2 + 2i)", "atan2(3, 2)", "arg(2 + 3i)"], seealso: ["re", "im", "conj", "abs"] }, conjDocs = { name: "conj", category: "Complex", syntax: ["conj(x)"], description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.", examples: ["conj(2 + 3i)", "conj(2 - 3i)", "conj(-5.2i)"], seealso: ["re", "im", "abs", "arg"] }, imDocs = { name: "im", category: "Complex", syntax: ["im(x)"], description: "Get the imaginary part of a complex number.", examples: ["im(2 + 3i)", "re(2 + 3i)", "im(-5.2i)", "im(2.4)"], seealso: ["re", "conj", "abs", "arg"] }, reDocs = { name: "re", category: "Complex", syntax: ["re(x)"], description: "Get the real part of a complex number.", examples: ["re(2 + 3i)", "im(2 + 3i)", "re(-5.2i)", "re(2.4)"], seealso: ["im", "conj", "abs", "arg"] }, evaluateDocs = { name: "evaluate", category: "Expression", syntax: ["evaluate(expression)", "evaluate(expression, scope)", "evaluate([expr1, expr2, expr3, ...])", "evaluate([expr1, expr2, expr3, ...], scope)"], description: "Evaluate an expression or an array with expressions.", examples: ['evaluate("2 + 3")', 'evaluate("sqrt(16)")', 'evaluate("2 inch to cm")', 'evaluate("sin(x * pi)", { "x": 1/2 })', 'evaluate(["width=2", "height=4","width*height"])'], seealso: ["parser", "parse", "compile"] }, parserDocs = { name: "parser", category: "Expression", syntax: ["parser()"], description: "Create a parser object that keeps a context of variables and their values, allowing the evaluation of expressions in that context.", examples: ["myParser = parser()", 'myParser.evaluate("sqrt(3^2 + 4^2)")', 'myParser.set("x", 3)', 'myParser.evaluate("y = x + 3")', 'myParser.evaluate(["y = x + 3", "y = y + 1"])', 'myParser.get("y")'], seealso: ["evaluate", "parse", "compile"] }, parseDocs = { name: "parse", category: "Expression", syntax: ["parse(expr)", "parse(expr, options)", "parse([expr1, expr2, expr3, ...])", "parse([expr1, expr2, expr3, ...], options)"], description: "Parse an expression. Returns a node tree, which can be evaluated by invoking node.evaluate() or transformed into a functional object via node.compile().", examples: ['node1 = parse("sqrt(3^2 + 4^2)")', "node1.evaluate()", "code1 = node1.compile()", "code1.evaluate()", "scope = {a: 3, b: 4}", 'node2 = parse("a * b")', "node2.evaluate(scope)", "code2 = node2.compile()", "code2.evaluate(scope)"], seealso: ["parser", "evaluate", "compile"] }, compileDocs = { name: "compile", category: "Expression", syntax: ["compile(expr) ", "compile([expr1, expr2, expr3, ...])"], description: "Parse and compile an expression. Returns a an object with a function evaluate([scope]) to evaluate the compiled expression.", examples: ['code1 = compile("sqrt(3^2 + 4^2)")', "code1.evaluate() ", 'code2 = compile("a * b")', "code2.evaluate({a: 3, b: 4})"], seealso: ["parser", "parse", "evaluate"] }, helpDocs = { name: "help", category: "Expression", syntax: ["help(object)", "help(string)"], description: "Display documentation on a function or data type.", examples: ["help(sqrt)", 'help("complex")'], seealso: [] }, distanceDocs = { name: "distance", category: "Geometry", syntax: ["distance([x1, y1], [x2, y2])", "distance([[x1, y1], [x2, y2]])"], description: "Calculates the Euclidean distance between two points.", examples: ["distance([0,0], [4,4])", "distance([[0,0], [4,4]])"], seealso: [] }, intersectDocs = { name: "intersect", category: "Geometry", syntax: ["intersect(expr1, expr2, expr3, expr4)", "intersect(expr1, expr2, expr3)"], description: "Computes the intersection point of lines and/or planes.", examples: ["intersect([0, 0], [10, 10], [10, 0], [0, 10])", "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"], seealso: [] }, andDocs = { name: "and", category: "Logical", syntax: ["x and y", "and(x, y)"], description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.", examples: ["true and false", "true and true", "2 and 4"], seealso: ["not", "or", "xor"] }, notDocs = { name: "not", category: "Logical", syntax: ["not x", "not(x)"], description: "Logical not. Flips the boolean value of given argument.", examples: ["not true", "not false", "not 2", "not 0"], seealso: ["and", "or", "xor"] }, nullishDocs = { name: "nullish", category: "Logical", syntax: ["x ?? y", "nullish(x, y)"], description: "Nullish coalescing operator. Returns the right-hand operand when the left-hand operand is null or undefined, and otherwise returns the left-hand operand.", examples: ["null ?? 42", "undefined ?? 42", "0 ?? 42", "false ?? 42", "null ?? undefined ?? 42"], seealso: ["and", "or", "not"] }, orDocs = { name: "or", category: "Logical", syntax: ["x or y", "or(x, y)"], description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.", examples: ["true or false", "false or false", "0 or 4"], seealso: ["not", "and", "xor"] }, xorDocs = { name: "xor", category: "Logical", syntax: ["x xor y", "xor(x, y)"], description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.", examples: ["true xor false", "false xor false", "true xor true", "0 xor 4"], seealso: ["not", "and", "or"] }, mapSlicesDocs = { name: "mapSlices", category: "Matrix", syntax: ["mapSlices(A, dim, callback)"], description: "Generate a matrix one dimension less than A by applying callback to each slice of A along dimension dim.", examples: ["A = [[1, 2], [3, 4]]", "mapSlices(A, 1, sum)", "mapSlices(A, 2, prod)"], seealso: ["map", "forEach"] }, columnDocs = { name: "column", category: "Matrix", syntax: ["column(x, index)"], description: "Return a column from a matrix or array.", examples: ["A = [[1, 2], [3, 4]]", "column(A, 1)", "column(A, 2)"], seealso: ["row", "matrixFromColumns"] }, concatDocs = { name: "concat", category: "Matrix", syntax: ["concat(A, B, C, ...)", "concat(A, B, C, ..., dim)"], description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.", examples: ["A = [1, 2; 5, 6]", "B = [3, 4; 7, 8]", "concat(A, B)", "concat(A, B, 1)", "concat(A, B, 2)"], seealso: ["det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, countDocs = { name: "count", category: "Matrix", syntax: ["count(x)"], description: "Count the number of elements of a matrix, array or string.", examples: ["a = [1, 2; 3, 4; 5, 6]", "count(a)", "size(a)", 'count("hello world")'], seealso: ["size"] }, crossDocs = { name: "cross", category: "Matrix", syntax: ["cross(A, B)"], description: "Calculate the cross product for two vectors in three dimensional space.", examples: ["cross([1, 1, 0],  [0, 1, 1])", "cross([3, -3, 1], [4, 9, 2])", "cross([2, 3, 4],  [5, 6, 7])"], seealso: ["multiply", "dot"] }, ctransposeDocs = { name: "ctranspose", category: "Matrix", syntax: ["x'", "ctranspose(x)"], description: "Complex Conjugate and Transpose a matrix", examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "ctranspose(a)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"] }, detDocs = { name: "det", category: "Matrix", syntax: ["det(x)"], description: "Calculate the determinant of a matrix", examples: ["det([1, 2; 3, 4])", "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"], seealso: ["concat", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, diagDocs = { name: "diag", category: "Matrix", syntax: ["diag(x)", "diag(x, k)"], description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.", examples: ["diag(1:3)", "diag(1:3, 1)", "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]", "diag(a)"], seealso: ["concat", "det", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, diffDocs = { name: "diff", category: "Matrix", syntax: ["diff(arr)", "diff(arr, dim)"], description: ["Create a new matrix or array with the difference of the passed matrix or array.", "Dim parameter is optional and used to indicate the dimension of the array/matrix to apply the difference", "If no dimension parameter is passed it is assumed as dimension 0", "Dimension is zero-based in javascript and one-based in the parser", "Arrays must be 'rectangular' meaning arrays like [1, 2]", "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"], examples: ["A = [1, 2, 4, 7, 0]", "diff(A)", "diff(A, 1)", "B = [[1, 2], [3, 4]]", "diff(B)", "diff(B, 1)", "diff(B, 2)", "diff(B, bignumber(2))", "diff([[1, 2], matrix([3, 4])], 2)"], seealso: ["subtract", "partitionSelect"] }, dotDocs = { name: "dot", category: "Matrix", syntax: ["dot(A, B)", "A * B"], description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn", examples: ["dot([2, 4, 1], [2, 2, 3])", "[2, 4, 1] * [2, 2, 3]"], seealso: ["multiply", "cross"] }, eigsDocs = { name: "eigs", category: "Matrix", syntax: ["eigs(x)"], description: "Calculate the eigenvalues and optionally eigenvectors of a square matrix", examples: ["eigs([[5, 2.3], [2.3, 1]])", "eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })"], seealso: ["inv"] }, filterDocs = { name: "filter", category: "Matrix", syntax: ["filter(x, test)"], description: "Filter items in a matrix.", examples: ["isPositive(x) = x > 0", "filter([6, -2, -1, 4, 3], isPositive)", "filter([6, -2, 0, 1, 0], x != 0)"], seealso: ["sort", "map", "forEach"] }, flattenDocs = { name: "flatten", category: "Matrix", syntax: ["flatten(x)"], description: "Flatten a multi dimensional matrix into a single dimensional matrix.", examples: ["a = [1, 2, 3; 4, 5, 6]", "size(a)", "b = flatten(a)", "size(b)"], seealso: ["concat", "resize", "size", "squeeze"] }, forEachDocs = { name: "forEach", category: "Matrix", syntax: ["forEach(x, callback)"], description: "Iterates over all elements of a matrix/array, and executes the given callback function.", examples: ["numberOfPets = {}", "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;", 'forEach(["Dog","Cat","Cat"], addPet)', "numberOfPets"], seealso: ["map", "sort", "filter"] }, getMatrixDataTypeDocs = { name: "getMatrixDataType", category: "Matrix", syntax: ["getMatrixDataType(x)"], description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".', examples: ["getMatrixDataType([1, 2, 3])", "getMatrixDataType([[5 cm], [2 inch]])", 'getMatrixDataType([1, "text"])', "getMatrixDataType([1, bignumber(4)])"], seealso: ["matrix", "sparse", "typeOf"] }, identityDocs = { name: "identity", category: "Matrix", syntax: ["identity(n)", "identity(m, n)", "identity([m, n])"], description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.", examples: ["identity(3)", "identity(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "identity(size(a))"], seealso: ["concat", "det", "diag", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, invDocs = { name: "inv", category: "Matrix", syntax: ["inv(x)"], description: "Calculate the inverse of a matrix", examples: ["inv([1, 2; 3, 4])", "inv(4)", "1 / 4"], seealso: ["concat", "det", "diag", "identity", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, pinvDocs = { name: "pinv", category: "Matrix", syntax: ["pinv(x)"], description: "Calculate the Moore–Penrose inverse of a matrix", examples: ["pinv([1, 2; 3, 4])", "pinv([[1, 0], [0, 1], [0, 1]])", "pinv(4)"], seealso: ["inv"] }, kronDocs = { name: "kron", category: "Matrix", syntax: ["kron(x, y)"], description: "Calculates the Kronecker product of 2 matrices or vectors.", examples: ["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])", "kron([1,1], [2,3,4])"], seealso: ["multiply", "dot", "cross"] }, mapDocs = { name: "map", category: "Matrix", syntax: ["map(x, callback)", "map(x, y, ..., callback)"], description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array or the matrices/arrays.", examples: ["map([1, 2, 3], square)", "map([1, 2], [3, 4], f(a,b) = a + b)"], seealso: ["filter", "forEach"] }, matrixFromColumnsDocs = { name: "matrixFromColumns", category: "Matrix", syntax: ["matrixFromColumns(...arr)", "matrixFromColumns(row1, row2)", "matrixFromColumns(row1, row2, row3)"], description: "Create a dense matrix from vectors as individual columns.", examples: ["matrixFromColumns([1, 2, 3], [[4],[5],[6]])"], seealso: ["matrix", "matrixFromRows", "matrixFromFunction", "zeros"] }, matrixFromFunctionDocs = { name: "matrixFromFunction", category: "Matrix", syntax: ["matrixFromFunction(size, fn)", "matrixFromFunction(size, fn, format)", "matrixFromFunction(size, fn, format, datatype)", "matrixFromFunction(size, format, fn)", "matrixFromFunction(size, format, datatype, fn)"], description: "Create a matrix by evaluating a generating function at each index.", examples: ["f(I) = I[1] - I[2]", "matrixFromFunction([3,3], f)", "g(I) = I[1] - I[2] == 1 ? 4 : 0", 'matrixFromFunction([100, 100], "sparse", g)', "matrixFromFunction([5], random)"], seealso: ["matrix", "matrixFromRows", "matrixFromColumns", "zeros"] }, matrixFromRowsDocs = { name: "matrixFromRows", category: "Matrix", syntax: ["matrixFromRows(...arr)", "matrixFromRows(row1, row2)", "matrixFromRows(row1, row2, row3)"], description: "Create a dense matrix from vectors as individual rows.", examples: ["matrixFromRows([1, 2, 3], [[4],[5],[6]])"], seealso: ["matrix", "matrixFromColumns", "matrixFromFunction", "zeros"] }, onesDocs = { name: "ones", category: "Matrix", syntax: ["ones(m)", "ones(m, n)", "ones(m, n, p, ...)", "ones([m])", "ones([m, n])", "ones([m, n, p, ...])"], description: "Create a matrix containing ones.", examples: ["ones(3)", "ones(3, 5)", "ones([2,3]) * 4.5", "a = [1, 2, 3; 4, 5, 6]", "ones(size(a))"], seealso: ["concat", "det", "diag", "identity", "inv", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, partitionSelectDocs = { name: "partitionSelect", category: "Matrix", syntax: ["partitionSelect(x, k)", "partitionSelect(x, k, compare)"], description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.", examples: ["partitionSelect([5, 10, 1], 2)", 'partitionSelect(["C", "B", "A", "D"], 1, compareText)', "arr = [5, 2, 1]", "partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]", "arr", "partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]", "arr"], seealso: ["sort"] }, rangeDocs = { name: "range", category: "Type", syntax: ["start:end", "start:step:end", "range(start, end)", "range(start, end, step)", "range(string)"], description: "Create a range. Lower bound of the range is included, upper bound is excluded.", examples: ["1:5", "3:-1:-3", "range(3, 7)", "range(0, 12, 2)", 'range("4:10")', "range(1m, 1m, 3m)", "a = [1, 2, 3, 4; 5, 6, 7, 8]", "a[1:2, 1:2]"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "size", "squeeze", "subset", "trace", "transpose", "zeros"] }, reshapeDocs = { name: "reshape", category: "Matrix", syntax: ["reshape(x, sizes)"], description: "Reshape a multi dimensional array to fit the specified dimensions.", examples: ["reshape([1, 2, 3, 4, 5, 6], [2, 3])", "reshape([[1, 2], [3, 4]], [1, 4])", "reshape([[1, 2], [3, 4]], [4])", "reshape([1, 2, 3, 4], [-1, 2])"], seealso: ["size", "squeeze", "resize"] }, resizeDocs = { name: "resize", category: "Matrix", syntax: ["resize(x, size)", "resize(x, size, defaultValue)"], description: "Resize a matrix.", examples: ["resize([1,2,3,4,5], [3])", "resize([1,2,3], [5])", "resize([1,2,3], [5], -1)", "resize(2, [2, 3])", 'resize("hello", [8], "!")'], seealso: ["size", "subset", "squeeze", "reshape"] }, rotateDocs = { name: "rotate", category: "Matrix", syntax: ["rotate(w, theta)", "rotate(w, theta, v)"], description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.", examples: ["rotate([1, 0], pi / 2)", 'rotate(matrix([1, 0]), unit("35deg"))', 'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])', 'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'], seealso: ["matrix", "rotationMatrix"] }, rotationMatrixDocs = { name: "rotationMatrix", category: "Matrix", syntax: ["rotationMatrix(theta)", "rotationMatrix(theta, v)", "rotationMatrix(theta, v, format)"], description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.", examples: ["rotationMatrix(pi / 2)", 'rotationMatrix(unit("45deg"), [0, 0, 1])', 'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'], seealso: ["cos", "sin"] }, rowDocs = { name: "row", category: "Matrix", syntax: ["row(x, index)"], description: "Return a row from a matrix or array.", examples: ["A = [[1, 2], [3, 4]]", "row(A, 1)", "row(A, 2)"], seealso: ["column", "matrixFromRows"] }, sizeDocs = { name: "size", category: "Matrix", syntax: ["size(x)"], description: "Calculate the size of a matrix.", examples: ["size(2.3)", 'size("hello world")', "a = [1, 2; 3, 4; 5, 6]", "size(a)", "size(1:6)"], seealso: ["concat", "count", "det", "diag", "identity", "inv", "ones", "range", "squeeze", "subset", "trace", "transpose", "zeros"] }, sortDocs = { name: "sort", category: "Matrix", syntax: ["sort(x)", "sort(x, compare)"], description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.', examples: ["sort([5, 10, 1])", 'sort(["C", "B", "A", "D"], "natural")', "sortByLength(a, b) = size(a)[1] - size(b)[1]", 'sort(["Langdon", "Tom", "Sara"], sortByLength)', 'sort(["10", "1", "2"], "natural")'], seealso: ["map", "filter", "forEach"] }, squeezeDocs = { name: "squeeze", category: "Matrix", syntax: ["squeeze(x)"], description: "Remove inner and outer singleton dimensions from a matrix.", examples: ["a = zeros(3,2,1)", "size(squeeze(a))", "b = zeros(1,1,3)", "size(squeeze(b))"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "subset", "trace", "transpose", "zeros"] }, subsetDocs = { name: "subset", category: "Matrix", syntax: ["value(index)", "value(index) = replacement", "subset(value, [index])", "subset(value, [index], replacement)"], description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.", examples: ["d = [1, 2; 3, 4]", "e = []", "e[1, 1:2] = [5, 6]", "e[2, :] = [7, 8]", "f = d * e", "f[2, 1]", "f[:, 1]", "f[[1,2], [1,3]] = [9, 10; 11, 12]", "f"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "trace", "transpose", "zeros"] }, traceDocs = { name: "trace", category: "Matrix", syntax: ["trace(A)"], description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.", examples: ["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]", "trace(A)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "transpose", "zeros"] }, transposeDocs = { name: "transpose", category: "Matrix", syntax: ["x'", "transpose(x)"], description: "Transpose a matrix", examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "transpose(a)"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"] }, zerosDocs = { name: "zeros", category: "Matrix", syntax: ["zeros(m)", "zeros(m, n)", "zeros(m, n, p, ...)", "zeros([m])", "zeros([m, n])", "zeros([m, n, p, ...])"], description: "Create a matrix containing zeros.", examples: ["zeros(3)", "zeros(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "zeros(size(a))"], seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose"] }, fftDocs = { name: "fft", category: "Matrix", syntax: ["fft(x)"], description: "Calculate N-dimensional Fourier transform", examples: ["fft([[1, 0], [1, 0]])"], seealso: ["ifft"] }, ifftDocs = { name: "ifft", category: "Matrix", syntax: ["ifft(x)"], description: "Calculate N-dimensional inverse Fourier transform", examples: ["ifft([[2, 2], [0, 0]])"], seealso: ["fft"] }, bernoulliDocs = { name: "bernoulli", category: "Probability", syntax: ["bernoulli(n)"], description: "The nth Bernoulli number", examples: ["bernoulli(4)", "bernoulli(fraction(12))"], seealso: ["combinations", "gamma", "stirlingS2"] }, combinationsDocs = { name: "combinations", category: "Probability", syntax: ["combinations(n, k)"], description: "Compute the number of combinations of n items taken k at a time", examples: ["combinations(7, 5)"], seealso: ["combinationsWithRep", "permutations", "factorial"] }, combinationsWithRepDocs = { name: "combinationsWithRep", category: "Probability", syntax: ["combinationsWithRep(n, k)"], description: "Compute the number of combinations of n items taken k at a time with replacements.", examples: ["combinationsWithRep(7, 5)"], seealso: ["combinations", "permutations", "factorial"] }, factorialDocs = { name: "factorial", category: "Probability", syntax: ["n!", "factorial(n)"], description: "Compute the factorial of a value", examples: ["5!", "5 * 4 * 3 * 2 * 1", "3!"], seealso: ["combinations", "combinationsWithRep", "permutations", "gamma"] }, gammaDocs = { name: "gamma", category: "Probability", syntax: ["gamma(n)"], description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.", examples: ["gamma(4)", "3!", "gamma(1/2)", "sqrt(pi)"], seealso: ["factorial"] }, lgammaDocs = { name: "lgamma", category: "Probability", syntax: ["lgamma(n)"], description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.", examples: ["lgamma(4)", "lgamma(1/2)", "lgamma(i)", "lgamma(complex(1.1, 2))"], seealso: ["gamma"] }, kldivergenceDocs = { name: "kldivergence", category: "Probability", syntax: ["kldivergence(x, y)"], description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.", examples: ["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"], seealso: [] }, multinomialDocs = { name: "multinomial", category: "Probability", syntax: ["multinomial(A)"], description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.", examples: ["multinomial([1, 2, 1])"], seealso: ["combinations", "factorial"] }, permutationsDocs = { name: "permutations", category: "Probability", syntax: ["permutations(n)", "permutations(n, k)"], description: "Compute the number of permutations of n items taken k at a time", examples: ["permutations(5)", "permutations(5, 3)"], seealso: ["combinations", "combinationsWithRep", "factorial"] }, pickRandomDocs = { name: "pickRandom", category: "Probability", syntax: ["pickRandom(array)", "pickRandom(array, number)", "pickRandom(array, weights)", "pickRandom(array, number, weights)", "pickRandom(array, weights, number)"], description: "Pick a random entry from a given array.", examples: ["pickRandom(0:10)", "pickRandom([1, 3, 1, 6])", "pickRandom([1, 3, 1, 6], 2)", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"], seealso: ["random", "randomInt"] }, randomDocs = { name: "random", category: "Probability", syntax: ["random()", "random(max)", "random(min, max)", "random(size)", "random(size, max)", "random(size, min, max)"], description: "Return a random number.", examples: ["random()", "random(10, 20)", "random([2, 3])"], seealso: ["pickRandom", "randomInt"] }, randomIntDocs = { name: "randomInt", category: "Probability", syntax: ["randomInt(max)", "randomInt(min, max)", "randomInt(size)", "randomInt(size, max)", "randomInt(size, min, max)"], description: "Return a random integer number", examples: ["randomInt(10, 20)", "randomInt([2, 3], 10)"], seealso: ["pickRandom", "random"] }, compareDocs = { name: "compare", category: "Relational", syntax: ["compare(x, y)"], description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ["compare(2, 3)", "compare(3, 2)", "compare(2, 2)", "compare(5cm, 40mm)", "compare(2, [1, 2, 3])"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compareNatural", "compareText"] }, compareNaturalDocs = { name: "compareNatural", category: "Relational", syntax: ["compareNatural(x, y)"], description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ["compareNatural(2, 3)", "compareNatural(3, 2)", "compareNatural(2, 2)", "compareNatural(5cm, 40mm)", 'compareNatural("2", "10")', "compareNatural(2 + 3i, 2 + 4i)", "compareNatural([1, 2, 4], [1, 2, 3])", "compareNatural([1, 5], [1, 2, 3])", "compareNatural([1, 2], [1, 2])", "compareNatural({a: 2}, {a: 4})"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare", "compareText"] }, compareTextDocs = { name: "compareText", category: "Relational", syntax: ["compareText(x, y)"], description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.", examples: ['compareText("B", "A")', 'compareText("A", "B")', 'compareText("A", "A")', 'compareText("2", "10")', 'compare("2", "10")', "compare(2, 10)", 'compareNatural("2", "10")', 'compareText("B", ["A", "B", "C"])'], seealso: ["compare", "compareNatural"] }, deepEqualDocs = { name: "deepEqual", category: "Relational", syntax: ["deepEqual(x, y)"], description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.", examples: ["deepEqual([1,3,4], [1,3,4])", "deepEqual([1,3,4], [1,3])"], seealso: ["equal", "unequal", "smaller", "larger", "smallerEq", "largerEq", "compare"] }, equalDocs = { name: "equal", category: "Relational", syntax: ["x == y", "equal(x, y)"], description: "Check equality of two values. Returns true if the values are equal, and false if not.", examples: ["2+2 == 3", "2+2 == 4", "a = 3.2", "b = 6-2.8", "a == b", "50cm == 0.5m"], seealso: ["unequal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual", "equalText"] }, equalTextDocs = { name: "equalText", category: "Relational", syntax: ["equalText(x, y)"], description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.", examples: ['equalText("Hello", "Hello")', 'equalText("a", "A")', 'equal("2e3", "2000")', 'equalText("2e3", "2000")', 'equalText("B", ["A", "B", "C"])'], seealso: ["compare", "compareNatural", "compareText", "equal"] }, largerDocs = { name: "larger", category: "Relational", syntax: ["x > y", "larger(x, y)"], description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not. Comparing a value with NaN returns false.", examples: ["2 > 3", "5 > 2*2", "a = 3.3", "b = 6-2.8", "(a > b)", "(b < a)", "5 cm > 2 inch"], seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare"] }, largerEqDocs = { name: "largerEq", category: "Relational", syntax: ["x >= y", "largerEq(x, y)"], description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.", examples: ["2 >= 1+1", "2 > 1+1", "a = 3.2", "b = 6-2.8", "(a >= b)"], seealso: ["equal", "unequal", "smallerEq", "smaller", "compare"] }, smallerDocs = { name: "smaller", category: "Relational", syntax: ["x < y", "smaller(x, y)"], description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not. Comparing a value with NaN returns false.", examples: ["2 < 3", "5 < 2*2", "a = 3.3", "b = 6-2.8", "(a < b)", "5 cm < 2 inch"], seealso: ["equal", "unequal", "larger", "smallerEq", "largerEq", "compare"] }, smallerEqDocs = { name: "smallerEq", category: "Relational", syntax: ["x <= y", "smallerEq(x, y)"], description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.", examples: ["2 <= 1+1", "2 < 1+1", "a = 3.2", "b = 6-2.8", "(a <= b)"], seealso: ["equal", "unequal", "larger", "smaller", "largerEq", "compare"] }, unequalDocs = { name: "unequal", category: "Relational", syntax: ["x != y", "unequal(x, y)"], description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.", examples: ["2+2 != 3", "2+2 != 4", "a = 3.2", "b = 6-2.8", "a != b", "50cm != 0.5m", "5 cm != 2 inch"], seealso: ["equal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"] }, setCartesianDocs = { name: "setCartesian", category: "Set", syntax: ["setCartesian(set1, set2)"], description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.", examples: ["setCartesian([1, 2], [3, 4])"], seealso: ["setUnion", "setIntersect", "setDifference", "setPowerset"] }, setDifferenceDocs = { name: "setDifference", category: "Set", syntax: ["setDifference(set1, set2)"], description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setIntersect", "setSymDifference"] }, setDistinctDocs = { name: "setDistinct", category: "Set", syntax: ["setDistinct(set)"], description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setDistinct([1, 1, 1, 2, 2, 3])"], seealso: ["setMultiplicity"] }, setIntersectDocs = { name: "setIntersect", category: "Set", syntax: ["setIntersect(set1, set2)"], description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])", "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setDifference"] }, setIsSubsetDocs = { name: "setIsSubset", category: "Set", syntax: ["setIsSubset(set1, set2)"], description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setIsSubset([1, 2], [3, 4, 5, 6])", "setIsSubset([3, 4], [3, 4, 5, 6])"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setMultiplicityDocs = { name: "setMultiplicity", category: "Set", syntax: ["setMultiplicity(element, set)"], description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setMultiplicity(1, [1, 2, 2, 4])", "setMultiplicity(2, [1, 2, 2, 4])"], seealso: ["setDistinct", "setSize"] }, setPowersetDocs = { name: "setPowerset", category: "Set", syntax: ["setPowerset(set)"], description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.", examples: ["setPowerset([1, 2, 3])"], seealso: ["setCartesian"] }, setSizeDocs = { name: "setSize", category: "Set", syntax: ["setSize(set)", "setSize(set, unique)"], description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.', examples: ["setSize([1, 2, 2, 4])", "setSize([1, 2, 2, 4], true)"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setSymDifferenceDocs = { name: "setSymDifference", category: "Set", syntax: ["setSymDifference(set1, set2)"], description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setUnion", "setIntersect", "setDifference"] }, setUnionDocs = { name: "setUnion", category: "Set", syntax: ["setUnion(set1, set2)"], description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.", examples: ["setUnion([1, 2, 3, 4], [3, 4, 5, 6])", "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"], seealso: ["setIntersect", "setDifference"] }, zpk2tfDocs = { name: "zpk2tf", category: "Signal", syntax: ["zpk2tf(z, p, k)"], description: "Compute the transfer function of a zero-pole-gain model.", examples: ["zpk2tf([1, 2], [-1, -2], 1)", "zpk2tf([1, 2], [-1, -2])", "zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"], seealso: [] }, freqzDocs = { name: "freqz", category: "Signal", syntax: ["freqz(b, a)", "freqz(b, a, w)"], description: "Calculates the frequency response of a filter given its numerator and denominator coefficients.", examples: ["freqz([1, 2], [1, 2, 3])", "freqz([1, 2], [1, 2, 3], [0, 1])", "freqz([1, 2], [1, 2, 3], 512)"], seealso: [] }, erfDocs = { name: "erf", category: "Special", syntax: ["erf(x)"], description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x", examples: ["erf(0.2)", "erf(-0.5)", "erf(4)"], seealso: [] }, zetaDocs = { name: "zeta", category: "Special", syntax: ["zeta(s)"], description: "Compute the Riemann Zeta Function using an infinite series and Riemann's Functional Equation for the entire complex plane", examples: ["zeta(0.2)", "zeta(-0.5)", "zeta(4)"], seealso: [] }, madDocs = { name: "mad", category: "Statistics", syntax: ["mad(a, b, c, ...)", "mad(A)"], description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.", examples: ["mad(10, 20, 30)", "mad([1, 2, 3])"], seealso: ["mean", "median", "std", "abs"] }, maxDocs = { name: "max", category: "Statistics", syntax: ["max(a, b, c, ...)", "max(A)", "max(A, dimension)"], description: "Compute the maximum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.", examples: ["max(2, 3, 4, 1)", "max([2, 3, 4, 1])", "max([2, 5; 4, 3])", "max([2, 5; 4, 3], 1)", "max([2, 5; 4, 3], 2)", "max(2.7, 7.1, -4.5, 2.0, 4.1)", "min(2.7, 7.1, -4.5, 2.0, 4.1)"], seealso: ["mean", "median", "min", "prod", "std", "sum", "variance"] }, meanDocs = { name: "mean", category: "Statistics", syntax: ["mean(a, b, c, ...)", "mean(A)", "mean(A, dimension)"], description: "Compute the arithmetic mean of a list of values.", examples: ["mean(2, 3, 4, 1)", "mean([2, 3, 4, 1])", "mean([2, 5; 4, 3])", "mean([2, 5; 4, 3], 1)", "mean([2, 5; 4, 3], 2)", "mean([1.0, 2.7, 3.2, 4.0])"], seealso: ["max", "median", "min", "prod", "std", "sum", "variance"] }, medianDocs = { name: "median", category: "Statistics", syntax: ["median(a, b, c, ...)", "median(A)"], description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.", examples: ["median(5, 2, 7)", "median([3, -1, 5, 7])"], seealso: ["max", "mean", "min", "prod", "std", "sum", "variance", "quantileSeq"] }, minDocs = { name: "min", category: "Statistics", syntax: ["min(a, b, c, ...)", "min(A)", "min(A, dimension)"], description: "Compute the minimum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.", examples: ["min(2, 3, 4, 1)", "min([2, 3, 4, 1])", "min([2, 5; 4, 3])", "min([2, 5; 4, 3], 1)", "min([2, 5; 4, 3], 2)", "min(2.7, 7.1, -4.5, 2.0, 4.1)", "max(2.7, 7.1, -4.5, 2.0, 4.1)"], seealso: ["max", "mean", "median", "prod", "std", "sum", "variance"] }, modeDocs = { name: "mode", category: "Statistics", syntax: ["mode(a, b, c, ...)", "mode(A)", "mode(A, a, b, B, c, ...)"], description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.", examples: ["mode(2, 1, 4, 3, 1)", "mode([1, 2.7, 3.2, 4, 2.7])", "mode(1, 4, 6, 1, 6)"], seealso: ["max", "mean", "min", "median", "prod", "std", "sum", "variance"] }, prodDocs = { name: "prod", category: "Statistics", syntax: ["prod(a, b, c, ...)", "prod(A)"], description: "Compute the product of all values.", examples: ["prod(2, 3, 4)", "prod([2, 3, 4])", "prod([2, 5; 4, 3])"], seealso: ["max", "mean", "min", "median", "min", "std", "sum", "variance"] }, quantileSeqDocs = { name: "quantileSeq", category: "Statistics", syntax: ["quantileSeq(A, prob[, sorted])", "quantileSeq(A, [prob1, prob2, ...][, sorted])", "quantileSeq(A, N[, sorted])"], description: "Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probability are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.", examples: ["quantileSeq([3, -1, 5, 7], 0.5)", "quantileSeq([3, -1, 5, 7], [1/3, 2/3])", "quantileSeq([3, -1, 5, 7], 2)", "quantileSeq([-1, 3, 5, 7], 0.5, true)"], seealso: ["mean", "median", "min", "max", "prod", "std", "sum", "variance"] }, stdDocs = { name: "std", category: "Statistics", syntax: ["std(a, b, c, ...)", "std(A)", "std(A, dimension)", "std(A, normalization)", "std(A, dimension, normalization)"], description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".', examples: ["std(2, 4, 6)", "std([2, 4, 6, 8])", 'std([2, 4, 6, 8], "uncorrected")', 'std([2, 4, 6, 8], "biased")', "std([1, 2, 3; 4, 5, 6])"], seealso: ["max", "mean", "min", "median", "prod", "sum", "variance"] }, cumSumDocs = { name: "cumsum", category: "Statistics", syntax: ["cumsum(a, b, c, ...)", "cumsum(A)"], description: "Compute the cumulative sum of all values.", examples: ["cumsum(2, 3, 4, 1)", "cumsum([2, 3, 4, 1])", "cumsum([1, 2; 3, 4])", "cumsum([1, 2; 3, 4], 1)", "cumsum([1, 2; 3, 4], 2)"], seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"] }, sumDocs = { name: "sum", category: "Statistics", syntax: ["sum(a, b, c, ...)", "sum(A)", "sum(A, dimension)"], description: "Compute the sum of all values.", examples: ["sum(2, 3, 4, 1)", "sum([2, 3, 4, 1])", "sum([2, 5; 4, 3])"], seealso: ["max", "mean", "median", "min", "prod", "std", "variance"] }, varianceDocs = { name: "variance", category: "Statistics", syntax: ["variance(a, b, c, ...)", "variance(A)", "variance(A, dimension)", "variance(A, normalization)", "variance(A, dimension, normalization)"], description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".', examples: ["variance(2, 4, 6)", "variance([2, 4, 6, 8])", 'variance([2, 4, 6, 8], "uncorrected")', 'variance([2, 4, 6, 8], "biased")', "variance([1, 2, 3; 4, 5, 6])"], seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"] }, corrDocs = { name: "corr", category: "Statistics", syntax: ["corr(A,B)"], description: "Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.", examples: ["corr([2, 4, 6, 8],[1, 2, 3, 6])", "corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"], seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"] }, acosDocs = { name: "acos", category: "Trigonometry", syntax: ["acos(x)"], description: "Compute the inverse cosine of a value in radians.", examples: ["acos(0.5)", "acos(cos(2.3))"], seealso: ["cos", "atan", "asin"] }, acoshDocs = { name: "acosh", category: "Trigonometry", syntax: ["acosh(x)"], description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.", examples: ["acosh(1.5)"], seealso: ["cosh", "asinh", "atanh"] }, acotDocs = { name: "acot", category: "Trigonometry", syntax: ["acot(x)"], description: "Calculate the inverse cotangent of a value.", examples: ["acot(0.5)", "acot(cot(0.5))", "acot(2)"], seealso: ["cot", "atan"] }, acothDocs = { name: "acoth", category: "Trigonometry", syntax: ["acoth(x)"], description: "Calculate the inverse hyperbolic tangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.", examples: ["acoth(2)", "acoth(0.5)"], seealso: ["acsch", "asech"] }, acscDocs = { name: "acsc", category: "Trigonometry", syntax: ["acsc(x)"], description: "Calculate the inverse cotangent of a value.", examples: ["acsc(2)", "acsc(csc(0.5))", "acsc(0.5)"], seealso: ["csc", "asin", "asec"] }, acschDocs = { name: "acsch", category: "Trigonometry", syntax: ["acsch(x)"], description: "Calculate the inverse hyperbolic cosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.", examples: ["acsch(0.5)"], seealso: ["asech", "acoth"] }, asecDocs = { name: "asec", category: "Trigonometry", syntax: ["asec(x)"], description: "Calculate the inverse secant of a value.", examples: ["asec(0.5)", "asec(sec(0.5))", "asec(2)"], seealso: ["acos", "acot", "acsc"] }, asechDocs = { name: "asech", category: "Trigonometry", syntax: ["asech(x)"], description: "Calculate the inverse secant of a value.", examples: ["asech(0.5)"], seealso: ["acsch", "acoth"] }, asinDocs = { name: "asin", category: "Trigonometry", syntax: ["asin(x)"], description: "Compute the inverse sine of a value in radians.", examples: ["asin(0.5)", "asin(sin(0.5))"], seealso: ["sin", "acos", "atan"] }, asinhDocs = { name: "asinh", category: "Trigonometry", syntax: ["asinh(x)"], description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.", examples: ["asinh(0.5)"], seealso: ["acosh", "atanh"] }, atanDocs = { name: "atan", category: "Trigonometry", syntax: ["atan(x)"], description: "Compute the inverse tangent of a value in radians.", examples: ["atan(0.5)", "atan(tan(0.5))"], seealso: ["tan", "acos", "asin"] }, atan2Docs = { name: "atan2", category: "Trigonometry", syntax: ["atan2(y, x)"], description: "Computes the principal value of the arc tangent of y/x in radians.", examples: ["atan2(2, 2) / pi", "angle = 60 deg in rad", "x = cos(angle)", "y = sin(angle)", "atan2(y, x)"], seealso: ["sin", "cos", "tan"] }, atanhDocs = { name: "atanh", category: "Trigonometry", syntax: ["atanh(x)"], description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.", examples: ["atanh(0.5)"], seealso: ["acosh", "asinh"] }, cosDocs = { name: "cos", category: "Trigonometry", syntax: ["cos(x)"], description: "Compute the cosine of x in radians.", examples: ["cos(2)", "cos(pi / 4) ^ 2", "cos(180 deg)", "cos(60 deg)", "sin(0.2)^2 + cos(0.2)^2"], seealso: ["acos", "sin", "tan"] }, coshDocs = { name: "cosh", category: "Trigonometry", syntax: ["cosh(x)"], description: "Compute the hyperbolic cosine of x in radians.", examples: ["cosh(0.5)"], seealso: ["sinh", "tanh", "coth"] }, cotDocs = { name: "cot", category: "Trigonometry", syntax: ["cot(x)"], description: "Compute the cotangent of x in radians. Defined as 1/tan(x)", examples: ["cot(2)", "1 / tan(2)"], seealso: ["sec", "csc", "tan"] }, cothDocs = { name: "coth", category: "Trigonometry", syntax: ["coth(x)"], description: "Compute the hyperbolic cotangent of x in radians.", examples: ["coth(2)", "1 / tanh(2)"], seealso: ["sech", "csch", "tanh"] }, cscDocs = { name: "csc", category: "Trigonometry", syntax: ["csc(x)"], description: "Compute the cosecant of x in radians. Defined as 1/sin(x)", examples: ["csc(2)", "1 / sin(2)"], seealso: ["sec", "cot", "sin"] }, cschDocs = { name: "csch", category: "Trigonometry", syntax: ["csch(x)"], description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)", examples: ["csch(2)", "1 / sinh(2)"], seealso: ["sech", "coth", "sinh"] }, secDocs = { name: "sec", category: "Trigonometry", syntax: ["sec(x)"], description: "Compute the secant of x in radians. Defined as 1/cos(x)", examples: ["sec(2)", "1 / cos(2)"], seealso: ["cot", "csc", "cos"] }, sechDocs = { name: "sech", category: "Trigonometry", syntax: ["sech(x)"], description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)", examples: ["sech(2)", "1 / cosh(2)"], seealso: ["coth", "csch", "cosh"] }, sinDocs = { name: "sin", category: "Trigonometry", syntax: ["sin(x)"], description: "Compute the sine of x in radians.", examples: ["sin(2)", "sin(pi / 4) ^ 2", "sin(90 deg)", "sin(30 deg)", "sin(0.2)^2 + cos(0.2)^2"], seealso: ["asin", "cos", "tan"] }, sinhDocs = { name: "sinh", category: "Trigonometry", syntax: ["sinh(x)"], description: "Compute the hyperbolic sine of x in radians.", examples: ["sinh(0.5)"], seealso: ["cosh", "tanh"] }, tanDocs = { name: "tan", category: "Trigonometry", syntax: ["tan(x)"], description: "Compute the tangent of x in radians.", examples: ["tan(0.5)", "sin(0.5) / cos(0.5)", "tan(pi / 4)", "tan(45 deg)"], seealso: ["atan", "sin", "cos"] }, tanhDocs = { name: "tanh", category: "Trigonometry", syntax: ["tanh(x)"], description: "Compute the hyperbolic tangent of x in radians.", examples: ["tanh(0.5)", "sinh(0.5) / cosh(0.5)"], seealso: ["sinh", "cosh"] }, toDocs = { name: "to", category: "Units", syntax: ["x to unit", "to(x, unit)"], description: "Change the unit of a value.", examples: ["5 inch to cm", "3.2kg to g", "16 bytes in bits"], seealso: [] }, toBestDocs = { name: "toBest", category: "Units", syntax: ["toBest(x)", "toBest(x, unitList)", "toBest(x, unitList, options)"], description: "Converts to the most appropriate display unit.", examples: ['toBest(unit(5000, "m"))', 'toBest(unit(3500000, "W"))', 'toBest(unit(0.000000123, "A"))', 'toBest(unit(10, "m"), "cm")', 'toBest(unit(10, "m"), "mm,km", {offset: 1.5})'], seealso: [] }, binDocs = { name: "bin", category: "Utils", syntax: ["bin(value)"], description: "Format a number as binary", examples: ["bin(2)"], seealso: ["oct", "hex"] }, cloneDocs = { name: "clone", category: "Utils", syntax: ["clone(x)"], description: "Clone a variable. Creates a copy of primitive variables, and a deep copy of matrices", examples: ["clone(3.5)", "clone(2 - 4i)", "clone(45 deg)", "clone([1, 2; 3, 4])", 'clone("hello world")'], seealso: [] }, formatDocs = { name: "format", category: "Utils", syntax: ["format(value)", "format(value, precision)"], description: "Format a value of any type as string.", examples: ["format(2.3)", "format(3 - 4i)", "format([])", "format(pi, 3)"], seealso: ["print"] }, hasNumericValueDocs = { name: "hasNumericValue", category: "Utils", syntax: ["hasNumericValue(x)"], description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.", examples: ["hasNumericValue(2)", 'hasNumericValue("2")', 'isNumeric("2")', "hasNumericValue(0)", "hasNumericValue(bignumber(500))", "hasNumericValue(fraction(0.125))", "hasNumericValue(2 + 3i)", 'hasNumericValue([2.3, "foo", false])'], seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "isNumeric"] }, hexDocs = { name: "hex", category: "Utils", syntax: ["hex(value)"], description: "Format a number as hexadecimal", examples: ["hex(240)"], seealso: ["bin", "oct"] }, isIntegerDocs = { name: "isInteger", category: "Utils", syntax: ["isInteger(x)"], description: "Test whether a value is an integer number.", examples: ["isInteger(2)", "isInteger(3.5)", "isInteger([3, 0.5, -2])"], seealso: ["isNegative", "isNumeric", "isPositive", "isZero"] }, isNaNDocs = { name: "isNaN", category: "Utils", syntax: ["isNaN(x)"], description: "Test whether a value is NaN (not a number)", examples: ["isNaN(2)", "isNaN(0 / 0)", "isNaN(NaN)", "isNaN(Infinity)"], seealso: ["isNegative", "isNumeric", "isPositive", "isZero", "isFinite", "isBounded"] }, isBoundedDocs = { name: "isBounded", category: "Utils", syntax: ["isBounded(x)"], description: "Test whether a value or its entries are bounded.", examples: ["isBounded(Infinity)", "isBounded(bigint(3))", "isBounded([3, -Infinity, -3])"], seealso: ["isFinite", "isNumeric", "isNaN", "isNegative", "isPositive"] }, isFiniteDocs = { name: "isFinite", category: "Utils", syntax: ["isFinite(x)"], description: "Test whether a value is finite, elementwise on collections.", examples: ["isFinite(Infinity)", "isFinite(bigint(3))", "isFinite([3, -Infinity, -3])"], seealso: ["isBounded", "isNumeric", "isNaN", "isNegative", "isPositive"] }, isNegativeDocs = { name: "isNegative", category: "Utils", syntax: ["isNegative(x)"], description: "Test whether a value is negative: smaller than zero.", examples: ["isNegative(2)", "isNegative(0)", "isNegative(-4)", "isNegative([3, 0.5, -2])"], seealso: ["isInteger", "isNumeric", "isPositive", "isZero"] }, isNumericDocs = { name: "isNumeric", category: "Utils", syntax: ["isNumeric(x)"], description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.", examples: ["isNumeric(2)", 'isNumeric("2")', 'hasNumericValue("2")', "isNumeric(0)", "isNumeric(bignumber(500))", "isNumeric(fraction(0.125))", "isNumeric(2 + 3i)", 'isNumeric([2.3, "foo", false])'], seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "hasNumericValue", "isFinite", "isBounded"] }, isPositiveDocs = { name: "isPositive", category: "Utils", syntax: ["isPositive(x)"], description: "Test whether a value is positive: larger than zero.", examples: ["isPositive(2)", "isPositive(0)", "isPositive(-4)", "isPositive([3, 0.5, -2])"], seealso: ["isInteger", "isNumeric", "isNegative", "isZero"] }, isPrimeDocs = { name: "isPrime", category: "Utils", syntax: ["isPrime(x)"], description: "Test whether a value is prime: has no divisors other than itself and one.", examples: ["isPrime(3)", "isPrime(-2)", "isPrime([2, 17, 100])"], seealso: ["isInteger", "isNumeric", "isNegative", "isZero"] }, isZeroDocs = { name: "isZero", category: "Utils", syntax: ["isZero(x)"], description: "Test whether a value is zero.", examples: ["isZero(2)", "isZero(0)", "isZero(-4)", "isZero([3, 0, -2, 0])"], seealso: ["isInteger", "isNumeric", "isNegative", "isPositive"] }, numericDocs = { name: "numeric", category: "Utils", syntax: ["numeric(x)"], description: "Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.", examples: ['numeric("4")', 'numeric("4", "number")', 'numeric("4", "bigint")', 'numeric("4", "BigNumber")', 'numeric("4", "Fraction")', 'numeric(4, "Fraction")', 'numeric(fraction(2, 5), "number")'], seealso: ["number", "bigint", "fraction", "bignumber", "string", "format"] }, octDocs = { name: "oct", category: "Utils", syntax: ["oct(value)"], description: "Format a number as octal", examples: ["oct(56)"], seealso: ["bin", "hex"] }, printDocs = { name: "print", category: "Utils", syntax: ["print(template, values)", "print(template, values, precision)"], description: "Interpolate values into a string template.", examples: ['print("Lucy is $age years old", {age: 5})', 'print("The value of pi is $pi", {pi: pi}, 3)', 'print("Hello, $user.name!", {user: {name: "John"}})', 'print("Values: $1, $2, $3", [6, 9, 4])'], seealso: ["format"] }, typeOfDocs = { name: "typeOf", category: "Utils", syntax: ["typeOf(x)"], description: "Get the type of a variable.", examples: ["typeOf(3.5)", "typeOf(2 - 4i)", "typeOf(45 deg)", 'typeOf("hello world")'], seealso: ["getMatrixDataType"] }, solveODEDocs = { name: "solveODE", category: "Numeric", syntax: ["solveODE(func, tspan, y0)", "solveODE(func, tspan, y0, options)"], description: "Numerical Integration of Ordinary Differential Equations.", examples: ["f(t,y) = y", "tspan = [0, 4]", "solveODE(f, tspan, 1)", "solveODE(f, tspan, [1, 2])", 'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })'], seealso: ["derivative", "simplifyCore"] }, embeddedDocs = { bignumber: bignumberDocs, bigint: bigintDocs, boolean: booleanDocs, complex: complexDocs, createUnit: createUnitDocs, fraction: fractionDocs, index: indexDocs, matrix: matrixDocs, number: numberDocs, sparse: sparseDocs, splitUnit: splitUnitDocs, string: stringDocs, unit: unitDocs, e: eDocs, E: eDocs, false: falseDocs, i: iDocs, Infinity: InfinityDocs, LN2: LN2Docs, LN10: LN10Docs, LOG2E: LOG2EDocs, LOG10E: LOG10EDocs, NaN: NaNDocs, null: nullDocs, pi: piDocs, PI: piDocs, phi: phiDocs, SQRT1_2: SQRT12Docs, SQRT2: SQRT2Docs, tau: tauDocs, true: trueDocs, version: versionDocs, speedOfLight: { description: "Speed of light in vacuum", examples: ["speedOfLight"] }, gravitationConstant: { description: "Newtonian constant of gravitation", examples: ["gravitationConstant"] }, planckConstant: { description: "Planck constant", examples: ["planckConstant"] }, reducedPlanckConstant: { description: "Reduced Planck constant", examples: ["reducedPlanckConstant"] }, magneticConstant: { description: "Magnetic constant (vacuum permeability)", examples: ["magneticConstant"] }, electricConstant: { description: "Electric constant (vacuum permeability)", examples: ["electricConstant"] }, vacuumImpedance: { description: "Characteristic impedance of vacuum", examples: ["vacuumImpedance"] }, coulomb: { description: "Coulomb's constant. Deprecated in favor of coulombConstant", examples: ["coulombConstant"] }, coulombConstant: { description: "Coulomb's constant", examples: ["coulombConstant"] }, elementaryCharge: { description: "Elementary charge", examples: ["elementaryCharge"] }, bohrMagneton: { description: "Bohr magneton", examples: ["bohrMagneton"] }, conductanceQuantum: { description: "Conductance quantum", examples: ["conductanceQuantum"] }, inverseConductanceQuantum: { description: "Inverse conductance quantum", examples: ["inverseConductanceQuantum"] }, magneticFluxQuantum: { description: "Magnetic flux quantum", examples: ["magneticFluxQuantum"] }, nuclearMagneton: { description: "Nuclear magneton", examples: ["nuclearMagneton"] }, klitzing: { description: "Von Klitzing constant", examples: ["klitzing"] }, bohrRadius: { description: "Bohr radius", examples: ["bohrRadius"] }, classicalElectronRadius: { description: "Classical electron radius", examples: ["classicalElectronRadius"] }, electronMass: { description: "Electron mass", examples: ["electronMass"] }, fermiCoupling: { description: "Fermi coupling constant", examples: ["fermiCoupling"] }, fineStructure: { description: "Fine-structure constant", examples: ["fineStructure"] }, hartreeEnergy: { description: "Hartree energy", examples: ["hartreeEnergy"] }, protonMass: { description: "Proton mass", examples: ["protonMass"] }, deuteronMass: { description: "Deuteron Mass", examples: ["deuteronMass"] }, neutronMass: { description: "Neutron mass", examples: ["neutronMass"] }, quantumOfCirculation: { description: "Quantum of circulation", examples: ["quantumOfCirculation"] }, rydberg: { description: "Rydberg constant", examples: ["rydberg"] }, thomsonCrossSection: { description: "Thomson cross section", examples: ["thomsonCrossSection"] }, weakMixingAngle: { description: "Weak mixing angle", examples: ["weakMixingAngle"] }, efimovFactor: { description: "Efimov factor", examples: ["efimovFactor"] }, atomicMass: { description: "Atomic mass constant", examples: ["atomicMass"] }, avogadro: { description: "Avogadro's number", examples: ["avogadro"] }, boltzmann: { description: "Boltzmann constant", examples: ["boltzmann"] }, faraday: { description: "Faraday constant", examples: ["faraday"] }, firstRadiation: { description: "First radiation constant", examples: ["firstRadiation"] }, loschmidt: { description: "Loschmidt constant at T=273.15 K and p=101.325 kPa", examples: ["loschmidt"] }, gasConstant: { description: "Gas constant", examples: ["gasConstant"] }, molarPlanckConstant: { description: "Molar Planck constant", examples: ["molarPlanckConstant"] }, molarVolume: { description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa", examples: ["molarVolume"] }, sackurTetrode: { description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa", examples: ["sackurTetrode"] }, secondRadiation: { description: "Second radiation constant", examples: ["secondRadiation"] }, stefanBoltzmann: { description: "Stefan-Boltzmann constant", examples: ["stefanBoltzmann"] }, wienDisplacement: { description: "Wien displacement law constant", examples: ["wienDisplacement"] }, molarMass: { description: "Molar mass constant", examples: ["molarMass"] }, molarMassC12: { description: "Molar mass constant of carbon-12", examples: ["molarMassC12"] }, gravity: { description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)", examples: ["gravity"] }, planckLength: { description: "Planck length", examples: ["planckLength"] }, planckMass: { description: "Planck mass", examples: ["planckMass"] }, planckTime: { description: "Planck time", examples: ["planckTime"] }, planckCharge: { description: "Planck charge", examples: ["planckCharge"] }, planckTemperature: { description: "Planck temperature", examples: ["planckTemperature"] }, derivative: derivativeDocs, lsolve: lsolveDocs, lsolveAll: lsolveAllDocs, lup: lupDocs, lusolve: lusolveDocs, leafCount: leafCountDocs, polynomialRoot: polynomialRootDocs, resolve: resolveDocs, simplify: simplifyDocs, simplifyConstant: simplifyConstantDocs, simplifyCore: simplifyCoreDocs, symbolicEqual: symbolicEqualDocs, rationalize: rationalizeDocs, slu: sluDocs, usolve: usolveDocs, usolveAll: usolveAllDocs, qr: qrDocs, abs: absDocs, add: addDocs, cbrt: cbrtDocs, ceil: ceilDocs, cube: cubeDocs, divide: divideDocs, dotDivide: dotDivideDocs, dotMultiply: dotMultiplyDocs, dotPow: dotPowDocs, exp: expDocs, expm: expmDocs, expm1: expm1Docs, fix: fixDocs, floor: floorDocs, gcd: gcdDocs, hypot: hypotDocs, lcm: lcmDocs, log: logDocs, log2: log2Docs, log1p: log1pDocs, log10: log10Docs, mod: modDocs, multiply: multiplyDocs, norm: normDocs, nthRoot: nthRootDocs, nthRoots: nthRootsDocs, pow: powDocs, round: roundDocs, sign: signDocs, sqrt: sqrtDocs, sqrtm: sqrtmDocs, square: squareDocs, subtract: subtractDocs, unaryMinus: unaryMinusDocs, unaryPlus: unaryPlusDocs, xgcd: xgcdDocs, invmod: invmodDocs, bitAnd: bitAndDocs, bitNot: bitNotDocs, bitOr: bitOrDocs, bitXor: bitXorDocs, leftShift: leftShiftDocs, rightArithShift: rightArithShiftDocs, rightLogShift: rightLogShiftDocs, bellNumbers: bellNumbersDocs, catalan: catalanDocs, composition: compositionDocs, stirlingS2: stirlingS2Docs, config: configDocs, import: importDocs, typed: typedDocs, arg: argDocs, conj: conjDocs, re: reDocs, im: imDocs, evaluate: evaluateDocs, help: helpDocs, parse: parseDocs, parser: parserDocs, compile: compileDocs, distance: distanceDocs, intersect: intersectDocs, and: andDocs, not: notDocs, nullish: nullishDocs, or: orDocs, xor: xorDocs, mapSlices: mapSlicesDocs, concat: concatDocs, count: countDocs, cross: crossDocs, column: columnDocs, ctranspose: ctransposeDocs, det: detDocs, diag: diagDocs, diff: diffDocs, dot: dotDocs, getMatrixDataType: getMatrixDataTypeDocs, identity: identityDocs, filter: filterDocs, flatten: flattenDocs, forEach: forEachDocs, inv: invDocs, pinv: pinvDocs, eigs: eigsDocs, kron: kronDocs, matrixFromFunction: matrixFromFunctionDocs, matrixFromRows: matrixFromRowsDocs, matrixFromColumns: matrixFromColumnsDocs, map: mapDocs, ones: onesDocs, partitionSelect: partitionSelectDocs, range: rangeDocs, resize: resizeDocs, reshape: reshapeDocs, rotate: rotateDocs, rotationMatrix: rotationMatrixDocs, row: rowDocs, size: sizeDocs, sort: sortDocs, squeeze: squeezeDocs, subset: subsetDocs, trace: traceDocs, transpose: transposeDocs, zeros: zerosDocs, fft: fftDocs, ifft: ifftDocs, sylvester: sylvesterDocs, schur: schurDocs, lyap: lyapDocs, solveODE: solveODEDocs, bernoulli: bernoulliDocs, combinations: combinationsDocs, combinationsWithRep: combinationsWithRepDocs, factorial: factorialDocs, gamma: gammaDocs, kldivergence: kldivergenceDocs, lgamma: lgammaDocs, multinomial: multinomialDocs, permutations: permutationsDocs, pickRandom: pickRandomDocs, random: randomDocs, randomInt: randomIntDocs, compare: compareDocs, compareNatural: compareNaturalDocs, compareText: compareTextDocs, deepEqual: deepEqualDocs, equal: equalDocs, equalText: equalTextDocs, larger: largerDocs, largerEq: largerEqDocs, smaller: smallerDocs, smallerEq: smallerEqDocs, unequal: unequalDocs, setCartesian: setCartesianDocs, setDifference: setDifferenceDocs, setDistinct: setDistinctDocs, setIntersect: setIntersectDocs, setIsSubset: setIsSubsetDocs, setMultiplicity: setMultiplicityDocs, setPowerset: setPowersetDocs, setSize: setSizeDocs, setSymDifference: setSymDifferenceDocs, setUnion: setUnionDocs, zpk2tf: zpk2tfDocs, freqz: freqzDocs, erf: erfDocs, zeta: zetaDocs, cumsum: cumSumDocs, mad: madDocs, max: maxDocs, mean: meanDocs, median: medianDocs, min: minDocs, mode: modeDocs, prod: prodDocs, quantileSeq: quantileSeqDocs, std: stdDocs, sum: sumDocs, variance: varianceDocs, corr: corrDocs, acos: acosDocs, acosh: acoshDocs, acot: acotDocs, acoth: acothDocs, acsc: acscDocs, acsch: acschDocs, asec: asecDocs, asech: asechDocs, asin: asinDocs, asinh: asinhDocs, atan: atanDocs, atanh: atanhDocs, atan2: atan2Docs, cos: cosDocs, cosh: coshDocs, cot: cotDocs, coth: cothDocs, csc: cscDocs, csch: cschDocs, sec: secDocs, sech: sechDocs, sin: sinDocs, sinh: sinhDocs, tan: tanDocs, tanh: tanhDocs, to: toDocs, toBest: toBestDocs, clone: cloneDocs, format: formatDocs, bin: binDocs, oct: octDocs, hex: hexDocs, isNaN: isNaNDocs, isBounded: isBoundedDocs, isFinite: isFiniteDocs, isInteger: isIntegerDocs, isNegative: isNegativeDocs, isNumeric: isNumericDocs, hasNumericValue: hasNumericValueDocs, isPositive: isPositiveDocs, isPrime: isPrimeDocs, isZero: isZeroDocs, print: printDocs, typeOf: typeOfDocs, numeric: numericDocs }, name$1d = "help", dependencies$1d = ["typed", "mathWithTransform", "Help"], createHelp = factory(name$1d, dependencies$1d, ((e2) => {
  var { typed: t2, mathWithTransform: r, Help: n } = e2;
  return t2(name$1d, { any: function(e3) {
    var t22, i2 = e3;
    if ("string" != typeof e3) {
      for (t22 in r) if (hasOwnProperty$1$1(r, t22) && e3 === r[t22]) {
        i2 = t22;
        break;
      }
    }
    var a = getSafeProperty(embeddedDocs, i2);
    if (!a) {
      var o = "function" == typeof i2 ? i2.name : i2;
      throw new Error('No documentation found on "' + o + '"');
    }
    return new n(a);
  } });
})), name$1c = "chain", dependencies$1c = ["typed", "Chain"], createChain = factory(name$1c, dependencies$1c, ((e2) => {
  var { typed: t2, Chain: r } = e2;
  return t2(name$1c, { "": function() {
    return new r();
  }, any: function(e3) {
    return new r(e3);
  } });
})), name$1b = "det", dependencies$1b = ["typed", "matrix", "subtractScalar", "multiply", "divideScalar", "isZero", "unaryMinus"], createDet = factory(name$1b, dependencies$1b, ((e2) => {
  var { typed: t2, matrix: r, subtractScalar: n, multiply: i2, divideScalar: a, isZero: o, unaryMinus: s } = e2;
  return t2(name$1b, { any: function(e3) {
    return clone$3(e3);
  }, "Array | Matrix": function(e3) {
    var t22;
    switch ((t22 = isMatrix(e3) ? e3.size() : Array.isArray(e3) ? (e3 = r(e3)).size() : []).length) {
      case 0:
        return clone$3(e3);
      case 1:
        if (1 === t22[0]) return clone$3(e3.valueOf()[0]);
        if (0 === t22[0]) return 1;
        throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
      case 2:
        var u = t22[0], c2 = t22[1];
        if (u === c2) return (function(e4, t3) {
          if (1 === t3) return clone$3(e4[0][0]);
          if (2 === t3) return n(i2(e4[0][0], e4[1][1]), i2(e4[1][0], e4[0][1]));
          for (var r2 = false, u2 = new Array(t3).fill(0).map(((e5, t4) => t4)), c3 = 0; c3 < t3; c3++) {
            var l = u2[c3];
            if (o(e4[l][c3])) {
              var f2 = void 0;
              for (f2 = c3 + 1; f2 < t3; f2++) if (!o(e4[u2[f2]][c3])) {
                l = u2[f2], u2[f2] = u2[c3], u2[c3] = l, r2 = !r2;
                break;
              }
              if (f2 === t3) return e4[l][c3];
            }
            for (var p = e4[l][c3], m = 0 === c3 ? 1 : e4[u2[c3 - 1]][c3 - 1], d = c3 + 1; d < t3; d++) for (var h = u2[d], g = c3 + 1; g < t3; g++) e4[h][g] = a(n(i2(e4[h][g], p), i2(e4[h][c3], e4[l][g])), m);
          }
          var y = e4[u2[t3 - 1]][t3 - 1];
          return r2 ? s(y) : y;
        })(e3.clone().valueOf(), u);
        if (0 === c2) return 1;
        throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + format(t22) + ")");
    }
  } });
})), name$1a = "inv", dependencies$1a = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], createInv = factory(name$1a, dependencies$1a, ((e2) => {
  var { typed: t2, matrix: r, divideScalar: n, addScalar: i2, multiply: a, unaryMinus: o, det: s, identity: u, abs: c2 } = e2;
  return t2(name$1a, { "Array | Matrix": function(e3) {
    var t22 = isMatrix(e3) ? e3.size() : arraySize(e3);
    switch (t22.length) {
      case 1:
        if (1 === t22[0]) return isMatrix(e3) ? r([n(1, e3.valueOf()[0])]) : [n(1, e3[0])];
        throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
      case 2:
        var i22 = t22[0], a2 = t22[1];
        if (i22 === a2) return isMatrix(e3) ? r(l(e3.valueOf(), i22, a2), e3.storage()) : l(e3, i22, a2);
        throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + format(t22) + ")");
    }
  }, any: function(e3) {
    return n(1, e3);
  } });
  function l(e3, t22, r2) {
    var l2, f2, p, m, d;
    if (1 === t22) {
      if (0 === (m = e3[0][0])) throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(1, m)]];
    }
    if (2 === t22) {
      var h = s(e3);
      if (0 === h) throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(e3[1][1], h), n(o(e3[0][1]), h)], [n(o(e3[1][0]), h), n(e3[0][0], h)]];
    }
    var g = e3.concat();
    for (l2 = 0; l2 < t22; l2++) g[l2] = g[l2].concat();
    for (var y = u(t22).valueOf(), v2 = 0; v2 < r2; v2++) {
      var x2 = c2(g[v2][v2]), b2 = v2;
      for (l2 = v2 + 1; l2 < t22; ) c2(g[l2][v2]) > x2 && (x2 = c2(g[l2][v2]), b2 = l2), l2++;
      if (0 === x2) throw Error("Cannot calculate inverse, determinant is zero");
      (l2 = b2) !== v2 && (d = g[v2], g[v2] = g[l2], g[l2] = d, d = y[v2], y[v2] = y[l2], y[l2] = d);
      var _2 = g[v2], w2 = y[v2];
      for (l2 = 0; l2 < t22; l2++) {
        var A2 = g[l2], N = y[l2];
        if (l2 !== v2) {
          if (0 !== A2[v2]) {
            for (p = n(o(A2[v2]), _2[v2]), f2 = v2; f2 < r2; f2++) A2[f2] = i2(A2[f2], a(p, _2[f2]));
            for (f2 = 0; f2 < r2; f2++) N[f2] = i2(N[f2], a(p, w2[f2]));
          }
        } else {
          for (p = _2[v2], f2 = v2; f2 < r2; f2++) A2[f2] = n(A2[f2], p);
          for (f2 = 0; f2 < r2; f2++) N[f2] = n(N[f2], p);
        }
      }
    }
    return y;
  }
})), name$19 = "pinv", dependencies$19 = ["typed", "matrix", "inv", "deepEqual", "equal", "dotDivide", "dot", "ctranspose", "divideScalar", "multiply", "add", "Complex"], createPinv = factory(name$19, dependencies$19, ((e2) => {
  var { typed: t2, matrix: r, inv: n, deepEqual: i2, equal: a, dotDivide: o, dot: s, ctranspose: u, divideScalar: c2, multiply: l, add: f2, Complex: p } = e2;
  return t2(name$19, { "Array | Matrix": function(e3) {
    var t22 = isMatrix(e3) ? e3.size() : arraySize(e3);
    switch (t22.length) {
      case 1:
        return h(e3) ? u(e3) : 1 === t22[0] ? n(e3) : o(u(e3), s(e3, e3));
      case 2:
        if (h(e3)) return u(e3);
        var i22 = t22[0], a2 = t22[1];
        if (i22 === a2) try {
          return n(e3);
        } catch (e4) {
          if (!(e4 instanceof Error && e4.message.match(/Cannot calculate inverse, determinant is zero/))) throw e4;
        }
        return isMatrix(e3) ? r(m(e3.valueOf(), i22, a2), e3.storage()) : m(e3, i22, a2);
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + format(t22) + ")");
    }
  }, any: function(e3) {
    return a(e3, 0) ? clone$3(e3) : c2(1, e3);
  } });
  function m(e3, t22, r2) {
    var { C: i22, F: a2 } = (function(e4, t3, r3) {
      var n3 = (function(e5, t4, r4) {
        for (var n4 = clone$3(e5), i4 = 0, a4 = 0; a4 < t4; a4++) {
          if (r4 <= i4) return n4;
          for (var s2 = a4; d(n4[s2][i4]); ) if (t4 === ++s2 && (s2 = a4, r4 === ++i4)) return n4;
          [n4[s2], n4[a4]] = [n4[a4], n4[s2]];
          for (var u2 = n4[a4][i4], c4 = 0; c4 < r4; c4++) n4[a4][c4] = o(n4[a4][c4], u2);
          for (var p3 = 0; p3 < t4; p3++) if (p3 !== a4) {
            u2 = n4[p3][i4];
            for (var m2 = 0; m2 < r4; m2++) n4[p3][m2] = f2(n4[p3][m2], l(-1, l(u2, n4[a4][m2])));
          }
          i4++;
        }
        return n4;
      })(e4, t3, r3), i3 = e4.map(((e5, r4) => e5.filter(((e6, r5) => r5 < t3 && !d(s(n3[r5], n3[r5])))))), a3 = n3.filter(((e5, t4) => !d(s(n3[t4], n3[t4]))));
      return { C: i3, F: a3 };
    })(e3, t22, r2), c3 = l(n(l(u(i22), i22)), u(i22)), p2 = l(u(a2), n(l(a2, u(a2))));
    return l(p2, c3);
  }
  function d(e3) {
    return a(f2(e3, p(1, 1)), f2(0, p(1, 1)));
  }
  function h(e3) {
    return i2(f2(e3, p(1, 1)), f2(l(e3, 0), p(1, 1)));
  }
}));
function createComplexEigs(e2) {
  var { addScalar: t2, subtract: r, flatten: n, multiply: i2, multiplyScalar: a, divideScalar: o, sqrt: s, abs: u, bignumber: c2, diag: l, size: f2, reshape: p, inv: m, qr: d, usolve: h, usolveAll: g, equal: y, complex: v2, larger: x2, smaller: b2, matrixFromColumns: _2, dot: w2 } = e2;
  function A2(e3, n3, i22, o2) {
    var u2 = t2(e3, o2), c3 = r(a(e3, o2), a(n3, i22)), l2 = a(u2, 0.5), f3 = a(s(r(a(u2, u2), a(4, c3))), 0.5);
    return [t2(l2, f3), r(l2, f3)];
  }
  function N(e3, t22, n3, i22, a2, o2, s2, l2) {
    var f3 = "BigNumber" === l2, p2 = "Complex" === l2, m2 = f3 ? c2(0) : p2 ? v2(0) : 0, d2 = f3 ? c2(1) : p2 ? v2(1) : 1;
    if (b2(u(n3), s2)) return [[d2, m2], [m2, d2]];
    if (x2(u(r(a2, o2)), s2)) return [[r(a2, i22), r(o2, i22)], [n3, n3]];
    var h2 = r(e3, a2), g2 = r(i22, a2);
    return b2(u(t22), s2) && b2(u(g2), s2) ? [[h2, d2], [n3, m2]] : [[t22, m2], [g2, d2]];
  }
  function D(e3, t22) {
    for (var r2 = 0; r2 < e3.length; r2++) e3[r2].push(...Array(t22 - e3[r2].length).fill(0));
    for (var n3 = e3.length; n3 < t22; n3++) e3.push(Array(t22).fill(0)), e3[n3][n3] = 1;
    return e3;
  }
  function E(e3, t22, r2) {
    for (var n3 = 0; n3 < e3.length; n3++) if (r2(e3[n3], t22)) return n3;
    return -1;
  }
  function $2(e3, t22, r2, n3, i22) {
    for (var a2, o2 = "BigNumber" === i22 ? c2(1e3) : 1e3, s2 = 0; s2 < 5; ++s2) {
      a2 = S2(t22, r2, i22);
      try {
        a2 = h(e3, a2);
      } catch (e4) {
        continue;
      }
      if (x2(M2(a2), o2)) break;
    }
    if (s2 >= 5) return null;
    for (s2 = 0; ; ) {
      var u2 = h(e3, a2);
      if (b2(M2(C2(a2, [u2])), n3)) break;
      if (++s2 >= 10) return null;
      a2 = T2(u2);
    }
    return a2;
  }
  function S2(e3, t22, r2) {
    var n3 = "BigNumber" === r2, i22 = "Complex" === r2, a2 = Array(e3).fill(0).map(((e4) => 2 * Math.random() - 1));
    return n3 && (a2 = a2.map(((e4) => c2(e4)))), i22 && (a2 = a2.map(((e4) => v2(e4)))), T2(a2 = C2(a2, t22), r2);
  }
  function C2(e3, t22) {
    var n3 = f2(e3);
    for (var a2 of t22) a2 = p(a2, n3), e3 = r(e3, i2(o(w2(a2, e3), w2(a2, a2)), a2));
    return e3;
  }
  function M2(e3) {
    return u(s(w2(e3, e3)));
  }
  function T2(e3, t22) {
    var r2 = "Complex" === t22, n3 = "BigNumber" === t22 ? c2(1) : r2 ? v2(1) : 1;
    return i2(o(n3, M2(e3)), e3);
  }
  return function(e3, s2, f3, p2) {
    var h2 = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], _3 = (function(e4, r2, n3, i22, s3) {
      var f4, p3 = "BigNumber" === i22, m2 = "Complex" === i22, d2 = p3 ? c2(0) : 0, h3 = p3 ? c2(1) : m2 ? v2(1) : 1, g2 = p3 ? c2(1) : 1, _4 = p3 ? c2(10) : 2, w3 = a(_4, _4);
      s3 && (f4 = Array(r2).fill(h3));
      var A3 = false;
      for (; !A3; ) {
        A3 = true;
        for (var N2 = 0; N2 < r2; N2++) {
          for (var D2 = d2, E2 = d2, $22 = 0; $22 < r2; $22++) N2 !== $22 && (D2 = t2(D2, u(e4[$22][N2])), E2 = t2(E2, u(e4[N2][$22])));
          if (!y(D2, 0) && !y(E2, 0)) {
            for (var S3 = g2, C4 = D2, M22 = o(E2, _4), T3 = a(E2, _4); b2(C4, M22); ) C4 = a(C4, w3), S3 = a(S3, _4);
            for (; x2(C4, T3); ) C4 = o(C4, w3), S3 = o(S3, _4);
            if (b2(o(t2(C4, E2), S3), a(t2(D2, E2), 0.95))) {
              A3 = false;
              for (var F = o(1, S3), O2 = 0; O2 < r2; O2++) N2 !== O2 && (e4[N2][O2] = a(e4[N2][O2], F), e4[O2][N2] = a(e4[O2][N2], S3));
              s3 && (f4[N2] = a(f4[N2], F));
            }
          }
        }
      }
      return s3 ? l(f4) : null;
    })(e3, s2, 0, p2, h2);
    !(function(e4, n3, i22, s3, l2, f4) {
      var p3 = "BigNumber" === s3, m2 = "Complex" === s3, d2 = p3 ? c2(0) : m2 ? v2(0) : 0;
      p3 && (i22 = c2(i22));
      for (var h3 = 0; h3 < n3 - 2; h3++) {
        for (var g2 = 0, y2 = d2, x22 = h3 + 1; x22 < n3; x22++) {
          var _4 = e4[x22][h3];
          b2(u(y2), u(_4)) && (y2 = _4, g2 = x22);
        }
        if (!b2(u(y2), i22)) {
          if (g2 !== h3 + 1) {
            var w3 = e4[g2];
            e4[g2] = e4[h3 + 1], e4[h3 + 1] = w3;
            for (var A3 = 0; A3 < n3; A3++) {
              var N2 = e4[A3][g2];
              e4[A3][g2] = e4[A3][h3 + 1], e4[A3][h3 + 1] = N2;
            }
            if (l2) {
              var D2 = f4[g2];
              f4[g2] = f4[h3 + 1], f4[h3 + 1] = D2;
            }
          }
          for (var E2 = h3 + 2; E2 < n3; E2++) {
            var $22 = o(e4[E2][h3], y2);
            if (0 !== $22) {
              for (var S3 = 0; S3 < n3; S3++) e4[E2][S3] = r(e4[E2][S3], a($22, e4[h3 + 1][S3]));
              for (var C4 = 0; C4 < n3; C4++) e4[C4][h3 + 1] = t2(e4[C4][h3 + 1], a($22, e4[C4][E2]));
              if (l2) for (var M22 = 0; M22 < n3; M22++) f4[E2][M22] = r(f4[E2][M22], a($22, f4[h3 + 1][M22]));
            }
          }
        }
      }
    })(e3, s2, f3, p2, h2, _3);
    var { values: w22, C: S22 } = (function(e4, n3, a2, o2, s3) {
      var f4 = "BigNumber" === o2, p3 = "Complex" === o2, m2 = f4 ? c2(1) : p3 ? v2(1) : 1;
      f4 && (a2 = c2(a2));
      var h3 = clone$3(e4), g2 = [], y2 = n3, x22 = [], _4 = s3 ? l(Array(n3).fill(m2)) : void 0, w3 = s3 ? l(Array(y2).fill(m2)) : void 0, E2 = 0;
      for (; E2 <= 100; ) {
        E2 += 1;
        for (var $22 = h3[y2 - 1][y2 - 1], S3 = 0; S3 < y2; S3++) h3[S3][S3] = r(h3[S3][S3], $22);
        var { Q: C4, R: M22 } = d(h3);
        h3 = i2(M22, C4);
        for (var T3 = 0; T3 < y2; T3++) h3[T3][T3] = t2(h3[T3][T3], $22);
        if (s3 && (w3 = i2(w3, C4)), 1 === y2 || b2(u(h3[y2 - 1][y2 - 2]), a2)) {
          E2 = 0, g2.push(h3[y2 - 1][y2 - 1]), s3 && (x22.unshift([[1]]), D(w3, n3), _4 = i2(_4, w3), y2 > 1 && (w3 = l(Array(y2 - 1).fill(m2)))), y2 -= 1, h3.pop();
          for (var F = 0; F < y2; F++) h3[F].pop();
        } else if (2 === y2 || b2(u(h3[y2 - 2][y2 - 3]), a2)) {
          E2 = 0;
          var O2 = A2(h3[y2 - 2][y2 - 2], h3[y2 - 2][y2 - 1], h3[y2 - 1][y2 - 2], h3[y2 - 1][y2 - 1]);
          g2.push(...O2), s3 && (x22.unshift(N(h3[y2 - 2][y2 - 2], h3[y2 - 2][y2 - 1], h3[y2 - 1][y2 - 2], h3[y2 - 1][y2 - 1], O2[0], O2[1], a2, o2)), D(w3, n3), _4 = i2(_4, w3), y2 > 2 && (w3 = l(Array(y2 - 2).fill(m2)))), y2 -= 2, h3.pop(), h3.pop();
          for (var k2 = 0; k2 < y2; k2++) h3[k2].pop(), h3[k2].pop();
        }
        if (0 === y2) break;
      }
      if (g2.sort(((e5, t22) => +r(u(e5), u(t22)))), E2 > 100) {
        var B2 = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + g2.join(", "));
        throw B2.values = g2, B2.vectors = [], B2;
      }
      var I2 = s3 ? i2(_4, (function(e5, t22) {
        for (var r2 = [], n4 = 0; n4 < t22; n4++) r2[n4] = Array(t22).fill(0);
        var i22 = 0;
        for (var a3 of e5) {
          for (var o3 = a3.length, s4 = 0; s4 < o3; s4++) for (var u2 = 0; u2 < o3; u2++) r2[i22 + s4][i22 + u2] = a3[s4][u2];
          i22 += o3;
        }
        return r2;
      })(x22, n3)) : void 0;
      return { values: g2, C: I2 };
    })(e3, s2, f3, p2, h2);
    if (h2) {
      var C3 = (function(e4, t22, a2, o2, s3, u2, f4) {
        var p3 = m(a2), d2 = i2(p3, e4, a2), h3 = "BigNumber" === f4, x22 = "Complex" === f4, b22 = h3 ? c2(0) : x22 ? v2(0) : 0, _4 = h3 ? c2(1) : x22 ? v2(1) : 1, w3 = [], A3 = [];
        for (var N2 of s3) {
          var D2 = E(w3, N2, y);
          -1 === D2 ? (w3.push(N2), A3.push(1)) : A3[D2] += 1;
        }
        for (var S3 = [], C4 = w3.length, M22 = Array(t22).fill(b22), T3 = l(Array(t22).fill(_4)), F = function() {
          var e5 = w3[O2], s4 = r(d2, i2(e5, T3)), c3 = g(s4, M22);
          for (c3.shift(); c3.length < A3[O2]; ) {
            var l2 = $2(s4, t22, c3, u2, f4);
            if (null === l2) break;
            c3.push(l2);
          }
          var p4 = i2(m(o2), a2);
          c3 = c3.map(((e6) => i2(p4, e6))), S3.push(...c3.map(((t3) => ({ value: e5, vector: n(t3) }))));
        }, O2 = 0; O2 < C4; O2++) F();
        return S3;
      })(e3, s2, S22, _3, w22, f3, p2);
      return { values: w22, eigenvectors: C3 };
    }
    return { values: w22 };
  };
}
function createRealSymmetric(e2) {
  var { config: t2, addScalar: r, subtract: n, abs: i2, atan: a, cos: o, sin: s, multiplyScalar: u, inv: c2, bignumber: l, multiply: f2, add: p } = e2;
  function m(e3, r2, n3) {
    var i22 = r2 - e3;
    return Math.abs(i22) <= t2.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * n3 / (r2 - e3));
  }
  function d(e3, r2, o2) {
    var s2 = n(r2, e3);
    return i2(s2) <= t2.relTol ? l(-1).acos().div(4) : u(0.5, a(f2(2, o2, c2(s2))));
  }
  function h(e3, t22, r2, n3) {
    for (var i22 = e3.length, a2 = Math.cos(t22), o2 = Math.sin(t22), s2 = Array(i22).fill(0), u2 = Array(i22).fill(0), c3 = 0; c3 < i22; c3++) s2[c3] = a2 * e3[c3][r2] - o2 * e3[c3][n3], u2[c3] = o2 * e3[c3][r2] + a2 * e3[c3][n3];
    for (var l2 = 0; l2 < i22; l2++) e3[l2][r2] = s2[l2], e3[l2][n3] = u2[l2];
    return e3;
  }
  function g(e3, t22, i22, a2) {
    for (var c3 = e3.length, f3 = o(t22), p2 = s(t22), m2 = Array(c3).fill(l(0)), d2 = Array(c3).fill(l(0)), h2 = 0; h2 < c3; h2++) m2[h2] = n(u(f3, e3[h2][i22]), u(p2, e3[h2][a2])), d2[h2] = r(u(p2, e3[h2][i22]), u(f3, e3[h2][a2]));
    for (var g2 = 0; g2 < c3; g2++) e3[g2][i22] = m2[g2], e3[g2][a2] = d2[g2];
    return e3;
  }
  function y(e3, t22, i22, a2) {
    for (var c3 = e3.length, m2 = l(o(t22)), d2 = l(s(t22)), h2 = u(m2, m2), g2 = u(d2, d2), y2 = Array(c3).fill(l(0)), v22 = Array(c3).fill(l(0)), x22 = f2(l(2), m2, d2, e3[i22][a2]), b22 = r(n(u(h2, e3[i22][i22]), x22), u(g2, e3[a2][a2])), _3 = p(u(g2, e3[i22][i22]), x22, u(h2, e3[a2][a2])), w2 = 0; w2 < c3; w2++) y2[w2] = n(u(m2, e3[i22][w2]), u(d2, e3[a2][w2])), v22[w2] = r(u(d2, e3[i22][w2]), u(m2, e3[a2][w2]));
    e3[i22][i22] = b22, e3[a2][a2] = _3, e3[i22][a2] = l(0), e3[a2][i22] = l(0);
    for (var A2 = 0; A2 < c3; A2++) A2 !== i22 && A2 !== a2 && (e3[i22][A2] = y2[A2], e3[A2][i22] = y2[A2], e3[a2][A2] = v22[A2], e3[A2][a2] = v22[A2]);
    return e3;
  }
  function v2(e3, t22, r2, n3) {
    for (var i22 = e3.length, a2 = Math.cos(t22), o2 = Math.sin(t22), s2 = a2 * a2, u2 = o2 * o2, c3 = Array(i22).fill(0), l2 = Array(i22).fill(0), f3 = s2 * e3[r2][r2] - 2 * a2 * o2 * e3[r2][n3] + u2 * e3[n3][n3], p2 = u2 * e3[r2][r2] + 2 * a2 * o2 * e3[r2][n3] + s2 * e3[n3][n3], m2 = 0; m2 < i22; m2++) c3[m2] = a2 * e3[r2][m2] - o2 * e3[n3][m2], l2[m2] = o2 * e3[r2][m2] + a2 * e3[n3][m2];
    e3[r2][r2] = f3, e3[n3][n3] = p2, e3[r2][n3] = 0, e3[n3][r2] = 0;
    for (var d2 = 0; d2 < i22; d2++) d2 !== r2 && d2 !== n3 && (e3[r2][d2] = c3[d2], e3[d2][r2] = c3[d2], e3[n3][d2] = l2[d2], e3[d2][n3] = l2[d2]);
    return e3;
  }
  function x2(e3) {
    for (var t22 = e3.length, r2 = 0, n3 = [0, 1], i22 = 0; i22 < t22; i22++) for (var a2 = i22 + 1; a2 < t22; a2++) Math.abs(r2) < Math.abs(e3[i22][a2]) && (r2 = Math.abs(e3[i22][a2]), n3 = [i22, a2]);
    return [n3, r2];
  }
  function b2(e3) {
    for (var t22 = e3.length, r2 = 0, n3 = [0, 1], a2 = 0; a2 < t22; a2++) for (var o2 = a2 + 1; o2 < t22; o2++) i2(r2) < i2(e3[a2][o2]) && (r2 = i2(e3[a2][o2]), n3 = [a2, o2]);
    return [n3, r2];
  }
  function _2(e3, t22, r2) {
    var n3, a2 = e3.length, o2 = Array(a2);
    if (r2) {
      n3 = Array(a2);
      for (var s2 = 0; s2 < a2; s2++) n3[s2] = Array(a2);
    }
    for (var u2 = 0; u2 < a2; u2++) {
      for (var c3 = 0, l2 = e3[0], f3 = 0; f3 < e3.length; f3++) i2(e3[f3]) < i2(l2) && (l2 = e3[c3 = f3]);
      if (o2[u2] = e3.splice(c3, 1)[0], r2) for (var p2 = 0; p2 < a2; p2++) n3[u2][p2] = t22[p2][c3], t22[p2].splice(c3, 1);
    }
    if (!r2) return { values: o2 };
    var m2 = n3.map(((e4, t3) => ({ value: o2[t3], vector: e4 })));
    return { values: o2, eigenvectors: m2 };
  }
  return function(e3, r2) {
    var n3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t2.relTol, a2 = arguments.length > 3 ? arguments[3] : void 0, o2 = arguments.length > 4 ? arguments[4] : void 0;
    if ("number" === a2) return (function(e4, t22, r3) {
      var n4, i22, a3 = e4.length, o3 = Math.abs(t22 / a3);
      if (r3) {
        i22 = new Array(a3);
        for (var s2 = 0; s2 < a3; s2++) i22[s2] = Array(a3).fill(0), i22[s2][s2] = 1;
      }
      var u2 = x2(e4);
      for (; Math.abs(u2[1]) >= Math.abs(o3); ) {
        var c3 = u2[0][0], l2 = u2[0][1];
        e4 = v2(e4, n4 = m(e4[c3][c3], e4[l2][l2], e4[c3][l2]), c3, l2), r3 && (i22 = h(i22, n4, c3, l2)), u2 = x2(e4);
      }
      for (var f3 = Array(a3).fill(0), p2 = 0; p2 < a3; p2++) f3[p2] = e4[p2][p2];
      return _2(clone$3(f3), i22, r3);
    })(e3, n3, o2);
    if ("BigNumber" === a2) return (function(e4, t22, r3) {
      var n4, a3, o3 = e4.length, s2 = i2(t22 / o3);
      if (r3) {
        a3 = new Array(o3);
        for (var u2 = 0; u2 < o3; u2++) a3[u2] = Array(o3).fill(0), a3[u2][u2] = 1;
      }
      var c3 = b2(e4);
      for (; i2(c3[1]) >= i2(s2); ) {
        var l2 = c3[0][0], f3 = c3[0][1];
        e4 = y(e4, n4 = d(e4[l2][l2], e4[f3][f3], e4[l2][f3]), l2, f3), r3 && (a3 = g(a3, n4, l2, f3)), c3 = b2(e4);
      }
      for (var p2 = Array(o3).fill(0), m2 = 0; m2 < o3; m2++) p2[m2] = e4[m2][m2];
      return _2(clone$3(p2), a3, r3);
    })(e3, n3, o2);
    throw TypeError("Unsupported data type: " + a2);
  };
}
var name$18 = "eigs", dependencies$18 = ["config", "typed", "matrix", "addScalar", "equal", "subtract", "abs", "atan", "cos", "sin", "multiplyScalar", "divideScalar", "inv", "bignumber", "multiply", "add", "larger", "column", "flatten", "number", "complex", "sqrt", "diag", "size", "reshape", "qr", "usolve", "usolveAll", "im", "re", "smaller", "matrixFromColumns", "dot"], createEigs = factory(name$18, dependencies$18, ((e2) => {
  var { config: t2, typed: r, matrix: n, addScalar: i2, subtract: a, equal: o, abs: s, atan: u, cos: c2, sin: l, multiplyScalar: f2, divideScalar: p, inv: m, bignumber: d, multiply: h, add: g, larger: y, column: v2, flatten: x2, number: b2, complex: _2, sqrt: w2, diag: A2, size: N, reshape: D, qr: E, usolve: $2, usolveAll: S2, im: C2, re: M2, smaller: T2, matrixFromColumns: F, dot: O2 } = e2, k2 = createRealSymmetric({ config: t2, addScalar: i2, subtract: a, abs: s, atan: u, cos: c2, sin: l, multiplyScalar: f2, inv: m, bignumber: d, multiply: h, add: g }), B2 = createComplexEigs({ addScalar: i2, subtract: a, multiply: h, multiplyScalar: f2, flatten: x2, divideScalar: p, sqrt: w2, abs: s, bignumber: d, diag: A2, size: N, reshape: D, qr: E, inv: m, usolve: $2, usolveAll: S2, equal: o, complex: _2, larger: y, smaller: T2, matrixFromColumns: F, dot: O2 });
  return r("eigs", { Array: function(e3) {
    return I2(n(e3));
  }, "Array, number|BigNumber": function(e3, t22) {
    return I2(n(e3), { precision: t22 });
  }, "Array, Object": (e3, t22) => I2(n(e3), t22), Matrix: function(e3) {
    return I2(e3, { matricize: true });
  }, "Matrix, number|BigNumber": function(e3, t22) {
    return I2(e3, { precision: t22, matricize: true });
  }, "Matrix, Object": function(e3, t22) {
    var r2 = { matricize: true };
    return _extends$2(r2, t22), I2(e3, r2);
  } });
  function I2(e3) {
    var r2, i22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, o2 = !("eigenvectors" in i22) || i22.eigenvectors, u2 = (function(e4, t22, r3) {
      var n3 = e4.toArray(), i3 = e4.size();
      if (2 !== i3.length || i3[0] !== i3[1]) throw new RangeError("Matrix must be square (size: ".concat(format(i3), ")"));
      var o3 = i3[0];
      if ((function(e5, t3, r4) {
        for (var n4 = 0; n4 < t3; n4++) for (var i4 = 0; i4 < t3; i4++) if (y(d(s(C2(e5[n4][i4]))), r4)) return false;
        return true;
      })(n3, o3, t22) && ((function(e5, t3) {
        for (var r4 = 0; r4 < t3; r4++) for (var n4 = 0; n4 < t3; n4++) e5[r4][n4] = M2(e5[r4][n4]);
      })(n3, o3), (function(e5, t3, r4) {
        for (var n4 = 0; n4 < t3; n4++) for (var i4 = n4; i4 < t3; i4++) if (y(d(s(a(e5[n4][i4], e5[i4][n4]))), r4)) return false;
        return true;
      })(n3, o3, t22))) {
        var u3 = R2(e4, n3, o3);
        return k2(n3, o3, t22, u3, r3);
      }
      var c3 = R2(e4, n3, o3);
      return B2(n3, o3, t22, c3, r3);
    })(e3, null !== (r2 = i22.precision) && void 0 !== r2 ? r2 : t2.relTol, o2);
    return i22.matricize && (u2.values = n(u2.values), o2 && (u2.eigenvectors = u2.eigenvectors.map(((e4) => {
      var { value: t22, vector: r3 } = e4;
      return { value: t22, vector: n(r3) };
    })))), o2 && Object.defineProperty(u2, "vectors", { enumerable: false, get: () => {
      throw new Error("eigs(M).vectors replaced with eigs(M).eigenvectors");
    } }), u2;
  }
  function R2(e3, t22, r2) {
    var n3 = e3.datatype();
    if ("number" === n3 || "BigNumber" === n3 || "Complex" === n3) return n3;
    for (var i22 = false, a2 = false, o2 = false, s2 = 0; s2 < r2; s2++) for (var u2 = 0; u2 < r2; u2++) {
      var c3 = t22[s2][u2];
      if (isNumber$1(c3) || isFraction(c3)) i22 = true;
      else if (isBigNumber(c3)) a2 = true;
      else {
        if (!isComplex(c3)) throw TypeError("Unsupported type in Matrix: " + typeOf(c3));
        o2 = true;
      }
    }
    if (a2 && o2 && console.warn("Complex BigNumbers not supported, this operation will lose precission."), o2) {
      for (var l2 = 0; l2 < r2; l2++) for (var f3 = 0; f3 < r2; f3++) t22[l2][f3] = _2(t22[l2][f3]);
      return "Complex";
    }
    if (a2) {
      for (var p2 = 0; p2 < r2; p2++) for (var m2 = 0; m2 < r2; m2++) t22[p2][m2] = d(t22[p2][m2]);
      return "BigNumber";
    }
    if (i22) {
      for (var h2 = 0; h2 < r2; h2++) for (var g2 = 0; g2 < r2; g2++) t22[h2][g2] = b2(t22[h2][g2]);
      return "number";
    }
    throw TypeError("Matrix contains unsupported types only.");
  }
})), name$17 = "expm", dependencies$17 = ["typed", "abs", "add", "identity", "inv", "multiply"], createExpm = factory(name$17, dependencies$17, ((e2) => {
  var { typed: t2, abs: r, add: n, identity: i2, inv: a, multiply: o } = e2;
  return t2(name$17, { Matrix: function(e3) {
    var t22 = e3.size();
    if (2 !== t22.length || t22[0] !== t22[1]) throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
    for (var u = t22[0], c2 = (function(e4) {
      for (var t3 = e4.size()[0], n3 = 0, i22 = 0; i22 < t3; i22++) {
        for (var a2 = 0, o2 = 0; o2 < t3; o2++) a2 += r(e4.get([i22, o2]));
        n3 = Math.max(a2, n3);
      }
      return n3;
    })(e3), l = (function(e4, t3) {
      for (var r2 = 30, n3 = 0; n3 < r2; n3++) for (var i22 = 0; i22 <= n3; i22++) {
        var a2 = n3 - i22;
        if (s(e4, i22, a2) < t3) return { q: i22, j: a2 };
      }
      throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
    })(c2, 1e-15), f2 = l.q, p = l.j, m = o(e3, Math.pow(2, -p)), d = i2(u), h = i2(u), g = 1, y = m, v2 = -1, x2 = 1; x2 <= f2; x2++) x2 > 1 && (y = o(y, m), v2 = -v2), d = n(d, o(g = g * (f2 - x2 + 1) / ((2 * f2 - x2 + 1) * x2), y)), h = n(h, o(g * v2, y));
    for (var b2 = o(a(h), d), _2 = 0; _2 < p; _2++) b2 = o(b2, b2);
    return isSparseMatrix(e3) ? e3.createSparseMatrix(b2) : b2;
  } });
  function s(e3, t22, r2) {
    for (var n3 = 1, i22 = 2; i22 <= t22; i22++) n3 *= i22;
    for (var a2 = n3, o2 = t22 + 1; o2 <= 2 * t22; o2++) a2 *= o2;
    var s2 = a2 * (2 * t22 + 1);
    return 8 * Math.pow(e3 / Math.pow(2, r2), 2 * t22) * n3 * n3 / (a2 * s2);
  }
})), name$16 = "sqrtm", dependencies$16 = ["typed", "abs", "add", "multiply", "map", "sqrt", "subtract", "inv", "size", "max", "identity"], createSqrtm = factory(name$16, dependencies$16, ((e2) => {
  var { typed: t2, abs: r, add: n, multiply: i2, map: a, sqrt: o, subtract: s, inv: u, size: c2, max: l, identity: f2 } = e2, p = 1e-6;
  function m(e3) {
    var t22, a2 = 0, o2 = e3, m2 = f2(c2(e3));
    do {
      var d = o2;
      if (o2 = i2(0.5, n(d, u(m2))), m2 = i2(0.5, n(m2, u(d))), (t22 = l(r(s(o2, d)))) > p && ++a2 > 1e3) throw new Error("computing square root of matrix: iterative method could not converge");
    } while (t22 > p);
    return o2;
  }
  return t2(name$16, { "Array | Matrix": function(e3) {
    var t22 = isMatrix(e3) ? e3.size() : arraySize(e3);
    switch (t22.length) {
      case 1:
        if (1 === t22[0]) return a(e3, o);
        throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
      case 2:
        if (t22[0] === t22[1]) return m(e3);
        throw new RangeError("Matrix must be square (size: " + format(t22) + ")");
      default:
        throw new RangeError("Matrix must be at most two dimensional (size: " + format(t22) + ")");
    }
  } });
})), name$15 = "sylvester", dependencies$15 = ["typed", "schur", "matrixFromColumns", "matrix", "multiply", "range", "concat", "transpose", "index", "subset", "add", "subtract", "identity", "lusolve", "abs"], createSylvester = factory(name$15, dependencies$15, ((e2) => {
  var { typed: t2, schur: r, matrixFromColumns: n, matrix: i2, multiply: a, range: o, concat: s, transpose: u, index: c2, subset: l, add: f2, subtract: p, identity: m, lusolve: d, abs: h, config: g } = e2;
  return t2(name$15, { "Matrix, Matrix, Matrix": y, "Array, Matrix, Matrix": function(e3, t22, r2) {
    return y(i2(e3), t22, r2);
  }, "Array, Array, Matrix": function(e3, t22, r2) {
    return y(i2(e3), i2(t22), r2);
  }, "Array, Matrix, Array": function(e3, t22, r2) {
    return y(i2(e3), t22, i2(r2));
  }, "Matrix, Array, Matrix": function(e3, t22, r2) {
    return y(e3, i2(t22), r2);
  }, "Matrix, Array, Array": function(e3, t22, r2) {
    return y(e3, i2(t22), i2(r2));
  }, "Matrix, Matrix, Array": function(e3, t22, r2) {
    return y(e3, t22, i2(r2));
  }, "Array, Array, Array": function(e3, t22, r2) {
    return y(i2(e3), i2(t22), i2(r2)).toArray();
  } });
  function y(e3, t22, g2) {
    for (var y2 = t22.size()[0], v2 = e3.size()[0], x2 = r(e3), b2 = x2.T, _2 = x2.U, w2 = r(a(-1, t22)), A2 = w2.T, N = w2.U, D = a(a(u(_2), g2), N), E = o(0, v2), $2 = [], S2 = (e4, t3) => s(e4, t3, 1), C2 = (e4, t3) => s(e4, t3, 0), M2 = 0; M2 < y2; M2++) if (M2 < y2 - 1 && h(l(A2, c2(M2 + 1, M2))) > 1e-5) {
      for (var T2 = C2(l(D, c2(E, [M2])), l(D, c2(E, [M2 + 1]))), F = 0; F < M2; F++) T2 = f2(T2, C2(a($2[F], l(A2, c2(F, M2))), a($2[F], l(A2, c2(F, M2 + 1)))));
      var O2 = a(m(v2), a(-1, l(A2, c2(M2, M2)))), k2 = a(m(v2), a(-1, l(A2, c2(M2 + 1, M2)))), B2 = a(m(v2), a(-1, l(A2, c2(M2, M2 + 1)))), I2 = a(m(v2), a(-1, l(A2, c2(M2 + 1, M2 + 1)))), R2 = C2(S2(f2(b2, O2), k2), S2(B2, f2(b2, I2))), q2 = d(R2, T2);
      $2[M2] = q2.subset(c2(o(0, v2), [0])), $2[M2 + 1] = q2.subset(c2(o(v2, 2 * v2), [0])), M2++;
    } else {
      for (var z2 = l(D, c2(E, [M2])), P2 = 0; P2 < M2; P2++) z2 = f2(z2, a($2[P2], l(A2, c2(P2, M2))));
      var L2 = l(A2, c2(M2, M2)), j2 = p(b2, a(L2, m(v2)));
      $2[M2] = d(j2, z2);
    }
    var U2 = i2(n(...$2));
    return a(_2, a(U2, u(N)));
  }
})), name$14 = "schur", dependencies$14 = ["typed", "matrix", "identity", "multiply", "qr", "norm", "subtract"], createSchur = factory(name$14, dependencies$14, ((e2) => {
  var { typed: t2, matrix: r, identity: n, multiply: i2, qr: a, norm: o, subtract: s } = e2;
  return t2(name$14, { Array: function(e3) {
    var t22 = u(r(e3));
    return { U: t22.U.valueOf(), T: t22.T.valueOf() };
  }, Matrix: function(e3) {
    return u(e3);
  } });
  function u(e3) {
    var t22, r2 = e3.size()[0], u2 = e3, c2 = n(r2), l = 0;
    do {
      t22 = u2;
      var f2 = a(u2), p = f2.Q, m = f2.R;
      if (u2 = i2(m, p), c2 = i2(c2, p), l++ > 100) break;
    } while (o(s(u2, t22)) > 1e-4);
    return { U: c2, T: u2 };
  }
})), name$13 = "lyap", dependencies$13 = ["typed", "matrix", "sylvester", "multiply", "transpose"], createLyap = factory(name$13, dependencies$13, ((e2) => {
  var { typed: t2, matrix: r, sylvester: n, multiply: i2, transpose: a } = e2;
  return t2(name$13, { "Matrix, Matrix": function(e3, t22) {
    return n(e3, a(e3), i2(-1, t22));
  }, "Array, Matrix": function(e3, t22) {
    return n(r(e3), a(r(e3)), i2(-1, t22));
  }, "Matrix, Array": function(e3, t22) {
    return n(e3, a(r(e3)), r(i2(-1, t22)));
  }, "Array, Array": function(e3, t22) {
    return n(r(e3), a(r(e3)), r(i2(-1, t22))).toArray();
  } });
})), name$12 = "divide", dependencies$12 = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], createDivide = factory(name$12, dependencies$12, ((e2) => {
  var { typed: t2, matrix: r, multiply: n, equalScalar: i2, divideScalar: a, inv: o } = e2, s = createMatAlgo11xS0s({ typed: t2, equalScalar: i2 }), u = createMatAlgo14xDs({ typed: t2 });
  return t2("divide", extend$2({ "Array | Matrix, Array | Matrix": function(e3, t22) {
    return n(e3, o(t22));
  }, "DenseMatrix, any": function(e3, t22) {
    return u(e3, t22, a, false);
  }, "SparseMatrix, any": function(e3, t22) {
    return s(e3, t22, a, false);
  }, "Array, any": function(e3, t22) {
    return u(r(e3), t22, a, false).valueOf();
  }, "any, Array | Matrix": function(e3, t22) {
    return n(e3, o(t22));
  } }, a.signatures));
})), name$11 = "distance", dependencies$11 = ["typed", "addScalar", "subtractScalar", "divideScalar", "multiplyScalar", "deepEqual", "sqrt", "abs"], createDistance = factory(name$11, dependencies$11, ((e2) => {
  var { typed: t2, addScalar: r, subtractScalar: n, multiplyScalar: i2, divideScalar: a, deepEqual: o, sqrt: s, abs: u } = e2;
  return t2(name$11, { "Array, Array, Array": function(e3, t22, r2) {
    if (2 === e3.length && 2 === t22.length && 2 === r2.length) {
      if (!l(e3)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!l(t22)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!l(r2)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (o(t22, r2)) throw new TypeError("LinePoint1 should not be same with LinePoint2");
      var a2 = n(r2[1], t22[1]), s2 = n(t22[0], r2[0]), u2 = n(i2(r2[0], t22[1]), i2(t22[0], r2[1]));
      return h(e3[0], e3[1], a2, s2, u2);
    }
    throw new TypeError("Invalid Arguments: Try again");
  }, "Object, Object, Object": function(e3, t22, r2) {
    if (2 === Object.keys(e3).length && 2 === Object.keys(t22).length && 2 === Object.keys(r2).length) {
      if (!l(e3)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
      if (!l(t22)) throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
      if (!l(r2)) throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
      if (o(d(t22), d(r2))) throw new TypeError("LinePoint1 should not be same with LinePoint2");
      if ("pointX" in e3 && "pointY" in e3 && "lineOnePtX" in t22 && "lineOnePtY" in t22 && "lineTwoPtX" in r2 && "lineTwoPtY" in r2) {
        var a2 = n(r2.lineTwoPtY, t22.lineOnePtY), s2 = n(t22.lineOnePtX, r2.lineTwoPtX), u2 = n(i2(r2.lineTwoPtX, t22.lineOnePtY), i2(t22.lineOnePtX, r2.lineTwoPtY));
        return h(e3.pointX, e3.pointY, a2, s2, u2);
      }
      throw new TypeError("Key names do not match");
    }
    throw new TypeError("Invalid Arguments: Try again");
  }, "Array, Array": function(e3, t22) {
    if (2 === e3.length && 3 === t22.length) {
      if (!l(e3)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!f2(t22)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      return h(e3[0], e3[1], t22[0], t22[1], t22[2]);
    }
    if (3 === e3.length && 6 === t22.length) {
      if (!f2(e3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!m(t22)) throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
      return g(e3[0], e3[1], e3[2], t22[0], t22[1], t22[2], t22[3], t22[4], t22[5]);
    }
    if (e3.length === t22.length && e3.length > 0) {
      if (!p(e3)) throw new TypeError("All values of an array should be numbers or BigNumbers");
      if (!p(t22)) throw new TypeError("All values of an array should be numbers or BigNumbers");
      return y(e3, t22);
    }
    throw new TypeError("Invalid Arguments: Try again");
  }, "Object, Object": function(e3, t22) {
    if (2 === Object.keys(e3).length && 3 === Object.keys(t22).length) {
      if (!l(e3)) throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
      if (!f2(t22)) throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
      if ("pointX" in e3 && "pointY" in e3 && "xCoeffLine" in t22 && "yCoeffLine" in t22 && "constant" in t22) return h(e3.pointX, e3.pointY, t22.xCoeffLine, t22.yCoeffLine, t22.constant);
      throw new TypeError("Key names do not match");
    }
    if (3 === Object.keys(e3).length && 6 === Object.keys(t22).length) {
      if (!f2(e3)) throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
      if (!m(t22)) throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
      if ("pointX" in e3 && "pointY" in e3 && "x0" in t22 && "y0" in t22 && "z0" in t22 && "a" in t22 && "b" in t22 && "c" in t22) return g(e3.pointX, e3.pointY, e3.pointZ, t22.x0, t22.y0, t22.z0, t22.a, t22.b, t22.c);
      throw new TypeError("Key names do not match");
    }
    if (2 === Object.keys(e3).length && 2 === Object.keys(t22).length) {
      if (!l(e3)) throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
      if (!l(t22)) throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
      if ("pointOneX" in e3 && "pointOneY" in e3 && "pointTwoX" in t22 && "pointTwoY" in t22) return y([e3.pointOneX, e3.pointOneY], [t22.pointTwoX, t22.pointTwoY]);
      throw new TypeError("Key names do not match");
    }
    if (3 === Object.keys(e3).length && 3 === Object.keys(t22).length) {
      if (!f2(e3)) throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
      if (!f2(t22)) throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
      if ("pointOneX" in e3 && "pointOneY" in e3 && "pointOneZ" in e3 && "pointTwoX" in t22 && "pointTwoY" in t22 && "pointTwoZ" in t22) return y([e3.pointOneX, e3.pointOneY, e3.pointOneZ], [t22.pointTwoX, t22.pointTwoY, t22.pointTwoZ]);
      throw new TypeError("Key names do not match");
    }
    throw new TypeError("Invalid Arguments: Try again");
  }, Array: function(e3) {
    if (!(function(e4) {
      if (2 === e4[0].length && c2(e4[0][0]) && c2(e4[0][1])) {
        if (e4.some(((e5) => 2 !== e5.length || !c2(e5[0]) || !c2(e5[1])))) return false;
      } else {
        if (!(3 === e4[0].length && c2(e4[0][0]) && c2(e4[0][1]) && c2(e4[0][2]))) return false;
        if (e4.some(((e5) => 3 !== e5.length || !c2(e5[0]) || !c2(e5[1]) || !c2(e5[2])))) return false;
      }
      return true;
    })(e3)) throw new TypeError("Incorrect array format entered for pairwise distance calculation");
    return (function(e4) {
      for (var t22 = [], r2 = [], n3 = [], i22 = 0; i22 < e4.length - 1; i22++) for (var a2 = i22 + 1; a2 < e4.length; a2++) 2 === e4[0].length ? (r2 = [e4[i22][0], e4[i22][1]], n3 = [e4[a2][0], e4[a2][1]]) : 3 === e4[0].length && (r2 = [e4[i22][0], e4[i22][1], e4[i22][2]], n3 = [e4[a2][0], e4[a2][1], e4[a2][2]]), t22.push(y(r2, n3));
      return t22;
    })(e3);
  } });
  function c2(e3) {
    return "number" == typeof e3 || isBigNumber(e3);
  }
  function l(e3) {
    return e3.constructor !== Array && (e3 = d(e3)), c2(e3[0]) && c2(e3[1]);
  }
  function f2(e3) {
    return e3.constructor !== Array && (e3 = d(e3)), c2(e3[0]) && c2(e3[1]) && c2(e3[2]);
  }
  function p(e3) {
    return Array.isArray(e3) || (e3 = d(e3)), e3.every(c2);
  }
  function m(e3) {
    return e3.constructor !== Array && (e3 = d(e3)), c2(e3[0]) && c2(e3[1]) && c2(e3[2]) && c2(e3[3]) && c2(e3[4]) && c2(e3[5]);
  }
  function d(e3) {
    for (var t22 = Object.keys(e3), r2 = [], n3 = 0; n3 < t22.length; n3++) r2.push(e3[t22[n3]]);
    return r2;
  }
  function h(e3, t22, n3, o2, c3) {
    var l2 = u(r(r(i2(n3, e3), i2(o2, t22)), c3)), f3 = s(r(i2(n3, n3), i2(o2, o2)));
    return a(l2, f3);
  }
  function g(e3, t22, o2, u2, c3, l2, f3, p2, m2) {
    var d2 = [n(i2(n(c3, t22), m2), i2(n(l2, o2), p2)), n(i2(n(l2, o2), f3), i2(n(u2, e3), m2)), n(i2(n(u2, e3), p2), i2(n(c3, t22), f3))];
    d2 = s(r(r(i2(d2[0], d2[0]), i2(d2[1], d2[1])), i2(d2[2], d2[2])));
    var h2 = s(r(r(i2(f3, f3), i2(p2, p2)), i2(m2, m2)));
    return a(d2, h2);
  }
  function y(e3, t22) {
    for (var a2 = e3.length, o2 = 0, u2 = 0, c3 = 0; c3 < a2; c3++) u2 = n(e3[c3], t22[c3]), o2 = r(i2(u2, u2), o2);
    return s(o2);
  }
})), name$10 = "intersect", dependencies$10 = ["typed", "config", "abs", "add", "addScalar", "matrix", "multiply", "multiplyScalar", "divideScalar", "subtract", "smaller", "equalScalar", "flatten", "isZero", "isNumeric"], createIntersect = factory(name$10, dependencies$10, ((e2) => {
  var { typed: t2, config: r, abs: n, add: i2, addScalar: a, matrix: o, multiply: s, multiplyScalar: u, divideScalar: c2, subtract: l, smaller: f2, equalScalar: p, flatten: m, isZero: d, isNumeric: h } = e2;
  return t2("intersect", { "Array, Array, Array": g, "Array, Array, Array, Array": y, "Matrix, Matrix, Matrix": function(e3, t22, r2) {
    var n3 = g(e3.valueOf(), t22.valueOf(), r2.valueOf());
    return null === n3 ? null : o(n3);
  }, "Matrix, Matrix, Matrix, Matrix": function(e3, t22, r2, n3) {
    var i22 = y(e3.valueOf(), t22.valueOf(), r2.valueOf(), n3.valueOf());
    return null === i22 ? null : o(i22);
  } });
  function g(e3, t22, r2) {
    if (e3 = v2(e3), t22 = v2(t22), r2 = v2(r2), !b2(e3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
    if (!b2(t22)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
    if (!(function(e4) {
      return 4 === e4.length && h(e4[0]) && h(e4[1]) && h(e4[2]) && h(e4[3]);
    })(r2)) throw new TypeError("Array with 4 numbers expected as third argument");
    return (function(e4, t3, r3, n3, i22, o2, s2, f3, p2, m2) {
      var d2 = u(e4, s2), h2 = u(n3, s2), g2 = u(t3, f3), y2 = u(i22, f3), v22 = u(r3, p2), x22 = u(o2, p2), b22 = l(l(l(m2, d2), g2), v22), _3 = l(l(l(a(a(h2, y2), x22), d2), g2), v22), w2 = c2(b22, _3), A2 = a(e4, u(w2, l(n3, e4))), N = a(t3, u(w2, l(i22, t3))), D = a(r3, u(w2, l(o2, r3)));
      return [A2, N, D];
    })(e3[0], e3[1], e3[2], t22[0], t22[1], t22[2], r2[0], r2[1], r2[2], r2[3]);
  }
  function y(e3, t22, o2, m2) {
    if (e3 = v2(e3), t22 = v2(t22), o2 = v2(o2), m2 = v2(m2), 2 === e3.length) {
      if (!x2(e3)) throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!x2(t22)) throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!x2(o2)) throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (!x2(m2)) throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
      return (function(e4, t3, o3, p2) {
        var m3 = e4, h2 = o3, g2 = l(m3, t3), y2 = l(h2, p2), v22 = l(u(g2[0], y2[1]), u(y2[0], g2[1]));
        if (d(v22)) return null;
        if (f2(n(v22), r.relTol)) return null;
        var x22 = u(y2[0], m3[1]), b22 = u(y2[1], m3[0]), _3 = u(y2[0], h2[1]), w2 = u(y2[1], h2[0]), A2 = c2(a(l(l(x22, b22), _3), w2), v22);
        return i2(s(g2, A2), m3);
      })(e3, t22, o2, m2);
    }
    if (3 === e3.length) {
      if (!b2(e3)) throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!b2(t22)) throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      if (!b2(o2)) throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
      if (!b2(m2)) throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
      return (function(e4, t3, r2, n3, i22, o3, s2, f3, m3, h2, g2, y2) {
        var v22 = _2(e4, s2, h2, s2, t3, f3, g2, f3, r2, m3, y2, m3), x22 = _2(h2, s2, n3, e4, g2, f3, i22, t3, y2, m3, o3, r2), b22 = _2(e4, s2, n3, e4, t3, f3, i22, t3, r2, m3, o3, r2), w2 = _2(h2, s2, h2, s2, g2, f3, g2, f3, y2, m3, y2, m3), A2 = _2(n3, e4, n3, e4, i22, t3, i22, t3, o3, r2, o3, r2), N = l(u(v22, x22), u(b22, w2)), D = l(u(A2, w2), u(x22, x22));
        if (d(D)) return null;
        var E = c2(N, D), $2 = c2(a(v22, u(E, x22)), w2), S2 = a(e4, u(E, l(n3, e4))), C2 = a(t3, u(E, l(i22, t3))), M2 = a(r2, u(E, l(o3, r2))), T2 = a(s2, u($2, l(h2, s2))), F = a(f3, u($2, l(g2, f3))), O2 = a(m3, u($2, l(y2, m3)));
        return p(S2, T2) && p(C2, F) && p(M2, O2) ? [S2, C2, M2] : null;
      })(e3[0], e3[1], e3[2], t22[0], t22[1], t22[2], o2[0], o2[1], o2[2], m2[0], m2[1], m2[2]);
    }
    throw new TypeError("Arrays with two or thee dimensional points expected");
  }
  function v2(e3) {
    return 1 === e3.length ? e3[0] : e3.length > 1 && Array.isArray(e3[0]) && e3.every(((e4) => Array.isArray(e4) && 1 === e4.length)) ? m(e3) : e3;
  }
  function x2(e3) {
    return 2 === e3.length && h(e3[0]) && h(e3[1]);
  }
  function b2(e3) {
    return 3 === e3.length && h(e3[0]) && h(e3[1]) && h(e3[2]);
  }
  function _2(e3, t22, r2, n3, i22, o2, s2, c3, f3, p2, m2, d2) {
    var h2 = u(l(e3, t22), l(r2, n3)), g2 = u(l(i22, o2), l(s2, c3)), y2 = u(l(f3, p2), l(m2, d2));
    return a(a(h2, g2), y2);
  }
})), name$$ = "sum", dependencies$$ = ["typed", "config", "add", "numeric"], createSum = factory(name$$, dependencies$$, ((e2) => {
  var { typed: t2, config: r, add: n, numeric: i2 } = e2;
  return t2(name$$, { "Array | Matrix": a, "Array | Matrix, number | BigNumber": function(e3, t22) {
    try {
      return reduce$2(e3, t22, n);
    } catch (e4) {
      throw improveErrorMessage(e4, "sum");
    }
  }, "...": function(e3) {
    if (containsCollections(e3)) throw new TypeError("Scalar values expected in function sum");
    return a(e3);
  } });
  function a(e3) {
    var t22;
    return deepForEach(e3, (function(e4) {
      try {
        t22 = void 0 === t22 ? e4 : n(t22, e4);
      } catch (t3) {
        throw improveErrorMessage(t3, "sum", e4);
      }
    })), void 0 === t22 && (t22 = i2(0, r.number)), "string" == typeof t22 && (t22 = i2(t22, safeNumberType(t22, r))), t22;
  }
})), name$_ = "cumsum", dependencies$_ = ["typed", "add", "unaryPlus"], createCumSum = factory(name$_, dependencies$_, ((e2) => {
  var { typed: t2, add: r, unaryPlus: n } = e2;
  return t2(name$_, { Array: i2, Matrix: function(e3) {
    return e3.create(i2(e3.valueOf(), e3.datatype()));
  }, "Array, number | BigNumber": o, "Matrix, number | BigNumber": function(e3, t22) {
    return e3.create(o(e3.valueOf(), t22), e3.datatype());
  }, "...": function(e3) {
    if (containsCollections(e3)) throw new TypeError("All values expected to be scalar in function cumsum");
    return i2(e3);
  } });
  function i2(e3) {
    try {
      return a(e3);
    } catch (e4) {
      throw improveErrorMessage(e4, name$_);
    }
  }
  function a(e3) {
    if (0 === e3.length) return [];
    for (var t22 = [n(e3[0])], i22 = 1; i22 < e3.length; ++i22) t22.push(r(t22[i22 - 1], e3[i22]));
    return t22;
  }
  function o(e3, t22) {
    var r2 = arraySize(e3);
    if (t22 < 0 || t22 >= r2.length) throw new IndexError(t22, r2.length);
    try {
      return s(e3, t22);
    } catch (e4) {
      throw improveErrorMessage(e4, name$_);
    }
  }
  function s(e3, t22) {
    var r2, n3, i22;
    if (t22 <= 0) {
      var o2 = e3[0][0];
      if (Array.isArray(o2)) {
        for (i22 = _switch$1(e3), n3 = [], r2 = 0; r2 < i22.length; r2++) n3[r2] = s(i22[r2], t22 - 1);
        return n3;
      }
      return a(e3);
    }
    for (n3 = [], r2 = 0; r2 < e3.length; r2++) n3[r2] = s(e3[r2], t22 - 1);
    return n3;
  }
})), name$Z = "mean", dependencies$Z = ["typed", "add", "divide"], createMean = factory(name$Z, dependencies$Z, ((e2) => {
  var { typed: t2, add: r, divide: n } = e2;
  return t2(name$Z, { "Array | Matrix": i2, "Array | Matrix, number | BigNumber": function(e3, t22) {
    try {
      var i22 = reduce$2(e3, t22, r), a = Array.isArray(e3) ? arraySize(e3) : e3.size();
      return n(i22, a[t22]);
    } catch (e4) {
      throw improveErrorMessage(e4, "mean");
    }
  }, "...": function(e3) {
    if (containsCollections(e3)) throw new TypeError("Scalar values expected in function mean");
    return i2(e3);
  } });
  function i2(e3) {
    var t22, i22 = 0;
    if (deepForEach(e3, (function(e4) {
      try {
        t22 = void 0 === t22 ? e4 : r(t22, e4), i22++;
      } catch (t3) {
        throw improveErrorMessage(t3, "mean", e4);
      }
    })), 0 === i22) throw new Error("Cannot calculate the mean of an empty array");
    return n(t22, i22);
  }
})), name$Y = "median", dependencies$Y = ["typed", "add", "divide", "compare", "partitionSelect"], createMedian = factory(name$Y, dependencies$Y, ((e2) => {
  var { typed: t2, add: r, divide: n, compare: i2, partitionSelect: a } = e2;
  function o(e3) {
    try {
      var t22 = (e3 = flatten$4(e3.valueOf())).length;
      if (0 === t22) throw new Error("Cannot calculate median of an empty array");
      if (t22 % 2 == 0) {
        for (var r2 = t22 / 2 - 1, n3 = a(e3, r2 + 1), o2 = e3[r2], c2 = 0; c2 < r2; ++c2) i2(e3[c2], o2) > 0 && (o2 = e3[c2]);
        return u(o2, n3);
      }
      var l = a(e3, (t22 - 1) / 2);
      return s(l);
    } catch (e4) {
      throw improveErrorMessage(e4, "median");
    }
  }
  var s = t2({ "number | BigNumber | Complex | Unit": function(e3) {
    return e3;
  } }), u = t2({ "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(e3, t22) {
    return n(r(e3, t22), 2);
  } });
  return t2(name$Y, { "Array | Matrix": o, "Array | Matrix, number | BigNumber": function(e3, t22) {
    throw new Error("median(A, dim) is not yet supported");
  }, "...": function(e3) {
    if (containsCollections(e3)) throw new TypeError("Scalar values expected in function median");
    return o(e3);
  } });
})), name$X = "mad", dependencies$X = ["typed", "abs", "map", "median", "subtract"], createMad = factory(name$X, dependencies$X, ((e2) => {
  var { typed: t2, abs: r, map: n, median: i2, subtract: a } = e2;
  return t2(name$X, { "Array | Matrix": o, "...": function(e3) {
    return o(e3);
  } });
  function o(e3) {
    if (0 === (e3 = flatten$4(e3.valueOf())).length) throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
    try {
      var t22 = i2(e3);
      return i2(n(e3, (function(e4) {
        return r(a(e4, t22));
      })));
    } catch (e4) {
      throw e4 instanceof TypeError && e4.message.includes("median") ? new TypeError(e4.message.replace("median", "mad")) : improveErrorMessage(e4, "mad");
    }
  }
})), DEFAULT_NORMALIZATION = "unbiased", name$W = "variance", dependencies$W = ["typed", "add", "subtract", "multiply", "divide", "mapSlices", "isNaN"], createVariance = factory(name$W, dependencies$W, ((e2) => {
  var { typed: t2, add: r, subtract: n, multiply: i2, divide: a, mapSlices: o, isNaN: s } = e2;
  return t2(name$W, { "Array | Matrix": function(e3) {
    return u(e3, DEFAULT_NORMALIZATION);
  }, "Array | Matrix, string": u, "Array | Matrix, number | BigNumber": function(e3, t22) {
    return c2(e3, t22, DEFAULT_NORMALIZATION);
  }, "Array | Matrix, number | BigNumber, string": c2, "...": function(e3) {
    return u(e3, DEFAULT_NORMALIZATION);
  } });
  function u(e3, t22) {
    var o2, u2 = 0;
    if (0 === e3.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
    if (deepForEach(e3, (function(e4) {
      try {
        o2 = void 0 === o2 ? e4 : r(o2, e4), u2++;
      } catch (t3) {
        throw improveErrorMessage(t3, "variance", e4);
      }
    })), 0 === u2) throw new Error("Cannot calculate variance of an empty array");
    var c3 = a(o2, u2);
    if (o2 = void 0, deepForEach(e3, (function(e4) {
      var t3 = n(e4, c3);
      o2 = void 0 === o2 ? i2(t3, t3) : r(o2, i2(t3, t3));
    })), s(o2)) return o2;
    switch (t22) {
      case "uncorrected":
        return a(o2, u2);
      case "biased":
        return a(o2, u2 + 1);
      case "unbiased":
        var l = isBigNumber(o2) ? o2.mul(0) : 0;
        return 1 === u2 ? l : a(o2, u2 - 1);
      default:
        throw new Error('Unknown normalization "' + t22 + '". Choose "unbiased" (default), "uncorrected", or "biased".');
    }
  }
  function c2(e3, t22, r2) {
    try {
      if (0 === e3.length) throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
      return o(e3, t22, ((e4) => u(e4, r2)));
    } catch (e4) {
      throw improveErrorMessage(e4, "variance");
    }
  }
})), name$V = "quantileSeq", dependencies$V = ["typed", "?bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger", "mapSlices"], createQuantileSeq = factory(name$V, dependencies$V, ((e2) => {
  var { typed: t2, bignumber: r, add: n, subtract: i2, divide: a, multiply: o, partitionSelect: s, compare: u, isInteger: c2, smaller: l, smallerEq: f2, larger: p, mapSlices: m } = e2;
  return t2(name$V, { "Array | Matrix, number | BigNumber": (e3, t22) => h(e3, t22, false), "Array | Matrix, number | BigNumber, number": (e3, t22, r2) => d(e3, t22, false, r2, h), "Array | Matrix, number | BigNumber, boolean": h, "Array | Matrix, number | BigNumber, boolean, number": (e3, t22, r2, n3) => d(e3, t22, r2, n3, h), "Array | Matrix, Array | Matrix": (e3, t22) => g(e3, t22, false), "Array | Matrix, Array | Matrix, number": (e3, t22, r2) => d(e3, t22, false, r2, g), "Array | Matrix, Array | Matrix, boolean": g, "Array | Matrix, Array | Matrix, boolean, number": (e3, t22, r2, n3) => d(e3, t22, r2, n3, g) });
  function d(e3, t22, r2, n3, i22) {
    return m(e3, n3, ((e4) => i22(e4, t22, r2)));
  }
  function h(e3, t22, i22) {
    var o2, s2 = e3.valueOf();
    if (l(t22, 0)) throw new Error("N/prob must be non-negative");
    if (f2(t22, 1)) return isNumber$1(t22) ? y(s2, t22, i22) : r(y(s2, t22, i22));
    if (p(t22, 1)) {
      if (!c2(t22)) throw new Error("N must be a positive integer");
      if (p(t22, 4294967295)) throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
      var u2 = n(t22, 1);
      o2 = [];
      for (var m2 = 0; l(m2, t22); m2++) {
        var d2 = a(m2 + 1, u2);
        o2.push(y(s2, d2, i22));
      }
      return isNumber$1(t22) ? o2 : r(o2);
    }
  }
  function g(e3, t22, r2) {
    for (var n3 = e3.valueOf(), i22 = t22.valueOf(), a2 = [], o2 = 0; o2 < i22.length; ++o2) a2.push(y(n3, i22[o2], r2));
    return a2;
  }
  function y(e3, t22, r2) {
    var a2 = flatten$4(e3), l2 = a2.length;
    if (0 === l2) throw new Error("Cannot calculate quantile of an empty sequence");
    var f3, p2, m2 = isNumber$1(t22) ? t22 * (l2 - 1) : t22.times(l2 - 1), d2 = isNumber$1(t22) ? Math.floor(m2) : m2.floor().toNumber(), h2 = isNumber$1(t22) ? m2 % 1 : m2.minus(d2);
    if (c2(m2)) return r2 ? a2[m2] : s(a2, isNumber$1(t22) ? m2 : m2.valueOf());
    if (r2) f3 = a2[d2], p2 = a2[d2 + 1];
    else {
      p2 = s(a2, d2 + 1), f3 = a2[d2];
      for (var g2 = 0; g2 < d2; ++g2) u(a2[g2], f3) > 0 && (f3 = a2[g2]);
    }
    return n(o(f3, i2(1, h2)), o(p2, h2));
  }
})), name$U = "std", dependencies$U = ["typed", "map", "sqrt", "variance"], createStd = factory(name$U, dependencies$U, ((e2) => {
  var { typed: t2, map: r, sqrt: n, variance: i2 } = e2;
  return t2(name$U, { "Array | Matrix": a, "Array | Matrix, string": a, "Array | Matrix, number | BigNumber": a, "Array | Matrix, number | BigNumber, string": a, "...": function(e3) {
    return a(e3);
  } });
  function a(e3, t22) {
    if (0 === e3.length) throw new SyntaxError("Function std requires one or more parameters (0 provided)");
    try {
      var a2 = i2.apply(null, arguments);
      return isCollection(a2) ? r(a2, n) : n(a2);
    } catch (e4) {
      throw e4 instanceof TypeError && e4.message.includes(" variance") ? new TypeError(e4.message.replace(" variance", " std")) : e4;
    }
  }
})), name$T = "corr", dependencies$T = ["typed", "matrix", "mean", "sqrt", "sum", "add", "subtract", "multiply", "pow", "divide"], createCorr = factory(name$T, dependencies$T, ((e2) => {
  var { typed: t2, matrix: r, sqrt: n, sum: i2, add: a, subtract: o, multiply: s, pow: u, divide: c2 } = e2;
  return t2(name$T, { "Array, Array": function(e3, t22) {
    return l(e3, t22);
  }, "Matrix, Matrix": function(e3, t22) {
    var n3 = l(e3.toArray(), t22.toArray());
    return Array.isArray(n3) ? r(n3) : n3;
  } });
  function l(e3, t22) {
    var r2 = [];
    if (Array.isArray(e3[0]) && Array.isArray(t22[0])) {
      if (e3.length !== t22.length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same length.");
      for (var n3 = 0; n3 < e3.length; n3++) {
        if (e3[n3].length !== t22[n3].length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
        r2.push(f2(e3[n3], t22[n3]));
      }
      return r2;
    }
    if (e3.length !== t22.length) throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
    return f2(e3, t22);
  }
  function f2(e3, t22) {
    var r2 = e3.length, l2 = i2(e3), f3 = i2(t22), p = e3.reduce(((e4, r3, n3) => a(e4, s(r3, t22[n3]))), 0), m = i2(e3.map(((e4) => u(e4, 2)))), d = i2(t22.map(((e4) => u(e4, 2)))), h = o(s(r2, p), s(l2, f3)), g = n(s(o(s(r2, m), u(l2, 2)), o(s(r2, d), u(f3, 2))));
    return c2(h, g);
  }
})), name$S = "bernoulli", dependencies$S = ["typed", "config", "isInteger", "number", "?BigNumber", "?Fraction"], createBernoulli = factory(name$S, dependencies$S, ((e2) => {
  var { typed: t2, config: r, number: n, BigNumber: i2, Fraction: a } = e2, o = [void 0], s = [void 0], u = [void 0], c2 = 50;
  return t2(name$S, { number: (e3) => _bernoulli(e3, ((e4) => e4), o, ((e4, t22) => e4 + t22), ((e4, t22) => e4 * t22), ((e4, t22) => e4 / t22)), "bigint | Fraction": (e3) => _bernoulli(n(e3), ((e4) => new a(e4)), s, ((e4, t22) => e4.add(t22)), ((e4, t22) => e4.mul(t22)), ((e4, t22) => e4.div(t22))), BigNumber: (e3) => (r.precision !== c2 && (u = [void 0], c2 = r.precision), _bernoulli(n(e3), ((e4) => new i2(e4)), u, ((e4, t22) => e4.add(t22)), ((e4, t22) => e4.mul(t22)), ((e4, t22) => e4.div(t22)))) });
}));
function _bernoulli(e2, t2, r, n, i2, a) {
  if (e2 < 0 || !isInteger(e2)) throw new RangeError("Bernoulli index must be nonnegative integer");
  if (0 === e2) return t2(1);
  if (1 === e2) return a(t2(-1), t2(2));
  if (e2 % 2 == 1) return t2(0);
  var o = t2(1);
  1 === r.length && r.push([a(o, t2(-3)), a(o, t2(-2)), a(o, t2(6))]);
  for (var s = e2 / 2, u = t2(0), c2 = t2(2); r.length <= s; ) {
    for (var l = r.length, f2 = Math.floor((l + 1) / 2), p = u, m = 1; m < f2; ++m) p = n(p, i2(r[m][0], r[l - m][0]));
    p = i2(p, c2), l % 2 == 0 && (p = n(p, i2(r[f2][0], r[f2][0]))), p = a(p, t2(-(2 * l + 1)));
    var d = a(i2(r[l - 1][1], t2(-l * (2 * l - 1))), c2);
    r.push([p, d, i2(d, p)]);
  }
  return r[s][2];
}
var name$R = "combinations", dependencies$R = ["typed"], createCombinations = factory(name$R, dependencies$R, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$R, { "number, number": combinationsNumber, "BigNumber, BigNumber": function(e3, t22) {
    var r, n, i2 = e3.constructor, a = e3.minus(t22), o = new i2(1);
    if (!isPositiveInteger$2(e3) || !isPositiveInteger$2(t22)) throw new TypeError("Positive integer value expected in function combinations");
    if (t22.gt(e3)) throw new TypeError("k must be less than n in function combinations");
    if (r = o, t22.lt(a)) for (n = o; n.lte(a); n = n.plus(o)) r = r.times(t22.plus(n)).dividedBy(n);
    else for (n = o; n.lte(t22); n = n.plus(o)) r = r.times(a.plus(n)).dividedBy(n);
    return r;
  } });
}));
function isPositiveInteger$2(e2) {
  return e2.isInteger() && e2.gte(0);
}
var name$Q = "combinationsWithRep", dependencies$Q = ["typed"], createCombinationsWithRep = factory(name$Q, dependencies$Q, ((e2) => {
  var { typed: t2 } = e2;
  return t2(name$Q, { "number, number": function(e3, t22) {
    if (!isInteger(e3) || e3 < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
    if (!isInteger(t22) || t22 < 0) throw new TypeError("Positive integer value expected in function combinationsWithRep");
    if (e3 < 1) throw new TypeError("k must be less than or equal to n + k - 1");
    return t22 < e3 - 1 ? product(e3, e3 + t22 - 1) / product(1, t22) : product(t22 + 1, e3 + t22 - 1) / product(1, e3 - 1);
  }, "BigNumber, BigNumber": function(e3, t22) {
    var r, n, i2 = new e3.constructor(1), a = e3.minus(i2);
    if (!isPositiveInteger$1(e3) || !isPositiveInteger$1(t22)) throw new TypeError("Positive integer value expected in function combinationsWithRep");
    if (e3.lt(i2)) throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
    if (r = i2, t22.lt(a)) for (n = i2; n.lte(a); n = n.plus(i2)) r = r.times(t22.plus(n)).dividedBy(n);
    else for (n = i2; n.lte(t22); n = n.plus(i2)) r = r.times(a.plus(n)).dividedBy(n);
    return r;
  } });
}));
function isPositiveInteger$1(e2) {
  return e2.isInteger() && e2.gte(0);
}
var name$P = "gamma", dependencies$P = ["typed", "config", "multiplyScalar", "pow", "BigNumber", "Complex"], createGamma = factory(name$P, dependencies$P, ((e2) => {
  var { typed: t2, config: r, multiplyScalar: n, pow: i2, BigNumber: a, Complex: o } = e2;
  return t2(name$P, { number: gammaNumber, Complex: function e3(t22) {
    if (0 === t22.im) return gammaNumber(t22.re);
    if (t22.re < 0.5) {
      var r2 = new o(1 - t22.re, -t22.im), n3 = new o(Math.PI * t22.re, Math.PI * t22.im);
      return new o(Math.PI).div(n3.sin()).div(e3(r2));
    }
    t22 = new o(t22.re - 1, t22.im);
    for (var i22 = new o(gammaP[0], 0), a2 = 1; a2 < gammaP.length; ++a2) {
      var s2 = new o(gammaP[a2], 0);
      i22 = i22.add(s2.div(t22.add(a2)));
    }
    var u = new o(t22.re + gammaG + 0.5, t22.im), c2 = Math.sqrt(2 * Math.PI), l = u.pow(t22.add(0.5)), f2 = u.neg().exp();
    return i22.mul(c2).mul(l).mul(f2);
  }, BigNumber: function(e3) {
    if (e3.isInteger()) return e3.isNegative() || e3.isZero() ? new a(1 / 0) : s(e3.minus(1));
    if (!e3.isFinite()) return new a(e3.isNegative() ? NaN : 1 / 0);
    throw new Error("Integer BigNumber expected");
  } });
  function s(e3) {
    if (e3 < 8) return new a([1, 1, 2, 6, 24, 120, 720, 5040][e3]);
    var t22 = r.precision + (0 | Math.log(e3.toNumber())), n3 = a.clone({ precision: t22 });
    if (e3 % 2 == 1) return e3.times(s(new a(e3 - 1)));
    for (var i22 = e3, o2 = new n3(e3), u = e3.toNumber(); i22 > 2; ) u += i22 -= 2, o2 = o2.times(u);
    return new a(o2.toPrecision(a.precision));
  }
})), name$O = "lgamma", dependencies$O = ["Complex", "typed"], createLgamma = factory(name$O, dependencies$O, ((e2) => {
  var { Complex: t2, typed: r } = e2, n = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return r(name$O, { number: lgammaNumber, Complex: function e3(r2) {
    if (r2.isNaN()) return new t2(NaN, NaN);
    if (0 === r2.im) return new t2(lgammaNumber(r2.re), 0);
    if (r2.re >= 7 || Math.abs(r2.im) >= 7) return i2(r2);
    if (r2.re <= 0.1) {
      var n3 = copysign(6.283185307179586, r2.im) * Math.floor(0.5 * r2.re + 0.25), o = r2.mul(Math.PI).sin().log(), s = e3(new t2(1 - r2.re, -r2.im));
      return new t2(1.1447298858494002, n3).sub(o).sub(s);
    }
    return r2.im >= 0 ? a(r2) : a(r2.conjugate()).conjugate();
  }, BigNumber: function() {
    throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
  } });
  function i2(e3) {
    for (var r2 = e3.sub(0.5).mul(e3.log()).sub(e3).add(lnSqrt2PI), i22 = new t2(1, 0).div(e3), a2 = i22.div(e3), o = n[0], s = n[1], u = 2 * a2.re, c2 = a2.re * a2.re + a2.im * a2.im, l = 2; l < 8; l++) {
      var f2 = s;
      s = -c2 * o + n[l], o = u * o + f2;
    }
    var p = i22.mul(a2.mul(o).add(s));
    return r2.add(p);
  }
  function a(e3) {
    var r2 = 0, n3 = 0, a2 = e3;
    for (e3 = e3.add(1); e3.re <= 7; ) {
      var o = (a2 = a2.mul(e3)).im < 0 ? 1 : 0;
      0 !== o && 0 === n3 && r2++, n3 = o, e3 = e3.add(1);
    }
    return i2(e3).sub(a2.log()).sub(new t2(0, 2 * r2 * Math.PI * 1));
  }
})), name$N = "factorial", dependencies$N = ["typed", "gamma"], createFactorial = factory(name$N, dependencies$N, ((e2) => {
  var { typed: t2, gamma: r } = e2;
  return t2(name$N, { number: function(e3) {
    if (e3 < 0) throw new Error("Value must be non-negative");
    return r(e3 + 1);
  }, BigNumber: function(e3) {
    if (e3.isNegative()) throw new Error("Value must be non-negative");
    return r(e3.plus(1));
  }, "Array | Matrix": t2.referToSelf(((e3) => (t22) => deepMap(t22, e3))) });
})), name$M = "kldivergence", dependencies$M = ["typed", "matrix", "divide", "sum", "multiply", "map", "dotDivide", "log", "isNumeric"], createKldivergence = factory(name$M, dependencies$M, ((e2) => {
  var { typed: t2, matrix: r, divide: n, sum: i2, multiply: a, map: o, dotDivide: s, log: u, isNumeric: c2 } = e2;
  return t2(name$M, { "Array, Array": function(e3, t22) {
    return l(r(e3), r(t22));
  }, "Matrix, Array": function(e3, t22) {
    return l(e3, r(t22));
  }, "Array, Matrix": function(e3, t22) {
    return l(r(e3), t22);
  }, "Matrix, Matrix": function(e3, t22) {
    return l(e3, t22);
  } });
  function l(e3, t22) {
    var r2 = t22.size().length, l2 = e3.size().length;
    if (r2 > 1) throw new Error("first object must be one dimensional");
    if (l2 > 1) throw new Error("second object must be one dimensional");
    if (r2 !== l2) throw new Error("Length of two vectors must be equal");
    if (0 === i2(e3)) throw new Error("Sum of elements in first object must be non zero");
    if (0 === i2(t22)) throw new Error("Sum of elements in second object must be non zero");
    var f2 = n(e3, i2(e3)), p = n(t22, i2(t22)), m = i2(a(f2, o(s(f2, p), ((e4) => u(e4)))));
    return c2(m) ? m : Number.NaN;
  }
})), name$L = "multinomial", dependencies$L = ["typed", "add", "divide", "multiply", "factorial", "isInteger", "isPositive"], createMultinomial = factory(name$L, dependencies$L, ((e2) => {
  var { typed: t2, add: r, divide: n, multiply: i2, factorial: a, isInteger: o, isPositive: s } = e2;
  return t2(name$L, { "Array | Matrix": function(e3) {
    var t22 = 0, u = 1;
    return deepForEach(e3, (function(e4) {
      if (!o(e4) || !s(e4)) throw new TypeError("Positive integer value expected in function multinomial");
      t22 = r(t22, e4), u = i2(u, a(e4));
    })), n(a(t22), u);
  } });
})), name$K = "permutations", dependencies$K = ["typed", "factorial"], createPermutations = factory(name$K, dependencies$K, ((e2) => {
  var { typed: t2, factorial: r } = e2;
  return t2(name$K, { "number | BigNumber": r, "number, number": function(e3, t22) {
    if (!isInteger(e3) || e3 < 0) throw new TypeError("Positive integer value expected in function permutations");
    if (!isInteger(t22) || t22 < 0) throw new TypeError("Positive integer value expected in function permutations");
    if (t22 > e3) throw new TypeError("second argument k must be less than or equal to first argument n");
    return product(e3 - t22 + 1, e3);
  }, "BigNumber, BigNumber": function(e3, t22) {
    var r2, n;
    if (!isPositiveInteger(e3) || !isPositiveInteger(t22)) throw new TypeError("Positive integer value expected in function permutations");
    if (t22.gt(e3)) throw new TypeError("second argument k must be less than or equal to first argument n");
    for (r2 = e3.mul(0).add(1), n = e3.minus(t22).plus(1); n.lte(e3); n = n.plus(1)) r2 = r2.times(n);
    return r2;
  } });
}));
function isPositiveInteger(e2) {
  return e2.isInteger() && e2.gte(0);
}
var alea$1 = { exports: {} }, hasRequiredAlea;
function requireAlea() {
  return hasRequiredAlea || (hasRequiredAlea = 1, (function(e2, t2, r) {
    function n(e3) {
      var t22 = this, r2 = /* @__PURE__ */ (function() {
        var e4 = 4022871197, t3 = function(t4) {
          t4 = String(t4);
          for (var r3 = 0; r3 < t4.length; r3++) {
            var n3 = 0.02519603282416938 * (e4 += t4.charCodeAt(r3));
            n3 -= e4 = n3 >>> 0, e4 = (n3 *= e4) >>> 0, e4 += 4294967296 * (n3 -= e4);
          }
          return 23283064365386963e-26 * (e4 >>> 0);
        };
        return t3;
      })();
      t22.next = function() {
        var e4 = 2091639 * t22.s0 + 23283064365386963e-26 * t22.c;
        return t22.s0 = t22.s1, t22.s1 = t22.s2, t22.s2 = e4 - (t22.c = 0 | e4);
      }, t22.c = 1, t22.s0 = r2(" "), t22.s1 = r2(" "), t22.s2 = r2(" "), t22.s0 -= r2(e3), t22.s0 < 0 && (t22.s0 += 1), t22.s1 -= r2(e3), t22.s1 < 0 && (t22.s1 += 1), t22.s2 -= r2(e3), t22.s2 < 0 && (t22.s2 += 1), r2 = null;
    }
    function i2(e3, t22) {
      return t22.c = e3.c, t22.s0 = e3.s0, t22.s1 = e3.s1, t22.s2 = e3.s2, t22;
    }
    function a(e3, t22) {
      var r2 = new n(e3), a2 = t22 && t22.state, o = r2.next;
      return o.int32 = function() {
        return 4294967296 * r2.next() | 0;
      }, o.double = function() {
        return o() + 11102230246251565e-32 * (2097152 * o() | 0);
      }, o.quick = o, a2 && ("object" == typeof a2 && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.alea = a;
  })(0, alea$1)), alea$1.exports;
}
var xor128$1 = { exports: {} }, hasRequiredXor128;
function requireXor128() {
  return hasRequiredXor128 || (hasRequiredXor128 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t22 = this, r2 = "";
      t22.x = 0, t22.y = 0, t22.z = 0, t22.w = 0, t22.next = function() {
        var e4 = t22.x ^ t22.x << 11;
        return t22.x = t22.y, t22.y = t22.z, t22.z = t22.w, t22.w ^= t22.w >>> 19 ^ e4 ^ e4 >>> 8;
      }, e3 === (0 | e3) ? t22.x = e3 : r2 += e3;
      for (var n3 = 0; n3 < r2.length + 64; n3++) t22.x ^= 0 | r2.charCodeAt(n3), t22.next();
    }
    function i2(e3, t22) {
      return t22.x = e3.x, t22.y = e3.y, t22.z = e3.z, t22.w = e3.w, t22;
    }
    function a(e3, t22) {
      var r2 = new n(e3), a2 = t22 && t22.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && ("object" == typeof a2 && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.xor128 = a;
  })(0, xor128$1)), xor128$1.exports;
}
var xorwow$1 = { exports: {} }, hasRequiredXorwow;
function requireXorwow() {
  return hasRequiredXorwow || (hasRequiredXorwow = 1, (function(e2, t2, r) {
    function n(e3) {
      var t22 = this, r2 = "";
      t22.next = function() {
        var e4 = t22.x ^ t22.x >>> 2;
        return t22.x = t22.y, t22.y = t22.z, t22.z = t22.w, t22.w = t22.v, (t22.d = t22.d + 362437 | 0) + (t22.v = t22.v ^ t22.v << 4 ^ e4 ^ e4 << 1) | 0;
      }, t22.x = 0, t22.y = 0, t22.z = 0, t22.w = 0, t22.v = 0, e3 === (0 | e3) ? t22.x = e3 : r2 += e3;
      for (var n3 = 0; n3 < r2.length + 64; n3++) t22.x ^= 0 | r2.charCodeAt(n3), n3 == r2.length && (t22.d = t22.x << 10 ^ t22.x >>> 4), t22.next();
    }
    function i2(e3, t22) {
      return t22.x = e3.x, t22.y = e3.y, t22.z = e3.z, t22.w = e3.w, t22.v = e3.v, t22.d = e3.d, t22;
    }
    function a(e3, t22) {
      var r2 = new n(e3), a2 = t22 && t22.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && ("object" == typeof a2 && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.xorwow = a;
  })(0, xorwow$1)), xorwow$1.exports;
}
var xorshift7$1 = { exports: {} }, hasRequiredXorshift7;
function requireXorshift7() {
  return hasRequiredXorshift7 || (hasRequiredXorshift7 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t22 = this;
      t22.next = function() {
        var e4, r2, n3 = t22.x, i22 = t22.i;
        return e4 = n3[i22], r2 = (e4 ^= e4 >>> 7) ^ e4 << 24, r2 ^= (e4 = n3[i22 + 1 & 7]) ^ e4 >>> 10, r2 ^= (e4 = n3[i22 + 3 & 7]) ^ e4 >>> 3, r2 ^= (e4 = n3[i22 + 4 & 7]) ^ e4 << 7, e4 = n3[i22 + 7 & 7], r2 ^= (e4 ^= e4 << 13) ^ e4 << 9, n3[i22] = r2, t22.i = i22 + 1 & 7, r2;
      }, (function(e4, t3) {
        var r2, n3 = [];
        if (t3 === (0 | t3)) n3[0] = t3;
        else for (t3 = "" + t3, r2 = 0; r2 < t3.length; ++r2) n3[7 & r2] = n3[7 & r2] << 15 ^ t3.charCodeAt(r2) + n3[r2 + 1 & 7] << 13;
        for (; n3.length < 8; ) n3.push(0);
        for (r2 = 0; r2 < 8 && 0 === n3[r2]; ++r2) ;
        for (8 == r2 ? n3[7] = -1 : n3[r2], e4.x = n3, e4.i = 0, r2 = 256; r2 > 0; --r2) e4.next();
      })(t22, e3);
    }
    function i2(e3, t22) {
      return t22.x = e3.x.slice(), t22.i = e3.i, t22;
    }
    function a(e3, t22) {
      null == e3 && (e3 = +/* @__PURE__ */ new Date());
      var r2 = new n(e3), a2 = t22 && t22.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && (a2.x && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.xorshift7 = a;
  })(0, xorshift7$1)), xorshift7$1.exports;
}
var xor4096$1 = { exports: {} }, hasRequiredXor4096;
function requireXor4096() {
  return hasRequiredXor4096 || (hasRequiredXor4096 = 1, (function(e2, t2, r) {
    function n(e3) {
      var t22 = this;
      t22.next = function() {
        var e4, r2, n3 = t22.w, i22 = t22.X, a2 = t22.i;
        return t22.w = n3 = n3 + 1640531527 | 0, r2 = i22[a2 + 34 & 127], e4 = i22[a2 = a2 + 1 & 127], r2 ^= r2 << 13, e4 ^= e4 << 17, r2 ^= r2 >>> 15, e4 ^= e4 >>> 12, r2 = i22[a2] = r2 ^ e4, t22.i = a2, r2 + (n3 ^ n3 >>> 16) | 0;
      }, (function(e4, t3) {
        var r2, n3, i22, a2, o, s = [], u = 128;
        for (t3 === (0 | t3) ? (n3 = t3, t3 = null) : (t3 += "\0", n3 = 0, u = Math.max(u, t3.length)), i22 = 0, a2 = -32; a2 < u; ++a2) t3 && (n3 ^= t3.charCodeAt((a2 + 32) % t3.length)), 0 === a2 && (o = n3), n3 ^= n3 << 10, n3 ^= n3 >>> 15, n3 ^= n3 << 4, n3 ^= n3 >>> 13, a2 >= 0 && (o = o + 1640531527 | 0, i22 = 0 == (r2 = s[127 & a2] ^= n3 + o) ? i22 + 1 : 0);
        for (i22 >= 128 && (s[127 & (t3 && t3.length || 0)] = -1), i22 = 127, a2 = 512; a2 > 0; --a2) n3 = s[i22 + 34 & 127], r2 = s[i22 = i22 + 1 & 127], n3 ^= n3 << 13, r2 ^= r2 << 17, n3 ^= n3 >>> 15, r2 ^= r2 >>> 12, s[i22] = n3 ^ r2;
        e4.w = o, e4.X = s, e4.i = i22;
      })(t22, e3);
    }
    function i2(e3, t22) {
      return t22.i = e3.i, t22.w = e3.w, t22.X = e3.X.slice(), t22;
    }
    function a(e3, t22) {
      null == e3 && (e3 = +/* @__PURE__ */ new Date());
      var r2 = new n(e3), a2 = t22 && t22.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && (a2.X && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.xor4096 = a;
  })(0, xor4096$1)), xor4096$1.exports;
}
var tychei$1 = { exports: {} }, hasRequiredTychei;
function requireTychei() {
  return hasRequiredTychei || (hasRequiredTychei = 1, (function(e2, t2, r) {
    function n(e3) {
      var t22 = this, r2 = "";
      t22.next = function() {
        var e4 = t22.b, r3 = t22.c, n4 = t22.d, i22 = t22.a;
        return e4 = e4 << 25 ^ e4 >>> 7 ^ r3, r3 = r3 - n4 | 0, n4 = n4 << 24 ^ n4 >>> 8 ^ i22, i22 = i22 - e4 | 0, t22.b = e4 = e4 << 20 ^ e4 >>> 12 ^ r3, t22.c = r3 = r3 - n4 | 0, t22.d = n4 << 16 ^ r3 >>> 16 ^ i22, t22.a = i22 - e4 | 0;
      }, t22.a = 0, t22.b = 0, t22.c = -1640531527, t22.d = 1367130551, e3 === Math.floor(e3) ? (t22.a = e3 / 4294967296 | 0, t22.b = 0 | e3) : r2 += e3;
      for (var n3 = 0; n3 < r2.length + 20; n3++) t22.b ^= 0 | r2.charCodeAt(n3), t22.next();
    }
    function i2(e3, t22) {
      return t22.a = e3.a, t22.b = e3.b, t22.c = e3.c, t22.d = e3.d, t22;
    }
    function a(e3, t22) {
      var r2 = new n(e3), a2 = t22 && t22.state, o = function() {
        return (r2.next() >>> 0) / 4294967296;
      };
      return o.double = function() {
        do {
          var e4 = ((r2.next() >>> 11) + (r2.next() >>> 0) / 4294967296) / (1 << 21);
        } while (0 === e4);
        return e4;
      }, o.int32 = r2.next, o.quick = o, a2 && ("object" == typeof a2 && i2(a2, r2), o.state = function() {
        return i2(r2, {});
      }), o;
    }
    t2 && t2.exports ? t2.exports = a : this.tychei = a;
  })(0, tychei$1)), tychei$1.exports;
}
var seedrandom$4 = { exports: {} }, _polyfillNode_crypto = {}, _polyfillNode_crypto$1 = Object.freeze({ __proto__: null, default: _polyfillNode_crypto }), require$$0$1 = getAugmentedNamespace$1(_polyfillNode_crypto$1), seedrandom$3 = seedrandom$4.exports, hasRequiredSeedrandom$1, seedrandom$2, hasRequiredSeedrandom;
function requireSeedrandom$1() {
  return hasRequiredSeedrandom$1 || (hasRequiredSeedrandom$1 = 1, e2 = seedrandom$4, (function(t2, r, n) {
    var i2, a = 256, o = "random", s = n.pow(a, 6), u = n.pow(2, 52), c2 = 2 * u, l = 255;
    function f2(e3, l2, f3) {
      var y = [], v2 = h(d((l2 = 1 == l2 ? { entropy: true } : l2 || {}).entropy ? [e3, g(r)] : null == e3 ? (function() {
        try {
          var e4;
          return i2 && (e4 = i2.randomBytes) ? e4 = e4(a) : (e4 = new Uint8Array(a), (t2.crypto || t2.msCrypto).getRandomValues(e4)), g(e4);
        } catch (e5) {
          var n3 = t2.navigator, o2 = n3 && n3.plugins;
          return [+/* @__PURE__ */ new Date(), t2, o2, t2.screen, g(r)];
        }
      })() : e3, 3), y), x2 = new p(y), b2 = function() {
        for (var e4 = x2.g(6), t22 = s, r2 = 0; e4 < u; ) e4 = (e4 + r2) * a, t22 *= a, r2 = x2.g(1);
        for (; e4 >= c2; ) e4 /= 2, t22 /= 2, r2 >>>= 1;
        return (e4 + r2) / t22;
      };
      return b2.int32 = function() {
        return 0 | x2.g(4);
      }, b2.quick = function() {
        return x2.g(4) / 4294967296;
      }, b2.double = b2, h(g(x2.S), r), (l2.pass || f3 || function(e4, t22, r2, i22) {
        return i22 && (i22.S && m(i22, x2), e4.state = function() {
          return m(x2, {});
        }), r2 ? (n[o] = e4, t22) : e4;
      })(b2, v2, "global" in l2 ? l2.global : this == n, l2.state);
    }
    function p(e3) {
      var t22, r2 = e3.length, n3 = this, i22 = 0, o2 = n3.i = n3.j = 0, s2 = n3.S = [];
      for (r2 || (e3 = [r2++]); i22 < a; ) s2[i22] = i22++;
      for (i22 = 0; i22 < a; i22++) s2[i22] = s2[o2 = l & o2 + e3[i22 % r2] + (t22 = s2[i22])], s2[o2] = t22;
      (n3.g = function(e4) {
        for (var t3, r3 = 0, i3 = n3.i, o3 = n3.j, s3 = n3.S; e4--; ) t3 = s3[i3 = l & i3 + 1], r3 = r3 * a + s3[l & (s3[i3] = s3[o3 = l & o3 + t3]) + (s3[o3] = t3)];
        return n3.i = i3, n3.j = o3, r3;
      })(a);
    }
    function m(e3, t22) {
      return t22.i = e3.i, t22.j = e3.j, t22.S = e3.S.slice(), t22;
    }
    function d(e3, t22) {
      var r2, n3 = [], i22 = typeof e3;
      if (t22 && "object" == i22) for (r2 in e3) try {
        n3.push(d(e3[r2], t22 - 1));
      } catch (e4) {
      }
      return n3.length ? n3 : "string" == i22 ? e3 : e3 + "\0";
    }
    function h(e3, t22) {
      for (var r2, n3 = e3 + "", i22 = 0; i22 < n3.length; ) t22[l & i22] = l & (r2 ^= 19 * t22[l & i22]) + n3.charCodeAt(i22++);
      return g(t22);
    }
    function g(e3) {
      return String.fromCharCode.apply(0, e3);
    }
    if (h(n.random(), r), e2.exports) {
      e2.exports = f2;
      try {
        i2 = require$$0$1;
      } catch (e3) {
      }
    } else n["seed" + o] = f2;
  })("undefined" != typeof self ? self : seedrandom$3, [], Math)), seedrandom$4.exports;
  var e2;
}
function requireSeedrandom() {
  if (hasRequiredSeedrandom) return seedrandom$2;
  hasRequiredSeedrandom = 1;
  var e2 = requireAlea(), t2 = requireXor128(), r = requireXorwow(), n = requireXorshift7(), i2 = requireXor4096(), a = requireTychei(), o = requireSeedrandom$1();
  return o.alea = e2, o.xor128 = t2, o.xorwow = r, o.xorshift7 = n, o.xor4096 = i2, o.tychei = a, seedrandom$2 = o;
}
var seedrandomExports = requireSeedrandom(), seedrandom$1 = getDefaultExportFromCjs$2(seedrandomExports), singletonRandom = seedrandom$1(Date.now());
function createRng(e2) {
  var t2, r;
  return t2 = null === (r = e2) ? singletonRandom : seedrandom$1(String(r)), function() {
    return t2();
  };
}
var name$J = "pickRandom", dependencies$J = ["typed", "config", "?on"], createPickRandom = factory(name$J, dependencies$J, ((e2) => {
  var { typed: t2, config: r, on: n } = e2, i2 = createRng(r.randomSeed);
  return n && n("config", (function(e3, t22) {
    e3.randomSeed !== t22.randomSeed && (i2 = createRng(e3.randomSeed));
  })), t2(name$J, { "Array | Matrix": function(e3) {
    return a(e3, {});
  }, "Array | Matrix, Object": function(e3, t22) {
    return a(e3, t22);
  }, "Array | Matrix, number": function(e3, t22) {
    return a(e3, { number: t22 });
  }, "Array | Matrix, Array | Matrix": function(e3, t22) {
    return a(e3, { weights: t22 });
  }, "Array | Matrix, Array | Matrix, number": function(e3, t22, r2) {
    return a(e3, { number: r2, weights: t22 });
  }, "Array | Matrix, number, Array | Matrix": function(e3, t22, r2) {
    return a(e3, { number: t22, weights: r2 });
  } });
  function a(e3, t22) {
    var { number: r2, weights: n3, elementWise: a2 = true } = t22, o = void 0 === r2;
    o && (r2 = 1);
    var s = isMatrix(e3) ? e3.create : isMatrix(n3) ? n3.create : null;
    e3 = e3.valueOf(), n3 && (n3 = n3.valueOf()), true === a2 && (e3 = flatten$4(e3), n3 = flatten$4(n3));
    var u = 0;
    if (void 0 !== n3) {
      if (n3.length !== e3.length) throw new Error("Weights must have the same length as possibles");
      for (var c2 = 0, l = n3.length; c2 < l; c2++) {
        if (!isNumber$1(n3[c2]) || n3[c2] < 0) throw new Error("Weights must be an array of positive numbers");
        u += n3[c2];
      }
    }
    for (var f2, p = e3.length, m = []; m.length < r2; ) {
      if (void 0 === n3) f2 = e3[Math.floor(i2() * p)];
      else for (var d = i2() * u, h = 0, g = e3.length; h < g; h++) if ((d -= n3[h]) < 0) {
        f2 = e3[h];
        break;
      }
      m.push(f2);
    }
    return o ? m[0] : s ? s(m) : m;
  }
}));
function randomMatrix(e2, t2) {
  var r = [];
  if ((e2 = e2.slice(0)).length > 1) for (var n = 0, i2 = e2.shift(); n < i2; n++) r.push(randomMatrix(e2, t2));
  else for (var a = 0, o = e2.shift(); a < o; a++) r.push(t2());
  return r;
}
var name$I = "random", dependencies$I = ["typed", "config", "?on"], createRandom = factory(name$I, dependencies$I, ((e2) => {
  var { typed: t2, config: r, on: n } = e2, i2 = createRng(r.randomSeed);
  return n && n("config", (function(e3, t22) {
    e3.randomSeed !== t22.randomSeed && (i2 = createRng(e3.randomSeed));
  })), t2(name$I, { "": () => o(0, 1), number: (e3) => o(0, e3), "number, number": (e3, t22) => o(e3, t22), "Array | Matrix": (e3) => a(e3, 0, 1), "Array | Matrix, number": (e3, t22) => a(e3, 0, t22), "Array | Matrix, number, number": (e3, t22, r2) => a(e3, t22, r2) });
  function a(e3, t22, r2) {
    var n3 = randomMatrix(e3.valueOf(), (() => o(t22, r2)));
    return isMatrix(e3) ? e3.create(n3, "number") : n3;
  }
  function o(e3, t22) {
    return e3 + i2() * (t22 - e3);
  }
})), name$H = "randomInt", dependencies$H = ["typed", "config", "log2", "?on"], createRandomInt = factory(name$H, dependencies$H, ((e2) => {
  var { typed: t2, config: r, log2: n, on: i2 } = e2, a = createRng(r.randomSeed);
  return i2 && i2("config", (function(e3, t22) {
    e3.randomSeed !== t22.randomSeed && (a = createRng(e3.randomSeed));
  })), t2(name$H, { "": () => s(0, 2), number: (e3) => s(0, e3), "number, number": (e3, t22) => s(e3, t22), bigint: (e3) => u(0n, e3), "bigint, bigint": u, "Array | Matrix": (e3) => o(e3, 0, 1), "Array | Matrix, number": (e3, t22) => o(e3, 0, t22), "Array | Matrix, number, number": (e3, t22, r2) => o(e3, t22, r2) });
  function o(e3, t22, r2) {
    var n3 = randomMatrix(e3.valueOf(), (() => s(t22, r2)));
    return isMatrix(e3) ? e3.create(n3, "number") : n3;
  }
  function s(e3, t22) {
    return Math.floor(e3 + a() * (t22 - e3));
  }
  function u(e3, t22) {
    var r2 = t22 - e3;
    if (r2 <= 2n ** 30n) return e3 + BigInt(s(0, Number(r2)));
    for (var i22 = n(r2), o2 = r2; o2 >= r2; ) {
      o2 = 0n;
      for (var u2 = 0; u2 < i22; ++u2) o2 = 2n * o2 + (a() < 0.5 ? 0n : 1n);
    }
    return e3 + o2;
  }
})), name$G = "stirlingS2", dependencies$G = ["typed", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "factorial", "combinations", "isNegative", "isInteger", "number", "?bignumber", "larger"], createStirlingS2 = factory(name$G, dependencies$G, ((e2) => {
  var { typed: t2, addScalar: r, subtractScalar: n, multiplyScalar: i2, divideScalar: a, pow: o, factorial: s, combinations: u, isNegative: c2, isInteger: l, number: f2, bignumber: p, larger: m } = e2, d = [], h = [];
  return t2(name$G, { "number | BigNumber, number | BigNumber": function(e3, t22) {
    if (!l(e3) || c2(e3) || !l(t22) || c2(t22)) throw new TypeError("Non-negative integer value expected in function stirlingS2");
    if (m(t22, e3)) throw new TypeError("k must be less than or equal to n in function stirlingS2");
    var n3 = !(isNumber$1(e3) && isNumber$1(t22)), a2 = n3 ? h : d, o2 = n3 ? p : f2, s2 = f2(e3), u2 = f2(t22);
    if (a2[s2] && a2[s2].length > u2) return a2[s2][u2];
    for (var g = 0; g <= s2; ++g) if (a2[g] || (a2[g] = [o2(0 === g ? 1 : 0)]), 0 !== g) for (var y = a2[g], v2 = a2[g - 1], x2 = y.length; x2 <= g && x2 <= u2; ++x2) y[x2] = x2 === g ? 1 : r(i2(o2(x2), v2[x2]), v2[x2 - 1]);
    return a2[s2][u2];
  } });
})), name$F = "bellNumbers", dependencies$F = ["typed", "addScalar", "isNegative", "isInteger", "stirlingS2"], createBellNumbers = factory(name$F, dependencies$F, ((e2) => {
  var { typed: t2, addScalar: r, isNegative: n, isInteger: i2, stirlingS2: a } = e2;
  return t2(name$F, { "number | BigNumber": function(e3) {
    if (!i2(e3) || n(e3)) throw new TypeError("Non-negative integer value expected in function bellNumbers");
    for (var t22 = 0, o = 0; o <= e3; o++) t22 = r(t22, a(e3, o));
    return t22;
  } });
})), name$E = "catalan", dependencies$E = ["typed", "addScalar", "divideScalar", "multiplyScalar", "combinations", "isNegative", "isInteger"], createCatalan = factory(name$E, dependencies$E, ((e2) => {
  var { typed: t2, addScalar: r, divideScalar: n, multiplyScalar: i2, combinations: a, isNegative: o, isInteger: s } = e2;
  return t2(name$E, { "number | BigNumber": function(e3) {
    if (!s(e3) || o(e3)) throw new TypeError("Non-negative integer value expected in function catalan");
    return n(a(i2(e3, 2), e3), r(e3, 1));
  } });
})), name$D = "composition", dependencies$D = ["typed", "addScalar", "combinations", "isNegative", "isPositive", "isInteger", "larger"], createComposition = factory(name$D, dependencies$D, ((e2) => {
  var { typed: t2, addScalar: r, combinations: n, isPositive: i2, isNegative: a, isInteger: o, larger: s } = e2;
  return t2(name$D, { "number | BigNumber, number | BigNumber": function(e3, t22) {
    if (!(o(e3) && i2(e3) && o(t22) && i2(t22))) throw new TypeError("Positive integer value expected in function composition");
    if (s(t22, e3)) throw new TypeError("k must be less than or equal to n in function composition");
    return n(r(e3, -1), r(t22, -1));
  } });
})), name$C = "leafCount", dependencies$C = ["parse", "typed"], createLeafCount = factory(name$C, dependencies$C, ((e2) => {
  var { parse: t2, typed: r } = e2;
  function n(e3) {
    var t22 = 0;
    return e3.forEach(((e4) => {
      t22 += n(e4);
    })), t22 || 1;
  }
  return r(name$C, { Node: function(e3) {
    return n(e3);
  } });
}));
function isNumericNode(e2) {
  return isConstantNode(e2) || isOperatorNode(e2) && e2.isUnary() && isConstantNode(e2.args[0]);
}
function isConstantExpression(e2) {
  return !!isConstantNode(e2) || (!(!isFunctionNode(e2) && !isOperatorNode(e2) || !e2.args.every(isConstantExpression)) || !(!isParenthesisNode(e2) || !isConstantExpression(e2.content)));
}
function ownKeys$1(e2, t2) {
  var r = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e2);
    t2 && (n = n.filter((function(t22) {
      return Object.getOwnPropertyDescriptor(e2, t22).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread$1(e2) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? ownKeys$1(Object(r), true).forEach((function(t22) {
      _defineProperty$1(e2, t22, r[t22]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r)) : ownKeys$1(Object(r)).forEach((function(t22) {
      Object.defineProperty(e2, t22, Object.getOwnPropertyDescriptor(r, t22));
    }));
  }
  return e2;
}
var name$B = "simplifyUtil", dependencies$B = ["FunctionNode", "OperatorNode", "SymbolNode"], createUtil = factory(name$B, dependencies$B, ((e2) => {
  var { FunctionNode: t2, OperatorNode: r, SymbolNode: n } = e2, i2 = true, a = false, o = "defaultF", s = { add: { trivial: i2, total: i2, commutative: i2, associative: i2 }, unaryPlus: { trivial: i2, total: i2, commutative: i2, associative: i2 }, subtract: { trivial: a, total: i2, commutative: a, associative: a }, multiply: { trivial: i2, total: i2, commutative: i2, associative: i2 }, divide: { trivial: a, total: i2, commutative: a, associative: a }, paren: { trivial: i2, total: i2, commutative: i2, associative: a }, defaultF: { trivial: a, total: i2, commutative: a, associative: a } };
  function u(e3, t22) {
    var r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s, n3 = o;
    if ("string" == typeof e3 ? n3 = e3 : isOperatorNode(e3) ? n3 = e3.fn.toString() : isFunctionNode(e3) ? n3 = e3.name : isParenthesisNode(e3) && (n3 = "paren"), hasOwnProperty$1$1(r2, n3)) {
      var i22 = r2[n3];
      if (hasOwnProperty$1$1(i22, t22)) return i22[t22];
      if (hasOwnProperty$1$1(s, n3)) return s[n3][t22];
    }
    if (hasOwnProperty$1$1(r2, o)) {
      var a2 = r2[o];
      return hasOwnProperty$1$1(a2, t22) ? a2[t22] : s[o][t22];
    }
    if (hasOwnProperty$1$1(s, n3)) {
      var u2 = s[n3];
      if (hasOwnProperty$1$1(u2, t22)) return u2[t22];
    }
    return s[o][t22];
  }
  function c2(e3) {
    return u(e3, "associative", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s);
  }
  function l(e3, t22) {
    var r2, n3 = [], i22 = function(e4) {
      for (var t3 = 0; t3 < e4.args.length; t3++) {
        var a2 = e4.args[t3];
        isOperatorNode(a2) && r2 === a2.op ? i22(a2) : n3.push(a2);
      }
    };
    return c2(e3, t22) ? (r2 = e3.op, i22(e3), n3) : e3.args;
  }
  function f2(e3) {
    return isOperatorNode(e3) ? function(t22) {
      try {
        return new r(e3.op, e3.fn, t22, e3.implicit);
      } catch (e4) {
        return console.error(e4), [];
      }
    } : function(r2) {
      return new t2(new n(e3.name), r2);
    };
  }
  return { createMakeNodeFunction: f2, hasProperty: u, isCommutative: function(e3) {
    return u(e3, "commutative", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s);
  }, isAssociative: c2, mergeContext: function(e3, t22) {
    var r2 = _objectSpread$1({}, e3);
    for (var n3 in t22) hasOwnProperty$1$1(e3, n3) ? r2[n3] = _objectSpread$1(_objectSpread$1({}, t22[n3]), e3[n3]) : r2[n3] = t22[n3];
    return r2;
  }, flatten: function e3(t22, r2) {
    if (!t22.args || 0 === t22.args.length) return t22;
    t22.args = l(t22, r2);
    for (var n3 = 0; n3 < t22.args.length; n3++) e3(t22.args[n3], r2);
  }, allChildren: l, unflattenr: function e3(t22, r2) {
    if (t22.args && 0 !== t22.args.length) {
      for (var n3 = f2(t22), i22 = t22.args.length, a2 = 0; a2 < i22; a2++) e3(t22.args[a2], r2);
      if (i22 > 2 && c2(t22, r2)) {
        for (var o2 = t22.args.pop(); t22.args.length > 0; ) o2 = n3([t22.args.pop(), o2]);
        t22.args = o2.args;
      }
    }
  }, unflattenl: function e3(t22, r2) {
    if (t22.args && 0 !== t22.args.length) {
      for (var n3 = f2(t22), i22 = t22.args.length, a2 = 0; a2 < i22; a2++) e3(t22.args[a2], r2);
      if (i22 > 2 && c2(t22, r2)) {
        for (var o2 = t22.args.shift(); t22.args.length > 0; ) o2 = n3([o2, t22.args.shift()]);
        t22.args = o2.args;
      }
    }
  }, defaultContext: s, realContext: { divide: { total: a }, log: { total: a } }, positiveContext: { subtract: { total: a }, abs: { trivial: i2 }, log: { total: i2 } } };
})), name$A = "simplify", dependencies$A = ["typed", "parse", "equal", "resolve", "simplifyConstant", "simplifyCore", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode", "replacer"], createSimplify = factory(name$A, dependencies$A, ((e2) => {
  var { typed: t2, parse: r, equal: n, resolve: i2, simplifyConstant: a, simplifyCore: o, AccessorNode: s, ArrayNode: u, ConstantNode: c2, FunctionNode: l, IndexNode: f2, ObjectNode: p, OperatorNode: m, ParenthesisNode: d, SymbolNode: h, replacer: g } = e2, { hasProperty: y, isCommutative: v2, isAssociative: x2, mergeContext: b2, flatten: _2, unflattenr: w2, unflattenl: A2, createMakeNodeFunction: N, defaultContext: D, realContext: E, positiveContext: $2 } = createUtil({ FunctionNode: l, OperatorNode: m, SymbolNode: h });
  t2.addConversion({ from: "Object", to: "Map", convert: createMap$1 });
  var S2 = t2("simplify", { Node: k2, "Node, Map": (e3, t22) => k2(e3, false, t22), "Node, Map, Object": (e3, t22, r2) => k2(e3, false, t22, r2), "Node, Array": k2, "Node, Array, Map": k2, "Node, Array, Map, Object": k2 });
  function C2(e3) {
    return e3.transform((function(e4) {
      return isParenthesisNode(e4) ? C2(e4.content) : e4;
    }));
  }
  t2.removeConversion({ from: "Object", to: "Map", convert: createMap$1 }), S2.defaultContext = D, S2.realContext = E, S2.positiveContext = $2;
  var M2 = { true: true, false: true, e: true, i: true, Infinity: true, LN2: true, LN10: true, LOG2E: true, LOG10E: true, NaN: true, phi: true, pi: true, SQRT1_2: true, SQRT2: true, tau: true };
  function T2(e3, t22) {
    var n3 = {};
    if (e3.s) {
      var i22 = e3.s.split("->");
      if (2 !== i22.length) throw SyntaxError("Could not parse rule: " + e3.s);
      n3.l = i22[0], n3.r = i22[1];
    } else n3.l = e3.l, n3.r = e3.r;
    for (var a2 of (n3.l = C2(r(n3.l)), n3.r = C2(r(n3.r)), ["imposeContext", "repeat", "assuming"])) a2 in e3 && (n3[a2] = e3[a2]);
    if (e3.evaluate && (n3.evaluate = r(e3.evaluate)), x2(n3.l, t22)) {
      var o2, s2 = !v2(n3.l, t22);
      s2 && (o2 = O2());
      var u2 = N(n3.l), c3 = O2();
      n3.expanded = {}, n3.expanded.l = u2([n3.l, c3]), _2(n3.expanded.l, t22), w2(n3.expanded.l, t22), n3.expanded.r = u2([n3.r, c3]), s2 && (n3.expandedNC1 = {}, n3.expandedNC1.l = u2([o2, n3.l]), n3.expandedNC1.r = u2([o2, n3.r]), n3.expandedNC2 = {}, n3.expandedNC2.l = u2([o2, n3.expanded.l]), n3.expandedNC2.r = u2([o2, n3.expanded.r]));
    }
    return n3;
  }
  S2.rules = [o, { l: "log(e)", r: "1" }, { s: "n-n1 -> n+-n1", assuming: { subtract: { total: true } } }, { s: "n-n -> 0", assuming: { subtract: { total: false } } }, { s: "-(cl*v) -> v * (-cl)", assuming: { multiply: { commutative: true }, subtract: { total: true } } }, { s: "-(cl*v) -> (-cl) * v", assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { s: "-(v*cl) -> v * (-cl)", assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { l: "-(n1/n2)", r: "-n1/n2" }, { l: "-v", r: "v * (-1)" }, { l: "(n1 + n2)*(-1)", r: "n1*(-1) + n2*(-1)", repeat: true }, { l: "n/n1^n2", r: "n*n1^-n2" }, { l: "n/n1", r: "n*n1^-1" }, { s: "(n1*n2)^n3 -> n1^n3 * n2^n3", assuming: { multiply: { commutative: true } } }, { s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)", assuming: { multiply: { commutative: false } } }, { s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)", assuming: { divide: { total: true } } }, { l: " vd   * ( vd   * n1 + n2)", r: "vd^2       * n1 +  vd   * n2" }, { s: " vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2", assuming: { divide: { total: true } } }, { s: "vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2", assuming: { divide: { total: true } } }, { s: "vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2", assuming: { divide: { total: true } } }, { l: "n*n", r: "n^2" }, { s: "n * n^n1 -> n^(n1+1)", assuming: { divide: { total: true } } }, { s: "n^n1 * n^n2 -> n^(n1+n2)", assuming: { divide: { total: true } } }, a, { s: "n+n -> 2*n", assuming: { add: { total: true } } }, { l: "n+-n", r: "0" }, { l: "vd*n + vd", r: "vd*(n+1)" }, { l: "n3*n1 + n3*n2", r: "n3*(n1+n2)" }, { l: "n3^(-n4)*n1 +   n3  * n2", r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)" }, { l: "n3^(-n4)*n1 + n3^n5 * n2", r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)" }, { s: "n*vd + vd -> (n+1)*vd", assuming: { multiply: { commutative: false } } }, { s: "vd + n*vd -> (1+n)*vd", assuming: { multiply: { commutative: false } } }, { s: "n1*n3 + n2*n3 -> (n1+n2)*n3", assuming: { multiply: { commutative: false } } }, { s: "n^n1 * n -> n^(n1+1)", assuming: { divide: { total: true }, multiply: { commutative: false } } }, { s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)", assuming: { multiply: { commutative: false } } }, { s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)", assuming: { multiply: { commutative: false } } }, { l: "n*cd + cd", r: "(n+1)*cd" }, { s: "cd*n + cd -> cd*(n+1)", assuming: { multiply: { commutative: false } } }, { s: "cd + cd*n -> cd*(1+n)", assuming: { multiply: { commutative: false } } }, a, { s: "(-n)*n1 -> -(n*n1)", assuming: { subtract: { total: true } } }, { s: "n1*(-n) -> -(n1*n)", assuming: { subtract: { total: true }, multiply: { commutative: false } } }, { s: "ce+ve -> ve+ce", assuming: { add: { commutative: true } }, imposeContext: { add: { commutative: false } } }, { s: "vd*cd -> cd*vd", assuming: { multiply: { commutative: true } }, imposeContext: { multiply: { commutative: false } } }, { l: "n+-n1", r: "n-n1" }, { l: "n+-(n1)", r: "n-(n1)" }, { s: "n*(n1^-1) -> n/n1", assuming: { multiply: { commutative: true } } }, { s: "n*n1^-n2 -> n/n1^n2", assuming: { multiply: { commutative: true } } }, { s: "n^-1 -> 1/n", assuming: { multiply: { commutative: true } } }, { l: "n^1", r: "n" }, { s: "n*(n1/n2) -> (n*n1)/n2", assuming: { multiply: { associative: true } } }, { s: "n-(n1+n2) -> n-n1-n2", assuming: { addition: { associative: true, commutative: true } } }, { l: "1*n", r: "n", imposeContext: { multiply: { commutative: true } } }, { s: "n1/(n2/n3) -> (n1*n3)/n2", assuming: { multiply: { associative: true } } }, { l: "n1/(-n2)", r: "-n1/n2" }];
  var F = 0;
  function O2() {
    return new h("_p" + F++);
  }
  function k2(e3, t22) {
    var r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : createEmptyMap(), n3 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, a2 = n3.consoleDebug;
    t22 = (function(e4, t3) {
      for (var r3 = [], n4 = 0; n4 < e4.length; n4++) {
        var i22 = e4[n4], a3 = void 0, o3 = typeof i22;
        switch (o3) {
          case "string":
            i22 = { s: i22 };
          case "object":
            a3 = T2(i22, t3);
            break;
          case "function":
            a3 = i22;
            break;
          default:
            throw TypeError("Unsupported type of rule: " + o3);
        }
        r3.push(a3);
      }
      return r3;
    })(t22 || S2.rules, n3.context);
    for (var o2 = i2(e3, r2), s2 = {}, u2 = (o2 = C2(o2)).toString({ parenthesis: "all" }); !s2[u2]; ) {
      s2[u2] = true, F = 0;
      var c3 = u2;
      a2 && console.log("Working on: ", u2);
      for (var l2 = 0; l2 < t22.length; l2++) {
        var f3 = "";
        if ("function" == typeof t22[l2] ? (o2 = t22[l2](o2, n3), a2 && (f3 = t22[l2].name)) : (_2(o2, n3.context), o2 = I2(o2, t22[l2], n3.context), a2 && (f3 = "".concat(t22[l2].l.toString(), " -> ").concat(t22[l2].r.toString()))), a2) {
          var p2 = o2.toString({ parenthesis: "all" });
          p2 !== c3 && (console.log("Applying", f3, "produced", p2), c3 = p2);
        }
        A2(o2, n3.context);
      }
      u2 = o2.toString({ parenthesis: "all" });
    }
    return o2;
  }
  function B2(e3, t22, r2) {
    var n3 = e3;
    if (e3) for (var i22 = 0; i22 < e3.length; ++i22) {
      var a2 = I2(e3[i22], t22, r2);
      a2 !== e3[i22] && (n3 === e3 && (n3 = e3.slice()), n3[i22] = a2);
    }
    return n3;
  }
  function I2(e3, t22, r2) {
    if (t22.assuming) {
      for (var n3 in t22.assuming) for (var i22 in t22.assuming[n3]) if (y(n3, i22, r2) !== t22.assuming[n3][i22]) return e3;
    }
    var a2 = b2(t22.imposeContext, r2), o2 = e3;
    if (o2 instanceof m || o2 instanceof l) {
      var c3 = B2(o2.args, t22, r2);
      c3 !== o2.args && ((o2 = o2.clone()).args = c3);
    } else if (o2 instanceof d) {
      if (o2.content) {
        var h2 = I2(o2.content, t22, r2);
        h2 !== o2.content && (o2 = new d(h2));
      }
    } else if (o2 instanceof u) {
      var g2 = B2(o2.items, t22, r2);
      g2 !== o2.items && (o2 = new u(g2));
    } else if (o2 instanceof s) {
      var v22 = o2.object;
      o2.object && (v22 = I2(o2.object, t22, r2));
      var x22 = o2.index;
      o2.index && (x22 = I2(o2.index, t22, r2)), v22 === o2.object && x22 === o2.index || (o2 = new s(v22, x22));
    } else if (o2 instanceof f2) {
      var _3 = B2(o2.dimensions, t22, r2);
      _3 !== o2.dimensions && (o2 = new f2(_3));
    } else if (o2 instanceof p) {
      var w22 = false, A3 = {};
      for (var N2 in o2.properties) A3[N2] = I2(o2.properties[N2], t22, r2), A3[N2] !== o2.properties[N2] && (w22 = true);
      w22 && (o2 = new p(A3));
    }
    var D2 = t22.r, E2 = z2(t22.l, o2, a2)[0];
    if (!E2 && t22.expanded && (D2 = t22.expanded.r, E2 = z2(t22.expanded.l, o2, a2)[0]), !E2 && t22.expandedNC1 && (D2 = t22.expandedNC1.r, (E2 = z2(t22.expandedNC1.l, o2, a2)[0]) || (D2 = t22.expandedNC2.r, E2 = z2(t22.expandedNC2.l, o2, a2)[0])), E2) {
      var $22 = o2.implicit;
      o2 = D2.clone(), $22 && "implicit" in D2 && (o2.implicit = true), o2 = o2.transform((function(e4) {
        return e4.isSymbolNode && hasOwnProperty$1$1(E2.placeholders, e4.name) ? E2.placeholders[e4.name].clone() : e4;
      }));
    }
    return t22.repeat && o2 !== e3 && (o2 = I2(o2, t22, r2)), o2;
  }
  function R2(e3, t22) {
    var r2 = { placeholders: {} };
    if (!e3.placeholders && !t22.placeholders) return r2;
    if (!e3.placeholders) return t22;
    if (!t22.placeholders) return e3;
    for (var n3 in e3.placeholders) if (hasOwnProperty$1$1(e3.placeholders, n3) && (r2.placeholders[n3] = e3.placeholders[n3], hasOwnProperty$1$1(t22.placeholders, n3) && !P2(e3.placeholders[n3], t22.placeholders[n3]))) return null;
    for (var i22 in t22.placeholders) hasOwnProperty$1$1(t22.placeholders, i22) && (r2.placeholders[i22] = t22.placeholders[i22]);
    return r2;
  }
  function q2(e3, t22) {
    var r2, n3 = [];
    if (0 === e3.length || 0 === t22.length) return n3;
    for (var i22 = 0; i22 < e3.length; i22++) for (var a2 = 0; a2 < t22.length; a2++) (r2 = R2(e3[i22], t22[a2])) && n3.push(r2);
    return n3;
  }
  function z2(e3, t22, r2, i22) {
    var a2 = [{ placeholders: {} }];
    if (e3 instanceof m && t22 instanceof m || e3 instanceof l && t22 instanceof l) {
      if (e3 instanceof m) {
        if (e3.op !== t22.op || e3.fn !== t22.fn) return [];
      } else if (e3 instanceof l && e3.name !== t22.name) return [];
      if (!(1 === t22.args.length && 1 === e3.args.length || !x2(t22, r2) && t22.args.length === e3.args.length || i22)) {
        if (t22.args.length >= 2 && 2 === e3.args.length) {
          for (var o2 = (function(e4, t3) {
            var r3, n3, i3 = [], a3 = N(e4);
            if (v2(e4, t3)) for (var o3 = 0; o3 < e4.args.length; o3++) (n3 = e4.args.slice(0)).splice(o3, 1), r3 = 1 === n3.length ? n3[0] : a3(n3), i3.push(a3([e4.args[o3], r3]));
            else for (var s3 = 1; s3 < e4.args.length; s3++) {
              var u3 = e4.args[0];
              s3 > 1 && (u3 = a3(e4.args.slice(0, s3))), r3 = 1 === (n3 = e4.args.slice(s3)).length ? n3[0] : a3(n3), i3.push(a3([u3, r3]));
            }
            return i3;
          })(t22, r2), s2 = [], u2 = 0; u2 < o2.length; u2++) {
            var f3 = z2(e3, o2[u2], r2, true);
            s2 = s2.concat(f3);
          }
          return s2;
        }
        if (e3.args.length > 2) throw Error("Unexpected non-binary associative function: " + e3.toString());
        return [];
      }
      for (var p2 = [], d2 = 0; d2 < e3.args.length; d2++) {
        var y2 = z2(e3.args[d2], t22.args[d2], r2);
        if (0 === y2.length) break;
        p2.push(y2);
      }
      if (p2.length !== e3.args.length) {
        if (!v2(t22, r2) || 1 === e3.args.length) return [];
        if (e3.args.length > 2) throw new Error("permuting >2 commutative non-associative rule arguments not yet implemented");
        var b22 = z2(e3.args[0], t22.args[1], r2);
        if (0 === b22.length) return [];
        var _3 = z2(e3.args[1], t22.args[0], r2);
        if (0 === _3.length) return [];
        p2 = [b22, _3];
      }
      a2 = (function(e4) {
        if (0 === e4.length) return e4;
        for (var t3 = e4.reduce(q2), r3 = [], n3 = {}, i3 = 0; i3 < t3.length; i3++) {
          var a3 = JSON.stringify(t3[i3], g);
          n3[a3] || (n3[a3] = true, r3.push(t3[i3]));
        }
        return r3;
      })(p2);
    } else if (e3 instanceof h) {
      if (0 === e3.name.length) throw new Error("Symbol in rule has 0 length...!?");
      if (M2[e3.name]) {
        if (e3.name !== t22.name) return [];
      } else switch (e3.name[1] >= "a" && e3.name[1] <= "z" ? e3.name.substring(0, 2) : e3.name[0]) {
        case "n":
        case "_p":
          a2[0].placeholders[e3.name] = t22;
          break;
        case "c":
        case "cl":
          if (!isConstantNode(t22)) return [];
          a2[0].placeholders[e3.name] = t22;
          break;
        case "v":
          if (isConstantNode(t22)) return [];
          a2[0].placeholders[e3.name] = t22;
          break;
        case "vl":
          if (!isSymbolNode(t22)) return [];
          a2[0].placeholders[e3.name] = t22;
          break;
        case "cd":
          if (!isNumericNode(t22)) return [];
          a2[0].placeholders[e3.name] = t22;
          break;
        case "vd":
          if (isNumericNode(t22)) return [];
          a2[0].placeholders[e3.name] = t22;
          break;
        case "ce":
          if (!isConstantExpression(t22)) return [];
          a2[0].placeholders[e3.name] = t22;
          break;
        case "ve":
          if (isConstantExpression(t22)) return [];
          a2[0].placeholders[e3.name] = t22;
          break;
        default:
          throw new Error("Invalid symbol in rule: " + e3.name);
      }
    } else {
      if (!(e3 instanceof c2)) return [];
      if (!n(e3.value, t22.value)) return [];
    }
    return a2;
  }
  function P2(e3, t22) {
    if (e3 instanceof c2 && t22 instanceof c2) {
      if (!n(e3.value, t22.value)) return false;
    } else if (e3 instanceof h && t22 instanceof h) {
      if (e3.name !== t22.name) return false;
    } else {
      if (!(e3 instanceof m && t22 instanceof m || e3 instanceof l && t22 instanceof l)) return false;
      if (e3 instanceof m) {
        if (e3.op !== t22.op || e3.fn !== t22.fn) return false;
      } else if (e3 instanceof l && e3.name !== t22.name) return false;
      if (e3.args.length !== t22.args.length) return false;
      for (var r2 = 0; r2 < e3.args.length; r2++) if (!P2(e3.args[r2], t22.args[r2])) return false;
    }
    return true;
  }
  return S2;
})), name$z = "simplifyConstant", dependencies$z = ["typed", "config", "mathWithTransform", "matrix", "isBounded", "?fraction", "?bignumber", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode"], createSimplifyConstant = factory(name$z, dependencies$z, ((e2) => {
  var { typed: t2, config: r, mathWithTransform: n, matrix: i2, isBounded: a, fraction: o, bignumber: s, AccessorNode: u, ArrayNode: c2, ConstantNode: l, FunctionNode: f2, IndexNode: p, ObjectNode: m, OperatorNode: d, SymbolNode: h } = e2, { isCommutative: g, isAssociative: y, allChildren: v2, createMakeNodeFunction: x2 } = createUtil({ FunctionNode: f2, OperatorNode: d, SymbolNode: h }), b2 = t2("simplifyConstant", { Node: (e3) => N(C2(e3, {})), "Node, Object": function(e3, t22) {
    return N(C2(e3, t22));
  } });
  function _2(e3) {
    return isFraction(e3) ? e3.valueOf() : e3 instanceof Array ? e3.map(_2) : isMatrix(e3) ? i2(_2(e3.valueOf())) : e3;
  }
  function w2(e3, t22, r2) {
    try {
      return n[e3].apply(null, t22);
    } catch (i22) {
      return t22 = t22.map(_2), E(n[e3].apply(null, t22), r2);
    }
  }
  var A2 = t2({ Fraction: function(e3) {
    var t22 = (e4) => "BigNumber" === r.number && s ? s(e4) : Number(e4), n3 = e3.s * e3.n, i22 = n3 < 0n ? new d("-", "unaryMinus", [new l(-t22(n3))]) : new l(t22(n3));
    return 1n === e3.d ? i22 : new d("/", "divide", [i22, new l(t22(e3.d))]);
  }, number: function(e3) {
    return e3 < 0 ? $2(new l(-e3)) : new l(e3);
  }, BigNumber: function(e3) {
    return e3 < 0 ? $2(new l(-e3)) : new l(e3);
  }, bigint: function(e3) {
    return e3 < 0n ? $2(new l(-e3)) : new l(e3);
  }, Complex: function(e3) {
    throw new Error("Cannot convert Complex number to Node");
  }, string: function(e3) {
    return new l(e3);
  }, Matrix: function(e3) {
    return new c2(e3.valueOf().map(((e4) => A2(e4))));
  } });
  function N(e3) {
    return isNode$1(e3) ? e3 : A2(e3);
  }
  function D(e3, t22) {
    if (t22 && false !== t22.exactFractions && a(e3) && o) {
      var r2 = o(e3), n3 = t22 && "number" == typeof t22.fractionsLimit ? t22.fractionsLimit : 1 / 0;
      if (r2.valueOf() === e3 && r2.n < n3 && r2.d < n3) return r2;
    }
    return e3;
  }
  var E = t2({ "string, Object": function(e3, t22) {
    var n3 = safeNumberType(e3, r);
    return "BigNumber" === n3 ? (void 0 === s && noBignumber(), s(e3)) : "bigint" === n3 ? BigInt(e3) : "Fraction" === n3 ? (void 0 === o && noFraction(), o(e3)) : D(parseFloat(e3), t22);
  }, "Fraction, Object": function(e3, t22) {
    return e3;
  }, "BigNumber, Object": function(e3, t22) {
    return e3;
  }, "number, Object": function(e3, t22) {
    return D(e3, t22);
  }, "bigint, Object": function(e3, t22) {
    return e3;
  }, "Complex, Object": function(e3, t22) {
    return 0 !== e3.im ? e3 : D(e3.re, t22);
  }, "Matrix, Object": function(e3, t22) {
    return i2(D(e3.valueOf()));
  }, "Array, Object": function(e3, t22) {
    return e3.map(D);
  } });
  function $2(e3) {
    return new d("-", "unaryMinus", [e3]);
  }
  function S2(e3, t22, r2, n3) {
    var i22 = t22.shift(), a2 = t22.reduce(((t3, i3) => {
      if (!isNode$1(i3)) {
        var a3 = t3.pop();
        if (isNode$1(a3)) return [a3, i3];
        try {
          return t3.push(w2(e3, [a3, i3], n3)), t3;
        } catch (e4) {
          t3.push(a3);
        }
      }
      t3.push(N(t3.pop()));
      var o2 = 1 === t3.length ? t3[0] : r2(t3);
      return [r2([o2, N(i3)])];
    }), [i22]);
    return 1 === a2.length ? a2[0] : r2([a2[0], A2(a2[1])]);
  }
  function C2(e3, t22) {
    switch (e3.type) {
      case "SymbolNode":
        return e3;
      case "ConstantNode":
        switch (typeof e3.value) {
          case "number":
          case "bigint":
            return E(e3.value, t22);
          case "string":
            return e3.value;
          default:
            if (!isNaN(e3.value)) return E(e3.value, t22);
        }
        return e3;
      case "FunctionNode":
        if (n[e3.name] && n[e3.name].rawArgs) return e3;
        if (!["add", "multiply"].includes(e3.name)) {
          var r2 = e3.args.map(((e4) => C2(e4, t22)));
          if (!r2.some(isNode$1)) try {
            return w2(e3.name, r2, t22);
          } catch (e4) {
          }
          if ("size" === e3.name && 1 === r2.length && isArrayNode(r2[0])) {
            for (var a2 = [], o2 = r2[0]; isArrayNode(o2); ) a2.push(o2.items.length), o2 = o2.items[0];
            return i2(a2);
          }
          return new f2(e3.name, r2.map(N));
        }
      case "OperatorNode":
        var s2, d2, h2 = e3.fn.toString(), _3 = x2(e3);
        if (isOperatorNode(e3) && e3.isUnary()) d2 = isNode$1((s2 = [C2(e3.args[0], t22)])[0]) ? _3(s2) : w2(h2, s2, t22);
        else if (y(e3, t22.context)) if (s2 = (s2 = v2(e3, t22.context)).map(((e4) => C2(e4, t22))), g(h2, t22.context)) {
          for (var A3 = [], D2 = [], $22 = 0; $22 < s2.length; $22++) isNode$1(s2[$22]) ? D2.push(s2[$22]) : A3.push(s2[$22]);
          A3.length > 1 ? (d2 = S2(h2, A3, _3, t22), D2.unshift(d2), d2 = S2(h2, D2, _3, t22)) : d2 = S2(h2, s2, _3, t22);
        } else d2 = S2(h2, s2, _3, t22);
        else d2 = S2(h2, s2 = e3.args.map(((e4) => C2(e4, t22))), _3, t22);
        return d2;
      case "ParenthesisNode":
        return C2(e3.content, t22);
      case "AccessorNode":
        return (function(e4, t3, r3) {
          if (!isIndexNode(t3)) return new u(N(e4), N(t3));
          if (isArrayNode(e4) || isMatrix(e4)) {
            for (var n3 = Array.from(t3.dimensions); n3.length > 0; ) if (isConstantNode(n3[0]) && "string" != typeof n3[0].value) {
              var a3 = E(n3.shift().value, r3);
              isArrayNode(e4) ? e4 = e4.items[a3 - 1] : (e4 = e4.valueOf()[a3 - 1]) instanceof Array && (e4 = i2(e4));
            } else {
              if (!(n3.length > 1 && isConstantNode(n3[1]) && "string" != typeof n3[1].value)) break;
              var o3 = E(n3[1].value, r3), s3 = [], f3 = isArrayNode(e4) ? e4.items : e4.valueOf();
              for (var m2 of f3) if (isArrayNode(m2)) s3.push(m2.items[o3 - 1]);
              else {
                if (!isMatrix(e4)) break;
                s3.push(m2[o3 - 1]);
              }
              if (s3.length !== f3.length) break;
              e4 = isArrayNode(e4) ? new c2(s3) : i2(s3), n3.splice(1, 1);
            }
            return n3.length === t3.dimensions.length ? new u(N(e4), t3) : n3.length > 0 ? (t3 = new p(n3), new u(N(e4), t3)) : e4;
          }
          if (isObjectNode(e4) && 1 === t3.dimensions.length && isConstantNode(t3.dimensions[0])) {
            var d3 = t3.dimensions[0].value;
            return d3 in e4.properties ? e4.properties[d3] : new l();
          }
          return new u(N(e4), t3);
        })(C2(e3.object, t22), C2(e3.index, t22), t22);
      case "ArrayNode":
        var M2 = e3.items.map(((e4) => C2(e4, t22)));
        return M2.some(isNode$1) ? new c2(M2.map(N)) : i2(M2);
      case "IndexNode":
        return new p(e3.dimensions.map(((e4) => b2(e4, t22))));
      case "ObjectNode":
        var T2 = {};
        for (var F in e3.properties) T2[F] = b2(e3.properties[F], t22);
        return new m(T2);
      default:
        throw new Error("Unimplemented node type in simplifyConstant: ".concat(e3.type));
    }
  }
  return b2;
})), name$y = "simplifyCore", dependencies$y = ["typed", "parse", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], createSimplifyCore = factory(name$y, dependencies$y, ((e2) => {
  var { typed: t2, parse: r, equal: n, isZero: i2, add: a, subtract: o, multiply: s, divide: u, pow: c2, AccessorNode: l, ArrayNode: f2, ConstantNode: p, FunctionNode: m, IndexNode: d, ObjectNode: h, OperatorNode: g, ParenthesisNode: y, SymbolNode: v2 } = e2, x2 = new p(0), b2 = new p(1), _2 = new p(true), w2 = new p(false);
  function A2(e3) {
    return isOperatorNode(e3) && ["and", "not", "or"].includes(e3.op);
  }
  var { hasProperty: N, isCommutative: D } = createUtil({ FunctionNode: m, OperatorNode: g, SymbolNode: v2 });
  function E(e3) {
    var t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = t22 ? t22.context : void 0;
    if (N(e3, "trivial", r2)) {
      if (isFunctionNode(e3) && 1 === e3.args.length) return E(e3.args[0], t22);
      var a2 = false, o2 = 0;
      if (e3.forEach(((e4) => {
        1 === ++o2 && (a2 = E(e4, t22));
      })), 1 === o2) return a2;
    }
    var s2 = e3;
    if (isFunctionNode(s2)) {
      var u2 = getOperator(s2.name);
      if (!u2) return new m(E(s2.fn), s2.args.map(((e4) => E(e4, t22))));
      if (s2.args.length > 2 && N(s2, "associative", r2)) for (; s2.args.length > 2; ) {
        var c3 = s2.args.pop(), p2 = s2.args.pop();
        s2.args.push(new g(u2, s2.name, [c3, p2]));
      }
      s2 = new g(u2, s2.name, s2.args);
    }
    if (isOperatorNode(s2) && s2.isUnary()) {
      var y2 = E(s2.args[0], t22);
      if ("~" === s2.op && isOperatorNode(y2) && y2.isUnary() && "~" === y2.op) return y2.args[0];
      if ("not" === s2.op && isOperatorNode(y2) && y2.isUnary() && "not" === y2.op && A2(y2.args[0])) return y2.args[0];
      var v22 = true;
      if ("-" === s2.op && isOperatorNode(y2) && (y2.isBinary() && "subtract" === y2.fn && (s2 = new g("-", "subtract", [y2.args[1], y2.args[0]]), v22 = false), y2.isUnary() && "-" === y2.op)) return y2.args[0];
      if (v22) return new g(s2.op, s2.fn, [y2]);
    }
    if (isOperatorNode(s2) && s2.isBinary()) {
      var $2 = E(s2.args[0], t22), S2 = E(s2.args[1], t22);
      if ("+" === s2.op) {
        if (isConstantNode($2) && i2($2.value)) return S2;
        if (isConstantNode(S2) && i2(S2.value)) return $2;
        isOperatorNode(S2) && S2.isUnary() && "-" === S2.op && (S2 = S2.args[0], s2 = new g("-", "subtract", [$2, S2]));
      }
      if ("-" === s2.op) return isOperatorNode(S2) && S2.isUnary() && "-" === S2.op ? E(new g("+", "add", [$2, S2.args[0]]), t22) : isConstantNode($2) && i2($2.value) ? E(new g("-", "unaryMinus", [S2])) : isConstantNode(S2) && i2(S2.value) ? $2 : new g(s2.op, s2.fn, [$2, S2]);
      if ("*" === s2.op) {
        if (isConstantNode($2)) {
          if (i2($2.value)) return x2;
          if (n($2.value, 1)) return S2;
        }
        if (isConstantNode(S2)) {
          if (i2(S2.value)) return x2;
          if (n(S2.value, 1)) return $2;
          if (D(s2, r2)) return new g(s2.op, s2.fn, [S2, $2], s2.implicit);
        }
        return new g(s2.op, s2.fn, [$2, S2], s2.implicit);
      }
      if ("/" === s2.op) return isConstantNode($2) && i2($2.value) ? x2 : isConstantNode(S2) && n(S2.value, 1) ? $2 : new g(s2.op, s2.fn, [$2, S2]);
      if ("^" === s2.op && isConstantNode(S2)) {
        if (i2(S2.value)) return b2;
        if (n(S2.value, 1)) return $2;
      }
      if ("and" === s2.op) {
        if (isConstantNode($2)) {
          if (!$2.value) return w2;
          if (A2(S2)) return S2;
          if (isConstantNode(S2)) return S2.value ? _2 : w2;
        }
        if (isConstantNode(S2)) {
          if (!S2.value) return w2;
          if (A2($2)) return $2;
        }
      }
      if ("or" === s2.op) {
        if (isConstantNode($2)) {
          if ($2.value) return _2;
          if (A2(S2)) return S2;
        }
        if (isConstantNode(S2)) {
          if (S2.value) return _2;
          if (A2($2)) return $2;
        }
      }
      return new g(s2.op, s2.fn, [$2, S2]);
    }
    if (isOperatorNode(s2)) return new g(s2.op, s2.fn, s2.args.map(((e4) => E(e4, t22))));
    if (isArrayNode(s2)) return new f2(s2.items.map(((e4) => E(e4, t22))));
    if (isAccessorNode(s2)) return new l(E(s2.object, t22), E(s2.index, t22));
    if (isIndexNode(s2)) return new d(s2.dimensions.map(((e4) => E(e4, t22))));
    if (isObjectNode(s2)) {
      var C2 = {};
      for (var M2 in s2.properties) C2[M2] = E(s2.properties[M2], t22);
      return new h(C2);
    }
    return s2;
  }
  return t2(name$y, { Node: E, "Node,Object": E });
})), name$x = "resolve", dependencies$x = ["typed", "parse", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode"], createResolve = factory(name$x, dependencies$x, ((e2) => {
  var { typed: t2, parse: r, ConstantNode: n, FunctionNode: i2, OperatorNode: a, ParenthesisNode: o } = e2;
  function s(e3, t22) {
    var u = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : /* @__PURE__ */ new Set();
    if (!t22) return e3;
    if (isSymbolNode(e3)) {
      if (u.has(e3.name)) {
        var c2 = Array.from(u).join(", ");
        throw new ReferenceError("recursive loop of variable definitions among {".concat(c2, "}"));
      }
      var l = t22.get(e3.name);
      if (isNode$1(l)) {
        var f2 = new Set(u);
        return f2.add(e3.name), s(l, t22, f2);
      }
      return "number" == typeof l ? r(String(l)) : void 0 !== l ? new n(l) : e3;
    }
    if (isOperatorNode(e3)) {
      var p = e3.args.map((function(e4) {
        return s(e4, t22, u);
      }));
      return new a(e3.op, e3.fn, p, e3.implicit);
    }
    if (isParenthesisNode(e3)) return new o(s(e3.content, t22, u));
    if (isFunctionNode(e3)) {
      var m = e3.args.map((function(e4) {
        return s(e4, t22, u);
      }));
      return new i2(e3.name, m);
    }
    return e3.map(((e4) => s(e4, t22, u)));
  }
  return t2("resolve", { Node: s, "Node, Map | null | undefined": s, "Node, Object": (e3, t22) => s(e3, createMap$1(t22)), "Array | Matrix": t2.referToSelf(((e3) => (t22) => t22.map(((t3) => e3(t3))))), "Array | Matrix, null | undefined": t2.referToSelf(((e3) => (t22) => t22.map(((t3) => e3(t3))))), "Array, Object": t2.referTo("Array,Map", ((e3) => (t22, r2) => e3(t22, createMap$1(r2)))), "Matrix, Object": t2.referTo("Matrix,Map", ((e3) => (t22, r2) => e3(t22, createMap$1(r2)))), "Array | Matrix, Map": t2.referToSelf(((e3) => (t22, r2) => t22.map(((t3) => e3(t3, r2))))) });
})), name$w = "symbolicEqual", dependencies$w = ["parse", "simplify", "typed", "OperatorNode"], createSymbolicEqual = factory(name$w, dependencies$w, ((e2) => {
  var { parse: t2, simplify: r, typed: n, OperatorNode: i2 } = e2;
  function a(e3, t22) {
    var n3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, a2 = new i2("-", "subtract", [e3, t22]), o = r(a2, {}, n3);
    return isConstantNode(o) && !o.value;
  }
  return n(name$w, { "Node, Node": a, "Node, Node, Object": a });
})), name$v = "derivative", dependencies$v = ["typed", "config", "parse", "simplify", "equal", "isZero", "numeric", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], createDerivative = factory(name$v, dependencies$v, ((e2) => {
  var { typed: t2, config: r, parse: n, simplify: i2, equal: a, isZero: o, numeric: s, ConstantNode: u, FunctionNode: c2, OperatorNode: l, ParenthesisNode: f2, SymbolNode: p } = e2;
  function m(e3, t22) {
    var r2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { simplify: true }, n3 = /* @__PURE__ */ new Map(), a2 = t22.name;
    var o2 = v2(e3, (function e4(t3) {
      var r3 = n3.get(t3);
      if (void 0 !== r3) return r3;
      var i22 = y(e4, t3, a2);
      return n3.set(t3, i22), i22;
    }));
    return r2.simplify ? i2(o2) : o2;
  }
  function d(e3) {
    var t22 = n(e3);
    if (!t22.isSymbolNode) throw new TypeError("Invalid variable. " + "Cannot parse ".concat(JSON.stringify(e3), " into a variable in function derivative"));
    return t22;
  }
  var h = t2(name$v, { "Node, SymbolNode": m, "Node, SymbolNode, Object": m, "Node, string": (e3, t22) => m(e3, d(t22)), "Node, string, Object": (e3, t22, r2) => m(e3, d(t22), r2) });
  h._simplify = true, h.toTex = function(e3) {
    return g.apply(null, e3.args);
  };
  var g = t2("_derivTex", { "Node, SymbolNode": function(e3, t22) {
    return isConstantNode(e3) && "string" === typeOf(e3.value) ? g(n(e3.value).toString(), t22.toString(), 1) : g(e3.toTex(), t22.toString(), 1);
  }, "Node, ConstantNode": function(e3, t22) {
    if ("string" === typeOf(t22.value)) return g(e3, n(t22.value));
    throw new Error("The second parameter to 'derivative' is a non-string constant");
  }, "Node, SymbolNode, ConstantNode": function(e3, t22, r2) {
    return g(e3.toString(), t22.name, r2.value);
  }, "string, string, number": function(e3, t22, r2) {
    return (1 === r2 ? "{d\\over d" + t22 + "}" : "{d^{" + r2 + "}\\over d" + t22 + "^{" + r2 + "}}") + "\\left[".concat(e3, "\\right]");
  } }), y = t2("_isConst", { "function, ConstantNode, string": function() {
    return true;
  }, "function, SymbolNode, string": function(e3, t22, r2) {
    return t22.name !== r2;
  }, "function, ParenthesisNode, string": function(e3, t22, r2) {
    return e3(t22.content, r2);
  }, "function, FunctionAssignmentNode, string": function(e3, t22, r2) {
    return !t22.params.includes(r2) || e3(t22.expr, r2);
  }, "function, FunctionNode | OperatorNode, string": function(e3, t22, r2) {
    return t22.args.every(((t3) => e3(t3, r2)));
  } }), v2 = t2("_derivative", { "ConstantNode, function": function() {
    return x2(0);
  }, "SymbolNode, function": function(e3, t22) {
    return t22(e3) ? x2(0) : x2(1);
  }, "ParenthesisNode, function": function(e3, t22) {
    return new f2(v2(e3.content, t22));
  }, "FunctionAssignmentNode, function": function(e3, t22) {
    return t22(e3) ? x2(0) : v2(e3.expr, t22);
  }, "FunctionNode, function": function(e3, t22) {
    if (t22(e3)) return x2(0);
    var r2, n3, i22, a2, o2 = e3.args[0], s2 = false, u2 = false;
    switch (e3.name) {
      case "cbrt":
        s2 = true, n3 = new l("*", "multiply", [x2(3), new l("^", "pow", [o2, new l("/", "divide", [x2(2), x2(3)])])]);
        break;
      case "sqrt":
      case "nthRoot":
        if (1 === e3.args.length) s2 = true, n3 = new l("*", "multiply", [x2(2), new c2("sqrt", [o2])]);
        else if (2 === e3.args.length) return r2 = new l("/", "divide", [x2(1), e3.args[1]]), v2(new l("^", "pow", [o2, r2]), t22);
        break;
      case "log10":
        r2 = x2(10);
      case "log":
        if (r2 || 1 !== e3.args.length) {
          if (1 === e3.args.length && r2 || 2 === e3.args.length && t22(e3.args[1])) n3 = new l("*", "multiply", [o2.clone(), new c2("log", [r2 || e3.args[1]])]), s2 = true;
          else if (2 === e3.args.length) return v2(new l("/", "divide", [new c2("log", [o2]), new c2("log", [e3.args[1]])]), t22);
        } else n3 = o2.clone(), s2 = true;
        break;
      case "pow":
        if (2 === e3.args.length) return v2(new l("^", "pow", [o2, e3.args[1]]), t22);
        break;
      case "exp":
        n3 = new c2("exp", [o2.clone()]);
        break;
      case "sin":
        n3 = new c2("cos", [o2.clone()]);
        break;
      case "cos":
        n3 = new l("-", "unaryMinus", [new c2("sin", [o2.clone()])]);
        break;
      case "tan":
        n3 = new l("^", "pow", [new c2("sec", [o2.clone()]), x2(2)]);
        break;
      case "sec":
        n3 = new l("*", "multiply", [e3, new c2("tan", [o2.clone()])]);
        break;
      case "csc":
        u2 = true, n3 = new l("*", "multiply", [e3, new c2("cot", [o2.clone()])]);
        break;
      case "cot":
        u2 = true, n3 = new l("^", "pow", [new c2("csc", [o2.clone()]), x2(2)]);
        break;
      case "asin":
        s2 = true, n3 = new c2("sqrt", [new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])])]);
        break;
      case "acos":
        s2 = true, u2 = true, n3 = new c2("sqrt", [new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])])]);
        break;
      case "atan":
        s2 = true, n3 = new l("+", "add", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)]);
        break;
      case "asec":
        s2 = true, n3 = new l("*", "multiply", [new c2("abs", [o2.clone()]), new c2("sqrt", [new l("-", "subtract", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])])]);
        break;
      case "acsc":
        s2 = true, u2 = true, n3 = new l("*", "multiply", [new c2("abs", [o2.clone()]), new c2("sqrt", [new l("-", "subtract", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])])]);
        break;
      case "acot":
        s2 = true, u2 = true, n3 = new l("+", "add", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)]);
        break;
      case "sinh":
        n3 = new c2("cosh", [o2.clone()]);
        break;
      case "cosh":
        n3 = new c2("sinh", [o2.clone()]);
        break;
      case "tanh":
        n3 = new l("^", "pow", [new c2("sech", [o2.clone()]), x2(2)]);
        break;
      case "sech":
        u2 = true, n3 = new l("*", "multiply", [e3, new c2("tanh", [o2.clone()])]);
        break;
      case "csch":
        u2 = true, n3 = new l("*", "multiply", [e3, new c2("coth", [o2.clone()])]);
        break;
      case "coth":
        u2 = true, n3 = new l("^", "pow", [new c2("csch", [o2.clone()]), x2(2)]);
        break;
      case "asinh":
        s2 = true, n3 = new c2("sqrt", [new l("+", "add", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])]);
        break;
      case "acosh":
        s2 = true, n3 = new c2("sqrt", [new l("-", "subtract", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])]);
        break;
      case "atanh":
        s2 = true, n3 = new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])]);
        break;
      case "asech":
        s2 = true, u2 = true, n3 = new l("*", "multiply", [o2.clone(), new c2("sqrt", [new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])])])]);
        break;
      case "acsch":
        s2 = true, u2 = true, n3 = new l("*", "multiply", [new c2("abs", [o2.clone()]), new c2("sqrt", [new l("+", "add", [new l("^", "pow", [o2.clone(), x2(2)]), x2(1)])])]);
        break;
      case "acoth":
        s2 = true, u2 = true, n3 = new l("-", "subtract", [x2(1), new l("^", "pow", [o2.clone(), x2(2)])]);
        break;
      case "abs":
        n3 = new l("/", "divide", [new c2(new p("abs"), [o2.clone()]), o2.clone()]);
        break;
      default:
        throw new Error('Cannot process function "' + e3.name + '" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported');
    }
    s2 ? (i22 = "/", a2 = "divide") : (i22 = "*", a2 = "multiply");
    var f3 = v2(o2, t22);
    return u2 && (f3 = new l("-", "unaryMinus", [f3])), new l(i22, a2, [f3, n3]);
  }, "OperatorNode, function": function(e3, t22) {
    if (t22(e3)) return x2(0);
    if ("+" === e3.op) return new l(e3.op, e3.fn, e3.args.map((function(e4) {
      return v2(e4, t22);
    })));
    if ("-" === e3.op) {
      if (e3.isUnary()) return new l(e3.op, e3.fn, [v2(e3.args[0], t22)]);
      if (e3.isBinary()) return new l(e3.op, e3.fn, [v2(e3.args[0], t22), v2(e3.args[1], t22)]);
    }
    if ("*" === e3.op) {
      var r2 = e3.args.filter((function(e4) {
        return t22(e4);
      }));
      if (r2.length > 0) {
        var n3 = e3.args.filter((function(e4) {
          return !t22(e4);
        })), i22 = 1 === n3.length ? n3[0] : new l("*", "multiply", n3), s2 = r2.concat(v2(i22, t22));
        return new l("*", "multiply", s2);
      }
      return new l("+", "add", e3.args.map((function(r3) {
        return new l("*", "multiply", e3.args.map((function(e4) {
          return e4 === r3 ? v2(e4, t22) : e4.clone();
        })));
      })));
    }
    if ("/" === e3.op && e3.isBinary()) {
      var u2 = e3.args[0], f3 = e3.args[1];
      return t22(f3) ? new l("/", "divide", [v2(u2, t22), f3]) : t22(u2) ? new l("*", "multiply", [new l("-", "unaryMinus", [u2]), new l("/", "divide", [v2(f3, t22), new l("^", "pow", [f3.clone(), x2(2)])])]) : new l("/", "divide", [new l("-", "subtract", [new l("*", "multiply", [v2(u2, t22), f3.clone()]), new l("*", "multiply", [u2.clone(), v2(f3, t22)])]), new l("^", "pow", [f3.clone(), x2(2)])]);
    }
    if ("^" === e3.op && e3.isBinary()) {
      var p2 = e3.args[0], m2 = e3.args[1];
      if (t22(p2)) return isConstantNode(p2) && (o(p2.value) || a(p2.value, 1)) ? x2(0) : new l("*", "multiply", [e3, new l("*", "multiply", [new c2("log", [p2.clone()]), v2(m2.clone(), t22)])]);
      if (t22(m2)) {
        if (isConstantNode(m2)) {
          if (o(m2.value)) return x2(0);
          if (a(m2.value, 1)) return v2(p2, t22);
        }
        var d2 = new l("^", "pow", [p2.clone(), new l("-", "subtract", [m2, x2(1)])]);
        return new l("*", "multiply", [m2.clone(), new l("*", "multiply", [v2(p2, t22), d2])]);
      }
      return new l("*", "multiply", [new l("^", "pow", [p2.clone(), m2.clone()]), new l("+", "add", [new l("*", "multiply", [v2(p2, t22), new l("/", "divide", [m2.clone(), p2.clone()])]), new l("*", "multiply", [v2(m2, t22), new c2("log", [p2.clone()])])])]);
    }
    throw new Error('Cannot process operator "' + e3.op + '" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported');
  } });
  function x2(e3, t22) {
    return new u(s(e3, safeNumberType(String(e3), r)));
  }
  return h;
})), name$u = "rationalize", dependencies$u = ["config", "typed", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "parse", "simplifyConstant", "simplifyCore", "simplify", "?bignumber", "?fraction", "mathWithTransform", "matrix", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode", "ParenthesisNode"], createRationalize = factory(name$u, dependencies$u, ((e2) => {
  var { config: t2, typed: r, equal: n, isZero: i2, add: a, subtract: o, multiply: s, divide: u, pow: c2, parse: l, simplifyConstant: f2, simplifyCore: p, simplify: m, fraction: d, bignumber: h, mathWithTransform: g, matrix: y, AccessorNode: v2, ArrayNode: x2, ConstantNode: b2, FunctionNode: _2, IndexNode: w2, ObjectNode: A2, OperatorNode: N, SymbolNode: D, ParenthesisNode: E } = e2;
  function $2(e3) {
    var t22 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r2 = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n3 = (function() {
      var e4 = [p, { l: "n+n", r: "2*n" }, { l: "n+-n", r: "0" }, f2, { l: "n*(n1^-1)", r: "n/n1" }, { l: "n*n1^-n2", r: "n/n1^n2" }, { l: "n1^-1", r: "1/n1" }, { l: "n*(n1/n2)", r: "(n*n1)/n2" }, { l: "1*n", r: "n" }], t3 = [{ l: "(-n1)/(-n2)", r: "n1/n2" }, { l: "(-n1)*(-n2)", r: "n1*n2" }, { l: "n1--n2", r: "n1+n2" }, { l: "n1-n2", r: "n1+(-n2)" }, { l: "(n1+n2)*n3", r: "(n1*n3 + n2*n3)" }, { l: "n1*(n2+n3)", r: "(n1*n2+n1*n3)" }, { l: "c1*n + c2*n", r: "(c1+c2)*n" }, { l: "c1*n + n", r: "(c1+1)*n" }, { l: "c1*n - c2*n", r: "(c1-c2)*n" }, { l: "c1*n - n", r: "(c1-1)*n" }, { l: "v/c", r: "(1/c)*v" }, { l: "v/-c", r: "-(1/c)*v" }, { l: "-v*-c", r: "c*v" }, { l: "-v*c", r: "-c*v" }, { l: "v*-c", r: "-c*v" }, { l: "v*c", r: "c*v" }, { l: "-(-n1*n2)", r: "(n1*n2)" }, { l: "-(n1*n2)", r: "(-n1*n2)" }, { l: "-(-n1+n2)", r: "(n1-n2)" }, { l: "-(n1+n2)", r: "(-n1-n2)" }, { l: "(n1^n2)^n3", r: "(n1^(n2*n3))" }, { l: "-(-n1/n2)", r: "(n1/n2)" }, { l: "-(n1/n2)", r: "(-n1/n2)" }], r3 = [{ l: "(n1/n2 + n3/n4)", r: "((n1*n4 + n3*n2)/(n2*n4))" }, { l: "(n1/n2 + n3)", r: "((n1 + n3*n2)/n2)" }, { l: "(n1 + n2/n3)", r: "((n1*n3 + n2)/n3)" }], n4 = [{ l: "(n1/(n2/n3))", r: "((n1*n3)/n2)" }, { l: "(n1/n2/n3)", r: "(n1/(n2*n3))" }], i3 = {};
      return i3.firstRules = e4.concat(t3, n4), i3.distrDivRules = r3, i3.sucDivRules = n4, i3.firstRulesAgain = e4.concat(t3), i3.finalRules = [p, { l: "n*-n", r: "-n^2" }, { l: "n*n", r: "n^2" }, f2, { l: "n*-n^n1", r: "-n^(n1+1)" }, { l: "n*n^n1", r: "n^(n1+1)" }, { l: "n^n1*-n^n2", r: "-n^(n1+n2)" }, { l: "n^n1*n^n2", r: "n^(n1+n2)" }, { l: "n^n1*-n", r: "-n^(n1+1)" }, { l: "n^n1*n", r: "n^(n1+1)" }, { l: "n^n1/-n", r: "-n^(n1-1)" }, { l: "n^n1/n", r: "n^(n1-1)" }, { l: "n/-n^n1", r: "-n^(1-n1)" }, { l: "n/n^n1", r: "n^(1-n1)" }, { l: "n^n1/-n^n2", r: "n^(n1-n2)" }, { l: "n^n1/n^n2", r: "n^(n1-n2)" }, { l: "n1+(-n2*n3)", r: "n1-n2*n3" }, { l: "v*(-c)", r: "-c*v" }, { l: "n1+-n2", r: "n1-n2" }, { l: "v*c", r: "c*v" }, { l: "(n1^n2)^n3", r: "(n1^(n2*n3))" }], i3;
    })(), i22 = (function(e4, t3, r3, n4) {
      var i3 = [], a3 = m(e4, n4, t3, { exactFractions: false }), o3 = "+-*" + ((r3 = !!r3) ? "/" : "");
      u3(a3);
      var s3 = {};
      return s3.expression = a3, s3.variables = i3, s3;
      function u3(e5) {
        var t4 = e5.type;
        if ("FunctionNode" === t4) throw new Error("There is an unsolved function call");
        if ("OperatorNode" === t4) if ("^" === e5.op) {
          if ("ConstantNode" !== e5.args[1].type || !isInteger(parseFloat(e5.args[1].value))) throw new Error("There is a non-integer exponent");
          u3(e5.args[0]);
        } else {
          if (!o3.includes(e5.op)) throw new Error("Operator " + e5.op + " invalid in polynomial expression");
          for (var r4 = 0; r4 < e5.args.length; r4++) u3(e5.args[r4]);
        }
        else if ("SymbolNode" === t4) {
          var n5 = e5.name;
          -1 === i3.indexOf(n5) && i3.push(n5);
        } else if ("ParenthesisNode" === t4) u3(e5.content);
        else if ("ConstantNode" !== t4) throw new Error("type " + t4 + " is not allowed in polynomial expression");
      }
    })(e3, t22, true, n3.firstRules), a2 = i22.variables.length, o2 = { exactFractions: false }, s2 = { exactFractions: true };
    if (e3 = i22.expression, a2 >= 1) {
      var u2, c3;
      e3 = S2(e3);
      var l2, d2 = true, h2 = false;
      for (e3 = m(e3, n3.firstRules, {}, o2); c3 = d2 ? n3.distrDivRules : n3.sucDivRules, d2 = !d2, (l2 = (e3 = m(e3, c3, {}, s2)).toString()) !== u2; ) h2 = true, u2 = l2;
      h2 && (e3 = m(e3, n3.firstRulesAgain, {}, o2)), e3 = m(e3, n3.finalRules, {}, o2);
    }
    var g2 = [], y2 = {};
    return "OperatorNode" === e3.type && e3.isBinary() && "/" === e3.op ? (1 === a2 && (e3.args[0] = C2(e3.args[0], g2), e3.args[1] = C2(e3.args[1])), r2 && (y2.numerator = e3.args[0], y2.denominator = e3.args[1])) : (1 === a2 && (e3 = C2(e3, g2)), r2 && (y2.numerator = e3, y2.denominator = null)), r2 ? (y2.coefficients = g2, y2.variables = i22.variables, y2.expression = e3, y2) : e3;
  }
  return r(name$u, { Node: $2, "Node, boolean": (e3, t22) => $2(e3, {}, t22), "Node, Object": $2, "Node, Object, boolean": $2 });
  function S2(e3, t22, r2) {
    var n3 = e3.type, i22 = arguments.length > 1;
    if ("OperatorNode" === n3 && e3.isBinary()) {
      var a2, o2 = false;
      if ("^" === e3.op && ("ParenthesisNode" !== e3.args[0].type && "OperatorNode" !== e3.args[0].type || "ConstantNode" !== e3.args[1].type || (o2 = (a2 = parseFloat(e3.args[1].value)) >= 2 && isInteger(a2))), o2) {
        if (a2 > 2) {
          var s2 = e3.args[0], u2 = new N("^", "pow", [e3.args[0].cloneDeep(), new b2(a2 - 1)]);
          e3 = new N("*", "multiply", [s2, u2]);
        } else e3 = new N("*", "multiply", [e3.args[0], e3.args[0].cloneDeep()]);
        i22 && ("content" === r2 ? t22.content = e3 : t22.args[r2] = e3);
      }
    }
    if ("ParenthesisNode" === n3) S2(e3.content, e3, "content");
    else if ("ConstantNode" !== n3 && "SymbolNode" !== n3) for (var c3 = 0; c3 < e3.args.length; c3++) S2(e3.args[c3], e3, c3);
    if (!i22) return e3;
  }
  function C2(e3, t22) {
    void 0 === t22 && (t22 = []), t22[0] = 0;
    var r2 = { cte: 1, oper: "+", fire: "" }, n3 = 0, i22 = "";
    !(function e4(r3, a3, o3) {
      var s3 = r3.type;
      if ("FunctionNode" === s3) throw new Error("There is an unsolved function call");
      if ("OperatorNode" === s3) {
        if (!"+-*^".includes(r3.op)) throw new Error("Operator " + r3.op + " invalid");
        if (null !== a3) {
          if (("unaryMinus" === r3.fn || "pow" === r3.fn) && "add" !== a3.fn && "subtract" !== a3.fn && "multiply" !== a3.fn) throw new Error("Invalid " + r3.op + " placing");
          if (("subtract" === r3.fn || "add" === r3.fn || "multiply" === r3.fn) && "add" !== a3.fn && "subtract" !== a3.fn) throw new Error("Invalid " + r3.op + " placing");
          if (("subtract" === r3.fn || "add" === r3.fn || "unaryMinus" === r3.fn) && 0 !== o3.noFil) throw new Error("Invalid " + r3.op + " placing");
        }
        "^" !== r3.op && "*" !== r3.op || (o3.fire = r3.op);
        for (var u3 = 0; u3 < r3.args.length; u3++) "unaryMinus" === r3.fn && (o3.oper = "-"), "+" !== r3.op && "subtract" !== r3.fn || (o3.fire = "", o3.cte = 1, o3.oper = 0 === u3 ? "+" : r3.op), o3.noFil = u3, e4(r3.args[u3], r3, o3);
      } else if ("SymbolNode" === s3) {
        if (r3.name !== i22 && "" !== i22) throw new Error("There is more than one variable");
        if (i22 = r3.name, null === a3) return void (t22[1] = 1);
        if ("^" === a3.op && 0 !== o3.noFil) throw new Error("In power the variable should be the first parameter");
        if ("*" === a3.op && 1 !== o3.noFil) throw new Error("In multiply the variable should be the second parameter");
        "" !== o3.fire && "*" !== o3.fire || (n3 < 1 && (t22[1] = 0), t22[1] += o3.cte * ("+" === o3.oper ? 1 : -1), n3 = Math.max(1, n3));
      } else {
        if ("ConstantNode" !== s3) throw new Error("Type " + s3 + " is not allowed");
        var c4 = parseFloat(r3.value);
        if (null === a3) return void (t22[0] = c4);
        if ("^" === a3.op) {
          if (1 !== o3.noFil) throw new Error("Constant cannot be powered");
          if (!isInteger(c4) || c4 <= 0) throw new Error("Non-integer exponent is not allowed");
          for (var l3 = n3 + 1; l3 < c4; l3++) t22[l3] = 0;
          return c4 > n3 && (t22[c4] = 0), t22[c4] += o3.cte * ("+" === o3.oper ? 1 : -1), void (n3 = Math.max(c4, n3));
        }
        o3.cte = c4, "" === o3.fire && (t22[0] += o3.cte * ("+" === o3.oper ? 1 : -1));
      }
    })(e3, null, r2);
    for (var a2, o2 = true, s2 = n3 = t22.length - 1; s2 >= 0; s2--) if (0 !== t22[s2]) {
      var u2 = new b2(o2 ? t22[s2] : Math.abs(t22[s2])), c3 = t22[s2] < 0 ? "-" : "+";
      if (s2 > 0) {
        var l2 = new D(i22);
        if (s2 > 1) {
          var f3 = new b2(s2);
          l2 = new N("^", "pow", [l2, f3]);
        }
        u2 = -1 === t22[s2] && o2 ? new N("-", "unaryMinus", [l2]) : 1 === Math.abs(t22[s2]) ? l2 : new N("*", "multiply", [u2, l2]);
      }
      a2 = o2 ? u2 : "+" === c3 ? new N("+", "add", [a2, u2]) : new N("-", "subtract", [a2, u2]), o2 = false;
    }
    return o2 ? new b2(0) : a2;
  }
})), name$t = "zpk2tf", dependencies$t = ["typed", "add", "multiply", "Complex", "number"], createZpk2tf = factory(name$t, dependencies$t, ((e2) => {
  var { typed: t2, add: r, multiply: n, Complex: i2, number: a } = e2;
  return t2(name$t, { "Array,Array,number": function(e3, t22, r2) {
    return o(e3, t22, r2);
  }, "Array,Array": function(e3, t22) {
    return o(e3, t22, 1);
  }, "Matrix,Matrix,number": function(e3, t22, r2) {
    return o(e3.valueOf(), t22.valueOf(), r2);
  }, "Matrix,Matrix": function(e3, t22) {
    return o(e3.valueOf(), t22.valueOf(), 1);
  } });
  function o(e3, t22, r2) {
    e3.some(((e4) => "BigNumber" === e4.type)) && (e3 = e3.map(((e4) => a(e4)))), t22.some(((e4) => "BigNumber" === e4.type)) && (t22 = t22.map(((e4) => a(e4))));
    for (var o2 = [i2(1, 0)], u = [i2(1, 0)], c2 = 0; c2 < e3.length; c2++) {
      var l = e3[c2];
      "number" == typeof l && (l = i2(l, 0)), o2 = s(o2, [i2(1, 0), i2(-l.re, -l.im)]);
    }
    for (var f2 = 0; f2 < t22.length; f2++) {
      var p = t22[f2];
      "number" == typeof p && (p = i2(p, 0)), u = s(u, [i2(1, 0), i2(-p.re, -p.im)]);
    }
    for (var m = 0; m < o2.length; m++) o2[m] = n(o2[m], r2);
    return [o2, u];
  }
  function s(e3, t22) {
    for (var a2 = [], o2 = 0; o2 < e3.length + t22.length - 1; o2++) {
      a2[o2] = i2(0, 0);
      for (var s2 = 0; s2 < e3.length; s2++) o2 - s2 >= 0 && o2 - s2 < t22.length && (a2[o2] = r(a2[o2], n(e3[s2], t22[o2 - s2])));
    }
    return a2;
  }
})), name$s = "freqz", dependencies$s = ["typed", "add", "multiply", "Complex", "divide", "matrix"], createFreqz = factory(name$s, dependencies$s, ((e2) => {
  var { typed: t2, add: r, multiply: n, Complex: i2, divide: a, matrix: o } = e2;
  return t2(name$s, { "Array, Array": function(e3, t22) {
    return s(e3, t22, u(512));
  }, "Array, Array, Array": function(e3, t22, r2) {
    return s(e3, t22, r2);
  }, "Array, Array, number": function(e3, t22, r2) {
    if (r2 < 0) throw new Error("w must be a positive number");
    return s(e3, t22, u(r2));
  }, "Matrix, Matrix": function(e3, t22) {
    var r2 = u(512), { w: n3, h: i22 } = s(e3.valueOf(), t22.valueOf(), r2);
    return { w: o(n3), h: o(i22) };
  }, "Matrix, Matrix, Matrix": function(e3, t22, r2) {
    var { h: n3 } = s(e3.valueOf(), t22.valueOf(), r2.valueOf());
    return { h: o(n3), w: o(r2) };
  }, "Matrix, Matrix, number": function(e3, t22, r2) {
    if (r2 < 0) throw new Error("w must be a positive number");
    var n3 = u(r2), { h: i22 } = s(e3.valueOf(), t22.valueOf(), n3);
    return { h: o(i22), w: o(n3) };
  } });
  function s(e3, t22, o2) {
    for (var s2 = [], u2 = [], c2 = 0; c2 < o2.length; c2++) {
      for (var l = i2(0, 0), f2 = i2(0, 0), p = 0; p < e3.length; p++) l = r(l, n(e3[p], i2(Math.cos(-p * o2[c2]), Math.sin(-p * o2[c2]))));
      for (var m = 0; m < t22.length; m++) f2 = r(f2, n(t22[m], i2(Math.cos(-m * o2[c2]), Math.sin(-m * o2[c2]))));
      s2.push(l), u2.push(f2);
    }
    for (var d = [], h = 0; h < s2.length; h++) d.push(a(s2[h], u2[h]));
    return { h: d, w: o2 };
  }
  function u(e3) {
    for (var t22 = [], r2 = 0; r2 < e3; r2++) t22.push(r2 / e3 * Math.PI);
    return t22;
  }
})), name$r = "reviver", dependencies$r = ["classes"], createReviver = factory(name$r, dependencies$r, ((e2) => {
  var { classes: t2 } = e2;
  return function(e3, r) {
    var n = t2[r && r.mathjs];
    return n && "function" == typeof n.fromJSON ? n.fromJSON(r) : r;
  };
})), name$q = "replacer", dependencies$q = [], createReplacer = factory(name$q, dependencies$q, (() => function(e2, t2) {
  return "number" != typeof t2 || Number.isFinite(t2) && !isNaN(t2) ? "bigint" == typeof t2 ? { mathjs: "bigint", value: String(t2) } : t2 : { mathjs: "number", value: String(t2) };
})), version$1 = "15.1.0", createTrue = factory("true", [], (() => true)), createFalse = factory("false", [], (() => false)), createNull = factory("null", [], (() => null)), createInfinity = recreateFactory("Infinity", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(1 / 0) : 1 / 0;
})), createNaN = recreateFactory("NaN", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(NaN) : NaN;
})), createPi = recreateFactory("pi", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? createBigNumberPi(r) : pi;
})), createTau = recreateFactory("tau", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? createBigNumberTau(r) : tau;
})), createE = recreateFactory("e", ["config", "?BigNumber"], ((t2) => {
  var { config: r, BigNumber: n } = t2;
  return "BigNumber" === r.number ? createBigNumberE(n) : e;
})), createPhi = recreateFactory("phi", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? createBigNumberPhi(r) : phi;
})), createLN2 = recreateFactory("LN2", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(2).ln() : Math.LN2;
})), createLN10 = recreateFactory("LN10", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(10).ln() : Math.LN10;
})), createLOG2E = recreateFactory("LOG2E", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(1).div(new r(2).ln()) : Math.LOG2E;
})), createLOG10E = recreateFactory("LOG10E", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(1).div(new r(10).ln()) : Math.LOG10E;
})), createSQRT1_2 = recreateFactory("SQRT1_2", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r("0.5").sqrt() : Math.SQRT1_2;
})), createSQRT2 = recreateFactory("SQRT2", ["config", "?BigNumber"], ((e2) => {
  var { config: t2, BigNumber: r } = e2;
  return "BigNumber" === t2.number ? new r(2).sqrt() : Math.SQRT2;
})), createI = recreateFactory("i", ["Complex"], ((e2) => {
  var { Complex: t2 } = e2;
  return t2.I;
})), createUppercasePi = factory("PI", ["pi"], ((e2) => {
  var { pi: t2 } = e2;
  return t2;
})), createUppercaseE = factory("E", ["e"], ((e2) => {
  var { e: t2 } = e2;
  return t2;
})), createVersion = factory("version", [], (() => version$1));
function recreateFactory(e2, t2, r) {
  return factory(e2, t2, r, { recreateOnConfigChange: true });
}
var createSpeedOfLight = unitFactory("speedOfLight", "299792458", "m s^-1"), createGravitationConstant = unitFactory("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2"), createPlanckConstant = unitFactory("planckConstant", "6.62607015e-34", "J s"), createReducedPlanckConstant = unitFactory("reducedPlanckConstant", "1.0545718176461565e-34", "J s"), createMagneticConstant = unitFactory("magneticConstant", "1.25663706212e-6", "N A^-2"), createElectricConstant = unitFactory("electricConstant", "8.8541878128e-12", "F m^-1"), createVacuumImpedance = unitFactory("vacuumImpedance", "376.730313667", "ohm"), createCoulomb = unitFactory("coulomb", "8.987551792261171e9", "N m^2 C^-2"), createCoulombConstant = unitFactory("coulombConstant", "8.987551792261171e9", "N m^2 C^-2"), createElementaryCharge = unitFactory("elementaryCharge", "1.602176634e-19", "C"), createBohrMagneton = unitFactory("bohrMagneton", "9.2740100783e-24", "J T^-1"), createConductanceQuantum = unitFactory("conductanceQuantum", "7.748091729863649e-5", "S"), createInverseConductanceQuantum = unitFactory("inverseConductanceQuantum", "12906.403729652257", "ohm"), createMagneticFluxQuantum = unitFactory("magneticFluxQuantum", "2.0678338484619295e-15", "Wb"), createNuclearMagneton = unitFactory("nuclearMagneton", "5.0507837461e-27", "J T^-1"), createKlitzing = unitFactory("klitzing", "25812.807459304513", "ohm"), createBohrRadius = unitFactory("bohrRadius", "5.29177210903e-11", "m"), createClassicalElectronRadius = unitFactory("classicalElectronRadius", "2.8179403262e-15", "m"), createElectronMass = unitFactory("electronMass", "9.1093837015e-31", "kg"), createFermiCoupling = unitFactory("fermiCoupling", "1.1663787e-5", "GeV^-2"), createFineStructure = numberFactory("fineStructure", 0.0072973525693), createHartreeEnergy = unitFactory("hartreeEnergy", "4.3597447222071e-18", "J"), createProtonMass = unitFactory("protonMass", "1.67262192369e-27", "kg"), createDeuteronMass = unitFactory("deuteronMass", "3.3435830926e-27", "kg"), createNeutronMass = unitFactory("neutronMass", "1.6749271613e-27", "kg"), createQuantumOfCirculation = unitFactory("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1"), createRydberg = unitFactory("rydberg", "10973731.568160", "m^-1"), createThomsonCrossSection = unitFactory("thomsonCrossSection", "6.6524587321e-29", "m^2"), createWeakMixingAngle = numberFactory("weakMixingAngle", 0.2229), createEfimovFactor = numberFactory("efimovFactor", 22.7), createAtomicMass = unitFactory("atomicMass", "1.66053906660e-27", "kg"), createAvogadro = unitFactory("avogadro", "6.02214076e23", "mol^-1"), createBoltzmann = unitFactory("boltzmann", "1.380649e-23", "J K^-1"), createFaraday = unitFactory("faraday", "96485.33212331001", "C mol^-1"), createFirstRadiation = unitFactory("firstRadiation", "3.7417718521927573e-16", "W m^2"), createLoschmidt = unitFactory("loschmidt", "2.686780111798444e25", "m^-3"), createGasConstant = unitFactory("gasConstant", "8.31446261815324", "J K^-1 mol^-1"), createMolarPlanckConstant = unitFactory("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1"), createMolarVolume = unitFactory("molarVolume", "0.022413969545014137", "m^3 mol^-1"), createSackurTetrode = numberFactory("sackurTetrode", -1.16487052358), createSecondRadiation = unitFactory("secondRadiation", "0.014387768775039337", "m K"), createStefanBoltzmann = unitFactory("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4"), createWienDisplacement = unitFactory("wienDisplacement", "2.897771955e-3", "m K"), createMolarMass = unitFactory("molarMass", "0.99999999965e-3", "kg mol^-1"), createMolarMassC12 = unitFactory("molarMassC12", "11.9999999958e-3", "kg mol^-1"), createGravity = unitFactory("gravity", "9.80665", "m s^-2"), createPlanckLength = unitFactory("planckLength", "1.616255e-35", "m"), createPlanckMass = unitFactory("planckMass", "2.176435e-8", "kg"), createPlanckTime = unitFactory("planckTime", "5.391245e-44", "s"), createPlanckCharge = unitFactory("planckCharge", "1.87554603778e-18", "C"), createPlanckTemperature = unitFactory("planckTemperature", "1.416785e+32", "K");
function unitFactory(e2, t2, r) {
  return factory(e2, ["config", "Unit", "BigNumber"], ((e3) => {
    var { config: n, Unit: i2, BigNumber: a } = e3, o = new i2("BigNumber" === n.number ? new a(t2) : parseFloat(t2), r);
    return o.fixPrefix = true, o;
  }));
}
function numberFactory(e2, t2) {
  return factory(e2, ["config", "BigNumber"], ((e3) => {
    var { config: r, BigNumber: n } = e3;
    return "BigNumber" === r.number ? new n(t2) : t2;
  }));
}
function ownKeys$4(e2, t2) {
  var r = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e2);
    t2 && (n = n.filter((function(t22) {
      return Object.getOwnPropertyDescriptor(e2, t22).enumerable;
    }))), r.push.apply(r, n);
  }
  return r;
}
function _objectSpread$4(e2) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? ownKeys$4(Object(r), true).forEach((function(t22) {
      _defineProperty$1(e2, t22, r[t22]);
    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(r)) : ownKeys$4(Object(r)).forEach((function(t22) {
      Object.defineProperty(e2, t22, Object.getOwnPropertyDescriptor(r, t22));
    }));
  }
  return e2;
}
var name$p = "mapSlices", dependencies$p = ["typed", "isInteger"], createMapSlicesTransform = factory(name$p, dependencies$p, ((e2) => {
  var { typed: t2, isInteger: r } = e2, n = createMapSlices({ typed: t2, isInteger: r });
  return t2("mapSlices", { "...any": function(e3) {
    var t22 = e3[1];
    isNumber$1(t22) ? e3[1] = t22 - 1 : isBigNumber(t22) && (e3[1] = t22.minus(1));
    try {
      return n.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), _objectSpread$4({ isTransformFunction: true }, createMapSlices.meta)), name$o = "column", dependencies$o = ["typed", "Index", "matrix", "range"], createColumnTransform = factory(name$o, dependencies$o, ((e2) => {
  var { typed: t2, Index: r, matrix: n, range: i2 } = e2, a = createColumn({ typed: t2, Index: r, matrix: n, range: i2 });
  return t2("column", { "...any": function(e3) {
    var t22 = e3.length - 1, r2 = e3[t22];
    isNumber$1(r2) && (e3[t22] = r2 - 1);
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true });
function compileInlineExpression(e2, t2, r) {
  var n = e2.filter((function(e3) {
    return isSymbolNode(e3) && !(e3.name in t2) && !r.has(e3.name);
  }))[0];
  if (!n) throw new Error('No undefined variable found in inline expression "' + e2 + '"');
  var i2 = n.name, a = /* @__PURE__ */ new Map(), o = new PartitionedMap(r, a, /* @__PURE__ */ new Set([i2])), s = e2.compile();
  return function(e3) {
    return a.set(i2, e3), s.evaluate(o);
  };
}
var name$n = "transformCallback", dependencies$n = ["typed"], createTransformCallback = factory(name$n, dependencies$n, ((e2) => {
  var { typed: t2 } = e2;
  return function(e3, n) {
    return t2.isTypedFunction(e3) ? r(e3, n) : _transformCallbackFunction(e3, e3.length, n);
  };
  function r(e3, n) {
    var i2 = Object.fromEntries(Object.entries(e3.signatures).map(((e4) => {
      var [i22, a] = e4, o = i22.split(",").length;
      return t2.isTypedFunction(a) ? [i22, r(a, n)] : [i22, _transformCallbackFunction(a, o, n)];
    })));
    return "string" == typeof e3.name ? t2(e3.name, i2) : t2(i2);
  }
}));
function _transformCallbackFunction(e2, t2, r) {
  return t2 === r ? e2 : t2 === r + 1 ? function() {
    for (var t22 = arguments.length, n = new Array(t22), i2 = 0; i2 < t22; i2++) n[i2] = arguments[i2];
    var a = n.slice(0, r), o = _transformDims(n[r]);
    return e2(...a, o);
  } : t2 > r + 1 ? function() {
    for (var t22 = arguments.length, n = new Array(t22), i2 = 0; i2 < t22; i2++) n[i2] = arguments[i2];
    var a = n.slice(0, r), o = _transformDims(n[r]), s = n.slice(r + 1);
    return e2(...a, o, ...s);
  } : e2;
}
function _transformDims(e2) {
  return e2.map(((e3) => e3 + 1));
}
var name$m = "filter", dependencies$m = ["typed"], createFilterTransform = factory(name$m, dependencies$m, ((e2) => {
  var { typed: t2 } = e2;
  function r(e3, r2, i2) {
    var a = createFilter({ typed: t2 }), o = createTransformCallback({ typed: t2 });
    if (0 === e3.length) return a();
    var s = e3[0];
    if (1 === e3.length) return a(s);
    var u = e3.length - 1, c2 = e3[u];
    return s && (s = n(s, i2)), c2 && (c2 = isSymbolNode(c2) || isFunctionAssignmentNode(c2) ? n(c2, i2) : compileInlineExpression(c2, r2, i2)), a(s, o(c2, u));
  }
  function n(e3, t22) {
    return e3.compile().evaluate(t22);
  }
  return r.rawArgs = true, r;
}), { isTransformFunction: true }), name$l = "forEach", dependencies$l = ["typed"], createForEachTransform = factory(name$l, dependencies$l, ((e2) => {
  var { typed: t2 } = e2, r = createForEach({ typed: t2 }), n = createTransformCallback({ typed: t2 });
  function i2(e3, t22, i22) {
    if (0 === e3.length) return r();
    var o = e3[0];
    if (1 === e3.length) return r(o);
    var s = e3.length - 1, u = e3[s];
    return o && (o = a(o, i22)), u && (u = isSymbolNode(u) || isFunctionAssignmentNode(u) ? a(u, i22) : compileInlineExpression(u, t22, i22)), r(o, n(u, s));
  }
  function a(e3, t22) {
    return e3.compile().evaluate(t22);
  }
  return i2.rawArgs = true, i2;
}), { isTransformFunction: true }), name$k = "index", dependencies$k = ["Index", "getMatrixDataType"], createIndexTransform = factory(name$k, dependencies$k, ((e2) => {
  var { Index: t2, getMatrixDataType: r } = e2;
  return function() {
    for (var e3 = [], n = 0, i2 = arguments.length; n < i2; n++) {
      var a = arguments[n];
      if (isRange(a)) a.start--, a.end -= a.step > 0 ? 0 : 2;
      else if (a && true === a.isSet) a = a.map((function(e4) {
        return e4 - 1;
      }));
      else if (isArray$1(a) || isMatrix(a)) "boolean" !== r(a) && (a = a.map((function(e4) {
        return e4 - 1;
      })));
      else if (isNumber$1(a) || isBigInt(a)) a--;
      else if (isBigNumber(a)) a = a.toNumber() - 1;
      else if ("string" != typeof a) throw new TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");
      e3[n] = a;
    }
    var o = new t2();
    return t2.apply(o, e3), o;
  };
}), { isTransformFunction: true }), name$j = "map", dependencies$j = ["typed"], createMapTransform = factory(name$j, dependencies$j, ((e2) => {
  var { typed: t2 } = e2, r = createMap({ typed: t2 }), n = createTransformCallback({ typed: t2 });
  function i2(e3, t22, i22) {
    if (0 === e3.length) return r();
    if (1 === e3.length) return r(e3[0]);
    var a = e3.length - 1, o = e3.slice(0, a), s = e3[a];
    return o = o.map(((e4) => u(e4, i22))), s && (s = isSymbolNode(s) || isFunctionAssignmentNode(s) ? u(s, i22) : compileInlineExpression(s, t22, i22)), r(...o, n(s, a));
    function u(e4, t3) {
      return e4.compile().evaluate(t3);
    }
  }
  return i2.rawArgs = true, i2;
}), { isTransformFunction: true });
function dimToZeroBase(e2) {
  return isNumber$1(e2) ? e2 - 1 : isBigNumber(e2) ? e2.minus(1) : e2;
}
function isNumberOrBigNumber(e2) {
  return isNumber$1(e2) || isBigNumber(e2);
}
function lastDimToZeroBase(e2) {
  if (2 === e2.length && isCollection(e2[0])) {
    var t2 = (e2 = e2.slice())[1];
    isNumberOrBigNumber(t2) && (e2[1] = dimToZeroBase(t2));
  }
  return e2;
}
var name$i = "max", dependencies$i = ["typed", "config", "numeric", "larger", "isNaN"], createMaxTransform = factory(name$i, dependencies$i, ((e2) => {
  var { typed: t2, config: r, numeric: n, larger: i2, isNaN: a } = e2, o = createMax({ typed: t2, config: r, numeric: n, larger: i2, isNaN: a });
  return t2("max", { "...any": function(e3) {
    e3 = lastDimToZeroBase(e3);
    try {
      return o.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$h = "mean", dependencies$h = ["typed", "add", "divide"], createMeanTransform = factory(name$h, dependencies$h, ((e2) => {
  var { typed: t2, add: r, divide: n } = e2, i2 = createMean({ typed: t2, add: r, divide: n });
  return t2("mean", { "...any": function(e3) {
    e3 = lastDimToZeroBase(e3);
    try {
      return i2.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$g = "min", dependencies$g = ["typed", "config", "numeric", "smaller", "isNaN"], createMinTransform = factory(name$g, dependencies$g, ((e2) => {
  var { typed: t2, config: r, numeric: n, smaller: i2, isNaN: a } = e2, o = createMin({ typed: t2, config: r, numeric: n, smaller: i2, isNaN: a });
  return t2("min", { "...any": function(e3) {
    e3 = lastDimToZeroBase(e3);
    try {
      return o.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$f = "range", dependencies$f = ["typed", "config", "?matrix", "?bignumber", "equal", "smaller", "smallerEq", "larger", "largerEq", "add", "isZero", "isPositive"], createRangeTransform = factory(name$f, dependencies$f, ((e2) => {
  var { typed: t2, config: r, matrix: n, bignumber: i2, equal: a, smaller: o, smallerEq: s, larger: u, largerEq: c2, add: l, isZero: f2, isPositive: p } = e2, m = createRange({ typed: t2, config: r, matrix: n, bignumber: i2, equal: a, smaller: o, smallerEq: s, larger: u, largerEq: c2, add: l, isZero: f2, isPositive: p });
  return t2("range", { "...any": function(e3) {
    return "boolean" != typeof e3[e3.length - 1] && e3.push(true), m.apply(null, e3);
  } });
}), { isTransformFunction: true }), name$e = "row", dependencies$e = ["typed", "Index", "matrix", "range"], createRowTransform = factory(name$e, dependencies$e, ((e2) => {
  var { typed: t2, Index: r, matrix: n, range: i2 } = e2, a = createRow({ typed: t2, Index: r, matrix: n, range: i2 });
  return t2("row", { "...any": function(e3) {
    var t22 = e3.length - 1, r2 = e3[t22];
    isNumber$1(r2) && (e3[t22] = r2 - 1);
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$d = "subset", dependencies$d = ["typed", "matrix", "zeros", "add"], createSubsetTransform = factory(name$d, dependencies$d, ((e2) => {
  var { typed: t2, matrix: r, zeros: n, add: i2 } = e2, a = createSubset({ typed: t2, matrix: r, zeros: n, add: i2 });
  return t2("subset", { "...any": function(e3) {
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$c = "concat", dependencies$c = ["typed", "matrix", "isInteger"], createConcatTransform = factory(name$c, dependencies$c, ((e2) => {
  var { typed: t2, matrix: r, isInteger: n } = e2, i2 = createConcat({ typed: t2, matrix: r, isInteger: n });
  return t2("concat", { "...any": function(e3) {
    var t22 = e3.length - 1, r2 = e3[t22];
    isNumber$1(r2) ? e3[t22] = r2 - 1 : isBigNumber(r2) && (e3[t22] = r2.minus(1));
    try {
      return i2.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$b = "diff", dependencies$b = ["typed", "matrix", "subtract", "number", "bignumber"], createDiffTransform = factory(name$b, dependencies$b, ((e2) => {
  var { typed: t2, matrix: r, subtract: n, number: i2, bignumber: a } = e2, o = createDiff({ typed: t2, matrix: r, subtract: n, number: i2, bignumber: a });
  return t2(name$b, { "...any": function(e3) {
    e3 = lastDimToZeroBase(e3);
    try {
      return o.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$a = "std", dependencies$a = ["typed", "map", "sqrt", "variance"], createStdTransform = factory(name$a, dependencies$a, ((e2) => {
  var { typed: t2, map: r, sqrt: n, variance: i2 } = e2, a = createStd({ typed: t2, map: r, sqrt: n, variance: i2 });
  return t2("std", { "...any": function(e3) {
    e3 = lastDimToZeroBase(e3);
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$9 = "sum", dependencies$9 = ["typed", "config", "add", "numeric"], createSumTransform = factory(name$9, dependencies$9, ((e2) => {
  var { typed: t2, config: r, add: n, numeric: i2 } = e2, a = createSum({ typed: t2, config: r, add: n, numeric: i2 });
  return t2(name$9, { "...any": function(e3) {
    e3 = lastDimToZeroBase(e3);
    try {
      return a.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$8 = "quantileSeq", dependencies$8 = ["typed", "bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger", "mapSlices"], createQuantileSeqTransform = factory(name$8, dependencies$8, ((e2) => {
  var { typed: t2, bignumber: r, add: n, subtract: i2, divide: a, multiply: o, partitionSelect: s, compare: u, isInteger: c2, smaller: l, smallerEq: f2, larger: p, mapSlices: m } = e2, d = createQuantileSeq({ typed: t2, bignumber: r, add: n, subtract: i2, divide: a, multiply: o, partitionSelect: s, compare: u, isInteger: c2, smaller: l, smallerEq: f2, larger: p, mapSlices: m });
  return t2("quantileSeq", { "Array | Matrix, number | BigNumber": d, "Array | Matrix, number | BigNumber, number": (e3, t22, r2) => d(e3, t22, h(r2)), "Array | Matrix, number | BigNumber, boolean": d, "Array | Matrix, number | BigNumber, boolean, number": (e3, t22, r2, n3) => d(e3, t22, r2, h(n3)), "Array | Matrix, Array | Matrix": d, "Array | Matrix, Array | Matrix, number": (e3, t22, r2) => d(e3, t22, h(r2)), "Array | Matrix, Array | Matrix, boolean": d, "Array | Matrix, Array | Matrix, boolean, number": (e3, t22, r2, n3) => d(e3, t22, r2, h(n3)) });
  function h(e3) {
    return lastDimToZeroBase([[], e3])[1];
  }
}), { isTransformFunction: true }), name$7 = "cumsum", dependencies$7 = ["typed", "add", "unaryPlus"], createCumSumTransform = factory(name$7, dependencies$7, ((e2) => {
  var { typed: t2, add: r, unaryPlus: n } = e2, i2 = createCumSum({ typed: t2, add: r, unaryPlus: n });
  return t2(name$7, { "...any": function(e3) {
    if (2 === e3.length && isCollection(e3[0])) {
      var t22 = e3[1];
      isNumber$1(t22) ? e3[1] = t22 - 1 : isBigNumber(t22) && (e3[1] = t22.minus(1));
    }
    try {
      return i2.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$6 = "variance", dependencies$6 = ["typed", "add", "subtract", "multiply", "divide", "mapSlices", "isNaN"], createVarianceTransform = factory(name$6, dependencies$6, ((e2) => {
  var { typed: t2, add: r, subtract: n, multiply: i2, divide: a, mapSlices: o, isNaN: s } = e2, u = createVariance({ typed: t2, add: r, subtract: n, multiply: i2, divide: a, mapSlices: o, isNaN: s });
  return t2(name$6, { "...any": function(e3) {
    e3 = lastDimToZeroBase(e3);
    try {
      return u.apply(null, e3);
    } catch (e4) {
      throw errorTransform(e4);
    }
  } });
}), { isTransformFunction: true }), name$5 = "print", dependencies$5 = ["typed", "matrix", "zeros", "add"], createPrintTransform = factory(name$5, dependencies$5, ((e2) => {
  var { typed: t2, matrix: r, zeros: n, add: i2 } = e2, a = createPrint({ typed: t2, matrix: r, zeros: n, add: i2 });
  return t2(name$5, { "string, Object | Array": function(e3, t22) {
    return a(o(e3), t22);
  }, "string, Object | Array, number | Object": function(e3, t22, r2) {
    return a(o(e3), t22, r2);
  } });
  function o(e3) {
    return e3.replace(printTemplate, ((e4) => "$" + e4.slice(1).split(".").map((function(e5) {
      return !isNaN(e5) && e5.length > 0 ? parseInt(e5) - 1 : e5;
    })).join(".")));
  }
}), { isTransformFunction: true }), name$4 = "and", dependencies$4 = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], createAndTransform = factory(name$4, dependencies$4, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o } = e2, s = createAnd({ typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o });
  function u(e3, t22, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection(n3) && !s(n3, true)) return false;
    var i22 = e3[1].compile().evaluate(r2);
    return s(n3, i22);
  }
  return u.rawArgs = true, u;
}), { isTransformFunction: true }), name$3 = "or", dependencies$3 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createOrTransform = factory(name$3, dependencies$3, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a } = e2, o = createOr({ typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a });
  function s(e3, t22, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection(n3) && o(n3, false)) return true;
    var i22 = e3[1].compile().evaluate(r2);
    return o(n3, i22);
  }
  return s.rawArgs = true, s;
}), { isTransformFunction: true }), name$2 = "nullish", dependencies$2 = ["typed", "matrix", "size", "flatten", "deepEqual"], createNullishTransform = factory(name$2, dependencies$2, ((e2) => {
  var { typed: t2, matrix: r, size: n, flatten: i2, deepEqual: a } = e2, o = createNullish({ typed: t2, matrix: r, size: n, flatten: i2, deepEqual: a });
  function s(e3, t22, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection(n3) && null != n3 && void 0 !== n3) return n3;
    var i22 = e3[1].compile().evaluate(r2);
    return o(n3, i22);
  }
  return s.rawArgs = true, s;
}), { isTransformFunction: true }), name$1 = "bitAnd", dependencies$1 = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], createBitAndTransform = factory(name$1, dependencies$1, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o } = e2, s = createBitAnd({ typed: t2, matrix: r, equalScalar: n, zeros: i2, not: a, concat: o });
  function u(e3, t22, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection(n3)) {
      if (isNaN(n3)) return NaN;
      if (0 === n3 || false === n3) return 0;
    }
    var i22 = e3[1].compile().evaluate(r2);
    return s(n3, i22);
  }
  return u.rawArgs = true, u;
}), { isTransformFunction: true }), name$50 = "bitOr", dependencies = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], createBitOrTransform = factory(name$50, dependencies, ((e2) => {
  var { typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a } = e2, o = createBitOr({ typed: t2, matrix: r, equalScalar: n, DenseMatrix: i2, concat: a });
  function s(e3, t22, r2) {
    var n3 = e3[0].compile().evaluate(r2);
    if (!isCollection(n3)) {
      if (isNaN(n3)) return NaN;
      if (-1 === n3) return -1;
      if (true === n3) return 1;
    }
    var i22 = e3[1].compile().evaluate(r2);
    return o(n3, i22);
  }
  return s.rawArgs = true, s;
}), { isTransformFunction: true }), allFactories = Object.freeze({ __proto__: null, createTyped, createResultSet, createBigNumberClass, createComplexClass, createFractionClass, createRangeClass, createMatrixClass, createDenseMatrixClass, createClone, createIsInteger, createIsNegative, createIsNumeric, createHasNumericValue, createIsPositive, createIsZero, createIsNaN, createIsBounded, createIsFinite, createTypeOf, createEqualScalar, createSparseMatrixClass, createNumber, createBigint, createString, createBoolean, createBignumber, createComplex, createFraction, createMatrix, createMatrixFromFunction, createMatrixFromRows, createMatrixFromColumns, createSplitUnit, createUnaryMinus, createUnaryPlus, createAbs, createMapSlices, createAddScalar, createSubtractScalar, createCbrt, createCeil, createCube, createExp, createExpm1, createFix, createFloor, createGcd, createLcm, createLog10, createLog2, createMod, createMultiplyScalar, createMultiply, createNthRoot, createSign, createSqrt, createSquare, createSubtract, createXgcd, createInvmod, createDotMultiply, createBitAnd, createBitNot, createBitOr, createBitXor, createArg, createConj, createIm, createRe, createNot, createNullish, createOr, createXor, createConcat, createColumn, createCount, createCross, createDiag, createFilter, createFlatten, createForEach, createGetMatrixDataType, createIdentity, createKron, createMap, createDiff, createOnes, createRange, createReshape, createResize, createRotate, createRotationMatrix, createRow, createSize, createSqueeze, createSubset, createTranspose, createCtranspose, createZeros, createFft, createIfft, createSolveODE, createErf, createZeta, createMode, createProd, createFormat, createBin, createOct, createHex, createPrint, createTo, createToBest, createIsPrime, createNumeric, createDivideScalar, createPow, createRound, createLog, createLog1p, createNthRoots, createDotPow, createDotDivide, createLsolve, createUsolve, createLsolveAll, createUsolveAll, createLeftShift, createRightArithShift, createRightLogShift, createAnd, createCompare, createCompareNatural, createCompareText, createEqual, createEqualText, createSmaller, createSmallerEq, createLarger, createLargerEq, createDeepEqual, createUnequal, createPartitionSelect, createSort, createMax, createMin, createImmutableDenseMatrixClass, createIndexClass, createFibonacciHeapClass, createSpaClass, createUnitClass, createUnitFunction, createSparse, createCreateUnit, createAcos, createAcosh, createAcot, createAcoth, createAcsc, createAcsch, createAsec, createAsech, createAsin, createAsinh, createAtan, createAtan2, createAtanh, createCos, createCosh, createCot, createCoth, createCsc, createCsch, createSec, createSech, createSin, createSinh, createTan, createTanh, createSetCartesian, createSetDifference, createSetDistinct, createSetIntersect, createSetIsSubset, createSetMultiplicity, createSetPowerset, createSetSize, createSetSymDifference, createSetUnion, createAdd, createHypot, createNorm, createDot, createTrace, createIndex, createNode, createAccessorNode, createArrayNode, createAssignmentNode, createBlockNode, createConditionalNode, createConstantNode, createFunctionAssignmentNode, createIndexNode, createObjectNode, createOperatorNode, createParenthesisNode, createRangeNode, createRelationalNode, createSymbolNode, createFunctionNode, createParse, createCompile, createEvaluate, createParserClass, createParser, createLup, createQr, createSlu, createLusolve, createPolynomialRoot, createHelpClass, createChainClass, createHelp, createChain, createDet, createInv, createPinv, createEigs, createExpm, createSqrtm, createSylvester, createSchur, createLyap, createDivide, createDistance, createIntersect, createSum, createCumSum, createMean, createMedian, createMad, createVariance, createQuantileSeq, createStd, createCorr, createBernoulli, createCombinations, createCombinationsWithRep, createGamma, createLgamma, createFactorial, createKldivergence, createMultinomial, createPermutations, createPickRandom, createRandom, createRandomInt, createStirlingS2, createBellNumbers, createCatalan, createComposition, createLeafCount, createSimplify, createSimplifyConstant, createSimplifyCore, createResolve, createSymbolicEqual, createDerivative, createRationalize, createZpk2tf, createFreqz, createReviver, createReplacer, createE, createUppercaseE, createFalse, createI, createInfinity, createLN10, createLN2, createLOG10E, createLOG2E, createNaN, createNull, createPhi, createPi, createUppercasePi, createSQRT1_2, createSQRT2, createTau, createTrue, createVersion, createAtomicMass, createAvogadro, createBohrMagneton, createBohrRadius, createBoltzmann, createClassicalElectronRadius, createConductanceQuantum, createCoulomb, createCoulombConstant, createDeuteronMass, createEfimovFactor, createElectricConstant, createElectronMass, createElementaryCharge, createFaraday, createFermiCoupling, createFineStructure, createFirstRadiation, createGasConstant, createGravitationConstant, createGravity, createHartreeEnergy, createInverseConductanceQuantum, createKlitzing, createLoschmidt, createMagneticConstant, createMagneticFluxQuantum, createMolarMass, createMolarMassC12, createMolarPlanckConstant, createMolarVolume, createNeutronMass, createNuclearMagneton, createPlanckCharge, createPlanckConstant, createPlanckLength, createPlanckMass, createPlanckTemperature, createPlanckTime, createProtonMass, createQuantumOfCirculation, createReducedPlanckConstant, createRydberg, createSackurTetrode, createSecondRadiation, createSpeedOfLight, createStefanBoltzmann, createThomsonCrossSection, createVacuumImpedance, createWeakMixingAngle, createWienDisplacement, createMapSlicesTransform, createColumnTransform, createFilterTransform, createForEachTransform, createIndexTransform, createMapTransform, createMaxTransform, createMeanTransform, createMinTransform, createRangeTransform, createRowTransform, createSubsetTransform, createConcatTransform, createDiffTransform, createStdTransform, createSumTransform, createQuantileSeqTransform, createCumSumTransform, createVarianceTransform, createPrintTransform, createAndTransform, createOrTransform, createNullishTransform, createBitAndTransform, createBitOrTransform }), all = allFactories, tinyEmitter = { exports: {} }, hasRequiredTinyEmitter;
function requireTinyEmitter() {
  if (hasRequiredTinyEmitter) return tinyEmitter.exports;
  function e2() {
  }
  return hasRequiredTinyEmitter = 1, e2.prototype = { on: function(e3, t2, r) {
    var n = this.e || (this.e = {});
    return (n[e3] || (n[e3] = [])).push({ fn: t2, ctx: r }), this;
  }, once: function(e3, t2, r) {
    var n = this;
    function i2() {
      n.off(e3, i2), t2.apply(r, arguments);
    }
    return i2._ = t2, this.on(e3, i2, r);
  }, emit: function(e3) {
    for (var t2 = [].slice.call(arguments, 1), r = ((this.e || (this.e = {}))[e3] || []).slice(), n = 0, i2 = r.length; n < i2; n++) r[n].fn.apply(r[n].ctx, t2);
    return this;
  }, off: function(e3, t2) {
    var r = this.e || (this.e = {}), n = r[e3], i2 = [];
    if (n && t2) for (var a = 0, o = n.length; a < o; a++) n[a].fn !== t2 && n[a].fn._ !== t2 && i2.push(n[a]);
    return i2.length ? r[e3] = i2 : delete r[e3], this;
  } }, tinyEmitter.exports = e2, tinyEmitter.exports.TinyEmitter = e2, tinyEmitter.exports;
}
var tinyEmitterExports = requireTinyEmitter(), Emitter = getDefaultExportFromCjs$2(tinyEmitterExports);
function mixin$1(e2) {
  var t2 = new Emitter();
  return e2.on = t2.on.bind(t2), e2.off = t2.off.bind(t2), e2.once = t2.once.bind(t2), e2.emit = t2.emit.bind(t2), e2;
}
function importFactory(e2, t2, r, n) {
  function i2(t22, i22, o2) {
    var s2, u2;
    if (o2.wrap && "function" == typeof i22 && (i22 = (function(e3) {
      var t3 = function() {
        for (var t4 = [], n3 = 0, i3 = arguments.length; n3 < i3; n3++) {
          var a2 = arguments[n3];
          t4[n3] = a2 && a2.valueOf();
        }
        return e3.apply(r, t4);
      };
      e3.transform && (t3.transform = e3.transform);
      return t3;
    })(i22)), "function" == typeof (u2 = i22) && "string" == typeof u2.signature && (i22 = e2(t22, { [i22.signature]: i22 })), e2.isTypedFunction(r[t22]) && e2.isTypedFunction(i22)) return i22 = o2.override ? e2(t22, i22.signatures) : e2(r[t22], i22), r[t22] = i22, delete n[t22], a(t22, i22), void r.emit("import", t22, (function() {
      return i22;
    }));
    var c3 = void 0 !== r[t22], l2 = null === (s2 = r.Unit) || void 0 === s2 ? void 0 : s2.isValuelessUnit(t22);
    if (!c3 && !l2 || o2.override) return r[t22] = i22, delete n[t22], a(t22, i22), void r.emit("import", t22, (function() {
      return i22;
    }));
    if (!o2.silent) throw new Error('Cannot import "' + t22 + '": already exists');
  }
  function a(e3, t22) {
    t22 && "function" == typeof t22.transform ? (r.expression.transform[e3] = t22.transform, c2(e3) && (r.expression.mathWithTransform[e3] = t22.transform)) : (delete r.expression.transform[e3], c2(e3) && (r.expression.mathWithTransform[e3] = t22));
  }
  function o(e3) {
    delete r.expression.transform[e3], c2(e3) ? r.expression.mathWithTransform[e3] = r[e3] : delete r.expression.mathWithTransform[e3];
  }
  function s(t22, i22) {
    var a2, s2, u2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t22.fn;
    if (u2.includes(".")) throw new Error("Factory name should not contain a nested path. Name: " + JSON.stringify(u2));
    var c3 = l(t22) ? r.expression.transform : r, p = u2 in r.expression.transform, m = hasOwnProperty$1$1(c3, u2) ? c3[u2] : void 0, d = function() {
      var n3 = {};
      t22.dependencies.map(stripOptionalNotation).forEach(((e3) => {
        if (e3.includes(".")) throw new Error("Factory dependency should not contain a nested path. Name: " + JSON.stringify(e3));
        "math" === e3 ? n3.math = r : "mathWithTransform" === e3 ? n3.mathWithTransform = r.expression.mathWithTransform : "classes" === e3 ? n3.classes = r : n3[e3] = r[e3];
      }));
      var a3 = t22(n3);
      if (a3 && "function" == typeof a3.transform) throw new Error('Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"');
      if (void 0 === m || i22.override) return a3;
      if (e2.isTypedFunction(m) && e2.isTypedFunction(a3)) return e2(m, a3);
      if (i22.silent) return m;
      throw new Error('Cannot import "' + u2 + '": already exists');
    }, h = null !== (a2 = null === (s2 = t22.meta) || void 0 === s2 ? void 0 : s2.formerly) && void 0 !== a2 ? a2 : "", g = l(t22) || (function(e3) {
      return !(e3.fn.includes(".") || hasOwnProperty$1$1(f2, e3.fn) || e3.meta && e3.meta.isClass);
    })(t22), y = r.expression.mathWithTransform;
    t22.meta && false === t22.meta.lazy ? (c3[u2] = d(), h && (c3[h] = c3[u2]), m && p ? (o(u2), h && o(h)) : g && (lazy(y, u2, (() => c3[u2])), h && lazy(y, h, (() => c3[u2])))) : (lazy(c3, u2, d), h && lazy(c3, h, d), m && p ? (o(u2), h && o(h)) : g && (lazy(y, u2, (() => c3[u2])), h && lazy(y, h, (() => c3[u2])))), n[u2] = t22, r.emit("import", u2, d);
  }
  function u(e3) {
    return "function" == typeof e3 || "number" == typeof e3 || "string" == typeof e3 || "boolean" == typeof e3 || null === e3 || isUnit(e3) || isComplex(e3) || isBigNumber(e3) || isFraction(e3) || isMatrix(e3) || Array.isArray(e3);
  }
  function c2(e3) {
    return !hasOwnProperty$1$1(f2, e3);
  }
  function l(e3) {
    return void 0 !== e3 && void 0 !== e3.meta && true === e3.meta.isTransformFunction || false;
  }
  var f2 = { expression: true, type: true, docs: true, error: true, json: true, chain: true };
  return function(e3, t22) {
    var r2 = arguments.length;
    if (1 !== r2 && 2 !== r2) throw new ArgumentsError("import", r2, 1, 2);
    t22 || (t22 = {});
    var n3 = {};
    for (var a2 in (function e4(r3, n4, i22) {
      if (Array.isArray(n4)) n4.forEach(((t3) => e4(r3, t3)));
      else if (isObject$1(n4) || (function(e5) {
        return "object" == typeof e5 && "Module" === e5[Symbol.toStringTag];
      })(n4)) for (var a3 in n4) hasOwnProperty$1$1(n4, a3) && e4(r3, n4[a3], a3);
      else if (isFactory(n4) || void 0 !== i22) {
        var o3 = isFactory(n4) ? l(n4) ? n4.fn + ".transform" : n4.fn : i22;
        if (hasOwnProperty$1$1(r3, o3) && r3[o3] !== n4 && !t22.silent) throw new Error('Cannot import "' + o3 + '" twice');
        r3[o3] = n4;
      } else if (!t22.silent) throw new TypeError("Factory, Object, or Array expected");
    })(n3, e3), n3) if (hasOwnProperty$1$1(n3, a2)) {
      var o2 = n3[a2];
      if (isFactory(o2)) s(o2, t22);
      else if (u(o2)) i2(a2, o2, t22);
      else if (!t22.silent) throw new TypeError("Factory, Object, or Array expected");
    }
  };
}
function create$1(e2, t2) {
  var r = _extends$2({}, DEFAULT_CONFIG, t2);
  if ("function" != typeof Object.create) throw new Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");
  var n = mixin$1({ isNumber: isNumber$1, isComplex, isBigNumber, isBigInt, isFraction, isUnit, isString: isString$1, isArray: isArray$1, isMatrix, isCollection, isDenseMatrix, isSparseMatrix, isRange, isIndex, isBoolean: isBoolean$1, isResultSet, isHelp, isFunction: isFunction$2, isDate: isDate$1, isRegExp: isRegExp$1, isObject: isObject$1, isMap: isMap$1, isPartitionedMap, isObjectWrappingMap, isNull: isNull$1, isUndefined: isUndefined$1, isAccessorNode, isArrayNode, isAssignmentNode, isBlockNode, isConditionalNode, isConstantNode, isFunctionAssignmentNode, isFunctionNode, isIndexNode, isNode: isNode$1, isObjectNode, isOperatorNode, isParenthesisNode, isRangeNode, isRelationalNode, isSymbolNode, isChain });
  n.config = configFactory(r, n.emit), n.expression = { transform: {}, mathWithTransform: { config: n.config } };
  var i2 = [], a = [];
  var o = {};
  function s() {
    for (var e3 = arguments.length, t22 = new Array(e3), r2 = 0; r2 < e3; r2++) t22[r2] = arguments[r2];
    return n.typed.apply(n.typed, t22);
  }
  s.isTypedFunction = typedFunction.isTypedFunction;
  var u = importFactory(s, (function e3(t22) {
    if (isFactory(t22)) return t22(n);
    var o2 = t22[Object.keys(t22)[0]];
    if (isFactory(o2)) return o2(n);
    if (!isLegacyFactory(t22)) throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", t22), new Error("Factory object with properties `type`, `name`, and `factory` expected");
    var s2, u2 = i2.indexOf(t22);
    return -1 === u2 ? (s2 = true === t22.math ? t22.factory(n.type, r, e3, n.typed, n) : t22.factory(n.type, r, e3, n.typed), i2.push(t22), a.push(s2)) : s2 = a[u2], s2;
  }), n, o);
  return n.import = u, n.on("config", (() => {
    Object.values(o).forEach(((e3) => {
      e3 && e3.meta && e3.meta.recreateOnConfigChange && u(e3, { override: true });
    }));
  })), n.create = create$1.bind(null, e2), n.factory = factory, n.import(Object.values(deepFlatten(e2))), n.ArgumentsError = ArgumentsError, n.DimensionError = DimensionError, n.IndexError = IndexError, n;
}
var numeric1_2_6 = {}, hasRequiredNumeric1_2_6;
function requireNumeric1_2_6() {
  return hasRequiredNumeric1_2_6 || (hasRequiredNumeric1_2_6 = 1, (function(exports$1) {
    var numeric = exports$1;
    void 0 !== commonjsGlobal$1 && (commonjsGlobal$1.numeric = numeric), numeric.version = "1.2.6", numeric.bench = function(e2, t2) {
      var r, n, i2;
      for (void 0 === t2 && (t2 = 15), n = 0.5, r = /* @__PURE__ */ new Date(); ; ) {
        for (i2 = n *= 2; i2 > 3; i2 -= 4) e2(), e2(), e2(), e2();
        for (; i2 > 0; ) e2(), i2--;
        if (/* @__PURE__ */ new Date() - r > t2) break;
      }
      for (i2 = n; i2 > 3; i2 -= 4) e2(), e2(), e2(), e2();
      for (; i2 > 0; ) e2(), i2--;
      return 1e3 * (3 * n - 1) / (/* @__PURE__ */ new Date() - r);
    }, numeric._myIndexOf = function(e2) {
      var t2, r = this.length;
      for (t2 = 0; t2 < r; ++t2) if (this[t2] === e2) return t2;
      return -1;
    }, numeric.myIndexOf = Array.prototype.indexOf ? Array.prototype.indexOf : numeric._myIndexOf, numeric.Function = Function, numeric.precision = 4, numeric.largeArray = 50, numeric.prettyPrint = function(e2) {
      function t2(e3) {
        if (0 === e3) return "0";
        if (isNaN(e3)) return "NaN";
        if (e3 < 0) return "-" + t2(-e3);
        if (isFinite(e3)) {
          var r2 = Math.floor(Math.log(e3) / Math.log(10)), n = e3 / Math.pow(10, r2), i2 = n.toPrecision(numeric.precision);
          return 10 === parseFloat(i2) && (r2++, i2 = (n = 1).toPrecision(numeric.precision)), parseFloat(i2).toString() + "e" + r2.toString();
        }
        return "Infinity";
      }
      var r = [];
      return (function e3(n) {
        var i2;
        if (void 0 === n) return r.push(Array(numeric.precision + 8).join(" ")), false;
        if ("string" == typeof n) return r.push('"' + n + '"'), false;
        if ("boolean" == typeof n) return r.push(n.toString()), false;
        if ("number" == typeof n) {
          var a = t2(n), o = n.toPrecision(numeric.precision), s = parseFloat(n.toString()).toString(), u = [a, o, s, parseFloat(o).toString(), parseFloat(s).toString()];
          for (i2 = 1; i2 < u.length; i2++) u[i2].length < a.length && (a = u[i2]);
          return r.push(Array(numeric.precision + 8 - a.length).join(" ") + a), false;
        }
        if (null === n) return r.push("null"), false;
        if ("function" == typeof n) {
          r.push(n.toString());
          var c2 = false;
          for (i2 in n) n.hasOwnProperty(i2) && (c2 ? r.push(",\n") : r.push("\n{"), c2 = true, r.push(i2), r.push(": \n"), e3(n[i2]));
          return c2 && r.push("}\n"), true;
        }
        if (n instanceof Array) {
          if (n.length > numeric.largeArray) return r.push("...Large Array..."), true;
          c2 = false;
          for (r.push("["), i2 = 0; i2 < n.length; i2++) i2 > 0 && (r.push(","), c2 && r.push("\n ")), c2 = e3(n[i2]);
          return r.push("]"), true;
        }
        for (i2 in r.push("{"), c2 = false, n) n.hasOwnProperty(i2) && (c2 && r.push(",\n"), c2 = true, r.push(i2), r.push(": \n"), e3(n[i2]));
        return r.push("}"), true;
      })(e2), r.join("");
    }, numeric.parseDate = function(e2) {
      return (function e3(t2) {
        if ("string" == typeof t2) return Date.parse(t2.replace(/-/g, "/"));
        if (!(t2 instanceof Array)) throw new Error("parseDate: parameter must be arrays of strings");
        var r, n = [];
        for (r = 0; r < t2.length; r++) n[r] = e3(t2[r]);
        return n;
      })(e2);
    }, numeric.parseFloat = function(e2) {
      return (function e3(t2) {
        if ("string" == typeof t2) return parseFloat(t2);
        if (!(t2 instanceof Array)) throw new Error("parseFloat: parameter must be arrays of strings");
        var r, n = [];
        for (r = 0; r < t2.length; r++) n[r] = e3(t2[r]);
        return n;
      })(e2);
    }, numeric.parseCSV = function(e2) {
      var t2, r, n, i2 = e2.split("\n"), a = [], o = /(([^'",]*)|('[^']*')|("[^"]*")),/g, s = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/, u = 0;
      for (r = 0; r < i2.length; r++) {
        var c2, l = (i2[r] + ",").match(o);
        if (l.length > 0) {
          for (a[u] = [], t2 = 0; t2 < l.length; t2++) c2 = (n = l[t2]).substr(0, n.length - 1), s.test(c2) ? a[u][t2] = parseFloat(c2) : a[u][t2] = c2;
          u++;
        }
      }
      return a;
    }, numeric.toCSV = function(e2) {
      var t2, r, n, i2, a, o = numeric.dim(e2);
      for (n = o[0], o[1], a = [], t2 = 0; t2 < n; t2++) {
        for (i2 = [], r = 0; r < n; r++) i2[r] = e2[t2][r].toString();
        a[t2] = i2.join(", ");
      }
      return a.join("\n") + "\n";
    }, numeric.getURL = function(e2) {
      var t2 = new XMLHttpRequest();
      return t2.open("GET", e2, false), t2.send(), t2;
    }, numeric.imageURL = function(e2) {
      function t2(e3, t22, r2) {
        void 0 === t22 && (t22 = 0), void 0 === r2 && (r2 = e3.length);
        var n3, i22 = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117], a2 = -1;
        for (e3.length, n3 = t22; n3 < r2; n3++) a2 = a2 >>> 8 ^ i22[255 & (a2 ^ e3[n3])];
        return ~a2;
      }
      var r, n, i2, a, o, s, u, c2, l, f2, p = e2[0].length, m = e2[0][0].length, d = [137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, 255 & m, p >> 24 & 255, p >> 16 & 255, p >> 8 & 255, 255 & p, 8, 2, 0, 0, 0, -1, -2, -3, -4, -5, -6, -7, -8, 73, 68, 65, 84, 8, 29];
      for (f2 = t2(d, 12, 29), d[29] = f2 >> 24 & 255, d[30] = f2 >> 16 & 255, d[31] = f2 >> 8 & 255, d[32] = 255 & f2, r = 1, n = 0, u = 0; u < p; u++) {
        for (u < p - 1 ? d.push(0) : d.push(1), o = 3 * m + 1 + (0 === u) & 255, s = 3 * m + 1 + (0 === u) >> 8 & 255, d.push(o), d.push(s), d.push(255 & ~o), d.push(255 & ~s), 0 === u && d.push(0), c2 = 0; c2 < m; c2++) for (i2 = 0; i2 < 3; i2++) n = (n + (r = (r + (o = (o = e2[i2][u][c2]) > 255 ? 255 : o < 0 ? 0 : Math.round(o))) % 65521)) % 65521, d.push(o);
        d.push(0);
      }
      return l = (n << 16) + r, d.push(l >> 24 & 255), d.push(l >> 16 & 255), d.push(l >> 8 & 255), d.push(255 & l), a = d.length - 41, d[33] = a >> 24 & 255, d[34] = a >> 16 & 255, d[35] = a >> 8 & 255, d[36] = 255 & a, f2 = t2(d, 37), d.push(f2 >> 24 & 255), d.push(f2 >> 16 & 255), d.push(f2 >> 8 & 255), d.push(255 & f2), d.push(0), d.push(0), d.push(0), d.push(0), d.push(73), d.push(69), d.push(78), d.push(68), d.push(174), d.push(66), d.push(96), d.push(130), "data:image/png;base64," + (function(e3) {
        var t22, r2, n3, i22, a2, o2, s2, u2 = e3.length, c3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", l2 = "";
        for (t22 = 0; t22 < u2; t22 += 3) a2 = ((3 & (r2 = e3[t22])) << 4) + ((n3 = e3[t22 + 1]) >> 4), o2 = ((15 & n3) << 2) + ((i22 = e3[t22 + 2]) >> 6), s2 = 63 & i22, t22 + 1 >= u2 ? o2 = s2 = 64 : t22 + 2 >= u2 && (s2 = 64), l2 += c3.charAt(r2 >> 2) + c3.charAt(a2) + c3.charAt(o2) + c3.charAt(s2);
        return l2;
      })(d);
    }, numeric._dim = function(e2) {
      for (var t2 = []; "object" == typeof e2; ) t2.push(e2.length), e2 = e2[0];
      return t2;
    }, numeric.dim = function(e2) {
      var t2;
      return "object" == typeof e2 ? "object" == typeof (t2 = e2[0]) ? "object" == typeof t2[0] ? numeric._dim(e2) : [e2.length, t2.length] : [e2.length] : [];
    }, numeric.mapreduce = function(e2, t2) {
      return Function("x", "accum", "_s", "_k", 'if(typeof accum === "undefined") accum = ' + t2 + ';\nif(typeof x === "number") { var xi = x; ' + e2 + '; return accum; }\nif(typeof _s === "undefined") _s = numeric.dim(x);\nif(typeof _k === "undefined") _k = 0;\nvar _n = _s[_k];\nvar i,xi;\nif(_k < _s.length-1) {\n    for(i=_n-1;i>=0;i--) {\n        accum = arguments.callee(x[i],accum,_s,_k+1);\n    }    return accum;\n}\nfor(i=_n-1;i>=1;i-=2) { \n    xi = x[i];\n    ' + e2 + ";\n    xi = x[i-1];\n    " + e2 + ";\n}\nif(i === 0) {\n    xi = x[i];\n    " + e2 + "\n}\nreturn accum;");
    }, numeric.mapreduce2 = function(e2, t2) {
      return Function("x", "var n = x.length;\nvar i,xi;\n" + t2 + ";\nfor(i=n-1;i!==-1;--i) { \n    xi = x[i];\n    " + e2 + ";\n}\nreturn accum;");
    }, numeric.same = function e2(t2, r) {
      var n, i2;
      if (!(t2 instanceof Array && r instanceof Array)) return false;
      if ((i2 = t2.length) !== r.length) return false;
      for (n = 0; n < i2; n++) if (t2[n] !== r[n]) {
        if ("object" != typeof t2[n]) return false;
        if (!e2(t2[n], r[n])) return false;
      }
      return true;
    }, numeric.rep = function(e2, t2, r) {
      void 0 === r && (r = 0);
      var n, i2 = e2[r], a = Array(i2);
      if (r === e2.length - 1) {
        for (n = i2 - 2; n >= 0; n -= 2) a[n + 1] = t2, a[n] = t2;
        return -1 === n && (a[0] = t2), a;
      }
      for (n = i2 - 1; n >= 0; n--) a[n] = numeric.rep(e2, t2, r + 1);
      return a;
    }, numeric.dotMMsmall = function(e2, t2) {
      var r, n, i2, a, o, s, u, c2, l, f2, p;
      for (a = e2.length, o = t2.length, s = t2[0].length, u = Array(a), r = a - 1; r >= 0; r--) {
        for (c2 = Array(s), l = e2[r], i2 = s - 1; i2 >= 0; i2--) {
          for (f2 = l[o - 1] * t2[o - 1][i2], n = o - 2; n >= 1; n -= 2) p = n - 1, f2 += l[n] * t2[n][i2] + l[p] * t2[p][i2];
          0 === n && (f2 += l[0] * t2[0][i2]), c2[i2] = f2;
        }
        u[r] = c2;
      }
      return u;
    }, numeric._getCol = function(e2, t2, r) {
      var n;
      for (n = e2.length - 1; n > 0; --n) r[n] = e2[n][t2], r[--n] = e2[n][t2];
      0 === n && (r[0] = e2[0][t2]);
    }, numeric.dotMMbig = function(e2, t2) {
      var r, n, i2, a = numeric._getCol, o = t2.length, s = Array(o), u = e2.length, c2 = t2[0].length, l = new Array(u), f2 = numeric.dotVV;
      for (--o, n = --u; -1 !== n; --n) l[n] = Array(c2);
      for (n = --c2; -1 !== n; --n) for (a(t2, n, s), i2 = u; -1 !== i2; --i2) r = e2[i2], l[i2][n] = f2(r, s);
      return l;
    }, numeric.dotMV = function(e2, t2) {
      var r, n = e2.length;
      t2.length;
      var i2 = Array(n), a = numeric.dotVV;
      for (r = n - 1; r >= 0; r--) i2[r] = a(e2[r], t2);
      return i2;
    }, numeric.dotVM = function(e2, t2) {
      var r, n, i2, a, o, s, u;
      for (i2 = e2.length, a = t2[0].length, o = Array(a), n = a - 1; n >= 0; n--) {
        for (s = e2[i2 - 1] * t2[i2 - 1][n], r = i2 - 2; r >= 1; r -= 2) u = r - 1, s += e2[r] * t2[r][n] + e2[u] * t2[u][n];
        0 === r && (s += e2[0] * t2[0][n]), o[n] = s;
      }
      return o;
    }, numeric.dotVV = function(e2, t2) {
      var r, n, i2 = e2.length, a = e2[i2 - 1] * t2[i2 - 1];
      for (r = i2 - 2; r >= 1; r -= 2) n = r - 1, a += e2[r] * t2[r] + e2[n] * t2[n];
      return 0 === r && (a += e2[0] * t2[0]), a;
    }, numeric.dot = function(e2, t2) {
      var r = numeric.dim;
      switch (1e3 * r(e2).length + r(t2).length) {
        case 2002:
          return t2.length < 10 ? numeric.dotMMsmall(e2, t2) : numeric.dotMMbig(e2, t2);
        case 2001:
          return numeric.dotMV(e2, t2);
        case 1002:
          return numeric.dotVM(e2, t2);
        case 1001:
          return numeric.dotVV(e2, t2);
        case 1e3:
          return numeric.mulVS(e2, t2);
        case 1:
          return numeric.mulSV(e2, t2);
        case 0:
          return e2 * t2;
        default:
          throw new Error("numeric.dot only works on vectors and matrices");
      }
    }, numeric.diag = function(e2) {
      var t2, r, n, i2, a = e2.length, o = Array(a);
      for (t2 = a - 1; t2 >= 0; t2--) {
        for (i2 = Array(a), r = t2 + 2, n = a - 1; n >= r; n -= 2) i2[n] = 0, i2[n - 1] = 0;
        for (n > t2 && (i2[n] = 0), i2[t2] = e2[t2], n = t2 - 1; n >= 1; n -= 2) i2[n] = 0, i2[n - 1] = 0;
        0 === n && (i2[0] = 0), o[t2] = i2;
      }
      return o;
    }, numeric.getDiag = function(e2) {
      var t2, r = Math.min(e2.length, e2[0].length), n = Array(r);
      for (t2 = r - 1; t2 >= 1; --t2) n[t2] = e2[t2][t2], n[--t2] = e2[t2][t2];
      return 0 === t2 && (n[0] = e2[0][0]), n;
    }, numeric.identity = function(e2) {
      return numeric.diag(numeric.rep([e2], 1));
    }, numeric.pointwise = function(e2, t2, r) {
      void 0 === r && (r = "");
      var n, i2, a = [], o = /\[i\]$/, s = "", u = false;
      for (n = 0; n < e2.length; n++) o.test(e2[n]) ? s = i2 = e2[n].substring(0, e2[n].length - 3) : i2 = e2[n], "ret" === i2 && (u = true), a.push(i2);
      return a[e2.length] = "_s", a[e2.length + 1] = "_k", a[e2.length + 2] = 'if(typeof _s === "undefined") _s = numeric.dim(' + s + ');\nif(typeof _k === "undefined") _k = 0;\nvar _n = _s[_k];\nvar i' + (u ? "" : ", ret = Array(_n)") + ";\nif(_k < _s.length-1) {\n    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee(" + e2.join(",") + ",_s,_k+1);\n    return ret;\n}\n" + r + "\nfor(i=_n-1;i!==-1;--i) {\n    " + t2 + "\n}\nreturn ret;", Function.apply(null, a);
    }, numeric.pointwise2 = function(e2, t2, r) {
      void 0 === r && (r = "");
      var n, i2, a = [], o = /\[i\]$/, s = "", u = false;
      for (n = 0; n < e2.length; n++) o.test(e2[n]) ? s = i2 = e2[n].substring(0, e2[n].length - 3) : i2 = e2[n], "ret" === i2 && (u = true), a.push(i2);
      return a[e2.length] = "var _n = " + s + ".length;\nvar i" + (u ? "" : ", ret = Array(_n)") + ";\n" + r + "\nfor(i=_n-1;i!==-1;--i) {\n" + t2 + "\n}\nreturn ret;", Function.apply(null, a);
    }, numeric._biforeach = function e2(t2, r, n, i2, a) {
      var o;
      if (i2 !== n.length - 1) for (o = n[i2] - 1; o >= 0; o--) e2("object" == typeof t2 ? t2[o] : t2, "object" == typeof r ? r[o] : r, n, i2 + 1, a);
      else a(t2, r);
    }, numeric._biforeach2 = function e2(t2, r, n, i2, a) {
      if (i2 === n.length - 1) return a(t2, r);
      var o, s = n[i2], u = Array(s);
      for (o = s - 1; o >= 0; --o) u[o] = e2("object" == typeof t2 ? t2[o] : t2, "object" == typeof r ? r[o] : r, n, i2 + 1, a);
      return u;
    }, numeric._foreach = function e2(t2, r, n, i2) {
      var a;
      if (n !== r.length - 1) for (a = r[n] - 1; a >= 0; a--) e2(t2[a], r, n + 1, i2);
      else i2(t2);
    }, numeric._foreach2 = function e2(t2, r, n, i2) {
      if (n === r.length - 1) return i2(t2);
      var a, o = r[n], s = Array(o);
      for (a = o - 1; a >= 0; a--) s[a] = e2(t2[a], r, n + 1, i2);
      return s;
    }, numeric.ops2 = { add: "+", sub: "-", mul: "*", div: "/", mod: "%", and: "&&", or: "||", eq: "===", neq: "!==", lt: "<", gt: ">", leq: "<=", geq: ">=", band: "&", bor: "|", bxor: "^", lshift: "<<", rshift: ">>", rrshift: ">>>" }, numeric.opseq = { addeq: "+=", subeq: "-=", muleq: "*=", diveq: "/=", modeq: "%=", lshifteq: "<<=", rshifteq: ">>=", rrshifteq: ">>>=", bandeq: "&=", boreq: "|=", bxoreq: "^=" }, numeric.mathfuns = ["abs", "acos", "asin", "atan", "ceil", "cos", "exp", "floor", "log", "round", "sin", "sqrt", "tan", "isNaN", "isFinite"], numeric.mathfuns2 = ["atan2", "pow", "max", "min"], numeric.ops1 = { neg: "-", not: "!", bnot: "~", clone: "" }, numeric.mapreducers = { any: ["if(xi) return true;", "var accum = false;"], all: ["if(!xi) return false;", "var accum = true;"], sum: ["accum += xi;", "var accum = 0;"], prod: ["accum *= xi;", "var accum = 1;"], norm2Squared: ["accum += xi*xi;", "var accum = 0;"], norminf: ["accum = max(accum,abs(xi));", "var accum = 0, max = Math.max, abs = Math.abs;"], norm1: ["accum += abs(xi)", "var accum = 0, abs = Math.abs;"], sup: ["accum = max(accum,xi);", "var accum = -Infinity, max = Math.max;"], inf: ["accum = min(accum,xi);", "var accum = Infinity, min = Math.min;"] }, (function() {
      var e2, t2;
      for (e2 = 0; e2 < numeric.mathfuns2.length; ++e2) t2 = numeric.mathfuns2[e2], numeric.ops2[t2] = t2;
      for (e2 in numeric.ops2) if (numeric.ops2.hasOwnProperty(e2)) {
        t2 = numeric.ops2[e2];
        var r, n, i2 = "";
        -1 !== numeric.myIndexOf.call(numeric.mathfuns2, e2) ? (i2 = "var " + t2 + " = Math." + t2 + ";\n", r = function(e3, r2, n3) {
          return e3 + " = " + t2 + "(" + r2 + "," + n3 + ")";
        }, n = function(e3, r2) {
          return e3 + " = " + t2 + "(" + e3 + "," + r2 + ")";
        }) : (r = function(e3, r2, n3) {
          return e3 + " = " + r2 + " " + t2 + " " + n3;
        }, n = numeric.opseq.hasOwnProperty(e2 + "eq") ? function(e3, r2) {
          return e3 + " " + t2 + "= " + r2;
        } : function(e3, r2) {
          return e3 + " = " + e3 + " " + t2 + " " + r2;
        }), numeric[e2 + "VV"] = numeric.pointwise2(["x[i]", "y[i]"], r("ret[i]", "x[i]", "y[i]"), i2), numeric[e2 + "SV"] = numeric.pointwise2(["x", "y[i]"], r("ret[i]", "x", "y[i]"), i2), numeric[e2 + "VS"] = numeric.pointwise2(["x[i]", "y"], r("ret[i]", "x[i]", "y"), i2), numeric[e2] = Function("var n = arguments.length, i, x = arguments[0], y;\nvar VV = numeric." + e2 + "VV, VS = numeric." + e2 + "VS, SV = numeric." + e2 + 'SV;\nvar dim = numeric.dim;\nfor(i=1;i!==n;++i) { \n  y = arguments[i];\n  if(typeof x === "object") {\n      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);\n      else x = numeric._biforeach2(x,y,dim(x),0,VS);\n  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);\n  else ' + n("x", "y") + "\n}\nreturn x;\n"), numeric[t2] = numeric[e2], numeric[e2 + "eqV"] = numeric.pointwise2(["ret[i]", "x[i]"], n("ret[i]", "x[i]"), i2), numeric[e2 + "eqS"] = numeric.pointwise2(["ret[i]", "x"], n("ret[i]", "x"), i2), numeric[e2 + "eq"] = Function("var n = arguments.length, i, x = arguments[0], y;\nvar V = numeric." + e2 + "eqV, S = numeric." + e2 + 'eqS\nvar s = numeric.dim(x);\nfor(i=1;i!==n;++i) { \n  y = arguments[i];\n  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);\n  else numeric._biforeach(x,y,s,0,S);\n}\nreturn x;\n');
      }
      for (e2 = 0; e2 < numeric.mathfuns2.length; ++e2) t2 = numeric.mathfuns2[e2], delete numeric.ops2[t2];
      for (e2 = 0; e2 < numeric.mathfuns.length; ++e2) t2 = numeric.mathfuns[e2], numeric.ops1[t2] = t2;
      for (e2 in numeric.ops1) numeric.ops1.hasOwnProperty(e2) && (i2 = "", t2 = numeric.ops1[e2], -1 !== numeric.myIndexOf.call(numeric.mathfuns, e2) && Math.hasOwnProperty(t2) && (i2 = "var " + t2 + " = Math." + t2 + ";\n"), numeric[e2 + "eqV"] = numeric.pointwise2(["ret[i]"], "ret[i] = " + t2 + "(ret[i]);", i2), numeric[e2 + "eq"] = Function("x", 'if(typeof x !== "object") return ' + t2 + "x\nvar i;\nvar V = numeric." + e2 + "eqV;\nvar s = numeric.dim(x);\nnumeric._foreach(x,s,0,V);\nreturn x;\n"), numeric[e2 + "V"] = numeric.pointwise2(["x[i]"], "ret[i] = " + t2 + "(x[i]);", i2), numeric[e2] = Function("x", 'if(typeof x !== "object") return ' + t2 + "(x)\nvar i;\nvar V = numeric." + e2 + "V;\nvar s = numeric.dim(x);\nreturn numeric._foreach2(x,s,0,V);\n"));
      for (e2 = 0; e2 < numeric.mathfuns.length; ++e2) t2 = numeric.mathfuns[e2], delete numeric.ops1[t2];
      for (e2 in numeric.mapreducers) numeric.mapreducers.hasOwnProperty(e2) && (t2 = numeric.mapreducers[e2], numeric[e2 + "V"] = numeric.mapreduce2(t2[0], t2[1]), numeric[e2] = Function("x", "s", "k", t2[1] + 'if(typeof x !== "object") {    xi = x;\n' + t2[0] + ';\n    return accum;\n}if(typeof s === "undefined") s = numeric.dim(x);\nif(typeof k === "undefined") k = 0;\nif(k === s.length-1) return numeric.' + e2 + "V(x);\nvar xi;\nvar n = x.length, i;\nfor(i=n-1;i!==-1;--i) {\n   xi = arguments.callee(x[i]);\n" + t2[0] + ";\n}\nreturn accum;\n"));
    })(), numeric.truncVV = numeric.pointwise(["x[i]", "y[i]"], "ret[i] = round(x[i]/y[i])*y[i];", "var round = Math.round;"), numeric.truncVS = numeric.pointwise(["x[i]", "y"], "ret[i] = round(x[i]/y)*y;", "var round = Math.round;"), numeric.truncSV = numeric.pointwise(["x", "y[i]"], "ret[i] = round(x/y[i])*y[i];", "var round = Math.round;"), numeric.trunc = function(e2, t2) {
      return "object" == typeof e2 ? "object" == typeof t2 ? numeric.truncVV(e2, t2) : numeric.truncVS(e2, t2) : "object" == typeof t2 ? numeric.truncSV(e2, t2) : Math.round(e2 / t2) * t2;
    }, numeric.inv = function(e2) {
      var t2, r, n, i2, a, o, s, u = numeric.dim(e2), c2 = Math.abs, l = u[0], f2 = u[1], p = numeric.clone(e2), m = numeric.identity(l);
      for (o = 0; o < f2; ++o) {
        var d = -1, h = -1;
        for (a = o; a !== l; ++a) (s = c2(p[a][o])) > h && (d = a, h = s);
        for (r = p[d], p[d] = p[o], p[o] = r, i2 = m[d], m[d] = m[o], m[o] = i2, e2 = r[o], s = o; s !== f2; ++s) r[s] /= e2;
        for (s = f2 - 1; -1 !== s; --s) i2[s] /= e2;
        for (a = l - 1; -1 !== a; --a) if (a !== o) {
          for (t2 = p[a], n = m[a], e2 = t2[o], s = o + 1; s !== f2; ++s) t2[s] -= r[s] * e2;
          for (s = f2 - 1; s > 0; --s) n[s] -= i2[s] * e2, n[--s] -= i2[s] * e2;
          0 === s && (n[0] -= i2[0] * e2);
        }
      }
      return m;
    }, numeric.det = function(e2) {
      var t2 = numeric.dim(e2);
      if (2 !== t2.length || t2[0] !== t2[1]) throw new Error("numeric: det() only works on square matrices");
      var r, n, i2, a, o, s, u, c2, l = t2[0], f2 = 1, p = numeric.clone(e2);
      for (n = 0; n < l - 1; n++) {
        for (i2 = n, r = n + 1; r < l; r++) Math.abs(p[r][n]) > Math.abs(p[i2][n]) && (i2 = r);
        for (i2 !== n && (u = p[i2], p[i2] = p[n], p[n] = u, f2 *= -1), a = p[n], r = n + 1; r < l; r++) {
          for (s = (o = p[r])[n] / a[n], i2 = n + 1; i2 < l - 1; i2 += 2) c2 = i2 + 1, o[i2] -= a[i2] * s, o[c2] -= a[c2] * s;
          i2 !== l && (o[i2] -= a[i2] * s);
        }
        if (0 === a[n]) return 0;
        f2 *= a[n];
      }
      return f2 * p[n][n];
    }, numeric.transpose = function(e2) {
      var t2, r, n, i2, a, o = e2.length, s = e2[0].length, u = Array(s);
      for (r = 0; r < s; r++) u[r] = Array(o);
      for (t2 = o - 1; t2 >= 1; t2 -= 2) {
        for (i2 = e2[t2], n = e2[t2 - 1], r = s - 1; r >= 1; --r) (a = u[r])[t2] = i2[r], a[t2 - 1] = n[r], (a = u[--r])[t2] = i2[r], a[t2 - 1] = n[r];
        0 === r && ((a = u[0])[t2] = i2[0], a[t2 - 1] = n[0]);
      }
      if (0 === t2) {
        for (n = e2[0], r = s - 1; r >= 1; --r) u[r][0] = n[r], u[--r][0] = n[r];
        0 === r && (u[0][0] = n[0]);
      }
      return u;
    }, numeric.negtranspose = function(e2) {
      var t2, r, n, i2, a, o = e2.length, s = e2[0].length, u = Array(s);
      for (r = 0; r < s; r++) u[r] = Array(o);
      for (t2 = o - 1; t2 >= 1; t2 -= 2) {
        for (i2 = e2[t2], n = e2[t2 - 1], r = s - 1; r >= 1; --r) (a = u[r])[t2] = -i2[r], a[t2 - 1] = -n[r], (a = u[--r])[t2] = -i2[r], a[t2 - 1] = -n[r];
        0 === r && ((a = u[0])[t2] = -i2[0], a[t2 - 1] = -n[0]);
      }
      if (0 === t2) {
        for (n = e2[0], r = s - 1; r >= 1; --r) u[r][0] = -n[r], u[--r][0] = -n[r];
        0 === r && (u[0][0] = -n[0]);
      }
      return u;
    }, numeric._random = function e2(t2, r) {
      var n, i2, a = t2[r], o = Array(a);
      if (r === t2.length - 1) {
        for (i2 = Math.random, n = a - 1; n >= 1; n -= 2) o[n] = i2(), o[n - 1] = i2();
        return 0 === n && (o[0] = i2()), o;
      }
      for (n = a - 1; n >= 0; n--) o[n] = e2(t2, r + 1);
      return o;
    }, numeric.random = function(e2) {
      return numeric._random(e2, 0);
    }, numeric.norm2 = function(e2) {
      return Math.sqrt(numeric.norm2Squared(e2));
    }, numeric.linspace = function(e2, t2, r) {
      if (void 0 === r && (r = Math.max(Math.round(t2 - e2) + 1, 1)), r < 2) return 1 === r ? [e2] : [];
      var n, i2 = Array(r);
      for (n = --r; n >= 0; n--) i2[n] = (n * t2 + (r - n) * e2) / r;
      return i2;
    }, numeric.getBlock = function(e2, t2, r) {
      var n = numeric.dim(e2);
      return (function e3(i2, a) {
        var o, s = t2[a], u = r[a] - s, c2 = Array(u);
        if (a === n.length - 1) {
          for (o = u; o >= 0; o--) c2[o] = i2[o + s];
          return c2;
        }
        for (o = u; o >= 0; o--) c2[o] = e3(i2[o + s], a + 1);
        return c2;
      })(e2, 0);
    }, numeric.setBlock = function(e2, t2, r, n) {
      var i2 = numeric.dim(e2);
      return (function e3(n3, a, o) {
        var s, u = t2[o], c2 = r[o] - u;
        if (o === i2.length - 1) for (s = c2; s >= 0; s--) n3[s + u] = a[s];
        for (s = c2; s >= 0; s--) e3(n3[s + u], a[s], o + 1);
      })(e2, n, 0), e2;
    }, numeric.getRange = function(e2, t2, r) {
      var n, i2, a, o, s = t2.length, u = r.length, c2 = Array(s);
      for (n = s - 1; -1 !== n; --n) for (c2[n] = Array(u), a = c2[n], o = e2[t2[n]], i2 = u - 1; -1 !== i2; --i2) a[i2] = o[r[i2]];
      return c2;
    }, numeric.blockMatrix = function(e2) {
      var t2 = numeric.dim(e2);
      if (t2.length < 4) return numeric.blockMatrix([e2]);
      var r, n, i2, a, o, s = t2[0], u = t2[1];
      for (r = 0, n = 0, i2 = 0; i2 < s; ++i2) r += e2[i2][0].length;
      for (a = 0; a < u; ++a) n += e2[0][a][0].length;
      var c2 = Array(r);
      for (i2 = 0; i2 < r; ++i2) c2[i2] = Array(n);
      var l, f2, p, m, d, h = 0;
      for (i2 = 0; i2 < s; ++i2) {
        for (l = n, a = u - 1; -1 !== a; --a) for (l -= (o = e2[i2][a])[0].length, p = o.length - 1; -1 !== p; --p) for (d = o[p], f2 = c2[h + p], m = d.length - 1; -1 !== m; --m) f2[l + m] = d[m];
        h += e2[i2][0].length;
      }
      return c2;
    }, numeric.tensor = function(e2, t2) {
      if ("number" == typeof e2 || "number" == typeof t2) return numeric.mul(e2, t2);
      var r = numeric.dim(e2), n = numeric.dim(t2);
      if (1 !== r.length || 1 !== n.length) throw new Error("numeric: tensor product is only defined for vectors");
      var i2, a, o, s, u = r[0], c2 = n[0], l = Array(u);
      for (a = u - 1; a >= 0; a--) {
        for (i2 = Array(c2), s = e2[a], o = c2 - 1; o >= 3; --o) i2[o] = s * t2[o], i2[--o] = s * t2[o], i2[--o] = s * t2[o], i2[--o] = s * t2[o];
        for (; o >= 0; ) i2[o] = s * t2[o], --o;
        l[a] = i2;
      }
      return l;
    }, numeric.T = function(e2, t2) {
      this.x = e2, this.y = t2;
    }, numeric.t = function(e2, t2) {
      return new numeric.T(e2, t2);
    }, numeric.Tbinop = function(e2, t2, r, n, i2) {
      var a;
      if (numeric.indexOf, "string" != typeof i2) for (a in i2 = "", numeric) numeric.hasOwnProperty(a) && (e2.indexOf(a) >= 0 || t2.indexOf(a) >= 0 || r.indexOf(a) >= 0 || n.indexOf(a) >= 0) && a.length > 1 && (i2 += "var " + a + " = numeric." + a + ";\n");
      return Function(["y"], "var x = this;\nif(!(y instanceof numeric.T)) { y = new numeric.T(y); }\n" + i2 + "\nif(x.y) {  if(y.y) {    return new numeric.T(" + n + ");\n  }\n  return new numeric.T(" + r + ");\n}\nif(y.y) {\n  return new numeric.T(" + t2 + ");\n}\nreturn new numeric.T(" + e2 + ");\n");
    }, numeric.T.prototype.add = numeric.Tbinop("add(x.x,y.x)", "add(x.x,y.x),y.y", "add(x.x,y.x),x.y", "add(x.x,y.x),add(x.y,y.y)"), numeric.T.prototype.sub = numeric.Tbinop("sub(x.x,y.x)", "sub(x.x,y.x),neg(y.y)", "sub(x.x,y.x),x.y", "sub(x.x,y.x),sub(x.y,y.y)"), numeric.T.prototype.mul = numeric.Tbinop("mul(x.x,y.x)", "mul(x.x,y.x),mul(x.x,y.y)", "mul(x.x,y.x),mul(x.y,y.x)", "sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))"), numeric.T.prototype.reciprocal = function() {
      var e2 = numeric.mul, t2 = numeric.div;
      if (this.y) {
        var r = numeric.add(e2(this.x, this.x), e2(this.y, this.y));
        return new numeric.T(t2(this.x, r), t2(numeric.neg(this.y), r));
      }
      return new T(t2(1, this.x));
    }, numeric.T.prototype.div = function(e2) {
      if (e2 instanceof numeric.T || (e2 = new numeric.T(e2)), e2.y) return this.mul(e2.reciprocal());
      var t2 = numeric.div;
      return this.y ? new numeric.T(t2(this.x, e2.x), t2(this.y, e2.x)) : new numeric.T(t2(this.x, e2.x));
    }, numeric.T.prototype.dot = numeric.Tbinop("dot(x.x,y.x)", "dot(x.x,y.x),dot(x.x,y.y)", "dot(x.x,y.x),dot(x.y,y.x)", "sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))"), numeric.T.prototype.transpose = function() {
      var e2 = numeric.transpose, t2 = this.x, r = this.y;
      return r ? new numeric.T(e2(t2), e2(r)) : new numeric.T(e2(t2));
    }, numeric.T.prototype.transjugate = function() {
      var e2 = numeric.transpose, t2 = this.x, r = this.y;
      return r ? new numeric.T(e2(t2), numeric.negtranspose(r)) : new numeric.T(e2(t2));
    }, numeric.Tunop = function(e2, t2, r) {
      return "string" != typeof r && (r = ""), Function("var x = this;\n" + r + "\nif(x.y) {  " + t2 + ";\n}\n" + e2 + ";\n");
    }, numeric.T.prototype.exp = numeric.Tunop("return new numeric.T(ex)", "return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))", "var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;"), numeric.T.prototype.conj = numeric.Tunop("return new numeric.T(x.x);", "return new numeric.T(x.x,numeric.neg(x.y));"), numeric.T.prototype.neg = numeric.Tunop("return new numeric.T(neg(x.x));", "return new numeric.T(neg(x.x),neg(x.y));", "var neg = numeric.neg;"), numeric.T.prototype.sin = numeric.Tunop("return new numeric.T(numeric.sin(x.x))", "return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));"), numeric.T.prototype.cos = numeric.Tunop("return new numeric.T(numeric.cos(x.x))", "return x.exp().add(x.neg().exp()).div(2);"), numeric.T.prototype.abs = numeric.Tunop("return new numeric.T(numeric.abs(x.x));", "return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));", "var mul = numeric.mul;"), numeric.T.prototype.log = numeric.Tunop("return new numeric.T(numeric.log(x.x));", "var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();\nreturn new numeric.T(numeric.log(r.x),theta.x);"), numeric.T.prototype.norm2 = numeric.Tunop("return numeric.norm2(x.x);", "var f = numeric.norm2Squared;\nreturn Math.sqrt(f(x.x)+f(x.y));"), numeric.T.prototype.inv = function() {
      var e2 = this;
      if (void 0 === e2.y) return new numeric.T(numeric.inv(e2.x));
      var t2, r, n, i2, a, o, s, u, c2, l, f2, p, m, d, h, g, y, v2, x2 = e2.x.length, b2 = numeric.identity(x2), _2 = numeric.rep([x2, x2], 0), w2 = numeric.clone(e2.x), A2 = numeric.clone(e2.y);
      for (c2 = 0; c2 < x2; c2++) {
        for (p = (d = w2[c2][c2]) * d + (h = A2[c2][c2]) * h, f2 = c2, l = c2 + 1; l < x2; l++) (m = (d = w2[l][c2]) * d + (h = A2[l][c2]) * h) > p && (f2 = l, p = m);
        for (f2 !== c2 && (v2 = w2[c2], w2[c2] = w2[f2], w2[f2] = v2, v2 = A2[c2], A2[c2] = A2[f2], A2[f2] = v2, v2 = b2[c2], b2[c2] = b2[f2], b2[f2] = v2, v2 = _2[c2], _2[c2] = _2[f2], _2[f2] = v2), t2 = w2[c2], r = A2[c2], a = b2[c2], o = _2[c2], d = t2[c2], h = r[c2], l = c2 + 1; l < x2; l++) g = t2[l], y = r[l], t2[l] = (g * d + y * h) / p, r[l] = (y * d - g * h) / p;
        for (l = 0; l < x2; l++) g = a[l], y = o[l], a[l] = (g * d + y * h) / p, o[l] = (y * d - g * h) / p;
        for (l = c2 + 1; l < x2; l++) {
          for (n = w2[l], i2 = A2[l], s = b2[l], u = _2[l], d = n[c2], h = i2[c2], f2 = c2 + 1; f2 < x2; f2++) g = t2[f2], y = r[f2], n[f2] -= g * d - y * h, i2[f2] -= y * d + g * h;
          for (f2 = 0; f2 < x2; f2++) g = a[f2], y = o[f2], s[f2] -= g * d - y * h, u[f2] -= y * d + g * h;
        }
      }
      for (c2 = x2 - 1; c2 > 0; c2--) for (a = b2[c2], o = _2[c2], l = c2 - 1; l >= 0; l--) for (s = b2[l], u = _2[l], d = w2[l][c2], h = A2[l][c2], f2 = x2 - 1; f2 >= 0; f2--) g = a[f2], y = o[f2], s[f2] -= d * g - h * y, u[f2] -= d * y + h * g;
      return new numeric.T(b2, _2);
    }, numeric.T.prototype.get = function(e2) {
      var t2, r = this.x, n = this.y, i2 = 0, a = e2.length;
      if (n) {
        for (; i2 < a; ) r = r[t2 = e2[i2]], n = n[t2], i2++;
        return new numeric.T(r, n);
      }
      for (; i2 < a; ) r = r[t2 = e2[i2]], i2++;
      return new numeric.T(r);
    }, numeric.T.prototype.set = function(e2, t2) {
      var r, n = this.x, i2 = this.y, a = 0, o = e2.length, s = t2.x, u = t2.y;
      if (0 === o) return u ? this.y = u : i2 && (this.y = void 0), this.x = n, this;
      if (u) {
        for (i2 || (i2 = numeric.rep(numeric.dim(n), 0), this.y = i2); a < o - 1; ) n = n[r = e2[a]], i2 = i2[r], a++;
        return n[r = e2[a]] = s, i2[r] = u, this;
      }
      if (i2) {
        for (; a < o - 1; ) n = n[r = e2[a]], i2 = i2[r], a++;
        return n[r = e2[a]] = s, i2[r] = s instanceof Array ? numeric.rep(numeric.dim(s), 0) : 0, this;
      }
      for (; a < o - 1; ) n = n[r = e2[a]], a++;
      return n[r = e2[a]] = s, this;
    }, numeric.T.prototype.getRows = function(e2, t2) {
      var r, n, i2 = t2 - e2 + 1, a = Array(i2), o = this.x, s = this.y;
      for (r = e2; r <= t2; r++) a[r - e2] = o[r];
      if (s) {
        for (n = Array(i2), r = e2; r <= t2; r++) n[r - e2] = s[r];
        return new numeric.T(a, n);
      }
      return new numeric.T(a);
    }, numeric.T.prototype.setRows = function(e2, t2, r) {
      var n, i2 = this.x, a = this.y, o = r.x, s = r.y;
      for (n = e2; n <= t2; n++) i2[n] = o[n - e2];
      if (s) for (a || (a = numeric.rep(numeric.dim(i2), 0), this.y = a), n = e2; n <= t2; n++) a[n] = s[n - e2];
      else if (a) for (n = e2; n <= t2; n++) a[n] = numeric.rep([o[n - e2].length], 0);
      return this;
    }, numeric.T.prototype.getRow = function(e2) {
      var t2 = this.x, r = this.y;
      return r ? new numeric.T(t2[e2], r[e2]) : new numeric.T(t2[e2]);
    }, numeric.T.prototype.setRow = function(e2, t2) {
      var r = this.x, n = this.y, i2 = t2.x, a = t2.y;
      return r[e2] = i2, a ? (n || (n = numeric.rep(numeric.dim(r), 0), this.y = n), n[e2] = a) : n && (n = numeric.rep([i2.length], 0)), this;
    }, numeric.T.prototype.getBlock = function(e2, t2) {
      var r = this.x, n = this.y, i2 = numeric.getBlock;
      return n ? new numeric.T(i2(r, e2, t2), i2(n, e2, t2)) : new numeric.T(i2(r, e2, t2));
    }, numeric.T.prototype.setBlock = function(e2, t2, r) {
      r instanceof numeric.T || (r = new numeric.T(r));
      var n = this.x, i2 = this.y, a = numeric.setBlock, o = r.x, s = r.y;
      if (s) return i2 || (this.y = numeric.rep(numeric.dim(this), 0), i2 = this.y), a(n, e2, t2, o), a(i2, e2, t2, s), this;
      a(n, e2, t2, o), i2 && a(i2, e2, t2, numeric.rep(numeric.dim(o), 0));
    }, numeric.T.rep = function(e2, t2) {
      var r = numeric.T;
      t2 instanceof r || (t2 = new r(t2));
      var n = t2.x, i2 = t2.y, a = numeric.rep;
      return i2 ? new r(a(e2, n), a(e2, i2)) : new r(a(e2, n));
    }, numeric.T.diag = function(e2) {
      e2 instanceof numeric.T || (e2 = new numeric.T(e2));
      var t2 = e2.x, r = e2.y, n = numeric.diag;
      return r ? new numeric.T(n(t2), n(r)) : new numeric.T(n(t2));
    }, numeric.T.eig = function() {
      if (this.y) throw new Error("eig: not implemented for complex matrices.");
      return numeric.eig(this.x);
    }, numeric.T.identity = function(e2) {
      return new numeric.T(numeric.identity(e2));
    }, numeric.T.prototype.getDiag = function() {
      var e2 = numeric, t2 = this.x, r = this.y;
      return r ? new e2.T(e2.getDiag(t2), e2.getDiag(r)) : new e2.T(e2.getDiag(t2));
    }, numeric.house = function(e2) {
      var t2 = numeric.clone(e2), r = (e2[0] >= 0 ? 1 : -1) * numeric.norm2(e2);
      t2[0] += r;
      var n = numeric.norm2(t2);
      if (0 === n) throw new Error("eig: internal error");
      return numeric.div(t2, n);
    }, numeric.toUpperHessenberg = function(e2) {
      var t2 = numeric.dim(e2);
      if (2 !== t2.length || t2[0] !== t2[1]) throw new Error("numeric: toUpperHessenberg() only works on square matrices");
      var r, n, i2, a, o, s, u, c2, l, f2, p = t2[0], m = numeric.clone(e2), d = numeric.identity(p);
      for (n = 0; n < p - 2; n++) {
        for (a = Array(p - n - 1), r = n + 1; r < p; r++) a[r - n - 1] = m[r][n];
        if (numeric.norm2(a) > 0) {
          for (o = numeric.house(a), s = numeric.getBlock(m, [n + 1, n], [p - 1, p - 1]), u = numeric.tensor(o, numeric.dot(o, s)), r = n + 1; r < p; r++) for (c2 = m[r], l = u[r - n - 1], i2 = n; i2 < p; i2++) c2[i2] -= 2 * l[i2 - n];
          for (s = numeric.getBlock(m, [0, n + 1], [p - 1, p - 1]), u = numeric.tensor(numeric.dot(s, o), o), r = 0; r < p; r++) for (c2 = m[r], l = u[r], i2 = n + 1; i2 < p; i2++) c2[i2] -= 2 * l[i2 - n - 1];
          for (s = Array(p - n - 1), r = n + 1; r < p; r++) s[r - n - 1] = d[r];
          for (u = numeric.tensor(o, numeric.dot(o, s)), r = n + 1; r < p; r++) for (f2 = d[r], l = u[r - n - 1], i2 = 0; i2 < p; i2++) f2[i2] -= 2 * l[i2];
        }
      }
      return { H: m, Q: d };
    }, numeric.epsilon = 2220446049250313e-31, numeric.QRFrancis = function(e2, t2) {
      void 0 === t2 && (t2 = 1e4), e2 = numeric.clone(e2), numeric.clone(e2);
      var r, n, i2, a, o, s, u, c2, l, f2, p, m, d, h, g, y, v2, x2, b2 = numeric.dim(e2)[0], _2 = numeric.identity(b2);
      if (b2 < 3) return { Q: _2, B: [[0, b2 - 1]] };
      var w2 = numeric.epsilon;
      for (x2 = 0; x2 < t2; x2++) {
        for (y = 0; y < b2 - 1; y++) if (Math.abs(e2[y + 1][y]) < w2 * (Math.abs(e2[y][y]) + Math.abs(e2[y + 1][y + 1]))) {
          var A2 = numeric.QRFrancis(numeric.getBlock(e2, [0, 0], [y, y]), t2), N = numeric.QRFrancis(numeric.getBlock(e2, [y + 1, y + 1], [b2 - 1, b2 - 1]), t2);
          for (m = Array(y + 1), g = 0; g <= y; g++) m[g] = _2[g];
          for (d = numeric.dot(A2.Q, m), g = 0; g <= y; g++) _2[g] = d[g];
          for (m = Array(b2 - y - 1), g = y + 1; g < b2; g++) m[g - y - 1] = _2[g];
          for (d = numeric.dot(N.Q, m), g = y + 1; g < b2; g++) _2[g] = d[g - y - 1];
          return { Q: _2, B: A2.B.concat(numeric.add(N.B, y + 1)) };
        }
        var D, E, $2;
        if (i2 = e2[b2 - 2][b2 - 2], a = e2[b2 - 2][b2 - 1], o = e2[b2 - 1][b2 - 2], c2 = i2 + (s = e2[b2 - 1][b2 - 1]), u = i2 * s - a * o, l = numeric.getBlock(e2, [0, 0], [2, 2]), c2 * c2 >= 4 * u) D = 0.5 * (c2 + Math.sqrt(c2 * c2 - 4 * u)), E = 0.5 * (c2 - Math.sqrt(c2 * c2 - 4 * u)), l = numeric.add(numeric.sub(numeric.dot(l, l), numeric.mul(l, D + E)), numeric.diag(numeric.rep([3], D * E)));
        else l = numeric.add(numeric.sub(numeric.dot(l, l), numeric.mul(l, c2)), numeric.diag(numeric.rep([3], u)));
        for (r = [l[0][0], l[1][0], l[2][0]], n = numeric.house(r), m = [e2[0], e2[1], e2[2]], d = numeric.tensor(n, numeric.dot(n, m)), g = 0; g < 3; g++) for (p = e2[g], h = d[g], v2 = 0; v2 < b2; v2++) p[v2] -= 2 * h[v2];
        for (m = numeric.getBlock(e2, [0, 0], [b2 - 1, 2]), d = numeric.tensor(numeric.dot(m, n), n), g = 0; g < b2; g++) for (p = e2[g], h = d[g], v2 = 0; v2 < 3; v2++) p[v2] -= 2 * h[v2];
        for (m = [_2[0], _2[1], _2[2]], d = numeric.tensor(n, numeric.dot(n, m)), g = 0; g < 3; g++) for (f2 = _2[g], h = d[g], v2 = 0; v2 < b2; v2++) f2[v2] -= 2 * h[v2];
        for (y = 0; y < b2 - 2; y++) {
          for (v2 = y; v2 <= y + 1; v2++) if (Math.abs(e2[v2 + 1][v2]) < w2 * (Math.abs(e2[v2][v2]) + Math.abs(e2[v2 + 1][v2 + 1]))) {
            A2 = numeric.QRFrancis(numeric.getBlock(e2, [0, 0], [v2, v2]), t2), N = numeric.QRFrancis(numeric.getBlock(e2, [v2 + 1, v2 + 1], [b2 - 1, b2 - 1]), t2);
            for (m = Array(v2 + 1), g = 0; g <= v2; g++) m[g] = _2[g];
            for (d = numeric.dot(A2.Q, m), g = 0; g <= v2; g++) _2[g] = d[g];
            for (m = Array(b2 - v2 - 1), g = v2 + 1; g < b2; g++) m[g - v2 - 1] = _2[g];
            for (d = numeric.dot(N.Q, m), g = v2 + 1; g < b2; g++) _2[g] = d[g - v2 - 1];
            return { Q: _2, B: A2.B.concat(numeric.add(N.B, v2 + 1)) };
          }
          for ($2 = Math.min(b2 - 1, y + 3), r = Array($2 - y), g = y + 1; g <= $2; g++) r[g - y - 1] = e2[g][y];
          for (n = numeric.house(r), m = numeric.getBlock(e2, [y + 1, y], [$2, b2 - 1]), d = numeric.tensor(n, numeric.dot(n, m)), g = y + 1; g <= $2; g++) for (p = e2[g], h = d[g - y - 1], v2 = y; v2 < b2; v2++) p[v2] -= 2 * h[v2 - y];
          for (m = numeric.getBlock(e2, [0, y + 1], [b2 - 1, $2]), d = numeric.tensor(numeric.dot(m, n), n), g = 0; g < b2; g++) for (p = e2[g], h = d[g], v2 = y + 1; v2 <= $2; v2++) p[v2] -= 2 * h[v2 - y - 1];
          for (m = Array($2 - y), g = y + 1; g <= $2; g++) m[g - y - 1] = _2[g];
          for (d = numeric.tensor(n, numeric.dot(n, m)), g = y + 1; g <= $2; g++) for (f2 = _2[g], h = d[g - y - 1], v2 = 0; v2 < b2; v2++) f2[v2] -= 2 * h[v2];
        }
      }
      throw new Error("numeric: eigenvalue iteration does not converge -- increase maxiter?");
    }, numeric.eig = function(e2, t2) {
      var r, n, i2, a, o, s, u, c2, l, f2, p, m, d, h, g, y, v2 = numeric.toUpperHessenberg(e2), x2 = numeric.QRFrancis(v2.H, t2), b2 = numeric.T, _2 = e2.length, w2 = x2.B, A2 = numeric.dot(x2.Q, numeric.dot(v2.H, numeric.transpose(x2.Q))), N = new b2(numeric.dot(x2.Q, v2.Q)), D = w2.length, E = Math.sqrt;
      for (n = 0; n < D; n++) if ((r = w2[n][0]) === w2[n][1]) ;
      else {
        if (a = r + 1, o = A2[r][r], s = A2[r][a], u = A2[a][r], c2 = A2[a][a], 0 === s && 0 === u) continue;
        (f2 = (l = -o - c2) * l - 4 * (o * c2 - s * u)) >= 0 ? ((g = (o - (p = l < 0 ? -0.5 * (l - E(f2)) : -0.5 * (l + E(f2)))) * (o - p) + s * s) > (y = u * u + (c2 - p) * (c2 - p)) ? (d = (o - p) / (g = E(g)), h = s / g) : (d = u / (y = E(y)), h = (c2 - p) / y), i2 = new b2([[h, -d], [d, h]]), N.setRows(r, a, i2.dot(N.getRows(r, a)))) : (p = -0.5 * l, m = 0.5 * E(-f2), (g = (o - p) * (o - p) + s * s) > (y = u * u + (c2 - p) * (c2 - p)) ? (d = (o - p) / (g = E(g + m * m)), h = s / g, p = 0, m /= g) : (d = u / (y = E(y + m * m)), h = (c2 - p) / y, p = m / y, m = 0), i2 = new b2([[h, -d], [d, h]], [[p, m], [m, -p]]), N.setRows(r, a, i2.dot(N.getRows(r, a))));
      }
      var $2 = N.dot(e2).dot(N.transjugate()), S2 = (_2 = e2.length, numeric.T.identity(_2));
      for (a = 0; a < _2; a++) if (a > 0) for (n = a - 1; n >= 0; n--) {
        var C2 = $2.get([n, n]), M2 = $2.get([a, a]);
        numeric.neq(C2.x, M2.x) || numeric.neq(C2.y, M2.y) ? (p = $2.getRow(n).getBlock([n], [a - 1]), m = S2.getRow(a).getBlock([n], [a - 1]), S2.set([a, n], $2.get([n, a]).neg().sub(p.dot(m)).div(C2.sub(M2)))) : S2.setRow(a, S2.getRow(n));
      }
      for (a = 0; a < _2; a++) p = S2.getRow(a), S2.setRow(a, p.div(p.norm2()));
      return S2 = S2.transpose(), S2 = N.transjugate().dot(S2), { lambda: $2.getDiag(), E: S2 };
    }, numeric.ccsSparse = function(e2) {
      var t2, r, n, i2 = e2.length, a = [];
      for (r = i2 - 1; -1 !== r; --r) for (n in t2 = e2[r]) {
        for (n = parseInt(n); n >= a.length; ) a[a.length] = 0;
        0 !== t2[n] && a[n]++;
      }
      var o = a.length, s = Array(o + 1);
      for (s[0] = 0, r = 0; r < o; ++r) s[r + 1] = s[r] + a[r];
      var u = Array(s[o]), c2 = Array(s[o]);
      for (r = i2 - 1; -1 !== r; --r) for (n in t2 = e2[r]) 0 !== t2[n] && (a[n]--, u[s[n] + a[n]] = r, c2[s[n] + a[n]] = t2[n]);
      return [s, u, c2];
    }, numeric.ccsFull = function(e2) {
      var t2, r, n, i2, a = e2[0], o = e2[1], s = e2[2], u = numeric.ccsDim(e2), c2 = u[0], l = u[1], f2 = numeric.rep([c2, l], 0);
      for (t2 = 0; t2 < l; t2++) for (n = a[t2], i2 = a[t2 + 1], r = n; r < i2; ++r) f2[o[r]][t2] = s[r];
      return f2;
    }, numeric.ccsTSolve = function(e2, t2, r, n, i2) {
      var a, o, s, u, c2, l, f2, p = e2[0], m = e2[1], d = e2[2], h = p.length - 1, g = Math.max, y = 0;
      function v2(e3) {
        var t22;
        if (0 === r[e3]) {
          for (r[e3] = 1, t22 = p[e3]; t22 < p[e3 + 1]; ++t22) v2(m[t22]);
          i2[y] = e3, ++y;
        }
      }
      for (void 0 === n && (r = numeric.rep([h], 0)), void 0 === n && (n = numeric.linspace(0, r.length - 1)), void 0 === i2 && (i2 = []), a = n.length - 1; -1 !== a; --a) v2(n[a]);
      for (i2.length = y, a = i2.length - 1; -1 !== a; --a) r[i2[a]] = 0;
      for (a = n.length - 1; -1 !== a; --a) o = n[a], r[o] = t2[o];
      for (a = i2.length - 1; -1 !== a; --a) {
        for (o = i2[a], s = p[o], u = g(p[o + 1], s), c2 = s; c2 !== u; ++c2) if (m[c2] === o) {
          r[o] /= d[c2];
          break;
        }
        for (f2 = r[o], c2 = s; c2 !== u; ++c2) (l = m[c2]) !== o && (r[l] -= f2 * d[c2]);
      }
      return r;
    }, numeric.ccsDFS = function(e2) {
      this.k = Array(e2), this.k1 = Array(e2), this.j = Array(e2);
    }, numeric.ccsDFS.prototype.dfs = function(e2, t2, r, n, i2, a) {
      var o, s, u, c2 = 0, l = i2.length, f2 = this.k, p = this.k1, m = this.j;
      if (0 === n[e2]) for (n[e2] = 1, m[0] = e2, f2[0] = s = t2[e2], p[0] = u = t2[e2 + 1]; ; ) if (s >= u) {
        if (i2[l] = m[c2], 0 === c2) return;
        ++l, s = f2[--c2], u = p[c2];
      } else 0 === n[o = a[r[s]]] ? (n[o] = 1, f2[c2] = s, m[++c2] = o, s = t2[o], p[c2] = u = t2[o + 1]) : ++s;
    }, numeric.ccsLPSolve = function(e2, t2, r, n, i2, a, o) {
      var s = e2[0], u = e2[1], c2 = e2[2];
      s.length;
      var l, f2, p, m, d, h, g, y, v2, x2 = t2[0], b2 = t2[1], _2 = t2[2];
      for (f2 = x2[i2], p = x2[i2 + 1], n.length = 0, l = f2; l < p; ++l) o.dfs(a[b2[l]], s, u, r, n, a);
      for (l = n.length - 1; -1 !== l; --l) r[n[l]] = 0;
      for (l = f2; l !== p; ++l) r[m = a[b2[l]]] = _2[l];
      for (l = n.length - 1; -1 !== l; --l) {
        for (d = s[m = n[l]], h = s[m + 1], g = d; g < h; ++g) if (a[u[g]] === m) {
          r[m] /= c2[g];
          break;
        }
        for (v2 = r[m], g = d; g < h; ++g) (y = a[u[g]]) !== m && (r[y] -= v2 * c2[g]);
      }
      return r;
    }, numeric.ccsLUP1 = function(e2, t2) {
      var r, n, i2, a, o, s, u, c2 = e2[0].length - 1, l = [numeric.rep([c2 + 1], 0), [], []], f2 = [numeric.rep([c2 + 1], 0), [], []], p = l[0], m = l[1], d = l[2], h = f2[0], g = f2[1], y = f2[2], v2 = numeric.rep([c2], 0), x2 = numeric.rep([c2], 0), b2 = numeric.ccsLPSolve, _2 = Math.abs, w2 = numeric.linspace(0, c2 - 1), A2 = numeric.linspace(0, c2 - 1), N = new numeric.ccsDFS(c2);
      for (void 0 === t2 && (t2 = 1), r = 0; r < c2; ++r) {
        for (b2(l, e2, v2, x2, r, A2, N), a = -1, o = -1, n = x2.length - 1; -1 !== n; --n) (i2 = x2[n]) <= r || (s = _2(v2[i2])) > a && (o = i2, a = s);
        for (_2(v2[r]) < t2 * a && (n = w2[r], a = w2[o], w2[r] = a, A2[a] = r, w2[o] = n, A2[n] = o, a = v2[r], v2[r] = v2[o], v2[o] = a), a = p[r], o = h[r], u = v2[r], m[a] = w2[r], d[a] = 1, ++a, n = x2.length - 1; -1 !== n; --n) s = v2[i2 = x2[n]], x2[n] = 0, v2[i2] = 0, i2 <= r ? (g[o] = i2, y[o] = s, ++o) : (m[a] = w2[i2], d[a] = s / u, ++a);
        p[r + 1] = a, h[r + 1] = o;
      }
      for (n = m.length - 1; -1 !== n; --n) m[n] = A2[m[n]];
      return { L: l, U: f2, P: w2, Pinv: A2 };
    }, numeric.ccsDFS0 = function(e2) {
      this.k = Array(e2), this.k1 = Array(e2), this.j = Array(e2);
    }, numeric.ccsDFS0.prototype.dfs = function(e2, t2, r, n, i2, a, o) {
      var s, u, c2, l = 0, f2 = i2.length, p = this.k, m = this.k1, d = this.j;
      if (0 === n[e2]) for (n[e2] = 1, d[0] = e2, p[0] = u = t2[a[e2]], m[0] = c2 = t2[a[e2] + 1]; ; ) {
        if (isNaN(u)) throw new Error("Ow!");
        if (u >= c2) {
          if (i2[f2] = a[d[l]], 0 === l) return;
          ++f2, u = p[--l], c2 = m[l];
        } else 0 === n[s = r[u]] ? (n[s] = 1, p[l] = u, d[++l] = s, u = t2[s = a[s]], m[l] = c2 = t2[s + 1]) : ++u;
      }
    }, numeric.ccsLPSolve0 = function(e2, t2, r, n, i2, a, o, s) {
      var u = e2[0], c2 = e2[1], l = e2[2];
      u.length;
      var f2, p, m, d, h, g, y, v2, x2, b2 = t2[0], _2 = t2[1], w2 = t2[2];
      for (p = b2[i2], m = b2[i2 + 1], n.length = 0, f2 = p; f2 < m; ++f2) s.dfs(_2[f2], u, c2, r, n, a, o);
      for (f2 = n.length - 1; -1 !== f2; --f2) r[o[d = n[f2]]] = 0;
      for (f2 = p; f2 !== m; ++f2) r[d = _2[f2]] = w2[f2];
      for (f2 = n.length - 1; -1 !== f2; --f2) {
        for (v2 = o[d = n[f2]], h = u[d], g = u[d + 1], y = h; y < g; ++y) if (c2[y] === v2) {
          r[v2] /= l[y];
          break;
        }
        for (x2 = r[v2], y = h; y < g; ++y) r[c2[y]] -= x2 * l[y];
        r[v2] = x2;
      }
    }, numeric.ccsLUP0 = function(e2, t2) {
      var r, n, i2, a, o, s, u, c2 = e2[0].length - 1, l = [numeric.rep([c2 + 1], 0), [], []], f2 = [numeric.rep([c2 + 1], 0), [], []], p = l[0], m = l[1], d = l[2], h = f2[0], g = f2[1], y = f2[2], v2 = numeric.rep([c2], 0), x2 = numeric.rep([c2], 0), b2 = numeric.ccsLPSolve0, _2 = Math.abs, w2 = numeric.linspace(0, c2 - 1), A2 = numeric.linspace(0, c2 - 1), N = new numeric.ccsDFS0(c2);
      for (void 0 === t2 && (t2 = 1), r = 0; r < c2; ++r) {
        for (b2(l, e2, v2, x2, r, A2, w2, N), a = -1, o = -1, n = x2.length - 1; -1 !== n; --n) (i2 = x2[n]) <= r || (s = _2(v2[w2[i2]])) > a && (o = i2, a = s);
        for (_2(v2[w2[r]]) < t2 * a && (n = w2[r], a = w2[o], w2[r] = a, A2[a] = r, w2[o] = n, A2[n] = o), a = p[r], o = h[r], u = v2[w2[r]], m[a] = w2[r], d[a] = 1, ++a, n = x2.length - 1; -1 !== n; --n) s = v2[w2[i2 = x2[n]]], x2[n] = 0, v2[w2[i2]] = 0, i2 <= r ? (g[o] = i2, y[o] = s, ++o) : (m[a] = w2[i2], d[a] = s / u, ++a);
        p[r + 1] = a, h[r + 1] = o;
      }
      for (n = m.length - 1; -1 !== n; --n) m[n] = A2[m[n]];
      return { L: l, U: f2, P: w2, Pinv: A2 };
    }, numeric.ccsLUP = numeric.ccsLUP0, numeric.ccsDim = function(e2) {
      return [numeric.sup(e2[1]) + 1, e2[0].length - 1];
    }, numeric.ccsGetBlock = function(e2, t2, r) {
      var n = numeric.ccsDim(e2), i2 = n[0], a = n[1];
      void 0 === t2 ? t2 = numeric.linspace(0, i2 - 1) : "number" == typeof t2 && (t2 = [t2]), void 0 === r ? r = numeric.linspace(0, a - 1) : "number" == typeof r && (r = [r]);
      var o, s, u, c2, l = t2.length, f2 = r.length, p = numeric.rep([a], 0), m = [], d = [], h = [p, m, d], g = e2[0], y = e2[1], v2 = e2[2], x2 = numeric.rep([i2], 0), b2 = 0, _2 = numeric.rep([i2], 0);
      for (s = 0; s < f2; ++s) {
        var w2 = g[c2 = r[s]], A2 = g[c2 + 1];
        for (o = w2; o < A2; ++o) _2[u = y[o]] = 1, x2[u] = v2[o];
        for (o = 0; o < l; ++o) _2[t2[o]] && (m[b2] = o, d[b2] = x2[t2[o]], ++b2);
        for (o = w2; o < A2; ++o) _2[u = y[o]] = 0;
        p[s + 1] = b2;
      }
      return h;
    }, numeric.ccsDot = function(e2, t2) {
      var r = e2[0], n = e2[1], i2 = e2[2], a = t2[0], o = t2[1], s = t2[2], u = numeric.ccsDim(e2), c2 = numeric.ccsDim(t2), l = u[0];
      u[1];
      var f2, p, m, d, h, g, y, v2, x2, b2, _2, w2 = c2[1], A2 = numeric.rep([l], 0), N = numeric.rep([l], 0), D = Array(l), E = numeric.rep([w2], 0), $2 = [], S2 = [], C2 = [E, $2, S2];
      for (m = 0; m !== w2; ++m) {
        for (d = a[m], h = a[m + 1], x2 = 0, p = d; p < h; ++p) for (b2 = o[p], _2 = s[p], g = r[b2], y = r[b2 + 1], f2 = g; f2 < y; ++f2) 0 === N[v2 = n[f2]] && (D[x2] = v2, N[v2] = 1, x2 += 1), A2[v2] = A2[v2] + i2[f2] * _2;
        for (h = (d = E[m]) + x2, E[m + 1] = h, p = x2 - 1; -1 !== p; --p) _2 = d + p, f2 = D[p], $2[_2] = f2, S2[_2] = A2[f2], N[f2] = 0, A2[f2] = 0;
        E[m + 1] = E[m] + x2;
      }
      return C2;
    }, numeric.ccsLUPSolve = function(e2, t2) {
      var r = e2.L, n = e2.U;
      e2.P;
      var i2 = t2[0], a = false;
      "object" != typeof i2 && (i2 = (t2 = [[0, t2.length], numeric.linspace(0, t2.length - 1), t2])[0], a = true);
      var o, s, u, c2, l, f2, p = t2[1], m = t2[2], d = r[0].length - 1, h = i2.length - 1, g = numeric.rep([d], 0), y = Array(d), v2 = numeric.rep([d], 0), x2 = Array(d), b2 = numeric.rep([h + 1], 0), _2 = [], w2 = [], A2 = numeric.ccsTSolve, N = 0;
      for (o = 0; o < h; ++o) {
        for (l = 0, u = i2[o], c2 = i2[o + 1], s = u; s < c2; ++s) f2 = e2.Pinv[p[s]], x2[l] = f2, v2[f2] = m[s], ++l;
        for (x2.length = l, A2(r, v2, g, x2, y), s = x2.length - 1; -1 !== s; --s) v2[x2[s]] = 0;
        if (A2(n, g, v2, y, x2), a) return v2;
        for (s = y.length - 1; -1 !== s; --s) g[y[s]] = 0;
        for (s = x2.length - 1; -1 !== s; --s) f2 = x2[s], _2[N] = f2, w2[N] = v2[f2], v2[f2] = 0, ++N;
        b2[o + 1] = N;
      }
      return [b2, _2, w2];
    }, numeric.ccsbinop = function(e2, t2) {
      return void 0 === t2 && (t2 = ""), Function("X", "Y", "var Xi = X[0], Xj = X[1], Xv = X[2];\nvar Yi = Y[0], Yj = Y[1], Yv = Y[2];\nvar n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;\nvar Zi = numeric.rep([n+1],0), Zj = [], Zv = [];\nvar x = numeric.rep([m],0),y = numeric.rep([m],0);\nvar xk,yk,zk;\nvar i,j,j0,j1,k,p=0;\n" + t2 + "for(i=0;i<n;++i) {\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Xj[j];\n    x[k] = 1;\n    Zj[p] = k;\n    ++p;\n  }\n  j0 = Yi[i]; j1 = Yi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Yj[j];\n    y[k] = Yv[j];\n    if(x[k] === 0) {\n      Zj[p] = k;\n      ++p;\n    }\n  }\n  Zi[i+1] = p;\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];\n  j0 = Zi[i]; j1 = Zi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Zj[j];\n    xk = x[k];\n    yk = y[k];\n" + e2 + "\n    Zv[j] = zk;\n  }\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;\n  j0 = Yi[i]; j1 = Yi[i+1];\n  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;\n}\nreturn [Zi,Zj,Zv];");
    }, (function() {
      var k, A, B, C;
      for (k in numeric.ops2) A = isFinite(eval("1" + numeric.ops2[k] + "0")) ? "[Y[0],Y[1],numeric." + k + "(X,Y[2])]" : "NaN", B = isFinite(eval("0" + numeric.ops2[k] + "1")) ? "[X[0],X[1],numeric." + k + "(X[2],Y)]" : "NaN", C = isFinite(eval("1" + numeric.ops2[k] + "0")) && isFinite(eval("0" + numeric.ops2[k] + "1")) ? "numeric.ccs" + k + "MM(X,Y)" : "NaN", numeric["ccs" + k + "MM"] = numeric.ccsbinop("zk = xk " + numeric.ops2[k] + "yk;"), numeric["ccs" + k] = Function("X", "Y", 'if(typeof X === "number") return ' + A + ';\nif(typeof Y === "number") return ' + B + ";\nreturn " + C + ";\n");
    })(), numeric.ccsScatter = function(e2) {
      var t2, r = e2[0], n = e2[1], i2 = e2[2], a = numeric.sup(n) + 1, o = r.length, s = numeric.rep([a], 0), u = Array(o), c2 = Array(o), l = numeric.rep([a], 0);
      for (t2 = 0; t2 < o; ++t2) l[n[t2]]++;
      for (t2 = 0; t2 < a; ++t2) s[t2 + 1] = s[t2] + l[t2];
      var f2, p, m = s.slice(0);
      for (t2 = 0; t2 < o; ++t2) u[f2 = m[p = n[t2]]] = r[t2], c2[f2] = i2[t2], m[p] = m[p] + 1;
      return [s, u, c2];
    }, numeric.ccsGather = function(e2) {
      var t2, r, n, i2, a, o = e2[0], s = e2[1], u = e2[2], c2 = o.length - 1, l = s.length, f2 = Array(l), p = Array(l), m = Array(l);
      for (a = 0, t2 = 0; t2 < c2; ++t2) for (n = o[t2], i2 = o[t2 + 1], r = n; r !== i2; ++r) p[a] = t2, f2[a] = s[r], m[a] = u[r], ++a;
      return [f2, p, m];
    }, numeric.sdim = function e2(t2, r, n) {
      if (void 0 === r && (r = []), "object" != typeof t2) return r;
      var i2;
      for (i2 in void 0 === n && (n = 0), n in r || (r[n] = 0), t2.length > r[n] && (r[n] = t2.length), t2) t2.hasOwnProperty(i2) && e2(t2[i2], r, n + 1);
      return r;
    }, numeric.sclone = function e2(t2, r, n) {
      void 0 === r && (r = 0), void 0 === n && (n = numeric.sdim(t2).length);
      var i2, a = Array(t2.length);
      if (r === n - 1) {
        for (i2 in t2) t2.hasOwnProperty(i2) && (a[i2] = t2[i2]);
        return a;
      }
      for (i2 in t2) t2.hasOwnProperty(i2) && (a[i2] = e2(t2[i2], r + 1, n));
      return a;
    }, numeric.sdiag = function(e2) {
      var t2, r, n = e2.length, i2 = Array(n);
      for (t2 = n - 1; t2 >= 1; t2 -= 2) r = t2 - 1, i2[t2] = [], i2[t2][t2] = e2[t2], i2[r] = [], i2[r][r] = e2[r];
      return 0 === t2 && (i2[0] = [], i2[0][0] = e2[t2]), i2;
    }, numeric.sidentity = function(e2) {
      return numeric.sdiag(numeric.rep([e2], 1));
    }, numeric.stranspose = function(e2) {
      var t2, r, n, i2 = [];
      for (t2 in e2.length, e2) if (e2.hasOwnProperty(t2)) for (r in n = e2[t2]) n.hasOwnProperty(r) && ("object" != typeof i2[r] && (i2[r] = []), i2[r][t2] = n[r]);
      return i2;
    }, numeric.sLUP = function(e2, t2) {
      throw new Error("The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.");
    }, numeric.sdotMM = function(e2, t2) {
      var r = e2.length;
      t2.length;
      var n, i2, a, o, s, u, c2, l = numeric.stranspose(t2), f2 = l.length, p = Array(r);
      for (a = r - 1; a >= 0; a--) {
        for (c2 = [], n = e2[a], s = f2 - 1; s >= 0; s--) {
          for (o in u = 0, i2 = l[s], n) n.hasOwnProperty(o) && o in i2 && (u += n[o] * i2[o]);
          u && (c2[s] = u);
        }
        p[a] = c2;
      }
      return p;
    }, numeric.sdotMV = function(e2, t2) {
      var r, n, i2, a, o = e2.length, s = Array(o);
      for (n = o - 1; n >= 0; n--) {
        for (i2 in a = 0, r = e2[n]) r.hasOwnProperty(i2) && t2[i2] && (a += r[i2] * t2[i2]);
        a && (s[n] = a);
      }
      return s;
    }, numeric.sdotVM = function(e2, t2) {
      var r, n, i2, a, o = [];
      for (r in e2) if (e2.hasOwnProperty(r)) for (n in i2 = t2[r], a = e2[r], i2) i2.hasOwnProperty(n) && (o[n] || (o[n] = 0), o[n] += a * i2[n]);
      return o;
    }, numeric.sdotVV = function(e2, t2) {
      var r, n = 0;
      for (r in e2) e2[r] && t2[r] && (n += e2[r] * t2[r]);
      return n;
    }, numeric.sdot = function(e2, t2) {
      var r = numeric.sdim(e2).length, n = numeric.sdim(t2).length;
      switch (1e3 * r + n) {
        case 0:
          return e2 * t2;
        case 1001:
          return numeric.sdotVV(e2, t2);
        case 2001:
          return numeric.sdotMV(e2, t2);
        case 1002:
          return numeric.sdotVM(e2, t2);
        case 2002:
          return numeric.sdotMM(e2, t2);
        default:
          throw new Error("numeric.sdot not implemented for tensors of order " + r + " and " + n);
      }
    }, numeric.sscatter = function(e2) {
      var t2, r, n, i2, a = e2[0].length, o = e2.length, s = [];
      for (r = a - 1; r >= 0; --r) if (e2[o - 1][r]) {
        for (i2 = s, n = 0; n < o - 2; n++) i2[t2 = e2[n][r]] || (i2[t2] = []), i2 = i2[t2];
        i2[e2[n][r]] = e2[n + 1][r];
      }
      return s;
    }, numeric.sgather = function e2(t2, r, n) {
      var i2, a, o;
      for (a in void 0 === r && (r = []), void 0 === n && (n = []), i2 = n.length, t2) if (t2.hasOwnProperty(a)) if (n[i2] = parseInt(a), "number" == typeof (o = t2[a])) {
        if (o) {
          if (0 === r.length) for (a = i2 + 1; a >= 0; --a) r[a] = [];
          for (a = i2; a >= 0; --a) r[a].push(n[a]);
          r[i2 + 1].push(o);
        }
      } else e2(o, r, n);
      return n.length > i2 && n.pop(), r;
    }, numeric.cLU = function(e2) {
      var t2, r, n, i2, a, o, s = e2[0], u = e2[1], c2 = e2[2], l = s.length, f2 = 0;
      for (t2 = 0; t2 < l; t2++) s[t2] > f2 && (f2 = s[t2]);
      f2++;
      var p, m = Array(f2), d = Array(f2), h = numeric.rep([f2], 1 / 0), g = numeric.rep([f2], -1 / 0);
      for (n = 0; n < l; n++) t2 = s[n], (r = u[n]) < h[t2] && (h[t2] = r), r > g[t2] && (g[t2] = r);
      for (t2 = 0; t2 < f2 - 1; t2++) g[t2] > g[t2 + 1] && (g[t2 + 1] = g[t2]);
      for (t2 = f2 - 1; t2 >= 1; t2--) h[t2] < h[t2 - 1] && (h[t2 - 1] = h[t2]);
      for (t2 = 0; t2 < f2; t2++) d[t2] = numeric.rep([g[t2] - h[t2] + 1], 0), m[t2] = numeric.rep([t2 - h[t2]], 0), t2 - h[t2] + 1, g[t2] - t2 + 1;
      for (n = 0; n < l; n++) d[t2 = s[n]][u[n] - h[t2]] = c2[n];
      for (t2 = 0; t2 < f2 - 1; t2++) for (i2 = t2 - h[t2], x2 = d[t2], r = t2 + 1; h[r] <= t2 && r < f2; r++) if (a = t2 - h[r], o = g[t2] - t2, p = (b2 = d[r])[a] / x2[i2]) {
        for (n = 1; n <= o; n++) b2[n + a] -= p * x2[n + i2];
        m[r][t2 - h[r]] = p;
      }
      var y, v2, x2 = [], b2 = [], _2 = [], w2 = [], A2 = [], N = [];
      for (l = 0, y = 0, t2 = 0; t2 < f2; t2++) {
        for (i2 = h[t2], a = g[t2], v2 = d[t2], r = t2; r <= a; r++) v2[r - i2] && (x2[l] = t2, b2[l] = r, _2[l] = v2[r - i2], l++);
        for (v2 = m[t2], r = i2; r < t2; r++) v2[r - i2] && (w2[y] = t2, A2[y] = r, N[y] = v2[r - i2], y++);
        w2[y] = t2, A2[y] = t2, N[y] = 1, y++;
      }
      return { U: [x2, b2, _2], L: [w2, A2, N] };
    }, numeric.cLUsolve = function(e2, t2) {
      var r = e2.L, n = e2.U, i2 = numeric.clone(t2), a = r[0], o = r[1], s = r[2], u = n[0], c2 = n[1], l = n[2], f2 = u.length;
      a.length;
      var p, m, d = i2.length;
      for (m = 0, p = 0; p < d; p++) {
        for (; o[m] < p; ) i2[p] -= s[m] * i2[o[m]], m++;
        m++;
      }
      for (m = f2 - 1, p = d - 1; p >= 0; p--) {
        for (; c2[m] > p; ) i2[p] -= l[m] * i2[c2[m]], m--;
        i2[p] /= l[m], m--;
      }
      return i2;
    }, numeric.cgrid = function(e2, t2) {
      "number" == typeof e2 && (e2 = [e2, e2]);
      var r, n, i2, a = numeric.rep(e2, -1);
      if ("function" != typeof t2) if ("L" === t2) t2 = function(t22, r2) {
        return t22 >= e2[0] / 2 || r2 < e2[1] / 2;
      };
      else t2 = function(e3, t22) {
        return true;
      };
      for (i2 = 0, r = 1; r < e2[0] - 1; r++) for (n = 1; n < e2[1] - 1; n++) t2(r, n) && (a[r][n] = i2, i2++);
      return a;
    }, numeric.cdelsq = function(e2) {
      var t2, r, n, i2, a, o = [[-1, 0], [0, -1], [0, 1], [1, 0]], s = numeric.dim(e2), u = s[0], c2 = s[1], l = [], f2 = [], p = [];
      for (t2 = 1; t2 < u - 1; t2++) for (r = 1; r < c2 - 1; r++) if (!(e2[t2][r] < 0)) {
        for (n = 0; n < 4; n++) i2 = t2 + o[n][0], a = r + o[n][1], e2[i2][a] < 0 || (l.push(e2[t2][r]), f2.push(e2[i2][a]), p.push(-1));
        l.push(e2[t2][r]), f2.push(e2[t2][r]), p.push(4);
      }
      return [l, f2, p];
    }, numeric.cdotMV = function(e2, t2) {
      var r, n, i2, a = e2[0], o = e2[1], s = e2[2], u = a.length;
      for (i2 = 0, n = 0; n < u; n++) a[n] > i2 && (i2 = a[n]);
      for (i2++, r = numeric.rep([i2], 0), n = 0; n < u; n++) r[a[n]] += s[n] * t2[o[n]];
      return r;
    }, numeric.Spline = function(e2, t2, r, n, i2) {
      this.x = e2, this.yl = t2, this.yr = r, this.kl = n, this.kr = i2;
    }, numeric.Spline.prototype._at = function(e2, t2) {
      var r, n, i2, a = this.x, o = this.yl, s = this.yr, u = this.kl, c2 = this.kr, l = numeric.add, f2 = numeric.sub, p = numeric.mul;
      r = f2(p(u[t2], a[t2 + 1] - a[t2]), f2(s[t2 + 1], o[t2])), n = l(p(c2[t2 + 1], a[t2] - a[t2 + 1]), f2(s[t2 + 1], o[t2]));
      var m = (i2 = (e2 - a[t2]) / (a[t2 + 1] - a[t2])) * (1 - i2);
      return l(l(l(p(1 - i2, o[t2]), p(i2, s[t2 + 1])), p(r, m * (1 - i2))), p(n, m * i2));
    }, numeric.Spline.prototype.at = function(e2) {
      if ("number" == typeof e2) {
        var t2, r, n, i2 = this.x, a = i2.length, o = Math.floor;
        for (t2 = 0, r = a - 1; r - t2 > 1; ) i2[n = o((t2 + r) / 2)] <= e2 ? t2 = n : r = n;
        return this._at(e2, t2);
      }
      a = e2.length;
      var s, u = Array(a);
      for (s = a - 1; -1 !== s; --s) u[s] = this.at(e2[s]);
      return u;
    }, numeric.Spline.prototype.diff = function() {
      var e2, t2, r, n = this.x, i2 = this.yl, a = this.yr, o = this.kl, s = this.kr, u = i2.length, c2 = o, l = s, f2 = Array(u), p = Array(u), m = numeric.add, d = numeric.mul, h = numeric.div, g = numeric.sub;
      for (e2 = u - 1; -1 !== e2; --e2) t2 = n[e2 + 1] - n[e2], r = g(a[e2 + 1], i2[e2]), f2[e2] = h(m(d(r, 6), d(o[e2], -4 * t2), d(s[e2 + 1], -2 * t2)), t2 * t2), p[e2 + 1] = h(m(d(r, -6), d(o[e2], 2 * t2), d(s[e2 + 1], 4 * t2)), t2 * t2);
      return new numeric.Spline(n, c2, l, f2, p);
    }, numeric.Spline.prototype.roots = function() {
      function e2(e3) {
        return e3 * e3;
      }
      var t2 = [], r = this.x, n = this.yl, i2 = this.yr, a = this.kl, o = this.kr;
      "number" == typeof n[0] && (n = [n], i2 = [i2], a = [a], o = [o]);
      var s, u, c2, l, f2, p, m, d, h, g, y, v2, x2, b2, _2, w2, A2, N, D, E, $2, S2, C2, M2 = n.length, T2 = r.length - 1, F = (t2 = Array(M2), Math.sqrt);
      for (s = 0; s !== M2; ++s) {
        for (l = n[s], f2 = i2[s], p = a[s], m = o[s], d = [], u = 0; u !== T2; u++) {
          for (u > 0 && f2[u] * l[u] < 0 && d.push(r[u]), w2 = r[u + 1] - r[u], r[u], y = l[u], v2 = f2[u + 1], h = p[u] / w2, x2 = (g = m[u + 1] / w2) + 3 * y + 2 * h - 3 * v2, b2 = 3 * (g + h + 2 * (y - v2)), (_2 = e2(h - g + 3 * (y - v2)) + 12 * g * y) <= 0 ? A2 = (N = x2 / b2) > r[u] && N < r[u + 1] ? [r[u], N, r[u + 1]] : [r[u], r[u + 1]] : (N = (x2 - F(_2)) / b2, D = (x2 + F(_2)) / b2, A2 = [r[u]], N > r[u] && N < r[u + 1] && A2.push(N), D > r[u] && D < r[u + 1] && A2.push(D), A2.push(r[u + 1])), $2 = A2[0], N = this._at($2, u), c2 = 0; c2 < A2.length - 1; c2++) if (S2 = A2[c2 + 1], D = this._at(S2, u), 0 !== N) if (0 === D || N * D > 0) $2 = S2, N = D;
          else {
            for (var O2 = 0; !((C2 = (N * S2 - D * $2) / (N - D)) <= $2 || C2 >= S2); ) if ((E = this._at(C2, u)) * D > 0) S2 = C2, D = E, -1 === O2 && (N *= 0.5), O2 = -1;
            else {
              if (!(E * N > 0)) break;
              $2 = C2, N = E, 1 === O2 && (D *= 0.5), O2 = 1;
            }
            d.push(C2), $2 = A2[c2 + 1], N = this._at($2, u);
          }
          else d.push($2), $2 = S2, N = D;
          0 === D && d.push(S2);
        }
        t2[s] = d;
      }
      return "number" == typeof this.yl[0] ? t2[0] : t2;
    }, numeric.spline = function(e2, t2, r, n) {
      var i2, a = e2.length, o = [], s = [], u = [], c2 = numeric.sub, l = numeric.mul, f2 = numeric.add;
      for (i2 = a - 2; i2 >= 0; i2--) s[i2] = e2[i2 + 1] - e2[i2], u[i2] = c2(t2[i2 + 1], t2[i2]);
      "string" != typeof r && "string" != typeof n || (r = n = "periodic");
      var p = [[], [], []];
      switch (typeof r) {
        case "undefined":
          o[0] = l(3 / (s[0] * s[0]), u[0]), p[0].push(0, 0), p[1].push(0, 1), p[2].push(2 / s[0], 1 / s[0]);
          break;
        case "string":
          o[0] = f2(l(3 / (s[a - 2] * s[a - 2]), u[a - 2]), l(3 / (s[0] * s[0]), u[0])), p[0].push(0, 0, 0), p[1].push(a - 2, 0, 1), p[2].push(1 / s[a - 2], 2 / s[a - 2] + 2 / s[0], 1 / s[0]);
          break;
        default:
          o[0] = r, p[0].push(0), p[1].push(0), p[2].push(1);
      }
      for (i2 = 1; i2 < a - 1; i2++) o[i2] = f2(l(3 / (s[i2 - 1] * s[i2 - 1]), u[i2 - 1]), l(3 / (s[i2] * s[i2]), u[i2])), p[0].push(i2, i2, i2), p[1].push(i2 - 1, i2, i2 + 1), p[2].push(1 / s[i2 - 1], 2 / s[i2 - 1] + 2 / s[i2], 1 / s[i2]);
      switch (typeof n) {
        case "undefined":
          o[a - 1] = l(3 / (s[a - 2] * s[a - 2]), u[a - 2]), p[0].push(a - 1, a - 1), p[1].push(a - 2, a - 1), p[2].push(1 / s[a - 2], 2 / s[a - 2]);
          break;
        case "string":
          p[1][p[1].length - 1] = 0;
          break;
        default:
          o[a - 1] = n, p[0].push(a - 1), p[1].push(a - 1), p[2].push(1);
      }
      o = "number" != typeof o[0] ? numeric.transpose(o) : [o];
      var m = Array(o.length);
      if ("string" == typeof r) for (i2 = m.length - 1; -1 !== i2; --i2) m[i2] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(p)), o[i2]), m[i2][a - 1] = m[i2][0];
      else for (i2 = m.length - 1; -1 !== i2; --i2) m[i2] = numeric.cLUsolve(numeric.cLU(p), o[i2]);
      return m = "number" == typeof t2[0] ? m[0] : numeric.transpose(m), new numeric.Spline(e2, t2, t2, m, m);
    }, numeric.fftpow2 = function e2(t2, r) {
      var n = t2.length;
      if (1 !== n) {
        var i2, a, o = Math.cos, s = Math.sin, u = Array(n / 2), c2 = Array(n / 2), l = Array(n / 2), f2 = Array(n / 2);
        for (a = n / 2, i2 = n - 1; -1 !== i2; --i2) l[--a] = t2[i2], f2[a] = r[i2], --i2, u[a] = t2[i2], c2[a] = r[i2];
        e2(u, c2), e2(l, f2), a = n / 2;
        var p, m, d, h = -6.283185307179586 / n;
        for (i2 = n - 1; -1 !== i2; --i2) -1 === --a && (a = n / 2 - 1), m = o(p = h * i2), d = s(p), t2[i2] = u[a] + m * l[a] - d * f2[a], r[i2] = c2[a] + m * f2[a] + d * l[a];
      }
    }, numeric._ifftpow2 = function e2(t2, r) {
      var n = t2.length;
      if (1 !== n) {
        var i2, a, o = Math.cos, s = Math.sin, u = Array(n / 2), c2 = Array(n / 2), l = Array(n / 2), f2 = Array(n / 2);
        for (a = n / 2, i2 = n - 1; -1 !== i2; --i2) l[--a] = t2[i2], f2[a] = r[i2], --i2, u[a] = t2[i2], c2[a] = r[i2];
        e2(u, c2), e2(l, f2), a = n / 2;
        var p, m, d, h = 6.283185307179586 / n;
        for (i2 = n - 1; -1 !== i2; --i2) -1 === --a && (a = n / 2 - 1), m = o(p = h * i2), d = s(p), t2[i2] = u[a] + m * l[a] - d * f2[a], r[i2] = c2[a] + m * f2[a] + d * l[a];
      }
    }, numeric.ifftpow2 = function(e2, t2) {
      numeric._ifftpow2(e2, t2), numeric.diveq(e2, e2.length), numeric.diveq(t2, t2.length);
    }, numeric.convpow2 = function(e2, t2, r, n) {
      var i2, a, o, s, u;
      for (numeric.fftpow2(e2, t2), numeric.fftpow2(r, n), i2 = e2.length - 1; -1 !== i2; --i2) a = e2[i2], s = t2[i2], o = r[i2], u = n[i2], e2[i2] = a * o - s * u, t2[i2] = a * u + s * o;
      numeric.ifftpow2(e2, t2);
    }, numeric.T.prototype.fft = function() {
      var e2, t2, r = this.x, n = this.y, i2 = r.length, a = Math.log, o = a(2), s = Math.ceil(a(2 * i2 - 1) / o), u = Math.pow(2, s), c2 = numeric.rep([u], 0), l = numeric.rep([u], 0), f2 = Math.cos, p = Math.sin, m = -3.141592653589793 / i2, d = numeric.rep([u], 0), h = numeric.rep([u], 0);
      for (e2 = 0; e2 < i2; e2++) d[e2] = r[e2];
      if (void 0 !== n) for (e2 = 0; e2 < i2; e2++) h[e2] = n[e2];
      for (c2[0] = 1, e2 = 1; e2 <= u / 2; e2++) t2 = m * e2 * e2, c2[e2] = f2(t2), l[e2] = p(t2), c2[u - e2] = f2(t2), l[u - e2] = p(t2);
      var g = new numeric.T(d, h), y = new numeric.T(c2, l);
      return g = g.mul(y), numeric.convpow2(g.x, g.y, numeric.clone(y.x), numeric.neg(y.y)), (g = g.mul(y)).x.length = i2, g.y.length = i2, g;
    }, numeric.T.prototype.ifft = function() {
      var e2, t2, r = this.x, n = this.y, i2 = r.length, a = Math.log, o = a(2), s = Math.ceil(a(2 * i2 - 1) / o), u = Math.pow(2, s), c2 = numeric.rep([u], 0), l = numeric.rep([u], 0), f2 = Math.cos, p = Math.sin, m = 3.141592653589793 / i2, d = numeric.rep([u], 0), h = numeric.rep([u], 0);
      for (e2 = 0; e2 < i2; e2++) d[e2] = r[e2];
      if (void 0 !== n) for (e2 = 0; e2 < i2; e2++) h[e2] = n[e2];
      for (c2[0] = 1, e2 = 1; e2 <= u / 2; e2++) t2 = m * e2 * e2, c2[e2] = f2(t2), l[e2] = p(t2), c2[u - e2] = f2(t2), l[u - e2] = p(t2);
      var g = new numeric.T(d, h), y = new numeric.T(c2, l);
      return g = g.mul(y), numeric.convpow2(g.x, g.y, numeric.clone(y.x), numeric.neg(y.y)), (g = g.mul(y)).x.length = i2, g.y.length = i2, g.div(i2);
    }, numeric.gradient = function(e2, t2) {
      var r = t2.length, n = e2(t2);
      if (isNaN(n)) throw new Error("gradient: f(x) is a NaN!");
      var i2, a, o, s = Math.max, u = numeric.clone(t2), c2 = Array(r);
      numeric.div, numeric.sub;
      s = Math.max;
      var l, f2, p, m, d, h, g = Math.abs, y = Math.min, v2 = 0;
      for (i2 = 0; i2 < r; i2++) for (var x2 = s(1e-6 * n, 1e-8); ; ) {
        if (++v2 > 20) throw new Error("Numerical gradient fails");
        if (u[i2] = t2[i2] + x2, a = e2(u), u[i2] = t2[i2] - x2, o = e2(u), u[i2] = t2[i2], isNaN(a) || isNaN(o)) x2 /= 16;
        else {
          if (c2[i2] = (a - o) / (2 * x2), l = t2[i2] - x2, f2 = t2[i2], p = t2[i2] + x2, m = (a - n) / x2, d = (n - o) / x2, h = s(g(c2[i2]), g(n), g(a), g(o), g(l), g(f2), g(p), 1e-8), !(y(s(g(m - c2[i2]), g(d - c2[i2]), g(m - d)) / h, x2 / h) > 1e-3)) break;
          x2 /= 16;
        }
      }
      return c2;
    }, numeric.uncmin = function(e2, t2, r, n, i2, a, o) {
      var s = numeric.gradient;
      void 0 === o && (o = {}), void 0 === r && (r = 1e-8), void 0 === n && (n = function(t22) {
        return s(e2, t22);
      }), void 0 === i2 && (i2 = 1e3);
      var u, c2, l = (t2 = numeric.clone(t2)).length, f2 = e2(t2);
      if (isNaN(f2)) throw new Error("uncmin: f(x0) is a NaN!");
      var p = Math.max, m = numeric.norm2;
      r = p(r, numeric.epsilon);
      var d, h, g, y = o.Hinv || numeric.identity(l), v2 = numeric.dot;
      numeric.inv;
      var x2, b2, _2, w2, A2, N, D, E = numeric.sub, $2 = numeric.add, S2 = numeric.tensor, C2 = numeric.div, M2 = numeric.mul, T2 = numeric.all, F = numeric.isFinite, O2 = numeric.neg, k2 = 0, B2 = "";
      for (h = n(t2); k2 < i2; ) {
        if ("function" == typeof a && a(k2, t2, f2, h, y)) {
          B2 = "Callback returned true";
          break;
        }
        if (!T2(F(h))) {
          B2 = "Gradient has Infinity or NaN";
          break;
        }
        if (!T2(F(d = O2(v2(y, h))))) {
          B2 = "Search direction has Infinity or NaN";
          break;
        }
        if ((D = m(d)) < r) {
          B2 = "Newton step smaller than tol";
          break;
        }
        for (N = 1, c2 = v2(h, d), b2 = t2; k2 < i2 && !(N * D < r) && (b2 = $2(t2, x2 = M2(d, N)), (u = e2(b2)) - f2 >= 0.1 * N * c2 || isNaN(u)); ) N *= 0.5, ++k2;
        if (N * D < r) {
          B2 = "Line search step size smaller than tol";
          break;
        }
        if (k2 === i2) {
          B2 = "maxit reached during line search";
          break;
        }
        A2 = v2(_2 = E(g = n(b2), h), x2), w2 = v2(y, _2), y = E($2(y, M2((A2 + v2(_2, w2)) / (A2 * A2), S2(x2, x2))), C2($2(S2(w2, x2), S2(x2, w2)), A2)), t2 = b2, f2 = u, h = g, ++k2;
      }
      return { solution: t2, f: f2, gradient: h, invHessian: y, iterations: k2, message: B2 };
    }, numeric.Dopri = function(e2, t2, r, n, i2, a, o) {
      this.x = e2, this.y = t2, this.f = r, this.ymid = n, this.iterations = i2, this.events = o, this.message = a;
    }, numeric.Dopri.prototype._at = function(e2, t2) {
      function r(e3) {
        return e3 * e3;
      }
      var n, i2, a, o, s, u, c2 = this, l = c2.x, f2 = c2.y, p = c2.f, m = c2.ymid;
      l.length;
      var d, h, g, y = numeric.add, v2 = numeric.mul, x2 = numeric.sub;
      return n = l[t2], i2 = l[t2 + 1], o = f2[t2], s = f2[t2 + 1], a = n + 0.5 * (i2 - n), u = m[t2], d = x2(p[t2], v2(o, 1 / (n - a) + 2 / (n - i2))), h = x2(p[t2 + 1], v2(s, 1 / (i2 - a) + 2 / (i2 - n))), y(y(y(y(v2(o, (g = [r(e2 - i2) * (e2 - a) / r(n - i2) / (n - a), r(e2 - n) * r(e2 - i2) / r(n - a) / r(i2 - a), r(e2 - n) * (e2 - a) / r(i2 - n) / (i2 - a), (e2 - n) * r(e2 - i2) * (e2 - a) / r(n - i2) / (n - a), (e2 - i2) * r(e2 - n) * (e2 - a) / r(n - i2) / (i2 - a)])[0]), v2(u, g[1])), v2(s, g[2])), v2(d, g[3])), v2(h, g[4]));
    }, numeric.Dopri.prototype.at = function(e2) {
      var t2, r, n, i2 = Math.floor;
      if ("number" != typeof e2) {
        var a = e2.length, o = Array(a);
        for (t2 = a - 1; -1 !== t2; --t2) o[t2] = this.at(e2[t2]);
        return o;
      }
      var s = this.x;
      for (t2 = 0, r = s.length - 1; r - t2 > 1; ) s[n = i2(0.5 * (t2 + r))] <= e2 ? t2 = n : r = n;
      return this._at(e2, t2);
    }, numeric.dopri = function(e2, t2, r, n, i2, a, o) {
      void 0 === i2 && (i2 = 1e-6), void 0 === a && (a = 1e3);
      var s, u, c2, l, f2, p, m, d, h, g, y, v2, x2, b2 = [e2], _2 = [r], w2 = [n(e2, r)], A2 = [], N = [3 / 40, 9 / 40], D = [44 / 45, -56 / 15, 32 / 9], E = [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], $2 = [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], S2 = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84], C2 = [0.10013431883002395, 0, 0.3918321794184259, -0.02982460176594817, 0.05893268337240795, -0.04497888809104361, 56185495e-1 / 235043384], M2 = [0.2, 0.3, 0.8, 8 / 9, 1, 1], T2 = [-71 / 57600, 0, 71 / 16695, -71 / 1920, 17253 / 339200, -22 / 525, 1 / 40], F = 0, O2 = (t2 - e2) / 10, k2 = 0, B2 = numeric.add, I2 = numeric.mul, R2 = Math.min, q2 = Math.abs, z2 = numeric.norminf, P2 = Math.pow, L2 = numeric.any, j2 = numeric.lt, U2 = numeric.and;
      numeric.sub;
      var Z2 = new numeric.Dopri(b2, _2, w2, A2, -1, "");
      for ("function" == typeof o && (y = o(e2, r)); e2 < t2 && k2 < a; ) if (++k2, e2 + O2 > t2 && (O2 = t2 - e2), s = n(e2 + M2[0] * O2, B2(r, I2(0.2 * O2, w2[F]))), u = n(e2 + M2[1] * O2, B2(B2(r, I2(N[0] * O2, w2[F])), I2(N[1] * O2, s))), c2 = n(e2 + M2[2] * O2, B2(B2(B2(r, I2(D[0] * O2, w2[F])), I2(D[1] * O2, s)), I2(D[2] * O2, u))), l = n(e2 + M2[3] * O2, B2(B2(B2(B2(r, I2(E[0] * O2, w2[F])), I2(E[1] * O2, s)), I2(E[2] * O2, u)), I2(E[3] * O2, c2))), f2 = n(e2 + M2[4] * O2, B2(B2(B2(B2(B2(r, I2($2[0] * O2, w2[F])), I2($2[1] * O2, s)), I2($2[2] * O2, u)), I2($2[3] * O2, c2)), I2($2[4] * O2, l))), p = n(e2 + O2, h = B2(B2(B2(B2(B2(r, I2(w2[F], O2 * S2[0])), I2(u, O2 * S2[2])), I2(c2, O2 * S2[3])), I2(l, O2 * S2[4])), I2(f2, O2 * S2[5]))), (g = "number" == typeof (m = B2(B2(B2(B2(B2(I2(w2[F], O2 * T2[0]), I2(u, O2 * T2[2])), I2(c2, O2 * T2[3])), I2(l, O2 * T2[4])), I2(f2, O2 * T2[5])), I2(p, O2 * T2[6]))) ? q2(m) : z2(m)) > i2) {
        if (e2 + (O2 = 0.2 * O2 * P2(i2 / g, 0.25)) === e2) {
          Z2.msg = "Step size became too small";
          break;
        }
      } else {
        if (A2[F] = B2(B2(B2(B2(B2(B2(r, I2(w2[F], O2 * C2[0])), I2(u, O2 * C2[2])), I2(c2, O2 * C2[3])), I2(l, O2 * C2[4])), I2(f2, O2 * C2[5])), I2(p, O2 * C2[6])), b2[++F] = e2 + O2, _2[F] = h, w2[F] = p, "function" == typeof o) {
          var G2, V2, H2 = e2, X2 = e2 + 0.5 * O2;
          if (v2 = o(X2, A2[F - 1]), L2(x2 = U2(j2(y, 0), j2(0, v2))) || (H2 = X2, y = v2, v2 = o(X2 = e2 + O2, h), x2 = U2(j2(y, 0), j2(0, v2))), L2(x2)) {
            for (var W2, Q2, Y2 = 0, J = 1, K2 = 1; ; ) {
              if ("number" == typeof y) V2 = (K2 * v2 * H2 - J * y * X2) / (K2 * v2 - J * y);
              else for (V2 = X2, d = y.length - 1; -1 !== d; --d) y[d] < 0 && v2[d] > 0 && (V2 = R2(V2, (K2 * v2[d] * H2 - J * y[d] * X2) / (K2 * v2[d] - J * y[d])));
              if (V2 <= H2 || V2 >= X2) break;
              Q2 = o(V2, G2 = Z2._at(V2, F - 1)), L2(W2 = U2(j2(y, 0), j2(0, Q2))) ? (X2 = V2, v2 = Q2, x2 = W2, K2 = 1, -1 === Y2 ? J *= 0.5 : J = 1, Y2 = -1) : (H2 = V2, y = Q2, J = 1, 1 === Y2 ? K2 *= 0.5 : K2 = 1, Y2 = 1);
            }
            return h = Z2._at(0.5 * (e2 + V2), F - 1), Z2.f[F] = n(V2, G2), Z2.x[F] = V2, Z2.y[F] = G2, Z2.ymid[F - 1] = h, Z2.events = x2, Z2.iterations = k2, Z2;
          }
        }
        e2 += O2, r = h, y = v2, O2 = R2(0.8 * O2 * P2(i2 / g, 0.25), 4 * O2);
      }
      return Z2.iterations = k2, Z2;
    }, numeric.LU = function(e2, t2) {
      t2 = t2 || false;
      var r, n, i2, a, o, s, u, c2, l, f2 = Math.abs, p = e2.length, m = p - 1, d = new Array(p);
      for (t2 || (e2 = numeric.clone(e2)), i2 = 0; i2 < p; ++i2) {
        for (u = i2, l = f2((s = e2[i2])[i2]), n = i2 + 1; n < p; ++n) l < (a = f2(e2[n][i2])) && (l = a, u = n);
        for (d[i2] = u, u != i2 && (e2[i2] = e2[u], e2[u] = s, s = e2[i2]), o = s[i2], r = i2 + 1; r < p; ++r) e2[r][i2] /= o;
        for (r = i2 + 1; r < p; ++r) {
          for (c2 = e2[r], n = i2 + 1; n < m; ++n) c2[n] -= c2[i2] * s[n], c2[++n] -= c2[i2] * s[n];
          n === m && (c2[n] -= c2[i2] * s[n]);
        }
      }
      return { LU: e2, P: d };
    }, numeric.LUsolve = function(e2, t2) {
      var r, n, i2, a, o, s = e2.LU, u = s.length, c2 = numeric.clone(t2), l = e2.P;
      for (r = u - 1; -1 !== r; --r) c2[r] = t2[r];
      for (r = 0; r < u; ++r) for (i2 = l[r], l[r] !== r && (o = c2[r], c2[r] = c2[i2], c2[i2] = o), a = s[r], n = 0; n < r; ++n) c2[r] -= c2[n] * a[n];
      for (r = u - 1; r >= 0; --r) {
        for (a = s[r], n = r + 1; n < u; ++n) c2[r] -= c2[n] * a[n];
        c2[r] /= a[r];
      }
      return c2;
    }, numeric.solve = function(e2, t2, r) {
      return numeric.LUsolve(numeric.LU(e2, r), t2);
    }, numeric.echelonize = function(e2) {
      var t2, r, n, i2, a, o, s, u, c2 = numeric.dim(e2), l = c2[0], f2 = c2[1], p = numeric.identity(l), m = Array(l), d = Math.abs, h = numeric.diveq;
      for (e2 = numeric.clone(e2), t2 = 0; t2 < l; ++t2) {
        for (n = 0, a = e2[t2], o = p[t2], r = 1; r < f2; ++r) d(a[n]) < d(a[r]) && (n = r);
        for (m[t2] = n, h(o, a[n]), h(a, a[n]), r = 0; r < l; ++r) if (r !== t2) {
          for (u = (s = e2[r])[n], i2 = f2 - 1; -1 !== i2; --i2) s[i2] -= a[i2] * u;
          for (s = p[r], i2 = l - 1; -1 !== i2; --i2) s[i2] -= o[i2] * u;
        }
      }
      return { I: p, A: e2, P: m };
    }, numeric.__solveLP = function(e2, t2, r, n, i2, a, o) {
      var s = numeric.sum;
      numeric.log;
      var u, c2 = numeric.mul, l = numeric.sub, f2 = numeric.dot, p = numeric.div, m = numeric.add, d = e2.length, h = r.length, g = false, y = 1;
      numeric.transpose(t2), numeric.svd;
      var v2 = numeric.transpose;
      numeric.leq;
      var x2 = Math.sqrt, b2 = Math.abs;
      numeric.muleq, numeric.norminf, numeric.any;
      var _2, w2 = Math.min, A2 = numeric.all, N = numeric.gt, D = Array(d), E = Array(h);
      numeric.rep([h], 1);
      var $2, S2, C2 = numeric.solve, M2 = l(r, f2(t2, a)), T2 = f2(e2, e2);
      for ($2 = 0; $2 < i2; ++$2) {
        var F, O2;
        for (F = h - 1; -1 !== F; --F) E[F] = p(t2[F], M2[F]);
        var k2 = v2(E);
        for (F = d - 1; -1 !== F; --F) D[F] = s(k2[F]);
        y = 0.25 * b2(T2 / f2(e2, D));
        var B2 = 100 * x2(T2 / f2(D, D));
        for ((!isFinite(y) || y > B2) && (y = B2), S2 = m(e2, c2(y, D)), _2 = f2(k2, E), F = d - 1; -1 !== F; --F) _2[F][F] += 1;
        O2 = C2(_2, p(S2, y), true);
        var I2 = p(M2, f2(t2, O2)), R2 = 1;
        for (F = h - 1; -1 !== F; --F) I2[F] < 0 && (R2 = w2(R2, -0.999 * I2[F]));
        if (u = l(a, c2(O2, R2)), !A2(N(M2 = l(r, f2(t2, u)), 0))) return { solution: a, message: "", iterations: $2 };
        if (a = u, y < n) return { solution: u, message: "", iterations: $2 };
        if (o) {
          var q2 = f2(e2, S2), z2 = f2(t2, S2);
          for (g = true, F = h - 1; -1 !== F; --F) if (q2 * z2[F] < 0) {
            g = false;
            break;
          }
        } else g = !(a[d - 1] >= 0);
        if (g) return { solution: u, message: "Unbounded", iterations: $2 };
      }
      return { solution: a, message: "maximum iteration count exceeded", iterations: $2 };
    }, numeric._solveLP = function(e2, t2, r, n, i2) {
      var a = e2.length, o = r.length;
      numeric.sum, numeric.log, numeric.mul;
      var s = numeric.sub, u = numeric.dot;
      numeric.div, numeric.add;
      var c2 = numeric.rep([a], 0).concat([1]), l = numeric.rep([o, 1], -1), f2 = numeric.blockMatrix([[t2, l]]), p = r, m = numeric.rep([a], 0).concat(Math.max(0, numeric.sup(numeric.neg(r))) + 1), d = numeric.__solveLP(c2, f2, p, n, i2, m, false), h = numeric.clone(d.solution);
      if (h.length = a, numeric.inf(s(r, u(t2, h))) < 0) return { solution: NaN, message: "Infeasible", iterations: d.iterations };
      var g = numeric.__solveLP(e2, t2, r, n, i2 - d.iterations, h, true);
      return g.iterations += d.iterations, g;
    }, numeric.solveLP = function(e2, t2, r, n, i2, a, o) {
      if (void 0 === o && (o = 1e3), void 0 === a && (a = numeric.epsilon), void 0 === n) return numeric._solveLP(e2, t2, r, a, o);
      var s, u = n.length, c2 = n[0].length, l = t2.length, f2 = numeric.echelonize(n), p = numeric.rep([c2], 0), m = f2.P, d = [];
      for (s = m.length - 1; -1 !== s; --s) p[m[s]] = 1;
      for (s = c2 - 1; -1 !== s; --s) 0 === p[s] && d.push(s);
      var h = numeric.getRange, g = numeric.linspace(0, u - 1), y = numeric.linspace(0, l - 1), v2 = h(n, g, d), x2 = h(t2, y, m), b2 = h(t2, y, d), _2 = numeric.dot, w2 = numeric.sub, A2 = _2(x2, f2.I), N = w2(b2, _2(A2, v2)), D = w2(r, _2(A2, i2)), E = Array(m.length), $2 = Array(d.length);
      for (s = m.length - 1; -1 !== s; --s) E[s] = e2[m[s]];
      for (s = d.length - 1; -1 !== s; --s) $2[s] = e2[d[s]];
      var S2 = w2($2, _2(E, _2(f2.I, v2))), C2 = numeric._solveLP(S2, N, D, a, o), M2 = C2.solution;
      if (M2 != M2) return C2;
      var T2 = _2(f2.I, w2(i2, _2(v2, M2))), F = Array(e2.length);
      for (s = m.length - 1; -1 !== s; --s) F[m[s]] = T2[s];
      for (s = d.length - 1; -1 !== s; --s) F[d[s]] = M2[s];
      return { solution: F, message: C2.message, iterations: C2.iterations };
    }, numeric.MPStoLP = function(e2) {
      e2 instanceof String && e2.split("\n");
      var t2, r, n, i2, a = 0, o = ["Initial state", "NAME", "ROWS", "COLUMNS", "RHS", "BOUNDS", "ENDATA"], s = e2.length, u = 0, c2 = {}, l = [], f2 = 0, p = {}, m = 0, d = [], h = [], g = [];
      function y(r2) {
        throw new Error("MPStoLP: " + r2 + "\nLine " + t2 + ": " + e2[t2] + "\nCurrent state: " + o[a] + "\n");
      }
      for (t2 = 0; t2 < s; ++t2) {
        var v2 = (n = e2[t2]).match(/\S*/g), x2 = [];
        for (r = 0; r < v2.length; ++r) "" !== v2[r] && x2.push(v2[r]);
        if (0 !== x2.length) {
          for (r = 0; r < o.length && n.substr(0, o[r].length) !== o[r]; ++r) ;
          if (r < o.length) {
            if (a = r, 1 === r && (i2 = x2[1]), 6 === r) return { name: i2, c: d, A: numeric.transpose(h), b: g, rows: c2, vars: p };
          } else switch (a) {
            case 0:
            case 1:
              y("Unexpected line");
            case 2:
              switch (x2[0]) {
                case "N":
                  0 === u ? u = x2[1] : y("Two or more N rows");
                  break;
                case "L":
                  c2[x2[1]] = f2, l[f2] = 1, g[f2] = 0, ++f2;
                  break;
                case "G":
                  c2[x2[1]] = f2, l[f2] = -1, g[f2] = 0, ++f2;
                  break;
                case "E":
                  c2[x2[1]] = f2, l[f2] = 0, g[f2] = 0, ++f2;
                  break;
                default:
                  y("Parse error " + numeric.prettyPrint(x2));
              }
              break;
            case 3:
              p.hasOwnProperty(x2[0]) || (p[x2[0]] = m, d[m] = 0, h[m] = numeric.rep([f2], 0), ++m);
              var b2 = p[x2[0]];
              for (r = 1; r < x2.length; r += 2) if (x2[r] !== u) {
                var _2 = c2[x2[r]];
                h[b2][_2] = (l[_2] < 0 ? -1 : 1) * parseFloat(x2[r + 1]);
              } else d[b2] = parseFloat(x2[r + 1]);
              break;
            case 4:
              for (r = 1; r < x2.length; r += 2) g[c2[x2[r]]] = (l[c2[x2[r]]] < 0 ? -1 : 1) * parseFloat(x2[r + 1]);
              break;
            case 5:
              break;
            case 6:
              y("Internal error");
          }
        }
      }
      y("Reached end of file without ENDATA");
    }, numeric.seedrandom = { pow: Math.pow, random: Math.random }, (function(e2, t2, r, n, i2, a, o) {
      function s(e3) {
        var t22, n3, i22 = this, a2 = e3.length, o2 = 0, s2 = i22.i = i22.j = i22.m = 0;
        for (i22.S = [], i22.c = [], a2 || (e3 = [a2++]); o2 < r; ) i22.S[o2] = o2++;
        for (o2 = 0; o2 < r; o2++) s2 = l(s2 + (t22 = i22.S[o2]) + e3[o2 % a2]), n3 = i22.S[s2], i22.S[o2] = n3, i22.S[s2] = t22;
        i22.g = function(e4) {
          var t3 = i22.S, n4 = l(i22.i + 1), a3 = t3[n4], o3 = l(i22.j + a3), s3 = t3[o3];
          t3[n4] = s3, t3[o3] = a3;
          for (var u2 = t3[l(a3 + s3)]; --e4; ) n4 = l(n4 + 1), s3 = t3[o3 = l(o3 + (a3 = t3[n4]))], t3[n4] = s3, t3[o3] = a3, u2 = u2 * r + t3[l(a3 + s3)];
          return i22.i = n4, i22.j = o3, u2;
        }, i22.g(r);
      }
      function u(e3, t22, r2, n3, i22) {
        if (r2 = [], i22 = typeof e3, t22 && "object" == i22) {
          for (n3 in e3) if (n3.indexOf("S") < 5) try {
            r2.push(u(e3[n3], t22 - 1));
          } catch (e4) {
          }
        }
        return r2.length ? r2 : e3 + ("string" != i22 ? "\0" : "");
      }
      function c2(e3, t22, r2, n3) {
        for (e3 += "", r2 = 0, n3 = 0; n3 < e3.length; n3++) t22[l(n3)] = l((r2 ^= 19 * t22[l(n3)]) + e3.charCodeAt(n3));
        for (n3 in e3 = "", t22) e3 += String.fromCharCode(t22[n3]);
        return e3;
      }
      function l(e3) {
        return 255 & e3;
      }
      t2.seedrandom = function(n3, l2) {
        var f2, p = [];
        return n3 = c2(u(l2 ? [n3, e2] : arguments.length ? n3 : [(/* @__PURE__ */ new Date()).getTime(), e2, window], 3), p), c2((f2 = new s(p)).S, e2), t2.random = function() {
          for (var e3 = f2.g(6), t22 = o, n4 = 0; e3 < i2; ) e3 = (e3 + n4) * r, t22 *= r, n4 = f2.g(1);
          for (; e3 >= a; ) e3 /= 2, t22 /= 2, n4 >>>= 1;
          return (e3 + n4) / t22;
        }, n3;
      }, o = t2.pow(r, 6), i2 = t2.pow(2, i2), a = 2 * i2, c2(t2.random(), e2);
    })([], numeric.seedrandom, 256, 0, 52), (function(e2) {
      function t2(e3) {
        if ("object" != typeof e3) return e3;
        var r2, n3 = [], i2 = e3.length;
        for (r2 = 0; r2 < i2; r2++) n3[r2 + 1] = t2(e3[r2]);
        return n3;
      }
      function r(e3) {
        if ("object" != typeof e3) return e3;
        var t22, n3 = [], i2 = e3.length;
        for (t22 = 1; t22 < i2; t22++) n3[t22 - 1] = r(e3[t22]);
        return n3;
      }
      function n(e3, t22, r2, n3, i2, a, o, s, u, c2, l, f2, p, m, d, h) {
        var g, y, v2, x2, b2, _2, w2, A2, N, D, E, $2, S2, C2, M2, T2, F, O2, k2, B2, I2, R2, q2, z2, P2, L2, j2;
        S2 = Math.min(n3, c2), v2 = 2 * n3 + S2 * (S2 + 5) / 2 + 2 * c2 + 1, z2 = 1e-60;
        do {
          P2 = 1 + 0.1 * (z2 += z2), L2 = 1 + 0.2 * z2;
        } while (P2 <= 1 || L2 <= 1);
        for (g = 1; g <= n3; g += 1) d[g] = t22[g];
        for (g = n3 + 1; g <= v2; g += 1) d[g] = 0;
        for (g = 1; g <= c2; g += 1) f2[g] = 0;
        if (b2 = [], 0 === h[1]) {
          if ((function(e4, t3, r3, n4) {
            var i22, a2, o2, s2, u2, c3;
            for (a2 = 1; a2 <= r3; a2 += 1) {
              if (n4[1] = a2, c3 = 0, (o2 = a2 - 1) < 1) {
                if ((c3 = e4[a2][a2] - c3) <= 0) break;
                e4[a2][a2] = Math.sqrt(c3);
              } else {
                for (s2 = 1; s2 <= o2; s2 += 1) {
                  for (u2 = e4[s2][a2], i22 = 1; i22 < s2; i22 += 1) u2 -= e4[i22][a2] * e4[i22][s2];
                  u2 /= e4[s2][s2], e4[s2][a2] = u2, c3 += u2 * u2;
                }
                if ((c3 = e4[a2][a2] - c3) <= 0) break;
                e4[a2][a2] = Math.sqrt(c3);
              }
              n4[1] = 0;
            }
          })(e3, 0, n3, b2), 0 !== b2[1]) return void (h[1] = 2);
          !(function(e4, t3, r3, n4) {
            var i22, a2, o2, s2;
            for (a2 = 1; a2 <= r3; a2 += 1) {
              for (s2 = 0, i22 = 1; i22 < a2; i22 += 1) s2 += e4[i22][a2] * n4[i22];
              n4[a2] = (n4[a2] - s2) / e4[a2][a2];
            }
            for (o2 = 1; o2 <= r3; o2 += 1) for (n4[a2 = r3 + 1 - o2] = n4[a2] / e4[a2][a2], s2 = -n4[a2], i22 = 1; i22 < a2; i22 += 1) n4[i22] = n4[i22] + s2 * e4[i22][a2];
          })(e3, 0, n3, t22), (function(e4, t3, r3) {
            var n4, i22, a2, o2, s2;
            for (a2 = 1; a2 <= r3; a2 += 1) {
              for (e4[a2][a2] = 1 / e4[a2][a2], s2 = -e4[a2][a2], n4 = 1; n4 < a2; n4 += 1) e4[n4][a2] = s2 * e4[n4][a2];
              if (r3 < (o2 = a2 + 1)) break;
              for (i22 = o2; i22 <= r3; i22 += 1) for (s2 = e4[a2][i22], e4[a2][i22] = 0, n4 = 1; n4 <= a2; n4 += 1) e4[n4][i22] = e4[n4][i22] + s2 * e4[n4][a2];
            }
          })(e3, 0, n3);
        } else {
          for (y = 1; y <= n3; y += 1) for (i2[y] = 0, g = 1; g <= y; g += 1) i2[y] = i2[y] + e3[g][y] * t22[g];
          for (y = 1; y <= n3; y += 1) for (t22[y] = 0, g = y; g <= n3; g += 1) t22[y] = t22[y] + e3[y][g] * i2[g];
        }
        for (a[1] = 0, y = 1; y <= n3; y += 1) for (i2[y] = t22[y], a[1] = a[1] + d[y] * i2[y], d[y] = 0, g = y + 1; g <= n3; g += 1) e3[g][y] = 0;
        for (a[1] = -a[1] / 2, h[1] = 0, C2 = (D = (N = (E = (A2 = (w2 = n3) + n3) + S2) + S2 + 1) + S2 * (S2 + 1) / 2) + c2, g = 1; g <= c2; g += 1) {
          for (T2 = 0, y = 1; y <= n3; y += 1) T2 += o[y][g] * o[y][g];
          d[C2 + g] = Math.sqrt(T2);
        }
        function U2() {
          for (m[1] = m[1] + 1, v2 = D, g = 1; g <= c2; g += 1) {
            for (v2 += 1, T2 = -s[g], y = 1; y <= n3; y += 1) T2 += o[y][g] * i2[y];
            if (Math.abs(T2) < z2 && (T2 = 0), g > l) d[v2] = T2;
            else if (d[v2] = -Math.abs(T2), T2 > 0) {
              for (y = 1; y <= n3; y += 1) o[y][g] = -o[y][g];
              s[g] = -s[g];
            }
          }
          for (g = 1; g <= p; g += 1) d[D + f2[g]] = 0;
          for ($2 = 0, M2 = 0, g = 1; g <= c2; g += 1) d[D + g] < M2 * d[C2 + g] && ($2 = g, M2 = d[D + g] / d[C2 + g]);
          return 0 === $2 ? 999 : 0;
        }
        function Z2() {
          for (g = 1; g <= n3; g += 1) {
            for (T2 = 0, y = 1; y <= n3; y += 1) T2 += e3[y][g] * o[y][$2];
            d[g] = T2;
          }
          for (x2 = w2, g = 1; g <= n3; g += 1) d[x2 + g] = 0;
          for (y = p + 1; y <= n3; y += 1) for (g = 1; g <= n3; g += 1) d[x2 + g] = d[x2 + g] + e3[g][y] * d[y];
          for (R2 = true, g = p; g >= 1; g -= 1) {
            for (T2 = d[g], x2 = (v2 = N + g * (g + 3) / 2) - g, y = g + 1; y <= p; y += 1) T2 -= d[v2] * d[A2 + y], v2 += y;
            if (T2 /= d[x2], d[A2 + g] = T2, f2[g] < l) break;
            if (T2 < 0) break;
            R2 = false, _2 = g;
          }
          if (!R2) for (F = d[E + _2] / d[A2 + _2], g = 1; g <= p && !(f2[g] < l) && !(d[A2 + g] < 0); g += 1) (M2 = d[E + g] / d[A2 + g]) < F && (F = M2, _2 = g);
          for (T2 = 0, g = w2 + 1; g <= w2 + n3; g += 1) T2 += d[g] * d[g];
          if (Math.abs(T2) <= z2) {
            if (R2) return h[1] = 1, 999;
            for (g = 1; g <= p; g += 1) d[E + g] = d[E + g] - F * d[A2 + g];
            return d[E + p + 1] = d[E + p + 1] + F, 700;
          }
          for (T2 = 0, g = 1; g <= n3; g += 1) T2 += d[w2 + g] * o[g][$2];
          for (O2 = -d[D + $2] / T2, q2 = true, R2 || F < O2 && (O2 = F, q2 = false), g = 1; g <= n3; g += 1) i2[g] = i2[g] + O2 * d[w2 + g], Math.abs(i2[g]) < z2 && (i2[g] = 0);
          for (a[1] = a[1] + O2 * T2 * (O2 / 2 + d[E + p + 1]), g = 1; g <= p; g += 1) d[E + g] = d[E + g] - O2 * d[A2 + g];
          if (d[E + p + 1] = d[E + p + 1] + O2, !q2) {
            for (T2 = -s[$2], y = 1; y <= n3; y += 1) T2 += i2[y] * o[y][$2];
            if ($2 > l) d[D + $2] = T2;
            else if (d[D + $2] = -Math.abs(T2), T2 > 0) {
              for (y = 1; y <= n3; y += 1) o[y][$2] = -o[y][$2];
              s[$2] = -s[$2];
            }
            return 700;
          }
          for (f2[p += 1] = $2, v2 = N + (p - 1) * p / 2 + 1, g = 1; g <= p - 1; g += 1) d[v2] = d[g], v2 += 1;
          if (p === n3) d[v2] = d[n3];
          else {
            for (g = n3; g >= p + 1 && 0 !== d[g] && (k2 = Math.max(Math.abs(d[g - 1]), Math.abs(d[g])), B2 = Math.min(Math.abs(d[g - 1]), Math.abs(d[g])), M2 = d[g - 1] >= 0 ? Math.abs(k2 * Math.sqrt(1 + B2 * B2 / (k2 * k2))) : -Math.abs(k2 * Math.sqrt(1 + B2 * B2 / (k2 * k2))), k2 = d[g - 1] / M2, B2 = d[g] / M2, 1 !== k2); g -= 1) if (0 === k2) for (d[g - 1] = B2 * M2, y = 1; y <= n3; y += 1) M2 = e3[y][g - 1], e3[y][g - 1] = e3[y][g], e3[y][g] = M2;
            else for (d[g - 1] = M2, I2 = B2 / (1 + k2), y = 1; y <= n3; y += 1) M2 = k2 * e3[y][g - 1] + B2 * e3[y][g], e3[y][g] = I2 * (e3[y][g - 1] + M2) - e3[y][g], e3[y][g - 1] = M2;
            d[v2] = d[p];
          }
          return 0;
        }
        function G2() {
          if (0 === d[x2 = (v2 = N + _2 * (_2 + 1) / 2 + 1) + _2]) return 798;
          if (k2 = Math.max(Math.abs(d[x2 - 1]), Math.abs(d[x2])), B2 = Math.min(Math.abs(d[x2 - 1]), Math.abs(d[x2])), M2 = d[x2 - 1] >= 0 ? Math.abs(k2 * Math.sqrt(1 + B2 * B2 / (k2 * k2))) : -Math.abs(k2 * Math.sqrt(1 + B2 * B2 / (k2 * k2))), k2 = d[x2 - 1] / M2, B2 = d[x2] / M2, 1 === k2) return 798;
          if (0 === k2) {
            for (g = _2 + 1; g <= p; g += 1) M2 = d[x2 - 1], d[x2 - 1] = d[x2], d[x2] = M2, x2 += g;
            for (g = 1; g <= n3; g += 1) M2 = e3[g][_2], e3[g][_2] = e3[g][_2 + 1], e3[g][_2 + 1] = M2;
          } else {
            for (I2 = B2 / (1 + k2), g = _2 + 1; g <= p; g += 1) M2 = k2 * d[x2 - 1] + B2 * d[x2], d[x2] = I2 * (d[x2 - 1] + M2) - d[x2], d[x2 - 1] = M2, x2 += g;
            for (g = 1; g <= n3; g += 1) M2 = k2 * e3[g][_2] + B2 * e3[g][_2 + 1], e3[g][_2 + 1] = I2 * (e3[g][_2] + M2) - e3[g][_2 + 1], e3[g][_2] = M2;
          }
          return 0;
        }
        function V2() {
          for (x2 = v2 - _2, g = 1; g <= _2; g += 1) d[x2] = d[v2], v2 += 1, x2 += 1;
          return d[E + _2] = d[E + _2 + 1], f2[_2] = f2[_2 + 1], (_2 += 1) < p ? 797 : 0;
        }
        function H2() {
          return d[E + p] = d[E + p + 1], d[E + p + 1] = 0, f2[p] = 0, p -= 1, m[2] = m[2] + 1, 0;
        }
        for (p = 0, m[1] = 0, m[2] = 0, j2 = 0; ; ) {
          if (999 === (j2 = U2())) return;
          for (; 0 !== (j2 = Z2()); ) {
            if (999 === j2) return;
            if (700 === j2) if (_2 === p) H2();
            else {
              for (; G2(), 797 === (j2 = V2()); ) ;
              H2();
            }
          }
        }
      }
      e2.solveQP = function(e3, i2, a, o, s, u) {
        e3 = t2(e3), i2 = t2(i2), a = t2(a);
        var c2, l, f2, p, m, d = [], h = [], g = [], y = [], v2 = [];
        if (s = s || 0, u = u ? t2(u) : [void 0, 0], o = o ? t2(o) : [], l = e3.length - 1, f2 = a[1].length - 1, !o) for (c2 = 1; c2 <= f2; c2 += 1) o[c2] = 0;
        for (c2 = 1; c2 <= f2; c2 += 1) h[c2] = 0;
        for (p = Math.min(l, f2), c2 = 1; c2 <= l; c2 += 1) g[c2] = 0;
        for (d[1] = 0, c2 = 1; c2 <= 2 * l + p * (p + 5) / 2 + 2 * f2 + 1; c2 += 1) y[c2] = 0;
        for (c2 = 1; c2 <= 2; c2 += 1) v2[c2] = 0;
        return n(e3, i2, 0, l, g, d, a, o, 0, f2, s, h, 0, v2, y, u), m = "", 1 === u[1] && (m = "constraints are inconsistent, no solution!"), 2 === u[1] && (m = "matrix D in quadratic function is not positive definite!"), { solution: r(g), value: r(d), unconstrained_solution: r(i2), iterations: r(v2), iact: r(h), message: m };
      };
    })(numeric), numeric.svd = function(e2) {
      var t2, r = numeric.epsilon, n = 1e-64 / r, i2 = 0, a = 0, o = 0, s = 0, u = 0, c2 = numeric.clone(e2), l = c2.length, f2 = c2[0].length;
      if (l < f2) throw "Need more rows than columns";
      var p = new Array(f2), m = new Array(f2);
      for (a = 0; a < f2; a++) p[a] = m[a] = 0;
      var d = numeric.rep([f2, f2], 0);
      function h(e3, t22) {
        return (e3 = Math.abs(e3)) > (t22 = Math.abs(t22)) ? e3 * Math.sqrt(1 + t22 * t22 / e3 / e3) : 0 == t22 ? e3 : t22 * Math.sqrt(1 + e3 * e3 / t22 / t22);
      }
      var g = 0, y = 0, v2 = 0, x2 = 0, b2 = 0, _2 = 0, w2 = 0;
      for (a = 0; a < f2; a++) {
        for (p[a] = y, w2 = 0, u = a + 1, o = a; o < l; o++) w2 += c2[o][a] * c2[o][a];
        if (w2 <= n) y = 0;
        else for (g = c2[a][a], y = Math.sqrt(w2), g >= 0 && (y = -y), v2 = g * y - w2, c2[a][a] = g - y, o = u; o < f2; o++) {
          for (w2 = 0, s = a; s < l; s++) w2 += c2[s][a] * c2[s][o];
          for (g = w2 / v2, s = a; s < l; s++) c2[s][o] += g * c2[s][a];
        }
        for (m[a] = y, w2 = 0, o = u; o < f2; o++) w2 += c2[a][o] * c2[a][o];
        if (w2 <= n) y = 0;
        else {
          for (g = c2[a][a + 1], y = Math.sqrt(w2), g >= 0 && (y = -y), v2 = g * y - w2, c2[a][a + 1] = g - y, o = u; o < f2; o++) p[o] = c2[a][o] / v2;
          for (o = u; o < l; o++) {
            for (w2 = 0, s = u; s < f2; s++) w2 += c2[o][s] * c2[a][s];
            for (s = u; s < f2; s++) c2[o][s] += w2 * p[s];
          }
        }
        (b2 = Math.abs(m[a]) + Math.abs(p[a])) > x2 && (x2 = b2);
      }
      for (a = f2 - 1; -1 != a; a += -1) {
        if (0 != y) {
          for (v2 = y * c2[a][a + 1], o = u; o < f2; o++) d[o][a] = c2[a][o] / v2;
          for (o = u; o < f2; o++) {
            for (w2 = 0, s = u; s < f2; s++) w2 += c2[a][s] * d[s][o];
            for (s = u; s < f2; s++) d[s][o] += w2 * d[s][a];
          }
        }
        for (o = u; o < f2; o++) d[a][o] = 0, d[o][a] = 0;
        d[a][a] = 1, y = p[a], u = a;
      }
      for (a = f2 - 1; -1 != a; a += -1) {
        for (u = a + 1, y = m[a], o = u; o < f2; o++) c2[a][o] = 0;
        if (0 != y) {
          for (v2 = c2[a][a] * y, o = u; o < f2; o++) {
            for (w2 = 0, s = u; s < l; s++) w2 += c2[s][a] * c2[s][o];
            for (g = w2 / v2, s = a; s < l; s++) c2[s][o] += g * c2[s][a];
          }
          for (o = a; o < l; o++) c2[o][a] = c2[o][a] / y;
        } else for (o = a; o < l; o++) c2[o][a] = 0;
        c2[a][a] += 1;
      }
      for (r *= x2, s = f2 - 1; -1 != s; s += -1) for (var A2 = 0; A2 < 50; A2++) {
        var N = false;
        for (u = s; -1 != u; u += -1) {
          if (Math.abs(p[u]) <= r) {
            N = true;
            break;
          }
          if (Math.abs(m[u - 1]) <= r) break;
        }
        if (!N) {
          i2 = 0, w2 = 1;
          var D = u - 1;
          for (a = u; a < s + 1 && (g = w2 * p[a], p[a] = i2 * p[a], !(Math.abs(g) <= r)); a++) for (v2 = h(g, y = m[a]), m[a] = v2, i2 = y / v2, w2 = -g / v2, o = 0; o < l; o++) b2 = c2[o][D], _2 = c2[o][a], c2[o][D] = b2 * i2 + _2 * w2, c2[o][a] = -b2 * w2 + _2 * i2;
        }
        if (_2 = m[s], u == s) {
          if (_2 < 0) for (m[s] = -_2, o = 0; o < f2; o++) d[o][s] = -d[o][s];
          break;
        }
        if (A2 >= 49) throw "Error: no convergence.";
        for (x2 = m[u], y = h(g = (((b2 = m[s - 1]) - _2) * (b2 + _2) + ((y = p[s - 1]) - (v2 = p[s])) * (y + v2)) / (2 * v2 * b2), 1), g = g < 0 ? ((x2 - _2) * (x2 + _2) + v2 * (b2 / (g - y) - v2)) / x2 : ((x2 - _2) * (x2 + _2) + v2 * (b2 / (g + y) - v2)) / x2, i2 = 1, w2 = 1, a = u + 1; a < s + 1; a++) {
          for (y = p[a], b2 = m[a], v2 = w2 * y, y *= i2, _2 = h(g, v2), p[a - 1] = _2, g = x2 * (i2 = g / _2) + y * (w2 = v2 / _2), y = -x2 * w2 + y * i2, v2 = b2 * w2, b2 *= i2, o = 0; o < f2; o++) x2 = d[o][a - 1], _2 = d[o][a], d[o][a - 1] = x2 * i2 + _2 * w2, d[o][a] = -x2 * w2 + _2 * i2;
          for (_2 = h(g, v2), m[a - 1] = _2, g = (i2 = g / _2) * y + (w2 = v2 / _2) * b2, x2 = -w2 * y + i2 * b2, o = 0; o < l; o++) b2 = c2[o][a - 1], _2 = c2[o][a], c2[o][a - 1] = b2 * i2 + _2 * w2, c2[o][a] = -b2 * w2 + _2 * i2;
        }
        p[u] = 0, p[s] = g, m[s] = x2;
      }
      for (a = 0; a < m.length; a++) m[a] < r && (m[a] = 0);
      for (a = 0; a < f2; a++) for (o = a - 1; o >= 0; o--) if (m[o] < m[a]) {
        for (i2 = m[o], m[o] = m[a], m[a] = i2, s = 0; s < c2.length; s++) t2 = c2[s][a], c2[s][a] = c2[s][o], c2[s][o] = t2;
        for (s = 0; s < d.length; s++) t2 = d[s][a], d[s][a] = d[s][o], d[s][o] = t2;
        a = o;
      }
      return { U: c2, S: m, V: d };
    };
  })(numeric1_2_6)), numeric1_2_6;
}
var numeric1_2_6Exports = requireNumeric1_2_6(), numeric = getDefaultExportFromCjs$2(numeric1_2_6Exports);
function createInstance({ define_e: e2 = true, define_pi: t2 = true, define_i: r = true, pow_strict: n = true } = {}) {
  let i2 = { ...all };
  delete i2.createTau, delete i2.createPhi, e2 || delete i2.createE, t2 || delete i2.createPi, r || delete i2.createI;
  let a = create$1(i2);
  a.import(numeric, { wrap: true, silent: true });
  var o = a.pow;
  return n ? a.import({ pow: function(e3, t22) {
    return 0 !== t22 || "number" != typeof e3 || 0 !== e3 && Number.isFinite(e3) ? o(e3, t22) : NaN;
  } }, { override: true }) : a.import({ pow: o }, { override: true }), a.define_e = e2, a.define_pi = t2, a.define_i = r, a.pow_strict = n, a;
}
var math$1 = createInstance();
function leaves(e2, t2) {
  if (!Array.isArray(e2)) return [e2];
  var r = e2[0], n = e2.slice(1);
  return !t2 || "_" !== r || "string" != typeof n[0] || "string" != typeof n[1] && "number" != typeof n[1] ? ("apply" === r && (n = e2.slice(2)), 0 === n.length ? [] : n.map((function(e3, r2) {
    return leaves(e3, t2);
  })).reduce((function(e3, t22) {
    return e3.concat(t22);
  }))) : [n[0] + "_" + n[1]];
}
function variables(e2, t2 = false) {
  var r = leaves(get_tree(e2), t2);
  return r = (r = r.filter((function(e3, t22) {
    return "string" == typeof e3 && (math$1.define_e || "e" !== e3) && (math$1.define_pi || "pi" !== e3) && (math$1.define_i || "i" !== e3);
  }))).filter((function(e3, t22, n) {
    return t22 === r.indexOf(e3);
  }));
}
function operators_list(e2) {
  if (!Array.isArray(e2)) return [];
  var t2 = e2[0], r = e2.slice(1);
  return "apply" === t2 && (r = e2.slice(2)), 0 === r.length ? [t2] : [t2].concat(r.map((function(e3, t22) {
    return operators_list(e3);
  })).reduce((function(e3, t22) {
    return e3.concat(t22);
  })));
}
function operators$3(e2) {
  var t2 = operators_list(get_tree(e2));
  return t2 = (t2 = t2.filter((function(e3, t22) {
    return "apply" !== e3;
  }))).filter((function(e3, r, n) {
    return r === t2.indexOf(e3);
  }));
}
function functions_list(e2) {
  if (!Array.isArray(e2)) return [];
  var t2 = e2[0], r = e2.slice(1), n = [];
  return "apply" === t2 && (n = [r[0]], r = e2.slice(2)), n.concat(r.map((function(e3, t22) {
    return functions_list(e3);
  })).reduce((function(e3, t22) {
    return e3.concat(t22);
  }), []));
}
function functions$2(e2) {
  var t2 = functions_list(get_tree(e2));
  return t2 = t2.filter((function(e3, r, n) {
    return r === t2.indexOf(e3);
  }));
}
var variables$1 = Object.freeze({ __proto__: null, variables, operators: operators$3, functions: functions$2 }), global$1 = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, VERSION = "1.13.6", root = "object" == typeof self && self.self === self && self || "object" == typeof global$1 && global$1.global === global$1 && global$1 || Function("return this")() || {}, ArrayProto = Array.prototype, ObjProto = Object.prototype, SymbolProto = "undefined" != typeof Symbol ? Symbol.prototype : null, push$1 = ArrayProto.push, slice = ArrayProto.slice, toString$1 = ObjProto.toString, hasOwnProperty$4 = ObjProto.hasOwnProperty, supportsArrayBuffer = "undefined" != typeof ArrayBuffer, supportsDataView = "undefined" != typeof DataView, nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeCreate = Object.create, nativeIsView = supportsArrayBuffer && ArrayBuffer.isView, _isNaN = isNaN, _isFinite = isFinite, hasEnumBug = !{ toString: null }.propertyIsEnumerable("toString"), nonEnumerableProps = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"], MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
function restArguments(e2, t2) {
  return t2 = null == t2 ? e2.length - 1 : +t2, function() {
    for (var r = Math.max(arguments.length - t2, 0), n = Array(r), i2 = 0; i2 < r; i2++) n[i2] = arguments[i2 + t2];
    switch (t2) {
      case 0:
        return e2.call(this, n);
      case 1:
        return e2.call(this, arguments[0], n);
      case 2:
        return e2.call(this, arguments[0], arguments[1], n);
    }
    var a = Array(t2 + 1);
    for (i2 = 0; i2 < t2; i2++) a[i2] = arguments[i2];
    return a[t2] = n, e2.apply(this, a);
  };
}
function isObject(e2) {
  var t2 = typeof e2;
  return "function" === t2 || "object" === t2 && !!e2;
}
function isNull(e2) {
  return null === e2;
}
function isUndefined(e2) {
  return void 0 === e2;
}
function isBoolean(e2) {
  return true === e2 || false === e2 || "[object Boolean]" === toString$1.call(e2);
}
function isElement$2(e2) {
  return !(!e2 || 1 !== e2.nodeType);
}
function tagTester(e2) {
  var t2 = "[object " + e2 + "]";
  return function(e3) {
    return toString$1.call(e3) === t2;
  };
}
var isString = tagTester("String"), isNumber = tagTester("Number"), isDate = tagTester("Date"), isRegExp = tagTester("RegExp"), isError = tagTester("Error"), isSymbol = tagTester("Symbol"), isArrayBuffer = tagTester("ArrayBuffer"), isFunction = tagTester("Function"), nodelist = root.document && root.document.childNodes;
"function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof nodelist && (isFunction = function(e2) {
  return "function" == typeof e2 || false;
});
var isFunction$1 = isFunction, hasObjectTag = tagTester("Object"), hasStringTagBug = supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8))), isIE11 = "undefined" != typeof Map && hasObjectTag(/* @__PURE__ */ new Map()), isDataView = tagTester("DataView");
function ie10IsDataView(e2) {
  return null != e2 && isFunction$1(e2.getInt8) && isArrayBuffer(e2.buffer);
}
var isDataView$1 = hasStringTagBug ? ie10IsDataView : isDataView, isArray = nativeIsArray || tagTester("Array");
function has$1(e2, t2) {
  return null != e2 && hasOwnProperty$4.call(e2, t2);
}
var isArguments = tagTester("Arguments");
!(function() {
  isArguments(arguments) || (isArguments = function(e2) {
    return has$1(e2, "callee");
  });
})();
var isArguments$1 = isArguments;
function isFinite$1(e2) {
  return !isSymbol(e2) && _isFinite(e2) && !isNaN(parseFloat(e2));
}
function isNaN$1(e2) {
  return isNumber(e2) && _isNaN(e2);
}
function constant(e2) {
  return function() {
    return e2;
  };
}
function createSizePropertyCheck(e2) {
  return function(t2) {
    var r = e2(t2);
    return "number" == typeof r && r >= 0 && r <= MAX_ARRAY_INDEX;
  };
}
function shallowProperty(e2) {
  return function(t2) {
    return null == t2 ? void 0 : t2[e2];
  };
}
var getByteLength = shallowProperty("byteLength"), isBufferLike = createSizePropertyCheck(getByteLength), typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function isTypedArray(e2) {
  return nativeIsView ? nativeIsView(e2) && !isDataView$1(e2) : isBufferLike(e2) && typedArrayPattern.test(toString$1.call(e2));
}
var isTypedArray$1 = supportsArrayBuffer ? isTypedArray : constant(false), getLength = shallowProperty("length");
function emulatedSet(e2) {
  for (var t2 = {}, r = e2.length, n = 0; n < r; ++n) t2[e2[n]] = true;
  return { contains: function(e3) {
    return true === t2[e3];
  }, push: function(r2) {
    return t2[r2] = true, e2.push(r2);
  } };
}
function collectNonEnumProps(e2, t2) {
  t2 = emulatedSet(t2);
  var r = nonEnumerableProps.length, n = e2.constructor, i2 = isFunction$1(n) && n.prototype || ObjProto, a = "constructor";
  for (has$1(e2, a) && !t2.contains(a) && t2.push(a); r--; ) (a = nonEnumerableProps[r]) in e2 && e2[a] !== i2[a] && !t2.contains(a) && t2.push(a);
}
function keys$1(e2) {
  if (!isObject(e2)) return [];
  if (nativeKeys) return nativeKeys(e2);
  var t2 = [];
  for (var r in e2) has$1(e2, r) && t2.push(r);
  return hasEnumBug && collectNonEnumProps(e2, t2), t2;
}
function isEmpty(e2) {
  if (null == e2) return true;
  var t2 = getLength(e2);
  return "number" == typeof t2 && (isArray(e2) || isString(e2) || isArguments$1(e2)) ? 0 === t2 : 0 === getLength(keys$1(e2));
}
function isMatch(e2, t2) {
  var r = keys$1(t2), n = r.length;
  if (null == e2) return !n;
  for (var i2 = Object(e2), a = 0; a < n; a++) {
    var o = r[a];
    if (t2[o] !== i2[o] || !(o in i2)) return false;
  }
  return true;
}
function _$1(e2) {
  return e2 instanceof _$1 ? e2 : this instanceof _$1 ? void (this._wrapped = e2) : new _$1(e2);
}
function toBufferView(e2) {
  return new Uint8Array(e2.buffer || e2, e2.byteOffset || 0, getByteLength(e2));
}
_$1.VERSION = VERSION, _$1.prototype.value = function() {
  return this._wrapped;
}, _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value, _$1.prototype.toString = function() {
  return String(this._wrapped);
};
var tagDataView = "[object DataView]";
function eq(e2, t2, r, n) {
  if (e2 === t2) return 0 !== e2 || 1 / e2 == 1 / t2;
  if (null == e2 || null == t2) return false;
  if (e2 != e2) return t2 != t2;
  var i2 = typeof e2;
  return ("function" === i2 || "object" === i2 || "object" == typeof t2) && deepEq(e2, t2, r, n);
}
function deepEq(e2, t2, r, n) {
  e2 instanceof _$1 && (e2 = e2._wrapped), t2 instanceof _$1 && (t2 = t2._wrapped);
  var i2 = toString$1.call(e2);
  if (i2 !== toString$1.call(t2)) return false;
  if (hasStringTagBug && "[object Object]" == i2 && isDataView$1(e2)) {
    if (!isDataView$1(t2)) return false;
    i2 = tagDataView;
  }
  switch (i2) {
    case "[object RegExp]":
    case "[object String]":
      return "" + e2 == "" + t2;
    case "[object Number]":
      return +e2 != +e2 ? +t2 != +t2 : 0 == +e2 ? 1 / +e2 == 1 / t2 : +e2 == +t2;
    case "[object Date]":
    case "[object Boolean]":
      return +e2 == +t2;
    case "[object Symbol]":
      return SymbolProto.valueOf.call(e2) === SymbolProto.valueOf.call(t2);
    case "[object ArrayBuffer]":
    case tagDataView:
      return deepEq(toBufferView(e2), toBufferView(t2), r, n);
  }
  var a = "[object Array]" === i2;
  if (!a && isTypedArray$1(e2)) {
    if (getByteLength(e2) !== getByteLength(t2)) return false;
    if (e2.buffer === t2.buffer && e2.byteOffset === t2.byteOffset) return true;
    a = true;
  }
  if (!a) {
    if ("object" != typeof e2 || "object" != typeof t2) return false;
    var o = e2.constructor, s = t2.constructor;
    if (o !== s && !(isFunction$1(o) && o instanceof o && isFunction$1(s) && s instanceof s) && "constructor" in e2 && "constructor" in t2) return false;
  }
  n = n || [];
  for (var u = (r = r || []).length; u--; ) if (r[u] === e2) return n[u] === t2;
  if (r.push(e2), n.push(t2), a) {
    if ((u = e2.length) !== t2.length) return false;
    for (; u--; ) if (!eq(e2[u], t2[u], r, n)) return false;
  } else {
    var c2, l = keys$1(e2);
    if (u = l.length, keys$1(t2).length !== u) return false;
    for (; u--; ) if (!has$1(t2, c2 = l[u]) || !eq(e2[c2], t2[c2], r, n)) return false;
  }
  return r.pop(), n.pop(), true;
}
function isEqual(e2, t2) {
  return eq(e2, t2);
}
function allKeys(e2) {
  if (!isObject(e2)) return [];
  var t2 = [];
  for (var r in e2) t2.push(r);
  return hasEnumBug && collectNonEnumProps(e2, t2), t2;
}
function ie11fingerprint(e2) {
  var t2 = getLength(e2);
  return function(r) {
    if (null == r) return false;
    var n = allKeys(r);
    if (getLength(n)) return false;
    for (var i2 = 0; i2 < t2; i2++) if (!isFunction$1(r[e2[i2]])) return false;
    return e2 !== weakMapMethods || !isFunction$1(r[forEachName]);
  };
}
var forEachName = "forEach", hasName = "has", commonInit = ["clear", "delete"], mapTail = ["get", hasName, "set"], mapMethods = commonInit.concat(forEachName, mapTail), weakMapMethods = commonInit.concat(mapTail), setMethods = ["add"].concat(commonInit, forEachName, hasName), isMap = isIE11 ? ie11fingerprint(mapMethods) : tagTester("Map"), isWeakMap = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester("WeakMap"), isSet = isIE11 ? ie11fingerprint(setMethods) : tagTester("Set"), isWeakSet = tagTester("WeakSet");
function values(e2) {
  for (var t2 = keys$1(e2), r = t2.length, n = Array(r), i2 = 0; i2 < r; i2++) n[i2] = e2[t2[i2]];
  return n;
}
function pairs(e2) {
  for (var t2 = keys$1(e2), r = t2.length, n = Array(r), i2 = 0; i2 < r; i2++) n[i2] = [t2[i2], e2[t2[i2]]];
  return n;
}
function invert(e2) {
  for (var t2 = {}, r = keys$1(e2), n = 0, i2 = r.length; n < i2; n++) t2[e2[r[n]]] = r[n];
  return t2;
}
function functions$1(e2) {
  var t2 = [];
  for (var r in e2) isFunction$1(e2[r]) && t2.push(r);
  return t2.sort();
}
function createAssigner(e2, t2) {
  return function(r) {
    var n = arguments.length;
    if (t2 && (r = Object(r)), n < 2 || null == r) return r;
    for (var i2 = 1; i2 < n; i2++) for (var a = arguments[i2], o = e2(a), s = o.length, u = 0; u < s; u++) {
      var c2 = o[u];
      t2 && void 0 !== r[c2] || (r[c2] = a[c2]);
    }
    return r;
  };
}
var extend$1$1 = createAssigner(allKeys), extendOwn = createAssigner(keys$1), defaults$2 = createAssigner(allKeys, true);
function ctor() {
  return function() {
  };
}
function baseCreate(e2) {
  if (!isObject(e2)) return {};
  if (nativeCreate) return nativeCreate(e2);
  var t2 = ctor();
  t2.prototype = e2;
  var r = new t2();
  return t2.prototype = null, r;
}
function create(e2, t2) {
  var r = baseCreate(e2);
  return t2 && extendOwn(r, t2), r;
}
function clone(e2) {
  return isObject(e2) ? isArray(e2) ? e2.slice() : extend$1$1({}, e2) : e2;
}
function tap(e2, t2) {
  return t2(e2), e2;
}
function toPath$1(e2) {
  return isArray(e2) ? e2 : [e2];
}
function toPath(e2) {
  return _$1.toPath(e2);
}
function deepGet(e2, t2) {
  for (var r = t2.length, n = 0; n < r; n++) {
    if (null == e2) return;
    e2 = e2[t2[n]];
  }
  return r ? e2 : void 0;
}
function get(e2, t2, r) {
  var n = deepGet(e2, toPath(t2));
  return isUndefined(n) ? r : n;
}
function has(e2, t2) {
  for (var r = (t2 = toPath(t2)).length, n = 0; n < r; n++) {
    var i2 = t2[n];
    if (!has$1(e2, i2)) return false;
    e2 = e2[i2];
  }
  return !!r;
}
function identity$2(e2) {
  return e2;
}
function matcher(e2) {
  return e2 = extendOwn({}, e2), function(t2) {
    return isMatch(t2, e2);
  };
}
function property(e2) {
  return e2 = toPath(e2), function(t2) {
    return deepGet(t2, e2);
  };
}
function optimizeCb(e2, t2, r) {
  if (void 0 === t2) return e2;
  switch (null == r ? 3 : r) {
    case 1:
      return function(r2) {
        return e2.call(t2, r2);
      };
    case 3:
      return function(r2, n, i2) {
        return e2.call(t2, r2, n, i2);
      };
    case 4:
      return function(r2, n, i2, a) {
        return e2.call(t2, r2, n, i2, a);
      };
  }
  return function() {
    return e2.apply(t2, arguments);
  };
}
function baseIteratee(e2, t2, r) {
  return null == e2 ? identity$2 : isFunction$1(e2) ? optimizeCb(e2, t2, r) : isObject(e2) && !isArray(e2) ? matcher(e2) : property(e2);
}
function iteratee(e2, t2) {
  return baseIteratee(e2, t2, 1 / 0);
}
function cb(e2, t2, r) {
  return _$1.iteratee !== iteratee ? _$1.iteratee(e2, t2) : baseIteratee(e2, t2, r);
}
function mapObject(e2, t2, r) {
  t2 = cb(t2, r);
  for (var n = keys$1(e2), i2 = n.length, a = {}, o = 0; o < i2; o++) {
    var s = n[o];
    a[s] = t2(e2[s], s, e2);
  }
  return a;
}
function noop$1$1() {
}
function propertyOf(e2) {
  return null == e2 ? noop$1$1 : function(t2) {
    return get(e2, t2);
  };
}
function times(e2, t2, r) {
  var n = Array(Math.max(0, e2));
  t2 = optimizeCb(t2, r, 1);
  for (var i2 = 0; i2 < e2; i2++) n[i2] = t2(i2);
  return n;
}
function random(e2, t2) {
  return null == t2 && (t2 = e2, e2 = 0), e2 + Math.floor(Math.random() * (t2 - e2 + 1));
}
_$1.toPath = toPath$1, _$1.iteratee = iteratee;
var now = Date.now || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function createEscaper(e2) {
  var t2 = function(t22) {
    return e2[t22];
  }, r = "(?:" + keys$1(e2).join("|") + ")", n = RegExp(r), i2 = RegExp(r, "g");
  return function(e3) {
    return e3 = null == e3 ? "" : "" + e3, n.test(e3) ? e3.replace(i2, t2) : e3;
  };
}
var escapeMap = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;" }, escape = createEscaper(escapeMap), unescapeMap = invert(escapeMap), unescape = createEscaper(unescapeMap), templateSettings = _$1.templateSettings = { evaluate: /<%([\s\S]+?)%>/g, interpolate: /<%=([\s\S]+?)%>/g, escape: /<%-([\s\S]+?)%>/g }, noMatch = /(.)^/, escapes = { "'": "'", "\\": "\\", "\r": "r", "\n": "n", "\u2028": "u2028", "\u2029": "u2029" }, escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function escapeChar(e2) {
  return "\\" + escapes[e2];
}
var bareIdentifier = /^\s*(\w|\$)+\s*$/;
function template(e2, t2, r) {
  !t2 && r && (t2 = r), t2 = defaults$2({}, t2, _$1.templateSettings);
  var n = RegExp([(t2.escape || noMatch).source, (t2.interpolate || noMatch).source, (t2.evaluate || noMatch).source].join("|") + "|$", "g"), i2 = 0, a = "__p+='";
  e2.replace(n, (function(t22, r2, n3, o2, s2) {
    return a += e2.slice(i2, s2).replace(escapeRegExp, escapeChar), i2 = s2 + t22.length, r2 ? a += "'+\n((__t=(" + r2 + "))==null?'':_.escape(__t))+\n'" : n3 ? a += "'+\n((__t=(" + n3 + "))==null?'':__t)+\n'" : o2 && (a += "';\n" + o2 + "\n__p+='"), t22;
  })), a += "';\n";
  var o, s = t2.variable;
  if (s) {
    if (!bareIdentifier.test(s)) throw new Error("variable is not a bare identifier: " + s);
  } else a = "with(obj||{}){\n" + a + "}\n", s = "obj";
  a = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + a + "return __p;\n";
  try {
    o = new Function(s, "_", a);
  } catch (e3) {
    throw e3.source = a, e3;
  }
  var u = function(e3) {
    return o.call(this, e3, _$1);
  };
  return u.source = "function(" + s + "){\n" + a + "}", u;
}
function result(e2, t2, r) {
  var n = (t2 = toPath(t2)).length;
  if (!n) return isFunction$1(r) ? r.call(e2) : r;
  for (var i2 = 0; i2 < n; i2++) {
    var a = null == e2 ? void 0 : e2[t2[i2]];
    void 0 === a && (a = r, i2 = n), e2 = isFunction$1(a) ? a.call(e2) : a;
  }
  return e2;
}
var idCounter = 0;
function uniqueId(e2) {
  var t2 = ++idCounter + "";
  return e2 ? e2 + t2 : t2;
}
function chain$2(e2) {
  var t2 = _$1(e2);
  return t2._chain = true, t2;
}
function executeBound(e2, t2, r, n, i2) {
  if (!(n instanceof t2)) return e2.apply(r, i2);
  var a = baseCreate(e2.prototype), o = e2.apply(a, i2);
  return isObject(o) ? o : a;
}
var partial = restArguments((function(e2, t2) {
  var r = partial.placeholder, n = function() {
    for (var i2 = 0, a = t2.length, o = Array(a), s = 0; s < a; s++) o[s] = t2[s] === r ? arguments[i2++] : t2[s];
    for (; i2 < arguments.length; ) o.push(arguments[i2++]);
    return executeBound(e2, n, this, this, o);
  };
  return n;
}));
partial.placeholder = _$1;
var bind = restArguments((function(e2, t2, r) {
  if (!isFunction$1(e2)) throw new TypeError("Bind must be called on a function");
  var n = restArguments((function(i2) {
    return executeBound(e2, n, t2, this, r.concat(i2));
  }));
  return n;
})), isArrayLike = createSizePropertyCheck(getLength);
function flatten$3(e2, t2, r, n) {
  if (n = n || [], t2 || 0 === t2) {
    if (t2 <= 0) return n.concat(e2);
  } else t2 = 1 / 0;
  for (var i2 = n.length, a = 0, o = getLength(e2); a < o; a++) {
    var s = e2[a];
    if (isArrayLike(s) && (isArray(s) || isArguments$1(s))) if (t2 > 1) flatten$3(s, t2 - 1, r, n), i2 = n.length;
    else for (var u = 0, c2 = s.length; u < c2; ) n[i2++] = s[u++];
    else r || (n[i2++] = s);
  }
  return n;
}
var bindAll = restArguments((function(e2, t2) {
  var r = (t2 = flatten$3(t2, false, false)).length;
  if (r < 1) throw new Error("bindAll must be passed function names");
  for (; r--; ) {
    var n = t2[r];
    e2[n] = bind(e2[n], e2);
  }
  return e2;
}));
function memoize(e2, t2) {
  var r = function(n) {
    var i2 = r.cache, a = "" + (t2 ? t2.apply(this, arguments) : n);
    return has$1(i2, a) || (i2[a] = e2.apply(this, arguments)), i2[a];
  };
  return r.cache = {}, r;
}
var delay = restArguments((function(e2, t2, r) {
  return setTimeout((function() {
    return e2.apply(null, r);
  }), t2);
})), defer = partial(delay, _$1, 1);
function throttle(e2, t2, r) {
  var n, i2, a, o, s = 0;
  r || (r = {});
  var u = function() {
    s = false === r.leading ? 0 : now(), n = null, o = e2.apply(i2, a), n || (i2 = a = null);
  }, c2 = function() {
    var c3 = now();
    s || false !== r.leading || (s = c3);
    var l = t2 - (c3 - s);
    return i2 = this, a = arguments, l <= 0 || l > t2 ? (n && (clearTimeout(n), n = null), s = c3, o = e2.apply(i2, a), n || (i2 = a = null)) : n || false === r.trailing || (n = setTimeout(u, l)), o;
  };
  return c2.cancel = function() {
    clearTimeout(n), s = 0, n = i2 = a = null;
  }, c2;
}
function debounce$1(e2, t2, r) {
  var n, i2, a, o, s, u = function() {
    var c3 = now() - i2;
    t2 > c3 ? n = setTimeout(u, t2 - c3) : (n = null, r || (o = e2.apply(s, a)), n || (a = s = null));
  }, c2 = restArguments((function(c3) {
    return s = this, a = c3, i2 = now(), n || (n = setTimeout(u, t2), r && (o = e2.apply(s, a))), o;
  }));
  return c2.cancel = function() {
    clearTimeout(n), n = a = s = null;
  }, c2;
}
function wrap$1(e2, t2) {
  return partial(t2, e2);
}
function negate(e2) {
  return function() {
    return !e2.apply(this, arguments);
  };
}
function compose() {
  var e2 = arguments, t2 = e2.length - 1;
  return function() {
    for (var r = t2, n = e2[t2].apply(this, arguments); r--; ) n = e2[r].call(this, n);
    return n;
  };
}
function after(e2, t2) {
  return function() {
    if (--e2 < 1) return t2.apply(this, arguments);
  };
}
function before(e2, t2) {
  var r;
  return function() {
    return --e2 > 0 && (r = t2.apply(this, arguments)), e2 <= 1 && (t2 = null), r;
  };
}
var once$1 = partial(before, 2);
function findKey(e2, t2, r) {
  t2 = cb(t2, r);
  for (var n, i2 = keys$1(e2), a = 0, o = i2.length; a < o; a++) if (t2(e2[n = i2[a]], n, e2)) return n;
}
function createPredicateIndexFinder(e2) {
  return function(t2, r, n) {
    r = cb(r, n);
    for (var i2 = getLength(t2), a = e2 > 0 ? 0 : i2 - 1; a >= 0 && a < i2; a += e2) if (r(t2[a], a, t2)) return a;
    return -1;
  };
}
var findIndex = createPredicateIndexFinder(1), findLastIndex = createPredicateIndexFinder(-1);
function sortedIndex(e2, t2, r, n) {
  for (var i2 = (r = cb(r, n, 1))(t2), a = 0, o = getLength(e2); a < o; ) {
    var s = Math.floor((a + o) / 2);
    r(e2[s]) < i2 ? a = s + 1 : o = s;
  }
  return a;
}
function createIndexFinder(e2, t2, r) {
  return function(n, i2, a) {
    var o = 0, s = getLength(n);
    if ("number" == typeof a) e2 > 0 ? o = a >= 0 ? a : Math.max(a + s, o) : s = a >= 0 ? Math.min(a + 1, s) : a + s + 1;
    else if (r && a && s) return n[a = r(n, i2)] === i2 ? a : -1;
    if (i2 != i2) return (a = t2(slice.call(n, o, s), isNaN$1)) >= 0 ? a + o : -1;
    for (a = e2 > 0 ? o : s - 1; a >= 0 && a < s; a += e2) if (n[a] === i2) return a;
    return -1;
  };
}
var indexOf = createIndexFinder(1, findIndex, sortedIndex), lastIndexOf = createIndexFinder(-1, findLastIndex);
function find$1(e2, t2, r) {
  var n = (isArrayLike(e2) ? findIndex : findKey)(e2, t2, r);
  if (void 0 !== n && -1 !== n) return e2[n];
}
function findWhere(e2, t2) {
  return find$1(e2, matcher(t2));
}
function each(e2, t2, r) {
  var n, i2;
  if (t2 = optimizeCb(t2, r), isArrayLike(e2)) for (n = 0, i2 = e2.length; n < i2; n++) t2(e2[n], n, e2);
  else {
    var a = keys$1(e2);
    for (n = 0, i2 = a.length; n < i2; n++) t2(e2[a[n]], a[n], e2);
  }
  return e2;
}
function map(e2, t2, r) {
  t2 = cb(t2, r);
  for (var n = !isArrayLike(e2) && keys$1(e2), i2 = (n || e2).length, a = Array(i2), o = 0; o < i2; o++) {
    var s = n ? n[o] : o;
    a[o] = t2(e2[s], s, e2);
  }
  return a;
}
function createReduce(e2) {
  return function(t2, r, n, i2) {
    var a = arguments.length >= 3;
    return (function(t22, r2, n3, i22) {
      var a2 = !isArrayLike(t22) && keys$1(t22), o = (a2 || t22).length, s = e2 > 0 ? 0 : o - 1;
      for (i22 || (n3 = t22[a2 ? a2[s] : s], s += e2); s >= 0 && s < o; s += e2) {
        var u = a2 ? a2[s] : s;
        n3 = r2(n3, t22[u], u, t22);
      }
      return n3;
    })(t2, optimizeCb(r, i2, 4), n, a);
  };
}
var reduce$1 = createReduce(1), reduceRight = createReduce(-1);
function filter(e2, t2, r) {
  var n = [];
  return t2 = cb(t2, r), each(e2, (function(e3, r2, i2) {
    t2(e3, r2, i2) && n.push(e3);
  })), n;
}
function reject(e2, t2, r) {
  return filter(e2, negate(cb(t2)), r);
}
function every(e2, t2, r) {
  t2 = cb(t2, r);
  for (var n = !isArrayLike(e2) && keys$1(e2), i2 = (n || e2).length, a = 0; a < i2; a++) {
    var o = n ? n[a] : a;
    if (!t2(e2[o], o, e2)) return false;
  }
  return true;
}
function some(e2, t2, r) {
  t2 = cb(t2, r);
  for (var n = !isArrayLike(e2) && keys$1(e2), i2 = (n || e2).length, a = 0; a < i2; a++) {
    var o = n ? n[a] : a;
    if (t2(e2[o], o, e2)) return true;
  }
  return false;
}
function contains$3(e2, t2, r, n) {
  return isArrayLike(e2) || (e2 = values(e2)), ("number" != typeof r || n) && (r = 0), indexOf(e2, t2, r) >= 0;
}
var invoke = restArguments((function(e2, t2, r) {
  var n, i2;
  return isFunction$1(t2) ? i2 = t2 : (t2 = toPath(t2), n = t2.slice(0, -1), t2 = t2[t2.length - 1]), map(e2, (function(e3) {
    var a = i2;
    if (!a) {
      if (n && n.length && (e3 = deepGet(e3, n)), null == e3) return;
      a = e3[t2];
    }
    return null == a ? a : a.apply(e3, r);
  }));
}));
function pluck(e2, t2) {
  return map(e2, property(t2));
}
function where(e2, t2) {
  return filter(e2, matcher(t2));
}
function max$2(e2, t2, r) {
  var n, i2, a = -1 / 0, o = -1 / 0;
  if (null == t2 || "number" == typeof t2 && "object" != typeof e2[0] && null != e2) for (var s = 0, u = (e2 = isArrayLike(e2) ? e2 : values(e2)).length; s < u; s++) null != (n = e2[s]) && n > a && (a = n);
  else t2 = cb(t2, r), each(e2, (function(e3, r2, n3) {
    ((i2 = t2(e3, r2, n3)) > o || i2 === -1 / 0 && a === -1 / 0) && (a = e3, o = i2);
  }));
  return a;
}
function min$2(e2, t2, r) {
  var n, i2, a = 1 / 0, o = 1 / 0;
  if (null == t2 || "number" == typeof t2 && "object" != typeof e2[0] && null != e2) for (var s = 0, u = (e2 = isArrayLike(e2) ? e2 : values(e2)).length; s < u; s++) null != (n = e2[s]) && n < a && (a = n);
  else t2 = cb(t2, r), each(e2, (function(e3, r2, n3) {
    ((i2 = t2(e3, r2, n3)) < o || i2 === 1 / 0 && a === 1 / 0) && (a = e3, o = i2);
  }));
  return a;
}
var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function toArray$1(e2) {
  return e2 ? isArray(e2) ? slice.call(e2) : isString(e2) ? e2.match(reStrSymbol) : isArrayLike(e2) ? map(e2, identity$2) : values(e2) : [];
}
function sample(e2, t2, r) {
  if (null == t2 || r) return isArrayLike(e2) || (e2 = values(e2)), e2[random(e2.length - 1)];
  var n = toArray$1(e2), i2 = getLength(n);
  t2 = Math.max(Math.min(t2, i2), 0);
  for (var a = i2 - 1, o = 0; o < t2; o++) {
    var s = random(o, a), u = n[o];
    n[o] = n[s], n[s] = u;
  }
  return n.slice(0, t2);
}
function shuffle(e2) {
  return sample(e2, 1 / 0);
}
function sortBy(e2, t2, r) {
  var n = 0;
  return t2 = cb(t2, r), pluck(map(e2, (function(e3, r2, i2) {
    return { value: e3, index: n++, criteria: t2(e3, r2, i2) };
  })).sort((function(e3, t22) {
    var r2 = e3.criteria, n3 = t22.criteria;
    if (r2 !== n3) {
      if (r2 > n3 || void 0 === r2) return 1;
      if (r2 < n3 || void 0 === n3) return -1;
    }
    return e3.index - t22.index;
  })), "value");
}
function group$2(e2, t2) {
  return function(r, n, i2) {
    var a = t2 ? [[], []] : {};
    return n = cb(n, i2), each(r, (function(t22, i22) {
      var o = n(t22, i22, r);
      e2(a, t22, o);
    })), a;
  };
}
var groupBy = group$2((function(e2, t2, r) {
  has$1(e2, r) ? e2[r].push(t2) : e2[r] = [t2];
})), indexBy = group$2((function(e2, t2, r) {
  e2[r] = t2;
})), countBy = group$2((function(e2, t2, r) {
  has$1(e2, r) ? e2[r]++ : e2[r] = 1;
})), partition = group$2((function(e2, t2, r) {
  e2[r ? 0 : 1].push(t2);
}), true);
function size$2(e2) {
  return null == e2 ? 0 : isArrayLike(e2) ? e2.length : keys$1(e2).length;
}
function keyInObj(e2, t2, r) {
  return t2 in r;
}
var pick$2 = restArguments((function(e2, t2) {
  var r = {}, n = t2[0];
  if (null == e2) return r;
  isFunction$1(n) ? (t2.length > 1 && (n = optimizeCb(n, t2[1])), t2 = allKeys(e2)) : (n = keyInObj, t2 = flatten$3(t2, false, false), e2 = Object(e2));
  for (var i2 = 0, a = t2.length; i2 < a; i2++) {
    var o = t2[i2], s = e2[o];
    n(s, o, e2) && (r[o] = s);
  }
  return r;
})), omit$2 = restArguments((function(e2, t2) {
  var r, n = t2[0];
  return isFunction$1(n) ? (n = negate(n), t2.length > 1 && (r = t2[1])) : (t2 = map(flatten$3(t2, false, false), String), n = function(e3, r2) {
    return !contains$3(t2, r2);
  }), pick$2(e2, n, r);
}));
function initial(e2, t2, r) {
  return slice.call(e2, 0, Math.max(0, e2.length - (null == t2 || r ? 1 : t2)));
}
function first(e2, t2, r) {
  return null == e2 || e2.length < 1 ? null == t2 || r ? void 0 : [] : null == t2 || r ? e2[0] : initial(e2, e2.length - t2);
}
function rest(e2, t2, r) {
  return slice.call(e2, null == t2 || r ? 1 : t2);
}
function last(e2, t2, r) {
  return null == e2 || e2.length < 1 ? null == t2 || r ? void 0 : [] : null == t2 || r ? e2[e2.length - 1] : rest(e2, Math.max(0, e2.length - t2));
}
function compact(e2) {
  return filter(e2, Boolean);
}
function flatten$2(e2, t2) {
  return flatten$3(e2, t2, false);
}
var difference = restArguments((function(e2, t2) {
  return t2 = flatten$3(t2, true, true), filter(e2, (function(e3) {
    return !contains$3(t2, e3);
  }));
})), without = restArguments((function(e2, t2) {
  return difference(e2, t2);
}));
function uniq(e2, t2, r, n) {
  isBoolean(t2) || (n = r, r = t2, t2 = false), null != r && (r = cb(r, n));
  for (var i2 = [], a = [], o = 0, s = getLength(e2); o < s; o++) {
    var u = e2[o], c2 = r ? r(u, o, e2) : u;
    t2 && !r ? (o && a === c2 || i2.push(u), a = c2) : r ? contains$3(a, c2) || (a.push(c2), i2.push(u)) : contains$3(i2, u) || i2.push(u);
  }
  return i2;
}
var union = restArguments((function(e2) {
  return uniq(flatten$3(e2, true, true));
}));
function intersection(e2) {
  for (var t2 = [], r = arguments.length, n = 0, i2 = getLength(e2); n < i2; n++) {
    var a = e2[n];
    if (!contains$3(t2, a)) {
      var o;
      for (o = 1; o < r && contains$3(arguments[o], a); o++) ;
      o === r && t2.push(a);
    }
  }
  return t2;
}
function unzip(e2) {
  for (var t2 = e2 && max$2(e2, getLength).length || 0, r = Array(t2), n = 0; n < t2; n++) r[n] = pluck(e2, n);
  return r;
}
var zip = restArguments(unzip);
function object(e2, t2) {
  for (var r = {}, n = 0, i2 = getLength(e2); n < i2; n++) t2 ? r[e2[n]] = t2[n] : r[e2[n][0]] = e2[n][1];
  return r;
}
function range(e2, t2, r) {
  null == t2 && (t2 = e2 || 0, e2 = 0), r || (r = t2 < e2 ? -1 : 1);
  for (var n = Math.max(Math.ceil((t2 - e2) / r), 0), i2 = Array(n), a = 0; a < n; a++, e2 += r) i2[a] = e2;
  return i2;
}
function chunk(e2, t2) {
  if (null == t2 || t2 < 1) return [];
  for (var r = [], n = 0, i2 = e2.length; n < i2; ) r.push(slice.call(e2, n, n += t2));
  return r;
}
function chainResult(e2, t2) {
  return e2._chain ? _$1(t2).chain() : t2;
}
function mixin(e2) {
  return each(functions$1(e2), (function(t2) {
    var r = _$1[t2] = e2[t2];
    _$1.prototype[t2] = function() {
      var e3 = [this._wrapped];
      return push$1.apply(e3, arguments), chainResult(this, r.apply(_$1, e3));
    };
  })), _$1;
}
each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], (function(e2) {
  var t2 = ArrayProto[e2];
  _$1.prototype[e2] = function() {
    var r = this._wrapped;
    return null != r && (t2.apply(r, arguments), "shift" !== e2 && "splice" !== e2 || 0 !== r.length || delete r[0]), chainResult(this, r);
  };
})), each(["concat", "join", "slice"], (function(e2) {
  var t2 = ArrayProto[e2];
  _$1.prototype[e2] = function() {
    var e3 = this._wrapped;
    return null != e3 && (e3 = t2.apply(e3, arguments)), chainResult(this, e3);
  };
}));
var allExports = Object.freeze({ __proto__: null, VERSION, restArguments, isObject, isNull, isUndefined, isBoolean, isElement: isElement$2, isString, isNumber, isDate, isRegExp, isError, isSymbol, isArrayBuffer, isDataView: isDataView$1, isArray, isFunction: isFunction$1, isArguments: isArguments$1, isFinite: isFinite$1, isNaN: isNaN$1, isTypedArray: isTypedArray$1, isEmpty, isMatch, isEqual, isMap, isWeakMap, isSet, isWeakSet, keys: keys$1, allKeys, values, pairs, invert, functions: functions$1, methods: functions$1, extend: extend$1$1, extendOwn, assign: extendOwn, defaults: defaults$2, create, clone, tap, get, has, mapObject, identity: identity$2, constant, noop: noop$1$1, toPath: toPath$1, property, propertyOf, matcher, matches: matcher, times, random, now, escape, unescape, templateSettings, template, result, uniqueId, chain: chain$2, iteratee, partial, bind, bindAll, memoize, delay, defer, throttle, debounce: debounce$1, wrap: wrap$1, negate, compose, after, before, once: once$1, findKey, findIndex, findLastIndex, sortedIndex, indexOf, lastIndexOf, find: find$1, detect: find$1, findWhere, each, forEach: each, map, collect: map, reduce: reduce$1, foldl: reduce$1, inject: reduce$1, reduceRight, foldr: reduceRight, filter, select: filter, reject, every, all: every, some, any: some, contains: contains$3, includes: contains$3, include: contains$3, invoke, pluck, where, max: max$2, min: min$2, shuffle, sample, sortBy, groupBy, indexBy, countBy, partition, toArray: toArray$1, size: size$2, pick: pick$2, omit: omit$2, first, head: first, take: first, initial, last, rest, tail: rest, drop: rest, compact, flatten: flatten$2, without, uniq, unique: uniq, union, intersection, difference, unzip, transpose: unzip, zip, object, range, chunk, mixin, default: _$1 }), _$2 = mixin(allExports);
_$2._ = _$2;
var indexAll = Object.freeze({ __proto__: null, default: _$2, VERSION, restArguments, isObject, isNull, isUndefined, isBoolean, isElement: isElement$2, isString, isNumber, isDate, isRegExp, isError, isSymbol, isArrayBuffer, isDataView: isDataView$1, isArray, isFunction: isFunction$1, isArguments: isArguments$1, isFinite: isFinite$1, isNaN: isNaN$1, isTypedArray: isTypedArray$1, isEmpty, isMatch, isEqual, isMap, isWeakMap, isSet, isWeakSet, keys: keys$1, allKeys, values, pairs, invert, functions: functions$1, methods: functions$1, extend: extend$1$1, extendOwn, assign: extendOwn, defaults: defaults$2, create, clone, tap, get, has, mapObject, identity: identity$2, constant, noop: noop$1$1, toPath: toPath$1, property, propertyOf, matcher, matches: matcher, times, random, now, escape, unescape, templateSettings, template, result, uniqueId, chain: chain$2, iteratee, partial, bind, bindAll, memoize, delay, defer, throttle, debounce: debounce$1, wrap: wrap$1, negate, compose, after, before, once: once$1, findKey, findIndex, findLastIndex, sortedIndex, indexOf, lastIndexOf, find: find$1, detect: find$1, findWhere, each, forEach: each, map, collect: map, reduce: reduce$1, foldl: reduce$1, inject: reduce$1, reduceRight, foldr: reduceRight, filter, select: filter, reject, every, all: every, some, any: some, contains: contains$3, includes: contains$3, include: contains$3, invoke, pluck, where, max: max$2, min: min$2, shuffle, sample, sortBy, groupBy, indexBy, countBy, partition, toArray: toArray$1, size: size$2, pick: pick$2, omit: omit$2, first, head: first, take: first, initial, last, rest, tail: rest, drop: rest, compact, flatten: flatten$2, without, uniq, unique: uniq, union, intersection, difference, unzip, transpose: unzip, zip, object, range, chunk, mixin });
const nonTupleVectorOperators = ["vector", "altvector"];
function coerce_tuple_array_vectors({ operator1: e2, operator2: t2, operands1: r, operands2: n, coerce_tuples_arrays: i2, coerce_vectors: a }) {
  let o = e2 === t2;
  if (!o) {
    if (i2) {
      if ("tuple" === e2) {
        if (nonTupleVectorOperators.includes(t2)) e2 = t2, o = true;
        else if ("interval" === t2 && 2 === r.length) {
          let t22 = n[1];
          t22[1] || t22[2] || (o = true, e2 = "interval", r = [["tuple", ...r], ["tuple", false, false]]);
        }
      } else if ("tuple" === t2) {
        if (nonTupleVectorOperators.includes(e2)) t2 = e2, o = true;
        else if ("interval" === e2 && 2 === n.length) {
          let e3 = r[1];
          e3[1] || e3[2] || (o = true, t2 = "interval", n = [["tuple", ...n], ["tuple", false, false]]);
        }
      }
      if (!o) {
        if ("array" === e2 && 2 === r.length) {
          if ("interval" === t2) {
            let t22 = n[1];
            t22[1] && t22[2] && (o = true, e2 = "interval", r = [["tuple", ...r], ["tuple", true, true]]);
          }
        } else if ("array" === t2 && 2 === n.length && "interval" === e2) {
          let e3 = r[1];
          e3[1] && e3[2] && (o = true, t2 = "interval", n = [["tuple", ...n], ["tuple", true, true]]);
        }
      }
    }
    !o && a && nonTupleVectorOperators.includes(e2) && nonTupleVectorOperators.includes(t2) && (o = true, e2 = t2 = "vector");
  }
  return { operator1: e2, operator2: t2, operands1: r, operands2: n };
}
function handleNaNInfinityStringify(e2, t2) {
  return t2 != t2 ? "0/0" : t2 === 1 / 0 ? "1/0" : t2 === -1 / 0 ? "-1/0" : t2;
}
function handleNaNInfinityParse(e2, t2) {
  return "0/0" === t2 ? NaN : "1/0" === t2 ? 1 / 0 : "-1/0" === t2 ? -1 / 0 : t2;
}
function deepClone(e2) {
  return JSON.parse(JSON.stringify(e2, handleNaNInfinityStringify), handleNaNInfinityParse);
}
const equal = function(e2, t2, { allowed_error_in_numbers: r = 0, include_error_in_number_exponents: n = false, allowed_error_is_absolute: i2 = false, coerce_tuples_arrays: a = true, coerce_vectors: o = true } = {}) {
  if (!Array.isArray(e2) || !Array.isArray(t2)) {
    if (typeof e2 != typeof t2) return false;
    if ("number" == typeof e2 && Number.isFinite(e2)) {
      let n3 = 1e-14, a2 = Math.min(Math.abs(e2), Math.abs(t2));
      return i2 ? (n3 *= a2, r > n3 && (n3 = r)) : (r > n3 && (n3 = r), n3 *= a2), Math.abs(e2 - t2) <= n3;
    }
    return e2 === t2;
  }
  var s = e2[0], u = e2.slice(1), c2 = t2[0], l = t2.slice(1);
  if (s !== c2 && ({ operator1: s, operator2: c2, operands1: u, operands2: l } = coerce_tuple_array_vectors({ operator1: s, operator2: c2, operands1: u, operands2: l, coerce_tuples_arrays: a, coerce_vectors: o })), s !== c2) return false;
  if (u.length !== l.length) return false;
  if (r > 0 && !n && "^" === s) {
    return !!equal(u[0], l[0], { allowed_error_in_numbers: r, include_error_in_number_exponents: n, allowed_error_is_absolute: i2, coerce_tuples_arrays: a, coerce_vectors: o }) && equal(u[1], l[1], { coerce_tuples_arrays: a, coerce_vectors: o });
  }
  return _$2.every(_$2.zip(u, l), (function(e3) {
    return equal(e3[0], e3[1], { allowed_error_in_numbers: r, include_error_in_number_exponents: n, allowed_error_is_absolute: i2, coerce_tuples_arrays: a, coerce_vectors: o });
  }));
}, match$2 = function(e2, t2, r) {
  var n = false;
  void 0 === r ? r = {} : r.allow_extended_match && (n = true, delete (r = Object.assign({}, r)).allow_extended_match);
  var i2 = r.variables;
  if (void 0 === i2) {
    i2 = {};
    let e3 = variables(t2);
    for (let t22 = 0; t22 < e3.length; t22++) i2[e3[t22]] = true;
    (r = Object.assign({}, r)).variables = i2;
  }
  if (t2 in i2) {
    let r2 = i2[t2];
    if (true !== r2) if (r2 instanceof RegExp) {
      if ("string" == typeof e2) {
        if (!e2.match(r2)) return false;
      } else if (!JSON.stringify(e2).match(r2)) return false;
    } else {
      if ("function" != typeof i2[t2]) return false;
      if (!i2[t2](e2)) return false;
    }
    let n3 = {};
    return n3[t2] = e2, n3;
  }
  if (r.allow_permutations && (e2 = default_order(e2), t2 = default_order(t2)), !Array.isArray(t2)) return e2 === t2 && {};
  var a = allChildren(e2), o = t2[0], s = t2.slice(1);
  if (!Array.isArray(e2) || e2[0] !== o || a.length < s.length) {
    if (Array.isArray(r.allow_implicit_identities)) {
      let n3 = matchImplicitIdentity(e2, t2, r);
      if (n3) return n3;
    }
    if ("*" !== o || !Array.isArray(e2) || "-" !== e2[0] || !Array.isArray(e2[1]) || "*" !== e2[1][0]) return false;
    (a = allChildren(e2[1]))[0] = ["-", a[0]];
  }
  let u = matchOperands(o, a, s, r, n);
  return u || !!Array.isArray(r.allow_implicit_identities) && matchImplicitIdentity([o].concat(a), t2, r);
};
function matchOperands(e2, t2, r, n, i2) {
  var a = r.map(((e3) => Object())), o = r.length, s = false;
  function u(c3, l2, f2) {
    let p, m = 1, d = 1;
    if ((is_associative$1[e2] || ["tuple", "vector", "altvector"].includes(e2)) && (m = c3.length - (o - l2 - 1), d = c3.length), void 0 !== n.max_group && (m = n.max_group < m ? n.max_group : m), void 0 !== n.max_last_group && (d = n.max_last_group < d ? n.max_last_group : d), i2 || l2 !== o - 1) if (s) p = subsets(c3, m);
    else {
      p = [];
      for (let e3 = 1; e3 <= m; e3++) p.push(c3.slice(0, e3));
    }
    else {
      if (!(c3.length <= d)) return false;
      p = [c3];
    }
    for (let i22 of p) {
      let s2 = a[l2][i22];
      if (void 0 === s2) {
        let o2 = i22.reduce((function(e3, r2) {
          return e3.concat([t2[r2]]);
        }), []);
        o2 = o2.length > 1 ? [e2].concat(o2) : o2[0], s2 = match$2(o2, r[l2], n), a[l2][i22] = s2;
      }
      if (!s2) continue;
      if (!_$2.every(_$2.intersection(Object.keys(f2), Object.keys(s2)), (function(e3) {
        return equal(f2[e3], s2[e3]);
      }))) continue;
      let p2 = Object.assign({}, s2);
      Object.assign(p2, f2);
      let m2 = c3.filter(((e3) => !i22.includes(e3)));
      if (l2 === o - 1) {
        return { matches: p2, skipped: m2.reduce((function(e3, r2) {
          return e3.concat([t2[r2]]);
        }), []) };
      }
      let d2 = u(m2, l2 + 1, p2);
      if (d2) return d2;
    }
    return false;
  }
  n.allow_permutations && ("*" === e2 ? s = ![...t2, ...r].some(((e3) => ["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(e3[0]))) : "+" !== e2 && "=" !== e2 && "and" !== e2 && "or" !== e2 && "ne" !== e2 && "union" !== e2 && "intersect" !== e2 || (s = true));
  var c2 = {}, l = [...Array(t2.length).keys()];
  if (s) {
    let e3 = u(l, 0, {});
    return !!e3 && (c2 = e3.matches, e3.skipped.length > 0 && (c2._skipped = e3.skipped), c2);
  }
  {
    let e3, r2 = i2 ? t2.length - o : 0, n3 = [];
    for (let i22 = 0; i22 <= r2 && (e3 = u(l, 0, {}), !e3); i22++) l = l.slice(1), n3.push(t2[i22]);
    return !!e3 && (c2 = e3.matches, e3.skipped.length > 0 && (c2._skipped = e3.skipped), n3.length > 0 && (c2._skipped_before = n3), c2);
  }
}
function matchImplicitIdentity(e2, t2, r) {
  var n = t2[0], i2 = t2.slice(1);
  if ("+" !== n && "*" !== n && "^" !== n) return false;
  var a = [];
  for (let e3 = 0; e3 < i2.length; e3++) {
    let t22 = i2[e3];
    "string" == typeof t22 && r.allow_implicit_identities.includes(t22) && a.push(t22);
  }
  if (0 === a.length) return false;
  for (let n3 of a) {
    let i22 = match_one_implicit_identity(e2, t2, r, n3);
    if (i22) return i22;
  }
  return false;
}
function match_one_implicit_identity(e2, t2, r, n) {
  var i2 = t2[0], a = t2.slice(1), o = {};
  o[n] = "+" === i2 ? 0 : 1, "*" === i2 && a.includes(n) && Array.isArray(e2) && "-" === e2[0] && (o[n] = -1, e2 = e2[1]);
  var s = a.indexOf(n);
  if (a.splice(s, 1), "^" === i2 && 0 === s) return false;
  t2 = 1 === a.length ? a[0] : [i2].concat(a);
  var u = match$2(e2, t2, r);
  return !!u && (!(n in u && !equal(u[n], o[n])) && (Object.assign(o, u), o));
}
const substitute$1 = function(e2, t2) {
  return "number" == typeof e2 || "boolean" == typeof e2 ? e2 : "string" == typeof e2 ? void 0 !== t2[e2] ? deepClone(t2[e2]) : e2 : Array.isArray(e2) ? [e2[0]].concat(e2.slice(1).map((function(e3) {
    return substitute$1(e3, t2);
  }))) : [];
}, transform = function(e2, t2) {
  if (Array.isArray(e2)) {
    let r = [e2[0]];
    for (let n = 1; n < e2.length; n++) r.push(transform(e2[n], t2));
    return t2(r);
  }
  return t2(e2);
}, applyAllTransformations = function(e2, t2, r) {
  void 0 === r && (r = 5);
  for (var n, i2 = e2; r > 0; r--) {
    n = i2;
    for (let e3 = 0; e3 < t2.length; e3++) {
      let r2 = t2[e3][0], n3 = t2[e3][1], a = t2[e3][2];
      void 0 === a && (a = {}), i2 = transform(i2, (function(e4) {
        let t22 = match$2(e4, r2, a);
        if (t22) {
          let e5 = substitute$1(n3, t22);
          a.evaluate_numbers && (e5 = evaluate_numbers(e5, { max_digits: a.max_digits }));
          let i22 = [], o = [];
          return t22._skipped && (i22 = t22._skipped), t22._skipped_before && (o = t22._skipped_before), (o.length > 0 || i22.length > 0) && (Array.isArray(e5) && (e5 = e5[0] === r2[0] ? e5.slice(1) : [e5]), e5 = [r2[0]].concat(o, e5, i22)), a.evaluate_numbers && (e5 = evaluate_numbers(e5, { max_digits: a.max_digits })), e5;
        }
        return e4;
      }));
    }
    if (equal(n, i2)) return i2;
  }
  return i2;
};
var math = math$1;
const operators$2 = { "+": function(e2) {
  return 1 === e2.length ? e2[0] : new math.OperatorNode("+", "add", e2);
}, "*": function(e2) {
  return new math.OperatorNode("*", "multiply", e2);
}, "/": function(e2) {
  return new math.OperatorNode("/", "divide", e2);
}, "-": function(e2) {
  return new math.OperatorNode("-", "unaryMinus", [e2[0]]);
}, "^": function(e2) {
  return new math.OperatorNode("^", "pow", e2);
}, vector: function(e2) {
  return new math.ArrayNode(e2);
}, altvector: function(e2) {
  return new math.ArrayNode(e2);
}, and: function(e2) {
  return new math.OperatorNode("and", "and", e2);
}, or: function(e2) {
  return new math.OperatorNode("or", "or", e2);
}, not: function(e2) {
  return new math.OperatorNode("not", "not", [e2[0]]);
}, "<": function(e2) {
  return new math.OperatorNode("<", "smaller", e2);
}, ">": function(e2) {
  return new math.OperatorNode(">", "larger", e2);
}, le: function(e2) {
  return new math.OperatorNode("<=", "smallerEq", e2);
}, ge: function(e2) {
  return new math.OperatorNode(">=", "largerEq", e2);
}, ne: function(e2) {
  return new math.OperatorNode("!=", "unequal", e2);
}, binom: function(e2) {
  const t2 = new math.SymbolNode("combinations");
  return new math.FunctionNode(t2, e2);
} }, functionConverstions = { nCr: "combinations", nPr: "permutations", binom: "combinations" };
class astToMathjs$1 {
  constructor({ mathjs: e2 = null } = {}) {
    e2 && (math = e2);
  }
  convert(e2) {
    if ("number" == typeof e2) return Number.isFinite(e2) ? new math.ConstantNode(e2) : Number.isNaN(e2) ? new math.SymbolNode("NaN") : e2 < 0 ? operators$2["-"]([new math.SymbolNode("Infinity")]) : new math.SymbolNode("Infinity");
    if ("string" == typeof e2) return new math.SymbolNode(e2);
    if ("boolean" == typeof e2) throw Error("no support for boolean");
    if (!Array.isArray(e2)) throw Error("Invalid ast");
    const t2 = e2[0], r = e2.slice(1);
    if ("apply" === t2) {
      if ("string" != typeof r[0]) throw Error("Non string functions not implemented for conversion to mathjs");
      if ("factorial" === r[0]) return new math.OperatorNode("!", "factorial", [this.convert(r[1])]);
      let e3 = functionConverstions[r[0]];
      e3 || (e3 = r[0]);
      const t22 = new math.SymbolNode(e3), n = r[1];
      let i2;
      return i2 = "tuple" === n[0] ? n.slice(1).map((function(e4, t3) {
        return this.convert(e4);
      }).bind(this)) : [this.convert(n)], "count" === r[0] && (!(i2.length > 2) && i2[0] instanceof math.ArrayNode || (i2 = [new math.ArrayNode(i2)])), new math.FunctionNode(t22, i2);
    }
    if ("lts" === t2 || "gts" === t2) {
      const e3 = r[0], n = r[1];
      if ("tuple" !== e3[0] || "tuple" !== n[0]) throw new Error("Badly formed ast");
      const i2 = e3.slice(1).map((function(e4, t22) {
        return this.convert(e4);
      }).bind(this));
      let a = [];
      for (let r2 = 1; r2 < e3.length - 1; r2++) n[r2] ? "lts" === t2 ? a.push(new math.OperatorNode("<", "smaller", i2.slice(r2 - 1, r2 + 1))) : a.push(new math.OperatorNode(">", "larger", i2.slice(r2 - 1, r2 + 1))) : "lts" === t2 ? a.push(new math.OperatorNode("<=", "smallerEq", i2.slice(r2 - 1, r2 + 1))) : a.push(new math.OperatorNode(">=", "largerEq", i2.slice(r2 - 1, r2 + 1)));
      let o = new math.OperatorNode("and", "and", a.slice(0, 2));
      for (let e4 = 2; e4 < a.length; e4++) o = new math.OperatorNode("and", "and", [o, a[e4]]);
      return o;
    }
    if ("=" === t2) {
      let e3 = r.map((function(e4, t3) {
        return this.convert(e4);
      }).bind(this)), t22 = [];
      for (let r2 = 1; r2 < e3.length; r2++) t22.push(new math.OperatorNode("==", "equal", e3.slice(r2 - 1, r2 + 1)));
      if (1 === t22.length) return t22[0];
      let n = new math.OperatorNode("and", "and", t22.slice(0, 2));
      for (let e4 = 2; e4 < t22.length; e4++) n = new math.OperatorNode("and", "and", [n, t22[e4]]);
      return n;
    }
    if ("in" === t2 || "notin" === t2 || "ni" === t2 || "notni" === t2) {
      let e3, n;
      if ("in" === t2 || "notin" === t2 ? (e3 = r[0], n = r[1]) : (e3 = r[1], n = r[0]), "number" != typeof e3 && "string" != typeof e3) throw Error("Set membership non-string variables not implemented for conversion to mathjs");
      if (e3 = this.convert(e3), "interval" !== n[0]) throw Error("Set membership in non-intervals not implemented for conversion to mathjs");
      let i2 = n[1], a = n[2];
      if ("tuple" !== i2[0] || "tuple" !== a[0]) throw new Error("Badly formed ast");
      let o = this.convert(i2[1]), s = this.convert(i2[2]), u = [];
      a[1] ? u.push(new math.OperatorNode(">=", "largerEq", [e3, o])) : u.push(new math.OperatorNode(">", "larger", [e3, o])), a[2] ? u.push(new math.OperatorNode("<=", "smallerEq", [e3, s])) : u.push(new math.OperatorNode("<", "smaller", [e3, s]));
      let c2 = new math.OperatorNode("and", "and", u);
      return "notin" !== t2 && "notni" !== t2 || (c2 = new math.OperatorNode("not", "not", [c2])), c2;
    }
    if ("subset" === t2 || "notsubset" === t2 || "superset" === t2 || "notsuperset" === t2) {
      let e3, n;
      if ("subset" === t2 || "notsubset" === t2 ? (n = r[0], e3 = r[1]) : (n = r[1], e3 = r[0]), "interval" !== n[0] || "interval" !== e3[0]) throw Error("Set containment of non-intervals not implemented for conversion to mathjs");
      let i2 = n[1], a = n[2], o = e3[1], s = e3[2];
      if ("tuple" !== i2[0] || "tuple" !== a[0] || "tuple" !== o[0] || "tuple" !== s[0]) throw Error("Badly formed ast");
      let u = this.convert(i2[1]), c2 = this.convert(i2[2]), l = this.convert(o[1]), f2 = this.convert(o[2]), p = [];
      a[1] && !s[1] ? p.push(new math.OperatorNode(">", "larger", [u, l])) : p.push(new math.OperatorNode(">=", "largerEq", [u, l])), a[2] && !s[2] ? p.push(new math.OperatorNode("<", "smaller", [c2, f2])) : p.push(new math.OperatorNode("<=", "smallerEq", [c2, f2]));
      let m = new math.OperatorNode("and", "and", p);
      return "notsubset" !== t2 && "notsuperset" !== t2 || (m = new math.OperatorNode("not", "not", [m])), m;
    }
    if ("matrix" === t2) {
      let e3 = r[0], t22 = e3[1], n = e3[2], i2 = r[1];
      if (!Number.isInteger(t22) || !Number.isInteger(n)) throw Error("Matrix must have integer dimensions");
      let a = [];
      for (let e4 = 1; e4 <= t22; e4++) {
        let t3 = [];
        for (let r2 = 1; r2 <= n; r2++) t3.push(this.convert(i2[e4][r2]));
        a.push(new math.ArrayNode(t3));
      }
      return new math.ArrayNode(a);
    }
    if ("array" === t2) {
      let e3 = r.map(((e4) => this.convert(e4)));
      return new math.ArrayNode(e3);
    }
    if (t2 in operators$2) return operators$2[t2](r.map((function(e3, t22) {
      return this.convert(e3);
    }).bind(this)));
    throw Error("Operator " + t2 + " not implemented for conversion to mathjs");
  }
}
var sieve, hasRequiredSieve, factor, hasRequiredFactor, inc_mixed, hasRequiredInc_mixed, divisors, hasRequiredDivisors, prime_factors, hasRequiredPrime_factors, euler_phi, hasRequiredEuler_phi, gcd$1, hasRequiredGcd, find_divisor, hasRequiredFind_divisor, inverse_mod, hasRequiredInverse_mod, is_abundant, hasRequiredIs_abundant, is_deficient, hasRequiredIs_deficient, is_heptagonal, hasRequiredIs_heptagonal, is_hexagonal, hasRequiredIs_hexagonal, is_octagonal, hasRequiredIs_octagonal, is_pentagonal, hasRequiredIs_pentagonal, is_perfect, hasRequiredIs_perfect, is_prime, hasRequiredIs_prime, multiply_mod, hasRequiredMultiply_mod, power_mod, hasRequiredPower_mod, miller, hasRequiredMiller, is_square, hasRequiredIs_square, is_triangular, hasRequiredIs_triangular, jacobi_symbol, hasRequiredJacobi_symbol, log_mod, hasRequiredLog_mod;
function requireSieve() {
  return hasRequiredSieve ? sieve : (hasRequiredSieve = 1, sieve = function(e2) {
    for (var t2 = new Array(e2), r = 0; r < e2; r++) t2[r] = true;
    for (r = 2; r < Math.sqrt(e2); r++) for (var n = r * r; n < e2; n += r) t2[n] = false;
    var i2 = [];
    for (r = 2; r < e2; r++) t2[r] && i2.push(r);
    return i2;
  });
}
function requireFactor() {
  if (hasRequiredFactor) return factor;
  hasRequiredFactor = 1;
  var e2 = requireSieve(), t2 = e2(1e5);
  return factor = function(r) {
    (!t2 || t2[t2.length - 1] < r) && (t2 = e2(r));
    for (var n = [], i2 = 0; i2 < t2.length && r > 1; i2++) {
      var a = t2[i2];
      if (r % a == 0) {
        for (var o = { prime: a, power: 0 }; r % a == 0; ) o.power++, r /= a;
        n.push(o);
      }
    }
    return r > 1 && n.push({ prime: r, power: 1 }), n;
  };
}
function requireInc_mixed() {
  return hasRequiredInc_mixed || (hasRequiredInc_mixed = 1, inc_mixed = function(e2, t2) {
    var r = e2.map((function(e3) {
      return e3;
    }));
    r[0]++;
    for (var n = 0; n < e2.length && !(r[n] <= t2[n]); n++) n !== e2.length - 1 ? (r[n] = 0, r[n + 1]++) : r[n] = 0;
    return r;
  }), inc_mixed;
}
function requireDivisors() {
  if (hasRequiredDivisors) return divisors;
  hasRequiredDivisors = 1;
  var e2 = requireFactor(), t2 = requireInc_mixed();
  return divisors = function(r) {
    for (var n = e2(r), i2 = n.map((function(e3) {
      return 0;
    })), a = n.map((function(e3) {
      return e3.power;
    })), o = [1]; ; ) {
      var s = (i2 = t2(i2, a)).map((function(e3, t22) {
        return Math.pow(n[t22].prime, e3);
      })).reduce((function(e3, t22) {
        return e3 * t22;
      }), 1);
      if (1 === s) break;
      o.push(s);
    }
    return o.sort((function(e3, t22) {
      return parseInt(e3) - parseInt(t22);
    })), o;
  };
}
function requirePrime_factors() {
  if (hasRequiredPrime_factors) return prime_factors;
  hasRequiredPrime_factors = 1;
  var e2 = requireFactor();
  return prime_factors = function(t2) {
    return e2(t2).map((function(e3) {
      return e3.prime;
    }));
  }, prime_factors;
}
function requireEuler_phi() {
  if (hasRequiredEuler_phi) return euler_phi;
  hasRequiredEuler_phi = 1;
  var e2 = requirePrime_factors();
  return euler_phi = function(t2) {
    var r = function(e3) {
      return e3.reduce((function(e4, t22) {
        return e4 * t22;
      }), 1);
    }, n = e2(t2);
    return t2 * r(n.map((function(e3) {
      return e3 - 1;
    }))) / r(n);
  }, euler_phi;
}
function requireGcd() {
  return hasRequiredGcd ? gcd$1 : (hasRequiredGcd = 1, gcd$1 = function(e2, t2) {
    for (e2 < 0 && (e2 = -e2), t2 < 0 && (t2 = -t2); ; ) {
      if (0 === t2) return e2;
      if (0 === (e2 %= t2)) return t2;
      t2 %= e2;
    }
  });
}
function requireFind_divisor() {
  if (hasRequiredFind_divisor) return find_divisor;
  hasRequiredFind_divisor = 1;
  var e2 = requireGcd();
  return find_divisor = function(t2) {
    for (var r, n = 2 * Math.floor(Math.sqrt(Math.sqrt(t2))), i2 = 2, a = i2, o = 1; o < n; o++) if (1 != (r = e2((a = ((a = (a * a + 1) % t2) * a + 1) % t2) - (i2 = (i2 * i2 + 1) % t2), t2))) return r;
    return 1;
  };
}
function requireInverse_mod() {
  return hasRequiredInverse_mod ? inverse_mod : (hasRequiredInverse_mod = 1, inverse_mod = function(e2, t2) {
    e2 < 0 && (e2 = e2 % t2 + t2);
    for (var r = 0, n = 1, i2 = t2, a = e2; 0 !== a; ) {
      var o = Math.floor(i2 / a), s = r;
      r = n, n = s - o * n;
      var u = i2;
      i2 = a, a = u - o * a;
    }
    return i2 > 1 ? NaN : r > 0 ? r : r + t2;
  });
}
function requireIs_abundant() {
  if (hasRequiredIs_abundant) return is_abundant;
  hasRequiredIs_abundant = 1;
  var e2 = requireDivisors();
  return is_abundant = function(t2) {
    if (1 === t2) return false;
    var r = e2(t2);
    return r.pop(), t2 < r.reduce((function(e3, t22) {
      return e3 + t22;
    }));
  };
}
function requireIs_deficient() {
  if (hasRequiredIs_deficient) return is_deficient;
  hasRequiredIs_deficient = 1;
  var e2 = requireDivisors();
  return is_deficient = function(t2) {
    if (1 === t2) return true;
    var r = e2(t2);
    return r.pop(), t2 > r.reduce((function(e3, t22) {
      return e3 + t22;
    }));
  };
}
function requireIs_heptagonal() {
  return hasRequiredIs_heptagonal ? is_heptagonal : (hasRequiredIs_heptagonal = 1, is_heptagonal = function(e2) {
    return (Math.sqrt(40 * e2 + 9) + 3) / 10 % 1 == 0;
  });
}
function requireIs_hexagonal() {
  return hasRequiredIs_hexagonal ? is_hexagonal : (hasRequiredIs_hexagonal = 1, is_hexagonal = function(e2) {
    return (Math.sqrt(8 * e2 + 1) + 1) / 4 % 1 == 0;
  });
}
function requireIs_octagonal() {
  return hasRequiredIs_octagonal ? is_octagonal : (hasRequiredIs_octagonal = 1, is_octagonal = function(e2) {
    return (Math.sqrt(3 * e2 + 1) + 1) / 3 % 1 == 0;
  });
}
function requireIs_pentagonal() {
  return hasRequiredIs_pentagonal ? is_pentagonal : (hasRequiredIs_pentagonal = 1, is_pentagonal = function(e2) {
    return (Math.sqrt(24 * e2 + 1) + 1) / 6 % 1 == 0;
  });
}
function requireIs_perfect() {
  if (hasRequiredIs_perfect) return is_perfect;
  hasRequiredIs_perfect = 1;
  var e2 = requireDivisors();
  return is_perfect = function(t2) {
    if (1 === t2) return false;
    var r = e2(t2);
    return r.pop(), t2 === r.reduce((function(e3, t22) {
      return e3 + t22;
    }));
  };
}
function requireIs_prime() {
  if (hasRequiredIs_prime) return is_prime;
  hasRequiredIs_prime = 1;
  var e2 = requireFactor();
  return is_prime = function(t2) {
    var r = e2(t2);
    return 1 == r.length && 1 === r[0].power;
  };
}
function requireMultiply_mod() {
  return hasRequiredMultiply_mod ? multiply_mod : (hasRequiredMultiply_mod = 1, multiply_mod = function(e2, t2, r) {
    if (e2 < 94906265 && t2 < 94906265) return e2 * t2 % r;
    var n = 0, i2 = r / 2;
    e2 >= r && (e2 %= r), t2 >= r && (t2 %= r);
    for (var a = 0; a < 53; a++) n = n >= i2 ? 2 * n - r : 2 * n, e2 >= 4503599627370496 && (n += t2, e2 -= 4503599627370495), n > r && (n -= r), e2 *= 2;
    return n;
  });
}
function requirePower_mod() {
  if (hasRequiredPower_mod) return power_mod;
  hasRequiredPower_mod = 1;
  var e2 = requireMultiply_mod(), t2 = requireInverse_mod();
  return power_mod = function r(n, i2, a) {
    if (i2 < 0) return t2(r(n, -i2, a), a);
    var o = 1;
    for (n %= a; i2 > 0; ) i2 % 2 == 1 && (o = e2(o, n, a), i2 -= 1), i2 /= 2, n = e2(n, n, a);
    return o;
  }, power_mod;
}
function requireMiller() {
  if (hasRequiredMiller) return miller;
  hasRequiredMiller = 1;
  var e2 = requireMultiply_mod(), t2 = requirePower_mod();
  return miller = function(r) {
    if (r < 2) return false;
    if (2 == r || 3 == r) return true;
    if (!(1 & r) || r % 3 == 0) return false;
    for (var n, i2 = r - 1, a = 0; i2 % 2 == 0; ) i2 /= 2, a += 1;
    n = r < 1373653 ? [2, 3] : r < 9080191 ? [31, 73] : r < 4759123141 ? [2, 7, 61] : r < 1122004669633 ? [2, 13, 23, 1662803] : r < 2152302898747 ? [2, 3, 5, 7, 11] : r < 3474749660383 ? [2, 3, 5, 7, 11, 13] : [2, 3, 5, 7, 11, 13, 17];
    for (var o = 0; o < n.length; o++) {
      for (var s = n[o], u = t2(s, i2, r), c2 = 0, l = a; l > 0; ) {
        if (1 === (c2 = e2(u, u, r)) && 1 !== u && u !== r - 1) return false;
        u = c2, --l;
      }
      if (1 !== c2) return false;
    }
    return true;
  };
}
function requireIs_square() {
  return hasRequiredIs_square ? is_square : (hasRequiredIs_square = 1, is_square = function(e2) {
    return Math.sqrt(e2) % 1 == 0;
  });
}
function requireIs_triangular() {
  return hasRequiredIs_triangular ? is_triangular : (hasRequiredIs_triangular = 1, is_triangular = function(e2) {
    return Math.sqrt(8 * e2 + 1) % 1 == 0;
  });
}
function requireJacobi_symbol() {
  return hasRequiredJacobi_symbol ? jacobi_symbol : (hasRequiredJacobi_symbol = 1, jacobi_symbol = function(e2, t2) {
    if (t2 % 2 == 0) return NaN;
    if (t2 < 0) return NaN;
    e2 < 0 && (e2 = e2 % t2 + t2);
    for (var r = 0; ; ) {
      if (0 === (e2 %= t2)) return 0;
      for (; e2 % 2 == 0; ) r ^= (t2 % 8 * (t2 % 8) - 1) / 8, e2 /= 2;
      if (1 == e2) return 1 & r ? -1 : 1;
      r ^= (e2 % 4 - 1) * (t2 % 4 - 1) / 4;
      var n = e2;
      e2 = t2, t2 = n;
    }
    return NaN;
  });
}
function requireLog_mod() {
  if (hasRequiredLog_mod) return log_mod;
  hasRequiredLog_mod = 1;
  var e2 = requirePower_mod(), t2 = requireMultiply_mod(), r = {};
  return log_mod = function(n, i2, a) {
    n = (n % a + a) % a;
    var o = Math.ceil(Math.sqrt(a)), s = {};
    if (void 0 === r[a] && (r[a] = {}), void 0 === r[a][i2]) {
      r[a][i2] = {}, s = r[a][i2];
      for (var u = 0; u < o; u++) s[e2(i2, u, a)] = u;
    } else s = r[a][i2];
    for (var c2 = e2(i2, -o, a), l = n, f2 = 0; f2 < o; f2++) {
      if (void 0 !== s[l]) return (t2(f2, o, a) + s[l]) % a;
      l = t2(l, c2, a);
    }
    return NaN;
  };
}
var require$$0 = getAugmentedNamespace$1(indexAll), primitive_root, hasRequiredPrimitive_root, quadratic_nonresidue, hasRequiredQuadratic_nonresidue, random_primitive_root, hasRequiredRandom_primitive_root, square_root_mod_prime, hasRequiredSquare_root_mod_prime, square_root_mod, hasRequiredSquare_root_mod, numberTheory$1, hasRequiredNumberTheory;
function requirePrimitive_root() {
  if (hasRequiredPrimitive_root) return primitive_root;
  hasRequiredPrimitive_root = 1;
  var e2 = require$$0, t2 = requireEuler_phi(), r = requirePrime_factors(), n = requirePower_mod();
  return primitive_root = function(i2) {
    for (var a = t2(i2), o = r(a), s = 2; s < i2; s++) {
      if (e2.every(o, (function(e3) {
        return 1 != n(s, a / e3, i2);
      }))) return s;
    }
    return NaN;
  };
}
function requireQuadratic_nonresidue() {
  if (hasRequiredQuadratic_nonresidue) return quadratic_nonresidue;
  hasRequiredQuadratic_nonresidue = 1;
  var e2 = requireJacobi_symbol();
  return quadratic_nonresidue = function(t2) {
    for (var r = 2; r < t2; r++) if (-1 == e2(r, t2)) return r;
    return NaN;
  };
}
function requireRandom_primitive_root() {
  if (hasRequiredRandom_primitive_root) return random_primitive_root;
  hasRequiredRandom_primitive_root = 1;
  var e2 = requirePrimitive_root(), t2 = requireEuler_phi(), r = requireGcd(), n = requirePower_mod();
  return random_primitive_root = function(i2) {
    for (var a = e2(i2), o = t2(i2), s = 0; s < 100; s++) {
      var u = Math.floor(Math.random() * o);
      if (1 == r(u, o)) return n(a, u, i2);
    }
    return a;
  };
}
function requireSquare_root_mod_prime() {
  if (hasRequiredSquare_root_mod_prime) return square_root_mod_prime;
  hasRequiredSquare_root_mod_prime = 1;
  var e2 = requireJacobi_symbol(), t2 = requirePower_mod(), r = requireQuadratic_nonresidue();
  return square_root_mod_prime = function(n, i2) {
    if (1 != e2(n, i2)) return NaN;
    for (var a = i2 - 1, o = 0; a % 2 == 0; ) a /= 2, o++;
    if (i2 % 4 == 3) return t2(n, (i2 + 1) / 4, i2);
    for (var s = r(i2), u = t2(s, a, i2), c2 = t2(n, (a + 1) / 2, i2), l = t2(n, a, i2), f2 = o; ; ) {
      if (l % i2 == 1) return c2;
      for (var p = l, m = 1; m < f2 && 1 != (p = p * p % i2); m++) ;
      var d = m;
      m++;
      for (var h = u; m < f2; ) h = h * h % i2, m++;
      f2 = d, c2 = c2 * h % i2, l = l * h * h % i2, u = h * h % i2;
    }
    return NaN;
  }, square_root_mod_prime;
}
function requireSquare_root_mod() {
  if (hasRequiredSquare_root_mod) return square_root_mod;
  hasRequiredSquare_root_mod = 1;
  var e2 = require$$0, t2 = requireFactor(), r = requireSquare_root_mod_prime(), n = requireJacobi_symbol(), i2 = requireInverse_mod(), a = requireMultiply_mod();
  return square_root_mod = function(o, s) {
    var u = 1, c2 = [0];
    return t2(s).forEach((function(t22) {
      var s2 = t22.prime, l = t22.power, f2 = r(o, s2), p = [];
      if (1 != n(o, s2)) return [];
      c2.forEach((function(e3) {
        p.unshift(e3 * s2 * i2(s2, u) + f2 * u * i2(u, s2)), p.unshift(e3 * s2 * i2(s2, u) - f2 * u * i2(u, s2));
      })), p.sort(), c2 = e2.unique(p), u *= s2;
      for (l--; l > 0; ) {
        var m = Math.pow(s2, Math.min(1, l));
        l -= Math.min(1, l), c2 = c2.map((function(e3) {
          var t3 = -(e3 * e3 - o) / u, r2 = i2(2 * e3, m);
          return e3 + u * a(t3, r2, m);
        })), u *= m;
      }
    })), c2.map((function(e3) {
      return (e3 % s + s) % s;
    }));
  }, square_root_mod;
}
function requireNumberTheory() {
  return hasRequiredNumberTheory ? numberTheory$1 : (hasRequiredNumberTheory = 1, numberTheory$1 = { divisors: requireDivisors(), eulerPhi: requireEuler_phi(), factor: requireFactor(), findDivisor: requireFind_divisor(), gcd: requireGcd(), incMixed: requireInc_mixed(), inverseMod: requireInverse_mod(), isAbundant: requireIs_abundant(), isDeficient: requireIs_deficient(), isHeptagonal: requireIs_heptagonal(), isHexagonal: requireIs_hexagonal(), isOctagonal: requireIs_octagonal(), isPentagonal: requireIs_pentagonal(), isPerfect: requireIs_perfect(), isPrime: requireIs_prime(), isProbablyPrime: requireMiller(), isSquare: requireIs_square(), isTriangular: requireIs_triangular(), jacobiSymbol: requireJacobi_symbol(), logMod: requireLog_mod(), miller: requireMiller(), multiplyMod: requireMultiply_mod(), powerMod: requirePower_mod(), primeFactors: requirePrime_factors(), primitiveRoot: requirePrimitive_root(), quadraticNonresidue: requireQuadratic_nonresidue(), randomPrimitiveRoot: requireRandom_primitive_root(), sieve: requireSieve(), squareRootMod: requireSquare_root_mod(), squareRootModPrime: requireSquare_root_mod_prime(), totient: requireEuler_phi() });
}
var numberTheoryExports = requireNumberTheory(), numberTheory = getDefaultExportFromCjs$2(numberTheoryExports);
function gcd(e2, t2) {
  return Number.isNaN(e2) || Number.isNaN(t2) ? NaN : numberTheory.gcd(e2, t2);
}
function flatten$1(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.concat(t2);
  }), []);
}
function positiveModulo(e2, t2) {
  return (e2 % t2 + t2) % t2;
}
class ZmodN {
  constructor(e2, t2, r = false) {
    this.values = e2.map((function(e3) {
      return positiveModulo(e3, t2);
    })), this.modulus = t2, this.approximate = r;
  }
  apply(e2, t2, r) {
    if (null == r || Number.isNaN(r)) {
      if (Number.isNaN(this.modulus) || Number.isNaN(e2.modulus)) return new ZmodN([NaN], NaN, this.approximate || e2.approximate);
      r = gcd(this.modulus, e2.modulus);
    }
    return new ZmodN(flatten$1(this.values.map((function(n) {
      return e2.values.map((function(e3) {
        return Number.isNaN(n) || Number.isNaN(e3) ? NaN : (r + t2(n, e3)) % r;
      }));
    }))), r, this.approximate || e2.approximate);
  }
  add(e2) {
    return this.apply(e2, (function(e3, t2) {
      return e3 + t2;
    }));
  }
  power(e2) {
    var t2 = this.modulus;
    return e2.modulus != numberTheory.eulerPhi(t2) ? new ZmodN([NaN], NaN, this.approximate || e2.approximate) : this.apply(e2, (function(e3, r) {
      return numberTheory.powerMod(e3, r, t2);
    }), t2);
  }
  isNaN() {
    for (var e2 of this.values) if (isNaN(e2)) return true;
    return false;
  }
  subtract(e2) {
    return this.apply(e2, (function(e3, t2) {
      return e3 - t2;
    }));
  }
  multiply(e2) {
    var t2 = gcd(this.modulus, e2.modulus);
    return this.apply(e2, (function(e3, r) {
      return numberTheory.multiplyMod(e3, r, t2);
    }));
  }
  inverse() {
    var e2 = this.modulus;
    return new ZmodN(this.values.map((function(t2) {
      return numberTheory.inverseMod(t2, e2);
    })), this.modulus, this.approximate);
  }
  negate() {
    var e2 = this.modulus;
    return new ZmodN(this.values.map((function(t2) {
      return e2 - t2;
    })), this.modulus, this.approximate);
  }
  divide(e2) {
    var t2 = gcd(this.modulus, e2.modulus), r = flatten$1(flatten$1(this.values.map((function(r2) {
      return e2.values.map((function(e3) {
        if (r2 % e3 == 0) return [r2 / e3];
        var n = gcd(e3, t2);
        if (r2 % n != 0) return [];
        var i2, a = e3 / n, o = r2 / n, s = numberTheory.multiplyMod(o, numberTheory.inverseMod(a, t2), t2), u = [];
        for (i2 = 0; i2 < n; i2++) u.unshift(s + numberTheory.multiplyMod(i2, t2 / n, t2));
        return u;
      }));
    }))));
    return new ZmodN(r, t2, this.approximate || e2.approximate);
  }
  sqrt() {
    var e2 = this.modulus;
    return new ZmodN(flatten$1(this.values.map((function(t2) {
      return numberTheory.squareRootMod(t2, e2);
    }))), this.modulus, this.approximate);
  }
  toString = function() {
    return "{" + this.values.sort().toString() + "}/" + this.modulus.toString();
  };
  equals(e2) {
    return this.toString() == e2.toString();
  }
}
var PRIME = 10739999, levelFunctions = { "+": function(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.add(t2);
  }));
}, "*": function(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.multiply(t2);
  }));
}, "/": function(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.divide(t2);
  }));
}, "-": function(e2) {
  return e2[0].negate();
}, "~": function(e2) {
  return e2.reduce((function(e3, t2) {
    return e3.subtract(t2);
  }), new ZmodN([0], e2[0].modulus));
}, factorial: function(e2) {
  return ZmodN([NaN], 1);
}, gamma: function(e2) {
  return ZmodN([NaN], 1);
} };
function rationalApproximation(e2, t2 = 1e15) {
  let r, n = [[1, 0], [0, 1]];
  for (; n[1][0] * (r = Math.floor(e2)) + n[1][1] <= t2; ) {
    let t22;
    if (t22 = n[0][0] * r + n[0][1], n[0][1] = n[0][0], n[0][0] = t22, t22 = n[1][0] * r + n[1][1], n[1][1] = n[1][0], n[1][0] = t22, e2 == r) break;
    if ((e2 = 1 / (e2 - r)) > 2147483647) break;
  }
  const i2 = n[1][0] * r + n[1][1] > t2;
  return { numerator: n[0][0], denominator: n[1][0], approximate: i2 };
}
function finite_field_evaluate_ast(e2, t2, r, n) {
  if ("string" == typeof e2) return "e" === e2 ? new ZmodN([numberTheory.primitiveRoot(r)], r) : "pi" === e2 ? new ZmodN(r % 2 == 0 ? [r / 2] : [NaN], r) : "i" === e2 ? new ZmodN([0], 1) : e2 in t2 ? new ZmodN([t2[e2]], r) : e2;
  if ("number" == typeof e2) {
    if (Number.isInteger(e2)) return new ZmodN([e2], r);
    {
      let t22 = rationalApproximation(e2), n3 = new ZmodN([t22.numerator], r, t22.approximate), i22 = new ZmodN([t22.denominator], r, t22.approximate);
      return n3.divide(i22);
    }
  }
  var i2 = e2[0], a = e2.slice(1);
  if ("apply" === i2) {
    if ("string" != typeof a[0]) throw Error("Non string functions not implemented for finite fields");
    if ("exp" === a[0]) {
      var o = finite_field_evaluate_ast("e", {}, r), s = finite_field_evaluate_ast(a[1], t2, numberTheory.eulerPhi(r));
      return o.power(s);
    }
    if ("sec" === a[0]) return finite_field_evaluate_ast(["/", 1, ["apply", "cos", a[1]]], t2, r);
    if ("csc" === a[0]) return finite_field_evaluate_ast(["/", 1, ["apply", "sin", a[1]]], t2, r);
    if ("cot" === a[0]) return finite_field_evaluate_ast(["/", 1, ["apply", "tan", a[1]]], t2, r);
    if ("tan" === a[0]) {
      var u = numberTheory.eulerPhi(r);
      return finite_field_evaluate_ast(["/", ["apply", "sin", a[1]], ["apply", "cos", a[1]]], t2, r);
    }
    if ("sin" === a[0]) {
      var c2 = numberTheory.primitiveRoot(r), l = new ZmodN([c2], r);
      if ((u = numberTheory.eulerPhi(r)) % 4 != 0) return new ZmodN([NaN], r);
      var f2 = new ZmodN([numberTheory.powerMod(c2, u / 4, r)], r), p = finite_field_evaluate_ast(a[1], t2, u);
      return l.power(p).subtract(l.power(p.negate())).divide(f2.add(f2));
    }
    if ("cos" === a[0]) {
      l = new ZmodN([numberTheory.primitiveRoot(r)], r), p = finite_field_evaluate_ast(a[1], t2, numberTheory.eulerPhi(r));
      return l.power(p).add(l.power(p.negate())).divide(new ZmodN([2], r));
    }
    if ("log" === a[0]) return new ZmodN([NaN], NaN);
    if ("sqrt" === a[0]) return finite_field_evaluate_ast(a[1], t2, r).sqrt();
    if ("abs" === a[0]) {
      let e3 = finite_field_evaluate_ast(a[1], t2, r);
      return e3.multiply(e3).sqrt();
    }
  }
  if ("^" == i2) {
    o = finite_field_evaluate_ast(a[0], t2, r), s = finite_field_evaluate_ast(a[1], t2, numberTheory.eulerPhi(r));
    return o.power(s);
  }
  return i2 in levelFunctions ? levelFunctions[i2](a.map((function(e3, n3) {
    return finite_field_evaluate_ast(e3, t2, r);
  }))) : new ZmodN([NaN], r);
}
class astToFiniteField$1 {
  constructor() {
  }
  convert(e2, t2, r = PRIME) {
    return finite_field_evaluate_ast(e2, t2, r);
  }
}
var function_normalizations = { ln: "log", arccos: "acos", arccosh: "acosh", arcsin: "asin", arcsinh: "asinh", arctan: "atan", arctanh: "atanh", arcsec: "asec", arcsech: "asech", arccsc: "acsc", arccsch: "acsch", arccot: "acot", arccoth: "acoth", cosec: "csc" }, create_trig_inverses_for = ["cos", "cosh", "sin", "sinh", "tan", "tanh", "sec", "sech", "csc", "csch", "cot", "coth"], move_exponents_outside_for = ["cos", "cosh", "sin", "sinh", "tan", "tanh", "sec", "sech", "csc", "csch", "cot", "coth", "log", "ln"];
function normalize_function_names(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("apply" === r) {
    if ("sqrt" === n[0]) return ["^", normalize_function_names(n[1]), 0.5];
    var i2 = normalize_function_names_sub(n[0]);
    i2 = ["apply", i2];
    var a = n.slice(1).map((function(e3) {
      return normalize_function_names(e3);
    }));
    return a = a.length > 1 ? ["tuple"].concat(a) : a[0], i2.push(a), i2;
  }
  return "^" === r && "e" === n[0] && math$1.define_e ? ["apply", "exp", normalize_function_names(n[1])] : "binom" === r ? ["apply", "nCr", ["tuple", normalize_function_names(n[0]), normalize_function_names(n[1])]] : [r].concat(n.map((function(e3) {
    return normalize_function_names(e3);
  })));
}
function normalize_function_names_sub(e2) {
  if ("string" == typeof e2) return e2 in function_normalizations ? function_normalizations[e2] : e2;
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if ("^" === t2 && 2 === r.length && -1 === r[1]) {
    let e3 = normalize_function_names_sub(r[0]);
    if (create_trig_inverses_for.includes(e3)) return "a" + e3;
  }
  return [t2].concat(r.map((function(e3) {
    return normalize_function_names_sub(e3);
  })));
}
function normalize_applied_functions(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("apply" === r) {
    let e3 = n[0];
    if ("^" === e3[0]) {
      let t3 = e3[1], r3 = e3[2];
      return -1 !== r3 && move_exponents_outside_for.includes(t3) ? ["^", ["apply", t3, normalize_applied_functions(n[1])], r3] : ["apply", e3, normalize_applied_functions(n[1])];
    }
    let t22 = 0;
    for (; "prime" === e3[0]; ) t22 += 1, e3 = e3[1];
    let r2 = ["apply", e3, normalize_applied_functions(n[1])];
    for (let e4 = 0; e4 < t22; e4++) r2 = ["prime", r2];
    return r2;
  }
  return [r].concat(n.map((function(e3, t22) {
    return normalize_applied_functions(e3);
  })));
}
function log_subscript_to_two_arg_log(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  if ("apply" === r && 2 === n.length) {
    let e3 = n[0];
    if (Array.isArray(e3) && 3 === e3.length && "_" === e3[0] && "log" === e3[1]) return ["apply", "log", ["tuple", n[1], e3[2]]];
  }
  return [r, ...n.map(log_subscript_to_two_arg_log)];
}
function substitute_abs(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  return "apply" === r && "abs" === n[0] ? ["^", ["^", substitute_abs(n[1]), 2], 0.5] : [r].concat(n.map((function(e3) {
    return substitute_abs(e3);
  })));
}
function constants_to_floats(e2) {
  var t2 = get_tree(e2);
  if (!math$1.define_e && !math$1.define_pi) return t2;
  if ("string" == typeof t2) {
    if ("e" === t2) {
      if (math$1.define_e) return math$1.e;
    } else if ("pi" === t2 && math$1.define_pi) return math$1.pi;
    return t2;
  }
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  return "^" === r && "e" === n[0] ? ["^", "e", constants_to_floats(n[1])] : [r, ...n.map(constants_to_floats)];
}
function normalize_angle_linesegment_arg_order(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  return "angle" === r && 3 === n.length && 1 === compare_function(n[0], n[2]) || "linesegment" === r && 2 === n.length && 1 === compare_function(n[0], n[1]) ? (n.reverse(), [r, ...n]) : [r, ...n.map(normalize_angle_linesegment_arg_order)];
}
function normalize_negative_numbers(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  if ("-" === r && 1 === n.length) {
    if ("number" == typeof n[0] && n[0] >= 0) return -n[0];
    if (Array.isArray(n[0]) && "*" === n[0][0] && "number" == typeof n[0][1] && n[0][1] >= 0) return ["*", -n[0][1], ...n[0].slice(2).map(normalize_negative_numbers)];
  }
  return [r, ...n.map(normalize_negative_numbers)];
}
var astToMathjs = new astToMathjs$1({ mathjs: math$1 }), astToFiniteField = new astToFiniteField$1();
const f = function(e2) {
  var t2 = get_tree(e2), r = factorial_to_gamma_function(astToMathjs.convert(log_subscript_to_two_arg_log(normalize_function_names(normalize_applied_functions(t2)))));
  return r.evaluate.bind(r);
}, evaluate$1 = function(e2, t2) {
  return f(e2)(t2);
}, finite_field_evaluate = function(e2, t2, r) {
  return astToFiniteField.convert(e2.tree, t2, r);
}, evaluate_to_constant = function(e2, { remove_units_first: t2 = true, scale_based_on_unit: r = true, nan_for_non_numeric: n = true } = {}) {
  var i2 = get_tree(e2);
  if (t2 && (i2 = remove_units(i2, r)), "number" == typeof i2) return i2;
  if ("string" == typeof i2) return "pi" === i2 && math$1.define_pi ? Math.PI : "e" === i2 && math$1.define_e ? Math.E : "i" === i2 && math$1.define_i ? { re: 0, im: 1 } : n ? NaN : null;
  if (!Array.isArray(i2)) return n ? NaN : null;
  var a = [];
  a.push([["^", "x", ["/", "m", "n"]], ["^", ["apply", "nthRoot", ["tuple", "x", "n"]], "m"], { variables: { x: (e3) => e3 < 0, n: (e3) => Number.isInteger(e3) && Number.isInteger((e3 - 1) / 2), m: (e3) => Number.isInteger(e3) } }]), a.push([["^", "x", ["-", ["/", "m", "n"]]], ["^", ["apply", "nthRoot", ["tuple", "x", "n"]], ["-", "m"]], { variables: { x: (e3) => e3 < 0, n: (e3) => Number.isInteger(e3) && Number.isInteger((e3 - 1) / 2), m: (e3) => Number.isInteger(e3) } }]), i2 = applyAllTransformations(i2, a, 40);
  var o = n ? NaN : null;
  try {
    o = f(i2)();
  } catch (e3) {
  }
  if (!Number.isNaN(o) && ("number" == typeof o || "number" == typeof o?.re && "number" == typeof o?.im)) {
    if (o.re === 1 / 0 || o.re === -1 / 0 || o.im === 1 / 0 || o.im === -1 / 0) {
      let e3;
      if ("number" == typeof o?.re && "number" == typeof o?.im) if (0 === o.im) e3 = o.re;
      else {
        let t22;
        t22 = 1 === o.im ? "i" : -1 === o.im ? ["-", "i"] : ["*", o.im, "i"], e3 = 0 === o.re ? t22 : ["+", o.re, t22];
      }
      else e3 = o;
      o = n ? NaN : null;
      try {
        o = f(e3)();
      } catch (e4) {
      }
    } else 0 === o.im && (o = o.re);
    return o;
  }
  return "object" == typeof o && (o = n ? NaN : null), o;
};
function factorial_to_gamma_function(e2) {
  return e2.transform((function(e3, t2, r) {
    if (e3.isOperatorNode && "!" === e3.op && "factorial" === e3.fn) {
      var n = [new math$1.OperatorNode("+", "add", [e3.args[0], new math$1.ConstantNode(1)])];
      return new math$1.FunctionNode(new math$1.SymbolNode("gamma"), n);
    }
    return e3;
  }));
}
var evaluation = Object.freeze({ __proto__: null, f, evaluate: evaluate$1, finite_field_evaluate, evaluate_to_constant }), functions = { C: {}, R: {}, nonzeroC: {}, nonneg: {}, pos: {} };
function negate_adjust(e2, t2) {
  return e2 ? !t2 : false === e2 ? t2 : void 0;
}
function narrow_assumptions(e2, t2) {
  if (!Array.isArray(t2)) return [];
  var r = t2[0], n = t2.slice(1);
  if ("and" !== r) return [];
  for (var i2 = [], a = 0; a < n.length; a++) equal(n[a], e2) || i2.push(n[a]);
  return 0 === i2.length ? [] : 1 === i2.legnth ? i2[0] : [r].concat(i2);
}
function simple_assumption_combination(e2, t2, r) {
  return "and" === e2 ? void 0 === t2 ? r : void 0 === r ? t2 : t2 || r : void 0 !== t2 && void 0 !== r && t2 === r ? t2 : void 0;
}
function is_integer_ast(e2, t2, r) {
  if ("object" != typeof t2 && (t2 = []), void 0 === r && (r = t2), "number" == typeof e2) return Number.isInteger(e2);
  var n = evaluate_to_constant(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== n) return Number.isInteger(n);
  if ("string" == typeof e2) {
    let n3;
    if (n3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(n3)) return;
    let i2 = n3, a = n3[0], o = n3.slice(1), s = false;
    for (; "not" === a; ) {
      if (s = !s, n3 = o[0], !Array.isArray(n3)) return;
      a = n3[0], o = n3.slice(1);
    }
    if ("in" === a && o[0] === e2 && "Z" === o[1]) return negate_adjust(true, s);
    if ("notin" === a && o[0] === e2 && "Z" === o[1]) return negate_adjust(false, s);
    if (false === s) {
      if ("notin" === a) {
        if (o[0] === e2 && "R" === o[1]) return false;
        if (o[0] === e2 && "C" === o[1]) return false;
      }
    } else if ("in" === a) {
      if (o[0] === e2 && "R" === o[1]) return false;
      if (o[0] === e2 && "Z" === o[1]) return false;
    }
    if ("=" === a && !s || "ne" === a && s) {
      let t22 = narrow_assumptions(i2, r);
      if (o[0] === e2) return is_integer_ast(o[1], t22);
      if (o[1] === e2) return is_integer_ast(o[0], t22);
    }
    if ("and" !== a && "or" !== a) return;
    if (s) return;
    return o.length > 2 && (n3 = unflattenRight(n3), o = n3.slice(1)), simple_assumption_combination(a, is_integer_ast(e2, o[0], r), is_integer_ast(e2, o[1], r));
  }
  if (Array.isArray(e2)) {
    let n3;
    n3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables(e2)]);
    let i2 = e2[0], a = e2.slice(1);
    if ("-" === i2) return is_integer_ast(a[0], n3, r);
    if ("*" === i2) {
      return !!a.every((function(e3) {
        return is_integer_ast(e3, n3, r);
      })) || void 0;
    }
    if ("^" === i2) {
      let e3 = is_nonzero_ast(a[0], n3, r);
      if (e3) {
        if (false === is_nonzero_ast(a[1], n3, r)) return a[0] !== 1 / 0 && a[0] !== -1 / 0;
      } else {
        if (Number.isNaN(a[0])) return false;
        if (!is_positive_ast(a[1], n3, true, r)) return;
        if (false === e3) return true;
      }
      let t22 = is_integer_ast(a[0], n3, r), i22 = is_integer_ast(a[1], n3, r);
      if (!t22) return t22;
      if (!i22) return;
      return !!is_positive_ast(a[1], n3, false, r) || void 0;
    }
    if ("+" === i2) {
      let e3 = 0;
      for (let t22 = 0; t22 < a.length; t22++) {
        let i22 = is_integer_ast(a[t22], n3, r);
        if (false === i22) {
          if (e3 > 0) return;
          e3 += 1;
        }
        if (void 0 === i22) return;
      }
      return 0 === e3;
    }
    if ("apply" === i2) return !!(functions.C.Z && functions.C.Z.includes(a[0]) && is_complex_ast(a[1], n3, r)) || (!!(functions.R.Z && functions.R.Z.includes(a[0]) && is_real_ast(a[1], n3, r)) || (!!(functions.nonzeroC.Z && functions.nonzeroC.Z.includes(a[0]) && is_nonzero_ast(a[1], n3, r) && is_complex_ast(a[1], n3, r)) || (!!(functions.nonneg.Z && functions.nonneg.Z.includes(a[0]) && is_positive_ast(a[1], n3, false, r)) || (!!(functions.pos.Z && functions.pos.Z.includes(a[0]) && is_positive_ast(a[1], n3, true, r)) || void 0))));
    if ("/" === i2 || "prime" === i2) return;
    return false;
  }
  return false;
}
function is_real_ast(e2, t2, r) {
  if ("object" != typeof t2 && (t2 = []), void 0 === r && (r = t2), "number" == typeof e2) return Number.isFinite(e2);
  var n = evaluate_to_constant(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== n) return "number" == typeof n && Number.isFinite(n);
  if ("string" == typeof e2) {
    let n3;
    if (n3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(n3)) return;
    let i2 = n3, a = n3[0], o = n3.slice(1), s = false;
    for (; "not" === a; ) {
      if (s = !s, n3 = o[0], !Array.isArray(n3)) return;
      a = n3[0], o = n3.slice(1);
    }
    if ("in" === a && o[0] === e2 && "R" === o[1]) return negate_adjust(true, s);
    if ("notin" === a && o[0] === e2 && "R" === o[1]) return negate_adjust(false, s);
    if (false === s) {
      if ("in" === a && o[0] === e2 && "Z" === o[1]) return true;
    } else if ("notin" === a && o[0] === e2 && "Z" === o[1]) return true;
    if ("<" === a || "le" === a) {
      let t22 = variables(n3), r2 = functions$2(n3);
      if (-1 !== t22.indexOf(e2) && 0 === r2.length) return true;
    }
    if ("=" === a && !s || "ne" === a && s) {
      let t22 = narrow_assumptions(i2, r);
      if (o[0] === e2) return is_real_ast(o[1], t22);
      if (o[1] === e2) return is_real_ast(o[0], t22);
    }
    if ("and" !== a && "or" !== a) return;
    if (s) return;
    return o.length > 2 && (n3 = unflattenRight(n3), o = n3.slice(1)), simple_assumption_combination(a, is_real_ast(e2, o[0], r), is_real_ast(e2, o[1], r));
  }
  if (Array.isArray(e2)) {
    let n3;
    n3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables(e2)]);
    let i2 = e2[0], a = e2.slice(1);
    if ("-" === i2) return is_real_ast(a[0], n3, r);
    if ("*" === i2 || "+" === i2) {
      if (a.length > 2 && (a = (e2 = unflattenRight(e2)).slice(1)), "*" === i2 && (false === is_nonzero_ast(a[0], n3, r) || false === is_nonzero_ast(a[1], n3, r))) return true;
      let t22 = is_real_ast(a[0], n3, r), o = is_real_ast(a[1], n3, r);
      return !(!t22 || !o) || !(t22 && false === o || o && false === t22) && void 0;
    }
    if ("^" === i2) {
      let e3 = is_nonzero_ast(a[0], n3, r), t22 = is_positive_ast(a[1], n3, true, r);
      if (e3) {
        if (false === is_nonzero_ast(a[1], n3, r)) return a[0] !== 1 / 0 && a[0] !== -1 / 0;
      } else {
        if (Number.isNaN(a[0])) return false;
        if (!t22) return;
        if (false === e3) return true;
      }
      let i22 = is_real_ast(a[0], n3, r), o = is_real_ast(a[1], n3, r);
      if (!i22 || !o) return;
      if (!is_positive_ast(a[0], n3, false, r)) {
        return !!is_integer_ast(a[1], n3, r) || void 0;
      }
      return !!is_positive_ast(a[0], n3, true, r) || (!!t22 || void 0);
    }
    if ("/" === i2) {
      if (!is_nonzero_ast(a[1], n3, r)) return;
      if (false === is_nonzero_ast(a[0], n3, r)) return true;
      if (!is_real_ast(a[0], n3, r) || !is_real_ast(a[1], n3, r)) return;
      return true;
    }
    if ("apply" === i2) return !!(functions.C.R && functions.C.R.includes(a[0]) && is_complex_ast(a[1], n3, r)) || (!!(functions.R.R && functions.R.R.includes(a[0]) && is_real_ast(a[1], n3, r)) || (!!(functions.nonzeroC.R && functions.nonzeroC.R.includes(a[0]) && is_nonzero_ast(a[1], n3, r) && is_complex_ast(a[1], n3, r)) || (!!(functions.nonneg.R && functions.nonneg.R.includes(a[0]) && is_positive_ast(a[1], n3, false, r)) || (!!(functions.pos.R && functions.pos.R.includes(a[0]) && is_positive_ast(a[1], n3, true, r)) || void 0))));
    if ("prime" === i2) return;
    return false;
  }
  return false;
}
function is_complex_ast(e2, t2, r) {
  if ("object" != typeof t2 && (t2 = []), void 0 === r && (r = t2), "number" == typeof e2) return Number.isFinite(e2);
  var n = evaluate_to_constant(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== n) return "number" == typeof n ? Number.isFinite(n) : !(void 0 === n.re || !Number.isFinite(n.re) || void 0 === n.im || !Number.isFinite(n.im));
  if ("string" == typeof e2) {
    let n3;
    if (n3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(n3)) return;
    let i2 = n3, a = n3[0], o = n3.slice(1), s = false;
    for (; "not" === a; ) {
      if (s = !s, n3 = o[0], !Array.isArray(n3)) return;
      a = n3[0], o = n3.slice(1);
    }
    if ("in" === a && o[0] === e2 && "C" === o[1]) return negate_adjust(true, s);
    if ("notin" === a && o[0] === e2 && "C" === o[1]) return negate_adjust(false, s);
    if (false === s) {
      if ("in" === a) {
        if (o[0] === e2 && "Z" === o[1]) return true;
        if (o[0] === e2 && "R" === o[1]) return true;
      }
    } else if ("notin" === a) {
      if (o[0] === e2 && "Z" === o[1]) return true;
      if (o[0] === e2 && "R" === o[1]) return true;
    }
    if ("<" === a || "le" === a) {
      let t22 = variables(n3), r2 = functions$2(n3);
      if (-1 !== t22.indexOf(e2) && 0 === r2.length) return true;
    }
    if ("=" === a && !s || "ne" === a && s) {
      let t22 = narrow_assumptions(i2, r);
      if (o[0] === e2) return is_complex_ast(o[1], t22);
      if (o[1] === e2) return is_complex_ast(o[0], t22);
    }
    if ("and" !== a && "or" !== a) return;
    if (s) return;
    return o.length > 2 && (n3 = unflattenRight(n3), o = n3.slice(1)), simple_assumption_combination(a, is_complex_ast(e2, o[0], r), is_complex_ast(e2, o[1], r));
  }
  if (Array.isArray(e2)) {
    let n3;
    n3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables(e2)]);
    let i2 = e2[0], a = e2.slice(1);
    if ("-" === i2) return is_complex_ast(a[0], n3, r);
    if ("*" === i2 || "+" === i2) {
      if ("*" === i2 && !a.every(((e3) => false !== is_nonzero_ast(e3, n3, r)))) return true;
      return !!a.every(((e3) => is_complex_ast(e3, n3, r))) || void 0;
    }
    if ("^" === i2) {
      let e3 = is_nonzero_ast(a[0], n3, r), t22 = is_positive_ast(a[1], n3, true, r);
      if (e3) {
        if (false === is_nonzero_ast(a[1], n3, r)) return a[0] !== 1 / 0 && a[0] !== -1 / 0;
      } else {
        if (Number.isNaN(a[0])) return false;
        if (!t22) return;
        if (false === e3) return true;
      }
      let i22 = is_complex_ast(a[0], n3, r), o = is_complex_ast(a[1], n3, r);
      return !(!i22 || !o) || void 0;
    }
    if ("/" === i2) {
      if (!is_nonzero_ast(a[1], n3, r)) return;
      if (false === is_nonzero_ast(a[0], n3, r)) return true;
      if (!is_complex_ast(a[0], n3, r) || !is_complex_ast(a[1], n3, r)) return;
      return true;
    }
    if ("apply" === i2) return !!(functions.C.C && functions.C.C.includes(a[0]) && is_complex_ast(a[1], n3, r)) || (!!(functions.R.C && functions.R.C.includes(a[0]) && is_real_ast(a[1], n3, r)) || (!!(functions.nonzeroC.C && functions.nonzeroC.C.includes(a[0]) && is_nonzero_ast(a[1], n3, r) && is_complex_ast(a[1], n3, r)) || (!!(functions.nonneg.C && functions.nonneg.C.includes(a[0]) && is_positive_ast(a[1], n3, false, r)) || (!!(functions.pos.C && functions.pos.C.includes(a[0]) && is_positive_ast(a[1], n3, true, r)) || void 0))));
    if ("prime" === i2) return;
    return false;
  }
  return false;
}
function is_nonzero_ast(e2, t2, r) {
  if ("object" != typeof t2 && (t2 = []), void 0 === r && (r = t2), "number" == typeof e2) {
    if (Number.isFinite(e2)) return 0 !== e2;
    if (Number.isNaN(e2)) return;
    return true;
  }
  var n = evaluate_to_constant(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== n) {
    if ("number" == typeof n) {
      if (Number.isFinite(n)) return 0 !== n;
      if (Number.isNaN(n)) return;
      return true;
    }
    return void 0 !== n.re && void 0 !== n.im && (0 !== n.re || 0 !== n.im) || void 0;
  }
  if ("string" == typeof e2) {
    let n3;
    if (n3 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(n3)) return;
    let i2 = n3, a = n3[0], o = n3.slice(1), s = false;
    for (; "not" === a; ) {
      if (s = !s, n3 = o[0], !Array.isArray(n3)) return;
      a = n3[0], o = n3.slice(1);
    }
    let u = narrow_assumptions(i2, r);
    if ("=" === a && !s || "ne" === a && s) {
      if (o[0] === e2) return is_nonzero_ast(o[1], u);
      if (o[1] === e2) return is_nonzero_ast(o[0], u);
    }
    if ("ne" === a && !s || "=" === a && s) {
      if (o[0] === e2 && false === is_nonzero_ast(o[1], u)) return true;
      if (o[1] === e2 && false === is_nonzero_ast(o[0], u)) return true;
    }
    if ("<" === a) if (s) {
      if (o[0] === e2 && is_positive_ast(o[1], u, true)) return true;
      if (o[1] === e2 && is_negative_ast(o[0], u, true)) return true;
    } else {
      if (o[0] === e2 && is_negative_ast(o[1], u, false)) return true;
      if (o[1] === e2 && is_positive_ast(o[0], u, false)) return true;
    }
    if ("le" === a) if (s) {
      if (o[0] === e2 && is_positive_ast(o[1], u, false)) return true;
      if (o[1] === e2 && is_negative_ast(o[0], u, false)) return true;
    } else {
      if (o[0] === e2 && is_negative_ast(o[1], u, true)) return true;
      if (o[1] === e2 && is_positive_ast(o[0], u, true)) return true;
    }
    if ("and" !== a && "or" !== a) return;
    if (s) return;
    return o.length > 2 && (n3 = unflattenRight(n3), o = n3.slice(1)), simple_assumption_combination(a, is_nonzero_ast(e2, o[0], r), is_nonzero_ast(e2, o[1], r));
  }
  if (Array.isArray(e2)) {
    let n3;
    n3 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables(e2)]);
    let i2 = e2[0], a = e2.slice(1);
    if ("-" === i2) return is_nonzero_ast(a[0], n3, r);
    if ("+" === i2) {
      if (a.length > 2 && (a = (e2 = unflattenRight(e2)).slice(1)), equal(a[0], simplify(["-", a[1]], r))) return false;
      let t22 = is_nonzero_ast(a[0], n3, r), i22 = is_nonzero_ast(a[1], n3, r);
      if (false === t22) return i22;
      if (false === i22) return t22;
      let o = is_real_ast(a[0], n3, r), s = is_real_ast(a[1], n3, r);
      if (!o || !s) return true === o ? false === s || void 0 : true === s && false === o || void 0;
      let u = is_positive_ast(a[0], n3, false, r), c2 = is_positive_ast(a[1], n3, false, r), l = is_positive_ast(a[0], n3, true, r), f2 = is_positive_ast(a[1], n3, true, r);
      return !!(u && f2 || l && c2) || (false === u && false === f2 || false === l && false === c2 || void 0);
    }
    if ("*" === i2) {
      let e3 = true;
      for (let t22 = 0; t22 < a.length; t22++) {
        let i22 = is_nonzero_ast(a[t22], n3, r);
        if (false === i22) return false;
        void 0 === i22 && (e3 = false);
      }
      return !!e3 || void 0;
    }
    if ("/" === i2) {
      let e3 = is_nonzero_ast(a[0], n3, r);
      return is_nonzero_ast(a[1], n3, r) ? e3 : void 0;
    }
    if ("^" === i2) {
      let e3 = is_nonzero_ast(a[0], n3, r);
      if (e3) {
        if (a[0] === 1 / 0 || a[0] === -1 / 0) {
          if (false === is_nonzero_ast(a[1], n3, r)) return;
        }
        return true;
      }
      return (!is_positive_ast(a[1], n3, true, r) || false !== e3) && void 0;
    }
    if ("apply" === i2) return !!(functions.C.nonzero && functions.C.nonzero.includes(a[0]) && is_complex_ast(a[1], n3, r)) || (!!(functions.R.nonzero && functions.R.nonzero.includes(a[0]) && is_real_ast(a[1], n3, r)) || (!!(functions.nonzeroC.nonzero && functions.nonzeroC.nonzero.includes(a[0]) && is_nonzero_ast(a[1], n3, r) && is_complex_ast(a[1], n3, r)) || (!!(functions.nonneg.nonzero && functions.nonneg.nonzero.includes(a[0]) && is_positive_ast(a[1], n3, false, r)) || (!!(functions.pos.nonzero && functions.pos.nonzero.includes(a[0]) && is_positive_ast(a[1], n3, true, r)) || void 0))));
    if ("prime" === i2) return;
    return false;
  }
  return false;
}
function is_positive_ast(e2, t2, r, n) {
  if ("object" != typeof t2 && (t2 = []), void 0 === n && (n = t2), void 0 === r && (r = true), "number" == typeof e2) return !!Number.isFinite(e2) && (r ? e2 > 0 : e2 >= 0);
  var i2 = is_real_ast(e2, t2, n);
  if (!i2) return i2;
  var a = evaluate_to_constant(e2, { remove_units_first: false, nan_for_non_numeric: false });
  if (null !== a) return "number" == typeof a && (!!Number.isFinite(a) && (r ? a > 0 : a >= 0));
  if ("string" == typeof e2) {
    let i22;
    if (i22 = Array.isArray(t2) ? t2 : t2.get_assumptions(e2), !Array.isArray(i22)) return;
    let a2 = i22, o = i22[0], s = i22.slice(1), u = false;
    for (; "not" === o; ) {
      if (u = !u, i22 = s[0], !Array.isArray(i22)) return;
      o = i22[0], s = i22.slice(1);
    }
    let c2 = narrow_assumptions(a2, n);
    if ("=" === o && !u || "ne" === o && u) {
      if (s[0] === e2) return is_positive_ast(s[1], c2, r);
      if (s[1] === e2) return is_positive_ast(s[0], c2, r);
    }
    if ("<" === o) if (u) {
      if (s[0] === e2 && is_positive_ast(s[1], c2, r)) return true;
      if (s[1] === e2 && is_negative_ast(s[0], c2, !r)) return false;
    } else {
      if (s[0] === e2 && is_negative_ast(s[1], c2, false)) return false;
      if (s[1] === e2 && is_positive_ast(s[0], c2, false)) return true;
    }
    if ("le" === o) if (u) {
      if (s[0] === e2 && is_positive_ast(s[1], c2, false)) return true;
      if (s[1] === e2 && is_negative_ast(s[0], c2, false)) return false;
    } else {
      if (s[0] === e2 && is_negative_ast(s[1], c2, !r)) return false;
      if (s[1] === e2 && is_positive_ast(s[0], c2, r)) return true;
    }
    if ("and" !== o && "or" !== o) return;
    if (u) return;
    return s.length > 2 && (i22 = unflattenRight(i22), s = i22.slice(1)), simple_assumption_combination(o, is_positive_ast(e2, s[0], r, n), is_positive_ast(e2, s[1], r, n));
  }
  if (Array.isArray(e2)) {
    let i22;
    i22 = Array.isArray(t2) ? t2 : t2.get_assumptions([variables(e2)]);
    let a2 = e2[0], o = e2.slice(1);
    if ("-" === a2) return is_negative_ast(o[0], i22, r, n);
    if ("+" === a2) {
      o.length > 2 && (o = (e2 = unflattenRight(e2)).slice(1));
      let t22 = is_positive_ast(o[0], i22, false, n), a3 = is_positive_ast(o[1], i22, false, n), s = is_positive_ast(o[0], i22, true, n), u = is_positive_ast(o[1], i22, true, n);
      if (r) {
        if (t22 && u || s && a3) return true;
      } else if (t22 && a3) return true;
      if (r) {
        if (false === s && false === u) return false;
      } else if (false === t22 && false === u || false === s && false === a3) return false;
      return;
    }
    if ("*" === a2) {
      if (!o.every(((e3) => false !== is_nonzero_ast(e3, i22, n)))) return !r;
      o.length > 2 && (o = (e2 = unflattenRight(e2)).slice(1));
      let t22 = is_real_ast(o[0], i22, n), a3 = is_real_ast(o[1], i22, n);
      if (void 0 === t22 || void 0 === a3) return;
      if (false === t22) return false === a3 && void 0;
      if (false === a3) return false;
      let s = is_positive_ast(o[0], i22, false, n), u = is_positive_ast(o[1], i22, false, n), c2 = is_positive_ast(o[0], i22, true, n), l = is_positive_ast(o[1], i22, true, n);
      if (r) {
        if (c2 && l || false === s && false === u) return true;
        if (false === c2 && u || s && false === l) return false;
      } else {
        if (s && u || false === c2 && false === l) return true;
        if (c2 && false === u || false === s && l) return false;
      }
      return;
    }
    if ("/" === a2) {
      if (!is_nonzero_ast(o[1], i22, n)) return;
      if (false === is_nonzero_ast(o[0], i22, n)) return !r;
      let e3 = is_positive_ast(o[1], i22, true, n);
      if (void 0 === e3) return;
      let t22 = e3 ? r : !r, a3 = is_positive_ast(o[0], i22, t22, n);
      if (void 0 === a3) return;
      return true === a3 ? true === e3 : true !== e3;
    }
    if ("^" === a2) {
      let e3 = is_nonzero_ast(o[0], i22, n);
      if (e3) {
        if (false === is_nonzero_ast(o[1], i22, n)) {
          if (o[0] === 1 / 0 || o[0] === -1 / 0) return;
          return true;
        }
      } else {
        if (!is_positive_ast(o[1], i22, true, n)) return;
        if (false === e3) return !r;
        if (r) return;
      }
      if (true !== is_real_ast(o[0], i22, n)) return;
      if (!is_positive_ast(o[0], i22, r, n)) {
        return !!is_integer_ast(simplify(["/", o[1], 2], n), i22, n) || void 0;
      }
      return !!is_real_ast(o[1], i22, n) || void 0;
    }
    if ("apply" === a2 && !r) return !!(functions.C.nonneg && functions.C.nonneg.includes(o[0]) && is_complex_ast(o[1], i22, n)) || (!!(functions.R.nonneg && functions.R.nonneg.includes(o[0]) && is_real_ast(o[1], i22, n)) || (!!(functions.nonzeroC.nonneg && functions.nonzeroC.nonneg.includes(o[0]) && is_nonzero_ast(o[1], i22, n) && is_complex_ast(o[1], i22, n)) || (!!(functions.nonneg.nonneg && functions.nonneg.nonneg.includes(o[0]) && is_positive_ast(o[1], i22, false, n)) || (!!(functions.pos.nonneg && functions.pos.nonneg.includes(o[0]) && is_positive_ast(o[1], i22, true, n)) || void 0))));
    if ("apply" === a2 && r) return !!(functions.C.pos && functions.C.pos.includes(o[0]) && is_complex_ast(o[1], i22, n)) || (!!(functions.R.pos && functions.R.pos.includes(o[0]) && is_real_ast(o[1], i22, n)) || (!!(functions.nonzeroC.pos && functions.nonzeroC.pos.includes(o[0]) && is_nonzero_ast(o[1], i22, n) && is_complex_ast(o[1], i22, n)) || (!!(functions.nonneg.pos && functions.nonneg.pos.includes(o[0]) && is_positive_ast(o[1], i22, false, n)) || (!!(functions.pos.pos && functions.pos.pos.includes(o[0]) && is_positive_ast(o[1], i22, true, n)) || void 0))));
    if ("prime" === a2) return;
    return false;
  }
  return false;
}
function is_negative_ast(e2, t2, r, n) {
  void 0 === r && (r = true);
  var i2 = is_real_ast(e2, t2, n);
  if (true === i2) {
    let i22 = is_positive_ast(e2, t2, !r, n);
    return false === i22 || true !== i22 && void 0;
  }
  return i2;
}
function tuples_to_vectors(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("tuple" === r) {
    return ["vector"].concat(n.map((function(e3, t22) {
      return tuples_to_vectors(e3);
    })));
  }
  if ("apply" === r) {
    if ("tuple" === n[1][0]) {
      let e3 = tuples_to_vectors(n[0]), t22 = n[1].slice(1);
      return ["apply", e3, ["tuple"].concat(t22.map((function(e4, t3) {
        return tuples_to_vectors(e4);
      })))];
    }
  } else {
    if ("gts" === r || "lts" === r || "interval" === r) {
      let e3 = n[0], t22 = n[1];
      if ("tuple" !== e3[0] || "tuple" !== t22[0]) throw new Error("Badly formed ast");
      return [r, ["tuple"].concat(e3.slice(1).map((function(e4, t3) {
        return tuples_to_vectors(e4);
      }))), t22];
    }
    if ("matrix" === r) {
      let e3 = n[0], t22 = n[1];
      return e3 = ["tuple"].concat(e3.slice(1).map(tuples_to_vectors)), t22 = ["tuple"].concat(t22.slice(1).map(((e4) => ["tuple"].concat(e4.slice(1).map(tuples_to_vectors))))), ["matrix", e3, t22];
    }
  }
  return [r].concat(n.map((function(e3, t22) {
    return tuples_to_vectors(e3);
  })));
}
function to_intervals(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("tuple" === r && 2 === n.length) {
    let e3 = ["tuple"].concat(n.map((function(e4, t22) {
      return to_intervals(e4);
    })));
    return e3 = ["interval", e3, ["tuple", false, false]], e3;
  }
  if ("array" === r && 2 === n.length) {
    let e3 = ["tuple"].concat(n.map((function(e4, t22) {
      return to_intervals(e4);
    })));
    return e3 = ["interval", e3, ["tuple", true, true]], e3;
  }
  if ("apply" === r) {
    if ("tuple" === n[1][0]) {
      let e3 = to_intervals(n[0]), t22 = n[1].slice(1);
      return ["apply", e3, ["tuple"].concat(t22.map((function(e4, t3) {
        return to_intervals(e4);
      })))];
    }
  } else if ("gts" === r || "lts" === r || "interval" === r) {
    let e3 = n[0], t22 = n[1];
    if ("tuple" !== e3[0] || "tuple" !== t22[0]) throw new Error("Badly formed ast");
    return [r, ["tuple"].concat(e3.slice(1).map((function(e4, t3) {
      return to_intervals(e4);
    }))), t22];
  }
  return [r].concat(n.map((function(e3, t22) {
    return to_intervals(e3);
  })));
}
function altvectors_to_vectors(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if ("altvector" === r) {
    return ["vector"].concat(n.map((function(e3, t22) {
      return altvectors_to_vectors(e3);
    })));
  }
  return [r].concat(n.map((function(e3, t22) {
    return altvectors_to_vectors(e3);
  })));
}
function ParseError(e2, t2) {
  this.name = "ParseError", this.message = e2 || "Error parsing input", this.stack = new Error().stack, this.location = t2;
}
functions.C.nonneg = ["abs"], functions.C.nonzero = ["exp"], functions.C.R = ["abs", "arg"], functions.C.C = ["abs", "arg", "exp", "sign", "cos", "cosh", "sin", "sinh", "erf", "sqrt", "log", "ln", "log10"], functions.R.pos = ["exp"], functions.R.nonneg = ["abs", "exp", "arg"], functions.R.R = ["abs", "arg", "exp", "sign", "cos", "cosh", "sin", "sinh", "erf"], functions.R.Z = ["sign"], functions.nonzeroC.pos = ["abs"], functions.nonneg.nonneg = ["abs", "exp", "arg", "sqrt", "erf"], functions.nonzeroC.nonzero = ["abs"], functions.nonneg.R = [...new Set(functions.R.R.concat(functions.nonneg.nonneg))], functions.pos.pos = ["abs", "exp", "sqrt", "erf"], functions.pos.nonneg = functions.pos.pos, functions.pos.nonzero = ["abs", "exp", "sqrt", "erf"], functions.pos.R = functions.nonneg.R.concat(["log", "ln", "log10"]), ParseError.prototype = Object.create(Error.prototype), ParseError.prototype.constructor = ParseError;
class lexer {
  constructor(e2, t2 = "\\s") {
    this.input = "", this.location = 0, this.token_rules = [], this.initial_whitespace = new RegExp("^(" + t2 + ")+");
    for (let t22 of e2) this.token_rules.push([new RegExp("^" + t22[0])].concat(t22.slice(1)));
  }
  set_input(e2) {
    if ("string" != typeof e2) throw new Error("Input must be a string");
    this.input = e2, this.location = 0;
  }
  return_state() {
    return { input: this.input, location: this.location };
  }
  set_state({ input: e2 = null, location: t2 = 0 } = {}) {
    null !== e2 && (this.input = e2, this.location = t2);
  }
  advance({ remove_initial_space: e2 = true } = {}) {
    let t2 = this.initial_whitespace.exec(this.input);
    if (t2) {
      let r2 = t2[0].length;
      if (this.input = this.input.slice(r2), this.location += r2, !e2) return { token_type: "SPACE", token_text: t2[0], original_text: t2[0] };
    }
    if (0 === this.input.length) return { token_type: "EOF", token_text: "", original_text: "" };
    for (var r of (t2 = null, this.token_rules)) if (t2 = r[0].exec(this.input), t2) {
      let e3 = t2[0].length;
      this.input = this.input.slice(e3), this.location += e3;
      break;
    }
    return null === t2 ? { token_type: "INVALID", token_text: this.input[0], original_text: this.input[0] } : r.length > 2 ? { token_type: r[1], token_text: r[2], original_text: t2[0] } : { token_type: r[1], token_text: t2[0], original_text: t2[0] };
  }
  unput(e2) {
    if ("string" != typeof e2) throw new Error("Input must be a string");
    this.location -= e2.length, this.input = e2 + this.input;
  }
}
var is_associative = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$6(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if (r = r.map((function(e3, t22) {
    return flatten$6(e3);
  })), is_associative[t2]) {
    for (var n = [], i2 = 0; i2 < r.length; i2++) Array.isArray(r[i2]) && r[i2][0] === t2 && r[i2].length > 2 ? n = n.concat(r[i2].slice(1)) : n.push(r[i2]);
    r = n;
  }
  return [t2].concat(r);
}
const sci_notat_exp_regex$1 = "(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?", number_rules_sci$1 = [["[0-9]+(\\.[0-9]*)?" + sci_notat_exp_regex$1, "NUMBER"], ["\\.[0-9]+" + sci_notat_exp_regex$1, "NUMBER"]], number_rules_non_sci$1 = [["[0-9]+(\\.[0-9]*)?", "NUMBER"], ["\\.[0-9]+", "NUMBER"]], base_text_rules = [["\\*\\*", "^"], ["\\*", "*"], ["\\xB7", "*"], ["·", "*"], ["•", "*"], ["⋅", "*"], ["×", "*"], ["/", "/"], ["-", "-"], ["֊", "-"], ["־", "-"], ["᠆", "-"], ["‐", "-"], ["‑", "-"], ["‒", "-"], ["–", "-"], ["—", "-"], ["―", "-"], ["⁻", "-"], ["₋", "-"], ["−", "-"], ["⸺", "-"], ["⸻", "-"], ["﹘", "-"], ["﹣", "-"], ["－", "-"], ["\\+", "+"], ["\\^", "^"], ["‸", "^"], ["ʌ", "^"], ["′", "'"], ["\\|", "|"], ["\\(", "("], ["\\)", ")"], ["\\[", "["], ["\\]", "]"], ["\\{", "{"], ["\\}", "}"], ["⟨", "LANGLE"], ["⟩", "RANGLE"], ["〈", "LANGLE"], ["〉", "RANGLE"], [",", ","], [":", ":"], ["α", "VARMULTICHAR", "alpha"], ["β", "VARMULTICHAR", "beta"], ["ϐ", "VARMULTICHAR", "beta"], ["Γ", "VARMULTICHAR", "Gamma"], ["γ", "VARMULTICHAR", "gamma"], ["Δ", "VARMULTICHAR", "Delta"], ["δ", "VARMULTICHAR", "delta"], ["ε", "VARMULTICHAR", "epsilon"], ["ϵ", "VARMULTICHAR", "epsilon"], ["ζ", "VARMULTICHAR", "zeta"], ["η", "VARMULTICHAR", "eta"], ["Θ", "VARMULTICHAR", "Theta"], ["ϴ", "VARMULTICHAR", "Theta"], ["θ", "VARMULTICHAR", "theta"], ["ᶿ", "VARMULTICHAR", "theta"], ["ϑ", "VARMULTICHAR", "theta"], ["ι", "VARMULTICHAR", "iota"], ["κ", "VARMULTICHAR", "kappa"], ["Λ", "VARMULTICHAR", "Lambda"], ["λ", "VARMULTICHAR", "lambda"], ["μ", "VARMULTICHAR", "mu"], ["µ", "VARMULTICHAR", "mu"], ["ν", "VARMULTICHAR", "nu"], ["Ξ", "VARMULTICHAR", "Xi"], ["ξ", "VARMULTICHAR", "xi"], ["Π", "VARMULTICHAR", "Pi"], ["π", "VARMULTICHAR", "pi"], ["ϖ", "VARMULTICHAR", "pi"], ["ρ", "VARMULTICHAR", "rho"], ["ϱ", "VARMULTICHAR", "rho"], ["Σ", "VARMULTICHAR", "Sigma"], ["σ", "VARMULTICHAR", "sigma"], ["ς", "VARMULTICHAR", "sigma"], ["τ", "VARMULTICHAR", "tau"], ["Υ", "VARMULTICHAR", "Upsilon"], ["υ", "VARMULTICHAR", "upsilon"], ["Φ", "VARMULTICHAR", "Phi"], ["φ", "VARMULTICHAR", "phi"], ["ϕ", "VARMULTICHAR", "phi"], ["Ψ", "VARMULTICHAR", "Psi"], ["ψ", "VARMULTICHAR", "psi"], ["Ω", "VARMULTICHAR", "Omega"], ["ω", "VARMULTICHAR", "omega"], ["∅", "VARMULTICHAR", "emptyset"], ["oo(?![a-zA-Z0-9])", "INFINITY"], ["OO(?![a-zA-Z0-9])", "INFINITY"], ["infty(?![a-zA-Z0-9])", "INFINITY"], ["infinity(?![a-zA-Z0-9])", "INFINITY"], ["Infinity(?![a-zA-Z0-9])", "INFINITY"], ["∞", "INFINITY"], ["ℯ", "VAR", "e"], ["♠", "VARMULTICHAR", "spade"], ["♡", "VARMULTICHAR", "heart"], ["♢", "VARMULTICHAR", "diamond"], ["♣", "VARMULTICHAR", "club"], ["★", "VARMULTICHAR", "bigstar"], ["◯", "VARMULTICHAR", "bigcirc"], ["◊", "VARMULTICHAR", "lozenge"], ["△", "VARMULTICHAR", "bigtriangleup"], ["▽", "VARMULTICHAR", "bigtriangledown"], ["⧫", "VARMULTICHAR", "blacklozenge"], ["■", "VARMULTICHAR", "blacksquare"], ["▲", "VARMULTICHAR", "blacktriangle"], ["▼", "VARMULTICHAR", "blacktriangledown"], ["◀", "VARMULTICHAR", "blacktriangleleft"], ["▶", "VARMULTICHAR", "blacktriangleright"], ["□", "VARMULTICHAR", "Box"], ["∘", "VARMULTICHAR", "circ"], ["⋆", "VARMULTICHAR", "star"], ["and(?![a-zA-Z0-9])", "AND"], ["\\&\\&?", "AND"], ["∧", "AND"], ["or(?![a-zA-Z0-9])", "OR"], ["∨", "OR"], ["not(?![a-zA-Z0-9])", "NOT"], ["¬", "NOT"], ["=", "="], ["᐀", "="], ["゠", "="], ["!=", "NE"], ["≠", "NE"], ["<=", "LE"], ["≤", "LE"], [">=", "GE"], ["≥", "GE"], ["<", "<"], [">", ">"], ["forall(?![a-zA-Z0-9])", "FORALL"], ["∀", "FORALL"], ["exists(?![a-zA-Z0-9])", "EXISTS"], ["∃", "EXISTS"], ["elementof(?![a-zA-Z0-9])", "IN"], ["∈", "IN"], ["notelementof(?![a-zA-Z0-9])", "NOTIN"], ["∉", "NOTIN"], ["containselement(?![a-zA-Z0-9])", "NI"], ["∋", "NI"], ["notcontainselement(?![a-zA-Z0-9])", "NOTNI"], ["∌", "NOTNI"], ["subset(?![a-zA-Z0-9])", "SUBSET"], ["⊂", "SUBSET"], ["subseteq(?![a-zA-Z0-9])", "SUBSETEQ"], ["⊆", "SUBSETEQ"], ["notsubset(?![a-zA-Z0-9])", "NOTSUBSET"], ["⊄", "NOTSUBSET"], ["notsubseteq(?![a-zA-Z0-9])", "NOTSUBSETEQ"], ["⊈", "NOTSUBSETEQ"], ["superset(?![a-zA-Z0-9])", "SUPERSET"], ["⊃", "SUPERSET"], ["superseteq(?![a-zA-Z0-9])", "SUPERSETEQ"], ["⊇", "SUPERSETEQ"], ["notsuperset(?![a-zA-Z0-9])", "NOTSUPERSET"], ["⊅", "NOTSUPERSET"], ["notsuperseteq(?![a-zA-Z0-9])", "NOTSUPERSETEQ"], ["⊉", "NOTSUPERSETEQ"], ["union(?![a-zA-Z0-9])", "UNION"], ["∪", "UNION"], ["intersect(?![a-zA-Z0-9])", "INTERSECT"], ["∩", "INTERSECT"], ["rightarrow(?![a-zA-Z0-9])", "RIGHTARROW"], ["→", "RIGHTARROW"], ["⟶", "RIGHTARROW"], ["leftarrow(?![a-zA-Z0-9])", "LEFTARROW"], ["←", "LEFTARROW"], ["⟵", "LEFTARROW"], ["leftrightarrow(?![a-zA-Z0-9])", "LEFTRIGHTARROW"], ["↔", "LEFTRIGHTARROW"], ["⟷", "LEFTRIGHTARROW"], ["implies(?![a-zA-Z0-9])", "IMPLIES"], ["⇒", "IMPLIES"], ["⟹", "IMPLIES"], ["impliedby(?![a-zA-Z0-9])", "IMPLIEDBY"], ["⇐", "IMPLIEDBY"], ["⟸", "IMPLIEDBY"], ["iff(?![a-zA-Z0-9])", "IFF"], ["⇔", "IFF"], ["⟺", "IFF"], ["perp(?![a-zA-Z0-9])", "PERP"], ["⟂", "PERP"], ["parallel(?![a-zA-Z0-9])", "PARALLEL"], ["∥", "PARALLEL"], ["angle(?![a-zA-Z0-9])", "ANGLE"], ["∠", "ANGLE"], ["int(?![a-zA-Z0-9])", "INT"], ["∫", "INT"], ["!", "!"], ["'", "'"], ["_", "_"], ["\\.\\.\\.", "LDOTS"], ["[a-zA-Z∂][a-zA-Z∂0-9]*", "VAR"], ["[＿$%]", "VAR"]], allowSimplifiedFunctionApplicationDefault$1 = true, splitSymbolsDefault = true, unsplitSymbolsDefault = ["alpha", "beta", "gamma", "Gamma", "delta", "Delta", "epsilon", "zeta", "eta", "theta", "Theta", "iota", "kappa", "lambda", "Lambda", "mu", "nu", "xi", "Xi", "pi", "Pi", "rho", "sigma", "Sigma", "tau", "Tau", "upsilon", "Upsilon", "phi", "Phi", "chi", "psi", "Psi", "omega", "Omega", "angle", "deg", "emptyset"], appliedFunctionSymbolsDefault$1 = ["abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "cos", "cosh", "acos", "acosh", "arccos", "arccosh", "cot", "coth", "acot", "acoth", "arccot", "arccoth", "csc", "csch", "acsc", "acsch", "arccsc", "arccsch", "sec", "sech", "asec", "asech", "arcsec", "arcsech", "sin", "sinh", "asin", "asinh", "arcsin", "arcsinh", "tan", "tanh", "atan", "atan2", "atanh", "arctan", "arctanh", "arg", "conj", "re", "im", "det", "trace", "nPr", "nCr", "floor", "ceil", "round"], functionSymbolsDefault$1 = ["f", "g"], operatorSymbolsDefault$1 = ["binom", "vec", "linesegment"], unitsDefault$1 = get_all_units(), parseLeibnizNotationDefault$1 = true;
class textToAst$4 {
  constructor({ allowSimplifiedFunctionApplication: e2 = allowSimplifiedFunctionApplicationDefault$1, splitSymbols: t2 = splitSymbolsDefault, unsplitSymbols: r = unsplitSymbolsDefault, appliedFunctionSymbols: n = appliedFunctionSymbolsDefault$1, functionSymbols: i2 = functionSymbolsDefault$1, operatorSymbols: a = operatorSymbolsDefault$1, units: o = unitsDefault$1, parseLeibnizNotation: s = parseLeibnizNotationDefault$1, parseScientificNotation: u = true } = {}) {
    this.allowSimplifiedFunctionApplication = e2, this.splitSymbols = t2, this.unsplitSymbols = r, this.appliedFunctionSymbols = n, this.functionSymbols = i2, this.operatorSymbols = a, this.units = o, this.parseLeibnizNotation = s;
    let c2 = base_text_rules;
    c2 = u ? [...number_rules_sci$1, ...c2] : [...number_rules_non_sci$1, ...c2], this.lexer = new lexer(c2);
  }
  advance(e2) {
    if (this.token = this.lexer.advance(e2), "INVALID" === this.token.token_type) throw new ParseError("Invalid symbol '" + this.token.original_text + "'", this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(e2) {
    this.lexer.set_state(e2.lexer_state), this.token = Object.assign({}, e2.token);
  }
  convert(e2) {
    this.lexer.set_input(e2), this.advance();
    var t2 = this.statement_list();
    if ("EOF" !== this.token.token_type) throw new ParseError("Invalid location of '" + this.token.original_text + "'", this.lexer.location);
    return flatten$6(t2);
  }
  statement_list() {
    for (var e2 = [this.statement()]; "," === this.token.token_type; ) this.advance(), e2.push(this.statement());
    return e2 = e2.length > 1 ? ["list"].concat(e2) : e2[0];
  }
  statement({ inside_absolute_value: e2 = 0 } = {}) {
    if ("LDOTS" === this.token.token_type) return this.advance(), ["ldots"];
    var t2;
    try {
      t2 = this.return_state();
      let r = this.statement_a({ inside_absolute_value: e2 });
      return ":" !== this.token.token_type ? r : (this.advance(), [":", r, this.statement_a()]);
    } catch (e3) {
      try {
        this.set_state(t2);
        let r = this.statement_a({ parse_absolute_value: false });
        if ("|" !== this.token.token_type) throw e3;
        return this.advance(), ["|", r, this.statement_a({ parse_absolute_value: false })];
      } catch (t22) {
        throw e3;
      }
    }
  }
  statement_a({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true } = {}) {
    for (var r = this.statement_b({ inside_absolute_value: e2, parse_absolute_value: t2 }); ["IMPLIES", "IMPLIEDBY", "IFF", "LEFTARROW", "RIGHTARROW", "LEFTRIGHTARROW"].includes(this.token.token_type); ) {
      let n = this.token.token_type.toLowerCase();
      this.advance(), r = [n, r, this.statement_b({ inside_absolute_value: e2, parse_absolute_value: t2 })];
    }
    return r;
  }
  statement_b({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true } = {}) {
    for (var r = this.statement_c({ inside_absolute_value: e2, parse_absolute_value: t2 }); "OR" === this.token.token_type; ) {
      let n = this.token.token_type.toLowerCase();
      this.advance(), r = [n, r, this.statement_c({ inside_absolute_value: e2, parse_absolute_value: t2 })];
    }
    return r;
  }
  statement_c(e2) {
    for (var t2 = this.relation(e2); "AND" === this.token.token_type; ) {
      let r = this.token.token_type.toLowerCase();
      this.advance(), t2 = [r, t2, this.relation(e2)];
    }
    return t2;
  }
  relation(e2) {
    if ("NOT" === this.token.token_type || "!" === this.token.token_type) return this.advance(), ["not", this.relation(e2)];
    if ("FORALL" === this.token.token_type || "EXISTS" === this.token.token_type) {
      let t22 = this.token.token_type.toLowerCase();
      return this.advance(), [t22, this.relation(e2)];
    }
    for (var t2 = this.expression(e2); "=" === this.token.token_type || "NE" === this.token.token_type || "<" === this.token.token_type || ">" === this.token.token_type || "LE" === this.token.token_type || "GE" === this.token.token_type || "IN" === this.token.token_type || "NOTIN" === this.token.token_type || "NI" === this.token.token_type || "NOTNI" === this.token.token_type || "SUBSET" === this.token.token_type || "NOTSUBSET" === this.token.token_type || "SUBSETEQ" === this.token.token_type || "NOTSUBSETEQ" === this.token.token_type || "SUPERSET" === this.token.token_type || "NOTSUPERSET" === this.token.token_type || "SUPERSETEQ" === this.token.token_type || "NOTSUPERSETEQ" === this.token.token_type; ) {
      let r = this.token.token_type.toLowerCase(), n = 0;
      "<" === this.token.token_type || "LE" === this.token.token_type ? n = -1 : ">" !== this.token.token_type && "GE" !== this.token.token_type || (n = 1), this.advance();
      let i2 = this.expression(e2);
      if (-1 === n) if ("<" === this.token.token_type || "LE" === this.token.token_type) {
        let n3 = ["tuple"];
        "<" === r ? n3.push(true) : n3.push(false);
        let a = ["tuple", t2, i2];
        for (; "<" === this.token.token_type || "LE" === this.token.token_type; ) "<" === this.token.token_type ? n3.push(true) : n3.push(false), this.advance(), a.push(this.expression(e2));
        t2 = ["lts", a, n3];
      } else t2 = [r, t2, i2];
      else if (1 === n) if (">" === this.token.token_type || "GE" === this.token.token_type) {
        let n3 = ["tuple"];
        ">" === r ? n3.push(true) : n3.push(false);
        let a = ["tuple", t2, i2];
        for (; ">" === this.token.token_type || "GE" === this.token.token_type; ) ">" === this.token.token_type ? n3.push(true) : n3.push(false), this.advance(), a.push(this.expression(e2));
        t2 = ["gts", a, n3];
      } else t2 = [r, t2, i2];
      else if ("=" === r) for (t2 = ["=", t2, i2]; "=" === this.token.token_type; ) this.advance(), t2.push(this.expression(e2));
      else t2 = [r, t2, i2];
    }
    return t2;
  }
  expression(e2) {
    if ("NOT" === this.token.token_type || "!" === this.token.token_type) return this.advance(), ["not", this.expression(e2)];
    let t2 = false;
    "+" === this.token.token_type && (t2 = true, this.advance());
    let r = false;
    "-" === this.token.token_type && (r = true, this.advance());
    var n = this.term(e2);
    if (r || t2) {
      if (false === n) return (t2 ? "+" : "") + (r ? "-" : "");
      if ("string" == typeof n && [...n].every(((e3) => ["+", "-"].includes(e3)))) return (t2 ? "+" : "") + (r ? "-" : "") + n;
    }
    for (false === n && (n = "＿"), r && (n = n > 0 ? -n : ["-", n]), t2 && (n = ["+", n]); ["+", "-", "UNION", "INTERSECT", "PERP", "PARALLEL"].includes(this.token.token_type); ) {
      let t22 = this.token.token_type.toLowerCase(), r2 = false, i2 = false;
      "-" === this.token.token_type ? (t22 = "+", r2 = true, this.advance()) : (this.advance(), "+" === t22 && "-" === this.token.token_type && (r2 = true, i2 = true, this.advance()));
      let a = this.term(e2);
      if ("+" === t22) {
        if (false === a && ("number" == typeof n || "string" == typeof n)) return i2 ? n + "+-" : r2 ? n + "-" : n + "+";
        if ("string" == typeof a && [...a].every(((e3) => ["+", "-"].includes(e3))) && ("number" == typeof n || "string" == typeof n)) return i2 ? n + "+-" + a : r2 ? n + "-" + a : n + "+" + a;
      }
      false === a && (a = "＿"), r2 && (a = a > 0 ? -a : ["-", a]), n = [t22, n, a];
    }
    return n;
  }
  term(e2) {
    var t2 = this.factor(e2), r = false;
    do {
      if (r = false, "*" === this.token.token_type) {
        this.advance(), false === t2 && (t2 = "＿");
        let n = this.factor(e2);
        false === n && (n = "＿"), t2 = ["*", t2, n], r = true;
      } else if ("/" === this.token.token_type) {
        this.advance(), false === t2 && (t2 = "＿");
        let n = this.factor(e2);
        false === n && (n = "＿"), t2 = ["/", t2, n], r = true;
      } else {
        let n = Object.assign({}, e2);
        n.allow_absolute_value_closing = true;
        let i2 = this.nonMinusFactor(n);
        false !== i2 && (false === t2 && (t2 = "＿"), t2 = ["*", t2, i2], r = true);
      }
    } while (r);
    return this.convert_units_in_term(flatten$6(t2));
  }
  convert_units_in_term(e2) {
    if (!Array.isArray(e2)) return e2;
    let t2 = e2[0], r = e2.slice(1);
    if ("*" === t2) {
      let t22 = r.length;
      for (let [e3, n] of r.entries()) {
        let i2 = this.units[n];
        if (i2) {
          if (i2.prefix && e3 < t22 - 1) {
            let a;
            a = e3 === t22 - 2 ? r[t22 - 1] : this.convert_units_in_term(["*", ...r.slice(e3 + 1)]);
            let o = n;
            i2.substitute && (o = i2.substitute);
            let s = ["unit", o, a];
            return 0 === e3 ? s : ["*", ...r.slice(0, e3), s];
          }
          if (!i2.prefix && e3 > 0) {
            let a, o = n;
            return i2.substitute && (o = i2.substitute), a = 1 === e3 ? ["unit", r[0], o] : ["unit", ["*", ...r.slice(0, e3)], o], e3 === t22 - 1 ? a : this.convert_units_in_term(["*", a, ...r.slice(e3 + 1)]);
          }
        }
      }
      return e2;
    }
    return "/" === t2 ? ["/", this.convert_units_in_term(r[0]), this.convert_units_in_term(r[1])] : e2;
  }
  factor(e2) {
    if ("+" === this.token.token_text) {
      this.advance();
      let t22 = this.factor(e2);
      return false === t22 ? "+" : "string" == typeof t22 && [...t22].every(((e3) => ["+", "-"].includes(e3))) ? "+" + t22 : ["+", t22];
    }
    if ("-" === this.token.token_type) {
      this.advance();
      let t22 = this.factor(e2);
      return t22 > 0 ? -t22 : false === t22 ? "-" : "string" == typeof t22 && [...t22].every(((e3) => ["+", "-"].includes(e3))) ? "-" + t22 : ["-", t22];
    }
    let t2 = this.nonMinusFactor(e2);
    return false === t2 && "PERP" === this.token.token_type && (t2 = "perp", this.advance()), t2;
  }
  nonMinusFactor(e2) {
    for (var t2 = this.baseFactor(e2); "^" === this.token.token_type || "!" === this.token.token_type || "'" === this.token.token_type; ) if (false === t2 && (t2 = "＿"), "^" === this.token.token_type) {
      this.advance(), t2 = ["^", t2, this.get_subsuperscript(e2)];
    } else "!" === this.token.token_type ? (t2 = ["apply", "factorial", t2], this.advance()) : (t2 = ["prime", t2], this.advance());
    return t2;
  }
  get_subsuperscript({ parse_absolute_value: e2 }) {
    if (["+", "-", "PERP"].includes(this.token.token_type)) {
      let e3 = this.token.token_type.toLowerCase();
      return this.advance(), e3;
    }
    {
      let t2 = this.baseFactor({ parse_absolute_value: e2, in_subsuperscript_with_no_delimiters: true });
      return false === t2 && (t2 = "＿"), t2;
    }
  }
  baseFactor({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true, allow_absolute_value_closing: r = false, in_subsuperscript_with_no_delimiters: n = false } = {}) {
    var i2 = false;
    if ("NUMBER" === this.token.token_type) i2 = parseFloat(this.token.token_text), this.advance();
    else if ("INFINITY" === this.token.token_type) i2 = 1 / 0, this.advance();
    else if ("VAR" === this.token.token_type || "VARMULTICHAR" === this.token.token_type) {
      if (i2 = this.token.token_text, this.appliedFunctionSymbols.includes(i2) || this.functionSymbols.includes(i2)) {
        let e3 = false;
        if (this.appliedFunctionSymbols.includes(i2) && (e3 = true), this.advance(), "_" === this.token.token_type) {
          this.advance();
          let e4 = this.get_subsuperscript({ parse_absolute_value: t2 });
          i2 = "log" === i2 && 10 === e4 ? "log10" : ["_", i2, e4];
        }
        if (n) e3 && (i2 = ["apply", i2, "＿"]);
        else {
          for (; "'" === this.token.token_type; ) i2 = ["prime", i2], this.advance();
          for (; "^" === this.token.token_type; ) {
            this.advance(), i2 = ["^", i2, this.get_subsuperscript({ parse_absolute_value: t2 })];
          }
          if ("(" === this.token.token_type) {
            this.advance();
            let e4 = this.statement_list();
            if (")" !== this.token.token_type) throw new ParseError("Expecting )", this.lexer.location);
            this.advance(), "list" === e4[0] && (e4[0] = "tuple"), i2 = ["apply", i2, e4];
          } else if (e3) {
            if (!this.allowSimplifiedFunctionApplication) throw new ParseError("Expecting ( after function", this.lexer.location);
            let e4 = this.factor({ parse_absolute_value: t2 });
            false === e4 && (e4 = "＿"), i2 = ["apply", i2, e4];
          }
        }
        return i2;
      }
      if (this.operatorSymbols.includes(i2)) if (this.advance(), "(" === this.token.token_type) {
        this.advance();
        let e3 = this.statement_list();
        if (")" !== this.token.token_type) throw new ParseError("Expecting )", this.lexer.location);
        this.advance(), i2 = "list" === e3[0] ? [i2, ...e3.slice(1)] : [i2, e3];
      } else {
        let e3 = this.factor({ parse_absolute_value: t2 });
        false === e3 && (e3 = "＿"), i2 = [i2, e3];
      }
      else {
        if (this.parseLeibnizNotation) {
          let e3 = this.return_state(), t22 = this.leibniz_notation();
          if (t22) return t22;
          this.set_state(e3);
        }
        let n3 = this.splitSymbols;
        if (n3 && ("VARMULTICHAR" === this.token.token_type || this.unsplitSymbols.includes(i2) || 1 === i2.length || i2.match(/[\d]/g)) && (n3 = false), n3) {
          for (let e3 = i2.length - 1; e3 >= 0; e3--) this.lexer.unput(" "), this.lexer.unput(i2[e3]);
          return this.advance(), this.baseFactor({ inside_absolute_value: e2, parse_absolute_value: t2, allow_absolute_value_closing: r });
        }
        this.advance();
      }
    } else if ("(" === this.token.token_type || "[" === this.token.token_type || "{" === this.token.token_type || "LANGLE" === this.token.token_type) {
      let e3, t22, r2 = this.token.token_type;
      "(" === this.token.token_type ? (e3 = ")", t22 = "]") : "[" === this.token.token_type ? (e3 = "]", t22 = ")") : "{" === this.token.token_type ? (e3 = "}", t22 = null) : (e3 = "RANGLE", t22 = null), this.advance();
      let n3 = 1;
      if ("list" === (i2 = this.statement_list())[0] && (n3 = i2.length - 1), this.token.token_type !== e3) {
        if (2 !== n3 || null === t22) throw new ParseError("Expecting " + e3, this.lexer.location);
        if (this.token.token_type !== t22) throw new ParseError("Expecting ) or ]", this.lexer.location);
        let a;
        i2[0] = "tuple", a = "(" === r2 ? ["tuple", false, true] : ["tuple", true, false], (i2 = ["interval", i2]).push(a);
      } else n3 >= 2 ? i2[0] = "(" === r2 ? "tuple" : "[" === r2 ? "array" : "{" === r2 ? "set" : "altvector" : "{" === r2 && (i2 = ("|" === i2[0] || i2[0], ["set", i2]));
      this.advance();
    } else if ("|" !== this.token.token_type || !t2 || 0 !== e2 && r) {
      if ("ANGLE" === this.token.token_type) if (this.advance(), "(" === this.token.token_type) {
        this.advance();
        let e3 = this.statement_list();
        if (")" !== this.token.token_type) throw new ParseError("Expecting )", this.lexer.location);
        this.advance(), "list" === e3[0] ? i2 = ["angle", ...e3.slice(1)] : "*" === e3[0] && (i2 = ["angle", e3]);
      } else {
        let e3 = [], r2 = this.nonMinusFactor({ parse_absolute_value: t2 });
        for (; false !== r2; ) e3.push(r2), r2 = this.nonMinusFactor({ parse_absolute_value: t2 });
        i2 = 0 === e3.length ? "angle" : ["angle", ...e3];
      }
      else if ("INT" === this.token.token_type) {
        this.advance();
        let e3 = "int";
        if ("_" === this.token.token_type) {
          this.advance(), e3 = ["_", e3, this.get_subsuperscript({ parse_absolute_value: t2 })];
        }
        if ("^" === this.token.token_type) {
          this.advance(), e3 = ["^", e3, this.get_subsuperscript({ parse_absolute_value: t2 })];
        }
        let r2 = flatten$6(this.term({ parse_absolute_value: t2 }));
        if (Array.isArray(r2) && "*" === r2[0]) {
          let e4 = [];
          for (let t22 = 0; t22 < r2.length - 1; t22++) {
            if ("d" === r2[t22]) {
              let n3 = r2[t22 + 1];
              r2.splice(t22, 2), e4.push(["d", n3]), t22--;
            }
          }
          r2.push(...e4);
        }
        return ["apply", e3, r2];
      }
    } else {
      if (e2 += 1, this.advance(), i2 = ["apply", "abs", i2 = this.statement({ inside_absolute_value: e2 })], "|" !== this.token.token_type) throw new ParseError("Expecting |", this.lexer.location);
      this.advance();
    }
    if ("_" === this.token.token_type) {
      false === i2 && (i2 = "＿"), this.advance(), i2 = ["_", i2, this.get_subsuperscript({ parse_absolute_value: t2 })];
    }
    return i2;
  }
  leibniz_notation() {
    var e2 = this.token.token_text;
    if ("VAR" !== this.token.token_type || "d" !== e2[0] && "∂" !== e2[0] || !(1 === e2.length || 2 === e2.length && /[a-zA-Z]/.exec(e2[1]))) return false;
    let t2 = e2[0], r = 1, n = "", i2 = [], a = [];
    if (2 === e2.length) n = e2[1];
    else if (this.advance(), "VARMULTICHAR" === this.token.token_type || "VAR" === this.token.token_type && !this.token.token_text.includes("∂")) n = this.token.token_text;
    else {
      if ("^" !== this.token.token_type) return false;
      if (this.advance(), "NUMBER" !== this.token.token_type) return false;
      if (r = parseFloat(this.token.token_text), !Number.isInteger(r)) return false;
      if (this.advance(), ("VAR" !== this.token.token_type || this.token.token_text.includes("∂")) && "VARMULTICHAR" !== this.token.token_type) return false;
      n = this.token.token_text;
    }
    if (this.advance(), "/" !== this.token.token_type) return false;
    let o = 0;
    for (this.advance(); ; ) {
      if ("VAR" !== this.token.token_type || this.token.token_text[0] !== t2) return false;
      this.token.token_text.length > 2 && (this.lexer.unput(this.token.token_text.slice(2)), this.token.token_text = this.token.token_text.slice(0, 2));
      let s = this.token.token_text;
      if (2 === s.length) {
        if (!/[a-zA-Z]/.exec(s[1])) return false;
        i2.push(s[1]);
      } else {
        if (this.advance(), ("VAR" !== this.token.token_type || this.token.token_text.includes("∂")) && "VARMULTICHAR" !== this.token.token_type) return false;
        i2.push(this.token.token_text);
      }
      let u = 1, c2 = false;
      if (this.advance({ remove_initial_space: false }), "SPACE" === this.token.token_type && (c2 = true, this.advance()), "^" === this.token.token_type) {
        if (this.advance(), "NUMBER" !== this.token.token_type) return false;
        if (u = parseFloat(this.token.token_text), !Number.isInteger(u)) return false;
        c2 = false, this.advance({ remove_initial_space: false }), "SPACE" === this.token.token_type && (c2 = true, this.advance());
      }
      if (a.push(u), o += u, o > r) return false;
      if (o === r) {
        if (!c2 && ("VAR" === this.token.token_type || "VARMULTICHAR" === this.token.token_type)) return false;
        "SPACE" === this.token.token_type && this.advance();
        let o2 = "derivative_leibniz";
        "∂" === t2 && (o2 = "partial_" + o2), e2 = [o2], 1 === r ? e2.push(n) : e2.push(["tuple", n, r]);
        let s2 = [];
        for (let e3 = 0; e3 < i2.length; e3 += 1) 1 === a[e3] ? s2.push(i2[e3]) : s2.push(["tuple", i2[e3], a[e3]]);
        return s2 = ["tuple"].concat(s2), e2.push(s2), e2;
      }
    }
  }
}
var textToAst$3 = new textToAst$4();
function expand(e2, t2) {
  var r = get_tree(e2);
  r = perform_vector_matrix_additions_scalar_multiplications(r = perform_matrix_multiplications(r));
  const n = (e3) => !Array.isArray(e3) || !["d", "*"].includes(e3[0]) || "*" === e3[0] && e3.slice(1).every(((e4) => !Array.isArray(e4) || "d" !== e4[0]));
  var i2 = [];
  return i2.push([textToAst$3.convert("a*(b+c)"), textToAst$3.convert("a*b+a*c"), ["^", "x", ["+", "n", "m"]], { variables: { a: n, b: true, c: true }, allow_extended_match: true }]), i2.push([textToAst$3.convert("(a+b)*c"), textToAst$3.convert("a*c+b*c"), { variables: { a: true, b: true, c: n }, allow_extended_match: true }]), t2 || i2.push([textToAst$3.convert("(a+b)/c"), textToAst$3.convert("a/c+b/c")]), i2.push([textToAst$3.convert("-(a+b)"), textToAst$3.convert("-a-b")]), i2.push([textToAst$3.convert("a(-b)"), textToAst$3.convert("-ab")]), i2.push([textToAst$3.convert("(a+b)^2"), textToAst$3.convert("a^2+2ab+b^2")]), i2.push([textToAst$3.convert("(a+b)^3"), textToAst$3.convert("a^3+3a^2b+3ab^2+b^3")]), i2.push([textToAst$3.convert("(a+b)^4"), textToAst$3.convert("a^4+4a^3b+6a^2b^2+4ab^3+b^4")]), i2.push([textToAst$3.convert("a*(b+c)*d"), textToAst$3.convert("(a*b+a*c)*d")]), r = normalize_negatives(r = collect_like_terms_factors(r = evaluate_numbers(r = flatten$5(r = applyAllTransformations(r, i2, 20)))));
}
function perform_matrix_multiplications(e2, t2 = true, r = true) {
  var n = get_tree(e2);
  function i2(e3, t22) {
    let r2 = e3[1][1], n3 = e3[1][2], i22 = t22[1][2];
    if (t22[1][1] !== n3) return { success: false };
    let a2 = e3[2], o2 = t22[2], s = ["tuple"];
    for (let e4 = 0; e4 < r2; e4++) {
      let t3 = a2[e4 + 1].slice(1), r3 = ["tuple"];
      for (let e5 = 0; e5 < i22; e5++) {
        let i3 = o2.slice(1).map(((t4) => t4[e5 + 1]));
        if (t3.length !== n3 || i3.length !== n3) return subtree;
        let a3 = ["+", ...t3.map(((e6, t4) => ["*", e6, i3[t4]]))];
        r3.push(a3);
      }
      s.push(r3);
    }
    return { success: true, newMatrix: ["matrix", ["tuple", r2, i22], s] };
  }
  function a(e3, t22) {
    if (!Number.isInteger(t22) || t22 < 1) return { success: false };
    if (1 === t22) return { success: true, newMatrix: e3 };
    let r2 = e3[1][1];
    if (e3[1][2] !== r2) return { success: false };
    let n3 = e3[2], i22 = JSON.parse(JSON.stringify(n3));
    for (let e4 = 1; e4 < t22; e4++) {
      const e5 = i22;
      i22 = ["tuple"];
      for (let t3 = 0; t3 < r2; t3++) {
        let a2 = e5[t3 + 1].slice(1), o2 = ["tuple"];
        for (let e6 = 0; e6 < r2; e6++) {
          let t4 = n3.slice(1).map(((t5) => t5[e6 + 1]));
          if (a2.length !== r2 || t4.length !== r2) return subtree;
          let i3 = ["+", ...a2.map(((e7, r3) => ["*", e7, t4[r3]]))];
          o2.push(i3);
        }
        i22.push(o2);
      }
    }
    return { success: true, newMatrix: ["matrix", ["tuple", r2, r2], i22] };
  }
  function o(e3, t22) {
    let r2 = e3[1][1], n3 = e3[1][2], i22 = e3[2], a2 = ["tuple"];
    for (let e4 = 0; e4 < r2; e4++) {
      let r3 = ["tuple"], o2 = i22[e4 + 1];
      for (let e5 = 0; e5 < n3; e5++) r3.push(["*", t22, o2[e5 + 1]]);
      a2.push(r3);
    }
    return ["matrix", ["tuple", r2, n3], a2];
  }
  return (function() {
    let e3 = ["^", ["matrix", "size", "matrixData"], "p"], t22 = { variables: { p: (e4) => Number.isInteger(e4) && e4 > 0, size: true, matrixData: true } };
    n = transform(n, (function(r2) {
      let n3 = match$2(r2, e3, t22);
      if (n3) {
        let e4 = a(["matrix", n3.size, n3.matrixData], n3.p);
        return e4.success ? e4.newMatrix : r2;
      }
      return r2;
    }));
  })(), (function() {
    let e3 = ["*", "a", ["matrix", "size", "matrixData"], "b"], t22 = { variables: { a: true, b: true, size: true, matrixData: true }, allow_implicit_identities: ["a", "b"] };
    n = transform(n, (function(r2) {
      let n3 = match$2(r2, e3, t22);
      if (n3) {
        let e4 = ["matrix", n3.size, n3.matrixData], t3 = [], r3 = [];
        Array.isArray(n3.a) && "*" === n3.a[0] ? t3.push(...n3.a.slice(1)) : t3.push(n3.a), Array.isArray(n3.b) && "*" === n3.b[0] ? r3.push(...n3.b.slice(1)) : r3.push(n3.b);
        for (let r4 = t3.length - 1; r4 >= 0; r4--) {
          let n4 = t3[r4][0];
          if ("matrix" === n4) {
            let n5 = i2(t3[r4], e4);
            if (!n5.success) break;
            e4 = n5.newMatrix, t3.pop();
          } else {
            if (["tuple", "list", "vector", "altvector", "interval", "set", "array"].includes(n4)) break;
            1 !== t3[r4] && (e4 = o(e4, t3[r4])), t3.pop();
          }
        }
        for (; r3.length > 0; ) {
          let t4 = r3[0][0];
          if ("matrix" === t4) {
            let t5 = i2(e4, r3[0]);
            if (!t5.success) break;
            e4 = t5.newMatrix, r3.splice(0, 1);
          } else {
            if (["tuple", "list", "vector", "altvector", "interval", "set", "array"].includes(t4)) break;
            1 !== r3[0] && (e4 = o(e4, r3[0])), r3.splice(0, 1);
          }
        }
        return t3.length > 0 || r3.length > 0 ? ["*", ...t3, e4, ...r3] : e4;
      }
      return r2;
    }));
  })(), (t2 || r) && (function() {
    let e3 = ["*", ["matrix", ["tuple", "m", "n"], "matrixData"], "b"], i22 = { variables: { n: Number.isInteger, m: Number.isInteger, matrixData: true, b: true } };
    n = transform(n, (function(n3) {
      let a2 = match$2(n3, e3, i22);
      if (a2) {
        let e4, i3 = a2.m, o2 = a2.n, s = a2.b, u = a2.matrixData, c2 = [];
        t2 && (c2.push("vector"), c2.push("altvector")), r && c2.push("tuple");
        let l = [];
        if (c2.includes(s[0])) e4 = s;
        else {
          if (!Array.isArray(s) || "*" !== s[0] || !c2.includes(s[1][0])) return n3;
          e4 = s[1], l = s.slice(2);
        }
        let f2 = e4.slice(1);
        if (f2.length !== o2) return n3;
        let p = [e4[0]];
        for (let e5 = 0; e5 < i3; e5++) {
          let t22 = ["+", ...u[e5 + 1].slice(1).map(((e6, t3) => ["*", e6, f2[t3]]))];
          p.push(t22);
        }
        return l.length > 0 ? ["*", p, ...l] : p;
      }
      return n3;
    }));
  })(), n;
}
function perform_vector_scalar_multiplications(e2, t2 = true) {
  var r = get_tree(e2);
  let n = function(e3, t22) {
    let r2 = ["*", "a", [t22, "vectorData"], "b"], n3 = { allow_implicit_identities: ["a", "b"] };
    return e3 = transform(e3, (function(e4) {
      let i2 = match$2(e4, r2, n3);
      if (i2) {
        if (1 === i2.a && 1 === i2.b) return e4;
        let r3 = i2.vectorData;
        r3 = Array.isArray(r3) && r3[0] === t22 ? r3.slice(1) : [r3];
        let n4 = [], a = [];
        Array.isArray(i2.a) && "*" === i2.a[0] ? n4.push(...i2.a.slice(1)) : n4.push(i2.a), Array.isArray(i2.b) && "*" === i2.b[0] ? a.push(...i2.b.slice(1)) : a.push(i2.b);
        for (let e5 = n4.length - 1; e5 >= 0; e5--) {
          let t3 = n4[e5][0];
          if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(t3)) break;
          1 !== n4[e5] && (r3 = r3.map(((t4) => ["*", t4, n4[e5]]))), n4.pop();
        }
        for (; a.length > 0; ) {
          let e5 = a[0][0];
          if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(e5)) break;
          1 !== a[0] && (r3 = r3.map(((e6) => ["*", e6, a[0]]))), a.splice(0, 1);
        }
        let o = [t22, ...r3];
        return n4.length > 0 || a.length > 0 ? ["*", ...n4, o, ...a] : o;
      }
      return e4;
    }));
  };
  return r = n(r, "vector"), r = n(r, "altvector"), t2 && (r = n(r, "tuple")), r;
}
function perform_matrix_scalar_multiplications(e2) {
  var t2 = get_tree(e2);
  let r = ["*", "a", ["matrix", "size", "matrixData"], "b"], n = { allow_implicit_identities: ["a", "b"] };
  return t2 = transform(t2, (function(e3) {
    let t22 = match$2(e3, r, n);
    if (t22) {
      if (1 === t22.a && 1 === t22.b) return e3;
      let r2 = t22.matrixData, n3 = [], i2 = [];
      Array.isArray(t22.a) && "*" === t22.a[0] ? n3.push(...t22.a.slice(1)) : n3.push(t22.a), Array.isArray(t22.b) && "*" === t22.b[0] ? i2.push(...t22.b.slice(1)) : i2.push(t22.b);
      for (let e4 = n3.length - 1; e4 >= 0; e4--) {
        let t3 = n3[e4][0];
        if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(t3)) break;
        1 !== n3[e4] && (r2 = r2.map(((t4) => "tuple" === t4 ? t4 : t4.map(((t5) => "tuple" === t5 ? t5 : ["*", t5, n3[e4]]))))), n3.pop();
      }
      for (; i2.length > 0; ) {
        let e4 = i2[0][0];
        if (["tuple", "list", "vector", "altvector", "interval", "set", "array", "matrix"].includes(e4)) break;
        1 !== i2[0] && (r2 = r2.map(((e5) => "tuple" === e5 ? e5 : e5.map(((e6) => "tuple" === e6 ? e6 : ["*", e6, i2[0]]))))), i2.splice(0, 1);
      }
      let a = ["matrix", t22.size, r2];
      return n3.length > 0 || i2.length > 0 ? ["*", ...n3, a, ...i2] : a;
    }
    return e3;
  }));
}
function expand_relations(e2) {
  var t2 = get_tree(e2);
  return transform(t2, expand_relations_transform);
}
function expand_relations_transform(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if ("=" === t2) {
    if (r.length <= 2) return e2;
    let t22 = ["and"];
    for (let e3 = 0; e3 < r.length - 1; e3++) t22.push(["=", r[e3], r[e3 + 1]]);
    return t22;
  }
  if ("gts" === t2 || "lts" === t2) {
    let e3 = r[0], n = r[1];
    if ("tuple" !== e3[0] || "tuple" !== n[0]) throw new Error("Badly formed ast");
    let i2 = [];
    for (let r2 = 1; r2 < e3.length - 1; r2++) {
      let a2;
      a2 = n[r2] ? "lts" === t2 ? "<" : ">" : "lts" === t2 ? "le" : "ge", i2.push([a2, e3[r2], e3[r2 + 1]]);
    }
    let a = ["and", i2[0], i2[1]];
    for (let e4 = 2; e4 < i2.length; e4++) a = ["and", a, i2[e4]];
    return a;
  }
  if ("in" === t2 || "notin" === t2 || "ni" === t2 || "notni" === t2) {
    let n, i2, a = false;
    if ("notin" !== t2 && "notni" !== t2 || (a = true), "in" === t2 || "notin" === t2 ? (n = r[0], i2 = r[1]) : (n = r[1], i2 = r[0]), i2 = to_intervals(i2), "interval" !== i2[0]) return e2;
    let o = i2[1], s = i2[2];
    if ("tuple" !== o[0] || "tuple" !== s[0]) throw new Error("Badly formed ast");
    let u, c2 = o[1], l = o[2], f2 = [];
    return s[1] ? a ? f2.push(["<", n, c2]) : f2.push(["ge", n, c2]) : a ? f2.push(["le", n, c2]) : f2.push([">", n, c2]), s[2] ? a ? f2.push([">", n, l]) : f2.push(["le", n, l]) : a ? f2.push(["ge", n, l]) : f2.push(["<", n, l]), u = a ? ["or"].concat(f2) : ["and"].concat(f2), u;
  }
  if ("subset" === t2 || "notsubset" === t2 || "superset" === t2 || "notsuperset" === t2) {
    let n, i2, a = false;
    if ("notsubset" !== t2 && "notsuperset" !== t2 || (a = true), "subset" === t2 || "notsubset" === t2 ? (n = r[0], i2 = r[1]) : (n = r[1], i2 = r[0]), n = to_intervals(n), i2 = to_intervals(i2), "interval" !== n[0] || "interval" !== i2[0]) return e2;
    let o = n[1], s = n[2], u = i2[1], c2 = i2[2];
    if ("tuple" !== o[0] || "tuple" !== s[0] || "tuple" !== u[0] || "tuple" !== c2[0]) throw new Error("Badly formed ast");
    let l, f2 = o[1], p = o[2], m = u[1], d = u[2], h = [];
    return s[1] && !c2[1] ? a ? h.push(["le", f2, m]) : h.push([">", f2, m]) : a ? h.push(["<", f2, m]) : h.push(["ge", f2, m]), s[2] && !c2[2] ? a ? h.push(["ge", p, d]) : h.push(["<", p, d]) : a ? h.push([">", p, d]) : h.push(["le", p, d]), l = a ? ["or"].concat(h) : ["and"].concat(h), l;
  }
  return e2;
}
function substitute(e2, t2) {
  var r = get_tree(e2), n = {};
  for (let e3 in t2) n[e3] = get_tree(t2[e3]);
  return substitute$1(r, n);
}
function substitute_component(e2, t2, r) {
  let n = get_tree(e2);
  if (get_tree(r), "number" == typeof t2) t2 = [t2];
  else if (!Array.isArray(t2)) throw Error("Invalid substitute_component: " + t2);
  let i2 = ["list", "tuple", "vector", "altvector", "array"];
  return (function e3(t22, n3, a) {
    if (0 === n3.length) return r;
    if (!Array.isArray(t22)) throw Error("Invalid substitute_component: expected list, tuple, vector, or array");
    let o = t22[0], s = t22.slice(1);
    if (!i2.includes(o)) throw Error("Invalid substitute_component: expected list, tuple, vector, or array");
    let u = n3[0];
    if (u < 0 || u > s.length - 1) throw Error("Invalid substitute_component: component out of range");
    let c2 = n3.slice(1), l = e3(s[u], c2);
    return [o, ...s.slice(0, u), l, ...s.slice(u + 1)];
  })(n, t2);
}
function get_component(e2, t2) {
  let r = get_tree(e2);
  if ("number" == typeof t2) t2 = [t2];
  else if (!Array.isArray(t2)) throw Error("Invalid get_component: " + t2);
  let n = ["list", "tuple", "vector", "altvector", "array"];
  return (function e3(t22, r2) {
    if (0 === r2.length) return t22;
    if (!Array.isArray(t22)) throw Error("Invalid get_component: expected list, tuple, vector, or array");
    let i2 = t22[0], a = t22.slice(1);
    if (!n.includes(i2)) throw Error("Invalid get_component: expected list, tuple, vector, or array");
    let o = r2[0];
    if (o < 0 || o > a.length - 1) throw Error("Invalid get_component: component out of range");
    let s = r2.slice(1);
    return e3(a[o], s);
  })(r, t2);
}
var transformation = Object.freeze({ __proto__: null, expand, expand_relations, substitute, substitute_component, get_component, perform_vector_scalar_multiplications, perform_matrix_scalar_multiplications, perform_matrix_multiplications });
function clean(e2) {
  return flatten$5(get_tree(e2));
}
function evalf(e2, t2) {
  return parseFloat(math$1.format(e2, { notation: "exponential", precision: t2 }));
}
function collapse_unary_minus(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  var r = t2[0], n = t2.slice(1);
  if (n = n.map(((e3) => collapse_unary_minus(e3))), "-" === r) {
    if ("number" == typeof n[0]) return -n[0];
    if (Array.isArray(n[0]) && "*" === n[0][0] && "number" == typeof n[0][1]) return ["*", -n[0][1]].concat(n[0].slice(2));
    if (Array.isArray(n[0]) && "/" === n[0][0]) {
      if ("number" == typeof n[0][1]) return ["/", -n[0][1], n[0][2]];
      if (Array.isArray(n[0][1]) && "*" === n[0][1][0] && "number" == typeof n[0][1][1]) return ["/", ["*", -n[0][1][1]].concat(n[0][1].slice(2)), n[0][2]];
    }
  }
  return [r].concat(n);
}
function simplify(e2, t2, r) {
  var n = get_tree(e2);
  return contains_blank(n) ? n : (void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), n = evaluate_numbers(n, { assumptions: t2, max_digits: r, evaluate_functions: true }), Array.isArray(n) ? n = collect_like_terms_factors(n = simplify_integer_square_roots(n = perform_vector_matrix_additions_scalar_multiplications(n = simplify_logical(n, t2))), t2, r) : n);
}
function simplify_logical(e2, t2) {
  var r = get_tree(e2);
  if (contains_blank(r)) return r;
  void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), r = evaluate_numbers(r, { assumptions: t2 }), r = unflattenRight(r);
  var n = [];
  return n.push([["not", ["not", "a"]], "a"]), n.push([["not", ["and", "a", "b"]], ["or", ["not", "a"], ["not", "b"]]]), n.push([["not", ["or", "a", "b"]], ["and", ["not", "a"], ["not", "b"]]]), n.push([["not", ["=", "a", "b"]], ["ne", "a", "b"]]), n.push([["not", ["ne", "a", "b"]], ["=", "a", "b"]]), n.push([["not", ["<", "a", "b"]], ["le", "b", "a"]]), n.push([["not", ["le", "a", "b"]], ["not", ["le", "a", "b"]]]), n.push([["not", ["in", "a", "b"]], ["notin", "a", "b"]]), n.push([["not", ["subset", "a", "b"]], ["notsubset", "a", "b"]]), r = flatten$5(r = applyAllTransformations(r, n, 20));
}
function simplify_integer_square_roots(e2) {
  if (!Array.isArray(e2)) return e2;
  var t2 = e2[0], r = e2.slice(1);
  if ("apply" === t2 && "sqrt" === r[0] && Number.isInteger(r[1])) {
    let t22 = r[1], n = 1, i2 = 2, a = 4;
    for (; a <= Math.abs(t22); ) t22 % a == 0 ? (t22 /= a, n *= i2) : (i2++, a = i2 * i2);
    return n > 1 ? ["*", n, ["apply", "sqrt", t22]] : e2;
  }
  return [t2, ...r.map(simplify_integer_square_roots)];
}
function perform_vector_matrix_additions_scalar_multiplications(e2, t2 = true) {
  var r = get_tree(e2);
  r = perform_vector_scalar_multiplications(r = perform_matrix_scalar_multiplications(r), t2);
  let n = ["+", "a", "b"];
  return r = transform(r, (function(e3) {
    let r2 = match$2(e3, n, { allow_permutations: true });
    if (r2) {
      let n3 = ["vector", "altvector"];
      t2 && n3.push("tuple");
      let i2 = {}, a = {}, o = [];
      if (n3.includes(r2.a[0])) {
        let e4 = r2.a.length - 1;
        i2[e4] || (i2[e4] = []), i2[e4].push(r2.a);
      } else if ("matrix" === r2.a[0]) {
        let e4 = r2.a[1].slice(1).toString();
        a[e4] || (a[e4] = []), a[e4].push(r2.a);
      } else o.push(r2.a);
      if (n3.includes(r2.b[0])) {
        let e4 = r2.b.length - 1;
        i2[e4] || (i2[e4] = []), i2[e4].push(r2.b);
      } else if ("matrix" === r2.b[0]) {
        let e4 = r2.b[1].slice(1).toString();
        a[e4] || (a[e4] = []), a[e4].push(r2.b);
      } else if ("+" === r2.b[0]) for (let e4 of r2.b.slice(1)) if (n3.includes(e4[0])) {
        let t22 = e4.length - 1;
        i2[t22] || (i2[t22] = []), i2[t22].push(e4);
      } else if ("matrix" === e4[0]) {
        let t22 = e4[1].slice(1).toString();
        a[t22] || (a[t22] = []), a[t22].push(e4);
      } else o.push(e4);
      else o.push(r2.b);
      if (Object.values(i2).every(((e4) => e4.length < 2)) && Object.values(a).every(((e4) => e4.length < 2))) return e3;
      let s = o;
      for (let e4 in i2) if (i2[e4].length < 2) s.push(...i2[e4]);
      else {
        let t22, r3 = i2[e4].some(((e5) => "vector" === e5[0])), n4 = i2[e4].some(((e5) => "tuple" === e5[0])), a2 = i2[e4].some(((e5) => "altvector" === e5[0]));
        t22 = r3 || n4 && a2 ? ["vector"] : a2 ? ["altvector"] : ["tuple"];
        for (let r4 = 0; r4 < e4; r4++) t22.push(["+", ...i2[e4].map(((e5) => e5[r4 + 1]))]);
        s.push(t22);
      }
      for (let e4 in a) if (a[e4].length < 2) s.push(...a[e4]);
      else {
        let [t22, r3] = e4.split(",").map(Number), n4 = ["tuple"];
        for (let i3 = 0; i3 < t22; i3++) {
          let t3 = ["tuple"];
          for (let n5 = 0; n5 < r3; n5++) t3.push(["+", ...a[e4].map(((e5) => e5[2][i3 + 1][n5 + 1]))]);
          n4.push(t3);
        }
        let i22 = ["matrix", ["tuple", t22, r3], n4];
        s.push(i22);
      }
      return 1 === s.length ? s[0] : ["+", ...s];
    }
    return e3;
  })), r;
}
function contains_decimal_number(e2) {
  return "string" != typeof e2 && ("number" == typeof e2 ? !(!Number.isFinite(e2) || Number.isInteger(e2)) : !!Array.isArray(e2) && e2.slice(1).some(((e3) => contains_decimal_number(e3))));
}
function contains_only_numbers(e2, { include_number_symbols: t2 = false, evaluate_functions: r = false } = {}) {
  if ("string" == typeof e2) {
    if (t2) {
      if ("e" === e2 && math$1.define_e) return true;
      if ("pi" === e2 && math$1.define_pi) return true;
    }
    return !("i" !== e2 || !math$1.define_i);
  }
  return "number" == typeof e2 || !!Array.isArray(e2) && (r && "apply" === e2[0] ? e2.slice(2).every(((e3) => contains_only_numbers(e3, { include_number_symbols: t2 }))) : e2.slice(1).every(((e3) => contains_only_numbers(e3, { include_number_symbols: t2 }))));
}
function try_evaluate_sum_of_numbers(e2, t2, r) {
  if ("number" == typeof e2) {
    if (0 === e2) return t2;
    if ("number" == typeof t2) return e2 + t2;
    if (Array.isArray(t2) && "+" === t2[0] && "number" == typeof t2[1]) return ["+", e2 + t2[1], t2[2]];
    if (!r && Array.isArray(t2) && "+" === t2[0] && "number" == typeof t2[2]) return ["+", e2 + t2[2], t2[1]];
  }
  return "number" == typeof t2 && 0 === t2 ? e2 : null;
}
function try_evaluate_negate_number(e2) {
  if ("number" == typeof e2) return -e2;
  if (Array.isArray(e2) && "*" === e2[0] && "number" == typeof e2[1]) return ["*", -e2[1]].concat(e2.slice(2));
  if (Array.isArray(e2) && "/" === e2[0]) {
    if ("number" == typeof e2[1]) return ["/", -e2[1], e2[2]];
    if (Array.isArray(e2[1]) && "*" === e2[1][0] && "number" == typeof e2[1][1]) return ["/", ["*", -e2[1][1]].concat(e2[1].slice(2)), e2[2]];
  }
  return null;
}
function try_evaluate_product_of_numbers(e2, t2) {
  if ("number" == typeof e2) {
    if (isNaN(e2)) return NaN;
    if ("number" == typeof t2) return e2 * t2;
    if (!isFinite(e2)) return e2 === 1 / 0 && is_negative_ast(t2) || e2 === -1 / 0 && is_positive_ast(t2) ? -1 / 0 : false === is_nonzero_ast(t2) ? NaN : 1 / 0;
    if (0 === e2) return 0;
    if (1 === e2) return t2;
    if (-1 === e2) return ["-", t2];
    if (Array.isArray(t2) && "*" === t2[0] && "number" == typeof t2[1]) return e2 *= t2[1], t2 = t2[2], 1 === e2 ? t2 : -1 === e2 ? ["-", t2] : ["*", e2, t2];
  }
  if ("number" == typeof t2) {
    if (isNaN(t2)) return NaN;
    if (!isFinite(t2)) return t2 === 1 / 0 && is_negative_ast(e2) || t2 === -1 / 0 && is_positive_ast(e2) ? -1 / 0 : false === is_nonzero_ast(e2) ? NaN : 1 / 0;
    if (0 === t2) return 0;
    if (1 === t2) return e2;
    if (-1 === t2) return ["-", e2];
    if (Array.isArray(e2) && "*" === e2[0] && "number" == typeof e2[1]) return t2 *= e2[1], e2 = e2[2], 1 === t2 ? e2 : -1 === t2 ? ["-", e2] : ["*", e2, t2];
  }
  if (math$1.define_i && "i" === e2) {
    if ("i" === t2) return -1;
    if (Array.isArray(t2) && "*" === t2[0] && "i" === t2[1]) return ["-", t2[2]];
  } else if (math$1.define_i && "i" === t2 && Array.isArray(e2) && "*" === e2[0] && "i" === e2[1]) return ["-", e2[2]];
  return null;
}
function try_evaluate_quotient_of_numbers(e2, t2, r, n) {
  if ("number" == typeof e2) {
    if (0 === e2) {
      let e3 = is_nonzero_ast(t2, r);
      if (e3) return 0;
      if (false === e3) return NaN;
    }
    if ("number" == typeof t2) {
      let r2 = e2 / t2;
      if (n === 1 / 0 || math$1.round(r2, n) === r2) return r2;
      if (t2 < 0) return ["/", -e2, -t2];
    }
    if (Array.isArray(t2) && "*" === t2[0] && "number" == typeof t2[1]) {
      let r2 = e2 / t2[1];
      if (n === 1 / 0 || math$1.round(r2, n) === r2) return ["/", r2, t2[2]];
    }
  } else if ("number" == typeof t2) {
    if (Array.isArray(e2) && "*" === e2[0] && "number" == typeof e2[1]) {
      let r3 = e2[1] / t2;
      if (n === 1 / 0 || math$1.round(r3, n) === r3) return 1 === r3 ? e2[2] : ["*", r3, e2[2]];
      if (t2 < 0) return ["/", ["*", -e2[1], e2[2]], -t2];
    }
    let r2 = 1 / t2;
    if (n === 1 / 0 || math$1.round(r2, n) === r2) return ["*", r2, e2];
    if (t2 < 0) return Array.isArray(e2) && "-" === e2[0] ? ["/", e2[1], -t2] : ["-", ["/", e2, -t2]];
  }
  return null;
}
function set_small_zero(e2, t2 = 1e-14) {
  var r = get_tree(e2);
  return "number" == typeof r ? math$1.abs(r) < t2 ? 0 : r : Array.isArray(r) ? [r[0], ...r.slice(1).map(((e3) => set_small_zero(e3, t2)))] : r;
}
function evaluate_numbers_sub(e2, t2, r, n, i2, a) {
  if (void 0 === e2) return e2;
  if ("number" == typeof e2) return a > 0 && math$1.abs(e2) < a ? 0 : e2;
  if (contains_only_numbers(e2, { include_number_symbols: true, evaluate_functions: i2 })) {
    let t22 = function(t3) {
      if (a > 0 && math$1.abs(t3) < a) return 0;
      if (r === 1 / 0) return t3;
      if (Number.isInteger(t3)) return t3;
      let n3 = evalf(t3, 14), o2 = evalf(t3, r);
      if (0 === r && (o2 = math$1.round(t3)), o2 === n3) return t3;
      if (contains_decimal_number(e2) && contains_only_numbers(e2, { include_number_symbols: true, evaluate_functions: i2 })) return t3;
      let s2 = math$1.fraction(t3), u2 = { n: math$1.number(s2.n), d: math$1.number(s2.d), s: math$1.number(s2.s) }, c2 = evalf(u2.d, 3);
      if (u2.n < 1e4 || c2 === u2.d) {
        if (evalf(u2.s * u2.n / u2.d, 14) === n3) return 1 === u2.d ? u2.s * u2.n : ["/", u2.s * u2.n, u2.d];
      }
      return null;
    };
    var o = evaluate_to_constant(e2, { remove_units_first: false });
    if (!Number.isNaN(o)) {
      if ("number" == typeof o) {
        if (Number.isFinite(o)) {
          let e3 = t22(o);
          if (null !== e3) return e3;
        }
      } else if (o && Number.isFinite(o.re) && Number.isFinite(o.im)) {
        let e3 = t22(o.re), r2 = t22(o.im);
        if (null !== e3 && null !== r2) {
          if (0 === r2) return e3;
          {
            let t3;
            return t3 = 1 === r2 ? "i" : -1 === r2 ? ["-", "i"] : ["*", r2, "i"], 0 === e3 ? t3 : ["+", e3, t3];
          }
        }
      }
    }
  }
  if (!Array.isArray(e2)) return e2;
  var s = e2[0], u = e2.slice(1).map(((e3) => evaluate_numbers_sub(e3, t2, r, n, i2, a)));
  if ("+" === s) {
    let e3 = u[0], t22 = u[1];
    if (void 0 === t22) return e3;
    let r2 = try_evaluate_sum_of_numbers(e3, t22, n);
    if (null !== r2) return r2;
    if ("unit" === e3[0] && "unit" === t22[0]) {
      let r3 = get_unit_of_tree(e3), i22 = get_unit_of_tree(t22);
      if (r3 && r3 === i22) {
        let i3 = try_evaluate_sum_of_numbers(remove_units(e3, false), remove_units(t22, false), n);
        if (null !== i3) return add_unit(i3, r3);
      }
    }
    return [s].concat(u);
  }
  if ("-" === s) {
    let e3 = try_evaluate_negate_number(u[0]);
    if (null !== e3) return e3;
    if ("unit" === u[0][0]) {
      let e4 = get_unit_of_tree(u[0]);
      if (e4) {
        let t22 = try_evaluate_negate_number(remove_units(u[0], false));
        if (null !== t22) return add_unit(t22, e4);
      }
    }
    return [s].concat(u);
  }
  if ("*" === s) {
    let e3 = u[0], t22 = u[1];
    if (void 0 === t22) return e3;
    let r2 = try_evaluate_product_of_numbers(e3, t22);
    if (null !== r2) return r2;
    if ("unit" === e3[0] && "unit" !== t22[0]) {
      let r3 = get_unit_of_tree(e3);
      if (r3) {
        let n3 = try_evaluate_product_of_numbers(remove_units(e3, false), t22);
        if (null !== n3) return add_unit(n3, r3);
      }
    }
    if ("unit" !== e3[0] && "unit" === t22[0]) {
      let r3 = get_unit_of_tree(t22);
      if (r3) {
        let n3 = try_evaluate_product_of_numbers(e3, remove_units(t22, false));
        if (null !== n3) return add_unit(n3, r3);
      }
    }
    return [s].concat(u);
  }
  if ("/" === s) {
    let e3 = u[0], n3 = u[1], i22 = try_evaluate_quotient_of_numbers(e3, n3, t2, r);
    if (null !== i22) return i22;
    if ("unit" === e3[0] && "unit" !== n3[0]) {
      let i3 = get_unit_of_tree(e3);
      if (i3) {
        let a2 = try_evaluate_quotient_of_numbers(remove_units(e3, false), n3, t2, r);
        if (null !== a2) return add_unit(a2, i3);
      }
    }
    return [s].concat(u);
  }
  if ("^" === s) {
    let e3 = u[0], n3 = u[1];
    if ("number" == typeof n3) if (0 === n3) {
      if (!math$1.pow_strict) return 1;
      let r2 = is_nonzero_ast(e3, t2);
      if (r2 && e3 !== 1 / 0 && e3 !== -1 / 0) return 1;
      if (false === r2) return NaN;
    } else {
      if (1 === n3) return e3;
      if ("number" == typeof e3) {
        let t22 = math$1.pow(e3, n3);
        if (r === 1 / 0 || math$1.round(t22, r) === t22) return t22;
      }
    }
    else if (1 === e3) return 1;
    return [s].concat(u);
  }
  return [s].concat(u);
}
function evaluate_numbers(e2, { assumptions: t2, max_digits: r, skip_ordering: n = false, evaluate_functions: i2 = false, set_small_zero: a = 0 } = {}) {
  (void 0 === r || !Number.isInteger(r) && r !== 1 / 0) && (r = 0), true === a && (a = 1e-14);
  var o, s = get_tree(e2);
  return contains_blank(s) ? s : (void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), n ? o = evaluate_numbers_sub(s = unflattenRight(flatten$5(s)), t2, r, n, i2, a) : (s = move_units_outside_products(s), s = unflattenRight(default_order(flatten$5(s))), o = default_order(evaluate_numbers_sub(s, t2, r, n, i2, a)), o = default_order(evaluate_numbers_sub(unflattenRight(o), t2, r, n, i2, a))), flatten$5(o = set_negative_zeros_to_zero(o)));
}
function set_negative_zeros_to_zero(e2) {
  return 0 === e2 ? 0 : Array.isArray(e2) ? [e2[0], ...e2.slice(1).map(set_negative_zeros_to_zero)] : e2;
}
function collect_like_terms_factors(e2, t2, r) {
  function n(e3) {
    return "number" == typeof e3 || !(!Array.isArray(e3) || "-" !== e3[0] || "number" != typeof e3[1]);
  }
  function i2(e3) {
    return "number" == typeof e3 && e3 < 0 || !!(Array.isArray(e3) && "-" === e3[0] && "number" == typeof e3[1] && e3 > 0);
  }
  function a(e3) {
    if ("number" == typeof e3) return true;
    if (Array.isArray(e3) && "-" === e3[0] && "number" == typeof e3[1]) return true;
    var t22 = evaluate_to_constant(e3, { remove_units_first: false });
    return !!Number.isFinite(t22);
  }
  var o = get_tree(e2);
  if (contains_blank(o)) return o;
  void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), o = evaluate_numbers(o, { assumptions: t2, max_digits: r, evaluate_functions: true });
  var s = [];
  s.push([["/", "x", ["^", "y", "a"]], ["*", "x", ["^", "y", ["-", "a"]]], { evaluate_numbers: true, max_digits: r }]), s.push([["/", "x", ["apply", "exp", "a"]], ["*", "x", ["apply", "exp", ["-", "a"]]], { evaluate_numbers: true, max_digits: r, variables: { x: true, a: true } }]), s.push([["/", "x", "y"], ["*", "x", ["^", "y", ["-", 1]]], { evaluate_numbers: true, max_digits: r }]), o = applyAllTransformations(o, s, 40), s = [];
  for (let e3 in all_units) {
    all_units[e3].prefix ? (s.push([["+", ["unit", e3, "x"], ["unit", e3, "y"]], ["unit", e3, ["+", "x", "y"]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["unit", e3, "x"], ["-", ["unit", e3, "y"]]], ["unit", e3, ["+", "x", ["-", "y"]]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }])) : (s.push([["+", ["unit", "x", e3], ["unit", "y", e3]], ["unit", ["+", "x", "y"], e3], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["unit", "x", e3], ["-", ["unit", "y", e3]]], ["unit", ["+", "x", ["-", "y"]], e3], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]));
  }
  return s.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: (e3) => is_nonzero_ast(e3, t2), n, m: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: true, n: (e3) => n(e3) && is_positive_ast(e3, t2), m: (e3) => n(e3) && is_positive_ast(e3, t2) }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["^", ["-", "x"], "n"], ["^", "x", "n"], { variables: { x: true, n: (e3) => Number.isInteger(e3) && Number.isInteger(e3 / 2) }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, max_group: 1 }]), s.push([["^", ["-", "x"], "n"], ["-", ["^", "x", "n"]], { variables: { x: true, n: (e3) => Number.isInteger(e3) && !Number.isInteger(e3 / 2) }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, max_group: 1 }]), s.push([["*", ["^", "x", "n"], ["^", "x", "m"]], ["^", "x", ["+", "n", "m"]], { variables: { x: true, n: (e3) => n(e3) && is_negative_ast(e3, t2), m: (e3) => n(e3) && is_negative_ast(e3, t2) }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["*", ["apply", "exp", "n"], ["apply", "exp", "m"]], ["apply", "exp", ["+", "n", "m"]], { variables: { n, m: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", "n", "x"], ["*", "m", "x"]], ["*", ["+", "n", "m"], "x"], { variables: { x: true, n, m: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", "n1", "x"], ["*", ["/", "n2", "m2"], "x"]], ["*", ["+", "n1", ["/", "n2", "m2"]], "x"], { variables: { x: true, n1: n, n2: n, m2: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m2", "n1", "n2"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", "n1", "x"], ["*", ["-", ["/", "n2", "m2"]], "x"]], ["*", ["+", "n1", ["-", ["/", "n2", "m2"]]], "x"], { variables: { x: true, n1: n, n2: n, m2: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m2", "n1", "n2"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", ["/", "n1", "m1"], "x"], ["*", ["/", "n2", "m2"], "x"]], ["*", ["+", ["/", "n1", "m1"], ["/", "n2", "m2"]], "x"], { variables: { x: true, n1: n, m1: n, n2: n, m2: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m1", "m2", "n1", "n2"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", ["/", "n1", "m1"], "x"], ["*", ["-", ["/", "n2", "m2"]], "x"]], ["*", ["+", ["/", "n1", "m1"], ["-", ["/", "n2", "m2"]]], "x"], { variables: { x: true, n1: n, m1: n, n2: n, m2: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m1", "m2", "n1", "n2"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["+", ["*", "n", "x"], ["-", ["*", "m", "x"]]], ["*", ["+", "n", ["-", "m"]], "x"], { variables: { x: true, n, m: n }, evaluate_numbers: true, max_digits: r, allow_implicit_identities: ["m", "n"], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["^", ["*", "x", "y"], "a"], ["*", ["^", "x", "a"], ["^", "y", "a"]], { allow_permutations: true }]), s.push([["^", ["^", "x", "n"], "m"], ["^", "x", ["*", "n", "m"]], { variables: { x: true, n, m: n }, evaluate_numbers: true, max_digits: r, allow_permutations: true }]), s.push([["-", ["+", "a", "b"]], ["+", ["-", "a"], ["-", "b"]]]), s.push([["*", "x", "y"], ["*", "x", "y"], { variables: { x: a, y: a }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), o = applyAllTransformations(o, s, 40), (s = []).push([["*", "x", ["^", "y", ["-", "a"]]], ["/", "x", ["^", "y", "a"]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r, max_group: 1 }]), s.push([["*", "x", ["apply", "exp", ["-", "a"]]], ["/", "x", ["apply", "exp", "a"]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r, max_group: 1, variables: { x: true, a: true } }]), s.push([["*", "x", ["^", "y", "n"]], ["/", "x", ["^", "y", ["-", "n"]]], { variables: { x: true, y: true, n: i2 }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["*", "x", ["apply", "exp", "n"]], ["/", "x", ["apply", "exp", ["-", "n"]]], { variables: { x: true, n: i2 }, evaluate_numbers: true, max_digits: r, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), o = applyAllTransformations(o, s, 40), (s = []).push([["^", "y", "n"], ["/", 1, ["^", "y", ["-", "n"]]], { variables: { y: true, n: i2 }, evaluate_numbers: true, max_digits: r }]), s.push([["apply", "exp", "n"], ["/", 1, ["apply", "exp", ["-", "n"]]], { variables: { n: i2 }, evaluate_numbers: true, max_digits: r }]), o = applyAllTransformations(o, s, 40), (s = []).push([["*", "x", ["/", "y", "z"]], ["/", ["*", "x", "y"], "z"], { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), s.push([["/", ["/", "x", "y"], "z"], ["/", "x", ["*", "y", "z"]], { allow_extended_match: true, allow_permutations: true }]), s.push([["/", "x", ["/", "y", "z"]], ["/", ["*", "x", "z"], "y"], { allow_extended_match: true, allow_permutations: true }]), o = evaluate_numbers(o = applyAllTransformations(o, s, 40), { assumptions: t2, max_digits: r });
}
function simplify_ratios(e2, t2) {
  function r(e3) {
    var t22 = 1;
    return e3 = e3.map((function(e4) {
      if ("number" == typeof e4) return e4 < 0 ? (t22 *= -1, -e4) : e4;
      if (!Array.isArray(e4)) return e4;
      if ("-" === e4[0]) return t22 *= -1, e4[1];
      if ("+" !== e4[0]) return e4;
      var r2 = false;
      if (("number" == typeof e4[1] && e4[1] < 0 || Array.isArray(e4[1]) && "-" === e4[1][0] || Array.isArray(e4[1]) && "*" === e4[1][0] && Number(e4[1][1]) < 0) && (r2 = true), r2) {
        t22 *= -1;
        var n3 = e4.slice(1).map(((e5) => ["-", e5]));
        return evaluate_numbers(["+"].concat(n3));
      }
      return e4;
    })), { factors: e3, sign_change: t22 };
  }
  var n = get_tree(e2);
  return contains_blank(n) ? n : (void 0 === t2 && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (t2 = e2.context.get_assumptions([e2.variables()])), (function e3(t22, n3) {
    if (!Array.isArray(t22)) return n3 ? ["-", t22] : t22;
    var i2 = t22[0];
    if ("-" === i2) return e3(t22[1], n3 = true);
    var a = t22.slice(1).map(((t3) => e3(t3)));
    if ("/" !== i2) return n3 ? ["-", [i2, ...a]] : [i2, ...a];
    var o, s = a[0], u = a[1];
    s = default_order(s, { ignore_negatives: true });
    var c2, l = r(o = Array.isArray(s) && "*" === s[0] ? s.slice(1) : [s]);
    o = l.factors, n3 && (l.sign_change *= -1), u = default_order(u, { ignore_negatives: true });
    var f2 = r(c2 = Array.isArray(u) && "*" === u[0] ? u.slice(1) : [u]);
    return c2 = f2.factors, l.sign_change * f2.sign_change < 0 && (o[0] = ["-", o[0]]), ["/", s = 1 === o.length ? o[0] : ["*"].concat(o), u = 1 === c2.length ? c2[0] : ["*"].concat(c2)];
  })(n));
}
function contains_blank(e2) {
  return "＿" === e2 || !!Array.isArray(e2) && e2.some(contains_blank);
}
let all_units = get_all_units();
function remove_units(e2, t2 = true) {
  var r = get_tree(e2);
  if (!Array.isArray(r)) return r;
  let n = r[0], i2 = r.slice(1);
  if ("unit" === n) {
    let e3 = all_units[get_unit_of_tree(r)];
    if (!e3) return r;
    let n3 = remove_units(e3.prefix ? i2[1] : i2[0], t2);
    return t2 ? e3.scale(n3) : n3;
  }
  return [n, ...i2.map(((e3) => remove_units(e3, t2)))];
}
function remove_scaling_units(e2) {
  var t2 = get_tree(e2);
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  if ("unit" === r) {
    let e3 = all_units[get_unit_of_tree(t2)];
    if (!e3 || !e3.only_scales) return t2;
    let r2 = remove_scaling_units(e3.prefix ? n[1] : n[0]);
    return e3.scale(r2);
  }
  return [r, ...n.map(((e3) => remove_scaling_units(e3)))];
}
function add_unit(e2, t2) {
  var r = get_tree(e2);
  let n = all_units[t2];
  return n ? n.prefix ? ["unit", t2, r] : ["unit", r, t2] : r;
}
function move_units_outside_products(e2) {
  if (!Array.isArray(e2)) return e2;
  let t2 = e2[0], r = e2.slice(1);
  if ("*" === t2) {
    let e3 = [], t22 = [];
    for (let n3 of r) {
      let r2 = get_unit_value_of_tree(n3);
      r2 ? (e3.push(r2[0]), t22.push(r2[1])) : t22.push(n3);
    }
    let n = ["*", ...t22];
    for (let t3 of e3) n = add_unit(n, t3);
    return n;
  }
  return [t2, ...r.map(move_units_outside_products)];
}
var simplify$1 = Object.freeze({ __proto__: null, clean, simplify, simplify_logical, set_small_zero, evaluate_numbers, collect_like_terms_factors, collapse_unary_minus, simplify_ratios, default_order, perform_vector_matrix_additions_scalar_multiplications, remove_units, add_unit, remove_scaling_units });
function solve_linear(e2, t2, r) {
  if ("string" == typeof t2) {
    void 0 === r && void 0 !== e2.context && void 0 !== e2.context.get_assumptions && (r = e2.context.get_assumptions([e2.variables()]));
    var n = simplify(get_tree(e2), r);
    if (Array.isArray(n)) {
      var i2 = n[0], a = n.slice(1);
      if ("=" === i2 || "ne" === i2 || "<" === i2 || "le" === i2 || ">" === i2 || "ge" === i2) {
        var o = simplify(["+", a[0], ["-", a[1]]], r), s = (e3) => !variables(e3).includes(t2);
        if (variables(o = simplify(applyAllTransformations(o, [[["+", ["*", "_a", t2], ["*", "_b", t2]], ["*", ["+", "_a", "_b"], t2], { variables: { _a: s, _b: s }, allow_permutations: true, allow_extended_match: true, allow_implicit_identities: ["_a", "_b"], evaluate_numbers: true }]], 20))).includes(t2)) {
          var u = match$2(o, ["+", ["*", "_a", t2], "_b"], { variables: { _a: s, _b: s }, allow_permutations: true, allow_implicit_identities: ["_a", "_b"] });
          if (u) {
            var c2 = simplify(u._a), l = simplify(u._b);
            if (is_nonzero_ast(c2, r)) {
              if ("=" === i2 || "ne" === i2 || is_positive_ast(c2, r)) {
                let e3 = simplify(["/", ["-", l], c2]);
                return [i2, t2, e3];
              }
              if (is_negative_ast(c2, r)) {
                var f2 = simplify(["/", ["-", l], c2]);
                return [i2 = "<" === i2 ? ">" : "le" === i2 ? "ge" : ">" === i2 ? "<" : "le", t2, f2];
              }
            }
          }
        }
      }
    }
  }
}
var solve = Object.freeze({ __proto__: null, solve_linear });
function clean_assumptions(e2, t2) {
  if (!Array.isArray(e2) || 0 === e2.length) return e2;
  var r = (e2 = flatten$5(default_order(simplify_logical(expand_relations(e2)))))[0], n = e2.slice(1);
  if ("and" === r || "or" === r) {
    if (n = n.reduce((function(e3, t22) {
      return e3.every((function(e4) {
        return !equal(e4, t22);
      })) && e3.push(t22), e3;
    }), []), "and" === r && t2 && Array.isArray(t2)) {
      let e3;
      e3 = "and" === t2[0] ? t2.slice(1) : [t2], n = n.filter(((t22) => e3.every(((e4) => !equal(e4, t22)))));
    }
    e2 = 1 === n.length ? n[0] : [r].concat(n);
  }
  if ("and" !== r && t2 && Array.isArray(t2)) {
    let r2;
    if (r2 = "and" === t2[0] ? t2.slice(1) : [t2], !r2.every(((t22) => !equal(t22, e2)))) return;
  }
  return e2;
}
function calculate_derived_assumptions(e2, t2) {
  if (void 0 === t2) {
    t2 = [];
    for (let r2 in e2.byvar) {
      let n3 = e2.byvar[r2];
      n3.length > 0 && t2.push(n3);
    }
    if (0 === t2.length) return {};
    t2 = clean_assumptions(t2 = 1 === t2.length ? t2[0] : ["and"].concat(t2));
  }
  if (!Array.isArray(t2) || 0 === t2.length) return {};
  var r = t2[0], n = t2.slice(1);
  if ("and" === r || "or" === r) {
    let t22 = n.map((function(t3) {
      return calculate_derived_assumptions(e2, t3);
    })), i22 = [...new Set(t22.reduce(((e3, t3) => [...e3, ...Object.keys(t3)]), []))], a2 = {};
    for (let n3 of i22) {
      let i3 = t22.reduce((function(e3, t3) {
        return void 0 !== t3[n3] && e3.push(t3[n3]), e3;
      }), []);
      if ("and" === r || i3.length === t22.length) {
        let t3 = a2[n3];
        t3 = void 0 === t3 ? i3.length > 1 ? [r].concat(i3) : i3[0] : i3.length > 1 ? ["and", t3, [r].concat(i3)] : ["and", t3, i3[0]], a2[n3] = clean_assumptions(t3, get_assumptions(e2, n3, { omit_derived: true }));
      }
    }
    return a2;
  }
  let i2 = {};
  if ("=" === r || "ne" === r || "<" === r || "le" === r || "in" === r || "subset" === r || "notin" === r || "notsubset" === r) {
    var a = false;
    for (let t22 = 0; t22 < 2; t22++) {
      let s2 = n[t22], u = n[1 - t22], c2 = variables(u);
      if ("string" != typeof s2 || 0 === c2.length || c2.includes(s2)) continue;
      a = true;
      var o = r;
      1 === t22 && ("<" === r ? o = ">" : "le" === r ? o = "ge" : "in" === r ? o = "ni" : "subset" === r ? o = "superset" : "notin" === r ? o = "notni" : "notsubset" === r && (o = "notsuperset"));
      let l = get_assumptions_for_expr(e2, u, [s2]);
      if (l = combine_assumptions(s2, o, u, l), void 0 !== l) {
        let t3 = i2[s2];
        t3 = void 0 === t3 ? l : ["and", t3, l], i2[s2] = clean_assumptions(t3, get_assumptions(e2, s2, { omit_derived: true }));
      }
    }
    if (a) return i2;
  }
  let s = [];
  for (let t22 of n) {
    let r2 = get_assumptions_for_expr(e2, t22, []);
    void 0 !== r2 && s.push(r2);
  }
  if (0 === s.length) return {};
  s = 1 === s.length ? s[0] : ["and"].concat(s);
  for (let r2 of variables(t2)) i2[r2] = clean_assumptions(s, get_assumptions(e2, r2, { omit_derived: true }));
  return i2;
}
function get_assumptions_for_expr(e2, t2, r) {
  let n = variables(t2);
  if (n = n.filter(((e3) => !r.includes(e3))), 0 === n.length) return;
  function i2(e3) {
    return "number" == typeof e3 || !(!Array.isArray(e3) || "-" !== e3[0] || "number" != typeof e3[1]);
  }
  var a = ["_b"], o = ["_b"], s = { _b: i2 }, u = {};
  for (let e3 = 0; e3 < n.length; e3++) {
    let t22 = "_a" + e3;
    u[n[e3]] = t22, a.push(["*", t22, n[e3]]), o.push(t22), s[t22] = i2;
  }
  a = ["+"].concat(a);
  var c2 = match$2(t2, a, { variables: s, allow_permutations: true, allow_extended_match: false, allow_implicit_identities: o, max_group: 1 });
  if (!c2) {
    let n3 = [];
    for (let i22 of variables(t2)) {
      let t22 = get_assumptions_for_expr(e2, i22, r);
      void 0 !== t22 && n3.push(t22);
    }
    if (0 === n3.length) return;
    return 1 === n3.length ? n3[0] : ["and"].concat(n3);
  }
  for (let e3 of n) u[e3] = c2[u[e3]];
  let l = false;
  var f2;
  if (0 === c2._b && 1 === c2._a0 && 1 === n.length && (l = true), void 0 !== (f2 = get_assumptions(e2, [n], { exclude_variables: r }))) return clean_assumptions((function i22(a2) {
    if (!Array.isArray(a2)) return;
    var o2 = a2[0], s2 = a2.slice(1);
    if ("and" === o2 || "or" === o2) {
      let e3 = s2.map(i22).filter(((e4) => void 0 !== e4));
      if (0 === e3.length) return;
      return "or" === o2 ? e3.length === s2.length ? ["or"].concat(e3) : void 0 : 1 === e3.length ? e3[0] : ["and"].concat(e3);
    }
    if (!(["=", "ne", "<", "le"].includes(o2) || ["in", "notin", "subset", "notsubset"].includes(o2) && l)) {
      let n3 = r.concat(variables(t2)), i3 = [];
      for (let t22 of variables(a2)) {
        if (n3.includes(t22)) continue;
        let r2 = get_assumptions_for_expr(e2, t22, n3);
        void 0 !== r2 && i3.push(r2);
      }
      return 0 === i3.length ? a2 : 1 === i3.length ? ["and", a2, i3[0]] : ["and", a2].concat(i3);
    }
    let c3 = [];
    for (let i3 = 0; i3 <= 1; i3++) {
      let a3 = s2[i3], l2 = s2[1 - i3];
      if ("string" == typeof a3 && n.includes(a3)) {
        var f3 = {};
        f3[a3] = l2;
        var p = simplify(substitute$1(t2, f3)), m = false, d = o2;
        (1 === i3 && u[a3] > 0 || 0 === i3 && u[a3] < 0) && ("<" === o2 ? (m = true, d = ">") : "le" === o2 ? (m = true, d = "ge") : "in" === o2 ? (m = true, d = "ni") : "subset" === o2 ? (m = true, d = "superset") : "notin" === o2 ? (m = true, d = "notni") : "notsubset" === o2 && (m = true, d = "notsuperset")), m ? c3.push([o2, p, t2]) : c3.push([o2, t2, p]);
        let n3 = r.concat([a3]), s3 = get_assumptions_for_expr(e2, p, n3);
        s3 = combine_assumptions(t2, d, p, s3), void 0 !== s3 && c3.push(s3);
      }
    }
    if (1 === c3.length) return c3[0];
    if (c3.length > 1) return ["and"].concat(c3);
    let h = r.concat(variables(t2));
    c3 = [];
    for (let t22 of variables(a2)) {
      if (h.includes(t22)) continue;
      let r2 = get_assumptions_for_expr(e2, t22, h);
      void 0 !== r2 && c3.push(r2);
    }
    return 0 === c3.length ? a2 : 1 === c3.length ? ["and", a2, c3[0]] : ["and", a2].concat(c3);
  })(f2));
}
function combine_assumptions(e2, t2, r, n) {
  if (!["=", "ne", "<", "le", ">", "ge", "in", "notin", "ni", "notni", "subset", "notsubset", "superset", "notsuperset"].includes(t2)) return n;
  if (Array.isArray(n)) {
    var i2 = n[0], a = n.slice(1);
    if ("and" === i2 || "or" === i2) {
      let n3 = a.map(((n4) => combine_assumptions(e2, t2, r, n4))).filter(((e3) => void 0 !== e3));
      if (0 === n3.length) return;
      return "or" === i2 ? n3.length === a.length ? [["or"].concat(n3)] : void 0 : 1 === n3.length ? n3[0] : ["and"].concat(n3);
    }
    if (!["=", "ne", "<", "le", "in", "notin", "subset", "notsubset"].includes(i2)) return n;
    var o, s, u = i2;
    if (equal(a[0], r)) o = a[1];
    else {
      if (!equal(a[1], r)) return n;
      o = a[0], "<" === i2 ? u = ">" : "le" === i2 ? u = "ge" : "in" === i2 ? u = "ni" : "notin" === i2 ? u = "notni" : "subset" === i2 ? u = "superset" : "notsubset" === i2 && (u = "notsuperset");
    }
    if ("=" === t2) s = u;
    else if ("=" === u) s = t2;
    else if ("<" === t2) {
      if ("<" !== u && "le" !== u) return "in" === u || "notin" === u ? n : void 0;
      s = "<";
    } else if ("le" === t2) if ("<" === u) s = "<";
    else {
      if ("le" !== u) return "in" === u || "notin" === u ? n : void 0;
      s = "le";
    }
    else if (">" === t2) {
      if (">" !== u && "ge" !== u) return "in" === u || "notin" === u ? n : void 0;
      s = ">";
    } else if ("ge" === t2) if (">" === u) s = ">";
    else {
      if ("ge" !== u) return "in" === u || "notin" === u ? n : void 0;
      s = "ge";
    }
    else if ("in" === t2) {
      if ("subset" !== u) return;
      s = "in";
    } else if ("notin" === t2) {
      if ("superset" !== u) return;
      s = "notin";
    } else if ("ni" === t2) {
      if ("notin" !== u) return;
      s = "notsubset";
    } else if ("notni" === t2) {
      if ("in" !== u) return;
      s = "notsuperset";
    } else if ("subset" === t2) if ("subset" === u) s = "subset";
    else if ("notni" === u) s = "notni";
    else {
      if ("notsuperset" !== u) return;
      s = "notsuperset";
    }
    else if ("notsubset" === t2) {
      if ("superset" !== u) return;
      s = "notsubset";
    } else if ("superset" === t2) if ("superset" === u) s = "superset";
    else if ("ni" === u) s = "ni";
    else {
      if ("notsubset" !== u) return;
      s = "notsubset";
    }
    else {
      if ("notsuperset" !== t2) return;
      if ("subset" !== u) return;
      s = "notsuperset";
    }
    return ">" === s ? ["<", o, e2] : "ge" === s ? ["le", o, e2] : "ni" === s ? ["in", o, e2] : "notni" === s ? ["notin", o, e2] : "superset" === s ? ["subset", o, e2] : "notsuperset" === s ? ["notsubset", o, e2] : [s, e2, o];
  }
}
function filter_assumptions_from_tree(e2, t2) {
  if (Array.isArray(e2) && 0 !== e2.length) {
    Array.isArray(t2) || (t2 = [t2]);
    var r = e2[0], n = e2.slice(1);
    if ("and" === r) {
      var i2 = n.map((function(e3) {
        return filter_assumptions_from_tree(e3, t2);
      }));
      return 0 === (i2 = i2.filter(((e3) => void 0 !== e3))).length ? void 0 : 1 === i2.length ? i2[0] : ["and"].concat(i2);
    }
    var a = variables(e2);
    return t2.filter(((e3) => a.includes(e3))).length > 0 ? void 0 : e2;
  }
}
function get_assumptions_sub(e2, t2, r, n) {
  Array.isArray(t2) || (t2 = [t2]);
  var i2 = [];
  return t2.forEach((function(t22) {
    if (e2.byvar[t22] || e2.derived[t22]) {
      if (e2.byvar[t22] && e2.byvar[t22].length > 0) {
        var a = filter_assumptions_from_tree(e2.byvar[t22], r);
        void 0 !== a && i2.push(a);
      }
      if (e2.derived[t22] && e2.derived[t22].length > 0 && !n) {
        var o = filter_assumptions_from_tree(e2.derived[t22], r);
        void 0 !== o && i2.push(o);
      }
    } else e2.generic.length > 0 && ("x" !== t22 && variables(e2.generic).includes(t22) || i2.push(substitute$1(e2.generic, { x: t22 })));
  })), 1 === i2.length ? i2 = i2[0] : i2.length > 1 && (i2 = ["and"].concat(i2)), i2.length > 0 ? clean_assumptions(i2) : void 0;
}
function get_assumptions(e2, t2, r) {
  void 0 === r && (r = {});
  var n, i2 = r.exclude_variables;
  void 0 === i2 ? i2 = [] : Array.isArray(i2) || (i2 = [i2]);
  var a = get_tree(t2);
  if ("string" == typeof a) n = [a];
  else {
    if (!Array.isArray(a)) return;
    Array.isArray(a[0]) && (n = a[0]);
  }
  return n ? get_assumptions_sub(e2, n, i2, r.omit_derived) : get_assumptions_for_expr(e2, a, i2);
}
function add_assumption(e2, t2, r) {
  var n = get_tree(t2);
  if (!Array.isArray(n)) return 0;
  var i2 = add_assumption_sub(e2, n = clean_assumptions(simplify(n, e2)), r);
  return i2 && (e2.derived = calculate_derived_assumptions(e2)), i2;
}
function add_assumption_sub(e2, t2, r) {
  if ("and" === t2[0]) return t2.slice(1).map(((t22) => add_assumption_sub(e2, t22, r))).reduce((function(e3, t22) {
    return e3 + t22;
  }));
  var n = variables(t2);
  if (0 === n.length) return 0;
  let i2 = 0;
  !r && e2.generic.length > 0 && n.forEach((function(t22) {
    void 0 === e2.byvar[t22] && ("x" !== t22 && variables(e2.generic).includes(t22) || (add_assumption_sub(e2, substitute$1(e2.generic, { x: t22 }), true), i2 += 1));
  }));
  for (let r2 of n) {
    let n3 = solve_linear(t2, r2, e2), a = t2;
    n3 && (a = n3);
    let o = e2.byvar[r2];
    void 0 !== o && 0 !== o.length && (a = ["and", o, a]), a = clean_assumptions(a), equal(a, o) || (e2.byvar[r2] = a, i2 += 1);
  }
  return i2;
}
function add_generic_assumption(e2, t2) {
  var r = get_tree(t2);
  if (!Array.isArray(r)) return 0;
  var n = add_generic_assumption_sub(e2, r = clean_assumptions(simplify(r, e2)));
  return n && (e2.derived = calculate_derived_assumptions(e2)), n;
}
function add_generic_assumption_sub(e2, t2) {
  if ("and" === t2[0]) return t2.slice(1).map(((t22) => add_generic_assumption_sub(e2, t22))).reduce((function(e3, t22) {
    return e3 + t22;
  }));
  if (!variables(t2).includes("x")) return 0;
  let r = solve_linear(t2, "x", e2), n = t2;
  r && (n = r);
  let i2 = e2.generic;
  return 0 !== i2.length && (n = ["and", i2, n]), n = clean_assumptions(n), equal(n, i2) ? 0 : (e2.generic = n, 1);
}
function remove_assumption(e2, t2) {
  var r = get_tree(t2);
  if (!Array.isArray(r)) return 0;
  var n = remove_assumption_sub(e2, r = clean_assumptions(simplify(r, e2)));
  return n && (e2.derived = calculate_derived_assumptions(e2)), n;
}
function remove_assumption_sub(e2, t2) {
  if ("and" === t2[0]) return t2.slice(1).map(((t22) => remove_assumption_sub(e2, t22))).reduce((function(e3, t22) {
    return e3 + t22;
  }));
  var r = variables(t2);
  if (0 === r.length) return 0;
  var n = 0;
  for (let i2 of r) {
    let r2 = solve_linear(t2, i2, e2), a = e2.byvar[i2];
    if (!a || 0 === a.length) continue;
    let o, s = a[0], u = a.slice(1), c2 = u.length;
    if ("and" === s) if (u = u.filter(((e3) => !(equal(e3, t2) || equal(e3, r2)))), 0 === u.length) o = [];
    else if (1 === u.length) o = u[0];
    else {
      if (!(u.length < c2)) continue;
      o = [s].concat(u);
    }
    else {
      if (!equal(a, t2) && !equal(a, r2)) continue;
      o = [];
    }
    n += 1, e2.byvar[i2] = o;
  }
  return n;
}
function remove_generic_assumption(e2, t2) {
  var r = get_tree(t2);
  if (!Array.isArray(r)) return 0;
  var n = remove_generic_assumption_sub(e2, r = clean_assumptions(simplify(r, e2)));
  return n && (e2.derived = calculate_derived_assumptions(e2)), n;
}
function remove_generic_assumption_sub(e2, t2) {
  if ("and" === t2[0]) return t2.slice(1).map(((t22) => remove_generic_assumption_sub(e2, t22))).reduce((function(e3, t22) {
    return e3 + t22;
  }));
  if (!variables(t2).includes("x")) return 0;
  var r = e2.generic;
  if (0 === r.length) return 0;
  let n = solve_linear(t2, "x", e2);
  var i2, a = r[0], o = r.slice(1), s = o.length;
  if ("and" === a) if (0 === (o = o.filter(((e3) => !(equal(e3, t2) || equal(e3, n))))).length) i2 = [];
  else if (1 === o.length) i2 = o[0];
  else {
    if (!(o.length < s)) return 0;
    i2 = [a].concat(o);
  }
  else {
    if (!equal(r, t2) && !equal(r, n)) return 0;
    i2 = [];
  }
  return e2.generic = i2, 1;
}
function initialize_assumptions() {
  var e2 = { byvar: {}, derived: {}, generic: [], not_commutative: [], get_assumptions: function(t2, r) {
    return get_assumptions(e2, t2, r);
  }, add_assumption: function(t2, r) {
    return add_assumption(e2, t2, r);
  }, add_generic_assumption: function(t2) {
    return add_generic_assumption(e2, t2);
  }, remove_assumption: function(t2) {
    return remove_assumption(e2, t2);
  }, remove_generic_assumption: function(t2) {
    return remove_generic_assumption(e2, t2);
  } };
  return e2;
}
function padNumberStringToDigits(e2, t2) {
  let r = Math.floor(t2);
  if (r > 0) {
    if (e2.includes(".")) {
      if ("0" !== e2[0] ? r++ : r += e2.match(/^0\.0*/)[0].length, e2.length < r) {
        let t22 = r - e2.length;
        e2 += "0".repeat(t22);
      }
    } else if (e2.length < r) {
      let t22 = r - e2.length;
      e2 += "." + "0".repeat(t22);
    }
  }
  return e2;
}
function padNumberStringToDecimals(e2, t2) {
  let r = Math.floor(t2);
  if (r > 0) if (e2.includes(".")) {
    let t22 = e2.match(/\.\d*$/)[0].length - 1;
    if (t22 < r) {
      e2 += "0".repeat(r - t22);
    }
  } else e2 += "." + "0".repeat(r);
  return e2;
}
function padNumberStringToDigitsAndDecimals(e2, t2, r) {
  let n = Math.floor(t2);
  if (!(n > 0)) return padNumberStringToDecimals(e2, r);
  let i2 = Math.floor(r);
  if (!(i2 > 0)) return padNumberStringToDigits(e2, t2);
  if (e2.includes(".")) {
    "0" !== e2[0] ? n++ : n += e2.match(/^0\.0*/)[0].length;
    let t22 = 0;
    e2.length < n && (t22 = n - e2.length);
    let r2 = e2.match(/\.\d*$/)[0].length - 1;
    r2 < i2 && (t22 = Math.max(t22, i2 - r2)), t22 > 0 && (e2 += "0".repeat(t22));
  } else {
    let t22 = 0;
    e2.length < n && (t22 = n - e2.length), t22 = Math.max(t22, i2), e2 += "." + "0".repeat(t22);
  }
  return e2;
}
const operators$1 = { "+": function(e2) {
  return e2.join(" ");
}, "-": function(e2) {
  return "-" + e2[0];
}, "*": function(e2) {
  return e2.join(" ");
}, "/": function(e2) {
  return "\\frac{" + e2[0] + "}{" + e2[1] + "}";
}, _: function(e2) {
  return e2[0] + "_{" + e2[1] + "}";
}, "^": function(e2) {
  return e2[0] + "^{" + e2[1] + "}";
}, prime: function(e2) {
  return e2[0] + "'";
}, tuple: function(e2) {
  return "\\left( " + e2.join(", ") + " \\right)";
}, array: function(e2) {
  return "\\left[ " + e2.join(", ") + " \\right]";
}, list: function(e2) {
  return e2.join(", ");
}, set: function(e2) {
  return "\\left\\{ " + e2.join(", ") + " \\right\\}";
}, vector: function(e2) {
  return "\\left( " + e2.join(", ") + " \\right)";
}, altvector: function(e2) {
  return "\\left\\langle " + e2.join(", ") + " \\right\\rangle";
}, interval: function(e2) {
  return "\\left( " + e2.join(", ") + " \\right)";
}, matrix: function(e2) {
  return "\\left( " + e2.join(", ") + " \\right)";
}, and: function(e2) {
  return e2.join(" \\land ");
}, or: function(e2) {
  return e2.join(" \\lor ");
}, not: function(e2) {
  return "\\lnot " + e2[0];
}, "=": function(e2) {
  return e2.join(" = ");
}, "<": function(e2) {
  return e2.join(" < ");
}, ">": function(e2) {
  return e2.join(" > ");
}, lts: function(e2) {
  return e2.join(" < ");
}, gts: function(e2) {
  return e2.join(" > ");
}, le: function(e2) {
  return e2.join(" \\le ");
}, ge: function(e2) {
  return e2.join(" \\ge ");
}, ne: function(e2) {
  return e2.join(" \\ne ");
}, forall: function(e2) {
  return "\\forall " + e2[0];
}, exists: function(e2) {
  return "\\exists " + e2[0];
}, in: function(e2) {
  return e2[0] + " \\in " + e2[1];
}, notin: function(e2) {
  return e2[0] + " \\notin " + e2[1];
}, ni: function(e2) {
  return e2[0] + " \\ni " + e2[1];
}, notni: function(e2) {
  return e2[0] + " \\not\\ni " + e2[1];
}, subset: function(e2) {
  return e2[0] + " \\subset " + e2[1];
}, subseteq: function(e2) {
  return e2[0] + " \\subseteq " + e2[1];
}, notsubset: function(e2) {
  return e2[0] + " \\not\\subset " + e2[1];
}, notsubseteq: function(e2) {
  return e2[0] + " \\not\\subseteq " + e2[1];
}, superset: function(e2) {
  return e2[0] + " \\supset " + e2[1];
}, superseteq: function(e2) {
  return e2[0] + " \\supseteq " + e2[1];
}, notsuperset: function(e2) {
  return e2[0] + " \\not\\supset " + e2[1];
}, notsuperseteq: function(e2) {
  return e2[0] + " \\not\\supseteq " + e2[1];
}, union: function(e2) {
  return e2.join(" \\cup ");
}, intersect: function(e2) {
  return e2.join(" \\cap ");
}, implies: function(e2) {
  return e2.join(" \\implies ");
}, impliedby: function(e2) {
  return e2.join(" \\impliedby ");
}, iff: function(e2) {
  return e2.join(" \\iff ");
}, leftarrow: function(e2) {
  return e2.join(" \\leftarrow ");
}, rightarrow: function(e2) {
  return e2.join(" \\rightarrow ");
}, leftrightarrow: function(e2) {
  return e2.join(" \\leftrightarrow ");
}, perp: function(e2) {
  return e2.join(" \\perp ");
}, parallel: function(e2) {
  return e2.join(" \\parallel ");
}, derivative_leibniz: function(e2) {
  return "\\frac{d" + e2[0] + "}{d" + e2[1] + "}";
}, partial_derivative_leibniz: function(e2) {
  return "\\frac{d" + e2[0] + "}{d" + e2[1] + "}";
}, "|": function(e2) {
  return e2[0] + " \\mid " + e2[1];
}, ":": function(e2) {
  return e2[0] + " : " + e2[1];
}, binom: function(e2) {
  return "\\binom{" + e2[0] + "}{" + e2[1] + "}";
}, vec: function(e2) {
  return "\\vec{" + e2[0] + "}";
}, linesegment: function(e2) {
  return "\\overline{" + e2.join(" ") + "}";
}, angle: function(e2, t2) {
  return t2 ? "\\angle " + e2.join("") : "\\angle\\left( " + e2.join(", ") + " \\right)";
}, unit: function(e2) {
  return "\\circ" === e2[1] ? e2[0] + "^{\\circ}" : e2[0] + " " + e2[1];
} }, allowedLatexSymbolsDefault$1 = ["alpha", "beta", "gamma", "Gamma", "delta", "Delta", "epsilon", "zeta", "eta", "theta", "Theta", "iota", "kappa", "lambda", "Lambda", "mu", "nu", "xi", "Xi", "pi", "Pi", "rho", "sigma", "Sigma", "tau", "Tau", "upsilon", "Upsilon", "phi", "Phi", "chi", "psi", "Psi", "omega", "Omega", "partial", "abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "cos", "cosh", "cot", "coth", "csc", "csch", "sec", "sech", "sin", "sinh", "tan", "tanh", "arcsin", "arccos", "arctan", "arccsc", "arcsec", "arccot", "arg", "Re", "Im", "det", "angle", "perp", "circ", "%", "$", "int", "varnothing"], convertLatexSymbolsDefault = { acos: "arccos", acosh: "arccosh", acot: "arccot", acoth: "arccoth", acsc: "arccsc", acsch: "arccsch", asec: "arcsec", asech: "arcsech", asin: "arcsin", asinh: "arcsinh", atan: "arctan", atanh: "arctanh", deg: "circ", emptyset: "varnothing" }, matrixEnvironmentDefault = "bmatrix";
class astToLatex$1 {
  constructor({ allowedLatexSymbols: e2 = allowedLatexSymbolsDefault$1, convertLatexSymbols: t2 = convertLatexSymbolsDefault, matrixEnvironment: r = matrixEnvironmentDefault, padToDigits: n = null, padToDecimals: i2 = null, showBlanks: a = true } = {}) {
    this.allowedLatexSymbols = e2, this.convertLatexSymbols = t2, this.matrixEnvironment = r, this.padToDigits = n, this.padToDecimals = i2, this.showBlanks = a;
  }
  convert(e2) {
    return this.statement(e2);
  }
  statement(e2) {
    if (!Array.isArray(e2)) return this.single_statement(e2);
    var t2 = e2[0], r = e2.slice(1);
    if ("ldots" === t2) return "\\ldots";
    if (!(t2 in operators$1) && "apply" !== t2) throw new Error("Badly formed ast: operator " + t2 + " not recognized.");
    return ["implies", "impliedby", "iff", "rightarrow", "leftarrow", "leftrightarrow"].includes(t2) ? operators$1[t2](r.map(((e3) => this.statement(e3)))) : "and" === t2 || "or" === t2 ? operators$1[t2](r.map((function(e3, t22) {
      let r2 = this.single_statement(e3);
      return r2.match(/ /) && !r2.match(/^\\left\(.*\\right\)$/) ? "\\left(" + r2 + "\\right)" : r2;
    }).bind(this))) : this.single_statement(e2);
  }
  single_statement(e2) {
    if (!Array.isArray(e2)) return this.expression(e2);
    var t2 = e2[0], r = e2.slice(1);
    if ("not" === t2) return operators$1[t2](r.map((function(e3, t22) {
      let r2 = this.single_statement(e3);
      return r2.match(/ /) && !r2.match(/^\\left\(.*\\right\)$/) ? "\\left(" + r2 + "\\right)" : r2;
    }).bind(this)));
    if ("exists" === t2 || "forall" === t2) return operators$1[t2]([this.single_statement(r[0])]);
    if ("=" === t2 || "ne" === t2 || "<" === t2 || ">" === t2 || "le" === t2 || "ge" === t2 || "in" === t2 || "notin" === t2 || "ni" === t2 || "notni" === t2 || "subset" === t2 || "notsubset" === t2 || "subseteq" === t2 || "notsubseteq" === t2 || "superset" === t2 || "notsuperset" === t2 || "superseteq" === t2 || "notsuperseteq" === t2) return operators$1[t2](r.map((function(e3, t22) {
      return this.expression(e3);
    }).bind(this)));
    if ("lts" === t2 || "gts" === t2) {
      let e3 = r[0], n = r[1];
      if ("tuple" !== e3[0] || "tuple" !== n[0]) throw new Error("Badly formed ast");
      let i2 = this.expression(e3[1]);
      for (let r2 = 1; r2 < e3.length - 1; r2++) n[r2] ? i2 += "lts" === t2 ? " < " : " > " : i2 += "lts" === t2 ? " \\le " : " \\ge ", i2 += this.expression(e3[r2 + 1]);
      return i2;
    }
    return this.expression(e2);
  }
  expression(e2) {
    if (!Array.isArray(e2)) return this.term(e2);
    var t2 = e2[0], r = e2.slice(1);
    return "+" === t2 ? 1 === r.length ? "+" + this.term(r[0]) : operators$1[t2](r.map((function(e3, t22) {
      return t22 > 0 ? this.termWithPlusIfNotNegated(e3) : this.term(e3);
    }).bind(this))) : ["union", "intersect", "perp", "parallel"].includes(t2) ? operators$1[t2](r.map((function(e3, t22) {
      return this.term(e3);
    }).bind(this))) : this.term(e2);
  }
  term(e2) {
    if (!Array.isArray(e2)) return this.factor(e2);
    var t2 = e2[0], r = e2.slice(1);
    return "-" === t2 ? operators$1[t2](r.map((function(e3, t22) {
      return this.term(e3);
    }).bind(this))) : "*" === t2 ? operators$1[t2](r.map((function(e3, t22) {
      let n;
      return t22 > 0 ? (n = this.factorWithParenthesesIfNegatedExplicitPlusOrFraction(e3), n.match(/^[0-9]/) ? "\\cdot " + n : "angle" === e3[0] && r.length > 1 ? "\\left( " + n + " \\right)" : n) : (n = this.factor(e3), "angle" === e3[0] && r.length > 1 ? "\\left( " + n + " \\right)" : n);
    }).bind(this))) : "/" === t2 || "unit" === t2 ? operators$1[t2](r.map((function(e3, t22) {
      return this.expression(e3);
    }).bind(this))) : this.factor(e2);
  }
  simple_factor_or_function_or_parens(e2) {
    var t2 = this.factor(e2);
    return !!(t2.length <= 1 || "string" == typeof e2 && e2.match(/^\w+$/) || Array.isArray(e2) && "apply" === e2[0] && "sqrt" !== e2[1] || t2.match(/^\\left\(.*\\right\)$/) || t2.match(/^\\left\\langle.*\\right\\rangle$/)) || "number" == typeof e2 && (e2 >= 0 && !e2.toString().includes("e"));
  }
  stringConvert(e2) {
    return e2.length > 1 ? (this.convertLatexSymbols[e2] && (e2 = this.convertLatexSymbols[e2]), this.allowedLatexSymbols.includes(e2) ? "\\" + e2 : "\\operatorname{" + e2 + "}") : this.allowedLatexSymbols.includes(e2) ? "\\" + e2 : "＿" !== e2 || this.showBlanks ? e2 : "";
  }
  factor(e2) {
    if ("string" == typeof e2) return this.stringConvert(e2);
    if ("number" == typeof e2) {
      if (e2 === 1 / 0) return "\\infty";
      if (e2 === -1 / 0) return "-\\infty";
      if (Number.isNaN(e2)) return "NaN";
      {
        let t22 = e2.toString(), r2 = t22.indexOf("e");
        if (-1 === r2) return null === this.padToDigits && null === this.padToDecimals || (t22 = padNumberStringToDigitsAndDecimals(t22, this.padToDigits, this.padToDecimals)), t22;
        let n = t22.substring(0, r2), i2 = t22.substring(r2 + 1);
        if ("+" === i2[0] && (i2 = i2.slice(1)), null !== this.padToDigits || null !== this.padToDecimals) {
          let r3 = Number(i2);
          if (r3 > 0 && null !== this.padToDecimals) return t22 = e2.toLocaleString("fullwide", { useGrouping: false }), padNumberStringToDigitsAndDecimals(t22, this.padToDigits, this.padToDecimals);
          {
            let e3 = null;
            null !== this.padToDecimals && (e3 = this.padToDecimals + r3), n = padNumberStringToDigitsAndDecimals(n, this.padToDigits, e3);
          }
        }
        return n + " \\cdot 10^{" + i2 + "}";
      }
    }
    if (!Array.isArray(e2)) return "";
    var t2 = e2[0], r = e2.slice(1);
    if ("^" === t2) {
      if (Number.isInteger(r[0]) && Number.isInteger(r[1])) return r[0] < 0 ? "\\left(" + r[0].toString() + "\\right)^{" + r[1].toString() + "}" : r[0].toString() + "^{" + r[1].toString() + "}";
      let e3 = this.factor(r[0]), t22 = r[0];
      for (; "prime" === t22[0]; ) t22 = t22[1];
      return this.simple_factor_or_function_or_parens(t22) || "_" === t22[0] && "string" == typeof t22[1] || (e3 = "\\left(" + e3.toString() + "\\right)"), e3 + "^{" + this.statement(r[1]) + "}";
    }
    if ("_" === t2) {
      let e3 = this.factor(r[0]);
      return this.simple_factor_or_function_or_parens(r[0]) || (e3 = "\\left(" + e3.toString() + "\\right)"), e3 + "_{" + this.statement(r[1]) + "}";
    }
    if ("prime" === t2) {
      let e3 = r[0], t22 = 1;
      for (; "prime" === e3[0]; ) t22 += 1, e3 = e3[1];
      let n = this.factor(e3);
      this.simple_factor_or_function_or_parens(e3) || "_" === e3[0] && "string" == typeof e3[1] || (n = "\\left(" + n + "\\right)");
      for (let e4 = 0; e4 < t22; e4++) n += "'";
      return n;
    }
    if ("/" === t2) return this.term(e2);
    if ("-" === t2) return operators$1[t2](r.map((function(e3, t22) {
      return this.factor(e3);
    }).bind(this)));
    if ("tuple" === t2 || "array" === t2 || "list" === t2 || "set" === t2 || "vector" === t2 || "altvector" === t2 || "|" === t2 || ":" === t2 || "binom" === t2 || "vec" === t2 || "linesegment" === t2) return operators$1[t2](r.map((function(e3, t22) {
      return this.statement(e3);
    }).bind(this)));
    if ("interval" === t2) {
      let e3 = r[0], t22 = r[1];
      if ("tuple" !== e3[0] || "tuple" !== t22[0]) throw new Error("Badly formed ast");
      let n = this.statement(e3[1]) + ", " + this.statement(e3[2]);
      return n = t22[1] ? "\\left[ " + n : "\\left( " + n, t22[2] ? n += " \\right]" : n += " \\right)", n;
    }
    if ("matrix" === t2) {
      let e3 = r[0], t22 = r[1], n = "\\begin{" + this.matrixEnvironment + "} ";
      for (let r2 = 0; r2 < e3[1]; r2 += 1) {
        for (let i2 = 0; i2 < e3[2]; i2 += 1) n += this.statement(t22[r2 + 1][i2 + 1]), i2 < e3[2] - 1 && (n += " & ");
        r2 < e3[1] - 1 && (n += " \\\\ ");
      }
      return n = n + " \\end{" + this.matrixEnvironment + "}", n;
    }
    if ("derivative_leibniz" === t2 || "partial_derivative_leibniz" === t2) {
      let e3 = "d";
      "partial_derivative_leibniz" === t2 && (e3 = "\\partial ");
      let n = r[0], i2 = r[1], a = 1, o = "";
      Array.isArray(n) ? (o = n[1], a = n[2]) : o = n;
      let s = e3;
      a > 1 ? s = s.trimRight() + "^{" + a + "}" + this.stringConvert(o) : s += this.stringConvert(o), s = "\\frac{ " + s + " }{ ";
      let u = 1;
      Array.isArray(i2) && (u = i2.length - 1);
      for (let t22 = 1; t22 <= u; t22++) {
        let r2 = i2[t22], n3 = 1, a2 = "";
        Array.isArray(r2) ? (a2 = r2[1], n3 = r2[2]) : a2 = r2, s = s + e3 + this.stringConvert(a2), n3 > 1 && (s = s + "^{" + n3 + "}"), s += " ";
      }
      return s += "}", s;
    }
    if ("apply" === t2) {
      if ("abs" === r[0]) return "\\left|" + this.statement(r[1]) + "\\right|";
      if ("floor" === r[0]) return "\\left\\lfloor " + this.statement(r[1]) + " \\right\\rfloor";
      if ("ceil" === r[0]) return "\\left\\lceil " + this.statement(r[1]) + " \\right\\rceil";
      if ("factorial" === r[0]) {
        let e4 = this.factor(r[1]);
        return this.simple_factor_or_function_or_parens(r[1]) || "_" === r[1][0] && "string" == typeof r[1][1] ? e4 + "!" : "\\left(" + e4 + "\\right)!";
      }
      if ("sqrt" === r[0]) return "\\sqrt{" + this.statement(r[1]) + "}";
      let e3, t22 = r[0];
      if ("^" === t22[0] && (t22 = t22[1]), "_" === t22[0] && (t22 = t22[1]), "int" === t22) {
        let e4, t3 = this.factor(r[0]), n3 = r[1];
        if (Array.isArray(n3) && "*" === n3[0]) {
          let t4 = [], r2 = ["*"];
          for (let e5 = 1; e5 < n3.length; e5++) {
            let i2 = n3[e5];
            Array.isArray(i2) && "d" === i2[0] ? t4.push(i2) : r2.push(i2);
          }
          e4 = this.term(r2), t4.length > 0 && (e4[e4.length - 1].match(/[a-zA-Z]/) && (e4 += "\\,"), e4 += t4.map(((e5) => "d" + this.factor(e5[1]))).join("\\,"));
        }
        return e4 || (e4 = this.term(r[1])), t3 + " " + e4;
      }
      e3 = "log10" === r[0] ? "\\log_{10}" : "re" === r[0] ? "\\Re" : "im" === r[0] ? "\\Im" : this.factor(r[0]);
      let n = this.statement(r[1]);
      return "tuple" !== r[1][0] && (n = "\\left(" + n + "\\right)"), e3 + n;
    }
    if ("angle" === t2) {
      let e3 = r.every(((e4) => {
        if ("string" == typeof e4 && 1 === e4.length) return true;
        if (!Array.isArray(e4)) return false;
        let t22 = e4[0];
        return "_" === t22 || "^" === t22 || "prime" === t22;
      }));
      return operators$1[t2](r.map((function(e4, t22) {
        return this.statement(e4);
      }).bind(this)), e3);
    }
    return "+" === t2 && 2 === e2.length ? "+ " + this.factor(e2[1]) : "\\left(" + this.statement(e2) + "\\right)";
  }
  factorWithParenthesesIfNegatedExplicitPlusOrFraction(e2) {
    var t2 = this.factor(e2);
    return t2.match(/^-/) || t2.match(/^\+/) || "/" === e2[0] ? "\\left(" + t2 + "\\right)" : t2;
  }
  termWithPlusIfNotNegated(e2) {
    var t2 = this.term(e2);
    return t2.match(/^-/) ? t2.match(/^-[^ ]/) ? "- " + t2.slice(1) : t2 : "+ " + t2;
  }
}
const textToAst$2 = new textToAst$4(), astToLatex = new astToLatex$1();
var derivatives = { sin: textToAst$2.convert("cos x"), cos: textToAst$2.convert("-(sin x)"), tan: textToAst$2.convert("(sec x)^2"), cot: textToAst$2.convert("-((csc x)^2)"), sec: textToAst$2.convert("(sec x)*(tan x)"), csc: textToAst$2.convert("-(csc x)*(cot x)"), sqrt: textToAst$2.convert("1/(2*sqrt(x))"), log: textToAst$2.convert("1/x"), ln: textToAst$2.convert("1/x"), exp: textToAst$2.convert("exp(x)"), arcsin: textToAst$2.convert("1/sqrt(1 - x^2)"), arccos: textToAst$2.convert("-1/sqrt(1 - x^2)"), arctan: textToAst$2.convert("1/(1 + x^2)"), arccsc: textToAst$2.convert("-1/(sqrt(-1/x^2 + 1)*x^2)"), arcsec: textToAst$2.convert("1/(sqrt(-1/x^2 + 1)*x^2)"), arccot: textToAst$2.convert("-1/(1 + x^2)"), abs: textToAst$2.convert("abs(x)/x") };
function derivative(e2, t2, r = []) {
  var n = get_tree(e2), i2 = "\\frac{d}{d" + t2 + "} ";
  if ("number" == typeof n) return r.push("The derivative of a constant is zero, that is, \\(" + i2 + astToLatex.convert(n) + " = 0\\)."), 0;
  if (variables(n).indexOf(t2) < 0) return r.push("The derivative of a constant is zero, that is, \\(" + i2 + astToLatex.convert(n) + " = 0\\)."), 0;
  if ("string" == typeof n) return t2 === n ? (r.push("We know the derivative of the identity function is one, that is, \\(" + i2 + astToLatex.convert(n) + " = 1\\)."), 1) : (r.push("As far as \\(" + astToLatex.convert(t2) + "\\) is concerned, \\(" + astToLatex.convert(n) + "\\) is constant, so " + i2 + astToLatex.convert(n) + " = 0\\)."), 0);
  if (!Array.isArray(n)) return null;
  var a = n[0], o = n.slice(1);
  if ("+" === a || "-" === a || "~" === a) {
    r.push("Using the sum rule, \\(" + i2 + astToLatex.convert(n) + " = " + o.map((function(e4, t22) {
      return i2 + astToLatex.convert(e4);
    })).join(" + ") + "\\).");
    let e3 = [a].concat(o.map((function(e4, n3) {
      return derivative(e4, t2, r);
    })));
    return e3 = simplify(e3), r.push("So using the sum rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(e3) + "\\)."), e3;
  }
  if ("*" === a) {
    let e3 = [], a2 = [];
    for (let r2 = 0; r2 < o.length; r2++) "number" == typeof o[r2] || variables(o[r2]).indexOf(t2) < 0 ? a2.push(o[r2]) : e3.push(o[r2]);
    if (a2.length > 0) {
      if (0 === e3.length) {
        return r.push("Since the derivative of a constant is zero, \\(" + i2 + astToLatex.convert(n) + " = 0.\\)"), 0;
      }
      let o2 = ["*"].concat(e3);
      if (1 === e3.length && (o2 = e3[0]), o2 === t2) {
        r.push("By the constant multiple rule, \\(" + i2 + astToLatex.convert(n) + " = " + a2.map((function(e5, t22) {
          return astToLatex.convert(e5);
        })).join(" \\cdot ") + "\\).");
        let e4 = ["*"].concat(a2);
        return e4 = simplify(e4), e4;
      }
      r.push("By the constant multiple rule, \\(" + i2 + astToLatex.convert(n) + " = " + a2.map((function(e4, t22) {
        return astToLatex.convert(e4);
      })).join(" \\cdot ") + " \\cdot " + i2 + "\\left(" + astToLatex.convert(o2) + "\\right)\\).");
      let s2 = derivative(o2, t2, r), u2 = ["*"].concat(a2.concat([s2]));
      return u2 = simplify(u2), r.push("And so \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(u2) + "\\)."), u2;
    }
    r.push("Using the product rule, \\(" + i2 + astToLatex.convert(n) + " = " + o.map((function(e4, t22) {
      return o.map((function(r2, n3) {
        return t22 === n3 ? i2 + "\\left(" + astToLatex.convert(e4) + "\\right)" : astToLatex.convert(r2);
      })).join(" \\cdot ");
    })).join(" + ") + "\\).");
    let s = o.slice(), u = ["+"].concat(o.map((function(e4, n3) {
      return ["*"].concat(s.map((function(e5, i22) {
        if (n3 === i22) {
          let n4 = derivative(e5, t2, r);
          return 1 === n4 ? null : n4;
        }
        return e5;
      })).filter((function(e5) {
        return null != e5;
      })));
    })));
    return u = simplify(u), r.push("So using the product rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(u) + "\\)."), u;
  }
  if ("/" === a) {
    let e3 = o[0], a2 = o[1];
    if (variables(a2).indexOf(t2) < 0) {
      r.push("By the constant multiple rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(["/", 1, a2]) + " \\cdot " + i2 + "\\left(" + astToLatex.convert(e3) + "\\right)\\).");
      let o2 = derivative(e3, t2, r), s2 = textToAst$2.convert("(1/g)*d"), u2 = substitute$1(s2, { d: o2, g: a2 });
      return u2 = simplify(u2), r.push("So \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(u2) + "\\)."), u2;
    }
    if (variables(e3).indexOf(t2) < 0) {
      1 !== e3 && r.push("By the constant multiple rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(e3) + " \\cdot " + i2 + "\\left(" + astToLatex.convert(["/", 1, a2]) + "\\right)\\)."), r.push("Since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(e3) + "\\cdot \\frac{-1}{ " + astToLatex.convert(a2) + "^2} \\cdot " + i2 + astToLatex.convert(a2) + "\\).");
      let o2 = derivative(a2, t2, r), s2 = textToAst$2.convert("f * (-a/(g^2))"), u2 = substitute$1(s2, { f: e3, a: o2, g: a2 });
      return u2 = simplify(u2), r.push("So since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(u2) + "\\)."), u2;
    }
    r.push("Using the quotient rule, \\(" + i2 + astToLatex.convert(n) + " = \\frac{" + i2 + "\\left(" + astToLatex.convert(e3) + "\\right) \\cdot " + astToLatex.convert(a2) + " - " + astToLatex.convert(e3) + "\\cdot " + i2 + "\\left(" + astToLatex.convert(a2) + "\\right)}{ \\left( " + astToLatex.convert(a2) + " \\right)^2} \\).");
    let s = derivative(e3, t2, r), u = derivative(a2, t2, r), c2 = textToAst$2.convert("(a * g - f * b)/(g^2)"), l = substitute$1(c2, { a: s, b: u, f: e3, g: a2 });
    return l = simplify(l), r.push("So using the quotient rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(l) + "\\)."), l;
  }
  if ("^" === a) {
    let e3 = o[0], a2 = o[1];
    if (variables(a2).indexOf(t2) < 0) {
      if ("string" == typeof e3 && "x" === e3) {
        if ("number" == typeof a2) {
          let t3 = textToAst$2.convert("n * (f^m)"), o4 = substitute$1(t3, { n: a2, m: a2 - 1, f: e3 });
          return o4 = simplify(o4), r.push("By the power rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(a2) + " \\cdot \\left(" + astToLatex.convert(e3) + "\\right)^{" + astToLatex.convert(["-", a2, 1]) + "}\\)."), o4;
        }
        let t22 = textToAst$2.convert("n * (f^(n-1))"), o3 = substitute$1(t22, { n: a2, f: e3 });
        return o3 = simplify(o3), r.push("By the power rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(a2) + " \\cdot \\left(" + astToLatex.convert(e3) + "\\right)^{" + astToLatex.convert(["-", a2, 1]) + "}\\)."), o3;
      }
      1 !== a2 && r.push("By the power rule and the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(a2) + " \\cdot \\left(" + astToLatex.convert(e3) + "\\right)^{" + astToLatex.convert(["-", a2, 1]) + "} \\cdot " + i2 + astToLatex.convert(e3) + "\\).");
      let o2 = derivative(e3, t2, r);
      if (1 === a2) return o2;
      if ("number" == typeof a2) {
        let t22 = textToAst$2.convert("n * (f^m) * a"), s3 = substitute$1(t22, { n: a2, m: a2 - 1, f: e3, a: o2 });
        return s3 = simplify(s3), r.push("So by the power rule and the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(s3) + "\\)."), s3;
      }
      let s2 = textToAst$2.convert("n * (f^(n-1)) * a"), u2 = substitute$1(s2, { n: a2, f: e3, a: o2 });
      return u2 = simplify(u2), r.push("So by the power rule and the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(u2) + "\\)."), u2;
    }
    if ("e" === e3 && math$1.define_e) {
      if ("string" == typeof a2 && a2 === t2) {
        let e5 = textToAst$2.convert("e^(f)"), o3 = substitute$1(e5, { f: a2 });
        return o3 = simplify(o3), r.push("The derivative of \\(e^" + astToLatex.convert(t2) + "\\) is itself, that is, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(n) + "\\)."), o3;
      }
      r.push("Using the rule for \\(e^x\\) and the chain rule, we know \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(n) + " \\cdot " + i2 + astToLatex.convert(a2) + "\\).");
      let e4 = textToAst$2.convert("e^(f)*d"), o2 = derivative(a2, t2, r), s2 = substitute$1(e4, { f: a2, d: o2 });
      return s2 = simplify(s2), r.push("So using the rule for \\(e^x\\) and the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(s2) + "\\)."), s2;
    }
    if ("number" == typeof e3) {
      if ("string" == typeof a2 && a2 === t2) {
        let o3 = textToAst$2.convert("a^(f) * log(a)"), s3 = substitute$1(o3, { a: e3, f: a2 });
        return s3 = simplify(s3), r.push("The derivative of \\(a^" + astToLatex.convert(t2) + "\\) is \\(a^{" + astToLatex.convert(t2) + "} \\, \\log a\\), that is, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(s3) + "\\)."), s3;
      }
      let o2 = textToAst$2.convert("a^(f) * log(a)"), s2 = substitute$1(o2, { a: e3, f: a2 });
      r.push("Using the rule for \\(a^x\\) and the chain rule, we know \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(s2) + " \\cdot " + i2 + astToLatex.convert(a2) + "\\).");
      let u2 = textToAst$2.convert("a^(b)*log(a)*d"), c3 = derivative(a2, t2, r), l2 = substitute$1(u2, { a: e3, b: a2, d: c3 });
      return l2 = simplify(l2), r.push("So using the rule for \\(a^x\\) and the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(l2) + "\\)."), l2;
    }
    let s = e3, u = a2;
    r.push("Recall the general rule for exponents, namely that \\(\\frac{d}{dx} u(x)^{v(x)} = u(x)^{v(x)} \\cdot \\left( v'(x) \\cdot \\log u(x) + \\frac{v(x) \\cdot u'(x)}{u(x)} \\right)\\).  In this case, \\(u(x) = " + astToLatex.convert(s) + "\\) and \\(v(x) = " + astToLatex.convert(u) + "\\).");
    let c2 = derivative(s, t2, r), l = derivative(u, t2, r), f2 = textToAst$2.convert("(f^g)*(b * log(f) + (g * a)/f)"), p = substitute$1(f2, { a: c2, b: l, f: s, g: u });
    return p = simplify(p), r.push("So by the general rule for exponents, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(p) + "\\)."), p;
  }
  if ("apply" === a && !(o[0] in derivatives)) {
    let e3 = o[1];
    r.push("By the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(substitute$1(["apply", o[0] + "'", "x"], { x: e3 })) + " \\cdot " + i2 + astToLatex.convert(e3) + "\\).");
    let a2 = ["*", substitute$1(["apply", o[0] + "'", "x"], { x: e3 }), derivative(e3, t2, r)];
    return a2 = simplify(a2), r.push("So by the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(a2) + "\\)."), a2;
  }
  if ("apply" === a && o[0] in derivatives || a in derivatives) {
    let e3 = false;
    "apply" === a && (a = o[0], o = o.slice(1), e3 = true);
    let s = o[0];
    if ("number" == typeof s) {
      let e4 = 0;
      return r.push("The derivative of a constant is zero so \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(e4) + "\\)."), e4;
    }
    if ("string" == typeof s && s === t2) {
      let e4 = ["*", substitute$1(derivatives[a], { x: s })];
      return e4 = simplify(e4), r.push("It is the case that \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(e4) + "\\)."), e4;
    }
    if ("string" == typeof s && s !== t2) {
      let e4 = 0;
      return r.push("Since the derivative of a constant is zero, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(e4) + "\\)."), e4;
    }
    {
      let o2 = [a, "u"];
      e3 && (o2 = ["apply"].concat(o2)), r.push("Recall \\(\\frac{d}{du}" + astToLatex.convert(o2) + " = " + astToLatex.convert(derivative(o2, "u", [])) + "\\)."), r.push("By the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(substitute$1(derivatives[a], { x: s })) + " \\cdot " + i2 + astToLatex.convert(s) + "\\).");
      let u = ["*", substitute$1(derivatives[a], { x: s }), derivative(s, t2, r)];
      return u = simplify(u), r.push("So by the chain rule, \\(" + i2 + astToLatex.convert(n) + " = " + astToLatex.convert(u) + "\\)."), u;
    }
  }
  return 0;
}
function lowercaseFirstLetter(e2) {
  return e2.charAt(0).toLowerCase() + e2.slice(1);
}
function simplify_story(e2) {
  for (let t2 = e2.length - 1; t2 >= 1; t2--) e2[t2] === e2[t2 - 1] && e2.splice(t2, 1);
  for (let t2 = 0; t2 < e2.length; t2++) for (let r = t2 + 1; r < e2.length; r++) e2[t2] === e2[r] && (e2[r] = "Again, " + lowercaseFirstLetter(e2[r]));
  return e2;
}
function derivative_story(e2, t2) {
  var r = [];
  return derivative(e2, t2, r), r = simplify_story(r);
}
const derivativeStory = derivative_story;
var differentiation = Object.freeze({ __proto__: null, derivative, derivative_story, derivativeStory });
const unicode_operators = { "+": function(e2) {
  return e2.join(" ");
}, "-": function(e2) {
  return "-" + e2[0];
}, "*": function(e2) {
  return e2.join(" ");
}, "/": function(e2) {
  return e2[0] + "/" + e2[1];
}, _: function(e2) {
  return e2[0] + "_" + e2[1];
}, "^": function(e2) {
  return e2[0] + "^" + e2[1];
}, prime: function(e2) {
  return e2[0] + "'";
}, tuple: function(e2) {
  return "( " + e2.join(", ") + " )";
}, array: function(e2) {
  return "[ " + e2.join(", ") + " ]";
}, list: function(e2) {
  return e2.join(", ");
}, set: function(e2) {
  return "{ " + e2.join(", ") + " }";
}, vector: function(e2) {
  return "( " + e2.join(", ") + " )";
}, altvector: function(e2) {
  return "⟨ " + e2.join(", ") + " ⟩";
}, interval: function(e2) {
  return "( " + e2.join(", ") + " )";
}, matrix: function(e2) {
  return "( " + e2.join(", ") + " )";
}, and: function(e2) {
  return e2.join(" and ");
}, or: function(e2) {
  return e2.join(" or ");
}, not: function(e2) {
  return "not " + e2[0];
}, "=": function(e2) {
  return e2.join(" = ");
}, "<": function(e2) {
  return e2.join(" < ");
}, ">": function(e2) {
  return e2.join(" > ");
}, lts: function(e2) {
  return e2.join(" < ");
}, gts: function(e2) {
  return e2.join(" > ");
}, le: function(e2) {
  return e2.join(" ≤ ");
}, ge: function(e2) {
  return e2.join(" ≥ ");
}, ne: function(e2) {
  return e2.join(" ≠ ");
}, forall: function(e2) {
  return "∀ " + e2[0];
}, exists: function(e2) {
  return "∃ " + e2[0];
}, in: function(e2) {
  return e2[0] + " ∈ " + e2[1];
}, notin: function(e2) {
  return e2[0] + " ∉ " + e2[1];
}, ni: function(e2) {
  return e2[0] + " ∋ " + e2[1];
}, notni: function(e2) {
  return e2[0] + " ∌ " + e2[1];
}, subset: function(e2) {
  return e2[0] + " ⊂ " + e2[1];
}, subseteq: function(e2) {
  return e2[0] + " ⊆ " + e2[1];
}, notsubset: function(e2) {
  return e2[0] + " ⊄ " + e2[1];
}, notsubseteq: function(e2) {
  return e2[0] + " ⊈ " + e2[1];
}, superset: function(e2) {
  return e2[0] + " ⊃ " + e2[1];
}, superseteq: function(e2) {
  return e2[0] + " ⊇ " + e2[1];
}, notsuperset: function(e2) {
  return e2[0] + " ⊅ " + e2[1];
}, notsuperseteq: function(e2) {
  return e2[0] + " ⊉ " + e2[1];
}, union: function(e2) {
  return e2.join(" ∪ ");
}, intersect: function(e2) {
  return e2.join(" ∩ ");
}, rightarrow: function(e2) {
  return e2.join(" → ");
}, leftarrow: function(e2) {
  return e2.join(" ← ");
}, leftrightarrow: function(e2) {
  return e2.join(" ↔ ");
}, implies: function(e2) {
  return e2.join(" ⟹ ");
}, impliedby: function(e2) {
  return e2.join(" ⟸ ");
}, iff: function(e2) {
  return e2.join(" ⟺ ");
}, perp: function(e2) {
  return e2.join(" ⟂ ");
}, parallel: function(e2) {
  return e2.join(" ∥ ");
}, derivative_leibniz: function(e2) {
  return "d" + e2[0] + "/d" + e2[1];
}, partial_derivative_leibniz: function(e2) {
  return "∂" + e2[0] + "/∂" + e2[1];
}, "|": function(e2) {
  return e2[0] + " | " + e2[1];
}, ":": function(e2) {
  return e2[0] + " : " + e2[1];
}, binom: function(e2) {
  return "binom( " + e2[0] + ", " + e2[1] + " )";
}, vec: function(e2) {
  return "vec(" + e2[0] + ")";
}, linesegment: function(e2) {
  return "linesegment( " + e2.join(", ") + " )";
}, angle: function(e2, t2) {
  return t2 ? "∠" + e2.join("") : "∠( " + e2.join(", ") + " )";
}, unit: function(e2) {
  return e2[0] + " " + e2[1];
} }, nonunicode_operators = { "+": function(e2) {
  return e2.join(" ");
}, "-": function(e2) {
  return "-" + e2[0];
}, "*": function(e2) {
  return e2.join(" ");
}, "/": function(e2) {
  return e2[0] + "/" + e2[1];
}, _: function(e2) {
  return e2[0] + "_" + e2[1];
}, "^": function(e2) {
  return e2[0] + "^" + e2[1];
}, prime: function(e2) {
  return e2[0] + "'";
}, tuple: function(e2) {
  return "( " + e2.join(", ") + " )";
}, array: function(e2) {
  return "[ " + e2.join(", ") + " ]";
}, list: function(e2) {
  return e2.join(", ");
}, set: function(e2) {
  return "{ " + e2.join(", ") + " }";
}, vector: function(e2) {
  return "( " + e2.join(", ") + " )";
}, altvector: function(e2) {
  return "( " + e2.join(", ") + " )";
}, interval: function(e2) {
  return "( " + e2.join(", ") + " )";
}, matrix: function(e2) {
  return "( " + e2.join(", ") + " )";
}, and: function(e2) {
  return e2.join(" and ");
}, or: function(e2) {
  return e2.join(" or ");
}, not: function(e2) {
  return "not " + e2[0];
}, "=": function(e2) {
  return e2.join(" = ");
}, "<": function(e2) {
  return e2.join(" < ");
}, ">": function(e2) {
  return e2.join(" > ");
}, lts: function(e2) {
  return e2.join(" < ");
}, gts: function(e2) {
  return e2.join(" > ");
}, le: function(e2) {
  return e2.join(" <= ");
}, ge: function(e2) {
  return e2.join(" >= ");
}, ne: function(e2) {
  return e2.join(" ne ");
}, forall: function(e2) {
  return "forall " + e2[0];
}, exists: function(e2) {
  return "exists " + e2[0];
}, in: function(e2) {
  return e2[0] + " elementof " + e2[1];
}, notin: function(e2) {
  return e2[0] + " notelementof " + e2[1];
}, ni: function(e2) {
  return e2[0] + " containselement " + e2[1];
}, notni: function(e2) {
  return e2[0] + " notcontainselement " + e2[1];
}, subset: function(e2) {
  return e2[0] + " subset " + e2[1];
}, subseteq: function(e2) {
  return e2[0] + " subseteq " + e2[1];
}, notsubset: function(e2) {
  return e2[0] + " notsubset " + e2[1];
}, notsubseteq: function(e2) {
  return e2[0] + " notsubseteq " + e2[1];
}, superset: function(e2) {
  return e2[0] + " superset " + e2[1];
}, superseteq: function(e2) {
  return e2[0] + " superseteq " + e2[1];
}, notsuperset: function(e2) {
  return e2[0] + " notsuperset " + e2[1];
}, notsuperseteq: function(e2) {
  return e2[0] + " notsuperseteq " + e2[1];
}, union: function(e2) {
  return e2.join(" union ");
}, intersect: function(e2) {
  return e2.join(" intersect ");
}, rightarrow: function(e2) {
  return e2.join(" rightarrow ");
}, leftarrow: function(e2) {
  return e2.join(" leftarrow ");
}, leftrightarrow: function(e2) {
  return e2.join(" leftrightarrow ");
}, implies: function(e2) {
  return e2.join(" implies ");
}, impliedby: function(e2) {
  return e2.join(" impliedby ");
}, iff: function(e2) {
  return e2.join(" iff ");
}, perp: function(e2) {
  return e2.join(" perp ");
}, parallel: function(e2) {
  return e2.join(" parallel ");
}, derivative_leibniz: function(e2) {
  return "d" + e2[0] + "/d" + e2[1];
}, partial_derivative_leibniz: function(e2) {
  return "∂" + e2[0] + "/∂" + e2[1];
}, "|": function(e2) {
  return e2[0] + " | " + e2[1];
}, ":": function(e2) {
  return e2[0] + " : " + e2[1];
}, binom: function(e2) {
  return "binom( " + e2[0] + ", " + e2[1] + " )";
}, vec: function(e2) {
  return "vec(" + e2[0] + ")";
}, linesegment: function(e2) {
  return "linesegment( " + e2.join(", ") + " )";
}, angle: function(e2, t2) {
  return t2 ? "angle " + e2.join("") : "angle( " + e2.join(", ") + " )";
}, unit: function(e2) {
  return e2[0] + " " + e2[1];
} }, output_unicodeDefault = true;
class astToText$2 {
  constructor({ output_unicode: e2 = output_unicodeDefault, padToDigits: t2 = null, padToDecimals: r = null, showBlanks: n = true } = {}) {
    this.output_unicode = e2, this.operators = unicode_operators, e2 || (this.operators = nonunicode_operators), this.padToDigits = t2, this.padToDecimals = r, this.showBlanks = n;
  }
  convert(e2) {
    return this.statement(e2);
  }
  statement(e2) {
    if (!Array.isArray(e2)) return this.single_statement(e2);
    let t2 = e2[0], r = e2.slice(1);
    if ("ldots" === t2) return "...";
    if (!(t2 in this.operators) && "apply" !== t2) throw new Error("Badly formed ast: operator " + t2 + " not recognized.");
    return ["implies", "impliedby", "iff", "rightarrow", "leftarrow", "leftrightarrow"].includes(t2) ? this.operators[t2](r.map(((e3) => this.statement(e3)))) : "and" === t2 || "or" === t2 ? this.operators[t2](r.map((function(e3, t22) {
      let r2 = this.single_statement(e3);
      return r2.match(/ /) && !r2.match(/^\(.*\)$/) ? "(" + r2 + ")" : r2;
    }).bind(this))) : this.single_statement(e2);
  }
  single_statement(e2) {
    if (!Array.isArray(e2)) return this.expression(e2);
    let t2 = e2[0], r = e2.slice(1);
    if ("not" === t2) return this.operators[t2](r.map((function(e3, t22) {
      let r2 = this.single_statement(e3);
      return r2.match(/ /) && !r2.match(/^\(.*\)$/) ? "(" + r2 + ")" : r2;
    }).bind(this)));
    if ("exists" === t2 || "forall" === t2) return this.operators[t2]([this.single_statement(r[0])]);
    if ("=" === t2 || "ne" === t2 || "<" === t2 || ">" === t2 || "le" === t2 || "ge" === t2 || "in" === t2 || "notin" === t2 || "ni" === t2 || "notni" === t2 || "subset" === t2 || "notsubset" === t2 || "subseteq" === t2 || "notsubseteq" === t2 || "superset" === t2 || "notsuperset" === t2 || "superseteq" === t2 || "notsuperseteq" === t2) return this.operators[t2](r.map((function(e3, t22) {
      return this.expression(e3);
    }).bind(this)));
    if ("lts" === t2 || "gts" === t2) {
      let e3 = r[0], n = r[1];
      if ("tuple" !== e3[0] || "tuple" !== n[0]) throw new Error("Badly formed ast");
      let i2 = this.expression(e3[1]);
      for (let r2 = 1; r2 < e3.length - 1; r2++) n[r2] ? i2 += "lts" === t2 ? " < " : " > " : "lts" === t2 ? this.output_unicode ? i2 += " ≤ " : i2 += " <= " : this.output_unicode ? i2 += " ≥ " : i2 += " >= ", i2 += this.expression(e3[r2 + 1]);
      return i2;
    }
    return this.expression(e2);
  }
  expression(e2) {
    if (!Array.isArray(e2)) return this.term(e2);
    let t2 = e2[0], r = e2.slice(1);
    return "+" === t2 ? 1 === r.length ? "+" + this.term(r[0]) : this.operators[t2](r.map((function(e3, t22) {
      return t22 > 0 ? this.termWithPlusIfNotNegated(e3) : this.term(e3);
    }).bind(this))) : ["union", "intersect", "perp", "parallel"].includes(t2) ? this.operators[t2](r.map((function(e3, t22) {
      return this.term(e3);
    }).bind(this))) : this.term(e2);
  }
  term(e2) {
    if (!Array.isArray(e2)) return this.factor(e2);
    let t2 = e2[0], r = e2.slice(1);
    if ("-" === t2) return this.operators[t2](r.map((function(e3, t22) {
      return this.term(e3);
    }).bind(this)));
    if ("*" === t2) return this.operators[t2](r.map((function(e3, t22) {
      let n;
      return t22 > 0 ? (n = this.factorWithParenthesesIfNegatedOrExplicitPlus(e3), n.match(/^[0-9]/) ? "* " + n : "angle" === e3[0] && r.length > 1 ? "( " + n + " )" : n) : (n = this.factor(e3), "angle" === e3[0] && r.length > 1 ? "( " + n + " )" : n);
    }).bind(this)));
    if ("/" === t2) {
      let e3 = this.factor(r[0]), n = this.factor(r[1]);
      return this.simple_factor_or_function_or_parens(r[0]) || (e3 = "(" + e3 + ")"), this.simple_factor_or_function_or_parens(r[1]) || (n = "(" + n + ")"), this.operators[t2]([e3, n]);
    }
    return "unit" === t2 ? this.operators[t2](r.map((function(e3, t22) {
      return this.expression(e3);
    }).bind(this))) : this.factor(e2);
  }
  symbolConvert(e2) {
    let t2 = { alpha: "α", beta: "β", Gamma: "Γ", gamma: "γ", Delta: "Δ", delta: "δ", epsilon: "ε", zeta: "ζ", eta: "η", Theta: "ϴ", theta: "θ", iota: "ι", kappa: "κ", Lambda: "Λ", lambda: "λ", mu: "μ", nu: "ν", Xi: "Ξ", xi: "ξ", Pi: "Π", pi: "π", rho: "ρ", Sigma: "Σ", sigma: "σ", tau: "τ", Upsilon: "Υ", upsilon: "υ", Phi: "Φ", phi: "ϕ", Psi: "Ψ", psi: "ψ", Omega: "Ω", omega: "ω", perp: "⟂", int: "∫", emptyset: "∅" };
    return this.output_unicode && e2 in t2 ? t2[e2] : this.showBlanks || "＿" !== e2 ? e2 : "";
  }
  simple_factor_or_function_or_parens(e2) {
    let t2 = this.factor(e2);
    return !!(t2.length <= 1 || "string" == typeof e2 && e2.match(/^\w+$/) || Array.isArray(e2) && "apply" === e2[0] || t2.match(/^\(.*\)$/) || t2.match(/^⟨.*⟩$/)) || "number" == typeof e2 && (e2 >= 0 && !e2.toString().includes("e"));
  }
  factor(e2) {
    if ("string" == typeof e2) return this.symbolConvert(e2);
    if ("number" == typeof e2) {
      if (e2 === 1 / 0) return this.output_unicode ? "∞" : "infinity";
      if (e2 === -1 / 0) return this.output_unicode ? "-∞" : "-infinity";
      if (Number.isNaN(e2)) return "NaN";
      {
        let t22 = e2.toString(), r2 = t22.indexOf("e");
        if (-1 === r2) return null === this.padToDigits && null === this.padToDecimals || (t22 = padNumberStringToDigitsAndDecimals(t22, this.padToDigits, this.padToDecimals)), t22;
        let n = t22.substring(0, r2), i2 = t22.substring(r2 + 1);
        if (null !== this.padToDigits || null !== this.padToDecimals) {
          let r3 = Number(i2);
          if (r3 > 0 && null !== this.padToDecimals) return t22 = e2.toLocaleString("fullwide", { useGrouping: false }), padNumberStringToDigitsAndDecimals(t22, this.padToDigits, this.padToDecimals);
          {
            let e3 = null;
            null !== this.padToDecimals && (e3 = this.padToDecimals + r3), n = padNumberStringToDigitsAndDecimals(n, this.padToDigits, e3);
          }
        }
        return "+" === i2[0] ? n + " * 10^" + i2.substring(1) : n + " * 10^(" + i2 + ")";
      }
    }
    if (!Array.isArray(e2)) return "";
    let t2 = e2[0], r = e2.slice(1);
    if ("^" === t2) {
      if (Number.isInteger(r[0]) && Number.isInteger(r[1])) {
        let e4;
        return e4 = r[0] < 0 ? "(" + r[0].toString() + ")" : r[0].toString(), r[1] < 0 ? e4 + "^(" + r[1].toString() + ")" : e4 + "^" + r[1].toString();
      }
      let e3 = this.factor(r[0]), t22 = r[0];
      for (; "prime" === t22[0]; ) t22 = t22[1];
      this.simple_factor_or_function_or_parens(t22) || "_" === t22[0] && "string" == typeof t22[1] || (e3 = "(" + e3.toString() + ")");
      let n = this.factor(r[1]);
      return this.simple_factor_or_function_or_parens(r[1]) || (n = "(" + n.toString() + ")"), e3 + "^" + n;
    }
    if ("_" === t2) return this.operators[t2](r.map((function(e3, t22) {
      let r2 = this.factor(e3);
      return this.simple_factor_or_function_or_parens(e3) ? r2 : "(" + r2 + ")";
    }).bind(this)));
    if ("prime" === t2) {
      let e3 = r[0], t22 = 1;
      for (; "prime" === e3[0]; ) t22 += 1, e3 = e3[1];
      let n = this.factor(e3);
      this.simple_factor_or_function_or_parens(e3) || "_" === e3[0] && "string" == typeof e3[1] || (n = "(" + n + ")");
      for (let e4 = 0; e4 < t22; e4++) n += "'";
      return n;
    }
    if ("-" === t2) return this.operators[t2](r.map((function(e3, t22) {
      return this.factor(e3);
    }).bind(this)));
    if ("tuple" === t2 || "array" === t2 || "list" === t2 || "set" === t2 || "vector" === t2 || "altvector" === t2 || "|" === t2 || ":" === t2 || "binom" === t2 || "vec" === t2 || "linesegment" === t2) return this.operators[t2](r.map((function(e3, t22) {
      return this.statement(e3);
    }).bind(this)));
    if ("interval" === t2) {
      let e3 = r[0], t22 = r[1];
      if ("tuple" !== e3[0] || "tuple" !== t22[0]) throw new Error("Badly formed ast");
      let n = this.statement(e3[1]) + ", " + this.statement(e3[2]);
      return n = t22[1] ? "[ " + n : "( " + n, t22[2] ? n += " ]" : n += " )", n;
    }
    if ("matrix" === t2) {
      let e3 = r[0], t22 = r[1], n = "[ ";
      for (let r2 = 0; r2 < e3[1]; r2 += 1) {
        n += "[ ";
        for (let i2 = 0; i2 < e3[2]; i2 += 1) n += this.statement(t22[r2 + 1][i2 + 1]), i2 < e3[2] - 1 && (n += ","), n += " ";
        n += "]", r2 < e3[1] - 1 && (n += ","), n += " ";
      }
      return n += "]", n;
    }
    if ("derivative_leibniz" === t2 || "partial_derivative_leibniz" === t2) {
      let e3 = "d";
      "partial_derivative_leibniz" === t2 && (e3 = "∂");
      let n = r[0], i2 = r[1], a = 1, o = "";
      Array.isArray(n) ? (o = n[1], a = n[2]) : o = n;
      let s = e3;
      a > 1 && (s = s + "^" + a), s = s + this.symbolConvert(o) + "/";
      let u = 1;
      Array.isArray(i2) && (u = i2.length - 1);
      for (let t22 = 1; t22 <= u; t22++) {
        let r2 = i2[t22], n3 = 1, a2 = "";
        Array.isArray(r2) ? (a2 = r2[1], n3 = r2[2]) : a2 = r2, s = s + e3 + this.symbolConvert(a2), n3 > 1 && (s = s + "^" + n3);
      }
      return s;
    }
    if ("apply" === t2) {
      if ("abs" === r[0]) return "|" + this.statement(r[1]) + "|";
      if ("factorial" === r[0]) {
        let e4 = this.factor(r[1]);
        return this.simple_factor_or_function_or_parens(r[1]) || "_" === r[1][0] && "string" == typeof r[1][1] ? e4 + "!" : "(" + e4 + ")!";
      }
      let e3 = r[0];
      if ("^" === e3[0] && (e3 = e3[1]), "_" === e3[0] && (e3 = e3[1]), "int" === e3) {
        let e4, t3 = this.factor(r[0]), n3 = r[1];
        if (Array.isArray(n3) && "*" === n3[0]) {
          let t4 = [], r2 = ["*"];
          for (let e5 = 1; e5 < n3.length; e5++) {
            let i2 = n3[e5];
            Array.isArray(i2) && "d" === i2[0] ? t4.push(i2) : r2.push(i2);
          }
          e4 = this.term(r2), t4.length > 0 && (e4 += " " + t4.map(((e5) => "d" + this.factor(e5[1]))).join(" "));
        }
        return e4 || (e4 = this.term(r[1])), t3 + " " + e4;
      }
      let t22 = this.factor(r[0]), n = this.statement(r[1]);
      return "tuple" !== r[1][0] && (n = "(" + n + ")"), t22 + n;
    }
    if ("angle" === t2) {
      let e3 = r.every(((e4) => {
        if ("string" == typeof e4 && 1 === e4.length) return true;
        if (!Array.isArray(e4)) return false;
        let t22 = e4[0];
        return "_" === t22 || "^" === t22 || "prime" === t22;
      }));
      return this.operators[t2](r.map((function(e4, t22) {
        return this.statement(e4);
      }).bind(this)), e3);
    }
    return "+" === t2 && 2 === e2.length ? "+ " + this.factor(e2[1]) : "(" + this.statement(e2) + ")";
  }
  factorWithParenthesesIfNegatedOrExplicitPlus(e2) {
    var t2 = this.factor(e2);
    return t2.match(/^-/) || t2.match(/^\+/) ? "(" + t2 + ")" : t2;
  }
  termWithPlusIfNotNegated(e2) {
    let t2 = this.term(e2);
    return t2.match(/^-/) ? t2.match(/^-[^ ]/) ? "- " + t2.slice(1) : t2 : "+ " + t2;
  }
}
var astToText$1 = new astToText$2();
function subscripts_to_strings(e2, t2 = false) {
  var r = get_tree(e2);
  if (!Array.isArray(r)) return r;
  let n = r[0], i2 = r.slice(1);
  return "_" === n && (t2 || i2.every(((e3) => ["number", "string"].includes(typeof e3)))) ? astToText$1.convert(r) : [n].concat(i2.map(((e3) => subscripts_to_strings(e3, t2))));
}
function strings_to_subscripts(e2) {
  var t2 = get_tree(e2);
  if ("string" == typeof t2) {
    let e3 = t2.match(/^([0-9a-zA-Z]+)_([a-zA-Z]+|[0-9]+)$/);
    if (e3) {
      let t22 = Number(e3[1]);
      isNaN(t22) && (t22 = e3[1]);
      let r2 = Number(e3[2]);
      return isNaN(r2) && (r2 = e3[2]), ["_", t22, r2];
    }
    return t2;
  }
  if (!Array.isArray(t2)) return t2;
  let r = t2[0], n = t2.slice(1);
  return [r].concat(n.map(strings_to_subscripts));
}
var normalization = Object.freeze({ __proto__: null, normalize_function_names, normalize_applied_functions, log_subscript_to_two_arg_log, substitute_abs, default_order, constants_to_floats, normalize_angle_linesegment_arg_order, normalize_negative_numbers, tuples_to_vectors, to_intervals, altvectors_to_vectors, subscripts_to_strings, strings_to_subscripts }), astToText = new astToText$2();
function generate_random_integer(e2, t2, r) {
  return e2 = math$1.ceil(e2), t2 = math$1.floor(t2), math$1.floor(r() * (t2 - e2 + 1)) + e2;
}
const equals$6 = function({ expr: e2, other: t2, randomBindings: r, expr_context: n, other_context: i2, relative_tolerance: a = 1e-12, absolute_tolerance: o = 0, tolerance_for_zero: s = 1e-15, allowed_error_in_numbers: u = 0, include_error_in_number_exponents: c2 = false, allowed_error_is_absolute: l = false, coerce_tuples_arrays: f2 = true, coerce_vectors: p = true, rng: m }) {
  if (Array.isArray(e2.tree) && Array.isArray(t2.tree)) {
    let d = e2.tree[0], h = e2.tree.slice(1), g = t2.tree[0], y = t2.tree.slice(1);
    if ("tuple" === d || "vector" === d || "altvector" === d || "list" === d || "array" === d || "matrix" === d || "interval" === d) {
      if (g !== d && ({ operator1: d, operator2: g, operands1: h, operands2: y } = coerce_tuple_array_vectors({ operator1: d, operator2: g, operands1: h, operands2: y, coerce_tuples_arrays: f2, coerce_vectors: p })), g !== d) return false;
      if (y.length !== h.length) return false;
      for (let e3 = 0; e3 < h.length; e3++) if (!equals$6({ expr: n.fromAst(h[e3]), other: i2.fromAst(y[e3]), randomBindings: r, expr_context: n, other_context: i2, relative_tolerance: a, absolute_tolerance: o, tolerance_for_zero: s, allowed_error_in_numbers: u, include_error_in_number_exponents: c2, allowed_error_is_absolute: l, coerce_tuples_arrays: f2, coerce_vectors: p, rng: m })) return false;
      return true;
    }
    if (2 === h.length && ["=", ">", "<", "ge", "le"].includes(d)) {
      if (2 !== y.length) return false;
      if (">" === d ? (d = "<", h = [h[1], h[0]]) : "ge" === d && (d = "le", h = [h[1], h[0]]), ">" === g ? (g = "<", y = [y[1], y[0]]) : "ge" === g && (g = "le", y = [y[1], y[0]]), d !== g) return false;
      let e3 = ["+", h[0], ["-", h[1]]], t22 = ["+", y[0], ["-", y[1]]], v2 = "=" !== d;
      return component_equals$1({ expr: n.fromAst(e3), other: i2.fromAst(t22), randomBindings: r, expr_context: n, other_context: i2, allow_proportional: true, require_positive_proportion: v2, relative_tolerance: a, absolute_tolerance: o, tolerance_for_zero: s, allowed_error_in_numbers: u, include_error_in_number_exponents: c2, allowed_error_is_absolute: l, coerce_tuples_arrays: f2, coerce_vectors: p, rng: m });
    }
  }
  return component_equals$1({ expr: e2, other: t2, randomBindings: r, expr_context: n, other_context: i2, relative_tolerance: a, absolute_tolerance: o, tolerance_for_zero: s, allowed_error_in_numbers: u, include_error_in_number_exponents: c2, allowed_error_is_absolute: l, coerce_tuples_arrays: f2, coerce_vectors: p, rng: m });
}, component_equals$1 = function({ expr: e2, other: t2, randomBindings: r, expr_context: n, other_context: i2, allow_proportional: a = false, require_positive_proportion: o = false, relative_tolerance: s, absolute_tolerance: u, tolerance_for_zero: c2, allowed_error_in_numbers: l, include_error_in_number_exponents: f2, allowed_error_is_absolute: p, coerce_tuples_arrays: m, coerce_vectors: d, rng: h }) {
  var g, y, v2, x2 = 1e-20 * Number.MAX_VALUE;
  ({ variables: g, integer_variables: y, functions: v2, expr: e2, other: t2 } = prepare_exprs_numerical_eval(e2, t2, n, i2));
  try {
    var b2 = e2.f(), _2 = t2.f();
  } catch (a2) {
    if (e2.equalsViaSyntax(t2, { allow_blanks: true, allowed_error_in_numbers: l, include_error_in_number_exponents: f2, allowed_error_is_absolute: p, coerce_tuples_arrays: m, coerce_vectors: d })) return true;
    if (!Array.isArray(e2.tree) || !Array.isArray(t2.tree)) return false;
    if (e2.tree[0] !== t2.tree[0]) return false;
    let o2 = e2.tree.slice(1), g2 = t2.tree.slice(1);
    for (let e3 = 0; e3 < o2.length; e3++) if (!equals$6({ expr: n.fromAst(o2[e3]), other: i2.fromAst(g2[e3]), randomBindings: r, expr_context: n, other_context: i2, relative_tolerance: s, absolute_tolerance: u, tolerance_for_zero: c2, allowed_error_in_numbers: l, include_error_in_number_exponents: f2, allowed_error_is_absolute: p, coerce_tuples_arrays: m, coerce_vectors: d, rng: h })) return false;
    return true;
  }
  let w2, A2, N;
  if (l > 0) {
    let t22 = replace_numbers_with_parameters({ expr: e2, variables: g, include_exponents: f2 });
    w2 = n.fromAst(t22.expr_with_params), A2 = t22.parameters;
    let r2 = Object.keys(A2);
    if (r2.length > 0) {
      let e3 = w2.derivative(r2[0]);
      if (p || (e3 = e3.multiply(A2[r2[0]])), r2.length > 1) for (let t4 of r2.slice(1)) {
        let r3 = w2.derivative(t4);
        p || (r3 = r3.multiply(A2[t4])), e3 = e3.add(r3);
      }
      let t3 = e3.multiply(l);
      try {
        N = t3.f();
      } catch (e4) {
      }
    }
  }
  var D = [10, 1, 100, 0.1, 1e3, 0.01], E = 0;
  let $2 = 0, S2 = true, C2 = 0;
  for (let e3 = 0; e3 < 1e3; e3++) {
    try {
      var M2 = T2(D[E], h);
    } catch (e4) {
      continue;
    }
    if (false === M2.always_zero && (S2 = false), !M2.equal && !M2.out_of_bounds && !M2.always_zero && false !== M2.sufficient_finite_values && (C2++, C2 > 100)) return false;
    if (M2.equal) {
      if (M2.always_zero) {
        if (!S2) continue;
        if ($2 += 1, $2 > 5 && (E += 1, $2 = 0), E >= D.length) return true;
        continue;
      }
      return true;
    }
  }
  return false;
  function T2(e3, t22) {
    var n3, i22 = r(t22, g, e3);
    for (let e4 = 0; e4 < y.length; e4++) i22[y[e4]] = generate_random_integer(-10, 10, t22);
    for (let e4 = 0; e4 < v2.length; e4++) {
      let r2 = 1 * (t22() - 0.5), n4 = 2 * (t22() - 0.5), a2 = 6 * (t22() - 0.5), o2 = 24 * (t22() - 0.5);
      i22[v2[e4]] = function(e5) {
        return math$1.add(math$1.multiply(math$1.add(math$1.multiply(math$1.add(math$1.multiply(r2, e5), n4), e5), a2), e5), o2);
      };
    }
    N && (n3 = Object.assign({}, i22, A2));
    var l2 = b2(i22), f3 = _2(i22);
    if ("boolean" == typeof l2 || "boolean" == typeof f3) return { out_of_bounds: true, always_zero: false };
    var p2 = math$1.abs(l2), m2 = math$1.abs(f3);
    if (!(p2 < x2 && m2 < x2)) return { out_of_bounds: true, always_zero: false };
    if (!(0 === p2 || p2 > 0) || !(0 === m2 || m2 > 0)) return { out_of_bounds: true, always_zero: false };
    var d2 = Math.min(p2, m2), h2 = Math.max(p2, m2), w22 = 1;
    let D2 = 0;
    if (N) {
      try {
        D2 = math$1.abs(N(n3));
      } catch (e4) {
        return { equal_at_start: false, always_zero: false };
      }
      if (!Number.isFinite(D2)) return { equal_at_start: false, always_zero: false };
    }
    if (D2 += d2 * s, D2 = Math.min(D2, 0.1 * d2), D2 += 0 !== D2 || 0 !== l2 && 0 !== f3 ? u : c2, !(0 === h2 || math$1.abs(math$1.subtract(l2, f3)) < D2)) {
      if (!a) return { equal_at_start: false, always_zero: false };
      if (0 === p2 || 0 === m2) return { equal_at_start: false, always_zero: false };
      if (w22 = math$1.divide(l2, f3), o && !(w22 > 0)) return { equal_at_start: false, always_zero: false };
    }
    var E2 = 0 === h2, $22 = 0;
    for (let e4 = 0; e4 < 100; e4++) {
      var S22, C3 = r(t22, g, 0.01, i22);
      for (let e5 = 0; e5 < y.length; e5++) C3[y[e5]] = generate_random_integer(-10, 10, t22);
      for (let e5 = 0; e5 < v2.length; e5++) {
        let r2 = 1 * (t22() - 0.5), n4 = 2 * (t22() - 0.5), i3 = 6 * (t22() - 0.5), a2 = 24 * (t22() - 0.5);
        C3[v2[e5]] = function(e6) {
          return math$1.add(math$1.multiply(math$1.add(math$1.multiply(math$1.add(math$1.multiply(r2, e6), n4), e6), i3), e6), a2);
        };
      }
      N && (S22 = Object.assign({}, C3, A2));
      try {
        l2 = b2(C3), f3 = math$1.multiply(_2(C3), w22);
      } catch (e5) {
        continue;
      }
      if (p2 = math$1.abs(l2), m2 = math$1.abs(f3), p2 < x2 && m2 < x2) {
        d2 = Math.min(p2, m2), h2 = Math.max(p2, m2), $22++;
        let e5 = 0;
        if (N) {
          try {
            e5 = math$1.abs(N(S22));
          } catch (e6) {
            continue;
          }
          if (!Number.isFinite(e5)) continue;
        }
        if (e5 += d2 * s, e5 = Math.min(e5, 0.1 * d2), e5 += 0 !== e5 || 0 !== l2 && 0 !== f3 ? u : c2, !(0 === h2 || math$1.abs(math$1.subtract(l2, f3)) < e5)) return { equality_in_middle: false, always_zero: false };
        if (E2 = E2 && 0 === h2, $22 >= 10) return { equal: true, always_zero: E2 };
      }
    }
    return { sufficient_finite_values: false, always_zero: E2 };
  }
};
function prepare_exprs_numerical_eval(e2, t2, r, n) {
  r || (r = e2.context), n || (n = t2.context), { expr: e2, other: t2 } = normalize_for_equality_checking(e2, t2, r, n);
  var i2 = [.../* @__PURE__ */ new Set([...e2.variables(), ...t2.variables()])];
  math$1.define_pi && (i2 = i2.filter((function(e3) {
    return "pi" !== e3;
  }))), math$1.define_i && (i2 = i2.filter((function(e3) {
    return "i" !== e3;
  }))), math$1.define_e && (i2 = i2.filter((function(e3) {
    return "e" !== e3;
  })));
  var a = [];
  for (let e3 = 0; e3 < i2.length; e3++) (is_integer_ast(i2[e3], r.assumptions) || is_integer_ast(i2[e3], n.assumptions)) && a.push(i2[e3]);
  var o = [.../* @__PURE__ */ new Set([...e2.functions(), ...t2.functions()])].filter(((e3) => 1 === e3.length || e3.includes("_") || e3.includes("^"))), s = o.filter(((e3) => i2.includes(e3)));
  if (o = o.filter(((e3) => !i2.includes(e3))), s.length > 0) {
    let a2 = e2.tree, u = t2.tree, c2 = "x1";
    for (; [...o, ...i2].includes(c2); ) c2 += "x1";
    let l = "x2";
    for (; [...o, ...i2].includes(l); ) l += "x2";
    for (let e3 of s) {
      let t22 = e3 + e3;
      for (; [...o, ...i2].includes(t22); ) t22 += e3;
      let r2 = [[["apply", e3, c2], ["apply", t22, c2], { variables: { [c2]: true } }]];
      a2 = applyAllTransformations(a2, r2), u = applyAllTransformations(u, r2), o.push(t22);
    }
    e2 = r.fromAst(a2), t2 = n.fromAst(u);
  }
  return { variables: i2, integer_variables: a, functions: o, expr: e2, other: t2 };
}
function normalize_for_equality_checking(e2, t2, r, n) {
  r || (r = e2.context), n || (n = t2.context), e2 = e2.normalize_function_names(), t2 = t2.normalize_function_names(), e2 = e2.log_subscript_to_two_arg_log(), t2 = t2.log_subscript_to_two_arg_log(), e2 = e2.subscripts_to_strings(), t2 = t2.subscripts_to_strings(), e2 = e2.normalize_applied_functions(), t2 = t2.normalize_applied_functions();
  let i2 = rename_functions_with_exponents(e2.tree), a = rename_functions_with_exponents(t2.tree);
  return { expr: e2 = r.fromAst(rename_vecs(i2)), other: t2 = n.fromAst(rename_vecs(a)) };
}
function replace_numbers_with_parameters({ expr: e2, variables: t2, include_exponents: r = false }) {
  let n = {}, i2 = 0;
  function a() {
    i2++;
    let e3 = "par" + i2;
    for (; t2.includes(e3); ) i2++, e3 = "par" + i2;
    return e3;
  }
  return { expr_with_params: (function e3(t22) {
    if ("number" == typeof t22) {
      if (0 === t22) return t22;
      {
        let e4 = a();
        return n[e4] = t22, e4;
      }
    }
    if ("string" == typeof t22) {
      if ("pi" === t22) {
        if (math$1.define_pi) {
          let e4 = a();
          return n[e4] = math$1.PI, e4;
        }
      } else if ("e" === t22 && math$1.define_e) {
        let e4 = a();
        return n[e4] = math$1.e, e4;
      }
      return t22;
    }
    if (!Array.isArray(t22)) return t22;
    let i22 = t22[0], o = t22.slice(1);
    return "^" !== i22 || r ? [i22, ...o.map(e3)] : [i22, e3(o[0]), o[1]];
  })((e2 = e2.evaluate_numbers({ max_digits: 1 / 0 })).tree), parameters: n };
}
function rename_functions_with_exponents(e2) {
  if (!Array.isArray(e2)) return e2;
  let t2 = e2[0], r = e2.slice(1);
  if ("apply" === t2) {
    let e3 = r[0];
    return Array.isArray(e3) && "^" === e3[0] && e3.slice(1).every(((e4) => ["number", "string"].includes(typeof e4))) && (e3 = astToText.convert(e3)), ["apply", e3, r[1]];
  }
  return [t2, ...r.map(rename_functions_with_exponents)];
}
function rename_vecs(e2) {
  if (!Array.isArray(e2)) return e2;
  let t2 = e2[0], r = e2.slice(1);
  return "vec" === t2 && 1 === r.length ? "__vec_" + astToText.convert(r[0]) : [t2, ...r.map(rename_vecs)];
}
function randomComplexBindings(e2, t2, r, n) {
  var i2 = {};
  return void 0 === n ? t2.forEach((function(t22) {
    i2[t22] = math$1.complex(2 * e2() * r - r, 2 * e2() * r - r);
  })) : t2.forEach((function(t22) {
    i2[t22] = math$1.complex(n[t22].re + 2 * e2() * r - r, n[t22].im + 2 * e2() * r - r);
  })), i2;
}
const equals$5 = function(e2, t2, { relative_tolerance: r = 1e-12, absolute_tolerance: n = 0, tolerance_for_zero: i2 = 1e-15, allowed_error_in_numbers: a = 0, include_error_in_number_exponents: o = false, allowed_error_is_absolute: s = false, allow_blanks: u = false, coerce_tuples_arrays: c2 = true, coerce_vectors: l = true } = {}) {
  if (!u && (e2.variables().includes("＿") || t2.variables().includes("＿"))) return false;
  let f2 = seedrandom$1("complex_seed");
  return e2 = e2.remove_scaling_units(), t2 = t2.remove_scaling_units(), equals$6({ expr: e2, other: t2, randomBindings: randomComplexBindings, expr_context: e2.context, other_context: t2.context, relative_tolerance: r, absolute_tolerance: n, tolerance_for_zero: i2, allowed_error_in_numbers: a, include_error_in_number_exponents: o, allowed_error_is_absolute: s, coerce_tuples_arrays: c2, coerce_vectors: l, rng: f2 });
};
function randomRealBindings(e2, t2, r, n) {
  var i2 = {};
  return void 0 === n ? t2.forEach((function(t22) {
    i2[t22] = 2 * e2() * r - r;
  })) : t2.forEach((function(t22) {
    i2[t22] = n[t22] + 2 * e2() * r - r;
  })), i2;
}
const equals$4 = function(e2, t2, { relative_tolerance: r = 1e-12, absolute_tolerance: n = 0, tolerance_for_zero: i2 = 1e-15, allowed_error_in_numbers: a = 0, include_error_in_number_exponents: o = false, allowed_error_is_absolute: s = false } = {}) {
  if (!e2.isAnalytic() || !t2.isAnalytic()) return false;
  let u = seedrandom("real_seed");
  return equals$6({ expr: e2, other: t2, randomBindings: randomRealBindings, expr_context: e2.context, other_content: t2.context, relative_tolerance: r, absolute_tolerance: n, tolerance_for_zero: i2, allowed_error_in_numbers: a, include_error_in_number_exponents: o, allowed_error_is_absolute: s, rng: u });
}, equals$3 = function(e2, t2, { allowed_error_in_numbers: r = 0, include_error_in_number_exponents: n = false, allowed_error_is_absolute: i2 = false, allow_blanks: a = false, coerce_tuples_arrays: o = true, coerce_vectors: s = true } = {}) {
  if (!a && (e2.variables().includes("＿") || t2.variables().includes("＿"))) return false;
  let u = e2.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order(), c2 = t2.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order();
  return equal(u.tree, c2.tree, { allowed_error_in_numbers: r, include_error_in_number_exponents: n, allowed_error_is_absolute: i2, coerce_tuples_arrays: o, coerce_vectors: s });
};
function randomFiniteFieldBindings(e2, t2, r) {
  var n = {};
  return t2.forEach((function(t22) {
    n[t22] = Math.floor(e2() * r);
  })), n;
}
const equals$2 = function(e2, t2, { allow_blanks: r = false, coerce_tuples_arrays: n = true, coerce_vectors: i2 = true } = {}) {
  if (!r && (e2.variables().includes("＿") || t2.variables().includes("＿"))) return false;
  let a = seedrandom$1("finite_field_seed");
  if (Array.isArray(e2.tree) && Array.isArray(t2.tree)) {
    let r2 = e2.tree[0], f2 = e2.tree.slice(1), p = t2.tree[0], m = t2.tree.slice(1);
    if ("tuple" === r2 || "vector" === r2 || "altvector" === r2 || "list" === r2 || "array" === r2 || "matrix" === r2 || "interval" === r2) {
      if (p !== r2 && ({ operator1: r2, operator2: p, operands1: f2, operands2: m } = coerce_tuple_array_vectors({ operator1: r2, operator2: p, operands1: f2, operands2: m, coerce_tuples_arrays: n, coerce_vectors: i2 })), p !== r2) return false;
      if (m.length !== f2.length) return false;
      for (let r3 = 0; r3 < f2.length; r3++) if (false === equals$2(e2.context.fromAst(f2[r3]), t2.context.fromAst(m[r3]), a)) return false;
      return;
    }
    if (2 === f2.length && ["=", ">", "<", "ge", "le"].includes(r2)) {
      if (2 !== m.length) return false;
      if (">" === r2 ? (r2 = "<", f2 = [f2[1], f2[0]]) : "ge" === r2 && (r2 = "le", f2 = [f2[1], f2[0]]), ">" === p ? (p = "<", m = [m[1], m[0]]) : "ge" === p && (p = "le", m = [m[1], m[0]]), r2 !== p) return false;
      let n3 = ["+", f2[0], ["-", f2[1]]], i22 = ["+", m[0], ["-", m[1]]], d = "=" !== r2, h = e2.context.fromAst(n3), g = t2.context.fromAst(i22);
      try {
        let e3 = prepare_exprs_numerical_eval(h, g);
        if (0 === e3.functions.length) {
          var o = e3.expr.f(), s = e3.other.f();
          let r3 = 1e-20 * Number.MAX_VALUE;
          for (let n4 = 0; n4 < 10; n4++) {
            var u = {};
            e3.variables.forEach((function(e4) {
              u[e4] = 2 * a() - 1;
            }));
            for (let t22 = 0; t22 < e3.integer_variables.length; t22++) u[e3.integer_variables[t22]] = math$1.floor(21 * a()) - 10;
            let n5 = o(u), f3 = s(u);
            var c2 = math$1.abs(n5), l = math$1.abs(f3);
            if (!(c2 < r3 && l < r3)) continue;
            if (0 == c2 || 0 === l) continue;
            let p2 = math$1.divide(n5, f3);
            if (d && !(p2 > 0)) return false;
            if (1 !== p2) {
              const e4 = rationalApproximation(p2);
              g = t2.context.fromAst(["*", ["/", e4.numerator, e4.denominator], i22]);
            }
            break;
          }
        }
      } catch (e3) {
        return;
      }
      return component_equals(h, g, a);
    }
  }
  return component_equals(e2, t2, a);
}, component_equals = function(e2, t2, r) {
  ({ expr: e2, other: t2 } = normalize_for_equality_checking(e2, t2));
  let n = [1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231];
  var i2 = [.../* @__PURE__ */ new Set([...e2.variables(), ...t2.variables()])];
  for (let a of n) {
    let n3 = randomFiniteFieldBindings(r, i2, a);
    try {
      let r2 = e2.finite_field_evaluate(n3, a), i22 = t2.finite_field_evaluate(n3, a);
      if (!r2.approximate && !i22.approximate && !r2.isNaN() && !i22.isNaN() && r2.values.length > 0 && i22.values.length > 0 && !r2.equals(i22)) return false;
    } catch (e3) {
      return;
    }
  }
}, equals$1 = function(e2, t2, { min_elements_match: r = 3, match_partial: n = false } = {}) {
  if (!is_discrete_infinite_set(e2)) return false;
  if (is_discrete_infinite_set(t2)) {
    var i2 = [];
    let r2 = e2.context.get_assumptions(e2);
    if (void 0 !== r2 && i2.push(r2), r2 = t2.context.get_assumptions(t2), void 0 !== r2 && i2.push(r2), i2 = 0 === i2.length ? void 0 : 1 === i2.length ? i2[0] : clean_assumptions(["and"].concat(i2)), n) {
      let r3 = contained_in(e2.tree, t2.tree, i2, n);
      if (false === r3) return 0;
      let a = contained_in(t2.tree, e2.tree, i2, n);
      return false === a ? 0 : true === r3 ? true === a ? 1 : a : true === a ? r3 : Math.min(r3, a);
    }
    return contained_in(e2.tree, t2.tree, i2, n) && contained_in(t2.tree, e2.tree, i2, n);
  }
  {
    let n3 = t2.tree;
    if ("list" !== n3[0]) return false;
    let i22 = n3.length - 2;
    if ("ldots" !== n3[i22 + 1][0]) return false;
    if (i22 < r) return false;
    let a = n3.slice(0, i22 + 1), o = sequence_from_discrete_infinite(e2, i22);
    return !!o && (o = ["list"].concat(o), equals(e2.context.from(o), t2.context.from(a)));
  }
};
function is_discrete_infinite_set(e2) {
  var t2 = e2.tree;
  if (!Array.isArray(t2)) return false;
  if ("discrete_infinite_set" !== t2[0]) return false;
  var r = t2.slice(1);
  for (var n of r) {
    if (!Array.isArray(n)) return false;
    if ("tuple" !== n[0]) return false;
    if (5 !== n.length) return false;
  }
  return true;
}
function contained_in(e2, t2, r, n) {
  if ("discrete_infinite_set" === e2[0]) {
    if (n) {
      let i22 = 0;
      for (let a3 of e2.slice(1)) {
        let e3 = contained_in(a3, t2, r, n);
        true === e3 ? i22++ : false !== e3 && (i22 += e3);
      }
      let a2 = e2.length - 1;
      return i22 === a2 || 0 !== i22 && i22 / a2;
    }
    return e2.slice(1).every(((e3) => contained_in(e3, t2, r)));
  }
  var i2 = e2[1], a = e2[2], o = evaluate_numbers(e2[3], r), s = e2[4];
  if (o !== -1 / 0 || s !== 1 / 0) return false;
  i2 = simplify(["/", i2, a], r, 1 / 0);
  var u = t2.slice(1), c2 = [];
  for (let e3 = 0; e3 < u.length; e3++) {
    let t22 = evaluate_numbers(u[e3][3]), n3 = u[e3][4];
    if (t22 !== -1 / 0 || n3 !== 1 / 0) return false;
    let i22 = simplify(["/", u[e3][1], a], r, 1 / 0), o2 = simplify(["/", u[e3][2], a], r, 1 / 0);
    if ("number" != typeof o2) return false;
    let s2 = math$1.fraction(o2), l2 = math$1.number(s2.n), f3 = math$1.number(s2.d);
    c2.push([l2, f3, i22, o2]);
  }
  for (c2.sort(); ; ) {
    if (1 !== c2[0][0]) break;
    let e3 = c2[0][2], t22 = c2[0][3], n3 = simplify(expand(["+", e3, ["-", i2]]), r, 1 / 0);
    if (Number.isFinite(n3) && Number.isFinite(t22) && (n3 = math$1.mod(n3, t22), math$1.min(n3, t22 - n3) < 1e-10 * t22)) return true;
    if (c2.splice(0, 1), 0 === c2.length) return false;
  }
  var l = [...new Set(c2.map(((e3) => e3[0])))];
  let f2 = 0;
  for (let e3 of l) {
    let t22 = c2.map((function(t3, r2) {
      if (0 === math$1.mod(e3, t3[0])) {
        let n3 = e3 / t3[0];
        return [t3[0], n3, r2];
      }
    })).filter(((e4) => e4)), a2 = [];
    for (let n3 of t22) {
      let t3 = n3[0], o2 = n3[1], s2 = n3[2], u2 = c2[s2][2], l2 = c2[s2][3];
      for (let n4 = 0; n4 < t3; n4++) {
        let s3 = simplify(expand(["+", u2, ["-", ["+", i2, n4]]]), r, 1 / 0);
        if (Number.isFinite(s3) && Number.isFinite(l2) && (s3 = math$1.mod(s3, l2), math$1.min(s3, l2 - s3) < 1e-10 * l2)) {
          for (let e4 = 0; e4 < o2; e4++) a2[n4 + e4 * t3] = true;
          let r2 = true;
          for (let t4 = 0; t4 < e3; t4++) if (!a2[t4]) {
            r2 = false;
            break;
          }
          if (r2) return true;
          break;
        }
      }
    }
    if (n) {
      let t3 = 0;
      for (let r2 = 0; r2 < e3; r2++) a2[r2] && t3++;
      t3 /= e3, t3 > f2 && (f2 = t3);
    }
  }
  return !!(n && f2 > 0) && f2;
}
function sequence_from_discrete_infinite(e2, t2) {
  var r = e2.tree.slice(1);
  if (r.length > 1) return;
  let n = r[0][1], i2 = r[0][2], a = evaluate_numbers(r[0][3]), o = r[0][4];
  if (!Number.isInteger(a) || o !== 1 / 0) return;
  let s = [];
  for (let e3 = 0; e3 < t2; e3++) s.push(evaluate_numbers(["+", ["*", i2, a + e3], n]));
  return s;
}
const equals = function(e2, t2, { relative_tolerance: r = 1e-12, absolute_tolerance: n = 0, tolerance_for_zero: i2 = 1e-15, allowed_error_in_numbers: a = 0, include_error_in_number_exponents: o = false, allowed_error_is_absolute: s = false, allow_blanks: u = false, coerce_tuples_arrays: c2 = true, coerce_vectors: l = true } = {}) {
  if (!u && (e2.variables().includes("＿") || t2.variables().includes("＿"))) return false;
  let f2 = e2.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify(), p = t2.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify();
  return !!f2.equalsViaSyntax(p, { allowed_error_in_numbers: a, include_error_in_number_exponents: o, allowed_error_is_absolute: s, allow_blanks: true, coerce_tuples_arrays: c2, coerce_vectors: l }) || (0 !== a || 0 != e2.equalsViaFiniteField(t2, { allow_blanks: true, coerce_tuples_arrays: c2, coerce_vectors: l })) && (!!e2.equalsViaComplex(t2, { relative_tolerance: r, absolute_tolerance: n, tolerance_for_zero: i2, allowed_error_in_numbers: a, include_error_in_number_exponents: o, allowed_error_is_absolute: s, allow_blanks: true, coerce_tuples_arrays: c2, coerce_vectors: l }) || !!equals$1(e2, t2));
};
var equality = Object.freeze({ __proto__: null, equals, equalsViaComplex: equals$5, equalsViaReal: equals$4, equalsViaSyntax: equals$3, equalsViaFiniteField: equals$2, equalsDiscreteInfinite: equals$1 });
const equalWithSignErrors = function(e2, t2, { equalityFunction: r = equals, max_sign_errors: n = 1 } = {}) {
  if (r(e2, t2)) return { matched: true, n_sign_errors: 0 };
  for (let i2 = 1; i2 <= n; i2++) if (equalSpecifiedSignErrors(e2, t2, { equalityFunction: r, n_sign_errors: i2 })) return { matched: true, n_sign_errors: i2 };
  return { matched: false };
}, equalSpecifiedSignErrors = function(e2, t2, { equalityFunction: r = c, n_sign_errors: n = 1 } = {}) {
  if (0 === n) return r(e2, t2);
  if (!(Number.isInteger(n) && n > 0)) throw Error(`Have not implemented equality check with ${n} sign errors.`);
  if (n > 1) {
    let e3 = r;
    r = function(t22, r2) {
      return equalSpecifiedSignErrors(t22, r2, { equalityFunction: e3, n_sign_errors: n - 1 });
    };
  }
  var i2, a, o = e2.tree, s = [[o]], u = 0;
  e2.tree = ["-", o];
  var c2 = r(e2, t2);
  if (e2.tree = o, c2) return true;
  for (; i2 = s[u++]; ) if (i2 = i2[0], Array.isArray(i2)) {
    for (a = 1; a < i2.length; a++) if (s.push([i2[a]]), i2[a] = ["-", i2[a]], c2 = r(e2, t2), i2[a] = i2[a][1], c2) return true;
  }
  return false;
};
var sign_error = Object.freeze({ __proto__: null, equalSpecifiedSignErrors, equalWithSignErrors });
function add$2(e2, t2) {
  return clean(["+", get_tree(e2), get_tree(t2)]);
}
function subtract(e2, t2) {
  return clean(["+", get_tree(e2), ["-", get_tree(t2)]]);
}
function multiply(e2, t2) {
  return clean(["*", get_tree(e2), get_tree(t2)]);
}
function divide(e2, t2) {
  return clean(["/", get_tree(e2), get_tree(t2)]);
}
function pow(e2, t2) {
  return clean(["^", get_tree(e2), get_tree(t2)]);
}
function mod(e2, t2) {
  return clean(["apply", "mod", ["tuple", get_tree(e2), get_tree(t2)]]);
}
function copy(e2) {
  return get_tree(e2);
}
var arithmetic = Object.freeze({ __proto__: null, add: add$2, subtract, multiply, divide, pow, mod, copy }), analytic_operators = ["+", "-", "*", "/", "^", "tuple", "vector", "altvector", "list", "array", "matrix", "interval", "vec"], non_analytic_functions = ["abs", "sign", "arg"], relation_operators = ["=", "le", "ge", "<", ">"];
function isAnalytic(e2, { allow_abs: t2 = false, allow_arg: r = false, allow_relation: n = false } = {}) {
  var i2 = normalize_applied_functions(normalize_function_names(e2)), a = operators$3(i2 = subscripts_to_strings(i2));
  for (let e3 = 0; e3 < a.length; e3++) {
    let t22 = a[e3];
    if (-1 === analytic_operators.indexOf(t22)) {
      if (!n) return false;
      if (-1 === relation_operators.indexOf(t22)) return false;
    }
  }
  var o = functions$2(i2);
  for (let e3 = 0; e3 < o.length; e3++) {
    let n3 = o[e3];
    if (non_analytic_functions.includes(n3) && !(t2 && "abs" == n3 || r && "arg" == n3)) return false;
  }
  return true;
}
var analytic = Object.freeze({ __proto__: null, isAnalytic });
function create_discrete_infinite_set({ offsets: e2, periods: t2, min_index: r = ["-", 1 / 0], max_index: n = 1 / 0 } = {}) {
  if (e2 = get_tree(e2), t2 = get_tree(t2), r = get_tree(r), n = get_tree(n), void 0 === e2 || void 0 === t2) return;
  let i2 = [];
  if ("list" === e2[0]) if ("list" === t2[0]) {
    if (e2.length !== t2.length || 1 === e2.length) return;
    for (let a = 1; a < e2.length; a++) i2.push(["tuple", e2[a], t2[a], r, n]);
  } else for (let a = 1; a < e2.length; a++) i2.push(["tuple", e2[a], t2, r, n]);
  else i2.push(["tuple", e2, t2, r, n]);
  return ["discrete_infinite_set"].concat(i2);
}
var sets = Object.freeze({ __proto__: null, create_discrete_infinite_set });
function tuple(e2) {
  var t2 = [];
  t2.push("tuple");
  var r = e2.length;
  for (let n = 0; n < r; n++) t2.push(e2[n]);
  return t2;
}
function matrix(e2) {
  var t2 = [];
  t2.push("matrix");
  var r = e2.length, n = e2[0].length;
  for (let t22 = 1; t22 < r; t22++) if (e2[t22].length !== n) throw new Error("Matrix dimensions mismatch");
  t2.push(tuple([r, n]));
  let i2 = [];
  for (let t22 = 0; t22 < r; t22++) i2.push(tuple(e2[t22].map((function(e3) {
    return e3.tree;
  }))));
  return t2.push(tuple(i2)), t2;
}
function vector_add(e2, t2) {
  if (e2 = get_tree(e2), t2 = get_tree(t2), e2.length !== t2.length || "tuple" !== e2[0] && "vector" !== e2[0] && "altvector" !== e2[0] || "tuple" !== t2[0] && "vector" !== t2[0] && "altvector" !== t2[0]) throw new Error("Can't add. Those aren't vectors, or the dimensions don't match");
  var r = "altvector" === e2[0] && "altvector" === t2[0] ? ["altvector"] : ["vector"], n = e2.length;
  for (let i2 = 1; i2 < n; i2 += 1) r.push(["+", e2[i2], t2[i2]]);
  return simplify(r);
}
function scalar_mul(e2, t2) {
  if ("tuple" !== (t2 = get_tree(t2))[0] && "vector" !== t2[0] && "altvector" !== t2[0]) throw new Error("Can't scalar multiply. Isn't a vector");
  var r = "altvector" === t2[0] ? ["altvector"] : ["vector"], n = t2.length;
  for (let i2 = 1; i2 < n; i2 += 1) r.push(["*", t2[i2], e2]);
  return simplify(r);
}
function vector_sub(e2, t2) {
  return vector_add(e2, scalar_mul(-1, t2));
}
function dot_prod(e2, t2) {
  if (e2 = get_tree(e2), t2 = get_tree(t2), e2.length !== t2.length || "tuple" !== e2[0] && "vector" !== e2[0] && "altvector" !== e2[0] || "tuple" !== t2[0] && "vector" !== t2[0] && "altvector" !== t2[0]) throw new Error("Can't take dot product. Those aren't vectors, or the dimensions don't match");
  var r = 0, n = e2.length;
  for (let i2 = 1; i2 < n; i2 += 1) r = ["+", r, ["*", e2[i2], t2[i2]]];
  return simplify(r);
}
function cross_prod(e2, t2) {
  if (e2 = get_tree(e2), t2 = get_tree(t2), "tuple" !== e2[0] && "vector" !== e2[0] && "altvector" !== e2[0] || "tuple" !== t2[0] && "vector" !== t2[0] && "altvector" !== t2[0]) throw new Error("Can't take cross product. Those aren't vectors");
  if (3 === e2.length && 3 === t2.length) return simplify(["+", ["*", e2[1], t2[2]], ["-", ["*", e2[2], t2[1]]]]);
  if (4 === e2.length && 4 === t2.length) {
    var r = ["+", ["*", e2[2], t2[3]], ["-", ["*", e2[3], t2[2]]]], n = ["+", ["*", e2[3], t2[1]], ["-", ["*", e2[1], t2[3]]]], i2 = ["+", ["*", e2[1], t2[2]], ["-", ["*", e2[2], t2[1]]]];
    return simplify(["altvector" === e2[0] && "altvector" === t2[0] ? "altvector" : "vector", r, n, i2]);
  }
  throw new Error("Can't take cross product. The dimensions aren't both 2 or 3.");
}
var matrix$1 = Object.freeze({ __proto__: null, matrix, vector_add, scalar_mul, vector_sub, dot_prod, cross_prod });
class astToGuppy$1 {
  constructor() {
    this.operators = { "+": function(e2) {
      return e2.join("<e>+</e>");
    }, "-": function(e2) {
      return "<e>-" + e2.join("-") + "</e>";
    }, "*": function(e2) {
      return e2.join('<f type="*" group="operations" c="yes"><b p="latex">\\cdot</b><b p="text">*</b></f>');
    }, "/": function(e2) {
      return astToGuppy$1.dfrac(e2[0], e2[1]);
    }, "^": function(e2) {
      return astToGuppy$1.power(e2[0], e2[1]);
    }, sin: function(e2) {
      return astToGuppy$1.trig("sin", e2[0]);
    }, cos: function(e2) {
      return astToGuppy$1.trig("cos", e2[0]);
    }, tan: function(e2) {
      return astToGuppy$1.trig("tan", e2[0]);
    }, arcsin: function(e2) {
      return astToGuppy$1.trig("arcsin", e2[0]);
    }, arccos: function(e2) {
      return astToGuppy$1.trig("arccos", e2[0]);
    }, arctan: function(e2) {
      return astToGuppy$1.trig("arctan", e2[0]);
    }, arccsc: function(e2) {
      return astToGuppy$1.trig("arccsc", e2[0]);
    }, arcsec: function(e2) {
      return astToGuppy$1.trig("arcsec", e2[0]);
    }, arccot: function(e2) {
      return astToGuppy$1.trig("arccot", e2[0]);
    }, csc: function(e2) {
      return astToGuppy$1.trig("csc", e2[0]);
    }, sec: function(e2) {
      return astToGuppy$1.trig("sec", e2[0]);
    }, cot: function(e2) {
      return astToGuppy$1.trig("cot", e2[0]);
    }, log: function(e2) {
      return astToGuppy$1.trig("log", e2[0]);
    }, exp: function(e2) {
      return astToGuppy$1.trig("exp", e2[0]);
    }, ln: function(e2) {
      return astToGuppy$1.trig("ln", e2[0]);
    }, sqrt: function(e2) {
      return astToGuppy$1.sqrt(e2[0]);
    }, abs: function(e2) {
      return astToGuppy$1.abs(e2[0]);
    } };
  }
  static dfrac(e2, t2) {
    return '<f type="fraction" group="functions"><b p="latex">\\dfrac{<r ref="1"/>}{<r ref="2"/>}</b><b p="small_latex">\\frac{<r ref="1"/>}{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)/(<r ref="2"/>)</b><c up="1" down="2" name="numerator"><e></e>' + e2 + '<e></e></c><c up="1" down="2" name="denominator"><e></e>' + t2 + "<e></e></c></f>";
  }
  static trig(e2, t2) {
    return '<f type="' + e2 + '" group="functions"><b p="latex">\\' + e2 + '\\left(<r ref="1"/>\\right)</b><b p="text"> ' + e2 + '(<r ref="1"/>)</b><c delete="1"><e></e>' + t2 + "<e></e></c></f>";
  }
  static sqrt(e2) {
    return '<f type="square_root" group="functions"><b p="latex">\\sqrt{<r ref="1"/>}</b><b p="text">sqrt(<r ref="1"/>)</b><c delete="1"><e></e>' + e2 + "<e></e></c></f>";
  }
  static power(e2, t2) {
    return '<f type="exponential" group="functions"><b p="latex">{<r ref="1"/>}^{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)^(<r ref="2"/>)</b><c up="2" bracket="yes" delete="1" name="base"><e></e>' + e2 + '<e></e></c><c down="1" delete="1" name="exponent" small="yes"><e></e>' + t2 + "<e></e></c></f>";
  }
  static abs(e2) {
    return '<f type="absolute_value" group="functions"><b p="latex">\\left|<r ref="1"/>\\right|</b><b p="text">abs(<r ref="1"/>)</b><c delete="1"><e></e>' + e2 + "<e></e></c></f>";
  }
  static paren(e2) {
    return '<f type="bracket" group="functions"><b p="latex">\\left(<r ref="1"/>\\right)</b><b p="text">(<r ref="1"/>)</b><c delete="1" is_bracket="yes"><e></e>' + e2 + "<e></e></c></f>";
  }
  static isFunctionSymbol(e2) {
    return -1 !== ["sin", "cos", "tan", "csc", "sec", "cot", "arcsin", "arccos", "arctan", "arccsc", "arcsec", "arccot", "log", "ln", "exp", "sqrt", "abs", "this.factorial"].indexOf(e2);
  }
  static isGreekLetterSymbol(e2) {
    return -1 !== ["pi", "theta", "theta", "Theta", "alpha", "nu", "beta", "xi", "Xi", "gamma", "Gamma", "delta", "Delta", "pi", "Pi", "epsilon", "epsilon", "rho", "rho", "zeta", "sigma", "Sigma", "eta", "tau", "upsilon", "Upsilon", "iota", "phi", "phi", "Phi", "kappa", "chi", "lambda", "Lambda", "psi", "Psi", "omega", "Omega"].indexOf(e2);
  }
  factorWithParenthesesIfNegated(e2) {
    var t2 = this.factor(e2);
    return t2.toString().match(/^<e>-/) ? astToGuppy$1.paren(t2.toString()) : t2;
  }
  factor(e2) {
    if ("string" == typeof e2) return astToGuppy$1.isGreekLetterSymbol(e2) ? '<f type="' + e2 + '" group="greek" c="yes"><b p="latex">\\' + e2 + '</b><b p="text"> $' + e2 + "</b></f>" : "<e>" + e2 + "</e>";
    if ("number" == typeof e2) return "<e>" + e2 + "</e>";
    if (!Array.isArray(e2)) return "<e></e>";
    var t2 = e2[0], r = e2.slice(1);
    return "apply" === t2 && (t2 = e2[1], r = e2.slice(2)), "abs" === t2 ? this.operators[t2](r.map((function(e3, t22) {
      return this.expression(e3);
    }).bind(this))) : astToGuppy$1.isFunctionSymbol(t2) ? "this.factorial" !== t2 || 1 !== r[0].toString().length && !r[0].toString().match(/^[0-9]*$/) ? this.operators[t2](r.map((function(e3, t22) {
      return this.factor(e3);
    }).bind(this))) : this.operators[t2](r) : "^" === t2 || "~" === t2 ? this.operators[t2](r.map((function(e3, t22) {
      return this.factor(e3);
    }).bind(this))) : astToGuppy$1.paren(this.expression(e2));
  }
  term(e2) {
    if (!Array.isArray(e2)) return this.factor(e2);
    var t2 = e2[0], r = e2.slice(1);
    return "*" === t2 ? this.operators[t2](r.map((function(e3, t22) {
      var r2 = this.factorWithParenthesesIfNegated(e3);
      return r2.toString().match(/^[0-9]/) && t22 > 0 ? " * " + r2 : r2;
    }).bind(this))) : "/" === t2 ? this.operators[t2](r.map((function(e3, t22) {
      return this.factor(e3);
    }).bind(this))) : this.factor(e2);
  }
  expression(e2) {
    if (!Array.isArray(e2)) return this.term(e2);
    var t2 = e2[0], r = e2.slice(1);
    return "+" === t2 || "-" === t2 ? this.operators[t2](r.map((function(e3, t22) {
      return this.factorWithParenthesesIfNegated(e3);
    }).bind(this))) : this.term(e2);
  }
  convert(e2) {
    return ("<m><e></e>" + this.expression(e2) + "<e></e></m>").replace(/<\/e><e>/g, "");
  }
}
const glslOperators = { "+": function(e2) {
  var t2 = e2[0];
  return e2.slice(1).forEach((function(e3) {
    t2 = t2 + "+" + e3;
  })), t2;
}, "-": function(e2) {
  var t2 = "-" + e2[0];
  return e2.slice(1).forEach((function(e3) {
    t2 = t2 + "-" + e3;
  })), t2;
}, "~": function(e2) {
  var t2 = "vec2(0.0,0.0)";
  return e2.forEach((function(e3) {
    t2 = t2 + "-" + e3;
  })), t2;
}, "*": function(e2) {
  var t2 = e2[0];
  return e2.slice(1).forEach((function(e3) {
    t2 = "cmul(" + t2 + "," + e3 + ")";
  })), t2;
}, "/": function(e2) {
  var t2 = e2[0];
  return e2.slice(1).forEach((function(e3) {
    t2 = "cdiv(" + t2 + "," + e3 + ")";
  })), t2;
}, sin: function(e2) {
  return "csin(" + e2[0] + ")";
}, cos: function(e2) {
  return "ccos(" + e2[0] + ")";
}, tan: function(e2) {
  return "ctan(" + e2[0] + ")";
}, sinh: function(e2) {
  return "csinh(" + e2[0] + ")";
}, cosh: function(e2) {
  return "ccosh(" + e2[0] + ")";
}, arcsin: function(e2) {
  return "carcsin(" + e2[0] + ")";
}, arccos: function(e2) {
  return "carccos(" + e2[0] + ")";
}, arctan: function(e2) {
  return "carctan(" + e2[0] + ")";
}, arccsc: function(e2) {
  return "carcsin(cdiv(vec2(1.0,0)," + e2[0] + "))";
}, arcsec: function(e2) {
  return "carccos(cdiv(vec2(1.0,0)," + e2[0] + "))";
}, arccot: function(e2) {
  return "carctan(cdiv(vec2(1.0,0)," + e2[0] + "))";
}, csc: function(e2) {
  return "ccsc(" + e2[0] + ")";
}, sec: function(e2) {
  return "csec(" + e2[0] + ")";
}, cot: function(e2) {
  return "ccot(" + e2[0] + ")";
}, exp: function(e2) {
  return "cexp(" + e2[0] + ")";
}, conj: function(e2) {
  return "conjugate(" + e2[0] + ")";
}, sqrt: function(e2) {
  return "cpower(" + e2[0] + ",vec2(0.5,0.0))";
}, log: function(e2) {
  return "clog(" + e2[0] + ")";
}, ln: function(e2) {
  return "clog(" + e2[0] + ")";
}, "^": function(e2) {
  return "cpower(" + e2[0] + "," + e2[1] + ")";
}, abs: function(e2) {
  return "cabs(" + e2[0] + ")";
}, apply: function(e2) {
  return "vec2(NaN,NaN)";
} };
class astToGLSL$1 {
  constructor() {
  }
  convert(e2) {
    if ("boolean" == typeof e2) throw Error("no support for boolean");
    if ("string" == typeof e2) return "e" === e2 ? "vec2(2.71828182845905,0.0)" : "pi" === e2 ? "vec2(3.14159265358979,0.0)" : "i" === e2 ? "vec2(0.0,1.0)" : String(e2);
    if ("number" == typeof e2) return "vec2(" + String(e2) + ",0.0)";
    if ("real" in e2 && "imaginary" in e2) return e2;
    if (!Array.isArray(e2)) throw Error("Invalid ast");
    var t2 = e2[0], r = e2.slice(1);
    if ("apply" === t2) {
      if ("string" != typeof r[0]) throw Error("Non string functions not implemented for conversion to GLSL");
      t2 = r[0], r = r.slice(1);
      return glslOperators[t2](r.map((function(e3, t22) {
        return this.convert(e3);
      }).bind(this)));
    }
    if (t2 in glslOperators) return glslOperators[t2](r.map((function(e3, t22) {
      return this.convert(e3);
    }).bind(this)));
    throw Error("Operator " + t2 + " not implemented for conversion to mathjs");
  }
}
var astToGuppy = new astToGuppy$1(), astToGLSL = new astToGLSL$1();
const tex = function(e2, t2) {
  return new astToLatex$1(t2).convert(e2.tree);
}, toLatex = tex, toString = function(e2, t2) {
  return new astToText$2(t2).convert(e2.tree);
}, toGLSL = function(e2) {
  return astToGLSL.convert(e2.tree);
}, toXML = function(e2) {
  return astToGuppy.convert(e2.tree);
};
var printing = Object.freeze({ __proto__: null, tex, toLatex, toString, toXML, toGLSL });
const integrateNumerically = function(e2, t2, r, n) {
  for (var i2 = 0, a = {}, o = 0; o < 100; o++) {
    var s = r + (n - r) * (o + 0.5) / 100;
    a[t2] = s, i2 += e2.evaluate(a);
  }
  return i2 * (n - r) / 100;
};
var integration = Object.freeze({ __proto__: null, integrateNumerically });
function expression_to_polynomial(e2) {
  var t2 = get_tree(e2);
  if ("string" == typeof t2) return "pi" === t2 && math$1.define_pi || "i" === t2 && math$1.define_i || "e" === t2 && math$1.define_e ? t2 : ["polynomial", t2, [[1, 1]]];
  if ("number" == typeof t2) return t2;
  var r = evaluate_to_constant(t2, { remove_units_first: false });
  if (Number.isFinite(r)) return simplify(t2);
  if (!Array.isArray(t2)) return false;
  if (!operators$3(t2).every(((e3) => ["+", "-", "*", "^", "/", "_", "prime"].includes(e3)))) return false;
  var n = t2[0], i2 = t2.slice(1);
  if ("+" === n) {
    let e3 = i2.map(expression_to_polynomial);
    return !!e3.every(((e4) => false !== e4)) && e3.reduce(((e4, t22) => polynomial_add(e4, t22)));
  }
  if ("-" === n) {
    let e3 = expression_to_polynomial(i2[0]);
    return !!e3 && polynomial_neg(e3);
  }
  if ("*" === n) {
    let e3 = i2.map(expression_to_polynomial);
    return !!e3.every(((e4) => false !== e4)) && e3.reduce(((e4, t22) => polynomial_mul(e4, t22)));
  }
  if ("^" === n) {
    let e3 = i2[0], r2 = expression_to_polynomial(e3);
    if (false === r2) return false;
    let n3 = simplify(i2[1]);
    if ("number" != typeof n3 || n3 < 0 || !Number.isInteger(n3)) {
      let r3 = evaluate_to_constant(n3, { remove_units_first: false });
      if (Number.isFinite(r3)) {
        let t22 = math$1.fraction(r3), n4 = { n: math$1.number(t22.n), d: math$1.number(t22.d), s: math$1.number(t22.s) };
        if (n4.d <= 100) {
          e3 = n4.s < 0 ? ["^", e3, ["/", -1, n4.d]] : ["^", e3, ["/", 1, n4.d]];
          var a = ["polynomial", simplify(e3), []];
          return a[2].push([n4.n, 1]), a;
        }
      }
      return ["polynomial", t2, [[1, 1]]];
    }
    return 0 === n3 ? 1 : 1 === n3 ? r2 : polynomial_pow(r2, n3);
  }
  if ("/" === n) {
    var o = i2[1], s = evaluate_to_constant(o, { remove_units_first: false });
    return Number.isFinite(s) ? polynomial_mul(expression_to_polynomial(i2[0]), ["/", 1, s]) : ["polynomial", t2, [[1, 1]]];
  }
  return ["polynomial", t2, [[1, 1]]];
}
function polynomials_in_same_leading_variable(e2, t2) {
  return e2[1] !== t2[1] && (compare_function(e2[1], t2[1]) < 0 ? t2 = ["polynomial", e2[1], [[0, t2]]] : e2 = ["polynomial", t2[1], [[0, e2]]]), [e2, t2];
}
function polynomial_add(e2, t2) {
  if ("polynomial" !== e2[0]) {
    if ("polynomial" !== t2[0]) return simplify(["+", e2, t2]);
    e2 = ["polynomial", t2[1], [[0, e2]]];
  } else if ("polynomial" !== t2[0]) t2 = ["polynomial", e2[1], [[0, t2]]];
  else {
    let r2 = polynomials_in_same_leading_variable(e2, t2);
    e2 = r2[0], t2 = r2[1];
  }
  let r = ["polynomial", e2[1], []], n = e2[2], i2 = t2[2], a = r[2], o = n.length, s = i2.length, u = 0, c2 = 0;
  for (; u < o || c2 < s; ) if (u === o) i2[c2][1] && a.push(i2[c2]), c2 += 1;
  else if (c2 === s) n[u][1] && a.push(n[u]), u += 1;
  else if (n[u][0] === i2[c2][0]) {
    let e3 = polynomial_add(n[u][1], i2[c2][1]);
    e3 && a.push([n[u][0], e3]), u += 1, c2 += 1;
  } else n[u][0] < i2[c2][0] ? (n[u][1] && a.push(n[u]), u += 1) : (i2[c2][1] && a.push(i2[c2]), c2 += 1);
  return 0 === a.length ? 0 : 1 === a.length && 0 === a[0][0] ? a[0][1] : r;
}
function polynomial_neg(e2) {
  if ("polynomial" !== e2[0]) return simplify(["-", e2]);
  let t2 = ["polynomial", e2[1], []], r = e2[2], n = t2[2], i2 = r.length;
  for (var a = 0; a < i2; a += 1) n.push([r[a][0], polynomial_neg(r[a][1])]);
  return t2;
}
function polynomial_sub(e2, t2) {
  return polynomial_add(e2, polynomial_neg(t2));
}
function polynomial_mul(e2, t2) {
  if ("polynomial" !== e2[0]) {
    if ("polynomial" !== t2[0]) return simplify(["*", e2, t2]);
    if (e2) {
      let r2 = ["polynomial", t2[1], []], n3 = t2[2], i22 = r2[2];
      for (let t22 of n3) t22[1] && i22.push([t22[0], polynomial_mul(e2, t22[1])]);
      return r2;
    }
  } else if (t2 && "polynomial" !== t2[0]) {
    let r2 = ["polynomial", e2[1], []], n3 = e2[2], i22 = r2[2];
    for (let e3 of n3) e3[1] && i22.push([e3[0], polynomial_mul(e3[1], t2)]);
    return r2;
  }
  let r = polynomials_in_same_leading_variable(e2, t2);
  e2 = r[0], t2 = r[1];
  let n = e2[2], i2 = t2[2], a = ["polynomial", e2[1], []], o = a[2], s = n.length, u = i2.length, c2 = [];
  for (let e3 of n) for (let t22 of i2) {
    let r2 = false, n3 = e3[0] + t22[0];
    for (let e4 of c2) if (n3 === e4) {
      r2 = true;
      break;
    }
    r2 || c2.push(n3);
  }
  c2.sort((function(e3, t22) {
    return e3 - t22;
  }));
  for (let e3 of c2) {
    let t22 = 0, r2 = 0;
    for (; r2 < s && n[r2][0] <= e3; ) {
      let a2 = 0;
      for (; a2 < u && i2[a2][0] <= e3; ) {
        if (n[r2][0] + i2[a2][0] === e3) {
          t22 = polynomial_add(t22, polynomial_mul(n[r2][1], i2[a2][1]));
          break;
        }
        a2 += 1;
      }
      r2 += 1;
    }
    t22 && o.push([e3, t22]);
  }
  return a;
}
function polynomial_pow(e2, t2) {
  if (isNaN(t2) || t2 < 0 || !Number.isInteger(t2)) return;
  let r = 1;
  for (; t2 > 0; ) 1 & t2 && (r = polynomial_mul(r, e2)), e2 = polynomial_mul(e2, e2), t2 >>= 1;
  return r;
}
function polynomial_to_expression(e2) {
  if (!Array.isArray(e2) || "polynomial" !== e2[0]) return e2;
  let t2 = e2[1], r = e2[2], n = [], i2 = r.length;
  for (var a = 0; a < i2; a += 1) r[a][1] && (0 === r[a][0] ? n.push(polynomial_to_expression(r[a][1])) : 1 === r[a][0] ? n.push(["*", polynomial_to_expression(r[a][1]), t2]) : n.push(["*", polynomial_to_expression(r[a][1]), ["^", t2, r[a][0]]]));
  return 0 === n.length ? 0 : (1 === n.length ? n = n[0] : n.unshift("+"), simplify(n));
}
function initial_term(e2) {
  if (!Array.isArray(e2) || "polynomial" !== e2[0]) return e2;
  let t2 = [];
  for (; Array.isArray(e2) && "polynomial" === e2[0]; ) {
    let r = e2[1], n = e2[2], i2 = n[n.length - 1][0];
    e2 = n[n.length - 1][1], t2.push([r, i2]);
  }
  return ["monomial", e2, t2];
}
function mono_less_than(e2, t2) {
  if (!Array.isArray(t2) || "monomial" !== t2[0]) return false;
  if (!Array.isArray(e2) || "monomial" !== e2[0]) return true;
  let r = e2[2], n = t2[2], i2 = r.length, a = n.length;
  var o;
  o = i2 < a ? i2 : a;
  for (var s = 0; s < o; s++) {
    if (r[s][0] !== n[s][0]) return !(compare_function(r[s][0], n[s][0]) < 0);
    if (r[s][1] < n[s][1]) return true;
    if (r[s][1] > n[s][1]) return false;
  }
  return i2 !== a && o !== a;
}
function mono_gcd(e2, t2) {
  if (!Array.isArray(e2) || !Array.isArray(t2) || "monomial" !== e2[0] || "monomial" !== t2[0]) return 1;
  let r = e2[2], n = t2[2], i2 = [], a = r.length, o = n.length, s = 0, u = 0;
  for (; s < a && u < o; ) r[s][0] === n[u][0] ? (r[s][1] < n[u][1] ? i2.push(r[s]) : i2.push(n[u]), s += 1, u += 1) : compare_function(r[s][0], n[u][0]) < 0 ? s += 1 : compare_function(n[u][0], r[s][0]) < 0 && (u += 1);
  return 0 === i2.length ? 1 : ["monomial", 1, i2];
}
function mono_div(e2, t2) {
  if (!Array.isArray(t2) || "monomial" !== t2[0]) return 1 === t2 ? e2 : Array.isArray(e2) && "monomial" === e2[0] ? [e2[0], evaluate_numbers(["/", e2[1], t2]), e2[2]] : evaluate_numbers(["/", e2, t2]);
  if (!Array.isArray(e2) || "monomial" !== e2[0]) return;
  let r = e2[2], n = t2[2], i2 = [], a = r.length, o = n.length, s = 0, u = 0;
  for (; s < a && u < o; ) if (r[s][0] === n[u][0]) {
    if (r[s][1] < n[u][1]) return;
    {
      let e3 = r[s][1] - n[u][1];
      0 !== e3 && i2.push([r[s][0], e3]);
    }
    s += 1, u += 1;
  } else if (compare_function(r[s][0], n[u][0]) < 0) i2.push(r[s]), s += 1;
  else if (compare_function(n[u][0], r[s][0]) < 0) return;
  if (!(u < o)) {
    for (; s < a; ) i2.push(r[s]), s += 1;
    return 0 === i2.length ? 1 === t2[1] ? e2[1] : evaluate_numbers(["/", e2[1], t2[1]]) : 1 === t2[1] ? ["monomial", e2[1], i2] : ["monomial", evaluate_numbers(["/", e2[1], t2[1]]), i2];
  }
}
function mono_is_div(e2, t2) {
  if (0 === t2) return false;
  if (!Array.isArray(t2) || "monomial" !== t2[0]) return true;
  if (!Array.isArray(e2) || "monomial" !== e2[0]) return false;
  let r = e2[2], n = t2[2], i2 = [], a = r.length, o = n.length, s = 0, u = 0;
  for (; s < a && u < o; ) if (r[s][0] === n[u][0]) {
    if (r[s][1] < n[u][1]) return false;
    {
      let e3 = r[s][1] - n[u][1];
      0 !== e3 && i2.push([r[s][0], e3]);
    }
    s += 1, u += 1;
  } else if (compare_function(r[s][0], n[u][0]) < 0) i2.push(r[s]), s += 1;
  else if (compare_function(n[u][0], r[s][0]) < 0) return false;
  return !(u < o);
}
function mono_to_poly(e2) {
  if (!Array.isArray(e2) || "monomial" !== e2[0]) return e2;
  let t2 = e2[2].length - 1, r = e2[1];
  for (; t2 >= 0; ) {
    var n = [];
    n.push([e2[2][t2][1], r]), r = ["polynomial", e2[2][t2][0], n], t2 -= 1;
  }
  return r;
}
function max_div_init(e2, t2) {
  if (0 === e2) return 0;
  let r = e2, n = [];
  for (; Array.isArray(r) && "polynomial" === r[0]; ) {
    let e3 = r[1], t22 = r[2], i22 = t22[t22.length - 1][0];
    r = t22[t22.length - 1][1], n.push([e3, i22]);
  }
  let i2 = ["monomial", r, n], a = t2.length;
  for (var o = 0; o < a; o += 1) if (mono_is_div(i2, t2[o])) return [i2, o];
  return max_div_init(polynomial_sub(e2, mono_to_poly(i2)), t2);
}
function poly_div(e2, t2) {
  let r = [], n = [], i2 = [], a = [], o = e2;
  for (var s of t2) r.push(initial_term(s));
  let u = max_div_init(o, r);
  for (; 0 !== u; ) i2 = u[1], a = mono_div(u[0], r[i2]), n.push([i2, a]), o = polynomial_sub(o, polynomial_mul(mono_to_poly(a), t2[i2])), u = max_div_init(o, r);
  return [n, o];
}
function prereduce(e2) {
  let t2 = e2.length, r = [];
  for (var n = 0; n < t2; n++) {
    if (0 !== e2[n] && (!Array.isArray(e2[n]) || "polynomial" !== e2[n][0])) return [1];
    0 !== e2[n] && r.push(e2[n]);
  }
  return 0 === r.length ? [0] : r;
}
function reduce_ith(e2, t2) {
  let r = [], n = [], i2 = [], a = t2[e2], o = t2.length;
  for (var s = 0; s < o; s += 1) s === e2 ? r.push(0) : r.push(initial_term(t2[s]));
  let u = max_div_init(a, r);
  for (; 0 !== u; ) n = u[1], i2 = mono_div(u[0], r[n]), a = polynomial_sub(a, polynomial_mul(mono_to_poly(i2), t2[n])), u = max_div_init(a, r);
  return a;
}
function reduce(e2) {
  let t2 = 0, r = [], n = prereduce(e2), i2 = n.length;
  if (1 === i2) return n;
  let a = true;
  for (; a; ) for (a = false, n = prereduce(n), i2 = n.length, t2 = 0; t2 < i2; ) r = reduce_ith(t2, n), _$2.isEqual(r, n[t2]) || (n[t2] = r, a = true), t2 += 1;
  t2 = 0;
  let o = [], s = 0;
  for (; t2 < i2; ) o = initial_term(n[t2]), Array.isArray(o) && "monomial" === o[0] ? (s = o[1], 1 !== s && (n[t2] = polynomial_mul(n[t2], ["/", 1, s]))) : n[t2] = 1, t2 += 1;
  return n;
}
function hij(e2, t2, r) {
  let n = initial_term(r[e2]), i2 = initial_term(r[t2]), a = mono_gcd(n, i2), o = mono_to_poly(mono_div(n, a));
  return poly_div(polynomial_sub(polynomial_mul(mono_to_poly(mono_div(i2, a)), r[e2]), polynomial_mul(o, r[t2])), r)[1];
}
function build_hij_table(e2, t2) {
  let r = t2.length, n = 0, i2 = 1, a = [];
  for (; i2 < r; ) {
    for (; n < i2; ) e2[[n, i2]] = hij(n, i2, t2), 0 !== e2[[n, i2]] && a.push(e2[[n, i2]]), n += 1;
    n = 0, i2 += 1;
  }
  return a.length > 0 ? choice_lowest_degree(a) : 0;
}
function update_hij_table(e2, t2, r) {
  let n = t2.length;
  t2.push(r);
  let i2 = 0, a = 1, o = [];
  for (; a < n; ) {
    for (; i2 < a; ) 0 !== e2[[i2, a]] && (e2[[i2, a]] = hij(i2, a, t2), 0 !== e2[[i2, a]] && o.push(e2[[i2, a]])), i2 += 1;
    i2 = 0, a += 1;
  }
  for (; i2 < n; ) e2[[i2, n]] = hij(i2, n, t2), 0 !== e2[[i2, n]] && o.push(e2[[i2, n]]), i2 += 1;
  return o.length > 0 ? choice_lowest_degree(o) : 0;
}
function choice_lowest_degree(e2) {
  let t2 = [], r = e2.length;
  for (i2 = 0; i2 < r; i2 += 1) t2.push(initial_term(e2[i2]));
  let n = 0;
  for (var i2 = 1; i2 < r; i2 += 1) {
    if (1 === t2[i2]) return 1;
    mono_less_than(t2[i2], t2[n]) && (n = i2);
  }
  return e2[n];
}
function reduced_grobner(e2) {
  let t2 = reduce(e2), r = {}, n = build_hij_table(r, t2);
  for (; 0 !== n; ) n = update_hij_table(r, t2, n);
  return t2 = reduce(t2), t2;
}
function poly_lcm(e2, t2) {
  let r = reduced_grobner([polynomial_mul(["polynomial", "_t", [[1, 1]]], e2), polynomial_mul(["polynomial", "_t", [[0, 1], [1, -1]]], t2)]), n = r.length;
  for (var i2 = 0; i2 < n; i2 += 1) {
    if (!Array.isArray(r[i2]) || "polynomial" !== r[i2][0]) return 1;
    if ("_t" !== r[i2][1]) return r[i2];
  }
}
function poly_gcd(e2, t2) {
  let r = poly_lcm(e2, t2), n = poly_div(polynomial_mul(e2, t2), [r]), i2 = 0, a = n[0].length;
  for (var o = 0; o < a; o += 1) i2 = polynomial_add(i2, mono_to_poly(n[0][o][1]));
  let s = initial_term(i2);
  if (Array.isArray(s) && "monomial" === s[0]) {
    let e3 = s[1];
    1 !== e3 && (i2 = polynomial_mul(i2, ["/", 1, e3]));
  } else i2 = 1;
  return i2;
}
function poly_by_divisor(e2, t2) {
  let r = poly_div(e2, [t2]), n = 0, i2 = r[0].length;
  for (var a = 0; a < i2; a += 1) n = polynomial_add(n, mono_to_poly(r[0][a][1]));
  return n;
}
function reduce_rational_expression(e2, t2) {
  let r = stringify_vars(e2), n = stringify_vars(t2), i2 = polynomial_mul(poly_gcd(e2 = r[0], t2 = n[0]), initial_term(t2)[1]), a = poly_by_divisor(e2, i2), o = poly_by_divisor(t2, i2);
  return [destringify_vars(destringify_vars(a, r[1]), n[1]), destringify_vars(destringify_vars(o, r[1]), n[1])];
}
function stringify_vars(e2) {
  if (!Array.isArray(e2) || "polynomial" !== e2[0]) return [e2, {}];
  let t2 = {}, r = "z" + JSON.stringify(e2[1]);
  t2[r] = e2[1], e2[1] = r;
  let n = e2[2], i2 = [];
  for (let e3 of n) {
    i2 = stringify_vars(e3[1]), e3[1] = i2[0];
    for (let e4 in i2[1]) t2[e4] = i2[1][e4];
  }
  return [e2, t2];
}
function destringify_vars(e2, t2) {
  if (!Array.isArray(e2) || "polynomial" !== e2[0]) return e2;
  t2[e2[1]] && (e2[1] = t2[e2[1]]);
  let r = e2[2];
  for (let e3 of r) e3[1] = destringify_vars(e3[1], t2);
  return e2;
}
var textToAst$1 = new textToAst$4();
function common_denominator(e2, t2) {
  e2 = simplify(e2, t2);
  var r = [];
  return r.push([textToAst$1.convert("a/c+b/c"), textToAst$1.convert("(a+b)/c"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1.convert("a/c-b/c"), textToAst$1.convert("(a-b)/c"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1.convert("a+b/c"), textToAst$1.convert("(ac+b)/c"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1.convert("a-b/c"), textToAst$1.convert("(ac-b)/c"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1.convert("a/d+b/c"), textToAst$1.convert("(ac+bd)/(cd)"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1.convert("a/d-b/c"), textToAst$1.convert("(ac-bd)/(cd)"), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1.convert("x*(y/z)"), textToAst$1.convert("(x*y)/z"), { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r.push([textToAst$1.convert("(x/y)/z"), textToAst$1.convert("x/(y*z)"), { allow_extended_match: true, allow_permutations: true }]), r.push([textToAst$1.convert("x/(y/z)"), textToAst$1.convert("xz/y"), { allow_extended_match: true, allow_permutations: true }]), e2 = expand(e2 = applyAllTransformations(e2, r, 40), true);
}
function as_num_denom(e2) {
  var t2 = get_tree(e2);
  return "/" === (t2 = common_denominator(t2))[0] ? [t2[1], t2[2]] : [t2, 1];
}
function reduce_rational(e2) {
  var t2 = get_tree(e2), r = as_num_denom(t2);
  if (1 === r[1]) return t2;
  var n = reduce_rational_expression(expression_to_polynomial(r[0]), expression_to_polynomial(r[1])), i2 = polynomial_to_expression(n[0]), a = polynomial_to_expression(n[1]);
  return 1 === a ? i2 : ["/", i2, a];
}
const common_demoninator = common_denominator;
var rational = Object.freeze({ __proto__: null, reduce_rational, common_demoninator });
function toFixed(e2, t2) {
  return math$1.format(e2, { notation: "fixed", precision: t2 });
}
function round_numbers_to_precision(e2, t2 = 14) {
  var r = get_tree(e2);
  if (t2 < 1) throw Error("For round_numbers_to_precision, digits must be positive");
  if (!Number.isFinite(t2)) throw Error("For round_numbers_to_precision, digits must be a number");
  return t2 > 15 ? r : (t2 = Math.round(t2), round_numbers_to_precision_sub(r, t2));
}
const round_numbers_to_precision_sub = function(e2, t2 = 14) {
  if ("number" == typeof e2 && Number.isFinite(e2) && 0 !== e2) {
    const r = math$1.floor(math$1.log10(math$1.abs(e2))), n = t2 - r - 1;
    return n < 0 ? parseFloat(toFixed(e2, n) + "0".repeat(math$1.abs(n))) : parseFloat(toFixed(e2, n));
  }
  if (!Array.isArray(e2)) return e2;
  return [e2[0], ...e2.slice(1).map(((e3) => round_numbers_to_precision_sub(e3, t2)))];
};
function round_numbers_to_decimals(e2, t2 = 14) {
  var r = get_tree(e2);
  if (!Number.isFinite(t2)) throw Error("For round_numbers_to_decimals, ndecimals must be a number");
  return t2 = Math.round(t2), t2 = Math.max(-330, Math.min(330, t2)), round_numbers_to_decimals_sub(r, t2);
}
const round_numbers_to_decimals_sub = function(e2, t2 = 0) {
  if ("number" == typeof e2) return t2 < 0 ? parseFloat(toFixed(e2, t2) + "0".repeat(math$1.abs(t2))) : parseFloat(toFixed(e2, t2));
  if (!Array.isArray(e2)) return e2;
  return [e2[0], ...e2.slice(1).map(((e3) => round_numbers_to_decimals_sub(e3, t2)))];
};
function round_numbers_to_precision_plus_decimals(e2, t2 = 4, r = 2) {
  var n = get_tree(e2);
  let i2 = true, a = true;
  if (t2 >= 1) {
    if ((t2 = Math.round(t2)) > 15) return n;
  } else i2 = false;
  return Number.isFinite(r) ? (r = Math.round(r), r = Math.max(-330, Math.min(330, r))) : a = false, i2 ? a ? round_numbers_to_precision_plus_decimals_sub(n, t2, r) : round_numbers_to_precision_sub(n, t2) : a ? round_numbers_to_decimals_sub(n, r) : n;
}
const round_numbers_to_precision_plus_decimals_sub = function(e2, t2 = 4, r = 2) {
  if ("number" == typeof e2 && Number.isFinite(e2) && 0 !== e2) {
    const n = math$1.floor(math$1.log10(math$1.abs(e2))), i2 = Math.max(t2 - n - 1, r);
    return i2 < 0 ? parseFloat(toFixed(e2, i2) + "0".repeat(math$1.abs(i2))) : parseFloat(toFixed(e2, i2));
  }
  if (!Array.isArray(e2)) return e2;
  return [e2[0], ...e2.slice(1).map(((e3) => round_numbers_to_precision_plus_decimals_sub(e3, t2, r)))];
};
var round$2 = Object.freeze({ __proto__: null, round_numbers_to_precision, round_numbers_to_decimals, round_numbers_to_precision_plus_decimals });
const match = function(e2, t2, r) {
  let n = get_tree(e2), i2 = get_tree(t2);
  return match$2(n, i2, r);
};
var match$1 = Object.freeze({ __proto__: null, match });
const expression_to_tree$1 = [simplify$1, differentiation, normalization, arithmetic, transformation, solve, sets, matrix$1, rational, round$2], expression_to_other = [variables$1, printing, equality, integration, evaluation, analytic, sign_error, match$1];
function abs(e2) {
  return ["apply", "abs", get_tree(e2)];
}
function exp(e2) {
  return ["apply", "exp", get_tree(e2)];
}
function log(e2) {
  return ["apply", "log", get_tree(e2)];
}
function log10(e2) {
  return ["apply", "log10", get_tree(e2)];
}
function sign(e2) {
  return ["apply", "sign", get_tree(e2)];
}
function sqrt(e2) {
  return ["apply", "sqrt", get_tree(e2)];
}
function conj(e2) {
  return ["apply", "conj", get_tree(e2)];
}
function im(e2) {
  return ["apply", "im", get_tree(e2)];
}
function re(e2) {
  return ["apply", "re", get_tree(e2)];
}
function factorial(e2) {
  return ["apply", "factorial", get_tree(e2)];
}
function gamma(e2) {
  return ["apply", "gamma", get_tree(e2)];
}
function erf(e2) {
  return ["apply", "erf", get_tree(e2)];
}
function acos(e2) {
  return ["apply", "acos", get_tree(e2)];
}
function acosh(e2) {
  return ["apply", "acosh", get_tree(e2)];
}
function acot(e2) {
  return ["apply", "acot", get_tree(e2)];
}
function acoth(e2) {
  return ["apply", "acoth", get_tree(e2)];
}
function acsc(e2) {
  return ["apply", "acsc", get_tree(e2)];
}
function acsch(e2) {
  return ["apply", "acsch", get_tree(e2)];
}
function asec(e2) {
  return ["apply", "asec", get_tree(e2)];
}
function asech(e2) {
  return ["apply", "asech", get_tree(e2)];
}
function asin(e2) {
  return ["apply", "asin", get_tree(e2)];
}
function asinh(e2) {
  return ["apply", "asinh", get_tree(e2)];
}
function atan(e2) {
  return ["apply", "atan", get_tree(e2)];
}
function atanh(e2) {
  return ["apply", "atanh", get_tree(e2)];
}
function cos(e2) {
  return ["apply", "cos", get_tree(e2)];
}
function cosh(e2) {
  return ["apply", "cosh", get_tree(e2)];
}
function cot(e2) {
  return ["apply", "cot", get_tree(e2)];
}
function coth(e2) {
  return ["apply", "coth", get_tree(e2)];
}
function csc(e2) {
  return ["apply", "csc", get_tree(e2)];
}
function csch(e2) {
  return ["apply", "csch", get_tree(e2)];
}
function sec(e2) {
  return ["apply", "sec", get_tree(e2)];
}
function sech(e2) {
  return ["apply", "sech", get_tree(e2)];
}
function sin(e2) {
  return ["apply", "sin", get_tree(e2)];
}
function sinh(e2) {
  return ["apply", "sinh", get_tree(e2)];
}
function tan(e2) {
  return ["apply", "tan", get_tree(e2)];
}
function tanh(e2) {
  return ["apply", "tanh", get_tree(e2)];
}
function atan2(e2, t2) {
  return ["apply", "atan2", ["tuple", get_tree(e2), get_tree(t2)]];
}
var standard = Object.freeze({ __proto__: null, abs, exp, log, log10, sign, sqrt, conj, im, re, factorial, gamma, erf, acos, acosh, acot, acoth, acsc, acsch, asec, asech, asin, asinh, atan, atanh, cos, cosh, cot, coth, csc, csch, sec, sech, sin, sinh, tan, tanh, atan2 });
const expression_to_tree = [standard], whitespace_rule = "\\s|\\\\,|\\\\!|\\\\ |\\\\>|\\\\;|\\\\:|\\\\quad\\b|\\\\qquad\\b", sci_notat_exp_regex = "(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?", number_rules_sci = [["[0-9]+(\\.[0-9]*)?" + sci_notat_exp_regex, "NUMBER"], ["\\.[0-9]+" + sci_notat_exp_regex, "NUMBER"]], number_rules_non_sci = [["[0-9]+(\\.[0-9]*)?", "NUMBER"], ["\\.[0-9]+", "NUMBER"]], base_latex_rules = [["\\*", "*"], ["\\/", "/"], ["-", "-"], ["\\+", "+"], ["\\^", "^"], ["\\(", "("], ["\\\\left\\s*\\(", "("], ["\\\\bigl\\s*\\(", "("], ["\\\\Bigl\\s*\\(", "("], ["\\\\biggl\\s*\\(", "("], ["\\\\Biggl\\s*\\(", "("], ["\\)", ")"], ["\\\\right\\s*\\)", ")"], ["\\\\bigr\\s*\\)", ")"], ["\\\\Bigr\\s*\\)", ")"], ["\\\\biggr\\s*\\)", ")"], ["\\\\Biggr\\s*\\)", ")"], ["\\[", "["], ["\\\\left\\s*\\[", "["], ["\\\\bigl\\s*\\[", "["], ["\\\\Bigl\\s*\\[", "["], ["\\\\biggl\\s*\\[", "["], ["\\\\Biggl\\s*\\[", "["], ["\\]", "]"], ["\\\\right\\s*\\]", "]"], ["\\\\bigr\\s*\\]", "]"], ["\\\\Bigr\\s*\\]", "]"], ["\\\\biggr\\s*\\]", "]"], ["\\\\Biggr\\s*\\]", "]"], ["\\|", "|"], ["\\\\left\\s*\\|", "|L"], ["\\\\bigl\\s*\\|", "|L"], ["\\\\Bigl\\s*\\|", "|L"], ["\\\\biggl\\s*\\|", "|L"], ["\\\\Biggl\\s*\\|", "|L"], ["\\\\right\\s*\\|", "|"], ["\\\\bigr\\s*\\|", "|"], ["\\\\Bigr\\s*\\|", "|"], ["\\\\biggr\\s*\\|", "|"], ["\\\\Biggr\\s*\\|", "|"], ["\\\\big\\s*\\|", "|"], ["\\\\Big\\s*\\|", "|"], ["\\\\bigg\\s*\\|", "|"], ["\\\\Bigg\\s*\\|", "|"], ["{", "{"], ["}", "}"], ["\\\\{", "LBRACE"], ["\\\\left\\s*\\\\{", "LBRACE"], ["\\\\bigl\\s*\\\\{", "LBRACE"], ["\\\\Bigl\\s*\\\\{", "LBRACE"], ["\\\\biggl\\s*\\\\{", "LBRACE"], ["\\\\Biggl\\s*\\\\{", "LBRACE"], ["\\\\}", "RBRACE"], ["\\\\right\\s*\\\\}", "RBRACE"], ["\\\\bigr\\s*\\\\}", "RBRACE"], ["\\\\Bigr\\s*\\\\}", "RBRACE"], ["\\\\biggr\\s*\\\\}", "RBRACE"], ["\\\\Biggr\\s*\\\\}", "RBRACE"], ["\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\left\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\bigl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\Bigl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\biggl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\Biggl\\s*\\\\lfloor(?![a-zA-Z])", "LFLOOR"], ["\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\right\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\bigr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\Bigr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\biggr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\Biggr\\s*\\\\rfloor(?![a-zA-Z])", "RFLOOR"], ["\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\left\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\bigl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\Bigl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\biggl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\Biggl\\s*\\\\lceil(?![a-zA-Z])", "LCEIL"], ["\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\right\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\bigr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\Bigr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\biggr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\Biggr\\s*\\\\rceil(?![a-zA-Z])", "RCEIL"], ["\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\left\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\bigl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\Bigl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\biggl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\Biggl\\s*\\\\langle(?![a-zA-Z])", "LANGLE"], ["\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\right\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\bigr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\Bigr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\biggr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\Biggr\\s*\\\\rangle(?![a-zA-Z])", "RANGLE"], ["\\\\cdot(?![a-zA-Z])", "*"], ["\\\\div(?![a-zA-Z])", "/"], ["\\\\times(?![a-zA-Z])", "*"], [",", ","], [":", ":"], ["\\\\mid(?![a-zA-Z])", "MID"], ["\\\\varnothing(?![a-zA-Z])", "LATEXCOMMAND", "\\emptyset"], ["\\\\vartheta(?![a-zA-Z])", "LATEXCOMMAND", "\\theta"], ["\\\\varepsilon(?![a-zA-Z])", "LATEXCOMMAND", "\\epsilon"], ["\\\\varrho(?![a-zA-Z])", "LATEXCOMMAND", "\\rho"], ["\\\\varphi(?![a-zA-Z])", "LATEXCOMMAND", "\\phi"], ["\\\\infty(?![a-zA-Z])", "INFINITY"], ["\\\\asin(?![a-zA-Z])", "LATEXCOMMAND", "\\arcsin"], ["\\\\acos(?![a-zA-Z])", "LATEXCOMMAND", "\\arccos"], ["\\\\atan(?![a-zA-Z])", "LATEXCOMMAND", "\\arctan"], ["\\\\sqrt(?![a-zA-Z])", "SQRT"], ["\\\\land(?![a-zA-Z])", "AND"], ["\\\\wedge(?![a-zA-Z])", "AND"], ["\\\\lor(?![a-zA-Z])", "OR"], ["\\\\vee(?![a-zA-Z])", "OR"], ["\\\\lnot(?![a-zA-Z])", "NOT"], ["\\\\neg(?![a-zA-Z])", "NOT"], ["=", "="], ["\\\\neq(?![a-zA-Z])", "NE"], ["\\\\ne(?![a-zA-Z])", "NE"], ["\\\\not\\s*=", "NE"], ["\\\\leq(?![a-zA-Z])", "LE"], ["\\\\le(?![a-zA-Z])", "LE"], ["\\\\geq(?![a-zA-Z])", "GE"], ["\\\\ge(?![a-zA-Z])", "GE"], ["<", "<"], ["\\\\lt(?![a-zA-Z])", "<"], [">", ">"], ["\\\\gt(?![a-zA-Z])", ">"], ["\\\\forall(?![a-zA-Z])", "FORALL"], ["\\\\exists(?![a-zA-Z])", "EXISTS"], ["\\\\in(?![a-zA-Z])", "IN"], ["\\\\notin(?![a-zA-Z])", "NOTIN"], ["\\\\not\\s*\\\\in(?![a-zA-Z])", "NOTIN"], ["\\\\ni(?![a-zA-Z])", "NI"], ["\\\\not\\s*\\\\ni(?![a-zA-Z])", "NOTNI"], ["\\\\subset(?![a-zA-Z])", "SUBSET"], ["\\\\subseteq(?![a-zA-Z])", "SUBSETEQ"], ["\\\\not\\s*\\\\subset(?![a-zA-Z])", "NOTSUBSET"], ["\\\\not\\s*\\\\subseteq(?![a-zA-Z])", "NOTSUBSETEQ"], ["\\\\supset(?![a-zA-Z])", "SUPERSET"], ["\\\\supseteq(?![a-zA-Z])", "SUPERSETEQ"], ["\\\\not\\s*\\\\supset(?![a-zA-Z])", "NOTSUPERSET"], ["\\\\not\\s*\\\\supseteq(?![a-zA-Z])", "NOTSUPERSETEQ"], ["\\\\cup(?![a-zA-Z])", "UNION"], ["\\\\cap(?![a-zA-Z])", "INTERSECT"], ["\\\\to(?![a-zA-Z])", "RIGHTARROW"], ["\\\\rightarrow(?![a-zA-Z])", "RIGHTARROW"], ["\\\\longrightarrow(?![a-zA-Z])", "RIGHTARROW"], ["\\\\gets(?![a-zA-Z])", "LEFTARROW"], ["\\\\leftarrow(?![a-zA-Z])", "LEFTARROW"], ["\\\\longleftarrow(?![a-zA-Z])", "LEFTARROW"], ["\\\\leftrightarrow(?![a-zA-Z])", "LEFTRIGHTARROW"], ["\\\\longleftrightarrow(?![a-zA-Z])", "LEFTRIGHTARROW"], ["\\\\implies(?![a-zA-Z])", "IMPLIES"], ["\\\\Longrightarrow(?![a-zA-Z])", "IMPLIES"], ["\\\\Rightarrow(?![a-zA-Z])", "IMPLIES"], ["\\\\impliedby(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\Longleftarrow(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\Leftarrow(?![a-zA-Z])", "IMPLIEDBY"], ["\\\\iff(?![a-zA-Z])", "IFF"], ["\\\\Longleftrightarrow(?![a-zA-Z])", "IFF"], ["\\\\Leftrightarrow(?![a-zA-Z])", "IFF"], ["\\\\perp(?![a-zA-Z])", "PERP"], ["\\\\bot(?![a-zA-Z])", "PERP"], ["\\\\parallel(?![a-zA-Z])", "PARALLEL"], ["\\\\\\|", "PARALLEL"], ["\\\\angle(?![a-zA-Z])", "ANGLE"], ["\\\\int(?![a-zA-Z])", "INT"], ["!", "!"], ["'", "'"], ["_", "_"], ["&", "&"], ["\\\\ldots(?![a-zA-Z])", "LDOTS"], ["\\\\\\\\", "LINEBREAK"], ["\\\\begin\\s*{\\s*[a-zA-Z0-9]+\\s*}", "BEGINENVIRONMENT"], ["\\\\end\\s*{\\s*[a-zA-Z0-9]+\\s*}", "ENDENVIRONMENT"], ["\\\\operatorname\\s*{\\s*[a-zA-Z0-9\\+\\-]+\\s*}", "VARMULTICHAR"], ["\\\\[a-zA-Z]+(?![a-zA-Z])", "LATEXCOMMAND"], ["\\\\[$%]", "LATEXCOMMAND"], ["[a-zA-Z＿$%]", "VAR"]], allowSimplifiedFunctionApplicationDefault = true, allowedLatexSymbolsDefault = ["alpha", "beta", "gamma", "Gamma", "delta", "Delta", "epsilon", "zeta", "eta", "theta", "Theta", "iota", "kappa", "lambda", "Lambda", "mu", "nu", "xi", "Xi", "pi", "Pi", "rho", "sigma", "Sigma", "tau", "Tau", "upsilon", "Upsilon", "phi", "Phi", "chi", "psi", "Psi", "omega", "Omega", "partial", "angle", "circ", "%", "$", "emptyset"], appliedFunctionSymbolsDefault = ["abs", "exp", "log", "ln", "log10", "sign", "sqrt", "erf", "cos", "cosh", "acos", "acosh", "arccos", "arccosh", "cot", "coth", "acot", "acoth", "arccot", "arccoth", "csc", "csch", "acsc", "acsch", "arccsc", "arccsch", "sec", "sech", "asec", "asech", "arcsec", "arcsech", "sin", "sinh", "asin", "asinh", "arcsin", "arcsinh", "tan", "tanh", "atan", "atan2", "atanh", "arctan", "arctanh", "arg", "conj", "Re", "Im", "det", "trace", "nPr", "nCr", "floor", "ceil", "round"], functionSymbolsDefault = ["f", "g"], operatorSymbolsDefault = { frac: { nargs: 2, substitute: "/" }, binom: { nargs: 2 }, vec: { nargs: 1 }, overline: { nargs: 1, substitute: "linesegment", remove_products: true } }, unitsDefault = get_all_units();
unitsDefault.circ = unitsDefault.deg, unitsDefault.circ.substitute = "deg", unitsDefault.circ.isExponent = true, delete unitsDefault.deg;
const parseLeibnizNotationDefault = true;
class latexToAst$1 {
  constructor({ allowSimplifiedFunctionApplication: e2 = allowSimplifiedFunctionApplicationDefault, allowedLatexSymbols: t2 = allowedLatexSymbolsDefault, appliedFunctionSymbols: r = appliedFunctionSymbolsDefault, functionSymbols: n = functionSymbolsDefault, operatorSymbols: i2 = operatorSymbolsDefault, units: a = unitsDefault, parseLeibnizNotation: o = parseLeibnizNotationDefault, parseScientificNotation: s = true } = {}) {
    this.allowSimplifiedFunctionApplication = e2, this.allowedLatexSymbols = t2, this.appliedFunctionSymbols = r, this.functionSymbols = n, this.operatorSymbols = i2, this.units = a, this.parseLeibnizNotation = o;
    let u = base_latex_rules;
    u = s ? [...number_rules_sci, ...u] : [...number_rules_non_sci, ...u], this.lexer = new lexer(u, whitespace_rule);
  }
  advance(e2) {
    if (this.token = this.lexer.advance(e2), "INVALID" === this.token.token_type) throw new ParseError("Invalid symbol '" + this.token.original_text + "'", this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(e2) {
    this.lexer.set_state(e2.lexer_state), this.token = Object.assign({}, e2.token);
  }
  convert(e2) {
    this.lexer.set_input(e2), this.advance();
    var t2 = this.statement_list();
    if ("EOF" !== this.token.token_type) throw new ParseError("Invalid location of '" + this.token.original_text + "'", this.lexer.location);
    return flatten$6(t2);
  }
  statement_list() {
    for (var e2 = [this.statement()]; "," === this.token.token_type; ) this.advance(), e2.push(this.statement());
    return e2 = e2.length > 1 ? ["list"].concat(e2) : e2[0];
  }
  statement({ inside_absolute_value: e2 = 0 } = {}) {
    if ("LDOTS" === this.token.token_type) return this.advance(), ["ldots"];
    var t2;
    try {
      t2 = this.return_state();
      let r = this.statement_a({ inside_absolute_value: e2 });
      if (":" !== this.token.token_type && "MID" !== this.token.token_type) return r;
      let n = ":" === this.token.token_type ? ":" : "|";
      return this.advance(), [n, r, this.statement_a()];
    } catch (e3) {
      try {
        this.set_state(t2);
        let r = this.statement_a({ parse_absolute_value: false });
        if ("|" !== this.token.token_type[0]) throw e3;
        return this.advance(), ["|", r, this.statement_a({ parse_absolute_value: false })];
      } catch (t22) {
        throw e3;
      }
    }
  }
  statement_a({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true } = {}) {
    for (var r = this.statement_b({ inside_absolute_value: e2, parse_absolute_value: t2 }); ["IMPLIES", "IMPLIEDBY", "IFF", "LEFTARROW", "RIGHTARROW", "LEFTRIGHTARROW"].includes(this.token.token_type); ) {
      let n = this.token.token_type.toLowerCase();
      this.advance(), r = [n, r, this.statement_b({ inside_absolute_value: e2, parse_absolute_value: t2 })];
    }
    return r;
  }
  statement_b({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true } = {}) {
    for (var r = this.statement_c({ inside_absolute_value: e2, parse_absolute_value: t2 }); "OR" === this.token.token_type; ) {
      let n = this.token.token_type.toLowerCase();
      this.advance(), r = [n, r, this.statement_c({ inside_absolute_value: e2, parse_absolute_value: t2 })];
    }
    return r;
  }
  statement_c(e2) {
    for (var t2 = this.relation(e2); "AND" === this.token.token_type; ) {
      let r = this.token.token_type.toLowerCase();
      this.advance(), t2 = [r, t2, this.relation(e2)];
    }
    return t2;
  }
  relation(e2) {
    if ("NOT" === this.token.token_type || "!" === this.token.token_type) return this.advance(), ["not", this.relation(e2)];
    if ("FORALL" === this.token.token_type || "EXISTS" === this.token.token_type) {
      let t22 = this.token.token_type.toLowerCase();
      return this.advance(), [t22, this.relation(e2)];
    }
    for (var t2 = this.expression(e2); "=" === this.token.token_type || "NE" === this.token.token_type || "<" === this.token.token_type || ">" === this.token.token_type || "LE" === this.token.token_type || "GE" === this.token.token_type || "IN" === this.token.token_type || "NOTIN" === this.token.token_type || "NI" === this.token.token_type || "NOTNI" === this.token.token_type || "SUBSET" === this.token.token_type || "NOTSUBSET" === this.token.token_type || "SUBSETEQ" === this.token.token_type || "NOTSUBSETEQ" === this.token.token_type || "SUPERSET" === this.token.token_type || "NOTSUPERSET" === this.token.token_type || "SUPERSETEQ" === this.token.token_type || "NOTSUPERSETEQ" === this.token.token_type; ) {
      let r = this.token.token_type.toLowerCase(), n = 0;
      "<" === this.token.token_type || "LE" === this.token.token_type ? n = -1 : ">" !== this.token.token_type && "GE" !== this.token.token_type || (n = 1), this.advance();
      let i2 = this.expression(e2);
      if (-1 === n) if ("<" === this.token.token_type || "LE" === this.token.token_type) {
        let n3 = ["tuple"];
        "<" === r ? n3.push(true) : n3.push(false);
        let a = ["tuple", t2, i2];
        for (; "<" === this.token.token_type || "LE" === this.token.token_type; ) "<" === this.token.token_type ? n3.push(true) : n3.push(false), this.advance(), a.push(this.expression(e2));
        t2 = ["lts", a, n3];
      } else t2 = [r, t2, i2];
      else if (1 === n) if (">" === this.token.token_type || "GE" === this.token.token_type) {
        let n3 = ["tuple"];
        ">" === r ? n3.push(true) : n3.push(false);
        let a = ["tuple", t2, i2];
        for (; ">" === this.token.token_type || "GE" === this.token.token_type; ) ">" === this.token.token_type ? n3.push(true) : n3.push(false), this.advance(), a.push(this.expression(e2));
        t2 = ["gts", a, n3];
      } else t2 = [r, t2, i2];
      else if ("=" === r) for (t2 = ["=", t2, i2]; "=" === this.token.token_type; ) this.advance(), t2.push(this.expression(e2));
      else t2 = [r, t2, i2];
    }
    return t2;
  }
  expression(e2) {
    if ("NOT" === this.token.token_type || "!" === this.token.token_type) return this.advance(), ["not", this.expression(e2)];
    let t2 = false;
    "+" === this.token.token_type && (t2 = true, this.advance());
    let r = false;
    "-" === this.token.token_type && (r = true, this.advance());
    var n = this.term(e2);
    if (r || t2) {
      if (false === n) return (t2 ? "+" : "") + (r ? "-" : "");
      if ("string" == typeof n && [...n].every(((e3) => ["+", "-"].includes(e3)))) return (t2 ? "+" : "") + (r ? "-" : "") + n;
    }
    for (false === n && (n = "＿"), r && (n = n > 0 ? -n : ["-", n]), t2 && (n = ["+", n]); ["+", "-", "UNION", "INTERSECT", "PERP", "PARALLEL"].includes(this.token.token_type); ) {
      let t22 = this.token.token_type.toLowerCase(), r2 = false, i2 = false;
      "-" === this.token.token_type ? (t22 = "+", r2 = true, this.advance()) : (this.advance(), "+" === t22 && "-" === this.token.token_type && (r2 = true, i2 = true, this.advance()));
      let a = this.term(e2);
      if ("+" === t22) {
        if (false === a && ("number" == typeof n || "string" == typeof n)) return i2 ? n + "+-" : r2 ? n + "-" : n + "+";
        if ("string" == typeof a && [...a].every(((e3) => ["+", "-"].includes(e3))) && ("number" == typeof n || "string" == typeof n)) return i2 ? n + "+-" + a : r2 ? n + "-" + a : n + "+" + a;
      }
      false === a && (a = "＿"), r2 && (a = a > 0 ? -a : ["-", a]), n = [t22, n, a];
    }
    return n;
  }
  term(e2) {
    var t2 = this.factor(e2), r = false;
    do {
      if (r = false, "*" === this.token.token_type) {
        this.advance(), false === t2 && (t2 = "＿");
        let n = this.factor(e2);
        false === n && (n = "＿"), t2 = ["*", t2, n], r = true;
      } else if ("/" === this.token.token_type) {
        this.advance(), false === t2 && (t2 = "＿");
        let n = this.factor(e2);
        false === n && (n = "＿"), t2 = ["/", t2, n], r = true;
      } else {
        let n = Object.assign({}, e2);
        n.allow_absolute_value_closing = true;
        let i2 = this.nonMinusFactor(n);
        false !== i2 && (false === t2 && (t2 = "＿"), t2 = ["*", t2, i2], r = true);
      }
    } while (r);
    return this.convert_units_in_term(flatten$6(t2));
  }
  convert_units_in_term(e2) {
    if (!Array.isArray(e2)) return e2;
    let t2 = e2[0], r = e2.slice(1);
    if ("*" === t2) {
      let e3 = r.length;
      for (let [t22, n] of r.entries()) {
        let i2 = this.units[n];
        if (i2) {
          if (i2.prefix && t22 < e3 - 1) {
            let a;
            a = t22 === e3 - 2 ? r[e3 - 1] : this.convert_units_in_term(["*", ...r.slice(t22 + 1)]);
            let o = n;
            i2.substitute && (o = i2.substitute);
            let s = ["unit", o, a];
            return 0 === t22 ? s : ["*", ...r.slice(0, t22).map(this.convert_units_in_term.bind(this)), s];
          }
          if (!i2.prefix && t22 > 0) {
            let a, o = n;
            return i2.substitute && (o = i2.substitute), a = 1 === t22 ? ["unit", r[0], o] : ["unit", ["*", ...r.slice(0, t22).map(this.convert_units_in_term.bind(this))], o], t22 === e3 - 1 ? a : this.convert_units_in_term(["*", a, ...r.slice(t22 + 1)]);
          }
        }
      }
      return [t2, ...r.map(this.convert_units_in_term.bind(this))];
    }
    if ("/" === t2) return ["/", this.convert_units_in_term(r[0]), this.convert_units_in_term(r[1])];
    if ("^" === t2) {
      let e3 = this.units[r[1]];
      if (e3 && e3.isExponent) {
        let t22 = r[1];
        return e3.substitute && (t22 = e3.substitute), ["unit", r[0], t22];
      }
      return [t2, ...r.map(this.convert_units_in_term.bind(this))];
    }
    return [t2, ...r.map(this.convert_units_in_term.bind(this))];
  }
  factor(e2) {
    if ("+" === this.token.token_text) {
      this.advance();
      let t22 = this.factor(e2);
      return false === t22 ? "+" : "string" == typeof t22 && [...t22].every(((e3) => ["+", "-"].includes(e3))) ? "+" + t22 : ["+", t22];
    }
    if ("-" === this.token.token_type) {
      this.advance();
      let t22 = this.factor(e2);
      return t22 > 0 ? -t22 : false === t22 ? "-" : "string" == typeof t22 && [...t22].every(((e3) => ["+", "-"].includes(e3))) ? "-" + t22 : ["-", t22];
    }
    let t2 = this.nonMinusFactor(e2);
    return false === t2 && "PERP" === this.token.token_type && (t2 = "perp", this.advance()), t2;
  }
  nonMinusFactor(e2) {
    for (var t2 = this.baseFactor(e2); "^" === this.token.token_type || "!" === this.token.token_type || "'" === this.token.token_type; ) if (false === t2 && (t2 = "＿"), "^" === this.token.token_type) {
      this.advance(), t2 = ["^", t2, this.get_subsuperscript(e2)];
    } else "!" === this.token.token_type ? (t2 = ["apply", "factorial", t2], this.advance()) : (t2 = ["prime", t2], this.advance());
    return t2;
  }
  get_single_digit_as_number() {
    if ("NUMBER" === this.token.token_type && "." !== this.token.token_text[0]) {
      let e2 = Number(this.token.token_text[0]);
      return this.token.token_text.length > 1 && this.lexer.unput(this.token.token_text.slice(1)), this.advance(), e2;
    }
    return null;
  }
  get_subsuperscript({ parse_absolute_value: e2 }) {
    let t2 = this.get_single_digit_as_number();
    if (null !== t2) return t2;
    if (["+", "-", "PERP"].includes(this.token.token_type)) {
      let e3 = this.token.token_type.toLowerCase();
      return this.advance(), e3;
    }
    {
      let t22 = this.baseFactor({ parse_absolute_value: e2, in_subsuperscript_with_no_delimiters: true });
      return false === t22 && (t22 = "＿"), t22;
    }
  }
  baseFactor({ inside_absolute_value: e2 = 0, parse_absolute_value: t2 = true, allow_absolute_value_closing: r = false, in_subsuperscript_with_no_delimiters: n = false } = {}) {
    var i2 = false;
    if ("BEGINENVIRONMENT" === this.token.token_type) {
      let e3 = /\\begin\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1];
      if (["matrix", "pmatrix", "bmatrix"].includes(e3)) {
        let r2 = 0, n3 = 0, a = [], o = [], s = 0, u = this.token.token_type;
        for (this.advance(); "ENDENVIRONMENT" !== this.token.token_type; ) "&" === this.token.token_type ? ("&" !== u && "LINEBREAK" !== u || (o.push(0), s += 1), u = this.token.token_type, this.advance()) : "LINEBREAK" === this.token.token_type ? ("&" !== u && "LINEBREAK" !== u || (o.push(0), s += 1), a.push(o), s > n3 && (n3 = s), r2 += 1, s = 0, o = [], u = this.token.token_type, this.advance()) : (o.push(this.statement({ parse_absolute_value: t2 })), s += 1, u = " ");
        if (/\\end\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1] !== e3) throw new ParseError("Expecting \\end{" + e3 + "}", this.lexer.location);
        "&" === u && (o.push(0), s += 1), a.push(o), s > n3 && (n3 = s), r2 += 1, this.advance(), i2 = ["matrix", ["tuple", r2, n3]];
        let c2 = ["tuple"];
        for (let e4 of a) {
          let t22 = ["tuple"].concat(e4);
          for (let r3 = e4.length; r3 < n3; r3 += 1) t22.push(0);
          c2.push(t22);
        }
        return i2.push(c2), i2;
      }
      throw new ParseError("Unrecognized environment " + e3, this.lexer.location);
    }
    if ("NUMBER" === this.token.token_type) i2 = parseFloat(this.token.token_text), this.advance();
    else if ("INFINITY" === this.token.token_type) i2 = 1 / 0, this.advance();
    else if ("SQRT" === this.token.token_type) {
      this.advance();
      let e3 = 2;
      if ("[" === this.token.token_type) {
        this.advance();
        let r3 = this.statement({ parse_absolute_value: t2 });
        if ("]" !== this.token.token_type) throw new ParseError("Expecting ]", this.lexer.location);
        this.advance(), e3 = r3;
      }
      if ("{" !== this.token.token_type) throw new ParseError("Expecting {", this.lexer.location);
      this.advance();
      let r2 = this.statement({ parse_absolute_value: t2 });
      if ("}" !== this.token.token_type) throw new ParseError("Expecting }", this.lexer.location);
      this.advance(), i2 = 2 === e3 ? ["apply", "sqrt", r2] : ["^", r2, ["/", 1, e3]];
    } else if ("VAR" === this.token.token_type || "LATEXCOMMAND" === this.token.token_type || "VARMULTICHAR" === this.token.token_type) {
      if (i2 = this.token.token_text, "LATEXCOMMAND" === this.token.token_type) {
        if (i2 = i2.slice(1), !(this.appliedFunctionSymbols.includes(i2) || this.functionSymbols.includes(i2) || this.allowedLatexSymbols.includes(i2) || i2 in this.operatorSymbols)) throw new ParseError("Unrecognized latex command " + this.token.original_text, this.lexer.location);
      } else "VARMULTICHAR" === this.token.token_type && (i2 = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(i2)[1]);
      if (this.appliedFunctionSymbols.includes(i2) || this.functionSymbols.includes(i2)) {
        let e3 = false;
        if (this.appliedFunctionSymbols.includes(i2) && (e3 = true), ["Re", "Im"].includes(i2) && (i2 = i2.toLowerCase()), this.advance(), "_" === this.token.token_type) {
          this.advance();
          let e4 = this.get_subsuperscript({ parse_absolute_value: t2 });
          i2 = "log" === i2 && 10 === e4 ? "log10" : ["_", i2, e4];
        }
        if (n) e3 && (i2 = ["apply", i2, "＿"]);
        else {
          for (; "'" === this.token.token_type; ) i2 = ["prime", i2], this.advance();
          for (; "^" === this.token.token_type; ) {
            this.advance(), i2 = ["^", i2, this.get_subsuperscript({ parse_absolute_value: t2 })];
          }
          if ("{" === this.token.token_type || "(" === this.token.token_type) {
            let e4;
            e4 = "{" === this.token.token_type ? "}" : ")", this.advance();
            let t22 = this.statement_list();
            if (this.token.token_type !== e4) throw new ParseError("Expecting " + e4, this.lexer.location);
            this.advance(), "list" === t22[0] && (t22[0] = "tuple"), i2 = ["apply", i2, t22];
          } else if (e3) {
            if (!this.allowSimplifiedFunctionApplication) throw new ParseError("Expecting ( after function", this.lexer.location);
            let e4 = this.factor({ parse_absolute_value: t2 });
            false === e4 && (e4 = "＿"), i2 = ["apply", i2, e4];
          }
        }
        return i2;
      }
      if (i2 in this.operatorSymbols) {
        if (this.advance(), "frac" === i2 && this.parseLeibnizNotation) {
          let e4 = this.return_state(), t22 = this.leibniz_notation();
          if (t22) return t22;
          this.set_state(e4);
        }
        let e3 = i2;
        this.operatorSymbols[i2].substitute && (e3 = this.operatorSymbols[i2].substitute);
        let r2 = this.operatorSymbols[i2].nargs, n3 = this.operatorSymbols[i2].remove_products, a = [];
        for (let e4 = 0; e4 < r2; e4++) if ("{" === this.token.token_type) {
          this.advance();
          let e5 = this.statement({ parse_absolute_value: t2 });
          if (n3 && Array.isArray(e5) && "*" === e5[0] ? a.push(...e5.slice(1)) : a.push(e5), "}" !== this.token.token_type) throw new ParseError("Expecting }", this.lexer.location);
          this.advance();
        } else {
          let e5 = this.get_single_digit_as_number();
          if (null === e5) {
            if ("VAR" !== this.token.token_type) throw new ParseError("Expecting {", this.lexer.location);
            e5 = this.token.token_text, this.advance();
          }
          a.push(e5);
        }
        i2 = [e3, ...a];
      } else this.advance();
    } else if ("(" === this.token.token_type || "[" === this.token.token_type || "{" === this.token.token_type || "LBRACE" === this.token.token_type || "LANGLE" === this.token.token_type) {
      let e3, t22, r2 = this.token.token_type;
      "(" === this.token.token_type ? (e3 = ")", t22 = "]") : "[" === this.token.token_type ? (e3 = "]", t22 = ")") : "{" === this.token.token_type ? (e3 = "}", t22 = null) : "LBRACE" === this.token.token_type ? (e3 = "RBRACE", t22 = null) : (e3 = "RANGLE", t22 = null), this.advance();
      let n3 = 1;
      if ("list" === (i2 = this.statement_list())[0] && (n3 = i2.length - 1), this.token.token_type !== e3) {
        if (2 !== n3 || null === t22) throw new ParseError("Expecting " + e3, this.lexer.location);
        if (this.token.token_type !== t22) throw new ParseError("Expecting ) or ]", this.lexer.location);
        let a;
        i2[0] = "tuple", a = "(" === r2 ? ["tuple", false, true] : ["tuple", true, false], (i2 = ["interval", i2]).push(a);
      } else n3 >= 2 ? i2[0] = "(" === r2 || "{" === r2 ? "tuple" : "[" === r2 ? "array" : "LBRACE" === r2 ? "set" : "altvector" : "LBRACE" === r2 && (i2 = ("|" === i2[0] || i2[0], ["set", i2]));
      this.advance();
    } else if ("|" !== this.token.token_type[0] || !t2 || 0 !== e2 && r && "L" !== this.token.token_type[1]) {
      if ("LFLOOR" === this.token.token_type || "LCEIL" === this.token.token_type) {
        let e3, t22;
        if ("LFLOOR" === this.token.token_type ? (e3 = "RFLOOR", t22 = "floor") : "LCEIL" === this.token.token_type && (e3 = "RCEIL", t22 = "ceil"), this.advance(), i2 = ["apply", t22, i2 = this.statement()], this.token.token_type !== e3) throw new ParseError("Expecting " + e3, this.lexer.location);
        this.advance();
      } else if ("ANGLE" === this.token.token_type) if (this.advance(), "{" === this.token.token_type || "(" === this.token.token_type) {
        let e3;
        e3 = "{" === this.token.token_type ? "}" : ")", this.advance();
        let t22 = this.statement_list();
        if (this.token.token_type !== e3) throw new ParseError("Expecting " + e3, this.lexer.location);
        this.advance(), "list" === t22[0] ? i2 = ["angle", ...t22.slice(1)] : "*" === t22[0] && (i2 = ["angle", t22]);
      } else {
        let e3 = [], r2 = this.nonMinusFactor({ parse_absolute_value: t2 });
        for (; false !== r2; ) e3.push(r2), r2 = this.nonMinusFactor({ parse_absolute_value: t2 });
        i2 = 0 === e3.length ? "angle" : ["angle", ...e3];
      }
      else if ("INT" === this.token.token_type) {
        this.advance();
        let e3 = "int";
        if ("_" === this.token.token_type) {
          this.advance(), e3 = ["_", e3, this.get_subsuperscript({ parse_absolute_value: t2 })];
        }
        if ("^" === this.token.token_type) {
          this.advance(), e3 = ["^", e3, this.get_subsuperscript({ parse_absolute_value: t2 })];
        }
        let r2 = flatten$6(this.term({ parse_absolute_value: t2 }));
        if (Array.isArray(r2) && "*" === r2[0]) {
          let e4 = [];
          for (let t22 = 0; t22 < r2.length - 1; t22++) {
            if ("d" === r2[t22]) {
              let n3 = r2[t22 + 1];
              r2.splice(t22, 2), e4.push(["d", n3]), t22--;
            }
          }
          r2.push(...e4);
        }
        return ["apply", e3, r2];
      }
    } else {
      if (e2 += 1, this.advance(), i2 = ["apply", "abs", i2 = this.statement({ inside_absolute_value: e2 })], "|" !== this.token.token_type) throw new ParseError("Expecting |", this.lexer.location);
      this.advance();
    }
    if ("_" === this.token.token_type) {
      false === i2 && (i2 = "＿"), this.advance(), i2 = ["_", i2, this.get_subsuperscript({ parse_absolute_value: t2 })];
    }
    return i2;
  }
  leibniz_notation() {
    if ("{" !== this.token.token_type) return false;
    this.advance();
    var e2 = this.token.token_text;
    let t2 = "", r = 1, n = "", i2 = [], a = [];
    if ("LATEXCOMMAND" === this.token.token_type && "partial" === e2.slice(1)) t2 = "∂";
    else {
      if ("VAR" !== this.token.token_type || "d" !== e2) return false;
      t2 = "d";
    }
    if (this.advance(), "^" === this.token.token_type) {
      this.advance();
      let e3 = false;
      if ("{" === this.token.token_type && (e3 = true, this.advance()), "NUMBER" !== this.token.token_type) return false;
      if (r = parseFloat(this.token.token_text), !Number.isInteger(r)) return false;
      if (e3 && (this.advance(), "}" !== this.token.token_type)) return false;
      this.advance();
    }
    if ("VAR" === this.token.token_type) n = this.token.token_text;
    else if ("VARMULTICHAR" === this.token.token_type) n = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1];
    else if ("LATEXCOMMAND" === this.token.token_type) {
      if (e2 = this.token.token_text.slice(1), !this.allowedLatexSymbols.includes(e2)) return false;
      n = e2;
    }
    if (this.advance(), "}" !== this.token.token_type) return false;
    if (this.advance(), "{" !== this.token.token_type) return false;
    this.advance();
    let o = 0;
    for (; ; ) {
      if (!("d" === t2 && "VAR" === this.token.token_type && "d" === this.token.token_text || "∂" === t2 && "LATEXCOMMAND" === this.token.token_type && "partial" === this.token.token_text.slice(1))) return false;
      if (this.advance(), "VAR" === this.token.token_type) i2.push(this.token.token_text);
      else if ("VARMULTICHAR" === this.token.token_type) i2.push(/\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1]);
      else {
        if ("LATEXCOMMAND" !== this.token.token_type) return false;
        {
          let e3 = this.token.token_text.slice(1);
          if (!this.allowedLatexSymbols.includes(e3)) return false;
          i2.push(e3);
        }
      }
      let s = 1;
      if (this.advance(), "^" === this.token.token_type) {
        this.advance();
        let e3 = false;
        if ("{" === this.token.token_type && (e3 = true, this.advance()), "NUMBER" !== this.token.token_type) return false;
        if (s = parseFloat(this.token.token_text), !Number.isInteger(s)) return false;
        if (e3 && (this.advance(), "}" !== this.token.token_type)) return false;
        this.advance();
      }
      if (a.push(s), o += s, o > r) return false;
      if (o === r) {
        if ("}" !== this.token.token_type) return false;
        this.advance();
        let o2 = "derivative_leibniz";
        "∂" === t2 && (o2 = "partial_" + o2), e2 = [o2], 1 === r ? e2.push(n) : e2.push(["tuple", n, r]);
        let s2 = [];
        for (let e3 = 0; e3 < i2.length; e3 += 1) 1 === a[e3] ? s2.push(i2[e3]) : s2.push(["tuple", i2[e3], a[e3]]);
        return s2 = ["tuple"].concat(s2), e2.push(s2), e2;
      }
    }
  }
}
class latexToGuppy {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToGuppy = new astToGuppy$1();
  }
  convert(e2) {
    return this.astToGuppy.convert(this.latexToAst.convert(e2));
  }
}
class latexToMathjs {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToMathjs = new astToMathjs$1();
  }
  convert(e2) {
    return this.astToMathjs.convert(this.latexToAst.convert(e2));
  }
}
class latexToText {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToText = new astToText$2();
  }
  convert(e2) {
    return this.astToText.convert(this.latexToAst.convert(e2));
  }
}
const operators = { "+,add": function(e2) {
  return ["+"].concat(e2);
}, "*,multiply": function(e2) {
  return ["*"].concat(e2);
}, "/,divide": function(e2) {
  return ["/", e2[0], e2[1]];
}, "-,unaryMinus": function(e2) {
  return ["-", e2[0]];
}, "-,subtract": function(e2) {
  return ["+", e2[0], ["-", e2[1]]];
}, "^,pow": function(e2) {
  return ["^", e2[0], e2[1]];
}, "and,and": function(e2) {
  return ["and"].concat(e2);
}, "or,or": function(e2) {
  return ["or"].concat(e2);
}, "not,not": function(e2) {
  return ["not", e2[0]];
}, "==,equal": function(e2) {
  return ["="].concat(e2);
}, "<,smaller": function(e2) {
  return ["<", e2[0], e2[1]];
}, ">,larger": function(e2) {
  return [">", e2[0], e2[1]];
}, "<=,smallerEq": function(e2) {
  return ["le", e2[0], e2[1]];
}, ">=,largerEq": function(e2) {
  return ["ge", e2[0], e2[1]];
}, "!=,unequal": function(e2) {
  return ["ne", e2[0], e2[1]];
}, "!,factorial": function(e2) {
  return ["apply", "factorial", e2[0]];
} };
class mathjsToAst {
  convert(e2) {
    if (e2.isConstantNode) return e2.value;
    if (e2.isSymbolNode) return e2.name;
    if (e2.isOperatorNode) {
      var t2 = [e2.op, e2.fn].join(",");
      if (t2 in operators) return operators[t2](e2.args.map((function(e3, t22) {
        return this.convert(e3);
      }).bind(this)));
      throw Error("Unsupported operator: " + e2.op + ", " + e2.fn);
    }
    if (e2.isFunctionNode) {
      var r = e2.args.map((function(e3, t22) {
        return this.convert(e3);
      }).bind(this));
      r = r.length > 1 ? ["tuple"].concat(r) : r[0];
      var n = ["apply", e2.name];
      return n.push(r), n;
    }
    if (e2.isArrayNode) return ["vector"].concat(e2.args.map((function(e3, t22) {
      return this.convert(e3);
    }).bind(this)));
    if (e2.isParenthesisNode) return this.convert(e2.content);
    throw Error("Unsupported node type: " + e2.type);
  }
}
class mathjsToGuppy {
  constructor() {
    this.mathjsToAst = new mathjsToAst(), this.astToGuppy = new astToGuppy$1();
  }
  convert(e2) {
    return this.astToGuppy.convert(this.mathjsToAst.convert(e2));
  }
}
class mathjsToLatex {
  constructor() {
    this.mathjsToAst = new mathjsToAst(), this.astToLatex = new astToLatex$1();
  }
  convert(e2) {
    return this.astToLatex.convert(this.mathjsToAst.convert(e2));
  }
}
class mathjsToText {
  constructor() {
    this.mathjsToAst = new mathjsToAst(), this.astToText = new astToText$2();
  }
  convert(e2) {
    return this.astToText.convert(this.mathjsToAst.convert(e2));
  }
}
function defaultSetTimout() {
  throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
  throw new Error("clearTimeout has not been defined");
}
var cachedSetTimeout = defaultSetTimout, cachedClearTimeout = defaultClearTimeout;
function runTimeout(e2) {
  if (cachedSetTimeout === setTimeout) return setTimeout(e2, 0);
  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) return cachedSetTimeout = setTimeout, setTimeout(e2, 0);
  try {
    return cachedSetTimeout(e2, 0);
  } catch (t2) {
    try {
      return cachedSetTimeout.call(null, e2, 0);
    } catch (t22) {
      return cachedSetTimeout.call(this, e2, 0);
    }
  }
}
function runClearTimeout(e2) {
  if (cachedClearTimeout === clearTimeout) return clearTimeout(e2);
  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) return cachedClearTimeout = clearTimeout, clearTimeout(e2);
  try {
    return cachedClearTimeout(e2);
  } catch (t2) {
    try {
      return cachedClearTimeout.call(null, e2);
    } catch (t22) {
      return cachedClearTimeout.call(this, e2);
    }
  }
}
"function" == typeof global$1.setTimeout && (cachedSetTimeout = setTimeout), "function" == typeof global$1.clearTimeout && (cachedClearTimeout = clearTimeout);
var queue = [], draining = false, currentQueue, queueIndex = -1;
function cleanUpNextTick() {
  draining && currentQueue && (draining = false, currentQueue.length ? queue = currentQueue.concat(queue) : queueIndex = -1, queue.length && drainQueue());
}
function drainQueue() {
  if (!draining) {
    var e2 = runTimeout(cleanUpNextTick);
    draining = true;
    for (var t2 = queue.length; t2; ) {
      for (currentQueue = queue, queue = []; ++queueIndex < t2; ) currentQueue && currentQueue[queueIndex].run();
      queueIndex = -1, t2 = queue.length;
    }
    currentQueue = null, draining = false, runClearTimeout(e2);
  }
}
function nextTick(e2) {
  var t2 = new Array(arguments.length - 1);
  if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) t2[r - 1] = arguments[r];
  queue.push(new Item(e2, t2)), 1 !== queue.length || draining || runTimeout(drainQueue);
}
function Item(e2, t2) {
  this.fun = e2, this.array = t2;
}
Item.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var title = "browser", platform$1 = "browser", browser$1$1 = true, env = {}, argv = [], version = "", versions = {}, release = {}, config$2 = {};
function noop$3() {
}
var on$1 = noop$3, addListener = noop$3, once = noop$3, off = noop$3, removeListener = noop$3, removeAllListeners = noop$3, emit = noop$3;
function binding(e2) {
  throw new Error("process.binding is not supported");
}
function cwd$1() {
  return "/";
}
function chdir(e2) {
  throw new Error("process.chdir is not supported");
}
function umask() {
  return 0;
}
var performance$1 = global$1.performance || {}, performanceNow = performance$1.now || performance$1.mozNow || performance$1.msNow || performance$1.oNow || performance$1.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function hrtime(e2) {
  var t2 = 1e-3 * performanceNow.call(performance$1), r = Math.floor(t2), n = Math.floor(t2 % 1 * 1e9);
  return e2 && (r -= e2[0], (n -= e2[1]) < 0 && (r--, n += 1e9)), [r, n];
}
var startTime = /* @__PURE__ */ new Date();
function uptime() {
  return (/* @__PURE__ */ new Date() - startTime) / 1e3;
}
var browser$1$1$1 = { nextTick, title, browser: browser$1$1, env, argv, version, versions, on: on$1, addListener, once, off, removeListener, removeAllListeners, emit, binding, cwd: cwd$1, chdir, umask, hrtime, platform: platform$1, release, config: config$2, uptime }, browser$3 = { exports: {} }, debug = { exports: {} }, ms, hasRequiredMs, hasRequiredDebug, hasRequiredBrowser$2, xmlParser, hasRequiredXmlParser;
function requireMs() {
  if (hasRequiredMs) return ms;
  hasRequiredMs = 1;
  var e2 = 1e3, t2 = 60 * e2, r = 60 * t2, n = 24 * r, i2 = 365.25 * n;
  function a(e3, t22, r2) {
    if (!(e3 < t22)) return e3 < 1.5 * t22 ? Math.floor(e3 / t22) + " " + r2 : Math.ceil(e3 / t22) + " " + r2 + "s";
  }
  return ms = function(o, s) {
    s = s || {};
    var u = typeof o;
    if ("string" === u && o.length > 0) return (function(a2) {
      if ((a2 = String(a2)).length > 100) return;
      var o2 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(a2);
      if (!o2) return;
      var s2 = parseFloat(o2[1]);
      switch ((o2[2] || "ms").toLowerCase()) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return s2 * i2;
        case "days":
        case "day":
        case "d":
          return s2 * n;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return s2 * r;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return s2 * t2;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return s2 * e2;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return s2;
        default:
          return;
      }
    })(o);
    if ("number" === u && false === isNaN(o)) return s.long ? (function(i22) {
      return a(i22, n, "day") || a(i22, r, "hour") || a(i22, t2, "minute") || a(i22, e2, "second") || i22 + " ms";
    })(o) : (function(i22) {
      if (i22 >= n) return Math.round(i22 / n) + "d";
      if (i22 >= r) return Math.round(i22 / r) + "h";
      if (i22 >= t2) return Math.round(i22 / t2) + "m";
      if (i22 >= e2) return Math.round(i22 / e2) + "s";
      return i22 + "ms";
    })(o);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(o));
  }, ms;
}
function requireDebug() {
  return hasRequiredDebug || (hasRequiredDebug = 1, (function(e2, t2) {
    var r;
    function n(e3) {
      function n3() {
        if (n3.enabled) {
          var e4 = n3, i2 = +/* @__PURE__ */ new Date(), a = i2 - (r || i2);
          e4.diff = a, e4.prev = r, e4.curr = i2, r = i2;
          for (var o = new Array(arguments.length), s = 0; s < o.length; s++) o[s] = arguments[s];
          o[0] = t2.coerce(o[0]), "string" != typeof o[0] && o.unshift("%O");
          var u = 0;
          o[0] = o[0].replace(/%([a-zA-Z%])/g, (function(r2, n4) {
            if ("%%" === r2) return r2;
            u++;
            var i22 = t2.formatters[n4];
            if ("function" == typeof i22) {
              var a2 = o[u];
              r2 = i22.call(e4, a2), o.splice(u, 1), u--;
            }
            return r2;
          })), t2.formatArgs.call(e4, o), (n3.log || t2.log || console.log.bind(console)).apply(e4, o);
        }
      }
      return n3.namespace = e3, n3.enabled = t2.enabled(e3), n3.useColors = t2.useColors(), n3.color = (function(e4) {
        var r2, n4 = 0;
        for (r2 in e4) n4 = (n4 << 5) - n4 + e4.charCodeAt(r2), n4 |= 0;
        return t2.colors[Math.abs(n4) % t2.colors.length];
      })(e3), "function" == typeof t2.init && t2.init(n3), n3;
    }
    (t2 = e2.exports = n.debug = n.default = n).coerce = function(e3) {
      return e3 instanceof Error ? e3.stack || e3.message : e3;
    }, t2.disable = function() {
      t2.enable("");
    }, t2.enable = function(e3) {
      t2.save(e3), t2.names = [], t2.skips = [];
      for (var r2 = ("string" == typeof e3 ? e3 : "").split(/[\s,]+/), n3 = r2.length, i2 = 0; i2 < n3; i2++) r2[i2] && ("-" === (e3 = r2[i2].replace(/\*/g, ".*?"))[0] ? t2.skips.push(new RegExp("^" + e3.substr(1) + "$")) : t2.names.push(new RegExp("^" + e3 + "$")));
    }, t2.enabled = function(e3) {
      var r2, n3;
      for (r2 = 0, n3 = t2.skips.length; r2 < n3; r2++) if (t2.skips[r2].test(e3)) return false;
      for (r2 = 0, n3 = t2.names.length; r2 < n3; r2++) if (t2.names[r2].test(e3)) return true;
      return false;
    }, t2.humanize = requireMs(), t2.names = [], t2.skips = [], t2.formatters = {};
  })(debug, debug.exports)), debug.exports;
}
function requireBrowser$2() {
  return hasRequiredBrowser$2 || (hasRequiredBrowser$2 = 1, (function(e2, t2) {
    function r() {
      var e3;
      try {
        e3 = t2.storage.debug;
      } catch (e4) {
      }
      return !e3 && void 0 !== browser$1$1$1 && "env" in browser$1$1$1 && (e3 = browser$1$1$1.env.DEBUG), e3;
    }
    (t2 = e2.exports = requireDebug()).log = function() {
      return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }, t2.formatArgs = function(e3) {
      var r2 = this.useColors;
      if (e3[0] = (r2 ? "%c" : "") + this.namespace + (r2 ? " %c" : " ") + e3[0] + (r2 ? "%c " : " ") + "+" + t2.humanize(this.diff), !r2) return;
      var n = "color: " + this.color;
      e3.splice(1, 0, n, "color: inherit");
      var i2 = 0, a = 0;
      e3[0].replace(/%[a-zA-Z%]/g, (function(e4) {
        "%%" !== e4 && (i2++, "%c" === e4 && (a = i2));
      })), e3.splice(a, 0, n);
    }, t2.save = function(e3) {
      try {
        null == e3 ? t2.storage.removeItem("debug") : t2.storage.debug = e3;
      } catch (e4) {
      }
    }, t2.load = r, t2.useColors = function() {
      if ("undefined" != typeof window && window.process && "renderer" === window.process.type) return true;
      return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }, t2.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : (function() {
      try {
        return window.localStorage;
      } catch (e3) {
      }
    })(), t2.colors = ["lightseagreen", "forestgreen", "goldenrod", "dodgerblue", "darkorchid", "crimson"], t2.formatters.j = function(e3) {
      try {
        return JSON.stringify(e3);
      } catch (e4) {
        return "[UnexpectedJSONParseError]: " + e4.message;
      }
    }, t2.enable(r());
  })(browser$3, browser$3.exports)), browser$3.exports;
}
function requireXmlParser() {
  if (hasRequiredXmlParser) return xmlParser;
  hasRequiredXmlParser = 1;
  var e2 = requireBrowser$2()("xml-parser");
  return xmlParser = function(t2) {
    return t2 = (t2 = t2.trim()).replace(/<!--[\s\S]*?-->/g, ""), r();
    function r() {
      return { declaration: n(), root: i2() };
    }
    function n() {
      if (o(/^<\?xml\s*/)) {
        for (var e3 = { attributes: {} }; !s() && !u("?>"); ) {
          var t22 = a();
          if (!t22) return e3;
          e3.attributes[t22.name] = t22.value;
        }
        return o(/\?>\s*/), e3;
      }
    }
    function i2() {
      e2("tag %j", t2);
      var r2 = o(/^<([\w-:.]+)\s*/);
      if (r2) {
        for (var n3, c2 = { name: r2[1], attributes: {}, children: [] }; !(s() || u(">") || u("?>") || u("/>")); ) {
          var l = a();
          if (!l) return c2;
          c2.attributes[l.name] = l.value;
        }
        if (o(/^\s*\/>\s*/)) return c2;
        for (o(/\??>\s*/), c2.content = (function() {
          e2("content %j", t2);
          var r3 = o(/^([^<]*)/);
          return r3 ? r3[1] : "";
        })(); n3 = i2(); ) c2.children.push(n3);
        return o(/^<\/[\w-:.]+>\s*/), c2;
      }
    }
    function a() {
      e2("attribute %j", t2);
      var r2, n3 = o(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/);
      if (n3) return { name: n3[1], value: (r2 = n3[2], r2.replace(/^['"]|['"]$/g, "")) };
    }
    function o(e3) {
      var r2 = t2.match(e3);
      if (r2) return t2 = t2.slice(r2[0].length), r2;
    }
    function s() {
      return 0 == t2.length;
    }
    function u(e3) {
      return 0 == t2.indexOf(e3);
    }
  }, xmlParser;
}
var xmlParserExports = requireXmlParser(), parseString = getDefaultExportFromCjs$2(xmlParserExports);
const entities = { "&#913;": "\\Alpha", "&Alpha;": "\\Alpha", "&#x0391;": "\\Alpha", "\\u0391;": "\\Alpha", "&#914;": "\\Beta", "&Beta;": "\\Beta", "&#x0392;": "\\Beta", "\\u0392;": "\\Beta", "&#915;": "\\Gamma", "&Gamma;": "\\Gamma", "&#x0393;": "\\Gamma", "\\u0393;": "\\Gamma", "&#916;": "\\Delta", "&Delta;": "\\Delta", "&#x0394;": "\\Delta", "\\u0394;": "\\Delta", "&#917;": "\\Epsilon", "&Epsilon;": "\\Epsilon", "&#x0395;": "\\Epsilon", "\\u0395;": "\\Epsilon", "&#918;": "\\Zeta", "&Zeta;": "\\Zeta", "&#x0396;": "\\Zeta", "\\u0396;": "\\Zeta", "&#919;": "\\Eta", "&Eta;": "\\Eta", "&#x0397;": "\\Eta", "\\u0397;": "\\Eta", "&#920;": "\\Theta", "&Theta;": "\\Theta", "&#x0398;": "\\Theta", "\\u0398;": "\\Theta", "&#921;": "\\Iota", "&Iota;": "\\Iota", "&#x0399;": "\\Iota", "\\u0399;": "\\Iota", "&#922;": "\\Kappa", "&Kappa;": "\\Kappa", "&#x039A;": "\\Kappa", "\\u039A;": "\\Kappa", "&#923;": "\\Lambda", "&Lambda;": "\\Lambda", "&#x039B;": "\\Lambda", "\\u039B;": "\\Lambda", "&#924;": "\\Mu", "&Mu;": "\\Mu", "&#x039C;": "\\Mu", "\\u039C;": "\\Mu", "&#925;": "\\Nu", "&Nu;": "\\Nu", "&#x039D;": "\\Nu", "\\u039D;": "\\Nu", "&#926;": "\\Xi", "&Xi;": "\\Xi", "&#x039E;": "\\Xi", "\\u039E;": "\\Xi", "&#927;": "\\Omicron", "&Omicron;": "\\Omicron", "&#x039F;": "\\Omicron", "\\u039F;": "\\Omicron", "&#928;": "\\Pi", "&Pi;": "\\Pi", "&#x03A0;": "\\Pi", "\\u03A0;": "\\Pi", "&#929;": "\\Rho", "&Rho;": "\\Rho", "&#x03A1;": "\\Rho", "\\u03A1;": "\\Rho", "&#931;": "\\Sigma", "&Sigma;": "\\Sigma", "&#x03A3;": "\\Sigma", "\\u03A3;": "\\Sigma", "&#932;": "\\Tau", "&Tau;": "\\Tau", "&#x03A4;": "\\Tau", "\\u03A4;": "\\Tau", "&#933;": "\\Upsilon", "&Upsilon;": "\\Upsilon", "&#x03A5;": "\\Upsilon", "\\u03A5;": "\\Upsilon", "&#934;": "\\Phi", "&Phi;": "\\Phi", "&#x03A6;": "\\Phi", "\\u03A6;": "\\Phi", "&#935;": "\\Chi", "&Chi;": "\\Chi", "&#x03A7;": "\\Chi", "\\u03A7;": "\\Chi", "&#936;": "\\Psi", "&Psi;": "\\Psi", "&#x03A8;": "\\Psi", "\\u03A8;": "\\Psi", "&#937;": "\\Omega", "&Omega;": "\\Omega", "&#x03A9;": "\\Omega", "\\u03A9;": "\\Omega", "&#945;": "\\alpha", "&alpha;": "\\alpha", "&#x03B1;": "\\alpha", "\\u03B1;": "\\alpha", "&#946;": "\\beta", "&beta;": "\\beta", "&#x03B2;": "\\beta", "\\u03B2;": "\\beta", "&#947;": "\\gamma", "&gamma;": "\\gamma", "&#x03B3;": "\\gamma", "\\u03B3;": "\\gamma", "&#948;": "\\delta", "&delta;": "\\delta", "&#x03B4;": "\\delta", "\\u03B4;": "\\delta", "&#949;": "\\epsilon", "&epsilon;": "\\epsilon", "&#x03B5;": "\\epsilon", "\\u03B5;": "\\epsilon", "&#950;": "\\zeta", "&zeta;": "\\zeta", "&#x03B6;": "\\zeta", "\\u03B6;": "\\zeta", "&#951;": "\\eta", "&eta;": "\\eta", "&#x03B7;": "\\eta", "\\u03B7;": "\\eta", "&#952;": "\\theta", "&theta;": "\\theta", "&#x03B8;": "\\theta", "\\u03B8;": "\\theta", "&#953;": "\\iota", "&iota;": "\\iota", "&#x03B9;": "\\iota", "\\u03B9;": "\\iota", "&#954;": "\\kappa", "&kappa;": "\\kappa", "&#x03BA;": "\\kappa", "\\u03BA;": "\\kappa", "&#955;": "\\lambda", "&lambda;": "\\lambda", "&#x03BB;": "\\lambda", "\\u03BB;": "\\lambda", "&#956;": "\\mu", "&mu;": "\\mu", "&#x03BC;": "\\mu", "\\u03BC;": "\\mu", "&#957;": "\\nu", "&nu;": "\\nu", "&#x03BD;": "\\nu", "\\u03BD;": "\\nu", "&#958;": "\\xi", "&xi;": "\\xi", "&#x03BE;": "\\xi", "\\u03BE;": "\\xi", "&#959;": "\\omicron", "&omicron;": "\\omicron", "&#x03BF;": "\\omicron", "\\u03BF;": "\\omicron", "&#960;": "\\pi", "&pi;": "\\pi", "&#x03C0;": "\\pi", "\\u03C0;": "\\pi", "&#961;": "\\rho", "&rho;": "\\rho", "&#x03C1;": "\\rho", "\\u03C1;": "\\rho", "&#962;": "\\sigma", ";": "\\sigma", "&#x03C2;": "\\sigma", "\\u03C2;": "\\sigma", "&#963;": "\\sigma", "&sigma;": "\\sigma", "&#x03C3;": "\\sigma", "\\u03C3;": "\\sigma", "&#964;": "\\tau", "&tau;": "\\tau", "&#x03C4;": "\\tau", "\\u03C4;": "\\tau", "&#965;": "\\upsilon", "&upsilon;": "\\upsilon", "&#x03C5;": "\\upsilon", "\\u03C5;": "\\upsilon", "&#966;": "\\phi", "&phi;": "\\phi", "&#x03C6;": "\\phi", "\\u03C6;": "\\phi", "&#967;": "\\chi", "&chi;": "\\chi", "&#x03C7;": "\\chi", "\\u03C7;": "\\chi", "&#968;": "\\psi", "&psi;": "\\psi", "&#x03C8;": "\\psi", "\\u03C8;": "\\psi", "&#969;": "\\omega", "&omega;": "\\omega", "&#x03C9;": "\\omega", "\\u03C9;": "\\omega", "&#x2212;": "-", "&minus;": "-", "&#x221E;": "\\infty", "&#8734;": "\\infty", "&infin;": "\\infty", "&sdot;": "\\cdot", "&#x22C5;": "\\cdot", "&#8901;": "\\cdot", "&times;": "\\times", "&#x00D7;": "\\times", "&#215;": "\\times" };
class mmlToLatex {
  parse(e2) {
    return "mi" === e2.name ? entities[e2.content] ? entities[e2.content] : e2.content.length > 1 ? "\\" + e2.content : e2.content : "mn" === e2.name ? e2.content : "msup" === e2.name ? this.parse(e2.children[0]) + "^{" + this.parse(e2.children[1]) + "}" : "mroot" === e2.name ? "\\sqrt[" + this.parse(e2.children[1]) + "]{" + this.parse(e2.children[1]) + "}" : "mfrac" === e2.name ? "\\frac{" + this.parse(e2.children[0]) + "}{" + this.parse(e2.children[1]) + "}" : "msqrt" === e2.name ? "\\sqrt{" + e2.children.map((function(e3, t2) {
      return this.parse(e3);
    }).bind(this)).join(" ") + "}" : "mo" === e2.name ? entities[e2.content] ? entities[e2.content] : "&#x2061;" === e2.content ? " " : e2.content : "mrow" === e2.name && "MJX-TeXAtom-ORD" === e2.attributes.class ? e2.children.map((function(e3, t2) {
      return this.parse(e3);
    }).bind(this)).join(" ") : "math" === e2.name || "mrow" === e2.name ? "(" + e2.children.map((function(e3, t2) {
      return this.parse(e3);
    }).bind(this)).join(" ") + ")" : void 0;
  }
  convert(e2) {
    return this.parse(parseString(e2).root);
  }
}
class mmlToAst$1 {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1();
  }
  convert(e2) {
    return this.latexToAst.convert(this.mmlToLatex.convert(e2));
  }
}
class mmlToGuppy {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToGuppy = new astToGuppy$1();
  }
  convert(e2) {
    return this.astToGuppy.convert(this.latexToAst.convert(this.mmlToLatex.convert(e2)));
  }
}
class mmlToMathjs {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToMathjs = new astToMathjs$1();
  }
  convert(e2) {
    return this.astToMathjs.convert(this.latexToAst.convert(this.mmlToLatex.convert(e2)));
  }
}
class mmlToText {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToText = new astToText$2();
  }
  convert(e2) {
    return this.astToText.convert(this.latexToAst.convert(this.mmlToLatex.convert(e2)));
  }
}
class textToGuppy {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToGuppy = new astToGuppy$1();
  }
  convert(e2) {
    return this.astToGuppy.convert(this.textToAst.convert(e2));
  }
}
class textToLatex {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToLatex = new astToLatex$1();
  }
  convert(e2) {
    return this.astToLatex.convert(this.textToAst.convert(e2));
  }
}
class textToMathjs {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToMathjs = new astToMathjs$1();
  }
  convert(e2) {
    return this.astToMathjs.convert(this.textToAst.convert(e2));
  }
}
var converters = Object.freeze({ __proto__: null, astToLatexObj: astToLatex$1, astToTextObj: astToText$2, astToGuppyObj: astToGuppy$1, astToMathjsObj: astToMathjs$1, astToFiniteFieldObj: astToFiniteField$1, latexToAstObj: latexToAst$1, latexToGuppyObj: latexToGuppy, latexToMathjsObj: latexToMathjs, latexToTextObj: latexToText, mathjsToAstObj: mathjsToAst, mathjsToGuppyObj: mathjsToGuppy, mathjsToLatexObj: mathjsToLatex, mathjsToTextObj: mathjsToText, mmlToAstObj: mmlToAst$1, mmlToGuppyObj: mmlToGuppy, mmlToLatexObj: mmlToLatex, mmlToMathjsObj: mmlToMathjs, mmlToTextObj: mmlToText, textToAstObj: textToAst$4, textToGuppyObj: textToGuppy, textToLatexObj: textToLatex, textToMathjsObj: textToMathjs, astToGLSL: astToGLSL$1 }), textToAst = new textToAst$4(), latexToAst = new latexToAst$1(), mmlToAst = new mmlToAst$1(), utils$1 = { match: match$2, flatten: flatten$5, unflattenLeft, unflattenRight };
function Expression(e2, t2) {
  this.tree = flatten$5(e2), this.context = t2, this.toJSON = function() {
    let e3 = { objectType: "math-expression", tree: this.tree }, t22 = {};
    for (let e4 in this.context.assumptions) Object.keys(this.context.assumptions[e4]).length > 0 && (t22[e4] = this.context.assumptions[e4]);
    return Object.keys(t22).length > 0 && (e3.assumptions = t22), e3;
  };
}
function extend$3(e2, t2) {
  return flatten_array(Array.prototype.slice.call(arguments, 2)).forEach((function(r) {
    if (r) for (var n in r) t2 ? (function() {
      var t22 = n;
      e2[t22] = function() {
        return this.fromAst(r[t22].apply(null, arguments));
      };
    })() : e2[n] = r[n];
  })), e2;
}
function extend_prototype(e2, t2) {
  return flatten_array(Array.prototype.slice.call(arguments, 2)).forEach((function(r) {
    if (r) for (var n in r) !(function() {
      var i2 = n;
      e2[i2] = function() {
        var e3 = [this].concat(Array.prototype.slice.call(arguments));
        return t2 ? this.context.fromAst(r[i2].apply(null, e3)) : r[i2].apply(null, e3);
      };
    })();
  })), e2;
}
function create_from_multiple(e2, t2) {
  if (Array.isArray(e2) || "number" == typeof e2) return new Expression(e2, Context);
  if ("string" == typeof e2) try {
    return new Expression(textToAst.convert(e2), Context);
  } catch (t22) {
    try {
      return new Expression(latexToAst.convert(e2), Context);
    } catch (r) {
      try {
        return new Expression(mmlToAst.convert(e2), Context);
      } catch (n) {
        if (-1 !== e2.indexOf("\\")) throw r;
        if (-1 !== e2.indexOf("</")) throw n;
        throw t22;
      }
    }
  }
}
function parseText(e2, t2) {
  return new Expression(textToAst.convert(e2), Context);
}
function parseLatex(e2, t2) {
  return new Expression(latexToAst.convert(e2), Context);
}
function parseMml(e2, t2) {
  return new Expression(mmlToAst.convert(e2), Context);
}
var Context = { ZmodN, assumptions: initialize_assumptions(), parser_parameters: {}, from: create_from_multiple, fromText: parseText, parse: parseText, fromLaTeX: parseLatex, fromLatex: parseLatex, fromTeX: parseLatex, fromTex: parseLatex, fromMml: parseMml, parse_tex: parseLatex, converters, utils: utils$1, fromAst: function(e2) {
  return new Expression(e2, this);
}, set_to_default: function() {
  this.assumptions = initialize_assumptions();
}, get_assumptions: function(e2, t2) {
  return get_assumptions(this.assumptions, e2, t2);
}, add_assumption: function(e2, t2) {
  return add_assumption(this.assumptions, e2, t2);
}, add_generic_assumption: function(e2) {
  return add_generic_assumption(this.assumptions, e2);
}, remove_assumption: function(e2) {
  return remove_assumption(this.assumptions, e2);
}, remove_generic_assumption: function(e2) {
  return remove_generic_assumption(this.assumptions, e2);
}, clear_assumptions: function() {
  this.assumptions = initialize_assumptions();
}, math: math$1, reviver: function(e2, t2) {
  if (t2 && "math-expression" === t2.objectType && void 0 !== t2.tree) {
    let e3 = Context.fromAst(t2.tree);
    return void 0 !== t2.assumptions && (e3.assumptions = t2.assumptions), e3;
  }
  return t2;
}, class: Expression };
function flatten_array(e2, t2) {
  t2 = void 0 === t2 ? [] : t2;
  for (var r = 0; r < e2.length; r++) Array.isArray(e2[r]) ? flatten_array(e2[r], t2) : t2.push(e2[r]);
  return t2;
}
Context.set_to_default(), extend$3(Context, true, expression_to_tree$1, expression_to_tree), extend$3(Context, false, expression_to_other), extend_prototype(Expression.prototype, true, expression_to_tree$1), extend_prototype(Expression.prototype, false, expression_to_other);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var base32$1 = { exports: {} };
var hasRequiredBase32;
function requireBase32() {
  if (hasRequiredBase32) return base32$1.exports;
  hasRequiredBase32 = 1;
  (function(module) {
    (function() {
      var root2 = typeof window === "object" ? window : {};
      var NODE_JS = !root2.HI_BASE32_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
      if (NODE_JS) {
        root2 = commonjsGlobal;
      }
      var COMMON_JS = !root2.HI_BASE32_NO_COMMON_JS && true && module.exports;
      var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
      var BASE32_DECODE_CHAR = {
        "A": 0,
        "B": 1,
        "C": 2,
        "D": 3,
        "E": 4,
        "F": 5,
        "G": 6,
        "H": 7,
        "I": 8,
        "J": 9,
        "K": 10,
        "L": 11,
        "M": 12,
        "N": 13,
        "O": 14,
        "P": 15,
        "Q": 16,
        "R": 17,
        "S": 18,
        "T": 19,
        "U": 20,
        "V": 21,
        "W": 22,
        "X": 23,
        "Y": 24,
        "Z": 25,
        "2": 26,
        "3": 27,
        "4": 28,
        "5": 29,
        "6": 30,
        "7": 31
      };
      var blocks = [0, 0, 0, 0, 0, 0, 0, 0];
      var throwInvalidUtf8 = function(position2, partial2) {
        if (partial2.length > 10) {
          partial2 = "..." + partial2.substr(-10);
        }
        var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position2 + " bytes: " + partial2 + " <-");
        err.position = position2;
        throw err;
      };
      var toUtf8String = function(bytes) {
        var str = "", length = bytes.length, i2 = 0, followingChars = 0, b2, c2;
        while (i2 < length) {
          b2 = bytes[i2++];
          if (b2 <= 127) {
            str += String.fromCharCode(b2);
            continue;
          } else if (b2 > 191 && b2 <= 223) {
            c2 = b2 & 31;
            followingChars = 1;
          } else if (b2 <= 239) {
            c2 = b2 & 15;
            followingChars = 2;
          } else if (b2 <= 247) {
            c2 = b2 & 7;
            followingChars = 3;
          } else {
            throwInvalidUtf8(i2, str);
          }
          for (var j2 = 0; j2 < followingChars; ++j2) {
            b2 = bytes[i2++];
            if (b2 < 128 || b2 > 191) {
              throwInvalidUtf8(i2, str);
            }
            c2 <<= 6;
            c2 += b2 & 63;
          }
          if (c2 >= 55296 && c2 <= 57343) {
            throwInvalidUtf8(i2, str);
          }
          if (c2 > 1114111) {
            throwInvalidUtf8(i2, str);
          }
          if (c2 <= 65535) {
            str += String.fromCharCode(c2);
          } else {
            c2 -= 65536;
            str += String.fromCharCode((c2 >> 10) + 55296);
            str += String.fromCharCode((c2 & 1023) + 56320);
          }
        }
        return str;
      };
      var decodeAsBytes = function(base32Str) {
        if (base32Str === "") {
          return [];
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        base32Str = base32Str.replace(/=/g, "");
        var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index2 = 0, length = base32Str.length;
        for (var i2 = 0, count = length >> 3 << 3; i2 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
          bytes[index2++] = (v7 << 5 | v8) & 255;
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
        }
        return bytes;
      };
      var encodeAscii = function(str) {
        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
        for (var i2 = 0, count = parseInt(length / 5) * 5; i2 < count; ) {
          v1 = str.charCodeAt(i2++);
          v2 = str.charCodeAt(i2++);
          v3 = str.charCodeAt(i2++);
          v4 = str.charCodeAt(i2++);
          v5 = str.charCodeAt(i2++);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = str.charCodeAt(i2);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = str.charCodeAt(i2++);
          v2 = str.charCodeAt(i2);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = str.charCodeAt(i2++);
          v2 = str.charCodeAt(i2++);
          v3 = str.charCodeAt(i2);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = str.charCodeAt(i2++);
          v2 = str.charCodeAt(i2++);
          v3 = str.charCodeAt(i2++);
          v4 = str.charCodeAt(i2);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encodeUtf8 = function(str) {
        var v1, v2, v3, v4, v5, code2, end = false, base32Str = "", index2 = 0, i2, start = 0, length = str.length;
        if (str === "") {
          return base32Str;
        }
        do {
          blocks[0] = blocks[5];
          blocks[1] = blocks[6];
          blocks[2] = blocks[7];
          for (i2 = start; index2 < length && i2 < 5; ++index2) {
            code2 = str.charCodeAt(index2);
            if (code2 < 128) {
              blocks[i2++] = code2;
            } else if (code2 < 2048) {
              blocks[i2++] = 192 | code2 >> 6;
              blocks[i2++] = 128 | code2 & 63;
            } else if (code2 < 55296 || code2 >= 57344) {
              blocks[i2++] = 224 | code2 >> 12;
              blocks[i2++] = 128 | code2 >> 6 & 63;
              blocks[i2++] = 128 | code2 & 63;
            } else {
              code2 = 65536 + ((code2 & 1023) << 10 | str.charCodeAt(++index2) & 1023);
              blocks[i2++] = 240 | code2 >> 18;
              blocks[i2++] = 128 | code2 >> 12 & 63;
              blocks[i2++] = 128 | code2 >> 6 & 63;
              blocks[i2++] = 128 | code2 & 63;
            }
          }
          start = i2 - 5;
          if (index2 === length) {
            ++index2;
          }
          if (index2 > length && i2 < 6) {
            end = true;
          }
          v1 = blocks[0];
          if (i2 > 4) {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            v5 = blocks[4];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
          } else if (i2 === 1) {
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
          } else if (i2 === 2) {
            v2 = blocks[1];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
          } else if (i2 === 3) {
            v2 = blocks[1];
            v3 = blocks[2];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
          } else {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
          }
        } while (!end);
        return base32Str;
      };
      var encodeBytes = function(bytes) {
        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
        for (var i2 = 0, count = parseInt(length / 5) * 5; i2 < count; ) {
          v1 = bytes[i2++];
          v2 = bytes[i2++];
          v3 = bytes[i2++];
          v4 = bytes[i2++];
          v5 = bytes[i2++];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = bytes[i2];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = bytes[i2++];
          v2 = bytes[i2];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = bytes[i2++];
          v2 = bytes[i2++];
          v3 = bytes[i2];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = bytes[i2++];
          v2 = bytes[i2++];
          v3 = bytes[i2++];
          v4 = bytes[i2];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encode2 = function(input, asciiOnly) {
        var notString = typeof input !== "string";
        if (notString && input.constructor === ArrayBuffer) {
          input = new Uint8Array(input);
        }
        if (notString) {
          return encodeBytes(input);
        } else if (asciiOnly) {
          return encodeAscii(input);
        } else {
          return encodeUtf8(input);
        }
      };
      var decode = function(base32Str, asciiOnly) {
        if (!asciiOnly) {
          return toUtf8String(decodeAsBytes(base32Str));
        }
        if (base32Str === "") {
          return "";
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
        if (length === -1) {
          length = base32Str.length;
        }
        for (var i2 = 0, count = length >> 3 << 3; i2 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i2++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
        }
        return str;
      };
      var exports$12 = {
        encode: encode2,
        decode
      };
      decode.asBytes = decodeAsBytes;
      if (COMMON_JS) {
        module.exports = exports$12;
      } else {
        root2.base32 = exports$12;
      }
    })();
  })(base32$1);
  return base32$1.exports;
}
requireBase32();
const mathjaxConfig = {
  tex: {
    tags: "ams",
    macros: {
      lt: "<",
      gt: ">",
      amp: "&",
      var: ["\\mathrm{#1}", 1],
      csch: "\\operatorname{csch}",
      sech: "\\operatorname{sech}",
      erf: "\\operatorname{erf}"
    },
    displayMath: [["\\[", "\\]"]]
  },
  output: {
    displayOverflow: "linebreak"
  }
};
var cssesc_1;
var hasRequiredCssesc;
function requireCssesc() {
  if (hasRequiredCssesc) return cssesc_1;
  hasRequiredCssesc = 1;
  var object2 = {};
  var hasOwnProperty2 = object2.hasOwnProperty;
  var merge = function merge2(options2, defaults2) {
    if (!options2) {
      return defaults2;
    }
    var result2 = {};
    for (var key in defaults2) {
      result2[key] = hasOwnProperty2.call(options2, key) ? options2[key] : defaults2[key];
    }
    return result2;
  };
  var regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
  var regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
  var regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
  var cssesc2 = function cssesc3(string2, options2) {
    options2 = merge(options2, cssesc3.options);
    if (options2.quotes != "single" && options2.quotes != "double") {
      options2.quotes = "single";
    }
    var quote2 = options2.quotes == "double" ? '"' : "'";
    var isIdentifier = options2.isIdentifier;
    var firstChar = string2.charAt(0);
    var output = "";
    var counter2 = 0;
    var length = string2.length;
    while (counter2 < length) {
      var character = string2.charAt(counter2++);
      var codePoint = character.charCodeAt();
      var value = void 0;
      if (codePoint < 32 || codePoint > 126) {
        if (codePoint >= 55296 && codePoint <= 56319 && counter2 < length) {
          var extra = string2.charCodeAt(counter2++);
          if ((extra & 64512) == 56320) {
            codePoint = ((codePoint & 1023) << 10) + (extra & 1023) + 65536;
          } else {
            counter2--;
          }
        }
        value = "\\" + codePoint.toString(16).toUpperCase() + " ";
      } else {
        if (options2.escapeEverything) {
          if (regexAnySingleEscape.test(character)) {
            value = "\\" + character;
          } else {
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
          }
        } else if (/[\t\n\f\r\x0B]/.test(character)) {
          value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else if (character == "\\" || !isIdentifier && (character == '"' && quote2 == character || character == "'" && quote2 == character) || isIdentifier && regexSingleEscape.test(character)) {
          value = "\\" + character;
        } else {
          value = character;
        }
      }
      output += value;
    }
    if (isIdentifier) {
      if (/^-[-\d]/.test(output)) {
        output = "\\-" + output.slice(1);
      } else if (/\d/.test(firstChar)) {
        output = "\\3" + firstChar + " " + output.slice(1);
      }
    }
    output = output.replace(regexExcessiveSpaces, function($0, $1, $2) {
      if ($1 && $1.length % 2) {
        return $0;
      }
      return ($1 || "") + $2;
    });
    if (!isIdentifier && options2.wrap) {
      return quote2 + output + quote2;
    }
    return output;
  };
  cssesc2.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
  };
  cssesc2.version = "3.0.0";
  cssesc_1 = cssesc2;
  return cssesc_1;
}
requireCssesc();
const globalThis$1 = Function("return this")() || {};
const virtualKeyboardState = globalThis$1?.virtualKeyboardState || {
  count: 0,
  keyboardDomNode: null,
  keyboardReactRoot: null,
  callbacks: []
};
globalThis$1.virtualKeyboardState = virtualKeyboardState;
function UniqueKeyboardTray({ onClick }) {
  React__default.useEffect(() => {
    if (virtualKeyboardState.count === 0) {
      const keyboardDomNode = document.createElement("footer");
      keyboardDomNode.id = "virtual-keyboard-dummy";
      document.body.appendChild(keyboardDomNode);
      virtualKeyboardState.keyboardDomNode = keyboardDomNode;
      const root2 = clientExports.createRoot(keyboardDomNode);
      virtualKeyboardState.keyboardReactRoot = root2;
      root2.render(
        /* @__PURE__ */ React__default.createElement(MathJaxContext, { config: mathjaxConfig, version: 4 }, /* @__PURE__ */ React__default.createElement(
          KeyboardTray,
          {
            onClick: (e2) => {
              virtualKeyboardState.callbacks.forEach(
                (cb2) => cb2(e2)
              );
            }
          }
        ))
      );
    }
    virtualKeyboardState.count += 1;
    virtualKeyboardState.callbacks.push(onClick);
    return () => {
      const callbackIndex = virtualKeyboardState.callbacks.indexOf(onClick);
      virtualKeyboardState.callbacks.splice(callbackIndex, 1);
      virtualKeyboardState.count -= 1;
      if (virtualKeyboardState.count === 0) {
        if (virtualKeyboardState.keyboardReactRoot) {
          const root2 = virtualKeyboardState.keyboardReactRoot;
          setTimeout(() => {
            root2.unmount();
          }, 0);
          virtualKeyboardState.keyboardReactRoot = null;
        }
        if (virtualKeyboardState.keyboardDomNode) {
          document.body.removeChild(
            virtualKeyboardState.keyboardDomNode
          );
          virtualKeyboardState.keyboardDomNode = null;
        }
      }
    };
  }, []);
  return null;
}
function ExternalAwareVirtualKeyboard({
  externalVirtualKeyboardProvided = false,
  onClick = () => {
  }
}) {
  React__default.useEffect(() => {
    if (externalVirtualKeyboardProvided) {
      const listener = (event) => {
        if (event.origin !== window.parent.location.origin || event.data?.subject !== "keyboard") {
          return;
        }
        onClick(event.data.keyCommands);
      };
      window.parent.addEventListener("message", listener);
      return () => {
        window.parent.removeEventListener("message", listener);
      };
    }
  }, [externalVirtualKeyboardProvided]);
  return externalVirtualKeyboardProvided ? null : /* @__PURE__ */ React__default.createElement(UniqueKeyboardTray, { onClick });
}
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  if (hasRequiredClassnames) return classnames.exports;
  hasRequiredClassnames = 1;
  (function(module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i2 = 0; i2 < arguments.length; i2++) {
          var arg = arguments[i2];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else {
        window.classNames = classNames2;
      }
    })();
  })(classnames);
  return classnames.exports;
}
var classnamesExports = requireClassnames();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs$6(classnamesExports);
function noop$2(..._2) {
}
function applyState$1(argument, currentValue) {
  if (isUpdater$1(argument)) {
    const value = isLazyValue$1(currentValue) ? currentValue() : currentValue;
    return argument(value);
  }
  return argument;
}
function isUpdater$1(argument) {
  return typeof argument === "function";
}
function isLazyValue$1(value) {
  return typeof value === "function";
}
function hasOwnProperty$3(object2, prop) {
  if (typeof Object.hasOwn === "function") {
    return Object.hasOwn(object2, prop);
  }
  return Object.prototype.hasOwnProperty.call(object2, prop);
}
function chain$1(...fns) {
  return (...args) => {
    for (const fn of fns) {
      if (typeof fn === "function") {
        fn(...args);
      }
    }
  };
}
function omit$1(object2, keys2) {
  const result2 = { ...object2 };
  for (const key of keys2) {
    if (hasOwnProperty$3(result2, key)) {
      delete result2[key];
    }
  }
  return result2;
}
function pick$1(object2, paths) {
  const result2 = {};
  for (const key of paths) {
    if (hasOwnProperty$3(object2, key)) {
      result2[key] = object2[key];
    }
  }
  return result2;
}
function identity$1(value) {
  return value;
}
function invariant$1(condition, message) {
  if (condition) return;
  if (typeof message !== "string") throw new Error("Invariant failed");
  throw new Error(message);
}
function getKeys$1(obj) {
  return Object.keys(obj);
}
function disabledFromProps$1(props2) {
  return props2.disabled || props2["aria-disabled"] === true || props2["aria-disabled"] === "true";
}
function removeUndefinedValues$1(obj) {
  const result2 = {};
  for (const key in obj) {
    if (obj[key] !== void 0) {
      result2[key] = obj[key];
    }
  }
  return result2;
}
function defaultValue$1(...values2) {
  for (const value of values2) {
    if (value !== void 0) return value;
  }
  return void 0;
}
function setRef$1(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function isValidElementWithRef$1(element2) {
  if (!element2) return false;
  if (!isValidElement$1(element2)) return false;
  if ("ref" in element2.props) return true;
  if ("ref" in element2) return true;
  return false;
}
function getRefProperty$1(element2) {
  if (!isValidElementWithRef$1(element2)) return null;
  const props2 = { ...element2.props };
  return props2.ref || element2.ref;
}
function mergeProps$1(base2, overrides2) {
  const props2 = { ...base2 };
  for (const key in overrides2) {
    if (!hasOwnProperty$3(overrides2, key)) continue;
    if (key === "className") {
      const prop = "className";
      props2[prop] = base2[prop] ? `${base2[prop]} ${overrides2[prop]}` : overrides2[prop];
      continue;
    }
    if (key === "style") {
      const prop = "style";
      props2[prop] = base2[prop] ? { ...base2[prop], ...overrides2[prop] } : overrides2[prop];
      continue;
    }
    const overrideValue = overrides2[key];
    if (typeof overrideValue === "function" && key.startsWith("on")) {
      const baseValue = base2[key];
      if (typeof baseValue === "function") {
        props2[key] = (...args) => {
          overrideValue(...args);
          baseValue(...args);
        };
        continue;
      }
    }
    props2[key] = overrideValue;
  }
  return props2;
}
var canUseDOM$1 = checkIsBrowser$1();
function checkIsBrowser$1() {
  var _a2;
  return typeof window !== "undefined" && !!((_a2 = window.document) == null ? void 0 : _a2.createElement);
}
function getDocument$1(node) {
  if (!node) return document;
  if ("self" in node) return node.document;
  return node.ownerDocument || document;
}
function getActiveElement$1(node, activeDescendant = false) {
  const { activeElement } = getDocument$1(node);
  if (!(activeElement == null ? void 0 : activeElement.nodeName)) {
    return null;
  }
  if (isFrame$1(activeElement) && activeElement.contentDocument) {
    return getActiveElement$1(
      activeElement.contentDocument.body,
      activeDescendant
    );
  }
  if (activeDescendant) {
    const id2 = activeElement.getAttribute("aria-activedescendant");
    if (id2) {
      const element2 = getDocument$1(activeElement).getElementById(id2);
      if (element2) {
        return element2;
      }
    }
  }
  return activeElement;
}
function contains$2(parent, child) {
  return parent === child || parent.contains(child);
}
function isFrame$1(element2) {
  return element2.tagName === "IFRAME";
}
function isButton$1(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "button") return true;
  if (tagName === "input" && element2.type) {
    return buttonInputTypes$1.indexOf(element2.type) !== -1;
  }
  return false;
}
var buttonInputTypes$1 = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function isVisible$1(element2) {
  if (typeof element2.checkVisibility === "function") {
    return element2.checkVisibility();
  }
  const htmlElement = element2;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element2.getClientRects().length > 0;
}
function isTextField$1(element2) {
  try {
    const isTextInput = element2 instanceof HTMLInputElement && element2.selectionStart !== null;
    const isTextArea = element2.tagName === "TEXTAREA";
    return isTextInput || isTextArea || false;
  } catch (_error) {
    return false;
  }
}
function isTextbox$1(element2) {
  return element2.isContentEditable || isTextField$1(element2);
}
function getTextboxValue$1(element2) {
  if (isTextField$1(element2)) {
    return element2.value;
  }
  if (element2.isContentEditable) {
    const range2 = getDocument$1(element2).createRange();
    range2.selectNodeContents(element2);
    return range2.toString();
  }
  return "";
}
function getTextboxSelection$1(element2) {
  let start = 0;
  let end = 0;
  if (isTextField$1(element2)) {
    start = element2.selectionStart || 0;
    end = element2.selectionEnd || 0;
  } else if (element2.isContentEditable) {
    const selection2 = getDocument$1(element2).getSelection();
    if ((selection2 == null ? void 0 : selection2.rangeCount) && selection2.anchorNode && contains$2(element2, selection2.anchorNode) && selection2.focusNode && contains$2(element2, selection2.focusNode)) {
      const range2 = selection2.getRangeAt(0);
      const nextRange = range2.cloneRange();
      nextRange.selectNodeContents(element2);
      nextRange.setEnd(range2.startContainer, range2.startOffset);
      start = nextRange.toString().length;
      nextRange.setEnd(range2.endContainer, range2.endOffset);
      end = nextRange.toString().length;
    }
  }
  return { start, end };
}
function getScrollingElement$1(element2) {
  if (!element2) return null;
  const isScrollableOverflow = (overflow) => {
    if (overflow === "auto") return true;
    if (overflow === "scroll") return true;
    return false;
  };
  if (element2.clientHeight && element2.scrollHeight > element2.clientHeight) {
    const { overflowY } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowY)) return element2;
  } else if (element2.clientWidth && element2.scrollWidth > element2.clientWidth) {
    const { overflowX } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowX)) return element2;
  }
  return getScrollingElement$1(element2.parentElement) || document.scrollingElement || document.body;
}
function sortBasedOnDOMPosition$1(items, getElement) {
  const pairs2 = items.map((item, index2) => [index2, item]);
  let isOrderDifferent = false;
  pairs2.sort(([indexA, a], [indexB, b2]) => {
    const elementA = getElement(a);
    const elementB = getElement(b2);
    if (elementA === elementB) return 0;
    if (!elementA || !elementB) return 0;
    if (isElementPreceding$1(elementA, elementB)) {
      if (indexA > indexB) {
        isOrderDifferent = true;
      }
      return -1;
    }
    if (indexA < indexB) {
      isOrderDifferent = true;
    }
    return 1;
  });
  if (isOrderDifferent) {
    return pairs2.map(([_2, item]) => item);
  }
  return items;
}
function isElementPreceding$1(a, b2) {
  return Boolean(
    b2.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING
  );
}
function isApple$1() {
  if (!canUseDOM$1) return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform);
}
function isSafari$1() {
  return canUseDOM$1 && isApple$1() && /apple/i.test(navigator.vendor);
}
function isFirefox$1() {
  return canUseDOM$1 && /firefox\//i.test(navigator.userAgent);
}
function isPortalEvent$1(event) {
  return Boolean(
    event.currentTarget && !contains$2(event.currentTarget, event.target)
  );
}
function isSelfTarget$1(event) {
  return event.target === event.currentTarget;
}
function fireBlurEvent$1(element2, eventInit) {
  const event = new FocusEvent("blur", eventInit);
  const defaultAllowed = element2.dispatchEvent(event);
  const bubbleInit = { ...eventInit, bubbles: true };
  element2.dispatchEvent(new FocusEvent("focusout", bubbleInit));
  return defaultAllowed;
}
function fireKeyboardEvent$1(element2, type, eventInit) {
  const event = new KeyboardEvent(type, eventInit);
  return element2.dispatchEvent(event);
}
function fireClickEvent$1(element2, eventInit) {
  const event = new MouseEvent("click", eventInit);
  return element2.dispatchEvent(event);
}
function isFocusEventOutside$1(event, container) {
  const containerElement = event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains$2(containerElement, relatedTarget);
}
function queueBeforeEvent$1(element2, type, callback, timeout) {
  const createTimer = (callback2) => {
    const timerId = requestAnimationFrame(callback2);
    return () => cancelAnimationFrame(timerId);
  };
  const cancelTimer = createTimer(() => {
    element2.removeEventListener(type, callSync, true);
    callback();
  });
  const callSync = () => {
    cancelTimer();
    callback();
  };
  element2.addEventListener(type, callSync, { once: true, capture: true });
  return cancelTimer;
}
function addGlobalEventListener$1(type, listener, options2, scope = window) {
  const children = [];
  try {
    scope.document.addEventListener(type, listener, options2);
    for (const frame of Array.from(scope.frames)) {
      children.push(addGlobalEventListener$1(type, listener, options2, frame));
    }
  } catch (e2) {
  }
  const removeEventListener2 = () => {
    try {
      scope.document.removeEventListener(type, listener, options2);
    } catch (e2) {
    }
    for (const remove2 of children) {
      remove2();
    }
  };
  return removeEventListener2;
}
var _React$1 = { ...React };
var useReactId$1 = _React$1.useId;
var useReactInsertionEffect$1 = _React$1.useInsertionEffect;
var useSafeLayoutEffect$1 = canUseDOM$1 ? useLayoutEffect : useEffect;
function useLiveRef$1(value) {
  const ref = useRef(value);
  useSafeLayoutEffect$1(() => {
    ref.current = value;
  });
  return ref;
}
function useEvent$1(callback) {
  const ref = useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  if (useReactInsertionEffect$1) {
    useReactInsertionEffect$1(() => {
      ref.current = callback;
    });
  } else {
    ref.current = callback;
  }
  return useCallback((...args) => {
    var _a2;
    return (_a2 = ref.current) == null ? void 0 : _a2.call(ref, ...args);
  }, []);
}
function useTransactionState$1(callback) {
  const [state, setState] = useState(null);
  useSafeLayoutEffect$1(() => {
    if (state == null) return;
    if (!callback) return;
    let prevState = null;
    callback((prev) => {
      prevState = prev;
      return state;
    });
    return () => {
      callback(prevState);
    };
  }, [state, callback]);
  return [state, setState];
}
function useMergeRefs$1(...refs) {
  return useMemo(() => {
    if (!refs.some(Boolean)) return;
    return (value) => {
      for (const ref of refs) {
        setRef$1(ref, value);
      }
    };
  }, refs);
}
function useId$1(defaultId) {
  if (useReactId$1) {
    const reactId = useReactId$1();
    if (defaultId) return defaultId;
    return reactId;
  }
  const [id2, setId] = useState(defaultId);
  useSafeLayoutEffect$1(() => {
    if (defaultId || id2) return;
    const random2 = Math.random().toString(36).slice(2, 8);
    setId(`id-${random2}`);
  }, [defaultId, id2]);
  return defaultId || id2;
}
function useTagName$1(refOrElement, type) {
  const stringOrUndefined = (type2) => {
    if (typeof type2 !== "string") return;
    return type2;
  };
  const [tagName, setTagName] = useState(() => stringOrUndefined(type));
  useSafeLayoutEffect$1(() => {
    const element2 = refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement;
    setTagName((element2 == null ? void 0 : element2.tagName.toLowerCase()) || stringOrUndefined(type));
  }, [refOrElement, type]);
  return tagName;
}
function useUpdateEffect$1(effect, deps) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) {
      return effect();
    }
    mounted.current = true;
  }, deps);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );
}
function useForceUpdate$1() {
  return useReducer(() => [], []);
}
function useBooleanEvent$1(booleanOrCallback) {
  return useEvent$1(
    typeof booleanOrCallback === "function" ? booleanOrCallback : () => booleanOrCallback
  );
}
function useWrapElement$1(props2, callback, deps = []) {
  const wrapElement = useCallback(
    (element2) => {
      if (props2.wrapElement) {
        element2 = props2.wrapElement(element2);
      }
      return callback(element2);
    },
    [...deps, props2.wrapElement]
  );
  return { ...props2, wrapElement };
}
function useMetadataProps$1(props2, key, value) {
  const parent = props2.onLoadedMetadataCapture;
  const onLoadedMetadataCapture = useMemo(() => {
    return Object.assign(() => {
    }, { ...parent, [key]: value });
  }, [parent, key, value]);
  return [parent == null ? void 0 : parent[key], { onLoadedMetadataCapture }];
}
function getDefaultExportFromCjs$1(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var jsxRuntime$1 = { exports: {} };
var reactJsxRuntime_production$1 = {};
var hasRequiredReactJsxRuntime_production$1;
function requireReactJsxRuntime_production$1() {
  if (hasRequiredReactJsxRuntime_production$1) return reactJsxRuntime_production$1;
  hasRequiredReactJsxRuntime_production$1 = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production$1.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production$1.jsx = jsxProd;
  reactJsxRuntime_production$1.jsxs = jsxProd;
  return reactJsxRuntime_production$1;
}
var reactJsxRuntime_development$1 = {};
var hasRequiredReactJsxRuntime_development$1;
function requireReactJsxRuntime_development$1() {
  if (hasRequiredReactJsxRuntime_development$1) return reactJsxRuntime_development$1;
  hasRequiredReactJsxRuntime_development$1 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name2 = getComponentNameFromType(type);
        return name2 ? "<" + name2 + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props2, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props2, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props2, owner, debugStack, debugTask) {
      var refProp = props2.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props: props2,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node) {
      isValidElement2(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement2(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement2(object2) {
      return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React2 = React__default, REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React2 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React2.react_stack_bottom_frame.bind(
      React2,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development$1.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development$1.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development$1.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development$1;
}
var hasRequiredJsxRuntime$1;
function requireJsxRuntime$1() {
  if (hasRequiredJsxRuntime$1) return jsxRuntime$1.exports;
  hasRequiredJsxRuntime$1 = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime$1.exports = requireReactJsxRuntime_production$1();
  } else {
    jsxRuntime$1.exports = requireReactJsxRuntime_development$1();
  }
  return jsxRuntime$1.exports;
}
var jsxRuntimeExports$1 = requireJsxRuntime$1();
function forwardRef2$1(render) {
  const Role3 = React.forwardRef((props2, ref) => render({ ...props2, ref }));
  Role3.displayName = render.displayName || render.name;
  return Role3;
}
function memo2$1(Component, propsAreEqual) {
  return React.memo(Component, propsAreEqual);
}
function createElement$1(Type, props2) {
  const { wrapElement, render, ...rest2 } = props2;
  const mergedRef = useMergeRefs$1(props2.ref, getRefProperty$1(render));
  let element2;
  if (React.isValidElement(render)) {
    const renderProps = { ...render.props, ref: mergedRef };
    element2 = React.cloneElement(render, mergeProps$1(rest2, renderProps));
  } else if (render) {
    element2 = render(rest2);
  } else {
    element2 = /* @__PURE__ */ jsxRuntimeExports$1.jsx(Type, { ...rest2 });
  }
  if (wrapElement) {
    return wrapElement(element2);
  }
  return element2;
}
function createHook$1(useProps) {
  const useRole = (props2 = {}) => {
    return useProps(props2);
  };
  useRole.displayName = useProps.name;
  return useRole;
}
function createStoreContext$1(providers = [], scopedProviders = []) {
  const context = React.createContext(void 0);
  const scopedContext = React.createContext(void 0);
  const useContext2 = () => React.useContext(context);
  const useScopedContext = (onlyScoped = false) => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (onlyScoped) return scoped;
    return scoped || store2;
  };
  const useProviderContext = () => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (scoped && scoped === store2) return;
    return store2;
  };
  const ContextProvider = (props2) => {
    return providers.reduceRight(
      (children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(Provider2, { ...props2, children }),
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(context.Provider, { ...props2 })
    );
  };
  const ScopedContextProvider = (props2) => {
    return /* @__PURE__ */ jsxRuntimeExports$1.jsx(ContextProvider, { ...props2, children: scopedProviders.reduceRight(
      (children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(Provider2, { ...props2, children }),
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(scopedContext.Provider, { ...props2 })
    ) });
  };
  return {
    context,
    scopedContext,
    useContext: useContext2,
    useScopedContext,
    useProviderContext,
    ContextProvider,
    ScopedContextProvider
  };
}
var ctx$3$1 = createStoreContext$1();
var useCollectionContext$1 = ctx$3$1.useContext;
var CollectionContextProvider$1 = ctx$3$1.ContextProvider;
var CollectionScopedContextProvider$1 = ctx$3$1.ScopedContextProvider;
var ctx$2$1 = createStoreContext$1(
  [CollectionContextProvider$1],
  [CollectionScopedContextProvider$1]
);
var useCompositeContext$1 = ctx$2$1.useContext;
var useCompositeProviderContext$1 = ctx$2$1.useProviderContext;
var CompositeContextProvider$1 = ctx$2$1.ContextProvider;
var CompositeScopedContextProvider$1 = ctx$2$1.ScopedContextProvider;
var CompositeItemContext$1 = createContext(
  void 0
);
var CompositeRowContext$1 = createContext(
  void 0
);
function findFirstEnabledItem$1$1(items, excludeId) {
  return items.find((item) => {
    return !item.disabled;
  });
}
function getEnabledItem$1(store2, id2) {
  if (!id2) return null;
  return store2.item(id2) || null;
}
function groupItemsByRows$1$1(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => {
      var _a2;
      return ((_a2 = currentRow[0]) == null ? void 0 : _a2.rowId) === item.rowId;
    });
    if (row) {
      row.push(item);
    } else {
      rows.push([item]);
    }
  }
  return rows;
}
function selectTextField$1(element2, collapseToEnd = false) {
  if (isTextField$1(element2)) {
    element2.setSelectionRange(
      collapseToEnd ? element2.value.length : 0,
      element2.value.length
    );
  } else if (element2.isContentEditable) {
    const selection2 = getDocument$1(element2).getSelection();
    selection2 == null ? void 0 : selection2.selectAllChildren(element2);
    if (collapseToEnd) {
      selection2 == null ? void 0 : selection2.collapseToEnd();
    }
  }
}
var FOCUS_SILENTLY$1 = Symbol("FOCUS_SILENTLY");
function focusSilently$1(element2) {
  element2[FOCUS_SILENTLY$1] = true;
  element2.focus({ preventScroll: true });
}
function silentlyFocused$1(element2) {
  const isSilentlyFocused = element2[FOCUS_SILENTLY$1];
  delete element2[FOCUS_SILENTLY$1];
  return isSilentlyFocused;
}
function isItem$1(store2, element2, exclude) {
  if (!element2) return false;
  if (element2 === exclude) return false;
  const item = store2.item(element2.id);
  if (!item) return false;
  return true;
}
var TagName$8$1 = "div";
var useCollectionItem$1 = createHook$1(
  function useCollectionItem22({
    store: store2,
    shouldRegisterItem = true,
    getItem = identity$1,
    // @ts-expect-error This prop may come from a collection renderer.
    element: element2,
    ...props2
  }) {
    const context = useCollectionContext$1();
    store2 = store2 || context;
    const id2 = useId$1(props2.id);
    const ref = useRef(element2);
    useEffect(() => {
      const element22 = ref.current;
      if (!id2) return;
      if (!element22) return;
      if (!shouldRegisterItem) return;
      const item = getItem({ id: id2, element: element22 });
      return store2 == null ? void 0 : store2.renderItem(item);
    }, [id2, shouldRegisterItem, getItem, store2]);
    props2 = {
      ...props2,
      ref: useMergeRefs$1(ref, props2.ref)
    };
    return removeUndefinedValues$1(props2);
  }
);
forwardRef2$1(function CollectionItem22(props2) {
  const htmlProps = useCollectionItem$1(props2);
  return createElement$1(TagName$8$1, htmlProps);
});
var FocusableContext$1 = createContext(true);
var selector$1 = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function isFocusable$1(element2) {
  if (!element2.matches(selector$1)) return false;
  if (!isVisible$1(element2)) return false;
  if (element2.closest("[inert]")) return false;
  return true;
}
function getClosestFocusable$1(element2) {
  while (element2 && !isFocusable$1(element2)) {
    element2 = element2.closest(selector$1);
  }
  return element2 || null;
}
function hasFocus$1(element2) {
  const activeElement = getActiveElement$1(element2);
  if (!activeElement) return false;
  if (activeElement === element2) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  return activeDescendant === element2.id;
}
function hasFocusWithin$1(element2) {
  const activeElement = getActiveElement$1(element2);
  if (!activeElement) return false;
  if (contains$2(element2, activeElement)) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  if (!("id" in element2)) return false;
  if (activeDescendant === element2.id) return true;
  return !!element2.querySelector(`#${CSS.escape(activeDescendant)}`);
}
function focusIfNeeded$1(element2) {
  if (!hasFocusWithin$1(element2) && isFocusable$1(element2)) {
    element2.focus();
  }
}
function focusIntoView$1(element2, options2) {
  if (!("scrollIntoView" in element2)) {
    element2.focus();
  } else {
    element2.focus({ preventScroll: true });
    element2.scrollIntoView({ block: "nearest", inline: "nearest", ...options2 });
  }
}
var TagName$7$1 = "div";
var isSafariBrowser$2 = isSafari$1();
var alwaysFocusVisibleInputTypes$1 = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
var safariFocusAncestorSymbol$1 = Symbol("safariFocusAncestor");
function markSafariFocusAncestor$1(element2, value) {
  if (!element2) return;
  element2[safariFocusAncestorSymbol$1] = value;
}
function isAlwaysFocusVisible$1(element2) {
  const { tagName, readOnly: readOnly2, type } = element2;
  if (tagName === "TEXTAREA" && !readOnly2) return true;
  if (tagName === "SELECT" && !readOnly2) return true;
  if (tagName === "INPUT" && !readOnly2) {
    return alwaysFocusVisibleInputTypes$1.includes(type);
  }
  if (element2.isContentEditable) return true;
  const role = element2.getAttribute("role");
  if (role === "combobox" && element2.dataset.name) {
    return true;
  }
  return false;
}
function getLabels$1(element2) {
  if ("labels" in element2) {
    return element2.labels;
  }
  return null;
}
function isNativeCheckboxOrRadio$1(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "input" && element2.type) {
    return element2.type === "radio" || element2.type === "checkbox";
  }
  return false;
}
function isNativeTabbable$1(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "summary" || tagName === "input" || tagName === "select" || tagName === "textarea" || tagName === "a";
}
function supportsDisabledAttribute$1(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea";
}
function getTabIndex$1(focusable, trulyDisabled, nativeTabbable, supportsDisabled, tabIndexProp) {
  if (!focusable) {
    return tabIndexProp;
  }
  if (trulyDisabled) {
    if (nativeTabbable && !supportsDisabled) {
      return -1;
    }
    return;
  }
  if (nativeTabbable) {
    return tabIndexProp;
  }
  return tabIndexProp || 0;
}
function useDisableEvent$1(onEvent, disabled) {
  return useEvent$1((event) => {
    onEvent == null ? void 0 : onEvent(event);
    if (event.defaultPrevented) return;
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  });
}
var hasInstalledGlobalEventListeners$2 = false;
var isKeyboardModality$1 = true;
function onGlobalMouseDown$1(event) {
  const target = event.target;
  if (target && "hasAttribute" in target) {
    if (!target.hasAttribute("data-focus-visible")) {
      isKeyboardModality$1 = false;
    }
  }
}
function onGlobalKeyDown$1(event) {
  if (event.metaKey) return;
  if (event.ctrlKey) return;
  if (event.altKey) return;
  isKeyboardModality$1 = true;
}
var useFocusable$1 = createHook$1(
  function useFocusable22({
    focusable = true,
    accessibleWhenDisabled,
    autoFocus,
    onFocusVisible,
    ...props2
  }) {
    const ref = useRef(null);
    useEffect(() => {
      if (!focusable) return;
      if (hasInstalledGlobalEventListeners$2) return;
      addGlobalEventListener$1("mousedown", onGlobalMouseDown$1, true);
      addGlobalEventListener$1("keydown", onGlobalKeyDown$1, true);
      hasInstalledGlobalEventListeners$2 = true;
    }, [focusable]);
    if (isSafariBrowser$2) {
      useEffect(() => {
        if (!focusable) return;
        const element2 = ref.current;
        if (!element2) return;
        if (!isNativeCheckboxOrRadio$1(element2)) return;
        const labels = getLabels$1(element2);
        if (!labels) return;
        const onMouseUp = () => queueMicrotask(() => element2.focus());
        for (const label2 of labels) {
          label2.addEventListener("mouseup", onMouseUp);
        }
        return () => {
          for (const label2 of labels) {
            label2.removeEventListener("mouseup", onMouseUp);
          }
        };
      }, [focusable]);
    }
    const disabled = focusable && disabledFromProps$1(props2);
    const trulyDisabled = !!disabled && !accessibleWhenDisabled;
    const [focusVisible, setFocusVisible] = useState(false);
    useEffect(() => {
      if (!focusable) return;
      if (trulyDisabled && focusVisible) {
        setFocusVisible(false);
      }
    }, [focusable, trulyDisabled, focusVisible]);
    useEffect(() => {
      if (!focusable) return;
      if (!focusVisible) return;
      const element2 = ref.current;
      if (!element2) return;
      if (typeof IntersectionObserver === "undefined") return;
      const observer = new IntersectionObserver(() => {
        if (!isFocusable$1(element2)) {
          setFocusVisible(false);
        }
      });
      observer.observe(element2);
      return () => observer.disconnect();
    }, [focusable, focusVisible]);
    const onKeyPressCapture = useDisableEvent$1(
      props2.onKeyPressCapture,
      disabled
    );
    const onMouseDownCapture = useDisableEvent$1(
      props2.onMouseDownCapture,
      disabled
    );
    const onClickCapture = useDisableEvent$1(props2.onClickCapture, disabled);
    const onMouseDownProp = props2.onMouseDown;
    const onMouseDown = useEvent$1((event) => {
      onMouseDownProp == null ? void 0 : onMouseDownProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      const element2 = event.currentTarget;
      if (!isSafariBrowser$2) return;
      if (isPortalEvent$1(event)) return;
      if (!isButton$1(element2) && !isNativeCheckboxOrRadio$1(element2)) return;
      let receivedFocus = false;
      const onFocus = () => {
        receivedFocus = true;
      };
      const options2 = { capture: true, once: true };
      element2.addEventListener("focusin", onFocus, options2);
      const focusableContainer = getClosestFocusable$1(element2.parentElement);
      markSafariFocusAncestor$1(focusableContainer, true);
      queueBeforeEvent$1(element2, "mouseup", () => {
        element2.removeEventListener("focusin", onFocus, true);
        markSafariFocusAncestor$1(focusableContainer, false);
        if (receivedFocus) return;
        focusIfNeeded$1(element2);
      });
    });
    const handleFocusVisible = (event, currentTarget) => {
      if (currentTarget) {
        event.currentTarget = currentTarget;
      }
      if (!focusable) return;
      const element2 = event.currentTarget;
      if (!element2) return;
      if (!hasFocus$1(element2)) return;
      onFocusVisible == null ? void 0 : onFocusVisible(event);
      if (event.defaultPrevented) return;
      element2.dataset.focusVisible = "true";
      setFocusVisible(true);
    };
    const onKeyDownCaptureProp = props2.onKeyDownCapture;
    const onKeyDownCapture = useEvent$1((event) => {
      onKeyDownCaptureProp == null ? void 0 : onKeyDownCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      if (focusVisible) return;
      if (event.metaKey) return;
      if (event.altKey) return;
      if (event.ctrlKey) return;
      if (!isSelfTarget$1(event)) return;
      const element2 = event.currentTarget;
      const applyFocusVisible = () => handleFocusVisible(event, element2);
      queueBeforeEvent$1(element2, "focusout", applyFocusVisible);
    });
    const onFocusCaptureProp = props2.onFocusCapture;
    const onFocusCapture = useEvent$1((event) => {
      onFocusCaptureProp == null ? void 0 : onFocusCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      if (!isSelfTarget$1(event)) {
        setFocusVisible(false);
        return;
      }
      const element2 = event.currentTarget;
      const applyFocusVisible = () => handleFocusVisible(event, element2);
      if (isKeyboardModality$1 || isAlwaysFocusVisible$1(event.target)) {
        queueBeforeEvent$1(event.target, "focusout", applyFocusVisible);
      } else {
        setFocusVisible(false);
      }
    });
    const onBlurProp = props2.onBlur;
    const onBlur = useEvent$1((event) => {
      onBlurProp == null ? void 0 : onBlurProp(event);
      if (!focusable) return;
      if (!isFocusEventOutside$1(event)) return;
      event.currentTarget.removeAttribute("data-focus-visible");
      setFocusVisible(false);
    });
    const autoFocusOnShow = useContext(FocusableContext$1);
    const autoFocusRef = useEvent$1((element2) => {
      if (!focusable) return;
      if (!autoFocus) return;
      if (!element2) return;
      if (!autoFocusOnShow) return;
      queueMicrotask(() => {
        if (hasFocus$1(element2)) return;
        if (!isFocusable$1(element2)) return;
        element2.focus();
      });
    });
    const tagName = useTagName$1(ref);
    const nativeTabbable = focusable && isNativeTabbable$1(tagName);
    const supportsDisabled = focusable && supportsDisabledAttribute$1(tagName);
    const styleProp = props2.style;
    const style = useMemo(() => {
      if (trulyDisabled) {
        return { pointerEvents: "none", ...styleProp };
      }
      return styleProp;
    }, [trulyDisabled, styleProp]);
    props2 = {
      "data-focus-visible": focusable && focusVisible || void 0,
      "data-autofocus": autoFocus || void 0,
      "aria-disabled": disabled || void 0,
      ...props2,
      ref: useMergeRefs$1(ref, autoFocusRef, props2.ref),
      style,
      tabIndex: getTabIndex$1(
        focusable,
        trulyDisabled,
        nativeTabbable,
        supportsDisabled,
        props2.tabIndex
      ),
      disabled: supportsDisabled && trulyDisabled ? true : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: disabled ? void 0 : props2.contentEditable,
      onKeyPressCapture,
      onClickCapture,
      onMouseDownCapture,
      onMouseDown,
      onKeyDownCapture,
      onFocusCapture,
      onBlur
    };
    return removeUndefinedValues$1(props2);
  }
);
forwardRef2$1(function Focusable22(props2) {
  const htmlProps = useFocusable$1(props2);
  return createElement$1(TagName$7$1, htmlProps);
});
var TagName$6$1 = "button";
function isNativeClick$1(event) {
  if (!event.isTrusted) return false;
  const element2 = event.currentTarget;
  if (event.key === "Enter") {
    return isButton$1(element2) || element2.tagName === "SUMMARY" || element2.tagName === "A";
  }
  if (event.key === " ") {
    return isButton$1(element2) || element2.tagName === "SUMMARY" || element2.tagName === "INPUT" || element2.tagName === "SELECT";
  }
  return false;
}
var symbol$3 = Symbol("command");
var useCommand$1 = createHook$1(
  function useCommand22({ clickOnEnter = true, clickOnSpace = true, ...props2 }) {
    const ref = useRef(null);
    const [isNativeButton, setIsNativeButton] = useState(false);
    useEffect(() => {
      if (!ref.current) return;
      setIsNativeButton(isButton$1(ref.current));
    }, []);
    const [active, setActive] = useState(false);
    const activeRef = useRef(false);
    const disabled = disabledFromProps$1(props2);
    const [isDuplicate, metadataProps] = useMetadataProps$1(props2, symbol$3, true);
    const onKeyDownProp = props2.onKeyDown;
    const onKeyDown = useEvent$1((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      const element2 = event.currentTarget;
      if (event.defaultPrevented) return;
      if (isDuplicate) return;
      if (disabled) return;
      if (!isSelfTarget$1(event)) return;
      if (isTextField$1(element2)) return;
      if (element2.isContentEditable) return;
      const isEnter = clickOnEnter && event.key === "Enter";
      const isSpace2 = clickOnSpace && event.key === " ";
      const shouldPreventEnter = event.key === "Enter" && !clickOnEnter;
      const shouldPreventSpace = event.key === " " && !clickOnSpace;
      if (shouldPreventEnter || shouldPreventSpace) {
        event.preventDefault();
        return;
      }
      if (isEnter || isSpace2) {
        const nativeClick = isNativeClick$1(event);
        if (isEnter) {
          if (!nativeClick) {
            event.preventDefault();
            const { view, ...eventInit } = event;
            const click = () => fireClickEvent$1(element2, eventInit);
            if (isFirefox$1()) {
              queueBeforeEvent$1(element2, "keyup", click);
            } else {
              queueMicrotask(click);
            }
          }
        } else if (isSpace2) {
          activeRef.current = true;
          if (!nativeClick) {
            event.preventDefault();
            setActive(true);
          }
        }
      }
    });
    const onKeyUpProp = props2.onKeyUp;
    const onKeyUp = useEvent$1((event) => {
      onKeyUpProp == null ? void 0 : onKeyUpProp(event);
      if (event.defaultPrevented) return;
      if (isDuplicate) return;
      if (disabled) return;
      if (event.metaKey) return;
      const isSpace2 = clickOnSpace && event.key === " ";
      if (activeRef.current && isSpace2) {
        activeRef.current = false;
        if (!isNativeClick$1(event)) {
          event.preventDefault();
          setActive(false);
          const element2 = event.currentTarget;
          const { view, ...eventInit } = event;
          queueMicrotask(() => fireClickEvent$1(element2, eventInit));
        }
      }
    });
    props2 = {
      "data-active": active || void 0,
      type: isNativeButton ? "button" : void 0,
      ...metadataProps,
      ...props2,
      ref: useMergeRefs$1(ref, props2.ref),
      onKeyDown,
      onKeyUp
    };
    props2 = useFocusable$1(props2);
    return props2;
  }
);
forwardRef2$1(function Command22(props2) {
  const htmlProps = useCommand$1(props2);
  return createElement$1(TagName$6$1, htmlProps);
});
function getInternal$1(store2, key) {
  const internals = store2.__unstableInternals;
  invariant$1(internals, "Invalid store");
  return internals[key];
}
function createStore$1(initialState2, ...stores) {
  let state = initialState2;
  let prevStateBatch = state;
  let lastUpdate = Symbol();
  let destroy = noop$2;
  const instances = /* @__PURE__ */ new Set();
  const updatedKeys = /* @__PURE__ */ new Set();
  const setups = /* @__PURE__ */ new Set();
  const listeners = /* @__PURE__ */ new Set();
  const batchListeners = /* @__PURE__ */ new Set();
  const disposables = /* @__PURE__ */ new WeakMap();
  const listenerKeys = /* @__PURE__ */ new WeakMap();
  const storeSetup = (callback) => {
    setups.add(callback);
    return () => setups.delete(callback);
  };
  const storeInit = () => {
    const initialized = instances.size;
    const instance = Symbol();
    instances.add(instance);
    const maybeDestroy = () => {
      instances.delete(instance);
      if (instances.size) return;
      destroy();
    };
    if (initialized) return maybeDestroy;
    const desyncs = getKeys$1(state).map(
      (key) => chain$1(
        ...stores.map((store2) => {
          var _a2;
          const storeState = (_a2 = store2 == null ? void 0 : store2.getState) == null ? void 0 : _a2.call(store2);
          if (!storeState) return;
          if (!hasOwnProperty$3(storeState, key)) return;
          return sync$1(store2, [key], (state2) => {
            setState(
              key,
              state2[key],
              // @ts-expect-error - Not public API. This is just to prevent
              // infinite loops.
              true
            );
          });
        })
      )
    );
    const teardowns = [];
    for (const setup2 of setups) {
      teardowns.push(setup2());
    }
    const cleanups2 = stores.map(init$1);
    destroy = chain$1(...desyncs, ...teardowns, ...cleanups2);
    return maybeDestroy;
  };
  const sub2 = (keys2, listener, set2 = listeners) => {
    set2.add(listener);
    listenerKeys.set(listener, keys2);
    return () => {
      var _a2;
      (_a2 = disposables.get(listener)) == null ? void 0 : _a2();
      disposables.delete(listener);
      listenerKeys.delete(listener);
      set2.delete(listener);
    };
  };
  const storeSubscribe = (keys2, listener) => sub2(keys2, listener);
  const storeSync = (keys2, listener) => {
    disposables.set(listener, listener(state, state));
    return sub2(keys2, listener);
  };
  const storeBatch = (keys2, listener) => {
    disposables.set(listener, listener(state, prevStateBatch));
    return sub2(keys2, listener, batchListeners);
  };
  const storePick = (keys2) => createStore$1(pick$1(state, keys2), finalStore);
  const storeOmit = (keys2) => createStore$1(omit$1(state, keys2), finalStore);
  const getState = () => state;
  const setState = (key, value, fromStores = false) => {
    var _a2;
    if (!hasOwnProperty$3(state, key)) return;
    const nextValue = applyState$1(value, state[key]);
    if (nextValue === state[key]) return;
    if (!fromStores) {
      for (const store2 of stores) {
        (_a2 = store2 == null ? void 0 : store2.setState) == null ? void 0 : _a2.call(store2, key, nextValue);
      }
    }
    const prevState = state;
    state = { ...state, [key]: nextValue };
    const thisUpdate = Symbol();
    lastUpdate = thisUpdate;
    updatedKeys.add(key);
    const run = (listener, prev, uKeys) => {
      var _a22;
      const keys2 = listenerKeys.get(listener);
      const updated = (k2) => uKeys ? uKeys.has(k2) : k2 === key;
      if (!keys2 || keys2.some(updated)) {
        (_a22 = disposables.get(listener)) == null ? void 0 : _a22();
        disposables.set(listener, listener(state, prev));
      }
    };
    for (const listener of listeners) {
      run(listener, prevState);
    }
    queueMicrotask(() => {
      if (lastUpdate !== thisUpdate) return;
      const snapshot = state;
      for (const listener of batchListeners) {
        run(listener, prevStateBatch, updatedKeys);
      }
      prevStateBatch = snapshot;
      updatedKeys.clear();
    });
  };
  const finalStore = {
    getState,
    setState,
    __unstableInternals: {
      setup: storeSetup,
      init: storeInit,
      subscribe: storeSubscribe,
      sync: storeSync,
      batch: storeBatch,
      pick: storePick,
      omit: storeOmit
    }
  };
  return finalStore;
}
function setup$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "setup")(...args);
}
function init$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "init")(...args);
}
function subscribe$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "subscribe")(...args);
}
function sync$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "sync")(...args);
}
function batch$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "batch")(...args);
}
function throwOnConflictingProps$1(props2, store2) {
  if (process.env.NODE_ENV === "production") return;
  if (!store2) return;
  const defaultKeys = Object.entries(props2).filter(([key, value]) => key.startsWith("default") && value !== void 0).map(([key]) => {
    var _a2;
    const stateKey = key.replace("default", "");
    return `${((_a2 = stateKey[0]) == null ? void 0 : _a2.toLowerCase()) || ""}${stateKey.slice(1)}`;
  });
  if (!defaultKeys.length) return;
  const storeState = store2.getState();
  const conflictingProps = defaultKeys.filter(
    (key) => hasOwnProperty$3(storeState, key)
  );
  if (!conflictingProps.length) return;
  throw new Error(
    `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
  );
}
var shim$1 = { exports: {} };
var useSyncExternalStoreShim_production$1 = {};
var hasRequiredUseSyncExternalStoreShim_production$1;
function requireUseSyncExternalStoreShim_production$1() {
  if (hasRequiredUseSyncExternalStoreShim_production$1) return useSyncExternalStoreShim_production$1;
  hasRequiredUseSyncExternalStoreShim_production$1 = 1;
  var React2 = React__default;
  function is2(x2, y) {
    return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue;
  function useSyncExternalStore$22(subscribe2, getSnapshot) {
    var value = getSnapshot(), _useState = useState2({ inst: { value, getSnapshot } }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect2(
      function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
      },
      [subscribe2, value, getSnapshot]
    );
    useEffect2(
      function() {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        return subscribe2(function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        });
      },
      [subscribe2]
    );
    useDebugValue(value);
    return value;
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function useSyncExternalStore$12(subscribe2, getSnapshot) {
    return getSnapshot();
  }
  var shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$12 : useSyncExternalStore$22;
  useSyncExternalStoreShim_production$1.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
  return useSyncExternalStoreShim_production$1;
}
var useSyncExternalStoreShim_development$1 = {};
var hasRequiredUseSyncExternalStoreShim_development$1;
function requireUseSyncExternalStoreShim_development$1() {
  if (hasRequiredUseSyncExternalStoreShim_development$1) return useSyncExternalStoreShim_development$1;
  hasRequiredUseSyncExternalStoreShim_development$1 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function is2(x2, y) {
      return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
    }
    function useSyncExternalStore$22(subscribe2, getSnapshot) {
      didWarnOld18Alpha || void 0 === React2.startTransition || (didWarnOld18Alpha = true, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var value = getSnapshot();
      if (!didWarnUncachedGetSnapshot) {
        var cachedValue = getSnapshot();
        objectIs(value, cachedValue) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      cachedValue = useState2({
        inst: { value, getSnapshot }
      });
      var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
      useLayoutEffect2(
        function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        },
        [subscribe2, value, getSnapshot]
      );
      useEffect2(
        function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          return subscribe2(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          });
        },
        [subscribe2]
      );
      useDebugValue(value);
      return value;
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error) {
        return true;
      }
    }
    function useSyncExternalStore$12(subscribe2, getSnapshot) {
      return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue, didWarnOld18Alpha = false, didWarnUncachedGetSnapshot = false, shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$12 : useSyncExternalStore$22;
    useSyncExternalStoreShim_development$1.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return useSyncExternalStoreShim_development$1;
}
var hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1.exports;
  hasRequiredShim$1 = 1;
  if (process.env.NODE_ENV === "production") {
    shim$1.exports = requireUseSyncExternalStoreShim_production$1();
  } else {
    shim$1.exports = requireUseSyncExternalStoreShim_development$1();
  }
  return shim$1.exports;
}
var shimExports$1 = requireShim$1();
const useSyncExternalStoreExports$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(shimExports$1);
var { useSyncExternalStore: useSyncExternalStore$1 } = useSyncExternalStoreExports$1;
var noopSubscribe$1 = () => () => {
};
function useStoreState$1(store2, keyOrSelector = identity$1) {
  const storeSubscribe = React.useCallback(
    (callback) => {
      if (!store2) return noopSubscribe$1();
      return subscribe$1(store2, null, callback);
    },
    [store2]
  );
  const getSnapshot = () => {
    const key = typeof keyOrSelector === "string" ? keyOrSelector : null;
    const selector2 = typeof keyOrSelector === "function" ? keyOrSelector : null;
    const state = store2 == null ? void 0 : store2.getState();
    if (selector2) return selector2(state);
    if (!state) return;
    if (!key) return;
    if (!hasOwnProperty$3(state, key)) return;
    return state[key];
  };
  return useSyncExternalStore$1(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreStateObject$1(store2, object2) {
  const objRef = React.useRef(
    {}
  );
  const storeSubscribe = React.useCallback(
    (callback) => {
      if (!store2) return noopSubscribe$1();
      return subscribe$1(store2, null, callback);
    },
    [store2]
  );
  const getSnapshot = () => {
    const state = store2 == null ? void 0 : store2.getState();
    let updated = false;
    const obj = objRef.current;
    for (const prop in object2) {
      const keyOrSelector = object2[prop];
      if (typeof keyOrSelector === "function") {
        const value = keyOrSelector(state);
        if (value !== obj[prop]) {
          obj[prop] = value;
          updated = true;
        }
      }
      if (typeof keyOrSelector === "string") {
        if (!state) continue;
        if (!hasOwnProperty$3(state, keyOrSelector)) continue;
        const value = state[keyOrSelector];
        if (value !== obj[prop]) {
          obj[prop] = value;
          updated = true;
        }
      }
    }
    if (updated) {
      objRef.current = { ...obj };
    }
    return objRef.current;
  };
  return useSyncExternalStore$1(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreProps$1(store2, props2, key, setKey) {
  const value = hasOwnProperty$3(props2, key) ? props2[key] : void 0;
  const setValue = setKey ? props2[setKey] : void 0;
  const propsRef = useLiveRef$1({ value, setValue });
  useSafeLayoutEffect$1(() => {
    return sync$1(store2, [key], (state, prev) => {
      const { value: value2, setValue: setValue2 } = propsRef.current;
      if (!setValue2) return;
      if (state[key] === prev[key]) return;
      if (state[key] === value2) return;
      setValue2(state[key]);
    });
  }, [store2, key]);
  useSafeLayoutEffect$1(() => {
    if (value === void 0) return;
    store2.setState(key, value);
    return batch$1(store2, [key], () => {
      if (value === void 0) return;
      store2.setState(key, value);
    });
  });
}
function useStore$1(createStore2, props2) {
  const [store2, setStore] = React.useState(() => createStore2(props2));
  useSafeLayoutEffect$1(() => init$1(store2), [store2]);
  const useState2 = React.useCallback(
    (keyOrSelector) => useStoreState$1(store2, keyOrSelector),
    [store2]
  );
  const memoizedStore = React.useMemo(
    () => ({ ...store2, useState: useState2 }),
    [store2, useState2]
  );
  const updateStore = useEvent$1(() => {
    setStore((store22) => createStore2({ ...props2, ...store22.getState() }));
  });
  return [memoizedStore, updateStore];
}
var TagName$5$1 = "button";
function isEditableElement$1(element2) {
  if (isTextbox$1(element2)) return true;
  return element2.tagName === "INPUT" && !isButton$1(element2);
}
function getNextPageOffset$1(scrollingElement, pageUp = false) {
  const height = scrollingElement.clientHeight;
  const { top: top2 } = scrollingElement.getBoundingClientRect();
  const pageSize = Math.max(height * 0.875, height - 40) * 1.5;
  const pageOffset = pageUp ? height - pageSize + top2 : pageSize + top2;
  if (scrollingElement.tagName === "HTML") {
    return pageOffset + scrollingElement.scrollTop;
  }
  return pageOffset;
}
function getItemOffset$1(itemElement, pageUp = false) {
  const { top: top2 } = itemElement.getBoundingClientRect();
  if (pageUp) {
    return top2 + itemElement.clientHeight;
  }
  return top2;
}
function findNextPageItemId$1(element2, store2, next, pageUp = false) {
  var _a2;
  if (!store2) return;
  if (!next) return;
  const { renderedItems } = store2.getState();
  const scrollingElement = getScrollingElement$1(element2);
  if (!scrollingElement) return;
  const nextPageOffset = getNextPageOffset$1(scrollingElement, pageUp);
  let id2;
  let prevDifference;
  for (let i2 = 0; i2 < renderedItems.length; i2 += 1) {
    const previousId = id2;
    id2 = next(i2);
    if (!id2) break;
    if (id2 === previousId) continue;
    const itemElement = (_a2 = getEnabledItem$1(store2, id2)) == null ? void 0 : _a2.element;
    if (!itemElement) continue;
    const itemOffset = getItemOffset$1(itemElement, pageUp);
    const difference2 = itemOffset - nextPageOffset;
    const absDifference = Math.abs(difference2);
    if (pageUp && difference2 <= 0 || !pageUp && difference2 >= 0) {
      if (prevDifference !== void 0 && prevDifference < absDifference) {
        id2 = previousId;
      }
      break;
    }
    prevDifference = absDifference;
  }
  return id2;
}
function targetIsAnotherItem$1(event, store2) {
  if (isSelfTarget$1(event)) return false;
  return isItem$1(store2, event.target);
}
var useCompositeItem$1 = createHook$1(
  function useCompositeItem22({
    store: store2,
    rowId: rowIdProp,
    preventScrollOnKeyDown = false,
    moveOnKeyPress = true,
    tabbable = false,
    getItem: getItemProp,
    "aria-setsize": ariaSetSizeProp,
    "aria-posinset": ariaPosInSetProp,
    ...props2
  }) {
    const context = useCompositeContext$1();
    store2 = store2 || context;
    const id2 = useId$1(props2.id);
    const ref = useRef(null);
    const row = useContext(CompositeRowContext$1);
    const disabled = disabledFromProps$1(props2);
    const trulyDisabled = disabled && !props2.accessibleWhenDisabled;
    const {
      rowId,
      baseElement,
      isActiveItem,
      ariaSetSize,
      ariaPosInSet,
      isTabbable: isTabbable2
    } = useStoreStateObject$1(store2, {
      rowId(state) {
        if (rowIdProp) return rowIdProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.baseElement)) return;
        if (row.baseElement !== state.baseElement) return;
        return row.id;
      },
      baseElement(state) {
        return (state == null ? void 0 : state.baseElement) || void 0;
      },
      isActiveItem(state) {
        return !!state && state.activeId === id2;
      },
      ariaSetSize(state) {
        if (ariaSetSizeProp != null) return ariaSetSizeProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.ariaSetSize)) return;
        if (row.baseElement !== state.baseElement) return;
        return row.ariaSetSize;
      },
      ariaPosInSet(state) {
        if (ariaPosInSetProp != null) return ariaPosInSetProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.ariaPosInSet)) return;
        if (row.baseElement !== state.baseElement) return;
        const itemsInRow = state.renderedItems.filter(
          (item) => item.rowId === rowId
        );
        return row.ariaPosInSet + itemsInRow.findIndex((item) => item.id === id2);
      },
      isTabbable(state) {
        if (!(state == null ? void 0 : state.renderedItems.length)) return true;
        if (state.virtualFocus) return false;
        if (tabbable) return true;
        if (state.activeId === null) return false;
        const item = store2 == null ? void 0 : store2.item(state.activeId);
        if (item == null ? void 0 : item.disabled) return true;
        if (!(item == null ? void 0 : item.element)) return true;
        return state.activeId === id2;
      }
    });
    const getItem = useCallback(
      (item) => {
        var _a2;
        const nextItem = {
          ...item,
          id: id2 || item.id,
          rowId,
          disabled: !!trulyDisabled,
          children: (_a2 = item.element) == null ? void 0 : _a2.textContent
        };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [id2, rowId, trulyDisabled, getItemProp]
    );
    const onFocusProp = props2.onFocus;
    const hasFocusedComposite = useRef(false);
    const onFocus = useEvent$1((event) => {
      onFocusProp == null ? void 0 : onFocusProp(event);
      if (event.defaultPrevented) return;
      if (isPortalEvent$1(event)) return;
      if (!id2) return;
      if (!store2) return;
      if (targetIsAnotherItem$1(event, store2)) return;
      const { virtualFocus, baseElement: baseElement2 } = store2.getState();
      store2.setActiveId(id2);
      if (isTextbox$1(event.currentTarget)) {
        selectTextField$1(event.currentTarget);
      }
      if (!virtualFocus) return;
      if (!isSelfTarget$1(event)) return;
      if (isEditableElement$1(event.currentTarget)) return;
      if (!(baseElement2 == null ? void 0 : baseElement2.isConnected)) return;
      if (isSafari$1() && event.currentTarget.hasAttribute("data-autofocus")) {
        event.currentTarget.scrollIntoView({
          block: "nearest",
          inline: "nearest"
        });
      }
      hasFocusedComposite.current = true;
      const fromComposite = event.relatedTarget === baseElement2 || isItem$1(store2, event.relatedTarget);
      if (fromComposite) {
        focusSilently$1(baseElement2);
      } else {
        baseElement2.focus();
      }
    });
    const onBlurCaptureProp = props2.onBlurCapture;
    const onBlurCapture = useEvent$1((event) => {
      onBlurCaptureProp == null ? void 0 : onBlurCaptureProp(event);
      if (event.defaultPrevented) return;
      const state = store2 == null ? void 0 : store2.getState();
      if ((state == null ? void 0 : state.virtualFocus) && hasFocusedComposite.current) {
        hasFocusedComposite.current = false;
        event.preventDefault();
        event.stopPropagation();
      }
    });
    const onKeyDownProp = props2.onKeyDown;
    const preventScrollOnKeyDownProp = useBooleanEvent$1(preventScrollOnKeyDown);
    const moveOnKeyPressProp = useBooleanEvent$1(moveOnKeyPress);
    const onKeyDown = useEvent$1((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.defaultPrevented) return;
      if (!isSelfTarget$1(event)) return;
      if (!store2) return;
      const { currentTarget } = event;
      const state = store2.getState();
      const item = store2.item(id2);
      const isGrid2 = !!(item == null ? void 0 : item.rowId);
      const isVertical = state.orientation !== "horizontal";
      const isHorizontal = state.orientation !== "vertical";
      const canHomeEnd = () => {
        if (isGrid2) return true;
        if (isHorizontal) return true;
        if (!state.baseElement) return true;
        if (!isTextField$1(state.baseElement)) return true;
        return false;
      };
      const keyMap = {
        ArrowUp: (isGrid2 || isVertical) && store2.up,
        ArrowRight: (isGrid2 || isHorizontal) && store2.next,
        ArrowDown: (isGrid2 || isVertical) && store2.down,
        ArrowLeft: (isGrid2 || isHorizontal) && store2.previous,
        Home: () => {
          if (!canHomeEnd()) return;
          if (!isGrid2 || event.ctrlKey) {
            return store2 == null ? void 0 : store2.first();
          }
          return store2 == null ? void 0 : store2.previous(-1);
        },
        End: () => {
          if (!canHomeEnd()) return;
          if (!isGrid2 || event.ctrlKey) {
            return store2 == null ? void 0 : store2.last();
          }
          return store2 == null ? void 0 : store2.next(-1);
        },
        PageUp: () => {
          return findNextPageItemId$1(currentTarget, store2, store2 == null ? void 0 : store2.up, true);
        },
        PageDown: () => {
          return findNextPageItemId$1(currentTarget, store2, store2 == null ? void 0 : store2.down);
        }
      };
      const action = keyMap[event.key];
      if (action) {
        if (isTextbox$1(currentTarget)) {
          const selection2 = getTextboxSelection$1(currentTarget);
          const isLeft = isHorizontal && event.key === "ArrowLeft";
          const isRight = isHorizontal && event.key === "ArrowRight";
          const isUp = isVertical && event.key === "ArrowUp";
          const isDown = isVertical && event.key === "ArrowDown";
          if (isRight || isDown) {
            const { length: valueLength } = getTextboxValue$1(currentTarget);
            if (selection2.end !== valueLength) return;
          } else if ((isLeft || isUp) && selection2.start !== 0) return;
        }
        const nextId = action();
        if (preventScrollOnKeyDownProp(event) || nextId !== void 0) {
          if (!moveOnKeyPressProp(event)) return;
          event.preventDefault();
          store2.move(nextId);
        }
      }
    });
    const providerValue = useMemo(
      () => ({ id: id2, baseElement }),
      [id2, baseElement]
    );
    props2 = useWrapElement$1(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(CompositeItemContext$1.Provider, { value: providerValue, children: element2 }),
      [providerValue]
    );
    props2 = {
      id: id2,
      "data-active-item": isActiveItem || void 0,
      ...props2,
      ref: useMergeRefs$1(ref, props2.ref),
      tabIndex: isTabbable2 ? props2.tabIndex : -1,
      onFocus,
      onBlurCapture,
      onKeyDown
    };
    props2 = useCommand$1(props2);
    props2 = useCollectionItem$1({
      store: store2,
      ...props2,
      getItem,
      shouldRegisterItem: id2 ? props2.shouldRegisterItem : false
    });
    return removeUndefinedValues$1({
      ...props2,
      "aria-setsize": ariaSetSize,
      "aria-posinset": ariaPosInSet
    });
  }
);
memo2$1(
  forwardRef2$1(function CompositeItem22(props2) {
    const htmlProps = useCompositeItem$1(props2);
    return createElement$1(TagName$5$1, htmlProps);
  })
);
function flatten2DArray$1(array) {
  const flattened2 = [];
  for (const row of array) {
    flattened2.push(...row);
  }
  return flattened2;
}
function reverseArray$1(array) {
  return array.slice().reverse();
}
var TagName$4$1 = "div";
function isGrid$1(items) {
  return items.some((item) => !!item.rowId);
}
function isPrintableKey$1(event) {
  const target = event.target;
  if (target && !isTextField$1(target)) return false;
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
function isModifierKey$1(event) {
  return event.key === "Shift" || event.key === "Control" || event.key === "Alt" || event.key === "Meta";
}
function useKeyboardEventProxy$1(store2, onKeyboardEvent, previousElementRef) {
  return useEvent$1((event) => {
    var _a2;
    onKeyboardEvent == null ? void 0 : onKeyboardEvent(event);
    if (event.defaultPrevented) return;
    if (event.isPropagationStopped()) return;
    if (!isSelfTarget$1(event)) return;
    if (isModifierKey$1(event)) return;
    if (isPrintableKey$1(event)) return;
    const state = store2.getState();
    const activeElement = (_a2 = getEnabledItem$1(store2, state.activeId)) == null ? void 0 : _a2.element;
    if (!activeElement) return;
    const { view, ...eventInit } = event;
    const previousElement = previousElementRef == null ? void 0 : previousElementRef.current;
    if (activeElement !== previousElement) {
      activeElement.focus();
    }
    if (!fireKeyboardEvent$1(activeElement, event.type, eventInit)) {
      event.preventDefault();
    }
    if (event.currentTarget.contains(activeElement)) {
      event.stopPropagation();
    }
  });
}
function findFirstEnabledItemInTheLastRow$1(items) {
  return findFirstEnabledItem$1$1(
    flatten2DArray$1(reverseArray$1(groupItemsByRows$1$1(items)))
  );
}
function useScheduleFocus$1(store2) {
  const [scheduled, setScheduled] = useState(false);
  const schedule = useCallback(() => setScheduled(true), []);
  const activeItem = store2.useState(
    (state) => getEnabledItem$1(store2, state.activeId)
  );
  useEffect(() => {
    const activeElement = activeItem == null ? void 0 : activeItem.element;
    if (!scheduled) return;
    if (!activeElement) return;
    setScheduled(false);
    activeElement.focus({ preventScroll: true });
  }, [activeItem, scheduled]);
  return schedule;
}
var useComposite$1 = createHook$1(
  function useComposite22({
    store: store2,
    composite = true,
    focusOnMove = composite,
    moveOnKeyPress = true,
    ...props2
  }) {
    const context = useCompositeProviderContext$1();
    store2 = store2 || context;
    invariant$1(
      store2,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const ref = useRef(null);
    const previousElementRef = useRef(null);
    const scheduleFocus = useScheduleFocus$1(store2);
    const moves = store2.useState("moves");
    const [, setBaseElement] = useTransactionState$1(
      composite ? store2.setBaseElement : null
    );
    useEffect(() => {
      var _a2;
      if (!store2) return;
      if (!moves) return;
      if (!composite) return;
      if (!focusOnMove) return;
      const { activeId: activeId2 } = store2.getState();
      const itemElement = (_a2 = getEnabledItem$1(store2, activeId2)) == null ? void 0 : _a2.element;
      if (!itemElement) return;
      focusIntoView$1(itemElement);
    }, [store2, moves, composite, focusOnMove]);
    useSafeLayoutEffect$1(() => {
      if (!store2) return;
      if (!moves) return;
      if (!composite) return;
      const { baseElement, activeId: activeId2 } = store2.getState();
      const isSelfAcive = activeId2 === null;
      if (!isSelfAcive) return;
      if (!baseElement) return;
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (previousElement) {
        fireBlurEvent$1(previousElement, { relatedTarget: baseElement });
      }
      if (!hasFocus$1(baseElement)) {
        baseElement.focus();
      }
    }, [store2, moves, composite]);
    const activeId = store2.useState("activeId");
    const virtualFocus = store2.useState("virtualFocus");
    useSafeLayoutEffect$1(() => {
      var _a2;
      if (!store2) return;
      if (!composite) return;
      if (!virtualFocus) return;
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (!previousElement) return;
      const activeElement = (_a2 = getEnabledItem$1(store2, activeId)) == null ? void 0 : _a2.element;
      const relatedTarget = activeElement || getActiveElement$1(previousElement);
      if (relatedTarget === previousElement) return;
      fireBlurEvent$1(previousElement, { relatedTarget });
    }, [store2, activeId, virtualFocus, composite]);
    const onKeyDownCapture = useKeyboardEventProxy$1(
      store2,
      props2.onKeyDownCapture,
      previousElementRef
    );
    const onKeyUpCapture = useKeyboardEventProxy$1(
      store2,
      props2.onKeyUpCapture,
      previousElementRef
    );
    const onFocusCaptureProp = props2.onFocusCapture;
    const onFocusCapture = useEvent$1((event) => {
      onFocusCaptureProp == null ? void 0 : onFocusCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!store2) return;
      const { virtualFocus: virtualFocus2 } = store2.getState();
      if (!virtualFocus2) return;
      const previousActiveElement = event.relatedTarget;
      const isSilentlyFocused = silentlyFocused$1(event.currentTarget);
      if (isSelfTarget$1(event) && isSilentlyFocused) {
        event.stopPropagation();
        previousElementRef.current = previousActiveElement;
      }
    });
    const onFocusProp = props2.onFocus;
    const onFocus = useEvent$1((event) => {
      onFocusProp == null ? void 0 : onFocusProp(event);
      if (event.defaultPrevented) return;
      if (!composite) return;
      if (!store2) return;
      const { relatedTarget } = event;
      const { virtualFocus: virtualFocus2 } = store2.getState();
      if (virtualFocus2) {
        if (isSelfTarget$1(event) && !isItem$1(store2, relatedTarget)) {
          queueMicrotask(scheduleFocus);
        }
      } else if (isSelfTarget$1(event)) {
        store2.setActiveId(null);
      }
    });
    const onBlurCaptureProp = props2.onBlurCapture;
    const onBlurCapture = useEvent$1((event) => {
      var _a2;
      onBlurCaptureProp == null ? void 0 : onBlurCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!store2) return;
      const { virtualFocus: virtualFocus2, activeId: activeId2 } = store2.getState();
      if (!virtualFocus2) return;
      const activeElement = (_a2 = getEnabledItem$1(store2, activeId2)) == null ? void 0 : _a2.element;
      const nextActiveElement = event.relatedTarget;
      const nextActiveElementIsItem = isItem$1(store2, nextActiveElement);
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (isSelfTarget$1(event) && nextActiveElementIsItem) {
        if (nextActiveElement === activeElement) {
          if (previousElement && previousElement !== nextActiveElement) {
            fireBlurEvent$1(previousElement, event);
          }
        } else if (activeElement) {
          fireBlurEvent$1(activeElement, event);
        } else if (previousElement) {
          fireBlurEvent$1(previousElement, event);
        }
        event.stopPropagation();
      } else {
        const targetIsItem = isItem$1(store2, event.target);
        if (!targetIsItem && activeElement) {
          fireBlurEvent$1(activeElement, event);
        }
      }
    });
    const onKeyDownProp = props2.onKeyDown;
    const moveOnKeyPressProp = useBooleanEvent$1(moveOnKeyPress);
    const onKeyDown = useEvent$1((event) => {
      var _a2;
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.nativeEvent.isComposing) return;
      if (event.defaultPrevented) return;
      if (!store2) return;
      if (!isSelfTarget$1(event)) return;
      const { orientation, renderedItems, activeId: activeId2 } = store2.getState();
      const activeItem = getEnabledItem$1(store2, activeId2);
      if ((_a2 = activeItem == null ? void 0 : activeItem.element) == null ? void 0 : _a2.isConnected) return;
      const isVertical = orientation !== "horizontal";
      const isHorizontal = orientation !== "vertical";
      const grid = isGrid$1(renderedItems);
      const isHorizontalKey = event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Home" || event.key === "End";
      if (isHorizontalKey && isTextField$1(event.currentTarget)) return;
      const up = () => {
        if (grid) {
          const item = findFirstEnabledItemInTheLastRow$1(renderedItems);
          return item == null ? void 0 : item.id;
        }
        return store2 == null ? void 0 : store2.last();
      };
      const keyMap = {
        ArrowUp: (grid || isVertical) && up,
        ArrowRight: (grid || isHorizontal) && store2.first,
        ArrowDown: (grid || isVertical) && store2.first,
        ArrowLeft: (grid || isHorizontal) && store2.last,
        Home: store2.first,
        End: store2.last,
        PageUp: store2.first,
        PageDown: store2.last
      };
      const action = keyMap[event.key];
      if (action) {
        const id2 = action();
        if (id2 !== void 0) {
          if (!moveOnKeyPressProp(event)) return;
          event.preventDefault();
          store2.move(id2);
        }
      }
    });
    props2 = useWrapElement$1(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(CompositeContextProvider$1, { value: store2, children: element2 }),
      [store2]
    );
    const activeDescendant = store2.useState((state) => {
      var _a2;
      if (!store2) return;
      if (!composite) return;
      if (!state.virtualFocus) return;
      return (_a2 = getEnabledItem$1(store2, state.activeId)) == null ? void 0 : _a2.id;
    });
    props2 = {
      "aria-activedescendant": activeDescendant,
      ...props2,
      ref: useMergeRefs$1(ref, setBaseElement, props2.ref),
      onKeyDownCapture,
      onKeyUpCapture,
      onFocusCapture,
      onFocus,
      onBlurCapture,
      onKeyDown
    };
    const focusable = store2.useState(
      (state) => composite && (state.virtualFocus || state.activeId === null)
    );
    props2 = useFocusable$1({ focusable, ...props2 });
    return props2;
  }
);
forwardRef2$1(function Composite22(props2) {
  const htmlProps = useComposite$1(props2);
  return createElement$1(TagName$4$1, htmlProps);
});
function getCommonParent$1(items) {
  var _a2;
  const firstItem = items.find((item) => !!item.element);
  const lastItem = [...items].reverse().find((item) => !!item.element);
  let parentElement = (_a2 = firstItem == null ? void 0 : firstItem.element) == null ? void 0 : _a2.parentElement;
  while (parentElement && (lastItem == null ? void 0 : lastItem.element)) {
    const parent = parentElement;
    if (lastItem && parent.contains(lastItem.element)) {
      return parentElement;
    }
    parentElement = parentElement.parentElement;
  }
  return getDocument$1(parentElement).body;
}
function getPrivateStore$1(store2) {
  return store2 == null ? void 0 : store2.__unstablePrivateStore;
}
function createCollectionStore$1(props2 = {}) {
  var _a2;
  throwOnConflictingProps$1(props2, props2.store);
  const syncState = (_a2 = props2.store) == null ? void 0 : _a2.getState();
  const items = defaultValue$1(
    props2.items,
    syncState == null ? void 0 : syncState.items,
    props2.defaultItems,
    []
  );
  const itemsMap = new Map(items.map((item) => [item.id, item]));
  const initialState2 = {
    items,
    renderedItems: defaultValue$1(syncState == null ? void 0 : syncState.renderedItems, [])
  };
  const syncPrivateStore = getPrivateStore$1(props2.store);
  const privateStore = createStore$1(
    { items, renderedItems: initialState2.renderedItems },
    syncPrivateStore
  );
  const collection = createStore$1(initialState2, props2.store);
  const sortItems = (renderedItems) => {
    const sortedItems = sortBasedOnDOMPosition$1(renderedItems, (i2) => i2.element);
    privateStore.setState("renderedItems", sortedItems);
    collection.setState("renderedItems", sortedItems);
  };
  setup$1(collection, () => init$1(privateStore));
  setup$1(privateStore, () => {
    return batch$1(privateStore, ["items"], (state) => {
      collection.setState("items", state.items);
    });
  });
  setup$1(privateStore, () => {
    return batch$1(privateStore, ["renderedItems"], (state) => {
      let firstRun = true;
      let raf = requestAnimationFrame(() => {
        const { renderedItems } = collection.getState();
        if (state.renderedItems === renderedItems) return;
        sortItems(state.renderedItems);
      });
      if (typeof IntersectionObserver !== "function") {
        return () => cancelAnimationFrame(raf);
      }
      const ioCallback = () => {
        if (firstRun) {
          firstRun = false;
          return;
        }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => sortItems(state.renderedItems));
      };
      const root2 = getCommonParent$1(state.renderedItems);
      const observer = new IntersectionObserver(ioCallback, { root: root2 });
      for (const item of state.renderedItems) {
        if (!item.element) continue;
        observer.observe(item.element);
      }
      return () => {
        cancelAnimationFrame(raf);
        observer.disconnect();
      };
    });
  });
  const mergeItem = (item, setItems, canDeleteFromMap = false) => {
    let prevItem;
    setItems((items2) => {
      const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
      const nextItems = items2.slice();
      if (index2 !== -1) {
        prevItem = items2[index2];
        const nextItem = { ...prevItem, ...item };
        nextItems[index2] = nextItem;
        itemsMap.set(item.id, nextItem);
      } else {
        nextItems.push(item);
        itemsMap.set(item.id, item);
      }
      return nextItems;
    });
    const unmergeItem = () => {
      setItems((items2) => {
        if (!prevItem) {
          if (canDeleteFromMap) {
            itemsMap.delete(item.id);
          }
          return items2.filter(({ id: id2 }) => id2 !== item.id);
        }
        const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
        if (index2 === -1) return items2;
        const nextItems = items2.slice();
        nextItems[index2] = prevItem;
        itemsMap.set(item.id, prevItem);
        return nextItems;
      });
    };
    return unmergeItem;
  };
  const registerItem = (item) => mergeItem(
    item,
    (getItems) => privateStore.setState("items", getItems),
    true
  );
  return {
    ...collection,
    registerItem,
    renderItem: (item) => chain$1(
      registerItem(item),
      mergeItem(
        item,
        (getItems) => privateStore.setState("renderedItems", getItems)
      )
    ),
    item: (id2) => {
      if (!id2) return null;
      let item = itemsMap.get(id2);
      if (!item) {
        const { items: items2 } = privateStore.getState();
        item = items2.find((item2) => item2.id === id2);
        if (item) {
          itemsMap.set(id2, item);
        }
      }
      return item || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: privateStore
  };
}
function useCollectionStoreProps$1(store2, update, props2) {
  useUpdateEffect$1(update, [props2.store]);
  useStoreProps$1(store2, props2, "items", "setItems");
  return store2;
}
var NULL_ITEM$2 = { id: null };
function findFirstEnabledItem$2(items, excludeId) {
  return items.find((item) => {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getEnabledItems$2(items, excludeId) {
  return items.filter((item) => {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getItemsInRow$1(items, rowId) {
  return items.filter((item) => item.rowId === rowId);
}
function flipItems$2(items, activeId, shouldInsertNullItem = false) {
  const index2 = items.findIndex((item) => item.id === activeId);
  return [
    ...items.slice(index2 + 1),
    ...shouldInsertNullItem ? [NULL_ITEM$2] : [],
    ...items.slice(0, index2)
  ];
}
function groupItemsByRows$2(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => {
      var _a2;
      return ((_a2 = currentRow[0]) == null ? void 0 : _a2.rowId) === item.rowId;
    });
    if (row) {
      row.push(item);
    } else {
      rows.push([item]);
    }
  }
  return rows;
}
function getMaxRowLength$1(array) {
  let maxLength = 0;
  for (const { length } of array) {
    if (length > maxLength) {
      maxLength = length;
    }
  }
  return maxLength;
}
function createEmptyItem$1(rowId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    rowId
  };
}
function normalizeRows$1(rows, activeId, focusShift) {
  const maxLength = getMaxRowLength$1(rows);
  for (const row of rows) {
    for (let i2 = 0; i2 < maxLength; i2 += 1) {
      const item = row[i2];
      if (!item || focusShift && item.disabled) {
        const isFirst = i2 === 0;
        const previousItem = isFirst && focusShift ? findFirstEnabledItem$2(row) : row[i2 - 1];
        row[i2] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem$1(previousItem == null ? void 0 : previousItem.rowId);
      }
    }
  }
  return rows;
}
function verticalizeItems$1(items) {
  const rows = groupItemsByRows$2(items);
  const maxLength = getMaxRowLength$1(rows);
  const verticalized = [];
  for (let i2 = 0; i2 < maxLength; i2 += 1) {
    for (const row of rows) {
      const item = row[i2];
      if (item) {
        verticalized.push({
          ...item,
          // If there's no rowId, it means that it's not a grid composite, but
          // a single row instead. So, instead of verticalizing it, that is,
          // assigning a different rowId based on the column index, we keep it
          // undefined so they will be part of the same row. This is useful
          // when using up/down on one-dimensional composites.
          rowId: item.rowId ? `${i2}` : void 0
        });
      }
    }
  }
  return verticalized;
}
function createCompositeStore$1(props2 = {}) {
  var _a2;
  const syncState = (_a2 = props2.store) == null ? void 0 : _a2.getState();
  const collection = createCollectionStore$1(props2);
  const activeId = defaultValue$1(
    props2.activeId,
    syncState == null ? void 0 : syncState.activeId,
    props2.defaultActiveId
  );
  const initialState2 = {
    ...collection.getState(),
    id: defaultValue$1(
      props2.id,
      syncState == null ? void 0 : syncState.id,
      `id-${Math.random().toString(36).slice(2, 8)}`
    ),
    activeId,
    baseElement: defaultValue$1(syncState == null ? void 0 : syncState.baseElement, null),
    includesBaseElement: defaultValue$1(
      props2.includesBaseElement,
      syncState == null ? void 0 : syncState.includesBaseElement,
      activeId === null
    ),
    moves: defaultValue$1(syncState == null ? void 0 : syncState.moves, 0),
    orientation: defaultValue$1(
      props2.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "both"
    ),
    rtl: defaultValue$1(props2.rtl, syncState == null ? void 0 : syncState.rtl, false),
    virtualFocus: defaultValue$1(
      props2.virtualFocus,
      syncState == null ? void 0 : syncState.virtualFocus,
      false
    ),
    focusLoop: defaultValue$1(props2.focusLoop, syncState == null ? void 0 : syncState.focusLoop, false),
    focusWrap: defaultValue$1(props2.focusWrap, syncState == null ? void 0 : syncState.focusWrap, false),
    focusShift: defaultValue$1(props2.focusShift, syncState == null ? void 0 : syncState.focusShift, false)
  };
  const composite = createStore$1(initialState2, collection, props2.store);
  setup$1(
    composite,
    () => sync$1(composite, ["renderedItems", "activeId"], (state) => {
      composite.setState("activeId", (activeId2) => {
        var _a22;
        if (activeId2 !== void 0) return activeId2;
        return (_a22 = findFirstEnabledItem$2(state.renderedItems)) == null ? void 0 : _a22.id;
      });
    })
  );
  const getNextId = (direction = "next", options2 = {}) => {
    var _a22, _b;
    const defaultState = composite.getState();
    const {
      skip = 0,
      activeId: activeId2 = defaultState.activeId,
      focusShift = defaultState.focusShift,
      focusLoop = defaultState.focusLoop,
      focusWrap = defaultState.focusWrap,
      includesBaseElement = defaultState.includesBaseElement,
      renderedItems = defaultState.renderedItems,
      rtl = defaultState.rtl
    } = options2;
    const isVerticalDirection = direction === "up" || direction === "down";
    const isNextDirection = direction === "next" || direction === "down";
    const canReverse = isNextDirection ? rtl && !isVerticalDirection : !rtl || isVerticalDirection;
    const canShift = focusShift && !skip;
    let items = !isVerticalDirection ? renderedItems : flatten2DArray$1(
      normalizeRows$1(groupItemsByRows$2(renderedItems), activeId2, canShift)
    );
    items = canReverse ? reverseArray$1(items) : items;
    items = isVerticalDirection ? verticalizeItems$1(items) : items;
    if (activeId2 == null) {
      return (_a22 = findFirstEnabledItem$2(items)) == null ? void 0 : _a22.id;
    }
    const activeItem = items.find((item) => item.id === activeId2);
    if (!activeItem) {
      return (_b = findFirstEnabledItem$2(items)) == null ? void 0 : _b.id;
    }
    const isGrid2 = items.some((item) => item.rowId);
    const activeIndex = items.indexOf(activeItem);
    const nextItems = items.slice(activeIndex + 1);
    const nextItemsInRow = getItemsInRow$1(nextItems, activeItem.rowId);
    if (skip) {
      const nextEnabledItemsInRow = getEnabledItems$2(nextItemsInRow, activeId2);
      const nextItem2 = nextEnabledItemsInRow.slice(skip)[0] || // If we can't find an item, just return the last one.
      nextEnabledItemsInRow[nextEnabledItemsInRow.length - 1];
      return nextItem2 == null ? void 0 : nextItem2.id;
    }
    const canLoop = focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical");
    const canWrap = isGrid2 && focusWrap && (isVerticalDirection ? focusWrap !== "horizontal" : focusWrap !== "vertical");
    const hasNullItem = isNextDirection ? (!isGrid2 || isVerticalDirection) && canLoop && includesBaseElement : isVerticalDirection ? includesBaseElement : false;
    if (canLoop) {
      const loopItems = canWrap && !hasNullItem ? items : getItemsInRow$1(items, activeItem.rowId);
      const sortedItems = flipItems$2(loopItems, activeId2, hasNullItem);
      const nextItem2 = findFirstEnabledItem$2(sortedItems, activeId2);
      return nextItem2 == null ? void 0 : nextItem2.id;
    }
    if (canWrap) {
      const nextItem2 = findFirstEnabledItem$2(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        hasNullItem ? nextItemsInRow : nextItems,
        activeId2
      );
      const nextId = hasNullItem ? (nextItem2 == null ? void 0 : nextItem2.id) || null : nextItem2 == null ? void 0 : nextItem2.id;
      return nextId;
    }
    const nextItem = findFirstEnabledItem$2(nextItemsInRow, activeId2);
    if (!nextItem && hasNullItem) {
      return null;
    }
    return nextItem == null ? void 0 : nextItem.id;
  };
  return {
    ...collection,
    ...composite,
    setBaseElement: (element2) => composite.setState("baseElement", element2),
    setActiveId: (id2) => composite.setState("activeId", id2),
    move: (id2) => {
      if (id2 === void 0) return;
      composite.setState("activeId", id2);
      composite.setState("moves", (moves) => moves + 1);
    },
    first: () => {
      var _a22;
      return (_a22 = findFirstEnabledItem$2(composite.getState().renderedItems)) == null ? void 0 : _a22.id;
    },
    last: () => {
      var _a22;
      return (_a22 = findFirstEnabledItem$2(reverseArray$1(composite.getState().renderedItems))) == null ? void 0 : _a22.id;
    },
    next: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("next", options2);
    },
    previous: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("previous", options2);
    },
    down: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("down", options2);
    },
    up: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("up", options2);
    }
  };
}
function useCompositeStoreProps$1(store2, update, props2) {
  store2 = useCollectionStoreProps$1(store2, update, props2);
  useStoreProps$1(store2, props2, "activeId", "setActiveId");
  useStoreProps$1(store2, props2, "includesBaseElement");
  useStoreProps$1(store2, props2, "virtualFocus");
  useStoreProps$1(store2, props2, "orientation");
  useStoreProps$1(store2, props2, "rtl");
  useStoreProps$1(store2, props2, "focusLoop");
  useStoreProps$1(store2, props2, "focusWrap");
  useStoreProps$1(store2, props2, "focusShift");
  return store2;
}
var TagName$3$1 = "button";
var useButton$1 = createHook$1(
  function useButton2(props2) {
    const ref = useRef(null);
    const tagName = useTagName$1(ref, TagName$3$1);
    const [isNativeButton, setIsNativeButton] = useState(
      () => !!tagName && isButton$1({ tagName, type: props2.type })
    );
    useEffect(() => {
      if (!ref.current) return;
      setIsNativeButton(isButton$1(ref.current));
    }, []);
    props2 = {
      role: !isNativeButton && tagName !== "a" ? "button" : void 0,
      ...props2,
      ref: useMergeRefs$1(ref, props2.ref)
    };
    props2 = useCommand$1(props2);
    return props2;
  }
);
var Button$1 = forwardRef2$1(function Button2(props2) {
  const htmlProps = useButton$1(props2);
  return createElement$1(TagName$3$1, htmlProps);
});
var ctx$1$1 = createStoreContext$1(
  [CompositeContextProvider$1],
  [CompositeScopedContextProvider$1]
);
var useRadioContext = ctx$1$1.useContext;
var useRadioProviderContext = ctx$1$1.useProviderContext;
var RadioContextProvider = ctx$1$1.ContextProvider;
var RadioScopedContextProvider = ctx$1$1.ScopedContextProvider;
var TagName$2$1 = "input";
function getIsChecked(value, storeValue) {
  if (storeValue === void 0) return;
  if (value != null && storeValue != null) {
    return storeValue === value;
  }
  return !!storeValue;
}
function isNativeRadio(tagName, type) {
  return tagName === "input" && (!type || type === "radio");
}
var useRadio = createHook$1(function useRadio2({
  store: store2,
  name: name2,
  value,
  checked,
  ...props2
}) {
  const context = useRadioContext();
  store2 = store2 || context;
  const id2 = useId$1(props2.id);
  const ref = useRef(null);
  const isChecked = useStoreState$1(
    store2,
    (state) => checked != null ? checked : getIsChecked(value, state == null ? void 0 : state.value)
  );
  useEffect(() => {
    if (!id2) return;
    if (!isChecked) return;
    const isActiveItem = (store2 == null ? void 0 : store2.getState().activeId) === id2;
    if (isActiveItem) return;
    store2 == null ? void 0 : store2.setActiveId(id2);
  }, [store2, isChecked, id2]);
  const onChangeProp = props2.onChange;
  const tagName = useTagName$1(ref, TagName$2$1);
  const nativeRadio = isNativeRadio(tagName, props2.type);
  const disabled = disabledFromProps$1(props2);
  const [propertyUpdated, schedulePropertyUpdate] = useForceUpdate$1();
  useEffect(() => {
    const element2 = ref.current;
    if (!element2) return;
    if (nativeRadio) return;
    if (isChecked !== void 0) {
      element2.checked = isChecked;
    }
    if (name2 !== void 0) {
      element2.name = name2;
    }
    if (value !== void 0) {
      element2.value = `${value}`;
    }
  }, [propertyUpdated, nativeRadio, isChecked, name2, value]);
  const onChange = useEvent$1((event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if ((store2 == null ? void 0 : store2.getState().value) === value) return;
    if (!nativeRadio) {
      event.currentTarget.checked = true;
      schedulePropertyUpdate();
    }
    onChangeProp == null ? void 0 : onChangeProp(event);
    if (event.defaultPrevented) return;
    store2 == null ? void 0 : store2.setValue(value);
  });
  const onClickProp = props2.onClick;
  const onClick = useEvent$1((event) => {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    if (nativeRadio) return;
    onChange(event);
  });
  const onFocusProp = props2.onFocus;
  const onFocus = useEvent$1((event) => {
    onFocusProp == null ? void 0 : onFocusProp(event);
    if (event.defaultPrevented) return;
    if (!nativeRadio) return;
    if (!store2) return;
    const { moves, activeId } = store2.getState();
    if (!moves) return;
    if (id2 && activeId !== id2) return;
    onChange(event);
  });
  props2 = {
    id: id2,
    role: !nativeRadio ? "radio" : void 0,
    type: nativeRadio ? "radio" : void 0,
    "aria-checked": isChecked,
    ...props2,
    ref: useMergeRefs$1(ref, props2.ref),
    onChange,
    onClick,
    onFocus
  };
  props2 = useCompositeItem$1({
    store: store2,
    clickOnEnter: !nativeRadio,
    ...props2
  });
  return removeUndefinedValues$1({
    name: nativeRadio ? name2 : void 0,
    value: nativeRadio ? value : void 0,
    checked: isChecked,
    ...props2
  });
});
var Radio = memo2$1(
  forwardRef2$1(function Radio2(props2) {
    const htmlProps = useRadio(props2);
    return createElement$1(TagName$2$1, htmlProps);
  })
);
var TagName$1$1 = "div";
var useRadioGroup = createHook$1(
  function useRadioGroup2({ store: store2, ...props2 }) {
    const context = useRadioProviderContext();
    store2 = store2 || context;
    invariant$1(
      store2,
      process.env.NODE_ENV !== "production" && "RadioGroup must receive a `store` prop or be wrapped in a RadioProvider component."
    );
    props2 = useWrapElement$1(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(RadioScopedContextProvider, { value: store2, children: element2 }),
      [store2]
    );
    props2 = {
      role: "radiogroup",
      ...props2
    };
    props2 = useComposite$1({ store: store2, ...props2 });
    return props2;
  }
);
var RadioGroup = forwardRef2$1(function RadioGroup2(props2) {
  const htmlProps = useRadioGroup(props2);
  return createElement$1(TagName$1$1, htmlProps);
});
function createRadioStore({
  ...props2
} = {}) {
  var _a2;
  const syncState = (_a2 = props2.store) == null ? void 0 : _a2.getState();
  const composite = createCompositeStore$1({
    ...props2,
    focusLoop: defaultValue$1(props2.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  });
  const initialState2 = {
    ...composite.getState(),
    value: defaultValue$1(
      props2.value,
      syncState == null ? void 0 : syncState.value,
      props2.defaultValue,
      null
    )
  };
  const radio = createStore$1(initialState2, composite, props2.store);
  return {
    ...composite,
    ...radio,
    setValue: (value) => radio.setState("value", value)
  };
}
function useRadioStoreProps(store2, update, props2) {
  store2 = useCompositeStoreProps$1(store2, update, props2);
  useStoreProps$1(store2, props2, "value", "setValue");
  return store2;
}
function useRadioStore(props2 = {}) {
  const [store2, update] = useStore$1(createRadioStore, props2);
  return useRadioStoreProps(store2, update, props2);
}
function RadioProvider(props2 = {}) {
  const store2 = useRadioStore(props2);
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(RadioContextProvider, { value: store2, children: props2.children });
}
var CheckboxCheckedContext = createContext(false);
var ctx$9 = createStoreContext$1();
var useCheckboxContext = ctx$9.useContext;
var TagName$w = "input";
function setMixed(element2, mixed) {
  if (mixed) {
    element2.indeterminate = true;
  } else if (element2.indeterminate) {
    element2.indeterminate = false;
  }
}
function isNativeCheckbox(tagName, type) {
  return tagName === "input" && (!type || type === "checkbox");
}
function getPrimitiveValue(value) {
  if (Array.isArray(value)) {
    return value.toString();
  }
  return value;
}
var useCheckbox = createHook$1(
  function useCheckbox2({
    store: store2,
    name: name2,
    value: valueProp,
    checked: checkedProp,
    defaultChecked,
    ...props2
  }) {
    const context = useCheckboxContext();
    store2 = store2 || context;
    const [_checked, setChecked] = useState(defaultChecked != null ? defaultChecked : false);
    const checked = useStoreState$1(store2, (state) => {
      if (checkedProp !== void 0) return checkedProp;
      if ((state == null ? void 0 : state.value) === void 0) return _checked;
      if (valueProp != null) {
        if (Array.isArray(state.value)) {
          const primitiveValue = getPrimitiveValue(valueProp);
          return state.value.includes(primitiveValue);
        }
        return state.value === valueProp;
      }
      if (Array.isArray(state.value)) return false;
      if (typeof state.value === "boolean") return state.value;
      return false;
    });
    const ref = useRef(null);
    const tagName = useTagName$1(ref, TagName$w);
    const nativeCheckbox = isNativeCheckbox(tagName, props2.type);
    const mixed = checked ? checked === "mixed" : void 0;
    const isChecked = checked === "mixed" ? false : checked;
    const disabled = disabledFromProps$1(props2);
    const [propertyUpdated, schedulePropertyUpdate] = useForceUpdate$1();
    useEffect(() => {
      const element2 = ref.current;
      if (!element2) return;
      setMixed(element2, mixed);
      if (nativeCheckbox) return;
      element2.checked = isChecked;
      if (name2 !== void 0) {
        element2.name = name2;
      }
      if (valueProp !== void 0) {
        element2.value = `${valueProp}`;
      }
    }, [propertyUpdated, mixed, nativeCheckbox, isChecked, name2, valueProp]);
    const onChangeProp = props2.onChange;
    const onChange = useEvent$1((event) => {
      if (disabled) {
        event.stopPropagation();
        event.preventDefault();
        return;
      }
      setMixed(event.currentTarget, mixed);
      if (!nativeCheckbox) {
        event.currentTarget.checked = !event.currentTarget.checked;
        schedulePropertyUpdate();
      }
      onChangeProp == null ? void 0 : onChangeProp(event);
      if (event.defaultPrevented) return;
      const elementChecked = event.currentTarget.checked;
      setChecked(elementChecked);
      store2 == null ? void 0 : store2.setValue((prevValue) => {
        if (valueProp == null) return elementChecked;
        const primitiveValue = getPrimitiveValue(valueProp);
        if (!Array.isArray(prevValue)) {
          return prevValue === primitiveValue ? false : primitiveValue;
        }
        if (elementChecked) {
          if (prevValue.includes(primitiveValue)) {
            return prevValue;
          }
          return [...prevValue, primitiveValue];
        }
        return prevValue.filter((v2) => v2 !== primitiveValue);
      });
    });
    const onClickProp = props2.onClick;
    const onClick = useEvent$1((event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (nativeCheckbox) return;
      onChange(event);
    });
    props2 = useWrapElement$1(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(CheckboxCheckedContext.Provider, { value: isChecked, children: element2 }),
      [isChecked]
    );
    props2 = {
      role: !nativeCheckbox ? "checkbox" : void 0,
      type: nativeCheckbox ? "checkbox" : void 0,
      "aria-checked": checked,
      ...props2,
      ref: useMergeRefs$1(ref, props2.ref),
      onChange,
      onClick
    };
    props2 = useCommand$1({ clickOnEnter: !nativeCheckbox, ...props2 });
    return removeUndefinedValues$1({
      name: nativeCheckbox ? name2 : void 0,
      value: nativeCheckbox ? valueProp : void 0,
      checked: isChecked,
      ...props2
    });
  }
);
var Checkbox = forwardRef2$1(function Checkbox2(props2) {
  const htmlProps = useCheckbox(props2);
  return createElement$1(TagName$w, htmlProps);
});
function Button$2(props2) {
  if (props2.value != null && props2.children != null) {
    console.warn(
      "Button: Both `value` and `children` props are provided. Using `value`."
    );
  }
  let value = props2.value ?? props2.children;
  if (value && props2.valueHasLatex) {
    value = /* @__PURE__ */ React__default.createElement(MathJax, { hideUntilTypeset: "first", inline: true, dynamic: true }, value);
  }
  let icon = props2.icon && /* @__PURE__ */ React__default.createElement("div", { className: "button-icon" }, props2.icon);
  const button = /* @__PURE__ */ React__default.createElement(
    Button$1,
    {
      id: props2.id,
      disabled: props2.disabled,
      onClick: props2.onClick,
      className: classNames(
        "doenet-button",
        {
          vertical: props2.vertical,
          alert: props2.alert
        },
        props2.className
      ),
      style: props2.fillColor ? {
        "--button-color": props2.fillColor
      } : void 0,
      "aria-label": props2.ariaLabel
    },
    icon,
    value
  );
  if (props2.label) {
    return /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: classNames("doenet-labelled-button", {
          vertical: props2.vertical
        })
      },
      /* @__PURE__ */ React__default.createElement("span", { className: "label" }, props2.label),
      button
    );
  }
  return button;
}
function ActionButton(props2) {
  return /* @__PURE__ */ React__default.createElement(
    Button$2,
    {
      ...props2,
      className: classNames("action-button", props2.className)
    },
    props2.children
  );
}
const ActionButtonGroup = (props2) => {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames("doenet-button-group", {
        vertical: props2.vertical
      }),
      style: props2.style
    },
    props2.children
  );
};
function ToggleButton(props2) {
  const inputType = props2.inputType ?? "checkbox";
  const [isSelected2, setSelected] = useState(!!props2.isSelected);
  useEffect(() => {
    setSelected(!!props2.isSelected);
  }, [props2.isSelected]);
  if (props2.value != null && props2.children != null) {
    console.warn(
      "Button: Both `value` and `children` props are provided. Using `value`."
    );
  }
  let value = props2.value ?? props2.children;
  if (value && props2.valueHasLatex) {
    value = /* @__PURE__ */ React__default.createElement(MathJax, { hideUntilTypeset: "first", inline: true, dynamic: true }, value);
  }
  let icon = props2.icon && /* @__PURE__ */ React__default.createElement("div", { className: "button-icon" }, props2.icon);
  const Input = inputType === "radio" ? Radio : Checkbox;
  return /* @__PURE__ */ React__default.createElement(
    "label",
    {
      className: classNames(
        "doenet-toggle-button-label",
        "doenet-button",
        "action-button"
      )
    },
    /* @__PURE__ */ React__default.createElement(
      Input,
      {
        value: "",
        id: props2.id,
        checked: isSelected2,
        onChange: () => {
          setSelected(!isSelected2);
          if (props2.onClick) {
            props2.onClick(props2.index != null ? props2.index : null);
          }
        },
        onKeyDown: (e2) => {
          if (e2.key === "Enter") {
            e2.target.dispatchEvent(
              new MouseEvent("click", {
                bubbles: true,
                cancelable: true
              })
            );
          }
        },
        className: "doenet-toggle-button",
        "aria-label": props2.ariaLabel
      }
    ),
    icon,
    value
  );
}
function isToggleButton(node) {
  return React__default.isValidElement(node) && node.type === ToggleButton;
}
const ToggleButtonGroup = (props2) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const containerRef = React__default.useRef(null);
  const onClick = React__default.useCallback(
    (e2) => {
      if ("key" in e2 && e2.key !== "Enter") {
        return;
      }
      const target = e2.target;
      const button = target.querySelector(".doenet-toggle-button") || target.closest(".doenet-toggle-button");
      if (!button || !containerRef.current) {
        return;
      }
      const allToggleButtons = Array.from(
        containerRef.current?.querySelectorAll(
          ".doenet-toggle-button"
        ) || []
      );
      const index2 = allToggleButtons.indexOf(button);
      if (index2 === -1) {
        return;
      }
      setSelectedIndex(index2);
      if (props2.onClick) {
        props2.onClick(index2);
      }
    },
    [props2.onClick]
  );
  const children = React__default.Children.map(props2.children, (child, index2) => {
    if (!isToggleButton(child)) {
      console.warn(
        "ToggleButtonGroup was passed a child that is not a ToggleButton."
      );
      return child;
    }
    return React__default.cloneElement(child, {
      isSelected: index2 === selectedIndex,
      index: index2,
      inputType: "radio"
      // Always use radio for ToggleButtonGroup
    });
  });
  return /* @__PURE__ */ React__default.createElement(RadioProvider, null, /* @__PURE__ */ React__default.createElement(
    RadioGroup,
    {
      className: classNames("doenet-button-group", {
        vertical: props2.vertical
      }),
      ref: containerRef,
      onClick,
      onKeyDown: onClick
    },
    children
  ));
};
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React__default.createContext && /* @__PURE__ */ React__default.createContext(DefaultContext);
var _excluded$1 = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function ownKeys(e2, r) {
  var t2 = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e2);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e2, r2).enumerable;
    })), t2.push.apply(t2, o);
  }
  return t2;
}
function _objectSpread(e2) {
  for (var r = 1; r < arguments.length; r++) {
    var t2 = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t2), true).forEach(function(r2) {
      _defineProperty(e2, r2, t2[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)) : ownKeys(Object(t2)).forEach(function(r2) {
      Object.defineProperty(e2, r2, Object.getOwnPropertyDescriptor(t2, r2));
    });
  }
  return e2;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t2) {
  var i2 = _toPrimitive(t2, "string");
  return "symbol" == typeof i2 ? i2 : i2 + "";
}
function _toPrimitive(t2, r) {
  if ("object" != typeof t2 || !t2) return t2;
  var e2 = t2[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i2 = e2.call(t2, r);
    if ("object" != typeof i2) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t2);
}
function Tree2Element(tree) {
  return tree && tree.map((node, i2) => /* @__PURE__ */ React__default.createElement(node.tag, _objectSpread({
    key: i2
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  return (props2) => /* @__PURE__ */ React__default.createElement(IconBase, _extends$1({
    attr: _objectSpread({}, data.attr)
  }, props2), Tree2Element(data.child));
}
function IconBase(props2) {
  var elem = (conf) => {
    var {
      attr,
      size: size2,
      title: title2
    } = props2, svgProps = _objectWithoutProperties(props2, _excluded$1);
    var computedSize = size2 || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props2.className) className = (className ? className + " " : "") + props2.className;
    return /* @__PURE__ */ React__default.createElement("svg", _extends$1({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: _objectSpread(_objectSpread({
        color: props2.color || conf.color
      }, conf.style), props2.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title2 && /* @__PURE__ */ React__default.createElement("title", null, title2), props2.children);
  };
  return IconContext !== void 0 ? /* @__PURE__ */ React__default.createElement(IconContext.Consumer, null, (conf) => elem(conf)) : elem(DefaultContext);
}
function BsGripHorizontal(props2) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }, "child": [] }] })(props2);
}
function BsGripVertical(props2) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }, "child": [] }] })(props2);
}
const PanelGroupContext = createContext(null);
PanelGroupContext.displayName = "PanelGroupContext";
const DATA_ATTRIBUTES = {
  group: "data-panel-group",
  groupDirection: "data-panel-group-direction",
  groupId: "data-panel-group-id",
  panel: "data-panel",
  panelCollapsible: "data-panel-collapsible",
  panelId: "data-panel-id",
  panelSize: "data-panel-size",
  resizeHandle: "data-resize-handle",
  resizeHandleActive: "data-resize-handle-active",
  resizeHandleEnabled: "data-panel-resize-handle-enabled",
  resizeHandleId: "data-panel-resize-handle-id",
  resizeHandleState: "data-resize-handle-state"
};
const PRECISION = 10;
const useIsomorphicLayoutEffect = useLayoutEffect;
const useId$2 = React["useId".toString()];
const wrappedUseId = typeof useId$2 === "function" ? useId$2 : () => null;
let counter = 0;
function useUniqueId(idFromParams = null) {
  const idFromUseId = wrappedUseId();
  const idRef = useRef(idFromParams || idFromUseId || null);
  if (idRef.current === null) {
    idRef.current = "" + counter++;
  }
  return idFromParams !== null && idFromParams !== void 0 ? idFromParams : idRef.current;
}
function PanelWithForwardedRef({
  children,
  className: classNameFromProps = "",
  collapsedSize,
  collapsible,
  defaultSize,
  forwardedRef,
  id: idFromProps,
  maxSize,
  minSize,
  onCollapse,
  onExpand,
  onResize,
  order: order2,
  style: styleFromProps,
  tagName: Type = "div",
  ...rest2
}) {
  const context = useContext(PanelGroupContext);
  if (context === null) {
    throw Error(`Panel components must be rendered within a PanelGroup container`);
  }
  const {
    collapsePanel,
    expandPanel,
    getPanelSize,
    getPanelStyle,
    groupId,
    isPanelCollapsed,
    reevaluatePanelConstraints,
    registerPanel,
    resizePanel: resizePanel2,
    unregisterPanel
  } = context;
  const panelId = useUniqueId(idFromProps);
  const panelDataRef = useRef({
    callbacks: {
      onCollapse,
      onExpand,
      onResize
    },
    constraints: {
      collapsedSize,
      collapsible,
      defaultSize,
      maxSize,
      minSize
    },
    id: panelId,
    idIsFromProps: idFromProps !== void 0,
    order: order2
  });
  useRef({
    didLogMissingDefaultSizeWarning: false
  });
  useIsomorphicLayoutEffect(() => {
    const {
      callbacks,
      constraints
    } = panelDataRef.current;
    const prevConstraints = {
      ...constraints
    };
    panelDataRef.current.id = panelId;
    panelDataRef.current.idIsFromProps = idFromProps !== void 0;
    panelDataRef.current.order = order2;
    callbacks.onCollapse = onCollapse;
    callbacks.onExpand = onExpand;
    callbacks.onResize = onResize;
    constraints.collapsedSize = collapsedSize;
    constraints.collapsible = collapsible;
    constraints.defaultSize = defaultSize;
    constraints.maxSize = maxSize;
    constraints.minSize = minSize;
    if (prevConstraints.collapsedSize !== constraints.collapsedSize || prevConstraints.collapsible !== constraints.collapsible || prevConstraints.maxSize !== constraints.maxSize || prevConstraints.minSize !== constraints.minSize) {
      reevaluatePanelConstraints(panelDataRef.current, prevConstraints);
    }
  });
  useIsomorphicLayoutEffect(() => {
    const panelData = panelDataRef.current;
    registerPanel(panelData);
    return () => {
      unregisterPanel(panelData);
    };
  }, [order2, panelId, registerPanel, unregisterPanel]);
  useImperativeHandle(forwardedRef, () => ({
    collapse: () => {
      collapsePanel(panelDataRef.current);
    },
    expand: (minSize2) => {
      expandPanel(panelDataRef.current, minSize2);
    },
    getId() {
      return panelId;
    },
    getSize() {
      return getPanelSize(panelDataRef.current);
    },
    isCollapsed() {
      return isPanelCollapsed(panelDataRef.current);
    },
    isExpanded() {
      return !isPanelCollapsed(panelDataRef.current);
    },
    resize: (size2) => {
      resizePanel2(panelDataRef.current, size2);
    }
  }), [collapsePanel, expandPanel, getPanelSize, isPanelCollapsed, panelId, resizePanel2]);
  const style = getPanelStyle(panelDataRef.current, defaultSize);
  return createElement$3(Type, {
    ...rest2,
    children,
    className: classNameFromProps,
    id: panelId,
    style: {
      ...style,
      ...styleFromProps
    },
    // CSS selectors
    [DATA_ATTRIBUTES.groupId]: groupId,
    [DATA_ATTRIBUTES.panel]: "",
    [DATA_ATTRIBUTES.panelCollapsible]: collapsible || void 0,
    [DATA_ATTRIBUTES.panelId]: panelId,
    [DATA_ATTRIBUTES.panelSize]: parseFloat("" + style.flexGrow).toFixed(1)
  });
}
const Panel = forwardRef((props2, ref) => createElement$3(PanelWithForwardedRef, {
  ...props2,
  forwardedRef: ref
}));
PanelWithForwardedRef.displayName = "Panel";
Panel.displayName = "forwardRef(Panel)";
let currentCursorStyle = null;
let prevRuleIndex = -1;
let styleElement = null;
function getCursorStyle(state, constraintFlags, isPointerDown2) {
  const horizontalMin = (constraintFlags & EXCEEDED_HORIZONTAL_MIN) !== 0;
  const horizontalMax = (constraintFlags & EXCEEDED_HORIZONTAL_MAX) !== 0;
  const verticalMin = (constraintFlags & EXCEEDED_VERTICAL_MIN) !== 0;
  const verticalMax = (constraintFlags & EXCEEDED_VERTICAL_MAX) !== 0;
  if (constraintFlags) {
    if (horizontalMin) {
      if (verticalMin) {
        return "se-resize";
      } else if (verticalMax) {
        return "ne-resize";
      } else {
        return "e-resize";
      }
    } else if (horizontalMax) {
      if (verticalMin) {
        return "sw-resize";
      } else if (verticalMax) {
        return "nw-resize";
      } else {
        return "w-resize";
      }
    } else if (verticalMin) {
      return "s-resize";
    } else if (verticalMax) {
      return "n-resize";
    }
  }
  switch (state) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function resetGlobalCursorStyle() {
  if (styleElement !== null) {
    document.head.removeChild(styleElement);
    currentCursorStyle = null;
    styleElement = null;
    prevRuleIndex = -1;
  }
}
function setGlobalCursorStyle(state, constraintFlags, isPointerDown2) {
  var _styleElement$sheet$i, _styleElement$sheet2;
  const style = getCursorStyle(state, constraintFlags);
  if (currentCursorStyle === style) {
    return;
  }
  currentCursorStyle = style;
  if (styleElement === null) {
    styleElement = document.createElement("style");
    document.head.appendChild(styleElement);
  }
  if (prevRuleIndex >= 0) {
    var _styleElement$sheet;
    (_styleElement$sheet = styleElement.sheet) === null || _styleElement$sheet === void 0 ? void 0 : _styleElement$sheet.removeRule(prevRuleIndex);
  }
  prevRuleIndex = (_styleElement$sheet$i = (_styleElement$sheet2 = styleElement.sheet) === null || _styleElement$sheet2 === void 0 ? void 0 : _styleElement$sheet2.insertRule(`*{cursor: ${style} !important;}`)) !== null && _styleElement$sheet$i !== void 0 ? _styleElement$sheet$i : -1;
}
function isKeyDown(event) {
  return event.type === "keydown";
}
function isPointerEvent(event) {
  return event.type.startsWith("pointer");
}
function isMouseEvent(event) {
  return event.type.startsWith("mouse");
}
function getResizeEventCoordinates(event) {
  if (isPointerEvent(event)) {
    if (event.isPrimary) {
      return {
        x: event.clientX,
        y: event.clientY
      };
    }
  } else if (isMouseEvent(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  return {
    x: Infinity,
    y: Infinity
  };
}
function getInputType() {
  if (typeof matchMedia === "function") {
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
  }
}
function intersects(rectOne, rectTwo, strict) {
  {
    return rectOne.x < rectTwo.x + rectTwo.width && rectOne.x + rectOne.width > rectTwo.x && rectOne.y < rectTwo.y + rectTwo.height && rectOne.y + rectOne.height > rectTwo.y;
  }
}
function compare$1(a, b2) {
  if (a === b2) throw new Error("Cannot compare node with itself");
  const ancestors = {
    a: get_ancestors(a),
    b: get_ancestors(b2)
  };
  let common_ancestor;
  while (ancestors.a.at(-1) === ancestors.b.at(-1)) {
    a = ancestors.a.pop();
    b2 = ancestors.b.pop();
    common_ancestor = a;
  }
  assert(common_ancestor, "Stacking order can only be calculated for elements with a common ancestor");
  const z_indexes = {
    a: get_z_index(find_stacking_context(ancestors.a)),
    b: get_z_index(find_stacking_context(ancestors.b))
  };
  if (z_indexes.a === z_indexes.b) {
    const children = common_ancestor.childNodes;
    const furthest_ancestors = {
      a: ancestors.a.at(-1),
      b: ancestors.b.at(-1)
    };
    let i2 = children.length;
    while (i2--) {
      const child = children[i2];
      if (child === furthest_ancestors.a) return 1;
      if (child === furthest_ancestors.b) return -1;
    }
  }
  return Math.sign(z_indexes.a - z_indexes.b);
}
const props = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function is_flex_item(node) {
  var _get_parent;
  const display = getComputedStyle((_get_parent = get_parent(node)) !== null && _get_parent !== void 0 ? _get_parent : node).display;
  return display === "flex" || display === "inline-flex";
}
function creates_stacking_context(node) {
  const style = getComputedStyle(node);
  if (style.position === "fixed") return true;
  if (style.zIndex !== "auto" && (style.position !== "static" || is_flex_item(node))) return true;
  if (+style.opacity < 1) return true;
  if ("transform" in style && style.transform !== "none") return true;
  if ("webkitTransform" in style && style.webkitTransform !== "none") return true;
  if ("mixBlendMode" in style && style.mixBlendMode !== "normal") return true;
  if ("filter" in style && style.filter !== "none") return true;
  if ("webkitFilter" in style && style.webkitFilter !== "none") return true;
  if ("isolation" in style && style.isolation === "isolate") return true;
  if (props.test(style.willChange)) return true;
  if (style.webkitOverflowScrolling === "touch") return true;
  return false;
}
function find_stacking_context(nodes) {
  let i2 = nodes.length;
  while (i2--) {
    const node = nodes[i2];
    assert(node, "Missing node");
    if (creates_stacking_context(node)) return node;
  }
  return null;
}
function get_z_index(node) {
  return node && Number(getComputedStyle(node).zIndex) || 0;
}
function get_ancestors(node) {
  const ancestors = [];
  while (node) {
    ancestors.push(node);
    node = get_parent(node);
  }
  return ancestors;
}
function get_parent(node) {
  const {
    parentNode
  } = node;
  if (parentNode && parentNode instanceof ShadowRoot) {
    return parentNode.host;
  }
  return parentNode;
}
const EXCEEDED_HORIZONTAL_MIN = 1;
const EXCEEDED_HORIZONTAL_MAX = 2;
const EXCEEDED_VERTICAL_MIN = 4;
const EXCEEDED_VERTICAL_MAX = 8;
const isCoarsePointer = getInputType() === "coarse";
let intersectingHandles = [];
let isPointerDown = false;
let ownerDocumentCounts = /* @__PURE__ */ new Map();
let panelConstraintFlags = /* @__PURE__ */ new Map();
const registeredResizeHandlers = /* @__PURE__ */ new Set();
function registerResizeHandle(resizeHandleId, element2, direction, hitAreaMargins, setResizeHandlerState) {
  var _ownerDocumentCounts$;
  const {
    ownerDocument
  } = element2;
  const data = {
    direction,
    element: element2,
    hitAreaMargins,
    setResizeHandlerState
  };
  const count = (_ownerDocumentCounts$ = ownerDocumentCounts.get(ownerDocument)) !== null && _ownerDocumentCounts$ !== void 0 ? _ownerDocumentCounts$ : 0;
  ownerDocumentCounts.set(ownerDocument, count + 1);
  registeredResizeHandlers.add(data);
  updateListeners();
  return function unregisterResizeHandle() {
    var _ownerDocumentCounts$2;
    panelConstraintFlags.delete(resizeHandleId);
    registeredResizeHandlers.delete(data);
    const count2 = (_ownerDocumentCounts$2 = ownerDocumentCounts.get(ownerDocument)) !== null && _ownerDocumentCounts$2 !== void 0 ? _ownerDocumentCounts$2 : 1;
    ownerDocumentCounts.set(ownerDocument, count2 - 1);
    updateListeners();
    if (count2 === 1) {
      ownerDocumentCounts.delete(ownerDocument);
    }
    if (intersectingHandles.includes(data)) {
      const index2 = intersectingHandles.indexOf(data);
      if (index2 >= 0) {
        intersectingHandles.splice(index2, 1);
      }
      updateCursor();
      setResizeHandlerState("up", true, null);
    }
  };
}
function handlePointerDown(event) {
  const {
    target
  } = event;
  const {
    x: x2,
    y
  } = getResizeEventCoordinates(event);
  isPointerDown = true;
  recalculateIntersectingHandles({
    target,
    x: x2,
    y
  });
  updateListeners();
  if (intersectingHandles.length > 0) {
    updateResizeHandlerStates("down", event);
    updateCursor();
    event.preventDefault();
    if (!isWithinResizeHandle(target)) {
      event.stopImmediatePropagation();
    }
  }
}
function handlePointerMove(event) {
  const {
    x: x2,
    y
  } = getResizeEventCoordinates(event);
  if (isPointerDown && // Skip this check for "pointerleave" events, else Firefox triggers a false positive (see #514)
  event.type !== "pointerleave" && event.buttons === 0) {
    isPointerDown = false;
    updateResizeHandlerStates("up", event);
  }
  if (!isPointerDown) {
    const {
      target
    } = event;
    recalculateIntersectingHandles({
      target,
      x: x2,
      y
    });
  }
  updateResizeHandlerStates("move", event);
  updateCursor();
  if (intersectingHandles.length > 0) {
    event.preventDefault();
  }
}
function handlePointerUp(event) {
  const {
    target
  } = event;
  const {
    x: x2,
    y
  } = getResizeEventCoordinates(event);
  panelConstraintFlags.clear();
  isPointerDown = false;
  if (intersectingHandles.length > 0) {
    event.preventDefault();
    if (!isWithinResizeHandle(target)) {
      event.stopImmediatePropagation();
    }
  }
  updateResizeHandlerStates("up", event);
  recalculateIntersectingHandles({
    target,
    x: x2,
    y
  });
  updateCursor();
  updateListeners();
}
function isWithinResizeHandle(element2) {
  let currentElement = element2;
  while (currentElement) {
    if (currentElement.hasAttribute(DATA_ATTRIBUTES.resizeHandle)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function recalculateIntersectingHandles({
  target,
  x: x2,
  y
}) {
  intersectingHandles.splice(0);
  let targetElement = null;
  if (target instanceof HTMLElement || target instanceof SVGElement) {
    targetElement = target;
  }
  registeredResizeHandlers.forEach((data) => {
    const {
      element: dragHandleElement,
      hitAreaMargins
    } = data;
    const dragHandleRect = dragHandleElement.getBoundingClientRect();
    const {
      bottom,
      left,
      right,
      top: top2
    } = dragHandleRect;
    const margin = isCoarsePointer ? hitAreaMargins.coarse : hitAreaMargins.fine;
    const eventIntersects = x2 >= left - margin && x2 <= right + margin && y >= top2 - margin && y <= bottom + margin;
    if (eventIntersects) {
      if (targetElement !== null && document.contains(targetElement) && dragHandleElement !== targetElement && !dragHandleElement.contains(targetElement) && !targetElement.contains(dragHandleElement) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      compare$1(targetElement, dragHandleElement) > 0) {
        let currentElement = targetElement;
        let didIntersect = false;
        while (currentElement) {
          if (currentElement.contains(dragHandleElement)) {
            break;
          } else if (intersects(currentElement.getBoundingClientRect(), dragHandleRect)) {
            didIntersect = true;
            break;
          }
          currentElement = currentElement.parentElement;
        }
        if (didIntersect) {
          return;
        }
      }
      intersectingHandles.push(data);
    }
  });
}
function reportConstraintsViolation(resizeHandleId, flag) {
  panelConstraintFlags.set(resizeHandleId, flag);
}
function updateCursor() {
  let intersectsHorizontal = false;
  let intersectsVertical = false;
  intersectingHandles.forEach((data) => {
    const {
      direction
    } = data;
    if (direction === "horizontal") {
      intersectsHorizontal = true;
    } else {
      intersectsVertical = true;
    }
  });
  let constraintFlags = 0;
  panelConstraintFlags.forEach((flag) => {
    constraintFlags |= flag;
  });
  if (intersectsHorizontal && intersectsVertical) {
    setGlobalCursorStyle("intersection", constraintFlags);
  } else if (intersectsHorizontal) {
    setGlobalCursorStyle("horizontal", constraintFlags);
  } else if (intersectsVertical) {
    setGlobalCursorStyle("vertical", constraintFlags);
  } else {
    resetGlobalCursorStyle();
  }
}
let listenersAbortController;
function updateListeners() {
  var _listenersAbortContro;
  (_listenersAbortContro = listenersAbortController) === null || _listenersAbortContro === void 0 ? void 0 : _listenersAbortContro.abort();
  listenersAbortController = new AbortController();
  const options2 = {
    capture: true,
    signal: listenersAbortController.signal
  };
  if (!registeredResizeHandlers.size) {
    return;
  }
  if (isPointerDown) {
    if (intersectingHandles.length > 0) {
      ownerDocumentCounts.forEach((count, ownerDocument) => {
        const {
          body
        } = ownerDocument;
        if (count > 0) {
          body.addEventListener("contextmenu", handlePointerUp, options2);
          body.addEventListener("pointerleave", handlePointerMove, options2);
          body.addEventListener("pointermove", handlePointerMove, options2);
        }
      });
    }
    ownerDocumentCounts.forEach((_2, ownerDocument) => {
      const {
        body
      } = ownerDocument;
      body.addEventListener("pointerup", handlePointerUp, options2);
      body.addEventListener("pointercancel", handlePointerUp, options2);
    });
  } else {
    ownerDocumentCounts.forEach((count, ownerDocument) => {
      const {
        body
      } = ownerDocument;
      if (count > 0) {
        body.addEventListener("pointerdown", handlePointerDown, options2);
        body.addEventListener("pointermove", handlePointerMove, options2);
      }
    });
  }
}
function updateResizeHandlerStates(action, event) {
  registeredResizeHandlers.forEach((data) => {
    const {
      setResizeHandlerState
    } = data;
    const isActive = intersectingHandles.includes(data);
    setResizeHandlerState(action, isActive, event);
  });
}
function useForceUpdate$2() {
  const [_2, setCount] = useState(0);
  return useCallback(() => setCount((prevCount) => prevCount + 1), []);
}
function assert(expectedCondition, message) {
  if (!expectedCondition) {
    console.error(message);
    throw Error(message);
  }
}
function fuzzyCompareNumbers(actual, expected, fractionDigits = PRECISION) {
  if (actual.toFixed(fractionDigits) === expected.toFixed(fractionDigits)) {
    return 0;
  } else {
    return actual > expected ? 1 : -1;
  }
}
function fuzzyNumbersEqual$1(actual, expected, fractionDigits = PRECISION) {
  return fuzzyCompareNumbers(actual, expected, fractionDigits) === 0;
}
function fuzzyNumbersEqual(actual, expected, fractionDigits) {
  return fuzzyCompareNumbers(actual, expected, fractionDigits) === 0;
}
function fuzzyLayoutsEqual(actual, expected, fractionDigits) {
  if (actual.length !== expected.length) {
    return false;
  }
  for (let index2 = 0; index2 < actual.length; index2++) {
    const actualSize = actual[index2];
    const expectedSize = expected[index2];
    if (!fuzzyNumbersEqual(actualSize, expectedSize, fractionDigits)) {
      return false;
    }
  }
  return true;
}
function resizePanel({
  panelConstraints: panelConstraintsArray,
  panelIndex,
  size: size2
}) {
  const panelConstraints = panelConstraintsArray[panelIndex];
  assert(panelConstraints != null, `Panel constraints not found for index ${panelIndex}`);
  let {
    collapsedSize = 0,
    collapsible,
    maxSize = 100,
    minSize = 0
  } = panelConstraints;
  if (fuzzyCompareNumbers(size2, minSize) < 0) {
    if (collapsible) {
      const halfwayPoint = (collapsedSize + minSize) / 2;
      if (fuzzyCompareNumbers(size2, halfwayPoint) < 0) {
        size2 = collapsedSize;
      } else {
        size2 = minSize;
      }
    } else {
      size2 = minSize;
    }
  }
  size2 = Math.min(maxSize, size2);
  size2 = parseFloat(size2.toFixed(PRECISION));
  return size2;
}
function adjustLayoutByDelta({
  delta,
  initialLayout,
  panelConstraints: panelConstraintsArray,
  pivotIndices,
  prevLayout,
  trigger
}) {
  if (fuzzyNumbersEqual(delta, 0)) {
    return initialLayout;
  }
  const nextLayout = [...initialLayout];
  const [firstPivotIndex, secondPivotIndex] = pivotIndices;
  assert(firstPivotIndex != null, "Invalid first pivot index");
  assert(secondPivotIndex != null, "Invalid second pivot index");
  let deltaApplied = 0;
  {
    if (trigger === "keyboard") {
      {
        const index2 = delta < 0 ? secondPivotIndex : firstPivotIndex;
        const panelConstraints = panelConstraintsArray[index2];
        assert(panelConstraints, `Panel constraints not found for index ${index2}`);
        const {
          collapsedSize = 0,
          collapsible,
          minSize = 0
        } = panelConstraints;
        if (collapsible) {
          const prevSize = initialLayout[index2];
          assert(prevSize != null, `Previous layout not found for panel index ${index2}`);
          if (fuzzyNumbersEqual(prevSize, collapsedSize)) {
            const localDelta = minSize - prevSize;
            if (fuzzyCompareNumbers(localDelta, Math.abs(delta)) > 0) {
              delta = delta < 0 ? 0 - localDelta : localDelta;
            }
          }
        }
      }
      {
        const index2 = delta < 0 ? firstPivotIndex : secondPivotIndex;
        const panelConstraints = panelConstraintsArray[index2];
        assert(panelConstraints, `No panel constraints found for index ${index2}`);
        const {
          collapsedSize = 0,
          collapsible,
          minSize = 0
        } = panelConstraints;
        if (collapsible) {
          const prevSize = initialLayout[index2];
          assert(prevSize != null, `Previous layout not found for panel index ${index2}`);
          if (fuzzyNumbersEqual(prevSize, minSize)) {
            const localDelta = prevSize - collapsedSize;
            if (fuzzyCompareNumbers(localDelta, Math.abs(delta)) > 0) {
              delta = delta < 0 ? 0 - localDelta : localDelta;
            }
          }
        }
      }
    }
  }
  {
    const increment = delta < 0 ? 1 : -1;
    let index2 = delta < 0 ? secondPivotIndex : firstPivotIndex;
    let maxAvailableDelta = 0;
    while (true) {
      const prevSize = initialLayout[index2];
      assert(prevSize != null, `Previous layout not found for panel index ${index2}`);
      const maxSafeSize = resizePanel({
        panelConstraints: panelConstraintsArray,
        panelIndex: index2,
        size: 100
      });
      const delta2 = maxSafeSize - prevSize;
      maxAvailableDelta += delta2;
      index2 += increment;
      if (index2 < 0 || index2 >= panelConstraintsArray.length) {
        break;
      }
    }
    const minAbsDelta = Math.min(Math.abs(delta), Math.abs(maxAvailableDelta));
    delta = delta < 0 ? 0 - minAbsDelta : minAbsDelta;
  }
  {
    const pivotIndex = delta < 0 ? firstPivotIndex : secondPivotIndex;
    let index2 = pivotIndex;
    while (index2 >= 0 && index2 < panelConstraintsArray.length) {
      const deltaRemaining = Math.abs(delta) - Math.abs(deltaApplied);
      const prevSize = initialLayout[index2];
      assert(prevSize != null, `Previous layout not found for panel index ${index2}`);
      const unsafeSize = prevSize - deltaRemaining;
      const safeSize = resizePanel({
        panelConstraints: panelConstraintsArray,
        panelIndex: index2,
        size: unsafeSize
      });
      if (!fuzzyNumbersEqual(prevSize, safeSize)) {
        deltaApplied += prevSize - safeSize;
        nextLayout[index2] = safeSize;
        if (deltaApplied.toFixed(3).localeCompare(Math.abs(delta).toFixed(3), void 0, {
          numeric: true
        }) >= 0) {
          break;
        }
      }
      if (delta < 0) {
        index2--;
      } else {
        index2++;
      }
    }
  }
  if (fuzzyLayoutsEqual(prevLayout, nextLayout)) {
    return prevLayout;
  }
  {
    const pivotIndex = delta < 0 ? secondPivotIndex : firstPivotIndex;
    const prevSize = initialLayout[pivotIndex];
    assert(prevSize != null, `Previous layout not found for panel index ${pivotIndex}`);
    const unsafeSize = prevSize + deltaApplied;
    const safeSize = resizePanel({
      panelConstraints: panelConstraintsArray,
      panelIndex: pivotIndex,
      size: unsafeSize
    });
    nextLayout[pivotIndex] = safeSize;
    if (!fuzzyNumbersEqual(safeSize, unsafeSize)) {
      let deltaRemaining = unsafeSize - safeSize;
      const pivotIndex2 = delta < 0 ? secondPivotIndex : firstPivotIndex;
      let index2 = pivotIndex2;
      while (index2 >= 0 && index2 < panelConstraintsArray.length) {
        const prevSize2 = nextLayout[index2];
        assert(prevSize2 != null, `Previous layout not found for panel index ${index2}`);
        const unsafeSize2 = prevSize2 + deltaRemaining;
        const safeSize2 = resizePanel({
          panelConstraints: panelConstraintsArray,
          panelIndex: index2,
          size: unsafeSize2
        });
        if (!fuzzyNumbersEqual(prevSize2, safeSize2)) {
          deltaRemaining -= safeSize2 - prevSize2;
          nextLayout[index2] = safeSize2;
        }
        if (fuzzyNumbersEqual(deltaRemaining, 0)) {
          break;
        }
        if (delta > 0) {
          index2--;
        } else {
          index2++;
        }
      }
    }
  }
  const totalSize = nextLayout.reduce((total, size2) => size2 + total, 0);
  if (!fuzzyNumbersEqual(totalSize, 100)) {
    return prevLayout;
  }
  return nextLayout;
}
function calculateAriaValues({
  layout,
  panelsArray,
  pivotIndices
}) {
  let currentMinSize = 0;
  let currentMaxSize = 100;
  let totalMinSize = 0;
  let totalMaxSize = 0;
  const firstIndex = pivotIndices[0];
  assert(firstIndex != null, "No pivot index found");
  panelsArray.forEach((panelData, index2) => {
    const {
      constraints
    } = panelData;
    const {
      maxSize = 100,
      minSize = 0
    } = constraints;
    if (index2 === firstIndex) {
      currentMinSize = minSize;
      currentMaxSize = maxSize;
    } else {
      totalMinSize += minSize;
      totalMaxSize += maxSize;
    }
  });
  const valueMax = Math.min(currentMaxSize, 100 - totalMinSize);
  const valueMin = Math.max(currentMinSize, 100 - totalMaxSize);
  const valueNow = layout[firstIndex];
  return {
    valueMax,
    valueMin,
    valueNow
  };
}
function getResizeHandleElementsForGroup(groupId, scope = document) {
  return Array.from(scope.querySelectorAll(`[${DATA_ATTRIBUTES.resizeHandleId}][data-panel-group-id="${groupId}"]`));
}
function getResizeHandleElementIndex(groupId, id2, scope = document) {
  const handles = getResizeHandleElementsForGroup(groupId, scope);
  const index2 = handles.findIndex((handle) => handle.getAttribute(DATA_ATTRIBUTES.resizeHandleId) === id2);
  return index2 !== null && index2 !== void 0 ? index2 : null;
}
function determinePivotIndices(groupId, dragHandleId, panelGroupElement) {
  const index2 = getResizeHandleElementIndex(groupId, dragHandleId, panelGroupElement);
  return index2 != null ? [index2, index2 + 1] : [-1, -1];
}
function isHTMLElement$1(target) {
  if (target instanceof HTMLElement) {
    return true;
  }
  return typeof target === "object" && target !== null && "tagName" in target && "getAttribute" in target;
}
function getPanelGroupElement(id2, rootElement = document) {
  if (isHTMLElement$1(rootElement) && rootElement.dataset.panelGroupId == id2) {
    return rootElement;
  }
  const element2 = rootElement.querySelector(`[data-panel-group][data-panel-group-id="${id2}"]`);
  if (element2) {
    return element2;
  }
  return null;
}
function getResizeHandleElement(id2, scope = document) {
  const element2 = scope.querySelector(`[${DATA_ATTRIBUTES.resizeHandleId}="${id2}"]`);
  if (element2) {
    return element2;
  }
  return null;
}
function getResizeHandlePanelIds(groupId, handleId, panelsArray, scope = document) {
  var _panelsArray$index$id, _panelsArray$index, _panelsArray$id, _panelsArray;
  const handle = getResizeHandleElement(handleId, scope);
  const handles = getResizeHandleElementsForGroup(groupId, scope);
  const index2 = handle ? handles.indexOf(handle) : -1;
  const idBefore = (_panelsArray$index$id = (_panelsArray$index = panelsArray[index2]) === null || _panelsArray$index === void 0 ? void 0 : _panelsArray$index.id) !== null && _panelsArray$index$id !== void 0 ? _panelsArray$index$id : null;
  const idAfter = (_panelsArray$id = (_panelsArray = panelsArray[index2 + 1]) === null || _panelsArray === void 0 ? void 0 : _panelsArray.id) !== null && _panelsArray$id !== void 0 ? _panelsArray$id : null;
  return [idBefore, idAfter];
}
function useWindowSplitterPanelGroupBehavior({
  committedValuesRef,
  eagerValuesRef,
  groupId,
  layout,
  panelDataArray,
  panelGroupElement,
  setLayout
}) {
  useRef({
    didWarnAboutMissingResizeHandle: false
  });
  useIsomorphicLayoutEffect(() => {
    if (!panelGroupElement) {
      return;
    }
    const resizeHandleElements = getResizeHandleElementsForGroup(groupId, panelGroupElement);
    for (let index2 = 0; index2 < panelDataArray.length - 1; index2++) {
      const {
        valueMax,
        valueMin,
        valueNow
      } = calculateAriaValues({
        layout,
        panelsArray: panelDataArray,
        pivotIndices: [index2, index2 + 1]
      });
      const resizeHandleElement = resizeHandleElements[index2];
      if (resizeHandleElement == null) ;
      else {
        const panelData = panelDataArray[index2];
        assert(panelData, `No panel data found for index "${index2}"`);
        resizeHandleElement.setAttribute("aria-controls", panelData.id);
        resizeHandleElement.setAttribute("aria-valuemax", "" + Math.round(valueMax));
        resizeHandleElement.setAttribute("aria-valuemin", "" + Math.round(valueMin));
        resizeHandleElement.setAttribute("aria-valuenow", valueNow != null ? "" + Math.round(valueNow) : "");
      }
    }
    return () => {
      resizeHandleElements.forEach((resizeHandleElement, index2) => {
        resizeHandleElement.removeAttribute("aria-controls");
        resizeHandleElement.removeAttribute("aria-valuemax");
        resizeHandleElement.removeAttribute("aria-valuemin");
        resizeHandleElement.removeAttribute("aria-valuenow");
      });
    };
  }, [groupId, layout, panelDataArray, panelGroupElement]);
  useEffect(() => {
    if (!panelGroupElement) {
      return;
    }
    const eagerValues = eagerValuesRef.current;
    assert(eagerValues, `Eager values not found`);
    const {
      panelDataArray: panelDataArray2
    } = eagerValues;
    const groupElement = getPanelGroupElement(groupId, panelGroupElement);
    assert(groupElement != null, `No group found for id "${groupId}"`);
    const handles = getResizeHandleElementsForGroup(groupId, panelGroupElement);
    assert(handles, `No resize handles found for group id "${groupId}"`);
    const cleanupFunctions = handles.map((handle) => {
      const handleId = handle.getAttribute(DATA_ATTRIBUTES.resizeHandleId);
      assert(handleId, `Resize handle element has no handle id attribute`);
      const [idBefore, idAfter] = getResizeHandlePanelIds(groupId, handleId, panelDataArray2, panelGroupElement);
      if (idBefore == null || idAfter == null) {
        return () => {
        };
      }
      const onKeyDown = (event) => {
        if (event.defaultPrevented) {
          return;
        }
        switch (event.key) {
          case "Enter": {
            event.preventDefault();
            const index2 = panelDataArray2.findIndex((panelData) => panelData.id === idBefore);
            if (index2 >= 0) {
              const panelData = panelDataArray2[index2];
              assert(panelData, `No panel data found for index ${index2}`);
              const size2 = layout[index2];
              const {
                collapsedSize = 0,
                collapsible,
                minSize = 0
              } = panelData.constraints;
              if (size2 != null && collapsible) {
                const nextLayout = adjustLayoutByDelta({
                  delta: fuzzyNumbersEqual(size2, collapsedSize) ? minSize - collapsedSize : collapsedSize - size2,
                  initialLayout: layout,
                  panelConstraints: panelDataArray2.map((panelData2) => panelData2.constraints),
                  pivotIndices: determinePivotIndices(groupId, handleId, panelGroupElement),
                  prevLayout: layout,
                  trigger: "keyboard"
                });
                if (layout !== nextLayout) {
                  setLayout(nextLayout);
                }
              }
            }
            break;
          }
        }
      };
      handle.addEventListener("keydown", onKeyDown);
      return () => {
        handle.removeEventListener("keydown", onKeyDown);
      };
    });
    return () => {
      cleanupFunctions.forEach((cleanupFunction) => cleanupFunction());
    };
  }, [panelGroupElement, committedValuesRef, eagerValuesRef, groupId, layout, panelDataArray, setLayout]);
}
function areEqual(arrayA, arrayB) {
  if (arrayA.length !== arrayB.length) {
    return false;
  }
  for (let index2 = 0; index2 < arrayA.length; index2++) {
    if (arrayA[index2] !== arrayB[index2]) {
      return false;
    }
  }
  return true;
}
function getResizeEventCursorPosition(direction, event) {
  const isHorizontal = direction === "horizontal";
  const {
    x: x2,
    y
  } = getResizeEventCoordinates(event);
  return isHorizontal ? x2 : y;
}
function calculateDragOffsetPercentage(event, dragHandleId, direction, initialDragState, panelGroupElement) {
  const isHorizontal = direction === "horizontal";
  const handleElement = getResizeHandleElement(dragHandleId, panelGroupElement);
  assert(handleElement, `No resize handle element found for id "${dragHandleId}"`);
  const groupId = handleElement.getAttribute(DATA_ATTRIBUTES.groupId);
  assert(groupId, `Resize handle element has no group id attribute`);
  let {
    initialCursorPosition
  } = initialDragState;
  const cursorPosition = getResizeEventCursorPosition(direction, event);
  const groupElement = getPanelGroupElement(groupId, panelGroupElement);
  assert(groupElement, `No group element found for id "${groupId}"`);
  const groupRect = groupElement.getBoundingClientRect();
  const groupSizeInPixels = isHorizontal ? groupRect.width : groupRect.height;
  const offsetPixels = cursorPosition - initialCursorPosition;
  const offsetPercentage = offsetPixels / groupSizeInPixels * 100;
  return offsetPercentage;
}
function calculateDeltaPercentage(event, dragHandleId, direction, initialDragState, keyboardResizeBy, panelGroupElement) {
  if (isKeyDown(event)) {
    const isHorizontal = direction === "horizontal";
    let delta = 0;
    if (event.shiftKey) {
      delta = 100;
    } else if (keyboardResizeBy != null) {
      delta = keyboardResizeBy;
    } else {
      delta = 10;
    }
    let movement = 0;
    switch (event.key) {
      case "ArrowDown":
        movement = isHorizontal ? 0 : delta;
        break;
      case "ArrowLeft":
        movement = isHorizontal ? -delta : 0;
        break;
      case "ArrowRight":
        movement = isHorizontal ? delta : 0;
        break;
      case "ArrowUp":
        movement = isHorizontal ? 0 : -delta;
        break;
      case "End":
        movement = 100;
        break;
      case "Home":
        movement = -100;
        break;
    }
    return movement;
  } else {
    if (initialDragState == null) {
      return 0;
    }
    return calculateDragOffsetPercentage(event, dragHandleId, direction, initialDragState, panelGroupElement);
  }
}
function calculateUnsafeDefaultLayout({
  panelDataArray
}) {
  const layout = Array(panelDataArray.length);
  const panelConstraintsArray = panelDataArray.map((panelData) => panelData.constraints);
  let numPanelsWithSizes = 0;
  let remainingSize = 100;
  for (let index2 = 0; index2 < panelDataArray.length; index2++) {
    const panelConstraints = panelConstraintsArray[index2];
    assert(panelConstraints, `Panel constraints not found for index ${index2}`);
    const {
      defaultSize
    } = panelConstraints;
    if (defaultSize != null) {
      numPanelsWithSizes++;
      layout[index2] = defaultSize;
      remainingSize -= defaultSize;
    }
  }
  for (let index2 = 0; index2 < panelDataArray.length; index2++) {
    const panelConstraints = panelConstraintsArray[index2];
    assert(panelConstraints, `Panel constraints not found for index ${index2}`);
    const {
      defaultSize
    } = panelConstraints;
    if (defaultSize != null) {
      continue;
    }
    const numRemainingPanels = panelDataArray.length - numPanelsWithSizes;
    const size2 = remainingSize / numRemainingPanels;
    numPanelsWithSizes++;
    layout[index2] = size2;
    remainingSize -= size2;
  }
  return layout;
}
function callPanelCallbacks(panelsArray, layout, panelIdToLastNotifiedSizeMap) {
  layout.forEach((size2, index2) => {
    const panelData = panelsArray[index2];
    assert(panelData, `Panel data not found for index ${index2}`);
    const {
      callbacks,
      constraints,
      id: panelId
    } = panelData;
    const {
      collapsedSize = 0,
      collapsible
    } = constraints;
    const lastNotifiedSize = panelIdToLastNotifiedSizeMap[panelId];
    if (lastNotifiedSize == null || size2 !== lastNotifiedSize) {
      panelIdToLastNotifiedSizeMap[panelId] = size2;
      const {
        onCollapse,
        onExpand,
        onResize
      } = callbacks;
      if (onResize) {
        onResize(size2, lastNotifiedSize);
      }
      if (collapsible && (onCollapse || onExpand)) {
        if (onExpand && (lastNotifiedSize == null || fuzzyNumbersEqual$1(lastNotifiedSize, collapsedSize)) && !fuzzyNumbersEqual$1(size2, collapsedSize)) {
          onExpand();
        }
        if (onCollapse && (lastNotifiedSize == null || !fuzzyNumbersEqual$1(lastNotifiedSize, collapsedSize)) && fuzzyNumbersEqual$1(size2, collapsedSize)) {
          onCollapse();
        }
      }
    }
  });
}
function compareLayouts(a, b2) {
  if (a.length !== b2.length) {
    return false;
  } else {
    for (let index2 = 0; index2 < a.length; index2++) {
      if (a[index2] != b2[index2]) {
        return false;
      }
    }
  }
  return true;
}
function computePanelFlexBoxStyle({
  defaultSize,
  dragState,
  layout,
  panelData,
  panelIndex,
  precision = 3
}) {
  const size2 = layout[panelIndex];
  let flexGrow;
  if (size2 == null) {
    flexGrow = defaultSize != void 0 ? defaultSize.toFixed(precision) : "1";
  } else if (panelData.length === 1) {
    flexGrow = "1";
  } else {
    flexGrow = size2.toFixed(precision);
  }
  return {
    flexBasis: 0,
    flexGrow,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: dragState !== null ? "none" : void 0
  };
}
function debounce(callback, durationMs = 10) {
  let timeoutId = null;
  let callable = (...args) => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      callback(...args);
    }, durationMs);
  };
  return callable;
}
function initializeDefaultStorage(storageObject) {
  try {
    if (typeof localStorage !== "undefined") {
      storageObject.getItem = (name2) => {
        return localStorage.getItem(name2);
      };
      storageObject.setItem = (name2, value) => {
        localStorage.setItem(name2, value);
      };
    } else {
      throw new Error("localStorage not supported in this environment");
    }
  } catch (error) {
    console.error(error);
    storageObject.getItem = () => null;
    storageObject.setItem = () => {
    };
  }
}
function getPanelGroupKey(autoSaveId) {
  return `react-resizable-panels:${autoSaveId}`;
}
function getPanelKey(panels) {
  return panels.map((panel) => {
    const {
      constraints,
      id: id2,
      idIsFromProps,
      order: order2
    } = panel;
    if (idIsFromProps) {
      return id2;
    } else {
      return order2 ? `${order2}:${JSON.stringify(constraints)}` : JSON.stringify(constraints);
    }
  }).sort((a, b2) => a.localeCompare(b2)).join(",");
}
function loadSerializedPanelGroupState(autoSaveId, storage) {
  try {
    const panelGroupKey = getPanelGroupKey(autoSaveId);
    const serialized = storage.getItem(panelGroupKey);
    if (serialized) {
      const parsed = JSON.parse(serialized);
      if (typeof parsed === "object" && parsed != null) {
        return parsed;
      }
    }
  } catch (error) {
  }
  return null;
}
function loadPanelGroupState(autoSaveId, panels, storage) {
  var _loadSerializedPanelG, _state$panelKey;
  const state = (_loadSerializedPanelG = loadSerializedPanelGroupState(autoSaveId, storage)) !== null && _loadSerializedPanelG !== void 0 ? _loadSerializedPanelG : {};
  const panelKey = getPanelKey(panels);
  return (_state$panelKey = state[panelKey]) !== null && _state$panelKey !== void 0 ? _state$panelKey : null;
}
function savePanelGroupState(autoSaveId, panels, panelSizesBeforeCollapse, sizes, storage) {
  var _loadSerializedPanelG2;
  const panelGroupKey = getPanelGroupKey(autoSaveId);
  const panelKey = getPanelKey(panels);
  const state = (_loadSerializedPanelG2 = loadSerializedPanelGroupState(autoSaveId, storage)) !== null && _loadSerializedPanelG2 !== void 0 ? _loadSerializedPanelG2 : {};
  state[panelKey] = {
    expandToSizes: Object.fromEntries(panelSizesBeforeCollapse.entries()),
    layout: sizes
  };
  try {
    storage.setItem(panelGroupKey, JSON.stringify(state));
  } catch (error) {
    console.error(error);
  }
}
function validatePanelGroupLayout({
  layout: prevLayout,
  panelConstraints
}) {
  const nextLayout = [...prevLayout];
  const nextLayoutTotalSize = nextLayout.reduce((accumulated, current2) => accumulated + current2, 0);
  if (nextLayout.length !== panelConstraints.length) {
    throw Error(`Invalid ${panelConstraints.length} panel layout: ${nextLayout.map((size2) => `${size2}%`).join(", ")}`);
  } else if (!fuzzyNumbersEqual(nextLayoutTotalSize, 100) && nextLayout.length > 0) {
    for (let index2 = 0; index2 < panelConstraints.length; index2++) {
      const unsafeSize = nextLayout[index2];
      assert(unsafeSize != null, `No layout data found for index ${index2}`);
      const safeSize = 100 / nextLayoutTotalSize * unsafeSize;
      nextLayout[index2] = safeSize;
    }
  }
  let remainingSize = 0;
  for (let index2 = 0; index2 < panelConstraints.length; index2++) {
    const unsafeSize = nextLayout[index2];
    assert(unsafeSize != null, `No layout data found for index ${index2}`);
    const safeSize = resizePanel({
      panelConstraints,
      panelIndex: index2,
      size: unsafeSize
    });
    if (unsafeSize != safeSize) {
      remainingSize += unsafeSize - safeSize;
      nextLayout[index2] = safeSize;
    }
  }
  if (!fuzzyNumbersEqual(remainingSize, 0)) {
    for (let index2 = 0; index2 < panelConstraints.length; index2++) {
      const prevSize = nextLayout[index2];
      assert(prevSize != null, `No layout data found for index ${index2}`);
      const unsafeSize = prevSize + remainingSize;
      const safeSize = resizePanel({
        panelConstraints,
        panelIndex: index2,
        size: unsafeSize
      });
      if (prevSize !== safeSize) {
        remainingSize -= safeSize - prevSize;
        nextLayout[index2] = safeSize;
        if (fuzzyNumbersEqual(remainingSize, 0)) {
          break;
        }
      }
    }
  }
  return nextLayout;
}
const LOCAL_STORAGE_DEBOUNCE_INTERVAL = 100;
const defaultStorage = {
  getItem: (name2) => {
    initializeDefaultStorage(defaultStorage);
    return defaultStorage.getItem(name2);
  },
  setItem: (name2, value) => {
    initializeDefaultStorage(defaultStorage);
    defaultStorage.setItem(name2, value);
  }
};
const debounceMap = {};
function PanelGroupWithForwardedRef({
  autoSaveId = null,
  children,
  className: classNameFromProps = "",
  direction,
  forwardedRef,
  id: idFromProps = null,
  onLayout = null,
  keyboardResizeBy = null,
  storage = defaultStorage,
  style: styleFromProps,
  tagName: Type = "div",
  ...rest2
}) {
  const groupId = useUniqueId(idFromProps);
  const panelGroupElementRef = useRef(null);
  const [dragState, setDragState] = useState(null);
  const [layout, setLayout] = useState([]);
  const forceUpdate = useForceUpdate$2();
  const panelIdToLastNotifiedSizeMapRef = useRef({});
  const panelSizeBeforeCollapseRef = useRef(/* @__PURE__ */ new Map());
  const prevDeltaRef = useRef(0);
  const committedValuesRef = useRef({
    autoSaveId,
    direction,
    dragState,
    id: groupId,
    keyboardResizeBy,
    onLayout,
    storage
  });
  const eagerValuesRef = useRef({
    layout,
    panelDataArray: [],
    panelDataArrayChanged: false
  });
  useRef({
    didLogIdAndOrderWarning: false,
    didLogPanelConstraintsWarning: false,
    prevPanelIds: []
  });
  useImperativeHandle(forwardedRef, () => ({
    getId: () => committedValuesRef.current.id,
    getLayout: () => {
      const {
        layout: layout2
      } = eagerValuesRef.current;
      return layout2;
    },
    setLayout: (unsafeLayout) => {
      const {
        onLayout: onLayout2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      const safeLayout = validatePanelGroupLayout({
        layout: unsafeLayout,
        panelConstraints: panelDataArray.map((panelData) => panelData.constraints)
      });
      if (!areEqual(prevLayout, safeLayout)) {
        setLayout(safeLayout);
        eagerValuesRef.current.layout = safeLayout;
        if (onLayout2) {
          onLayout2(safeLayout);
        }
        callPanelCallbacks(panelDataArray, safeLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    }
  }), []);
  useIsomorphicLayoutEffect(() => {
    committedValuesRef.current.autoSaveId = autoSaveId;
    committedValuesRef.current.direction = direction;
    committedValuesRef.current.dragState = dragState;
    committedValuesRef.current.id = groupId;
    committedValuesRef.current.onLayout = onLayout;
    committedValuesRef.current.storage = storage;
  });
  useWindowSplitterPanelGroupBehavior({
    committedValuesRef,
    eagerValuesRef,
    groupId,
    layout,
    panelDataArray: eagerValuesRef.current.panelDataArray,
    setLayout,
    panelGroupElement: panelGroupElementRef.current
  });
  useEffect(() => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    if (autoSaveId) {
      if (layout.length === 0 || layout.length !== panelDataArray.length) {
        return;
      }
      let debouncedSave = debounceMap[autoSaveId];
      if (debouncedSave == null) {
        debouncedSave = debounce(savePanelGroupState, LOCAL_STORAGE_DEBOUNCE_INTERVAL);
        debounceMap[autoSaveId] = debouncedSave;
      }
      const clonedPanelDataArray = [...panelDataArray];
      const clonedPanelSizesBeforeCollapse = new Map(panelSizeBeforeCollapseRef.current);
      debouncedSave(autoSaveId, clonedPanelDataArray, clonedPanelSizesBeforeCollapse, layout, storage);
    }
  }, [autoSaveId, layout, storage]);
  useEffect(() => {
  });
  const collapsePanel = useCallback((panelData) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    if (panelData.constraints.collapsible) {
      const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
      const {
        collapsedSize = 0,
        panelSize,
        pivotIndices
      } = panelDataHelper(panelDataArray, panelData, prevLayout);
      assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
      if (!fuzzyNumbersEqual$1(panelSize, collapsedSize)) {
        panelSizeBeforeCollapseRef.current.set(panelData.id, panelSize);
        const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
        const delta = isLastPanel ? panelSize - collapsedSize : collapsedSize - panelSize;
        const nextLayout = adjustLayoutByDelta({
          delta,
          initialLayout: prevLayout,
          panelConstraints: panelConstraintsArray,
          pivotIndices,
          prevLayout,
          trigger: "imperative-api"
        });
        if (!compareLayouts(prevLayout, nextLayout)) {
          setLayout(nextLayout);
          eagerValuesRef.current.layout = nextLayout;
          if (onLayout2) {
            onLayout2(nextLayout);
          }
          callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
        }
      }
    }
  }, []);
  const expandPanel = useCallback((panelData, minSizeOverride) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    if (panelData.constraints.collapsible) {
      const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
      const {
        collapsedSize = 0,
        panelSize = 0,
        minSize: minSizeFromProps = 0,
        pivotIndices
      } = panelDataHelper(panelDataArray, panelData, prevLayout);
      const minSize = minSizeOverride !== null && minSizeOverride !== void 0 ? minSizeOverride : minSizeFromProps;
      if (fuzzyNumbersEqual$1(panelSize, collapsedSize)) {
        const prevPanelSize = panelSizeBeforeCollapseRef.current.get(panelData.id);
        const baseSize = prevPanelSize != null && prevPanelSize >= minSize ? prevPanelSize : minSize;
        const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
        const delta = isLastPanel ? panelSize - baseSize : baseSize - panelSize;
        const nextLayout = adjustLayoutByDelta({
          delta,
          initialLayout: prevLayout,
          panelConstraints: panelConstraintsArray,
          pivotIndices,
          prevLayout,
          trigger: "imperative-api"
        });
        if (!compareLayouts(prevLayout, nextLayout)) {
          setLayout(nextLayout);
          eagerValuesRef.current.layout = nextLayout;
          if (onLayout2) {
            onLayout2(nextLayout);
          }
          callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
        }
      }
    }
  }, []);
  const getPanelSize = useCallback((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return panelSize;
  }, []);
  const getPanelStyle = useCallback((panelData, defaultSize) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    const panelIndex = findPanelDataIndex(panelDataArray, panelData);
    return computePanelFlexBoxStyle({
      defaultSize,
      dragState,
      layout,
      panelData: panelDataArray,
      panelIndex
    });
  }, [dragState, layout]);
  const isPanelCollapsed = useCallback((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize = 0,
      collapsible,
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return collapsible === true && fuzzyNumbersEqual$1(panelSize, collapsedSize);
  }, []);
  const isPanelExpanded = useCallback((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize = 0,
      collapsible,
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return !collapsible || fuzzyCompareNumbers(panelSize, collapsedSize) > 0;
  }, []);
  const registerPanel = useCallback((panelData) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    panelDataArray.push(panelData);
    panelDataArray.sort((panelA, panelB) => {
      const orderA = panelA.order;
      const orderB = panelB.order;
      if (orderA == null && orderB == null) {
        return 0;
      } else if (orderA == null) {
        return -1;
      } else if (orderB == null) {
        return 1;
      } else {
        return orderA - orderB;
      }
    });
    eagerValuesRef.current.panelDataArrayChanged = true;
    forceUpdate();
  }, [forceUpdate]);
  useIsomorphicLayoutEffect(() => {
    if (eagerValuesRef.current.panelDataArrayChanged) {
      eagerValuesRef.current.panelDataArrayChanged = false;
      const {
        autoSaveId: autoSaveId2,
        onLayout: onLayout2,
        storage: storage2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      let unsafeLayout = null;
      if (autoSaveId2) {
        const state = loadPanelGroupState(autoSaveId2, panelDataArray, storage2);
        if (state) {
          panelSizeBeforeCollapseRef.current = new Map(Object.entries(state.expandToSizes));
          unsafeLayout = state.layout;
        }
      }
      if (unsafeLayout == null) {
        unsafeLayout = calculateUnsafeDefaultLayout({
          panelDataArray
        });
      }
      const nextLayout = validatePanelGroupLayout({
        layout: unsafeLayout,
        panelConstraints: panelDataArray.map((panelData) => panelData.constraints)
      });
      if (!areEqual(prevLayout, nextLayout)) {
        setLayout(nextLayout);
        eagerValuesRef.current.layout = nextLayout;
        if (onLayout2) {
          onLayout2(nextLayout);
        }
        callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    }
  });
  useIsomorphicLayoutEffect(() => {
    const eagerValues = eagerValuesRef.current;
    return () => {
      eagerValues.layout = [];
    };
  }, []);
  const registerResizeHandle2 = useCallback((dragHandleId) => {
    let isRTL2 = false;
    const panelGroupElement = panelGroupElementRef.current;
    if (panelGroupElement) {
      const style2 = window.getComputedStyle(panelGroupElement, null);
      if (style2.getPropertyValue("direction") === "rtl") {
        isRTL2 = true;
      }
    }
    return function resizeHandler(event) {
      event.preventDefault();
      const panelGroupElement2 = panelGroupElementRef.current;
      if (!panelGroupElement2) {
        return () => null;
      }
      const {
        direction: direction2,
        dragState: dragState2,
        id: groupId2,
        keyboardResizeBy: keyboardResizeBy2,
        onLayout: onLayout2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      const {
        initialLayout
      } = dragState2 !== null && dragState2 !== void 0 ? dragState2 : {};
      const pivotIndices = determinePivotIndices(groupId2, dragHandleId, panelGroupElement2);
      let delta = calculateDeltaPercentage(event, dragHandleId, direction2, dragState2, keyboardResizeBy2, panelGroupElement2);
      const isHorizontal = direction2 === "horizontal";
      if (isHorizontal && isRTL2) {
        delta = -delta;
      }
      const panelConstraints = panelDataArray.map((panelData) => panelData.constraints);
      const nextLayout = adjustLayoutByDelta({
        delta,
        initialLayout: initialLayout !== null && initialLayout !== void 0 ? initialLayout : prevLayout,
        panelConstraints,
        pivotIndices,
        prevLayout,
        trigger: isKeyDown(event) ? "keyboard" : "mouse-or-touch"
      });
      const layoutChanged = !compareLayouts(prevLayout, nextLayout);
      if (isPointerEvent(event) || isMouseEvent(event)) {
        if (prevDeltaRef.current != delta) {
          prevDeltaRef.current = delta;
          if (!layoutChanged && delta !== 0) {
            if (isHorizontal) {
              reportConstraintsViolation(dragHandleId, delta < 0 ? EXCEEDED_HORIZONTAL_MIN : EXCEEDED_HORIZONTAL_MAX);
            } else {
              reportConstraintsViolation(dragHandleId, delta < 0 ? EXCEEDED_VERTICAL_MIN : EXCEEDED_VERTICAL_MAX);
            }
          } else {
            reportConstraintsViolation(dragHandleId, 0);
          }
        }
      }
      if (layoutChanged) {
        setLayout(nextLayout);
        eagerValuesRef.current.layout = nextLayout;
        if (onLayout2) {
          onLayout2(nextLayout);
        }
        callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    };
  }, []);
  const resizePanel2 = useCallback((panelData, unsafePanelSize) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
    const {
      panelSize,
      pivotIndices
    } = panelDataHelper(panelDataArray, panelData, prevLayout);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
    const delta = isLastPanel ? panelSize - unsafePanelSize : unsafePanelSize - panelSize;
    const nextLayout = adjustLayoutByDelta({
      delta,
      initialLayout: prevLayout,
      panelConstraints: panelConstraintsArray,
      pivotIndices,
      prevLayout,
      trigger: "imperative-api"
    });
    if (!compareLayouts(prevLayout, nextLayout)) {
      setLayout(nextLayout);
      eagerValuesRef.current.layout = nextLayout;
      if (onLayout2) {
        onLayout2(nextLayout);
      }
      callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
    }
  }, []);
  const reevaluatePanelConstraints = useCallback((panelData, prevConstraints) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize: prevCollapsedSize = 0,
      collapsible: prevCollapsible
    } = prevConstraints;
    const {
      collapsedSize: nextCollapsedSize = 0,
      collapsible: nextCollapsible,
      maxSize: nextMaxSize = 100,
      minSize: nextMinSize = 0
    } = panelData.constraints;
    const {
      panelSize: prevPanelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    if (prevPanelSize == null) {
      return;
    }
    if (prevCollapsible && nextCollapsible && fuzzyNumbersEqual$1(prevPanelSize, prevCollapsedSize)) {
      if (!fuzzyNumbersEqual$1(prevCollapsedSize, nextCollapsedSize)) {
        resizePanel2(panelData, nextCollapsedSize);
      }
    } else if (prevPanelSize < nextMinSize) {
      resizePanel2(panelData, nextMinSize);
    } else if (prevPanelSize > nextMaxSize) {
      resizePanel2(panelData, nextMaxSize);
    }
  }, [resizePanel2]);
  const startDragging = useCallback((dragHandleId, event) => {
    const {
      direction: direction2
    } = committedValuesRef.current;
    const {
      layout: layout2
    } = eagerValuesRef.current;
    if (!panelGroupElementRef.current) {
      return;
    }
    const handleElement = getResizeHandleElement(dragHandleId, panelGroupElementRef.current);
    assert(handleElement, `Drag handle element not found for id "${dragHandleId}"`);
    const initialCursorPosition = getResizeEventCursorPosition(direction2, event);
    setDragState({
      dragHandleId,
      dragHandleRect: handleElement.getBoundingClientRect(),
      initialCursorPosition,
      initialLayout: layout2
    });
  }, []);
  const stopDragging = useCallback(() => {
    setDragState(null);
  }, []);
  const unregisterPanel = useCallback((panelData) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    const index2 = findPanelDataIndex(panelDataArray, panelData);
    if (index2 >= 0) {
      panelDataArray.splice(index2, 1);
      delete panelIdToLastNotifiedSizeMapRef.current[panelData.id];
      eagerValuesRef.current.panelDataArrayChanged = true;
      forceUpdate();
    }
  }, [forceUpdate]);
  const context = useMemo(() => ({
    collapsePanel,
    direction,
    dragState,
    expandPanel,
    getPanelSize,
    getPanelStyle,
    groupId,
    isPanelCollapsed,
    isPanelExpanded,
    reevaluatePanelConstraints,
    registerPanel,
    registerResizeHandle: registerResizeHandle2,
    resizePanel: resizePanel2,
    startDragging,
    stopDragging,
    unregisterPanel,
    panelGroupElement: panelGroupElementRef.current
  }), [collapsePanel, dragState, direction, expandPanel, getPanelSize, getPanelStyle, groupId, isPanelCollapsed, isPanelExpanded, reevaluatePanelConstraints, registerPanel, registerResizeHandle2, resizePanel2, startDragging, stopDragging, unregisterPanel]);
  const style = {
    display: "flex",
    flexDirection: direction === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return createElement$3(PanelGroupContext.Provider, {
    value: context
  }, createElement$3(Type, {
    ...rest2,
    children,
    className: classNameFromProps,
    id: idFromProps,
    ref: panelGroupElementRef,
    style: {
      ...style,
      ...styleFromProps
    },
    // CSS selectors
    [DATA_ATTRIBUTES.group]: "",
    [DATA_ATTRIBUTES.groupDirection]: direction,
    [DATA_ATTRIBUTES.groupId]: groupId
  }));
}
const PanelGroup$1 = forwardRef((props2, ref) => createElement$3(PanelGroupWithForwardedRef, {
  ...props2,
  forwardedRef: ref
}));
PanelGroupWithForwardedRef.displayName = "PanelGroup";
PanelGroup$1.displayName = "forwardRef(PanelGroup)";
function findPanelDataIndex(panelDataArray, panelData) {
  return panelDataArray.findIndex((prevPanelData) => prevPanelData === panelData || prevPanelData.id === panelData.id);
}
function panelDataHelper(panelDataArray, panelData, layout) {
  const panelIndex = findPanelDataIndex(panelDataArray, panelData);
  const isLastPanel = panelIndex === panelDataArray.length - 1;
  const pivotIndices = isLastPanel ? [panelIndex - 1, panelIndex] : [panelIndex, panelIndex + 1];
  const panelSize = layout[panelIndex];
  return {
    ...panelData.constraints,
    panelSize,
    pivotIndices
  };
}
function useWindowSplitterResizeHandlerBehavior({
  disabled,
  handleId,
  resizeHandler,
  panelGroupElement
}) {
  useEffect(() => {
    if (disabled || resizeHandler == null || panelGroupElement == null) {
      return;
    }
    const handleElement = getResizeHandleElement(handleId, panelGroupElement);
    if (handleElement == null) {
      return;
    }
    const onKeyDown = (event) => {
      if (event.defaultPrevented) {
        return;
      }
      switch (event.key) {
        case "ArrowDown":
        case "ArrowLeft":
        case "ArrowRight":
        case "ArrowUp":
        case "End":
        case "Home": {
          event.preventDefault();
          resizeHandler(event);
          break;
        }
        case "F6": {
          event.preventDefault();
          const groupId = handleElement.getAttribute(DATA_ATTRIBUTES.groupId);
          assert(groupId, `No group element found for id "${groupId}"`);
          const handles = getResizeHandleElementsForGroup(groupId, panelGroupElement);
          const index2 = getResizeHandleElementIndex(groupId, handleId, panelGroupElement);
          assert(index2 !== null, `No resize element found for id "${handleId}"`);
          const nextIndex = event.shiftKey ? index2 > 0 ? index2 - 1 : handles.length - 1 : index2 + 1 < handles.length ? index2 + 1 : 0;
          const nextHandle = handles[nextIndex];
          nextHandle.focus();
          break;
        }
      }
    };
    handleElement.addEventListener("keydown", onKeyDown);
    return () => {
      handleElement.removeEventListener("keydown", onKeyDown);
    };
  }, [panelGroupElement, disabled, handleId, resizeHandler]);
}
function PanelResizeHandle({
  children = null,
  className: classNameFromProps = "",
  disabled = false,
  hitAreaMargins,
  id: idFromProps,
  onBlur,
  onClick,
  onDragging,
  onFocus,
  onPointerDown,
  onPointerUp,
  style: styleFromProps = {},
  tabIndex = 0,
  tagName: Type = "div",
  ...rest2
}) {
  var _hitAreaMargins$coars, _hitAreaMargins$fine;
  const elementRef = useRef(null);
  const callbacksRef = useRef({
    onClick,
    onDragging,
    onPointerDown,
    onPointerUp
  });
  useEffect(() => {
    callbacksRef.current.onClick = onClick;
    callbacksRef.current.onDragging = onDragging;
    callbacksRef.current.onPointerDown = onPointerDown;
    callbacksRef.current.onPointerUp = onPointerUp;
  });
  const panelGroupContext = useContext(PanelGroupContext);
  if (panelGroupContext === null) {
    throw Error(`PanelResizeHandle components must be rendered within a PanelGroup container`);
  }
  const {
    direction,
    groupId,
    registerResizeHandle: registerResizeHandleWithParentGroup,
    startDragging,
    stopDragging,
    panelGroupElement
  } = panelGroupContext;
  const resizeHandleId = useUniqueId(idFromProps);
  const [state, setState] = useState("inactive");
  const [isFocused, setIsFocused] = useState(false);
  const [resizeHandler, setResizeHandler] = useState(null);
  const committedValuesRef = useRef({
    state
  });
  useIsomorphicLayoutEffect(() => {
    committedValuesRef.current.state = state;
  });
  useEffect(() => {
    if (disabled) {
      setResizeHandler(null);
    } else {
      const resizeHandler2 = registerResizeHandleWithParentGroup(resizeHandleId);
      setResizeHandler(() => resizeHandler2);
    }
  }, [disabled, resizeHandleId, registerResizeHandleWithParentGroup]);
  const coarseHitAreaMargins = (_hitAreaMargins$coars = hitAreaMargins === null || hitAreaMargins === void 0 ? void 0 : hitAreaMargins.coarse) !== null && _hitAreaMargins$coars !== void 0 ? _hitAreaMargins$coars : 15;
  const fineHitAreaMargins = (_hitAreaMargins$fine = hitAreaMargins === null || hitAreaMargins === void 0 ? void 0 : hitAreaMargins.fine) !== null && _hitAreaMargins$fine !== void 0 ? _hitAreaMargins$fine : 5;
  useEffect(() => {
    if (disabled || resizeHandler == null) {
      return;
    }
    const element2 = elementRef.current;
    assert(element2, "Element ref not attached");
    let didMove = false;
    const setResizeHandlerState = (action, isActive, event) => {
      if (!isActive) {
        setState("inactive");
        return;
      }
      switch (action) {
        case "down": {
          setState("drag");
          didMove = false;
          assert(event, 'Expected event to be defined for "down" action');
          startDragging(resizeHandleId, event);
          const {
            onDragging: onDragging2,
            onPointerDown: onPointerDown2
          } = callbacksRef.current;
          onDragging2 === null || onDragging2 === void 0 ? void 0 : onDragging2(true);
          onPointerDown2 === null || onPointerDown2 === void 0 ? void 0 : onPointerDown2();
          break;
        }
        case "move": {
          const {
            state: state2
          } = committedValuesRef.current;
          didMove = true;
          if (state2 !== "drag") {
            setState("hover");
          }
          assert(event, 'Expected event to be defined for "move" action');
          resizeHandler(event);
          break;
        }
        case "up": {
          setState("hover");
          stopDragging();
          const {
            onClick: onClick2,
            onDragging: onDragging2,
            onPointerUp: onPointerUp2
          } = callbacksRef.current;
          onDragging2 === null || onDragging2 === void 0 ? void 0 : onDragging2(false);
          onPointerUp2 === null || onPointerUp2 === void 0 ? void 0 : onPointerUp2();
          if (!didMove) {
            onClick2 === null || onClick2 === void 0 ? void 0 : onClick2();
          }
          break;
        }
      }
    };
    return registerResizeHandle(resizeHandleId, element2, direction, {
      coarse: coarseHitAreaMargins,
      fine: fineHitAreaMargins
    }, setResizeHandlerState);
  }, [coarseHitAreaMargins, direction, disabled, fineHitAreaMargins, registerResizeHandleWithParentGroup, resizeHandleId, resizeHandler, startDragging, stopDragging]);
  useWindowSplitterResizeHandlerBehavior({
    disabled,
    handleId: resizeHandleId,
    resizeHandler,
    panelGroupElement
  });
  const style = {
    touchAction: "none",
    userSelect: "none"
  };
  return createElement$3(Type, {
    ...rest2,
    children,
    className: classNameFromProps,
    id: idFromProps,
    onBlur: () => {
      setIsFocused(false);
      onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    },
    onFocus: () => {
      setIsFocused(true);
      onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    },
    ref: elementRef,
    role: "separator",
    style: {
      ...style,
      ...styleFromProps
    },
    tabIndex,
    // CSS selectors
    [DATA_ATTRIBUTES.groupDirection]: direction,
    [DATA_ATTRIBUTES.groupId]: groupId,
    [DATA_ATTRIBUTES.resizeHandle]: "",
    [DATA_ATTRIBUTES.resizeHandleActive]: state === "drag" ? "pointer" : isFocused ? "keyboard" : void 0,
    [DATA_ATTRIBUTES.resizeHandleEnabled]: !disabled,
    [DATA_ATTRIBUTES.resizeHandleId]: resizeHandleId,
    [DATA_ATTRIBUTES.resizeHandleState]: state
  });
}
PanelResizeHandle.displayName = "PanelResizeHandle";
function ResizablePanelPair({
  panelA,
  panelB,
  preferredDirection = "horizontal",
  width = "100%",
  height = "100%",
  border = "1px solid"
}) {
  const panelContainerRef = React__default.useRef(null);
  const [direction, setDirection] = React__default.useState(preferredDirection);
  const grip = direction === "horizontal" ? /* @__PURE__ */ React__default.createElement(BsGripVertical, null) : /* @__PURE__ */ React__default.createElement(BsGripHorizontal, null);
  React__default.useEffect(() => {
    if (!panelContainerRef.current) {
      return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width2 = entry.contentRect.width;
        const desiredDirection = width2 < 430 ? "vertical" : preferredDirection;
        if (desiredDirection !== direction) {
          setDirection(desiredDirection);
        }
      }
    });
    resizeObserver.observe(panelContainerRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [direction, preferredDirection]);
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ref: panelContainerRef,
      style: {
        width,
        height,
        border,
        boxSizing: "border-box"
      }
    },
    /* @__PURE__ */ React__default.createElement(PanelGroup$1, { direction }, /* @__PURE__ */ React__default.createElement(Panel, null, panelA), /* @__PURE__ */ React__default.createElement(
      PanelResizeHandle,
      {
        className: classNames("doenet-resizable-panel-handle", {
          vertical: direction === "vertical"
        }),
        "data-test": "contentPanelDragHandle"
      },
      grip
    ), /* @__PURE__ */ React__default.createElement(Panel, null, panelB))
  );
}
function ResizableCollapsiblePanelPair({
  mainPanel,
  subPanel,
  alwaysVisiblePanel,
  collapsedSize = 15,
  isOpen,
  setIsOpen
}) {
  const collapsablePanelRef = React__default.useRef(null);
  React__default.useEffect(() => {
    if (collapsablePanelRef.current) {
      if (isOpen) {
        collapsablePanelRef.current.expand();
      } else {
        collapsablePanelRef.current.collapse();
      }
    }
  }, [isOpen]);
  return /* @__PURE__ */ React__default.createElement("div", { style: { height: "100%", width: "100%", boxSizing: "border-box" } }, /* @__PURE__ */ React__default.createElement(PanelGroup$1, { direction: "vertical" }, /* @__PURE__ */ React__default.createElement(Panel, null, mainPanel), /* @__PURE__ */ React__default.createElement(
    PanelResizeHandle,
    {
      className: classNames(
        "doenet-resizable-panel-handle",
        "vertical",
        "collapsible",
        { isOpen }
      ),
      "data-test": "contentPanelDragHandle"
    },
    isOpen && /* @__PURE__ */ React__default.createElement(BsGripHorizontal, null)
  ), alwaysVisiblePanel, /* @__PURE__ */ React__default.createElement(
    Panel,
    {
      ref: collapsablePanelRef,
      collapsible: true,
      collapsedSize: 0,
      minSize: collapsedSize,
      onCollapse: () => {
        setIsOpen(false);
      },
      onExpand: () => {
        setIsOpen(true);
      }
    },
    subPanel
  )));
}
const CLASS_NAME = "doenet-ui-button";
function UiButton(props2) {
  let className = props2.className ? `${CLASS_NAME} ${props2.className}` : CLASS_NAME;
  return /* @__PURE__ */ React__default.createElement(Button$1, { ...props2, className });
}
function RxUpdate(props2) {
  return GenIcon$1({ "attr": { "viewBox": "0 0 15 15", "fill": "none" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "clipRule": "evenodd", "d": "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z", "fill": "currentColor" }, "child": [] }] })(props2);
}
function noop$1(..._2) {
}
function applyState(argument, currentValue) {
  if (isUpdater(argument)) {
    const value = isLazyValue(currentValue) ? currentValue() : currentValue;
    return argument(value);
  }
  return argument;
}
function isUpdater(argument) {
  return typeof argument === "function";
}
function isLazyValue(value) {
  return typeof value === "function";
}
function hasOwnProperty$2(object2, prop) {
  if (typeof Object.hasOwn === "function") {
    return Object.hasOwn(object2, prop);
  }
  return Object.prototype.hasOwnProperty.call(object2, prop);
}
function chain(...fns) {
  return (...args) => {
    for (const fn of fns) {
      if (typeof fn === "function") {
        fn(...args);
      }
    }
  };
}
function normalizeString$1(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function omit(object2, keys2) {
  const result2 = { ...object2 };
  for (const key of keys2) {
    if (hasOwnProperty$2(result2, key)) {
      delete result2[key];
    }
  }
  return result2;
}
function pick(object2, paths) {
  const result2 = {};
  for (const key of paths) {
    if (hasOwnProperty$2(object2, key)) {
      result2[key] = object2[key];
    }
  }
  return result2;
}
function identity(value) {
  return value;
}
function invariant(condition, message) {
  if (condition) return;
  if (typeof message !== "string") throw new Error("Invariant failed");
  throw new Error(message);
}
function getKeys(obj) {
  return Object.keys(obj);
}
function isFalsyBooleanCallback(booleanOrCallback, ...args) {
  const result2 = typeof booleanOrCallback === "function" ? booleanOrCallback(...args) : booleanOrCallback;
  if (result2 == null) return false;
  return !result2;
}
function disabledFromProps(props2) {
  return props2.disabled || props2["aria-disabled"] === true || props2["aria-disabled"] === "true";
}
function removeUndefinedValues(obj) {
  const result2 = {};
  for (const key in obj) {
    if (obj[key] !== void 0) {
      result2[key] = obj[key];
    }
  }
  return result2;
}
function defaultValue(...values2) {
  for (const value of values2) {
    if (value !== void 0) return value;
  }
  return void 0;
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function isValidElementWithRef(element2) {
  if (!element2) return false;
  if (!isValidElement$1(element2)) return false;
  if ("ref" in element2.props) return true;
  if ("ref" in element2) return true;
  return false;
}
function getRefProperty(element2) {
  if (!isValidElementWithRef(element2)) return null;
  const props2 = { ...element2.props };
  return props2.ref || element2.ref;
}
function mergeProps(base2, overrides2) {
  const props2 = { ...base2 };
  for (const key in overrides2) {
    if (!hasOwnProperty$2(overrides2, key)) continue;
    if (key === "className") {
      const prop = "className";
      props2[prop] = base2[prop] ? `${base2[prop]} ${overrides2[prop]}` : overrides2[prop];
      continue;
    }
    if (key === "style") {
      const prop = "style";
      props2[prop] = base2[prop] ? { ...base2[prop], ...overrides2[prop] } : overrides2[prop];
      continue;
    }
    const overrideValue = overrides2[key];
    if (typeof overrideValue === "function" && key.startsWith("on")) {
      const baseValue = base2[key];
      if (typeof baseValue === "function") {
        props2[key] = (...args) => {
          overrideValue(...args);
          baseValue(...args);
        };
        continue;
      }
    }
    props2[key] = overrideValue;
  }
  return props2;
}
var canUseDOM = checkIsBrowser();
function checkIsBrowser() {
  var _a2;
  return typeof window !== "undefined" && !!((_a2 = window.document) == null ? void 0 : _a2.createElement);
}
function getDocument(node) {
  if (!node) return document;
  if ("self" in node) return node.document;
  return node.ownerDocument || document;
}
function getWindow$1(node) {
  if (!node) return self;
  if ("self" in node) return node.self;
  return getDocument(node).defaultView || window;
}
function getActiveElement(node, activeDescendant = false) {
  const { activeElement } = getDocument(node);
  if (!(activeElement == null ? void 0 : activeElement.nodeName)) {
    return null;
  }
  if (isFrame(activeElement) && activeElement.contentDocument) {
    return getActiveElement(
      activeElement.contentDocument.body,
      activeDescendant
    );
  }
  if (activeDescendant) {
    const id2 = activeElement.getAttribute("aria-activedescendant");
    if (id2) {
      const element2 = getDocument(activeElement).getElementById(id2);
      if (element2) {
        return element2;
      }
    }
  }
  return activeElement;
}
function contains$1(parent, child) {
  return parent === child || parent.contains(child);
}
function isFrame(element2) {
  return element2.tagName === "IFRAME";
}
function isButton(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "button") return true;
  if (tagName === "input" && element2.type) {
    return buttonInputTypes.indexOf(element2.type) !== -1;
  }
  return false;
}
var buttonInputTypes = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function isVisible(element2) {
  if (typeof element2.checkVisibility === "function") {
    return element2.checkVisibility();
  }
  const htmlElement = element2;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element2.getClientRects().length > 0;
}
function isTextField(element2) {
  try {
    const isTextInput = element2 instanceof HTMLInputElement && element2.selectionStart !== null;
    const isTextArea = element2.tagName === "TEXTAREA";
    return isTextInput || isTextArea || false;
  } catch (_error) {
    return false;
  }
}
function isTextbox(element2) {
  return element2.isContentEditable || isTextField(element2);
}
function getTextboxValue(element2) {
  if (isTextField(element2)) {
    return element2.value;
  }
  if (element2.isContentEditable) {
    const range2 = getDocument(element2).createRange();
    range2.selectNodeContents(element2);
    return range2.toString();
  }
  return "";
}
function getTextboxSelection(element2) {
  let start = 0;
  let end = 0;
  if (isTextField(element2)) {
    start = element2.selectionStart || 0;
    end = element2.selectionEnd || 0;
  } else if (element2.isContentEditable) {
    const selection2 = getDocument(element2).getSelection();
    if ((selection2 == null ? void 0 : selection2.rangeCount) && selection2.anchorNode && contains$1(element2, selection2.anchorNode) && selection2.focusNode && contains$1(element2, selection2.focusNode)) {
      const range2 = selection2.getRangeAt(0);
      const nextRange = range2.cloneRange();
      nextRange.selectNodeContents(element2);
      nextRange.setEnd(range2.startContainer, range2.startOffset);
      start = nextRange.toString().length;
      nextRange.setEnd(range2.endContainer, range2.endOffset);
      end = nextRange.toString().length;
    }
  }
  return { start, end };
}
function getPopupRole(element2, fallback) {
  const allowedPopupRoles = ["dialog", "menu", "listbox", "tree", "grid"];
  const role = element2 == null ? void 0 : element2.getAttribute("role");
  if (role && allowedPopupRoles.indexOf(role) !== -1) {
    return role;
  }
  return fallback;
}
function getPopupItemRole(element2, fallback) {
  var _a2;
  const itemRoleByPopupRole = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  };
  const popupRole = getPopupRole(element2);
  if (!popupRole) return fallback;
  const key = popupRole;
  return (_a2 = itemRoleByPopupRole[key]) != null ? _a2 : fallback;
}
function getScrollingElement(element2) {
  if (!element2) return null;
  const isScrollableOverflow = (overflow) => {
    if (overflow === "auto") return true;
    if (overflow === "scroll") return true;
    return false;
  };
  if (element2.clientHeight && element2.scrollHeight > element2.clientHeight) {
    const { overflowY } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowY)) return element2;
  } else if (element2.clientWidth && element2.scrollWidth > element2.clientWidth) {
    const { overflowX } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowX)) return element2;
  }
  return getScrollingElement(element2.parentElement) || document.scrollingElement || document.body;
}
function setSelectionRange(element2, ...args) {
  if (/text|search|password|tel|url/i.test(element2.type)) {
    element2.setSelectionRange(...args);
  }
}
function sortBasedOnDOMPosition(items, getElement) {
  const pairs2 = items.map((item, index2) => [index2, item]);
  let isOrderDifferent = false;
  pairs2.sort(([indexA, a], [indexB, b2]) => {
    const elementA = getElement(a);
    const elementB = getElement(b2);
    if (elementA === elementB) return 0;
    if (!elementA || !elementB) return 0;
    if (isElementPreceding(elementA, elementB)) {
      if (indexA > indexB) {
        isOrderDifferent = true;
      }
      return -1;
    }
    if (indexA < indexB) {
      isOrderDifferent = true;
    }
    return 1;
  });
  if (isOrderDifferent) {
    return pairs2.map(([_2, item]) => item);
  }
  return items;
}
function isElementPreceding(a, b2) {
  return Boolean(
    b2.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING
  );
}
function isTouchDevice() {
  return canUseDOM && !!navigator.maxTouchPoints;
}
function isApple() {
  if (!canUseDOM) return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform);
}
function isSafari() {
  return canUseDOM && isApple() && /apple/i.test(navigator.vendor);
}
function isFirefox() {
  return canUseDOM && /firefox\//i.test(navigator.userAgent);
}
function isMac() {
  return canUseDOM && navigator.platform.startsWith("Mac") && !isTouchDevice();
}
function isPortalEvent(event) {
  return Boolean(
    event.currentTarget && !contains$1(event.currentTarget, event.target)
  );
}
function isSelfTarget(event) {
  return event.target === event.currentTarget;
}
function isOpeningInNewTab(event) {
  const element2 = event.currentTarget;
  if (!element2) return false;
  const isAppleDevice = isApple();
  if (isAppleDevice && !event.metaKey) return false;
  if (!isAppleDevice && !event.ctrlKey) return false;
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "a") return true;
  if (tagName === "button" && element2.type === "submit") return true;
  if (tagName === "input" && element2.type === "submit") return true;
  return false;
}
function isDownloading(event) {
  const element2 = event.currentTarget;
  if (!element2) return false;
  const tagName = element2.tagName.toLowerCase();
  if (!event.altKey) return false;
  if (tagName === "a") return true;
  if (tagName === "button" && element2.type === "submit") return true;
  if (tagName === "input" && element2.type === "submit") return true;
  return false;
}
function fireBlurEvent(element2, eventInit) {
  const event = new FocusEvent("blur", eventInit);
  const defaultAllowed = element2.dispatchEvent(event);
  const bubbleInit = { ...eventInit, bubbles: true };
  element2.dispatchEvent(new FocusEvent("focusout", bubbleInit));
  return defaultAllowed;
}
function fireKeyboardEvent(element2, type, eventInit) {
  const event = new KeyboardEvent(type, eventInit);
  return element2.dispatchEvent(event);
}
function fireClickEvent(element2, eventInit) {
  const event = new MouseEvent("click", eventInit);
  return element2.dispatchEvent(event);
}
function isFocusEventOutside(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains$1(containerElement, relatedTarget);
}
function queueBeforeEvent(element2, type, callback, timeout) {
  const createTimer = (callback2) => {
    const timerId = requestAnimationFrame(callback2);
    return () => cancelAnimationFrame(timerId);
  };
  const cancelTimer = createTimer(() => {
    element2.removeEventListener(type, callSync, true);
    callback();
  });
  const callSync = () => {
    cancelTimer();
    callback();
  };
  element2.addEventListener(type, callSync, { once: true, capture: true });
  return cancelTimer;
}
function addGlobalEventListener(type, listener, options2, scope = window) {
  const children = [];
  try {
    scope.document.addEventListener(type, listener, options2);
    for (const frame of Array.from(scope.frames)) {
      children.push(addGlobalEventListener(type, listener, options2, frame));
    }
  } catch (e2) {
  }
  const removeEventListener2 = () => {
    try {
      scope.document.removeEventListener(type, listener, options2);
    } catch (e2) {
    }
    for (const remove2 of children) {
      remove2();
    }
  };
  return removeEventListener2;
}
var _React = { ...React };
var useReactId = _React.useId;
var useReactInsertionEffect = _React.useInsertionEffect;
var useSafeLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;
function useInitialValue(value) {
  const [initialValue] = useState(value);
  return initialValue;
}
function useLiveRef(value) {
  const ref = useRef(value);
  useSafeLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
function useEvent(callback) {
  const ref = useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  if (useReactInsertionEffect) {
    useReactInsertionEffect(() => {
      ref.current = callback;
    });
  } else {
    ref.current = callback;
  }
  return useCallback((...args) => {
    var _a2;
    return (_a2 = ref.current) == null ? void 0 : _a2.call(ref, ...args);
  }, []);
}
function useTransactionState(callback) {
  const [state, setState] = useState(null);
  useSafeLayoutEffect(() => {
    if (state == null) return;
    if (!callback) return;
    let prevState = null;
    callback((prev) => {
      prevState = prev;
      return state;
    });
    return () => {
      callback(prevState);
    };
  }, [state, callback]);
  return [state, setState];
}
function useMergeRefs(...refs) {
  return useMemo(() => {
    if (!refs.some(Boolean)) return;
    return (value) => {
      for (const ref of refs) {
        setRef(ref, value);
      }
    };
  }, refs);
}
function useId(defaultId) {
  if (useReactId) {
    const reactId = useReactId();
    if (defaultId) return defaultId;
    return reactId;
  }
  const [id2, setId] = useState(defaultId);
  useSafeLayoutEffect(() => {
    if (defaultId || id2) return;
    const random2 = Math.random().toString(36).slice(2, 8);
    setId(`id-${random2}`);
  }, [defaultId, id2]);
  return defaultId || id2;
}
function useTagName(refOrElement, type) {
  const stringOrUndefined = (type2) => {
    if (typeof type2 !== "string") return;
    return type2;
  };
  const [tagName, setTagName] = useState(() => stringOrUndefined(type));
  useSafeLayoutEffect(() => {
    const element2 = refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement;
    setTagName((element2 == null ? void 0 : element2.tagName.toLowerCase()) || stringOrUndefined(type));
  }, [refOrElement, type]);
  return tagName;
}
function useAttribute(refOrElement, attributeName, defaultValue2) {
  const initialValue = useInitialValue(defaultValue2);
  const [attribute, setAttribute2] = useState(initialValue);
  useEffect(() => {
    const element2 = refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement;
    if (!element2) return;
    const callback = () => {
      const value = element2.getAttribute(attributeName);
      setAttribute2(value == null ? initialValue : value);
    };
    const observer = new MutationObserver(callback);
    observer.observe(element2, { attributeFilter: [attributeName] });
    callback();
    return () => observer.disconnect();
  }, [refOrElement, attributeName, initialValue]);
  return attribute;
}
function useUpdateEffect(effect, deps) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) {
      return effect();
    }
    mounted.current = true;
  }, deps);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );
}
function useUpdateLayoutEffect(effect, deps) {
  const mounted = useRef(false);
  useSafeLayoutEffect(() => {
    if (mounted.current) {
      return effect();
    }
    mounted.current = true;
  }, deps);
  useSafeLayoutEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );
}
function useForceUpdate() {
  return useReducer(() => [], []);
}
function useBooleanEvent(booleanOrCallback) {
  return useEvent(
    typeof booleanOrCallback === "function" ? booleanOrCallback : () => booleanOrCallback
  );
}
function useWrapElement(props2, callback, deps = []) {
  const wrapElement = useCallback(
    (element2) => {
      if (props2.wrapElement) {
        element2 = props2.wrapElement(element2);
      }
      return callback(element2);
    },
    [...deps, props2.wrapElement]
  );
  return { ...props2, wrapElement };
}
function usePortalRef(portalProp = false, portalRefProp) {
  const [portalNode, setPortalNode] = useState(null);
  const portalRef = useMergeRefs(setPortalNode, portalRefProp);
  const domReady = !portalProp || portalNode;
  return { portalRef, portalNode, domReady };
}
function useMetadataProps(props2, key, value) {
  const parent = props2.onLoadedMetadataCapture;
  const onLoadedMetadataCapture = useMemo(() => {
    return Object.assign(() => {
    }, { ...parent, [key]: value });
  }, [parent, key, value]);
  return [parent == null ? void 0 : parent[key], { onLoadedMetadataCapture }];
}
var hasInstalledGlobalEventListeners$1 = false;
function useIsMouseMoving() {
  useEffect(() => {
    if (hasInstalledGlobalEventListeners$1) return;
    addGlobalEventListener("mousemove", setMouseMoving, true);
    addGlobalEventListener("mousedown", resetMouseMoving, true);
    addGlobalEventListener("mouseup", resetMouseMoving, true);
    addGlobalEventListener("keydown", resetMouseMoving, true);
    addGlobalEventListener("scroll", resetMouseMoving, true);
    hasInstalledGlobalEventListeners$1 = true;
  }, []);
  const isMouseMoving = useEvent(() => mouseMoving);
  return isMouseMoving;
}
var mouseMoving = false;
var previousScreenX = 0;
var previousScreenY = 0;
function hasMouseMovement(event) {
  const movementX = event.movementX || event.screenX - previousScreenX;
  const movementY = event.movementY || event.screenY - previousScreenY;
  previousScreenX = event.screenX;
  previousScreenY = event.screenY;
  return movementX || movementY || process.env.NODE_ENV === "test";
}
function setMouseMoving(event) {
  if (!hasMouseMovement(event)) return;
  mouseMoving = true;
}
function resetMouseMoving() {
  mouseMoving = false;
}
function forwardRef2(render) {
  const Role3 = React.forwardRef((props2, ref) => render({ ...props2, ref }));
  Role3.displayName = render.displayName || render.name;
  return Role3;
}
function memo2(Component, propsAreEqual) {
  return React.memo(Component, propsAreEqual);
}
function createElement(Type, props2) {
  const { wrapElement, render, ...rest2 } = props2;
  const mergedRef = useMergeRefs(props2.ref, getRefProperty(render));
  let element2;
  if (React.isValidElement(render)) {
    const renderProps = { ...render.props, ref: mergedRef };
    element2 = React.cloneElement(render, mergeProps(rest2, renderProps));
  } else if (render) {
    element2 = render(rest2);
  } else {
    element2 = /* @__PURE__ */ jsxRuntimeExports$3.jsx(Type, { ...rest2 });
  }
  if (wrapElement) {
    return wrapElement(element2);
  }
  return element2;
}
function createHook(useProps) {
  const useRole = (props2 = {}) => {
    return useProps(props2);
  };
  useRole.displayName = useProps.name;
  return useRole;
}
function createStoreContext(providers = [], scopedProviders = []) {
  const context = React.createContext(void 0);
  const scopedContext = React.createContext(void 0);
  const useContext2 = () => React.useContext(context);
  const useScopedContext = (onlyScoped = false) => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (onlyScoped) return scoped;
    return scoped || store2;
  };
  const useProviderContext = () => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (scoped && scoped === store2) return;
    return store2;
  };
  const ContextProvider = (props2) => {
    return providers.reduceRight(
      (children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(Provider2, { ...props2, children }),
      /* @__PURE__ */ jsxRuntimeExports$3.jsx(context.Provider, { ...props2 })
    );
  };
  const ScopedContextProvider = (props2) => {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx(ContextProvider, { ...props2, children: scopedProviders.reduceRight(
      (children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(Provider2, { ...props2, children }),
      /* @__PURE__ */ jsxRuntimeExports$3.jsx(scopedContext.Provider, { ...props2 })
    ) });
  };
  return {
    context,
    scopedContext,
    useContext: useContext2,
    useScopedContext,
    useProviderContext,
    ContextProvider,
    ScopedContextProvider
  };
}
var ctx$8 = createStoreContext();
var useCollectionContext = ctx$8.useContext;
var CollectionContextProvider = ctx$8.ContextProvider;
var CollectionScopedContextProvider = ctx$8.ScopedContextProvider;
var ctx$7 = createStoreContext(
  [CollectionContextProvider],
  [CollectionScopedContextProvider]
);
var useCompositeContext = ctx$7.useContext;
var useCompositeProviderContext = ctx$7.useProviderContext;
var CompositeContextProvider = ctx$7.ContextProvider;
var CompositeScopedContextProvider = ctx$7.ScopedContextProvider;
var CompositeItemContext = createContext(
  void 0
);
var CompositeRowContext = createContext(
  void 0
);
var ctx$6 = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useTabScopedContext = ctx$6.useScopedContext;
var useTabProviderContext = ctx$6.useProviderContext;
var TabContextProvider = ctx$6.ContextProvider;
var TabScopedContextProvider = ctx$6.ScopedContextProvider;
var NULL_ITEM$1 = { id: null };
function flipItems$1(items, activeId, shouldInsertNullItem = false) {
  const index2 = items.findIndex((item) => item.id === activeId);
  return [
    ...items.slice(index2 + 1),
    ...shouldInsertNullItem ? [NULL_ITEM$1] : [],
    ...items.slice(0, index2)
  ];
}
function findFirstEnabledItem$1(items, excludeId) {
  return items.find((item) => {
    return !item.disabled;
  });
}
function getEnabledItem(store2, id2) {
  if (!id2) return null;
  return store2.item(id2) || null;
}
function groupItemsByRows$1(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => {
      var _a2;
      return ((_a2 = currentRow[0]) == null ? void 0 : _a2.rowId) === item.rowId;
    });
    if (row) {
      row.push(item);
    } else {
      rows.push([item]);
    }
  }
  return rows;
}
function selectTextField(element2, collapseToEnd = false) {
  if (isTextField(element2)) {
    element2.setSelectionRange(
      collapseToEnd ? element2.value.length : 0,
      element2.value.length
    );
  } else if (element2.isContentEditable) {
    const selection2 = getDocument(element2).getSelection();
    selection2 == null ? void 0 : selection2.selectAllChildren(element2);
    if (collapseToEnd) {
      selection2 == null ? void 0 : selection2.collapseToEnd();
    }
  }
}
var FOCUS_SILENTLY = Symbol("FOCUS_SILENTLY");
function focusSilently(element2) {
  element2[FOCUS_SILENTLY] = true;
  element2.focus({ preventScroll: true });
}
function silentlyFocused(element2) {
  const isSilentlyFocused = element2[FOCUS_SILENTLY];
  delete element2[FOCUS_SILENTLY];
  return isSilentlyFocused;
}
function isItem(store2, element2, exclude) {
  if (!element2) return false;
  if (element2 === exclude) return false;
  const item = store2.item(element2.id);
  if (!item) return false;
  return true;
}
var TagName$v = "div";
var useCollectionItem = createHook(
  function useCollectionItem23({
    store: store2,
    shouldRegisterItem = true,
    getItem = identity,
    // @ts-expect-error This prop may come from a collection renderer.
    element: element2,
    ...props2
  }) {
    const context = useCollectionContext();
    store2 = store2 || context;
    const id2 = useId(props2.id);
    const ref = useRef(element2);
    useEffect(() => {
      const element22 = ref.current;
      if (!id2) return;
      if (!element22) return;
      if (!shouldRegisterItem) return;
      const item = getItem({ id: id2, element: element22 });
      return store2 == null ? void 0 : store2.renderItem(item);
    }, [id2, shouldRegisterItem, getItem, store2]);
    props2 = {
      ...props2,
      ref: useMergeRefs(ref, props2.ref)
    };
    return removeUndefinedValues(props2);
  }
);
forwardRef2(function CollectionItem23(props2) {
  const htmlProps = useCollectionItem(props2);
  return createElement(TagName$v, htmlProps);
});
var FocusableContext = createContext(true);
var selector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function hasNegativeTabIndex(element2) {
  const tabIndex = Number.parseInt(element2.getAttribute("tabindex") || "0", 10);
  return tabIndex < 0;
}
function isFocusable(element2) {
  if (!element2.matches(selector)) return false;
  if (!isVisible(element2)) return false;
  if (element2.closest("[inert]")) return false;
  return true;
}
function isTabbable(element2) {
  if (!isFocusable(element2)) return false;
  if (hasNegativeTabIndex(element2)) return false;
  if (!("form" in element2)) return true;
  if (!element2.form) return true;
  if (element2.checked) return true;
  if (element2.type !== "radio") return true;
  const radioGroup = element2.form.elements.namedItem(element2.name);
  if (!radioGroup) return true;
  if (!("length" in radioGroup)) return true;
  const activeElement = getActiveElement(element2);
  if (!activeElement) return true;
  if (activeElement === element2) return true;
  if (!("form" in activeElement)) return true;
  if (activeElement.form !== element2.form) return true;
  if (activeElement.name !== element2.name) return true;
  return false;
}
function getAllFocusableIn(container, includeContainer) {
  const elements2 = Array.from(
    container.querySelectorAll(selector)
  );
  if (includeContainer) {
    elements2.unshift(container);
  }
  const focusableElements = elements2.filter(isFocusable);
  focusableElements.forEach((element2, i2) => {
    if (isFrame(element2) && element2.contentDocument) {
      const frameBody = element2.contentDocument.body;
      focusableElements.splice(i2, 1, ...getAllFocusableIn(frameBody));
    }
  });
  return focusableElements;
}
function getAllTabbableIn(container, includeContainer, fallbackToFocusable) {
  const elements2 = Array.from(
    container.querySelectorAll(selector)
  );
  const tabbableElements = elements2.filter(isTabbable);
  if (includeContainer && isTabbable(container)) {
    tabbableElements.unshift(container);
  }
  tabbableElements.forEach((element2, i2) => {
    if (isFrame(element2) && element2.contentDocument) {
      const frameBody = element2.contentDocument.body;
      const allFrameTabbable = getAllTabbableIn(
        frameBody,
        false,
        fallbackToFocusable
      );
      tabbableElements.splice(i2, 1, ...allFrameTabbable);
    }
  });
  if (!tabbableElements.length && fallbackToFocusable) {
    return elements2;
  }
  return tabbableElements;
}
function getFirstTabbableIn(container, includeContainer, fallbackToFocusable) {
  const [first2] = getAllTabbableIn(
    container,
    includeContainer,
    fallbackToFocusable
  );
  return first2 || null;
}
function getNextTabbableIn(container, includeContainer, fallbackToFirst, fallbackToFocusable) {
  const activeElement = getActiveElement(container);
  const allFocusable = getAllFocusableIn(container, includeContainer);
  const activeIndex = allFocusable.indexOf(activeElement);
  const nextFocusableElements = allFocusable.slice(activeIndex + 1);
  return nextFocusableElements.find(isTabbable) || (fallbackToFirst ? allFocusable.find(isTabbable) : null) || (fallbackToFocusable ? nextFocusableElements[0] : null) || null;
}
function getNextTabbable(fallbackToFirst, fallbackToFocusable) {
  return getNextTabbableIn(
    document.body,
    false,
    fallbackToFirst,
    fallbackToFocusable
  );
}
function getPreviousTabbableIn(container, includeContainer, fallbackToLast, fallbackToFocusable) {
  const activeElement = getActiveElement(container);
  const allFocusable = getAllFocusableIn(container, includeContainer).reverse();
  const activeIndex = allFocusable.indexOf(activeElement);
  const previousFocusableElements = allFocusable.slice(activeIndex + 1);
  return previousFocusableElements.find(isTabbable) || null || null || null;
}
function getPreviousTabbable(fallbackToFirst, fallbackToFocusable) {
  return getPreviousTabbableIn(
    document.body,
    false
  );
}
function getClosestFocusable(element2) {
  while (element2 && !isFocusable(element2)) {
    element2 = element2.closest(selector);
  }
  return element2 || null;
}
function hasFocus(element2) {
  const activeElement = getActiveElement(element2);
  if (!activeElement) return false;
  if (activeElement === element2) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  return activeDescendant === element2.id;
}
function hasFocusWithin(element2) {
  const activeElement = getActiveElement(element2);
  if (!activeElement) return false;
  if (contains$1(element2, activeElement)) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  if (!("id" in element2)) return false;
  if (activeDescendant === element2.id) return true;
  return !!element2.querySelector(`#${CSS.escape(activeDescendant)}`);
}
function focusIfNeeded(element2) {
  if (!hasFocusWithin(element2) && isFocusable(element2)) {
    element2.focus();
  }
}
function disableFocus(element2) {
  var _a2;
  const currentTabindex = (_a2 = element2.getAttribute("tabindex")) != null ? _a2 : "";
  element2.setAttribute("data-tabindex", currentTabindex);
  element2.setAttribute("tabindex", "-1");
}
function disableFocusIn(container, includeContainer) {
  const tabbableElements = getAllTabbableIn(container, includeContainer);
  for (const element2 of tabbableElements) {
    disableFocus(element2);
  }
}
function restoreFocusIn(container) {
  const elements2 = container.querySelectorAll("[data-tabindex]");
  const restoreTabIndex = (element2) => {
    const tabindex = element2.getAttribute("data-tabindex");
    element2.removeAttribute("data-tabindex");
    if (tabindex) {
      element2.setAttribute("tabindex", tabindex);
    } else {
      element2.removeAttribute("tabindex");
    }
  };
  if (container.hasAttribute("data-tabindex")) {
    restoreTabIndex(container);
  }
  for (const element2 of elements2) {
    restoreTabIndex(element2);
  }
}
function focusIntoView(element2, options2) {
  if (!("scrollIntoView" in element2)) {
    element2.focus();
  } else {
    element2.focus({ preventScroll: true });
    element2.scrollIntoView({ block: "nearest", inline: "nearest", ...options2 });
  }
}
var TagName$u = "div";
var isSafariBrowser$1 = isSafari();
var alwaysFocusVisibleInputTypes = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
var safariFocusAncestorSymbol = Symbol("safariFocusAncestor");
function isSafariFocusAncestor(element2) {
  if (!element2) return false;
  return !!element2[safariFocusAncestorSymbol];
}
function markSafariFocusAncestor(element2, value) {
  if (!element2) return;
  element2[safariFocusAncestorSymbol] = value;
}
function isAlwaysFocusVisible(element2) {
  const { tagName, readOnly: readOnly2, type } = element2;
  if (tagName === "TEXTAREA" && !readOnly2) return true;
  if (tagName === "SELECT" && !readOnly2) return true;
  if (tagName === "INPUT" && !readOnly2) {
    return alwaysFocusVisibleInputTypes.includes(type);
  }
  if (element2.isContentEditable) return true;
  const role = element2.getAttribute("role");
  if (role === "combobox" && element2.dataset.name) {
    return true;
  }
  return false;
}
function getLabels(element2) {
  if ("labels" in element2) {
    return element2.labels;
  }
  return null;
}
function isNativeCheckboxOrRadio(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "input" && element2.type) {
    return element2.type === "radio" || element2.type === "checkbox";
  }
  return false;
}
function isNativeTabbable(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "summary" || tagName === "input" || tagName === "select" || tagName === "textarea" || tagName === "a";
}
function supportsDisabledAttribute(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea";
}
function getTabIndex(focusable, trulyDisabled, nativeTabbable, supportsDisabled, tabIndexProp) {
  if (!focusable) {
    return tabIndexProp;
  }
  if (trulyDisabled) {
    if (nativeTabbable && !supportsDisabled) {
      return -1;
    }
    return;
  }
  if (nativeTabbable) {
    return tabIndexProp;
  }
  return tabIndexProp || 0;
}
function useDisableEvent(onEvent, disabled) {
  return useEvent((event) => {
    onEvent == null ? void 0 : onEvent(event);
    if (event.defaultPrevented) return;
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  });
}
var hasInstalledGlobalEventListeners = false;
var isKeyboardModality = true;
function onGlobalMouseDown(event) {
  const target = event.target;
  if (target && "hasAttribute" in target) {
    if (!target.hasAttribute("data-focus-visible")) {
      isKeyboardModality = false;
    }
  }
}
function onGlobalKeyDown(event) {
  if (event.metaKey) return;
  if (event.ctrlKey) return;
  if (event.altKey) return;
  isKeyboardModality = true;
}
var useFocusable = createHook(
  function useFocusable23({
    focusable = true,
    accessibleWhenDisabled,
    autoFocus,
    onFocusVisible,
    ...props2
  }) {
    const ref = useRef(null);
    useEffect(() => {
      if (!focusable) return;
      if (hasInstalledGlobalEventListeners) return;
      addGlobalEventListener("mousedown", onGlobalMouseDown, true);
      addGlobalEventListener("keydown", onGlobalKeyDown, true);
      hasInstalledGlobalEventListeners = true;
    }, [focusable]);
    if (isSafariBrowser$1) {
      useEffect(() => {
        if (!focusable) return;
        const element2 = ref.current;
        if (!element2) return;
        if (!isNativeCheckboxOrRadio(element2)) return;
        const labels = getLabels(element2);
        if (!labels) return;
        const onMouseUp = () => queueMicrotask(() => element2.focus());
        for (const label2 of labels) {
          label2.addEventListener("mouseup", onMouseUp);
        }
        return () => {
          for (const label2 of labels) {
            label2.removeEventListener("mouseup", onMouseUp);
          }
        };
      }, [focusable]);
    }
    const disabled = focusable && disabledFromProps(props2);
    const trulyDisabled = !!disabled && !accessibleWhenDisabled;
    const [focusVisible, setFocusVisible] = useState(false);
    useEffect(() => {
      if (!focusable) return;
      if (trulyDisabled && focusVisible) {
        setFocusVisible(false);
      }
    }, [focusable, trulyDisabled, focusVisible]);
    useEffect(() => {
      if (!focusable) return;
      if (!focusVisible) return;
      const element2 = ref.current;
      if (!element2) return;
      if (typeof IntersectionObserver === "undefined") return;
      const observer = new IntersectionObserver(() => {
        if (!isFocusable(element2)) {
          setFocusVisible(false);
        }
      });
      observer.observe(element2);
      return () => observer.disconnect();
    }, [focusable, focusVisible]);
    const onKeyPressCapture = useDisableEvent(
      props2.onKeyPressCapture,
      disabled
    );
    const onMouseDownCapture = useDisableEvent(
      props2.onMouseDownCapture,
      disabled
    );
    const onClickCapture = useDisableEvent(props2.onClickCapture, disabled);
    const onMouseDownProp = props2.onMouseDown;
    const onMouseDown = useEvent((event) => {
      onMouseDownProp == null ? void 0 : onMouseDownProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      const element2 = event.currentTarget;
      if (!isSafariBrowser$1) return;
      if (isPortalEvent(event)) return;
      if (!isButton(element2) && !isNativeCheckboxOrRadio(element2)) return;
      let receivedFocus = false;
      const onFocus = () => {
        receivedFocus = true;
      };
      const options2 = { capture: true, once: true };
      element2.addEventListener("focusin", onFocus, options2);
      const focusableContainer = getClosestFocusable(element2.parentElement);
      markSafariFocusAncestor(focusableContainer, true);
      queueBeforeEvent(element2, "mouseup", () => {
        element2.removeEventListener("focusin", onFocus, true);
        markSafariFocusAncestor(focusableContainer, false);
        if (receivedFocus) return;
        focusIfNeeded(element2);
      });
    });
    const handleFocusVisible = (event, currentTarget) => {
      if (currentTarget) {
        event.currentTarget = currentTarget;
      }
      if (!focusable) return;
      const element2 = event.currentTarget;
      if (!element2) return;
      if (!hasFocus(element2)) return;
      onFocusVisible == null ? void 0 : onFocusVisible(event);
      if (event.defaultPrevented) return;
      element2.dataset.focusVisible = "true";
      setFocusVisible(true);
    };
    const onKeyDownCaptureProp = props2.onKeyDownCapture;
    const onKeyDownCapture = useEvent((event) => {
      onKeyDownCaptureProp == null ? void 0 : onKeyDownCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      if (focusVisible) return;
      if (event.metaKey) return;
      if (event.altKey) return;
      if (event.ctrlKey) return;
      if (!isSelfTarget(event)) return;
      const element2 = event.currentTarget;
      const applyFocusVisible = () => handleFocusVisible(event, element2);
      queueBeforeEvent(element2, "focusout", applyFocusVisible);
    });
    const onFocusCaptureProp = props2.onFocusCapture;
    const onFocusCapture = useEvent((event) => {
      onFocusCaptureProp == null ? void 0 : onFocusCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!focusable) return;
      if (!isSelfTarget(event)) {
        setFocusVisible(false);
        return;
      }
      const element2 = event.currentTarget;
      const applyFocusVisible = () => handleFocusVisible(event, element2);
      if (isKeyboardModality || isAlwaysFocusVisible(event.target)) {
        queueBeforeEvent(event.target, "focusout", applyFocusVisible);
      } else {
        setFocusVisible(false);
      }
    });
    const onBlurProp = props2.onBlur;
    const onBlur = useEvent((event) => {
      onBlurProp == null ? void 0 : onBlurProp(event);
      if (!focusable) return;
      if (!isFocusEventOutside(event)) return;
      event.currentTarget.removeAttribute("data-focus-visible");
      setFocusVisible(false);
    });
    const autoFocusOnShow = useContext(FocusableContext);
    const autoFocusRef = useEvent((element2) => {
      if (!focusable) return;
      if (!autoFocus) return;
      if (!element2) return;
      if (!autoFocusOnShow) return;
      queueMicrotask(() => {
        if (hasFocus(element2)) return;
        if (!isFocusable(element2)) return;
        element2.focus();
      });
    });
    const tagName = useTagName(ref);
    const nativeTabbable = focusable && isNativeTabbable(tagName);
    const supportsDisabled = focusable && supportsDisabledAttribute(tagName);
    const styleProp = props2.style;
    const style = useMemo(() => {
      if (trulyDisabled) {
        return { pointerEvents: "none", ...styleProp };
      }
      return styleProp;
    }, [trulyDisabled, styleProp]);
    props2 = {
      "data-focus-visible": focusable && focusVisible || void 0,
      "data-autofocus": autoFocus || void 0,
      "aria-disabled": disabled || void 0,
      ...props2,
      ref: useMergeRefs(ref, autoFocusRef, props2.ref),
      style,
      tabIndex: getTabIndex(
        focusable,
        trulyDisabled,
        nativeTabbable,
        supportsDisabled,
        props2.tabIndex
      ),
      disabled: supportsDisabled && trulyDisabled ? true : void 0,
      // TODO: Test Focusable contentEditable.
      contentEditable: disabled ? void 0 : props2.contentEditable,
      onKeyPressCapture,
      onClickCapture,
      onMouseDownCapture,
      onMouseDown,
      onKeyDownCapture,
      onFocusCapture,
      onBlur
    };
    return removeUndefinedValues(props2);
  }
);
forwardRef2(function Focusable23(props2) {
  const htmlProps = useFocusable(props2);
  return createElement(TagName$u, htmlProps);
});
var TagName$t = "button";
function isNativeClick(event) {
  if (!event.isTrusted) return false;
  const element2 = event.currentTarget;
  if (event.key === "Enter") {
    return isButton(element2) || element2.tagName === "SUMMARY" || element2.tagName === "A";
  }
  if (event.key === " ") {
    return isButton(element2) || element2.tagName === "SUMMARY" || element2.tagName === "INPUT" || element2.tagName === "SELECT";
  }
  return false;
}
var symbol$2 = Symbol("command");
var useCommand = createHook(
  function useCommand23({ clickOnEnter = true, clickOnSpace = true, ...props2 }) {
    const ref = useRef(null);
    const [isNativeButton, setIsNativeButton] = useState(false);
    useEffect(() => {
      if (!ref.current) return;
      setIsNativeButton(isButton(ref.current));
    }, []);
    const [active, setActive] = useState(false);
    const activeRef = useRef(false);
    const disabled = disabledFromProps(props2);
    const [isDuplicate, metadataProps] = useMetadataProps(props2, symbol$2, true);
    const onKeyDownProp = props2.onKeyDown;
    const onKeyDown = useEvent((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      const element2 = event.currentTarget;
      if (event.defaultPrevented) return;
      if (isDuplicate) return;
      if (disabled) return;
      if (!isSelfTarget(event)) return;
      if (isTextField(element2)) return;
      if (element2.isContentEditable) return;
      const isEnter = clickOnEnter && event.key === "Enter";
      const isSpace2 = clickOnSpace && event.key === " ";
      const shouldPreventEnter = event.key === "Enter" && !clickOnEnter;
      const shouldPreventSpace = event.key === " " && !clickOnSpace;
      if (shouldPreventEnter || shouldPreventSpace) {
        event.preventDefault();
        return;
      }
      if (isEnter || isSpace2) {
        const nativeClick = isNativeClick(event);
        if (isEnter) {
          if (!nativeClick) {
            event.preventDefault();
            const { view, ...eventInit } = event;
            const click = () => fireClickEvent(element2, eventInit);
            if (isFirefox()) {
              queueBeforeEvent(element2, "keyup", click);
            } else {
              queueMicrotask(click);
            }
          }
        } else if (isSpace2) {
          activeRef.current = true;
          if (!nativeClick) {
            event.preventDefault();
            setActive(true);
          }
        }
      }
    });
    const onKeyUpProp = props2.onKeyUp;
    const onKeyUp = useEvent((event) => {
      onKeyUpProp == null ? void 0 : onKeyUpProp(event);
      if (event.defaultPrevented) return;
      if (isDuplicate) return;
      if (disabled) return;
      if (event.metaKey) return;
      const isSpace2 = clickOnSpace && event.key === " ";
      if (activeRef.current && isSpace2) {
        activeRef.current = false;
        if (!isNativeClick(event)) {
          event.preventDefault();
          setActive(false);
          const element2 = event.currentTarget;
          const { view, ...eventInit } = event;
          queueMicrotask(() => fireClickEvent(element2, eventInit));
        }
      }
    });
    props2 = {
      "data-active": active || void 0,
      type: isNativeButton ? "button" : void 0,
      ...metadataProps,
      ...props2,
      ref: useMergeRefs(ref, props2.ref),
      onKeyDown,
      onKeyUp
    };
    props2 = useFocusable(props2);
    return props2;
  }
);
forwardRef2(function Command23(props2) {
  const htmlProps = useCommand(props2);
  return createElement(TagName$t, htmlProps);
});
function getInternal(store2, key) {
  const internals = store2.__unstableInternals;
  invariant(internals, "Invalid store");
  return internals[key];
}
function createStore(initialState2, ...stores) {
  let state = initialState2;
  let prevStateBatch = state;
  let lastUpdate = Symbol();
  let destroy = noop$1;
  const instances = /* @__PURE__ */ new Set();
  const updatedKeys = /* @__PURE__ */ new Set();
  const setups = /* @__PURE__ */ new Set();
  const listeners = /* @__PURE__ */ new Set();
  const batchListeners = /* @__PURE__ */ new Set();
  const disposables = /* @__PURE__ */ new WeakMap();
  const listenerKeys = /* @__PURE__ */ new WeakMap();
  const storeSetup = (callback) => {
    setups.add(callback);
    return () => setups.delete(callback);
  };
  const storeInit = () => {
    const initialized = instances.size;
    const instance = Symbol();
    instances.add(instance);
    const maybeDestroy = () => {
      instances.delete(instance);
      if (instances.size) return;
      destroy();
    };
    if (initialized) return maybeDestroy;
    const desyncs = getKeys(state).map(
      (key) => chain(
        ...stores.map((store2) => {
          var _a2;
          const storeState = (_a2 = store2 == null ? void 0 : store2.getState) == null ? void 0 : _a2.call(store2);
          if (!storeState) return;
          if (!hasOwnProperty$2(storeState, key)) return;
          return sync(store2, [key], (state2) => {
            setState(
              key,
              state2[key],
              // @ts-expect-error - Not public API. This is just to prevent
              // infinite loops.
              true
            );
          });
        })
      )
    );
    const teardowns = [];
    for (const setup2 of setups) {
      teardowns.push(setup2());
    }
    const cleanups2 = stores.map(init);
    destroy = chain(...desyncs, ...teardowns, ...cleanups2);
    return maybeDestroy;
  };
  const sub2 = (keys2, listener, set2 = listeners) => {
    set2.add(listener);
    listenerKeys.set(listener, keys2);
    return () => {
      var _a2;
      (_a2 = disposables.get(listener)) == null ? void 0 : _a2();
      disposables.delete(listener);
      listenerKeys.delete(listener);
      set2.delete(listener);
    };
  };
  const storeSubscribe = (keys2, listener) => sub2(keys2, listener);
  const storeSync = (keys2, listener) => {
    disposables.set(listener, listener(state, state));
    return sub2(keys2, listener);
  };
  const storeBatch = (keys2, listener) => {
    disposables.set(listener, listener(state, prevStateBatch));
    return sub2(keys2, listener, batchListeners);
  };
  const storePick = (keys2) => createStore(pick(state, keys2), finalStore);
  const storeOmit = (keys2) => createStore(omit(state, keys2), finalStore);
  const getState = () => state;
  const setState = (key, value, fromStores = false) => {
    var _a2;
    if (!hasOwnProperty$2(state, key)) return;
    const nextValue = applyState(value, state[key]);
    if (nextValue === state[key]) return;
    if (!fromStores) {
      for (const store2 of stores) {
        (_a2 = store2 == null ? void 0 : store2.setState) == null ? void 0 : _a2.call(store2, key, nextValue);
      }
    }
    const prevState = state;
    state = { ...state, [key]: nextValue };
    const thisUpdate = Symbol();
    lastUpdate = thisUpdate;
    updatedKeys.add(key);
    const run = (listener, prev, uKeys) => {
      var _a22;
      const keys2 = listenerKeys.get(listener);
      const updated = (k2) => uKeys ? uKeys.has(k2) : k2 === key;
      if (!keys2 || keys2.some(updated)) {
        (_a22 = disposables.get(listener)) == null ? void 0 : _a22();
        disposables.set(listener, listener(state, prev));
      }
    };
    for (const listener of listeners) {
      run(listener, prevState);
    }
    queueMicrotask(() => {
      if (lastUpdate !== thisUpdate) return;
      const snapshot = state;
      for (const listener of batchListeners) {
        run(listener, prevStateBatch, updatedKeys);
      }
      prevStateBatch = snapshot;
      updatedKeys.clear();
    });
  };
  const finalStore = {
    getState,
    setState,
    __unstableInternals: {
      setup: storeSetup,
      init: storeInit,
      subscribe: storeSubscribe,
      sync: storeSync,
      batch: storeBatch,
      pick: storePick,
      omit: storeOmit
    }
  };
  return finalStore;
}
function setup(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "setup")(...args);
}
function init(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "init")(...args);
}
function subscribe(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "subscribe")(...args);
}
function sync(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "sync")(...args);
}
function batch(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "batch")(...args);
}
function omit2(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "omit")(...args);
}
function pick2(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "pick")(...args);
}
function mergeStore(...stores) {
  var _a2;
  const initialState2 = {};
  for (const store22 of stores) {
    const nextState = (_a2 = store22 == null ? void 0 : store22.getState) == null ? void 0 : _a2.call(store22);
    if (nextState) {
      Object.assign(initialState2, nextState);
    }
  }
  const store2 = createStore(initialState2, ...stores);
  return Object.assign({}, ...stores, store2);
}
function throwOnConflictingProps(props2, store2) {
  if (process.env.NODE_ENV === "production") return;
  if (!store2) return;
  const defaultKeys = Object.entries(props2).filter(([key, value]) => key.startsWith("default") && value !== void 0).map(([key]) => {
    var _a2;
    const stateKey = key.replace("default", "");
    return `${((_a2 = stateKey[0]) == null ? void 0 : _a2.toLowerCase()) || ""}${stateKey.slice(1)}`;
  });
  if (!defaultKeys.length) return;
  const storeState = store2.getState();
  const conflictingProps = defaultKeys.filter(
    (key) => hasOwnProperty$2(storeState, key)
  );
  if (!conflictingProps.length) return;
  throw new Error(
    `Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`
  );
}
var shim = { exports: {} };
var useSyncExternalStoreShim_production = {};
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var React2 = React__default;
  function is2(x2, y) {
    return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue;
  function useSyncExternalStore$22(subscribe2, getSnapshot) {
    var value = getSnapshot(), _useState = useState2({ inst: { value, getSnapshot } }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect2(
      function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
      },
      [subscribe2, value, getSnapshot]
    );
    useEffect2(
      function() {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        return subscribe2(function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        });
      },
      [subscribe2]
    );
    useDebugValue(value);
    return value;
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function useSyncExternalStore$12(subscribe2, getSnapshot) {
    return getSnapshot();
  }
  var shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$12 : useSyncExternalStore$22;
  useSyncExternalStoreShim_production.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
  return useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {};
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function is2(x2, y) {
      return x2 === y && (0 !== x2 || 1 / x2 === 1 / y) || x2 !== x2 && y !== y;
    }
    function useSyncExternalStore$22(subscribe2, getSnapshot) {
      didWarnOld18Alpha || void 0 === React2.startTransition || (didWarnOld18Alpha = true, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var value = getSnapshot();
      if (!didWarnUncachedGetSnapshot) {
        var cachedValue = getSnapshot();
        objectIs(value, cachedValue) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      cachedValue = useState2({
        inst: { value, getSnapshot }
      });
      var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
      useLayoutEffect2(
        function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        },
        [subscribe2, value, getSnapshot]
      );
      useEffect2(
        function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          return subscribe2(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          });
        },
        [subscribe2]
      );
      useDebugValue(value);
      return value;
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error) {
        return true;
      }
    }
    function useSyncExternalStore$12(subscribe2, getSnapshot) {
      return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue, didWarnOld18Alpha = false, didWarnUncachedGetSnapshot = false, shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$12 : useSyncExternalStore$22;
    useSyncExternalStoreShim_development.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim.exports;
  hasRequiredShim = 1;
  if (process.env.NODE_ENV === "production") {
    shim.exports = requireUseSyncExternalStoreShim_production();
  } else {
    shim.exports = requireUseSyncExternalStoreShim_development();
  }
  return shim.exports;
}
var shimExports = requireShim();
const useSyncExternalStoreExports = /* @__PURE__ */ getDefaultExportFromCjs$6(shimExports);
var { useSyncExternalStore } = useSyncExternalStoreExports;
var noopSubscribe = () => () => {
};
function useStoreState(store2, keyOrSelector = identity) {
  const storeSubscribe = React.useCallback(
    (callback) => {
      if (!store2) return noopSubscribe();
      return subscribe(store2, null, callback);
    },
    [store2]
  );
  const getSnapshot = () => {
    const key = typeof keyOrSelector === "string" ? keyOrSelector : null;
    const selector2 = typeof keyOrSelector === "function" ? keyOrSelector : null;
    const state = store2 == null ? void 0 : store2.getState();
    if (selector2) return selector2(state);
    if (!state) return;
    if (!key) return;
    if (!hasOwnProperty$2(state, key)) return;
    return state[key];
  };
  return useSyncExternalStore(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreStateObject(store2, object2) {
  const objRef = React.useRef(
    {}
  );
  const storeSubscribe = React.useCallback(
    (callback) => {
      if (!store2) return noopSubscribe();
      return subscribe(store2, null, callback);
    },
    [store2]
  );
  const getSnapshot = () => {
    const state = store2 == null ? void 0 : store2.getState();
    let updated = false;
    const obj = objRef.current;
    for (const prop in object2) {
      const keyOrSelector = object2[prop];
      if (typeof keyOrSelector === "function") {
        const value = keyOrSelector(state);
        if (value !== obj[prop]) {
          obj[prop] = value;
          updated = true;
        }
      }
      if (typeof keyOrSelector === "string") {
        if (!state) continue;
        if (!hasOwnProperty$2(state, keyOrSelector)) continue;
        const value = state[keyOrSelector];
        if (value !== obj[prop]) {
          obj[prop] = value;
          updated = true;
        }
      }
    }
    if (updated) {
      objRef.current = { ...obj };
    }
    return objRef.current;
  };
  return useSyncExternalStore(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreProps(store2, props2, key, setKey) {
  const value = hasOwnProperty$2(props2, key) ? props2[key] : void 0;
  const setValue = setKey ? props2[setKey] : void 0;
  const propsRef = useLiveRef({ value, setValue });
  useSafeLayoutEffect(() => {
    return sync(store2, [key], (state, prev) => {
      const { value: value2, setValue: setValue2 } = propsRef.current;
      if (!setValue2) return;
      if (state[key] === prev[key]) return;
      if (state[key] === value2) return;
      setValue2(state[key]);
    });
  }, [store2, key]);
  useSafeLayoutEffect(() => {
    if (value === void 0) return;
    store2.setState(key, value);
    return batch(store2, [key], () => {
      if (value === void 0) return;
      store2.setState(key, value);
    });
  });
}
function useStore(createStore2, props2) {
  const [store2, setStore] = React.useState(() => createStore2(props2));
  useSafeLayoutEffect(() => init(store2), [store2]);
  const useState2 = React.useCallback(
    (keyOrSelector) => useStoreState(store2, keyOrSelector),
    [store2]
  );
  const memoizedStore = React.useMemo(
    () => ({ ...store2, useState: useState2 }),
    [store2, useState2]
  );
  const updateStore = useEvent(() => {
    setStore((store22) => createStore2({ ...props2, ...store22.getState() }));
  });
  return [memoizedStore, updateStore];
}
var TagName$s = "button";
function isEditableElement(element2) {
  if (isTextbox(element2)) return true;
  return element2.tagName === "INPUT" && !isButton(element2);
}
function getNextPageOffset(scrollingElement, pageUp = false) {
  const height = scrollingElement.clientHeight;
  const { top: top2 } = scrollingElement.getBoundingClientRect();
  const pageSize = Math.max(height * 0.875, height - 40) * 1.5;
  const pageOffset = pageUp ? height - pageSize + top2 : pageSize + top2;
  if (scrollingElement.tagName === "HTML") {
    return pageOffset + scrollingElement.scrollTop;
  }
  return pageOffset;
}
function getItemOffset(itemElement, pageUp = false) {
  const { top: top2 } = itemElement.getBoundingClientRect();
  if (pageUp) {
    return top2 + itemElement.clientHeight;
  }
  return top2;
}
function findNextPageItemId(element2, store2, next, pageUp = false) {
  var _a2;
  if (!store2) return;
  if (!next) return;
  const { renderedItems } = store2.getState();
  const scrollingElement = getScrollingElement(element2);
  if (!scrollingElement) return;
  const nextPageOffset = getNextPageOffset(scrollingElement, pageUp);
  let id2;
  let prevDifference;
  for (let i2 = 0; i2 < renderedItems.length; i2 += 1) {
    const previousId = id2;
    id2 = next(i2);
    if (!id2) break;
    if (id2 === previousId) continue;
    const itemElement = (_a2 = getEnabledItem(store2, id2)) == null ? void 0 : _a2.element;
    if (!itemElement) continue;
    const itemOffset = getItemOffset(itemElement, pageUp);
    const difference2 = itemOffset - nextPageOffset;
    const absDifference = Math.abs(difference2);
    if (pageUp && difference2 <= 0 || !pageUp && difference2 >= 0) {
      if (prevDifference !== void 0 && prevDifference < absDifference) {
        id2 = previousId;
      }
      break;
    }
    prevDifference = absDifference;
  }
  return id2;
}
function targetIsAnotherItem(event, store2) {
  if (isSelfTarget(event)) return false;
  return isItem(store2, event.target);
}
var useCompositeItem = createHook(
  function useCompositeItem23({
    store: store2,
    rowId: rowIdProp,
    preventScrollOnKeyDown = false,
    moveOnKeyPress = true,
    tabbable = false,
    getItem: getItemProp,
    "aria-setsize": ariaSetSizeProp,
    "aria-posinset": ariaPosInSetProp,
    ...props2
  }) {
    const context = useCompositeContext();
    store2 = store2 || context;
    const id2 = useId(props2.id);
    const ref = useRef(null);
    const row = useContext(CompositeRowContext);
    const disabled = disabledFromProps(props2);
    const trulyDisabled = disabled && !props2.accessibleWhenDisabled;
    const {
      rowId,
      baseElement,
      isActiveItem,
      ariaSetSize,
      ariaPosInSet,
      isTabbable: isTabbable2
    } = useStoreStateObject(store2, {
      rowId(state) {
        if (rowIdProp) return rowIdProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.baseElement)) return;
        if (row.baseElement !== state.baseElement) return;
        return row.id;
      },
      baseElement(state) {
        return (state == null ? void 0 : state.baseElement) || void 0;
      },
      isActiveItem(state) {
        return !!state && state.activeId === id2;
      },
      ariaSetSize(state) {
        if (ariaSetSizeProp != null) return ariaSetSizeProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.ariaSetSize)) return;
        if (row.baseElement !== state.baseElement) return;
        return row.ariaSetSize;
      },
      ariaPosInSet(state) {
        if (ariaPosInSetProp != null) return ariaPosInSetProp;
        if (!state) return;
        if (!(row == null ? void 0 : row.ariaPosInSet)) return;
        if (row.baseElement !== state.baseElement) return;
        const itemsInRow = state.renderedItems.filter(
          (item) => item.rowId === rowId
        );
        return row.ariaPosInSet + itemsInRow.findIndex((item) => item.id === id2);
      },
      isTabbable(state) {
        if (!(state == null ? void 0 : state.renderedItems.length)) return true;
        if (state.virtualFocus) return false;
        if (tabbable) return true;
        if (state.activeId === null) return false;
        const item = store2 == null ? void 0 : store2.item(state.activeId);
        if (item == null ? void 0 : item.disabled) return true;
        if (!(item == null ? void 0 : item.element)) return true;
        return state.activeId === id2;
      }
    });
    const getItem = useCallback(
      (item) => {
        var _a2;
        const nextItem = {
          ...item,
          id: id2 || item.id,
          rowId,
          disabled: !!trulyDisabled,
          children: (_a2 = item.element) == null ? void 0 : _a2.textContent
        };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [id2, rowId, trulyDisabled, getItemProp]
    );
    const onFocusProp = props2.onFocus;
    const hasFocusedComposite = useRef(false);
    const onFocus = useEvent((event) => {
      onFocusProp == null ? void 0 : onFocusProp(event);
      if (event.defaultPrevented) return;
      if (isPortalEvent(event)) return;
      if (!id2) return;
      if (!store2) return;
      if (targetIsAnotherItem(event, store2)) return;
      const { virtualFocus, baseElement: baseElement2 } = store2.getState();
      store2.setActiveId(id2);
      if (isTextbox(event.currentTarget)) {
        selectTextField(event.currentTarget);
      }
      if (!virtualFocus) return;
      if (!isSelfTarget(event)) return;
      if (isEditableElement(event.currentTarget)) return;
      if (!(baseElement2 == null ? void 0 : baseElement2.isConnected)) return;
      if (isSafari() && event.currentTarget.hasAttribute("data-autofocus")) {
        event.currentTarget.scrollIntoView({
          block: "nearest",
          inline: "nearest"
        });
      }
      hasFocusedComposite.current = true;
      const fromComposite = event.relatedTarget === baseElement2 || isItem(store2, event.relatedTarget);
      if (fromComposite) {
        focusSilently(baseElement2);
      } else {
        baseElement2.focus();
      }
    });
    const onBlurCaptureProp = props2.onBlurCapture;
    const onBlurCapture = useEvent((event) => {
      onBlurCaptureProp == null ? void 0 : onBlurCaptureProp(event);
      if (event.defaultPrevented) return;
      const state = store2 == null ? void 0 : store2.getState();
      if ((state == null ? void 0 : state.virtualFocus) && hasFocusedComposite.current) {
        hasFocusedComposite.current = false;
        event.preventDefault();
        event.stopPropagation();
      }
    });
    const onKeyDownProp = props2.onKeyDown;
    const preventScrollOnKeyDownProp = useBooleanEvent(preventScrollOnKeyDown);
    const moveOnKeyPressProp = useBooleanEvent(moveOnKeyPress);
    const onKeyDown = useEvent((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.defaultPrevented) return;
      if (!isSelfTarget(event)) return;
      if (!store2) return;
      const { currentTarget } = event;
      const state = store2.getState();
      const item = store2.item(id2);
      const isGrid2 = !!(item == null ? void 0 : item.rowId);
      const isVertical = state.orientation !== "horizontal";
      const isHorizontal = state.orientation !== "vertical";
      const canHomeEnd = () => {
        if (isGrid2) return true;
        if (isHorizontal) return true;
        if (!state.baseElement) return true;
        if (!isTextField(state.baseElement)) return true;
        return false;
      };
      const keyMap = {
        ArrowUp: (isGrid2 || isVertical) && store2.up,
        ArrowRight: (isGrid2 || isHorizontal) && store2.next,
        ArrowDown: (isGrid2 || isVertical) && store2.down,
        ArrowLeft: (isGrid2 || isHorizontal) && store2.previous,
        Home: () => {
          if (!canHomeEnd()) return;
          if (!isGrid2 || event.ctrlKey) {
            return store2 == null ? void 0 : store2.first();
          }
          return store2 == null ? void 0 : store2.previous(-1);
        },
        End: () => {
          if (!canHomeEnd()) return;
          if (!isGrid2 || event.ctrlKey) {
            return store2 == null ? void 0 : store2.last();
          }
          return store2 == null ? void 0 : store2.next(-1);
        },
        PageUp: () => {
          return findNextPageItemId(currentTarget, store2, store2 == null ? void 0 : store2.up, true);
        },
        PageDown: () => {
          return findNextPageItemId(currentTarget, store2, store2 == null ? void 0 : store2.down);
        }
      };
      const action = keyMap[event.key];
      if (action) {
        if (isTextbox(currentTarget)) {
          const selection2 = getTextboxSelection(currentTarget);
          const isLeft = isHorizontal && event.key === "ArrowLeft";
          const isRight = isHorizontal && event.key === "ArrowRight";
          const isUp = isVertical && event.key === "ArrowUp";
          const isDown = isVertical && event.key === "ArrowDown";
          if (isRight || isDown) {
            const { length: valueLength } = getTextboxValue(currentTarget);
            if (selection2.end !== valueLength) return;
          } else if ((isLeft || isUp) && selection2.start !== 0) return;
        }
        const nextId = action();
        if (preventScrollOnKeyDownProp(event) || nextId !== void 0) {
          if (!moveOnKeyPressProp(event)) return;
          event.preventDefault();
          store2.move(nextId);
        }
      }
    });
    const providerValue = useMemo(
      () => ({ id: id2, baseElement }),
      [id2, baseElement]
    );
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(CompositeItemContext.Provider, { value: providerValue, children: element2 }),
      [providerValue]
    );
    props2 = {
      id: id2,
      "data-active-item": isActiveItem || void 0,
      ...props2,
      ref: useMergeRefs(ref, props2.ref),
      tabIndex: isTabbable2 ? props2.tabIndex : -1,
      onFocus,
      onBlurCapture,
      onKeyDown
    };
    props2 = useCommand(props2);
    props2 = useCollectionItem({
      store: store2,
      ...props2,
      getItem,
      shouldRegisterItem: id2 ? props2.shouldRegisterItem : false
    });
    return removeUndefinedValues({
      ...props2,
      "aria-setsize": ariaSetSize,
      "aria-posinset": ariaPosInSet
    });
  }
);
var CompositeItem = memo2(
  forwardRef2(function CompositeItem23(props2) {
    const htmlProps = useCompositeItem(props2);
    return createElement(TagName$s, htmlProps);
  })
);
var TagName$r = "button";
var useTab = createHook(function useTab22({
  store: store2,
  getItem: getItemProp,
  ...props2
}) {
  var _a2;
  const context = useTabScopedContext();
  store2 = store2 || context;
  invariant(
    store2,
    process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component."
  );
  const defaultId = useId();
  const id2 = props2.id || defaultId;
  const dimmed = disabledFromProps(props2);
  const getItem = useCallback(
    (item) => {
      const nextItem = { ...item, dimmed };
      if (getItemProp) {
        return getItemProp(nextItem);
      }
      return nextItem;
    },
    [dimmed, getItemProp]
  );
  const onClickProp = props2.onClick;
  const onClick = useEvent((event) => {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    store2 == null ? void 0 : store2.setSelectedId(id2);
  });
  const panelId = store2.panels.useState(
    (state) => {
      var _a22;
      return (_a22 = state.items.find((item) => item.tabId === id2)) == null ? void 0 : _a22.id;
    }
  );
  const shouldRegisterItem = defaultId ? props2.shouldRegisterItem : false;
  const isActive = store2.useState((state) => !!id2 && state.activeId === id2);
  const selected = store2.useState((state) => !!id2 && state.selectedId === id2);
  const hasActiveItem = store2.useState((state) => !!store2.item(state.activeId));
  const canRegisterComposedItem = isActive || selected && !hasActiveItem;
  const accessibleWhenDisabled = selected || ((_a2 = props2.accessibleWhenDisabled) != null ? _a2 : true);
  const isWithinVirtualFocusComposite = useStoreState(
    store2.combobox || store2.composite,
    "virtualFocus"
  );
  if (isWithinVirtualFocusComposite) {
    props2 = {
      ...props2,
      tabIndex: -1
    };
  }
  props2 = {
    id: id2,
    role: "tab",
    "aria-selected": selected,
    "aria-controls": panelId || void 0,
    ...props2,
    onClick
  };
  if (store2.composite) {
    const defaultProps = {
      id: id2,
      accessibleWhenDisabled,
      store: store2.composite,
      shouldRegisterItem: canRegisterComposedItem && shouldRegisterItem,
      rowId: props2.rowId,
      render: props2.render
    };
    props2 = {
      ...props2,
      render: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        CompositeItem,
        {
          ...defaultProps,
          render: store2.combobox && store2.composite !== store2.combobox ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(CompositeItem, { ...defaultProps, store: store2.combobox }) : defaultProps.render
        }
      )
    };
  }
  props2 = useCompositeItem({
    store: store2,
    ...props2,
    accessibleWhenDisabled,
    getItem,
    shouldRegisterItem
  });
  return props2;
});
var Tab = memo2(
  forwardRef2(function Tab22(props2) {
    const htmlProps = useTab(props2);
    return createElement(TagName$r, htmlProps);
  })
);
function toArray(arg) {
  if (Array.isArray(arg)) {
    return arg;
  }
  return typeof arg !== "undefined" ? [arg] : [];
}
function flatten2DArray(array) {
  const flattened2 = [];
  for (const row of array) {
    flattened2.push(...row);
  }
  return flattened2;
}
function reverseArray(array) {
  return array.slice().reverse();
}
var TagName$q = "div";
function isGrid(items) {
  return items.some((item) => !!item.rowId);
}
function isPrintableKey(event) {
  const target = event.target;
  if (target && !isTextField(target)) return false;
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
function isModifierKey(event) {
  return event.key === "Shift" || event.key === "Control" || event.key === "Alt" || event.key === "Meta";
}
function useKeyboardEventProxy(store2, onKeyboardEvent, previousElementRef) {
  return useEvent((event) => {
    var _a2;
    onKeyboardEvent == null ? void 0 : onKeyboardEvent(event);
    if (event.defaultPrevented) return;
    if (event.isPropagationStopped()) return;
    if (!isSelfTarget(event)) return;
    if (isModifierKey(event)) return;
    if (isPrintableKey(event)) return;
    const state = store2.getState();
    const activeElement = (_a2 = getEnabledItem(store2, state.activeId)) == null ? void 0 : _a2.element;
    if (!activeElement) return;
    const { view, ...eventInit } = event;
    const previousElement = previousElementRef == null ? void 0 : previousElementRef.current;
    if (activeElement !== previousElement) {
      activeElement.focus();
    }
    if (!fireKeyboardEvent(activeElement, event.type, eventInit)) {
      event.preventDefault();
    }
    if (event.currentTarget.contains(activeElement)) {
      event.stopPropagation();
    }
  });
}
function findFirstEnabledItemInTheLastRow(items) {
  return findFirstEnabledItem$1(
    flatten2DArray(reverseArray(groupItemsByRows$1(items)))
  );
}
function useScheduleFocus(store2) {
  const [scheduled, setScheduled] = useState(false);
  const schedule = useCallback(() => setScheduled(true), []);
  const activeItem = store2.useState(
    (state) => getEnabledItem(store2, state.activeId)
  );
  useEffect(() => {
    const activeElement = activeItem == null ? void 0 : activeItem.element;
    if (!scheduled) return;
    if (!activeElement) return;
    setScheduled(false);
    activeElement.focus({ preventScroll: true });
  }, [activeItem, scheduled]);
  return schedule;
}
var useComposite = createHook(
  function useComposite23({
    store: store2,
    composite = true,
    focusOnMove = composite,
    moveOnKeyPress = true,
    ...props2
  }) {
    const context = useCompositeProviderContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const ref = useRef(null);
    const previousElementRef = useRef(null);
    const scheduleFocus = useScheduleFocus(store2);
    const moves = store2.useState("moves");
    const [, setBaseElement] = useTransactionState(
      composite ? store2.setBaseElement : null
    );
    useEffect(() => {
      var _a2;
      if (!store2) return;
      if (!moves) return;
      if (!composite) return;
      if (!focusOnMove) return;
      const { activeId: activeId2 } = store2.getState();
      const itemElement = (_a2 = getEnabledItem(store2, activeId2)) == null ? void 0 : _a2.element;
      if (!itemElement) return;
      focusIntoView(itemElement);
    }, [store2, moves, composite, focusOnMove]);
    useSafeLayoutEffect(() => {
      if (!store2) return;
      if (!moves) return;
      if (!composite) return;
      const { baseElement, activeId: activeId2 } = store2.getState();
      const isSelfAcive = activeId2 === null;
      if (!isSelfAcive) return;
      if (!baseElement) return;
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (previousElement) {
        fireBlurEvent(previousElement, { relatedTarget: baseElement });
      }
      if (!hasFocus(baseElement)) {
        baseElement.focus();
      }
    }, [store2, moves, composite]);
    const activeId = store2.useState("activeId");
    const virtualFocus = store2.useState("virtualFocus");
    useSafeLayoutEffect(() => {
      var _a2;
      if (!store2) return;
      if (!composite) return;
      if (!virtualFocus) return;
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (!previousElement) return;
      const activeElement = (_a2 = getEnabledItem(store2, activeId)) == null ? void 0 : _a2.element;
      const relatedTarget = activeElement || getActiveElement(previousElement);
      if (relatedTarget === previousElement) return;
      fireBlurEvent(previousElement, { relatedTarget });
    }, [store2, activeId, virtualFocus, composite]);
    const onKeyDownCapture = useKeyboardEventProxy(
      store2,
      props2.onKeyDownCapture,
      previousElementRef
    );
    const onKeyUpCapture = useKeyboardEventProxy(
      store2,
      props2.onKeyUpCapture,
      previousElementRef
    );
    const onFocusCaptureProp = props2.onFocusCapture;
    const onFocusCapture = useEvent((event) => {
      onFocusCaptureProp == null ? void 0 : onFocusCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!store2) return;
      const { virtualFocus: virtualFocus2 } = store2.getState();
      if (!virtualFocus2) return;
      const previousActiveElement = event.relatedTarget;
      const isSilentlyFocused = silentlyFocused(event.currentTarget);
      if (isSelfTarget(event) && isSilentlyFocused) {
        event.stopPropagation();
        previousElementRef.current = previousActiveElement;
      }
    });
    const onFocusProp = props2.onFocus;
    const onFocus = useEvent((event) => {
      onFocusProp == null ? void 0 : onFocusProp(event);
      if (event.defaultPrevented) return;
      if (!composite) return;
      if (!store2) return;
      const { relatedTarget } = event;
      const { virtualFocus: virtualFocus2 } = store2.getState();
      if (virtualFocus2) {
        if (isSelfTarget(event) && !isItem(store2, relatedTarget)) {
          queueMicrotask(scheduleFocus);
        }
      } else if (isSelfTarget(event)) {
        store2.setActiveId(null);
      }
    });
    const onBlurCaptureProp = props2.onBlurCapture;
    const onBlurCapture = useEvent((event) => {
      var _a2;
      onBlurCaptureProp == null ? void 0 : onBlurCaptureProp(event);
      if (event.defaultPrevented) return;
      if (!store2) return;
      const { virtualFocus: virtualFocus2, activeId: activeId2 } = store2.getState();
      if (!virtualFocus2) return;
      const activeElement = (_a2 = getEnabledItem(store2, activeId2)) == null ? void 0 : _a2.element;
      const nextActiveElement = event.relatedTarget;
      const nextActiveElementIsItem = isItem(store2, nextActiveElement);
      const previousElement = previousElementRef.current;
      previousElementRef.current = null;
      if (isSelfTarget(event) && nextActiveElementIsItem) {
        if (nextActiveElement === activeElement) {
          if (previousElement && previousElement !== nextActiveElement) {
            fireBlurEvent(previousElement, event);
          }
        } else if (activeElement) {
          fireBlurEvent(activeElement, event);
        } else if (previousElement) {
          fireBlurEvent(previousElement, event);
        }
        event.stopPropagation();
      } else {
        const targetIsItem = isItem(store2, event.target);
        if (!targetIsItem && activeElement) {
          fireBlurEvent(activeElement, event);
        }
      }
    });
    const onKeyDownProp = props2.onKeyDown;
    const moveOnKeyPressProp = useBooleanEvent(moveOnKeyPress);
    const onKeyDown = useEvent((event) => {
      var _a2;
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.nativeEvent.isComposing) return;
      if (event.defaultPrevented) return;
      if (!store2) return;
      if (!isSelfTarget(event)) return;
      const { orientation, renderedItems, activeId: activeId2 } = store2.getState();
      const activeItem = getEnabledItem(store2, activeId2);
      if ((_a2 = activeItem == null ? void 0 : activeItem.element) == null ? void 0 : _a2.isConnected) return;
      const isVertical = orientation !== "horizontal";
      const isHorizontal = orientation !== "vertical";
      const grid = isGrid(renderedItems);
      const isHorizontalKey = event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Home" || event.key === "End";
      if (isHorizontalKey && isTextField(event.currentTarget)) return;
      const up = () => {
        if (grid) {
          const item = findFirstEnabledItemInTheLastRow(renderedItems);
          return item == null ? void 0 : item.id;
        }
        return store2 == null ? void 0 : store2.last();
      };
      const keyMap = {
        ArrowUp: (grid || isVertical) && up,
        ArrowRight: (grid || isHorizontal) && store2.first,
        ArrowDown: (grid || isVertical) && store2.first,
        ArrowLeft: (grid || isHorizontal) && store2.last,
        Home: store2.first,
        End: store2.last,
        PageUp: store2.first,
        PageDown: store2.last
      };
      const action = keyMap[event.key];
      if (action) {
        const id2 = action();
        if (id2 !== void 0) {
          if (!moveOnKeyPressProp(event)) return;
          event.preventDefault();
          store2.move(id2);
        }
      }
    });
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(CompositeContextProvider, { value: store2, children: element2 }),
      [store2]
    );
    const activeDescendant = store2.useState((state) => {
      var _a2;
      if (!store2) return;
      if (!composite) return;
      if (!state.virtualFocus) return;
      return (_a2 = getEnabledItem(store2, state.activeId)) == null ? void 0 : _a2.id;
    });
    props2 = {
      "aria-activedescendant": activeDescendant,
      ...props2,
      ref: useMergeRefs(ref, setBaseElement, props2.ref),
      onKeyDownCapture,
      onKeyUpCapture,
      onFocusCapture,
      onFocus,
      onBlurCapture,
      onKeyDown
    };
    const focusable = store2.useState(
      (state) => composite && (state.virtualFocus || state.activeId === null)
    );
    props2 = useFocusable({ focusable, ...props2 });
    return props2;
  }
);
forwardRef2(function Composite23(props2) {
  const htmlProps = useComposite(props2);
  return createElement(TagName$q, htmlProps);
});
var TagName$p = "div";
var useTabList = createHook(
  function useTabList22({ store: store2, ...props2 }) {
    const context = useTabProviderContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const orientation = store2.useState(
      (state) => state.orientation === "both" ? void 0 : state.orientation
    );
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabScopedContextProvider, { value: store2, children: element2 }),
      [store2]
    );
    if (store2.composite) {
      props2 = {
        focusable: false,
        ...props2
      };
    }
    props2 = {
      role: "tablist",
      "aria-orientation": orientation,
      ...props2
    };
    props2 = useComposite({ store: store2, ...props2 });
    return props2;
  }
);
var TabList = forwardRef2(function TabList22(props2) {
  const htmlProps = useTabList(props2);
  return createElement(TagName$p, htmlProps);
});
var ctx$5 = createStoreContext();
var useDisclosureProviderContext = ctx$5.useProviderContext;
var DisclosureContextProvider = ctx$5.ContextProvider;
var DisclosureScopedContextProvider = ctx$5.ScopedContextProvider;
var ctx$4 = createStoreContext(
  [DisclosureContextProvider],
  [DisclosureScopedContextProvider]
);
var useDialogProviderContext = ctx$4.useProviderContext;
var DialogContextProvider = ctx$4.ContextProvider;
var DialogScopedContextProvider = ctx$4.ScopedContextProvider;
var DialogHeadingContext = createContext(void 0);
var DialogDescriptionContext = createContext(void 0);
var TagName$o = "div";
function afterTimeout(timeoutMs, cb2) {
  const timeoutId = setTimeout(cb2, timeoutMs);
  return () => clearTimeout(timeoutId);
}
function afterPaint(cb2) {
  let raf = requestAnimationFrame(() => {
    raf = requestAnimationFrame(cb2);
  });
  return () => cancelAnimationFrame(raf);
}
function parseCSSTime(...times2) {
  return times2.join(", ").split(", ").reduce((longestTime, currentTimeString) => {
    const multiplier = currentTimeString.endsWith("ms") ? 1 : 1e3;
    const currentTime = Number.parseFloat(currentTimeString || "0s") * multiplier;
    if (currentTime > longestTime) return currentTime;
    return longestTime;
  }, 0);
}
function isHidden(mounted, hidden, alwaysVisible) {
  return !alwaysVisible && hidden !== false && (!mounted || !!hidden);
}
var useDisclosureContent = createHook(function useDisclosureContent2({ store: store2, alwaysVisible, ...props2 }) {
  const context = useDisclosureProviderContext();
  store2 = store2 || context;
  invariant(
    store2,
    process.env.NODE_ENV !== "production" && "DisclosureContent must receive a `store` prop or be wrapped in a DisclosureProvider component."
  );
  const ref = useRef(null);
  const id2 = useId(props2.id);
  const [transition, setTransition] = useState(null);
  const open = store2.useState("open");
  const mounted = store2.useState("mounted");
  const animated = store2.useState("animated");
  const contentElement = store2.useState("contentElement");
  const otherElement = useStoreState(store2.disclosure, "contentElement");
  useSafeLayoutEffect(() => {
    if (!ref.current) return;
    store2 == null ? void 0 : store2.setContentElement(ref.current);
  }, [store2]);
  useSafeLayoutEffect(() => {
    let previousAnimated;
    store2 == null ? void 0 : store2.setState("animated", (animated2) => {
      previousAnimated = animated2;
      return true;
    });
    return () => {
      if (previousAnimated === void 0) return;
      store2 == null ? void 0 : store2.setState("animated", previousAnimated);
    };
  }, [store2]);
  useSafeLayoutEffect(() => {
    if (!animated) return;
    if (!(contentElement == null ? void 0 : contentElement.isConnected)) {
      setTransition(null);
      return;
    }
    return afterPaint(() => {
      setTransition(open ? "enter" : mounted ? "leave" : null);
    });
  }, [animated, contentElement, open, mounted]);
  useSafeLayoutEffect(() => {
    if (!store2) return;
    if (!animated) return;
    if (!transition) return;
    if (!contentElement) return;
    const stopAnimation = () => store2 == null ? void 0 : store2.setState("animating", false);
    const stopAnimationSync = () => flushSync(stopAnimation);
    if (transition === "leave" && open) return;
    if (transition === "enter" && !open) return;
    if (typeof animated === "number") {
      const timeout2 = animated;
      return afterTimeout(timeout2, stopAnimationSync);
    }
    const {
      transitionDuration,
      animationDuration,
      transitionDelay,
      animationDelay
    } = getComputedStyle(contentElement);
    const {
      transitionDuration: transitionDuration2 = "0",
      animationDuration: animationDuration2 = "0",
      transitionDelay: transitionDelay2 = "0",
      animationDelay: animationDelay2 = "0"
    } = otherElement ? getComputedStyle(otherElement) : {};
    const delay2 = parseCSSTime(
      transitionDelay,
      animationDelay,
      transitionDelay2,
      animationDelay2
    );
    const duration = parseCSSTime(
      transitionDuration,
      animationDuration,
      transitionDuration2,
      animationDuration2
    );
    const timeout = delay2 + duration;
    if (!timeout) {
      if (transition === "enter") {
        store2.setState("animated", false);
      }
      stopAnimation();
      return;
    }
    const frameRate = 1e3 / 60;
    const maxTimeout = Math.max(timeout - frameRate, 0);
    return afterTimeout(maxTimeout, stopAnimationSync);
  }, [store2, animated, contentElement, otherElement, open, transition]);
  props2 = useWrapElement(
    props2,
    (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogScopedContextProvider, { value: store2, children: element2 }),
    [store2]
  );
  const hidden = isHidden(mounted, props2.hidden, alwaysVisible);
  const styleProp = props2.style;
  const style = useMemo(() => {
    if (hidden) {
      return { ...styleProp, display: "none" };
    }
    return styleProp;
  }, [hidden, styleProp]);
  props2 = {
    id: id2,
    "data-open": open || void 0,
    "data-enter": transition === "enter" || void 0,
    "data-leave": transition === "leave" || void 0,
    hidden,
    ...props2,
    ref: useMergeRefs(id2 ? store2.setContentElement : null, ref, props2.ref),
    style
  };
  return removeUndefinedValues(props2);
});
var DisclosureContentImpl = forwardRef2(function DisclosureContentImpl2(props2) {
  const htmlProps = useDisclosureContent(props2);
  return createElement(TagName$o, htmlProps);
});
forwardRef2(function DisclosureContent2({
  unmountOnHide,
  ...props2
}) {
  const context = useDisclosureProviderContext();
  const store2 = props2.store || context;
  const mounted = useStoreState(
    store2,
    (state) => !unmountOnHide || (state == null ? void 0 : state.mounted)
  );
  if (mounted === false) return null;
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(DisclosureContentImpl, { ...props2 });
});
function createDisclosureStore(props2 = {}) {
  const store2 = mergeStore(
    props2.store,
    omit2(props2.disclosure, ["contentElement", "disclosureElement"])
  );
  throwOnConflictingProps(props2, store2);
  const syncState = store2 == null ? void 0 : store2.getState();
  const open = defaultValue(
    props2.open,
    syncState == null ? void 0 : syncState.open,
    props2.defaultOpen,
    false
  );
  const animated = defaultValue(props2.animated, syncState == null ? void 0 : syncState.animated, false);
  const initialState2 = {
    open,
    animated,
    animating: !!animated && open,
    mounted: open,
    contentElement: defaultValue(syncState == null ? void 0 : syncState.contentElement, null),
    disclosureElement: defaultValue(syncState == null ? void 0 : syncState.disclosureElement, null)
  };
  const disclosure = createStore(initialState2, store2);
  setup(
    disclosure,
    () => sync(disclosure, ["animated", "animating"], (state) => {
      if (state.animated) return;
      disclosure.setState("animating", false);
    })
  );
  setup(
    disclosure,
    () => subscribe(disclosure, ["open"], () => {
      if (!disclosure.getState().animated) return;
      disclosure.setState("animating", true);
    })
  );
  setup(
    disclosure,
    () => sync(disclosure, ["open", "animating"], (state) => {
      disclosure.setState("mounted", state.open || state.animating);
    })
  );
  return {
    ...disclosure,
    disclosure: props2.disclosure,
    setOpen: (value) => disclosure.setState("open", value),
    show: () => disclosure.setState("open", true),
    hide: () => disclosure.setState("open", false),
    toggle: () => disclosure.setState("open", (open2) => !open2),
    stopAnimation: () => disclosure.setState("animating", false),
    setContentElement: (value) => disclosure.setState("contentElement", value),
    setDisclosureElement: (value) => disclosure.setState("disclosureElement", value)
  };
}
function useDisclosureStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.store, props2.disclosure]);
  useStoreProps(store2, props2, "open", "setOpen");
  useStoreProps(store2, props2, "mounted", "setMounted");
  useStoreProps(store2, props2, "animated");
  return Object.assign(store2, { disclosure: props2.disclosure });
}
function useDisclosureStore(props2 = {}) {
  const [store2, update] = useStore(createDisclosureStore, props2);
  return useDisclosureStoreProps(store2, update, props2);
}
var TagName$n = "div";
var useTabPanel = createHook(
  function useTabPanel2({
    store: store2,
    unmountOnHide,
    tabId: tabIdProp,
    getItem: getItemProp,
    scrollRestoration,
    scrollElement,
    ...props2
  }) {
    const context = useTabProviderContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "TabPanel must receive a `store` prop or be wrapped in a TabProvider component."
    );
    const ref = useRef(null);
    const id2 = useId(props2.id);
    const tabId = useStoreState(
      store2.panels,
      () => {
        var _a2;
        return tabIdProp || ((_a2 = store2 == null ? void 0 : store2.panels.item(id2)) == null ? void 0 : _a2.tabId);
      }
    );
    const open = useStoreState(
      store2,
      (state) => !!tabId && state.selectedId === tabId
    );
    const disclosure = useDisclosureStore({ open });
    const mounted = useStoreState(disclosure, "mounted");
    const scrollPositionRef = useRef(
      /* @__PURE__ */ new Map()
    );
    const getScrollElement = useEvent(() => {
      const panelElement = ref.current;
      if (!panelElement) return null;
      if (!scrollElement) return panelElement;
      if (typeof scrollElement === "function") {
        return scrollElement(panelElement);
      }
      if ("current" in scrollElement) {
        return scrollElement.current;
      }
      return scrollElement;
    });
    useEffect(() => {
      var _a2, _b;
      if (!scrollRestoration) return;
      if (!mounted) return;
      const element2 = getScrollElement();
      if (!element2) return;
      if (scrollRestoration === "reset") {
        element2.scroll(0, 0);
        return;
      }
      if (!tabId) return;
      const position2 = scrollPositionRef.current.get(tabId);
      element2.scroll((_a2 = position2 == null ? void 0 : position2.x) != null ? _a2 : 0, (_b = position2 == null ? void 0 : position2.y) != null ? _b : 0);
      const onScroll = () => {
        scrollPositionRef.current.set(tabId, {
          x: element2.scrollLeft,
          y: element2.scrollTop
        });
      };
      element2.addEventListener("scroll", onScroll);
      return () => {
        element2.removeEventListener("scroll", onScroll);
      };
    }, [scrollRestoration, mounted, tabId, getScrollElement, store2]);
    const [hasTabbableChildren, setHasTabbableChildren] = useState(false);
    useEffect(() => {
      const element2 = ref.current;
      if (!element2) return;
      const tabbable = getAllTabbableIn(element2);
      setHasTabbableChildren(!!tabbable.length);
    }, []);
    const getItem = useCallback(
      (item) => {
        const nextItem = { ...item, id: id2 || item.id, tabId: tabIdProp };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [id2, tabIdProp, getItemProp]
    );
    const onKeyDownProp = props2.onKeyDown;
    const onKeyDown = useEvent((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.defaultPrevented) return;
      if (!(store2 == null ? void 0 : store2.composite)) return;
      const keyMap = {
        ArrowLeft: store2.previous,
        ArrowRight: store2.next,
        Home: store2.first,
        End: store2.last
      };
      const action = keyMap[event.key];
      if (!action) return;
      const { selectedId } = store2.getState();
      const nextId = action({ activeId: selectedId });
      if (!nextId) return;
      event.preventDefault();
      store2.move(nextId);
    });
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabScopedContextProvider, { value: store2, children: element2 }),
      [store2]
    );
    props2 = {
      id: id2,
      role: "tabpanel",
      "aria-labelledby": tabId || void 0,
      ...props2,
      children: unmountOnHide && !mounted ? null : props2.children,
      ref: useMergeRefs(ref, props2.ref),
      onKeyDown
    };
    props2 = useFocusable({
      // If the tab panel is rendered as part of another composite widget such
      // as combobox, it should not be focusable.
      focusable: !store2.composite && !hasTabbableChildren,
      ...props2
    });
    props2 = useDisclosureContent({ store: disclosure, ...props2 });
    props2 = useCollectionItem({ store: store2.panels, ...props2, getItem });
    return props2;
  }
);
var TabPanel = forwardRef2(function TabPanel2(props2) {
  const htmlProps = useTabPanel(props2);
  return createElement(TagName$n, htmlProps);
});
var ctx$3 = createStoreContext(
  [DialogContextProvider],
  [DialogScopedContextProvider]
);
var usePopoverContext = ctx$3.useContext;
var usePopoverProviderContext = ctx$3.useProviderContext;
var PopoverContextProvider = ctx$3.ContextProvider;
var PopoverScopedContextProvider = ctx$3.ScopedContextProvider;
var ctx$2 = createStoreContext(
  [PopoverContextProvider, CompositeContextProvider],
  [PopoverScopedContextProvider, CompositeScopedContextProvider]
);
var useSelectContext = ctx$2.useContext;
var useSelectScopedContext = ctx$2.useScopedContext;
var useSelectProviderContext = ctx$2.useProviderContext;
var SelectContextProvider = ctx$2.ContextProvider;
var SelectScopedContextProvider = ctx$2.ScopedContextProvider;
var SelectItemCheckedContext = createContext(false);
var SelectHeadingContext = createContext(null);
function getCommonParent(items) {
  var _a2;
  const firstItem = items.find((item) => !!item.element);
  const lastItem = [...items].reverse().find((item) => !!item.element);
  let parentElement = (_a2 = firstItem == null ? void 0 : firstItem.element) == null ? void 0 : _a2.parentElement;
  while (parentElement && (lastItem == null ? void 0 : lastItem.element)) {
    const parent = parentElement;
    if (lastItem && parent.contains(lastItem.element)) {
      return parentElement;
    }
    parentElement = parentElement.parentElement;
  }
  return getDocument(parentElement).body;
}
function getPrivateStore(store2) {
  return store2 == null ? void 0 : store2.__unstablePrivateStore;
}
function createCollectionStore(props2 = {}) {
  var _a2;
  throwOnConflictingProps(props2, props2.store);
  const syncState = (_a2 = props2.store) == null ? void 0 : _a2.getState();
  const items = defaultValue(
    props2.items,
    syncState == null ? void 0 : syncState.items,
    props2.defaultItems,
    []
  );
  const itemsMap = new Map(items.map((item) => [item.id, item]));
  const initialState2 = {
    items,
    renderedItems: defaultValue(syncState == null ? void 0 : syncState.renderedItems, [])
  };
  const syncPrivateStore = getPrivateStore(props2.store);
  const privateStore = createStore(
    { items, renderedItems: initialState2.renderedItems },
    syncPrivateStore
  );
  const collection = createStore(initialState2, props2.store);
  const sortItems = (renderedItems) => {
    const sortedItems = sortBasedOnDOMPosition(renderedItems, (i2) => i2.element);
    privateStore.setState("renderedItems", sortedItems);
    collection.setState("renderedItems", sortedItems);
  };
  setup(collection, () => init(privateStore));
  setup(privateStore, () => {
    return batch(privateStore, ["items"], (state) => {
      collection.setState("items", state.items);
    });
  });
  setup(privateStore, () => {
    return batch(privateStore, ["renderedItems"], (state) => {
      let firstRun = true;
      let raf = requestAnimationFrame(() => {
        const { renderedItems } = collection.getState();
        if (state.renderedItems === renderedItems) return;
        sortItems(state.renderedItems);
      });
      if (typeof IntersectionObserver !== "function") {
        return () => cancelAnimationFrame(raf);
      }
      const ioCallback = () => {
        if (firstRun) {
          firstRun = false;
          return;
        }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => sortItems(state.renderedItems));
      };
      const root2 = getCommonParent(state.renderedItems);
      const observer = new IntersectionObserver(ioCallback, { root: root2 });
      for (const item of state.renderedItems) {
        if (!item.element) continue;
        observer.observe(item.element);
      }
      return () => {
        cancelAnimationFrame(raf);
        observer.disconnect();
      };
    });
  });
  const mergeItem = (item, setItems, canDeleteFromMap = false) => {
    let prevItem;
    setItems((items2) => {
      const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
      const nextItems = items2.slice();
      if (index2 !== -1) {
        prevItem = items2[index2];
        const nextItem = { ...prevItem, ...item };
        nextItems[index2] = nextItem;
        itemsMap.set(item.id, nextItem);
      } else {
        nextItems.push(item);
        itemsMap.set(item.id, item);
      }
      return nextItems;
    });
    const unmergeItem = () => {
      setItems((items2) => {
        if (!prevItem) {
          if (canDeleteFromMap) {
            itemsMap.delete(item.id);
          }
          return items2.filter(({ id: id2 }) => id2 !== item.id);
        }
        const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
        if (index2 === -1) return items2;
        const nextItems = items2.slice();
        nextItems[index2] = prevItem;
        itemsMap.set(item.id, prevItem);
        return nextItems;
      });
    };
    return unmergeItem;
  };
  const registerItem = (item) => mergeItem(
    item,
    (getItems) => privateStore.setState("items", getItems),
    true
  );
  return {
    ...collection,
    registerItem,
    renderItem: (item) => chain(
      registerItem(item),
      mergeItem(
        item,
        (getItems) => privateStore.setState("renderedItems", getItems)
      )
    ),
    item: (id2) => {
      if (!id2) return null;
      let item = itemsMap.get(id2);
      if (!item) {
        const { items: items2 } = privateStore.getState();
        item = items2.find((item2) => item2.id === id2);
        if (item) {
          itemsMap.set(id2, item);
        }
      }
      return item || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: privateStore
  };
}
function useCollectionStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.store]);
  useStoreProps(store2, props2, "items", "setItems");
  return store2;
}
var NULL_ITEM = { id: null };
function findFirstEnabledItem(items, excludeId) {
  return items.find((item) => {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getEnabledItems$1(items, excludeId) {
  return items.filter((item) => {
    if (excludeId) {
      return !item.disabled && item.id !== excludeId;
    }
    return !item.disabled;
  });
}
function getItemsInRow(items, rowId) {
  return items.filter((item) => item.rowId === rowId);
}
function flipItems(items, activeId, shouldInsertNullItem = false) {
  const index2 = items.findIndex((item) => item.id === activeId);
  return [
    ...items.slice(index2 + 1),
    ...shouldInsertNullItem ? [NULL_ITEM] : [],
    ...items.slice(0, index2)
  ];
}
function groupItemsByRows(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => {
      var _a2;
      return ((_a2 = currentRow[0]) == null ? void 0 : _a2.rowId) === item.rowId;
    });
    if (row) {
      row.push(item);
    } else {
      rows.push([item]);
    }
  }
  return rows;
}
function getMaxRowLength(array) {
  let maxLength = 0;
  for (const { length } of array) {
    if (length > maxLength) {
      maxLength = length;
    }
  }
  return maxLength;
}
function createEmptyItem(rowId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    rowId
  };
}
function normalizeRows(rows, activeId, focusShift) {
  const maxLength = getMaxRowLength(rows);
  for (const row of rows) {
    for (let i2 = 0; i2 < maxLength; i2 += 1) {
      const item = row[i2];
      if (!item || focusShift && item.disabled) {
        const isFirst = i2 === 0;
        const previousItem = isFirst && focusShift ? findFirstEnabledItem(row) : row[i2 - 1];
        row[i2] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem(previousItem == null ? void 0 : previousItem.rowId);
      }
    }
  }
  return rows;
}
function verticalizeItems(items) {
  const rows = groupItemsByRows(items);
  const maxLength = getMaxRowLength(rows);
  const verticalized = [];
  for (let i2 = 0; i2 < maxLength; i2 += 1) {
    for (const row of rows) {
      const item = row[i2];
      if (item) {
        verticalized.push({
          ...item,
          // If there's no rowId, it means that it's not a grid composite, but
          // a single row instead. So, instead of verticalizing it, that is,
          // assigning a different rowId based on the column index, we keep it
          // undefined so they will be part of the same row. This is useful
          // when using up/down on one-dimensional composites.
          rowId: item.rowId ? `${i2}` : void 0
        });
      }
    }
  }
  return verticalized;
}
function createCompositeStore(props2 = {}) {
  var _a2;
  const syncState = (_a2 = props2.store) == null ? void 0 : _a2.getState();
  const collection = createCollectionStore(props2);
  const activeId = defaultValue(
    props2.activeId,
    syncState == null ? void 0 : syncState.activeId,
    props2.defaultActiveId
  );
  const initialState2 = {
    ...collection.getState(),
    id: defaultValue(
      props2.id,
      syncState == null ? void 0 : syncState.id,
      `id-${Math.random().toString(36).slice(2, 8)}`
    ),
    activeId,
    baseElement: defaultValue(syncState == null ? void 0 : syncState.baseElement, null),
    includesBaseElement: defaultValue(
      props2.includesBaseElement,
      syncState == null ? void 0 : syncState.includesBaseElement,
      activeId === null
    ),
    moves: defaultValue(syncState == null ? void 0 : syncState.moves, 0),
    orientation: defaultValue(
      props2.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "both"
    ),
    rtl: defaultValue(props2.rtl, syncState == null ? void 0 : syncState.rtl, false),
    virtualFocus: defaultValue(
      props2.virtualFocus,
      syncState == null ? void 0 : syncState.virtualFocus,
      false
    ),
    focusLoop: defaultValue(props2.focusLoop, syncState == null ? void 0 : syncState.focusLoop, false),
    focusWrap: defaultValue(props2.focusWrap, syncState == null ? void 0 : syncState.focusWrap, false),
    focusShift: defaultValue(props2.focusShift, syncState == null ? void 0 : syncState.focusShift, false)
  };
  const composite = createStore(initialState2, collection, props2.store);
  setup(
    composite,
    () => sync(composite, ["renderedItems", "activeId"], (state) => {
      composite.setState("activeId", (activeId2) => {
        var _a22;
        if (activeId2 !== void 0) return activeId2;
        return (_a22 = findFirstEnabledItem(state.renderedItems)) == null ? void 0 : _a22.id;
      });
    })
  );
  const getNextId = (direction = "next", options2 = {}) => {
    var _a22, _b;
    const defaultState = composite.getState();
    const {
      skip = 0,
      activeId: activeId2 = defaultState.activeId,
      focusShift = defaultState.focusShift,
      focusLoop = defaultState.focusLoop,
      focusWrap = defaultState.focusWrap,
      includesBaseElement = defaultState.includesBaseElement,
      renderedItems = defaultState.renderedItems,
      rtl = defaultState.rtl
    } = options2;
    const isVerticalDirection = direction === "up" || direction === "down";
    const isNextDirection = direction === "next" || direction === "down";
    const canReverse = isNextDirection ? rtl && !isVerticalDirection : !rtl || isVerticalDirection;
    const canShift = focusShift && !skip;
    let items = !isVerticalDirection ? renderedItems : flatten2DArray(
      normalizeRows(groupItemsByRows(renderedItems), activeId2, canShift)
    );
    items = canReverse ? reverseArray(items) : items;
    items = isVerticalDirection ? verticalizeItems(items) : items;
    if (activeId2 == null) {
      return (_a22 = findFirstEnabledItem(items)) == null ? void 0 : _a22.id;
    }
    const activeItem = items.find((item) => item.id === activeId2);
    if (!activeItem) {
      return (_b = findFirstEnabledItem(items)) == null ? void 0 : _b.id;
    }
    const isGrid2 = items.some((item) => item.rowId);
    const activeIndex = items.indexOf(activeItem);
    const nextItems = items.slice(activeIndex + 1);
    const nextItemsInRow = getItemsInRow(nextItems, activeItem.rowId);
    if (skip) {
      const nextEnabledItemsInRow = getEnabledItems$1(nextItemsInRow, activeId2);
      const nextItem2 = nextEnabledItemsInRow.slice(skip)[0] || // If we can't find an item, just return the last one.
      nextEnabledItemsInRow[nextEnabledItemsInRow.length - 1];
      return nextItem2 == null ? void 0 : nextItem2.id;
    }
    const canLoop = focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical");
    const canWrap = isGrid2 && focusWrap && (isVerticalDirection ? focusWrap !== "horizontal" : focusWrap !== "vertical");
    const hasNullItem = isNextDirection ? (!isGrid2 || isVerticalDirection) && canLoop && includesBaseElement : isVerticalDirection ? includesBaseElement : false;
    if (canLoop) {
      const loopItems = canWrap && !hasNullItem ? items : getItemsInRow(items, activeItem.rowId);
      const sortedItems = flipItems(loopItems, activeId2, hasNullItem);
      const nextItem2 = findFirstEnabledItem(sortedItems, activeId2);
      return nextItem2 == null ? void 0 : nextItem2.id;
    }
    if (canWrap) {
      const nextItem2 = findFirstEnabledItem(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        hasNullItem ? nextItemsInRow : nextItems,
        activeId2
      );
      const nextId = hasNullItem ? (nextItem2 == null ? void 0 : nextItem2.id) || null : nextItem2 == null ? void 0 : nextItem2.id;
      return nextId;
    }
    const nextItem = findFirstEnabledItem(nextItemsInRow, activeId2);
    if (!nextItem && hasNullItem) {
      return null;
    }
    return nextItem == null ? void 0 : nextItem.id;
  };
  return {
    ...collection,
    ...composite,
    setBaseElement: (element2) => composite.setState("baseElement", element2),
    setActiveId: (id2) => composite.setState("activeId", id2),
    move: (id2) => {
      if (id2 === void 0) return;
      composite.setState("activeId", id2);
      composite.setState("moves", (moves) => moves + 1);
    },
    first: () => {
      var _a22;
      return (_a22 = findFirstEnabledItem(composite.getState().renderedItems)) == null ? void 0 : _a22.id;
    },
    last: () => {
      var _a22;
      return (_a22 = findFirstEnabledItem(reverseArray(composite.getState().renderedItems))) == null ? void 0 : _a22.id;
    },
    next: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("next", options2);
    },
    previous: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("previous", options2);
    },
    down: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("down", options2);
    },
    up: (options2) => {
      if (options2 !== void 0 && typeof options2 === "number") {
        options2 = { skip: options2 };
      }
      return getNextId("up", options2);
    }
  };
}
function useCompositeStoreOptions(props2) {
  const id2 = useId(props2.id);
  return { id: id2, ...props2 };
}
function useCompositeStoreProps(store2, update, props2) {
  store2 = useCollectionStoreProps(store2, update, props2);
  useStoreProps(store2, props2, "activeId", "setActiveId");
  useStoreProps(store2, props2, "includesBaseElement");
  useStoreProps(store2, props2, "virtualFocus");
  useStoreProps(store2, props2, "orientation");
  useStoreProps(store2, props2, "rtl");
  useStoreProps(store2, props2, "focusLoop");
  useStoreProps(store2, props2, "focusWrap");
  useStoreProps(store2, props2, "focusShift");
  return store2;
}
var ComboboxListRoleContext = createContext(
  void 0
);
var ctx$1 = createStoreContext(
  [PopoverContextProvider, CompositeContextProvider],
  [PopoverScopedContextProvider, CompositeScopedContextProvider]
);
var useComboboxContext = ctx$1.useContext;
var useComboboxScopedContext = ctx$1.useScopedContext;
var useComboboxProviderContext = ctx$1.useProviderContext;
var ComboboxContextProvider = ctx$1.ContextProvider;
var ComboboxScopedContextProvider = ctx$1.ScopedContextProvider;
var ComboboxItemValueContext = createContext(
  void 0
);
var ComboboxItemCheckedContext = createContext(false);
function createTabStore({
  composite: parentComposite,
  combobox,
  ...props2
} = {}) {
  const independentKeys = [
    "items",
    "renderedItems",
    "moves",
    "orientation",
    "virtualFocus",
    "includesBaseElement",
    "baseElement",
    "focusLoop",
    "focusShift",
    "focusWrap"
  ];
  const store2 = mergeStore(
    props2.store,
    omit2(parentComposite, independentKeys),
    omit2(combobox, independentKeys)
  );
  const syncState = store2 == null ? void 0 : store2.getState();
  const composite = createCompositeStore({
    ...props2,
    store: store2,
    // We need to explicitly set the default value of `includesBaseElement` to
    // `false` since we don't want the composite store to default it to `true`
    // when the activeId state is null, which could be the case when rendering
    // combobox with tab.
    includesBaseElement: defaultValue(
      props2.includesBaseElement,
      syncState == null ? void 0 : syncState.includesBaseElement,
      false
    ),
    orientation: defaultValue(
      props2.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "horizontal"
    ),
    focusLoop: defaultValue(props2.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  });
  const panels = createCollectionStore();
  const initialState2 = {
    ...composite.getState(),
    selectedId: defaultValue(
      props2.selectedId,
      syncState == null ? void 0 : syncState.selectedId,
      props2.defaultSelectedId
    ),
    selectOnMove: defaultValue(
      props2.selectOnMove,
      syncState == null ? void 0 : syncState.selectOnMove,
      true
    )
  };
  const tab2 = createStore(initialState2, composite, store2);
  setup(
    tab2,
    () => sync(tab2, ["moves"], () => {
      const { activeId, selectOnMove } = tab2.getState();
      if (!selectOnMove) return;
      if (!activeId) return;
      const tabItem = composite.item(activeId);
      if (!tabItem) return;
      if (tabItem.dimmed) return;
      if (tabItem.disabled) return;
      tab2.setState("selectedId", tabItem.id);
    })
  );
  let syncActiveId = true;
  setup(
    tab2,
    () => batch(tab2, ["selectedId"], (state, prev) => {
      if (!syncActiveId) {
        syncActiveId = true;
        return;
      }
      if (parentComposite && state.selectedId === prev.selectedId) return;
      tab2.setState("activeId", state.selectedId);
    })
  );
  setup(
    tab2,
    () => sync(tab2, ["selectedId", "renderedItems"], (state) => {
      if (state.selectedId !== void 0) return;
      const { activeId, renderedItems } = tab2.getState();
      const tabItem = composite.item(activeId);
      if (tabItem && !tabItem.disabled && !tabItem.dimmed) {
        tab2.setState("selectedId", tabItem.id);
      } else {
        const tabItem2 = renderedItems.find(
          (item) => !item.disabled && !item.dimmed
        );
        tab2.setState("selectedId", tabItem2 == null ? void 0 : tabItem2.id);
      }
    })
  );
  setup(
    tab2,
    () => sync(tab2, ["renderedItems"], (state) => {
      const tabs = state.renderedItems;
      if (!tabs.length) return;
      return sync(panels, ["renderedItems"], (state2) => {
        const items = state2.renderedItems;
        const hasOrphanPanels = items.some((panel) => !panel.tabId);
        if (!hasOrphanPanels) return;
        items.forEach((panel, i2) => {
          if (panel.tabId) return;
          const tabItem = tabs[i2];
          if (!tabItem) return;
          panels.renderItem({ ...panel, tabId: tabItem.id });
        });
      });
    })
  );
  let selectedIdFromSelectedValue = null;
  setup(tab2, () => {
    const backupSelectedId = () => {
      selectedIdFromSelectedValue = tab2.getState().selectedId;
    };
    const restoreSelectedId = () => {
      syncActiveId = false;
      tab2.setState("selectedId", selectedIdFromSelectedValue);
    };
    if (parentComposite && "setSelectElement" in parentComposite) {
      return chain(
        sync(parentComposite, ["value"], backupSelectedId),
        sync(parentComposite, ["mounted"], restoreSelectedId)
      );
    }
    if (!combobox) return;
    return chain(
      sync(combobox, ["selectedValue"], backupSelectedId),
      sync(combobox, ["mounted"], restoreSelectedId)
    );
  });
  return {
    ...composite,
    ...tab2,
    panels,
    setSelectedId: (id2) => tab2.setState("selectedId", id2),
    select: (id2) => {
      tab2.setState("selectedId", id2);
      composite.move(id2);
    }
  };
}
function useTabStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.composite, props2.combobox]);
  store2 = useCompositeStoreProps(store2, update, props2);
  useStoreProps(store2, props2, "selectedId", "setSelectedId");
  useStoreProps(store2, props2, "selectOnMove");
  const [panels, updatePanels] = useStore(() => store2.panels, {});
  useUpdateEffect(updatePanels, [store2, updatePanels]);
  return Object.assign(
    useMemo(() => ({ ...store2, panels }), [store2, panels]),
    { composite: props2.composite, combobox: props2.combobox }
  );
}
function useTabStore(props2 = {}) {
  const combobox = useComboboxContext();
  const composite = useSelectContext() || combobox;
  props2 = {
    ...props2,
    composite: props2.composite !== void 0 ? props2.composite : composite,
    combobox: props2.combobox !== void 0 ? props2.combobox : combobox
  };
  const [store2, update] = useStore(createTabStore, props2);
  return useTabStoreProps(store2, update, props2);
}
function TabProvider(props2 = {}) {
  const store2 = useTabStore(props2);
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabContextProvider, { value: store2, children: props2.children });
}
var PortalContext = createContext(null);
var TagName$m = "span";
var useVisuallyHidden = createHook(
  function useVisuallyHidden2(props2) {
    props2 = {
      ...props2,
      style: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px",
        ...props2.style
      }
    };
    return props2;
  }
);
forwardRef2(function VisuallyHidden2(props2) {
  const htmlProps = useVisuallyHidden(props2);
  return createElement(TagName$m, htmlProps);
});
var TagName$l = "span";
var useFocusTrap = createHook(
  function useFocusTrap2(props2) {
    props2 = {
      "data-focus-trap": "",
      tabIndex: 0,
      "aria-hidden": true,
      ...props2,
      style: {
        // Prevents unintended scroll jumps.
        position: "fixed",
        top: 0,
        left: 0,
        ...props2.style
      }
    };
    props2 = useVisuallyHidden(props2);
    return props2;
  }
);
var FocusTrap = forwardRef2(function FocusTrap2(props2) {
  const htmlProps = useFocusTrap(props2);
  return createElement(TagName$l, htmlProps);
});
var TagName$k = "div";
function getRootElement(element2) {
  return getDocument(element2).body;
}
function getPortalElement(element2, portalElement) {
  if (!portalElement) {
    return getDocument(element2).createElement("div");
  }
  if (typeof portalElement === "function") {
    return portalElement(element2);
  }
  return portalElement;
}
function getRandomId(prefix = "id") {
  return `${prefix ? `${prefix}-` : ""}${Math.random().toString(36).slice(2, 8)}`;
}
function queueFocus(element2) {
  queueMicrotask(() => {
    element2 == null ? void 0 : element2.focus();
  });
}
var usePortal = createHook(function usePortal2({
  preserveTabOrder,
  preserveTabOrderAnchor,
  portalElement,
  portalRef,
  portal = true,
  ...props2
}) {
  const ref = useRef(null);
  const refProp = useMergeRefs(ref, props2.ref);
  const context = useContext(PortalContext);
  const [portalNode, setPortalNode] = useState(null);
  const [anchorPortalNode, setAnchorPortalNode] = useState(
    null
  );
  const outerBeforeRef = useRef(null);
  const innerBeforeRef = useRef(null);
  const innerAfterRef = useRef(null);
  const outerAfterRef = useRef(null);
  useSafeLayoutEffect(() => {
    const element2 = ref.current;
    if (!element2 || !portal) {
      setPortalNode(null);
      return;
    }
    const portalEl = getPortalElement(element2, portalElement);
    if (!portalEl) {
      setPortalNode(null);
      return;
    }
    const isPortalInDocument = portalEl.isConnected;
    if (!isPortalInDocument) {
      const rootElement = context || getRootElement(element2);
      rootElement.appendChild(portalEl);
    }
    if (!portalEl.id) {
      portalEl.id = element2.id ? `portal/${element2.id}` : getRandomId();
    }
    setPortalNode(portalEl);
    setRef(portalRef, portalEl);
    if (isPortalInDocument) return;
    return () => {
      portalEl.remove();
      setRef(portalRef, null);
    };
  }, [portal, portalElement, context, portalRef]);
  useSafeLayoutEffect(() => {
    if (!portal) return;
    if (!preserveTabOrder) return;
    if (!preserveTabOrderAnchor) return;
    const doc2 = getDocument(preserveTabOrderAnchor);
    const element2 = doc2.createElement("span");
    element2.style.position = "fixed";
    preserveTabOrderAnchor.insertAdjacentElement("afterend", element2);
    setAnchorPortalNode(element2);
    return () => {
      element2.remove();
      setAnchorPortalNode(null);
    };
  }, [portal, preserveTabOrder, preserveTabOrderAnchor]);
  useEffect(() => {
    if (!portalNode) return;
    if (!preserveTabOrder) return;
    let raf = 0;
    const onFocus = (event) => {
      if (!isFocusEventOutside(event)) return;
      const focusing = event.type === "focusin";
      cancelAnimationFrame(raf);
      if (focusing) {
        return restoreFocusIn(portalNode);
      }
      raf = requestAnimationFrame(() => {
        disableFocusIn(portalNode, true);
      });
    };
    portalNode.addEventListener("focusin", onFocus, true);
    portalNode.addEventListener("focusout", onFocus, true);
    return () => {
      cancelAnimationFrame(raf);
      portalNode.removeEventListener("focusin", onFocus, true);
      portalNode.removeEventListener("focusout", onFocus, true);
    };
  }, [portalNode, preserveTabOrder]);
  props2 = useWrapElement(
    props2,
    (element2) => {
      element2 = // While the portal node is not in the DOM, we need to pass the
      // current context to the portal context, otherwise it's going to
      // reset to the body element on nested portals.
      /* @__PURE__ */ jsxRuntimeExports$3.jsx(PortalContext.Provider, { value: portalNode || context, children: element2 });
      if (!portal) return element2;
      if (!portalNode) {
        return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          "span",
          {
            ref: refProp,
            id: props2.id,
            style: { position: "fixed" },
            hidden: true
          }
        );
      }
      element2 = /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        preserveTabOrder && portalNode && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          FocusTrap,
          {
            ref: innerBeforeRef,
            "data-focus-trap": props2.id,
            className: "__focus-trap-inner-before",
            onFocus: (event) => {
              if (isFocusEventOutside(event, portalNode)) {
                queueFocus(getNextTabbable());
              } else {
                queueFocus(outerBeforeRef.current);
              }
            }
          }
        ),
        element2,
        preserveTabOrder && portalNode && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          FocusTrap,
          {
            ref: innerAfterRef,
            "data-focus-trap": props2.id,
            className: "__focus-trap-inner-after",
            onFocus: (event) => {
              if (isFocusEventOutside(event, portalNode)) {
                queueFocus(getPreviousTabbable());
              } else {
                queueFocus(outerAfterRef.current);
              }
            }
          }
        )
      ] });
      if (portalNode) {
        element2 = createPortal(element2, portalNode);
      }
      let preserveTabOrderElement = /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        preserveTabOrder && portalNode && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          FocusTrap,
          {
            ref: outerBeforeRef,
            "data-focus-trap": props2.id,
            className: "__focus-trap-outer-before",
            onFocus: (event) => {
              const fromOuter = event.relatedTarget === outerAfterRef.current;
              if (!fromOuter && isFocusEventOutside(event, portalNode)) {
                queueFocus(innerBeforeRef.current);
              } else {
                queueFocus(getPreviousTabbable());
              }
            }
          }
        ),
        preserveTabOrder && // We're using position: fixed here so that the browser doesn't
        // add margin to the element when setting gap on a parent element.
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { "aria-owns": portalNode == null ? void 0 : portalNode.id, style: { position: "fixed" } }),
        preserveTabOrder && portalNode && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          FocusTrap,
          {
            ref: outerAfterRef,
            "data-focus-trap": props2.id,
            className: "__focus-trap-outer-after",
            onFocus: (event) => {
              if (isFocusEventOutside(event, portalNode)) {
                queueFocus(innerAfterRef.current);
              } else {
                const nextTabbable = getNextTabbable();
                if (nextTabbable === innerBeforeRef.current) {
                  requestAnimationFrame(() => {
                    var _a2;
                    return (_a2 = getNextTabbable()) == null ? void 0 : _a2.focus();
                  });
                  return;
                }
                queueFocus(nextTabbable);
              }
            }
          }
        )
      ] });
      if (anchorPortalNode && preserveTabOrder) {
        preserveTabOrderElement = createPortal(
          preserveTabOrderElement,
          anchorPortalNode
        );
      }
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        preserveTabOrderElement,
        element2
      ] });
    },
    [portalNode, context, portal, props2.id, preserveTabOrder, anchorPortalNode]
  );
  props2 = {
    ...props2,
    ref: refProp
  };
  return props2;
});
forwardRef2(function Portal2(props2) {
  const htmlProps = usePortal(props2);
  return createElement(TagName$k, htmlProps);
});
var HeadingContext = createContext(0);
function HeadingLevel({ level, children }) {
  const contextLevel = useContext(HeadingContext);
  const nextLevel = Math.max(
    Math.min(level || contextLevel + 1, 6),
    1
  );
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(HeadingContext.Provider, { value: nextLevel, children });
}
var TagName$j = "div";
var useFocusableContainer = createHook(function useFocusableContainer2({ autoFocusOnShow = true, ...props2 }) {
  props2 = useWrapElement(
    props2,
    (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(FocusableContext.Provider, { value: autoFocusOnShow, children: element2 }),
    [autoFocusOnShow]
  );
  return props2;
});
forwardRef2(function FocusableContainer2(props2) {
  const htmlProps = useFocusableContainer(props2);
  return createElement(TagName$j, htmlProps);
});
function prependHiddenDismiss(container, onClick) {
  const document2 = getDocument(container);
  const button = document2.createElement("button");
  button.type = "button";
  button.tabIndex = -1;
  button.textContent = "Dismiss popup";
  Object.assign(button.style, {
    border: "0px",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0px",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  });
  button.addEventListener("click", onClick);
  container.prepend(button);
  const removeHiddenDismiss = () => {
    button.removeEventListener("click", onClick);
    button.remove();
  };
  return removeHiddenDismiss;
}
function usePreviousMouseDownRef(enabled) {
  const previousMouseDownRef = useRef();
  useEffect(() => {
    if (!enabled) {
      previousMouseDownRef.current = null;
      return;
    }
    const onMouseDown = (event) => {
      previousMouseDownRef.current = event.target;
    };
    return addGlobalEventListener("mousedown", onMouseDown, true);
  }, [enabled]);
  return previousMouseDownRef;
}
var cleanups = /* @__PURE__ */ new WeakMap();
function orchestrate(element2, key, setup2) {
  if (!cleanups.has(element2)) {
    cleanups.set(element2, /* @__PURE__ */ new Map());
  }
  const elementCleanups = cleanups.get(element2);
  const prevCleanup = elementCleanups.get(key);
  if (!prevCleanup) {
    elementCleanups.set(key, setup2());
    return () => {
      var _a2;
      (_a2 = elementCleanups.get(key)) == null ? void 0 : _a2();
      elementCleanups.delete(key);
    };
  }
  const cleanup = setup2();
  const nextCleanup = () => {
    cleanup();
    prevCleanup();
    elementCleanups.delete(key);
  };
  elementCleanups.set(key, nextCleanup);
  return () => {
    const isCurrent = elementCleanups.get(key) === nextCleanup;
    if (!isCurrent) return;
    cleanup();
    elementCleanups.set(key, prevCleanup);
  };
}
function setAttribute(element2, attr, value) {
  const setup2 = () => {
    const previousValue = element2.getAttribute(attr);
    element2.setAttribute(attr, value);
    return () => {
      if (previousValue == null) {
        element2.removeAttribute(attr);
      } else {
        element2.setAttribute(attr, previousValue);
      }
    };
  };
  return orchestrate(element2, attr, setup2);
}
function setProperty(element2, property2, value) {
  const setup2 = () => {
    const exists = property2 in element2;
    const previousValue = element2[property2];
    element2[property2] = value;
    return () => {
      if (!exists) {
        delete element2[property2];
      } else {
        element2[property2] = previousValue;
      }
    };
  };
  return orchestrate(element2, property2, setup2);
}
function assignStyle(element2, style) {
  if (!element2) return () => {
  };
  const setup2 = () => {
    const prevStyle = element2.style.cssText;
    Object.assign(element2.style, style);
    return () => {
      element2.style.cssText = prevStyle;
    };
  };
  return orchestrate(element2, "style", setup2);
}
function setCSSProperty(element2, property2, value) {
  if (!element2) return () => {
  };
  const setup2 = () => {
    const previousValue = element2.style.getPropertyValue(property2);
    element2.style.setProperty(property2, value);
    return () => {
      if (previousValue) {
        element2.style.setProperty(property2, previousValue);
      } else {
        element2.style.removeProperty(property2);
      }
    };
  };
  return orchestrate(element2, property2, setup2);
}
var ignoreTags = ["SCRIPT", "STYLE"];
function getSnapshotPropertyName(id2) {
  return `__ariakit-dialog-snapshot-${id2}`;
}
function inSnapshot(id2, element2) {
  const doc2 = getDocument(element2);
  const propertyName2 = getSnapshotPropertyName(id2);
  if (!doc2.body[propertyName2]) return true;
  do {
    if (element2 === doc2.body) return false;
    if (element2[propertyName2]) return true;
    if (!element2.parentElement) return false;
    element2 = element2.parentElement;
  } while (true);
}
function isValidElement(id2, element2, ignoredElements) {
  if (ignoreTags.includes(element2.tagName)) return false;
  if (!inSnapshot(id2, element2)) return false;
  return !ignoredElements.some(
    (enabledElement) => enabledElement && contains$1(element2, enabledElement)
  );
}
function walkTreeOutside(id2, elements2, callback, ancestorCallback) {
  for (let element2 of elements2) {
    if (!(element2 == null ? void 0 : element2.isConnected)) continue;
    const hasAncestorAlready = elements2.some((maybeAncestor) => {
      if (!maybeAncestor) return false;
      if (maybeAncestor === element2) return false;
      return maybeAncestor.contains(element2);
    });
    const doc2 = getDocument(element2);
    const originalElement = element2;
    while (element2.parentElement && element2 !== doc2.body) {
      ancestorCallback == null ? void 0 : ancestorCallback(element2.parentElement, originalElement);
      if (!hasAncestorAlready) {
        for (const child of element2.parentElement.children) {
          if (isValidElement(id2, child, elements2)) {
            callback(child, originalElement);
          }
        }
      }
      element2 = element2.parentElement;
    }
  }
}
function createWalkTreeSnapshot(id2, elements2) {
  const { body } = getDocument(elements2[0]);
  const cleanups2 = [];
  const markElement2 = (element2) => {
    cleanups2.push(setProperty(element2, getSnapshotPropertyName(id2), true));
  };
  walkTreeOutside(id2, elements2, markElement2);
  return chain(setProperty(body, getSnapshotPropertyName(id2), true), () => {
    for (const cleanup of cleanups2) {
      cleanup();
    }
  });
}
function isBackdrop(element2, ...ids) {
  if (!element2) return false;
  const backdrop = element2.getAttribute("data-backdrop");
  if (backdrop == null) return false;
  if (backdrop === "") return true;
  if (backdrop === "true") return true;
  if (!ids.length) return true;
  return ids.some((id2) => backdrop === id2);
}
function getPropertyName(id2 = "", ancestor = false) {
  return `__ariakit-dialog-${ancestor ? "ancestor" : "outside"}${id2 ? `-${id2}` : ""}`;
}
function markElement(element2, id2 = "") {
  return chain(
    setProperty(element2, getPropertyName(), true),
    setProperty(element2, getPropertyName(id2), true)
  );
}
function markAncestor(element2, id2 = "") {
  return chain(
    setProperty(element2, getPropertyName("", true), true),
    setProperty(element2, getPropertyName(id2, true), true)
  );
}
function isElementMarked(element2, id2) {
  const ancestorProperty = getPropertyName(id2, true);
  if (element2[ancestorProperty]) return true;
  const elementProperty = getPropertyName(id2);
  do {
    if (element2[elementProperty]) return true;
    if (!element2.parentElement) return false;
    element2 = element2.parentElement;
  } while (true);
}
function markTreeOutside(id2, elements2) {
  const cleanups2 = [];
  const ids = elements2.map((el) => el == null ? void 0 : el.id);
  walkTreeOutside(
    id2,
    elements2,
    (element2) => {
      if (isBackdrop(element2, ...ids)) return;
      cleanups2.unshift(markElement(element2, id2));
    },
    (ancestor, element2) => {
      const isAnotherDialogAncestor = element2.hasAttribute("data-dialog") && element2.id !== id2;
      if (isAnotherDialogAncestor) return;
      cleanups2.unshift(markAncestor(ancestor, id2));
    }
  );
  const restoreAccessibilityTree = () => {
    for (const cleanup of cleanups2) {
      cleanup();
    }
  };
  return restoreAccessibilityTree;
}
function isInDocument(target) {
  if (target.tagName === "HTML") return true;
  return contains$1(getDocument(target).body, target);
}
function isDisclosure(disclosure, target) {
  if (!disclosure) return false;
  if (contains$1(disclosure, target)) return true;
  const activeId = target.getAttribute("aria-activedescendant");
  if (activeId) {
    const activeElement = getDocument(disclosure).getElementById(activeId);
    if (activeElement) {
      return contains$1(disclosure, activeElement);
    }
  }
  return false;
}
function isMouseEventOnDialog(event, dialog) {
  if (!("clientY" in event)) return false;
  const rect = dialog.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return false;
  return rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
}
function useEventOutside({
  store: store2,
  type,
  listener,
  capture,
  domReady
}) {
  const callListener = useEvent(listener);
  const open = useStoreState(store2, "open");
  const focusedRef = useRef(false);
  useSafeLayoutEffect(() => {
    if (!open) return;
    if (!domReady) return;
    const { contentElement } = store2.getState();
    if (!contentElement) return;
    const onFocus = () => {
      focusedRef.current = true;
    };
    contentElement.addEventListener("focusin", onFocus, true);
    return () => contentElement.removeEventListener("focusin", onFocus, true);
  }, [store2, open, domReady]);
  useEffect(() => {
    if (!open) return;
    const onEvent = (event) => {
      const { contentElement, disclosureElement } = store2.getState();
      const target = event.target;
      if (!contentElement) return;
      if (!target) return;
      if (!isInDocument(target)) return;
      if (contains$1(contentElement, target)) return;
      if (isDisclosure(disclosureElement, target)) return;
      if (target.hasAttribute("data-focus-trap")) return;
      if (isMouseEventOnDialog(event, contentElement)) return;
      const focused = focusedRef.current;
      if (focused && !isElementMarked(target, contentElement.id)) return;
      if (isSafariFocusAncestor(target)) return;
      callListener(event);
    };
    return addGlobalEventListener(type, onEvent, capture);
  }, [open, capture]);
}
function shouldHideOnInteractOutside(hideOnInteractOutside, event) {
  if (typeof hideOnInteractOutside === "function") {
    return hideOnInteractOutside(event);
  }
  return !!hideOnInteractOutside;
}
function useHideOnInteractOutside(store2, hideOnInteractOutside, domReady) {
  const open = useStoreState(store2, "open");
  const previousMouseDownRef = usePreviousMouseDownRef(open);
  const props2 = { store: store2, domReady, capture: true };
  useEventOutside({
    ...props2,
    type: "click",
    listener: (event) => {
      const { contentElement } = store2.getState();
      const previousMouseDown = previousMouseDownRef.current;
      if (!previousMouseDown) return;
      if (!isVisible(previousMouseDown)) return;
      if (!isElementMarked(previousMouseDown, contentElement == null ? void 0 : contentElement.id)) return;
      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) return;
      store2.hide();
    }
  });
  useEventOutside({
    ...props2,
    type: "focusin",
    listener: (event) => {
      const { contentElement } = store2.getState();
      if (!contentElement) return;
      if (event.target === getDocument(contentElement)) return;
      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) return;
      store2.hide();
    }
  });
  useEventOutside({
    ...props2,
    type: "contextmenu",
    listener: (event) => {
      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) return;
      store2.hide();
    }
  });
}
var NestedDialogsContext = createContext({});
function useNestedDialogs(store2) {
  const context = useContext(NestedDialogsContext);
  const [dialogs, setDialogs] = useState([]);
  const add2 = useCallback(
    (dialog) => {
      var _a2;
      setDialogs((dialogs2) => [...dialogs2, dialog]);
      return chain((_a2 = context.add) == null ? void 0 : _a2.call(context, dialog), () => {
        setDialogs((dialogs2) => dialogs2.filter((d) => d !== dialog));
      });
    },
    [context]
  );
  useSafeLayoutEffect(() => {
    return sync(store2, ["open", "contentElement"], (state) => {
      var _a2;
      if (!state.open) return;
      if (!state.contentElement) return;
      return (_a2 = context.add) == null ? void 0 : _a2.call(context, store2);
    });
  }, [store2, context]);
  const providerValue = useMemo(() => ({ store: store2, add: add2 }), [store2, add2]);
  const wrapElement = useCallback(
    (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(NestedDialogsContext.Provider, { value: providerValue, children: element2 }),
    [providerValue]
  );
  return { wrapElement, nestedDialogs: dialogs };
}
function useRootDialog({
  attribute,
  contentId,
  contentElement,
  enabled
}) {
  const [updated, retry] = useForceUpdate();
  const isRootDialog = useCallback(() => {
    if (!enabled) return false;
    if (!contentElement) return false;
    const { body } = getDocument(contentElement);
    const id2 = body.getAttribute(attribute);
    return !id2 || id2 === contentId;
  }, [updated, enabled, contentElement, attribute, contentId]);
  useEffect(() => {
    if (!enabled) return;
    if (!contentId) return;
    if (!contentElement) return;
    const { body } = getDocument(contentElement);
    if (isRootDialog()) {
      body.setAttribute(attribute, contentId);
      return () => body.removeAttribute(attribute);
    }
    const observer = new MutationObserver(() => flushSync(retry));
    observer.observe(body, { attributeFilter: [attribute] });
    return () => observer.disconnect();
  }, [updated, enabled, contentId, contentElement, isRootDialog, attribute]);
  return isRootDialog;
}
function getPaddingProperty(documentElement) {
  const documentLeft = documentElement.getBoundingClientRect().left;
  const scrollbarX = Math.round(documentLeft) + documentElement.scrollLeft;
  return scrollbarX ? "paddingLeft" : "paddingRight";
}
function usePreventBodyScroll(contentElement, contentId, enabled) {
  const isRootDialog = useRootDialog({
    attribute: "data-dialog-prevent-body-scroll",
    contentElement,
    contentId,
    enabled
  });
  useEffect(() => {
    if (!isRootDialog()) return;
    if (!contentElement) return;
    const doc2 = getDocument(contentElement);
    const win = getWindow$1(contentElement);
    const { documentElement, body } = doc2;
    const cssScrollbarWidth = documentElement.style.getPropertyValue("--scrollbar-width");
    const scrollbarWidth = cssScrollbarWidth ? Number.parseInt(cssScrollbarWidth, 10) : win.innerWidth - documentElement.clientWidth;
    const setScrollbarWidthProperty = () => setCSSProperty(
      documentElement,
      "--scrollbar-width",
      `${scrollbarWidth}px`
    );
    const paddingProperty = getPaddingProperty(documentElement);
    const setStyle = () => assignStyle(body, {
      overflow: "hidden",
      [paddingProperty]: `${scrollbarWidth}px`
    });
    const setIOSStyle = () => {
      var _a2, _b;
      const { scrollX, scrollY, visualViewport } = win;
      const offsetLeft = (_a2 = visualViewport == null ? void 0 : visualViewport.offsetLeft) != null ? _a2 : 0;
      const offsetTop = (_b = visualViewport == null ? void 0 : visualViewport.offsetTop) != null ? _b : 0;
      const restoreStyle = assignStyle(body, {
        position: "fixed",
        overflow: "hidden",
        top: `${-(scrollY - Math.floor(offsetTop))}px`,
        left: `${-(scrollX - Math.floor(offsetLeft))}px`,
        right: "0",
        [paddingProperty]: `${scrollbarWidth}px`
      });
      return () => {
        restoreStyle();
        if (process.env.NODE_ENV !== "test") {
          win.scrollTo({ left: scrollX, top: scrollY, behavior: "instant" });
        }
      };
    };
    const isIOS = isApple() && !isMac();
    return chain(
      setScrollbarWidthProperty(),
      isIOS ? setIOSStyle() : setStyle()
    );
  }, [isRootDialog, contentElement]);
}
function isFocusTrap(element2, ...ids) {
  if (!element2) return false;
  const attr = element2.getAttribute("data-focus-trap");
  if (attr == null) return false;
  if (!ids.length) return true;
  if (attr === "") return false;
  return ids.some((id2) => attr === id2);
}
function supportsInert() {
  return "inert" in HTMLElement.prototype;
}
function hideElementFromAccessibilityTree(element2) {
  return setAttribute(element2, "aria-hidden", "true");
}
function disableTree(element2, ignoredElements) {
  if (!("style" in element2)) return noop$1;
  if (supportsInert()) {
    return setProperty(element2, "inert", true);
  }
  const tabbableElements = getAllTabbableIn(element2, true);
  const enableElements = tabbableElements.map((element22) => {
    if (ignoredElements == null ? void 0 : ignoredElements.some((el) => el && contains$1(el, element22))) return noop$1;
    const restoreFocusMethod = orchestrate(element22, "focus", () => {
      element22.focus = noop$1;
      return () => {
        delete element22.focus;
      };
    });
    return chain(setAttribute(element22, "tabindex", "-1"), restoreFocusMethod);
  });
  return chain(
    ...enableElements,
    hideElementFromAccessibilityTree(element2),
    assignStyle(element2, {
      pointerEvents: "none",
      userSelect: "none",
      cursor: "default"
    })
  );
}
function disableTreeOutside(id2, elements2) {
  const cleanups2 = [];
  const ids = elements2.map((el) => el == null ? void 0 : el.id);
  walkTreeOutside(
    id2,
    elements2,
    (element2) => {
      if (isBackdrop(element2, ...ids)) return;
      if (isFocusTrap(element2, ...ids)) return;
      cleanups2.unshift(disableTree(element2, elements2));
    },
    (element2) => {
      if (!element2.hasAttribute("role")) return;
      if (elements2.some((el) => el && contains$1(el, element2))) return;
      cleanups2.unshift(setAttribute(element2, "role", "none"));
    }
  );
  const restoreTreeOutside = () => {
    for (const cleanup of cleanups2) {
      cleanup();
    }
  };
  return restoreTreeOutside;
}
var TagName$i = "div";
var elements = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "summary",
  "textarea",
  "ul",
  "svg"
];
createHook(
  function useRole2(props2) {
    return props2;
  }
);
var Role = forwardRef2(
  // @ts-expect-error
  function Role2(props2) {
    return createElement(TagName$i, props2);
  }
);
Object.assign(
  Role,
  elements.reduce((acc, element2) => {
    acc[element2] = forwardRef2(function Role3(props2) {
      return createElement(element2, props2);
    });
    return acc;
  }, {})
);
function DialogBackdrop({
  store: store2,
  backdrop,
  alwaysVisible,
  hidden
}) {
  const ref = useRef(null);
  const disclosure = useDisclosureStore({ disclosure: store2 });
  const contentElement = useStoreState(store2, "contentElement");
  useEffect(() => {
    const backdrop2 = ref.current;
    const dialog = contentElement;
    if (!backdrop2) return;
    if (!dialog) return;
    backdrop2.style.zIndex = getComputedStyle(dialog).zIndex;
  }, [contentElement]);
  useSafeLayoutEffect(() => {
    const id2 = contentElement == null ? void 0 : contentElement.id;
    if (!id2) return;
    const backdrop2 = ref.current;
    if (!backdrop2) return;
    return markAncestor(backdrop2, id2);
  }, [contentElement]);
  const props2 = useDisclosureContent({
    ref,
    store: disclosure,
    role: "presentation",
    "data-backdrop": (contentElement == null ? void 0 : contentElement.id) || "",
    alwaysVisible,
    hidden: hidden != null ? hidden : void 0,
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
  if (!backdrop) return null;
  if (isValidElement$1(backdrop)) {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Role, { ...props2, render: backdrop });
  }
  const Component = typeof backdrop !== "boolean" ? backdrop : "div";
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Role, { ...props2, render: /* @__PURE__ */ jsxRuntimeExports$3.jsx(Component, {}) });
}
function createDialogStore(props2 = {}) {
  return createDisclosureStore(props2);
}
function useDialogStoreProps(store2, update, props2) {
  return useDisclosureStoreProps(store2, update, props2);
}
function useDialogStore(props2 = {}) {
  const [store2, update] = useStore(createDialogStore, props2);
  return useDialogStoreProps(store2, update, props2);
}
var TagName$h = "div";
var isSafariBrowser = isSafari();
function isAlreadyFocusingAnotherElement(dialog) {
  const activeElement = getActiveElement();
  if (!activeElement) return false;
  if (dialog && contains$1(dialog, activeElement)) return false;
  if (isFocusable(activeElement)) return true;
  return false;
}
function getElementFromProp(prop, focusable = false) {
  if (!prop) return null;
  const element2 = "current" in prop ? prop.current : prop;
  if (!element2) return null;
  if (focusable) return isFocusable(element2) ? element2 : null;
  return element2;
}
var useDialog = createHook(function useDialog2({
  store: storeProp,
  open: openProp,
  onClose,
  focusable = true,
  modal = true,
  portal = !!modal,
  backdrop = !!modal,
  hideOnEscape = true,
  hideOnInteractOutside = true,
  getPersistentElements,
  preventBodyScroll = !!modal,
  autoFocusOnShow = true,
  autoFocusOnHide = true,
  initialFocus,
  finalFocus,
  unmountOnHide,
  unstable_treeSnapshotKey,
  ...props2
}) {
  const context = useDialogProviderContext();
  const ref = useRef(null);
  const store2 = useDialogStore({
    store: storeProp || context,
    open: openProp,
    setOpen(open2) {
      if (open2) return;
      const dialog = ref.current;
      if (!dialog) return;
      const event = new Event("close", { bubbles: false, cancelable: true });
      if (onClose) {
        dialog.addEventListener("close", onClose, { once: true });
      }
      dialog.dispatchEvent(event);
      if (!event.defaultPrevented) return;
      store2.setOpen(true);
    }
  });
  const { portalRef, domReady } = usePortalRef(portal, props2.portalRef);
  const preserveTabOrderProp = props2.preserveTabOrder;
  const preserveTabOrder = useStoreState(
    store2,
    (state) => preserveTabOrderProp && !modal && state.mounted
  );
  const id2 = useId(props2.id);
  const open = useStoreState(store2, "open");
  const mounted = useStoreState(store2, "mounted");
  const contentElement = useStoreState(store2, "contentElement");
  const hidden = isHidden(mounted, props2.hidden, props2.alwaysVisible);
  usePreventBodyScroll(contentElement, id2, preventBodyScroll && !hidden);
  useHideOnInteractOutside(store2, hideOnInteractOutside, domReady);
  const { wrapElement, nestedDialogs } = useNestedDialogs(store2);
  props2 = useWrapElement(props2, wrapElement, [wrapElement]);
  useSafeLayoutEffect(() => {
    if (!open) return;
    const dialog = ref.current;
    const activeElement = getActiveElement(dialog, true);
    if (!activeElement) return;
    if (activeElement.tagName === "BODY") return;
    if (dialog && contains$1(dialog, activeElement)) return;
    store2.setDisclosureElement(activeElement);
  }, [store2, open]);
  if (isSafariBrowser) {
    useEffect(() => {
      if (!mounted) return;
      const { disclosureElement } = store2.getState();
      if (!disclosureElement) return;
      if (!isButton(disclosureElement)) return;
      const onMouseDown = () => {
        let receivedFocus = false;
        const onFocus = () => {
          receivedFocus = true;
        };
        const options2 = { capture: true, once: true };
        disclosureElement.addEventListener("focusin", onFocus, options2);
        queueBeforeEvent(disclosureElement, "mouseup", () => {
          disclosureElement.removeEventListener("focusin", onFocus, true);
          if (receivedFocus) return;
          focusIfNeeded(disclosureElement);
        });
      };
      disclosureElement.addEventListener("mousedown", onMouseDown);
      return () => {
        disclosureElement.removeEventListener("mousedown", onMouseDown);
      };
    }, [store2, mounted]);
  }
  useEffect(() => {
    if (!mounted) return;
    if (!domReady) return;
    const dialog = ref.current;
    if (!dialog) return;
    const win = getWindow$1(dialog);
    const viewport = win.visualViewport || win;
    const setViewportHeight = () => {
      var _a2, _b;
      const height = (_b = (_a2 = win.visualViewport) == null ? void 0 : _a2.height) != null ? _b : win.innerHeight;
      dialog.style.setProperty("--dialog-viewport-height", `${height}px`);
    };
    setViewportHeight();
    viewport.addEventListener("resize", setViewportHeight);
    return () => {
      viewport.removeEventListener("resize", setViewportHeight);
    };
  }, [mounted, domReady]);
  useEffect(() => {
    if (!modal) return;
    if (!mounted) return;
    if (!domReady) return;
    const dialog = ref.current;
    if (!dialog) return;
    const existingDismiss = dialog.querySelector("[data-dialog-dismiss]");
    if (existingDismiss) return;
    return prependHiddenDismiss(dialog, store2.hide);
  }, [store2, modal, mounted, domReady]);
  useSafeLayoutEffect(() => {
    if (!supportsInert()) return;
    if (open) return;
    if (!mounted) return;
    if (!domReady) return;
    const dialog = ref.current;
    if (!dialog) return;
    return disableTree(dialog);
  }, [open, mounted, domReady]);
  const canTakeTreeSnapshot = open && domReady;
  useSafeLayoutEffect(() => {
    if (!id2) return;
    if (!canTakeTreeSnapshot) return;
    const dialog = ref.current;
    return createWalkTreeSnapshot(id2, [dialog]);
  }, [id2, canTakeTreeSnapshot, unstable_treeSnapshotKey]);
  const getPersistentElementsProp = useEvent(getPersistentElements);
  useSafeLayoutEffect(() => {
    if (!id2) return;
    if (!canTakeTreeSnapshot) return;
    const { disclosureElement } = store2.getState();
    const dialog = ref.current;
    const persistentElements = getPersistentElementsProp() || [];
    const allElements = [
      dialog,
      ...persistentElements,
      ...nestedDialogs.map((dialog2) => dialog2.getState().contentElement)
    ];
    if (modal) {
      return chain(
        markTreeOutside(id2, allElements),
        disableTreeOutside(id2, allElements)
      );
    }
    return markTreeOutside(id2, [disclosureElement, ...allElements]);
  }, [
    id2,
    store2,
    canTakeTreeSnapshot,
    getPersistentElementsProp,
    nestedDialogs,
    modal,
    unstable_treeSnapshotKey
  ]);
  const mayAutoFocusOnShow = !!autoFocusOnShow;
  const autoFocusOnShowProp = useBooleanEvent(autoFocusOnShow);
  const [autoFocusEnabled, setAutoFocusEnabled] = useState(false);
  useEffect(() => {
    if (!open) return;
    if (!mayAutoFocusOnShow) return;
    if (!domReady) return;
    if (!(contentElement == null ? void 0 : contentElement.isConnected)) return;
    const element2 = getElementFromProp(initialFocus, true) || // If no initial focus is specified, we try to focus the first element
    // with the autofocus attribute. If it's an Ariakit component, the
    // Focusable component will consume the autoFocus prop and add the
    // data-autofocus attribute to the element instead.
    contentElement.querySelector(
      "[data-autofocus=true],[autofocus]"
    ) || // We have to fallback to the first focusable element otherwise portaled
    // dialogs with preserveTabOrder set to true will not receive focus
    // properly because the elements aren't tabbable until the dialog receives
    // focus.
    getFirstTabbableIn(contentElement, true, portal && preserveTabOrder) || // Finally, we fallback to the dialog element itself.
    contentElement;
    const isElementFocusable = isFocusable(element2);
    if (!autoFocusOnShowProp(isElementFocusable ? element2 : null)) return;
    setAutoFocusEnabled(true);
    queueMicrotask(() => {
      element2.focus();
      if (!isSafariBrowser) return;
      if (!isElementFocusable) return;
      element2.scrollIntoView({ block: "nearest", inline: "nearest" });
    });
  }, [
    open,
    mayAutoFocusOnShow,
    domReady,
    contentElement,
    initialFocus,
    portal,
    preserveTabOrder,
    autoFocusOnShowProp
  ]);
  const mayAutoFocusOnHide = !!autoFocusOnHide;
  const autoFocusOnHideProp = useBooleanEvent(autoFocusOnHide);
  const [hasOpened, setHasOpened] = useState(false);
  useEffect(() => {
    if (!open) return;
    setHasOpened(true);
    return () => setHasOpened(false);
  }, [open]);
  const focusOnHide = useCallback(
    (dialog, retry = true) => {
      const { disclosureElement } = store2.getState();
      if (isAlreadyFocusingAnotherElement(dialog)) return;
      let element2 = getElementFromProp(finalFocus) || disclosureElement;
      if (element2 == null ? void 0 : element2.id) {
        const doc2 = getDocument(element2);
        const selector2 = `[aria-activedescendant="${element2.id}"]`;
        const composite = doc2.querySelector(selector2);
        if (composite) {
          element2 = composite;
        }
      }
      if (element2 && !isFocusable(element2)) {
        const maybeParentDialog = element2.closest("[data-dialog]");
        if (maybeParentDialog == null ? void 0 : maybeParentDialog.id) {
          const doc2 = getDocument(maybeParentDialog);
          const selector2 = `[aria-controls~="${maybeParentDialog.id}"]`;
          const control = doc2.querySelector(selector2);
          if (control) {
            element2 = control;
          }
        }
      }
      const isElementFocusable = element2 && isFocusable(element2);
      if (!isElementFocusable && retry) {
        requestAnimationFrame(() => focusOnHide(dialog, false));
        return;
      }
      if (!autoFocusOnHideProp(isElementFocusable ? element2 : null)) return;
      if (!isElementFocusable) return;
      element2 == null ? void 0 : element2.focus({ preventScroll: true });
    },
    [store2, finalFocus, autoFocusOnHideProp]
  );
  const focusedOnHideRef = useRef(false);
  useSafeLayoutEffect(() => {
    if (open) return;
    if (!hasOpened) return;
    if (!mayAutoFocusOnHide) return;
    const dialog = ref.current;
    focusedOnHideRef.current = true;
    focusOnHide(dialog);
  }, [open, hasOpened, domReady, mayAutoFocusOnHide, focusOnHide]);
  useEffect(() => {
    if (!hasOpened) return;
    if (!mayAutoFocusOnHide) return;
    const dialog = ref.current;
    return () => {
      if (focusedOnHideRef.current) {
        focusedOnHideRef.current = false;
        return;
      }
      focusOnHide(dialog);
    };
  }, [hasOpened, mayAutoFocusOnHide, focusOnHide]);
  const hideOnEscapeProp = useBooleanEvent(hideOnEscape);
  useEffect(() => {
    if (!domReady) return;
    if (!mounted) return;
    const onKeyDown = (event) => {
      if (event.key !== "Escape") return;
      if (event.defaultPrevented) return;
      const dialog = ref.current;
      if (!dialog) return;
      if (isElementMarked(dialog)) return;
      const target = event.target;
      if (!target) return;
      const { disclosureElement } = store2.getState();
      const isValidTarget = () => {
        if (target.tagName === "BODY") return true;
        if (contains$1(dialog, target)) return true;
        if (!disclosureElement) return true;
        if (contains$1(disclosureElement, target)) return true;
        return false;
      };
      if (!isValidTarget()) return;
      if (!hideOnEscapeProp(event)) return;
      store2.hide();
    };
    return addGlobalEventListener("keydown", onKeyDown, true);
  }, [store2, domReady, mounted, hideOnEscapeProp]);
  props2 = useWrapElement(
    props2,
    (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(HeadingLevel, { level: modal ? 1 : void 0, children: element2 }),
    [modal]
  );
  const hiddenProp = props2.hidden;
  const alwaysVisible = props2.alwaysVisible;
  props2 = useWrapElement(
    props2,
    (element2) => {
      if (!backdrop) return element2;
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          DialogBackdrop,
          {
            store: store2,
            backdrop,
            hidden: hiddenProp,
            alwaysVisible
          }
        ),
        element2
      ] });
    },
    [store2, backdrop, hiddenProp, alwaysVisible]
  );
  const [headingId, setHeadingId] = useState();
  const [descriptionId, setDescriptionId] = useState();
  props2 = useWrapElement(
    props2,
    (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogScopedContextProvider, { value: store2, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogHeadingContext.Provider, { value: setHeadingId, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogDescriptionContext.Provider, { value: setDescriptionId, children: element2 }) }) }),
    [store2]
  );
  props2 = {
    id: id2,
    "data-dialog": "",
    role: "dialog",
    tabIndex: focusable ? -1 : void 0,
    "aria-labelledby": headingId,
    "aria-describedby": descriptionId,
    ...props2,
    ref: useMergeRefs(ref, props2.ref)
  };
  props2 = useFocusableContainer({
    ...props2,
    autoFocusOnShow: autoFocusEnabled
  });
  props2 = useDisclosureContent({ store: store2, ...props2 });
  props2 = useFocusable({ ...props2, focusable });
  props2 = usePortal({ portal, ...props2, portalRef, preserveTabOrder });
  return props2;
});
function createDialogComponent(Component, useProviderContext = useDialogProviderContext) {
  return forwardRef2(function DialogComponent(props2) {
    const context = useProviderContext();
    const store2 = props2.store || context;
    const mounted = useStoreState(
      store2,
      (state) => !props2.unmountOnHide || (state == null ? void 0 : state.mounted) || !!props2.open
    );
    if (!mounted) return null;
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Component, { ...props2 });
  });
}
createDialogComponent(
  forwardRef2(function Dialog2(props2) {
    const htmlProps = useDialog(props2);
    return createElement(TagName$h, htmlProps);
  }),
  useDialogProviderContext
);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
const yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
const lrPlacement = ["left", "right"];
const rlPlacement = ["right", "left"];
const tbPlacement = ["top", "bottom"];
const btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list2 = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list2 = list2.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list2 = list2.concat(list2.map(getOppositeAlignmentPlacement));
    }
  }
  return list2;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x2,
    right: x2 + width,
    bottom: y + height,
    x: x2,
    y
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name: name2,
      fn
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x2,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name2]: {
        ...middlewareData[name2],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x: x2,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options2) {
  var _await$platform$isEle;
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    x: x2,
    y,
    platform: platform2,
    rects,
    elements: elements2,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext: elementContext2 = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options2, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext2 === "floating" ? "reference" : "floating";
  const element2 = elements2[altBoundary ? altContext : elementContext2];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element2))) != null ? _await$platform$isEle : true) ? element2 : element2.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements2.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext2 === "floating" ? {
    x: x2,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements2.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: elements2,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow$1 = (options2) => ({
  name: "arrow",
  options: options2,
  async fn(state) {
    const {
      x: x2,
      y,
      placement,
      rects,
      platform: platform2,
      elements: elements2,
      middlewareData
    } = state;
    const {
      element: element2,
      padding = 0
    } = evaluate(options2, state) || {};
    if (element2 == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x2,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element2);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element2));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements2.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$12 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$12, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length] / 2 - (center < min$12 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$12 ? center - min$12 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "flip",
    options: options2,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements: elements2
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options2, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d) => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b2) => a.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b2) => a[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
const originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options2) {
  const {
    placement,
    platform: platform2,
    elements: elements2
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options2, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$1 = function(options2) {
  if (options2 === void 0) {
    options2 = 0;
  }
  return {
    name: "offset",
    options: options2,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options2);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$2 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "shift",
    options: options2,
    async fn(state) {
      const {
        x: x2,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y2
            } = _ref;
            return {
              x: x3,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const coords = {
        x: x2,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
const limitShift$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    options: options2,
    fn(state) {
      const {
        x: x2,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset2 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options2, state);
      const coords = {
        x: x2,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset2, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = originSides.has(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
const size$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "size",
    options: options2,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements: elements2
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements2.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /* @__PURE__ */ new Set(["inline", "contents"]);
function isOverflowElement(element2) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element2);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
const tableElements = /* @__PURE__ */ new Set(["table", "td", "th"]);
function isTableElement(element2) {
  return tableElements.has(getNodeName(element2));
}
const topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element2) {
  return topLayerSelectors.some((selector2) => {
    try {
      return element2.matches(selector2);
    } catch (_e2) {
      return false;
    }
  });
}
const transformProperties = ["transform", "translate", "scale", "rotate", "perspective"];
const willChangeValues = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
const containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(elementOrCss) {
  const webkit2 = isWebKit();
  const css = isElement$1(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return transformProperties.some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit2 && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit2 && (css.filter ? css.filter !== "none" : false) || willChangeValues.some((value) => (css.willChange || "").includes(value)) || containValues.some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element2) {
  let currentNode = getParentNode(element2);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
const lastTraversableNodeNames = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle$1(element2) {
  return getWindow(element2).getComputedStyle(element2);
}
function getNodeScroll(element2) {
  if (isElement$1(element2)) {
    return {
      scrollLeft: element2.scrollLeft,
      scrollTop: element2.scrollTop
    };
  }
  return {
    scrollLeft: element2.scrollX,
    scrollTop: element2.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result2 = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result2) ? result2.host : result2;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list2, traverseIframes) {
  var _node$ownerDocument2;
  if (list2 === void 0) {
    list2 = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element2) {
  const css = getComputedStyle$1(element2);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element2);
  const offsetWidth = hasOffset ? element2.offsetWidth : width;
  const offsetHeight = hasOffset ? element2.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element2) {
  return !isElement$1(element2) ? element2.contextElement : element2;
}
function getScale$1(element2) {
  const domElement = unwrapElement(element2);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round(rect.width) : rect.width) / width;
  let y = ($2 ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x: x2,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element2) {
  const win = getWindow(element2);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element2, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element2)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element2, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element2.getBoundingClientRect();
  const domElement = unwrapElement(element2);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement$1(offsetParent)) {
        scale = getScale$1(offsetParent);
      }
    } else {
      scale = getScale$1(element2);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement$1(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale$1(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left;
      y += top2;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x2,
    y
  });
}
function getWindowScrollBarX(element2, rect) {
  const leftScroll = getNodeScroll(element2).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element2)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements: elements2,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements2 ? isTopLayer(elements2.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale$1(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element2) {
  return Array.from(element2.getClientRects());
}
function getDocumentRect(element2) {
  const html = getDocumentElement(element2);
  const scroll = getNodeScroll(element2);
  const body = element2.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element2);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y
  };
}
const SCROLLBAR_MAX = 25;
function getViewportRect(element2, strategy) {
  const win = getWindow(element2);
  const html = getDocumentElement(element2);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc2 = html.ownerDocument;
    const body = doc2.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc2.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x: x2,
    y
  };
}
const absoluteOrFixed = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect(element2, strategy) {
  const clientRect = getBoundingClientRect(element2, true, strategy === "fixed");
  const top2 = clientRect.top + element2.clientTop;
  const left = clientRect.left + element2.clientLeft;
  const scale = isHTMLElement(element2) ? getScale$1(element2) : createCoords(1);
  const width = element2.clientWidth * scale.x;
  const height = element2.clientHeight * scale.y;
  const x2 = left * scale.x;
  const y = top2 * scale.y;
  return {
    width,
    height,
    x: x2,
    y
  };
}
function getClientRectFromClippingAncestor(element2, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element2, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element2));
  } else if (isElement$1(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element2);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element2, stopNode) {
  const parentNode = getParentNode(element2);
  if (parentNode === stopNode || !isElement$1(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element2, cache) {
  const cachedResult = cache.get(element2);
  if (cachedResult) {
    return cachedResult;
  }
  let result2 = getOverflowAncestors(element2, [], false).filter((el) => isElement$1(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element2).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element2) : element2;
  while (isElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element2, currentNode);
    if (shouldDropCurrentNode) {
      result2 = result2.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element2, result2);
  return result2;
}
function getClippingRect(_ref) {
  let {
    element: element2,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element2) ? [] : getClippingElementAncestors(element2, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element2, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element2, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element2) {
  const {
    width,
    height
  } = getCssDimensions(element2);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element2, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element2, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element2) {
  return getComputedStyle$1(element2).position === "static";
}
function getTrueOffsetParent(element2, polyfill) {
  if (!isHTMLElement(element2) || getComputedStyle$1(element2).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element2);
  }
  let rawOffsetParent = element2.offsetParent;
  if (getDocumentElement(element2) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element2, polyfill) {
  const win = getWindow(element2);
  if (isTopLayer(element2)) {
    return win;
  }
  if (!isHTMLElement(element2)) {
    let svgOffsetParent = getParentNode(element2);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement$1(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element2, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element2) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element2) {
  return getComputedStyle$1(element2).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale: getScale$1,
  isElement: isElement$1,
  isRTL
};
function rectsAreEqual(a, b2) {
  return a.x === b2.x && a.y === b2.y && a.width === b2.width && a.height === b2.height;
}
function observeMove(element2, onMove) {
  let io2 = null;
  let timeoutId;
  const root2 = getDocumentElement(element2);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io2) == null || _io.disconnect();
    io2 = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element2.getBoundingClientRect();
    const {
      left,
      top: top2,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top2);
    const insetRight = floor(root2.clientWidth - (left + width));
    const insetBottom = floor(root2.clientHeight - (top2 + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options2 = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element2.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io2 = new IntersectionObserver(handleObserve, {
        ...options2,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (_e2) {
      io2 = new IntersectionObserver(handleObserve, options2);
    }
    io2.observe(element2);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options2;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset = offset$1;
const shift$1 = shift$2;
const flip = flip$1;
const size = size$1;
const arrow = arrow$1;
const limitShift = limitShift$1;
const computePosition = (reference, floating, options2) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options2
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
var TagName$g = "div";
function createDOMRect(x2 = 0, y = 0, width = 0, height = 0) {
  if (typeof DOMRect === "function") {
    return new DOMRect(x2, y, width, height);
  }
  const rect = {
    x: x2,
    y,
    width,
    height,
    top: y,
    right: x2 + width,
    bottom: y + height,
    left: x2
  };
  return { ...rect, toJSON: () => rect };
}
function getDOMRect(anchorRect) {
  if (!anchorRect) return createDOMRect();
  const { x: x2, y, width, height } = anchorRect;
  return createDOMRect(x2, y, width, height);
}
function getAnchorElement(anchorElement, getAnchorRect) {
  const contextElement = anchorElement || void 0;
  return {
    contextElement,
    getBoundingClientRect: () => {
      const anchor = anchorElement;
      const anchorRect = getAnchorRect == null ? void 0 : getAnchorRect(anchor);
      if (anchorRect || !anchor) {
        return getDOMRect(anchorRect);
      }
      return anchor.getBoundingClientRect();
    }
  };
}
function isValidPlacement(flip2) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(flip2);
}
function roundByDPR(value) {
  const dpr = window.devicePixelRatio || 1;
  return Math.round(value * dpr) / dpr;
}
function getOffsetMiddleware(arrowElement, props2) {
  return offset(({ placement }) => {
    var _a2;
    const arrowOffset = ((arrowElement == null ? void 0 : arrowElement.clientHeight) || 0) / 2;
    const finalGutter = typeof props2.gutter === "number" ? props2.gutter + arrowOffset : (_a2 = props2.gutter) != null ? _a2 : arrowOffset;
    const hasAlignment = !!placement.split("-")[1];
    return {
      crossAxis: !hasAlignment ? props2.shift : void 0,
      mainAxis: finalGutter,
      alignmentAxis: props2.shift
    };
  });
}
function getFlipMiddleware(props2) {
  if (props2.flip === false) return;
  const fallbackPlacements = typeof props2.flip === "string" ? props2.flip.split(" ") : void 0;
  invariant(
    !fallbackPlacements || fallbackPlacements.every(isValidPlacement),
    process.env.NODE_ENV !== "production" && "`flip` expects a spaced-delimited list of placements"
  );
  return flip({
    padding: props2.overflowPadding,
    fallbackPlacements
  });
}
function getShiftMiddleware(props2) {
  if (!props2.slide && !props2.overlap) return;
  return shift$1({
    mainAxis: props2.slide,
    crossAxis: props2.overlap,
    padding: props2.overflowPadding,
    limiter: limitShift()
  });
}
function getSizeMiddleware(props2) {
  return size({
    padding: props2.overflowPadding,
    apply({ elements: elements2, availableWidth, availableHeight, rects }) {
      const wrapper = elements2.floating;
      const referenceWidth = Math.round(rects.reference.width);
      availableWidth = Math.floor(availableWidth);
      availableHeight = Math.floor(availableHeight);
      wrapper.style.setProperty(
        "--popover-anchor-width",
        `${referenceWidth}px`
      );
      wrapper.style.setProperty(
        "--popover-available-width",
        `${availableWidth}px`
      );
      wrapper.style.setProperty(
        "--popover-available-height",
        `${availableHeight}px`
      );
      if (props2.sameWidth) {
        wrapper.style.width = `${referenceWidth}px`;
      }
      if (props2.fitViewport) {
        wrapper.style.maxWidth = `${availableWidth}px`;
        wrapper.style.maxHeight = `${availableHeight}px`;
      }
    }
  });
}
function getArrowMiddleware(arrowElement, props2) {
  if (!arrowElement) return;
  return arrow({
    element: arrowElement,
    padding: props2.arrowPadding
  });
}
var usePopover = createHook(
  function usePopover2({
    store: store2,
    modal = false,
    portal = !!modal,
    preserveTabOrder = true,
    autoFocusOnShow = true,
    wrapperProps,
    fixed = false,
    flip: flip2 = true,
    shift: shift2 = 0,
    slide = true,
    overlap = false,
    sameWidth = false,
    fitViewport = false,
    gutter: gutter2,
    arrowPadding = 4,
    overflowPadding = 8,
    getAnchorRect,
    updatePosition,
    ...props2
  }) {
    const context = usePopoverProviderContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "Popover must receive a `store` prop or be wrapped in a PopoverProvider component."
    );
    const arrowElement = store2.useState("arrowElement");
    const anchorElement = store2.useState("anchorElement");
    const disclosureElement = store2.useState("disclosureElement");
    const popoverElement = store2.useState("popoverElement");
    const contentElement = store2.useState("contentElement");
    const placement = store2.useState("placement");
    const mounted = store2.useState("mounted");
    const rendered = store2.useState("rendered");
    const defaultArrowElementRef = useRef(null);
    const [positioned, setPositioned] = useState(false);
    const { portalRef, domReady } = usePortalRef(portal, props2.portalRef);
    const getAnchorRectProp = useEvent(getAnchorRect);
    const updatePositionProp = useEvent(updatePosition);
    const hasCustomUpdatePosition = !!updatePosition;
    useSafeLayoutEffect(() => {
      if (!(popoverElement == null ? void 0 : popoverElement.isConnected)) return;
      popoverElement.style.setProperty(
        "--popover-overflow-padding",
        `${overflowPadding}px`
      );
      const anchor = getAnchorElement(anchorElement, getAnchorRectProp);
      const updatePosition2 = async () => {
        if (!mounted) return;
        if (!arrowElement) {
          defaultArrowElementRef.current = defaultArrowElementRef.current || document.createElement("div");
        }
        const arrow2 = arrowElement || defaultArrowElementRef.current;
        const middleware = [
          getOffsetMiddleware(arrow2, { gutter: gutter2, shift: shift2 }),
          getFlipMiddleware({ flip: flip2, overflowPadding }),
          getShiftMiddleware({ slide, overlap, overflowPadding }),
          getArrowMiddleware(arrow2, { arrowPadding }),
          getSizeMiddleware({
            sameWidth,
            fitViewport,
            overflowPadding
          })
        ];
        const pos = await computePosition(anchor, popoverElement, {
          placement,
          strategy: fixed ? "fixed" : "absolute",
          middleware
        });
        store2 == null ? void 0 : store2.setState("currentPlacement", pos.placement);
        setPositioned(true);
        const x2 = roundByDPR(pos.x);
        const y = roundByDPR(pos.y);
        Object.assign(popoverElement.style, {
          top: "0",
          left: "0",
          transform: `translate3d(${x2}px,${y}px,0)`
        });
        if (arrow2 && pos.middlewareData.arrow) {
          const { x: arrowX, y: arrowY } = pos.middlewareData.arrow;
          const side = pos.placement.split("-")[0];
          const centerX = arrow2.clientWidth / 2;
          const centerY = arrow2.clientHeight / 2;
          const originX = arrowX != null ? arrowX + centerX : -centerX;
          const originY = arrowY != null ? arrowY + centerY : -centerY;
          popoverElement.style.setProperty(
            "--popover-transform-origin",
            {
              top: `${originX}px calc(100% + ${centerY}px)`,
              bottom: `${originX}px ${-centerY}px`,
              left: `calc(100% + ${centerX}px) ${originY}px`,
              right: `${-centerX}px ${originY}px`
            }[side]
          );
          Object.assign(arrow2.style, {
            left: arrowX != null ? `${arrowX}px` : "",
            top: arrowY != null ? `${arrowY}px` : "",
            [side]: "100%"
          });
        }
      };
      const update = async () => {
        if (hasCustomUpdatePosition) {
          await updatePositionProp({ updatePosition: updatePosition2 });
          setPositioned(true);
        } else {
          await updatePosition2();
        }
      };
      const cancelAutoUpdate = autoUpdate(anchor, popoverElement, update, {
        // JSDOM doesn't support ResizeObserver
        elementResize: typeof ResizeObserver === "function"
      });
      return () => {
        setPositioned(false);
        cancelAutoUpdate();
      };
    }, [
      store2,
      rendered,
      popoverElement,
      arrowElement,
      anchorElement,
      popoverElement,
      placement,
      mounted,
      domReady,
      fixed,
      flip2,
      shift2,
      slide,
      overlap,
      sameWidth,
      fitViewport,
      gutter2,
      arrowPadding,
      overflowPadding,
      getAnchorRectProp,
      hasCustomUpdatePosition,
      updatePositionProp
    ]);
    useSafeLayoutEffect(() => {
      if (!mounted) return;
      if (!domReady) return;
      if (!(popoverElement == null ? void 0 : popoverElement.isConnected)) return;
      if (!(contentElement == null ? void 0 : contentElement.isConnected)) return;
      const applyZIndex = () => {
        popoverElement.style.zIndex = getComputedStyle(contentElement).zIndex;
      };
      applyZIndex();
      let raf = requestAnimationFrame(() => {
        raf = requestAnimationFrame(applyZIndex);
      });
      return () => cancelAnimationFrame(raf);
    }, [mounted, domReady, popoverElement, contentElement]);
    const position2 = fixed ? "fixed" : "absolute";
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        "div",
        {
          ...wrapperProps,
          style: {
            // https://floating-ui.com/docs/computeposition#initial-layout
            position: position2,
            top: 0,
            left: 0,
            width: "max-content",
            ...wrapperProps == null ? void 0 : wrapperProps.style
          },
          ref: store2 == null ? void 0 : store2.setPopoverElement,
          children: element2
        }
      ),
      [store2, position2, wrapperProps]
    );
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(PopoverScopedContextProvider, { value: store2, children: element2 }),
      [store2]
    );
    props2 = {
      // data-placing is not part of the public API. We're setting this here so
      // we can wait for the popover to be positioned before other components
      // move focus into it. For example, this attribute is observed by the
      // Combobox component with the autoSelect behavior.
      "data-placing": !positioned || void 0,
      ...props2,
      style: {
        position: "relative",
        ...props2.style
      }
    };
    props2 = useDialog({
      store: store2,
      modal,
      portal,
      preserveTabOrder,
      preserveTabOrderAnchor: disclosureElement || anchorElement,
      autoFocusOnShow: positioned && autoFocusOnShow,
      ...props2,
      portalRef
    });
    return props2;
  }
);
createDialogComponent(
  forwardRef2(function Popover2(props2) {
    const htmlProps = usePopover(props2);
    return createElement(TagName$g, htmlProps);
  }),
  usePopoverProviderContext
);
function createPopoverStore({
  popover: otherPopover,
  ...props2
} = {}) {
  const store2 = mergeStore(
    props2.store,
    omit2(otherPopover, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  throwOnConflictingProps(props2, store2);
  const syncState = store2 == null ? void 0 : store2.getState();
  const dialog = createDialogStore({ ...props2, store: store2 });
  const placement = defaultValue(
    props2.placement,
    syncState == null ? void 0 : syncState.placement,
    "bottom"
  );
  const initialState2 = {
    ...dialog.getState(),
    placement,
    currentPlacement: placement,
    anchorElement: defaultValue(syncState == null ? void 0 : syncState.anchorElement, null),
    popoverElement: defaultValue(syncState == null ? void 0 : syncState.popoverElement, null),
    arrowElement: defaultValue(syncState == null ? void 0 : syncState.arrowElement, null),
    rendered: Symbol("rendered")
  };
  const popover = createStore(initialState2, dialog, store2);
  return {
    ...dialog,
    ...popover,
    setAnchorElement: (element2) => popover.setState("anchorElement", element2),
    setPopoverElement: (element2) => popover.setState("popoverElement", element2),
    setArrowElement: (element2) => popover.setState("arrowElement", element2),
    render: () => popover.setState("rendered", Symbol("rendered"))
  };
}
function usePopoverStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.popover]);
  useStoreProps(store2, props2, "placement");
  return useDialogStoreProps(store2, update, props2);
}
var TagName$f = "div";
var usePopoverAnchor = createHook(
  function usePopoverAnchor2({ store: store2, ...props2 }) {
    const context = usePopoverProviderContext();
    store2 = store2 || context;
    props2 = {
      ...props2,
      ref: useMergeRefs(store2 == null ? void 0 : store2.setAnchorElement, props2.ref)
    };
    return props2;
  }
);
forwardRef2(function PopoverAnchor2(props2) {
  const htmlProps = usePopoverAnchor(props2);
  return createElement(TagName$f, htmlProps);
});
var TagName$e = "button";
var useButton = createHook(
  function useButton22(props2) {
    const ref = useRef(null);
    const tagName = useTagName(ref, TagName$e);
    const [isNativeButton, setIsNativeButton] = useState(
      () => !!tagName && isButton({ tagName, type: props2.type })
    );
    useEffect(() => {
      if (!ref.current) return;
      setIsNativeButton(isButton(ref.current));
    }, []);
    props2 = {
      role: !isNativeButton && tagName !== "a" ? "button" : void 0,
      ...props2,
      ref: useMergeRefs(ref, props2.ref)
    };
    props2 = useCommand(props2);
    return props2;
  }
);
var Button = forwardRef2(function Button22(props2) {
  const htmlProps = useButton(props2);
  return createElement(TagName$e, htmlProps);
});
var TagName$d = "button";
var symbol$1 = Symbol("disclosure");
var useDisclosure = createHook(
  function useDisclosure2({ store: store2, toggleOnClick = true, ...props2 }) {
    const context = useDisclosureProviderContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "Disclosure must receive a `store` prop or be wrapped in a DisclosureProvider component."
    );
    const ref = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const disclosureElement = store2.useState("disclosureElement");
    const open = store2.useState("open");
    useEffect(() => {
      let isCurrentDisclosure = disclosureElement === ref.current;
      if (!(disclosureElement == null ? void 0 : disclosureElement.isConnected)) {
        store2 == null ? void 0 : store2.setDisclosureElement(ref.current);
        isCurrentDisclosure = true;
      }
      setExpanded(open && isCurrentDisclosure);
    }, [disclosureElement, store2, open]);
    const onClickProp = props2.onClick;
    const toggleOnClickProp = useBooleanEvent(toggleOnClick);
    const [isDuplicate, metadataProps] = useMetadataProps(props2, symbol$1, true);
    const onClick = useEvent((event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (isDuplicate) return;
      if (!toggleOnClickProp(event)) return;
      store2 == null ? void 0 : store2.setDisclosureElement(event.currentTarget);
      store2 == null ? void 0 : store2.toggle();
    });
    const contentElement = store2.useState("contentElement");
    props2 = {
      "aria-expanded": expanded,
      "aria-controls": contentElement == null ? void 0 : contentElement.id,
      ...metadataProps,
      ...props2,
      ref: useMergeRefs(ref, props2.ref),
      onClick
    };
    props2 = useButton(props2);
    return props2;
  }
);
forwardRef2(function Disclosure2(props2) {
  const htmlProps = useDisclosure(props2);
  return createElement(TagName$d, htmlProps);
});
var TagName$c = "button";
var useDialogDisclosure = createHook(
  function useDialogDisclosure2({ store: store2, ...props2 }) {
    const context = useDialogProviderContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "DialogDisclosure must receive a `store` prop or be wrapped in a DialogProvider component."
    );
    const contentElement = store2.useState("contentElement");
    props2 = {
      "aria-haspopup": getPopupRole(contentElement, "dialog"),
      ...props2
    };
    props2 = useDisclosure({ store: store2, ...props2 });
    return props2;
  }
);
forwardRef2(function DialogDisclosure2(props2) {
  const htmlProps = useDialogDisclosure(props2);
  return createElement(TagName$c, htmlProps);
});
var TagName$b = "button";
var usePopoverDisclosure = createHook(function usePopoverDisclosure2({ store: store2, ...props2 }) {
  const context = usePopoverProviderContext();
  store2 = store2 || context;
  invariant(
    store2,
    process.env.NODE_ENV !== "production" && "PopoverDisclosure must receive a `store` prop or be wrapped in a PopoverProvider component."
  );
  const onClickProp = props2.onClick;
  const onClick = useEvent((event) => {
    store2 == null ? void 0 : store2.setAnchorElement(event.currentTarget);
    onClickProp == null ? void 0 : onClickProp(event);
  });
  props2 = useWrapElement(
    props2,
    (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(PopoverScopedContextProvider, { value: store2, children: element2 }),
    [store2]
  );
  props2 = {
    ...props2,
    onClick
  };
  props2 = usePopoverAnchor({ store: store2, ...props2 });
  props2 = useDialogDisclosure({ store: store2, ...props2 });
  return props2;
});
forwardRef2(function PopoverDisclosure2(props2) {
  const htmlProps = usePopoverDisclosure(props2);
  return createElement(TagName$b, htmlProps);
});
var TagName$a = "span";
var pointsMap = {
  top: "4,10 8,6 12,10",
  right: "6,4 10,8 6,12",
  bottom: "4,6 8,10 12,6",
  left: "10,4 6,8 10,12"
};
var usePopoverDisclosureArrow = createHook(function usePopoverDisclosureArrow2({ store: store2, placement, ...props2 }) {
  const context = usePopoverContext();
  store2 = store2 || context;
  invariant(
    store2,
    process.env.NODE_ENV !== "production" && "PopoverDisclosureArrow must be wrapped in a PopoverDisclosure component."
  );
  const position2 = store2.useState((state) => placement || state.placement);
  const dir = position2.split("-")[0];
  const points = pointsMap[dir];
  const children = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      "svg",
      {
        display: "block",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("polyline", { points })
      }
    ),
    [points]
  );
  props2 = {
    children,
    "aria-hidden": true,
    ...props2,
    style: {
      width: "1em",
      height: "1em",
      pointerEvents: "none",
      ...props2.style
    }
  };
  return removeUndefinedValues(props2);
});
forwardRef2(
  function PopoverDisclosureArrow2(props2) {
    const htmlProps = usePopoverDisclosureArrow(props2);
    return createElement(TagName$a, htmlProps);
  }
);
var TagName$9 = "span";
var useSelectArrow = createHook(
  function useSelectArrow2({ store: store2, ...props2 }) {
    const context = useSelectContext();
    store2 = store2 || context;
    props2 = usePopoverDisclosureArrow({ store: store2, ...props2 });
    return props2;
  }
);
var SelectArrow = forwardRef2(function SelectArrow2(props2) {
  const htmlProps = useSelectArrow(props2);
  return createElement(TagName$9, htmlProps);
});
var TagName$8 = "div";
var chars = "";
function clearChars() {
  chars = "";
}
function isValidTypeaheadEvent(event) {
  const target = event.target;
  if (target && isTextField(target)) return false;
  if (event.key === " " && chars.length) return true;
  return event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey && /^[\p{Letter}\p{Number}]$/u.test(event.key);
}
function isSelfTargetOrItem(event, items) {
  if (isSelfTarget(event)) return true;
  const target = event.target;
  if (!target) return false;
  const isItem2 = items.some((item) => item.element === target);
  return isItem2;
}
function getEnabledItems(items) {
  return items.filter((item) => !item.disabled);
}
function itemTextStartsWith(item, text2) {
  var _a2;
  const itemText = ((_a2 = item.element) == null ? void 0 : _a2.textContent) || item.children || // The composite item object itself doesn't include a value property, but
  // other components like Select do. Since CompositeTypeahead is a generic
  // component that can be used with those as well, we also consider the value
  // property as a fallback for the typeahead text content.
  "value" in item && item.value;
  if (!itemText) return false;
  return normalizeString$1(itemText).trim().toLowerCase().startsWith(text2.toLowerCase());
}
function getSameInitialItems(items, char, activeId) {
  if (!activeId) return items;
  const activeItem = items.find((item) => item.id === activeId);
  if (!activeItem) return items;
  if (!itemTextStartsWith(activeItem, char)) return items;
  if (chars !== char && itemTextStartsWith(activeItem, chars)) return items;
  chars = char;
  return flipItems$1(
    items.filter((item) => itemTextStartsWith(item, chars)),
    activeId
  ).filter((item) => item.id !== activeId);
}
var useCompositeTypeahead = createHook(function useCompositeTypeahead2({ store: store2, typeahead = true, ...props2 }) {
  const context = useCompositeContext();
  store2 = store2 || context;
  invariant(
    store2,
    process.env.NODE_ENV !== "production" && "CompositeTypeahead must be a Composite component"
  );
  const onKeyDownCaptureProp = props2.onKeyDownCapture;
  const cleanupTimeoutRef = useRef(0);
  const onKeyDownCapture = useEvent((event) => {
    onKeyDownCaptureProp == null ? void 0 : onKeyDownCaptureProp(event);
    if (event.defaultPrevented) return;
    if (!typeahead) return;
    if (!store2) return;
    if (!isValidTypeaheadEvent(event)) {
      return clearChars();
    }
    const { renderedItems, items, activeId, id: id2 } = store2.getState();
    let enabledItems = getEnabledItems(
      items.length > renderedItems.length ? items : renderedItems
    );
    const document2 = getDocument(event.currentTarget);
    const selector2 = `[data-offscreen-id="${id2}"]`;
    const offscreenItems = document2.querySelectorAll(selector2);
    for (const element2 of offscreenItems) {
      const disabled = element2.ariaDisabled === "true" || "disabled" in element2 && !!element2.disabled;
      enabledItems.push({ id: element2.id, element: element2, disabled });
    }
    if (offscreenItems.length) {
      enabledItems = sortBasedOnDOMPosition(enabledItems, (i2) => i2.element);
    }
    if (!isSelfTargetOrItem(event, enabledItems)) return clearChars();
    event.preventDefault();
    window.clearTimeout(cleanupTimeoutRef.current);
    cleanupTimeoutRef.current = window.setTimeout(() => {
      chars = "";
    }, 500);
    const char = event.key.toLowerCase();
    chars += char;
    enabledItems = getSameInitialItems(enabledItems, char, activeId);
    const item = enabledItems.find((item2) => itemTextStartsWith(item2, chars));
    if (item) {
      store2.move(item.id);
    } else {
      clearChars();
    }
  });
  props2 = {
    ...props2,
    onKeyDownCapture
  };
  return removeUndefinedValues(props2);
});
forwardRef2(function CompositeTypeahead2(props2) {
  const htmlProps = useCompositeTypeahead(props2);
  return createElement(TagName$8, htmlProps);
});
var TagName$7 = "button";
function getSelectedValues(select) {
  return Array.from(select.selectedOptions).map((option) => option.value);
}
function nextWithValue(store2, next) {
  return () => {
    const nextId = next();
    if (!nextId) return;
    let i2 = 0;
    let nextItem = store2.item(nextId);
    const firstItem = nextItem;
    while (nextItem && nextItem.value == null) {
      const nextId2 = next(++i2);
      if (!nextId2) return;
      nextItem = store2.item(nextId2);
      if (nextItem === firstItem) break;
    }
    return nextItem == null ? void 0 : nextItem.id;
  };
}
var useSelect = createHook(function useSelect2({
  store: store2,
  name: name2,
  form,
  required,
  showOnKeyDown = true,
  moveOnKeyDown = true,
  toggleOnPress = true,
  toggleOnClick = toggleOnPress,
  ...props2
}) {
  const context = useSelectProviderContext();
  store2 = store2 || context;
  invariant(
    store2,
    process.env.NODE_ENV !== "production" && "Select must receive a `store` prop or be wrapped in a SelectProvider component."
  );
  const onKeyDownProp = props2.onKeyDown;
  const showOnKeyDownProp = useBooleanEvent(showOnKeyDown);
  const moveOnKeyDownProp = useBooleanEvent(moveOnKeyDown);
  const placement = store2.useState("placement");
  const dir = placement.split("-")[0];
  const value = store2.useState("value");
  const multiSelectable = Array.isArray(value);
  const onKeyDown = useEvent((event) => {
    var _a2;
    onKeyDownProp == null ? void 0 : onKeyDownProp(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { orientation, items: items2, activeId } = store2.getState();
    const isVertical = orientation !== "horizontal";
    const isHorizontal = orientation !== "vertical";
    const isGrid2 = !!((_a2 = items2.find((item) => !item.disabled && item.value != null)) == null ? void 0 : _a2.rowId);
    const moveKeyMap = {
      ArrowUp: (isGrid2 || isVertical) && nextWithValue(store2, store2.up),
      ArrowRight: (isGrid2 || isHorizontal) && nextWithValue(store2, store2.next),
      ArrowDown: (isGrid2 || isVertical) && nextWithValue(store2, store2.down),
      ArrowLeft: (isGrid2 || isHorizontal) && nextWithValue(store2, store2.previous)
    };
    const getId = moveKeyMap[event.key];
    if (getId && moveOnKeyDownProp(event)) {
      event.preventDefault();
      store2.move(getId());
    }
    const isTopOrBottom = dir === "top" || dir === "bottom";
    const isLeft = dir === "left";
    const isRight = dir === "right";
    const canShowKeyMap = {
      ArrowDown: isTopOrBottom,
      ArrowUp: isTopOrBottom,
      ArrowLeft: isLeft,
      ArrowRight: isRight
    };
    const canShow = canShowKeyMap[event.key];
    if (canShow && showOnKeyDownProp(event)) {
      event.preventDefault();
      store2.move(activeId);
      queueBeforeEvent(event.currentTarget, "keyup", store2.show);
    }
  });
  props2 = useWrapElement(
    props2,
    (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectScopedContextProvider, { value: store2, children: element2 }),
    [store2]
  );
  const [autofill, setAutofill] = useState(false);
  const nativeSelectChangedRef = useRef(false);
  useEffect(() => {
    const nativeSelectChanged = nativeSelectChangedRef.current;
    nativeSelectChangedRef.current = false;
    if (nativeSelectChanged) return;
    setAutofill(false);
  }, [value]);
  const labelId = store2.useState((state) => {
    var _a2;
    return (_a2 = state.labelElement) == null ? void 0 : _a2.id;
  });
  const label2 = props2["aria-label"];
  const labelledBy = props2["aria-labelledby"] || labelId;
  const items = store2.useState((state) => {
    if (!name2) return;
    return state.items;
  });
  const values2 = useMemo(() => {
    return [...new Set(items == null ? void 0 : items.map((i2) => i2.value).filter((v2) => v2 != null))];
  }, [items]);
  props2 = useWrapElement(
    props2,
    (element2) => {
      if (!name2) return element2;
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
          "select",
          {
            style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              whiteSpace: "nowrap",
              width: "1px"
            },
            tabIndex: -1,
            "aria-hidden": true,
            "aria-label": label2,
            "aria-labelledby": labelledBy,
            name: name2,
            form,
            required,
            disabled: props2.disabled,
            value,
            multiple: multiSelectable,
            onFocus: () => {
              var _a2;
              return (_a2 = store2 == null ? void 0 : store2.getState().selectElement) == null ? void 0 : _a2.focus();
            },
            onChange: (event) => {
              nativeSelectChangedRef.current = true;
              setAutofill(true);
              store2 == null ? void 0 : store2.setValue(
                multiSelectable ? getSelectedValues(event.target) : event.target.value
              );
            },
            children: [
              toArray(value).map((value2) => {
                if (value2 == null) return null;
                if (values2.includes(value2)) return null;
                return /* @__PURE__ */ jsxRuntimeExports$3.jsx("option", { value: value2, children: value2 }, value2);
              }),
              values2.map((value2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx("option", { value: value2, children: value2 }, value2))
            ]
          }
        ),
        element2
      ] });
    },
    [
      store2,
      label2,
      labelledBy,
      name2,
      form,
      required,
      value,
      multiSelectable,
      values2,
      props2.disabled
    ]
  );
  const children = /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
    value,
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectArrow, {})
  ] });
  const contentElement = store2.useState("contentElement");
  props2 = {
    role: "combobox",
    "aria-autocomplete": "none",
    "aria-labelledby": labelId,
    "aria-haspopup": getPopupRole(contentElement, "listbox"),
    "data-autofill": autofill || void 0,
    "data-name": name2,
    children,
    ...props2,
    ref: useMergeRefs(store2.setSelectElement, props2.ref),
    onKeyDown
  };
  props2 = usePopoverDisclosure({ store: store2, toggleOnClick, ...props2 });
  props2 = useCompositeTypeahead({ store: store2, ...props2 });
  return props2;
});
var Select = forwardRef2(function Select2(props2) {
  const htmlProps = useSelect(props2);
  return createElement(TagName$7, htmlProps);
});
var TagName$6 = "div";
function getMouseDestination(event) {
  const relatedTarget = event.relatedTarget;
  if ((relatedTarget == null ? void 0 : relatedTarget.nodeType) === Node.ELEMENT_NODE) {
    return relatedTarget;
  }
  return null;
}
function hoveringInside(event) {
  const nextElement = getMouseDestination(event);
  if (!nextElement) return false;
  return contains$1(event.currentTarget, nextElement);
}
var symbol = Symbol("composite-hover");
function movingToAnotherItem(event) {
  let dest = getMouseDestination(event);
  if (!dest) return false;
  do {
    if (hasOwnProperty$2(dest, symbol) && dest[symbol]) return true;
    dest = dest.parentElement;
  } while (dest);
  return false;
}
var useCompositeHover = createHook(
  function useCompositeHover2({
    store: store2,
    focusOnHover = true,
    blurOnHoverEnd = !!focusOnHover,
    ...props2
  }) {
    const context = useCompositeContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component."
    );
    const isMouseMoving = useIsMouseMoving();
    const onMouseMoveProp = props2.onMouseMove;
    const focusOnHoverProp = useBooleanEvent(focusOnHover);
    const onMouseMove = useEvent((event) => {
      onMouseMoveProp == null ? void 0 : onMouseMoveProp(event);
      if (event.defaultPrevented) return;
      if (!isMouseMoving()) return;
      if (!focusOnHoverProp(event)) return;
      if (!hasFocusWithin(event.currentTarget)) {
        const baseElement = store2 == null ? void 0 : store2.getState().baseElement;
        if (baseElement && !hasFocus(baseElement)) {
          baseElement.focus();
        }
      }
      store2 == null ? void 0 : store2.setActiveId(event.currentTarget.id);
    });
    const onMouseLeaveProp = props2.onMouseLeave;
    const blurOnHoverEndProp = useBooleanEvent(blurOnHoverEnd);
    const onMouseLeave = useEvent((event) => {
      var _a2;
      onMouseLeaveProp == null ? void 0 : onMouseLeaveProp(event);
      if (event.defaultPrevented) return;
      if (!isMouseMoving()) return;
      if (hoveringInside(event)) return;
      if (movingToAnotherItem(event)) return;
      if (!focusOnHoverProp(event)) return;
      if (!blurOnHoverEndProp(event)) return;
      store2 == null ? void 0 : store2.setActiveId(null);
      (_a2 = store2 == null ? void 0 : store2.getState().baseElement) == null ? void 0 : _a2.focus();
    });
    const ref = useCallback((element2) => {
      if (!element2) return;
      element2[symbol] = true;
    }, []);
    props2 = {
      ...props2,
      ref: useMergeRefs(ref, props2.ref),
      onMouseMove,
      onMouseLeave
    };
    return removeUndefinedValues(props2);
  }
);
memo2(
  forwardRef2(function CompositeHover2(props2) {
    const htmlProps = useCompositeHover(props2);
    return createElement(TagName$6, htmlProps);
  })
);
var TagName$5 = "div";
function isSelected$1(storeValue, itemValue) {
  if (itemValue == null) return;
  if (storeValue == null) return false;
  if (Array.isArray(storeValue)) {
    return storeValue.includes(itemValue);
  }
  return storeValue === itemValue;
}
var useSelectItem = createHook(
  function useSelectItem2({
    store: store2,
    value,
    getItem: getItemProp,
    hideOnClick,
    setValueOnClick = value != null,
    preventScrollOnKeyDown = true,
    focusOnHover = true,
    ...props2
  }) {
    var _a2;
    const context = useSelectScopedContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "SelectItem must be wrapped in a SelectList or SelectPopover component."
    );
    const id2 = useId(props2.id);
    const disabled = disabledFromProps(props2);
    const { listElement, multiSelectable, selected, autoFocus } = useStoreStateObject(store2, {
      listElement: "listElement",
      multiSelectable(state) {
        return Array.isArray(state.value);
      },
      selected(state) {
        return isSelected$1(state.value, value);
      },
      autoFocus(state) {
        if (value == null) return false;
        if (state.value == null) return false;
        if (state.activeId !== id2 && (store2 == null ? void 0 : store2.item(state.activeId))) {
          return false;
        }
        if (Array.isArray(state.value)) {
          return state.value[state.value.length - 1] === value;
        }
        return state.value === value;
      }
    });
    const getItem = useCallback(
      (item) => {
        const nextItem = {
          ...item,
          value: disabled ? void 0 : value,
          children: value
        };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [disabled, value, getItemProp]
    );
    hideOnClick = hideOnClick != null ? hideOnClick : value != null && !multiSelectable;
    const onClickProp = props2.onClick;
    const setValueOnClickProp = useBooleanEvent(setValueOnClick);
    const hideOnClickProp = useBooleanEvent(hideOnClick);
    const onClick = useEvent((event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (isDownloading(event)) return;
      if (isOpeningInNewTab(event)) return;
      if (setValueOnClickProp(event) && value != null) {
        store2 == null ? void 0 : store2.setValue((prevValue) => {
          if (!Array.isArray(prevValue)) return value;
          if (prevValue.includes(value)) {
            return prevValue.filter((v2) => v2 !== value);
          }
          return [...prevValue, value];
        });
      }
      if (hideOnClickProp(event)) {
        store2 == null ? void 0 : store2.hide();
      }
    });
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectItemCheckedContext.Provider, { value: selected != null ? selected : false, children: element2 }),
      [selected]
    );
    props2 = {
      id: id2,
      role: getPopupItemRole(listElement),
      "aria-selected": selected,
      children: value,
      ...props2,
      autoFocus: (_a2 = props2.autoFocus) != null ? _a2 : autoFocus,
      onClick
    };
    props2 = useCompositeItem({
      store: store2,
      getItem,
      preventScrollOnKeyDown,
      ...props2
    });
    const focusOnHoverProp = useBooleanEvent(focusOnHover);
    props2 = useCompositeHover({
      store: store2,
      ...props2,
      // We have to disable focusOnHover when the popup is closed, otherwise
      // the active item will change to null (the container) when the popup is
      // closed by clicking on an item.
      focusOnHover(event) {
        if (!focusOnHoverProp(event)) return false;
        const state = store2 == null ? void 0 : store2.getState();
        return !!(state == null ? void 0 : state.open);
      }
    });
    return props2;
  }
);
var SelectItem = memo2(
  forwardRef2(function SelectItem2(props2) {
    const htmlProps = useSelectItem(props2);
    return createElement(TagName$5, htmlProps);
  })
);
var TagName$4 = "div";
var SelectListContext = createContext(null);
var useSelectList = createHook(
  function useSelectList2({
    store: store2,
    resetOnEscape = true,
    hideOnEnter = true,
    focusOnMove = true,
    composite,
    alwaysVisible,
    ...props2
  }) {
    const context = useSelectContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "SelectList must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const id2 = useId(props2.id);
    const value = store2.useState("value");
    const multiSelectable = Array.isArray(value);
    const [defaultValue2, setDefaultValue] = useState(value);
    const mounted = store2.useState("mounted");
    useEffect(() => {
      if (mounted) return;
      setDefaultValue(value);
    }, [mounted, value]);
    resetOnEscape = resetOnEscape && !multiSelectable;
    const onKeyDownProp = props2.onKeyDown;
    const resetOnEscapeProp = useBooleanEvent(resetOnEscape);
    const hideOnEnterProp = useBooleanEvent(hideOnEnter);
    const onKeyDown = useEvent((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.defaultPrevented) return;
      if (event.key === "Escape" && resetOnEscapeProp(event)) {
        store2 == null ? void 0 : store2.setValue(defaultValue2);
      }
      if (event.key === " " || event.key === "Enter") {
        if (isSelfTarget(event) && hideOnEnterProp(event)) {
          event.preventDefault();
          store2 == null ? void 0 : store2.hide();
        }
      }
    });
    const headingContext = useContext(SelectHeadingContext);
    const headingState = useState();
    const [headingId, setHeadingId] = headingContext || headingState;
    const headingContextValue = useMemo(
      () => [headingId, setHeadingId],
      [headingId]
    );
    const [childStore, setChildStore] = useState(null);
    const setStore = useContext(SelectListContext);
    useEffect(() => {
      if (!setStore) return;
      setStore(store2);
      return () => setStore(null);
    }, [setStore, store2]);
    props2 = useWrapElement(
      props2,
      (element22) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectScopedContextProvider, { value: store2, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectListContext.Provider, { value: setChildStore, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectHeadingContext.Provider, { value: headingContextValue, children: element22 }) }) }),
      [store2, headingContextValue]
    );
    const hasCombobox = !!store2.combobox;
    composite = composite != null ? composite : !hasCombobox && childStore !== store2;
    const [element2, setElement] = useTransactionState(
      composite ? store2.setListElement : null
    );
    const role = useAttribute(element2, "role", props2.role);
    const isCompositeRole = role === "listbox" || role === "menu" || role === "tree" || role === "grid";
    const ariaMultiSelectable = composite || isCompositeRole ? multiSelectable || void 0 : void 0;
    const hidden = isHidden(mounted, props2.hidden, alwaysVisible);
    const style = hidden ? { ...props2.style, display: "none" } : props2.style;
    if (composite) {
      props2 = {
        role: "listbox",
        "aria-multiselectable": ariaMultiSelectable,
        ...props2
      };
    }
    const labelId = store2.useState(
      (state) => {
        var _a2;
        return headingId || ((_a2 = state.labelElement) == null ? void 0 : _a2.id);
      }
    );
    props2 = {
      id: id2,
      "aria-labelledby": labelId,
      hidden,
      ...props2,
      ref: useMergeRefs(setElement, props2.ref),
      style,
      onKeyDown
    };
    props2 = useComposite({ store: store2, ...props2, composite });
    props2 = useCompositeTypeahead({ store: store2, typeahead: !hasCombobox, ...props2 });
    return props2;
  }
);
forwardRef2(function SelectList2(props2) {
  const htmlProps = useSelectList(props2);
  return createElement(TagName$4, htmlProps);
});
var TagName$3 = "div";
var useSelectPopover = createHook(
  function useSelectPopover2({ store: store2, alwaysVisible, ...props2 }) {
    const context = useSelectProviderContext();
    store2 = store2 || context;
    props2 = useSelectList({ store: store2, alwaysVisible, ...props2 });
    props2 = usePopover({ store: store2, alwaysVisible, ...props2 });
    return props2;
  }
);
var SelectPopover = createDialogComponent(
  forwardRef2(function SelectPopover2(props2) {
    const htmlProps = useSelectPopover(props2);
    return createElement(TagName$3, htmlProps);
  }),
  useSelectProviderContext
);
function createSelectStore({
  combobox,
  ...props2
} = {}) {
  const store2 = mergeStore(
    props2.store,
    omit2(combobox, [
      "value",
      "items",
      "renderedItems",
      "baseElement",
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  throwOnConflictingProps(props2, store2);
  const syncState = store2.getState();
  const composite = createCompositeStore({
    ...props2,
    store: store2,
    virtualFocus: defaultValue(
      props2.virtualFocus,
      syncState.virtualFocus,
      true
    ),
    includesBaseElement: defaultValue(
      props2.includesBaseElement,
      syncState.includesBaseElement,
      false
    ),
    activeId: defaultValue(
      props2.activeId,
      syncState.activeId,
      props2.defaultActiveId,
      null
    ),
    orientation: defaultValue(
      props2.orientation,
      syncState.orientation,
      "vertical"
    )
  });
  const popover = createPopoverStore({
    ...props2,
    store: store2,
    placement: defaultValue(
      props2.placement,
      syncState.placement,
      "bottom-start"
    )
  });
  const initialValue = new String("");
  const initialState2 = {
    ...composite.getState(),
    ...popover.getState(),
    value: defaultValue(
      props2.value,
      syncState.value,
      props2.defaultValue,
      initialValue
    ),
    setValueOnMove: defaultValue(
      props2.setValueOnMove,
      syncState.setValueOnMove,
      false
    ),
    labelElement: defaultValue(syncState.labelElement, null),
    selectElement: defaultValue(syncState.selectElement, null),
    listElement: defaultValue(syncState.listElement, null)
  };
  const select = createStore(initialState2, composite, popover, store2);
  setup(
    select,
    () => sync(select, ["value", "items"], (state) => {
      if (state.value !== initialValue) return;
      if (!state.items.length) return;
      const item = state.items.find(
        (item2) => !item2.disabled && item2.value != null
      );
      if ((item == null ? void 0 : item.value) == null) return;
      select.setState("value", item.value);
    })
  );
  setup(
    select,
    () => sync(select, ["mounted"], (state) => {
      if (state.mounted) return;
      select.setState("activeId", initialState2.activeId);
    })
  );
  setup(
    select,
    () => sync(select, ["mounted", "items", "value"], (state) => {
      if (combobox) return;
      if (state.mounted) return;
      const values2 = toArray(state.value);
      const lastValue = values2[values2.length - 1];
      if (lastValue == null) return;
      const item = state.items.find(
        (item2) => !item2.disabled && item2.value === lastValue
      );
      if (!item) return;
      select.setState("activeId", item.id);
    })
  );
  setup(
    select,
    () => batch(select, ["setValueOnMove", "moves"], (state) => {
      const { mounted, value, activeId } = select.getState();
      if (!state.setValueOnMove && mounted) return;
      if (Array.isArray(value)) return;
      if (!state.moves) return;
      if (!activeId) return;
      const item = composite.item(activeId);
      if (!item || item.disabled || item.value == null) return;
      select.setState("value", item.value);
    })
  );
  return {
    ...composite,
    ...popover,
    ...select,
    combobox,
    setValue: (value) => select.setState("value", value),
    setLabelElement: (element2) => select.setState("labelElement", element2),
    setSelectElement: (element2) => select.setState("selectElement", element2),
    setListElement: (element2) => select.setState("listElement", element2)
  };
}
function useSelectStoreOptions(props2) {
  const combobox = useComboboxProviderContext();
  props2 = {
    ...props2,
    combobox: props2.combobox !== void 0 ? props2.combobox : combobox
  };
  return useCompositeStoreOptions(props2);
}
function useSelectStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.combobox]);
  useStoreProps(store2, props2, "value", "setValue");
  useStoreProps(store2, props2, "setValueOnMove");
  return Object.assign(
    usePopoverStoreProps(
      useCompositeStoreProps(store2, update, props2),
      update,
      props2
    ),
    { combobox: props2.combobox }
  );
}
function useSelectStore(props2 = {}) {
  props2 = useSelectStoreOptions(props2);
  const [store2, update] = useStore(createSelectStore, props2);
  return useSelectStoreProps(store2, update, props2);
}
function SelectProvider(props2 = {}) {
  const store2 = useSelectStore(props2);
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectContextProvider, { value: store2, children: props2.children });
}
var TagName$2 = "input";
function isFirstItemAutoSelected(items, activeValue, autoSelect) {
  if (!autoSelect) return false;
  const firstItem = items.find((item) => !item.disabled && item.value);
  return (firstItem == null ? void 0 : firstItem.value) === activeValue;
}
function hasCompletionString(value, activeValue) {
  if (!activeValue) return false;
  if (value == null) return false;
  value = normalizeString$1(value);
  return activeValue.length > value.length && activeValue.toLowerCase().indexOf(value.toLowerCase()) === 0;
}
function isInputEvent(event) {
  return event.type === "input";
}
function isAriaAutoCompleteValue(value) {
  return value === "inline" || value === "list" || value === "both" || value === "none";
}
function getDefaultAutoSelectId(items) {
  const item = items.find((item2) => {
    var _a2;
    if (item2.disabled) return false;
    return ((_a2 = item2.element) == null ? void 0 : _a2.getAttribute("role")) !== "tab";
  });
  return item == null ? void 0 : item.id;
}
var useCombobox = createHook(
  function useCombobox2({
    store: store2,
    focusable = true,
    autoSelect: autoSelectProp = false,
    getAutoSelectId,
    setValueOnChange,
    showMinLength = 0,
    showOnChange,
    showOnMouseDown,
    showOnClick = showOnMouseDown,
    showOnKeyDown,
    showOnKeyPress = showOnKeyDown,
    blurActiveItemOnClick,
    setValueOnClick = true,
    moveOnKeyPress = true,
    autoComplete = "list",
    ...props2
  }) {
    const context = useComboboxProviderContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "Combobox must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const ref = useRef(null);
    const [valueUpdated, forceValueUpdate] = useForceUpdate();
    const canAutoSelectRef = useRef(false);
    const composingRef = useRef(false);
    const autoSelect = store2.useState(
      (state) => state.virtualFocus && autoSelectProp
    );
    const inline = autoComplete === "inline" || autoComplete === "both";
    const [canInline, setCanInline] = useState(inline);
    useUpdateLayoutEffect(() => {
      if (!inline) return;
      setCanInline(true);
    }, [inline]);
    const storeValue = store2.useState("value");
    const prevSelectedValueRef = useRef();
    useEffect(() => {
      return sync(store2, ["selectedValue", "activeId"], (_2, prev) => {
        prevSelectedValueRef.current = prev.selectedValue;
      });
    }, []);
    const inlineActiveValue = store2.useState((state) => {
      var _a2;
      if (!inline) return;
      if (!canInline) return;
      if (state.activeValue && Array.isArray(state.selectedValue)) {
        if (state.selectedValue.includes(state.activeValue)) return;
        if ((_a2 = prevSelectedValueRef.current) == null ? void 0 : _a2.includes(state.activeValue)) return;
      }
      return state.activeValue;
    });
    const items = store2.useState("renderedItems");
    const open = store2.useState("open");
    const contentElement = store2.useState("contentElement");
    const value = useMemo(() => {
      if (!inline) return storeValue;
      if (!canInline) return storeValue;
      const firstItemAutoSelected = isFirstItemAutoSelected(
        items,
        inlineActiveValue,
        autoSelect
      );
      if (firstItemAutoSelected) {
        if (hasCompletionString(storeValue, inlineActiveValue)) {
          const slice2 = (inlineActiveValue == null ? void 0 : inlineActiveValue.slice(storeValue.length)) || "";
          return storeValue + slice2;
        }
        return storeValue;
      }
      return inlineActiveValue || storeValue;
    }, [inline, canInline, items, inlineActiveValue, autoSelect, storeValue]);
    useEffect(() => {
      const element2 = ref.current;
      if (!element2) return;
      const onCompositeItemMove = () => setCanInline(true);
      element2.addEventListener("combobox-item-move", onCompositeItemMove);
      return () => {
        element2.removeEventListener("combobox-item-move", onCompositeItemMove);
      };
    }, []);
    useEffect(() => {
      if (!inline) return;
      if (!canInline) return;
      if (!inlineActiveValue) return;
      const firstItemAutoSelected = isFirstItemAutoSelected(
        items,
        inlineActiveValue,
        autoSelect
      );
      if (!firstItemAutoSelected) return;
      if (!hasCompletionString(storeValue, inlineActiveValue)) return;
      let cleanup = noop$1;
      queueMicrotask(() => {
        const element2 = ref.current;
        if (!element2) return;
        const { start: prevStart, end: prevEnd } = getTextboxSelection(element2);
        const nextStart = storeValue.length;
        const nextEnd = inlineActiveValue.length;
        setSelectionRange(element2, nextStart, nextEnd);
        cleanup = () => {
          if (!hasFocus(element2)) return;
          const { start, end } = getTextboxSelection(element2);
          if (start !== nextStart) return;
          if (end !== nextEnd) return;
          setSelectionRange(element2, prevStart, prevEnd);
        };
      });
      return () => cleanup();
    }, [
      valueUpdated,
      inline,
      canInline,
      inlineActiveValue,
      items,
      autoSelect,
      storeValue
    ]);
    const scrollingElementRef = useRef(null);
    const getAutoSelectIdProp = useEvent(getAutoSelectId);
    const autoSelectIdRef = useRef(null);
    useEffect(() => {
      if (!open) return;
      if (!contentElement) return;
      const scrollingElement = getScrollingElement(contentElement);
      if (!scrollingElement) return;
      scrollingElementRef.current = scrollingElement;
      const onUserScroll = () => {
        canAutoSelectRef.current = false;
      };
      const onScroll = () => {
        if (!store2) return;
        if (!canAutoSelectRef.current) return;
        const { activeId } = store2.getState();
        if (activeId === null) return;
        if (activeId === autoSelectIdRef.current) return;
        canAutoSelectRef.current = false;
      };
      const options2 = { passive: true, capture: true };
      scrollingElement.addEventListener("wheel", onUserScroll, options2);
      scrollingElement.addEventListener("touchmove", onUserScroll, options2);
      scrollingElement.addEventListener("scroll", onScroll, options2);
      return () => {
        scrollingElement.removeEventListener("wheel", onUserScroll, true);
        scrollingElement.removeEventListener("touchmove", onUserScroll, true);
        scrollingElement.removeEventListener("scroll", onScroll, true);
      };
    }, [open, contentElement, store2]);
    useSafeLayoutEffect(() => {
      if (!storeValue) return;
      if (composingRef.current) return;
      canAutoSelectRef.current = true;
    }, [storeValue]);
    useSafeLayoutEffect(() => {
      if (autoSelect !== "always" && open) return;
      canAutoSelectRef.current = open;
    }, [autoSelect, open]);
    const resetValueOnSelect = store2.useState("resetValueOnSelect");
    useUpdateEffect(() => {
      var _a2, _b;
      const canAutoSelect = canAutoSelectRef.current;
      if (!store2) return;
      if (!open) return;
      if (!canAutoSelect && !resetValueOnSelect) return;
      const { baseElement, contentElement: contentElement2, activeId } = store2.getState();
      if (baseElement && !hasFocus(baseElement)) return;
      if (contentElement2 == null ? void 0 : contentElement2.hasAttribute("data-placing")) {
        const observer = new MutationObserver(forceValueUpdate);
        observer.observe(contentElement2, { attributeFilter: ["data-placing"] });
        return () => observer.disconnect();
      }
      if (autoSelect && canAutoSelect) {
        const userAutoSelectId = getAutoSelectIdProp(items);
        const autoSelectId = userAutoSelectId !== void 0 ? userAutoSelectId : (_a2 = getDefaultAutoSelectId(items)) != null ? _a2 : store2.first();
        autoSelectIdRef.current = autoSelectId;
        store2.move(autoSelectId != null ? autoSelectId : null);
      } else {
        const element2 = (_b = store2.item(activeId || store2.first())) == null ? void 0 : _b.element;
        if (element2 && "scrollIntoView" in element2) {
          element2.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      }
      return;
    }, [
      store2,
      open,
      valueUpdated,
      storeValue,
      autoSelect,
      resetValueOnSelect,
      getAutoSelectIdProp,
      items
    ]);
    useEffect(() => {
      if (!inline) return;
      const combobox = ref.current;
      if (!combobox) return;
      const elements2 = [combobox, contentElement].filter(
        (value2) => !!value2
      );
      const onBlur2 = (event) => {
        if (elements2.every((el) => isFocusEventOutside(event, el))) {
          store2 == null ? void 0 : store2.setValue(value);
        }
      };
      for (const element2 of elements2) {
        element2.addEventListener("focusout", onBlur2);
      }
      return () => {
        for (const element2 of elements2) {
          element2.removeEventListener("focusout", onBlur2);
        }
      };
    }, [inline, contentElement, store2, value]);
    const canShow = (event) => {
      const currentTarget = event.currentTarget;
      return currentTarget.value.length >= showMinLength;
    };
    const onChangeProp = props2.onChange;
    const showOnChangeProp = useBooleanEvent(showOnChange != null ? showOnChange : canShow);
    const setValueOnChangeProp = useBooleanEvent(
      // If the combobox is combined with tags, the value will be set by the tag
      // input component.
      setValueOnChange != null ? setValueOnChange : !store2.tag
    );
    const onChange = useEvent((event) => {
      onChangeProp == null ? void 0 : onChangeProp(event);
      if (event.defaultPrevented) return;
      if (!store2) return;
      const currentTarget = event.currentTarget;
      const { value: value2, selectionStart, selectionEnd } = currentTarget;
      const nativeEvent = event.nativeEvent;
      canAutoSelectRef.current = true;
      if (isInputEvent(nativeEvent)) {
        if (nativeEvent.isComposing) {
          canAutoSelectRef.current = false;
          composingRef.current = true;
        }
        if (inline) {
          const textInserted = nativeEvent.inputType === "insertText" || nativeEvent.inputType === "insertCompositionText";
          const caretAtEnd = selectionStart === value2.length;
          setCanInline(textInserted && caretAtEnd);
        }
      }
      if (setValueOnChangeProp(event)) {
        const isSameValue = value2 === store2.getState().value;
        store2.setValue(value2);
        queueMicrotask(() => {
          setSelectionRange(currentTarget, selectionStart, selectionEnd);
        });
        if (inline && autoSelect && isSameValue) {
          forceValueUpdate();
        }
      }
      if (showOnChangeProp(event)) {
        store2.show();
      }
      if (!autoSelect || !canAutoSelectRef.current) {
        store2.setActiveId(null);
      }
    });
    const onCompositionEndProp = props2.onCompositionEnd;
    const onCompositionEnd = useEvent((event) => {
      canAutoSelectRef.current = true;
      composingRef.current = false;
      onCompositionEndProp == null ? void 0 : onCompositionEndProp(event);
      if (event.defaultPrevented) return;
      if (!autoSelect) return;
      forceValueUpdate();
    });
    const onMouseDownProp = props2.onMouseDown;
    const blurActiveItemOnClickProp = useBooleanEvent(
      blurActiveItemOnClick != null ? blurActiveItemOnClick : (() => !!(store2 == null ? void 0 : store2.getState().includesBaseElement))
    );
    const setValueOnClickProp = useBooleanEvent(setValueOnClick);
    const showOnClickProp = useBooleanEvent(showOnClick != null ? showOnClick : canShow);
    const onMouseDown = useEvent((event) => {
      onMouseDownProp == null ? void 0 : onMouseDownProp(event);
      if (event.defaultPrevented) return;
      if (event.button) return;
      if (event.ctrlKey) return;
      if (!store2) return;
      if (blurActiveItemOnClickProp(event)) {
        store2.setActiveId(null);
      }
      if (setValueOnClickProp(event)) {
        store2.setValue(value);
      }
      if (showOnClickProp(event)) {
        queueBeforeEvent(event.currentTarget, "mouseup", store2.show);
      }
    });
    const onKeyDownProp = props2.onKeyDown;
    const showOnKeyPressProp = useBooleanEvent(showOnKeyPress != null ? showOnKeyPress : canShow);
    const onKeyDown = useEvent((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (!event.repeat) {
        canAutoSelectRef.current = false;
      }
      if (event.defaultPrevented) return;
      if (event.ctrlKey) return;
      if (event.altKey) return;
      if (event.shiftKey) return;
      if (event.metaKey) return;
      if (!store2) return;
      const { open: open2 } = store2.getState();
      if (open2) return;
      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        if (showOnKeyPressProp(event)) {
          event.preventDefault();
          store2.show();
        }
      }
    });
    const onBlurProp = props2.onBlur;
    const onBlur = useEvent((event) => {
      canAutoSelectRef.current = false;
      onBlurProp == null ? void 0 : onBlurProp(event);
      if (event.defaultPrevented) return;
    });
    const id2 = useId(props2.id);
    const ariaAutoComplete = isAriaAutoCompleteValue(autoComplete) ? autoComplete : void 0;
    const isActiveItem = store2.useState((state) => state.activeId === null);
    props2 = {
      id: id2,
      role: "combobox",
      "aria-autocomplete": ariaAutoComplete,
      "aria-haspopup": getPopupRole(contentElement, "listbox"),
      "aria-expanded": open,
      "aria-controls": contentElement == null ? void 0 : contentElement.id,
      "data-active-item": isActiveItem || void 0,
      value,
      ...props2,
      ref: useMergeRefs(ref, props2.ref),
      onChange,
      onCompositionEnd,
      onMouseDown,
      onKeyDown,
      onBlur
    };
    props2 = useComposite({
      store: store2,
      focusable,
      ...props2,
      // Enable inline autocomplete when the user moves from the combobox input
      // to an item.
      moveOnKeyPress: (event) => {
        if (isFalsyBooleanCallback(moveOnKeyPress, event)) return false;
        if (inline) setCanInline(true);
        return true;
      }
    });
    props2 = usePopoverAnchor({ store: store2, ...props2 });
    return { autoComplete: "off", ...props2 };
  }
);
var Combobox = forwardRef2(function Combobox2(props2) {
  const htmlProps = useCombobox(props2);
  return createElement(TagName$2, htmlProps);
});
var TagName$1 = "div";
function isSelected(storeValue, itemValue) {
  if (itemValue == null) return;
  if (storeValue == null) return false;
  if (Array.isArray(storeValue)) {
    return storeValue.includes(itemValue);
  }
  return storeValue === itemValue;
}
function getItemRole(popupRole) {
  var _a2;
  const itemRoleByPopupRole = {
    menu: "menuitem",
    listbox: "option",
    tree: "treeitem"
  };
  const key = popupRole;
  return (_a2 = itemRoleByPopupRole[key]) != null ? _a2 : "option";
}
var useComboboxItem = createHook(
  function useComboboxItem2({
    store: store2,
    value,
    hideOnClick,
    setValueOnClick,
    selectValueOnClick = true,
    resetValueOnSelect,
    focusOnHover = false,
    moveOnKeyPress = true,
    getItem: getItemProp,
    ...props2
  }) {
    var _a2;
    const context = useComboboxScopedContext();
    store2 = store2 || context;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "ComboboxItem must be wrapped in a ComboboxList or ComboboxPopover component."
    );
    const { resetValueOnSelectState, multiSelectable, selected } = useStoreStateObject(store2, {
      resetValueOnSelectState: "resetValueOnSelect",
      multiSelectable(state) {
        return Array.isArray(state.selectedValue);
      },
      selected(state) {
        return isSelected(state.selectedValue, value);
      }
    });
    const getItem = useCallback(
      (item) => {
        const nextItem = { ...item, value };
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [value, getItemProp]
    );
    setValueOnClick = setValueOnClick != null ? setValueOnClick : !multiSelectable;
    hideOnClick = hideOnClick != null ? hideOnClick : value != null && !multiSelectable;
    const onClickProp = props2.onClick;
    const setValueOnClickProp = useBooleanEvent(setValueOnClick);
    const selectValueOnClickProp = useBooleanEvent(selectValueOnClick);
    const resetValueOnSelectProp = useBooleanEvent(
      (_a2 = resetValueOnSelect != null ? resetValueOnSelect : resetValueOnSelectState) != null ? _a2 : multiSelectable
    );
    const hideOnClickProp = useBooleanEvent(hideOnClick);
    const onClick = useEvent((event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented) return;
      if (isDownloading(event)) return;
      if (isOpeningInNewTab(event)) return;
      if (value != null) {
        if (selectValueOnClickProp(event)) {
          if (resetValueOnSelectProp(event)) {
            store2 == null ? void 0 : store2.resetValue();
          }
          store2 == null ? void 0 : store2.setSelectedValue((prevValue) => {
            if (!Array.isArray(prevValue)) return value;
            if (prevValue.includes(value)) {
              return prevValue.filter((v2) => v2 !== value);
            }
            return [...prevValue, value];
          });
        }
        if (setValueOnClickProp(event)) {
          store2 == null ? void 0 : store2.setValue(value);
        }
      }
      if (hideOnClickProp(event)) {
        store2 == null ? void 0 : store2.hide();
      }
    });
    const onKeyDownProp = props2.onKeyDown;
    const onKeyDown = useEvent((event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.defaultPrevented) return;
      const baseElement = store2 == null ? void 0 : store2.getState().baseElement;
      if (!baseElement) return;
      if (hasFocus(baseElement)) return;
      const printable = event.key.length === 1;
      if (printable || event.key === "Backspace" || event.key === "Delete") {
        queueMicrotask(() => baseElement.focus());
        if (isTextField(baseElement)) {
          store2 == null ? void 0 : store2.setValue(baseElement.value);
        }
      }
    });
    if (multiSelectable && selected != null) {
      props2 = {
        "aria-selected": selected,
        ...props2
      };
    }
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxItemValueContext.Provider, { value, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxItemCheckedContext.Provider, { value: selected != null ? selected : false, children: element2 }) }),
      [value, selected]
    );
    const popupRole = useContext(ComboboxListRoleContext);
    props2 = {
      role: getItemRole(popupRole),
      children: value,
      ...props2,
      onClick,
      onKeyDown
    };
    const moveOnKeyPressProp = useBooleanEvent(moveOnKeyPress);
    props2 = useCompositeItem({
      store: store2,
      ...props2,
      getItem,
      // Dispatch a custom event on the combobox input when moving to an item
      // with the keyboard so the Combobox component can enable inline
      // autocompletion.
      moveOnKeyPress: (event) => {
        if (!moveOnKeyPressProp(event)) return false;
        const moveEvent = new Event("combobox-item-move");
        const baseElement = store2 == null ? void 0 : store2.getState().baseElement;
        baseElement == null ? void 0 : baseElement.dispatchEvent(moveEvent);
        return true;
      }
    });
    props2 = useCompositeHover({ store: store2, focusOnHover, ...props2 });
    return props2;
  }
);
var ComboboxItem = memo2(
  forwardRef2(function ComboboxItem2(props2) {
    const htmlProps = useComboboxItem(props2);
    return createElement(TagName$1, htmlProps);
  })
);
var TagName = "div";
var useComboboxList = createHook(
  function useComboboxList2({ store: store2, alwaysVisible, ...props2 }) {
    const scopedContext = useComboboxScopedContext(true);
    const context = useComboboxContext();
    store2 = store2 || context;
    const scopedContextSameStore = !!store2 && store2 === scopedContext;
    invariant(
      store2,
      process.env.NODE_ENV !== "production" && "ComboboxList must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const ref = useRef(null);
    const id2 = useId(props2.id);
    const mounted = store2.useState("mounted");
    const hidden = isHidden(mounted, props2.hidden, alwaysVisible);
    const style = hidden ? { ...props2.style, display: "none" } : props2.style;
    const multiSelectable = store2.useState(
      (state) => Array.isArray(state.selectedValue)
    );
    const role = useAttribute(ref, "role", props2.role);
    const isCompositeRole = role === "listbox" || role === "tree" || role === "grid";
    const ariaMultiSelectable = isCompositeRole ? multiSelectable || void 0 : void 0;
    const [hasListboxInside, setHasListboxInside] = useState(false);
    const contentElement = store2.useState("contentElement");
    useSafeLayoutEffect(() => {
      if (!mounted) return;
      const element2 = ref.current;
      if (!element2) return;
      if (contentElement !== element2) return;
      const callback = () => {
        setHasListboxInside(!!element2.querySelector("[role='listbox']"));
      };
      const observer = new MutationObserver(callback);
      observer.observe(element2, {
        subtree: true,
        childList: true,
        attributeFilter: ["role"]
      });
      callback();
      return () => observer.disconnect();
    }, [mounted, contentElement]);
    if (!hasListboxInside) {
      props2 = {
        role: "listbox",
        "aria-multiselectable": ariaMultiSelectable,
        ...props2
      };
    }
    props2 = useWrapElement(
      props2,
      (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxScopedContextProvider, { value: store2, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxListRoleContext.Provider, { value: role, children: element2 }) }),
      [store2, role]
    );
    const setContentElement = id2 && (!scopedContext || !scopedContextSameStore) ? store2.setContentElement : null;
    props2 = {
      id: id2,
      hidden,
      ...props2,
      ref: useMergeRefs(setContentElement, ref, props2.ref),
      style
    };
    return removeUndefinedValues(props2);
  }
);
var ComboboxList = forwardRef2(function ComboboxList2(props2) {
  const htmlProps = useComboboxList(props2);
  return createElement(TagName, htmlProps);
});
createContext(null);
createContext(
  null
);
var ctx = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useTagContext = ctx.useContext;
var isTouchSafari = isSafari() && isTouchDevice();
function createComboboxStore({
  tag: tag2,
  ...props2
} = {}) {
  const store2 = mergeStore(props2.store, pick2(tag2, ["value", "rtl"]));
  throwOnConflictingProps(props2, store2);
  const tagState = tag2 == null ? void 0 : tag2.getState();
  const syncState = store2 == null ? void 0 : store2.getState();
  const activeId = defaultValue(
    props2.activeId,
    syncState == null ? void 0 : syncState.activeId,
    props2.defaultActiveId,
    null
  );
  const composite = createCompositeStore({
    ...props2,
    activeId,
    includesBaseElement: defaultValue(
      props2.includesBaseElement,
      syncState == null ? void 0 : syncState.includesBaseElement,
      true
    ),
    orientation: defaultValue(
      props2.orientation,
      syncState == null ? void 0 : syncState.orientation,
      "vertical"
    ),
    focusLoop: defaultValue(props2.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true),
    focusWrap: defaultValue(props2.focusWrap, syncState == null ? void 0 : syncState.focusWrap, true),
    virtualFocus: defaultValue(
      props2.virtualFocus,
      syncState == null ? void 0 : syncState.virtualFocus,
      true
    )
  });
  const popover = createPopoverStore({
    ...props2,
    placement: defaultValue(
      props2.placement,
      syncState == null ? void 0 : syncState.placement,
      "bottom-start"
    )
  });
  const value = defaultValue(
    props2.value,
    syncState == null ? void 0 : syncState.value,
    props2.defaultValue,
    ""
  );
  const selectedValue = defaultValue(
    props2.selectedValue,
    syncState == null ? void 0 : syncState.selectedValue,
    tagState == null ? void 0 : tagState.values,
    props2.defaultSelectedValue,
    ""
  );
  const multiSelectable = Array.isArray(selectedValue);
  const initialState2 = {
    ...composite.getState(),
    ...popover.getState(),
    value,
    selectedValue,
    resetValueOnSelect: defaultValue(
      props2.resetValueOnSelect,
      syncState == null ? void 0 : syncState.resetValueOnSelect,
      multiSelectable
    ),
    resetValueOnHide: defaultValue(
      props2.resetValueOnHide,
      syncState == null ? void 0 : syncState.resetValueOnHide,
      multiSelectable && !tag2
    ),
    activeValue: syncState == null ? void 0 : syncState.activeValue
  };
  const combobox = createStore(initialState2, composite, popover, store2);
  if (isTouchSafari) {
    setup(
      combobox,
      () => sync(combobox, ["virtualFocus"], () => {
        combobox.setState("virtualFocus", false);
      })
    );
  }
  setup(combobox, () => {
    if (!tag2) return;
    return chain(
      sync(combobox, ["selectedValue"], (state) => {
        if (!Array.isArray(state.selectedValue)) return;
        tag2.setValues(state.selectedValue);
      }),
      sync(tag2, ["values"], (state) => {
        combobox.setState("selectedValue", state.values);
      })
    );
  });
  setup(
    combobox,
    () => sync(combobox, ["resetValueOnHide", "mounted"], (state) => {
      if (!state.resetValueOnHide) return;
      if (state.mounted) return;
      combobox.setState("value", value);
    })
  );
  setup(
    combobox,
    () => sync(combobox, ["open"], (state) => {
      if (state.open) return;
      combobox.setState("activeId", activeId);
      combobox.setState("moves", 0);
    })
  );
  setup(
    combobox,
    () => sync(combobox, ["moves", "activeId"], (state, prevState) => {
      if (state.moves === prevState.moves) {
        combobox.setState("activeValue", void 0);
      }
    })
  );
  setup(
    combobox,
    () => batch(combobox, ["moves", "renderedItems"], (state, prev) => {
      if (state.moves === prev.moves) return;
      const { activeId: activeId2 } = combobox.getState();
      const activeItem = composite.item(activeId2);
      combobox.setState("activeValue", activeItem == null ? void 0 : activeItem.value);
    })
  );
  return {
    ...popover,
    ...composite,
    ...combobox,
    tag: tag2,
    setValue: (value2) => combobox.setState("value", value2),
    resetValue: () => combobox.setState("value", initialState2.value),
    setSelectedValue: (selectedValue2) => combobox.setState("selectedValue", selectedValue2)
  };
}
function useComboboxStoreOptions(props2) {
  const tag2 = useTagContext();
  props2 = {
    ...props2,
    tag: props2.tag !== void 0 ? props2.tag : tag2
  };
  return useCompositeStoreOptions(props2);
}
function useComboboxStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.tag]);
  useStoreProps(store2, props2, "value", "setValue");
  useStoreProps(store2, props2, "selectedValue", "setSelectedValue");
  useStoreProps(store2, props2, "resetValueOnHide");
  useStoreProps(store2, props2, "resetValueOnSelect");
  return Object.assign(
    useCompositeStoreProps(
      usePopoverStoreProps(store2, update, props2),
      update,
      props2
    ),
    { tag: props2.tag }
  );
}
function useComboboxStore(props2 = {}) {
  props2 = useComboboxStoreOptions(props2);
  const [store2, update] = useStore(createComboboxStore, props2);
  return useComboboxStoreProps(store2, update, props2);
}
function ComboboxProvider(props2 = {}) {
  const store2 = useComboboxStore(props2);
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxContextProvider, { value: store2, children: props2.children });
}
function BsCaretDownFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" }, "child": [] }] })(props2);
}
function BsCaretUpFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" }, "child": [] }] })(props2);
}
function BsExclamationTriangleFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }, "child": [] }] })(props2);
}
function BsX(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" }, "child": [] }] })(props2);
}
function VariantSelect({
  size: size2 = "sm",
  menuWidth,
  array = [],
  onChange = () => {
  },
  syncIndex
  //Optional attribute to keep several variant selects in sync
}) {
  const [index2, setIndex] = useState(0);
  const [value, setValue] = useState(array[index2]);
  const [inputValue, setInputValue] = useState("");
  const [showTooltip2, setShowTooltip] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  useEffect(() => {
    if (syncIndex != void 0 && index2 != syncIndex - 1) {
      setIndex(syncIndex - 1);
      setValue(array[syncIndex - 1]);
    }
  }, [index2, syncIndex, array]);
  const filteredArray = array.filter(
    (string2) => inputValue === "" ? true : string2.includes(inputValue)
  );
  const matches2 = filteredArray.length > 0 ? filteredArray : array;
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "variant-select", children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "wrapper", children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      ComboboxProvider,
      {
        resetValueOnHide: true,
        setValue: (value2) => {
          React__default.startTransition(() => {
            setInputValue(value2);
          });
        },
        children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
          SelectProvider,
          {
            value,
            defaultValue: value,
            setValue: (val) => {
              const index22 = array.indexOf(val);
              setIndex(index22);
              setValue(val);
              setInputValue("");
              onChange(index22);
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                Select,
                {
                  className: "button select-button",
                  title: "Variant"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
                SelectPopover,
                {
                  gutter: 4,
                  sameWidth: true,
                  className: "popover",
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "combobox-wrapper", children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                      Combobox,
                      {
                        autoSelect: true,
                        placeholder: "Filter...",
                        className: "combobox"
                      }
                    ) }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxList, { children: matches2.map((value2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                      SelectItem,
                      {
                        value: value2,
                        className: "select-item",
                        render: /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxItem, {})
                      },
                      value2
                    )) })
                  ]
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      Button,
      {
        title: "Select next variant",
        className: "button prev-next-button",
        disabled: index2 == array.length - 1,
        onClick: () => {
          if (index2 == array.length - 1) {
            return;
          }
          const nextIndex = index2 + 1;
          setIndex(nextIndex);
          setValue(array[nextIndex]);
          setInputValue("");
          onChange(nextIndex);
        },
        children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsCaretDownFill, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      Button,
      {
        title: "Select previous variant",
        className: "button prev-next-button",
        disabled: index2 < 1,
        onClick: () => {
          if (index2 < 1) {
            return;
          }
          const nextIndex = index2 - 1;
          setIndex(nextIndex);
          setValue(array[nextIndex]);
          setInputValue("");
          onChange(nextIndex);
        },
        children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsCaretUpFill, {})
      }
    )
  ] });
}
let rangeFrom = [], rangeTo = [];
(() => {
  let numbers = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s) => s ? parseInt(s, 36) : 1);
  for (let i2 = 0, n = 0; i2 < numbers.length; i2++)
    (i2 % 2 ? rangeTo : rangeFrom).push(n = n + numbers[i2]);
})();
function isExtendingChar(code2) {
  if (code2 < 768) return false;
  for (let from = 0, to2 = rangeFrom.length; ; ) {
    let mid = from + to2 >> 1;
    if (code2 < rangeFrom[mid]) to2 = mid;
    else if (code2 >= rangeTo[mid]) from = mid + 1;
    else return true;
    if (from == to2) return false;
  }
}
function isRegionalIndicator(code2) {
  return code2 >= 127462 && code2 <= 127487;
}
const ZWJ = 8205;
function findClusterBreak$1(str, pos, forward = true, includeExtending = true) {
  return (forward ? nextClusterBreak : prevClusterBreak)(str, pos, includeExtending);
}
function nextClusterBreak(str, pos, includeExtending) {
  if (pos == str.length) return pos;
  if (pos && surrogateLow$1(str.charCodeAt(pos)) && surrogateHigh$1(str.charCodeAt(pos - 1))) pos--;
  let prev = codePointAt$1(str, pos);
  pos += codePointSize$1(prev);
  while (pos < str.length) {
    let next = codePointAt$1(str, pos);
    if (prev == ZWJ || next == ZWJ || includeExtending && isExtendingChar(next)) {
      pos += codePointSize$1(next);
      prev = next;
    } else if (isRegionalIndicator(next)) {
      let countBefore = 0, i2 = pos - 2;
      while (i2 >= 0 && isRegionalIndicator(codePointAt$1(str, i2))) {
        countBefore++;
        i2 -= 2;
      }
      if (countBefore % 2 == 0) break;
      else pos += 2;
    } else {
      break;
    }
  }
  return pos;
}
function prevClusterBreak(str, pos, includeExtending) {
  while (pos > 0) {
    let found = nextClusterBreak(str, pos - 2, includeExtending);
    if (found < pos) return found;
    pos--;
  }
  return 0;
}
function codePointAt$1(str, pos) {
  let code0 = str.charCodeAt(pos);
  if (!surrogateHigh$1(code0) || pos + 1 == str.length) return code0;
  let code1 = str.charCodeAt(pos + 1);
  if (!surrogateLow$1(code1)) return code0;
  return (code0 - 55296 << 10) + (code1 - 56320) + 65536;
}
function surrogateLow$1(ch) {
  return ch >= 56320 && ch < 57344;
}
function surrogateHigh$1(ch) {
  return ch >= 55296 && ch < 56320;
}
function codePointSize$1(code2) {
  return code2 < 65536 ? 1 : 2;
}
let Text$1 = class Text3 {
  /**
  Get the line description around the given position.
  */
  lineAt(pos) {
    if (pos < 0 || pos > this.length)
      throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
    return this.lineInner(pos, false, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(n) {
    if (n < 1 || n > this.lines)
      throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
    return this.lineInner(n, true, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(from, to2, text2) {
    [from, to2] = clip(this, from, to2);
    let parts = [];
    this.decompose(
      0,
      from,
      parts,
      2
      /* Open.To */
    );
    if (text2.length)
      text2.decompose(
        0,
        text2.length,
        parts,
        1 | 2
        /* Open.To */
      );
    this.decompose(
      to2,
      this.length,
      parts,
      1
      /* Open.From */
    );
    return TextNode.from(parts, this.length - (to2 - from) + text2.length);
  }
  /**
  Append another document to this one.
  */
  append(other) {
    return this.replace(this.length, this.length, other);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(from, to2 = this.length) {
    [from, to2] = clip(this, from, to2);
    let parts = [];
    this.decompose(from, to2, parts, 0);
    return TextNode.from(parts, to2 - from);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(other) {
    if (other == this)
      return true;
    if (other.length != this.length || other.lines != this.lines)
      return false;
    let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
    let a = new RawTextCursor(this), b2 = new RawTextCursor(other);
    for (let skip = start, pos = start; ; ) {
      a.next(skip);
      b2.next(skip);
      skip = 0;
      if (a.lineBreak != b2.lineBreak || a.done != b2.done || a.value != b2.value)
        return false;
      pos += a.value.length;
      if (a.done || pos >= end)
        return true;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(dir = 1) {
    return new RawTextCursor(this, dir);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(from, to2 = this.length) {
    return new PartialTextCursor(this, from, to2);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(from, to2) {
    let inner;
    if (from == null) {
      inner = this.iter();
    } else {
      if (to2 == null)
        to2 = this.lines + 1;
      let start = this.line(from).from;
      inner = this.iterRange(start, Math.max(start, to2 == this.lines + 1 ? this.length : to2 <= 1 ? 0 : this.line(to2 - 1).to));
    }
    return new LineCursor(inner);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let lines = [];
    this.flatten(lines);
    return lines;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(text2) {
    if (text2.length == 0)
      throw new RangeError("A document must have at least one line");
    if (text2.length == 1 && !text2[0])
      return Text3.empty;
    return text2.length <= 32 ? new TextLeaf(text2) : TextNode.from(TextLeaf.split(text2, []));
  }
};
class TextLeaf extends Text$1 {
  constructor(text2, length = textLength(text2)) {
    super();
    this.text = text2;
    this.length = length;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(target, isLine2, line2, offset2) {
    for (let i2 = 0; ; i2++) {
      let string2 = this.text[i2], end = offset2 + string2.length;
      if ((isLine2 ? line2 : end) >= target)
        return new Line(offset2, end, line2, string2);
      offset2 = end + 1;
      line2++;
    }
  }
  decompose(from, to2, target, open) {
    let text2 = from <= 0 && to2 >= this.length ? this : new TextLeaf(sliceText(this.text, from, to2), Math.min(to2, this.length) - Math.max(0, from));
    if (open & 1) {
      let prev = target.pop();
      let joined = appendText(text2.text, prev.text.slice(), 0, text2.length);
      if (joined.length <= 32) {
        target.push(new TextLeaf(joined, prev.length + text2.length));
      } else {
        let mid = joined.length >> 1;
        target.push(new TextLeaf(joined.slice(0, mid)), new TextLeaf(joined.slice(mid)));
      }
    } else {
      target.push(text2);
    }
  }
  replace(from, to2, text2) {
    if (!(text2 instanceof TextLeaf))
      return super.replace(from, to2, text2);
    [from, to2] = clip(this, from, to2);
    let lines = appendText(this.text, appendText(text2.text, sliceText(this.text, 0, from)), to2);
    let newLen = this.length + text2.length - (to2 - from);
    if (lines.length <= 32)
      return new TextLeaf(lines, newLen);
    return TextNode.from(TextLeaf.split(lines, []), newLen);
  }
  sliceString(from, to2 = this.length, lineSep = "\n") {
    [from, to2] = clip(this, from, to2);
    let result2 = "";
    for (let pos = 0, i2 = 0; pos <= to2 && i2 < this.text.length; i2++) {
      let line2 = this.text[i2], end = pos + line2.length;
      if (pos > from && i2)
        result2 += lineSep;
      if (from < end && to2 > pos)
        result2 += line2.slice(Math.max(0, from - pos), to2 - pos);
      pos = end + 1;
    }
    return result2;
  }
  flatten(target) {
    for (let line2 of this.text)
      target.push(line2);
  }
  scanIdentical() {
    return 0;
  }
  static split(text2, target) {
    let part = [], len = -1;
    for (let line2 of text2) {
      part.push(line2);
      len += line2.length + 1;
      if (part.length == 32) {
        target.push(new TextLeaf(part, len));
        part = [];
        len = -1;
      }
    }
    if (len > -1)
      target.push(new TextLeaf(part, len));
    return target;
  }
}
class TextNode extends Text$1 {
  constructor(children, length) {
    super();
    this.children = children;
    this.length = length;
    this.lines = 0;
    for (let child of children)
      this.lines += child.lines;
  }
  lineInner(target, isLine2, line2, offset2) {
    for (let i2 = 0; ; i2++) {
      let child = this.children[i2], end = offset2 + child.length, endLine = line2 + child.lines - 1;
      if ((isLine2 ? endLine : end) >= target)
        return child.lineInner(target, isLine2, line2, offset2);
      offset2 = end + 1;
      line2 = endLine + 1;
    }
  }
  decompose(from, to2, target, open) {
    for (let i2 = 0, pos = 0; pos <= to2 && i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (from <= end && to2 >= pos) {
        let childOpen = open & ((pos <= from ? 1 : 0) | (end >= to2 ? 2 : 0));
        if (pos >= from && end <= to2 && !childOpen)
          target.push(child);
        else
          child.decompose(from - pos, to2 - pos, target, childOpen);
      }
      pos = end + 1;
    }
  }
  replace(from, to2, text2) {
    [from, to2] = clip(this, from, to2);
    if (text2.lines < this.lines)
      for (let i2 = 0, pos = 0; i2 < this.children.length; i2++) {
        let child = this.children[i2], end = pos + child.length;
        if (from >= pos && to2 <= end) {
          let updated = child.replace(from - pos, to2 - pos, text2);
          let totalLines = this.lines - child.lines + updated.lines;
          if (updated.lines < totalLines >> 5 - 1 && updated.lines > totalLines >> 5 + 1) {
            let copy2 = this.children.slice();
            copy2[i2] = updated;
            return new TextNode(copy2, this.length - (to2 - from) + text2.length);
          }
          return super.replace(pos, end, updated);
        }
        pos = end + 1;
      }
    return super.replace(from, to2, text2);
  }
  sliceString(from, to2 = this.length, lineSep = "\n") {
    [from, to2] = clip(this, from, to2);
    let result2 = "";
    for (let i2 = 0, pos = 0; i2 < this.children.length && pos <= to2; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (pos > from && i2)
        result2 += lineSep;
      if (from < end && to2 > pos)
        result2 += child.sliceString(from - pos, to2 - pos, lineSep);
      pos = end + 1;
    }
    return result2;
  }
  flatten(target) {
    for (let child of this.children)
      child.flatten(target);
  }
  scanIdentical(other, dir) {
    if (!(other instanceof TextNode))
      return 0;
    let length = 0;
    let [iA, iB, eA, eB] = dir > 0 ? [0, 0, this.children.length, other.children.length] : [this.children.length - 1, other.children.length - 1, -1, -1];
    for (; ; iA += dir, iB += dir) {
      if (iA == eA || iB == eB)
        return length;
      let chA = this.children[iA], chB = other.children[iB];
      if (chA != chB)
        return length + chA.scanIdentical(chB, dir);
      length += chA.length + 1;
    }
  }
  static from(children, length = children.reduce((l, ch) => l + ch.length + 1, -1)) {
    let lines = 0;
    for (let ch of children)
      lines += ch.lines;
    if (lines < 32) {
      let flat = [];
      for (let ch of children)
        ch.flatten(flat);
      return new TextLeaf(flat, length);
    }
    let chunk2 = Math.max(
      32,
      lines >> 5
      /* Tree.BranchShift */
    ), maxChunk = chunk2 << 1, minChunk = chunk2 >> 1;
    let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
    function add2(child) {
      let last2;
      if (child.lines > maxChunk && child instanceof TextNode) {
        for (let node of child.children)
          add2(node);
      } else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
        flush();
        chunked.push(child);
      } else if (child instanceof TextLeaf && currentLines && (last2 = currentChunk[currentChunk.length - 1]) instanceof TextLeaf && child.lines + last2.lines <= 32) {
        currentLines += child.lines;
        currentLen += child.length + 1;
        currentChunk[currentChunk.length - 1] = new TextLeaf(last2.text.concat(child.text), last2.length + 1 + child.length);
      } else {
        if (currentLines + child.lines > chunk2)
          flush();
        currentLines += child.lines;
        currentLen += child.length + 1;
        currentChunk.push(child);
      }
    }
    function flush() {
      if (currentLines == 0)
        return;
      chunked.push(currentChunk.length == 1 ? currentChunk[0] : TextNode.from(currentChunk, currentLen));
      currentLen = -1;
      currentLines = currentChunk.length = 0;
    }
    for (let child of children)
      add2(child);
    flush();
    return chunked.length == 1 ? chunked[0] : new TextNode(chunked, length);
  }
}
Text$1.empty = /* @__PURE__ */ new TextLeaf([""], 0);
function textLength(text2) {
  let length = -1;
  for (let line2 of text2)
    length += line2.length + 1;
  return length;
}
function appendText(text2, target, from = 0, to2 = 1e9) {
  for (let pos = 0, i2 = 0, first2 = true; i2 < text2.length && pos <= to2; i2++) {
    let line2 = text2[i2], end = pos + line2.length;
    if (end >= from) {
      if (end > to2)
        line2 = line2.slice(0, to2 - pos);
      if (pos < from)
        line2 = line2.slice(from - pos);
      if (first2) {
        target[target.length - 1] += line2;
        first2 = false;
      } else
        target.push(line2);
    }
    pos = end + 1;
  }
  return target;
}
function sliceText(text2, from, to2) {
  return appendText(text2, [""], from, to2);
}
class RawTextCursor {
  constructor(text2, dir = 1) {
    this.dir = dir;
    this.done = false;
    this.lineBreak = false;
    this.value = "";
    this.nodes = [text2];
    this.offsets = [dir > 0 ? 1 : (text2 instanceof TextLeaf ? text2.text.length : text2.children.length) << 1];
  }
  nextInner(skip, dir) {
    this.done = this.lineBreak = false;
    for (; ; ) {
      let last2 = this.nodes.length - 1;
      let top2 = this.nodes[last2], offsetValue = this.offsets[last2], offset2 = offsetValue >> 1;
      let size2 = top2 instanceof TextLeaf ? top2.text.length : top2.children.length;
      if (offset2 == (dir > 0 ? size2 : 0)) {
        if (last2 == 0) {
          this.done = true;
          this.value = "";
          return this;
        }
        if (dir > 0)
          this.offsets[last2 - 1]++;
        this.nodes.pop();
        this.offsets.pop();
      } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
        this.offsets[last2] += dir;
        if (skip == 0) {
          this.lineBreak = true;
          this.value = "\n";
          return this;
        }
        skip--;
      } else if (top2 instanceof TextLeaf) {
        let next = top2.text[offset2 + (dir < 0 ? -1 : 0)];
        this.offsets[last2] += dir;
        if (next.length > Math.max(0, skip)) {
          this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
          return this;
        }
        skip -= next.length;
      } else {
        let next = top2.children[offset2 + (dir < 0 ? -1 : 0)];
        if (skip > next.length) {
          skip -= next.length;
          this.offsets[last2] += dir;
        } else {
          if (dir < 0)
            this.offsets[last2]--;
          this.nodes.push(next);
          this.offsets.push(dir > 0 ? 1 : (next instanceof TextLeaf ? next.text.length : next.children.length) << 1);
        }
      }
    }
  }
  next(skip = 0) {
    if (skip < 0) {
      this.nextInner(-skip, -this.dir);
      skip = this.value.length;
    }
    return this.nextInner(skip, this.dir);
  }
}
class PartialTextCursor {
  constructor(text2, start, end) {
    this.value = "";
    this.done = false;
    this.cursor = new RawTextCursor(text2, start > end ? -1 : 1);
    this.pos = start > end ? text2.length : 0;
    this.from = Math.min(start, end);
    this.to = Math.max(start, end);
  }
  nextInner(skip, dir) {
    if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
      this.value = "";
      this.done = true;
      return this;
    }
    skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
    let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
    if (skip > limit)
      skip = limit;
    limit -= skip;
    let { value } = this.cursor.next(skip);
    this.pos += (value.length + skip) * dir;
    this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
    this.done = !this.value;
    return this;
  }
  next(skip = 0) {
    if (skip < 0)
      skip = Math.max(skip, this.from - this.pos);
    else if (skip > 0)
      skip = Math.min(skip, this.to - this.pos);
    return this.nextInner(skip, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class LineCursor {
  constructor(inner) {
    this.inner = inner;
    this.afterBreak = true;
    this.value = "";
    this.done = false;
  }
  next(skip = 0) {
    let { done, lineBreak, value } = this.inner.next(skip);
    if (done && this.afterBreak) {
      this.value = "";
      this.afterBreak = false;
    } else if (done) {
      this.done = true;
      this.value = "";
    } else if (lineBreak) {
      if (this.afterBreak) {
        this.value = "";
      } else {
        this.afterBreak = true;
        this.next();
      }
    } else {
      this.value = value;
      this.afterBreak = false;
    }
    return this;
  }
  get lineBreak() {
    return false;
  }
}
if (typeof Symbol != "undefined") {
  Text$1.prototype[Symbol.iterator] = function() {
    return this.iter();
  };
  RawTextCursor.prototype[Symbol.iterator] = PartialTextCursor.prototype[Symbol.iterator] = LineCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
}
class Line {
  /**
  @internal
  */
  constructor(from, to2, number2, text2) {
    this.from = from;
    this.to = to2;
    this.number = number2;
    this.text = text2;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}
function clip(text2, from, to2) {
  from = Math.max(0, Math.min(text2.length, from));
  return [from, Math.max(from, Math.min(text2.length, to2))];
}
function findClusterBreak(str, pos, forward = true, includeExtending = true) {
  return findClusterBreak$1(str, pos, forward, includeExtending);
}
function surrogateLow(ch) {
  return ch >= 56320 && ch < 57344;
}
function surrogateHigh(ch) {
  return ch >= 55296 && ch < 56320;
}
function codePointAt(str, pos) {
  let code0 = str.charCodeAt(pos);
  if (!surrogateHigh(code0) || pos + 1 == str.length)
    return code0;
  let code1 = str.charCodeAt(pos + 1);
  if (!surrogateLow(code1))
    return code0;
  return (code0 - 55296 << 10) + (code1 - 56320) + 65536;
}
function fromCodePoint(code2) {
  if (code2 <= 65535)
    return String.fromCharCode(code2);
  code2 -= 65536;
  return String.fromCharCode((code2 >> 10) + 55296, (code2 & 1023) + 56320);
}
function codePointSize(code2) {
  return code2 < 65536 ? 1 : 2;
}
const DefaultSplit = /\r\n?|\n/;
var MapMode = /* @__PURE__ */ (function(MapMode2) {
  MapMode2[MapMode2["Simple"] = 0] = "Simple";
  MapMode2[MapMode2["TrackDel"] = 1] = "TrackDel";
  MapMode2[MapMode2["TrackBefore"] = 2] = "TrackBefore";
  MapMode2[MapMode2["TrackAfter"] = 3] = "TrackAfter";
  return MapMode2;
})(MapMode || (MapMode = {}));
class ChangeDesc {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(sections) {
    this.sections = sections;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let result2 = 0;
    for (let i2 = 0; i2 < this.sections.length; i2 += 2)
      result2 += this.sections[i2];
    return result2;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let result2 = 0;
    for (let i2 = 0; i2 < this.sections.length; i2 += 2) {
      let ins = this.sections[i2 + 1];
      result2 += ins < 0 ? this.sections[i2] : ins;
    }
    return result2;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(f2) {
    for (let i2 = 0, posA = 0, posB = 0; i2 < this.sections.length; ) {
      let len = this.sections[i2++], ins = this.sections[i2++];
      if (ins < 0) {
        f2(posA, posB, len);
        posB += len;
      } else {
        posB += ins;
      }
      posA += len;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(f2, individual = false) {
    iterChanges(this, f2, individual);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let sections = [];
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len = this.sections[i2++], ins = this.sections[i2++];
      if (ins < 0)
        sections.push(len, ins);
      else
        sections.push(ins, len);
    }
    return new ChangeDesc(sections);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(other) {
    return this.empty ? other : other.empty ? this : composeSets(this, other);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `this` happened before the ones in `other`.
  */
  mapDesc(other, before2 = false) {
    return other.empty ? this : mapSet(this, other, before2);
  }
  mapPos(pos, assoc = -1, mode = MapMode.Simple) {
    let posA = 0, posB = 0;
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len = this.sections[i2++], ins = this.sections[i2++], endA = posA + len;
      if (ins < 0) {
        if (endA > pos)
          return posB + (pos - posA);
        posB += len;
      } else {
        if (mode != MapMode.Simple && endA >= pos && (mode == MapMode.TrackDel && posA < pos && endA > pos || mode == MapMode.TrackBefore && posA < pos || mode == MapMode.TrackAfter && endA > pos))
          return null;
        if (endA > pos || endA == pos && assoc < 0 && !len)
          return pos == posA || assoc < 0 ? posB : posB + ins;
        posB += ins;
      }
      posA = endA;
    }
    if (pos > posA)
      throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
    return posB;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(from, to2 = from) {
    for (let i2 = 0, pos = 0; i2 < this.sections.length && pos <= to2; ) {
      let len = this.sections[i2++], ins = this.sections[i2++], end = pos + len;
      if (ins >= 0 && pos <= to2 && end >= from)
        return pos < from && end > to2 ? "cover" : true;
      pos = end;
    }
    return false;
  }
  /**
  @internal
  */
  toString() {
    let result2 = "";
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len = this.sections[i2++], ins = this.sections[i2++];
      result2 += (result2 ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
    }
    return result2;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(json) {
    if (!Array.isArray(json) || json.length % 2 || json.some((a) => typeof a != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new ChangeDesc(json);
  }
  /**
  @internal
  */
  static create(sections) {
    return new ChangeDesc(sections);
  }
}
class ChangeSet extends ChangeDesc {
  constructor(sections, inserted) {
    super(sections);
    this.inserted = inserted;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(doc2) {
    if (this.length != doc2.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    iterChanges(this, (fromA, toA, fromB, _toB, text2) => doc2 = doc2.replace(fromB, fromB + (toA - fromA), text2), false);
    return doc2;
  }
  mapDesc(other, before2 = false) {
    return mapSet(this, other, before2, true);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(doc2) {
    let sections = this.sections.slice(), inserted = [];
    for (let i2 = 0, pos = 0; i2 < sections.length; i2 += 2) {
      let len = sections[i2], ins = sections[i2 + 1];
      if (ins >= 0) {
        sections[i2] = ins;
        sections[i2 + 1] = len;
        let index2 = i2 >> 1;
        while (inserted.length < index2)
          inserted.push(Text$1.empty);
        inserted.push(len ? doc2.slice(pos, pos + len) : Text$1.empty);
      }
      pos += len;
    }
    return new ChangeSet(sections, inserted);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(other) {
    return this.empty ? other : other.empty ? this : composeSets(this, other, true);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(other, before2 = false) {
    return other.empty ? this : mapSet(this, other, before2, true);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(f2, individual = false) {
    iterChanges(this, f2, individual);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return ChangeDesc.create(this.sections);
  }
  /**
  @internal
  */
  filter(ranges) {
    let resultSections = [], resultInserted = [], filteredSections = [];
    let iter = new SectionIter(this);
    done: for (let i2 = 0, pos = 0; ; ) {
      let next = i2 == ranges.length ? 1e9 : ranges[i2++];
      while (pos < next || pos == next && iter.len == 0) {
        if (iter.done)
          break done;
        let len = Math.min(iter.len, next - pos);
        addSection(filteredSections, len, -1);
        let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
        addSection(resultSections, len, ins);
        if (ins > 0)
          addInsert(resultInserted, resultSections, iter.text);
        iter.forward(len);
        pos += len;
      }
      let end = ranges[i2++];
      while (pos < end) {
        if (iter.done)
          break done;
        let len = Math.min(iter.len, end - pos);
        addSection(resultSections, len, -1);
        addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
        iter.forward(len);
        pos += len;
      }
    }
    return {
      changes: new ChangeSet(resultSections, resultInserted),
      filtered: ChangeDesc.create(filteredSections)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let parts = [];
    for (let i2 = 0; i2 < this.sections.length; i2 += 2) {
      let len = this.sections[i2], ins = this.sections[i2 + 1];
      if (ins < 0)
        parts.push(len);
      else if (ins == 0)
        parts.push([len]);
      else
        parts.push([len].concat(this.inserted[i2 >> 1].toJSON()));
    }
    return parts;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(changes, length, lineSep) {
    let sections = [], inserted = [], pos = 0;
    let total = null;
    function flush(force = false) {
      if (!force && !sections.length)
        return;
      if (pos < length)
        addSection(sections, length - pos, -1);
      let set2 = new ChangeSet(sections, inserted);
      total = total ? total.compose(set2.map(total)) : set2;
      sections = [];
      inserted = [];
      pos = 0;
    }
    function process2(spec) {
      if (Array.isArray(spec)) {
        for (let sub2 of spec)
          process2(sub2);
      } else if (spec instanceof ChangeSet) {
        if (spec.length != length)
          throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
        flush();
        total = total ? total.compose(spec.map(total)) : spec;
      } else {
        let { from, to: to2 = from, insert: insert2 } = spec;
        if (from > to2 || from < 0 || to2 > length)
          throw new RangeError(`Invalid change range ${from} to ${to2} (in doc of length ${length})`);
        let insText = !insert2 ? Text$1.empty : typeof insert2 == "string" ? Text$1.of(insert2.split(lineSep || DefaultSplit)) : insert2;
        let insLen = insText.length;
        if (from == to2 && insLen == 0)
          return;
        if (from < pos)
          flush();
        if (from > pos)
          addSection(sections, from - pos, -1);
        addSection(sections, to2 - from, insLen);
        addInsert(inserted, sections, insText);
        pos = to2;
      }
    }
    process2(changes);
    flush(!total);
    return total;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(length) {
    return new ChangeSet(length ? [length, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(json) {
    if (!Array.isArray(json))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let sections = [], inserted = [];
    for (let i2 = 0; i2 < json.length; i2++) {
      let part = json[i2];
      if (typeof part == "number") {
        sections.push(part, -1);
      } else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e2, i22) => i22 && typeof e2 != "string")) {
        throw new RangeError("Invalid JSON representation of ChangeSet");
      } else if (part.length == 1) {
        sections.push(part[0], 0);
      } else {
        while (inserted.length < i2)
          inserted.push(Text$1.empty);
        inserted[i2] = Text$1.of(part.slice(1));
        sections.push(part[0], inserted[i2].length);
      }
    }
    return new ChangeSet(sections, inserted);
  }
  /**
  @internal
  */
  static createSet(sections, inserted) {
    return new ChangeSet(sections, inserted);
  }
}
function addSection(sections, len, ins, forceJoin = false) {
  if (len == 0 && ins <= 0)
    return;
  let last2 = sections.length - 2;
  if (last2 >= 0 && ins <= 0 && ins == sections[last2 + 1])
    sections[last2] += len;
  else if (last2 >= 0 && len == 0 && sections[last2] == 0)
    sections[last2 + 1] += ins;
  else if (forceJoin) {
    sections[last2] += len;
    sections[last2 + 1] += ins;
  } else
    sections.push(len, ins);
}
function addInsert(values2, sections, value) {
  if (value.length == 0)
    return;
  let index2 = sections.length - 2 >> 1;
  if (index2 < values2.length) {
    values2[values2.length - 1] = values2[values2.length - 1].append(value);
  } else {
    while (values2.length < index2)
      values2.push(Text$1.empty);
    values2.push(value);
  }
}
function iterChanges(desc, f2, individual) {
  let inserted = desc.inserted;
  for (let posA = 0, posB = 0, i2 = 0; i2 < desc.sections.length; ) {
    let len = desc.sections[i2++], ins = desc.sections[i2++];
    if (ins < 0) {
      posA += len;
      posB += len;
    } else {
      let endA = posA, endB = posB, text2 = Text$1.empty;
      for (; ; ) {
        endA += len;
        endB += ins;
        if (ins && inserted)
          text2 = text2.append(inserted[i2 - 2 >> 1]);
        if (individual || i2 == desc.sections.length || desc.sections[i2 + 1] < 0)
          break;
        len = desc.sections[i2++];
        ins = desc.sections[i2++];
      }
      f2(posA, endA, posB, endB, text2);
      posA = endA;
      posB = endB;
    }
  }
}
function mapSet(setA, setB, before2, mkSet = false) {
  let sections = [], insert2 = mkSet ? [] : null;
  let a = new SectionIter(setA), b2 = new SectionIter(setB);
  for (let inserted = -1; ; ) {
    if (a.done && b2.len || b2.done && a.len) {
      throw new Error("Mismatched change set lengths");
    } else if (a.ins == -1 && b2.ins == -1) {
      let len = Math.min(a.len, b2.len);
      addSection(sections, len, -1);
      a.forward(len);
      b2.forward(len);
    } else if (b2.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b2.len < a.len || b2.len == a.len && !before2))) {
      let len = b2.len;
      addSection(sections, b2.ins, -1);
      while (len) {
        let piece = Math.min(a.len, len);
        if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
          addSection(sections, 0, a.ins);
          if (insert2)
            addInsert(insert2, sections, a.text);
          inserted = a.i;
        }
        a.forward(piece);
        len -= piece;
      }
      b2.next();
    } else if (a.ins >= 0) {
      let len = 0, left = a.len;
      while (left) {
        if (b2.ins == -1) {
          let piece = Math.min(left, b2.len);
          len += piece;
          left -= piece;
          b2.forward(piece);
        } else if (b2.ins == 0 && b2.len < left) {
          left -= b2.len;
          b2.next();
        } else {
          break;
        }
      }
      addSection(sections, len, inserted < a.i ? a.ins : 0);
      if (insert2 && inserted < a.i)
        addInsert(insert2, sections, a.text);
      inserted = a.i;
      a.forward(a.len - left);
    } else if (a.done && b2.done) {
      return insert2 ? ChangeSet.createSet(sections, insert2) : ChangeDesc.create(sections);
    } else {
      throw new Error("Mismatched change set lengths");
    }
  }
}
function composeSets(setA, setB, mkSet = false) {
  let sections = [];
  let insert2 = mkSet ? [] : null;
  let a = new SectionIter(setA), b2 = new SectionIter(setB);
  for (let open = false; ; ) {
    if (a.done && b2.done) {
      return insert2 ? ChangeSet.createSet(sections, insert2) : ChangeDesc.create(sections);
    } else if (a.ins == 0) {
      addSection(sections, a.len, 0, open);
      a.next();
    } else if (b2.len == 0 && !b2.done) {
      addSection(sections, 0, b2.ins, open);
      if (insert2)
        addInsert(insert2, sections, b2.text);
      b2.next();
    } else if (a.done || b2.done) {
      throw new Error("Mismatched change set lengths");
    } else {
      let len = Math.min(a.len2, b2.len), sectionLen = sections.length;
      if (a.ins == -1) {
        let insB = b2.ins == -1 ? -1 : b2.off ? 0 : b2.ins;
        addSection(sections, len, insB, open);
        if (insert2 && insB)
          addInsert(insert2, sections, b2.text);
      } else if (b2.ins == -1) {
        addSection(sections, a.off ? 0 : a.len, len, open);
        if (insert2)
          addInsert(insert2, sections, a.textBit(len));
      } else {
        addSection(sections, a.off ? 0 : a.len, b2.off ? 0 : b2.ins, open);
        if (insert2 && !b2.off)
          addInsert(insert2, sections, b2.text);
      }
      open = (a.ins > len || b2.ins >= 0 && b2.len > len) && (open || sections.length > sectionLen);
      a.forward2(len);
      b2.forward(len);
    }
  }
}
class SectionIter {
  constructor(set2) {
    this.set = set2;
    this.i = 0;
    this.next();
  }
  next() {
    let { sections } = this.set;
    if (this.i < sections.length) {
      this.len = sections[this.i++];
      this.ins = sections[this.i++];
    } else {
      this.len = 0;
      this.ins = -2;
    }
    this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted } = this.set, index2 = this.i - 2 >> 1;
    return index2 >= inserted.length ? Text$1.empty : inserted[index2];
  }
  textBit(len) {
    let { inserted } = this.set, index2 = this.i - 2 >> 1;
    return index2 >= inserted.length && !len ? Text$1.empty : inserted[index2].slice(this.off, len == null ? void 0 : this.off + len);
  }
  forward(len) {
    if (len == this.len)
      this.next();
    else {
      this.len -= len;
      this.off += len;
    }
  }
  forward2(len) {
    if (this.ins == -1)
      this.forward(len);
    else if (len == this.ins)
      this.next();
    else {
      this.ins -= len;
      this.off += len;
    }
  }
}
let SelectionRange$1 = class SelectionRange {
  constructor(from, to2, flags) {
    this.from = from;
    this.to = to2;
    this.flags = flags;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let level = this.flags & 7;
    return level == 7 ? null : level;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let value = this.flags >> 6;
    return value == 16777215 ? void 0 : value;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(change, assoc = -1) {
    let from, to2;
    if (this.empty) {
      from = to2 = change.mapPos(this.from, assoc);
    } else {
      from = change.mapPos(this.from, 1);
      to2 = change.mapPos(this.to, -1);
    }
    return from == this.from && to2 == this.to ? this : new SelectionRange(from, to2, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(from, to2 = from) {
    if (from <= this.anchor && to2 >= this.anchor)
      return EditorSelection.range(from, to2);
    let head = Math.abs(from - this.anchor) > Math.abs(to2 - this.anchor) ? from : to2;
    return EditorSelection.range(this.anchor, head);
  }
  /**
  Compare this range to another range.
  */
  eq(other, includeAssoc = false) {
    return this.anchor == other.anchor && this.head == other.head && (!includeAssoc || !this.empty || this.assoc == other.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(json) {
    if (!json || typeof json.anchor != "number" || typeof json.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return EditorSelection.range(json.anchor, json.head);
  }
  /**
  @internal
  */
  static create(from, to2, flags) {
    return new SelectionRange(from, to2, flags);
  }
};
class EditorSelection {
  constructor(ranges, mainIndex) {
    this.ranges = ranges;
    this.mainIndex = mainIndex;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(change, assoc = -1) {
    if (change.empty)
      return this;
    return EditorSelection.create(this.ranges.map((r) => r.map(change, assoc)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(other, includeAssoc = false) {
    if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex)
      return false;
    for (let i2 = 0; i2 < this.ranges.length; i2++)
      if (!this.ranges[i2].eq(other.ranges[i2], includeAssoc))
        return false;
    return true;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new EditorSelection([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(range2, main2 = true) {
    return EditorSelection.create([range2].concat(this.ranges), main2 ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(range2, which = this.mainIndex) {
    let ranges = this.ranges.slice();
    ranges[which] = range2;
    return EditorSelection.create(ranges, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((r) => r.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(json) {
    if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new EditorSelection(json.ranges.map((r) => SelectionRange$1.fromJSON(r)), json.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(anchor, head = anchor) {
    return new EditorSelection([EditorSelection.range(anchor, head)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(ranges, mainIndex = 0) {
    if (ranges.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let pos = 0, i2 = 0; i2 < ranges.length; i2++) {
      let range2 = ranges[i2];
      if (range2.empty ? range2.from <= pos : range2.from < pos)
        return EditorSelection.normalized(ranges.slice(), mainIndex);
      pos = range2.to;
    }
    return new EditorSelection(ranges, mainIndex);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
    return SelectionRange$1.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 : 16) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(anchor, head, goalColumn, bidiLevel) {
    let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215) << 6 | (bidiLevel == null ? 7 : Math.min(6, bidiLevel));
    return head < anchor ? SelectionRange$1.create(head, anchor, 32 | 16 | flags) : SelectionRange$1.create(anchor, head, (head > anchor ? 8 : 0) | flags);
  }
  /**
  @internal
  */
  static normalized(ranges, mainIndex = 0) {
    let main2 = ranges[mainIndex];
    ranges.sort((a, b2) => a.from - b2.from);
    mainIndex = ranges.indexOf(main2);
    for (let i2 = 1; i2 < ranges.length; i2++) {
      let range2 = ranges[i2], prev = ranges[i2 - 1];
      if (range2.empty ? range2.from <= prev.to : range2.from < prev.to) {
        let from = prev.from, to2 = Math.max(range2.to, prev.to);
        if (i2 <= mainIndex)
          mainIndex--;
        ranges.splice(--i2, 2, range2.anchor > range2.head ? EditorSelection.range(to2, from) : EditorSelection.range(from, to2));
      }
    }
    return new EditorSelection(ranges, mainIndex);
  }
}
function checkSelection(selection2, docLength) {
  for (let range2 of selection2.ranges)
    if (range2.to > docLength)
      throw new RangeError("Selection points outside of document");
}
let nextID = 0;
class Facet {
  constructor(combine, compareInput, compare2, isStatic, enables) {
    this.combine = combine;
    this.compareInput = compareInput;
    this.compare = compare2;
    this.isStatic = isStatic;
    this.id = nextID++;
    this.default = combine([]);
    this.extensions = typeof enables == "function" ? enables(this) : enables;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(config2 = {}) {
    return new Facet(config2.combine || ((a) => a), config2.compareInput || ((a, b2) => a === b2), config2.compare || (!config2.combine ? sameArray$1 : (a, b2) => a === b2), !!config2.static, config2.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(value) {
    return new FacetProvider([], this, 0, value);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(deps, get2) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new FacetProvider(deps, this, 1, get2);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(deps, get2) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new FacetProvider(deps, this, 2, get2);
  }
  from(field, get2) {
    if (!get2)
      get2 = (x2) => x2;
    return this.compute([field], (state) => get2(state.field(field)));
  }
}
function sameArray$1(a, b2) {
  return a == b2 || a.length == b2.length && a.every((e2, i2) => e2 === b2[i2]);
}
class FacetProvider {
  constructor(dependencies2, facet, type, value) {
    this.dependencies = dependencies2;
    this.facet = facet;
    this.type = type;
    this.value = value;
    this.id = nextID++;
  }
  dynamicSlot(addresses) {
    var _a2;
    let getter = this.value;
    let compare2 = this.facet.compareInput;
    let id2 = this.id, idx = addresses[id2] >> 1, multi = this.type == 2;
    let depDoc = false, depSel = false, depAddrs = [];
    for (let dep of this.dependencies) {
      if (dep == "doc")
        depDoc = true;
      else if (dep == "selection")
        depSel = true;
      else if ((((_a2 = addresses[dep.id]) !== null && _a2 !== void 0 ? _a2 : 1) & 1) == 0)
        depAddrs.push(addresses[dep.id]);
    }
    return {
      create(state) {
        state.values[idx] = getter(state);
        return 1;
      },
      update(state, tr2) {
        if (depDoc && tr2.docChanged || depSel && (tr2.docChanged || tr2.selection) || ensureAll(state, depAddrs)) {
          let newVal = getter(state);
          if (multi ? !compareArray(newVal, state.values[idx], compare2) : !compare2(newVal, state.values[idx])) {
            state.values[idx] = newVal;
            return 1;
          }
        }
        return 0;
      },
      reconfigure: (state, oldState) => {
        let newVal, oldAddr = oldState.config.address[id2];
        if (oldAddr != null) {
          let oldVal = getAddr(oldState, oldAddr);
          if (this.dependencies.every((dep) => {
            return dep instanceof Facet ? oldState.facet(dep) === state.facet(dep) : dep instanceof StateField ? oldState.field(dep, false) == state.field(dep, false) : true;
          }) || (multi ? compareArray(newVal = getter(state), oldVal, compare2) : compare2(newVal = getter(state), oldVal))) {
            state.values[idx] = oldVal;
            return 0;
          }
        } else {
          newVal = getter(state);
        }
        state.values[idx] = newVal;
        return 1;
      }
    };
  }
}
function compareArray(a, b2, compare2) {
  if (a.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a.length; i2++)
    if (!compare2(a[i2], b2[i2]))
      return false;
  return true;
}
function ensureAll(state, addrs) {
  let changed = false;
  for (let addr of addrs)
    if (ensureAddr(state, addr) & 1)
      changed = true;
  return changed;
}
function dynamicFacetSlot(addresses, facet, providers) {
  let providerAddrs = providers.map((p) => addresses[p.id]);
  let providerTypes = providers.map((p) => p.type);
  let dynamic = providerAddrs.filter((p) => !(p & 1));
  let idx = addresses[facet.id] >> 1;
  function get2(state) {
    let values2 = [];
    for (let i2 = 0; i2 < providerAddrs.length; i2++) {
      let value = getAddr(state, providerAddrs[i2]);
      if (providerTypes[i2] == 2)
        for (let val of value)
          values2.push(val);
      else
        values2.push(value);
    }
    return facet.combine(values2);
  }
  return {
    create(state) {
      for (let addr of providerAddrs)
        ensureAddr(state, addr);
      state.values[idx] = get2(state);
      return 1;
    },
    update(state, tr2) {
      if (!ensureAll(state, dynamic))
        return 0;
      let value = get2(state);
      if (facet.compare(value, state.values[idx]))
        return 0;
      state.values[idx] = value;
      return 1;
    },
    reconfigure(state, oldState) {
      let depChanged = ensureAll(state, providerAddrs);
      let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
      if (oldProviders && !depChanged && sameArray$1(providers, oldProviders)) {
        state.values[idx] = oldValue;
        return 0;
      }
      let value = get2(state);
      if (facet.compare(value, oldValue)) {
        state.values[idx] = oldValue;
        return 0;
      }
      state.values[idx] = value;
      return 1;
    }
  };
}
const initField = /* @__PURE__ */ Facet.define({ static: true });
class StateField {
  constructor(id2, createF, updateF, compareF, spec) {
    this.id = id2;
    this.createF = createF;
    this.updateF = updateF;
    this.compareF = compareF;
    this.spec = spec;
    this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(config2) {
    let field = new StateField(nextID++, config2.create, config2.update, config2.compare || ((a, b2) => a === b2), config2);
    if (config2.provide)
      field.provides = config2.provide(field);
    return field;
  }
  create(state) {
    let init2 = state.facet(initField).find((i2) => i2.field == this);
    return ((init2 === null || init2 === void 0 ? void 0 : init2.create) || this.createF)(state);
  }
  /**
  @internal
  */
  slot(addresses) {
    let idx = addresses[this.id] >> 1;
    return {
      create: (state) => {
        state.values[idx] = this.create(state);
        return 1;
      },
      update: (state, tr2) => {
        let oldVal = state.values[idx];
        let value = this.updateF(oldVal, tr2);
        if (this.compareF(oldVal, value))
          return 0;
        state.values[idx] = value;
        return 1;
      },
      reconfigure: (state, oldState) => {
        let init2 = state.facet(initField), oldInit = oldState.facet(initField), reInit;
        if ((reInit = init2.find((i2) => i2.field == this)) && reInit != oldInit.find((i2) => i2.field == this)) {
          state.values[idx] = reInit.create(state);
          return 1;
        }
        if (oldState.config.address[this.id] != null) {
          state.values[idx] = oldState.field(this);
          return 0;
        }
        state.values[idx] = this.create(state);
        return 1;
      }
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(create2) {
    return [this, initField.of({ field: this, create: create2 })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const Prec_ = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function prec(value) {
  return (ext) => new PrecExtension(ext, value);
}
const Prec = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ prec(Prec_.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ prec(Prec_.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ prec(Prec_.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ prec(Prec_.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ prec(Prec_.lowest)
};
class PrecExtension {
  constructor(inner, prec2) {
    this.inner = inner;
    this.prec = prec2;
  }
}
class Compartment {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(ext) {
    return new CompartmentInstance(this, ext);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(content2) {
    return Compartment.reconfigure.of({ compartment: this, extension: content2 });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(state) {
    return state.config.compartments.get(this);
  }
}
class CompartmentInstance {
  constructor(compartment, inner) {
    this.compartment = compartment;
    this.inner = inner;
  }
}
class Configuration {
  constructor(base2, compartments, dynamicSlots, address, staticValues, facets) {
    this.base = base2;
    this.compartments = compartments;
    this.dynamicSlots = dynamicSlots;
    this.address = address;
    this.staticValues = staticValues;
    this.facets = facets;
    this.statusTemplate = [];
    while (this.statusTemplate.length < dynamicSlots.length)
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(facet) {
    let addr = this.address[facet.id];
    return addr == null ? facet.default : this.staticValues[addr >> 1];
  }
  static resolve(base2, compartments, oldState) {
    let fields = [];
    let facets = /* @__PURE__ */ Object.create(null);
    let newCompartments = /* @__PURE__ */ new Map();
    for (let ext of flatten(base2, compartments, newCompartments)) {
      if (ext instanceof StateField)
        fields.push(ext);
      else
        (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
    }
    let address = /* @__PURE__ */ Object.create(null);
    let staticValues = [];
    let dynamicSlots = [];
    for (let field of fields) {
      address[field.id] = dynamicSlots.length << 1;
      dynamicSlots.push((a) => field.slot(a));
    }
    let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
    for (let id2 in facets) {
      let providers = facets[id2], facet = providers[0].facet;
      let oldProviders = oldFacets && oldFacets[id2] || [];
      if (providers.every(
        (p) => p.type == 0
        /* Provider.Static */
      )) {
        address[facet.id] = staticValues.length << 1 | 1;
        if (sameArray$1(oldProviders, providers)) {
          staticValues.push(oldState.facet(facet));
        } else {
          let value = facet.combine(providers.map((p) => p.value));
          staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
        }
      } else {
        for (let p of providers) {
          if (p.type == 0) {
            address[p.id] = staticValues.length << 1 | 1;
            staticValues.push(p.value);
          } else {
            address[p.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a) => p.dynamicSlot(a));
          }
        }
        address[facet.id] = dynamicSlots.length << 1;
        dynamicSlots.push((a) => dynamicFacetSlot(a, facet, providers));
      }
    }
    let dynamic = dynamicSlots.map((f2) => f2(address));
    return new Configuration(base2, newCompartments, dynamic, address, staticValues, facets);
  }
}
function flatten(extension, compartments, newCompartments) {
  let result2 = [[], [], [], [], []];
  let seen = /* @__PURE__ */ new Map();
  function inner(ext, prec2) {
    let known = seen.get(ext);
    if (known != null) {
      if (known <= prec2)
        return;
      let found = result2[known].indexOf(ext);
      if (found > -1)
        result2[known].splice(found, 1);
      if (ext instanceof CompartmentInstance)
        newCompartments.delete(ext.compartment);
    }
    seen.set(ext, prec2);
    if (Array.isArray(ext)) {
      for (let e2 of ext)
        inner(e2, prec2);
    } else if (ext instanceof CompartmentInstance) {
      if (newCompartments.has(ext.compartment))
        throw new RangeError(`Duplicate use of compartment in extensions`);
      let content2 = compartments.get(ext.compartment) || ext.inner;
      newCompartments.set(ext.compartment, content2);
      inner(content2, prec2);
    } else if (ext instanceof PrecExtension) {
      inner(ext.inner, ext.prec);
    } else if (ext instanceof StateField) {
      result2[prec2].push(ext);
      if (ext.provides)
        inner(ext.provides, prec2);
    } else if (ext instanceof FacetProvider) {
      result2[prec2].push(ext);
      if (ext.facet.extensions)
        inner(ext.facet.extensions, Prec_.default);
    } else {
      let content2 = ext.extension;
      if (!content2)
        throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      inner(content2, prec2);
    }
  }
  inner(extension, Prec_.default);
  return result2.reduce((a, b2) => a.concat(b2));
}
function ensureAddr(state, addr) {
  if (addr & 1)
    return 2;
  let idx = addr >> 1;
  let status = state.status[idx];
  if (status == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (status & 2)
    return status;
  state.status[idx] = 4;
  let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
  return state.status[idx] = 2 | changed;
}
function getAddr(state, addr) {
  return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const languageData = /* @__PURE__ */ Facet.define();
const allowMultipleSelections = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((v2) => v2),
  static: true
});
const lineSeparator = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : void 0,
  static: true
});
const changeFilter = /* @__PURE__ */ Facet.define();
const transactionFilter = /* @__PURE__ */ Facet.define();
const transactionExtender = /* @__PURE__ */ Facet.define();
const readOnly = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : false
});
class Annotation {
  /**
  @internal
  */
  constructor(type, value) {
    this.type = type;
    this.value = value;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new AnnotationType();
  }
}
class AnnotationType {
  /**
  Create an instance of this annotation.
  */
  of(value) {
    return new Annotation(this, value);
  }
}
class StateEffectType {
  /**
  @internal
  */
  constructor(map2) {
    this.map = map2;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(value) {
    return new StateEffect(this, value);
  }
}
class StateEffect {
  /**
  @internal
  */
  constructor(type, value) {
    this.type = type;
    this.value = value;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(mapping) {
    let mapped = this.type.map(this.value, mapping);
    return mapped === void 0 ? void 0 : mapped == this.value ? this : new StateEffect(this.type, mapped);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(type) {
    return this.type == type;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(spec = {}) {
    return new StateEffectType(spec.map || ((v2) => v2));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(effects, mapping) {
    if (!effects.length)
      return effects;
    let result2 = [];
    for (let effect of effects) {
      let mapped = effect.map(mapping);
      if (mapped)
        result2.push(mapped);
    }
    return result2;
  }
}
StateEffect.reconfigure = /* @__PURE__ */ StateEffect.define();
StateEffect.appendConfig = /* @__PURE__ */ StateEffect.define();
class Transaction {
  constructor(startState, changes, selection2, effects, annotations, scrollIntoView2) {
    this.startState = startState;
    this.changes = changes;
    this.selection = selection2;
    this.effects = effects;
    this.annotations = annotations;
    this.scrollIntoView = scrollIntoView2;
    this._doc = null;
    this._state = null;
    if (selection2)
      checkSelection(selection2, changes.newLength);
    if (!annotations.some((a) => a.type == Transaction.time))
      this.annotations = annotations.concat(Transaction.time.of(Date.now()));
  }
  /**
  @internal
  */
  static create(startState, changes, selection2, effects, annotations, scrollIntoView2) {
    return new Transaction(startState, changes, selection2, effects, annotations, scrollIntoView2);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    if (!this._state)
      this.startState.applyTransaction(this);
    return this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(type) {
    for (let ann of this.annotations)
      if (ann.type == type)
        return ann.value;
    return void 0;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(event) {
    let e2 = this.annotation(Transaction.userEvent);
    return !!(e2 && (e2 == event || e2.length > event.length && e2.slice(0, event.length) == event && e2[event.length] == "."));
  }
}
Transaction.time = /* @__PURE__ */ Annotation.define();
Transaction.userEvent = /* @__PURE__ */ Annotation.define();
Transaction.addToHistory = /* @__PURE__ */ Annotation.define();
Transaction.remote = /* @__PURE__ */ Annotation.define();
function joinRanges(a, b2) {
  let result2 = [];
  for (let iA = 0, iB = 0; ; ) {
    let from, to2;
    if (iA < a.length && (iB == b2.length || b2[iB] >= a[iA])) {
      from = a[iA++];
      to2 = a[iA++];
    } else if (iB < b2.length) {
      from = b2[iB++];
      to2 = b2[iB++];
    } else
      return result2;
    if (!result2.length || result2[result2.length - 1] < from)
      result2.push(from, to2);
    else if (result2[result2.length - 1] < to2)
      result2[result2.length - 1] = to2;
  }
}
function mergeTransaction(a, b2, sequential) {
  var _a2;
  let mapForA, mapForB, changes;
  if (sequential) {
    mapForA = b2.changes;
    mapForB = ChangeSet.empty(b2.changes.length);
    changes = a.changes.compose(b2.changes);
  } else {
    mapForA = b2.changes.map(a.changes);
    mapForB = a.changes.mapDesc(b2.changes, true);
    changes = a.changes.compose(mapForA);
  }
  return {
    changes,
    selection: b2.selection ? b2.selection.map(mapForB) : (_a2 = a.selection) === null || _a2 === void 0 ? void 0 : _a2.map(mapForA),
    effects: StateEffect.mapEffects(a.effects, mapForA).concat(StateEffect.mapEffects(b2.effects, mapForB)),
    annotations: a.annotations.length ? a.annotations.concat(b2.annotations) : b2.annotations,
    scrollIntoView: a.scrollIntoView || b2.scrollIntoView
  };
}
function resolveTransactionInner(state, spec, docSize) {
  let sel = spec.selection, annotations = asArray$1(spec.annotations);
  if (spec.userEvent)
    annotations = annotations.concat(Transaction.userEvent.of(spec.userEvent));
  return {
    changes: spec.changes instanceof ChangeSet ? spec.changes : ChangeSet.of(spec.changes || [], docSize, state.facet(lineSeparator)),
    selection: sel && (sel instanceof EditorSelection ? sel : EditorSelection.single(sel.anchor, sel.head)),
    effects: asArray$1(spec.effects),
    annotations,
    scrollIntoView: !!spec.scrollIntoView
  };
}
function resolveTransaction(state, specs, filter2) {
  let s = resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
  if (specs.length && specs[0].filter === false)
    filter2 = false;
  for (let i2 = 1; i2 < specs.length; i2++) {
    if (specs[i2].filter === false)
      filter2 = false;
    let seq = !!specs[i2].sequential;
    s = mergeTransaction(s, resolveTransactionInner(state, specs[i2], seq ? s.changes.newLength : state.doc.length), seq);
  }
  let tr2 = Transaction.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
  return extendTransaction(filter2 ? filterTransaction(tr2) : tr2);
}
function filterTransaction(tr2) {
  let state = tr2.startState;
  let result2 = true;
  for (let filter2 of state.facet(changeFilter)) {
    let value = filter2(tr2);
    if (value === false) {
      result2 = false;
      break;
    }
    if (Array.isArray(value))
      result2 = result2 === true ? value : joinRanges(result2, value);
  }
  if (result2 !== true) {
    let changes, back;
    if (result2 === false) {
      back = tr2.changes.invertedDesc;
      changes = ChangeSet.empty(state.doc.length);
    } else {
      let filtered = tr2.changes.filter(result2);
      changes = filtered.changes;
      back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
    }
    tr2 = Transaction.create(state, changes, tr2.selection && tr2.selection.map(back), StateEffect.mapEffects(tr2.effects, back), tr2.annotations, tr2.scrollIntoView);
  }
  let filters = state.facet(transactionFilter);
  for (let i2 = filters.length - 1; i2 >= 0; i2--) {
    let filtered = filters[i2](tr2);
    if (filtered instanceof Transaction)
      tr2 = filtered;
    else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof Transaction)
      tr2 = filtered[0];
    else
      tr2 = resolveTransaction(state, asArray$1(filtered), false);
  }
  return tr2;
}
function extendTransaction(tr2) {
  let state = tr2.startState, extenders = state.facet(transactionExtender), spec = tr2;
  for (let i2 = extenders.length - 1; i2 >= 0; i2--) {
    let extension = extenders[i2](tr2);
    if (extension && Object.keys(extension).length)
      spec = mergeTransaction(spec, resolveTransactionInner(state, extension, tr2.changes.newLength), true);
  }
  return spec == tr2 ? tr2 : Transaction.create(state, tr2.changes, tr2.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const none$2 = [];
function asArray$1(value) {
  return value == null ? none$2 : Array.isArray(value) ? value : [value];
}
var CharCategory = /* @__PURE__ */ (function(CharCategory2) {
  CharCategory2[CharCategory2["Word"] = 0] = "Word";
  CharCategory2[CharCategory2["Space"] = 1] = "Space";
  CharCategory2[CharCategory2["Other"] = 2] = "Other";
  return CharCategory2;
})(CharCategory || (CharCategory = {}));
const nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let wordChar;
try {
  wordChar = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_2) {
}
function hasWordChar(str) {
  if (wordChar)
    return wordChar.test(str);
  for (let i2 = 0; i2 < str.length; i2++) {
    let ch = str[i2];
    if (/\w/.test(ch) || ch > "" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch)))
      return true;
  }
  return false;
}
function makeCategorizer(wordChars) {
  return (char) => {
    if (!/\S/.test(char))
      return CharCategory.Space;
    if (hasWordChar(char))
      return CharCategory.Word;
    for (let i2 = 0; i2 < wordChars.length; i2++)
      if (char.indexOf(wordChars[i2]) > -1)
        return CharCategory.Word;
    return CharCategory.Other;
  };
}
class EditorState {
  constructor(config2, doc2, selection2, values2, computeSlot, tr2) {
    this.config = config2;
    this.doc = doc2;
    this.selection = selection2;
    this.values = values2;
    this.status = config2.statusTemplate.slice();
    this.computeSlot = computeSlot;
    if (tr2)
      tr2._state = this;
    for (let i2 = 0; i2 < this.config.dynamicSlots.length; i2++)
      ensureAddr(this, i2 << 1);
    this.computeSlot = null;
  }
  field(field, require2 = true) {
    let addr = this.config.address[field.id];
    if (addr == null) {
      if (require2)
        throw new RangeError("Field is not present in this state");
      return void 0;
    }
    ensureAddr(this, addr);
    return getAddr(this, addr);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...specs) {
    return resolveTransaction(this, specs, true);
  }
  /**
  @internal
  */
  applyTransaction(tr2) {
    let conf = this.config, { base: base2, compartments } = conf;
    for (let effect of tr2.effects) {
      if (effect.is(Compartment.reconfigure)) {
        if (conf) {
          compartments = /* @__PURE__ */ new Map();
          conf.compartments.forEach((val, key) => compartments.set(key, val));
          conf = null;
        }
        compartments.set(effect.value.compartment, effect.value.extension);
      } else if (effect.is(StateEffect.reconfigure)) {
        conf = null;
        base2 = effect.value;
      } else if (effect.is(StateEffect.appendConfig)) {
        conf = null;
        base2 = asArray$1(base2).concat(effect.value);
      }
    }
    let startValues;
    if (!conf) {
      conf = Configuration.resolve(base2, compartments, this);
      let intermediateState = new EditorState(conf, this.doc, this.selection, conf.dynamicSlots.map(() => null), (state, slot) => slot.reconfigure(state, this), null);
      startValues = intermediateState.values;
    } else {
      startValues = tr2.startState.values.slice();
    }
    let selection2 = tr2.startState.facet(allowMultipleSelections) ? tr2.newSelection : tr2.newSelection.asSingle();
    new EditorState(conf, tr2.newDoc, selection2, startValues, (state, slot) => slot.update(state, tr2), tr2);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(text2) {
    if (typeof text2 == "string")
      text2 = this.toText(text2);
    return this.changeByRange((range2) => ({
      changes: { from: range2.from, to: range2.to, insert: text2 },
      range: EditorSelection.cursor(range2.from + text2.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(f2) {
    let sel = this.selection;
    let result1 = f2(sel.ranges[0]);
    let changes = this.changes(result1.changes), ranges = [result1.range];
    let effects = asArray$1(result1.effects);
    for (let i2 = 1; i2 < sel.ranges.length; i2++) {
      let result2 = f2(sel.ranges[i2]);
      let newChanges = this.changes(result2.changes), newMapped = newChanges.map(changes);
      for (let j2 = 0; j2 < i2; j2++)
        ranges[j2] = ranges[j2].map(newMapped);
      let mapBy = changes.mapDesc(newChanges, true);
      ranges.push(result2.range.map(mapBy));
      changes = changes.compose(newMapped);
      effects = StateEffect.mapEffects(effects, newMapped).concat(StateEffect.mapEffects(asArray$1(result2.effects), mapBy));
    }
    return {
      changes,
      selection: EditorSelection.create(ranges, sel.mainIndex),
      effects
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(spec = []) {
    if (spec instanceof ChangeSet)
      return spec;
    return ChangeSet.of(spec, this.doc.length, this.facet(EditorState.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(string2) {
    return Text$1.of(string2.split(this.facet(EditorState.lineSeparator) || DefaultSplit));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(from = 0, to2 = this.doc.length) {
    return this.doc.sliceString(from, to2, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(facet) {
    let addr = this.config.address[facet.id];
    if (addr == null)
      return facet.default;
    ensureAddr(this, addr);
    return getAddr(this, addr);
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(fields) {
    let result2 = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (fields)
      for (let prop in fields) {
        let value = fields[prop];
        if (value instanceof StateField && this.config.address[value.id] != null)
          result2[prop] = value.spec.toJSON(this.field(fields[prop]), this);
      }
    return result2;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(json, config2 = {}, fields) {
    if (!json || typeof json.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let fieldInit = [];
    if (fields)
      for (let prop in fields) {
        if (Object.prototype.hasOwnProperty.call(json, prop)) {
          let field = fields[prop], value = json[prop];
          fieldInit.push(field.init((state) => field.spec.fromJSON(value, state)));
        }
      }
    return EditorState.create({
      doc: json.doc,
      selection: EditorSelection.fromJSON(json.selection),
      extensions: config2.extensions ? fieldInit.concat([config2.extensions]) : fieldInit
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(config2 = {}) {
    let configuration = Configuration.resolve(config2.extensions || [], /* @__PURE__ */ new Map());
    let doc2 = config2.doc instanceof Text$1 ? config2.doc : Text$1.of((config2.doc || "").split(configuration.staticFacet(EditorState.lineSeparator) || DefaultSplit));
    let selection2 = !config2.selection ? EditorSelection.single(0) : config2.selection instanceof EditorSelection ? config2.selection : EditorSelection.single(config2.selection.anchor, config2.selection.head);
    checkSelection(selection2, doc2.length);
    if (!configuration.staticFacet(allowMultipleSelections))
      selection2 = selection2.asSingle();
    return new EditorState(configuration, doc2, selection2, configuration.dynamicSlots.map(() => null), (state, slot) => slot.create(state), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(EditorState.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(EditorState.lineSeparator) || "\n";
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(readOnly);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(phrase2, ...insert2) {
    for (let map2 of this.facet(EditorState.phrases))
      if (Object.prototype.hasOwnProperty.call(map2, phrase2)) {
        phrase2 = map2[phrase2];
        break;
      }
    if (insert2.length)
      phrase2 = phrase2.replace(/\$(\$|\d*)/g, (m, i2) => {
        if (i2 == "$")
          return "$";
        let n = +(i2 || 1);
        return !n || n > insert2.length ? m : insert2[n - 1];
      });
    return phrase2;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(name2, pos, side = -1) {
    let values2 = [];
    for (let provider of this.facet(languageData)) {
      for (let result2 of provider(this, pos, side)) {
        if (Object.prototype.hasOwnProperty.call(result2, name2))
          values2.push(result2[name2]);
      }
    }
    return values2;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(at2) {
    return makeCategorizer(this.languageDataAt("wordChars", at2).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(pos) {
    let { text: text2, from, length } = this.doc.lineAt(pos);
    let cat = this.charCategorizer(pos);
    let start = pos - from, end = pos - from;
    while (start > 0) {
      let prev = findClusterBreak(text2, start, false);
      if (cat(text2.slice(prev, start)) != CharCategory.Word)
        break;
      start = prev;
    }
    while (end < length) {
      let next = findClusterBreak(text2, end);
      if (cat(text2.slice(end, next)) != CharCategory.Word)
        break;
      end = next;
    }
    return start == end ? null : EditorSelection.range(start + from, end + from);
  }
}
EditorState.allowMultipleSelections = allowMultipleSelections;
EditorState.tabSize = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : 4
});
EditorState.lineSeparator = lineSeparator;
EditorState.readOnly = readOnly;
EditorState.phrases = /* @__PURE__ */ Facet.define({
  compare(a, b2) {
    let kA = Object.keys(a), kB = Object.keys(b2);
    return kA.length == kB.length && kA.every((k2) => a[k2] == b2[k2]);
  }
});
EditorState.languageData = languageData;
EditorState.changeFilter = changeFilter;
EditorState.transactionFilter = transactionFilter;
EditorState.transactionExtender = transactionExtender;
Compartment.reconfigure = /* @__PURE__ */ StateEffect.define();
function combineConfig(configs, defaults2, combine = {}) {
  let result2 = {};
  for (let config2 of configs)
    for (let key of Object.keys(config2)) {
      let value = config2[key], current2 = result2[key];
      if (current2 === void 0)
        result2[key] = value;
      else if (current2 === value || value === void 0) ;
      else if (Object.hasOwnProperty.call(combine, key))
        result2[key] = combine[key](current2, value);
      else
        throw new Error("Config merge conflict for field " + key);
    }
  for (let key in defaults2)
    if (result2[key] === void 0)
      result2[key] = defaults2[key];
  return result2;
}
class RangeValue {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(other) {
    return this == other;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(from, to2 = from) {
    return Range$3.create(from, to2, this);
  }
}
RangeValue.prototype.startSide = RangeValue.prototype.endSide = 0;
RangeValue.prototype.point = false;
RangeValue.prototype.mapMode = MapMode.TrackDel;
let Range$3 = class Range2 {
  constructor(from, to2, value) {
    this.from = from;
    this.to = to2;
    this.value = value;
  }
  /**
  @internal
  */
  static create(from, to2, value) {
    return new Range2(from, to2, value);
  }
};
function cmpRange(a, b2) {
  return a.from - b2.from || a.value.startSide - b2.value.startSide;
}
class Chunk {
  constructor(from, to2, value, maxPoint) {
    this.from = from;
    this.to = to2;
    this.value = value;
    this.maxPoint = maxPoint;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(pos, side, end, startAt = 0) {
    let arr = end ? this.to : this.from;
    for (let lo2 = startAt, hi = arr.length; ; ) {
      if (lo2 == hi)
        return lo2;
      let mid = lo2 + hi >> 1;
      let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
      if (mid == lo2)
        return diff >= 0 ? lo2 : hi;
      if (diff >= 0)
        hi = mid;
      else
        lo2 = mid + 1;
    }
  }
  between(offset2, from, to2, f2) {
    for (let i2 = this.findIndex(from, -1e9, true), e2 = this.findIndex(to2, 1e9, false, i2); i2 < e2; i2++)
      if (f2(this.from[i2] + offset2, this.to[i2] + offset2, this.value[i2]) === false)
        return false;
  }
  map(offset2, changes) {
    let value = [], from = [], to2 = [], newPos = -1, maxPoint = -1;
    for (let i2 = 0; i2 < this.value.length; i2++) {
      let val = this.value[i2], curFrom = this.from[i2] + offset2, curTo = this.to[i2] + offset2, newFrom, newTo;
      if (curFrom == curTo) {
        let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
        if (mapped == null)
          continue;
        newFrom = newTo = mapped;
        if (val.startSide != val.endSide) {
          newTo = changes.mapPos(curFrom, val.endSide);
          if (newTo < newFrom)
            continue;
        }
      } else {
        newFrom = changes.mapPos(curFrom, val.startSide);
        newTo = changes.mapPos(curTo, val.endSide);
        if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0)
          continue;
      }
      if ((newTo - newFrom || val.endSide - val.startSide) < 0)
        continue;
      if (newPos < 0)
        newPos = newFrom;
      if (val.point)
        maxPoint = Math.max(maxPoint, newTo - newFrom);
      value.push(val);
      from.push(newFrom - newPos);
      to2.push(newTo - newPos);
    }
    return { mapped: value.length ? new Chunk(from, to2, value, maxPoint) : null, pos: newPos };
  }
}
class RangeSet {
  constructor(chunkPos, chunk2, nextLayer, maxPoint) {
    this.chunkPos = chunkPos;
    this.chunk = chunk2;
    this.nextLayer = nextLayer;
    this.maxPoint = maxPoint;
  }
  /**
  @internal
  */
  static create(chunkPos, chunk2, nextLayer, maxPoint) {
    return new RangeSet(chunkPos, chunk2, nextLayer, maxPoint);
  }
  /**
  @internal
  */
  get length() {
    let last2 = this.chunk.length - 1;
    return last2 < 0 ? 0 : Math.max(this.chunkEnd(last2), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let size2 = this.nextLayer.size;
    for (let chunk2 of this.chunk)
      size2 += chunk2.value.length;
    return size2;
  }
  /**
  @internal
  */
  chunkEnd(index2) {
    return this.chunkPos[index2] + this.chunk[index2].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(updateSpec) {
    let { add: add2 = [], sort = false, filterFrom = 0, filterTo = this.length } = updateSpec;
    let filter2 = updateSpec.filter;
    if (add2.length == 0 && !filter2)
      return this;
    if (sort)
      add2 = add2.slice().sort(cmpRange);
    if (this.isEmpty)
      return add2.length ? RangeSet.of(add2) : this;
    let cur2 = new LayerCursor(this, null, -1).goto(0), i2 = 0, spill = [];
    let builder = new RangeSetBuilder();
    while (cur2.value || i2 < add2.length) {
      if (i2 < add2.length && (cur2.from - add2[i2].from || cur2.startSide - add2[i2].value.startSide) >= 0) {
        let range2 = add2[i2++];
        if (!builder.addInner(range2.from, range2.to, range2.value))
          spill.push(range2);
      } else if (cur2.rangeIndex == 1 && cur2.chunkIndex < this.chunk.length && (i2 == add2.length || this.chunkEnd(cur2.chunkIndex) < add2[i2].from) && (!filter2 || filterFrom > this.chunkEnd(cur2.chunkIndex) || filterTo < this.chunkPos[cur2.chunkIndex]) && builder.addChunk(this.chunkPos[cur2.chunkIndex], this.chunk[cur2.chunkIndex])) {
        cur2.nextChunk();
      } else {
        if (!filter2 || filterFrom > cur2.to || filterTo < cur2.from || filter2(cur2.from, cur2.to, cur2.value)) {
          if (!builder.addInner(cur2.from, cur2.to, cur2.value))
            spill.push(Range$3.create(cur2.from, cur2.to, cur2.value));
        }
        cur2.next();
      }
    }
    return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? RangeSet.empty : this.nextLayer.update({ add: spill, filter: filter2, filterFrom, filterTo }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(changes) {
    if (changes.empty || this.isEmpty)
      return this;
    let chunks = [], chunkPos = [], maxPoint = -1;
    for (let i2 = 0; i2 < this.chunk.length; i2++) {
      let start = this.chunkPos[i2], chunk2 = this.chunk[i2];
      let touch = changes.touchesRange(start, start + chunk2.length);
      if (touch === false) {
        maxPoint = Math.max(maxPoint, chunk2.maxPoint);
        chunks.push(chunk2);
        chunkPos.push(changes.mapPos(start));
      } else if (touch === true) {
        let { mapped, pos } = chunk2.map(start, changes);
        if (mapped) {
          maxPoint = Math.max(maxPoint, mapped.maxPoint);
          chunks.push(mapped);
          chunkPos.push(pos);
        }
      }
    }
    let next = this.nextLayer.map(changes);
    return chunks.length == 0 ? next : new RangeSet(chunkPos, chunks, next || RangeSet.empty, maxPoint);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(from, to2, f2) {
    if (this.isEmpty)
      return;
    for (let i2 = 0; i2 < this.chunk.length; i2++) {
      let start = this.chunkPos[i2], chunk2 = this.chunk[i2];
      if (to2 >= start && from <= start + chunk2.length && chunk2.between(start, from - start, to2 - start, f2) === false)
        return;
    }
    this.nextLayer.between(from, to2, f2);
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(from = 0) {
    return HeapCursor.from([this]).goto(from);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(sets2, from = 0) {
    return HeapCursor.from(sets2).goto(from);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(oldSets, newSets, textDiff, comparator, minPointSize = -1) {
    let a = oldSets.filter((set2) => set2.maxPoint > 0 || !set2.isEmpty && set2.maxPoint >= minPointSize);
    let b2 = newSets.filter((set2) => set2.maxPoint > 0 || !set2.isEmpty && set2.maxPoint >= minPointSize);
    let sharedChunks = findSharedChunks(a, b2, textDiff);
    let sideA = new SpanCursor(a, sharedChunks, minPointSize);
    let sideB = new SpanCursor(b2, sharedChunks, minPointSize);
    textDiff.iterGaps((fromA, fromB, length) => compare(sideA, fromA, sideB, fromB, length, comparator));
    if (textDiff.empty && textDiff.length == 0)
      compare(sideA, 0, sideB, 0, 0, comparator);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(oldSets, newSets, from = 0, to2) {
    if (to2 == null)
      to2 = 1e9 - 1;
    let a = oldSets.filter((set2) => !set2.isEmpty && newSets.indexOf(set2) < 0);
    let b2 = newSets.filter((set2) => !set2.isEmpty && oldSets.indexOf(set2) < 0);
    if (a.length != b2.length)
      return false;
    if (!a.length)
      return true;
    let sharedChunks = findSharedChunks(a, b2);
    let sideA = new SpanCursor(a, sharedChunks, 0).goto(from), sideB = new SpanCursor(b2, sharedChunks, 0).goto(from);
    for (; ; ) {
      if (sideA.to != sideB.to || !sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point)))
        return false;
      if (sideA.to > to2)
        return true;
      sideA.next();
      sideB.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(sets2, from, to2, iterator, minPointSize = -1) {
    let cursor2 = new SpanCursor(sets2, null, minPointSize).goto(from), pos = from;
    let openRanges = cursor2.openStart;
    for (; ; ) {
      let curTo = Math.min(cursor2.to, to2);
      if (cursor2.point) {
        let active = cursor2.activeForPoint(cursor2.to);
        let openCount = cursor2.pointFrom < from ? active.length + 1 : cursor2.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
        iterator.point(pos, curTo, cursor2.point, active, openCount, cursor2.pointRank);
        openRanges = Math.min(cursor2.openEnd(curTo), active.length);
      } else if (curTo > pos) {
        iterator.span(pos, curTo, cursor2.active, openRanges);
        openRanges = cursor2.openEnd(curTo);
      }
      if (cursor2.to > to2)
        return openRanges + (cursor2.point && cursor2.to > to2 ? 1 : 0);
      pos = cursor2.to;
      cursor2.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(ranges, sort = false) {
    let build = new RangeSetBuilder();
    for (let range2 of ranges instanceof Range$3 ? [ranges] : sort ? lazySort(ranges) : ranges)
      build.add(range2.from, range2.to, range2.value);
    return build.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(sets2) {
    if (!sets2.length)
      return RangeSet.empty;
    let result2 = sets2[sets2.length - 1];
    for (let i2 = sets2.length - 2; i2 >= 0; i2--) {
      for (let layer2 = sets2[i2]; layer2 != RangeSet.empty; layer2 = layer2.nextLayer)
        result2 = new RangeSet(layer2.chunkPos, layer2.chunk, result2, Math.max(layer2.maxPoint, result2.maxPoint));
    }
    return result2;
  }
}
RangeSet.empty = /* @__PURE__ */ new RangeSet([], [], null, -1);
function lazySort(ranges) {
  if (ranges.length > 1)
    for (let prev = ranges[0], i2 = 1; i2 < ranges.length; i2++) {
      let cur2 = ranges[i2];
      if (cmpRange(prev, cur2) > 0)
        return ranges.slice().sort(cmpRange);
      prev = cur2;
    }
  return ranges;
}
RangeSet.empty.nextLayer = RangeSet.empty;
class RangeSetBuilder {
  finishChunk(newArrays) {
    this.chunks.push(new Chunk(this.from, this.to, this.value, this.maxPoint));
    this.chunkPos.push(this.chunkStart);
    this.chunkStart = -1;
    this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
    this.maxPoint = -1;
    if (newArrays) {
      this.from = [];
      this.to = [];
      this.value = [];
    }
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [];
    this.chunkPos = [];
    this.chunkStart = -1;
    this.last = null;
    this.lastFrom = -1e9;
    this.lastTo = -1e9;
    this.from = [];
    this.to = [];
    this.value = [];
    this.maxPoint = -1;
    this.setMaxPoint = -1;
    this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(from, to2, value) {
    if (!this.addInner(from, to2, value))
      (this.nextLayer || (this.nextLayer = new RangeSetBuilder())).add(from, to2, value);
  }
  /**
  @internal
  */
  addInner(from, to2, value) {
    let diff = from - this.lastTo || value.startSide - this.last.endSide;
    if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    if (diff < 0)
      return false;
    if (this.from.length == 250)
      this.finishChunk(true);
    if (this.chunkStart < 0)
      this.chunkStart = from;
    this.from.push(from - this.chunkStart);
    this.to.push(to2 - this.chunkStart);
    this.last = value;
    this.lastFrom = from;
    this.lastTo = to2;
    this.value.push(value);
    if (value.point)
      this.maxPoint = Math.max(this.maxPoint, to2 - from);
    return true;
  }
  /**
  @internal
  */
  addChunk(from, chunk2) {
    if ((from - this.lastTo || chunk2.value[0].startSide - this.last.endSide) < 0)
      return false;
    if (this.from.length)
      this.finishChunk(true);
    this.setMaxPoint = Math.max(this.setMaxPoint, chunk2.maxPoint);
    this.chunks.push(chunk2);
    this.chunkPos.push(from);
    let last2 = chunk2.value.length - 1;
    this.last = chunk2.value[last2];
    this.lastFrom = chunk2.from[last2] + from;
    this.lastTo = chunk2.to[last2] + from;
    return true;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(RangeSet.empty);
  }
  /**
  @internal
  */
  finishInner(next) {
    if (this.from.length)
      this.finishChunk(false);
    if (this.chunks.length == 0)
      return next;
    let result2 = RangeSet.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
    this.from = null;
    return result2;
  }
}
function findSharedChunks(a, b2, textDiff) {
  let inA = /* @__PURE__ */ new Map();
  for (let set2 of a)
    for (let i2 = 0; i2 < set2.chunk.length; i2++)
      if (set2.chunk[i2].maxPoint <= 0)
        inA.set(set2.chunk[i2], set2.chunkPos[i2]);
  let shared = /* @__PURE__ */ new Set();
  for (let set2 of b2)
    for (let i2 = 0; i2 < set2.chunk.length; i2++) {
      let known = inA.get(set2.chunk[i2]);
      if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set2.chunkPos[i2] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set2.chunk[i2].length)))
        shared.add(set2.chunk[i2]);
    }
  return shared;
}
class LayerCursor {
  constructor(layer2, skip, minPoint, rank = 0) {
    this.layer = layer2;
    this.skip = skip;
    this.minPoint = minPoint;
    this.rank = rank;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(pos, side = -1e9) {
    this.chunkIndex = this.rangeIndex = 0;
    this.gotoInner(pos, side, false);
    return this;
  }
  gotoInner(pos, side, forward) {
    while (this.chunkIndex < this.layer.chunk.length) {
      let next = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint))
        break;
      this.chunkIndex++;
      forward = false;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
      if (!forward || this.rangeIndex < rangeIndex)
        this.setRangeIndex(rangeIndex);
    }
    this.next();
  }
  forward(pos, side) {
    if ((this.to - pos || this.endSide - side) < 0)
      this.gotoInner(pos, side, true);
  }
  next() {
    for (; ; ) {
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9;
        this.value = null;
        break;
      } else {
        let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk2 = this.layer.chunk[this.chunkIndex];
        let from = chunkPos + chunk2.from[this.rangeIndex];
        this.from = from;
        this.to = chunkPos + chunk2.to[this.rangeIndex];
        this.value = chunk2.value[this.rangeIndex];
        this.setRangeIndex(this.rangeIndex + 1);
        if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
    }
  }
  setRangeIndex(index2) {
    if (index2 == this.layer.chunk[this.chunkIndex].value.length) {
      this.chunkIndex++;
      if (this.skip) {
        while (this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))
          this.chunkIndex++;
      }
      this.rangeIndex = 0;
    } else {
      this.rangeIndex = index2;
    }
  }
  nextChunk() {
    this.chunkIndex++;
    this.rangeIndex = 0;
    this.next();
  }
  compare(other) {
    return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
  }
}
class HeapCursor {
  constructor(heap) {
    this.heap = heap;
  }
  static from(sets2, skip = null, minPoint = -1) {
    let heap = [];
    for (let i2 = 0; i2 < sets2.length; i2++) {
      for (let cur2 = sets2[i2]; !cur2.isEmpty; cur2 = cur2.nextLayer) {
        if (cur2.maxPoint >= minPoint)
          heap.push(new LayerCursor(cur2, skip, minPoint, i2));
      }
    }
    return heap.length == 1 ? heap[0] : new HeapCursor(heap);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(pos, side = -1e9) {
    for (let cur2 of this.heap)
      cur2.goto(pos, side);
    for (let i2 = this.heap.length >> 1; i2 >= 0; i2--)
      heapBubble(this.heap, i2);
    this.next();
    return this;
  }
  forward(pos, side) {
    for (let cur2 of this.heap)
      cur2.forward(pos, side);
    for (let i2 = this.heap.length >> 1; i2 >= 0; i2--)
      heapBubble(this.heap, i2);
    if ((this.to - pos || this.value.endSide - side) < 0)
      this.next();
  }
  next() {
    if (this.heap.length == 0) {
      this.from = this.to = 1e9;
      this.value = null;
      this.rank = -1;
    } else {
      let top2 = this.heap[0];
      this.from = top2.from;
      this.to = top2.to;
      this.value = top2.value;
      this.rank = top2.rank;
      if (top2.value)
        top2.next();
      heapBubble(this.heap, 0);
    }
  }
}
function heapBubble(heap, index2) {
  for (let cur2 = heap[index2]; ; ) {
    let childIndex = (index2 << 1) + 1;
    if (childIndex >= heap.length)
      break;
    let child = heap[childIndex];
    if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
      child = heap[childIndex + 1];
      childIndex++;
    }
    if (cur2.compare(child) < 0)
      break;
    heap[childIndex] = cur2;
    heap[index2] = child;
    index2 = childIndex;
  }
}
class SpanCursor {
  constructor(sets2, skip, minPoint) {
    this.minPoint = minPoint;
    this.active = [];
    this.activeTo = [];
    this.activeRank = [];
    this.minActive = -1;
    this.point = null;
    this.pointFrom = 0;
    this.pointRank = 0;
    this.to = -1e9;
    this.endSide = 0;
    this.openStart = -1;
    this.cursor = HeapCursor.from(sets2, skip, minPoint);
  }
  goto(pos, side = -1e9) {
    this.cursor.goto(pos, side);
    this.active.length = this.activeTo.length = this.activeRank.length = 0;
    this.minActive = -1;
    this.to = pos;
    this.endSide = side;
    this.openStart = -1;
    this.next();
    return this;
  }
  forward(pos, side) {
    while (this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)
      this.removeActive(this.minActive);
    this.cursor.forward(pos, side);
  }
  removeActive(index2) {
    remove(this.active, index2);
    remove(this.activeTo, index2);
    remove(this.activeRank, index2);
    this.minActive = findMinIndex(this.active, this.activeTo);
  }
  addActive(trackOpen) {
    let i2 = 0, { value, to: to2, rank } = this.cursor;
    while (i2 < this.activeRank.length && (rank - this.activeRank[i2] || to2 - this.activeTo[i2]) > 0)
      i2++;
    insert(this.active, i2, value);
    insert(this.activeTo, i2, to2);
    insert(this.activeRank, i2, rank);
    if (trackOpen)
      insert(trackOpen, i2, this.cursor.from);
    this.minActive = findMinIndex(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let from = this.to, wasPoint = this.point;
    this.point = null;
    let trackOpen = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let a = this.minActive;
      if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[a] > from) {
          this.to = this.activeTo[a];
          this.endSide = this.active[a].endSide;
          break;
        }
        this.removeActive(a);
        if (trackOpen)
          remove(trackOpen, a);
      } else if (!this.cursor.value) {
        this.to = this.endSide = 1e9;
        break;
      } else if (this.cursor.from > from) {
        this.to = this.cursor.from;
        this.endSide = this.cursor.startSide;
        break;
      } else {
        let nextVal = this.cursor.value;
        if (!nextVal.point) {
          this.addActive(trackOpen);
          this.cursor.next();
        } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) {
          this.cursor.next();
        } else {
          this.point = nextVal;
          this.pointFrom = this.cursor.from;
          this.pointRank = this.cursor.rank;
          this.to = this.cursor.to;
          this.endSide = nextVal.endSide;
          this.cursor.next();
          this.forward(this.to, this.endSide);
          break;
        }
      }
    }
    if (trackOpen) {
      this.openStart = 0;
      for (let i2 = trackOpen.length - 1; i2 >= 0 && trackOpen[i2] < from; i2--)
        this.openStart++;
    }
  }
  activeForPoint(to2) {
    if (!this.active.length)
      return this.active;
    let active = [];
    for (let i2 = this.active.length - 1; i2 >= 0; i2--) {
      if (this.activeRank[i2] < this.pointRank)
        break;
      if (this.activeTo[i2] > to2 || this.activeTo[i2] == to2 && this.active[i2].endSide >= this.point.endSide)
        active.push(this.active[i2]);
    }
    return active.reverse();
  }
  openEnd(to2) {
    let open = 0;
    for (let i2 = this.activeTo.length - 1; i2 >= 0 && this.activeTo[i2] > to2; i2--)
      open++;
    return open;
  }
}
function compare(a, startA, b2, startB, length, comparator) {
  a.goto(startA);
  b2.goto(startB);
  let endB = startB + length;
  let pos = startB, dPos = startB - startA;
  for (; ; ) {
    let dEnd = a.to + dPos - b2.to, diff = dEnd || a.endSide - b2.endSide;
    let end = diff < 0 ? a.to + dPos : b2.to, clipEnd = Math.min(end, endB);
    if (a.point || b2.point) {
      if (!(a.point && b2.point && (a.point == b2.point || a.point.eq(b2.point)) && sameValues(a.activeForPoint(a.to), b2.activeForPoint(b2.to))))
        comparator.comparePoint(pos, clipEnd, a.point, b2.point);
    } else {
      if (clipEnd > pos && !sameValues(a.active, b2.active))
        comparator.compareRange(pos, clipEnd, a.active, b2.active);
    }
    if (end > endB)
      break;
    if ((dEnd || a.openEnd != b2.openEnd) && comparator.boundChange)
      comparator.boundChange(end);
    pos = end;
    if (diff <= 0)
      a.next();
    if (diff >= 0)
      b2.next();
  }
}
function sameValues(a, b2) {
  if (a.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a.length; i2++)
    if (a[i2] != b2[i2] && !a[i2].eq(b2[i2]))
      return false;
  return true;
}
function remove(array, index2) {
  for (let i2 = index2, e2 = array.length - 1; i2 < e2; i2++)
    array[i2] = array[i2 + 1];
  array.pop();
}
function insert(array, index2, value) {
  for (let i2 = array.length - 1; i2 >= index2; i2--)
    array[i2 + 1] = array[i2];
  array[index2] = value;
}
function findMinIndex(value, array) {
  let found = -1, foundPos = 1e9;
  for (let i2 = 0; i2 < array.length; i2++)
    if ((array[i2] - foundPos || value[i2].endSide - value[found].endSide) < 0) {
      found = i2;
      foundPos = array[i2];
    }
  return found;
}
function countColumn(string2, tabSize, to2 = string2.length) {
  let n = 0;
  for (let i2 = 0; i2 < to2 && i2 < string2.length; ) {
    if (string2.charCodeAt(i2) == 9) {
      n += tabSize - n % tabSize;
      i2++;
    } else {
      n++;
      i2 = findClusterBreak(string2, i2);
    }
  }
  return n;
}
function findColumn(string2, col, tabSize, strict) {
  for (let i2 = 0, n = 0; ; ) {
    if (n >= col)
      return i2;
    if (i2 == string2.length)
      break;
    n += string2.charCodeAt(i2) == 9 ? tabSize - n % tabSize : 1;
    i2 = findClusterBreak(string2, i2);
  }
  return strict === true ? -1 : string2.length;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t2 = arguments[e2];
      for (var r in t2) ({}).hasOwnProperty.call(t2, r) && (n[r] = t2[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e2) {
  if (null == r) return {};
  var t2 = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e2.indexOf(n)) continue;
    t2[n] = r[n];
  }
  return t2;
}
const C = "ͼ";
const COUNT = typeof Symbol == "undefined" ? "__" + C : Symbol.for(C);
const SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class StyleModule {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(spec, options2) {
    this.rules = [];
    let { finish } = options2 || {};
    function splitSelector(selector2) {
      return /^@/.test(selector2) ? [selector2] : selector2.split(/,\s*/);
    }
    function render(selectors, spec2, target, isKeyframes) {
      let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
      if (isAt && spec2 == null) return target.push(selectors[0] + ";");
      for (let prop in spec2) {
        let value = spec2[prop];
        if (/&/.test(prop)) {
          render(
            prop.split(/,\s*/).map((part) => selectors.map((sel) => part.replace(/&/, sel))).reduce((a, b2) => a.concat(b2)),
            value,
            target
          );
        } else if (value && typeof value == "object") {
          if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
          render(splitSelector(prop), value, local, keyframes);
        } else if (value != null) {
          local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l) => "-" + l.toLowerCase()) + ": " + value + ";");
        }
      }
      if (local.length || keyframes) {
        target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
      }
    }
    for (let prop in spec) render(splitSelector(prop), spec[prop], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join("\n");
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let id2 = top[COUNT] || 1;
    top[COUNT] = id2 + 1;
    return C + id2.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(root2, modules, options2) {
    let set2 = root2[SET], nonce = options2 && options2.nonce;
    if (!set2) set2 = new StyleSet(root2, nonce);
    else if (nonce) set2.setNonce(nonce);
    set2.mount(Array.isArray(modules) ? modules : [modules], root2);
  }
}
let adoptedSet = /* @__PURE__ */ new Map();
class StyleSet {
  constructor(root2, nonce) {
    let doc2 = root2.ownerDocument || root2, win = doc2.defaultView;
    if (!root2.head && root2.adoptedStyleSheets && win.CSSStyleSheet) {
      let adopted = adoptedSet.get(doc2);
      if (adopted) return root2[SET] = adopted;
      this.sheet = new win.CSSStyleSheet();
      adoptedSet.set(doc2, this);
    } else {
      this.styleTag = doc2.createElement("style");
      if (nonce) this.styleTag.setAttribute("nonce", nonce);
    }
    this.modules = [];
    root2[SET] = this;
  }
  mount(modules, root2) {
    let sheet = this.sheet;
    let pos = 0, j2 = 0;
    for (let i2 = 0; i2 < modules.length; i2++) {
      let mod2 = modules[i2], index2 = this.modules.indexOf(mod2);
      if (index2 < j2 && index2 > -1) {
        this.modules.splice(index2, 1);
        j2--;
        index2 = -1;
      }
      if (index2 == -1) {
        this.modules.splice(j2++, 0, mod2);
        if (sheet) for (let k2 = 0; k2 < mod2.rules.length; k2++)
          sheet.insertRule(mod2.rules[k2], pos++);
      } else {
        while (j2 < index2) pos += this.modules[j2++].rules.length;
        pos += mod2.rules.length;
        j2++;
      }
    }
    if (sheet) {
      if (root2.adoptedStyleSheets.indexOf(this.sheet) < 0)
        root2.adoptedStyleSheets = [this.sheet, ...root2.adoptedStyleSheets];
    } else {
      let text2 = "";
      for (let i2 = 0; i2 < this.modules.length; i2++)
        text2 += this.modules[i2].getRules() + "\n";
      this.styleTag.textContent = text2;
      let target = root2.head || root2;
      if (this.styleTag.parentNode != target)
        target.insertBefore(this.styleTag, target.firstChild);
    }
  }
  setNonce(nonce) {
    if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce)
      this.styleTag.setAttribute("nonce", nonce);
  }
}
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
};
var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
};
var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie$1 = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i);
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i;
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32);
  shift[i] = String.fromCharCode(i);
}
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code];
function keyName(event) {
  var ignoreKey = mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || ie$1 && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
  var name2 = !ignoreKey && event.key || (event.shiftKey ? shift : base)[event.keyCode] || event.key || "Unidentified";
  if (name2 == "Esc") name2 = "Escape";
  if (name2 == "Del") name2 = "Delete";
  if (name2 == "Left") name2 = "ArrowLeft";
  if (name2 == "Up") name2 = "ArrowUp";
  if (name2 == "Right") name2 = "ArrowRight";
  if (name2 == "Down") name2 = "ArrowDown";
  return name2;
}
function crelt() {
  var elt = arguments[0];
  if (typeof elt == "string") elt = document.createElement(elt);
  var i2 = 1, next = arguments[1];
  if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
    for (var name2 in next) if (Object.prototype.hasOwnProperty.call(next, name2)) {
      var value = next[name2];
      if (typeof value == "string") elt.setAttribute(name2, value);
      else if (value != null) elt[name2] = value;
    }
    i2++;
  }
  for (; i2 < arguments.length; i2++) add(elt, arguments[i2]);
  return elt;
}
function add(elt, child) {
  if (typeof child == "string") {
    elt.appendChild(document.createTextNode(child));
  } else if (child == null) ;
  else if (child.nodeType != null) {
    elt.appendChild(child);
  } else if (Array.isArray(child)) {
    for (var i2 = 0; i2 < child.length; i2++) add(elt, child[i2]);
  } else {
    throw new RangeError("Unsupported child node: " + child);
  }
}
let nav = typeof navigator != "undefined" ? navigator : { userAgent: "", vendor: "", platform: "" };
let doc = typeof document != "undefined" ? document : { documentElement: { style: {} } };
const ie_edge = /* @__PURE__ */ /Edge\/(\d+)/.exec(nav.userAgent);
const ie_upto10 = /* @__PURE__ */ /MSIE \d/.test(nav.userAgent);
const ie_11up = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(nav.userAgent);
const ie$2 = !!(ie_upto10 || ie_11up || ie_edge);
const gecko = !ie$2 && /* @__PURE__ */ /gecko\/(\d+)/i.test(nav.userAgent);
const chrome$1 = !ie$2 && /* @__PURE__ */ /Chrome\/(\d+)/.exec(nav.userAgent);
const webkit = "webkitFontSmoothing" in doc.documentElement.style;
const safari = !ie$2 && /* @__PURE__ */ /Apple Computer/.test(nav.vendor);
const ios = safari && (/* @__PURE__ */ /Mobile\/\w+/.test(nav.userAgent) || nav.maxTouchPoints > 2);
var browser$2 = {
  mac: ios || /* @__PURE__ */ /Mac/.test(nav.platform),
  windows: /* @__PURE__ */ /Win/.test(nav.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(nav.platform),
  ie: ie$2,
  ie_version: ie_upto10 ? doc.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0,
  gecko,
  gecko_version: gecko ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(nav.userAgent) || [0, 0])[1] : 0,
  chrome: !!chrome$1,
  chrome_version: chrome$1 ? +chrome$1[1] : 0,
  ios,
  android: /* @__PURE__ */ /Android\b/.test(nav.userAgent),
  webkit_version: webkit ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(nav.userAgent) || [0, 0])[1] : 0,
  safari,
  safari_version: safari ? +(/* @__PURE__ */ /\bVersion\/(\d+(\.\d+)?)/.exec(nav.userAgent) || [0, 0])[1] : 0,
  tabSize: doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
function getSelection(root2) {
  let target;
  if (root2.nodeType == 11) {
    target = root2.getSelection ? root2 : root2.ownerDocument;
  } else {
    target = root2;
  }
  return target.getSelection();
}
function contains(dom, node) {
  return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function hasSelection(dom, selection2) {
  if (!selection2.anchorNode)
    return false;
  try {
    return contains(dom, selection2.anchorNode);
  } catch (_2) {
    return false;
  }
}
function clientRectsFor(dom) {
  if (dom.nodeType == 3)
    return textRange(dom, 0, dom.nodeValue.length).getClientRects();
  else if (dom.nodeType == 1)
    return dom.getClientRects();
  else
    return [];
}
function isEquivalentPosition(node, off2, targetNode, targetOff) {
  return targetNode ? scanFor(node, off2, targetNode, targetOff, -1) || scanFor(node, off2, targetNode, targetOff, 1) : false;
}
function domIndex(node) {
  for (var index2 = 0; ; index2++) {
    node = node.previousSibling;
    if (!node)
      return index2;
  }
}
function isBlockElement(node) {
  return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
function scanFor(node, off2, targetNode, targetOff, dir) {
  for (; ; ) {
    if (node == targetNode && off2 == targetOff)
      return true;
    if (off2 == (dir < 0 ? 0 : maxOffset(node))) {
      if (node.nodeName == "DIV")
        return false;
      let parent = node.parentNode;
      if (!parent || parent.nodeType != 1)
        return false;
      off2 = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      node = node.childNodes[off2 + (dir < 0 ? -1 : 0)];
      if (node.nodeType == 1 && node.contentEditable == "false")
        return false;
      off2 = dir < 0 ? maxOffset(node) : 0;
    } else {
      return false;
    }
  }
}
function maxOffset(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function flattenRect(rect, left) {
  let x2 = left ? rect.left : rect.right;
  return { left: x2, right: x2, top: rect.top, bottom: rect.bottom };
}
function windowRect(win) {
  let vp = win.visualViewport;
  if (vp)
    return {
      left: 0,
      right: vp.width,
      top: 0,
      bottom: vp.height
    };
  return {
    left: 0,
    right: win.innerWidth,
    top: 0,
    bottom: win.innerHeight
  };
}
function getScale(elt, rect) {
  let scaleX = rect.width / elt.offsetWidth;
  let scaleY = rect.height / elt.offsetHeight;
  if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1)
    scaleX = 1;
  if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1)
    scaleY = 1;
  return { scaleX, scaleY };
}
function scrollRectIntoView(dom, rect, side, x2, y, xMargin, yMargin, ltr) {
  let doc2 = dom.ownerDocument, win = doc2.defaultView || window;
  for (let cur2 = dom, stop = false; cur2 && !stop; ) {
    if (cur2.nodeType == 1) {
      let bounding, top2 = cur2 == doc2.body;
      let scaleX = 1, scaleY = 1;
      if (top2) {
        bounding = windowRect(win);
      } else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(cur2).position))
          stop = true;
        if (cur2.scrollHeight <= cur2.clientHeight && cur2.scrollWidth <= cur2.clientWidth) {
          cur2 = cur2.assignedSlot || cur2.parentNode;
          continue;
        }
        let rect2 = cur2.getBoundingClientRect();
        ({ scaleX, scaleY } = getScale(cur2, rect2));
        bounding = {
          left: rect2.left,
          right: rect2.left + cur2.clientWidth * scaleX,
          top: rect2.top,
          bottom: rect2.top + cur2.clientHeight * scaleY
        };
      }
      let moveX = 0, moveY = 0;
      if (y == "nearest") {
        if (rect.top < bounding.top) {
          moveY = rect.top - (bounding.top + yMargin);
          if (side > 0 && rect.bottom > bounding.bottom + moveY)
            moveY = rect.bottom - bounding.bottom + yMargin;
        } else if (rect.bottom > bounding.bottom) {
          moveY = rect.bottom - bounding.bottom + yMargin;
          if (side < 0 && rect.top - moveY < bounding.top)
            moveY = rect.top - (bounding.top + yMargin);
        }
      } else {
        let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
        let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
        moveY = targetTop - bounding.top;
      }
      if (x2 == "nearest") {
        if (rect.left < bounding.left) {
          moveX = rect.left - (bounding.left + xMargin);
          if (side > 0 && rect.right > bounding.right + moveX)
            moveX = rect.right - bounding.right + xMargin;
        } else if (rect.right > bounding.right) {
          moveX = rect.right - bounding.right + xMargin;
          if (side < 0 && rect.left < bounding.left + moveX)
            moveX = rect.left - (bounding.left + xMargin);
        }
      } else {
        let targetLeft = x2 == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x2 == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
        moveX = targetLeft - bounding.left;
      }
      if (moveX || moveY) {
        if (top2) {
          win.scrollBy(moveX, moveY);
        } else {
          let movedX = 0, movedY = 0;
          if (moveY) {
            let start = cur2.scrollTop;
            cur2.scrollTop += moveY / scaleY;
            movedY = (cur2.scrollTop - start) * scaleY;
          }
          if (moveX) {
            let start = cur2.scrollLeft;
            cur2.scrollLeft += moveX / scaleX;
            movedX = (cur2.scrollLeft - start) * scaleX;
          }
          rect = {
            left: rect.left - movedX,
            top: rect.top - movedY,
            right: rect.right - movedX,
            bottom: rect.bottom - movedY
          };
          if (movedX && Math.abs(movedX - moveX) < 1)
            x2 = "nearest";
          if (movedY && Math.abs(movedY - moveY) < 1)
            y = "nearest";
        }
      }
      if (top2)
        break;
      if (rect.top < bounding.top || rect.bottom > bounding.bottom || rect.left < bounding.left || rect.right > bounding.right)
        rect = {
          left: Math.max(rect.left, bounding.left),
          right: Math.min(rect.right, bounding.right),
          top: Math.max(rect.top, bounding.top),
          bottom: Math.min(rect.bottom, bounding.bottom)
        };
      cur2 = cur2.assignedSlot || cur2.parentNode;
    } else if (cur2.nodeType == 11) {
      cur2 = cur2.host;
    } else {
      break;
    }
  }
}
function scrollableParents(dom) {
  let doc2 = dom.ownerDocument, x2, y;
  for (let cur2 = dom.parentNode; cur2; ) {
    if (cur2 == doc2.body || x2 && y) {
      break;
    } else if (cur2.nodeType == 1) {
      if (!y && cur2.scrollHeight > cur2.clientHeight)
        y = cur2;
      if (!x2 && cur2.scrollWidth > cur2.clientWidth)
        x2 = cur2;
      cur2 = cur2.assignedSlot || cur2.parentNode;
    } else if (cur2.nodeType == 11) {
      cur2 = cur2.host;
    } else {
      break;
    }
  }
  return { x: x2, y };
}
class DOMSelectionState {
  constructor() {
    this.anchorNode = null;
    this.anchorOffset = 0;
    this.focusNode = null;
    this.focusOffset = 0;
  }
  eq(domSel) {
    return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
  }
  setRange(range2) {
    let { anchorNode, focusNode } = range2;
    this.set(anchorNode, Math.min(range2.anchorOffset, anchorNode ? maxOffset(anchorNode) : 0), focusNode, Math.min(range2.focusOffset, focusNode ? maxOffset(focusNode) : 0));
  }
  set(anchorNode, anchorOffset, focusNode, focusOffset) {
    this.anchorNode = anchorNode;
    this.anchorOffset = anchorOffset;
    this.focusNode = focusNode;
    this.focusOffset = focusOffset;
  }
}
let preventScrollSupported = null;
if (browser$2.safari && browser$2.safari_version >= 26)
  preventScrollSupported = false;
function focusPreventScroll(dom) {
  if (dom.setActive)
    return dom.setActive();
  if (preventScrollSupported)
    return dom.focus(preventScrollSupported);
  let stack = [];
  for (let cur2 = dom; cur2; cur2 = cur2.parentNode) {
    stack.push(cur2, cur2.scrollTop, cur2.scrollLeft);
    if (cur2 == cur2.ownerDocument)
      break;
  }
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = { preventScroll: true };
      return true;
    }
  } : void 0);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    for (let i2 = 0; i2 < stack.length; ) {
      let elt = stack[i2++], top2 = stack[i2++], left = stack[i2++];
      if (elt.scrollTop != top2)
        elt.scrollTop = top2;
      if (elt.scrollLeft != left)
        elt.scrollLeft = left;
    }
  }
}
let scratchRange;
function textRange(node, from, to2 = from) {
  let range2 = scratchRange || (scratchRange = document.createRange());
  range2.setEnd(node, to2);
  range2.setStart(node, from);
  return range2;
}
function dispatchKey(elt, name2, code2, mods) {
  let options2 = { key: name2, code: name2, keyCode: code2, which: code2, cancelable: true };
  if (mods)
    ({ altKey: options2.altKey, ctrlKey: options2.ctrlKey, shiftKey: options2.shiftKey, metaKey: options2.metaKey } = mods);
  let down = new KeyboardEvent("keydown", options2);
  down.synthetic = true;
  elt.dispatchEvent(down);
  let up = new KeyboardEvent("keyup", options2);
  up.synthetic = true;
  elt.dispatchEvent(up);
  return down.defaultPrevented || up.defaultPrevented;
}
function getRoot(node) {
  while (node) {
    if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host))
      return node;
    node = node.assignedSlot || node.parentNode;
  }
  return null;
}
function clearAttributes(node) {
  while (node.attributes.length)
    node.removeAttributeNode(node.attributes[0]);
}
function atElementStart(doc2, selection2) {
  let node = selection2.focusNode, offset2 = selection2.focusOffset;
  if (!node || selection2.anchorNode != node || selection2.anchorOffset != offset2)
    return false;
  offset2 = Math.min(offset2, maxOffset(node));
  for (; ; ) {
    if (offset2) {
      if (node.nodeType != 1)
        return false;
      let prev = node.childNodes[offset2 - 1];
      if (prev.contentEditable == "false")
        offset2--;
      else {
        node = prev;
        offset2 = maxOffset(node);
      }
    } else if (node == doc2) {
      return true;
    } else {
      offset2 = domIndex(node);
      node = node.parentNode;
    }
  }
}
function isScrolledToBottom(elt) {
  return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
function textNodeBefore(startNode, startOffset) {
  for (let node = startNode, offset2 = startOffset; ; ) {
    if (node.nodeType == 3 && offset2 > 0) {
      return { node, offset: offset2 };
    } else if (node.nodeType == 1 && offset2 > 0) {
      if (node.contentEditable == "false")
        return null;
      node = node.childNodes[offset2 - 1];
      offset2 = maxOffset(node);
    } else if (node.parentNode && !isBlockElement(node)) {
      offset2 = domIndex(node);
      node = node.parentNode;
    } else {
      return null;
    }
  }
}
function textNodeAfter(startNode, startOffset) {
  for (let node = startNode, offset2 = startOffset; ; ) {
    if (node.nodeType == 3 && offset2 < node.nodeValue.length) {
      return { node, offset: offset2 };
    } else if (node.nodeType == 1 && offset2 < node.childNodes.length) {
      if (node.contentEditable == "false")
        return null;
      node = node.childNodes[offset2];
      offset2 = 0;
    } else if (node.parentNode && !isBlockElement(node)) {
      offset2 = domIndex(node) + 1;
      node = node.parentNode;
    } else {
      return null;
    }
  }
}
class DOMPos {
  constructor(node, offset2, precise = true) {
    this.node = node;
    this.offset = offset2;
    this.precise = precise;
  }
  static before(dom, precise) {
    return new DOMPos(dom.parentNode, domIndex(dom), precise);
  }
  static after(dom, precise) {
    return new DOMPos(dom.parentNode, domIndex(dom) + 1, precise);
  }
}
const noChildren = [];
class ContentView {
  constructor() {
    this.parent = null;
    this.dom = null;
    this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(view) {
    let pos = this.posAtStart;
    for (let child of this.children) {
      if (child == view)
        return pos;
      pos += child.length + child.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(view) {
    return this.posBefore(view) + view.length;
  }
  sync(view, track) {
    if (this.flags & 2) {
      let parent = this.dom;
      let prev = null, next;
      for (let child of this.children) {
        if (child.flags & 7) {
          if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
            let contentView = ContentView.get(next);
            if (!contentView || !contentView.parent && contentView.canReuseDOM(child))
              child.reuseDOM(next);
          }
          child.sync(view, track);
          child.flags &= -8;
        }
        next = prev ? prev.nextSibling : parent.firstChild;
        if (track && !track.written && track.node == parent && next != child.dom)
          track.written = true;
        if (child.dom.parentNode == parent) {
          while (next && next != child.dom)
            next = rm$1(next);
        } else {
          parent.insertBefore(child.dom, next);
        }
        prev = child.dom;
      }
      next = prev ? prev.nextSibling : parent.firstChild;
      if (next && track && track.node == parent)
        track.written = true;
      while (next)
        next = rm$1(next);
    } else if (this.flags & 1) {
      for (let child of this.children)
        if (child.flags & 7) {
          child.sync(view, track);
          child.flags &= -8;
        }
    }
  }
  reuseDOM(_dom) {
  }
  localPosFromDOM(node, offset2) {
    let after2;
    if (node == this.dom) {
      after2 = this.dom.childNodes[offset2];
    } else {
      let bias = maxOffset(node) == 0 ? 0 : offset2 == 0 ? -1 : 1;
      for (; ; ) {
        let parent = node.parentNode;
        if (parent == this.dom)
          break;
        if (bias == 0 && parent.firstChild != parent.lastChild) {
          if (node == parent.firstChild)
            bias = -1;
          else
            bias = 1;
        }
        node = parent;
      }
      if (bias < 0)
        after2 = node;
      else
        after2 = node.nextSibling;
    }
    if (after2 == this.dom.firstChild)
      return 0;
    while (after2 && !ContentView.get(after2))
      after2 = after2.nextSibling;
    if (!after2)
      return this.length;
    for (let i2 = 0, pos = 0; ; i2++) {
      let child = this.children[i2];
      if (child.dom == after2)
        return pos;
      pos += child.length + child.breakAfter;
    }
  }
  domBoundsAround(from, to2, offset2 = 0) {
    let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
    for (let i2 = 0, pos = offset2, prevEnd = offset2; i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (pos < from && end > to2)
        return child.domBoundsAround(from, to2, pos);
      if (end >= from && fromI == -1) {
        fromI = i2;
        fromStart = pos;
      }
      if (pos > to2 && child.dom.parentNode == this.dom) {
        toI = i2;
        toEnd = prevEnd;
        break;
      }
      prevEnd = end;
      pos = end + child.breakAfter;
    }
    return {
      from: fromStart,
      to: toEnd < 0 ? offset2 + this.length : toEnd,
      startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
    };
  }
  markDirty(andParent = false) {
    this.flags |= 2;
    this.markParentsDirty(andParent);
  }
  markParentsDirty(childList) {
    for (let parent = this.parent; parent; parent = parent.parent) {
      if (childList)
        parent.flags |= 2;
      if (parent.flags & 1)
        return;
      parent.flags |= 1;
      childList = false;
    }
  }
  setParent(parent) {
    if (this.parent != parent) {
      this.parent = parent;
      if (this.flags & 7)
        this.markParentsDirty(true);
    }
  }
  setDOM(dom) {
    if (this.dom == dom)
      return;
    if (this.dom)
      this.dom.cmView = null;
    this.dom = dom;
    dom.cmView = this;
  }
  get rootView() {
    for (let v2 = this; ; ) {
      let parent = v2.parent;
      if (!parent)
        return v2;
      v2 = parent;
    }
  }
  replaceChildren(from, to2, children = noChildren) {
    this.markDirty();
    for (let i2 = from; i2 < to2; i2++) {
      let child = this.children[i2];
      if (child.parent == this && children.indexOf(child) < 0)
        child.destroy();
    }
    if (children.length < 250)
      this.children.splice(from, to2 - from, ...children);
    else
      this.children = [].concat(this.children.slice(0, from), children, this.children.slice(to2));
    for (let i2 = 0; i2 < children.length; i2++)
      children[i2].setParent(this);
  }
  ignoreMutation(_rec) {
    return false;
  }
  ignoreEvent(_event) {
    return false;
  }
  childCursor(pos = this.length) {
    return new ChildCursor(this.children, pos, this.children.length);
  }
  childPos(pos, bias = 1) {
    return this.childCursor().findPos(pos, bias);
  }
  toString() {
    let name2 = this.constructor.name.replace("View", "");
    return name2 + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name2 == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(node) {
    return node.cmView;
  }
  get isEditable() {
    return true;
  }
  get isWidget() {
    return false;
  }
  get isHidden() {
    return false;
  }
  merge(from, to2, source, hasStart, openStart, openEnd) {
    return false;
  }
  become(other) {
    return false;
  }
  canReuseDOM(other) {
    return other.constructor == this.constructor && !((this.flags | other.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let child of this.children)
      if (child.parent == this)
        child.destroy();
    this.parent = null;
  }
}
ContentView.prototype.breakAfter = 0;
function rm$1(dom) {
  let next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next;
}
class ChildCursor {
  constructor(children, pos, i2) {
    this.children = children;
    this.pos = pos;
    this.i = i2;
    this.off = 0;
  }
  findPos(pos, bias = 1) {
    for (; ; ) {
      if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
        this.off = pos - this.pos;
        return this;
      }
      let next = this.children[--this.i];
      this.pos -= next.length + next.breakAfter;
    }
  }
}
function replaceRange(parent, fromI, fromOff, toI, toOff, insert2, breakAtStart, openStart, openEnd) {
  let { children } = parent;
  let before2 = children.length ? children[fromI] : null;
  let last2 = insert2.length ? insert2[insert2.length - 1] : null;
  let breakAtEnd = last2 ? last2.breakAfter : breakAtStart;
  if (fromI == toI && before2 && !breakAtStart && !breakAtEnd && insert2.length < 2 && before2.merge(fromOff, toOff, insert2.length ? last2 : null, fromOff == 0, openStart, openEnd))
    return;
  if (toI < children.length) {
    let after2 = children[toI];
    if (after2 && (toOff < after2.length || after2.breakAfter && (last2 === null || last2 === void 0 ? void 0 : last2.breakAfter))) {
      if (fromI == toI) {
        after2 = after2.split(toOff);
        toOff = 0;
      }
      if (!breakAtEnd && last2 && after2.merge(0, toOff, last2, true, 0, openEnd)) {
        insert2[insert2.length - 1] = after2;
      } else {
        if (toOff || after2.children.length && !after2.children[0].length)
          after2.merge(0, toOff, null, false, 0, openEnd);
        insert2.push(after2);
      }
    } else if (after2 === null || after2 === void 0 ? void 0 : after2.breakAfter) {
      if (last2)
        last2.breakAfter = 1;
      else
        breakAtStart = 1;
    }
    toI++;
  }
  if (before2) {
    before2.breakAfter = breakAtStart;
    if (fromOff > 0) {
      if (!breakAtStart && insert2.length && before2.merge(fromOff, before2.length, insert2[0], false, openStart, 0)) {
        before2.breakAfter = insert2.shift().breakAfter;
      } else if (fromOff < before2.length || before2.children.length && before2.children[before2.children.length - 1].length == 0) {
        before2.merge(fromOff, before2.length, null, false, openStart, 0);
      }
      fromI++;
    }
  }
  while (fromI < toI && insert2.length) {
    if (children[toI - 1].become(insert2[insert2.length - 1])) {
      toI--;
      insert2.pop();
      openEnd = insert2.length ? 0 : openStart;
    } else if (children[fromI].become(insert2[0])) {
      fromI++;
      insert2.shift();
      openStart = insert2.length ? 0 : openEnd;
    } else {
      break;
    }
  }
  if (!insert2.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd))
    fromI--;
  if (fromI < toI || insert2.length)
    parent.replaceChildren(fromI, toI, insert2);
}
function mergeChildrenInto(parent, from, to2, insert2, openStart, openEnd) {
  let cur2 = parent.childCursor();
  let { i: toI, off: toOff } = cur2.findPos(to2, 1);
  let { i: fromI, off: fromOff } = cur2.findPos(from, -1);
  let dLen = from - to2;
  for (let view of insert2)
    dLen += view.length;
  parent.length += dLen;
  replaceRange(parent, fromI, fromOff, toI, toOff, insert2, 0, openStart, openEnd);
}
const MaxJoinLen = 256;
class TextView extends ContentView {
  constructor(text2) {
    super();
    this.text = text2;
  }
  get length() {
    return this.text.length;
  }
  createDOM(textDOM) {
    this.setDOM(textDOM || document.createTextNode(this.text));
  }
  sync(view, track) {
    if (!this.dom)
      this.createDOM();
    if (this.dom.nodeValue != this.text) {
      if (track && track.node == this.dom)
        track.written = true;
      this.dom.nodeValue = this.text;
    }
  }
  reuseDOM(dom) {
    if (dom.nodeType == 3)
      this.createDOM(dom);
  }
  merge(from, to2, source) {
    if (this.flags & 8 || source && (!(source instanceof TextView) || this.length - (to2 - from) + source.length > MaxJoinLen || source.flags & 8))
      return false;
    this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to2);
    this.markDirty();
    return true;
  }
  split(from) {
    let result2 = new TextView(this.text.slice(from));
    this.text = this.text.slice(0, from);
    this.markDirty();
    result2.flags |= this.flags & 8;
    return result2;
  }
  localPosFromDOM(node, offset2) {
    return node == this.dom ? offset2 : offset2 ? this.text.length : 0;
  }
  domAtPos(pos) {
    return new DOMPos(this.dom, pos);
  }
  domBoundsAround(_from, _to, offset2) {
    return { from: offset2, to: offset2 + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(pos, side) {
    return textCoords(this.dom, pos, side);
  }
}
class MarkView extends ContentView {
  constructor(mark, children = [], length = 0) {
    super();
    this.mark = mark;
    this.children = children;
    this.length = length;
    for (let ch of children)
      ch.setParent(this);
  }
  setAttrs(dom) {
    clearAttributes(dom);
    if (this.mark.class)
      dom.className = this.mark.class;
    if (this.mark.attrs)
      for (let name2 in this.mark.attrs)
        dom.setAttribute(name2, this.mark.attrs[name2]);
    return dom;
  }
  canReuseDOM(other) {
    return super.canReuseDOM(other) && !((this.flags | other.flags) & 8);
  }
  reuseDOM(node) {
    if (node.nodeName == this.mark.tagName.toUpperCase()) {
      this.setDOM(node);
      this.flags |= 4 | 2;
    }
  }
  sync(view, track) {
    if (!this.dom)
      this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
    else if (this.flags & 4)
      this.setAttrs(this.dom);
    super.sync(view, track);
  }
  merge(from, to2, source, _hasStart, openStart, openEnd) {
    if (source && (!(source instanceof MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    mergeChildrenInto(this, from, to2, source ? source.children.slice() : [], openStart - 1, openEnd - 1);
    this.markDirty();
    return true;
  }
  split(from) {
    let result2 = [], off2 = 0, detachFrom = -1, i2 = 0;
    for (let elt of this.children) {
      let end = off2 + elt.length;
      if (end > from)
        result2.push(off2 < from ? elt.split(from - off2) : elt);
      if (detachFrom < 0 && off2 >= from)
        detachFrom = i2;
      off2 = end;
      i2++;
    }
    let length = this.length - from;
    this.length = from;
    if (detachFrom > -1) {
      this.children.length = detachFrom;
      this.markDirty();
    }
    return new MarkView(this.mark, result2, length);
  }
  domAtPos(pos) {
    return inlineDOMAtPos(this, pos);
  }
  coordsAt(pos, side) {
    return coordsInChildren(this, pos, side);
  }
}
function textCoords(text2, pos, side) {
  let length = text2.nodeValue.length;
  if (pos > length)
    pos = length;
  let from = pos, to2 = pos, flatten2 = 0;
  if (pos == 0 && side < 0 || pos == length && side >= 0) {
    if (!(browser$2.chrome || browser$2.gecko)) {
      if (pos) {
        from--;
        flatten2 = 1;
      } else if (to2 < length) {
        to2++;
        flatten2 = -1;
      }
    }
  } else {
    if (side < 0)
      from--;
    else if (to2 < length)
      to2++;
  }
  let rects = textRange(text2, from, to2).getClientRects();
  if (!rects.length)
    return null;
  let rect = rects[(flatten2 ? flatten2 < 0 : side >= 0) ? 0 : rects.length - 1];
  if (browser$2.safari && !flatten2 && rect.width == 0)
    rect = Array.prototype.find.call(rects, (r) => r.width) || rect;
  return flatten2 ? flattenRect(rect, flatten2 < 0) : rect || null;
}
class WidgetView extends ContentView {
  static create(widget, length, side) {
    return new WidgetView(widget, length, side);
  }
  constructor(widget, length, side) {
    super();
    this.widget = widget;
    this.length = length;
    this.side = side;
    this.prevWidget = null;
  }
  split(from) {
    let result2 = WidgetView.create(this.widget, this.length - from, this.side);
    this.length -= from;
    return result2;
  }
  sync(view) {
    if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
      if (this.dom && this.prevWidget)
        this.prevWidget.destroy(this.dom);
      this.prevWidget = null;
      this.setDOM(this.widget.toDOM(view));
      if (!this.widget.editable)
        this.dom.contentEditable = "false";
    }
  }
  getSide() {
    return this.side;
  }
  merge(from, to2, source, hasStart, openStart, openEnd) {
    if (source && (!(source instanceof WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    this.length = from + (source ? source.length : 0) + (this.length - to2);
    return true;
  }
  become(other) {
    if (other instanceof WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
      if (!this.widget.compare(other.widget))
        this.markDirty(true);
      if (this.dom && !this.prevWidget)
        this.prevWidget = this.widget;
      this.widget = other.widget;
      this.length = other.length;
      return true;
    }
    return false;
  }
  ignoreMutation() {
    return true;
  }
  ignoreEvent(event) {
    return this.widget.ignoreEvent(event);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return Text$1.empty;
    let top2 = this;
    while (top2.parent)
      top2 = top2.parent;
    let { view } = top2, text2 = view && view.state.doc, start = this.posAtStart;
    return text2 ? text2.slice(start, start + this.length) : Text$1.empty;
  }
  domAtPos(pos) {
    return (this.length ? pos == 0 : this.side > 0) ? DOMPos.before(this.dom) : DOMPos.after(this.dom, pos == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(pos, side) {
    let custom = this.widget.coordsAt(this.dom, pos, side);
    if (custom)
      return custom;
    let rects = this.dom.getClientRects(), rect = null;
    if (!rects.length)
      return null;
    let fromBack = this.side ? this.side < 0 : pos > 0;
    for (let i2 = fromBack ? rects.length - 1 : 0; ; i2 += fromBack ? -1 : 1) {
      rect = rects[i2];
      if (pos > 0 ? i2 == 0 : i2 == rects.length - 1 || rect.top < rect.bottom)
        break;
    }
    return flattenRect(rect, !fromBack);
  }
  get isEditable() {
    return false;
  }
  get isWidget() {
    return true;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy();
    if (this.dom)
      this.widget.destroy(this.dom);
  }
}
class WidgetBufferView extends ContentView {
  constructor(side) {
    super();
    this.side = side;
  }
  get length() {
    return 0;
  }
  merge() {
    return false;
  }
  become(other) {
    return other instanceof WidgetBufferView && other.side == this.side;
  }
  split() {
    return new WidgetBufferView(this.side);
  }
  sync() {
    if (!this.dom) {
      let dom = document.createElement("img");
      dom.className = "cm-widgetBuffer";
      dom.setAttribute("aria-hidden", "true");
      this.setDOM(dom);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(pos) {
    return this.side > 0 ? DOMPos.before(this.dom) : DOMPos.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(pos) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return Text$1.empty;
  }
  get isHidden() {
    return true;
  }
}
TextView.prototype.children = WidgetView.prototype.children = WidgetBufferView.prototype.children = noChildren;
function inlineDOMAtPos(parent, pos) {
  let dom = parent.dom, { children } = parent, i2 = 0;
  for (let off2 = 0; i2 < children.length; i2++) {
    let child = children[i2], end = off2 + child.length;
    if (end == off2 && child.getSide() <= 0)
      continue;
    if (pos > off2 && pos < end && child.dom.parentNode == dom)
      return child.domAtPos(pos - off2);
    if (pos <= off2)
      break;
    off2 = end;
  }
  for (let j2 = i2; j2 > 0; j2--) {
    let prev = children[j2 - 1];
    if (prev.dom.parentNode == dom)
      return prev.domAtPos(prev.length);
  }
  for (let j2 = i2; j2 < children.length; j2++) {
    let next = children[j2];
    if (next.dom.parentNode == dom)
      return next.domAtPos(0);
  }
  return new DOMPos(dom, 0);
}
function joinInlineInto(parent, view, open) {
  let last2, { children } = parent;
  if (open > 0 && view instanceof MarkView && children.length && (last2 = children[children.length - 1]) instanceof MarkView && last2.mark.eq(view.mark)) {
    joinInlineInto(last2, view.children[0], open - 1);
  } else {
    children.push(view);
    view.setParent(parent);
  }
  parent.length += view.length;
}
function coordsInChildren(view, pos, side) {
  let before2 = null, beforePos = -1, after2 = null, afterPos = -1;
  function scan(view2, pos2) {
    for (let i2 = 0, off2 = 0; i2 < view2.children.length && off2 <= pos2; i2++) {
      let child = view2.children[i2], end = off2 + child.length;
      if (end >= pos2) {
        if (child.children.length) {
          scan(child, pos2 - off2);
        } else if ((!after2 || after2.isHidden && (side > 0 || onSameLine(after2, child))) && (end > pos2 || off2 == end && child.getSide() > 0)) {
          after2 = child;
          afterPos = pos2 - off2;
        } else if (off2 < pos2 || off2 == end && child.getSide() < 0 && !child.isHidden) {
          before2 = child;
          beforePos = pos2 - off2;
        }
      }
      off2 = end;
    }
  }
  scan(view, pos);
  let target = (side < 0 ? before2 : after2) || before2 || after2;
  if (target)
    return target.coordsAt(Math.max(0, target == before2 ? beforePos : afterPos), side);
  return fallbackRect(view);
}
function fallbackRect(view) {
  let last2 = view.dom.lastChild;
  if (!last2)
    return view.dom.getBoundingClientRect();
  let rects = clientRectsFor(last2);
  return rects[rects.length - 1] || null;
}
function onSameLine(a, b2) {
  let posA = a.coordsAt(0, 1), posB = b2.coordsAt(0, 1);
  return posA && posB && posB.top < posA.bottom;
}
function combineAttrs(source, target) {
  for (let name2 in source) {
    if (name2 == "class" && target.class)
      target.class += " " + source.class;
    else if (name2 == "style" && target.style)
      target.style += ";" + source.style;
    else
      target[name2] = source[name2];
  }
  return target;
}
const noAttrs$1 = /* @__PURE__ */ Object.create(null);
function attrsEq(a, b2, ignore) {
  if (a == b2)
    return true;
  if (!a)
    a = noAttrs$1;
  if (!b2)
    b2 = noAttrs$1;
  let keysA = Object.keys(a), keysB = Object.keys(b2);
  if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0))
    return false;
  for (let key of keysA) {
    if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b2[key]))
      return false;
  }
  return true;
}
function updateAttrs(dom, prev, attrs) {
  let changed = false;
  if (prev) {
    for (let name2 in prev)
      if (!(attrs && name2 in attrs)) {
        changed = true;
        if (name2 == "style")
          dom.style.cssText = "";
        else
          dom.removeAttribute(name2);
      }
  }
  if (attrs) {
    for (let name2 in attrs)
      if (!(prev && prev[name2] == attrs[name2])) {
        changed = true;
        if (name2 == "style")
          dom.style.cssText = attrs[name2];
        else
          dom.setAttribute(name2, attrs[name2]);
      }
  }
  return changed;
}
function getAttrs(dom) {
  let attrs = /* @__PURE__ */ Object.create(null);
  for (let i2 = 0; i2 < dom.attributes.length; i2++) {
    let attr = dom.attributes[i2];
    attrs[attr.name] = attr.value;
  }
  return attrs;
}
class WidgetType {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(widget) {
    return false;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(dom, view) {
    return false;
  }
  /**
  @internal
  */
  compare(other) {
    return this == other || this.constructor == other.constructor && this.eq(other);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(event) {
    return true;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(dom, pos, side) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return false;
  }
  /**
  @internal
  */
  get editable() {
    return false;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(dom) {
  }
}
var BlockType = /* @__PURE__ */ (function(BlockType2) {
  BlockType2[BlockType2["Text"] = 0] = "Text";
  BlockType2[BlockType2["WidgetBefore"] = 1] = "WidgetBefore";
  BlockType2[BlockType2["WidgetAfter"] = 2] = "WidgetAfter";
  BlockType2[BlockType2["WidgetRange"] = 3] = "WidgetRange";
  return BlockType2;
})(BlockType || (BlockType = {}));
class Decoration extends RangeValue {
  constructor(startSide, endSide, widget, spec) {
    super();
    this.startSide = startSide;
    this.endSide = endSide;
    this.widget = widget;
    this.spec = spec;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return false;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(spec) {
    return new MarkDecoration(spec);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(spec) {
    let side = Math.max(-1e4, Math.min(1e4, spec.side || 0)), block = !!spec.block;
    side += block && !spec.inlineOrder ? side > 0 ? 3e8 : -4e8 : side > 0 ? 1e8 : -1e8;
    return new PointDecoration(spec, side, side, block, spec.widget || null, false);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(spec) {
    let block = !!spec.block, startSide, endSide;
    if (spec.isBlockGap) {
      startSide = -5e8;
      endSide = 4e8;
    } else {
      let { start, end } = getInclusive(spec, block);
      startSide = (start ? block ? -3e8 : -1 : 5e8) - 1;
      endSide = (end ? block ? 2e8 : 1 : -6e8) + 1;
    }
    return new PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(spec) {
    return new LineDecoration(spec);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(of, sort = false) {
    return RangeSet.of(of, sort);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : false;
  }
}
Decoration.none = RangeSet.empty;
class MarkDecoration extends Decoration {
  constructor(spec) {
    let { start, end } = getInclusive(spec);
    super(start ? -1 : 5e8, end ? 1 : -6e8, null, spec);
    this.tagName = spec.tagName || "span";
    this.class = spec.class || "";
    this.attrs = spec.attributes || null;
  }
  eq(other) {
    var _a2, _b;
    return this == other || other instanceof MarkDecoration && this.tagName == other.tagName && (this.class || ((_a2 = this.attrs) === null || _a2 === void 0 ? void 0 : _a2.class)) == (other.class || ((_b = other.attrs) === null || _b === void 0 ? void 0 : _b.class)) && attrsEq(this.attrs, other.attrs, "class");
  }
  range(from, to2 = from) {
    if (from >= to2)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(from, to2);
  }
}
MarkDecoration.prototype.point = false;
class LineDecoration extends Decoration {
  constructor(spec) {
    super(-2e8, -2e8, null, spec);
  }
  eq(other) {
    return other instanceof LineDecoration && this.spec.class == other.spec.class && attrsEq(this.spec.attributes, other.spec.attributes);
  }
  range(from, to2 = from) {
    if (to2 != from)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(from, to2);
  }
}
LineDecoration.prototype.mapMode = MapMode.TrackBefore;
LineDecoration.prototype.point = true;
class PointDecoration extends Decoration {
  constructor(spec, startSide, endSide, block, widget, isReplace) {
    super(startSide, endSide, widget, spec);
    this.block = block;
    this.isReplace = isReplace;
    this.mapMode = !block ? MapMode.TrackDel : startSide <= 0 ? MapMode.TrackBefore : MapMode.TrackAfter;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? BlockType.WidgetRange : this.startSide <= 0 ? BlockType.WidgetBefore : BlockType.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(other) {
    return other instanceof PointDecoration && widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
  }
  range(from, to2 = from) {
    if (this.isReplace && (from > to2 || from == to2 && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && to2 != from)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(from, to2);
  }
}
PointDecoration.prototype.point = true;
function getInclusive(spec, block = false) {
  let { inclusiveStart: start, inclusiveEnd: end } = spec;
  if (start == null)
    start = spec.inclusive;
  if (end == null)
    end = spec.inclusive;
  return { start: start !== null && start !== void 0 ? start : block, end: end !== null && end !== void 0 ? end : block };
}
function widgetsEq(a, b2) {
  return a == b2 || !!(a && b2 && a.compare(b2));
}
function addRange(from, to2, ranges, margin = 0) {
  let last2 = ranges.length - 1;
  if (last2 >= 0 && ranges[last2] + margin >= from)
    ranges[last2] = Math.max(ranges[last2], to2);
  else
    ranges.push(from, to2);
}
class LineView extends ContentView {
  constructor() {
    super(...arguments);
    this.children = [];
    this.length = 0;
    this.prevAttrs = void 0;
    this.attrs = null;
    this.breakAfter = 0;
  }
  // Consumes source
  merge(from, to2, source, hasStart, openStart, openEnd) {
    if (source) {
      if (!(source instanceof LineView))
        return false;
      if (!this.dom)
        source.transferDOM(this);
    }
    if (hasStart)
      this.setDeco(source ? source.attrs : null);
    mergeChildrenInto(this, from, to2, source ? source.children.slice() : [], openStart, openEnd);
    return true;
  }
  split(at2) {
    let end = new LineView();
    end.breakAfter = this.breakAfter;
    if (this.length == 0)
      return end;
    let { i: i2, off: off2 } = this.childPos(at2);
    if (off2) {
      end.append(this.children[i2].split(off2), 0);
      this.children[i2].merge(off2, this.children[i2].length, null, false, 0, 0);
      i2++;
    }
    for (let j2 = i2; j2 < this.children.length; j2++)
      end.append(this.children[j2], 0);
    while (i2 > 0 && this.children[i2 - 1].length == 0)
      this.children[--i2].destroy();
    this.children.length = i2;
    this.markDirty();
    this.length = at2;
    return end;
  }
  transferDOM(other) {
    if (!this.dom)
      return;
    this.markDirty();
    other.setDOM(this.dom);
    other.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs;
    this.prevAttrs = void 0;
    this.dom = null;
  }
  setDeco(attrs) {
    if (!attrsEq(this.attrs, attrs)) {
      if (this.dom) {
        this.prevAttrs = this.attrs;
        this.markDirty();
      }
      this.attrs = attrs;
    }
  }
  append(child, openStart) {
    joinInlineInto(this, child, openStart);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(deco) {
    let attrs = deco.spec.attributes, cls = deco.spec.class;
    if (attrs)
      this.attrs = combineAttrs(attrs, this.attrs || {});
    if (cls)
      this.attrs = combineAttrs({ class: cls }, this.attrs || {});
  }
  domAtPos(pos) {
    return inlineDOMAtPos(this, pos);
  }
  reuseDOM(node) {
    if (node.nodeName == "DIV") {
      this.setDOM(node);
      this.flags |= 4 | 2;
    }
  }
  sync(view, track) {
    var _a2;
    if (!this.dom) {
      this.setDOM(document.createElement("div"));
      this.dom.className = "cm-line";
      this.prevAttrs = this.attrs ? null : void 0;
    } else if (this.flags & 4) {
      clearAttributes(this.dom);
      this.dom.className = "cm-line";
      this.prevAttrs = this.attrs ? null : void 0;
    }
    if (this.prevAttrs !== void 0) {
      updateAttrs(this.dom, this.prevAttrs, this.attrs);
      this.dom.classList.add("cm-line");
      this.prevAttrs = void 0;
    }
    super.sync(view, track);
    let last2 = this.dom.lastChild;
    while (last2 && ContentView.get(last2) instanceof MarkView)
      last2 = last2.lastChild;
    if (!last2 || !this.length || last2.nodeName != "BR" && ((_a2 = ContentView.get(last2)) === null || _a2 === void 0 ? void 0 : _a2.isEditable) == false && (!browser$2.ios || !this.children.some((ch) => ch instanceof TextView))) {
      let hack = document.createElement("BR");
      hack.cmIgnore = true;
      this.dom.appendChild(hack);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let totalWidth = 0, textHeight;
    for (let child of this.children) {
      if (!(child instanceof TextView) || /[^ -~]/.test(child.text))
        return null;
      let rects = clientRectsFor(child.dom);
      if (rects.length != 1)
        return null;
      totalWidth += rects[0].width;
      textHeight = rects[0].height;
    }
    return !totalWidth ? null : {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: totalWidth / this.length,
      textHeight
    };
  }
  coordsAt(pos, side) {
    let rect = coordsInChildren(this, pos, side);
    if (!this.children.length && rect && this.parent) {
      let { heightOracle } = this.parent.view.viewState, height = rect.bottom - rect.top;
      if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
        let dist2 = (height - heightOracle.textHeight) / 2;
        return { top: rect.top + dist2, bottom: rect.bottom - dist2, left: rect.left, right: rect.left };
      }
    }
    return rect;
  }
  become(other) {
    return other instanceof LineView && this.children.length == 0 && other.children.length == 0 && attrsEq(this.attrs, other.attrs) && this.breakAfter == other.breakAfter;
  }
  covers() {
    return true;
  }
  static find(docView, pos) {
    for (let i2 = 0, off2 = 0; i2 < docView.children.length; i2++) {
      let block = docView.children[i2], end = off2 + block.length;
      if (end >= pos) {
        if (block instanceof LineView)
          return block;
        if (end > pos)
          break;
      }
      off2 = end + block.breakAfter;
    }
    return null;
  }
}
class BlockWidgetView extends ContentView {
  constructor(widget, length, deco) {
    super();
    this.widget = widget;
    this.length = length;
    this.deco = deco;
    this.breakAfter = 0;
    this.prevWidget = null;
  }
  merge(from, to2, source, _takeDeco, openStart, openEnd) {
    if (source && (!(source instanceof BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    this.length = from + (source ? source.length : 0) + (this.length - to2);
    return true;
  }
  domAtPos(pos) {
    return pos == 0 ? DOMPos.before(this.dom) : DOMPos.after(this.dom, pos == this.length);
  }
  split(at2) {
    let len = this.length - at2;
    this.length = at2;
    let end = new BlockWidgetView(this.widget, len, this.deco);
    end.breakAfter = this.breakAfter;
    return end;
  }
  get children() {
    return noChildren;
  }
  sync(view) {
    if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
      if (this.dom && this.prevWidget)
        this.prevWidget.destroy(this.dom);
      this.prevWidget = null;
      this.setDOM(this.widget.toDOM(view));
      if (!this.widget.editable)
        this.dom.contentEditable = "false";
    }
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : Text$1.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(other) {
    if (other instanceof BlockWidgetView && other.widget.constructor == this.widget.constructor) {
      if (!other.widget.compare(this.widget))
        this.markDirty(true);
      if (this.dom && !this.prevWidget)
        this.prevWidget = this.widget;
      this.widget = other.widget;
      this.length = other.length;
      this.deco = other.deco;
      this.breakAfter = other.breakAfter;
      return true;
    }
    return false;
  }
  ignoreMutation() {
    return true;
  }
  ignoreEvent(event) {
    return this.widget.ignoreEvent(event);
  }
  get isEditable() {
    return false;
  }
  get isWidget() {
    return true;
  }
  coordsAt(pos, side) {
    let custom = this.widget.coordsAt(this.dom, pos, side);
    if (custom)
      return custom;
    if (this.widget instanceof BlockGapWidget)
      return null;
    return flattenRect(this.dom.getBoundingClientRect(), this.length ? pos == 0 : side <= 0);
  }
  destroy() {
    super.destroy();
    if (this.dom)
      this.widget.destroy(this.dom);
  }
  covers(side) {
    let { startSide, endSide } = this.deco;
    return startSide == endSide ? false : side < 0 ? startSide < 0 : endSide > 0;
  }
}
class BlockGapWidget extends WidgetType {
  constructor(height) {
    super();
    this.height = height;
  }
  toDOM() {
    let elt = document.createElement("div");
    elt.className = "cm-gap";
    this.updateDOM(elt);
    return elt;
  }
  eq(other) {
    return other.height == this.height;
  }
  updateDOM(elt) {
    elt.style.height = this.height + "px";
    return true;
  }
  get editable() {
    return true;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return false;
  }
}
class ContentBuilder {
  constructor(doc2, pos, end, disallowBlockEffectsFor) {
    this.doc = doc2;
    this.pos = pos;
    this.end = end;
    this.disallowBlockEffectsFor = disallowBlockEffectsFor;
    this.content = [];
    this.curLine = null;
    this.breakAtStart = 0;
    this.pendingBuffer = 0;
    this.bufferMarks = [];
    this.atCursorPos = true;
    this.openStart = -1;
    this.openEnd = -1;
    this.text = "";
    this.textOff = 0;
    this.cursor = doc2.iter();
    this.skip = pos;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let last2 = this.content[this.content.length - 1];
    return !(last2.breakAfter || last2 instanceof BlockWidgetView && last2.deco.endSide < 0);
  }
  getLine() {
    if (!this.curLine) {
      this.content.push(this.curLine = new LineView());
      this.atCursorPos = true;
    }
    return this.curLine;
  }
  flushBuffer(active = this.bufferMarks) {
    if (this.pendingBuffer) {
      this.curLine.append(wrapMarks(new WidgetBufferView(-1), active), active.length);
      this.pendingBuffer = 0;
    }
  }
  addBlockWidget(view) {
    this.flushBuffer();
    this.curLine = null;
    this.content.push(view);
  }
  finish(openEnd) {
    if (this.pendingBuffer && openEnd <= this.bufferMarks.length)
      this.flushBuffer();
    else
      this.pendingBuffer = 0;
    if (!this.posCovered() && !(openEnd && this.content.length && this.content[this.content.length - 1] instanceof BlockWidgetView))
      this.getLine();
  }
  buildText(length, active, openStart) {
    while (length > 0) {
      if (this.textOff == this.text.length) {
        let { value, lineBreak, done } = this.cursor.next(this.skip);
        this.skip = 0;
        if (done)
          throw new Error("Ran out of text content when drawing inline views");
        if (lineBreak) {
          if (!this.posCovered())
            this.getLine();
          if (this.content.length)
            this.content[this.content.length - 1].breakAfter = 1;
          else
            this.breakAtStart = 1;
          this.flushBuffer();
          this.curLine = null;
          this.atCursorPos = true;
          length--;
          continue;
        } else {
          this.text = value;
          this.textOff = 0;
        }
      }
      let remaining = Math.min(this.text.length - this.textOff, length);
      let take = Math.min(
        remaining,
        512
        /* T.Chunk */
      );
      this.flushBuffer(active.slice(active.length - openStart));
      this.getLine().append(wrapMarks(new TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
      this.atCursorPos = true;
      this.textOff += take;
      length -= take;
      openStart = remaining <= take ? 0 : active.length;
    }
  }
  span(from, to2, active, openStart) {
    this.buildText(to2 - from, active, openStart);
    this.pos = to2;
    if (this.openStart < 0)
      this.openStart = openStart;
  }
  point(from, to2, deco, active, openStart, index2) {
    if (this.disallowBlockEffectsFor[index2] && deco instanceof PointDecoration) {
      if (deco.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (to2 > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let len = to2 - from;
    if (deco instanceof PointDecoration) {
      if (deco.block) {
        if (deco.startSide > 0 && !this.posCovered())
          this.getLine();
        this.addBlockWidget(new BlockWidgetView(deco.widget || NullWidget.block, len, deco));
      } else {
        let view = WidgetView.create(deco.widget || NullWidget.inline, len, len ? 0 : deco.startSide);
        let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to2 || deco.startSide > 0);
        let cursorAfter = !view.isEditable && (from < to2 || openStart > active.length || deco.startSide <= 0);
        let line2 = this.getLine();
        if (this.pendingBuffer == 2 && !cursorBefore && !view.isEditable)
          this.pendingBuffer = 0;
        this.flushBuffer(active);
        if (cursorBefore) {
          line2.append(wrapMarks(new WidgetBufferView(1), active), openStart);
          openStart = active.length + Math.max(0, openStart - active.length);
        }
        line2.append(wrapMarks(view, active), openStart);
        this.atCursorPos = cursorAfter;
        this.pendingBuffer = !cursorAfter ? 0 : from < to2 || openStart > active.length ? 1 : 2;
        if (this.pendingBuffer)
          this.bufferMarks = active.slice();
      }
    } else if (this.doc.lineAt(this.pos).from == this.pos) {
      this.getLine().addLineDeco(deco);
    }
    if (len) {
      if (this.textOff + len <= this.text.length) {
        this.textOff += len;
      } else {
        this.skip += len - (this.text.length - this.textOff);
        this.text = "";
        this.textOff = 0;
      }
      this.pos = to2;
    }
    if (this.openStart < 0)
      this.openStart = openStart;
  }
  static build(text2, from, to2, decorations2, dynamicDecorationMap) {
    let builder = new ContentBuilder(text2, from, to2, dynamicDecorationMap);
    builder.openEnd = RangeSet.spans(decorations2, from, to2, builder);
    if (builder.openStart < 0)
      builder.openStart = builder.openEnd;
    builder.finish(builder.openEnd);
    return builder;
  }
}
function wrapMarks(view, active) {
  for (let mark of active)
    view = new MarkView(mark, [view], view.length);
  return view;
}
class NullWidget extends WidgetType {
  constructor(tag2) {
    super();
    this.tag = tag2;
  }
  eq(other) {
    return other.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(elt) {
    return elt.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return true;
  }
}
NullWidget.inline = /* @__PURE__ */ new NullWidget("span");
NullWidget.block = /* @__PURE__ */ new NullWidget("div");
var Direction = /* @__PURE__ */ (function(Direction2) {
  Direction2[Direction2["LTR"] = 0] = "LTR";
  Direction2[Direction2["RTL"] = 1] = "RTL";
  return Direction2;
})(Direction || (Direction = {}));
const LTR = Direction.LTR, RTL = Direction.RTL;
function dec(str) {
  let result2 = [];
  for (let i2 = 0; i2 < str.length; i2++)
    result2.push(1 << +str[i2]);
  return result2;
}
const LowTypes = /* @__PURE__ */ dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
const ArabicTypes = /* @__PURE__ */ dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const Brackets = /* @__PURE__ */ Object.create(null), BracketStack = [];
for (let p of ["()", "[]", "{}"]) {
  let l = /* @__PURE__ */ p.charCodeAt(0), r = /* @__PURE__ */ p.charCodeAt(1);
  Brackets[l] = r;
  Brackets[r] = -l;
}
function charType(ch) {
  return ch <= 247 ? LowTypes[ch] : 1424 <= ch && ch <= 1524 ? 2 : 1536 <= ch && ch <= 1785 ? ArabicTypes[ch - 1536] : 1774 <= ch && ch <= 2220 ? 4 : 8192 <= ch && ch <= 8204 ? 256 : 64336 <= ch && ch <= 65023 ? 4 : 1;
}
const BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class BidiSpan {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? RTL : LTR;
  }
  /**
  @internal
  */
  constructor(from, to2, level) {
    this.from = from;
    this.to = to2;
    this.level = level;
  }
  /**
  @internal
  */
  side(end, dir) {
    return this.dir == dir == end ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(forward, dir) {
    return forward == (this.dir == dir);
  }
  /**
  @internal
  */
  static find(order2, index2, level, assoc) {
    let maybe = -1;
    for (let i2 = 0; i2 < order2.length; i2++) {
      let span = order2[i2];
      if (span.from <= index2 && span.to >= index2) {
        if (span.level == level)
          return i2;
        if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index2 : span.to > index2 : order2[maybe].level > span.level))
          maybe = i2;
      }
    }
    if (maybe < 0)
      throw new RangeError("Index out of range");
    return maybe;
  }
}
function isolatesEq(a, b2) {
  if (a.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a.length; i2++) {
    let iA = a[i2], iB = b2[i2];
    if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !isolatesEq(iA.inner, iB.inner))
      return false;
  }
  return true;
}
const types = [];
function computeCharTypes(line2, rFrom, rTo, isolates, outerType) {
  for (let iI = 0; iI <= isolates.length; iI++) {
    let from = iI ? isolates[iI - 1].to : rFrom, to2 = iI < isolates.length ? isolates[iI].from : rTo;
    let prevType = iI ? 256 : outerType;
    for (let i2 = from, prev = prevType, prevStrong = prevType; i2 < to2; i2++) {
      let type = charType(line2.charCodeAt(i2));
      if (type == 512)
        type = prev;
      else if (type == 8 && prevStrong == 4)
        type = 16;
      types[i2] = type == 4 ? 2 : type;
      if (type & 7)
        prevStrong = type;
      prev = type;
    }
    for (let i2 = from, prev = prevType, prevStrong = prevType; i2 < to2; i2++) {
      let type = types[i2];
      if (type == 128) {
        if (i2 < to2 - 1 && prev == types[i2 + 1] && prev & 24)
          type = types[i2] = prev;
        else
          types[i2] = 256;
      } else if (type == 64) {
        let end = i2 + 1;
        while (end < to2 && types[end] == 64)
          end++;
        let replace2 = i2 && prev == 8 || end < rTo && types[end] == 8 ? prevStrong == 1 ? 1 : 8 : 256;
        for (let j2 = i2; j2 < end; j2++)
          types[j2] = replace2;
        i2 = end - 1;
      } else if (type == 8 && prevStrong == 1) {
        types[i2] = 1;
      }
      prev = type;
      if (type & 7)
        prevStrong = type;
    }
  }
}
function processBracketPairs(line2, rFrom, rTo, isolates, outerType) {
  let oppositeType = outerType == 1 ? 2 : 1;
  for (let iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++) {
    let from = iI ? isolates[iI - 1].to : rFrom, to2 = iI < isolates.length ? isolates[iI].from : rTo;
    for (let i2 = from, ch, br2, type; i2 < to2; i2++) {
      if (br2 = Brackets[ch = line2.charCodeAt(i2)]) {
        if (br2 < 0) {
          for (let sJ = sI - 3; sJ >= 0; sJ -= 3) {
            if (BracketStack[sJ + 1] == -br2) {
              let flags = BracketStack[sJ + 2];
              let type2 = flags & 2 ? outerType : !(flags & 4) ? 0 : flags & 1 ? oppositeType : outerType;
              if (type2)
                types[i2] = types[BracketStack[sJ]] = type2;
              sI = sJ;
              break;
            }
          }
        } else if (BracketStack.length == 189) {
          break;
        } else {
          BracketStack[sI++] = i2;
          BracketStack[sI++] = ch;
          BracketStack[sI++] = context;
        }
      } else if ((type = types[i2]) == 2 || type == 1) {
        let embed = type == outerType;
        context = embed ? 0 : 1;
        for (let sJ = sI - 3; sJ >= 0; sJ -= 3) {
          let cur2 = BracketStack[sJ + 2];
          if (cur2 & 2)
            break;
          if (embed) {
            BracketStack[sJ + 2] |= 2;
          } else {
            if (cur2 & 4)
              break;
            BracketStack[sJ + 2] |= 4;
          }
        }
      }
    }
  }
}
function processNeutrals(rFrom, rTo, isolates, outerType) {
  for (let iI = 0, prev = outerType; iI <= isolates.length; iI++) {
    let from = iI ? isolates[iI - 1].to : rFrom, to2 = iI < isolates.length ? isolates[iI].from : rTo;
    for (let i2 = from; i2 < to2; ) {
      let type = types[i2];
      if (type == 256) {
        let end = i2 + 1;
        for (; ; ) {
          if (end == to2) {
            if (iI == isolates.length)
              break;
            end = isolates[iI++].to;
            to2 = iI < isolates.length ? isolates[iI].from : rTo;
          } else if (types[end] == 256) {
            end++;
          } else {
            break;
          }
        }
        let beforeL = prev == 1;
        let afterL = (end < rTo ? types[end] : outerType) == 1;
        let replace2 = beforeL == afterL ? beforeL ? 1 : 2 : outerType;
        for (let j2 = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j2 > i2; ) {
          if (j2 == fromJ) {
            j2 = isolates[--jI].from;
            fromJ = jI ? isolates[jI - 1].to : rFrom;
          }
          types[--j2] = replace2;
        }
        i2 = end;
      } else {
        prev = type;
        i2++;
      }
    }
  }
}
function emitSpans(line2, from, to2, level, baseLevel, isolates, order2) {
  let ourType = level % 2 ? 2 : 1;
  if (level % 2 == baseLevel % 2) {
    for (let iCh = from, iI = 0; iCh < to2; ) {
      let sameDir = true, isNum = false;
      if (iI == isolates.length || iCh < isolates[iI].from) {
        let next = types[iCh];
        if (next != ourType) {
          sameDir = false;
          isNum = next == 16;
        }
      }
      let recurse = !sameDir && ourType == 1 ? [] : null;
      let localLevel = sameDir ? level : level + 1;
      let iScan = iCh;
      run: for (; ; ) {
        if (iI < isolates.length && iScan == isolates[iI].from) {
          if (isNum)
            break run;
          let iso = isolates[iI];
          if (!sameDir)
            for (let upto = iso.to, jI = iI + 1; ; ) {
              if (upto == to2)
                break run;
              if (jI < isolates.length && isolates[jI].from == upto)
                upto = isolates[jI++].to;
              else if (types[upto] == ourType)
                break run;
              else
                break;
            }
          iI++;
          if (recurse) {
            recurse.push(iso);
          } else {
            if (iso.from > iCh)
              order2.push(new BidiSpan(iCh, iso.from, localLevel));
            let dirSwap = iso.direction == LTR != !(localLevel % 2);
            computeSectionOrder(line2, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order2);
            iCh = iso.to;
          }
          iScan = iso.to;
        } else if (iScan == to2 || (sameDir ? types[iScan] != ourType : types[iScan] == ourType)) {
          break;
        } else {
          iScan++;
        }
      }
      if (recurse)
        emitSpans(line2, iCh, iScan, level + 1, baseLevel, recurse, order2);
      else if (iCh < iScan)
        order2.push(new BidiSpan(iCh, iScan, localLevel));
      iCh = iScan;
    }
  } else {
    for (let iCh = to2, iI = isolates.length; iCh > from; ) {
      let sameDir = true, isNum = false;
      if (!iI || iCh > isolates[iI - 1].to) {
        let next = types[iCh - 1];
        if (next != ourType) {
          sameDir = false;
          isNum = next == 16;
        }
      }
      let recurse = !sameDir && ourType == 1 ? [] : null;
      let localLevel = sameDir ? level : level + 1;
      let iScan = iCh;
      run: for (; ; ) {
        if (iI && iScan == isolates[iI - 1].to) {
          if (isNum)
            break run;
          let iso = isolates[--iI];
          if (!sameDir)
            for (let upto = iso.from, jI = iI; ; ) {
              if (upto == from)
                break run;
              if (jI && isolates[jI - 1].to == upto)
                upto = isolates[--jI].from;
              else if (types[upto - 1] == ourType)
                break run;
              else
                break;
            }
          if (recurse) {
            recurse.push(iso);
          } else {
            if (iso.to < iCh)
              order2.push(new BidiSpan(iso.to, iCh, localLevel));
            let dirSwap = iso.direction == LTR != !(localLevel % 2);
            computeSectionOrder(line2, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order2);
            iCh = iso.from;
          }
          iScan = iso.from;
        } else if (iScan == from || (sameDir ? types[iScan - 1] != ourType : types[iScan - 1] == ourType)) {
          break;
        } else {
          iScan--;
        }
      }
      if (recurse)
        emitSpans(line2, iScan, iCh, level + 1, baseLevel, recurse, order2);
      else if (iScan < iCh)
        order2.push(new BidiSpan(iScan, iCh, localLevel));
      iCh = iScan;
    }
  }
}
function computeSectionOrder(line2, level, baseLevel, isolates, from, to2, order2) {
  let outerType = level % 2 ? 2 : 1;
  computeCharTypes(line2, from, to2, isolates, outerType);
  processBracketPairs(line2, from, to2, isolates, outerType);
  processNeutrals(from, to2, isolates, outerType);
  emitSpans(line2, from, to2, level, baseLevel, isolates, order2);
}
function computeOrder(line2, direction, isolates) {
  if (!line2)
    return [new BidiSpan(0, 0, direction == RTL ? 1 : 0)];
  if (direction == LTR && !isolates.length && !BidiRE.test(line2))
    return trivialOrder(line2.length);
  if (isolates.length)
    while (line2.length > types.length)
      types[types.length] = 256;
  let order2 = [], level = direction == LTR ? 0 : 1;
  computeSectionOrder(line2, level, level, isolates, 0, line2.length, order2);
  return order2;
}
function trivialOrder(length) {
  return [new BidiSpan(0, length, 0)];
}
let movedOver = "";
function moveVisually(line2, order2, dir, start, forward) {
  var _a2;
  let startIndex = start.head - line2.from;
  let spanI = BidiSpan.find(order2, startIndex, (_a2 = start.bidiLevel) !== null && _a2 !== void 0 ? _a2 : -1, start.assoc);
  let span = order2[spanI], spanEnd = span.side(forward, dir);
  if (startIndex == spanEnd) {
    let nextI = spanI += forward ? 1 : -1;
    if (nextI < 0 || nextI >= order2.length)
      return null;
    span = order2[spanI = nextI];
    startIndex = span.side(!forward, dir);
    spanEnd = span.side(forward, dir);
  }
  let nextIndex = findClusterBreak(line2.text, startIndex, span.forward(forward, dir));
  if (nextIndex < span.from || nextIndex > span.to)
    nextIndex = spanEnd;
  movedOver = line2.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
  let nextSpan = spanI == (forward ? order2.length - 1 : 0) ? null : order2[spanI + (forward ? 1 : -1)];
  if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level)
    return EditorSelection.cursor(nextSpan.side(!forward, dir) + line2.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
  return EditorSelection.cursor(nextIndex + line2.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function autoDirection(text2, from, to2) {
  for (let i2 = from; i2 < to2; i2++) {
    let type = charType(text2.charCodeAt(i2));
    if (type == 1)
      return LTR;
    if (type == 2 || type == 4)
      return RTL;
  }
  return LTR;
}
const clickAddsSelectionRange = /* @__PURE__ */ Facet.define();
const dragMovesSelection$1 = /* @__PURE__ */ Facet.define();
const mouseSelectionStyle = /* @__PURE__ */ Facet.define();
const exceptionSink = /* @__PURE__ */ Facet.define();
const updateListener = /* @__PURE__ */ Facet.define();
const inputHandler$1 = /* @__PURE__ */ Facet.define();
const focusChangeEffect = /* @__PURE__ */ Facet.define();
const clipboardInputFilter = /* @__PURE__ */ Facet.define();
const clipboardOutputFilter = /* @__PURE__ */ Facet.define();
const perLineTextDirection = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
const nativeSelectionHidden = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
const scrollHandler = /* @__PURE__ */ Facet.define();
class ScrollTarget {
  constructor(range2, y = "nearest", x2 = "nearest", yMargin = 5, xMargin = 5, isSnapshot = false) {
    this.range = range2;
    this.y = y;
    this.x = x2;
    this.yMargin = yMargin;
    this.xMargin = xMargin;
    this.isSnapshot = isSnapshot;
  }
  map(changes) {
    return changes.empty ? this : new ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(state) {
    return this.range.to <= state.doc.length ? this : new ScrollTarget(EditorSelection.cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const scrollIntoView$1 = /* @__PURE__ */ StateEffect.define({ map: (t2, ch) => t2.map(ch) });
const setEditContextFormatting = /* @__PURE__ */ StateEffect.define();
function logException(state, exception, context) {
  let handler = state.facet(exceptionSink);
  if (handler.length)
    handler[0](exception);
  else if (window.onerror && window.onerror(String(exception), context, void 0, void 0, exception)) ;
  else if (context)
    console.error(context + ":", exception);
  else
    console.error(exception);
}
const editable = /* @__PURE__ */ Facet.define({ combine: (values2) => values2.length ? values2[0] : true });
let nextPluginID = 0;
const viewPlugin = /* @__PURE__ */ Facet.define({
  combine(plugins2) {
    return plugins2.filter((p, i2) => {
      for (let j2 = 0; j2 < i2; j2++)
        if (plugins2[j2].plugin == p.plugin)
          return false;
      return true;
    });
  }
});
class ViewPlugin {
  constructor(id2, create2, domEventHandlers, domEventObservers, buildExtensions) {
    this.id = id2;
    this.create = create2;
    this.domEventHandlers = domEventHandlers;
    this.domEventObservers = domEventObservers;
    this.baseExtensions = buildExtensions(this);
    this.extension = this.baseExtensions.concat(viewPlugin.of({ plugin: this, arg: void 0 }));
  }
  /**
  Create an extension for this plugin with the given argument.
  */
  of(arg) {
    return this.baseExtensions.concat(viewPlugin.of({ plugin: this, arg }));
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(create2, spec) {
    const { eventHandlers, eventObservers, provide, decorations: deco } = spec || {};
    return new ViewPlugin(nextPluginID++, create2, eventHandlers, eventObservers, (plugin) => {
      let ext = [];
      if (deco)
        ext.push(decorations.of((view) => {
          let pluginInst = view.plugin(plugin);
          return pluginInst ? deco(pluginInst) : Decoration.none;
        }));
      if (provide)
        ext.push(provide(plugin));
      return ext;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(cls, spec) {
    return ViewPlugin.define((view, arg) => new cls(view, arg), spec);
  }
}
class PluginInstance {
  constructor(spec) {
    this.spec = spec;
    this.mustUpdate = null;
    this.value = null;
  }
  get plugin() {
    return this.spec && this.spec.plugin;
  }
  update(view) {
    if (!this.value) {
      if (this.spec) {
        try {
          this.value = this.spec.plugin.create(view, this.spec.arg);
        } catch (e2) {
          logException(view.state, e2, "CodeMirror plugin crashed");
          this.deactivate();
        }
      }
    } else if (this.mustUpdate) {
      let update = this.mustUpdate;
      this.mustUpdate = null;
      if (this.value.update) {
        try {
          this.value.update(update);
        } catch (e2) {
          logException(update.state, e2, "CodeMirror plugin crashed");
          if (this.value.destroy)
            try {
              this.value.destroy();
            } catch (_2) {
            }
          this.deactivate();
        }
      }
    }
    return this;
  }
  destroy(view) {
    var _a2;
    if ((_a2 = this.value) === null || _a2 === void 0 ? void 0 : _a2.destroy) {
      try {
        this.value.destroy();
      } catch (e2) {
        logException(view.state, e2, "CodeMirror plugin crashed");
      }
    }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const editorAttributes = /* @__PURE__ */ Facet.define();
const contentAttributes = /* @__PURE__ */ Facet.define();
const decorations = /* @__PURE__ */ Facet.define();
const outerDecorations = /* @__PURE__ */ Facet.define();
const atomicRanges = /* @__PURE__ */ Facet.define();
const bidiIsolatedRanges = /* @__PURE__ */ Facet.define();
function getIsolatedRanges(view, line2) {
  let isolates = view.state.facet(bidiIsolatedRanges);
  if (!isolates.length)
    return isolates;
  let sets2 = isolates.map((i2) => i2 instanceof Function ? i2(view) : i2);
  let result2 = [];
  RangeSet.spans(sets2, line2.from, line2.to, {
    point() {
    },
    span(fromDoc, toDoc, active, open) {
      let from = fromDoc - line2.from, to2 = toDoc - line2.from;
      let level = result2;
      for (let i2 = active.length - 1; i2 >= 0; i2--, open--) {
        let direction = active[i2].spec.bidiIsolate, update;
        if (direction == null)
          direction = autoDirection(line2.text, from, to2);
        if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
          update.to = to2;
          level = update.inner;
        } else {
          let add2 = { from, to: to2, direction, inner: [] };
          level.push(add2);
          level = add2.inner;
        }
      }
    }
  });
  return result2;
}
const scrollMargins = /* @__PURE__ */ Facet.define();
function getScrollMargins(view) {
  let left = 0, right = 0, top2 = 0, bottom = 0;
  for (let source of view.state.facet(scrollMargins)) {
    let m = source(view);
    if (m) {
      if (m.left != null)
        left = Math.max(left, m.left);
      if (m.right != null)
        right = Math.max(right, m.right);
      if (m.top != null)
        top2 = Math.max(top2, m.top);
      if (m.bottom != null)
        bottom = Math.max(bottom, m.bottom);
    }
  }
  return { left, right, top: top2, bottom };
}
const styleModule = /* @__PURE__ */ Facet.define();
class ChangedRange {
  constructor(fromA, toA, fromB, toB) {
    this.fromA = fromA;
    this.toA = toA;
    this.fromB = fromB;
    this.toB = toB;
  }
  join(other) {
    return new ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
  }
  addToSet(set2) {
    let i2 = set2.length, me2 = this;
    for (; i2 > 0; i2--) {
      let range2 = set2[i2 - 1];
      if (range2.fromA > me2.toA)
        continue;
      if (range2.toA < me2.fromA)
        break;
      me2 = me2.join(range2);
      set2.splice(i2 - 1, 1);
    }
    set2.splice(i2, 0, me2);
    return set2;
  }
  static extendWithRanges(diff, ranges) {
    if (ranges.length == 0)
      return diff;
    let result2 = [];
    for (let dI = 0, rI = 0, posA = 0, posB = 0; ; dI++) {
      let next = dI == diff.length ? null : diff[dI], off2 = posA - posB;
      let end = next ? next.fromB : 1e9;
      while (rI < ranges.length && ranges[rI] < end) {
        let from = ranges[rI], to2 = ranges[rI + 1];
        let fromB = Math.max(posB, from), toB = Math.min(end, to2);
        if (fromB <= toB)
          new ChangedRange(fromB + off2, toB + off2, fromB, toB).addToSet(result2);
        if (to2 > end)
          break;
        else
          rI += 2;
      }
      if (!next)
        return result2;
      new ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result2);
      posA = next.toA;
      posB = next.toB;
    }
  }
}
class ViewUpdate {
  constructor(view, state, transactions) {
    this.view = view;
    this.state = state;
    this.transactions = transactions;
    this.flags = 0;
    this.startState = view.state;
    this.changes = ChangeSet.empty(this.startState.doc.length);
    for (let tr2 of transactions)
      this.changes = this.changes.compose(tr2.changes);
    let changedRanges = [];
    this.changes.iterChangedRanges((fromA, toA, fromB, toB) => changedRanges.push(new ChangedRange(fromA, toA, fromB, toB)));
    this.changedRanges = changedRanges;
  }
  /**
  @internal
  */
  static create(view, state, transactions) {
    return new ViewUpdate(view, state, transactions);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Returns true when
  [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
  and the viewport change is not just the result of mapping it in
  response to document changes.
  */
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & (16 | 2)) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((tr2) => tr2.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class DocView extends ContentView {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(view) {
    super();
    this.view = view;
    this.decorations = [];
    this.dynamicDecorationMap = [false];
    this.domChanged = null;
    this.hasComposition = null;
    this.markedForComposition = /* @__PURE__ */ new Set();
    this.editContextFormatting = Decoration.none;
    this.lastCompositionAfterCursor = false;
    this.minWidth = 0;
    this.minWidthFrom = 0;
    this.minWidthTo = 0;
    this.impreciseAnchor = null;
    this.impreciseHead = null;
    this.forceSelection = false;
    this.lastUpdate = Date.now();
    this.setDOM(view.contentDOM);
    this.children = [new LineView()];
    this.children[0].setParent(this);
    this.updateDeco();
    this.updateInner([new ChangedRange(0, 0, 0, view.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(update) {
    var _a2;
    let changedRanges = update.changedRanges;
    if (this.minWidth > 0 && changedRanges.length) {
      if (!changedRanges.every(({ fromA, toA }) => toA < this.minWidthFrom || fromA > this.minWidthTo)) {
        this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
      } else {
        this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
        this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
      }
    }
    this.updateEditContextFormatting(update);
    let readCompositionAt = -1;
    if (this.view.inputState.composing >= 0 && !this.view.observer.editContext) {
      if ((_a2 = this.domChanged) === null || _a2 === void 0 ? void 0 : _a2.newSel)
        readCompositionAt = this.domChanged.newSel.head;
      else if (!touchesComposition(update.changes, this.hasComposition) && !update.selectionSet)
        readCompositionAt = update.state.selection.main.head;
    }
    let composition = readCompositionAt > -1 ? findCompositionRange(this.view, update.changes, readCompositionAt) : null;
    this.domChanged = null;
    if (this.hasComposition) {
      this.markedForComposition.clear();
      let { from, to: to2 } = this.hasComposition;
      changedRanges = new ChangedRange(from, to2, update.changes.mapPos(from, -1), update.changes.mapPos(to2, 1)).addToSet(changedRanges.slice());
    }
    this.hasComposition = composition ? { from: composition.range.fromB, to: composition.range.toB } : null;
    if ((browser$2.ie || browser$2.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines)
      this.forceSelection = true;
    let prevDeco = this.decorations, deco = this.updateDeco();
    let decoDiff = findChangedDeco(prevDeco, deco, update.changes);
    changedRanges = ChangedRange.extendWithRanges(changedRanges, decoDiff);
    if (!(this.flags & 7) && changedRanges.length == 0) {
      return false;
    } else {
      this.updateInner(changedRanges, update.startState.doc.length, composition);
      if (update.transactions.length)
        this.lastUpdate = Date.now();
      return true;
    }
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(changes, oldLength, composition) {
    this.view.viewState.mustMeasureContent = true;
    this.updateChildren(changes, oldLength, composition);
    let { observer } = this.view;
    observer.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
      this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let track = browser$2.chrome || browser$2.ios ? { node: observer.selectionRange.focusNode, written: false } : void 0;
      this.sync(this.view, track);
      this.flags &= -8;
      if (track && (track.written || observer.selectionRange.focusNode != track.node))
        this.forceSelection = true;
      this.dom.style.height = "";
    });
    this.markedForComposition.forEach(
      (cView) => cView.flags &= -9
      /* ViewFlag.Composition */
    );
    let gaps = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
      for (let child of this.children)
        if (child instanceof BlockWidgetView && child.widget instanceof BlockGapWidget)
          gaps.push(child.dom);
    }
    observer.updateGaps(gaps);
  }
  updateChildren(changes, oldLength, composition) {
    let ranges = composition ? composition.range.addToSet(changes.slice()) : changes;
    let cursor2 = this.childCursor(oldLength);
    for (let i2 = ranges.length - 1; ; i2--) {
      let next = i2 >= 0 ? ranges[i2] : null;
      if (!next)
        break;
      let { fromA, toA, fromB, toB } = next, content2, breakAtStart, openStart, openEnd;
      if (composition && composition.range.fromB < toB && composition.range.toB > fromB) {
        let before2 = ContentBuilder.build(this.view.state.doc, fromB, composition.range.fromB, this.decorations, this.dynamicDecorationMap);
        let after2 = ContentBuilder.build(this.view.state.doc, composition.range.toB, toB, this.decorations, this.dynamicDecorationMap);
        breakAtStart = before2.breakAtStart;
        openStart = before2.openStart;
        openEnd = after2.openEnd;
        let compLine = this.compositionView(composition);
        if (after2.breakAtStart) {
          compLine.breakAfter = 1;
        } else if (after2.content.length && compLine.merge(compLine.length, compLine.length, after2.content[0], false, after2.openStart, 0)) {
          compLine.breakAfter = after2.content[0].breakAfter;
          after2.content.shift();
        }
        if (before2.content.length && compLine.merge(0, 0, before2.content[before2.content.length - 1], true, 0, before2.openEnd)) {
          before2.content.pop();
        }
        content2 = before2.content.concat(compLine).concat(after2.content);
      } else {
        ({ content: content2, breakAtStart, openStart, openEnd } = ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap));
      }
      let { i: toI, off: toOff } = cursor2.findPos(toA, 1);
      let { i: fromI, off: fromOff } = cursor2.findPos(fromA, -1);
      replaceRange(this, fromI, fromOff, toI, toOff, content2, breakAtStart, openStart, openEnd);
    }
    if (composition)
      this.fixCompositionDOM(composition);
  }
  updateEditContextFormatting(update) {
    this.editContextFormatting = this.editContextFormatting.map(update.changes);
    for (let tr2 of update.transactions)
      for (let effect of tr2.effects)
        if (effect.is(setEditContextFormatting)) {
          this.editContextFormatting = effect.value;
        }
  }
  compositionView(composition) {
    let cur2 = new TextView(composition.text.nodeValue);
    cur2.flags |= 8;
    for (let { deco } of composition.marks)
      cur2 = new MarkView(deco, [cur2], cur2.length);
    let line2 = new LineView();
    line2.append(cur2, 0);
    return line2;
  }
  fixCompositionDOM(composition) {
    let fix = (dom, cView2) => {
      cView2.flags |= 8 | (cView2.children.some(
        (c2) => c2.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0);
      this.markedForComposition.add(cView2);
      let prev = ContentView.get(dom);
      if (prev && prev != cView2)
        prev.dom = null;
      cView2.setDOM(dom);
    };
    let pos = this.childPos(composition.range.fromB, 1);
    let cView = this.children[pos.i];
    fix(composition.line, cView);
    for (let i2 = composition.marks.length - 1; i2 >= -1; i2--) {
      pos = cView.childPos(pos.off, 1);
      cView = cView.children[pos.i];
      fix(i2 >= 0 ? composition.marks[i2].node : composition.text, cView);
    }
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(mustRead = false, fromPointer = false) {
    if (mustRead || !this.view.observer.selectionRange.focusNode)
      this.view.observer.readSelectionRange();
    let activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
    let selectionNotFocus = !focused && !(this.view.state.facet(editable) || this.dom.tabIndex > -1) && hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
    if (!(focused || fromPointer || selectionNotFocus))
      return;
    let force = this.forceSelection;
    this.forceSelection = false;
    let main2 = this.view.state.selection.main;
    let anchor = this.moveToLine(this.domAtPos(main2.anchor));
    let head = main2.empty ? anchor : this.moveToLine(this.domAtPos(main2.head));
    if (browser$2.gecko && main2.empty && !this.hasComposition && betweenUneditable(anchor)) {
      let dummy = document.createTextNode("");
      this.view.observer.ignore(() => anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
      anchor = head = new DOMPos(dummy, 0);
      force = true;
    }
    let domSel = this.view.observer.selectionRange;
    if (force || !domSel.focusNode || (!isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main2)) {
      this.view.observer.ignore(() => {
        if (browser$2.android && browser$2.chrome && this.dom.contains(domSel.focusNode) && inUneditable(domSel.focusNode, this.dom)) {
          this.dom.blur();
          this.dom.focus({ preventScroll: true });
        }
        let rawSel = getSelection(this.view.root);
        if (!rawSel) ;
        else if (main2.empty) {
          if (browser$2.gecko) {
            let nextTo = nextToUneditable(anchor.node, anchor.offset);
            if (nextTo && nextTo != (1 | 2)) {
              let text2 = (nextTo == 1 ? textNodeBefore : textNodeAfter)(anchor.node, anchor.offset);
              if (text2)
                anchor = new DOMPos(text2.node, text2.offset);
            }
          }
          rawSel.collapse(anchor.node, anchor.offset);
          if (main2.bidiLevel != null && rawSel.caretBidiLevel !== void 0)
            rawSel.caretBidiLevel = main2.bidiLevel;
        } else if (rawSel.extend) {
          rawSel.collapse(anchor.node, anchor.offset);
          try {
            rawSel.extend(head.node, head.offset);
          } catch (_2) {
          }
        } else {
          let range2 = document.createRange();
          if (main2.anchor > main2.head)
            [anchor, head] = [head, anchor];
          range2.setEnd(head.node, head.offset);
          range2.setStart(anchor.node, anchor.offset);
          rawSel.removeAllRanges();
          rawSel.addRange(range2);
        }
        if (selectionNotFocus && this.view.root.activeElement == this.dom) {
          this.dom.blur();
          if (activeElt)
            activeElt.focus();
        }
      });
      this.view.observer.setSelectionRange(anchor, head);
    }
    this.impreciseAnchor = anchor.precise ? null : new DOMPos(domSel.anchorNode, domSel.anchorOffset);
    this.impreciseHead = head.precise ? null : new DOMPos(domSel.focusNode, domSel.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(sel, cursor2) {
    return this.hasComposition && cursor2.empty && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor2.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view } = this, cursor2 = view.state.selection.main;
    let sel = getSelection(view.root);
    let { anchorNode, anchorOffset } = view.observer.selectionRange;
    if (!sel || !cursor2.empty || !cursor2.assoc || !sel.modify)
      return;
    let line2 = LineView.find(this, cursor2.head);
    if (!line2)
      return;
    let lineStart = line2.posAtStart;
    if (cursor2.head == lineStart || cursor2.head == lineStart + line2.length)
      return;
    let before2 = this.coordsAt(cursor2.head, -1), after2 = this.coordsAt(cursor2.head, 1);
    if (!before2 || !after2 || before2.bottom > after2.top)
      return;
    let dom = this.domAtPos(cursor2.head + cursor2.assoc);
    sel.collapse(dom.node, dom.offset);
    sel.modify("move", cursor2.assoc < 0 ? "forward" : "backward", "lineboundary");
    view.observer.readSelectionRange();
    let newRange = view.observer.selectionRange;
    if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor2.from)
      sel.collapse(anchorNode, anchorOffset);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(pos) {
    let dom = this.dom, newPos;
    if (pos.node != dom)
      return pos;
    for (let i2 = pos.offset; !newPos && i2 < dom.childNodes.length; i2++) {
      let view = ContentView.get(dom.childNodes[i2]);
      if (view instanceof LineView)
        newPos = view.domAtPos(0);
    }
    for (let i2 = pos.offset - 1; !newPos && i2 >= 0; i2--) {
      let view = ContentView.get(dom.childNodes[i2]);
      if (view instanceof LineView)
        newPos = view.domAtPos(view.length);
    }
    return newPos ? new DOMPos(newPos.node, newPos.offset, true) : pos;
  }
  nearest(dom) {
    for (let cur2 = dom; cur2; ) {
      let domView = ContentView.get(cur2);
      if (domView && domView.rootView == this)
        return domView;
      cur2 = cur2.parentNode;
    }
    return null;
  }
  posFromDOM(node, offset2) {
    let view = this.nearest(node);
    if (!view)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return view.localPosFromDOM(node, offset2) + view.posAtStart;
  }
  domAtPos(pos) {
    let { i: i2, off: off2 } = this.childCursor().findPos(pos, -1);
    for (; i2 < this.children.length - 1; ) {
      let child = this.children[i2];
      if (off2 < child.length || child instanceof LineView)
        break;
      i2++;
      off2 = 0;
    }
    return this.children[i2].domAtPos(off2);
  }
  coordsAt(pos, side) {
    let best = null, bestPos = 0;
    for (let off2 = this.length, i2 = this.children.length - 1; i2 >= 0; i2--) {
      let child = this.children[i2], end = off2 - child.breakAfter, start = end - child.length;
      if (end < pos)
        break;
      if (start <= pos && (start < pos || child.covers(-1)) && (end > pos || child.covers(1)) && (!best || child instanceof LineView && !(best instanceof LineView && side >= 0))) {
        best = child;
        bestPos = start;
      } else if (best && start == pos && end == pos && child instanceof BlockWidgetView && Math.abs(side) < 2) {
        if (child.deco.startSide < 0)
          break;
        else if (i2)
          best = null;
      }
      off2 = start;
    }
    return best ? best.coordsAt(pos - bestPos, side) : null;
  }
  coordsForChar(pos) {
    let { i: i2, off: off2 } = this.childPos(pos, 1), child = this.children[i2];
    if (!(child instanceof LineView))
      return null;
    while (child.children.length) {
      let { i: i22, off: childOff } = child.childPos(off2, 1);
      for (; ; i22++) {
        if (i22 == child.children.length)
          return null;
        if ((child = child.children[i22]).length)
          break;
      }
      off2 = childOff;
    }
    if (!(child instanceof TextView))
      return null;
    let end = findClusterBreak(child.text, off2);
    if (end == off2)
      return null;
    let rects = textRange(child.dom, off2, end).getClientRects();
    for (let i22 = 0; i22 < rects.length; i22++) {
      let rect = rects[i22];
      if (i22 == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right)
        return rect;
    }
    return null;
  }
  measureVisibleLineHeights(viewport) {
    let result2 = [], { from, to: to2 } = viewport;
    let contentWidth = this.view.contentDOM.clientWidth;
    let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
    let widest = -1, ltr = this.view.textDirection == Direction.LTR;
    for (let pos = 0, i2 = 0; i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (end > to2)
        break;
      if (pos >= from) {
        let childRect = child.dom.getBoundingClientRect();
        result2.push(childRect.height);
        if (isWider) {
          let last2 = child.dom.lastChild;
          let rects = last2 ? clientRectsFor(last2) : [];
          if (rects.length) {
            let rect = rects[rects.length - 1];
            let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
            if (width > widest) {
              widest = width;
              this.minWidth = contentWidth;
              this.minWidthFrom = pos;
              this.minWidthTo = end;
            }
          }
        }
      }
      pos = end + child.breakAfter;
    }
    return result2;
  }
  textDirectionAt(pos) {
    let { i: i2 } = this.childPos(pos, 1);
    return getComputedStyle(this.children[i2].dom).direction == "rtl" ? Direction.RTL : Direction.LTR;
  }
  measureTextSize() {
    for (let child of this.children) {
      if (child instanceof LineView) {
        let measure = child.measureTextSize();
        if (measure)
          return measure;
      }
    }
    let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
    dummy.className = "cm-line";
    dummy.style.width = "99999px";
    dummy.style.position = "absolute";
    dummy.textContent = "abc def ghi jkl mno pqr stu";
    this.view.observer.ignore(() => {
      this.dom.appendChild(dummy);
      let rect = clientRectsFor(dummy.firstChild)[0];
      lineHeight = dummy.getBoundingClientRect().height;
      charWidth = rect ? rect.width / 27 : 7;
      textHeight = rect ? rect.height : lineHeight;
      dummy.remove();
    });
    return { lineHeight, charWidth, textHeight };
  }
  childCursor(pos = this.length) {
    let i2 = this.children.length;
    if (i2)
      pos -= this.children[--i2].length;
    return new ChildCursor(this.children, pos, i2);
  }
  computeBlockGapDeco() {
    let deco = [], vs = this.view.viewState;
    for (let pos = 0, i2 = 0; ; i2++) {
      let next = i2 == vs.viewports.length ? null : vs.viewports[i2];
      let end = next ? next.from - 1 : this.length;
      if (end > pos) {
        let height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
        deco.push(Decoration.replace({
          widget: new BlockGapWidget(height),
          block: true,
          inclusive: true,
          isBlockGap: true
        }).range(pos, end));
      }
      if (!next)
        break;
      pos = next.to + 1;
    }
    return Decoration.set(deco);
  }
  updateDeco() {
    let i2 = 1;
    let allDeco = this.view.state.facet(decorations).map((d) => {
      let dynamic = this.dynamicDecorationMap[i2++] = typeof d == "function";
      return dynamic ? d(this.view) : d;
    });
    let dynamicOuter = false, outerDeco = this.view.state.facet(outerDecorations).map((d, i22) => {
      let dynamic = typeof d == "function";
      if (dynamic)
        dynamicOuter = true;
      return dynamic ? d(this.view) : d;
    });
    if (outerDeco.length) {
      this.dynamicDecorationMap[i2++] = dynamicOuter;
      allDeco.push(RangeSet.join(outerDeco));
    }
    this.decorations = [
      this.editContextFormatting,
      ...allDeco,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ];
    while (i2 < this.decorations.length)
      this.dynamicDecorationMap[i2++] = false;
    return this.decorations;
  }
  scrollIntoView(target) {
    if (target.isSnapshot) {
      let ref = this.view.viewState.lineBlockAt(target.range.head);
      this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
      this.view.scrollDOM.scrollLeft = target.xMargin;
      return;
    }
    for (let handler of this.view.state.facet(scrollHandler)) {
      try {
        if (handler(this.view, target.range, target))
          return true;
      } catch (e2) {
        logException(this.view.state, e2, "scroll handler");
      }
    }
    let { range: range2 } = target;
    let rect = this.coordsAt(range2.head, range2.empty ? range2.assoc : range2.head > range2.anchor ? -1 : 1), other;
    if (!rect)
      return;
    if (!range2.empty && (other = this.coordsAt(range2.anchor, range2.anchor > range2.head ? -1 : 1)))
      rect = {
        left: Math.min(rect.left, other.left),
        top: Math.min(rect.top, other.top),
        right: Math.max(rect.right, other.right),
        bottom: Math.max(rect.bottom, other.bottom)
      };
    let margins = getScrollMargins(this.view);
    let targetRect = {
      left: rect.left - margins.left,
      top: rect.top - margins.top,
      right: rect.right + margins.right,
      bottom: rect.bottom + margins.bottom
    };
    let { offsetWidth, offsetHeight } = this.view.scrollDOM;
    scrollRectIntoView(this.view.scrollDOM, targetRect, range2.head < range2.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == Direction.LTR);
  }
  lineHasWidget(pos) {
    let { i: i2 } = this.childCursor().findPos(pos);
    if (i2 == this.children.length)
      return false;
    let scan = (child) => child instanceof WidgetView || child.children.some(scan);
    return scan(this.children[i2]);
  }
}
function betweenUneditable(pos) {
  return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
function findCompositionNode(view, headPos) {
  let sel = view.observer.selectionRange;
  if (!sel.focusNode)
    return null;
  let textBefore = textNodeBefore(sel.focusNode, sel.focusOffset);
  let textAfter = textNodeAfter(sel.focusNode, sel.focusOffset);
  let textNode = textBefore || textAfter;
  if (textAfter && textBefore && textAfter.node != textBefore.node) {
    let descAfter = ContentView.get(textAfter.node);
    if (!descAfter || descAfter instanceof TextView && descAfter.text != textAfter.node.nodeValue) {
      textNode = textAfter;
    } else if (view.docView.lastCompositionAfterCursor) {
      let descBefore = ContentView.get(textBefore.node);
      if (!(!descBefore || descBefore instanceof TextView && descBefore.text != textBefore.node.nodeValue))
        textNode = textAfter;
    }
  }
  view.docView.lastCompositionAfterCursor = textNode != textBefore;
  if (!textNode)
    return null;
  let from = headPos - textNode.offset;
  return { from, to: from + textNode.node.nodeValue.length, node: textNode.node };
}
function findCompositionRange(view, changes, headPos) {
  let found = findCompositionNode(view, headPos);
  if (!found)
    return null;
  let { node: textNode, from, to: to2 } = found, text2 = textNode.nodeValue;
  if (/[\n\r]/.test(text2))
    return null;
  if (view.state.doc.sliceString(found.from, found.to) != text2)
    return null;
  let inv = changes.invertedDesc;
  let range2 = new ChangedRange(inv.mapPos(from), inv.mapPos(to2), from, to2);
  let marks = [];
  for (let parent = textNode.parentNode; ; parent = parent.parentNode) {
    let parentView = ContentView.get(parent);
    if (parentView instanceof MarkView)
      marks.push({ node: parent, deco: parentView.mark });
    else if (parentView instanceof LineView || parent.nodeName == "DIV" && parent.parentNode == view.contentDOM)
      return { range: range2, text: textNode, marks, line: parent };
    else if (parent != view.contentDOM)
      marks.push({ node: parent, deco: new MarkDecoration({
        inclusive: true,
        attributes: getAttrs(parent),
        tagName: parent.tagName.toLowerCase()
      }) });
    else
      return null;
  }
}
function nextToUneditable(node, offset2) {
  if (node.nodeType != 1)
    return 0;
  return (offset2 && node.childNodes[offset2 - 1].contentEditable == "false" ? 1 : 0) | (offset2 < node.childNodes.length && node.childNodes[offset2].contentEditable == "false" ? 2 : 0);
}
let DecorationComparator$1 = class DecorationComparator {
  constructor() {
    this.changes = [];
  }
  compareRange(from, to2) {
    addRange(from, to2, this.changes);
  }
  comparePoint(from, to2) {
    addRange(from, to2, this.changes);
  }
  boundChange(pos) {
    addRange(pos, pos, this.changes);
  }
};
function findChangedDeco(a, b2, diff) {
  let comp = new DecorationComparator$1();
  RangeSet.compare(a, b2, diff, comp);
  return comp.changes;
}
function inUneditable(node, inside2) {
  for (let cur2 = node; cur2 && cur2 != inside2; cur2 = cur2.assignedSlot || cur2.parentNode) {
    if (cur2.nodeType == 1 && cur2.contentEditable == "false") {
      return true;
    }
  }
  return false;
}
function touchesComposition(changes, composition) {
  let touched = false;
  if (composition)
    changes.iterChangedRanges((from, to2) => {
      if (from < composition.to && to2 > composition.from)
        touched = true;
    });
  return touched;
}
function groupAt(state, pos, bias = 1) {
  let categorize = state.charCategorizer(pos);
  let line2 = state.doc.lineAt(pos), linePos = pos - line2.from;
  if (line2.length == 0)
    return EditorSelection.cursor(pos);
  if (linePos == 0)
    bias = 1;
  else if (linePos == line2.length)
    bias = -1;
  let from = linePos, to2 = linePos;
  if (bias < 0)
    from = findClusterBreak(line2.text, linePos, false);
  else
    to2 = findClusterBreak(line2.text, linePos);
  let cat = categorize(line2.text.slice(from, to2));
  while (from > 0) {
    let prev = findClusterBreak(line2.text, from, false);
    if (categorize(line2.text.slice(prev, from)) != cat)
      break;
    from = prev;
  }
  while (to2 < line2.length) {
    let next = findClusterBreak(line2.text, to2);
    if (categorize(line2.text.slice(to2, next)) != cat)
      break;
    to2 = next;
  }
  return EditorSelection.range(from + line2.from, to2 + line2.from);
}
function getdx(x2, rect) {
  return rect.left > x2 ? rect.left - x2 : Math.max(0, x2 - rect.right);
}
function getdy(y, rect) {
  return rect.top > y ? rect.top - y : Math.max(0, y - rect.bottom);
}
function yOverlap(a, b2) {
  return a.top < b2.bottom - 1 && a.bottom > b2.top + 1;
}
function upTop(rect, top2) {
  return top2 < rect.top ? { top: top2, left: rect.left, right: rect.right, bottom: rect.bottom } : rect;
}
function upBot(rect, bottom) {
  return bottom > rect.bottom ? { top: rect.top, left: rect.left, right: rect.right, bottom } : rect;
}
function domPosAtCoords(parent, x2, y) {
  let closest, closestRect, closestX, closestY, closestOverlap = false;
  let above, below, aboveRect, belowRect;
  for (let child = parent.firstChild; child; child = child.nextSibling) {
    let rects = clientRectsFor(child);
    for (let i2 = 0; i2 < rects.length; i2++) {
      let rect = rects[i2];
      if (closestRect && yOverlap(closestRect, rect))
        rect = upTop(upBot(rect, closestRect.bottom), closestRect.top);
      let dx = getdx(x2, rect), dy = getdy(y, rect);
      if (dx == 0 && dy == 0)
        return child.nodeType == 3 ? domPosInText(child, x2, y) : domPosAtCoords(child, x2, y);
      if (!closest || closestY > dy || closestY == dy && closestX > dx) {
        closest = child;
        closestRect = rect;
        closestX = dx;
        closestY = dy;
        closestOverlap = !dx ? true : x2 < rect.left ? i2 > 0 : i2 < rects.length - 1;
      }
      if (dx == 0) {
        if (y > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
          above = child;
          aboveRect = rect;
        } else if (y < rect.top && (!belowRect || belowRect.top > rect.top)) {
          below = child;
          belowRect = rect;
        }
      } else if (aboveRect && yOverlap(aboveRect, rect)) {
        aboveRect = upBot(aboveRect, rect.bottom);
      } else if (belowRect && yOverlap(belowRect, rect)) {
        belowRect = upTop(belowRect, rect.top);
      }
    }
  }
  if (aboveRect && aboveRect.bottom >= y) {
    closest = above;
    closestRect = aboveRect;
  } else if (belowRect && belowRect.top <= y) {
    closest = below;
    closestRect = belowRect;
  }
  if (!closest)
    return { node: parent, offset: 0 };
  let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x2));
  if (closest.nodeType == 3)
    return domPosInText(closest, clipX, y);
  if (closestOverlap && closest.contentEditable != "false")
    return domPosAtCoords(closest, clipX, y);
  let offset2 = Array.prototype.indexOf.call(parent.childNodes, closest) + (x2 >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
  return { node: parent, offset: offset2 };
}
function domPosInText(node, x2, y) {
  let len = node.nodeValue.length;
  let closestOffset = -1, closestDY = 1e9, generalSide = 0;
  for (let i2 = 0; i2 < len; i2++) {
    let rects = textRange(node, i2, i2 + 1).getClientRects();
    for (let j2 = 0; j2 < rects.length; j2++) {
      let rect = rects[j2];
      if (rect.top == rect.bottom)
        continue;
      if (!generalSide)
        generalSide = x2 - rect.left;
      let dy = (rect.top > y ? rect.top - y : y - rect.bottom) - 1;
      if (rect.left - 1 <= x2 && rect.right + 1 >= x2 && dy < closestDY) {
        let right = x2 >= (rect.left + rect.right) / 2, after2 = right;
        if (browser$2.chrome || browser$2.gecko) {
          let rectBefore = textRange(node, i2).getBoundingClientRect();
          if (Math.abs(rectBefore.left - rect.right) < 0.1)
            after2 = !right;
        }
        if (dy <= 0)
          return { node, offset: i2 + (after2 ? 1 : 0) };
        closestOffset = i2 + (after2 ? 1 : 0);
        closestDY = dy;
      }
    }
  }
  return { node, offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0 };
}
function posAtCoords(view, coords, precise, bias = -1) {
  var _a2, _b;
  let content2 = view.contentDOM.getBoundingClientRect(), docTop = content2.top + view.viewState.paddingTop;
  let block, { docHeight } = view.viewState;
  let { x: x2, y } = coords, yOffset = y - docTop;
  if (yOffset < 0)
    return 0;
  if (yOffset > docHeight)
    return view.state.doc.length;
  for (let halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false; ; ) {
    block = view.elementAtHeight(yOffset);
    if (block.type == BlockType.Text)
      break;
    for (; ; ) {
      yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
      if (yOffset >= 0 && yOffset <= docHeight)
        break;
      if (bounced)
        return precise ? null : 0;
      bounced = true;
      bias = -bias;
    }
  }
  y = docTop + yOffset;
  let lineStart = block.from;
  if (lineStart < view.viewport.from)
    return view.viewport.from == 0 ? 0 : precise ? null : posAtCoordsImprecise(view, content2, block, x2, y);
  if (lineStart > view.viewport.to)
    return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : posAtCoordsImprecise(view, content2, block, x2, y);
  let doc2 = view.dom.ownerDocument;
  let root2 = view.root.elementFromPoint ? view.root : doc2;
  let element2 = root2.elementFromPoint(x2, y);
  if (element2 && !view.contentDOM.contains(element2))
    element2 = null;
  if (!element2) {
    x2 = Math.max(content2.left + 1, Math.min(content2.right - 1, x2));
    element2 = root2.elementFromPoint(x2, y);
    if (element2 && !view.contentDOM.contains(element2))
      element2 = null;
  }
  let node, offset2 = -1;
  if (element2 && ((_a2 = view.docView.nearest(element2)) === null || _a2 === void 0 ? void 0 : _a2.isEditable) != false) {
    if (doc2.caretPositionFromPoint) {
      let pos = doc2.caretPositionFromPoint(x2, y);
      if (pos)
        ({ offsetNode: node, offset: offset2 } = pos);
    } else if (doc2.caretRangeFromPoint) {
      let range2 = doc2.caretRangeFromPoint(x2, y);
      if (range2)
        ({ startContainer: node, startOffset: offset2 } = range2);
    }
    if (node && (!view.contentDOM.contains(node) || browser$2.safari && isSuspiciousSafariCaretResult(node, offset2, x2) || browser$2.chrome && isSuspiciousChromeCaretResult(node, offset2, x2)))
      node = void 0;
    if (node)
      offset2 = Math.min(maxOffset(node), offset2);
  }
  if (!node || !view.docView.dom.contains(node)) {
    let line2 = LineView.find(view.docView, lineStart);
    if (!line2)
      return yOffset > block.top + block.height / 2 ? block.to : block.from;
    ({ node, offset: offset2 } = domPosAtCoords(line2.dom, x2, y));
  }
  let nearest = view.docView.nearest(node);
  if (!nearest)
    return null;
  if (nearest.isWidget && ((_b = nearest.dom) === null || _b === void 0 ? void 0 : _b.nodeType) == 1) {
    let rect = nearest.dom.getBoundingClientRect();
    return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
  } else {
    return nearest.localPosFromDOM(node, offset2) + nearest.posAtStart;
  }
}
function posAtCoordsImprecise(view, contentRect, block, x2, y) {
  let into = Math.round((x2 - contentRect.left) * view.defaultCharacterWidth);
  if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
    let textHeight = view.viewState.heightOracle.textHeight;
    let line2 = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
    into += line2 * view.viewState.heightOracle.lineLength;
  }
  let content2 = view.state.sliceDoc(block.from, block.to);
  return block.from + findColumn(content2, into, view.state.tabSize);
}
function isEndOfLineBefore(node, offset2, x2) {
  let len, scan = node;
  if (node.nodeType != 3 || offset2 != (len = node.nodeValue.length))
    return false;
  for (; ; ) {
    let next = scan.nextSibling;
    if (next) {
      if (next.nodeName == "BR")
        break;
      return false;
    } else {
      let parent = scan.parentNode;
      if (!parent || parent.nodeName == "DIV")
        break;
      scan = parent;
    }
  }
  return textRange(node, len - 1, len).getBoundingClientRect().right > x2;
}
function isSuspiciousSafariCaretResult(node, offset2, x2) {
  return isEndOfLineBefore(node, offset2, x2);
}
function isSuspiciousChromeCaretResult(node, offset2, x2) {
  if (offset2 != 0)
    return isEndOfLineBefore(node, offset2, x2);
  for (let cur2 = node; ; ) {
    let parent = cur2.parentNode;
    if (!parent || parent.nodeType != 1 || parent.firstChild != cur2)
      return false;
    if (parent.classList.contains("cm-line"))
      break;
    cur2 = parent;
  }
  let rect = node.nodeType == 1 ? node.getBoundingClientRect() : textRange(node, 0, Math.max(node.nodeValue.length, 1)).getBoundingClientRect();
  return x2 - rect.left > 5;
}
function blockAt(view, pos, side) {
  let line2 = view.lineBlockAt(pos);
  if (Array.isArray(line2.type)) {
    let best;
    for (let l of line2.type) {
      if (l.from > pos)
        break;
      if (l.to < pos)
        continue;
      if (l.from < pos && l.to > pos)
        return l;
      if (!best || l.type == BlockType.Text && (best.type != l.type || (side < 0 ? l.from < pos : l.to > pos)))
        best = l;
    }
    return best || line2;
  }
  return line2;
}
function moveToLineBoundary(view, start, forward, includeWrap) {
  let line2 = blockAt(view, start.head, start.assoc || -1);
  let coords = !includeWrap || line2.type != BlockType.Text || !(view.lineWrapping || line2.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line2.from ? start.head - 1 : start.head);
  if (coords) {
    let editorRect = view.dom.getBoundingClientRect();
    let direction = view.textDirectionAt(line2.from);
    let pos = view.posAtCoords({
      x: forward == (direction == Direction.LTR) ? editorRect.right - 1 : editorRect.left + 1,
      y: (coords.top + coords.bottom) / 2
    });
    if (pos != null)
      return EditorSelection.cursor(pos, forward ? -1 : 1);
  }
  return EditorSelection.cursor(forward ? line2.to : line2.from, forward ? -1 : 1);
}
function moveByChar(view, start, forward, by) {
  let line2 = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line2);
  let direction = view.textDirectionAt(line2.from);
  for (let cur2 = start, check = null; ; ) {
    let next = moveVisually(line2, spans, direction, cur2, forward), char = movedOver;
    if (!next) {
      if (line2.number == (forward ? view.state.doc.lines : 1))
        return cur2;
      char = "\n";
      line2 = view.state.doc.line(line2.number + (forward ? 1 : -1));
      spans = view.bidiSpans(line2);
      next = view.visualLineSide(line2, !forward);
    }
    if (!check) {
      if (!by)
        return next;
      check = by(char);
    } else if (!check(char)) {
      return cur2;
    }
    cur2 = next;
  }
}
function byGroup(view, pos, start) {
  let categorize = view.state.charCategorizer(pos);
  let cat = categorize(start);
  return (next) => {
    let nextCat = categorize(next);
    if (cat == CharCategory.Space)
      cat = nextCat;
    return cat == nextCat;
  };
}
function moveVertically(view, start, forward, distance) {
  let startPos = start.head, dir = forward ? 1 : -1;
  if (startPos == (forward ? view.state.doc.length : 0))
    return EditorSelection.cursor(startPos, start.assoc);
  let goal = start.goalColumn, startY;
  let rect = view.contentDOM.getBoundingClientRect();
  let startCoords = view.coordsAtPos(startPos, start.assoc || -1), docTop = view.documentTop;
  if (startCoords) {
    if (goal == null)
      goal = startCoords.left - rect.left;
    startY = dir < 0 ? startCoords.top : startCoords.bottom;
  } else {
    let line2 = view.viewState.lineBlockAt(startPos);
    if (goal == null)
      goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line2.from));
    startY = (dir < 0 ? line2.top : line2.bottom) + docTop;
  }
  let resolvedGoal = rect.left + goal;
  let dist2 = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
  for (let extra = 0; ; extra += 10) {
    let curY = startY + (dist2 + extra) * dir;
    let pos = posAtCoords(view, { x: resolvedGoal, y: curY }, false, dir);
    if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) {
      let charRect = view.docView.coordsForChar(pos);
      let assoc = !charRect || curY < charRect.top ? -1 : 1;
      return EditorSelection.cursor(pos, assoc, void 0, goal);
    }
  }
}
function skipAtomicRanges(atoms, pos, bias) {
  for (; ; ) {
    let moved = 0;
    for (let set2 of atoms) {
      set2.between(pos - 1, pos + 1, (from, to2, value) => {
        if (pos > from && pos < to2) {
          let side = moved || bias || (pos - from < to2 - pos ? -1 : 1);
          pos = side < 0 ? from : to2;
          moved = side;
        }
      });
    }
    if (!moved)
      return pos;
  }
}
function skipAtomsForSelection(atoms, sel) {
  let ranges = null;
  for (let i2 = 0; i2 < sel.ranges.length; i2++) {
    let range2 = sel.ranges[i2], updated = null;
    if (range2.empty) {
      let pos = skipAtomicRanges(atoms, range2.from, 0);
      if (pos != range2.from)
        updated = EditorSelection.cursor(pos, -1);
    } else {
      let from = skipAtomicRanges(atoms, range2.from, -1);
      let to2 = skipAtomicRanges(atoms, range2.to, 1);
      if (from != range2.from || to2 != range2.to)
        updated = EditorSelection.range(range2.from == range2.anchor ? from : to2, range2.from == range2.head ? from : to2);
    }
    if (updated) {
      if (!ranges)
        ranges = sel.ranges.slice();
      ranges[i2] = updated;
    }
  }
  return ranges ? EditorSelection.create(ranges, sel.mainIndex) : sel;
}
function skipAtoms(view, oldPos, pos) {
  let newPos = skipAtomicRanges(view.state.facet(atomicRanges).map((f2) => f2(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
  return newPos == pos.from ? pos : EditorSelection.cursor(newPos, newPos < pos.from ? 1 : -1);
}
const LineBreakPlaceholder = "￿";
class DOMReader {
  constructor(points, state) {
    this.points = points;
    this.text = "";
    this.lineSeparator = state.facet(EditorState.lineSeparator);
  }
  append(text2) {
    this.text += text2;
  }
  lineBreak() {
    this.text += LineBreakPlaceholder;
  }
  readRange(start, end) {
    if (!start)
      return this;
    let parent = start.parentNode;
    for (let cur2 = start; ; ) {
      this.findPointBefore(parent, cur2);
      let oldLen = this.text.length;
      this.readNode(cur2);
      let next = cur2.nextSibling;
      if (next == end)
        break;
      let view = ContentView.get(cur2), nextView = ContentView.get(next);
      if ((view && nextView ? view.breakAfter : (view ? view.breakAfter : isBlockElement(cur2)) || isBlockElement(next) && (cur2.nodeName != "BR" || cur2.cmIgnore) && this.text.length > oldLen) && !isEmptyToEnd(next, end))
        this.lineBreak();
      cur2 = next;
    }
    this.findPointBefore(parent, end);
    return this;
  }
  readTextNode(node) {
    let text2 = node.nodeValue;
    for (let point2 of this.points)
      if (point2.node == node)
        point2.pos = this.text.length + Math.min(point2.offset, text2.length);
    for (let off2 = 0, re2 = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let nextBreak = -1, breakSize = 1, m;
      if (this.lineSeparator) {
        nextBreak = text2.indexOf(this.lineSeparator, off2);
        breakSize = this.lineSeparator.length;
      } else if (m = re2.exec(text2)) {
        nextBreak = m.index;
        breakSize = m[0].length;
      }
      this.append(text2.slice(off2, nextBreak < 0 ? text2.length : nextBreak));
      if (nextBreak < 0)
        break;
      this.lineBreak();
      if (breakSize > 1) {
        for (let point2 of this.points)
          if (point2.node == node && point2.pos > this.text.length)
            point2.pos -= breakSize - 1;
      }
      off2 = nextBreak + breakSize;
    }
  }
  readNode(node) {
    if (node.cmIgnore)
      return;
    let view = ContentView.get(node);
    let fromView = view && view.overrideDOMText;
    if (fromView != null) {
      this.findPointInside(node, fromView.length);
      for (let i2 = fromView.iter(); !i2.next().done; ) {
        if (i2.lineBreak)
          this.lineBreak();
        else
          this.append(i2.value);
      }
    } else if (node.nodeType == 3) {
      this.readTextNode(node);
    } else if (node.nodeName == "BR") {
      if (node.nextSibling)
        this.lineBreak();
    } else if (node.nodeType == 1) {
      this.readRange(node.firstChild, null);
    }
  }
  findPointBefore(node, next) {
    for (let point2 of this.points)
      if (point2.node == node && node.childNodes[point2.offset] == next)
        point2.pos = this.text.length;
  }
  findPointInside(node, length) {
    for (let point2 of this.points)
      if (node.nodeType == 3 ? point2.node == node : node.contains(point2.node))
        point2.pos = this.text.length + (isAtEnd(node, point2.node, point2.offset) ? length : 0);
  }
}
function isAtEnd(parent, node, offset2) {
  for (; ; ) {
    if (!node || offset2 < maxOffset(node))
      return false;
    if (node == parent)
      return true;
    offset2 = domIndex(node) + 1;
    node = node.parentNode;
  }
}
function isEmptyToEnd(node, end) {
  let widgets;
  for (; ; node = node.nextSibling) {
    if (node == end || !node)
      break;
    let view = ContentView.get(node);
    if (!((view === null || view === void 0 ? void 0 : view.isWidget) || node.cmIgnore))
      return false;
    if (view)
      (widgets || (widgets = [])).push(view);
  }
  if (widgets)
    for (let w2 of widgets) {
      let override = w2.overrideDOMText;
      if (override === null || override === void 0 ? void 0 : override.length)
        return false;
    }
  return true;
}
class DOMPoint {
  constructor(node, offset2) {
    this.node = node;
    this.offset = offset2;
    this.pos = -1;
  }
}
class DOMChange {
  constructor(view, start, end, typeOver) {
    this.typeOver = typeOver;
    this.bounds = null;
    this.text = "";
    this.domChanged = start > -1;
    let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
    if (view.state.readOnly && start > -1) {
      this.newSel = null;
    } else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
      let selPoints = iHead || iAnchor ? [] : selectionPoints(view);
      let reader = new DOMReader(selPoints, view.state);
      reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
      this.text = reader.text;
      this.newSel = selectionFromPoints(selPoints, this.bounds.from);
    } else {
      let domSel = view.observer.selectionRange;
      let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
      let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
      let vp = view.viewport;
      if ((browser$2.ios || browser$2.chrome) && view.state.selection.main.empty && head != anchor && (vp.from > 0 || vp.to < view.state.doc.length)) {
        let from = Math.min(head, anchor), to2 = Math.max(head, anchor);
        let offFrom = vp.from - from, offTo = vp.to - to2;
        if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to2 == view.state.doc.length)) {
          head = 0;
          anchor = view.state.doc.length;
        }
      }
      if (view.inputState.composing > -1 && view.state.selection.ranges.length > 1)
        this.newSel = view.state.selection.replaceRange(EditorSelection.range(anchor, head));
      else
        this.newSel = EditorSelection.single(anchor, head);
    }
  }
}
function applyDOMChange(view, domChange) {
  let change;
  let { newSel } = domChange, sel = view.state.selection.main;
  let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
  if (domChange.bounds) {
    let { from, to: to2 } = domChange.bounds;
    let preferredPos = sel.from, preferredSide = null;
    if (lastKey === 8 || browser$2.android && domChange.text.length < to2 - from) {
      preferredPos = sel.to;
      preferredSide = "end";
    }
    let diff = findDiff(view.state.doc.sliceString(from, to2, LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
    if (diff) {
      if (browser$2.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == LineBreakPlaceholder + LineBreakPlaceholder)
        diff.toB--;
      change = {
        from: from + diff.from,
        to: from + diff.toA,
        insert: Text$1.of(domChange.text.slice(diff.from, diff.toB).split(LineBreakPlaceholder))
      };
    }
  } else if (newSel && (!view.hasFocus && view.state.facet(editable) || newSel.main.eq(sel))) {
    newSel = null;
  }
  if (!change && !newSel)
    return false;
  if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) {
    change = { from: sel.from, to: sel.to, insert: view.state.doc.slice(sel.from, sel.to) };
  } else if ((browser$2.mac || browser$2.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
    if (newSel && change.insert.length == 2)
      newSel = EditorSelection.single(newSel.main.anchor - 1, newSel.main.head - 1);
    change = { from: change.from, to: change.to, insert: Text$1.of([change.insert.toString().replace(".", " ")]) };
  } else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) {
    change = {
      from: sel.from,
      to: sel.to,
      insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
  } else if (view.state.doc.lineAt(sel.from).to < sel.to && view.docView.lineHasWidget(sel.to) && view.inputState.insertingTextAt > Date.now() - 50) {
    change = {
      from: sel.from,
      to: sel.to,
      insert: view.state.toText(view.inputState.insertingText)
    };
  } else if (browser$2.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
    if (newSel)
      newSel = EditorSelection.single(newSel.main.anchor - 1, newSel.main.head - 1);
    change = { from: sel.from, to: sel.to, insert: Text$1.of([" "]) };
  }
  if (change) {
    return applyDOMChangeInner(view, change, newSel, lastKey);
  } else if (newSel && !newSel.main.eq(sel)) {
    let scrollIntoView2 = false, userEvent = "select";
    if (view.inputState.lastSelectionTime > Date.now() - 50) {
      if (view.inputState.lastSelectionOrigin == "select")
        scrollIntoView2 = true;
      userEvent = view.inputState.lastSelectionOrigin;
      if (userEvent == "select.pointer")
        newSel = skipAtomsForSelection(view.state.facet(atomicRanges).map((f2) => f2(view)), newSel);
    }
    view.dispatch({ selection: newSel, scrollIntoView: scrollIntoView2, userEvent });
    return true;
  } else {
    return false;
  }
}
function applyDOMChangeInner(view, change, newSel, lastKey = -1) {
  if (browser$2.ios && view.inputState.flushIOSKey(change))
    return true;
  let sel = view.state.selection.main;
  if (browser$2.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && dispatchKey(view.contentDOM, "Delete", 46)))
    return true;
  let text2 = change.insert.toString();
  if (view.inputState.composing >= 0)
    view.inputState.composing++;
  let defaultTr;
  let defaultInsert = () => defaultTr || (defaultTr = applyDefaultInsert(view, change, newSel));
  if (!view.state.facet(inputHandler$1).some((h) => h(view, change.from, change.to, text2, defaultInsert)))
    view.dispatch(defaultInsert());
  return true;
}
function applyDefaultInsert(view, change, newSel) {
  let tr2, startState = view.state, sel = startState.selection.main, inAtomic = -1;
  if (change.from == change.to && change.from < sel.from || change.from > sel.to) {
    let side = change.from < sel.from ? -1 : 1, pos = side < 0 ? sel.from : sel.to;
    let moved = skipAtomicRanges(startState.facet(atomicRanges).map((f2) => f2(view)), pos, side);
    if (change.from == moved)
      inAtomic = moved;
  }
  if (inAtomic > -1) {
    tr2 = {
      changes: change,
      selection: EditorSelection.cursor(change.from + change.insert.length, -1)
    };
  } else if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
    let before2 = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
    let after2 = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
    tr2 = startState.replaceSelection(view.state.toText(before2 + change.insert.sliceString(0, void 0, view.state.lineBreak) + after2));
  } else {
    let changes = startState.changes(change);
    let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : void 0;
    if (startState.selection.ranges.length > 1 && (view.inputState.composing >= 0 || view.inputState.compositionPendingChange) && change.to <= sel.to + 10 && change.to >= sel.to - 10) {
      let replaced = view.state.sliceDoc(change.from, change.to);
      let compositionRange, composition = newSel && findCompositionNode(view, newSel.main.head);
      if (composition) {
        let dLen = change.insert.length - (change.to - change.from);
        compositionRange = { from: composition.from, to: composition.to - dLen };
      } else {
        compositionRange = view.state.doc.lineAt(sel.head);
      }
      let offset2 = sel.to - change.to;
      tr2 = startState.changeByRange((range2) => {
        if (range2.from == sel.from && range2.to == sel.to)
          return { changes, range: mainSel || range2.map(changes) };
        let to2 = range2.to - offset2, from = to2 - replaced.length;
        if (view.state.sliceDoc(from, to2) != replaced || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        to2 >= compositionRange.from && from <= compositionRange.to)
          return { range: range2 };
        let rangeChanges = startState.changes({ from, to: to2, insert: change.insert }), selOff = range2.to - sel.to;
        return {
          changes: rangeChanges,
          range: !mainSel ? range2.map(rangeChanges) : EditorSelection.range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
        };
      });
    } else {
      tr2 = {
        changes,
        selection: mainSel && startState.selection.replaceRange(mainSel)
      };
    }
  }
  let userEvent = "input.type";
  if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
    view.inputState.compositionPendingChange = false;
    userEvent += ".compose";
    if (view.inputState.compositionFirstChange) {
      userEvent += ".start";
      view.inputState.compositionFirstChange = false;
    }
  }
  return startState.update(tr2, { userEvent, scrollIntoView: true });
}
function findDiff(a, b2, preferredPos, preferredSide) {
  let minLen = Math.min(a.length, b2.length);
  let from = 0;
  while (from < minLen && a.charCodeAt(from) == b2.charCodeAt(from))
    from++;
  if (from == minLen && a.length == b2.length)
    return null;
  let toA = a.length, toB = b2.length;
  while (toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b2.charCodeAt(toB - 1)) {
    toA--;
    toB--;
  }
  if (preferredSide == "end") {
    let adjust = Math.max(0, from - Math.min(toA, toB));
    preferredPos -= toA + adjust - from;
  }
  if (toA < from && a.length < b2.length) {
    let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
    from -= move;
    toB = from + (toB - toA);
    toA = from;
  } else if (toB < from) {
    let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
    from -= move;
    toA = from + (toA - toB);
    toB = from;
  }
  return { from, toA, toB };
}
function selectionPoints(view) {
  let result2 = [];
  if (view.root.activeElement != view.contentDOM)
    return result2;
  let { anchorNode, anchorOffset, focusNode, focusOffset } = view.observer.selectionRange;
  if (anchorNode) {
    result2.push(new DOMPoint(anchorNode, anchorOffset));
    if (focusNode != anchorNode || focusOffset != anchorOffset)
      result2.push(new DOMPoint(focusNode, focusOffset));
  }
  return result2;
}
function selectionFromPoints(points, base2) {
  if (points.length == 0)
    return null;
  let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
  return anchor > -1 && head > -1 ? EditorSelection.single(anchor + base2, head + base2) : null;
}
class InputState {
  setSelectionOrigin(origin) {
    this.lastSelectionOrigin = origin;
    this.lastSelectionTime = Date.now();
  }
  constructor(view) {
    this.view = view;
    this.lastKeyCode = 0;
    this.lastKeyTime = 0;
    this.lastTouchTime = 0;
    this.lastFocusTime = 0;
    this.lastScrollTop = 0;
    this.lastScrollLeft = 0;
    this.pendingIOSKey = void 0;
    this.tabFocusMode = -1;
    this.lastSelectionOrigin = null;
    this.lastSelectionTime = 0;
    this.lastContextMenu = 0;
    this.scrollHandlers = [];
    this.handlers = /* @__PURE__ */ Object.create(null);
    this.composing = -1;
    this.compositionFirstChange = null;
    this.compositionEndedAt = 0;
    this.compositionPendingKey = false;
    this.compositionPendingChange = false;
    this.insertingText = "";
    this.insertingTextAt = 0;
    this.mouseSelection = null;
    this.draggedContent = null;
    this.handleEvent = this.handleEvent.bind(this);
    this.notifiedFocused = view.hasFocus;
    if (browser$2.safari)
      view.contentDOM.addEventListener("input", () => null);
    if (browser$2.gecko)
      firefoxCopyCutHack(view.contentDOM.ownerDocument);
  }
  handleEvent(event) {
    if (!eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event))
      return;
    if (event.type == "keydown" && this.keydown(event))
      return;
    if (this.view.updateState != 0)
      Promise.resolve().then(() => this.runHandlers(event.type, event));
    else
      this.runHandlers(event.type, event);
  }
  runHandlers(type, event) {
    let handlers2 = this.handlers[type];
    if (handlers2) {
      for (let observer of handlers2.observers)
        observer(this.view, event);
      for (let handler of handlers2.handlers) {
        if (event.defaultPrevented)
          break;
        if (handler(this.view, event)) {
          event.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(plugins2) {
    let handlers2 = computeHandlers(plugins2), prev = this.handlers, dom = this.view.contentDOM;
    for (let type in handlers2)
      if (type != "scroll") {
        let passive = !handlers2[type].handlers.length;
        let exists = prev[type];
        if (exists && passive != !exists.handlers.length) {
          dom.removeEventListener(type, this.handleEvent);
          exists = null;
        }
        if (!exists)
          dom.addEventListener(type, this.handleEvent, { passive });
      }
    for (let type in prev)
      if (type != "scroll" && !handlers2[type])
        dom.removeEventListener(type, this.handleEvent);
    this.handlers = handlers2;
  }
  keydown(event) {
    this.lastKeyCode = event.keyCode;
    this.lastKeyTime = Date.now();
    if (event.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return true;
    if (this.tabFocusMode > 0 && event.keyCode != 27 && modifierCodes.indexOf(event.keyCode) < 0)
      this.tabFocusMode = -1;
    if (browser$2.android && browser$2.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
      this.view.observer.delayAndroidKey(event.key, event.keyCode);
      return true;
    }
    let pending;
    if (browser$2.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = PendingKeys.find((key) => key.keyCode == event.keyCode)) && !event.ctrlKey || EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
      this.pendingIOSKey = pending || event;
      setTimeout(() => this.flushIOSKey(), 250);
      return true;
    }
    if (event.keyCode != 229)
      this.view.observer.forceFlush();
    return false;
  }
  flushIOSKey(change) {
    let key = this.pendingIOSKey;
    if (!key)
      return false;
    if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString()))
      return false;
    this.pendingIOSKey = void 0;
    return dispatchKey(this.view.contentDOM, key.key, key.keyCode, key instanceof KeyboardEvent ? key : void 0);
  }
  ignoreDuringComposition(event) {
    if (!/^key/.test(event.type) || event.synthetic)
      return false;
    if (this.composing > 0)
      return true;
    if (browser$2.safari && !browser$2.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
      this.compositionPendingKey = false;
      return true;
    }
    return false;
  }
  startMouseSelection(mouseSelection) {
    if (this.mouseSelection)
      this.mouseSelection.destroy();
    this.mouseSelection = mouseSelection;
  }
  update(update) {
    this.view.observer.update(update);
    if (this.mouseSelection)
      this.mouseSelection.update(update);
    if (this.draggedContent && update.docChanged)
      this.draggedContent = this.draggedContent.map(update.changes);
    if (update.transactions.length)
      this.lastKeyCode = this.lastSelectionTime = 0;
  }
  destroy() {
    if (this.mouseSelection)
      this.mouseSelection.destroy();
  }
}
function bindHandler(plugin, handler) {
  return (view, event) => {
    try {
      return handler.call(plugin, event, view);
    } catch (e2) {
      logException(view.state, e2);
    }
  };
}
function computeHandlers(plugins2) {
  let result2 = /* @__PURE__ */ Object.create(null);
  function record(type) {
    return result2[type] || (result2[type] = { observers: [], handlers: [] });
  }
  for (let plugin of plugins2) {
    let spec = plugin.spec, handlers2 = spec && spec.plugin.domEventHandlers, observers2 = spec && spec.plugin.domEventObservers;
    if (handlers2)
      for (let type in handlers2) {
        let f2 = handlers2[type];
        if (f2)
          record(type).handlers.push(bindHandler(plugin.value, f2));
      }
    if (observers2)
      for (let type in observers2) {
        let f2 = observers2[type];
        if (f2)
          record(type).observers.push(bindHandler(plugin.value, f2));
      }
  }
  for (let type in handlers)
    record(type).handlers.push(handlers[type]);
  for (let type in observers)
    record(type).observers.push(observers[type]);
  return result2;
}
const PendingKeys = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
];
const EmacsyPendingKeys = "dthko";
const modifierCodes = [16, 17, 18, 20, 91, 92, 224, 225];
const dragScrollMargin = 6;
function dragScrollSpeed(dist2) {
  return Math.max(0, dist2) * 0.7 + 8;
}
function dist(a, b2) {
  return Math.max(Math.abs(a.clientX - b2.clientX), Math.abs(a.clientY - b2.clientY));
}
class MouseSelection {
  constructor(view, startEvent, style, mustSelect) {
    this.view = view;
    this.startEvent = startEvent;
    this.style = style;
    this.mustSelect = mustSelect;
    this.scrollSpeed = { x: 0, y: 0 };
    this.scrolling = -1;
    this.lastEvent = startEvent;
    this.scrollParents = scrollableParents(view.contentDOM);
    this.atoms = view.state.facet(atomicRanges).map((f2) => f2(view));
    let doc2 = view.contentDOM.ownerDocument;
    doc2.addEventListener("mousemove", this.move = this.move.bind(this));
    doc2.addEventListener("mouseup", this.up = this.up.bind(this));
    this.extend = startEvent.shiftKey;
    this.multiple = view.state.facet(EditorState.allowMultipleSelections) && addsSelectionRange(view, startEvent);
    this.dragging = isInPrimarySelection(view, startEvent) && getClickType(startEvent) == 1 ? null : false;
  }
  start(event) {
    if (this.dragging === false)
      this.select(event);
  }
  move(event) {
    if (event.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && dist(this.startEvent, event) < 10)
      return;
    this.select(this.lastEvent = event);
    let sx = 0, sy = 0;
    let left = 0, top2 = 0, right = this.view.win.innerWidth, bottom = this.view.win.innerHeight;
    if (this.scrollParents.x)
      ({ left, right } = this.scrollParents.x.getBoundingClientRect());
    if (this.scrollParents.y)
      ({ top: top2, bottom } = this.scrollParents.y.getBoundingClientRect());
    let margins = getScrollMargins(this.view);
    if (event.clientX - margins.left <= left + dragScrollMargin)
      sx = -dragScrollSpeed(left - event.clientX);
    else if (event.clientX + margins.right >= right - dragScrollMargin)
      sx = dragScrollSpeed(event.clientX - right);
    if (event.clientY - margins.top <= top2 + dragScrollMargin)
      sy = -dragScrollSpeed(top2 - event.clientY);
    else if (event.clientY + margins.bottom >= bottom - dragScrollMargin)
      sy = dragScrollSpeed(event.clientY - bottom);
    this.setScrollSpeed(sx, sy);
  }
  up(event) {
    if (this.dragging == null)
      this.select(this.lastEvent);
    if (!this.dragging)
      event.preventDefault();
    this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let doc2 = this.view.contentDOM.ownerDocument;
    doc2.removeEventListener("mousemove", this.move);
    doc2.removeEventListener("mouseup", this.up);
    this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(sx, sy) {
    this.scrollSpeed = { x: sx, y: sy };
    if (sx || sy) {
      if (this.scrolling < 0)
        this.scrolling = setInterval(() => this.scroll(), 50);
    } else if (this.scrolling > -1) {
      clearInterval(this.scrolling);
      this.scrolling = -1;
    }
  }
  scroll() {
    let { x: x2, y } = this.scrollSpeed;
    if (x2 && this.scrollParents.x) {
      this.scrollParents.x.scrollLeft += x2;
      x2 = 0;
    }
    if (y && this.scrollParents.y) {
      this.scrollParents.y.scrollTop += y;
      y = 0;
    }
    if (x2 || y)
      this.view.win.scrollBy(x2, y);
    if (this.dragging === false)
      this.select(this.lastEvent);
  }
  select(event) {
    let { view } = this, selection2 = skipAtomsForSelection(this.atoms, this.style.get(event, this.extend, this.multiple));
    if (this.mustSelect || !selection2.eq(view.state.selection, this.dragging === false))
      this.view.dispatch({
        selection: selection2,
        userEvent: "select.pointer"
      });
    this.mustSelect = false;
  }
  update(update) {
    if (update.transactions.some((tr2) => tr2.isUserEvent("input.type")))
      this.destroy();
    else if (this.style.update(update))
      setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function addsSelectionRange(view, event) {
  let facet = view.state.facet(clickAddsSelectionRange);
  return facet.length ? facet[0](event) : browser$2.mac ? event.metaKey : event.ctrlKey;
}
function dragMovesSelection(view, event) {
  let facet = view.state.facet(dragMovesSelection$1);
  return facet.length ? facet[0](event) : browser$2.mac ? !event.altKey : !event.ctrlKey;
}
function isInPrimarySelection(view, event) {
  let { main: main2 } = view.state.selection;
  if (main2.empty)
    return false;
  let sel = getSelection(view.root);
  if (!sel || sel.rangeCount == 0)
    return true;
  let rects = sel.getRangeAt(0).getClientRects();
  for (let i2 = 0; i2 < rects.length; i2++) {
    let rect = rects[i2];
    if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY)
      return true;
  }
  return false;
}
function eventBelongsToEditor(view, event) {
  if (!event.bubbles)
    return true;
  if (event.defaultPrevented)
    return false;
  for (let node = event.target, cView; node != view.contentDOM; node = node.parentNode)
    if (!node || node.nodeType == 11 || (cView = ContentView.get(node)) && cView.ignoreEvent(event))
      return false;
  return true;
}
const handlers = /* @__PURE__ */ Object.create(null);
const observers = /* @__PURE__ */ Object.create(null);
const brokenClipboardAPI = browser$2.ie && browser$2.ie_version < 15 || browser$2.ios && browser$2.webkit_version < 604;
function capturePaste(view) {
  let parent = view.dom.parentNode;
  if (!parent)
    return;
  let target = parent.appendChild(document.createElement("textarea"));
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(() => {
    view.focus();
    target.remove();
    doPaste(view, target.value);
  }, 50);
}
function textFilter(state, facet, text2) {
  for (let filter2 of state.facet(facet))
    text2 = filter2(text2, state);
  return text2;
}
function doPaste(view, input) {
  input = textFilter(view.state, clipboardInputFilter, input);
  let { state } = view, changes, i2 = 1, text2 = state.toText(input);
  let byLine = text2.lines == state.selection.ranges.length;
  let linewise = lastLinewiseCopy != null && state.selection.ranges.every((r) => r.empty) && lastLinewiseCopy == text2.toString();
  if (linewise) {
    let lastLine = -1;
    changes = state.changeByRange((range2) => {
      let line2 = state.doc.lineAt(range2.from);
      if (line2.from == lastLine)
        return { range: range2 };
      lastLine = line2.from;
      let insert2 = state.toText((byLine ? text2.line(i2++).text : input) + state.lineBreak);
      return {
        changes: { from: line2.from, insert: insert2 },
        range: EditorSelection.cursor(range2.from + insert2.length)
      };
    });
  } else if (byLine) {
    changes = state.changeByRange((range2) => {
      let line2 = text2.line(i2++);
      return {
        changes: { from: range2.from, to: range2.to, insert: line2.text },
        range: EditorSelection.cursor(range2.from + line2.length)
      };
    });
  } else {
    changes = state.replaceSelection(text2);
  }
  view.dispatch(changes, {
    userEvent: "input.paste",
    scrollIntoView: true
  });
}
observers.scroll = (view) => {
  view.inputState.lastScrollTop = view.scrollDOM.scrollTop;
  view.inputState.lastScrollLeft = view.scrollDOM.scrollLeft;
};
handlers.keydown = (view, event) => {
  view.inputState.setSelectionOrigin("select");
  if (event.keyCode == 27 && view.inputState.tabFocusMode != 0)
    view.inputState.tabFocusMode = Date.now() + 2e3;
  return false;
};
observers.touchstart = (view, e2) => {
  view.inputState.lastTouchTime = Date.now();
  view.inputState.setSelectionOrigin("select.pointer");
};
observers.touchmove = (view) => {
  view.inputState.setSelectionOrigin("select.pointer");
};
handlers.mousedown = (view, event) => {
  view.observer.flush();
  if (view.inputState.lastTouchTime > Date.now() - 2e3)
    return false;
  let style = null;
  for (let makeStyle of view.state.facet(mouseSelectionStyle)) {
    style = makeStyle(view, event);
    if (style)
      break;
  }
  if (!style && event.button == 0)
    style = basicMouseSelection(view, event);
  if (style) {
    let mustFocus = !view.hasFocus;
    view.inputState.startMouseSelection(new MouseSelection(view, event, style, mustFocus));
    if (mustFocus)
      view.observer.ignore(() => {
        focusPreventScroll(view.contentDOM);
        let active = view.root.activeElement;
        if (active && !active.contains(view.contentDOM))
          active.blur();
      });
    let mouseSel = view.inputState.mouseSelection;
    if (mouseSel) {
      mouseSel.start(event);
      return mouseSel.dragging === false;
    }
  } else {
    view.inputState.setSelectionOrigin("select.pointer");
  }
  return false;
};
function rangeForClick(view, pos, bias, type) {
  if (type == 1) {
    return EditorSelection.cursor(pos, bias);
  } else if (type == 2) {
    return groupAt(view.state, pos, bias);
  } else {
    let visual = LineView.find(view.docView, pos), line2 = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
    let from = visual ? visual.posAtStart : line2.from, to2 = visual ? visual.posAtEnd : line2.to;
    if (to2 < view.state.doc.length && to2 == line2.to)
      to2++;
    return EditorSelection.range(from, to2);
  }
}
let inside = (x2, y, rect) => y >= rect.top && y <= rect.bottom && x2 >= rect.left && x2 <= rect.right;
function findPositionSide(view, pos, x2, y) {
  let line2 = LineView.find(view.docView, pos);
  if (!line2)
    return 1;
  let off2 = pos - line2.posAtStart;
  if (off2 == 0)
    return 1;
  if (off2 == line2.length)
    return -1;
  let before2 = line2.coordsAt(off2, -1);
  if (before2 && inside(x2, y, before2))
    return -1;
  let after2 = line2.coordsAt(off2, 1);
  if (after2 && inside(x2, y, after2))
    return 1;
  return before2 && before2.bottom >= y ? -1 : 1;
}
function queryPos(view, event) {
  let pos = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  return { pos, bias: findPositionSide(view, pos, event.clientX, event.clientY) };
}
const BadMouseDetail = browser$2.ie && browser$2.ie_version <= 11;
let lastMouseDown = null, lastMouseDownCount = 0, lastMouseDownTime = 0;
function getClickType(event) {
  if (!BadMouseDetail)
    return event.detail;
  let last2 = lastMouseDown, lastTime = lastMouseDownTime;
  lastMouseDown = event;
  lastMouseDownTime = Date.now();
  return lastMouseDownCount = !last2 || lastTime > Date.now() - 400 && Math.abs(last2.clientX - event.clientX) < 2 && Math.abs(last2.clientY - event.clientY) < 2 ? (lastMouseDownCount + 1) % 3 : 1;
}
function basicMouseSelection(view, event) {
  let start = queryPos(view, event), type = getClickType(event);
  let startSel = view.state.selection;
  return {
    update(update) {
      if (update.docChanged) {
        start.pos = update.changes.mapPos(start.pos);
        startSel = startSel.map(update.changes);
      }
    },
    get(event2, extend2, multiple) {
      let cur2 = queryPos(view, event2), removed;
      let range2 = rangeForClick(view, cur2.pos, cur2.bias, type);
      if (start.pos != cur2.pos && !extend2) {
        let startRange = rangeForClick(view, start.pos, start.bias, type);
        let from = Math.min(startRange.from, range2.from), to2 = Math.max(startRange.to, range2.to);
        range2 = from < range2.from ? EditorSelection.range(from, to2) : EditorSelection.range(to2, from);
      }
      if (extend2)
        return startSel.replaceRange(startSel.main.extend(range2.from, range2.to));
      else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = removeRangeAround(startSel, cur2.pos)))
        return removed;
      else if (multiple)
        return startSel.addRange(range2);
      else
        return EditorSelection.create([range2]);
    }
  };
}
function removeRangeAround(sel, pos) {
  for (let i2 = 0; i2 < sel.ranges.length; i2++) {
    let { from, to: to2 } = sel.ranges[i2];
    if (from <= pos && to2 >= pos)
      return EditorSelection.create(sel.ranges.slice(0, i2).concat(sel.ranges.slice(i2 + 1)), sel.mainIndex == i2 ? 0 : sel.mainIndex - (sel.mainIndex > i2 ? 1 : 0));
  }
  return null;
}
handlers.dragstart = (view, event) => {
  let { selection: { main: range2 } } = view.state;
  if (event.target.draggable) {
    let cView = view.docView.nearest(event.target);
    if (cView && cView.isWidget) {
      let from = cView.posAtStart, to2 = from + cView.length;
      if (from >= range2.to || to2 <= range2.from)
        range2 = EditorSelection.range(from, to2);
    }
  }
  let { inputState } = view;
  if (inputState.mouseSelection)
    inputState.mouseSelection.dragging = true;
  inputState.draggedContent = range2;
  if (event.dataTransfer) {
    event.dataTransfer.setData("Text", textFilter(view.state, clipboardOutputFilter, view.state.sliceDoc(range2.from, range2.to)));
    event.dataTransfer.effectAllowed = "copyMove";
  }
  return false;
};
handlers.dragend = (view) => {
  view.inputState.draggedContent = null;
  return false;
};
function dropText(view, event, text2, direct) {
  text2 = textFilter(view.state, clipboardInputFilter, text2);
  if (!text2)
    return;
  let dropPos = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  let { draggedContent } = view.inputState;
  let del = direct && draggedContent && dragMovesSelection(view, event) ? { from: draggedContent.from, to: draggedContent.to } : null;
  let ins = { from: dropPos, insert: text2 };
  let changes = view.state.changes(del ? [del, ins] : ins);
  view.focus();
  view.dispatch({
    changes,
    selection: { anchor: changes.mapPos(dropPos, -1), head: changes.mapPos(dropPos, 1) },
    userEvent: del ? "move.drop" : "input.drop"
  });
  view.inputState.draggedContent = null;
}
handlers.drop = (view, event) => {
  if (!event.dataTransfer)
    return false;
  if (view.state.readOnly)
    return true;
  let files = event.dataTransfer.files;
  if (files && files.length) {
    let text2 = Array(files.length), read = 0;
    let finishFile = () => {
      if (++read == files.length)
        dropText(view, event, text2.filter((s) => s != null).join(view.state.lineBreak), false);
    };
    for (let i2 = 0; i2 < files.length; i2++) {
      let reader = new FileReader();
      reader.onerror = finishFile;
      reader.onload = () => {
        if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result))
          text2[i2] = reader.result;
        finishFile();
      };
      reader.readAsText(files[i2]);
    }
    return true;
  } else {
    let text2 = event.dataTransfer.getData("Text");
    if (text2) {
      dropText(view, event, text2, true);
      return true;
    }
  }
  return false;
};
handlers.paste = (view, event) => {
  if (view.state.readOnly)
    return true;
  view.observer.flush();
  let data = brokenClipboardAPI ? null : event.clipboardData;
  if (data) {
    doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
    return true;
  } else {
    capturePaste(view);
    return false;
  }
};
function captureCopy(view, text2) {
  let parent = view.dom.parentNode;
  if (!parent)
    return;
  let target = parent.appendChild(document.createElement("textarea"));
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.value = text2;
  target.focus();
  target.selectionEnd = text2.length;
  target.selectionStart = 0;
  setTimeout(() => {
    target.remove();
    view.focus();
  }, 50);
}
function copiedRange(state) {
  let content2 = [], ranges = [], linewise = false;
  for (let range2 of state.selection.ranges)
    if (!range2.empty) {
      content2.push(state.sliceDoc(range2.from, range2.to));
      ranges.push(range2);
    }
  if (!content2.length) {
    let upto = -1;
    for (let { from } of state.selection.ranges) {
      let line2 = state.doc.lineAt(from);
      if (line2.number > upto) {
        content2.push(line2.text);
        ranges.push({ from: line2.from, to: Math.min(state.doc.length, line2.to + 1) });
      }
      upto = line2.number;
    }
    linewise = true;
  }
  return { text: textFilter(state, clipboardOutputFilter, content2.join(state.lineBreak)), ranges, linewise };
}
let lastLinewiseCopy = null;
handlers.copy = handlers.cut = (view, event) => {
  let { text: text2, ranges, linewise } = copiedRange(view.state);
  if (!text2 && !linewise)
    return false;
  lastLinewiseCopy = linewise ? text2 : null;
  if (event.type == "cut" && !view.state.readOnly)
    view.dispatch({
      changes: ranges,
      scrollIntoView: true,
      userEvent: "delete.cut"
    });
  let data = brokenClipboardAPI ? null : event.clipboardData;
  if (data) {
    data.clearData();
    data.setData("text/plain", text2);
    return true;
  } else {
    captureCopy(view, text2);
    return false;
  }
};
const isFocusChange = /* @__PURE__ */ Annotation.define();
function focusChangeTransaction(state, focus) {
  let effects = [];
  for (let getEffect of state.facet(focusChangeEffect)) {
    let effect = getEffect(state, focus);
    if (effect)
      effects.push(effect);
  }
  return effects.length ? state.update({ effects, annotations: isFocusChange.of(true) }) : null;
}
function updateForFocusChange(view) {
  setTimeout(() => {
    let focus = view.hasFocus;
    if (focus != view.inputState.notifiedFocused) {
      let tr2 = focusChangeTransaction(view.state, focus);
      if (tr2)
        view.dispatch(tr2);
      else
        view.update([]);
    }
  }, 10);
}
observers.focus = (view) => {
  view.inputState.lastFocusTime = Date.now();
  if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
    view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
    view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
  }
  updateForFocusChange(view);
};
observers.blur = (view) => {
  view.observer.clearSelectionRange();
  updateForFocusChange(view);
};
observers.compositionstart = observers.compositionupdate = (view) => {
  if (view.observer.editContext)
    return;
  if (view.inputState.compositionFirstChange == null)
    view.inputState.compositionFirstChange = true;
  if (view.inputState.composing < 0) {
    view.inputState.composing = 0;
  }
};
observers.compositionend = (view) => {
  if (view.observer.editContext)
    return;
  view.inputState.composing = -1;
  view.inputState.compositionEndedAt = Date.now();
  view.inputState.compositionPendingKey = true;
  view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
  view.inputState.compositionFirstChange = null;
  if (browser$2.chrome && browser$2.android) {
    view.observer.flushSoon();
  } else if (view.inputState.compositionPendingChange) {
    Promise.resolve().then(() => view.observer.flush());
  } else {
    setTimeout(() => {
      if (view.inputState.composing < 0 && view.docView.hasComposition)
        view.update([]);
    }, 50);
  }
};
observers.contextmenu = (view) => {
  view.inputState.lastContextMenu = Date.now();
};
handlers.beforeinput = (view, event) => {
  var _a2, _b;
  if (event.inputType == "insertText" || event.inputType == "insertCompositionText") {
    view.inputState.insertingText = event.data;
    view.inputState.insertingTextAt = Date.now();
  }
  if (event.inputType == "insertReplacementText" && view.observer.editContext) {
    let text2 = (_a2 = event.dataTransfer) === null || _a2 === void 0 ? void 0 : _a2.getData("text/plain"), ranges = event.getTargetRanges();
    if (text2 && ranges.length) {
      let r = ranges[0];
      let from = view.posAtDOM(r.startContainer, r.startOffset), to2 = view.posAtDOM(r.endContainer, r.endOffset);
      applyDOMChangeInner(view, { from, to: to2, insert: view.state.toText(text2) }, null);
      return true;
    }
  }
  let pending;
  if (browser$2.chrome && browser$2.android && (pending = PendingKeys.find((key) => key.inputType == event.inputType))) {
    view.observer.delayAndroidKey(pending.key, pending.keyCode);
    if (pending.key == "Backspace" || pending.key == "Delete") {
      let startViewHeight = ((_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.height) || 0;
      setTimeout(() => {
        var _a3;
        if ((((_a3 = window.visualViewport) === null || _a3 === void 0 ? void 0 : _a3.height) || 0) > startViewHeight + 10 && view.hasFocus) {
          view.contentDOM.blur();
          view.focus();
        }
      }, 100);
    }
  }
  if (browser$2.ios && event.inputType == "deleteContentForward") {
    view.observer.flushSoon();
  }
  if (browser$2.safari && event.inputType == "insertText" && view.inputState.composing >= 0) {
    setTimeout(() => observers.compositionend(view, event), 20);
  }
  return false;
};
const appliedFirefoxHack = /* @__PURE__ */ new Set();
function firefoxCopyCutHack(doc2) {
  if (!appliedFirefoxHack.has(doc2)) {
    appliedFirefoxHack.add(doc2);
    doc2.addEventListener("copy", () => {
    });
    doc2.addEventListener("cut", () => {
    });
  }
}
const wrappingWhiteSpace = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let heightChangeFlag = false;
function clearHeightChangeFlag() {
  heightChangeFlag = false;
}
class HeightOracle {
  constructor(lineWrapping) {
    this.lineWrapping = lineWrapping;
    this.doc = Text$1.empty;
    this.heightSamples = {};
    this.lineHeight = 14;
    this.charWidth = 7;
    this.textHeight = 14;
    this.lineLength = 30;
  }
  heightForGap(from, to2) {
    let lines = this.doc.lineAt(to2).number - this.doc.lineAt(from).number + 1;
    if (this.lineWrapping)
      lines += Math.max(0, Math.ceil((to2 - from - lines * this.lineLength * 0.5) / this.lineLength));
    return this.lineHeight * lines;
  }
  heightForLine(length) {
    if (!this.lineWrapping)
      return this.lineHeight;
    let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / Math.max(1, this.lineLength - 5)));
    return lines * this.lineHeight;
  }
  setDoc(doc2) {
    this.doc = doc2;
    return this;
  }
  mustRefreshForWrapping(whiteSpace) {
    return wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(lineHeights) {
    let newHeight = false;
    for (let i2 = 0; i2 < lineHeights.length; i2++) {
      let h = lineHeights[i2];
      if (h < 0) {
        i2++;
      } else if (!this.heightSamples[Math.floor(h * 10)]) {
        newHeight = true;
        this.heightSamples[Math.floor(h * 10)] = true;
      }
    }
    return newHeight;
  }
  refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
    let lineWrapping = wrappingWhiteSpace.indexOf(whiteSpace) > -1;
    let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
    this.lineWrapping = lineWrapping;
    this.lineHeight = lineHeight;
    this.charWidth = charWidth;
    this.textHeight = textHeight;
    this.lineLength = lineLength;
    if (changed) {
      this.heightSamples = {};
      for (let i2 = 0; i2 < knownHeights.length; i2++) {
        let h = knownHeights[i2];
        if (h < 0)
          i2++;
        else
          this.heightSamples[Math.floor(h * 10)] = true;
      }
    }
    return changed;
  }
}
class MeasuredHeights {
  constructor(from, heights) {
    this.from = from;
    this.heights = heights;
    this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class BlockInfo {
  /**
  @internal
  */
  constructor(from, length, top2, height, _content) {
    this.from = from;
    this.length = length;
    this.top = top2;
    this.height = height;
    this._content = _content;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? BlockType.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof PointDecoration ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(other) {
    let content2 = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(other._content) ? other._content : [other]);
    return new BlockInfo(this.from, this.length + other.length, this.top, this.height + other.height, content2);
  }
}
var QueryType$1 = /* @__PURE__ */ (function(QueryType2) {
  QueryType2[QueryType2["ByPos"] = 0] = "ByPos";
  QueryType2[QueryType2["ByHeight"] = 1] = "ByHeight";
  QueryType2[QueryType2["ByPosNoHeight"] = 2] = "ByPosNoHeight";
  return QueryType2;
})(QueryType$1 || (QueryType$1 = {}));
const Epsilon = 1e-3;
class HeightMap {
  constructor(length, height, flags = 2) {
    this.length = length;
    this.height = height;
    this.flags = flags;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(value) {
    this.flags = (value ? 2 : 0) | this.flags & -3;
  }
  setHeight(height) {
    if (this.height != height) {
      if (Math.abs(this.height - height) > Epsilon)
        heightChangeFlag = true;
      this.height = height;
    }
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(_from, _to, nodes) {
    return HeightMap.of(nodes);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(_to, result2) {
    result2.push(this);
  }
  decomposeRight(_from, result2) {
    result2.push(this);
  }
  applyChanges(decorations2, oldDoc, oracle, changes) {
    let me2 = this, doc2 = oracle.doc;
    for (let i2 = changes.length - 1; i2 >= 0; i2--) {
      let { fromA, toA, fromB, toB } = changes[i2];
      let start = me2.lineAt(fromA, QueryType$1.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
      let end = start.to >= toA ? start : me2.lineAt(toA, QueryType$1.ByPosNoHeight, oracle, 0, 0);
      toB += end.to - toA;
      toA = end.to;
      while (i2 > 0 && start.from <= changes[i2 - 1].toA) {
        fromA = changes[i2 - 1].fromA;
        fromB = changes[i2 - 1].fromB;
        i2--;
        if (fromA < start.from)
          start = me2.lineAt(fromA, QueryType$1.ByPosNoHeight, oracle, 0, 0);
      }
      fromB += start.from - fromA;
      fromA = start.from;
      let nodes = NodeBuilder.build(oracle.setDoc(doc2), decorations2, fromB, toB);
      me2 = replace(me2, me2.replace(fromA, toA, nodes));
    }
    return me2.updateHeight(oracle, 0);
  }
  static empty() {
    return new HeightMapText(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(nodes) {
    if (nodes.length == 1)
      return nodes[0];
    let i2 = 0, j2 = nodes.length, before2 = 0, after2 = 0;
    for (; ; ) {
      if (i2 == j2) {
        if (before2 > after2 * 2) {
          let split = nodes[i2 - 1];
          if (split.break)
            nodes.splice(--i2, 1, split.left, null, split.right);
          else
            nodes.splice(--i2, 1, split.left, split.right);
          j2 += 1 + split.break;
          before2 -= split.size;
        } else if (after2 > before2 * 2) {
          let split = nodes[j2];
          if (split.break)
            nodes.splice(j2, 1, split.left, null, split.right);
          else
            nodes.splice(j2, 1, split.left, split.right);
          j2 += 2 + split.break;
          after2 -= split.size;
        } else {
          break;
        }
      } else if (before2 < after2) {
        let next = nodes[i2++];
        if (next)
          before2 += next.size;
      } else {
        let next = nodes[--j2];
        if (next)
          after2 += next.size;
      }
    }
    let brk = 0;
    if (nodes[i2 - 1] == null) {
      brk = 1;
      i2--;
    } else if (nodes[i2] == null) {
      brk = 1;
      j2++;
    }
    return new HeightMapBranch(HeightMap.of(nodes.slice(0, i2)), brk, HeightMap.of(nodes.slice(j2)));
  }
}
function replace(old, val) {
  if (old == val)
    return old;
  if (old.constructor != val.constructor)
    heightChangeFlag = true;
  return val;
}
HeightMap.prototype.size = 1;
class HeightMapBlock extends HeightMap {
  constructor(length, height, deco) {
    super(length, height);
    this.deco = deco;
  }
  blockAt(_height, _oracle, top2, offset2) {
    return new BlockInfo(offset2, this.length, top2, this.height, this.deco || 0);
  }
  lineAt(_value, _type, oracle, top2, offset2) {
    return this.blockAt(0, oracle, top2, offset2);
  }
  forEachLine(from, to2, oracle, top2, offset2, f2) {
    if (from <= offset2 + this.length && to2 >= offset2)
      f2(this.blockAt(0, oracle, top2, offset2));
  }
  updateHeight(oracle, offset2 = 0, _force = false, measured) {
    if (measured && measured.from <= offset2 && measured.more)
      this.setHeight(measured.heights[measured.index++]);
    this.outdated = false;
    return this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class HeightMapText extends HeightMapBlock {
  constructor(length, height) {
    super(length, height, null);
    this.collapsed = 0;
    this.widgetHeight = 0;
    this.breaks = 0;
  }
  blockAt(_height, _oracle, top2, offset2) {
    return new BlockInfo(offset2, this.length, top2, this.height, this.breaks);
  }
  replace(_from, _to, nodes) {
    let node = nodes[0];
    if (nodes.length == 1 && (node instanceof HeightMapText || node instanceof HeightMapGap && node.flags & 4) && Math.abs(this.length - node.length) < 10) {
      if (node instanceof HeightMapGap)
        node = new HeightMapText(node.length, this.height);
      else
        node.height = this.height;
      if (!this.outdated)
        node.outdated = false;
      return node;
    } else {
      return HeightMap.of(nodes);
    }
  }
  updateHeight(oracle, offset2 = 0, force = false, measured) {
    if (measured && measured.from <= offset2 && measured.more)
      this.setHeight(measured.heights[measured.index++]);
    else if (force || this.outdated)
      this.setHeight(Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
    this.outdated = false;
    return this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class HeightMapGap extends HeightMap {
  constructor(length) {
    super(length, 0);
  }
  heightMetrics(oracle, offset2) {
    let firstLine = oracle.doc.lineAt(offset2).number, lastLine = oracle.doc.lineAt(offset2 + this.length).number;
    let lines = lastLine - firstLine + 1;
    let perLine, perChar = 0;
    if (oracle.lineWrapping) {
      let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
      perLine = totalPerLine / lines;
      if (this.length > lines + 1)
        perChar = (this.height - totalPerLine) / (this.length - lines - 1);
    } else {
      perLine = this.height / lines;
    }
    return { firstLine, lastLine, perLine, perChar };
  }
  blockAt(height, oracle, top2, offset2) {
    let { firstLine, lastLine, perLine, perChar } = this.heightMetrics(oracle, offset2);
    if (oracle.lineWrapping) {
      let guess = offset2 + (height < oracle.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (height - top2) / this.height)) * this.length));
      let line2 = oracle.doc.lineAt(guess), lineHeight = perLine + line2.length * perChar;
      let lineTop = Math.max(top2, height - lineHeight / 2);
      return new BlockInfo(line2.from, line2.length, lineTop, lineHeight, 0);
    } else {
      let line2 = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top2) / perLine)));
      let { from, length } = oracle.doc.line(firstLine + line2);
      return new BlockInfo(from, length, top2 + perLine * line2, perLine, 0);
    }
  }
  lineAt(value, type, oracle, top2, offset2) {
    if (type == QueryType$1.ByHeight)
      return this.blockAt(value, oracle, top2, offset2);
    if (type == QueryType$1.ByPosNoHeight) {
      let { from, to: to2 } = oracle.doc.lineAt(value);
      return new BlockInfo(from, to2 - from, 0, 0, 0);
    }
    let { firstLine, perLine, perChar } = this.heightMetrics(oracle, offset2);
    let line2 = oracle.doc.lineAt(value), lineHeight = perLine + line2.length * perChar;
    let linesAbove = line2.number - firstLine;
    let lineTop = top2 + perLine * linesAbove + perChar * (line2.from - offset2 - linesAbove);
    return new BlockInfo(line2.from, line2.length, Math.max(top2, Math.min(lineTop, top2 + this.height - lineHeight)), lineHeight, 0);
  }
  forEachLine(from, to2, oracle, top2, offset2, f2) {
    from = Math.max(from, offset2);
    to2 = Math.min(to2, offset2 + this.length);
    let { firstLine, perLine, perChar } = this.heightMetrics(oracle, offset2);
    for (let pos = from, lineTop = top2; pos <= to2; ) {
      let line2 = oracle.doc.lineAt(pos);
      if (pos == from) {
        let linesAbove = line2.number - firstLine;
        lineTop += perLine * linesAbove + perChar * (from - offset2 - linesAbove);
      }
      let lineHeight = perLine + perChar * line2.length;
      f2(new BlockInfo(line2.from, line2.length, lineTop, lineHeight, 0));
      lineTop += lineHeight;
      pos = line2.to + 1;
    }
  }
  replace(from, to2, nodes) {
    let after2 = this.length - to2;
    if (after2 > 0) {
      let last2 = nodes[nodes.length - 1];
      if (last2 instanceof HeightMapGap)
        nodes[nodes.length - 1] = new HeightMapGap(last2.length + after2);
      else
        nodes.push(null, new HeightMapGap(after2 - 1));
    }
    if (from > 0) {
      let first2 = nodes[0];
      if (first2 instanceof HeightMapGap)
        nodes[0] = new HeightMapGap(from + first2.length);
      else
        nodes.unshift(new HeightMapGap(from - 1), null);
    }
    return HeightMap.of(nodes);
  }
  decomposeLeft(to2, result2) {
    result2.push(new HeightMapGap(to2 - 1), null);
  }
  decomposeRight(from, result2) {
    result2.push(null, new HeightMapGap(this.length - from - 1));
  }
  updateHeight(oracle, offset2 = 0, force = false, measured) {
    let end = offset2 + this.length;
    if (measured && measured.from <= offset2 + this.length && measured.more) {
      let nodes = [], pos = Math.max(offset2, measured.from), singleHeight = -1;
      if (measured.from > offset2)
        nodes.push(new HeightMapGap(measured.from - offset2 - 1).updateHeight(oracle, offset2));
      while (pos <= end && measured.more) {
        let len = oracle.doc.lineAt(pos).length;
        if (nodes.length)
          nodes.push(null);
        let height = measured.heights[measured.index++];
        if (singleHeight == -1)
          singleHeight = height;
        else if (Math.abs(height - singleHeight) >= Epsilon)
          singleHeight = -2;
        let line2 = new HeightMapText(len, height);
        line2.outdated = false;
        nodes.push(line2);
        pos += len + 1;
      }
      if (pos <= end)
        nodes.push(null, new HeightMapGap(end - pos).updateHeight(oracle, pos));
      let result2 = HeightMap.of(nodes);
      if (singleHeight < 0 || Math.abs(result2.height - this.height) >= Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset2).perLine) >= Epsilon)
        heightChangeFlag = true;
      return replace(this, result2);
    } else if (force || this.outdated) {
      this.setHeight(oracle.heightForGap(offset2, offset2 + this.length));
      this.outdated = false;
    }
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class HeightMapBranch extends HeightMap {
  constructor(left, brk, right) {
    super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 : 0));
    this.left = left;
    this.right = right;
    this.size = left.size + right.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(height, oracle, top2, offset2) {
    let mid = top2 + this.left.height;
    return height < mid ? this.left.blockAt(height, oracle, top2, offset2) : this.right.blockAt(height, oracle, mid, offset2 + this.left.length + this.break);
  }
  lineAt(value, type, oracle, top2, offset2) {
    let rightTop = top2 + this.left.height, rightOffset = offset2 + this.left.length + this.break;
    let left = type == QueryType$1.ByHeight ? value < rightTop : value < rightOffset;
    let base2 = left ? this.left.lineAt(value, type, oracle, top2, offset2) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
    if (this.break || (left ? base2.to < rightOffset : base2.from > rightOffset))
      return base2;
    let subQuery = type == QueryType$1.ByPosNoHeight ? QueryType$1.ByPosNoHeight : QueryType$1.ByPos;
    if (left)
      return base2.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
    else
      return this.left.lineAt(rightOffset, subQuery, oracle, top2, offset2).join(base2);
  }
  forEachLine(from, to2, oracle, top2, offset2, f2) {
    let rightTop = top2 + this.left.height, rightOffset = offset2 + this.left.length + this.break;
    if (this.break) {
      if (from < rightOffset)
        this.left.forEachLine(from, to2, oracle, top2, offset2, f2);
      if (to2 >= rightOffset)
        this.right.forEachLine(from, to2, oracle, rightTop, rightOffset, f2);
    } else {
      let mid = this.lineAt(rightOffset, QueryType$1.ByPos, oracle, top2, offset2);
      if (from < mid.from)
        this.left.forEachLine(from, mid.from - 1, oracle, top2, offset2, f2);
      if (mid.to >= from && mid.from <= to2)
        f2(mid);
      if (to2 > mid.to)
        this.right.forEachLine(mid.to + 1, to2, oracle, rightTop, rightOffset, f2);
    }
  }
  replace(from, to2, nodes) {
    let rightStart = this.left.length + this.break;
    if (to2 < rightStart)
      return this.balanced(this.left.replace(from, to2, nodes), this.right);
    if (from > this.left.length)
      return this.balanced(this.left, this.right.replace(from - rightStart, to2 - rightStart, nodes));
    let result2 = [];
    if (from > 0)
      this.decomposeLeft(from, result2);
    let left = result2.length;
    for (let node of nodes)
      result2.push(node);
    if (from > 0)
      mergeGaps(result2, left - 1);
    if (to2 < this.length) {
      let right = result2.length;
      this.decomposeRight(to2, result2);
      mergeGaps(result2, right);
    }
    return HeightMap.of(result2);
  }
  decomposeLeft(to2, result2) {
    let left = this.left.length;
    if (to2 <= left)
      return this.left.decomposeLeft(to2, result2);
    result2.push(this.left);
    if (this.break) {
      left++;
      if (to2 >= left)
        result2.push(null);
    }
    if (to2 > left)
      this.right.decomposeLeft(to2 - left, result2);
  }
  decomposeRight(from, result2) {
    let left = this.left.length, right = left + this.break;
    if (from >= right)
      return this.right.decomposeRight(from - right, result2);
    if (from < left)
      this.left.decomposeRight(from, result2);
    if (this.break && from < right)
      result2.push(null);
    result2.push(this.right);
  }
  balanced(left, right) {
    if (left.size > 2 * right.size || right.size > 2 * left.size)
      return HeightMap.of(this.break ? [left, null, right] : [left, right]);
    this.left = replace(this.left, left);
    this.right = replace(this.right, right);
    this.setHeight(left.height + right.height);
    this.outdated = left.outdated || right.outdated;
    this.size = left.size + right.size;
    this.length = left.length + this.break + right.length;
    return this;
  }
  updateHeight(oracle, offset2 = 0, force = false, measured) {
    let { left, right } = this, rightStart = offset2 + left.length + this.break, rebalance = null;
    if (measured && measured.from <= offset2 + left.length && measured.more)
      rebalance = left = left.updateHeight(oracle, offset2, force, measured);
    else
      left.updateHeight(oracle, offset2, force);
    if (measured && measured.from <= rightStart + right.length && measured.more)
      rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
    else
      right.updateHeight(oracle, rightStart, force);
    if (rebalance)
      return this.balanced(left, right);
    this.height = this.left.height + this.right.height;
    this.outdated = false;
    return this;
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function mergeGaps(nodes, around) {
  let before2, after2;
  if (nodes[around] == null && (before2 = nodes[around - 1]) instanceof HeightMapGap && (after2 = nodes[around + 1]) instanceof HeightMapGap)
    nodes.splice(around - 1, 3, new HeightMapGap(before2.length + 1 + after2.length));
}
const relevantWidgetHeight = 5;
class NodeBuilder {
  constructor(pos, oracle) {
    this.pos = pos;
    this.oracle = oracle;
    this.nodes = [];
    this.lineStart = -1;
    this.lineEnd = -1;
    this.covering = null;
    this.writtenTo = pos;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(_from, to2) {
    if (this.lineStart > -1) {
      let end = Math.min(to2, this.lineEnd), last2 = this.nodes[this.nodes.length - 1];
      if (last2 instanceof HeightMapText)
        last2.length += end - this.pos;
      else if (end > this.pos || !this.isCovered)
        this.nodes.push(new HeightMapText(end - this.pos, -1));
      this.writtenTo = end;
      if (to2 > end) {
        this.nodes.push(null);
        this.writtenTo++;
        this.lineStart = -1;
      }
    }
    this.pos = to2;
  }
  point(from, to2, deco) {
    if (from < to2 || deco.heightRelevant) {
      let height = deco.widget ? deco.widget.estimatedHeight : 0;
      let breaks = deco.widget ? deco.widget.lineBreaks : 0;
      if (height < 0)
        height = this.oracle.lineHeight;
      let len = to2 - from;
      if (deco.block) {
        this.addBlock(new HeightMapBlock(len, height, deco));
      } else if (len || breaks || height >= relevantWidgetHeight) {
        this.addLineDeco(height, breaks, len);
      }
    } else if (to2 > from) {
      this.span(from, to2);
    }
    if (this.lineEnd > -1 && this.lineEnd < this.pos)
      this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from, to: to2 } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = from;
    this.lineEnd = to2;
    if (this.writtenTo < from) {
      if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null)
        this.nodes.push(this.blankContent(this.writtenTo, from - 1));
      this.nodes.push(null);
    }
    if (this.pos > from)
      this.nodes.push(new HeightMapText(this.pos - from, -1));
    this.writtenTo = this.pos;
  }
  blankContent(from, to2) {
    let gap = new HeightMapGap(to2 - from);
    if (this.oracle.doc.lineAt(from).to == to2)
      gap.flags |= 4;
    return gap;
  }
  ensureLine() {
    this.enterLine();
    let last2 = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (last2 instanceof HeightMapText)
      return last2;
    let line2 = new HeightMapText(0, -1);
    this.nodes.push(line2);
    return line2;
  }
  addBlock(block) {
    this.enterLine();
    let deco = block.deco;
    if (deco && deco.startSide > 0 && !this.isCovered)
      this.ensureLine();
    this.nodes.push(block);
    this.writtenTo = this.pos = this.pos + block.length;
    if (deco && deco.endSide > 0)
      this.covering = block;
  }
  addLineDeco(height, breaks, length) {
    let line2 = this.ensureLine();
    line2.length += length;
    line2.collapsed += length;
    line2.widgetHeight = Math.max(line2.widgetHeight, height);
    line2.breaks += breaks;
    this.writtenTo = this.pos = this.pos + length;
  }
  finish(from) {
    let last2 = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    if (this.lineStart > -1 && !(last2 instanceof HeightMapText) && !this.isCovered)
      this.nodes.push(new HeightMapText(0, -1));
    else if (this.writtenTo < this.pos || last2 == null)
      this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let pos = from;
    for (let node of this.nodes) {
      if (node instanceof HeightMapText)
        node.updateHeight(this.oracle, pos);
      pos += node ? node.length : 1;
    }
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(oracle, decorations2, from, to2) {
    let builder = new NodeBuilder(from, oracle);
    RangeSet.spans(decorations2, from, to2, builder, 0);
    return builder.finish(from);
  }
}
function heightRelevantDecoChanges(a, b2, diff) {
  let comp = new DecorationComparator2();
  RangeSet.compare(a, b2, diff, comp, 0);
  return comp.changes;
}
class DecorationComparator2 {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(from, to2, a, b2) {
    if (from < to2 || a && a.heightRelevant || b2 && b2.heightRelevant)
      addRange(from, to2, this.changes, 5);
  }
}
function visiblePixelRange(dom, paddingTop) {
  let rect = dom.getBoundingClientRect();
  let doc2 = dom.ownerDocument, win = doc2.defaultView || window;
  let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
  let top2 = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
  for (let parent = dom.parentNode; parent && parent != doc2.body; ) {
    if (parent.nodeType == 1) {
      let elt = parent;
      let style = window.getComputedStyle(elt);
      if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
        let parentRect = elt.getBoundingClientRect();
        left = Math.max(left, parentRect.left);
        right = Math.min(right, parentRect.right);
        top2 = Math.max(top2, parentRect.top);
        bottom = Math.min(parent == dom.parentNode ? win.innerHeight : bottom, parentRect.bottom);
      }
      parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
    } else if (parent.nodeType == 11) {
      parent = parent.host;
    } else {
      break;
    }
  }
  return {
    left: left - rect.left,
    right: Math.max(left, right) - rect.left,
    top: top2 - (rect.top + paddingTop),
    bottom: Math.max(top2, bottom) - (rect.top + paddingTop)
  };
}
function inWindow(elt) {
  let rect = elt.getBoundingClientRect(), win = elt.ownerDocument.defaultView || window;
  return rect.left < win.innerWidth && rect.right > 0 && rect.top < win.innerHeight && rect.bottom > 0;
}
function fullPixelRange(dom, paddingTop) {
  let rect = dom.getBoundingClientRect();
  return {
    left: 0,
    right: rect.right - rect.left,
    top: paddingTop,
    bottom: rect.bottom - (rect.top + paddingTop)
  };
}
class LineGap {
  constructor(from, to2, size2, displaySize) {
    this.from = from;
    this.to = to2;
    this.size = size2;
    this.displaySize = displaySize;
  }
  static same(a, b2) {
    if (a.length != b2.length)
      return false;
    for (let i2 = 0; i2 < a.length; i2++) {
      let gA = a[i2], gB = b2[i2];
      if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size)
        return false;
    }
    return true;
  }
  draw(viewState, wrapping) {
    return Decoration.replace({
      widget: new LineGapWidget(this.displaySize * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
    }).range(this.from, this.to);
  }
}
class LineGapWidget extends WidgetType {
  constructor(size2, vertical) {
    super();
    this.size = size2;
    this.vertical = vertical;
  }
  eq(other) {
    return other.size == this.size && other.vertical == this.vertical;
  }
  toDOM() {
    let elt = document.createElement("div");
    if (this.vertical) {
      elt.style.height = this.size + "px";
    } else {
      elt.style.width = this.size + "px";
      elt.style.height = "2px";
      elt.style.display = "inline-block";
    }
    return elt;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class ViewState {
  constructor(state) {
    this.state = state;
    this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 };
    this.inView = true;
    this.paddingTop = 0;
    this.paddingBottom = 0;
    this.contentDOMWidth = 0;
    this.contentDOMHeight = 0;
    this.editorHeight = 0;
    this.editorWidth = 0;
    this.scrollTop = 0;
    this.scrolledToBottom = false;
    this.scaleX = 1;
    this.scaleY = 1;
    this.scrollAnchorPos = 0;
    this.scrollAnchorHeight = -1;
    this.scaler = IdScaler;
    this.scrollTarget = null;
    this.printing = false;
    this.mustMeasureContent = true;
    this.defaultTextDirection = Direction.LTR;
    this.visibleRanges = [];
    this.mustEnforceCursorAssoc = false;
    let guessWrapping = state.facet(contentAttributes).some((v2) => typeof v2 != "function" && v2.class == "cm-lineWrapping");
    this.heightOracle = new HeightOracle(guessWrapping);
    this.stateDeco = state.facet(decorations).filter((d) => typeof d != "function");
    this.heightMap = HeightMap.empty().applyChanges(this.stateDeco, Text$1.empty, this.heightOracle.setDoc(state.doc), [new ChangedRange(0, 0, 0, state.doc.length)]);
    for (let i2 = 0; i2 < 2; i2++) {
      this.viewport = this.getViewport(0, null);
      if (!this.updateForViewport())
        break;
    }
    this.updateViewportLines();
    this.lineGaps = this.ensureLineGaps([]);
    this.lineGapDeco = Decoration.set(this.lineGaps.map((gap) => gap.draw(this, false)));
    this.computeVisibleRanges();
  }
  updateForViewport() {
    let viewports = [this.viewport], { main: main2 } = this.state.selection;
    for (let i2 = 0; i2 <= 1; i2++) {
      let pos = i2 ? main2.head : main2.anchor;
      if (!viewports.some(({ from, to: to2 }) => pos >= from && pos <= to2)) {
        let { from, to: to2 } = this.lineBlockAt(pos);
        viewports.push(new Viewport(from, to2));
      }
    }
    this.viewports = viewports.sort((a, b2) => a.from - b2.from);
    return this.updateScaler();
  }
  updateScaler() {
    let scaler = this.scaler;
    this.scaler = this.heightMap.height <= 7e6 ? IdScaler : new BigScaler(this.heightOracle, this.heightMap, this.viewports);
    return scaler.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [];
    this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block) => {
      this.viewportLines.push(scaleBlock(block, this.scaler));
    });
  }
  update(update, scrollTarget = null) {
    this.state = update.state;
    let prevDeco = this.stateDeco;
    this.stateDeco = this.state.facet(decorations).filter((d) => typeof d != "function");
    let contentChanges = update.changedRanges;
    let heightChanges = ChangedRange.extendWithRanges(contentChanges, heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : ChangeSet.empty(this.state.doc.length)));
    let prevHeight = this.heightMap.height;
    let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    clearHeightChangeFlag();
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
    if (this.heightMap.height != prevHeight || heightChangeFlag)
      update.flags |= 2;
    if (scrollAnchor) {
      this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
      this.scrollAnchorHeight = scrollAnchor.top;
    } else {
      this.scrollAnchorPos = -1;
      this.scrollAnchorHeight = prevHeight;
    }
    let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
    if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport))
      viewport = this.getViewport(0, scrollTarget);
    let viewportChange = viewport.from != this.viewport.from || viewport.to != this.viewport.to;
    this.viewport = viewport;
    update.flags |= this.updateForViewport();
    if (viewportChange || !update.changes.empty || update.flags & 2)
      this.updateViewportLines();
    if (this.lineGaps.length || this.viewport.to - this.viewport.from > 2e3 << 1)
      this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
    update.flags |= this.computeVisibleRanges(update.changes);
    if (scrollTarget)
      this.scrollTarget = scrollTarget;
    if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet(nativeSelectionHidden))
      this.mustEnforceCursorAssoc = true;
  }
  measure(view) {
    let dom = view.contentDOM, style = window.getComputedStyle(dom);
    let oracle = this.heightOracle;
    let whiteSpace = style.whiteSpace;
    this.defaultTextDirection = style.direction == "rtl" ? Direction.RTL : Direction.LTR;
    let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
    let domRect = dom.getBoundingClientRect();
    let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
    this.contentDOMHeight = domRect.height;
    this.mustMeasureContent = false;
    let result2 = 0, bias = 0;
    if (domRect.width && domRect.height) {
      let { scaleX, scaleY } = getScale(dom, domRect);
      if (scaleX > 5e-3 && Math.abs(this.scaleX - scaleX) > 5e-3 || scaleY > 5e-3 && Math.abs(this.scaleY - scaleY) > 5e-3) {
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        result2 |= 16;
        refresh = measureContent = true;
      }
    }
    let paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
    let paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
    if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
      this.paddingTop = paddingTop;
      this.paddingBottom = paddingBottom;
      result2 |= 16 | 2;
    }
    if (this.editorWidth != view.scrollDOM.clientWidth) {
      if (oracle.lineWrapping)
        measureContent = true;
      this.editorWidth = view.scrollDOM.clientWidth;
      result2 |= 16;
    }
    let scrollTop = view.scrollDOM.scrollTop * this.scaleY;
    if (this.scrollTop != scrollTop) {
      this.scrollAnchorHeight = -1;
      this.scrollTop = scrollTop;
    }
    this.scrolledToBottom = isScrolledToBottom(view.scrollDOM);
    let pixelViewport = (this.printing ? fullPixelRange : visiblePixelRange)(dom, this.paddingTop);
    let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
    this.pixelViewport = pixelViewport;
    let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (inView != this.inView) {
      this.inView = inView;
      if (inView)
        measureContent = true;
    }
    if (!this.inView && !this.scrollTarget && !inWindow(view.dom))
      return 0;
    let contentWidth = domRect.width;
    if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
      this.contentDOMWidth = domRect.width;
      this.editorHeight = view.scrollDOM.clientHeight;
      result2 |= 16;
    }
    if (measureContent) {
      let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
      if (oracle.mustRefreshForHeights(lineHeights))
        refresh = true;
      if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
        let { lineHeight, charWidth, textHeight } = view.docView.measureTextSize();
        refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, Math.max(5, contentWidth / charWidth), lineHeights);
        if (refresh) {
          view.docView.minWidth = 0;
          result2 |= 16;
        }
      }
      if (dTop > 0 && dBottom > 0)
        bias = Math.max(dTop, dBottom);
      else if (dTop < 0 && dBottom < 0)
        bias = Math.min(dTop, dBottom);
      clearHeightChangeFlag();
      for (let vp of this.viewports) {
        let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
        this.heightMap = (refresh ? HeightMap.empty().applyChanges(this.stateDeco, Text$1.empty, this.heightOracle, [new ChangedRange(0, 0, 0, view.state.doc.length)]) : this.heightMap).updateHeight(oracle, 0, refresh, new MeasuredHeights(vp.from, heights));
      }
      if (heightChangeFlag)
        result2 |= 2;
    }
    let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    if (viewportChange) {
      if (result2 & 2)
        result2 |= this.updateScaler();
      this.viewport = this.getViewport(bias, this.scrollTarget);
      result2 |= this.updateForViewport();
    }
    if (result2 & 2 || viewportChange)
      this.updateViewportLines();
    if (this.lineGaps.length || this.viewport.to - this.viewport.from > 2e3 << 1)
      this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
    result2 |= this.computeVisibleRanges();
    if (this.mustEnforceCursorAssoc) {
      this.mustEnforceCursorAssoc = false;
      view.docView.enforceCursorAssoc();
    }
    return result2;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(bias, scrollTarget) {
    let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1e3 / 2));
    let map2 = this.heightMap, oracle = this.heightOracle;
    let { visibleTop, visibleBottom } = this;
    let viewport = new Viewport(map2.lineAt(visibleTop - marginTop * 1e3, QueryType$1.ByHeight, oracle, 0, 0).from, map2.lineAt(visibleBottom + (1 - marginTop) * 1e3, QueryType$1.ByHeight, oracle, 0, 0).to);
    if (scrollTarget) {
      let { head } = scrollTarget.range;
      if (head < viewport.from || head > viewport.to) {
        let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
        let block = map2.lineAt(head, QueryType$1.ByPos, oracle, 0, 0), topPos;
        if (scrollTarget.y == "center")
          topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
        else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from)
          topPos = block.top;
        else
          topPos = block.bottom - viewHeight;
        viewport = new Viewport(map2.lineAt(topPos - 1e3 / 2, QueryType$1.ByHeight, oracle, 0, 0).from, map2.lineAt(topPos + viewHeight + 1e3 / 2, QueryType$1.ByHeight, oracle, 0, 0).to);
      }
    }
    return viewport;
  }
  mapViewport(viewport, changes) {
    let from = changes.mapPos(viewport.from, -1), to2 = changes.mapPos(viewport.to, 1);
    return new Viewport(this.heightMap.lineAt(from, QueryType$1.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to2, QueryType$1.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from, to: to2 }, bias = 0) {
    if (!this.inView)
      return true;
    let { top: top2 } = this.heightMap.lineAt(from, QueryType$1.ByPos, this.heightOracle, 0, 0);
    let { bottom } = this.heightMap.lineAt(to2, QueryType$1.ByPos, this.heightOracle, 0, 0);
    let { visibleTop, visibleBottom } = this;
    return (from == 0 || top2 <= visibleTop - Math.max(10, Math.min(
      -bias,
      250
      /* VP.MaxCoverMargin */
    ))) && (to2 == this.state.doc.length || bottom >= visibleBottom + Math.max(10, Math.min(
      bias,
      250
      /* VP.MaxCoverMargin */
    ))) && (top2 > visibleTop - 2 * 1e3 && bottom < visibleBottom + 2 * 1e3);
  }
  mapLineGaps(gaps, changes) {
    if (!gaps.length || changes.empty)
      return gaps;
    let mapped = [];
    for (let gap of gaps)
      if (!changes.touchesRange(gap.from, gap.to))
        mapped.push(new LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size, gap.displaySize));
    return mapped;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(current2, mayMeasure) {
    let wrapping = this.heightOracle.lineWrapping;
    let margin = wrapping ? 1e4 : 2e3, halfMargin = margin >> 1, doubleMargin = margin << 1;
    if (this.defaultTextDirection != Direction.LTR && !wrapping)
      return [];
    let gaps = [];
    let addGap = (from, to2, line2, structure) => {
      if (to2 - from < halfMargin)
        return;
      let sel = this.state.selection.main, avoid = [sel.from];
      if (!sel.empty)
        avoid.push(sel.to);
      for (let pos of avoid) {
        if (pos > from && pos < to2) {
          addGap(from, pos - 10, line2, structure);
          addGap(pos + 10, to2, line2, structure);
          return;
        }
      }
      let gap = find(current2, (gap2) => gap2.from >= line2.from && gap2.to <= line2.to && Math.abs(gap2.from - from) < halfMargin && Math.abs(gap2.to - to2) < halfMargin && !avoid.some((pos) => gap2.from < pos && gap2.to > pos));
      if (!gap) {
        if (to2 < line2.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r) => r.from <= to2 && r.to >= to2)) {
          let lineStart = mayMeasure.moveToLineBoundary(EditorSelection.cursor(to2), false, true).head;
          if (lineStart > from)
            to2 = lineStart;
        }
        let size2 = this.gapSize(line2, from, to2, structure);
        let displaySize = wrapping || size2 < 2e6 ? size2 : 2e6;
        gap = new LineGap(from, to2, size2, displaySize);
      }
      gaps.push(gap);
    };
    let checkLine = (line2) => {
      if (line2.length < doubleMargin || line2.type != BlockType.Text)
        return;
      let structure = lineStructure(line2.from, line2.to, this.stateDeco);
      if (structure.total < doubleMargin)
        return;
      let target = this.scrollTarget ? this.scrollTarget.range.head : null;
      let viewFrom, viewTo;
      if (wrapping) {
        let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
        let top2, bot;
        if (target != null) {
          let targetFrac = findFraction(structure, target);
          let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line2.height;
          top2 = targetFrac - spaceFrac;
          bot = targetFrac + spaceFrac;
        } else {
          top2 = (this.visibleTop - line2.top - marginHeight) / line2.height;
          bot = (this.visibleBottom - line2.top + marginHeight) / line2.height;
        }
        viewFrom = findPosition(structure, top2);
        viewTo = findPosition(structure, bot);
      } else {
        let totalWidth = structure.total * this.heightOracle.charWidth;
        let marginWidth = margin * this.heightOracle.charWidth;
        let horizOffset = 0;
        if (totalWidth > 2e6)
          for (let old of current2) {
            if (old.from >= line2.from && old.from < line2.to && old.size != old.displaySize && old.from * this.heightOracle.charWidth + horizOffset < this.pixelViewport.left)
              horizOffset = old.size - old.displaySize;
          }
        let pxLeft = this.pixelViewport.left + horizOffset, pxRight = this.pixelViewport.right + horizOffset;
        let left, right;
        if (target != null) {
          let targetFrac = findFraction(structure, target);
          let spaceFrac = ((pxRight - pxLeft) / 2 + marginWidth) / totalWidth;
          left = targetFrac - spaceFrac;
          right = targetFrac + spaceFrac;
        } else {
          left = (pxLeft - marginWidth) / totalWidth;
          right = (pxRight + marginWidth) / totalWidth;
        }
        viewFrom = findPosition(structure, left);
        viewTo = findPosition(structure, right);
      }
      if (viewFrom > line2.from)
        addGap(line2.from, viewFrom, line2, structure);
      if (viewTo < line2.to)
        addGap(viewTo, line2.to, line2, structure);
    };
    for (let line2 of this.viewportLines) {
      if (Array.isArray(line2.type))
        line2.type.forEach(checkLine);
      else
        checkLine(line2);
    }
    return gaps;
  }
  gapSize(line2, from, to2, structure) {
    let fraction = findFraction(structure, to2) - findFraction(structure, from);
    if (this.heightOracle.lineWrapping) {
      return line2.height * fraction;
    } else {
      return structure.total * this.heightOracle.charWidth * fraction;
    }
  }
  updateLineGaps(gaps) {
    if (!LineGap.same(gaps, this.lineGaps)) {
      this.lineGaps = gaps;
      this.lineGapDeco = Decoration.set(gaps.map((gap) => gap.draw(this, this.heightOracle.lineWrapping)));
    }
  }
  computeVisibleRanges(changes) {
    let deco = this.stateDeco;
    if (this.lineGaps.length)
      deco = deco.concat(this.lineGapDeco);
    let ranges = [];
    RangeSet.spans(deco, this.viewport.from, this.viewport.to, {
      span(from, to2) {
        ranges.push({ from, to: to2 });
      },
      point() {
      }
    }, 20);
    let changed = 0;
    if (ranges.length != this.visibleRanges.length) {
      changed = 8 | 4;
    } else {
      for (let i2 = 0; i2 < ranges.length && !(changed & 8); i2++) {
        let old = this.visibleRanges[i2], nw = ranges[i2];
        if (old.from != nw.from || old.to != nw.to) {
          changed |= 4;
          if (!(changes && changes.mapPos(old.from, -1) == nw.from && changes.mapPos(old.to, 1) == nw.to))
            changed |= 8;
        }
      }
    }
    this.visibleRanges = ranges;
    return changed;
  }
  lineBlockAt(pos) {
    return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b2) => b2.from <= pos && b2.to >= pos) || scaleBlock(this.heightMap.lineAt(pos, QueryType$1.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(height) {
    return height >= this.viewportLines[0].top && height <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((l) => l.top <= height && l.bottom >= height) || scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), QueryType$1.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(scrollTop) {
    let block = this.lineBlockAtHeight(scrollTop + 8);
    return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
  }
  elementAtHeight(height) {
    return scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class Viewport {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
}
function lineStructure(from, to2, stateDeco) {
  let ranges = [], pos = from, total = 0;
  RangeSet.spans(stateDeco, from, to2, {
    span() {
    },
    point(from2, to22) {
      if (from2 > pos) {
        ranges.push({ from: pos, to: from2 });
        total += from2 - pos;
      }
      pos = to22;
    }
  }, 20);
  if (pos < to2) {
    ranges.push({ from: pos, to: to2 });
    total += to2 - pos;
  }
  return { total, ranges };
}
function findPosition({ total, ranges }, ratio) {
  if (ratio <= 0)
    return ranges[0].from;
  if (ratio >= 1)
    return ranges[ranges.length - 1].to;
  let dist2 = Math.floor(total * ratio);
  for (let i2 = 0; ; i2++) {
    let { from, to: to2 } = ranges[i2], size2 = to2 - from;
    if (dist2 <= size2)
      return from + dist2;
    dist2 -= size2;
  }
}
function findFraction(structure, pos) {
  let counted = 0;
  for (let { from, to: to2 } of structure.ranges) {
    if (pos <= to2) {
      counted += pos - from;
      break;
    }
    counted += to2 - from;
  }
  return counted / structure.total;
}
function find(array, f2) {
  for (let val of array)
    if (f2(val))
      return val;
  return void 0;
}
const IdScaler = {
  toDOM(n) {
    return n;
  },
  fromDOM(n) {
    return n;
  },
  scale: 1,
  eq(other) {
    return other == this;
  }
};
class BigScaler {
  constructor(oracle, heightMap, viewports) {
    let vpHeight = 0, base2 = 0, domBase = 0;
    this.viewports = viewports.map(({ from, to: to2 }) => {
      let top2 = heightMap.lineAt(from, QueryType$1.ByPos, oracle, 0, 0).top;
      let bottom = heightMap.lineAt(to2, QueryType$1.ByPos, oracle, 0, 0).bottom;
      vpHeight += bottom - top2;
      return { from, to: to2, top: top2, bottom, domTop: 0, domBottom: 0 };
    });
    this.scale = (7e6 - vpHeight) / (heightMap.height - vpHeight);
    for (let obj of this.viewports) {
      obj.domTop = domBase + (obj.top - base2) * this.scale;
      domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
      base2 = obj.bottom;
    }
  }
  toDOM(n) {
    for (let i2 = 0, base2 = 0, domBase = 0; ; i2++) {
      let vp = i2 < this.viewports.length ? this.viewports[i2] : null;
      if (!vp || n < vp.top)
        return domBase + (n - base2) * this.scale;
      if (n <= vp.bottom)
        return vp.domTop + (n - vp.top);
      base2 = vp.bottom;
      domBase = vp.domBottom;
    }
  }
  fromDOM(n) {
    for (let i2 = 0, base2 = 0, domBase = 0; ; i2++) {
      let vp = i2 < this.viewports.length ? this.viewports[i2] : null;
      if (!vp || n < vp.domTop)
        return base2 + (n - domBase) / this.scale;
      if (n <= vp.domBottom)
        return vp.top + (n - vp.domTop);
      base2 = vp.bottom;
      domBase = vp.domBottom;
    }
  }
  eq(other) {
    if (!(other instanceof BigScaler))
      return false;
    return this.scale == other.scale && this.viewports.length == other.viewports.length && this.viewports.every((vp, i2) => vp.from == other.viewports[i2].from && vp.to == other.viewports[i2].to);
  }
}
function scaleBlock(block, scaler) {
  if (scaler.scale == 1)
    return block;
  let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
  return new BlockInfo(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b2) => scaleBlock(b2, scaler)) : block._content);
}
const theme = /* @__PURE__ */ Facet.define({ combine: (strs) => strs.join(" ") });
const darkTheme = /* @__PURE__ */ Facet.define({ combine: (values2) => values2.indexOf(true) > -1 });
const baseThemeID = /* @__PURE__ */ StyleModule.newName(), baseLightID = /* @__PURE__ */ StyleModule.newName(), baseDarkID = /* @__PURE__ */ StyleModule.newName();
const lightDarkIDs = { "&light": "." + baseLightID, "&dark": "." + baseDarkID };
function buildTheme(main2, spec, scopes) {
  return new StyleModule(spec, {
    finish(sel) {
      return /&/.test(sel) ? sel.replace(/&\w*/, (m) => {
        if (m == "&")
          return main2;
        if (!scopes || !scopes[m])
          throw new RangeError(`Unsupported selector: ${m}`);
        return scopes[m];
      }) : main2 + " " + sel;
    }
  });
}
const baseTheme$1$3 = /* @__PURE__ */ buildTheme("." + baseThemeID, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0,
    overflowAnchor: "none"
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#ddd"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    zIndex: 200
  },
  ".cm-gutters-before": { insetInlineStart: 0 },
  ".cm-gutters-after": { insetInlineEnd: 0 },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    border: "0px solid #ddd",
    "&.cm-gutters-before": { borderRightWidth: "1px" },
    "&.cm-gutters-after": { borderLeftWidth: "1px" }
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: 300
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-dialog": {
    padding: "2px 19px 4px 6px",
    position: "relative",
    "& label": { fontSize: "80%" }
  },
  ".cm-dialog-close": {
    position: "absolute",
    top: "3px",
    right: "4px",
    backgroundColor: "inherit",
    border: "none",
    font: "inherit",
    fontSize: "14px",
    padding: "0"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top",
    userSelect: "none"
  },
  ".cm-highlightSpace": {
    backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
    backgroundPosition: "center"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, lightDarkIDs);
const observeOptions = {
  childList: true,
  characterData: true,
  subtree: true,
  attributes: true,
  characterDataOldValue: true
};
const useCharData = browser$2.ie && browser$2.ie_version <= 11;
class DOMObserver {
  constructor(view) {
    this.view = view;
    this.active = false;
    this.editContext = null;
    this.selectionRange = new DOMSelectionState();
    this.selectionChanged = false;
    this.delayedFlush = -1;
    this.resizeTimeout = -1;
    this.queue = [];
    this.delayedAndroidKey = null;
    this.flushingAndroidKey = -1;
    this.lastChange = 0;
    this.scrollTargets = [];
    this.intersection = null;
    this.resizeScroll = null;
    this.intersecting = false;
    this.gapIntersection = null;
    this.gaps = [];
    this.printQuery = null;
    this.parentCheck = -1;
    this.dom = view.contentDOM;
    this.observer = new MutationObserver((mutations) => {
      for (let mut of mutations)
        this.queue.push(mut);
      if ((browser$2.ie && browser$2.ie_version <= 11 || browser$2.ios && view.composing) && mutations.some((m) => m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length))
        this.flushSoon();
      else
        this.flush();
    });
    if (window.EditContext && browser$2.android && view.constructor.EDIT_CONTEXT !== false && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(browser$2.chrome && browser$2.chrome_version < 126)) {
      this.editContext = new EditContextManager(view);
      if (view.state.facet(editable))
        view.contentDOM.editContext = this.editContext.editContext;
    }
    if (useCharData)
      this.onCharData = (event) => {
        this.queue.push({
          target: event.target,
          type: "characterData",
          oldValue: event.prevValue
        });
        this.flushSoon();
      };
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onPrint = this.onPrint.bind(this);
    this.onScroll = this.onScroll.bind(this);
    if (window.matchMedia)
      this.printQuery = window.matchMedia("print");
    if (typeof ResizeObserver == "function") {
      this.resizeScroll = new ResizeObserver(() => {
        var _a2;
        if (((_a2 = this.view.docView) === null || _a2 === void 0 ? void 0 : _a2.lastUpdate) < Date.now() - 75)
          this.onResize();
      });
      this.resizeScroll.observe(view.scrollDOM);
    }
    this.addWindowListeners(this.win = view.win);
    this.start();
    if (typeof IntersectionObserver == "function") {
      this.intersection = new IntersectionObserver((entries) => {
        if (this.parentCheck < 0)
          this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3);
        if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
          this.intersecting = !this.intersecting;
          if (this.intersecting != this.view.inView)
            this.onScrollChanged(document.createEvent("Event"));
        }
      }, { threshold: [0, 1e-3] });
      this.intersection.observe(this.dom);
      this.gapIntersection = new IntersectionObserver((entries) => {
        if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0)
          this.onScrollChanged(document.createEvent("Event"));
      }, {});
    }
    this.listenForScroll();
    this.readSelectionRange();
  }
  onScrollChanged(e2) {
    this.view.inputState.runHandlers("scroll", e2);
    if (this.intersecting)
      this.view.measure();
  }
  onScroll(e2) {
    if (this.intersecting)
      this.flush(false);
    if (this.editContext)
      this.view.requestMeasure(this.editContext.measureReq);
    this.onScrollChanged(e2);
  }
  onResize() {
    if (this.resizeTimeout < 0)
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = -1;
        this.view.requestMeasure();
      }, 50);
  }
  onPrint(event) {
    if ((event.type == "change" || !event.type) && !event.matches)
      return;
    this.view.viewState.printing = true;
    this.view.measure();
    setTimeout(() => {
      this.view.viewState.printing = false;
      this.view.requestMeasure();
    }, 500);
  }
  updateGaps(gaps) {
    if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i2) => g != gaps[i2]))) {
      this.gapIntersection.disconnect();
      for (let gap of gaps)
        this.gapIntersection.observe(gap);
      this.gaps = gaps;
    }
  }
  onSelectionChange(event) {
    let wasChanged = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view } = this, sel = this.selectionRange;
    if (view.state.facet(editable) ? view.root.activeElement != this.dom : !hasSelection(this.dom, sel))
      return;
    let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
    if (context && context.ignoreEvent(event)) {
      if (!wasChanged)
        this.selectionChanged = false;
      return;
    }
    if ((browser$2.ie && browser$2.ie_version <= 11 || browser$2.android && browser$2.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
      this.flushSoon();
    else
      this.flush(false);
  }
  readSelectionRange() {
    let { view } = this;
    let selection2 = getSelection(view.root);
    if (!selection2)
      return false;
    let range2 = browser$2.safari && view.root.nodeType == 11 && view.root.activeElement == this.dom && safariSelectionRangeHack(this.view, selection2) || selection2;
    if (!range2 || this.selectionRange.eq(range2))
      return false;
    let local = hasSelection(this.dom, range2);
    if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && atElementStart(this.dom, range2)) {
      this.view.inputState.lastFocusTime = 0;
      view.docView.updateSelection();
      return false;
    }
    this.selectionRange.setRange(range2);
    if (local)
      this.selectionChanged = true;
    return true;
  }
  setSelectionRange(anchor, head) {
    this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
    this.selectionChanged = false;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let i2 = 0, changed = null;
    for (let dom = this.dom; dom; ) {
      if (dom.nodeType == 1) {
        if (!changed && i2 < this.scrollTargets.length && this.scrollTargets[i2] == dom)
          i2++;
        else if (!changed)
          changed = this.scrollTargets.slice(0, i2);
        if (changed)
          changed.push(dom);
        dom = dom.assignedSlot || dom.parentNode;
      } else if (dom.nodeType == 11) {
        dom = dom.host;
      } else {
        break;
      }
    }
    if (i2 < this.scrollTargets.length && !changed)
      changed = this.scrollTargets.slice(0, i2);
    if (changed) {
      for (let dom of this.scrollTargets)
        dom.removeEventListener("scroll", this.onScroll);
      for (let dom of this.scrollTargets = changed)
        dom.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(f2) {
    if (!this.active)
      return f2();
    try {
      this.stop();
      return f2();
    } finally {
      this.start();
      this.clear();
    }
  }
  start() {
    if (this.active)
      return;
    this.observer.observe(this.dom, observeOptions);
    if (useCharData)
      this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
    this.active = true;
  }
  stop() {
    if (!this.active)
      return;
    this.active = false;
    this.observer.disconnect();
    if (useCharData)
      this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
  }
  // Throw away any pending changes
  clear() {
    this.processRecords();
    this.queue.length = 0;
    this.selectionChanged = false;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(key, keyCode) {
    var _a2;
    if (!this.delayedAndroidKey) {
      let flush = () => {
        let key2 = this.delayedAndroidKey;
        if (key2) {
          this.clearDelayedAndroidKey();
          this.view.inputState.lastKeyCode = key2.keyCode;
          this.view.inputState.lastKeyTime = Date.now();
          let flushed = this.flush();
          if (!flushed && key2.force)
            dispatchKey(this.dom, key2.key, key2.keyCode);
        }
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
    }
    if (!this.delayedAndroidKey || key == "Enter")
      this.delayedAndroidKey = {
        key,
        keyCode,
        // Only run the key handler when no changes are detected if
        // this isn't coming right after another change, in which case
        // it is probably part of a weird chain of updates, and should
        // be ignored if it returns the DOM to its previous state.
        force: this.lastChange < Date.now() - 50 || !!((_a2 = this.delayedAndroidKey) === null || _a2 === void 0 ? void 0 : _a2.force)
      };
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey);
    this.delayedAndroidKey = null;
    this.flushingAndroidKey = -1;
  }
  flushSoon() {
    if (this.delayedFlush < 0)
      this.delayedFlush = this.view.win.requestAnimationFrame(() => {
        this.delayedFlush = -1;
        this.flush();
      });
  }
  forceFlush() {
    if (this.delayedFlush >= 0) {
      this.view.win.cancelAnimationFrame(this.delayedFlush);
      this.delayedFlush = -1;
    }
    this.flush();
  }
  pendingRecords() {
    for (let mut of this.observer.takeRecords())
      this.queue.push(mut);
    return this.queue;
  }
  processRecords() {
    let records = this.pendingRecords();
    if (records.length)
      this.queue = [];
    let from = -1, to2 = -1, typeOver = false;
    for (let record of records) {
      let range2 = this.readMutation(record);
      if (!range2)
        continue;
      if (range2.typeOver)
        typeOver = true;
      if (from == -1) {
        ({ from, to: to2 } = range2);
      } else {
        from = Math.min(range2.from, from);
        to2 = Math.max(range2.to, to2);
      }
    }
    return { from, to: to2, typeOver };
  }
  readChange() {
    let { from, to: to2, typeOver } = this.processRecords();
    let newSel = this.selectionChanged && hasSelection(this.dom, this.selectionRange);
    if (from < 0 && !newSel)
      return null;
    if (from > -1)
      this.lastChange = Date.now();
    this.view.inputState.lastFocusTime = 0;
    this.selectionChanged = false;
    let change = new DOMChange(this.view, from, to2, typeOver);
    this.view.docView.domChanged = { newSel: change.newSel ? change.newSel.main : null };
    return change;
  }
  // Apply pending changes, if any
  flush(readSelection = true) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return false;
    if (readSelection)
      this.readSelectionRange();
    let domChange = this.readChange();
    if (!domChange) {
      this.view.requestMeasure();
      return false;
    }
    let startState = this.view.state;
    let handled = applyDOMChange(this.view, domChange);
    if (this.view.state == startState && (domChange.domChanged || domChange.newSel && !domChange.newSel.main.eq(this.view.state.selection.main)))
      this.view.update([]);
    return handled;
  }
  readMutation(rec) {
    let cView = this.view.docView.nearest(rec.target);
    if (!cView || cView.ignoreMutation(rec))
      return null;
    cView.markDirty(rec.type == "attributes");
    if (rec.type == "attributes")
      cView.flags |= 4;
    if (rec.type == "childList") {
      let childBefore = findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
      let childAfter = findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
      return {
        from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
        to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
        typeOver: false
      };
    } else if (rec.type == "characterData") {
      return { from: cView.posAtStart, to: cView.posAtEnd, typeOver: rec.target.nodeValue == rec.oldValue };
    } else {
      return null;
    }
  }
  setWindow(win) {
    if (win != this.win) {
      this.removeWindowListeners(this.win);
      this.win = win;
      this.addWindowListeners(this.win);
    }
  }
  addWindowListeners(win) {
    win.addEventListener("resize", this.onResize);
    if (this.printQuery) {
      if (this.printQuery.addEventListener)
        this.printQuery.addEventListener("change", this.onPrint);
      else
        this.printQuery.addListener(this.onPrint);
    } else
      win.addEventListener("beforeprint", this.onPrint);
    win.addEventListener("scroll", this.onScroll);
    win.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(win) {
    win.removeEventListener("scroll", this.onScroll);
    win.removeEventListener("resize", this.onResize);
    if (this.printQuery) {
      if (this.printQuery.removeEventListener)
        this.printQuery.removeEventListener("change", this.onPrint);
      else
        this.printQuery.removeListener(this.onPrint);
    } else
      win.removeEventListener("beforeprint", this.onPrint);
    win.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(update) {
    if (this.editContext) {
      this.editContext.update(update);
      if (update.startState.facet(editable) != update.state.facet(editable))
        update.view.contentDOM.editContext = update.state.facet(editable) ? this.editContext.editContext : null;
    }
  }
  destroy() {
    var _a2, _b, _c;
    this.stop();
    (_a2 = this.intersection) === null || _a2 === void 0 ? void 0 : _a2.disconnect();
    (_b = this.gapIntersection) === null || _b === void 0 ? void 0 : _b.disconnect();
    (_c = this.resizeScroll) === null || _c === void 0 ? void 0 : _c.disconnect();
    for (let dom of this.scrollTargets)
      dom.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win);
    clearTimeout(this.parentCheck);
    clearTimeout(this.resizeTimeout);
    this.win.cancelAnimationFrame(this.delayedFlush);
    this.win.cancelAnimationFrame(this.flushingAndroidKey);
    if (this.editContext) {
      this.view.contentDOM.editContext = null;
      this.editContext.destroy();
    }
  }
}
function findChild(cView, dom, dir) {
  while (dom) {
    let curView = ContentView.get(dom);
    if (curView && curView.parent == cView)
      return curView;
    let parent = dom.parentNode;
    dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
  }
  return null;
}
function buildSelectionRangeFromRange(view, range2) {
  let anchorNode = range2.startContainer, anchorOffset = range2.startOffset;
  let focusNode = range2.endContainer, focusOffset = range2.endOffset;
  let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
  if (isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset))
    [anchorNode, anchorOffset, focusNode, focusOffset] = [focusNode, focusOffset, anchorNode, anchorOffset];
  return { anchorNode, anchorOffset, focusNode, focusOffset };
}
function safariSelectionRangeHack(view, selection2) {
  if (selection2.getComposedRanges) {
    let range2 = selection2.getComposedRanges(view.root)[0];
    if (range2)
      return buildSelectionRangeFromRange(view, range2);
  }
  let found = null;
  function read(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    found = event.getTargetRanges()[0];
  }
  view.contentDOM.addEventListener("beforeinput", read, true);
  view.dom.ownerDocument.execCommand("indent");
  view.contentDOM.removeEventListener("beforeinput", read, true);
  return found ? buildSelectionRangeFromRange(view, found) : null;
}
class EditContextManager {
  constructor(view) {
    this.from = 0;
    this.to = 0;
    this.pendingContextChange = null;
    this.handlers = /* @__PURE__ */ Object.create(null);
    this.composing = null;
    this.resetRange(view.state);
    let context = this.editContext = new window.EditContext({
      text: view.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, view.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(view.state.selection.main.head)
    });
    this.handlers.textupdate = (e2) => {
      let main2 = view.state.selection.main, { anchor, head } = main2;
      let from = this.toEditorPos(e2.updateRangeStart), to2 = this.toEditorPos(e2.updateRangeEnd);
      if (view.inputState.composing >= 0 && !this.composing)
        this.composing = { contextBase: e2.updateRangeStart, editorBase: from, drifted: false };
      let deletes = to2 - from > e2.text.length;
      if (from == this.from && anchor < this.from)
        from = anchor;
      else if (to2 == this.to && anchor > this.to)
        to2 = anchor;
      let diff = findDiff(view.state.sliceDoc(from, to2), e2.text, (deletes ? main2.from : main2.to) - from, deletes ? "end" : null);
      if (!diff) {
        let newSel = EditorSelection.single(this.toEditorPos(e2.selectionStart), this.toEditorPos(e2.selectionEnd));
        if (!newSel.main.eq(main2))
          view.dispatch({ selection: newSel, userEvent: "select" });
        return;
      }
      let change = {
        from: diff.from + from,
        to: diff.toA + from,
        insert: Text$1.of(e2.text.slice(diff.from, diff.toB).split("\n"))
      };
      if ((browser$2.mac || browser$2.android) && change.from == head - 1 && /^\. ?$/.test(e2.text) && view.contentDOM.getAttribute("autocorrect") == "off")
        change = { from, to: to2, insert: Text$1.of([e2.text.replace(".", " ")]) };
      this.pendingContextChange = change;
      if (!view.state.readOnly) {
        let newLen = this.to - this.from + (change.to - change.from + change.insert.length);
        applyDOMChangeInner(view, change, EditorSelection.single(this.toEditorPos(e2.selectionStart, newLen), this.toEditorPos(e2.selectionEnd, newLen)));
      }
      if (this.pendingContextChange) {
        this.revertPending(view.state);
        this.setSelection(view.state);
      }
      if (change.from < change.to && !change.insert.length && view.inputState.composing >= 0 && !/[\\p{Alphabetic}\\p{Number}_]/.test(context.text.slice(Math.max(0, e2.updateRangeStart - 1), Math.min(context.text.length, e2.updateRangeStart + 1))))
        this.handlers.compositionend(e2);
    };
    this.handlers.characterboundsupdate = (e2) => {
      let rects = [], prev = null;
      for (let i2 = this.toEditorPos(e2.rangeStart), end = this.toEditorPos(e2.rangeEnd); i2 < end; i2++) {
        let rect = view.coordsForChar(i2);
        prev = rect && new DOMRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top) || prev || new DOMRect();
        rects.push(prev);
      }
      context.updateCharacterBounds(e2.rangeStart, rects);
    };
    this.handlers.textformatupdate = (e2) => {
      let deco = [];
      for (let format2 of e2.getTextFormats()) {
        let lineStyle = format2.underlineStyle, thickness = format2.underlineThickness;
        if (!/none/i.test(lineStyle) && !/none/i.test(thickness)) {
          let from = this.toEditorPos(format2.rangeStart), to2 = this.toEditorPos(format2.rangeEnd);
          if (from < to2) {
            let style = `text-decoration: underline ${/^[a-z]/.test(lineStyle) ? lineStyle + " " : lineStyle == "Dashed" ? "dashed " : lineStyle == "Squiggle" ? "wavy " : ""}${/thin/i.test(thickness) ? 1 : 2}px`;
            deco.push(Decoration.mark({ attributes: { style } }).range(from, to2));
          }
        }
      }
      view.dispatch({ effects: setEditContextFormatting.of(Decoration.set(deco)) });
    };
    this.handlers.compositionstart = () => {
      if (view.inputState.composing < 0) {
        view.inputState.composing = 0;
        view.inputState.compositionFirstChange = true;
      }
    };
    this.handlers.compositionend = () => {
      view.inputState.composing = -1;
      view.inputState.compositionFirstChange = null;
      if (this.composing) {
        let { drifted } = this.composing;
        this.composing = null;
        if (drifted)
          this.reset(view.state);
      }
    };
    for (let event in this.handlers)
      context.addEventListener(event, this.handlers[event]);
    this.measureReq = { read: (view2) => {
      this.editContext.updateControlBounds(view2.contentDOM.getBoundingClientRect());
      let sel = getSelection(view2.root);
      if (sel && sel.rangeCount)
        this.editContext.updateSelectionBounds(sel.getRangeAt(0).getBoundingClientRect());
    } };
  }
  applyEdits(update) {
    let off2 = 0, abort = false, pending = this.pendingContextChange;
    update.changes.iterChanges((fromA, toA, _fromB, _toB, insert2) => {
      if (abort)
        return;
      let dLen = insert2.length - (toA - fromA);
      if (pending && toA >= pending.to) {
        if (pending.from == fromA && pending.to == toA && pending.insert.eq(insert2)) {
          pending = this.pendingContextChange = null;
          off2 += dLen;
          this.to += dLen;
          return;
        } else {
          pending = null;
          this.revertPending(update.state);
        }
      }
      fromA += off2;
      toA += off2;
      if (toA <= this.from) {
        this.from += dLen;
        this.to += dLen;
      } else if (fromA < this.to) {
        if (fromA < this.from || toA > this.to || this.to - this.from + insert2.length > 3e4) {
          abort = true;
          return;
        }
        this.editContext.updateText(this.toContextPos(fromA), this.toContextPos(toA), insert2.toString());
        this.to += dLen;
      }
      off2 += dLen;
    });
    if (pending && !abort)
      this.revertPending(update.state);
    return !abort;
  }
  update(update) {
    let reverted = this.pendingContextChange, startSel = update.startState.selection.main;
    if (this.composing && (this.composing.drifted || !update.changes.touchesRange(startSel.from, startSel.to) && update.transactions.some((tr2) => !tr2.isUserEvent("input.type") && tr2.changes.touchesRange(this.from, this.to)))) {
      this.composing.drifted = true;
      this.composing.editorBase = update.changes.mapPos(this.composing.editorBase);
    } else if (!this.applyEdits(update) || !this.rangeIsValid(update.state)) {
      this.pendingContextChange = null;
      this.reset(update.state);
    } else if (update.docChanged || update.selectionSet || reverted) {
      this.setSelection(update.state);
    }
    if (update.geometryChanged || update.docChanged || update.selectionSet)
      update.view.requestMeasure(this.measureReq);
  }
  resetRange(state) {
    let { head } = state.selection.main;
    this.from = Math.max(
      0,
      head - 1e4
      /* CxVp.Margin */
    );
    this.to = Math.min(
      state.doc.length,
      head + 1e4
      /* CxVp.Margin */
    );
  }
  reset(state) {
    this.resetRange(state);
    this.editContext.updateText(0, this.editContext.text.length, state.doc.sliceString(this.from, this.to));
    this.setSelection(state);
  }
  revertPending(state) {
    let pending = this.pendingContextChange;
    this.pendingContextChange = null;
    this.editContext.updateText(this.toContextPos(pending.from), this.toContextPos(pending.from + pending.insert.length), state.doc.sliceString(pending.from, pending.to));
  }
  setSelection(state) {
    let { main: main2 } = state.selection;
    let start = this.toContextPos(Math.max(this.from, Math.min(this.to, main2.anchor)));
    let end = this.toContextPos(main2.head);
    if (this.editContext.selectionStart != start || this.editContext.selectionEnd != end)
      this.editContext.updateSelection(start, end);
  }
  rangeIsValid(state) {
    let { head } = state.selection.main;
    return !(this.from > 0 && head - this.from < 500 || this.to < state.doc.length && this.to - head < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(contextPos, clipLen = this.to - this.from) {
    contextPos = Math.min(contextPos, clipLen);
    let c2 = this.composing;
    return c2 && c2.drifted ? c2.editorBase + (contextPos - c2.contextBase) : contextPos + this.from;
  }
  toContextPos(editorPos) {
    let c2 = this.composing;
    return c2 && c2.drifted ? c2.contextBase + (editorPos - c2.editorBase) : editorPos - this.from;
  }
  destroy() {
    for (let event in this.handlers)
      this.editContext.removeEventListener(event, this.handlers[event]);
  }
}
class EditorView {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return !!this.inputState && this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return !!this.inputState && this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(config2 = {}) {
    var _a2;
    this.plugins = [];
    this.pluginMap = /* @__PURE__ */ new Map();
    this.editorAttrs = {};
    this.contentAttrs = {};
    this.bidiCache = [];
    this.destroyed = false;
    this.updateState = 2;
    this.measureScheduled = -1;
    this.measureRequests = [];
    this.contentDOM = document.createElement("div");
    this.scrollDOM = document.createElement("div");
    this.scrollDOM.tabIndex = -1;
    this.scrollDOM.className = "cm-scroller";
    this.scrollDOM.appendChild(this.contentDOM);
    this.announceDOM = document.createElement("div");
    this.announceDOM.className = "cm-announced";
    this.announceDOM.setAttribute("aria-live", "polite");
    this.dom = document.createElement("div");
    this.dom.appendChild(this.announceDOM);
    this.dom.appendChild(this.scrollDOM);
    if (config2.parent)
      config2.parent.appendChild(this.dom);
    let { dispatch } = config2;
    this.dispatchTransactions = config2.dispatchTransactions || dispatch && ((trs) => trs.forEach((tr2) => dispatch(tr2, this))) || ((trs) => this.update(trs));
    this.dispatch = this.dispatch.bind(this);
    this._root = config2.root || getRoot(config2.parent) || document;
    this.viewState = new ViewState(config2.state || EditorState.create(config2));
    if (config2.scrollTo && config2.scrollTo.is(scrollIntoView$1))
      this.viewState.scrollTarget = config2.scrollTo.value.clip(this.viewState.state);
    this.plugins = this.state.facet(viewPlugin).map((spec) => new PluginInstance(spec));
    for (let plugin of this.plugins)
      plugin.update(this);
    this.observer = new DOMObserver(this);
    this.inputState = new InputState(this);
    this.inputState.ensureHandlers(this.plugins);
    this.docView = new DocView(this);
    this.mountStyles();
    this.updateAttrs();
    this.updateState = 0;
    this.requestMeasure();
    if ((_a2 = document.fonts) === null || _a2 === void 0 ? void 0 : _a2.ready)
      document.fonts.ready.then(() => this.requestMeasure());
  }
  dispatch(...input) {
    let trs = input.length == 1 && input[0] instanceof Transaction ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [this.state.update(...input)];
    this.dispatchTransactions(trs, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(transactions) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let redrawn = false, attrsChanged = false, update;
    let state = this.state;
    for (let tr2 of transactions) {
      if (tr2.startState != state)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      state = tr2.state;
    }
    if (this.destroyed) {
      this.viewState.state = state;
      return;
    }
    let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
    if (transactions.some((tr2) => tr2.annotation(isFocusChange))) {
      this.inputState.notifiedFocused = focus;
      focusFlag = 1;
    } else if (focus != this.inputState.notifiedFocused) {
      this.inputState.notifiedFocused = focus;
      dispatchFocus = focusChangeTransaction(state, focus);
      if (!dispatchFocus)
        focusFlag = 1;
    }
    let pendingKey = this.observer.delayedAndroidKey, domChange = null;
    if (pendingKey) {
      this.observer.clearDelayedAndroidKey();
      domChange = this.observer.readChange();
      if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection))
        domChange = null;
    } else {
      this.observer.clear();
    }
    if (state.facet(EditorState.phrases) != this.state.facet(EditorState.phrases))
      return this.setState(state);
    update = ViewUpdate.create(this, state, transactions);
    update.flags |= focusFlag;
    let scrollTarget = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let tr2 of transactions) {
        if (scrollTarget)
          scrollTarget = scrollTarget.map(tr2.changes);
        if (tr2.scrollIntoView) {
          let { main: main2 } = tr2.state.selection;
          scrollTarget = new ScrollTarget(main2.empty ? main2 : EditorSelection.cursor(main2.head, main2.head > main2.anchor ? -1 : 1));
        }
        for (let e2 of tr2.effects)
          if (e2.is(scrollIntoView$1))
            scrollTarget = e2.value.clip(this.state);
      }
      this.viewState.update(update, scrollTarget);
      this.bidiCache = CachedOrder.update(this.bidiCache, update.changes);
      if (!update.empty) {
        this.updatePlugins(update);
        this.inputState.update(update);
      }
      redrawn = this.docView.update(update);
      if (this.state.facet(styleModule) != this.styleModules)
        this.mountStyles();
      attrsChanged = this.updateAttrs();
      this.showAnnouncements(transactions);
      this.docView.updateSelection(redrawn, transactions.some((tr2) => tr2.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (update.startState.facet(theme) != update.state.facet(theme))
      this.viewState.mustMeasureContent = true;
    if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent)
      this.requestMeasure();
    if (redrawn)
      this.docViewUpdate();
    if (!update.empty)
      for (let listener of this.state.facet(updateListener)) {
        try {
          listener(update);
        } catch (e2) {
          logException(this.state, e2, "update listener");
        }
      }
    if (dispatchFocus || domChange)
      Promise.resolve().then(() => {
        if (dispatchFocus && this.state == dispatchFocus.startState)
          this.dispatch(dispatchFocus);
        if (domChange) {
          if (!applyDOMChange(this, domChange) && pendingKey.force)
            dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
        }
      });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(newState) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = newState;
      return;
    }
    this.updateState = 2;
    let hadFocus = this.hasFocus;
    try {
      for (let plugin of this.plugins)
        plugin.destroy(this);
      this.viewState = new ViewState(newState);
      this.plugins = newState.facet(viewPlugin).map((spec) => new PluginInstance(spec));
      this.pluginMap.clear();
      for (let plugin of this.plugins)
        plugin.update(this);
      this.docView.destroy();
      this.docView = new DocView(this);
      this.inputState.ensureHandlers(this.plugins);
      this.mountStyles();
      this.updateAttrs();
      this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    if (hadFocus)
      this.focus();
    this.requestMeasure();
  }
  updatePlugins(update) {
    let prevSpecs = update.startState.facet(viewPlugin), specs = update.state.facet(viewPlugin);
    if (prevSpecs != specs) {
      let newPlugins = [];
      for (let spec of specs) {
        let found = prevSpecs.indexOf(spec);
        if (found < 0) {
          newPlugins.push(new PluginInstance(spec));
        } else {
          let plugin = this.plugins[found];
          plugin.mustUpdate = update;
          newPlugins.push(plugin);
        }
      }
      for (let plugin of this.plugins)
        if (plugin.mustUpdate != update)
          plugin.destroy(this);
      this.plugins = newPlugins;
      this.pluginMap.clear();
    } else {
      for (let p of this.plugins)
        p.mustUpdate = update;
    }
    for (let i2 = 0; i2 < this.plugins.length; i2++)
      this.plugins[i2].update(this);
    if (prevSpecs != specs)
      this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let plugin of this.plugins) {
      let val = plugin.value;
      if (val && val.docViewUpdate) {
        try {
          val.docViewUpdate(this);
        } catch (e2) {
          logException(this.state, e2, "doc view update listener");
        }
      }
    }
  }
  /**
  @internal
  */
  measure(flush = true) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1)
      this.win.cancelAnimationFrame(this.measureScheduled);
    if (this.observer.delayedAndroidKey) {
      this.measureScheduled = -1;
      this.requestMeasure();
      return;
    }
    this.measureScheduled = 0;
    if (flush)
      this.observer.forceFlush();
    let updated = null;
    let sDOM = this.scrollDOM, scrollTop = sDOM.scrollTop * this.scaleY;
    let { scrollAnchorPos, scrollAnchorHeight } = this.viewState;
    if (Math.abs(scrollTop - this.viewState.scrollTop) > 1)
      scrollAnchorHeight = -1;
    this.viewState.scrollAnchorHeight = -1;
    try {
      for (let i2 = 0; ; i2++) {
        if (scrollAnchorHeight < 0) {
          if (isScrolledToBottom(sDOM)) {
            scrollAnchorPos = -1;
            scrollAnchorHeight = this.viewState.heightMap.height;
          } else {
            let block = this.viewState.scrollAnchorAt(scrollTop);
            scrollAnchorPos = block.from;
            scrollAnchorHeight = block.top;
          }
        }
        this.updateState = 1;
        let changed = this.viewState.measure(this);
        if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (i2 > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let measuring = [];
        if (!(changed & 4))
          [this.measureRequests, measuring] = [measuring, this.measureRequests];
        let measured = measuring.map((m) => {
          try {
            return m.read(this);
          } catch (e2) {
            logException(this.state, e2);
            return BadMeasure;
          }
        });
        let update = ViewUpdate.create(this, this.state, []), redrawn = false;
        update.flags |= changed;
        if (!updated)
          updated = update;
        else
          updated.flags |= changed;
        this.updateState = 2;
        if (!update.empty) {
          this.updatePlugins(update);
          this.inputState.update(update);
          this.updateAttrs();
          redrawn = this.docView.update(update);
          if (redrawn)
            this.docViewUpdate();
        }
        for (let i22 = 0; i22 < measuring.length; i22++)
          if (measured[i22] != BadMeasure) {
            try {
              let m = measuring[i22];
              if (m.write)
                m.write(measured[i22], this);
            } catch (e2) {
              logException(this.state, e2);
            }
          }
        if (redrawn)
          this.docView.updateSelection(true);
        if (!update.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight) {
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget);
              this.viewState.scrollTarget = null;
              scrollAnchorHeight = -1;
              continue;
            } else {
              let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
              let diff = newAnchorHeight - scrollAnchorHeight;
              if (diff > 1 || diff < -1) {
                scrollTop = scrollTop + diff;
                sDOM.scrollTop = scrollTop / this.scaleY;
                scrollAnchorHeight = -1;
                continue;
              }
            }
          }
          break;
        }
      }
    } finally {
      this.updateState = 0;
      this.measureScheduled = -1;
    }
    if (updated && !updated.empty)
      for (let listener of this.state.facet(updateListener))
        listener(updated);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return baseThemeID + " " + (this.state.facet(darkTheme) ? baseDarkID : baseLightID) + " " + this.state.facet(theme);
  }
  updateAttrs() {
    let editorAttrs = attrsFromFacet(this, editorAttributes, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    });
    let contentAttrs = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      writingsuggestions: "false",
      translate: "no",
      contenteditable: !this.state.facet(editable) ? "false" : "true",
      class: "cm-content",
      style: `${browser$2.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    if (this.state.readOnly)
      contentAttrs["aria-readonly"] = "true";
    attrsFromFacet(this, contentAttributes, contentAttrs);
    let changed = this.observer.ignore(() => {
      let changedContent = updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
      let changedEditor = updateAttrs(this.dom, this.editorAttrs, editorAttrs);
      return changedContent || changedEditor;
    });
    this.editorAttrs = editorAttrs;
    this.contentAttrs = contentAttrs;
    return changed;
  }
  showAnnouncements(trs) {
    let first2 = true;
    for (let tr2 of trs)
      for (let effect of tr2.effects)
        if (effect.is(EditorView.announce)) {
          if (first2)
            this.announceDOM.textContent = "";
          first2 = false;
          let div2 = this.announceDOM.appendChild(document.createElement("div"));
          div2.textContent = effect.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(styleModule);
    let nonce = this.state.facet(EditorView.cspNonce);
    StyleModule.mount(this.root, this.styleModules.concat(baseTheme$1$3).reverse(), nonce ? { nonce } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    if (this.updateState == 0 && this.measureScheduled > -1)
      this.measure(false);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(request) {
    if (this.measureScheduled < 0)
      this.measureScheduled = this.win.requestAnimationFrame(() => this.measure());
    if (request) {
      if (this.measureRequests.indexOf(request) > -1)
        return;
      if (request.key != null)
        for (let i2 = 0; i2 < this.measureRequests.length; i2++) {
          if (this.measureRequests[i2].key === request.key) {
            this.measureRequests[i2] = request;
            return;
          }
        }
      this.measureRequests.push(request);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(plugin) {
    let known = this.pluginMap.get(plugin);
    if (known === void 0 || known && known.plugin != plugin)
      this.pluginMap.set(plugin, known = this.plugins.find((p) => p.plugin == plugin) || null);
    return known && known.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(height) {
    this.readMeasured();
    return this.viewState.elementAtHeight(height);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt)) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(height) {
    this.readMeasured();
    return this.viewState.lineBlockAtHeight(height);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(pos) {
    return this.viewState.lineBlockAt(pos);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(start, forward, by) {
    return skipAtoms(this, start, moveByChar(this, start, forward, by));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(start, forward) {
    return skipAtoms(this, start, moveByChar(this, start, forward, (initial2) => byGroup(this, start.head, initial2)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(line2, end) {
    let order2 = this.bidiSpans(line2), dir = this.textDirectionAt(line2.from);
    let span = order2[end ? order2.length - 1 : 0];
    return EditorSelection.cursor(span.side(end, dir) + line2.from, span.forward(!end, dir) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(start, forward, includeWrap = true) {
    return moveToLineBoundary(this, start, forward, includeWrap);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(start, forward, distance) {
    return skipAtoms(this, start, moveVertically(this, start, forward, distance));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(pos) {
    return this.docView.domAtPos(pos);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(node, offset2 = 0) {
    return this.docView.posFromDOM(node, offset2);
  }
  posAtCoords(coords, precise = true) {
    this.readMeasured();
    return posAtCoords(this, coords, precise);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(pos, side = 1) {
    this.readMeasured();
    let rect = this.docView.coordsAt(pos, side);
    if (!rect || rect.left == rect.right)
      return rect;
    let line2 = this.state.doc.lineAt(pos), order2 = this.bidiSpans(line2);
    let span = order2[BidiSpan.find(order2, pos - line2.from, -1, side)];
    return flattenRect(rect, span.dir == Direction.LTR == side > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(pos) {
    this.readMeasured();
    return this.docView.coordsForChar(pos);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(pos) {
    let perLine = this.state.facet(perLineTextDirection);
    if (!perLine || pos < this.viewport.from || pos > this.viewport.to)
      return this.textDirection;
    this.readMeasured();
    return this.docView.textDirectionAt(pos);
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(line2) {
    if (line2.length > MaxBidiLine)
      return trivialOrder(line2.length);
    let dir = this.textDirectionAt(line2.from), isolates;
    for (let entry of this.bidiCache) {
      if (entry.from == line2.from && entry.dir == dir && (entry.fresh || isolatesEq(entry.isolates, isolates = getIsolatedRanges(this, line2))))
        return entry.order;
    }
    if (!isolates)
      isolates = getIsolatedRanges(this, line2);
    let order2 = computeOrder(line2.text, dir, isolates);
    this.bidiCache.push(new CachedOrder(line2.from, line2.to, dir, isolates, true, order2));
    return order2;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var _a2;
    return (this.dom.ownerDocument.hasFocus() || browser$2.safari && ((_a2 = this.inputState) === null || _a2 === void 0 ? void 0 : _a2.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      focusPreventScroll(this.contentDOM);
      this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(root2) {
    if (this._root != root2) {
      this._root = root2;
      this.observer.setWindow((root2.nodeType == 9 ? root2 : root2.ownerDocument).defaultView || window);
      this.mountStyles();
    }
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    if (this.root.activeElement == this.contentDOM)
      this.contentDOM.blur();
    for (let plugin of this.plugins)
      plugin.destroy(this);
    this.plugins = [];
    this.inputState.destroy();
    this.docView.destroy();
    this.dom.remove();
    this.observer.destroy();
    if (this.measureScheduled > -1)
      this.win.cancelAnimationFrame(this.measureScheduled);
    this.destroyed = true;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(pos, options2 = {}) {
    return scrollIntoView$1.of(new ScrollTarget(typeof pos == "number" ? EditorSelection.cursor(pos) : pos, options2.y, options2.x, options2.yMargin, options2.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop, scrollLeft } = this.scrollDOM;
    let ref = this.viewState.scrollAnchorAt(scrollTop);
    return scrollIntoView$1.of(new ScrollTarget(EditorSelection.cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(to2) {
    if (to2 == null)
      this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1;
    else if (typeof to2 == "boolean")
      this.inputState.tabFocusMode = to2 ? 0 : -1;
    else if (this.inputState.tabFocusMode != 0)
      this.inputState.tabFocusMode = Date.now() + to2;
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(handlers2) {
    return ViewPlugin.define(() => ({}), { eventHandlers: handlers2 });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(observers2) {
    return ViewPlugin.define(() => ({}), { eventObservers: observers2 });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(spec, options2) {
    let prefix = StyleModule.newName();
    let result2 = [theme.of(prefix), styleModule.of(buildTheme(`.${prefix}`, spec))];
    if (options2 && options2.dark)
      result2.push(darkTheme.of(true));
    return result2;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(spec) {
    return Prec.lowest(styleModule.of(buildTheme("." + baseThemeID, spec, lightDarkIDs)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(dom) {
    var _a2;
    let content2 = dom.querySelector(".cm-content");
    let cView = content2 && ContentView.get(content2) || ContentView.get(dom);
    return ((_a2 = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a2 === void 0 ? void 0 : _a2.view) || null;
  }
}
EditorView.styleModule = styleModule;
EditorView.inputHandler = inputHandler$1;
EditorView.clipboardInputFilter = clipboardInputFilter;
EditorView.clipboardOutputFilter = clipboardOutputFilter;
EditorView.scrollHandler = scrollHandler;
EditorView.focusChangeEffect = focusChangeEffect;
EditorView.perLineTextDirection = perLineTextDirection;
EditorView.exceptionSink = exceptionSink;
EditorView.updateListener = updateListener;
EditorView.editable = editable;
EditorView.mouseSelectionStyle = mouseSelectionStyle;
EditorView.dragMovesSelection = dragMovesSelection$1;
EditorView.clickAddsSelectionRange = clickAddsSelectionRange;
EditorView.decorations = decorations;
EditorView.outerDecorations = outerDecorations;
EditorView.atomicRanges = atomicRanges;
EditorView.bidiIsolatedRanges = bidiIsolatedRanges;
EditorView.scrollMargins = scrollMargins;
EditorView.darkTheme = darkTheme;
EditorView.cspNonce = /* @__PURE__ */ Facet.define({ combine: (values2) => values2.length ? values2[0] : "" });
EditorView.contentAttributes = contentAttributes;
EditorView.editorAttributes = editorAttributes;
EditorView.lineWrapping = /* @__PURE__ */ EditorView.contentAttributes.of({ "class": "cm-lineWrapping" });
EditorView.announce = /* @__PURE__ */ StateEffect.define();
const MaxBidiLine = 4096;
const BadMeasure = {};
class CachedOrder {
  constructor(from, to2, dir, isolates, fresh, order2) {
    this.from = from;
    this.to = to2;
    this.dir = dir;
    this.isolates = isolates;
    this.fresh = fresh;
    this.order = order2;
  }
  static update(cache, changes) {
    if (changes.empty && !cache.some((c2) => c2.fresh))
      return cache;
    let result2 = [], lastDir = cache.length ? cache[cache.length - 1].dir : Direction.LTR;
    for (let i2 = Math.max(0, cache.length - 10); i2 < cache.length; i2++) {
      let entry = cache[i2];
      if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to))
        result2.push(new CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
    }
    return result2;
  }
}
function attrsFromFacet(view, facet, base2) {
  for (let sources = view.state.facet(facet), i2 = sources.length - 1; i2 >= 0; i2--) {
    let source = sources[i2], value = typeof source == "function" ? source(view) : source;
    if (value)
      combineAttrs(value, base2);
  }
  return base2;
}
const currentPlatform = browser$2.mac ? "mac" : browser$2.windows ? "win" : browser$2.linux ? "linux" : "key";
function normalizeKeyName(name2, platform2) {
  const parts = name2.split(/-(?!$)/);
  let result2 = parts[parts.length - 1];
  if (result2 == "Space")
    result2 = " ";
  let alt, ctrl, shift2, meta2;
  for (let i2 = 0; i2 < parts.length - 1; ++i2) {
    const mod2 = parts[i2];
    if (/^(cmd|meta|m)$/i.test(mod2))
      meta2 = true;
    else if (/^a(lt)?$/i.test(mod2))
      alt = true;
    else if (/^(c|ctrl|control)$/i.test(mod2))
      ctrl = true;
    else if (/^s(hift)?$/i.test(mod2))
      shift2 = true;
    else if (/^mod$/i.test(mod2)) {
      if (platform2 == "mac")
        meta2 = true;
      else
        ctrl = true;
    } else
      throw new Error("Unrecognized modifier name: " + mod2);
  }
  if (alt)
    result2 = "Alt-" + result2;
  if (ctrl)
    result2 = "Ctrl-" + result2;
  if (meta2)
    result2 = "Meta-" + result2;
  if (shift2)
    result2 = "Shift-" + result2;
  return result2;
}
function modifiers(name2, event, shift2) {
  if (event.altKey)
    name2 = "Alt-" + name2;
  if (event.ctrlKey)
    name2 = "Ctrl-" + name2;
  if (event.metaKey)
    name2 = "Meta-" + name2;
  if (shift2 !== false && event.shiftKey)
    name2 = "Shift-" + name2;
  return name2;
}
const handleKeyEvents = /* @__PURE__ */ Prec.default(/* @__PURE__ */ EditorView.domEventHandlers({
  keydown(event, view) {
    return runHandlers(getKeymap(view.state), event, view, "editor");
  }
}));
const keymap = /* @__PURE__ */ Facet.define({ enables: handleKeyEvents });
const Keymaps = /* @__PURE__ */ new WeakMap();
function getKeymap(state) {
  let bindings = state.facet(keymap);
  let map2 = Keymaps.get(bindings);
  if (!map2)
    Keymaps.set(bindings, map2 = buildKeymap(bindings.reduce((a, b2) => a.concat(b2), [])));
  return map2;
}
function runScopeHandlers(view, event, scope) {
  return runHandlers(getKeymap(view.state), event, view, scope);
}
let storedPrefix = null;
const PrefixTimeout = 4e3;
function buildKeymap(bindings, platform2 = currentPlatform) {
  let bound = /* @__PURE__ */ Object.create(null);
  let isPrefix = /* @__PURE__ */ Object.create(null);
  let checkPrefix = (name2, is2) => {
    let current2 = isPrefix[name2];
    if (current2 == null)
      isPrefix[name2] = is2;
    else if (current2 != is2)
      throw new Error("Key binding " + name2 + " is used both as a regular binding and as a multi-stroke prefix");
  };
  let add2 = (scope, key, command2, preventDefault, stopPropagation) => {
    var _a2, _b;
    let scopeObj = bound[scope] || (bound[scope] = /* @__PURE__ */ Object.create(null));
    let parts = key.split(/ (?!$)/).map((k2) => normalizeKeyName(k2, platform2));
    for (let i2 = 1; i2 < parts.length; i2++) {
      let prefix = parts.slice(0, i2).join(" ");
      checkPrefix(prefix, true);
      if (!scopeObj[prefix])
        scopeObj[prefix] = {
          preventDefault: true,
          stopPropagation: false,
          run: [(view) => {
            let ourObj = storedPrefix = { view, prefix, scope };
            setTimeout(() => {
              if (storedPrefix == ourObj)
                storedPrefix = null;
            }, PrefixTimeout);
            return true;
          }]
        };
    }
    let full = parts.join(" ");
    checkPrefix(full, false);
    let binding2 = scopeObj[full] || (scopeObj[full] = {
      preventDefault: false,
      stopPropagation: false,
      run: ((_b = (_a2 = scopeObj._any) === null || _a2 === void 0 ? void 0 : _a2.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
    });
    if (command2)
      binding2.run.push(command2);
    if (preventDefault)
      binding2.preventDefault = true;
    if (stopPropagation)
      binding2.stopPropagation = true;
  };
  for (let b2 of bindings) {
    let scopes = b2.scope ? b2.scope.split(" ") : ["editor"];
    if (b2.any)
      for (let scope of scopes) {
        let scopeObj = bound[scope] || (bound[scope] = /* @__PURE__ */ Object.create(null));
        if (!scopeObj._any)
          scopeObj._any = { preventDefault: false, stopPropagation: false, run: [] };
        let { any } = b2;
        for (let key in scopeObj)
          scopeObj[key].run.push((view) => any(view, currentKeyEvent));
      }
    let name2 = b2[platform2] || b2.key;
    if (!name2)
      continue;
    for (let scope of scopes) {
      add2(scope, name2, b2.run, b2.preventDefault, b2.stopPropagation);
      if (b2.shift)
        add2(scope, "Shift-" + name2, b2.shift, b2.preventDefault, b2.stopPropagation);
    }
  }
  return bound;
}
let currentKeyEvent = null;
function runHandlers(map2, event, view, scope) {
  currentKeyEvent = event;
  let name2 = keyName(event);
  let charCode = codePointAt(name2, 0), isChar = codePointSize(charCode) == name2.length && name2 != " ";
  let prefix = "", handled = false, prevented = false, stopPropagation = false;
  if (storedPrefix && storedPrefix.view == view && storedPrefix.scope == scope) {
    prefix = storedPrefix.prefix + " ";
    if (modifierCodes.indexOf(event.keyCode) < 0) {
      prevented = true;
      storedPrefix = null;
    }
  }
  let ran = /* @__PURE__ */ new Set();
  let runFor = (binding2) => {
    if (binding2) {
      for (let cmd2 of binding2.run)
        if (!ran.has(cmd2)) {
          ran.add(cmd2);
          if (cmd2(view)) {
            if (binding2.stopPropagation)
              stopPropagation = true;
            return true;
          }
        }
      if (binding2.preventDefault) {
        if (binding2.stopPropagation)
          stopPropagation = true;
        prevented = true;
      }
    }
    return false;
  };
  let scopeObj = map2[scope], baseName, shiftName;
  if (scopeObj) {
    if (runFor(scopeObj[prefix + modifiers(name2, event, !isChar)])) {
      handled = true;
    } else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
    !(browser$2.windows && event.ctrlKey && event.altKey) && // Alt-combinations on macOS tend to be typed characters
    !(browser$2.mac && event.altKey && !(event.ctrlKey || event.metaKey)) && (baseName = base[event.keyCode]) && baseName != name2) {
      if (runFor(scopeObj[prefix + modifiers(baseName, event, true)])) {
        handled = true;
      } else if (event.shiftKey && (shiftName = shift[event.keyCode]) != name2 && shiftName != baseName && runFor(scopeObj[prefix + modifiers(shiftName, event, false)])) {
        handled = true;
      }
    } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + modifiers(name2, event, true)])) {
      handled = true;
    }
    if (!handled && runFor(scopeObj._any))
      handled = true;
  }
  if (prevented)
    handled = true;
  if (handled && stopPropagation)
    event.stopPropagation();
  currentKeyEvent = null;
  return handled;
}
class RectangleMarker {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(className, left, top2, width, height) {
    this.className = className;
    this.left = left;
    this.top = top2;
    this.width = width;
    this.height = height;
  }
  draw() {
    let elt = document.createElement("div");
    elt.className = this.className;
    this.adjust(elt);
    return elt;
  }
  update(elt, prev) {
    if (prev.className != this.className)
      return false;
    this.adjust(elt);
    return true;
  }
  adjust(elt) {
    elt.style.left = this.left + "px";
    elt.style.top = this.top + "px";
    if (this.width != null)
      elt.style.width = this.width + "px";
    elt.style.height = this.height + "px";
  }
  eq(p) {
    return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(view, className, range2) {
    if (range2.empty) {
      let pos = view.coordsAtPos(range2.head, range2.assoc || 1);
      if (!pos)
        return [];
      let base2 = getBase(view);
      return [new RectangleMarker(className, pos.left - base2.left, pos.top - base2.top, null, pos.bottom - pos.top)];
    } else {
      return rectanglesForRange(view, className, range2);
    }
  }
}
function getBase(view) {
  let rect = view.scrollDOM.getBoundingClientRect();
  let left = view.textDirection == Direction.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
  return { left: left - view.scrollDOM.scrollLeft * view.scaleX, top: rect.top - view.scrollDOM.scrollTop * view.scaleY };
}
function wrappedLine(view, pos, side, inside2) {
  let coords = view.coordsAtPos(pos, side * 2);
  if (!coords)
    return inside2;
  let editorRect = view.dom.getBoundingClientRect();
  let y = (coords.top + coords.bottom) / 2;
  let left = view.posAtCoords({ x: editorRect.left + 1, y });
  let right = view.posAtCoords({ x: editorRect.right - 1, y });
  if (left == null || right == null)
    return inside2;
  return { from: Math.max(inside2.from, Math.min(left, right)), to: Math.min(inside2.to, Math.max(left, right)) };
}
function rectanglesForRange(view, className, range2) {
  if (range2.to <= view.viewport.from || range2.from >= view.viewport.to)
    return [];
  let from = Math.max(range2.from, view.viewport.from), to2 = Math.min(range2.to, view.viewport.to);
  let ltr = view.textDirection == Direction.LTR;
  let content2 = view.contentDOM, contentRect = content2.getBoundingClientRect(), base2 = getBase(view);
  let lineElt = content2.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
  let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
  let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
  let startBlock = blockAt(view, from, 1), endBlock = blockAt(view, to2, -1);
  let visualStart = startBlock.type == BlockType.Text ? startBlock : null;
  let visualEnd = endBlock.type == BlockType.Text ? endBlock : null;
  if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks))
    visualStart = wrappedLine(view, from, 1, visualStart);
  if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks))
    visualEnd = wrappedLine(view, to2, -1, visualEnd);
  if (visualStart && visualEnd && visualStart.from == visualEnd.from && visualStart.to == visualEnd.to) {
    return pieces(drawForLine(range2.from, range2.to, visualStart));
  } else {
    let top2 = visualStart ? drawForLine(range2.from, null, visualStart) : drawForWidget(startBlock, false);
    let bottom = visualEnd ? drawForLine(null, range2.to, visualEnd) : drawForWidget(endBlock, true);
    let between = [];
    if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top2.bottom + view.defaultLineHeight / 2 < bottom.top)
      between.push(piece(leftSide, top2.bottom, rightSide, bottom.top));
    else if (top2.bottom < bottom.top && view.elementAtHeight((top2.bottom + bottom.top) / 2).type == BlockType.Text)
      top2.bottom = bottom.top = (top2.bottom + bottom.top) / 2;
    return pieces(top2).concat(between).concat(pieces(bottom));
  }
  function piece(left, top2, right, bottom) {
    return new RectangleMarker(className, left - base2.left, top2 - base2.top, right - left, bottom - top2);
  }
  function pieces({ top: top2, bottom, horizontal }) {
    let pieces2 = [];
    for (let i2 = 0; i2 < horizontal.length; i2 += 2)
      pieces2.push(piece(horizontal[i2], top2, horizontal[i2 + 1], bottom));
    return pieces2;
  }
  function drawForLine(from2, to22, line2) {
    let top2 = 1e9, bottom = -1e9, horizontal = [];
    function addSpan(from3, fromOpen, to3, toOpen, dir) {
      let fromCoords = view.coordsAtPos(from3, from3 == line2.to ? -2 : 2);
      let toCoords = view.coordsAtPos(to3, to3 == line2.from ? 2 : -2);
      if (!fromCoords || !toCoords)
        return;
      top2 = Math.min(fromCoords.top, toCoords.top, top2);
      bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
      if (dir == Direction.LTR)
        horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
      else
        horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
    }
    let start = from2 !== null && from2 !== void 0 ? from2 : line2.from, end = to22 !== null && to22 !== void 0 ? to22 : line2.to;
    for (let r of view.visibleRanges)
      if (r.to > start && r.from < end) {
        for (let pos = Math.max(r.from, start), endPos = Math.min(r.to, end); ; ) {
          let docLine = view.state.doc.lineAt(pos);
          for (let span of view.bidiSpans(docLine)) {
            let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
            if (spanFrom >= endPos)
              break;
            if (spanTo > pos)
              addSpan(Math.max(spanFrom, pos), from2 == null && spanFrom <= start, Math.min(spanTo, endPos), to22 == null && spanTo >= end, span.dir);
          }
          pos = docLine.to + 1;
          if (pos >= endPos)
            break;
        }
      }
    if (horizontal.length == 0)
      addSpan(start, from2 == null, end, to22 == null, view.textDirection);
    return { top: top2, bottom, horizontal };
  }
  function drawForWidget(block, top2) {
    let y = contentRect.top + (top2 ? block.top : block.bottom);
    return { top: y, bottom: y, horizontal: [] };
  }
}
function sameMarker(a, b2) {
  return a.constructor == b2.constructor && a.eq(b2);
}
class LayerView {
  constructor(view, layer2) {
    this.view = view;
    this.layer = layer2;
    this.drawn = [];
    this.scaleX = 1;
    this.scaleY = 1;
    this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) };
    this.dom = view.scrollDOM.appendChild(document.createElement("div"));
    this.dom.classList.add("cm-layer");
    if (layer2.above)
      this.dom.classList.add("cm-layer-above");
    if (layer2.class)
      this.dom.classList.add(layer2.class);
    this.scale();
    this.dom.setAttribute("aria-hidden", "true");
    this.setOrder(view.state);
    view.requestMeasure(this.measureReq);
    if (layer2.mount)
      layer2.mount(this.dom, view);
  }
  update(update) {
    if (update.startState.facet(layerOrder) != update.state.facet(layerOrder))
      this.setOrder(update.state);
    if (this.layer.update(update, this.dom) || update.geometryChanged) {
      this.scale();
      update.view.requestMeasure(this.measureReq);
    }
  }
  docViewUpdate(view) {
    if (this.layer.updateOnDocViewUpdate !== false)
      view.requestMeasure(this.measureReq);
  }
  setOrder(state) {
    let pos = 0, order2 = state.facet(layerOrder);
    while (pos < order2.length && order2[pos] != this.layer)
      pos++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX, scaleY } = this.view;
    if (scaleX != this.scaleX || scaleY != this.scaleY) {
      this.scaleX = scaleX;
      this.scaleY = scaleY;
      this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
    }
  }
  draw(markers) {
    if (markers.length != this.drawn.length || markers.some((p, i2) => !sameMarker(p, this.drawn[i2]))) {
      let old = this.dom.firstChild, oldI = 0;
      for (let marker of markers) {
        if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
          old = old.nextSibling;
          oldI++;
        } else {
          this.dom.insertBefore(marker.draw(), old);
        }
      }
      while (old) {
        let next = old.nextSibling;
        old.remove();
        old = next;
      }
      this.drawn = markers;
      if (browser$2.safari && browser$2.safari_version >= 26)
        this.dom.style.display = this.dom.firstChild ? "" : "none";
    }
  }
  destroy() {
    if (this.layer.destroy)
      this.layer.destroy(this.dom, this.view);
    this.dom.remove();
  }
}
const layerOrder = /* @__PURE__ */ Facet.define();
function layer(config2) {
  return [
    ViewPlugin.define((v2) => new LayerView(v2, config2)),
    layerOrder.of(config2)
  ];
}
const selectionConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      cursorBlinkRate: 1200,
      drawRangeCursor: true
    }, {
      cursorBlinkRate: (a, b2) => Math.min(a, b2),
      drawRangeCursor: (a, b2) => a || b2
    });
  }
});
function drawSelection(config2 = {}) {
  return [
    selectionConfig.of(config2),
    cursorLayer,
    selectionLayer,
    hideNativeSelection,
    nativeSelectionHidden.of(true)
  ];
}
function configChanged(update) {
  return update.startState.facet(selectionConfig) != update.state.facet(selectionConfig);
}
const cursorLayer = /* @__PURE__ */ layer({
  above: true,
  markers(view) {
    let { state } = view, conf = state.facet(selectionConfig);
    let cursors = [];
    for (let r of state.selection.ranges) {
      let prim = r == state.selection.main;
      if (r.empty || conf.drawRangeCursor) {
        let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
        let cursor2 = r.empty ? r : EditorSelection.cursor(r.head, r.head > r.anchor ? -1 : 1);
        for (let piece of RectangleMarker.forRange(view, className, cursor2))
          cursors.push(piece);
      }
    }
    return cursors;
  },
  update(update, dom) {
    if (update.transactions.some((tr2) => tr2.selection))
      dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
    let confChange = configChanged(update);
    if (confChange)
      setBlinkRate(update.state, dom);
    return update.docChanged || update.selectionSet || confChange;
  },
  mount(dom, view) {
    setBlinkRate(view.state, dom);
  },
  class: "cm-cursorLayer"
});
function setBlinkRate(state, dom) {
  dom.style.animationDuration = state.facet(selectionConfig).cursorBlinkRate + "ms";
}
const selectionLayer = /* @__PURE__ */ layer({
  above: false,
  markers(view) {
    return view.state.selection.ranges.map((r) => r.empty ? [] : RectangleMarker.forRange(view, "cm-selectionBackground", r)).reduce((a, b2) => a.concat(b2));
  },
  update(update, dom) {
    return update.docChanged || update.selectionSet || update.viewportChanged || configChanged(update);
  },
  class: "cm-selectionLayer"
});
const hideNativeSelection = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ EditorView.theme({
  ".cm-line": {
    "& ::selection, &::selection": { backgroundColor: "transparent !important" },
    caretColor: "transparent !important"
  },
  ".cm-content": {
    caretColor: "transparent !important",
    "& :focus": {
      caretColor: "initial !important",
      "&::selection, & ::selection": {
        backgroundColor: "Highlight !important"
      }
    }
  }
}));
const setDropCursorPos = /* @__PURE__ */ StateEffect.define({
  map(pos, mapping) {
    return pos == null ? null : mapping.mapPos(pos);
  }
});
const dropCursorPos = /* @__PURE__ */ StateField.define({
  create() {
    return null;
  },
  update(pos, tr2) {
    if (pos != null)
      pos = tr2.changes.mapPos(pos);
    return tr2.effects.reduce((pos2, e2) => e2.is(setDropCursorPos) ? e2.value : pos2, pos);
  }
});
const drawDropCursor = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.cursor = null;
    this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(update) {
    var _a2;
    let cursorPos = update.state.field(dropCursorPos);
    if (cursorPos == null) {
      if (this.cursor != null) {
        (_a2 = this.cursor) === null || _a2 === void 0 ? void 0 : _a2.remove();
        this.cursor = null;
      }
    } else {
      if (!this.cursor) {
        this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
        this.cursor.className = "cm-dropCursor";
      }
      if (update.startState.field(dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged)
        this.view.requestMeasure(this.measureReq);
    }
  }
  readPos() {
    let { view } = this;
    let pos = view.state.field(dropCursorPos);
    let rect = pos != null && view.coordsAtPos(pos);
    if (!rect)
      return null;
    let outer = view.scrollDOM.getBoundingClientRect();
    return {
      left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
      top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
      height: rect.bottom - rect.top
    };
  }
  drawCursor(pos) {
    if (this.cursor) {
      let { scaleX, scaleY } = this.view;
      if (pos) {
        this.cursor.style.left = pos.left / scaleX + "px";
        this.cursor.style.top = pos.top / scaleY + "px";
        this.cursor.style.height = pos.height / scaleY + "px";
      } else {
        this.cursor.style.left = "-100000px";
      }
    }
  }
  destroy() {
    if (this.cursor)
      this.cursor.remove();
  }
  setDropPos(pos) {
    if (this.view.state.field(dropCursorPos) != pos)
      this.view.dispatch({ effects: setDropCursorPos.of(pos) });
  }
}, {
  eventObservers: {
    dragover(event) {
      this.setDropPos(this.view.posAtCoords({ x: event.clientX, y: event.clientY }));
    },
    dragleave(event) {
      if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget))
        this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function dropCursor() {
  return [dropCursorPos, drawDropCursor];
}
function iterMatches(doc2, re2, from, to2, f2) {
  re2.lastIndex = 0;
  for (let cursor2 = doc2.iterRange(from, to2), pos = from, m; !cursor2.next().done; pos += cursor2.value.length) {
    if (!cursor2.lineBreak)
      while (m = re2.exec(cursor2.value))
        f2(pos + m.index, m);
  }
}
function matchRanges(view, maxLength) {
  let visible = view.visibleRanges;
  if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to)
    return visible;
  let result2 = [];
  for (let { from, to: to2 } of visible) {
    from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
    to2 = Math.min(view.state.doc.lineAt(to2).to, to2 + maxLength);
    if (result2.length && result2[result2.length - 1].to >= from)
      result2[result2.length - 1].to = to2;
    else
      result2.push({ from, to: to2 });
  }
  return result2;
}
class MatchDecorator {
  /**
  Create a decorator.
  */
  constructor(config2) {
    const { regexp, decoration, decorate, boundary, maxLength = 1e3 } = config2;
    if (!regexp.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    this.regexp = regexp;
    if (decorate) {
      this.addMatch = (match2, view, from, add2) => decorate(add2, from, from + match2[0].length, match2, view);
    } else if (typeof decoration == "function") {
      this.addMatch = (match2, view, from, add2) => {
        let deco = decoration(match2, view, from);
        if (deco)
          add2(from, from + match2[0].length, deco);
      };
    } else if (decoration) {
      this.addMatch = (match2, _view, from, add2) => add2(from, from + match2[0].length, decoration);
    } else {
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    }
    this.boundary = boundary;
    this.maxLength = maxLength;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(view) {
    let build = new RangeSetBuilder(), add2 = build.add.bind(build);
    for (let { from, to: to2 } of matchRanges(view, this.maxLength))
      iterMatches(view.state.doc, this.regexp, from, to2, (from2, m) => this.addMatch(m, view, from2, add2));
    return build.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(update, deco) {
    let changeFrom = 1e9, changeTo = -1;
    if (update.docChanged)
      update.changes.iterChanges((_f, _t, from, to2) => {
        if (to2 >= update.view.viewport.from && from <= update.view.viewport.to) {
          changeFrom = Math.min(from, changeFrom);
          changeTo = Math.max(to2, changeTo);
        }
      });
    if (update.viewportMoved || changeTo - changeFrom > 1e3)
      return this.createDeco(update.view);
    if (changeTo > -1)
      return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
    return deco;
  }
  updateRange(view, deco, updateFrom, updateTo) {
    for (let r of view.visibleRanges) {
      let from = Math.max(r.from, updateFrom), to2 = Math.min(r.to, updateTo);
      if (to2 >= from) {
        let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to2 ? view.state.doc.lineAt(to2) : fromLine;
        let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
        if (this.boundary) {
          for (; from > fromLine.from; from--)
            if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
              start = from;
              break;
            }
          for (; to2 < toLine.to; to2++)
            if (this.boundary.test(toLine.text[to2 - toLine.from])) {
              end = to2;
              break;
            }
        }
        let ranges = [], m;
        let add2 = (from2, to22, deco2) => ranges.push(deco2.range(from2, to22));
        if (fromLine == toLine) {
          this.regexp.lastIndex = start - fromLine.from;
          while ((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)
            this.addMatch(m, view, m.index + fromLine.from, add2);
        } else {
          iterMatches(view.state.doc, this.regexp, start, end, (from2, m2) => this.addMatch(m2, view, from2, add2));
        }
        deco = deco.update({ filterFrom: start, filterTo: end, filter: (from2, to22) => from2 < start || to22 > end, add: ranges });
      }
    }
    return deco;
  }
}
const UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const Specials = /* @__PURE__ */ new RegExp("[\0-\b\n--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]", UnicodeRegexpSupport);
const Names = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let _supportsTabSize = null;
function supportsTabSize() {
  var _a2;
  if (_supportsTabSize == null && typeof document != "undefined" && document.body) {
    let styles = document.body.style;
    _supportsTabSize = ((_a2 = styles.tabSize) !== null && _a2 !== void 0 ? _a2 : styles.MozTabSize) != null;
  }
  return _supportsTabSize || false;
}
const specialCharConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    let config2 = combineConfig(configs, {
      render: null,
      specialChars: Specials,
      addSpecialChars: null
    });
    if (config2.replaceTabs = !supportsTabSize())
      config2.specialChars = new RegExp("	|" + config2.specialChars.source, UnicodeRegexpSupport);
    if (config2.addSpecialChars)
      config2.specialChars = new RegExp(config2.specialChars.source + "|" + config2.addSpecialChars.source, UnicodeRegexpSupport);
    return config2;
  }
});
function highlightSpecialChars(config2 = {}) {
  return [specialCharConfig.of(config2), specialCharPlugin()];
}
let _plugin = null;
function specialCharPlugin() {
  return _plugin || (_plugin = ViewPlugin.fromClass(class {
    constructor(view) {
      this.view = view;
      this.decorations = Decoration.none;
      this.decorationCache = /* @__PURE__ */ Object.create(null);
      this.decorator = this.makeDecorator(view.state.facet(specialCharConfig));
      this.decorations = this.decorator.createDeco(view);
    }
    makeDecorator(conf) {
      return new MatchDecorator({
        regexp: conf.specialChars,
        decoration: (m, view, pos) => {
          let { doc: doc2 } = view.state;
          let code2 = codePointAt(m[0], 0);
          if (code2 == 9) {
            let line2 = doc2.lineAt(pos);
            let size2 = view.state.tabSize, col = countColumn(line2.text, size2, pos - line2.from);
            return Decoration.replace({
              widget: new TabWidget((size2 - col % size2) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[code2] || (this.decorationCache[code2] = Decoration.replace({ widget: new SpecialCharWidget(conf, code2) }));
        },
        boundary: conf.replaceTabs ? void 0 : /[^]/
      });
    }
    update(update) {
      let conf = update.state.facet(specialCharConfig);
      if (update.startState.facet(specialCharConfig) != conf) {
        this.decorator = this.makeDecorator(conf);
        this.decorations = this.decorator.createDeco(update.view);
      } else {
        this.decorations = this.decorator.updateDeco(update, this.decorations);
      }
    }
  }, {
    decorations: (v2) => v2.decorations
  }));
}
const DefaultPlaceholder = "•";
function placeholder$1(code2) {
  if (code2 >= 32)
    return DefaultPlaceholder;
  if (code2 == 10)
    return "␤";
  return String.fromCharCode(9216 + code2);
}
class SpecialCharWidget extends WidgetType {
  constructor(options2, code2) {
    super();
    this.options = options2;
    this.code = code2;
  }
  eq(other) {
    return other.code == this.code;
  }
  toDOM(view) {
    let ph = placeholder$1(this.code);
    let desc = view.state.phrase("Control character") + " " + (Names[this.code] || "0x" + this.code.toString(16));
    let custom = this.options.render && this.options.render(this.code, desc, ph);
    if (custom)
      return custom;
    let span = document.createElement("span");
    span.textContent = ph;
    span.title = desc;
    span.setAttribute("aria-label", desc);
    span.className = "cm-specialChar";
    return span;
  }
  ignoreEvent() {
    return false;
  }
}
class TabWidget extends WidgetType {
  constructor(width) {
    super();
    this.width = width;
  }
  eq(other) {
    return other.width == this.width;
  }
  toDOM() {
    let span = document.createElement("span");
    span.textContent = "	";
    span.className = "cm-tab";
    span.style.width = this.width + "px";
    return span;
  }
  ignoreEvent() {
    return false;
  }
}
function highlightActiveLine() {
  return activeLineHighlighter;
}
const lineDeco = /* @__PURE__ */ Decoration.line({ class: "cm-activeLine" });
const activeLineHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.decorations = this.getDeco(view);
  }
  update(update) {
    if (update.docChanged || update.selectionSet)
      this.decorations = this.getDeco(update.view);
  }
  getDeco(view) {
    let lastLineStart = -1, deco = [];
    for (let r of view.state.selection.ranges) {
      let line2 = view.lineBlockAt(r.head);
      if (line2.from > lastLineStart) {
        deco.push(lineDeco.range(line2.from));
        lastLineStart = line2.from;
      }
    }
    return Decoration.set(deco);
  }
}, {
  decorations: (v2) => v2.decorations
});
class Placeholder extends WidgetType {
  constructor(content2) {
    super();
    this.content = content2;
  }
  toDOM(view) {
    let wrap2 = document.createElement("span");
    wrap2.className = "cm-placeholder";
    wrap2.style.pointerEvents = "none";
    wrap2.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(view) : this.content.cloneNode(true));
    wrap2.setAttribute("aria-hidden", "true");
    return wrap2;
  }
  coordsAt(dom) {
    let rects = dom.firstChild ? clientRectsFor(dom.firstChild) : [];
    if (!rects.length)
      return null;
    let style = window.getComputedStyle(dom.parentNode);
    let rect = flattenRect(rects[0], style.direction != "rtl");
    let lineHeight = parseInt(style.lineHeight);
    if (rect.bottom - rect.top > lineHeight * 1.5)
      return { left: rect.left, right: rect.right, top: rect.top, bottom: rect.top + lineHeight };
    return rect;
  }
  ignoreEvent() {
    return false;
  }
}
function placeholder(content2) {
  let plugin = ViewPlugin.fromClass(class {
    constructor(view) {
      this.view = view;
      this.placeholder = content2 ? Decoration.set([Decoration.widget({ widget: new Placeholder(content2), side: 1 }).range(0)]) : Decoration.none;
    }
    get decorations() {
      return this.view.state.doc.length ? Decoration.none : this.placeholder;
    }
  }, { decorations: (v2) => v2.decorations });
  return typeof content2 == "string" ? [
    plugin,
    EditorView.contentAttributes.of({ "aria-placeholder": content2 })
  ] : plugin;
}
const MaxOff = 2e3;
function rectangleFor(state, a, b2) {
  let startLine = Math.min(a.line, b2.line), endLine = Math.max(a.line, b2.line);
  let ranges = [];
  if (a.off > MaxOff || b2.off > MaxOff || a.col < 0 || b2.col < 0) {
    let startOff = Math.min(a.off, b2.off), endOff = Math.max(a.off, b2.off);
    for (let i2 = startLine; i2 <= endLine; i2++) {
      let line2 = state.doc.line(i2);
      if (line2.length <= endOff)
        ranges.push(EditorSelection.range(line2.from + startOff, line2.to + endOff));
    }
  } else {
    let startCol = Math.min(a.col, b2.col), endCol = Math.max(a.col, b2.col);
    for (let i2 = startLine; i2 <= endLine; i2++) {
      let line2 = state.doc.line(i2);
      let start = findColumn(line2.text, startCol, state.tabSize, true);
      if (start < 0) {
        ranges.push(EditorSelection.cursor(line2.to));
      } else {
        let end = findColumn(line2.text, endCol, state.tabSize);
        ranges.push(EditorSelection.range(line2.from + start, line2.from + end));
      }
    }
  }
  return ranges;
}
function absoluteColumn(view, x2) {
  let ref = view.coordsAtPos(view.viewport.from);
  return ref ? Math.round(Math.abs((ref.left - x2) / view.defaultCharacterWidth)) : -1;
}
function getPos(view, event) {
  let offset2 = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  let line2 = view.state.doc.lineAt(offset2), off2 = offset2 - line2.from;
  let col = off2 > MaxOff ? -1 : off2 == line2.length ? absoluteColumn(view, event.clientX) : countColumn(line2.text, view.state.tabSize, offset2 - line2.from);
  return { line: line2.number, col, off: off2 };
}
function rectangleSelectionStyle(view, event) {
  let start = getPos(view, event), startSel = view.state.selection;
  if (!start)
    return null;
  return {
    update(update) {
      if (update.docChanged) {
        let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
        let newLine = update.state.doc.lineAt(newStart);
        start = { line: newLine.number, col: start.col, off: Math.min(start.off, newLine.length) };
        startSel = startSel.map(update.changes);
      }
    },
    get(event2, _extend, multiple) {
      let cur2 = getPos(view, event2);
      if (!cur2)
        return startSel;
      let ranges = rectangleFor(view.state, start, cur2);
      if (!ranges.length)
        return startSel;
      if (multiple)
        return EditorSelection.create(ranges.concat(startSel.ranges));
      else
        return EditorSelection.create(ranges);
    }
  };
}
function rectangularSelection(options2) {
  let filter2 = ((e2) => e2.altKey && e2.button == 0);
  return EditorView.mouseSelectionStyle.of((view, event) => filter2(event) ? rectangleSelectionStyle(view, event) : null);
}
const keys = {
  Alt: [18, (e2) => !!e2.altKey],
  Control: [17, (e2) => !!e2.ctrlKey],
  Shift: [16, (e2) => !!e2.shiftKey],
  Meta: [91, (e2) => !!e2.metaKey]
};
const showCrosshair = { style: "cursor: crosshair" };
function crosshairCursor(options2 = {}) {
  let [code2, getter] = keys[options2.key || "Alt"];
  let plugin = ViewPlugin.fromClass(class {
    constructor(view) {
      this.view = view;
      this.isDown = false;
    }
    set(isDown) {
      if (this.isDown != isDown) {
        this.isDown = isDown;
        this.view.update([]);
      }
    }
  }, {
    eventObservers: {
      keydown(e2) {
        this.set(e2.keyCode == code2 || getter(e2));
      },
      keyup(e2) {
        if (e2.keyCode == code2 || !getter(e2))
          this.set(false);
      },
      mousemove(e2) {
        this.set(getter(e2));
      }
    }
  });
  return [
    plugin,
    EditorView.contentAttributes.of((view) => {
      var _a2;
      return ((_a2 = view.plugin(plugin)) === null || _a2 === void 0 ? void 0 : _a2.isDown) ? showCrosshair : null;
    })
  ];
}
const Outside = "-10000px";
class TooltipViewManager {
  constructor(view, facet, createTooltipView, removeTooltipView) {
    this.facet = facet;
    this.createTooltipView = createTooltipView;
    this.removeTooltipView = removeTooltipView;
    this.input = view.state.facet(facet);
    this.tooltips = this.input.filter((t2) => t2);
    let prev = null;
    this.tooltipViews = this.tooltips.map((t2) => prev = createTooltipView(t2, prev));
  }
  update(update, above) {
    var _a2;
    let input = update.state.facet(this.facet);
    let tooltips = input.filter((x2) => x2);
    if (input === this.input) {
      for (let t2 of this.tooltipViews)
        if (t2.update)
          t2.update(update);
      return false;
    }
    let tooltipViews = [], newAbove = above ? [] : null;
    for (let i2 = 0; i2 < tooltips.length; i2++) {
      let tip = tooltips[i2], known = -1;
      if (!tip)
        continue;
      for (let i22 = 0; i22 < this.tooltips.length; i22++) {
        let other = this.tooltips[i22];
        if (other && other.create == tip.create)
          known = i22;
      }
      if (known < 0) {
        tooltipViews[i2] = this.createTooltipView(tip, i2 ? tooltipViews[i2 - 1] : null);
        if (newAbove)
          newAbove[i2] = !!tip.above;
      } else {
        let tooltipView = tooltipViews[i2] = this.tooltipViews[known];
        if (newAbove)
          newAbove[i2] = above[known];
        if (tooltipView.update)
          tooltipView.update(update);
      }
    }
    for (let t2 of this.tooltipViews)
      if (tooltipViews.indexOf(t2) < 0) {
        this.removeTooltipView(t2);
        (_a2 = t2.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(t2);
      }
    if (above) {
      newAbove.forEach((val, i2) => above[i2] = val);
      above.length = newAbove.length;
    }
    this.input = input;
    this.tooltips = tooltips;
    this.tooltipViews = tooltipViews;
    return true;
  }
}
function windowSpace(view) {
  let docElt = view.dom.ownerDocument.documentElement;
  return { top: 0, left: 0, bottom: docElt.clientHeight, right: docElt.clientWidth };
}
const tooltipConfig = /* @__PURE__ */ Facet.define({
  combine: (values2) => {
    var _a2, _b, _c;
    return {
      position: browser$2.ios ? "absolute" : ((_a2 = values2.find((conf) => conf.position)) === null || _a2 === void 0 ? void 0 : _a2.position) || "fixed",
      parent: ((_b = values2.find((conf) => conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
      tooltipSpace: ((_c = values2.find((conf) => conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || windowSpace
    };
  }
});
const knownHeight = /* @__PURE__ */ new WeakMap();
const tooltipPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.above = [];
    this.inView = true;
    this.madeAbsolute = false;
    this.lastTransaction = 0;
    this.measureTimeout = -1;
    let config2 = view.state.facet(tooltipConfig);
    this.position = config2.position;
    this.parent = config2.parent;
    this.classes = view.themeClasses;
    this.createContainer();
    this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this };
    this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null;
    this.manager = new TooltipViewManager(view, showTooltip, (t2, p) => this.createTooltip(t2, p), (t2) => {
      if (this.resizeObserver)
        this.resizeObserver.unobserve(t2.dom);
      t2.dom.remove();
    });
    this.above = this.manager.tooltips.map((t2) => !!t2.above);
    this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries) => {
      if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1)
        this.measureSoon();
    }, { threshold: [1] }) : null;
    this.observeIntersection();
    view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
    this.maybeMeasure();
  }
  createContainer() {
    if (this.parent) {
      this.container = document.createElement("div");
      this.container.style.position = "relative";
      this.container.className = this.view.themeClasses;
      this.parent.appendChild(this.container);
    } else {
      this.container = this.view.dom;
    }
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let tooltip of this.manager.tooltipViews)
        this.intersectionObserver.observe(tooltip.dom);
    }
  }
  measureSoon() {
    if (this.measureTimeout < 0)
      this.measureTimeout = setTimeout(() => {
        this.measureTimeout = -1;
        this.maybeMeasure();
      }, 50);
  }
  update(update) {
    if (update.transactions.length)
      this.lastTransaction = Date.now();
    let updated = this.manager.update(update, this.above);
    if (updated)
      this.observeIntersection();
    let shouldMeasure = updated || update.geometryChanged;
    let newConfig = update.state.facet(tooltipConfig);
    if (newConfig.position != this.position && !this.madeAbsolute) {
      this.position = newConfig.position;
      for (let t2 of this.manager.tooltipViews)
        t2.dom.style.position = this.position;
      shouldMeasure = true;
    }
    if (newConfig.parent != this.parent) {
      if (this.parent)
        this.container.remove();
      this.parent = newConfig.parent;
      this.createContainer();
      for (let t2 of this.manager.tooltipViews)
        this.container.appendChild(t2.dom);
      shouldMeasure = true;
    } else if (this.parent && this.view.themeClasses != this.classes) {
      this.classes = this.container.className = this.view.themeClasses;
    }
    if (shouldMeasure)
      this.maybeMeasure();
  }
  createTooltip(tooltip, prev) {
    let tooltipView = tooltip.create(this.view);
    let before2 = prev ? prev.dom : null;
    tooltipView.dom.classList.add("cm-tooltip");
    if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let arrow2 = document.createElement("div");
      arrow2.className = "cm-tooltip-arrow";
      tooltipView.dom.appendChild(arrow2);
    }
    tooltipView.dom.style.position = this.position;
    tooltipView.dom.style.top = Outside;
    tooltipView.dom.style.left = "0px";
    this.container.insertBefore(tooltipView.dom, before2);
    if (tooltipView.mount)
      tooltipView.mount(this.view);
    if (this.resizeObserver)
      this.resizeObserver.observe(tooltipView.dom);
    return tooltipView;
  }
  destroy() {
    var _a2, _b, _c;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let tooltipView of this.manager.tooltipViews) {
      tooltipView.dom.remove();
      (_a2 = tooltipView.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(tooltipView);
    }
    if (this.parent)
      this.container.remove();
    (_b = this.resizeObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    (_c = this.intersectionObserver) === null || _c === void 0 ? void 0 : _c.disconnect();
    clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let scaleX = 1, scaleY = 1, makeAbsolute = false;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom } = this.manager.tooltipViews[0];
      if (browser$2.safari) {
        let rect = dom.getBoundingClientRect();
        makeAbsolute = Math.abs(rect.top + 1e4) > 1 || Math.abs(rect.left) > 1;
      } else {
        makeAbsolute = !!dom.offsetParent && dom.offsetParent != this.container.ownerDocument.body;
      }
    }
    if (makeAbsolute || this.position == "absolute") {
      if (this.parent) {
        let rect = this.parent.getBoundingClientRect();
        if (rect.width && rect.height) {
          scaleX = rect.width / this.parent.offsetWidth;
          scaleY = rect.height / this.parent.offsetHeight;
        }
      } else {
        ({ scaleX, scaleY } = this.view.viewState);
      }
    }
    let visible = this.view.scrollDOM.getBoundingClientRect(), margins = getScrollMargins(this.view);
    return {
      visible: {
        left: visible.left + margins.left,
        top: visible.top + margins.top,
        right: visible.right - margins.right,
        bottom: visible.bottom - margins.bottom
      },
      parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
      pos: this.manager.tooltips.map((t2, i2) => {
        let tv = this.manager.tooltipViews[i2];
        return tv.getCoords ? tv.getCoords(t2.pos) : this.view.coordsAtPos(t2.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom }) => dom.getBoundingClientRect()),
      space: this.view.state.facet(tooltipConfig).tooltipSpace(this.view),
      scaleX,
      scaleY,
      makeAbsolute
    };
  }
  writeMeasure(measured) {
    var _a2;
    if (measured.makeAbsolute) {
      this.madeAbsolute = true;
      this.position = "absolute";
      for (let t2 of this.manager.tooltipViews)
        t2.dom.style.position = "absolute";
    }
    let { visible, space, scaleX, scaleY } = measured;
    let others = [];
    for (let i2 = 0; i2 < this.manager.tooltips.length; i2++) {
      let tooltip = this.manager.tooltips[i2], tView = this.manager.tooltipViews[i2], { dom } = tView;
      let pos = measured.pos[i2], size2 = measured.size[i2];
      if (!pos || tooltip.clip !== false && (pos.bottom <= Math.max(visible.top, space.top) || pos.top >= Math.min(visible.bottom, space.bottom) || pos.right < Math.max(visible.left, space.left) - 0.1 || pos.left > Math.min(visible.right, space.right) + 0.1)) {
        dom.style.top = Outside;
        continue;
      }
      let arrow2 = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
      let arrowHeight = arrow2 ? 7 : 0;
      let width = size2.right - size2.left, height = (_a2 = knownHeight.get(tView)) !== null && _a2 !== void 0 ? _a2 : size2.bottom - size2.top;
      let offset2 = tView.offset || noOffset, ltr = this.view.textDirection == Direction.LTR;
      let left = size2.width > space.right - space.left ? ltr ? space.left : space.right - size2.width : ltr ? Math.max(space.left, Math.min(pos.left - (arrow2 ? 14 : 0) + offset2.x, space.right - width)) : Math.min(Math.max(space.left, pos.left - width + (arrow2 ? 14 : 0) - offset2.x), space.right - width);
      let above = this.above[i2];
      if (!tooltip.strictSide && (above ? pos.top - height - arrowHeight - offset2.y < space.top : pos.bottom + height + arrowHeight + offset2.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top)
        above = this.above[i2] = !above;
      let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
      if (spaceVert < height && tView.resize !== false) {
        if (spaceVert < this.view.defaultLineHeight) {
          dom.style.top = Outside;
          continue;
        }
        knownHeight.set(tView, height);
        dom.style.height = (height = spaceVert) / scaleY + "px";
      } else if (dom.style.height) {
        dom.style.height = "";
      }
      let top2 = above ? pos.top - height - arrowHeight - offset2.y : pos.bottom + arrowHeight + offset2.y;
      let right = left + width;
      if (tView.overlap !== true) {
        for (let r of others)
          if (r.left < right && r.right > left && r.top < top2 + height && r.bottom > top2)
            top2 = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
      }
      if (this.position == "absolute") {
        dom.style.top = (top2 - measured.parent.top) / scaleY + "px";
        setLeftStyle(dom, (left - measured.parent.left) / scaleX);
      } else {
        dom.style.top = top2 / scaleY + "px";
        setLeftStyle(dom, left / scaleX);
      }
      if (arrow2) {
        let arrowLeft = pos.left + (ltr ? offset2.x : -offset2.x) - (left + 14 - 7);
        arrow2.style.left = arrowLeft / scaleX + "px";
      }
      if (tView.overlap !== true)
        others.push({ left, top: top2, right, bottom: top2 + height });
      dom.classList.toggle("cm-tooltip-above", above);
      dom.classList.toggle("cm-tooltip-below", !above);
      if (tView.positioned)
        tView.positioned(measured.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length) {
      if (this.view.inView)
        this.view.requestMeasure(this.measureReq);
      if (this.inView != this.view.inView) {
        this.inView = this.view.inView;
        if (!this.inView)
          for (let tv of this.manager.tooltipViews)
            tv.dom.style.top = Outside;
      }
    }
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
});
function setLeftStyle(elt, value) {
  let current2 = parseInt(elt.style.left, 10);
  if (isNaN(current2) || Math.abs(value - current2) > 1)
    elt.style.left = value + "px";
}
const baseTheme$4 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-tooltip": {
    zIndex: 500,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: `${7}px`,
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: `${7}px solid transparent`,
      borderRight: `${7}px solid transparent`
    },
    ".cm-tooltip-above &": {
      bottom: `-${7}px`,
      "&:before": {
        borderTop: `${7}px solid #bbb`
      },
      "&:after": {
        borderTop: `${7}px solid #f5f5f5`,
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: `-${7}px`,
      "&:before": {
        borderBottom: `${7}px solid #bbb`
      },
      "&:after": {
        borderBottom: `${7}px solid #f5f5f5`,
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
});
const noOffset = { x: 0, y: 0 };
const showTooltip = /* @__PURE__ */ Facet.define({
  enables: [tooltipPlugin, baseTheme$4]
});
const showHoverTooltip = /* @__PURE__ */ Facet.define({
  combine: (inputs) => inputs.reduce((a, i2) => a.concat(i2), [])
});
class HoverTooltipHost {
  // Needs to be static so that host tooltip instances always match
  static create(view) {
    return new HoverTooltipHost(view);
  }
  constructor(view) {
    this.view = view;
    this.mounted = false;
    this.dom = document.createElement("div");
    this.dom.classList.add("cm-tooltip-hover");
    this.manager = new TooltipViewManager(view, showHoverTooltip, (t2, p) => this.createHostedView(t2, p), (t2) => t2.dom.remove());
  }
  createHostedView(tooltip, prev) {
    let hostedView = tooltip.create(this.view);
    hostedView.dom.classList.add("cm-tooltip-section");
    this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
    if (this.mounted && hostedView.mount)
      hostedView.mount(this.view);
    return hostedView;
  }
  mount(view) {
    for (let hostedView of this.manager.tooltipViews) {
      if (hostedView.mount)
        hostedView.mount(view);
    }
    this.mounted = true;
  }
  positioned(space) {
    for (let hostedView of this.manager.tooltipViews) {
      if (hostedView.positioned)
        hostedView.positioned(space);
    }
  }
  update(update) {
    this.manager.update(update);
  }
  destroy() {
    var _a2;
    for (let t2 of this.manager.tooltipViews)
      (_a2 = t2.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(t2);
  }
  passProp(name2) {
    let value = void 0;
    for (let view of this.manager.tooltipViews) {
      let given = view[name2];
      if (given !== void 0) {
        if (value === void 0)
          value = given;
        else if (value !== given)
          return void 0;
      }
    }
    return value;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const showHoverTooltipHost = /* @__PURE__ */ showTooltip.compute([showHoverTooltip], (state) => {
  let tooltips = state.facet(showHoverTooltip);
  if (tooltips.length === 0)
    return null;
  return {
    pos: Math.min(...tooltips.map((t2) => t2.pos)),
    end: Math.max(...tooltips.map((t2) => {
      var _a2;
      return (_a2 = t2.end) !== null && _a2 !== void 0 ? _a2 : t2.pos;
    })),
    create: HoverTooltipHost.create,
    above: tooltips[0].above,
    arrow: tooltips.some((t2) => t2.arrow)
  };
});
class HoverPlugin {
  constructor(view, source, field, setHover, hoverTime) {
    this.view = view;
    this.source = source;
    this.field = field;
    this.setHover = setHover;
    this.hoverTime = hoverTime;
    this.hoverTimeout = -1;
    this.restartTimeout = -1;
    this.pending = null;
    this.lastMove = { x: 0, y: 0, target: view.dom, time: 0 };
    this.checkHover = this.checkHover.bind(this);
    view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
    view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    if (this.pending) {
      this.pending = null;
      clearTimeout(this.restartTimeout);
      this.restartTimeout = setTimeout(() => this.startHover(), 20);
    }
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    this.hoverTimeout = -1;
    if (this.active.length)
      return;
    let hovered = Date.now() - this.lastMove.time;
    if (hovered < this.hoverTime)
      this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
    else
      this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view, lastMove } = this;
    let desc = view.docView.nearest(lastMove.target);
    if (!desc)
      return;
    let pos, side = 1;
    if (desc instanceof WidgetView) {
      pos = desc.posAtStart;
    } else {
      pos = view.posAtCoords(lastMove);
      if (pos == null)
        return;
      let posCoords = view.coordsAtPos(pos);
      if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth)
        return;
      let bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s) => s.from <= pos && s.to >= pos);
      let rtl = bidi && bidi.dir == Direction.RTL ? -1 : 1;
      side = lastMove.x < posCoords.left ? -rtl : rtl;
    }
    let open = this.source(view, pos, side);
    if (open === null || open === void 0 ? void 0 : open.then) {
      let pending = this.pending = { pos };
      open.then((result2) => {
        if (this.pending == pending) {
          this.pending = null;
          if (result2 && !(Array.isArray(result2) && !result2.length))
            view.dispatch({ effects: this.setHover.of(Array.isArray(result2) ? result2 : [result2]) });
        }
      }, (e2) => logException(view.state, e2, "hover tooltip"));
    } else if (open && !(Array.isArray(open) && !open.length)) {
      view.dispatch({ effects: this.setHover.of(Array.isArray(open) ? open : [open]) });
    }
  }
  get tooltip() {
    let plugin = this.view.plugin(tooltipPlugin);
    let index2 = plugin ? plugin.manager.tooltips.findIndex((t2) => t2.create == HoverTooltipHost.create) : -1;
    return index2 > -1 ? plugin.manager.tooltipViews[index2] : null;
  }
  mousemove(event) {
    var _a2, _b;
    this.lastMove = { x: event.clientX, y: event.clientY, target: event.target, time: Date.now() };
    if (this.hoverTimeout < 0)
      this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
    let { active, tooltip } = this;
    if (active.length && tooltip && !isInTooltip(tooltip.dom, event) || this.pending) {
      let { pos } = active[0] || this.pending, end = (_b = (_a2 = active[0]) === null || _a2 === void 0 ? void 0 : _a2.end) !== null && _b !== void 0 ? _b : pos;
      if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
        this.view.dispatch({ effects: this.setHover.of([]) });
        this.pending = null;
      }
    }
  }
  mouseleave(event) {
    clearTimeout(this.hoverTimeout);
    this.hoverTimeout = -1;
    let { active } = this;
    if (active.length) {
      let { tooltip } = this;
      let inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
      if (!inTooltip)
        this.view.dispatch({ effects: this.setHover.of([]) });
      else
        this.watchTooltipLeave(tooltip.dom);
    }
  }
  watchTooltipLeave(tooltip) {
    let watch = (event) => {
      tooltip.removeEventListener("mouseleave", watch);
      if (this.active.length && !this.view.dom.contains(event.relatedTarget))
        this.view.dispatch({ effects: this.setHover.of([]) });
    };
    tooltip.addEventListener("mouseleave", watch);
  }
  destroy() {
    clearTimeout(this.hoverTimeout);
    this.view.dom.removeEventListener("mouseleave", this.mouseleave);
    this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const tooltipMargin = 4;
function isInTooltip(tooltip, event) {
  let { left, right, top: top2, bottom } = tooltip.getBoundingClientRect(), arrow2;
  if (arrow2 = tooltip.querySelector(".cm-tooltip-arrow")) {
    let arrowRect = arrow2.getBoundingClientRect();
    top2 = Math.min(arrowRect.top, top2);
    bottom = Math.max(arrowRect.bottom, bottom);
  }
  return event.clientX >= left - tooltipMargin && event.clientX <= right + tooltipMargin && event.clientY >= top2 - tooltipMargin && event.clientY <= bottom + tooltipMargin;
}
function isOverRange(view, from, to2, x2, y, margin) {
  let rect = view.scrollDOM.getBoundingClientRect();
  let docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
  if (rect.left > x2 || rect.right < x2 || rect.top > y || Math.min(rect.bottom, docBottom) < y)
    return false;
  let pos = view.posAtCoords({ x: x2, y }, false);
  return pos >= from && pos <= to2;
}
function hoverTooltip(source, options2 = {}) {
  let setHover = StateEffect.define();
  let hoverState = StateField.define({
    create() {
      return [];
    },
    update(value, tr2) {
      if (value.length) {
        if (options2.hideOnChange && (tr2.docChanged || tr2.selection))
          value = [];
        else if (options2.hideOn)
          value = value.filter((v2) => !options2.hideOn(tr2, v2));
        if (tr2.docChanged) {
          let mapped = [];
          for (let tooltip of value) {
            let newPos = tr2.changes.mapPos(tooltip.pos, -1, MapMode.TrackDel);
            if (newPos != null) {
              let copy2 = Object.assign(/* @__PURE__ */ Object.create(null), tooltip);
              copy2.pos = newPos;
              if (copy2.end != null)
                copy2.end = tr2.changes.mapPos(copy2.end);
              mapped.push(copy2);
            }
          }
          value = mapped;
        }
      }
      for (let effect of tr2.effects) {
        if (effect.is(setHover))
          value = effect.value;
        if (effect.is(closeHoverTooltipEffect))
          value = [];
      }
      return value;
    },
    provide: (f2) => showHoverTooltip.from(f2)
  });
  return {
    active: hoverState,
    extension: [
      hoverState,
      ViewPlugin.define((view) => new HoverPlugin(
        view,
        source,
        hoverState,
        setHover,
        options2.hoverTime || 300
        /* Hover.Time */
      )),
      showHoverTooltipHost
    ]
  };
}
function getTooltip(view, tooltip) {
  let plugin = view.plugin(tooltipPlugin);
  if (!plugin)
    return null;
  let found = plugin.manager.tooltips.indexOf(tooltip);
  return found < 0 ? null : plugin.manager.tooltipViews[found];
}
const closeHoverTooltipEffect = /* @__PURE__ */ StateEffect.define();
const panelConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    let topContainer, bottomContainer;
    for (let c2 of configs) {
      topContainer = topContainer || c2.topContainer;
      bottomContainer = bottomContainer || c2.bottomContainer;
    }
    return { topContainer, bottomContainer };
  }
});
function getPanel(view, panel) {
  let plugin = view.plugin(panelPlugin);
  let index2 = plugin ? plugin.specs.indexOf(panel) : -1;
  return index2 > -1 ? plugin.panels[index2] : null;
}
const panelPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.input = view.state.facet(showPanel);
    this.specs = this.input.filter((s) => s);
    this.panels = this.specs.map((spec) => spec(view));
    let conf = view.state.facet(panelConfig);
    this.top = new PanelGroup(view, true, conf.topContainer);
    this.bottom = new PanelGroup(view, false, conf.bottomContainer);
    this.top.sync(this.panels.filter((p) => p.top));
    this.bottom.sync(this.panels.filter((p) => !p.top));
    for (let p of this.panels) {
      p.dom.classList.add("cm-panel");
      if (p.mount)
        p.mount();
    }
  }
  update(update) {
    let conf = update.state.facet(panelConfig);
    if (this.top.container != conf.topContainer) {
      this.top.sync([]);
      this.top = new PanelGroup(update.view, true, conf.topContainer);
    }
    if (this.bottom.container != conf.bottomContainer) {
      this.bottom.sync([]);
      this.bottom = new PanelGroup(update.view, false, conf.bottomContainer);
    }
    this.top.syncClasses();
    this.bottom.syncClasses();
    let input = update.state.facet(showPanel);
    if (input != this.input) {
      let specs = input.filter((x2) => x2);
      let panels = [], top2 = [], bottom = [], mount = [];
      for (let spec of specs) {
        let known = this.specs.indexOf(spec), panel;
        if (known < 0) {
          panel = spec(update.view);
          mount.push(panel);
        } else {
          panel = this.panels[known];
          if (panel.update)
            panel.update(update);
        }
        panels.push(panel);
        (panel.top ? top2 : bottom).push(panel);
      }
      this.specs = specs;
      this.panels = panels;
      this.top.sync(top2);
      this.bottom.sync(bottom);
      for (let p of mount) {
        p.dom.classList.add("cm-panel");
        if (p.mount)
          p.mount();
      }
    } else {
      for (let p of this.panels)
        if (p.update)
          p.update(update);
    }
  }
  destroy() {
    this.top.sync([]);
    this.bottom.sync([]);
  }
}, {
  provide: (plugin) => EditorView.scrollMargins.of((view) => {
    let value = view.plugin(plugin);
    return value && { top: value.top.scrollMargin(), bottom: value.bottom.scrollMargin() };
  })
});
class PanelGroup {
  constructor(view, top2, container) {
    this.view = view;
    this.top = top2;
    this.container = container;
    this.dom = void 0;
    this.classes = "";
    this.panels = [];
    this.syncClasses();
  }
  sync(panels) {
    for (let p of this.panels)
      if (p.destroy && panels.indexOf(p) < 0)
        p.destroy();
    this.panels = panels;
    this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      if (this.dom) {
        this.dom.remove();
        this.dom = void 0;
      }
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div");
      this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
      this.dom.style[this.top ? "top" : "bottom"] = "0";
      let parent = this.container || this.view.dom;
      parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
    }
    let curDOM = this.dom.firstChild;
    for (let panel of this.panels) {
      if (panel.dom.parentNode == this.dom) {
        while (curDOM != panel.dom)
          curDOM = rm(curDOM);
        curDOM = curDOM.nextSibling;
      } else {
        this.dom.insertBefore(panel.dom, curDOM);
      }
    }
    while (curDOM)
      curDOM = rm(curDOM);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!this.container || this.classes == this.view.themeClasses)
      return;
    for (let cls of this.classes.split(" "))
      if (cls)
        this.container.classList.remove(cls);
    for (let cls of (this.classes = this.view.themeClasses).split(" "))
      if (cls)
        this.container.classList.add(cls);
  }
}
function rm(node) {
  let next = node.nextSibling;
  node.remove();
  return next;
}
const showPanel = /* @__PURE__ */ Facet.define({
  enables: panelPlugin
});
class GutterMarker extends RangeValue {
  /**
  @internal
  */
  compare(other) {
    return this == other || this.constructor == other.constructor && this.eq(other);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(other) {
    return false;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(dom) {
  }
}
GutterMarker.prototype.elementClass = "";
GutterMarker.prototype.toDOM = void 0;
GutterMarker.prototype.mapMode = MapMode.TrackBefore;
GutterMarker.prototype.startSide = GutterMarker.prototype.endSide = -1;
GutterMarker.prototype.point = true;
const gutterLineClass = /* @__PURE__ */ Facet.define();
const gutterWidgetClass = /* @__PURE__ */ Facet.define();
const defaults$1 = {
  class: "",
  renderEmptyElements: false,
  elementStyle: "",
  markers: () => RangeSet.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {},
  side: "before"
};
const activeGutters = /* @__PURE__ */ Facet.define();
function gutter(config2) {
  return [gutters(), activeGutters.of({ ...defaults$1, ...config2 })];
}
const unfixGutters = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
function gutters(config2) {
  let result2 = [
    gutterView
  ];
  return result2;
}
const gutterView = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.domAfter = null;
    this.prevViewport = view.viewport;
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutters cm-gutters-before";
    this.dom.setAttribute("aria-hidden", "true");
    this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
    this.gutters = view.state.facet(activeGutters).map((conf) => new SingleGutterView(view, conf));
    this.fixed = !view.state.facet(unfixGutters);
    for (let gutter2 of this.gutters) {
      if (gutter2.config.side == "after")
        this.getDOMAfter().appendChild(gutter2.dom);
      else
        this.dom.appendChild(gutter2.dom);
    }
    if (this.fixed) {
      this.dom.style.position = "sticky";
    }
    this.syncGutters(false);
    view.scrollDOM.insertBefore(this.dom, view.contentDOM);
  }
  getDOMAfter() {
    if (!this.domAfter) {
      this.domAfter = document.createElement("div");
      this.domAfter.className = "cm-gutters cm-gutters-after";
      this.domAfter.setAttribute("aria-hidden", "true");
      this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
      this.domAfter.style.position = this.fixed ? "sticky" : "";
      this.view.scrollDOM.appendChild(this.domAfter);
    }
    return this.domAfter;
  }
  update(update) {
    if (this.updateGutters(update)) {
      let vpA = this.prevViewport, vpB = update.view.viewport;
      let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
      this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
    }
    if (update.geometryChanged) {
      let min2 = this.view.contentHeight / this.view.scaleY + "px";
      this.dom.style.minHeight = min2;
      if (this.domAfter)
        this.domAfter.style.minHeight = min2;
    }
    if (this.view.state.facet(unfixGutters) != !this.fixed) {
      this.fixed = !this.fixed;
      this.dom.style.position = this.fixed ? "sticky" : "";
      if (this.domAfter)
        this.domAfter.style.position = this.fixed ? "sticky" : "";
    }
    this.prevViewport = update.view.viewport;
  }
  syncGutters(detach) {
    let after2 = this.dom.nextSibling;
    if (detach) {
      this.dom.remove();
      if (this.domAfter)
        this.domAfter.remove();
    }
    let lineClasses = RangeSet.iter(this.view.state.facet(gutterLineClass), this.view.viewport.from);
    let classSet = [];
    let contexts = this.gutters.map((gutter2) => new UpdateContext(gutter2, this.view.viewport, -this.view.documentPadding.top));
    for (let line2 of this.view.viewportLineBlocks) {
      if (classSet.length)
        classSet = [];
      if (Array.isArray(line2.type)) {
        let first2 = true;
        for (let b2 of line2.type) {
          if (b2.type == BlockType.Text && first2) {
            advanceCursor(lineClasses, classSet, b2.from);
            for (let cx of contexts)
              cx.line(this.view, b2, classSet);
            first2 = false;
          } else if (b2.widget) {
            for (let cx of contexts)
              cx.widget(this.view, b2);
          }
        }
      } else if (line2.type == BlockType.Text) {
        advanceCursor(lineClasses, classSet, line2.from);
        for (let cx of contexts)
          cx.line(this.view, line2, classSet);
      } else if (line2.widget) {
        for (let cx of contexts)
          cx.widget(this.view, line2);
      }
    }
    for (let cx of contexts)
      cx.finish();
    if (detach) {
      this.view.scrollDOM.insertBefore(this.dom, after2);
      if (this.domAfter)
        this.view.scrollDOM.appendChild(this.domAfter);
    }
  }
  updateGutters(update) {
    let prev = update.startState.facet(activeGutters), cur2 = update.state.facet(activeGutters);
    let change = update.docChanged || update.heightChanged || update.viewportChanged || !RangeSet.eq(update.startState.facet(gutterLineClass), update.state.facet(gutterLineClass), update.view.viewport.from, update.view.viewport.to);
    if (prev == cur2) {
      for (let gutter2 of this.gutters)
        if (gutter2.update(update))
          change = true;
    } else {
      change = true;
      let gutters2 = [];
      for (let conf of cur2) {
        let known = prev.indexOf(conf);
        if (known < 0) {
          gutters2.push(new SingleGutterView(this.view, conf));
        } else {
          this.gutters[known].update(update);
          gutters2.push(this.gutters[known]);
        }
      }
      for (let g of this.gutters) {
        g.dom.remove();
        if (gutters2.indexOf(g) < 0)
          g.destroy();
      }
      for (let g of gutters2) {
        if (g.config.side == "after")
          this.getDOMAfter().appendChild(g.dom);
        else
          this.dom.appendChild(g.dom);
      }
      this.gutters = gutters2;
    }
    return change;
  }
  destroy() {
    for (let view of this.gutters)
      view.destroy();
    this.dom.remove();
    if (this.domAfter)
      this.domAfter.remove();
  }
}, {
  provide: (plugin) => EditorView.scrollMargins.of((view) => {
    let value = view.plugin(plugin);
    if (!value || value.gutters.length == 0 || !value.fixed)
      return null;
    let before2 = value.dom.offsetWidth * view.scaleX, after2 = value.domAfter ? value.domAfter.offsetWidth * view.scaleX : 0;
    return view.textDirection == Direction.LTR ? { left: before2, right: after2 } : { right: before2, left: after2 };
  })
});
function asArray(val) {
  return Array.isArray(val) ? val : [val];
}
function advanceCursor(cursor2, collect, pos) {
  while (cursor2.value && cursor2.from <= pos) {
    if (cursor2.from == pos)
      collect.push(cursor2.value);
    cursor2.next();
  }
}
class UpdateContext {
  constructor(gutter2, viewport, height) {
    this.gutter = gutter2;
    this.height = height;
    this.i = 0;
    this.cursor = RangeSet.iter(gutter2.markers, viewport.from);
  }
  addElement(view, block, markers) {
    let { gutter: gutter2 } = this, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
    if (this.i == gutter2.elements.length) {
      let newElt = new GutterElement(view, height, above, markers);
      gutter2.elements.push(newElt);
      gutter2.dom.appendChild(newElt.dom);
    } else {
      gutter2.elements[this.i].update(view, height, above, markers);
    }
    this.height = block.bottom;
    this.i++;
  }
  line(view, line2, extraMarkers) {
    let localMarkers = [];
    advanceCursor(this.cursor, localMarkers, line2.from);
    if (extraMarkers.length)
      localMarkers = localMarkers.concat(extraMarkers);
    let forLine = this.gutter.config.lineMarker(view, line2, localMarkers);
    if (forLine)
      localMarkers.unshift(forLine);
    let gutter2 = this.gutter;
    if (localMarkers.length == 0 && !gutter2.config.renderEmptyElements)
      return;
    this.addElement(view, line2, localMarkers);
  }
  widget(view, block) {
    let marker = this.gutter.config.widgetMarker(view, block.widget, block), markers = marker ? [marker] : null;
    for (let cls of view.state.facet(gutterWidgetClass)) {
      let marker2 = cls(view, block.widget, block);
      if (marker2)
        (markers || (markers = [])).push(marker2);
    }
    if (markers)
      this.addElement(view, block, markers);
  }
  finish() {
    let gutter2 = this.gutter;
    while (gutter2.elements.length > this.i) {
      let last2 = gutter2.elements.pop();
      gutter2.dom.removeChild(last2.dom);
      last2.destroy();
    }
  }
}
class SingleGutterView {
  constructor(view, config2) {
    this.view = view;
    this.config = config2;
    this.elements = [];
    this.spacer = null;
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let prop in config2.domEventHandlers) {
      this.dom.addEventListener(prop, (event) => {
        let target = event.target, y;
        if (target != this.dom && this.dom.contains(target)) {
          while (target.parentNode != this.dom)
            target = target.parentNode;
          let rect = target.getBoundingClientRect();
          y = (rect.top + rect.bottom) / 2;
        } else {
          y = event.clientY;
        }
        let line2 = view.lineBlockAtHeight(y - view.documentTop);
        if (config2.domEventHandlers[prop](view, line2, event))
          event.preventDefault();
      });
    }
    this.markers = asArray(config2.markers(view));
    if (config2.initialSpacer) {
      this.spacer = new GutterElement(view, 0, 0, [config2.initialSpacer(view)]);
      this.dom.appendChild(this.spacer.dom);
      this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
    }
  }
  update(update) {
    let prevMarkers = this.markers;
    this.markers = asArray(this.config.markers(update.view));
    if (this.spacer && this.config.updateSpacer) {
      let updated = this.config.updateSpacer(this.spacer.markers[0], update);
      if (updated != this.spacer.markers[0])
        this.spacer.update(update.view, 0, 0, [updated]);
    }
    let vp = update.view.viewport;
    return !RangeSet.eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
  }
  destroy() {
    for (let elt of this.elements)
      elt.destroy();
  }
}
class GutterElement {
  constructor(view, height, above, markers) {
    this.height = -1;
    this.above = 0;
    this.markers = [];
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutterElement";
    this.update(view, height, above, markers);
  }
  update(view, height, above, markers) {
    if (this.height != height) {
      this.height = height;
      this.dom.style.height = height + "px";
    }
    if (this.above != above)
      this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
    if (!sameMarkers(this.markers, markers))
      this.setMarkers(view, markers);
  }
  setMarkers(view, markers) {
    let cls = "cm-gutterElement", domPos = this.dom.firstChild;
    for (let iNew = 0, iOld = 0; ; ) {
      let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
      if (marker) {
        let c2 = marker.elementClass;
        if (c2)
          cls += " " + c2;
        for (let i2 = iOld; i2 < this.markers.length; i2++)
          if (this.markers[i2].compare(marker)) {
            skipTo = i2;
            matched = true;
            break;
          }
      } else {
        skipTo = this.markers.length;
      }
      while (iOld < skipTo) {
        let next = this.markers[iOld++];
        if (next.toDOM) {
          next.destroy(domPos);
          let after2 = domPos.nextSibling;
          domPos.remove();
          domPos = after2;
        }
      }
      if (!marker)
        break;
      if (marker.toDOM) {
        if (matched)
          domPos = domPos.nextSibling;
        else
          this.dom.insertBefore(marker.toDOM(view), domPos);
      }
      if (matched)
        iOld++;
    }
    this.dom.className = cls;
    this.markers = markers;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function sameMarkers(a, b2) {
  if (a.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a.length; i2++)
    if (!a[i2].compare(b2[i2]))
      return false;
  return true;
}
const lineNumberMarkers = /* @__PURE__ */ Facet.define();
const lineNumberWidgetMarker = /* @__PURE__ */ Facet.define();
const lineNumberConfig = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return combineConfig(values2, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(a, b2) {
        let result2 = Object.assign({}, a);
        for (let event in b2) {
          let exists = result2[event], add2 = b2[event];
          result2[event] = exists ? (view, line2, event2) => exists(view, line2, event2) || add2(view, line2, event2) : add2;
        }
        return result2;
      }
    });
  }
});
class NumberMarker extends GutterMarker {
  constructor(number2) {
    super();
    this.number = number2;
  }
  eq(other) {
    return this.number == other.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function formatNumber(view, number2) {
  return view.state.facet(lineNumberConfig).formatNumber(number2, view.state);
}
const lineNumberGutter = /* @__PURE__ */ activeGutters.compute([lineNumberConfig], (state) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: false,
  markers(view) {
    return view.state.facet(lineNumberMarkers);
  },
  lineMarker(view, line2, others) {
    if (others.some((m) => m.toDOM))
      return null;
    return new NumberMarker(formatNumber(view, view.state.doc.lineAt(line2.from).number));
  },
  widgetMarker: (view, widget, block) => {
    for (let m of view.state.facet(lineNumberWidgetMarker)) {
      let result2 = m(view, widget, block);
      if (result2)
        return result2;
    }
    return null;
  },
  lineMarkerChange: (update) => update.startState.facet(lineNumberConfig) != update.state.facet(lineNumberConfig),
  initialSpacer(view) {
    return new NumberMarker(formatNumber(view, maxLineNumber(view.state.doc.lines)));
  },
  updateSpacer(spacer, update) {
    let max2 = formatNumber(update.view, maxLineNumber(update.view.state.doc.lines));
    return max2 == spacer.number ? spacer : new NumberMarker(max2);
  },
  domEventHandlers: state.facet(lineNumberConfig).domEventHandlers,
  side: "before"
}));
function lineNumbers(config2 = {}) {
  return [
    lineNumberConfig.of(config2),
    gutters(),
    lineNumberGutter
  ];
}
function maxLineNumber(lines) {
  let last2 = 9;
  while (last2 < lines)
    last2 = last2 * 10 + 9;
  return last2;
}
const activeLineGutterMarker = /* @__PURE__ */ new class extends GutterMarker {
  constructor() {
    super(...arguments);
    this.elementClass = "cm-activeLineGutter";
  }
}();
const activeLineGutterHighlighter = /* @__PURE__ */ gutterLineClass.compute(["selection"], (state) => {
  let marks = [], last2 = -1;
  for (let range2 of state.selection.ranges) {
    let linePos = state.doc.lineAt(range2.head).from;
    if (linePos > last2) {
      last2 = linePos;
      marks.push(activeLineGutterMarker.range(linePos));
    }
  }
  return RangeSet.of(marks);
});
function highlightActiveLineGutter() {
  return activeLineGutterHighlighter;
}
const DefaultBufferLength$1 = 1024;
let nextPropID$1 = 0;
let Range$2 = class Range22 {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
};
let NodeProp$1 = class NodeProp3 {
  /**
  Create a new node prop type.
  */
  constructor(config2 = {}) {
    this.id = nextPropID$1++;
    this.perNode = !!config2.perNode;
    this.deserialize = config2.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
    this.combine = config2.combine || null;
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(match2) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    if (typeof match2 != "function")
      match2 = NodeType$1.match(match2);
    return (type) => {
      let result2 = match2(type);
      return result2 === void 0 ? null : [this, result2];
    };
  }
};
NodeProp$1.closedBy = new NodeProp$1({ deserialize: (str) => str.split(" ") });
NodeProp$1.openedBy = new NodeProp$1({ deserialize: (str) => str.split(" ") });
NodeProp$1.group = new NodeProp$1({ deserialize: (str) => str.split(" ") });
NodeProp$1.isolate = new NodeProp$1({ deserialize: (value) => {
  if (value && value != "rtl" && value != "ltr" && value != "auto")
    throw new RangeError("Invalid value for isolate: " + value);
  return value || "auto";
} });
NodeProp$1.contextHash = new NodeProp$1({ perNode: true });
NodeProp$1.lookAhead = new NodeProp$1({ perNode: true });
NodeProp$1.mounted = new NodeProp$1({ perNode: true });
let MountedTree$1 = class MountedTree3 {
  constructor(tree, overlay, parser2) {
    this.tree = tree;
    this.overlay = overlay;
    this.parser = parser2;
  }
  /**
  @internal
  */
  static get(tree) {
    return tree && tree.props && tree.props[NodeProp$1.mounted.id];
  }
};
const noProps$1 = /* @__PURE__ */ Object.create(null);
let NodeType$1 = class NodeType3 {
  /**
  @internal
  */
  constructor(name2, props2, id2, flags = 0) {
    this.name = name2;
    this.props = props2;
    this.id = id2;
    this.flags = flags;
  }
  /**
  Define a node type.
  */
  static define(spec) {
    let props2 = spec.props && spec.props.length ? /* @__PURE__ */ Object.create(null) : noProps$1;
    let flags = (spec.top ? 1 : 0) | (spec.skipped ? 2 : 0) | (spec.error ? 4 : 0) | (spec.name == null ? 8 : 0);
    let type = new NodeType3(spec.name || "", props2, spec.id, flags);
    if (spec.props)
      for (let src of spec.props) {
        if (!Array.isArray(src))
          src = src(type);
        if (src) {
          if (src[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          props2[src[0].id] = src[1];
        }
      }
    return type;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(prop) {
    return this.props[prop.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(name2) {
    if (typeof name2 == "string") {
      if (this.name == name2)
        return true;
      let group2 = this.prop(NodeProp$1.group);
      return group2 ? group2.indexOf(name2) > -1 : false;
    }
    return this.id == name2;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(map2) {
    let direct = /* @__PURE__ */ Object.create(null);
    for (let prop in map2)
      for (let name2 of prop.split(" "))
        direct[name2] = map2[prop];
    return (node) => {
      for (let groups = node.prop(NodeProp$1.group), i2 = -1; i2 < (groups ? groups.length : 0); i2++) {
        let found = direct[i2 < 0 ? node.name : groups[i2]];
        if (found)
          return found;
      }
    };
  }
};
NodeType$1.none = new NodeType$1(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
const CachedNode$1 = /* @__PURE__ */ new WeakMap(), CachedInnerNode$1 = /* @__PURE__ */ new WeakMap();
var IterMode$1;
(function(IterMode2) {
  IterMode2[IterMode2["ExcludeBuffers"] = 1] = "ExcludeBuffers";
  IterMode2[IterMode2["IncludeAnonymous"] = 2] = "IncludeAnonymous";
  IterMode2[IterMode2["IgnoreMounts"] = 4] = "IgnoreMounts";
  IterMode2[IterMode2["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})(IterMode$1 || (IterMode$1 = {}));
let Tree$1 = class Tree3 {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(type, children, positions, length, props2) {
    this.type = type;
    this.children = children;
    this.positions = positions;
    this.length = length;
    this.props = null;
    if (props2 && props2.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [prop, value] of props2)
        this.props[typeof prop == "number" ? prop : prop.id] = value;
    }
  }
  /**
  @internal
  */
  toString() {
    let mounted = MountedTree$1.get(this);
    if (mounted && !mounted.overlay)
      return mounted.tree.toString();
    let children = "";
    for (let ch of this.children) {
      let str = ch.toString();
      if (str) {
        if (children)
          children += ",";
        children += str;
      }
    }
    return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(mode = 0) {
    return new TreeCursor$1(this.topNode, mode);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(pos, side = 0, mode = 0) {
    let scope = CachedNode$1.get(this) || this.topNode;
    let cursor2 = new TreeCursor$1(scope);
    cursor2.moveTo(pos, side);
    CachedNode$1.set(this, cursor2._tree);
    return cursor2;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new TreeNode$1(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(pos, side = 0) {
    let node = resolveNode$1(CachedNode$1.get(this) || this.topNode, pos, side, false);
    CachedNode$1.set(this, node);
    return node;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(pos, side = 0) {
    let node = resolveNode$1(CachedInnerNode$1.get(this) || this.topNode, pos, side, true);
    CachedInnerNode$1.set(this, node);
    return node;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(pos, side = 0) {
    return stackIterator$1(this, pos, side);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(spec) {
    let { enter, leave, from = 0, to: to2 = this.length } = spec;
    let mode = spec.mode || 0, anon = (mode & IterMode$1.IncludeAnonymous) > 0;
    for (let c2 = this.cursor(mode | IterMode$1.IncludeAnonymous); ; ) {
      let entered = false;
      if (c2.from <= to2 && c2.to >= from && (!anon && c2.type.isAnonymous || enter(c2) !== false)) {
        if (c2.firstChild())
          continue;
        entered = true;
      }
      for (; ; ) {
        if (entered && leave && (anon || !c2.type.isAnonymous))
          leave(c2);
        if (c2.nextSibling())
          break;
        if (!c2.parent())
          return;
        entered = true;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(prop) {
    return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : void 0;
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let result2 = [];
    if (this.props)
      for (let id2 in this.props)
        result2.push([+id2, this.props[id2]]);
    return result2;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(config2 = {}) {
    return this.children.length <= 8 ? this : balanceRange$1(NodeType$1.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length) => new Tree3(this.type, children, positions, length, this.propValues), config2.makeTree || ((children, positions, length) => new Tree3(NodeType$1.none, children, positions, length)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(data) {
    return buildTree$1(data);
  }
};
Tree$1.empty = new Tree$1(NodeType$1.none, [], [], 0);
let FlatBufferCursor$1 = class FlatBufferCursor3 {
  constructor(buffer, index2) {
    this.buffer = buffer;
    this.index = index2;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new FlatBufferCursor3(this.buffer, this.index);
  }
};
let TreeBuffer$1 = class TreeBuffer3 {
  /**
  Create a tree buffer.
  */
  constructor(buffer, length, set2) {
    this.buffer = buffer;
    this.length = length;
    this.set = set2;
  }
  /**
  @internal
  */
  get type() {
    return NodeType$1.none;
  }
  /**
  @internal
  */
  toString() {
    let result2 = [];
    for (let index2 = 0; index2 < this.buffer.length; ) {
      result2.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2.join(",");
  }
  /**
  @internal
  */
  childString(index2) {
    let id2 = this.buffer[index2], endIndex = this.buffer[index2 + 3];
    let type = this.set.types[id2], result2 = type.name;
    if (/\W/.test(result2) && !type.isError)
      result2 = JSON.stringify(result2);
    index2 += 4;
    if (endIndex == index2)
      return result2;
    let children = [];
    while (index2 < endIndex) {
      children.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2 + "(" + children.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(startIndex, endIndex, dir, pos, side) {
    let { buffer } = this, pick3 = -1;
    for (let i2 = startIndex; i2 != endIndex; i2 = buffer[i2 + 3]) {
      if (checkSide$1(side, pos, buffer[i2 + 1], buffer[i2 + 2])) {
        pick3 = i2;
        if (dir > 0)
          break;
      }
    }
    return pick3;
  }
  /**
  @internal
  */
  slice(startI, endI, from) {
    let b2 = this.buffer;
    let copy2 = new Uint16Array(endI - startI), len = 0;
    for (let i2 = startI, j2 = 0; i2 < endI; ) {
      copy2[j2++] = b2[i2++];
      copy2[j2++] = b2[i2++] - from;
      let to2 = copy2[j2++] = b2[i2++] - from;
      copy2[j2++] = b2[i2++] - startI;
      len = Math.max(len, to2);
    }
    return new TreeBuffer3(copy2, len, this.set);
  }
};
function checkSide$1(side, pos, from, to2) {
  switch (side) {
    case -2:
      return from < pos;
    case -1:
      return to2 >= pos && from < pos;
    case 0:
      return from < pos && to2 > pos;
    case 1:
      return from <= pos && to2 > pos;
    case 2:
      return to2 > pos;
    case 4:
      return true;
  }
}
function resolveNode$1(node, pos, side, overlays) {
  var _a2;
  while (node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)) {
    let parent = !overlays && node instanceof TreeNode$1 && node.index < 0 ? null : node.parent;
    if (!parent)
      return node;
    node = parent;
  }
  let mode = overlays ? 0 : IterMode$1.IgnoreOverlays;
  if (overlays)
    for (let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent) {
      if (scan instanceof TreeNode$1 && scan.index < 0 && ((_a2 = parent.enter(pos, side, mode)) === null || _a2 === void 0 ? void 0 : _a2.from) != scan.from)
        node = parent;
    }
  for (; ; ) {
    let inner = node.enter(pos, side, mode);
    if (!inner)
      return node;
    node = inner;
  }
}
let BaseNode$1 = class BaseNode3 {
  cursor(mode = 0) {
    return new TreeCursor$1(this, mode);
  }
  getChild(type, before2 = null, after2 = null) {
    let r = getChildren$1(this, type, before2, after2);
    return r.length ? r[0] : null;
  }
  getChildren(type, before2 = null, after2 = null) {
    return getChildren$1(this, type, before2, after2);
  }
  resolve(pos, side = 0) {
    return resolveNode$1(this, pos, side, false);
  }
  resolveInner(pos, side = 0) {
    return resolveNode$1(this, pos, side, true);
  }
  matchContext(context) {
    return matchNodeContext$1(this.parent, context);
  }
  enterUnfinishedNodesBefore(pos) {
    let scan = this.childBefore(pos), node = this;
    while (scan) {
      let last2 = scan.lastChild;
      if (!last2 || last2.to != scan.to)
        break;
      if (last2.type.isError && last2.from == last2.to) {
        node = scan;
        scan = last2.prevSibling;
      } else {
        scan = last2;
      }
    }
    return node;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
};
let TreeNode$1 = class TreeNode3 extends BaseNode$1 {
  constructor(_tree, from, index2, _parent) {
    super();
    this._tree = _tree;
    this.from = from;
    this.index = index2;
    this._parent = _parent;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(i2, dir, pos, side, mode = 0) {
    for (let parent = this; ; ) {
      for (let { children, positions } = parent._tree, e2 = dir > 0 ? children.length : -1; i2 != e2; i2 += dir) {
        let next = children[i2], start = positions[i2] + parent.from;
        if (!checkSide$1(side, pos, start, start + next.length))
          continue;
        if (next instanceof TreeBuffer$1) {
          if (mode & IterMode$1.ExcludeBuffers)
            continue;
          let index2 = next.findChild(0, next.buffer.length, dir, pos - start, side);
          if (index2 > -1)
            return new BufferNode$1(new BufferContext$1(parent, next, i2, start), null, index2);
        } else if (mode & IterMode$1.IncludeAnonymous || (!next.type.isAnonymous || hasChild$1(next))) {
          let mounted;
          if (!(mode & IterMode$1.IgnoreMounts) && (mounted = MountedTree$1.get(next)) && !mounted.overlay)
            return new TreeNode3(mounted.tree, start, i2, parent);
          let inner = new TreeNode3(next, start, i2, parent);
          return mode & IterMode$1.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
        }
      }
      if (mode & IterMode$1.IncludeAnonymous || !parent.type.isAnonymous)
        return null;
      if (parent.index >= 0)
        i2 = parent.index + dir;
      else
        i2 = dir < 0 ? -1 : parent._parent._tree.children.length;
      parent = parent._parent;
      if (!parent)
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.nextChild(
      0,
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this._tree.prop(prop);
  }
  enter(pos, side, mode = 0) {
    let mounted;
    if (!(mode & IterMode$1.IgnoreOverlays) && (mounted = MountedTree$1.get(this._tree)) && mounted.overlay) {
      let rPos = pos - this.from;
      for (let { from, to: to2 } of mounted.overlay) {
        if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to2 >= rPos : to2 > rPos))
          return new TreeNode3(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
      }
    }
    return this.nextChild(0, 1, pos, side, mode);
  }
  nextSignificantParent() {
    let val = this;
    while (val.type.isAnonymous && val._parent)
      val = val._parent;
    return val;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
};
function getChildren$1(node, type, before2, after2) {
  let cur2 = node.cursor(), result2 = [];
  if (!cur2.firstChild())
    return result2;
  if (before2 != null)
    for (let found = false; !found; ) {
      found = cur2.type.is(before2);
      if (!cur2.nextSibling())
        return result2;
    }
  for (; ; ) {
    if (after2 != null && cur2.type.is(after2))
      return result2;
    if (cur2.type.is(type))
      result2.push(cur2.node);
    if (!cur2.nextSibling())
      return after2 == null ? result2 : [];
  }
}
function matchNodeContext$1(node, context, i2 = context.length - 1) {
  for (let p = node; i2 >= 0; p = p.parent) {
    if (!p)
      return false;
    if (!p.type.isAnonymous) {
      if (context[i2] && context[i2] != p.name)
        return false;
      i2--;
    }
  }
  return true;
}
let BufferContext$1 = class BufferContext3 {
  constructor(parent, buffer, index2, start) {
    this.parent = parent;
    this.buffer = buffer;
    this.index = index2;
    this.start = start;
  }
};
let BufferNode$1 = class BufferNode3 extends BaseNode$1 {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(context, _parent, index2) {
    super();
    this.context = context;
    this._parent = _parent;
    this.index = index2;
    this.type = context.buffer.set.types[context.buffer.buffer[index2]];
  }
  child(dir, pos, side) {
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode3(this.context, this, index2);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.child(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.child(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this.type.prop(prop);
  }
  enter(pos, side, mode = 0) {
    if (mode & IterMode$1.ExcludeBuffers)
      return null;
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode3(this.context, this, index2);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(dir) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + dir,
      dir,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer } = this.context;
    let after2 = buffer.buffer[this.index + 3];
    if (after2 < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length))
      return new BufferNode3(this.context, this._parent, after2);
    return this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer } = this.context;
    let parentStart = this._parent ? this._parent.index + 4 : 0;
    if (this.index == parentStart)
      return this.externalSibling(-1);
    return new BufferNode3(this.context, this._parent, buffer.findChild(
      parentStart,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let children = [], positions = [];
    let { buffer } = this.context;
    let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
    if (endI > startI) {
      let from = buffer.buffer[this.index + 1];
      children.push(buffer.slice(startI, endI, from));
      positions.push(0);
    }
    return new Tree$1(this.type, children, positions, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
};
function iterStack$1(heads) {
  if (!heads.length)
    return null;
  let pick3 = 0, picked = heads[0];
  for (let i2 = 1; i2 < heads.length; i2++) {
    let node = heads[i2];
    if (node.from > picked.from || node.to < picked.to) {
      picked = node;
      pick3 = i2;
    }
  }
  let next = picked instanceof TreeNode$1 && picked.index < 0 ? null : picked.parent;
  let newHeads = heads.slice();
  if (next)
    newHeads[pick3] = next;
  else
    newHeads.splice(pick3, 1);
  return new StackIterator$1(newHeads, picked);
}
let StackIterator$1 = class StackIterator3 {
  constructor(heads, node) {
    this.heads = heads;
    this.node = node;
  }
  get next() {
    return iterStack$1(this.heads);
  }
};
function stackIterator$1(tree, pos, side) {
  let inner = tree.resolveInner(pos, side), layers = null;
  for (let scan = inner instanceof TreeNode$1 ? inner : inner.context.parent; scan; scan = scan.parent) {
    if (scan.index < 0) {
      let parent = scan.parent;
      (layers || (layers = [inner])).push(parent.resolve(pos, side));
      scan = parent;
    } else {
      let mount = MountedTree$1.get(scan.tree);
      if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
        let root2 = new TreeNode$1(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
        (layers || (layers = [inner])).push(resolveNode$1(root2, pos, side, false));
      }
    }
  }
  return layers ? iterStack$1(layers) : inner;
}
let TreeCursor$1 = class TreeCursor3 {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(node, mode = 0) {
    this.mode = mode;
    this.buffer = null;
    this.stack = [];
    this.index = 0;
    this.bufferNode = null;
    if (node instanceof TreeNode$1) {
      this.yieldNode(node);
    } else {
      this._tree = node.context.parent;
      this.buffer = node.context;
      for (let n = node._parent; n; n = n._parent)
        this.stack.unshift(n.index);
      this.bufferNode = node;
      this.yieldBuf(node.index);
    }
  }
  yieldNode(node) {
    if (!node)
      return false;
    this._tree = node;
    this.type = node.type;
    this.from = node.from;
    this.to = node.to;
    return true;
  }
  yieldBuf(index2, type) {
    this.index = index2;
    let { start, buffer } = this.buffer;
    this.type = type || buffer.set.types[buffer.buffer[index2]];
    this.from = start + buffer.buffer[index2 + 1];
    this.to = start + buffer.buffer[index2 + 2];
    return true;
  }
  /**
  @internal
  */
  yield(node) {
    if (!node)
      return false;
    if (node instanceof TreeNode$1) {
      this.buffer = null;
      return this.yieldNode(node);
    }
    this.buffer = node.context;
    return this.yieldBuf(node.index, node.type);
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(dir, pos, side) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
    let { buffer } = this.buffer;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
    if (index2 < 0)
      return false;
    this.stack.push(this.index);
    return this.yieldBuf(index2);
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(pos) {
    return this.enterChild(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(pos) {
    return this.enterChild(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(pos, side, mode = this.mode) {
    if (!this.buffer)
      return this.yield(this._tree.enter(pos, side, mode));
    return mode & IterMode$1.ExcludeBuffers ? false : this.enterChild(1, pos, side);
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & IterMode$1.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let parent = this.mode & IterMode$1.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    this.buffer = null;
    return this.yieldNode(parent);
  }
  /**
  @internal
  */
  sibling(dir) {
    if (!this.buffer)
      return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4, this.mode));
    let { buffer } = this.buffer, d = this.stack.length - 1;
    if (dir < 0) {
      let parentStart = d < 0 ? 0 : this.stack[d] + 4;
      if (this.index != parentStart)
        return this.yieldBuf(buffer.findChild(
          parentStart,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let after2 = buffer.buffer[this.index + 3];
      if (after2 < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3]))
        return this.yieldBuf(after2);
    }
    return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4, this.mode)) : false;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(dir) {
    let index2, parent, { buffer } = this;
    if (buffer) {
      if (dir > 0) {
        if (this.index < buffer.buffer.buffer.length)
          return false;
      } else {
        for (let i2 = 0; i2 < this.index; i2++)
          if (buffer.buffer.buffer[i2 + 3] < this.index)
            return false;
      }
      ({ index: index2, parent } = buffer);
    } else {
      ({ index: index2, _parent: parent } = this._tree);
    }
    for (; parent; { index: index2, _parent: parent } = parent) {
      if (index2 > -1)
        for (let i2 = index2 + dir, e2 = dir < 0 ? -1 : parent._tree.children.length; i2 != e2; i2 += dir) {
          let child = parent._tree.children[i2];
          if (this.mode & IterMode$1.IncludeAnonymous || child instanceof TreeBuffer$1 || !child.type.isAnonymous || hasChild$1(child))
            return false;
        }
    }
    return true;
  }
  move(dir, enter) {
    if (enter && this.enterChild(
      dir,
      0,
      4
      /* Side.DontCare */
    ))
      return true;
    for (; ; ) {
      if (this.sibling(dir))
        return true;
      if (this.atLastNode(dir) || !this.parent())
        return false;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(enter = true) {
    return this.move(1, enter);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(enter = true) {
    return this.move(-1, enter);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(pos, side = 0) {
    while (this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))
      if (!this.parent())
        break;
    while (this.enterChild(1, pos, side)) {
    }
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let cache = this.bufferNode, result2 = null, depth = 0;
    if (cache && cache.context == this.buffer) {
      scan: for (let index2 = this.index, d = this.stack.length; d >= 0; ) {
        for (let c2 = cache; c2; c2 = c2._parent)
          if (c2.index == index2) {
            if (index2 == this.index)
              return c2;
            result2 = c2;
            depth = d + 1;
            break scan;
          }
        index2 = this.stack[--d];
      }
    }
    for (let i2 = depth; i2 < this.stack.length; i2++)
      result2 = new BufferNode$1(this.buffer, result2, this.stack[i2]);
    return this.bufferNode = new BufferNode$1(this.buffer, result2, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(enter, leave) {
    for (let depth = 0; ; ) {
      let mustLeave = false;
      if (this.type.isAnonymous || enter(this) !== false) {
        if (this.firstChild()) {
          depth++;
          continue;
        }
        if (!this.type.isAnonymous)
          mustLeave = true;
      }
      for (; ; ) {
        if (mustLeave && leave)
          leave(this);
        mustLeave = this.type.isAnonymous;
        if (!depth)
          return;
        if (this.nextSibling())
          break;
        this.parent();
        depth--;
        mustLeave = true;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(context) {
    if (!this.buffer)
      return matchNodeContext$1(this.node.parent, context);
    let { buffer } = this.buffer, { types: types2 } = buffer.set;
    for (let i2 = context.length - 1, d = this.stack.length - 1; i2 >= 0; d--) {
      if (d < 0)
        return matchNodeContext$1(this._tree, context, i2);
      let type = types2[buffer.buffer[this.stack[d]]];
      if (!type.isAnonymous) {
        if (context[i2] && context[i2] != type.name)
          return false;
        i2--;
      }
    }
    return true;
  }
};
function hasChild$1(tree) {
  return tree.children.some((ch) => ch instanceof TreeBuffer$1 || !ch.type.isAnonymous || hasChild$1(ch));
}
function buildTree$1(data) {
  var _a2;
  let { buffer, nodeSet, maxBufferLength = DefaultBufferLength$1, reused = [], minRepeatType = nodeSet.types.length } = data;
  let cursor2 = Array.isArray(buffer) ? new FlatBufferCursor$1(buffer, buffer.length) : buffer;
  let types2 = nodeSet.types;
  let contextHash = 0, lookAhead = 0;
  function takeNode(parentStart, minPos, children2, positions2, inRepeat, depth) {
    let { id: id2, start, end, size: size2 } = cursor2;
    let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
    if (size2 < 0) {
      cursor2.next();
      if (size2 == -1) {
        let node2 = reused[id2];
        children2.push(node2);
        positions2.push(start - parentStart);
        return;
      } else if (size2 == -3) {
        contextHash = id2;
        return;
      } else if (size2 == -4) {
        lookAhead = id2;
        return;
      } else {
        throw new RangeError(`Unrecognized record size: ${size2}`);
      }
    }
    let type = types2[id2], node, buffer2;
    let startPos = start - parentStart;
    if (end - start <= maxBufferLength && (buffer2 = findBufferSize(cursor2.pos - minPos, inRepeat))) {
      let data2 = new Uint16Array(buffer2.size - buffer2.skip);
      let endPos = cursor2.pos - buffer2.size, index2 = data2.length;
      while (cursor2.pos > endPos)
        index2 = copyToBuffer(buffer2.start, data2, index2);
      node = new TreeBuffer$1(data2, end - buffer2.start, nodeSet);
      startPos = buffer2.start - parentStart;
    } else {
      let endPos = cursor2.pos - size2;
      cursor2.next();
      let localChildren = [], localPositions = [];
      let localInRepeat = id2 >= minRepeatType ? id2 : -1;
      let lastGroup = 0, lastEnd = end;
      while (cursor2.pos > endPos) {
        if (localInRepeat >= 0 && cursor2.id == localInRepeat && cursor2.size >= 0) {
          if (cursor2.end <= lastEnd - maxBufferLength) {
            makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor2.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            lastGroup = localChildren.length;
            lastEnd = cursor2.end;
          }
          cursor2.next();
        } else if (depth > 2500) {
          takeFlatNode(start, endPos, localChildren, localPositions);
        } else {
          takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
        }
      }
      if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length)
        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
      localChildren.reverse();
      localPositions.reverse();
      if (localInRepeat > -1 && lastGroup > 0) {
        let make = makeBalanced(type, contextAtStart);
        node = balanceRange$1(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
      } else {
        node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
      }
    }
    children2.push(node);
    positions2.push(startPos);
  }
  function takeFlatNode(parentStart, minPos, children2, positions2) {
    let nodes = [];
    let nodeCount = 0, stopAt = -1;
    while (cursor2.pos > minPos) {
      let { id: id2, start, end, size: size2 } = cursor2;
      if (size2 > 4) {
        cursor2.next();
      } else if (stopAt > -1 && start < stopAt) {
        break;
      } else {
        if (stopAt < 0)
          stopAt = end - maxBufferLength;
        nodes.push(id2, start, end);
        nodeCount++;
        cursor2.next();
      }
    }
    if (nodeCount) {
      let buffer2 = new Uint16Array(nodeCount * 4);
      let start = nodes[nodes.length - 2];
      for (let i2 = nodes.length - 3, j2 = 0; i2 >= 0; i2 -= 3) {
        buffer2[j2++] = nodes[i2];
        buffer2[j2++] = nodes[i2 + 1] - start;
        buffer2[j2++] = nodes[i2 + 2] - start;
        buffer2[j2++] = j2;
      }
      children2.push(new TreeBuffer$1(buffer2, nodes[2] - start, nodeSet));
      positions2.push(start - parentStart);
    }
  }
  function makeBalanced(type, contextHash2) {
    return (children2, positions2, length2) => {
      let lookAhead2 = 0, lastI = children2.length - 1, last2, lookAheadProp;
      if (lastI >= 0 && (last2 = children2[lastI]) instanceof Tree$1) {
        if (!lastI && last2.type == type && last2.length == length2)
          return last2;
        if (lookAheadProp = last2.prop(NodeProp$1.lookAhead))
          lookAhead2 = positions2[lastI] + last2.length + lookAheadProp;
      }
      return makeTree(type, children2, positions2, length2, lookAhead2, contextHash2);
    };
  }
  function makeRepeatLeaf(children2, positions2, base2, i2, from, to2, type, lookAhead2, contextHash2) {
    let localChildren = [], localPositions = [];
    while (children2.length > i2) {
      localChildren.push(children2.pop());
      localPositions.push(positions2.pop() + base2 - from);
    }
    children2.push(makeTree(nodeSet.types[type], localChildren, localPositions, to2 - from, lookAhead2 - to2, contextHash2));
    positions2.push(from - base2);
  }
  function makeTree(type, children2, positions2, length2, lookAhead2, contextHash2, props2) {
    if (contextHash2) {
      let pair2 = [NodeProp$1.contextHash, contextHash2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    if (lookAhead2 > 25) {
      let pair2 = [NodeProp$1.lookAhead, lookAhead2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    return new Tree$1(type, children2, positions2, length2, props2);
  }
  function findBufferSize(maxSize, inRepeat) {
    let fork = cursor2.fork();
    let size2 = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
    let result2 = { size: 0, start: 0, skip: 0 };
    scan: for (let minPos = fork.pos - maxSize; fork.pos > minPos; ) {
      let nodeSize2 = fork.size;
      if (fork.id == inRepeat && nodeSize2 >= 0) {
        result2.size = size2;
        result2.start = start;
        result2.skip = skip;
        skip += 4;
        size2 += 4;
        fork.next();
        continue;
      }
      let startPos = fork.pos - nodeSize2;
      if (nodeSize2 < 0 || startPos < minPos || fork.start < minStart)
        break;
      let localSkipped = fork.id >= minRepeatType ? 4 : 0;
      let nodeStart2 = fork.start;
      fork.next();
      while (fork.pos > startPos) {
        if (fork.size < 0) {
          if (fork.size == -3 || fork.size == -4)
            localSkipped += 4;
          else
            break scan;
        } else if (fork.id >= minRepeatType) {
          localSkipped += 4;
        }
        fork.next();
      }
      start = nodeStart2;
      size2 += nodeSize2;
      skip += localSkipped;
    }
    if (inRepeat < 0 || size2 == maxSize) {
      result2.size = size2;
      result2.start = start;
      result2.skip = skip;
    }
    return result2.size > 4 ? result2 : void 0;
  }
  function copyToBuffer(bufferStart, buffer2, index2) {
    let { id: id2, start, end, size: size2 } = cursor2;
    cursor2.next();
    if (size2 >= 0 && id2 < minRepeatType) {
      let startIndex = index2;
      if (size2 > 4) {
        let endPos = cursor2.pos - (size2 - 4);
        while (cursor2.pos > endPos)
          index2 = copyToBuffer(bufferStart, buffer2, index2);
      }
      buffer2[--index2] = startIndex;
      buffer2[--index2] = end - bufferStart;
      buffer2[--index2] = start - bufferStart;
      buffer2[--index2] = id2;
    } else if (size2 == -3) {
      contextHash = id2;
    } else if (size2 == -4) {
      lookAhead = id2;
    }
    return index2;
  }
  let children = [], positions = [];
  while (cursor2.pos > 0)
    takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
  let length = (_a2 = data.length) !== null && _a2 !== void 0 ? _a2 : children.length ? positions[0] + children[0].length : 0;
  return new Tree$1(types2[data.topID], children.reverse(), positions.reverse(), length);
}
const nodeSizeCache$1 = /* @__PURE__ */ new WeakMap();
function nodeSize$1(balanceType, node) {
  if (!balanceType.isAnonymous || node instanceof TreeBuffer$1 || node.type != balanceType)
    return 1;
  let size2 = nodeSizeCache$1.get(node);
  if (size2 == null) {
    size2 = 1;
    for (let child of node.children) {
      if (child.type != balanceType || !(child instanceof Tree$1)) {
        size2 = 1;
        break;
      }
      size2 += nodeSize$1(balanceType, child);
    }
    nodeSizeCache$1.set(node, size2);
  }
  return size2;
}
function balanceRange$1(balanceType, children, positions, from, to2, start, length, mkTop, mkTree) {
  let total = 0;
  for (let i2 = from; i2 < to2; i2++)
    total += nodeSize$1(balanceType, children[i2]);
  let maxChild = Math.ceil(
    total * 1.5 / 8
    /* Balance.BranchFactor */
  );
  let localChildren = [], localPositions = [];
  function divide2(children2, positions2, from2, to22, offset2) {
    for (let i2 = from2; i2 < to22; ) {
      let groupFrom = i2, groupStart = positions2[i2], groupSize = nodeSize$1(balanceType, children2[i2]);
      i2++;
      for (; i2 < to22; i2++) {
        let nextSize = nodeSize$1(balanceType, children2[i2]);
        if (groupSize + nextSize >= maxChild)
          break;
        groupSize += nextSize;
      }
      if (i2 == groupFrom + 1) {
        if (groupSize > maxChild) {
          let only = children2[groupFrom];
          divide2(only.children, only.positions, 0, only.children.length, positions2[groupFrom] + offset2);
          continue;
        }
        localChildren.push(children2[groupFrom]);
      } else {
        let length2 = positions2[i2 - 1] + children2[i2 - 1].length - groupStart;
        localChildren.push(balanceRange$1(balanceType, children2, positions2, groupFrom, i2, groupStart, length2, null, mkTree));
      }
      localPositions.push(groupStart + offset2 - start);
    }
  }
  divide2(children, positions, from, to2, 0);
  return (mkTop || mkTree)(localChildren, localPositions, length);
}
class TreeFragment {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(from, to2, tree, offset2, openStart = false, openEnd = false) {
    this.from = from;
    this.to = to2;
    this.tree = tree;
    this.offset = offset2;
    this.open = (openStart ? 1 : 0) | (openEnd ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(tree, fragments = [], partial2 = false) {
    let result2 = [new TreeFragment(0, tree.length, tree, 0, false, partial2)];
    for (let f2 of fragments)
      if (f2.to > tree.length)
        result2.push(f2);
    return result2;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(fragments, changes, minGap = 128) {
    if (!changes.length)
      return fragments;
    let result2 = [];
    let fI = 1, nextF = fragments.length ? fragments[0] : null;
    for (let cI = 0, pos = 0, off2 = 0; ; cI++) {
      let nextC = cI < changes.length ? changes[cI] : null;
      let nextPos = nextC ? nextC.fromA : 1e9;
      if (nextPos - pos >= minGap)
        while (nextF && nextF.from < nextPos) {
          let cut = nextF;
          if (pos >= cut.from || nextPos <= cut.to || off2) {
            let fFrom = Math.max(cut.from, pos) - off2, fTo = Math.min(cut.to, nextPos) - off2;
            cut = fFrom >= fTo ? null : new TreeFragment(fFrom, fTo, cut.tree, cut.offset + off2, cI > 0, !!nextC);
          }
          if (cut)
            result2.push(cut);
          if (nextF.to > nextPos)
            break;
          nextF = fI < fragments.length ? fragments[fI++] : null;
        }
      if (!nextC)
        break;
      pos = nextC.toA;
      off2 = nextC.toA - nextC.toB;
    }
    return result2;
  }
}
let Parser$1 = class Parser3 {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(input, fragments, ranges) {
    if (typeof input == "string")
      input = new StringInput$1(input);
    ranges = !ranges ? [new Range$2(0, input.length)] : ranges.length ? ranges.map((r) => new Range$2(r.from, r.to)) : [new Range$2(0, 0)];
    return this.createParse(input, fragments || [], ranges);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(input, fragments, ranges) {
    let parse2 = this.startParse(input, fragments, ranges);
    for (; ; ) {
      let done = parse2.advance();
      if (done)
        return done;
    }
  }
};
let StringInput$1 = class StringInput3 {
  constructor(string2) {
    this.string = string2;
  }
  get length() {
    return this.string.length;
  }
  chunk(from) {
    return this.string.slice(from);
  }
  get lineChunks() {
    return false;
  }
  read(from, to2) {
    return this.string.slice(from, to2);
  }
};
new NodeProp$1({ perNode: true });
let nextTagID = 0;
class Tag {
  /**
  @internal
  */
  constructor(name2, set2, base2, modified) {
    this.name = name2;
    this.set = set2;
    this.base = base2;
    this.modified = modified;
    this.id = nextTagID++;
  }
  toString() {
    let { name: name2 } = this;
    for (let mod2 of this.modified)
      if (mod2.name)
        name2 = `${mod2.name}(${name2})`;
    return name2;
  }
  static define(nameOrParent, parent) {
    let name2 = typeof nameOrParent == "string" ? nameOrParent : "?";
    if (nameOrParent instanceof Tag)
      parent = nameOrParent;
    if (parent === null || parent === void 0 ? void 0 : parent.base)
      throw new Error("Can not derive from a modified tag");
    let tag2 = new Tag(name2, [], null, []);
    tag2.set.push(tag2);
    if (parent)
      for (let t2 of parent.set)
        tag2.set.push(t2);
    return tag2;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier(name2) {
    let mod2 = new Modifier(name2);
    return (tag2) => {
      if (tag2.modified.indexOf(mod2) > -1)
        return tag2;
      return Modifier.get(tag2.base || tag2, tag2.modified.concat(mod2).sort((a, b2) => a.id - b2.id));
    };
  }
}
let nextModifierID = 0;
class Modifier {
  constructor(name2) {
    this.name = name2;
    this.instances = [];
    this.id = nextModifierID++;
  }
  static get(base2, mods) {
    if (!mods.length)
      return base2;
    let exists = mods[0].instances.find((t2) => t2.base == base2 && sameArray(mods, t2.modified));
    if (exists)
      return exists;
    let set2 = [], tag2 = new Tag(base2.name, set2, base2, mods);
    for (let m of mods)
      m.instances.push(tag2);
    let configs = powerSet(mods);
    for (let parent of base2.set)
      if (!parent.modified.length)
        for (let config2 of configs)
          set2.push(Modifier.get(parent, config2));
    return tag2;
  }
}
function sameArray(a, b2) {
  return a.length == b2.length && a.every((x2, i2) => x2 == b2[i2]);
}
function powerSet(array) {
  let sets2 = [[]];
  for (let i2 = 0; i2 < array.length; i2++) {
    for (let j2 = 0, e2 = sets2.length; j2 < e2; j2++) {
      sets2.push(sets2[j2].concat(array[i2]));
    }
  }
  return sets2.sort((a, b2) => b2.length - a.length);
}
function styleTags(spec) {
  let byName = /* @__PURE__ */ Object.create(null);
  for (let prop in spec) {
    let tags2 = spec[prop];
    if (!Array.isArray(tags2))
      tags2 = [tags2];
    for (let part of prop.split(" "))
      if (part) {
        let pieces = [], mode = 2, rest2 = part;
        for (let pos = 0; ; ) {
          if (rest2 == "..." && pos > 0 && pos + 3 == part.length) {
            mode = 1;
            break;
          }
          let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest2);
          if (!m)
            throw new RangeError("Invalid path: " + part);
          pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
          pos += m[0].length;
          if (pos == part.length)
            break;
          let next = part[pos++];
          if (pos == part.length && next == "!") {
            mode = 0;
            break;
          }
          if (next != "/")
            throw new RangeError("Invalid path: " + part);
          rest2 = part.slice(pos);
        }
        let last2 = pieces.length - 1, inner = pieces[last2];
        if (!inner)
          throw new RangeError("Invalid path: " + part);
        let rule = new Rule(tags2, mode, last2 > 0 ? pieces.slice(0, last2) : null);
        byName[inner] = rule.sort(byName[inner]);
      }
  }
  return ruleNodeProp.add(byName);
}
const ruleNodeProp = new NodeProp$1({
  combine(a, b2) {
    let cur2, root2, take;
    while (a || b2) {
      if (!a || b2 && a.depth >= b2.depth) {
        take = b2;
        b2 = b2.next;
      } else {
        take = a;
        a = a.next;
      }
      if (cur2 && cur2.mode == take.mode && !take.context && !cur2.context)
        continue;
      let copy2 = new Rule(take.tags, take.mode, take.context);
      if (cur2)
        cur2.next = copy2;
      else
        root2 = copy2;
      cur2 = copy2;
    }
    return root2;
  }
});
class Rule {
  constructor(tags2, mode, context, next) {
    this.tags = tags2;
    this.mode = mode;
    this.context = context;
    this.next = next;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(other) {
    if (!other || other.depth < this.depth) {
      this.next = other;
      return this;
    }
    other.next = this.sort(other.next);
    return other;
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
Rule.empty = new Rule([], 2, null);
function tagHighlighter(tags2, options2) {
  let map2 = /* @__PURE__ */ Object.create(null);
  for (let style of tags2) {
    if (!Array.isArray(style.tag))
      map2[style.tag.id] = style.class;
    else
      for (let tag2 of style.tag)
        map2[tag2.id] = style.class;
  }
  let { scope, all: all2 = null } = options2 || {};
  return {
    style: (tags3) => {
      let cls = all2;
      for (let tag2 of tags3) {
        for (let sub2 of tag2.set) {
          let tagClass = map2[sub2.id];
          if (tagClass) {
            cls = cls ? cls + " " + tagClass : tagClass;
            break;
          }
        }
      }
      return cls;
    },
    scope
  };
}
function highlightTags(highlighters, tags2) {
  let result2 = null;
  for (let highlighter of highlighters) {
    let value = highlighter.style(tags2);
    if (value)
      result2 = result2 ? result2 + " " + value : value;
  }
  return result2;
}
function highlightTree(tree, highlighter, putStyle, from = 0, to2 = tree.length) {
  let builder = new HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [highlighter], putStyle);
  builder.highlightRange(tree.cursor(), from, to2, "", builder.highlighters);
  builder.flush(to2);
}
class HighlightBuilder {
  constructor(at2, highlighters, span) {
    this.at = at2;
    this.highlighters = highlighters;
    this.span = span;
    this.class = "";
  }
  startSpan(at2, cls) {
    if (cls != this.class) {
      this.flush(at2);
      if (at2 > this.at)
        this.at = at2;
      this.class = cls;
    }
  }
  flush(to2) {
    if (to2 > this.at && this.class)
      this.span(this.at, to2, this.class);
  }
  highlightRange(cursor2, from, to2, inheritedClass, highlighters) {
    let { type, from: start, to: end } = cursor2;
    if (start >= to2 || end <= from)
      return;
    if (type.isTop)
      highlighters = this.highlighters.filter((h) => !h.scope || h.scope(type));
    let cls = inheritedClass;
    let rule = getStyleTags(cursor2) || Rule.empty;
    let tagCls = highlightTags(highlighters, rule.tags);
    if (tagCls) {
      if (cls)
        cls += " ";
      cls += tagCls;
      if (rule.mode == 1)
        inheritedClass += (inheritedClass ? " " : "") + tagCls;
    }
    this.startSpan(Math.max(from, start), cls);
    if (rule.opaque)
      return;
    let mounted = cursor2.tree && cursor2.tree.prop(NodeProp$1.mounted);
    if (mounted && mounted.overlay) {
      let inner = cursor2.node.enter(mounted.overlay[0].from + start, 1);
      let innerHighlighters = this.highlighters.filter((h) => !h.scope || h.scope(mounted.tree.type));
      let hasChild2 = cursor2.firstChild();
      for (let i2 = 0, pos = start; ; i2++) {
        let next = i2 < mounted.overlay.length ? mounted.overlay[i2] : null;
        let nextPos = next ? next.from + start : end;
        let rangeFrom2 = Math.max(from, pos), rangeTo2 = Math.min(to2, nextPos);
        if (rangeFrom2 < rangeTo2 && hasChild2) {
          while (cursor2.from < rangeTo2) {
            this.highlightRange(cursor2, rangeFrom2, rangeTo2, inheritedClass, highlighters);
            this.startSpan(Math.min(rangeTo2, cursor2.to), cls);
            if (cursor2.to >= nextPos || !cursor2.nextSibling())
              break;
          }
        }
        if (!next || nextPos > to2)
          break;
        pos = next.to + start;
        if (pos > from) {
          this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to2, pos), "", innerHighlighters);
          this.startSpan(Math.min(to2, pos), cls);
        }
      }
      if (hasChild2)
        cursor2.parent();
    } else if (cursor2.firstChild()) {
      if (mounted)
        inheritedClass = "";
      do {
        if (cursor2.to <= from)
          continue;
        if (cursor2.from >= to2)
          break;
        this.highlightRange(cursor2, from, to2, inheritedClass, highlighters);
        this.startSpan(Math.min(to2, cursor2.to), cls);
      } while (cursor2.nextSibling());
      cursor2.parent();
    }
  }
}
function getStyleTags(node) {
  let rule = node.type.prop(ruleNodeProp);
  while (rule && rule.context && !node.matchContext(rule.context))
    rule = rule.next;
  return rule || null;
}
const t = Tag.define;
const comment = t(), name = t(), typeName = t(name), propertyName = t(name), literal = t(), string$2 = t(literal), number = t(literal), content$2 = t(), heading = t(content$2), keyword = t(), operator = t(), punctuation = t(), bracket = t(punctuation), meta = t();
const tags = {
  /**
  A comment.
  */
  comment,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: t(comment),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: t(comment),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: t(comment),
  /**
  Any kind of identifier.
  */
  name,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: t(name),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: t(typeName),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: t(propertyName),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: t(name),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: t(name),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: t(name),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: t(name),
  /**
  A literal value.
  */
  literal,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: string$2,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: t(string$2),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: t(string$2),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: t(string$2),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: t(number),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: t(number),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: t(literal),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: t(literal),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: t(literal),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: t(literal),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: t(literal),
  /**
  A language keyword.
  */
  keyword,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: t(keyword),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: t(keyword),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: t(keyword),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: t(keyword),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: t(keyword),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: t(keyword),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: t(keyword),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: t(keyword),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: t(keyword),
  /**
  An operator.
  */
  operator,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: t(operator),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: t(operator),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: t(operator),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: t(operator),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: t(operator),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: t(operator),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: t(operator),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: t(operator),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: t(operator),
  /**
  Program or markup punctuation.
  */
  punctuation,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: t(punctuation),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: t(bracket),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: t(bracket),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: t(bracket),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: t(bracket),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: content$2,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: t(heading),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: t(heading),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: t(heading),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: t(heading),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: t(heading),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: t(heading),
  /**
  A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
  */
  contentSeparator: t(content$2),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: t(content$2),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: t(content$2),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: t(content$2),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: t(content$2),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: t(content$2),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: t(content$2),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: t(content$2),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: t(),
  /**
  Deleted text.
  */
  deleted: t(),
  /**
  Changed text.
  */
  changed: t(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: t(),
  /**
  Metadata or meta-instruction.
  */
  meta,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: t(meta),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: t(meta),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: t(meta),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: Tag.defineModifier("definition"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: Tag.defineModifier("constant"),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: Tag.defineModifier("function"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: Tag.defineModifier("standard"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: Tag.defineModifier("local"),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: Tag.defineModifier("special")
};
for (let name2 in tags) {
  let val = tags[name2];
  if (val instanceof Tag)
    val.name = name2;
}
tagHighlighter([
  { tag: tags.link, class: "tok-link" },
  { tag: tags.heading, class: "tok-heading" },
  { tag: tags.emphasis, class: "tok-emphasis" },
  { tag: tags.strong, class: "tok-strong" },
  { tag: tags.keyword, class: "tok-keyword" },
  { tag: tags.atom, class: "tok-atom" },
  { tag: tags.bool, class: "tok-bool" },
  { tag: tags.url, class: "tok-url" },
  { tag: tags.labelName, class: "tok-labelName" },
  { tag: tags.inserted, class: "tok-inserted" },
  { tag: tags.deleted, class: "tok-deleted" },
  { tag: tags.literal, class: "tok-literal" },
  { tag: tags.string, class: "tok-string" },
  { tag: tags.number, class: "tok-number" },
  { tag: [tags.regexp, tags.escape, tags.special(tags.string)], class: "tok-string2" },
  { tag: tags.variableName, class: "tok-variableName" },
  { tag: tags.local(tags.variableName), class: "tok-variableName tok-local" },
  { tag: tags.definition(tags.variableName), class: "tok-variableName tok-definition" },
  { tag: tags.special(tags.variableName), class: "tok-variableName2" },
  { tag: tags.definition(tags.propertyName), class: "tok-propertyName tok-definition" },
  { tag: tags.typeName, class: "tok-typeName" },
  { tag: tags.namespace, class: "tok-namespace" },
  { tag: tags.className, class: "tok-className" },
  { tag: tags.macroName, class: "tok-macroName" },
  { tag: tags.propertyName, class: "tok-propertyName" },
  { tag: tags.operator, class: "tok-operator" },
  { tag: tags.comment, class: "tok-comment" },
  { tag: tags.meta, class: "tok-meta" },
  { tag: tags.invalid, class: "tok-invalid" },
  { tag: tags.punctuation, class: "tok-punctuation" }
]);
var _a$1;
const languageDataProp = /* @__PURE__ */ new NodeProp$1();
function defineLanguageFacet(baseData) {
  return Facet.define({
    combine: baseData ? (values2) => values2.concat(baseData) : void 0
  });
}
const sublanguageProp = /* @__PURE__ */ new NodeProp$1();
class Language {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(data, parser2, extraExtensions = [], name2 = "") {
    this.data = data;
    this.name = name2;
    if (!EditorState.prototype.hasOwnProperty("tree"))
      Object.defineProperty(EditorState.prototype, "tree", { get() {
        return syntaxTree(this);
      } });
    this.parser = parser2;
    this.extension = [
      language.of(this),
      EditorState.languageData.of((state, pos, side) => {
        let top2 = topNodeAt(state, pos, side), data2 = top2.type.prop(languageDataProp);
        if (!data2)
          return [];
        let base2 = state.facet(data2), sub2 = top2.type.prop(sublanguageProp);
        if (sub2) {
          let innerNode = top2.resolve(pos - top2.from, side);
          for (let sublang of sub2)
            if (sublang.test(innerNode, state)) {
              let data3 = state.facet(sublang.facet);
              return sublang.type == "replace" ? data3 : data3.concat(base2);
            }
        }
        return base2;
      })
    ].concat(extraExtensions);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(state, pos, side = -1) {
    return topNodeAt(state, pos, side).type.prop(languageDataProp) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(state) {
    let lang = state.facet(language);
    if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data)
      return [{ from: 0, to: state.doc.length }];
    if (!lang || !lang.allowsNesting)
      return [];
    let result2 = [];
    let explore = (tree, from) => {
      if (tree.prop(languageDataProp) == this.data) {
        result2.push({ from, to: from + tree.length });
        return;
      }
      let mount = tree.prop(NodeProp$1.mounted);
      if (mount) {
        if (mount.tree.prop(languageDataProp) == this.data) {
          if (mount.overlay)
            for (let r of mount.overlay)
              result2.push({ from: r.from + from, to: r.to + from });
          else
            result2.push({ from, to: from + tree.length });
          return;
        } else if (mount.overlay) {
          let size2 = result2.length;
          explore(mount.tree, mount.overlay[0].from + from);
          if (result2.length > size2)
            return;
        }
      }
      for (let i2 = 0; i2 < tree.children.length; i2++) {
        let ch = tree.children[i2];
        if (ch instanceof Tree$1)
          explore(ch, tree.positions[i2] + from);
      }
    };
    explore(syntaxTree(state), 0);
    return result2;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return true;
  }
}
Language.setState = /* @__PURE__ */ StateEffect.define();
function topNodeAt(state, pos, side) {
  let topLang = state.facet(language), tree = syntaxTree(state).topNode;
  if (!topLang || topLang.allowsNesting) {
    for (let node = tree; node; node = node.enter(pos, side, IterMode$1.ExcludeBuffers))
      if (node.type.isTop)
        tree = node;
  }
  return tree;
}
class LRLanguage extends Language {
  constructor(data, parser2, name2) {
    super(data, parser2, [], name2);
    this.parser = parser2;
  }
  /**
  Define a language from a parser.
  */
  static define(spec) {
    let data = defineLanguageFacet(spec.languageData);
    return new LRLanguage(data, spec.parser.configure({
      props: [languageDataProp.add((type) => type.isTop ? data : void 0)]
    }), spec.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(options2, name2) {
    return new LRLanguage(this.data, this.parser.configure(options2), name2 || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function syntaxTree(state) {
  let field = state.field(Language.state, false);
  return field ? field.tree : Tree$1.empty;
}
class DocInput {
  /**
  Create an input object for the given document.
  */
  constructor(doc2) {
    this.doc = doc2;
    this.cursorPos = 0;
    this.string = "";
    this.cursor = doc2.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(pos) {
    this.string = this.cursor.next(pos - this.cursorPos).value;
    this.cursorPos = pos + this.string.length;
    return this.cursorPos - this.string.length;
  }
  chunk(pos) {
    this.syncTo(pos);
    return this.string;
  }
  get lineChunks() {
    return true;
  }
  read(from, to2) {
    let stringStart = this.cursorPos - this.string.length;
    if (from < stringStart || to2 >= this.cursorPos)
      return this.doc.sliceString(from, to2);
    else
      return this.string.slice(from - stringStart, to2 - stringStart);
  }
}
let currentContext = null;
class ParseContext {
  constructor(parser2, state, fragments = [], tree, treeLen, viewport, skipped, scheduleOn) {
    this.parser = parser2;
    this.state = state;
    this.fragments = fragments;
    this.tree = tree;
    this.treeLen = treeLen;
    this.viewport = viewport;
    this.skipped = skipped;
    this.scheduleOn = scheduleOn;
    this.parse = null;
    this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(parser2, state, viewport) {
    return new ParseContext(parser2, state, [], Tree$1.empty, 0, viewport, [], null);
  }
  startParse() {
    return this.parser.startParse(new DocInput(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(until, upto) {
    if (upto != null && upto >= this.state.doc.length)
      upto = void 0;
    if (this.tree != Tree$1.empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
      this.takeTree();
      return true;
    }
    return this.withContext(() => {
      var _a2;
      if (typeof until == "number") {
        let endTime = Date.now() + until;
        until = () => Date.now() > endTime;
      }
      if (!this.parse)
        this.parse = this.startParse();
      if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length)
        this.parse.stopAt(upto);
      for (; ; ) {
        let done = this.parse.advance();
        if (done) {
          this.fragments = this.withoutTempSkipped(TreeFragment.addTree(done, this.fragments, this.parse.stoppedAt != null));
          this.treeLen = (_a2 = this.parse.stoppedAt) !== null && _a2 !== void 0 ? _a2 : this.state.doc.length;
          this.tree = done;
          this.parse = null;
          if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length))
            this.parse = this.startParse();
          else
            return true;
        }
        if (until())
          return false;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let pos, tree;
    if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
      if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos)
        this.parse.stopAt(pos);
      this.withContext(() => {
        while (!(tree = this.parse.advance())) {
        }
      });
      this.treeLen = pos;
      this.tree = tree;
      this.fragments = this.withoutTempSkipped(TreeFragment.addTree(this.tree, this.fragments, true));
      this.parse = null;
    }
  }
  withContext(f2) {
    let prev = currentContext;
    currentContext = this;
    try {
      return f2();
    } finally {
      currentContext = prev;
    }
  }
  withoutTempSkipped(fragments) {
    for (let r; r = this.tempSkipped.pop(); )
      fragments = cutFragments(fragments, r.from, r.to);
    return fragments;
  }
  /**
  @internal
  */
  changes(changes, newState) {
    let { fragments, tree, treeLen, viewport, skipped } = this;
    this.takeTree();
    if (!changes.empty) {
      let ranges = [];
      changes.iterChangedRanges((fromA, toA, fromB, toB) => ranges.push({ fromA, toA, fromB, toB }));
      fragments = TreeFragment.applyChanges(fragments, ranges);
      tree = Tree$1.empty;
      treeLen = 0;
      viewport = { from: changes.mapPos(viewport.from, -1), to: changes.mapPos(viewport.to, 1) };
      if (this.skipped.length) {
        skipped = [];
        for (let r of this.skipped) {
          let from = changes.mapPos(r.from, 1), to2 = changes.mapPos(r.to, -1);
          if (from < to2)
            skipped.push({ from, to: to2 });
        }
      }
    }
    return new ParseContext(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(viewport) {
    if (this.viewport.from == viewport.from && this.viewport.to == viewport.to)
      return false;
    this.viewport = viewport;
    let startLen = this.skipped.length;
    for (let i2 = 0; i2 < this.skipped.length; i2++) {
      let { from, to: to2 } = this.skipped[i2];
      if (from < viewport.to && to2 > viewport.from) {
        this.fragments = cutFragments(this.fragments, from, to2);
        this.skipped.splice(i2--, 1);
      }
    }
    if (this.skipped.length >= startLen)
      return false;
    this.reset();
    return true;
  }
  /**
  @internal
  */
  reset() {
    if (this.parse) {
      this.takeTree();
      this.parse = null;
    }
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(from, to2) {
    this.skipped.push({ from, to: to2 });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(until) {
    return new class extends Parser$1 {
      createParse(input, fragments, ranges) {
        let from = ranges[0].from, to2 = ranges[ranges.length - 1].to;
        let parser2 = {
          parsedPos: from,
          advance() {
            let cx = currentContext;
            if (cx) {
              for (let r of ranges)
                cx.tempSkipped.push(r);
              if (until)
                cx.scheduleOn = cx.scheduleOn ? Promise.all([cx.scheduleOn, until]) : until;
            }
            this.parsedPos = to2;
            return new Tree$1(NodeType$1.none, [], [], to2 - from);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
        return parser2;
      }
    }();
  }
  /**
  @internal
  */
  isDone(upto) {
    upto = Math.min(upto, this.state.doc.length);
    let frags = this.fragments;
    return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return currentContext;
  }
}
function cutFragments(fragments, from, to2) {
  return TreeFragment.applyChanges(fragments, [{ fromA: from, toA: to2, fromB: from, toB: to2 }]);
}
class LanguageState {
  constructor(context) {
    this.context = context;
    this.tree = context.tree;
  }
  apply(tr2) {
    if (!tr2.docChanged && this.tree == this.context.tree)
      return this;
    let newCx = this.context.changes(tr2.changes, tr2.state);
    let upto = this.context.treeLen == tr2.startState.doc.length ? void 0 : Math.max(tr2.changes.mapPos(this.context.treeLen), newCx.viewport.to);
    if (!newCx.work(20, upto))
      newCx.takeTree();
    return new LanguageState(newCx);
  }
  static init(state) {
    let vpTo = Math.min(3e3, state.doc.length);
    let parseState = ParseContext.create(state.facet(language).parser, state, { from: 0, to: vpTo });
    if (!parseState.work(20, vpTo))
      parseState.takeTree();
    return new LanguageState(parseState);
  }
}
Language.state = /* @__PURE__ */ StateField.define({
  create: LanguageState.init,
  update(value, tr2) {
    for (let e2 of tr2.effects)
      if (e2.is(Language.setState))
        return e2.value;
    if (tr2.startState.facet(language) != tr2.state.facet(language))
      return LanguageState.init(tr2.state);
    return value.apply(tr2);
  }
});
let requestIdle = (callback) => {
  let timeout = setTimeout(
    () => callback(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined")
  requestIdle = (callback) => {
    let idle = -1, timeout = setTimeout(
      () => {
        idle = requestIdleCallback(callback, {
          timeout: 500 - 100
          /* Work.MinPause */
        });
      },
      100
      /* Work.MinPause */
    );
    return () => idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
  };
const isInputPending = typeof navigator != "undefined" && ((_a$1 = navigator.scheduling) === null || _a$1 === void 0 ? void 0 : _a$1.isInputPending) ? () => navigator.scheduling.isInputPending() : null;
const parseWorker = /* @__PURE__ */ ViewPlugin.fromClass(class ParseWorker {
  constructor(view) {
    this.view = view;
    this.working = null;
    this.workScheduled = 0;
    this.chunkEnd = -1;
    this.chunkBudget = -1;
    this.work = this.work.bind(this);
    this.scheduleWork();
  }
  update(update) {
    let cx = this.view.state.field(Language.state).context;
    if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen)
      this.scheduleWork();
    if (update.docChanged || update.selectionSet) {
      if (this.view.hasFocus)
        this.chunkBudget += 50;
      this.scheduleWork();
    }
    this.checkAsyncSchedule(cx);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state } = this.view, field = state.field(Language.state);
    if (field.tree != field.context.tree || !field.context.isDone(state.doc.length))
      this.working = requestIdle(this.work);
  }
  work(deadline) {
    this.working = null;
    let now2 = Date.now();
    if (this.chunkEnd < now2 && (this.chunkEnd < 0 || this.view.hasFocus)) {
      this.chunkEnd = now2 + 3e4;
      this.chunkBudget = 3e3;
    }
    if (this.chunkBudget <= 0)
      return;
    let { state, viewport: { to: vpTo } } = this.view, field = state.field(Language.state);
    if (field.tree == field.context.tree && field.context.isDone(
      vpTo + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let endTime = Date.now() + Math.min(this.chunkBudget, 100, deadline && !isInputPending ? Math.max(25, deadline.timeRemaining() - 5) : 1e9);
    let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1e3;
    let done = field.context.work(() => {
      return isInputPending && isInputPending() || Date.now() > endTime;
    }, vpTo + (viewportFirst ? 0 : 1e5));
    this.chunkBudget -= Date.now() - now2;
    if (done || this.chunkBudget <= 0) {
      field.context.takeTree();
      this.view.dispatch({ effects: Language.setState.of(new LanguageState(field.context)) });
    }
    if (this.chunkBudget > 0 && !(done && !viewportFirst))
      this.scheduleWork();
    this.checkAsyncSchedule(field.context);
  }
  checkAsyncSchedule(cx) {
    if (cx.scheduleOn) {
      this.workScheduled++;
      cx.scheduleOn.then(() => this.scheduleWork()).catch((err) => logException(this.view.state, err)).then(() => this.workScheduled--);
      cx.scheduleOn = null;
    }
  }
  destroy() {
    if (this.working)
      this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
});
const language = /* @__PURE__ */ Facet.define({
  combine(languages2) {
    return languages2.length ? languages2[0] : null;
  },
  enables: (language2) => [
    Language.state,
    parseWorker,
    EditorView.contentAttributes.compute([language2], (state) => {
      let lang = state.facet(language2);
      return lang && lang.name ? { "data-language": lang.name } : {};
    })
  ]
});
class LanguageSupport {
  /**
  Create a language support object.
  */
  constructor(language2, support = []) {
    this.language = language2;
    this.support = support;
    this.extension = [language2, support];
  }
}
const indentService = /* @__PURE__ */ Facet.define();
const indentUnit = /* @__PURE__ */ Facet.define({
  combine: (values2) => {
    if (!values2.length)
      return "  ";
    let unit = values2[0];
    if (!unit || /\S/.test(unit) || Array.from(unit).some((e2) => e2 != unit[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(values2[0]));
    return unit;
  }
});
function getIndentUnit(state) {
  let unit = state.facet(indentUnit);
  return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
function indentString(state, cols) {
  let result2 = "", ts = state.tabSize, ch = state.facet(indentUnit)[0];
  if (ch == "	") {
    while (cols >= ts) {
      result2 += "	";
      cols -= ts;
    }
    ch = " ";
  }
  for (let i2 = 0; i2 < cols; i2++)
    result2 += ch;
  return result2;
}
function getIndentation(context, pos) {
  if (context instanceof EditorState)
    context = new IndentContext(context);
  for (let service of context.state.facet(indentService)) {
    let result2 = service(context, pos);
    if (result2 !== void 0)
      return result2;
  }
  let tree = syntaxTree(context.state);
  return tree.length >= pos ? syntaxIndentation(context, tree, pos) : null;
}
class IndentContext {
  /**
  Create an indent context.
  */
  constructor(state, options2 = {}) {
    this.state = state;
    this.options = options2;
    this.unit = getIndentUnit(state);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(pos, bias = 1) {
    let line2 = this.state.doc.lineAt(pos);
    let { simulateBreak, simulateDoubleBreak } = this.options;
    if (simulateBreak != null && simulateBreak >= line2.from && simulateBreak <= line2.to) {
      if (simulateDoubleBreak && simulateBreak == pos)
        return { text: "", from: pos };
      else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos)
        return { text: line2.text.slice(simulateBreak - line2.from), from: simulateBreak };
      else
        return { text: line2.text.slice(0, simulateBreak - line2.from), from: line2.from };
    }
    return line2;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(pos, bias = 1) {
    if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak)
      return "";
    let { text: text2, from } = this.lineAt(pos, bias);
    return text2.slice(pos - from, Math.min(text2.length, pos + 100 - from));
  }
  /**
  Find the column for the given position.
  */
  column(pos, bias = 1) {
    let { text: text2, from } = this.lineAt(pos, bias);
    let result2 = this.countColumn(text2, pos - from);
    let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
    if (override > -1)
      result2 += override - this.countColumn(text2, text2.search(/\S|$/));
    return result2;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(line2, pos = line2.length) {
    return countColumn(line2, this.state.tabSize, pos);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(pos, bias = 1) {
    let { text: text2, from } = this.lineAt(pos, bias);
    let override = this.options.overrideIndentation;
    if (override) {
      let overriden = override(from);
      if (overriden > -1)
        return overriden;
    }
    return this.countColumn(text2, text2.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const indentNodeProp = /* @__PURE__ */ new NodeProp$1();
function syntaxIndentation(cx, ast, pos) {
  let stack = ast.resolveStack(pos);
  let inner = ast.resolveInner(pos, -1).resolve(pos, 0).enterUnfinishedNodesBefore(pos);
  if (inner != stack.node) {
    let add2 = [];
    for (let cur2 = inner; cur2 && !(cur2.from < stack.node.from || cur2.to > stack.node.to || cur2.from == stack.node.from && cur2.type == stack.node.type); cur2 = cur2.parent)
      add2.push(cur2);
    for (let i2 = add2.length - 1; i2 >= 0; i2--)
      stack = { node: add2[i2], next: stack };
  }
  return indentFor(stack, cx, pos);
}
function indentFor(stack, cx, pos) {
  for (let cur2 = stack; cur2; cur2 = cur2.next) {
    let strategy = indentStrategy(cur2.node);
    if (strategy)
      return strategy(TreeIndentContext.create(cx, pos, cur2));
  }
  return 0;
}
function ignoreClosed(cx) {
  return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function indentStrategy(tree) {
  let strategy = tree.type.prop(indentNodeProp);
  if (strategy)
    return strategy;
  let first2 = tree.firstChild, close;
  if (first2 && (close = first2.type.prop(NodeProp$1.closedBy))) {
    let last2 = tree.lastChild, closed = last2 && close.indexOf(last2.name) > -1;
    return (cx) => delimitedStrategy(cx, true, 1, void 0, closed && !ignoreClosed(cx) ? last2.from : void 0);
  }
  return tree.parent == null ? topIndent : null;
}
function topIndent() {
  return 0;
}
class TreeIndentContext extends IndentContext {
  constructor(base2, pos, context) {
    super(base2.state, base2.options);
    this.base = base2;
    this.pos = pos;
    this.context = context;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(base2, pos, context) {
    return new TreeIndentContext(base2, pos, context);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(node) {
    let line2 = this.state.doc.lineAt(node.from);
    for (; ; ) {
      let atBreak = node.resolve(line2.from);
      while (atBreak.parent && atBreak.parent.from == atBreak.from)
        atBreak = atBreak.parent;
      if (isParent(atBreak, node))
        break;
      line2 = this.state.doc.lineAt(atBreak.from);
    }
    return this.lineIndent(line2.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return indentFor(this.context.next, this.base, this.pos);
  }
}
function isParent(parent, of) {
  for (let cur2 = of; cur2; cur2 = cur2.parent)
    if (parent == cur2)
      return true;
  return false;
}
function bracketedAligned(context) {
  let tree = context.node;
  let openToken = tree.childAfter(tree.from), last2 = tree.lastChild;
  if (!openToken)
    return null;
  let sim = context.options.simulateBreak;
  let openLine = context.state.doc.lineAt(openToken.from);
  let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
  for (let pos = openToken.to; ; ) {
    let next = tree.childAfter(pos);
    if (!next || next == last2)
      return null;
    if (!next.type.isSkipped) {
      if (next.from >= lineEnd)
        return null;
      let space = /^ */.exec(openLine.text.slice(openToken.to - openLine.from))[0].length;
      return { from: openToken.from, to: openToken.to + space };
    }
    pos = next.to;
  }
}
function delimitedStrategy(context, align2, units, closing2, closedAt) {
  let after2 = context.textAfter, space = after2.match(/^\s*/)[0].length;
  let closed = closedAt == context.pos + space;
  let aligned = bracketedAligned(context);
  if (aligned)
    return closed ? context.column(aligned.from) : context.column(aligned.to);
  return context.baseIndent + (closed ? 0 : context.unit * units);
}
const DontIndentBeyond = 200;
function indentOnInput() {
  return EditorState.transactionFilter.of((tr2) => {
    if (!tr2.docChanged || !tr2.isUserEvent("input.type") && !tr2.isUserEvent("input.complete"))
      return tr2;
    let rules = tr2.startState.languageDataAt("indentOnInput", tr2.startState.selection.main.head);
    if (!rules.length)
      return tr2;
    let doc2 = tr2.newDoc, { head } = tr2.newSelection.main, line2 = doc2.lineAt(head);
    if (head > line2.from + DontIndentBeyond)
      return tr2;
    let lineStart = doc2.sliceString(line2.from, head);
    if (!rules.some((r) => r.test(lineStart)))
      return tr2;
    let { state } = tr2, last2 = -1, changes = [];
    for (let { head: head2 } of state.selection.ranges) {
      let line22 = state.doc.lineAt(head2);
      if (line22.from == last2)
        continue;
      last2 = line22.from;
      let indent2 = getIndentation(state, line22.from);
      if (indent2 == null)
        continue;
      let cur2 = /^\s*/.exec(line22.text)[0];
      let norm = indentString(state, indent2);
      if (cur2 != norm)
        changes.push({ from: line22.from, to: line22.from + cur2.length, insert: norm });
    }
    return changes.length ? [tr2, { changes, sequential: true }] : tr2;
  });
}
const foldService = /* @__PURE__ */ Facet.define();
const foldNodeProp = /* @__PURE__ */ new NodeProp$1();
function syntaxFolding(state, start, end) {
  let tree = syntaxTree(state);
  if (tree.length < end)
    return null;
  let stack = tree.resolveStack(end, 1);
  let found = null;
  for (let iter = stack; iter; iter = iter.next) {
    let cur2 = iter.node;
    if (cur2.to <= end || cur2.from > end)
      continue;
    if (found && cur2.from < start)
      break;
    let prop = cur2.type.prop(foldNodeProp);
    if (prop && (cur2.to < tree.length - 50 || tree.length == state.doc.length || !isUnfinished(cur2))) {
      let value = prop(cur2, state);
      if (value && value.from <= end && value.from >= start && value.to > end)
        found = value;
    }
  }
  return found;
}
function isUnfinished(node) {
  let ch = node.lastChild;
  return ch && ch.to == node.to && ch.type.isError;
}
function foldable(state, lineStart, lineEnd) {
  for (let service of state.facet(foldService)) {
    let result2 = service(state, lineStart, lineEnd);
    if (result2)
      return result2;
  }
  return syntaxFolding(state, lineStart, lineEnd);
}
function mapRange(range2, mapping) {
  let from = mapping.mapPos(range2.from, 1), to2 = mapping.mapPos(range2.to, -1);
  return from >= to2 ? void 0 : { from, to: to2 };
}
const foldEffect = /* @__PURE__ */ StateEffect.define({ map: mapRange });
const unfoldEffect = /* @__PURE__ */ StateEffect.define({ map: mapRange });
function selectedLines(view) {
  let lines = [];
  for (let { head } of view.state.selection.ranges) {
    if (lines.some((l) => l.from <= head && l.to >= head))
      continue;
    lines.push(view.lineBlockAt(head));
  }
  return lines;
}
const foldState = /* @__PURE__ */ StateField.define({
  create() {
    return Decoration.none;
  },
  update(folded, tr2) {
    if (tr2.isUserEvent("delete"))
      tr2.changes.iterChangedRanges((fromA, toA) => folded = clearTouchedFolds(folded, fromA, toA));
    folded = folded.map(tr2.changes);
    for (let e2 of tr2.effects) {
      if (e2.is(foldEffect) && !foldExists(folded, e2.value.from, e2.value.to)) {
        let { preparePlaceholder } = tr2.state.facet(foldConfig);
        let widget = !preparePlaceholder ? foldWidget : Decoration.replace({ widget: new PreparedFoldWidget(preparePlaceholder(tr2.state, e2.value)) });
        folded = folded.update({ add: [widget.range(e2.value.from, e2.value.to)] });
      } else if (e2.is(unfoldEffect)) {
        folded = folded.update({
          filter: (from, to2) => e2.value.from != from || e2.value.to != to2,
          filterFrom: e2.value.from,
          filterTo: e2.value.to
        });
      }
    }
    if (tr2.selection)
      folded = clearTouchedFolds(folded, tr2.selection.main.head);
    return folded;
  },
  provide: (f2) => EditorView.decorations.from(f2),
  toJSON(folded, state) {
    let ranges = [];
    folded.between(0, state.doc.length, (from, to2) => {
      ranges.push(from, to2);
    });
    return ranges;
  },
  fromJSON(value) {
    if (!Array.isArray(value) || value.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let ranges = [];
    for (let i2 = 0; i2 < value.length; ) {
      let from = value[i2++], to2 = value[i2++];
      if (typeof from != "number" || typeof to2 != "number")
        throw new RangeError("Invalid JSON for fold state");
      ranges.push(foldWidget.range(from, to2));
    }
    return Decoration.set(ranges, true);
  }
});
function clearTouchedFolds(folded, from, to2 = from) {
  let touched = false;
  folded.between(from, to2, (a, b2) => {
    if (a < to2 && b2 > from)
      touched = true;
  });
  return !touched ? folded : folded.update({
    filterFrom: from,
    filterTo: to2,
    filter: (a, b2) => a >= to2 || b2 <= from
  });
}
function findFold(state, from, to2) {
  var _a2;
  let found = null;
  (_a2 = state.field(foldState, false)) === null || _a2 === void 0 ? void 0 : _a2.between(from, to2, (from2, to22) => {
    if (!found || found.from > from2)
      found = { from: from2, to: to22 };
  });
  return found;
}
function foldExists(folded, from, to2) {
  let found = false;
  folded.between(from, from, (a, b2) => {
    if (a == from && b2 == to2)
      found = true;
  });
  return found;
}
function maybeEnable(state, other) {
  return state.field(foldState, false) ? other : other.concat(StateEffect.appendConfig.of(codeFolding()));
}
const foldCode = (view) => {
  for (let line2 of selectedLines(view)) {
    let range2 = foldable(view.state, line2.from, line2.to);
    if (range2) {
      view.dispatch({ effects: maybeEnable(view.state, [foldEffect.of(range2), announceFold(view, range2)]) });
      return true;
    }
  }
  return false;
};
const unfoldCode = (view) => {
  if (!view.state.field(foldState, false))
    return false;
  let effects = [];
  for (let line2 of selectedLines(view)) {
    let folded = findFold(view.state, line2.from, line2.to);
    if (folded)
      effects.push(unfoldEffect.of(folded), announceFold(view, folded, false));
  }
  if (effects.length)
    view.dispatch({ effects });
  return effects.length > 0;
};
function announceFold(view, range2, fold = true) {
  let lineFrom = view.state.doc.lineAt(range2.from).number, lineTo = view.state.doc.lineAt(range2.to).number;
  return EditorView.announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
const foldAll = (view) => {
  let { state } = view, effects = [];
  for (let pos = 0; pos < state.doc.length; ) {
    let line2 = view.lineBlockAt(pos), range2 = foldable(state, line2.from, line2.to);
    if (range2)
      effects.push(foldEffect.of(range2));
    pos = (range2 ? view.lineBlockAt(range2.to) : line2).to + 1;
  }
  if (effects.length)
    view.dispatch({ effects: maybeEnable(view.state, effects) });
  return !!effects.length;
};
const unfoldAll = (view) => {
  let field = view.state.field(foldState, false);
  if (!field || !field.size)
    return false;
  let effects = [];
  field.between(0, view.state.doc.length, (from, to2) => {
    effects.push(unfoldEffect.of({ from, to: to2 }));
  });
  view.dispatch({ effects });
  return true;
};
const foldKeymap = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: foldCode },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: unfoldCode },
  { key: "Ctrl-Alt-[", run: foldAll },
  { key: "Ctrl-Alt-]", run: unfoldAll }
];
const defaultConfig = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
};
const foldConfig = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return combineConfig(values2, defaultConfig);
  }
});
function codeFolding(config2) {
  let result2 = [foldState, baseTheme$1$2];
  return result2;
}
function widgetToDOM(view, prepared) {
  let { state } = view, conf = state.facet(foldConfig);
  let onclick = (event) => {
    let line2 = view.lineBlockAt(view.posAtDOM(event.target));
    let folded = findFold(view.state, line2.from, line2.to);
    if (folded)
      view.dispatch({ effects: unfoldEffect.of(folded) });
    event.preventDefault();
  };
  if (conf.placeholderDOM)
    return conf.placeholderDOM(view, onclick, prepared);
  let element2 = document.createElement("span");
  element2.textContent = conf.placeholderText;
  element2.setAttribute("aria-label", state.phrase("folded code"));
  element2.title = state.phrase("unfold");
  element2.className = "cm-foldPlaceholder";
  element2.onclick = onclick;
  return element2;
}
const foldWidget = /* @__PURE__ */ Decoration.replace({ widget: /* @__PURE__ */ new class extends WidgetType {
  toDOM(view) {
    return widgetToDOM(view, null);
  }
}() });
class PreparedFoldWidget extends WidgetType {
  constructor(value) {
    super();
    this.value = value;
  }
  eq(other) {
    return this.value == other.value;
  }
  toDOM(view) {
    return widgetToDOM(view, this.value);
  }
}
const foldGutterDefaults = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => false
};
class FoldMarker extends GutterMarker {
  constructor(config2, open) {
    super();
    this.config = config2;
    this.open = open;
  }
  eq(other) {
    return this.config == other.config && this.open == other.open;
  }
  toDOM(view) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let span = document.createElement("span");
    span.textContent = this.open ? this.config.openText : this.config.closedText;
    span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
    return span;
  }
}
function foldGutter(config2 = {}) {
  let fullConfig = { ...foldGutterDefaults, ...config2 };
  let canFold = new FoldMarker(fullConfig, true), canUnfold = new FoldMarker(fullConfig, false);
  let markers = ViewPlugin.fromClass(class {
    constructor(view) {
      this.from = view.viewport.from;
      this.markers = this.buildMarkers(view);
    }
    update(update) {
      if (update.docChanged || update.viewportChanged || update.startState.facet(language) != update.state.facet(language) || update.startState.field(foldState, false) != update.state.field(foldState, false) || syntaxTree(update.startState) != syntaxTree(update.state) || fullConfig.foldingChanged(update))
        this.markers = this.buildMarkers(update.view);
    }
    buildMarkers(view) {
      let builder = new RangeSetBuilder();
      for (let line2 of view.viewportLineBlocks) {
        let mark = findFold(view.state, line2.from, line2.to) ? canUnfold : foldable(view.state, line2.from, line2.to) ? canFold : null;
        if (mark)
          builder.add(line2.from, line2.from, mark);
      }
      return builder.finish();
    }
  });
  let { domEventHandlers } = fullConfig;
  return [
    markers,
    gutter({
      class: "cm-foldGutter",
      markers(view) {
        var _a2;
        return ((_a2 = view.plugin(markers)) === null || _a2 === void 0 ? void 0 : _a2.markers) || RangeSet.empty;
      },
      initialSpacer() {
        return new FoldMarker(fullConfig, false);
      },
      domEventHandlers: {
        ...domEventHandlers,
        click: (view, line2, event) => {
          if (domEventHandlers.click && domEventHandlers.click(view, line2, event))
            return true;
          let folded = findFold(view.state, line2.from, line2.to);
          if (folded) {
            view.dispatch({ effects: unfoldEffect.of(folded) });
            return true;
          }
          let range2 = foldable(view.state, line2.from, line2.to);
          if (range2) {
            view.dispatch({ effects: foldEffect.of(range2) });
            return true;
          }
          return false;
        }
      }
    }),
    codeFolding()
  ];
}
const baseTheme$1$2 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class HighlightStyle {
  constructor(specs, options2) {
    this.specs = specs;
    let modSpec;
    function def(spec) {
      let cls = StyleModule.newName();
      (modSpec || (modSpec = /* @__PURE__ */ Object.create(null)))["." + cls] = spec;
      return cls;
    }
    const all2 = typeof options2.all == "string" ? options2.all : options2.all ? def(options2.all) : void 0;
    const scopeOpt = options2.scope;
    this.scope = scopeOpt instanceof Language ? (type) => type.prop(languageDataProp) == scopeOpt.data : scopeOpt ? (type) => type == scopeOpt : void 0;
    this.style = tagHighlighter(specs.map((style) => ({
      tag: style.tag,
      class: style.class || def(Object.assign({}, style, { tag: null }))
    })), {
      all: all2
    }).style;
    this.module = modSpec ? new StyleModule(modSpec) : null;
    this.themeType = options2.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(specs, options2) {
    return new HighlightStyle(specs, options2 || {});
  }
}
const highlighterFacet = /* @__PURE__ */ Facet.define();
const fallbackHighlighter = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return values2.length ? [values2[0]] : null;
  }
});
function getHighlighters(state) {
  let main2 = state.facet(highlighterFacet);
  return main2.length ? main2 : state.facet(fallbackHighlighter);
}
function syntaxHighlighting(highlighter, options2) {
  let ext = [treeHighlighter], themeType;
  if (highlighter instanceof HighlightStyle) {
    if (highlighter.module)
      ext.push(EditorView.styleModule.of(highlighter.module));
    themeType = highlighter.themeType;
  }
  if (options2 === null || options2 === void 0 ? void 0 : options2.fallback)
    ext.push(fallbackHighlighter.of(highlighter));
  else if (themeType)
    ext.push(highlighterFacet.computeN([EditorView.darkTheme], (state) => {
      return state.facet(EditorView.darkTheme) == (themeType == "dark") ? [highlighter] : [];
    }));
  else
    ext.push(highlighterFacet.of(highlighter));
  return ext;
}
class TreeHighlighter {
  constructor(view) {
    this.markCache = /* @__PURE__ */ Object.create(null);
    this.tree = syntaxTree(view.state);
    this.decorations = this.buildDeco(view, getHighlighters(view.state));
    this.decoratedTo = view.viewport.to;
  }
  update(update) {
    let tree = syntaxTree(update.state), highlighters = getHighlighters(update.state);
    let styleChange = highlighters != getHighlighters(update.startState);
    let { viewport } = update.view, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
    if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
      this.decorations = this.decorations.map(update.changes);
      this.decoratedTo = decoratedToMapped;
    } else if (tree != this.tree || update.viewportChanged || styleChange) {
      this.tree = tree;
      this.decorations = this.buildDeco(update.view, highlighters);
      this.decoratedTo = viewport.to;
    }
  }
  buildDeco(view, highlighters) {
    if (!highlighters || !this.tree.length)
      return Decoration.none;
    let builder = new RangeSetBuilder();
    for (let { from, to: to2 } of view.visibleRanges) {
      highlightTree(this.tree, highlighters, (from2, to22, style) => {
        builder.add(from2, to22, this.markCache[style] || (this.markCache[style] = Decoration.mark({ class: style })));
      }, from, to2);
    }
    return builder.finish();
  }
}
const treeHighlighter = /* @__PURE__ */ Prec.high(/* @__PURE__ */ ViewPlugin.fromClass(TreeHighlighter, {
  decorations: (v2) => v2.decorations
}));
const defaultHighlightStyle = /* @__PURE__ */ HighlightStyle.define([
  {
    tag: tags.meta,
    color: "#404740"
  },
  {
    tag: tags.link,
    textDecoration: "underline"
  },
  {
    tag: tags.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: tags.emphasis,
    fontStyle: "italic"
  },
  {
    tag: tags.strong,
    fontWeight: "bold"
  },
  {
    tag: tags.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: tags.keyword,
    color: "#708"
  },
  {
    tag: [tags.atom, tags.bool, tags.url, tags.contentSeparator, tags.labelName],
    color: "#219"
  },
  {
    tag: [tags.literal, tags.inserted],
    color: "#164"
  },
  {
    tag: [tags.string, tags.deleted],
    color: "#a11"
  },
  {
    tag: [tags.regexp, tags.escape, /* @__PURE__ */ tags.special(tags.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ tags.definition(tags.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ tags.local(tags.variableName),
    color: "#30a"
  },
  {
    tag: [tags.typeName, tags.namespace],
    color: "#085"
  },
  {
    tag: tags.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ tags.special(tags.variableName), tags.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ tags.definition(tags.propertyName),
    color: "#00c"
  },
  {
    tag: tags.comment,
    color: "#940"
  },
  {
    tag: tags.invalid,
    color: "#f00"
  }
]);
const baseTheme$3 = /* @__PURE__ */ EditorView.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
});
const DefaultScanDist = 1e4, DefaultBrackets = "()[]{}";
const bracketMatchingConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      afterCursor: true,
      brackets: DefaultBrackets,
      maxScanDistance: DefaultScanDist,
      renderMatch: defaultRenderMatch
    });
  }
});
const matchingMark = /* @__PURE__ */ Decoration.mark({ class: "cm-matchingBracket" }), nonmatchingMark = /* @__PURE__ */ Decoration.mark({ class: "cm-nonmatchingBracket" });
function defaultRenderMatch(match2) {
  let decorations2 = [];
  let mark = match2.matched ? matchingMark : nonmatchingMark;
  decorations2.push(mark.range(match2.start.from, match2.start.to));
  if (match2.end)
    decorations2.push(mark.range(match2.end.from, match2.end.to));
  return decorations2;
}
const bracketMatchingState = /* @__PURE__ */ StateField.define({
  create() {
    return Decoration.none;
  },
  update(deco, tr2) {
    if (!tr2.docChanged && !tr2.selection)
      return deco;
    let decorations2 = [];
    let config2 = tr2.state.facet(bracketMatchingConfig);
    for (let range2 of tr2.state.selection.ranges) {
      if (!range2.empty)
        continue;
      let match2 = matchBrackets(tr2.state, range2.head, -1, config2) || range2.head > 0 && matchBrackets(tr2.state, range2.head - 1, 1, config2) || config2.afterCursor && (matchBrackets(tr2.state, range2.head, 1, config2) || range2.head < tr2.state.doc.length && matchBrackets(tr2.state, range2.head + 1, -1, config2));
      if (match2)
        decorations2 = decorations2.concat(config2.renderMatch(match2, tr2.state));
    }
    return Decoration.set(decorations2, true);
  },
  provide: (f2) => EditorView.decorations.from(f2)
});
const bracketMatchingUnique = [
  bracketMatchingState,
  baseTheme$3
];
function bracketMatching(config2 = {}) {
  return [bracketMatchingConfig.of(config2), bracketMatchingUnique];
}
const bracketMatchingHandle = /* @__PURE__ */ new NodeProp$1();
function matchingNodes(node, dir, brackets) {
  let byProp = node.prop(dir < 0 ? NodeProp$1.openedBy : NodeProp$1.closedBy);
  if (byProp)
    return byProp;
  if (node.name.length == 1) {
    let index2 = brackets.indexOf(node.name);
    if (index2 > -1 && index2 % 2 == (dir < 0 ? 1 : 0))
      return [brackets[index2 + dir]];
  }
  return null;
}
function findHandle(node) {
  let hasHandle = node.type.prop(bracketMatchingHandle);
  return hasHandle ? hasHandle(node.node) : node;
}
function matchBrackets(state, pos, dir, config2 = {}) {
  let maxScanDistance = config2.maxScanDistance || DefaultScanDist, brackets = config2.brackets || DefaultBrackets;
  let tree = syntaxTree(state), node = tree.resolveInner(pos, dir);
  for (let cur2 = node; cur2; cur2 = cur2.parent) {
    let matches2 = matchingNodes(cur2.type, dir, brackets);
    if (matches2 && cur2.from < cur2.to) {
      let handle = findHandle(cur2);
      if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to))
        return matchMarkedBrackets(state, pos, dir, cur2, handle, matches2, brackets);
    }
  }
  return matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
  let parent = token.parent, firstToken = { from: handle.from, to: handle.to };
  let depth = 0, cursor2 = parent === null || parent === void 0 ? void 0 : parent.cursor();
  if (cursor2 && (dir < 0 ? cursor2.childBefore(token.from) : cursor2.childAfter(token.to)))
    do {
      if (dir < 0 ? cursor2.to <= token.from : cursor2.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor2.type.name) > -1 && cursor2.from < cursor2.to) {
          let endHandle = findHandle(cursor2);
          return { start: firstToken, end: endHandle ? { from: endHandle.from, to: endHandle.to } : void 0, matched: true };
        } else if (matchingNodes(cursor2.type, dir, brackets)) {
          depth++;
        } else if (matchingNodes(cursor2.type, -dir, brackets)) {
          if (depth == 0) {
            let endHandle = findHandle(cursor2);
            return {
              start: firstToken,
              end: endHandle && endHandle.from < endHandle.to ? { from: endHandle.from, to: endHandle.to } : void 0,
              matched: false
            };
          }
          depth--;
        }
      }
    } while (dir < 0 ? cursor2.prevSibling() : cursor2.nextSibling());
  return { start: firstToken, matched: false };
}
function matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
  let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
  let bracket2 = brackets.indexOf(startCh);
  if (bracket2 < 0 || bracket2 % 2 == 0 != dir > 0)
    return null;
  let startToken = { from: dir < 0 ? pos - 1 : pos, to: dir > 0 ? pos + 1 : pos };
  let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
  for (let distance = 0; !iter.next().done && distance <= maxScanDistance; ) {
    let text2 = iter.value;
    if (dir < 0)
      distance += text2.length;
    let basePos = pos + distance * dir;
    for (let pos2 = dir > 0 ? 0 : text2.length - 1, end = dir > 0 ? text2.length : -1; pos2 != end; pos2 += dir) {
      let found = brackets.indexOf(text2[pos2]);
      if (found < 0 || tree.resolveInner(basePos + pos2, 1).type != tokenType)
        continue;
      if (found % 2 == 0 == dir > 0) {
        depth++;
      } else if (depth == 1) {
        return { start: startToken, end: { from: basePos + pos2, to: basePos + pos2 + 1 }, matched: found >> 1 == bracket2 >> 1 };
      } else {
        depth--;
      }
    }
    if (dir > 0)
      distance += text2.length;
  }
  return iter.done ? { start: startToken, matched: false } : null;
}
const noTokens = /* @__PURE__ */ Object.create(null);
const typeArray = [NodeType$1.none];
const warned = [];
const byTag = /* @__PURE__ */ Object.create(null);
const defaultTable = /* @__PURE__ */ Object.create(null);
for (let [legacyName, name2] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  defaultTable[legacyName] = /* @__PURE__ */ createTokenType(noTokens, name2);
function warnForPart(part, msg) {
  if (warned.indexOf(part) > -1)
    return;
  warned.push(part);
  console.warn(msg);
}
function createTokenType(extra, tagStr) {
  let tags$1 = [];
  for (let name3 of tagStr.split(" ")) {
    let found = [];
    for (let part of name3.split(".")) {
      let value = extra[part] || tags[part];
      if (!value) {
        warnForPart(part, `Unknown highlighting tag ${part}`);
      } else if (typeof value == "function") {
        if (!found.length)
          warnForPart(part, `Modifier ${part} used at start of tag`);
        else
          found = found.map(value);
      } else {
        if (found.length)
          warnForPart(part, `Tag ${part} used as modifier`);
        else
          found = Array.isArray(value) ? value : [value];
      }
    }
    for (let tag2 of found)
      tags$1.push(tag2);
  }
  if (!tags$1.length)
    return 0;
  let name2 = tagStr.replace(/ /g, "_"), key = name2 + " " + tags$1.map((t2) => t2.id);
  let known = byTag[key];
  if (known)
    return known.id;
  let type = byTag[key] = NodeType$1.define({
    id: typeArray.length,
    name: name2,
    props: [styleTags({ [name2]: tags$1 })]
  });
  typeArray.push(type);
  return type.id;
}
({
  rtl: /* @__PURE__ */ Decoration.mark({ class: "cm-iso", inclusive: true, attributes: { dir: "rtl" }, bidiIsolate: Direction.RTL }),
  ltr: /* @__PURE__ */ Decoration.mark({ class: "cm-iso", inclusive: true, attributes: { dir: "ltr" }, bidiIsolate: Direction.LTR })
});
const toggleComment = (target) => {
  let { state } = target, line2 = state.doc.lineAt(state.selection.main.from), config2 = getConfig(target.state, line2.from);
  return config2.line ? toggleLineComment(target) : config2.block ? toggleBlockCommentByLine(target) : false;
};
function command(f2, option) {
  return ({ state, dispatch }) => {
    if (state.readOnly)
      return false;
    let tr2 = f2(option, state);
    if (!tr2)
      return false;
    dispatch(state.update(tr2));
    return true;
  };
}
const toggleLineComment = /* @__PURE__ */ command(
  changeLineComment,
  0
  /* CommentOption.Toggle */
);
const toggleBlockComment = /* @__PURE__ */ command(
  changeBlockComment,
  0
  /* CommentOption.Toggle */
);
const toggleBlockCommentByLine = /* @__PURE__ */ command(
  (o, s) => changeBlockComment(o, s, selectedLineRanges(s)),
  0
  /* CommentOption.Toggle */
);
function getConfig(state, pos) {
  let data = state.languageDataAt("commentTokens", pos, 1);
  return data.length ? data[0] : {};
}
const SearchMargin = 50;
function findBlockComment(state, { open, close }, from, to2) {
  let textBefore = state.sliceDoc(from - SearchMargin, from);
  let textAfter = state.sliceDoc(to2, to2 + SearchMargin);
  let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
  let beforeOff = textBefore.length - spaceBefore;
  if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) {
    return {
      open: { pos: from - spaceBefore, margin: spaceBefore && 1 },
      close: { pos: to2 + spaceAfter, margin: spaceAfter && 1 }
    };
  }
  let startText, endText;
  if (to2 - from <= 2 * SearchMargin) {
    startText = endText = state.sliceDoc(from, to2);
  } else {
    startText = state.sliceDoc(from, from + SearchMargin);
    endText = state.sliceDoc(to2 - SearchMargin, to2);
  }
  let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
  let endOff = endText.length - endSpace - close.length;
  if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) {
    return {
      open: {
        pos: from + startSpace + open.length,
        margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
      },
      close: {
        pos: to2 - endSpace - close.length,
        margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
      }
    };
  }
  return null;
}
function selectedLineRanges(state) {
  let ranges = [];
  for (let r of state.selection.ranges) {
    let fromLine = state.doc.lineAt(r.from);
    let toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
    if (toLine.from > fromLine.from && toLine.from == r.to)
      toLine = r.to == fromLine.to + 1 ? fromLine : state.doc.lineAt(r.to - 1);
    let last2 = ranges.length - 1;
    if (last2 >= 0 && ranges[last2].to > fromLine.from)
      ranges[last2].to = toLine.to;
    else
      ranges.push({ from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length, to: toLine.to });
  }
  return ranges;
}
function changeBlockComment(option, state, ranges = state.selection.ranges) {
  let tokens = ranges.map((r) => getConfig(state, r.from).block);
  if (!tokens.every((c2) => c2))
    return null;
  let comments = ranges.map((r, i2) => findBlockComment(state, tokens[i2], r.from, r.to));
  if (option != 2 && !comments.every((c2) => c2)) {
    return { changes: state.changes(ranges.map((range2, i2) => {
      if (comments[i2])
        return [];
      return [{ from: range2.from, insert: tokens[i2].open + " " }, { from: range2.to, insert: " " + tokens[i2].close }];
    })) };
  } else if (option != 1 && comments.some((c2) => c2)) {
    let changes = [];
    for (let i2 = 0, comment2; i2 < comments.length; i2++)
      if (comment2 = comments[i2]) {
        let token = tokens[i2], { open, close } = comment2;
        changes.push({ from: open.pos - token.open.length, to: open.pos + open.margin }, { from: close.pos - close.margin, to: close.pos + token.close.length });
      }
    return { changes };
  }
  return null;
}
function changeLineComment(option, state, ranges = state.selection.ranges) {
  let lines = [];
  let prevLine = -1;
  for (let { from, to: to2 } of ranges) {
    let startI = lines.length, minIndent = 1e9;
    let token = getConfig(state, from).line;
    if (!token)
      continue;
    for (let pos = from; pos <= to2; ) {
      let line2 = state.doc.lineAt(pos);
      if (line2.from > prevLine && (from == to2 || to2 > line2.from)) {
        prevLine = line2.from;
        let indent2 = /^\s*/.exec(line2.text)[0].length;
        let empty2 = indent2 == line2.length;
        let comment2 = line2.text.slice(indent2, indent2 + token.length) == token ? indent2 : -1;
        if (indent2 < line2.text.length && indent2 < minIndent)
          minIndent = indent2;
        lines.push({ line: line2, comment: comment2, token, indent: indent2, empty: empty2, single: false });
      }
      pos = line2.to + 1;
    }
    if (minIndent < 1e9) {
      for (let i2 = startI; i2 < lines.length; i2++)
        if (lines[i2].indent < lines[i2].line.text.length)
          lines[i2].indent = minIndent;
    }
    if (lines.length == startI + 1)
      lines[startI].single = true;
  }
  if (option != 2 && lines.some((l) => l.comment < 0 && (!l.empty || l.single))) {
    let changes = [];
    for (let { line: line2, token, indent: indent2, empty: empty2, single } of lines)
      if (single || !empty2)
        changes.push({ from: line2.from + indent2, insert: token + " " });
    let changeSet = state.changes(changes);
    return { changes: changeSet, selection: state.selection.map(changeSet, 1) };
  } else if (option != 1 && lines.some((l) => l.comment >= 0)) {
    let changes = [];
    for (let { line: line2, comment: comment2, token } of lines)
      if (comment2 >= 0) {
        let from = line2.from + comment2, to2 = from + token.length;
        if (line2.text[to2 - line2.from] == " ")
          to2++;
        changes.push({ from, to: to2 });
      }
    return { changes };
  }
  return null;
}
const fromHistory = /* @__PURE__ */ Annotation.define();
const isolateHistory = /* @__PURE__ */ Annotation.define();
const invertedEffects = /* @__PURE__ */ Facet.define();
const historyConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (_t, isAdjacent2) => isAdjacent2
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (a, b2) => (tr2, adj) => a(tr2, adj) || b2(tr2, adj)
    });
  }
});
const historyField_ = /* @__PURE__ */ StateField.define({
  create() {
    return HistoryState.empty;
  },
  update(state, tr2) {
    let config2 = tr2.state.facet(historyConfig);
    let fromHist = tr2.annotation(fromHistory);
    if (fromHist) {
      let item = HistEvent.fromTransaction(tr2, fromHist.selection), from = fromHist.side;
      let other = from == 0 ? state.undone : state.done;
      if (item)
        other = updateBranch(other, other.length, config2.minDepth, item);
      else
        other = addSelection(other, tr2.startState.selection);
      return new HistoryState(from == 0 ? fromHist.rest : other, from == 0 ? other : fromHist.rest);
    }
    let isolate = tr2.annotation(isolateHistory);
    if (isolate == "full" || isolate == "before")
      state = state.isolate();
    if (tr2.annotation(Transaction.addToHistory) === false)
      return !tr2.changes.empty ? state.addMapping(tr2.changes.desc) : state;
    let event = HistEvent.fromTransaction(tr2);
    let time = tr2.annotation(Transaction.time), userEvent = tr2.annotation(Transaction.userEvent);
    if (event)
      state = state.addChanges(event, time, userEvent, config2, tr2);
    else if (tr2.selection)
      state = state.addSelection(tr2.startState.selection, time, userEvent, config2.newGroupDelay);
    if (isolate == "full" || isolate == "after")
      state = state.isolate();
    return state;
  },
  toJSON(value) {
    return { done: value.done.map((e2) => e2.toJSON()), undone: value.undone.map((e2) => e2.toJSON()) };
  },
  fromJSON(json) {
    return new HistoryState(json.done.map(HistEvent.fromJSON), json.undone.map(HistEvent.fromJSON));
  }
});
function history(config2 = {}) {
  return [
    historyField_,
    historyConfig.of(config2),
    EditorView.domEventHandlers({
      beforeinput(e2, view) {
        let command2 = e2.inputType == "historyUndo" ? undo : e2.inputType == "historyRedo" ? redo : null;
        if (!command2)
          return false;
        e2.preventDefault();
        return command2(view);
      }
    })
  ];
}
function cmd(side, selection2) {
  return function({ state, dispatch }) {
    if (!selection2 && state.readOnly)
      return false;
    let historyState = state.field(historyField_, false);
    if (!historyState)
      return false;
    let tr2 = historyState.pop(side, state, selection2);
    if (!tr2)
      return false;
    dispatch(tr2);
    return true;
  };
}
const undo = /* @__PURE__ */ cmd(0, false);
const redo = /* @__PURE__ */ cmd(1, false);
const undoSelection = /* @__PURE__ */ cmd(0, true);
const redoSelection = /* @__PURE__ */ cmd(1, true);
class HistEvent {
  constructor(changes, effects, mapped, startSelection, selectionsAfter) {
    this.changes = changes;
    this.effects = effects;
    this.mapped = mapped;
    this.startSelection = startSelection;
    this.selectionsAfter = selectionsAfter;
  }
  setSelAfter(after2) {
    return new HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after2);
  }
  toJSON() {
    var _a2, _b, _c;
    return {
      changes: (_a2 = this.changes) === null || _a2 === void 0 ? void 0 : _a2.toJSON(),
      mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
      startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
      selectionsAfter: this.selectionsAfter.map((s) => s.toJSON())
    };
  }
  static fromJSON(json) {
    return new HistEvent(json.changes && ChangeSet.fromJSON(json.changes), [], json.mapped && ChangeDesc.fromJSON(json.mapped), json.startSelection && EditorSelection.fromJSON(json.startSelection), json.selectionsAfter.map(EditorSelection.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(tr2, selection2) {
    let effects = none$1;
    for (let invert2 of tr2.startState.facet(invertedEffects)) {
      let result2 = invert2(tr2);
      if (result2.length)
        effects = effects.concat(result2);
    }
    if (!effects.length && tr2.changes.empty)
      return null;
    return new HistEvent(tr2.changes.invert(tr2.startState.doc), effects, void 0, selection2 || tr2.startState.selection, none$1);
  }
  static selection(selections) {
    return new HistEvent(void 0, none$1, void 0, void 0, selections);
  }
}
function updateBranch(branch, to2, maxLen, newEvent) {
  let start = to2 + 1 > maxLen + 20 ? to2 - maxLen - 1 : 0;
  let newBranch = branch.slice(start, to2);
  newBranch.push(newEvent);
  return newBranch;
}
function isAdjacent(a, b2) {
  let ranges = [], isAdjacent2 = false;
  a.iterChangedRanges((f2, t2) => ranges.push(f2, t2));
  b2.iterChangedRanges((_f, _t, f2, t2) => {
    for (let i2 = 0; i2 < ranges.length; ) {
      let from = ranges[i2++], to2 = ranges[i2++];
      if (t2 >= from && f2 <= to2)
        isAdjacent2 = true;
    }
  });
  return isAdjacent2;
}
function eqSelectionShape(a, b2) {
  return a.ranges.length == b2.ranges.length && a.ranges.filter((r, i2) => r.empty != b2.ranges[i2].empty).length === 0;
}
function conc(a, b2) {
  return !a.length ? b2 : !b2.length ? a : a.concat(b2);
}
const none$1 = [];
const MaxSelectionsPerEvent = 200;
function addSelection(branch, selection2) {
  if (!branch.length) {
    return [HistEvent.selection([selection2])];
  } else {
    let lastEvent = branch[branch.length - 1];
    let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - MaxSelectionsPerEvent));
    if (sels.length && sels[sels.length - 1].eq(selection2))
      return branch;
    sels.push(selection2);
    return updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
  }
}
function popSelection(branch) {
  let last2 = branch[branch.length - 1];
  let newBranch = branch.slice();
  newBranch[branch.length - 1] = last2.setSelAfter(last2.selectionsAfter.slice(0, last2.selectionsAfter.length - 1));
  return newBranch;
}
function addMappingToBranch(branch, mapping) {
  if (!branch.length)
    return branch;
  let length = branch.length, selections = none$1;
  while (length) {
    let event = mapEvent(branch[length - 1], mapping, selections);
    if (event.changes && !event.changes.empty || event.effects.length) {
      let result2 = branch.slice(0, length);
      result2[length - 1] = event;
      return result2;
    } else {
      mapping = event.mapped;
      length--;
      selections = event.selectionsAfter;
    }
  }
  return selections.length ? [HistEvent.selection(selections)] : none$1;
}
function mapEvent(event, mapping, extraSelections) {
  let selections = conc(event.selectionsAfter.length ? event.selectionsAfter.map((s) => s.map(mapping)) : none$1, extraSelections);
  if (!event.changes)
    return HistEvent.selection(selections);
  let mappedChanges = event.changes.map(mapping), before2 = mapping.mapDesc(event.changes, true);
  let fullMapping = event.mapped ? event.mapped.composeDesc(before2) : before2;
  return new HistEvent(mappedChanges, StateEffect.mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before2), selections);
}
const joinableUserEvent = /^(input\.type|delete)($|\.)/;
class HistoryState {
  constructor(done, undone, prevTime = 0, prevUserEvent = void 0) {
    this.done = done;
    this.undone = undone;
    this.prevTime = prevTime;
    this.prevUserEvent = prevUserEvent;
  }
  isolate() {
    return this.prevTime ? new HistoryState(this.done, this.undone) : this;
  }
  addChanges(event, time, userEvent, config2, tr2) {
    let done = this.done, lastEvent = done[done.length - 1];
    if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config2.newGroupDelay && config2.joinToEvent(tr2, isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
    userEvent == "input.type.compose")) {
      done = updateBranch(done, done.length - 1, config2.minDepth, new HistEvent(event.changes.compose(lastEvent.changes), conc(StateEffect.mapEffects(event.effects, lastEvent.changes), lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, none$1));
    } else {
      done = updateBranch(done, done.length, config2.minDepth, event);
    }
    return new HistoryState(done, none$1, time, userEvent);
  }
  addSelection(selection2, time, userEvent, newGroupDelay) {
    let last2 = this.done.length ? this.done[this.done.length - 1].selectionsAfter : none$1;
    if (last2.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && eqSelectionShape(last2[last2.length - 1], selection2))
      return this;
    return new HistoryState(addSelection(this.done, selection2), this.undone, time, userEvent);
  }
  addMapping(mapping) {
    return new HistoryState(addMappingToBranch(this.done, mapping), addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
  }
  pop(side, state, onlySelection) {
    let branch = side == 0 ? this.done : this.undone;
    if (branch.length == 0)
      return null;
    let event = branch[branch.length - 1], selection2 = event.selectionsAfter[0] || state.selection;
    if (onlySelection && event.selectionsAfter.length) {
      return state.update({
        selection: event.selectionsAfter[event.selectionsAfter.length - 1],
        annotations: fromHistory.of({ side, rest: popSelection(branch), selection: selection2 }),
        userEvent: side == 0 ? "select.undo" : "select.redo",
        scrollIntoView: true
      });
    } else if (!event.changes) {
      return null;
    } else {
      let rest2 = branch.length == 1 ? none$1 : branch.slice(0, branch.length - 1);
      if (event.mapped)
        rest2 = addMappingToBranch(rest2, event.mapped);
      return state.update({
        changes: event.changes,
        selection: event.startSelection,
        effects: event.effects,
        annotations: fromHistory.of({ side, rest: rest2, selection: selection2 }),
        filter: false,
        userEvent: side == 0 ? "undo" : "redo",
        scrollIntoView: true
      });
    }
  }
}
HistoryState.empty = /* @__PURE__ */ new HistoryState(none$1, none$1);
const historyKeymap = [
  { key: "Mod-z", run: undo, preventDefault: true },
  { key: "Mod-y", mac: "Mod-Shift-z", run: redo, preventDefault: true },
  { linux: "Ctrl-Shift-z", run: redo, preventDefault: true },
  { key: "Mod-u", run: undoSelection, preventDefault: true },
  { key: "Alt-u", mac: "Mod-Shift-u", run: redoSelection, preventDefault: true }
];
function updateSel(sel, by) {
  return EditorSelection.create(sel.ranges.map(by), sel.mainIndex);
}
function setSel(state, selection2) {
  return state.update({ selection: selection2, scrollIntoView: true, userEvent: "select" });
}
function moveSel({ state, dispatch }, how) {
  let selection2 = updateSel(state.selection, how);
  if (selection2.eq(state.selection, true))
    return false;
  dispatch(setSel(state, selection2));
  return true;
}
function rangeEnd(range2, forward) {
  return EditorSelection.cursor(forward ? range2.to : range2.from);
}
function cursorByChar(view, forward) {
  return moveSel(view, (range2) => range2.empty ? view.moveByChar(range2, forward) : rangeEnd(range2, forward));
}
function ltrAtCursor(view) {
  return view.textDirectionAt(view.state.selection.main.head) == Direction.LTR;
}
const cursorCharLeft = (view) => cursorByChar(view, !ltrAtCursor(view));
const cursorCharRight = (view) => cursorByChar(view, ltrAtCursor(view));
function cursorByGroup(view, forward) {
  return moveSel(view, (range2) => range2.empty ? view.moveByGroup(range2, forward) : rangeEnd(range2, forward));
}
const cursorGroupLeft = (view) => cursorByGroup(view, !ltrAtCursor(view));
const cursorGroupRight = (view) => cursorByGroup(view, ltrAtCursor(view));
function interestingNode(state, node, bracketProp) {
  if (node.type.prop(bracketProp))
    return true;
  let len = node.to - node.from;
  return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function moveBySyntax(state, start, forward) {
  let pos = syntaxTree(state).resolveInner(start.head);
  let bracketProp = forward ? NodeProp$1.closedBy : NodeProp$1.openedBy;
  for (let at2 = start.head; ; ) {
    let next = forward ? pos.childAfter(at2) : pos.childBefore(at2);
    if (!next)
      break;
    if (interestingNode(state, next, bracketProp))
      pos = next;
    else
      at2 = forward ? next.to : next.from;
  }
  let bracket2 = pos.type.prop(bracketProp), match2, newPos;
  if (bracket2 && (match2 = forward ? matchBrackets(state, pos.from, 1) : matchBrackets(state, pos.to, -1)) && match2.matched)
    newPos = forward ? match2.end.to : match2.end.from;
  else
    newPos = forward ? pos.to : pos.from;
  return EditorSelection.cursor(newPos, forward ? -1 : 1);
}
const cursorSyntaxLeft = (view) => moveSel(view, (range2) => moveBySyntax(view.state, range2, !ltrAtCursor(view)));
const cursorSyntaxRight = (view) => moveSel(view, (range2) => moveBySyntax(view.state, range2, ltrAtCursor(view)));
function cursorByLine(view, forward) {
  return moveSel(view, (range2) => {
    if (!range2.empty)
      return rangeEnd(range2, forward);
    let moved = view.moveVertically(range2, forward);
    return moved.head != range2.head ? moved : view.moveToLineBoundary(range2, forward);
  });
}
const cursorLineUp = (view) => cursorByLine(view, false);
const cursorLineDown = (view) => cursorByLine(view, true);
function pageInfo(view) {
  let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
  let marginTop = 0, marginBottom = 0, height;
  if (selfScroll) {
    for (let source of view.state.facet(EditorView.scrollMargins)) {
      let margins = source(view);
      if (margins === null || margins === void 0 ? void 0 : margins.top)
        marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
      if (margins === null || margins === void 0 ? void 0 : margins.bottom)
        marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
    }
    height = view.scrollDOM.clientHeight - marginTop - marginBottom;
  } else {
    height = (view.dom.ownerDocument.defaultView || window).innerHeight;
  }
  return {
    marginTop,
    marginBottom,
    selfScroll,
    height: Math.max(view.defaultLineHeight, height - 5)
  };
}
function cursorByPage(view, forward) {
  let page = pageInfo(view);
  let { state } = view, selection2 = updateSel(state.selection, (range2) => {
    return range2.empty ? view.moveVertically(range2, forward, page.height) : rangeEnd(range2, forward);
  });
  if (selection2.eq(state.selection))
    return false;
  let effect;
  if (page.selfScroll) {
    let startPos = view.coordsAtPos(state.selection.main.head);
    let scrollRect = view.scrollDOM.getBoundingClientRect();
    let scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
    if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom)
      effect = EditorView.scrollIntoView(selection2.main.head, { y: "start", yMargin: startPos.top - scrollTop });
  }
  view.dispatch(setSel(state, selection2), { effects: effect });
  return true;
}
const cursorPageUp = (view) => cursorByPage(view, false);
const cursorPageDown = (view) => cursorByPage(view, true);
function moveByLineBoundary(view, start, forward) {
  let line2 = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
  if (moved.head == start.head && moved.head != (forward ? line2.to : line2.from))
    moved = view.moveToLineBoundary(start, forward, false);
  if (!forward && moved.head == line2.from && line2.length) {
    let space = /^\s*/.exec(view.state.sliceDoc(line2.from, Math.min(line2.from + 100, line2.to)))[0].length;
    if (space && start.head != line2.from + space)
      moved = EditorSelection.cursor(line2.from + space);
  }
  return moved;
}
const cursorLineBoundaryForward = (view) => moveSel(view, (range2) => moveByLineBoundary(view, range2, true));
const cursorLineBoundaryBackward = (view) => moveSel(view, (range2) => moveByLineBoundary(view, range2, false));
const cursorLineBoundaryLeft = (view) => moveSel(view, (range2) => moveByLineBoundary(view, range2, !ltrAtCursor(view)));
const cursorLineBoundaryRight = (view) => moveSel(view, (range2) => moveByLineBoundary(view, range2, ltrAtCursor(view)));
const cursorLineStart = (view) => moveSel(view, (range2) => EditorSelection.cursor(view.lineBlockAt(range2.head).from, 1));
const cursorLineEnd = (view) => moveSel(view, (range2) => EditorSelection.cursor(view.lineBlockAt(range2.head).to, -1));
function toMatchingBracket(state, dispatch, extend2) {
  let found = false, selection2 = updateSel(state.selection, (range2) => {
    let matching = matchBrackets(state, range2.head, -1) || matchBrackets(state, range2.head, 1) || range2.head > 0 && matchBrackets(state, range2.head - 1, 1) || range2.head < state.doc.length && matchBrackets(state, range2.head + 1, -1);
    if (!matching || !matching.end)
      return range2;
    found = true;
    let head = matching.start.from == range2.head ? matching.end.to : matching.end.from;
    return EditorSelection.cursor(head);
  });
  if (!found)
    return false;
  dispatch(setSel(state, selection2));
  return true;
}
const cursorMatchingBracket = ({ state, dispatch }) => toMatchingBracket(state, dispatch);
function extendSel(target, how) {
  let selection2 = updateSel(target.state.selection, (range2) => {
    let head = how(range2);
    return EditorSelection.range(range2.anchor, head.head, head.goalColumn, head.bidiLevel || void 0);
  });
  if (selection2.eq(target.state.selection))
    return false;
  target.dispatch(setSel(target.state, selection2));
  return true;
}
function selectByChar(view, forward) {
  return extendSel(view, (range2) => view.moveByChar(range2, forward));
}
const selectCharLeft = (view) => selectByChar(view, !ltrAtCursor(view));
const selectCharRight = (view) => selectByChar(view, ltrAtCursor(view));
function selectByGroup(view, forward) {
  return extendSel(view, (range2) => view.moveByGroup(range2, forward));
}
const selectGroupLeft = (view) => selectByGroup(view, !ltrAtCursor(view));
const selectGroupRight = (view) => selectByGroup(view, ltrAtCursor(view));
const selectSyntaxLeft = (view) => extendSel(view, (range2) => moveBySyntax(view.state, range2, !ltrAtCursor(view)));
const selectSyntaxRight = (view) => extendSel(view, (range2) => moveBySyntax(view.state, range2, ltrAtCursor(view)));
function selectByLine(view, forward) {
  return extendSel(view, (range2) => view.moveVertically(range2, forward));
}
const selectLineUp = (view) => selectByLine(view, false);
const selectLineDown = (view) => selectByLine(view, true);
function selectByPage(view, forward) {
  return extendSel(view, (range2) => view.moveVertically(range2, forward, pageInfo(view).height));
}
const selectPageUp = (view) => selectByPage(view, false);
const selectPageDown = (view) => selectByPage(view, true);
const selectLineBoundaryForward = (view) => extendSel(view, (range2) => moveByLineBoundary(view, range2, true));
const selectLineBoundaryBackward = (view) => extendSel(view, (range2) => moveByLineBoundary(view, range2, false));
const selectLineBoundaryLeft = (view) => extendSel(view, (range2) => moveByLineBoundary(view, range2, !ltrAtCursor(view)));
const selectLineBoundaryRight = (view) => extendSel(view, (range2) => moveByLineBoundary(view, range2, ltrAtCursor(view)));
const selectLineStart = (view) => extendSel(view, (range2) => EditorSelection.cursor(view.lineBlockAt(range2.head).from));
const selectLineEnd = (view) => extendSel(view, (range2) => EditorSelection.cursor(view.lineBlockAt(range2.head).to));
const cursorDocStart = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: 0 }));
  return true;
};
const cursorDocEnd = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.doc.length }));
  return true;
};
const selectDocStart = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.selection.main.anchor, head: 0 }));
  return true;
};
const selectDocEnd = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.selection.main.anchor, head: state.doc.length }));
  return true;
};
const selectAll = ({ state, dispatch }) => {
  dispatch(state.update({ selection: { anchor: 0, head: state.doc.length }, userEvent: "select" }));
  return true;
};
const selectLine = ({ state, dispatch }) => {
  let ranges = selectedLineBlocks(state).map(({ from, to: to2 }) => EditorSelection.range(from, Math.min(to2 + 1, state.doc.length)));
  dispatch(state.update({ selection: EditorSelection.create(ranges), userEvent: "select" }));
  return true;
};
const selectParentSyntax = ({ state, dispatch }) => {
  let selection2 = updateSel(state.selection, (range2) => {
    let tree = syntaxTree(state), stack = tree.resolveStack(range2.from, 1);
    if (range2.empty) {
      let stackBefore = tree.resolveStack(range2.from, -1);
      if (stackBefore.node.from >= stack.node.from && stackBefore.node.to <= stack.node.to)
        stack = stackBefore;
    }
    for (let cur2 = stack; cur2; cur2 = cur2.next) {
      let { node } = cur2;
      if ((node.from < range2.from && node.to >= range2.to || node.to > range2.to && node.from <= range2.from) && cur2.next)
        return EditorSelection.range(node.to, node.from);
    }
    return range2;
  });
  if (selection2.eq(state.selection))
    return false;
  dispatch(setSel(state, selection2));
  return true;
};
function addCursorVertically(view, forward) {
  let { state } = view, sel = state.selection, ranges = state.selection.ranges.slice();
  for (let range2 of state.selection.ranges) {
    let line2 = state.doc.lineAt(range2.head);
    if (forward ? line2.to < view.state.doc.length : line2.from > 0)
      for (let cur2 = range2; ; ) {
        let next = view.moveVertically(cur2, forward);
        if (next.head < line2.from || next.head > line2.to) {
          if (!ranges.some((r) => r.head == next.head))
            ranges.push(next);
          break;
        } else if (next.head == cur2.head) {
          break;
        } else {
          cur2 = next;
        }
      }
  }
  if (ranges.length == sel.ranges.length)
    return false;
  view.dispatch(setSel(state, EditorSelection.create(ranges, ranges.length - 1)));
  return true;
}
const addCursorAbove = (view) => addCursorVertically(view, false);
const addCursorBelow = (view) => addCursorVertically(view, true);
const simplifySelection = ({ state, dispatch }) => {
  let cur2 = state.selection, selection2 = null;
  if (cur2.ranges.length > 1)
    selection2 = EditorSelection.create([cur2.main]);
  else if (!cur2.main.empty)
    selection2 = EditorSelection.create([EditorSelection.cursor(cur2.main.head)]);
  if (!selection2)
    return false;
  dispatch(setSel(state, selection2));
  return true;
};
function deleteBy(target, by) {
  if (target.state.readOnly)
    return false;
  let event = "delete.selection", { state } = target;
  let changes = state.changeByRange((range2) => {
    let { from, to: to2 } = range2;
    if (from == to2) {
      let towards = by(range2);
      if (towards < from) {
        event = "delete.backward";
        towards = skipAtomic(target, towards, false);
      } else if (towards > from) {
        event = "delete.forward";
        towards = skipAtomic(target, towards, true);
      }
      from = Math.min(from, towards);
      to2 = Math.max(to2, towards);
    } else {
      from = skipAtomic(target, from, false);
      to2 = skipAtomic(target, to2, true);
    }
    return from == to2 ? { range: range2 } : { changes: { from, to: to2 }, range: EditorSelection.cursor(from, from < range2.head ? -1 : 1) };
  });
  if (changes.changes.empty)
    return false;
  target.dispatch(state.update(changes, {
    scrollIntoView: true,
    userEvent: event,
    effects: event == "delete.selection" ? EditorView.announce.of(state.phrase("Selection deleted")) : void 0
  }));
  return true;
}
function skipAtomic(target, pos, forward) {
  if (target instanceof EditorView)
    for (let ranges of target.state.facet(EditorView.atomicRanges).map((f2) => f2(target)))
      ranges.between(pos, pos, (from, to2) => {
        if (from < pos && to2 > pos)
          pos = forward ? to2 : from;
      });
  return pos;
}
const deleteByChar = (target, forward, byIndentUnit) => deleteBy(target, (range2) => {
  let pos = range2.from, { state } = target, line2 = state.doc.lineAt(pos), before2, targetPos;
  if (byIndentUnit && !forward && pos > line2.from && pos < line2.from + 200 && !/[^ \t]/.test(before2 = line2.text.slice(0, pos - line2.from))) {
    if (before2[before2.length - 1] == "	")
      return pos - 1;
    let col = countColumn(before2, state.tabSize), drop = col % getIndentUnit(state) || getIndentUnit(state);
    for (let i2 = 0; i2 < drop && before2[before2.length - 1 - i2] == " "; i2++)
      pos--;
    targetPos = pos;
  } else {
    targetPos = findClusterBreak(line2.text, pos - line2.from, forward, forward) + line2.from;
    if (targetPos == pos && line2.number != (forward ? state.doc.lines : 1))
      targetPos += forward ? 1 : -1;
    else if (!forward && /[\ufe00-\ufe0f]/.test(line2.text.slice(targetPos - line2.from, pos - line2.from)))
      targetPos = findClusterBreak(line2.text, targetPos - line2.from, false, false) + line2.from;
  }
  return targetPos;
});
const deleteCharBackward = (view) => deleteByChar(view, false, true);
const deleteCharForward = (view) => deleteByChar(view, true, false);
const deleteByGroup = (target, forward) => deleteBy(target, (range2) => {
  let pos = range2.head, { state } = target, line2 = state.doc.lineAt(pos);
  let categorize = state.charCategorizer(pos);
  for (let cat = null; ; ) {
    if (pos == (forward ? line2.to : line2.from)) {
      if (pos == range2.head && line2.number != (forward ? state.doc.lines : 1))
        pos += forward ? 1 : -1;
      break;
    }
    let next = findClusterBreak(line2.text, pos - line2.from, forward) + line2.from;
    let nextChar2 = line2.text.slice(Math.min(pos, next) - line2.from, Math.max(pos, next) - line2.from);
    let nextCat = categorize(nextChar2);
    if (cat != null && nextCat != cat)
      break;
    if (nextChar2 != " " || pos != range2.head)
      cat = nextCat;
    pos = next;
  }
  return pos;
});
const deleteGroupBackward = (target) => deleteByGroup(target, false);
const deleteGroupForward = (target) => deleteByGroup(target, true);
const deleteToLineEnd = (view) => deleteBy(view, (range2) => {
  let lineEnd = view.lineBlockAt(range2.head).to;
  return range2.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range2.head + 1);
});
const deleteLineBoundaryBackward = (view) => deleteBy(view, (range2) => {
  let lineStart = view.moveToLineBoundary(range2, false).head;
  return range2.head > lineStart ? lineStart : Math.max(0, range2.head - 1);
});
const deleteLineBoundaryForward = (view) => deleteBy(view, (range2) => {
  let lineStart = view.moveToLineBoundary(range2, true).head;
  return range2.head < lineStart ? lineStart : Math.min(view.state.doc.length, range2.head + 1);
});
const splitLine = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let changes = state.changeByRange((range2) => {
    return {
      changes: { from: range2.from, to: range2.to, insert: Text$1.of(["", ""]) },
      range: EditorSelection.cursor(range2.from)
    };
  });
  dispatch(state.update(changes, { scrollIntoView: true, userEvent: "input" }));
  return true;
};
const transposeChars = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let changes = state.changeByRange((range2) => {
    if (!range2.empty || range2.from == 0 || range2.from == state.doc.length)
      return { range: range2 };
    let pos = range2.from, line2 = state.doc.lineAt(pos);
    let from = pos == line2.from ? pos - 1 : findClusterBreak(line2.text, pos - line2.from, false) + line2.from;
    let to2 = pos == line2.to ? pos + 1 : findClusterBreak(line2.text, pos - line2.from, true) + line2.from;
    return {
      changes: { from, to: to2, insert: state.doc.slice(pos, to2).append(state.doc.slice(from, pos)) },
      range: EditorSelection.cursor(to2)
    };
  });
  if (changes.changes.empty)
    return false;
  dispatch(state.update(changes, { scrollIntoView: true, userEvent: "move.character" }));
  return true;
};
function selectedLineBlocks(state) {
  let blocks = [], upto = -1;
  for (let range2 of state.selection.ranges) {
    let startLine = state.doc.lineAt(range2.from), endLine = state.doc.lineAt(range2.to);
    if (!range2.empty && range2.to == endLine.from)
      endLine = state.doc.lineAt(range2.to - 1);
    if (upto >= startLine.number) {
      let prev = blocks[blocks.length - 1];
      prev.to = endLine.to;
      prev.ranges.push(range2);
    } else {
      blocks.push({ from: startLine.from, to: endLine.to, ranges: [range2] });
    }
    upto = endLine.number + 1;
  }
  return blocks;
}
function moveLine(state, dispatch, forward) {
  if (state.readOnly)
    return false;
  let changes = [], ranges = [];
  for (let block of selectedLineBlocks(state)) {
    if (forward ? block.to == state.doc.length : block.from == 0)
      continue;
    let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
    let size2 = nextLine.length + 1;
    if (forward) {
      changes.push({ from: block.to, to: nextLine.to }, { from: block.from, insert: nextLine.text + state.lineBreak });
      for (let r of block.ranges)
        ranges.push(EditorSelection.range(Math.min(state.doc.length, r.anchor + size2), Math.min(state.doc.length, r.head + size2)));
    } else {
      changes.push({ from: nextLine.from, to: block.from }, { from: block.to, insert: state.lineBreak + nextLine.text });
      for (let r of block.ranges)
        ranges.push(EditorSelection.range(r.anchor - size2, r.head - size2));
    }
  }
  if (!changes.length)
    return false;
  dispatch(state.update({
    changes,
    scrollIntoView: true,
    selection: EditorSelection.create(ranges, state.selection.mainIndex),
    userEvent: "move.line"
  }));
  return true;
}
const moveLineUp = ({ state, dispatch }) => moveLine(state, dispatch, false);
const moveLineDown = ({ state, dispatch }) => moveLine(state, dispatch, true);
function copyLine(state, dispatch, forward) {
  if (state.readOnly)
    return false;
  let changes = [];
  for (let block of selectedLineBlocks(state)) {
    if (forward)
      changes.push({ from: block.from, insert: state.doc.slice(block.from, block.to) + state.lineBreak });
    else
      changes.push({ from: block.to, insert: state.lineBreak + state.doc.slice(block.from, block.to) });
  }
  dispatch(state.update({ changes, scrollIntoView: true, userEvent: "input.copyline" }));
  return true;
}
const copyLineUp = ({ state, dispatch }) => copyLine(state, dispatch, false);
const copyLineDown = ({ state, dispatch }) => copyLine(state, dispatch, true);
const deleteLine = (view) => {
  if (view.state.readOnly)
    return false;
  let { state } = view, changes = state.changes(selectedLineBlocks(state).map(({ from, to: to2 }) => {
    if (from > 0)
      from--;
    else if (to2 < state.doc.length)
      to2++;
    return { from, to: to2 };
  }));
  let selection2 = updateSel(state.selection, (range2) => {
    let dist2 = void 0;
    if (view.lineWrapping) {
      let block = view.lineBlockAt(range2.head), pos = view.coordsAtPos(range2.head, range2.assoc || 1);
      if (pos)
        dist2 = block.bottom + view.documentTop - pos.bottom + view.defaultLineHeight / 2;
    }
    return view.moveVertically(range2, true, dist2);
  }).map(changes);
  view.dispatch({ changes, selection: selection2, scrollIntoView: true, userEvent: "delete.line" });
  return true;
};
function isBetweenBrackets(state, pos) {
  if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1)))
    return { from: pos, to: pos };
  let context = syntaxTree(state).resolveInner(pos);
  let before2 = context.childBefore(pos), after2 = context.childAfter(pos), closedBy;
  if (before2 && after2 && before2.to <= pos && after2.from >= pos && (closedBy = before2.type.prop(NodeProp$1.closedBy)) && closedBy.indexOf(after2.name) > -1 && state.doc.lineAt(before2.to).from == state.doc.lineAt(after2.from).from && !/\S/.test(state.sliceDoc(before2.to, after2.from)))
    return { from: before2.to, to: after2.from };
  return null;
}
const insertNewlineAndIndent = /* @__PURE__ */ newlineAndIndent(false);
const insertBlankLine = /* @__PURE__ */ newlineAndIndent(true);
function newlineAndIndent(atEof) {
  return ({ state, dispatch }) => {
    if (state.readOnly)
      return false;
    let changes = state.changeByRange((range2) => {
      let { from, to: to2 } = range2, line2 = state.doc.lineAt(from);
      let explode = !atEof && from == to2 && isBetweenBrackets(state, from);
      if (atEof)
        from = to2 = (to2 <= line2.to ? line2 : state.doc.lineAt(to2)).to;
      let cx = new IndentContext(state, { simulateBreak: from, simulateDoubleBreak: !!explode });
      let indent2 = getIndentation(cx, from);
      if (indent2 == null)
        indent2 = countColumn(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
      while (to2 < line2.to && /\s/.test(line2.text[to2 - line2.from]))
        to2++;
      if (explode)
        ({ from, to: to2 } = explode);
      else if (from > line2.from && from < line2.from + 100 && !/\S/.test(line2.text.slice(0, from)))
        from = line2.from;
      let insert2 = ["", indentString(state, indent2)];
      if (explode)
        insert2.push(indentString(state, cx.lineIndent(line2.from, -1)));
      return {
        changes: { from, to: to2, insert: Text$1.of(insert2) },
        range: EditorSelection.cursor(from + 1 + insert2[1].length)
      };
    });
    dispatch(state.update(changes, { scrollIntoView: true, userEvent: "input" }));
    return true;
  };
}
function changeBySelectedLine(state, f2) {
  let atLine = -1;
  return state.changeByRange((range2) => {
    let changes = [];
    for (let pos = range2.from; pos <= range2.to; ) {
      let line2 = state.doc.lineAt(pos);
      if (line2.number > atLine && (range2.empty || range2.to > line2.from)) {
        f2(line2, changes, range2);
        atLine = line2.number;
      }
      pos = line2.to + 1;
    }
    let changeSet = state.changes(changes);
    return {
      changes,
      range: EditorSelection.range(changeSet.mapPos(range2.anchor, 1), changeSet.mapPos(range2.head, 1))
    };
  });
}
const indentSelection = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let updated = /* @__PURE__ */ Object.create(null);
  let context = new IndentContext(state, { overrideIndentation: (start) => {
    let found = updated[start];
    return found == null ? -1 : found;
  } });
  let changes = changeBySelectedLine(state, (line2, changes2, range2) => {
    let indent2 = getIndentation(context, line2.from);
    if (indent2 == null)
      return;
    if (!/\S/.test(line2.text))
      indent2 = 0;
    let cur2 = /^\s*/.exec(line2.text)[0];
    let norm = indentString(state, indent2);
    if (cur2 != norm || range2.from < line2.from + cur2.length) {
      updated[line2.from] = indent2;
      changes2.push({ from: line2.from, to: line2.from + cur2.length, insert: norm });
    }
  });
  if (!changes.changes.empty)
    dispatch(state.update(changes, { userEvent: "indent" }));
  return true;
};
const indentMore = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  dispatch(state.update(changeBySelectedLine(state, (line2, changes) => {
    changes.push({ from: line2.from, insert: state.facet(indentUnit) });
  }), { userEvent: "input.indent" }));
  return true;
};
const indentLess = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  dispatch(state.update(changeBySelectedLine(state, (line2, changes) => {
    let space = /^\s*/.exec(line2.text)[0];
    if (!space)
      return;
    let col = countColumn(space, state.tabSize), keep = 0;
    let insert2 = indentString(state, Math.max(0, col - getIndentUnit(state)));
    while (keep < space.length && keep < insert2.length && space.charCodeAt(keep) == insert2.charCodeAt(keep))
      keep++;
    changes.push({ from: line2.from + keep, to: line2.from + space.length, insert: insert2.slice(keep) });
  }), { userEvent: "delete.dedent" }));
  return true;
};
const toggleTabFocusMode = (view) => {
  view.setTabFocusMode();
  return true;
};
const emacsStyleKeymap = [
  { key: "Ctrl-b", run: cursorCharLeft, shift: selectCharLeft, preventDefault: true },
  { key: "Ctrl-f", run: cursorCharRight, shift: selectCharRight },
  { key: "Ctrl-p", run: cursorLineUp, shift: selectLineUp },
  { key: "Ctrl-n", run: cursorLineDown, shift: selectLineDown },
  { key: "Ctrl-a", run: cursorLineStart, shift: selectLineStart },
  { key: "Ctrl-e", run: cursorLineEnd, shift: selectLineEnd },
  { key: "Ctrl-d", run: deleteCharForward },
  { key: "Ctrl-h", run: deleteCharBackward },
  { key: "Ctrl-k", run: deleteToLineEnd },
  { key: "Ctrl-Alt-h", run: deleteGroupBackward },
  { key: "Ctrl-o", run: splitLine },
  { key: "Ctrl-t", run: transposeChars },
  { key: "Ctrl-v", run: cursorPageDown }
];
const standardKeymap = /* @__PURE__ */ [
  { key: "ArrowLeft", run: cursorCharLeft, shift: selectCharLeft, preventDefault: true },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: cursorGroupLeft, shift: selectGroupLeft, preventDefault: true },
  { mac: "Cmd-ArrowLeft", run: cursorLineBoundaryLeft, shift: selectLineBoundaryLeft, preventDefault: true },
  { key: "ArrowRight", run: cursorCharRight, shift: selectCharRight, preventDefault: true },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: cursorGroupRight, shift: selectGroupRight, preventDefault: true },
  { mac: "Cmd-ArrowRight", run: cursorLineBoundaryRight, shift: selectLineBoundaryRight, preventDefault: true },
  { key: "ArrowUp", run: cursorLineUp, shift: selectLineUp, preventDefault: true },
  { mac: "Cmd-ArrowUp", run: cursorDocStart, shift: selectDocStart },
  { mac: "Ctrl-ArrowUp", run: cursorPageUp, shift: selectPageUp },
  { key: "ArrowDown", run: cursorLineDown, shift: selectLineDown, preventDefault: true },
  { mac: "Cmd-ArrowDown", run: cursorDocEnd, shift: selectDocEnd },
  { mac: "Ctrl-ArrowDown", run: cursorPageDown, shift: selectPageDown },
  { key: "PageUp", run: cursorPageUp, shift: selectPageUp },
  { key: "PageDown", run: cursorPageDown, shift: selectPageDown },
  { key: "Home", run: cursorLineBoundaryBackward, shift: selectLineBoundaryBackward, preventDefault: true },
  { key: "Mod-Home", run: cursorDocStart, shift: selectDocStart },
  { key: "End", run: cursorLineBoundaryForward, shift: selectLineBoundaryForward, preventDefault: true },
  { key: "Mod-End", run: cursorDocEnd, shift: selectDocEnd },
  { key: "Enter", run: insertNewlineAndIndent, shift: insertNewlineAndIndent },
  { key: "Mod-a", run: selectAll },
  { key: "Backspace", run: deleteCharBackward, shift: deleteCharBackward, preventDefault: true },
  { key: "Delete", run: deleteCharForward, preventDefault: true },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: deleteGroupBackward, preventDefault: true },
  { key: "Mod-Delete", mac: "Alt-Delete", run: deleteGroupForward, preventDefault: true },
  { mac: "Mod-Backspace", run: deleteLineBoundaryBackward, preventDefault: true },
  { mac: "Mod-Delete", run: deleteLineBoundaryForward, preventDefault: true }
].concat(/* @__PURE__ */ emacsStyleKeymap.map((b2) => ({ mac: b2.key, run: b2.run, shift: b2.shift })));
const defaultKeymap = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: cursorSyntaxLeft, shift: selectSyntaxLeft },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: cursorSyntaxRight, shift: selectSyntaxRight },
  { key: "Alt-ArrowUp", run: moveLineUp },
  { key: "Shift-Alt-ArrowUp", run: copyLineUp },
  { key: "Alt-ArrowDown", run: moveLineDown },
  { key: "Shift-Alt-ArrowDown", run: copyLineDown },
  { key: "Mod-Alt-ArrowUp", run: addCursorAbove },
  { key: "Mod-Alt-ArrowDown", run: addCursorBelow },
  { key: "Escape", run: simplifySelection },
  { key: "Mod-Enter", run: insertBlankLine },
  { key: "Alt-l", mac: "Ctrl-l", run: selectLine },
  { key: "Mod-i", run: selectParentSyntax, preventDefault: true },
  { key: "Mod-[", run: indentLess },
  { key: "Mod-]", run: indentMore },
  { key: "Mod-Alt-\\", run: indentSelection },
  { key: "Shift-Mod-k", run: deleteLine },
  { key: "Shift-Mod-\\", run: cursorMatchingBracket },
  { key: "Mod-/", run: toggleComment },
  { key: "Alt-A", run: toggleBlockComment },
  { key: "Ctrl-m", mac: "Shift-Alt-m", run: toggleTabFocusMode }
].concat(standardKeymap);
const indentWithTab = { key: "Tab", run: indentMore, shift: indentLess };
const basicNormalize = typeof String.prototype.normalize == "function" ? (x2) => x2.normalize("NFKD") : (x2) => x2;
class SearchCursor {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(text2, query, from = 0, to2 = text2.length, normalize2, test) {
    this.test = test;
    this.value = { from: 0, to: 0 };
    this.done = false;
    this.matches = [];
    this.buffer = "";
    this.bufferPos = 0;
    this.iter = text2.iterRange(from, to2);
    this.bufferStart = from;
    this.normalize = normalize2 ? (x2) => normalize2(basicNormalize(x2)) : basicNormalize;
    this.query = this.normalize(query);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      this.bufferStart += this.buffer.length;
      this.iter.next();
      if (this.iter.done)
        return -1;
      this.bufferPos = 0;
      this.buffer = this.iter.value;
    }
    return codePointAt(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    while (this.matches.length)
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let next = this.peek();
      if (next < 0) {
        this.done = true;
        return this;
      }
      let str = fromCodePoint(next), start = this.bufferStart + this.bufferPos;
      this.bufferPos += codePointSize(next);
      let norm = this.normalize(str);
      if (norm.length)
        for (let i2 = 0, pos = start; ; i2++) {
          let code2 = norm.charCodeAt(i2);
          let match2 = this.match(code2, pos, this.bufferPos + this.bufferStart);
          if (i2 == norm.length - 1) {
            if (match2) {
              this.value = match2;
              return this;
            }
            break;
          }
          if (pos == start && i2 < str.length && str.charCodeAt(i2) == code2)
            pos++;
        }
    }
  }
  match(code2, pos, end) {
    let match2 = null;
    for (let i2 = 0; i2 < this.matches.length; i2 += 2) {
      let index2 = this.matches[i2], keep = false;
      if (this.query.charCodeAt(index2) == code2) {
        if (index2 == this.query.length - 1) {
          match2 = { from: this.matches[i2 + 1], to: end };
        } else {
          this.matches[i2]++;
          keep = true;
        }
      }
      if (!keep) {
        this.matches.splice(i2, 2);
        i2 -= 2;
      }
    }
    if (this.query.charCodeAt(0) == code2) {
      if (this.query.length == 1)
        match2 = { from: pos, to: end };
      else
        this.matches.push(1, pos);
    }
    if (match2 && this.test && !this.test(match2.from, match2.to, this.buffer, this.bufferStart))
      match2 = null;
    return match2;
  }
}
if (typeof Symbol != "undefined")
  SearchCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
const empty = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") };
const baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
class RegExpCursor {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(text2, query, options2, from = 0, to2 = text2.length) {
    this.text = text2;
    this.to = to2;
    this.curLine = "";
    this.done = false;
    this.value = empty;
    if (/\\[sWDnr]|\n|\r|\[\^/.test(query))
      return new MultilineRegExpCursor(text2, query, options2, from, to2);
    this.re = new RegExp(query, baseFlags + ((options2 === null || options2 === void 0 ? void 0 : options2.ignoreCase) ? "i" : ""));
    this.test = options2 === null || options2 === void 0 ? void 0 : options2.test;
    this.iter = text2.iter();
    let startLine = text2.lineAt(from);
    this.curLineStart = startLine.from;
    this.matchPos = toCharEnd(text2, from);
    this.getLine(this.curLineStart);
  }
  getLine(skip) {
    this.iter.next(skip);
    if (this.iter.lineBreak) {
      this.curLine = "";
    } else {
      this.curLine = this.iter.value;
      if (this.curLineStart + this.curLine.length > this.to)
        this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
      this.iter.next();
    }
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1;
    if (this.curLineStart > this.to)
      this.curLine = "";
    else
      this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let off2 = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = off2;
      let match2 = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (match2) {
        let from = this.curLineStart + match2.index, to2 = from + match2[0].length;
        this.matchPos = toCharEnd(this.text, to2 + (from == to2 ? 1 : 0));
        if (from == this.curLineStart + this.curLine.length)
          this.nextLine();
        if ((from < to2 || from > this.value.to) && (!this.test || this.test(from, to2, match2))) {
          this.value = { from, to: to2, match: match2 };
          return this;
        }
        off2 = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to) {
        this.nextLine();
        off2 = 0;
      } else {
        this.done = true;
        return this;
      }
    }
  }
}
const flattened = /* @__PURE__ */ new WeakMap();
class FlattenedDoc {
  constructor(from, text2) {
    this.from = from;
    this.text = text2;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(doc2, from, to2) {
    let cached = flattened.get(doc2);
    if (!cached || cached.from >= to2 || cached.to <= from) {
      let flat = new FlattenedDoc(from, doc2.sliceString(from, to2));
      flattened.set(doc2, flat);
      return flat;
    }
    if (cached.from == from && cached.to == to2)
      return cached;
    let { text: text2, from: cachedFrom } = cached;
    if (cachedFrom > from) {
      text2 = doc2.sliceString(from, cachedFrom) + text2;
      cachedFrom = from;
    }
    if (cached.to < to2)
      text2 += doc2.sliceString(cached.to, to2);
    flattened.set(doc2, new FlattenedDoc(cachedFrom, text2));
    return new FlattenedDoc(from, text2.slice(from - cachedFrom, to2 - cachedFrom));
  }
}
class MultilineRegExpCursor {
  constructor(text2, query, options2, from, to2) {
    this.text = text2;
    this.to = to2;
    this.done = false;
    this.value = empty;
    this.matchPos = toCharEnd(text2, from);
    this.re = new RegExp(query, baseFlags + ((options2 === null || options2 === void 0 ? void 0 : options2.ignoreCase) ? "i" : ""));
    this.test = options2 === null || options2 === void 0 ? void 0 : options2.test;
    this.flat = FlattenedDoc.get(text2, from, this.chunkEnd(
      from + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(pos) {
    return pos >= this.to ? this.to : this.text.lineAt(pos).to;
  }
  next() {
    for (; ; ) {
      let off2 = this.re.lastIndex = this.matchPos - this.flat.from;
      let match2 = this.re.exec(this.flat.text);
      if (match2 && !match2[0] && match2.index == off2) {
        this.re.lastIndex = off2 + 1;
        match2 = this.re.exec(this.flat.text);
      }
      if (match2) {
        let from = this.flat.from + match2.index, to2 = from + match2[0].length;
        if ((this.flat.to >= this.to || match2.index + match2[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to2, match2))) {
          this.value = { from, to: to2, match: match2 };
          this.matchPos = toCharEnd(this.text, to2 + (from == to2 ? 1 : 0));
          return this;
        }
      }
      if (this.flat.to == this.to) {
        this.done = true;
        return this;
      }
      this.flat = FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
if (typeof Symbol != "undefined") {
  RegExpCursor.prototype[Symbol.iterator] = MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
}
function validRegExp(source) {
  try {
    new RegExp(source, baseFlags);
    return true;
  } catch (_a2) {
    return false;
  }
}
function toCharEnd(text2, pos) {
  if (pos >= text2.length)
    return pos;
  let line2 = text2.lineAt(pos), next;
  while (pos < line2.to && (next = line2.text.charCodeAt(pos - line2.from)) >= 56320 && next < 57344)
    pos++;
  return pos;
}
function createLineDialog(view) {
  let line2 = String(view.state.doc.lineAt(view.state.selection.main.head).number);
  let input = crelt("input", { class: "cm-textfield", name: "line", value: line2 });
  let dom = crelt("form", {
    class: "cm-gotoLine",
    onkeydown: (event) => {
      if (event.keyCode == 27) {
        event.preventDefault();
        view.dispatch({ effects: dialogEffect.of(false) });
        view.focus();
      } else if (event.keyCode == 13) {
        event.preventDefault();
        go2();
      }
    },
    onsubmit: (event) => {
      event.preventDefault();
      go2();
    }
  }, crelt("label", view.state.phrase("Go to line"), ": ", input), " ", crelt("button", { class: "cm-button", type: "submit" }, view.state.phrase("go")), crelt("button", {
    name: "close",
    onclick: () => {
      view.dispatch({ effects: dialogEffect.of(false) });
      view.focus();
    },
    "aria-label": view.state.phrase("close"),
    type: "button"
  }, ["×"]));
  function go2() {
    let match2 = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(input.value);
    if (!match2)
      return;
    let { state } = view, startLine = state.doc.lineAt(state.selection.main.head);
    let [, sign2, ln2, cl, percent] = match2;
    let col = cl ? +cl.slice(1) : 0;
    let line22 = ln2 ? +ln2 : startLine.number;
    if (ln2 && percent) {
      let pc = line22 / 100;
      if (sign2)
        pc = pc * (sign2 == "-" ? -1 : 1) + startLine.number / state.doc.lines;
      line22 = Math.round(state.doc.lines * pc);
    } else if (ln2 && sign2) {
      line22 = line22 * (sign2 == "-" ? -1 : 1) + startLine.number;
    }
    let docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line22)));
    let selection2 = EditorSelection.cursor(docLine.from + Math.max(0, Math.min(col, docLine.length)));
    view.dispatch({
      effects: [dialogEffect.of(false), EditorView.scrollIntoView(selection2.from, { y: "center" })],
      selection: selection2
    });
    view.focus();
  }
  return { dom };
}
const dialogEffect = /* @__PURE__ */ StateEffect.define();
const dialogField = /* @__PURE__ */ StateField.define({
  create() {
    return true;
  },
  update(value, tr2) {
    for (let e2 of tr2.effects)
      if (e2.is(dialogEffect))
        value = e2.value;
    return value;
  },
  provide: (f2) => showPanel.from(f2, (val) => val ? createLineDialog : null)
});
const gotoLine = (view) => {
  let panel = getPanel(view, createLineDialog);
  if (!panel) {
    let effects = [dialogEffect.of(true)];
    if (view.state.field(dialogField, false) == null)
      effects.push(StateEffect.appendConfig.of([dialogField, baseTheme$1$1]));
    view.dispatch({ effects });
    panel = getPanel(view, createLineDialog);
  }
  if (panel)
    panel.dom.querySelector("input").select();
  return true;
};
const baseTheme$1$1 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    position: "relative",
    "& label": { fontSize: "80%" },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      bottom: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: "0"
    }
  }
});
const defaultHighlightOptions = {
  highlightWordAroundCursor: false,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: false
};
const highlightConfig = /* @__PURE__ */ Facet.define({
  combine(options2) {
    return combineConfig(options2, defaultHighlightOptions, {
      highlightWordAroundCursor: (a, b2) => a || b2,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function highlightSelectionMatches(options2) {
  let ext = [defaultTheme, matchHighlighter];
  return ext;
}
const matchDeco = /* @__PURE__ */ Decoration.mark({ class: "cm-selectionMatch" });
const mainMatchDeco = /* @__PURE__ */ Decoration.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function insideWordBoundaries(check, state, from, to2) {
  return (from == 0 || check(state.sliceDoc(from - 1, from)) != CharCategory.Word) && (to2 == state.doc.length || check(state.sliceDoc(to2, to2 + 1)) != CharCategory.Word);
}
function insideWord(check, state, from, to2) {
  return check(state.sliceDoc(from, from + 1)) == CharCategory.Word && check(state.sliceDoc(to2 - 1, to2)) == CharCategory.Word;
}
const matchHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.decorations = this.getDeco(view);
  }
  update(update) {
    if (update.selectionSet || update.docChanged || update.viewportChanged)
      this.decorations = this.getDeco(update.view);
  }
  getDeco(view) {
    let conf = view.state.facet(highlightConfig);
    let { state } = view, sel = state.selection;
    if (sel.ranges.length > 1)
      return Decoration.none;
    let range2 = sel.main, query, check = null;
    if (range2.empty) {
      if (!conf.highlightWordAroundCursor)
        return Decoration.none;
      let word = state.wordAt(range2.head);
      if (!word)
        return Decoration.none;
      check = state.charCategorizer(range2.head);
      query = state.sliceDoc(word.from, word.to);
    } else {
      let len = range2.to - range2.from;
      if (len < conf.minSelectionLength || len > 200)
        return Decoration.none;
      if (conf.wholeWords) {
        query = state.sliceDoc(range2.from, range2.to);
        check = state.charCategorizer(range2.head);
        if (!(insideWordBoundaries(check, state, range2.from, range2.to) && insideWord(check, state, range2.from, range2.to)))
          return Decoration.none;
      } else {
        query = state.sliceDoc(range2.from, range2.to);
        if (!query)
          return Decoration.none;
      }
    }
    let deco = [];
    for (let part of view.visibleRanges) {
      let cursor2 = new SearchCursor(state.doc, query, part.from, part.to);
      while (!cursor2.next().done) {
        let { from, to: to2 } = cursor2.value;
        if (!check || insideWordBoundaries(check, state, from, to2)) {
          if (range2.empty && from <= range2.from && to2 >= range2.to)
            deco.push(mainMatchDeco.range(from, to2));
          else if (from >= range2.to || to2 <= range2.from)
            deco.push(matchDeco.range(from, to2));
          if (deco.length > conf.maxMatches)
            return Decoration.none;
        }
      }
    }
    return Decoration.set(deco);
  }
}, {
  decorations: (v2) => v2.decorations
});
const defaultTheme = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
});
const selectWord = ({ state, dispatch }) => {
  let { selection: selection2 } = state;
  let newSel = EditorSelection.create(selection2.ranges.map((range2) => state.wordAt(range2.head) || EditorSelection.cursor(range2.head)), selection2.mainIndex);
  if (newSel.eq(selection2))
    return false;
  dispatch(state.update({ selection: newSel }));
  return true;
};
function findNextOccurrence(state, query) {
  let { main: main2, ranges } = state.selection;
  let word = state.wordAt(main2.head), fullWord = word && word.from == main2.from && word.to == main2.to;
  for (let cycled = false, cursor2 = new SearchCursor(state.doc, query, ranges[ranges.length - 1].to); ; ) {
    cursor2.next();
    if (cursor2.done) {
      if (cycled)
        return null;
      cursor2 = new SearchCursor(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
      cycled = true;
    } else {
      if (cycled && ranges.some((r) => r.from == cursor2.value.from))
        continue;
      if (fullWord) {
        let word2 = state.wordAt(cursor2.value.from);
        if (!word2 || word2.from != cursor2.value.from || word2.to != cursor2.value.to)
          continue;
      }
      return cursor2.value;
    }
  }
}
const selectNextOccurrence = ({ state, dispatch }) => {
  let { ranges } = state.selection;
  if (ranges.some((sel) => sel.from === sel.to))
    return selectWord({ state, dispatch });
  let searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
  if (state.selection.ranges.some((r) => state.sliceDoc(r.from, r.to) != searchedText))
    return false;
  let range2 = findNextOccurrence(state, searchedText);
  if (!range2)
    return false;
  dispatch(state.update({
    selection: state.selection.addRange(EditorSelection.range(range2.from, range2.to), false),
    effects: EditorView.scrollIntoView(range2.to)
  }));
  return true;
};
const searchConfigFacet = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      top: false,
      caseSensitive: false,
      literal: false,
      regexp: false,
      wholeWord: false,
      createPanel: (view) => new SearchPanel(view),
      scrollToMatch: (range2) => EditorView.scrollIntoView(range2)
    });
  }
});
class SearchQuery {
  /**
  Create a query object.
  */
  constructor(config2) {
    this.search = config2.search;
    this.caseSensitive = !!config2.caseSensitive;
    this.literal = !!config2.literal;
    this.regexp = !!config2.regexp;
    this.replace = config2.replace || "";
    this.valid = !!this.search && (!this.regexp || validRegExp(this.search));
    this.unquoted = this.unquote(this.search);
    this.wholeWord = !!config2.wholeWord;
  }
  /**
  @internal
  */
  unquote(text2) {
    return this.literal ? text2 : text2.replace(/\\([nrt\\])/g, (_2, ch) => ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(other) {
    return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new RegExpQuery(this) : new StringQuery(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(state, from = 0, to2) {
    let st2 = state.doc ? state : EditorState.create({ doc: state });
    if (to2 == null)
      to2 = st2.doc.length;
    return this.regexp ? regexpCursor(this, st2, from, to2) : stringCursor(this, st2, from, to2);
  }
}
class QueryType {
  constructor(spec) {
    this.spec = spec;
  }
}
function stringCursor(spec, state, from, to2) {
  return new SearchCursor(state.doc, spec.unquoted, from, to2, spec.caseSensitive ? void 0 : (x2) => x2.toLowerCase(), spec.wholeWord ? stringWordTest(state.doc, state.charCategorizer(state.selection.main.head)) : void 0);
}
function stringWordTest(doc2, categorizer) {
  return (from, to2, buf, bufPos) => {
    if (bufPos > from || bufPos + buf.length < to2) {
      bufPos = Math.max(0, from - 2);
      buf = doc2.sliceString(bufPos, Math.min(doc2.length, to2 + 2));
    }
    return (categorizer(charBefore(buf, from - bufPos)) != CharCategory.Word || categorizer(charAfter(buf, from - bufPos)) != CharCategory.Word) && (categorizer(charAfter(buf, to2 - bufPos)) != CharCategory.Word || categorizer(charBefore(buf, to2 - bufPos)) != CharCategory.Word);
  };
}
class StringQuery extends QueryType {
  constructor(spec) {
    super(spec);
  }
  nextMatch(state, curFrom, curTo) {
    let cursor2 = stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
    if (cursor2.done) {
      let end = Math.min(state.doc.length, curFrom + this.spec.unquoted.length);
      cursor2 = stringCursor(this.spec, state, 0, end).nextOverlapping();
    }
    return cursor2.done || cursor2.value.from == curFrom && cursor2.value.to == curTo ? null : cursor2.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(state, from, to2) {
    for (let pos = to2; ; ) {
      let start = Math.max(from, pos - 1e4 - this.spec.unquoted.length);
      let cursor2 = stringCursor(this.spec, state, start, pos), range2 = null;
      while (!cursor2.nextOverlapping().done)
        range2 = cursor2.value;
      if (range2)
        return range2;
      if (start == from)
        return null;
      pos -= 1e4;
    }
  }
  prevMatch(state, curFrom, curTo) {
    let found = this.prevMatchInRange(state, 0, curFrom);
    if (!found)
      found = this.prevMatchInRange(state, Math.max(0, curTo - this.spec.unquoted.length), state.doc.length);
    return found && (found.from != curFrom || found.to != curTo) ? found : null;
  }
  getReplacement(_result) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(state, limit) {
    let cursor2 = stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
    while (!cursor2.next().done) {
      if (ranges.length >= limit)
        return null;
      ranges.push(cursor2.value);
    }
    return ranges;
  }
  highlight(state, from, to2, add2) {
    let cursor2 = stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to2 + this.spec.unquoted.length, state.doc.length));
    while (!cursor2.next().done)
      add2(cursor2.value.from, cursor2.value.to);
  }
}
function regexpCursor(spec, state, from, to2) {
  return new RegExpCursor(state.doc, spec.search, {
    ignoreCase: !spec.caseSensitive,
    test: spec.wholeWord ? regexpWordTest(state.charCategorizer(state.selection.main.head)) : void 0
  }, from, to2);
}
function charBefore(str, index2) {
  return str.slice(findClusterBreak(str, index2, false), index2);
}
function charAfter(str, index2) {
  return str.slice(index2, findClusterBreak(str, index2));
}
function regexpWordTest(categorizer) {
  return (_from, _to, match2) => !match2[0].length || (categorizer(charBefore(match2.input, match2.index)) != CharCategory.Word || categorizer(charAfter(match2.input, match2.index)) != CharCategory.Word) && (categorizer(charAfter(match2.input, match2.index + match2[0].length)) != CharCategory.Word || categorizer(charBefore(match2.input, match2.index + match2[0].length)) != CharCategory.Word);
}
class RegExpQuery extends QueryType {
  nextMatch(state, curFrom, curTo) {
    let cursor2 = regexpCursor(this.spec, state, curTo, state.doc.length).next();
    if (cursor2.done)
      cursor2 = regexpCursor(this.spec, state, 0, curFrom).next();
    return cursor2.done ? null : cursor2.value;
  }
  prevMatchInRange(state, from, to2) {
    for (let size2 = 1; ; size2++) {
      let start = Math.max(
        from,
        to2 - size2 * 1e4
        /* FindPrev.ChunkSize */
      );
      let cursor2 = regexpCursor(this.spec, state, start, to2), range2 = null;
      while (!cursor2.next().done)
        range2 = cursor2.value;
      if (range2 && (start == from || range2.from > start + 10))
        return range2;
      if (start == from)
        return null;
    }
  }
  prevMatch(state, curFrom, curTo) {
    return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
  }
  getReplacement(result2) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (m, i2) => {
      if (i2 == "&")
        return result2.match[0];
      if (i2 == "$")
        return "$";
      for (let l = i2.length; l > 0; l--) {
        let n = +i2.slice(0, l);
        if (n > 0 && n < result2.match.length)
          return result2.match[n] + i2.slice(l);
      }
      return m;
    });
  }
  matchAll(state, limit) {
    let cursor2 = regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
    while (!cursor2.next().done) {
      if (ranges.length >= limit)
        return null;
      ranges.push(cursor2.value);
    }
    return ranges;
  }
  highlight(state, from, to2, add2) {
    let cursor2 = regexpCursor(this.spec, state, Math.max(
      0,
      from - 250
      /* RegExp.HighlightMargin */
    ), Math.min(to2 + 250, state.doc.length));
    while (!cursor2.next().done)
      add2(cursor2.value.from, cursor2.value.to);
  }
}
const setSearchQuery = /* @__PURE__ */ StateEffect.define();
const togglePanel$1 = /* @__PURE__ */ StateEffect.define();
const searchState = /* @__PURE__ */ StateField.define({
  create(state) {
    return new SearchState(defaultQuery(state).create(), null);
  },
  update(value, tr2) {
    for (let effect of tr2.effects) {
      if (effect.is(setSearchQuery))
        value = new SearchState(effect.value.create(), value.panel);
      else if (effect.is(togglePanel$1))
        value = new SearchState(value.query, effect.value ? createSearchPanel : null);
    }
    return value;
  },
  provide: (f2) => showPanel.from(f2, (val) => val.panel)
});
class SearchState {
  constructor(query, panel) {
    this.query = query;
    this.panel = panel;
  }
}
const matchMark = /* @__PURE__ */ Decoration.mark({ class: "cm-searchMatch" }), selectedMatchMark = /* @__PURE__ */ Decoration.mark({ class: "cm-searchMatch cm-searchMatch-selected" });
const searchHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.decorations = this.highlight(view.state.field(searchState));
  }
  update(update) {
    let state = update.state.field(searchState);
    if (state != update.startState.field(searchState) || update.docChanged || update.selectionSet || update.viewportChanged)
      this.decorations = this.highlight(state);
  }
  highlight({ query, panel }) {
    if (!panel || !query.spec.valid)
      return Decoration.none;
    let { view } = this;
    let builder = new RangeSetBuilder();
    for (let i2 = 0, ranges = view.visibleRanges, l = ranges.length; i2 < l; i2++) {
      let { from, to: to2 } = ranges[i2];
      while (i2 < l - 1 && to2 > ranges[i2 + 1].from - 2 * 250)
        to2 = ranges[++i2].to;
      query.highlight(view.state, from, to2, (from2, to22) => {
        let selected = view.state.selection.ranges.some((r) => r.from == from2 && r.to == to22);
        builder.add(from2, to22, selected ? selectedMatchMark : matchMark);
      });
    }
    return builder.finish();
  }
}, {
  decorations: (v2) => v2.decorations
});
function searchCommand(f2) {
  return (view) => {
    let state = view.state.field(searchState, false);
    return state && state.query.spec.valid ? f2(view, state) : openSearchPanel(view);
  };
}
const findNext = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { to: to2 } = view.state.selection.main;
  let next = query.nextMatch(view.state, to2, to2);
  if (!next)
    return false;
  let selection2 = EditorSelection.single(next.from, next.to);
  let config2 = view.state.facet(searchConfigFacet);
  view.dispatch({
    selection: selection2,
    effects: [announceMatch(view, next), config2.scrollToMatch(selection2.main, view)],
    userEvent: "select.search"
  });
  selectSearchInput(view);
  return true;
});
const findPrevious = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { state } = view, { from } = state.selection.main;
  let prev = query.prevMatch(state, from, from);
  if (!prev)
    return false;
  let selection2 = EditorSelection.single(prev.from, prev.to);
  let config2 = view.state.facet(searchConfigFacet);
  view.dispatch({
    selection: selection2,
    effects: [announceMatch(view, prev), config2.scrollToMatch(selection2.main, view)],
    userEvent: "select.search"
  });
  selectSearchInput(view);
  return true;
});
const selectMatches = /* @__PURE__ */ searchCommand((view, { query }) => {
  let ranges = query.matchAll(view.state, 1e3);
  if (!ranges || !ranges.length)
    return false;
  view.dispatch({
    selection: EditorSelection.create(ranges.map((r) => EditorSelection.range(r.from, r.to))),
    userEvent: "select.search.matches"
  });
  return true;
});
const selectSelectionMatches = ({ state, dispatch }) => {
  let sel = state.selection;
  if (sel.ranges.length > 1 || sel.main.empty)
    return false;
  let { from, to: to2 } = sel.main;
  let ranges = [], main2 = 0;
  for (let cur2 = new SearchCursor(state.doc, state.sliceDoc(from, to2)); !cur2.next().done; ) {
    if (ranges.length > 1e3)
      return false;
    if (cur2.value.from == from)
      main2 = ranges.length;
    ranges.push(EditorSelection.range(cur2.value.from, cur2.value.to));
  }
  dispatch(state.update({
    selection: EditorSelection.create(ranges, main2),
    userEvent: "select.search.matches"
  }));
  return true;
};
const replaceNext = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { state } = view, { from, to: to2 } = state.selection.main;
  if (state.readOnly)
    return false;
  let match2 = query.nextMatch(state, from, from);
  if (!match2)
    return false;
  let next = match2;
  let changes = [], selection2, replacement;
  let effects = [];
  if (next.from == from && next.to == to2) {
    replacement = state.toText(query.getReplacement(next));
    changes.push({ from: next.from, to: next.to, insert: replacement });
    next = query.nextMatch(state, next.from, next.to);
    effects.push(EditorView.announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
  }
  let changeSet = view.state.changes(changes);
  if (next) {
    selection2 = EditorSelection.single(next.from, next.to).map(changeSet);
    effects.push(announceMatch(view, next));
    effects.push(state.facet(searchConfigFacet).scrollToMatch(selection2.main, view));
  }
  view.dispatch({
    changes: changeSet,
    selection: selection2,
    effects,
    userEvent: "input.replace"
  });
  return true;
});
const replaceAll$1 = /* @__PURE__ */ searchCommand((view, { query }) => {
  if (view.state.readOnly)
    return false;
  let changes = query.matchAll(view.state, 1e9).map((match2) => {
    let { from, to: to2 } = match2;
    return { from, to: to2, insert: query.getReplacement(match2) };
  });
  if (!changes.length)
    return false;
  let announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
  view.dispatch({
    changes,
    effects: EditorView.announce.of(announceText),
    userEvent: "input.replace.all"
  });
  return true;
});
function createSearchPanel(view) {
  return view.state.facet(searchConfigFacet).createPanel(view);
}
function defaultQuery(state, fallback) {
  var _a2, _b, _c, _d, _e2;
  let sel = state.selection.main;
  let selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
  if (fallback && !selText)
    return fallback;
  let config2 = state.facet(searchConfigFacet);
  return new SearchQuery({
    search: ((_a2 = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a2 !== void 0 ? _a2 : config2.literal) ? selText : selText.replace(/\n/g, "\\n"),
    caseSensitive: (_b = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b !== void 0 ? _b : config2.caseSensitive,
    literal: (_c = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c !== void 0 ? _c : config2.literal,
    regexp: (_d = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d !== void 0 ? _d : config2.regexp,
    wholeWord: (_e2 = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e2 !== void 0 ? _e2 : config2.wholeWord
  });
}
function getSearchInput(view) {
  let panel = getPanel(view, createSearchPanel);
  return panel && panel.dom.querySelector("[main-field]");
}
function selectSearchInput(view) {
  let input = getSearchInput(view);
  if (input && input == view.root.activeElement)
    input.select();
}
const openSearchPanel = (view) => {
  let state = view.state.field(searchState, false);
  if (state && state.panel) {
    let searchInput = getSearchInput(view);
    if (searchInput && searchInput != view.root.activeElement) {
      let query = defaultQuery(view.state, state.query.spec);
      if (query.valid)
        view.dispatch({ effects: setSearchQuery.of(query) });
      searchInput.focus();
      searchInput.select();
    }
  } else {
    view.dispatch({ effects: [
      togglePanel$1.of(true),
      state ? setSearchQuery.of(defaultQuery(view.state, state.query.spec)) : StateEffect.appendConfig.of(searchExtensions)
    ] });
  }
  return true;
};
const closeSearchPanel = (view) => {
  let state = view.state.field(searchState, false);
  if (!state || !state.panel)
    return false;
  let panel = getPanel(view, createSearchPanel);
  if (panel && panel.dom.contains(view.root.activeElement))
    view.focus();
  view.dispatch({ effects: togglePanel$1.of(false) });
  return true;
};
const searchKeymap = [
  { key: "Mod-f", run: openSearchPanel, scope: "editor search-panel" },
  { key: "F3", run: findNext, shift: findPrevious, scope: "editor search-panel", preventDefault: true },
  { key: "Mod-g", run: findNext, shift: findPrevious, scope: "editor search-panel", preventDefault: true },
  { key: "Escape", run: closeSearchPanel, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: selectSelectionMatches },
  { key: "Mod-Alt-g", run: gotoLine },
  { key: "Mod-d", run: selectNextOccurrence, preventDefault: true }
];
class SearchPanel {
  constructor(view) {
    this.view = view;
    let query = this.query = view.state.field(searchState).query.spec;
    this.commit = this.commit.bind(this);
    this.searchField = crelt("input", {
      value: query.search,
      placeholder: phrase(view, "Find"),
      "aria-label": phrase(view, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    });
    this.replaceField = crelt("input", {
      value: query.replace,
      placeholder: phrase(view, "Replace"),
      "aria-label": phrase(view, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    });
    this.caseField = crelt("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: query.caseSensitive,
      onchange: this.commit
    });
    this.reField = crelt("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: query.regexp,
      onchange: this.commit
    });
    this.wordField = crelt("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: query.wholeWord,
      onchange: this.commit
    });
    function button(name2, onclick, content2) {
      return crelt("button", { class: "cm-button", name: name2, onclick, type: "button" }, content2);
    }
    this.dom = crelt("div", { onkeydown: (e2) => this.keydown(e2), class: "cm-search" }, [
      this.searchField,
      button("next", () => findNext(view), [phrase(view, "next")]),
      button("prev", () => findPrevious(view), [phrase(view, "previous")]),
      button("select", () => selectMatches(view), [phrase(view, "all")]),
      crelt("label", null, [this.caseField, phrase(view, "match case")]),
      crelt("label", null, [this.reField, phrase(view, "regexp")]),
      crelt("label", null, [this.wordField, phrase(view, "by word")]),
      ...view.state.readOnly ? [] : [
        crelt("br"),
        this.replaceField,
        button("replace", () => replaceNext(view), [phrase(view, "replace")]),
        button("replaceAll", () => replaceAll$1(view), [phrase(view, "replace all")])
      ],
      crelt("button", {
        name: "close",
        onclick: () => closeSearchPanel(view),
        "aria-label": phrase(view, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let query = new SearchQuery({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    if (!query.eq(this.query)) {
      this.query = query;
      this.view.dispatch({ effects: setSearchQuery.of(query) });
    }
  }
  keydown(e2) {
    if (runScopeHandlers(this.view, e2, "search-panel")) {
      e2.preventDefault();
    } else if (e2.keyCode == 13 && e2.target == this.searchField) {
      e2.preventDefault();
      (e2.shiftKey ? findPrevious : findNext)(this.view);
    } else if (e2.keyCode == 13 && e2.target == this.replaceField) {
      e2.preventDefault();
      replaceNext(this.view);
    }
  }
  update(update) {
    for (let tr2 of update.transactions)
      for (let effect of tr2.effects) {
        if (effect.is(setSearchQuery) && !effect.value.eq(this.query))
          this.setQuery(effect.value);
      }
  }
  setQuery(query) {
    this.query = query;
    this.searchField.value = query.search;
    this.replaceField.value = query.replace;
    this.caseField.checked = query.caseSensitive;
    this.reField.checked = query.regexp;
    this.wordField.checked = query.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(searchConfigFacet).top;
  }
}
function phrase(view, phrase2) {
  return view.state.phrase(phrase2);
}
const AnnounceMargin = 30;
const Break = /[\s\.,:;?!]/;
function announceMatch(view, { from, to: to2 }) {
  let line2 = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to2).to;
  let start = Math.max(line2.from, from - AnnounceMargin), end = Math.min(lineEnd, to2 + AnnounceMargin);
  let text2 = view.state.sliceDoc(start, end);
  if (start != line2.from) {
    for (let i2 = 0; i2 < AnnounceMargin; i2++)
      if (!Break.test(text2[i2 + 1]) && Break.test(text2[i2])) {
        text2 = text2.slice(i2);
        break;
      }
  }
  if (end != lineEnd) {
    for (let i2 = text2.length - 1; i2 > text2.length - AnnounceMargin; i2--)
      if (!Break.test(text2[i2 - 1]) && Break.test(text2[i2])) {
        text2 = text2.slice(0, i2);
        break;
      }
  }
  return EditorView.announce.of(`${view.state.phrase("current match")}. ${text2} ${view.state.phrase("on line")} ${line2.number}.`);
}
const baseTheme$2 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
});
const searchExtensions = [
  searchState,
  /* @__PURE__ */ Prec.low(searchHighlighter),
  baseTheme$2
];
class CompletionContext {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(state, pos, explicit, view) {
    this.state = state;
    this.pos = pos;
    this.explicit = explicit;
    this.view = view;
    this.abortListeners = [];
    this.abortOnDocChange = false;
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(types2) {
    let token = syntaxTree(this.state).resolveInner(this.pos, -1);
    while (token && types2.indexOf(token.name) < 0)
      token = token.parent;
    return token ? {
      from: token.from,
      to: this.pos,
      text: this.state.sliceDoc(token.from, this.pos),
      type: token.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(expr) {
    let line2 = this.state.doc.lineAt(this.pos);
    let start = Math.max(line2.from, this.pos - 250);
    let str = line2.text.slice(start - line2.from, this.pos - line2.from);
    let found = str.search(ensureAnchor(expr, false));
    return found < 0 ? null : { from: start + found, to: this.pos, text: str.slice(found) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  
  By default, running queries will not be aborted for regular
  typing or backspacing, on the assumption that they are likely to
  return a result with a
  [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
  allows the result to be used after all. Passing `onDocChange:
  true` will cause this query to be aborted for any document
  change.
  */
  addEventListener(type, listener, options2) {
    if (type == "abort" && this.abortListeners) {
      this.abortListeners.push(listener);
      if (options2 && options2.onDocChange)
        this.abortOnDocChange = true;
    }
  }
}
function toSet$1(chars2) {
  let flat = Object.keys(chars2).join("");
  let words = /\w/.test(flat);
  if (words)
    flat = flat.replace(/\w/g, "");
  return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function prefixMatch$1(options2) {
  let first2 = /* @__PURE__ */ Object.create(null), rest2 = /* @__PURE__ */ Object.create(null);
  for (let { label: label2 } of options2) {
    first2[label2[0]] = true;
    for (let i2 = 1; i2 < label2.length; i2++)
      rest2[label2[i2]] = true;
  }
  let source = toSet$1(first2) + toSet$1(rest2) + "*$";
  return [new RegExp("^" + source), new RegExp(source)];
}
function completeFromList(list2) {
  let options2 = list2.map((o) => typeof o == "string" ? { label: o } : o);
  let [validFor, match2] = options2.every((o) => /^\w+$/.test(o.label)) ? [/\w*$/, /\w+$/] : prefixMatch$1(options2);
  return (context) => {
    let token = context.matchBefore(match2);
    return token || context.explicit ? { from: token ? token.from : context.pos, options: options2, validFor } : null;
  };
}
class Option {
  constructor(completion, source, match2, score2) {
    this.completion = completion;
    this.source = source;
    this.match = match2;
    this.score = score2;
  }
}
function cur(state) {
  return state.selection.main.from;
}
function ensureAnchor(expr, start) {
  var _a2;
  let { source } = expr;
  let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
  if (!addStart && !addEnd)
    return expr;
  return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a2 = expr.flags) !== null && _a2 !== void 0 ? _a2 : expr.ignoreCase ? "i" : "");
}
const pickedCompletion = /* @__PURE__ */ Annotation.define();
function insertCompletionText(state, text2, from, to2) {
  let { main: main2 } = state.selection, fromOff = from - main2.from, toOff = to2 - main2.from;
  return {
    ...state.changeByRange((range2) => {
      if (range2 != main2 && from != to2 && state.sliceDoc(range2.from + fromOff, range2.from + toOff) != state.sliceDoc(from, to2))
        return { range: range2 };
      let lines = state.toText(text2);
      return {
        changes: { from: range2.from + fromOff, to: to2 == main2.from ? range2.to : range2.from + toOff, insert: lines },
        range: EditorSelection.cursor(range2.from + fromOff + lines.length)
      };
    }),
    scrollIntoView: true,
    userEvent: "input.complete"
  };
}
const SourceCache = /* @__PURE__ */ new WeakMap();
function asSource(source) {
  if (!Array.isArray(source))
    return source;
  let known = SourceCache.get(source);
  if (!known)
    SourceCache.set(source, known = completeFromList(source));
  return known;
}
const startCompletionEffect = /* @__PURE__ */ StateEffect.define();
const closeCompletionEffect = /* @__PURE__ */ StateEffect.define();
class FuzzyMatcher {
  constructor(pattern) {
    this.pattern = pattern;
    this.chars = [];
    this.folded = [];
    this.any = [];
    this.precise = [];
    this.byWord = [];
    this.score = 0;
    this.matched = [];
    for (let p = 0; p < pattern.length; ) {
      let char = codePointAt(pattern, p), size2 = codePointSize(char);
      this.chars.push(char);
      let part = pattern.slice(p, p + size2), upper = part.toUpperCase();
      this.folded.push(codePointAt(upper == part ? part.toLowerCase() : upper, 0));
      p += size2;
    }
    this.astral = pattern.length != this.chars.length;
  }
  ret(score2, matched) {
    this.score = score2;
    this.matched = matched;
    return this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(word) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (word.length < this.pattern.length)
      return null;
    let { chars: chars2, folded, any, precise, byWord } = this;
    if (chars2.length == 1) {
      let first2 = codePointAt(word, 0), firstSize = codePointSize(first2);
      let score2 = firstSize == word.length ? 0 : -100;
      if (first2 == chars2[0]) ;
      else if (first2 == folded[0])
        score2 += -200;
      else
        return null;
      return this.ret(score2, [0, firstSize]);
    }
    let direct = word.indexOf(this.pattern);
    if (direct == 0)
      return this.ret(word.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let len = chars2.length, anyTo = 0;
    if (direct < 0) {
      for (let i2 = 0, e2 = Math.min(word.length, 200); i2 < e2 && anyTo < len; ) {
        let next = codePointAt(word, i2);
        if (next == chars2[anyTo] || next == folded[anyTo])
          any[anyTo++] = i2;
        i2 += codePointSize(next);
      }
      if (anyTo < len)
        return null;
    }
    let preciseTo = 0;
    let byWordTo = 0, byWordFolded = false;
    let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
    let hasLower = /[a-z]/.test(word), wordAdjacent = true;
    for (let i2 = 0, e2 = Math.min(word.length, 200), prevType = 0; i2 < e2 && byWordTo < len; ) {
      let next = codePointAt(word, i2);
      if (direct < 0) {
        if (preciseTo < len && next == chars2[preciseTo])
          precise[preciseTo++] = i2;
        if (adjacentTo < len) {
          if (next == chars2[adjacentTo] || next == folded[adjacentTo]) {
            if (adjacentTo == 0)
              adjacentStart = i2;
            adjacentEnd = i2 + 1;
            adjacentTo++;
          } else {
            adjacentTo = 0;
          }
        }
      }
      let ch, type = next < 255 ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 : next >= 65 && next <= 90 ? 1 : 0 : (ch = fromCodePoint(next)) != ch.toLowerCase() ? 1 : ch != ch.toUpperCase() ? 2 : 0;
      if (!i2 || type == 1 && hasLower || prevType == 0 && type != 0) {
        if (chars2[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true))
          byWord[byWordTo++] = i2;
        else if (byWord.length)
          wordAdjacent = false;
      }
      prevType = type;
      i2 += codePointSize(next);
    }
    if (byWordTo == len && byWord[0] == 0 && wordAdjacent)
      return this.result(-100 + (byWordFolded ? -200 : 0), byWord, word);
    if (adjacentTo == len && adjacentStart == 0)
      return this.ret(-200 - word.length + (adjacentEnd == word.length ? 0 : -100), [0, adjacentEnd]);
    if (direct > -1)
      return this.ret(-700 - word.length, [direct, direct + this.pattern.length]);
    if (adjacentTo == len)
      return this.ret(-200 + -700 - word.length, [adjacentStart, adjacentEnd]);
    if (byWordTo == len)
      return this.result(-100 + (byWordFolded ? -200 : 0) + -700 + (wordAdjacent ? 0 : -1100), byWord, word);
    return chars2.length == 2 ? null : this.result((any[0] ? -700 : 0) + -200 + -1100, any, word);
  }
  result(score2, positions, word) {
    let result2 = [], i2 = 0;
    for (let pos of positions) {
      let to2 = pos + (this.astral ? codePointSize(codePointAt(word, pos)) : 1);
      if (i2 && result2[i2 - 1] == pos)
        result2[i2 - 1] = to2;
      else {
        result2[i2++] = pos;
        result2[i2++] = to2;
      }
    }
    return this.ret(score2 - word.length, result2);
  }
}
class StrictMatcher {
  constructor(pattern) {
    this.pattern = pattern;
    this.matched = [];
    this.score = 0;
    this.folded = pattern.toLowerCase();
  }
  match(word) {
    if (word.length < this.pattern.length)
      return null;
    let start = word.slice(0, this.pattern.length);
    let match2 = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 : null;
    if (match2 == null)
      return null;
    this.matched = [0, start.length];
    this.score = match2 + (word.length == this.pattern.length ? 0 : -100);
    return this;
  }
}
const completionConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      activateOnTyping: true,
      activateOnCompletion: () => false,
      activateOnTypingDelay: 100,
      selectOnOpen: true,
      override: null,
      closeOnBlur: true,
      maxRenderedOptions: 100,
      defaultKeymap: true,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: false,
      icons: true,
      addToOptions: [],
      positionInfo: defaultPositionInfo,
      filterStrict: false,
      compareCompletions: (a, b2) => (a.sortText || a.label).localeCompare(b2.sortText || b2.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (a, b2) => a && b2,
      closeOnBlur: (a, b2) => a && b2,
      icons: (a, b2) => a && b2,
      tooltipClass: (a, b2) => (c2) => joinClass(a(c2), b2(c2)),
      optionClass: (a, b2) => (c2) => joinClass(a(c2), b2(c2)),
      addToOptions: (a, b2) => a.concat(b2),
      filterStrict: (a, b2) => a || b2
    });
  }
});
function joinClass(a, b2) {
  return a ? b2 ? a + " " + b2 : a : b2;
}
function defaultPositionInfo(view, list2, option, info, space, tooltip) {
  let rtl = view.textDirection == Direction.RTL, left = rtl, narrow = false;
  let side = "top", offset2, maxWidth;
  let spaceLeft = list2.left - space.left, spaceRight = space.right - list2.right;
  let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
  if (left && spaceLeft < Math.min(infoWidth, spaceRight))
    left = false;
  else if (!left && spaceRight < Math.min(infoWidth, spaceLeft))
    left = true;
  if (infoWidth <= (left ? spaceLeft : spaceRight)) {
    offset2 = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list2.top;
    maxWidth = Math.min(400, left ? spaceLeft : spaceRight);
  } else {
    narrow = true;
    maxWidth = Math.min(
      400,
      (rtl ? list2.right : space.right - list2.left) - 30
      /* Info.Margin */
    );
    let spaceBelow = space.bottom - list2.bottom;
    if (spaceBelow >= infoHeight || spaceBelow > list2.top) {
      offset2 = option.bottom - list2.top;
    } else {
      side = "bottom";
      offset2 = list2.bottom - option.top;
    }
  }
  let scaleY = (list2.bottom - list2.top) / tooltip.offsetHeight;
  let scaleX = (list2.right - list2.left) / tooltip.offsetWidth;
  return {
    style: `${side}: ${offset2 / scaleY}px; max-width: ${maxWidth / scaleX}px`,
    class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
  };
}
function optionContent(config2) {
  let content2 = config2.addToOptions.slice();
  if (config2.icons)
    content2.push({
      render(completion) {
        let icon = document.createElement("div");
        icon.classList.add("cm-completionIcon");
        if (completion.type)
          icon.classList.add(...completion.type.split(/\s+/g).map((cls) => "cm-completionIcon-" + cls));
        icon.setAttribute("aria-hidden", "true");
        return icon;
      },
      position: 20
    });
  content2.push({
    render(completion, _s, _v, match2) {
      let labelElt = document.createElement("span");
      labelElt.className = "cm-completionLabel";
      let label2 = completion.displayLabel || completion.label, off2 = 0;
      for (let j2 = 0; j2 < match2.length; ) {
        let from = match2[j2++], to2 = match2[j2++];
        if (from > off2)
          labelElt.appendChild(document.createTextNode(label2.slice(off2, from)));
        let span = labelElt.appendChild(document.createElement("span"));
        span.appendChild(document.createTextNode(label2.slice(from, to2)));
        span.className = "cm-completionMatchedText";
        off2 = to2;
      }
      if (off2 < label2.length)
        labelElt.appendChild(document.createTextNode(label2.slice(off2)));
      return labelElt;
    },
    position: 50
  }, {
    render(completion) {
      if (!completion.detail)
        return null;
      let detailElt = document.createElement("span");
      detailElt.className = "cm-completionDetail";
      detailElt.textContent = completion.detail;
      return detailElt;
    },
    position: 80
  });
  return content2.sort((a, b2) => a.position - b2.position).map((a) => a.render);
}
function rangeAroundSelected(total, selected, max2) {
  if (total <= max2)
    return { from: 0, to: total };
  if (selected < 0)
    selected = 0;
  if (selected <= total >> 1) {
    let off22 = Math.floor(selected / max2);
    return { from: off22 * max2, to: (off22 + 1) * max2 };
  }
  let off2 = Math.floor((total - selected) / max2);
  return { from: total - (off2 + 1) * max2, to: total - off2 * max2 };
}
class CompletionTooltip {
  constructor(view, stateField, applyCompletion2) {
    this.view = view;
    this.stateField = stateField;
    this.applyCompletion = applyCompletion2;
    this.info = null;
    this.infoDestroy = null;
    this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (pos) => this.placeInfo(pos),
      key: this
    };
    this.space = null;
    this.currentClass = "";
    let cState = view.state.field(stateField);
    let { options: options2, selected } = cState.open;
    let config2 = view.state.facet(completionConfig);
    this.optionContent = optionContent(config2);
    this.optionClass = config2.optionClass;
    this.tooltipClass = config2.tooltipClass;
    this.range = rangeAroundSelected(options2.length, selected, config2.maxRenderedOptions);
    this.dom = document.createElement("div");
    this.dom.className = "cm-tooltip-autocomplete";
    this.updateTooltipClass(view.state);
    this.dom.addEventListener("mousedown", (e2) => {
      let { options: options22 } = view.state.field(stateField).open;
      for (let dom = e2.target, match2; dom && dom != this.dom; dom = dom.parentNode) {
        if (dom.nodeName == "LI" && (match2 = /-(\d+)$/.exec(dom.id)) && +match2[1] < options22.length) {
          this.applyCompletion(view, options22[+match2[1]]);
          e2.preventDefault();
          return;
        }
      }
    });
    this.dom.addEventListener("focusout", (e2) => {
      let state = view.state.field(this.stateField, false);
      if (state && state.tooltip && view.state.facet(completionConfig).closeOnBlur && e2.relatedTarget != view.contentDOM)
        view.dispatch({ effects: closeCompletionEffect.of(null) });
    });
    this.showOptions(options2, cState.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(options2, id2) {
    if (this.list)
      this.list.remove();
    this.list = this.dom.appendChild(this.createListBox(options2, id2, this.range));
    this.list.addEventListener("scroll", () => {
      if (this.info)
        this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(update) {
    var _a2;
    let cState = update.state.field(this.stateField);
    let prevState = update.startState.field(this.stateField);
    this.updateTooltipClass(update.state);
    if (cState != prevState) {
      let { options: options2, selected, disabled } = cState.open;
      if (!prevState.open || prevState.open.options != options2) {
        this.range = rangeAroundSelected(options2.length, selected, update.state.facet(completionConfig).maxRenderedOptions);
        this.showOptions(options2, cState.id);
      }
      this.updateSel();
      if (disabled != ((_a2 = prevState.open) === null || _a2 === void 0 ? void 0 : _a2.disabled))
        this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
    }
  }
  updateTooltipClass(state) {
    let cls = this.tooltipClass(state);
    if (cls != this.currentClass) {
      for (let c2 of this.currentClass.split(" "))
        if (c2)
          this.dom.classList.remove(c2);
      for (let c2 of cls.split(" "))
        if (c2)
          this.dom.classList.add(c2);
      this.currentClass = cls;
    }
  }
  positioned(space) {
    this.space = space;
    if (this.info)
      this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let cState = this.view.state.field(this.stateField), open = cState.open;
    if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
      this.range = rangeAroundSelected(open.options.length, open.selected, this.view.state.facet(completionConfig).maxRenderedOptions);
      this.showOptions(open.options, cState.id);
    }
    let newSel = this.updateSelectedOption(open.selected);
    if (newSel) {
      this.destroyInfo();
      let { completion } = open.options[open.selected];
      let { info } = completion;
      if (!info)
        return;
      let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
      if (!infoResult)
        return;
      if ("then" in infoResult) {
        infoResult.then((obj) => {
          if (obj && this.view.state.field(this.stateField, false) == cState)
            this.addInfoPane(obj, completion);
        }).catch((e2) => logException(this.view.state, e2, "completion info"));
      } else {
        this.addInfoPane(infoResult, completion);
        newSel.setAttribute("aria-describedby", this.info.id);
      }
    }
  }
  addInfoPane(content2, completion) {
    this.destroyInfo();
    let wrap2 = this.info = document.createElement("div");
    wrap2.className = "cm-tooltip cm-completionInfo";
    wrap2.id = "cm-completionInfo-" + Math.floor(Math.random() * 65535).toString(16);
    if (content2.nodeType != null) {
      wrap2.appendChild(content2);
      this.infoDestroy = null;
    } else {
      let { dom, destroy } = content2;
      wrap2.appendChild(dom);
      this.infoDestroy = destroy || null;
    }
    this.dom.appendChild(wrap2);
    this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(selected) {
    let set2 = null;
    for (let opt = this.list.firstChild, i2 = this.range.from; opt; opt = opt.nextSibling, i2++) {
      if (opt.nodeName != "LI" || !opt.id) {
        i2--;
      } else if (i2 == selected) {
        if (!opt.hasAttribute("aria-selected")) {
          opt.setAttribute("aria-selected", "true");
          set2 = opt;
        }
      } else {
        if (opt.hasAttribute("aria-selected")) {
          opt.removeAttribute("aria-selected");
          opt.removeAttribute("aria-describedby");
        }
      }
    }
    if (set2)
      scrollIntoView(this.list, set2);
    return set2;
  }
  measureInfo() {
    let sel = this.dom.querySelector("[aria-selected]");
    if (!sel || !this.info)
      return null;
    let listRect = this.dom.getBoundingClientRect();
    let infoRect = this.info.getBoundingClientRect();
    let selRect = sel.getBoundingClientRect();
    let space = this.space;
    if (!space) {
      let docElt = this.dom.ownerDocument.documentElement;
      space = { left: 0, top: 0, right: docElt.clientWidth, bottom: docElt.clientHeight };
    }
    if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10)
      return null;
    return this.view.state.facet(completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
  }
  placeInfo(pos) {
    if (this.info) {
      if (pos) {
        if (pos.style)
          this.info.style.cssText = pos.style;
        this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
      } else {
        this.info.style.cssText = "top: -1e6px";
      }
    }
  }
  createListBox(options2, id2, range2) {
    const ul = document.createElement("ul");
    ul.id = id2;
    ul.setAttribute("role", "listbox");
    ul.setAttribute("aria-expanded", "true");
    ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
    ul.addEventListener("mousedown", (e2) => {
      if (e2.target == ul)
        e2.preventDefault();
    });
    let curSection = null;
    for (let i2 = range2.from; i2 < range2.to; i2++) {
      let { completion, match: match2 } = options2[i2], { section } = completion;
      if (section) {
        let name2 = typeof section == "string" ? section : section.name;
        if (name2 != curSection && (i2 > range2.from || range2.from == 0)) {
          curSection = name2;
          if (typeof section != "string" && section.header) {
            ul.appendChild(section.header(section));
          } else {
            let header = ul.appendChild(document.createElement("completion-section"));
            header.textContent = name2;
          }
        }
      }
      const li2 = ul.appendChild(document.createElement("li"));
      li2.id = id2 + "-" + i2;
      li2.setAttribute("role", "option");
      let cls = this.optionClass(completion);
      if (cls)
        li2.className = cls;
      for (let source of this.optionContent) {
        let node = source(completion, this.view.state, this.view, match2);
        if (node)
          li2.appendChild(node);
      }
    }
    if (range2.from)
      ul.classList.add("cm-completionListIncompleteTop");
    if (range2.to < options2.length)
      ul.classList.add("cm-completionListIncompleteBottom");
    return ul;
  }
  destroyInfo() {
    if (this.info) {
      if (this.infoDestroy)
        this.infoDestroy();
      this.info.remove();
      this.info = null;
    }
  }
  destroy() {
    this.destroyInfo();
  }
}
function completionTooltip(stateField, applyCompletion2) {
  return (view) => new CompletionTooltip(view, stateField, applyCompletion2);
}
function scrollIntoView(container, element2) {
  let parent = container.getBoundingClientRect();
  let self2 = element2.getBoundingClientRect();
  let scaleY = parent.height / container.offsetHeight;
  if (self2.top < parent.top)
    container.scrollTop -= (parent.top - self2.top) / scaleY;
  else if (self2.bottom > parent.bottom)
    container.scrollTop += (self2.bottom - parent.bottom) / scaleY;
}
function score(option) {
  return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function sortOptions(active, state) {
  let options2 = [];
  let sections = null, dynamicSectionScore = null;
  let addOption = (option) => {
    options2.push(option);
    let { section } = option.completion;
    if (section) {
      if (!sections)
        sections = [];
      let name2 = typeof section == "string" ? section : section.name;
      if (!sections.some((s) => s.name == name2))
        sections.push(typeof section == "string" ? { name: name2 } : section);
    }
  };
  let conf = state.facet(completionConfig);
  for (let a of active)
    if (a.hasResult()) {
      let getMatch = a.result.getMatch;
      if (a.result.filter === false) {
        for (let option of a.result.options) {
          addOption(new Option(option, a.source, getMatch ? getMatch(option) : [], 1e9 - options2.length));
        }
      } else {
        let pattern = state.sliceDoc(a.from, a.to), match2;
        let matcher2 = conf.filterStrict ? new StrictMatcher(pattern) : new FuzzyMatcher(pattern);
        for (let option of a.result.options)
          if (match2 = matcher2.match(option.label)) {
            let matched = !option.displayLabel ? match2.matched : getMatch ? getMatch(option, match2.matched) : [];
            let score2 = match2.score + (option.boost || 0);
            addOption(new Option(option, a.source, matched, score2));
            if (typeof option.section == "object" && option.section.rank === "dynamic") {
              let { name: name2 } = option.section;
              if (!dynamicSectionScore)
                dynamicSectionScore = /* @__PURE__ */ Object.create(null);
              dynamicSectionScore[name2] = Math.max(score2, dynamicSectionScore[name2] || -1e9);
            }
          }
      }
    }
  if (sections) {
    let sectionOrder = /* @__PURE__ */ Object.create(null), pos = 0;
    let cmp = (a, b2) => {
      return (a.rank === "dynamic" && b2.rank === "dynamic" ? dynamicSectionScore[b2.name] - dynamicSectionScore[a.name] : 0) || (typeof a.rank == "number" ? a.rank : 1e9) - (typeof b2.rank == "number" ? b2.rank : 1e9) || (a.name < b2.name ? -1 : 1);
    };
    for (let s of sections.sort(cmp)) {
      pos -= 1e5;
      sectionOrder[s.name] = pos;
    }
    for (let option of options2) {
      let { section } = option.completion;
      if (section)
        option.score += sectionOrder[typeof section == "string" ? section : section.name];
    }
  }
  let result2 = [], prev = null;
  let compare2 = conf.compareCompletions;
  for (let opt of options2.sort((a, b2) => b2.score - a.score || compare2(a.completion, b2.completion))) {
    let cur2 = opt.completion;
    if (!prev || prev.label != cur2.label || prev.detail != cur2.detail || prev.type != null && cur2.type != null && prev.type != cur2.type || prev.apply != cur2.apply || prev.boost != cur2.boost)
      result2.push(opt);
    else if (score(opt.completion) > score(prev))
      result2[result2.length - 1] = opt;
    prev = opt.completion;
  }
  return result2;
}
class CompletionDialog {
  constructor(options2, attrs, tooltip, timestamp, selected, disabled) {
    this.options = options2;
    this.attrs = attrs;
    this.tooltip = tooltip;
    this.timestamp = timestamp;
    this.selected = selected;
    this.disabled = disabled;
  }
  setSelected(selected, id2) {
    return selected == this.selected || selected >= this.options.length ? this : new CompletionDialog(this.options, makeAttrs(id2, selected), this.tooltip, this.timestamp, selected, this.disabled);
  }
  static build(active, state, id2, prev, conf, didSetActive) {
    if (prev && !didSetActive && active.some((s) => s.isPending))
      return prev.setDisabled();
    let options2 = sortOptions(active, state);
    if (!options2.length)
      return prev && active.some((a) => a.isPending) ? prev.setDisabled() : null;
    let selected = state.facet(completionConfig).selectOnOpen ? 0 : -1;
    if (prev && prev.selected != selected && prev.selected != -1) {
      let selectedValue = prev.options[prev.selected].completion;
      for (let i2 = 0; i2 < options2.length; i2++)
        if (options2[i2].completion == selectedValue) {
          selected = i2;
          break;
        }
    }
    return new CompletionDialog(options2, makeAttrs(id2, selected), {
      pos: active.reduce((a, b2) => b2.hasResult() ? Math.min(a, b2.from) : a, 1e8),
      create: createTooltip,
      above: conf.aboveCursor
    }, prev ? prev.timestamp : Date.now(), selected, false);
  }
  map(changes) {
    return new CompletionDialog(this.options, this.attrs, { ...this.tooltip, pos: changes.mapPos(this.tooltip.pos) }, this.timestamp, this.selected, this.disabled);
  }
  setDisabled() {
    return new CompletionDialog(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, true);
  }
}
class CompletionState {
  constructor(active, id2, open) {
    this.active = active;
    this.id = id2;
    this.open = open;
  }
  static start() {
    return new CompletionState(none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(tr2) {
    let { state } = tr2, conf = state.facet(completionConfig);
    let sources = conf.override || state.languageDataAt("autocomplete", cur(state)).map(asSource);
    let active = sources.map((source) => {
      let value = this.active.find((s) => s.source == source) || new ActiveSource(
        source,
        this.active.some(
          (a) => a.state != 0
          /* State.Inactive */
        ) ? 1 : 0
        /* State.Inactive */
      );
      return value.update(tr2, conf);
    });
    if (active.length == this.active.length && active.every((a, i2) => a == this.active[i2]))
      active = this.active;
    let open = this.open, didSet = tr2.effects.some((e2) => e2.is(setActiveEffect));
    if (open && tr2.docChanged)
      open = open.map(tr2.changes);
    if (tr2.selection || active.some((a) => a.hasResult() && tr2.changes.touchesRange(a.from, a.to)) || !sameResults(active, this.active) || didSet)
      open = CompletionDialog.build(active, state, this.id, open, conf, didSet);
    else if (open && open.disabled && !active.some((a) => a.isPending))
      open = null;
    if (!open && active.every((a) => !a.isPending) && active.some((a) => a.hasResult()))
      active = active.map((a) => a.hasResult() ? new ActiveSource(
        a.source,
        0
        /* State.Inactive */
      ) : a);
    for (let effect of tr2.effects)
      if (effect.is(setSelectedEffect))
        open = open && open.setSelected(effect.value, this.id);
    return active == this.active && open == this.open ? this : new CompletionState(active, this.id, open);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : this.active.length ? baseAttrs : noAttrs;
  }
}
function sameResults(a, b2) {
  if (a == b2)
    return true;
  for (let iA = 0, iB = 0; ; ) {
    while (iA < a.length && !a[iA].hasResult())
      iA++;
    while (iB < b2.length && !b2[iB].hasResult())
      iB++;
    let endA = iA == a.length, endB = iB == b2.length;
    if (endA || endB)
      return endA == endB;
    if (a[iA++].result != b2[iB++].result)
      return false;
  }
}
const baseAttrs = {
  "aria-autocomplete": "list"
};
const noAttrs = {};
function makeAttrs(id2, selected) {
  let result2 = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": id2
  };
  if (selected > -1)
    result2["aria-activedescendant"] = id2 + "-" + selected;
  return result2;
}
const none = [];
function getUpdateType(tr2, conf) {
  if (tr2.isUserEvent("input.complete")) {
    let completion = tr2.annotation(pickedCompletion);
    if (completion && conf.activateOnCompletion(completion))
      return 4 | 8;
  }
  let typing = tr2.isUserEvent("input.type");
  return typing && conf.activateOnTyping ? 4 | 1 : typing ? 1 : tr2.isUserEvent("delete.backward") ? 2 : tr2.selection ? 8 : tr2.docChanged ? 16 : 0;
}
class ActiveSource {
  constructor(source, state, explicit = false) {
    this.source = source;
    this.state = state;
    this.explicit = explicit;
  }
  hasResult() {
    return false;
  }
  get isPending() {
    return this.state == 1;
  }
  update(tr2, conf) {
    let type = getUpdateType(tr2, conf), value = this;
    if (type & 8 || type & 16 && this.touches(tr2))
      value = new ActiveSource(
        value.source,
        0
        /* State.Inactive */
      );
    if (type & 4 && value.state == 0)
      value = new ActiveSource(
        this.source,
        1
        /* State.Pending */
      );
    value = value.updateFor(tr2, type);
    for (let effect of tr2.effects) {
      if (effect.is(startCompletionEffect))
        value = new ActiveSource(value.source, 1, effect.value);
      else if (effect.is(closeCompletionEffect))
        value = new ActiveSource(
          value.source,
          0
          /* State.Inactive */
        );
      else if (effect.is(setActiveEffect)) {
        for (let active of effect.value)
          if (active.source == value.source)
            value = active;
      }
    }
    return value;
  }
  updateFor(tr2, type) {
    return this.map(tr2.changes);
  }
  map(changes) {
    return this;
  }
  touches(tr2) {
    return tr2.changes.touchesRange(cur(tr2.state));
  }
}
class ActiveResult extends ActiveSource {
  constructor(source, explicit, limit, result2, from, to2) {
    super(source, 3, explicit);
    this.limit = limit;
    this.result = result2;
    this.from = from;
    this.to = to2;
  }
  hasResult() {
    return true;
  }
  updateFor(tr2, type) {
    var _a2;
    if (!(type & 3))
      return this.map(tr2.changes);
    let result2 = this.result;
    if (result2.map && !tr2.changes.empty)
      result2 = result2.map(result2, tr2.changes);
    let from = tr2.changes.mapPos(this.from), to2 = tr2.changes.mapPos(this.to, 1);
    let pos = cur(tr2.state);
    if (pos > to2 || !result2 || type & 2 && (cur(tr2.startState) == this.from || pos < this.limit))
      return new ActiveSource(
        this.source,
        type & 4 ? 1 : 0
        /* State.Inactive */
      );
    let limit = tr2.changes.mapPos(this.limit);
    if (checkValid(result2.validFor, tr2.state, from, to2))
      return new ActiveResult(this.source, this.explicit, limit, result2, from, to2);
    if (result2.update && (result2 = result2.update(result2, from, to2, new CompletionContext(tr2.state, pos, false))))
      return new ActiveResult(this.source, this.explicit, limit, result2, result2.from, (_a2 = result2.to) !== null && _a2 !== void 0 ? _a2 : cur(tr2.state));
    return new ActiveSource(this.source, 1, this.explicit);
  }
  map(mapping) {
    if (mapping.empty)
      return this;
    let result2 = this.result.map ? this.result.map(this.result, mapping) : this.result;
    if (!result2)
      return new ActiveSource(
        this.source,
        0
        /* State.Inactive */
      );
    return new ActiveResult(this.source, this.explicit, mapping.mapPos(this.limit), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
  }
  touches(tr2) {
    return tr2.changes.touchesRange(this.from, this.to);
  }
}
function checkValid(validFor, state, from, to2) {
  if (!validFor)
    return false;
  let text2 = state.sliceDoc(from, to2);
  return typeof validFor == "function" ? validFor(text2, from, to2, state) : ensureAnchor(validFor, true).test(text2);
}
const setActiveEffect = /* @__PURE__ */ StateEffect.define({
  map(sources, mapping) {
    return sources.map((s) => s.map(mapping));
  }
});
const setSelectedEffect = /* @__PURE__ */ StateEffect.define();
const completionState = /* @__PURE__ */ StateField.define({
  create() {
    return CompletionState.start();
  },
  update(value, tr2) {
    return value.update(tr2);
  },
  provide: (f2) => [
    showTooltip.from(f2, (val) => val.tooltip),
    EditorView.contentAttributes.from(f2, (state) => state.attrs)
  ]
});
function applyCompletion(view, option) {
  const apply = option.completion.apply || option.completion.label;
  let result2 = view.state.field(completionState).active.find((a) => a.source == option.source);
  if (!(result2 instanceof ActiveResult))
    return false;
  if (typeof apply == "string")
    view.dispatch({
      ...insertCompletionText(view.state, apply, result2.from, result2.to),
      annotations: pickedCompletion.of(option.completion)
    });
  else
    apply(view, option.completion, result2.from, result2.to);
  return true;
}
const createTooltip = /* @__PURE__ */ completionTooltip(completionState, applyCompletion);
function moveCompletionSelection(forward, by = "option") {
  return (view) => {
    let cState = view.state.field(completionState, false);
    if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet(completionConfig).interactionDelay)
      return false;
    let step = 1, tooltip;
    if (by == "page" && (tooltip = getTooltip(view, cState.open.tooltip)))
      step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
    let { length } = cState.open.options;
    let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
    if (selected < 0)
      selected = by == "page" ? 0 : length - 1;
    else if (selected >= length)
      selected = by == "page" ? length - 1 : 0;
    view.dispatch({ effects: setSelectedEffect.of(selected) });
    return true;
  };
}
const acceptCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet(completionConfig).interactionDelay)
    return false;
  return applyCompletion(view, cState.open.options[cState.open.selected]);
};
const startCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (!cState)
    return false;
  view.dispatch({ effects: startCompletionEffect.of(true) });
  return true;
};
const closeCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (!cState || !cState.active.some(
    (a) => a.state != 0
    /* State.Inactive */
  ))
    return false;
  view.dispatch({ effects: closeCompletionEffect.of(null) });
  return true;
};
class RunningQuery {
  constructor(active, context) {
    this.active = active;
    this.context = context;
    this.time = Date.now();
    this.updates = [];
    this.done = void 0;
  }
}
const MaxUpdateCount = 50, MinAbortTime = 1e3;
const completionPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.debounceUpdate = -1;
    this.running = [];
    this.debounceAccept = -1;
    this.pendingStart = false;
    this.composing = 0;
    for (let active of view.state.field(completionState).active)
      if (active.isPending)
        this.startQuery(active);
  }
  update(update) {
    let cState = update.state.field(completionState);
    let conf = update.state.facet(completionConfig);
    if (!update.selectionSet && !update.docChanged && update.startState.field(completionState) == cState)
      return;
    let doesReset = update.transactions.some((tr2) => {
      let type = getUpdateType(tr2, conf);
      return type & 8 || (tr2.selection || tr2.docChanged) && !(type & 3);
    });
    for (let i2 = 0; i2 < this.running.length; i2++) {
      let query = this.running[i2];
      if (doesReset || query.context.abortOnDocChange && update.docChanged || query.updates.length + update.transactions.length > MaxUpdateCount && Date.now() - query.time > MinAbortTime) {
        for (let handler of query.context.abortListeners) {
          try {
            handler();
          } catch (e2) {
            logException(this.view.state, e2);
          }
        }
        query.context.abortListeners = null;
        this.running.splice(i2--, 1);
      } else {
        query.updates.push(...update.transactions);
      }
    }
    if (this.debounceUpdate > -1)
      clearTimeout(this.debounceUpdate);
    if (update.transactions.some((tr2) => tr2.effects.some((e2) => e2.is(startCompletionEffect))))
      this.pendingStart = true;
    let delay2 = this.pendingStart ? 50 : conf.activateOnTypingDelay;
    this.debounceUpdate = cState.active.some((a) => a.isPending && !this.running.some((q2) => q2.active.source == a.source)) ? setTimeout(() => this.startUpdate(), delay2) : -1;
    if (this.composing != 0)
      for (let tr2 of update.transactions) {
        if (tr2.isUserEvent("input.type"))
          this.composing = 2;
        else if (this.composing == 2 && tr2.selection)
          this.composing = 3;
      }
  }
  startUpdate() {
    this.debounceUpdate = -1;
    this.pendingStart = false;
    let { state } = this.view, cState = state.field(completionState);
    for (let active of cState.active) {
      if (active.isPending && !this.running.some((r) => r.active.source == active.source))
        this.startQuery(active);
    }
    if (this.running.length && cState.open && cState.open.disabled)
      this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(completionConfig).updateSyncTime);
  }
  startQuery(active) {
    let { state } = this.view, pos = cur(state);
    let context = new CompletionContext(state, pos, active.explicit, this.view);
    let pending = new RunningQuery(active, context);
    this.running.push(pending);
    Promise.resolve(active.source(context)).then((result2) => {
      if (!pending.context.aborted) {
        pending.done = result2 || null;
        this.scheduleAccept();
      }
    }, (err) => {
      this.view.dispatch({ effects: closeCompletionEffect.of(null) });
      logException(this.view.state, err);
    });
  }
  scheduleAccept() {
    if (this.running.every((q2) => q2.done !== void 0))
      this.accept();
    else if (this.debounceAccept < 0)
      this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(completionConfig).updateSyncTime);
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var _a2;
    if (this.debounceAccept > -1)
      clearTimeout(this.debounceAccept);
    this.debounceAccept = -1;
    let updated = [];
    let conf = this.view.state.facet(completionConfig), cState = this.view.state.field(completionState);
    for (let i2 = 0; i2 < this.running.length; i2++) {
      let query = this.running[i2];
      if (query.done === void 0)
        continue;
      this.running.splice(i2--, 1);
      if (query.done) {
        let pos = cur(query.updates.length ? query.updates[0].startState : this.view.state);
        let limit = Math.min(pos, query.done.from + (query.active.explicit ? 0 : 1));
        let active = new ActiveResult(query.active.source, query.active.explicit, limit, query.done, query.done.from, (_a2 = query.done.to) !== null && _a2 !== void 0 ? _a2 : pos);
        for (let tr2 of query.updates)
          active = active.update(tr2, conf);
        if (active.hasResult()) {
          updated.push(active);
          continue;
        }
      }
      let current2 = cState.active.find((a) => a.source == query.active.source);
      if (current2 && current2.isPending) {
        if (query.done == null) {
          let active = new ActiveSource(
            query.active.source,
            0
            /* State.Inactive */
          );
          for (let tr2 of query.updates)
            active = active.update(tr2, conf);
          if (!active.isPending)
            updated.push(active);
        } else {
          this.startQuery(current2);
        }
      }
    }
    if (updated.length || cState.open && cState.open.disabled)
      this.view.dispatch({ effects: setActiveEffect.of(updated) });
  }
}, {
  eventHandlers: {
    blur(event) {
      let state = this.view.state.field(completionState, false);
      if (state && state.tooltip && this.view.state.facet(completionConfig).closeOnBlur) {
        let dialog = state.open && getTooltip(this.view, state.open.tooltip);
        if (!dialog || !dialog.dom.contains(event.relatedTarget))
          setTimeout(() => this.view.dispatch({ effects: closeCompletionEffect.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      if (this.composing == 3) {
        setTimeout(() => this.view.dispatch({ effects: startCompletionEffect.of(false) }), 20);
      }
      this.composing = 0;
    }
  }
});
const windows = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform);
const commitCharacters = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ EditorView.domEventHandlers({
  keydown(event, view) {
    let field = view.state.field(completionState, false);
    if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !(windows && event.altKey) || event.metaKey)
      return false;
    let option = field.open.options[field.open.selected];
    let result2 = field.active.find((a) => a.source == option.source);
    let commitChars = option.completion.commitCharacters || result2.result.commitCharacters;
    if (commitChars && commitChars.indexOf(event.key) > -1)
      applyCompletion(view, option);
    return false;
  }
}));
const baseTheme$1 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: `${400}px`,
    boxSizing: "border-box",
    whiteSpace: "pre-line"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: `${30}px` },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: `${30}px` },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
const defaults = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
};
const closeBracketEffect = /* @__PURE__ */ StateEffect.define({
  map(value, mapping) {
    let mapped = mapping.mapPos(value, -1, MapMode.TrackAfter);
    return mapped == null ? void 0 : mapped;
  }
});
const closedBracket = /* @__PURE__ */ new class extends RangeValue {
}();
closedBracket.startSide = 1;
closedBracket.endSide = -1;
const bracketState = /* @__PURE__ */ StateField.define({
  create() {
    return RangeSet.empty;
  },
  update(value, tr2) {
    value = value.map(tr2.changes);
    if (tr2.selection) {
      let line2 = tr2.state.doc.lineAt(tr2.selection.main.head);
      value = value.update({ filter: (from) => from >= line2.from && from <= line2.to });
    }
    for (let effect of tr2.effects)
      if (effect.is(closeBracketEffect))
        value = value.update({ add: [closedBracket.range(effect.value, effect.value + 1)] });
    return value;
  }
});
function closeBrackets() {
  return [inputHandler, bracketState];
}
const definedClosing = "()[]{}<>«»»«［］｛｝";
function closing(ch) {
  for (let i2 = 0; i2 < definedClosing.length; i2 += 2)
    if (definedClosing.charCodeAt(i2) == ch)
      return definedClosing.charAt(i2 + 1);
  return fromCodePoint(ch < 128 ? ch : ch + 1);
}
function config(state, pos) {
  return state.languageDataAt("closeBrackets", pos)[0] || defaults;
}
const android = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent);
const inputHandler = /* @__PURE__ */ EditorView.inputHandler.of((view, from, to2, insert2) => {
  if ((android ? view.composing : view.compositionStarted) || view.state.readOnly)
    return false;
  let sel = view.state.selection.main;
  if (insert2.length > 2 || insert2.length == 2 && codePointSize(codePointAt(insert2, 0)) == 1 || from != sel.from || to2 != sel.to)
    return false;
  let tr2 = insertBracket(view.state, insert2);
  if (!tr2)
    return false;
  view.dispatch(tr2);
  return true;
});
const deleteBracketPair = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let conf = config(state, state.selection.main.head);
  let tokens = conf.brackets || defaults.brackets;
  let dont = null, changes = state.changeByRange((range2) => {
    if (range2.empty) {
      let before2 = prevChar(state.doc, range2.head);
      for (let token of tokens) {
        if (token == before2 && nextChar(state.doc, range2.head) == closing(codePointAt(token, 0)))
          return {
            changes: { from: range2.head - token.length, to: range2.head + token.length },
            range: EditorSelection.cursor(range2.head - token.length)
          };
      }
    }
    return { range: dont = range2 };
  });
  if (!dont)
    dispatch(state.update(changes, { scrollIntoView: true, userEvent: "delete.backward" }));
  return !dont;
};
const closeBracketsKeymap = [
  { key: "Backspace", run: deleteBracketPair }
];
function insertBracket(state, bracket2) {
  let conf = config(state, state.selection.main.head);
  let tokens = conf.brackets || defaults.brackets;
  for (let tok of tokens) {
    let closed = closing(codePointAt(tok, 0));
    if (bracket2 == tok)
      return closed == tok ? handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : handleOpen(state, tok, closed, conf.before || defaults.before);
    if (bracket2 == closed && closedBracketAt(state, state.selection.main.from))
      return handleClose(state, tok, closed);
  }
  return null;
}
function closedBracketAt(state, pos) {
  let found = false;
  state.field(bracketState).between(0, state.doc.length, (from) => {
    if (from == pos)
      found = true;
  });
  return found;
}
function nextChar(doc2, pos) {
  let next = doc2.sliceString(pos, pos + 2);
  return next.slice(0, codePointSize(codePointAt(next, 0)));
}
function prevChar(doc2, pos) {
  let prev = doc2.sliceString(pos - 2, pos);
  return codePointSize(codePointAt(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function handleOpen(state, open, close, closeBefore) {
  let dont = null, changes = state.changeByRange((range2) => {
    if (!range2.empty)
      return {
        changes: [{ insert: open, from: range2.from }, { insert: close, from: range2.to }],
        effects: closeBracketEffect.of(range2.to + open.length),
        range: EditorSelection.range(range2.anchor + open.length, range2.head + open.length)
      };
    let next = nextChar(state.doc, range2.head);
    if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1)
      return {
        changes: { insert: open + close, from: range2.head },
        effects: closeBracketEffect.of(range2.head + open.length),
        range: EditorSelection.cursor(range2.head + open.length)
      };
    return { range: dont = range2 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function handleClose(state, _open, close) {
  let dont = null, changes = state.changeByRange((range2) => {
    if (range2.empty && nextChar(state.doc, range2.head) == close)
      return {
        changes: { from: range2.head, to: range2.head + close.length, insert: close },
        range: EditorSelection.cursor(range2.head + close.length)
      };
    return dont = { range: range2 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function handleSame(state, token, allowTriple, config2) {
  let stringPrefixes = config2.stringPrefixes || defaults.stringPrefixes;
  let dont = null, changes = state.changeByRange((range2) => {
    if (!range2.empty)
      return {
        changes: [{ insert: token, from: range2.from }, { insert: token, from: range2.to }],
        effects: closeBracketEffect.of(range2.to + token.length),
        range: EditorSelection.range(range2.anchor + token.length, range2.head + token.length)
      };
    let pos = range2.head, next = nextChar(state.doc, pos), start;
    if (next == token) {
      if (nodeStart(state, pos)) {
        return {
          changes: { insert: token + token, from: pos },
          effects: closeBracketEffect.of(pos + token.length),
          range: EditorSelection.cursor(pos + token.length)
        };
      } else if (closedBracketAt(state, pos)) {
        let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
        let content2 = isTriple ? token + token + token : token;
        return {
          changes: { from: pos, to: pos + content2.length, insert: content2 },
          range: EditorSelection.cursor(pos + content2.length)
        };
      }
    } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && nodeStart(state, start)) {
      return {
        changes: { insert: token + token + token + token, from: pos },
        effects: closeBracketEffect.of(pos + token.length),
        range: EditorSelection.cursor(pos + token.length)
      };
    } else if (state.charCategorizer(pos)(next) != CharCategory.Word) {
      if (canStartStringAt(state, pos, stringPrefixes) > -1 && !probablyInString(state, pos, token, stringPrefixes))
        return {
          changes: { insert: token + token, from: pos },
          effects: closeBracketEffect.of(pos + token.length),
          range: EditorSelection.cursor(pos + token.length)
        };
    }
    return { range: dont = range2 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function nodeStart(state, pos) {
  let tree = syntaxTree(state).resolveInner(pos + 1);
  return tree.parent && tree.from == pos;
}
function probablyInString(state, pos, quoteToken, prefixes) {
  let node = syntaxTree(state).resolveInner(pos, -1);
  let maxPrefix = prefixes.reduce((m, p) => Math.max(m, p.length), 0);
  for (let i2 = 0; i2 < 5; i2++) {
    let start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
    let quotePos = start.indexOf(quoteToken);
    if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
      let first2 = node.firstChild;
      while (first2 && first2.from == node.from && first2.to - first2.from > quoteToken.length + quotePos) {
        if (state.sliceDoc(first2.to - quoteToken.length, first2.to) == quoteToken)
          return false;
        first2 = first2.firstChild;
      }
      return true;
    }
    let parent = node.to == pos && node.parent;
    if (!parent)
      break;
    node = parent;
  }
  return false;
}
function canStartStringAt(state, pos, prefixes) {
  let charCat = state.charCategorizer(pos);
  if (charCat(state.sliceDoc(pos - 1, pos)) != CharCategory.Word)
    return pos;
  for (let prefix of prefixes) {
    let start = pos - prefix.length;
    if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != CharCategory.Word)
      return start;
  }
  return -1;
}
function autocompletion(config2 = {}) {
  return [
    commitCharacters,
    completionState,
    completionConfig.of(config2),
    completionPlugin,
    completionKeymapExt,
    baseTheme$1
  ];
}
const completionKeymap = [
  { key: "Ctrl-Space", run: startCompletion },
  { mac: "Alt-`", run: startCompletion },
  { mac: "Alt-i", run: startCompletion },
  { key: "Escape", run: closeCompletion },
  { key: "ArrowDown", run: /* @__PURE__ */ moveCompletionSelection(true) },
  { key: "ArrowUp", run: /* @__PURE__ */ moveCompletionSelection(false) },
  { key: "PageDown", run: /* @__PURE__ */ moveCompletionSelection(true, "page") },
  { key: "PageUp", run: /* @__PURE__ */ moveCompletionSelection(false, "page") },
  { key: "Enter", run: acceptCompletion }
];
const completionKeymapExt = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ keymap.computeN([completionConfig], (state) => state.facet(completionConfig).defaultKeymap ? [completionKeymap] : []));
class SelectedDiagnostic {
  constructor(from, to2, diagnostic) {
    this.from = from;
    this.to = to2;
    this.diagnostic = diagnostic;
  }
}
class LintState {
  constructor(diagnostics, panel, selected) {
    this.diagnostics = diagnostics;
    this.panel = panel;
    this.selected = selected;
  }
  static init(diagnostics, panel, state) {
    let diagnosticFilter = state.facet(lintConfig).markerFilter;
    if (diagnosticFilter)
      diagnostics = diagnosticFilter(diagnostics, state);
    let sorted = diagnostics.slice().sort((a, b2) => a.from - b2.from || a.to - b2.to);
    let deco = new RangeSetBuilder(), active = [], pos = 0;
    let scan = state.doc.iter(), scanPos = 0, docLen = state.doc.length;
    for (let i2 = 0; ; ) {
      let next = i2 == sorted.length ? null : sorted[i2];
      if (!next && !active.length)
        break;
      let from, to2;
      if (active.length) {
        from = pos;
        to2 = active.reduce((p, d) => Math.min(p, d.to), next && next.from > from ? next.from : 1e8);
      } else {
        from = next.from;
        if (from > docLen)
          break;
        to2 = next.to;
        active.push(next);
        i2++;
      }
      while (i2 < sorted.length) {
        let next2 = sorted[i2];
        if (next2.from == from && (next2.to > next2.from || next2.to == from)) {
          active.push(next2);
          i2++;
          to2 = Math.min(next2.to, to2);
        } else {
          to2 = Math.min(next2.from, to2);
          break;
        }
      }
      to2 = Math.min(to2, docLen);
      let widget = false;
      if (active.some((d) => d.from == from && (d.to == to2 || to2 == docLen))) {
        widget = from == to2;
        if (!widget && to2 - from < 10) {
          let behind = from - (scanPos + scan.value.length);
          if (behind > 0) {
            scan.next(behind);
            scanPos = from;
          }
          for (let check = from; ; ) {
            if (check >= to2) {
              widget = true;
              break;
            }
            if (!scan.lineBreak && scanPos + scan.value.length > check)
              break;
            check = scanPos + scan.value.length;
            scanPos += scan.value.length;
            scan.next();
          }
        }
      }
      let sev = maxSeverity(active);
      if (widget) {
        deco.add(from, from, Decoration.widget({
          widget: new DiagnosticWidget(sev),
          diagnostics: active.slice()
        }));
      } else {
        let markClass = active.reduce((c2, d) => d.markClass ? c2 + " " + d.markClass : c2, "");
        deco.add(from, to2, Decoration.mark({
          class: "cm-lintRange cm-lintRange-" + sev + markClass,
          diagnostics: active.slice(),
          inclusiveEnd: active.some((a) => a.to > to2)
        }));
      }
      pos = to2;
      if (pos == docLen)
        break;
      for (let i22 = 0; i22 < active.length; i22++)
        if (active[i22].to <= pos)
          active.splice(i22--, 1);
    }
    let set2 = deco.finish();
    return new LintState(set2, panel, findDiagnostic(set2));
  }
}
function findDiagnostic(diagnostics, diagnostic = null, after2 = 0) {
  let found = null;
  diagnostics.between(after2, 1e9, (from, to2, { spec }) => {
    if (diagnostic && spec.diagnostics.indexOf(diagnostic) < 0)
      return;
    if (!found)
      found = new SelectedDiagnostic(from, to2, diagnostic || spec.diagnostics[0]);
    else if (spec.diagnostics.indexOf(found.diagnostic) < 0)
      return false;
    else
      found = new SelectedDiagnostic(found.from, to2, found.diagnostic);
  });
  return found;
}
function hideTooltip(tr2, tooltip) {
  let from = tooltip.pos, to2 = tooltip.end || from;
  let result2 = tr2.state.facet(lintConfig).hideOn(tr2, from, to2);
  if (result2 != null)
    return result2;
  let line2 = tr2.startState.doc.lineAt(tooltip.pos);
  return !!(tr2.effects.some((e2) => e2.is(setDiagnosticsEffect)) || tr2.changes.touchesRange(line2.from, Math.max(line2.to, to2)));
}
function maybeEnableLint(state, effects) {
  return state.field(lintState, false) ? effects : effects.concat(StateEffect.appendConfig.of(lintExtensions));
}
function setDiagnostics(state, diagnostics) {
  return {
    effects: maybeEnableLint(state, [setDiagnosticsEffect.of(diagnostics)])
  };
}
const setDiagnosticsEffect = /* @__PURE__ */ StateEffect.define();
const togglePanel = /* @__PURE__ */ StateEffect.define();
const movePanelSelection = /* @__PURE__ */ StateEffect.define();
const lintState = /* @__PURE__ */ StateField.define({
  create() {
    return new LintState(Decoration.none, null, null);
  },
  update(value, tr2) {
    if (tr2.docChanged && value.diagnostics.size) {
      let mapped = value.diagnostics.map(tr2.changes), selected = null, panel = value.panel;
      if (value.selected) {
        let selPos = tr2.changes.mapPos(value.selected.from, 1);
        selected = findDiagnostic(mapped, value.selected.diagnostic, selPos) || findDiagnostic(mapped, null, selPos);
      }
      if (!mapped.size && panel && tr2.state.facet(lintConfig).autoPanel)
        panel = null;
      value = new LintState(mapped, panel, selected);
    }
    for (let effect of tr2.effects) {
      if (effect.is(setDiagnosticsEffect)) {
        let panel = !tr2.state.facet(lintConfig).autoPanel ? value.panel : effect.value.length ? LintPanel.open : null;
        value = LintState.init(effect.value, panel, tr2.state);
      } else if (effect.is(togglePanel)) {
        value = new LintState(value.diagnostics, effect.value ? LintPanel.open : null, value.selected);
      } else if (effect.is(movePanelSelection)) {
        value = new LintState(value.diagnostics, value.panel, effect.value);
      }
    }
    return value;
  },
  provide: (f2) => [
    showPanel.from(f2, (val) => val.panel),
    EditorView.decorations.from(f2, (s) => s.diagnostics)
  ]
});
const activeMark = /* @__PURE__ */ Decoration.mark({ class: "cm-lintRange cm-lintRange-active" });
function lintTooltip(view, pos, side) {
  let { diagnostics } = view.state.field(lintState);
  let found, start = -1, end = -1;
  diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to2, { spec }) => {
    if (pos >= from && pos <= to2 && (from == to2 || (pos > from || side > 0) && (pos < to2 || side < 0))) {
      found = spec.diagnostics;
      start = from;
      end = to2;
      return false;
    }
  });
  let diagnosticFilter = view.state.facet(lintConfig).tooltipFilter;
  if (found && diagnosticFilter)
    found = diagnosticFilter(found, view.state);
  if (!found)
    return null;
  return {
    pos: start,
    end,
    above: view.state.doc.lineAt(start).to < end,
    create() {
      return { dom: diagnosticsTooltip(view, found) };
    }
  };
}
function diagnosticsTooltip(view, diagnostics) {
  return crelt("ul", { class: "cm-tooltip-lint" }, diagnostics.map((d) => renderDiagnostic(view, d, false)));
}
const openLintPanel = (view) => {
  let field = view.state.field(lintState, false);
  if (!field || !field.panel)
    view.dispatch({ effects: maybeEnableLint(view.state, [togglePanel.of(true)]) });
  let panel = getPanel(view, LintPanel.open);
  if (panel)
    panel.dom.querySelector(".cm-panel-lint ul").focus();
  return true;
};
const closeLintPanel = (view) => {
  let field = view.state.field(lintState, false);
  if (!field || !field.panel)
    return false;
  view.dispatch({ effects: togglePanel.of(false) });
  return true;
};
const nextDiagnostic = (view) => {
  let field = view.state.field(lintState, false);
  if (!field)
    return false;
  let sel = view.state.selection.main, next = field.diagnostics.iter(sel.to + 1);
  if (!next.value) {
    next = field.diagnostics.iter(0);
    if (!next.value || next.from == sel.from && next.to == sel.to)
      return false;
  }
  view.dispatch({ selection: { anchor: next.from, head: next.to }, scrollIntoView: true });
  return true;
};
const lintKeymap = [
  { key: "Mod-Shift-m", run: openLintPanel, preventDefault: true },
  { key: "F8", run: nextDiagnostic }
];
const lintConfig = /* @__PURE__ */ Facet.define({
  combine(input) {
    return {
      sources: input.map((i2) => i2.source).filter((x2) => x2 != null),
      ...combineConfig(input.map((i2) => i2.config), {
        delay: 750,
        markerFilter: null,
        tooltipFilter: null,
        needsRefresh: null,
        hideOn: () => null
      }, {
        delay: Math.max,
        markerFilter: combineFilter,
        tooltipFilter: combineFilter,
        needsRefresh: (a, b2) => !a ? b2 : !b2 ? a : (u) => a(u) || b2(u),
        hideOn: (a, b2) => !a ? b2 : !b2 ? a : (t2, x2, y) => a(t2, x2, y) || b2(t2, x2, y),
        autoPanel: (a, b2) => a || b2
      })
    };
  }
});
function combineFilter(a, b2) {
  return !a ? b2 : !b2 ? a : (d, s) => b2(a(d, s), s);
}
function assignKeys(actions) {
  let assigned = [];
  if (actions)
    actions: for (let { name: name2 } of actions) {
      for (let i2 = 0; i2 < name2.length; i2++) {
        let ch = name2[i2];
        if (/[a-zA-Z]/.test(ch) && !assigned.some((c2) => c2.toLowerCase() == ch.toLowerCase())) {
          assigned.push(ch);
          continue actions;
        }
      }
      assigned.push("");
    }
  return assigned;
}
function renderDiagnostic(view, diagnostic, inPanel) {
  var _a2;
  let keys2 = inPanel ? assignKeys(diagnostic.actions) : [];
  return crelt("li", { class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity }, crelt("span", { class: "cm-diagnosticText" }, diagnostic.renderMessage ? diagnostic.renderMessage(view) : diagnostic.message), (_a2 = diagnostic.actions) === null || _a2 === void 0 ? void 0 : _a2.map((action, i2) => {
    let fired = false, click = (e2) => {
      e2.preventDefault();
      if (fired)
        return;
      fired = true;
      let found = findDiagnostic(view.state.field(lintState).diagnostics, diagnostic);
      if (found)
        action.apply(view, found.from, found.to);
    };
    let { name: name2 } = action, keyIndex = keys2[i2] ? name2.indexOf(keys2[i2]) : -1;
    let nameElt = keyIndex < 0 ? name2 : [
      name2.slice(0, keyIndex),
      crelt("u", name2.slice(keyIndex, keyIndex + 1)),
      name2.slice(keyIndex + 1)
    ];
    let markClass = action.markClass ? " " + action.markClass : "";
    return crelt("button", {
      type: "button",
      class: "cm-diagnosticAction" + markClass,
      onclick: click,
      onmousedown: click,
      "aria-label": ` Action: ${name2}${keyIndex < 0 ? "" : ` (access key "${keys2[i2]})"`}.`
    }, nameElt);
  }), diagnostic.source && crelt("div", { class: "cm-diagnosticSource" }, diagnostic.source));
}
class DiagnosticWidget extends WidgetType {
  constructor(sev) {
    super();
    this.sev = sev;
  }
  eq(other) {
    return other.sev == this.sev;
  }
  toDOM() {
    return crelt("span", { class: "cm-lintPoint cm-lintPoint-" + this.sev });
  }
}
class PanelItem {
  constructor(view, diagnostic) {
    this.diagnostic = diagnostic;
    this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16);
    this.dom = renderDiagnostic(view, diagnostic, true);
    this.dom.id = this.id;
    this.dom.setAttribute("role", "option");
  }
}
class LintPanel {
  constructor(view) {
    this.view = view;
    this.items = [];
    let onkeydown = (event) => {
      if (event.keyCode == 27) {
        closeLintPanel(this.view);
        this.view.focus();
      } else if (event.keyCode == 38 || event.keyCode == 33) {
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      } else if (event.keyCode == 40 || event.keyCode == 34) {
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      } else if (event.keyCode == 36) {
        this.moveSelection(0);
      } else if (event.keyCode == 35) {
        this.moveSelection(this.items.length - 1);
      } else if (event.keyCode == 13) {
        this.view.focus();
      } else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic } = this.items[this.selectedIndex], keys2 = assignKeys(diagnostic.actions);
        for (let i2 = 0; i2 < keys2.length; i2++)
          if (keys2[i2].toUpperCase().charCodeAt(0) == event.keyCode) {
            let found = findDiagnostic(this.view.state.field(lintState).diagnostics, diagnostic);
            if (found)
              diagnostic.actions[i2].apply(view, found.from, found.to);
          }
      } else {
        return;
      }
      event.preventDefault();
    };
    let onclick = (event) => {
      for (let i2 = 0; i2 < this.items.length; i2++) {
        if (this.items[i2].dom.contains(event.target))
          this.moveSelection(i2);
      }
    };
    this.list = crelt("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown,
      onclick
    });
    this.dom = crelt("div", { class: "cm-panel-lint" }, this.list, crelt("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => closeLintPanel(this.view)
    }, "×"));
    this.update();
  }
  get selectedIndex() {
    let selected = this.view.state.field(lintState).selected;
    if (!selected)
      return -1;
    for (let i2 = 0; i2 < this.items.length; i2++)
      if (this.items[i2].diagnostic == selected.diagnostic)
        return i2;
    return -1;
  }
  update() {
    let { diagnostics, selected } = this.view.state.field(lintState);
    let i2 = 0, needsSync = false, newSelectedItem = null;
    let seen = /* @__PURE__ */ new Set();
    diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec }) => {
      for (let diagnostic of spec.diagnostics) {
        if (seen.has(diagnostic))
          continue;
        seen.add(diagnostic);
        let found = -1, item;
        for (let j2 = i2; j2 < this.items.length; j2++)
          if (this.items[j2].diagnostic == diagnostic) {
            found = j2;
            break;
          }
        if (found < 0) {
          item = new PanelItem(this.view, diagnostic);
          this.items.splice(i2, 0, item);
          needsSync = true;
        } else {
          item = this.items[found];
          if (found > i2) {
            this.items.splice(i2, found - i2);
            needsSync = true;
          }
        }
        if (selected && item.diagnostic == selected.diagnostic) {
          if (!item.dom.hasAttribute("aria-selected")) {
            item.dom.setAttribute("aria-selected", "true");
            newSelectedItem = item;
          }
        } else if (item.dom.hasAttribute("aria-selected")) {
          item.dom.removeAttribute("aria-selected");
        }
        i2++;
      }
    });
    while (i2 < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)) {
      needsSync = true;
      this.items.pop();
    }
    if (this.items.length == 0) {
      this.items.push(new PanelItem(this.view, {
        from: -1,
        to: -1,
        severity: "info",
        message: this.view.state.phrase("No diagnostics")
      }));
      needsSync = true;
    }
    if (newSelectedItem) {
      this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
      this.view.requestMeasure({
        key: this,
        read: () => ({ sel: newSelectedItem.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
        write: ({ sel, panel }) => {
          let scaleY = panel.height / this.list.offsetHeight;
          if (sel.top < panel.top)
            this.list.scrollTop -= (panel.top - sel.top) / scaleY;
          else if (sel.bottom > panel.bottom)
            this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
        }
      });
    } else if (this.selectedIndex < 0) {
      this.list.removeAttribute("aria-activedescendant");
    }
    if (needsSync)
      this.sync();
  }
  sync() {
    let domPos = this.list.firstChild;
    function rm2() {
      let prev = domPos;
      domPos = prev.nextSibling;
      prev.remove();
    }
    for (let item of this.items) {
      if (item.dom.parentNode == this.list) {
        while (domPos != item.dom)
          rm2();
        domPos = item.dom.nextSibling;
      } else {
        this.list.insertBefore(item.dom, domPos);
      }
    }
    while (domPos)
      rm2();
  }
  moveSelection(selectedIndex) {
    if (this.selectedIndex < 0)
      return;
    let field = this.view.state.field(lintState);
    let selection2 = findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
    if (!selection2)
      return;
    this.view.dispatch({
      selection: { anchor: selection2.from, head: selection2.to },
      scrollIntoView: true,
      effects: movePanelSelection.of(selection2)
    });
  }
  static open(view) {
    return new LintPanel(view);
  }
}
function svg(content2, attrs = `viewBox="0 0 40 40"`) {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content2)}</svg>')`;
}
function underline(color) {
  return svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const baseTheme = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ underline("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ underline("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ underline("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ underline("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function severityWeight(sev) {
  return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
function maxSeverity(diagnostics) {
  let sev = "hint", weight = 1;
  for (let d of diagnostics) {
    let w2 = severityWeight(d.severity);
    if (w2 > weight) {
      weight = w2;
      sev = d.severity;
    }
  }
  return sev;
}
const lintExtensions = [
  lintState,
  /* @__PURE__ */ EditorView.decorations.compute([lintState], (state) => {
    let { selected, panel } = state.field(lintState);
    return !selected || !panel || selected.from == selected.to ? Decoration.none : Decoration.set([
      activeMark.range(selected.from, selected.to)
    ]);
  }),
  /* @__PURE__ */ hoverTooltip(lintTooltip, { hideOn: hideTooltip }),
  baseTheme
];
var basicSetup = function basicSetup2(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var {
    crosshairCursor: initCrosshairCursor = false
  } = options2;
  var keymaps = [];
  if (options2.closeBracketsKeymap !== false) {
    keymaps = keymaps.concat(closeBracketsKeymap);
  }
  if (options2.defaultKeymap !== false) {
    keymaps = keymaps.concat(defaultKeymap);
  }
  if (options2.searchKeymap !== false) {
    keymaps = keymaps.concat(searchKeymap);
  }
  if (options2.historyKeymap !== false) {
    keymaps = keymaps.concat(historyKeymap);
  }
  if (options2.foldKeymap !== false) {
    keymaps = keymaps.concat(foldKeymap);
  }
  if (options2.completionKeymap !== false) {
    keymaps = keymaps.concat(completionKeymap);
  }
  if (options2.lintKeymap !== false) {
    keymaps = keymaps.concat(lintKeymap);
  }
  var extensions = [];
  if (options2.lineNumbers !== false) extensions.push(lineNumbers());
  if (options2.highlightActiveLineGutter !== false) extensions.push(highlightActiveLineGutter());
  if (options2.highlightSpecialChars !== false) extensions.push(highlightSpecialChars());
  if (options2.history !== false) extensions.push(history());
  if (options2.foldGutter !== false) extensions.push(foldGutter());
  if (options2.drawSelection !== false) extensions.push(drawSelection());
  if (options2.dropCursor !== false) extensions.push(dropCursor());
  if (options2.allowMultipleSelections !== false) extensions.push(EditorState.allowMultipleSelections.of(true));
  if (options2.indentOnInput !== false) extensions.push(indentOnInput());
  if (options2.syntaxHighlighting !== false) extensions.push(syntaxHighlighting(defaultHighlightStyle, {
    fallback: true
  }));
  if (options2.bracketMatching !== false) extensions.push(bracketMatching());
  if (options2.closeBrackets !== false) extensions.push(closeBrackets());
  if (options2.autocompletion !== false) extensions.push(autocompletion());
  if (options2.rectangularSelection !== false) extensions.push(rectangularSelection());
  if (initCrosshairCursor !== false) extensions.push(crosshairCursor());
  if (options2.highlightActiveLine !== false) extensions.push(highlightActiveLine());
  if (options2.highlightSelectionMatches !== false) extensions.push(highlightSelectionMatches());
  if (options2.tabSize && typeof options2.tabSize === "number") extensions.push(indentUnit.of(" ".repeat(options2.tabSize)));
  return extensions.concat([keymap.of(keymaps.flat())]).filter(Boolean);
};
const chalky = "#e5c07b", coral = "#e06c75", cyan = "#56b6c2", invalid = "#ffffff", ivory = "#abb2bf", stone = "#7d8799", malibu = "#61afef", sage = "#98c379", whiskey = "#d19a66", violet = "#c678dd", darkBackground = "#21252b", highlightBackground = "#2c313a", background = "#282c34", tooltipBackground = "#353a42", selection = "#3E4451", cursor$1 = "#528bff";
const oneDarkTheme = /* @__PURE__ */ EditorView.theme({
  "&": {
    color: ivory,
    backgroundColor: background
  },
  ".cm-content": {
    caretColor: cursor$1
  },
  ".cm-cursor, .cm-dropCursor": { borderLeftColor: cursor$1 },
  "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: selection },
  ".cm-panels": { backgroundColor: darkBackground, color: ivory },
  ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
  ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
  ".cm-searchMatch": {
    backgroundColor: "#72a1ff59",
    outline: "1px solid #457dff"
  },
  ".cm-searchMatch.cm-searchMatch-selected": {
    backgroundColor: "#6199ff2f"
  },
  ".cm-activeLine": { backgroundColor: "#6699ff0b" },
  ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
  "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
    backgroundColor: "#bad0f847"
  },
  ".cm-gutters": {
    backgroundColor: background,
    color: stone,
    border: "none"
  },
  ".cm-activeLineGutter": {
    backgroundColor: highlightBackground
  },
  ".cm-foldPlaceholder": {
    backgroundColor: "transparent",
    border: "none",
    color: "#ddd"
  },
  ".cm-tooltip": {
    border: "none",
    backgroundColor: tooltipBackground
  },
  ".cm-tooltip .cm-tooltip-arrow:before": {
    borderTopColor: "transparent",
    borderBottomColor: "transparent"
  },
  ".cm-tooltip .cm-tooltip-arrow:after": {
    borderTopColor: tooltipBackground,
    borderBottomColor: tooltipBackground
  },
  ".cm-tooltip-autocomplete": {
    "& > ul > li[aria-selected]": {
      backgroundColor: highlightBackground,
      color: ivory
    }
  }
}, { dark: true });
const oneDarkHighlightStyle = /* @__PURE__ */ HighlightStyle.define([
  {
    tag: tags.keyword,
    color: violet
  },
  {
    tag: [tags.name, tags.deleted, tags.character, tags.propertyName, tags.macroName],
    color: coral
  },
  {
    tag: [/* @__PURE__ */ tags.function(tags.variableName), tags.labelName],
    color: malibu
  },
  {
    tag: [tags.color, /* @__PURE__ */ tags.constant(tags.name), /* @__PURE__ */ tags.standard(tags.name)],
    color: whiskey
  },
  {
    tag: [/* @__PURE__ */ tags.definition(tags.name), tags.separator],
    color: ivory
  },
  {
    tag: [tags.typeName, tags.className, tags.number, tags.changed, tags.annotation, tags.modifier, tags.self, tags.namespace],
    color: chalky
  },
  {
    tag: [tags.operator, tags.operatorKeyword, tags.url, tags.escape, tags.regexp, tags.link, /* @__PURE__ */ tags.special(tags.string)],
    color: cyan
  },
  {
    tag: [tags.meta, tags.comment],
    color: stone
  },
  {
    tag: tags.strong,
    fontWeight: "bold"
  },
  {
    tag: tags.emphasis,
    fontStyle: "italic"
  },
  {
    tag: tags.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: tags.link,
    color: stone,
    textDecoration: "underline"
  },
  {
    tag: tags.heading,
    fontWeight: "bold",
    color: coral
  },
  {
    tag: [tags.atom, tags.bool, /* @__PURE__ */ tags.special(tags.variableName)],
    color: whiskey
  },
  {
    tag: [tags.processingInstruction, tags.string, tags.inserted],
    color: sage
  },
  {
    tag: tags.invalid,
    color: invalid
  }
]);
const oneDark = [oneDarkTheme, /* @__PURE__ */ syntaxHighlighting(oneDarkHighlightStyle)];
var defaultLightThemeOption = EditorView.theme({
  "&": {
    backgroundColor: "#fff"
  }
}, {
  dark: false
});
var getDefaultExtensions = function getDefaultExtensions2(optios) {
  if (optios === void 0) {
    optios = {};
  }
  var {
    indentWithTab: defaultIndentWithTab = true,
    editable: editable2 = true,
    readOnly: readOnly2 = false,
    theme: theme2 = "light",
    placeholder: placeholderStr = "",
    basicSetup: defaultBasicSetup = true
  } = optios;
  var getExtensions = [];
  if (defaultIndentWithTab) {
    getExtensions.unshift(keymap.of([indentWithTab]));
  }
  if (defaultBasicSetup) {
    if (typeof defaultBasicSetup === "boolean") {
      getExtensions.unshift(basicSetup());
    } else {
      getExtensions.unshift(basicSetup(defaultBasicSetup));
    }
  }
  if (placeholderStr) {
    getExtensions.unshift(placeholder(placeholderStr));
  }
  switch (theme2) {
    case "light":
      getExtensions.push(defaultLightThemeOption);
      break;
    case "dark":
      getExtensions.push(oneDark);
      break;
    case "none":
      break;
    default:
      getExtensions.push(theme2);
      break;
  }
  if (editable2 === false) {
    getExtensions.push(EditorView.editable.of(false));
  }
  if (readOnly2) {
    getExtensions.push(EditorState.readOnly.of(true));
  }
  return [...getExtensions];
};
var getStatistics = (view) => {
  return {
    line: view.state.doc.lineAt(view.state.selection.main.from),
    lineCount: view.state.doc.lines,
    lineBreak: view.state.lineBreak,
    length: view.state.doc.length,
    readOnly: view.state.readOnly,
    tabSize: view.state.tabSize,
    selection: view.state.selection,
    selectionAsSingle: view.state.selection.asSingle().main,
    ranges: view.state.selection.ranges,
    selectionCode: view.state.sliceDoc(view.state.selection.main.from, view.state.selection.main.to),
    selections: view.state.selection.ranges.map((r) => view.state.sliceDoc(r.from, r.to)),
    selectedText: view.state.selection.ranges.some((r) => !r.empty)
  };
};
class TimeoutLatch {
  constructor(callback, timeoutMS) {
    this.timeLeftMS = void 0;
    this.timeoutMS = void 0;
    this.isCancelled = false;
    this.isTimeExhausted = false;
    this.callbacks = [];
    this.timeLeftMS = timeoutMS;
    this.timeoutMS = timeoutMS;
    this.callbacks.push(callback);
  }
  tick() {
    if (!this.isCancelled && !this.isTimeExhausted) {
      this.timeLeftMS--;
      if (this.timeLeftMS <= 0) {
        this.isTimeExhausted = true;
        var callbacks = this.callbacks.slice();
        this.callbacks.length = 0;
        callbacks.forEach((callback) => {
          try {
            callback();
          } catch (error) {
            console.error("TimeoutLatch callback error:", error);
          }
        });
      }
    }
  }
  cancel() {
    this.isCancelled = true;
    this.callbacks.length = 0;
  }
  reset() {
    this.timeLeftMS = this.timeoutMS;
    this.isCancelled = false;
    this.isTimeExhausted = false;
  }
  get isDone() {
    return this.isCancelled || this.isTimeExhausted;
  }
}
class Scheduler {
  constructor() {
    this.interval = null;
    this.latches = /* @__PURE__ */ new Set();
  }
  add(latch) {
    this.latches.add(latch);
    this.start();
  }
  remove(latch) {
    this.latches.delete(latch);
    if (this.latches.size === 0) {
      this.stop();
    }
  }
  start() {
    if (this.interval === null) {
      this.interval = setInterval(() => {
        this.latches.forEach((latch) => {
          latch.tick();
          if (latch.isDone) {
            this.remove(latch);
          }
        });
      }, 1);
    }
  }
  stop() {
    if (this.interval !== null) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}
var globalScheduler = null;
var getScheduler = () => {
  if (typeof window === "undefined") {
    return new Scheduler();
  }
  if (!globalScheduler) {
    globalScheduler = new Scheduler();
  }
  return globalScheduler;
};
var ExternalChange = Annotation.define();
var TYPING_TIMOUT = 200;
var emptyExtensions = [];
function useCodeMirror(props2) {
  var {
    value,
    selection: selection2,
    onChange,
    onStatistics,
    onCreateEditor,
    onUpdate,
    extensions = emptyExtensions,
    autoFocus,
    theme: theme2 = "light",
    height = null,
    minHeight = null,
    maxHeight = null,
    width = null,
    minWidth = null,
    maxWidth = null,
    placeholder: placeholderStr = "",
    editable: editable2 = true,
    readOnly: readOnly2 = false,
    indentWithTab: defaultIndentWithTab = true,
    basicSetup: defaultBasicSetup = true,
    root: root2,
    initialState: initialState2
  } = props2;
  var [container, setContainer] = useState();
  var [view, setView] = useState();
  var [state, setState] = useState();
  var typingLatch = useState(() => ({
    current: null
  }))[0];
  var pendingUpdate = useState(() => ({
    current: null
  }))[0];
  var defaultThemeOption = EditorView.theme({
    "&": {
      height,
      minHeight,
      maxHeight,
      width,
      minWidth,
      maxWidth
    },
    "& .cm-scroller": {
      height: "100% !important"
    }
  });
  var updateListener2 = EditorView.updateListener.of((vu) => {
    if (vu.docChanged && typeof onChange === "function" && // Fix echoing of the remote changes:
    // If transaction is market as remote we don't have to call `onChange` handler again
    !vu.transactions.some((tr2) => tr2.annotation(ExternalChange))) {
      if (typingLatch.current) {
        typingLatch.current.reset();
      } else {
        typingLatch.current = new TimeoutLatch(() => {
          if (pendingUpdate.current) {
            var forceUpdate = pendingUpdate.current;
            pendingUpdate.current = null;
            forceUpdate();
          }
          typingLatch.current = null;
        }, TYPING_TIMOUT);
        getScheduler().add(typingLatch.current);
      }
      var doc2 = vu.state.doc;
      var _value = doc2.toString();
      onChange(_value, vu);
    }
    onStatistics && onStatistics(getStatistics(vu));
  });
  var defaultExtensions = getDefaultExtensions({
    theme: theme2,
    editable: editable2,
    readOnly: readOnly2,
    placeholder: placeholderStr,
    indentWithTab: defaultIndentWithTab,
    basicSetup: defaultBasicSetup
  });
  var getExtensions = [updateListener2, defaultThemeOption, ...defaultExtensions];
  if (onUpdate && typeof onUpdate === "function") {
    getExtensions.push(EditorView.updateListener.of(onUpdate));
  }
  getExtensions = getExtensions.concat(extensions);
  useLayoutEffect(() => {
    if (container && !state) {
      var config2 = {
        doc: value,
        selection: selection2,
        extensions: getExtensions
      };
      var stateCurrent = initialState2 ? EditorState.fromJSON(initialState2.json, config2, initialState2.fields) : EditorState.create(config2);
      setState(stateCurrent);
      if (!view) {
        var viewCurrent = new EditorView({
          state: stateCurrent,
          parent: container,
          root: root2
        });
        setView(viewCurrent);
        onCreateEditor && onCreateEditor(viewCurrent, stateCurrent);
      }
    }
    return () => {
      if (view) {
        setState(void 0);
        setView(void 0);
      }
    };
  }, [container, state]);
  useEffect(() => {
    if (props2.container) {
      setContainer(props2.container);
    }
  }, [props2.container]);
  useEffect(() => () => {
    if (view) {
      view.destroy();
      setView(void 0);
    }
    if (typingLatch.current) {
      typingLatch.current.cancel();
      typingLatch.current = null;
    }
  }, [view]);
  useEffect(() => {
    if (autoFocus && view) {
      view.focus();
    }
  }, [autoFocus, view]);
  useEffect(() => {
    if (view) {
      view.dispatch({
        effects: StateEffect.reconfigure.of(getExtensions)
      });
    }
  }, [theme2, extensions, height, minHeight, maxHeight, width, minWidth, maxWidth, placeholderStr, editable2, readOnly2, defaultIndentWithTab, defaultBasicSetup, onChange, onUpdate]);
  useEffect(() => {
    if (value === void 0) {
      return;
    }
    var currentValue = view ? view.state.doc.toString() : "";
    if (view && value !== currentValue) {
      var isTyping = typingLatch.current && !typingLatch.current.isDone;
      var forceUpdate = () => {
        if (view && value !== view.state.doc.toString()) {
          view.dispatch({
            changes: {
              from: 0,
              to: view.state.doc.toString().length,
              insert: value || ""
            },
            annotations: [ExternalChange.of(true)]
          });
        }
      };
      if (!isTyping) {
        forceUpdate();
      } else {
        pendingUpdate.current = forceUpdate;
      }
    }
  }, [value, view]);
  return {
    state,
    setState,
    view,
    setView,
    container,
    setContainer
  };
}
function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, "__esModule")) return n;
  var f2 = n.default;
  if (typeof f2 == "function") {
    var a = function a2() {
      var isInstance = false;
      try {
        isInstance = this instanceof a2;
      } catch {
      }
      if (isInstance) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a.prototype = f2.prototype;
  } else a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k2) {
    var d = Object.getOwnPropertyDescriptor(n, k2);
    Object.defineProperty(a, k2, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k2];
      }
    });
  });
  return a;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production = {};
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production.jsx = jsxProd;
  reactJsxRuntime_production.jsxs = jsxProd;
  return reactJsxRuntime_production;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name2 = getComponentNameFromType(type);
        return name2 ? "<" + name2 + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props2, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props2, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props2, owner, debugStack, debugTask) {
      var refProp = props2.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props: props2,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node) {
      isValidElement2(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement2(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement2(object2) {
      return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React$1 = React__default, REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React$1.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React$1 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React$1.react_stack_bottom_frame.bind(
      React$1,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
var _excluded = ["className", "value", "selection", "extensions", "onChange", "onStatistics", "onCreateEditor", "onUpdate", "autoFocus", "theme", "height", "minHeight", "maxHeight", "width", "minWidth", "maxWidth", "basicSetup", "placeholder", "indentWithTab", "editable", "readOnly", "root", "initialState"];
var ReactCodeMirror = /* @__PURE__ */ forwardRef((props2, ref) => {
  var {
    className,
    value = "",
    selection: selection2,
    extensions = [],
    onChange,
    onStatistics,
    onCreateEditor,
    onUpdate,
    autoFocus,
    theme: theme2 = "light",
    height,
    minHeight,
    maxHeight,
    width,
    minWidth,
    maxWidth,
    basicSetup: basicSetup3,
    placeholder: placeholder2,
    indentWithTab: indentWithTab2,
    editable: editable2,
    readOnly: readOnly2,
    root: root2,
    initialState: initialState2
  } = props2, other = _objectWithoutPropertiesLoose(props2, _excluded);
  var editor = useRef(null);
  var {
    state,
    view,
    container,
    setContainer
  } = useCodeMirror({
    root: root2,
    value,
    autoFocus,
    theme: theme2,
    height,
    minHeight,
    maxHeight,
    width,
    minWidth,
    maxWidth,
    basicSetup: basicSetup3,
    placeholder: placeholder2,
    indentWithTab: indentWithTab2,
    editable: editable2,
    readOnly: readOnly2,
    selection: selection2,
    onChange,
    onStatistics,
    onCreateEditor,
    onUpdate,
    extensions,
    initialState: initialState2
  });
  useImperativeHandle(ref, () => ({
    editor: editor.current,
    state,
    view
  }), [editor, container, state, view]);
  var setEditorRef = useCallback((el) => {
    editor.current = el;
    setContainer(el);
  }, [setContainer]);
  if (typeof value !== "string") {
    throw new Error("value must be typeof string but got " + typeof value);
  }
  var defaultClassNames = typeof theme2 === "string" ? "cm-theme-" + theme2 : "cm-theme";
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", _extends({
    ref: setEditorRef,
    className: "" + defaultClassNames + (className ? " " + className : "")
  }, other));
});
ReactCodeMirror.displayName = "CodeMirror";
const DefaultBufferLength = 1024;
let nextPropID = 0;
let Range$1 = class Range3 {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
};
class NodeProp2 {
  /**
  Create a new node prop type.
  */
  constructor(config2 = {}) {
    this.id = nextPropID++;
    this.perNode = !!config2.perNode;
    this.deserialize = config2.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
    this.combine = config2.combine || null;
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(match2) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    if (typeof match2 != "function")
      match2 = NodeType2.match(match2);
    return (type) => {
      let result2 = match2(type);
      return result2 === void 0 ? null : [this, result2];
    };
  }
}
NodeProp2.closedBy = new NodeProp2({ deserialize: (str) => str.split(" ") });
NodeProp2.openedBy = new NodeProp2({ deserialize: (str) => str.split(" ") });
NodeProp2.group = new NodeProp2({ deserialize: (str) => str.split(" ") });
NodeProp2.isolate = new NodeProp2({ deserialize: (value) => {
  if (value && value != "rtl" && value != "ltr" && value != "auto")
    throw new RangeError("Invalid value for isolate: " + value);
  return value || "auto";
} });
NodeProp2.contextHash = new NodeProp2({ perNode: true });
NodeProp2.lookAhead = new NodeProp2({ perNode: true });
NodeProp2.mounted = new NodeProp2({ perNode: true });
class MountedTree2 {
  constructor(tree, overlay, parser2) {
    this.tree = tree;
    this.overlay = overlay;
    this.parser = parser2;
  }
  /**
  @internal
  */
  static get(tree) {
    return tree && tree.props && tree.props[NodeProp2.mounted.id];
  }
}
const noProps = /* @__PURE__ */ Object.create(null);
class NodeType2 {
  /**
  @internal
  */
  constructor(name2, props2, id2, flags = 0) {
    this.name = name2;
    this.props = props2;
    this.id = id2;
    this.flags = flags;
  }
  /**
  Define a node type.
  */
  static define(spec) {
    let props2 = spec.props && spec.props.length ? /* @__PURE__ */ Object.create(null) : noProps;
    let flags = (spec.top ? 1 : 0) | (spec.skipped ? 2 : 0) | (spec.error ? 4 : 0) | (spec.name == null ? 8 : 0);
    let type = new NodeType2(spec.name || "", props2, spec.id, flags);
    if (spec.props)
      for (let src of spec.props) {
        if (!Array.isArray(src))
          src = src(type);
        if (src) {
          if (src[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          props2[src[0].id] = src[1];
        }
      }
    return type;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(prop) {
    return this.props[prop.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(name2) {
    if (typeof name2 == "string") {
      if (this.name == name2)
        return true;
      let group2 = this.prop(NodeProp2.group);
      return group2 ? group2.indexOf(name2) > -1 : false;
    }
    return this.id == name2;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(map2) {
    let direct = /* @__PURE__ */ Object.create(null);
    for (let prop in map2)
      for (let name2 of prop.split(" "))
        direct[name2] = map2[prop];
    return (node) => {
      for (let groups = node.prop(NodeProp2.group), i2 = -1; i2 < (groups ? groups.length : 0); i2++) {
        let found = direct[i2 < 0 ? node.name : groups[i2]];
        if (found)
          return found;
      }
    };
  }
}
NodeType2.none = new NodeType2(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class NodeSet {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(types2) {
    this.types = types2;
    for (let i2 = 0; i2 < types2.length; i2++)
      if (types2[i2].id != i2)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...props2) {
    let newTypes = [];
    for (let type of this.types) {
      let newProps = null;
      for (let source of props2) {
        let add2 = source(type);
        if (add2) {
          if (!newProps)
            newProps = Object.assign({}, type.props);
          let value = add2[1], prop = add2[0];
          if (prop.combine && prop.id in newProps)
            value = prop.combine(newProps[prop.id], value);
          newProps[prop.id] = value;
        }
      }
      newTypes.push(newProps ? new NodeType2(type.name, newProps, type.id, type.flags) : type);
    }
    return new NodeSet(newTypes);
  }
}
const CachedNode = /* @__PURE__ */ new WeakMap(), CachedInnerNode = /* @__PURE__ */ new WeakMap();
var IterMode;
(function(IterMode2) {
  IterMode2[IterMode2["ExcludeBuffers"] = 1] = "ExcludeBuffers";
  IterMode2[IterMode2["IncludeAnonymous"] = 2] = "IncludeAnonymous";
  IterMode2[IterMode2["IgnoreMounts"] = 4] = "IgnoreMounts";
  IterMode2[IterMode2["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})(IterMode || (IterMode = {}));
class Tree2 {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(type, children, positions, length, props2) {
    this.type = type;
    this.children = children;
    this.positions = positions;
    this.length = length;
    this.props = null;
    if (props2 && props2.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [prop, value] of props2)
        this.props[typeof prop == "number" ? prop : prop.id] = value;
    }
  }
  /**
  @internal
  */
  toString() {
    let mounted = MountedTree2.get(this);
    if (mounted && !mounted.overlay)
      return mounted.tree.toString();
    let children = "";
    for (let ch of this.children) {
      let str = ch.toString();
      if (str) {
        if (children)
          children += ",";
        children += str;
      }
    }
    return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(mode = 0) {
    return new TreeCursor2(this.topNode, mode);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(pos, side = 0, mode = 0) {
    let scope = CachedNode.get(this) || this.topNode;
    let cursor2 = new TreeCursor2(scope);
    cursor2.moveTo(pos, side);
    CachedNode.set(this, cursor2._tree);
    return cursor2;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new TreeNode2(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(pos, side = 0) {
    let node = resolveNode(CachedNode.get(this) || this.topNode, pos, side, false);
    CachedNode.set(this, node);
    return node;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(pos, side = 0) {
    let node = resolveNode(CachedInnerNode.get(this) || this.topNode, pos, side, true);
    CachedInnerNode.set(this, node);
    return node;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(pos, side = 0) {
    return stackIterator(this, pos, side);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(spec) {
    let { enter, leave, from = 0, to: to2 = this.length } = spec;
    let mode = spec.mode || 0, anon = (mode & IterMode.IncludeAnonymous) > 0;
    for (let c2 = this.cursor(mode | IterMode.IncludeAnonymous); ; ) {
      let entered = false;
      if (c2.from <= to2 && c2.to >= from && (!anon && c2.type.isAnonymous || enter(c2) !== false)) {
        if (c2.firstChild())
          continue;
        entered = true;
      }
      for (; ; ) {
        if (entered && leave && (anon || !c2.type.isAnonymous))
          leave(c2);
        if (c2.nextSibling())
          break;
        if (!c2.parent())
          return;
        entered = true;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(prop) {
    return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : void 0;
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let result2 = [];
    if (this.props)
      for (let id2 in this.props)
        result2.push([+id2, this.props[id2]]);
    return result2;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(config2 = {}) {
    return this.children.length <= 8 ? this : balanceRange(NodeType2.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length) => new Tree2(this.type, children, positions, length, this.propValues), config2.makeTree || ((children, positions, length) => new Tree2(NodeType2.none, children, positions, length)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(data) {
    return buildTree(data);
  }
}
Tree2.empty = new Tree2(NodeType2.none, [], [], 0);
class FlatBufferCursor2 {
  constructor(buffer, index2) {
    this.buffer = buffer;
    this.index = index2;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new FlatBufferCursor2(this.buffer, this.index);
  }
}
class TreeBuffer2 {
  /**
  Create a tree buffer.
  */
  constructor(buffer, length, set2) {
    this.buffer = buffer;
    this.length = length;
    this.set = set2;
  }
  /**
  @internal
  */
  get type() {
    return NodeType2.none;
  }
  /**
  @internal
  */
  toString() {
    let result2 = [];
    for (let index2 = 0; index2 < this.buffer.length; ) {
      result2.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2.join(",");
  }
  /**
  @internal
  */
  childString(index2) {
    let id2 = this.buffer[index2], endIndex = this.buffer[index2 + 3];
    let type = this.set.types[id2], result2 = type.name;
    if (/\W/.test(result2) && !type.isError)
      result2 = JSON.stringify(result2);
    index2 += 4;
    if (endIndex == index2)
      return result2;
    let children = [];
    while (index2 < endIndex) {
      children.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2 + "(" + children.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(startIndex, endIndex, dir, pos, side) {
    let { buffer } = this, pick3 = -1;
    for (let i2 = startIndex; i2 != endIndex; i2 = buffer[i2 + 3]) {
      if (checkSide(side, pos, buffer[i2 + 1], buffer[i2 + 2])) {
        pick3 = i2;
        if (dir > 0)
          break;
      }
    }
    return pick3;
  }
  /**
  @internal
  */
  slice(startI, endI, from) {
    let b2 = this.buffer;
    let copy2 = new Uint16Array(endI - startI), len = 0;
    for (let i2 = startI, j2 = 0; i2 < endI; ) {
      copy2[j2++] = b2[i2++];
      copy2[j2++] = b2[i2++] - from;
      let to2 = copy2[j2++] = b2[i2++] - from;
      copy2[j2++] = b2[i2++] - startI;
      len = Math.max(len, to2);
    }
    return new TreeBuffer2(copy2, len, this.set);
  }
}
function checkSide(side, pos, from, to2) {
  switch (side) {
    case -2:
      return from < pos;
    case -1:
      return to2 >= pos && from < pos;
    case 0:
      return from < pos && to2 > pos;
    case 1:
      return from <= pos && to2 > pos;
    case 2:
      return to2 > pos;
    case 4:
      return true;
  }
}
function resolveNode(node, pos, side, overlays) {
  var _a2;
  while (node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)) {
    let parent = !overlays && node instanceof TreeNode2 && node.index < 0 ? null : node.parent;
    if (!parent)
      return node;
    node = parent;
  }
  let mode = overlays ? 0 : IterMode.IgnoreOverlays;
  if (overlays)
    for (let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent) {
      if (scan instanceof TreeNode2 && scan.index < 0 && ((_a2 = parent.enter(pos, side, mode)) === null || _a2 === void 0 ? void 0 : _a2.from) != scan.from)
        node = parent;
    }
  for (; ; ) {
    let inner = node.enter(pos, side, mode);
    if (!inner)
      return node;
    node = inner;
  }
}
class BaseNode2 {
  cursor(mode = 0) {
    return new TreeCursor2(this, mode);
  }
  getChild(type, before2 = null, after2 = null) {
    let r = getChildren(this, type, before2, after2);
    return r.length ? r[0] : null;
  }
  getChildren(type, before2 = null, after2 = null) {
    return getChildren(this, type, before2, after2);
  }
  resolve(pos, side = 0) {
    return resolveNode(this, pos, side, false);
  }
  resolveInner(pos, side = 0) {
    return resolveNode(this, pos, side, true);
  }
  matchContext(context) {
    return matchNodeContext(this.parent, context);
  }
  enterUnfinishedNodesBefore(pos) {
    let scan = this.childBefore(pos), node = this;
    while (scan) {
      let last2 = scan.lastChild;
      if (!last2 || last2.to != scan.to)
        break;
      if (last2.type.isError && last2.from == last2.to) {
        node = scan;
        scan = last2.prevSibling;
      } else {
        scan = last2;
      }
    }
    return node;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class TreeNode2 extends BaseNode2 {
  constructor(_tree, from, index2, _parent) {
    super();
    this._tree = _tree;
    this.from = from;
    this.index = index2;
    this._parent = _parent;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(i2, dir, pos, side, mode = 0) {
    for (let parent = this; ; ) {
      for (let { children, positions } = parent._tree, e2 = dir > 0 ? children.length : -1; i2 != e2; i2 += dir) {
        let next = children[i2], start = positions[i2] + parent.from;
        if (!checkSide(side, pos, start, start + next.length))
          continue;
        if (next instanceof TreeBuffer2) {
          if (mode & IterMode.ExcludeBuffers)
            continue;
          let index2 = next.findChild(0, next.buffer.length, dir, pos - start, side);
          if (index2 > -1)
            return new BufferNode2(new BufferContext2(parent, next, i2, start), null, index2);
        } else if (mode & IterMode.IncludeAnonymous || (!next.type.isAnonymous || hasChild(next))) {
          let mounted;
          if (!(mode & IterMode.IgnoreMounts) && (mounted = MountedTree2.get(next)) && !mounted.overlay)
            return new TreeNode2(mounted.tree, start, i2, parent);
          let inner = new TreeNode2(next, start, i2, parent);
          return mode & IterMode.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
        }
      }
      if (mode & IterMode.IncludeAnonymous || !parent.type.isAnonymous)
        return null;
      if (parent.index >= 0)
        i2 = parent.index + dir;
      else
        i2 = dir < 0 ? -1 : parent._parent._tree.children.length;
      parent = parent._parent;
      if (!parent)
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.nextChild(
      0,
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this._tree.prop(prop);
  }
  enter(pos, side, mode = 0) {
    let mounted;
    if (!(mode & IterMode.IgnoreOverlays) && (mounted = MountedTree2.get(this._tree)) && mounted.overlay) {
      let rPos = pos - this.from;
      for (let { from, to: to2 } of mounted.overlay) {
        if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to2 >= rPos : to2 > rPos))
          return new TreeNode2(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
      }
    }
    return this.nextChild(0, 1, pos, side, mode);
  }
  nextSignificantParent() {
    let val = this;
    while (val.type.isAnonymous && val._parent)
      val = val._parent;
    return val;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function getChildren(node, type, before2, after2) {
  let cur2 = node.cursor(), result2 = [];
  if (!cur2.firstChild())
    return result2;
  if (before2 != null)
    for (let found = false; !found; ) {
      found = cur2.type.is(before2);
      if (!cur2.nextSibling())
        return result2;
    }
  for (; ; ) {
    if (after2 != null && cur2.type.is(after2))
      return result2;
    if (cur2.type.is(type))
      result2.push(cur2.node);
    if (!cur2.nextSibling())
      return after2 == null ? result2 : [];
  }
}
function matchNodeContext(node, context, i2 = context.length - 1) {
  for (let p = node; i2 >= 0; p = p.parent) {
    if (!p)
      return false;
    if (!p.type.isAnonymous) {
      if (context[i2] && context[i2] != p.name)
        return false;
      i2--;
    }
  }
  return true;
}
class BufferContext2 {
  constructor(parent, buffer, index2, start) {
    this.parent = parent;
    this.buffer = buffer;
    this.index = index2;
    this.start = start;
  }
}
class BufferNode2 extends BaseNode2 {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(context, _parent, index2) {
    super();
    this.context = context;
    this._parent = _parent;
    this.index = index2;
    this.type = context.buffer.set.types[context.buffer.buffer[index2]];
  }
  child(dir, pos, side) {
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode2(this.context, this, index2);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.child(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.child(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this.type.prop(prop);
  }
  enter(pos, side, mode = 0) {
    if (mode & IterMode.ExcludeBuffers)
      return null;
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode2(this.context, this, index2);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(dir) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + dir,
      dir,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer } = this.context;
    let after2 = buffer.buffer[this.index + 3];
    if (after2 < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length))
      return new BufferNode2(this.context, this._parent, after2);
    return this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer } = this.context;
    let parentStart = this._parent ? this._parent.index + 4 : 0;
    if (this.index == parentStart)
      return this.externalSibling(-1);
    return new BufferNode2(this.context, this._parent, buffer.findChild(
      parentStart,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let children = [], positions = [];
    let { buffer } = this.context;
    let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
    if (endI > startI) {
      let from = buffer.buffer[this.index + 1];
      children.push(buffer.slice(startI, endI, from));
      positions.push(0);
    }
    return new Tree2(this.type, children, positions, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function iterStack(heads) {
  if (!heads.length)
    return null;
  let pick3 = 0, picked = heads[0];
  for (let i2 = 1; i2 < heads.length; i2++) {
    let node = heads[i2];
    if (node.from > picked.from || node.to < picked.to) {
      picked = node;
      pick3 = i2;
    }
  }
  let next = picked instanceof TreeNode2 && picked.index < 0 ? null : picked.parent;
  let newHeads = heads.slice();
  if (next)
    newHeads[pick3] = next;
  else
    newHeads.splice(pick3, 1);
  return new StackIterator2(newHeads, picked);
}
class StackIterator2 {
  constructor(heads, node) {
    this.heads = heads;
    this.node = node;
  }
  get next() {
    return iterStack(this.heads);
  }
}
function stackIterator(tree, pos, side) {
  let inner = tree.resolveInner(pos, side), layers = null;
  for (let scan = inner instanceof TreeNode2 ? inner : inner.context.parent; scan; scan = scan.parent) {
    if (scan.index < 0) {
      let parent = scan.parent;
      (layers || (layers = [inner])).push(parent.resolve(pos, side));
      scan = parent;
    } else {
      let mount = MountedTree2.get(scan.tree);
      if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
        let root2 = new TreeNode2(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
        (layers || (layers = [inner])).push(resolveNode(root2, pos, side, false));
      }
    }
  }
  return layers ? iterStack(layers) : inner;
}
class TreeCursor2 {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(node, mode = 0) {
    this.mode = mode;
    this.buffer = null;
    this.stack = [];
    this.index = 0;
    this.bufferNode = null;
    if (node instanceof TreeNode2) {
      this.yieldNode(node);
    } else {
      this._tree = node.context.parent;
      this.buffer = node.context;
      for (let n = node._parent; n; n = n._parent)
        this.stack.unshift(n.index);
      this.bufferNode = node;
      this.yieldBuf(node.index);
    }
  }
  yieldNode(node) {
    if (!node)
      return false;
    this._tree = node;
    this.type = node.type;
    this.from = node.from;
    this.to = node.to;
    return true;
  }
  yieldBuf(index2, type) {
    this.index = index2;
    let { start, buffer } = this.buffer;
    this.type = type || buffer.set.types[buffer.buffer[index2]];
    this.from = start + buffer.buffer[index2 + 1];
    this.to = start + buffer.buffer[index2 + 2];
    return true;
  }
  /**
  @internal
  */
  yield(node) {
    if (!node)
      return false;
    if (node instanceof TreeNode2) {
      this.buffer = null;
      return this.yieldNode(node);
    }
    this.buffer = node.context;
    return this.yieldBuf(node.index, node.type);
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(dir, pos, side) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
    let { buffer } = this.buffer;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
    if (index2 < 0)
      return false;
    this.stack.push(this.index);
    return this.yieldBuf(index2);
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(pos) {
    return this.enterChild(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(pos) {
    return this.enterChild(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(pos, side, mode = this.mode) {
    if (!this.buffer)
      return this.yield(this._tree.enter(pos, side, mode));
    return mode & IterMode.ExcludeBuffers ? false : this.enterChild(1, pos, side);
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & IterMode.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let parent = this.mode & IterMode.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    this.buffer = null;
    return this.yieldNode(parent);
  }
  /**
  @internal
  */
  sibling(dir) {
    if (!this.buffer)
      return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4, this.mode));
    let { buffer } = this.buffer, d = this.stack.length - 1;
    if (dir < 0) {
      let parentStart = d < 0 ? 0 : this.stack[d] + 4;
      if (this.index != parentStart)
        return this.yieldBuf(buffer.findChild(
          parentStart,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let after2 = buffer.buffer[this.index + 3];
      if (after2 < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3]))
        return this.yieldBuf(after2);
    }
    return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4, this.mode)) : false;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(dir) {
    let index2, parent, { buffer } = this;
    if (buffer) {
      if (dir > 0) {
        if (this.index < buffer.buffer.buffer.length)
          return false;
      } else {
        for (let i2 = 0; i2 < this.index; i2++)
          if (buffer.buffer.buffer[i2 + 3] < this.index)
            return false;
      }
      ({ index: index2, parent } = buffer);
    } else {
      ({ index: index2, _parent: parent } = this._tree);
    }
    for (; parent; { index: index2, _parent: parent } = parent) {
      if (index2 > -1)
        for (let i2 = index2 + dir, e2 = dir < 0 ? -1 : parent._tree.children.length; i2 != e2; i2 += dir) {
          let child = parent._tree.children[i2];
          if (this.mode & IterMode.IncludeAnonymous || child instanceof TreeBuffer2 || !child.type.isAnonymous || hasChild(child))
            return false;
        }
    }
    return true;
  }
  move(dir, enter) {
    if (enter && this.enterChild(
      dir,
      0,
      4
      /* Side.DontCare */
    ))
      return true;
    for (; ; ) {
      if (this.sibling(dir))
        return true;
      if (this.atLastNode(dir) || !this.parent())
        return false;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(enter = true) {
    return this.move(1, enter);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(enter = true) {
    return this.move(-1, enter);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(pos, side = 0) {
    while (this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))
      if (!this.parent())
        break;
    while (this.enterChild(1, pos, side)) {
    }
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let cache = this.bufferNode, result2 = null, depth = 0;
    if (cache && cache.context == this.buffer) {
      scan: for (let index2 = this.index, d = this.stack.length; d >= 0; ) {
        for (let c2 = cache; c2; c2 = c2._parent)
          if (c2.index == index2) {
            if (index2 == this.index)
              return c2;
            result2 = c2;
            depth = d + 1;
            break scan;
          }
        index2 = this.stack[--d];
      }
    }
    for (let i2 = depth; i2 < this.stack.length; i2++)
      result2 = new BufferNode2(this.buffer, result2, this.stack[i2]);
    return this.bufferNode = new BufferNode2(this.buffer, result2, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(enter, leave) {
    for (let depth = 0; ; ) {
      let mustLeave = false;
      if (this.type.isAnonymous || enter(this) !== false) {
        if (this.firstChild()) {
          depth++;
          continue;
        }
        if (!this.type.isAnonymous)
          mustLeave = true;
      }
      for (; ; ) {
        if (mustLeave && leave)
          leave(this);
        mustLeave = this.type.isAnonymous;
        if (!depth)
          return;
        if (this.nextSibling())
          break;
        this.parent();
        depth--;
        mustLeave = true;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(context) {
    if (!this.buffer)
      return matchNodeContext(this.node.parent, context);
    let { buffer } = this.buffer, { types: types2 } = buffer.set;
    for (let i2 = context.length - 1, d = this.stack.length - 1; i2 >= 0; d--) {
      if (d < 0)
        return matchNodeContext(this._tree, context, i2);
      let type = types2[buffer.buffer[this.stack[d]]];
      if (!type.isAnonymous) {
        if (context[i2] && context[i2] != type.name)
          return false;
        i2--;
      }
    }
    return true;
  }
}
function hasChild(tree) {
  return tree.children.some((ch) => ch instanceof TreeBuffer2 || !ch.type.isAnonymous || hasChild(ch));
}
function buildTree(data) {
  var _a2;
  let { buffer, nodeSet, maxBufferLength = DefaultBufferLength, reused = [], minRepeatType = nodeSet.types.length } = data;
  let cursor2 = Array.isArray(buffer) ? new FlatBufferCursor2(buffer, buffer.length) : buffer;
  let types2 = nodeSet.types;
  let contextHash = 0, lookAhead = 0;
  function takeNode(parentStart, minPos, children2, positions2, inRepeat, depth) {
    let { id: id2, start, end, size: size2 } = cursor2;
    let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
    if (size2 < 0) {
      cursor2.next();
      if (size2 == -1) {
        let node2 = reused[id2];
        children2.push(node2);
        positions2.push(start - parentStart);
        return;
      } else if (size2 == -3) {
        contextHash = id2;
        return;
      } else if (size2 == -4) {
        lookAhead = id2;
        return;
      } else {
        throw new RangeError(`Unrecognized record size: ${size2}`);
      }
    }
    let type = types2[id2], node, buffer2;
    let startPos = start - parentStart;
    if (end - start <= maxBufferLength && (buffer2 = findBufferSize(cursor2.pos - minPos, inRepeat))) {
      let data2 = new Uint16Array(buffer2.size - buffer2.skip);
      let endPos = cursor2.pos - buffer2.size, index2 = data2.length;
      while (cursor2.pos > endPos)
        index2 = copyToBuffer(buffer2.start, data2, index2);
      node = new TreeBuffer2(data2, end - buffer2.start, nodeSet);
      startPos = buffer2.start - parentStart;
    } else {
      let endPos = cursor2.pos - size2;
      cursor2.next();
      let localChildren = [], localPositions = [];
      let localInRepeat = id2 >= minRepeatType ? id2 : -1;
      let lastGroup = 0, lastEnd = end;
      while (cursor2.pos > endPos) {
        if (localInRepeat >= 0 && cursor2.id == localInRepeat && cursor2.size >= 0) {
          if (cursor2.end <= lastEnd - maxBufferLength) {
            makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor2.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            lastGroup = localChildren.length;
            lastEnd = cursor2.end;
          }
          cursor2.next();
        } else if (depth > 2500) {
          takeFlatNode(start, endPos, localChildren, localPositions);
        } else {
          takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
        }
      }
      if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length)
        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
      localChildren.reverse();
      localPositions.reverse();
      if (localInRepeat > -1 && lastGroup > 0) {
        let make = makeBalanced(type, contextAtStart);
        node = balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
      } else {
        node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
      }
    }
    children2.push(node);
    positions2.push(startPos);
  }
  function takeFlatNode(parentStart, minPos, children2, positions2) {
    let nodes = [];
    let nodeCount = 0, stopAt = -1;
    while (cursor2.pos > minPos) {
      let { id: id2, start, end, size: size2 } = cursor2;
      if (size2 > 4) {
        cursor2.next();
      } else if (stopAt > -1 && start < stopAt) {
        break;
      } else {
        if (stopAt < 0)
          stopAt = end - maxBufferLength;
        nodes.push(id2, start, end);
        nodeCount++;
        cursor2.next();
      }
    }
    if (nodeCount) {
      let buffer2 = new Uint16Array(nodeCount * 4);
      let start = nodes[nodes.length - 2];
      for (let i2 = nodes.length - 3, j2 = 0; i2 >= 0; i2 -= 3) {
        buffer2[j2++] = nodes[i2];
        buffer2[j2++] = nodes[i2 + 1] - start;
        buffer2[j2++] = nodes[i2 + 2] - start;
        buffer2[j2++] = j2;
      }
      children2.push(new TreeBuffer2(buffer2, nodes[2] - start, nodeSet));
      positions2.push(start - parentStart);
    }
  }
  function makeBalanced(type, contextHash2) {
    return (children2, positions2, length2) => {
      let lookAhead2 = 0, lastI = children2.length - 1, last2, lookAheadProp;
      if (lastI >= 0 && (last2 = children2[lastI]) instanceof Tree2) {
        if (!lastI && last2.type == type && last2.length == length2)
          return last2;
        if (lookAheadProp = last2.prop(NodeProp2.lookAhead))
          lookAhead2 = positions2[lastI] + last2.length + lookAheadProp;
      }
      return makeTree(type, children2, positions2, length2, lookAhead2, contextHash2);
    };
  }
  function makeRepeatLeaf(children2, positions2, base2, i2, from, to2, type, lookAhead2, contextHash2) {
    let localChildren = [], localPositions = [];
    while (children2.length > i2) {
      localChildren.push(children2.pop());
      localPositions.push(positions2.pop() + base2 - from);
    }
    children2.push(makeTree(nodeSet.types[type], localChildren, localPositions, to2 - from, lookAhead2 - to2, contextHash2));
    positions2.push(from - base2);
  }
  function makeTree(type, children2, positions2, length2, lookAhead2, contextHash2, props2) {
    if (contextHash2) {
      let pair2 = [NodeProp2.contextHash, contextHash2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    if (lookAhead2 > 25) {
      let pair2 = [NodeProp2.lookAhead, lookAhead2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    return new Tree2(type, children2, positions2, length2, props2);
  }
  function findBufferSize(maxSize, inRepeat) {
    let fork = cursor2.fork();
    let size2 = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
    let result2 = { size: 0, start: 0, skip: 0 };
    scan: for (let minPos = fork.pos - maxSize; fork.pos > minPos; ) {
      let nodeSize2 = fork.size;
      if (fork.id == inRepeat && nodeSize2 >= 0) {
        result2.size = size2;
        result2.start = start;
        result2.skip = skip;
        skip += 4;
        size2 += 4;
        fork.next();
        continue;
      }
      let startPos = fork.pos - nodeSize2;
      if (nodeSize2 < 0 || startPos < minPos || fork.start < minStart)
        break;
      let localSkipped = fork.id >= minRepeatType ? 4 : 0;
      let nodeStart2 = fork.start;
      fork.next();
      while (fork.pos > startPos) {
        if (fork.size < 0) {
          if (fork.size == -3 || fork.size == -4)
            localSkipped += 4;
          else
            break scan;
        } else if (fork.id >= minRepeatType) {
          localSkipped += 4;
        }
        fork.next();
      }
      start = nodeStart2;
      size2 += nodeSize2;
      skip += localSkipped;
    }
    if (inRepeat < 0 || size2 == maxSize) {
      result2.size = size2;
      result2.start = start;
      result2.skip = skip;
    }
    return result2.size > 4 ? result2 : void 0;
  }
  function copyToBuffer(bufferStart, buffer2, index2) {
    let { id: id2, start, end, size: size2 } = cursor2;
    cursor2.next();
    if (size2 >= 0 && id2 < minRepeatType) {
      let startIndex = index2;
      if (size2 > 4) {
        let endPos = cursor2.pos - (size2 - 4);
        while (cursor2.pos > endPos)
          index2 = copyToBuffer(bufferStart, buffer2, index2);
      }
      buffer2[--index2] = startIndex;
      buffer2[--index2] = end - bufferStart;
      buffer2[--index2] = start - bufferStart;
      buffer2[--index2] = id2;
    } else if (size2 == -3) {
      contextHash = id2;
    } else if (size2 == -4) {
      lookAhead = id2;
    }
    return index2;
  }
  let children = [], positions = [];
  while (cursor2.pos > 0)
    takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
  let length = (_a2 = data.length) !== null && _a2 !== void 0 ? _a2 : children.length ? positions[0] + children[0].length : 0;
  return new Tree2(types2[data.topID], children.reverse(), positions.reverse(), length);
}
const nodeSizeCache = /* @__PURE__ */ new WeakMap();
function nodeSize(balanceType, node) {
  if (!balanceType.isAnonymous || node instanceof TreeBuffer2 || node.type != balanceType)
    return 1;
  let size2 = nodeSizeCache.get(node);
  if (size2 == null) {
    size2 = 1;
    for (let child of node.children) {
      if (child.type != balanceType || !(child instanceof Tree2)) {
        size2 = 1;
        break;
      }
      size2 += nodeSize(balanceType, child);
    }
    nodeSizeCache.set(node, size2);
  }
  return size2;
}
function balanceRange(balanceType, children, positions, from, to2, start, length, mkTop, mkTree) {
  let total = 0;
  for (let i2 = from; i2 < to2; i2++)
    total += nodeSize(balanceType, children[i2]);
  let maxChild = Math.ceil(
    total * 1.5 / 8
    /* Balance.BranchFactor */
  );
  let localChildren = [], localPositions = [];
  function divide2(children2, positions2, from2, to22, offset2) {
    for (let i2 = from2; i2 < to22; ) {
      let groupFrom = i2, groupStart = positions2[i2], groupSize = nodeSize(balanceType, children2[i2]);
      i2++;
      for (; i2 < to22; i2++) {
        let nextSize = nodeSize(balanceType, children2[i2]);
        if (groupSize + nextSize >= maxChild)
          break;
        groupSize += nextSize;
      }
      if (i2 == groupFrom + 1) {
        if (groupSize > maxChild) {
          let only = children2[groupFrom];
          divide2(only.children, only.positions, 0, only.children.length, positions2[groupFrom] + offset2);
          continue;
        }
        localChildren.push(children2[groupFrom]);
      } else {
        let length2 = positions2[i2 - 1] + children2[i2 - 1].length - groupStart;
        localChildren.push(balanceRange(balanceType, children2, positions2, groupFrom, i2, groupStart, length2, null, mkTree));
      }
      localPositions.push(groupStart + offset2 - start);
    }
  }
  divide2(children, positions, from, to2, 0);
  return (mkTop || mkTree)(localChildren, localPositions, length);
}
class Parser2 {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(input, fragments, ranges) {
    if (typeof input == "string")
      input = new StringInput2(input);
    ranges = !ranges ? [new Range$1(0, input.length)] : ranges.length ? ranges.map((r) => new Range$1(r.from, r.to)) : [new Range$1(0, 0)];
    return this.createParse(input, fragments || [], ranges);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(input, fragments, ranges) {
    let parse2 = this.startParse(input, fragments, ranges);
    for (; ; ) {
      let done = parse2.advance();
      if (done)
        return done;
    }
  }
}
class StringInput2 {
  constructor(string2) {
    this.string = string2;
  }
  get length() {
    return this.string.length;
  }
  chunk(from) {
    return this.string.slice(from);
  }
  get lineChunks() {
    return false;
  }
  read(from, to2) {
    return this.string.slice(from, to2);
  }
}
new NodeProp2({ perNode: true });
class Stack {
  /**
  @internal
  */
  constructor(p, stack, state, reducePos, pos, score2, buffer, bufferBase, curContext, lookAhead = 0, parent) {
    this.p = p;
    this.stack = stack;
    this.state = state;
    this.reducePos = reducePos;
    this.pos = pos;
    this.score = score2;
    this.buffer = buffer;
    this.bufferBase = bufferBase;
    this.curContext = curContext;
    this.lookAhead = lookAhead;
    this.parent = parent;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((_2, i2) => i2 % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(p, state, pos = 0) {
    let cx = p.parser.context;
    return new Stack(p, [], state, pos, pos, 0, [], 0, cx ? new StackContext(cx, cx.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(state, start) {
    this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
    this.state = state;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(action) {
    var _a2;
    let depth = action >> 19, type = action & 65535;
    let { parser: parser2 } = this.p;
    let lookaheadRecord = this.reducePos < this.pos - 25 && this.setLookAhead(this.pos);
    let dPrec = parser2.dynamicPrecedence(type);
    if (dPrec)
      this.score += dPrec;
    if (depth == 0) {
      this.pushState(parser2.getGoto(this.state, type, true), this.reducePos);
      if (type < parser2.minRepeatTerm)
        this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
      this.reduceContext(type, this.reducePos);
      return;
    }
    let base2 = this.stack.length - (depth - 1) * 3 - (action & 262144 ? 6 : 0);
    let start = base2 ? this.stack[base2 - 2] : this.p.ranges[0].from, size2 = this.reducePos - start;
    if (size2 >= 2e3 && !((_a2 = this.p.parser.nodeSet.types[type]) === null || _a2 === void 0 ? void 0 : _a2.isAnonymous)) {
      if (start == this.p.lastBigReductionStart) {
        this.p.bigReductionCount++;
        this.p.lastBigReductionSize = size2;
      } else if (this.p.lastBigReductionSize < size2) {
        this.p.bigReductionCount = 1;
        this.p.lastBigReductionStart = start;
        this.p.lastBigReductionSize = size2;
      }
    }
    let bufferBase = base2 ? this.stack[base2 - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
    if (type < parser2.minRepeatTerm || action & 131072) {
      let pos = parser2.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(type, start, pos, count + 4, true);
    }
    if (action & 262144) {
      this.state = this.stack[base2];
    } else {
      let baseStateID = this.stack[base2 - 3];
      this.state = parser2.getGoto(baseStateID, type, true);
    }
    while (this.stack.length > base2)
      this.stack.pop();
    this.reduceContext(type, start);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(term, start, end, size2 = 4, mustSink = false) {
    if (term == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let cur2 = this, top2 = this.buffer.length;
      if (top2 == 0 && cur2.parent) {
        top2 = cur2.bufferBase - cur2.parent.bufferBase;
        cur2 = cur2.parent;
      }
      if (top2 > 0 && cur2.buffer[top2 - 4] == 0 && cur2.buffer[top2 - 1] > -1) {
        if (start == end)
          return;
        if (cur2.buffer[top2 - 2] >= start) {
          cur2.buffer[top2 - 2] = end;
          return;
        }
      }
    }
    if (!mustSink || this.pos == end) {
      this.buffer.push(term, start, end, size2);
    } else {
      let index2 = this.buffer.length;
      if (index2 > 0 && (this.buffer[index2 - 4] != 0 || this.buffer[index2 - 1] < 0)) {
        let mustMove = false;
        for (let scan = index2; scan > 0 && this.buffer[scan - 2] > end; scan -= 4) {
          if (this.buffer[scan - 1] >= 0) {
            mustMove = true;
            break;
          }
        }
        if (mustMove)
          while (index2 > 0 && this.buffer[index2 - 2] > end) {
            this.buffer[index2] = this.buffer[index2 - 4];
            this.buffer[index2 + 1] = this.buffer[index2 - 3];
            this.buffer[index2 + 2] = this.buffer[index2 - 2];
            this.buffer[index2 + 3] = this.buffer[index2 - 1];
            index2 -= 4;
            if (size2 > 4)
              size2 -= 4;
          }
      }
      this.buffer[index2] = term;
      this.buffer[index2 + 1] = start;
      this.buffer[index2 + 2] = end;
      this.buffer[index2 + 3] = size2;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(action, type, start, end) {
    if (action & 131072) {
      this.pushState(action & 65535, this.pos);
    } else if ((action & 262144) == 0) {
      let nextState = action, { parser: parser2 } = this.p;
      if (end > this.pos || type <= parser2.maxNode) {
        this.pos = end;
        if (!parser2.stateFlag(
          nextState,
          1
          /* StateFlag.Skipped */
        ))
          this.reducePos = end;
      }
      this.pushState(nextState, start);
      this.shiftContext(type, start);
      if (type <= parser2.maxNode)
        this.buffer.push(type, start, end, 4);
    } else {
      this.pos = end;
      this.shiftContext(type, start);
      if (type <= this.p.parser.maxNode)
        this.buffer.push(type, start, end, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(action, next, nextStart, nextEnd) {
    if (action & 65536)
      this.reduce(action);
    else
      this.shift(action, next, nextStart, nextEnd);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(value, next) {
    let index2 = this.p.reused.length - 1;
    if (index2 < 0 || this.p.reused[index2] != value) {
      this.p.reused.push(value);
      index2++;
    }
    let start = this.pos;
    this.reducePos = this.pos = start + value.length;
    this.pushState(next, start);
    this.buffer.push(
      index2,
      start,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    );
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let parent = this;
    let off2 = parent.buffer.length;
    while (off2 > 0 && parent.buffer[off2 - 2] > parent.reducePos)
      off2 -= 4;
    let buffer = parent.buffer.slice(off2), base2 = parent.bufferBase + off2;
    while (parent && base2 == parent.bufferBase)
      parent = parent.parent;
    return new Stack(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base2, this.curContext, this.lookAhead, parent);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(next, nextEnd) {
    let isNode2 = next <= this.p.parser.maxNode;
    if (isNode2)
      this.storeNode(next, this.pos, nextEnd, 4);
    this.storeNode(0, this.pos, nextEnd, isNode2 ? 8 : 4);
    this.pos = this.reducePos = nextEnd;
    this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(term) {
    for (let sim = new SimulatedStack(this); ; ) {
      let action = this.p.parser.stateSlot(
        sim.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(sim.state, term);
      if (action == 0)
        return false;
      if ((action & 65536) == 0)
        return true;
      sim.reduce(action);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(next) {
    if (this.stack.length >= 300)
      return [];
    let nextStates = this.p.parser.nextStates(this.state);
    if (nextStates.length > 4 << 1 || this.stack.length >= 120) {
      let best = [];
      for (let i2 = 0, s; i2 < nextStates.length; i2 += 2) {
        if ((s = nextStates[i2 + 1]) != this.state && this.p.parser.hasAction(s, next))
          best.push(nextStates[i2], s);
      }
      if (this.stack.length < 120)
        for (let i2 = 0; best.length < 4 << 1 && i2 < nextStates.length; i2 += 2) {
          let s = nextStates[i2 + 1];
          if (!best.some((v2, i22) => i22 & 1 && v2 == s))
            best.push(nextStates[i2], s);
        }
      nextStates = best;
    }
    let result2 = [];
    for (let i2 = 0; i2 < nextStates.length && result2.length < 4; i2 += 2) {
      let s = nextStates[i2 + 1];
      if (s == this.state)
        continue;
      let stack = this.split();
      stack.pushState(s, this.pos);
      stack.storeNode(0, stack.pos, stack.pos, 4, true);
      stack.shiftContext(nextStates[i2], this.pos);
      stack.reducePos = this.pos;
      stack.score -= 200;
      result2.push(stack);
    }
    return result2;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: parser2 } = this.p;
    let reduce2 = parser2.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((reduce2 & 65536) == 0)
      return false;
    if (!parser2.validAction(this.state, reduce2)) {
      let depth = reduce2 >> 19, term = reduce2 & 65535;
      let target = this.stack.length - depth * 3;
      if (target < 0 || parser2.getGoto(this.stack[target], term, false) < 0) {
        let backup = this.findForcedReduction();
        if (backup == null)
          return false;
        reduce2 = backup;
      }
      this.storeNode(0, this.pos, this.pos, 4, true);
      this.score -= 100;
    }
    this.reducePos = this.pos;
    this.reduce(reduce2);
    return true;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: parser2 } = this.p, seen = [];
    let explore = (state, depth) => {
      if (seen.includes(state))
        return;
      seen.push(state);
      return parser2.allActions(state, (action) => {
        if (action & (262144 | 131072)) ;
        else if (action & 65536) {
          let rDepth = (action >> 19) - depth;
          if (rDepth > 1) {
            let term = action & 65535, target = this.stack.length - rDepth * 3;
            if (target >= 0 && parser2.getGoto(this.stack[target], term, false) >= 0)
              return rDepth << 19 | 65536 | term;
          }
        } else {
          let found = explore(action, depth + 1);
          if (found != null)
            return found;
        }
      });
    };
    return explore(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    while (!this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    )) {
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, true);
        break;
      }
    }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return false;
    let { parser: parser2 } = this.p;
    return parser2.data[parser2.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !parser2.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, true);
    this.state = this.stack[0];
    this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(other) {
    if (this.state != other.state || this.stack.length != other.stack.length)
      return false;
    for (let i2 = 0; i2 < this.stack.length; i2 += 3)
      if (this.stack[i2] != other.stack[i2])
        return false;
    return true;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(dialectID) {
    return this.p.parser.dialect.flags[dialectID];
  }
  shiftContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  reduceContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  /**
  @internal
  */
  emitContext() {
    let last2 = this.buffer.length - 1;
    if (last2 < 0 || this.buffer[last2] != -3)
      this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let last2 = this.buffer.length - 1;
    if (last2 < 0 || this.buffer[last2] != -4)
      this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(context) {
    if (context != this.curContext.context) {
      let newCx = new StackContext(this.curContext.tracker, context);
      if (newCx.hash != this.curContext.hash)
        this.emitContext();
      this.curContext = newCx;
    }
  }
  /**
  @internal
  */
  setLookAhead(lookAhead) {
    if (lookAhead <= this.lookAhead)
      return false;
    this.emitLookAhead();
    this.lookAhead = lookAhead;
    return true;
  }
  /**
  @internal
  */
  close() {
    if (this.curContext && this.curContext.tracker.strict)
      this.emitContext();
    if (this.lookAhead > 0)
      this.emitLookAhead();
  }
}
class StackContext {
  constructor(tracker, context) {
    this.tracker = tracker;
    this.context = context;
    this.hash = tracker.strict ? tracker.hash(context) : 0;
  }
}
class SimulatedStack {
  constructor(start) {
    this.start = start;
    this.state = start.state;
    this.stack = start.stack;
    this.base = this.stack.length;
  }
  reduce(action) {
    let term = action & 65535, depth = action >> 19;
    if (depth == 0) {
      if (this.stack == this.start.stack)
        this.stack = this.stack.slice();
      this.stack.push(this.state, 0, 0);
      this.base += 3;
    } else {
      this.base -= (depth - 1) * 3;
    }
    let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
    this.state = goto;
  }
}
class StackBufferCursor {
  constructor(stack, pos, index2) {
    this.stack = stack;
    this.pos = pos;
    this.index = index2;
    this.buffer = stack.buffer;
    if (this.index == 0)
      this.maybeNext();
  }
  static create(stack, pos = stack.bufferBase + stack.buffer.length) {
    return new StackBufferCursor(stack, pos, pos - stack.bufferBase);
  }
  maybeNext() {
    let next = this.stack.parent;
    if (next != null) {
      this.index = this.stack.bufferBase - next.bufferBase;
      this.stack = next;
      this.buffer = next.buffer;
    }
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4;
    this.pos -= 4;
    if (this.index == 0)
      this.maybeNext();
  }
  fork() {
    return new StackBufferCursor(this.stack, this.pos, this.index);
  }
}
function decodeArray(input, Type = Uint16Array) {
  if (typeof input != "string")
    return input;
  let array = null;
  for (let pos = 0, out = 0; pos < input.length; ) {
    let value = 0;
    for (; ; ) {
      let next = input.charCodeAt(pos++), stop = false;
      if (next == 126) {
        value = 65535;
        break;
      }
      if (next >= 92)
        next--;
      if (next >= 34)
        next--;
      let digit = next - 32;
      if (digit >= 46) {
        digit -= 46;
        stop = true;
      }
      value += digit;
      if (stop)
        break;
      value *= 46;
    }
    if (array)
      array[out++] = value;
    else
      array = new Type(value);
  }
  return array;
}
class CachedToken {
  constructor() {
    this.start = -1;
    this.value = -1;
    this.end = -1;
    this.extended = -1;
    this.lookAhead = 0;
    this.mask = 0;
    this.context = 0;
  }
}
const nullToken = new CachedToken();
class InputStream {
  /**
  @internal
  */
  constructor(input, ranges) {
    this.input = input;
    this.ranges = ranges;
    this.chunk = "";
    this.chunkOff = 0;
    this.chunk2 = "";
    this.chunk2Pos = 0;
    this.next = -1;
    this.token = nullToken;
    this.rangeIndex = 0;
    this.pos = this.chunkPos = ranges[0].from;
    this.range = ranges[0];
    this.end = ranges[ranges.length - 1].to;
    this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(offset2, assoc) {
    let range2 = this.range, index2 = this.rangeIndex;
    let pos = this.pos + offset2;
    while (pos < range2.from) {
      if (!index2)
        return null;
      let next = this.ranges[--index2];
      pos -= range2.from - next.to;
      range2 = next;
    }
    while (assoc < 0 ? pos > range2.to : pos >= range2.to) {
      if (index2 == this.ranges.length - 1)
        return null;
      let next = this.ranges[++index2];
      pos += next.from - range2.to;
      range2 = next;
    }
    return pos;
  }
  /**
  @internal
  */
  clipPos(pos) {
    if (pos >= this.range.from && pos < this.range.to)
      return pos;
    for (let range2 of this.ranges)
      if (range2.to > pos)
        return Math.max(pos, range2.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(offset2) {
    let idx = this.chunkOff + offset2, pos, result2;
    if (idx >= 0 && idx < this.chunk.length) {
      pos = this.pos + offset2;
      result2 = this.chunk.charCodeAt(idx);
    } else {
      let resolved = this.resolveOffset(offset2, 1);
      if (resolved == null)
        return -1;
      pos = resolved;
      if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) {
        result2 = this.chunk2.charCodeAt(pos - this.chunk2Pos);
      } else {
        let i2 = this.rangeIndex, range2 = this.range;
        while (range2.to <= pos)
          range2 = this.ranges[++i2];
        this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
        if (pos + this.chunk2.length > range2.to)
          this.chunk2 = this.chunk2.slice(0, range2.to - pos);
        result2 = this.chunk2.charCodeAt(0);
      }
    }
    if (pos >= this.token.lookAhead)
      this.token.lookAhead = pos + 1;
    return result2;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(token, endOffset = 0) {
    let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
    if (end == null || end < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = token;
    this.token.end = end;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(token, endPos) {
    this.token.value = token;
    this.token.end = endPos;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: chunk2, chunkPos } = this;
      this.chunk = this.chunk2;
      this.chunkPos = this.chunk2Pos;
      this.chunk2 = chunk2;
      this.chunk2Pos = chunkPos;
      this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk;
      this.chunk2Pos = this.chunkPos;
      let nextChunk = this.input.chunk(this.pos);
      let end = this.pos + nextChunk.length;
      this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
      this.chunkPos = this.pos;
      this.chunkOff = 0;
    }
  }
  readNext() {
    if (this.chunkOff >= this.chunk.length) {
      this.getChunk();
      if (this.chunkOff == this.chunk.length)
        return this.next = -1;
    }
    return this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(n = 1) {
    this.chunkOff += n;
    while (this.pos + n >= this.range.to) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      n -= this.range.to - this.pos;
      this.range = this.ranges[++this.rangeIndex];
      this.pos = this.range.from;
    }
    this.pos += n;
    if (this.pos >= this.token.lookAhead)
      this.token.lookAhead = this.pos + 1;
    return this.readNext();
  }
  setDone() {
    this.pos = this.chunkPos = this.end;
    this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
    this.chunk = "";
    return this.next = -1;
  }
  /**
  @internal
  */
  reset(pos, token) {
    if (token) {
      this.token = token;
      token.start = pos;
      token.lookAhead = pos + 1;
      token.value = token.extended = -1;
    } else {
      this.token = nullToken;
    }
    if (this.pos != pos) {
      this.pos = pos;
      if (pos == this.end) {
        this.setDone();
        return this;
      }
      while (pos < this.range.from)
        this.range = this.ranges[--this.rangeIndex];
      while (pos >= this.range.to)
        this.range = this.ranges[++this.rangeIndex];
      if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) {
        this.chunkOff = pos - this.chunkPos;
      } else {
        this.chunk = "";
        this.chunkOff = 0;
      }
      this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(from, to2) {
    if (from >= this.chunkPos && to2 <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(from - this.chunkPos, to2 - this.chunkPos);
    if (from >= this.chunk2Pos && to2 <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(from - this.chunk2Pos, to2 - this.chunk2Pos);
    if (from >= this.range.from && to2 <= this.range.to)
      return this.input.read(from, to2);
    let result2 = "";
    for (let r of this.ranges) {
      if (r.from >= to2)
        break;
      if (r.to > from)
        result2 += this.input.read(Math.max(r.from, from), Math.min(r.to, to2));
    }
    return result2;
  }
}
class TokenGroup {
  constructor(data, id2) {
    this.data = data;
    this.id = id2;
  }
  token(input, stack) {
    let { parser: parser2 } = stack.p;
    readToken(this.data, input, stack, this.id, parser2.data, parser2.tokenPrecTable);
  }
}
TokenGroup.prototype.contextual = TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false;
TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false;
class ExternalTokenizer {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(token, options2 = {}) {
    this.token = token;
    this.contextual = !!options2.contextual;
    this.fallback = !!options2.fallback;
    this.extend = !!options2.extend;
  }
}
function readToken(data, input, stack, group2, precTable, precOffset) {
  let state = 0, groupMask = 1 << group2, { dialect } = stack.p.parser;
  scan: for (; ; ) {
    if ((groupMask & data[state]) == 0)
      break;
    let accEnd = data[state + 1];
    for (let i2 = state + 3; i2 < accEnd; i2 += 2)
      if ((data[i2 + 1] & groupMask) > 0) {
        let term = data[i2];
        if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || overrides(term, input.token.value, precTable, precOffset))) {
          input.acceptToken(term);
          break;
        }
      }
    let next = input.next, low = 0, high = data[state + 2];
    if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535) {
      state = data[accEnd + high * 3 - 1];
      continue scan;
    }
    for (; low < high; ) {
      let mid = low + high >> 1;
      let index2 = accEnd + mid + (mid << 1);
      let from = data[index2], to2 = data[index2 + 1] || 65536;
      if (next < from)
        high = mid;
      else if (next >= to2)
        low = mid + 1;
      else {
        state = data[index2 + 2];
        input.advance();
        continue scan;
      }
    }
    break;
  }
}
function findOffset(data, start, term) {
  for (let i2 = start, next; (next = data[i2]) != 65535; i2++)
    if (next == term)
      return i2 - start;
  return -1;
}
function overrides(token, prev, tableData, tableOffset) {
  let iPrev = findOffset(tableData, tableOffset, prev);
  return iPrev < 0 || findOffset(tableData, tableOffset, token) < iPrev;
}
const verbose = typeof process != "undefined" && process.env && /\bparse\b/.test(process.env.LOG);
let stackIDs = null;
function cutAt(tree, pos, side) {
  let cursor2 = tree.cursor(IterMode.IncludeAnonymous);
  cursor2.moveTo(pos);
  for (; ; ) {
    if (!(side < 0 ? cursor2.childBefore(pos) : cursor2.childAfter(pos)))
      for (; ; ) {
        if ((side < 0 ? cursor2.to < pos : cursor2.from > pos) && !cursor2.type.isError)
          return side < 0 ? Math.max(0, Math.min(
            cursor2.to - 1,
            pos - 25
            /* Lookahead.Margin */
          )) : Math.min(tree.length, Math.max(
            cursor2.from + 1,
            pos + 25
            /* Lookahead.Margin */
          ));
        if (side < 0 ? cursor2.prevSibling() : cursor2.nextSibling())
          break;
        if (!cursor2.parent())
          return side < 0 ? 0 : tree.length;
      }
  }
}
class FragmentCursor {
  constructor(fragments, nodeSet) {
    this.fragments = fragments;
    this.nodeSet = nodeSet;
    this.i = 0;
    this.fragment = null;
    this.safeFrom = -1;
    this.safeTo = -1;
    this.trees = [];
    this.start = [];
    this.index = [];
    this.nextFragment();
  }
  nextFragment() {
    let fr2 = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (fr2) {
      this.safeFrom = fr2.openStart ? cutAt(fr2.tree, fr2.from + fr2.offset, 1) - fr2.offset : fr2.from;
      this.safeTo = fr2.openEnd ? cutAt(fr2.tree, fr2.to + fr2.offset, -1) - fr2.offset : fr2.to;
      while (this.trees.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
      }
      this.trees.push(fr2.tree);
      this.start.push(-fr2.offset);
      this.index.push(0);
      this.nextStart = this.safeFrom;
    } else {
      this.nextStart = 1e9;
    }
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(pos) {
    if (pos < this.nextStart)
      return null;
    while (this.fragment && this.safeTo <= pos)
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let last2 = this.trees.length - 1;
      if (last2 < 0) {
        this.nextFragment();
        return null;
      }
      let top2 = this.trees[last2], index2 = this.index[last2];
      if (index2 == top2.children.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
        continue;
      }
      let next = top2.children[index2];
      let start = this.start[last2] + top2.positions[index2];
      if (start > pos) {
        this.nextStart = start;
        return null;
      }
      if (next instanceof Tree2) {
        if (start == pos) {
          if (start < this.safeFrom)
            return null;
          let end = start + next.length;
          if (end <= this.safeTo) {
            let lookAhead = next.prop(NodeProp2.lookAhead);
            if (!lookAhead || end + lookAhead < this.fragment.to)
              return next;
          }
        }
        this.index[last2]++;
        if (start + next.length >= Math.max(this.safeFrom, pos)) {
          this.trees.push(next);
          this.start.push(start);
          this.index.push(0);
        }
      } else {
        this.index[last2]++;
        this.nextStart = start + next.length;
      }
    }
  }
}
class TokenCache {
  constructor(parser2, stream) {
    this.stream = stream;
    this.tokens = [];
    this.mainToken = null;
    this.actions = [];
    this.tokens = parser2.tokenizers.map((_2) => new CachedToken());
  }
  getActions(stack) {
    let actionIndex = 0;
    let main2 = null;
    let { parser: parser2 } = stack.p, { tokenizers } = parser2;
    let mask = parser2.stateSlot(
      stack.state,
      3
      /* ParseState.TokenizerMask */
    );
    let context = stack.curContext ? stack.curContext.hash : 0;
    let lookAhead = 0;
    for (let i2 = 0; i2 < tokenizers.length; i2++) {
      if ((1 << i2 & mask) == 0)
        continue;
      let tokenizer = tokenizers[i2], token = this.tokens[i2];
      if (main2 && !tokenizer.fallback)
        continue;
      if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
        this.updateCachedToken(token, tokenizer, stack);
        token.mask = mask;
        token.context = context;
      }
      if (token.lookAhead > token.end + 25)
        lookAhead = Math.max(token.lookAhead, lookAhead);
      if (token.value != 0) {
        let startIndex = actionIndex;
        if (token.extended > -1)
          actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
        actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
        if (!tokenizer.extend) {
          main2 = token;
          if (actionIndex > startIndex)
            break;
        }
      }
    }
    while (this.actions.length > actionIndex)
      this.actions.pop();
    if (lookAhead)
      stack.setLookAhead(lookAhead);
    if (!main2 && stack.pos == this.stream.end) {
      main2 = new CachedToken();
      main2.value = stack.p.parser.eofTerm;
      main2.start = main2.end = stack.pos;
      actionIndex = this.addActions(stack, main2.value, main2.end, actionIndex);
    }
    this.mainToken = main2;
    return this.actions;
  }
  getMainToken(stack) {
    if (this.mainToken)
      return this.mainToken;
    let main2 = new CachedToken(), { pos, p } = stack;
    main2.start = pos;
    main2.end = Math.min(pos + 1, p.stream.end);
    main2.value = pos == p.stream.end ? p.parser.eofTerm : 0;
    return main2;
  }
  updateCachedToken(token, tokenizer, stack) {
    let start = this.stream.clipPos(stack.pos);
    tokenizer.token(this.stream.reset(start, token), stack);
    if (token.value > -1) {
      let { parser: parser2 } = stack.p;
      for (let i2 = 0; i2 < parser2.specialized.length; i2++)
        if (parser2.specialized[i2] == token.value) {
          let result2 = parser2.specializers[i2](this.stream.read(token.start, token.end), stack);
          if (result2 >= 0 && stack.p.parser.dialect.allows(result2 >> 1)) {
            if ((result2 & 1) == 0)
              token.value = result2 >> 1;
            else
              token.extended = result2 >> 1;
            break;
          }
        }
    } else {
      token.value = 0;
      token.end = this.stream.clipPos(start + 1);
    }
  }
  putAction(action, token, end, index2) {
    for (let i2 = 0; i2 < index2; i2 += 3)
      if (this.actions[i2] == action)
        return index2;
    this.actions[index2++] = action;
    this.actions[index2++] = token;
    this.actions[index2++] = end;
    return index2;
  }
  addActions(stack, token, end, index2) {
    let { state } = stack, { parser: parser2 } = stack.p, { data } = parser2;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = parser2.stateSlot(
        state,
        set2 ? 2 : 1
        /* ParseState.Actions */
      ); ; i2 += 3) {
        if (data[i2] == 65535) {
          if (data[i2 + 1] == 1) {
            i2 = pair(data, i2 + 2);
          } else {
            if (index2 == 0 && data[i2 + 1] == 2)
              index2 = this.putAction(pair(data, i2 + 2), token, end, index2);
            break;
          }
        }
        if (data[i2] == token)
          index2 = this.putAction(pair(data, i2 + 1), token, end, index2);
      }
    }
    return index2;
  }
}
class Parse {
  constructor(parser2, input, fragments, ranges) {
    this.parser = parser2;
    this.input = input;
    this.ranges = ranges;
    this.recovering = 0;
    this.nextStackID = 9812;
    this.minStackPos = 0;
    this.reused = [];
    this.stoppedAt = null;
    this.lastBigReductionStart = -1;
    this.lastBigReductionSize = 0;
    this.bigReductionCount = 0;
    this.stream = new InputStream(input, ranges);
    this.tokens = new TokenCache(parser2, this.stream);
    this.topTerm = parser2.top[1];
    let { from } = ranges[0];
    this.stacks = [Stack.start(this, parser2.top[0], from)];
    this.fragments = fragments.length && this.stream.end - from > parser2.bufferLength * 4 ? new FragmentCursor(fragments, parser2.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let stacks = this.stacks, pos = this.minStackPos;
    let newStacks = this.stacks = [];
    let stopped, stoppedTokens;
    if (this.bigReductionCount > 300 && stacks.length == 1) {
      let [s] = stacks;
      while (s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart) {
      }
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack = stacks[i2];
      for (; ; ) {
        this.tokens.mainToken = null;
        if (stack.pos > pos) {
          newStacks.push(stack);
        } else if (this.advanceStack(stack, newStacks, stacks)) {
          continue;
        } else {
          if (!stopped) {
            stopped = [];
            stoppedTokens = [];
          }
          stopped.push(stack);
          let tok = this.tokens.getMainToken(stack);
          stoppedTokens.push(tok.value, tok.end);
        }
        break;
      }
    }
    if (!newStacks.length) {
      let finished = stopped && findFinished(stopped);
      if (finished) {
        if (verbose)
          console.log("Finish with " + this.stackID(finished));
        return this.stackToTree(finished);
      }
      if (this.parser.strict) {
        if (verbose && stopped)
          console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
        throw new SyntaxError("No parse at " + pos);
      }
      if (!this.recovering)
        this.recovering = 5;
    }
    if (this.recovering && stopped) {
      let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
      if (finished) {
        if (verbose)
          console.log("Force-finish " + this.stackID(finished));
        return this.stackToTree(finished.forceAll());
      }
    }
    if (this.recovering) {
      let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3;
      if (newStacks.length > maxRemaining) {
        newStacks.sort((a, b2) => b2.score - a.score);
        while (newStacks.length > maxRemaining)
          newStacks.pop();
      }
      if (newStacks.some((s) => s.reducePos > pos))
        this.recovering--;
    } else if (newStacks.length > 1) {
      outer: for (let i2 = 0; i2 < newStacks.length - 1; i2++) {
        let stack = newStacks[i2];
        for (let j2 = i2 + 1; j2 < newStacks.length; j2++) {
          let other = newStacks[j2];
          if (stack.sameState(other) || stack.buffer.length > 500 && other.buffer.length > 500) {
            if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) {
              newStacks.splice(j2--, 1);
            } else {
              newStacks.splice(i2--, 1);
              continue outer;
            }
          }
        }
      }
      if (newStacks.length > 12)
        newStacks.splice(
          12,
          newStacks.length - 12
          /* Rec.MaxStackCount */
        );
    }
    this.minStackPos = newStacks[0].pos;
    for (let i2 = 1; i2 < newStacks.length; i2++)
      if (newStacks[i2].pos < this.minStackPos)
        this.minStackPos = newStacks[i2].pos;
    return null;
  }
  stopAt(pos) {
    if (this.stoppedAt != null && this.stoppedAt < pos)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = pos;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(stack, stacks, split) {
    let start = stack.pos, { parser: parser2 } = this;
    let base2 = verbose ? this.stackID(stack) + " -> " : "";
    if (this.stoppedAt != null && start > this.stoppedAt)
      return stack.forceReduce() ? stack : null;
    if (this.fragments) {
      let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
      for (let cached = this.fragments.nodeAt(start); cached; ) {
        let match2 = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser2.getGoto(stack.state, cached.type.id) : -1;
        if (match2 > -1 && cached.length && (!strictCx || (cached.prop(NodeProp2.contextHash) || 0) == cxHash)) {
          stack.useNode(cached, match2);
          if (verbose)
            console.log(base2 + this.stackID(stack) + ` (via reuse of ${parser2.getName(cached.type.id)})`);
          return true;
        }
        if (!(cached instanceof Tree2) || cached.children.length == 0 || cached.positions[0] > 0)
          break;
        let inner = cached.children[0];
        if (inner instanceof Tree2 && cached.positions[0] == 0)
          cached = inner;
        else
          break;
      }
    }
    let defaultReduce = parser2.stateSlot(
      stack.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (defaultReduce > 0) {
      stack.reduce(defaultReduce);
      if (verbose)
        console.log(base2 + this.stackID(stack) + ` (via always-reduce ${parser2.getName(
          defaultReduce & 65535
          /* Action.ValueMask */
        )})`);
      return true;
    }
    if (stack.stack.length >= 8400) {
      while (stack.stack.length > 6e3 && stack.forceReduce()) {
      }
    }
    let actions = this.tokens.getActions(stack);
    for (let i2 = 0; i2 < actions.length; ) {
      let action = actions[i2++], term = actions[i2++], end = actions[i2++];
      let last2 = i2 == actions.length || !split;
      let localStack = last2 ? stack : stack.split();
      let main2 = this.tokens.mainToken;
      localStack.apply(action, term, main2 ? main2.start : localStack.pos, end);
      if (verbose)
        console.log(base2 + this.stackID(localStack) + ` (via ${(action & 65536) == 0 ? "shift" : `reduce of ${parser2.getName(
          action & 65535
          /* Action.ValueMask */
        )}`} for ${parser2.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
      if (last2)
        return true;
      else if (localStack.pos > start)
        stacks.push(localStack);
      else
        split.push(localStack);
    }
    return false;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(stack, newStacks) {
    let pos = stack.pos;
    for (; ; ) {
      if (!this.advanceStack(stack, null, null))
        return false;
      if (stack.pos > pos) {
        pushStackDedup(stack, newStacks);
        return true;
      }
    }
  }
  runRecovery(stacks, tokens, newStacks) {
    let finished = null, restarted = false;
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack = stacks[i2], token = tokens[i2 << 1], tokenEnd = tokens[(i2 << 1) + 1];
      let base2 = verbose ? this.stackID(stack) + " -> " : "";
      if (stack.deadEnd) {
        if (restarted)
          continue;
        restarted = true;
        stack.restart();
        if (verbose)
          console.log(base2 + this.stackID(stack) + " (restarted)");
        let done = this.advanceFully(stack, newStacks);
        if (done)
          continue;
      }
      let force = stack.split(), forceBase = base2;
      for (let j2 = 0; j2 < 10 && force.forceReduce(); j2++) {
        if (verbose)
          console.log(forceBase + this.stackID(force) + " (via force-reduce)");
        let done = this.advanceFully(force, newStacks);
        if (done)
          break;
        if (verbose)
          forceBase = this.stackID(force) + " -> ";
      }
      for (let insert2 of stack.recoverByInsert(token)) {
        if (verbose)
          console.log(base2 + this.stackID(insert2) + " (via recover-insert)");
        this.advanceFully(insert2, newStacks);
      }
      if (this.stream.end > stack.pos) {
        if (tokenEnd == stack.pos) {
          tokenEnd++;
          token = 0;
        }
        stack.recoverByDelete(token, tokenEnd);
        if (verbose)
          console.log(base2 + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
        pushStackDedup(stack, newStacks);
      } else if (!finished || finished.score < stack.score) {
        finished = stack;
      }
    }
    return finished;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(stack) {
    stack.close();
    return Tree2.build({
      buffer: StackBufferCursor.create(stack),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: stack.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(stack) {
    let id2 = (stackIDs || (stackIDs = /* @__PURE__ */ new WeakMap())).get(stack);
    if (!id2)
      stackIDs.set(stack, id2 = String.fromCodePoint(this.nextStackID++));
    return id2 + stack;
  }
}
function pushStackDedup(stack, newStacks) {
  for (let i2 = 0; i2 < newStacks.length; i2++) {
    let other = newStacks[i2];
    if (other.pos == stack.pos && other.sameState(stack)) {
      if (newStacks[i2].score < stack.score)
        newStacks[i2] = stack;
      return;
    }
  }
  newStacks.push(stack);
}
class Dialect {
  constructor(source, flags, disabled) {
    this.source = source;
    this.flags = flags;
    this.disabled = disabled;
  }
  allows(term) {
    return !this.disabled || this.disabled[term] == 0;
  }
}
const id = (x2) => x2;
class ContextTracker {
  /**
  Define a context tracker.
  */
  constructor(spec) {
    this.start = spec.start;
    this.shift = spec.shift || id;
    this.reduce = spec.reduce || id;
    this.reuse = spec.reuse || id;
    this.hash = spec.hash || (() => 0);
    this.strict = spec.strict !== false;
  }
}
class LRParser extends Parser2 {
  /**
  @internal
  */
  constructor(spec) {
    super();
    this.wrappers = [];
    if (spec.version != 14)
      throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14})`);
    let nodeNames = spec.nodeNames.split(" ");
    this.minRepeatTerm = nodeNames.length;
    for (let i2 = 0; i2 < spec.repeatNodeCount; i2++)
      nodeNames.push("");
    let topTerms = Object.keys(spec.topRules).map((r) => spec.topRules[r][1]);
    let nodeProps = [];
    for (let i2 = 0; i2 < nodeNames.length; i2++)
      nodeProps.push([]);
    function setProp(nodeID, prop, value) {
      nodeProps[nodeID].push([prop, prop.deserialize(String(value))]);
    }
    if (spec.nodeProps)
      for (let propSpec of spec.nodeProps) {
        let prop = propSpec[0];
        if (typeof prop == "string")
          prop = NodeProp2[prop];
        for (let i2 = 1; i2 < propSpec.length; ) {
          let next = propSpec[i2++];
          if (next >= 0) {
            setProp(next, prop, propSpec[i2++]);
          } else {
            let value = propSpec[i2 + -next];
            for (let j2 = -next; j2 > 0; j2--)
              setProp(propSpec[i2++], prop, value);
            i2++;
          }
        }
      }
    this.nodeSet = new NodeSet(nodeNames.map((name2, i2) => NodeType2.define({
      name: i2 >= this.minRepeatTerm ? void 0 : name2,
      id: i2,
      props: nodeProps[i2],
      top: topTerms.indexOf(i2) > -1,
      error: i2 == 0,
      skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i2) > -1
    })));
    if (spec.propSources)
      this.nodeSet = this.nodeSet.extend(...spec.propSources);
    this.strict = false;
    this.bufferLength = DefaultBufferLength;
    let tokenArray = decodeArray(spec.tokenData);
    this.context = spec.context;
    this.specializerSpecs = spec.specialized || [];
    this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let i2 = 0; i2 < this.specializerSpecs.length; i2++)
      this.specialized[i2] = this.specializerSpecs[i2].term;
    this.specializers = this.specializerSpecs.map(getSpecializer);
    this.states = decodeArray(spec.states, Uint32Array);
    this.data = decodeArray(spec.stateData);
    this.goto = decodeArray(spec.goto);
    this.maxTerm = spec.maxTerm;
    this.tokenizers = spec.tokenizers.map((value) => typeof value == "number" ? new TokenGroup(tokenArray, value) : value);
    this.topRules = spec.topRules;
    this.dialects = spec.dialects || {};
    this.dynamicPrecedences = spec.dynamicPrecedences || null;
    this.tokenPrecTable = spec.tokenPrec;
    this.termNames = spec.termNames || null;
    this.maxNode = this.nodeSet.types.length - 1;
    this.dialect = this.parseDialect();
    this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(input, fragments, ranges) {
    let parse2 = new Parse(this, input, fragments, ranges);
    for (let w2 of this.wrappers)
      parse2 = w2(parse2, input, fragments, ranges);
    return parse2;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(state, term, loose = false) {
    let table = this.goto;
    if (term >= table[0])
      return -1;
    for (let pos = table[term + 1]; ; ) {
      let groupTag = table[pos++], last2 = groupTag & 1;
      let target = table[pos++];
      if (last2 && loose)
        return target;
      for (let end = pos + (groupTag >> 1); pos < end; pos++)
        if (table[pos] == state)
          return target;
      if (last2)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(state, terminal) {
    let data = this.data;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = this.stateSlot(
        state,
        set2 ? 2 : 1
        /* ParseState.Actions */
      ), next; ; i2 += 3) {
        if ((next = data[i2]) == 65535) {
          if (data[i2 + 1] == 1)
            next = data[i2 = pair(data, i2 + 2)];
          else if (data[i2 + 1] == 2)
            return pair(data, i2 + 2);
          else
            break;
        }
        if (next == terminal || next == 0)
          return pair(data, i2 + 1);
      }
    }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(state, slot) {
    return this.states[state * 6 + slot];
  }
  /**
  @internal
  */
  stateFlag(state, flag) {
    return (this.stateSlot(
      state,
      0
      /* ParseState.Flags */
    ) & flag) > 0;
  }
  /**
  @internal
  */
  validAction(state, action) {
    return !!this.allActions(state, (a) => a == action ? true : null);
  }
  /**
  @internal
  */
  allActions(state, action) {
    let deflt = this.stateSlot(
      state,
      4
      /* ParseState.DefaultReduce */
    );
    let result2 = deflt ? action(deflt) : void 0;
    for (let i2 = this.stateSlot(
      state,
      1
      /* ParseState.Actions */
    ); result2 == null; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair(this.data, i2 + 2);
        else
          break;
      }
      result2 = action(pair(this.data, i2 + 1));
    }
    return result2;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(state) {
    let result2 = [];
    for (let i2 = this.stateSlot(
      state,
      1
      /* ParseState.Actions */
    ); ; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair(this.data, i2 + 2);
        else
          break;
      }
      if ((this.data[i2 + 2] & 65536 >> 16) == 0) {
        let value = this.data[i2 + 1];
        if (!result2.some((v2, i22) => i22 & 1 && v2 == value))
          result2.push(this.data[i2], value);
      }
    }
    return result2;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(config2) {
    let copy2 = Object.assign(Object.create(LRParser.prototype), this);
    if (config2.props)
      copy2.nodeSet = this.nodeSet.extend(...config2.props);
    if (config2.top) {
      let info = this.topRules[config2.top];
      if (!info)
        throw new RangeError(`Invalid top rule name ${config2.top}`);
      copy2.top = info;
    }
    if (config2.tokenizers)
      copy2.tokenizers = this.tokenizers.map((t2) => {
        let found = config2.tokenizers.find((r) => r.from == t2);
        return found ? found.to : t2;
      });
    if (config2.specializers) {
      copy2.specializers = this.specializers.slice();
      copy2.specializerSpecs = this.specializerSpecs.map((s, i2) => {
        let found = config2.specializers.find((r) => r.from == s.external);
        if (!found)
          return s;
        let spec = Object.assign(Object.assign({}, s), { external: found.to });
        copy2.specializers[i2] = getSpecializer(spec);
        return spec;
      });
    }
    if (config2.contextTracker)
      copy2.context = config2.contextTracker;
    if (config2.dialect)
      copy2.dialect = this.parseDialect(config2.dialect);
    if (config2.strict != null)
      copy2.strict = config2.strict;
    if (config2.wrap)
      copy2.wrappers = copy2.wrappers.concat(config2.wrap);
    if (config2.bufferLength != null)
      copy2.bufferLength = config2.bufferLength;
    return copy2;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(term) {
    return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(term) {
    let prec2 = this.dynamicPrecedences;
    return prec2 == null ? 0 : prec2[term] || 0;
  }
  /**
  @internal
  */
  parseDialect(dialect) {
    let values2 = Object.keys(this.dialects), flags = values2.map(() => false);
    if (dialect)
      for (let part of dialect.split(" ")) {
        let id2 = values2.indexOf(part);
        if (id2 >= 0)
          flags[id2] = true;
      }
    let disabled = null;
    for (let i2 = 0; i2 < values2.length; i2++)
      if (!flags[i2]) {
        for (let j2 = this.dialects[values2[i2]], id2; (id2 = this.data[j2++]) != 65535; )
          (disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id2] = 1;
      }
    return new Dialect(dialect, flags, disabled);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(spec) {
    return new LRParser(spec);
  }
}
function pair(data, off2) {
  return data[off2] | data[off2 + 1] << 16;
}
function findFinished(stacks) {
  let best = null;
  for (let stack of stacks) {
    let stopped = stack.p.stoppedAt;
    if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(
      stack.state,
      2
      /* StateFlag.Accepting */
    ) && (!best || best.score < stack.score))
      best = stack;
  }
  return best;
}
function getSpecializer(spec) {
  if (spec.external) {
    let mask = spec.extend ? 1 : 0;
    return (value, stack) => spec.external(value, stack) << 1 | mask;
  }
  return spec.get;
}
const StartTag = 1, StartCloseTag = 2, MissingCloseTag = 3, mismatchedStartCloseTag = 4, incompleteStartCloseTag = 5, commentContent$1 = 36, piContent$1 = 37, cdataContent$1 = 38, Text2 = 7, Element$1 = 12, OpenTag = 14;
function nameChar(ch) {
  return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
function isSpace(ch) {
  return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}
let cachedName = null, cachedInput = null, cachedPos = 0;
function tagNameAfter(input, offset2) {
  let pos = input.pos + offset2;
  if (cachedInput == input && cachedPos == pos) return cachedName;
  while (isSpace(input.peek(offset2))) offset2++;
  let name2 = "";
  for (; ; ) {
    let next = input.peek(offset2);
    if (!nameChar(next)) break;
    name2 += String.fromCharCode(next);
    offset2++;
  }
  cachedInput = input;
  cachedPos = pos;
  return cachedName = name2 || null;
}
class ElementContext {
  constructor(name2, parent) {
    this.name = name2;
    this.parent = parent ?? null;
    this.hash = parent ? parent.hash : 0;
    for (let i2 = 0; i2 < name2.length; i2++) {
      this.hash += (this.hash << 4) + name2.charCodeAt(i2) + (name2.charCodeAt(i2) << 8);
    }
  }
}
const elementContext = new ContextTracker({
  start: null,
  shift(context, term, stack, input) {
    return term == StartTag ? new ElementContext(tagNameAfter(input, 1) || "", context) : context;
  },
  reduce(context, term) {
    return term == Element$1 && context ? context.parent : context;
  },
  reuse(context, node, _stack, input) {
    let type = node.type.id;
    return type == StartTag || type == OpenTag ? new ElementContext(tagNameAfter(input, 1) || "", context) : context;
  },
  hash(context) {
    return context ? context.hash : 0;
  },
  strict: false
});
const startTag = new ExternalTokenizer(
  (input, stack) => {
    if (input.next !== 60) {
      return;
    }
    const nextNext = input.peek(1);
    if (nextNext === 61) {
      return;
    }
    input.advance();
    if (input.next === 47) {
      input.advance();
      let name2 = tagNameAfter(input, 0);
      if (!name2) {
        return input.acceptToken(incompleteStartCloseTag);
      }
      if (stack.context && name2.toLowerCase() == stack.context.name.toLowerCase()) {
        return input.acceptToken(StartCloseTag);
      }
      for (let cx = stack.context; cx; cx = cx.parent) {
        if (cx.name === name2) {
          return input.acceptToken(MissingCloseTag, -2);
        }
      }
      input.acceptToken(mismatchedStartCloseTag);
    } else if (
      // @ts-ignore
      input.next !== 33 && // @ts-ignore
      input.next !== 63 && !isSpace(input.next)
    ) {
      return input.acceptToken(StartTag);
    }
  },
  { contextual: true }
);
const textLessThan = new ExternalTokenizer((input) => {
  if (input.next !== 60) {
    return;
  }
  const nextNext = input.peek(1);
  if (nextNext === 60) {
    return input.acceptToken(Text2, 1);
  }
});
function scanTo(type, end) {
  return new ExternalTokenizer((input) => {
    for (let endPos = 0, len = 0; ; len++) {
      if (input.next < 0) {
        if (len) {
          input.acceptToken(type);
        }
        break;
      }
      if (input.next == end.charCodeAt(endPos)) {
        endPos++;
        if (endPos == end.length) {
          if (len > end.length) {
            input.acceptToken(type, 1 - end.length);
          }
          break;
        }
      } else {
        endPos = 0;
      }
      input.advance();
    }
  });
}
const commentContent = scanTo(commentContent$1, "-->");
const piContent = scanTo(piContent$1, "?>");
const cdataContent = scanTo(cdataContent$1, "]]>");
const parser = LRParser.deserialize({
  version: 14,
  states: "(jOVOqOOOzO!jO'#CgO!SQ!bO'#CjO!|OqO'#ChOOOP'#Ch'#ChO#TO!dO'#CsO#]O!fO'#CtO#eQ!bO'#CuOOOP'#DW'#DWOOOP'#Cw'#CwQVOqOOOOOW'#Cx'#CxO#jO!jO,59ROOOP,59R,59RO#rQ#tO,59UOOOP'#C|'#C|O#}OqO,59SO$UQ!bO'#CpOOOP,59S,59SOOOQ'#C}'#C}O$ZO!dO,59_OOOP,59_,59_OOOS'#DO'#DOO$cO!fO,59`OOOP,59`,59`O$kQ!bO,59aOOOP-E6u-E6uOOOW-E6v-E6vOOOP1G.m1G.mO$pQ#tO'#ClOOQO'#Cy'#CyO%OQ#tO1G.pOOOP1G.p1G.pOOOP1G.x1G.xOOOP-E6z-E6zOOOP1G.n1G.nO%ZQ!bO,59[OOOQ-E6{-E6{OOOP1G.y1G.yOOOS-E6|-E6|OOOP1G.z1G.zOOOP1G.{1G.{O%`Q!bO,59WOOQO-E6w-E6wOOOP7+$[7+$[OOOP7+$d7+$dOOOP1G.v1G.vO%hO&jO'#CoO%yO,UO'#CoOOQO1G.r1G.rOOOO'#Cz'#CzO&[O&jO,59ZOOQO,59Z,59ZOOOO'#C{'#C{O&mO,UO,59ZOOOO-E6x-E6xOOQO1G.u1G.uOOOO-E6y-E6y",
  stateData: "'T~OyOS~OPQOSVOTWOVWOWWOXWOYWOjXO|PO!STO!UUO~OvZO{]O~O_^O~OPQOQaOSVOTWOVWOWWOXWOYWO|PO!STO!UUO~ORbO~P!XOtcO!ReO~OufO!ThO~O_iO~OvZO{lO~O]pOamOeqO~ORsO~P!XO_tO~OtcO!RvO~OufO!TxO~O]yO~ObzO]`Xa`Xe`X~O]|OamOe}O~O]!OO~O}!PO!P!QO~OW!SOX!SOY!SO}!UO!O!SO~OW!VOX!VOY!VO!P!UO!Q!VO~OW!SOX!SOY!SO}!YO!O!SO~OW!VOX!VOY!VO!P!YO!Q!VO~OXWYW~",
  goto: "#w{PPPPPPPPPPP||P!SP!YPP!^!aP!g|||P!m!s!y#P#V#]#c#iPPPPPPP#oXWORY`XRORY`Tn^oR!RzQbRRs`XSORY`QYORjYQ[PRk[Qo^R{oQ!T!PR!X!TQ!W!QR!Z!WQ`RRr`QdTRudQgURwgSXOYT_R`",
  nodeNames: "⚠ StartTag StartCloseTag MissingCloseTag StartCloseTag StartCloseTag Document Text EntityReference CharacterReference Ampersand Cdata Element EndTag OpenTag TagName Attribute AttributeName Is AttributeValue CloseTag SelfCloseEndTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag DoctypeDecl",
  maxTerm: 52,
  context: elementContext,
  nodeProps: [
    [
      "closedBy",
      1,
      "SelfCloseEndTag EndTag",
      14,
      "CloseTag MissingCloseTag"
    ],
    [
      "openedBy",
      13,
      "StartTag StartCloseTag",
      20,
      "OpenTag",
      21,
      "StartTag"
    ]
  ],
  skippedNodes: [0],
  repeatNodeCount: 8,
  tokenData: "!2c~R!YOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs2wsv$qvw3gwx7lx}$q}!O8_!O!P$q!P!Q:}!Q![$q![!]<q!]!^$q!^!_@X!_!`!,a!`!a!-X!a!b!.P!b!c$q!c!}<q!}#P$q#P#Q!/s#Q#R$q#R#S<q#S#T$q#T#o<q#o%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U$q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;'S<q;'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qi$zXVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qa%nVVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%gP&YUVPOv&Tw!^&T!^!_&l!_;'S&T;'S;=`'|<%lO&TP&oTXY'OYZ'O]^'Opq'O!_!`&TP'T]VPOX&TXY'OYZ'OZ]&T]^'O^p&Tpq'Oqv&Tw!^&T!^!_&l!_;'S&T;'S;=`'|<%lO&TP(PP;=`<%l&Ta(X]!Q`OX)QXY)iYZ)iZ])Q]^)i^p)Qpq)iqv)Qx!_)Q!_!`%g!`;'S)Q;'S;=`)c<%lO)Q`)VS!Q`Ov)Qx;'S)Q;'S;=`)c<%lO)Q`)fP;=`<%l)Qa)p^VP!Q`OX%gXY)iYZ)iZ]%g]^)i^p%gpq)iqv%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%ga*oP;=`<%l%gX*yWVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rX+h^!OWOX,dXY-OYZ-OZ],d]^-O^p,dpq-Oqr,dsv,dw!_,d!_!`*r!`;'S,d;'S;=`,x<%lO,dW,iT!OWOr,dsv,dw;'S,d;'S;=`,x<%lO,dW,{P;=`<%l,dX-V_VP!OWOX*rXY-OYZ-OZ]*r]^-O^p*rpq-Oqr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rX.XP;=`<%l*ri.c`!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0Xqr/ers)Qsv/ewx,dx!_/e!_!`$q!`;'S/e;'S;=`0R<%lO/eh/lV!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eh0UP;=`<%l/ei0b`VP!OW!Q`OX$qXY0XYZ0XZ]$q]^0X^p$qpq0Xqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qi1gP;=`<%l$qo1u`VP!OW!Q`yUOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk3QV}YVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%g~3laY~st4q![!]5u!c!}5u#R#S5u#T#o5u%W%o5u%p&a5u&b1p5u4U4d5u4e$IS5u$I`$Ib5u$Kh%#t5u&/x&Et5u&FV;'S5u;'S;:j7f?&r?Ah5u?BY?Mn5u~4tQ!Q![4z#l#m5Y~4}Q!Q![4z!]!^5T~5YOX~~5]R!Q![5f!c!i5f#T#Z5f~5iS!Q![5f!]!^5T!c!i5f#T#Z5f~5xg}!O5u!O!P5u!Q![5u![!]5u!]!^7a!c!}5u#R#S5u#T#o5u$}%O5u%W%o5u%p&a5u&b1p5u1p4U5u4U4d5u4e$IS5u$I`$Ib5u$Je$Jg5u$Kh%#t5u&/x&Et5u&FV;'S5u;'S;:j7f?&r?Ah5u?BY?Mn5u~7fOW~~7iP;=`<%l5uk7uW!PbVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rk8hZVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O9Z!O!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk9dZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a:V!a;'S$q;'S;=`1d<%lO$qk:bX!RQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qm;WZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a;y!a;'S$q;'S;=`1d<%lO$qm<UXeSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qo=O!PaS_QVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O<q!O!P<q!P!Q$q!Q![<q![!]<q!]!^$q!^!_.[!_!c$q!c!}<q!}#R$q#R#S<q#S#T$q#T#o<q#o$}$q$}%O<q%O%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U<q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Je$q$Je$Jg<q$Jg$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;'S<q;'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qo@UP;=`<%l<qi@`b!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0XqrAhrs)Qsv/ewx,dx!_/e!_!`$q!`!a/e!a!b!+q!b;'S/e;'S;=`0R<%lO/eiAo_!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OBn!O!f/e!f!gDQ!g!}/e!}#OMT#O#W/e#W#X!']#X;'S/e;'S;=`0R<%lO/eiBuX!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OCb!O;'S/e;'S;=`0R<%lO/eiCkV!SP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eiDXX!OW!Q`Or/ers)Qsv/ewx,dx!q/e!q!rDt!r;'S/e;'S;=`0R<%lO/eiD{X!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fEh!f;'S/e;'S;=`0R<%lO/eiEoX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!wF[!w;'S/e;'S;=`0R<%lO/eiFcX!OW!Q`Or/ers)Qsv/ewx,dx!{/e!{!|GO!|;'S/e;'S;=`0R<%lO/eiGVX!OW!Q`Or/ers)Qsv/ewx,dx!r/e!r!sGr!s;'S/e;'S;=`0R<%lO/eiGyX!OW!Q`Or/ers)Qsv/ewx,dx!g/e!g!hHf!h;'S/e;'S;=`0R<%lO/eiHmY!OW!Q`OrHfrsI]svHfvwIwwxKPx!`Hf!`!aL_!a;'SHf;'S;=`L}<%lOHfaIbV!Q`OvI]vxIwx!`I]!`!aJf!a;'SI];'S;=`Jy<%lOI]PIzTO!`Iw!`!aJZ!a;'SIw;'S;=`J`<%lOIwPJ`OjPPJcP;=`<%lIwaJmSjP!Q`Ov)Qx;'S)Q;'S;=`)c<%lO)QaJ|P;=`<%lI]XKUX!OWOrKPrsIwsvKPvwIww!`KP!`!aKq!a;'SKP;'S;=`LX<%lOKPXKxTjP!OWOr,dsv,dw;'S,d;'S;=`,x<%lO,dXL[P;=`<%lKPiLhVjP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eiMQP;=`<%lHfiM[Z!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fM}!f#V/e#V#W!$_#W;'S/e;'S;=`0R<%lO/eiNUX!OW!Q`Or/ers)Qsv/ewx,dx!f/e!f!gNq!g;'S/e;'S;=`0R<%lO/eiNxX!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d! e!d;'S/e;'S;=`0R<%lO/ei! lX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!w!!X!w;'S/e;'S;=`0R<%lO/ei!!`X!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d!!{!d;'S/e;'S;=`0R<%lO/ei!#SX!OW!Q`Or/ers)Qsv/ewx,dx!}/e!}#O!#o#O;'S/e;'S;=`0R<%lO/ei!#xV|P!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/ei!$fX!OW!Q`Or/ers)Qsv/ewx,dx#W/e#W#X!%R#X;'S/e;'S;=`0R<%lO/ei!%YX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!%u#U;'S/e;'S;=`0R<%lO/ei!%|X!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!&i#i;'S/e;'S;=`0R<%lO/ei!&pX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!!{#U;'S/e;'S;=`0R<%lO/ei!'dX!OW!Q`Or/ers)Qsv/ewx,dx#c/e#c#d!(P#d;'S/e;'S;=`0R<%lO/ei!(WX!OW!Q`Or/ers)Qsv/ewx,dx#V/e#V#W!(s#W;'S/e;'S;=`0R<%lO/ei!(zX!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!)g#i;'S/e;'S;=`0R<%lO/ei!)nX!OW!Q`Or/ers)Qsv/ewx,dx#m/e#m#n!*Z#n;'S/e;'S;=`0R<%lO/ei!*bX!OW!Q`Or/ers)Qsv/ewx,dx#d/e#d#e!*}#e;'S/e;'S;=`0R<%lO/ei!+UX!OW!Q`Or/ers)Qsv/ewx,dx#X/e#X#YHf#Y;'S/e;'S;=`0R<%lO/ei!+zV!UP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/em!,lXbSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qo!-dX]UVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk!.YZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!.{!a;'S$q;'S;=`1d<%lO$qk!/WX!TQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk!/|ZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_#P$q#P#Q!0o#Q;'S$q;'S;=`1d<%lO$qk!0xZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!1k!a;'S$q;'S;=`1d<%lO$qk!1vX{QVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$q",
  tokenizers: [
    startTag,
    commentContent,
    piContent,
    cdataContent,
    textLessThan,
    0,
    1,
    2,
    3,
    4
  ],
  topRules: { Document: [0, 6] },
  tokenPrec: 276
});
function bail(error) {
  if (error) {
    throw error;
  }
}
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var extend$1;
var hasRequiredExtend;
function requireExtend() {
  if (hasRequiredExtend) return extend$1;
  hasRequiredExtend = 1;
  var hasOwn = Object.prototype.hasOwnProperty;
  var toStr = Object.prototype.toString;
  var defineProperty = Object.defineProperty;
  var gOPD = Object.getOwnPropertyDescriptor;
  var isArray2 = function isArray22(arr) {
    if (typeof Array.isArray === "function") {
      return Array.isArray(arr);
    }
    return toStr.call(arr) === "[object Array]";
  };
  var isPlainObject2 = function isPlainObject3(obj) {
    if (!obj || toStr.call(obj) !== "[object Object]") {
      return false;
    }
    var hasOwnConstructor = hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
      return false;
    }
    var key;
    for (key in obj) {
    }
    return typeof key === "undefined" || hasOwn.call(obj, key);
  };
  var setProperty2 = function setProperty22(target, options2) {
    if (defineProperty && options2.name === "__proto__") {
      defineProperty(target, options2.name, {
        enumerable: true,
        configurable: true,
        value: options2.newValue,
        writable: true
      });
    } else {
      target[options2.name] = options2.newValue;
    }
  };
  var getProperty = function getProperty2(obj, name2) {
    if (name2 === "__proto__") {
      if (!hasOwn.call(obj, name2)) {
        return void 0;
      } else if (gOPD) {
        return gOPD(obj, name2).value;
      }
    }
    return obj[name2];
  };
  extend$1 = function extend2() {
    var options2, name2, src, copy2, copyIsArray, clone2;
    var target = arguments[0];
    var i2 = 1;
    var length = arguments.length;
    var deep = false;
    if (typeof target === "boolean") {
      deep = target;
      target = arguments[1] || {};
      i2 = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") {
      target = {};
    }
    for (; i2 < length; ++i2) {
      options2 = arguments[i2];
      if (options2 != null) {
        for (name2 in options2) {
          src = getProperty(target, name2);
          copy2 = getProperty(options2, name2);
          if (target !== copy2) {
            if (deep && copy2 && (isPlainObject2(copy2) || (copyIsArray = isArray2(copy2)))) {
              if (copyIsArray) {
                copyIsArray = false;
                clone2 = src && isArray2(src) ? src : [];
              } else {
                clone2 = src && isPlainObject2(src) ? src : {};
              }
              setProperty2(target, { name: name2, newValue: extend2(deep, clone2, copy2) });
            } else if (typeof copy2 !== "undefined") {
              setProperty2(target, { name: name2, newValue: copy2 });
            }
          }
        }
      }
    }
    return target;
  };
  return extend$1;
}
var extendExports = requireExtend();
const extend = /* @__PURE__ */ getDefaultExportFromCjs(extendExports);
function isPlainObject(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}
function trough() {
  const fns = [];
  const pipeline = { run, use };
  return pipeline;
  function run(...values2) {
    let middlewareIndex = -1;
    const callback = values2.pop();
    if (typeof callback !== "function") {
      throw new TypeError("Expected function as last argument, not " + callback);
    }
    next(null, ...values2);
    function next(error, ...output) {
      const fn = fns[++middlewareIndex];
      let index2 = -1;
      if (error) {
        callback(error);
        return;
      }
      while (++index2 < values2.length) {
        if (output[index2] === null || output[index2] === void 0) {
          output[index2] = values2[index2];
        }
      }
      values2 = output;
      if (fn) {
        wrap(fn, next)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }
  function use(middelware) {
    if (typeof middelware !== "function") {
      throw new TypeError(
        "Expected `middelware` to be a function, not " + middelware
      );
    }
    fns.push(middelware);
    return pipeline;
  }
}
function wrap(middleware, callback) {
  let called;
  return wrapped;
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    let result2;
    if (fnExpectsCallback) {
      parameters.push(done);
    }
    try {
      result2 = middleware.apply(this, parameters);
    } catch (error) {
      const exception = (
        /** @type {Error} */
        error
      );
      if (fnExpectsCallback && called) {
        throw exception;
      }
      return done(exception);
    }
    if (!fnExpectsCallback) {
      if (result2 && result2.then && typeof result2.then === "function") {
        result2.then(then, done);
      } else if (result2 instanceof Error) {
        done(result2);
      } else {
        then(result2);
      }
    }
  }
  function done(error, ...output) {
    if (!called) {
      called = true;
      callback(error, ...output);
    }
  }
  function then(value) {
    done(null, value);
  }
}
function stringifyPosition(value) {
  if (!value || typeof value !== "object") {
    return "";
  }
  if ("position" in value || "type" in value) {
    return position(value.position);
  }
  if ("start" in value || "end" in value) {
    return position(value);
  }
  if ("line" in value || "column" in value) {
    return point(value);
  }
  return "";
}
function point(point2) {
  return index(point2 && point2.line) + ":" + index(point2 && point2.column);
}
function position(pos) {
  return point(pos && pos.start) + "-" + point(pos && pos.end);
}
function index(value) {
  return value && typeof value === "number" ? value : 1;
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super();
    if (typeof optionsOrParentOrPlace === "string") {
      origin = optionsOrParentOrPlace;
      optionsOrParentOrPlace = void 0;
    }
    let reason = "";
    let options2 = {};
    let legacyCause = false;
    if (optionsOrParentOrPlace) {
      if ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace) {
        options2 = { place: optionsOrParentOrPlace };
      } else if ("start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace) {
        options2 = { place: optionsOrParentOrPlace };
      } else if ("type" in optionsOrParentOrPlace) {
        options2 = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        };
      } else {
        options2 = { ...optionsOrParentOrPlace };
      }
    }
    if (typeof causeOrReason === "string") {
      reason = causeOrReason;
    } else if (!options2.cause && causeOrReason) {
      legacyCause = true;
      reason = causeOrReason.message;
      options2.cause = causeOrReason;
    }
    if (!options2.ruleId && !options2.source && typeof origin === "string") {
      const index2 = origin.indexOf(":");
      if (index2 === -1) {
        options2.ruleId = origin;
      } else {
        options2.source = origin.slice(0, index2);
        options2.ruleId = origin.slice(index2 + 1);
      }
    }
    if (!options2.place && options2.ancestors && options2.ancestors) {
      const parent = options2.ancestors[options2.ancestors.length - 1];
      if (parent) {
        options2.place = parent.position;
      }
    }
    const start = options2.place && "start" in options2.place ? options2.place.start : options2.place;
    this.ancestors = options2.ancestors || void 0;
    this.cause = options2.cause || void 0;
    this.column = start ? start.column : void 0;
    this.fatal = void 0;
    this.file = "";
    this.message = reason;
    this.line = start ? start.line : void 0;
    this.name = stringifyPosition(options2.place) || "1:1";
    this.place = options2.place || void 0;
    this.reason = this.message;
    this.ruleId = options2.ruleId || void 0;
    this.source = options2.source || void 0;
    this.stack = legacyCause && options2.cause && typeof options2.cause.stack === "string" ? options2.cause.stack : "";
    this.actual = void 0;
    this.expected = void 0;
    this.note = void 0;
    this.url = void 0;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const minpath = { basename, dirname, extname, join: join$2, sep: "/" };
function basename(path, extname2) {
  if (extname2 !== void 0 && typeof extname2 !== "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  assertPath$1(path);
  let start = 0;
  let end = -1;
  let index2 = path.length;
  let seenNonSlash;
  if (extname2 === void 0 || extname2.length === 0 || extname2.length > path.length) {
    while (index2--) {
      if (path.codePointAt(index2) === 47) {
        if (seenNonSlash) {
          start = index2 + 1;
          break;
        }
      } else if (end < 0) {
        seenNonSlash = true;
        end = index2 + 1;
      }
    }
    return end < 0 ? "" : path.slice(start, end);
  }
  if (extname2 === path) {
    return "";
  }
  let firstNonSlashEnd = -1;
  let extnameIndex = extname2.length - 1;
  while (index2--) {
    if (path.codePointAt(index2) === 47) {
      if (seenNonSlash) {
        start = index2 + 1;
        break;
      }
    } else {
      if (firstNonSlashEnd < 0) {
        seenNonSlash = true;
        firstNonSlashEnd = index2 + 1;
      }
      if (extnameIndex > -1) {
        if (path.codePointAt(index2) === extname2.codePointAt(extnameIndex--)) {
          if (extnameIndex < 0) {
            end = index2;
          }
        } else {
          extnameIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }
  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path.length;
  }
  return path.slice(start, end);
}
function dirname(path) {
  assertPath$1(path);
  if (path.length === 0) {
    return ".";
  }
  let end = -1;
  let index2 = path.length;
  let unmatchedSlash;
  while (--index2) {
    if (path.codePointAt(index2) === 47) {
      if (unmatchedSlash) {
        end = index2;
        break;
      }
    } else if (!unmatchedSlash) {
      unmatchedSlash = true;
    }
  }
  return end < 0 ? path.codePointAt(0) === 47 ? "/" : "." : end === 1 && path.codePointAt(0) === 47 ? "//" : path.slice(0, end);
}
function extname(path) {
  assertPath$1(path);
  let index2 = path.length;
  let end = -1;
  let startPart = 0;
  let startDot = -1;
  let preDotState = 0;
  let unmatchedSlash;
  while (index2--) {
    const code2 = path.codePointAt(index2);
    if (code2 === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    if (end < 0) {
      unmatchedSlash = true;
      end = index2 + 1;
    }
    if (code2 === 46) {
      if (startDot < 0) {
        startDot = index2;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      preDotState = -1;
    }
  }
  if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return "";
  }
  return path.slice(startDot, end);
}
function join$2(...segments) {
  let index2 = -1;
  let joined;
  while (++index2 < segments.length) {
    assertPath$1(segments[index2]);
    if (segments[index2]) {
      joined = joined === void 0 ? segments[index2] : joined + "/" + segments[index2];
    }
  }
  return joined === void 0 ? "." : normalize$1(joined);
}
function normalize$1(path) {
  assertPath$1(path);
  const absolute = path.codePointAt(0) === 47;
  let value = normalizeString(path, !absolute);
  if (value.length === 0 && !absolute) {
    value = ".";
  }
  if (value.length > 0 && path.codePointAt(path.length - 1) === 47) {
    value += "/";
  }
  return absolute ? "/" + value : value;
}
function normalizeString(path, allowAboveRoot) {
  let result2 = "";
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index2 = -1;
  let code2;
  let lastSlashIndex;
  while (++index2 <= path.length) {
    if (index2 < path.length) {
      code2 = path.codePointAt(index2);
    } else if (code2 === 47) {
      break;
    } else {
      code2 = 47;
    }
    if (code2 === 47) {
      if (lastSlash === index2 - 1 || dots === 1) ;
      else if (lastSlash !== index2 - 1 && dots === 2) {
        if (result2.length < 2 || lastSegmentLength !== 2 || result2.codePointAt(result2.length - 1) !== 46 || result2.codePointAt(result2.length - 2) !== 46) {
          if (result2.length > 2) {
            lastSlashIndex = result2.lastIndexOf("/");
            if (lastSlashIndex !== result2.length - 1) {
              if (lastSlashIndex < 0) {
                result2 = "";
                lastSegmentLength = 0;
              } else {
                result2 = result2.slice(0, lastSlashIndex);
                lastSegmentLength = result2.length - 1 - result2.lastIndexOf("/");
              }
              lastSlash = index2;
              dots = 0;
              continue;
            }
          } else if (result2.length > 0) {
            result2 = "";
            lastSegmentLength = 0;
            lastSlash = index2;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          result2 = result2.length > 0 ? result2 + "/.." : "..";
          lastSegmentLength = 2;
        }
      } else {
        if (result2.length > 0) {
          result2 += "/" + path.slice(lastSlash + 1, index2);
        } else {
          result2 = path.slice(lastSlash + 1, index2);
        }
        lastSegmentLength = index2 - lastSlash - 1;
      }
      lastSlash = index2;
      dots = 0;
    } else if (code2 === 46 && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }
  return result2;
}
function assertPath$1(path) {
  if (typeof path !== "string") {
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path)
    );
  }
}
const minproc = { cwd };
function cwd() {
  return "/";
}
function isUrl(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === void 0
  );
}
function urlToPath(path) {
  if (typeof path === "string") {
    path = new URL(path);
  } else if (!isUrl(path)) {
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + path + "`"
    );
    error.code = "ERR_INVALID_ARG_TYPE";
    throw error;
  }
  if (path.protocol !== "file:") {
    const error = new TypeError("The URL must be of scheme file");
    error.code = "ERR_INVALID_URL_SCHEME";
    throw error;
  }
  return getPathFromURLPosix(path);
}
function getPathFromURLPosix(url) {
  if (url.hostname !== "") {
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error.code = "ERR_INVALID_FILE_URL_HOST";
    throw error;
  }
  const pathname = url.pathname;
  let index2 = -1;
  while (++index2 < pathname.length) {
    if (pathname.codePointAt(index2) === 37 && pathname.codePointAt(index2 + 1) === 50) {
      const third = pathname.codePointAt(index2 + 2);
      if (third === 70 || third === 102) {
        const error = new TypeError(
          "File URL path must not include encoded / characters"
        );
        error.code = "ERR_INVALID_FILE_URL_PATH";
        throw error;
      }
    }
  }
  return decodeURIComponent(pathname);
}
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    let options2;
    if (!value) {
      options2 = {};
    } else if (isUrl(value)) {
      options2 = { path: value };
    } else if (typeof value === "string" || isUint8Array$1(value)) {
      options2 = { value };
    } else {
      options2 = value;
    }
    this.cwd = "cwd" in options2 ? "" : minproc.cwd();
    this.data = {};
    this.history = [];
    this.messages = [];
    this.value;
    this.map;
    this.result;
    this.stored;
    let index2 = -1;
    while (++index2 < order.length) {
      const field2 = order[index2];
      if (field2 in options2 && options2[field2] !== void 0 && options2[field2] !== null) {
        this[field2] = field2 === "history" ? [...options2[field2]] : options2[field2];
      }
    }
    let field;
    for (field in options2) {
      if (!order.includes(field)) {
        this[field] = options2[field];
      }
    }
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename2) {
    assertNonEmpty(basename2, "basename");
    assertPart(basename2, "basename");
    this.path = minpath.join(this.dirname || "", basename2);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname2) {
    assertPath(this.basename, "dirname");
    this.path = minpath.join(dirname2 || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname2) {
    assertPart(extname2, "extname");
    assertPath(this.dirname, "extname");
    if (extname2) {
      if (extname2.codePointAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (extname2.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = minpath.join(this.dirname, this.stem + (extname2 || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path);
    }
    assertNonEmpty(path, "path");
    if (this.path !== path) {
      this.history.push(path);
    }
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty(stem, "stem");
    assertPart(stem, "stem");
    this.path = minpath.join(this.dirname || "", stem + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = true;
    throw message;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = void 0;
    return message;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    );
    if (this.path) {
      message.name = this.path + ":" + message.name;
      message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === void 0) {
      return "";
    }
    if (typeof this.value === "string") {
      return this.value;
    }
    const decoder = new TextDecoder(encoding || void 0);
    return decoder.decode(this.value);
  }
}
function assertPart(part, name2) {
  if (part && part.includes(minpath.sep)) {
    throw new Error(
      "`" + name2 + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
  }
}
function assertNonEmpty(part, name2) {
  if (!part) {
    throw new Error("`" + name2 + "` cannot be empty");
  }
}
function assertPath(path, name2) {
  if (!path) {
    throw new Error("Setting `" + name2 + "` requires `path` to be set too");
  }
}
function isUint8Array$1(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(property2) {
    const self2 = this;
    const constr = self2.constructor;
    const proto = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      constr.prototype
    );
    const value = proto[property2];
    const apply = function() {
      return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    return apply;
  })
);
const own = {}.hasOwnProperty;
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy");
    this.Compiler = void 0;
    this.Parser = void 0;
    this.attachers = [];
    this.compiler = void 0;
    this.freezeIndex = -1;
    this.frozen = void 0;
    this.namespace = {};
    this.parser = void 0;
    this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const destination = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor()
    );
    let index2 = -1;
    while (++index2 < this.attachers.length) {
      const attacher = this.attachers[index2];
      destination.use(...attacher);
    }
    destination.data(extend(true, {}, this.namespace));
    return destination;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    if (typeof key === "string") {
      if (arguments.length === 2) {
        assertUnfrozen("data", this.frozen);
        this.namespace[key] = value;
        return this;
      }
      return own.call(this.namespace, key) && this.namespace[key] || void 0;
    }
    if (key) {
      assertUnfrozen("data", this.frozen);
      this.namespace = key;
      return this;
    }
    return this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this;
    }
    const self2 = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options2] = this.attachers[this.freezeIndex];
      if (options2[0] === false) {
        continue;
      }
      if (options2[0] === true) {
        options2[0] = void 0;
      }
      const transformer = attacher.call(self2, ...options2);
      if (typeof transformer === "function") {
        this.transformers.use(transformer);
      }
    }
    this.frozen = true;
    this.freezeIndex = Number.POSITIVE_INFINITY;
    return this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile(file);
    const parser2 = this.parser || this.Parser;
    assertParser("parse", parser2);
    return parser2(String(realFile), realFile);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self2 = this;
    this.freeze();
    assertParser("process", this.parser || this.Parser);
    assertCompiler("process", this.compiler || this.Compiler);
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject2) {
      const realFile = vfile(file);
      const parseTree = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        self2.parse(realFile)
      );
      self2.run(parseTree, realFile, function(error, tree, file2) {
        if (error || !tree || !file2) {
          return realDone(error);
        }
        const compileTree = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          tree
        );
        const compileResult = self2.stringify(compileTree, file2);
        if (looksLikeAValue(compileResult)) {
          file2.value = compileResult;
        } else {
          file2.result = compileResult;
        }
        realDone(
          error,
          /** @type {VFileWithOutput<CompileResult>} */
          file2
        );
      });
      function realDone(error, file2) {
        if (error || !file2) {
          reject2(error);
        } else if (resolve) {
          resolve(file2);
        } else {
          done(void 0, file2);
        }
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    let complete = false;
    let result2;
    this.freeze();
    assertParser("processSync", this.parser || this.Parser);
    assertCompiler("processSync", this.compiler || this.Compiler);
    this.process(file, realDone);
    assertDone("processSync", "process", complete);
    return result2;
    function realDone(error, file2) {
      complete = true;
      bail(error);
      result2 = file2;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode(tree);
    this.freeze();
    const transformers = this.transformers;
    if (!done && typeof file === "function") {
      done = file;
      file = void 0;
    }
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject2) {
      const realFile = vfile(file);
      transformers.run(tree, realFile, realDone);
      function realDone(error, outputTree, file2) {
        const resultingTree = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          outputTree || tree
        );
        if (error) {
          reject2(error);
        } else if (resolve) {
          resolve(resultingTree);
        } else {
          done(void 0, resultingTree, file2);
        }
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    let complete = false;
    let result2;
    this.run(tree, file, realDone);
    assertDone("runSync", "run", complete);
    return result2;
    function realDone(error, tree2) {
      bail(error);
      result2 = tree2;
      complete = true;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile(file);
    const compiler = this.compiler || this.Compiler;
    assertCompiler("stringify", compiler);
    assertNode(tree);
    return compiler(tree, realFile);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers;
    const namespace = this.namespace;
    assertUnfrozen("use", this.frozen);
    if (value === null || value === void 0) ;
    else if (typeof value === "function") {
      addPlugin(value, parameters);
    } else if (typeof value === "object") {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError("Expected usable value, not `" + value + "`");
    }
    return this;
    function add2(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2, []);
      } else if (typeof value2 === "object") {
        if (Array.isArray(value2)) {
          const [plugin, ...parameters2] = (
            /** @type {PluginTuple<Array<unknown>>} */
            value2
          );
          addPlugin(plugin, parameters2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + value2 + "`");
      }
    }
    function addPreset(result2) {
      if (!("plugins" in result2) && !("settings" in result2)) {
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      }
      addList(result2.plugins);
      if (result2.settings) {
        namespace.settings = extend(true, namespace.settings, result2.settings);
      }
    }
    function addList(plugins2) {
      let index2 = -1;
      if (plugins2 === null || plugins2 === void 0) ;
      else if (Array.isArray(plugins2)) {
        while (++index2 < plugins2.length) {
          const thing = plugins2[index2];
          add2(thing);
        }
      } else {
        throw new TypeError("Expected a list of plugins, not `" + plugins2 + "`");
      }
    }
    function addPlugin(plugin, parameters2) {
      let index2 = -1;
      let entryIndex = -1;
      while (++index2 < attachers.length) {
        if (attachers[index2][0] === plugin) {
          entryIndex = index2;
          break;
        }
      }
      if (entryIndex === -1) {
        attachers.push([plugin, ...parameters2]);
      } else if (parameters2.length > 0) {
        let [primary, ...rest2] = parameters2;
        const currentPrimary = attachers[entryIndex][1];
        if (isPlainObject(currentPrimary) && isPlainObject(primary)) {
          primary = extend(true, currentPrimary, primary);
        }
        attachers[entryIndex] = [plugin, primary, ...rest2];
      }
    }
  }
}
new Processor().freeze();
function assertParser(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `parser`");
  }
}
function assertCompiler(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `compiler`");
  }
}
function assertUnfrozen(name2, frozen) {
  if (frozen) {
    throw new Error(
      "Cannot call `" + name2 + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
  }
}
function assertNode(node) {
  if (!isPlainObject(node) || typeof node.type !== "string") {
    throw new TypeError("Expected node, got `" + node + "`");
  }
}
function assertDone(name2, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name2 + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value);
}
function looksLikeAVFile(value) {
  return Boolean(
    value && typeof value === "object" && "message" in value && "messages" in value
  );
}
function looksLikeAValue(value) {
  return typeof value === "string" || isUint8Array(value);
}
function isUint8Array(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const parserWithMetadata = parser.configure({
  props: [
    indentNodeProp.add({
      //fun (unfixable?) glitch: If you modify the document and then create a newline before enough time has passed for a new parse (which is often < 50ms)
      //the indent wont have time to update and you're going right back to the left side of the screen.
      Element(context) {
        let closed = /^\s*<\//.test(context.textAfter);
        return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
      },
      "OpenTag CloseTag SelfClosingTag"(context) {
        if (context.node.firstChild?.name == "TagName") {
          return context.column(context.node.from);
        }
        return context.column(context.node.from) + context.unit;
      }
    }),
    foldNodeProp.add({
      Element(subtree2) {
        let first2 = subtree2.firstChild;
        let last2 = subtree2.lastChild;
        if (!first2 || first2.name != "OpenTag") return null;
        return {
          from: first2.to,
          to: last2?.name == "CloseTag" ? last2.from : subtree2.to
        };
      }
    }),
    styleTags({
      AttributeValue: tags.string,
      Text: tags.content,
      TagName: tags.tagName,
      MismatchedCloseTag: tags.invalid,
      "StartTag StartCloseTag EndTag SelfCloseEndTag": tags.angleBracket,
      "MismatchedCloseTag/TagName": [tags.tagName, tags.invalid],
      "MismatchedCloseTag/StartCloseTag": tags.invalid,
      AttributeName: tags.propertyName,
      Is: tags.definitionOperator,
      "EntityReference CharacterReference": tags.character,
      Comment: tags.blockComment,
      Macro: tags.macroName
    })
  ]
});
const doenetLanguage = LRLanguage.define({
  parser: parserWithMetadata,
  languageData: {
    commentTokens: { block: { open: "<!--", close: "-->" } },
    indentOnInput: /^\s*<\/$/
  }
});
const syntaxHighlightingExtension = new LanguageSupport(doenetLanguage);
const tab = "  ";
const tabCommand = ({ state, dispatch }) => {
  console.log("running");
  dispatch(
    state.update(state.replaceSelection(tab), {
      scrollIntoView: true,
      annotations: Transaction.userEvent.of("input")
    })
  );
  return true;
};
const tabExtension = keymap.of([
  {
    key: "Tab",
    run: tabCommand
  }
]);
const element = document.createElement("i");
function decodeNamedCharacterReference(value) {
  const characterReference2 = "&" + value + ";";
  element.innerHTML = characterReference2;
  const character = element.textContent;
  if (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    character.charCodeAt(character.length - 1) === 59 && value !== "semi"
  ) {
    return false;
  }
  return character === characterReference2 ? false : character;
}
function splice(list2, start, remove2, items) {
  const end = list2.length;
  let chunkStart = 0;
  let parameters;
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove2 = remove2 > 0 ? remove2 : 0;
  if (items.length < 1e4) {
    parameters = Array.from(items);
    parameters.unshift(start, remove2);
    list2.splice(...parameters);
  } else {
    if (remove2) list2.splice(start, remove2);
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 1e4);
      parameters.unshift(start, 0);
      list2.splice(...parameters);
      chunkStart += 1e4;
      start += 1e4;
    }
  }
}
function push(list2, items) {
  if (list2.length > 0) {
    splice(list2, list2.length, 0, items);
    return list2;
  }
  return items;
}
const hasOwnProperty$1 = {}.hasOwnProperty;
function combineExtensions(extensions) {
  const all2 = {};
  let index2 = -1;
  while (++index2 < extensions.length) {
    syntaxExtension(all2, extensions[index2]);
  }
  return all2;
}
function syntaxExtension(all2, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty$1.call(all2, hook) ? all2[hook] : void 0;
    const left = maybe || (all2[hook] = {});
    const right = extension[hook];
    let code2;
    if (right) {
      for (code2 in right) {
        if (!hasOwnProperty$1.call(left, code2)) left[code2] = [];
        const value = right[code2];
        constructs(
          // @ts-expect-error Looks like a list.
          left[code2],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}
function constructs(existing, list2) {
  let index2 = -1;
  const before2 = [];
  while (++index2 < list2.length) {
    (list2[index2].add === "after" ? existing : before2).push(list2[index2]);
  }
  splice(existing, 0, 0, before2);
}
function combineHtmlExtensions(htmlExtensions) {
  const handlers2 = {};
  let index2 = -1;
  while (++index2 < htmlExtensions.length) {
    htmlExtension(handlers2, htmlExtensions[index2]);
  }
  return handlers2;
}
function htmlExtension(all2, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty$1.call(all2, hook) ? all2[hook] : void 0;
    const left = maybe || (all2[hook] = {});
    const right = extension[hook];
    let type;
    if (right) {
      for (type in right) {
        left[type] = right[type];
      }
    }
  }
}
function decodeNumericCharacterReference(value, base2) {
  const code2 = Number.parseInt(value, base2);
  if (
    // C0 except for HT, LF, FF, CR, space.
    code2 < 9 || code2 === 11 || code2 > 13 && code2 < 32 || // Control character (DEL) of C0, and C1 controls.
    code2 > 126 && code2 < 160 || // Lone high surrogates and low surrogates.
    code2 > 55295 && code2 < 57344 || // Noncharacters.
    code2 > 64975 && code2 < 65008 || /* eslint-disable no-bitwise */
    (code2 & 65535) === 65535 || (code2 & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    code2 > 1114111
  ) {
    return "�";
  }
  return String.fromCodePoint(code2);
}
const characterReferences = { '"': "quot", "&": "amp", "<": "lt", ">": "gt" };
function encode(value) {
  return value.replace(/["&<>]/g, replace2);
  function replace2(value2) {
    return "&" + characterReferences[
      /** @type {keyof typeof characterReferences} */
      value2
    ] + ";";
  }
}
function normalizeIdentifier(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha = regexCheck(/[A-Za-z]/);
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(code2) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code2 !== null && (code2 < 32 || code2 === 127)
  );
}
const asciiDigit = regexCheck(/\d/);
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(code2) {
  return code2 !== null && code2 < -2;
}
function markdownLineEndingOrSpace(code2) {
  return code2 !== null && (code2 < 0 || code2 === 32);
}
function markdownSpace(code2) {
  return code2 === -2 || code2 === -1 || code2 === 32;
}
const unicodePunctuation = regexCheck(new RegExp("\\p{P}|\\p{S}", "u"));
const unicodeWhitespace = regexCheck(/\s/);
function regexCheck(regex) {
  return check;
  function check(code2) {
    return code2 !== null && code2 > -1 && regex.test(String.fromCharCode(code2));
  }
}
function sanitizeUri(url, protocol2) {
  const value = encode(normalizeUri(url || ""));
  if (!protocol2) {
    return value;
  }
  const colon = value.indexOf(":");
  const questionMark = value.indexOf("?");
  const numberSign = value.indexOf("#");
  const slash = value.indexOf("/");
  if (
    // If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol2.test(value.slice(0, colon))
  ) {
    return value;
  }
  return "";
}
function normalizeUri(value) {
  const result2 = [];
  let index2 = -1;
  let start = 0;
  let skip = 0;
  while (++index2 < value.length) {
    const code2 = value.charCodeAt(index2);
    let replace2 = "";
    if (code2 === 37 && asciiAlphanumeric(value.charCodeAt(index2 + 1)) && asciiAlphanumeric(value.charCodeAt(index2 + 2))) {
      skip = 2;
    } else if (code2 < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code2))) {
        replace2 = String.fromCharCode(code2);
      }
    } else if (code2 > 55295 && code2 < 57344) {
      const next = value.charCodeAt(index2 + 1);
      if (code2 < 56320 && next > 56319 && next < 57344) {
        replace2 = String.fromCharCode(code2, next);
        skip = 1;
      } else {
        replace2 = "�";
      }
    } else {
      replace2 = String.fromCharCode(code2);
    }
    if (replace2) {
      result2.push(value.slice(start, index2), encodeURIComponent(replace2));
      start = index2 + skip + 1;
      replace2 = "";
    }
    if (skip) {
      index2 += skip;
      skip = 0;
    }
  }
  return result2.join("") + value.slice(start);
}
const hasOwnProperty = {}.hasOwnProperty;
const protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const protocolSource = /^https?$/i;
function compile(options2) {
  const settings = options2 || {};
  let tags2 = true;
  const definitions = {};
  const buffers = [[]];
  const mediaStack = [];
  const tightStack = [];
  const defaultHandlers = {
    enter: {
      blockQuote: onenterblockquote,
      codeFenced: onentercodefenced,
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: onentercodeindented,
      codeText: onentercodetext,
      content: onentercontent,
      definition: onenterdefinition,
      definitionDestinationString: onenterdefinitiondestinationstring,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: onenteremphasis,
      htmlFlow: onenterhtmlflow,
      htmlText: onenterhtml,
      image: onenterimage,
      label: buffer,
      link: onenterlink,
      listItemMarker: onenterlistitemmarker,
      listItemValue: onenterlistitemvalue,
      listOrdered: onenterlistordered,
      listUnordered: onenterlistunordered,
      paragraph: onenterparagraph,
      reference: buffer,
      resource: onenterresource,
      resourceDestinationString: onenterresourcedestinationstring,
      resourceTitleString: buffer,
      setextHeading: onentersetextheading,
      strong: onenterstrong
    },
    exit: {
      atxHeading: onexitatxheading,
      atxHeadingSequence: onexitatxheadingsequence,
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: onexitblockquote,
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      codeFenced: onexitflowcode,
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onresumedrop,
      codeFlowValue: onexitcodeflowvalue,
      codeIndented: onexitflowcode,
      codeText: onexitcodetext,
      codeTextData: onexitdata,
      data: onexitdata,
      definition: onexitdefinition,
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: onexitemphasis,
      hardBreakEscape: onexithardbreak,
      hardBreakTrailing: onexithardbreak,
      htmlFlow: onexithtml,
      htmlFlowData: onexitdata,
      htmlText: onexithtml,
      htmlTextData: onexitdata,
      image: onexitmedia,
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: onexitmedia,
      listOrdered: onexitlistordered,
      listUnordered: onexitlistunordered,
      paragraph: onexitparagraph,
      reference: onresumedrop,
      referenceString: onexitreferencestring,
      resource: onresumedrop,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      setextHeading: onexitsetextheading,
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: onexitstrong,
      thematicBreak: onexitthematicbreak
    }
  };
  const handlers2 = (
    /** @type {NormalizedHtmlExtension} */
    combineHtmlExtensions([defaultHandlers, ...settings.htmlExtensions || []])
  );
  const data = {
    definitions,
    tightStack
  };
  const context = {
    buffer,
    encode: encode$1,
    getData,
    lineEndingIfNeeded,
    options: settings,
    raw,
    resume,
    setData,
    tag: tag2
  };
  let lineEndingStyle = settings.defaultLineEnding;
  return compile2;
  function compile2(events2) {
    let index2 = -1;
    let start = 0;
    const listStack = [];
    let head = [];
    let body = [];
    while (++index2 < events2.length) {
      if (!lineEndingStyle && (events2[index2][1].type === "lineEnding" || events2[index2][1].type === "lineEndingBlank")) {
        lineEndingStyle = /** @type {LineEnding} */
        events2[index2][2].sliceSerialize(events2[index2][1]);
      }
      if (events2[index2][1].type === "listOrdered" || events2[index2][1].type === "listUnordered") {
        if (events2[index2][0] === "enter") {
          listStack.push(index2);
        } else {
          prepareList(events2.slice(listStack.pop(), index2));
        }
      }
      if (events2[index2][1].type === "definition") {
        if (events2[index2][0] === "enter") {
          body = push(body, events2.slice(start, index2));
          start = index2;
        } else {
          head = push(head, events2.slice(start, index2 + 1));
          start = index2 + 1;
        }
      }
    }
    head = push(head, body);
    head = push(head, events2.slice(start));
    index2 = -1;
    const result2 = head;
    if (handlers2.enter.null) {
      handlers2.enter.null.call(context);
    }
    while (++index2 < events2.length) {
      const handles = handlers2[result2[index2][0]];
      const kind = result2[index2][1].type;
      const handle = handles[kind];
      if (hasOwnProperty.call(handles, kind) && handle) {
        handle.call({
          sliceSerialize: result2[index2][2].sliceSerialize,
          ...context
        }, result2[index2][1]);
      }
    }
    if (handlers2.exit.null) {
      handlers2.exit.null.call(context);
    }
    return buffers[0].join("");
  }
  function prepareList(slice2) {
    const length = slice2.length;
    let index2 = 0;
    let containerBalance = 0;
    let loose = false;
    let atMarker;
    while (++index2 < length) {
      const event = slice2[index2];
      if (event[1]._container) {
        atMarker = void 0;
        if (event[0] === "enter") {
          containerBalance++;
        } else {
          containerBalance--;
        }
      } else switch (event[1].type) {
        case "listItemPrefix": {
          if (event[0] === "exit") {
            atMarker = true;
          }
          break;
        }
        case "linePrefix": {
          break;
        }
        case "lineEndingBlank": {
          if (event[0] === "enter" && !containerBalance) {
            if (atMarker) {
              atMarker = void 0;
            } else {
              loose = true;
            }
          }
          break;
        }
        default: {
          atMarker = void 0;
        }
      }
    }
    slice2[0][1]._loose = loose;
  }
  function setData(key, value) {
    data[key] = value;
  }
  function getData(key) {
    return data[key];
  }
  function buffer() {
    buffers.push([]);
  }
  function resume() {
    const buf = buffers.pop();
    return buf.join("");
  }
  function tag2(value) {
    if (!tags2) return;
    setData("lastWasTag", true);
    buffers[buffers.length - 1].push(value);
  }
  function raw(value) {
    setData("lastWasTag");
    buffers[buffers.length - 1].push(value);
  }
  function lineEnding2() {
    raw(lineEndingStyle || "\n");
  }
  function lineEndingIfNeeded() {
    const buffer2 = buffers[buffers.length - 1];
    const slice2 = buffer2[buffer2.length - 1];
    const previous2 = slice2 ? slice2.charCodeAt(slice2.length - 1) : null;
    if (previous2 === 10 || previous2 === 13 || previous2 === null) {
      return;
    }
    lineEnding2();
  }
  function encode$1(value) {
    return getData("ignoreEncode") ? value : encode(value);
  }
  function onresumedrop() {
    resume();
  }
  function onenterlistordered(token) {
    tightStack.push(!token._loose);
    lineEndingIfNeeded();
    tag2("<ol");
    setData("expectFirstItem", true);
  }
  function onenterlistunordered(token) {
    tightStack.push(!token._loose);
    lineEndingIfNeeded();
    tag2("<ul");
    setData("expectFirstItem", true);
  }
  function onenterlistitemvalue(token) {
    if (getData("expectFirstItem")) {
      const value = Number.parseInt(this.sliceSerialize(token), 10);
      if (value !== 1) {
        tag2(' start="' + encode$1(String(value)) + '"');
      }
    }
  }
  function onenterlistitemmarker() {
    if (getData("expectFirstItem")) {
      tag2(">");
    } else {
      onexitlistitem();
    }
    lineEndingIfNeeded();
    tag2("<li>");
    setData("expectFirstItem");
    setData("lastWasTag");
  }
  function onexitlistordered() {
    onexitlistitem();
    tightStack.pop();
    lineEnding2();
    tag2("</ol>");
  }
  function onexitlistunordered() {
    onexitlistitem();
    tightStack.pop();
    lineEnding2();
    tag2("</ul>");
  }
  function onexitlistitem() {
    if (getData("lastWasTag") && !getData("slurpAllLineEndings")) {
      lineEndingIfNeeded();
    }
    tag2("</li>");
    setData("slurpAllLineEndings");
  }
  function onenterblockquote() {
    tightStack.push(false);
    lineEndingIfNeeded();
    tag2("<blockquote>");
  }
  function onexitblockquote() {
    tightStack.pop();
    lineEndingIfNeeded();
    tag2("</blockquote>");
    setData("slurpAllLineEndings");
  }
  function onenterparagraph() {
    if (!tightStack[tightStack.length - 1]) {
      lineEndingIfNeeded();
      tag2("<p>");
    }
    setData("slurpAllLineEndings");
  }
  function onexitparagraph() {
    if (tightStack[tightStack.length - 1]) {
      setData("slurpAllLineEndings", true);
    } else {
      tag2("</p>");
    }
  }
  function onentercodefenced() {
    lineEndingIfNeeded();
    tag2("<pre><code");
    setData("fencesCount", 0);
  }
  function onexitcodefencedfenceinfo() {
    const value = resume();
    tag2(' class="language-' + value + '"');
  }
  function onexitcodefencedfence() {
    const count = getData("fencesCount") || 0;
    if (!count) {
      tag2(">");
      setData("slurpOneLineEnding", true);
    }
    setData("fencesCount", count + 1);
  }
  function onentercodeindented() {
    lineEndingIfNeeded();
    tag2("<pre><code>");
  }
  function onexitflowcode() {
    const count = getData("fencesCount");
    if (count !== void 0 && count < 2 && data.tightStack.length > 0 && !getData("lastWasTag")) {
      lineEnding2();
    }
    if (getData("flowCodeSeenData")) {
      lineEndingIfNeeded();
    }
    tag2("</code></pre>");
    if (count !== void 0 && count < 2) lineEndingIfNeeded();
    setData("flowCodeSeenData");
    setData("fencesCount");
    setData("slurpOneLineEnding");
  }
  function onenterimage() {
    mediaStack.push({
      image: true
    });
    tags2 = void 0;
  }
  function onenterlink() {
    mediaStack.push({});
  }
  function onexitlabeltext(token) {
    mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
  }
  function onexitlabel() {
    mediaStack[mediaStack.length - 1].label = resume();
  }
  function onexitreferencestring(token) {
    mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
  }
  function onenterresource() {
    buffer();
    mediaStack[mediaStack.length - 1].destination = "";
  }
  function onenterresourcedestinationstring() {
    buffer();
    setData("ignoreEncode", true);
  }
  function onexitresourcedestinationstring() {
    mediaStack[mediaStack.length - 1].destination = resume();
    setData("ignoreEncode");
  }
  function onexitresourcetitlestring() {
    mediaStack[mediaStack.length - 1].title = resume();
  }
  function onexitmedia() {
    let index2 = mediaStack.length - 1;
    const media = mediaStack[index2];
    const id2 = media.referenceId || media.labelId;
    const context2 = media.destination === void 0 ? definitions[normalizeIdentifier(id2)] : media;
    tags2 = true;
    while (index2--) {
      if (mediaStack[index2].image) {
        tags2 = void 0;
        break;
      }
    }
    if (media.image) {
      tag2('<img src="' + sanitizeUri(context2.destination, settings.allowDangerousProtocol ? void 0 : protocolSource) + '" alt="');
      raw(media.label);
      tag2('"');
    } else {
      tag2('<a href="' + sanitizeUri(context2.destination, settings.allowDangerousProtocol ? void 0 : protocolHref) + '"');
    }
    tag2(context2.title ? ' title="' + context2.title + '"' : "");
    if (media.image) {
      tag2(" />");
    } else {
      tag2(">");
      raw(media.label);
      tag2("</a>");
    }
    mediaStack.pop();
  }
  function onenterdefinition() {
    buffer();
    mediaStack.push({});
  }
  function onexitdefinitionlabelstring(token) {
    resume();
    mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
  }
  function onenterdefinitiondestinationstring() {
    buffer();
    setData("ignoreEncode", true);
  }
  function onexitdefinitiondestinationstring() {
    mediaStack[mediaStack.length - 1].destination = resume();
    setData("ignoreEncode");
  }
  function onexitdefinitiontitlestring() {
    mediaStack[mediaStack.length - 1].title = resume();
  }
  function onexitdefinition() {
    const media = mediaStack[mediaStack.length - 1];
    const id2 = normalizeIdentifier(media.labelId);
    resume();
    if (!hasOwnProperty.call(definitions, id2)) {
      definitions[id2] = mediaStack[mediaStack.length - 1];
    }
    mediaStack.pop();
  }
  function onentercontent() {
    setData("slurpAllLineEndings", true);
  }
  function onexitatxheadingsequence(token) {
    if (getData("headingRank")) return;
    setData("headingRank", this.sliceSerialize(token).length);
    lineEndingIfNeeded();
    tag2("<h" + getData("headingRank") + ">");
  }
  function onentersetextheading() {
    buffer();
    setData("slurpAllLineEndings");
  }
  function onexitsetextheadingtext() {
    setData("slurpAllLineEndings", true);
  }
  function onexitatxheading() {
    tag2("</h" + getData("headingRank") + ">");
    setData("headingRank");
  }
  function onexitsetextheadinglinesequence(token) {
    setData("headingRank", this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
  }
  function onexitsetextheading() {
    const value = resume();
    lineEndingIfNeeded();
    tag2("<h" + getData("headingRank") + ">");
    raw(value);
    tag2("</h" + getData("headingRank") + ">");
    setData("slurpAllLineEndings");
    setData("headingRank");
  }
  function onexitdata(token) {
    raw(encode$1(this.sliceSerialize(token)));
  }
  function onexitlineending(token) {
    if (getData("slurpAllLineEndings")) {
      return;
    }
    if (getData("slurpOneLineEnding")) {
      setData("slurpOneLineEnding");
      return;
    }
    if (getData("inCodeText")) {
      raw(" ");
      return;
    }
    raw(encode$1(this.sliceSerialize(token)));
  }
  function onexitcodeflowvalue(token) {
    raw(encode$1(this.sliceSerialize(token)));
    setData("flowCodeSeenData", true);
  }
  function onexithardbreak() {
    tag2("<br />");
  }
  function onenterhtmlflow() {
    lineEndingIfNeeded();
    onenterhtml();
  }
  function onexithtml() {
    setData("ignoreEncode");
  }
  function onenterhtml() {
    if (settings.allowDangerousHtml) {
      setData("ignoreEncode", true);
    }
  }
  function onenteremphasis() {
    tag2("<em>");
  }
  function onenterstrong() {
    tag2("<strong>");
  }
  function onentercodetext() {
    setData("inCodeText", true);
    tag2("<code>");
  }
  function onexitcodetext() {
    setData("inCodeText");
    tag2("</code>");
  }
  function onexitemphasis() {
    tag2("</em>");
  }
  function onexitstrong() {
    tag2("</strong>");
  }
  function onexitthematicbreak() {
    lineEndingIfNeeded();
    tag2("<hr />");
  }
  function onexitcharacterreferencemarker(token) {
    setData("characterReferenceType", token.type);
  }
  function onexitcharacterreferencevalue(token) {
    const value = this.sliceSerialize(token);
    const decoded = getData("characterReferenceType") ? decodeNumericCharacterReference(value, getData("characterReferenceType") === "characterReferenceMarkerNumeric" ? 10 : 16) : decodeNamedCharacterReference(value);
    raw(encode$1(
      /** @type {string} */
      decoded
    ));
    setData("characterReferenceType");
  }
  function onexitautolinkprotocol(token) {
    const uri = this.sliceSerialize(token);
    tag2('<a href="' + sanitizeUri(uri, settings.allowDangerousProtocol ? void 0 : protocolHref) + '">');
    raw(encode$1(uri));
    tag2("</a>");
  }
  function onexitautolinkemail(token) {
    const uri = this.sliceSerialize(token);
    tag2('<a href="' + sanitizeUri("mailto:" + uri) + '">');
    raw(encode$1(uri));
    tag2("</a>");
  }
}
function factorySpace(effects, ok, type, max2) {
  const limit = max2 ? max2 - 1 : Number.POSITIVE_INFINITY;
  let size2 = 0;
  return start;
  function start(code2) {
    if (markdownSpace(code2)) {
      effects.enter(type);
      return prefix(code2);
    }
    return ok(code2);
  }
  function prefix(code2) {
    if (markdownSpace(code2) && size2++ < limit) {
      effects.consume(code2);
      return prefix;
    }
    effects.exit(type);
    return ok(code2);
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(effects) {
  const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
  let previous2;
  return contentStart;
  function afterContentStartConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, contentStart, "linePrefix");
  }
  function paragraphInitial(code2) {
    effects.enter("paragraph");
    return lineStart(code2);
  }
  function lineStart(code2) {
    const token = effects.enter("chunkText", {
      contentType: "text",
      previous: previous2
    });
    if (previous2) {
      previous2.next = token;
    }
    previous2 = token;
    return data(code2);
  }
  function data(code2) {
    if (code2 === null) {
      effects.exit("chunkText");
      effects.exit("paragraph");
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding(code2)) {
      effects.consume(code2);
      effects.exit("chunkText");
      return lineStart;
    }
    effects.consume(code2);
    return data;
  }
}
const document$2 = {
  tokenize: initializeDocument
};
const containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(effects) {
  const self2 = this;
  const stack = [];
  let continued = 0;
  let childFlow;
  let childToken;
  let lineStartOffset;
  return start;
  function start(code2) {
    if (continued < stack.length) {
      const item = stack[continued];
      self2.containerState = item[1];
      return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code2);
    }
    return checkNewContainers(code2);
  }
  function documentContinue(code2) {
    continued++;
    if (self2.containerState._closeFlow) {
      self2.containerState._closeFlow = void 0;
      if (childFlow) {
        closeFlow();
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          point2 = self2.events[indexBeforeFlow][1].end;
          break;
        }
      }
      exitContainers(continued);
      let index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = {
          ...point2
        };
        index2++;
      }
      splice(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits));
      self2.events.length = index2;
      return checkNewContainers(code2);
    }
    return start(code2);
  }
  function checkNewContainers(code2) {
    if (continued === stack.length) {
      if (!childFlow) {
        return documentContinued(code2);
      }
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code2);
      }
      self2.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
    }
    self2.containerState = {};
    return effects.check(containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code2);
  }
  function thereIsANewContainer(code2) {
    if (childFlow) closeFlow();
    exitContainers(continued);
    return documentContinued(code2);
  }
  function thereIsNoNewContainer(code2) {
    self2.parser.lazy[self2.now().line] = continued !== stack.length;
    lineStartOffset = self2.now().offset;
    return flowStart(code2);
  }
  function documentContinued(code2) {
    self2.containerState = {};
    return effects.attempt(containerConstruct, containerContinue, flowStart)(code2);
  }
  function containerContinue(code2) {
    continued++;
    stack.push([self2.currentConstruct, self2.containerState]);
    return documentContinued(code2);
  }
  function flowStart(code2) {
    if (code2 === null) {
      if (childFlow) closeFlow();
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    childFlow = childFlow || self2.parser.flow(self2.now());
    effects.enter("chunkFlow", {
      _tokenizer: childFlow,
      contentType: "flow",
      previous: childToken
    });
    return flowContinue(code2);
  }
  function flowContinue(code2) {
    if (code2 === null) {
      writeToChild(effects.exit("chunkFlow"), true);
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding(code2)) {
      effects.consume(code2);
      writeToChild(effects.exit("chunkFlow"));
      continued = 0;
      self2.interrupt = void 0;
      return start;
    }
    effects.consume(code2);
    return flowContinue;
  }
  function writeToChild(token, endOfFile) {
    const stream = self2.sliceStream(token);
    if (endOfFile) stream.push(null);
    token.previous = childToken;
    if (childToken) childToken.next = token;
    childToken = token;
    childFlow.defineSkip(token.start);
    childFlow.write(stream);
    if (self2.parser.lazy[token.start.line]) {
      let index2 = childFlow.events.length;
      while (index2--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index2][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index2][1].end || // …or ends after it.
          childFlow.events[index2][1].end.offset > lineStartOffset)
        ) {
          return;
        }
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let seen;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          if (seen) {
            point2 = self2.events[indexBeforeFlow][1].end;
            break;
          }
          seen = true;
        }
      }
      exitContainers(continued);
      index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = {
          ...point2
        };
        index2++;
      }
      splice(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits));
      self2.events.length = index2;
    }
  }
  function exitContainers(size2) {
    let index2 = stack.length;
    while (index2-- > size2) {
      const entry = stack[index2];
      self2.containerState = entry[1];
      entry[0].exit.call(self2, effects);
    }
    stack.length = size2;
  }
  function closeFlow() {
    childFlow.write([null]);
    childToken = void 0;
    childFlow = void 0;
    self2.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(effects, ok, nok) {
  return factorySpace(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function classifyCharacter(code2) {
  if (code2 === null || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2)) {
    return 1;
  }
  if (unicodePunctuation(code2)) {
    return 2;
  }
}
function resolveAll(constructs2, events2, context) {
  const called = [];
  let index2 = -1;
  while (++index2 < constructs2.length) {
    const resolve = constructs2[index2].resolveAll;
    if (resolve && !called.includes(resolve)) {
      events2 = resolve(events2, context);
      called.push(resolve);
    }
  }
  return events2;
}
const attention = {
  name: "attention",
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};
function resolveAllAttention(events2, context) {
  let index2 = -1;
  let open;
  let group2;
  let text2;
  let openingSequence;
  let closingSequence;
  let use;
  let nextEvents;
  let offset2;
  while (++index2 < events2.length) {
    if (events2[index2][0] === "enter" && events2[index2][1].type === "attentionSequence" && events2[index2][1]._close) {
      open = index2;
      while (open--) {
        if (events2[open][0] === "exit" && events2[open][1].type === "attentionSequence" && events2[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events2[open][1]).charCodeAt(0) === context.sliceSerialize(events2[index2][1]).charCodeAt(0)) {
          if ((events2[open][1]._close || events2[index2][1]._open) && (events2[index2][1].end.offset - events2[index2][1].start.offset) % 3 && !((events2[open][1].end.offset - events2[open][1].start.offset + events2[index2][1].end.offset - events2[index2][1].start.offset) % 3)) {
            continue;
          }
          use = events2[open][1].end.offset - events2[open][1].start.offset > 1 && events2[index2][1].end.offset - events2[index2][1].start.offset > 1 ? 2 : 1;
          const start = {
            ...events2[open][1].end
          };
          const end = {
            ...events2[index2][1].start
          };
          movePoint(start, -use);
          movePoint(end, use);
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start,
            end: {
              ...events2[open][1].end
            }
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...events2[index2][1].start
            },
            end
          };
          text2 = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: {
              ...events2[open][1].end
            },
            end: {
              ...events2[index2][1].start
            }
          };
          group2 = {
            type: use > 1 ? "strong" : "emphasis",
            start: {
              ...openingSequence.start
            },
            end: {
              ...closingSequence.end
            }
          };
          events2[open][1].end = {
            ...openingSequence.start
          };
          events2[index2][1].start = {
            ...closingSequence.end
          };
          nextEvents = [];
          if (events2[open][1].end.offset - events2[open][1].start.offset) {
            nextEvents = push(nextEvents, [["enter", events2[open][1], context], ["exit", events2[open][1], context]]);
          }
          nextEvents = push(nextEvents, [["enter", group2, context], ["enter", openingSequence, context], ["exit", openingSequence, context], ["enter", text2, context]]);
          nextEvents = push(nextEvents, resolveAll(context.parser.constructs.insideSpan.null, events2.slice(open + 1, index2), context));
          nextEvents = push(nextEvents, [["exit", text2, context], ["enter", closingSequence, context], ["exit", closingSequence, context], ["exit", group2, context]]);
          if (events2[index2][1].end.offset - events2[index2][1].start.offset) {
            offset2 = 2;
            nextEvents = push(nextEvents, [["enter", events2[index2][1], context], ["exit", events2[index2][1], context]]);
          } else {
            offset2 = 0;
          }
          splice(events2, open - 1, index2 - open + 3, nextEvents);
          index2 = open + nextEvents.length - offset2 - 2;
          break;
        }
      }
    }
  }
  index2 = -1;
  while (++index2 < events2.length) {
    if (events2[index2][1].type === "attentionSequence") {
      events2[index2][1].type = "data";
    }
  }
  return events2;
}
function tokenizeAttention(effects, ok) {
  const attentionMarkers2 = this.parser.constructs.attentionMarkers.null;
  const previous2 = this.previous;
  const before2 = classifyCharacter(previous2);
  let marker;
  return start;
  function start(code2) {
    marker = code2;
    effects.enter("attentionSequence");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside2;
    }
    const token = effects.exit("attentionSequence");
    const after2 = classifyCharacter(code2);
    const open = !after2 || after2 === 2 && before2 || attentionMarkers2.includes(code2);
    const close = !before2 || before2 === 2 && after2 || attentionMarkers2.includes(previous2);
    token._open = Boolean(marker === 42 ? open : open && (before2 || !close));
    token._close = Boolean(marker === 42 ? close : close && (after2 || !open));
    return ok(code2);
  }
}
function movePoint(point2, offset2) {
  point2.column += offset2;
  point2.offset += offset2;
  point2._bufferIndex += offset2;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok, nok) {
  let size2 = 0;
  return start;
  function start(code2) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code2);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }
  function open(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return schemeOrEmailAtext;
    }
    if (code2 === 64) {
      return nok(code2);
    }
    return emailAtext(code2);
  }
  function schemeOrEmailAtext(code2) {
    if (code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) {
      size2 = 1;
      return schemeInsideOrEmailAtext(code2);
    }
    return emailAtext(code2);
  }
  function schemeInsideOrEmailAtext(code2) {
    if (code2 === 58) {
      effects.consume(code2);
      size2 = 0;
      return urlInside;
    }
    if ((code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) && size2++ < 32) {
      effects.consume(code2);
      return schemeInsideOrEmailAtext;
    }
    size2 = 0;
    return emailAtext(code2);
  }
  function urlInside(code2) {
    if (code2 === 62) {
      effects.exit("autolinkProtocol");
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok;
    }
    if (code2 === null || code2 === 32 || code2 === 60 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return urlInside;
  }
  function emailAtext(code2) {
    if (code2 === 64) {
      effects.consume(code2);
      return emailAtSignOrDot;
    }
    if (asciiAtext(code2)) {
      effects.consume(code2);
      return emailAtext;
    }
    return nok(code2);
  }
  function emailAtSignOrDot(code2) {
    return asciiAlphanumeric(code2) ? emailLabel(code2) : nok(code2);
  }
  function emailLabel(code2) {
    if (code2 === 46) {
      effects.consume(code2);
      size2 = 0;
      return emailAtSignOrDot;
    }
    if (code2 === 62) {
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok;
    }
    return emailValue(code2);
  }
  function emailValue(code2) {
    if ((code2 === 45 || asciiAlphanumeric(code2)) && size2++ < 63) {
      const next = code2 === 45 ? emailValue : emailLabel;
      effects.consume(code2);
      return next;
    }
    return nok(code2);
  }
}
const blankLine = {
  partial: true,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(effects, ok, nok) {
  return start;
  function start(code2) {
    return markdownSpace(code2) ? factorySpace(effects, after2, "linePrefix")(code2) : after2(code2);
  }
  function after2(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok(code2) : nok(code2);
  }
}
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === 62) {
      const state = self2.containerState;
      if (!state.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        state.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code2);
      effects.exit("blockQuoteMarker");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    if (markdownSpace(code2)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code2);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok;
    }
    effects.exit("blockQuotePrefix");
    return ok(code2);
  }
}
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  const self2 = this;
  return contStart;
  function contStart(code2) {
    if (markdownSpace(code2)) {
      return factorySpace(effects, contBefore, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2);
    }
    return contBefore(code2);
  }
  function contBefore(code2) {
    return effects.attempt(blockQuote, ok, nok)(code2);
  }
}
function exit(effects) {
  effects.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok, nok) {
  return start;
  function start(code2) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code2);
    effects.exit("escapeMarker");
    return inside2;
  }
  function inside2(code2) {
    if (asciiPunctuation(code2)) {
      effects.enter("characterEscapeValue");
      effects.consume(code2);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok;
    }
    return nok(code2);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok, nok) {
  const self2 = this;
  let size2 = 0;
  let max2;
  let test;
  return start;
  function start(code2) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code2);
    effects.exit("characterReferenceMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric2;
    }
    effects.enter("characterReferenceValue");
    max2 = 31;
    test = asciiAlphanumeric;
    return value(code2);
  }
  function numeric2(code2) {
    if (code2 === 88 || code2 === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max2 = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter("characterReferenceValue");
    max2 = 7;
    test = asciiDigit;
    return value(code2);
  }
  function value(code2) {
    if (code2 === 59 && size2) {
      const token = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric && !decodeNamedCharacterReference(self2.sliceSerialize(token))) {
        return nok(code2);
      }
      effects.enter("characterReferenceMarker");
      effects.consume(code2);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok;
    }
    if (test(code2) && size2++ < max2) {
      effects.consume(code2);
      return value;
    }
    return nok(code2);
  }
}
const nonLazyContinuation = {
  partial: true,
  tokenize: tokenizeNonLazyContinuation
};
const codeFenced = {
  concrete: true,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(effects, ok, nok) {
  const self2 = this;
  const closeStart = {
    partial: true,
    tokenize: tokenizeCloseStart
  };
  let initialPrefix = 0;
  let sizeOpen = 0;
  let marker;
  return start;
  function start(code2) {
    return beforeSequenceOpen(code2);
  }
  function beforeSequenceOpen(code2) {
    const tail = self2.events[self2.events.length - 1];
    initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    marker = code2;
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === marker) {
      sizeOpen++;
      effects.consume(code2);
      return sequenceOpen;
    }
    if (sizeOpen < 3) {
      return nok(code2);
    }
    effects.exit("codeFencedFenceSequence");
    return markdownSpace(code2) ? factorySpace(effects, infoBefore, "whitespace")(code2) : infoBefore(code2);
  }
  function infoBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFencedFence");
      return self2.interrupt ? ok(code2) : effects.check(nonLazyContinuation, atNonLazyBreak, after2)(code2);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info(code2);
  }
  function info(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return infoBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace(effects, metaBefore, "whitespace")(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return info;
  }
  function metaBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return infoBefore(code2);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta2(code2);
  }
  function meta2(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return infoBefore(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return meta2;
  }
  function atNonLazyBreak(code2) {
    return effects.attempt(closeStart, after2, contentBefore)(code2);
  }
  function contentBefore(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return contentStart;
  }
  function contentStart(code2) {
    return initialPrefix > 0 && markdownSpace(code2) ? factorySpace(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code2) : beforeContentChunk(code2);
  }
  function beforeContentChunk(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after2)(code2);
    }
    effects.enter("codeFlowValue");
    return contentChunk(code2);
  }
  function contentChunk(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFlowValue");
      return beforeContentChunk(code2);
    }
    effects.consume(code2);
    return contentChunk;
  }
  function after2(code2) {
    effects.exit("codeFenced");
    return ok(code2);
  }
  function tokenizeCloseStart(effects2, ok2, nok2) {
    let size2 = 0;
    return startBefore;
    function startBefore(code2) {
      effects2.enter("lineEnding");
      effects2.consume(code2);
      effects2.exit("lineEnding");
      return start2;
    }
    function start2(code2) {
      effects2.enter("codeFencedFence");
      return markdownSpace(code2) ? factorySpace(effects2, beforeSequenceClose, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : beforeSequenceClose(code2);
    }
    function beforeSequenceClose(code2) {
      if (code2 === marker) {
        effects2.enter("codeFencedFenceSequence");
        return sequenceClose(code2);
      }
      return nok2(code2);
    }
    function sequenceClose(code2) {
      if (code2 === marker) {
        size2++;
        effects2.consume(code2);
        return sequenceClose;
      }
      if (size2 >= sizeOpen) {
        effects2.exit("codeFencedFenceSequence");
        return markdownSpace(code2) ? factorySpace(effects2, sequenceCloseAfter, "whitespace")(code2) : sequenceCloseAfter(code2);
      }
      return nok2(code2);
    }
    function sequenceCloseAfter(code2) {
      if (code2 === null || markdownLineEnding(code2)) {
        effects2.exit("codeFencedFence");
        return ok2(code2);
      }
      return nok2(code2);
    }
  }
}
function tokenizeNonLazyContinuation(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineStart;
  }
  function lineStart(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok(code2);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
};
const furtherStart = {
  partial: true,
  tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("codeIndented");
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code2) : nok(code2);
  }
  function atBreak(code2) {
    if (code2 === null) {
      return after2(code2);
    }
    if (markdownLineEnding(code2)) {
      return effects.attempt(furtherStart, atBreak, after2)(code2);
    }
    effects.enter("codeFlowValue");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFlowValue");
      return atBreak(code2);
    }
    effects.consume(code2);
    return inside2;
  }
  function after2(code2) {
    effects.exit("codeIndented");
    return ok(code2);
  }
}
function tokenizeFurtherStart(effects, ok, nok) {
  const self2 = this;
  return furtherStart2;
  function furtherStart2(code2) {
    if (self2.parser.lazy[self2.now().line]) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return furtherStart2;
    }
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code2) : markdownLineEnding(code2) ? furtherStart2(code2) : nok(code2);
  }
}
const codeText = {
  name: "codeText",
  previous,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};
function resolveCodeText(events2) {
  let tailExitIndex = events2.length - 4;
  let headEnterIndex = 3;
  let index2;
  let enter;
  if ((events2[headEnterIndex][1].type === "lineEnding" || events2[headEnterIndex][1].type === "space") && (events2[tailExitIndex][1].type === "lineEnding" || events2[tailExitIndex][1].type === "space")) {
    index2 = headEnterIndex;
    while (++index2 < tailExitIndex) {
      if (events2[index2][1].type === "codeTextData") {
        events2[headEnterIndex][1].type = "codeTextPadding";
        events2[tailExitIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }
  index2 = headEnterIndex - 1;
  tailExitIndex++;
  while (++index2 <= tailExitIndex) {
    if (enter === void 0) {
      if (index2 !== tailExitIndex && events2[index2][1].type !== "lineEnding") {
        enter = index2;
      }
    } else if (index2 === tailExitIndex || events2[index2][1].type === "lineEnding") {
      events2[enter][1].type = "codeTextData";
      if (index2 !== enter + 2) {
        events2[enter][1].end = events2[index2 - 1][1].end;
        events2.splice(enter + 2, index2 - enter - 2);
        tailExitIndex -= index2 - enter - 2;
        index2 = enter + 2;
      }
      enter = void 0;
    }
  }
  return events2;
}
function previous(code2) {
  return code2 !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(effects, ok, nok) {
  let sizeOpen = 0;
  let size2;
  let token;
  return start;
  function start(code2) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeTextSequence");
    return between(code2);
  }
  function between(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 32) {
      effects.enter("space");
      effects.consume(code2);
      effects.exit("space");
      return between;
    }
    if (code2 === 96) {
      token = effects.enter("codeTextSequence");
      size2 = 0;
      return sequenceClose(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return between;
    }
    effects.enter("codeTextData");
    return data(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 32 || code2 === 96 || markdownLineEnding(code2)) {
      effects.exit("codeTextData");
      return between(code2);
    }
    effects.consume(code2);
    return data;
  }
  function sequenceClose(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      size2++;
      return sequenceClose;
    }
    if (size2 === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok(code2);
    }
    token.type = "codeTextData";
    return data(code2);
  }
}
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(initial2) {
    this.left = initial2 ? [...initial2] : [];
    this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(index2) {
    if (index2 < 0 || index2 >= this.left.length + this.right.length) {
      throw new RangeError("Cannot access index `" + index2 + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    }
    if (index2 < this.left.length) return this.left[index2];
    return this.right[this.right.length - index2 + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    this.setCursor(0);
    return this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(start, end) {
    const stop = end === null || end === void 0 ? Number.POSITIVE_INFINITY : end;
    if (stop < this.left.length) {
      return this.left.slice(start, stop);
    }
    if (start > this.left.length) {
      return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
    }
    return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(start, deleteCount, items) {
    const count = deleteCount || 0;
    this.setCursor(Math.trunc(start));
    const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
    if (items) chunkedPush(this.left, items);
    return removed.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    this.setCursor(Number.POSITIVE_INFINITY);
    return this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(item) {
    this.setCursor(Number.POSITIVE_INFINITY);
    this.left.push(item);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(items) {
    this.setCursor(Number.POSITIVE_INFINITY);
    chunkedPush(this.left, items);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(item) {
    this.setCursor(0);
    this.right.push(item);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(items) {
    this.setCursor(0);
    chunkedPush(this.right, items.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
    if (n < this.left.length) {
      const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
      chunkedPush(this.right, removed.reverse());
    } else {
      const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
      chunkedPush(this.left, removed.reverse());
    }
  }
}
function chunkedPush(list2, right) {
  let chunkStart = 0;
  if (right.length < 1e4) {
    list2.push(...right);
  } else {
    while (chunkStart < right.length) {
      list2.push(...right.slice(chunkStart, chunkStart + 1e4));
      chunkStart += 1e4;
    }
  }
}
function subtokenize(eventsArray) {
  const jumps = {};
  let index2 = -1;
  let event;
  let lineIndex;
  let otherIndex;
  let otherEvent;
  let parameters;
  let subevents;
  let more;
  const events2 = new SpliceBuffer(eventsArray);
  while (++index2 < events2.length) {
    while (index2 in jumps) {
      index2 = jumps[index2];
    }
    event = events2.get(index2);
    if (index2 && event[1].type === "chunkFlow" && events2.get(index2 - 1)[1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }
    if (event[0] === "enter") {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events2, index2));
        index2 = jumps[index2];
        more = true;
      }
    } else if (event[1]._container) {
      otherIndex = index2;
      lineIndex = void 0;
      while (otherIndex--) {
        otherEvent = events2.get(otherIndex);
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === "enter") {
            if (lineIndex) {
              events2.get(lineIndex)[1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
        else {
          break;
        }
      }
      if (lineIndex) {
        event[1].end = {
          ...events2.get(lineIndex)[1].start
        };
        parameters = events2.slice(lineIndex, index2);
        parameters.unshift(event);
        events2.splice(lineIndex, index2 - lineIndex + 1, parameters);
      }
    }
  }
  splice(eventsArray, 0, Number.POSITIVE_INFINITY, events2.slice(0));
  return !more;
}
function subcontent(events2, eventIndex) {
  const token = events2.get(eventIndex)[1];
  const context = events2.get(eventIndex)[2];
  let startPosition = eventIndex - 1;
  const startPositions = [];
  let tokenizer = token._tokenizer;
  if (!tokenizer) {
    tokenizer = context.parser[token.contentType](token.start);
    if (token._contentTypeTextTrailing) {
      tokenizer._contentTypeTextTrailing = true;
    }
  }
  const childEvents = tokenizer.events;
  const jumps = [];
  const gaps = {};
  let stream;
  let previous2;
  let index2 = -1;
  let current2 = token;
  let adjust = 0;
  let start = 0;
  const breaks = [start];
  while (current2) {
    while (events2.get(++startPosition)[1] !== current2) {
    }
    startPositions.push(startPosition);
    if (!current2._tokenizer) {
      stream = context.sliceStream(current2);
      if (!current2.next) {
        stream.push(null);
      }
      if (previous2) {
        tokenizer.defineSkip(current2.start);
      }
      if (current2._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (current2._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = void 0;
      }
    }
    previous2 = current2;
    current2 = current2.next;
  }
  current2 = token;
  while (++index2 < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index2][0] === "exit" && childEvents[index2 - 1][0] === "enter" && childEvents[index2][1].type === childEvents[index2 - 1][1].type && childEvents[index2][1].start.line !== childEvents[index2][1].end.line
    ) {
      start = index2 + 1;
      breaks.push(start);
      current2._tokenizer = void 0;
      current2.previous = void 0;
      current2 = current2.next;
    }
  }
  tokenizer.events = [];
  if (current2) {
    current2._tokenizer = void 0;
    current2.previous = void 0;
  } else {
    breaks.pop();
  }
  index2 = breaks.length;
  while (index2--) {
    const slice2 = childEvents.slice(breaks[index2], breaks[index2 + 1]);
    const start2 = startPositions.pop();
    jumps.push([start2, start2 + slice2.length - 1]);
    events2.splice(start2, 2, slice2);
  }
  jumps.reverse();
  index2 = -1;
  while (++index2 < jumps.length) {
    gaps[adjust + jumps[index2][0]] = adjust + jumps[index2][1];
    adjust += jumps[index2][1] - jumps[index2][0] - 1;
  }
  return gaps;
}
const content = {
  resolve: resolveContent,
  tokenize: tokenizeContent
};
const continuationConstruct = {
  partial: true,
  tokenize: tokenizeContinuation
};
function resolveContent(events2) {
  subtokenize(events2);
  return events2;
}
function tokenizeContent(effects, ok) {
  let previous2;
  return chunkStart;
  function chunkStart(code2) {
    effects.enter("content");
    previous2 = effects.enter("chunkContent", {
      contentType: "content"
    });
    return chunkInside(code2);
  }
  function chunkInside(code2) {
    if (code2 === null) {
      return contentEnd(code2);
    }
    if (markdownLineEnding(code2)) {
      return effects.check(continuationConstruct, contentContinue, contentEnd)(code2);
    }
    effects.consume(code2);
    return chunkInside;
  }
  function contentEnd(code2) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok(code2);
  }
  function contentContinue(code2) {
    effects.consume(code2);
    effects.exit("chunkContent");
    previous2.next = effects.enter("chunkContent", {
      contentType: "content",
      previous: previous2
    });
    previous2 = previous2.next;
    return chunkInside;
  }
}
function tokenizeContinuation(effects, ok, nok) {
  const self2 = this;
  return startLookahead;
  function startLookahead(code2) {
    effects.exit("chunkContent");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, prefixed, "linePrefix");
  }
  function prefixed(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return nok(code2);
    }
    const tail = self2.events[self2.events.length - 1];
    if (!self2.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) {
      return ok(code2);
    }
    return effects.interrupt(self2.parser.constructs.flow, nok, ok)(code2);
  }
}
function factoryDestination(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max2) {
  const limit = max2 || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start;
  function start(code2) {
    if (code2 === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      return enclosedBefore;
    }
    if (code2 === null || code2 === 32 || code2 === 41 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return raw(code2);
  }
  function enclosedBefore(code2) {
    if (code2 === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok;
    }
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return enclosed(code2);
  }
  function enclosed(code2) {
    if (code2 === 62) {
      effects.exit("chunkString");
      effects.exit(stringType);
      return enclosedBefore(code2);
    }
    if (code2 === null || code2 === 60 || markdownLineEnding(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? enclosedEscape : enclosed;
  }
  function enclosedEscape(code2) {
    if (code2 === 60 || code2 === 62 || code2 === 92) {
      effects.consume(code2);
      return enclosed;
    }
    return enclosed(code2);
  }
  function raw(code2) {
    if (!balance && (code2 === null || code2 === 41 || markdownLineEndingOrSpace(code2))) {
      effects.exit("chunkString");
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok(code2);
    }
    if (balance < limit && code2 === 40) {
      effects.consume(code2);
      balance++;
      return raw;
    }
    if (code2 === 41) {
      effects.consume(code2);
      balance--;
      return raw;
    }
    if (code2 === null || code2 === 32 || code2 === 40 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? rawEscape : raw;
  }
  function rawEscape(code2) {
    if (code2 === 40 || code2 === 41 || code2 === 92) {
      effects.consume(code2);
      return raw;
    }
    return raw(code2);
  }
}
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self2 = this;
  let size2 = 0;
  let seen;
  return start;
  function start(code2) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code2);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak;
  }
  function atBreak(code2) {
    if (size2 > 999 || code2 === null || code2 === 91 || code2 === 93 && !seen || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    code2 === 94 && !size2 && "_hiddenFootnoteSupport" in self2.parser.constructs) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok;
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return atBreak;
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return labelInside(code2);
  }
  function labelInside(code2) {
    if (code2 === null || code2 === 91 || code2 === 93 || markdownLineEnding(code2) || size2++ > 999) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    if (!seen) seen = !markdownSpace(code2);
    return code2 === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code2) {
    if (code2 === 91 || code2 === 92 || code2 === 93) {
      effects.consume(code2);
      size2++;
      return labelInside;
    }
    return labelInside(code2);
  }
}
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  let marker;
  return start;
  function start(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      effects.enter(type);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      marker = code2 === 40 ? 41 : code2;
      return begin;
    }
    return nok(code2);
  }
  function begin(code2) {
    if (code2 === marker) {
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok;
    }
    effects.enter(stringType);
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.exit(stringType);
      return begin(marker);
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return factorySpace(effects, atBreak, "linePrefix");
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker || code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? escape2 : inside2;
  }
  function escape2(code2) {
    if (code2 === marker || code2 === 92) {
      effects.consume(code2);
      return inside2;
    }
    return inside2(code2);
  }
}
function factoryWhitespace(effects, ok) {
  let seen;
  return start;
  function start(code2) {
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      seen = true;
      return start;
    }
    if (markdownSpace(code2)) {
      return factorySpace(effects, start, seen ? "linePrefix" : "lineSuffix")(code2);
    }
    return ok(code2);
  }
}
const definition = {
  name: "definition",
  tokenize: tokenizeDefinition
};
const titleBefore = {
  partial: true,
  tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(effects, ok, nok) {
  const self2 = this;
  let identifier;
  return start;
  function start(code2) {
    effects.enter("definition");
    return before2(code2);
  }
  function before2(code2) {
    return factoryLabel.call(
      self2,
      effects,
      labelAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(code2);
  }
  function labelAfter(code2) {
    identifier = normalizeIdentifier(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1));
    if (code2 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code2);
      effects.exit("definitionMarker");
      return markerAfter;
    }
    return nok(code2);
  }
  function markerAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, destinationBefore)(code2) : destinationBefore(code2);
  }
  function destinationBefore(code2) {
    return factoryDestination(
      effects,
      destinationAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(code2);
  }
  function destinationAfter(code2) {
    return effects.attempt(titleBefore, after2, after2)(code2);
  }
  function after2(code2) {
    return markdownSpace(code2) ? factorySpace(effects, afterWhitespace, "whitespace")(code2) : afterWhitespace(code2);
  }
  function afterWhitespace(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("definition");
      self2.parser.defined.push(identifier);
      return ok(code2);
    }
    return nok(code2);
  }
}
function tokenizeTitleBefore(effects, ok, nok) {
  return titleBefore2;
  function titleBefore2(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, beforeMarker)(code2) : nok(code2);
  }
  function beforeMarker(code2) {
    return factoryTitle(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code2);
  }
  function titleAfter(code2) {
    return markdownSpace(code2) ? factorySpace(effects, titleAfterOptionalWhitespace, "whitespace")(code2) : titleAfterOptionalWhitespace(code2);
  }
  function titleAfterOptionalWhitespace(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok(code2) : nok(code2);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok, nok) {
  return start;
  function start(code2) {
    effects.enter("hardBreakEscape");
    effects.consume(code2);
    return after2;
  }
  function after2(code2) {
    if (markdownLineEnding(code2)) {
      effects.exit("hardBreakEscape");
      return ok(code2);
    }
    return nok(code2);
  }
}
const headingAtx = {
  name: "headingAtx",
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(events2, context) {
  let contentEnd = events2.length - 2;
  let contentStart = 3;
  let content2;
  let text2;
  if (events2[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }
  if (contentEnd - 2 > contentStart && events2[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events2[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events2[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content2 = {
      type: "atxHeadingText",
      start: events2[contentStart][1].start,
      end: events2[contentEnd][1].end
    };
    text2 = {
      type: "chunkText",
      start: events2[contentStart][1].start,
      end: events2[contentEnd][1].end,
      contentType: "text"
    };
    splice(events2, contentStart, contentEnd - contentStart + 1, [["enter", content2, context], ["enter", text2, context], ["exit", text2, context], ["exit", content2, context]]);
  }
  return events2;
}
function tokenizeHeadingAtx(effects, ok, nok) {
  let size2 = 0;
  return start;
  function start(code2) {
    effects.enter("atxHeading");
    return before2(code2);
  }
  function before2(code2) {
    effects.enter("atxHeadingSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 35 && size2++ < 6) {
      effects.consume(code2);
      return sequenceOpen;
    }
    if (code2 === null || markdownLineEndingOrSpace(code2)) {
      effects.exit("atxHeadingSequence");
      return atBreak(code2);
    }
    return nok(code2);
  }
  function atBreak(code2) {
    if (code2 === 35) {
      effects.enter("atxHeadingSequence");
      return sequenceFurther(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("atxHeading");
      return ok(code2);
    }
    if (markdownSpace(code2)) {
      return factorySpace(effects, atBreak, "whitespace")(code2);
    }
    effects.enter("atxHeadingText");
    return data(code2);
  }
  function sequenceFurther(code2) {
    if (code2 === 35) {
      effects.consume(code2);
      return sequenceFurther;
    }
    effects.exit("atxHeadingSequence");
    return atBreak(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 35 || markdownLineEndingOrSpace(code2)) {
      effects.exit("atxHeadingText");
      return atBreak(code2);
    }
    effects.consume(code2);
    return data;
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
];
const htmlRawNames = ["pre", "script", "style", "textarea"];
const htmlFlow = {
  concrete: true,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
};
const blankLineBefore = {
  partial: true,
  tokenize: tokenizeBlankLineBefore
};
const nonLazyContinuationStart = {
  partial: true,
  tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(events2) {
  let index2 = events2.length;
  while (index2--) {
    if (events2[index2][0] === "enter" && events2[index2][1].type === "htmlFlow") {
      break;
    }
  }
  if (index2 > 1 && events2[index2 - 2][1].type === "linePrefix") {
    events2[index2][1].start = events2[index2 - 2][1].start;
    events2[index2 + 1][1].start = events2[index2 - 2][1].start;
    events2.splice(index2 - 2, 2);
  }
  return events2;
}
function tokenizeHtmlFlow(effects, ok, nok) {
  const self2 = this;
  let marker;
  let closingTag;
  let buffer;
  let index2;
  let markerB;
  return start;
  function start(code2) {
    return before2(code2);
  }
  function before2(code2) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      closingTag = true;
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      marker = 3;
      return self2.interrupt ? ok : continuationDeclarationInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      buffer = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      marker = 2;
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      marker = 5;
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      marker = 4;
      return self2.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return self2.interrupt ? ok : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index2++)) {
      effects.consume(code2);
      if (index2 === value.length) {
        return self2.interrupt ? ok : continuation;
      }
      return cdataOpenInside;
    }
    return nok(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      buffer = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function tagName(code2) {
    if (code2 === null || code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      const slash = code2 === 47;
      const name2 = buffer.toLowerCase();
      if (!slash && !closingTag && htmlRawNames.includes(name2)) {
        marker = 1;
        return self2.interrupt ? ok(code2) : continuation(code2);
      }
      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        marker = 6;
        if (slash) {
          effects.consume(code2);
          return basicSelfClosing;
        }
        return self2.interrupt ? ok(code2) : continuation(code2);
      }
      marker = 7;
      return self2.interrupt && !self2.parser.lazy[self2.now().line] ? nok(code2) : closingTag ? completeClosingTagAfter(code2) : completeAttributeNameBefore(code2);
    }
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      buffer += String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function basicSelfClosing(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return self2.interrupt ? ok : continuation;
    }
    return nok(code2);
  }
  function completeClosingTagAfter(code2) {
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeClosingTagAfter;
    }
    return completeEnd(code2);
  }
  function completeAttributeNameBefore(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return completeEnd;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeNameBefore;
    }
    return completeEnd(code2);
  }
  function completeAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code2);
  }
  function completeAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code2);
  }
  function completeAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      markerB = code2;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    return completeAttributeValueUnquoted(code2);
  }
  function completeAttributeValueQuoted(code2) {
    if (code2 === markerB) {
      effects.consume(code2);
      markerB = null;
      return completeAttributeValueQuotedAfter;
    }
    if (code2 === null || markdownLineEnding(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return completeAttributeValueQuoted;
  }
  function completeAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 47 || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 || markdownLineEndingOrSpace(code2)) {
      return completeAttributeNameAfter(code2);
    }
    effects.consume(code2);
    return completeAttributeValueUnquoted;
  }
  function completeAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownSpace(code2)) {
      return completeAttributeNameBefore(code2);
    }
    return nok(code2);
  }
  function completeEnd(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function completeAfter(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return continuation(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function continuation(code2) {
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationCommentInside;
    }
    if (code2 === 60 && marker === 1) {
      effects.consume(code2);
      return continuationRawTagOpen;
    }
    if (code2 === 62 && marker === 4) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 63 && marker === 3) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    if (code2 === 93 && marker === 5) {
      effects.consume(code2);
      return continuationCdataInside;
    }
    if (markdownLineEnding(code2) && (marker === 6 || marker === 7)) {
      effects.exit("htmlFlowData");
      return effects.check(blankLineBefore, continuationAfter, continuationStart)(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("htmlFlowData");
      return continuationStart(code2);
    }
    effects.consume(code2);
    return continuation;
  }
  function continuationStart(code2) {
    return effects.check(nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code2);
  }
  function continuationStartNonLazy(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return continuationBefore;
  }
  function continuationBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return continuationStart(code2);
    }
    effects.enter("htmlFlowData");
    return continuation(code2);
  }
  function continuationCommentInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationRawTagOpen(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      buffer = "";
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationRawEndTag(code2) {
    if (code2 === 62) {
      const name2 = buffer.toLowerCase();
      if (htmlRawNames.includes(name2)) {
        effects.consume(code2);
        return continuationClose;
      }
      return continuation(code2);
    }
    if (asciiAlpha(code2) && buffer.length < 8) {
      effects.consume(code2);
      buffer += String.fromCharCode(code2);
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationCdataInside(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationDeclarationInside(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationClose(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("htmlFlowData");
      return continuationAfter(code2);
    }
    effects.consume(code2);
    return continuationClose;
  }
  function continuationAfter(code2) {
    effects.exit("htmlFlow");
    return ok(code2);
  }
}
function tokenizeNonLazyContinuationStart(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok(code2);
  }
}
function tokenizeBlankLineBefore(effects, ok, nok) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return effects.attempt(blankLine, ok, nok);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok, nok) {
  const self2 = this;
  let marker;
  let index2;
  let returnState;
  return start;
  function start(code2) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instruction;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return declaration;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return nok(code2);
  }
  function comment2(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 45) {
      effects.consume(code2);
      return commentClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = comment2;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return comment2;
  }
  function commentClose(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return comment2(code2);
  }
  function commentEnd(code2) {
    return code2 === 62 ? end(code2) : code2 === 45 ? commentClose(code2) : comment2(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index2++)) {
      effects.consume(code2);
      return index2 === value.length ? cdata : cdataOpenInside;
    }
    return nok(code2);
  }
  function cdata(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = cdata;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return cdata;
  }
  function cdataClose(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function cdataEnd(code2) {
    if (code2 === 62) {
      return end(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function declaration(code2) {
    if (code2 === null || code2 === 62) {
      return end(code2);
    }
    if (markdownLineEnding(code2)) {
      returnState = declaration;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return declaration;
  }
  function instruction(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instructionClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = instruction;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return instruction;
  }
  function instructionClose(code2) {
    return code2 === 62 ? end(code2) : instruction(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return nok(code2);
  }
  function tagClose(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return tagCloseBetween(code2);
  }
  function tagCloseBetween(code2) {
    if (markdownLineEnding(code2)) {
      returnState = tagCloseBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagCloseBetween;
    }
    return end(code2);
  }
  function tagOpen(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function tagOpenBetween(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return end;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenBetween;
    }
    return end(code2);
  }
  function tagOpenAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code2);
  }
  function tagOpenAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeNameAfter;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code2);
  }
  function tagOpenAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      marker = code2;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeValueBefore;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuoted(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      marker = void 0;
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeValueQuoted;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueQuoted;
  }
  function tagOpenAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 60 || code2 === 61 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function end(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok;
    }
    return nok(code2);
  }
  function lineEndingBefore(code2) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineEndingAfter;
  }
  function lineEndingAfter(code2) {
    return markdownSpace(code2) ? factorySpace(effects, lineEndingAfterPrefix, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : lineEndingAfterPrefix(code2);
  }
  function lineEndingAfterPrefix(code2) {
    effects.enter("htmlTextData");
    return returnState(code2);
  }
}
const labelEnd = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
};
const resourceConstruct = {
  tokenize: tokenizeResource
};
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
};
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(events2) {
  let index2 = -1;
  const newEvents = [];
  while (++index2 < events2.length) {
    const token = events2[index2][1];
    newEvents.push(events2[index2]);
    if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
      const offset2 = token.type === "labelImage" ? 4 : 2;
      token.type = "data";
      index2 += offset2;
    }
  }
  if (events2.length !== newEvents.length) {
    splice(events2, 0, events2.length, newEvents);
  }
  return events2;
}
function resolveToLabelEnd(events2, context) {
  let index2 = events2.length;
  let offset2 = 0;
  let token;
  let open;
  let close;
  let media;
  while (index2--) {
    token = events2[index2][1];
    if (open) {
      if (token.type === "link" || token.type === "labelLink" && token._inactive) {
        break;
      }
      if (events2[index2][0] === "enter" && token.type === "labelLink") {
        token._inactive = true;
      }
    } else if (close) {
      if (events2[index2][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
        open = index2;
        if (token.type !== "labelLink") {
          offset2 = 2;
          break;
        }
      }
    } else if (token.type === "labelEnd") {
      close = index2;
    }
  }
  const group2 = {
    type: events2[open][1].type === "labelLink" ? "link" : "image",
    start: {
      ...events2[open][1].start
    },
    end: {
      ...events2[events2.length - 1][1].end
    }
  };
  const label2 = {
    type: "label",
    start: {
      ...events2[open][1].start
    },
    end: {
      ...events2[close][1].end
    }
  };
  const text2 = {
    type: "labelText",
    start: {
      ...events2[open + offset2 + 2][1].end
    },
    end: {
      ...events2[close - 2][1].start
    }
  };
  media = [["enter", group2, context], ["enter", label2, context]];
  media = push(media, events2.slice(open + 1, open + offset2 + 3));
  media = push(media, [["enter", text2, context]]);
  media = push(media, resolveAll(context.parser.constructs.insideSpan.null, events2.slice(open + offset2 + 4, close - 3), context));
  media = push(media, [["exit", text2, context], events2[close - 2], events2[close - 1], ["exit", label2, context]]);
  media = push(media, events2.slice(close + 1));
  media = push(media, [["exit", group2, context]]);
  splice(events2, open, events2.length, media);
  return events2;
}
function tokenizeLabelEnd(effects, ok, nok) {
  const self2 = this;
  let index2 = self2.events.length;
  let labelStart;
  let defined;
  while (index2--) {
    if ((self2.events[index2][1].type === "labelImage" || self2.events[index2][1].type === "labelLink") && !self2.events[index2][1]._balanced) {
      labelStart = self2.events[index2][1];
      break;
    }
  }
  return start;
  function start(code2) {
    if (!labelStart) {
      return nok(code2);
    }
    if (labelStart._inactive) {
      return labelEndNok(code2);
    }
    defined = self2.parser.defined.includes(normalizeIdentifier(self2.sliceSerialize({
      start: labelStart.end,
      end: self2.now()
    })));
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return after2;
  }
  function after2(code2) {
    if (code2 === 40) {
      return effects.attempt(resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code2);
    }
    if (code2 === 91) {
      return effects.attempt(referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code2);
    }
    return defined ? labelEndOk(code2) : labelEndNok(code2);
  }
  function referenceNotFull(code2) {
    return effects.attempt(referenceCollapsedConstruct, labelEndOk, labelEndNok)(code2);
  }
  function labelEndOk(code2) {
    return ok(code2);
  }
  function labelEndNok(code2) {
    labelStart._balanced = true;
    return nok(code2);
  }
}
function tokenizeResource(effects, ok, nok) {
  return resourceStart;
  function resourceStart(code2) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code2);
    effects.exit("resourceMarker");
    return resourceBefore;
  }
  function resourceBefore(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceOpen)(code2) : resourceOpen(code2);
  }
  function resourceOpen(code2) {
    if (code2 === 41) {
      return resourceEnd(code2);
    }
    return factoryDestination(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code2);
  }
  function resourceDestinationAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceBetween)(code2) : resourceEnd(code2);
  }
  function resourceDestinationMissing(code2) {
    return nok(code2);
  }
  function resourceBetween(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      return factoryTitle(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code2);
    }
    return resourceEnd(code2);
  }
  function resourceTitleAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceEnd)(code2) : resourceEnd(code2);
  }
  function resourceEnd(code2) {
    if (code2 === 41) {
      effects.enter("resourceMarker");
      effects.consume(code2);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok;
    }
    return nok(code2);
  }
}
function tokenizeReferenceFull(effects, ok, nok) {
  const self2 = this;
  return referenceFull;
  function referenceFull(code2) {
    return factoryLabel.call(self2, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code2);
  }
  function referenceFullAfter(code2) {
    return self2.parser.defined.includes(normalizeIdentifier(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1))) ? ok(code2) : nok(code2);
  }
  function referenceFullMissing(code2) {
    return nok(code2);
  }
}
function tokenizeReferenceCollapsed(effects, ok, nok) {
  return referenceCollapsedStart;
  function referenceCollapsedStart(code2) {
    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code2);
    effects.exit("referenceMarker");
    return referenceCollapsedOpen;
  }
  function referenceCollapsedOpen(code2) {
    if (code2 === 93) {
      effects.enter("referenceMarker");
      effects.consume(code2);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok;
    }
    return nok(code2);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code2);
    effects.exit("labelImageMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 91) {
      effects.enter("labelMarker");
      effects.consume(code2);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok(code2);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(effects, ok, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after2;
  }
  function after2(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok(code2);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, ok, "linePrefix");
  }
}
const thematicBreak = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok, nok) {
  let size2 = 0;
  let marker;
  return start;
  function start(code2) {
    effects.enter("thematicBreak");
    return before2(code2);
  }
  function before2(code2) {
    marker = code2;
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code2);
    }
    if (size2 >= 3 && (code2 === null || markdownLineEnding(code2))) {
      effects.exit("thematicBreak");
      return ok(code2);
    }
    return nok(code2);
  }
  function sequence(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      size2++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return markdownSpace(code2) ? factorySpace(effects, atBreak, "whitespace")(code2) : atBreak(code2);
  }
}
const list = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: "list",
  tokenize: tokenizeListStart
};
const listItemPrefixWhitespaceConstruct = {
  partial: true,
  tokenize: tokenizeListItemPrefixWhitespace
};
const indentConstruct = {
  partial: true,
  tokenize: tokenizeIndent
};
function tokenizeListStart(effects, ok, nok) {
  const self2 = this;
  const tail = self2.events[self2.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let size2 = 0;
  return start;
  function start(code2) {
    const kind = self2.containerState.type || (code2 === 42 || code2 === 43 || code2 === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self2.containerState.marker || code2 === self2.containerState.marker : asciiDigit(code2)) {
      if (!self2.containerState.type) {
        self2.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code2 === 42 || code2 === 45 ? effects.check(thematicBreak, nok, atMarker)(code2) : atMarker(code2);
      }
      if (!self2.interrupt || code2 === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside2(code2);
      }
    }
    return nok(code2);
  }
  function inside2(code2) {
    if (asciiDigit(code2) && ++size2 < 10) {
      effects.consume(code2);
      return inside2;
    }
    if ((!self2.interrupt || size2 < 2) && (self2.containerState.marker ? code2 === self2.containerState.marker : code2 === 41 || code2 === 46)) {
      effects.exit("listItemValue");
      return atMarker(code2);
    }
    return nok(code2);
  }
  function atMarker(code2) {
    effects.enter("listItemMarker");
    effects.consume(code2);
    effects.exit("listItemMarker");
    self2.containerState.marker = self2.containerState.marker || code2;
    return effects.check(
      blankLine,
      // Can’t be empty when interrupting.
      self2.interrupt ? nok : onBlank,
      effects.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix)
    );
  }
  function onBlank(code2) {
    self2.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code2);
  }
  function otherPrefix(code2) {
    if (markdownSpace(code2)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code2);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code2);
  }
  function endOfPrefix(code2) {
    self2.containerState.size = initialSize + self2.sliceSerialize(effects.exit("listItemPrefix"), true).length;
    return ok(code2);
  }
}
function tokenizeListContinuation(effects, ok, nok) {
  const self2 = this;
  self2.containerState._closeFlow = void 0;
  return effects.check(blankLine, onBlank, notBlank);
  function onBlank(code2) {
    self2.containerState.furtherBlankLines = self2.containerState.furtherBlankLines || self2.containerState.initialBlankLine;
    return factorySpace(effects, ok, "listItemIndent", self2.containerState.size + 1)(code2);
  }
  function notBlank(code2) {
    if (self2.containerState.furtherBlankLines || !markdownSpace(code2)) {
      self2.containerState.furtherBlankLines = void 0;
      self2.containerState.initialBlankLine = void 0;
      return notInCurrentItem(code2);
    }
    self2.containerState.furtherBlankLines = void 0;
    self2.containerState.initialBlankLine = void 0;
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code2);
  }
  function notInCurrentItem(code2) {
    self2.containerState._closeFlow = true;
    self2.interrupt = void 0;
    return factorySpace(effects, effects.attempt(list, ok, nok), "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2);
  }
}
function tokenizeIndent(effects, ok, nok) {
  const self2 = this;
  return factorySpace(effects, afterPrefix, "listItemIndent", self2.containerState.size + 1);
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self2.containerState.size ? ok(code2) : nok(code2);
  }
}
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self2 = this;
  return factorySpace(effects, afterPrefix, "listItemPrefixWhitespace", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1);
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return !markdownSpace(code2) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code2) : nok(code2);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(events2, context) {
  let index2 = events2.length;
  let content2;
  let text2;
  let definition2;
  while (index2--) {
    if (events2[index2][0] === "enter") {
      if (events2[index2][1].type === "content") {
        content2 = index2;
        break;
      }
      if (events2[index2][1].type === "paragraph") {
        text2 = index2;
      }
    } else {
      if (events2[index2][1].type === "content") {
        events2.splice(index2, 1);
      }
      if (!definition2 && events2[index2][1].type === "definition") {
        definition2 = index2;
      }
    }
  }
  const heading2 = {
    type: "setextHeading",
    start: {
      ...events2[content2][1].start
    },
    end: {
      ...events2[events2.length - 1][1].end
    }
  };
  events2[text2][1].type = "setextHeadingText";
  if (definition2) {
    events2.splice(text2, 0, ["enter", heading2, context]);
    events2.splice(definition2 + 1, 0, ["exit", events2[content2][1], context]);
    events2[content2][1].end = {
      ...events2[definition2][1].end
    };
  } else {
    events2[content2][1] = heading2;
  }
  events2.push(["exit", heading2, context]);
  return events2;
}
function tokenizeSetextUnderline(effects, ok, nok) {
  const self2 = this;
  let marker;
  return start;
  function start(code2) {
    let index2 = self2.events.length;
    let paragraph;
    while (index2--) {
      if (self2.events[index2][1].type !== "lineEnding" && self2.events[index2][1].type !== "linePrefix" && self2.events[index2][1].type !== "content") {
        paragraph = self2.events[index2][1].type === "paragraph";
        break;
      }
    }
    if (!self2.parser.lazy[self2.now().line] && (self2.interrupt || paragraph)) {
      effects.enter("setextHeadingLine");
      marker = code2;
      return before2(code2);
    }
    return nok(code2);
  }
  function before2(code2) {
    effects.enter("setextHeadingLineSequence");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside2;
    }
    effects.exit("setextHeadingLineSequence");
    return markdownSpace(code2) ? factorySpace(effects, after2, "lineSuffix")(code2) : after2(code2);
  }
  function after2(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("setextHeadingLine");
      return ok(code2);
    }
    return nok(code2);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(effects) {
  const self2 = this;
  const initial2 = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt(content, afterConstruct)), "linePrefix"))
  );
  return initial2;
  function atBlankEnding(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEndingBlank");
    effects.consume(code2);
    effects.exit("lineEndingBlank");
    self2.currentConstruct = void 0;
    return initial2;
  }
  function afterConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    self2.currentConstruct = void 0;
    return initial2;
  }
}
const resolver = {
  resolveAll: createResolver()
};
const string$1 = initializeFactory("string");
const text$1 = initializeFactory("text");
function initializeFactory(field) {
  return {
    resolveAll: createResolver(field === "text" ? resolveAllLineSuffixes : void 0),
    tokenize: initializeText
  };
  function initializeText(effects) {
    const self2 = this;
    const constructs2 = this.parser.constructs[field];
    const text2 = effects.attempt(constructs2, start, notText);
    return start;
    function start(code2) {
      return atBreak(code2) ? text2(code2) : notText(code2);
    }
    function notText(code2) {
      if (code2 === null) {
        effects.consume(code2);
        return;
      }
      effects.enter("data");
      effects.consume(code2);
      return data;
    }
    function data(code2) {
      if (atBreak(code2)) {
        effects.exit("data");
        return text2(code2);
      }
      effects.consume(code2);
      return data;
    }
    function atBreak(code2) {
      if (code2 === null) {
        return true;
      }
      const list2 = constructs2[code2];
      let index2 = -1;
      if (list2) {
        while (++index2 < list2.length) {
          const item = list2[index2];
          if (!item.previous || item.previous.call(self2, self2.previous)) {
            return true;
          }
        }
      }
      return false;
    }
  }
}
function createResolver(extraResolver) {
  return resolveAllText;
  function resolveAllText(events2, context) {
    let index2 = -1;
    let enter;
    while (++index2 <= events2.length) {
      if (enter === void 0) {
        if (events2[index2] && events2[index2][1].type === "data") {
          enter = index2;
          index2++;
        }
      } else if (!events2[index2] || events2[index2][1].type !== "data") {
        if (index2 !== enter + 2) {
          events2[enter][1].end = events2[index2 - 1][1].end;
          events2.splice(enter + 2, index2 - enter - 2);
          index2 = enter + 2;
        }
        enter = void 0;
      }
    }
    return extraResolver ? extraResolver(events2, context) : events2;
  }
}
function resolveAllLineSuffixes(events2, context) {
  let eventIndex = 0;
  while (++eventIndex <= events2.length) {
    if ((eventIndex === events2.length || events2[eventIndex][1].type === "lineEnding") && events2[eventIndex - 1][1].type === "data") {
      const data = events2[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index2 = chunks.length;
      let bufferIndex = -1;
      let size2 = 0;
      let tabs;
      while (index2--) {
        const chunk2 = chunks[index2];
        if (typeof chunk2 === "string") {
          bufferIndex = chunk2.length;
          while (chunk2.charCodeAt(bufferIndex - 1) === 32) {
            size2++;
            bufferIndex--;
          }
          if (bufferIndex) break;
          bufferIndex = -1;
        } else if (chunk2 === -2) {
          tabs = true;
          size2++;
        } else if (chunk2 === -1) ;
        else {
          index2++;
          break;
        }
      }
      if (context._contentTypeTextTrailing && eventIndex === events2.length) {
        size2 = 0;
      }
      if (size2) {
        const token = {
          type: eventIndex === events2.length || tabs || size2 < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: index2 ? bufferIndex : data.start._bufferIndex + bufferIndex,
            _index: data.start._index + index2,
            line: data.end.line,
            column: data.end.column - size2,
            offset: data.end.offset - size2
          },
          end: {
            ...data.end
          }
        };
        data.end = {
          ...token.start
        };
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token);
        } else {
          events2.splice(eventIndex, 0, ["enter", token, context], ["exit", token, context]);
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events2;
}
const document$1 = {
  [42]: list,
  [43]: list,
  [45]: list,
  [48]: list,
  [49]: list,
  [50]: list,
  [51]: list,
  [52]: list,
  [53]: list,
  [54]: list,
  [55]: list,
  [56]: list,
  [57]: list,
  [62]: blockQuote
};
const contentInitial = {
  [91]: definition
};
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
};
const flow = {
  [35]: headingAtx,
  [42]: thematicBreak,
  [45]: [setextUnderline, thematicBreak],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak,
  [96]: codeFenced,
  [126]: codeFenced
};
const string = {
  [38]: characterReference,
  [92]: characterEscape
};
const text = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
};
const insideSpan = {
  null: [attention, resolver]
};
const attentionMarkers = {
  null: [42, 95]
};
const disable = {
  null: []
};
const defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string,
  text
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer(parser2, initialize, from) {
  let point2 = {
    _bufferIndex: -1,
    _index: 0,
    line: from && from.line || 1,
    column: from && from.column || 1,
    offset: from && from.offset || 0
  };
  const columnStart = {};
  const resolveAllConstructs = [];
  let chunks = [];
  let stack = [];
  const effects = {
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    consume,
    enter,
    exit: exit2,
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };
  const context = {
    code: null,
    containerState: {},
    defineSkip,
    events: [],
    now: now2,
    parser: parser2,
    previous: null,
    sliceSerialize,
    sliceStream,
    write
  };
  let state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  return context;
  function write(slice2) {
    chunks = push(chunks, slice2);
    main2();
    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0);
    context.events = resolveAll(resolveAllConstructs, context.events, context);
    return context.events;
  }
  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs);
  }
  function sliceStream(token) {
    return sliceChunks(chunks, token);
  }
  function now2() {
    const {
      _bufferIndex,
      _index,
      line: line2,
      column,
      offset: offset2
    } = point2;
    return {
      _bufferIndex,
      _index,
      line: line2,
      column,
      offset: offset2
    };
  }
  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }
  function main2() {
    let chunkIndex;
    while (point2._index < chunks.length) {
      const chunk2 = chunks[point2._index];
      if (typeof chunk2 === "string") {
        chunkIndex = point2._index;
        if (point2._bufferIndex < 0) {
          point2._bufferIndex = 0;
        }
        while (point2._index === chunkIndex && point2._bufferIndex < chunk2.length) {
          go2(chunk2.charCodeAt(point2._bufferIndex));
        }
      } else {
        go2(chunk2);
      }
    }
  }
  function go2(code2) {
    state = state(code2);
  }
  function consume(code2) {
    if (markdownLineEnding(code2)) {
      point2.line++;
      point2.column = 1;
      point2.offset += code2 === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code2 !== -1) {
      point2.column++;
      point2.offset++;
    }
    if (point2._bufferIndex < 0) {
      point2._index++;
    } else {
      point2._bufferIndex++;
      if (point2._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
      // strings.
      /** @type {string} */
      chunks[point2._index].length) {
        point2._bufferIndex = -1;
        point2._index++;
      }
    }
    context.previous = code2;
  }
  function enter(type, fields) {
    const token = fields || {};
    token.type = type;
    token.start = now2();
    context.events.push(["enter", token, context]);
    stack.push(token);
    return token;
  }
  function exit2(type) {
    const token = stack.pop();
    token.end = now2();
    context.events.push(["exit", token, context]);
    return token;
  }
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }
  function onsuccessfulcheck(_2, info) {
    info.restore();
  }
  function constructFactory(onreturn, fields) {
    return hook;
    function hook(constructs2, returnState, bogusState) {
      let listOfConstructs;
      let constructIndex;
      let currentConstruct;
      let info;
      return Array.isArray(constructs2) ? (
        /* c8 ignore next 1 */
        handleListOfConstructs(constructs2)
      ) : "tokenize" in constructs2 ? (
        // Looks like a construct.
        handleListOfConstructs([
          /** @type {Construct} */
          constructs2
        ])
      ) : handleMapOfConstructs(constructs2);
      function handleMapOfConstructs(map2) {
        return start;
        function start(code2) {
          const left = code2 !== null && map2[code2];
          const all2 = code2 !== null && map2.null;
          const list2 = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(left) ? left : left ? [left] : [],
            ...Array.isArray(all2) ? all2 : all2 ? [all2] : []
          ];
          return handleListOfConstructs(list2)(code2);
        }
      }
      function handleListOfConstructs(list2) {
        listOfConstructs = list2;
        constructIndex = 0;
        if (list2.length === 0) {
          return bogusState;
        }
        return handleConstruct(list2[constructIndex]);
      }
      function handleConstruct(construct) {
        return start;
        function start(code2) {
          info = store2();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }
          if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) {
            return nok();
          }
          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code2);
        }
      }
      function ok(code2) {
        onreturn(currentConstruct, info);
        return returnState;
      }
      function nok(code2) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }
  function addResult(construct, from2) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      splice(context.events, from2, context.events.length - from2, construct.resolve(context.events.slice(from2), context));
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  function store2() {
    const startPoint = now2();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      from: startEventsIndex,
      restore
    };
    function restore() {
      point2 = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  function accountForPotentialSkip() {
    if (point2.line in columnStart && point2.column < 2) {
      point2.column = columnStart[point2.line];
      point2.offset += columnStart[point2.line] - 1;
    }
  }
}
function sliceChunks(chunks, token) {
  const startIndex = token.start._index;
  const startBufferIndex = token.start._bufferIndex;
  const endIndex = token.end._index;
  const endBufferIndex = token.end._bufferIndex;
  let view;
  if (startIndex === endIndex) {
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      const head = view[0];
      if (typeof head === "string") {
        view[0] = head.slice(startBufferIndex);
      } else {
        view.shift();
      }
    }
    if (endBufferIndex > 0) {
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}
function serializeChunks(chunks, expandTabs) {
  let index2 = -1;
  const result2 = [];
  let atTab;
  while (++index2 < chunks.length) {
    const chunk2 = chunks[index2];
    let value;
    if (typeof chunk2 === "string") {
      value = chunk2;
    } else switch (chunk2) {
      case -5: {
        value = "\r";
        break;
      }
      case -4: {
        value = "\n";
        break;
      }
      case -3: {
        value = "\r\n";
        break;
      }
      case -2: {
        value = expandTabs ? " " : "	";
        break;
      }
      case -1: {
        if (!expandTabs && atTab) continue;
        value = " ";
        break;
      }
      default: {
        value = String.fromCharCode(chunk2);
      }
    }
    atTab = chunk2 === -2;
    result2.push(value);
  }
  return result2.join("");
}
function parse(options2) {
  const settings = options2 || {};
  const constructs2 = (
    /** @type {FullNormalizedExtension} */
    combineExtensions([defaultConstructs, ...settings.extensions || []])
  );
  const parser2 = {
    constructs: constructs2,
    content: create2(content$1),
    defined: [],
    document: create2(document$2),
    flow: create2(flow$1),
    lazy: {},
    string: create2(string$1),
    text: create2(text$1)
  };
  return parser2;
  function create2(initial2) {
    return creator;
    function creator(from) {
      return createTokenizer(parser2, initial2, from);
    }
  }
}
function postprocess(events2) {
  while (!subtokenize(events2)) {
  }
  return events2;
}
const search = /[\0\t\n\r]/g;
function preprocess() {
  let column = 1;
  let buffer = "";
  let start = true;
  let atCarriageReturn;
  return preprocessor;
  function preprocessor(value, encoding, end) {
    const chunks = [];
    let match2;
    let next;
    let startPosition;
    let endPosition;
    let code2;
    value = buffer + (typeof value === "string" ? value.toString() : new TextDecoder(encoding || void 0).decode(value));
    startPosition = 0;
    buffer = "";
    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = void 0;
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition;
      match2 = search.exec(value);
      endPosition = match2 && match2.index !== void 0 ? match2.index : value.length;
      code2 = value.charCodeAt(endPosition);
      if (!match2) {
        buffer = value.slice(startPosition);
        break;
      }
      if (code2 === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = void 0;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = void 0;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }
        switch (code2) {
          case 0: {
            chunks.push(65533);
            column++;
            break;
          }
          case 9: {
            next = Math.ceil(column / 4) * 4;
            chunks.push(-2);
            while (column++ < next) chunks.push(-1);
            break;
          }
          case 10: {
            chunks.push(-4);
            column = 1;
            break;
          }
          default: {
            atCarriageReturn = true;
            column = 1;
          }
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer) chunks.push(buffer);
      chunks.push(null);
    }
    return chunks;
  }
}
function micromark(value, encoding, options2) {
  if (typeof encoding !== "string") {
    options2 = encoding;
    encoding = void 0;
  }
  return compile(options2)(postprocess(parse(options2).document().write(preprocess()(value, encoding, true))));
}
function WorkerWrapper(options2) {
  return new Worker(
    "" + new URL("data:text/javascript;base64,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", import.meta.url).href,
    {
      name: options2?.name
    }
  );
}
var main$2 = {};
var main$1 = {};
var ril = {};
var api$1 = {};
var messages$1 = {};
var is$1 = {};
var hasRequiredIs$1;
function requireIs$1() {
  if (hasRequiredIs$1) return is$1;
  hasRequiredIs$1 = 1;
  Object.defineProperty(is$1, "__esModule", { value: true });
  is$1.stringArray = is$1.array = is$1.func = is$1.error = is$1.number = is$1.string = is$1.boolean = void 0;
  function boolean(value) {
    return value === true || value === false;
  }
  is$1.boolean = boolean;
  function string2(value) {
    return typeof value === "string" || value instanceof String;
  }
  is$1.string = string2;
  function number2(value) {
    return typeof value === "number" || value instanceof Number;
  }
  is$1.number = number2;
  function error(value) {
    return value instanceof Error;
  }
  is$1.error = error;
  function func(value) {
    return typeof value === "function";
  }
  is$1.func = func;
  function array(value) {
    return Array.isArray(value);
  }
  is$1.array = array;
  function stringArray(value) {
    return array(value) && value.every((elem) => string2(elem));
  }
  is$1.stringArray = stringArray;
  return is$1;
}
var hasRequiredMessages$1;
function requireMessages$1() {
  if (hasRequiredMessages$1) return messages$1;
  hasRequiredMessages$1 = 1;
  Object.defineProperty(messages$1, "__esModule", { value: true });
  messages$1.Message = messages$1.NotificationType9 = messages$1.NotificationType8 = messages$1.NotificationType7 = messages$1.NotificationType6 = messages$1.NotificationType5 = messages$1.NotificationType4 = messages$1.NotificationType3 = messages$1.NotificationType2 = messages$1.NotificationType1 = messages$1.NotificationType0 = messages$1.NotificationType = messages$1.RequestType9 = messages$1.RequestType8 = messages$1.RequestType7 = messages$1.RequestType6 = messages$1.RequestType5 = messages$1.RequestType4 = messages$1.RequestType3 = messages$1.RequestType2 = messages$1.RequestType1 = messages$1.RequestType = messages$1.RequestType0 = messages$1.AbstractMessageSignature = messages$1.ParameterStructures = messages$1.ResponseError = messages$1.ErrorCodes = void 0;
  const is2 = requireIs$1();
  var ErrorCodes;
  (function(ErrorCodes2) {
    ErrorCodes2.ParseError = -32700;
    ErrorCodes2.InvalidRequest = -32600;
    ErrorCodes2.MethodNotFound = -32601;
    ErrorCodes2.InvalidParams = -32602;
    ErrorCodes2.InternalError = -32603;
    ErrorCodes2.jsonrpcReservedErrorRangeStart = -32099;
    ErrorCodes2.serverErrorStart = -32099;
    ErrorCodes2.MessageWriteError = -32099;
    ErrorCodes2.MessageReadError = -32098;
    ErrorCodes2.PendingResponseRejected = -32097;
    ErrorCodes2.ConnectionInactive = -32096;
    ErrorCodes2.ServerNotInitialized = -32002;
    ErrorCodes2.UnknownErrorCode = -32001;
    ErrorCodes2.jsonrpcReservedErrorRangeEnd = -32e3;
    ErrorCodes2.serverErrorEnd = -32e3;
  })(ErrorCodes || (messages$1.ErrorCodes = ErrorCodes = {}));
  class ResponseError extends Error {
    constructor(code2, message, data) {
      super(message);
      this.code = is2.number(code2) ? code2 : ErrorCodes.UnknownErrorCode;
      this.data = data;
      Object.setPrototypeOf(this, ResponseError.prototype);
    }
    toJson() {
      const result2 = {
        code: this.code,
        message: this.message
      };
      if (this.data !== void 0) {
        result2.data = this.data;
      }
      return result2;
    }
  }
  messages$1.ResponseError = ResponseError;
  class ParameterStructures {
    constructor(kind) {
      this.kind = kind;
    }
    static is(value) {
      return value === ParameterStructures.auto || value === ParameterStructures.byName || value === ParameterStructures.byPosition;
    }
    toString() {
      return this.kind;
    }
  }
  messages$1.ParameterStructures = ParameterStructures;
  ParameterStructures.auto = new ParameterStructures("auto");
  ParameterStructures.byPosition = new ParameterStructures("byPosition");
  ParameterStructures.byName = new ParameterStructures("byName");
  class AbstractMessageSignature {
    constructor(method, numberOfParams) {
      this.method = method;
      this.numberOfParams = numberOfParams;
    }
    get parameterStructures() {
      return ParameterStructures.auto;
    }
  }
  messages$1.AbstractMessageSignature = AbstractMessageSignature;
  class RequestType0 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 0);
    }
  }
  messages$1.RequestType0 = RequestType0;
  class RequestType extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1.RequestType = RequestType;
  class RequestType1 extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1.RequestType1 = RequestType1;
  class RequestType2 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 2);
    }
  }
  messages$1.RequestType2 = RequestType2;
  class RequestType3 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 3);
    }
  }
  messages$1.RequestType3 = RequestType3;
  class RequestType4 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 4);
    }
  }
  messages$1.RequestType4 = RequestType4;
  class RequestType5 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 5);
    }
  }
  messages$1.RequestType5 = RequestType5;
  class RequestType6 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 6);
    }
  }
  messages$1.RequestType6 = RequestType6;
  class RequestType7 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 7);
    }
  }
  messages$1.RequestType7 = RequestType7;
  class RequestType8 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 8);
    }
  }
  messages$1.RequestType8 = RequestType8;
  class RequestType9 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 9);
    }
  }
  messages$1.RequestType9 = RequestType9;
  class NotificationType extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1.NotificationType = NotificationType;
  class NotificationType0 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 0);
    }
  }
  messages$1.NotificationType0 = NotificationType0;
  class NotificationType1 extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1.NotificationType1 = NotificationType1;
  class NotificationType2 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 2);
    }
  }
  messages$1.NotificationType2 = NotificationType2;
  class NotificationType3 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 3);
    }
  }
  messages$1.NotificationType3 = NotificationType3;
  class NotificationType4 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 4);
    }
  }
  messages$1.NotificationType4 = NotificationType4;
  class NotificationType5 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 5);
    }
  }
  messages$1.NotificationType5 = NotificationType5;
  class NotificationType6 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 6);
    }
  }
  messages$1.NotificationType6 = NotificationType6;
  class NotificationType7 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 7);
    }
  }
  messages$1.NotificationType7 = NotificationType7;
  class NotificationType8 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 8);
    }
  }
  messages$1.NotificationType8 = NotificationType8;
  class NotificationType9 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 9);
    }
  }
  messages$1.NotificationType9 = NotificationType9;
  var Message;
  (function(Message2) {
    function isRequest(message) {
      const candidate = message;
      return candidate && is2.string(candidate.method) && (is2.string(candidate.id) || is2.number(candidate.id));
    }
    Message2.isRequest = isRequest;
    function isNotification(message) {
      const candidate = message;
      return candidate && is2.string(candidate.method) && message.id === void 0;
    }
    Message2.isNotification = isNotification;
    function isResponse(message) {
      const candidate = message;
      return candidate && (candidate.result !== void 0 || !!candidate.error) && (is2.string(candidate.id) || is2.number(candidate.id) || candidate.id === null);
    }
    Message2.isResponse = isResponse;
  })(Message || (messages$1.Message = Message = {}));
  return messages$1;
}
var linkedMap = {};
var hasRequiredLinkedMap;
function requireLinkedMap() {
  if (hasRequiredLinkedMap) return linkedMap;
  hasRequiredLinkedMap = 1;
  var _a2;
  Object.defineProperty(linkedMap, "__esModule", { value: true });
  linkedMap.LRUCache = linkedMap.LinkedMap = linkedMap.Touch = void 0;
  var Touch;
  (function(Touch2) {
    Touch2.None = 0;
    Touch2.First = 1;
    Touch2.AsOld = Touch2.First;
    Touch2.Last = 2;
    Touch2.AsNew = Touch2.Last;
  })(Touch || (linkedMap.Touch = Touch = {}));
  class LinkedMap {
    constructor() {
      this[_a2] = "LinkedMap";
      this._map = /* @__PURE__ */ new Map();
      this._head = void 0;
      this._tail = void 0;
      this._size = 0;
      this._state = 0;
    }
    clear() {
      this._map.clear();
      this._head = void 0;
      this._tail = void 0;
      this._size = 0;
      this._state++;
    }
    isEmpty() {
      return !this._head && !this._tail;
    }
    get size() {
      return this._size;
    }
    get first() {
      return this._head?.value;
    }
    get last() {
      return this._tail?.value;
    }
    has(key) {
      return this._map.has(key);
    }
    get(key, touch = Touch.None) {
      const item = this._map.get(key);
      if (!item) {
        return void 0;
      }
      if (touch !== Touch.None) {
        this.touch(item, touch);
      }
      return item.value;
    }
    set(key, value, touch = Touch.None) {
      let item = this._map.get(key);
      if (item) {
        item.value = value;
        if (touch !== Touch.None) {
          this.touch(item, touch);
        }
      } else {
        item = { key, value, next: void 0, previous: void 0 };
        switch (touch) {
          case Touch.None:
            this.addItemLast(item);
            break;
          case Touch.First:
            this.addItemFirst(item);
            break;
          case Touch.Last:
            this.addItemLast(item);
            break;
          default:
            this.addItemLast(item);
            break;
        }
        this._map.set(key, item);
        this._size++;
      }
      return this;
    }
    delete(key) {
      return !!this.remove(key);
    }
    remove(key) {
      const item = this._map.get(key);
      if (!item) {
        return void 0;
      }
      this._map.delete(key);
      this.removeItem(item);
      this._size--;
      return item.value;
    }
    shift() {
      if (!this._head && !this._tail) {
        return void 0;
      }
      if (!this._head || !this._tail) {
        throw new Error("Invalid list");
      }
      const item = this._head;
      this._map.delete(item.key);
      this.removeItem(item);
      this._size--;
      return item.value;
    }
    forEach(callbackfn, thisArg) {
      const state = this._state;
      let current2 = this._head;
      while (current2) {
        if (thisArg) {
          callbackfn.bind(thisArg)(current2.value, current2.key, this);
        } else {
          callbackfn(current2.value, current2.key, this);
        }
        if (this._state !== state) {
          throw new Error(`LinkedMap got modified during iteration.`);
        }
        current2 = current2.next;
      }
    }
    keys() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: current2.key, done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    values() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: current2.value, done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    entries() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: [current2.key, current2.value], done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    [(_a2 = Symbol.toStringTag, Symbol.iterator)]() {
      return this.entries();
    }
    trimOld(newSize) {
      if (newSize >= this.size) {
        return;
      }
      if (newSize === 0) {
        this.clear();
        return;
      }
      let current2 = this._head;
      let currentSize = this.size;
      while (current2 && currentSize > newSize) {
        this._map.delete(current2.key);
        current2 = current2.next;
        currentSize--;
      }
      this._head = current2;
      this._size = currentSize;
      if (current2) {
        current2.previous = void 0;
      }
      this._state++;
    }
    addItemFirst(item) {
      if (!this._head && !this._tail) {
        this._tail = item;
      } else if (!this._head) {
        throw new Error("Invalid list");
      } else {
        item.next = this._head;
        this._head.previous = item;
      }
      this._head = item;
      this._state++;
    }
    addItemLast(item) {
      if (!this._head && !this._tail) {
        this._head = item;
      } else if (!this._tail) {
        throw new Error("Invalid list");
      } else {
        item.previous = this._tail;
        this._tail.next = item;
      }
      this._tail = item;
      this._state++;
    }
    removeItem(item) {
      if (item === this._head && item === this._tail) {
        this._head = void 0;
        this._tail = void 0;
      } else if (item === this._head) {
        if (!item.next) {
          throw new Error("Invalid list");
        }
        item.next.previous = void 0;
        this._head = item.next;
      } else if (item === this._tail) {
        if (!item.previous) {
          throw new Error("Invalid list");
        }
        item.previous.next = void 0;
        this._tail = item.previous;
      } else {
        const next = item.next;
        const previous2 = item.previous;
        if (!next || !previous2) {
          throw new Error("Invalid list");
        }
        next.previous = previous2;
        previous2.next = next;
      }
      item.next = void 0;
      item.previous = void 0;
      this._state++;
    }
    touch(item, touch) {
      if (!this._head || !this._tail) {
        throw new Error("Invalid list");
      }
      if (touch !== Touch.First && touch !== Touch.Last) {
        return;
      }
      if (touch === Touch.First) {
        if (item === this._head) {
          return;
        }
        const next = item.next;
        const previous2 = item.previous;
        if (item === this._tail) {
          previous2.next = void 0;
          this._tail = previous2;
        } else {
          next.previous = previous2;
          previous2.next = next;
        }
        item.previous = void 0;
        item.next = this._head;
        this._head.previous = item;
        this._head = item;
        this._state++;
      } else if (touch === Touch.Last) {
        if (item === this._tail) {
          return;
        }
        const next = item.next;
        const previous2 = item.previous;
        if (item === this._head) {
          next.previous = void 0;
          this._head = next;
        } else {
          next.previous = previous2;
          previous2.next = next;
        }
        item.next = void 0;
        item.previous = this._tail;
        this._tail.next = item;
        this._tail = item;
        this._state++;
      }
    }
    toJSON() {
      const data = [];
      this.forEach((value, key) => {
        data.push([key, value]);
      });
      return data;
    }
    fromJSON(data) {
      this.clear();
      for (const [key, value] of data) {
        this.set(key, value);
      }
    }
  }
  linkedMap.LinkedMap = LinkedMap;
  class LRUCache extends LinkedMap {
    constructor(limit, ratio = 1) {
      super();
      this._limit = limit;
      this._ratio = Math.min(Math.max(0, ratio), 1);
    }
    get limit() {
      return this._limit;
    }
    set limit(limit) {
      this._limit = limit;
      this.checkTrim();
    }
    get ratio() {
      return this._ratio;
    }
    set ratio(ratio) {
      this._ratio = Math.min(Math.max(0, ratio), 1);
      this.checkTrim();
    }
    get(key, touch = Touch.AsNew) {
      return super.get(key, touch);
    }
    peek(key) {
      return super.get(key, Touch.None);
    }
    set(key, value) {
      super.set(key, value, Touch.Last);
      this.checkTrim();
      return this;
    }
    checkTrim() {
      if (this.size > this._limit) {
        this.trimOld(Math.round(this._limit * this._ratio));
      }
    }
  }
  linkedMap.LRUCache = LRUCache;
  return linkedMap;
}
var disposable = {};
var hasRequiredDisposable;
function requireDisposable() {
  if (hasRequiredDisposable) return disposable;
  hasRequiredDisposable = 1;
  Object.defineProperty(disposable, "__esModule", { value: true });
  disposable.Disposable = void 0;
  var Disposable;
  (function(Disposable2) {
    function create2(func) {
      return {
        dispose: func
      };
    }
    Disposable2.create = create2;
  })(Disposable || (disposable.Disposable = Disposable = {}));
  return disposable;
}
var events = {};
var ral = {};
var hasRequiredRal;
function requireRal() {
  if (hasRequiredRal) return ral;
  hasRequiredRal = 1;
  Object.defineProperty(ral, "__esModule", { value: true });
  let _ral;
  function RAL() {
    if (_ral === void 0) {
      throw new Error(`No runtime abstraction layer installed`);
    }
    return _ral;
  }
  (function(RAL2) {
    function install(ral2) {
      if (ral2 === void 0) {
        throw new Error(`No runtime abstraction layer provided`);
      }
      _ral = ral2;
    }
    RAL2.install = install;
  })(RAL || (RAL = {}));
  ral.default = RAL;
  return ral;
}
var hasRequiredEvents;
function requireEvents() {
  if (hasRequiredEvents) return events;
  hasRequiredEvents = 1;
  Object.defineProperty(events, "__esModule", { value: true });
  events.Emitter = events.Event = void 0;
  const ral_1 = requireRal();
  var Event2;
  (function(Event22) {
    const _disposable = { dispose() {
    } };
    Event22.None = function() {
      return _disposable;
    };
  })(Event2 || (events.Event = Event2 = {}));
  class CallbackList {
    add(callback, context = null, bucket) {
      if (!this._callbacks) {
        this._callbacks = [];
        this._contexts = [];
      }
      this._callbacks.push(callback);
      this._contexts.push(context);
      if (Array.isArray(bucket)) {
        bucket.push({ dispose: () => this.remove(callback, context) });
      }
    }
    remove(callback, context = null) {
      if (!this._callbacks) {
        return;
      }
      let foundCallbackWithDifferentContext = false;
      for (let i2 = 0, len = this._callbacks.length; i2 < len; i2++) {
        if (this._callbacks[i2] === callback) {
          if (this._contexts[i2] === context) {
            this._callbacks.splice(i2, 1);
            this._contexts.splice(i2, 1);
            return;
          } else {
            foundCallbackWithDifferentContext = true;
          }
        }
      }
      if (foundCallbackWithDifferentContext) {
        throw new Error("When adding a listener with a context, you should remove it with the same context");
      }
    }
    invoke(...args) {
      if (!this._callbacks) {
        return [];
      }
      const ret = [], callbacks = this._callbacks.slice(0), contexts = this._contexts.slice(0);
      for (let i2 = 0, len = callbacks.length; i2 < len; i2++) {
        try {
          ret.push(callbacks[i2].apply(contexts[i2], args));
        } catch (e2) {
          (0, ral_1.default)().console.error(e2);
        }
      }
      return ret;
    }
    isEmpty() {
      return !this._callbacks || this._callbacks.length === 0;
    }
    dispose() {
      this._callbacks = void 0;
      this._contexts = void 0;
    }
  }
  class Emitter2 {
    constructor(_options) {
      this._options = _options;
    }
    /**
     * For the public to allow to subscribe
     * to events from this Emitter
     */
    get event() {
      if (!this._event) {
        this._event = (listener, thisArgs, disposables) => {
          if (!this._callbacks) {
            this._callbacks = new CallbackList();
          }
          if (this._options && this._options.onFirstListenerAdd && this._callbacks.isEmpty()) {
            this._options.onFirstListenerAdd(this);
          }
          this._callbacks.add(listener, thisArgs);
          const result2 = {
            dispose: () => {
              if (!this._callbacks) {
                return;
              }
              this._callbacks.remove(listener, thisArgs);
              result2.dispose = Emitter2._noop;
              if (this._options && this._options.onLastListenerRemove && this._callbacks.isEmpty()) {
                this._options.onLastListenerRemove(this);
              }
            }
          };
          if (Array.isArray(disposables)) {
            disposables.push(result2);
          }
          return result2;
        };
      }
      return this._event;
    }
    /**
     * To be kept private to fire an event to
     * subscribers
     */
    fire(event) {
      if (this._callbacks) {
        this._callbacks.invoke.call(this._callbacks, event);
      }
    }
    dispose() {
      if (this._callbacks) {
        this._callbacks.dispose();
        this._callbacks = void 0;
      }
    }
  }
  events.Emitter = Emitter2;
  Emitter2._noop = function() {
  };
  return events;
}
var cancellation = {};
var hasRequiredCancellation;
function requireCancellation() {
  if (hasRequiredCancellation) return cancellation;
  hasRequiredCancellation = 1;
  Object.defineProperty(cancellation, "__esModule", { value: true });
  cancellation.CancellationTokenSource = cancellation.CancellationToken = void 0;
  const ral_1 = requireRal();
  const Is2 = requireIs$1();
  const events_1 = requireEvents();
  var CancellationToken;
  (function(CancellationToken2) {
    CancellationToken2.None = Object.freeze({
      isCancellationRequested: false,
      onCancellationRequested: events_1.Event.None
    });
    CancellationToken2.Cancelled = Object.freeze({
      isCancellationRequested: true,
      onCancellationRequested: events_1.Event.None
    });
    function is2(value) {
      const candidate = value;
      return candidate && (candidate === CancellationToken2.None || candidate === CancellationToken2.Cancelled || Is2.boolean(candidate.isCancellationRequested) && !!candidate.onCancellationRequested);
    }
    CancellationToken2.is = is2;
  })(CancellationToken || (cancellation.CancellationToken = CancellationToken = {}));
  const shortcutEvent = Object.freeze(function(callback, context) {
    const handle = (0, ral_1.default)().timer.setTimeout(callback.bind(context), 0);
    return { dispose() {
      handle.dispose();
    } };
  });
  class MutableToken {
    constructor() {
      this._isCancelled = false;
    }
    cancel() {
      if (!this._isCancelled) {
        this._isCancelled = true;
        if (this._emitter) {
          this._emitter.fire(void 0);
          this.dispose();
        }
      }
    }
    get isCancellationRequested() {
      return this._isCancelled;
    }
    get onCancellationRequested() {
      if (this._isCancelled) {
        return shortcutEvent;
      }
      if (!this._emitter) {
        this._emitter = new events_1.Emitter();
      }
      return this._emitter.event;
    }
    dispose() {
      if (this._emitter) {
        this._emitter.dispose();
        this._emitter = void 0;
      }
    }
  }
  class CancellationTokenSource {
    get token() {
      if (!this._token) {
        this._token = new MutableToken();
      }
      return this._token;
    }
    cancel() {
      if (!this._token) {
        this._token = CancellationToken.Cancelled;
      } else {
        this._token.cancel();
      }
    }
    dispose() {
      if (!this._token) {
        this._token = CancellationToken.None;
      } else if (this._token instanceof MutableToken) {
        this._token.dispose();
      }
    }
  }
  cancellation.CancellationTokenSource = CancellationTokenSource;
  return cancellation;
}
var sharedArrayCancellation = {};
var hasRequiredSharedArrayCancellation;
function requireSharedArrayCancellation() {
  if (hasRequiredSharedArrayCancellation) return sharedArrayCancellation;
  hasRequiredSharedArrayCancellation = 1;
  Object.defineProperty(sharedArrayCancellation, "__esModule", { value: true });
  sharedArrayCancellation.SharedArrayReceiverStrategy = sharedArrayCancellation.SharedArraySenderStrategy = void 0;
  const cancellation_1 = requireCancellation();
  var CancellationState;
  (function(CancellationState2) {
    CancellationState2.Continue = 0;
    CancellationState2.Cancelled = 1;
  })(CancellationState || (CancellationState = {}));
  class SharedArraySenderStrategy {
    constructor() {
      this.buffers = /* @__PURE__ */ new Map();
    }
    enableCancellation(request) {
      if (request.id === null) {
        return;
      }
      const buffer = new SharedArrayBuffer(4);
      const data = new Int32Array(buffer, 0, 1);
      data[0] = CancellationState.Continue;
      this.buffers.set(request.id, buffer);
      request.$cancellationData = buffer;
    }
    async sendCancellation(_conn, id2) {
      const buffer = this.buffers.get(id2);
      if (buffer === void 0) {
        return;
      }
      const data = new Int32Array(buffer, 0, 1);
      Atomics.store(data, 0, CancellationState.Cancelled);
    }
    cleanup(id2) {
      this.buffers.delete(id2);
    }
    dispose() {
      this.buffers.clear();
    }
  }
  sharedArrayCancellation.SharedArraySenderStrategy = SharedArraySenderStrategy;
  class SharedArrayBufferCancellationToken {
    constructor(buffer) {
      this.data = new Int32Array(buffer, 0, 1);
    }
    get isCancellationRequested() {
      return Atomics.load(this.data, 0) === CancellationState.Cancelled;
    }
    get onCancellationRequested() {
      throw new Error(`Cancellation over SharedArrayBuffer doesn't support cancellation events`);
    }
  }
  class SharedArrayBufferCancellationTokenSource {
    constructor(buffer) {
      this.token = new SharedArrayBufferCancellationToken(buffer);
    }
    cancel() {
    }
    dispose() {
    }
  }
  class SharedArrayReceiverStrategy {
    constructor() {
      this.kind = "request";
    }
    createCancellationTokenSource(request) {
      const buffer = request.$cancellationData;
      if (buffer === void 0) {
        return new cancellation_1.CancellationTokenSource();
      }
      return new SharedArrayBufferCancellationTokenSource(buffer);
    }
  }
  sharedArrayCancellation.SharedArrayReceiverStrategy = SharedArrayReceiverStrategy;
  return sharedArrayCancellation;
}
var messageReader = {};
var semaphore = {};
var hasRequiredSemaphore;
function requireSemaphore() {
  if (hasRequiredSemaphore) return semaphore;
  hasRequiredSemaphore = 1;
  Object.defineProperty(semaphore, "__esModule", { value: true });
  semaphore.Semaphore = void 0;
  const ral_1 = requireRal();
  class Semaphore {
    constructor(capacity = 1) {
      if (capacity <= 0) {
        throw new Error("Capacity must be greater than 0");
      }
      this._capacity = capacity;
      this._active = 0;
      this._waiting = [];
    }
    lock(thunk2) {
      return new Promise((resolve, reject2) => {
        this._waiting.push({ thunk: thunk2, resolve, reject: reject2 });
        this.runNext();
      });
    }
    get active() {
      return this._active;
    }
    runNext() {
      if (this._waiting.length === 0 || this._active === this._capacity) {
        return;
      }
      (0, ral_1.default)().timer.setImmediate(() => this.doRunNext());
    }
    doRunNext() {
      if (this._waiting.length === 0 || this._active === this._capacity) {
        return;
      }
      const next = this._waiting.shift();
      this._active++;
      if (this._active > this._capacity) {
        throw new Error(`To many thunks active`);
      }
      try {
        const result2 = next.thunk();
        if (result2 instanceof Promise) {
          result2.then((value) => {
            this._active--;
            next.resolve(value);
            this.runNext();
          }, (err) => {
            this._active--;
            next.reject(err);
            this.runNext();
          });
        } else {
          this._active--;
          next.resolve(result2);
          this.runNext();
        }
      } catch (err) {
        this._active--;
        next.reject(err);
        this.runNext();
      }
    }
  }
  semaphore.Semaphore = Semaphore;
  return semaphore;
}
var hasRequiredMessageReader;
function requireMessageReader() {
  if (hasRequiredMessageReader) return messageReader;
  hasRequiredMessageReader = 1;
  Object.defineProperty(messageReader, "__esModule", { value: true });
  messageReader.ReadableStreamMessageReader = messageReader.AbstractMessageReader = messageReader.MessageReader = void 0;
  const ral_1 = requireRal();
  const Is2 = requireIs$1();
  const events_1 = requireEvents();
  const semaphore_1 = requireSemaphore();
  var MessageReader;
  (function(MessageReader2) {
    function is2(value) {
      let candidate = value;
      return candidate && Is2.func(candidate.listen) && Is2.func(candidate.dispose) && Is2.func(candidate.onError) && Is2.func(candidate.onClose) && Is2.func(candidate.onPartialMessage);
    }
    MessageReader2.is = is2;
  })(MessageReader || (messageReader.MessageReader = MessageReader = {}));
  class AbstractMessageReader {
    constructor() {
      this.errorEmitter = new events_1.Emitter();
      this.closeEmitter = new events_1.Emitter();
      this.partialMessageEmitter = new events_1.Emitter();
    }
    dispose() {
      this.errorEmitter.dispose();
      this.closeEmitter.dispose();
    }
    get onError() {
      return this.errorEmitter.event;
    }
    fireError(error) {
      this.errorEmitter.fire(this.asError(error));
    }
    get onClose() {
      return this.closeEmitter.event;
    }
    fireClose() {
      this.closeEmitter.fire(void 0);
    }
    get onPartialMessage() {
      return this.partialMessageEmitter.event;
    }
    firePartialMessage(info) {
      this.partialMessageEmitter.fire(info);
    }
    asError(error) {
      if (error instanceof Error) {
        return error;
      } else {
        return new Error(`Reader received error. Reason: ${Is2.string(error.message) ? error.message : "unknown"}`);
      }
    }
  }
  messageReader.AbstractMessageReader = AbstractMessageReader;
  var ResolvedMessageReaderOptions;
  (function(ResolvedMessageReaderOptions2) {
    function fromOptions(options2) {
      let charset;
      let contentDecoder;
      const contentDecoders = /* @__PURE__ */ new Map();
      let contentTypeDecoder;
      const contentTypeDecoders = /* @__PURE__ */ new Map();
      if (options2 === void 0 || typeof options2 === "string") {
        charset = options2 ?? "utf-8";
      } else {
        charset = options2.charset ?? "utf-8";
        if (options2.contentDecoder !== void 0) {
          contentDecoder = options2.contentDecoder;
          contentDecoders.set(contentDecoder.name, contentDecoder);
        }
        if (options2.contentDecoders !== void 0) {
          for (const decoder of options2.contentDecoders) {
            contentDecoders.set(decoder.name, decoder);
          }
        }
        if (options2.contentTypeDecoder !== void 0) {
          contentTypeDecoder = options2.contentTypeDecoder;
          contentTypeDecoders.set(contentTypeDecoder.name, contentTypeDecoder);
        }
        if (options2.contentTypeDecoders !== void 0) {
          for (const decoder of options2.contentTypeDecoders) {
            contentTypeDecoders.set(decoder.name, decoder);
          }
        }
      }
      if (contentTypeDecoder === void 0) {
        contentTypeDecoder = (0, ral_1.default)().applicationJson.decoder;
        contentTypeDecoders.set(contentTypeDecoder.name, contentTypeDecoder);
      }
      return { charset, contentDecoder, contentDecoders, contentTypeDecoder, contentTypeDecoders };
    }
    ResolvedMessageReaderOptions2.fromOptions = fromOptions;
  })(ResolvedMessageReaderOptions || (ResolvedMessageReaderOptions = {}));
  class ReadableStreamMessageReader extends AbstractMessageReader {
    constructor(readable, options2) {
      super();
      this.readable = readable;
      this.options = ResolvedMessageReaderOptions.fromOptions(options2);
      this.buffer = (0, ral_1.default)().messageBuffer.create(this.options.charset);
      this._partialMessageTimeout = 1e4;
      this.nextMessageLength = -1;
      this.messageToken = 0;
      this.readSemaphore = new semaphore_1.Semaphore(1);
    }
    set partialMessageTimeout(timeout) {
      this._partialMessageTimeout = timeout;
    }
    get partialMessageTimeout() {
      return this._partialMessageTimeout;
    }
    listen(callback) {
      this.nextMessageLength = -1;
      this.messageToken = 0;
      this.partialMessageTimer = void 0;
      this.callback = callback;
      const result2 = this.readable.onData((data) => {
        this.onData(data);
      });
      this.readable.onError((error) => this.fireError(error));
      this.readable.onClose(() => this.fireClose());
      return result2;
    }
    onData(data) {
      try {
        this.buffer.append(data);
        while (true) {
          if (this.nextMessageLength === -1) {
            const headers = this.buffer.tryReadHeaders(true);
            if (!headers) {
              return;
            }
            const contentLength = headers.get("content-length");
            if (!contentLength) {
              this.fireError(new Error(`Header must provide a Content-Length property.
${JSON.stringify(Object.fromEntries(headers))}`));
              return;
            }
            const length = parseInt(contentLength);
            if (isNaN(length)) {
              this.fireError(new Error(`Content-Length value must be a number. Got ${contentLength}`));
              return;
            }
            this.nextMessageLength = length;
          }
          const body = this.buffer.tryReadBody(this.nextMessageLength);
          if (body === void 0) {
            this.setPartialMessageTimer();
            return;
          }
          this.clearPartialMessageTimer();
          this.nextMessageLength = -1;
          this.readSemaphore.lock(async () => {
            const bytes = this.options.contentDecoder !== void 0 ? await this.options.contentDecoder.decode(body) : body;
            const message = await this.options.contentTypeDecoder.decode(bytes, this.options);
            this.callback(message);
          }).catch((error) => {
            this.fireError(error);
          });
        }
      } catch (error) {
        this.fireError(error);
      }
    }
    clearPartialMessageTimer() {
      if (this.partialMessageTimer) {
        this.partialMessageTimer.dispose();
        this.partialMessageTimer = void 0;
      }
    }
    setPartialMessageTimer() {
      this.clearPartialMessageTimer();
      if (this._partialMessageTimeout <= 0) {
        return;
      }
      this.partialMessageTimer = (0, ral_1.default)().timer.setTimeout((token, timeout) => {
        this.partialMessageTimer = void 0;
        if (token === this.messageToken) {
          this.firePartialMessage({ messageToken: token, waitingTime: timeout });
          this.setPartialMessageTimer();
        }
      }, this._partialMessageTimeout, this.messageToken, this._partialMessageTimeout);
    }
  }
  messageReader.ReadableStreamMessageReader = ReadableStreamMessageReader;
  return messageReader;
}
var messageWriter = {};
var hasRequiredMessageWriter;
function requireMessageWriter() {
  if (hasRequiredMessageWriter) return messageWriter;
  hasRequiredMessageWriter = 1;
  Object.defineProperty(messageWriter, "__esModule", { value: true });
  messageWriter.WriteableStreamMessageWriter = messageWriter.AbstractMessageWriter = messageWriter.MessageWriter = void 0;
  const ral_1 = requireRal();
  const Is2 = requireIs$1();
  const semaphore_1 = requireSemaphore();
  const events_1 = requireEvents();
  const ContentLength = "Content-Length: ";
  const CRLF = "\r\n";
  var MessageWriter;
  (function(MessageWriter2) {
    function is2(value) {
      let candidate = value;
      return candidate && Is2.func(candidate.dispose) && Is2.func(candidate.onClose) && Is2.func(candidate.onError) && Is2.func(candidate.write);
    }
    MessageWriter2.is = is2;
  })(MessageWriter || (messageWriter.MessageWriter = MessageWriter = {}));
  class AbstractMessageWriter {
    constructor() {
      this.errorEmitter = new events_1.Emitter();
      this.closeEmitter = new events_1.Emitter();
    }
    dispose() {
      this.errorEmitter.dispose();
      this.closeEmitter.dispose();
    }
    get onError() {
      return this.errorEmitter.event;
    }
    fireError(error, message, count) {
      this.errorEmitter.fire([this.asError(error), message, count]);
    }
    get onClose() {
      return this.closeEmitter.event;
    }
    fireClose() {
      this.closeEmitter.fire(void 0);
    }
    asError(error) {
      if (error instanceof Error) {
        return error;
      } else {
        return new Error(`Writer received error. Reason: ${Is2.string(error.message) ? error.message : "unknown"}`);
      }
    }
  }
  messageWriter.AbstractMessageWriter = AbstractMessageWriter;
  var ResolvedMessageWriterOptions;
  (function(ResolvedMessageWriterOptions2) {
    function fromOptions(options2) {
      if (options2 === void 0 || typeof options2 === "string") {
        return { charset: options2 ?? "utf-8", contentTypeEncoder: (0, ral_1.default)().applicationJson.encoder };
      } else {
        return { charset: options2.charset ?? "utf-8", contentEncoder: options2.contentEncoder, contentTypeEncoder: options2.contentTypeEncoder ?? (0, ral_1.default)().applicationJson.encoder };
      }
    }
    ResolvedMessageWriterOptions2.fromOptions = fromOptions;
  })(ResolvedMessageWriterOptions || (ResolvedMessageWriterOptions = {}));
  class WriteableStreamMessageWriter extends AbstractMessageWriter {
    constructor(writable, options2) {
      super();
      this.writable = writable;
      this.options = ResolvedMessageWriterOptions.fromOptions(options2);
      this.errorCount = 0;
      this.writeSemaphore = new semaphore_1.Semaphore(1);
      this.writable.onError((error) => this.fireError(error));
      this.writable.onClose(() => this.fireClose());
    }
    async write(msg) {
      return this.writeSemaphore.lock(async () => {
        const payload = this.options.contentTypeEncoder.encode(msg, this.options).then((buffer) => {
          if (this.options.contentEncoder !== void 0) {
            return this.options.contentEncoder.encode(buffer);
          } else {
            return buffer;
          }
        });
        return payload.then((buffer) => {
          const headers = [];
          headers.push(ContentLength, buffer.byteLength.toString(), CRLF);
          headers.push(CRLF);
          return this.doWrite(msg, headers, buffer);
        }, (error) => {
          this.fireError(error);
          throw error;
        });
      });
    }
    async doWrite(msg, headers, data) {
      try {
        await this.writable.write(headers.join(""), "ascii");
        return this.writable.write(data);
      } catch (error) {
        this.handleError(error, msg);
        return Promise.reject(error);
      }
    }
    handleError(error, msg) {
      this.errorCount++;
      this.fireError(error, msg, this.errorCount);
    }
    end() {
      this.writable.end();
    }
  }
  messageWriter.WriteableStreamMessageWriter = WriteableStreamMessageWriter;
  return messageWriter;
}
var messageBuffer = {};
var hasRequiredMessageBuffer;
function requireMessageBuffer() {
  if (hasRequiredMessageBuffer) return messageBuffer;
  hasRequiredMessageBuffer = 1;
  Object.defineProperty(messageBuffer, "__esModule", { value: true });
  messageBuffer.AbstractMessageBuffer = void 0;
  const CR = 13;
  const LF = 10;
  const CRLF = "\r\n";
  class AbstractMessageBuffer {
    constructor(encoding = "utf-8") {
      this._encoding = encoding;
      this._chunks = [];
      this._totalLength = 0;
    }
    get encoding() {
      return this._encoding;
    }
    append(chunk2) {
      const toAppend = typeof chunk2 === "string" ? this.fromString(chunk2, this._encoding) : chunk2;
      this._chunks.push(toAppend);
      this._totalLength += toAppend.byteLength;
    }
    tryReadHeaders(lowerCaseKeys = false) {
      if (this._chunks.length === 0) {
        return void 0;
      }
      let state = 0;
      let chunkIndex = 0;
      let offset2 = 0;
      let chunkBytesRead = 0;
      row: while (chunkIndex < this._chunks.length) {
        const chunk2 = this._chunks[chunkIndex];
        offset2 = 0;
        while (offset2 < chunk2.length) {
          const value = chunk2[offset2];
          switch (value) {
            case CR:
              switch (state) {
                case 0:
                  state = 1;
                  break;
                case 2:
                  state = 3;
                  break;
                default:
                  state = 0;
              }
              break;
            case LF:
              switch (state) {
                case 1:
                  state = 2;
                  break;
                case 3:
                  state = 4;
                  offset2++;
                  break row;
                default:
                  state = 0;
              }
              break;
            default:
              state = 0;
          }
          offset2++;
        }
        chunkBytesRead += chunk2.byteLength;
        chunkIndex++;
      }
      if (state !== 4) {
        return void 0;
      }
      const buffer = this._read(chunkBytesRead + offset2);
      const result2 = /* @__PURE__ */ new Map();
      const headers = this.toString(buffer, "ascii").split(CRLF);
      if (headers.length < 2) {
        return result2;
      }
      for (let i2 = 0; i2 < headers.length - 2; i2++) {
        const header = headers[i2];
        const index2 = header.indexOf(":");
        if (index2 === -1) {
          throw new Error(`Message header must separate key and value using ':'
${header}`);
        }
        const key = header.substr(0, index2);
        const value = header.substr(index2 + 1).trim();
        result2.set(lowerCaseKeys ? key.toLowerCase() : key, value);
      }
      return result2;
    }
    tryReadBody(length) {
      if (this._totalLength < length) {
        return void 0;
      }
      return this._read(length);
    }
    get numberOfBytes() {
      return this._totalLength;
    }
    _read(byteCount) {
      if (byteCount === 0) {
        return this.emptyBuffer();
      }
      if (byteCount > this._totalLength) {
        throw new Error(`Cannot read so many bytes!`);
      }
      if (this._chunks[0].byteLength === byteCount) {
        const chunk2 = this._chunks[0];
        this._chunks.shift();
        this._totalLength -= byteCount;
        return this.asNative(chunk2);
      }
      if (this._chunks[0].byteLength > byteCount) {
        const chunk2 = this._chunks[0];
        const result22 = this.asNative(chunk2, byteCount);
        this._chunks[0] = chunk2.slice(byteCount);
        this._totalLength -= byteCount;
        return result22;
      }
      const result2 = this.allocNative(byteCount);
      let resultOffset = 0;
      let chunkIndex = 0;
      while (byteCount > 0) {
        const chunk2 = this._chunks[chunkIndex];
        if (chunk2.byteLength > byteCount) {
          const chunkPart = chunk2.slice(0, byteCount);
          result2.set(chunkPart, resultOffset);
          resultOffset += byteCount;
          this._chunks[chunkIndex] = chunk2.slice(byteCount);
          this._totalLength -= byteCount;
          byteCount -= byteCount;
        } else {
          result2.set(chunk2, resultOffset);
          resultOffset += chunk2.byteLength;
          this._chunks.shift();
          this._totalLength -= chunk2.byteLength;
          byteCount -= chunk2.byteLength;
        }
      }
      return result2;
    }
  }
  messageBuffer.AbstractMessageBuffer = AbstractMessageBuffer;
  return messageBuffer;
}
var connection$1 = {};
var hasRequiredConnection$1;
function requireConnection$1() {
  if (hasRequiredConnection$1) return connection$1;
  hasRequiredConnection$1 = 1;
  (function(exports$12) {
    Object.defineProperty(exports$12, "__esModule", { value: true });
    exports$12.createMessageConnection = exports$12.ConnectionOptions = exports$12.MessageStrategy = exports$12.CancellationStrategy = exports$12.CancellationSenderStrategy = exports$12.CancellationReceiverStrategy = exports$12.RequestCancellationReceiverStrategy = exports$12.IdCancellationReceiverStrategy = exports$12.ConnectionStrategy = exports$12.ConnectionError = exports$12.ConnectionErrors = exports$12.LogTraceNotification = exports$12.SetTraceNotification = exports$12.TraceFormat = exports$12.TraceValues = exports$12.Trace = exports$12.NullLogger = exports$12.ProgressType = exports$12.ProgressToken = void 0;
    const ral_1 = requireRal();
    const Is2 = requireIs$1();
    const messages_1 = requireMessages$1();
    const linkedMap_1 = requireLinkedMap();
    const events_1 = requireEvents();
    const cancellation_1 = requireCancellation();
    var CancelNotification;
    (function(CancelNotification2) {
      CancelNotification2.type = new messages_1.NotificationType("$/cancelRequest");
    })(CancelNotification || (CancelNotification = {}));
    var ProgressToken;
    (function(ProgressToken2) {
      function is2(value) {
        return typeof value === "string" || typeof value === "number";
      }
      ProgressToken2.is = is2;
    })(ProgressToken || (exports$12.ProgressToken = ProgressToken = {}));
    var ProgressNotification;
    (function(ProgressNotification2) {
      ProgressNotification2.type = new messages_1.NotificationType("$/progress");
    })(ProgressNotification || (ProgressNotification = {}));
    class ProgressType {
      constructor() {
      }
    }
    exports$12.ProgressType = ProgressType;
    var StarRequestHandler;
    (function(StarRequestHandler2) {
      function is2(value) {
        return Is2.func(value);
      }
      StarRequestHandler2.is = is2;
    })(StarRequestHandler || (StarRequestHandler = {}));
    exports$12.NullLogger = Object.freeze({
      error: () => {
      },
      warn: () => {
      },
      info: () => {
      },
      log: () => {
      }
    });
    var Trace;
    (function(Trace2) {
      Trace2[Trace2["Off"] = 0] = "Off";
      Trace2[Trace2["Messages"] = 1] = "Messages";
      Trace2[Trace2["Compact"] = 2] = "Compact";
      Trace2[Trace2["Verbose"] = 3] = "Verbose";
    })(Trace || (exports$12.Trace = Trace = {}));
    var TraceValues;
    (function(TraceValues2) {
      TraceValues2.Off = "off";
      TraceValues2.Messages = "messages";
      TraceValues2.Compact = "compact";
      TraceValues2.Verbose = "verbose";
    })(TraceValues || (exports$12.TraceValues = TraceValues = {}));
    (function(Trace2) {
      function fromString(value) {
        if (!Is2.string(value)) {
          return Trace2.Off;
        }
        value = value.toLowerCase();
        switch (value) {
          case "off":
            return Trace2.Off;
          case "messages":
            return Trace2.Messages;
          case "compact":
            return Trace2.Compact;
          case "verbose":
            return Trace2.Verbose;
          default:
            return Trace2.Off;
        }
      }
      Trace2.fromString = fromString;
      function toString2(value) {
        switch (value) {
          case Trace2.Off:
            return "off";
          case Trace2.Messages:
            return "messages";
          case Trace2.Compact:
            return "compact";
          case Trace2.Verbose:
            return "verbose";
          default:
            return "off";
        }
      }
      Trace2.toString = toString2;
    })(Trace || (exports$12.Trace = Trace = {}));
    var TraceFormat;
    (function(TraceFormat2) {
      TraceFormat2["Text"] = "text";
      TraceFormat2["JSON"] = "json";
    })(TraceFormat || (exports$12.TraceFormat = TraceFormat = {}));
    (function(TraceFormat2) {
      function fromString(value) {
        if (!Is2.string(value)) {
          return TraceFormat2.Text;
        }
        value = value.toLowerCase();
        if (value === "json") {
          return TraceFormat2.JSON;
        } else {
          return TraceFormat2.Text;
        }
      }
      TraceFormat2.fromString = fromString;
    })(TraceFormat || (exports$12.TraceFormat = TraceFormat = {}));
    var SetTraceNotification;
    (function(SetTraceNotification2) {
      SetTraceNotification2.type = new messages_1.NotificationType("$/setTrace");
    })(SetTraceNotification || (exports$12.SetTraceNotification = SetTraceNotification = {}));
    var LogTraceNotification;
    (function(LogTraceNotification2) {
      LogTraceNotification2.type = new messages_1.NotificationType("$/logTrace");
    })(LogTraceNotification || (exports$12.LogTraceNotification = LogTraceNotification = {}));
    var ConnectionErrors;
    (function(ConnectionErrors2) {
      ConnectionErrors2[ConnectionErrors2["Closed"] = 1] = "Closed";
      ConnectionErrors2[ConnectionErrors2["Disposed"] = 2] = "Disposed";
      ConnectionErrors2[ConnectionErrors2["AlreadyListening"] = 3] = "AlreadyListening";
    })(ConnectionErrors || (exports$12.ConnectionErrors = ConnectionErrors = {}));
    class ConnectionError extends Error {
      constructor(code2, message) {
        super(message);
        this.code = code2;
        Object.setPrototypeOf(this, ConnectionError.prototype);
      }
    }
    exports$12.ConnectionError = ConnectionError;
    var ConnectionStrategy;
    (function(ConnectionStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.cancelUndispatched);
      }
      ConnectionStrategy2.is = is2;
    })(ConnectionStrategy || (exports$12.ConnectionStrategy = ConnectionStrategy = {}));
    var IdCancellationReceiverStrategy;
    (function(IdCancellationReceiverStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && (candidate.kind === void 0 || candidate.kind === "id") && Is2.func(candidate.createCancellationTokenSource) && (candidate.dispose === void 0 || Is2.func(candidate.dispose));
      }
      IdCancellationReceiverStrategy2.is = is2;
    })(IdCancellationReceiverStrategy || (exports$12.IdCancellationReceiverStrategy = IdCancellationReceiverStrategy = {}));
    var RequestCancellationReceiverStrategy;
    (function(RequestCancellationReceiverStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && candidate.kind === "request" && Is2.func(candidate.createCancellationTokenSource) && (candidate.dispose === void 0 || Is2.func(candidate.dispose));
      }
      RequestCancellationReceiverStrategy2.is = is2;
    })(RequestCancellationReceiverStrategy || (exports$12.RequestCancellationReceiverStrategy = RequestCancellationReceiverStrategy = {}));
    var CancellationReceiverStrategy;
    (function(CancellationReceiverStrategy2) {
      CancellationReceiverStrategy2.Message = Object.freeze({
        createCancellationTokenSource(_2) {
          return new cancellation_1.CancellationTokenSource();
        }
      });
      function is2(value) {
        return IdCancellationReceiverStrategy.is(value) || RequestCancellationReceiverStrategy.is(value);
      }
      CancellationReceiverStrategy2.is = is2;
    })(CancellationReceiverStrategy || (exports$12.CancellationReceiverStrategy = CancellationReceiverStrategy = {}));
    var CancellationSenderStrategy;
    (function(CancellationSenderStrategy2) {
      CancellationSenderStrategy2.Message = Object.freeze({
        sendCancellation(conn, id2) {
          return conn.sendNotification(CancelNotification.type, { id: id2 });
        },
        cleanup(_2) {
        }
      });
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.sendCancellation) && Is2.func(candidate.cleanup);
      }
      CancellationSenderStrategy2.is = is2;
    })(CancellationSenderStrategy || (exports$12.CancellationSenderStrategy = CancellationSenderStrategy = {}));
    var CancellationStrategy;
    (function(CancellationStrategy2) {
      CancellationStrategy2.Message = Object.freeze({
        receiver: CancellationReceiverStrategy.Message,
        sender: CancellationSenderStrategy.Message
      });
      function is2(value) {
        const candidate = value;
        return candidate && CancellationReceiverStrategy.is(candidate.receiver) && CancellationSenderStrategy.is(candidate.sender);
      }
      CancellationStrategy2.is = is2;
    })(CancellationStrategy || (exports$12.CancellationStrategy = CancellationStrategy = {}));
    var MessageStrategy;
    (function(MessageStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.handleMessage);
      }
      MessageStrategy2.is = is2;
    })(MessageStrategy || (exports$12.MessageStrategy = MessageStrategy = {}));
    var ConnectionOptions;
    (function(ConnectionOptions2) {
      function is2(value) {
        const candidate = value;
        return candidate && (CancellationStrategy.is(candidate.cancellationStrategy) || ConnectionStrategy.is(candidate.connectionStrategy) || MessageStrategy.is(candidate.messageStrategy));
      }
      ConnectionOptions2.is = is2;
    })(ConnectionOptions || (exports$12.ConnectionOptions = ConnectionOptions = {}));
    var ConnectionState;
    (function(ConnectionState2) {
      ConnectionState2[ConnectionState2["New"] = 1] = "New";
      ConnectionState2[ConnectionState2["Listening"] = 2] = "Listening";
      ConnectionState2[ConnectionState2["Closed"] = 3] = "Closed";
      ConnectionState2[ConnectionState2["Disposed"] = 4] = "Disposed";
    })(ConnectionState || (ConnectionState = {}));
    function createMessageConnection2(messageReader2, messageWriter2, _logger, options2) {
      const logger = _logger !== void 0 ? _logger : exports$12.NullLogger;
      let sequenceNumber = 0;
      let notificationSequenceNumber = 0;
      let unknownResponseSequenceNumber = 0;
      const version2 = "2.0";
      let starRequestHandler = void 0;
      const requestHandlers = /* @__PURE__ */ new Map();
      let starNotificationHandler = void 0;
      const notificationHandlers = /* @__PURE__ */ new Map();
      const progressHandlers = /* @__PURE__ */ new Map();
      let timer;
      let messageQueue = new linkedMap_1.LinkedMap();
      let responsePromises = /* @__PURE__ */ new Map();
      let knownCanceledRequests = /* @__PURE__ */ new Set();
      let requestTokens = /* @__PURE__ */ new Map();
      let trace = Trace.Off;
      let traceFormat = TraceFormat.Text;
      let tracer;
      let state = ConnectionState.New;
      const errorEmitter = new events_1.Emitter();
      const closeEmitter = new events_1.Emitter();
      const unhandledNotificationEmitter = new events_1.Emitter();
      const unhandledProgressEmitter = new events_1.Emitter();
      const disposeEmitter = new events_1.Emitter();
      const cancellationStrategy = options2 && options2.cancellationStrategy ? options2.cancellationStrategy : CancellationStrategy.Message;
      function createRequestQueueKey(id2) {
        if (id2 === null) {
          throw new Error(`Can't send requests with id null since the response can't be correlated.`);
        }
        return "req-" + id2.toString();
      }
      function createResponseQueueKey(id2) {
        if (id2 === null) {
          return "res-unknown-" + (++unknownResponseSequenceNumber).toString();
        } else {
          return "res-" + id2.toString();
        }
      }
      function createNotificationQueueKey() {
        return "not-" + (++notificationSequenceNumber).toString();
      }
      function addMessageToQueue(queue2, message) {
        if (messages_1.Message.isRequest(message)) {
          queue2.set(createRequestQueueKey(message.id), message);
        } else if (messages_1.Message.isResponse(message)) {
          queue2.set(createResponseQueueKey(message.id), message);
        } else {
          queue2.set(createNotificationQueueKey(), message);
        }
      }
      function cancelUndispatched(_message) {
        return void 0;
      }
      function isListening() {
        return state === ConnectionState.Listening;
      }
      function isClosed() {
        return state === ConnectionState.Closed;
      }
      function isDisposed() {
        return state === ConnectionState.Disposed;
      }
      function closeHandler() {
        if (state === ConnectionState.New || state === ConnectionState.Listening) {
          state = ConnectionState.Closed;
          closeEmitter.fire(void 0);
        }
      }
      function readErrorHandler(error) {
        errorEmitter.fire([error, void 0, void 0]);
      }
      function writeErrorHandler(data) {
        errorEmitter.fire(data);
      }
      messageReader2.onClose(closeHandler);
      messageReader2.onError(readErrorHandler);
      messageWriter2.onClose(closeHandler);
      messageWriter2.onError(writeErrorHandler);
      function triggerMessageQueue() {
        if (timer || messageQueue.size === 0) {
          return;
        }
        timer = (0, ral_1.default)().timer.setImmediate(() => {
          timer = void 0;
          processMessageQueue();
        });
      }
      function handleMessage(message) {
        if (messages_1.Message.isRequest(message)) {
          handleRequest(message);
        } else if (messages_1.Message.isNotification(message)) {
          handleNotification(message);
        } else if (messages_1.Message.isResponse(message)) {
          handleResponse(message);
        } else {
          handleInvalidMessage(message);
        }
      }
      function processMessageQueue() {
        if (messageQueue.size === 0) {
          return;
        }
        const message = messageQueue.shift();
        try {
          const messageStrategy = options2?.messageStrategy;
          if (MessageStrategy.is(messageStrategy)) {
            messageStrategy.handleMessage(message, handleMessage);
          } else {
            handleMessage(message);
          }
        } finally {
          triggerMessageQueue();
        }
      }
      const callback = (message) => {
        try {
          if (messages_1.Message.isNotification(message) && message.method === CancelNotification.type.method) {
            const cancelId = message.params.id;
            const key = createRequestQueueKey(cancelId);
            const toCancel = messageQueue.get(key);
            if (messages_1.Message.isRequest(toCancel)) {
              const strategy = options2?.connectionStrategy;
              const response = strategy && strategy.cancelUndispatched ? strategy.cancelUndispatched(toCancel, cancelUndispatched) : cancelUndispatched(toCancel);
              if (response && (response.error !== void 0 || response.result !== void 0)) {
                messageQueue.delete(key);
                requestTokens.delete(cancelId);
                response.id = toCancel.id;
                traceSendingResponse(response, message.method, Date.now());
                messageWriter2.write(response).catch(() => logger.error(`Sending response for canceled message failed.`));
                return;
              }
            }
            const cancellationToken = requestTokens.get(cancelId);
            if (cancellationToken !== void 0) {
              cancellationToken.cancel();
              traceReceivedNotification(message);
              return;
            } else {
              knownCanceledRequests.add(cancelId);
            }
          }
          addMessageToQueue(messageQueue, message);
        } finally {
          triggerMessageQueue();
        }
      };
      function handleRequest(requestMessage) {
        if (isDisposed()) {
          return;
        }
        function reply(resultOrError, method, startTime22) {
          const message = {
            jsonrpc: version2,
            id: requestMessage.id
          };
          if (resultOrError instanceof messages_1.ResponseError) {
            message.error = resultOrError.toJson();
          } else {
            message.result = resultOrError === void 0 ? null : resultOrError;
          }
          traceSendingResponse(message, method, startTime22);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        function replyError(error, method, startTime22) {
          const message = {
            jsonrpc: version2,
            id: requestMessage.id,
            error: error.toJson()
          };
          traceSendingResponse(message, method, startTime22);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        function replySuccess(result2, method, startTime22) {
          if (result2 === void 0) {
            result2 = null;
          }
          const message = {
            jsonrpc: version2,
            id: requestMessage.id,
            result: result2
          };
          traceSendingResponse(message, method, startTime22);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        traceReceivedRequest(requestMessage);
        const element2 = requestHandlers.get(requestMessage.method);
        let type;
        let requestHandler;
        if (element2) {
          type = element2.type;
          requestHandler = element2.handler;
        }
        const startTime2 = Date.now();
        if (requestHandler || starRequestHandler) {
          const tokenKey = requestMessage.id ?? String(Date.now());
          const cancellationSource = IdCancellationReceiverStrategy.is(cancellationStrategy.receiver) ? cancellationStrategy.receiver.createCancellationTokenSource(tokenKey) : cancellationStrategy.receiver.createCancellationTokenSource(requestMessage);
          if (requestMessage.id !== null && knownCanceledRequests.has(requestMessage.id)) {
            cancellationSource.cancel();
          }
          if (requestMessage.id !== null) {
            requestTokens.set(tokenKey, cancellationSource);
          }
          try {
            let handlerResult;
            if (requestHandler) {
              if (requestMessage.params === void 0) {
                if (type !== void 0 && type.numberOfParams !== 0) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines ${type.numberOfParams} params but received none.`), requestMessage.method, startTime2);
                  return;
                }
                handlerResult = requestHandler(cancellationSource.token);
              } else if (Array.isArray(requestMessage.params)) {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byName) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines parameters by name but received parameters by position`), requestMessage.method, startTime2);
                  return;
                }
                handlerResult = requestHandler(...requestMessage.params, cancellationSource.token);
              } else {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byPosition) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines parameters by position but received parameters by name`), requestMessage.method, startTime2);
                  return;
                }
                handlerResult = requestHandler(requestMessage.params, cancellationSource.token);
              }
            } else if (starRequestHandler) {
              handlerResult = starRequestHandler(requestMessage.method, requestMessage.params, cancellationSource.token);
            }
            const promise = handlerResult;
            if (!handlerResult) {
              requestTokens.delete(tokenKey);
              replySuccess(handlerResult, requestMessage.method, startTime2);
            } else if (promise.then) {
              promise.then((resultOrError) => {
                requestTokens.delete(tokenKey);
                reply(resultOrError, requestMessage.method, startTime2);
              }, (error) => {
                requestTokens.delete(tokenKey);
                if (error instanceof messages_1.ResponseError) {
                  replyError(error, requestMessage.method, startTime2);
                } else if (error && Is2.string(error.message)) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed with message: ${error.message}`), requestMessage.method, startTime2);
                } else {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed unexpectedly without providing any details.`), requestMessage.method, startTime2);
                }
              });
            } else {
              requestTokens.delete(tokenKey);
              reply(handlerResult, requestMessage.method, startTime2);
            }
          } catch (error) {
            requestTokens.delete(tokenKey);
            if (error instanceof messages_1.ResponseError) {
              reply(error, requestMessage.method, startTime2);
            } else if (error && Is2.string(error.message)) {
              replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed with message: ${error.message}`), requestMessage.method, startTime2);
            } else {
              replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed unexpectedly without providing any details.`), requestMessage.method, startTime2);
            }
          }
        } else {
          replyError(new messages_1.ResponseError(messages_1.ErrorCodes.MethodNotFound, `Unhandled method ${requestMessage.method}`), requestMessage.method, startTime2);
        }
      }
      function handleResponse(responseMessage) {
        if (isDisposed()) {
          return;
        }
        if (responseMessage.id === null) {
          if (responseMessage.error) {
            logger.error(`Received response message without id: Error is: 
${JSON.stringify(responseMessage.error, void 0, 4)}`);
          } else {
            logger.error(`Received response message without id. No further error information provided.`);
          }
        } else {
          const key = responseMessage.id;
          const responsePromise = responsePromises.get(key);
          traceReceivedResponse(responseMessage, responsePromise);
          if (responsePromise !== void 0) {
            responsePromises.delete(key);
            try {
              if (responseMessage.error) {
                const error = responseMessage.error;
                responsePromise.reject(new messages_1.ResponseError(error.code, error.message, error.data));
              } else if (responseMessage.result !== void 0) {
                responsePromise.resolve(responseMessage.result);
              } else {
                throw new Error("Should never happen.");
              }
            } catch (error) {
              if (error.message) {
                logger.error(`Response handler '${responsePromise.method}' failed with message: ${error.message}`);
              } else {
                logger.error(`Response handler '${responsePromise.method}' failed unexpectedly.`);
              }
            }
          }
        }
      }
      function handleNotification(message) {
        if (isDisposed()) {
          return;
        }
        let type = void 0;
        let notificationHandler;
        if (message.method === CancelNotification.type.method) {
          const cancelId = message.params.id;
          knownCanceledRequests.delete(cancelId);
          traceReceivedNotification(message);
          return;
        } else {
          const element2 = notificationHandlers.get(message.method);
          if (element2) {
            notificationHandler = element2.handler;
            type = element2.type;
          }
        }
        if (notificationHandler || starNotificationHandler) {
          try {
            traceReceivedNotification(message);
            if (notificationHandler) {
              if (message.params === void 0) {
                if (type !== void 0) {
                  if (type.numberOfParams !== 0 && type.parameterStructures !== messages_1.ParameterStructures.byName) {
                    logger.error(`Notification ${message.method} defines ${type.numberOfParams} params but received none.`);
                  }
                }
                notificationHandler();
              } else if (Array.isArray(message.params)) {
                const params = message.params;
                if (message.method === ProgressNotification.type.method && params.length === 2 && ProgressToken.is(params[0])) {
                  notificationHandler({ token: params[0], value: params[1] });
                } else {
                  if (type !== void 0) {
                    if (type.parameterStructures === messages_1.ParameterStructures.byName) {
                      logger.error(`Notification ${message.method} defines parameters by name but received parameters by position`);
                    }
                    if (type.numberOfParams !== message.params.length) {
                      logger.error(`Notification ${message.method} defines ${type.numberOfParams} params but received ${params.length} arguments`);
                    }
                  }
                  notificationHandler(...params);
                }
              } else {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byPosition) {
                  logger.error(`Notification ${message.method} defines parameters by position but received parameters by name`);
                }
                notificationHandler(message.params);
              }
            } else if (starNotificationHandler) {
              starNotificationHandler(message.method, message.params);
            }
          } catch (error) {
            if (error.message) {
              logger.error(`Notification handler '${message.method}' failed with message: ${error.message}`);
            } else {
              logger.error(`Notification handler '${message.method}' failed unexpectedly.`);
            }
          }
        } else {
          unhandledNotificationEmitter.fire(message);
        }
      }
      function handleInvalidMessage(message) {
        if (!message) {
          logger.error("Received empty message.");
          return;
        }
        logger.error(`Received message which is neither a response nor a notification message:
${JSON.stringify(message, null, 4)}`);
        const responseMessage = message;
        if (Is2.string(responseMessage.id) || Is2.number(responseMessage.id)) {
          const key = responseMessage.id;
          const responseHandler = responsePromises.get(key);
          if (responseHandler) {
            responseHandler.reject(new Error("The received response has neither a result nor an error property."));
          }
        }
      }
      function stringifyTrace(params) {
        if (params === void 0 || params === null) {
          return void 0;
        }
        switch (trace) {
          case Trace.Verbose:
            return JSON.stringify(params, null, 4);
          case Trace.Compact:
            return JSON.stringify(params);
          default:
            return void 0;
        }
      }
      function traceSendingRequest(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if ((trace === Trace.Verbose || trace === Trace.Compact) && message.params) {
            data = `Params: ${stringifyTrace(message.params)}

`;
          }
          tracer.log(`Sending request '${message.method} - (${message.id})'.`, data);
        } else {
          logLSPMessage("send-request", message);
        }
      }
      function traceSendingNotification(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.params) {
              data = `Params: ${stringifyTrace(message.params)}

`;
            } else {
              data = "No parameters provided.\n\n";
            }
          }
          tracer.log(`Sending notification '${message.method}'.`, data);
        } else {
          logLSPMessage("send-notification", message);
        }
      }
      function traceSendingResponse(message, method, startTime2) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.error && message.error.data) {
              data = `Error data: ${stringifyTrace(message.error.data)}

`;
            } else {
              if (message.result) {
                data = `Result: ${stringifyTrace(message.result)}

`;
              } else if (message.error === void 0) {
                data = "No result returned.\n\n";
              }
            }
          }
          tracer.log(`Sending response '${method} - (${message.id})'. Processing request took ${Date.now() - startTime2}ms`, data);
        } else {
          logLSPMessage("send-response", message);
        }
      }
      function traceReceivedRequest(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if ((trace === Trace.Verbose || trace === Trace.Compact) && message.params) {
            data = `Params: ${stringifyTrace(message.params)}

`;
          }
          tracer.log(`Received request '${message.method} - (${message.id})'.`, data);
        } else {
          logLSPMessage("receive-request", message);
        }
      }
      function traceReceivedNotification(message) {
        if (trace === Trace.Off || !tracer || message.method === LogTraceNotification.type.method) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.params) {
              data = `Params: ${stringifyTrace(message.params)}

`;
            } else {
              data = "No parameters provided.\n\n";
            }
          }
          tracer.log(`Received notification '${message.method}'.`, data);
        } else {
          logLSPMessage("receive-notification", message);
        }
      }
      function traceReceivedResponse(message, responsePromise) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.error && message.error.data) {
              data = `Error data: ${stringifyTrace(message.error.data)}

`;
            } else {
              if (message.result) {
                data = `Result: ${stringifyTrace(message.result)}

`;
              } else if (message.error === void 0) {
                data = "No result returned.\n\n";
              }
            }
          }
          if (responsePromise) {
            const error = message.error ? ` Request failed: ${message.error.message} (${message.error.code}).` : "";
            tracer.log(`Received response '${responsePromise.method} - (${message.id})' in ${Date.now() - responsePromise.timerStart}ms.${error}`, data);
          } else {
            tracer.log(`Received response ${message.id} without active response promise.`, data);
          }
        } else {
          logLSPMessage("receive-response", message);
        }
      }
      function logLSPMessage(type, message) {
        if (!tracer || trace === Trace.Off) {
          return;
        }
        const lspMessage = {
          isLSPMessage: true,
          type,
          message,
          timestamp: Date.now()
        };
        tracer.log(lspMessage);
      }
      function throwIfClosedOrDisposed() {
        if (isClosed()) {
          throw new ConnectionError(ConnectionErrors.Closed, "Connection is closed.");
        }
        if (isDisposed()) {
          throw new ConnectionError(ConnectionErrors.Disposed, "Connection is disposed.");
        }
      }
      function throwIfListening() {
        if (isListening()) {
          throw new ConnectionError(ConnectionErrors.AlreadyListening, "Connection is already listening");
        }
      }
      function throwIfNotListening() {
        if (!isListening()) {
          throw new Error("Call listen() first.");
        }
      }
      function undefinedToNull(param) {
        if (param === void 0) {
          return null;
        } else {
          return param;
        }
      }
      function nullToUndefined(param) {
        if (param === null) {
          return void 0;
        } else {
          return param;
        }
      }
      function isNamedParam(param) {
        return param !== void 0 && param !== null && !Array.isArray(param) && typeof param === "object";
      }
      function computeSingleParam(parameterStructures, param) {
        switch (parameterStructures) {
          case messages_1.ParameterStructures.auto:
            if (isNamedParam(param)) {
              return nullToUndefined(param);
            } else {
              return [undefinedToNull(param)];
            }
          case messages_1.ParameterStructures.byName:
            if (!isNamedParam(param)) {
              throw new Error(`Received parameters by name but param is not an object literal.`);
            }
            return nullToUndefined(param);
          case messages_1.ParameterStructures.byPosition:
            return [undefinedToNull(param)];
          default:
            throw new Error(`Unknown parameter structure ${parameterStructures.toString()}`);
        }
      }
      function computeMessageParams(type, params) {
        let result2;
        const numberOfParams = type.numberOfParams;
        switch (numberOfParams) {
          case 0:
            result2 = void 0;
            break;
          case 1:
            result2 = computeSingleParam(type.parameterStructures, params[0]);
            break;
          default:
            result2 = [];
            for (let i2 = 0; i2 < params.length && i2 < numberOfParams; i2++) {
              result2.push(undefinedToNull(params[i2]));
            }
            if (params.length < numberOfParams) {
              for (let i2 = params.length; i2 < numberOfParams; i2++) {
                result2.push(null);
              }
            }
            break;
        }
        return result2;
      }
      const connection2 = {
        sendNotification: (type, ...args) => {
          throwIfClosedOrDisposed();
          let method;
          let messageParams;
          if (Is2.string(type)) {
            method = type;
            const first2 = args[0];
            let paramStart = 0;
            let parameterStructures = messages_1.ParameterStructures.auto;
            if (messages_1.ParameterStructures.is(first2)) {
              paramStart = 1;
              parameterStructures = first2;
            }
            let paramEnd = args.length;
            const numberOfParams = paramEnd - paramStart;
            switch (numberOfParams) {
              case 0:
                messageParams = void 0;
                break;
              case 1:
                messageParams = computeSingleParam(parameterStructures, args[paramStart]);
                break;
              default:
                if (parameterStructures === messages_1.ParameterStructures.byName) {
                  throw new Error(`Received ${numberOfParams} parameters for 'by Name' notification parameter structure.`);
                }
                messageParams = args.slice(paramStart, paramEnd).map((value) => undefinedToNull(value));
                break;
            }
          } else {
            const params = args;
            method = type.method;
            messageParams = computeMessageParams(type, params);
          }
          const notificationMessage = {
            jsonrpc: version2,
            method,
            params: messageParams
          };
          traceSendingNotification(notificationMessage);
          return messageWriter2.write(notificationMessage).catch((error) => {
            logger.error(`Sending notification failed.`);
            throw error;
          });
        },
        onNotification: (type, handler) => {
          throwIfClosedOrDisposed();
          let method;
          if (Is2.func(type)) {
            starNotificationHandler = type;
          } else if (handler) {
            if (Is2.string(type)) {
              method = type;
              notificationHandlers.set(type, { type: void 0, handler });
            } else {
              method = type.method;
              notificationHandlers.set(type.method, { type, handler });
            }
          }
          return {
            dispose: () => {
              if (method !== void 0) {
                notificationHandlers.delete(method);
              } else {
                starNotificationHandler = void 0;
              }
            }
          };
        },
        onProgress: (_type, token, handler) => {
          if (progressHandlers.has(token)) {
            throw new Error(`Progress handler for token ${token} already registered`);
          }
          progressHandlers.set(token, handler);
          return {
            dispose: () => {
              progressHandlers.delete(token);
            }
          };
        },
        sendProgress: (_type, token, value) => {
          return connection2.sendNotification(ProgressNotification.type, { token, value });
        },
        onUnhandledProgress: unhandledProgressEmitter.event,
        sendRequest: (type, ...args) => {
          throwIfClosedOrDisposed();
          throwIfNotListening();
          let method;
          let messageParams;
          let token = void 0;
          if (Is2.string(type)) {
            method = type;
            const first2 = args[0];
            const last2 = args[args.length - 1];
            let paramStart = 0;
            let parameterStructures = messages_1.ParameterStructures.auto;
            if (messages_1.ParameterStructures.is(first2)) {
              paramStart = 1;
              parameterStructures = first2;
            }
            let paramEnd = args.length;
            if (cancellation_1.CancellationToken.is(last2)) {
              paramEnd = paramEnd - 1;
              token = last2;
            }
            const numberOfParams = paramEnd - paramStart;
            switch (numberOfParams) {
              case 0:
                messageParams = void 0;
                break;
              case 1:
                messageParams = computeSingleParam(parameterStructures, args[paramStart]);
                break;
              default:
                if (parameterStructures === messages_1.ParameterStructures.byName) {
                  throw new Error(`Received ${numberOfParams} parameters for 'by Name' request parameter structure.`);
                }
                messageParams = args.slice(paramStart, paramEnd).map((value) => undefinedToNull(value));
                break;
            }
          } else {
            const params = args;
            method = type.method;
            messageParams = computeMessageParams(type, params);
            const numberOfParams = type.numberOfParams;
            token = cancellation_1.CancellationToken.is(params[numberOfParams]) ? params[numberOfParams] : void 0;
          }
          const id2 = sequenceNumber++;
          let disposable2;
          if (token) {
            disposable2 = token.onCancellationRequested(() => {
              const p = cancellationStrategy.sender.sendCancellation(connection2, id2);
              if (p === void 0) {
                logger.log(`Received no promise from cancellation strategy when cancelling id ${id2}`);
                return Promise.resolve();
              } else {
                return p.catch(() => {
                  logger.log(`Sending cancellation messages for id ${id2} failed`);
                });
              }
            });
          }
          const requestMessage = {
            jsonrpc: version2,
            id: id2,
            method,
            params: messageParams
          };
          traceSendingRequest(requestMessage);
          if (typeof cancellationStrategy.sender.enableCancellation === "function") {
            cancellationStrategy.sender.enableCancellation(requestMessage);
          }
          return new Promise(async (resolve, reject2) => {
            const resolveWithCleanup = (r) => {
              resolve(r);
              cancellationStrategy.sender.cleanup(id2);
              disposable2?.dispose();
            };
            const rejectWithCleanup = (r) => {
              reject2(r);
              cancellationStrategy.sender.cleanup(id2);
              disposable2?.dispose();
            };
            const responsePromise = { method, timerStart: Date.now(), resolve: resolveWithCleanup, reject: rejectWithCleanup };
            try {
              responsePromises.set(id2, responsePromise);
              await messageWriter2.write(requestMessage);
            } catch (error) {
              responsePromises.delete(id2);
              responsePromise.reject(new messages_1.ResponseError(messages_1.ErrorCodes.MessageWriteError, error.message ? error.message : "Unknown reason"));
              logger.error(`Sending request failed.`);
              throw error;
            }
          });
        },
        onRequest: (type, handler) => {
          throwIfClosedOrDisposed();
          let method = null;
          if (StarRequestHandler.is(type)) {
            method = void 0;
            starRequestHandler = type;
          } else if (Is2.string(type)) {
            method = null;
            if (handler !== void 0) {
              method = type;
              requestHandlers.set(type, { handler, type: void 0 });
            }
          } else {
            if (handler !== void 0) {
              method = type.method;
              requestHandlers.set(type.method, { type, handler });
            }
          }
          return {
            dispose: () => {
              if (method === null) {
                return;
              }
              if (method !== void 0) {
                requestHandlers.delete(method);
              } else {
                starRequestHandler = void 0;
              }
            }
          };
        },
        hasPendingResponse: () => {
          return responsePromises.size > 0;
        },
        trace: async (_value, _tracer, sendNotificationOrTraceOptions) => {
          let _sendNotification = false;
          let _traceFormat = TraceFormat.Text;
          if (sendNotificationOrTraceOptions !== void 0) {
            if (Is2.boolean(sendNotificationOrTraceOptions)) {
              _sendNotification = sendNotificationOrTraceOptions;
            } else {
              _sendNotification = sendNotificationOrTraceOptions.sendNotification || false;
              _traceFormat = sendNotificationOrTraceOptions.traceFormat || TraceFormat.Text;
            }
          }
          trace = _value;
          traceFormat = _traceFormat;
          if (trace === Trace.Off) {
            tracer = void 0;
          } else {
            tracer = _tracer;
          }
          if (_sendNotification && !isClosed() && !isDisposed()) {
            await connection2.sendNotification(SetTraceNotification.type, { value: Trace.toString(_value) });
          }
        },
        onError: errorEmitter.event,
        onClose: closeEmitter.event,
        onUnhandledNotification: unhandledNotificationEmitter.event,
        onDispose: disposeEmitter.event,
        end: () => {
          messageWriter2.end();
        },
        dispose: () => {
          if (isDisposed()) {
            return;
          }
          state = ConnectionState.Disposed;
          disposeEmitter.fire(void 0);
          const error = new messages_1.ResponseError(messages_1.ErrorCodes.PendingResponseRejected, "Pending response rejected since connection got disposed");
          for (const promise of responsePromises.values()) {
            promise.reject(error);
          }
          responsePromises = /* @__PURE__ */ new Map();
          requestTokens = /* @__PURE__ */ new Map();
          knownCanceledRequests = /* @__PURE__ */ new Set();
          messageQueue = new linkedMap_1.LinkedMap();
          if (Is2.func(messageWriter2.dispose)) {
            messageWriter2.dispose();
          }
          if (Is2.func(messageReader2.dispose)) {
            messageReader2.dispose();
          }
        },
        listen: () => {
          throwIfClosedOrDisposed();
          throwIfListening();
          state = ConnectionState.Listening;
          messageReader2.listen(callback);
        },
        inspect: () => {
          (0, ral_1.default)().console.log("inspect");
        }
      };
      connection2.onNotification(LogTraceNotification.type, (params) => {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        const verbose2 = trace === Trace.Verbose || trace === Trace.Compact;
        tracer.log(params.message, verbose2 ? params.verbose : void 0);
      });
      connection2.onNotification(ProgressNotification.type, (params) => {
        const handler = progressHandlers.get(params.token);
        if (handler) {
          handler(params.value);
        } else {
          unhandledProgressEmitter.fire(params);
        }
      });
      return connection2;
    }
    exports$12.createMessageConnection = createMessageConnection2;
  })(connection$1);
  return connection$1;
}
var hasRequiredApi$1;
function requireApi$1() {
  if (hasRequiredApi$1) return api$1;
  hasRequiredApi$1 = 1;
  (function(exports$12) {
    Object.defineProperty(exports$12, "__esModule", { value: true });
    exports$12.ProgressType = exports$12.ProgressToken = exports$12.createMessageConnection = exports$12.NullLogger = exports$12.ConnectionOptions = exports$12.ConnectionStrategy = exports$12.AbstractMessageBuffer = exports$12.WriteableStreamMessageWriter = exports$12.AbstractMessageWriter = exports$12.MessageWriter = exports$12.ReadableStreamMessageReader = exports$12.AbstractMessageReader = exports$12.MessageReader = exports$12.SharedArrayReceiverStrategy = exports$12.SharedArraySenderStrategy = exports$12.CancellationToken = exports$12.CancellationTokenSource = exports$12.Emitter = exports$12.Event = exports$12.Disposable = exports$12.LRUCache = exports$12.Touch = exports$12.LinkedMap = exports$12.ParameterStructures = exports$12.NotificationType9 = exports$12.NotificationType8 = exports$12.NotificationType7 = exports$12.NotificationType6 = exports$12.NotificationType5 = exports$12.NotificationType4 = exports$12.NotificationType3 = exports$12.NotificationType2 = exports$12.NotificationType1 = exports$12.NotificationType0 = exports$12.NotificationType = exports$12.ErrorCodes = exports$12.ResponseError = exports$12.RequestType9 = exports$12.RequestType8 = exports$12.RequestType7 = exports$12.RequestType6 = exports$12.RequestType5 = exports$12.RequestType4 = exports$12.RequestType3 = exports$12.RequestType2 = exports$12.RequestType1 = exports$12.RequestType0 = exports$12.RequestType = exports$12.Message = exports$12.RAL = void 0;
    exports$12.MessageStrategy = exports$12.CancellationStrategy = exports$12.CancellationSenderStrategy = exports$12.CancellationReceiverStrategy = exports$12.ConnectionError = exports$12.ConnectionErrors = exports$12.LogTraceNotification = exports$12.SetTraceNotification = exports$12.TraceFormat = exports$12.TraceValues = exports$12.Trace = void 0;
    const messages_1 = requireMessages$1();
    Object.defineProperty(exports$12, "Message", { enumerable: true, get: function() {
      return messages_1.Message;
    } });
    Object.defineProperty(exports$12, "RequestType", { enumerable: true, get: function() {
      return messages_1.RequestType;
    } });
    Object.defineProperty(exports$12, "RequestType0", { enumerable: true, get: function() {
      return messages_1.RequestType0;
    } });
    Object.defineProperty(exports$12, "RequestType1", { enumerable: true, get: function() {
      return messages_1.RequestType1;
    } });
    Object.defineProperty(exports$12, "RequestType2", { enumerable: true, get: function() {
      return messages_1.RequestType2;
    } });
    Object.defineProperty(exports$12, "RequestType3", { enumerable: true, get: function() {
      return messages_1.RequestType3;
    } });
    Object.defineProperty(exports$12, "RequestType4", { enumerable: true, get: function() {
      return messages_1.RequestType4;
    } });
    Object.defineProperty(exports$12, "RequestType5", { enumerable: true, get: function() {
      return messages_1.RequestType5;
    } });
    Object.defineProperty(exports$12, "RequestType6", { enumerable: true, get: function() {
      return messages_1.RequestType6;
    } });
    Object.defineProperty(exports$12, "RequestType7", { enumerable: true, get: function() {
      return messages_1.RequestType7;
    } });
    Object.defineProperty(exports$12, "RequestType8", { enumerable: true, get: function() {
      return messages_1.RequestType8;
    } });
    Object.defineProperty(exports$12, "RequestType9", { enumerable: true, get: function() {
      return messages_1.RequestType9;
    } });
    Object.defineProperty(exports$12, "ResponseError", { enumerable: true, get: function() {
      return messages_1.ResponseError;
    } });
    Object.defineProperty(exports$12, "ErrorCodes", { enumerable: true, get: function() {
      return messages_1.ErrorCodes;
    } });
    Object.defineProperty(exports$12, "NotificationType", { enumerable: true, get: function() {
      return messages_1.NotificationType;
    } });
    Object.defineProperty(exports$12, "NotificationType0", { enumerable: true, get: function() {
      return messages_1.NotificationType0;
    } });
    Object.defineProperty(exports$12, "NotificationType1", { enumerable: true, get: function() {
      return messages_1.NotificationType1;
    } });
    Object.defineProperty(exports$12, "NotificationType2", { enumerable: true, get: function() {
      return messages_1.NotificationType2;
    } });
    Object.defineProperty(exports$12, "NotificationType3", { enumerable: true, get: function() {
      return messages_1.NotificationType3;
    } });
    Object.defineProperty(exports$12, "NotificationType4", { enumerable: true, get: function() {
      return messages_1.NotificationType4;
    } });
    Object.defineProperty(exports$12, "NotificationType5", { enumerable: true, get: function() {
      return messages_1.NotificationType5;
    } });
    Object.defineProperty(exports$12, "NotificationType6", { enumerable: true, get: function() {
      return messages_1.NotificationType6;
    } });
    Object.defineProperty(exports$12, "NotificationType7", { enumerable: true, get: function() {
      return messages_1.NotificationType7;
    } });
    Object.defineProperty(exports$12, "NotificationType8", { enumerable: true, get: function() {
      return messages_1.NotificationType8;
    } });
    Object.defineProperty(exports$12, "NotificationType9", { enumerable: true, get: function() {
      return messages_1.NotificationType9;
    } });
    Object.defineProperty(exports$12, "ParameterStructures", { enumerable: true, get: function() {
      return messages_1.ParameterStructures;
    } });
    const linkedMap_1 = requireLinkedMap();
    Object.defineProperty(exports$12, "LinkedMap", { enumerable: true, get: function() {
      return linkedMap_1.LinkedMap;
    } });
    Object.defineProperty(exports$12, "LRUCache", { enumerable: true, get: function() {
      return linkedMap_1.LRUCache;
    } });
    Object.defineProperty(exports$12, "Touch", { enumerable: true, get: function() {
      return linkedMap_1.Touch;
    } });
    const disposable_1 = requireDisposable();
    Object.defineProperty(exports$12, "Disposable", { enumerable: true, get: function() {
      return disposable_1.Disposable;
    } });
    const events_1 = requireEvents();
    Object.defineProperty(exports$12, "Event", { enumerable: true, get: function() {
      return events_1.Event;
    } });
    Object.defineProperty(exports$12, "Emitter", { enumerable: true, get: function() {
      return events_1.Emitter;
    } });
    const cancellation_1 = requireCancellation();
    Object.defineProperty(exports$12, "CancellationTokenSource", { enumerable: true, get: function() {
      return cancellation_1.CancellationTokenSource;
    } });
    Object.defineProperty(exports$12, "CancellationToken", { enumerable: true, get: function() {
      return cancellation_1.CancellationToken;
    } });
    const sharedArrayCancellation_1 = requireSharedArrayCancellation();
    Object.defineProperty(exports$12, "SharedArraySenderStrategy", { enumerable: true, get: function() {
      return sharedArrayCancellation_1.SharedArraySenderStrategy;
    } });
    Object.defineProperty(exports$12, "SharedArrayReceiverStrategy", { enumerable: true, get: function() {
      return sharedArrayCancellation_1.SharedArrayReceiverStrategy;
    } });
    const messageReader_1 = requireMessageReader();
    Object.defineProperty(exports$12, "MessageReader", { enumerable: true, get: function() {
      return messageReader_1.MessageReader;
    } });
    Object.defineProperty(exports$12, "AbstractMessageReader", { enumerable: true, get: function() {
      return messageReader_1.AbstractMessageReader;
    } });
    Object.defineProperty(exports$12, "ReadableStreamMessageReader", { enumerable: true, get: function() {
      return messageReader_1.ReadableStreamMessageReader;
    } });
    const messageWriter_1 = requireMessageWriter();
    Object.defineProperty(exports$12, "MessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.MessageWriter;
    } });
    Object.defineProperty(exports$12, "AbstractMessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.AbstractMessageWriter;
    } });
    Object.defineProperty(exports$12, "WriteableStreamMessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.WriteableStreamMessageWriter;
    } });
    const messageBuffer_1 = requireMessageBuffer();
    Object.defineProperty(exports$12, "AbstractMessageBuffer", { enumerable: true, get: function() {
      return messageBuffer_1.AbstractMessageBuffer;
    } });
    const connection_1 = requireConnection$1();
    Object.defineProperty(exports$12, "ConnectionStrategy", { enumerable: true, get: function() {
      return connection_1.ConnectionStrategy;
    } });
    Object.defineProperty(exports$12, "ConnectionOptions", { enumerable: true, get: function() {
      return connection_1.ConnectionOptions;
    } });
    Object.defineProperty(exports$12, "NullLogger", { enumerable: true, get: function() {
      return connection_1.NullLogger;
    } });
    Object.defineProperty(exports$12, "createMessageConnection", { enumerable: true, get: function() {
      return connection_1.createMessageConnection;
    } });
    Object.defineProperty(exports$12, "ProgressToken", { enumerable: true, get: function() {
      return connection_1.ProgressToken;
    } });
    Object.defineProperty(exports$12, "ProgressType", { enumerable: true, get: function() {
      return connection_1.ProgressType;
    } });
    Object.defineProperty(exports$12, "Trace", { enumerable: true, get: function() {
      return connection_1.Trace;
    } });
    Object.defineProperty(exports$12, "TraceValues", { enumerable: true, get: function() {
      return connection_1.TraceValues;
    } });
    Object.defineProperty(exports$12, "TraceFormat", { enumerable: true, get: function() {
      return connection_1.TraceFormat;
    } });
    Object.defineProperty(exports$12, "SetTraceNotification", { enumerable: true, get: function() {
      return connection_1.SetTraceNotification;
    } });
    Object.defineProperty(exports$12, "LogTraceNotification", { enumerable: true, get: function() {
      return connection_1.LogTraceNotification;
    } });
    Object.defineProperty(exports$12, "ConnectionErrors", { enumerable: true, get: function() {
      return connection_1.ConnectionErrors;
    } });
    Object.defineProperty(exports$12, "ConnectionError", { enumerable: true, get: function() {
      return connection_1.ConnectionError;
    } });
    Object.defineProperty(exports$12, "CancellationReceiverStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationReceiverStrategy;
    } });
    Object.defineProperty(exports$12, "CancellationSenderStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationSenderStrategy;
    } });
    Object.defineProperty(exports$12, "CancellationStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationStrategy;
    } });
    Object.defineProperty(exports$12, "MessageStrategy", { enumerable: true, get: function() {
      return connection_1.MessageStrategy;
    } });
    const ral_1 = requireRal();
    exports$12.RAL = ral_1.default;
  })(api$1);
  return api$1;
}
var hasRequiredRil;
function requireRil() {
  if (hasRequiredRil) return ril;
  hasRequiredRil = 1;
  Object.defineProperty(ril, "__esModule", { value: true });
  const api_1 = requireApi$1();
  class MessageBuffer extends api_1.AbstractMessageBuffer {
    constructor(encoding = "utf-8") {
      super(encoding);
      this.asciiDecoder = new TextDecoder("ascii");
    }
    emptyBuffer() {
      return MessageBuffer.emptyBuffer;
    }
    fromString(value, _encoding) {
      return new TextEncoder().encode(value);
    }
    toString(value, encoding) {
      if (encoding === "ascii") {
        return this.asciiDecoder.decode(value);
      } else {
        return new TextDecoder(encoding).decode(value);
      }
    }
    asNative(buffer, length) {
      if (length === void 0) {
        return buffer;
      } else {
        return buffer.slice(0, length);
      }
    }
    allocNative(length) {
      return new Uint8Array(length);
    }
  }
  MessageBuffer.emptyBuffer = new Uint8Array(0);
  class ReadableStreamWrapper {
    constructor(socket) {
      this.socket = socket;
      this._onData = new api_1.Emitter();
      this._messageListener = (event) => {
        const blob = event.data;
        blob.arrayBuffer().then((buffer) => {
          this._onData.fire(new Uint8Array(buffer));
        }, () => {
          (0, api_1.RAL)().console.error(`Converting blob to array buffer failed.`);
        });
      };
      this.socket.addEventListener("message", this._messageListener);
    }
    onClose(listener) {
      this.socket.addEventListener("close", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("close", listener));
    }
    onError(listener) {
      this.socket.addEventListener("error", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("error", listener));
    }
    onEnd(listener) {
      this.socket.addEventListener("end", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("end", listener));
    }
    onData(listener) {
      return this._onData.event(listener);
    }
  }
  class WritableStreamWrapper {
    constructor(socket) {
      this.socket = socket;
    }
    onClose(listener) {
      this.socket.addEventListener("close", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("close", listener));
    }
    onError(listener) {
      this.socket.addEventListener("error", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("error", listener));
    }
    onEnd(listener) {
      this.socket.addEventListener("end", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("end", listener));
    }
    write(data, encoding) {
      if (typeof data === "string") {
        if (encoding !== void 0 && encoding !== "utf-8") {
          throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${encoding}`);
        }
        this.socket.send(data);
      } else {
        this.socket.send(data);
      }
      return Promise.resolve();
    }
    end() {
      this.socket.close();
    }
  }
  const _textEncoder = new TextEncoder();
  const _ril = Object.freeze({
    messageBuffer: Object.freeze({
      create: (encoding) => new MessageBuffer(encoding)
    }),
    applicationJson: Object.freeze({
      encoder: Object.freeze({
        name: "application/json",
        encode: (msg, options2) => {
          if (options2.charset !== "utf-8") {
            throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${options2.charset}`);
          }
          return Promise.resolve(_textEncoder.encode(JSON.stringify(msg, void 0, 0)));
        }
      }),
      decoder: Object.freeze({
        name: "application/json",
        decode: (buffer, options2) => {
          if (!(buffer instanceof Uint8Array)) {
            throw new Error(`In a Browser environments only Uint8Arrays are supported.`);
          }
          return Promise.resolve(JSON.parse(new TextDecoder(options2.charset).decode(buffer)));
        }
      })
    }),
    stream: Object.freeze({
      asReadableStream: (socket) => new ReadableStreamWrapper(socket),
      asWritableStream: (socket) => new WritableStreamWrapper(socket)
    }),
    console,
    timer: Object.freeze({
      setTimeout(callback, ms2, ...args) {
        const handle = setTimeout(callback, ms2, ...args);
        return { dispose: () => clearTimeout(handle) };
      },
      setImmediate(callback, ...args) {
        const handle = setTimeout(callback, 0, ...args);
        return { dispose: () => clearTimeout(handle) };
      },
      setInterval(callback, ms2, ...args) {
        const handle = setInterval(callback, ms2, ...args);
        return { dispose: () => clearInterval(handle) };
      }
    })
  });
  function RIL() {
    return _ril;
  }
  (function(RIL2) {
    function install() {
      api_1.RAL.install(_ril);
    }
    RIL2.install = install;
  })(RIL || (RIL = {}));
  ril.default = RIL;
  return ril;
}
var hasRequiredMain$1;
function requireMain$1() {
  if (hasRequiredMain$1) return main$1;
  hasRequiredMain$1 = 1;
  (function(exports$12) {
    var __createBinding = main$1 && main$1.__createBinding || (Object.create ? (function(o, m, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m, k2);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k2];
        } };
      }
      Object.defineProperty(o, k22, desc);
    }) : (function(o, m, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o[k22] = m[k2];
    }));
    var __exportStar = main$1 && main$1.__exportStar || function(m, exports$122) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports$122, p)) __createBinding(exports$122, m, p);
    };
    Object.defineProperty(exports$12, "__esModule", { value: true });
    exports$12.createMessageConnection = exports$12.BrowserMessageWriter = exports$12.BrowserMessageReader = void 0;
    const ril_1 = requireRil();
    ril_1.default.install();
    const api_1 = requireApi$1();
    __exportStar(requireApi$1(), exports$12);
    class BrowserMessageReader extends api_1.AbstractMessageReader {
      constructor(port) {
        super();
        this._onData = new api_1.Emitter();
        this._messageListener = (event) => {
          this._onData.fire(event.data);
        };
        port.addEventListener("error", (event) => this.fireError(event));
        port.onmessage = this._messageListener;
      }
      listen(callback) {
        return this._onData.event(callback);
      }
    }
    exports$12.BrowserMessageReader = BrowserMessageReader;
    class BrowserMessageWriter extends api_1.AbstractMessageWriter {
      constructor(port) {
        super();
        this.port = port;
        this.errorCount = 0;
        port.addEventListener("error", (event) => this.fireError(event));
      }
      write(msg) {
        try {
          this.port.postMessage(msg);
          return Promise.resolve();
        } catch (error) {
          this.handleError(error, msg);
          return Promise.reject(error);
        }
      }
      handleError(error, msg) {
        this.errorCount++;
        this.fireError(error, msg, this.errorCount);
      }
      end() {
      }
    }
    exports$12.BrowserMessageWriter = BrowserMessageWriter;
    function createMessageConnection2(reader, writer, logger, options2) {
      if (logger === void 0) {
        logger = api_1.NullLogger;
      }
      if (api_1.ConnectionStrategy.is(options2)) {
        options2 = { connectionStrategy: options2 };
      }
      return (0, api_1.createMessageConnection)(reader, writer, logger, options2);
    }
    exports$12.createMessageConnection = createMessageConnection2;
  })(main$1);
  return main$1;
}
var browser$1;
var hasRequiredBrowser$1;
function requireBrowser$1() {
  if (hasRequiredBrowser$1) return browser$1;
  hasRequiredBrowser$1 = 1;
  browser$1 = requireMain$1();
  return browser$1;
}
var api = {};
var DocumentUri;
(function(DocumentUri2) {
  function is2(value) {
    return typeof value === "string";
  }
  DocumentUri2.is = is2;
})(DocumentUri || (DocumentUri = {}));
var URI;
(function(URI2) {
  function is2(value) {
    return typeof value === "string";
  }
  URI2.is = is2;
})(URI || (URI = {}));
var integer;
(function(integer2) {
  integer2.MIN_VALUE = -2147483648;
  integer2.MAX_VALUE = 2147483647;
  function is2(value) {
    return typeof value === "number" && integer2.MIN_VALUE <= value && value <= integer2.MAX_VALUE;
  }
  integer2.is = is2;
})(integer || (integer = {}));
var uinteger;
(function(uinteger2) {
  uinteger2.MIN_VALUE = 0;
  uinteger2.MAX_VALUE = 2147483647;
  function is2(value) {
    return typeof value === "number" && uinteger2.MIN_VALUE <= value && value <= uinteger2.MAX_VALUE;
  }
  uinteger2.is = is2;
})(uinteger || (uinteger = {}));
var Position;
(function(Position2) {
  function create2(line2, character) {
    if (line2 === Number.MAX_VALUE) {
      line2 = uinteger.MAX_VALUE;
    }
    if (character === Number.MAX_VALUE) {
      character = uinteger.MAX_VALUE;
    }
    return { line: line2, character };
  }
  Position2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Is.uinteger(candidate.line) && Is.uinteger(candidate.character);
  }
  Position2.is = is2;
})(Position || (Position = {}));
var Range4;
(function(Range5) {
  function create2(one, two, three, four) {
    if (Is.uinteger(one) && Is.uinteger(two) && Is.uinteger(three) && Is.uinteger(four)) {
      return { start: Position.create(one, two), end: Position.create(three, four) };
    } else if (Position.is(one) && Position.is(two)) {
      return { start: one, end: two };
    } else {
      throw new Error(`Range#create called with invalid arguments[${one}, ${two}, ${three}, ${four}]`);
    }
  }
  Range5.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Position.is(candidate.start) && Position.is(candidate.end);
  }
  Range5.is = is2;
})(Range4 || (Range4 = {}));
var Location;
(function(Location2) {
  function create2(uri, range2) {
    return { uri, range: range2 };
  }
  Location2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Range4.is(candidate.range) && (Is.string(candidate.uri) || Is.undefined(candidate.uri));
  }
  Location2.is = is2;
})(Location || (Location = {}));
var LocationLink;
(function(LocationLink2) {
  function create2(targetUri, targetRange, targetSelectionRange, originSelectionRange) {
    return { targetUri, targetRange, targetSelectionRange, originSelectionRange };
  }
  LocationLink2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Range4.is(candidate.targetRange) && Is.string(candidate.targetUri) && Range4.is(candidate.targetSelectionRange) && (Range4.is(candidate.originSelectionRange) || Is.undefined(candidate.originSelectionRange));
  }
  LocationLink2.is = is2;
})(LocationLink || (LocationLink = {}));
var Color;
(function(Color2) {
  function create2(red, green, blue, alpha) {
    return {
      red,
      green,
      blue,
      alpha
    };
  }
  Color2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.numberRange(candidate.red, 0, 1) && Is.numberRange(candidate.green, 0, 1) && Is.numberRange(candidate.blue, 0, 1) && Is.numberRange(candidate.alpha, 0, 1);
  }
  Color2.is = is2;
})(Color || (Color = {}));
var ColorInformation;
(function(ColorInformation2) {
  function create2(range2, color) {
    return {
      range: range2,
      color
    };
  }
  ColorInformation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Range4.is(candidate.range) && Color.is(candidate.color);
  }
  ColorInformation2.is = is2;
})(ColorInformation || (ColorInformation = {}));
var ColorPresentation;
(function(ColorPresentation2) {
  function create2(label2, textEdit, additionalTextEdits) {
    return {
      label: label2,
      textEdit,
      additionalTextEdits
    };
  }
  ColorPresentation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.undefined(candidate.textEdit) || TextEdit.is(candidate)) && (Is.undefined(candidate.additionalTextEdits) || Is.typedArray(candidate.additionalTextEdits, TextEdit.is));
  }
  ColorPresentation2.is = is2;
})(ColorPresentation || (ColorPresentation = {}));
var FoldingRangeKind;
(function(FoldingRangeKind2) {
  FoldingRangeKind2.Comment = "comment";
  FoldingRangeKind2.Imports = "imports";
  FoldingRangeKind2.Region = "region";
})(FoldingRangeKind || (FoldingRangeKind = {}));
var FoldingRange;
(function(FoldingRange2) {
  function create2(startLine, endLine, startCharacter, endCharacter, kind, collapsedText) {
    const result2 = {
      startLine,
      endLine
    };
    if (Is.defined(startCharacter)) {
      result2.startCharacter = startCharacter;
    }
    if (Is.defined(endCharacter)) {
      result2.endCharacter = endCharacter;
    }
    if (Is.defined(kind)) {
      result2.kind = kind;
    }
    if (Is.defined(collapsedText)) {
      result2.collapsedText = collapsedText;
    }
    return result2;
  }
  FoldingRange2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.uinteger(candidate.startLine) && Is.uinteger(candidate.startLine) && (Is.undefined(candidate.startCharacter) || Is.uinteger(candidate.startCharacter)) && (Is.undefined(candidate.endCharacter) || Is.uinteger(candidate.endCharacter)) && (Is.undefined(candidate.kind) || Is.string(candidate.kind));
  }
  FoldingRange2.is = is2;
})(FoldingRange || (FoldingRange = {}));
var DiagnosticRelatedInformation;
(function(DiagnosticRelatedInformation2) {
  function create2(location, message) {
    return {
      location,
      message
    };
  }
  DiagnosticRelatedInformation2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Location.is(candidate.location) && Is.string(candidate.message);
  }
  DiagnosticRelatedInformation2.is = is2;
})(DiagnosticRelatedInformation || (DiagnosticRelatedInformation = {}));
var DiagnosticSeverity;
(function(DiagnosticSeverity2) {
  DiagnosticSeverity2.Error = 1;
  DiagnosticSeverity2.Warning = 2;
  DiagnosticSeverity2.Information = 3;
  DiagnosticSeverity2.Hint = 4;
})(DiagnosticSeverity || (DiagnosticSeverity = {}));
var DiagnosticTag;
(function(DiagnosticTag2) {
  DiagnosticTag2.Unnecessary = 1;
  DiagnosticTag2.Deprecated = 2;
})(DiagnosticTag || (DiagnosticTag = {}));
var CodeDescription;
(function(CodeDescription2) {
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.string(candidate.href);
  }
  CodeDescription2.is = is2;
})(CodeDescription || (CodeDescription = {}));
var Diagnostic;
(function(Diagnostic2) {
  function create2(range2, message, severity, code2, source, relatedInformation) {
    let result2 = { range: range2, message };
    if (Is.defined(severity)) {
      result2.severity = severity;
    }
    if (Is.defined(code2)) {
      result2.code = code2;
    }
    if (Is.defined(source)) {
      result2.source = source;
    }
    if (Is.defined(relatedInformation)) {
      result2.relatedInformation = relatedInformation;
    }
    return result2;
  }
  Diagnostic2.create = create2;
  function is2(value) {
    var _a2;
    let candidate = value;
    return Is.defined(candidate) && Range4.is(candidate.range) && Is.string(candidate.message) && (Is.number(candidate.severity) || Is.undefined(candidate.severity)) && (Is.integer(candidate.code) || Is.string(candidate.code) || Is.undefined(candidate.code)) && (Is.undefined(candidate.codeDescription) || Is.string((_a2 = candidate.codeDescription) === null || _a2 === void 0 ? void 0 : _a2.href)) && (Is.string(candidate.source) || Is.undefined(candidate.source)) && (Is.undefined(candidate.relatedInformation) || Is.typedArray(candidate.relatedInformation, DiagnosticRelatedInformation.is));
  }
  Diagnostic2.is = is2;
})(Diagnostic || (Diagnostic = {}));
var Command;
(function(Command24) {
  function create2(title2, command2, ...args) {
    let result2 = { title: title2, command: command2 };
    if (Is.defined(args) && args.length > 0) {
      result2.arguments = args;
    }
    return result2;
  }
  Command24.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.title) && Is.string(candidate.command);
  }
  Command24.is = is2;
})(Command || (Command = {}));
var TextEdit;
(function(TextEdit2) {
  function replace2(range2, newText) {
    return { range: range2, newText };
  }
  TextEdit2.replace = replace2;
  function insert2(position2, newText) {
    return { range: { start: position2, end: position2 }, newText };
  }
  TextEdit2.insert = insert2;
  function del(range2) {
    return { range: range2, newText: "" };
  }
  TextEdit2.del = del;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.string(candidate.newText) && Range4.is(candidate.range);
  }
  TextEdit2.is = is2;
})(TextEdit || (TextEdit = {}));
var ChangeAnnotation;
(function(ChangeAnnotation2) {
  function create2(label2, needsConfirmation, description) {
    const result2 = { label: label2 };
    if (needsConfirmation !== void 0) {
      result2.needsConfirmation = needsConfirmation;
    }
    if (description !== void 0) {
      result2.description = description;
    }
    return result2;
  }
  ChangeAnnotation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.boolean(candidate.needsConfirmation) || candidate.needsConfirmation === void 0) && (Is.string(candidate.description) || candidate.description === void 0);
  }
  ChangeAnnotation2.is = is2;
})(ChangeAnnotation || (ChangeAnnotation = {}));
var ChangeAnnotationIdentifier;
(function(ChangeAnnotationIdentifier2) {
  function is2(value) {
    const candidate = value;
    return Is.string(candidate);
  }
  ChangeAnnotationIdentifier2.is = is2;
})(ChangeAnnotationIdentifier || (ChangeAnnotationIdentifier = {}));
var AnnotatedTextEdit;
(function(AnnotatedTextEdit2) {
  function replace2(range2, newText, annotation) {
    return { range: range2, newText, annotationId: annotation };
  }
  AnnotatedTextEdit2.replace = replace2;
  function insert2(position2, newText, annotation) {
    return { range: { start: position2, end: position2 }, newText, annotationId: annotation };
  }
  AnnotatedTextEdit2.insert = insert2;
  function del(range2, annotation) {
    return { range: range2, newText: "", annotationId: annotation };
  }
  AnnotatedTextEdit2.del = del;
  function is2(value) {
    const candidate = value;
    return TextEdit.is(candidate) && (ChangeAnnotation.is(candidate.annotationId) || ChangeAnnotationIdentifier.is(candidate.annotationId));
  }
  AnnotatedTextEdit2.is = is2;
})(AnnotatedTextEdit || (AnnotatedTextEdit = {}));
var TextDocumentEdit;
(function(TextDocumentEdit2) {
  function create2(textDocument, edits) {
    return { textDocument, edits };
  }
  TextDocumentEdit2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && OptionalVersionedTextDocumentIdentifier.is(candidate.textDocument) && Array.isArray(candidate.edits);
  }
  TextDocumentEdit2.is = is2;
})(TextDocumentEdit || (TextDocumentEdit = {}));
var CreateFile;
(function(CreateFile2) {
  function create2(uri, options2, annotation) {
    let result2 = {
      kind: "create",
      uri
    };
    if (options2 !== void 0 && (options2.overwrite !== void 0 || options2.ignoreIfExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  CreateFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "create" && Is.string(candidate.uri) && (candidate.options === void 0 || (candidate.options.overwrite === void 0 || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === void 0 || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier.is(candidate.annotationId));
  }
  CreateFile2.is = is2;
})(CreateFile || (CreateFile = {}));
var RenameFile;
(function(RenameFile2) {
  function create2(oldUri, newUri, options2, annotation) {
    let result2 = {
      kind: "rename",
      oldUri,
      newUri
    };
    if (options2 !== void 0 && (options2.overwrite !== void 0 || options2.ignoreIfExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  RenameFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "rename" && Is.string(candidate.oldUri) && Is.string(candidate.newUri) && (candidate.options === void 0 || (candidate.options.overwrite === void 0 || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === void 0 || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier.is(candidate.annotationId));
  }
  RenameFile2.is = is2;
})(RenameFile || (RenameFile = {}));
var DeleteFile;
(function(DeleteFile2) {
  function create2(uri, options2, annotation) {
    let result2 = {
      kind: "delete",
      uri
    };
    if (options2 !== void 0 && (options2.recursive !== void 0 || options2.ignoreIfNotExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  DeleteFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "delete" && Is.string(candidate.uri) && (candidate.options === void 0 || (candidate.options.recursive === void 0 || Is.boolean(candidate.options.recursive)) && (candidate.options.ignoreIfNotExists === void 0 || Is.boolean(candidate.options.ignoreIfNotExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier.is(candidate.annotationId));
  }
  DeleteFile2.is = is2;
})(DeleteFile || (DeleteFile = {}));
var WorkspaceEdit;
(function(WorkspaceEdit2) {
  function is2(value) {
    let candidate = value;
    return candidate && (candidate.changes !== void 0 || candidate.documentChanges !== void 0) && (candidate.documentChanges === void 0 || candidate.documentChanges.every((change) => {
      if (Is.string(change.kind)) {
        return CreateFile.is(change) || RenameFile.is(change) || DeleteFile.is(change);
      } else {
        return TextDocumentEdit.is(change);
      }
    }));
  }
  WorkspaceEdit2.is = is2;
})(WorkspaceEdit || (WorkspaceEdit = {}));
class TextEditChangeImpl {
  constructor(edits, changeAnnotations) {
    this.edits = edits;
    this.changeAnnotations = changeAnnotations;
  }
  insert(position2, newText, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit.insert(position2, newText);
    } else if (ChangeAnnotationIdentifier.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit.insert(position2, newText, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit.insert(position2, newText, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  replace(range2, newText, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit.replace(range2, newText);
    } else if (ChangeAnnotationIdentifier.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit.replace(range2, newText, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit.replace(range2, newText, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  delete(range2, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit.del(range2);
    } else if (ChangeAnnotationIdentifier.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit.del(range2, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit.del(range2, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  add(edit) {
    this.edits.push(edit);
  }
  all() {
    return this.edits;
  }
  clear() {
    this.edits.splice(0, this.edits.length);
  }
  assertChangeAnnotations(value) {
    if (value === void 0) {
      throw new Error(`Text edit change is not configured to manage change annotations.`);
    }
  }
}
class ChangeAnnotations {
  constructor(annotations) {
    this._annotations = annotations === void 0 ? /* @__PURE__ */ Object.create(null) : annotations;
    this._counter = 0;
    this._size = 0;
  }
  all() {
    return this._annotations;
  }
  get size() {
    return this._size;
  }
  manage(idOrAnnotation, annotation) {
    let id2;
    if (ChangeAnnotationIdentifier.is(idOrAnnotation)) {
      id2 = idOrAnnotation;
    } else {
      id2 = this.nextId();
      annotation = idOrAnnotation;
    }
    if (this._annotations[id2] !== void 0) {
      throw new Error(`Id ${id2} is already in use.`);
    }
    if (annotation === void 0) {
      throw new Error(`No annotation provided for id ${id2}`);
    }
    this._annotations[id2] = annotation;
    this._size++;
    return id2;
  }
  nextId() {
    this._counter++;
    return this._counter.toString();
  }
}
class WorkspaceChange {
  constructor(workspaceEdit) {
    this._textEditChanges = /* @__PURE__ */ Object.create(null);
    if (workspaceEdit !== void 0) {
      this._workspaceEdit = workspaceEdit;
      if (workspaceEdit.documentChanges) {
        this._changeAnnotations = new ChangeAnnotations(workspaceEdit.changeAnnotations);
        workspaceEdit.changeAnnotations = this._changeAnnotations.all();
        workspaceEdit.documentChanges.forEach((change) => {
          if (TextDocumentEdit.is(change)) {
            const textEditChange = new TextEditChangeImpl(change.edits, this._changeAnnotations);
            this._textEditChanges[change.textDocument.uri] = textEditChange;
          }
        });
      } else if (workspaceEdit.changes) {
        Object.keys(workspaceEdit.changes).forEach((key) => {
          const textEditChange = new TextEditChangeImpl(workspaceEdit.changes[key]);
          this._textEditChanges[key] = textEditChange;
        });
      }
    } else {
      this._workspaceEdit = {};
    }
  }
  /**
   * Returns the underlying {@link WorkspaceEdit} literal
   * use to be returned from a workspace edit operation like rename.
   */
  get edit() {
    this.initDocumentChanges();
    if (this._changeAnnotations !== void 0) {
      if (this._changeAnnotations.size === 0) {
        this._workspaceEdit.changeAnnotations = void 0;
      } else {
        this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
      }
    }
    return this._workspaceEdit;
  }
  getTextEditChange(key) {
    if (OptionalVersionedTextDocumentIdentifier.is(key)) {
      this.initDocumentChanges();
      if (this._workspaceEdit.documentChanges === void 0) {
        throw new Error("Workspace edit is not configured for document changes.");
      }
      const textDocument = { uri: key.uri, version: key.version };
      let result2 = this._textEditChanges[textDocument.uri];
      if (!result2) {
        const edits = [];
        const textDocumentEdit = {
          textDocument,
          edits
        };
        this._workspaceEdit.documentChanges.push(textDocumentEdit);
        result2 = new TextEditChangeImpl(edits, this._changeAnnotations);
        this._textEditChanges[textDocument.uri] = result2;
      }
      return result2;
    } else {
      this.initChanges();
      if (this._workspaceEdit.changes === void 0) {
        throw new Error("Workspace edit is not configured for normal text edit changes.");
      }
      let result2 = this._textEditChanges[key];
      if (!result2) {
        let edits = [];
        this._workspaceEdit.changes[key] = edits;
        result2 = new TextEditChangeImpl(edits);
        this._textEditChanges[key] = result2;
      }
      return result2;
    }
  }
  initDocumentChanges() {
    if (this._workspaceEdit.documentChanges === void 0 && this._workspaceEdit.changes === void 0) {
      this._changeAnnotations = new ChangeAnnotations();
      this._workspaceEdit.documentChanges = [];
      this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
    }
  }
  initChanges() {
    if (this._workspaceEdit.documentChanges === void 0 && this._workspaceEdit.changes === void 0) {
      this._workspaceEdit.changes = /* @__PURE__ */ Object.create(null);
    }
  }
  createFile(uri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = CreateFile.create(uri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = CreateFile.create(uri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
  renameFile(oldUri, newUri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = RenameFile.create(oldUri, newUri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = RenameFile.create(oldUri, newUri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
  deleteFile(uri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = DeleteFile.create(uri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = DeleteFile.create(uri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
}
var TextDocumentIdentifier;
(function(TextDocumentIdentifier2) {
  function create2(uri) {
    return { uri };
  }
  TextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri);
  }
  TextDocumentIdentifier2.is = is2;
})(TextDocumentIdentifier || (TextDocumentIdentifier = {}));
var VersionedTextDocumentIdentifier;
(function(VersionedTextDocumentIdentifier2) {
  function create2(uri, version2) {
    return { uri, version: version2 };
  }
  VersionedTextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri) && Is.integer(candidate.version);
  }
  VersionedTextDocumentIdentifier2.is = is2;
})(VersionedTextDocumentIdentifier || (VersionedTextDocumentIdentifier = {}));
var OptionalVersionedTextDocumentIdentifier;
(function(OptionalVersionedTextDocumentIdentifier2) {
  function create2(uri, version2) {
    return { uri, version: version2 };
  }
  OptionalVersionedTextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri) && (candidate.version === null || Is.integer(candidate.version));
  }
  OptionalVersionedTextDocumentIdentifier2.is = is2;
})(OptionalVersionedTextDocumentIdentifier || (OptionalVersionedTextDocumentIdentifier = {}));
var TextDocumentItem;
(function(TextDocumentItem2) {
  function create2(uri, languageId, version2, text2) {
    return { uri, languageId, version: version2, text: text2 };
  }
  TextDocumentItem2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri) && Is.string(candidate.languageId) && Is.integer(candidate.version) && Is.string(candidate.text);
  }
  TextDocumentItem2.is = is2;
})(TextDocumentItem || (TextDocumentItem = {}));
var MarkupKind;
(function(MarkupKind2) {
  MarkupKind2.PlainText = "plaintext";
  MarkupKind2.Markdown = "markdown";
  function is2(value) {
    const candidate = value;
    return candidate === MarkupKind2.PlainText || candidate === MarkupKind2.Markdown;
  }
  MarkupKind2.is = is2;
})(MarkupKind || (MarkupKind = {}));
var MarkupContent;
(function(MarkupContent2) {
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(value) && MarkupKind.is(candidate.kind) && Is.string(candidate.value);
  }
  MarkupContent2.is = is2;
})(MarkupContent || (MarkupContent = {}));
var CompletionItemKind;
(function(CompletionItemKind2) {
  CompletionItemKind2.Text = 1;
  CompletionItemKind2.Method = 2;
  CompletionItemKind2.Function = 3;
  CompletionItemKind2.Constructor = 4;
  CompletionItemKind2.Field = 5;
  CompletionItemKind2.Variable = 6;
  CompletionItemKind2.Class = 7;
  CompletionItemKind2.Interface = 8;
  CompletionItemKind2.Module = 9;
  CompletionItemKind2.Property = 10;
  CompletionItemKind2.Unit = 11;
  CompletionItemKind2.Value = 12;
  CompletionItemKind2.Enum = 13;
  CompletionItemKind2.Keyword = 14;
  CompletionItemKind2.Snippet = 15;
  CompletionItemKind2.Color = 16;
  CompletionItemKind2.File = 17;
  CompletionItemKind2.Reference = 18;
  CompletionItemKind2.Folder = 19;
  CompletionItemKind2.EnumMember = 20;
  CompletionItemKind2.Constant = 21;
  CompletionItemKind2.Struct = 22;
  CompletionItemKind2.Event = 23;
  CompletionItemKind2.Operator = 24;
  CompletionItemKind2.TypeParameter = 25;
})(CompletionItemKind || (CompletionItemKind = {}));
var InsertTextFormat;
(function(InsertTextFormat2) {
  InsertTextFormat2.PlainText = 1;
  InsertTextFormat2.Snippet = 2;
})(InsertTextFormat || (InsertTextFormat = {}));
var CompletionItemTag;
(function(CompletionItemTag2) {
  CompletionItemTag2.Deprecated = 1;
})(CompletionItemTag || (CompletionItemTag = {}));
var InsertReplaceEdit;
(function(InsertReplaceEdit2) {
  function create2(newText, insert2, replace2) {
    return { newText, insert: insert2, replace: replace2 };
  }
  InsertReplaceEdit2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate && Is.string(candidate.newText) && Range4.is(candidate.insert) && Range4.is(candidate.replace);
  }
  InsertReplaceEdit2.is = is2;
})(InsertReplaceEdit || (InsertReplaceEdit = {}));
var InsertTextMode;
(function(InsertTextMode2) {
  InsertTextMode2.asIs = 1;
  InsertTextMode2.adjustIndentation = 2;
})(InsertTextMode || (InsertTextMode = {}));
var CompletionItemLabelDetails;
(function(CompletionItemLabelDetails2) {
  function is2(value) {
    const candidate = value;
    return candidate && (Is.string(candidate.detail) || candidate.detail === void 0) && (Is.string(candidate.description) || candidate.description === void 0);
  }
  CompletionItemLabelDetails2.is = is2;
})(CompletionItemLabelDetails || (CompletionItemLabelDetails = {}));
var CompletionItem;
(function(CompletionItem2) {
  function create2(label2) {
    return { label: label2 };
  }
  CompletionItem2.create = create2;
})(CompletionItem || (CompletionItem = {}));
var CompletionList;
(function(CompletionList2) {
  function create2(items, isIncomplete) {
    return { items: items ? items : [], isIncomplete: !!isIncomplete };
  }
  CompletionList2.create = create2;
})(CompletionList || (CompletionList = {}));
var MarkedString;
(function(MarkedString2) {
  function fromPlainText(plainText) {
    return plainText.replace(/[\\`*_{}[\]()#+\-.!]/g, "\\$&");
  }
  MarkedString2.fromPlainText = fromPlainText;
  function is2(value) {
    const candidate = value;
    return Is.string(candidate) || Is.objectLiteral(candidate) && Is.string(candidate.language) && Is.string(candidate.value);
  }
  MarkedString2.is = is2;
})(MarkedString || (MarkedString = {}));
var Hover;
(function(Hover2) {
  function is2(value) {
    let candidate = value;
    return !!candidate && Is.objectLiteral(candidate) && (MarkupContent.is(candidate.contents) || MarkedString.is(candidate.contents) || Is.typedArray(candidate.contents, MarkedString.is)) && (value.range === void 0 || Range4.is(value.range));
  }
  Hover2.is = is2;
})(Hover || (Hover = {}));
var ParameterInformation;
(function(ParameterInformation2) {
  function create2(label2, documentation) {
    return documentation ? { label: label2, documentation } : { label: label2 };
  }
  ParameterInformation2.create = create2;
})(ParameterInformation || (ParameterInformation = {}));
var SignatureInformation;
(function(SignatureInformation2) {
  function create2(label2, documentation, ...parameters) {
    let result2 = { label: label2 };
    if (Is.defined(documentation)) {
      result2.documentation = documentation;
    }
    if (Is.defined(parameters)) {
      result2.parameters = parameters;
    } else {
      result2.parameters = [];
    }
    return result2;
  }
  SignatureInformation2.create = create2;
})(SignatureInformation || (SignatureInformation = {}));
var DocumentHighlightKind;
(function(DocumentHighlightKind2) {
  DocumentHighlightKind2.Text = 1;
  DocumentHighlightKind2.Read = 2;
  DocumentHighlightKind2.Write = 3;
})(DocumentHighlightKind || (DocumentHighlightKind = {}));
var DocumentHighlight;
(function(DocumentHighlight2) {
  function create2(range2, kind) {
    let result2 = { range: range2 };
    if (Is.number(kind)) {
      result2.kind = kind;
    }
    return result2;
  }
  DocumentHighlight2.create = create2;
})(DocumentHighlight || (DocumentHighlight = {}));
var SymbolKind;
(function(SymbolKind2) {
  SymbolKind2.File = 1;
  SymbolKind2.Module = 2;
  SymbolKind2.Namespace = 3;
  SymbolKind2.Package = 4;
  SymbolKind2.Class = 5;
  SymbolKind2.Method = 6;
  SymbolKind2.Property = 7;
  SymbolKind2.Field = 8;
  SymbolKind2.Constructor = 9;
  SymbolKind2.Enum = 10;
  SymbolKind2.Interface = 11;
  SymbolKind2.Function = 12;
  SymbolKind2.Variable = 13;
  SymbolKind2.Constant = 14;
  SymbolKind2.String = 15;
  SymbolKind2.Number = 16;
  SymbolKind2.Boolean = 17;
  SymbolKind2.Array = 18;
  SymbolKind2.Object = 19;
  SymbolKind2.Key = 20;
  SymbolKind2.Null = 21;
  SymbolKind2.EnumMember = 22;
  SymbolKind2.Struct = 23;
  SymbolKind2.Event = 24;
  SymbolKind2.Operator = 25;
  SymbolKind2.TypeParameter = 26;
})(SymbolKind || (SymbolKind = {}));
var SymbolTag;
(function(SymbolTag2) {
  SymbolTag2.Deprecated = 1;
})(SymbolTag || (SymbolTag = {}));
var SymbolInformation;
(function(SymbolInformation2) {
  function create2(name2, kind, range2, uri, containerName) {
    let result2 = {
      name: name2,
      kind,
      location: { uri, range: range2 }
    };
    if (containerName) {
      result2.containerName = containerName;
    }
    return result2;
  }
  SymbolInformation2.create = create2;
})(SymbolInformation || (SymbolInformation = {}));
var WorkspaceSymbol;
(function(WorkspaceSymbol2) {
  function create2(name2, kind, uri, range2) {
    return range2 !== void 0 ? { name: name2, kind, location: { uri, range: range2 } } : { name: name2, kind, location: { uri } };
  }
  WorkspaceSymbol2.create = create2;
})(WorkspaceSymbol || (WorkspaceSymbol = {}));
var DocumentSymbol;
(function(DocumentSymbol2) {
  function create2(name2, detail, kind, range2, selectionRange, children) {
    let result2 = {
      name: name2,
      detail,
      kind,
      range: range2,
      selectionRange
    };
    if (children !== void 0) {
      result2.children = children;
    }
    return result2;
  }
  DocumentSymbol2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && Is.string(candidate.name) && Is.number(candidate.kind) && Range4.is(candidate.range) && Range4.is(candidate.selectionRange) && (candidate.detail === void 0 || Is.string(candidate.detail)) && (candidate.deprecated === void 0 || Is.boolean(candidate.deprecated)) && (candidate.children === void 0 || Array.isArray(candidate.children)) && (candidate.tags === void 0 || Array.isArray(candidate.tags));
  }
  DocumentSymbol2.is = is2;
})(DocumentSymbol || (DocumentSymbol = {}));
var CodeActionKind;
(function(CodeActionKind2) {
  CodeActionKind2.Empty = "";
  CodeActionKind2.QuickFix = "quickfix";
  CodeActionKind2.Refactor = "refactor";
  CodeActionKind2.RefactorExtract = "refactor.extract";
  CodeActionKind2.RefactorInline = "refactor.inline";
  CodeActionKind2.RefactorRewrite = "refactor.rewrite";
  CodeActionKind2.Source = "source";
  CodeActionKind2.SourceOrganizeImports = "source.organizeImports";
  CodeActionKind2.SourceFixAll = "source.fixAll";
})(CodeActionKind || (CodeActionKind = {}));
var CodeActionTriggerKind;
(function(CodeActionTriggerKind2) {
  CodeActionTriggerKind2.Invoked = 1;
  CodeActionTriggerKind2.Automatic = 2;
})(CodeActionTriggerKind || (CodeActionTriggerKind = {}));
var CodeActionContext;
(function(CodeActionContext2) {
  function create2(diagnostics, only, triggerKind) {
    let result2 = { diagnostics };
    if (only !== void 0 && only !== null) {
      result2.only = only;
    }
    if (triggerKind !== void 0 && triggerKind !== null) {
      result2.triggerKind = triggerKind;
    }
    return result2;
  }
  CodeActionContext2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.typedArray(candidate.diagnostics, Diagnostic.is) && (candidate.only === void 0 || Is.typedArray(candidate.only, Is.string)) && (candidate.triggerKind === void 0 || candidate.triggerKind === CodeActionTriggerKind.Invoked || candidate.triggerKind === CodeActionTriggerKind.Automatic);
  }
  CodeActionContext2.is = is2;
})(CodeActionContext || (CodeActionContext = {}));
var CodeAction;
(function(CodeAction2) {
  function create2(title2, kindOrCommandOrEdit, kind) {
    let result2 = { title: title2 };
    let checkKind = true;
    if (typeof kindOrCommandOrEdit === "string") {
      checkKind = false;
      result2.kind = kindOrCommandOrEdit;
    } else if (Command.is(kindOrCommandOrEdit)) {
      result2.command = kindOrCommandOrEdit;
    } else {
      result2.edit = kindOrCommandOrEdit;
    }
    if (checkKind && kind !== void 0) {
      result2.kind = kind;
    }
    return result2;
  }
  CodeAction2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && Is.string(candidate.title) && (candidate.diagnostics === void 0 || Is.typedArray(candidate.diagnostics, Diagnostic.is)) && (candidate.kind === void 0 || Is.string(candidate.kind)) && (candidate.edit !== void 0 || candidate.command !== void 0) && (candidate.command === void 0 || Command.is(candidate.command)) && (candidate.isPreferred === void 0 || Is.boolean(candidate.isPreferred)) && (candidate.edit === void 0 || WorkspaceEdit.is(candidate.edit));
  }
  CodeAction2.is = is2;
})(CodeAction || (CodeAction = {}));
var CodeLens;
(function(CodeLens2) {
  function create2(range2, data) {
    let result2 = { range: range2 };
    if (Is.defined(data)) {
      result2.data = data;
    }
    return result2;
  }
  CodeLens2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Range4.is(candidate.range) && (Is.undefined(candidate.command) || Command.is(candidate.command));
  }
  CodeLens2.is = is2;
})(CodeLens || (CodeLens = {}));
var FormattingOptions;
(function(FormattingOptions2) {
  function create2(tabSize, insertSpaces) {
    return { tabSize, insertSpaces };
  }
  FormattingOptions2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.uinteger(candidate.tabSize) && Is.boolean(candidate.insertSpaces);
  }
  FormattingOptions2.is = is2;
})(FormattingOptions || (FormattingOptions = {}));
var DocumentLink;
(function(DocumentLink2) {
  function create2(range2, target, data) {
    return { range: range2, target, data };
  }
  DocumentLink2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Range4.is(candidate.range) && (Is.undefined(candidate.target) || Is.string(candidate.target));
  }
  DocumentLink2.is = is2;
})(DocumentLink || (DocumentLink = {}));
var SelectionRange2;
(function(SelectionRange3) {
  function create2(range2, parent) {
    return { range: range2, parent };
  }
  SelectionRange3.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Range4.is(candidate.range) && (candidate.parent === void 0 || SelectionRange3.is(candidate.parent));
  }
  SelectionRange3.is = is2;
})(SelectionRange2 || (SelectionRange2 = {}));
var SemanticTokenTypes;
(function(SemanticTokenTypes2) {
  SemanticTokenTypes2["namespace"] = "namespace";
  SemanticTokenTypes2["type"] = "type";
  SemanticTokenTypes2["class"] = "class";
  SemanticTokenTypes2["enum"] = "enum";
  SemanticTokenTypes2["interface"] = "interface";
  SemanticTokenTypes2["struct"] = "struct";
  SemanticTokenTypes2["typeParameter"] = "typeParameter";
  SemanticTokenTypes2["parameter"] = "parameter";
  SemanticTokenTypes2["variable"] = "variable";
  SemanticTokenTypes2["property"] = "property";
  SemanticTokenTypes2["enumMember"] = "enumMember";
  SemanticTokenTypes2["event"] = "event";
  SemanticTokenTypes2["function"] = "function";
  SemanticTokenTypes2["method"] = "method";
  SemanticTokenTypes2["macro"] = "macro";
  SemanticTokenTypes2["keyword"] = "keyword";
  SemanticTokenTypes2["modifier"] = "modifier";
  SemanticTokenTypes2["comment"] = "comment";
  SemanticTokenTypes2["string"] = "string";
  SemanticTokenTypes2["number"] = "number";
  SemanticTokenTypes2["regexp"] = "regexp";
  SemanticTokenTypes2["operator"] = "operator";
  SemanticTokenTypes2["decorator"] = "decorator";
})(SemanticTokenTypes || (SemanticTokenTypes = {}));
var SemanticTokenModifiers;
(function(SemanticTokenModifiers2) {
  SemanticTokenModifiers2["declaration"] = "declaration";
  SemanticTokenModifiers2["definition"] = "definition";
  SemanticTokenModifiers2["readonly"] = "readonly";
  SemanticTokenModifiers2["static"] = "static";
  SemanticTokenModifiers2["deprecated"] = "deprecated";
  SemanticTokenModifiers2["abstract"] = "abstract";
  SemanticTokenModifiers2["async"] = "async";
  SemanticTokenModifiers2["modification"] = "modification";
  SemanticTokenModifiers2["documentation"] = "documentation";
  SemanticTokenModifiers2["defaultLibrary"] = "defaultLibrary";
})(SemanticTokenModifiers || (SemanticTokenModifiers = {}));
var SemanticTokens;
(function(SemanticTokens2) {
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && (candidate.resultId === void 0 || typeof candidate.resultId === "string") && Array.isArray(candidate.data) && (candidate.data.length === 0 || typeof candidate.data[0] === "number");
  }
  SemanticTokens2.is = is2;
})(SemanticTokens || (SemanticTokens = {}));
var InlineValueText;
(function(InlineValueText2) {
  function create2(range2, text2) {
    return { range: range2, text: text2 };
  }
  InlineValueText2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range4.is(candidate.range) && Is.string(candidate.text);
  }
  InlineValueText2.is = is2;
})(InlineValueText || (InlineValueText = {}));
var InlineValueVariableLookup;
(function(InlineValueVariableLookup2) {
  function create2(range2, variableName, caseSensitiveLookup) {
    return { range: range2, variableName, caseSensitiveLookup };
  }
  InlineValueVariableLookup2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range4.is(candidate.range) && Is.boolean(candidate.caseSensitiveLookup) && (Is.string(candidate.variableName) || candidate.variableName === void 0);
  }
  InlineValueVariableLookup2.is = is2;
})(InlineValueVariableLookup || (InlineValueVariableLookup = {}));
var InlineValueEvaluatableExpression;
(function(InlineValueEvaluatableExpression2) {
  function create2(range2, expression) {
    return { range: range2, expression };
  }
  InlineValueEvaluatableExpression2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range4.is(candidate.range) && (Is.string(candidate.expression) || candidate.expression === void 0);
  }
  InlineValueEvaluatableExpression2.is = is2;
})(InlineValueEvaluatableExpression || (InlineValueEvaluatableExpression = {}));
var InlineValueContext;
(function(InlineValueContext2) {
  function create2(frameId, stoppedLocation) {
    return { frameId, stoppedLocation };
  }
  InlineValueContext2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.defined(candidate) && Range4.is(value.stoppedLocation);
  }
  InlineValueContext2.is = is2;
})(InlineValueContext || (InlineValueContext = {}));
var InlayHintKind;
(function(InlayHintKind2) {
  InlayHintKind2.Type = 1;
  InlayHintKind2.Parameter = 2;
  function is2(value) {
    return value === 1 || value === 2;
  }
  InlayHintKind2.is = is2;
})(InlayHintKind || (InlayHintKind = {}));
var InlayHintLabelPart;
(function(InlayHintLabelPart2) {
  function create2(value) {
    return { value };
  }
  InlayHintLabelPart2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && (candidate.tooltip === void 0 || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.location === void 0 || Location.is(candidate.location)) && (candidate.command === void 0 || Command.is(candidate.command));
  }
  InlayHintLabelPart2.is = is2;
})(InlayHintLabelPart || (InlayHintLabelPart = {}));
var InlayHint;
(function(InlayHint2) {
  function create2(position2, label2, kind) {
    const result2 = { position: position2, label: label2 };
    if (kind !== void 0) {
      result2.kind = kind;
    }
    return result2;
  }
  InlayHint2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Position.is(candidate.position) && (Is.string(candidate.label) || Is.typedArray(candidate.label, InlayHintLabelPart.is)) && (candidate.kind === void 0 || InlayHintKind.is(candidate.kind)) && candidate.textEdits === void 0 || Is.typedArray(candidate.textEdits, TextEdit.is) && (candidate.tooltip === void 0 || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.paddingLeft === void 0 || Is.boolean(candidate.paddingLeft)) && (candidate.paddingRight === void 0 || Is.boolean(candidate.paddingRight));
  }
  InlayHint2.is = is2;
})(InlayHint || (InlayHint = {}));
var StringValue;
(function(StringValue2) {
  function createSnippet(value) {
    return { kind: "snippet", value };
  }
  StringValue2.createSnippet = createSnippet;
})(StringValue || (StringValue = {}));
var InlineCompletionItem;
(function(InlineCompletionItem2) {
  function create2(insertText, filterText, range2, command2) {
    return { insertText, filterText, range: range2, command: command2 };
  }
  InlineCompletionItem2.create = create2;
})(InlineCompletionItem || (InlineCompletionItem = {}));
var InlineCompletionList;
(function(InlineCompletionList2) {
  function create2(items) {
    return { items };
  }
  InlineCompletionList2.create = create2;
})(InlineCompletionList || (InlineCompletionList = {}));
var InlineCompletionTriggerKind;
(function(InlineCompletionTriggerKind2) {
  InlineCompletionTriggerKind2.Invoked = 0;
  InlineCompletionTriggerKind2.Automatic = 1;
})(InlineCompletionTriggerKind || (InlineCompletionTriggerKind = {}));
var SelectedCompletionInfo;
(function(SelectedCompletionInfo2) {
  function create2(range2, text2) {
    return { range: range2, text: text2 };
  }
  SelectedCompletionInfo2.create = create2;
})(SelectedCompletionInfo || (SelectedCompletionInfo = {}));
var InlineCompletionContext;
(function(InlineCompletionContext2) {
  function create2(triggerKind, selectedCompletionInfo) {
    return { triggerKind, selectedCompletionInfo };
  }
  InlineCompletionContext2.create = create2;
})(InlineCompletionContext || (InlineCompletionContext = {}));
var WorkspaceFolder;
(function(WorkspaceFolder2) {
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && URI.is(candidate.uri) && Is.string(candidate.name);
  }
  WorkspaceFolder2.is = is2;
})(WorkspaceFolder || (WorkspaceFolder = {}));
const EOL = ["\n", "\r\n", "\r"];
var TextDocument;
(function(TextDocument2) {
  function create2(uri, languageId, version2, content2) {
    return new FullTextDocument(uri, languageId, version2, content2);
  }
  TextDocument2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri) && (Is.undefined(candidate.languageId) || Is.string(candidate.languageId)) && Is.uinteger(candidate.lineCount) && Is.func(candidate.getText) && Is.func(candidate.positionAt) && Is.func(candidate.offsetAt) ? true : false;
  }
  TextDocument2.is = is2;
  function applyEdits(document2, edits) {
    let text2 = document2.getText();
    let sortedEdits = mergeSort(edits, (a, b2) => {
      let diff = a.range.start.line - b2.range.start.line;
      if (diff === 0) {
        return a.range.start.character - b2.range.start.character;
      }
      return diff;
    });
    let lastModifiedOffset = text2.length;
    for (let i2 = sortedEdits.length - 1; i2 >= 0; i2--) {
      let e2 = sortedEdits[i2];
      let startOffset = document2.offsetAt(e2.range.start);
      let endOffset = document2.offsetAt(e2.range.end);
      if (endOffset <= lastModifiedOffset) {
        text2 = text2.substring(0, startOffset) + e2.newText + text2.substring(endOffset, text2.length);
      } else {
        throw new Error("Overlapping edit");
      }
      lastModifiedOffset = startOffset;
    }
    return text2;
  }
  TextDocument2.applyEdits = applyEdits;
  function mergeSort(data, compare2) {
    if (data.length <= 1) {
      return data;
    }
    const p = data.length / 2 | 0;
    const left = data.slice(0, p);
    const right = data.slice(p);
    mergeSort(left, compare2);
    mergeSort(right, compare2);
    let leftIdx = 0;
    let rightIdx = 0;
    let i2 = 0;
    while (leftIdx < left.length && rightIdx < right.length) {
      let ret = compare2(left[leftIdx], right[rightIdx]);
      if (ret <= 0) {
        data[i2++] = left[leftIdx++];
      } else {
        data[i2++] = right[rightIdx++];
      }
    }
    while (leftIdx < left.length) {
      data[i2++] = left[leftIdx++];
    }
    while (rightIdx < right.length) {
      data[i2++] = right[rightIdx++];
    }
    return data;
  }
})(TextDocument || (TextDocument = {}));
class FullTextDocument {
  constructor(uri, languageId, version2, content2) {
    this._uri = uri;
    this._languageId = languageId;
    this._version = version2;
    this._content = content2;
    this._lineOffsets = void 0;
  }
  get uri() {
    return this._uri;
  }
  get languageId() {
    return this._languageId;
  }
  get version() {
    return this._version;
  }
  getText(range2) {
    if (range2) {
      let start = this.offsetAt(range2.start);
      let end = this.offsetAt(range2.end);
      return this._content.substring(start, end);
    }
    return this._content;
  }
  update(event, version2) {
    this._content = event.text;
    this._version = version2;
    this._lineOffsets = void 0;
  }
  getLineOffsets() {
    if (this._lineOffsets === void 0) {
      let lineOffsets = [];
      let text2 = this._content;
      let isLineStart = true;
      for (let i2 = 0; i2 < text2.length; i2++) {
        if (isLineStart) {
          lineOffsets.push(i2);
          isLineStart = false;
        }
        let ch = text2.charAt(i2);
        isLineStart = ch === "\r" || ch === "\n";
        if (ch === "\r" && i2 + 1 < text2.length && text2.charAt(i2 + 1) === "\n") {
          i2++;
        }
      }
      if (isLineStart && text2.length > 0) {
        lineOffsets.push(text2.length);
      }
      this._lineOffsets = lineOffsets;
    }
    return this._lineOffsets;
  }
  positionAt(offset2) {
    offset2 = Math.max(Math.min(offset2, this._content.length), 0);
    let lineOffsets = this.getLineOffsets();
    let low = 0, high = lineOffsets.length;
    if (high === 0) {
      return Position.create(0, offset2);
    }
    while (low < high) {
      let mid = Math.floor((low + high) / 2);
      if (lineOffsets[mid] > offset2) {
        high = mid;
      } else {
        low = mid + 1;
      }
    }
    let line2 = low - 1;
    return Position.create(line2, offset2 - lineOffsets[line2]);
  }
  offsetAt(position2) {
    let lineOffsets = this.getLineOffsets();
    if (position2.line >= lineOffsets.length) {
      return this._content.length;
    } else if (position2.line < 0) {
      return 0;
    }
    let lineOffset = lineOffsets[position2.line];
    let nextLineOffset = position2.line + 1 < lineOffsets.length ? lineOffsets[position2.line + 1] : this._content.length;
    return Math.max(Math.min(lineOffset + position2.character, nextLineOffset), lineOffset);
  }
  get lineCount() {
    return this.getLineOffsets().length;
  }
}
var Is;
(function(Is2) {
  const toString2 = Object.prototype.toString;
  function defined(value) {
    return typeof value !== "undefined";
  }
  Is2.defined = defined;
  function undefined$1(value) {
    return typeof value === "undefined";
  }
  Is2.undefined = undefined$1;
  function boolean(value) {
    return value === true || value === false;
  }
  Is2.boolean = boolean;
  function string2(value) {
    return toString2.call(value) === "[object String]";
  }
  Is2.string = string2;
  function number2(value) {
    return toString2.call(value) === "[object Number]";
  }
  Is2.number = number2;
  function numberRange(value, min2, max2) {
    return toString2.call(value) === "[object Number]" && min2 <= value && value <= max2;
  }
  Is2.numberRange = numberRange;
  function integer2(value) {
    return toString2.call(value) === "[object Number]" && -2147483648 <= value && value <= 2147483647;
  }
  Is2.integer = integer2;
  function uinteger2(value) {
    return toString2.call(value) === "[object Number]" && 0 <= value && value <= 2147483647;
  }
  Is2.uinteger = uinteger2;
  function func(value) {
    return toString2.call(value) === "[object Function]";
  }
  Is2.func = func;
  function objectLiteral(value) {
    return value !== null && typeof value === "object";
  }
  Is2.objectLiteral = objectLiteral;
  function typedArray(value, check) {
    return Array.isArray(value) && value.every(check);
  }
  Is2.typedArray = typedArray;
})(Is || (Is = {}));
const main = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get AnnotatedTextEdit() {
    return AnnotatedTextEdit;
  },
  get ChangeAnnotation() {
    return ChangeAnnotation;
  },
  get ChangeAnnotationIdentifier() {
    return ChangeAnnotationIdentifier;
  },
  get CodeAction() {
    return CodeAction;
  },
  get CodeActionContext() {
    return CodeActionContext;
  },
  get CodeActionKind() {
    return CodeActionKind;
  },
  get CodeActionTriggerKind() {
    return CodeActionTriggerKind;
  },
  get CodeDescription() {
    return CodeDescription;
  },
  get CodeLens() {
    return CodeLens;
  },
  get Color() {
    return Color;
  },
  get ColorInformation() {
    return ColorInformation;
  },
  get ColorPresentation() {
    return ColorPresentation;
  },
  get Command() {
    return Command;
  },
  get CompletionItem() {
    return CompletionItem;
  },
  get CompletionItemKind() {
    return CompletionItemKind;
  },
  get CompletionItemLabelDetails() {
    return CompletionItemLabelDetails;
  },
  get CompletionItemTag() {
    return CompletionItemTag;
  },
  get CompletionList() {
    return CompletionList;
  },
  get CreateFile() {
    return CreateFile;
  },
  get DeleteFile() {
    return DeleteFile;
  },
  get Diagnostic() {
    return Diagnostic;
  },
  get DiagnosticRelatedInformation() {
    return DiagnosticRelatedInformation;
  },
  get DiagnosticSeverity() {
    return DiagnosticSeverity;
  },
  get DiagnosticTag() {
    return DiagnosticTag;
  },
  get DocumentHighlight() {
    return DocumentHighlight;
  },
  get DocumentHighlightKind() {
    return DocumentHighlightKind;
  },
  get DocumentLink() {
    return DocumentLink;
  },
  get DocumentSymbol() {
    return DocumentSymbol;
  },
  get DocumentUri() {
    return DocumentUri;
  },
  EOL,
  get FoldingRange() {
    return FoldingRange;
  },
  get FoldingRangeKind() {
    return FoldingRangeKind;
  },
  get FormattingOptions() {
    return FormattingOptions;
  },
  get Hover() {
    return Hover;
  },
  get InlayHint() {
    return InlayHint;
  },
  get InlayHintKind() {
    return InlayHintKind;
  },
  get InlayHintLabelPart() {
    return InlayHintLabelPart;
  },
  get InlineCompletionContext() {
    return InlineCompletionContext;
  },
  get InlineCompletionItem() {
    return InlineCompletionItem;
  },
  get InlineCompletionList() {
    return InlineCompletionList;
  },
  get InlineCompletionTriggerKind() {
    return InlineCompletionTriggerKind;
  },
  get InlineValueContext() {
    return InlineValueContext;
  },
  get InlineValueEvaluatableExpression() {
    return InlineValueEvaluatableExpression;
  },
  get InlineValueText() {
    return InlineValueText;
  },
  get InlineValueVariableLookup() {
    return InlineValueVariableLookup;
  },
  get InsertReplaceEdit() {
    return InsertReplaceEdit;
  },
  get InsertTextFormat() {
    return InsertTextFormat;
  },
  get InsertTextMode() {
    return InsertTextMode;
  },
  get Location() {
    return Location;
  },
  get LocationLink() {
    return LocationLink;
  },
  get MarkedString() {
    return MarkedString;
  },
  get MarkupContent() {
    return MarkupContent;
  },
  get MarkupKind() {
    return MarkupKind;
  },
  get OptionalVersionedTextDocumentIdentifier() {
    return OptionalVersionedTextDocumentIdentifier;
  },
  get ParameterInformation() {
    return ParameterInformation;
  },
  get Position() {
    return Position;
  },
  get Range() {
    return Range4;
  },
  get RenameFile() {
    return RenameFile;
  },
  get SelectedCompletionInfo() {
    return SelectedCompletionInfo;
  },
  get SelectionRange() {
    return SelectionRange2;
  },
  get SemanticTokenModifiers() {
    return SemanticTokenModifiers;
  },
  get SemanticTokenTypes() {
    return SemanticTokenTypes;
  },
  get SemanticTokens() {
    return SemanticTokens;
  },
  get SignatureInformation() {
    return SignatureInformation;
  },
  get StringValue() {
    return StringValue;
  },
  get SymbolInformation() {
    return SymbolInformation;
  },
  get SymbolKind() {
    return SymbolKind;
  },
  get SymbolTag() {
    return SymbolTag;
  },
  get TextDocument() {
    return TextDocument;
  },
  get TextDocumentEdit() {
    return TextDocumentEdit;
  },
  get TextDocumentIdentifier() {
    return TextDocumentIdentifier;
  },
  get TextDocumentItem() {
    return TextDocumentItem;
  },
  get TextEdit() {
    return TextEdit;
  },
  get URI() {
    return URI;
  },
  get VersionedTextDocumentIdentifier() {
    return VersionedTextDocumentIdentifier;
  },
  WorkspaceChange,
  get WorkspaceEdit() {
    return WorkspaceEdit;
  },
  get WorkspaceFolder() {
    return WorkspaceFolder;
  },
  get WorkspaceSymbol() {
    return WorkspaceSymbol;
  },
  get integer() {
    return integer;
  },
  get uinteger() {
    return uinteger;
  }
}, Symbol.toStringTag, { value: "Module" }));
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(main);
var messages = {};
var hasRequiredMessages;
function requireMessages() {
  if (hasRequiredMessages) return messages;
  hasRequiredMessages = 1;
  Object.defineProperty(messages, "__esModule", { value: true });
  messages.ProtocolNotificationType = messages.ProtocolNotificationType0 = messages.ProtocolRequestType = messages.ProtocolRequestType0 = messages.RegistrationType = messages.MessageDirection = void 0;
  const vscode_jsonrpc_1 = requireMain$1();
  var MessageDirection;
  (function(MessageDirection2) {
    MessageDirection2["clientToServer"] = "clientToServer";
    MessageDirection2["serverToClient"] = "serverToClient";
    MessageDirection2["both"] = "both";
  })(MessageDirection || (messages.MessageDirection = MessageDirection = {}));
  class RegistrationType {
    constructor(method) {
      this.method = method;
    }
  }
  messages.RegistrationType = RegistrationType;
  class ProtocolRequestType0 extends vscode_jsonrpc_1.RequestType0 {
    constructor(method) {
      super(method);
    }
  }
  messages.ProtocolRequestType0 = ProtocolRequestType0;
  class ProtocolRequestType extends vscode_jsonrpc_1.RequestType {
    constructor(method) {
      super(method, vscode_jsonrpc_1.ParameterStructures.byName);
    }
  }
  messages.ProtocolRequestType = ProtocolRequestType;
  class ProtocolNotificationType0 extends vscode_jsonrpc_1.NotificationType0 {
    constructor(method) {
      super(method);
    }
  }
  messages.ProtocolNotificationType0 = ProtocolNotificationType0;
  class ProtocolNotificationType extends vscode_jsonrpc_1.NotificationType {
    constructor(method) {
      super(method, vscode_jsonrpc_1.ParameterStructures.byName);
    }
  }
  messages.ProtocolNotificationType = ProtocolNotificationType;
  return messages;
}
var protocol = {};
var is = {};
var hasRequiredIs;
function requireIs() {
  if (hasRequiredIs) return is;
  hasRequiredIs = 1;
  Object.defineProperty(is, "__esModule", { value: true });
  is.objectLiteral = is.typedArray = is.stringArray = is.array = is.func = is.error = is.number = is.string = is.boolean = void 0;
  function boolean(value) {
    return value === true || value === false;
  }
  is.boolean = boolean;
  function string2(value) {
    return typeof value === "string" || value instanceof String;
  }
  is.string = string2;
  function number2(value) {
    return typeof value === "number" || value instanceof Number;
  }
  is.number = number2;
  function error(value) {
    return value instanceof Error;
  }
  is.error = error;
  function func(value) {
    return typeof value === "function";
  }
  is.func = func;
  function array(value) {
    return Array.isArray(value);
  }
  is.array = array;
  function stringArray(value) {
    return array(value) && value.every((elem) => string2(elem));
  }
  is.stringArray = stringArray;
  function typedArray(value, check) {
    return Array.isArray(value) && value.every(check);
  }
  is.typedArray = typedArray;
  function objectLiteral(value) {
    return value !== null && typeof value === "object";
  }
  is.objectLiteral = objectLiteral;
  return is;
}
var protocol_implementation = {};
var hasRequiredProtocol_implementation;
function requireProtocol_implementation() {
  if (hasRequiredProtocol_implementation) return protocol_implementation;
  hasRequiredProtocol_implementation = 1;
  Object.defineProperty(protocol_implementation, "__esModule", { value: true });
  protocol_implementation.ImplementationRequest = void 0;
  const messages_1 = requireMessages();
  var ImplementationRequest;
  (function(ImplementationRequest2) {
    ImplementationRequest2.method = "textDocument/implementation";
    ImplementationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    ImplementationRequest2.type = new messages_1.ProtocolRequestType(ImplementationRequest2.method);
  })(ImplementationRequest || (protocol_implementation.ImplementationRequest = ImplementationRequest = {}));
  return protocol_implementation;
}
var protocol_typeDefinition = {};
var hasRequiredProtocol_typeDefinition;
function requireProtocol_typeDefinition() {
  if (hasRequiredProtocol_typeDefinition) return protocol_typeDefinition;
  hasRequiredProtocol_typeDefinition = 1;
  Object.defineProperty(protocol_typeDefinition, "__esModule", { value: true });
  protocol_typeDefinition.TypeDefinitionRequest = void 0;
  const messages_1 = requireMessages();
  var TypeDefinitionRequest;
  (function(TypeDefinitionRequest2) {
    TypeDefinitionRequest2.method = "textDocument/typeDefinition";
    TypeDefinitionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeDefinitionRequest2.type = new messages_1.ProtocolRequestType(TypeDefinitionRequest2.method);
  })(TypeDefinitionRequest || (protocol_typeDefinition.TypeDefinitionRequest = TypeDefinitionRequest = {}));
  return protocol_typeDefinition;
}
var protocol_workspaceFolder = {};
var hasRequiredProtocol_workspaceFolder;
function requireProtocol_workspaceFolder() {
  if (hasRequiredProtocol_workspaceFolder) return protocol_workspaceFolder;
  hasRequiredProtocol_workspaceFolder = 1;
  Object.defineProperty(protocol_workspaceFolder, "__esModule", { value: true });
  protocol_workspaceFolder.DidChangeWorkspaceFoldersNotification = protocol_workspaceFolder.WorkspaceFoldersRequest = void 0;
  const messages_1 = requireMessages();
  var WorkspaceFoldersRequest;
  (function(WorkspaceFoldersRequest2) {
    WorkspaceFoldersRequest2.method = "workspace/workspaceFolders";
    WorkspaceFoldersRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    WorkspaceFoldersRequest2.type = new messages_1.ProtocolRequestType0(WorkspaceFoldersRequest2.method);
  })(WorkspaceFoldersRequest || (protocol_workspaceFolder.WorkspaceFoldersRequest = WorkspaceFoldersRequest = {}));
  var DidChangeWorkspaceFoldersNotification;
  (function(DidChangeWorkspaceFoldersNotification2) {
    DidChangeWorkspaceFoldersNotification2.method = "workspace/didChangeWorkspaceFolders";
    DidChangeWorkspaceFoldersNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidChangeWorkspaceFoldersNotification2.type = new messages_1.ProtocolNotificationType(DidChangeWorkspaceFoldersNotification2.method);
  })(DidChangeWorkspaceFoldersNotification || (protocol_workspaceFolder.DidChangeWorkspaceFoldersNotification = DidChangeWorkspaceFoldersNotification = {}));
  return protocol_workspaceFolder;
}
var protocol_configuration = {};
var hasRequiredProtocol_configuration;
function requireProtocol_configuration() {
  if (hasRequiredProtocol_configuration) return protocol_configuration;
  hasRequiredProtocol_configuration = 1;
  Object.defineProperty(protocol_configuration, "__esModule", { value: true });
  protocol_configuration.ConfigurationRequest = void 0;
  const messages_1 = requireMessages();
  var ConfigurationRequest;
  (function(ConfigurationRequest2) {
    ConfigurationRequest2.method = "workspace/configuration";
    ConfigurationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    ConfigurationRequest2.type = new messages_1.ProtocolRequestType(ConfigurationRequest2.method);
  })(ConfigurationRequest || (protocol_configuration.ConfigurationRequest = ConfigurationRequest = {}));
  return protocol_configuration;
}
var protocol_colorProvider = {};
var hasRequiredProtocol_colorProvider;
function requireProtocol_colorProvider() {
  if (hasRequiredProtocol_colorProvider) return protocol_colorProvider;
  hasRequiredProtocol_colorProvider = 1;
  Object.defineProperty(protocol_colorProvider, "__esModule", { value: true });
  protocol_colorProvider.ColorPresentationRequest = protocol_colorProvider.DocumentColorRequest = void 0;
  const messages_1 = requireMessages();
  var DocumentColorRequest;
  (function(DocumentColorRequest2) {
    DocumentColorRequest2.method = "textDocument/documentColor";
    DocumentColorRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DocumentColorRequest2.type = new messages_1.ProtocolRequestType(DocumentColorRequest2.method);
  })(DocumentColorRequest || (protocol_colorProvider.DocumentColorRequest = DocumentColorRequest = {}));
  var ColorPresentationRequest;
  (function(ColorPresentationRequest2) {
    ColorPresentationRequest2.method = "textDocument/colorPresentation";
    ColorPresentationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    ColorPresentationRequest2.type = new messages_1.ProtocolRequestType(ColorPresentationRequest2.method);
  })(ColorPresentationRequest || (protocol_colorProvider.ColorPresentationRequest = ColorPresentationRequest = {}));
  return protocol_colorProvider;
}
var protocol_foldingRange = {};
var hasRequiredProtocol_foldingRange;
function requireProtocol_foldingRange() {
  if (hasRequiredProtocol_foldingRange) return protocol_foldingRange;
  hasRequiredProtocol_foldingRange = 1;
  Object.defineProperty(protocol_foldingRange, "__esModule", { value: true });
  protocol_foldingRange.FoldingRangeRefreshRequest = protocol_foldingRange.FoldingRangeRequest = void 0;
  const messages_1 = requireMessages();
  var FoldingRangeRequest;
  (function(FoldingRangeRequest2) {
    FoldingRangeRequest2.method = "textDocument/foldingRange";
    FoldingRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    FoldingRangeRequest2.type = new messages_1.ProtocolRequestType(FoldingRangeRequest2.method);
  })(FoldingRangeRequest || (protocol_foldingRange.FoldingRangeRequest = FoldingRangeRequest = {}));
  var FoldingRangeRefreshRequest;
  (function(FoldingRangeRefreshRequest2) {
    FoldingRangeRefreshRequest2.method = `workspace/foldingRange/refresh`;
    FoldingRangeRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    FoldingRangeRefreshRequest2.type = new messages_1.ProtocolRequestType0(FoldingRangeRefreshRequest2.method);
  })(FoldingRangeRefreshRequest || (protocol_foldingRange.FoldingRangeRefreshRequest = FoldingRangeRefreshRequest = {}));
  return protocol_foldingRange;
}
var protocol_declaration = {};
var hasRequiredProtocol_declaration;
function requireProtocol_declaration() {
  if (hasRequiredProtocol_declaration) return protocol_declaration;
  hasRequiredProtocol_declaration = 1;
  Object.defineProperty(protocol_declaration, "__esModule", { value: true });
  protocol_declaration.DeclarationRequest = void 0;
  const messages_1 = requireMessages();
  var DeclarationRequest;
  (function(DeclarationRequest2) {
    DeclarationRequest2.method = "textDocument/declaration";
    DeclarationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DeclarationRequest2.type = new messages_1.ProtocolRequestType(DeclarationRequest2.method);
  })(DeclarationRequest || (protocol_declaration.DeclarationRequest = DeclarationRequest = {}));
  return protocol_declaration;
}
var protocol_selectionRange = {};
var hasRequiredProtocol_selectionRange;
function requireProtocol_selectionRange() {
  if (hasRequiredProtocol_selectionRange) return protocol_selectionRange;
  hasRequiredProtocol_selectionRange = 1;
  Object.defineProperty(protocol_selectionRange, "__esModule", { value: true });
  protocol_selectionRange.SelectionRangeRequest = void 0;
  const messages_1 = requireMessages();
  var SelectionRangeRequest;
  (function(SelectionRangeRequest2) {
    SelectionRangeRequest2.method = "textDocument/selectionRange";
    SelectionRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SelectionRangeRequest2.type = new messages_1.ProtocolRequestType(SelectionRangeRequest2.method);
  })(SelectionRangeRequest || (protocol_selectionRange.SelectionRangeRequest = SelectionRangeRequest = {}));
  return protocol_selectionRange;
}
var protocol_progress = {};
var hasRequiredProtocol_progress;
function requireProtocol_progress() {
  if (hasRequiredProtocol_progress) return protocol_progress;
  hasRequiredProtocol_progress = 1;
  Object.defineProperty(protocol_progress, "__esModule", { value: true });
  protocol_progress.WorkDoneProgressCancelNotification = protocol_progress.WorkDoneProgressCreateRequest = protocol_progress.WorkDoneProgress = void 0;
  const vscode_jsonrpc_1 = requireMain$1();
  const messages_1 = requireMessages();
  var WorkDoneProgress;
  (function(WorkDoneProgress2) {
    WorkDoneProgress2.type = new vscode_jsonrpc_1.ProgressType();
    function is2(value) {
      return value === WorkDoneProgress2.type;
    }
    WorkDoneProgress2.is = is2;
  })(WorkDoneProgress || (protocol_progress.WorkDoneProgress = WorkDoneProgress = {}));
  var WorkDoneProgressCreateRequest;
  (function(WorkDoneProgressCreateRequest2) {
    WorkDoneProgressCreateRequest2.method = "window/workDoneProgress/create";
    WorkDoneProgressCreateRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    WorkDoneProgressCreateRequest2.type = new messages_1.ProtocolRequestType(WorkDoneProgressCreateRequest2.method);
  })(WorkDoneProgressCreateRequest || (protocol_progress.WorkDoneProgressCreateRequest = WorkDoneProgressCreateRequest = {}));
  var WorkDoneProgressCancelNotification;
  (function(WorkDoneProgressCancelNotification2) {
    WorkDoneProgressCancelNotification2.method = "window/workDoneProgress/cancel";
    WorkDoneProgressCancelNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    WorkDoneProgressCancelNotification2.type = new messages_1.ProtocolNotificationType(WorkDoneProgressCancelNotification2.method);
  })(WorkDoneProgressCancelNotification || (protocol_progress.WorkDoneProgressCancelNotification = WorkDoneProgressCancelNotification = {}));
  return protocol_progress;
}
var protocol_callHierarchy = {};
var hasRequiredProtocol_callHierarchy;
function requireProtocol_callHierarchy() {
  if (hasRequiredProtocol_callHierarchy) return protocol_callHierarchy;
  hasRequiredProtocol_callHierarchy = 1;
  Object.defineProperty(protocol_callHierarchy, "__esModule", { value: true });
  protocol_callHierarchy.CallHierarchyOutgoingCallsRequest = protocol_callHierarchy.CallHierarchyIncomingCallsRequest = protocol_callHierarchy.CallHierarchyPrepareRequest = void 0;
  const messages_1 = requireMessages();
  var CallHierarchyPrepareRequest;
  (function(CallHierarchyPrepareRequest2) {
    CallHierarchyPrepareRequest2.method = "textDocument/prepareCallHierarchy";
    CallHierarchyPrepareRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyPrepareRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyPrepareRequest2.method);
  })(CallHierarchyPrepareRequest || (protocol_callHierarchy.CallHierarchyPrepareRequest = CallHierarchyPrepareRequest = {}));
  var CallHierarchyIncomingCallsRequest;
  (function(CallHierarchyIncomingCallsRequest2) {
    CallHierarchyIncomingCallsRequest2.method = "callHierarchy/incomingCalls";
    CallHierarchyIncomingCallsRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyIncomingCallsRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyIncomingCallsRequest2.method);
  })(CallHierarchyIncomingCallsRequest || (protocol_callHierarchy.CallHierarchyIncomingCallsRequest = CallHierarchyIncomingCallsRequest = {}));
  var CallHierarchyOutgoingCallsRequest;
  (function(CallHierarchyOutgoingCallsRequest2) {
    CallHierarchyOutgoingCallsRequest2.method = "callHierarchy/outgoingCalls";
    CallHierarchyOutgoingCallsRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyOutgoingCallsRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyOutgoingCallsRequest2.method);
  })(CallHierarchyOutgoingCallsRequest || (protocol_callHierarchy.CallHierarchyOutgoingCallsRequest = CallHierarchyOutgoingCallsRequest = {}));
  return protocol_callHierarchy;
}
var protocol_semanticTokens = {};
var hasRequiredProtocol_semanticTokens;
function requireProtocol_semanticTokens() {
  if (hasRequiredProtocol_semanticTokens) return protocol_semanticTokens;
  hasRequiredProtocol_semanticTokens = 1;
  Object.defineProperty(protocol_semanticTokens, "__esModule", { value: true });
  protocol_semanticTokens.SemanticTokensRefreshRequest = protocol_semanticTokens.SemanticTokensRangeRequest = protocol_semanticTokens.SemanticTokensDeltaRequest = protocol_semanticTokens.SemanticTokensRequest = protocol_semanticTokens.SemanticTokensRegistrationType = protocol_semanticTokens.TokenFormat = void 0;
  const messages_1 = requireMessages();
  var TokenFormat;
  (function(TokenFormat2) {
    TokenFormat2.Relative = "relative";
  })(TokenFormat || (protocol_semanticTokens.TokenFormat = TokenFormat = {}));
  var SemanticTokensRegistrationType;
  (function(SemanticTokensRegistrationType2) {
    SemanticTokensRegistrationType2.method = "textDocument/semanticTokens";
    SemanticTokensRegistrationType2.type = new messages_1.RegistrationType(SemanticTokensRegistrationType2.method);
  })(SemanticTokensRegistrationType || (protocol_semanticTokens.SemanticTokensRegistrationType = SemanticTokensRegistrationType = {}));
  var SemanticTokensRequest;
  (function(SemanticTokensRequest2) {
    SemanticTokensRequest2.method = "textDocument/semanticTokens/full";
    SemanticTokensRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensRequest2.method);
    SemanticTokensRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensRequest || (protocol_semanticTokens.SemanticTokensRequest = SemanticTokensRequest = {}));
  var SemanticTokensDeltaRequest;
  (function(SemanticTokensDeltaRequest2) {
    SemanticTokensDeltaRequest2.method = "textDocument/semanticTokens/full/delta";
    SemanticTokensDeltaRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensDeltaRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensDeltaRequest2.method);
    SemanticTokensDeltaRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensDeltaRequest || (protocol_semanticTokens.SemanticTokensDeltaRequest = SemanticTokensDeltaRequest = {}));
  var SemanticTokensRangeRequest;
  (function(SemanticTokensRangeRequest2) {
    SemanticTokensRangeRequest2.method = "textDocument/semanticTokens/range";
    SemanticTokensRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensRangeRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensRangeRequest2.method);
    SemanticTokensRangeRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensRangeRequest || (protocol_semanticTokens.SemanticTokensRangeRequest = SemanticTokensRangeRequest = {}));
  var SemanticTokensRefreshRequest;
  (function(SemanticTokensRefreshRequest2) {
    SemanticTokensRefreshRequest2.method = `workspace/semanticTokens/refresh`;
    SemanticTokensRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    SemanticTokensRefreshRequest2.type = new messages_1.ProtocolRequestType0(SemanticTokensRefreshRequest2.method);
  })(SemanticTokensRefreshRequest || (protocol_semanticTokens.SemanticTokensRefreshRequest = SemanticTokensRefreshRequest = {}));
  return protocol_semanticTokens;
}
var protocol_showDocument = {};
var hasRequiredProtocol_showDocument;
function requireProtocol_showDocument() {
  if (hasRequiredProtocol_showDocument) return protocol_showDocument;
  hasRequiredProtocol_showDocument = 1;
  Object.defineProperty(protocol_showDocument, "__esModule", { value: true });
  protocol_showDocument.ShowDocumentRequest = void 0;
  const messages_1 = requireMessages();
  var ShowDocumentRequest;
  (function(ShowDocumentRequest2) {
    ShowDocumentRequest2.method = "window/showDocument";
    ShowDocumentRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    ShowDocumentRequest2.type = new messages_1.ProtocolRequestType(ShowDocumentRequest2.method);
  })(ShowDocumentRequest || (protocol_showDocument.ShowDocumentRequest = ShowDocumentRequest = {}));
  return protocol_showDocument;
}
var protocol_linkedEditingRange = {};
var hasRequiredProtocol_linkedEditingRange;
function requireProtocol_linkedEditingRange() {
  if (hasRequiredProtocol_linkedEditingRange) return protocol_linkedEditingRange;
  hasRequiredProtocol_linkedEditingRange = 1;
  Object.defineProperty(protocol_linkedEditingRange, "__esModule", { value: true });
  protocol_linkedEditingRange.LinkedEditingRangeRequest = void 0;
  const messages_1 = requireMessages();
  var LinkedEditingRangeRequest;
  (function(LinkedEditingRangeRequest2) {
    LinkedEditingRangeRequest2.method = "textDocument/linkedEditingRange";
    LinkedEditingRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    LinkedEditingRangeRequest2.type = new messages_1.ProtocolRequestType(LinkedEditingRangeRequest2.method);
  })(LinkedEditingRangeRequest || (protocol_linkedEditingRange.LinkedEditingRangeRequest = LinkedEditingRangeRequest = {}));
  return protocol_linkedEditingRange;
}
var protocol_fileOperations = {};
var hasRequiredProtocol_fileOperations;
function requireProtocol_fileOperations() {
  if (hasRequiredProtocol_fileOperations) return protocol_fileOperations;
  hasRequiredProtocol_fileOperations = 1;
  Object.defineProperty(protocol_fileOperations, "__esModule", { value: true });
  protocol_fileOperations.WillDeleteFilesRequest = protocol_fileOperations.DidDeleteFilesNotification = protocol_fileOperations.DidRenameFilesNotification = protocol_fileOperations.WillRenameFilesRequest = protocol_fileOperations.DidCreateFilesNotification = protocol_fileOperations.WillCreateFilesRequest = protocol_fileOperations.FileOperationPatternKind = void 0;
  const messages_1 = requireMessages();
  var FileOperationPatternKind;
  (function(FileOperationPatternKind2) {
    FileOperationPatternKind2.file = "file";
    FileOperationPatternKind2.folder = "folder";
  })(FileOperationPatternKind || (protocol_fileOperations.FileOperationPatternKind = FileOperationPatternKind = {}));
  var WillCreateFilesRequest;
  (function(WillCreateFilesRequest2) {
    WillCreateFilesRequest2.method = "workspace/willCreateFiles";
    WillCreateFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillCreateFilesRequest2.type = new messages_1.ProtocolRequestType(WillCreateFilesRequest2.method);
  })(WillCreateFilesRequest || (protocol_fileOperations.WillCreateFilesRequest = WillCreateFilesRequest = {}));
  var DidCreateFilesNotification;
  (function(DidCreateFilesNotification2) {
    DidCreateFilesNotification2.method = "workspace/didCreateFiles";
    DidCreateFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidCreateFilesNotification2.type = new messages_1.ProtocolNotificationType(DidCreateFilesNotification2.method);
  })(DidCreateFilesNotification || (protocol_fileOperations.DidCreateFilesNotification = DidCreateFilesNotification = {}));
  var WillRenameFilesRequest;
  (function(WillRenameFilesRequest2) {
    WillRenameFilesRequest2.method = "workspace/willRenameFiles";
    WillRenameFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillRenameFilesRequest2.type = new messages_1.ProtocolRequestType(WillRenameFilesRequest2.method);
  })(WillRenameFilesRequest || (protocol_fileOperations.WillRenameFilesRequest = WillRenameFilesRequest = {}));
  var DidRenameFilesNotification;
  (function(DidRenameFilesNotification2) {
    DidRenameFilesNotification2.method = "workspace/didRenameFiles";
    DidRenameFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidRenameFilesNotification2.type = new messages_1.ProtocolNotificationType(DidRenameFilesNotification2.method);
  })(DidRenameFilesNotification || (protocol_fileOperations.DidRenameFilesNotification = DidRenameFilesNotification = {}));
  var DidDeleteFilesNotification;
  (function(DidDeleteFilesNotification2) {
    DidDeleteFilesNotification2.method = "workspace/didDeleteFiles";
    DidDeleteFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidDeleteFilesNotification2.type = new messages_1.ProtocolNotificationType(DidDeleteFilesNotification2.method);
  })(DidDeleteFilesNotification || (protocol_fileOperations.DidDeleteFilesNotification = DidDeleteFilesNotification = {}));
  var WillDeleteFilesRequest;
  (function(WillDeleteFilesRequest2) {
    WillDeleteFilesRequest2.method = "workspace/willDeleteFiles";
    WillDeleteFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillDeleteFilesRequest2.type = new messages_1.ProtocolRequestType(WillDeleteFilesRequest2.method);
  })(WillDeleteFilesRequest || (protocol_fileOperations.WillDeleteFilesRequest = WillDeleteFilesRequest = {}));
  return protocol_fileOperations;
}
var protocol_moniker = {};
var hasRequiredProtocol_moniker;
function requireProtocol_moniker() {
  if (hasRequiredProtocol_moniker) return protocol_moniker;
  hasRequiredProtocol_moniker = 1;
  Object.defineProperty(protocol_moniker, "__esModule", { value: true });
  protocol_moniker.MonikerRequest = protocol_moniker.MonikerKind = protocol_moniker.UniquenessLevel = void 0;
  const messages_1 = requireMessages();
  var UniquenessLevel;
  (function(UniquenessLevel2) {
    UniquenessLevel2.document = "document";
    UniquenessLevel2.project = "project";
    UniquenessLevel2.group = "group";
    UniquenessLevel2.scheme = "scheme";
    UniquenessLevel2.global = "global";
  })(UniquenessLevel || (protocol_moniker.UniquenessLevel = UniquenessLevel = {}));
  var MonikerKind;
  (function(MonikerKind2) {
    MonikerKind2.$import = "import";
    MonikerKind2.$export = "export";
    MonikerKind2.local = "local";
  })(MonikerKind || (protocol_moniker.MonikerKind = MonikerKind = {}));
  var MonikerRequest;
  (function(MonikerRequest2) {
    MonikerRequest2.method = "textDocument/moniker";
    MonikerRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    MonikerRequest2.type = new messages_1.ProtocolRequestType(MonikerRequest2.method);
  })(MonikerRequest || (protocol_moniker.MonikerRequest = MonikerRequest = {}));
  return protocol_moniker;
}
var protocol_typeHierarchy = {};
var hasRequiredProtocol_typeHierarchy;
function requireProtocol_typeHierarchy() {
  if (hasRequiredProtocol_typeHierarchy) return protocol_typeHierarchy;
  hasRequiredProtocol_typeHierarchy = 1;
  Object.defineProperty(protocol_typeHierarchy, "__esModule", { value: true });
  protocol_typeHierarchy.TypeHierarchySubtypesRequest = protocol_typeHierarchy.TypeHierarchySupertypesRequest = protocol_typeHierarchy.TypeHierarchyPrepareRequest = void 0;
  const messages_1 = requireMessages();
  var TypeHierarchyPrepareRequest;
  (function(TypeHierarchyPrepareRequest2) {
    TypeHierarchyPrepareRequest2.method = "textDocument/prepareTypeHierarchy";
    TypeHierarchyPrepareRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchyPrepareRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchyPrepareRequest2.method);
  })(TypeHierarchyPrepareRequest || (protocol_typeHierarchy.TypeHierarchyPrepareRequest = TypeHierarchyPrepareRequest = {}));
  var TypeHierarchySupertypesRequest;
  (function(TypeHierarchySupertypesRequest2) {
    TypeHierarchySupertypesRequest2.method = "typeHierarchy/supertypes";
    TypeHierarchySupertypesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchySupertypesRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchySupertypesRequest2.method);
  })(TypeHierarchySupertypesRequest || (protocol_typeHierarchy.TypeHierarchySupertypesRequest = TypeHierarchySupertypesRequest = {}));
  var TypeHierarchySubtypesRequest;
  (function(TypeHierarchySubtypesRequest2) {
    TypeHierarchySubtypesRequest2.method = "typeHierarchy/subtypes";
    TypeHierarchySubtypesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchySubtypesRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchySubtypesRequest2.method);
  })(TypeHierarchySubtypesRequest || (protocol_typeHierarchy.TypeHierarchySubtypesRequest = TypeHierarchySubtypesRequest = {}));
  return protocol_typeHierarchy;
}
var protocol_inlineValue = {};
var hasRequiredProtocol_inlineValue;
function requireProtocol_inlineValue() {
  if (hasRequiredProtocol_inlineValue) return protocol_inlineValue;
  hasRequiredProtocol_inlineValue = 1;
  Object.defineProperty(protocol_inlineValue, "__esModule", { value: true });
  protocol_inlineValue.InlineValueRefreshRequest = protocol_inlineValue.InlineValueRequest = void 0;
  const messages_1 = requireMessages();
  var InlineValueRequest;
  (function(InlineValueRequest2) {
    InlineValueRequest2.method = "textDocument/inlineValue";
    InlineValueRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlineValueRequest2.type = new messages_1.ProtocolRequestType(InlineValueRequest2.method);
  })(InlineValueRequest || (protocol_inlineValue.InlineValueRequest = InlineValueRequest = {}));
  var InlineValueRefreshRequest;
  (function(InlineValueRefreshRequest2) {
    InlineValueRefreshRequest2.method = `workspace/inlineValue/refresh`;
    InlineValueRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    InlineValueRefreshRequest2.type = new messages_1.ProtocolRequestType0(InlineValueRefreshRequest2.method);
  })(InlineValueRefreshRequest || (protocol_inlineValue.InlineValueRefreshRequest = InlineValueRefreshRequest = {}));
  return protocol_inlineValue;
}
var protocol_inlayHint = {};
var hasRequiredProtocol_inlayHint;
function requireProtocol_inlayHint() {
  if (hasRequiredProtocol_inlayHint) return protocol_inlayHint;
  hasRequiredProtocol_inlayHint = 1;
  Object.defineProperty(protocol_inlayHint, "__esModule", { value: true });
  protocol_inlayHint.InlayHintRefreshRequest = protocol_inlayHint.InlayHintResolveRequest = protocol_inlayHint.InlayHintRequest = void 0;
  const messages_1 = requireMessages();
  var InlayHintRequest;
  (function(InlayHintRequest2) {
    InlayHintRequest2.method = "textDocument/inlayHint";
    InlayHintRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlayHintRequest2.type = new messages_1.ProtocolRequestType(InlayHintRequest2.method);
  })(InlayHintRequest || (protocol_inlayHint.InlayHintRequest = InlayHintRequest = {}));
  var InlayHintResolveRequest;
  (function(InlayHintResolveRequest2) {
    InlayHintResolveRequest2.method = "inlayHint/resolve";
    InlayHintResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlayHintResolveRequest2.type = new messages_1.ProtocolRequestType(InlayHintResolveRequest2.method);
  })(InlayHintResolveRequest || (protocol_inlayHint.InlayHintResolveRequest = InlayHintResolveRequest = {}));
  var InlayHintRefreshRequest;
  (function(InlayHintRefreshRequest2) {
    InlayHintRefreshRequest2.method = `workspace/inlayHint/refresh`;
    InlayHintRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    InlayHintRefreshRequest2.type = new messages_1.ProtocolRequestType0(InlayHintRefreshRequest2.method);
  })(InlayHintRefreshRequest || (protocol_inlayHint.InlayHintRefreshRequest = InlayHintRefreshRequest = {}));
  return protocol_inlayHint;
}
var protocol_diagnostic = {};
var hasRequiredProtocol_diagnostic;
function requireProtocol_diagnostic() {
  if (hasRequiredProtocol_diagnostic) return protocol_diagnostic;
  hasRequiredProtocol_diagnostic = 1;
  Object.defineProperty(protocol_diagnostic, "__esModule", { value: true });
  protocol_diagnostic.DiagnosticRefreshRequest = protocol_diagnostic.WorkspaceDiagnosticRequest = protocol_diagnostic.DocumentDiagnosticRequest = protocol_diagnostic.DocumentDiagnosticReportKind = protocol_diagnostic.DiagnosticServerCancellationData = void 0;
  const vscode_jsonrpc_1 = requireMain$1();
  const Is2 = requireIs();
  const messages_1 = requireMessages();
  var DiagnosticServerCancellationData;
  (function(DiagnosticServerCancellationData2) {
    function is2(value) {
      const candidate = value;
      return candidate && Is2.boolean(candidate.retriggerRequest);
    }
    DiagnosticServerCancellationData2.is = is2;
  })(DiagnosticServerCancellationData || (protocol_diagnostic.DiagnosticServerCancellationData = DiagnosticServerCancellationData = {}));
  var DocumentDiagnosticReportKind;
  (function(DocumentDiagnosticReportKind2) {
    DocumentDiagnosticReportKind2.Full = "full";
    DocumentDiagnosticReportKind2.Unchanged = "unchanged";
  })(DocumentDiagnosticReportKind || (protocol_diagnostic.DocumentDiagnosticReportKind = DocumentDiagnosticReportKind = {}));
  var DocumentDiagnosticRequest;
  (function(DocumentDiagnosticRequest2) {
    DocumentDiagnosticRequest2.method = "textDocument/diagnostic";
    DocumentDiagnosticRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DocumentDiagnosticRequest2.type = new messages_1.ProtocolRequestType(DocumentDiagnosticRequest2.method);
    DocumentDiagnosticRequest2.partialResult = new vscode_jsonrpc_1.ProgressType();
  })(DocumentDiagnosticRequest || (protocol_diagnostic.DocumentDiagnosticRequest = DocumentDiagnosticRequest = {}));
  var WorkspaceDiagnosticRequest;
  (function(WorkspaceDiagnosticRequest2) {
    WorkspaceDiagnosticRequest2.method = "workspace/diagnostic";
    WorkspaceDiagnosticRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WorkspaceDiagnosticRequest2.type = new messages_1.ProtocolRequestType(WorkspaceDiagnosticRequest2.method);
    WorkspaceDiagnosticRequest2.partialResult = new vscode_jsonrpc_1.ProgressType();
  })(WorkspaceDiagnosticRequest || (protocol_diagnostic.WorkspaceDiagnosticRequest = WorkspaceDiagnosticRequest = {}));
  var DiagnosticRefreshRequest;
  (function(DiagnosticRefreshRequest2) {
    DiagnosticRefreshRequest2.method = `workspace/diagnostic/refresh`;
    DiagnosticRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    DiagnosticRefreshRequest2.type = new messages_1.ProtocolRequestType0(DiagnosticRefreshRequest2.method);
  })(DiagnosticRefreshRequest || (protocol_diagnostic.DiagnosticRefreshRequest = DiagnosticRefreshRequest = {}));
  return protocol_diagnostic;
}
var protocol_notebook = {};
var hasRequiredProtocol_notebook;
function requireProtocol_notebook() {
  if (hasRequiredProtocol_notebook) return protocol_notebook;
  hasRequiredProtocol_notebook = 1;
  Object.defineProperty(protocol_notebook, "__esModule", { value: true });
  protocol_notebook.DidCloseNotebookDocumentNotification = protocol_notebook.DidSaveNotebookDocumentNotification = protocol_notebook.DidChangeNotebookDocumentNotification = protocol_notebook.NotebookCellArrayChange = protocol_notebook.DidOpenNotebookDocumentNotification = protocol_notebook.NotebookDocumentSyncRegistrationType = protocol_notebook.NotebookDocument = protocol_notebook.NotebookCell = protocol_notebook.ExecutionSummary = protocol_notebook.NotebookCellKind = void 0;
  const vscode_languageserver_types_1 = require$$1;
  const Is2 = requireIs();
  const messages_1 = requireMessages();
  var NotebookCellKind;
  (function(NotebookCellKind2) {
    NotebookCellKind2.Markup = 1;
    NotebookCellKind2.Code = 2;
    function is2(value) {
      return value === 1 || value === 2;
    }
    NotebookCellKind2.is = is2;
  })(NotebookCellKind || (protocol_notebook.NotebookCellKind = NotebookCellKind = {}));
  var ExecutionSummary;
  (function(ExecutionSummary2) {
    function create2(executionOrder, success) {
      const result2 = { executionOrder };
      if (success === true || success === false) {
        result2.success = success;
      }
      return result2;
    }
    ExecutionSummary2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && vscode_languageserver_types_1.uinteger.is(candidate.executionOrder) && (candidate.success === void 0 || Is2.boolean(candidate.success));
    }
    ExecutionSummary2.is = is2;
    function equals2(one, other) {
      if (one === other) {
        return true;
      }
      if (one === null || one === void 0 || other === null || other === void 0) {
        return false;
      }
      return one.executionOrder === other.executionOrder && one.success === other.success;
    }
    ExecutionSummary2.equals = equals2;
  })(ExecutionSummary || (protocol_notebook.ExecutionSummary = ExecutionSummary = {}));
  var NotebookCell;
  (function(NotebookCell2) {
    function create2(kind, document2) {
      return { kind, document: document2 };
    }
    NotebookCell2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && NotebookCellKind.is(candidate.kind) && vscode_languageserver_types_1.DocumentUri.is(candidate.document) && (candidate.metadata === void 0 || Is2.objectLiteral(candidate.metadata));
    }
    NotebookCell2.is = is2;
    function diff(one, two) {
      const result2 = /* @__PURE__ */ new Set();
      if (one.document !== two.document) {
        result2.add("document");
      }
      if (one.kind !== two.kind) {
        result2.add("kind");
      }
      if (one.executionSummary !== two.executionSummary) {
        result2.add("executionSummary");
      }
      if ((one.metadata !== void 0 || two.metadata !== void 0) && !equalsMetadata(one.metadata, two.metadata)) {
        result2.add("metadata");
      }
      if ((one.executionSummary !== void 0 || two.executionSummary !== void 0) && !ExecutionSummary.equals(one.executionSummary, two.executionSummary)) {
        result2.add("executionSummary");
      }
      return result2;
    }
    NotebookCell2.diff = diff;
    function equalsMetadata(one, other) {
      if (one === other) {
        return true;
      }
      if (one === null || one === void 0 || other === null || other === void 0) {
        return false;
      }
      if (typeof one !== typeof other) {
        return false;
      }
      if (typeof one !== "object") {
        return false;
      }
      const oneArray = Array.isArray(one);
      const otherArray = Array.isArray(other);
      if (oneArray !== otherArray) {
        return false;
      }
      if (oneArray && otherArray) {
        if (one.length !== other.length) {
          return false;
        }
        for (let i2 = 0; i2 < one.length; i2++) {
          if (!equalsMetadata(one[i2], other[i2])) {
            return false;
          }
        }
      }
      if (Is2.objectLiteral(one) && Is2.objectLiteral(other)) {
        const oneKeys = Object.keys(one);
        const otherKeys = Object.keys(other);
        if (oneKeys.length !== otherKeys.length) {
          return false;
        }
        oneKeys.sort();
        otherKeys.sort();
        if (!equalsMetadata(oneKeys, otherKeys)) {
          return false;
        }
        for (let i2 = 0; i2 < oneKeys.length; i2++) {
          const prop = oneKeys[i2];
          if (!equalsMetadata(one[prop], other[prop])) {
            return false;
          }
        }
      }
      return true;
    }
  })(NotebookCell || (protocol_notebook.NotebookCell = NotebookCell = {}));
  var NotebookDocument;
  (function(NotebookDocument2) {
    function create2(uri, notebookType, version2, cells) {
      return { uri, notebookType, version: version2, cells };
    }
    NotebookDocument2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && Is2.string(candidate.uri) && vscode_languageserver_types_1.integer.is(candidate.version) && Is2.typedArray(candidate.cells, NotebookCell.is);
    }
    NotebookDocument2.is = is2;
  })(NotebookDocument || (protocol_notebook.NotebookDocument = NotebookDocument = {}));
  var NotebookDocumentSyncRegistrationType;
  (function(NotebookDocumentSyncRegistrationType2) {
    NotebookDocumentSyncRegistrationType2.method = "notebookDocument/sync";
    NotebookDocumentSyncRegistrationType2.messageDirection = messages_1.MessageDirection.clientToServer;
    NotebookDocumentSyncRegistrationType2.type = new messages_1.RegistrationType(NotebookDocumentSyncRegistrationType2.method);
  })(NotebookDocumentSyncRegistrationType || (protocol_notebook.NotebookDocumentSyncRegistrationType = NotebookDocumentSyncRegistrationType = {}));
  var DidOpenNotebookDocumentNotification;
  (function(DidOpenNotebookDocumentNotification2) {
    DidOpenNotebookDocumentNotification2.method = "notebookDocument/didOpen";
    DidOpenNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidOpenNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidOpenNotebookDocumentNotification2.method);
    DidOpenNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidOpenNotebookDocumentNotification || (protocol_notebook.DidOpenNotebookDocumentNotification = DidOpenNotebookDocumentNotification = {}));
  var NotebookCellArrayChange;
  (function(NotebookCellArrayChange2) {
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && vscode_languageserver_types_1.uinteger.is(candidate.start) && vscode_languageserver_types_1.uinteger.is(candidate.deleteCount) && (candidate.cells === void 0 || Is2.typedArray(candidate.cells, NotebookCell.is));
    }
    NotebookCellArrayChange2.is = is2;
    function create2(start, deleteCount, cells) {
      const result2 = { start, deleteCount };
      if (cells !== void 0) {
        result2.cells = cells;
      }
      return result2;
    }
    NotebookCellArrayChange2.create = create2;
  })(NotebookCellArrayChange || (protocol_notebook.NotebookCellArrayChange = NotebookCellArrayChange = {}));
  var DidChangeNotebookDocumentNotification;
  (function(DidChangeNotebookDocumentNotification2) {
    DidChangeNotebookDocumentNotification2.method = "notebookDocument/didChange";
    DidChangeNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidChangeNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidChangeNotebookDocumentNotification2.method);
    DidChangeNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidChangeNotebookDocumentNotification || (protocol_notebook.DidChangeNotebookDocumentNotification = DidChangeNotebookDocumentNotification = {}));
  var DidSaveNotebookDocumentNotification;
  (function(DidSaveNotebookDocumentNotification2) {
    DidSaveNotebookDocumentNotification2.method = "notebookDocument/didSave";
    DidSaveNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidSaveNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidSaveNotebookDocumentNotification2.method);
    DidSaveNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidSaveNotebookDocumentNotification || (protocol_notebook.DidSaveNotebookDocumentNotification = DidSaveNotebookDocumentNotification = {}));
  var DidCloseNotebookDocumentNotification;
  (function(DidCloseNotebookDocumentNotification2) {
    DidCloseNotebookDocumentNotification2.method = "notebookDocument/didClose";
    DidCloseNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidCloseNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidCloseNotebookDocumentNotification2.method);
    DidCloseNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidCloseNotebookDocumentNotification || (protocol_notebook.DidCloseNotebookDocumentNotification = DidCloseNotebookDocumentNotification = {}));
  return protocol_notebook;
}
var protocol_inlineCompletion = {};
var hasRequiredProtocol_inlineCompletion;
function requireProtocol_inlineCompletion() {
  if (hasRequiredProtocol_inlineCompletion) return protocol_inlineCompletion;
  hasRequiredProtocol_inlineCompletion = 1;
  Object.defineProperty(protocol_inlineCompletion, "__esModule", { value: true });
  protocol_inlineCompletion.InlineCompletionRequest = void 0;
  const messages_1 = requireMessages();
  var InlineCompletionRequest;
  (function(InlineCompletionRequest2) {
    InlineCompletionRequest2.method = "textDocument/inlineCompletion";
    InlineCompletionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlineCompletionRequest2.type = new messages_1.ProtocolRequestType(InlineCompletionRequest2.method);
  })(InlineCompletionRequest || (protocol_inlineCompletion.InlineCompletionRequest = InlineCompletionRequest = {}));
  return protocol_inlineCompletion;
}
var hasRequiredProtocol;
function requireProtocol() {
  if (hasRequiredProtocol) return protocol;
  hasRequiredProtocol = 1;
  (function(exports$12) {
    Object.defineProperty(exports$12, "__esModule", { value: true });
    exports$12.WorkspaceSymbolRequest = exports$12.CodeActionResolveRequest = exports$12.CodeActionRequest = exports$12.DocumentSymbolRequest = exports$12.DocumentHighlightRequest = exports$12.ReferencesRequest = exports$12.DefinitionRequest = exports$12.SignatureHelpRequest = exports$12.SignatureHelpTriggerKind = exports$12.HoverRequest = exports$12.CompletionResolveRequest = exports$12.CompletionRequest = exports$12.CompletionTriggerKind = exports$12.PublishDiagnosticsNotification = exports$12.WatchKind = exports$12.RelativePattern = exports$12.FileChangeType = exports$12.DidChangeWatchedFilesNotification = exports$12.WillSaveTextDocumentWaitUntilRequest = exports$12.WillSaveTextDocumentNotification = exports$12.TextDocumentSaveReason = exports$12.DidSaveTextDocumentNotification = exports$12.DidCloseTextDocumentNotification = exports$12.DidChangeTextDocumentNotification = exports$12.TextDocumentContentChangeEvent = exports$12.DidOpenTextDocumentNotification = exports$12.TextDocumentSyncKind = exports$12.TelemetryEventNotification = exports$12.LogMessageNotification = exports$12.ShowMessageRequest = exports$12.ShowMessageNotification = exports$12.MessageType = exports$12.DidChangeConfigurationNotification = exports$12.ExitNotification = exports$12.ShutdownRequest = exports$12.InitializedNotification = exports$12.InitializeErrorCodes = exports$12.InitializeRequest = exports$12.WorkDoneProgressOptions = exports$12.TextDocumentRegistrationOptions = exports$12.StaticRegistrationOptions = exports$12.PositionEncodingKind = exports$12.FailureHandlingKind = exports$12.ResourceOperationKind = exports$12.UnregistrationRequest = exports$12.RegistrationRequest = exports$12.DocumentSelector = exports$12.NotebookCellTextDocumentFilter = exports$12.NotebookDocumentFilter = exports$12.TextDocumentFilter = void 0;
    exports$12.MonikerRequest = exports$12.MonikerKind = exports$12.UniquenessLevel = exports$12.WillDeleteFilesRequest = exports$12.DidDeleteFilesNotification = exports$12.WillRenameFilesRequest = exports$12.DidRenameFilesNotification = exports$12.WillCreateFilesRequest = exports$12.DidCreateFilesNotification = exports$12.FileOperationPatternKind = exports$12.LinkedEditingRangeRequest = exports$12.ShowDocumentRequest = exports$12.SemanticTokensRegistrationType = exports$12.SemanticTokensRefreshRequest = exports$12.SemanticTokensRangeRequest = exports$12.SemanticTokensDeltaRequest = exports$12.SemanticTokensRequest = exports$12.TokenFormat = exports$12.CallHierarchyPrepareRequest = exports$12.CallHierarchyOutgoingCallsRequest = exports$12.CallHierarchyIncomingCallsRequest = exports$12.WorkDoneProgressCancelNotification = exports$12.WorkDoneProgressCreateRequest = exports$12.WorkDoneProgress = exports$12.SelectionRangeRequest = exports$12.DeclarationRequest = exports$12.FoldingRangeRefreshRequest = exports$12.FoldingRangeRequest = exports$12.ColorPresentationRequest = exports$12.DocumentColorRequest = exports$12.ConfigurationRequest = exports$12.DidChangeWorkspaceFoldersNotification = exports$12.WorkspaceFoldersRequest = exports$12.TypeDefinitionRequest = exports$12.ImplementationRequest = exports$12.ApplyWorkspaceEditRequest = exports$12.ExecuteCommandRequest = exports$12.PrepareRenameRequest = exports$12.RenameRequest = exports$12.PrepareSupportDefaultBehavior = exports$12.DocumentOnTypeFormattingRequest = exports$12.DocumentRangesFormattingRequest = exports$12.DocumentRangeFormattingRequest = exports$12.DocumentFormattingRequest = exports$12.DocumentLinkResolveRequest = exports$12.DocumentLinkRequest = exports$12.CodeLensRefreshRequest = exports$12.CodeLensResolveRequest = exports$12.CodeLensRequest = exports$12.WorkspaceSymbolResolveRequest = void 0;
    exports$12.InlineCompletionRequest = exports$12.DidCloseNotebookDocumentNotification = exports$12.DidSaveNotebookDocumentNotification = exports$12.DidChangeNotebookDocumentNotification = exports$12.NotebookCellArrayChange = exports$12.DidOpenNotebookDocumentNotification = exports$12.NotebookDocumentSyncRegistrationType = exports$12.NotebookDocument = exports$12.NotebookCell = exports$12.ExecutionSummary = exports$12.NotebookCellKind = exports$12.DiagnosticRefreshRequest = exports$12.WorkspaceDiagnosticRequest = exports$12.DocumentDiagnosticRequest = exports$12.DocumentDiagnosticReportKind = exports$12.DiagnosticServerCancellationData = exports$12.InlayHintRefreshRequest = exports$12.InlayHintResolveRequest = exports$12.InlayHintRequest = exports$12.InlineValueRefreshRequest = exports$12.InlineValueRequest = exports$12.TypeHierarchySupertypesRequest = exports$12.TypeHierarchySubtypesRequest = exports$12.TypeHierarchyPrepareRequest = void 0;
    const messages_1 = requireMessages();
    const vscode_languageserver_types_1 = require$$1;
    const Is2 = requireIs();
    const protocol_implementation_1 = requireProtocol_implementation();
    Object.defineProperty(exports$12, "ImplementationRequest", { enumerable: true, get: function() {
      return protocol_implementation_1.ImplementationRequest;
    } });
    const protocol_typeDefinition_1 = requireProtocol_typeDefinition();
    Object.defineProperty(exports$12, "TypeDefinitionRequest", { enumerable: true, get: function() {
      return protocol_typeDefinition_1.TypeDefinitionRequest;
    } });
    const protocol_workspaceFolder_1 = requireProtocol_workspaceFolder();
    Object.defineProperty(exports$12, "WorkspaceFoldersRequest", { enumerable: true, get: function() {
      return protocol_workspaceFolder_1.WorkspaceFoldersRequest;
    } });
    Object.defineProperty(exports$12, "DidChangeWorkspaceFoldersNotification", { enumerable: true, get: function() {
      return protocol_workspaceFolder_1.DidChangeWorkspaceFoldersNotification;
    } });
    const protocol_configuration_1 = requireProtocol_configuration();
    Object.defineProperty(exports$12, "ConfigurationRequest", { enumerable: true, get: function() {
      return protocol_configuration_1.ConfigurationRequest;
    } });
    const protocol_colorProvider_1 = requireProtocol_colorProvider();
    Object.defineProperty(exports$12, "DocumentColorRequest", { enumerable: true, get: function() {
      return protocol_colorProvider_1.DocumentColorRequest;
    } });
    Object.defineProperty(exports$12, "ColorPresentationRequest", { enumerable: true, get: function() {
      return protocol_colorProvider_1.ColorPresentationRequest;
    } });
    const protocol_foldingRange_1 = requireProtocol_foldingRange();
    Object.defineProperty(exports$12, "FoldingRangeRequest", { enumerable: true, get: function() {
      return protocol_foldingRange_1.FoldingRangeRequest;
    } });
    Object.defineProperty(exports$12, "FoldingRangeRefreshRequest", { enumerable: true, get: function() {
      return protocol_foldingRange_1.FoldingRangeRefreshRequest;
    } });
    const protocol_declaration_1 = requireProtocol_declaration();
    Object.defineProperty(exports$12, "DeclarationRequest", { enumerable: true, get: function() {
      return protocol_declaration_1.DeclarationRequest;
    } });
    const protocol_selectionRange_1 = requireProtocol_selectionRange();
    Object.defineProperty(exports$12, "SelectionRangeRequest", { enumerable: true, get: function() {
      return protocol_selectionRange_1.SelectionRangeRequest;
    } });
    const protocol_progress_1 = requireProtocol_progress();
    Object.defineProperty(exports$12, "WorkDoneProgress", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgress;
    } });
    Object.defineProperty(exports$12, "WorkDoneProgressCreateRequest", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgressCreateRequest;
    } });
    Object.defineProperty(exports$12, "WorkDoneProgressCancelNotification", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgressCancelNotification;
    } });
    const protocol_callHierarchy_1 = requireProtocol_callHierarchy();
    Object.defineProperty(exports$12, "CallHierarchyIncomingCallsRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyIncomingCallsRequest;
    } });
    Object.defineProperty(exports$12, "CallHierarchyOutgoingCallsRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyOutgoingCallsRequest;
    } });
    Object.defineProperty(exports$12, "CallHierarchyPrepareRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyPrepareRequest;
    } });
    const protocol_semanticTokens_1 = requireProtocol_semanticTokens();
    Object.defineProperty(exports$12, "TokenFormat", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.TokenFormat;
    } });
    Object.defineProperty(exports$12, "SemanticTokensRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRequest;
    } });
    Object.defineProperty(exports$12, "SemanticTokensDeltaRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensDeltaRequest;
    } });
    Object.defineProperty(exports$12, "SemanticTokensRangeRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRangeRequest;
    } });
    Object.defineProperty(exports$12, "SemanticTokensRefreshRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRefreshRequest;
    } });
    Object.defineProperty(exports$12, "SemanticTokensRegistrationType", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRegistrationType;
    } });
    const protocol_showDocument_1 = requireProtocol_showDocument();
    Object.defineProperty(exports$12, "ShowDocumentRequest", { enumerable: true, get: function() {
      return protocol_showDocument_1.ShowDocumentRequest;
    } });
    const protocol_linkedEditingRange_1 = requireProtocol_linkedEditingRange();
    Object.defineProperty(exports$12, "LinkedEditingRangeRequest", { enumerable: true, get: function() {
      return protocol_linkedEditingRange_1.LinkedEditingRangeRequest;
    } });
    const protocol_fileOperations_1 = requireProtocol_fileOperations();
    Object.defineProperty(exports$12, "FileOperationPatternKind", { enumerable: true, get: function() {
      return protocol_fileOperations_1.FileOperationPatternKind;
    } });
    Object.defineProperty(exports$12, "DidCreateFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidCreateFilesNotification;
    } });
    Object.defineProperty(exports$12, "WillCreateFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillCreateFilesRequest;
    } });
    Object.defineProperty(exports$12, "DidRenameFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidRenameFilesNotification;
    } });
    Object.defineProperty(exports$12, "WillRenameFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillRenameFilesRequest;
    } });
    Object.defineProperty(exports$12, "DidDeleteFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidDeleteFilesNotification;
    } });
    Object.defineProperty(exports$12, "WillDeleteFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillDeleteFilesRequest;
    } });
    const protocol_moniker_1 = requireProtocol_moniker();
    Object.defineProperty(exports$12, "UniquenessLevel", { enumerable: true, get: function() {
      return protocol_moniker_1.UniquenessLevel;
    } });
    Object.defineProperty(exports$12, "MonikerKind", { enumerable: true, get: function() {
      return protocol_moniker_1.MonikerKind;
    } });
    Object.defineProperty(exports$12, "MonikerRequest", { enumerable: true, get: function() {
      return protocol_moniker_1.MonikerRequest;
    } });
    const protocol_typeHierarchy_1 = requireProtocol_typeHierarchy();
    Object.defineProperty(exports$12, "TypeHierarchyPrepareRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchyPrepareRequest;
    } });
    Object.defineProperty(exports$12, "TypeHierarchySubtypesRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchySubtypesRequest;
    } });
    Object.defineProperty(exports$12, "TypeHierarchySupertypesRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchySupertypesRequest;
    } });
    const protocol_inlineValue_1 = requireProtocol_inlineValue();
    Object.defineProperty(exports$12, "InlineValueRequest", { enumerable: true, get: function() {
      return protocol_inlineValue_1.InlineValueRequest;
    } });
    Object.defineProperty(exports$12, "InlineValueRefreshRequest", { enumerable: true, get: function() {
      return protocol_inlineValue_1.InlineValueRefreshRequest;
    } });
    const protocol_inlayHint_1 = requireProtocol_inlayHint();
    Object.defineProperty(exports$12, "InlayHintRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintRequest;
    } });
    Object.defineProperty(exports$12, "InlayHintResolveRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintResolveRequest;
    } });
    Object.defineProperty(exports$12, "InlayHintRefreshRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintRefreshRequest;
    } });
    const protocol_diagnostic_1 = requireProtocol_diagnostic();
    Object.defineProperty(exports$12, "DiagnosticServerCancellationData", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DiagnosticServerCancellationData;
    } });
    Object.defineProperty(exports$12, "DocumentDiagnosticReportKind", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DocumentDiagnosticReportKind;
    } });
    Object.defineProperty(exports$12, "DocumentDiagnosticRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DocumentDiagnosticRequest;
    } });
    Object.defineProperty(exports$12, "WorkspaceDiagnosticRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.WorkspaceDiagnosticRequest;
    } });
    Object.defineProperty(exports$12, "DiagnosticRefreshRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DiagnosticRefreshRequest;
    } });
    const protocol_notebook_1 = requireProtocol_notebook();
    Object.defineProperty(exports$12, "NotebookCellKind", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCellKind;
    } });
    Object.defineProperty(exports$12, "ExecutionSummary", { enumerable: true, get: function() {
      return protocol_notebook_1.ExecutionSummary;
    } });
    Object.defineProperty(exports$12, "NotebookCell", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCell;
    } });
    Object.defineProperty(exports$12, "NotebookDocument", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookDocument;
    } });
    Object.defineProperty(exports$12, "NotebookDocumentSyncRegistrationType", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookDocumentSyncRegistrationType;
    } });
    Object.defineProperty(exports$12, "DidOpenNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidOpenNotebookDocumentNotification;
    } });
    Object.defineProperty(exports$12, "NotebookCellArrayChange", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCellArrayChange;
    } });
    Object.defineProperty(exports$12, "DidChangeNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidChangeNotebookDocumentNotification;
    } });
    Object.defineProperty(exports$12, "DidSaveNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidSaveNotebookDocumentNotification;
    } });
    Object.defineProperty(exports$12, "DidCloseNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidCloseNotebookDocumentNotification;
    } });
    const protocol_inlineCompletion_1 = requireProtocol_inlineCompletion();
    Object.defineProperty(exports$12, "InlineCompletionRequest", { enumerable: true, get: function() {
      return protocol_inlineCompletion_1.InlineCompletionRequest;
    } });
    var TextDocumentFilter;
    (function(TextDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.string(candidate) || (Is2.string(candidate.language) || Is2.string(candidate.scheme) || Is2.string(candidate.pattern));
      }
      TextDocumentFilter2.is = is2;
    })(TextDocumentFilter || (exports$12.TextDocumentFilter = TextDocumentFilter = {}));
    var NotebookDocumentFilter;
    (function(NotebookDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (Is2.string(candidate.notebookType) || Is2.string(candidate.scheme) || Is2.string(candidate.pattern));
      }
      NotebookDocumentFilter2.is = is2;
    })(NotebookDocumentFilter || (exports$12.NotebookDocumentFilter = NotebookDocumentFilter = {}));
    var NotebookCellTextDocumentFilter;
    (function(NotebookCellTextDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (Is2.string(candidate.notebook) || NotebookDocumentFilter.is(candidate.notebook)) && (candidate.language === void 0 || Is2.string(candidate.language));
      }
      NotebookCellTextDocumentFilter2.is = is2;
    })(NotebookCellTextDocumentFilter || (exports$12.NotebookCellTextDocumentFilter = NotebookCellTextDocumentFilter = {}));
    var DocumentSelector;
    (function(DocumentSelector2) {
      function is2(value) {
        if (!Array.isArray(value)) {
          return false;
        }
        for (let elem of value) {
          if (!Is2.string(elem) && !TextDocumentFilter.is(elem) && !NotebookCellTextDocumentFilter.is(elem)) {
            return false;
          }
        }
        return true;
      }
      DocumentSelector2.is = is2;
    })(DocumentSelector || (exports$12.DocumentSelector = DocumentSelector = {}));
    var RegistrationRequest;
    (function(RegistrationRequest2) {
      RegistrationRequest2.method = "client/registerCapability";
      RegistrationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      RegistrationRequest2.type = new messages_1.ProtocolRequestType(RegistrationRequest2.method);
    })(RegistrationRequest || (exports$12.RegistrationRequest = RegistrationRequest = {}));
    var UnregistrationRequest;
    (function(UnregistrationRequest2) {
      UnregistrationRequest2.method = "client/unregisterCapability";
      UnregistrationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      UnregistrationRequest2.type = new messages_1.ProtocolRequestType(UnregistrationRequest2.method);
    })(UnregistrationRequest || (exports$12.UnregistrationRequest = UnregistrationRequest = {}));
    var ResourceOperationKind;
    (function(ResourceOperationKind2) {
      ResourceOperationKind2.Create = "create";
      ResourceOperationKind2.Rename = "rename";
      ResourceOperationKind2.Delete = "delete";
    })(ResourceOperationKind || (exports$12.ResourceOperationKind = ResourceOperationKind = {}));
    var FailureHandlingKind;
    (function(FailureHandlingKind2) {
      FailureHandlingKind2.Abort = "abort";
      FailureHandlingKind2.Transactional = "transactional";
      FailureHandlingKind2.TextOnlyTransactional = "textOnlyTransactional";
      FailureHandlingKind2.Undo = "undo";
    })(FailureHandlingKind || (exports$12.FailureHandlingKind = FailureHandlingKind = {}));
    var PositionEncodingKind;
    (function(PositionEncodingKind2) {
      PositionEncodingKind2.UTF8 = "utf-8";
      PositionEncodingKind2.UTF16 = "utf-16";
      PositionEncodingKind2.UTF32 = "utf-32";
    })(PositionEncodingKind || (exports$12.PositionEncodingKind = PositionEncodingKind = {}));
    var StaticRegistrationOptions;
    (function(StaticRegistrationOptions2) {
      function hasId(value) {
        const candidate = value;
        return candidate && Is2.string(candidate.id) && candidate.id.length > 0;
      }
      StaticRegistrationOptions2.hasId = hasId;
    })(StaticRegistrationOptions || (exports$12.StaticRegistrationOptions = StaticRegistrationOptions = {}));
    var TextDocumentRegistrationOptions;
    (function(TextDocumentRegistrationOptions2) {
      function is2(value) {
        const candidate = value;
        return candidate && (candidate.documentSelector === null || DocumentSelector.is(candidate.documentSelector));
      }
      TextDocumentRegistrationOptions2.is = is2;
    })(TextDocumentRegistrationOptions || (exports$12.TextDocumentRegistrationOptions = TextDocumentRegistrationOptions = {}));
    var WorkDoneProgressOptions;
    (function(WorkDoneProgressOptions2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (candidate.workDoneProgress === void 0 || Is2.boolean(candidate.workDoneProgress));
      }
      WorkDoneProgressOptions2.is = is2;
      function hasWorkDoneProgress(value) {
        const candidate = value;
        return candidate && Is2.boolean(candidate.workDoneProgress);
      }
      WorkDoneProgressOptions2.hasWorkDoneProgress = hasWorkDoneProgress;
    })(WorkDoneProgressOptions || (exports$12.WorkDoneProgressOptions = WorkDoneProgressOptions = {}));
    var InitializeRequest;
    (function(InitializeRequest2) {
      InitializeRequest2.method = "initialize";
      InitializeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      InitializeRequest2.type = new messages_1.ProtocolRequestType(InitializeRequest2.method);
    })(InitializeRequest || (exports$12.InitializeRequest = InitializeRequest = {}));
    var InitializeErrorCodes;
    (function(InitializeErrorCodes2) {
      InitializeErrorCodes2.unknownProtocolVersion = 1;
    })(InitializeErrorCodes || (exports$12.InitializeErrorCodes = InitializeErrorCodes = {}));
    var InitializedNotification;
    (function(InitializedNotification2) {
      InitializedNotification2.method = "initialized";
      InitializedNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      InitializedNotification2.type = new messages_1.ProtocolNotificationType(InitializedNotification2.method);
    })(InitializedNotification || (exports$12.InitializedNotification = InitializedNotification = {}));
    var ShutdownRequest;
    (function(ShutdownRequest2) {
      ShutdownRequest2.method = "shutdown";
      ShutdownRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ShutdownRequest2.type = new messages_1.ProtocolRequestType0(ShutdownRequest2.method);
    })(ShutdownRequest || (exports$12.ShutdownRequest = ShutdownRequest = {}));
    var ExitNotification;
    (function(ExitNotification2) {
      ExitNotification2.method = "exit";
      ExitNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      ExitNotification2.type = new messages_1.ProtocolNotificationType0(ExitNotification2.method);
    })(ExitNotification || (exports$12.ExitNotification = ExitNotification = {}));
    var DidChangeConfigurationNotification;
    (function(DidChangeConfigurationNotification2) {
      DidChangeConfigurationNotification2.method = "workspace/didChangeConfiguration";
      DidChangeConfigurationNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeConfigurationNotification2.type = new messages_1.ProtocolNotificationType(DidChangeConfigurationNotification2.method);
    })(DidChangeConfigurationNotification || (exports$12.DidChangeConfigurationNotification = DidChangeConfigurationNotification = {}));
    var MessageType;
    (function(MessageType2) {
      MessageType2.Error = 1;
      MessageType2.Warning = 2;
      MessageType2.Info = 3;
      MessageType2.Log = 4;
      MessageType2.Debug = 5;
    })(MessageType || (exports$12.MessageType = MessageType = {}));
    var ShowMessageNotification;
    (function(ShowMessageNotification2) {
      ShowMessageNotification2.method = "window/showMessage";
      ShowMessageNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      ShowMessageNotification2.type = new messages_1.ProtocolNotificationType(ShowMessageNotification2.method);
    })(ShowMessageNotification || (exports$12.ShowMessageNotification = ShowMessageNotification = {}));
    var ShowMessageRequest;
    (function(ShowMessageRequest2) {
      ShowMessageRequest2.method = "window/showMessageRequest";
      ShowMessageRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      ShowMessageRequest2.type = new messages_1.ProtocolRequestType(ShowMessageRequest2.method);
    })(ShowMessageRequest || (exports$12.ShowMessageRequest = ShowMessageRequest = {}));
    var LogMessageNotification;
    (function(LogMessageNotification2) {
      LogMessageNotification2.method = "window/logMessage";
      LogMessageNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      LogMessageNotification2.type = new messages_1.ProtocolNotificationType(LogMessageNotification2.method);
    })(LogMessageNotification || (exports$12.LogMessageNotification = LogMessageNotification = {}));
    var TelemetryEventNotification;
    (function(TelemetryEventNotification2) {
      TelemetryEventNotification2.method = "telemetry/event";
      TelemetryEventNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      TelemetryEventNotification2.type = new messages_1.ProtocolNotificationType(TelemetryEventNotification2.method);
    })(TelemetryEventNotification || (exports$12.TelemetryEventNotification = TelemetryEventNotification = {}));
    var TextDocumentSyncKind;
    (function(TextDocumentSyncKind2) {
      TextDocumentSyncKind2.None = 0;
      TextDocumentSyncKind2.Full = 1;
      TextDocumentSyncKind2.Incremental = 2;
    })(TextDocumentSyncKind || (exports$12.TextDocumentSyncKind = TextDocumentSyncKind = {}));
    var DidOpenTextDocumentNotification;
    (function(DidOpenTextDocumentNotification2) {
      DidOpenTextDocumentNotification2.method = "textDocument/didOpen";
      DidOpenTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidOpenTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidOpenTextDocumentNotification2.method);
    })(DidOpenTextDocumentNotification || (exports$12.DidOpenTextDocumentNotification = DidOpenTextDocumentNotification = {}));
    var TextDocumentContentChangeEvent;
    (function(TextDocumentContentChangeEvent2) {
      function isIncremental(event) {
        let candidate = event;
        return candidate !== void 0 && candidate !== null && typeof candidate.text === "string" && candidate.range !== void 0 && (candidate.rangeLength === void 0 || typeof candidate.rangeLength === "number");
      }
      TextDocumentContentChangeEvent2.isIncremental = isIncremental;
      function isFull(event) {
        let candidate = event;
        return candidate !== void 0 && candidate !== null && typeof candidate.text === "string" && candidate.range === void 0 && candidate.rangeLength === void 0;
      }
      TextDocumentContentChangeEvent2.isFull = isFull;
    })(TextDocumentContentChangeEvent || (exports$12.TextDocumentContentChangeEvent = TextDocumentContentChangeEvent = {}));
    var DidChangeTextDocumentNotification;
    (function(DidChangeTextDocumentNotification2) {
      DidChangeTextDocumentNotification2.method = "textDocument/didChange";
      DidChangeTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidChangeTextDocumentNotification2.method);
    })(DidChangeTextDocumentNotification || (exports$12.DidChangeTextDocumentNotification = DidChangeTextDocumentNotification = {}));
    var DidCloseTextDocumentNotification;
    (function(DidCloseTextDocumentNotification2) {
      DidCloseTextDocumentNotification2.method = "textDocument/didClose";
      DidCloseTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidCloseTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidCloseTextDocumentNotification2.method);
    })(DidCloseTextDocumentNotification || (exports$12.DidCloseTextDocumentNotification = DidCloseTextDocumentNotification = {}));
    var DidSaveTextDocumentNotification;
    (function(DidSaveTextDocumentNotification2) {
      DidSaveTextDocumentNotification2.method = "textDocument/didSave";
      DidSaveTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidSaveTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidSaveTextDocumentNotification2.method);
    })(DidSaveTextDocumentNotification || (exports$12.DidSaveTextDocumentNotification = DidSaveTextDocumentNotification = {}));
    var TextDocumentSaveReason;
    (function(TextDocumentSaveReason2) {
      TextDocumentSaveReason2.Manual = 1;
      TextDocumentSaveReason2.AfterDelay = 2;
      TextDocumentSaveReason2.FocusOut = 3;
    })(TextDocumentSaveReason || (exports$12.TextDocumentSaveReason = TextDocumentSaveReason = {}));
    var WillSaveTextDocumentNotification;
    (function(WillSaveTextDocumentNotification2) {
      WillSaveTextDocumentNotification2.method = "textDocument/willSave";
      WillSaveTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      WillSaveTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(WillSaveTextDocumentNotification2.method);
    })(WillSaveTextDocumentNotification || (exports$12.WillSaveTextDocumentNotification = WillSaveTextDocumentNotification = {}));
    var WillSaveTextDocumentWaitUntilRequest;
    (function(WillSaveTextDocumentWaitUntilRequest2) {
      WillSaveTextDocumentWaitUntilRequest2.method = "textDocument/willSaveWaitUntil";
      WillSaveTextDocumentWaitUntilRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WillSaveTextDocumentWaitUntilRequest2.type = new messages_1.ProtocolRequestType(WillSaveTextDocumentWaitUntilRequest2.method);
    })(WillSaveTextDocumentWaitUntilRequest || (exports$12.WillSaveTextDocumentWaitUntilRequest = WillSaveTextDocumentWaitUntilRequest = {}));
    var DidChangeWatchedFilesNotification;
    (function(DidChangeWatchedFilesNotification2) {
      DidChangeWatchedFilesNotification2.method = "workspace/didChangeWatchedFiles";
      DidChangeWatchedFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeWatchedFilesNotification2.type = new messages_1.ProtocolNotificationType(DidChangeWatchedFilesNotification2.method);
    })(DidChangeWatchedFilesNotification || (exports$12.DidChangeWatchedFilesNotification = DidChangeWatchedFilesNotification = {}));
    var FileChangeType;
    (function(FileChangeType2) {
      FileChangeType2.Created = 1;
      FileChangeType2.Changed = 2;
      FileChangeType2.Deleted = 3;
    })(FileChangeType || (exports$12.FileChangeType = FileChangeType = {}));
    var RelativePattern;
    (function(RelativePattern2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (vscode_languageserver_types_1.URI.is(candidate.baseUri) || vscode_languageserver_types_1.WorkspaceFolder.is(candidate.baseUri)) && Is2.string(candidate.pattern);
      }
      RelativePattern2.is = is2;
    })(RelativePattern || (exports$12.RelativePattern = RelativePattern = {}));
    var WatchKind;
    (function(WatchKind2) {
      WatchKind2.Create = 1;
      WatchKind2.Change = 2;
      WatchKind2.Delete = 4;
    })(WatchKind || (exports$12.WatchKind = WatchKind = {}));
    var PublishDiagnosticsNotification;
    (function(PublishDiagnosticsNotification2) {
      PublishDiagnosticsNotification2.method = "textDocument/publishDiagnostics";
      PublishDiagnosticsNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      PublishDiagnosticsNotification2.type = new messages_1.ProtocolNotificationType(PublishDiagnosticsNotification2.method);
    })(PublishDiagnosticsNotification || (exports$12.PublishDiagnosticsNotification = PublishDiagnosticsNotification = {}));
    var CompletionTriggerKind;
    (function(CompletionTriggerKind2) {
      CompletionTriggerKind2.Invoked = 1;
      CompletionTriggerKind2.TriggerCharacter = 2;
      CompletionTriggerKind2.TriggerForIncompleteCompletions = 3;
    })(CompletionTriggerKind || (exports$12.CompletionTriggerKind = CompletionTriggerKind = {}));
    var CompletionRequest;
    (function(CompletionRequest2) {
      CompletionRequest2.method = "textDocument/completion";
      CompletionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CompletionRequest2.type = new messages_1.ProtocolRequestType(CompletionRequest2.method);
    })(CompletionRequest || (exports$12.CompletionRequest = CompletionRequest = {}));
    var CompletionResolveRequest;
    (function(CompletionResolveRequest2) {
      CompletionResolveRequest2.method = "completionItem/resolve";
      CompletionResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CompletionResolveRequest2.type = new messages_1.ProtocolRequestType(CompletionResolveRequest2.method);
    })(CompletionResolveRequest || (exports$12.CompletionResolveRequest = CompletionResolveRequest = {}));
    var HoverRequest;
    (function(HoverRequest2) {
      HoverRequest2.method = "textDocument/hover";
      HoverRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      HoverRequest2.type = new messages_1.ProtocolRequestType(HoverRequest2.method);
    })(HoverRequest || (exports$12.HoverRequest = HoverRequest = {}));
    var SignatureHelpTriggerKind;
    (function(SignatureHelpTriggerKind2) {
      SignatureHelpTriggerKind2.Invoked = 1;
      SignatureHelpTriggerKind2.TriggerCharacter = 2;
      SignatureHelpTriggerKind2.ContentChange = 3;
    })(SignatureHelpTriggerKind || (exports$12.SignatureHelpTriggerKind = SignatureHelpTriggerKind = {}));
    var SignatureHelpRequest;
    (function(SignatureHelpRequest2) {
      SignatureHelpRequest2.method = "textDocument/signatureHelp";
      SignatureHelpRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      SignatureHelpRequest2.type = new messages_1.ProtocolRequestType(SignatureHelpRequest2.method);
    })(SignatureHelpRequest || (exports$12.SignatureHelpRequest = SignatureHelpRequest = {}));
    var DefinitionRequest;
    (function(DefinitionRequest2) {
      DefinitionRequest2.method = "textDocument/definition";
      DefinitionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DefinitionRequest2.type = new messages_1.ProtocolRequestType(DefinitionRequest2.method);
    })(DefinitionRequest || (exports$12.DefinitionRequest = DefinitionRequest = {}));
    var ReferencesRequest;
    (function(ReferencesRequest2) {
      ReferencesRequest2.method = "textDocument/references";
      ReferencesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ReferencesRequest2.type = new messages_1.ProtocolRequestType(ReferencesRequest2.method);
    })(ReferencesRequest || (exports$12.ReferencesRequest = ReferencesRequest = {}));
    var DocumentHighlightRequest;
    (function(DocumentHighlightRequest2) {
      DocumentHighlightRequest2.method = "textDocument/documentHighlight";
      DocumentHighlightRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentHighlightRequest2.type = new messages_1.ProtocolRequestType(DocumentHighlightRequest2.method);
    })(DocumentHighlightRequest || (exports$12.DocumentHighlightRequest = DocumentHighlightRequest = {}));
    var DocumentSymbolRequest;
    (function(DocumentSymbolRequest2) {
      DocumentSymbolRequest2.method = "textDocument/documentSymbol";
      DocumentSymbolRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentSymbolRequest2.type = new messages_1.ProtocolRequestType(DocumentSymbolRequest2.method);
    })(DocumentSymbolRequest || (exports$12.DocumentSymbolRequest = DocumentSymbolRequest = {}));
    var CodeActionRequest;
    (function(CodeActionRequest2) {
      CodeActionRequest2.method = "textDocument/codeAction";
      CodeActionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeActionRequest2.type = new messages_1.ProtocolRequestType(CodeActionRequest2.method);
    })(CodeActionRequest || (exports$12.CodeActionRequest = CodeActionRequest = {}));
    var CodeActionResolveRequest;
    (function(CodeActionResolveRequest2) {
      CodeActionResolveRequest2.method = "codeAction/resolve";
      CodeActionResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeActionResolveRequest2.type = new messages_1.ProtocolRequestType(CodeActionResolveRequest2.method);
    })(CodeActionResolveRequest || (exports$12.CodeActionResolveRequest = CodeActionResolveRequest = {}));
    var WorkspaceSymbolRequest;
    (function(WorkspaceSymbolRequest2) {
      WorkspaceSymbolRequest2.method = "workspace/symbol";
      WorkspaceSymbolRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WorkspaceSymbolRequest2.type = new messages_1.ProtocolRequestType(WorkspaceSymbolRequest2.method);
    })(WorkspaceSymbolRequest || (exports$12.WorkspaceSymbolRequest = WorkspaceSymbolRequest = {}));
    var WorkspaceSymbolResolveRequest;
    (function(WorkspaceSymbolResolveRequest2) {
      WorkspaceSymbolResolveRequest2.method = "workspaceSymbol/resolve";
      WorkspaceSymbolResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WorkspaceSymbolResolveRequest2.type = new messages_1.ProtocolRequestType(WorkspaceSymbolResolveRequest2.method);
    })(WorkspaceSymbolResolveRequest || (exports$12.WorkspaceSymbolResolveRequest = WorkspaceSymbolResolveRequest = {}));
    var CodeLensRequest;
    (function(CodeLensRequest2) {
      CodeLensRequest2.method = "textDocument/codeLens";
      CodeLensRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeLensRequest2.type = new messages_1.ProtocolRequestType(CodeLensRequest2.method);
    })(CodeLensRequest || (exports$12.CodeLensRequest = CodeLensRequest = {}));
    var CodeLensResolveRequest;
    (function(CodeLensResolveRequest2) {
      CodeLensResolveRequest2.method = "codeLens/resolve";
      CodeLensResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeLensResolveRequest2.type = new messages_1.ProtocolRequestType(CodeLensResolveRequest2.method);
    })(CodeLensResolveRequest || (exports$12.CodeLensResolveRequest = CodeLensResolveRequest = {}));
    var CodeLensRefreshRequest;
    (function(CodeLensRefreshRequest2) {
      CodeLensRefreshRequest2.method = `workspace/codeLens/refresh`;
      CodeLensRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      CodeLensRefreshRequest2.type = new messages_1.ProtocolRequestType0(CodeLensRefreshRequest2.method);
    })(CodeLensRefreshRequest || (exports$12.CodeLensRefreshRequest = CodeLensRefreshRequest = {}));
    var DocumentLinkRequest;
    (function(DocumentLinkRequest2) {
      DocumentLinkRequest2.method = "textDocument/documentLink";
      DocumentLinkRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentLinkRequest2.type = new messages_1.ProtocolRequestType(DocumentLinkRequest2.method);
    })(DocumentLinkRequest || (exports$12.DocumentLinkRequest = DocumentLinkRequest = {}));
    var DocumentLinkResolveRequest;
    (function(DocumentLinkResolveRequest2) {
      DocumentLinkResolveRequest2.method = "documentLink/resolve";
      DocumentLinkResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentLinkResolveRequest2.type = new messages_1.ProtocolRequestType(DocumentLinkResolveRequest2.method);
    })(DocumentLinkResolveRequest || (exports$12.DocumentLinkResolveRequest = DocumentLinkResolveRequest = {}));
    var DocumentFormattingRequest;
    (function(DocumentFormattingRequest2) {
      DocumentFormattingRequest2.method = "textDocument/formatting";
      DocumentFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentFormattingRequest2.method);
    })(DocumentFormattingRequest || (exports$12.DocumentFormattingRequest = DocumentFormattingRequest = {}));
    var DocumentRangeFormattingRequest;
    (function(DocumentRangeFormattingRequest2) {
      DocumentRangeFormattingRequest2.method = "textDocument/rangeFormatting";
      DocumentRangeFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentRangeFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentRangeFormattingRequest2.method);
    })(DocumentRangeFormattingRequest || (exports$12.DocumentRangeFormattingRequest = DocumentRangeFormattingRequest = {}));
    var DocumentRangesFormattingRequest;
    (function(DocumentRangesFormattingRequest2) {
      DocumentRangesFormattingRequest2.method = "textDocument/rangesFormatting";
      DocumentRangesFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentRangesFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentRangesFormattingRequest2.method);
    })(DocumentRangesFormattingRequest || (exports$12.DocumentRangesFormattingRequest = DocumentRangesFormattingRequest = {}));
    var DocumentOnTypeFormattingRequest;
    (function(DocumentOnTypeFormattingRequest2) {
      DocumentOnTypeFormattingRequest2.method = "textDocument/onTypeFormatting";
      DocumentOnTypeFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentOnTypeFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentOnTypeFormattingRequest2.method);
    })(DocumentOnTypeFormattingRequest || (exports$12.DocumentOnTypeFormattingRequest = DocumentOnTypeFormattingRequest = {}));
    var PrepareSupportDefaultBehavior;
    (function(PrepareSupportDefaultBehavior2) {
      PrepareSupportDefaultBehavior2.Identifier = 1;
    })(PrepareSupportDefaultBehavior || (exports$12.PrepareSupportDefaultBehavior = PrepareSupportDefaultBehavior = {}));
    var RenameRequest;
    (function(RenameRequest2) {
      RenameRequest2.method = "textDocument/rename";
      RenameRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      RenameRequest2.type = new messages_1.ProtocolRequestType(RenameRequest2.method);
    })(RenameRequest || (exports$12.RenameRequest = RenameRequest = {}));
    var PrepareRenameRequest;
    (function(PrepareRenameRequest2) {
      PrepareRenameRequest2.method = "textDocument/prepareRename";
      PrepareRenameRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      PrepareRenameRequest2.type = new messages_1.ProtocolRequestType(PrepareRenameRequest2.method);
    })(PrepareRenameRequest || (exports$12.PrepareRenameRequest = PrepareRenameRequest = {}));
    var ExecuteCommandRequest;
    (function(ExecuteCommandRequest2) {
      ExecuteCommandRequest2.method = "workspace/executeCommand";
      ExecuteCommandRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ExecuteCommandRequest2.type = new messages_1.ProtocolRequestType(ExecuteCommandRequest2.method);
    })(ExecuteCommandRequest || (exports$12.ExecuteCommandRequest = ExecuteCommandRequest = {}));
    var ApplyWorkspaceEditRequest;
    (function(ApplyWorkspaceEditRequest2) {
      ApplyWorkspaceEditRequest2.method = "workspace/applyEdit";
      ApplyWorkspaceEditRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      ApplyWorkspaceEditRequest2.type = new messages_1.ProtocolRequestType("workspace/applyEdit");
    })(ApplyWorkspaceEditRequest || (exports$12.ApplyWorkspaceEditRequest = ApplyWorkspaceEditRequest = {}));
  })(protocol);
  return protocol;
}
var connection = {};
var hasRequiredConnection;
function requireConnection() {
  if (hasRequiredConnection) return connection;
  hasRequiredConnection = 1;
  Object.defineProperty(connection, "__esModule", { value: true });
  connection.createProtocolConnection = void 0;
  const vscode_jsonrpc_1 = requireMain$1();
  function createProtocolConnection(input, output, logger, options2) {
    if (vscode_jsonrpc_1.ConnectionStrategy.is(options2)) {
      options2 = { connectionStrategy: options2 };
    }
    return (0, vscode_jsonrpc_1.createMessageConnection)(input, output, logger, options2);
  }
  connection.createProtocolConnection = createProtocolConnection;
  return connection;
}
var hasRequiredApi;
function requireApi() {
  if (hasRequiredApi) return api;
  hasRequiredApi = 1;
  (function(exports$12) {
    var __createBinding = api && api.__createBinding || (Object.create ? (function(o, m, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m, k2);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k2];
        } };
      }
      Object.defineProperty(o, k22, desc);
    }) : (function(o, m, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o[k22] = m[k2];
    }));
    var __exportStar = api && api.__exportStar || function(m, exports$122) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports$122, p)) __createBinding(exports$122, m, p);
    };
    Object.defineProperty(exports$12, "__esModule", { value: true });
    exports$12.LSPErrorCodes = exports$12.createProtocolConnection = void 0;
    __exportStar(requireMain$1(), exports$12);
    __exportStar(require$$1, exports$12);
    __exportStar(requireMessages(), exports$12);
    __exportStar(requireProtocol(), exports$12);
    var connection_1 = requireConnection();
    Object.defineProperty(exports$12, "createProtocolConnection", { enumerable: true, get: function() {
      return connection_1.createProtocolConnection;
    } });
    var LSPErrorCodes;
    (function(LSPErrorCodes2) {
      LSPErrorCodes2.lspReservedErrorRangeStart = -32899;
      LSPErrorCodes2.RequestFailed = -32803;
      LSPErrorCodes2.ServerCancelled = -32802;
      LSPErrorCodes2.ContentModified = -32801;
      LSPErrorCodes2.RequestCancelled = -32800;
      LSPErrorCodes2.lspReservedErrorRangeEnd = -32800;
    })(LSPErrorCodes || (exports$12.LSPErrorCodes = LSPErrorCodes = {}));
  })(api);
  return api;
}
var hasRequiredMain;
function requireMain() {
  if (hasRequiredMain) return main$2;
  hasRequiredMain = 1;
  (function(exports$12) {
    var __createBinding = main$2 && main$2.__createBinding || (Object.create ? (function(o, m, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m, k2);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k2];
        } };
      }
      Object.defineProperty(o, k22, desc);
    }) : (function(o, m, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o[k22] = m[k2];
    }));
    var __exportStar = main$2 && main$2.__exportStar || function(m, exports$122) {
      for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports$122, p)) __createBinding(exports$122, m, p);
    };
    Object.defineProperty(exports$12, "__esModule", { value: true });
    exports$12.createProtocolConnection = void 0;
    const browser_1 = requireBrowser$1();
    __exportStar(requireBrowser$1(), exports$12);
    __exportStar(requireApi(), exports$12);
    function createProtocolConnection(reader, writer, logger, options2) {
      return (0, browser_1.createMessageConnection)(reader, writer, logger, options2);
    }
    exports$12.createProtocolConnection = createProtocolConnection;
  })(main$2);
  return main$2;
}
var mainExports$1 = requireMain();
const createLspConnection = (conn) => {
  let capabilities;
  conn.onRequest(mainExports$1.RegistrationRequest.type, ({ registrations }) => {
    for (const { method, registerOptions } of registrations) {
      const provider = METHOD_TO_PROVIDER[method];
      if (provider)
        capabilities[provider] = registerOptions !== null && registerOptions !== void 0 ? registerOptions : true;
    }
  });
  conn.onRequest(mainExports$1.UnregistrationRequest.type, ({ unregisterations }) => {
    for (const { method } of unregisterations) {
      const provider = METHOD_TO_PROVIDER[method];
      if (provider)
        capabilities[provider] = void 0;
    }
  });
  const maybeReq = (cond, type) => (params, token) => cond() ? conn.sendRequest(type, params, token) : Promise.resolve(null);
  const maybeNotify = (cond, type) => (params) => cond() ? conn.sendNotification(type, params) : Promise.resolve();
  const notifier = (type) => (params) => conn.sendNotification(type, params);
  const onNotification = (type) => (handler) => {
    conn.onNotification(type, handler);
  };
  const hasTextDocumentWillSave = () => {
    var _a2;
    const c2 = (_a2 = capabilities.textDocumentSync) !== null && _a2 !== void 0 ? _a2 : mainExports$1.TextDocumentSyncKind.None;
    return typeof c2 !== "number" && !!c2.willSave;
  };
  const hasTextDocumentWillSaveWaitUntil = () => {
    var _a2;
    const c2 = (_a2 = capabilities.textDocumentSync) !== null && _a2 !== void 0 ? _a2 : mainExports$1.TextDocumentSyncKind.None;
    return typeof c2 !== "number" && !!c2.willSaveWaitUntil;
  };
  const hasTextDocumentDidSave = () => {
    var _a2;
    const c2 = (_a2 = capabilities.textDocumentSync) !== null && _a2 !== void 0 ? _a2 : mainExports$1.TextDocumentSyncKind.None;
    return typeof c2 === "number" ? c2 !== mainExports$1.TextDocumentSyncKind.None : !!c2.save;
  };
  return {
    /** Start listening. */
    listen: () => conn.listen(),
    /** Dispose connection. */
    dispose: () => conn.dispose(),
    /**
     * Send initialize request with params and store the server capability.
     */
    initialize: async (params) => {
      const result2 = await conn.sendRequest(mainExports$1.InitializeRequest.type, params);
      capabilities = result2.capabilities;
      return result2;
    },
    /** Notify that the client initialized. */
    initialized: () => (
      // Need to send empty object literal to prevent ParameterStructures error.
      conn.sendNotification(mainExports$1.InitializedNotification.type, {})
    ),
    /** Send shutdown request. */
    shutdown: () => conn.sendRequest(mainExports$1.ShutdownRequest.type),
    /** Notify exit. */
    exit: () => conn.sendNotification(mainExports$1.ExitNotification.type),
    /** Register an error handler. */
    onError: (handler) => conn.onError(([err, msg, code2]) => handler(err, msg, code2)),
    /** Register a close handler. */
    onClose: (handler) => conn.onClose(() => handler()),
    /** Register a handler for logMessage notification. */
    onLogMessage: onNotification(mainExports$1.LogMessageNotification.type),
    /**
     * Register a handler for showMessage notification.
     * The handler should display the message in the user interface.
     */
    onShowMessage: onNotification(mainExports$1.ShowMessageNotification.type),
    /** Register a handler for diagnostics notification. */
    onDiagnostics: onNotification(mainExports$1.PublishDiagnosticsNotification.type),
    /**
     * Notify newly opened text document.
     *
     * "open" means the document's truth is now managed by the client and
     * the server must not try to read the document's truth using the document's
     * uri. It doesn't necessarily mean it's presented in an editor.
     *
     * The notification must not be sent more than once without a corresponding
     * close notification sent before.
     */
    textDocumentOpened: notifier(mainExports$1.DidOpenTextDocumentNotification.type),
    /**
     * Notify the text document got closed.
     *
     * The document's truth now exists where the document's uri points to
     * and the server is allowed to read it using the document's uri.
     *
     * Requires that the text document is "open".
     */
    textDocumentClosed: notifier(mainExports$1.DidCloseTextDocumentNotification.type),
    /**
     * Notify changes to a text document.
     */
    textDocumentChanged: notifier(mainExports$1.DidChangeTextDocumentNotification.type),
    /**
     * Notify that the text document will be saved.
     */
    textDocumentWillSave: maybeNotify(hasTextDocumentWillSave, mainExports$1.WillSaveTextDocumentNotification.type),
    /**
     * Get text edits to apply before saving.
     */
    getEditsBeforeSave: maybeReq(hasTextDocumentWillSaveWaitUntil, mainExports$1.WillSaveTextDocumentWaitUntilRequest.type),
    /**
     * Notify that the text document got saved in the client.
     */
    textDocumentSaved: maybeNotify(hasTextDocumentDidSave, mainExports$1.DidSaveTextDocumentNotification.type),
    /**
     * Notify that the client's configuration changed.
     */
    configurationChanged: notifier(mainExports$1.DidChangeConfigurationNotification.type),
    /**
     * Notify that the client detected changes to files.
     */
    watchedFilesChanged: notifier(mainExports$1.DidChangeWatchedFilesNotification.type),
    /** If supported, request completion at a given text document position. */
    getCompletion: maybeReq(() => !!capabilities.completionProvider, mainExports$1.CompletionRequest.type),
    /** If supported, resolve additional information for a given completion item. */
    getCompletionItemDetails: maybeReq(() => {
      var _a2;
      return !!((_a2 = capabilities.completionProvider) === null || _a2 === void 0 ? void 0 : _a2.resolveProvider);
    }, mainExports$1.CompletionResolveRequest.type),
    /** If supported, request hover information at a given text document position. */
    getHoverInfo: maybeReq(() => !!capabilities.hoverProvider, mainExports$1.HoverRequest.type),
    /** If supported, request signature information at a given text document position. */
    getSignatureHelp: maybeReq(() => !!capabilities.signatureHelpProvider, mainExports$1.SignatureHelpRequest.type),
    /** If supported, resolve the type definition locations of a symbol at a given text document position. */
    getDeclaration: maybeReq(() => !!capabilities.declarationProvider, mainExports$1.DeclarationRequest.type),
    /** If supported, resolve the definition location of a symbol at a given text document position. */
    getDefinition: maybeReq(() => !!capabilities.definitionProvider, mainExports$1.DefinitionRequest.type),
    /** If supported, resolve the type definition locations of a symbol at a given text document position. */
    getTypeDefinition: maybeReq(() => !!capabilities.typeDefinitionProvider, mainExports$1.TypeDefinitionRequest.type),
    /** If supported, resolve the implementation locations of a symbol at a given text document position. */
    getImplementation: maybeReq(() => !!capabilities.implementationProvider, mainExports$1.ImplementationRequest.type),
    /** If supported, resolve project-wide references for the symbol denoted by the given text document position. */
    getReferences: maybeReq(() => !!capabilities.referencesProvider, mainExports$1.ReferencesRequest.type),
    /** If supported, resolve a DocumentHighlight for a given text document position. */
    getDocumentHighlight: maybeReq(() => !!capabilities.documentHighlightProvider, mainExports$1.DocumentHighlightRequest.type),
    /** If supported, list all symbols found in a given text document. */
    getDocumentSymbol: maybeReq(() => !!capabilities.documentSymbolProvider, mainExports$1.DocumentSymbolRequest.type),
    /** If supported, get commands for the given text document and range. */
    getCodeAction: maybeReq(() => !!capabilities.codeActionProvider, mainExports$1.CodeActionRequest.type),
    /** If supported, get code lens for the given text document. */
    getCodeLens: maybeReq(() => !!capabilities.codeLensProvider, mainExports$1.CodeLensRequest.type),
    /** If supported, resolve a command for a given code lens. */
    resolveCodeLens: maybeReq(() => {
      var _a2;
      return !!((_a2 = capabilities.codeLensProvider) === null || _a2 === void 0 ? void 0 : _a2.resolveProvider);
    }, mainExports$1.CodeLensResolveRequest.type),
    /** If supported, get document links. */
    getDocumentLink: maybeReq(() => !!capabilities.documentLinkProvider, mainExports$1.DocumentLinkRequest.type),
    /** If supported, resolve additional information for a given document link. */
    resolveDocumentLink: maybeReq(() => {
      var _a2;
      return !!((_a2 = capabilities.documentLinkProvider) === null || _a2 === void 0 ? void 0 : _a2.resolveProvider);
    }, mainExports$1.DocumentLinkResolveRequest.type),
    /** If supported, list all color symbols found in a given text document. */
    getColorSymbols: maybeReq(() => !!capabilities.colorProvider, mainExports$1.DocumentColorRequest.type),
    /** If supported, get folding ranges in a document. */
    getFoldingRanges: maybeReq(() => !!capabilities.foldingRangeProvider, mainExports$1.FoldingRangeRequest.type),
    /** If supported, get selection ranges in a document. */
    getSelectionRanges: maybeReq(() => !!capabilities.selectionRangeProvider, mainExports$1.SelectionRangeRequest.type),
    /** If supported, list project-wide symbols matching the query string in params. */
    getWorkspaceSymbols: maybeReq(() => !!capabilities.workspaceSymbolProvider, mainExports$1.WorkspaceSymbolRequest.type),
    get syncsIncrementally() {
      var _a2, _b;
      let syncCapability = (_a2 = capabilities.textDocumentSync) !== null && _a2 !== void 0 ? _a2 : mainExports$1.TextDocumentSyncKind.None;
      if (typeof syncCapability !== "number") {
        syncCapability = (_b = syncCapability.change) !== null && _b !== void 0 ? _b : mainExports$1.TextDocumentSyncKind.None;
      }
      return syncCapability === mainExports$1.TextDocumentSyncKind.Incremental;
    },
    get completionTriggers() {
      var _a2;
      return ((_a2 = capabilities.completionProvider) === null || _a2 === void 0 ? void 0 : _a2.triggerCharacters) || [];
    },
    get signatureHelpTriggers() {
      var _a2;
      return ((_a2 = capabilities.signatureHelpProvider) === null || _a2 === void 0 ? void 0 : _a2.triggerCharacters) || [];
    },
    get signatureHelpRetriggers() {
      var _a2;
      return ((_a2 = capabilities.signatureHelpProvider) === null || _a2 === void 0 ? void 0 : _a2.retriggerCharacters) || [];
    }
  };
};
const METHOD_TO_PROVIDER = {
  "textDocument/codeAction": "codeActionProvider",
  "textDocument/codeLens": "codeLensProvider",
  "textDocument/color": "colorProvider",
  "textDocument/completion": "completionProvider",
  "textDocument/declaration": "declarationProvider",
  "textDocument/definition": "definitionProvider",
  "textDocument/documentFormatting": "documentFormattingProvider",
  "textDocument/documentHighlight": "documentHighlightProvider",
  "textDocument/documentLink": "documentLinkProvider",
  "textDocument/documentOnTypeFormatting": "documentOnTypeFormattingProvider",
  "textDocument/documentRangeFormatting": "documentRangeFormattingProvider",
  "textDocument/documentSymbol": "documentSymbolProvider",
  "textDocument/executeCommand": "executeCommandProvider",
  "textDocument/foldingRange": "foldingRangeProvider",
  "textDocument/hover": "hoverProvider",
  "textDocument/implementation": "implementationProvider",
  "textDocument/references": "referencesProvider",
  "textDocument/rename": "renameProvider",
  "textDocument/signatureHelp": "signatureHelpProvider",
  "textDocument/typeDefinition": "typeDefinitionProvider",
  "textDocument/workspaceSymbol": "workspaceSymbolProvider"
};
var mainExports = requireMain$1();
const createMessageReader = (worker) => {
  const messageEmitter = new mainExports.Emitter();
  const errorEmitter = new mainExports.Emitter();
  const closeEmitter = new mainExports.Emitter();
  const partialMessageEmitter = new mainExports.Emitter();
  const messageHandler = (event) => {
    messageEmitter.fire(event.data);
  };
  const errorHandler = (error) => {
    errorEmitter.fire(error);
  };
  worker.addEventListener("message", messageHandler);
  worker.addEventListener("error", errorHandler);
  worker.addEventListener("messageerror", errorHandler);
  return {
    get onError() {
      return errorEmitter.event;
    },
    get onClose() {
      return closeEmitter.event;
    },
    get onPartialMessage() {
      return partialMessageEmitter.event;
    },
    listen(callback) {
      return messageEmitter.event(callback);
    },
    dispose() {
      worker.removeEventListener("message", messageHandler);
      worker.removeEventListener("error", errorHandler);
      worker.removeEventListener("messageerror", errorHandler);
      messageEmitter.dispose();
      errorEmitter.dispose();
      closeEmitter.dispose();
      partialMessageEmitter.dispose();
    }
  };
};
const createMessageWriter = (worker) => {
  const errorEmitter = new mainExports.Emitter();
  const closeEmitter = new mainExports.Emitter();
  let errorCount = 0;
  const errorHandler = (error) => {
    errorEmitter.fire([toError(error), void 0, ++errorCount]);
  };
  worker.addEventListener("error", errorHandler);
  return {
    get onError() {
      return errorEmitter.event;
    },
    get onClose() {
      return closeEmitter.event;
    },
    async write(msg) {
      try {
        worker.postMessage(msg);
      } catch (e2) {
        errorEmitter.fire([toError(e2), msg, ++errorCount]);
      }
    },
    end() {
    },
    dispose() {
      worker.removeEventListener("error", errorHandler);
      errorEmitter.dispose();
      closeEmitter.dispose();
    }
  };
};
const toError = (err) => err instanceof Error ? err : new Error((err === null || err === void 0 ? void 0 : err.message) || "Unknown error");
const createMessageConnection = (worker, logger = createConsoleLogger()) => {
  const conn = mainExports.createMessageConnection(createMessageReader(worker), createMessageWriter(worker), logger);
  conn.onClose(() => conn.dispose());
  return Promise.resolve(conn);
};
const createConsoleLogger = () => ({
  error: (message) => console.error(message),
  warn: (message) => console.warn(message),
  info: (message) => console.info(message),
  log: (message) => console.log(message)
});
async function initWorker(worker) {
  const workerConn = await createMessageConnection(worker);
  const lspConn = createLspConnection(workerConn);
  lspConn.listen();
  await lspConn.initialize({
    capabilities: {
      textDocument: {
        synchronization: {
          dynamicRegistration: true,
          willSave: true,
          willSaveWaitUntil: true,
          didSave: true
        },
        completion: {
          dynamicRegistration: true,
          completionItem: {
            snippetSupport: true,
            insertReplaceSupport: true,
            commitCharactersSupport: false,
            documentationFormat: ["markdown", "plaintext"],
            deprecatedSupport: true,
            preselectSupport: true,
            resolveSupport: {
              properties: ["documentation", "detail"]
            }
          },
          contextSupport: true
        },
        hover: {
          dynamicRegistration: true,
          contentFormat: ["markdown", "plaintext"]
        },
        signatureHelp: {
          dynamicRegistration: true,
          signatureInformation: {
            documentationFormat: ["markdown", "plaintext"],
            parameterInformation: {
              labelOffsetSupport: true
            }
          },
          contextSupport: true
        },
        declaration: {
          dynamicRegistration: true,
          linkSupport: false
        },
        definition: {
          dynamicRegistration: true,
          linkSupport: true
        },
        typeDefinition: {
          dynamicRegistration: true,
          linkSupport: true
        },
        implementation: {
          dynamicRegistration: true,
          linkSupport: true
        },
        references: {
          dynamicRegistration: true
        },
        documentHighlight: {
          dynamicRegistration: true
        },
        documentSymbol: {
          dynamicRegistration: true,
          hierarchicalDocumentSymbolSupport: true
        },
        publishDiagnostics: {
          relatedInformation: true,
          tagSupport: {
            valueSet: [1, 2]
          }
        },
        moniker: {}
      },
      workspace: {
        didChangeConfiguration: {
          dynamicRegistration: true
        },
        didChangeWatchedFiles: {
          dynamicRegistration: false
        }
      }
    },
    initializationOptions: null,
    processId: null,
    rootUri: "file:///",
    workspaceFolders: null
  });
  await lspConn.initialized();
  return { lspConn, workerConn };
}
function withResolver() {
  let resolve;
  const promise = new Promise((res) => {
    resolve = res;
  });
  return { resolve, promise };
}
class LSP {
  constructor() {
    this.versionCounter = {};
    this.initPromise = withResolver();
    this.initStatus = "uninitialized";
    this.completionTriggers = [];
  }
  async init() {
    if (this.lspConn) {
      return;
    }
    if (this.initStatus === "uninitialized") {
      this.initStatus = "initializing";
      this.worker = new WorkerWrapper();
      const { lspConn, workerConn } = await initWorker(this.worker);
      this.lspConn = lspConn;
      this.workerConn = workerConn;
      this.completionTriggers = this.lspConn.completionTriggers;
      this.initPromise.resolve();
      this.initStatus = "initialized";
    }
    if (this.initStatus === "initializing") {
      await this.initPromise.promise;
    }
  }
  async initDocument(uri, text2) {
    if (!this.lspConn) {
      await this.init();
      await this.initDocument(uri, text2);
      return;
    }
    this.versionCounter[uri] = 1;
    await this.lspConn.textDocumentOpened({
      textDocument: {
        uri,
        languageId: "doenet",
        version: 1,
        text: text2
      }
    });
  }
  async closeDocument(uri) {
    if (!this.lspConn) {
      await this.init();
      await this.closeDocument(uri);
      return;
    }
    await this.lspConn.textDocumentClosed({
      textDocument: {
        uri
      }
    });
  }
  async updateDocument(uri, text2) {
    if (!this.lspConn || !this.versionCounter[uri]) {
      await this.initDocument(uri, text2);
      return;
    }
    this.versionCounter[uri] += 1;
    await this.lspConn.textDocumentChanged({
      textDocument: {
        uri,
        version: this.versionCounter[uri]
      },
      contentChanges: [
        {
          text: text2
        }
      ]
    });
  }
  async getDiagnostics(uri) {
    await this.initPromise.promise;
    return new Promise((resolve) => {
      if (!this.lspConn) {
        console.warn("Cannot get diagnostics without lspConn");
        return [];
      }
      this.lspConn.onDiagnostics((params) => {
        if (params.uri === uri) {
          resolve(params.diagnostics);
        }
      });
    });
  }
  async getCompletionItems(uri, position2, context) {
    await this.initPromise.promise;
    if (!this.lspConn) {
      console.warn("Cannot get completion items without lspConn");
      return [];
    }
    return await this.lspConn.getCompletion({
      textDocument: { uri },
      position: position2,
      context
    });
  }
  /**
   * This is a special function just for the Doenet LSP.
   * It allows the client to send additional diagnostics that are not generated by the LSP itself.
   * For example, messages generated by an external instance of Core may be sent here and then delivered
   * by the LSP back to the client.
   */
  async sendAdditionalDiagnostics(uri, additionalDiagnostics) {
    await this.initPromise.promise;
    if (!this.workerConn) {
      console.warn("Cannot send additional diagnostics without lspConn");
      return;
    }
    await this.workerConn.sendRequest("doenet/setAdditionalDiagnostics", {
      uri,
      additionalDiagnostics
    });
  }
}
var browser;
var hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  browser = requireMain();
  return browser;
}
var browserExports = requireBrowser();
const completionItemKindMap = Object.fromEntries(
  Object.entries(browserExports.CompletionItemKind).map(([key, value]) => [value, key])
);
const lspDiagnosticToName = {
  [browserExports.DiagnosticSeverity.Error]: "Error",
  [browserExports.DiagnosticSeverity.Warning]: "Warning",
  [browserExports.DiagnosticSeverity.Information]: "Info",
  [browserExports.DiagnosticSeverity.Hint]: "Hint"
};
const lspSeverityToCmSeverity = {
  [browserExports.DiagnosticSeverity.Error]: "error",
  [browserExports.DiagnosticSeverity.Warning]: "warning",
  [browserExports.DiagnosticSeverity.Information]: "info",
  [browserExports.DiagnosticSeverity.Hint]: "info"
};
const uniqueLanguageServerInstance = new LSP();
class LSPPlugin {
  constructor(documentId) {
    this.uri = "";
    this.value = "";
    this.diagnostics = [];
    this.documentId = documentId;
    this.uri = `file:///${documentId}.doenet`;
  }
  update(update) {
    const value = update.state.doc.toString();
    if (update.docChanged) {
      this.setValue(value);
    }
  }
  async setValue(value) {
    if (value === this.value) {
      return;
    }
    await uniqueLanguageServerInstance.updateDocument(this.uri, value);
    this.pollForDiagnostics();
    this.value = value;
  }
  async pollForDiagnostics() {
    this.diagnosticsPromise = uniqueLanguageServerInstance.getDiagnostics(
      this.uri
    );
    this.diagnostics = await this.diagnosticsPromise;
    this.processDiagnostics();
  }
  processDiagnostics() {
    if (!this.view) {
      return;
    }
    const diagnostics = this.diagnostics.map(({ range: range2, message, severity }) => {
      const cmSeverity = lspSeverityToCmSeverity[severity];
      return {
        from: posToOffset(this.view.state.doc, range2.start),
        to: posToOffset(this.view.state.doc, range2.end),
        severity: cmSeverity,
        message,
        renderMessage: () => {
          const div2 = document.createElement("div");
          div2.innerHTML = `<div class="cm-lint-tooltip"><h4 class="${"heading " + cmSeverity}">${lspDiagnosticToName[severity]}</h4><div class="cm-lint-body">${micromark(
            message
          )}</div>
                            </div>`;
          return div2.firstChild;
        }
      };
    }).filter(({ from, to: to2 }) => from != null && to2 != null).sort((a, b2) => {
      switch (true) {
        case a.from < b2.from:
          return -1;
        case a.from > b2.from:
          return 1;
      }
      return 0;
    });
    const diagnosticTransaction = setDiagnostics(
      this.view.state,
      diagnostics
    );
    this.view.dispatch(diagnosticTransaction);
  }
  async getCompletions(context) {
    let { state, pos, explicit } = context;
    const line2 = state.doc.lineAt(pos);
    let triggerKind = browserExports.CompletionTriggerKind.Invoked;
    let triggerCharacter;
    const precedingTriggerCharacter = uniqueLanguageServerInstance.completionTriggers.includes(
      line2.text[pos - line2.from - 1]
    );
    if (!explicit && precedingTriggerCharacter) {
      triggerKind = browserExports.CompletionTriggerKind.TriggerCharacter;
      triggerCharacter = line2.text[pos - line2.from - 1];
    }
    if (triggerKind === browserExports.CompletionTriggerKind.Invoked && !context.matchBefore(/\w+$/) && !precedingTriggerCharacter && !explicit) {
      return null;
    }
    const position2 = offsetToPos(state.doc, pos);
    const result2 = await uniqueLanguageServerInstance.getCompletionItems(
      this.uri,
      { line: position2.line, character: position2.character },
      {
        triggerKind,
        triggerCharacter
      }
    );
    if (!result2) {
      return null;
    }
    const items = "items" in result2 ? result2.items : result2;
    let options2 = items.map(
      ({
        detail,
        label: label2,
        kind,
        textEdit,
        documentation,
        sortText,
        filterText
      }) => {
        const completion = {
          label: label2,
          detail,
          apply: textEdit?.newText ?? label2,
          type: kind && completionItemKindMap[kind].toLowerCase(),
          sortText: sortText ?? label2,
          filterText: filterText ?? label2
        };
        if (documentation) {
          completion.info = formatContents(documentation);
        }
        return completion;
      }
    );
    const [span, match2] = prefixMatch(options2);
    const token = context.matchBefore(match2);
    if (token) {
      pos = token.from;
      const word = token.text.toLowerCase();
      if (/^\w+$/.test(word)) {
        options2 = options2.filter(
          ({ filterText }) => filterText.toLowerCase().startsWith(word)
        ).sort(({ apply: a }, { apply: b2 }) => {
          switch (true) {
            case (a.startsWith(token.text) && !b2.startsWith(token.text)):
              return -1;
            case (!a.startsWith(token.text) && b2.startsWith(token.text)):
              return 1;
          }
          return 0;
        });
      }
    }
    return {
      from: pos,
      options: options2
    };
  }
}
const lspPlugin = (documentId) => {
  const plugin = new LSPPlugin(documentId);
  return [
    ViewPlugin.define((view) => {
      plugin.view = view;
      plugin.setValue(view.state.doc.toString());
      return plugin;
    }),
    hoverTooltip((view, pos) => {
      return null;
    }),
    autocompletion({
      override: [plugin.getCompletions.bind(plugin)]
    })
  ];
};
function posToOffset(doc2, pos) {
  if (pos.line >= doc2.lines) {
    return;
  }
  const offset2 = doc2.line(pos.line + 1).from + pos.character;
  if (offset2 > doc2.length) {
    return;
  }
  return offset2;
}
function offsetToPos(doc2, offset2) {
  const line2 = doc2.lineAt(offset2);
  return {
    line: line2.number - 1,
    character: offset2 - line2.from
  };
}
function toSet(chars2) {
  let preamble = "";
  let flat = Array.from(chars2).join("");
  const words = /\w/.test(flat);
  if (words) {
    preamble += "\\w";
    flat = flat.replace(/\w/g, "");
  }
  return `[${preamble}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function prefixMatch(options2) {
  const first2 = /* @__PURE__ */ new Set();
  const rest2 = /* @__PURE__ */ new Set();
  for (const { apply } of options2) {
    const [initial2, ...restStr] = apply;
    first2.add(initial2);
    for (const char of restStr) {
      rest2.add(char);
    }
  }
  const source = toSet(first2) + toSet(rest2) + "*$";
  return [new RegExp("^" + source), new RegExp(source)];
}
function formatContents(contents) {
  if (Array.isArray(contents)) {
    return contents.map((c2) => formatContents(c2) + "\n\n").join("");
  } else if (typeof contents === "string") {
    return contents;
  } else {
    return contents.value;
  }
}
const colorTheme = EditorView.theme({
  "&": {
    color: "var(--canvasText)",
    height: "100%"
    //backgroundColor: "var(--canvas)",
  },
  ".cm-content": {
    caretColor: "#0e9",
    borderDownColor: "var(--canvasText)"
  },
  ".cm-editor": {
    caretColor: "#0e9",
    backgroundColor: "var(--canvas)"
  },
  "&.cm-focused .cm-cursor": {
    backgroundColor: "var(--lightBlue)",
    borderLeftColor: "var(--canvasText)"
  },
  "&.cm-focused .cm-selectionBackground, ::selection": {
    backgroundColor: "var(--mainGray)"
  },
  "&.cm-focused": {
    color: "var(--canvasText)"
  },
  "cm-selectionLayer": {
    backgroundColor: "var(--mainGreen)"
  },
  ".cm-gutters": {
    backgroundColor: "var(--mainGray)",
    color: "black",
    border: "none"
  },
  ".cm-activeLine": {
    backgroundColor: "#50505020",
    color: "black"
  }
});
const readOnlyColorTheme = EditorView.theme({
  "&": {
    color: "var(--canvasText)",
    height: "100%"
  },
  ".cm-content": {
    caretColor: "#0e9",
    borderDownColor: "var(--canvasText)",
    backgroundColor: "#77777720"
  },
  ".cm-editor": {
    caretColor: "#0e9"
  },
  "&.cm-focused .cm-cursor": {
    backgroundColor: "var(--lightBlue)",
    borderLeftColor: "var(--canvasText)"
  },
  "&.cm-focused .cm-selectionBackground, ::selection": {
    backgroundColor: "var(--mainGray)"
  },
  "&.cm-focused": {
    color: "var(--canvasText)"
  },
  "cm-selectionLayer": {
    backgroundColor: "var(--mainGreen)"
  },
  ".cm-gutters": {
    backgroundColor: "var(--mainGray)",
    color: "black",
    border: "none"
  },
  ".cm-activeLine": {
    backgroundColor: "var(--mainGray)",
    color: "black"
  },
  ".cm-line": {
    color: "#666666"
  }
});
const CodeMirror = React__default.memo(function CodeMirror2({
  value,
  onChange,
  onCursorChange,
  readOnly: readOnly2,
  onBlur,
  onFocus,
  languageServerRef
}) {
  const [documentId, _2] = React__default.useState(
    () => Math.floor(Math.random() * 1e5).toString()
  );
  React__default.useEffect(() => {
    return () => {
      if (readOnly2) {
        return;
      }
      const uri = `file:///${documentId}.doenet`;
      uniqueLanguageServerInstance.closeDocument(uri);
    };
  }, [documentId, readOnly2]);
  React__default.useEffect(() => {
    if (!languageServerRef) {
      return;
    }
    languageServerRef.current = {
      lsp: uniqueLanguageServerInstance,
      documentUri: `file:///${documentId}.doenet`
    };
  }, [languageServerRef]);
  const extensions = React__default.useMemo(() => {
    const extensions2 = [
      syntaxHighlightingExtension,
      readOnly2 ? readOnlyColorTheme : colorTheme,
      EditorView.lineWrapping
    ];
    if (!readOnly2) {
      extensions2.push(tabExtension);
      extensions2.push(lspPlugin(documentId));
    } else {
      extensions2.push(EditorState.readOnly.of(true));
    }
    return extensions2;
  }, [documentId, readOnly2]);
  return /* @__PURE__ */ React__default.createElement("div", { className: "mathjax_ignore", style: { height: "100%" } }, /* @__PURE__ */ React__default.createElement(
    ReactCodeMirror,
    {
      style: { height: "100%" },
      value,
      basicSetup: {
        indentOnInput: true,
        highlightActiveLine: !readOnly2,
        highlightActiveLineGutter: !readOnly2
      },
      onChange: (editor, update) => {
        if (onChange) {
          onChange(update.state.doc.toString());
        }
      },
      onUpdate: (viewUpdate) => {
        for (const tr2 of viewUpdate.transactions) {
          if (tr2.selection && onCursorChange) {
            onCursorChange(tr2.selection);
          }
        }
      },
      onBlur: () => onBlur && onBlur(),
      onFocus: () => onFocus && onFocus(),
      height: "100%",
      extensions
    }
  ));
});
function ErrorWarningResponseTabstrip({
  store: store2,
  isOpen,
  showErrorsWarnings,
  warnings,
  errors: errors2,
  submittedResponses,
  setIsOpen,
  showResponses
}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabProvider, { store: store2, children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
    TabList,
    {
      onClick: (e2) => {
        if (!isOpen) {
          setIsOpen(true);
        }
      },
      className: "error-warning-response-tabs",
      store: store2,
      children: [
        showErrorsWarnings && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(Tab, { children: [
          warnings.length,
          " Warning",
          warnings.length != 1 && "s"
        ] }),
        showErrorsWarnings && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(Tab, { children: [
          errors2.length,
          " Error",
          errors2.length != 1 && "s"
        ] }),
        showResponses && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(Tab, { children: [
          submittedResponses.length,
          " Submitted response",
          submittedResponses.length != 1 && "s"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          "div",
          {
            style: {
              flexGrow: 1
            }
          }
        ),
        isOpen ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          Button,
          {
            title: "Close panel",
            className: "close-button",
            onClick: () => {
              setIsOpen(false);
            },
            children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsX, {})
          }
        ) : null
      ]
    }
  ) });
}
function ErrorWarningResponseTabContents({
  store: store2,
  warnings,
  errors: errors2,
  submittedResponses,
  isOpen,
  setIsOpen,
  showErrorsWarnings = true,
  showResponses = true
}) {
  const panels = useRef(null);
  const lastScrolledToBottom = useRef(true);
  function scrollToBottom() {
    if (panels.current) {
      setTimeout(() => {
        if (panels.current) {
          panels.current.scrollTo(0, panels.current.scrollHeight);
        }
      });
    }
  }
  useEffect(() => {
    function scrollListener() {
      if (panels.current) {
        lastScrolledToBottom.current = Math.abs(
          panels.current.scrollHeight - panels.current.scrollTop - panels.current.clientHeight
        ) <= 3;
      }
    }
    panels.current?.addEventListener("scroll", scrollListener);
    return () => {
      panels.current?.removeEventListener("scroll", scrollListener);
    };
  }, [panels.current]);
  useEffect(() => {
    if (isOpen) {
      scrollToBottom();
    }
  }, [isOpen]);
  useEffect(() => {
    if (isOpen) {
      if (lastScrolledToBottom.current) {
        scrollToBottom();
      }
    }
  }, [submittedResponses]);
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    "div",
    {
      className: classNames("error-warning-response-tabs-container", {
        "is-open": isOpen
      }),
      children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabProvider, { store: store2, children: isOpen && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
        "div",
        {
          ref: panels,
          className: "error-warning-response-tabs-panels",
          children: [
            showErrorsWarnings && /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabPanel, { store: store2, children: warnings.length == 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx("h3", { children: "No Warnings" }) : /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              "ul",
              {
                style: {
                  listStyleType: "none"
                },
                children: warnings.map((warningObj, i2) => {
                  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
                    "li",
                    {
                      "data-test": `Warning ${i2}`,
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                          BsExclamationTriangleFill,
                          {
                            style: {
                              color: "yellow",
                              marginRight: 4,
                              marginBottom: -2
                            }
                          }
                        ),
                        warningObj.position ? `Line #${warningObj.position?.start.line}` : null,
                        " ",
                        warningObj.message
                      ]
                    },
                    i2
                  );
                })
              }
            ) }),
            showErrorsWarnings && /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabPanel, { store: store2, children: errors2.length == 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx("h3", { children: "No Errors" }) : /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              "ul",
              {
                style: {
                  listStyleType: "none"
                },
                children: errors2.map((errorObj, i2) => {
                  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
                    "li",
                    {
                      "data-test": `Error ${i2}`,
                      children: [
                        /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                          BsExclamationTriangleFill,
                          {
                            color: "red",
                            style: {
                              marginRight: 4,
                              marginBottom: -2
                            }
                          }
                        ),
                        errorObj.position ? `Line #${errorObj.position?.start.line}` : null,
                        " ",
                        errorObj.message
                      ]
                    },
                    i2
                  );
                })
              }
            ) }),
            showResponses && /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabPanel, { store: store2, children: submittedResponses.length == 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx("h3", { children: "No submitted responses yet" }) : /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { style: { minWidth: "fit-content" }, children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs("table", { children: [
              /* @__PURE__ */ jsxRuntimeExports$3.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs("tr", { children: [
                /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: "Answer Id" }),
                /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: "Response" }),
                /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: "Credit" }),
                /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: "Submitted" })
              ] }) }),
              /* @__PURE__ */ jsxRuntimeExports$3.jsx("tbody", { children: submittedResponses.map(
                (resp, i2) => {
                  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("tr", { children: [
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: resp.answerId }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: resp.response }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsxs("td", { children: [
                      Math.round(
                        resp.creditAchieved * 1e3
                      ) / 10,
                      "%"
                    ] }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: resp.submittedAt })
                  ] }, i2);
                }
              ) })
            ] }) }) })
          ]
        }
      ) })
    }
  );
}
var Zn = Object.create;
var Mt = Object.defineProperty;
var eo = Object.getOwnPropertyDescriptor;
var to = Object.getOwnPropertyNames;
var uo = Object.getPrototypeOf, ro = Object.prototype.hasOwnProperty;
var no = (e2, t2) => () => (t2 || e2((t2 = { exports: {} }).exports, t2), t2.exports), Yt = (e2, t2) => {
  for (var u in t2) Mt(e2, u, { get: t2[u], enumerable: true });
}, oo = (e2, t2, u, r) => {
  if (t2 && typeof t2 == "object" || typeof t2 == "function") for (let o of to(t2)) !ro.call(e2, o) && o !== u && Mt(e2, o, { get: () => t2[o], enumerable: !(r = eo(t2, o)) || r.enumerable });
  return e2;
};
var ao = (e2, t2, u) => (u = e2 != null ? Zn(uo(e2)) : {}, oo(Mt(u, "default", { value: e2, enumerable: true }), e2));
var dn = no((of, ln2) => {
  var yt, bt, At, _t, xt, $e, bu, Ke, Bt, cn, Tt, Ve, Nt, St, wt, pe, fn, Ot, Pt;
  Nt = /\/(?![*\/])(?:\[(?:[^\]\\\n\r\u2028\u2029]+|\\.)*\]|[^\/\\\n\r\u2028\u2029]+|\\.)*(\/[$_\u200C\u200D\p{ID_Continue}]*|\\)?/yu;
  Ve = /--|\+\+|=>|\.{3}|\??\.(?!\d)|(?:&&|\|\||\?\?|[+\-%&|^]|\*{1,2}|<{1,2}|>{1,3}|!=?|={1,2}|\/(?![\/*]))=?|[?~,:;[\](){}]/y;
  yt = /(\x23?)(?=[$_\p{ID_Start}\\])(?:[$_\u200C\u200D\p{ID_Continue}]+|\\u[\da-fA-F]{4}|\\u\{[\da-fA-F]+\})+/yu;
  wt = /(['"])(?:[^'"\\\n\r]+|(?!\1)['"]|\\(?:\r\n|[^]))*(\1)?/y;
  Tt = /(?:0[xX][\da-fA-F](?:_?[\da-fA-F])*|0[oO][0-7](?:_?[0-7])*|0[bB][01](?:_?[01])*)n?|0n|[1-9](?:_?\d)*n|(?:(?:0(?!\d)|0\d*[89]\d*|[1-9](?:_?\d)*)(?:\.(?:\d(?:_?\d)*)?)?|\.\d(?:_?\d)*)(?:[eE][+-]?\d(?:_?\d)*)?|0[0-7]+/y;
  pe = /[`}](?:[^`\\$]+|\\[^]|\$(?!\{))*(`|\$\{)?/y;
  Pt = /[\t\v\f\ufeff\p{Zs}]+/yu;
  Ke = /\r?\n|[\r\u2028\u2029]/y;
  Bt = /\/\*(?:[^*]+|\*(?!\/))*(\*\/)?/y;
  St = /\/\/.*/y;
  At = /[<>.:={}]|\/(?![\/*])/y;
  bt = /[$_\p{ID_Start}][$_\u200C\u200D\p{ID_Continue}-]*/yu;
  _t = /(['"])(?:[^'"]+|(?!\1)['"])*(\1)?/y;
  xt = /[^<>{}]+/y;
  Ot = /^(?:[\/+-]|\.{3}|\?(?:InterpolationIn(?:JSX|Template)|NoLineTerminatorHere|NonExpressionParenEnd|UnaryIncDec))?$|[{}([,;<>=*%&|^!~?:]$/;
  fn = /^(?:=>|[;\]){}]|else|\?(?:NoLineTerminatorHere|NonExpressionParenEnd))?$/;
  $e = /^(?:await|case|default|delete|do|else|instanceof|new|return|throw|typeof|void|yield)$/;
  bu = /^(?:return|throw|yield)$/;
  cn = RegExp(Ke.source);
  ln2.exports = function* (e2, { jsx: t2 = false } = {}) {
    var u, r, o, n, a, s, i2, D, f2, l, d, c2, p, F;
    for ({ length: s } = e2, n = 0, a = "", F = [{ tag: "JS" }], u = [], d = 0, c2 = false; n < s; ) {
      switch (D = F[F.length - 1], D.tag) {
        case "JS":
        case "JSNonExpressionParen":
        case "InterpolationInTemplate":
        case "InterpolationInJSX":
          if (e2[n] === "/" && (Ot.test(a) || $e.test(a)) && (Nt.lastIndex = n, i2 = Nt.exec(e2))) {
            n = Nt.lastIndex, a = i2[0], c2 = true, yield { type: "RegularExpressionLiteral", value: i2[0], closed: i2[1] !== void 0 && i2[1] !== "\\" };
            continue;
          }
          if (Ve.lastIndex = n, i2 = Ve.exec(e2)) {
            switch (p = i2[0], f2 = Ve.lastIndex, l = p, p) {
              case "(":
                a === "?NonExpressionParenKeyword" && F.push({ tag: "JSNonExpressionParen", nesting: d }), d++, c2 = false;
                break;
              case ")":
                d--, c2 = true, D.tag === "JSNonExpressionParen" && d === D.nesting && (F.pop(), l = "?NonExpressionParenEnd", c2 = false);
                break;
              case "{":
                Ve.lastIndex = 0, o = !fn.test(a) && (Ot.test(a) || $e.test(a)), u.push(o), c2 = false;
                break;
              case "}":
                switch (D.tag) {
                  case "InterpolationInTemplate":
                    if (u.length === D.nesting) {
                      pe.lastIndex = n, i2 = pe.exec(e2), n = pe.lastIndex, a = i2[0], i2[1] === "${" ? (a = "?InterpolationInTemplate", c2 = false, yield { type: "TemplateMiddle", value: i2[0] }) : (F.pop(), c2 = true, yield { type: "TemplateTail", value: i2[0], closed: i2[1] === "`" });
                      continue;
                    }
                    break;
                  case "InterpolationInJSX":
                    if (u.length === D.nesting) {
                      F.pop(), n += 1, a = "}", yield { type: "JSXPunctuator", value: "}" };
                      continue;
                    }
                }
                c2 = u.pop(), l = c2 ? "?ExpressionBraceEnd" : "}";
                break;
              case "]":
                c2 = true;
                break;
              case "++":
              case "--":
                l = c2 ? "?PostfixIncDec" : "?UnaryIncDec";
                break;
              case "<":
                if (t2 && (Ot.test(a) || $e.test(a))) {
                  F.push({ tag: "JSXTag" }), n += 1, a = "<", yield { type: "JSXPunctuator", value: p };
                  continue;
                }
                c2 = false;
                break;
              default:
                c2 = false;
            }
            n = f2, a = l, yield { type: "Punctuator", value: p };
            continue;
          }
          if (yt.lastIndex = n, i2 = yt.exec(e2)) {
            switch (n = yt.lastIndex, l = i2[0], i2[0]) {
              case "for":
              case "if":
              case "while":
              case "with":
                a !== "." && a !== "?." && (l = "?NonExpressionParenKeyword");
            }
            a = l, c2 = !$e.test(i2[0]), yield { type: i2[1] === "#" ? "PrivateIdentifier" : "IdentifierName", value: i2[0] };
            continue;
          }
          if (wt.lastIndex = n, i2 = wt.exec(e2)) {
            n = wt.lastIndex, a = i2[0], c2 = true, yield { type: "StringLiteral", value: i2[0], closed: i2[2] !== void 0 };
            continue;
          }
          if (Tt.lastIndex = n, i2 = Tt.exec(e2)) {
            n = Tt.lastIndex, a = i2[0], c2 = true, yield { type: "NumericLiteral", value: i2[0] };
            continue;
          }
          if (pe.lastIndex = n, i2 = pe.exec(e2)) {
            n = pe.lastIndex, a = i2[0], i2[1] === "${" ? (a = "?InterpolationInTemplate", F.push({ tag: "InterpolationInTemplate", nesting: u.length }), c2 = false, yield { type: "TemplateHead", value: i2[0] }) : (c2 = true, yield { type: "NoSubstitutionTemplate", value: i2[0], closed: i2[1] === "`" });
            continue;
          }
          break;
        case "JSXTag":
        case "JSXTagEnd":
          if (At.lastIndex = n, i2 = At.exec(e2)) {
            switch (n = At.lastIndex, l = i2[0], i2[0]) {
              case "<":
                F.push({ tag: "JSXTag" });
                break;
              case ">":
                F.pop(), a === "/" || D.tag === "JSXTagEnd" ? (l = "?JSX", c2 = true) : F.push({ tag: "JSXChildren" });
                break;
              case "{":
                F.push({ tag: "InterpolationInJSX", nesting: u.length }), l = "?InterpolationInJSX", c2 = false;
                break;
              case "/":
                a === "<" && (F.pop(), F[F.length - 1].tag === "JSXChildren" && F.pop(), F.push({ tag: "JSXTagEnd" }));
            }
            a = l, yield { type: "JSXPunctuator", value: i2[0] };
            continue;
          }
          if (bt.lastIndex = n, i2 = bt.exec(e2)) {
            n = bt.lastIndex, a = i2[0], yield { type: "JSXIdentifier", value: i2[0] };
            continue;
          }
          if (_t.lastIndex = n, i2 = _t.exec(e2)) {
            n = _t.lastIndex, a = i2[0], yield { type: "JSXString", value: i2[0], closed: i2[2] !== void 0 };
            continue;
          }
          break;
        case "JSXChildren":
          if (xt.lastIndex = n, i2 = xt.exec(e2)) {
            n = xt.lastIndex, a = i2[0], yield { type: "JSXText", value: i2[0] };
            continue;
          }
          switch (e2[n]) {
            case "<":
              F.push({ tag: "JSXTag" }), n++, a = "<", yield { type: "JSXPunctuator", value: "<" };
              continue;
            case "{":
              F.push({ tag: "InterpolationInJSX", nesting: u.length }), n++, a = "?InterpolationInJSX", c2 = false, yield { type: "JSXPunctuator", value: "{" };
              continue;
          }
      }
      if (Pt.lastIndex = n, i2 = Pt.exec(e2)) {
        n = Pt.lastIndex, yield { type: "WhiteSpace", value: i2[0] };
        continue;
      }
      if (Ke.lastIndex = n, i2 = Ke.exec(e2)) {
        n = Ke.lastIndex, c2 = false, bu.test(a) && (a = "?NoLineTerminatorHere"), yield { type: "LineTerminatorSequence", value: i2[0] };
        continue;
      }
      if (Bt.lastIndex = n, i2 = Bt.exec(e2)) {
        n = Bt.lastIndex, cn.test(i2[0]) && (c2 = false, bu.test(a) && (a = "?NoLineTerminatorHere")), yield { type: "MultiLineComment", value: i2[0], closed: i2[1] !== void 0 };
        continue;
      }
      if (St.lastIndex = n, i2 = St.exec(e2)) {
        n = St.lastIndex, c2 = false, yield { type: "SingleLineComment", value: i2[0] };
        continue;
      }
      r = String.fromCodePoint(e2.codePointAt(n)), n += r.length, a = r, c2 = false, yield { type: D.tag.startsWith("JSX") ? "JSXInvalid" : "Invalid", value: r };
    }
  };
});
var Hn = {};
Yt(Hn, { __debug: () => li, check: () => ci, doc: () => wu, format: () => Jn, formatWithCursor: () => zn, getSupportInfo: () => fi, util: () => Pu, version: () => Mn });
var X = (e2, t2) => (u, r, ...o) => u | 1 && r == null ? void 0 : (t2.call(r) ?? r[e2]).apply(r, o);
var io = String.prototype.replaceAll ?? function(e2, t2) {
  return e2.global ? this.replace(e2, t2) : this.split(e2).join(t2);
}, so = X("replaceAll", function() {
  if (typeof this == "string") return io;
}), oe = so;
var Ne = class {
  diff(t2, u, r = {}) {
    let o;
    typeof r == "function" ? (o = r, r = {}) : "callback" in r && (o = r.callback);
    let n = this.castInput(t2, r), a = this.castInput(u, r), s = this.removeEmpty(this.tokenize(n, r)), i2 = this.removeEmpty(this.tokenize(a, r));
    return this.diffWithOptionsObj(s, i2, r, o);
  }
  diffWithOptionsObj(t2, u, r, o) {
    var n;
    let a = (m) => {
      if (m = this.postProcess(m, r), o) {
        setTimeout(function() {
          o(m);
        }, 0);
        return;
      } else return m;
    }, s = u.length, i2 = t2.length, D = 1, f2 = s + i2;
    r.maxEditLength != null && (f2 = Math.min(f2, r.maxEditLength));
    let l = (n = r.timeout) !== null && n !== void 0 ? n : 1 / 0, d = Date.now() + l, c2 = [{ oldPos: -1, lastComponent: void 0 }], p = this.extractCommon(c2[0], u, t2, 0, r);
    if (c2[0].oldPos + 1 >= i2 && p + 1 >= s) return a(this.buildValues(c2[0].lastComponent, u, t2));
    let F = -1 / 0, C2 = 1 / 0, y = () => {
      for (let m = Math.max(F, -D); m <= Math.min(C2, D); m += 2) {
        let h, E = c2[m - 1], g = c2[m + 1];
        E && (c2[m - 1] = void 0);
        let A2 = false;
        if (g) {
          let Q2 = g.oldPos - m;
          A2 = g && 0 <= Q2 && Q2 < s;
        }
        let J = E && E.oldPos + 1 < i2;
        if (!A2 && !J) {
          c2[m] = void 0;
          continue;
        }
        if (!J || A2 && E.oldPos < g.oldPos ? h = this.addToPath(g, true, false, 0, r) : h = this.addToPath(E, false, true, 1, r), p = this.extractCommon(h, u, t2, m, r), h.oldPos + 1 >= i2 && p + 1 >= s) return a(this.buildValues(h.lastComponent, u, t2)) || true;
        c2[m] = h, h.oldPos + 1 >= i2 && (C2 = Math.min(C2, m - 1)), p + 1 >= s && (F = Math.max(F, m + 1));
      }
      D++;
    };
    if (o) (function m() {
      setTimeout(function() {
        if (D > f2 || Date.now() > d) return o(void 0);
        y() || m();
      }, 0);
    })();
    else for (; D <= f2 && Date.now() <= d; ) {
      let m = y();
      if (m) return m;
    }
  }
  addToPath(t2, u, r, o, n) {
    let a = t2.lastComponent;
    return a && !n.oneChangePerToken && a.added === u && a.removed === r ? { oldPos: t2.oldPos + o, lastComponent: { count: a.count + 1, added: u, removed: r, previousComponent: a.previousComponent } } : { oldPos: t2.oldPos + o, lastComponent: { count: 1, added: u, removed: r, previousComponent: a } };
  }
  extractCommon(t2, u, r, o, n) {
    let a = u.length, s = r.length, i2 = t2.oldPos, D = i2 - o, f2 = 0;
    for (; D + 1 < a && i2 + 1 < s && this.equals(r[i2 + 1], u[D + 1], n); ) D++, i2++, f2++, n.oneChangePerToken && (t2.lastComponent = { count: 1, previousComponent: t2.lastComponent, added: false, removed: false });
    return f2 && !n.oneChangePerToken && (t2.lastComponent = { count: f2, previousComponent: t2.lastComponent, added: false, removed: false }), t2.oldPos = i2, D;
  }
  equals(t2, u, r) {
    return r.comparator ? r.comparator(t2, u) : t2 === u || !!r.ignoreCase && t2.toLowerCase() === u.toLowerCase();
  }
  removeEmpty(t2) {
    let u = [];
    for (let r = 0; r < t2.length; r++) t2[r] && u.push(t2[r]);
    return u;
  }
  castInput(t2, u) {
    return t2;
  }
  tokenize(t2, u) {
    return Array.from(t2);
  }
  join(t2) {
    return t2.join("");
  }
  postProcess(t2, u) {
    return t2;
  }
  get useLongestToken() {
    return false;
  }
  buildValues(t2, u, r) {
    let o = [], n;
    for (; t2; ) o.push(t2), n = t2.previousComponent, delete t2.previousComponent, t2 = n;
    o.reverse();
    let a = o.length, s = 0, i2 = 0, D = 0;
    for (; s < a; s++) {
      let f2 = o[s];
      if (f2.removed) f2.value = this.join(r.slice(D, D + f2.count)), D += f2.count;
      else {
        if (!f2.added && this.useLongestToken) {
          let l = u.slice(i2, i2 + f2.count);
          l = l.map(function(d, c2) {
            let p = r[D + c2];
            return p.length > d.length ? p : d;
          }), f2.value = this.join(l);
        } else f2.value = this.join(u.slice(i2, i2 + f2.count));
        i2 += f2.count, f2.added || (D += f2.count);
      }
    }
    return o;
  }
};
var jt = class extends Ne {
  tokenize(t2) {
    return t2.slice();
  }
  join(t2) {
    return t2;
  }
  removeEmpty(t2) {
    return t2;
  }
}, ku = new jt();
function Ut(e2, t2, u) {
  return ku.diff(e2, t2, u);
}
var Do = () => {
}, P = Do;
var Ru = "cr", Lu = "crlf", co = "lf", fo = co, Wt = "\r", Mu = `\r
`, Je = `
`, lo = Je;
function Yu(e2) {
  let t2 = e2.indexOf(Wt);
  return t2 !== -1 ? e2.charAt(t2 + 1) === Je ? Lu : Ru : fo;
}
function Se(e2) {
  return e2 === Ru ? Wt : e2 === Lu ? Mu : lo;
}
var po = /* @__PURE__ */ new Map([[Je, /\n/gu], [Wt, /\r/gu], [Mu, /\r\n/gu]]);
function $t(e2, t2) {
  let u = po.get(t2);
  return e2.match(u)?.length ?? 0;
}
var Fo = /\r\n?/gu;
function ju(e2) {
  return oe(0, e2, Fo, Je);
}
function mo(e2) {
  return this[e2 < 0 ? this.length + e2 : e2];
}
var Eo = X("at", function() {
  if (Array.isArray(this) || typeof this == "string") return mo;
}), b = Eo;
var G = "string", j = "array", U = "cursor", I = "indent", k = "align", v = "trim", x = "group", w = "fill", B = "if-break", R = "indent-if-break", L = "line-suffix", M = "line-suffix-boundary", _ = "line", O = "label", T$1 = "break-parent", He = /* @__PURE__ */ new Set([U, I, k, v, x, w, B, R, L, M, _, O, T$1]);
function Uu(e2) {
  let t2 = e2.length;
  for (; t2 > 0 && (e2[t2 - 1] === "\r" || e2[t2 - 1] === `
`); ) t2--;
  return t2 < e2.length ? e2.slice(0, t2) : e2;
}
function Co(e2) {
  if (typeof e2 == "string") return G;
  if (Array.isArray(e2)) return j;
  if (!e2) return;
  let { type: t2 } = e2;
  if (He.has(t2)) return t2;
}
var H = Co;
var ho = (e2) => new Intl.ListFormat("en-US", { type: "disjunction" }).format(e2);
function go(e2) {
  let t2 = e2 === null ? "null" : typeof e2;
  if (t2 !== "string" && t2 !== "object") return `Unexpected doc '${t2}', 
Expected it to be 'string' or 'object'.`;
  if (H(e2)) throw new Error("doc is valid.");
  let u = Object.prototype.toString.call(e2);
  if (u !== "[object Object]") return `Unexpected doc '${u}'.`;
  let r = ho([...He].map((o) => `'${o}'`));
  return `Unexpected doc.type '${e2.type}'.
Expected it to be ${r}.`;
}
var Vt = class extends Error {
  name = "InvalidDocError";
  constructor(t2) {
    super(go(t2)), this.doc = t2;
  }
}, Z = Vt;
var Wu = {};
function yo(e2, t2, u, r) {
  let o = [e2];
  for (; o.length > 0; ) {
    let n = o.pop();
    if (n === Wu) {
      u(o.pop());
      continue;
    }
    u && o.push(n, Wu);
    let a = H(n);
    if (!a) throw new Z(n);
    if (t2?.(n) !== false) switch (a) {
      case j:
      case w: {
        let s = a === j ? n : n.parts;
        for (let i2 = s.length, D = i2 - 1; D >= 0; --D) o.push(s[D]);
        break;
      }
      case B:
        o.push(n.flatContents, n.breakContents);
        break;
      case x:
        if (r && n.expandedStates) for (let s = n.expandedStates.length, i2 = s - 1; i2 >= 0; --i2) o.push(n.expandedStates[i2]);
        else o.push(n.contents);
        break;
      case k:
      case I:
      case R:
      case O:
      case L:
        o.push(n.contents);
        break;
      case G:
      case U:
      case v:
      case M:
      case _:
      case T$1:
        break;
      default:
        throw new Z(n);
    }
  }
}
var we = yo;
function Pe(e2, t2) {
  if (typeof e2 == "string") return t2(e2);
  let u = /* @__PURE__ */ new Map();
  return r(e2);
  function r(n) {
    if (u.has(n)) return u.get(n);
    let a = o(n);
    return u.set(n, a), a;
  }
  function o(n) {
    switch (H(n)) {
      case j:
        return t2(n.map(r));
      case w:
        return t2({ ...n, parts: n.parts.map(r) });
      case B:
        return t2({ ...n, breakContents: r(n.breakContents), flatContents: r(n.flatContents) });
      case x: {
        let { expandedStates: a, contents: s } = n;
        return a ? (a = a.map(r), s = a[0]) : s = r(s), t2({ ...n, contents: s, expandedStates: a });
      }
      case k:
      case I:
      case R:
      case O:
      case L:
        return t2({ ...n, contents: r(n.contents) });
      case G:
      case U:
      case v:
      case M:
      case _:
      case T$1:
        return t2(n);
      default:
        throw new Z(n);
    }
  }
}
function Xe(e2, t2, u) {
  let r = u, o = false;
  function n(a) {
    if (o) return false;
    let s = t2(a);
    s !== void 0 && (o = true, r = s);
  }
  return we(e2, n), r;
}
function bo(e2) {
  if (e2.type === x && e2.break || e2.type === _ && e2.hard || e2.type === T$1) return true;
}
function Ku(e2) {
  return Xe(e2, bo, false);
}
function $u(e2) {
  if (e2.length > 0) {
    let t2 = b(0, e2, -1);
    !t2.expandedStates && !t2.break && (t2.break = "propagated");
  }
  return null;
}
function Gu(e2) {
  let t2 = /* @__PURE__ */ new Set(), u = [];
  function r(n) {
    if (n.type === T$1 && $u(u), n.type === x) {
      if (u.push(n), t2.has(n)) return false;
      t2.add(n);
    }
  }
  function o(n) {
    n.type === x && u.pop().break && $u(u);
  }
  we(e2, r, o, true);
}
function Ao(e2) {
  return e2.type === _ && !e2.hard ? e2.soft ? "" : " " : e2.type === B ? e2.flatContents : e2;
}
function zu(e2) {
  return Pe(e2, Ao);
}
function Vu(e2) {
  for (e2 = [...e2]; e2.length >= 2 && b(0, e2, -2).type === _ && b(0, e2, -1).type === T$1; ) e2.length -= 2;
  if (e2.length > 0) {
    let t2 = Oe(b(0, e2, -1));
    e2[e2.length - 1] = t2;
  }
  return e2;
}
function Oe(e2) {
  switch (H(e2)) {
    case I:
    case R:
    case x:
    case L:
    case O: {
      let t2 = Oe(e2.contents);
      return { ...e2, contents: t2 };
    }
    case B:
      return { ...e2, breakContents: Oe(e2.breakContents), flatContents: Oe(e2.flatContents) };
    case w:
      return { ...e2, parts: Vu(e2.parts) };
    case j:
      return Vu(e2);
    case G:
      return Uu(e2);
    case k:
    case U:
    case v:
    case M:
    case _:
    case T$1:
      break;
    default:
      throw new Z(e2);
  }
  return e2;
}
function qe(e2) {
  return Oe(xo(e2));
}
function _o(e2) {
  switch (H(e2)) {
    case w:
      if (e2.parts.every((t2) => t2 === "")) return "";
      break;
    case x:
      if (!e2.contents && !e2.id && !e2.break && !e2.expandedStates) return "";
      if (e2.contents.type === x && e2.contents.id === e2.id && e2.contents.break === e2.break && e2.contents.expandedStates === e2.expandedStates) return e2.contents;
      break;
    case k:
    case I:
    case R:
    case L:
      if (!e2.contents) return "";
      break;
    case B:
      if (!e2.flatContents && !e2.breakContents) return "";
      break;
    case j: {
      let t2 = [];
      for (let u of e2) {
        if (!u) continue;
        let [r, ...o] = Array.isArray(u) ? u : [u];
        typeof r == "string" && typeof b(0, t2, -1) == "string" ? t2[t2.length - 1] += r : t2.push(r), t2.push(...o);
      }
      return t2.length === 0 ? "" : t2.length === 1 ? t2[0] : t2;
    }
    case G:
    case U:
    case v:
    case M:
    case _:
    case O:
    case T$1:
      break;
    default:
      throw new Z(e2);
  }
  return e2;
}
function xo(e2) {
  return Pe(e2, (t2) => _o(t2));
}
function Ju(e2, t2 = Qe) {
  return Pe(e2, (u) => typeof u == "string" ? Ie(t2, u.split(`
`)) : u);
}
function Bo(e2) {
  if (e2.type === _) return true;
}
function Hu(e2) {
  return Xe(e2, Bo, false);
}
function Ee(e2, t2) {
  return e2.type === O ? { ...e2, contents: t2(e2.contents) } : t2(e2);
}
var Ze = P;
function ae(e2) {
  return { type: I, contents: e2 };
}
function De(e2, t2) {
  return { type: k, contents: t2, n: e2 };
}
function Qu(e2) {
  return De(Number.NEGATIVE_INFINITY, e2);
}
function et(e2) {
  return De({ type: "root" }, e2);
}
function Zu(e2) {
  return De(-1, e2);
}
function tt(e2, t2, u) {
  let r = e2;
  if (t2 > 0) {
    for (let o = 0; o < Math.floor(t2 / u); ++o) r = ae(r);
    r = De(t2 % u, r), r = De(Number.NEGATIVE_INFINITY, r);
  }
  return r;
}
var ce = { type: T$1 };
var ee = { type: U };
function er(e2) {
  return { type: w, parts: e2 };
}
function Kt(e2, t2 = {}) {
  return Ze(t2.expandedStates), { type: x, id: t2.id, contents: e2, break: !!t2.shouldBreak, expandedStates: t2.expandedStates };
}
function tr(e2, t2) {
  return Kt(e2[0], { ...t2, expandedStates: e2 });
}
function ur(e2, t2 = "", u = {}) {
  return { type: B, breakContents: e2, flatContents: t2, groupId: u.groupId };
}
function rr(e2, t2) {
  return { type: R, contents: e2, groupId: t2.groupId, negate: t2.negate };
}
function Ie(e2, t2) {
  let u = [];
  for (let r = 0; r < t2.length; r++) r !== 0 && u.push(e2), u.push(t2[r]);
  return u;
}
function nr(e2, t2) {
  return e2 ? { type: O, label: e2, contents: t2 } : t2;
}
var ut = { type: _ }, or = { type: _, soft: true }, ke = { type: _, hard: true }, V = [ke, ce], Gt = { type: _, hard: true, literal: true }, Qe = [Gt, ce];
function ve(e2) {
  return { type: L, contents: e2 };
}
var ar = { type: M };
var ir = { type: v };
function te(e2) {
  if (!e2) return "";
  if (Array.isArray(e2)) {
    let t2 = [];
    for (let u of e2) if (Array.isArray(u)) t2.push(...te(u));
    else {
      let r = te(u);
      r !== "" && t2.push(r);
    }
    return t2;
  }
  return e2.type === B ? { ...e2, breakContents: te(e2.breakContents), flatContents: te(e2.flatContents) } : e2.type === x ? { ...e2, contents: te(e2.contents), expandedStates: e2.expandedStates?.map(te) } : e2.type === w ? { type: "fill", parts: e2.parts.map(te) } : e2.contents ? { ...e2, contents: te(e2.contents) } : e2;
}
function sr(e2) {
  let t2 = /* @__PURE__ */ Object.create(null), u = /* @__PURE__ */ new Set();
  return r(te(e2));
  function r(n, a, s) {
    if (typeof n == "string") return JSON.stringify(n);
    if (Array.isArray(n)) {
      let i2 = n.map(r).filter(Boolean);
      return i2.length === 1 ? i2[0] : `[${i2.join(", ")}]`;
    }
    if (n.type === _) {
      let i2 = s?.[a + 1]?.type === T$1;
      return n.literal ? i2 ? "literalline" : "literallineWithoutBreakParent" : n.hard ? i2 ? "hardline" : "hardlineWithoutBreakParent" : n.soft ? "softline" : "line";
    }
    if (n.type === T$1) return s?.[a - 1]?.type === _ && s[a - 1].hard ? void 0 : "breakParent";
    if (n.type === v) return "trim";
    if (n.type === I) return "indent(" + r(n.contents) + ")";
    if (n.type === k) return n.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + r(n.contents) + ")" : n.n < 0 ? "dedent(" + r(n.contents) + ")" : n.n.type === "root" ? "markAsRoot(" + r(n.contents) + ")" : "align(" + JSON.stringify(n.n) + ", " + r(n.contents) + ")";
    if (n.type === B) return "ifBreak(" + r(n.breakContents) + (n.flatContents ? ", " + r(n.flatContents) : "") + (n.groupId ? (n.flatContents ? "" : ', ""') + `, { groupId: ${o(n.groupId)} }` : "") + ")";
    if (n.type === R) {
      let i2 = [];
      n.negate && i2.push("negate: true"), n.groupId && i2.push(`groupId: ${o(n.groupId)}`);
      let D = i2.length > 0 ? `, { ${i2.join(", ")} }` : "";
      return `indentIfBreak(${r(n.contents)}${D})`;
    }
    if (n.type === x) {
      let i2 = [];
      n.break && n.break !== "propagated" && i2.push("shouldBreak: true"), n.id && i2.push(`id: ${o(n.id)}`);
      let D = i2.length > 0 ? `, { ${i2.join(", ")} }` : "";
      return n.expandedStates ? `conditionalGroup([${n.expandedStates.map((f2) => r(f2)).join(",")}]${D})` : `group(${r(n.contents)}${D})`;
    }
    if (n.type === w) return `fill([${n.parts.map((i2) => r(i2)).join(", ")}])`;
    if (n.type === L) return "lineSuffix(" + r(n.contents) + ")";
    if (n.type === M) return "lineSuffixBoundary";
    if (n.type === O) return `label(${JSON.stringify(n.label)}, ${r(n.contents)})`;
    if (n.type === U) return "cursor";
    throw new Error("Unknown doc type " + n.type);
  }
  function o(n) {
    if (typeof n != "symbol") return JSON.stringify(String(n));
    if (n in t2) return t2[n];
    let a = n.description || "symbol";
    for (let s = 0; ; s++) {
      let i2 = a + (s > 0 ? ` #${s}` : "");
      if (!u.has(i2)) return u.add(i2), t2[n] = `Symbol.for(${JSON.stringify(i2)})`;
    }
  }
}
var Dr = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED8\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])))?))?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE8A\uDE8E-\uDEC2\uDEC6\uDEC8\uDECD-\uDEDC\uDEDF-\uDEEA\uDEEF]|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
function zt(e2) {
  return e2 === 12288 || e2 >= 65281 && e2 <= 65376 || e2 >= 65504 && e2 <= 65510;
}
function Jt(e2) {
  return e2 >= 4352 && e2 <= 4447 || e2 === 8986 || e2 === 8987 || e2 === 9001 || e2 === 9002 || e2 >= 9193 && e2 <= 9196 || e2 === 9200 || e2 === 9203 || e2 === 9725 || e2 === 9726 || e2 === 9748 || e2 === 9749 || e2 >= 9776 && e2 <= 9783 || e2 >= 9800 && e2 <= 9811 || e2 === 9855 || e2 >= 9866 && e2 <= 9871 || e2 === 9875 || e2 === 9889 || e2 === 9898 || e2 === 9899 || e2 === 9917 || e2 === 9918 || e2 === 9924 || e2 === 9925 || e2 === 9934 || e2 === 9940 || e2 === 9962 || e2 === 9970 || e2 === 9971 || e2 === 9973 || e2 === 9978 || e2 === 9981 || e2 === 9989 || e2 === 9994 || e2 === 9995 || e2 === 10024 || e2 === 10060 || e2 === 10062 || e2 >= 10067 && e2 <= 10069 || e2 === 10071 || e2 >= 10133 && e2 <= 10135 || e2 === 10160 || e2 === 10175 || e2 === 11035 || e2 === 11036 || e2 === 11088 || e2 === 11093 || e2 >= 11904 && e2 <= 11929 || e2 >= 11931 && e2 <= 12019 || e2 >= 12032 && e2 <= 12245 || e2 >= 12272 && e2 <= 12287 || e2 >= 12289 && e2 <= 12350 || e2 >= 12353 && e2 <= 12438 || e2 >= 12441 && e2 <= 12543 || e2 >= 12549 && e2 <= 12591 || e2 >= 12593 && e2 <= 12686 || e2 >= 12688 && e2 <= 12773 || e2 >= 12783 && e2 <= 12830 || e2 >= 12832 && e2 <= 12871 || e2 >= 12880 && e2 <= 42124 || e2 >= 42128 && e2 <= 42182 || e2 >= 43360 && e2 <= 43388 || e2 >= 44032 && e2 <= 55203 || e2 >= 63744 && e2 <= 64255 || e2 >= 65040 && e2 <= 65049 || e2 >= 65072 && e2 <= 65106 || e2 >= 65108 && e2 <= 65126 || e2 >= 65128 && e2 <= 65131 || e2 >= 94176 && e2 <= 94180 || e2 >= 94192 && e2 <= 94198 || e2 >= 94208 && e2 <= 101589 || e2 >= 101631 && e2 <= 101662 || e2 >= 101760 && e2 <= 101874 || e2 >= 110576 && e2 <= 110579 || e2 >= 110581 && e2 <= 110587 || e2 === 110589 || e2 === 110590 || e2 >= 110592 && e2 <= 110882 || e2 === 110898 || e2 >= 110928 && e2 <= 110930 || e2 === 110933 || e2 >= 110948 && e2 <= 110951 || e2 >= 110960 && e2 <= 111355 || e2 >= 119552 && e2 <= 119638 || e2 >= 119648 && e2 <= 119670 || e2 === 126980 || e2 === 127183 || e2 === 127374 || e2 >= 127377 && e2 <= 127386 || e2 >= 127488 && e2 <= 127490 || e2 >= 127504 && e2 <= 127547 || e2 >= 127552 && e2 <= 127560 || e2 === 127568 || e2 === 127569 || e2 >= 127584 && e2 <= 127589 || e2 >= 127744 && e2 <= 127776 || e2 >= 127789 && e2 <= 127797 || e2 >= 127799 && e2 <= 127868 || e2 >= 127870 && e2 <= 127891 || e2 >= 127904 && e2 <= 127946 || e2 >= 127951 && e2 <= 127955 || e2 >= 127968 && e2 <= 127984 || e2 === 127988 || e2 >= 127992 && e2 <= 128062 || e2 === 128064 || e2 >= 128066 && e2 <= 128252 || e2 >= 128255 && e2 <= 128317 || e2 >= 128331 && e2 <= 128334 || e2 >= 128336 && e2 <= 128359 || e2 === 128378 || e2 === 128405 || e2 === 128406 || e2 === 128420 || e2 >= 128507 && e2 <= 128591 || e2 >= 128640 && e2 <= 128709 || e2 === 128716 || e2 >= 128720 && e2 <= 128722 || e2 >= 128725 && e2 <= 128728 || e2 >= 128732 && e2 <= 128735 || e2 === 128747 || e2 === 128748 || e2 >= 128756 && e2 <= 128764 || e2 >= 128992 && e2 <= 129003 || e2 === 129008 || e2 >= 129292 && e2 <= 129338 || e2 >= 129340 && e2 <= 129349 || e2 >= 129351 && e2 <= 129535 || e2 >= 129648 && e2 <= 129660 || e2 >= 129664 && e2 <= 129674 || e2 >= 129678 && e2 <= 129734 || e2 === 129736 || e2 >= 129741 && e2 <= 129756 || e2 >= 129759 && e2 <= 129770 || e2 >= 129775 && e2 <= 129784 || e2 >= 131072 && e2 <= 196605 || e2 >= 196608 && e2 <= 262141;
}
var cr = "©®‼⁉™ℹ↔↕↖↗↘↙↩↪⌨⏏⏱⏲⏸⏹⏺▪▫▶◀◻◼☀☁☂☃☄☎☑☘☝☠☢☣☦☪☮☯☸☹☺♀♂♟♠♣♥♦♨♻♾⚒⚔⚕⚖⚗⚙⚛⚜⚠⚧⚰⚱⛈⛏⛑⛓⛩⛱⛷⛸⛹✂✈✉✌✍✏✒✔✖✝✡✳✴❄❇❣❤➡⤴⤵⬅⬆⬇";
var To = /[^\x20-\x7F]/u, No = new Set(cr);
function So(e2) {
  if (!e2) return 0;
  if (!To.test(e2)) return e2.length;
  e2 = e2.replace(Dr(), (u) => No.has(u) ? " " : "  ");
  let t2 = 0;
  for (let u of e2) {
    let r = u.codePointAt(0);
    r <= 31 || r >= 127 && r <= 159 || r >= 768 && r <= 879 || r >= 65024 && r <= 65039 || (t2 += zt(r) || Jt(r) ? 2 : 1);
  }
  return t2;
}
var Re = So;
var wo = { type: 0 }, Oo = { type: 1 }, Ht = { value: "", length: 0, queue: [], get root() {
  return Ht;
} };
function fr(e2, t2, u) {
  let r = t2.type === 1 ? e2.queue.slice(0, -1) : [...e2.queue, t2], o = "", n = 0, a = 0, s = 0;
  for (let p of r) switch (p.type) {
    case 0:
      f2(), u.useTabs ? i2(1) : D(u.tabWidth);
      break;
    case 3: {
      let { string: F } = p;
      f2(), o += F, n += F.length;
      break;
    }
    case 2: {
      let { width: F } = p;
      a += 1, s += F;
      break;
    }
    default:
      throw new Error(`Unexpected indent comment '${p.type}'.`);
  }
  return d(), { ...e2, value: o, length: n, queue: r };
  function i2(p) {
    o += "	".repeat(p), n += u.tabWidth * p;
  }
  function D(p) {
    o += " ".repeat(p), n += p;
  }
  function f2() {
    u.useTabs ? l() : d();
  }
  function l() {
    a > 0 && i2(a), c2();
  }
  function d() {
    s > 0 && D(s), c2();
  }
  function c2() {
    a = 0, s = 0;
  }
}
function lr(e2, t2, u) {
  if (!t2) return e2;
  if (t2.type === "root") return { ...e2, root: e2 };
  if (t2 === Number.NEGATIVE_INFINITY) return e2.root;
  let r;
  return typeof t2 == "number" ? t2 < 0 ? r = Oo : r = { type: 2, width: t2 } : r = { type: 3, string: t2 }, fr(e2, r, u);
}
function dr(e2, t2) {
  return fr(e2, wo, t2);
}
function Po(e2) {
  let t2 = 0;
  for (let u = e2.length - 1; u >= 0; u--) {
    let r = e2[u];
    if (r === " " || r === "	") t2++;
    else break;
  }
  return t2;
}
function Xt(e2) {
  let t2 = Po(e2);
  return { text: t2 === 0 ? e2 : e2.slice(0, e2.length - t2), count: t2 };
}
var W = Symbol("MODE_BREAK"), q = Symbol("MODE_FLAT"), qt = Symbol("DOC_FILL_PRINTED_LENGTH");
function rt(e2, t2, u, r, o, n) {
  if (u === Number.POSITIVE_INFINITY) return true;
  let a = t2.length, s = false, i2 = [e2], D = "";
  for (; u >= 0; ) {
    if (i2.length === 0) {
      if (a === 0) return true;
      i2.push(t2[--a]);
      continue;
    }
    let { mode: f2, doc: l } = i2.pop(), d = H(l);
    switch (d) {
      case G:
        l && (s && (D += " ", u -= 1, s = false), D += l, u -= Re(l));
        break;
      case j:
      case w: {
        let c2 = d === j ? l : l.parts, p = l[qt] ?? 0;
        for (let F = c2.length - 1; F >= p; F--) i2.push({ mode: f2, doc: c2[F] });
        break;
      }
      case I:
      case k:
      case R:
      case O:
        i2.push({ mode: f2, doc: l.contents });
        break;
      case v: {
        let { text: c2, count: p } = Xt(D);
        D = c2, u += p;
        break;
      }
      case x: {
        if (n && l.break) return false;
        let c2 = l.break ? W : f2, p = l.expandedStates && c2 === W ? b(0, l.expandedStates, -1) : l.contents;
        i2.push({ mode: c2, doc: p });
        break;
      }
      case B: {
        let p = (l.groupId ? o[l.groupId] || q : f2) === W ? l.breakContents : l.flatContents;
        p && i2.push({ mode: f2, doc: p });
        break;
      }
      case _:
        if (f2 === W || l.hard) return true;
        l.soft || (s = true);
        break;
      case L:
        r = true;
        break;
      case M:
        if (r) return false;
        break;
    }
  }
  return false;
}
function Ce(e2, t2) {
  let u = /* @__PURE__ */ Object.create(null), r = t2.printWidth, o = Se(t2.endOfLine), n = 0, a = [{ indent: Ht, mode: W, doc: e2 }], s = "", i2 = false, D = [], f2 = [], l = [], d = [], c2 = 0;
  for (Gu(e2); a.length > 0; ) {
    let { indent: m, mode: h, doc: E } = a.pop();
    switch (H(E)) {
      case G: {
        let g = o !== `
` ? oe(0, E, `
`, o) : E;
        g && (s += g, a.length > 0 && (n += Re(g)));
        break;
      }
      case j:
        for (let g = E.length - 1; g >= 0; g--) a.push({ indent: m, mode: h, doc: E[g] });
        break;
      case U:
        if (f2.length >= 2) throw new Error("There are too many 'cursor' in doc.");
        f2.push(c2 + s.length);
        break;
      case I:
        a.push({ indent: dr(m, t2), mode: h, doc: E.contents });
        break;
      case k:
        a.push({ indent: lr(m, E.n, t2), mode: h, doc: E.contents });
        break;
      case v:
        y();
        break;
      case x:
        switch (h) {
          case q:
            if (!i2) {
              a.push({ indent: m, mode: E.break ? W : q, doc: E.contents });
              break;
            }
          case W: {
            i2 = false;
            let g = { indent: m, mode: q, doc: E.contents }, A2 = r - n, J = D.length > 0;
            if (!E.break && rt(g, a, A2, J, u)) a.push(g);
            else if (E.expandedStates) {
              let Q2 = b(0, E.expandedStates, -1);
              if (E.break) {
                a.push({ indent: m, mode: W, doc: Q2 });
                break;
              } else for (let re2 = 1; re2 < E.expandedStates.length + 1; re2++) if (re2 >= E.expandedStates.length) {
                a.push({ indent: m, mode: W, doc: Q2 });
                break;
              } else {
                let Te = E.expandedStates[re2], ne = { indent: m, mode: q, doc: Te };
                if (rt(ne, a, A2, J, u)) {
                  a.push(ne);
                  break;
                }
              }
            } else a.push({ indent: m, mode: W, doc: E.contents });
            break;
          }
        }
        E.id && (u[E.id] = b(0, a, -1).mode);
        break;
      case w: {
        let g = r - n, A2 = E[qt] ?? 0, { parts: J } = E, Q2 = J.length - A2;
        if (Q2 === 0) break;
        let re2 = J[A2 + 0], Te = J[A2 + 1], ne = { indent: m, mode: q, doc: re2 }, vt = { indent: m, mode: W, doc: re2 }, Rt = rt(ne, [], g, D.length > 0, u, true);
        if (Q2 === 1) {
          Rt ? a.push(ne) : a.push(vt);
          break;
        }
        let Iu = { indent: m, mode: q, doc: Te }, Lt = { indent: m, mode: W, doc: Te };
        if (Q2 === 2) {
          Rt ? a.push(Iu, ne) : a.push(Lt, vt);
          break;
        }
        let Xn = J[A2 + 2], qn = { indent: m, mode: h, doc: { ...E, [qt]: A2 + 2 } }, Qn = rt({ indent: m, mode: q, doc: [re2, Te, Xn] }, [], g, D.length > 0, u, true);
        a.push(qn), Qn ? a.push(Iu, ne) : Rt ? a.push(Lt, ne) : a.push(Lt, vt);
        break;
      }
      case B:
      case R: {
        let g = E.groupId ? u[E.groupId] : h;
        if (g === W) {
          let A2 = E.type === B ? E.breakContents : E.negate ? E.contents : ae(E.contents);
          A2 && a.push({ indent: m, mode: h, doc: A2 });
        }
        if (g === q) {
          let A2 = E.type === B ? E.flatContents : E.negate ? ae(E.contents) : E.contents;
          A2 && a.push({ indent: m, mode: h, doc: A2 });
        }
        break;
      }
      case L:
        D.push({ indent: m, mode: h, doc: E.contents });
        break;
      case M:
        D.length > 0 && a.push({ indent: m, mode: h, doc: ke });
        break;
      case _:
        switch (h) {
          case q:
            if (E.hard) i2 = true;
            else {
              E.soft || (s += " ", n += 1);
              break;
            }
          case W:
            if (D.length > 0) {
              a.push({ indent: m, mode: h, doc: E }, ...D.reverse()), D.length = 0;
              break;
            }
            E.literal ? (s += o, n = 0, m.root && (m.root.value && (s += m.root.value), n = m.root.length)) : (y(), s += o + m.value, n = m.length);
            break;
        }
        break;
      case O:
        a.push({ indent: m, mode: h, doc: E.contents });
        break;
      case T$1:
        break;
      default:
        throw new Z(E);
    }
    a.length === 0 && D.length > 0 && (a.push(...D.reverse()), D.length = 0);
  }
  let p = l.join("") + s, F = [...d, ...f2];
  if (F.length !== 2) return { formatted: p };
  let C2 = F[0];
  return { formatted: p, cursorNodeStart: C2, cursorNodeText: p.slice(C2, b(0, F, -1)) };
  function y() {
    let { text: m, count: h } = Xt(s);
    m && (l.push(m), c2 += m.length), s = "", n -= h, f2.length > 0 && (d.push(...f2.map((E) => Math.min(E, c2))), f2.length = 0);
  }
}
function Io(e2, t2, u = 0) {
  let r = 0;
  for (let o = u; o < e2.length; ++o) e2[o] === "	" ? r = r + t2 - r % t2 : r++;
  return r;
}
var he = Io;
var Qt = class {
  constructor(t2) {
    this.stack = [t2];
  }
  get key() {
    let { stack: t2, siblings: u } = this;
    return b(0, t2, u === null ? -2 : -4) ?? null;
  }
  get index() {
    return this.siblings === null ? null : b(0, this.stack, -2);
  }
  get node() {
    return b(0, this.stack, -1);
  }
  get parent() {
    return this.getNode(1);
  }
  get grandparent() {
    return this.getNode(2);
  }
  get isInArray() {
    return this.siblings !== null;
  }
  get siblings() {
    let { stack: t2 } = this, u = b(0, t2, -3);
    return Array.isArray(u) ? u : null;
  }
  get next() {
    let { siblings: t2 } = this;
    return t2 === null ? null : t2[this.index + 1];
  }
  get previous() {
    let { siblings: t2 } = this;
    return t2 === null ? null : t2[this.index - 1];
  }
  get isFirst() {
    return this.index === 0;
  }
  get isLast() {
    let { siblings: t2, index: u } = this;
    return t2 !== null && u === t2.length - 1;
  }
  get isRoot() {
    return this.stack.length === 1;
  }
  get root() {
    return this.stack[0];
  }
  get ancestors() {
    return [...this.#e()];
  }
  getName() {
    let { stack: t2 } = this, { length: u } = t2;
    return u > 1 ? b(0, t2, -2) : null;
  }
  getValue() {
    return b(0, this.stack, -1);
  }
  getNode(t2 = 0) {
    let u = this.#t(t2);
    return u === -1 ? null : this.stack[u];
  }
  getParentNode(t2 = 0) {
    return this.getNode(t2 + 1);
  }
  #t(t2) {
    let { stack: u } = this;
    for (let r = u.length - 1; r >= 0; r -= 2) if (!Array.isArray(u[r]) && --t2 < 0) return r;
    return -1;
  }
  call(t2, ...u) {
    let { stack: r } = this, { length: o } = r, n = b(0, r, -1);
    for (let a of u) n = n?.[a], r.push(a, n);
    try {
      return t2(this);
    } finally {
      r.length = o;
    }
  }
  callParent(t2, u = 0) {
    let r = this.#t(u + 1), o = this.stack.splice(r + 1);
    try {
      return t2(this);
    } finally {
      this.stack.push(...o);
    }
  }
  each(t2, ...u) {
    let { stack: r } = this, { length: o } = r, n = b(0, r, -1);
    for (let a of u) n = n[a], r.push(a, n);
    try {
      for (let a = 0; a < n.length; ++a) r.push(a, n[a]), t2(this, a, n), r.length -= 2;
    } finally {
      r.length = o;
    }
  }
  map(t2, ...u) {
    let r = [];
    return this.each((o, n, a) => {
      r[n] = t2(o, n, a);
    }, ...u), r;
  }
  match(...t2) {
    let u = this.stack.length - 1, r = null, o = this.stack[u--];
    for (let n of t2) {
      if (o === void 0) return false;
      let a = null;
      if (typeof r == "number" && (a = r, r = this.stack[u--], o = this.stack[u--]), n && !n(o, r, a)) return false;
      r = this.stack[u--], o = this.stack[u--];
    }
    return true;
  }
  findAncestor(t2) {
    for (let u of this.#e()) if (t2(u)) return u;
  }
  hasAncestor(t2) {
    for (let u of this.#e()) if (t2(u)) return true;
    return false;
  }
  *#e() {
    let { stack: t2 } = this;
    for (let u = t2.length - 3; u >= 0; u -= 2) {
      let r = t2[u];
      Array.isArray(r) || (yield r);
    }
  }
}, pr = Qt;
function ko(e2) {
  return e2 !== null && typeof e2 == "object";
}
var ge = ko;
function ye(e2) {
  return (t2, u, r) => {
    let o = !!r?.backwards;
    if (u === false) return false;
    let { length: n } = t2, a = u;
    for (; a >= 0 && a < n; ) {
      let s = t2.charAt(a);
      if (e2 instanceof RegExp) {
        if (!e2.test(s)) return a;
      } else if (!e2.includes(s)) return a;
      o ? a-- : a++;
    }
    return a === -1 || a === n ? a : false;
  };
}
var Fr = ye(/\s/u), Y = ye(" 	"), nt = ye(",; 	"), ot = ye(/[^\n\r]/u);
var mr = (e2) => e2 === `
` || e2 === "\r" || e2 === "\u2028" || e2 === "\u2029";
function vo(e2, t2, u) {
  let r = !!u?.backwards;
  if (t2 === false) return false;
  let o = e2.charAt(t2);
  if (r) {
    if (e2.charAt(t2 - 1) === "\r" && o === `
`) return t2 - 2;
    if (mr(o)) return t2 - 1;
  } else {
    if (o === "\r" && e2.charAt(t2 + 1) === `
`) return t2 + 2;
    if (mr(o)) return t2 + 1;
  }
  return t2;
}
var K = vo;
function Ro(e2, t2, u = {}) {
  let r = Y(e2, u.backwards ? t2 - 1 : t2, u), o = K(e2, r, u);
  return r !== o;
}
var z = Ro;
function Lo(e2) {
  return Array.isArray(e2) && e2.length > 0;
}
var Er = Lo;
function* be(e2, t2) {
  let { getVisitorKeys: u, filter: r = () => true } = t2, o = (n) => ge(n) && r(n);
  for (let n of u(e2)) {
    let a = e2[n];
    if (Array.isArray(a)) for (let s of a) o(s) && (yield s);
    else o(a) && (yield a);
  }
}
function* Cr(e2, t2) {
  let u = [e2];
  for (let r = 0; r < u.length; r++) {
    let o = u[r];
    for (let n of be(o, t2)) yield n, u.push(n);
  }
}
function hr(e2, t2) {
  return be(e2, t2).next().done;
}
function gr(e2, t2, u) {
  let { cache: r } = u;
  if (r.has(e2)) return r.get(e2);
  let { filter: o } = u;
  if (!o) return [];
  let n, a = (u.getChildren?.(e2, u) ?? [...be(e2, { getVisitorKeys: u.getVisitorKeys })]).flatMap((D) => (n ?? (n = [e2, ...t2]), o(D, n) ? [D] : gr(D, n, u))), { locStart: s, locEnd: i2 } = u;
  return a.sort((D, f2) => s(D) - s(f2) || i2(D) - i2(f2)), r.set(e2, a), a;
}
var at$1 = gr;
function Mo(e2) {
  let t2 = e2.type || e2.kind || "(unknown type)", u = String(e2.name || e2.id && (typeof e2.id == "object" ? e2.id.name : e2.id) || e2.key && (typeof e2.key == "object" ? e2.key.name : e2.key) || e2.value && (typeof e2.value == "object" ? "" : String(e2.value)) || e2.operator || "");
  return u.length > 20 && (u = u.slice(0, 19) + "…"), t2 + (u ? " " + u : "");
}
function Zt(e2, t2) {
  (e2.comments ?? (e2.comments = [])).push(t2), t2.printed = false, t2.nodeDescription = Mo(e2);
}
function fe(e2, t2) {
  t2.leading = true, t2.trailing = false, Zt(e2, t2);
}
function ue(e2, t2, u) {
  t2.leading = false, t2.trailing = false, u && (t2.marker = u), Zt(e2, t2);
}
function le(e2, t2) {
  t2.leading = false, t2.trailing = true, Zt(e2, t2);
}
var uu = /* @__PURE__ */ new WeakMap();
function br(e2, t2, u, r, o = []) {
  let { locStart: n, locEnd: a } = u, s = n(t2), i2 = a(t2), D = at$1(e2, o, { cache: uu, locStart: n, locEnd: a, getVisitorKeys: u.getVisitorKeys, filter: u.printer.canAttachComment, getChildren: u.printer.getCommentChildNodes }), f2, l, d = 0, c2 = D.length;
  for (; d < c2; ) {
    let p = d + c2 >> 1, F = D[p], C2 = n(F), y = a(F);
    if (C2 <= s && i2 <= y) return br(F, t2, u, F, [F, ...o]);
    if (y <= s) {
      f2 = F, d = p + 1;
      continue;
    }
    if (i2 <= C2) {
      l = F, c2 = p;
      continue;
    }
    throw new Error("Comment location overlaps with node location");
  }
  if (r?.type === "TemplateLiteral") {
    let { quasis: p } = r, F = tu(p, t2, u);
    f2 && tu(p, f2, u) !== F && (f2 = null), l && tu(p, l, u) !== F && (l = null);
  }
  return { enclosingNode: r, precedingNode: f2, followingNode: l };
}
var eu = () => false;
function Ar(e2, t2) {
  let { comments: u } = e2;
  if (delete e2.comments, !Er(u) || !t2.printer.canAttachComment) return;
  let r = [], { printer: { features: { experimental_avoidAstMutation: o }, handleComments: n = {} }, originalText: a } = t2, { ownLine: s = eu, endOfLine: i2 = eu, remaining: D = eu } = n, f2 = u.map((l, d) => ({ ...br(e2, l, t2), comment: l, text: a, options: t2, ast: e2, isLastComment: u.length - 1 === d }));
  for (let [l, d] of f2.entries()) {
    let { comment: c2, precedingNode: p, enclosingNode: F, followingNode: C2, text: y, options: m, ast: h, isLastComment: E } = d, g;
    if (o ? g = [d] : (c2.enclosingNode = F, c2.precedingNode = p, c2.followingNode = C2, g = [c2, y, m, h, E]), Yo(y, m, f2, l)) c2.placement = "ownLine", s(...g) || (C2 ? fe(C2, c2) : p ? le(p, c2) : F ? ue(F, c2) : ue(h, c2));
    else if (jo(y, m, f2, l)) c2.placement = "endOfLine", i2(...g) || (p ? le(p, c2) : C2 ? fe(C2, c2) : F ? ue(F, c2) : ue(h, c2));
    else if (c2.placement = "remaining", !D(...g)) if (p && C2) {
      let A2 = r.length;
      A2 > 0 && r[A2 - 1].followingNode !== C2 && yr(r, m), r.push(d);
    } else p ? le(p, c2) : C2 ? fe(C2, c2) : F ? ue(F, c2) : ue(h, c2);
  }
  if (yr(r, t2), !o) for (let l of u) delete l.precedingNode, delete l.enclosingNode, delete l.followingNode;
}
var _r = (e2) => !/[\S\n\u2028\u2029]/u.test(e2);
function Yo(e2, t2, u, r) {
  let { comment: o, precedingNode: n } = u[r], { locStart: a, locEnd: s } = t2, i2 = a(o);
  if (n) for (let D = r - 1; D >= 0; D--) {
    let { comment: f2, precedingNode: l } = u[D];
    if (l !== n || !_r(e2.slice(s(f2), i2))) break;
    i2 = a(f2);
  }
  return z(e2, i2, { backwards: true });
}
function jo(e2, t2, u, r) {
  let { comment: o, followingNode: n } = u[r], { locStart: a, locEnd: s } = t2, i2 = s(o);
  if (n) for (let D = r + 1; D < u.length; D++) {
    let { comment: f2, followingNode: l } = u[D];
    if (l !== n || !_r(e2.slice(i2, a(f2)))) break;
    i2 = s(f2);
  }
  return z(e2, i2);
}
function yr(e2, t2) {
  let u = e2.length;
  if (u === 0) return;
  let { precedingNode: r, followingNode: o } = e2[0], n = t2.locStart(o), a;
  for (a = u; a > 0; --a) {
    let { comment: s, precedingNode: i2, followingNode: D } = e2[a - 1];
    let f2 = t2.originalText.slice(t2.locEnd(s), n);
    if (t2.printer.isGap?.(f2, t2) ?? /^[\s(]*$/u.test(f2)) n = t2.locStart(s);
    else break;
  }
  for (let [s, { comment: i2 }] of e2.entries()) s < a ? le(r, i2) : fe(o, i2);
  for (let s of [r, o]) s.comments && s.comments.length > 1 && s.comments.sort((i2, D) => t2.locStart(i2) - t2.locStart(D));
  e2.length = 0;
}
function tu(e2, t2, u) {
  let r = u.locStart(t2) - 1;
  for (let o = 1; o < e2.length; ++o) if (r < u.locStart(e2[o])) return o - 1;
  return 0;
}
function Uo(e2, t2) {
  let u = t2 - 1;
  u = Y(e2, u, { backwards: true }), u = K(e2, u, { backwards: true }), u = Y(e2, u, { backwards: true });
  let r = K(e2, u, { backwards: true });
  return u !== r;
}
var Le = Uo;
function xr(e2, t2) {
  let u = e2.node;
  return u.printed = true, t2.printer.printComment(e2, t2);
}
function Wo(e2, t2) {
  let u = e2.node, r = [xr(e2, t2)], { printer: o, originalText: n, locStart: a, locEnd: s } = t2;
  if (o.isBlockComment?.(u)) {
    let f2 = z(n, s(u)) ? z(n, a(u), { backwards: true }) ? V : ut : " ";
    r.push(f2);
  } else r.push(V);
  let D = K(n, Y(n, s(u)));
  return D !== false && z(n, D) && r.push(V), r;
}
function $o(e2, t2, u) {
  let r = e2.node, o = xr(e2, t2), { printer: n, originalText: a, locStart: s } = t2, i2 = n.isBlockComment?.(r);
  if (u?.hasLineSuffix && !u?.isBlock || z(a, s(r), { backwards: true })) {
    let D = Le(a, s(r));
    return { doc: ve([V, D ? V : "", o]), isBlock: i2, hasLineSuffix: true };
  }
  return !i2 || u?.hasLineSuffix ? { doc: [ve([" ", o]), ce], isBlock: i2, hasLineSuffix: true } : { doc: [" ", o], isBlock: i2, hasLineSuffix: false };
}
function Vo(e2, t2) {
  let u = e2.node;
  if (!u) return {};
  let r = t2[Symbol.for("printedComments")];
  if ((u.comments || []).filter((i2) => !r.has(i2)).length === 0) return { leading: "", trailing: "" };
  let n = [], a = [], s;
  return e2.each(() => {
    let i2 = e2.node;
    if (r?.has(i2)) return;
    let { leading: D, trailing: f2 } = i2;
    D ? n.push(Wo(e2, t2)) : f2 && (s = $o(e2, t2, s), a.push(s.doc));
  }, "comments"), { leading: n, trailing: a };
}
function Br(e2, t2, u) {
  let { leading: r, trailing: o } = Vo(e2, u);
  return !r && !o ? t2 : Ee(t2, (n) => [r, n, o]);
}
function Tr(e2) {
  let { [Symbol.for("comments")]: t2, [Symbol.for("printedComments")]: u } = e2;
  for (let r of t2) {
    if (!r.printed && !u.has(r)) throw new Error('Comment "' + r.value.trim() + '" was not printed. Please report this error!');
    delete r.printed;
  }
}
var Me = class extends Error {
  name = "ConfigError";
}, Ye = class extends Error {
  name = "UndefinedParserError";
};
var Sr = { checkIgnorePragma: { category: "Special", type: "boolean", default: false, description: "Check whether the file's first docblock comment contains '@noprettier' or '@noformat' to determine if it should be formatted.", cliCategory: "Other" }, cursorOffset: { category: "Special", type: "int", default: -1, range: { start: -1, end: 1 / 0, step: 1 }, description: "Print (to stderr) where a cursor at the given position would move to after formatting.", cliCategory: "Editor" }, endOfLine: { category: "Global", type: "choice", default: "lf", description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: `Maintain existing
(mixed values within one file are normalised by looking at what's used after the first line)` }] }, filepath: { category: "Special", type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: "Other", cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { category: "Special", type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: "Other" }, parser: { category: "Global", type: "choice", default: void 0, description: "Which parser to use.", exception: (e2) => typeof e2 == "string" || typeof e2 == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", description: "JavaScript" }, { value: "babel-flow", description: "Flow" }, { value: "babel-ts", description: "TypeScript" }, { value: "typescript", description: "TypeScript" }, { value: "acorn", description: "JavaScript" }, { value: "espree", description: "JavaScript" }, { value: "meriyah", description: "JavaScript" }, { value: "css", description: "CSS" }, { value: "less", description: "Less" }, { value: "scss", description: "SCSS" }, { value: "json", description: "JSON" }, { value: "json5", description: "JSON5" }, { value: "jsonc", description: "JSON with Comments" }, { value: "json-stringify", description: "JSON.stringify" }, { value: "graphql", description: "GraphQL" }, { value: "markdown", description: "Markdown" }, { value: "mdx", description: "MDX" }, { value: "vue", description: "Vue" }, { value: "yaml", description: "YAML" }, { value: "glimmer", description: "Ember / Handlebars" }, { value: "html", description: "HTML" }, { value: "angular", description: "Angular" }, { value: "lwc", description: "Lightning Web Components" }, { value: "mjml", description: "MJML" }] }, plugins: { type: "path", array: true, default: [{ value: [] }], category: "Global", description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (e2) => typeof e2 == "string" || typeof e2 == "object", cliName: "plugin", cliCategory: "Config" }, printWidth: { category: "Global", type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: 1 / 0, step: 1 } }, rangeEnd: { category: "Special", type: "int", default: 1 / 0, range: { start: 0, end: 1 / 0, step: 1 }, description: `Format code ending at a given character offset (exclusive).
The range will extend forwards to the end of the selected statement.`, cliCategory: "Editor" }, rangeStart: { category: "Special", type: "int", default: 0, range: { start: 0, end: 1 / 0, step: 1 }, description: `Format code starting at a given character offset.
The range will extend backwards to the start of the first line containing the selected statement.`, cliCategory: "Editor" }, requirePragma: { category: "Special", type: "boolean", default: false, description: "Require either '@prettier' or '@format' to be present in the file's first docblock comment in order for it to be formatted.", cliCategory: "Other" }, tabWidth: { type: "int", category: "Global", default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: 1 / 0, step: 1 } }, useTabs: { category: "Global", type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { category: "Global", type: "choice", default: "auto", description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
function it({ plugins: e2 = [], showDeprecated: t2 = false } = {}) {
  let u = e2.flatMap((o) => o.languages ?? []), r = [];
  for (let o of Go(Object.assign({}, ...e2.map(({ options: n }) => n), Sr))) !t2 && o.deprecated || (Array.isArray(o.choices) && (t2 || (o.choices = o.choices.filter((n) => !n.deprecated)), o.name === "parser" && (o.choices = [...o.choices, ...Ko(o.choices, u, e2)])), o.pluginDefaults = Object.fromEntries(e2.filter((n) => n.defaultOptions?.[o.name] !== void 0).map((n) => [n.name, n.defaultOptions[o.name]])), r.push(o));
  return { languages: u, options: r };
}
function* Ko(e2, t2, u) {
  let r = new Set(e2.map((o) => o.value));
  for (let o of t2) if (o.parsers) {
    for (let n of o.parsers) if (!r.has(n)) {
      r.add(n);
      let a = u.find((i2) => i2.parsers && Object.prototype.hasOwnProperty.call(i2.parsers, n)), s = o.name;
      a?.name && (s += ` (plugin: ${a.name})`), yield { value: n, description: s };
    }
  }
}
function Go(e2) {
  let t2 = [];
  for (let [u, r] of Object.entries(e2)) {
    let o = { name: u, ...r };
    Array.isArray(o.default) && (o.default = b(0, o.default, -1).value), t2.push(o);
  }
  return t2;
}
var zo = Array.prototype.toReversed ?? function() {
  return [...this].reverse();
}, Jo = X("toReversed", function() {
  if (Array.isArray(this)) return zo;
}), wr = Jo;
function Ho() {
  let e2 = globalThis, t2 = e2.Deno?.build?.os;
  return typeof t2 == "string" ? t2 === "windows" : e2.navigator?.platform?.startsWith("Win") ?? e2.process?.platform?.startsWith("win") ?? false;
}
var Xo = Ho();
function Or(e2) {
  if (e2 = e2 instanceof URL ? e2 : new URL(e2), e2.protocol !== "file:") throw new TypeError(`URL must be a file URL: received "${e2.protocol}"`);
  return e2;
}
function qo(e2) {
  return e2 = Or(e2), decodeURIComponent(e2.pathname.replace(/%(?![0-9A-Fa-f]{2})/g, "%25"));
}
function Qo(e2) {
  e2 = Or(e2);
  let t2 = decodeURIComponent(e2.pathname.replace(/\//g, "\\").replace(/%(?![0-9A-Fa-f]{2})/g, "%25")).replace(/^\\*([A-Za-z]:)(\\|$)/, "$1\\");
  return e2.hostname !== "" && (t2 = `\\\\${e2.hostname}${t2}`), t2;
}
function ru(e2) {
  return Xo ? Qo(e2) : qo(e2);
}
var Pr = (e2) => String(e2).split(/[/\\]/u).pop(), Ir = (e2) => String(e2).startsWith("file:");
function kr(e2, t2) {
  if (!t2) return;
  let u = Pr(t2).toLowerCase();
  return e2.find(({ filenames: r }) => r?.some((o) => o.toLowerCase() === u)) ?? e2.find(({ extensions: r }) => r?.some((o) => u.endsWith(o)));
}
function Zo(e2, t2) {
  if (t2) return e2.find(({ name: u }) => u.toLowerCase() === t2) ?? e2.find(({ aliases: u }) => u?.includes(t2)) ?? e2.find(({ extensions: u }) => u?.includes(`.${t2}`));
}
var ea = void 0;
function vr(e2, t2) {
  if (t2) {
    if (Ir(t2)) try {
      t2 = ru(t2);
    } catch {
      return;
    }
    if (typeof t2 == "string") return e2.find(({ isSupported: u }) => u?.({ filepath: t2 }));
  }
}
function ta(e2, t2) {
  let u = wr(0, e2.plugins).flatMap((o) => o.languages ?? []);
  return (Zo(u, t2.language) ?? kr(u, t2.physicalFile) ?? kr(u, t2.file) ?? vr(u, t2.physicalFile) ?? vr(u, t2.file) ?? ea?.(u, t2.physicalFile))?.parsers[0];
}
var st = ta;
var ie = { key: (e2) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(e2) ? e2 : JSON.stringify(e2), value(e2) {
  if (e2 === null || typeof e2 != "object") return JSON.stringify(e2);
  if (Array.isArray(e2)) return `[${e2.map((u) => ie.value(u)).join(", ")}]`;
  let t2 = Object.keys(e2);
  return t2.length === 0 ? "{}" : `{ ${t2.map((u) => `${ie.key(u)}: ${ie.value(e2[u])}`).join(", ")} }`;
}, pair: ({ key: e2, value: t2 }) => ie.value({ [e2]: t2 }) };
var nu = new Proxy(String, { get: () => nu }), $ = nu, ou = () => nu;
var Rr = (e2, t2, { descriptor: u }) => {
  let r = [`${$.yellow(typeof e2 == "string" ? u.key(e2) : u.pair(e2))} is deprecated`];
  return t2 && r.push(`we now treat it as ${$.blue(typeof t2 == "string" ? u.key(t2) : u.pair(t2))}`), r.join("; ") + ".";
};
var Dt = Symbol.for("vnopts.VALUE_NOT_EXIST"), Ae = Symbol.for("vnopts.VALUE_UNCHANGED");
var Lr = " ".repeat(2), Yr = (e2, t2, u) => {
  let { text: r, list: o } = u.normalizeExpectedResult(u.schemas[e2].expected(u)), n = [];
  return r && n.push(Mr(e2, t2, r, u.descriptor)), o && n.push([Mr(e2, t2, o.title, u.descriptor)].concat(o.values.map((a) => jr(a, u.loggerPrintWidth))).join(`
`)), Ur(n, u.loggerPrintWidth);
};
function Mr(e2, t2, u, r) {
  return [`Invalid ${$.red(r.key(e2))} value.`, `Expected ${$.blue(u)},`, `but received ${t2 === Dt ? $.gray("nothing") : $.red(r.value(t2))}.`].join(" ");
}
function jr({ text: e2, list: t2 }, u) {
  let r = [];
  return e2 && r.push(`- ${$.blue(e2)}`), t2 && r.push([`- ${$.blue(t2.title)}:`].concat(t2.values.map((o) => jr(o, u - Lr.length).replace(/^|\n/g, `$&${Lr}`))).join(`
`)), Ur(r, u);
}
function Ur(e2, t2) {
  if (e2.length === 1) return e2[0];
  let [u, r] = e2, [o, n] = e2.map((a) => a.split(`
`, 1)[0].length);
  return o > t2 && o > n ? r : u;
}
var _e = [], au = [];
function ct(e2, t2, u) {
  if (e2 === t2) return 0;
  let r = u?.maxDistance, o = e2;
  e2.length > t2.length && (e2 = t2, t2 = o);
  let n = e2.length, a = t2.length;
  for (; n > 0 && e2.charCodeAt(~-n) === t2.charCodeAt(~-a); ) n--, a--;
  let s = 0;
  for (; s < n && e2.charCodeAt(s) === t2.charCodeAt(s); ) s++;
  if (n -= s, a -= s, r !== void 0 && a - n > r) return r;
  if (n === 0) return r !== void 0 && a > r ? r : a;
  let i2, D, f2, l, d = 0, c2 = 0;
  for (; d < n; ) au[d] = e2.charCodeAt(s + d), _e[d] = ++d;
  for (; c2 < a; ) {
    for (i2 = t2.charCodeAt(s + c2), f2 = c2++, D = c2, d = 0; d < n; d++) l = i2 === au[d] ? f2 : f2 + 1, f2 = _e[d], D = _e[d] = f2 > D ? l > D ? D + 1 : l : l > f2 ? f2 + 1 : l;
    if (r !== void 0) {
      let p = D;
      for (d = 0; d < n; d++) _e[d] < p && (p = _e[d]);
      if (p > r) return r;
    }
  }
  return _e.length = n, au.length = n, r !== void 0 && D > r ? r : D;
}
function Wr(e2, t2, u) {
  if (!Array.isArray(t2) || t2.length === 0) return;
  let r = u?.maxDistance, o = e2.length;
  for (let i2 of t2) if (i2 === e2) return i2;
  let n, a = Number.POSITIVE_INFINITY, s = /* @__PURE__ */ new Set();
  for (let i2 of t2) {
    if (s.has(i2)) continue;
    s.add(i2);
    let D = Math.abs(i2.length - o);
    if (D >= a || D > r) continue;
    let f2 = Number.isFinite(a) ? Math.min(a, r) : r, l = f2 === void 0 ? ct(e2, i2) : ct(e2, i2, { maxDistance: f2 });
    if (l > r) continue;
    let d = l;
    if (f2 !== void 0 && l === f2 && f2 === r && (d = ct(e2, i2)), d < a && (a = d, n = i2, a === 0)) break;
  }
  if (!(a > r)) return n;
}
var ft = (e2, t2, { descriptor: u, logger: r, schemas: o }) => {
  let n = [`Ignored unknown option ${$.yellow(u.pair({ key: e2, value: t2 }))}.`], a = Wr(e2, Object.keys(o), { maxDistance: 3 });
  a && n.push(`Did you mean ${$.blue(u.key(a))}?`), r.warn(n.join(" "));
};
var ua = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
function ra(e2, t2) {
  let u = new e2(t2), r = Object.create(u);
  for (let o of ua) o in t2 && (r[o] = na(t2[o], u, S.prototype[o].length));
  return r;
}
var S = class {
  static create(t2) {
    return ra(this, t2);
  }
  constructor(t2) {
    this.name = t2.name;
  }
  default(t2) {
  }
  expected(t2) {
    return "nothing";
  }
  validate(t2, u) {
    return false;
  }
  deprecated(t2, u) {
    return false;
  }
  forward(t2, u) {
  }
  redirect(t2, u) {
  }
  overlap(t2, u, r) {
    return t2;
  }
  preprocess(t2, u) {
    return t2;
  }
  postprocess(t2, u) {
    return Ae;
  }
};
function na(e2, t2, u) {
  return typeof e2 == "function" ? (...r) => e2(...r.slice(0, u - 1), t2, ...r.slice(u - 1)) : () => e2;
}
var lt = class extends S {
  constructor(t2) {
    super(t2), this._sourceName = t2.sourceName;
  }
  expected(t2) {
    return t2.schemas[this._sourceName].expected(t2);
  }
  validate(t2, u) {
    return u.schemas[this._sourceName].validate(t2, u);
  }
  redirect(t2, u) {
    return this._sourceName;
  }
};
var dt = class extends S {
  expected() {
    return "anything";
  }
  validate() {
    return true;
  }
};
var pt = class extends S {
  constructor({ valueSchema: t2, name: u = t2.name, ...r }) {
    super({ ...r, name: u }), this._valueSchema = t2;
  }
  expected(t2) {
    let { text: u, list: r } = t2.normalizeExpectedResult(this._valueSchema.expected(t2));
    return { text: u && `an array of ${u}`, list: r && { title: "an array of the following values", values: [{ list: r }] } };
  }
  validate(t2, u) {
    if (!Array.isArray(t2)) return false;
    let r = [];
    for (let o of t2) {
      let n = u.normalizeValidateResult(this._valueSchema.validate(o, u), o);
      n !== true && r.push(n.value);
    }
    return r.length === 0 ? true : { value: r };
  }
  deprecated(t2, u) {
    let r = [];
    for (let o of t2) {
      let n = u.normalizeDeprecatedResult(this._valueSchema.deprecated(o, u), o);
      n !== false && r.push(...n.map(({ value: a }) => ({ value: [a] })));
    }
    return r;
  }
  forward(t2, u) {
    let r = [];
    for (let o of t2) {
      let n = u.normalizeForwardResult(this._valueSchema.forward(o, u), o);
      r.push(...n.map($r));
    }
    return r;
  }
  redirect(t2, u) {
    let r = [], o = [];
    for (let n of t2) {
      let a = u.normalizeRedirectResult(this._valueSchema.redirect(n, u), n);
      "remain" in a && r.push(a.remain), o.push(...a.redirect.map($r));
    }
    return r.length === 0 ? { redirect: o } : { redirect: o, remain: r };
  }
  overlap(t2, u) {
    return t2.concat(u);
  }
};
function $r({ from: e2, to: t2 }) {
  return { from: [e2], to: t2 };
}
var Ft = class extends S {
  expected() {
    return "true or false";
  }
  validate(t2) {
    return typeof t2 == "boolean";
  }
};
function Kr(e2, t2) {
  let u = /* @__PURE__ */ Object.create(null);
  for (let r of e2) {
    let o = r[t2];
    if (u[o]) throw new Error(`Duplicate ${t2} ${JSON.stringify(o)}`);
    u[o] = r;
  }
  return u;
}
function Gr(e2, t2) {
  let u = /* @__PURE__ */ new Map();
  for (let r of e2) {
    let o = r[t2];
    if (u.has(o)) throw new Error(`Duplicate ${t2} ${JSON.stringify(o)}`);
    u.set(o, r);
  }
  return u;
}
function zr() {
  let e2 = /* @__PURE__ */ Object.create(null);
  return (t2) => {
    let u = JSON.stringify(t2);
    return e2[u] ? true : (e2[u] = true, false);
  };
}
function Jr(e2, t2) {
  let u = [], r = [];
  for (let o of e2) t2(o) ? u.push(o) : r.push(o);
  return [u, r];
}
function Hr(e2) {
  return e2 === Math.floor(e2);
}
function Xr(e2, t2) {
  if (e2 === t2) return 0;
  let u = typeof e2, r = typeof t2, o = ["undefined", "object", "boolean", "number", "string"];
  return u !== r ? o.indexOf(u) - o.indexOf(r) : u !== "string" ? Number(e2) - Number(t2) : e2.localeCompare(t2);
}
function qr(e2) {
  return (...t2) => {
    let u = e2(...t2);
    return typeof u == "string" ? new Error(u) : u;
  };
}
function iu(e2) {
  return e2 === void 0 ? {} : e2;
}
function su(e2) {
  if (typeof e2 == "string") return { text: e2 };
  let { text: t2, list: u } = e2;
  return oa((t2 || u) !== void 0, "Unexpected `expected` result, there should be at least one field."), u ? { text: t2, list: { title: u.title, values: u.values.map(su) } } : { text: t2 };
}
function Du(e2, t2) {
  return e2 === true ? true : e2 === false ? { value: t2 } : e2;
}
function cu(e2, t2, u = false) {
  return e2 === false ? false : e2 === true ? u ? true : [{ value: t2 }] : "value" in e2 ? [e2] : e2.length === 0 ? false : e2;
}
function Vr(e2, t2) {
  return typeof e2 == "string" || "key" in e2 ? { from: t2, to: e2 } : "from" in e2 ? { from: e2.from, to: e2.to } : { from: t2, to: e2.to };
}
function mt(e2, t2) {
  return e2 === void 0 ? [] : Array.isArray(e2) ? e2.map((u) => Vr(u, t2)) : [Vr(e2, t2)];
}
function fu(e2, t2) {
  let u = mt(typeof e2 == "object" && "redirect" in e2 ? e2.redirect : e2, t2);
  return u.length === 0 ? { remain: t2, redirect: u } : typeof e2 == "object" && "remain" in e2 ? { remain: e2.remain, redirect: u } : { redirect: u };
}
function oa(e2, t2) {
  if (!e2) throw new Error(t2);
}
var Et = class extends S {
  constructor(t2) {
    super(t2), this._choices = Gr(t2.choices.map((u) => u && typeof u == "object" ? u : { value: u }), "value");
  }
  expected({ descriptor: t2 }) {
    let u = Array.from(this._choices.keys()).map((a) => this._choices.get(a)).filter(({ hidden: a }) => !a).map((a) => a.value).sort(Xr).map(t2.value), r = u.slice(0, -2), o = u.slice(-2);
    return { text: r.concat(o.join(" or ")).join(", "), list: { title: "one of the following values", values: u } };
  }
  validate(t2) {
    return this._choices.has(t2);
  }
  deprecated(t2) {
    let u = this._choices.get(t2);
    return u && u.deprecated ? { value: t2 } : false;
  }
  forward(t2) {
    let u = this._choices.get(t2);
    return u ? u.forward : void 0;
  }
  redirect(t2) {
    let u = this._choices.get(t2);
    return u ? u.redirect : void 0;
  }
};
var Ct = class extends S {
  expected() {
    return "a number";
  }
  validate(t2, u) {
    return typeof t2 == "number";
  }
};
var ht = class extends Ct {
  expected() {
    return "an integer";
  }
  validate(t2, u) {
    return u.normalizeValidateResult(super.validate(t2, u), t2) === true && Hr(t2);
  }
};
var je = class extends S {
  expected() {
    return "a string";
  }
  validate(t2) {
    return typeof t2 == "string";
  }
};
var Qr = ie, Zr = ft, en = Yr, tn = Rr;
var gt = class {
  constructor(t2, u) {
    let { logger: r = console, loggerPrintWidth: o = 80, descriptor: n = Qr, unknown: a = Zr, invalid: s = en, deprecated: i2 = tn, missing: D = () => false, required: f2 = () => false, preprocess: l = (c2) => c2, postprocess: d = () => Ae } = u || {};
    this._utils = { descriptor: n, logger: r || { warn: () => {
    } }, loggerPrintWidth: o, schemas: Kr(t2, "name"), normalizeDefaultResult: iu, normalizeExpectedResult: su, normalizeDeprecatedResult: cu, normalizeForwardResult: mt, normalizeRedirectResult: fu, normalizeValidateResult: Du }, this._unknownHandler = a, this._invalidHandler = qr(s), this._deprecatedHandler = i2, this._identifyMissing = (c2, p) => !(c2 in p) || D(c2, p), this._identifyRequired = f2, this._preprocess = l, this._postprocess = d, this.cleanHistory();
  }
  cleanHistory() {
    this._hasDeprecationWarned = zr();
  }
  normalize(t2) {
    let u = {}, o = [this._preprocess(t2, this._utils)], n = () => {
      for (; o.length !== 0; ) {
        let a = o.shift(), s = this._applyNormalization(a, u);
        o.push(...s);
      }
    };
    n();
    for (let a of Object.keys(this._utils.schemas)) {
      let s = this._utils.schemas[a];
      if (!(a in u)) {
        let i2 = iu(s.default(this._utils));
        "value" in i2 && o.push({ [a]: i2.value });
      }
    }
    n();
    for (let a of Object.keys(this._utils.schemas)) {
      if (!(a in u)) continue;
      let s = this._utils.schemas[a], i2 = u[a], D = s.postprocess(i2, this._utils);
      D !== Ae && (this._applyValidation(D, a, s), u[a] = D);
    }
    return this._applyPostprocess(u), this._applyRequiredCheck(u), u;
  }
  _applyNormalization(t2, u) {
    let r = [], { knownKeys: o, unknownKeys: n } = this._partitionOptionKeys(t2);
    for (let a of o) {
      let s = this._utils.schemas[a], i2 = s.preprocess(t2[a], this._utils);
      this._applyValidation(i2, a, s);
      let D = ({ from: c2, to: p }) => {
        r.push(typeof p == "string" ? { [p]: c2 } : { [p.key]: p.value });
      }, f2 = ({ value: c2, redirectTo: p }) => {
        let F = cu(s.deprecated(c2, this._utils), i2, true);
        if (F !== false) if (F === true) this._hasDeprecationWarned(a) || this._utils.logger.warn(this._deprecatedHandler(a, p, this._utils));
        else for (let { value: C2 } of F) {
          let y = { key: a, value: C2 };
          if (!this._hasDeprecationWarned(y)) {
            let m = typeof p == "string" ? { key: p, value: C2 } : p;
            this._utils.logger.warn(this._deprecatedHandler(y, m, this._utils));
          }
        }
      };
      mt(s.forward(i2, this._utils), i2).forEach(D);
      let d = fu(s.redirect(i2, this._utils), i2);
      if (d.redirect.forEach(D), "remain" in d) {
        let c2 = d.remain;
        u[a] = a in u ? s.overlap(u[a], c2, this._utils) : c2, f2({ value: c2 });
      }
      for (let { from: c2, to: p } of d.redirect) f2({ value: c2, redirectTo: p });
    }
    for (let a of n) {
      let s = t2[a];
      this._applyUnknownHandler(a, s, u, (i2, D) => {
        r.push({ [i2]: D });
      });
    }
    return r;
  }
  _applyRequiredCheck(t2) {
    for (let u of Object.keys(this._utils.schemas)) if (this._identifyMissing(u, t2) && this._identifyRequired(u)) throw this._invalidHandler(u, Dt, this._utils);
  }
  _partitionOptionKeys(t2) {
    let [u, r] = Jr(Object.keys(t2).filter((o) => !this._identifyMissing(o, t2)), (o) => o in this._utils.schemas);
    return { knownKeys: u, unknownKeys: r };
  }
  _applyValidation(t2, u, r) {
    let o = Du(r.validate(t2, this._utils), t2);
    if (o !== true) throw this._invalidHandler(u, o.value, this._utils);
  }
  _applyUnknownHandler(t2, u, r, o) {
    let n = this._unknownHandler(t2, u, this._utils);
    if (n) for (let a of Object.keys(n)) {
      if (this._identifyMissing(a, n)) continue;
      let s = n[a];
      a in this._utils.schemas ? o(a, s) : r[a] = s;
    }
  }
  _applyPostprocess(t2) {
    let u = this._postprocess(t2, this._utils);
    if (u !== Ae) {
      if (u.delete) for (let r of u.delete) delete t2[r];
      if (u.override) {
        let { knownKeys: r, unknownKeys: o } = this._partitionOptionKeys(u.override);
        for (let n of r) {
          let a = u.override[n];
          this._applyValidation(a, n, this._utils.schemas[n]), t2[n] = a;
        }
        for (let n of o) {
          let a = u.override[n];
          this._applyUnknownHandler(n, a, t2, (s, i2) => {
            let D = this._utils.schemas[s];
            this._applyValidation(i2, s, D), t2[s] = i2;
          });
        }
      }
    }
  }
};
var lu;
function ia(e2, t2, { logger: u = false, isCLI: r = false, passThrough: o = false, FlagSchema: n, descriptor: a } = {}) {
  if (r) {
    if (!n) throw new Error("'FlagSchema' option is required.");
    if (!a) throw new Error("'descriptor' option is required.");
  } else a = ie;
  let s = o ? Array.isArray(o) ? (d, c2) => o.includes(d) ? { [d]: c2 } : void 0 : (d, c2) => ({ [d]: c2 }) : (d, c2, p) => {
    let { _: F, ...C2 } = p.schemas;
    return ft(d, c2, { ...p, schemas: C2 });
  }, i2 = sa(t2, { isCLI: r, FlagSchema: n }), D = new gt(i2, { logger: u, unknown: s, descriptor: a }), f2 = u !== false;
  f2 && lu && (D._hasDeprecationWarned = lu);
  let l = D.normalize(e2);
  return f2 && (lu = D._hasDeprecationWarned), l;
}
function sa(e2, { isCLI: t2, FlagSchema: u }) {
  let r = [];
  t2 && r.push(dt.create({ name: "_" }));
  for (let o of e2) r.push(Da(o, { isCLI: t2, optionInfos: e2, FlagSchema: u })), o.alias && t2 && r.push(lt.create({ name: o.alias, sourceName: o.name }));
  return r;
}
function Da(e2, { isCLI: t2, optionInfos: u, FlagSchema: r }) {
  let { name: o } = e2, n = { name: o }, a, s = {};
  switch (e2.type) {
    case "int":
      a = ht, t2 && (n.preprocess = Number);
      break;
    case "string":
      a = je;
      break;
    case "choice":
      a = Et, n.choices = e2.choices.map((i2) => i2?.redirect ? { ...i2, redirect: { to: { key: e2.name, value: i2.redirect } } } : i2);
      break;
    case "boolean":
      a = Ft;
      break;
    case "flag":
      a = r, n.flags = u.flatMap((i2) => [i2.alias, i2.description && i2.name, i2.oppositeDescription && `no-${i2.name}`].filter(Boolean));
      break;
    case "path":
      a = je;
      break;
    default:
      throw new Error(`Unexpected type ${e2.type}`);
  }
  if (e2.exception ? n.validate = (i2, D, f2) => e2.exception(i2) || D.validate(i2, f2) : n.validate = (i2, D, f2) => i2 === void 0 || D.validate(i2, f2), e2.redirect && (s.redirect = (i2) => i2 ? { to: typeof e2.redirect == "string" ? e2.redirect : { key: e2.redirect.option, value: e2.redirect.value } } : void 0), e2.deprecated && (s.deprecated = true), t2 && !e2.array) {
    let i2 = n.preprocess || ((D) => D);
    n.preprocess = (D, f2, l) => f2.preprocess(i2(Array.isArray(D) ? b(0, D, -1) : D), l);
  }
  return e2.array ? pt.create({ ...t2 ? { preprocess: (i2) => Array.isArray(i2) ? i2 : [i2] } : {}, ...s, valueSchema: a.create(n) }) : a.create({ ...n, ...s });
}
var un = ia;
var ca = Array.prototype.findLast ?? function(e2) {
  for (let t2 = this.length - 1; t2 >= 0; t2--) {
    let u = this[t2];
    if (e2(u, t2, this)) return u;
  }
}, fa = X("findLast", function() {
  if (Array.isArray(this)) return ca;
}), du = fa;
var rn = Symbol.for("PRETTIER_IS_FRONT_MATTER"), pu = [];
function la(e2) {
  return !!e2?.[rn];
}
var de = la;
var nn = /* @__PURE__ */ new Set(["yaml", "toml"]), Ue = ({ node: e2 }) => de(e2) && nn.has(e2.language);
async function Fu(e2, t2, u, r) {
  let { node: o } = u, { language: n } = o;
  if (!nn.has(n)) return;
  let a = o.value.trim(), s;
  if (a) {
    let i2 = n === "yaml" ? n : st(r, { language: n });
    if (!i2) return;
    s = a ? await e2(a, { parser: i2 }) : "";
  } else s = a;
  return et([o.startDelimiter, o.explicitLanguage ?? "", V, s, s ? V : "", o.endDelimiter]);
}
function da(e2, t2) {
  return Ue({ node: e2 }) && (delete t2.end, delete t2.raw, delete t2.value), t2;
}
var mu = da;
function pa({ node: e2 }) {
  return e2.raw;
}
var Eu = pa;
var on = /* @__PURE__ */ new Set(["tokens", "comments", "parent", "enclosingNode", "precedingNode", "followingNode"]), Fa = (e2) => Object.keys(e2).filter((t2) => !on.has(t2));
function ma(e2, t2) {
  let u = e2 ? (r) => e2(r, on) : Fa;
  return t2 ? new Proxy(u, { apply: (r, o, n) => de(n[0]) ? pu : Reflect.apply(r, o, n) }) : u;
}
var Cu = ma;
function gu(e2, t2) {
  if (!t2) throw new Error("parserName is required.");
  let u = du(0, e2, (o) => o.parsers && Object.prototype.hasOwnProperty.call(o.parsers, t2));
  if (u) return u;
  let r = `Couldn't resolve parser "${t2}".`;
  throw r += " Plugins must be explicitly added to the standalone bundle.", new Me(r);
}
function an(e2, t2) {
  if (!t2) throw new Error("astFormat is required.");
  let u = du(0, e2, (o) => o.printers && Object.prototype.hasOwnProperty.call(o.printers, t2));
  if (u) return u;
  let r = `Couldn't find plugin for AST format "${t2}".`;
  throw r += " Plugins must be explicitly added to the standalone bundle.", new Me(r);
}
function We({ plugins: e2, parser: t2 }) {
  let u = gu(e2, t2);
  return yu(u, t2);
}
function yu(e2, t2) {
  let u = e2.parsers[t2];
  return typeof u == "function" ? u() : u;
}
async function sn(e2, t2) {
  let u = e2.printers[t2], r = typeof u == "function" ? await u() : u;
  return Ea(r);
}
var hu = /* @__PURE__ */ new WeakMap();
function Ea(e2) {
  if (hu.has(e2)) return hu.get(e2);
  let { features: t2, getVisitorKeys: u, embed: r, massageAstNode: o, print: n, ...a } = e2;
  t2 = ya(t2);
  let s = t2.experimental_frontMatterSupport;
  u = Cu(u, s.massageAstNode || s.embed || s.print);
  let i2 = o;
  o && s.massageAstNode && (i2 = new Proxy(o, { apply(d, c2, p) {
    return mu(...p), Reflect.apply(d, c2, p);
  } }));
  let D = r;
  if (r) {
    let d;
    D = new Proxy(r, { get(c2, p, F) {
      return p === "getVisitorKeys" ? (d ?? (d = r.getVisitorKeys ? Cu(r.getVisitorKeys, s.massageAstNode || s.embed) : u), d) : Reflect.get(c2, p, F);
    }, apply: (c2, p, F) => s.embed && Ue(...F) ? Fu : Reflect.apply(c2, p, F) });
  }
  let f2 = n;
  s.print && (f2 = new Proxy(n, { apply(d, c2, p) {
    let [F] = p;
    return de(F.node) ? Eu(F) : Reflect.apply(d, c2, p);
  } }));
  let l = { features: t2, getVisitorKeys: u, embed: D, massageAstNode: i2, print: f2, ...a };
  return hu.set(e2, l), l;
}
var Ca = ["clean", "embed", "print"], ha = Object.fromEntries(Ca.map((e2) => [e2, false]));
function ga(e2) {
  return { ...ha, ...e2 };
}
function ya(e2) {
  return { experimental_avoidAstMutation: false, ...e2, experimental_frontMatterSupport: ga(e2?.experimental_frontMatterSupport) };
}
var Dn = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null, getVisitorKeys: null };
async function ba(e2, t2 = {}) {
  let u = { ...e2 };
  if (!u.parser) if (u.filepath) {
    if (u.parser = st(u, { physicalFile: u.filepath }), !u.parser) throw new Ye(`No parser could be inferred for file "${u.filepath}".`);
  } else throw new Ye("No parser and no file path given, couldn't infer a parser.");
  let r = it({ plugins: e2.plugins, showDeprecated: true }).options, o = { ...Dn, ...Object.fromEntries(r.filter((l) => l.default !== void 0).map((l) => [l.name, l.default])) }, n = gu(u.plugins, u.parser), a = await yu(n, u.parser);
  u.astFormat = a.astFormat, u.locEnd = a.locEnd, u.locStart = a.locStart;
  let s = n.printers?.[a.astFormat] ? n : an(u.plugins, a.astFormat), i2 = await sn(s, a.astFormat);
  u.printer = i2, u.getVisitorKeys = i2.getVisitorKeys;
  let D = s.defaultOptions ? Object.fromEntries(Object.entries(s.defaultOptions).filter(([, l]) => l !== void 0)) : {}, f2 = { ...o, ...D };
  for (let [l, d] of Object.entries(f2)) (u[l] === null || u[l] === void 0) && (u[l] = d);
  return u.parser === "json" && (u.trailingComma = "none"), un(u, r, { passThrough: Object.keys(Dn), ...t2 });
}
var se = ba;
ao(dn());
var _u = { keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"], strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"], strictBind: ["eval", "arguments"] };
new Set(_u.keyword);
new Set(_u.strict);
new Set(_u.strictBind);
var It = (e2, t2) => (u) => e2(t2(u));
function mn(e2) {
  return { keyword: e2.cyan, capitalized: e2.yellow, jsxIdentifier: e2.yellow, punctuator: e2.yellow, number: e2.magenta, string: e2.green, regex: e2.magenta, comment: e2.gray, invalid: It(It(e2.white, e2.bgRed), e2.bold), gutter: e2.gray, marker: It(e2.red, e2.bold), message: It(e2.red, e2.bold), reset: e2.reset };
}
mn(ou());
mn(ou());
function _a() {
  return new Proxy({}, { get: () => (e2) => e2 });
}
var Fn = /\r\n|[\n\r\u2028\u2029]/;
function xa(e2, t2, u) {
  let r = Object.assign({ column: 0, line: -1 }, e2.start), o = Object.assign({}, r, e2.end), { linesAbove: n = 2, linesBelow: a = 3 } = u || {}, s = r.line, i2 = r.column, D = o.line, f2 = o.column, l = Math.max(s - (n + 1), 0), d = Math.min(t2.length, D + a);
  s === -1 && (l = 0), D === -1 && (d = t2.length);
  let c2 = D - s, p = {};
  if (c2) for (let F = 0; F <= c2; F++) {
    let C2 = F + s;
    if (!i2) p[C2] = true;
    else if (F === 0) {
      let y = t2[C2 - 1].length;
      p[C2] = [i2, y - i2 + 1];
    } else if (F === c2) p[C2] = [0, f2];
    else {
      let y = t2[C2 - F].length;
      p[C2] = [0, y];
    }
  }
  else i2 === f2 ? i2 ? p[s] = [i2, 0] : p[s] = true : p[s] = [i2, f2 - i2];
  return { start: l, end: d, markerLines: p };
}
function En(e2, t2, u = {}) {
  let o = _a(), n = e2.split(Fn), { start: a, end: s, markerLines: i2 } = xa(t2, n, u), D = t2.start && typeof t2.start.column == "number", f2 = String(s).length, d = e2.split(Fn, s).slice(a, s).map((c2, p) => {
    let F = a + 1 + p, y = ` ${` ${F}`.slice(-f2)} |`, m = i2[F], h = !i2[F + 1];
    if (m) {
      let E = "";
      if (Array.isArray(m)) {
        let g = c2.slice(0, Math.max(m[0] - 1, 0)).replace(/[^\t]/g, " "), A2 = m[1] || 1;
        E = [`
 `, o.gutter(y.replace(/\d/g, " ")), " ", g, o.marker("^").repeat(A2)].join(""), h && u.message && (E += " " + o.message(u.message));
      }
      return [o.marker(">"), o.gutter(y), c2.length > 0 ? ` ${c2}` : "", E].join("");
    } else return ` ${o.gutter(y)}${c2.length > 0 ? ` ${c2}` : ""}`;
  }).join(`
`);
  return u.message && !D && (d = `${" ".repeat(f2 + 1)}${u.message}
${d}`), d;
}
async function Ba(e2, t2) {
  let u = await We(t2), r = u.preprocess ? await u.preprocess(e2, t2) : e2;
  t2.originalText = r;
  let o;
  try {
    o = await u.parse(r, t2, t2);
  } catch (n) {
    Ta(n, e2);
  }
  return { text: r, ast: o };
}
function Ta(e2, t2) {
  let { loc: u } = e2;
  if (u) {
    let r = En(t2, u, {});
    throw e2.message += `
` + r, e2.codeFrame = r, e2;
  }
  throw e2;
}
var Fe = Ba;
async function Cn(e2, t2, u, r, o) {
  if (u.embeddedLanguageFormatting !== "auto") return;
  let { printer: n } = u, { embed: a } = n;
  if (!a) return;
  if (a.length > 2) throw new Error("printer.embed has too many parameters. The API changed in Prettier v3. Please update your plugin. See https://prettier.io/docs/plugins#optional-embed");
  let { hasPrettierIgnore: s } = n, { getVisitorKeys: i2 } = a, D = [];
  d();
  let f2 = e2.stack;
  for (let { print: c2, node: p, pathStack: F } of D) try {
    e2.stack = F;
    let C2 = await c2(l, t2, e2, u);
    C2 && o.set(p, C2);
  } catch (C2) {
    if (globalThis.PRETTIER_DEBUG) throw C2;
  }
  e2.stack = f2;
  function l(c2, p) {
    return Na(c2, p, u, r);
  }
  function d() {
    let { node: c2 } = e2;
    if (c2 === null || typeof c2 != "object" || s?.(e2)) return;
    for (let F of i2(c2)) Array.isArray(c2[F]) ? e2.each(d, F) : e2.call(d, F);
    let p = a(e2, u);
    if (p) {
      if (typeof p == "function") {
        D.push({ print: p, node: c2, pathStack: [...e2.stack] });
        return;
      }
      o.set(c2, p);
    }
  }
}
async function Na(e2, t2, u, r) {
  let o = await se({ ...u, ...t2, parentParser: u.parser, originalText: e2, cursorOffset: void 0, rangeStart: void 0, rangeEnd: void 0 }, { passThrough: true }), { ast: n } = await Fe(e2, o), a = await r(n, o);
  return qe(a);
}
function Sa(e2, t2, u, r) {
  let { originalText: o, [Symbol.for("comments")]: n, locStart: a, locEnd: s, [Symbol.for("printedComments")]: i2 } = t2, { node: D } = e2, f2 = a(D), l = s(D);
  for (let c2 of n) a(c2) >= f2 && s(c2) <= l && i2.add(c2);
  let { printPrettierIgnored: d } = t2.printer;
  return d ? d(e2, t2, u, r) : o.slice(f2, l);
}
var hn = Sa;
async function Ge(e2, t2) {
  ({ ast: e2 } = await xu(e2, t2));
  let u = /* @__PURE__ */ new Map(), r = new pr(e2), n = /* @__PURE__ */ new Map();
  await Cn(r, s, t2, Ge, n);
  let a = await gn(r, t2, s, void 0, n);
  if (Tr(t2), t2.cursorOffset >= 0) {
    if (t2.nodeAfterCursor && !t2.nodeBeforeCursor) return [ee, a];
    if (t2.nodeBeforeCursor && !t2.nodeAfterCursor) return [a, ee];
  }
  return a;
  function s(D, f2) {
    return D === void 0 || D === r ? i2(f2) : Array.isArray(D) ? r.call(() => i2(f2), ...D) : r.call(() => i2(f2), D);
  }
  function i2(D) {
    let f2 = r.node;
    if (f2 == null) return "";
    let l = ge(f2) && D === void 0;
    if (l && u.has(f2)) return u.get(f2);
    let d = gn(r, t2, s, D, n);
    return l && u.set(f2, d), d;
  }
}
function gn(e2, t2, u, r, o) {
  let { node: n } = e2, { printer: a } = t2, s;
  switch (a.hasPrettierIgnore?.(e2) ? s = hn(e2, t2, u, r) : o.has(n) ? s = o.get(n) : s = a.print(e2, t2, u, r), n) {
    case t2.cursorNode:
      s = Ee(s, (i2) => [ee, i2, ee]);
      break;
    case t2.nodeBeforeCursor:
      s = Ee(s, (i2) => [i2, ee]);
      break;
    case t2.nodeAfterCursor:
      s = Ee(s, (i2) => [ee, i2]);
      break;
  }
  return a.printComment && !a.willPrintOwnComments?.(e2, t2) && (s = Br(e2, s, t2)), s;
}
async function xu(e2, t2) {
  let u = e2.comments ?? [];
  t2[Symbol.for("comments")] = u, t2[Symbol.for("printedComments")] = /* @__PURE__ */ new Set(), Ar(e2, t2);
  let { printer: { preprocess: r } } = t2;
  return e2 = r ? await r(e2, t2) : e2, { ast: e2, comments: u };
}
function wa(e2, t2) {
  let { cursorOffset: u, locStart: r, locEnd: o, getVisitorKeys: n } = t2, a = (c2) => r(c2) <= u && o(c2) >= u, s = e2, i2 = [e2];
  for (let c2 of Cr(e2, { getVisitorKeys: n, filter: a })) i2.push(c2), s = c2;
  if (hr(s, { getVisitorKeys: n })) return { cursorNode: s };
  let D, f2, l = -1, d = Number.POSITIVE_INFINITY;
  for (; i2.length > 0 && (D === void 0 || f2 === void 0); ) {
    s = i2.pop();
    let c2 = D !== void 0, p = f2 !== void 0;
    for (let F of be(s, { getVisitorKeys: n })) {
      if (!c2) {
        let C2 = o(F);
        C2 <= u && C2 > l && (D = F, l = C2);
      }
      if (!p) {
        let C2 = r(F);
        C2 >= u && C2 < d && (f2 = F, d = C2);
      }
    }
  }
  return { nodeBeforeCursor: D, nodeAfterCursor: f2 };
}
var Bu = wa;
function Oa(e2, t2) {
  let { printer: u } = t2, r = u.massageAstNode;
  if (!r) return e2;
  let { getVisitorKeys: o } = u, { ignoredProperties: n } = r;
  return a(e2);
  function a(s, i2) {
    if (!ge(s)) return s;
    if (Array.isArray(s)) return s.map((d) => a(d, i2)).filter(Boolean);
    let D = {}, f2 = new Set(o(s));
    for (let d in s) !Object.prototype.hasOwnProperty.call(s, d) || n?.has(d) || (f2.has(d) ? D[d] = a(s[d], s) : D[d] = s[d]);
    let l = r(s, D, i2);
    if (l !== null) return l ?? D;
  }
}
var yn = Oa;
var Pa = Array.prototype.findLastIndex ?? function(e2) {
  for (let t2 = this.length - 1; t2 >= 0; t2--) {
    let u = this[t2];
    if (e2(u, t2, this)) return t2;
  }
  return -1;
}, Ia = X("findLastIndex", function() {
  if (Array.isArray(this)) return Pa;
}), bn = Ia;
var ka = ({ parser: e2 }) => e2 === "json" || e2 === "json5" || e2 === "jsonc" || e2 === "json-stringify";
function va(e2, t2) {
  return t2 = new Set(t2), e2.find((u) => xn.has(u.type) && t2.has(u));
}
function An(e2) {
  let t2 = bn(0, e2, (u) => u.type !== "Program" && u.type !== "File");
  return t2 === -1 ? e2 : e2.slice(0, t2 + 1);
}
function Ra(e2, t2, { locStart: u, locEnd: r }) {
  let [o, ...n] = e2, [a, ...s] = t2;
  if (o === a) return [o, a];
  let i2 = u(o);
  for (let f2 of An(s)) if (u(f2) >= i2) a = f2;
  else break;
  let D = r(a);
  for (let f2 of An(n)) {
    if (r(f2) <= D) o = f2;
    else break;
    if (o === a) break;
  }
  return [o, a];
}
function Tu(e2, t2, u, r, o = [], n) {
  let { locStart: a, locEnd: s } = u, i2 = a(e2), D = s(e2);
  if (t2 > D || t2 < i2 || n === "rangeEnd" && t2 === i2 || n === "rangeStart" && t2 === D) return;
  let f2 = [e2, ...o], l = at$1(e2, f2, { cache: uu, locStart: a, locEnd: s, getVisitorKeys: u.getVisitorKeys, filter: u.printer.canAttachComment, getChildren: u.printer.getCommentChildNodes });
  for (let d of l) {
    let c2 = Tu(d, t2, u, r, f2, n);
    if (c2) return c2;
  }
  if (r(e2, o[0])) return f2;
}
function La(e2, t2) {
  return t2 !== "DeclareExportDeclaration" && e2 !== "TypeParameterDeclaration" && (e2 === "Directive" || e2 === "TypeAlias" || e2 === "TSExportAssignment" || e2.startsWith("Declare") || e2.startsWith("TSDeclare") || e2.endsWith("Statement") || e2.endsWith("Declaration"));
}
var xn = /* @__PURE__ */ new Set(["JsonRoot", "ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), Ma = /* @__PURE__ */ new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
function _n(e2, t2, u) {
  if (!t2) return false;
  switch (e2.parser) {
    case "flow":
    case "hermes":
    case "babel":
    case "babel-flow":
    case "babel-ts":
    case "typescript":
    case "acorn":
    case "espree":
    case "meriyah":
    case "oxc":
    case "oxc-ts":
    case "__babel_estree":
      return La(t2.type, u?.type);
    case "json":
    case "json5":
    case "jsonc":
    case "json-stringify":
      return xn.has(t2.type);
    case "graphql":
      return Ma.has(t2.kind);
    case "vue":
      return t2.tag !== "root";
  }
  return false;
}
function Bn(e2, t2, u) {
  let { rangeStart: r, rangeEnd: o, locStart: n, locEnd: a } = t2;
  let s = e2.slice(r, o).search(/\S/u), i2 = s === -1;
  if (!i2) for (r += s; o > r && !/\S/u.test(e2[o - 1]); --o) ;
  let D = Tu(u, r, t2, (c2, p) => _n(t2, c2, p), [], "rangeStart");
  if (!D) return;
  let f2 = i2 ? D : Tu(u, o, t2, (c2) => _n(t2, c2), [], "rangeEnd");
  if (!f2) return;
  let l, d;
  if (ka(t2)) {
    let c2 = va(D, f2);
    l = c2, d = c2;
  } else [l, d] = Ra(D, f2, t2);
  return [Math.min(n(l), n(d)), Math.max(a(l), a(d))];
}
var wn = "\uFEFF", Tn = Symbol("cursor");
async function On(e2, t2, u = 0) {
  if (!e2 || e2.trim().length === 0) return { formatted: "", cursorOffset: -1, comments: [] };
  let { ast: r, text: o } = await Fe(e2, t2);
  t2.cursorOffset >= 0 && (t2 = { ...t2, ...Bu(r, t2) });
  let n = await Ge(r, t2);
  u > 0 && (n = tt([V, n], u, t2.tabWidth));
  let a = Ce(n, t2);
  if (u > 0) {
    let i2 = a.formatted.trim();
    a.cursorNodeStart !== void 0 && (a.cursorNodeStart -= a.formatted.indexOf(i2), a.cursorNodeStart < 0 && (a.cursorNodeStart = 0, a.cursorNodeText = a.cursorNodeText.trimStart()), a.cursorNodeStart + a.cursorNodeText.length > i2.length && (a.cursorNodeText = a.cursorNodeText.trimEnd())), a.formatted = i2 + Se(t2.endOfLine);
  }
  let s = t2[Symbol.for("comments")];
  if (t2.cursorOffset >= 0) {
    let i2, D, f2, l;
    if ((t2.cursorNode || t2.nodeBeforeCursor || t2.nodeAfterCursor) && a.cursorNodeText) if (f2 = a.cursorNodeStart, l = a.cursorNodeText, t2.cursorNode) i2 = t2.locStart(t2.cursorNode), D = o.slice(i2, t2.locEnd(t2.cursorNode));
    else {
      if (!t2.nodeBeforeCursor && !t2.nodeAfterCursor) throw new Error("Cursor location must contain at least one of cursorNode, nodeBeforeCursor, nodeAfterCursor");
      i2 = t2.nodeBeforeCursor ? t2.locEnd(t2.nodeBeforeCursor) : 0;
      let y = t2.nodeAfterCursor ? t2.locStart(t2.nodeAfterCursor) : o.length;
      D = o.slice(i2, y);
    }
    else i2 = 0, D = o, f2 = 0, l = a.formatted;
    let d = t2.cursorOffset - i2;
    if (D === l) return { formatted: a.formatted, cursorOffset: f2 + d, comments: s };
    let c2 = D.split("");
    c2.splice(d, 0, Tn);
    let p = l.split(""), F = Ut(c2, p), C2 = f2;
    for (let y of F) if (y.removed) {
      if (y.value.includes(Tn)) break;
    } else C2 += y.count;
    return { formatted: a.formatted, cursorOffset: C2, comments: s };
  }
  return { formatted: a.formatted, cursorOffset: -1, comments: s };
}
async function Ya(e2, t2) {
  let { ast: u, text: r } = await Fe(e2, t2), [o, n] = Bn(r, t2, u) ?? [0, 0], a = r.slice(o, n), s = Math.min(o, r.lastIndexOf(`
`, o) + 1), i2 = r.slice(s, o).match(/^\s*/u)[0], D = he(i2, t2.tabWidth), f2 = await On(a, { ...t2, rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: t2.cursorOffset > o && t2.cursorOffset <= n ? t2.cursorOffset - o : -1, endOfLine: "lf" }, D), l = f2.formatted.trimEnd(), { cursorOffset: d } = t2;
  d > n ? d += l.length - a.length : f2.cursorOffset >= 0 && (d = f2.cursorOffset + o);
  let c2 = r.slice(0, o) + l + r.slice(n);
  if (t2.endOfLine !== "lf") {
    let p = Se(t2.endOfLine);
    d >= 0 && p === `\r
` && (d += $t(c2.slice(0, d), `
`)), c2 = oe(0, c2, `
`, p);
  }
  return { formatted: c2, cursorOffset: d, comments: f2.comments };
}
function Nu(e2, t2, u) {
  return typeof t2 != "number" || Number.isNaN(t2) || t2 < 0 || t2 > e2.length ? u : t2;
}
function Nn(e2, t2) {
  let { cursorOffset: u, rangeStart: r, rangeEnd: o } = t2;
  return u = Nu(e2, u, -1), r = Nu(e2, r, 0), o = Nu(e2, o, e2.length), { ...t2, cursorOffset: u, rangeStart: r, rangeEnd: o };
}
function Pn(e2, t2) {
  let { cursorOffset: u, rangeStart: r, rangeEnd: o, endOfLine: n } = Nn(e2, t2), a = e2.charAt(0) === wn;
  if (a && (e2 = e2.slice(1), u--, r--, o--), n === "auto" && (n = Yu(e2)), e2.includes("\r")) {
    let s = (i2) => $t(e2.slice(0, Math.max(i2, 0)), `\r
`);
    u -= s(u), r -= s(r), o -= s(o), e2 = ju(e2);
  }
  return { hasBOM: a, text: e2, options: Nn(e2, { ...t2, cursorOffset: u, rangeStart: r, rangeEnd: o, endOfLine: n }) };
}
async function Sn(e2, t2) {
  let u = await We(t2);
  return !u.hasPragma || u.hasPragma(e2);
}
async function ja(e2, t2) {
  return (await We(t2)).hasIgnorePragma?.(e2);
}
async function Su(e2, t2) {
  let { hasBOM: u, text: r, options: o } = Pn(e2, await se(t2));
  if (o.rangeStart >= o.rangeEnd && r !== "" || o.requirePragma && !await Sn(r, o) || o.checkIgnorePragma && await ja(r, o)) return { formatted: e2, cursorOffset: t2.cursorOffset, comments: [] };
  let n;
  return o.rangeStart > 0 || o.rangeEnd < r.length ? n = await Ya(r, o) : (!o.requirePragma && o.insertPragma && o.printer.insertPragma && !await Sn(r, o) && (r = o.printer.insertPragma(r)), n = await On(r, o)), u && (n.formatted = wn + n.formatted, n.cursorOffset >= 0 && n.cursorOffset++), n;
}
async function In(e2, t2, u) {
  let { text: r, options: o } = Pn(e2, await se(t2)), n = await Fe(r, o);
  return u && (u.preprocessForPrint && (n.ast = await xu(n.ast, o)), u.massage && (n.ast = yn(n.ast, o))), n;
}
async function kn(e2, t2) {
  t2 = await se(t2);
  let u = await Ge(e2, t2);
  return Ce(u, t2);
}
async function vn(e2, t2) {
  let u = sr(e2), { formatted: r } = await Su(u, { ...t2, parser: "__js_expression" });
  return r;
}
async function Rn(e2, t2) {
  t2 = await se(t2);
  let { ast: u } = await Fe(e2, t2);
  return t2.cursorOffset >= 0 && (t2 = { ...t2, ...Bu(u, t2) }), Ge(u, t2);
}
async function Ln(e2, t2) {
  return Ce(e2, await se(t2));
}
var wu = {};
Yt(wu, { builders: () => Wa, printer: () => $a, utils: () => Va });
var Wa = { join: Ie, line: ut, softline: or, hardline: V, literalline: Qe, group: Kt, conditionalGroup: tr, fill: er, lineSuffix: ve, lineSuffixBoundary: ar, cursor: ee, breakParent: ce, ifBreak: ur, trim: ir, indent: ae, indentIfBreak: rr, align: De, addAlignmentToDoc: tt, markAsRoot: et, dedentToRoot: Qu, dedent: Zu, hardlineWithoutBreakParent: ke, literallineWithoutBreakParent: Gt, label: nr, concat: (e2) => e2 }, $a = { printDocToString: Ce }, Va = { willBreak: Ku, traverseDoc: we, findInDoc: Xe, mapDoc: Pe, removeLines: zu, stripTrailingHardline: qe, replaceEndOfLine: Ju, canBreak: Hu };
var Mn = "3.7.4";
var Pu = {};
Yt(Pu, { addDanglingComment: () => ue, addLeadingComment: () => fe, addTrailingComment: () => le, getAlignmentSize: () => he, getIndentSize: () => Yn, getMaxContinuousCount: () => jn, getNextNonSpaceNonCommentCharacter: () => Un, getNextNonSpaceNonCommentCharacterIndex: () => ni, getPreferredQuote: () => Vn, getStringWidth: () => Re, hasNewline: () => z, hasNewlineInRange: () => Kn, hasSpaces: () => Gn, isNextLineEmpty: () => Di, isNextLineEmptyAfterIndex: () => kt, isPreviousLineEmpty: () => ai, makeString: () => si, skip: () => ye, skipEverythingButNewLine: () => ot, skipInlineComment: () => xe, skipNewline: () => K, skipSpaces: () => Y, skipToLineEnd: () => nt, skipTrailingComment: () => Be, skipWhitespace: () => Fr });
function Ka(e2, t2) {
  if (t2 === false) return false;
  if (e2.charAt(t2) === "/" && e2.charAt(t2 + 1) === "*") {
    for (let u = t2 + 2; u < e2.length; ++u) if (e2.charAt(u) === "*" && e2.charAt(u + 1) === "/") return u + 2;
  }
  return t2;
}
var xe = Ka;
function Ga(e2, t2) {
  return t2 === false ? false : e2.charAt(t2) === "/" && e2.charAt(t2 + 1) === "/" ? ot(e2, t2) : t2;
}
var Be = Ga;
function za(e2, t2) {
  let u = null, r = t2;
  for (; r !== u; ) u = r, r = Y(e2, r), r = xe(e2, r), r = Be(e2, r), r = K(e2, r);
  return r;
}
var ze = za;
function Ja(e2, t2) {
  let u = null, r = t2;
  for (; r !== u; ) u = r, r = nt(e2, r), r = xe(e2, r), r = Y(e2, r);
  return r = Be(e2, r), r = K(e2, r), r !== false && z(e2, r);
}
var kt = Ja;
function Ha(e2, t2) {
  let u = e2.lastIndexOf(`
`);
  return u === -1 ? 0 : he(e2.slice(u + 1).match(/^[\t ]*/u)[0], t2);
}
var Yn = Ha;
function Ou(e2) {
  if (typeof e2 != "string") throw new TypeError("Expected a string");
  return e2.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function Xa(e2, t2) {
  let u = e2.matchAll(new RegExp(`(?:${Ou(t2)})+`, "gu"));
  return u.reduce || (u = [...u]), u.reduce((r, [o]) => Math.max(r, o.length), 0) / t2.length;
}
var jn = Xa;
function qa(e2, t2) {
  let u = ze(e2, t2);
  return u === false ? "" : e2.charAt(u);
}
var Un = qa;
var Wn = Object.freeze({ character: "'", codePoint: 39 }), $n = Object.freeze({ character: '"', codePoint: 34 }), Qa = Object.freeze({ preferred: Wn, alternate: $n }), Za = Object.freeze({ preferred: $n, alternate: Wn });
function ei(e2, t2) {
  let { preferred: u, alternate: r } = t2 === true || t2 === "'" ? Qa : Za, { length: o } = e2, n = 0, a = 0;
  for (let s = 0; s < o; s++) {
    let i2 = e2.charCodeAt(s);
    i2 === u.codePoint ? n++ : i2 === r.codePoint && a++;
  }
  return (n > a ? r : u).character;
}
var Vn = ei;
function ti(e2, t2, u) {
  for (let r = t2; r < u; ++r) if (e2.charAt(r) === `
`) return true;
  return false;
}
var Kn = ti;
function ui(e2, t2, u = {}) {
  return Y(e2, u.backwards ? t2 - 1 : t2, u) !== t2;
}
var Gn = ui;
function ri(e2, t2, u) {
  return ze(e2, u(t2));
}
function ni(e2, t2) {
  return arguments.length === 2 || typeof t2 == "number" ? ze(e2, t2) : ri(...arguments);
}
function oi(e2, t2, u) {
  return Le(e2, u(t2));
}
function ai(e2, t2) {
  return arguments.length === 2 || typeof t2 == "number" ? Le(e2, t2) : oi(...arguments);
}
function ii(e2, t2, u) {
  return kt(e2, u(t2));
}
function si(e2, t2, u) {
  let r = t2 === '"' ? "'" : '"', n = oe(0, e2, /\\(.)|(["'])/gsu, (a, s, i2) => s === r ? s : i2 === t2 ? "\\" + i2 : i2 || (u && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/u.test(s) ? s : "\\" + s));
  return t2 + n + t2;
}
function Di(e2, t2) {
  return arguments.length === 2 || typeof t2 == "number" ? kt(e2, t2) : ii(...arguments);
}
function me(e2, t2 = 1) {
  return async (...u) => {
    let r = u[t2] ?? {}, o = r.plugins ?? [];
    return u[t2] = { ...r, plugins: Array.isArray(o) ? o : Object.values(o) }, e2(...u);
  };
}
var zn = me(Su);
async function Jn(e2, t2) {
  let { formatted: u } = await zn(e2, { ...t2, cursorOffset: -1 });
  return u;
}
async function ci(e2, t2) {
  return await Jn(e2, t2) === e2;
}
var fi = me(it, 0), li = { parse: me(In), formatAST: me(kn), formatDoc: me(vn), printToDoc: me(Rn), printDocToString: me(Ln) };
const expandCdataPlugin = function() {
  return (root2) => {
    replaceNode(root2, (node) => {
      if (Array.isArray(node)) {
        return;
      }
      if (node.type === "cdata") {
        return { type: "text", value: node.value };
      }
    });
  };
};
const mergeAdjacentTextPlugin = function() {
  return (root2) => {
    replaceNode(root2, (node) => {
      if (!("children" in node)) {
        return;
      }
      const children = node.children;
      let prevNode = null;
      let needsMerging = false;
      for (const n of children) {
        if (prevNode && prevNode.type === "text" && n.type === "text") {
          needsMerging = true;
          break;
        }
        prevNode = n;
      }
      if (!needsMerging) {
        return;
      }
      prevNode = null;
      const newChildren = [];
      for (const n of children) {
        if (!prevNode) {
          newChildren.push(n);
          prevNode = n;
          continue;
        }
        if (prevNode.type === "text" && n.type === "text") {
          prevNode.value += n.value;
          continue;
        }
        newChildren.push(n);
        prevNode = n;
      }
      node.children = newChildren;
      return node;
    });
  };
};
const PRE_ELEMENTS = /* @__PURE__ */ new Set([
  "cline",
  "input",
  "output",
  "prompt",
  "pre"
]);
const INDENTABLE_PRE_ELEMENTS = /* @__PURE__ */ new Set([
  "latex-image",
  "latex-image-preamble",
  "macros",
  "asymptote"
]);
const PAR_ELEMENTS = /* @__PURE__ */ new Set([
  "p",
  "line",
  "biblio",
  "li",
  "idx",
  "h",
  "description",
  "caption",
  "cell",
  "q",
  "em",
  "title",
  "pubtitle",
  "section"
]);
const BREAK_AROUND_ELEMENTS = /* @__PURE__ */ new Set([
  "ol",
  "li",
  "ul",
  "dl",
  "p",
  "q",
  "title",
  "pubtitle",
  "section",
  "subsection",
  "blockquote",
  "feedback",
  "footnote",
  "solution",
  "hint",
  "choice",
  "graph"
]);
const ALWAYS_BREAK_ELEMENTS = /* @__PURE__ */ new Set([
  "section",
  "subsection",
  "ol",
  "ul",
  "dl",
  "graph"
]);
const CHILDREN_ON_OWN_LINE_ELEMENTS = /* @__PURE__ */ new Set([
  "ol",
  "ul",
  "dl",
  "graph"
]);
function isElement(node) {
  return node && node.type === "element";
}
function isText(node) {
  return node && node.type === "text";
}
const mergeWhitespacePlugin = function() {
  return (root2) => {
    visit(root2, (node, info) => {
      if (isElement(node) && (PRE_ELEMENTS.has(node.name) || INDENTABLE_PRE_ELEMENTS.has(node.name))) {
        return SKIP;
      }
      if (!isText(node)) {
        return;
      }
      node.value = normalizeWhitespace(node.value);
    });
  };
};
function normalizeWhitespace(str) {
  str = str.replace(/[^\S\r\n]*\n[^\S\r\n]*/g, "\n");
  let parts = str.split(/\n\n+/);
  parts = parts.map((part) => part.replace(/([^\S\r\n]|\n(?!\n))+/g, " "));
  str = parts.join("\n\n");
  return str;
}
const removeEmptyTextNodesPlugin = function() {
  return (root2) => {
    replaceNode(root2, (node, info) => {
      if (!isText(node)) {
        return;
      }
      if (!node.value) {
        return null;
      }
    });
  };
};
const removeInternodeWhitespacePlugin = function() {
  return (root2) => {
    replaceNode(root2, (node, info) => {
      const parent = info.parents[0];
      if (!isText(node) || node.value.trim().length > 0 || node.value.endsWith("\n\n") || node.value.startsWith("\n\n") || PRE_ELEMENTS.has(parent?.name)) {
        return;
      }
      const containingArray = info.containingArray;
      const index2 = info.index;
      if (!containingArray || index2 == null) {
        return;
      }
      const prevNode = containingArray[index2 - 1];
      const nextNode = containingArray[index2 + 1];
      if (isElement(prevNode) && (PAR_ELEMENTS.has(prevNode.name) || BREAK_AROUND_ELEMENTS.has(prevNode.name)) || isElement(nextNode) && (PAR_ELEMENTS.has(nextNode.name) || BREAK_AROUND_ELEMENTS.has(nextNode.name))) {
        return null;
      }
    });
  };
};
const trimWhitespacePlugin = function() {
  return (root2) => {
    visit(root2, (node, info) => {
      if (node.type !== "element" && node.type !== "root") {
        return;
      }
      if (isElement(node) && !(PAR_ELEMENTS.has(node.name) || ALWAYS_BREAK_ELEMENTS.has(node.name))) {
        return;
      }
      const firstChild = node.children[0];
      const lastChild = node.children[node.children.length - 1];
      if (firstChild?.type === "text") {
        firstChild.value = firstChild.value.trimStart();
      }
      if (lastChild?.type === "text") {
        lastChild.value = lastChild.value.trimEnd();
      }
    });
  };
};
const normalizeDoenetMlPlugin = function() {
  const processor = unified().use(expandCdataPlugin).use(mergeAdjacentTextPlugin).use(mergeWhitespacePlugin).use(removeInternodeWhitespacePlugin).use(trimWhitespacePlugin).use(removeEmptyTextNodesPlugin);
  return (root2, file) => {
    const processed = processor.runSync(root2, file);
    return processed;
  };
};
function normalize(root2) {
  const processor = unified().use(normalizeDoenetMlPlugin);
  return processor.runSync(root2);
}
var __defProp = Object.defineProperty;
var __export = (target, all2) => {
  for (var name2 in all2)
    __defProp(target, name2, { get: all2[name2], enumerable: true });
};
var public_exports = {};
__export(public_exports, {
  builders: () => builders,
  printer: () => printer,
  utils: () => utils
});
var OPTIONAL_OBJECT = 1;
var createMethodShim = (methodName, getImplementation) => (flags, object2, ...arguments_) => {
  if (flags | OPTIONAL_OBJECT && (object2 === void 0 || object2 === null)) {
    return;
  }
  const implementation = getImplementation.call(object2) ?? object2[methodName];
  return implementation.apply(object2, arguments_);
};
function stringOrArrayAt(index2) {
  return this[index2 < 0 ? this.length + index2 : index2];
}
var at = createMethodShim("at", function() {
  if (Array.isArray(this) || typeof this === "string") {
    return stringOrArrayAt;
  }
});
var method_at_default = at;
var noop = () => {
};
var noop_default = noop;
var DOC_TYPE_STRING = (
  /** @type {const} */
  "string"
);
var DOC_TYPE_ARRAY = (
  /** @type {const} */
  "array"
);
var DOC_TYPE_CURSOR = (
  /** @type {const} */
  "cursor"
);
var DOC_TYPE_INDENT = (
  /** @type {const} */
  "indent"
);
var DOC_TYPE_ALIGN = (
  /** @type {const} */
  "align"
);
var DOC_TYPE_TRIM = (
  /** @type {const} */
  "trim"
);
var DOC_TYPE_GROUP = (
  /** @type {const} */
  "group"
);
var DOC_TYPE_FILL = (
  /** @type {const} */
  "fill"
);
var DOC_TYPE_IF_BREAK = (
  /** @type {const} */
  "if-break"
);
var DOC_TYPE_INDENT_IF_BREAK = (
  /** @type {const} */
  "indent-if-break"
);
var DOC_TYPE_LINE_SUFFIX = (
  /** @type {const} */
  "line-suffix"
);
var DOC_TYPE_LINE_SUFFIX_BOUNDARY = (
  /** @type {const} */
  "line-suffix-boundary"
);
var DOC_TYPE_LINE = (
  /** @type {const} */
  "line"
);
var DOC_TYPE_LABEL = (
  /** @type {const} */
  "label"
);
var DOC_TYPE_BREAK_PARENT = (
  /** @type {const} */
  "break-parent"
);
var VALID_OBJECT_DOC_TYPES = /* @__PURE__ */ new Set([
  DOC_TYPE_CURSOR,
  DOC_TYPE_INDENT,
  DOC_TYPE_ALIGN,
  DOC_TYPE_TRIM,
  DOC_TYPE_GROUP,
  DOC_TYPE_FILL,
  DOC_TYPE_IF_BREAK,
  DOC_TYPE_INDENT_IF_BREAK,
  DOC_TYPE_LINE_SUFFIX,
  DOC_TYPE_LINE_SUFFIX_BOUNDARY,
  DOC_TYPE_LINE,
  DOC_TYPE_LABEL,
  DOC_TYPE_BREAK_PARENT
]);
function trimNewlinesEnd(string2) {
  let end = string2.length;
  while (end > 0 && (string2[end - 1] === "\r" || string2[end - 1] === "\n")) {
    end--;
  }
  return end < string2.length ? string2.slice(0, end) : string2;
}
function getDocType(doc2) {
  if (typeof doc2 === "string") {
    return DOC_TYPE_STRING;
  }
  if (Array.isArray(doc2)) {
    return DOC_TYPE_ARRAY;
  }
  if (!doc2) {
    return;
  }
  const { type } = doc2;
  if (VALID_OBJECT_DOC_TYPES.has(type)) {
    return type;
  }
}
var get_doc_type_default = getDocType;
var disjunctionListFormat = (list2) => new Intl.ListFormat("en-US", { type: "disjunction" }).format(list2);
function getDocErrorMessage(doc2) {
  const type = doc2 === null ? "null" : typeof doc2;
  if (type !== "string" && type !== "object") {
    return `Unexpected doc '${type}', 
Expected it to be 'string' or 'object'.`;
  }
  if (get_doc_type_default(doc2)) {
    throw new Error("doc is valid.");
  }
  const objectType = Object.prototype.toString.call(doc2);
  if (objectType !== "[object Object]") {
    return `Unexpected doc '${objectType}'.`;
  }
  const EXPECTED_TYPE_VALUES = disjunctionListFormat(
    [...VALID_OBJECT_DOC_TYPES].map((type2) => `'${type2}'`)
  );
  return `Unexpected doc.type '${doc2.type}'.
Expected it to be ${EXPECTED_TYPE_VALUES}.`;
}
var InvalidDocError = class extends Error {
  name = "InvalidDocError";
  constructor(doc2) {
    super(getDocErrorMessage(doc2));
    this.doc = doc2;
  }
};
var invalid_doc_error_default = InvalidDocError;
var traverseDocOnExitStackMarker = {};
function traverseDoc(doc2, onEnter, onExit, shouldTraverseConditionalGroups) {
  const docsStack = [doc2];
  while (docsStack.length > 0) {
    const doc22 = docsStack.pop();
    if (doc22 === traverseDocOnExitStackMarker) {
      onExit(docsStack.pop());
      continue;
    }
    if (onExit) {
      docsStack.push(doc22, traverseDocOnExitStackMarker);
    }
    const docType = get_doc_type_default(doc22);
    if (!docType) {
      throw new invalid_doc_error_default(doc22);
    }
    if (onEnter?.(doc22) === false) {
      continue;
    }
    switch (docType) {
      case DOC_TYPE_ARRAY:
      case DOC_TYPE_FILL: {
        const parts = docType === DOC_TYPE_ARRAY ? doc22 : doc22.parts;
        for (let ic = parts.length, i2 = ic - 1; i2 >= 0; --i2) {
          docsStack.push(parts[i2]);
        }
        break;
      }
      case DOC_TYPE_IF_BREAK:
        docsStack.push(doc22.flatContents, doc22.breakContents);
        break;
      case DOC_TYPE_GROUP:
        if (shouldTraverseConditionalGroups && doc22.expandedStates) {
          for (let ic = doc22.expandedStates.length, i2 = ic - 1; i2 >= 0; --i2) {
            docsStack.push(doc22.expandedStates[i2]);
          }
        } else {
          docsStack.push(doc22.contents);
        }
        break;
      case DOC_TYPE_ALIGN:
      case DOC_TYPE_INDENT:
      case DOC_TYPE_INDENT_IF_BREAK:
      case DOC_TYPE_LABEL:
      case DOC_TYPE_LINE_SUFFIX:
        docsStack.push(doc22.contents);
        break;
      case DOC_TYPE_STRING:
      case DOC_TYPE_CURSOR:
      case DOC_TYPE_TRIM:
      case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
      case DOC_TYPE_LINE:
      case DOC_TYPE_BREAK_PARENT:
        break;
      default:
        throw new invalid_doc_error_default(doc22);
    }
  }
}
var traverse_doc_default = traverseDoc;
function mapDoc(doc2, cb2) {
  if (typeof doc2 === "string") {
    return cb2(doc2);
  }
  const mapped = /* @__PURE__ */ new Map();
  return rec(doc2);
  function rec(doc22) {
    if (mapped.has(doc22)) {
      return mapped.get(doc22);
    }
    const result2 = process2(doc22);
    mapped.set(doc22, result2);
    return result2;
  }
  function process2(doc22) {
    switch (get_doc_type_default(doc22)) {
      case DOC_TYPE_ARRAY:
        return cb2(doc22.map(rec));
      case DOC_TYPE_FILL:
        return cb2({
          ...doc22,
          parts: doc22.parts.map(rec)
        });
      case DOC_TYPE_IF_BREAK:
        return cb2({
          ...doc22,
          breakContents: rec(doc22.breakContents),
          flatContents: rec(doc22.flatContents)
        });
      case DOC_TYPE_GROUP: {
        let {
          expandedStates,
          contents
        } = doc22;
        if (expandedStates) {
          expandedStates = expandedStates.map(rec);
          contents = expandedStates[0];
        } else {
          contents = rec(contents);
        }
        return cb2({
          ...doc22,
          contents,
          expandedStates
        });
      }
      case DOC_TYPE_ALIGN:
      case DOC_TYPE_INDENT:
      case DOC_TYPE_INDENT_IF_BREAK:
      case DOC_TYPE_LABEL:
      case DOC_TYPE_LINE_SUFFIX:
        return cb2({
          ...doc22,
          contents: rec(doc22.contents)
        });
      case DOC_TYPE_STRING:
      case DOC_TYPE_CURSOR:
      case DOC_TYPE_TRIM:
      case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
      case DOC_TYPE_LINE:
      case DOC_TYPE_BREAK_PARENT:
        return cb2(doc22);
      default:
        throw new invalid_doc_error_default(doc22);
    }
  }
}
function findInDoc(doc2, fn, defaultValue2) {
  let result2 = defaultValue2;
  let shouldSkipFurtherProcessing = false;
  function findInDocOnEnterFn(doc22) {
    if (shouldSkipFurtherProcessing) {
      return false;
    }
    const maybeResult = fn(doc22);
    if (maybeResult !== void 0) {
      shouldSkipFurtherProcessing = true;
      result2 = maybeResult;
    }
  }
  traverse_doc_default(doc2, findInDocOnEnterFn);
  return result2;
}
function willBreakFn(doc2) {
  if (doc2.type === DOC_TYPE_GROUP && doc2.break) {
    return true;
  }
  if (doc2.type === DOC_TYPE_LINE && doc2.hard) {
    return true;
  }
  if (doc2.type === DOC_TYPE_BREAK_PARENT) {
    return true;
  }
}
function willBreak(doc2) {
  return findInDoc(doc2, willBreakFn, false);
}
function breakParentGroup(groupStack) {
  if (groupStack.length > 0) {
    const parentGroup = method_at_default(
      /* OPTIONAL_OBJECT: false */
      0,
      groupStack,
      -1
    );
    if (!parentGroup.expandedStates && !parentGroup.break) {
      parentGroup.break = "propagated";
    }
  }
  return null;
}
function propagateBreaks(doc2) {
  const alreadyVisitedSet = /* @__PURE__ */ new Set();
  const groupStack = [];
  function propagateBreaksOnEnterFn(doc22) {
    if (doc22.type === DOC_TYPE_BREAK_PARENT) {
      breakParentGroup(groupStack);
    }
    if (doc22.type === DOC_TYPE_GROUP) {
      groupStack.push(doc22);
      if (alreadyVisitedSet.has(doc22)) {
        return false;
      }
      alreadyVisitedSet.add(doc22);
    }
  }
  function propagateBreaksOnExitFn(doc22) {
    if (doc22.type === DOC_TYPE_GROUP) {
      const group2 = groupStack.pop();
      if (group2.break) {
        breakParentGroup(groupStack);
      }
    }
  }
  traverse_doc_default(
    doc2,
    propagateBreaksOnEnterFn,
    propagateBreaksOnExitFn,
    /* shouldTraverseConditionalGroups */
    true
  );
}
function removeLinesFn(doc2) {
  if (doc2.type === DOC_TYPE_LINE && !doc2.hard) {
    return doc2.soft ? "" : " ";
  }
  if (doc2.type === DOC_TYPE_IF_BREAK) {
    return doc2.flatContents;
  }
  return doc2;
}
function removeLines(doc2) {
  return mapDoc(doc2, removeLinesFn);
}
function stripTrailingHardlineFromParts(parts) {
  parts = [...parts];
  while (parts.length >= 2 && method_at_default(
    /* OPTIONAL_OBJECT: false */
    0,
    parts,
    -2
  ).type === DOC_TYPE_LINE && method_at_default(
    /* OPTIONAL_OBJECT: false */
    0,
    parts,
    -1
  ).type === DOC_TYPE_BREAK_PARENT) {
    parts.length -= 2;
  }
  if (parts.length > 0) {
    const lastPart = stripTrailingHardlineFromDoc(method_at_default(
      /* OPTIONAL_OBJECT: false */
      0,
      parts,
      -1
    ));
    parts[parts.length - 1] = lastPart;
  }
  return parts;
}
function stripTrailingHardlineFromDoc(doc2) {
  switch (get_doc_type_default(doc2)) {
    case DOC_TYPE_INDENT:
    case DOC_TYPE_INDENT_IF_BREAK:
    case DOC_TYPE_GROUP:
    case DOC_TYPE_LINE_SUFFIX:
    case DOC_TYPE_LABEL: {
      const contents = stripTrailingHardlineFromDoc(doc2.contents);
      return {
        ...doc2,
        contents
      };
    }
    case DOC_TYPE_IF_BREAK:
      return {
        ...doc2,
        breakContents: stripTrailingHardlineFromDoc(doc2.breakContents),
        flatContents: stripTrailingHardlineFromDoc(doc2.flatContents)
      };
    case DOC_TYPE_FILL:
      return {
        ...doc2,
        parts: stripTrailingHardlineFromParts(doc2.parts)
      };
    case DOC_TYPE_ARRAY:
      return stripTrailingHardlineFromParts(doc2);
    case DOC_TYPE_STRING:
      return trimNewlinesEnd(doc2);
    case DOC_TYPE_ALIGN:
    case DOC_TYPE_CURSOR:
    case DOC_TYPE_TRIM:
    case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
    case DOC_TYPE_LINE:
    case DOC_TYPE_BREAK_PARENT:
      break;
    default:
      throw new invalid_doc_error_default(doc2);
  }
  return doc2;
}
function stripTrailingHardline(doc2) {
  return stripTrailingHardlineFromDoc(cleanDoc(doc2));
}
function cleanDocFn(doc2) {
  switch (get_doc_type_default(doc2)) {
    case DOC_TYPE_FILL:
      if (doc2.parts.every((part) => part === "")) {
        return "";
      }
      break;
    case DOC_TYPE_GROUP:
      if (!doc2.contents && !doc2.id && !doc2.break && !doc2.expandedStates) {
        return "";
      }
      if (doc2.contents.type === DOC_TYPE_GROUP && doc2.contents.id === doc2.id && doc2.contents.break === doc2.break && doc2.contents.expandedStates === doc2.expandedStates) {
        return doc2.contents;
      }
      break;
    case DOC_TYPE_ALIGN:
    case DOC_TYPE_INDENT:
    case DOC_TYPE_INDENT_IF_BREAK:
    case DOC_TYPE_LINE_SUFFIX:
      if (!doc2.contents) {
        return "";
      }
      break;
    case DOC_TYPE_IF_BREAK:
      if (!doc2.flatContents && !doc2.breakContents) {
        return "";
      }
      break;
    case DOC_TYPE_ARRAY: {
      const parts = [];
      for (const part of doc2) {
        if (!part) {
          continue;
        }
        const [currentPart, ...restParts] = Array.isArray(part) ? part : [part];
        if (typeof currentPart === "string" && typeof method_at_default(
          /* OPTIONAL_OBJECT: false */
          0,
          parts,
          -1
        ) === "string") {
          parts[parts.length - 1] += currentPart;
        } else {
          parts.push(currentPart);
        }
        parts.push(...restParts);
      }
      if (parts.length === 0) {
        return "";
      }
      if (parts.length === 1) {
        return parts[0];
      }
      return parts;
    }
    case DOC_TYPE_STRING:
    case DOC_TYPE_CURSOR:
    case DOC_TYPE_TRIM:
    case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
    case DOC_TYPE_LINE:
    case DOC_TYPE_LABEL:
    case DOC_TYPE_BREAK_PARENT:
      break;
    default:
      throw new invalid_doc_error_default(doc2);
  }
  return doc2;
}
function cleanDoc(doc2) {
  return mapDoc(doc2, (currentDoc) => cleanDocFn(currentDoc));
}
function replaceEndOfLine(doc2, replacement = literalline) {
  return mapDoc(doc2, (currentDoc) => typeof currentDoc === "string" ? join$1(replacement, currentDoc.split("\n")) : currentDoc);
}
function canBreakFn(doc2) {
  if (doc2.type === DOC_TYPE_LINE) {
    return true;
  }
}
function canBreak(doc2) {
  return findInDoc(doc2, canBreakFn, false);
}
var assertDocArray = noop_default;
function indent$1(contents) {
  return { type: DOC_TYPE_INDENT, contents };
}
function align(alignType, contents) {
  return { type: DOC_TYPE_ALIGN, contents, n: alignType };
}
function dedentToRoot(contents) {
  return align(Number.NEGATIVE_INFINITY, contents);
}
function markAsRoot(contents) {
  return align({ type: "root" }, contents);
}
function dedent(contents) {
  return align(-1, contents);
}
function addAlignmentToDoc(doc2, size2, tabWidth) {
  let aligned = doc2;
  if (size2 > 0) {
    for (let level = 0; level < Math.floor(size2 / tabWidth); ++level) {
      aligned = indent$1(aligned);
    }
    aligned = align(size2 % tabWidth, aligned);
    aligned = align(Number.NEGATIVE_INFINITY, aligned);
  }
  return aligned;
}
var breakParent$1 = { type: DOC_TYPE_BREAK_PARENT };
var cursor = { type: DOC_TYPE_CURSOR };
function fill$1(parts) {
  return { type: DOC_TYPE_FILL, parts };
}
function group$1(contents, options2 = {}) {
  assertDocArray(
    options2.expandedStates
  );
  return {
    type: DOC_TYPE_GROUP,
    id: options2.id,
    contents,
    break: Boolean(options2.shouldBreak),
    expandedStates: options2.expandedStates
  };
}
function conditionalGroup(states, options2) {
  return group$1(states[0], { ...options2, expandedStates: states });
}
function ifBreak(breakContents, flatContents = "", options2 = {}) {
  return {
    type: DOC_TYPE_IF_BREAK,
    breakContents,
    flatContents,
    groupId: options2.groupId
  };
}
function indentIfBreak(contents, options2) {
  return {
    type: DOC_TYPE_INDENT_IF_BREAK,
    contents,
    groupId: options2.groupId,
    negate: options2.negate
  };
}
function join$1(separator, docs) {
  const parts = [];
  for (let i2 = 0; i2 < docs.length; i2++) {
    if (i2 !== 0) {
      parts.push(separator);
    }
    parts.push(docs[i2]);
  }
  return parts;
}
function label(label2, contents) {
  return label2 ? { type: DOC_TYPE_LABEL, label: label2, contents } : contents;
}
var line$1 = { type: DOC_TYPE_LINE };
var softline$1 = { type: DOC_TYPE_LINE, soft: true };
var hardlineWithoutBreakParent = { type: DOC_TYPE_LINE, hard: true };
var hardline$1 = [hardlineWithoutBreakParent, breakParent$1];
var literallineWithoutBreakParent = {
  type: DOC_TYPE_LINE,
  hard: true,
  literal: true
};
var literalline = [literallineWithoutBreakParent, breakParent$1];
function lineSuffix(contents) {
  return { type: DOC_TYPE_LINE_SUFFIX, contents };
}
var lineSuffixBoundary = { type: DOC_TYPE_LINE_SUFFIX_BOUNDARY };
var trim = { type: DOC_TYPE_TRIM };
var stringReplaceAll = String.prototype.replaceAll ?? function(pattern, replacement) {
  if (pattern.global) {
    return this.replace(pattern, replacement);
  }
  return this.split(pattern).join(replacement);
};
var replaceAll = createMethodShim("replaceAll", function() {
  if (typeof this === "string") {
    return stringReplaceAll;
  }
});
var method_replace_all_default = replaceAll;
var OPTION_CR = "cr";
var OPTION_CRLF = "crlf";
var CHARACTER_CR = "\r";
var CHARACTER_CRLF = "\r\n";
var CHARACTER_LF = "\n";
var DEFAULT_EOL = CHARACTER_LF;
function convertEndOfLineOptionToCharacter(endOfLineOption) {
  return endOfLineOption === OPTION_CR ? CHARACTER_CR : endOfLineOption === OPTION_CRLF ? CHARACTER_CRLF : DEFAULT_EOL;
}
var emoji_regex_default = () => {
  return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED8\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])))?))?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE8A\uDE8E-\uDEC2\uDEC6\uDEC8\uDECD-\uDEDC\uDEDF-\uDEEA\uDEEF]|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
};
function isFullWidth(x2) {
  return x2 === 12288 || x2 >= 65281 && x2 <= 65376 || x2 >= 65504 && x2 <= 65510;
}
function isWide(x2) {
  return x2 >= 4352 && x2 <= 4447 || x2 === 8986 || x2 === 8987 || x2 === 9001 || x2 === 9002 || x2 >= 9193 && x2 <= 9196 || x2 === 9200 || x2 === 9203 || x2 === 9725 || x2 === 9726 || x2 === 9748 || x2 === 9749 || x2 >= 9776 && x2 <= 9783 || x2 >= 9800 && x2 <= 9811 || x2 === 9855 || x2 >= 9866 && x2 <= 9871 || x2 === 9875 || x2 === 9889 || x2 === 9898 || x2 === 9899 || x2 === 9917 || x2 === 9918 || x2 === 9924 || x2 === 9925 || x2 === 9934 || x2 === 9940 || x2 === 9962 || x2 === 9970 || x2 === 9971 || x2 === 9973 || x2 === 9978 || x2 === 9981 || x2 === 9989 || x2 === 9994 || x2 === 9995 || x2 === 10024 || x2 === 10060 || x2 === 10062 || x2 >= 10067 && x2 <= 10069 || x2 === 10071 || x2 >= 10133 && x2 <= 10135 || x2 === 10160 || x2 === 10175 || x2 === 11035 || x2 === 11036 || x2 === 11088 || x2 === 11093 || x2 >= 11904 && x2 <= 11929 || x2 >= 11931 && x2 <= 12019 || x2 >= 12032 && x2 <= 12245 || x2 >= 12272 && x2 <= 12287 || x2 >= 12289 && x2 <= 12350 || x2 >= 12353 && x2 <= 12438 || x2 >= 12441 && x2 <= 12543 || x2 >= 12549 && x2 <= 12591 || x2 >= 12593 && x2 <= 12686 || x2 >= 12688 && x2 <= 12773 || x2 >= 12783 && x2 <= 12830 || x2 >= 12832 && x2 <= 12871 || x2 >= 12880 && x2 <= 42124 || x2 >= 42128 && x2 <= 42182 || x2 >= 43360 && x2 <= 43388 || x2 >= 44032 && x2 <= 55203 || x2 >= 63744 && x2 <= 64255 || x2 >= 65040 && x2 <= 65049 || x2 >= 65072 && x2 <= 65106 || x2 >= 65108 && x2 <= 65126 || x2 >= 65128 && x2 <= 65131 || x2 >= 94176 && x2 <= 94180 || x2 >= 94192 && x2 <= 94198 || x2 >= 94208 && x2 <= 101589 || x2 >= 101631 && x2 <= 101662 || x2 >= 101760 && x2 <= 101874 || x2 >= 110576 && x2 <= 110579 || x2 >= 110581 && x2 <= 110587 || x2 === 110589 || x2 === 110590 || x2 >= 110592 && x2 <= 110882 || x2 === 110898 || x2 >= 110928 && x2 <= 110930 || x2 === 110933 || x2 >= 110948 && x2 <= 110951 || x2 >= 110960 && x2 <= 111355 || x2 >= 119552 && x2 <= 119638 || x2 >= 119648 && x2 <= 119670 || x2 === 126980 || x2 === 127183 || x2 === 127374 || x2 >= 127377 && x2 <= 127386 || x2 >= 127488 && x2 <= 127490 || x2 >= 127504 && x2 <= 127547 || x2 >= 127552 && x2 <= 127560 || x2 === 127568 || x2 === 127569 || x2 >= 127584 && x2 <= 127589 || x2 >= 127744 && x2 <= 127776 || x2 >= 127789 && x2 <= 127797 || x2 >= 127799 && x2 <= 127868 || x2 >= 127870 && x2 <= 127891 || x2 >= 127904 && x2 <= 127946 || x2 >= 127951 && x2 <= 127955 || x2 >= 127968 && x2 <= 127984 || x2 === 127988 || x2 >= 127992 && x2 <= 128062 || x2 === 128064 || x2 >= 128066 && x2 <= 128252 || x2 >= 128255 && x2 <= 128317 || x2 >= 128331 && x2 <= 128334 || x2 >= 128336 && x2 <= 128359 || x2 === 128378 || x2 === 128405 || x2 === 128406 || x2 === 128420 || x2 >= 128507 && x2 <= 128591 || x2 >= 128640 && x2 <= 128709 || x2 === 128716 || x2 >= 128720 && x2 <= 128722 || x2 >= 128725 && x2 <= 128728 || x2 >= 128732 && x2 <= 128735 || x2 === 128747 || x2 === 128748 || x2 >= 128756 && x2 <= 128764 || x2 >= 128992 && x2 <= 129003 || x2 === 129008 || x2 >= 129292 && x2 <= 129338 || x2 >= 129340 && x2 <= 129349 || x2 >= 129351 && x2 <= 129535 || x2 >= 129648 && x2 <= 129660 || x2 >= 129664 && x2 <= 129674 || x2 >= 129678 && x2 <= 129734 || x2 === 129736 || x2 >= 129741 && x2 <= 129756 || x2 >= 129759 && x2 <= 129770 || x2 >= 129775 && x2 <= 129784 || x2 >= 131072 && x2 <= 196605 || x2 >= 196608 && x2 <= 262141;
}
var narrow_emojis_evaluate_default = "©®‼⁉™ℹ↔↕↖↗↘↙↩↪⌨⏏⏱⏲⏸⏹⏺▪▫▶◀◻◼☀☁☂☃☄☎☑☘☝☠☢☣☦☪☮☯☸☹☺♀♂♟♠♣♥♦♨♻♾⚒⚔⚕⚖⚗⚙⚛⚜⚠⚧⚰⚱⛈⛏⛑⛓⛩⛱⛷⛸⛹✂✈✉✌✍✏✒✔✖✝✡✳✴❄❇❣❤➡⤴⤵⬅⬆⬇";
var notAsciiRegex = /[^\x20-\x7F]/u;
var narrowEmojisSet = new Set(narrow_emojis_evaluate_default);
function getStringWidth(text2) {
  if (!text2) {
    return 0;
  }
  if (!notAsciiRegex.test(text2)) {
    return text2.length;
  }
  text2 = text2.replace(
    emoji_regex_default(),
    (match2) => narrowEmojisSet.has(match2) ? " " : "  "
  );
  let width = 0;
  for (const character of text2) {
    const codePoint = character.codePointAt(0);
    if (codePoint <= 31 || codePoint >= 127 && codePoint <= 159) {
      continue;
    }
    if (codePoint >= 768 && codePoint <= 879) {
      continue;
    }
    if (codePoint >= 65024 && codePoint <= 65039) {
      continue;
    }
    width += isFullWidth(codePoint) || isWide(codePoint) ? 2 : 1;
  }
  return width;
}
var get_string_width_default = getStringWidth;
var INDENT_COMMAND_TYPE_INDENT = 0;
var INDENT_COMMAND_TYPE_DEDENT = 1;
var INDENT_COMMAND_TYPE_WIDTH = 2;
var INDENT_COMMAND_TYPE_STRING = 3;
var INDENT_COMMAND_INDENT = { type: INDENT_COMMAND_TYPE_INDENT };
var INDENT_COMMAND_DEDENT = { type: INDENT_COMMAND_TYPE_DEDENT };
var ROOT_INDENT = {
  value: "",
  length: 0,
  queue: [],
  get root() {
    return ROOT_INDENT;
  }
};
function generateIndent(indent2, command2, options2) {
  const queue2 = command2.type === INDENT_COMMAND_TYPE_DEDENT ? indent2.queue.slice(0, -1) : [...indent2.queue, command2];
  let value = "";
  let length = 0;
  let lastTabs = 0;
  let lastSpaces = 0;
  for (const command22 of queue2) {
    switch (command22.type) {
      case INDENT_COMMAND_TYPE_INDENT:
        flush();
        if (options2.useTabs) {
          addTabs(1);
        } else {
          addSpaces(options2.tabWidth);
        }
        break;
      case INDENT_COMMAND_TYPE_STRING: {
        const { string: string2 } = command22;
        flush();
        value += string2;
        length += string2.length;
        break;
      }
      case INDENT_COMMAND_TYPE_WIDTH: {
        const { width } = command22;
        lastTabs += 1;
        lastSpaces += width;
        break;
      }
      default:
        throw new Error(`Unexpected indent comment '${command22.type}'.`);
    }
  }
  flushSpaces();
  return { ...indent2, value, length, queue: queue2 };
  function addTabs(count) {
    value += "	".repeat(count);
    length += options2.tabWidth * count;
  }
  function addSpaces(count) {
    value += " ".repeat(count);
    length += count;
  }
  function flush() {
    if (options2.useTabs) {
      flushTabs();
    } else {
      flushSpaces();
    }
  }
  function flushTabs() {
    if (lastTabs > 0) {
      addTabs(lastTabs);
    }
    resetLast();
  }
  function flushSpaces() {
    if (lastSpaces > 0) {
      addSpaces(lastSpaces);
    }
    resetLast();
  }
  function resetLast() {
    lastTabs = 0;
    lastSpaces = 0;
  }
}
function makeAlign(indent2, indentOptions, options2) {
  if (!indentOptions) {
    return indent2;
  }
  if (indentOptions.type === "root") {
    return { ...indent2, root: indent2 };
  }
  if (indentOptions === Number.NEGATIVE_INFINITY) {
    return indent2.root;
  }
  let command2;
  if (typeof indentOptions === "number") {
    if (indentOptions < 0) {
      command2 = INDENT_COMMAND_DEDENT;
    } else {
      command2 = { type: INDENT_COMMAND_TYPE_WIDTH, width: indentOptions };
    }
  } else {
    command2 = { type: INDENT_COMMAND_TYPE_STRING, string: indentOptions };
  }
  return generateIndent(indent2, command2, options2);
}
function makeIndent(indent2, options2) {
  return generateIndent(indent2, INDENT_COMMAND_INDENT, options2);
}
function getTrailingIndentionLength(text2) {
  let length = 0;
  for (let index2 = text2.length - 1; index2 >= 0; index2--) {
    const character = text2[index2];
    if (character === " " || character === "	") {
      length++;
    } else {
      break;
    }
  }
  return length;
}
function trimIndentation(text2) {
  const length = getTrailingIndentionLength(text2);
  const trimmed = length === 0 ? text2 : text2.slice(0, text2.length - length);
  return { text: trimmed, count: length };
}
var MODE_BREAK = Symbol("MODE_BREAK");
var MODE_FLAT = Symbol("MODE_FLAT");
var DOC_FILL_PRINTED_LENGTH = Symbol("DOC_FILL_PRINTED_LENGTH");
function fits(next, restCommands, remainingWidth, hasLineSuffix, groupModeMap, mustBeFlat) {
  if (remainingWidth === Number.POSITIVE_INFINITY) {
    return true;
  }
  let restCommandsIndex = restCommands.length;
  let hasPendingSpace = false;
  const commands = [next];
  let output = "";
  while (remainingWidth >= 0) {
    if (commands.length === 0) {
      if (restCommandsIndex === 0) {
        return true;
      }
      commands.push(restCommands[--restCommandsIndex]);
      continue;
    }
    const {
      mode,
      doc: doc2
    } = commands.pop();
    const docType = get_doc_type_default(doc2);
    switch (docType) {
      case DOC_TYPE_STRING:
        if (doc2) {
          if (hasPendingSpace) {
            output += " ";
            remainingWidth -= 1;
            hasPendingSpace = false;
          }
          output += doc2;
          remainingWidth -= get_string_width_default(doc2);
        }
        break;
      case DOC_TYPE_ARRAY:
      case DOC_TYPE_FILL: {
        const parts = docType === DOC_TYPE_ARRAY ? doc2 : doc2.parts;
        const end = doc2[DOC_FILL_PRINTED_LENGTH] ?? 0;
        for (let index2 = parts.length - 1; index2 >= end; index2--) {
          commands.push({
            mode,
            doc: parts[index2]
          });
        }
        break;
      }
      case DOC_TYPE_INDENT:
      case DOC_TYPE_ALIGN:
      case DOC_TYPE_INDENT_IF_BREAK:
      case DOC_TYPE_LABEL:
        commands.push({
          mode,
          doc: doc2.contents
        });
        break;
      case DOC_TYPE_TRIM: {
        const {
          text: text2,
          count
        } = trimIndentation(output);
        output = text2;
        remainingWidth += count;
        break;
      }
      case DOC_TYPE_GROUP: {
        if (mustBeFlat && doc2.break) {
          return false;
        }
        const groupMode = doc2.break ? MODE_BREAK : mode;
        const contents = doc2.expandedStates && groupMode === MODE_BREAK ? method_at_default(
          /* OPTIONAL_OBJECT: false */
          0,
          doc2.expandedStates,
          -1
        ) : doc2.contents;
        commands.push({
          mode: groupMode,
          doc: contents
        });
        break;
      }
      case DOC_TYPE_IF_BREAK: {
        const groupMode = doc2.groupId ? groupModeMap[doc2.groupId] || MODE_FLAT : mode;
        const contents = groupMode === MODE_BREAK ? doc2.breakContents : doc2.flatContents;
        if (contents) {
          commands.push({
            mode,
            doc: contents
          });
        }
        break;
      }
      case DOC_TYPE_LINE:
        if (mode === MODE_BREAK || doc2.hard) {
          return true;
        }
        if (!doc2.soft) {
          hasPendingSpace = true;
        }
        break;
      case DOC_TYPE_LINE_SUFFIX:
        hasLineSuffix = true;
        break;
      case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
        if (hasLineSuffix) {
          return false;
        }
        break;
    }
  }
  return false;
}
function printDocToString(doc2, options2) {
  const groupModeMap = /* @__PURE__ */ Object.create(null);
  const width = options2.printWidth;
  const newLine = convertEndOfLineOptionToCharacter(options2.endOfLine);
  let position2 = 0;
  const commands = [{
    indent: ROOT_INDENT,
    mode: MODE_BREAK,
    doc: doc2
  }];
  let output = "";
  let shouldRemeasure = false;
  const lineSuffix2 = [];
  const cursorPositions = [];
  const settledOutput = [];
  const settledCursorPositions = [];
  let settledTextLength = 0;
  propagateBreaks(doc2);
  while (commands.length > 0) {
    const {
      indent: indent2,
      mode,
      doc: doc22
    } = commands.pop();
    switch (get_doc_type_default(doc22)) {
      case DOC_TYPE_STRING: {
        const formatted2 = newLine !== "\n" ? method_replace_all_default(
          /* OPTIONAL_OBJECT: false */
          0,
          doc22,
          "\n",
          newLine
        ) : doc22;
        if (formatted2) {
          output += formatted2;
          if (commands.length > 0) {
            position2 += get_string_width_default(formatted2);
          }
        }
        break;
      }
      case DOC_TYPE_ARRAY:
        for (let index2 = doc22.length - 1; index2 >= 0; index2--) {
          commands.push({
            indent: indent2,
            mode,
            doc: doc22[index2]
          });
        }
        break;
      case DOC_TYPE_CURSOR:
        if (cursorPositions.length >= 2) {
          throw new Error("There are too many 'cursor' in doc.");
        }
        cursorPositions.push(settledTextLength + output.length);
        break;
      case DOC_TYPE_INDENT:
        commands.push({
          indent: makeIndent(indent2, options2),
          mode,
          doc: doc22.contents
        });
        break;
      case DOC_TYPE_ALIGN:
        commands.push({
          indent: makeAlign(indent2, doc22.n, options2),
          mode,
          doc: doc22.contents
        });
        break;
      case DOC_TYPE_TRIM:
        trim2();
        break;
      case DOC_TYPE_GROUP:
        switch (mode) {
          case MODE_FLAT:
            if (!shouldRemeasure) {
              commands.push({
                indent: indent2,
                mode: doc22.break ? MODE_BREAK : MODE_FLAT,
                doc: doc22.contents
              });
              break;
            }
          // fallthrough
          case MODE_BREAK: {
            shouldRemeasure = false;
            const next = {
              indent: indent2,
              mode: MODE_FLAT,
              doc: doc22.contents
            };
            const remainingWidth = width - position2;
            const hasLineSuffix = lineSuffix2.length > 0;
            if (!doc22.break && fits(next, commands, remainingWidth, hasLineSuffix, groupModeMap)) {
              commands.push(next);
            } else {
              if (doc22.expandedStates) {
                const mostExpanded = method_at_default(
                  /* OPTIONAL_OBJECT: false */
                  0,
                  doc22.expandedStates,
                  -1
                );
                if (doc22.break) {
                  commands.push({
                    indent: indent2,
                    mode: MODE_BREAK,
                    doc: mostExpanded
                  });
                  break;
                } else {
                  for (let index2 = 1; index2 < doc22.expandedStates.length + 1; index2++) {
                    if (index2 >= doc22.expandedStates.length) {
                      commands.push({
                        indent: indent2,
                        mode: MODE_BREAK,
                        doc: mostExpanded
                      });
                      break;
                    } else {
                      const state = doc22.expandedStates[index2];
                      const cmd2 = {
                        indent: indent2,
                        mode: MODE_FLAT,
                        doc: state
                      };
                      if (fits(cmd2, commands, remainingWidth, hasLineSuffix, groupModeMap)) {
                        commands.push(cmd2);
                        break;
                      }
                    }
                  }
                }
              } else {
                commands.push({
                  indent: indent2,
                  mode: MODE_BREAK,
                  doc: doc22.contents
                });
              }
            }
            break;
          }
        }
        if (doc22.id) {
          groupModeMap[doc22.id] = method_at_default(
            /* OPTIONAL_OBJECT: false */
            0,
            commands,
            -1
          ).mode;
        }
        break;
      // Fills each line with as much code as possible before moving to a new
      // line with the same indentation.
      //
      // Expects doc.parts to be an array of alternating content and
      // whitespace. The whitespace contains the linebreaks.
      //
      // For example:
      //   ["I", line, "love", line, "monkeys"]
      // or
      //   [{ type: group, ... }, softline, { type: group, ... }]
      //
      // It uses this parts structure to handle three main layout cases:
      // * The first two content items fit on the same line without
      //   breaking
      //   -> output the first content item and the whitespace "flat".
      // * Only the first content item fits on the line without breaking
      //   -> output the first content item "flat" and the whitespace with
      //   "break".
      // * Neither content item fits on the line without breaking
      //   -> output the first content item and the whitespace with "break".
      case DOC_TYPE_FILL: {
        const remainingWidth = width - position2;
        const offset2 = doc22[DOC_FILL_PRINTED_LENGTH] ?? 0;
        const {
          parts
        } = doc22;
        const length = parts.length - offset2;
        if (length === 0) {
          break;
        }
        const content2 = parts[offset2 + 0];
        const whitespace = parts[offset2 + 1];
        const contentFlatCommand = {
          indent: indent2,
          mode: MODE_FLAT,
          doc: content2
        };
        const contentBreakCommand = {
          indent: indent2,
          mode: MODE_BREAK,
          doc: content2
        };
        const contentFits = fits(contentFlatCommand, [], remainingWidth, lineSuffix2.length > 0, groupModeMap, true);
        if (length === 1) {
          if (contentFits) {
            commands.push(contentFlatCommand);
          } else {
            commands.push(contentBreakCommand);
          }
          break;
        }
        const whitespaceFlatCommand = {
          indent: indent2,
          mode: MODE_FLAT,
          doc: whitespace
        };
        const whitespaceBreakCommand = {
          indent: indent2,
          mode: MODE_BREAK,
          doc: whitespace
        };
        if (length === 2) {
          if (contentFits) {
            commands.push(whitespaceFlatCommand, contentFlatCommand);
          } else {
            commands.push(whitespaceBreakCommand, contentBreakCommand);
          }
          break;
        }
        const secondContent = parts[offset2 + 2];
        const remainingCommand = {
          indent: indent2,
          mode,
          doc: {
            ...doc22,
            [DOC_FILL_PRINTED_LENGTH]: offset2 + 2
          }
        };
        const firstAndSecondContentFlatCommand = {
          indent: indent2,
          mode: MODE_FLAT,
          doc: [content2, whitespace, secondContent]
        };
        const firstAndSecondContentFits = fits(firstAndSecondContentFlatCommand, [], remainingWidth, lineSuffix2.length > 0, groupModeMap, true);
        commands.push(remainingCommand);
        if (firstAndSecondContentFits) {
          commands.push(whitespaceFlatCommand, contentFlatCommand);
        } else if (contentFits) {
          commands.push(whitespaceBreakCommand, contentFlatCommand);
        } else {
          commands.push(whitespaceBreakCommand, contentBreakCommand);
        }
        break;
      }
      case DOC_TYPE_IF_BREAK:
      case DOC_TYPE_INDENT_IF_BREAK: {
        const groupMode = doc22.groupId ? groupModeMap[doc22.groupId] : mode;
        if (groupMode === MODE_BREAK) {
          const breakContents = doc22.type === DOC_TYPE_IF_BREAK ? doc22.breakContents : doc22.negate ? doc22.contents : indent$1(doc22.contents);
          if (breakContents) {
            commands.push({
              indent: indent2,
              mode,
              doc: breakContents
            });
          }
        }
        if (groupMode === MODE_FLAT) {
          const flatContents = doc22.type === DOC_TYPE_IF_BREAK ? doc22.flatContents : doc22.negate ? indent$1(doc22.contents) : doc22.contents;
          if (flatContents) {
            commands.push({
              indent: indent2,
              mode,
              doc: flatContents
            });
          }
        }
        break;
      }
      case DOC_TYPE_LINE_SUFFIX:
        lineSuffix2.push({
          indent: indent2,
          mode,
          doc: doc22.contents
        });
        break;
      case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
        if (lineSuffix2.length > 0) {
          commands.push({
            indent: indent2,
            mode,
            doc: hardlineWithoutBreakParent
          });
        }
        break;
      case DOC_TYPE_LINE:
        switch (mode) {
          case MODE_FLAT:
            if (!doc22.hard) {
              if (!doc22.soft) {
                output += " ";
                position2 += 1;
              }
              break;
            } else {
              shouldRemeasure = true;
            }
          // fallthrough
          case MODE_BREAK:
            if (lineSuffix2.length > 0) {
              commands.push({
                indent: indent2,
                mode,
                doc: doc22
              }, ...lineSuffix2.reverse());
              lineSuffix2.length = 0;
              break;
            }
            if (doc22.literal) {
              output += newLine;
              position2 = 0;
              if (indent2.root) {
                if (indent2.root.value) {
                  output += indent2.root.value;
                }
                position2 = indent2.root.length;
              }
            } else {
              trim2();
              output += newLine + indent2.value;
              position2 = indent2.length;
            }
            break;
        }
        break;
      case DOC_TYPE_LABEL:
        commands.push({
          indent: indent2,
          mode,
          doc: doc22.contents
        });
        break;
      case DOC_TYPE_BREAK_PARENT:
        break;
      default:
        throw new invalid_doc_error_default(doc22);
    }
    if (commands.length === 0 && lineSuffix2.length > 0) {
      commands.push(...lineSuffix2.reverse());
      lineSuffix2.length = 0;
    }
  }
  const formatted = settledOutput.join("") + output;
  const finalCursorPositions = [...settledCursorPositions, ...cursorPositions];
  if (finalCursorPositions.length !== 2) {
    return {
      formatted
    };
  }
  const cursorNodeStart = finalCursorPositions[0];
  return {
    formatted,
    cursorNodeStart,
    cursorNodeText: formatted.slice(cursorNodeStart, method_at_default(
      /* OPTIONAL_OBJECT: false */
      0,
      finalCursorPositions,
      -1
    ))
  };
  function trim2() {
    const {
      text: trimmed,
      count
    } = trimIndentation(output);
    if (trimmed) {
      settledOutput.push(trimmed);
      settledTextLength += trimmed.length;
    }
    output = "";
    position2 -= count;
    if (cursorPositions.length > 0) {
      settledCursorPositions.push(...cursorPositions.map((position22) => Math.min(position22, settledTextLength)));
      cursorPositions.length = 0;
    }
  }
}
var builders = {
  join: join$1,
  line: line$1,
  softline: softline$1,
  hardline: hardline$1,
  literalline,
  group: group$1,
  conditionalGroup,
  fill: fill$1,
  lineSuffix,
  lineSuffixBoundary,
  cursor,
  breakParent: breakParent$1,
  ifBreak,
  trim,
  indent: indent$1,
  indentIfBreak,
  align,
  addAlignmentToDoc,
  markAsRoot,
  dedentToRoot,
  dedent,
  hardlineWithoutBreakParent,
  literallineWithoutBreakParent,
  label,
  // TODO: Remove this in v4
  concat: (parts) => parts
};
var printer = { printDocToString };
var utils = {
  willBreak,
  traverseDoc: traverse_doc_default,
  findInDoc,
  mapDoc,
  removeLines,
  stripTrailingHardline,
  replaceEndOfLine,
  canBreak
};
const { line, indent, softline, join, fill, group, hardline, breakParent } = builders;
const print = function print2(path, _options, print2) {
  const options2 = _options;
  const node = path.node;
  const nodeMap = options2.nodeMap;
  switch (node.type) {
    case "root": {
      options2.nodeMap = new NodeMap(node);
      const doc2 = fill(path.map(print2, "children").flat());
      return doc2;
    }
    case "cdata": {
      const unsafe = /]]>/g;
      const subset = [">"];
      return ["<![CDATA[", escape$2(node.value, subset, unsafe), "]]>"];
    }
    case "comment":
      return ["<!--", node.value, "-->"];
    case "doctype": {
      const nodeName = name$51(node.name);
      const pub = node.public;
      const sys = node.system;
      let result2 = ["<!DOCTYPE"];
      if (nodeName !== "") {
        result2.push(" ", nodeName);
      }
      if (pub) {
        result2.push(" ", "PUBLIC", " ", quote(pub));
      } else if (sys) {
        result2.push(" ", "SYSTEM");
      }
      if (sys) {
        result2.push(" ", quote(sys));
      }
      result2.push(">");
      return result2;
    }
    case "element": {
      const nodeName = name$51(node.name);
      const openingTag = ["<", nodeName];
      const closingTag = [];
      const attributes = node.attributes || [];
      const printedAttrs = [];
      for (const attr of Object.values(attributes)) {
        const attrName = name$51(attr.name);
        if (attr.children.length === 0) {
          if (options2.doenetSyntax) {
            printedAttrs.push(line, attrName);
          } else {
            printedAttrs.push(line, attrName, "=", '"true"');
          }
        } else {
          printedAttrs.push(
            line,
            attrName,
            "=",
            quote(nodesToXml(attr.children, options2))
          );
        }
      }
      if (printedAttrs.length > 0) {
        openingTag.push(indent(printedAttrs));
      }
      if (node.children.length === 0) {
        openingTag.push(printedAttrs.length > 0 ? line : " ", "/>");
      } else {
        openingTag.push(printedAttrs.length > 0 ? softline : "", ">");
        closingTag.push("</", nodeName, ">");
      }
      const leadingBreak = [];
      const closingBreak = [];
      if (BREAK_AROUND_ELEMENTS.has(node.name)) {
        const prevSibling = nodeMap?.prevSiblingOf(node);
        const nextSibling = nodeMap?.nextSiblingOf(node);
        if (!nodeMap?.hasLineBreakBefore(node) && prevSibling && !(isElement(prevSibling) && BREAK_AROUND_ELEMENTS.has(prevSibling.name))) {
          leadingBreak.push(hardline);
        }
        if (nextSibling && (!nodeMap?.hasLineBreakAfter(node) || isElement(nextSibling) && BREAK_AROUND_ELEMENTS.has(nextSibling.name))) {
          closingBreak.push(hardline);
        }
      }
      if (PRE_ELEMENTS.has(node.name)) {
        return [
          ...leadingBreak,
          group(openingTag),
          toXml(node.children, options2),
          group(closingTag),
          ...closingBreak
        ];
      }
      let children = path.map(print2, "children").flat().filter((x2) => !isEmptyGroup(x2) && x2 !== "");
      if (node.children.length > 0) {
        if (CHILDREN_ON_OWN_LINE_ELEMENTS.has(node.name)) {
          children = [
            indent([softline, joinWithSoftline(children)]),
            softline
          ];
          children.push(breakParent);
        } else {
          children = [indent([softline, fill(children)]), softline];
        }
        if (ALWAYS_BREAK_ELEMENTS.has(node.name)) {
          children.push(breakParent);
        }
      }
      return [
        ...leadingBreak,
        group([group(openingTag), group(children), group(closingTag)]),
        ...closingBreak
      ];
    }
    case "error":
      return "";
    case "instruction": {
      const unsafe = /\?>/g;
      const subset = [">"];
      const nodeName = name$51(node.name);
      const result2 = escape$2(node.value, subset, unsafe);
      return ["<?", nodeName, result2 ? " " + result2 : "", "?>"];
    }
    case "text": {
      let escapedText = escape$2(node.value, ["&", "<"]);
      if (options2.doenetSyntax) {
        escapedText = escapedText.replace(/&lt;(?=\s|=)/g, "<");
        escapedText = escapedText.replace(/&amp;(?!\S*;)/g, "&");
      }
      return join(
        [hardline, hardline],
        escapedText.split(/\n\n+/).map((str) => join(line, str.split(/\s+/)))
      ).flat();
    }
    case "macro":
    case "function":
      return toXml(node, options2);
    default: {
      const unhandledType = node;
      console.warn(
        `Unhandled node type when pretty-printing: ${unhandledType}`
      );
    }
  }
  return "";
};
class NodeMap {
  constructor(root2) {
    this._parents = /* @__PURE__ */ new Map();
    this._prevSiblings = /* @__PURE__ */ new Map();
    this._nextSiblings = /* @__PURE__ */ new Map();
    this._init(root2);
  }
  /**
   * Build a map of all parents/siblings.
   */
  _init(node, parent = null) {
    if (isElement(parent) || parent?.type === "root") {
      this._parents.set(node, parent);
    }
    if (isElement(node) || node?.type === "root") {
      const children = node.children;
      let prevNode = null;
      for (const n of children) {
        this._prevSiblings.set(n, prevNode);
        if (prevNode) {
          this._nextSiblings.set(prevNode, n);
        }
        prevNode = n;
        this._init(n, node);
      }
    }
  }
  parentOf(node) {
    return this._parents.get(node) || null;
  }
  prevSiblingOf(node) {
    return this._prevSiblings.get(node) || null;
  }
  nextSiblingOf(node) {
    return this._nextSiblings.get(node) || null;
  }
  hasLineBreakBefore(node) {
    const prevSibling = this.prevSiblingOf(node);
    if (prevSibling?.type === "text") {
      return prevSibling.value.endsWith("\n");
    }
    return false;
  }
  hasLineBreakAfter(node) {
    const nextSibling = this.nextSiblingOf(node);
    if (nextSibling?.type === "text") {
      return nextSibling.value.endsWith("\n");
    }
    return false;
  }
}
function isGroup(doc2) {
  if (typeof doc2 !== "object") {
    return false;
  }
  if (Array.isArray(doc2)) {
    return false;
  }
  return doc2.type === "group";
}
function isEmptyGroup(doc2) {
  return isGroup(doc2) && Array.isArray(doc2.contents) && doc2.contents.length === 0;
}
function joinWithSoftline(doc2) {
  if (doc2.length === 0) {
    return doc2;
  }
  const ret = [];
  for (let i2 = 0; i2 < doc2.length; i2++) {
    const curr = doc2[i2];
    const next = doc2[i2 + 1];
    ret.push(curr);
    if (next && !isLine(next) && !isLine(curr)) {
      ret.push(softline);
    }
  }
  return ret;
}
function isLine(doc2) {
  if (doc2 === line || doc2 === softline || doc2 === hardline) {
    return true;
  }
  if (typeof doc2 !== "object") {
    return false;
  }
  if (Array.isArray(doc2)) {
    return isLine(doc2[0]);
  } else {
    return doc2.type === "line";
  }
}
const languages = [
  { name: "doenet", extensions: [".doenet"], parsers: ["doenet-parser"] }
];
const parsers = {
  "doenet-parser": {
    parse(source, options2) {
      return normalize(lezerToDast(source));
    },
    astFormat: "dast",
    locStart: (node) => (node.position || { start: { offset: 0 } }).start.offset || 0,
    locEnd: (node) => (node.position || { end: { offset: 0 } }).end.offset || 0
  }
};
const printers = {
  dast: {
    print
  }
};
const options = {
  /**
   * Whether to render with the DoenetML syntax rather than true XML.
   * That means `<` and `&` characters are allowed unescaped in the output.
   */
  doenetSyntax: {
    category: "Global",
    type: "boolean",
    default: false,
    description: "Whether to render with the DoenetML syntax rather than true XML. That means `<` and `&` characters are allowed unescaped in the output."
  },
  /**
   * Whether to output XML error nodes when there are processing errors.
   */
  inlineErrors: {
    category: "Global",
    type: "boolean",
    default: false,
    description: "Whether to output XML error nodes when there are processing errors."
  }
};
const prettierPluginDoenet = { languages, parsers, printers, options };
const prettierPluginDoenet$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: prettierPluginDoenet,
  languages,
  options,
  parsers,
  printers
}, Symbol.toStringTag, { value: "Module" }));
async function prettyPrint(source = "", options2 = {}) {
  const plugins2 = options2.plugins || [];
  plugins2.push(prettierPluginDoenet$1);
  return await Jn(source, {
    printWidth: 80,
    useTabs: false,
    tabWidth: 4,
    ...options2,
    parser: "doenet-parser",
    plugins: plugins2
  });
}
function formatResponse(response, componentTypes) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(jsxRuntimeExports$3.Fragment, { children: response.map((v2, i2) => {
    const componentType = componentTypes[i2];
    if (["math", "point", "matrix", "vector"].includes(
      componentType
    )) {
      const expr = Context$1.fromAst(v2).round_numbers_to_precision_plus_decimals(6, 2);
      return /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(MathJax, {
        hideUntilTypeset: "first",
        inline: true,
        dynamic: true,
        //@ts-ignore
        children: "\\(" + expr.toLatex() + "\\)"
      }) }, i2);
    } else {
      return /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { style: { whiteSpace: "pre-line" }, children: String(v2) }, i2);
    }
  }) });
}
function EditorViewer({
  doenetML: initialDoenetML,
  activityId: specifiedActivityId,
  prefixForIds = "",
  doenetViewerUrl,
  darkMode = "light",
  showAnswerResponseButton = false,
  answerResponseCounts = {},
  width = "100%",
  height = "500px",
  showViewer = true,
  viewerLocation = "right",
  doenetmlChangeCallback,
  immediateDoenetmlChangeCallback,
  documentStructureCallback,
  id: specifiedId,
  readOnly: readOnly2 = false,
  showFormatter = true,
  showErrorsWarnings = true,
  showResponses = true,
  border = "1px solid",
  initialErrors = [],
  initialWarnings = [],
  fetchExternalDoenetML
}) {
  let platform2 = "Linux";
  if (navigator.platform.indexOf("Win") != -1) {
    platform2 = "Win";
  } else if (navigator.platform.indexOf("Mac") != -1) {
    platform2 = "Mac";
  }
  if (readOnly2) {
    showFormatter = false;
  }
  if (!showViewer) {
    showResponses = false;
  }
  const lspRef = useRef(null);
  const [id2, setId] = useState(specifiedId ?? "editor-" + nanoid$1(5));
  const [activityId, setActivityId] = useState(specifiedActivityId ?? id2);
  const [codeChanged, setCodeChanged] = useState(false);
  const codeChangedRef = useRef(false);
  codeChangedRef.current = codeChanged;
  const [viewerDoenetML, setViewerDoenetML] = useState(initialDoenetML);
  const lastReportedDoenetML = useRef(initialDoenetML);
  const editorDoenetMLRef = useRef(initialDoenetML);
  const [formatAsDoenetML, setFormatAsDoenetML] = useState(true);
  const updateValueTimer = useRef(null);
  const viewerContainer = useRef(null);
  const [variants, setVariants] = useState({
    index: 1,
    numVariants: 1,
    allPossibleVariants: ["a"]
  });
  const [infoPanelIsOpen, setInfoPanelIsOpen] = useState(false);
  const [errorsAndWarnings, setErrorsAndWarningsCallback] = useState({
    errors: [],
    warnings: []
  });
  const warningsObjs = [...initialWarnings, ...errorsAndWarnings.warnings];
  const errorsObjs = [...initialErrors, ...errorsAndWarnings.errors];
  const [responses, setResponses] = useState([]);
  useEffect(() => setResponses([]), [initialDoenetML]);
  useEffect(() => {
    function submittedResponseListener(event) {
      if (event.data.subject == "SPLICE.sendEvent") {
        const data = event.data.data;
        if (data.verb === "submitted") {
          const object2 = JSON.parse(data.object);
          const answerId = object2.rootName;
          if (answerId) {
            const result2 = JSON.parse(
              data.result,
              nanInfinityReviver
            );
            const answerCreditAchieved = result2.creditAchieved;
            const response = result2.response;
            const componentTypes = result2.componentTypes;
            if (response !== void 0 && componentTypes !== void 0 && response.length === componentTypes.length) {
              const responseElement = formatResponse(
                response,
                componentTypes
              );
              setResponses((was) => {
                const arr = [...was];
                arr.push({
                  answerId,
                  response: responseElement,
                  creditAchieved: answerCreditAchieved,
                  submittedAt: (/* @__PURE__ */ new Date()).toLocaleTimeString()
                });
                return arr;
              });
            }
          }
        }
      }
    }
    addEventListener("message", submittedResponseListener);
    return () => {
      removeEventListener("message", submittedResponseListener);
    };
  }, [showViewer]);
  useEffect(() => {
    editorDoenetMLRef.current = initialDoenetML;
  }, [initialDoenetML]);
  const documentStructureThenChangeCallback = useCallback(
    (obj) => {
      documentStructureCallback?.(obj);
      doenetmlChangeCallback?.(editorDoenetMLRef.current);
    },
    [documentStructureCallback, doenetmlChangeCallback]
  );
  const onEditorChange = useCallback(
    (value) => {
      if (editorDoenetMLRef.current !== value) {
        editorDoenetMLRef.current = value;
        if (!codeChangedRef.current) {
          setCodeChanged(true);
        }
        immediateDoenetmlChangeCallback?.(value);
        clearTimeout(updateValueTimer.current ?? void 0);
        updateValueTimer.current = window.setTimeout(function() {
          if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
            lastReportedDoenetML.current = editorDoenetMLRef.current;
            doenetmlChangeCallback?.(editorDoenetMLRef.current);
          }
          updateValueTimer.current = null;
        }, 3e3);
      }
    },
    [immediateDoenetmlChangeCallback, doenetmlChangeCallback]
  );
  const onBlur = useCallback(() => {
    window.clearTimeout(updateValueTimer.current ?? void 0);
    if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
      lastReportedDoenetML.current = editorDoenetMLRef.current;
      doenetmlChangeCallback?.(editorDoenetMLRef.current);
    }
    updateValueTimer.current = null;
  }, [
    doenetmlChangeCallback,
    updateValueTimer,
    lastReportedDoenetML,
    editorDoenetMLRef
  ]);
  useEffect(() => {
    const handleEditorKeyDown = (event) => {
      if (platform2 == "Mac" && event.metaKey && event.code === "KeyS" || platform2 != "Mac" && event.ctrlKey && event.code === "KeyS") {
        event.preventDefault();
        event.stopPropagation();
        window.clearTimeout(updateValueTimer.current ?? void 0);
        setViewerDoenetML(editorDoenetMLRef.current);
        if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
          lastReportedDoenetML.current = editorDoenetMLRef.current;
          if (!showViewer) {
            doenetmlChangeCallback?.(editorDoenetMLRef.current);
          }
        }
        setCodeChanged(false);
        setResponses([]);
        updateValueTimer.current = null;
      }
    };
    let codeEditorContainer = document.getElementById(id2);
    if (showViewer) {
      codeEditorContainer?.addEventListener(
        "keydown",
        handleEditorKeyDown
      );
    }
    return () => {
      codeEditorContainer?.removeEventListener(
        "keydown",
        handleEditorKeyDown
      );
    };
  }, [showViewer, id2]);
  useEffect(() => {
    return () => {
      if (updateValueTimer.current !== null) {
        window.clearTimeout(updateValueTimer.current);
        if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
          lastReportedDoenetML.current = editorDoenetMLRef.current;
          doenetmlChangeCallback?.(editorDoenetMLRef.current);
        }
      }
    };
  }, []);
  const tabStore = useTabStore();
  const codeMirror = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    CodeMirror,
    {
      value: initialDoenetML,
      readOnly: readOnly2,
      onBlur,
      onChange: onEditorChange,
      languageServerRef: lspRef
    }
  );
  const editorAndCollapsiblePanel = showErrorsWarnings || showResponses ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    ResizableCollapsiblePanelPair,
    {
      mainPanel: codeMirror,
      subPanel: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        ErrorWarningResponseTabContents,
        {
          store: tabStore,
          warnings: warningsObjs,
          errors: errorsObjs,
          submittedResponses: responses,
          isOpen: infoPanelIsOpen,
          setIsOpen: setInfoPanelIsOpen,
          showErrorsWarnings,
          showResponses
        }
      ),
      alwaysVisiblePanel: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        ErrorWarningResponseTabstrip,
        {
          store: tabStore,
          warnings: warningsObjs,
          errors: errorsObjs,
          submittedResponses: responses,
          isOpen: infoPanelIsOpen,
          setIsOpen: setInfoPanelIsOpen,
          showErrorsWarnings,
          showResponses
        }
      ),
      isOpen: infoPanelIsOpen,
      setIsOpen: setInfoPanelIsOpen
    }
  ) : codeMirror;
  const editorPanel = /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "editor-panel", id: id2, children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "editor-and-collapsible-panel", children: editorAndCollapsiblePanel }),
    /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "formatter-and-version", children: [
      showFormatter ? /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "label", children: "Format as" }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "wrapper", children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
          SelectProvider,
          {
            defaultValue: "DoenetML",
            setValue: (e2) => {
              setFormatAsDoenetML(e2 === "DoenetML");
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports$3.jsx(Select, { className: "button" }),
              /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
                SelectPopover,
                {
                  sameWidth: true,
                  gutter: 2,
                  className: "popover",
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                      SelectItem,
                      {
                        className: "select-item",
                        value: "DoenetML"
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                      SelectItem,
                      {
                        className: "select-item",
                        value: "XML"
                      }
                    )
                  ]
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          UiButton,
          {
            title: "Format your source code",
            onClick: async () => {
              const printed = await prettyPrint(
                editorDoenetMLRef.current,
                {
                  doenetSyntax: formatAsDoenetML,
                  tabWidth: 2
                }
              );
              onEditorChange(printed);
            },
            children: "Format"
          }
        )
      ] }) : null,
      /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "doenetml-version", title: "DoenetML version", children: [
        "Version: ",
        "0.7.0-rc-1"
      ] })
    ] })
  ] });
  if (!showViewer) {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      "div",
      {
        style: {
          display: "flex",
          width,
          height,
          border,
          boxSizing: "border-box"
        },
        children: editorPanel
      }
    );
  }
  function requestScrollTo(offset2) {
    if (viewerContainer.current) {
      viewerContainer.current.scrollTo({
        top: offset2 - 40,
        behavior: "smooth"
      });
    }
  }
  const viewerPanel = /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "viewer-panel", id: id2 + "-viewer", children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "viewer-controls", id: id2 + "-viewer-controls", children: [
      !readOnly2 && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
        UiButton,
        {
          "data-test": "Viewer Update Button",
          disabled: !codeChanged,
          title: platform2 == "Mac" ? "Updates Viewer cmd+s" : "Updates Viewer ctrl+s",
          onClick: () => {
            setViewerDoenetML(editorDoenetMLRef.current);
            window.clearTimeout(
              updateValueTimer.current ?? void 0
            );
            if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
              lastReportedDoenetML.current = editorDoenetMLRef.current;
              if (!showViewer) {
                doenetmlChangeCallback?.(
                  editorDoenetMLRef.current
                );
              }
            }
            setCodeChanged(false);
            updateValueTimer.current = null;
            setResponses([]);
          },
          children: [
            /* @__PURE__ */ jsxRuntimeExports$3.jsx(RxUpdate, {}),
            " Update",
            " ",
            codeChanged ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              BsExclamationTriangleFill,
              {
                fontSize: "18px",
                color: "var(--mainBlue)"
              }
            ) : void 0
          ]
        }
      ),
      variants.numVariants > 1 && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        VariantSelect,
        {
          size: "sm",
          menuWidth: "140px",
          array: variants.allPossibleVariants,
          syncIndex: variants.index,
          onChange: (index2) => setVariants((prev) => {
            let next = { ...prev };
            next.index = index2 + 1;
            return next;
          })
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "viewer", id: id2 + "-viewer", ref: viewerContainer, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      DocViewer,
      {
        doenetML: viewerDoenetML,
        flags: {
          showCorrectness: true,
          solutionDisplayMode: "button",
          showFeedback: true,
          showHints: true,
          autoSubmit: false,
          allowLoadState: false,
          allowSaveState: false,
          saveRendererState: false,
          allowLocalState: false,
          allowSaveEvents: showResponses,
          messageParent: false,
          readOnly: false
        },
        activityId,
        prefixForIds,
        attemptNumber: 1,
        generatedVariantCallback: (x2) => {
          const allPossibleVariants = x2.allPossibleVariants;
          if (Array.isArray(allPossibleVariants)) {
            const numVariants = allPossibleVariants.length;
            if (typeof x2.variantInfo === "object" && typeof x2.variantInfo.index === "number") {
              const index2 = x2.variantInfo.index;
              if (index2 !== variants.index || numVariants !== variants.numVariants || allPossibleVariants.some(
                (v2, i2) => v2 !== variants.allPossibleVariants[i2]
              )) {
                setVariants({
                  index: index2,
                  numVariants,
                  allPossibleVariants
                });
              }
            }
          }
        },
        requestedVariantIndex: variants.index,
        setErrorsAndWarningsCallback,
        documentStructureCallback: documentStructureThenChangeCallback,
        doenetViewerUrl,
        darkMode,
        showAnswerResponseButton,
        answerResponseCounts,
        fetchExternalDoenetML,
        requestScrollTo
      }
    ) })
  ] });
  const viewerFirst = viewerLocation === "left" || viewerLocation === "top";
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    ResizablePanelPair,
    {
      panelA: viewerFirst ? viewerPanel : editorPanel,
      panelB: viewerFirst ? editorPanel : viewerPanel,
      preferredDirection: viewerLocation === "bottom" || viewerLocation === "top" ? "vertical" : "horizontal",
      width,
      height,
      border
    }
  );
}
function useRecordVisibilityChanges(ref, callAction, actions, skipRecording = false) {
  useEffect(() => {
    if (skipRecording) {
      return;
    }
    if (ref.current) {
      const observer = new IntersectionObserver(([entry]) => {
        callAction({
          action: actions.recordVisibilityChange,
          args: { isVisible: entry.isIntersecting }
        });
      });
      observer.observe(ref.current);
      return () => {
        observer.disconnect();
        callAction({
          action: actions.recordVisibilityChange,
          args: { isVisible: false }
        });
      };
    }
  }, [ref]);
}
function useIsOnPage(ref) {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { rootMargin: "1000000px" }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return isIntersecting;
}
const defaultFlags = {
  showCorrectness: true,
  readOnly: false,
  solutionDisplayMode: "button",
  showFeedback: true,
  showHints: true,
  allowLoadState: true,
  allowSaveState: true,
  saveRendererState: false,
  allowLocalState: false,
  allowSaveEvents: true,
  messageParent: false,
  autoSubmit: false
};
const FocusedMathInputContext = React__default.createContext({ current: null });
const rngClass = seedrandom$5.alea;
window.global = window.global || window;
function DoenetViewer({
  doenetML,
  flags: specifiedFlags = {},
  activityId = "a",
  docId = "1",
  prefixForIds = "",
  userId,
  attemptNumber = 1,
  render = true,
  requestedVariantIndex,
  initialState: initialState2,
  reportScoreAndStateCallback,
  setIsInErrorState,
  generatedVariantCallback: specifiedGeneratedVariantCallback,
  documentStructureCallback,
  initializedCallback,
  setErrorsAndWarningsCallback,
  forceDisable = false,
  forceShowCorrectness = false,
  forceShowSolution = false,
  forceUnsuppressCheckWork = false,
  addVirtualKeyboard = true,
  externalVirtualKeyboardProvided = false,
  doenetViewerUrl,
  darkMode = "light",
  showAnswerResponseButton = false,
  answerResponseCounts = {},
  includeVariantSelector = false,
  initializeCounters = {},
  fetchExternalDoenetML,
  requestScrollTo,
  onInit = () => {
  }
}) {
  useEffect(() => {
    if (!document.querySelector(
      'script[src="https://www.youtube.com/iframe_api"]'
    )) {
      const script = document.createElement("script");
      script.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(script);
    }
  }, []);
  const [variants, setVariants] = useState({
    index: 1,
    numVariants: 1,
    allPossibleVariants: ["a"]
  });
  const thisPropSet = [doenetML, activityId, userId, requestedVariantIndex];
  const lastPropSet = useRef([]);
  const variantIndex = useRef(1);
  const ref = useRef(null);
  const isOnPage = useIsOnPage(ref);
  const [hidden, setHidden] = useState(true);
  useEffect(() => {
    if (isOnPage) {
      setHidden(false);
    }
  }, [isOnPage]);
  const flags = { ...defaultFlags, ...specifiedFlags };
  const generatedVariantCallback = useCallback(
    (newVariants) => {
      specifiedGeneratedVariantCallback?.(newVariants);
      if (includeVariantSelector) {
        setVariants(newVariants);
      }
    },
    [specifiedGeneratedVariantCallback, includeVariantSelector]
  );
  let variantSelector = null;
  if (includeVariantSelector) {
    variantIndex.current = variants.index;
    if (variants.numVariants > 1) {
      variantSelector = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        VariantSelect,
        {
          size: "sm",
          menuWidth: "140px",
          array: variants.allPossibleVariants,
          syncIndex: variants.index,
          onChange: (index2) => setVariants((prev) => {
            let next = { ...prev };
            next.index = index2 + 1;
            return next;
          })
        }
      );
    }
  } else {
    if (thisPropSet.some((v2, i2) => v2 !== lastPropSet.current[i2])) {
      if (requestedVariantIndex === void 0) {
        let rng = rngClass();
        requestedVariantIndex = Math.floor(rng() * 1e6) + 1;
      }
      variantIndex.current = Math.round(requestedVariantIndex);
      if (!Number.isInteger(variantIndex.current)) {
        variantIndex.current = 1;
      }
      lastPropSet.current = thisPropSet;
    }
  }
  const viewer = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    DocViewer,
    {
      doenetML,
      flags,
      activityId,
      docId,
      prefixForIds,
      userId,
      attemptNumber,
      render,
      hidden,
      requestedVariantIndex: variantIndex.current,
      initialState: initialState2,
      reportScoreAndStateCallback,
      setIsInErrorState,
      generatedVariantCallback,
      documentStructureCallback,
      initializedCallback,
      setErrorsAndWarningsCallback,
      forceDisable,
      forceShowCorrectness,
      forceShowSolution,
      forceUnsuppressCheckWork,
      doenetViewerUrl,
      darkMode,
      showAnswerResponseButton,
      answerResponseCounts,
      initializeCounters,
      fetchExternalDoenetML,
      requestScrollTo
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Provider_default, { store, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(MathJaxContext, { config: mathjaxConfig$1, version: 4, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    "div",
    {
      ref: (r) => {
        ref.current = r;
        if (onInit && r) {
          onInit(r);
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
        WrapWithKeyboard,
        {
          addVirtualKeyboard,
          externalVirtualKeyboardProvided,
          children: [
            variantSelector,
            viewer
          ]
        }
      )
    }
  ) }) });
}
function DoenetEditor({
  doenetML,
  activityId = "a",
  prefixForIds = "",
  addVirtualKeyboard = true,
  externalVirtualKeyboardProvided = false,
  doenetViewerUrl,
  darkMode = "light",
  showAnswerResponseButton = false,
  answerResponseCounts = {},
  width,
  height,
  viewerLocation,
  backgroundColor,
  showViewer,
  doenetmlChangeCallback,
  immediateDoenetmlChangeCallback,
  documentStructureCallback,
  id: id2,
  readOnly: readOnly2 = false,
  showFormatter = true,
  showErrorsWarnings = true,
  showResponses = true,
  border = "1px solid",
  initialErrors = [],
  initialWarnings = [],
  fetchExternalDoenetML
}) {
  useEffect(() => {
    if (!document.querySelector(
      'script[src="https://www.youtube.com/iframe_api"]'
    )) {
      const script = document.createElement("script");
      script.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(script);
    }
  }, []);
  const editor = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    EditorViewer,
    {
      doenetML,
      activityId,
      prefixForIds,
      doenetViewerUrl,
      darkMode,
      showAnswerResponseButton,
      answerResponseCounts,
      width,
      height,
      viewerLocation,
      showViewer,
      doenetmlChangeCallback,
      immediateDoenetmlChangeCallback,
      documentStructureCallback,
      id: id2,
      readOnly: readOnly2,
      showFormatter,
      showErrorsWarnings,
      showResponses,
      border,
      initialErrors,
      initialWarnings,
      fetchExternalDoenetML
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Provider_default, { store, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(MathJaxContext, { config: mathjaxConfig$1, version: 4, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    WrapWithKeyboard,
    {
      addVirtualKeyboard,
      externalVirtualKeyboardProvided,
      children: editor
    }
  ) }) });
}
function WrapWithKeyboard({
  addVirtualKeyboard,
  externalVirtualKeyboardProvided,
  children
}) {
  const dispatch = useAppDispatch();
  const focusedMathInput = useRef(null);
  const keyboard = addVirtualKeyboard ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    ExternalAwareVirtualKeyboard,
    {
      externalVirtualKeyboardProvided,
      onClick: (keyCommands) => {
        dispatch(keyboardSlice.actions.setKeyboardInput(keyCommands));
      }
    }
  ) : null;
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(FocusedMathInputContext.Provider, { value: focusedMathInput, children: [
    children,
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "before-keyboard" }),
    keyboard
  ] });
}
export {
  disabledFromProps as $,
  ActionButtonGroup as A,
  Button$2 as B,
  CodeMirror as C,
  DoenetViewer as D,
  EditorViewer as E,
  FocusedMathInputContext as F,
  useIsMouseMoving as G,
  useBooleanEvent as H,
  chain as I,
  addGlobalEventListener as J,
  useLiveRef as K,
  useSafeLayoutEffect as L,
  MathJax as M,
  useWrapElement as N,
  useMergeRefs as O,
  PopoverScopedContextProvider as P,
  usePopover as Q,
  isFalsyBooleanCallback as R,
  contains$1 as S,
  ToggleButton as T,
  useEvent as U,
  sync as V,
  hasFocusWithin as W,
  createDialogComponent as X,
  forwardRef2 as Y,
  createElement as Z,
  __variableDynamicImportRuntimeHelper as _,
  DoenetEditor as a,
  useFocusable as a0,
  createStore as a1,
  createPopoverStore as a2,
  defaultValue as a3,
  useStoreProps as a4,
  usePopoverStoreProps as a5,
  useStore as a6,
  Button as a7,
  getDefaultExportFromCjs$6 as a8,
  commonjsGlobal$4 as a9,
  getAugmentedNamespace$3 as aa,
  serializedComponentsReviver as b,
  cidFromText as c,
  DocContext as d,
  Context$1 as e,
  cesc as f,
  createFunctionFromDefinition as g,
  useAppSelector as h,
  mainSlice as i,
  jsxRuntimeExports$3 as j,
  renderersLoadComponent as k,
  deepCompare as l,
  mathjaxConfig$1 as m,
  ActionButton as n,
  doenetGlobalConfig as o,
  ToggleButtonGroup as p,
  keyboardSlice as q,
  retrieveTextFileForCid as r,
  serializedComponentsReplacer as s,
  textRendererStyle as t,
  useRecordVisibilityChanges as u,
  createStoreContext as v,
  PopoverContextProvider as w,
  createHook as x,
  invariant as y,
  usePortalRef as z
};
